(function () {
  'use strict';

  angular.module('dashboard', [
    'ngMaterial',
    'ngAnimate',
    'ngCookies',
    'ngSanitize',
    'ngMessages',
    'ngAria',
    'ngResource',
    'ui.router',
    'mgcrea.ngStrap',
    'toastr',
    'chart.js',
    'angularFileUpload',
    'smart-table',
    'ngStorage',
    'ngFileSaver',
    'angularFileUpload',
    'pascalprecht.translate',
    'ui.grid.autoResize',
    'ui.grid.cellNav',
    'ui.grid.edit',
    'ui.grid.expandable',
    'ui.grid.moveColumns',
    'ui.grid.pagination',
    'ui.grid.pinning',
    'ui.grid.resizeColumns',
    'ui.grid.saveState',
    'ui.grid.selection',
    'ui.grid.treeView',
    'ui.grid',
    'ngHandsontable',
    'ngTable',
    'panzoom',
    'ngMaterialDatePicker',
    'ui.sortable',
    'ui.ace',
    'gridster',
    'ui.bootstrap.datetimepicker',
    'ui.dateTimeInput',
    'ng-context-menu',
    'ui.tinymce'
  ]);
})();

'use strict';

var app = angular.module('dashboard');

app.component('cronOnceAWeek', {
  templateUrl:
    'app/app-utils/directives/cron-builder/components/cron-once-a-week/once-a-week.html',
  controllerAs: 'ctrl',
  bindings: {
    cron: '=',
  },
  controller: cronOnceAWeekController,
});

cronOnceAWeekController.$inject = ['$scope'];
function cronOnceAWeekController($scope) {
  var vm = this;

  vm.minute = vm.cron.minute || '';
  vm.starthour = vm.cron.hour || '';
  vm.dayOfWeek = vm.cron.dayOfWeek || '';

  vm.updateCron = function () {
    vm.cron = {
      seconds: '0',
      minute: vm.minute,
      hour: vm.starthour,
      dayOfMonth: '?',
      month: '*',
      dayOfWeek: vm.dayOfWeek,
      year: '*',
    };
  };

  $scope.days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

  $scope.minutes = Array.from({ length: 60 }, function (v, k) {
    return k;
  });

  $scope.hours = Array.from({ length: 24 }, function (v, k) {
    return k;
  });
}

"use strict";

var app = angular.module('dashboard');

app.component('predicateFunction', {
    templateUrl: 'app/rule-editor/components/predicates-dialog/components/predicate-function/predicate-function.html',
    controllerAs: 'ctrl',
    bindings: {
        index: "=",
        predicate: "=",
        inputSchema: "=?",
        removeFunction: "=?",
    },
    controller: predicateFunctionController,
});

predicateFunctionController.$inject = ['$scope', 'translationService'];
function predicateFunctionController($scope, $translationService) {
	$translationService.getTranslation($scope, 'predicates');
    var vm = this;
    vm.setOP = function(op){
        vm.predicate.operand = op;
    }

    vm.addFunction = function(){
        var baseFunc = {
            "operand": "AND", 
            "operandType": "function",
            "operands": []
        }
        vm.predicate.operands.push(baseFunc);
    }
    
    vm.addCondition = function(){
        var op = {
            "operand": ">",
            "operandType": "function",
            "operands": [
                {
                    "input": 0,
                    "name": "",
                    "operandType": "variable"
                },
                {
                    "value": '',
                    "type": "int",
                    "operandType": "constant"
                }
            ]
        };
        vm.predicate.operands.push(op);
    }

    vm.autoremove = function(index){
        vm.predicate.operands.splice(index, 1);
    }
}

"use strict";

var app = angular.module('dashboard');

app.component('predicateCondition', {
    templateUrl: 'app/rule-editor/components/predicates-dialog/components/predicate-condition/predicate-condition.html',
    controllerAs: 'ctrl',
    bindings: {
        index: "=",
        predicate: "=",
        inputSchema: "=?",
    },
    controller: predicateConditionController,
});

predicateConditionController.$inject = ['$scope', 'translationService', 'types'];
function predicateConditionController($scope, $translationService, $types) {
    $translationService.getTranslation($scope, 'predicates');
    var vm = this;
    vm.types = $types;
    $scope.$watch("ctrl.selectedItem", function (nval) {
        if(nval){
            vm.predicate.operands[1].type = nval.type;
        }
    }, true);

    vm.operations = [
        {operation: "EQUAL", operator:"=", title:"equal_to", required:false},
        {operation: "DIFF", operator:"!=", title:"not_equals_to", required:false},
        {operation: "GREATER_OR_EQUAL", operator:">=", title:"greater_equals_than", required:false},
        {operation: "GREATER", operator:">", title:"greater_than", required:false},
        {operation: "LESS_OR_EQUAL", operator:"<=", title:"smaller_equals_than", required:false},
        {operation: "LESS", operator:"<", title:"smaller_than", required:false}
    ];
    vm.removeCondition = $scope.$parent.ctrl.autoremove;

    // Autocomplete
    vm.inputRows = [];
    angular.forEach(vm.inputSchema, function(item, key){
        vm.inputRows.push({name: key, type:item.type});
        // vm.inputRows.push(key);
    });
    $scope.querySearch = function(query) {
        var results = query ? vm.inputRows.filter( createFilterFor(query) ) : vm.inputRows, deferred;
        return results;
    }
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(array) {
            return ( array.name.toLowerCase().indexOf(lowercaseQuery) > -1);
        };
    }
}

'use strict';

var app = angular.module('dashboard');

app.component('predicateBuilder', {
  templateUrl:
    'app/rule-editor/components/predicates-dialog/components/predicate-builder/predicate-builder.html',
  controllerAs: 'ctrl',
  bindings: {
    predicate: '=?',
    inputSchema: '=?',
  },
  controller: predicateBuilderController,
});

predicateBuilderController.$inject = ['$scope'];
function predicateBuilderController($scope) {
  var vm = this;
  vm.selectedTab = 0;

  vm.showace = false;

  vm.aceConfigs = {
    useWrapMode: true,
    showGutter: true,
    theme: 'twilight',
    mode: 'java',
  };

  vm.$onInit = function () {
    var basePredicate = {
      predicate: {
        operand: 'AND',
        operandType: 'function',
        operands: [],
      },
      advancedPredicate: '',
      use: 'predicate',
    };
    vm.predicate = vm.predicate ? vm.predicate : basePredicate;
    vm.selectedTab = vm.predicate.use == 'predicate' ? 0 : 1;
    vm.inputSchema = vm.inputSchema ? vm.inputSchema : [];
  };

  vm.use = function (type) {
    vm.predicate.use = type;

    if (vm.predicate.use == 'advanced') {
      setTimeout(function () {
        vm.showace = true;
      }, 500);
    } else {
      vm.showace = false;
    }
  };
}

'use strict';
var app = angular.module('dashboard');

app.component('notificationsList', {
  templateUrl:
    'app/main/components/notification/components/notifications-list/notifications-list.html',
  controllerAs: 'ctrl',
  bindings: {
    notifications: '=',
    isLoading: '=',
    pagination: '<',
    loadMore: '&',
    refreshList: '&',
    translation: '<',
  },
  controller: notificationsListController,
});

notificationsListController.$inject = [
  '$scope',
  'toastr',
  'NotificationsFactory',
  '$mdDialog',
  'translationService',
];
function notificationsListController(
  $scope,
  $toastr,
  $notificationsFactory,
  $mdDialog,
  $translationService
) {
  var vm = this;
  $scope.removeQueue = [];

  $scope.loadMore = function () {
    if (vm.pagination.itemsPerPage >= vm.pagination.totalRecords) return;
    if (vm.isLoading) return;
    vm.loadMore();
  };

  vm.confirmRemoveAll = function (ev) {
    var title = $translationService.getTranslationController(
      'Seguro quiere eliminar todas las notificaciones?',
      'Sure you want to remove all notifications',
      'Certeza de que deseja remover todas as notificações'
    );
    var textContent = $translationService.getTranslationController(
      'Confirma esta acción',
      'Confirm this action',
      'Confirme esta ação'
    );
    var ok = $translationService.getTranslationController('Si', 'Yes', 'Sim');
    var cancel = $translationService.getTranslationController(
      'Cancelar',
      'Cancel',
      'Cancelar'
    );
    var confirm = $mdDialog
      .confirm()
      .title(title)
      .textContent(textContent)
      .ariaLabel('confirmRemoveAll')
      .targetEvent(ev)
      .ok(ok)
      .cancel(cancel);

    $mdDialog.show(confirm).then(function () {
      vm.removeAll();
    });
  };

  vm.removeAll = function () {
    $notificationsFactory
      .removeAll()
      .then(function () {
        vm.refreshList();
      })
      .catch(function (err) {
        console.log('Error@markAllRead', err);
      });
  };

  vm.removeSelected = function () {
    if (vm.notifications.length == 0) return;
    $scope.removeQueue = vm.notifications
      .filter(function (n) {
        return n.selected == true;
      })
      .map(function (n) {
        return n.id;
      });

    if ($scope.removeQueue.length == 0) {
      $toastr.error(
        $translationService.getTranslationController(
          'No hay notificaciones seleccionadas',
          'No notifications selected',
          'Nenhuma notificação selecionada'
        )
      );
      return;
    }

    vm.isLoading = true;
    $notificationsFactory
      .removeByIdList($scope.removeQueue)
      .then(function () {
        vm.refreshList();
        $scope.removeQueue = [];
        vm.isLoading = false;
      })
      .catch(function (err) {
        console.log('Error@removeById', err);
      });
  };

  $scope.$on('refreshList', function (event, item) {
    vm.refreshList();
  });
}

'use strict';
var app = angular.module('dashboard');

app.component('notificationCard', {
  templateUrl:
    'app/main/components/notification/components/notification-card/notification-card.html',
  controllerAs: 'ctrl',
  bindings: {
    item: '=',
    translation: '<',
    removeItem: '&',
  },
  controller: notificationCardController,
});

notificationCardController.$inject = [
  '$rootScope',
  '$scope',
  '$mdDialog',
  'NotificationsFactory',
  'IssuesFactory',
  '$state',
];
function notificationCardController(
  $rootScope,
  $scope,
  $mdDialog,
  $notificationsFactory,
  $IssuesFactory,
  $state
) {
  var vm = this;
  $scope.isDeleted = false;
  $scope.isLoading = false;
  $scope.fadeOut = false;
  vm.removeItem = false;

  vm.$onInit = function () {};

  function _getIssuesTypes(categoryId) {
    return new Promise(function (resolve, reject) {
      var req = {
        categoryId: categoryId,
      };
      $IssuesFactory
        .getIssuesTypes(req)
        .then(function (res) {
          vm.issueTypes = res;
          resolve();
        })
        .catch(function (err) {
          console.log('Error@getIssuesTypes', err);
          reject();
        });
    });
  }

  function _getIssuesByUuid(uuid) {
    return new Promise(function (resolve, reject) {
      $IssuesFactory
        .getIssueByUUID(uuid)
        .then(function (response) {
          vm.selectedIssue = response;
          vm.selectedIssue.issueType.category = vm.selectedIssue.category;
          resolve();
        })
        .catch(function (err) {
          console.log('Error@getIssuesByUUID', err);
          reject();
        });
    });
  }

  vm.clickNoty = function () {
    $rootScope.loading = true;

    var promises = [
      _getIssuesByUuid(vm.item.body.uuid),
      _getIssuesTypes(vm.item.body.category.id),
    ];
    Promise.all(promises)
      .then(function () {
        $mdDialog.show({
          controller: 'IssuesDetailDialogController',
          controllerAs: 'ctrl',
          templateUrl:
            'app/dashboard/components/issues-detail-dialog/issues-detail-dialog.html',
          parent: angular.element(document.body),
          targetEvent: null,
          clickOutsideToClose: false,
          multiple: true,
          locals: {
            issueTypes: vm.issueTypes,
            currentIssueType: vm.issueTypes.find(function (e) {
              return e.id == vm.item.body.issueType.id;
            }),
            issue: vm.selectedIssue,
            issuesToLink: [],
            currentCategory: vm.selectedIssue.category,
          },
        });
      })
      .then(vm.notificationRead())
      .finally(function () {
        $rootScope.loading = false;
      });
  };

  vm.notificationRead = function () {
    if (vm.item.isRead == true) return;
    vm.item.isRead = true;
    $notificationsFactory
      .markReadById(vm.item.id)
      .then(function () {
        $scope.$emit('refreshList');
      })
      .catch(function (err) {
        console.log('Error@markReadById', err);
      });
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('relatedIssuesList', {
  templateUrl:
    'app/dashboard/components/issue-related-content-dialog/components/related-issues-list/related-issues-list.html',
  controllerAs: 'ctrl',
  bindings: {
    reference: '<',
    setSelectedIssuesFn: '&',
  },
  controller: relatedIssuesListController,
});

relatedIssuesListController.$inject = [
  '$scope',
  '$rootScope',
  '$mdDialog',
  'translationService',
  'ReferencesFactory',
  'IssuesFactory',
];

function relatedIssuesListController(
  $scope,
  $rootScope,
  $mdDialog,
  $translationService,
  $referencesFactory,
  $issuesFactory
) {
  var vm = this;
  vm.selectedRows = [];
  vm.gridOptions = {
    rowTemplate:
      '<div ng-dblclick="grid.appScope.ctrl.showDetail($event, row.entity)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell ng-class="{ \'cep-issue-unseen\' : !row.entity.viewed }"></div>',
    columnDefs: [
      {
        key: 'description',
        name: 'Description',
        displayName: $translationService.getTranslationController(
          'Descripción',
          'Description',
          'Descrição'
        ),
        field: 'description',
        width: '15%',
      },
      {
        key: 'classification',
        name: 'Classification',
        displayName: $translationService.getTranslationController(
          'Clasificación',
          'Classification',
          'Classificação'
        ),
        field: 'classification.name',
      },
      {
        key: 'createdAt',
        name: 'CreatedAt',
        displayName: $translationService.getTranslationController(
          'Creado en',
          'Created at',
          'Criado em'
        ),
        field: 'createdAtLocal',
        width: '130',
        cellFilter: 'date: "dd/MM/yy HH:mm"',
      },
      {
        key: 'assigned',
        name: 'Assigned',
        displayName: $translationService.getTranslationController(
          'Asignado',
          'Assigned',
          'Atribuído'
        ),
        field: 'assigned.name',
      },
      {
        key: 'category',
        name: 'Category',
        displayName: $translationService.getTranslationController(
          'Categoría',
          'Category',
          'Categoria'
        ),
        field: 'category.label',
        width: '100',
      },
      {
        key: 'criticality',
        name: 'Criticality',
        displayName: $translationService.getTranslationController(
          'Criticidad',
          'Criticality',
          'Criticidade'
        ),
        field: 'criticality.name',
        width: '100',
      },
      {
        key: 'status',
        name: 'Status',
        displayName: $translationService.getTranslationController(
          'Estado',
          'Status',
          'Status'
        ),
        field: 'status.name',
      },
    ],
    multiSelect: true,
    enableFullRowSelection: true,
    gridMenuShowHideColumns: false,
    // Grid pagination options
    useExternalPagination: true,
    paginationPageSizes: [15, 20, 25],
    paginationPageSize: 15,
    totalItems: 0,
    // Grid sorting options
    useExternalSorting: false,
    // Grid menu
    enableGridMenu: false,
    // Grid api Options
    onRegisterApi: function (gridApi) {
      gridApi.selection.on.rowSelectionChanged($scope, function (row, evt) {
        vm.selectedRows = gridApi.selection.getSelectedRows();
        _setSelectedIssuesOnParent();
      });

      gridApi.selection.on.rowSelectionChangedBatch($scope, function (rows) {
        vm.selectedRows = gridApi.selection.getSelectedRows();
        _setSelectedIssuesOnParent();
      });

      gridApi.pagination.on.paginationChanged($scope, function (
        newPage,
        pageSize
      ) {
        vm.filters.pagination.page = newPage;
        vm.filters.pagination.itemsPerPage = pageSize;

        $rootScope.loading = true;
        _getReferenceData(vm.reference, vm.filters).finally(function () {
          $rootScope.loading = false;
        });
      });
    },
  };
  vm.filters = {
    pagination: {
      itemsPerPage: 15,
      page: 1,
      sortBy: 'createdAtLocal',
      sort: 'desc',
    },
    predicates: [],
  };

  vm.$onInit = function () {
    _getReferenceData(vm.reference, vm.filters);
  };

  function _getReferenceData(relatedElement, filters) {
    return $referencesFactory
      .getReferenceData(relatedElement.referenceUUID, filters)
      .then(function (res) {
        var data = res.data
          .filter(function (e) {
            return e.target == 'issues';
          })
          .map(function (e) {
            return e.item;
          })
          .filter(function (e) {
            return e.uuid != relatedElement.parentIssueUuid;
          });

        vm.gridOptions.data = data;
        vm.gridOptions.totalItems = res.pagination.totalRecords;
      })
      .catch(function (error) {
        console.log('Error@getReferenceData', error);
      });
  }

  function _setSelectedIssuesOnParent() {
    var data = {
      referenceUuid: vm.reference.referenceUUID,
      selectedIssues: vm.selectedRows,
    };

    vm.setSelectedIssuesFn(data);
  }

  vm.showDetail = function (event, item) {
    $rootScope.loading = true;
    var promises = [];
    promises.push(_getIssuesByUuid(item.uuid));
    promises.push(_getIssuesTypes(item.category.id));
    Promise.all(promises).then(function () {
      $rootScope.loading = false;
      $mdDialog.show({
        controller: 'IssuesDetailDialogController',
        controllerAs: 'ctrl',
        templateUrl:
          'app/dashboard/components/issues-detail-dialog/issues-detail-dialog.html',
        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: false,
        multiple: true,
        locals: {
          issueTypes: vm.issueTypes,
          currentIssueType: vm.issueTypes.find(function (e) {
            return e.id == vm.selectedIssue.issueType.id;
          }),
          issue: vm.selectedIssue,
          issuesToLink: [],
          currentCategory: vm.selectedIssue.category,
        },
      });
    });
  };

  function _getIssuesByUuid(issueUuid) {
    return new Promise(function (resolve, reject) {
      $issuesFactory
        .getIssueByUUID(issueUuid)
        .then(function (response) {
          vm.selectedIssue = response;
          vm.selectedIssue.issueType.category = vm.selectedIssue.category;
          resolve();
        })
        .catch(function (e) {
          console.log('Error@getIssuesByUUID', err);
          reject();
        });
    });
  }

  function _getIssuesTypes(categoryId) {
    return new Promise(function (resolve, reject) {
      var req = {
        categoryId: categoryId,
      };
      $issuesFactory
        .getIssuesTypes(req)
        .then(function (res) {
          vm.issueTypes = res;
          resolve();
        })
        .catch(function (err) {
          console.log('Error@getIssuesTypes', err);
          reject();
        });
    });
  }
}

"use strict";

var app = angular.module("dashboard");

app.component("issueFileBox", {
  templateUrl:
    "app/dashboard/components/issue-files/components/issue-file-box/issue-file-box.html",
  controllerAs: "file",
  bindings: {
    data: "<",
    issueUuid: "<",
    onDelete: "&",
  },
  controller: issueFileBoxController,
});

issueFileBoxController.$inject = [
  "$scope",
  "$rootScope",
  "$mdDialog",
  "toastr",
  "FileSaver",
  "translationService",
  "IssuesFactory",
];

function issueFileBoxController(
  $scope,
  $rootScope,
  $mdDialog,
  toastr,
  FileSaver,
  $translationService,
  $issuesFactory
) {
  $translationService.getTranslation($scope, "files-storage");
  var vm = this;

  vm.toggle = false;
  vm.handlerToggle = function () {
    vm.toggle = !vm.toggle;
  };

  vm.downloadFile = function () {
    $issuesFactory
      .downloadIssueFile(vm.issueUuid, vm.data.name)
      .then(function (res) {
        FileSaver.saveAs(new Blob([res.data]), vm.data.name);
      })
      .catch(function (err) {
        console.error("Error@downloadIssueFile", err);
        toastr.error(
          $translationService.getTranslationController(
            "No se pudo descargar el archivo",
            "Could not download file",
            "Não foi possível baixar o arquivo"
          )
        );
      });
  };

  vm.deleteFile = function (ev) {
    var confirm = $mdDialog
      .confirm()
      .title(
        $translationService.getTranslationController(
          "¿Seguro deseas eliminar este archivo?",
          "Are you sure you want to delete this file?",
          "Tem certeza de que deseja excluir este arquivo?"
        )
      )
      .textContent("")
      .ariaLabel("File delete confirmation")
      .multiple(true)
      .targetEvent(ev)
      .ok(
        $translationService.getTranslationController(
          "Si elimínalo!",
          "Yes, delete!",
          "Sim, deletar"
        )
      )
      .cancel(
        $translationService.getTranslationController(
          "Cancelar",
          "Cancel",
          "Cancelar"
        )
      );

    $mdDialog.show(confirm).then(function () {
      _performDeletionOfFile();
    });
  };

  vm.filePreview = function (event) {
    $mdDialog.show({
      controller: "filePreviewDialogController",
      controllerAs: "ctrl",
      templateUrl: "app/app-utils/components/file-preview/file-preview-dialog.html",
      parent: angular.element(document.body),
      targetEvent: event,
      multiple: true,
      clickOutsideToClose: false,
      locals: {
        file: vm.data,
        issueUuid: vm.issueUuid,
      },
    });
  };

  function _performDeletionOfFile() {
    $rootScope.loading = true;
    $issuesFactory
      .deleteIssueFile(vm.issueUuid, vm.data.name)
      .then(function (res) {
        toastr.success(
          $translationService.getTranslationController(
            "Archivo eliminado",
            "File Deleted",
            "Arquivo excluído"
          )
        );
        vm.onDelete({ fileId: vm.data.id });
      })
      .catch(function (err) {
        console.error("Error@delteFolderbyID", err);
        toastr.error(
          $translationService.getTranslationController(
            "No se pudo eliminar",
            "Could not delete",
            "Não foi possível deletar"
          )
        );
      })
      .finally(function (e) {
        $rootScope.loading = false;
      });
  }
}

'use strict';

var app = angular.module('dashboard');

app.component('issueSequentialSelector', {
  templateUrl:
    'app/dashboard/components/issue-dynamic-schema/components/issue-sequential-selector/issue-sequential-selector.html',
  controllerAs: 'ctrl',
  bindings: {
    model: '=',
    field: '<',
    key: '<',
    disabled: '<',
  },
  controller: issueSequentialSelector,
});

issueSequentialSelector.$inject = ['InputListsFactory'];
function issueSequentialSelector($inputListsFactory) {
  var vm = this;
  console.log(vm);
  console.log(vm.disabled);
  vm.$onInit = function () {
    if (vm.model) {
      vm.selectorData = [vm.model];
    }
  };

  vm.loadSequentialValues = function () {
    if (!vm.field.metadata.id) {
      return;
    }

    var sourceListId = vm.field.metadata.id;
    return new Promise(function (resolve, reject) {
      $inputListsFactory
        .getInputListData(sourceListId, null, {
          page: 1,
          itemsPerPage: 10000,
          sort: 'asc',
        })
        .then(function (res) {
          var source = res.dataList
            .map(function (e) {
              var res = angular.fromJson(e.body);
              if (res.$visible) delete res.$visible;
              return Object.values(res)[0];
            })
            .sort();

          vm.selectorData = source;
          resolve();
        })
        .catch(function (err) {
          console.log('Error@loadSequentialValues', err);
          reject();
        });
    });
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('issueReferenceSelector', {
  templateUrl:
    'app/dashboard/components/issue-dynamic-schema/components/issue-reference-selector/issue-reference-selector.html',
  controllerAs: 'ctrl',
  bindings: {
    model: '=',
    field: '<',
    key: '<',
    onReferenceSelected: '&',
  },
  controller: issueReferenceSelector,
});

issueReferenceSelector.$inject = [
  '$mdDialog',
  'toastr',
  'translationService',
  'SchemasService',
  'InputListsFactory',
];
function issueReferenceSelector(
  $mdDialog,
  $toastr,
  $translationService,
  $schemasService,
  $inputListsFactory
) {
  var vm = this;
  vm.referencedValues = {};
  vm.referencedSchema = {};

  vm.$onInit = function () {
    if (vm.model && angular.isObject(vm.model)) {
      vm.referencedValues = vm.model;
      vm.model = vm.model._id;

      if (vm.field.metadata.id) {
        $inputListsFactory
          .getInputList(vm.field.metadata.id)
          .then(function (res) {
            vm.referencedSchema = $schemasService.parseSchema(res.schema);
          });
      }
    }
  };

  vm.showHint = function () {
    if (vm.referencedValues) {
      vm.showReferenceData = true;
    }
  };

  vm.hideHint = function () {
    vm.showReferenceData = false;
  };

  vm.openReferenceSelector = function (event) {
    if (vm.field.disabled) {
      return;
    }
    if (!vm.field.metadata.id) {
      $toastr.warning(
        $translationService.getTranslationController(
          'No hay una lista de fuentes configurada',
          'There is no source list configured',
          'Não há lista de fontes configurada'
        )
      );
      return;
    }

    var sourceListId = vm.field.metadata.id;
    $mdDialog
      .show({
        controller: 'IssueReferenceSearchDialogController',
        controllerAs: 'ctrl',
        templateUrl:
          'app/dashboard/components/issue-dynamic-schema/components/issue-reference-search-dialog/issue-reference-search-dialog.html',
        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: false,
        multiple: true,
        locals: {
          sourceListId: sourceListId,
        },
      })
      .then(function (selectedReference) {
        vm.onReferenceSelected({ reference: angular.copy(selectedReference) });

        angular.forEach(selectedReference, function (value, key) {
          if (key.indexOf('#') === 0) {
            selectedReference['id'] = value;
            delete selectedReference[key];
          }
        });

        vm.model = selectedReference.id;
        vm.referencedValues = selectedReference;
      });
  };
}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller(
      'IssueReferenceSearchDialogController',
      IssueReferenceSearchDialogController
    );

  IssueReferenceSearchDialogController.$inject = [
    '$scope',
    '$rootScope',
    '$mdDialog',
    'translationService',
    'SchemasService',
    'InputListsFactory',
    'tableListConstants',
    'sourceListId',
  ];
  function IssueReferenceSearchDialogController(
    $scope,
    $rootScope,
    $mdDialog,
    $translationService,
    $schemasService,
    $inputListsFactory,
    $tableListConstants,
    sourceListId
  ) {
    var vm = this;
    vm.sourceListId = sourceListId;
    vm.selectedRow = {};
    vm.filters = $tableListConstants.defaultFiltersTemplate;

    vm.gridOptions = {
      multiSelect: false,
      enableFullRowSelection: true,
      minimumColumnSize: 100,
      // Grid pagination options
      useExternalPagination: true,
      page: 1,
      paginationPageSizes: [8, 15, 20, 25],
      paginationPageSize: 8,
      totalItems: 0,
      // Grid sorting options
      useExternalSorting: true,
      externalSortingOptions: {
        sortBy: null,
        sort: 'asc',
        colType: null,
      },
      onRegisterApi: function (gridApi) {
        gridApi.selection.on.rowSelectionChanged($scope, function (row) {
          vm.selectedRow = row.entity;
        });

        gridApi.pagination.on.paginationChanged($scope, function (newPage) {
          vm.gridOptions.page = newPage;
          _loadReferenceValues();
        });

        gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (sortColumns[0]) {
            vm.gridOptions.externalSortingOptions.sortBy = sortColumns[0].field;
            vm.gridOptions.externalSortingOptions.sort =
              sortColumns[0].colDef.name = sortColumns[0].sort.direction;

            var selectedColName =
              sortColumns[0].field.indexOf('#') === 0
                ? sortColumns[0].field.substring(1)
                : sortColumns[0].field;

            vm.gridOptions.externalSortingOptions.colType =
              vm.schema[selectedColName].type;
          } else {
            vm.gridOptions.externalSortingOptions = {
              sortBy: null,
              sort: null,
              colType: null,
            };
          }

          _loadReferenceValues();
        });
      },
    };

    vm.$onInit = function () {
      $rootScope.loading = true;

      var promises = [
        $inputListsFactory.getInputList(vm.sourceListId),
        $inputListsFactory.getInputListFilters(vm.sourceListId),
      ];

      Promise.all(promises)
        .then(function (res) {
          var inputList = res[0];
          vm.schema = $schemasService.parseSchema(
            angular.fromJson(inputList.schema),
            angular.fromJson(inputList.settings)
          );
          vm.columnfilters = res[1];

          _setColumnDefs();
          _loadReferenceValues();
        })
        .catch(function (error) {
          console.error('Error@getInputList/getInputListFilters', error);
        });
    };

    function _setColumnDefs() {
      vm.gridOptions.columnDefs = [];
      angular.forEach(vm.schema, function (col, key) {
        if (col.visible) {
          vm.gridOptions.columnDefs.push({
            order: col.order,
            name: key,
            field: col.pk ? '#' + key : key,
            // General column properties
            enableColumnMenu: true,
            enableSorting: true,
            enableHiding: false,
            menuItems: [
              {
                title: $translationService.getTranslationController(
                  'Filtrar',
                  'Filter',
                  'Filtro'
                ),
                icon: 'ui-grid-icon-filter',
                shown: function () {
                  var hasFilters = vm.columnfilters.find(function (e) {
                    return e.field == col.key || e.label == col.displayName;
                  });

                  return hasFilters ? true : false;
                },
                action: function ($event) {
                  this.context.addFilterTo($event, col);
                },
                context: vm,
              },
            ],
          });
        }
      });
      vm.gridOptions.columnDefs = vm.gridOptions.columnDefs.sort(function (
        a,
        b
      ) {
        return a.order - b.order;
      });
    }

    function _loadReferenceValues() {
      $rootScope.loading = true;

      vm.filters.pagination = {
        page: vm.gridOptions.page,
        itemsPerPage: vm.gridOptions.paginationPageSize,
        sortBy: '',
        colType: '',
        sort: 'ASC',
        totalRecords: 0,
      };

      if (vm.gridOptions.externalSortingOptions.sortBy) {
        vm.filters.pagination.sortBy =
          vm.gridOptions.externalSortingOptions.sortBy;
      }
      if (vm.gridOptions.externalSortingOptions.sort) {
        vm.filters.pagination.sort = vm.gridOptions.externalSortingOptions.sort;
      }
      if (vm.gridOptions.externalSortingOptions.colType) {
        vm.filters.pagination.colType =
          vm.gridOptions.externalSortingOptions.colType;
      }

      return new Promise(function (resolve, reject) {
        $inputListsFactory
          .getInputListDataFiltered(vm.sourceListId, vm.filters)
          .then(function (res) {
            vm.gridOptions.totalItems = res.pagination.totalRecords;
            vm.gridOptions.data = res.data.map(function (e) {
              var res = angular.fromJson(e.body);
              angular.forEach(vm.schema, function (col, key) {
                var colName = col.pk ? '#' + key : key;
                if (!col.visible) delete res[colName];
              });

              return res;
            });

            resolve();
          })
          .catch(function (err) {
            console.error('Error@getInputListDataFiltered', err);
            reject();
          })
          .finally(function () {
            $rootScope.loading = false;
          });
      });
    }

    vm.addFilterTo = function (event, col) {
      col.name = col.displayName || col.key;

      var selectedColumnFilters = vm.columnfilters.find(function (e) {
        return e.field == vm.key || e.label == col.displayName;
      });

      if (!selectedColumnFilters) {
        $toastr.warning(
          $translationService.getTranslationController(
            'No hay filtros disponibles para la columna ',
            'There is no filters available for column ',
            'Não há filtros disponíveis para coluna '
          ) + col.name
        );
        return;
      }

      $mdDialog
        .show({
          controller: 'IssuesFiltersDialogController',
          controllerAs: 'ctrl',
          templateUrl:
            'app/dashboard/components/issues-filters-dialog/issues-filters-dialog.html',
          parent: angular.element(document.body),
          targetEvent: event,
          clickOutsideToClose: false,
          multiple: true,
          locals: {
            column: col,
            columnFilters: selectedColumnFilters,
          },
        })
        .then(function (predicate) {
          vm.filters.predicates.push(predicate);
          _loadReferenceValues();
        });
    };

    vm.removeFilter = function (index) {
      if (index == 'ALL') {
        vm.filters.predicates = [];
      } else {
        vm.filters.predicates.splice(index, 1);
      }

      _loadReferenceValues();
    };

    vm.select = function () {
      delete vm.selectedRow.$$hashKey;
      $mdDialog.hide(vm.selectedRow);
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

'use strict';

var app = angular.module('dashboard');

app.component('issueComplexField', {
  templateUrl:
    'app/dashboard/components/issue-dynamic-schema/components/issue-complex-field/issue-complex-field.html',
  controllerAs: 'ctrl',
  bindings: {
    model: '=',
    disabled: '=',
    field: '<',
    key: '<',
  },
  controller: issueComplexField,
});

issueComplexField.$inject = [];
function issueComplexField() {
  var vm = this;

  vm.$onInit = function () {
    vm.schema = vm.field.metadata.body;
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('statusGrid', {
  templateUrl:
    'app/configuration/dialog/issues-type/components/status-grid/status-grid.html',

  controllerAs: 'ctrl',
  bindings: {
    data: '=',
  },
  controller: statusGridController,
});

statusGridController.$inject = ['$scope', 'translationService'];
function statusGridController($scope, $translationService) {
  var vm = this;

  vm.tableSettings = {
    licenseKey: 'non-commercial-and-evaluation',
    stretchH: 'all',
    renderAllRows: false,
    colWidths: 100,
    width: '100%',
    height: 200,
    colHeaders: true,
    rowHeaders: false,
    currentRowClassName: 'cep-selected-row',
    manualColumnResize: true,
    manualRowResize: true,
    persistentState: false,
    columnSorting: false,
    allowInvalid: true,
    columnHeaderHeight: 10,
    outsideClickDeselects: false,
    contextMenu: {
      items: {
        remove_row: {
          name: $translationService.getTranslationController(
            'Eliminar fila',
            'Remove row',
            'Remover fila'
          ),
        },
      },
    },
    beforeCreateRow: function () {
      // Avoid to create row automatically
      return false;
    },
  };

  $scope.gridOptions = {
    columnDefs: [
      {
        displayName: 'name',
        name: 'name',
        field: 'name',
        align: 'htCenter',
      },
      {
        displayName: 'icon',
        name: 'icon',
        field: 'icon',
        align: 'htCenter',
      },
      {
        displayName: 'color',
        name: 'color',
        field: 'color',
        align: 'htCenter',
      },
      {
        displayName: 'weight',
        name: 'weight',
        field: 'weight',
        align: 'htCenter',
      },
      {
        displayName: 'type',
        name: 'type',
        field: 'type',
        align: 'htCenter',
      },
      {
        displayName: 'sla.active',
        name: 'active',
        field: 'sla.active',
        align: 'htCenter',
        cellTemplate:'<input type="checkbox" ng-model="row.entity.sla.active">'
      },
      {
        displayName: 'sla.action',
        name: 'sla.action',
        field: 'sla.action',
        align: 'htCenter',
      },
      {
        displayName: 'sla.daysToSolve',
        name: 'daysToSolve',
        field: 'sla.daysToSolve',
        align: 'htCenter',
      },
      {
        displayName: 'sla.daysForRetryNotification',
        name: 'sla.daysForRetryNotification',
        field: 'sla.daysForRetryNotification',
        align: 'htCenter',
      },
      {
        displayName: 'sla.businessDays',
        name: 'sla.businessDays',
        field: 'sla.businessDays',
        align: 'htCenter',
        cellTemplate:'<input type="checkbox" ng-model="row.entity.sla.businessDays">'
      }
    ],
    data: vm.data || [],
  };

  vm.tableColumns = $scope.gridOptions.columnDefs.map(function (col) {
    if (col.name == 'type') {
      return {
        type: 'dropdown',
        trimDropdown: true,
        strict: true,
        allowInvalid: false,
        source: ['PENDING', 'IN_PROCESS', 'DONE'],
        className: 'schema-editor-cell ' + col.align,
        data: col.field,
        title: col.displayName || col.name,
        width: 80,
      };
    }

    return {
      type: 'text',
      className: 'schema-editor-cell ' + col.align,
      data: col.field,
      title: col.displayName || col.name,
      width: col.width,
    };
  });

  $scope.$watch('ctrl.data', function (nval) {
    $scope.gridOptions.data = nval;
  });

  $scope.deleteRow = function (row) {
    var index = vm.data.indexOf(row);
    vm.data.splice(index, 1);
    vm.data = vm.data.map(function (e, i) {
      e.id = i;
      return e;
    });
  };

  $scope.addRow = function () {
    vm.data.push({
      name: '',
      icon: '',
      color: '',
      weight: '',
      type: '',
      sla: {
        active: false,
        action: 'ALERT',
        daysToSolve: 0,
        daysForRetryNotification: 0
      }
    });
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('criticalitiesGrid', {
  templateUrl:
    'app/configuration/dialog/issues-type/components/criticalities-grid/criticalities-grid.html',
  controllerAs: 'ctrl',
  bindings: {
    data: '=',
  },
  controller: criticalitiesGridController,
});

criticalitiesGridController.$inject = ['$scope', 'translationService'];
function criticalitiesGridController($scope, $translationService) {
  var vm = this;

  vm.tableSettings = {
    licenseKey: 'non-commercial-and-evaluation',
    stretchH: 'all',
    renderAllRows: false,
    colWidths: 100,
    width: '100%',
    height: 200,
    colHeaders: true,
    rowHeaders: false,
    currentRowClassName: 'cep-selected-row',
    manualColumnResize: true,
    manualRowResize: true,
    persistentState: false,
    columnSorting: false,
    allowInvalid: true,
    columnHeaderHeight: 10,
    outsideClickDeselects: false,
    contextMenu: {
      items: {
        remove_row: {
          name: $translationService.getTranslationController(
            'Eliminar fila',
            'Remove row',
            'Remover fila'
          ),
        },
      },
    },
    beforeCreateRow: function () {
      // Avoid to create row automatically
      return false;
    },
  };

  $scope.gridOptions = {
    columnDefs: [
      {
        displayName: 'name',
        name: 'name',
        field: 'name',
        align: 'htCenter',
      },
      {
        displayName: 'icon',
        name: 'icon',
        field: 'icon',
        align: 'htCenter',
      },
      {
        displayName: 'color',
        name: 'color',
        field: 'color',
        align: 'htCenter',
      },
      {
        displayName: 'weight',
        name: 'weight',
        field: 'weight',
        align: 'htCenter',
      },
    ],
    data: vm.data || [],
  };

  vm.tableColumns = $scope.gridOptions.columnDefs.map(function (col) {
    return {
      type: 'text',
      className: 'schema-editor-cell ' + col.align,
      data: col.field,
      title: col.displayName || col.name,
      width: col.width,
    };
  });

  $scope.$watch('ctrl.data', function (nval) {
    $scope.gridOptions.data = nval;
  });

  $scope.deleteRow = function (row) {
    var index = vm.data.indexOf(row);
    vm.data.splice(index, 1);
    vm.data = vm.data.map(function (e, i) {
      e.id = i;
      return e;
    });
  };

  $scope.addRow = function () {
    vm.data.push({
      name: '',
      icon: '',
      color: '',
      weight: '',
    });
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('classificationsGrid', {
  templateUrl:
    'app/configuration/dialog/issues-type/components/classifications-grid/classifications-grid.html',
  controllerAs: 'ctrl',
  bindings: {
    data: '=',
  },
  controller: classificationsGridController,
});

classificationsGridController.$inject = ['$scope', 'translationService'];
function classificationsGridController($scope, $translationService) {
  var vm = this;

  vm.tableSettings = {
    licenseKey: 'non-commercial-and-evaluation',
    stretchH: 'all',
    renderAllRows: false,
    colWidths: 100,
    width: '100%',
    height: 200,
    colHeaders: true,
    rowHeaders: false,
    currentRowClassName: 'cep-selected-row',
    manualColumnResize: true,
    manualRowResize: true,
    persistentState: false,
    columnSorting: false,
    allowInvalid: true,
    columnHeaderHeight: 10,
    outsideClickDeselects: false,
    contextMenu: {
      items: {
        remove_row: {
          name: $translationService.getTranslationController(
            'Eliminar fila',
            'Remove row',
            'Remover fila'
          ),
        },
      },
    },
    beforeCreateRow: function () {
      // Avoid to create row automatically
      return false;
    },
  };

  $scope.gridOptions = {
    columnDefs: [
      {
        displayName: 'name',
        name: 'name',
        field: 'name',
        align: 'htCenter',
      },
      {
        displayName: 'weight',
        name: 'weight',
        field: 'weight',
        align: 'htCenter',
      },
    ],
    data: vm.data || [],
  };

  vm.tableColumns = $scope.gridOptions.columnDefs.map(function (col) {
    return {
      type: 'text',
      className: 'schema-editor-cell ' + col.align,
      data: col.field,
      title: col.displayName || col.name,
      width: col.width,
    };
  });

  $scope.$watch('ctrl.data', function (nval) {
    $scope.gridOptions.data = nval;
  });

  $scope.deleteRow = function (row) {
    var index = vm.data.indexOf(row);
    vm.data.splice(index, 1);
    vm.data = vm.data.map(function (e, i) {
      e.id = i;
      return e;
    });
  };

  $scope.addRow = function () {
    vm.data.push({
      name: '',
      weight: '',
    });
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('cronWeek', {
  templateUrl:
    'app/app-utils/directives/cron-builder/components/cron-week/cron-week.html',
  controllerAs: 'ctrl',
  bindings: {
    expression: '=',
  },
  controller: cronWeekController,
});

cronWeekController.$inject = ['$scope', 'translationService'];
function cronWeekController($scope, $translationService) {
  var vm = this;
  vm.rpt = 'every';
  vm.onValue = '0';
  vm.selected = [];
  vm.$onInit = function () {
    vm.selectType();
    vm.parseExpression();
  };

  vm.selectType = function () {
    vm.text = {
      every: $translationService.getTranslationController(
        'Cada',
        'Every',
        'Cada'
      ),
      label: $translationService.getTranslationController('Dia', 'Day', 'Dia'),
      week: $translationService.getTranslationController(
        'Lunes a Viernes',
        'Monday to Friday',
        'Segunda a Sexta'
      ),
    };
    vm.state = {
      values: [
        {
          name: $translationService.getTranslationController(
            'Todos los días',
            'Everyday',
            'Todos os dias'
          ),
          nameShort: $translationService.getTranslationController(
            'Todos los días',
            'Everyday',
            'Todos os dias'
          ),
          value: '*',
        },
        {
          name: $translationService.getTranslationController(
            'Domingo',
            'Sunday',
            'Domingo'
          ),
          nameShort: $translationService.getTranslationController(
            'Dom',
            'Sun',
            'Dom'
          ),
          value: '0',
        },
        {
          name: $translationService.getTranslationController(
            'Lunes',
            'Monday',
            'Segunda-feira'
          ),
          nameShort: $translationService.getTranslationController(
            'Lun',
            'Mon',
            'Seg'
          ),
          value: '1',
        },
        {
          name: $translationService.getTranslationController(
            'Martes',
            'Tuesday',
            'Terça-feira'
          ),
          nameShort: $translationService.getTranslationController(
            'Mar',
            'Tue',
            'Ter'
          ),
          value: '2',
        },
        {
          name: $translationService.getTranslationController(
            'Miercoles',
            'Wednesday',
            'Quarta-feira'
          ),
          nameShort: $translationService.getTranslationController(
            'Mie',
            'Wed',
            'Qua'
          ),
          value: '3',
        },
        {
          name: $translationService.getTranslationController(
            'Jueves',
            'Thursday',
            'Quinta-feira'
          ),
          nameShort: $translationService.getTranslationController(
            'Jue',
            'Thu',
            'Qui'
          ),
          value: '4',
        },
        {
          name: $translationService.getTranslationController(
            'Viernes',
            'Friday',
            'Sexta-feira'
          ),
          nameShort: $translationService.getTranslationController(
            'Vie',
            'Fri',
            'Sex'
          ),
          value: '5',
        },
        {
          name: $translationService.getTranslationController(
            'Sábado',
            'Saturday',
            'Sábado'
          ),
          nameShort: $translationService.getTranslationController(
            'Sab',
            'Sat',
            'Sab'
          ),
          value: '6',
        },
      ],
    };
  };

  vm.toggle = function (item, list) {
    var idx = list.indexOf(item);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push(item);
    }
  };

  vm.exists = function (item, list) {
    return list.indexOf(item) > -1;
  };

  vm.parseExpression = function () {
    if (vm.expression == '1-5') {
      vm.rpt = 'mon-fri';
      vm.value = '1-5';
    } else if (vm.expression.toString().indexOf(',') > 0) {
      vm.rpt = 'select';
      vm.selected = vm.expression.split(',');
    } else {
      vm.rpt = 'on-time';
      vm.onValue = vm.expression;
    }
  };
  vm.regenerateCron = function () {
    switch (vm.rpt) {
      case 'on-time':
        vm.expression = vm.onValue;
        break;
      case 'mon-fri':
        vm.expression = '1-5';
        break;
      case 'select':
        vm.expression = vm.selected.join(',');
    }
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('cronTime', {
  templateUrl: 'app/app-utils/directives/cron-builder/components/cron-time/cron-time.html',
  controllerAs: 'ctrl',
  bindings: {
    expression: '=',
    type: '@'
  },
  controller: cronTimeController,
});

cronTimeController.$inject = ['$scope', 'translationService'];
function cronTimeController($scope, $translationService) {
  var vm = this;
  vm.rpt = 'every';
  vm.evValue = '0';
  vm.onValue = '0';
  vm.$onInit = function(){
    vm.parseExpression();
    vm.selectType();
  }

  vm.selectType = function(){
    vm.text = { every: $translationService.getTranslationController('Cada', 'Every', 'Cada') };
    switch(vm.type){
      case 'year':
        vm.text.label = $translationService.getTranslationController('Año', 'Year', 'Anio');
        vm.state = { values: ['*'].concat(getYears(2)) }
        break
      case 'month':
        vm.text.label = $translationService.getTranslationController('Mes', 'Month', 'Mês');
        vm.state = { values: ['*'].concat(getNumbers(12)) }
        break;
      case 'day':
        vm.text.label = $translationService.getTranslationController('Dia', 'Day', 'Dia');
        vm.state = { values: ['*', '0'].concat(getNumbers(31)) }
        break;
      case 'hour':
        vm.text.label = $translationService.getTranslationController('Hora', 'Hour', 'Hora');
        vm.state = { values: ['*', '0'].concat(getNumbers(24)) }
        break;
      case 'minute':
        vm.text.label = $translationService.getTranslationController('Minuto', 'Minute', 'Minuto');
        vm.state = { values: ['*', '0'].concat(getNumbers(59)) }
        break
    }
  }

  vm.parseExpression = function(){
    if(vm.expression.toString().indexOf('/') > -1){
      vm.rpt = 'every';
      vm.evValue = vm.expression.split('/')[1];
    }else{
      vm.rpt = 'on-time';
      vm.onValue = vm.expression;
    }
  }

  vm.regenerateCron = function(){
    if(vm.rpt == 'on-time'){
      vm.expression = vm.onValue;
    }else{
      vm.expression = ['0', '*'].includes(vm.evValue) ?  vm.evValue : '*/' + vm.evValue;
    }
  }
  
  function getNumbers(max){
    var current = 1; var numbers = [];
    for(var i = 0; i < max; i++) numbers.push((current++).toString());
    return numbers;
  }

  function getYears(max){
    var current = new Date().getFullYear();
    var numbers = [];
    max += current;
    for(var i = current; i < max; i++) numbers.push((current++).toString());
    return numbers;
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('cronOnceAYear', {
  templateUrl:
    'app/app-utils/directives/cron-builder/components/cron-once-a-year/once-a-year.html',
  controllerAs: 'ctrl',
  bindings: {
    cron: '=',
  },
  controller: cronOnceAYearController,
});

cronOnceAYearController.$inject = ['$scope'];
function cronOnceAYearController($scope) {
  var vm = this;

  vm.minute = vm.cron.minute || '';
  vm.hour = vm.cron.hour || '';
  vm.dayOfMonth = vm.cron.dayOfMonth || '';
  vm.month = vm.cron.month || '';

  vm.updateCron = function () {
    vm.cron = {
      seconds: '0',
      minute: vm.minute,
      hour: vm.hour,
      dayOfMonth: vm.dayOfMonth,
      month: vm.month,
      dayOfWeek: '?',
      year: '*',
    };
  };

  $scope.months = [
    'JAN',
    'FEB',
    'MAR',
    'APR',
    'MA',
    'JUN',
    'JUL',
    'AUG',
    'SEP',
    'OCT',
    'NOV',
    'DEC',
  ];

  $scope.days = Array.from({ length: 31 }, function (v, k) {
    return k + 1;
  });

  $scope.minutes = Array.from({ length: 60 }, function (v, k) {
    return k;
  });

  $scope.hours = Array.from({ length: 24 }, function (v, k) {
    return k;
  });
}

'use strict';

var app = angular.module('dashboard');

app.component('cronOnceAMonth', {
  templateUrl:
    'app/app-utils/directives/cron-builder/components/cron-once-a-month/once-a-month.html',
  controllerAs: 'ctrl',
  bindings: {
    cron: '=',
  },
  controller: cronOnceAMonthController,
});

cronOnceAMonthController.$inject = ['$scope'];
function cronOnceAMonthController($scope) {
  var vm = this;

  vm.minute = vm.cron.minute || '0';
  vm.hour = vm.cron.hour || '0';
  vm.dayOfMonth = vm.cron.dayOfMonth || '0';

  vm.updateCron = function () {
    vm.cron = {
      seconds: '0',
      minute: vm.minute,
      hour: vm.hour,
      dayOfMonth: vm.dayOfMonth,
      month: '*',
      dayOfWeek: '?',
      year: '*',
    };
  };

  $scope.days = Array.from({ length: 31 }, function (v, k) {
    return k + 1;
  });

  $scope.minutes = Array.from({ length: 60 }, function (v, k) {
    return k;
  });

  $scope.hours = Array.from({ length: 24 }, function (v, k) {
    return k;
  });
}

'use strict';

var app = angular.module('dashboard');

app.component('cronOnceADay', {
  templateUrl:
    'app/app-utils/directives/cron-builder/components/cron-once-a-day/once-a-day.html',
  controllerAs: 'ctrl',
  bindings: {
    cron: '=',
  },
  controller: cronOnceADayController,
});

cronOnceADayController.$inject = ['$scope'];
function cronOnceADayController($scope) {
  var vm = this;

  vm.minute = vm.cron.minute || '0';
  vm.hour = vm.cron.hour || '0';
  vm.dayOfWeek = vm.cron.dayOfWeek || '*';

  vm.updateCron = function () {
    vm.cron = {
      seconds: '0',
      minute: vm.minute,
      hour: vm.hour,
      dayOfMonth: '?',
      month: '*',
      dayOfWeek: vm.dayOfWeek,
      year: '*',
    };
  };

  $scope.days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

  $scope.minutes = Array.from({ length: 60 }, function (v, k) {
    return k;
  });

  $scope.hours = Array.from({ length: 24 }, function (v, k) {
    return k;
  });

  $scope.toggleSelection = function toggleSelection(value) {
    var toarray = vm.dayOfWeek.trim().split(',');

    if (toarray.includes('?')) toarray = [];
    if (toarray.includes('*')) toarray = [];
    if (toarray.includes('')) toarray = [];

    var hasvalue = toarray.includes(value);
    if (hasvalue) {
      toarray.splice(toarray.indexOf(value), 1);
    } else {
      toarray.push(value);
    }

    if (toarray.length == 0) toarray.push('?');
    vm.dayOfWeek = toarray.join();

    vm.updateCron();
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('cronEveryHour', {
  templateUrl:
    'app/app-utils/directives/cron-builder/components/cron-every-hour/every-hour.html',
  controllerAs: 'ctrl',
  bindings: {
    cron: '=',
  },
  controller: cronEveryHourController,
});

cronEveryHourController.$inject = ['$scope'];
function cronEveryHourController($scope) {
  var vm = this;

  vm.minute = vm.cron.minute || '0';
  vm.starthour = vm.cron.hour.split('-')[0] || '*';
  vm.endhour = vm.cron.hour.split('-')[1] || '*';
  vm.dayOfWeek = vm.cron.dayOfWeek || '?';

  vm.between = false;

  vm.updateCron = function () {
    var hour = vm.starthour;

    if (hour != '*') {
      hour = hour + '-' + vm.endhour;
    }

    vm.cron = {
      seconds: '0',
      minute: vm.minute,
      hour: hour,
      dayOfMonth: '?',
      month: '*',
      dayOfWeek: vm.dayOfWeek,
      year: '*',
    };
  };

  vm.toggleBetween = function () {
    if (!vm.between) {
      vm.starthour = '*';
      vm.endhour = '*';
    } else {
      vm.starthour = '0';
      vm.endhour = '0';
    }
    vm.updateCron();
  };

  $scope.days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

  $scope.minutes = Array.from({ length: 60 }, function (v, k) {
    return k;
  });

  $scope.hours = Array.from({ length: 24 }, function (v, k) {
    return k;
  });

  $scope.toggleSelection = function toggleSelection(value) {
    var toarray = vm.dayOfWeek.trim().split(',');

    if (toarray.includes('?')) toarray = [];
    if (toarray.includes('*')) toarray = [];
    if (toarray.includes('')) toarray = [];

    var hasvalue = toarray.includes(value);
    if (hasvalue) {
      toarray.splice(toarray.indexOf(value), 1);
    } else {
      toarray.push(value);
    }

    if (toarray.length == 0) toarray.push('?');
    vm.dayOfWeek = toarray.join();

    vm.updateCron();
  };
}

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller("dialogTextSearchController", dialogTextSearchController);

  dialogTextSearchController.$inject = [
    "$scope",
    "$rootScope",
    "$mdDialog"
  ];
  function dialogTextSearchController(
    $scope,
    $rootScope,
    $mdDialog
  ) {
    var vm = this;
    vm.data = [];
    vm.showSearch = false;

    $scope.$on("textSearch", function (e, data) {
      vm.showSearch = true;
      vm.data = data.map(function (item) {
        return {
          target : item.target,
          headers: Object.keys(item.data[0]),
          rows: item.data.map(function (row) {
            return Object.values(row)
          })
        }
      });
    });

    $scope.$on("textSearchLoading", function () {
      vm.showSearch = false;
    });

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('importTableSelectorController', importTableSelectorController);

  importTableSelectorController.$inject = ['translationService', '$mdDialog'];
  function importTableSelectorController($translationService, $mdDialog) {
    var vm = this;

    // $translationService.getTranslation(vm, 'input-list');

    vm.replaceCurrentData = function () {
      $mdDialog.cancel();
    };
    vm.addToCurrentData = function () {
      $mdDialog.cancel();
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('tableDataFilterController', tableDataFilterController);

  tableDataFilterController.$inject = [
    '$scope',
    'translationService',
    '$mdDialog',
    'table',
    'columns',
    'selected',
    'predicates',
    'translation',
  ];
  function tableDataFilterController(
    $scope,
    $translationService,
    $mdDialog,
    table,
    columns,
    selected,
    predicates,
    translation
  ) {
    var vm = this;

    $translationService.getTranslation($scope, 'data-management');

    vm.predicates = angular.copy(predicates) || [];

    vm.value = null;
    vm.operation = null;
    vm.predicateForm = false;
    vm.columns = columns;

    var inputsTypes = {
      string: 'text',
      numeric: 'number',
      boolean: 'checkbox',
      checkbox: 'checkbox',
      date: 'date',
      timestamp: 'datetime-local',
      time: 'time',
    };
    var defaultInputType = 'text';

    vm.newPredicate = {
      fieldName: null,
      operation: null,
      value: null,
      values: [null, null],
      type: null,
    };

    vm.togglePredicateForm = function () {
      vm.newPredicate = {
        fieldName: null,
        operation: null,
        value: null,
        values: [null, null],
      };
      vm.predicateForm = !vm.predicateForm;
    };
    vm.togglePredicateForm();

    vm.removePredicate = function (index) {
      vm.predicates.splice(index, 1);
      // $scope.$emit('reloadTable');
    };

    vm.addPredicate = function () {
      var predicate = angular.copy(vm.newPredicate);

      if (!predicate.fieldName) return;
      if (!predicate.operation) return;
      if (predicate.operation === 'BETWEEN') {
        var hasValues = predicate.values.every(function (e) {
          return e !== null;
        });
        if (!hasValues) return;
      } else {
        if (!predicate.value) return;
      }

      var column = vm.columns.find(function (e) {
        return e.data == predicate.fieldName;
      });

      if (
        ['datetime-local', 'date'].includes(column.colType) &&
        predicate.value
      ) {
        var date = predicate.value;
        predicate.value = moment(date).format(column.dateFormat);
      }

      if (
        ['datetime-local', 'date'].includes(column.colType) &&
        predicate.values.every(function (e) {
          return e !== null;
        })
      ) {
        var date_1 = predicate.values[0];
        var date_2 = predicate.values[1];
        predicate.values[0] = moment(date_1).format(column.dateFormat);
        predicate.values[1] = moment(date_2).format(column.dateFormat);
      }

      if (column.colType === 'boolean') {
        predicate.value = predicate.value === 'on';
      }

      delete predicate.type;

      vm.predicates.push(predicate);
      vm.newPredicate = {
        fieldName: null,
        operation: null,
        value: null,
        values: [null, null],
        type: null,
      };
      vm.predicateForm = false;
      // $scope.$emit('reloadTable');
    };

    vm.onChangeColumn = function (index) {
      vm.newPredicate.operation = null;
      vm.onChangeOperation(index);
    };

    vm.onChangeOperation = function (index) {
      vm.newPredicate.value = null;
      vm.newPredicate.values = [null, null];
    };

    vm.getOperations = function (col) {
      if (!col) return [];
      var column = vm.columns.find(function (e) {
        return e.data == col;
      });
      return column ? column.operations : [];
    };

    vm.getInputType = function (col) {
      if (!col) return [];
      var column = vm.columns.find(function (e) {
        return e.data == col;
      });

      var type = column ? inputsTypes[column.colType] || defaultInputType : [];

      vm.newPredicate.type = type;

      return type;
    };

    vm.inputTypeByColumn = function (type) {
      return 'text';
    };

    vm.applyFilters = function () {
      $mdDialog.hide(vm.predicates);
    };
    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

'use strict';

var app = angular.module('dashboard');

app.component('tableDataFilter', {
  templateUrl:
    'app/app-utils/components/table-data/dialogs/filter/table-data-filter.html',
  controllerAs: 'ctrl',
  bindings: {
    columns: '=',
    predicates: '=',
    translation: '=',
  },
  controller: tableDataFilterController,
});

tableDataFilterController.$inject = ['$scope', '$element'];

function tableDataFilterController($scope, $element) {
  var vm = this;

  vm.value = null;
  vm.operation = null;
  vm.predicateForm = false;

  var inputsTypes = {
    string: 'text',
    numeric: 'number',
    boolean: 'checkbox',
    date: 'datetime-local',
    time: 'time',
  };
  var defaultInputType = 'text';

  vm.newPredicate = {
    fieldName: null,
    operation: null,
    value: null,
    values: [null, null],
  };

  vm.togglePredicateForm = function () {
    vm.newPredicate = {
      fieldName: null,
      operation: null,
      value: null,
      values: [null, null],
    };
    vm.predicateForm = !vm.predicateForm;
  };

  vm.removePredicate = function (index) {
    vm.predicates.splice(index, 1);
    $scope.$emit('reloadTable');
  };

  vm.addPredicate = function () {
    if (!vm.newPredicate.fieldName) return;
    if (!vm.newPredicate.operation) return;
    if (vm.newPredicate.operation === 'BETWEEN') {
      var hasValues = vm.newPredicate.values.every(function (e) {
        return e !== null;
      });
      if (!hasValues) return;
    } else {
      if (!vm.newPredicate.value) return;
    }

    vm.predicates.push(vm.newPredicate);
    vm.newPredicate = {
      fieldName: null,
      operation: null,
      value: null,
      values: [null, null],
    };
    vm.predicateForm = false;
    $scope.$emit('reloadTable');
  };

  vm.onChangeColumn = function (index) {
    vm.newPredicate.operation = null;
    vm.onChangeOperation(index);
  };

  vm.onChangeOperation = function (index) {
    vm.newPredicate.value = null;
    vm.newPredicate.values = [null, null];
  };

  vm.getOperations = function (col) {
    if (!col) return [];
    var column = vm.columns.find(function (e) {
      return e.data == col;
    });
    return column ? column.operations : [];
  };

  vm.getInputType = function (col) {
    if (!col) return [];
    var column = vm.columns.find(function (e) {
      return e.data == col;
    });

    return column ? inputsTypes[column.type] || defaultInputType : [];
  };

  vm.inputTypeByColumn = function (type) {
    return 'text';
  };
}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('exportTableSelectorController', exportTableSelectorController);

  exportTableSelectorController.$inject = ['translationService', '$mdDialog'];
  function exportTableSelectorController($translationService, $mdDialog) {
    var vm = this;
    $translationService.getTranslation(vm, 'input-list');
    vm.selection = 'this';
    vm.selectSheet = function (selection) {
      $mdDialog.hide(selection);
    };
    vm.abortSelection = function () {
      $mdDialog.cancel();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('bulkEditController', bulkEditController);

  bulkEditController.$inject = [
    '$rootScope',
    '$mdDialog',
    'toastr',
    'translationService',
    'dataTableService',
    'tableName',
    'schemaName',
    'column',
    'columns',
  ];
  function bulkEditController(
    $rootScope,
    $mdDialog,
    toastr,
    $translationService,
    $dataTableService,
    tableName,
    schemaName,
    column,
    columns
  ) {
    var vm = this;
    $translationService.getTranslation(vm, 'data-management');

    var inputsTypes = {
      boolean: 'checkbox',
      date: 'date',
      double: 'number',
      long: 'number',
      integer: 'number',
      string: 'text',
      time: 'time',
      timestamp: 'datetime-local',
    };
    var defaultInputType = 'text';

    vm.column = column;
    vm.columns = columns;

    vm.$onInit = function () {
      console.log(vm.column);

      vm.replaceWith = {
        columnName: '',
        findValues: [null, null],
        newValue: '',
        operator: '',
      };

      if (!vm.column) return;

      vm.replaceWith.columnName = vm.column.data;

      vm.inputType = vm.column
        ? inputsTypes[vm.column.colType] || defaultInputType
        : null;

      vm.step = vm.column.colType === 'time' ? 2 : false;
    };

    vm.setupColumn = function () {
      console.log('setupColumn', vm.column);
      vm.$onInit();
    };

    vm.changeColumn = function () {
      vm.column = null;
    };

    vm.save = function () {
      if (!vm.column) return;

      var validValues = Object.values(vm.replaceWith).some(function (val) {
        return val === '' || val === null;
      });

      if (validValues) return;

      var replaceWith = angular.copy(vm.replaceWith);

      if (vm.column.colType === 'time') {
        var timeFormat = 'HH:mm:ss';
        replaceWith.findValues[0] = moment(replaceWith.findValues[0]).format(
          timeFormat
        );
        if (replaceWith.operator === 'BETWEEN') {
          replaceWith.findValues[1] = moment(replaceWith.findValues[1]).format(
            timeFormat
          );
        }
        replaceWith.newValue = moment(replaceWith.newValue).format(timeFormat);
      }

      if (['timestamp', 'data'].includes(vm.column.colType)) {
        var timestampFormat = 'YYYY-MM-DD HH:mm:ss';
        replaceWith.findValues[0] = moment(replaceWith.findValues[0]).format(
          timestampFormat
        );
        if (replaceWith.operator === 'BETWEEN') {
          replaceWith.findValues[1] = moment(replaceWith.findValues[1]).format(
            timestampFormat
          );
        }
        replaceWith.newValue = moment(replaceWith.newValue).format(
          timestampFormat
        );
      }

      $rootScope.loading = true;
      $dataTableService
        .replaceWith(tableName, schemaName, vm.replaceWith)
        .then(function (res) {
          toastr.success(res.total + ' Ediciones');
          $mdDialog.hide();
          $rootScope.loading = false;
        })
        .catch(function (err) {
          toastr.error(err);
          $rootScope.loading = false;
        });
    };
    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('folderSettingsController', folderSettingsController);

  folderSettingsController.$inject = [
    '$rootScope',
    '$scope',
    '$state',
    '$mdDialog',
    'folder',
    'toastr',
    'translationService',
    'PermissionsFactory',
    'FilesStorageFactory',
    'PermissionsFactory',
  ];

  function folderSettingsController(
    $rootScope,
    $scope,
    $state,
    $mdDialog,
    folder,
    toastr,
    $translationService,
    PermissionsFactory,
    FilesStorageFactory,
    $permissionsFactory
  ) {
    var vm = this;

    $translationService.getTranslation($scope, 'files-storage');
    vm.loading = true;
    vm.folder = folder
      ? folder
      : {
          name: null,
          description: null,
          color: null,
          extensions: [],
        };
    $scope.global_config_extensions = [];
    $scope.selected_extensions = [];

    vm.getConfigGlobalandInfo = function () {
      vm.loading = true;
      FilesStorageFactory.getConfigStorage()
        .then(function (res) {
          $scope.global_config_extensions = res.settings.extensions;
          //- remove invalid extensions
          vm.folder.extensions = vm.folder.extensions.filter(function (ext) {
            return res.settings.extensions.includes(ext);
          });
          $scope.selected_extensions = angular.copy(vm.folder.extensions);
          vm.loading = false;
        })
        .catch(function (err) {
          vm.loading = false;
          console.error('Error@getConfigGlobalandInfo', err);
        });
    };
    vm.getConfigGlobalandInfo();

    $scope.save = function () {
      vm.loading = true;
      vm.folder.extensions = angular.copy($scope.selected_extensions);
      if (vm.folder.id) {
        FilesStorageFactory.editFolder(vm.folder.id, vm.folder)
          .then(function (res) {
            vm.loading = false;
            toastr.success(
              $translationService.getTranslationController(
                'Carpeta Editada:' + res.name,
                'Edited Folder: ' + res.name,
                'Carpeta Editada: ' + res.name
              )
            );
            $rootScope.$broadcast('refreshStorage');
            $state.go('app.folder', { FolderName: res.id });
            $mdDialog.hide();
          })
          .catch(function (err) {
            console.error('Error@editFolder', err);
            toastr.error(err);
          })
          .finally(function () {
            vm.loading = false;
          });
      } else {
        FilesStorageFactory.createFolder(vm.folder)
          .then(function (res) {
            toastr.success(
              $translationService.getTranslationController(
                'Nueva carpeta creada ' + res.name,
                'New folder created ' + res.name,
                'Nova pasta criada ' + res.name
              )
            );
            $permissionsFactory.addPermission(
              'files-storage-folder',
              res.id,
              'all',
              true
            );
            $rootScope.$broadcast('refreshStorage');
            $state.go('app.folder', { FolderName: res.id });
            $mdDialog.hide();
          })
          .catch(function (err) {
            console.error('Error@createFolder', err);
            toastr.error(err);
          })
          .finally(function () {
            vm.loading = false;
          });
      }
    };

    $scope.cancel = function () {
      $mdDialog.cancel();
    };

    $scope.toggle = function (item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    };

    $scope.exists = function (item, list) {
      return list.indexOf(item) > -1;
    };

    $scope.isIndeterminate = function () {
      return (
        $scope.selected_extensions.length !== 0 &&
        $scope.selected_extensions.length !==
          $scope.global_config_extensions.length
      );
    };

    $scope.isChecked = function () {
      return (
        $scope.selected_extensions.length ===
        $scope.global_config_extensions.length
      );
    };

    $scope.toggleAll = function () {
      if (
        $scope.selected_extensions.length ===
        $scope.global_config_extensions.length
      ) {
        $scope.selected_extensions = [];
      } else if (
        $scope.selected_extensions.length === 0 ||
        $scope.selected_extensions.length > 0
      ) {
        $scope.selected_extensions = $scope.global_config_extensions.slice(0);
      }
    };

    $scope.validatePermission = function (action) {
      return PermissionsFactory.hasPermission(
        'files-storage-folder#' + vm.id + ':' + action
      );
    };
  }
})();


(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('MoveFileController', MoveFileController);

  MoveFileController.$inject = [
    '$scope',
    '$rootScope',
    '$mdDialog',
    'toastr',
    'translationService',
    'FilesStorageFactory',
    'PermissionsFactory',
    'fileID',
    'fileName',
    'folderID',
  ];

  function MoveFileController(
    $scope,
    $rootScope,
    $mdDialog,
    $toastr,
    $translationService,
    FilesStorageFactory,
    PermissionsFactory,
    fileID,
    fileName,
    folderID
  ) {
    var vm = this;
    vm.loading = false;
    vm.folderSelected = '';
    vm.fileID = fileID; // number - array;
    vm.fileName = fileName;
    vm.folderID = folderID;
    vm.foldersList = [];

    $translationService.getTranslation(vm, 'files-storage');

    vm.getFolders = function () {
      vm.loading = true;
      FilesStorageFactory.getFolders()
        .then(function (res) {
          vm.foldersList = res.data
            .map(function (fd) {
              return { name: fd.name, id: fd.id };
            })
            .filter(function (i) {
              return i.id != vm.folderID;
            });
        })
        .catch(function (err) {
          console.error('Error@foldersList', err);
          vm.errorReport.status = true;
          vm.errorReport.error = 'Folder Not found';
        })
        .finally(function () {
          vm.loading = false;
        });
    };
    vm.getFolders();

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    $scope.validatePermission = function (action) {
      return PermissionsFactory.hasPermission(
        'files-storage-folder#' + vm.folderID + ':' + action
      );
    };

    vm.moveFileToFolder = function () {
      vm.loading = true;
      if (vm.folderSelected == '') {
        $toastr.error(
          $translationService.getTranslationController(
            'Selecciona una carpeta destino',
            'Select a destination folder',
            'Selecione uma pasta de destino'
          )
        );
        return;
      }

      FilesStorageFactory.getFilesInFolder(vm.folderSelected)
        .then(function (res) {
          var foundFile = res.data.find(function (e) {
            return e.name == vm.fileName;
          });
          if (foundFile) {
            var foundFolder = vm.foldersList.find(function (e) {
              return e.id == vm.folderSelected;
            });
            var confirm = $mdDialog
              .confirm()
              .title(
                $translationService.getTranslationController(
                  'En la carpeta ' +
                    foundFile.folderName +
                    ' existe un archivo igual - ¿Seguro desea mover este archivo?',
                  'In the folder  ' +
                    foundFolder.name +
                    ' there is an equal file - Are you sure you want to move this file?',
                  'Na pasta ' +
                    foundFolder.name +
                    '  existe um arquivo igual - Tem certeza de que deseja mover este arquivo?'
                )
              )
              .textContent(
                $translationService.getTranslationController(
                  'Éste reemplaza al existente en la carpeta ' +
                    foundFile.folderName,
                  'This replaces the existing one in the folder ' +
                    foundFolder.name,
                  'Isso substitui o existente na pasta ' + foundFolder.name
                )
              )
              .ariaLabel('restoreFileToFolder')
              .ok(
                $translationService.getTranslationController(
                  'Si!',
                  'Yes!',
                  'Si'
                )
              )
              .cancel(
                $translationService.getTranslationController(
                  'Cancelar',
                  'Cancel',
                  'Cancelar'
                )
              );
            $mdDialog.show(confirm).then(
              function () {
                vm.move();
              },
              function () {
                $toastr.info(
                  $translationService.getTranslationController(
                    'Cancelado',
                    'Cancelled',
                    'Cancelado'
                  )
                );
              }
            );
          } else {
            vm.move();
          }
        })
        .catch(function (err) {
          console.error('Error@getFilesInFolder', err);
          $toastr.error(err);
        })
        .finally(function () {
          vm.loading = false;
        });
    };

    vm.move = function () {
      if (Array.isArray(vm.fileID)) {
        vm.loading = true;
        var promises = vm.fileID.map(function (file) {
          return FilesStorageFactory.moveFileToFolder(
            vm.folderID,
            file,
            vm.folderSelected
          );
        });
        Promise.allSettled(promises)
          .then(function (res) {
            console.log(res);
            vm.loading = false;
            var allFilesMoved = res.every(function (f) {
              return f.status === 'fulfilled';
            });
            console.log(allFilesMoved);
            if (allFilesMoved) {
              $toastr.success(
                $translationService.getTranslationController(
                  res.length + ' Archivos se movió exitosamente!',
                  res.length + ' Files moved successfully!',
                  res.length + ' arquivo foi movido com sucesso!'
                )
              );
            } else {
              res.forEach(function (f) {
                if (f.status === 'rejected') {
                  console.log('can move');
                  console.log(f);
                  $toastr.warning(f.reason);
                }
              });
            }
            $rootScope.$broadcast('refreshStorage');
            vm.cancel();
          })
          .catch(function (err) {
            console.error('PromiseMoveFiles', err);
            $toastr.error(err);
          });
      } else {
        vm.loading = true;
        FilesStorageFactory.moveFileToFolder(
          vm.folderID,
          vm.fileID,
          vm.folderSelected
        )
          .then(function (res) {
            $toastr.success(
              $translationService.getTranslationController(
                'El archivo se movió exitosamente!',
                'The file moved successfully!',
                'O arquivo foi movido com sucesso!'
              )
            );
            $rootScope.$broadcast('refreshStorage');
            vm.cancel();
          })
          .catch(function (err) {
            console.error('Error@moveFileToFolder', err);
            $toastr.error(err);
          })
          .finally(function () {
            vm.loading = false;
          });
      }
    };
  }
})();

"use strict";

var app = angular.module('dashboard');

app.component('typeObject', {
    templateUrl: 'app/rule-editor/components/json-editor/comps/type-object.html',
    controllerAs: 'ctrl',
    bindings: {
        obj: "=",
        ref: "@"
    },
    controller: jsonTypeObjectController
});
jsonTypeObjectController.$inject = ['$scope'];
function jsonTypeObjectController($scope) {
    var vm = this;
	$scope.keys  = Object.keys(vm.obj) ? Object.keys(vm.obj) : [];
	$scope.vals  = Object.values(vm.obj) ? Object.values(vm.obj) : [];

	$scope.items = [];
	$scope.keys.forEach(function(e,i){
		var ele = {e:$scope.vals[i]};
		$scope.items.push(ele)
	});
   	$scope.getTypeof = function(ele){ 
    	var type = typeof(ele); 
		if(Array.isArray(ele)){type='array'}
    	return type
    };
}

	
"use strict";

var app = angular.module('dashboard');

app.component('typeNumber', {
    templateUrl: 'app/rule-editor/components/json-editor/comps/type-number.html',
    controllerAs: 'ctrl',
    bindings: {
        value: "@"
    },
    controller: jsonTypeNumberController
});
jsonTypeNumberController.$inject = ['$scope'];
function jsonTypeNumberController($scope) {
    var vm = this;
        vm.size = vm.value.length
}


"use strict";

var app = angular.module('dashboard');

app.component('typeArray', {
    templateUrl: 'app/rule-editor/components/json-editor/comps/type-array.html',
    controllerAs: 'ctrl',
    bindings: {
        array: "=",
        ref: "@"
    },
    controller: jsonTypeArrayController
});
jsonTypeArrayController.$inject = ['$scope'];
function jsonTypeArrayController($scope) {
    var vm = this;
    $scope.getTypeof = function(ele){ 
    	var type = typeof(ele); 
		if(Array.isArray(ele)){type='array'}
    	return type
    };
}


"use strict";

var app = angular.module("dashboard");

app.component("documentCard", {
  templateUrl:
    "app/main/components/user-documents/components/document-card.html",
  controllerAs: "ctrl",
  controller: documentCardController,
  bindings: {
    document: "=",
  },
});

documentCardController.$inject = ["$scope", "DocumentsFactory"];
function documentCardController($scope, $documentsFactory) {
  var vm = this;
  vm.downloadDocument = function () {
    console.log(vm.document);
    $documentsFactory
      .DownloadDocument(vm.document.id)
      .then(function (response) {
        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        setTimeout(function () {
          console.clear();
        }, 500);
      });
  };
}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .service('notificationsService', notificationsService);

  notificationsService.$inject = ['NotificationsFactory', 'translationService'];
  function notificationsService($notificationsFactory, $translationService) {
    var translation = {
      ISSUES_STATUS: $translationService.getTranslationController(
        'Issues',
        'Issues',
        'Issues'
      ),
      EXPIRED_ISSUES: $translationService.getTranslationController(
        'Expiradas',
        'Expiradas',
        'Expiradas'
      ),
      ISSUES_ALERT: $translationService.getTranslationController(
        'Alerta',
        'Alert',
        'Alerta'
      ),
    };
    this.notifications = [];

    this.getNotificationsCount = function () {
      return $notificationsFactory
        .getNotificationsCount()
        .then(function (res) {
          return res.data;
        })
        .catch(function (err) {
          console.log('Error@getNotificationsCount', err);
        });
    };

    this.getNotifications = function (pagination, onlyUnread) {
      return new Promise(function (resolve, reject) {
        var TARGETS = ['ISSUES_STATUS', 'EXPIRED_ISSUES', 'ISSUES_ALERT'];
        var promises = [];
        TARGETS.forEach(function (target) {
          promises.push(
            $notificationsFactory.getNotifications(
              pagination,
              onlyUnread,
              target
            )
          );
        });
        Promise.allSettled(promises)
          .then(function (res) {
            var allnotifications = res
              .filter(function (notifications) {
                return notifications.status === 'fulfilled';
              })
              .map(function (notifications, index) {
                return createTab(
                  translation[TARGETS[index]],
                  notifications.value.data.data,
                  notifications.value.data.pagination,
                  onlyUnread
                );
              });

            resolve({
              notifications: allnotifications,
            });
          })
          .catch(function (err) {
            console.error('Error@Promise', err);
            reject(err);
          });
      }).catch(function (err) {
        console.error('Error@getNotifications', err);
        reject(err);
      });
    };
  }
})();

function createTab(target, notifications, pagination) {
  pagination.items = notifications.length;

  notifications = notifications.map(function (e) {
    e.selected = false;
    return e;
  });

  return {
    name: target,
    notifications: notifications,
    display: true,
    target: target,
    pagination: pagination,
  };
}

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller("LinkListController", LinkListController);

  LinkListController.$inject = [
    "$scope",
    "$rootScope",
    "$state",
    "$stateParams",
    "$mdDialog",
    "toastr",
    "formats",
    "SchemasService",
    "listService",
    "translationService",
    "tableListConstants",
    "InputListsFactory",
    "ConfigurationFactory",
    "listExporterService",
    "uiGridConstants",
    "cellTemplateFormatService",
    "IssuesFactory",
    "PermissionsFactory",
    "initfilter",
    "listid"
  ];

  function LinkListController(
    $scope,
    $rootScope,
    $state,
    $stateParams,
    $mdDialog,
    $toastr,
    $formats,
    $schemasService,
    $listService,
    $translationService,
    $tableListConstants,
    $inputListsFactory,
    $ConfigurationFactory,
    $listExporterService,
    $uiGridConstants,
    $cellTemplateFormatService,
    $issuesFactory,
    $permissionsFactory,
    initfilter,
    listid
  ) {
    $translationService.getTranslation($scope, "input-list");
    $rootScope.loading = true;

    var vm = this;
    vm.schemasFormat = [];
    vm.list = {};
    vm.dataList = [];
    vm.showTable = false;
    vm.columns = [];
    vm.schema = [];
    vm.groups = [];
    vm.showTable = false;
    vm.shouldShowFilters = false;
    vm.filters = $tableListConstants.defaultFiltersTemplate;
    vm.tableIsLoading = false;

    vm.gridOptions = {
      rowTemplate:
        '<div ng-dblclick="grid.appScope.ctrl.onClickListRow(row.entity)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>',
      minimumColumnSize: 100,
      useExternalPagination: true,
      paginationPageSizes: [5, 10, 25, 50, 100],
      paginationPageSize: 100,
      totalItems: 0,
      useExternalSorting: true,
      showGridFooter: true,
      showColumnFooter: true,
      onRegisterApi: function (gridApi) {
        $scope.gridApi = gridApi;
        gridApi.pagination.on.paginationChanged(
          $scope,
          function (newPage, pageSize) {
            vm.filters.pagination.page = newPage;
            vm.filters.pagination.itemsPerPage = pageSize;

            _getListData();
          }
        );
        gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (sortColumns[0]) {
            var colField = sortColumns[0].field.split(".")[0];

            vm.filters.pagination.sortBy = colField;
            vm.filters.pagination.sort = sortColumns[0].sort.direction;
          } else {
            vm.filters.pagination.sortBy = null;
          }

          _getListData();
        });
      },
    };

    $scope.params = {
      listId: listid,
      filters: {
        luceneQueryId:null,
        predicates: [],
      },
    };

    function _getColumnDefinition(key) {
      key = key.indexOf("#") === 0 ? key.substring(1) : key;

      return vm.schema[key];
    }

    function _init() {
      vm.filters.predicates = [];
      var promises = [
        $inputListsFactory.getInputList(listid),
        $inputListsFactory.getInputListFilters(listid),
        _getConfigFormatSchema(),
      ];

      Promise.allSettled(promises)
        .then(function (res) {
          vm.list = res[0].value;
          var hasSettings = res[0].value && res[0].value.settings;
          var schemaSettings = hasSettings && angular.fromJson(res[0].value.settings);
          vm.schema = $schemasService.parseSchema(
            vm.list.schema,
            schemaSettings
          );

          vm.columnfilters = res[1].value;
          vm.schemasFormat = res[2].status == "fulfilled" ? res[2].value : [];
        })
        .then(function () {
          _renderList();
          _setColumnDefs()
            .then(function () {
              if (
                $scope.params.filters &&
                $scope.params.filters != null &&
                $scope.params.filters != "null" &&
                $scope.params.filters.predicates
              ) {
                _setDefaultFilters();
              }

              _getListData();
            })
            .catch(function () {
              $toastr.warning(
                $translationService.getTranslationController(
                  "No hay columnas visibles en el esquema.",
                  "There is no columns visible on schema",
                  "Não há colunas visíveis no esquema"
                )
              );
              $rootScope.loading = false;
            });
        })
        .catch(function (error) {
          console.error("Error@getInputList/getInputListFilters", error);
          $toastr.error(error.message);
          $rootScope.loading = false
        });
    }
    _init();

    function _setDefaultFilters() {
      vm.filters.predicates = [];
      $scope.params.filters.predicates.forEach(function (filter) {
        if (filter.field === "time") {
          filter.value = moment(filter.value).format("HH:MM:SS");
        }

        if (filter.field == "id") {
          vm.filters.predicates.push({
            label: filter.field,
            fieldName: filter.field,
            operation: "IN",
            values: filter.values,
            value: null,
            valuesLabels: null,
          });
        } else {
          var colDef = _getColumnDefinition(filter.field);
          if (typeof filter.value == "object") {
            filter.value.forEach(function (item) {
              vm.filters.predicates.push({
                label: colDef.displayName || colDef.key,
                fieldName: filter.field,
                operation: "EQUAL",
                values: null,
                value: item,
                valuesLabels: null,
              });
            });
          } else {
            vm.filters.predicates.push({
              label: colDef.displayName || colDef.key,
              fieldName: filter.field,
              operation: "EQUAL",
              values: null,
              value: filter.value,
              valuesLabels: null,
            });
          }
        }
      });
      vm.isFiltered = true;
    }

    function _setColumnDefs() {
      return new Promise(function (resolve, reject) {
        vm.gridOptions.columnDefs = [];

        angular.forEach(vm.schema, function (col, key) {
          if (col.visible) {
            var field = col.pk ? "#" + key : key;

            var colDef = {
              order: col.order,
              name: key,
              displayName: col.displayName || key,
              field: field,
              cellFilter: $tableListConstants.cellFilters[col.type],
              // General column properties
              enableColumnMenu: true,
              enableSorting: true,
              enableHiding: false,
              aux: col,
              menuItems: [
                {
                  title: $translationService.getTranslationController(
                    "Reemplazar",
                    "Replace",
                    "Substituir"
                  ),
                  icon: "ui-grid-icon-pencil",
                  shown: function () {
                    var hasFilters = vm.columnfilters.find(function (e) {
                      return (
                        e.field.replace("#", "") == col.key ||
                        e.label == col.displayName
                      );
                    });

                    return hasFilters ? true : false;
                  },
                  action: function ($event) {
                    this.context.showReplaceDialog($event, col);
                  },
                  context: vm,
                },
                {
                  title: $translationService.getTranslationController(
                    "Filtrar",
                    "Filter",
                    "Filtro"
                  ),
                  icon: "ui-grid-icon-filter",
                  shown: function () {
                    var hasFilters = vm.columnfilters.find(function (e) {
                      return e.field == col.key || e.label == col.displayName;
                    });

                    return hasFilters ? true : false;
                  },
                  action: function ($event) {
                    this.context.addFilterTo($event, col);
                  },
                  context: vm,
                },
              ],
              aggregationHideLabel: true,
              aggregationType:
                col.type == "integer" || col.type == "double"
                  ? $uiGridConstants.aggregationTypes.sum
                  : null,
              footerCellTemplate:
                col.type == "integer" || col.type == "double"
                  ? '<div class="ui-grid-cell-contents" >{{col.getAggregationValue() | number:2 }}</div>'
                  : "",
            };

            colDef.cellTemplate = $cellTemplateFormatService.setTemplate(
              colDef,
              col,
              vm.schemasFormat
            );

            vm.gridOptions.columnDefs.push(colDef);
          }
        });

        vm.gridOptions.columnDefs = vm.gridOptions.columnDefs.sort(function (
          a,
          b
        ) {
          return a.order - b.order;
        });

        if (vm.gridOptions.columnDefs.length) {
          resolve();
        }
        reject();
      });
    }

    function _getListData() {
      vm.tableIsLoading = true;
      vm.filters.luceneQueryId = $scope.params.filters.luceneQueryId;
      if(initfilter){
        vm.filters.predicates = vm.filters.predicates.concat(initfilter);
        vm.isFiltered = true;
      }

      $inputListsFactory
        .getInputListDataFiltered(listid, vm.filters)
        .then(function (res) {
          vm.gridOptions.totalItems = res.pagination.totalRecords;

          vm.dataList = res.data.map(function (e) {
            return {
              dataId: e.dataId,
              body: angular.fromJson(e.body),
            };
          });

          vm.dataList = vm.dataList.map(function (e) {
            e.body.__dataId = e.dataId;
            var body = e.body;
            return body;
          });

          var cols = $listService.getColumns(vm.schema);
          vm.dataList = $listService.unNormalizeData(vm.dataList, cols);

          vm.gridOptions.data = vm.dataList;

          vm.filterlist = vm.dataList;

          _getMetadataList();
          vm.tableIsLoading = false;
        })
        .catch(function (err) {
          console.error("Error@getInputListData", err);
          vm.tableIsLoading = false;
        })
        .finally(function () {
          vm.tableIsLoading = false;
        });
    }

    function _getMetadataList() {
      var noGroupTag = $translationService.getTranslationController(
        "otros",
        "others",
        "otros"
      );

      $inputListsFactory
        .getInputListMetadata(listid)
        .then(function (res) {
          var mapData = res.columns.map(function (e) {
            var cleanColName = e.name.replace("#", "");

            var col = {
              field: e.name,
              title:
                vm.schema[cleanColName] && vm.schema[cleanColName].displayName
                  ? vm.schema[cleanColName].displayName
                  : e.name,
              type: e.type,
              show: true,
              group: vm.schema[cleanColName]
                ? angular.isUndefined(vm.schema[cleanColName].group)
                  ? noGroupTag
                  : vm.schema[cleanColName].group
                : noGroupTag,
              order: vm.schema[cleanColName]
                ? vm.schema[cleanColName].order
                : "1",
              sortable: e.name,
              filterable: { type: "text" },
              readonly: e.readonly,
              width: 30,
            };
            return col;
          });

          vm.columns = mapData.sort(function (a, b) {
            return a.order - b.order;
          });

          vm.groups = vm.columns.map(function (ele) {
            if (ele.show === false) return;

            var item = ele.group;
            if (
              typeof item === "string" &&
              item != undefined &&
              item != null &&
              item != "" &&
              item != "null"
            ) {
              return item;
            } else {
              return noGroupTag;
            }
          });

          vm.groups = vm.groups
            .filter(function (e) {
              return e;
            })
            .filter(function (value, index) {
              return vm.groups.indexOf(value) == index;
            });

          $rootScope.loading = false;
        })
        .catch(function (err) {
          console.error("Error@getInputListMetadata", err);
          vm.tableIsLoading = false;
        });
    }

    vm.validatePermission = function (permission) {
      return $permissionsFactory.hasPermission(permission);
    };

    vm.onClickListRow = function (item) {
      if (!vm.validatePermission("list#" + vm.list.listId + ":update")) return;

      var _item = {
        dataId: item.__dataId,
        body: item,
      };
      $mdDialog
        .show({
          controller: "clientCardController",
          controllerAs: "ctrl",
          templateUrl: "app/app-utils/components/client-card/client-card.html",
          clickOutsideToClose: false,
          locals: {
            title: $translationService.getTranslationController(
              "Editor de datos",
              "Data editor",
              "Editor de dados"
            ),
            listId: vm.list.listId,
            inputs: _item,
            inputsTypes: vm.columns,
            groups: vm.groups,
            listSchema: vm.schema,
          },
        })
        .then(function () {
          _init();
        });
    };

    vm.showIssueDialog = function (event, issueUuid) {
      if (!issueUuid || issueUuid === "") return;
      var uuid = issueUuid.split("&")[1] || issueUuid.split("&")[0];
      $rootScope.loading = true;
      var promises = [_getIssuesByUuid(uuid), _getIssuesTypes()];
      Promise.allSettled(promises)
        .then(function (res) {
          var issue = res[0].status == "fulfilled" ? res[0].value : false;
          var issueTypes = res[1].status == "fulfilled" ? res[1].value : [];
          if (issue) {
            issue.cat;
            $mdDialog.show({
              controller: "IssuesDetailDialogController",
              controllerAs: "ctrl",
              templateUrl:
                "app/dashboard/components/issues-detail-dialog/issues-detail-dialog.html",
              parent: angular.element(document.body),
              targetEvent: null,
              clickOutsideToClose: false,
              multiple: true,
              locals: {
                issueTypes: issueTypes,
                currentIssueType: issueTypes.find(function (e) {
                  return e.id == issue.issueType.id;
                }),
                issue: issue,
                issuesToLink: [],
                currentCategory: issue.category,
              },
            });
          } else {
            $toastr.warning(
              $translationService.getTranslationController(
                "No se pudo cargar el issue",
                "Can load issue",
                "Can load issue "
              )
            );
          }
        })
        .finally(function () {
          $rootScope.loading = false;
        });
    };

    vm.getBack = function () {
      if ($stateParams.backTo) $state.go("app." + $stateParams.backTo);
      else $state.go("app.schemasLists");
    };

    function _renderList() {
      var inputList = {
        cols: [],
        types: [],
      };

      angular.forEach(vm.schema, function (col, key) {
        inputList.types[(col.pk ? "#" : "") + key] = col.type;
        var referencedListId = col.metadata ? col.metadata.id : null;
        var colDefinition = _getInputType(
          col.type,
          referencedListId,
          col.autocomplete,
          col.inputFormat,
          col.outputFormat,
          col.readonly
        );
        colDefinition.data = (col.pk ? "#" : "") + key;
        colDefinition.title = key + (col.required || col.pk ? "*" : "");
        inputList.cols.push(colDefinition);
      });

      vm.inputList = inputList;
    }

    function _getInputType(
      input,
      list,
      autocomplete,
      inputFormat,
      outputFormat,
      readonly
    ) {
      var sequentialSourceFn = function (query, process) {
        $inputListsFactory
          .getInputListData(list, {}, false)
          .then(function (res) {
            var source = res.data.map(function (e) {
              var res = angular.fromJson(e.body);
              if (res.$visible) delete res.$visible;
              return Object.values(res)[0];
            });
            process(source);
          });
      };

      return $listService.getInputType(
        input,
        autocomplete,
        inputFormat,
        outputFormat,
        readonly,
        sequentialSourceFn
      );
    }

    vm.unFilterData = function () {
      vm.filters.predicates = [];
      vm.isFiltered = false;
      _getListData();
    };

    vm.removeFilter = function (index) {
      vm.filters.predicates.splice(index, 1);
      if (!vm.filters.predicates.length) {
        vm.isFiltered = false;
      }
      _getListData();
    };

    vm.addFilterTo = function (event, col) {
      col.name = col.displayName || col.key;
      var selectedColumnFilters = vm.columnfilters.find(function (e) {
        return e.field == col.key || e.label == col.displayName;
      });

      if (!selectedColumnFilters) {
        $toastr.warning(
          $translationService.getTranslationController(
            "No hay filtros disponibles para la columna ",
            "There is no filters available for column ",
            "Não há filtros disponíveis para coluna "
          ) + col.name
        );
        return;
      }

      $mdDialog
        .show({
          controller: "IssuesFiltersDialogController",
          controllerAs: "ctrl",
          templateUrl:
            "app/dashboard/components/issues-filters-dialog/issues-filters-dialog.html",

          parent: angular.element(document.body),
          targetEvent: event,
          clickOutsideToClose: false,
          locals: {
            column: col,
            columnFilters: selectedColumnFilters,
          },
        })
        .then(function (predicate) {
          // predicate.value = _formatPredicateValue(col, predicate.value);
          vm.filters.predicates.push(predicate);
          vm.isFiltered = true;

          _getListData();
        });
    };

    // function _formatPredicateValue(col, value) {
    //   console.log(col, value);
    //   if (["date", "time"].includes(col.type))
    //     return moment(value).format($formats.defaults[col.type]);

    //   if (col.type == "timestamp")
    //     return moment(value).format("YYYY-MM-DDTHH:mm:ss.000000000");

    //   return value;
    // }

    vm.showReplaceDialog = function (ev, col) {
      var colTypes = [];
      angular.forEach(vm.columns, function (e) {
        colTypes[e.field] = e.type;
      });

      $inputListsFactory.setSelectedCol((col.pk ? "#" : "") + col.key);

      $mdDialog.show({
        controller: "ListReplaceController",
        templateUrl: "app/input-list/components/list-replace/list-replace.html",
        locals: {
          listId: vm.list.listId,
          cellValue: "",
          colTypes: colTypes,
        },
        parent: angular.element(document.body),
        targetEvent: ev,
        hasBackdrop: false,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: true,
      });
    };

    vm.parsePredicateValue = function (predicate) {
      if (vm.schema[predicate.fieldName.replace("#", "")].type == "date") {
        return moment(predicate.value).format("DD-MM-YYYY");
      }

      return predicate.value;
    };

    $scope.$on("listFiltered", function (e, filter) {
      var predicate = {
        fieldName: filter.column,
        label: filter.column,
        operation: "EQUAL",
        value: filter.conditionValue,
        values: null,
        valuesLabels: null,
      };

      vm.filters.predicates.push(predicate);
      vm.isFiltered = true;

      _getListData();
    });

    function _getConfigFormatSchema() {
      return new Promise(function (resolve, reject) {
        $ConfigurationFactory
          .getSchemaFormat()
          .then(function (res) {
            if (res.data.length == 0) {
              resolve([]);
            }
            var schemaMap = res.data.map(function (schema) {
              schema.body = JSON.parse(schema.body);
              return schema;
            });
            resolve(schemaMap);
          })
          .catch(function (err) {
            console.error("Error@getSchemaFormat", err);
            reject(err);
          });
      });
    }

    vm.legacy_exportList = function (ext) {
      $rootScope.loading = true;
      var list = vm.list;

      $toastr.info(
        $translationService.getTranslationController(
          "Exportando lista: ",
          "Exporting list: ",
          "Exportando lista: "
        ) + vm.list.name
      );

      $listExporterService
        .execute(ext, false, list)
        .then(function () {
          $rootScope.loading = false;
          $toastr.success(
            $translationService.getTranslationController(
              "Lista descargadas",
              "List downloaded",
              "Lista baixadas"
            )
          );
        })
        .catch(function (error) {
          $rootScope.loading = false;
          console.error("Error@bulkExportLists", error);
          $toastr.error(
            $translationService.getTranslationController(
              "Se ha producido un error al exportar",
              "An error occurred while exporting",
              "Ocorreu um erro ao exportar"
            )
          );

          $rootScope.loading = false;
        });
    };

    function _getIssuesByUuid(issueUuid) {
      return new Promise(function (resolve, reject) {
        $issuesFactory
          .getIssueByUUID(issueUuid)
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            console.error("Error@_getIssuesByUuid", err);
            reject(err);
          });
      });
    }

    function _getIssuesTypes() {
      return new Promise(function (resolve, reject) {
        $issuesFactory
          .getIssuesTypes()
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            console.error("Error@_getIssuesTypes", err);
            reject(err);
          });
      });
    }

    vm.exportList = function (ext, templateOnly) {
      vm.cols = $listService.getColumns(vm.schema);
      vm.baseSchema = $listService.getBaseSchema(vm.schema);
      vm.types = $listService.getColumnsTypes(vm.schema);
      vm.headers = $listService.getHeaders(vm.schema);
      vm.colsToExport = $listService.getColumnsToExport(vm.schema);

      vm.selectedCol = vm.colsToExport[0];
      vm.baseSchema["$dataId"] = null;
      vm.baseSchema["$visible"] = true;

      var listToExport = {
        listId: vm.list.listId,
        name: vm.list.name,
        schema: vm.list.schema,
        headers: vm.headers,
        colsToExport: vm.colsToExport,
        data: [],
      };

      if (templateOnly) {
        $listExporterService.execute(ext, templateOnly, listToExport);
      } else {
        $mdDialog.show({
          controller: ["$mdDialog", exportSelectorController],
          controllerAs: "selCtrl",
          templateUrl: "app/input-list/templates/export-selector.html",
          scope: $scope,
          preserveScope: true,
          clickOutsideToClose: false,
        });

        function exportSelectorController($mdDialog) {
          this.selection = "this";
          this.selectSheet = function (selection) {
            // if (selection == 'all') {
            $rootScope.loading = true;
            var filters = angular.copy(vm.filters);

            filters.exportToCSV = ext == "xlsx" ? false : true;

            if (selection == "all") {
              filters.pagination.page = 1;
              filters.pagination.itemsPerPage = 9000000;
            }

            $listExporterService
              .execute(ext, false, vm.list, filters)
              .then(function () {
                $toastr.success(
                  $translationService.getTranslationController(
                    "Lista descargada",
                    "List downloaded",
                    "Lista baixada"
                  )
                );
              })
              .catch(function (error) {
                console.log("Error@listExporterService", error);
                $toastr.error(
                  $translationService.getTranslationController(
                    "Se ha producido un error al exportar",
                    "An error occurred while exporting",
                    "Ocorreu um erro ao exportar"
                  )
                );
              })
              .finally(function () {
                $rootScope.loading = false;
              });

            $mdDialog.hide();
          };
          this.abortSelection = function () {
            $mdDialog.cancel();
          };
        }
      }
    };


    $scope.cancel = function () {
        $mdDialog.cancel();
        }
  }
})();

'use strict';

var app = angular.module('dashboard');

app.component('vinculatedIssuesList', {
  templateUrl:
    'app/dashboard/components/vinculated-issues/components/vinculated-issues-list.html',
  controllerAs: 'ctrl',
  bindings: {
    issueUuid: '<',
    issuesToLink: '<',
    linksCount: '=',
    issueType: '<',
  },
  controller: vinculatedIssuesListController,
});

vinculatedIssuesListController.$inject = [
  '$scope',
  '$rootScope',
  '$mdDialog',
  'toastr',
  'translationService',
  'IssuesFactory',
];
function vinculatedIssuesListController(
  $scope,
  $rootScope,
  $mdDialog,
  $toastr,
  $translationService,
  $issuesFactory
) {
  var vm = this;

  vm.tabLabel = '';
  vm.linkedIssues = [];
  vm.selectedRows = [];
  vm.filters = {
    issueTypeId: vm.issueType.id,
    pagination: {
      sortBy: 'createdAtLocal',
      sort: 'desc',
    },
    predicates: [],
  };

  vm.gridOptions = {
    rowTemplate:
      '<div ng-dblclick="grid.appScope.ctrl.showDetail($event, row.entity)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell ng-class="{ \'cep-issue-unseen\' : !row.entity.viewed }"></div>',
    gridMenuShowHideColumns: false,
    showColumnFooter: true,
    enableGridMenu: true,
    // Grid sorting options
    useExternalSorting: true,
    // Grid pagination options
    useExternalPagination: true,
    paginationPageSizes: [15, 20, 25],
    paginationPageSize: 15,
    totalItems: 0,
    // Grid api Options
    onRegisterApi: function (gridApi) {
      gridApi.selection.on.rowSelectionChanged($scope, function (row, evt) {
        vm.selectedRows = gridApi.selection.getSelectedRows();
      });

      gridApi.selection.on.rowSelectionChangedBatch($scope, function (rows) {
        vm.selectedRows = gridApi.selection.getSelectedRows();
      });

      gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        if (sortColumns[0]) {
          vm.filters.pagination.sortBy = sortColumns[0].field.split('.')[0];
          vm.filters.pagination.sort = sortColumns[0].sort.direction;
        } else {
          vm.filters.pagination.sortBy = null;
        }

        $rootScope.loading = true;
        _getLinkedIssues(vm.issueUuid, vm.filters).finally(function () {
          $rootScope.loading = false;
        });
      });

      gridApi.pagination.on.paginationChanged(
        $scope,
        function (newPage, pageSize) {
          vm.filters.pagination.page = newPage;
          vm.filters.pagination.itemsPerPage = pageSize;

          $rootScope.loading = true;
          _getLinkedIssues(vm.issueUuid, vm.filters).finally(function () {
            $rootScope.loading = false;
          });
        }
      );

      gridApi.colMovable.on.columnPositionChanged($scope, function () {
        var gridState = gridApi.saveState.save();
        var gridColumnsState = gridState.columns.map(function (e) {
          return e.name;
        });

        $issuesFactory
          .setLinkedIssuesColumnsOrder(vm.issueUuid, gridColumnsState)
          .catch(function (error) {
            console.log('Error@setLinkedIssuesColumnsOrder', error);
          });
      });
    },
  };

  vm.$onInit = function () {
    if (vm.issueUuid) {
      _getIssueTypeFilters().then(function () {
        _getLinkedIssues(vm.issueUuid, vm.filters);
      });
    } else {
      _renderTable();
    }
  };

  function _getIssueTypeFilters() {
    return new Promise(function (resolve, reject) {
      $issuesFactory
        .getIssueTypeFilters(vm.issueType.id)
        .then(function (res) {
          vm.columnfilters = res;
          resolve();
        })
        .catch(function (err) {
          console.log('Error@getIssueTypeFilters', err);
          reject();
        });
    });
  }

  $scope.$watchCollection(
    'ctrl.issuesToLink',
    function () {
      vm.issuesToLink = vm.issuesToLink
        .filter(function (e) {
          return e.issueType.id == vm.issueType.id;
        })
        .filter(function (e) {
          // Remove duplicates
          return !vm.linkedIssues
            .map(function (e) {
              return e.uuid;
            })
            .includes(e.uuid);
        });

      vm.gridOptions.data = vm.issuesToLink.concat(vm.linkedIssues);
    },
    true
  );

  vm.manageColumns = function (event) {
    $rootScope.loading = true;
    // $issuesFactory
    //   .getLinkedIssuesAvailableColumns(vm.issueUuid)
    var promises = [
      $issuesFactory.getAvailableGroups(),
      $issuesFactory.getLinkedIssuesAvailableColumns(
        vm.issueType.id,
        vm.issueType.category.id
      ),
    ];
    Promise.all(promises)
      .then(function (res) {
        var groups = res[0].data
        var issueColumns = res[1].data
        _openColumnsManageDialog(event, vm.issueType.id, issueColumns, groups);
      })
      .catch(function (err) {
        console.log('Error@getLinkedIssuesAvailableColumns', err);
      })
      .finally(function () {
        $rootScope.loading = false;
      });
  };
  // console.log("vm.issueType", vm.issueType);  
  function _openColumnsManageDialog(event, issueTypeId, issueColumns, groups) {
    $mdDialog
      .show({
        controller: 'IssueColumnsDialogController',
        controllerAs: 'ctrl',
        templateUrl:
          'app/dashboard/components/issue-columns-dialog/issue-columns-dialog.html',
        parent: angular.element(document.body),
        targetEvent: event,
        multiple: true,
        clickOutsideToClose: false,
        locals: {
          issueTypeId: issueTypeId,
          issueColumns: issueColumns,
          groupId: vm.currentIssue.id,
          categoryId: vm.currentIssue.category.id,
          groups: groups,
        },
      })
      .then(function (data) {
        if (data.action == 'saveColumns') {
          _saveIssueColumns(data.issueTypeId, data.issueColumns, data.toGroup);
        }
        if (data.action == 'setDefaultColumns') {
          _setDefaultIssueColumns(data.issueTypeId);
        }
      });
  }

  function _saveIssueColumns(issueTypeId, issueColumns, toGroup) {
    $rootScope.loading = true;

    $issuesFactory
      .assignLinkedIssuesCustomColumns(vm.issueUuid, issueColumns)
      .then(function () {
        _getLinkedIssues(vm.issueUuid, vm.filters).finally(function () {
          $rootScope.loading = false;
        });

        var msg = $translationService.getTranslationController(
          'Configuración de columnas guardada',
          'Column settings saved',
          'Configurações de coluna salvas'
        );
        $toastr.success(msg);
      })
      .catch(function (err) {
        $toastr.error(
          $translationService.getTranslationController(
            'Se ha producido un error, intente de nuevo',
            'An error has occurred, please try again',
            'Ocorreu um erro, por favor, tente novamente'
          )
        );

        console.error('Error@assignCustomColumns', err);
      });
  }

  function _setDefaultIssueColumns() {
    $rootScope.loading = true;
    $issuesFactory
      .setLinkedIssuesDefaultIssueColumns(vm.issueUuid)
      .then(function () {
        _getLinkedIssues(vm.issueUuid, vm.filters).finally(function () {
          $rootScope.loading = false;
        });

        var msg = $translationService.getTranslationController(
          'Columnas por defecto establecidas',
          'Default columns set',
          'Configurações de coluna padrão'
        );
        $toastr.success(msg);
      })
      .catch(function (err) {
        $toastr.error(
          $translationService.getTranslationController(
            'Se ha producido un error, intente de nuevo',
            'An error has occurred, please try again',
            'Ocorreu um erro, por favor, tente novamente'
          )
        );

        console.error('Error@assignCustomColumns', err);
      });
  }

  vm.unlinkIssues = function () {
    if (vm.selectedRows.length) {
      var confirm = $mdDialog
        .confirm()
        .multiple(true)
        .title(
          $translationService.getTranslationController(
            'Desvincular issues',
            'Unlink Issues',
            'Desvincular issues'
          )
        )
        .textContent(
          $translationService.getTranslationController(
            '¿Estás seguro?',
            'Are you sure?',
            'Tem certeza?'
          )
        )
        .ok($translationService.getTranslationController('Si', 'Yes', 'Sim'))
        .cancel(
          $translationService.getTranslationController('No', 'No', 'Não')
        );

      $mdDialog.show(confirm).then(function () {
        $rootScope.loading = true;

        var promises = [];
        vm.selectedRows.forEach(function (issueToUnlink) {
          promises.push(_performIssueUnlink(vm.issueUuid, issueToUnlink.uuid));
        });

        Promise.all(promises)
          .then(function () {
            _getLinkedIssues(vm.issueUuid, vm.filters).finally(function () {
              $rootScope.loading = false;
            });

            $toastr.success(
              $translationService.getTranslationController(
                'Issues desvinculados',
                'Issues unlinked',
                'Issues desvinculados'
              )
            );
          })
          .catch(function (err) {
            $toastr.error(
              $translationService.getTranslationController(
                'Se ha producido un error, intente de nuevo',
                'An error has occurred, please try again',
                'Ocorreu um erro, por favor, tente novamente'
              )
            );

            $rootScope.loading = false;
          });
      });
    } else {
      $toastr.warning(
        $translationService.getTranslationController(
          'No se han seleccionado issues',
          'There is no issues selected',
          'Não há issues selecionados'
        )
      );
    }
  };

  function _performIssueUnlink(parentIssueUuid, linkedIssueUuid) {
    return new Promise(function (resolve, reject) {
      $issuesFactory
        .unlinkIssue(parentIssueUuid, linkedIssueUuid)
        .then(function () {
          resolve();
        })
        .catch(function (err) {
          console.log(
            'Error@unlinkIssue',
            {
              parentIssueUuid: parentIssueUuid,
              linkedIssueUuid: linkedIssueUuid,
            },
            err
          );
          reject();
        });
    });
  }

  function _getLinkedIssues(issueUuid, filters) {
    return new Promise(function (resolve, reject) {
      $issuesFactory
        .getLinkedIssues(issueUuid, filters)
        .then(function (res) {
          vm.linkedIssues = res.data.data;
          vm.gridOptions.footerData = res.data.footer || {};
          vm.filters.pagination = res.data.pagination;
          vm.gridOptions.totalItems = res.data.pagination.totalRecords;

          _renderTable(res.data.columns);
          resolve();
        })
        .catch(function (err) {
          console.log('Error@getLinkedIssues', err);
          reject();
        });
    });
  }

  function _renderTable(customColumns) {
    var tableColumns = [];
    var tableDefaultColumns = [
      {
        key: 'description',
        name: 'Description',
        displayName: $translationService.getTranslationController(
          'Descripción',
          'Description',
          'Descrição'
        ),
        field: 'description',
        width: '15%',
      },
      {
        key: 'classification',
        name: 'Classification',
        displayName: $translationService.getTranslationController(
          'Clasificación',
          'Classification',
          'Classificação'
        ),
        field: 'classification.name',
      },
      {
        key: 'createdAt',
        name: 'CreatedAt',
        displayName: $translationService.getTranslationController(
          'Creado el (UTC)',
          'Created at (UTC)',
          'Criado em (UTC)'
        ),
        field: 'createdAt',
        width: '140',
        dataType: 'date: "dd/MM/yy HH:mm"',
      },
      {
        key: 'createdAtLocal',
        name: 'CreatedAtLocal',
        displayName: $translationService.getTranslationController(
          'Creado el',
          'Created at',
          'Criado em'
        ),
        field: 'createdAtLocal',
        width: '140',
        dataType: 'date: "dd/MM/yy HH:mm"',
      },
      {
        key: 'createdBy',
        name: 'CreatedBy',
        displayName: $translationService.getTranslationController(
          'Creado por',
          'Created by',
          'Criado por'
        ),
        field: 'createdBy.name',
      },
      {
        key: 'source',
        name: 'Source',
        displayName: $translationService.getTranslationController(
          'Origen',
          'Source',
          'Origemr'
        ),
        field: 'source',
        width: '75',
      },
      {
        key: 'assigned',
        name: 'Assigned',
        displayName: $translationService.getTranslationController(
          'Asignado',
          'Assigned',
          'Atribuído'
        ),
        field: 'assigned.name',
      },
      { key: 'supervisor', name: 'Supervisor', field: 'supervisor.name' },
      {
        key: 'category',
        name: 'Category',
        displayName: $translationService.getTranslationController(
          'Categoría',
          'Category',
          'Categoria'
        ),
        field: 'category.name',
        width: '100',
      },
      {
        key: 'criticality',
        name: 'Criticality',
        displayName: $translationService.getTranslationController(
          'Criticidad',
          'Criticality',
          'Criticidade'
        ),
        field: 'criticality.name',
        width: '100',
      },
      {
        key: 'status',
        name: 'Status',
        displayName: $translationService.getTranslationController(
          'Estado',
          'Status',
          'Status'
        ),
        field: 'status.name',
      },
      {
        key: 'evidence_total',
        name: 'Evidences',
        displayName: $translationService.getTranslationController(
          'Evidencias',
          'Evidences',
          'Evidências'
        ),
        field: 'evidence_total',
      },
    ];

    // Determine table columns
    if (customColumns && customColumns.length) {
      angular.forEach(customColumns, function (col) {
        var defaultField = tableDefaultColumns.find(function (e) {
          return e.key == col.key;
        });

        if (defaultField) {
          defaultField.sortable = col.sortable;
          tableColumns.push(defaultField);
        } else {
          tableColumns.push({
            key: col.key,
            name: col.key,
            displayName: col.label,
            field: col.key,
            sortable: col.sortable,
          });
        }
      });
    } else {
      tableColumns = tableDefaultColumns;
    }

    vm.gridOptions.columnDefs = [];
    tableColumns
      .filter(function (col) {
        return col.key != 'footer';
      })
      .forEach(function (col) {
        var currentColumnDefinition = {
          name: col.key,
          field:
            col.name == 'Criticality' ? col.field.split('.')[0] : col.field,
          width: col.width || 100,
          visible: col.visible || true,
          cellFilter: col.dataType || null,
          headerTooltip: col.name,
          footerCellTemplate:
            '<div class="ui-grid-cell-contents">{{ grid.appScope.ctrl.gridOptions.footerData["' +
            col.field +
            '"] }}</div>',
          // General col properties
          enableColumnMenu: true,
          enableSorting: col.sortable,
          enableHiding: false,
          // Menu
          menuItems: [
            {
              title: $translationService.getTranslationController(
                'Filtrar',
                'Filter',
                'Filtro'
              ),
              icon: 'ui-grid-icon-filter',
              shown: function () {
                var hasFilters = vm.columnfilters.find(function (e) {
                  return e.field == col.key || e.label == col.name;
                });
                return hasFilters ? true : false;
              },
              action: function ($event) {
                this.context.addFilterTo($event, col);
              },
              context: vm,
            },
          ],
        };

        if (col.name == 'Criticality') {
          currentColumnDefinition.cellTemplate =
            '<span> <cep-icon icon="{{COL_FIELD.icon}}" color="{{COL_FIELD.color}}"></cep-icon>  {{COL_FIELD.name}}</span>';
        }

        if (col.displayName) {
          currentColumnDefinition.displayName = col.displayName;
        }
        vm.gridOptions.columnDefs.push(currentColumnDefinition);
      });

    if (!vm.issuesToLink) vm.issuesToLink = [];
    if (!vm.linkedIssues) vm.linkedIssues = [];

    vm.gridOptions.data = vm.issuesToLink.concat(vm.linkedIssues);
    vm.linksCount = vm.gridOptions.data.length;

    if (vm.gridOptions.data.length) {
      vm.tabLabel = vm.gridOptions.data[0].issueType.name;
    }
  }

  vm.addFilterTo = function (event, col) {
    var selectedColumnFilters = vm.columnfilters.find(function (e) {
      return e.field == col.key || e.label == col.name;
    });

    if (!selectedColumnFilters) {
      $toastr.warning(
        $translationService.getTranslationController(
          'No hay filtros disponibles para la columna ',
          'There is no filters available for column ',
          'Não há filtros disponíveis para coluna '
        ) + col.name
      );
      return;
    }

    $mdDialog
      .show({
        controller: 'IssuesFiltersDialogController',
        controllerAs: 'ctrl',
        templateUrl:
          'app/dashboard/components/issues-filters-dialog/issues-filters-dialog.html',
        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: false,
        multiple: true,
        locals: {
          column: col,
          columnFilters: selectedColumnFilters,
        },
      })
      .then(function (predicate) {
        vm.filters.predicates.push(predicate);

        $rootScope.loading = true;
        _getLinkedIssues(vm.issueUuid, vm.filters).finally(function () {
          $rootScope.loading = false;
        });
      });
  };

  vm.removeFilter = function (index) {
    if (index == 'ALL') {
      vm.filters.predicates = [];
    } else {
      vm.filters.predicates.splice(index, 1);
    }

    $rootScope.loading = true;
    _getLinkedIssues(vm.issueUuid, vm.filters).finally(function () {
      $rootScope.loading = false;
    });
  };

  vm.showDetail = function (event, item) {
    $rootScope.loading = true;
    var promises = [];
    promises.push(_getIssuesByUuid(item.uuid));
    promises.push(_getIssuesTypes(item.category.id));
    Promise.all(promises).then(function () {
      $rootScope.loading = false;
      $mdDialog.show({
        controller: 'IssuesDetailDialogController',
        controllerAs: 'ctrl',
        templateUrl:
          'app/dashboard/components/issues-detail-dialog/issues-detail-dialog.html',
        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: false,
        multiple: true,
        locals: {
          issueTypes: vm.issueTypes,
          currentIssueType: vm.issueTypes.find(function (e) {
            return e.id == vm.selectedIssue.issueType.id;
          }),
          issue: vm.selectedIssue,
          issuesToLink: [],
          currentCategory: vm.selectedIssue.category,
        },
      });
    });
  };

  function _getIssuesTypes(categoryId) {
    return new Promise(function (resolve, reject) {
      var req = {
        categoryId: categoryId,
      };
      $issuesFactory
        .getIssuesTypes(req)
        .then(function (res) {
          vm.issueTypes = res;
          resolve();
        })
        .catch(function (err) {
          console.log('Error@getIssuesTypes', err);
          reject();
        });
    });
  }

  function _getIssuesByUuid(issueUuid) {
    return new Promise(function (resolve, reject) {
      $issuesFactory
        .getIssueByUUID(issueUuid)
        .then(function (response) {
          vm.selectedIssue = response;
          vm.selectedIssue.issueType.category = vm.selectedIssue.category;
          resolve();
        })
        .catch(function (e) {
          console.log('Error@getIssuesByUUID', err);
          reject();
        });
    });
  }
}

'use strict';

var app = angular.module('dashboard');

app.component('itemFolder', {
  templateUrl:
    'app/dashboard/components/issue-columns-dialog/components/item-folder.html',
  controllerAs: 'ctrl',
  bindings: {
    item: '=',
  },
  controller: itemFolderController,
});

itemFolderController.$inject = ['$scope'];
function itemFolderController($scope) {
  var vm = this;
}

'use strict';

var app = angular.module('dashboard');

app.component('columnFolder', {
  templateUrl:
    'app/dashboard/components/issue-columns-dialog/components/column-folder.html',
  controllerAs: 'ctrl',
  bindings: {
    folder: '=',
  },
  controller: columnFolderController,
});

columnFolderController.$inject = ['$scope'];
function columnFolderController($scope) {
  var vm = this;
  vm.displayItems = true;
}

"use strict";

var app = angular.module("dashboard");

app.component("wizardStepYaxis", {
  templateUrl: "app/charts/components/wizard-dialog/y-axis/y-axis.html",
  controllerAs: "ctrl",
  bindings: {
    config: "<",
    assets: "<",
    translation: "<",
  },
  controller: wizardYaxisController,
});

wizardYaxisController.$inject = [
  "$scope",
  "chartService",
  "ConfigurationFactory",
];
function wizardYaxisController($scope, $chartService, ConfigurationFactory) {
  var vm = this;

  vm.stepIsDone = false;

  vm.yAxis = vm.config.yAxis;

  vm.selectedChart = null;
  vm.chartTypes = ["bar", "line", "pie", "boxplot"];

  vm.agregationFunctions = ["avg", "sum", "count"];

  var DEFAULT_METADATA = {
    boxplot: {
      max: null,
      Q3: null,
      mid: null,
      Q1: null,
      min: null,
    },
    treemap: {
      visibleMin: 1,
      leafDepth: 1,
    },
  };

  vm.marklinesOptions = [
    {
      name: "average line",
      value: [{ type: "average" }],
    },
    {
      name: "min line",
      value: [{ type: "min" }],
    },
    {
      name: "max line",
      value: [{ type: "max" }],
    },
  ];

  vm.$onInit = function () {
    console.log("wizardStepYaxis", vm.config, vm.assets);
    if (vm.assets.chartType == "treemap" && vm.config.series.length == 0) {
      vm.addTreemap();
    }

    if (
      vm.assets.event === "update" &&
      vm.assets.chartType == "treemap" &&
      vm.config.series.length == 1
    ) {
      vm.config.series = vm.config.series.map(function (serie) {
        if (angular.isUndefined(serie.metadata)) {
          serie.metadata = DEFAULT_METADATA["treemap"];
        }
        return serie;
      });
    }
  };

  vm.addSerie = function () {
    if (!vm.selectedChart) return;

    if (
      vm.config.series.some(function (e) {
        return e.type == "boxplot";
      }) &&
      vm.selectedChart == "boxplot"
    ) {
      alert("Ya se ha seleccionado un boxplot");
      return;
    }

    var DEFAULT_DATA = [];

    vm.config.series.push({
      source: vm.assets.source.listId,
      source2: vm.assets.source2.map(function (e) {
        return e.listId;
      }),
      groupBy: [],
      agregation: "avg",
      label: vm.selectedChart,
      type: vm.selectedChart,
      color: $chartService.randColor(0),
      markline: [
        {
          data: [],
        },
      ],
      data: DEFAULT_DATA,
      metadata: DEFAULT_METADATA[vm.selectedChart] || {},
    });

    vm.selectedChart = null;
  };

  vm.addTreemap = function () {
    vm.config.series.push({
      source: vm.assets.source.listId,
      source2: vm.assets.source2.map(function (e) {
        return e.listId;
      }),
      groupBy: [],
      agregation: "avg",
      label: "treemap",
      type: "treemap",
      color: $chartService.randColor(0),
      markline: [
        {
          data: [],
        },
      ],
      data: [],
      metadata: DEFAULT_METADATA["treemap"],
    });
  };

  vm.removeSerie = function (index) {
    vm.config.series.splice(index, 1);
  };

  vm.toggleMarkline = function (serie, opt) {
    if (vm.isSelectMarkline(serie, opt)) {
      serie.markline[0].data.splice(findIndexMarkline(serie, opt[0].type), 1);
    } else {
      serie.markline[0].data.push(opt);
    }
  };

  function findIndexMarkline(serie, type) {
    serie.markline[0].data
      .flat()
      .map(function (e, i) {
        return e.type;
      })
      .findIndex(function (e) {
        return e == type;
      });
  }

  vm.isSelectMarkline = function (serie, opt) {
    return serie.markline[0].data.flat().some(function (e) {
      return e.type == opt[0].type;
    });
  };

  vm.sourceSchema = function () {
    return vm.assets.sourceSchema.filter(function (e) {
      return ["double", "integer", "long"].includes(e.type);
    });
  };

  $scope.$on("submit-wizard-step-yaxis", function () {
    var res = $scope.isComplete();
    $scope.$emit("stepResponse", res);
  });

  $scope.isComplete = function () {
    if (vm.config.series.length === 0) return false;

    if (
      vm.config.series.some(function (e) {
        return (
          e.type == "boxplot" &&
          Object.values(e.metadata).some(function (e) {
            return e === null;
          })
        );
      })
    )
      return false;

    if (
      vm.config.series.some(function (e) {
        return e.type != "boxplot" && e.label == null;
      })
    )
      return false;

    vm.config.yAxis = vm.config.series
      .map(function (e) {
        return e.type == "boxplot" ? Object.values(e.metadata) : e.label;
      })
      .flat();

    return true;
  };
}

"use strict";

var app = angular.module("dashboard");

app.component("wizardStepXaxis", {
  templateUrl: "app/charts/components/wizard-dialog/x-axis/x-axis.html",
  controllerAs: "ctrl",
  bindings: {
    config: "<",
    assets: "<",
    translation: "<",
  },
  controller: wizardXaxisController,
});

wizardXaxisController.$inject = ["$scope"];
function wizardXaxisController($scope) {
  var vm = this;
  vm.selectedItem = null;
  vm.searchText = "";
  vm.stepIsDone = false;
  vm.input_displayError = false;
  vm.xAxis = vm.config.xAxis[0];
  // default type
  vm.serietype = "alfanumerica";
  vm.serietypeDisabled = false;
  vm.types = ["alfanumerica", "timeStamp"];

  vm.$onInit = function () {
    if (vm.config.xAxis.length > 0) {
      vm.selectedItem = { name: vm.config.xAxis[0] };
    }
  };

  $scope.onlyValidTypes = function (item) {
    var validType = ["string", "sequential"];
    if (validType.includes(item.type)) {
      return item;
    }
  };

  $scope.isComplete = function () {
    if (vm.selectedItem != null) {
      var opt = [];
      opt.push(vm.selectedItem.name);
      vm.config.xAxis = null;
      vm.config.xAxis = opt;

      vm.stepIsDone = true;
      vm.input_displayError = false;
    } else {
      vm.stepIsDone = false;
      vm.input_displayError = true;
    }
    return vm.stepIsDone;
  };

  $scope.$on("submit-wizard-step-xaxis", function () {
    var res = $scope.isComplete();
    $scope.$emit("stepResponse", res);
  });

  vm.querySearch = _querySearch;
  function _querySearch(query) {
    var results = query
      ? vm.assets.sourceSchema.filter(function (schema) {
          var schemaName = schema.name.toLowerCase();
          if (schemaName.includes(query.toLowerCase())) {
            return schema;
          }
        })
      : vm.assets.sourceSchema;
    return results;
  }


  $scope.$watch("ctrl.assets.sourceSchema", function (newValue) {
    vm.boxplotSelect = [];
    vm.boxplotSelect = newValue.filter(function (item) {
      return ["number", "interger", "double"].includes(item.type);
    });
  });
}

"use strict";

var app = angular.module("dashboard");

app
  .component("wizardStepTreemap", {
    templateUrl: "app/charts/components/wizard-dialog/treemap/treemap.html",
    controllerAs: "ctrl",
    bindings: {
      config: "<",
      assets: "<",
      translation: "<",
    },
    controller: wizardTreemapController,
  })
  .directive("draggable", function () {
    return {
      restrict: "A",
      link: function (scope, element, attrs) {
        element.draggable({
          helper: "clone",
          drag: function (event, ui) {
            event.data = { schema: attrs.schema };
          },
          zIndex: 999999,
          stack: ".custom-drag",
          revert: false,
          cursor: "move",
        });
      },
    };
  })
  .directive("droppable", function () {
    return {
      restrict: "A",
      link: function (scope, element, attrs) {
        element.droppable({
          accept: ".item-drag",
          drop: function (event, ui) {
            var schema = ui.draggable[0].attributes.schema.value;
            scope.newLevel(schema);
          },
        });
      },
    };
  });

wizardTreemapController.$inject = [
  "$scope",
  "listsToGroups",
  "ChartsFactory",
  "$mdDialog",
];
function wizardTreemapController(
  $scope,
  $listsToGroups,
  ChartsFactory,
  $mdDialog
) {
  var vm = this;
  vm.stepIsDone = true;
  vm.input_displayError = false;

  $scope.sortableOptionsList = {
    placeholder: "app",
    connectWith: ".level-container",
    cursor: "move",
    update: function (e, ui) {
      console.log(e);
      console.log(ui);
      var order = [];
      e.target.children.forEach(function (child) {
        order.push(child.attributes.schema.value);
        // vm.updateLevel(child.attributes.schema.value);
      });
      vm.updateLevel(order);
    },
  };

  vm.levels = vm.assets.levels || [];

  $scope.newLevel = function (data) {
    var schema = vm.assets.sourceSchema.find(function (schema) {
      return schema.name === data;
    });
    vm.levels.push(schema.name);
  };

  vm.updateLevel = function (levelsSorted) {
    vm.levels = levelsSorted;
  };

  vm.isSchemaInUse = function (schemaName) {
    return vm.levels.some(function (level) {
      return level === schemaName;
    });
  };

  vm.isSerie = function (name) {
    return vm.config.yAxis.includes(name);
  };

  vm.removeLevel = function (schemaName) {
    vm.levels = vm.levels.filter(function (level) {
      return level !== schemaName;
    });
  };

  $scope.isComplete = function () {
    vm.stepIsDone = false;

    if (vm.levels.length === 0) {
      vm.stepIsDone = false;
      return vm.stepIsDone;
    }

    vm.stepIsDone = true;
    vm.config.levels = vm.levels;
    return vm.stepIsDone;
  };

  $scope.$on("submit-wizard-step-treemap", function () {
    var res = $scope.isComplete();
    $scope.$emit("stepResponse", res);
  });
}

'use strict';

var app = angular.module('dashboard');

app.component('wizardStepGroupFilter', {
  templateUrl:
    'app/charts/components/wizard-dialog/group-filter/group-filter.html',
  controllerAs: 'ctrl',
  bindings: {
    config: '<',
    assets: '<',
    translation: '<',
  },
  controller: wizardGroupFilterController,
});

wizardGroupFilterController.$inject = ['$scope'];
function wizardGroupFilterController($scope) {
  var vm = this;
  vm.searchText = '';
  vm.stepIsDone = true;
  vm.FiltersOptions = ['Simple', 'Multiple'];
  vm.optionsForGoupByAndFilter = [];
  vm.viewAs = 'Simple';
  vm.disabled = false;

  $scope.toggleOption = function (property) {
    var copy = angular.copy(vm.optionsForGoupByAndFilter);
    if (property == 'groupBy') {
      var res = copy.filter(function (e) {
        return e.group == true;
      });
      //// @lert - ajustar si se activa el multiserie Yaxis step
      vm.config.series[0].groupBy = res.map(function (e) {
        return e.label;
      });
    }
    if (property == 'filter') {
      var res = copy.filter(function (e) {
        return e.filter == true;
      });
      vm.config.filters = res.map(function (e) {
        return { field: e.label, viewAs: e.viewAs };
      });
    }
  };

  vm.querySearch = _querySearch;

  function _setValue() {
    vm.config.series.forEach(function (element) {
      element.groupBy = vm.grouplist;
    });
    vm.config.filters = vm.filterlist || [];
    console.log('set');
  }

  function _querySearch(query) {
    var results = query
      ? vm.assets.sourceSchema.filter(function (schema) {
          var schemaName = schema.name.toLowerCase();
          if (schemaName.includes(query.toLowerCase())) {
            return schema;
          }
        })
      : vm.assets.sourceSchema;
    return results;
  }

  function tableForGoupByAndFilter() {
    var optionsForGoupByAndFilter = vm.assets.sourceSchema.map(function (e) {
      var model = {
        label: e.name,
        type: e.type,
        group: isGroupAlreadyDefined(e.name),
        filter: isFilterAlreadyDefined(e.name),
        viewAs: vm.FiltersOptions[0],
      };
      return model;
    });
    vm.optionsForGoupByAndFilter = optionsForGoupByAndFilter;
  }

  function isFilterAlreadyDefined(item) {
    var res = false;
    var exist = vm.config.filters && vm.config.filters.find(function (e) {
      return e.field == item;
    });
    if (exist != undefined) res = true;
    return res;
  }

  function isGroupAlreadyDefined(item) {
    var res = false;
    if (vm.config.series && vm.config.series.length > 0) {
      var exist = vm.config.series[0].groupBy.find(function (e) {
        return e == item;
      });
      if (exist != undefined) res = true;
    }
    return res;
  }

  vm.grouplist = vm.config.series && vm.config.series.length > 0 ? vm.config.series[0].groupBy : [];
  vm.filterlist = vm.config.filters && vm.config.filters.length > 0 ? vm.config.filters : [];

  vm.addToGrouplist = function () {
    if (vm.selectedItem != null) {
      var exist = vm.grouplist.find(function (e) {
        return e == vm.selectedItem.name;
      });
      if (exist == undefined) {
        vm.grouplist.push(vm.selectedItem.name);
      }
      setTimeout(function () {
        _setValue();
      }, 500);
    } else {
      console.warn('select a value');
    }
  };

  vm.addToFilterlist = function () {
    if (vm.selectedItem != null) {
      var exist = vm.filterlist.find(function (e) {
        return e.field == vm.selectedItem.name;
      });
      if (exist == undefined) {
        vm.filterlist.push({ field: vm.selectedItem.name, viewAs: vm.viewAs });
      }
      setTimeout(function () {
        _setValue();
      }, 500);
    } else {
      console.warn('select a value');
    }
  };
  vm.deleteFromGroup = function (value) {
    vm.grouplist = vm.grouplist.filter(function (e) {
      return e != value;
    });
    setTimeout(function () {
      _setValue();
    }, 500);
  };
  vm.deleteFromList = function (value) {
    vm.filterlist = vm.filterlist.filter(function (e) {
      return e.field != value;
    });
    setTimeout(function () {
      _setValue();
    }, 500);
  };

  $scope.isBoxplotChart = false;

  $scope.$watch('ctrl.assets.sourceSchema', function (newValue) {
    tableForGoupByAndFilter();
  });

  function _validBtnGroupBy() {
    if ($scope.isBoxplotChart == false && vm.config.yAxis.length > 1) {
      return true;
    } else {
      return false;
    }
  }

  $scope.$watch('ctrl.assets.chartType', function (newValue) {
    if (newValue == 'pie' || newValue == 'boxplot') {
      vm.disabled = true;
      vm.grouplist = [];
      $scope.isBoxplotChart = true;
    } else {
      vm.disabled = _validBtnGroupBy();
      $scope.isBoxplotChart = false;
    }
  });

  $scope.$watch('ctrl.config.yAxis', function (newValue) {
    vm.disabled = _validBtnGroupBy();
  });

  $scope.isComplete = function () {
    _setValue();
    return vm.stepIsDone;
  };

  $scope.$on('submit-wizard-step-group-filter', function () {
    var res = $scope.isComplete();
    $scope.$emit('stepResponse', res);
  });
}

"use strict";

var app = angular.module("dashboard");

app.component("wizardStepGeneral", {
  templateUrl: "app/charts/components/wizard-dialog/general/general.html",
  controllerAs: "ctrl",
  bindings: {
    config: "<",
    assets: "<",
    translation: "<",
    event: "@", 
  },
  controller: wizardGeneralController,
});

wizardGeneralController.$inject = [
  "$scope",
  "listsToGroups",
  "ChartsFactory",
  "$mdDialog",
];
function wizardGeneralController(
  $scope,
  $listsToGroups,
  ChartsFactory,
  $mdDialog
) {
  var vm = this;
  console.log("wizardGeneralController", vm);
  vm.chartTypes = ["multigrafico", "treemap"];
  vm.input_displayError = false;

  $scope.isComplete = function () {
    if (vm.config.name != "") {
      vm.stepIsDone = true;
      vm.input_displayError = false;
    } else {
      vm.stepIsDone = false;
      vm.input_displayError = true;
    }
    return vm.stepIsDone;
  };

  $scope.onChangeChart_type = function () {
    if (vm.config.hasOwnProperty("series") && vm.config.series.length > 0) {
      vm.config.series = vm.config.series.map(function (e) {
        e.type = vm.assets.chartType;
        return e;
      });
    }

    $scope.$emit("chartType", vm.assets.chartType);
  };

  $scope.$on("submit-wizard-step-general", function () {
    var res = $scope.isComplete();
    $scope.$emit("stepResponse", res);
  });

  ///-- group selector
  $scope.loadingDialog = false;

  $scope.moveItemGroup = function () {
    $scope.list = [];
    $scope.loadingDialog = true;
    ChartsFactory.getChartsbyDomain()
      .then(function (res) {
        $scope.list = $listsToGroups.createGroups(res.data, "group");
      })
      .then(function () {
        $scope.loadingDialog = false;
        $mdDialog
          .show({
            controller: "folderSelectorController",
            controllerAs: "ctrl",
            templateUrl:
              "app/app-utils/components/folder-selector/folder-selector.html",
            locals: {
              list: angular.copy($scope.list),
              item: vm.config,
            },
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            multiple: true,
          })
          .then(function (groups) {
            vm.config.group = groups;
          });
      });
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('wizardStepDataSource', {
  templateUrl:
    'app/charts/components/wizard-dialog/data-source/data-source.html',
  controllerAs: 'ctrl',
  bindings: {
    config: '<',
    assets: '<',
    translation: '<',
  },
  controller: wizardDataSoureceController,
});

wizardDataSoureceController.$inject = [
  '$scope',
  '$rootScope',
  'InputListsFactory',
];
function wizardDataSoureceController($scope, $rootScope, InputListsFactory) {
  var vm = this;
  vm.stepIsDone = false;
  vm.InputLists = [];
  vm.source_searchText = '';
  vm.relatedSchemas = [];
  vm.relatedSchemasSelected = [];
  vm.input_source_displayError = false;

  $scope.isComplete = function () {
    if (vm.assets.source != null && vm.assets.source.hasOwnProperty('listId')) {
      if (vm.config) {
        if (vm.config.series[0]) {
          vm.config.series[0].source2 = vm.assets.source2.map(function (e) {
            return e.listId;
          });
        }
      }
      vm.stepIsDone = true;
      vm.input_source_displayError = false;
    } else {
      vm.stepIsDone = false;
      vm.input_source_displayError = true;
    }
    return vm.stepIsDone;
  };

  $scope.$on('submit-wizard-step-data-source', function () {
    var res = $scope.isComplete();
    $scope.$emit('stepResponse', res);
  });

  vm.source_querySearch = source_querySearch;
  function source_querySearch(query) {
    var results = query
      ? vm.InputLists.filter(function (list) {
          var listName = list.name.toLowerCase();
          if (listName.includes(query.toLowerCase())) {
            return list;
          }
        })
      : vm.InputLists;
    return results;
  }
  function findRelatedSchemas(schemaID, listId) {
    var res = vm.InputLists.filter(function (e) {
      return e.schema.id == schemaID && e.listId != listId;
    });
    return res;
  }

  $scope.toggle = function (item) {
    var idx = vm.assets.source2.indexOf(item);
    if (idx > -1) {
      vm.assets.source2.splice(idx, 1);
    } else {
      vm.assets.source2.push(item);
    }
  };

  $scope.exists = function (item) {
    return vm.assets.source2.indexOf(item) > -1;
  };

  $scope.isIndeterminate = function () {
    return (
      vm.assets.source2.length !== 0 &&
      vm.assets.source2.length !== vm.relatedSchemas.length
    );
  };

  $scope.isChecked = function () {
    return vm.assets.source2.length === vm.relatedSchemas.length;
  };

  $scope.toggleAll = function () {
    if (vm.assets.source2.length === vm.relatedSchemas.length) {
      vm.assets.source2 = [];
    } else if (vm.assets.source2.length === 0 || vm.assets.source2.length > 0) {
      vm.assets.source2 = vm.relatedSchemas.slice(0);
    }
  };

  $scope.sourceChange = function (item) {
    if (item != undefined && item.listId) {
      vm.assets.source = item;
      vm.relatedSchemas = findRelatedSchemas(item.schema.id, item.listId);
      vm.relatedSchemasSelected = [];
      var data = [];
      var schemaDefinitions = angular.copy(JSON.parse(item.schema.schema));
      var required = schemaDefinitions.definitions[item.schema.name].required;
      var properties =
        schemaDefinitions.definitions[item.schema.name].properties;
      angular.forEach(properties, function (col, index) {
        var isPK = required.includes('#' + index);
        var item = {
          name: isPK ? '#' + index : index,
          type: col.type,
          group: col.group,
          description: col.description,
        };
        data.push(item);
      });

      vm.assets.sourceSchema = data.sort(function (x, y) {
        var a = x.name.toUpperCase();
        var b = y.name.toUpperCase();
        return a == b ? 0 : a > b ? 1 : -1;
      });
    } else {
      console.warn('opps', item);
    }
  };

  $scope.getLists = function () {
    $scope.isLoading = true;
    $rootScope.loading = true;
    InputListsFactory.getLists()
      .then(function (res) {
        vm.InputLists = res.lists.sort(function (a, b) {
          a.name > b.name ? 1 : -1;
        });
        if (vm.config.series.length > 0) {
          if (vm.config.series[0].source) {
            var loadItem = vm.InputLists.find(function (e) {
              return e.listId == vm.config.series[0].source;
            });
            vm.assets.source2 = vm.InputLists.filter(function (e) {
              return vm.config.series[0].source2.includes(e.listId);
            });
            $scope.sourceChange(loadItem);
          }
        }
        $rootScope.loading = false;
        $scope.isLoading = false;
      })
      .catch(function (err) {
        console.error('Error@getLists', err);
      });
  };
  $scope.getLists();
}

'use strict';

var app = angular.module('dashboard');

app.component('urlLink', {
  templateUrl:
    'app/charts/components/chart-list-dialog/components/url-link.html',
  controllerAs: 'ctrl',
  bindings: {
    links: '=',
  },
  controller: urlLinkController,
});

urlLinkController.$inject = ['$scope'];
function urlLinkController($scope) {
  var vm = this;
  vm.isLoading = false;
  vm.chartList = [];
  vm.chartListSelected = [];
  vm.currentlinks_ids = [];
  vm.name = '';
  vm.url = '';

  vm.removeLink = function (url) {
    vm.chartListSelected = vm.chartListSelected.filter(function (link) {
      if (link.url != url) return link;
    });
  };

  vm.addUrl = function () {
    if (vm.name != '' && vm.url != '') {
      var found = vm.chartListSelected.find(function (e) {
        return e.url == item.url;
      });
      if (found == undefined) {
        var item = {
          id: null,
          name: vm.name,
          type: 'url',
          url: vm.url,
        };
        vm.chartListSelected.push(item);
        vm.selectedItem = null;
        vm.links = vm.chartListSelected;
        vm.name = '';
        vm.url = '';
      }
    }
  };

  vm.$onInit = function () {
    if (vm.links.length > 0) {
      vm.currentlinks_ids = vm.links.map(function (link) {
        return link.url;
      });
    } else {
      vm.chartListSelected = [];
    }
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('chartSelector', {
  templateUrl:
    'app/charts/components/chart-list-dialog/components/chart-selector.html',
  controllerAs: 'ctrl',
  bindings: {
    links: '=',
  },
  controller: chartSelectorController,
});

chartSelectorController.$inject = ['$scope', 'ChartsFactory'];
function chartSelectorController($scope, ChartsFactory) {
  var vm = this;
  vm.isLoading = false;
  vm.chartList = [];
  vm.chartListSelected = [];
  $scope.searchTerm = '';
  vm.currentlinks_ids = [];
  vm.selectedItem = null;
  vm.querySearch = _querySearch;
  vm.selectedItemChange = _selectedItemChange;
  $scope.searchTerm = '';

  function _querySearch(query) {
    var results = query
      ? vm.chartList.filter(function (chart) {
          var chartName = chart.name.toLowerCase();
          if (chartName.includes(query.toLowerCase())) {
            return chart;
          }
        })
      : vm.chartList;
    return results;
  }

  function _selectedItemChange(item) {
    if (item != undefined && item.hasOwnProperty('id')) {
      var found = vm.chartListSelected.find(function (e) {
        return e.id == item.id;
      });
      if (found == undefined) {
        vm.chartListSelected.push(item);
        vm.selectedItem = null;
        vm.links = vm.chartListSelected;
      }
    }
  }

  vm.getChartsbyDomain = function () {
    vm.isLoading = true;
    ChartsFactory.getChartsbyDomain()
      .then(function (res) {
        vm.chartList = res.data.map(function (e) {
          return {
            id: e.id,
            name: e.name,
            type: 'chart',
            url: '',
          };
        });
        if (vm.currentlinks_ids != undefined) {
          if (vm.currentlinks_ids.length > 0) {
            vm.chartListSelected = res.data
              .filter(function (e) {
                if (vm.currentlinks_ids.includes(e.id)) return e;
              })
              .map(function (e) {
                return {
                  id: e.id,
                  name: e.name,
                  type: 'chart',
                  url: '',
                };
              });
          }
        }
        vm.isLoading = false;
      })
      .catch(function (err) {
        console.error('Error@getChartsbyDomain', err);
        vm.isLoading = false;
      });
  };

  vm.removeLink = function (id) {
    vm.chartListSelected = vm.chartListSelected.filter(function (link) {
      if (link.id != id) return link;
    });
    vm.links = vm.chartListSelected;
  };

  vm.$onInit = function () {
    if (vm.links.length > 0) {
      vm.currentlinks_ids = vm.links.map(function (link) {
        return link.id;
      });
    } else {
      vm.chartListSelected = [];
    }
    vm.getChartsbyDomain();
  };
}

/* Handsontable configuration service */

(function (Handsontable) {
  "use strict";

  angular.module("dashboard").service("dataTableService", dataTableService);

  dataTableService.$inject = [
    "DataTableFactory",
    "handsontableService",
    "FileSaver",
    "toastr",
  ];
  function dataTableService(
    $dataTableFactory,
    $handsontableService,
    $fileSaver,
    $toastr
  ) {
    var vm = this;

    vm.registerCustomEditors = function (scope) {
      var inputTimeStampEditor =
        $handsontableService.inputTimeStampEditor(scope);
      var inputTimeEditor = $handsontableService.inputTimeEditor(scope);
      var inputDateEditor = $handsontableService.inputDateEditor(scope);
      var inputJsonEditor = $handsontableService.inputJsonEditor(scope);

      

      Handsontable.editors.inputTimeStampEditor = inputTimeStampEditor;
      Handsontable.editors.inputTimeEditor = inputTimeEditor;
      Handsontable.editors.inputDateEditor = inputDateEditor;
      Handsontable.editors.inputJsonEditor = inputJsonEditor;

      Handsontable.editors.registerEditor(
        "inputTimeStampEditor",
        inputTimeStampEditor
      );
      Handsontable.editors.registerEditor("inputTimeEditor", inputTimeEditor);
      Handsontable.editors.registerEditor("inputDateEditor", inputDateEditor);
      Handsontable.editors.registerEditor("inputJsonEditor", inputJsonEditor);
    };
    vm.getTable = function (tableName, schemaName) {
      return new Promise(function (resolve, reject) {
        $dataTableFactory
          .getTable(tableName, schemaName)
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            console.error("Error@getTable", err);
            $toastr.error(err.error);
            reject();
          });
      });
    };
    vm.getDataTable = function (
      tableName,
      schemaName,
      pagination,
      predicates,
      exportToCSV
    ) {
      return new Promise(function (resolve, reject) {
        $dataTableFactory
          .getDataTable(
            tableName,
            schemaName,
            pagination,
            predicates,
            exportToCSV
          )
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            console.error("Error@getDataTable", err);
            $toastr.error(err.error);
            reject();
          });
      });
    };
    vm.getTableFilters = function (tableName, schemaName) {
      return new Promise(function (resolve, reject) {
        $dataTableFactory
          .getTableFilters(tableName, schemaName)
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            console.error("Error@_getTableFilters", err);
            reject();
          });
      });
    };
    vm.updateTableData = function (tableName, schemaName, rows) {
      return new Promise(function (resolve, reject) {
        $dataTableFactory
          .updateTableData(tableName, schemaName, rows)
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            console.error("Error@updateTableData", err);
            reject(err);
          });
      });
    };
    vm.insertTableData = function (tableName, schemaName, insertRows) {
      return new Promise(function (resolve, reject) {
        $dataTableFactory
          .insertTableData(tableName, schemaName, insertRows)
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            console.error("Error@insertTableData", err);
            reject(err);
          });
      });
    };
    vm.deleteTableData = function (tableName, schemaName, deleteRows) {
      return new Promise(function (resolve, reject) {
        $dataTableFactory
          .deleteTableData(tableName, schemaName, deleteRows)
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            console.error("Error@deleteTableData", err);
            reject();
          });
      });
    };
    vm.replaceWith = function (tableName, schemaName, data) {
      return new Promise(function (resolve, reject) {
        $dataTableFactory
          .replaceWith(tableName, schemaName, data)
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            console.error("Error@replaceWith", err);
            reject();
          });
      });
    };
    vm.truncateTable = function (tableName, schemaName) {
      return new Promise(function (resolve, reject) {
        $dataTableFactory
          .truncateTable(tableName, schemaName)
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            console.error("Error@truncateTable", err);
            reject();
          });
      });
    };
    vm.normalizeData = function (data, cols) {
      data = data.map(function (item) {
        angular.forEach(item, function (value, key) {
          if (key == "_ROW_STATUS_") return;

          var colDef =
            cols.find(function (col) {
              return col.data === key;
            }) || null;

          if (colDef && colDef.colType == "json") {
            item[key] = value ? JSON.stringify(value) : "";
          }
          
          if (
            (colDef && colDef.colType == "long") ||
            (colDef && colDef.colType == "integer") ||
            (colDef && colDef.colType == "numeric")
          ) {
            item[key] = value != null && !isNaN(value) ? Number(value) : null;
          }
          if (colDef && colDef.colType == "double") {
            item[key] = value != null && !isNaN(value) ? parseFloat(value) : null;
          }
          if (colDef && colDef.colType == "timestamp") {
            item[key] =
              value && moment(value).isValid()
                ? moment(value).format("YYYY-MM-DD HH:mm:ss")
                : null;
          }
          if (colDef && colDef.colType == "date") {
            item[key] =
              value && moment(value).isValid()
                ? new Date(value).toISOString().split("T")[0]
                : null;
          }
          if (colDef && colDef.colType == "timestamp") {
            item[key] =
              value && moment(value).isValid()
                ? moment(value).format("YYYY-MM-DD HH:mm:ss")
                : null;
          }
        });
        return item;
      });

      return data;
    };
    vm.createColumns = function (columns, filters) {
      var cols = [];
      var colType = {
        long: "numeric",
        integer: "numeric",
        numeric: "numeric",
        double: "numeric",
        string: "text",
        boolean: "checkbox",
        date: "date",
        timestamp: "date",
        time: "time",
        json: "text",
      };
      angular.forEach(columns, function (col) {
        var colFilter = filters.find(function (e) {
          return e.field == col.colName;
        });
        var pk = col.isPrimaryKey ? "*" : "";
        var placeholder = col.isNotNull ? "required" : "";
        var ncol = {
          order: col.order,
          title: col.colName + pk,
          data: col.colName,
          isPrimaryKey: col.isPrimaryKey,
          isNotNull: !col.isNotNull,
          operations: colFilter.operations,
          type: colType[col.colType],
          colType: col.colType,
          allowEmpty: !col.isNotNull,
          placeholder: placeholder,
          className: "htCenter ",
        };

        if (ncol.colName == "id_row") {
          ncol.readOnly = true;
        }
        if (ncol.colType == "string") {
        }

        if (ncol.colType == "json") {
          ncol.editor = Handsontable.editors.inputJsonEditor;
          ncol.renderer =  function(instance, td, row, col, prop, value, cellProperties) {

            // td.style.whiteSpace = 'pre-wrap';
            // td.style.maxHeight = '300px';
            // td.style.overflow = 'auto';
            td.className = 'font-monospace';
            td.innerHTML = value ? value.substring(0, 10)+"..." : '';
          }
          ncol.validator = function (value, callback) {
            try {
              JSON.parse(value);
              callback(true);
            } catch (e) {
              callback(false);
            }
          };
        }
        
        if (colFilter) {
          if (!colFilter.sortable) ncol.columnSorting = _disableSort();
          ncol.operations = colFilter.operations;
          ncol.component = colFilter.component;
        }

        if (["boolean", "checkbox"].includes(ncol.type)) {
          ncol.width = 120;
          ncol.allowEmpty = false;
          ncol.allowInvalid = false;
          ncol.validator = function (value, callback) {
            if (typeof value === "boolean") callback(value);
            if (value === "true") callback(true);
            if (value === "false") callback(false);
            else callback(false);
          };
        }

        if (["date"].includes(ncol.colType)) {
          ncol.dateFormat = "YYYY-MM-DD";
          ncol.editor = Handsontable.editors.inputDateEditor;
        }
        if (["timestamp"].includes(ncol.colType)) {
          ncol.dateFormat = "YYYY-MM-DD HH:mm:ss";
          ncol.editor = Handsontable.editors.inputTimeStampEditor;
        }

        if (["time"].includes(ncol.type)) {
          ncol.timeFormat = "HH:mm:ss";
          ncol.editor = Handsontable.editors.inputTimeEditor;
        }

        cols.push(ncol);
      });

      return cols;
    };
    vm.createDataSchema = function (columns) {
      var schema = {};
      angular.forEach(columns, function (col) {
        schema[col.colType] = null;
        if (["boolean", "checkbox"].includes(col.colType)) {
          schema[col.colType] = false;
        }
        if (["json"].includes(col.colType)) {
          schema[col.colType] = "{}"
        }
      });
      return schema;
    };
    vm.validObject = function (obj) {
      for (var key in obj) {
        if (obj[key] === "") obj[key] = null;
      }
      return obj;
    };

    vm.exportCSV = function (extention, data) {
      var prefixFileName = "table";
      var fileName = prefixFileName;
      var excel = { fileName: fileName, data: "sep=, \n" + data };

      $fileSaver.saveAs(
        new Blob([excel.data], { type: "application/octet-stream" }),
        excel.fileName + "." + extention
      );
    };

    function _disableSort() {
      return {
        indicator: false,
        headerAction: false,
      };
    }

    vm.export = function (ext, table) {
      return new Promise(function (resolve, reject) {
        var fileName = table.name;

        if (fileName.length > 31) {
          fileName = fileName.substring(-1, 31);
        }

        var mapHeaders = table.headers.map(function (e) {
          return e.title.replace("*", "");
        });

        var mapdata = table.data.map(function (e) {
          var row = [];
          table.headers.forEach(function (h) {
            if (h.type == "timestamp") {
              e[h.data] = moment(e[h.data]).format("YYYY-MM-DD HH:mm:ss");
            }

            if (h.type == "date") {
              e[h.data] = moment(e[h.data]).format("YYYY-MM-DD");
            }

            row.push(e[h.data]);
          });
          return row;
        });

        var wb = XLSX.utils.book_new();

        var ws = XLSX.utils.aoa_to_sheet([mapHeaders].concat(mapdata));

        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        try {
          var wbout = XLSX.write(wb, {
            bookType: ext,
            bookSST: true,
            type: "binary",
          });

          $fileSaver.saveAs(
            new Blob([_stringToArrayBuffer(wbout)], {
              type: "application/octet-stream",
            }),
            table.name + "." + ext
          );

          resolve();
        } catch (error) {
          reject(error);
        } finally {
          wbout = null;
        }
      });
    };
  }

  function _stringToArrayBuffer(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  }
})(Handsontable);

(function () {
  "use strict";

  angular.module("dashboard").directive("importTableJs", TableImportDirective);

  TableImportDirective.$inject = [
    "$rootScope",
    "$mdDialog",
    "toastr",
    "translationService",
    "dateService",
    "listService",
    "importSheetsService",
  ];

  function TableImportDirective(
    $rootScope,
    $mdDialog,
    $toastr,
    $translationService,
    $dateService,
    $listService,
    $importSheetsService
  ) {
    return {
      scope: {
        sheetData: "=",
        columns: "=",
        rowsRemove: "=",
        isImporting: "=",
        shouldReplaceData: "=",
      },
      link: function ($scope, $elm) {
        $translationService.getTranslation($scope, "input-list");
        $scope.selectedSheet = 0;
        $scope.separator = ",";

        $elm.on("change", function (changeEvent) {
          var reader = new FileReader();

          function converToArray(string) {
            return string
              .replace("sep=,", "")
              .trim()
              .split("\n")
              .map(function (e) {
                return e
                  .replace(/\r/g, "")
                  .split(",")
                  .map(function (z) {
                    return z.trim();
                  });
              });
          }

          function readData(datastrem) {
            return new Promise(function (resolve) {
              var bstr = datastrem;

              var values = converToArray(bstr);

              var data = [];
              // var hasIdRow = values[0].includes('id_row');
              var header = values.slice(0, 1).flat();
              var rows = values.slice(1, 99999);

              for (var i = 0; i < rows.length; i++) {
                var obj = {};
                var values = rows[i];

                for (var j = 0; j < values.length; j++) {
                  var val = values[j].replace(/"/g, "");

                  var h = header[j].replace(/"/g, "");

                  obj[h] = val;
                }
                obj._ROW_STATUS_ = "imported";
                delete obj["id_row"];
                data.push(obj);
              }
              resolve(data);
            });
          }

          reader.onloadstart = function () {
            // console.log('onloadstart');
            $scope.workbook = false;
            $rootScope.loading = true;
            $scope.sheetData = null;
          };

          reader.onloadend = function () {
            // console.log('onloadend');
            $rootScope.loading = false;
          };

          $scope.loadData = function (selSheet) {
            /* read workbook */
          };

          function isValidSchema(fileData) {
            var importedDataArray = converToArray(fileData);
            var importedHeader = importedDataArray[0].map(function (e) {
              return e.replace(/"/g, "");
            });

            var schemaColumns = $scope.columns.map(function (c) {
              return c.data;
            });

            var hascols = schemaColumns.filter(function (e) {
              return !importedHeader.includes(e);
            });

            if (hascols.length === 0) {
              var hasCorrentOrder =
                schemaColumns.join(",") === importedHeader.join(",");

              if (hasCorrentOrder) {
                return {
                  schemaColumns: schemaColumns,
                  importedHeader: importedHeader,
                  error: false,
                  text: "all ok",
                };
              } else {
                return {
                  schemaColumns: schemaColumns,
                  importedHeader: importedHeader,
                  error: true,
                  html:
                    "<h5> The columns are not in the correct order </h5>" +
                    "<table class='table'><thead><tr><th>Schema</th>" +
                    schemaColumns
                      .map(function (e, i) {
                        var clasName =
                          importedHeader[i] === e
                            ? ""
                            : "class='text-danger bold-text'";
                        return "<td " + clasName + "> " + e + " </td>";
                      })
                      .join(" ") +
                    "</tr><thead><tbody><tr><th>Imported</th>" +
                    importedHeader
                      .map(function (e, i) {
                        var clasName =
                          schemaColumns[i] === e
                            ? ""
                            : "class='text-danger bold-text'";
                        return "<td " + clasName + "> " + e + " </td>";
                      })
                      .join(" ") +
                    "</tr></tbody></table>",
                };
              }
            } else {
              return {
                schemaColumns: schemaColumns,
                importedHeader: importedHeader,
                error: true,
                html:
                  "<h5> The following columns are missing: </h5>" +
                  "<table class='table'><thead><tr colspan=" +
                  hascols.length +
                  "<th>Missing</th></tr></thead>" +
                  "<tbody><tr>" +
                  hascols
                    .map(function (e) {
                      return "<td> " + e + " </td>";
                    })
                    .join(" ") +
                  "</tr></tbody></table>",
              };
            }
          }

          reader.onload = function (e) {
            // console.log('onload');
            var fileData = e.target.result;
            var valid = isValidSchema(fileData);
            if (valid.error === false) {
              $mdDialog
                .show({
                  controller: ["$mdDialog", importTableSelectorController],
                  controllerAs: "ctrl",
                  templateUrl:
                    "app/app-utils/components/table-data/dialogs/import-table/import-table.html",
                  scope: $scope,
                  preserveScope: true,
                  clickOutsideToClose: false,
                })
                .then(
                  function (addToCurrentData) {
                    readData(fileData).then(function (data) {
                      $scope.sheetData = {
                        data: data,
                        addTocurrentData: addToCurrentData,
                      };
                    });
                  },
                  function () {
                    // console.log('cancel');
                  }
                );
            } else {
              console.log(valid);

              $mdDialog.show(
                $mdDialog
                  .alert()
                  .clickOutsideToClose(true)
                  .title("The data schema is invalid")
                  .htmlContent(valid.html)
                  .ariaLabel("invalid schema")
                  .ok("Cancel")
              );
            }
            $elm[0].value = null;
          };

          function importTableSelectorController($mdDialog) {
            var vm = this;

            vm.replaceCurrentData = function () {
              $mdDialog.hide(false);
            };

            vm.addToCurrentData = function () {
              $mdDialog.hide(true);
            };

            vm.cancel = function () {
              $mdDialog.cancel();
            };
          }

          reader.readAsBinaryString(changeEvent.target.files[0]);
        });
      },
    };
  }
})();

"use strict";

var app = angular.module("dashboard");

app.component("tableTextSearch", {
  templateUrl:
    "app/app-utils/components/table-data/components/text-search.html",
  controllerAs: "ctrl",
  bindings: {
    tableName: "@",
    schemaName: "@",
  },
  controller: tableTextSearchController,
});

tableTextSearchController.$inject = [
  "$scope",
  "$state",
  "$mdDialog",
  "toastr",
  "$rootScope",
  "translationService",
  "PermissionsFactory",
  "DataTableFactory",
];

function tableTextSearchController(
  $scope,
  $state,
  $mdDialog,
  $toastr,
  $rootScope,
  $translationService,
  PermissionsFactory,
  $dataTableFactory
) {
  var vm = this;
  vm.searchText = "";
  vm.isLoading = false;
  vm.onSearch = function () {
    vm.isLoading = true;
    $rootScope.$broadcast("textSearchLoading");
    TableTextSearch(vm.searchText)
      .then(function (response) {
        vm.isLoading = false;
        if (response.data && response.data.length > 0) {
          $toastr.success("Success", "Search text success");
          $rootScope.$broadcast("textSearch", response.data);
        } else if (Array.isArray(response) && response.length > 0) {

          $toastr.success("Success", "Search text success");
          $rootScope.$broadcast("textSearch", response);
        } else {
          $toastr.warning("Warning", "No data found");
        }
      })
      .catch(function (error) {
        $toastr.error("Error", "Error in search text");
        vm.isLoading = false;
      });
  };

  function TableTextSearch(searchText) {
    return new Promise(function (resolve, reject) {
      var pagination = {
        page: 1,
        itemsPerPage: 15,
        orderBy: "id_row",
        sort: "asc",
      };

      $dataTableFactory
        .TableTextSearch(vm.tableName, vm.schemaName, searchText, pagination)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
}

"use strict";
var app = angular.module("dashboard");

app.component("userForm", {
  templateUrl: "app/usuarios/components/user-form/user-form.html",
  controllerAs: "ctrl",
  bindings: {
    user: "=",
  },
  controller: userFormController,
});

userFormController.$inject = [
  "$rootScope",
  "$scope",
  "UserFactory",
  "GroupFactory",
  "CompanyFactory",
  "IssueCategoryFactory",
  "LoginFactory",
  "AclFactory",
  "usersConstants",
  "translationService",
  "timezoneService",
  "$localStorageService",
  "toastr",
];
function userFormController(
  $rootScope,
  $scope,
  $userFactory,
  $groupFactory,
  $companyFactory,
  $issueCategoryFactory,
  $loginFactory,
  $aclFactory,
  $usersConstants,
  $translationService,
  $timezoneService,
  $localStorageService,
  $toastr
) {
  var vm = this;
  $translationService.getTranslation(vm, "users");
  vm.loggedUser = $localStorageService.getItem("currentUser");
  vm.userLangs = $usersConstants.userLangs;
  vm.userTypes = $usersConstants.userTypes;
  vm.userRegions = $usersConstants.regions;
  vm.passwordPolicy = $usersConstants.passwordPolicy;
  vm.timesZones = $timezoneService.getListTimeZone();
  vm.userPassword = "";
  vm.showPassword = false;
  vm.creation = true;
  vm.userPolicies = [];
  vm.companies = [];
  vm.userCategories = [];
  vm.passwordPolicy = [];
  vm.userGroups = [];
  vm.usersCopmany = [];
  vm.disable2faButton = false;
  vm.$onInit = function () {
    vm.userModel = {};
    if (vm.user && vm.user.userId) {
      vm.creation = false;
      vm.getUserByUsername(vm.user.username);

      vm.userModel = Object.assign(vm.userModel, angular.copy(vm.user));
      vm.userModel.userId = vm.user.userId;
      vm.userModel.profile.groups = vm.user.profile.groups.map(function (e) {
        return e.id;
      });
      vm.userModel.profile.categories = vm.user.profile.categories.map(
        function (e) {
          return e.id;
        }
      );
      vm.disable2faButton = vm.userModel.twoFactorAuthEnabled && vm.loggedUser.userType === "SA"
    } else {
      vm.userModel = angular.copy($usersConstants.userModel);
      vm.userModel.timeZone = $timezoneService.zoneTimeUser();
      vm.userModel.color = _getRandomColor();
      vm.disable2faButton = false;
    }

    var companyId = vm.loggedUser.company ? vm.loggedUser.company.companyId : null;
    var promises = [
      _getAllCompanies(),
      _getAllCategories(),
      _getPasswordPolicies(),
      _getAllGroupsByCompanyId(companyId),
      _getAllUsersByCompanyId(companyId),
    ];

    Promise.allSettled(promises)
      .then(function (res) {
        vm.companies = res[0].status === "fulfilled" ? res[0].value : [];
        vm.userCategories = res[1].status === "fulfilled" ? res[1].value : [];
        vm.passwordPolicy = res[2].status === "fulfilled" ? res[2].value : [];
        vm.userGroups = res[3].status === "fulfilled" ? res[3].value : [];
        vm.usersCopmany = res[4].status === "fulfilled" ? res[4].value : [];
      })
      .then(function () {
        _getAclPolicies().then(function (response) {
          vm.userPolicies = response;
        });
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  vm.generatePassword = function () {
    var chars =
      "0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()[]ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var passwordLength = vm.passwordPolicy.minimumPasswordLength || 8;
    var password = "";
    for (var i = 0; i <= passwordLength; i++) {
      var randomNumber = Math.floor(Math.random() * chars.length);
      password += chars.substring(randomNumber, randomNumber + 1);
    }
    vm.userPassword = password;
  };

  function _getAllUsersByCompanyId(id) {
    return new Promise(function (resolve, reject) {
      $userFactory
        .getAllUsersByCompanyId(id)
        .then(function (response) {
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  function _getAllGroupsByCompanyId(id) {
    return new Promise(function (resolve, reject) {
      $groupFactory
        .getAllByCompanyId(id)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  function _getAllCompanies() {
    return new Promise(function (resolve, reject) {
      $companyFactory
        .getAllCompanies()
        .then(function (response) {
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  function _getAllCategories() {
    return new Promise(function (resolve, reject) {
      $issueCategoryFactory
        .getAllCategory()
        .then(function (response) {
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  function _getAclPolicies() {
    return new Promise(function (resolve, reject) {
      if (vm.creation) {
        resolve([]);
      }
      var groups = vm.userModel.profile.groups.join(",") || "";

      $aclFactory
        .search([vm.userModel.userId], groups, undefined, undefined, undefined)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  function _getPasswordPolicies() {
    return new Promise(function (resolve, reject) {
      $loginFactory
        .getPasswordPolicy()
        .then(function (response) {
          resolve(response);
        })
        .catch(function (err) {
          console.error("getPasswordPolicy", err);
          reject($usersConstants.passwordPolicy);
        });
    });
  }

  vm.changeCompany = function () {
    vm.userModel.company.supervisor = {};
    var companyId = vm.userModel.company.companyId;
    Promise.all([
      _getAllUsersByCompanyId(companyId),
      _getAllGroupsByCompanyId(companyId),
    ])
      .then(function (res) {
        vm.usersCopmany = res[0];
        vm.userGroups = res[1];
      })
      .catch(function (error) {
        console.error("changeCompany", error);
      });
  };

  vm.getAction = function (_item) {
    var grant =
      _item.resource.granted == true || _item.resource.granted == "true"
        ? "add"
        : "remove";
    var str =
      '<span><i class="material-icons">' +
      grant +
      "</i> <strong>" +
      _item.resource.actions +
      "</strong></span>";
    return str;
  };

  vm.getResource = function (_item) {
    var rules = "";
    if (
      angular.isDefined(_item.resource.entityId) &&
      _item.resource.entityId > 0
    ) {
      rules = "#" + _item.resource.entityId;
    }
    var str = "<p><strong>" + _item.resource.name + rules + "</strong></p>";
    return str;
  };

  function _getRandomColor() {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  function formUserValidation(riskUser) {
    var msgs = [];
    if (!riskUser.username) {
      msgs.push(
        $translationService.getTranslationController(
          "Es requerido llenar el campo username",
          "It is required to fill in the username field",
          "É necessário preencher o campo de nome de usuário"
        )
      );
    }
    if (!riskUser.name) {
      msgs.push(
        $translationService.getTranslationController(
          "Es requerido llenar el campo Nombre",
          "It is required to fill in the Name field",
          "É necessário preencher o campo Nome"
        )
      );
    }
    if (!riskUser.lastName) {
      msgs.push(
        $translationService.getTranslationController(
          "Es requerido llenar el campo Apellido",
          "It is required to fill in the Lastname field",
          "É necessário preencher o campo Apelido"
        )
      );
    }
    if (!riskUser.email) {
      msgs.push(
        $translationService.getTranslationController(
          "Es requerido llenar el campo Email",
          "It is required to fill in the Email field",
          "É necessário preencher o campo Email"
        )
      );
    }
    if (!riskUser.profile.type) {
      msgs.push(
        $translationService.getTranslationController(
          "Debe seleccionar un tipo de usuario",
          "You must select a user type",
          "Você deve selecionar um tipo de usuário"
        )
      );
    }
    if (!riskUser.lang) {
      msgs.push(
        $translationService.getTranslationController(
          "Debe seleccionar un lenguaje",
          "You must select a language",
          "Você deve selecionar um idioma"
        )
      );
    }
    if (!riskUser.timeZone) {
      msgs.push(
        $translationService.getTranslationController(
          "Debe seleccionar una zona horaria",
          "You must select a timezone",
          "Você deve selecionar um fuso horário"
        )
      );
    }
    if (!riskUser.company.companyId) {
      msgs.push(
        $translationService.getTranslationController(
          "Debe selecionanaruna compañia",
          "You must select a company",
          "Você deve selecionar uma empresa"
        )
      );
    }
    if (msgs.length > 0) {
      $rootScope.loading = false;
    }

    return msgs;
  }

  vm.getUserByUsername = function (username) {
    $userFactory
      .getUser(username)
      .then(function (res) {
        vm.user = res.data;
      })
      .catch(function (error) {
        console.error("error@getUser", error);
      });
  };
  vm.createUser = function () {
    var errors = formUserValidation(vm.userModel);
    if (errors.length > 0) {
      for (var i = 0; i < errors.length; i++) {
        var msg = errors[i];
        $toastr.error(msg);
      }
      return;
    }
    vm.userModel.fullName = vm.userModel.name + " " + vm.userModel.lastName;
    $rootScope.loading = true;
    $userFactory
      .create(vm.userModel)
      .then(function () {
        $rootScope.loading = false;

        var emmailMsg = vm.userModel.sendPwsByMail
          ? [
              ". Se envió un correo con la contraseña al email: " +
                vm.userModel.email,
              ". An email was sent with the password to the email: " +
                vm.userModel.email,
              ". Um email foi enviado com a senha para o email: " +
                vm.userModel.email,
            ]
          : ["", "", ""];

        $toastr.success(
          $translationService.getTranslationController(
            "Usuario creado exitosamente" + emmailMsg[0],
            "User created successfully" + emmailMsg[1],
            "Usuário criado com sucesso" + emmailMsg[2]
          )
        );
        $scope.$emit("cancelEdition", true);
      })
      .catch(function (error) {
        console.error("error@createUser", error);
        $toastr.error(error.data);
      })
      .finally(function () {
        $rootScope.loading = false;
      });
  };

  vm.updateUser = function () {
    // vm.userModel.twoFactorAuthEnabled = false;
    var errors = formUserValidation(vm.userModel);
    if (errors.length > 0) {
      for (var i = 0; i < errors.length; i++) {
        var msg = errors[i];
        $toastr.error(msg);
      }
      return;
    }
    $rootScope.loading = true;
    $userFactory
      .edit(vm.userModel.userId, vm.userModel)
      .then(function () {
        $toastr.success(
          $translationService.getTranslationController(
            "Se actualizó el usuario exitosamente.",
            "The user was successfully updated.",
            "O usuário foi atualizada com sucesso."
          )
        );
        $scope.$emit("cancelEdition", true);
      })
      .catch(function (error) {
        console.error("error@updateUser", error);
        $toastr.error(error.data);
      })
      .finally(function () {
        $rootScope.loading = false;
      });
  };

  vm.cancelEdition = function () {
    $scope.$emit("cancelEdition", true);
  };

  $scope.$watch(
    "ctrl.userPassword",
    function (newValue, oldValue) {
      if (
        angular.isDefined(vm.passwordPolicy) &&
        angular.isDefined(vm.passwordPolicy.showPasswordPolicy) &&
        vm.passwordPolicy.showPasswordPolicy
      ) {
        vm.passwordPolicy.minimumPasswordLengthGreen = false;
        vm.passwordPolicy.withAtLeastOneUppercaseGreen = false;
        vm.passwordPolicy.withAtLeastOneLowercaseGreen = false;
        vm.passwordPolicy.withAtLeastOneDigitGreen = false;
        vm.passwordPolicy.withAtLeastOneSymbolGreen = false;
        if (
          vm.passwordPolicy.minimumPasswordLength > 0 &&
          newValue.length >= vm.passwordPolicy.minimumPasswordLength
        ) {
          vm.passwordPolicy.minimumPasswordLengthGreen = true;
        }
        var regUppercase = /[A-Z]/;
        if (
          vm.passwordPolicy.withAtLeastOneUppercase &&
          regUppercase.test(newValue)
        ) {
          vm.passwordPolicy.withAtLeastOneUppercaseGreen = true;
        }
        var regLowercase = /[a-z]/;
        if (
          vm.passwordPolicy.withAtLeastOneLowercase &&
          regLowercase.test(newValue)
        ) {
          vm.passwordPolicy.withAtLeastOneLowercaseGreen = true;
        }
        var regDigit = /[0-9]/;
        if (vm.passwordPolicy.withAtLeastOneDigit && regDigit.test(newValue)) {
          vm.passwordPolicy.withAtLeastOneDigitGreen = true;
        }
        var regSymbol = /[^a-zA-Z0-9]/;
        if (
          vm.passwordPolicy.withAtLeastOneSymbol &&
          regSymbol.test(newValue)
        ) {
          vm.passwordPolicy.withAtLeastOneSymbolGreen = true;
        }
      }
    },
    false
  );

  vm.changePasswordV2 = function () {
    if (vm.userPassword === "") return;
    $rootScope.loading = true;
    $userFactory
      .changePasswordV2(vm.userModel.userId, vm.userPassword)
      .then(function (res) {
        $rootScope.loading = false;
        $scope.userPassword = undefined;
        $toastr.success(
          $translationService.getTranslationController(
            "Se modifico el password exitosamente",
            "The password was modified successfully",
            "A senha foi modificada com sucesso"
          )
        );
      })
      .catch(function (error) {
        $rootScope.loading = false;
        if (error.status == 403 || error.status == 401) {
          $toastr.error(
            $translationService.getTranslationController(
              "Usuario no autorizado.",
              "Unauthorized User.",
              "Usuário não autorizado."
            )
          );
        } else if (error.status == 406) {
          $toastr.error(error.data);
        } else if (error.status == 409) {
          $toastr.error(
            $translationService.getTranslationController(
              "Clave actual incorrecta.",
              "Wrong Current Password.",
              "Senha atual incorreta."
            )
          );
        } else {
          $toastr.error(error.data);
        }
      });
  };

  vm.disable2fa = function () {
    vm.loadingdisable2fa = true;
    $userFactory
      .disable2fa(vm.user.username)
      .then(function (res) {
        // console.log('disable2fa res', res);
        $toastr.success(
          $translationService.getTranslationController(
            "autenticación de dos factores deshabilitada",
            "two factor authentication disabled",
            "autenticação de dois fatores desabilitada"
          )
        );
        vm.userModel.twoFactorAuthEnabled = false;
      })
      .catch(function (err) {
        console.log("error@disable2fa", err);
      })
      .finally(function () {
        vm.loadingdisable2fa = false;
      });
  };
}

"use strict";

var app = angular.module("dashboard");

app.component("rulePreview", {
  templateUrl: "app/rules/components/rule-preview/rule-preview.html",
  controllerAs: "ctrl",
  bindings: {
    rule: "=",
    translation: "<",
  },
  controller: rulePreviewController,
});

rulePreviewController.$inject = [
  "$rootScope",
  "$scope",
  "$mdDialog",
  "toastr",
  "translationService",
  "JsonExporterService",
  "FunctionFactory",
];
function rulePreviewController(
  $rootScope,
  $scope,
  $mdDialog,
  toastr,
  $translationService,
  $jsonExporterService,
  $functionFactory
) {
  var vm = this;
  // console.log(vm.rule);

  vm.getRuleEditorURL = function () {
    if (vm.rule.realtime) {
      return "rules/realtime/editor/" + vm.rule.id;
    }
    return "rules/editor/" + vm.rule.id;
  };
  vm.rule.editorUrl = vm.getRuleEditorURL();

  vm.onUpdate = function (rule) {
    // console.log('onUpdate', rule);
    vm.rule = readSchedule(rule);
    vm.rule.description = rule.description;
    vm.rule.name = rule.name;
    vm.rule.realtime = rule.realtime;
    vm.rule.attributes = rule.attributes;
    vm.rule.liveVersion = rule.liveVersion;
  };

  vm.editRule = function (rule) {
    $rootScope.loading = true;
    $functionFactory
      .saveFunction(rule)
      .then(function (res) {
        var rule = $translationService.getTranslationController(
          "Regla ",
          "Rule ",
          "Rule "
        );
        var ruleIsActive = $translationService.getTranslationController(
          "Activa",
          "Active",
          "Ativo"
        );
        var ruleIsDisabled = $translationService.getTranslationController(
          "Inactiva",
          "Inactive",
          "Inativo"
        );
        var statusRule = res.active ? ruleIsActive : ruleIsDisabled;
        toastr.success(rule + " " + res.name + ": " + statusRule);
      })
      .catch(function (err) {
        toastr.error(
          $translationService.getTranslationController(
            "No se ha podido guardar: ",
            "Could not save: ",
            "Não foi possível salvar: "
          ) + err
        );
        console.error("Error@saveFunction", err);
      })
      .finally(function () {
        $rootScope.loading = false;
      });
  };

  vm.deleteRule = function (rule) {
    var confirm = $mdDialog
      .confirm()
      .title(
        $translationService.getTranslationController(
          "¿Eliminar regla: ",
          "Delete rule ",
          "Excluir regra?"
        ) +
          rule.name +
          "?"
      )
      .textContent(
        $translationService.getTranslationController(
          "¡Cuidado!, Esta acción no puede revertirse.",
          "Atention!, This action can not be reversed.",
          "Atenção!, esta ação não pode ser revertida."
        )
      )
      .ariaLabel("Delete-Question")
      .ok(
        $translationService.getTranslationController(
          "Si, Elimínala",
          "Yes, Delete it",
          "Sim, exclua"
        )
      )
      .cancel(
        $translationService.getTranslationController(
          "Aún no",
          "Not yet",
          "Ainda não"
        )
      );

    $mdDialog.show(confirm).then(
      function () {
        $rootScope.loading = true;
        $functionFactory
          .deleteFunction(rule.id)
          .then(function (res) {
            if (res == true) {
              $rootScope.$broadcast("ruleDeleted", rule);
              toastr.info(
                $translationService.getTranslationController(
                  "Regla eliminada.",
                  "Rule deleted.",
                  "Regra excluída."
                )
              );
            } else {
              toastr.info(
                $translationService.getTranslationController(
                  "No se ha podido eliminar la regla.",
                  "The rule could not be deleted.",
                  "A regra não pôde ser excluída."
                )
              );
            }
          })
          .catch(function (err) {
            if (typeof err === "string") {
              toastr.warning(err);
            } else {
              toastr.warning(
                $translationService.getTranslationController(
                  "No se ha podido eliminar.",
                  "The rule could not be deleted.",
                  "A regra não pôde ser excluída."
                )
              );
            }
            console.error("Error@deleteFunction", err);
          })
          .finally(function () {
            $rootScope.loading = false;
          });
      },
      function () {}
    );
  };

  vm.execute = function (rule) {
    $mdDialog.show({
      controller: "ExecuteDialogController",
      controllerAs: "ctrl",
      templateUrl: "app/rules/partials/execute-dialog/execute-dialog.html",
      locals: {
        rule: rule,
        properties:[]
      },
      parent: angular.element(document.body),
      multiple: true,
    });
  };

  vm.stopExecution = function (rule) {
    var confirm = $mdDialog
      .confirm()
      .title("¿Detener ejecución?")
      .textContent("¡Cuidado!, Esta acción no puede revertirse.")
      .ariaLabel("Stop-Execution-Question")
      .ok("Si, Detenerla")
      .cancel("Aún no");

    $mdDialog.show(confirm).then(
      function () {
        // console.log("Detener ejecución", rule);
        $functionFactory
          .stopExecutionV2(rule.id)
          .then(function (res) {
            console.log("ejecución detenida", res);
            $rootScope.$broadcast('onUpdate');
          })
          .catch(function (err) {
            console.error("Error@stopExecution", err);
          });
      },
      function () {}
    );
  };

  /********************************************** Modal Share searcher*******************************************/
  vm.showShareEntityDialog = function (selectedItem) {
    $mdDialog.show({
      controller: "ShareEntityController",
      templateUrl: "app/acl/component/dialog-share-entity.html",
      parent: angular.element(document.body),
      clickOutsideToClose: false,
      locals: {
        selectedItem: {
          id: selectedItem.id,
          resource: "function",
          name: selectedItem.name,
        },
        actions: [
          "read",
          "update",
          "delete",
          "read-pipeline",
          "run",
          "read-runs",
        ],
      },
    });
  };

  $scope.setClass = function (sufix) {
    sufix = sufix || "";
    var classList = "";
    if (vm.rule.realtime && vm.rule.running) classList = "blue animated pulse infinite ";
    else {
      if (vm.rule.typeCheck) classList = "green"+sufix;
      else classList = "red"+sufix;

      if (!vm.rule.active) classList
    }
    return classList;
  };

  function _getFunction(id) {
    return $functionFactory
      .getFunctionByID(id)
      .then(function (res) {
        var functionData = res;

        functionData.structure = angular.fromJson(functionData.structure);
        functionData.context = angular.fromJson(functionData.context);

        $jsonExporterService.execute(functionData, functionData.name, "rule");
      })
      .catch(function (err) {
        console.error("Error@getFunctionByID", err);
      });
  }

  vm.export = function (rule) {
    vm.downloadingRuleAsJson = true;

    _getFunction(rule.id).finally(function () {
      vm.downloadingRuleAsJson = false;
    });
  };

  function readSchedule(rule) {
    rule.origintalAttr = JSON.parse(JSON.stringify(rule.attributes));
    rule.originalActive = rule.active;
    // rule.filters = rule.attributes.filter(function (e) {
    //   return e.name == 'exclude';
    // });
    // rule.attributes = rule.attributes.filter(function (e) {
    //   return e.name != 'exclude';
    // });
    rule.attributes.forEach(function (at) {
      if (at.type == "boolean") {
        at.value == "true" ? true : false;
      } else if (at.type == "time") {
        var now = new Date();
        var timez = $timezoneService.zoneTimeUser();
        at.tz = moment(
          String(now.getFullYear()) +
            "-" +
            String(("00" + (now.getMonth() + 1)).slice(-2)) +
            "-" +
            String(("00" + now.getDate()).slice(-2)) +
            "T" +
            at.value.split(":")[0] +
            ":" +
            at.value.split(":")[1] +
            "Z"
        )
          .tz(timez)
          .format("Z");
        at.localTime = moment(
          String(now.getFullYear()) +
            "-" +
            String(("00" + (now.getMonth() + 1)).slice(-2)) +
            "-" +
            String(("00" + now.getDate()).slice(-2)) +
            "T" +
            at.value.split(":")[0] +
            ":" +
            at.value.split(":")[1] +
            "Z"
        )
          .tz(timez)
          .format("HH:mm");
      }
    });
    // // To deprecate
    // rule.version = rule.attributes.find(function (e) {
    //   return e.name == 'LIVE_VERSION';
    // });
    // // To deprecate
    // rule.attrSchedule = rule.attributes.find(function (e) {
    //   return e.name == 'SCHEDULE';
    // });
    // // To deprecate
    // if (rule.attrSchedule) {
    //   rule.attrSchedule.nowStr = prettyCron.toString(rule.attrSchedule.value);
    //   rule.attrSchedule.nextStr = prettyCron.getNext(rule.attrSchedule.value);
    // }

    // if (rule.schedule) {
    //   var cronExpression =
    //     rule.schedule.minute +
    //     ' ' +
    //     rule.schedule.hour +
    //     ' ' +
    //     rule.schedule.dayOfMonth +
    //     ' ' +
    //     rule.schedule.month +
    //     ' ' +
    //     rule.schedule.dayOfWeek;
    //   rule.nowStr = prettyCron.toString(cronExpression);
    //   rule.nowStr =
    //     rule.schedule.year == '*'
    //       ? rule.nowStr
    //       : rule.nowStr + ' in ' + rule.schedule.year;

    // }

    rule.schedules = rule.schedules || [];

    return rule;
  }

  vm.onClicked = function () {
    $rootScope.$broadcast('rulePreview',vm.rule);
  }
}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller(
      'searcherFiltersDialogController',
      searcherFiltersDialogController
    );

  searcherFiltersDialogController.$inject = [
    '$mdDialog',
    'column',
    'columnFilters',
  ];
  function searcherFiltersDialogController($mdDialog, column, columnFilters) {
    var vm = this;
    vm.column = column;
    vm.columnFilters = columnFilters;
    vm.columnFilters.component = 'text';
    vm.columnFilters.operations = ['EQUAL'];

    vm.predicate = {
      label: vm.columnFilters.key,
      fieldName: vm.columnFilters.name,
      operation: 'EQUAL',
      values: null,
      value: vm.columnFilters.component == 'boolean' ? false : null,
      valuesLabels: null,
    };

    vm.onPredicateValuesChanges = function () {
      if (vm.predicate.values != null) {
        vm.predicate.valuesLabels = vm.predicate.values.map(function (e) {
          return vm.columnFilters.metadata.find(function (i) {
            return i.key == e;
          })['value'];
        });
      }
    };

    vm.applyFilters = function () {
      $mdDialog.hide(vm.predicate);
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

(function () {
  "use strict";

  angular.module("dashboard").controller("HotCreateSchemasController", HotCreateSchemasController);

  HotCreateSchemasController.$inject = [
    "$document",
    "$scope",
    "$rootScope",
    "$mdDialog",
    "toastr",
    "translationService",
    "SchemasFactory",
    "InputListsFactory",
    "SelectedSchema",
    "LabelFactory",
    "PermissionsFactory",
    "ConfigurationFactory",
    "IndicatorsFactory",
    "types",
    "complexSchemas",
    "groupPath",
    "listsToGroups",
  ];
  function HotCreateSchemasController(
    $document,
    $scope,
    $rootScope,
    $mdDialog,
    $toastr,
    $translationService,
    $schemasFactory,
    $inputListsFactory,
    $selectedSchema,
    $labelFactory,
    $permissionsFactory,
    $ConfigurationFactory,
    $IndicatorsFactory,
    $types,
    complexSchemas,
    groupPath,
    $listsToGroups
  ) {
    var vm = this;

    $translationService.getTranslation($scope, "schemas");

    $scope.groupPath = groupPath || null;

    $scope.schemaTypes = ["USER", "SYSTEM", "COMPLEX", "SEQUENTIAL"];

    $scope.schemaIsSequential = function () {
      return $scope.schemaType == "SEQUENTIAL";
    };

    $scope.selectedSchema = $selectedSchema.getSchema();
    $scope.newSchemaDef = $selectedSchema.getNewRuleSchema();

    $scope.getLabels = function () {
      $rootScope.loading = true;
      $labelFactory
        .getLabels()
        .then(function (res) {
          $rootScope.loading = false;
          $scope.labelList = res;
          $scope.labelList.data = $scope.labelList.sort(function (a, b) {
            return a.labelId - b.labelId;
          });
        })
        .catch(function (err) {
          $rootScope.loading = false;
          $toastr.info(
            $translationService.getTranslationController(
              "No se han podido obtener las etiquetas.",
              "The labels could not be loaded.",
              "Os rótulos não puderam ser carregados."
            )
          );
          console.log("Error@getLabels", err);
        });
    };
    $scope.getLabels();

    $scope.loadSchema = function (schema) {
      if (schema) {
        schema = angular.fromJson(schema);
        var definitions = schema.definitions || schema.schema.definitions;
        // -- Update original name of actual schema
        definitions[$scope.schemaName] = angular.copy(definitions[Object.keys(definitions)[0]]);
        if (definitions.length > 1) delete definitions[Object.keys(definitions)[0]];

        // -- Load new data from json to schema

        $scope.myData = [];

        angular.forEach(definitions[$scope.schemaName].properties, function (col, index) {
          $scope.myData.push({
            order: col.order,
            name: index,
            displayName: col.displayName || "",
            type: col.type,
            metadata: col.metadata
              ? _getMetadataNameByReferenceId(col.metadata.id, col.type, col.lookupmatch)
              : null,
            autocomplete: col.autocomplete === undefined ? false : col.autocomplete,
            visible: col.visible === undefined ? false : col.visible,
            group: col.group,
            format: col.format,
            prefix: col.prefix,
            suffix: col.suffix,
            description: col.description,
            tooltip: col.tooltip === undefined ? true : col.tooltip,
            readonly: col.readonly === undefined ? false : col.readonly,
            required:
              schema.definitions[$scope.schemaName].required.indexOf(index) > -1 ? true : false,
            pk: definitions[$scope.schemaName].required.indexOf("#" + index) > -1 ? true : false,
            lookupmatch: col.type == "lookup" ? col.metadata.lookupmatch : null,
          });
        });

        $scope.myData.sort(function (a, b) {
          return a.order - b.order;
        });

        if ($scope.gridOptions) {
          $scope.gridOptions.data = $scope.myData;
        }
      }
    };

    console.log($scope.selectedSchema);
    console.log($scope.newSchemaDef);

    if ($scope.selectedSchema) {
      // If there us a selected schema, load it to update

      $scope.permission = "schema#" + $scope.selectedSchema.id + ":update";
      $scope.actionText = $translationService.getTranslationController(
        "Modificar Esquema: ",
        "Modify Schema: ",
        "Modificar Esquema: "
      );
      $scope.schemaId = $scope.selectedSchema.id;
      $scope.schemaName = $scope.selectedSchema.name;
      $scope.labelId = $scope.selectedSchema.labelId;
      $scope.schemaType = $scope.selectedSchema.schemaType;
      $scope.schemaIcon = $scope.selectedSchema.icon;
      $scope.schemaDescription = $scope.selectedSchema.description;
      $scope.schemaGroup = $scope.selectedSchema.group;
      $scope.schemaDisplay = $scope.selectedSchema.display;

      $scope.loadSchema($scope.selectedSchema.schema);

      if ($scope.selectedSchema.copy) {
        $scope.permission = "schema#" + $scope.selectedSchema.id + ":create";
        $scope.schemaId = null;
        $scope.actionText = $translationService.getTranslationController(
          "Crear Esquema: ",
          "Create Schema: ",
          "Criar esquema: "
        );
        $scope.schemaName = "Copy_of_" + $scope.selectedSchema.name;
        $scope.selectedSchema.schema_usage = 0;
        $scope.selectedSchema.function_usage = 0;
      }
    } else if ($scope.newSchemaDef && $scope.newSchemaDef.length > 0) {
      // If there is a new schema definition, but the columns are defined, create with preloaded data (Schemas from rules)

      $scope.permission = "schema:create";
      $scope.schemaId = null;
      $scope.actionText = $translationService.getTranslationController(
        "Crear Esquema: ",
        "Create Schema: ",
        "Criar esquema: "
      );
      $scope.schemaName = "";
      $scope.schemaType = "USER";
      $scope.schemaDescription = "Schema created from rule conection";
      $scope.schemaGroup = "";
      $scope.myData = [];
      angular.forEach($scope.newSchemaDef, function (value, key) {
        $scope.myData.push({
          order: key,
          name: value.key,
          displayName: value.key,
          type: value.value,
          metadata: null,
          autocomplete: false,
          visible: true,
          group: "",
          format: "",
          prefix: "",
          suffix: "",
          description: "",
          tooltip: true,
          readonly: false,
          required: false,
          pk: false,
          lookupmatch: null,
        });
      });
    } else {
      // Create a new blank schema

      $scope.permission = "schema:create";
      $scope.schemaId = null;
      $scope.actionText = $translationService.getTranslationController(
        "Crear Esquema: ",
        "Create Schema: ",
        "Criar esquema: "
      );
      $scope.schemaName = "";
      $scope.schemaDescription = "";
      $scope.schemaType = "USER";
      $scope.schemaIcon = "";
      $scope.schemaGroup = $scope.groupPath ? $scope.groupPath : "";
      $scope.myData = [
        {
          order: 0,
          name: "",
          displayName: "",
          type: null,
          metadata: null,
          autocomplete: false,
          visible: true,
          group: "",
          format: "",
          prefix: "",
          suffix: "",
          description: "",
          tooltip: true,
          readonly: false,
          required: true,
          pk: true,
          lookupmatch: null,
        },
      ];
    }

    $scope.buildSchema = function () {
      var finalSchema = {};

      var _PK = null;
      var error = false;
      var required = [];
      function checkBoolean(value) {
        if (value === undefined) return false;
        if (value === null) return false;
        if (typeof value === "string") return Boolean(value === "true");
        if (typeof value === "boolean") return value;
        return value;
      }

      angular.forEach($scope.myData, function (col, index) {
        finalSchema[col.name] = {
          order: index,
          type: col.type,
          displayName: col.displayName || "",
          metadata: null,
          autocomplete: checkBoolean(col.autocomplete),
          visible: checkBoolean(col.visible),
          group: col.group,
          format: col.format,
          prefix: col.prefix,
          suffix: col.suffix,
          description: col.description,
          tooltip: checkBoolean(col.tooltip),
          readonly: checkBoolean(col.readonly),
        };

        if (["reference", "sequential", "complex", "lookup"].includes(col.type)) {
          if (col.metadata) {
            finalSchema[col.name].metadata = _getMetadataByReferenceName(
              col.metadata,
              col.type,
              col.lookupmatch
            );
          }
        }

        if (col.pk === true || col.pk === "true") {
          if (_PK != null) {
            $toastr.warning(
              $translationService.getTranslationController(
                "El esquema solo puede tener una llave primaría.",
                "Schema must have only one primary key.",
                "O esquema deve ter apenas uma chave primária."
              )
            );
            error = true;
          }
          _PK = "#" + col.name;
          required.push(_PK);
        } else if (checkBoolean(col.required)) {
          required.push(col.name);
        }
      });

      if (_PK == null) {
        $toastr.warning(
          $translationService.getTranslationController(
            "El esquema debe tener una llave primaría.",
            "Schema must have one primary key.",
            "O esquema deve ter uma chave primária."
          )
        );
        error = true;
      }

      var builtSchema = { definitions: {} };
      builtSchema.definitions[$scope.schemaName] = {
        type: "object",
        $id: _PK,
        properties: finalSchema,
        required: required,
      };
      $scope.mySchema = builtSchema;
      $scope.mySchemaJson = angular.toJson(builtSchema, true);

      return !error;
    };

    function _getMetadataByReferenceName(refName, colType, lookupmatch) {
      var dataSourceByType = {
        complex: complexSchemas,
        sequential: $selectedSchema.getInputLists(),
        reference: $selectedSchema.getInputLists().map(function (item) {
          return {
            id: item.id,
            name: item.name,
            schema: item.schema,
            type: item.type,
          };
        }),
        lookup: $selectedSchema.getInputLists().map(function (item) {
          return {
            id: item.id,
            name: item.name,
            schema: item.schema,
            type: item.type,
            lookupmatch: lookupmatch,
          };
        }),
      };
      var sourceData = dataSourceByType[colType] || [];

      return sourceData.find(function (e) {
        return e.name == refName;
      });
    }

    function _getMetadataNameByReferenceId(refId, colType, lookupmatch) {
      var dataSourceByType = {
        complex: complexSchemas,
        sequential: $selectedSchema.getInputLists(),
        reference: $selectedSchema.getInputLists().map(function (item) {
          return {
            id: item.id,
            name: item.name,
            schema: item.schema,
            type: item.type,
          };
        }),
        lookup: $selectedSchema.getInputLists().map(function (item) {
          return {
            id: item.id,
            name: item.name,
            schema: item.schema,
            type: item,
            lookupmatch: lookupmatch,
          };
        }),
      };
      var sourceData = dataSourceByType[colType] || [];
      var result = sourceData.find(function (e) {
        return e.id == refId;
      });

      if (result) {
        return result.name;
      }

      return null;
    }

    $scope.aceChanged = function () {
      if ($scope.activeTab == "schema") {
        $scope.loadSchema($scope.mySchemaJson);
      }
    };

    $scope.gridOptions = {
      columndefinitions: [
        {
          displayName: $translationService.getTranslationController("Nombre", "Name", "Nome"),
          name: "Name",
          field: "name",
          width: 100,
          align: "htLeft",
        },
        {
          displayName: $translationService.getTranslationController(
            "Display",
            "Display",
            "Display"
          ),
          name: "DisplayName",
          field: "displayName",
          width: 100,
          align: "htLeft",
        },
        {
          displayName: $translationService.getTranslationController("Tipo", "DataType", "Tipo"),
          name: "DataType",
          field: "type",
          width: 60,
          align: "htCenter",
        },
        {
          displayName: "Reference",
          name: "Metadata",
          field: "metadata",
          width: 100,
          align: "htLeft",
        },
        {
          displayName: "lookupmatch",
          name: "lookupmatch",
          field: "lookupmatch",
          width: 100,
          align: "htLeft",
        },
        {
          displayName: "Autocomp.",
          name: "Autocomplete",
          field: "autocomplete",
          width: 60,
          align: "htCenter",
          type: "boolean",
        },
        {
          displayName: "PK",
          name: "PrimaryKey",
          field: "pk",
          type: "boolean",
          width: 60,
          align: "htCenter",
        },
        {
          displayName: $translationService.getTranslationController(
            "Requerido",
            "Required",
            "Obrigatório"
          ),
          name: "Required",
          field: "required",
          type: "boolean",
          width: 60,
          align: "htCenter",
        },
        {
          displayName: $translationService.getTranslationController(
            "Visible",
            "Visible",
            "Visível"
          ),
          name: "Visible",
          field: "visible",
          type: "boolean",
          width: 60,
          align: "htCenter",
        },
        {
          displayName: "Tooltip",
          name: "Tooltip",
          field: "tooltip",
          type: "boolean",
          width: 60,
          align: "htCenter",
        },
        {
          displayName: "Readonly",
          name: "Readonly",
          field: "readonly",
          type: "boolean",
          width: 60,
          align: "htCenter",
        },
        {
          displayName: $translationService.getTranslationController("Grupo", "Group", "Grupo"),
          name: "Group",
          field: "group",
          width: 100,
          align: "htLeft",
        },
        {
          displayName: $translationService.getTranslationController("Formato", "Format", "Formato"),
          name: "Format",
          field: "format",
          width: 60,
          align: "htCenter",
        },
        {
          displayName: $translationService.getTranslationController("Prefix", "Prefix", "Prefix"),
          name: "Prefix",
          field: "prefix",
          width: 60,
          align: "htCenter",
        },
        {
          displayName: $translationService.getTranslationController("suffix", "suffix", "suffix"),
          name: "suffix",
          field: "suffix",
          width: 60,
          align: "htCenter",
        },
        {
          displayName: $translationService.getTranslationController(
            "Descripción",
            "Description",
            "Descrição"
          ),
          name: "Description",
          field: "description",
          align: "htLeft",
        },
      ],
      data: $scope.myData,
    };

    // Table options
    vm.tableColumns = $scope.gridOptions.columndefinitions.map(function (col) {
      if (col.name == "Metadata")
        return {
          type: "autocomplete",
          trimDropdown: true,
          strict: true,
          allowInvalid: false,
          source: function (options, process) {
            if (!$scope.rowEntity) return;
            if (!$scope.rowEntity.type) return;
            var dataSourceByType = {
              complex: complexSchemas,
              sequential: $selectedSchema.getInputLists().map(function (e) {
                return e.name;
              }),
              reference: $selectedSchema.getInputLists().map(function (e) {
                return e.name;
              }),
              lookup: $selectedSchema.getInputLists().map(function (e) {
                return e.name;
              }),
            };
            var sourceData = dataSourceByType[$scope.rowEntity.type] || [];

            process(sourceData);
          },
          className: "schema-editor-cell htLeft",
          data: col.field,
          title: col.displayName || col.name,
          width: 80,
        };

      if (col.name == "lookupmatch")
        return {
          type: "autocomplete",
          trimDropdown: true,
          strict: true,
          allowInvalid: false,
          source: function (options, process) {
            var sourceData = $selectedSchema.getInputLists().find(function (e) {
              return e.name === $scope.rowEntity.metadata;
            });
            var schemaName = sourceData.rawSchema.name;
            var schemaProps = JSON.parse(sourceData.rawSchema.schema);
            var schemaPropsParsed = schemaProps.definitions[schemaName];
            // var $id = schemaPropsParsed.$id.replace("#","")
            var schemaPropsProperties = schemaPropsParsed.properties;
            var schemaKeys = Object.keys(schemaPropsProperties);
            // .map(function(e){
            //   if($id == e) return "#"+e
            //   else return e
            // });
            process(schemaKeys);
          },
          className: "schema-editor-cell htLeft",
          data: col.field,
          title: col.displayName || col.name,
          width: 80,
        };

      if (col.name == "DataType") {
        return {
          type: "dropdown",
          trimDropdown: true,
          strict: true,
          allowInvalid: false,
          source: $types.map(function (e) {
            return e.id;
          }),
          className: "schema-editor-cell " + col.align,
          data: col.field,
          title: col.displayName || col.name,
          width: 80,
        };
      }

      if (col.name == "Format") {
        return {
          type: "dropdown",
          trimDropdown: true,
          strict: true,
          allowInvalid: false,
          source: function (query, callback) {
            var promises = [
              $ConfigurationFactory.getSchemaFormat(),
              $IndicatorsFactory.getIndicators(),
            ];
            Promise.allSettled(promises)
              .then(function (res) {
                var schemas =
                  res[0].status == "fulfilled"
                    ? res[0].value.data.map(function (e) {
                        return e.name;
                      })
                    : [];
                var indicators =
                  res[1].status == "fulfilled"
                    ? res[1].value.data.map(function (e) {
                        return e.name;
                      })
                    : [];
                callback(["", "textarea", "checkbox", "issueLink"].concat(schemas, indicators));
              })
              .catch(function (err) {
                console.log(err);
              });
          },
          className: "schema-editor-cell " + col.align,
          data: col.field,
          title: col.displayName || col.name,
          width: 80,
        };
      }

      return {
        type: col.type == "boolean" ? "checkbox" : "text",
        className: "schema-editor-cell " + col.align,
        data: col.field,
        title: col.displayName || col.name,
        width: col.width,
      };
    });

    vm.tableSettings = {
      licenseKey: "non-commercial-and-evaluation",
      stretchH: "all",
      renderAllRows: false,
      colWidths: 100,
      colHeaders: true,
      rowHeaders: false,
      currentRowClassName: "cep-selected-row",
      manualColumnResize: true,
      manualRowResize: true,
      persistentState: false,
      columnSorting: false,
      allowInvalid: true,
      columnHeaderHeight: 10,
      outsideClickDeselects: false,
      contextMenu: {
        items: {
          remove_row: {
            name: $translationService.getTranslationController(
              "Eliminar fila",
              "Remove row",
              "Remover fila"
            ),
          },
        },
      },
      onAfterInit: function () {
        vm.gridInstance = this;
      },
      onAfterSelectionEnd: function (row, col) {
        $scope.rowEntity = $scope.gridOptions.data[row];
        $scope.selectedCellCoordinates = {
          row: row,
          col: col,
        };
      },
      beforeCreateRow: function () {
        // Avoid to create row automatically
        return false;
      },
      beforePaste: function (data, coords) {
        // for (var index = 0; index < $scope.myData.length; index++) {
        //   var prop = $scope.myData[index];

        //   prop.autocomplete = Boolean(prop.autocomplete === "true");
        //   prop.pk = Boolean(prop.pk === "true");
        //   prop.required = Boolean(prop.required === "true");
        //   prop.readonly = Boolean(prop.readonly === "true");
        //   prop.visible = Boolean(prop.visible === "true");
        //   prop.tooltip = Boolean(prop.tooltip === "true");
        //   prop.readonly = Boolean(prop.readonly === "true");
        // }

        setTimeout(function () {
          $scope.buildSchema();
        }, 500);
      },
    };
    // End Table options

    $scope.deleteRow = function (row) {
      if (
        row.new != true &&
        $scope.selectedSchema != null &&
        ($scope.selectedSchema.schema_usage > 0 || $scope.selectedSchema.function_usage > 0)
      ) {
        $toastr.info(
          $translationService.getTranslationController(
            "No se pueden eliminar columnas de esquemas en uso.",
            "You can not delete columns from schemas in use.",
            "Você não pode excluir colunas de esquemas em uso."
          )
        );
        return false;
      }
      delete row.$$hashKey;
      var index = $scope.myData.indexOf(row);
      $scope.myData.splice(index, 1);
    };

    $scope.moveRow = function (dir) {
      if ($scope.rowEntity) {
        var row = $scope.rowEntity;
        var index = $scope.myData.indexOf(row);

        if (!dir) {
          // Move down
          if ($scope.myData[index + 1]) {
            $scope.myData[index].order = Number($scope.myData[index].order) + 1;
            $scope.myData[index + 1].order = Number($scope.myData[index].order) - 1;

            $scope.myData.sort(function (a, b) {
              return a.order - b.order;
            });

            vm.gridInstance.selectCell(
              ++$scope.selectedCellCoordinates.row,
              $scope.selectedCellCoordinates.col
            );
          }
        } else {
          // Move up
          if ($scope.myData[index - 1]) {
            $scope.myData[index].order = Number($scope.myData[index].order) - 1;
            $scope.myData[index - 1].order = Number($scope.myData[index].order) + 1;

            $scope.myData.sort(function (a, b) {
              return a.order - b.order;
            });

            vm.gridInstance.selectCell(
              --$scope.selectedCellCoordinates.row,
              $scope.selectedCellCoordinates.col
            );
          }
        }
      }
    };

    $scope.addRow = function () {
      if ($scope.schemaIsSequential() && $scope.myData.length >= 1) {
        $toastr.info(
          $translationService.getTranslationController(
            "¡Los esquemas secuenciales deben tener solo una columna!",
            "Sequential schemas must have only one column!",
            "Esquemas sequenciais devem ter apenas uma coluna!"
          )
        );
        return false;
      }

      var order =
        $scope.myData.length > 0 ? Number($scope.myData[$scope.myData.length - 1].order) + 1 : 0;
      $scope.myData.push({
        order: order,
        name: "",
        displayName: "",
        type: null,
        metadata: null,
        autocomplete: false,
        visible: true,
        group: "",
        format: "",
        description: "",
        tooltip: true,
        readonly: false,
        required: false,
        pk: false,
        new: true,
        lookupmatch: null,
      });
    };

    var validateData = function () {
      if (!$scope.schemaName) {
        $toastr.info(
          $translationService.getTranslationController(
            "¡Debes agregar un nombre al esquema!",
            "You must add a schema name!",
            "Você deve adicionar um nome ao esquema!"
          )
        );
        return false;
      }

      if ($scope.myData.length < 1) {
        $toastr.info(
          $translationService.getTranslationController(
            "¡El esquema debe tener al menos un elemento!",
            "The schema must have at least one element!",
            "O esquema deve ter pelo menos um elemento!"
          )
        );
        return false;
      }

      if ($scope.mustCreateList && !$scope.listName) {
        $toastr.info(
          $translationService.getTranslationController(
            "¡Debes agregar un nombre a la lista!",
            "You must add a list name!",
            "Você deve adicionar um nome à lista!"
          )
        );
        return false;
      }

      var untypes = $scope.myData.filter(function (e) {
        return e.type == "reference";
      });
      if (untypes.length > 1) {
        $toastr.info(
          $translationService.getTranslationController(
            'Solo se permite una columna "reference"',
            'Only one "reference" column is permitted',
            'Apenas uma coluna "reference" é permitida'
          )
        );
        return false;
      }
      // var untypes = $scope.myData.filter(function (e) {
      //   return e.type == 'lookup';
      // });
      // if (untypes.length > 1) {
      //   $toastr.info(
      //     $translationService.getTranslationController(
      //       'Solo se permite una columna "lookup"',
      //       'Only one "lookup" column is permitted',
      //       'Apenas uma coluna "lookup" é permitida'
      //     )
      //   );
      //   return false;
      // }

      var untypes = $scope.myData.filter(function (e) {
        return e.type == "autoincrement";
      });
      if (untypes.length > 1) {
        $toastr.info(
          $translationService.getTranslationController(
            'Solo se permite una columna "autoincrement"',
            'Only one "autoincrement" column is permitted',
            'Apenas uma coluna "autoincrement" é permitida'
          )
        );
        return false;
      }

      var untypes = $scope.myData.filter(function (e) {
        return e.type == "autoincrement" && e.pk != true;
      });
      if (untypes.length) {
        $toastr.info(
          $translationService.getTranslationController(
            '¡La columna "autoincrement" debe ser la clave primaria!',
            "Autoincrement colum must be the primary key!",
            'A coluna "autoincrement" deve ser a chave primária!'
          )
        );
        return false;
      }

      if ($scope.schemaIsSequential() && $scope.myData.length > 1) {
        $toastr.info(
          $translationService.getTranslationController(
            "¡Los esquemas secuenciales deben tener una sola columna!",
            "Sequential schemas must have only one column!",
            "Esquemas seqüenciais devem ter apenas uma coluna!"
          )
        );
        return false;
      }

      var untypes = $scope.myData.filter(function (e) {
        return e.metadata != "" && e.metadata != null;
      });
      if ($scope.schemaIsSequential() && untypes.length) {
        $toastr.info(
          $translationService.getTranslationController(
            "¡Los esquemas secuenciales no pueden tener datos referenciados!",
            "Sequential schemes can not have references!",
            "Esquemas seqüenciais não podem ter data referenced!"
          )
        );
        return false;
      }

      var untypes = $scope.myData.filter(function (e) {
        return e.name == "";
      });
      if (untypes.length) {
        $toastr.info(
          $translationService.getTranslationController(
            "Debe indicar el nombre de la columna",
            "You must indicate the name of the column",
            "Você deve indicar o nome da coluna"
          )
        );
        return false;
      }

      var untypes = $scope.myData.filter(function (e) {
        return e.type == null;
      });
      if (untypes.length) {
        $toastr.info(
          $translationService.getTranslationController(
            "Debe indicar el tipo de dato de la columna: ",
            "You must indicate the data type of the column: ",
            "Você deve indicar o tipo de dados da coluna: "
          ) + untypes[0].name
        );
        return false;
      }

      var untypes = $scope.myData.filter(function (e) {
        return (
          (e.type == "lookup" || e.type == "sequential" || e.type == "reference") &&
          (e.metadata == "" || e.metadata == null)
        );
      });
      if (untypes.length) {
        $toastr.info(
          $translationService.getTranslationController(
            "¡Los campos secuenciales & referenciados deben tener una lista asociada!",
            "Sequential ,reference & lookup fields must have an associated list!",
            "Campos sequenciais devem ter uma lista associada!"
          )
        );
        return false;
      }

      var untypes = $scope.myData.filter(function (e) {
        return e.type == "complex" && (e.metadata == "" || e.metadata == null);
      });
      if (untypes.length) {
        $toastr.info(
          $translationService.getTranslationController(
            "¡Los campos complejos (complex) deben tener un esquema asociado!",
            "Complex fields must have an associated schema!",
            "Campos complexos (complex) devem ter um esquema associado!"
          )
        );
        return false;
      }

      var untypes = [];
      angular.forEach(
        $scope.myData.map(function (e) {
          return e.name;
        }),
        function (val) {
          untypes[val] = (untypes[val] || 0) + 1;
        }
      );
      if (
        Object.values(untypes).filter(function (e) {
          return e > 1;
        }).length
      ) {
        $toastr.info(
          $translationService.getTranslationController(
            "¡Las columnas deben tener nombres únicos!",
            "Columns must have unique names!",
            "Colunas devem ter nomes exclusivos!"
          )
        );
        return false;
      }

      return true;
    };

    $scope.createSchema = function (ev) {
      if (!validateData()) {
        return false;
      }

      if ($scope.mustCreateList) {
        $inputListsFactory
          .getInputList($scope.listName)
          .then(function () {
            $toastr.info(
              $translationService.getTranslationController(
                "La lista " +
                  $scope.listName +
                  " ya existe, seleccione un nombre diferente para la nueva lista.",
                "The list " +
                  $scope.listName +
                  " already exists, please select a different name for the new list",
                "A lista " +
                  $scope.listName +
                  " já existe, selecione um nome diferente para a nova lista"
              )
            );
          })
          .catch(function () {
            showUserConfirmation(ev);
          });
      } else {
        showUserConfirmation(ev);
      }
    };

    function showUserConfirmation(ev) {
      var confirm = $mdDialog
        .confirm()
        .multiple(true)
        .title(
          $translationService.getTranslationController(
            "¿Listo el esquema?",
            "Save Schema?",
            "Pronto o esquema?"
          )
        )
        .ariaLabel("Cancel-Question")
        .targetEvent(ev)
        .ok(
          $translationService.getTranslationController("Si, Guárdalo", "Yes, Save it", "Sim, salve")
        )
        .cancel($translationService.getTranslationController("Aún no", "Not yet", "Ainda não"));

      $mdDialog.show(confirm).then(
        function () {
          saveSchema();
        },
        function () {}
      );
    }

    function saveSchema() {
      if (!$scope.buildSchema()) return false;
      $rootScope.loading = true;
      var schema = angular.copy($scope.mySchema);

      // schema.definitions[$scope.schemaName].required = [];

      // for (var key in schema.definitions[$scope.schemaName]
      //   .properties) {
      //   var prop =
      //     schema.definitions[$scope.schemaName].properties[key];

      //   prop.autocomplete = Boolean(prop.tooltip === "true");
      //   prop.readonly = Boolean(prop.tooltip === "true");
      //   prop.visible = Boolean(prop.tooltip === "true");
      //   prop.tooltip = Boolean(prop.tooltip === "true");
      //   prop.required = Boolean(prop.required === "true");
      //   console.log(prop);
      //   if (prop.required) {
      //     var isPk =
      //       schema.definitions[$scope.schemaName].$id === "#" + key;
      //     var name = isPk ? "#" + key : key;
      //     schema.definitions[$scope.schemaName].required.push(name);
      //   }
      // }

      var schemaToCreate = {
        id: $scope.schemaId,
        schema: schema,
        name: $scope.schemaName,
        description: $scope.schemaDescription,
        type: $scope.schemaType,
        icon: $scope.schemaIcon,
        labelId: parseInt($scope.labelId),
        version: 0,
        hash: "",
        use: "ok",
        schema_references: 0,
        group: $scope.schemaGroup,
        display: $scope.schemaDisplay,
      };

      schema.definitions.aux = "{a:1}";
      schema.definitions.params = "{a:1}";
      schemaToCreate.schema = angular.toJson(schema);

      console.log(schema);

      if (angular.isUndefined($scope.schemaId) || $scope.schemaId == null) {
        $schemasFactory
          .createSchema(schemaToCreate)
          .then(function (res) {
            if ($scope.mustCreateList) {
              createList(res.id);
            }
            $toastr.info(
              $translationService.getTranslationController(
                "Esquema guardado.",
                "Schema saved.",
                "Esquema salvo."
              )
            );
            $permissionsFactory.addPermission("schema", res.id, "all", true);
            $rootScope.loading = false;
            $rootScope.$broadcast("schemaUpdated", res);
            $selectedSchema.clear();
            $mdDialog.cancel();
          })
          .catch(function (err) {
            $rootScope.loading = false;
            if (err.indexOf("invalid property types") > 0) {
              $toastr.warning(
                $translationService.getTranslationController(
                  "No se ha podido guardar, existen tipos de propiedad inválidos.",
                  "Could not be save, there are invalid property types.",
                  "Não foi possível salvar, tipos de propriedade inválidos."
                )
              );
            } else if (err.indexOf("because still have lists associated") > 0) {
              $toastr.warning(
                $translationService.getTranslationController(
                  "No se ha podido guardar, el esquema tiene listas asociadas.",
                  "Could not be save, the schema has associated lists.",
                  "Não foi possível salvar, o esquema tem listas associadas."
                )
              );
            } else {
              $toastr.warning(
                $translationService.getTranslationController(
                  "No se ha podido guardar el esquema. ",
                  "Unable to save the schema. ",
                  "O esquema não pôde ser salvado. "
                ) + err
              );
              console.log("Error@createSchema", err);
            }
          });
      } else {
        $schemasFactory
          .updateSchema(schemaToCreate)
          .then(function (res) {
            if ($scope.mustCreateList) {
              createList(res.id);
            }
            $toastr.info(
              $translationService.getTranslationController(
                "Esquema guardado.",
                "Schema saved.",
                "Esquema salvo."
              )
            );
            $rootScope.loading = false;
            $rootScope.$broadcast("schemaUpdated", res);
            $selectedSchema.clear();
            $mdDialog.cancel();
          })
          .catch(function (err) {
            $rootScope.loading = false;
            if (err.indexOf("invalid property types") > 0) {
              $toastr.warning(
                $translationService.getTranslationController(
                  "No se ha podido guardar, existen tipos de propiedad inválidos.",
                  "Could not be save, there are invalid property types.",
                  "Não foi possível salvar, tipos de propriedade inválidos."
                )
              );
            } else if (err.indexOf("because still have lists associated") > 0) {
              $toastr.warning(
                $translationService.getTranslationController(
                  "No se ha podido guardar, el esquema tiene listas asociadas.",
                  "Could not be save, the schema has associated lists.",
                  "Não foi possível salvar, o esquema tem listas associadas."
                )
              );
            } else {
              $toastr.warning(
                $translationService.getTranslationController(
                  "No se ha podido guardar el esquema. ",
                  "Unable to save the schema. ",
                  "O esquema não pôde ser salvado. "
                ) + err
              );
              console.log("Error@updateSchema", err);
            }
          });
      }
    }

    function createList(schemaId) {
      var listToCreate = {
        listId: null,
        name: $scope.listName,
        hash: "",
        schemaId: schemaId,
      };
      $inputListsFactory
        .createList(listToCreate)
        .then(function (res) {
          $toastr.info(
            $translationService.getTranslationController(
              "Lista guardada.",
              "List saved.",
              "Esquema salvo."
            )
          );
          $permissionsFactory.addPermission("list", res.id, "all", true);
        })
        .catch(function (err) {
          if (err) {
            $toastr.info(err);
          } else {
            $toastr.info(
              $translationService.getTranslationController(
                "No se ha podido crear la lista.",
                "Unable to create the list.",
                "Não é possível criar a lista."
              )
            );
          }
          console.log("Error@createList", err);
        });
    }

    $document.bind("keyup", function (e) {
      if (e.key === "Escape" || e.keyCode === 27) {
        e.preventDefault();
        $document.off("keyup");
        $document.unbind("keyup");
        $selectedSchema.clear();
        $mdDialog.cancel();
      }
    });

    $scope.cancel = function (ev) {
      var confirm = $mdDialog
        .confirm()
        .multiple(true)
        .title(
          $translationService.getTranslationController(
            "¿Deseas cancelar?",
            "Do you want to cancel?",
            "Você quer cancelar?"
          )
        )
        .textContent(
          $translationService.getTranslationController(
            "¡Todos los cambios se perderán!",
            "All changes will be lost!",
            "Todas as alterações serão perdidas!"
          )
        )
        .ariaLabel("Cancel-Question")
        .targetEvent(ev)
        .ok($translationService.getTranslationController("Abandonar", "Leave", "Deixar"))
        .cancel($translationService.getTranslationController("Cancelar", "Cancel", "Cancelar"));

      $mdDialog.show(confirm).then(
        function () {
          $document.off("keyup");
          $document.unbind("keyup");
          $selectedSchema.clear();
          $mdDialog.cancel();
        },
        function () {}
      );
    };

    $scope.validatePermission = function () {
      return $permissionsFactory.hasPermission($scope.permission);
    };

    ///-- group selector
    $scope.loadingDialog = false;

    $scope.moveItemGroup = function () {
      $scope.list = [];
      $scope.loadingDialog = true;
      $schemasFactory
        .getSchemas()
        .then(function (res) {
          $scope.list = $listsToGroups.createGroups(res.data, "group");
        })
        .then(function () {
          $scope.loadingDialog = false;
          $mdDialog
            .show({
              controller: "folderSelectorController",
              controllerAs: "ctrl",
              templateUrl: "app/app-utils/components/folder-selector/folder-selector.html",
              locals: {
                list: angular.copy($scope.list),
                item: $scope.data,
              },
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              multiple: true,
            })
            .then(function (groups) {
              $scope.schemaGroup = groups;
            });
        });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('CreateSchemasController', CreateSchemasController);

  CreateSchemasController.$inject = [
    '$scope',
    '$rootScope',
    '$mdDialog',
    'toastr',
    'translationService',
    'SchemasFactory',
    'InputListsFactory',
    'SelectedSchema',
    'LabelFactory',
    'PermissionsFactory',
    'types',
    'complexSchemas',
    'listsToGroups',
  ];
  function CreateSchemasController(
    $scope,
    $rootScope,
    $mdDialog,
    $toastr,
    $translationService,
    $schemasFactory,
    $inputListsFactory,
    SelectedSchema,
    $labelFactory,
    $permissionsFactory,
    $types,
    complexSchemas,
    $listsToGroups
  ) {
    $translationService.getTranslation($scope, 'schemas');
    $scope.schemaTypes = ['USER', 'SYSTEM', 'COMPLEX', 'SEQUENTIAL'];

    $scope.schemaIsSequential = function () {
      return $scope.schemaType == 'SEQUENTIAL';
    };

    $scope.selectedSchema = SelectedSchema.getSchema();
    $scope.newSchemaDef = SelectedSchema.getNewRuleSchema();

    $scope.getLabels = function () {
      $rootScope.loading = true;
      $labelFactory
        .getLabels()
        .then(function (res) {
          $rootScope.loading = false;
          $scope.labelList = res;
          $scope.labelList.data = $scope.labelList.sort(function (a, b) {
            return a.labelId - b.labelId;
          });
        })
        .catch(function (err) {
          $rootScope.loading = false;
          $toastr.info(
            $translationService.getTranslationController(
              'No se han podido obtener las etiquetas.',
              'The labels could not be loaded.',
              'Os rótulos não puderam ser carregados.'
            )
          );
          console.log('Error@getLabels', err);
        });
    };
    $scope.getLabels();

    $scope.loadSchema = function (schema) {
      if (schema) {
        schema = angular.fromJson(schema);
        // -- Cambiar a nombre original del esquema actual
        schema.definitions[$scope.schemaName] = angular.copy(
          schema.definitions[Object.keys(schema.definitions)[0]]
        );
        if (schema.definitions.length > 1)
          delete schema.definitions[Object.keys(schema.definitions)[0]];

        // -- Cargar los nuevos datos del json al esquema
        $scope.myData = [];
        angular.forEach(
          schema.definitions[$scope.schemaName].properties,
          function (col, index) {
            $scope.myData.push({
              order: col.order,
              name: index,
              displayName: col.displayName,
              type: col.type,
              metadata: col.metadata ? col.metadata.id : null,
              autocomplete: col.autocomplete,
              visible: col.visible,
              group: col.group,
              format: col.format,
              description: col.description,
              required:
                schema.definitions[$scope.schemaName].required.indexOf(index) >
                -1
                  ? true
                  : false,
              pk:
                schema.definitions[$scope.schemaName].required.indexOf(
                  '#' + index
                ) > -1
                  ? true
                  : false,
            });
          }
        );
        $scope.myData.sort(function (a, b) {
          return a.order - b.order;
        });

        if ($scope.gridOptions) {
          // -- Si ya existe la tabla, recarga
          $scope.gridOptions.data = $scope.myData;
          $scope.gridApi.core.refresh();
        }
      }
    };

    if ($scope.selectedSchema) {
      // Si hay un esquema seleccionado, modificar
      $scope.permission = 'schema#' + $scope.selectedSchema.id + ':update';
      $scope.actionText = $translationService.getTranslationController(
        'Modificar Esquema: ',
        'Modify Schema: ',
        'Modificar Esquema: '
      );
      $scope.schemaId = $scope.selectedSchema.id;
      $scope.schemaName = $scope.selectedSchema.name;
      $scope.labelId = $scope.selectedSchema.labelId;
      $scope.schemaType = $scope.selectedSchema.schemaType;
      $scope.schemaIcon = $scope.selectedSchema.icon;
      $scope.schemaDescription = $scope.selectedSchema.description;
      // $scope.schemaGroup = $scope.selectedSchema.group;
      $scope.schemaGroup =
        $scope.selectedSchema.groups != '' ? $scope.selectedSchema.groups : [];
      $scope.schemaDisplay = $scope.selectedSchema.display;

      $scope.loadSchema($scope.selectedSchema.schema);

      if ($scope.selectedSchema.copy) {
        $scope.permission = 'schema#' + $scope.selectedSchema.id + ':create';
        $scope.schemaId = null;
        $scope.actionText = $translationService.getTranslationController(
          'Crear Esquema: ',
          'Create Schema: ',
          'Criar esquema: '
        );
        $scope.schemaName = 'Copy_of_' + $scope.selectedSchema.name;
        $scope.selectedSchema.schema_usage = 0;
        $scope.selectedSchema.function_usage = 0;
      }
    } else if ($scope.newSchemaDef) {
      // Si no hay un esquema, pero se envian las columnas, crear con data precargada (desde reglas)

      $scope.permission = 'schema:create';
      $scope.schemaId = null;
      $scope.actionText = $translationService.getTranslationController(
        'Crear Esquema: ',
        'Create Schema: ',
        'Criar esquema: '
      );
      $scope.schemaName = '';
      $scope.schemaType = 'USER';
      $scope.schemaDescription = 'Schema created from rule conection';
      $scope.myData = [];
      angular.forEach($scope.newSchemaDef, function (value, key) {
        $scope.myData.push({
          order: key,
          name: value.key,
          displayName: value.key,
          type: value.value,
          metadata: null,
          autocomplete: false,
          visible: true,
          group: '',
          format: '',
          description: '',
          required: false,
          pk: false,
        });
      });
    } else {
      // Si no, crear nuevo esquema en blanco
      $scope.permission = 'schema:create';
      $scope.schemaId = null;
      $scope.actionText = $translationService.getTranslationController(
        'Crear Esquema: ',
        'Create Schema: ',
        'Criar esquema: '
      );
      $scope.schemaName = '';
      $scope.schemaDescription = '';
      $scope.schemaType = 'USER';
      $scope.schemaIcon = '';
      $scope.myData = [
        {
          order: 0,
          name: '',
          displayName: '',
          type: null,
          metadata: null,
          autocomplete: false,
          visible: true,
          group: '',
          format: '',
          description: '',
          required: true,
          pk: true,
        },
      ];
    }

    $scope.buildSchema = function () {
      $scope.finalSchema = {};
      var _PK = null;
      var error = false;
      var required = [];
      angular.forEach($scope.myData, function (col, index) {
        $scope.finalSchema[col.name] = {
          order: index,
          type: col.type,
          displayName: col.displayName,
          metadata: col.metadata ? { id: col.metadata } : null,
          autocomplete: col.autocomplete,
          visible: col.visible,
          group: col.group,
          format: col.format,
          description: col.description,
        };

        if (col.pk) {
          if (_PK != null) {
            $toastr.warning(
              $translationService.getTranslationController(
                'El esquema solo puede tener una llave primaría.',
                'Schema must have only one primary key.',
                'O esquema deve ter apenas uma chave primária.'
              )
            );
            error = true;
          }
          _PK = '#' + col.name;
          required.push(_PK);
        } else if (col.required) {
          required.push(col.name);
        }
      });

      $scope.mySchema = { definitions: {} };
      $scope.mySchema.definitions[$scope.schemaName] = {
        type: 'object',
        $id: _PK,
        properties: $scope.finalSchema,
        required: required,
      };

      $scope.mySchemaJson = angular.toJson($scope.mySchema, true);
      if (_PK == null) {
        $toastr.warning(
          $translationService.getTranslationController(
            'El esquema debe tener una llave primaría.',
            'Schema must have one primary key.',
            'O esquema deve ter uma chave primária.'
          )
        );
        error = true;
      }
      return !error;
    };

    $scope.aceChanged = function () {
      $scope.loadSchema($scope.mySchemaJson);
    };

    $scope.gridOptions = {
      enableGridMenu: false,
      enableCellEditOnFocus: true,
      enableSelectAll: false,
      enableRowSelection: false,
      enableRowHeaderSelection: true,
      multiSelect: false,
      excessRows: 10,
      columnDefs: [
        {
          displayName: $translationService.getTranslationController(
            'Nombre',
            'Name',
            'Nome'
          ),
          name: 'Name',
          field: 'name',
          enableColumnMenu: false,
          enableSorting: false,
          enableCellEditOnFocus: true,
          enableHiding: false,
          width: 150,
        },
        {
          displayName: $translationService.getTranslationController(
            'Display',
            'Display',
            'Display'
          ),
          name: 'DisplayName',
          field: 'displayName',
          enableColumnMenu: false,
          enableSorting: false,
          enableCellEditOnFocus: true,
          enableHiding: false,
          width: 150,
        },
        {
          displayName: $translationService.getTranslationController(
            'Tipo',
            'DataType',
            'Tipo'
          ),
          name: 'DataType',
          field: 'type',
          enableColumnMenu: false,
          enableSorting: false,
          enableCellEditOnFocus: true,
          enableHiding: false,
          editableCellTemplate: 'ui-grid/dropdownEditor',
          cellFilter: 'mapType',
          editDropdownValueLabel: 'type',
          editDropdownOptionsArray: $types,
          width: 100,
        },
        {
          displayName: 'Ref',
          name: 'Metadata',
          field: 'metadata',
          enableColumnMenu: false,
          enableSorting: false,
          enableCellEditOnFocus: true,
          enableHiding: false,
          editableCellTemplate: 'ui-grid/dropdownEditor',
          editDropdownValueLabel: 'name',
          editDropdownIdLabel: 'id',
          editDropdownOptionsFunction: function (rowEntity) {
            switch (rowEntity.type) {
              case 'complex':
                return complexSchemas;
              case 'sequential':
                return SelectedSchema.getInputLists().filter(function (e) {
                  return e.type == 'SEQUENTIAL';
                });
              case 'reference':
                return SelectedSchema.getInputLists();
              case 'lookup':
                return SelectedSchema.getInputLists();
              default:
                return [];
            }
          },
          width: 100,
        },
        {
          displayName: $translationService.getTranslationController(
            'Autocomplete',
            'Autocompletar',
            'Autocompletar'
          ),
          name: 'Autocomplete',
          field: 'autocomplete',
          enableColumnMenu: false,
          enableSorting: false,
          enableCellEditOnFocus: true,
          enableHiding: false,
          type: 'boolean',
          width: 60,
        },
        {
          displayName: 'PK',
          name: 'PrimaryKey',
          field: 'pk',
          enableColumnMenu: false,
          enableSorting: false,
          enableCellEditOnFocus: true,
          enableHiding: false,
          type: 'boolean',
          width: 60,
        },
        {
          displayName: $translationService.getTranslationController(
            'Requerido',
            'Required',
            'Obrigatório'
          ),
          name: 'Required',
          field: 'required',
          enableColumnMenu: false,
          enableSorting: false,
          enableCellEditOnFocus: true,
          enableHiding: false,
          type: 'boolean',
          width: 60,
        },
        {
          displayName: $translationService.getTranslationController(
            'Visible',
            'Visible',
            'Visível'
          ),
          name: 'Visible',
          field: 'visible',
          enableColumnMenu: false,
          enableSorting: false,
          enableCellEditOnFocus: true,
          enableHiding: false,
          type: 'boolean',
          width: 60,
        },
        {
          displayName: $translationService.getTranslationController(
            'Grupo',
            'Group',
            'Grupo'
          ),
          name: 'Group',
          field: 'group',
          enableColumnMenu: false,
          enableSorting: false,
          enableCellEditOnFocus: true,
          enableHiding: false,
          width: 100,
        },
        {
          displayName: $translationService.getTranslationController(
            'Formato',
            'Format',
            'Formato'
          ),
          name: 'Format',
          field: 'format',
          enableColumnMenu: false,
          enableSorting: false,
          enableCellEditOnFocus: true,
          enableHiding: false,
          width: 100,
        },
        {
          displayName: $translationService.getTranslationController(
            'Descripción',
            'Description',
            'Descrição'
          ),
          name: 'Description',
          field: 'description',
          enableColumnMenu: false,
          enableSorting: false,
          enableCellEditOnFocus: true,
          enableHiding: false,
        },
        {
          displayName: 'Del',
          name: 'Delete',
          enableFiltering: false,
          enableSorting: false,
          enableCellEdit: false,
          enableColumnMenu: false,
          cellTemplate:
            '<button type="button" ng-click="grid.appScope.deleteRow(row.entity)"><md-icon md-font-set="material-icons" aria-label="BTN">delete</md-icon></button>',
          cellClass: 'schema-cell-content',
          width: 42,
        },
      ],
      gridMenuCustomItems: [
        {
          title: $translationService.getTranslationController(
            'Agregar Fila',
            'Add Row',
            'Adicionar linha'
          ),
          action: function ($event) {
            $scope.addRow();
          },
          order: 210,
        },
      ],
      onRegisterApi: function (gridApi) {
        $scope.gridApi = gridApi;
        // Selection
        gridApi.selection.on.rowSelectionChanged($scope, function (row) {
          $scope.rowEntity = row.entity;
        });
      },
      data: 'myData',
    };

    $scope.deleteRow = function (row) {
      if (
        row.new != true &&
        $scope.selectedSchema != null &&
        ($scope.selectedSchema.schema_usage > 0 ||
          $scope.selectedSchema.function_usage > 0)
      ) {
        $toastr.info(
          $translationService.getTranslationController(
            'No se pueden eliminar columnas de esquemas en uso.',
            'You can not delete columns from schemas in use.',
            'Você não pode excluir colunas de esquemas em uso.'
          )
        );
        return false;
      }
      delete row.$$hashKey;
      var index = $scope.myData.indexOf(row);
      $scope.myData.splice(index, 1);
    };

    $scope.moveRow = function (dir) {
      if ($scope.rowEntity) {
        var row = $scope.rowEntity;
        var index = $scope.myData.indexOf(row);
        if (!dir) {
          // Baja
          if ($scope.myData[index + 1]) {
            $scope.myData[index].order = Number($scope.myData[index].order) + 1;
            $scope.myData[index + 1].order =
              Number($scope.myData[index].order) - 1;
          }
        } else {
          // Baja
          if ($scope.myData[index - 1]) {
            $scope.myData[index].order = Number($scope.myData[index].order) - 1;
            $scope.myData[index - 1].order =
              Number($scope.myData[index].order) + 1;
          }
        }
        $scope.myData.sort(function (a, b) {
          return a.order - b.order;
        });
      }
    };

    $scope.addRow = function () {
      // Validar cantidad de columnas
      if ($scope.schemaIsSequential() && $scope.myData.length >= 1) {
        $toastr.info(
          $translationService.getTranslationController(
            '¡Los esquemas secuenciales deben tener solo una columna!',
            'Sequential schemas must have only one column!',
            'Esquemas sequenciais devem ter apenas uma coluna!'
          )
        );
        return false;
      }
      var order = Number($scope.myData[$scope.myData.length - 1].order) + 1;
      $scope.myData.push({
        order: order,
        name: '',
        displayName: '',
        type: null,
        metadata: null,
        autocomplete: false,
        visible: true,
        group: '',
        format: '',
        description: '',
        required: false,
        pk: false,
        new: true,
      });
    };

    var validateData = function () {
      if (!$scope.schemaName) {
        $toastr.info(
          $translationService.getTranslationController(
            '¡Debes agregar un nombre al esquema!',
            'You must add a schema name!',
            'Você deve adicionar um nome ao esquema!'
          )
        );
        return false;
      }

      if ($scope.myData.length < 1) {
        $toastr.info(
          $translationService.getTranslationController(
            '¡El esquema debe tener al menos un elemento!',
            'The schema must have at least one element!',
            'O esquema deve ter pelo menos um elemento!'
          )
        );
        return false;
      }

      if ($scope.mustCreateList && !$scope.listName) {
        $toastr.info(
          $translationService.getTranslationController(
            '¡Debes agregar un nombre a la lista!',
            'You must add a list name!',
            'Você deve adicionar um nome à lista!'
          )
        );
        return false;
      }

      var untypes = $scope.myData.filter(function (e) {
        return e.type == 'reference';
      });
      if (untypes.length > 1) {
        $toastr.info(
          $translationService.getTranslationController(
            'Solo se permite una columna "reference"',
            'Only one "reference" column is permitted',
            'Apenas uma coluna "reference" é permitida'
          )
        );
        return false;
      }

      var untypes = $scope.myData.filter(function (e) {
        return e.type == 'autoincrement';
      });
      if (untypes.length > 1) {
        $toastr.info(
          $translationService.getTranslationController(
            'Solo se permite una columna "autoincrement"',
            'Only one "autoincrement" column is permitted',
            'Apenas uma coluna "autoincrement" é permitida'
          )
        );
        return false;
      }

      var untypes = $scope.myData.filter(function (e) {
        return e.type == 'autoincrement' && e.pk != true;
      });
      if (untypes.length) {
        $toastr.info(
          $translationService.getTranslationController(
            '¡La columna "autoincrement" debe ser la clave primaria!',
            'Autoincrement colum must be the primary key!',
            'A coluna "autoincrement" deve ser a chave primária!'
          )
        );
        return false;
      }

      if ($scope.schemaIsSequential() && $scope.myData.length > 1) {
        $toastr.info(
          $translationService.getTranslationController(
            '¡Los esquemas secuenciales deben tener una sola columna!',
            'Sequential schemas must have only one column!',
            'Esquemas seqüenciais devem ter apenas uma coluna!'
          )
        );
        return false;
      }

      var untypes = $scope.myData.filter(function (e) {
        return e.metadata != '' && e.metadata != null;
      });
      if ($scope.schemaIsSequential() && untypes.length) {
        $toastr.info(
          $translationService.getTranslationController(
            '¡Los esquemas secuenciales no pueden tener datos referenciados!',
            'Sequential schemes can not have references!',
            'Esquemas seqüenciais não podem ter data referenced!'
          )
        );
        return false;
      }

      var untypes = $scope.myData.filter(function (e) {
        return e.name == '';
      });
      if (untypes.length) {
        $toastr.info(
          $translationService.getTranslationController(
            'Debe indicar el nombre de la columna',
            'You must indicate the name of the column',
            'Você deve indicar o nome da coluna'
          )
        );
        return false;
      }

      var untypes = $scope.myData.filter(function (e) {
        return e.type == null;
      });
      if (untypes.length) {
        $toastr.info(
          $translationService.getTranslationController(
            'Debe indicar el tipo de dato de la columna: ',
            'You must indicate the data type of the column: ',
            'Você deve indicar o tipo de dados da coluna: '
          ) + untypes[0].name
        );
        return false;
      }

      var untypes = $scope.myData.filter(function (e) {
        return (
          (e.type == 'sequential' || e.type == 'reference') &&
          (e.metadata == '' || e.metadata == null)
        );
      });
      if (untypes.length) {
        $toastr.info(
          $translationService.getTranslationController(
            '¡Los campos secuenciales & referenciados deben tener una lista asociada!',
            'Sequential & reference fields must have an associated list!',
            'Campos sequenciais devem ter uma lista associada!'
          )
        );
        return false;
      }

      var untypes = $scope.myData.filter(function (e) {
        return e.type == 'complex' && (e.metadata == '' || e.metadata == null);
      });
      if (untypes.length) {
        $toastr.info(
          $translationService.getTranslationController(
            '¡Los campos complejos (complex) deben tener un esquema asociado!',
            'Complex fields must have an associated schema!',
            'Campos complexos (complex) devem ter um esquema associado!'
          )
        );
        return false;
      }

      var untypes = [];
      angular.forEach(
        $scope.myData.map(function (e) {
          return e.name;
        }),
        function (val) {
          untypes[val] = (untypes[val] || 0) + 1;
        }
      );
      if (
        Object.values(untypes).filter(function (e) {
          return e > 1;
        }).length
      ) {
        $toastr.info(
          $translationService.getTranslationController(
            '¡Las columnas deben tener nombres únicos!',
            'Columns must have unique names!',
            'Colunas devem ter nomes exclusivos!'
          )
        );
        return false;
      }

      return true;
    };

    $scope.createSchema = function (ev) {
      // Validate data
      if (!validateData()) {
        return false;
      }
      // Validate list name before save
      if ($scope.mustCreateList) {
        $inputListsFactory
          .getInputList($scope.listName)
          .then(function (res) {
            $toastr.info(
              $translationService.getTranslationController(
                'La lista ' +
                  $scope.listName +
                  ' ya existe, seleccione un nombre diferente para la nueva lista.',
                'The list ' +
                  $scope.listName +
                  ' already exists, please select a different name for the new list',
                'A lista ' +
                  $scope.listName +
                  ' já existe, selecione um nome diferente para a nova lista'
              )
            );
          })
          .catch(function (res) {
            showUserConfirmation(ev);
          });
      } else {
        showUserConfirmation(ev);
      }
    };

    function showUserConfirmation(ev) {
      var confirm = $mdDialog
        .confirm()
        .multiple(true)
        .title(
          $translationService.getTranslationController(
            '¿Listo el esquema?',
            'Save Schema?',
            'Pronto o esquema?'
          )
        )
        .ariaLabel('Cancel-Question')
        .targetEvent(ev)
        .ok(
          $translationService.getTranslationController(
            'Si, Guárdalo',
            'Yes, Save it',
            'Sim, salve'
          )
        )
        .cancel(
          $translationService.getTranslationController(
            'Aún no',
            'Not yet',
            'Ainda não'
          )
        );

      $mdDialog.show(confirm).then(
        function () {
          saveSchema();
        },
        function () {}
      );
    }

    function saveSchema() {
      if (!$scope.buildSchema()) return false;
      $rootScope.loading = true;
      var schemaToCreate = {
        id: $scope.schemaId,
        schema: angular.copy($scope.mySchema),
        name: $scope.schemaName,
        description: $scope.schemaDescription,
        type: $scope.schemaType,
        icon: $scope.schemaIcon,
        labelId: parseInt($scope.labelId),
        version: 0,
        hash: '',
        use: 'ok',
        schema_references: 0,
        group: $scope.schemaGroup,
        display: $scope.schemaDisplay,
      };

      schemaToCreate.schema = angular.toJson(schemaToCreate.schema);

      if (angular.isUndefined($scope.schemaId) || $scope.schemaId == null) {
        $schemasFactory
          .createSchema(schemaToCreate)
          .then(function (res) {
            if ($scope.mustCreateList) {
              createList(res.id);
            }
            $toastr.info(
              $translationService.getTranslationController(
                'Esquema guardado.',
                'Schema saved.',
                'Esquema salvo.'
              )
            );
            $permissionsFactory.addPermission('schema', res.id, 'all', true);
            $rootScope.loading = false;
            $rootScope.$broadcast('schemaUpdated');
            $mdDialog.cancel();
          })
          .catch(function (err) {
            $rootScope.loading = false;
            if (err.indexOf('invalid property types') > 0) {
              $toastr.warning(
                $translationService.getTranslationController(
                  'No se ha podido guardar, existen tipos de propiedad inválidos.',
                  'Could not be save, there are invalid property types.',
                  'Não foi possível salvar, tipos de propriedade inválidos.'
                )
              );
            } else if (err.indexOf('because still have lists associated') > 0) {
              $toastr.warning(
                $translationService.getTranslationController(
                  'No se ha podido guardar, el esquema tiene listas asociadas.',
                  'Could not be save, the schema has associated lists.',
                  'Não foi possível salvar, o esquema tem listas associadas.'
                )
              );
            } else {
              $toastr.warning(
                $translationService.getTranslationController(
                  'No se ha podido guardar el esquema. ',
                  'Unable to save the schema. ',
                  'O esquema não pôde ser salvado. '
                ) + err
              );
              console.log('Error@createSchema', err);
            }
          });
      } else {
        console.warn(schemaToCreate);
        $schemasFactory
          .updateSchema(schemaToCreate)
          .then(function (res) {
            $toastr.info(
              $translationService.getTranslationController(
                'Esquema guardado.',
                'Schema saved.',
                'Esquema salvo.'
              )
            );
            $rootScope.loading = false;
            $rootScope.$broadcast('schemaUpdated');
            $mdDialog.cancel();
          })
          .catch(function (err) {
            $rootScope.loading = false;
            if (err.indexOf('invalid property types') > 0) {
              $toastr.warning(
                $translationService.getTranslationController(
                  'No se ha podido guardar, existen tipos de propiedad inválidos.',
                  'Could not be save, there are invalid property types.',
                  'Não foi possível salvar, tipos de propriedade inválidos.'
                )
              );
            } else if (err.indexOf('because still have lists associated') > 0) {
              $toastr.warning(
                $translationService.getTranslationController(
                  'No se ha podido guardar, el esquema tiene listas asociadas.',
                  'Could not be save, the schema has associated lists.',
                  'Não foi possível salvar, o esquema tem listas associadas.'
                )
              );
            } else {
              $toastr.warning(
                $translationService.getTranslationController(
                  'No se ha podido guardar el esquema. ',
                  'Unable to save the schema. ',
                  'O esquema não pôde ser salvado. '
                ) + err
              );
              console.log('Error@updateSchema', err);
            }
          });
      }
    }

    function createList(schemaId) {
      var listToCreate = {
        listId: null,
        name: $scope.listName,
        hash: '',
        schemaId: schemaId,
      };
      $inputListsFactory
        .createList(listToCreate)
        .then(function (res) {
          $toastr.info(
            $translationService.getTranslationController(
              'Lista guardada.',
              'List saved.',
              'Esquema salvo.'
            )
          );
          $permissionsFactory.addPermission('list', res.id, 'all', true);
        })
        .catch(function (err) {
          if (err) {
            $toastr.info(err);
          } else {
            $toastr.info(
              $translationService.getTranslationController(
                'No se ha podido crear la lista.',
                'Unable to create the list.',
                'Não é possível criar a lista.'
              )
            );
          }
          console.log('Error@createList', err);
        });
    }

    $scope.cancel = function (ev) {
      var confirm = $mdDialog
        .confirm()
        .multiple(true)
        .title(
          $translationService.getTranslationController(
            '¿Deseas cancelar?',
            'Do you want to cancel?',
            'Você quer cancelar?'
          )
        )
        .textContent(
          $translationService.getTranslationController(
            '¡Todos los cambios se perderán!',
            'All changes will be lost!',
            'Todas as alterações serão perdidas!'
          )
        )
        .ariaLabel('Cancel-Question')
        .targetEvent(ev)
        .ok(
          $translationService.getTranslationController(
            'Abandonar',
            'Leave',
            'Deixar'
          )
        )
        .cancel(
          $translationService.getTranslationController(
            'Cancelar',
            'Cancel',
            'Cancelar'
          )
        );

      $mdDialog.show(confirm).then(
        function () {
          $mdDialog.cancel();
        },
        function () {}
      );
    };

    $scope.validatePermission = function () {
      return $permissionsFactory.hasPermission($scope.permission);
    };

    ///-- group selector
    $scope.loadingDialog = false;

    $scope.moveItemGroup = function () {
      $scope.list = [];
      $scope.loadingDialog = true;
      $schemasFactory
        .getLists()
        .then(function (res) {
          $scope.list = $listsToGroups.createGroups(res.lists, 'groups');
        })
        .then(function () {
          $scope.loadingDialog = false;
          $mdDialog
            .show({
              controller: 'folderSelectorController',
              controllerAs: 'ctrl',
              templateUrl:
                'app/app-utils/components/folder-selector/folder-selector.html',
              locals: {
                list: angular.copy($scope.list),
                item: $scope.data,
              },
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              multiple: true,
            })
            .then(function (groups) {
              $scope.selectedSchema.groups = groups;
            });
        });
    };
  }
})();

'use strict';

var app = angular.module('dashboard');

app.component('schemaListItem', {
  templateUrl: 'app/schemas/components/schema-list-item/schema-list-item.html',
  controllerAs: 'ctrl',
  bindings: {
    schema: '=',
    translation: '<',
  },
  controller: SchemaListItemController,
});

SchemaListItemController.$inject = [
  '$scope',
  '$rootScope',
  '$mdDialog',
  'toastr',
  'translationService',
  'JsonExporterService',
  'SchemasFactory',
];
function SchemaListItemController(
  $scope,
  $rootScope,
  $mdDialog,
  $toastr,
  $translationService,
  $jsonExporterService,
  SchemasFactory
) {
  var vm = this;

  vm.showCreateSchemaDialog = function (ev, schema, copy) {
    $rootScope.$broadcast('showCreateSchemaDialog', schema, copy);
  };

  vm.deleteSchema = function (ev, schema) {
    if (schema.schema_usage > 0 || schema.function_usage > 0) {
      $toastr.info(
        $translationService.getTranslationController(
          'Esquema en uso, no se puede eliminar.',
          'Schema in use, cannot be deleted.',
          'Esquema em uso, não pode ser excluído.'
        )
      );
      return false;
    }
    var confirm = $mdDialog
      .confirm()
      .title(
        $translationService.getTranslationController(
          '¿Elimininar esquema: ',
          'Delete Schema ',
          'Excluir esquema: '
        ) +
          schema.name +
          '?'
      )
      .textContent(
        $translationService.getTranslationController(
          '¡Cuidado!, Esta acción no puede revertirse',
          'Warning!, This action cannot be reverted',
          'Cuidado! Esta ação não pode ser revertida'
        )
      )
      .ariaLabel('Delete-Question')
      .targetEvent(ev)
      .ok(
        $translationService.getTranslationController(
          'Si, Elimínalo',
          'Yes, Delete it',
          'Sim, elimine'
        )
      )
      .cancel(
        $translationService.getTranslationController(
          'Aún no',
          'Not yet',
          'Ainda não'
        )
      );

    $mdDialog.show(confirm).then(
      function () {
        $rootScope.loading = true;
        SchemasFactory.deleteSchema(schema.id)
          .then(function (res) {
            if (res == true) {
              $toastr.info(
                $translationService.getTranslationController(
                  'Esquema eliminado.',
                  'Schema deleted.',
                  'Esquema excluído.'
                )
              );
              //-$scope.getSchemas(); // ToDo, eliminar el esquema de la lista sin llamar al rest

              $rootScope.$broadcast('getSchemas', null);
            } else {
              $toastr.warning(
                $translationService.getTranslationController(
                  'No se ha podido eliminar el esquema.',
                  'The schema could not be deleted.',
                  'O esquema não pôde ser excluído.'
                )
              );
            }
            $rootScope.loading = false;
          })
          .catch(function (err) {
            if (err) {
              if (err.indexOf('because still have lists associated') > 0) {
                $toastr.warning(
                  $translationService.getTranslationController(
                    'No se ha podido eliminar, el esquema tiene listas asociadas.',
                    'Could not be deleted, the schema has associated lists.',
                    'Não foi possível excluir, o esquema tem listas associadas.'
                  )
                );
              } else {
                $toastr.warning(err);
              }
            } else {
              $toastr.warning(
                $translationService.getTranslationController(
                  'No se ha podido eliminar el esquema.',
                  'The schema could not be deleted.',
                  'O esquema não pôde ser excluído.'
                )
              );
            }
            console.log('Error@deleteSchema', err);
            $rootScope.loading = false;
          });
      },
      function () {}
    );
  };

  vm.exportSchema = function (schema) {
    $jsonExporterService.execute(schema, schema.name, 'schema');
  };

  vm.showShareEntityDialog = function (ev, selectedItem) {
    $mdDialog.show({
      controller: 'ShareEntityController',
      templateUrl: 'app/acl/component/dialog-share-entity.html',
      parent: angular.element(document.body),
      clickOutsideToClose: false,
      targetEvent: ev,
      locals: {
        selectedItem: {
          id: selectedItem.id,
          resource: 'schema',
          name: selectedItem.name,
        },
        actions: ['read', 'update', 'delete'],
      },
    });
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('schemaGroupItem', {
  templateUrl:
    'app/schemas/components/schema-group-item/schema-group-item.html',
  controllerAs: 'ctrl',
  bindings: {
    group: '=',
    translation: '<',
    displayItems: '=',
  },
  controller: schemaGroupItemController,
});

schemaGroupItemController.$inject = [
  '$scope',
  '$rootScope',
  'toastr',
  'translationService',
  'JsonExporterService',
];
function schemaGroupItemController(
  $scope,
  $rootScope,
  $toastr,
  $translationService,
  $jsonExporterService
) {
  var vm = this;

  vm.group.subGroup = [];
  for (var key in vm.group) {
    var val = vm.group[key];
    if (key.includes('folder:')) vm.group.subGroup.push(val);
  }

  $scope.$on('displayItems', function (e, display) {
    vm.displayItems = display;
    vm.group.isOpen = display;
    vm.group.subGroup = [];
    for (var key in vm.group) {
      var val = vm.group[key];
      if (key.includes('folder:')) vm.group.subGroup.push(val);
    }
  });

  vm.toggleItems = function () {
    vm.group.isOpen = !vm.group.isOpen;
  };

  vm.showCreateSchemaDialog = function () {
    $rootScope.$broadcast(
      'showCreateSchemaDialog',
      false,
      false,
      vm.group.path
    );
  };

  vm.exportSchemas = function (index) {
    if (!vm.group.items.length) {
      $toastr.info(
        $translationService.getTranslationController(
          'No hay elementos para descargar',
          'There are no items to download',
          'Não há itens para baixar'
        )
      );
    }

    var index = index || 0;

    if (vm.group.items.length > index) {
      var schema = vm.group.items[index];
      var file_name = vm.group.groupName + '__' + schema.name;

      $jsonExporterService
        .execute(schema, file_name, 'schema')
        .then(function () {
          index++;
          vm.exportSchemas(index);
        });
    } else {
      $toastr.success(
        $translationService.getTranslationController(
          'Esquemas descargadas',
          'Schemas downloaded',
          'Schemas baixados'
        )
      );
    }
  };
}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('BulkSchemasImportDialog', BulkSchemasImportDialog);

  BulkSchemasImportDialog.$inject = [
    '$scope',
    '$rootScope',
    '$mdDialog',
    'toastr',
    'translationService',
    'SchemasService',
    'SchemasFactory',
    'PermissionsFactory',
  ];
  function BulkSchemasImportDialog(
    $scope,
    $rootScope,
    $mdDialog,
    $toastr,
    $translationService,
    $schemasService,
    $schemasFactory,
    $permissionsFactory
  ) {
    $translationService.getTranslation($scope, 'schemas');

    var vm = this;
    vm.importedData;
    vm.importedSchemas;

    $scope.$watch(
      'ctrl.importedData',
      function (data) {
        if (data) {
          vm.importedSchemas = data.map(function (schema) {
            try {
              schema = angular.fromJson(schema);
              _validateSchema(schema).then(function (validation) {
                schema.isValid = validation.isValid;
                schema.errorMsg = validation.details;
              });
              schema.properties = $schemasService.parseSchema(schema);
              schema.isValid = 'pending';
            } catch (error) {
              console.error('Error loading schema', error);

              schema.isValid = false;
              schema.errorMsg = 'Invalid Json Schema';
            }

            return schema;
          });
        }
      },
      true
    );

    function _validateSchema(schema) {
      return new Promise(function (resolve) {
        console.log("valid", $schemasService.isValidSchema(schema));

        if (!$schemasService.isValidSchema(schema)) {
          resolve({
            isValid: false,
            details: 'Invalid Json Schema',
          });
        }

        $schemasFactory
          .getSchemaByIdOrName(schema.name)
          .then(function () {
            resolve({
              isValid: false,
              details: 'There are another schema with the same name',
            });
          })
          .catch(function () {
            resolve({ isValid: true, details: '' });
          });
      });
    }

    vm.save = function () {
      if (!_validate()) {
        return;
      }

      $rootScope.loading = true;
      var promises = [];
      vm.importedSchemas.forEach(function (schema) {
        promises.push(_saveSchema(schema));
      });

      Promise.all(promises)
        .then(function () {
          $toastr.info(
            $translationService.getTranslationController(
              'Esquemas creados.',
              'Schemas created.',
              'Esquemas salvos.'
            )
          );

          $rootScope.$broadcast('schemaUpdated');
          $mdDialog.hide();
        })
        .finally(function () {
          $rootScope.loading = true;
        });
    };

    function _saveSchema(schema) {
      var schemaToCreate = {
        id: null,
        schema: angular.toJson(schema.schema),
        name: schema.name,
        description: schema.description,
        type: schema.type,
        icon: schema.icon,
        labelId: '',
        version: 0,
        hash: '',
        use: 'ok',
        schema_references: 0,
        group: schema.group,
        display: schema.display,
      };

      return $schemasFactory
        .createSchema(schemaToCreate)
        .then(function (res) {
          $permissionsFactory.addPermission('schema', res.id, 'all', true);
        })
        .catch(function (error) {
          if (error.indexOf('invalid property types') > 0) {
            $toastr.warning(
              $translationService.getTranslationController(
                'No se ha podido guardar, existen tipos de propiedad inválidos en esquema ',
                'Could not be save, there are invalid property types in schema ',
                'Não foi possível salvar, tipos de propriedade inválidos no esquema '
              ) + schema.name
            );
          } else {
            $toastr.warning(
              $translationService.getTranslationController(
                'No se ha podido guardar el esquema. ',
                'Unable to save the schema. ',
                'O esquema não pôde ser salvado. '
              ) +
              schema.name +
              ' - ' +
              error
            );

            console.log('Error@createSchema', error);
          }
        });
    }

    function _validate() {
      if (!vm.importedSchemas) {
        $toastr.error('No schemas to import');
        return false;
      }

      if (_areThereInvalidSchemas()) {
        $toastr.error('There are invalid schemas');
        return false;
      }

      return true;
    }

    function _areThereInvalidSchemas() {
      return vm.importedSchemas
        .map(function (e) {
          return e.isValid;
        })
        .includes(false);
    }

    vm.cancel = function (ev) {
      var confirm = $mdDialog
        .confirm()
        .multiple(true)
        .title(
          $translationService.getTranslationController(
            '¿Deseas cancelar?',
            'Do you want to cancel?',
            'Você quer cancelar?'
          )
        )
        .textContent(
          $translationService.getTranslationController(
            '¡Todos los cambios se perderán!',
            'All changes will be lost!',
            'Todas as alterações serão perdidas!'
          )
        )
        .ariaLabel('Cancel-Question')
        .targetEvent(ev)
        .ok(
          $translationService.getTranslationController(
            'Abandonar',
            'Leave',
            'Deixar'
          )
        )
        .cancel(
          $translationService.getTranslationController(
            'Cancelar',
            'Cancel',
            'Cancelar'
          )
        );

      $mdDialog.show(confirm).then(function () {
        $mdDialog.cancel();
      });
    };

    vm.validatePermission = function (permission) {
      return $permissionsFactory.hasPermission(permission);
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller("ExecuteDialogController", ExecuteDialogController);

  ExecuteDialogController.$inject = [
    "$scope",
    "$mdDialog",
    "translationService",
    "toastr",
    "FunctionFactory",
    "rule",
    "properties",
  ];
  function ExecuteDialogController(
    $scope,
    $mdDialog,
    $translationService,
    $toastr,
    $functionFactory,
    $rule,
    $properties
  ) {
    $translationService.getTranslation($scope, "rules");

    var vm = this;
    vm.rule = $rule;
    vm.loading = true;
    vm.showsave = $properties ? false : true;

    function _getFunctionByID(id) {
      vm.loading = true;
      return new Promise(function (resolve, reject) {
        $functionFactory
          .getFunctionByID(id)
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            console.log("err", err);
            reject(err);
          });
      });
    }

    _getFunctionByID(vm.rule.id)
      .then(function (res) {
        vm.getExecutions();
        $scope.current_config = angular.copy(res);
        $scope.testing_config = angular.copy(res);
      })
      .then(function () {
        var data = $scope.testing_config.attributes
        if ($properties && Array.isArray($properties) && $properties.length > 0) {
          data = $properties;
        }
        vm.gridOptions = {
          enableGridMenu: false,
          enableCellEditOnFocus: true,
          enableSelectAll: false,
          enableRowSelection: false,
          enableRowHeaderSelection: false,
          columnDefs: [
            {
              displayName: "ID",
              name: "ID",
              field: "id",
              enableColumnMenu: false,
              enableSorting: false,
              enableCellEditOnFocus: true,
              enableHiding: false,
              visible: false,
            },
            {
              displayName: $translationService.getTranslationController(
                "Tipo",
                "DataType",
                "Tipo"
              ),
              name: "DataType",
              field: "type",
              enableColumnMenu: false,
              enableSorting: false,
              enableCellEditOnFocus: true,
              enableHiding: false,
              width: 80,
              editableCellTemplate: "ui-grid/dropdownEditor",
              cellFilter: "mapType",
              editDropdownValueLabel: "type",
              editDropdownOptionsArray: [
                { id: "string", type: "String" },
                { id: "integer", type: "Integer" },
                { id: "double", type: "Double" },
                { id: "long", type: "Long" },
              ],
            },
            {
              displayName: $translationService.getTranslationController(
                "Nombre",
                "Name",
                "Nome"
              ),
              name: "Name",
              field: "name",
              enableColumnMenu: false,
              enableSorting: false,
              enableCellEditOnFocus: true,
              enableHiding: false,
              width: 200,
            },
            {
              displayName: $translationService.getTranslationController(
                "Valor",
                "Value",
                "Valor"
              ),
              name: "Value",
              field: "value",
              enableColumnMenu: false,
              enableSorting: false,
              enableCellEditOnFocus: true,
              enableHiding: false,
            },
            {
              displayName: $translationService.getTranslationController(
                "Descripción",
                "Description",
                "Descrição"
              ),
              name: "Description",
              field: "description",
              enableColumnMenu: false,
              enableSorting: false,
              enableCellEditOnFocus: true,
              enableHiding: false,
            },
          ],
          data: data,
        };
        vm.loading = false;
      })
      .catch(function (error) {
        console.warn("Error@_getFunctionByID", error);
      });

    vm.getExecutions = function () {
      var request = {
        pagination: {
          sortBy: "",
          sort: "DESC",
          page: 1,
          totalRecords: 0,
          itemsPerPage: 1,
        },
      };
      vm.loading = true;
      vm.rule.executions = [];

      $functionFactory
        .getExecutions(vm.rule.id, request)
        .then(function (res) {
          vm.rule.executions = res.data;
          vm.rule.lastStr = moment(vm.rule.executions[0].startTime).calendar();
        })
        .catch(function (err) {
          console.log("Error@getExecutions", err);
        })
        .finally(function () {
          vm.loadExecutions = false;
          vm.loading = false;
        });
    };

    vm.rule.schedule = vm.rule.schedule ? vm.rule.schedule : {};
    vm.loadExecutions = true;

    vm.testExecution = function () {
      if (!vm.rule.typeCheck) {
        $toastr.warning("Typecheck error.");
        return;
      }

      vm.loading = true;
      vm.rule.onProgress = true;
      var testingAtributes = $scope.testing_config.attributes.map(function (
        attr
      ) {
        var value = attr.value;

        if ($properties && Array.isArray($properties) && $properties.length > 0) {
          var _VALUE_ = $properties.find(function (e) {
            return e.name == attr.name;
          }) || false
          if (_VALUE_) value = _VALUE_.value;
        }

        return {
          attributeId: attr.id,
          attributeName: attr.name,
          attributeType: attr.type,
          attributeValue: value,
          attributeDescription: attr.description,
        };
      });

      $functionFactory
        .executeV2(
          vm.rule.id,
          vm.rule.liveVersion,
          JSON.stringify(testingAtributes)
        )
        .then(function () {
          $toastr.success(
            $translationService.getTranslationController(
              "Rule ejecutada",
              "Regla executed",
              "Regra executada"
            )
          );
        })
        .catch(function (error) {
          console.log("Error@execute", error);
          $toastr.warning(
            $translationService.getTranslationController(
              'La regla "' + vm.rule.name + '" no pudo ser ejecutada',
              'The rule "' + vm.rule.name + '" could not be executed',
              'A regra "' + vm.rule.name + '" não pôde ser executada'
            )
          );
          vm.executionError = error.msg
            ? error.msg + "; " + error.errorCode
            : false;
        })
        .finally(function () {
          vm.loading = false;
          vm.rule.onProgress = false;
        });
    };

    function _confirmSaveAtributesConfiguration(ev) {
      var title = $translationService.getTranslationController(
        "Hay cambios en los atributos",
        "There are changes in the attributes",
        "Há mudanças nos atributos"
      );
      var textContent = $translationService.getTranslationController(
        "¿Quieres guardar esta configuración?",
        "Do you want to save this configuration?",
        "Deseja salvar esta configuração?"
      );
      var yes = $translationService.getTranslationController(
        "Si, guarda esta configuracion",
        "yes, save this configuration",
        "Sim, salve esta configuração"
      );
      var no = $translationService.getTranslationController("No", "No", "Não");
      var confirm = $mdDialog
        .confirm()
        .title(title)
        .textContent(textContent)
        .ariaLabel("atributeshasChaged")
        .targetEvent(ev)
        .ok(yes)
        .cancel(no)
        .multiple(true);

      $mdDialog.show(confirm).then(
        function () {
          _applyNewAttributeSettings();
        },
        function () {
          $scope.testing_config = $scope.current_config;
          $mdDialog.cancel();
        }
      );
    }

    function _saveRuleAttrs(config) {
      vm.loading = true;
      return new Promise(function (resolve, reject) {
        var attrs = config.attributes.map(function (e) {
          return {
            attributeId: e.id || null,
            attributeName: e.name,
            attributeType: e.type,
            attributeValue: e.value,
            attributeDescription: e.description,
          };
        });
        $functionFactory
          .saveFunctionAttributes(vm.rule.id, attrs)
          .then(function (res) {
            vm.loading = false;
            resolve(res);
          })
          .catch(function (err) {
            console.error("Error@saveFunctionAttributes", err);
            vm.loading = false;
            $toastr.warning(err);
            reject(err);
          });
      });
    }

    vm.attributesHasChanged = function () {
      var current = JSON.stringify(
        angular.copy($scope.current_config.attributes)
      );
      var testing = JSON.stringify(
        angular.copy($scope.testing_config.attributes)
      );

      return current != testing;
    };

    vm.cancel = function () {
      if (vm.attributesHasChanged()) {
        _confirmSaveAtributesConfiguration();
      } else {
        $mdDialog.cancel();
      }
    };

    vm.save = function () {
      if (vm.attributesHasChanged()) {
        _confirmSaveAtributesConfiguration();
      } else {
        _applyNewAttributeSettings();
      }
    };

    function _applyNewAttributeSettings() {
      if ($scope.testing_config.attributes.length > 0) {
        _saveRuleAttrs($scope.testing_config).then(function () {
          $scope.current_config.attributes = $scope.testing_config.attributes;

          $toastr.success(
            $translationService.getTranslationController(
              "Atributos guardados",
              "Attributes saved",
              "Atributos salvos"
            )
          );
        });
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('assignPivotDialogController', assignPivotDialogController);

  assignPivotDialogController.$inject = [
    '$rootScope',
    '$mdDialog',
    'chartValues',
    'hasGroupby',
    'currentPivot',
    'chartId',
    'schemaFields',
    'toastr',
  ];
  function assignPivotDialogController(
    $rootScope,
    $mdDialog,
    chartValues,
    hasGroupby,
    currentPivot,
    chartId,
    schemaFields,
    toastr
  ) {
    var vm = this;
    vm.schemaFields = schemaFields;
    vm.haspivot = currentPivot ? currentPivot[1] : null;
    vm.hasGroupby = hasGroupby ? hasGroupby : false;
    vm.chartValueSelected = currentPivot ? currentPivot[1] : null;
    vm.field = '';
    vm.value = '';
    vm.pivotFunctionSelected = currentPivot ? currentPivot[0] : null;
    vm.pivotFunctionsOptions = [
      {
        name: 'Valores por porcentaje entre ejes X',
        value: 'xAxisPercentageValueRef',
        option: 'xAxis',
        disabled: false,
      },
      {
        name: 'Diferencia por porcentaje entre eje X',
        value: 'xAxisDiffPercentageValueRef',
        option: 'xAxis',
        disabled: false,
      },
      {
        name: 'Diferencia por porcentaje entre grupos de series',
        value: 'seriesDiffPercentageValueRef',
        option: 'yAxis',
        disabled: !vm.hasGroupby,
      },
      {
        name: 'Valores por porcentaje entre grupos de series',
        value: 'seriesPercentageValueRef',
        option: 'yAxis',
        disabled: !vm.hasGroupby,
      },
      {
        name:
          'Linea constante al 100% usando un campo/valor de la fuente de datos',
        value: 'extraConf',
        option: 'schemaFields',
        disabled: false,
      },
    ];
    vm.$onInit = function () {
      vm.chartValues = { xAxis: null, yAxis: null };
      vm.chartValues.xAxis = chartValues.xAxis;
      vm.chartValues.yAxis = Object.keys(chartValues.yAxis);
    };

    vm.onChangeFunction = function () {
      vm.chartValues.xAxis = chartValues.xAxis;
      vm.chartValues.yAxis = Object.keys(chartValues.yAxis);
    };

    vm.removePivot = function () {
      $rootScope.$broadcast('applyPercentageValue_' + chartId, null);
      $mdDialog.cancel();
    };

    vm.save = function () {
      if (vm.pivotFunctionSelected != null) {
        var pivot = {};
        if (
          vm.pivotFunctionSelected.value == 'extraConf' &&
          vm.field != '' &&
          vm.value != ''
        ) {
          pivot = {
            percentageFilterPivotField: vm.field,
            percentageFilterPivotValue: vm.value,
          };
          $rootScope.$broadcast(
            'applyPercentageValue_' + chartId,
            vm.pivotFunctionSelected.value,
            pivot
          );
          $mdDialog.cancel();
        } else if (vm.chartValueSelected != null) {
          pivot[vm.pivotFunctionSelected.value] = vm.chartValueSelected;
          $rootScope.$broadcast(
            'applyPercentageValue_' + chartId,
            vm.pivotFunctionSelected.value,
            pivot
          );
          $mdDialog.cancel();
        } else {
          toastr.error('Completa el formulario');
        }
      }
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller(
      "RuleManagementDialogController",
      RuleManagementDialogController
    );

  RuleManagementDialogController.$inject = [
    "$scope",
    "$rootScope",
    "$mdDialog",
    "toastr",
    "translationService",
    "uiGridConstants",
    "FunctionFactory",
    "PermissionsFactory",
    "_rule",
    "onUpdate",
    "realtime",
    "groupPath",
    "listsToGroups",
    "SchemasFactory",
  ];
  function RuleManagementDialogController(
    $scope,
    $rootScope,
    $mdDialog,
    toastr,
    $translationService,
    uiGridConstants,
    FunctionFactory,
    PermissionsFactory,
    _rule,
    onUpdate,
    realtime,
    groupPath,
    $listsToGroups,
    $SchemasFactory
  ) {
    $scope.groupPath = groupPath ? groupPath : null;
    $translationService.getTranslation($scope, "rules");
    $scope.cronBuilder;
    $scope.scheduleBuilder;

    var ruleModal = this;
    ruleModal.realtime = realtime || false;
    // console.log("ruleModal", ruleModal.realtime);
    ruleModal.toDelete = [];
    ruleModal.versions = [];
    ruleModal.isSaving = false;
    ruleModal.activeSchedule = false;
    ruleModal.schemas = [];
    ruleModal.schemaItemChange = schemaItemChange;
    ruleModal.querySearchSchema = querySearchSchema;
    ruleModal.applySchemas = false;

    var permission = "function:create";
    // console.log(_rule);
    if (_rule) {
      _getFunctionByName(_rule.name)
        .then(function (res) {
          // console.log("_getFunctionByName",res);
          ruleModal.data = res;
        })
        .then(function () {
          ruleModal.schemaJson = angular.toJson(ruleModal.data, 4);
          // if (ruleModal.data.schedule) {
          //   ruleModal.activeSchedule = true;
          //   var cronExpression =
          //     ruleModal.data.schedule.minute +
          //     ' ' +
          //     ruleModal.data.schedule.hour +
          //     ' ' +
          //     ruleModal.data.schedule.dayOfMonth +
          //     ' ' +
          //     ruleModal.data.schedule.month +
          //     ' ' +
          //     ruleModal.data.schedule.dayOfWeek;
          //   ruleModal.cronString = prettyCron.toString(cronExpression);
          //   ruleModal.cronString =
          //     ruleModal.data.schedule.year == '*'
          //       ? ruleModal.cronString
          //       : ruleModal.cronString + ' in ' + ruleModal.data.schedule.year;
          // } else {

          if (
            !ruleModal.data["schedules"] ||
            !ruleModal.data["schedules"].length
          ) {
            ruleModal.data.schedules = [];
            // ruleModal.cronString = 'Not set';
          }

          // }
          if (ruleModal.data.liveVersion)
            ruleModal.data.liveVersion = Number(ruleModal.data.liveVersion);

          permission = "function#" + ruleModal.data.id + ":update";
          ruleModal.attrSchedule = ruleModal.data.attributes.find(function (e) {
            return e.name == "SCHEDULE";
          });
          getRuleVersions();
        });
    } else {
      ruleModal.data = {
        new: true,
        id: false,
        name: "",
        description: "",
        groups: $scope.groupPath,
        attributes: [],
        schema: null,
      };
    }

    function getRuleVersions() {
      FunctionFactory.getVersions(ruleModal.data.id)
        .then(function (res) {
          if (res.length) {
            ruleModal.versions = res
              .map(function (e) {
                delete e.pipeline;
                return e;
              })
              .sort(function (a, b) {
                return b.id - a.id;
              });
          } else {
            ruleModal.versions = [
              {
                id: "",
                title: $translationService.getTranslationController(
                  "Sin versiones",
                  "Without versions",
                  "Sem versões"
                ),
              },
            ];
          }
        })
        .catch(function (err) {
          console.error("Error@getVersions", err);
        });
    }

    function getSchema() {
      $SchemasFactory
        .getSchemas()
        .then(function (schemas) {
          // console.log(schemas);
          ruleModal.schemas = schemas.data;
        })
        .catch(function (err) {
          console.error("Error@getSchema", err);
        });
    }
    getSchema();

    $scope.$watch(
      "rule.importedData",
      function (nval) {
        if (nval) {
          var importedRule = parseImportedPipeline(nval);
          importedRule.new = true;
          importedRule.id = false;
          importedRule.liveVersion = null;
          if (
            importedRule.hasOwnProperty("name") &&
            importedRule.hasOwnProperty("active") &&
            importedRule.hasOwnProperty("name") &&
            importedRule.hasOwnProperty("description")
          ) {
            importedRule.attributes.forEach(function (item) {
              item.id = false;
            });
            if ($scope.groupPath) importedRule.groups = $scope.groupPath;
            ruleModal.data = importedRule;
          } else {
            toastr.error("Invalid rule JSON");
          }
        }
      },
      true
    );

    function parseImportedPipeline(data) {
      var pipeline = angular.fromJson(data);

      angular.forEach(pipeline, function (value, key) {
        pipeline[key] = recursiveParse(value, key);
      });

      return pipeline;
    }

    function latin1_to_utf8(s) {
      return decodeURIComponent(escape(s));
    }

    function recursiveParse(value) {
      if (typeof value === "string") {
        value = latin1_to_utf8(value);
      }

      if (typeof value === "object") {
        angular.forEach(value, function (object, index) {
          value[index] = recursiveParse(object);
        });
      }

      return value;
    }

    function _getFunctionByName(id) {
      return new Promise(function (resolve, reject) {
        FunctionFactory.getFunctionByName(id)
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            reject(err);
          });
      });
    }

    ruleModal.validatePermission = function () {
      return PermissionsFactory.hasPermission(permission);
    };

    ruleModal.cancel = function () {
      $mdDialog.cancel();
    };

    ruleModal.addAttr = function () {
      ruleModal.data.attributes.push({
        id: false,
        name: "",
        type: "string",
        value: "",
      });
    };

    ruleModal.deleteAttr = function (row) {
      var index = ruleModal.data.attributes.indexOf(row);
      ruleModal.data.attributes.splice(index, 1);
      if (row.id) {
        ruleModal.toDelete.push(row);
      }
    };

    ruleModal.saveRule = function () {
      $rootScope.loading = true;
      ruleModal.isSaving = true;
      var rule = ruleModal.data;

      var toDelete = ruleModal.toDelete
        .map(function (e) {
          return e.id;
        })
        .join(",");

      var saveData = angular.copy(rule);

      saveData.id = saveData.id || null;
      saveData.realtime = saveData.realtime || ruleModal.realtime;

      if (saveData.liveVersion)
        saveData.liveVersion = Number(saveData.liveVersion);

      delete saveData.originalActive;
      delete saveData.origintalAttr;
      delete saveData.filter_icon;
      delete saveData.filters;
      delete saveData.primaryDomainId;
      delete saveData.attributes;
      delete saveData.typeCheck;
      delete saveData.context;

      if (
        typeof saveData.structure === "object" &&
        saveData.structure != null
      ) {
        saveData.structure = angular.toJson(saveData.structure);
      }

      if (saveData.schema && saveData.schema.id)
        saveData.schema = { id: saveData.schema.id };
      else saveData.schema = null;

      FunctionFactory.saveFunction(saveData)
        .then(function (res) {
          // console.log("saveFunction", res);
          rule.id = res.id;
          PermissionsFactory.addPermission("function", rule.id, "all", true);

          if (toDelete.length) {
            ruleModal.deleteAttributes(rule, toDelete);
          } else if (rule.attributes.length) {
            ruleModal.saveAttributes(rule);
          } else {
            toastr.success(
              $translationService.getTranslationController(
                "Regla guardada",
                "Rule saved",
                "Rule salvou"
              )
            );
            $rootScope.$broadcast("onUpdate", rule);
            if (onUpdate) onUpdate({ rule: rule });
            $mdDialog.hide();
          }
        })
        .catch(function (err) {
          ruleModal.isSaving = false;
          toastr.error(
            $translationService.getTranslationController(
              "No se ha podido guardar: ",
              "Could not save: ",
              "Não foi possível salvar: "
            ) + err
          );
          console.error("Error@saveFunction", err);
        })
        .finally(function () {
          $rootScope.loading = false;
        });
    };

    ruleModal.deleteAttributes = function (rule, toDelete, nohide) {
      FunctionFactory.deleteFunctionAttributes(rule.id, toDelete)
        .then(function (res) {
          if (rule.attributes.length) {
            ruleModal.saveAttributes(rule);
          } else {
            if (!nohide) {
              toastr.success(
                $translationService.getTranslationController(
                  "Regla guardada",
                  "Rule saved",
                  "Rule salvou"
                )
              );
            }
            $rootScope.$broadcast("onUpdate", rule);
            if (onUpdate) onUpdate({ rule: rule });
            if (!nohide) {
              $mdDialog.hide();
            }
          }
        })
        .catch(function (err) {
          ruleModal.isSaving = false;
          toastr.warning(err);
          console.error("Error@deleteFunctionAttributes", err);
        });
    };

    ruleModal.saveAttributes = function (rule) {
      var attrs = rule.attributes.map(function (e) {
        return {
          attributeId: e.id || null,
          attributeName: e.name,
          attributeType: e.type,
          attributeValue: e.value,
          attributeDescription: e.description,
        };
      });

      FunctionFactory.saveFunctionAttributes(rule.id, attrs)
        .then(function (res) {
          rule.attributes = res.map(function (e) {
            return {
              id: e.attributeId,
              name: e.attributeName,
              type: e.attributeType,
              value: e.attributeValue,
              description: e.attributeDescription,
            };
          });

          rule.version = rule.attributes.find(function (e) {
            return e.name == "LIVE_VERSION";
          });

          rule.attrSchedule = rule.attributes.find(function (e) {
            return e.name == "SCHEDULE";
          });

          // if (rule.attrSchedule) {
          //   rule.attrSchedule.nowStr = prettyCron.toString(
          //     rule.attrSchedule.value
          //   );
          //   rule.attrSchedule.nextStr = prettyCron.getNext(
          //     rule.attrSchedule.value
          //   );
          // }

          toastr.success(
            $translationService.getTranslationController(
              "Regla guardada",
              "Rule saved",
              "Rule salvou"
            )
          );
          $rootScope.$broadcast("onUpdate", rule);
          if (onUpdate) onUpdate({ rule: rule });
          $mdDialog.hide();
        })
        .catch(function (err) {
          ruleModal.isSaving = false;
          console.error("Error@saveFunctionAttributes", err);
          if (err) toastr.warning(err);
        });
    };

    //- Legacy schedule (toDeprecate)
    ruleModal.cronBuilderCallback = function (expression, id) {
      // console.log("cronBuilderCallback", expression, id);
      var schedule = ruleModal.data.attributes.find(function (e) {
        return e.name == "SCHEDULE";
      });

      if (schedule) {
        schedule.value = expression;
      } else {
        ruleModal.data.attributes.push({
          id: false,
          name: "SCHEDULE",
          value: expression,
          type: "string",
        });
      }

      ruleModal.schedule = ruleModal.data.attributes.find(function (e) {
        return e.name == "SCHEDULE";
      });
      $scope.cronBuilder.close();
    };

    ruleModal.scheduleBuilderCallback = function (schedule, action, index) {
      // console.log(schedule, action, index);
      if (action == "update" && index >= 0)
        ruleModal.data.schedules.splice(index, 1, schedule);
      else ruleModal.data.schedules.push(schedule);
      // console.log(ruleModal.data.schedules);
      $scope.scheduleBuilder.close();
    };

    ruleModal.clearSchedule = function (index) {
      ruleModal.data.schedules.splice(index, 1);
    };

    var allowedTypes = [
      { id: "string", type: "String" },
      { id: "integer", type: "Integer" },
      { id: "double", type: "Double" },
      { id: "long", type: "Long" },
    ];

    ruleModal.gridOptions = {
      enableGridMenu: false,
      enableCellEditOnFocus: true,
      enableSelectAll: false,
      enableRowSelection: false,
      enableRowHeaderSelection: false,
      columnDefs: [
        {
          displayName: "ID",
          name: "ID",
          field: "id",
          sort: {
            direction: uiGridConstants.ASC,
            priority: 1,
          },
          enableColumnMenu: false,
          enableSorting: false,
          enableCellEditOnFocus: true,
          enableHiding: false,
          visible: false,
        },
        {
          displayName: $translationService.getTranslationController(
            "Tipo",
            "DataType",
            "Tipo"
          ),
          name: "DataType",
          field: "type",
          enableColumnMenu: false,
          enableSorting: false,
          enableCellEditOnFocus: true,
          enableHiding: false,
          width: 80,
          editableCellTemplate: "ui-grid/dropdownEditor",
          cellFilter: "mapType",
          editDropdownValueLabel: "type",
          editDropdownOptionsArray: allowedTypes,
        },
        {
          displayName: $translationService.getTranslationController(
            "Nombre",
            "Name",
            "Nome"
          ),
          name: "Name",
          field: "name",
          enableColumnMenu: false,
          enableSorting: false,
          enableCellEditOnFocus: true,
          enableHiding: false,
          width: 200,
        },
        {
          displayName: $translationService.getTranslationController(
            "Valor",
            "Value",
            "Valor"
          ),
          name: "Value",
          field: "value",
          enableColumnMenu: false,
          enableSorting: false,
          enableCellEditOnFocus: true,
          enableHiding: false,
        },
        {
          displayName: $translationService.getTranslationController(
            "Descripción",
            "Description",
            "Descrição"
          ),
          name: "Description",
          field: "description",
          enableColumnMenu: false,
          enableSorting: false,
          enableCellEditOnFocus: true,
          enableHiding: false,
        },
        {
          displayName: "Act",
          name: "Actions",
          field: "edit",
          enableFiltering: false,
          enableSorting: false,
          enableCellEdit: false,
          enableColumnMenu: false,
          width: 45,
          cellTemplate:
            '<div><button type="button" ng-click="grid.appScope.rule.deleteAttr(row.entity)"><md-icon md-font-set="material-icons" aria-label="BTN">delete</md-icon></button></div>',
        },
      ],
      data: "rule.data.attributes",
    };

    $scope.loadingDialog = false;

    ruleModal.moveItemGroup = function () {
      ruleModal.list = [];
      $scope.loadingDialog = true;
      FunctionFactory.getFunctions(realtime)
        .then(function (res) {
          ruleModal.list = $listsToGroups.createGroups(res.data, "groups");
        })
        .then(function () {
          $scope.loadingDialog = false;
          $mdDialog
            .show({
              controller: "folderSelectorController",
              controllerAs: "ctrl",
              templateUrl:
                "app/app-utils/components/folder-selector/folder-selector.html",
              locals: {
                list: angular.copy(ruleModal.list),
                item: ruleModal.data,
              },
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              multiple: true,
            })
            .then(function (groups) {
              ruleModal.data.groups = groups;
            });
        });
      // });
    };

    ruleModal.openSchedule = function (index) {
      var rule = angular.copy(ruleModal.data);
      var schedule = rule.schedules[index] || {};
      var action = schedule ? "update" : "create";
      var form = schedule && schedule["form"] ? schedule["form"] : "{}";

      $scope.scheduleBuilder.open({
        label: "Rule",
        name: rule.name,
        id: rule.id,
        schedule: schedule,
        schedules: rule.schedules,
        action: action,
        index: index,
        form: JSON.parse(form),
      });
    };

    function schemaItemChange(schema) {
      if (!ruleModal.applySchemas) return;
      if (!schema) return;
      console.log("schemaItemChange", ruleModal.applySchemas, schema);

      schema.schema =
        typeof schema.schema === "string"
          ? JSON.parse(schema.schema)
          : schema.schema;
      var _SCHEMA_ = schema.schema.definitions[schema.name].properties;

      // ruleModal.data.attributes = [];
      for (var key in _SCHEMA_) {
        if (Object.hasOwnProperty.call(_SCHEMA_, key)) {
          var col = _SCHEMA_[key];

          var exist = ruleModal.data.attributes.find(function (e) {
            return e.name.toLowerCase() == key.toLowerCase();
          });

          var id = false;
          if (exist) id = exist.id;

          var type =
            allowedTypes
              .map(function (e) {
                return e.id;
              })
              .find(function (e) {
                return e == col.type;
              }) || "string";

          ruleModal.data.attributes.push({
            id: id,
            name: key,
            type: type || "string",
            value: type == "string" ? "" : 0,
            description: "",
          });
        }
      }
      ruleModal.applySchemas = false;
    }

    ruleModal.applySchemasToAttr = function () {
      console.log("applySchemasToAttr");
      ruleModal.applySchemas = true;
      schemaItemChange(ruleModal.data.schema);
      ruleModal.applySchemas = false;
    };

    function querySearchSchema(query) {
      var results = query
        ? ruleModal.schemas.filter(function (s) {
            var lowercaseQuery = query.toLowerCase();
            return s.name.toLowerCase().includes(lowercaseQuery);
          })
        : ruleModal.schemas;
      return results;
    }

    $scope.$watch("rule.data.name", function (newValue) {
      var regex = /[!@#$%^&*()+=\[\]{}|\\';,<>\/?]/g;
      if(newValue)
        ruleModal.data.name = newValue.replace(regex, " ");
    });
  }
})();

"use strict";

var app = angular.module("dashboard");

app.component("ruleListItem", {
  templateUrl: "app/rules/components/rule-list-item/rule-list-item.html",
  controllerAs: "ctrl",
  bindings: {
    rule: "=",
    translation: "<",
  },
  controller: ruleListItemController,
});

ruleListItemController.$inject = [
  "$rootScope",
  "$scope",
  "$mdDialog",
  "toastr",
  "translationService",
  "JsonExporterService",
  "FunctionFactory",
];
function ruleListItemController(
  $rootScope,
  $scope,
  $mdDialog,
  toastr,
  $translationService,
  $jsonExporterService,
  $functionFactory
) {
  var vm = this;

  vm.getRuleEditorURL = function () {
    if (vm.rule.realtime) {
      return "rules/realtime/editor/" + vm.rule.id;
    }
    return "rules/editor/" + vm.rule.id;
  };
  vm.rule.editorUrl = vm.getRuleEditorURL();

  vm.onUpdate = function (rule) {
    vm.rule.description = rule.description;
    vm.rule.name = rule.name;
    vm.rule.realtime = rule.realtime;
    vm.rule.attributes = rule.attributes;
    vm.rule.liveVersion = rule.liveVersion;
    vm.rule = readSchedule(rule);
  };
  vm.onUpdate(vm.rule);

  vm.editRule = function (rule) {
    $rootScope.loading = true;
    $functionFactory
      .saveFunction(rule)
      .then(function (res) {
        var rule = $translationService.getTranslationController(
          "Regla ",
          "Rule ",
          "Rule "
        );
        var ruleIsActive = $translationService.getTranslationController(
          "Activa",
          "Active",
          "Ativo"
        );
        var ruleIsDisabled = $translationService.getTranslationController(
          "Inactiva",
          "Inactive",
          "Inativo"
        );
        var statusRule = res.active ? ruleIsActive : ruleIsDisabled;
        toastr.success(rule + " " + res.name + ": " + statusRule);
      })
      .catch(function (err) {
        toastr.error(
          $translationService.getTranslationController(
            "No se ha podido guardar: ",
            "Could not save: ",
            "Não foi possível salvar: "
          ) + err
        );
        console.error("Error@saveFunction", err);
      })
      .finally(function () {
        $rootScope.loading = false;
      });
  };

  vm.deleteRule = function (rule) {
    var confirm = $mdDialog
      .confirm()
      .title(
        $translationService.getTranslationController(
          "¿Eliminar regla: ",
          "Delete rule ",
          "Excluir regra?"
        ) +
          rule.name +
          "?"
      )
      .textContent(
        $translationService.getTranslationController(
          "¡Cuidado!, Esta acción no puede revertirse.",
          "Atention!, This action can not be reversed.",
          "Atenção!, esta ação não pode ser revertida."
        )
      )
      .ariaLabel("Delete-Question")
      .ok(
        $translationService.getTranslationController(
          "Si, Elimínala",
          "Yes, Delete it",
          "Sim, exclua"
        )
      )
      .cancel(
        $translationService.getTranslationController(
          "Aún no",
          "Not yet",
          "Ainda não"
        )
      );

    $mdDialog.show(confirm).then(
      function () {
        $rootScope.loading = true;
        $functionFactory
          .deleteFunction(rule.id)
          .then(function (res) {
            if (res == true) {
              $rootScope.$broadcast("ruleDeleted", rule);
              toastr.info(
                $translationService.getTranslationController(
                  "Regla eliminada.",
                  "Rule deleted.",
                  "Regra excluída."
                )
              );
              $rootScope.$broadcast("onUpdate", rule);
            } else {
              toastr.info(
                $translationService.getTranslationController(
                  "No se ha podido eliminar la regla.",
                  "The rule could not be deleted.",
                  "A regra não pôde ser excluída."
                )
              );
            }
          })
          .catch(function (err) {
            if (typeof err === "string") {
              toastr.warning(err);
            } else {
              toastr.warning(
                $translationService.getTranslationController(
                  "No se ha podido eliminar.",
                  "The rule could not be deleted.",
                  "A regra não pôde ser excluída."
                )
              );
            }
            console.error("Error@deleteFunction", err);
          })
          .finally(function () {
            $rootScope.loading = false;
          });
      },
      function () {}
    );
  };

  vm.execute = function (rule) {
    $mdDialog.show({
      controller: "ExecuteDialogController",
      controllerAs: "ctrl",
      templateUrl: "app/rules/partials/execute-dialog/execute-dialog.html",
      locals: {
        rule: rule,
        properties:[]
      },
      parent: angular.element(document.body),
      multiple: true,
    });
  };

  vm.stopExecution = function (rule) {
    var confirm = $mdDialog
      .confirm()
      .title("¿Detener ejecución?")
      .textContent("¡Cuidado!, Esta acción no puede revertirse.")
      .ariaLabel("Stop-Execution-Question")
      .ok("Si, Detenerla")
      .cancel("Aún no");

    $mdDialog.show(confirm).then(
      function () {
        // console.log("Detener ejecución", rule);
        $functionFactory
          .stopExecutionV2(rule.id)
          .then(function (res) {
            console.log("ejecución detenida", res);
            $rootScope.$broadcast('onUpdate');
          })
          .catch(function (err) {
            console.error("Error@stopExecution", err);
          });
      },
      function () {}
    );
  };

  /********************************************** Modal Share searcher*******************************************/
  vm.showShareEntityDialog = function (selectedItem) {
    $mdDialog.show({
      controller: "ShareEntityController",
      templateUrl: "app/acl/component/dialog-share-entity.html",
      parent: angular.element(document.body),
      clickOutsideToClose: false,
      locals: {
        selectedItem: {
          id: selectedItem.id,
          resource: "function",
          name: selectedItem.name,
        },
        actions: [
          "read",
          "update",
          "delete",
          "read-pipeline",
          "run",
          "read-runs",
        ],
      },
    });
  };

  function _getFunction(id) {
    return $functionFactory
      .getFunctionByID(id)
      .then(function (res) {
        var functionData = res;

        functionData.structure = angular.fromJson(functionData.structure);
        functionData.context = angular.fromJson(functionData.context);

        $jsonExporterService.execute(functionData, functionData.name, "rule");
      })
      .catch(function (err) {
        console.error("Error@getFunctionByID", err);
      });
  }

  vm.export = function (rule) {
    vm.downloadingRuleAsJson = true;

    _getFunction(rule.id).finally(function () {
      vm.downloadingRuleAsJson = false;
    });
  };

  function readSchedule(rule) {


    if (Array.isArray(rule.schedules) && rule.schedules.length > 0) {
      for (var i = 0; i < rule.schedules.length; i++) {
        
        var _schedule = rule.schedules[i];

        var cronExpression =
          _schedule.minute +
          ' ' +
          _schedule.hour +
          ' ' +
          _schedule.dayOfMonth +
          ' ' +
          _schedule.month +
          ' ' +
          _schedule.dayOfWeek;

        _schedule.cron = prettyCron.toString(cronExpression);
        _schedule.nextExecution = prettyCron.getNext(cronExpression); 
        // console.log(_schedule);
        

      }
      
    }


    return rule;
  }

  vm.onClicked = function () {
    $rootScope.$broadcast('rulePreview',vm.rule);
  }
}

'use strict';

var app = angular.module('dashboard');

app.component('ruleGroupItem', {
  templateUrl: 'app/rules/components/rule-group-item/rule-group-item.html',
  controllerAs: 'ctrl',
  bindings: {
    group: '=',
    translation: '<',
    displayItems: '=',
  },
  controller: ruleGroupItemController,
});

ruleGroupItemController.$inject = [
  '$scope',
  '$mdDialog',
  'toastr',
  'translationService',
  'JsonExporterService',
  'FunctionFactory',
  '$stateParams'
];
function ruleGroupItemController(
  $scope,
  $mdDialog,
  $toastr,
  $translationService,
  $jsonExporterService,
  $functionFactory,
  $stateParams
) {
  var vm = this;

  vm.group.subGroup = [];
  for (var key in vm.group) {
    var val = vm.group[key];
    if (key.includes('folder:')) vm.group.subGroup.push(val);
  }

  $scope.$on('displayItems', function (e, display) {
    vm.group.isOpen = display;
    vm.group.subGroup = [];
    for (var key in vm.group) {
      var val = vm.group[key];
      if (key.includes('folder:')) vm.group.subGroup.push(val);
    }
  });

  vm.toggleItems = function () {
    vm.group.isOpen = !vm.group.isOpen;
  };

  vm.openEditor = function (event) {
    $mdDialog.show({
      multiple: true,
      templateUrl:
        'app/rules/components/rule-management-dialog/rule-management-dialog.html',
      controller: 'RuleManagementDialogController',
      controllerAs: 'rule',
      targetEvent: event,
      locals: {
        _rule: null,
        onUpdate: null,
        realtime: $stateParams.realtime || false,
        groupPath: vm.group.path,
      },
      clickOutsideToClose: false,
      escapeToClose: false,
    });
  };

  vm.exportFunctions = function (index) {
    if (!vm.group.items.length) {
      $toastr.info(
        $translationService.getTranslationController(
          'No hay elementos para descargar',
          'There are no items to download',
          'Não há itens para baixar'
        )
      );
    }

    vm.downloadingRules = true;

    var index = index || 0;

    if (vm.group.items.length > index) {
      var rule = vm.group.items[index];
      var file_name = vm.group.groupName + '__' + rule.name;

      _getFunction(rule.id)
        .then(function (rule) {
          $jsonExporterService
            .execute(rule, file_name, 'rule')
            .then(function () {
              index++;
              vm.exportFunctions(index);
            });
        })
        .catch(function () {
          vm.downloadingRules = false;
        });
    } else {
      vm.downloadingRules = false;
      $toastr.success(
        $translationService.getTranslationController(
          'Reglas descargadas',
          'Rules downloaded',
          'Regras baixadas'
        )
      );
    }
  };

  function _getFunction(id) {
    return $functionFactory
      .getFunctionByID(id)
      .then(function (res) {
        var functionData = res;
        functionData.structure = angular.fromJson(functionData.structure);
        functionData.context = angular.fromJson(functionData.context);

        return functionData;
      })
      .catch(function (err) {
        console.log('Error@getFunctionByID', err);
      });
  }
}

'use strict';

var app = angular.module('dashboard');

app.component('transformationsBar', {
  templateUrl:
    'app/rule-editor/components/transformations-bar/transformations-bar.html',
  controllerAs: 'ctrl',
  bindings: {
    translation: '<',
    realtime: '<',
    clicked: '=',
    selectedTool: '=',
  },
  controller: TransformationsBarController,
});

TransformationsBarController.$inject = [
  '$scope',
  'FunctionFactory',
  'transformationsService',
];
function TransformationsBarController(
  $scope,
  $functionFactory,
  $transformationsService
) {
  var vm = this;
  vm.tabs = {
    inputs: false,
    transformations: false,
    outputs: false,
    configParams: false,
  };
  vm.showCode = false;
  vm.displayToolsBox = false;

  vm.$onInit = function () {
    _getTransformations();
  };

  function _getTransformations() {
    $functionFactory
      .getTransformations({ realtime: vm.realtime })
      .then(function (res) {
        vm.transformations = res;
        vm.configParams = vm.transformations.filter(function (e) {
          return e.defaultInputs == 0 && e.defaultOutputs == 0;
        });
        vm.inputs = vm.transformations.filter(function (e) {
          return e.defaultInputs < 1 && e.defaultOutputs > 0;
        });
        vm.transforms = vm.transformations.filter(function (e) {
          return e.defaultInputs > 0 && e.defaultOutputs > 0;
        });
        vm.outputs = vm.transformations.filter(function (e) {
          return e.defaultOutputs < 1 && e.defaultInputs > 0;
        });
      })
      .catch(function (err) {
        console.log('Error@getTransformations', err);
      });
  }

  vm.onClickTab = function (tab) {
    if (tab == 'inputs') {
      vm.tabs.inputs = !vm.tabs.inputs;
      vm.tabs.transformations = false;
      vm.tabs.outputs = false;
      vm.tabs.configParams = false;
    } else if (tab == 'transforms') {
      vm.tabs.inputs = false;
      vm.tabs.transformations = !vm.tabs.transformations;
      vm.tabs.outputs = false;
      vm.tabs.configParams = false;
    } else if (tab == 'outputs') {
      vm.tabs.inputs = false;
      vm.tabs.transformations = false;
      vm.tabs.outputs = !vm.tabs.outputs;
      vm.tabs.configParams = false;
    } else if (tab == 'configParams') {
      vm.tabs.inputs = false;
      vm.tabs.transformations = false;
      vm.tabs.outputs = false;
      vm.tabs.configParams = !vm.tabs.configParams;
    }
  };

  vm.onClickTool = function (
    clsName,
    label,
    tool,
    startpoints,
    endpoints,
    contenteditable
  ) {
    var params = vm.transformations.filter(function (e) {
      return e.name == tool;
    });
    var _params = angular.copy(params[0].parameters);
    var _schema = angular.copy(params[0].parameters);
    var _types = {};

    angular.forEach(_params, function (item, key) {
      if (typeof item == 'object') {
        angular.forEach(item, function (_item, _key) {
          item[_key] = '';
        }); // Limpiar parametros
        _types[key] = 'table';
        _params[key] = item;
      } else if (item.indexOf('[') === 0) {
        _types[key] = 'list';
        _params[key] = [];
      } else if (item.indexOf('<') === 0) {
        _types[key] = 'map';
        _params[key] = {};
      } else {
        _types[key] = _params[key];
        _params[key] = null;
      }
    });

    vm.selectedTool = $transformationsService.loadProperties(
      clsName,
      label,
      tool,
      startpoints,
      endpoints,
      contenteditable,
      params[0].nameId,
      _schema,
      _params,
      _types,
      params[0].parametersOptionalValues
    );

    vm.clicked = true;
  };

  vm.toggleBoxTransformsTools = function () {
    vm.displayToolsBox = !vm.displayToolsBox;
  };

  $scope.$watch('ctrl.searchtext', function (nval) {
    if (nval) {
      vm.searched = vm.transformations
        .filter(function (e) {
          return (
            angular.lowercase(e.name).indexOf(angular.lowercase(nval)) > -1
          );
        })
        .slice(0, 6);
    } else {
      vm.searched = [];
    }
  });
}

"use strict";

var app = angular.module('dashboard');

app.component('transformTool', {
    templateUrl: 'app/rule-editor/components/transform-tool/transform-tool.html',
    controllerAs: 'ctrl',
    bindings: {props:'<',type:'@'},
    controller: transformToolController,
});

transformToolController.$inject = ['$scope'];
function transformToolController($scope) {
    var vm = this;
    vm.$onInit = function () {};
}

'use strict';

var app = angular.module('dashboard');

app.component('transformBox', {
  templateUrl: 'app/rule-editor/components/transform-box/transform-box.html',
  controller: transformBoxController,
  bindings: {
    time: '<',
    label: '@',
    debug: '@',
    processDisabled: '@',
    state: '@',
    showStats: '<',
    onProgress: '<',
    isRunning: '<',
    clickHandler: '<',
    dblClickHandler: '<',
    ctrlClickHandler: '<',
  },
});

transformBoxController.$inject = ['$scope', '$element'];
function transformBoxController($scope, elem) {
  var vm = this;
  vm.$postLink = function () {
    elem.click(function (event) {
      if (!vm.onProgress) {
        $('.window').removeClass('active success failed');
        if (event.metaKey || event.altKey) {
          vm.ctrlClickHandler(elem.attr('id'), elem.attr('data-id'));
        } else {
          elem.addClass('active');
          vm.clickHandler(elem.attr('data-id'));
        }
      }
    });
    elem.dblclick(function (event) {
      if (!vm.onProgress && !event.metaKey && !event.altKey) {
        vm.dblClickHandler();
      }
    });
  };

  vm.$onChanges = function (changes) {
    if (changes.state) {
      elem.removeClass('active success failed idle').addClass(vm.state);
    }
    if (changes.time) {
      if (!isNaN(vm.time)) {
        var timeScale =
          vm.time > 60000 ? 'min.' : vm.time > 1000 ? 'sec.' : 'ms.';
        vm.time =
          vm.time > 60000
            ? vm.time / 60000
            : vm.time > 1000
            ? vm.time / 1000
            : vm.time;
        vm.timeLabel = vm.time.toFixed(2) + timeScale;
      }
    }
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('ruleTerminal', {
  templateUrl: 'app/rule-editor/components/terminal/terminal.html',
  controllerAs: 'ctrl',
  bindings: {
    translation: '<',
    api: '=?',
    consoleLog: '<',
    selectedTransform: '<',
    context: '<',
    selectedContext: '<',
    overallBench: '<',
    overallBenchLabels: '<',
    executionOutput: '<',
  },
  controller: ruleTerminalController,
});

ruleTerminalController.$inject = ['$scope'];
function ruleTerminalController($scope) {
  var vm = this;
  vm.showConsole = false;
  vm.debugOutput = [];
  vm.api = {};

  vm.api.toggle = function () {
    vm.showConsole = !vm.showConsole;
  };

  vm.api.open = function () {
    vm.showConsole = true;
  };

  $scope.$watch('ctrl.selectedTransform', function (nval) {
    if (nval) {
      vm.debugOutput = processDebbuggerOutput(nval.id);
    }
  });

  /**
   * Process the debug output
   * @param {object} transformation selected transformation
   */
  function processDebbuggerOutput(transformation) {
    var debugOutputTuples = [];
    var id = transformation;

    if (vm.executionOutput[id] && vm.executionOutput[id].debugOutputTuples) {
      debugOutputTuples = vm.executionOutput[id].debugOutputTuples;
    }
    return debugOutputTuples;
  }
}

"use strict";

var app = angular.module("dashboard");

app.component("ruleSchemaBar", {
  templateUrl: "app/rule-editor/components/schema-bar/rule-schema-bar.html",
  controllerAs: "ctrl",
  bindings: {
    translation: "<",
    connName: "<",
    connOutputSchema: "<",
    api: "=?",
  },
  controller: ruleSchemaBarController,
});

ruleSchemaBarController.$inject = [
  "$scope",
  "$mdSidenav",
  "$mdDialog",
  "$timeout",
  "SchemasFactory",
  "SelectedSchema",
];
function ruleSchemaBarController(
  $scope,
  $mdSidenav,
  $mdDialog,
  $timeout,
  $schemasFactory,
  SelectedSchema
) {
  var vm = this;
  vm.tableData = [];

  vm.isOpened = false;
  vm.api = {
    toggle: function () {
      $mdSidenav("rule-schema-bar")
        .toggle()
        .then(function () {
          vm.isOpened = !vm.isOpened;
        });
    },
    close: function () {
      $mdSidenav("rule-schema-bar")
        .close()
        .then(function () {
          vm.isOpened = false;
        });
    },
  };

  vm.$onInit = function () {
    _getSchemas();
  };

  function _getSchemas() {
    $schemasFactory
      .getSchemas()
      .then(function (res) {
        vm.schemasList = res;
        vm.schemasList.data = vm.schemasList.data.map(function (e) {
          e.schema = angular.fromJson(e.schema);
          if (typeof e.schema.definitions === "string") {
            e.schema.definitions = angular.fromJson(e.schema.definitions);
            e.schema.definitions[e.name].properties = angular.fromJson(
              e.schema.definitions[e.name].properties
            );
          }
          return e;
        });
      })
      .catch(function (err) {
        console.log("Error@getSchemas@RuleSchemaBar", err);
      });
  }

  vm.createSchema = function (ev) {
    var schemaToCreate = vm.tableData
      .filter(function (e) {
        return e.$$treeLevel === 0;
      })
      .map(function (e) {
        return { key: e.key, value: e.value };
      });

    // SelectedSchema.setSchema(schemaToCreate);
    SelectedSchema.setNewRuleSchema(schemaToCreate);
    $mdDialog
      .show({
        controller: "HotCreateSchemasController",
        controllerAs: "ctrl",
        templateUrl:
          "app/schemas/partials/hot-create-schema/hot-dialog-create-schemas.html",
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        locals: {
          complexSchemas: vm.schemasList.data
            .filter(function (e) {
              return e.type == "COMPLEX";
            })
            .map(function (e) {
              return { id: e.id, name: e.name };
            }),
          groupPath: null,
        },
      })
      .then(function () {
        vm.renderGrid();
      });
  };

  vm.$onChanges = function () {
    vm.renderGrid();
  };

  function _buildSchemaWithNestedProperties(properties, treeLevel) {
    var data = [];
    angular.forEach(properties, function (val, key) {
      if (val.type == "list") {
        var nestedProperties = _buildSchemaWithNestedProperties(
          val.list.tuple,
          treeLevel + 1
        );

        data.push({
          key: key,
          value: val.type,
          $$treeLevel: treeLevel,
          __children: nestedProperties,
        });
      } else {
        data.push({
          key: key,
          value: val.type,
          $$treeLevel: treeLevel,
        });
      }
    });

    return data;
  }

  vm.renderGrid = function () {
    var dataFromSchema = [];
    if (vm.connOutputSchema) {
      var keys = Object.keys(vm.connOutputSchema.schemaDefinition.definitions);
      var properties =
        vm.connOutputSchema.schemaDefinition.definitions[keys[0]].properties;

      dataFromSchema = _buildSchemaWithNestedProperties(properties, 0);
    }

    // dataFromSchema = dataFromSchema.map(function (e) {
    //   e.key = e.key;
    //   e.value = e.value;
    //   return e;
    // });
    vm.tableData = dataFromSchema;
  };

  $scope.$watchCollection("ctrl.connOutputSchema", function () {
    vm.inTransit = false;
    $timeout(function () {
      vm.inTransit = true;
    }, 600);
  });

  // Table options
  vm.tableColumns = [
    {
      type: "text",
      className: "rule-pipeline-schema-cell",
      data: "key",
      title: "Key",
      readOnly: true,
      renderer: "html",
    },
    {
      type: "text",
      className: "rule-pipeline-schema-cell",
      data: "value",
      title: "Value",
      readOnly: true,
      renderer: "html",
    },
  ];

  vm.tableSettings = {
    licenseKey: "non-commercial-and-evaluation",
    stretchH: "all",
    renderAllRows: false,
    width: "100%",
    colWidths: 100,
    colHeaders: true,
    rowHeaders: true,
    manualColumnResize: true,
    manualRowResize: true,
    persistentState: false,
    columnSorting: true,
    columnHeaderHeight: 15,
    outsideClickDeselects: false,
    nestedRows: true,
    className: "htCenter",
  };
  // End Table options
}

"use strict";

var app = angular.module('dashboard');

app.component('rulesToolbar', {
  templateUrl: 'app/rule-editor/components/rules-toolbar/rules-toolbar.html',
  controllerAs: 'ctrl',
  bindings: {
    translation: '<',
    hasError: '<',
    isChecking: '<',
    isChanged: '<',
    onProgress: '<',
    isRunning: '<',
    isDarkMode: '<',
    executionState: '=',
    realtime:'<',
    loading: '<',
  },
  controller: RulesToolbarController,
});

RulesToolbarController.$inject = ['$scope','$rootScope','$localStorageService','PermissionsFactory'];
function RulesToolbarController($scope,$rootScope,$localStorageService,PermissionsFactory) { 
  var vm = this;
  vm.showCode = false;
  vm.zoom = $scope.$parent.ruleEditor.zoom;
  vm.buildPipeline = $scope.$parent.ruleEditor.buildPipeline;
  vm.saveFlowchart = $scope.$parent.ruleEditor.saveFlowchart;
  vm.loadFlowchart = $scope.$parent.ruleEditor.loadFlowchart;
  vm.showProperties = $scope.$parent.showProperties;
  vm.clear = $scope.$parent.ruleEditor.clear;
  vm.execute = $scope.$parent.ruleEditor.execute;
  vm.stopExecution = $scope.$parent.ruleEditor.stopExecution;
  vm.current_mode = vm.isDarkMode

  vm.onToogleView = function() {
    vm.showCode = !vm.showCode;
    $scope.$parent.showCode = !$scope.$parent.showCode;
  }

  vm.toggleTerminal = function(){
    $scope.$parent.ruleEditor.terminal.toggle();
  }

  vm.toggleDarkenMode = function(){
    $scope.$parent.ruleEditor.toggleDarkMode()
  }
  
  vm.test = function(){
    $scope.$parent.ruleEditor.test();
  }
  
  vm.validatePermission = function (permission) {
    if(!angular.isDefined($scope.$parent.ruleEditor.functionData)) {
      return false;
    }
    return PermissionsFactory.hasPermission('function#' + $scope.$parent.ruleEditor.functionData.id + ':' + permission);
  }
}

"use strict";

var app = angular.module('dashboard');

app.component('ruleTimerWidget', {
    templateUrl: 'app/rule-editor/components/rule-timer-widget/rule-timer-widget.html',
    controllerAs: 'ctrl',
    bindings: {
    	title: "@",
        value: "@",
        label: "@"
    },
    controller: ruleTimerWidgetController,
});

ruleTimerWidgetController.$inject = ['$scope', '$interval'];
function ruleTimerWidgetController($scope, $interval) {
	var vm = this;
    vm.counter = 0; vm.count = 0;
    vm.$onChanges = function () { 
        vm.counter = 0; vm.count = 0;
        
        vm.timeout = 600;
        vm.steps = (vm.value * 20) / vm.timeout;

        if(vm.interval) $interval.cancel(vm.interval);
        if(vm.value > 0){
            vm.interval = $interval(function () {
                vm.counter += vm.steps;
                vm.count = vm.counter / 1000;
                if(vm.counter >= vm.value) {
                    vm.count = vm.value / 1000;
                    $interval.cancel(vm.interval);
                }
            }, 20);
        }
    };
}

"use strict";

var app = angular.module('dashboard');

app.component('ruleCounterWidget', {
    templateUrl: 'app/rule-editor/components/rule-counter-widget/rule-counter-widget.html',
    controllerAs: 'ctrl',
    bindings: {
    	title: "@",
        value: "@",
        label: "@",
        symbol: "@"
    },
    controller: ruleCounterWidgetController,
});

ruleCounterWidgetController.$inject = ['$scope', '$interval'];
function ruleCounterWidgetController($scope, $interval) {
	var vm = this;
    vm.counter = 0; vm.count = 0;
    vm.$onChanges = function () { 
        vm.counter = 0; vm.count = 0;
        
        vm.timeout = 600;
        vm.steps = (vm.value * 20) / vm.timeout;

        if(vm.interval) $interval.cancel(vm.interval);
        if(vm.value > 0){
            vm.interval = $interval(function () {
                vm.counter += vm.steps;
                vm.count = vm.counter.toFixed(0);
                if(vm.counter >= vm.value) {
                    vm.count = vm.value;
                    $interval.cancel(vm.interval);
                }
            }, 20);
        }
    };
}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('QueriesDialogController', QueriesDialogController)

  QueriesDialogController.$inject = ['$scope', '$mdDialog', 'translationService', 'queries'];
  function QueriesDialogController($scope, $mdDialog, $translationService, queries) {
    $translationService.getTranslation($scope, 'predicates');
    var vm = this;
    vm.parameters = queries;
    vm.loading = true

    setTimeout(function () {
      vm.loading = false
    }, 500);

    vm.cancel = function () {
      $mdDialog.cancel();
    }

    vm.save = function () {
      $mdDialog.hide(vm.parameters[0]);
    }

    vm.addQuery = function () {
      vm.parameters[0].push("");
    }
  }
})();
/* Templates for rule-editor props-bar inputs */

(function () {
  'use strict';

  angular.module('dashboard').service('rulePropsService', rulePropsService);

  rulePropsService.$inject = [];
  function rulePropsService() {
    this.getFieldBy = function (type, key, optValues) {
      // Predicate
      if (type == 'predicate') {
        return $(
          '' +
          '<md-input-container class="w100" style="margin-botton:0px;">' +
          ' <label> {{key}} - {{type}} </label>' +
          ' <input type="text" ng-model="parameter" ng-change="isChanged = true" ng-click="predicateEditor($event, key)" readonly>' +
          ' <md-button class="md-icon-button p0 m0 input-sufix" ng-click="predicateEditor($event, key)" aria-label="Predicate editor button">' +
          '   <md-tooltip md-direction="left"> Predicate builder</md-tooltip>' +
          '   <md-icon md-font-set="material-icons"> account_tree</md-icon>' +
          ' </md-button>' +
          '</md-input-container>'
        );
      }

      // String - normal
      if (type == 'string' && key != 'password' && !optValues) {
        return $(
          '' +
          '<div class="rule-prop">' +
          '  <label> {{key}} <small> {{type}} </small></label>' +
          '  <input type="text" ng-model="parameter" ng-change="isChanged = true">' +
          '</div>'
        );
      }

      // String - password
      if (type == 'string' && key == 'password' && !optValues) {
        return $(
          '' +
          '<div class="rule-prop">' +
          '   <label> {{key}} <small> {{type}} </small></label>' +
          '   <input type="{{passInputType}}" ng-model="parameter" ng-change="isChanged = true" autocomplete="off">' +
          '   <md-icon class="p0 m0 input-sufix" ng-click="changePassVisibility()">  {{passVisibility? "visibility":"visibility_off"}}' +
          '     <md-tooltip md-direction="left"> Password visibility </md-tooltip>' +
          '   </md-icon>' +
          '</div>'
        );
      }

      //- optValues - autocomplete (deprecated by searchable select)
      // if(['string', 'integer', 'double', 'long'].includes(type) && optValues){
      //   return $(''+
      //     '<div class="w100">'+
      //     '<md-autocomplete'+
      //     '  md-selected-item="autocompleteInitialValue"'+
      //     '  md-require-match="true"'+
      //     '  md-floating-label="{{key}} - {{type}}"'+
      //     '  md-search-text="searchText"'+
      //     '  md-items="item in querySearch(searchText)"'+
      //     '  md-item-text="item.label"'+
      //     '  md-min-length="0"'+
      //     '  md-clear-button="true"'+
      //     '  md-dropdown-position="bottom"'+
      //     '  md-selected-item-change="parameter = item.value"'+
      //     '>'+
      //     ' <md-item-template>'+
      //     '  <span md-highlight-text="searchText" md-highlight-flags="^i">'+
      //     '    {{item.label}}'+
      //     '  </span>'+
      //     ' </md-item-template>'+
      //     '</md-autocomplete>'+
      //     '</div>')
      // }

      //- optValues - select
      if (['string', 'integer', 'double', 'long'].includes(type) && optValues) {
        return $(
          '' +
          '<div class="rule-prop">' +
          ' <label> {{key}} <small> {{type}} </small></label>' +
          ' <md-select class="w100" ng-model="parameter" ng-change="isChanged=true; processOptValues(optValues);" md-on-close="clearSearchTerm()" placeholder=" " aria-label="{{key}} value selector">' +
          '   <md-select-header class="opt-value-parameter-selector-header">' +
          '     <input ng-model="searchTerm" type="search" placeholder="Search value..." class="opt-value-parameter-selector-searcher" demo-header-searchbox md-text"></input>' +
          '   </md-select-header>' +
          '   <md-option ng-value="item.value" ng-repeat="item in optValues | filter:searchTerm"> {{item.label}}</md-option>' +
          ' </md-select>' +
          '</div>'
        );
      }

      //- Date
      if (type == 'date') {
        return $(
          '' +
          '<div class="rule-prop">' +
          '  <label> {{key}} <small> {{type}} </small> </label>' +
          '  <md-datepicker ng-model="parameter" app-datetime md-placeholder="" md-hide-icons="calendar" autocomplete="nope" style="width:100%;">' +
          '</div>'
        );
      }

      //- URL
      if (type == 'url') {
        return $(
          '' +
          '<div class="rule-prop">' +
          '  <label> {{key}} <small> {{type}} </small> </label>' +
          '  <input type="text" ng-model="parameter" ng-change="isChanged = true">' +
          '</div>'
        );
      }

      //- Number (int) (dbl)
      if (
        (type == 'integer' || type == 'double' || type == 'long') &&
        key != 'outputs'
      ) {
        return $(
          '' +
          '<div class="rule-prop">' +
          '  <label> {{key}} <small> {{type}} </small> </label>' +
          '  <input type="text" ng-model="parameter" ng-change="isChanged = true">' +
          '</div>'
        );
      }

      //- Boolean
      if (type == 'boolean') {
        return $(
          '' +
          '<div class="rule-prop">' +
          '  <label> {{key}} <small> {{type}} </small></label>' +
          '  <md-switch ng-model="parameter" aria-label="{{key}}" ng-change="isChanged = true">' +
          '    {{ parameter ? "true" : "false" }}' +
          '  </md-switch>' +
          '</div>'
        );
      }
      // Enter , Space, Tab, Comma
      //- List
      if (type == 'list' && key != 'queries') {
        
        return $(
          '' +
          '<div class="rule-prop">' +
          '  <label> {{key}} <small> {{type}} </small> </label>' +
          '  <md-chips class="wrap-chips" ng-change="onAddChip(key, type)" ng-model="parameter" md-enable-chip-edit="true" md-add-on-blur="true" input-aria-label="key" ng-change="isChanged = true" md-separator-keys="[13, 32, 9, 188]">' +
          '</div>'
        );
      }

      //- QueriesBuilder - List => HIGH COUPLING
      if (type == 'list' && key == 'queries') {
        return $(
          '' +
          '<div class="rule-prop">' +
          '  <label> {{key}} <small> {{type}} </small>  </label>' +
          '  <input type="text" ng-model="parameter" ng-change="isChanged = true" ng-click="queriesBuilder($event, key)" readonly>' +
          '  <md-button class="md-icon-button p0 m0 input-sufix" ng-click="queriesBuilder($event, key)" aria-label="Queries builder button">' +
          '    <md-tooltip md-direction="left"> Queries builder </md-tooltip>' +
          '    <md-icon md-font-set="material-icons"> usb </md-icon>' +
          '  </md-button>' +
          '</div>'
        );
      }

      //- Map Table
      if (type == 'map') {
        return $(
          '' +
          '<div class="rule-prop fl-column">' +
          '  <label > {{key}} <small> Map </small> </label>' +
          '  <div><div ui-grid="gridOptions" ui-grid-edit ui-grid-cellnav ui-grid-selection ui-grid-resize-columns class="myGrid font-monospace"></div></div>' +
          '</div>'
        );
      }

      //- Table
      if (type == 'table') {
        return $(
          '' +
          '<div class="rule-prop fl-column">' +
          '  <label> {{key}} <small> Table </small> </label>' +
          '  <div><div ui-grid="gridOptions" ui-grid-edit ui-grid-cellnav ui-grid-selection ui-grid-resize-columns class="myGrid font-monospace"></div></div>' +
          '</div>'
        );
      }

      return '<label>Undefined {{key}} <small> {{type}} </small></label>';
    };
  }
})();

/**
 * Rule props bar - props builder
 */

"use strict";

angular
  .module("dashboard")
  .directive("rulePropsBuilder", RulePropsBuilderController);

RulePropsBuilderController.$inject = [
  "$rootScope",
  "$compile",
  "$mdDialog",
  "toastr",
  "translationService",
  "rulePropsService",
];
function RulePropsBuilderController(
  $rootScope,
  $compile,
  $mdDialog,
  toastr,
  $translationService,
  rulePropsService
) {
  return {
    scope: {
      key: "=",
      parameter: "=",
      type: "=",
      optValues: "=",
      defaultSchema: "=",
      inputSchemas: "=",
      outputSchemas: "=",
      onUpdateOptValues: "<",
      isChanged: "=?",
    },
    restrict: "A",
    link: function (scope, elem) {
      scope.$watch("parameter", function () {
        scope.gridOptions = {};

        if (scope.type == "table") {
          gridOptionsBuilder();
        }

        // Initial value for autocomplete
        scope.autocompleteInitialValue = autocompleteInitialValue(
          scope.parameter
        );

        var param = rulePropsService.getFieldBy(
          scope.type,
          scope.key,
          scope.optValues
        );

        elem.replaceWith($compile(param)(scope));

        param
          .find(".opt-value-parameter-selector-searcher")
          .on("keydown", function (ev) {
            ev.stopPropagation();
          });
        param
          .find(".opt-value-parameter-selector-searcher")
          .on("click", function (ev) {
            ev.stopPropagation();
          });

        if (scope.parameter) {
          scope.processOptValues();
        }
      });

      /**
       * Searchable selector handler
       */
      scope.clearSearchTerm = function () {
        scope.searchTerm = "";
      };

      /**
       * Autocomplete field handle
       */
      function autocompleteInitialValue(value) {
        if (scope.optValues)
          return scope.optValues.find(function (e) {
            return e.value == value;
          });
        return null;
      }

      scope.querySearch = function (query) {
        var results = query
            ? scope.optValues.filter(createFilterFor(query))
            : scope.optValues,
          deferred;
        return results;
      };

      function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(array) {
          return array.label.toLowerCase().indexOf(lowercaseQuery) > -1;
        };
      }

      /**
       * Grid field handle
       */
      function gridOptionsBuilder() {
        scope.gridOptions = {
          showHeader: true,
          enableGridMenu: true,
          enableCellEditOnFocus: true,
          enableSelectAll: false,
          enableRowSelection: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          columnDefs: [],
          gridMenuShowHideColumns: false,
          onRegisterApi: function (gridApi) {
            scope.gridApi = gridApi;
            gridApi.edit.on.afterCellEdit(
              scope,
              function (rowEntity, colDef, newValue, oldValue) {
                if (newValue != oldValue) {
                  scope.isChanged = true;
                }
              }
            );
          },
        };

        var props = {};
        angular.forEach(scope.defaultSchema, function (colType, colName) {
          scope.gridOptions.columnDefs.push({
            displayName: colName,
            name: colName,
            field: colName,
            enableColumnMenu: false,
            enableSorting: false,
            enableHiding: false,
            cellTooltip: function (row, col) {
              if (colName == "type") return row.entity["type"];
              else return row.entity["new-column"];
            },
          });
          props[colName] = "";
        });

        scope.gridOptions.columnDefs.push({
          displayName: "Del",
          name: "Delete",
          enableFiltering: false,
          enableSorting: false,
          enableCellEdit: false,
          enableColumnMenu: false,
          cellTemplate:
            '<button type="button" ng-click="grid.appScope.deleteRow(row.entity);"><md-icon md-font-set="material-icons" aria-label="BTN">delete</md-icon></button>',
          cellClass: "schema-cell-content",
          width: 42,
          cellTooltip: function (row, col) {
            return "Del";
          },
        });

        scope.gridOptions.defaultSchema = angular.copy(props);
        scope.gridOptions.gridMenuCustomItems = [
          {
            title: $translationService.getTranslationController(
              "Agregar Fila",
              "Add Row",
              "Adicionar linha"
            ),
            action: function ($event) {
              scope.gridOptions.data.push(
                angular.copy(scope.gridOptions.defaultSchema)
              );
            },
            order: 0,
          },
          {
            title: $translationService.getTranslationController(
              "Expandir",
              "Expand",
              "Expand"
            ),
            action: function ($event) {
              if (!scope.tableExpanded) {
                scope.hotExpandTable($event);
              } else {
                toastr.info("Already expanded");
              }
            },
            order: 1,
          },
        ];

        scope.parameter = scope.parameter.length
          ? scope.parameter
          : (scope.parameter = [angular.copy(props)]);
        scope.gridOptions.data = scope.parameter;
        var columCount = scope.gridOptions.data.length;
        for (var i = columCount; i < 4; i++) {
          scope.gridOptions.data.push(angular.copy(props));
        }
      }

      function setTransformationConnections() {
        return new Promise(function (resolve) {
          scope.inputSchemas = [];
          scope.outputSchemas = [];
          if (scope.parameter) {
            var values = scope.optValues.find(function (e) {
              return e.value == scope.parameter;
            });
            if (values) {
              if (values["dynamic-inputs"]) {
                scope.inputSchemas = new Array(values["dynamic-inputs"]).fill(
                  {}
                );
              }
              if (values["dynamic-outputs"]) {
                scope.outputSchemas = new Array(values["dynamic-outputs"]).fill(
                  {}
                );
              }
            }
          }

          resolve(true);
        });
      }

      scope.processOptValues = function () {
        if (scope.optValues) {
          if (
            scope.optValues[0]["dynamic-inputs"] ||
            scope.optValues[0]["dynamic-outputs"]
          ) {
            setTransformationConnections().then(function () {
              setTimeout(function () {
                $rootScope.$broadcast("buildPipeline");
                console.log("buildPipeline");
              }, 200);
            });
          }
          scope.optValues
            .filter(function (e) {
              return e.value == scope.parameter;
            })
            .forEach(function (e) {
              angular.forEach(e, function (item, key) {
                if (typeof item === "object") {
                  scope.onUpdateOptValues(key, item);
                }
              });
            });
        }
      };

      scope.hotExpandTable = function (ev) {
        scope.tableExpanded = true;
        $mdDialog
          .show({
            controller: "HotExpandedTableController",
            controllerAs: "ctrl",
            templateUrl:
              "app/rule-editor/components/hot-expanded-table/hot-expanded-table.html",
            parent: angular.element(document.body),
            locals: {
              paramKey: scope.key,
              gridOptions: scope.gridOptions,
            },
            targetEvent: ev,
            clickOutsideToClose: false,
          })
          .then(function (data) {
            scope.gridOptions.data = data;
          })
          .finally(function () {
            scope.tableExpanded = false;
          });
      };

      scope.predicateEditor = function (ev, key) {
        inputSchema = [];
        if (scope.inputSchemas.length) {
          var keys = Object.keys(
            scope.inputSchemas[0].schemaDefinition.definitions
          );
          var inputSchema =
            scope.inputSchemas[0].schemaDefinition.definitions[keys[0]]
              .properties;
        }
        var predicate = angular.fromJson(angular.fromJson(scope.parameter));
        $mdDialog
          .show({
            controller: "PredicatesDialogController",
            controllerAs: "ctrl",
            templateUrl:
              "app/rule-editor/components/predicates-dialog/predicates-dialog.html",
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
              predicate: predicate,
              inputSchema: inputSchema,
            },
          })
          .then(function (predicate) {
            scope.parameter = angular.toJson(predicate);
          });
      };

      scope.onAddChip = function (key, type) {
        if(scope.parameter.length === 0) {
          scope.parameter = [];
        } else {
          scope.parameter = Array.from(new Set(scope.parameter.join(" ").split(" ")));
        }
      };

      scope.deleteRow = function (row) {
        delete row.$$hashKey;
        var index = scope.gridOptions.data.indexOf(row);
        scope.gridOptions.data.splice(index, 1);
      };

      scope.queriesBuilder = function (ev, key) {
        var queries =
          scope.parameter && scope.parameter != ""
            ? JSON.parse(scope.parameter)
            : [""];
        var queries = [queries];

        $mdDialog
          .show({
            controller: "QueriesDialogController",
            controllerAs: "ctrl",
            templateUrl:
              "app/rule-editor/components/queries-dialog/queries-dialog.html",
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
              queries: queries,
            },
          })
          .then(function (queries) {
            // Remove line breaks to avoid problem with rule savings
            // scope.parameter = queries.length ? angular.toJson(queries).replace(/\\n/g, ' ') : '';
            scope.parameter = queries.length ? angular.toJson(queries) : "";
          });
      };

      scope.passVisibility = false;
      scope.passInputType = "password";
      scope.changePassVisibility = function () {
        scope.passVisibility = !scope.passVisibility;
        if (scope.passVisibility) scope.passInputType = "text";
        else scope.passInputType = "password";
      };
    },
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('rulePropsBar', {
  templateUrl: 'app/rule-editor/components/props-bar/rule-props-bar.html',
  controllerAs: 'ctrl',
  bindings: {
    translation: '<',
    transformProps: '=',
    isChanged: '=?',
    api: '=?',
  },
  controller: rulePropsBarController,
});

rulePropsBarController.$inject = ['$scope', '$mdSidenav', '$localStorageService'];
function rulePropsBarController($scope, $mdSidenav, $localStorageService) {
  var vm = this;
  vm.api = {};
  $scope.currentsFavs = null;
  $scope.showProperties = false;
  $scope.onCLickshowProperties = function () {
    $scope.showProperties = !$scope.showProperties;
  };

  vm.api.toggle = function (e) {
    $scope.showProperties = false;
    if (e == 'close') return;
    setTimeout(function () {
      if (vm.transformProps && vm.transformProps.name) {
        $scope.currentsFavs = $scope.getFavsTransfomationId();
      }
    }, 200);
    $mdSidenav('rule-props-bar').toggle();
  };

  vm.api.close = function () {
    if ($mdSidenav('rule-props-bar').isOpen())
      $mdSidenav('rule-props-bar').toggle();
  };

  vm.onUpdateOptValues = function (key, values) {
    vm.transformProps.optValues[key] = values;
  };

  vm.buildPipeline = $scope.$parent.ruleEditor.buildPipeline;
  vm.duplicateTransformation =
    $scope.$parent.ruleEditor.duplicateTransformation;
  vm.deleteTransformation = $scope.$parent.ruleEditor.deleteTransformation;
  vm.removeOutputs = $scope.$parent.ruleEditor.removeOutputs;
  vm.addOutputs = $scope.$parent.ruleEditor.addOutputs;

  $scope.getFavsTransfomationId = function () {
    var newItem = { name: vm.transformProps.name, favs: [] };
    var store = $localStorageService.getItem("favsRulesProperties");
    if (store == null || store.length == 0) {
      $localStorageService.setItem("favsRulesProperties", [newItem]);
      return newItem;
    }
    var exits = store.find(function (s) {
      return s.name == vm.transformProps.name;
    });
    if (exits) {
      return exits;
    }
    $localStorageService.setItem("favsRulesProperties", [newItem]);
    return newItem;
  };

  $scope.updateFavProperties = function () {
    var ls = $localStorageService.getItem("favsRulesProperties");
    var cprops = ls.find(function (e) {
      return e.name == $scope.currentsFavs.name;
    });
    cprops.favs = $scope.currentsFavs.favs;
    $localStorageService.setItem("favsRulesProperties", ls);
  };

  $scope.removeFav = function (name) {
    $scope.currentsFavs.favs = $scope.currentsFavs.favs.filter(function (prop) {
      return prop != name;
    });
    $scope.updateFavProperties();
  };

  $scope.markAsFav = function (name) {
    var exits =
      $scope.currentsFavs.favs.find(function (e) {
        return e == name;
      }) || null;
    if (exits != null) return;
    $scope.currentsFavs.favs.push(name);
    $scope.updateFavProperties();
  };
}

(function () {
    'use strict';

    angular
    .module('dashboard')
    .controller('PredicatesDialogController', PredicatesDialogController)

    PredicatesDialogController.$inject = ['$scope', '$mdDialog', 'translationService', 'predicate', 'inputSchema'];
    function PredicatesDialogController($scope, $mdDialog, $translationService, predicate, inputSchema) {
        $translationService.getTranslation($scope, 'predicates');
        var vm = this;
        vm.valid = true;
        vm.inputSchema = inputSchema;
        vm.predicate = predicate;
        vm.cancel = function(){ $mdDialog.cancel(); }
        vm.save = function(){ $mdDialog.hide(vm.predicate); }
    }
})();
"use strict";

var app = angular.module('dashboard');

app.component('notesWidget', {
    templateUrl: 'app/rule-editor/components/notes-widget/notes-widget.html',
    controller: notesWidgetController,
    bindings: {
        label: "@",
        state: "@",
        onProgress: '<',
        clickHandler: "<",
        dblClickHandler: "<",
        ctrlClickHandler: "<",
    },
});

notesWidgetController.$inject = ['$scope', '$element'];
function notesWidgetController($scope, elem) {
    var vm = this;

    vm.$postLink = function() {
        elem.click(function(event){
            if(!vm.onProgress){
              $('.window').removeClass('active success failed');
              if(event.metaKey || event.altKey){
                vm.ctrlClickHandler(elem.attr('id'), elem.attr('data-id'));
              }else{
                elem.addClass('active');
                vm.clickHandler(elem.attr('data-id'));
              }
            }
        });
        elem.dblclick(function(){
          if(!vm.onProgress && !event.metaKey && !event.altKey){
            vm.dblClickHandler();
          }
        });
    }

    vm.$onChanges = function (changes) {
      if(changes.state){
        elem.removeClass('active success failed idle').addClass(vm.state);
      }
    }
}

"use strict";

var app = angular.module('dashboard');

app.component('jsonEditor', {
    templateUrl: 'app/rule-editor/components/json-editor/json-editor.html',
    controllerAs: 'ctrl',
    bindings: {
        json: "=",
    },
    controller: jsonEditorController,
});
jsonEditorController.$inject = ['$scope'];
function jsonEditorController($scope) {
    var vm = this;
    $scope.getTypeof = function (ele) {
        var type = typeof (ele);
        if (Array.isArray(ele)) { type = 'array' }
        return type
    };
}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('HotExpandedTableController', HotExpandedTableController);

  HotExpandedTableController.$inject = [
    '$scope',
    'translationService',
    '$mdDialog',
    'paramKey',
    'gridOptions',
  ];
  function HotExpandedTableController(
    $scope,
    $translationService,
    $mdDialog,
    paramKey,
    gridOptions
  ) {
    var vm = this;
    vm.loading = true;
    vm.editorMode = false;
    vm.paramKey = paramKey;
    vm.gridOptions = gridOptions;
    vm.schemaAsJson = angular.toJson(vm.gridOptions.data, true);

    vm.fakeLoading = function () {
      vm.loading = true;
      setTimeout(function () {
        vm.loading = false;
        $scope.$apply();
      }, 500);
    };
    vm.fakeLoading();

    vm.translation = {
      add_row: $translationService.getTranslationController(
        'Agregar fila',
        'Add row',
        'Adicionar linha'
      ),
      close: $translationService.getTranslationController(
        'Cerrar',
        'Close',
        'Fechar'
      ),
      move_up: $translationService.getTranslationController(
        'Mover arriba',
        'Move up',
        'Mover para cima'
      ),
      move_down: $translationService.getTranslationController(
        'Mover abajo',
        'Move down',
        'Mover para baixo'
      ),
      table_mode: $translationService.getTranslationController(
        'Modo tabla',
        'Table mode',
        'Modo tabla'
      ),
      edit_mode: $translationService.getTranslationController(
        'Modo edición',
        'Edit mode',
        'Modo edición'
      ),
    };

    vm.addRow = function () {
      vm.gridOptions.data.push(angular.copy(vm.gridOptions.defaultSchema));
    };

    $scope.deleteRow = function (row) {
      var data = vm.gridOptions.data;
      delete row.$$hashKey;
      var index = data.indexOf(row);
      data.splice(index, 1);
    };

    vm.togleEditionMode = function () {
      vm.editorMode = !vm.editorMode;
      if (vm.editorMode) {
        vm.schemaAsJson = angular.toJson(vm.gridOptions.data, true);
      } else {
        vm.gridOptions.data = angular.fromJson(vm.schemaAsJson);
      }
    };

    vm.moveRow = function (dir) {
      if (vm.rowEntity) {
        var row = vm.rowEntity;
        var index = vm.gridOptions.data.indexOf(row);

        if (!dir) {
          // Move down
          vm.gridOptions.data.splice(index, 1);
          vm.gridOptions.data.splice(index + 1, 0, row);
          vm.gridInstance.selectCell(
            ++vm.selectedCellCoordinates.row,
            vm.selectedCellCoordinates.col
          );
        } else {
          // Move up
          if (index > 0) {
            vm.gridOptions.data.splice(index, 1);
            vm.gridOptions.data.splice(index - 1, 0, row);
            vm.gridInstance.selectCell(
              --vm.selectedCellCoordinates.row,
              vm.selectedCellCoordinates.col
            );
          }
        }

        vm.gridOptions.data.sort(function (a, b) {
          return a.order - b.order;
        });
      }
    };

    vm.close = function () {
      $mdDialog.hide(vm.gridOptions.data);
    };

    // Table options
    vm.tableColumns = gridOptions.columnDefs
      .filter(function (col) {
        return col.displayName != 'Del';
      })
      .map(function (col) {
        return {
          type: 'text',
          className: 'htLeft',
          data: col.field,
          title: col.displayName || col.name,
        };
      });

    vm.tableSettings = {
      licenseKey: 'non-commercial-and-evaluation',
      stretchH: 'all',
      renderAllRows: false,
      colHeaders: true,
      rowHeaders: false,
      currentRowClassName: 'cep-selected-row',
      manualColumnResize: true,
      manualRowResize: true,
      persistentState: false,
      columnSorting: false,
      allowInvalid: true,
      columnHeaderHeight: 10,
      outsideClickDeselects: false,
      height: 'auto',
      contextMenu: {
        items: {
          remove_row: {
            name: $translationService.getTranslationController(
              'Eliminar fila',
              'Remove row',
              'Remover fila'
            ),
          },
        },
      },
      onAfterInit: function () {
        vm.gridInstance = this;
      },
      onAfterSelectionEnd: function (starRow, startCol) {
        vm.rowEntity = vm.gridOptions.data[starRow];
        vm.selectedCellCoordinates = {
          row: starRow,
          col: startCol,
        };
      },
      onBeforePaste: function (values, range) {
        var startRow = range[0].startRow;
        var startCol = range[0].startCol;

        var content = [];
        values.forEach(function (row, i) {
          row.forEach(function (value, x) {
            content.push([startRow + i, startCol + x, value]);
          });
        });
        this.setDataAtCell(content);

        return false;
      },
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('ExpandedTableController', ExpandedTableController);

  ExpandedTableController.$inject = [
    '$scope',
    'translationService',
    '$mdDialog',
    'paramKey',
    'gridOptions',
  ];
  function ExpandedTableController(
    $scope,
    $translationService,
    $mdDialog,
    paramKey,
    gridOptions
  ) {
    var vm = this;
    vm.editorMode = false;
    vm.paramKey = paramKey;
    vm.schemaAsJson = '';

    vm.gridOptions = gridOptions;
    vm.gridOptions.enableRowHeaderSelection = true;
    vm.gridOptions.onRegisterApi = function (gridApi) {
      // Selection
      gridApi.selection.on.rowSelectionChanged($scope, function (row) {
        vm.rowEntity = row.entity;
      });
    };

    vm.translation = {
      add_row: $translationService.getTranslationController(
        'Agregar fila',
        'Add row',
        'Adicionar linha'
      ),
      close: $translationService.getTranslationController(
        'Cerrar',
        'Close',
        'Fechar'
      ),
      move_up: $translationService.getTranslationController(
        'Mover arriba',
        'Move up',
        'Mover para cima'
      ),
      move_down: $translationService.getTranslationController(
        'Mover abajo',
        'Move down',
        'Mover para baixo'
      ),
      table_mode: $translationService.getTranslationController(
        'Modo tabla',
        'Table mode',
        'Modo tabla'
      ),
      edit_mode: $translationService.getTranslationController(
        'Modo edición',
        'Edit mode',
        'Modo edición'
      ),
    };

    vm.togleEditionMode = function () {
      vm.editorMode = !vm.editorMode;
      if (vm.editorMode) {
        vm.schemaAsJson = angular.toJson(vm.gridOptions.data, true);
      } else {
        vm.gridOptions.data = angular.fromJson(vm.schemaAsJson);
      }
    };

    vm.addRow = function () {
      if (vm.editorMode) {
        vm.gridOptions.data = angular.fromJson(vm.schemaAsJson);
        vm.gridOptions.data.push(angular.copy(vm.gridOptions.defaultSchema));
        vm.schemaAsJson = angular.toJson(vm.gridOptions.data, true);
      } else {
        vm.gridOptions.data.push(angular.copy(vm.gridOptions.defaultSchema));
      }
    };

    $scope.deleteRow = function (row) {
      var data = vm.gridOptions.data;
      delete row.$$hashKey;
      var index = data.indexOf(row);
      data.splice(index, 1);
    };

    vm.moveRow = function (dir) {
      if (vm.rowEntity) {
        var row = vm.rowEntity;
        var index = vm.gridOptions.data.indexOf(row);

        if (!dir) {
          // Move down
          vm.gridOptions.data.splice(index, 1);
          vm.gridOptions.data.splice(index + 1, 0, row);
        } else {
          // Move up
          if (index > 0) {
            vm.gridOptions.data.splice(index, 1);
            vm.gridOptions.data.splice(index - 1, 0, row);
          }
        }
        vm.gridOptions.data.sort(function (a, b) {
          return a.order - b.order;
        });
      }
    };

    vm.close = function () {
      if (vm.editorMode) {
        vm.gridOptions.data = angular.fromJson(vm.schemaAsJson);
      }

      $mdDialog.hide();
    };
  }
})();

'use strict';

var app = angular.module('dashboard');

app.component('transformationBox', {
  templateUrl:
    'app/realtime-rule-editor/components/transformation-box/transformation-box.html',
  controller: transformationBoxController,
  bindings: {
    time: '<',
    label: '@',
    debug: '@',
    processDisabled: '@',
    state: '@',
    showStats: '<',
    onProgress: '<',

    node: '<',
    rule: '<',
    editor: '<',
    onTransformationCreated: '&',
    clickHandler: '&',
    dblClickHandler: '&',
    ctrlClickHandler: '&',
  },
});

transformationBoxController.$inject = [
  '$element',
  'plumbProvider',
  'ruleEditorDefaults',
  'transformationsService',
];
function transformationBoxController(
  elem,
  $plumbProvider,
  $ruleEditorDefaults,
  $transformationsService
) {
  var vm = this;
  var elementId = $ruleEditorDefaults.baseTransformationId + vm.node.id;

  vm.$onInit = function () {
    vm.node.type = $transformationsService.defineType(
      vm.editor.transformations,
      vm.node.nodeType,
      vm.node.inputSchemas,
      vm.node.outputSchemas
    );
  };

  vm.$postLink = function () {
    elem.css(_getNodePosition());
    elem.attr('id', elementId);
    elem.attr('data-tool', vm.node.nodeType);
    elem.attr('data-type', vm.node.type);
    elem.addClass(
      'window step realtime-step jsplumb-connected-step md-truncate custom jtk-node jtk-endpoint-anchor jtk-managed jtk-draggable jtk-connected'
    );

    elem.click(function (event) {
      if (!vm.onProgress) {
        $('.window').removeClass('active success failed');

        if (event.metaKey || event.altKey) {
          vm.ctrlClickHandler({
            elementId: elementId,
            transformationId: +vm.node.id,
          });
        } else {
          elem.addClass('active');
          vm.clickHandler({ id: +vm.node.id });
        }
      }
    });

    elem.dblclick(function (event) {
      if (!vm.onProgress && !event.metaKey && !event.altKey) {
        vm.dblClickHandler();
      }
    });

    vm.afterCreated();
  };

  vm.afterCreated = function () {
    vm.editor.instance.draggable(elementId, {
      grid: [10, 10],
    });
    _addEndpoints('source', vm.node.sources);
    _addEndpoints('target', vm.node.targets);
    vm.onTransformationCreated();
  };

  function _getNodePosition() {
    var editorPanning = {
      x: vm.rule.structure.layout.pan.x || 0,
      y: vm.rule.structure.layout.pan.y || 0,
    };

    return {
      top: vm.node.positionY + editorPanning.y,
      left: vm.node.positionX + editorPanning.x,
    };
  }

  function _addEndpoints(type, points) {
    var offset = 0;
    var tics = 1 / (points * 2);

    for (var i = 0; i < points; i++) {
      var endpointUuid = elementId + '-' + type + '-' + i;

      var options =
        type === 'source'
          ? $plumbProvider.getSource()
          : $plumbProvider.getTarget();

      var attributes = {
        radius: 4,
        anchor:
          type === 'source'
            ? [1, tics + tics * offset, 1, 0]
            : [0, tics + tics * offset, -1, 0],
        uuid: endpointUuid,
      };

      vm.editor.instance.addEndpoint(elementId, options, attributes);
      offset += 2;
    }
  }

  vm.$onChanges = function (changes) {
    if (changes.state) {
      elem.removeClass('active success failed idle').addClass(vm.state);
    }
    if (changes.time) {
      if (!isNaN(vm.time)) {
        var timeScale =
          vm.time > 60000 ? 'min.' : vm.time > 1000 ? 'sec.' : 'ms.';
        vm.time =
          vm.time > 60000
            ? vm.time / 60000
            : vm.time > 1000
            ? vm.time / 1000
            : vm.time;
        vm.timeLabel = vm.time.toFixed(2) + timeScale;
      }
    }
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('ruleEditorToolbar', {
  templateUrl:
    'app/realtime-rule-editor/components/rule-editor-toolbar/rule-editor-toolbar.html',
  controllerAs: 'ctrl',
  bindings: {
    translation: '<',
    editorState: '<',
    typeCheckState: '<',
    typeCheckRuleFn: '&',
    executeRuleFn: '&',
    stopRuleFn: '&',
    saveRuleFn: '&',
    showCode: '=',
    darkMode: '=',
    //
    hasError: '<',
    isChecking: '<',
    isChanged: '<',
    onProgress: '<',
    isRunning: '<',
    executionState: '=',
  },
  controller: RuleEditorToolbarController,
});

RuleEditorToolbarController.$inject = ['ruleEditorDefaults'];
function RuleEditorToolbarController($ruleEditorDefaults) {
  var vm = this;

  vm.executeRule = function () {
    vm.executeRuleFn();
  };

  vm.stopRule = function () {
    vm.stopRuleFn();
  };

  vm.typeCheckRule = function () {
    vm.typeCheckRuleFn();
  };

  vm.saveRule = function () {
    vm.saveRuleFn();
  };

  vm.isTypeCheckInProgress = function () {
    return vm.editorState === $ruleEditorDefaults.editorStates.TYPE_CHECKING;
  };

  // vm.showCode = false;
  // vm.zoom = $scope.$parent.ruleEditor.zoom;
  // vm.buildPipeline = $scope.$parent.ruleEditor.buildPipeline;
  // vm.saveFlowchart = $scope.$parent.ruleEditor.saveFlowchart;
  // vm.loadFlowchart = $scope.$parent.ruleEditor.loadFlowchart;
  // vm.showProperties = $scope.$parent.showProperties;
  // vm.clear = $scope.$parent.ruleEditor.clear;
  // vm.execute = $scope.$parent.ruleEditor.execute;
  // vm.stopExecution = $scope.$parent.ruleEditor.stopExecution;
  // vm.current_mode = vm.isDarkMode;

  // vm.onToogleView = function () {
  //   vm.showCode = !vm.showCode;
  //   $scope.$parent.showCode = !$scope.$parent.showCode;
  // };

  // vm.toggleTerminal = function () {
  //   $scope.$parent.ruleEditor.terminal.toggle();
  // };

  // vm.toggleDarkenMode = function () {
  //   $scope.$parent.ruleEditor.toggleDarkMode();
  // };

  // vm.test = function () {
  //   $scope.$parent.ruleEditor.test();
  // };

  vm.validatePermission = function (permission) {
    return true;
    // if (!angular.isDefined($scope.$parent.ruleEditor.functionData)) {
    //   return false;
    // }
    // return PermissionsFactory.hasPermission(
    //   'function#' + $scope.$parent.ruleEditor.functionData.id + ':' + permission
    // );
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('ruleEditorCode', {
  templateUrl:
    'app/realtime-rule-editor/components/rule-editor-code/rule-editor-code.template.html',
  controllerAs: 'ctrl',
  bindings: {
    ruleStructure: '=',
    ngShow: '<',
  },

  controller: ruleEditorCodeController,
});

ruleEditorCodeController.$inject = ['toastr', 'translationService'];
function ruleEditorCodeController($toastr, $translationService) {
  var vm = this;

  vm.ruleStructureJson;
  $translationService.getTranslation(vm, 'rule-editor-code');

  vm.$onChanges = function (changes) {
    if (changes.ngShow && !changes.ngShow.isFirstChange()) {
      _refreshRuleStructure();
    }
  };

  function _refreshRuleStructure() {
    vm.ruleStructureJson = angular.toJson(vm.ruleStructure, 2);
  }

  vm.saveChanges = function () {
    try {
      vm.ruleStructure = angular.fromJson(vm.ruleStructureJson);
      $toastr.success(vm.translation.changes_saved);
    } catch (error) {
      console.log('Error@saveChanges', error);
      $toastr.error(vm.translation.sintax_error);
    }
  };

  vm.editorConfig = {
    useWrapMode: true,
    showGutter: true,
    theme: 'twilight',
    mode: 'json',
    rendererOptions: { minLines: 3 },
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('ruleEditorCanvas', {
  templateUrl:
    'app/realtime-rule-editor/components/rule-editor-canvas/rule-editor-canvas.template.html',
  controllerAs: 'ctrl',
  bindings: {
    editor: '=',
    rule: '=',
    tools: '=',
    darkMode: '<',
  },

  controller: ruleEditorCanvasController,
});

ruleEditorCanvasController.$inject = [
  '$scope',
  'toastr',
  'translationService',
  'transformationsService',
  'ruleEditorDefaults',
];
function ruleEditorCanvasController(
  $scope,
  $toastr,
  $translationService,
  $transformationsService,
  $ruleEditorDefaults
) {
  var vm = this;

  vm.execution = {
    state: null, // inProgress isChecking isSaving isVersioned isExecution
  };

  vm.panZoom = {
    config: {
      zoomOnMouseWheel: false,
      keepInBounds: false,
      panOnClickDrag: true,
      zoomOnDoubleClick: false,
    },
    model: {},
  };

  $scope.$watchCollection('ctrl.panZoom.model.pan', function (nval) {
    if (nval) {
      if (vm.rule.structure.layout) {
        vm.rule.structure.layout.pan.x = nval.x;
      }
    }
  });

  vm.$onInit = function () {
    jsPlumb.ready(function () {
      vm.editor.instance = jsPlumb.getInstance({
        DragOptions: {
          cursor: 'pointer',
          zIndex: 99999,
        },
        Container: 'canvas-area',
        ConnectionsDetachable: true,
      });

      vm.editor.instance.bind('connection', function (info) {
        var newStream = $transformationsService.buildStream(info);
        vm.rule.structure.streams = $transformationsService.removePreviousStream(
          vm.rule.structure.streams,
          newStream
        );
        vm.rule.structure.streams.push(newStream);
      });

      vm.editor.instance.bind('connectionDetached', function (info) {
        vm.rule.structure.streams = vm.rule.structure.streams.filter(function (
          stream
        ) {
          return stream.connectionId != info.connection.id;
        });
      });
    });
  };

  vm.onTransformationCreated = function () {
    vm.editor.elementCount++;
    if (_areAllTransformationsRendered()) {
      _makeConnections();
    }
  };

  /**
   * @param {id: number;} event
   */
  vm.onTransformationClicked = function (event) {
    console.log('Transformation Clicked', event);
  };

  /**
   * @param void
   */
  vm.onTransformationDoubleClicked = function () {
    console.log('Transformation Double Clicked');
  };

  /**
   * @param {elementId: string; transformationId: number;} event
   */
  vm.onTransformationCtrlClicked = function (event) {
    console.log('Transformation Ctrl+Click', event);
  };

  function _makeConnections() {
    vm.rule.structure.streams.forEach(function (stream) {
      var uuids = $transformationsService.getConnectionsUuid(stream);
      vm.editor.instance.connect({
        uuids: uuids,
      });
    });
  }

  function _areAllTransformationsRendered() {
    return vm.editor.elementCount == vm.rule.structure.transformations.length;
  }

  vm.onDrop = function (dom) {
    if (!_checkExecutionState(vm.execution.state)) {
      return;
    }

    if (!vm.tools.clicked) {
      return;
    }

    var selectedTool = vm.tools.selected[0];
    var dropPosition = $transformationsService.getDropPosition({
      dom: dom,
      panning: {
        x: vm.panZoom.model.pan.x + vm.rule.structure.layout.pan.x,
        y: vm.panZoom.model.pan.y + vm.rule.structure.layout.pan.y,
      },
      zoomLevel: vm.editor.zoomLevel,
    });

    var newNode = {
      id: vm.editor.elementCount.toString(),
      label: selectedTool.nameId,
      width: 45,
      height: 45,
      sources: selectedTool.startpoints,
      targets: selectedTool.endpoints,
      nodeType: selectedTool.nameId,
      elementId:
        $ruleEditorDefaults.baseTransformationId + vm.editor.elementCount,
      positionX: dropPosition.left,
      positionY: dropPosition.top,
    };
    vm.rule.structure.nodes.push(newNode);

    vm.tools.clicked = false; // review the ussage of this var
    vm.editor.isChanged = true;
  };

  function _checkExecutionState(state) {
    var stateMessages = {
      inProgress: $translationService.getTranslationController(
        'Ejecución en progreso, por favor espere.',
        'Execution in progress, please wait.',
        'Execução em andamento, por favor aguarde.'
      ),
      inTypecheck: $translationService.getTranslationController(
        'Typecheck en progreso, por favor espere.',
        'Typecheck in progress, please wait.',
        'Typecheck em andamento, por favor aguarde.'
      ),
      saving: $translationService.getTranslationController(
        'Guardando regla, por favor espere.',
        'Saving rule, please wait.',
        'Salvo em andamento, por favor aguarde.'
      ),
      isVersion: $translationService.getTranslationController(
        'La versión de la regla no es editable.',
        'Rule version is not editable.',
        'A versão da regra não é editável.'
      ),
      isExecution: $translationService.getTranslationController(
        'La ejecución de la regla no es editable.',
        'Rule executiom is not editable.',
        'A execução da regra não é editável.'
      ),
    };

    var message = stateMessages[state];

    if (message) {
      $toastr.info(message);
      return false;
    }

    return true;
  }

  // function _createElement(id, elemNum, label, inputSchemas, outputSchemas) {
  //   var _schema = angular.copy(vm.tools.selected[0].schema);
  //   var _params = angular.copy(vm.tools.selected[0].params);
  //   var _types = angular.copy(vm.tools.selected[0].types);

  //   var time = 0;
  //   if (
  //     !vm.execution.state == 'isExecution' &&
  //     vm.functionData.context &&
  //     vm.functionData.context.transformationStats[elemNum]
  //   ) {
  //     time = vm.functionData.context.transformationStats[elemNum].executionTime;
  //   }
  //   // Execution states
  //   var state = 'idle';
  //   if (vm.execution.state == 'isExecution') {
  //     if (vm.execution && vm.execution.context.transformationStats[elemNum]) {
  //       if (
  //         vm.execution.context.transformationStats[elemNum].startTime &&
  //         vm.execution.context.transformationStats[elemNum].finishTime
  //       ) {
  //         var startTime = $transformationsService.getDateTimeFromObject(
  //           vm.execution.context.transformationStats[elemNum].startTime
  //         );

  //         var finishTime = $transformationsService.getDateTimeFromObject(
  //           vm.execution.context.transformationStats[elemNum].finishTime
  //         );

  //         vm.execution.context.transformationStats[
  //           elemNum
  //         ].executionTime = finishTime.diff(startTime, 'ms', true);

  //         vm.execution.context.transformationStats[elemNum].state = 'success';

  //         time =
  //           vm.execution.context.transformationStats[elemNum].executionTime;

  //         state = 'success';
  //       } else {
  //         vm.execution.context.transformationStats[elemNum].state = 'failed';
  //         time = 0;
  //         state = 'failed';
  //       }
  //     }
  //   }

  //   vm.rule.transformations.push({
  //     id: elemNum,
  //     name: vm.tools.selected[0].tool,
  //     label: label || vm.tools.selected[0].tool,
  //     type: vm.tools.selected[0].nameId,
  //     parameters: _params,
  //     optValues: vm.tools.selected[0].optValues,
  //     inputSchemas: inputSchemas || [],
  //     outputSchemas: outputSchemas || [],
  //     schema: _schema,
  //     types: _types,
  //     state: state,
  //     executionTime: time,
  //   });

  //   vm.tools.selected[0].type = $transformationsService.defineType(
  //     vm.editor.transformations,
  //     vm.tools.selected[0].tool,
  //     inputSchemas,
  //     outputSchemas
  //   );

  //   if (vm.tools.selected[0].tool == 'Comment') {
  //     var elm = $(
  //       '<notes-widget ' +
  //         'label="{{ ctrl.rule.transformations | getFieldById:' +
  //         elemNum +
  //         ":'label' }}\"" +
  //         'class="note_box jtk-node"' +
  //         'id="' +
  //         id +
  //         '"' +
  //         'data-id="' +
  //         elemNum +
  //         '"' +
  //         'data-tool="' +
  //         vm.tools.selected[0].tool +
  //         '"' +
  //         'data-type="' +
  //         vm.tools.selected[0].type +
  //         '"' +
  //         'state="{{ ctrl.rule.transformations | getFieldById:' +
  //         elemNum +
  //         ":'state' }}\"" +
  //         'click-handler="ruleEditor.setSelectedTransformation"' +
  //         'dbl-click-handler="showProperties"' +
  //         'ctrl-click-handler="ruleEditor.addToDragSelection"' +
  //         'on-progress="ruleEditor.onProgress"' +
  //         '>'
  //     ).css({
  //       top: vm.tools.selected[0].top,
  //       left: vm.tools.selected[0].left,
  //     });
  //   } else {
  //     var elm = $(
  //       '<transform-box ' +
  //         'label="{{ ctrl.rule.transformations | getFieldById:' +
  //         elemNum +
  //         ":'label' }}\"" +
  //         'time="ctrl.rule.transformations | getFieldById:' +
  //         elemNum +
  //         ":'executionTime'\"" +
  //         'class="' +
  //         vm.tools.selected[0].clsName +
  //         '"' +
  //         'id="' +
  //         id +
  //         '"' +
  //         'data-id="' +
  //         elemNum +
  //         '"' +
  //         'data-tool="' +
  //         vm.tools.selected[0].tool +
  //         '"' +
  //         'data-type="' +
  //         vm.tools.selected[0].type +
  //         '"' +
  //         'debug="{{ ctrl.rule.transformations | getFieldById:' +
  //         elemNum +
  //         ":'parameters.debug' }}\"" +
  //         'process-disabled="{{ ctrl.rule.transformations | getFieldById:' +
  //         elemNum +
  //         ":'parameters.process-disabled' }}\"" +
  //         'show-stats="showBoxStats"' +
  //         'state="{{ ctrl.rule.transformations | getFieldById:' +
  //         elemNum +
  //         ":'state' }}\"" +
  //         'click-handler="ctrl.setSelectedTransformation"' +
  //         'dbl-click-handler="ctrl.showProperties"' +
  //         'ctrl-click-handler="ctrl.addToDragSelection"' +
  //         'on-progress="ruleEditor.onProgress"' +
  //         '>'
  //     ).css({
  //       top: vm.tools.selected[0].top,
  //       left: vm.tools.selected[0].left,
  //     });
  //   }

  //   elm = $compile(elm)($scope);
  //   return elm;
  // }

  // function _drawElement(element, canvasId, name, elemNum) {
  //   $(canvasId).append(element);
  //   _addEndpoints(
  //     name,
  //     vm.tools.selected[0].startpoints,
  //     vm.tools.selected[0].endpoints,
  //     elemNum
  //   );

  //   vm.editor.instance.draggable(vm.editor.instance.getSelector('.jtk-node'), {
  //     grid: [10, 10],
  //   });
  // }

  // var ep;
  // var sourcepointList = [];
  // var endpointList = [];
  // function _addEndpoints(toId, sourceAnchors, targetAnchors, elemNum) {
  //   var tics = 1 / (sourceAnchors * 2),
  //     offset = 0;
  //   for (var i = 0; i < sourceAnchors; i++) {
  //     var sourceOutputSchema = toId + '_source_' + i;
  //     ep = vm.editor.instance.addEndpoint(
  //       'flowchart' + toId,
  //       $plumbProvider.getSource(),
  //       {
  //         radius: 4,
  //         anchor: [1, tics + tics * offset, 1, 0],
  //         uuid: sourceOutputSchema,
  //       }
  //     );
  //     offset += 2;

  //     sourcepointList.push(['flowchart' + toId, ep]);
  //     ep.canvas.setAttribute(
  //       'title',
  //       $translationService.getTranslationController(
  //         'Arrastra una conexión desde aquí',
  //         'Drag a connection from here',
  //         'Arraste uma conexão daqui'
  //       )
  //     );
  //     ep = null;
  //   }

  //   var tics = 1 / (targetAnchors * 2),
  //     offset = 0;
  //   for (var j = 0; j < targetAnchors; j++) {
  //     var targetInputSchema = toId + '_target_' + j;
  //     ep = vm.editor.instance.addEndpoint(
  //       'flowchart' + toId,
  //       $plumbProvider.getTarget(),
  //       {
  //         radius: 4,
  //         anchor: [0, tics + tics * offset, -1, 0],
  //         uuid: targetInputSchema,
  //       }
  //     );
  //     offset += 2;

  //     endpointList.push(['flowchart' + toId, ep]);
  //     ep.canvas.setAttribute(
  //       'title',
  //       $translationService.getTranslationController(
  //         'Deja una conexión aquí',
  //         'Drop a connection here',
  //         'Solte uma conexão aqui'
  //       )
  //     );
  //     ep = null;
  //   }
  // }

  // vm.setSelectedTransformation = function (dataId) {
  //   vm.editor.instance.clearDragSelection();
  //   vm.multiSelection = [];

  //   angular.forEach(vm.editor.instance.getConnections(), function (connection) {
  //     connection.removeClass('stream-active stream-success');
  //   });

  //   vm.tools.selected = vm.editor.transformations.find(function (e) {
  //     return e.id == dataId;
  //   });

  //   // rule.selectedContext = [];
  //   // if (rule.functionData.context) {
  //   //   rule.selectedContext =
  //   //     rule.functionData.context.transformationStats[Number(dataId)];
  //   // }
  // };

  // vm.showProperties = function () {
  //   console.log('Show Props');
  // };

  // vm.addToDragSelection = function () {
  //   console.log('Add to drag selection');
  // };
}

"use strict";

var app = angular.module("dashboard");

app.component("userDocuments", {
  templateUrl: "app/main/components/user-documents/user-documents.html",
  controllerAs: "ctrl",
  controller: userDocumentsController,
});

userDocumentsController.$inject = [
  "$scope",
  "toastr",
  "$window",
  "$interval",
  "DocumentsFactory",
];
function userDocumentsController(
  $scope,
  $toastr,
  $window,
  $interval,
  $documentsFactory
) {
  var vm = this;
  vm.newDocument = false;
  vm.loading = true;
  vm.documents = [];
  vm.isOpen = false;
  
  vm.hasInProgress = false;

  var pagination = {
    page: 1,
    itemsPerPage: 999,
  };

  vm.toggleNoty = function (e) {
    if (e) e.stopPropagation();
    if (vm.isLoading) return;

    vm.isOpen = !vm.isOpen;

    if (vm.isOpen) {
      vm.getAllDocumentsUser();
      $window.onclick = function (e) {
        if (!e.path) {
          return;
        }
        vm.isOpen = e.path
          .map(function (e) {
            return e.classList;
          })
          .filter(function (e) {
            return e;
          })
          .some(function (e) {
            return e.contains("noti-menu-wrap");
          });
      };
      vm.newDocument = false;
    } else if (!e) {
      vm.isOpen = false;
    }
  };

  var checkDocumentsTimer = null;
  vm.$onInit = function () {
    vm.getAllDocumentsUser();
  };

  vm.getAllDocumentsUser = function () {
    vm.loading = true;
    $documentsFactory.getAllDocumentsUser(pagination)
    .then(function (response) {
        vm.documents = response.data;
        pagination = response.pagination;
        

        vm.documents = vm.documents.sort(function (a, b) {
          var order = ["IN_PROGRESS", "COMPLETED", "FAILED"];
          return order.indexOf(a.status) - order.indexOf(b.status);
        });

        vm.hasInProgress = vm.documents.some(function (d) {
          return d.status === "IN_PROGRESS";
        });


        if (vm.hasInProgress) {
          checkDocumentsTimer = setTimeout(function () {
            vm.getAllDocumentsUser();
          }, 20000);
        } else {
          if (checkDocumentsTimer != null) {
            $toastr.success("New document received", "Success");
            clearTimeout(checkDocumentsTimer);
            checkDocumentsTimer = null
          }
        }
        vm.loading = false;
      }
    ).catch(function (err) {
      console.log(err);
      vm.loading = false;
    })
  };

  vm.cleanDocuments = function () {
    $documentsFactory
      .cleanDocuments()
      .then(function (res) {
        console.log(res);
        vm.getAllDocumentsUser();
      })
      .catch(function (err) {
        console.log(err);
      });
  };

  $scope.$on("refreshUserDocuments", function () {
    vm.getAllDocumentsUser();
  });
}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('TimeZoneController', TimeZoneController);

  TimeZoneController.$inject = [
    '$scope',
    '$rootScope',
    '$localStorageService',
    'timezoneService',
    'UserFactory',
    '$localStorage',
    'translationService',
    'toastr',
  ];

  function TimeZoneController(
    $scope,
    $rootScope,
    $localStorageService,
    $timezoneService,
    $userFactory,
    $localStorage,
    $translationService,
    $toastr
  ) {

    $scope.querySearch = querySearch;
    $scope.searchText = null;

    var currentUser = $localStorageService.getItem('currentUser');
    var currentTimeZone =  Intl.DateTimeFormat().resolvedOptions().timeZone;
    var timeuser = currentUser ? currentUser.timeZone : currentTimeZone;
    $scope.timeZones = Intl.supportedValuesOf('timeZone');
    $scope.timeuser = timeuser

    
    $translationService.getTranslation($scope, 'includes');

    $scope.updateUserTimezone = function () {
      var timeZone = $scope.timeuser;
      if (!$scope.timeuser) {
        $toastr.info(
          $translationService.getTranslationController(
            'Por favor seleccione una zona horaria',
            'Please select a time zone',
            'Selecione um fuso horário'
          )
        );
        return false;
      }

      $rootScope.loading = true;
      $userFactory
        .getUser($localStorageService.getItem('currentUser').username)
        .then(function (res) {
          res.data.timeZone = timeZone;
          $userFactory
            .edit(res.data.userId, res.data)
            .then(function () {
              $toastr.success(
                $translationService.getTranslationController(
                  'Zona horaria actualizada',
                  'Timezone updated',
                  'Fuso horário atualizado'
                )
              );
              $localStorageService.setItem("currentUser.timeZone", timeZone);
              console.log('Timezone updated', timeZone);
              console.log($localStorageService.getItem("currentUser"));
              $rootScope.$broadcast('closeModalZone');
            })
            .catch(function (err) {
              handleError('edit', err);
            })
            .finally(function () {
              $rootScope.loading = false;
            });
        })
        .catch(function (error) {
          handleError('getUser', error);
        });
    };

    function querySearch(query) {
      var results = query
        ? $scope.timeZones .filter(function (e) {
            var tz = e.toLowerCase();
            if (tz.includes(query.toLowerCase())) {
              return e;
            }
          })
        : $scope.timeZones ;
      return results;
    }

    function handleError(source, error) {
      console.log('Error@' + source, error);
      $toastr.error(
        $translationService.getTranslationController(
          'No se ha podido guardar',
          'Could not save',
          'Não foi possível salvar'
        )
      );
      $rootScope.loading = false;
    }
  }
})();

"use strict";

var app = angular.module('dashboard');

app.component('riskMenuItem', {
    templateUrl: 'app/main/components/risk-menu-item/risk-menu-item.html',
    controllerAs: 'ctrl',
    bindings: {
    	mustShow: "<",
    	mustDeactivate: "<",
    	appName: "@",
    	appLink: "@",
    	menuIcon: "@",
    	menuLabel: "@"
    },
});
"use strict";

var app = angular.module("dashboard");

app.component("notification", {
  templateUrl: "app/main/components/notification/notification.html",
  controllerAs: "ctrl",
  controller: notificationController,
});

notificationController.$inject = [
  "$scope",
  "$window",
  "$mdSidenav",
  "notificationsService",
  "translationService",
  "NotificationsFactory",
];
function notificationController(
  $scope,
  $window,
  $mdSidenav,
  $notificationsService,
  $translationService,
  $notificationsFactory
) {
  var vm = this;
  $scope.isOpen = false;
  $translationService.getTranslation($scope, "notifications");

  $scope.toggleNoty = function (e) {
    if (e) e.stopPropagation();
    if (vm.isLoading) return;

    $scope.isOpen = !$scope.isOpen;

    if ($scope.isOpen) {
      $window.onclick = function (e) {
        if (!e.path) {
          return;
        }
        $scope.isOpen = e.path
          .map(function (e) {
            return e.classList;
          })
          .filter(function (e) {
            return e;
          })
          .some(function (e) {
            return e.contains("noti-menu-wrap");
          });
      };
    } else if (!e) {
      $scope.isOpen = false;
    }
  };
  $scope.toggleRight = buildToggler("right");

  function buildToggler(componentId) {
    return function () {
      $mdSidenav(componentId).toggle();
    };
  }
  vm.isLoading = false;
  vm.currentTab = 0;
  vm.showonlyUnread = true;
  vm.pagination = {
    itemsPerPage: 50,
    page: 1,
    sort: "asc",
    sortBy: { isRead: false },
    totalRecords: 0,
  };
  vm.allSelected = false;

  vm.$onInit = function () {
    setTimeout(function () {
      vm.getNotifications();
    }, 1000);// e
  };

  vm.loadMore = function () {
    // vm.pagination.itemsPerPage += 20;
    // vm.pagination.page += 1
    vm.getNotifications();
  };

  vm.refreshList = function () {
    // vm.pagination.itemsPerPage = 20;
    vm.pagination.page = 1
    vm.getNotifications();
    vm.isLoading = false;
  };

  vm.getNotifications = function () {
    vm.isLoading = true;
    var promises = [
      $notificationsService.getNotificationsCount(),
      $notificationsService.getNotifications(vm.pagination, vm.showonlyUnread),
    ];

    Promise.all(promises)
      .then(function (res) {
        vm.notificationsCount = res[0];
        vm.notificationsTabs = res[1].notifications;
      })
      .then(function () {
        vm.currentNotifications = null;

        var indexTabWithData = vm.notificationsTabs.findIndex(function (tab) {
          return tab.notifications.length > 0;
        });

        vm.setTab(indexTabWithData);

        vm.isLoading = false;
      });
  };

  vm.setTab = function (index) {
    if (index === -1) {
      vm.currentNotifications = [];
      vm.pagination.totalRecords = 0;
      vm.pagination.items = 0;
    } else {
      vm.currentTab = index;
      var tab = vm.notificationsTabs[vm.currentTab];
      vm.currentNotifications = tab.notifications;
      vm.pagination.totalRecords = tab.pagination.totalRecords;
      vm.pagination.items = tab.pagination.items;
    }
  };

  vm.onChangeShowonlyUnread = function () {
    vm.allSelected = false;
    vm.getNotifications();
  };

  vm.onSelectAll = function () {
    if (!vm.currentNotifications) return;

    if (vm.currentNotifications.length == 0) return;

    vm.currentNotifications.map(function (e) {
      e.selected = vm.allSelected;
      return e;
    });
  };

  vm.markAllAsRead = function () {
    $notificationsFactory
      .markAllRead()
      .then(function () {
        vm.getNotifications();
      })
      .catch(function (err) {
        console.error("Error@markAllRead", err);
      });
  };
}

(function () {
  'use strict';

  angular.module('dashboard').service('mainMenuService', mainMenuService);

  mainMenuService.$inject = ['translationService'];
  function mainMenuService($translationService) {
    this.menuName = function (keyName) {
      var menu = {
        dashboard: $translationService.getTranslationController(
          'Dashboard',
          'Dashboard',
          'Dashboard'
        ),
        issue: $translationService.getTranslationController(
          'Gestión de issues',
          'Issue management',
          'Gerenciamento de problemas'
        ),
        customreports: $translationService.getTranslationController(
          'Reportes personalizados',
          'Custom reports',
          'Custom reports'
        ),
        events: $translationService.getTranslationController(
          'Eventos',
          'Events',
          'Events'
        ),
        rankings: $translationService.getTranslationController(
          'Clasificaciones',
          'Rankings',
          'classificações'
        ),
        cases: $translationService.getTranslationController(
          'Casos',
          'Cases',
          'Casos'
        ),
        rules: $translationService.getTranslationController(
          'Reglas',
          'Rules',
          'reglas'
        ),
        ruleEditor: $translationService.getTranslationController(
          'Reglas',
          'Rules',
          'Regras'
        ),
        realtime: $translationService.getTranslationController(
          'Reglas en tiempo real',
          'Realtime rules',
          'Reglas en tiempo real'
        ),
        filters: $translationService.getTranslationController(
          'Filtros',
          'Filters',
          'Filtros'
        ),
        schedules: $translationService.getTranslationController(
          'Horarios',
          'Schedules',
          'Horários'
        ),
        dataConection: $translationService.getTranslationController(
          'Conexión de datos',
          'Data connection',
          'Conexão de dados'
        ),
        data: $translationService.getTranslationController(
          'Datos',
          'Data',
          'Datos'
        ),
        list: $translationService.getTranslationController(
          'Listas',
          'List',
          'Listas'
        ),
        schemas: $translationService.getTranslationController(
          'Esquemas',
          'Schemas',
          'Esquemas'
        ),
        searcher: $translationService.getTranslationController(
          'Buscador',
          'Searcher',
          'Pesquisar'
        ),
        series: $translationService.getTranslationController(
          'Series',
          'Series',
          'Series'
        ),
        reports: $translationService.getTranslationController(
          'Reportes',
          'Reports',
          'Relatórios'
        ),
        graphic: $translationService.getTranslationController(
          'Reportes gráficos',
          'Graphic reports',
          'Relatórios gráficos'
        ),
        powerBi: $translationService.getTranslationController(
          'Reportes BI',
          'BI Reports',
          'Relatórios BI'
        ),
        graphics: $translationService.getTranslationController(
          'Gráficos',
          'Graphics',
          'Gráficos'
        ),
        security: $translationService.getTranslationController(
          'Seguridad',
          'Security',
          'Segurança'
        ),
        users: $translationService.getTranslationController(
          'Usuarios',
          'Users',
          'Usuários'
        ),
        groups: $translationService.getTranslationController(
          'Grupos',
          'Groups',
          'Grupos'
        ),
        sistem: $translationService.getTranslationController(
          'Registro de sistema',
          'Sistem log',
          'Registro de sistema'
        ),
        global: $translationService.getTranslationController(
          'Configuración Global',
          'Global setting',
          'Configuração Global'
        ),
        files: $translationService.getTranslationController(
          'Almacenamiento de archivos',
          'Files storage',
          'Armazenamento de arquivos'
        ),
        documentation: $translationService.getTranslationController(
          'Documentación',
          'Documentation',
          'Documentação'
        ),
        system: $translationService.getTranslationController(
          'Sistema',
          'System',
          'Sistema'
        ),
        indicators: $translationService.getTranslationController(
          'Indicadores',
          'Indicators',
          'Indicadores'
        ),
        dataManagement: $translationService.getTranslationController(
          'Gestión de datos',
          'Data management',
          'Gestão de dados'
        ),
        tokensManager: $translationService.getTranslationController(
          'Gestión de tokens',
          'Tokens management',
          'Gestão de tokens'
        ),
        ethicalPortal: $translationService.getTranslationController(
          'Portal ético',
          'Ethical portal',
          'Portal ético'
        ),
        ethicalPortalCompanies: $translationService.getTranslationController(
          'Empresas',
          'Companies',
          'Empresas'
        ),
        ethicalPortalForm: $translationService.getTranslationController(
          'Formulario',
          'Form',
          'Formulário'
        ) 
      };

      return menu[keyName] || 'no name';
    };
  }
})();

"use strict";
var app = angular.module("dashboard");

app.component("mainMenu", {
  templateUrl: "app/main/components/main-menu/main-menu.html",
  controllerAs: "menu",
  bindings: {
    isOpen: "@",
    onUpdateFavs: "="
  },
  controller: mainMenuController
});

mainMenuController.$inject = [
  "$scope",
  "$state",
  "$rootScope",
  "$localStorageService",
  "mainMenuService",
  "PermissionsFactory",
  "IssuesFactory",
  "translationService",
  "ExternalLibrariesFactory"
];
function mainMenuController(
  $scope,
  $state,
  $rootScope,
  $localStorageService,
  $mainMenuService,
  PermissionsFactory,
  IssuesFactory,
  $translationService,
  $externalLibrariesFactory
) {
  var vm = this;
  vm.favs = [];
  vm.noMenu = false;
  $translationService.getTranslation($scope, "includes");

  $scope.$on("rebuildMainMenu", function () {
    console.log("rebuildMainMenu");
    vm.$onInit();
  });

  vm.$onInit = function () {
    /*
     * Maintain this func to preview auto opening of the menu at start
     */
    $scope.loadFavs();

    if (vm.validatePermission(["issues:read"])) {
      IssuesFactory.getIssuesCategories()
        .then(function (res) {
          var userAssignedCategories = res.data.filter(function (catg) {
            if (PermissionsFactory.hasCategory(catg.name)) {
              return catg;
            }
          });
          userAssignedCategories.forEach(function (e) {
            var category = {
              name: e.label || e.name,
              fav: false,
              rute: "dashboard",
              url: "dashboard/" + e.name + "/index",
              icon: null,
              cepIcon: e.icon,
              cepColor: e.color,
              hasPermission: ["issues:read"]
            };
            var issuesMenu = vm.mainMenu.find(function (e) {
              return e.id === "issues";
            });

            var existCategory = issuesMenu.submenu.rutes.some(function (e) {
              return e.name === category.name;
            });

            if (!existCategory) issuesMenu.submenu.rutes.push(category);
          });
          $scope.loadFavs();
        })
        .catch(function (err) {
          console.error("Error@getIssuesCategories", err);
        });
    }

    // if (vm.validatePermission(["dashboard:read", "custom-report:read"])) {
    //   CustomReportFactory.getCustomReports()
    //     .then(function (res) {
    //       res.data.forEach(function (e) {
    //         var customreport = {
    //           name: e.name,
    //           fav: false,
    //           rute: "dashboard",
    //           url: "custom-report/" + e.id + "/" + e.name,
    //           icon: e.html === "" ? "cep-folder-open" : e.html,
    //           hasPermission: [
    //             "dashboard:read",
    //             "custom-report#" + e.id + ":read",
    //           ],
    //         };
    //         var customReportMenu = vm.mainMenu.find(function (e) {
    //           return e.id === "custom-reports";
    //         });

    //         var existCustomReport = customReportMenu.submenu.rutes.some(
    //           function (e) {
    //             return e.name === customreport.name;
    //           }
    //         );

    //         if (!existCustomReport)
    //           customReportMenu.submenu.rutes.push(customreport);
    //       });
    //       $scope.loadFavs();
    //     })
    //     .catch(function (err) {
    //       console.error("Error@getIssuesCategories", err);
    //     });
    // }

    if (vm.validatePermission(["python-library:read"])) {
      $externalLibrariesFactory
        .getAllActivePythonLibraries()
        .then(function (res) {
          if (res.length === 0) {
            vm.mainMenu.find(function (e) {
              return e.id === "external-libraries";
            }).show = false;

            return;
          }

          vm.mainMenu.find(function (e) {
            return e.id === "external-libraries";
          }).submenu.rutes = [];

          res
            .filter(function (e) {
              return e.active === true;
            })
            .forEach(function (e) {
              var exli = {
                name: e.name,
                fav: false,
                rute: "dashboard",
                url: "external-libraries/" + e.id,
                icon: "python",
                hasPermission: ["python-library:read"]
              };
              var externalLibrariesMenu = vm.mainMenu.find(function (e) {
                return e.id === "external-libraries";
              });

              var existCustomReport = externalLibrariesMenu.submenu.rutes.some(
                function (e) {
                  return e.name === exli.name;
                }
              );

              if (!existCustomReport)
                externalLibrariesMenu.submenu.rutes.push(exli);
            });
          $scope.loadFavs();
        })
        .catch(function (err) {
          console.error("Error@getIssuesCategories", err);
        });
    }
  };

  vm.toggleMenu = function () {
    vm.isOpen = !vm.isOpen;
    $rootScope.$broadcast("toggleMenu");
  };

  $scope.$watch(
    function () {
      return vm.isOpen;
    },
    function (newValue) {
      vm.isOpen = newValue;

      var hasBtns = document.querySelectorAll(
        ".modal-menu-content .modal-menu-btn"
      ).length;
      vm.noMenu = hasBtns === 0;
    }
  );

  $scope.$watch(
    function () {
      return vm.onUpdateFavs;
    },
    function (newValue) {
      vm.onUpdateFavs = newValue;
    }
  );

  $scope.$watch(
    function () {
      return $state.current.name;
    },
    function (newValue) {
      vm.isOpen = false;
    }
  );

  vm.mainMenu = [
    {
      id: "home",
      name: $mainMenuService.menuName("dashboard"),
      rute: "home",
      url: "home",
      icon: "dashboard",
      hasPermission: ["dashboard:read"],
      fav: false,
      submenu: {
        fliped: false,
        rutes: []
      },
      hotkey: "alt+d",
      show: true
    },
    {
      id: "issues",
      name: $mainMenuService.menuName("issue"),
      rute: "dashboard",
      url: "dashboard",
      icon: "issue-management",
      hasPermission: ["issues:read"],
      fav: false,
      submenu: {
        fliped: false,
        rutes: []
      },
      show: true
    },
    // {
    //   id: "custom-reports",
    //   name: $mainMenuService.menuName("customreports"),
    //   rute: "dashboard",
    //   url: "dashboard",
    //   icon: "custom-reports",
    //   hasPermission: ["custom-report:read"],
    //   fav: false,
    //   submenu: {
    //     fliped: false,
    //     rutes: [],
    //   },
    //   show: true,
    // },
    {
      id: "external-libraries",
      name: "External Libraries",
      rute: "dashboard",
      url: "dashboard",
      icon: "python",
      hasPermission: ["python-library:read"],
      fav: false,
      submenu: {
        fliped: false,
        rutes: []
      },
      show: true
    },
    {
      id: "cases",
      name: $mainMenuService.menuName("cases"),
      rute: "casos",
      url: "casos/",
      icon: "cases",
      hasPermission: ["cases:read"],
      fav: false,
      submenu: {
        fliped: false,
        rutes: []
      },
      hotkey: "alt+c",
      show: true
    },
    {
      id: "rules",
      name: $mainMenuService.menuName("rules"),
      rute: "",
      url: "",
      icon: "rules",
      hasPermission: [
        "function:read",
        "function:read-filter",
        "function:read-schedule"
      ],
      fav: false,
      submenu: {
        fliped: false,
        rutes: [
          {
            id: "rules-list",
            name: $mainMenuService.menuName("rules"),
            fav: false,
            rute: "rules",
            url: "rules",
            icon: "rules-list",
            hasPermission: ["function:read"],
            hotkey: "alt+r"
          },
          {
            id: "realtime-rules-list",
            name: $mainMenuService.menuName("realtime"),
            fav: false,
            rute: "realtime-rules",
            url: "rules/realtime",
            icon: "realtime-rules",
            hasPermission: ["function:read"],
            hotkey: "alt+r"
          },
          {
            id: "rule-schedules",
            name: $mainMenuService.menuName("schedules"),
            fav: false,
            rute: "rule-schedules",
            url: "rules/schedules",
            icon: "rule-schedules",
            hasPermission: ["function:read-schedule"]
          },
          {
            id: "data-connection",
            name: $mainMenuService.menuName("data"),
            fav: false,
            rute: "data-conn",
            url: "connections",
            icon: "data-connection",
            hasPermission: ["configuration:read"]
          }
        ]
      },
      show: true
    },
    {
      id: "data",
      name: $mainMenuService.menuName("data"),
      rute: "",
      url: "",
      icon: "data",
      hasPermission: [
        "list:read",
        "schema:read",
        "searcher:read",
        "data-management:read"
      ],
      fav: false,
      submenu: {
        rutes: [
          {
            id: "list",
            name: $mainMenuService.menuName("list"),
            fav: false,
            rute: "schemasLists",
            url: "entries/lists",
            icon: "data-list",
            hasPermission: ["list:read"],
            hotkey: "alt+l"
          },
          {
            id: "schemas",
            name: $mainMenuService.menuName("schemas"),
            fav: false,
            rute: "schemas",
            url: "entries/schemas",
            icon: "data-schemas",
            hasPermission: ["schema:read"]
          },
          // {
          //   id: "searcher",
          //   name: $mainMenuService.menuName("searcher"),
          //   fav: false,
          //   rute: "searcher-list",
          //   url: "entries/searcher/config",
          //   icon: "data-searcher",
          //   hasPermission: ["searcher:read"],
          // },
          // {
          //   id: "series",
          //   name: $mainMenuService.menuName("series"),
          //   rute: "series",
          //   url: "replay/config/series",
          //   icon: "data-series",
          //   fav: false,
          //   hasPermission: ["series:read"],
          // },
          {
            id: "data-management",
            name: $mainMenuService.menuName("dataManagement"),
            rute: "data-management",
            url: "data-management",
            icon: "data-management",
            fav: false,
            hasPermission: ["data-management:read"]
          }
        ]
      },
      show: true
    },
    {
      id: "reports",
      name: $mainMenuService.menuName("reports"),
      rute: "",
      url: "",
      icon: "graphics",
      hasPermission: [
        "graphic-report:read",
        "report-bi:read",
        "custom-report:read"
      ],
      fav: false,
      submenu: {
        rutes: [
          {
            id: "graphic-reports",
            name: $mainMenuService.menuName("graphic"),
            fav: false,
            icon: "graphic-reports",
            rute: "graphic-reports",
            url: "graphic-reports",
            hasPermission: ["graphic-report:read"]
          },
          {
            id: "reports-bi",
            name: $mainMenuService.menuName("powerBi"),
            fav: false,
            icon: "graphic-bi",
            rute: "bi-reports",
            url: "bi-reports",
            hasPermission: ["report-bi:read"]
          },
          {
            id: "charts",
            name: $mainMenuService.menuName("graphics"),
            fav: false,
            icon: "graphic-charts",
            rute: "charts",
            url: "charts/",
            hasPermission: ["graphic-report:read"]
          },
          {
            id: "custom-reports",
            name: $mainMenuService.menuName("customreports"),
            fav: false,
            icon: "custom-reports",
            rute: "custom-report",
            url: "custom-report",
            hasPermission: ["custom-report:read"]
          }
        ]
      },
      show: true
    },
    {
      id: "ethical-portal",
      name: $mainMenuService.menuName("ethicalPortal"),
      rute: "ethical-portal",
      url: "ethical-portal/company",
      icon: "ethical-portal",
      hasPermission: ["ethical-portal:read"],
      fav: false,
      submenu: {
        fliped: false,
        rutes: []
      },
      show: true
    },
    {
      id: "files-storage",
      name: $mainMenuService.menuName("files"),
      rute: "files-storage",
      url: "files-storage",
      icon: "files-storage",
      hasPermission: ["files-storage:read"],
      fav: false,
      submenu: {
        fliped: false,
        rutes: []
      },
      hotkey: "alt+s",
      show: true
    },
    {
      id: "security",
      name: $mainMenuService.menuName("security"),
      rute: "",
      url: "",
      icon: "security",
      hasPermission: ["user:read", "acl:read", "group:read", "audit:read"],
      fav: false,
      submenu: {
        rutes: [
          {
            id: "acl",
            name: "ACL",
            fav: false,
            rute: "acl",
            url: "access-control-list",
            icon: "acl",
            hasPermission: ["acl:read"]
          },
          {
            id: "users",
            name: $mainMenuService.menuName("users"),
            fav: false,
            rute: "usuarios",
            url: "usuarios",
            icon: "users",
            hasPermission: ["user:read"]
          },
          {
            id: "groups",
            name: $mainMenuService.menuName("groups"),
            fav: false,
            rute: "group/config",
            url: "group/config",
            icon: "groups",
            hasPermission: ["group:read"]
          }
        ]
      },
      show: true
    },
    {
      id: "system",
      name: $mainMenuService.menuName("system"),
      rute: "",
      url: "",
      icon: "system",
      hasPermission: ["configuration:read", "audit:read"],
      fav: false,
      submenu: {
        rutes: [
          {
            id: "sistem-log",
            name: $mainMenuService.menuName("sistem"),
            fav: false,
            rute: "audit",
            url: "audit",
            icon: "log",
            hasPermission: ["audit:read"]
          },
          {
            id: "global-config",
            name: $mainMenuService.menuName("global"),
            fav: false,
            rute: "configuration",
            url: "configuration",
            icon: "global-settings",
            hasPermission: ["configuration:read"]
          },
          {
            id: "tokens",
            name: $mainMenuService.menuName("tokensManager"),
            fav: false,
            rute: "tokens-manager",
            url: "tokens-manager",
            icon: "tokens",
            hasPermission: ["configuration:read"]
          }
        ]
      },
      show: true
    },

    {
      id: "indicators",
      name: $mainMenuService.menuName("indicators"),
      rute: "indicators",
      url: "indicators",
      icon: "indicators",
      hasPermission: ["indicators:read"],
      fav: false,
      submenu: {
        fliped: false,
        rutes: []
      },
      show: true
    },
    {
      id: "docs",
      name: $mainMenuService.menuName("documentation"),
      rute: "docs",
      url: "docs",
      icon: "documetation",
      hasPermission: ["documentation:read"],
      fav: false,
      submenu: {
        fliped: false,
        rutes: []
      },
      show: true
    }
  ];

  $scope.loadFavs = function () {
    var favs = $localStorageService.getItem("favs");
    if (angular.isArray(favs)) {
      try {
        favs.forEach(function (fav) {
          var ref = fav.split("-");
          var a = ref[0];
          var b = ref[1];
          if (ref.length == 1) {
            if (vm.mainMenu[a]) {
              vm.mainMenu[a].fav = true;
            }
          } else {
            if (vm.mainMenu[a] && vm.mainMenu[a].submenu.rutes[b]) {
              vm.mainMenu[a].submenu.rutes[b].fav = true;
            }
          }
        });
        vm.onUpdateFavs = vm.mainMenu;
      } catch (err) {
        console.error(err);
      }
    }
  };
  $scope.loadFavs();

  $scope.toggleFav = function (parent, child) {
    if (child == undefined) {
      vm.mainMenu[parent].fav = !vm.mainMenu[parent].fav;
      $scope.setFavs(parent, vm.mainMenu[parent].fav);
    } else {
      vm.mainMenu[parent].submenu.rutes[child].fav =
        !vm.mainMenu[parent].submenu.rutes[child].fav;
      $scope.setFavs(
        parent + "-" + child,
        vm.mainMenu[parent].submenu.rutes[child].fav
      );
    }
    vm.onUpdateFavs = vm.mainMenu;
  };

  $scope.setFavs = function (ref, status) {
    var favs = $localStorageService.getItem("favs");
    if (!angular.isArray(favs)) {
      favs = [];
    }

    var ls = favs;
    var stored = ls;
    if (status) {
      //save
      stored.push(ref + "");
      $localStorageService.setItem("favs", stored);
    }
    if (!status) {
      //delete
      var fiterStored = stored.filter(function (e) {
        return e != ref;
      });
      $localStorageService.setItem("favs", fiterStored);
    }
    $scope.loadFavs();
    vm.onUpdateFavs = vm.mainMenu;
  };

  vm.clickMainMenu = function (ele, event) {
    console.log(ele, event);
    if (event == "changeState") {
      var state = "app." + ele.rute;
      if (state == "app.rules") {
        // AlertasConfig.obtenerAlertas(function (response) {
        //     if (response.header.code == 0) {
        //         vm.alertasConfigSrc = response.body;
        //         vm.alertasConfig = [].concat(vm.alertasConfigSrc);
        //     }
        // });
      }
      $state.go(state);
      vm.isOpen = false;
    } else if (event == "showSubMenu") {
      ele.submenu.fliped = true;
    } else if (event == null) {
      vm.isOpen = false;
    } else {
      vm.isOpen = false;
      // console.error('OoopS!')
    }
  };

  vm.validatePermission = function (permissions) {
    var flag = false;
    for (var i = 0; i < permissions.length; i++) {
      flag = PermissionsFactory.hasPermission(permissions[i]);
      if (flag == true) {
        return flag;
      }
    }
    return flag;
  };

  $scope.$on("refreshMaiMenu", function () {
    vm.$onInit();
  });
}

'use strict';

var app = angular.module('dashboard');

app.component('listsListItem', {
  templateUrl: 'app/lists/components/lists-list-item/lists-list-item.html',
  controllerAs: 'ctrl',
  bindings: {
    item: '=',
    schemas: '<',
    translation: '<',
  },
  controller: ListsListItemController,
});

ListsListItemController.$inject = [
  '$state',
  '$rootScope',
  'translationService',
  '$mdDialog',
  'toastr',
  'listExporterService',
  'InputListsFactory',
  'SelectedSchema',
];
function ListsListItemController(
  $state,
  $rootScope,
  $translationService,
  $mdDialog,
  $toastr,
  $listExporterService,
  $inputListsFactory,
  $selectedSchemaFactory
) {
  var vm = this;

  vm.viewList = function (listId) {
    $state.go('app.inputList', { action: 'GET', listId: listId });
  };

  vm.viewTable = function (listId, filter) {
    $state.go('app.tableList', {
      action: 'GET',
      listId: listId,
      filter: filter,
    });
  };

  vm.viewTable = function (listId, filter) {
    $state.go('app.tableList', {
      action: 'GET',
      listId: listId,
      filter: filter,
    });
  };

  vm.showCreateListDialog = function (ev, list) {
    $inputListsFactory.setSelectedList(list);
    $mdDialog.show({
      controller: 'ListDialogController',
      templateUrl: 'app/lists/components/create-list/dialog-create-list.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose: false,
      locals: {
        groupPath: null,
      },
    });
  };

  vm.showSchemaDialog = function (ev, schema) {
    $selectedSchemaFactory.setSchema(schema);
    $mdDialog.show({
      controller: 'HotCreateSchemasController',
      controllerAs: 'ctrl',
      templateUrl:
        'app/schemas/partials/hot-create-schema/hot-dialog-create-schemas.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose: false,
      escapeToClose: false,
      locals: {
        complexSchemas: vm.schemas.data
          .filter(function (e) {
            return e.type == 'COMPLEX';
          })
          .map(function (e) {
            return { id: e.id, name: e.name };
          }),
        groupPath: null,
      },
    });
  };

  vm.deleteList = function (ev, list) {
    var confirm = $mdDialog
      .confirm()
      .title(
        $translationService.getTranslationController(
          '¿Eliminar lista: ',
          'Delete list ',
          'Excluir lista?'
        ) +
          list.name +
          '?'
      )
      .textContent(
        $translationService.getTranslationController(
          '¡Cuidado!, Esta acción no puede revertirse.',
          'Atention!, This action can not be reversed.',
          'Atenção!, esta ação não pode ser revertida.'
        )
      )
      .ariaLabel('Delete-Question')
      .targetEvent(ev)
      .ok(
        $translationService.getTranslationController(
          'Si, Elimínala',
          'Yes, Delete it',
          'Sim, exclua'
        )
      )
      .cancel(
        $translationService.getTranslationController(
          'Aún no',
          'Not yet',
          'Ainda não'
        )
      );

    $mdDialog.show(confirm).then(
      function () {
        $rootScope.loading = true;
        $inputListsFactory
          .deleteList(list.listId)
          .then(function (res) {
            if (res == true) {
              $toastr.info(
                $translationService.getTranslationController(
                  'Lista eliminada.',
                  'List deleted.',
                  'Lista excluída.'
                )
              );
              $rootScope.$broadcast('listUpdated');
            } else {
              $toastr.info(
                $translationService.getTranslationController(
                  'No se ha podido eliminar la lista.',
                  'The list could not be deleted.',
                  'A lista não pôde ser excluída.'
                )
              );
              $rootScope.loading = false;
            }
          })
          .catch(function (err) {
            if (err) {
              $toastr.info(err);
            } else {
              $toastr.info(
                $translationService.getTranslationController(
                  'No se ha podido eliminar.',
                  'The list could not be deleted.',
                  'A lista não pôde ser excluída.'
                )
              );
            }
            console.log('Error@deleteList', err);
            $rootScope.loading = false;
          });
      },
      function () {}
    );
  };

  vm.showShareEntityDialog = function (ev, selectedItem) {
    $mdDialog.show({
      controller: 'ShareEntityController',
      templateUrl: 'app/acl/component/dialog-share-entity.html',
      parent: angular.element(document.body),
      clickOutsideToClose: false,
      targetEvent: ev,
      locals: {
        selectedItem: {
          id: selectedItem.listId,
          resource: 'list',
          name: selectedItem.name,
        },
        actions: ['read', 'update', 'delete'],
      },
    });
  };

  vm.exportList = function (inputList, ext) {
    $rootScope.loading = true;
    vm.exportingList = ext;
    console.log('exportList', ext, false, inputList);
    $listExporterService
      .execute(ext, false, inputList)
      .then(function () {
        $toastr.success(
          $translationService.getTranslationController(
            'Lista descargada',
            'List downloaded',
            'Lista baixada'
          )
        );
      })
      .catch(function (error) {
        console.log('Error@listExporterService', error);
        $toastr.error(
          $translationService.getTranslationController(
            'Se ha producido un error al exportar',
            'An error occurred while exporting',
            'Ocorreu um erro ao exportar'
          )
        );
      })
      .finally(function () {
        $rootScope.loading = false;
        vm.exportingList = false;
      });
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('listsGroupItem', {
  templateUrl: 'app/lists/components/lists-group-item/lists-group-item.html',
  controllerAs: 'ctrl',
  bindings: {
    group: '=',
    schemas: '<',
    translation: '<',
    displayItems: '=',
  },
  controller: listsGroupItemController,
});

listsGroupItemController.$inject = [
  '$scope',
  '$rootScope',
  '$mdDialog',
  'toastr',
  'translationService',
  'listExporterService',
  'InputListsFactory',
];
function listsGroupItemController(
  $scope,
  $rootScope,
  $mdDialog,
  $toastr,
  $translationService,
  $listExporterService,
  $inputListsFactory
) {
  var vm = this;

  function setGroups() {
    vm.group.subGroup = [];
    for (var key in vm.group) {
      var val = vm.group[key];
      if (key.includes('folder:')) vm.group.subGroup.push(val);
    }
  }
  setGroups();

  vm.toggleItems = function () {
    vm.group.isOpen = !vm.group.isOpen;
  };

  $scope.$on('displayItems', function (e, display) {
    vm.displayItems = display;
    vm.group.isOpen = display;
    setGroups();
  });

  vm.showGroupCreateListDialog = function (ev, list) {
    $inputListsFactory.setSelectedList(list);
    $mdDialog.show({
      controller: 'ListDialogController',
      templateUrl: 'app/lists/components/create-list/dialog-create-list.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose: false,
      locals: {
        groupPath: vm.group.path,
      },
    });
  };

  function _exportList(inputList, ext) {
    return $listExporterService.execute(ext, false, inputList);
  }

  vm.bulkExportLists = function (index, ext) {
    if (!vm.group.items.length) {
      $toastr.info(
        $translationService.getTranslationController(
          'No hay elementos para descargar',
          'There are no items to download',
          'Não há itens para baixar'
        )
      );
    }

    var index = index || 0;

    if (vm.group.items.length > index) {
      $rootScope.loading = true;
      vm.exportingLists = ext;

      var list = vm.group.items[index];

      $toastr.info(
        $translationService.getTranslationController(
          'Exportando lista: ',
          'Exporting list: ',
          'Exportando lista: '
        ) + list.name
      );

      $listExporterService
        .execute(ext, false, list)
        .then(function () {
          vm.bulkExportLists(++index, ext);
        })
        .catch(function (error) {
          console.log('Error@bulkExportLists', error);
          $toastr.error(
            $translationService.getTranslationController(
              'Se ha producido un error al exportar',
              'An error occurred while exporting',
              'Ocorreu um erro ao exportar'
            )
          );

          $rootScope.loading = false;
          vm.exportingLists = false;
        });
    } else {
      $toastr.success(
        $translationService.getTranslationController(
          'Listas descargadas',
          'Lists downloaded',
          'Listas baixadas'
        )
      );

      $rootScope.loading = false;
      vm.exportingLists = false;
    }
  };
}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('ListDialogController', ListDialogController);

  ListDialogController.$inject = [
    '$scope',
    '$rootScope',
    '$mdDialog',
    'toastr',
    'translationService',
    'SchemasFactory',
    'InputListsFactory',
    '$filter',
    'PermissionsFactory',
    'listsToGroups',
    '$state',
    'groupPath',
  ];
  function ListDialogController(
    $scope,
    $rootScope,
    $mdDialog,
    toastr,
    $translationService,
    SchemasFactory,
    InputListsFactory,
    $filter,
    PermissionsFactory,
    $listsToGroups,
    $state,
    groupPath
  ) {
    $scope.groupPath = groupPath || null;
    $translationService.getTranslation($scope, 'schemas');
    $scope.getSchemas = function () {
      $rootScope.loading = true;
      SchemasFactory.getSchemas()
        .then(function (res) {
          $rootScope.loading = false;
          $scope.schemasList = res;
          $scope.schemasList.data = $scope.schemasList.data
            .map(function (e) {
              e.schema = angular.fromJson(e.schema);
              return e;
            })
            .sort(function (a, b) {
              return a.id - b.id;
            });
          if ($scope.listSchema) {
            $scope.getSelectedSchema($scope.listSchema);
          }
        })
        .catch(function (err) {
          $rootScope.loading = false;
          toastr.info(
            $translationService.getTranslationController(
              'No se han podido obtener los esquemas.',
              'The schemas could not be loaded.',
              'Os esquemas não puderam ser carregados.'
            )
          );
          console.log('Error@getSchemas', err);
        });
    };
    $scope.getSchemas();

    $scope.getSelectedSchema = function (id) {
      $scope.listSchema = id;
      $scope.selectedSchemaObject = $scope.schemasList.data.find(function (e) {
        return e.id == id;
      });
      parseSchema($scope.selectedSchemaObject);
    };

    function parseSchema(_schema) {
      if (!_schema) return false;
      if (typeof _schema.schema.definitions === 'string') {
        _schema.schema.definitions = angular.fromJson(
          _schema.schema.definitions
        );
        _schema.schema.definitions[_schema.name].properties = angular.fromJson(
          _schema.schema.definitions[_schema.name].properties
        );
      }
      $scope.selectedSchema =
        _schema.schema.definitions[_schema.name].properties;
      $scope.selectedSchema = $filter('orderObjectBy')(
        $scope.selectedSchema,
        'order'
      );
      angular.forEach($scope.selectedSchema, function (col, index) {
        $scope.selectedSchema[index].required =
          _schema.schema.definitions[_schema.name].required.indexOf(index) > -1
            ? true
            : false;
        $scope.selectedSchema[index].pk =
          _schema.schema.definitions[_schema.name].required.indexOf(
            '#' + index
          ) > -1
            ? true
            : false;
      });
    }

    $scope.groups = [];
    InputListsFactory.getLists().then(function (res) {
      $scope.groups = $listsToGroups.createGroups(res.lists);
    });

    $scope.selectedList = InputListsFactory.getSelectedList();

    if ($scope.selectedList) {
      $scope.actionText = $translationService.getTranslationController(
        'Modificar Lista: ',
        'Modify List: ',
        'Modificar Lista: '
      );
      $scope.listId = $scope.selectedList.listId;
      var key = 'groups';
      if ($state.current.name == 'app.schemas') key = 'group';
      if ($state.current.name == 'app.schemasLists') key = 'groups';

      $scope.listName = $scope.selectedList.name;
      $scope.listGroups = $scope.selectedList[key];
      $scope.listSchema = $scope.selectedList.schema.id;
      $scope.generateLucene = $scope.selectedList.generateLucene;
    } else {
      $scope.actionText = $translationService.getTranslationController(
        'Crear Lista: ',
        'Create List: ',
        'Criar Lista: '
      );
      $scope.listId = null;
      $scope.listName = '';
      $scope.listGroups = $scope.groupPath ? $scope.groupPath : '';
      $scope.listSchema = null;
    }

    var validateData = function () {
      if (!$scope.listName) {
        toastr.info(
          $translationService.getTranslationController(
            '¡Debes agregar un nombre a la lista!',
            'You must add a list name!',
            'Você deve adicionar um nome de lista!'
          )
        );
        return false;
      }
      if (!$scope.listSchema) {
        toastr.info(
          $translationService.getTranslationController(
            '¡Debes establecer un esquema a la lista!',
            'You must add a schema!',
            'Você deve adicionar um esquema!'
          )
        );
        return false;
      }
      return true;
    };

    $scope.createList = function (ev) {
      if (!validateData()) {
        return false;
      }

      var confirm = $mdDialog
        .confirm()
        .multiple(true)
        .title(
          $translationService.getTranslationController(
            '¿Desea guardar la lista?',
            'Save List?',
            'Você quer salvar a lista?'
          )
        )
        .ariaLabel('Cancel-Question')
        .targetEvent(ev)
        .ok(
          $translationService.getTranslationController(
            'Si, Guárdala',
            'Yes, Save it',
            'Sim, salve'
          )
        )
        .cancel(
          $translationService.getTranslationController(
            'Aún no',
            'Not yet',
            'Ainda não'
          )
        );

      $mdDialog.show(confirm).then(
        function () {
          saveList();
        },
        function () {}
      );
    };

    function saveList() {
      var listToCreate = {
        listId: $scope.listId,
        name: $scope.listName,
        groups: $scope.listGroups,
        hash: '',
        schemaId: $scope.listSchema,
        generateLucene: $scope.generateLucene,
      };
      if (angular.isUndefined($scope.listId) || $scope.listId == null) {
        InputListsFactory.createList(listToCreate)
          .then(function (res) {
            toastr.info(
              $translationService.getTranslationController(
                'Lista guardada.',
                'List saved.',
                'Esquema salvo.'
              )
            );
            PermissionsFactory.addPermission('list', res.listId, 'all', true);
            $rootScope.$broadcast('listUpdated', res);
            $mdDialog.cancel();
          })
          .catch(function (err) {
            if (err) {
              toastr.info(err);
            } else {
              toastr.info(
                $translationService.getTranslationController(
                  'No se ha podido crear la lista.',
                  'Unable to create the list.',
                  'Não é possível criar a lista.'
                )
              );
            }
            console.log('Error@createList', err);
          });
      } else {
        InputListsFactory.updateList(listToCreate)
          .then(function (res) {
            toastr.info(
              $translationService.getTranslationController(
                'Lista guardada.',
                'List saved.',
                'Esquema salvo.'
              )
            );
            $rootScope.$broadcast('listUpdated', res);
            $mdDialog.cancel();
          })
          .catch(function (err) {
            if (err) {
              toastr.info(err);
            } else {
              toastr.info(
                $translationService.getTranslationController(
                  'No se ha podido actulizar la lista.',
                  'Unable to update the list.',
                  'Não é possível atualizar a lista.'
                )
              );
            }
            console.log('Error@updateList', err);
          });
      }
    }

    $scope.cancel = function (ev) {
      var confirm = $mdDialog
        .confirm()
        .multiple(true)
        .title(
          $translationService.getTranslationController(
            '¿Deseas cancelar?',
            'Do you want to cancel?',
            'Você quer cancelar?'
          )
        )
        .textContent(
          $translationService.getTranslationController(
            '¡Todos los cambios se perderán!',
            'All changes will be lost!',
            'Todas as alterações serão perdidas!'
          )
        )
        .ariaLabel('Cancel-Question')
        .targetEvent(ev)
        .ok(
          $translationService.getTranslationController(
            'Abandonar',
            'Leave',
            'Sair'
          )
        )
        .cancel(
          $translationService.getTranslationController(
            'Cancelar',
            'Cancel',
            'Cancelar'
          )
        );

      $mdDialog.show(confirm).then(
        function () {
          $mdDialog.cancel();
        },
        function () {}
      );
    };

    $scope.querySearch = function (query) {
      var results = query
          ? $scope.schemasList.data.filter(createFilterFor(query))
          : $scope.schemasList.data,
        deferred;
      return results;
    };

    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(array) {
        return array.name.toLowerCase().indexOf(lowercaseQuery) > -1;
      };
    }

    ///-- group selector
    $scope.loadingDialog = false;

    $scope.moveItemGroup = function () {
      $scope.list = [];
      $scope.loadingDialog = true;
      InputListsFactory.getLists()
        .then(function (res) {
          $scope.list = $listsToGroups.createGroups(res.lists, 'groups');
        })
        .then(function () {
          $scope.loadingDialog = false;
          $mdDialog
            .show({
              controller: 'folderSelectorController',
              controllerAs: 'ctrl',
              templateUrl:
                'app/app-utils/components/folder-selector/folder-selector.html',
              locals: {
                list: angular.copy($scope.list),
                item: $scope.data,
              },
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              multiple: true,
            })
            .then(function (groups) {
              $scope.listGroups = groups;
            });
        });
    };
  }
})();

"use strict";
var app = angular.module('dashboard');
app.component('linkedIssues', {
    templateUrl: 'app/issues/components/linkedIssues/linkedIssues.html',
    controllerAs: 'linkedIssues',
    bindings: {
        data: "=",
    },
    controller: linkedIssuesController,
});
linkedIssuesController.$inject = ['$scope', 'toastr'];
function linkedIssuesController($scope, toastr) {
    var vm = this;

}
"use strict";
var app = angular.module('dashboard');
app.component('historical', {
    templateUrl: 'app/issues/components/historical/historical.html',
    controllerAs: 'historical',
    bindings: {
        data: "=",
    },
    controller: historicalController,
});
historicalController.$inject = ['$scope', 'toastr'];
function historicalController($scope, toastr) {
    var vm = this;

}
"use strict";
var app = angular.module('dashboard');
app.component('evidences', {
    templateUrl: 'app/issues/components/evidences/evidences.html',
    controllerAs: 'evidence',
    bindings: {
        data: "=",
    },
    controller: evidencesController,
});
evidencesController.$inject = ['$scope', 'toastr'];
function evidencesController($scope, toastr) {
    var vm = this;
  
}
"use strict";
var app = angular.module('dashboard');
app.component('comments', {
    templateUrl: 'app/issues/components/comments/comments.html',
    controllerAs: 'comments',
    bindings: {
        data: "=",
    },
    controller: commentsController,
});
commentsController.$inject = ['$scope', 'toastr'];
function commentsController($scope, toastr) {
    var vm = this;

}
/**
 * Input list replace value dialog controller
 */

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('ListReplaceController', ListReplaceController);

  ListReplaceController.$inject = [
    '$scope',
    '$rootScope',
    '$mdDialog',
    'toastr',
    'translationService',
    'InputListsFactory',
    'listId',
    'cellValue',
    'colTypes',
  ];
  function ListReplaceController(
    $scope,
    $rootScope,
    $mdDialog,
    $toastr,
    $translationService,
    $inputListsFactory,
    listId,
    cellValue,
    colTypes
  ) {
    $translationService.getTranslation($scope, 'input-list');

    $scope.listId = listId;
    $scope.colTypes = colTypes;
    $scope.cellValue = cellValue;
    $scope.selectedCol = $inputListsFactory.getSelectedCol();
    $scope.recordsReplaced = false;

    $scope.findAndReplace = function () {
      $rootScope.loading = true;
      var options = {
        columnName: $scope.selectedCol,
        findValue: $scope.cellValue,
        replaceValue: $scope.replaceValue,
      };

      $inputListsFactory
        .findAndReplace($scope.listId, options)
        .then(function (res) {
          $scope.recordsReplaced = res;
          if ($scope.recordsReplaced) {
            $rootScope.$broadcast('listFiltered', {
              column: $scope.selectedCol,
              value: '',
              condition: '=',
              conditionValue: $scope.replaceValue,
            });
          } else {
            $rootScope.loading = false;
          }
        })
        .catch(function (err) {
          $toastr.warning(
            err +
              '\n <br> Col: ' +
              $scope.selectedCol +
              ', Type: ' +
              $scope.colTypes[$scope.selectedCol]
          );
          console.log('Error@findAndReplace', err);
          $rootScope.loading = false;
        });
    };

    $scope.close = function () {
      $mdDialog.hide();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('ListFormatController', ListFormatController);

  ListFormatController.$inject = [
    '$scope',
    '$mdDialog',
    'translationService',
    'toastr',
    'InputListsFactory',
    'formats',
    'schema',
    'listId',
  ];
  function ListFormatController(
    $scope,
    $mdDialog,
    $translationService,
    $toastr,
    $inputListsFactory,
    formats,
    schema,
    listId
  ) {
    $translationService.getTranslation($scope, 'input-list');
    var vm = this;
    vm.inputFormats = formats.date.input;
    vm.outputFormats = formats.date.output;
    vm.schema = schema;
    vm.translation = {
      bindFormatTooltip: $translationService.getTranslationController(
        'Enlazar formato en columnas del mismo tipo',
        'Bind formatting on columns of the same type',
        'Vincular formatação em colunas do mesmo tipo'
      ),
      formatsSaved: $translationService.getTranslationController(
        'Formatos guardados',
        'Formats Saved',
        'Formatos salvos'
      ),
      error: $translationService.getTranslationController(
        'Se ha producido un error',
        'An error has occurred',
        'Ocorreu um erro'
      ),
    };

    angular.forEach(vm.schema, function (value, key) {
      vm.schema[key].inputFormat = vm.schema[key].inputFormat
        ? vm.schema[key].inputFormat
        : vm.inputFormats[vm.schema[key].type]
        ? vm.inputFormats[vm.schema[key].type][0]
        : null;

      vm.schema[key].outputFormat = vm.schema[key].outputFormat
        ? vm.schema[key].outputFormat
        : vm.outputFormats[vm.schema[key].type]
        ? vm.outputFormats[vm.schema[key].type][0]
        : null;
    });

    vm.save = function () {
      var listFormats = {};
      angular.forEach(vm.schema, function (value, key) {
        var colId = value.pk ? '#' + key : key;
        listFormats[colId] = {
          type: value.type,
          outputFormat: value.outputFormat,
          inputFormat: value.inputFormat,
        };
      });

      $inputListsFactory
        .setSettings(listId, listFormats)
        .then(function (res) {
          var updatedFormats = JSON.parse(res.settings);

          $toastr.success(vm.translation.formatsSaved);
          $mdDialog.hide(updatedFormats);
        })
        .catch(function (err) {
          $toastr.warning(vm.translation.error);
          console.log('Error@setSettings', err);
        });
    };

    vm.bindFormat = function (selectedColumn, colType) {
      angular.forEach(vm.schema, function (e, key) {
        if (e.type == colType) {
          vm.schema[key].inputFormat = vm.schema[selectedColumn].inputFormat;
          vm.schema[key].outputFormat = vm.schema[selectedColumn].outputFormat;
        }
      });
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

/**
 * Input list filters dialog controller
 */

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('ListFiltersController', ListFiltersController);

  ListFiltersController.$inject = [
    '$scope',
    '$rootScope',
    '$mdDialog',
    'translationService',
    'InputListsFactory',
    'SchemasFactory',
    'cellValue',
    'dateFormat',
    'colTypes',
    'schema',
  ];
  function ListFiltersController(
    $scope,
    $rootScope,
    $mdDialog,
    $translationService,
    $inputListsFactory,
    $schemasFactory,
    cellValue,
    dateFormat,
    colTypes,
    schema
  ) {
    console.log('ListFiltersController');
    $translationService.getTranslation($scope, 'input-list');
    $scope.schema = schema;
    $scope.colTypes = colTypes;
    $scope.cellValue = cellValue;
    $scope.dateFormat = dateFormat || 'YYYY-MM-DD';
    $scope.selectedCol = $inputListsFactory.getSelectedCol();
    $scope.filterCondition = 'EQUAL';

    $scope.filterConditionValue = ['date', 'timestamp'].includes(
      $scope.colTypes[$scope.selectedCol]
    )
      ? moment($scope.cellValue)
      : ['time'].includes($scope.colTypes[$scope.selectedCol])
      ? moment('2019-01-01 ' + $scope.cellValue)
      : $scope.cellValue;

    $scope.filters = $inputListsFactory.getFilters();
    $scope.valueRequired = false;
    $scope.isPrimaryKey = $scope.selectedCol.indexOf('#') === 0 ? true : false;
    $scope.selectedColName =
      $scope.selectedCol.indexOf('#') === 0
        ? $scope.selectedCol.substring(1)
        : $scope.selectedCol;
    $scope.autocomplete = $scope.schema[$scope.selectedColName].autocomplete;

    if ($scope.colTypes[$scope.selectedCol] == 'timestamp') {
      $scope.dateFormat = $scope.dateFormat.split(' ');
    }

    var filterStrings = function (col) {
      return $scope.colTypes[col] == 'string' ? true : false;
    };

    var filterNumbers = function (col) {
      return $scope.colTypes[col] != 'string' ? true : false;
    };

    var parseTypes = function (val) {
      switch ($scope.colTypes[$scope.selectedCol]) {
        case 'date':
          return moment(val).format('YYYY-MM-DDTHH:mm:ss.SSSSSSSSS') + 'Z';
        case 'time':
          return moment(val).format('HH:mm:ss.SSSSSSSSS');
        case 'timestamp':
          return moment(val).format('YYYY-MM-DDTHH:mm:ss.SSSSSSSSS');
        case 'double':
          return parseFloat(val);
        case 'integer':
          return parseInt(val);
        default:
          return val;
      }
    };

    $scope.operations = [
      {
        operation: 'EQUAL',
        operator: '=',
        title: 'equal_to',
        required: true,
        disabled: false,
      },
      {
        operation: 'NOT_EQUAL',
        operator: '!=',
        title: 'not_equals_to',
        required: true,
        disabled: false,
      },
      {
        operation: 'LIKE',
        operator: '%%',
        title: 'text_contains',
        required: true,
        disabled: filterNumbers($scope.selectedCol),
      },
      {
        operation: 'LIKE_NOT_CONTAINS',
        operator: '!%%',
        title: 'text_not_contains',
        required: true,
        disabled: filterNumbers($scope.selectedCol),
      },
      {
        operation: 'GREATER_THAN',
        operator: '>',
        title: 'greater_than',
        required: true,
        disabled: filterStrings($scope.selectedCol),
      },
      {
        operation: 'GREATER_OR_EQUAL_THAN',
        operator: '>=',
        title: 'greater_equals_than',
        required: true,
        disabled: filterStrings($scope.selectedCol),
      },
      {
        operation: 'LESS_THAN',
        operator: '<',
        title: 'smaller_than',
        required: true,
        disabled: filterStrings($scope.selectedCol),
      },
      {
        operation: 'LESS_OR_EQUAL_THAN',
        operator: '<=',
        title: 'smaller_equals_than',
        required: true,
        disabled: filterStrings($scope.selectedCol),
      },
      {
        operation: 'IS_NULL',
        operator: 'isNull',
        title: 'null_cell',
        required: false,
        disabled: filterStrings($scope.selectedCol),
      },
      {
        operation: 'IS_NOT_NULL',
        operator: 'isNotNull',
        title: 'cell_is_not_null',
        required: false,
        disabled: filterStrings($scope.selectedCol),
      },
      {
        operation: 'IS_EMPTY',
        operator: 'isEmpty',
        title: 'empty_cell',
        required: false,
        disabled: filterNumbers($scope.selectedCol),
      },
      {
        operation: 'IS_NOT_EMPTY',
        operator: 'isNotEmpty',
        title: 'cell_is_not_empty',
        required: false,
        disabled: filterNumbers($scope.selectedCol),
      },
      {
        operation: 'none',
        operator: '',
        title: 'none',
        required: false,
        disabled: false,
      },
    ];

    if (
      $scope.filters.filterColumn == $scope.selectedCol &&
      $scope.filters.filterByConditions
    ) {
      var ope = $scope.operations.filter(function (e) {
        return e.operator == $scope.filters.filterByConditions[0].operation;
      });

      $scope.valueRequired = ope[0].required;
      $scope.filterCondition = ope[0].operation;

      if ($scope.colTypes[$scope.selectedCol] == 'time') {
        $scope.filterConditionValue = moment(
          '2019-01-01 ' + $scope.filters.filterByConditions[0].value
        );
      } else if (
        ['date', 'time', 'timestamp'].includes(
          $scope.colTypes[$scope.selectedCol]
        )
      ) {
        $scope.filterConditionValue = moment(
          $scope.filters.filterByConditions[0].value
        );
      } else {
        $scope.filterConditionValue =
          $scope.filters.filterByConditions[0].value;
      }
    }

    $scope.filter = function () {
      var ope = $scope.operations.filter(function (e) {
        return e.operation == $scope.filterCondition;
      });
      var value = parseTypes($scope.filterConditionValue);

      if (
        ['IS_NULL', 'IS_NOT_NULL', 'IS_EMPTY', 'IS_NOT_EMPTY'].includes(
          ope[0].operator
        )
      ) {
        value = '';
      }

      $rootScope.$broadcast('listFiltered', {
        column: $scope.selectedCol,
        value: $scope.filterValue,
        condition: ope[0].operator,
        operation: ope[0].operation,
        conditionValue: value,
      });

      $mdDialog.cancel();
    };

    $scope.isValueRequired = function () {
      var ope = $scope.operations.filter(function (e) {
        return e.operation == $scope.filterCondition;
      });
      $scope.valueRequired = ope[0].required;
    };

    $scope.cancel = function () {
      $mdDialog.cancel();
    };

    // ***** AUTOCOMPLETE
    $scope.selectedItem = null;
    $scope.querySearch = function (query) {
      var pkId = $scope.isPrimaryKey ? '%23' : '';
      return $schemasFactory
        .getSchemaAutocomplete(
          'list',
          pkId + $scope.selectedColName,
          null,
          query
        )
        .then(function (response) {
          return response;
        })
        .catch(function (e) {
          console.log(e);
          return e;
        });
    };
  }
})();

"use strict";

var app = angular.module("dashboard");

app.component("workQueueWidget", {
  templateUrl: "app/home/widgets/work-queue/work-queue.html",
  controllerAs: "ctrl",
  bindings: {
    menu: "=?",
  },
  controller: workQueueWidgetController,
});

workQueueWidgetController.$inject = [
  "$scope",
  "$interval",
  "$timeout",
  "translationService",
  "DashboardFactory",
  "PermissionsFactory",
];
function workQueueWidgetController(
  $scope,
  $interval,
  $timeout,
  $translationService,
  DashboardFactory,
  PermissionsFactory
) {
  $translationService.getTranslation($scope, "dashboard");
  var vm = this;
  vm.autoRefresh = false;
  vm.delay;
  vm.determinateValue = 0;
  vm.errorPermission = false;

  $scope.loading = true;

  vm.$onInit = function () {
    vm.getExecutions();
  };

  vm.startAutoRefresh = function () {
    vm.stopAutoRefresh();
    vm.autoRefresh = true;

    if (angular.isUndefined(vm.timeout)) {
      vm.timeout = $timeout(function () {
        vm.getExecutions();
        vm.determinateValue = 0;
        $interval.cancel(vm.loaderInterval);
      }, vm.delay);

      vm.determinateLoaderDelay = vm.delay / 100;
      vm.loaderInterval = $interval(function () {
        vm.determinateValue += 1;
      }, vm.determinateLoaderDelay);
    }
  };

  vm.stopAutoRefresh = function () {
    vm.autoRefresh = false;
    if (vm.timeout) {
      $timeout.cancel(vm.timeout);
      $interval.cancel(vm.loaderInterval);
      vm.determinateValue = 0;
      delete vm.loaderInterval;
      delete vm.timeout;
    }
  };

  vm.removeTask = function (canonicalName) {
    $scope.loading = true;
    DashboardFactory.removeTaskFromQueue(canonicalName)
      .then(function (res) {
        vm.getExecutions();
      })
      .catch(function (err) {
        console.log("Error@removeTaskFromQueue", err);
      })
      .finally(function () {
        $scope.loading = false;
      });
  };

  vm.permissionError = null
  vm.getExecutions = function () {
    vm.permissionError = null
    DashboardFactory.getWorkQueue()
      .then(function (res) {
        vm.executions = res;

        if (vm.autoRefresh) {
          vm.startAutoRefresh();
        }
      })
      .catch(function (err) {
        console.error("Error@getWorkQueue", err);
        if (err.status == 403) {
          vm.permissionError = err
        }
        vm.isLoading = false;
      })
      .finally(function () {
        $scope.loading = false;
      });
  };

  vm.menu = {};
  vm.menu.refresh = {
    label: $translationService.getTranslationController(
      "Actualizar",
      "Refresh",
      "Atualizar"
    ),
    fn: function () {
      $scope.loading = true;
      vm.executions = [];
      vm.getExecutions();
    },
  };
  vm.menu.autoRefresh5 = {
    label: $translationService.getTranslationController(
      "Actualización automática (5s)",
      "AutoRefresh (5s)",
      "Atualização automática (5s)"
    ),
    fn: function () {
      vm.delay = 5000;
      vm.startAutoRefresh();
    },
  };
  vm.menu.autoRefresh10 = {
    label: $translationService.getTranslationController(
      "Actualización automática (10s)",
      "AutoRefresh (10s)",
      "Atualização automática (10s)"
    ),
    fn: function () {
      vm.delay = 15000;
      vm.startAutoRefresh();
    },
  };
  vm.menu.autoRefresh15 = {
    label: $translationService.getTranslationController(
      "Actualización automática (15s)",
      "AutoRefresh (15s)",
      "Atualização automática (15s)"
    ),
    fn: function () {
      vm.delay = 15000;
      vm.startAutoRefresh(15000);
    },
  };
  vm.menu.stopAutoRefresh = {
    label: $translationService.getTranslationController(
      "Deneter autorefresh",
      "Stop autorefresh",
      "Parar autorefresh"
    ),
    fn: function () {
      vm.stopAutoRefresh();
    },
  };

  vm.$onDestroy = function () {
    vm.stopAutoRefresh();
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('topListsWidget', {
  templateUrl: 'app/home/widgets/top-lists/top-lists.html',
  controllerAs: 'ctrl',
  bindings: {
    menu: '=?',
    props: '<',
  },
  controller: topListsController,
});

topListsController.$inject = ['$scope', '$state'];
function topListsController($scope, $state) {
  var vm = this;
  vm.viewList = function (listId) {
    $state.go('app.tableList', {
      action: 'GET',
      listId: listId,
      backTo: 'home',
    });
  };

  $scope.sortableOptionsList = {
    placeholder: 'app',
    connectWith: '#sortable',
    receive: function (event, ui) {},
  };
}

"use strict";

var app = angular.module("dashboard");

app.component("rulesQueueWidget", {
  templateUrl: "app/home/widgets/rules-queue/rules-queue.html",
  controllerAs: "ctrl",
  bindings: {
    menu: "=?",
    position: "=",
  },
  controller: rulesQueueWidgetController,
});

rulesQueueWidgetController.$inject = [
  "$scope",
  "$interval",
  "$timeout",
  "translationService",
  "FunctionFactory",
  "PermissionsFactory",
  "toastr"
];
function rulesQueueWidgetController(
  $scope,
  $interval,
  $timeout,
  $translationService,
  FunctionFactory,
  PermissionsFactory,
  toastr
) {
  var vm = this;
  $translationService.getTranslation(vm, "dashboard");
  vm.autoRefresh = false;
  vm.delay;
  vm.determinateValue = 0;

  vm.request = {
    pagination: {
      page: 1,
      totalRecords: 0,
      itemsPerPage: 5,
    },
  };

  vm.loading = true;

  vm.$onInit = function () {
    vm.getExecutions();
  };

  vm.startAutoRefresh = function () {
    vm.stopAutoRefresh();
    vm.autoRefresh = true;

    if (angular.isUndefined(vm.timeout)) {
      vm.timeout = $timeout(function () {
        vm.getExecutions();
        vm.determinateValue = 0;
        $interval.cancel(vm.loaderInterval);
      }, vm.delay);

      vm.determinateLoaderDelay = vm.delay / 100;
      vm.loaderInterval = $interval(function () {
        vm.determinateValue += 1;
      }, vm.determinateLoaderDelay);
    }
  };

  vm.stopAutoRefresh = function () {
    vm.autoRefresh = false;
    if (vm.timeout) {
      $timeout.cancel(vm.timeout);
      $interval.cancel(vm.loaderInterval);
      vm.determinateValue = 0;
      delete vm.loaderInterval;
      delete vm.timeout;
    }
  };

  vm.permissionError = null

  vm.getExecutions = function () {
    
    vm.loading = true;
    vm.request.pagination.itemsPerPage = vm.position.sizeY || 5;

    FunctionFactory.getExecutionsQueue(vm.request)
      .then(function (res) {
        // console.log(res);
        vm.executions = res.sort(function (a, b) {
          return a.executionOrder - b.executionOrder;
        });

        if (vm.autoRefresh) {
          vm.startAutoRefresh();
        }
      })
      .catch(function (err) {
        console.log('Error@getExecutions', err);
        // $toastr.error(err.message);
        if (err.status == 403) {
          vm.permissionError = err
        }
        vm.isLoading = false;
      })
      .finally(function () {
        vm.loading = false;
      });
  };

  vm.menu = {};
  vm.menu.refresh = {
    label: $translationService.getTranslationController(
      "Actualizar",
      "Refresh",
      "Atualizar"
    ),
    fn: function () {
      vm.loading = true;
      vm.executions = [];
      vm.getExecutions();
    },
  };
  vm.menu.autoRefresh5 = {
    label: $translationService.getTranslationController(
      "Actualización automática (5s)",
      "AutoRefresh (5s)",
      "Atualização automática (5s)"
    ),
    fn: function () {
      vm.delay = 5000;
      vm.startAutoRefresh();
    },
  };
  vm.menu.autoRefresh10 = {
    label: $translationService.getTranslationController(
      "Actualización automática (10s)",
      "AutoRefresh (10s)",
      "Atualização automática (10s)"
    ),
    fn: function () {
      vm.delay = 15000;
      vm.startAutoRefresh();
    },
  };
  vm.menu.autoRefresh15 = {
    label: $translationService.getTranslationController(
      "Actualización automática (15s)",
      "AutoRefresh (15s)",
      "Atualização automática (15s)"
    ),
    fn: function () {
      vm.delay = 15000;
      vm.startAutoRefresh(15000);
    },
  };
  vm.menu.stopAutoRefresh = {
    label: $translationService.getTranslationController(
      "Deneter autorefresh",
      "Stop autorefresh",
      "Parar autorefresh"
    ),
    fn: function () {
      vm.stopAutoRefresh();
    },
  };

  vm.$onDestroy = function () {
    vm.stopAutoRefresh();
  };

  var hasChangeSize = false;

  $scope.$watch("ctrl.position.sizeY", function (nval) {
    if (hasChangeSize) return;
    hasChangeSize = true;
    setTimeout(function () {
      vm.getExecutions();
      hasChangeSize = false;
    }, 2000);
  });


  vm.isStoping = false;
  vm.stopExecution = function (execution) {
    console.log(execution);
    vm.isStoping = true;
    getFunctionByID(execution.functionId).then(function (rule) {

      if (!rule.realtime && !execution.executionId) {
        var msg = $translationService.getTranslationController(
          "No se puede detener, intente de nuevo",
          "Can't stop, try again",
          "Não pode parar, tente novamente"
        );
        toastr.warning(msg);
        return;
      }

      vm.isStoping = true;
      var id = execution.executionId;
      if (rule.realtime) id = execution.functionId

      FunctionFactory.stopExecutionV2(id)
        .then(function (res) {
          rule.executionData.executionId = false;
          var msg = $translationService.getTranslationController(
            "Ejecución detenida",
            "Execution stopped",
            "Execução interrompida"
          );
          toastr.warning(msg);

          $rootScope.loading = false;
        })
        .catch(function (err) {
          console.error("Error@stop_execution");
          var msg = $translationService.getTranslationController(
            "No se ha podido detener",
            "Could not stop",
            "Não foi possível parar"
          );
          toastr.warning(msg);
          rule.execution.state =
            $translationService.getTranslationController(msg);

        })
        .finally(function () {
          vm.isStoping = false;
          vm.getExecutions();
        });
    }).catch(function (err) {
      console.error("Error@getFunctionByID", err);
      toastr.error(err);
      vm.isStoping = false;
    });
  };

  function getFunctionByID(id) {
    return new Promise(function(resolve, reject) {
      FunctionFactory.getFunctionByID(id)
        .then(function (res) {
          resolve(res);
        })
        .catch(function (err) {
          reject(err);
        });
    });
  }
}

"use strict";

var app = angular.module("dashboard");

app.component("risksWidget", {
  templateUrl: "app/home/widgets/risks/risks.html",
  controllerAs: "ctrl",
  bindings: {
    props: "<",
    menu: "=?",
    size: "<",
  },
  controller: risksWidgetController,
});

risksWidgetController.$inject = [
  "$scope",
  "$interval",
  "$timeout",
  "translationService",
  "PermissionsFactory",
];

function risksWidgetController(
  $scope,
  $interval,
  $timeout,
  $translationService,
  PermissionsFactory
) {
  console.log("risksWidgetController", vm);
  var vm = this;
  $translationService.getTranslation(vm, "dashboard");
  vm.autoRefresh = false;
  vm.delay;
  vm.determinateValue = 0;
  vm.loading = true;

  vm.menu = {};
  vm.menu.refresh = {
    label: $translationService.getTranslationController(
      "Actualizar",
      "Refresh",
      "Atualizar"
    ),
    fn: function () {
      vm.init();
    },
  };
  vm.menu.autoRefresh5 = {
    label: $translationService.getTranslationController(
      "Actualización automática (5s)",
      "AutoRefresh (5s)",
      "Atualização automática (5s)"
    ),
    fn: function () {
      vm.delay = 5000;
      vm.startAutoRefresh();
    },
  };
  vm.menu.autoRefresh10 = {
    label: $translationService.getTranslationController(
      "Actualización automática (10s)",
      "AutoRefresh (10s)",
      "Atualização automática (10s)"
    ),
    fn: function () {
      vm.delay = 15000;
      vm.startAutoRefresh();
    },
  };
  vm.menu.autoRefresh15 = {
    label: $translationService.getTranslationController(
      "Actualización automática (15s)",
      "AutoRefresh (15s)",
      "Atualização automática (15s)"
    ),
    fn: function () {
      vm.delay = 15000;
      vm.startAutoRefresh(15000);
    },
  };
  vm.menu.stopAutoRefresh = {
    label: $translationService.getTranslationController(
      "Deneter autorefresh",
      "Stop autorefresh",
      "Parar autorefresh"
    ),
    fn: function () {
      vm.stopAutoRefresh();
    },
  };

  vm.$onInit = function () {
    vm.init();
  };

  vm.init = function () {
    $scope.$broadcast ('refres-risk-view');  
  };

  vm.startAutoRefresh = function () {
    vm.stopAutoRefresh();
    vm.autoRefresh = true;

    if (angular.isUndefined(vm.timeout)) {
      vm.timeout = $timeout(function () {
        vm.init();
        vm.determinateValue = 0;
        $interval.cancel(vm.loaderInterval);
      }, vm.delay);

      vm.determinateLoaderDelay = vm.delay / 100;
      vm.loaderInterval = $interval(function () {
        vm.determinateValue += 1;
      }, vm.determinateLoaderDelay);
    }
  };

  vm.stopAutoRefresh = function () {
    vm.autoRefresh = false;
    if (vm.timeout) {
      $timeout.cancel(vm.timeout);
      $interval.cancel(vm.loaderInterval);
      vm.determinateValue = 0;
      delete vm.loaderInterval;
      delete vm.timeout;
    }
  };

  vm.$onDestroy = function () {
    vm.stopAutoRefresh();
  };
}

"use strict";

var app = angular.module("dashboard");

app.component("configRisks", {
  templateUrl: "app/home/widgets/risks/config-risks.html",
  controllerAs: "ctrl",
  bindings: {
    widget: "=",
  },
  controller: ConfigRisksWidgetController,
});

ConfigRisksWidgetController.$inject = ["$scope", "$state", "DataTableFactory"];
function ConfigRisksWidgetController($scope, $state, $dataTableFactory) {
  var vm = this;
  vm.loading = true;
  var defaultSchema = "risk_1";
  vm.defaultSchema = defaultSchema;

  vm.config = {
    title: null,
    description: null,
    schemaName: null,
    tableName: null,
    gridName: null,
    dataSource: null,
    type: "risk-heatmap",
  };

  vm.tables_by_schema = [];
  vm.tableNameChange = tableNameChange;
  vm.queryTable = queryTable;
  $scope.searchSchema = null

  vm.tables_data_source = [];
  vm.dataSourceChange = dataSourceChange;
  vm.queryDataSource = queryDataSource;
  $scope.searchDataSource = null;

  vm.risksTypes = ["risk-heatmap", "risk-stats"];

  vm.table = {
    columns: [],
    data: [],
  };

  // tableName
  function tableNameChange(selected) {
    if (!selected) {
      vm.config.tableName = null;
      vm.config.gridName = null;
      vm.config.dataSource = null;
      vm.config.gridName = null;
      return;
    }

    vm.config.tableName = selected;

    vm.table.columns = [];
    vm.table.data = [];
    getTable();
    getDataTable();
  }

  function queryTable(query) {
    var valid = ["tipo_indicador"];
    var ff = vm.tables_by_schema.filter(function (s) {
      return valid.includes(s);
    });

    var results = query
      ? ff.filter(function (s) {
          var lowercaseQuery = query.toLowerCase();
          return s.toLowerCase().includes(lowercaseQuery);
        })
      : ff;
    return results;
  }
  // gridName
  vm.rowClick = function (row) {
    vm.config.gridName = row.name;
  };
  // dataSource
  function dataSourceChange(selected) {
    if (!selected) {
      vm.config.dataSource = null;
      return;
    }

    vm.config.dataSource = selected;

    getAllTablesBySchemasName();
  }

  function queryDataSource(query) {
    var invalid = ["tipo_indicador", "risks", "impacts", "ranges"];
    var ff = vm.tables_by_schema.filter(function (s) {
      return !invalid.includes(s);
    });

    var results = query
      ? ff.filter(function (s) {
          var lowercaseQuery = query.toLowerCase();
          return s.toLowerCase().includes(lowercaseQuery);
        })
      : ff;
    return results;
  }

  function getAllSchemas() {
    vm.loading = true;
    vm.widget.widget.props = vm.config;
    vm.widget.widget.required = [
      "title",
      "description",
      "schemaName",
      "tableName",
      "gridName",
      "dataSource",
      "type",
    ];
    $dataTableFactory
      .getAllSchemas(vm.config.schemaName)
      .then(function (response) {
        vm.schemas = response;
        var _schema_ = response.find(function (schema) {
          return schema === defaultSchema;
        });

        if (!_schema_) {
          throw new Error("Schema " + defaultSchema + " not found");
        }

        vm.config.schemaName = _schema_;
        
        getAllTablesBySchemasName();
        vm.loading = false;
      })
      .catch(function (error) {
        console.error(error);
        vm.loading = false;
      });
  }
  getAllSchemas();

  function getAllTablesBySchemasName() {
    vm.loading = true;
    vm.tables_by_schema = [];
    $dataTableFactory
      .getAllTablesBySchemasName(vm.config.schemaName)
      .then(function (response) {
        vm.tables_by_schema = response.map(function (table) {
          return table.tableName;
        });
        vm.config.tableName = vm.tables_by_schema.find(function (table) {
          return table.startsWith("tipo_indicador");
        });
        tableNameChange(vm.config.tableName);
        vm.loading = false;
      });
  }

  function getTable() {
    vm.loading = true;
    $dataTableFactory
      .getTable(vm.config.tableName, vm.config.schemaName)
      .then(function (response) {
        vm.loading = false;
        vm.table.columns = response.columns.filter(function (column) {
          return column.colName !== "id_row";
        });
      });
  }

  function getDataTable() {
    vm.loading = true;
    $dataTableFactory
      .getDataTable(vm.config.tableName, vm.config.schemaName)
      .then(function (response) {
        vm.loading = false;
        vm.table.data = response.data;
      });
  }
}

"use strict";

var app = angular.module("dashboard");

app.component("listSearcherWidget", {
  templateUrl: "app/home/widgets/list-searcher/list-searcher.html",
  controllerAs: "ctrl",
  bindings: {
    props: "<",
    menu: "=?",
  },
  controller: listSearcherWidgetController,
});

listSearcherWidgetController.$inject = [
  "$scope",
  "$rootScope",
  "$mdDialog",
  "translationService",
  "listService",
  "tableListConstants",
  "SchemasService",
  "InputListsFactory",
  "ConfigurationFactory",
  "cellTemplateFormatService",
  "IssuesFactory",
  "toastr",
  "$interval",
  "$timeout",
  "uiGridConstants",
  "PermissionsFactory",
];

function listSearcherWidgetController(
  $scope,
  $rootScope,
  $mdDialog,
  $translationService,
  $listService,
  $tableListConstants,
  $schemasService,
  $inputListsFactory,
  $ConfigurationFactory,
  $cellTemplateFormatService,
  $issuesFactory,
  $toastr,
  $interval,
  $timeout,
  $uiGridConstants,
  $permissionsFactory
) {
  var vm = this;

  vm.delay;
  vm.determinateValue = 0;
  vm.statistics = [];
  vm.schemasFormat = [];
  vm.widgetName =
    "list-searcher-widget-" +
    (Math.floor(Math.random() * (99999 - 10000)) + 10000);

  vm.menu = {};

  vm.menu.refresh = {
    label: $translationService.getTranslationController(
      "Actualizar",
      "Refresh",
      "Atualizar"
    ),
    fn: function () {
      vm.loading = true;
      vm.executions = [];
      vm.refresh();
    },
  };
  vm.menu.autoRefresh5 = {
    label: $translationService.getTranslationController(
      "Actualizar cada (5s)",
      "AutoRefresh (5s)",
      "Atualizar a cada (5s)"
    ),
    fn: function () {
      vm.delay = 5000;
      vm.startAutoRefresh();
    },
  };
  vm.menu.autoRefresh10 = {
    label: $translationService.getTranslationController(
      "Actualizar cada (10s)",
      "AutoRefresh (10s)",
      "Atualizar a cada (10s)"
    ),
    fn: function () {
      vm.delay = 15000;
      vm.startAutoRefresh();
    },
  };
  vm.menu.autoRefresh15 = {
    label: $translationService.getTranslationController(
      "Actualizar cada (15s)",
      "AutoRefresh (15s)",
      "Atualizar a cada (15s)"
    ),
    fn: function () {
      vm.delay = 15000;
      vm.startAutoRefresh(15000);
    },
  };
  vm.menu.stopAutoRefresh = {
    label: $translationService.getTranslationController(
      "Detener actualización automática",
      "Stop AutoRefresh",
      "Pare a atualização automática"
    ),
    fn: function () {
      vm.stopAutoRefresh();
    },
  };

  vm.translation = {
    statistics: $translationService.getTranslationController(
      "Estadísticas",
      "Statistics",
      "Estatisticas"
    ),
    remove_filters: $translationService.getTranslationController(
      "Quitar filtros",
      "Remove filters",
      "Remover filtros"
    ),
  };

  vm.columnfilters = [];

  vm.filters = angular.copy($tableListConstants.defaultFiltersTemplate);

  vm.gridOptions = {
    rowTemplate:
      '<div ng-dblclick="grid.appScope.ctrl.onClickRow($event, row.entity)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell ng-class="{ \'cep-issue-unseen\' : !row.entity.viewed }"></div>',
    // Grid pagination options
    useExternalPagination: true,
    paginationPageSizes: [15, 25, 50, 100],
    paginationPageSize: 15,
    totalItems: 0,
    // Grid sorting options
    useExternalSorting: true,
    // Columns
    columnDefs: [{ field: "_" }],
    // GridAPI
    onRegisterApi: function (gridApi) {
      gridApi.pagination.on.paginationChanged(
        $scope,
        function (newPage, pageSize) {
          vm.filters.pagination.page = newPage;
          vm.filters.pagination.itemsPerPage = pageSize;

          $rootScope.loading = true;
          _getListData(vm.props.list).finally(function () {
            $rootScope.loading = false;
          });
        }
      );

      gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        if (sortColumns[0]) {
          var colField = sortColumns[0].field.split(".")[0];
          var col = _getColumnDefinition(colField);

          vm.filters.pagination.sortBy = colField;
          vm.filters.pagination.sort = sortColumns[0].sort.direction;
          vm.filters.pagination.colType = col.type;
        } else {
          vm.filters.pagination.sortBy = null;
        }

        $rootScope.loading = true;
        _getListData(vm.props.list).finally(function () {
          $rootScope.loading = false;
        });
      });
    },
  };

  function _getColumnDefinition(key) {
    var col = vm.props.fields.find(function (e) {
      e = JSON.parse(e);
      var pk = e.pk ? "#" : "";
      return pk + e.key == key;
    });

    return JSON.parse(col);
  }

  $scope.$watchCollection(
    "ctrl.props",
    function (newCollection, oldCollection) {
      vm.$onInit();
    }
  );

  vm.$onInit = function () {
    if (vm.props.list) {
      var promises = [
        _setDefaultSorting(),
        _setDefaultFilters(),
        _getListData(vm.props.list),
        _getListFilters(vm.props.list.listId),
        _getColumns(),
        _getConfigFormatSchema(),
      ];
      Promise.allSettled(promises)
        .then(function (res) {
          vm.columns = res[4].status == "fulfilled" ? res[4].value : [];
          vm.schemasFormat = res[5].status == "fulfilled" ? res[5].value : [];
          vm.groups = _getGroups(vm.columns);

          if (vm.autoRefresh) {
            vm.startAutoRefresh();
          }

          _setColumnDefs(vm.props.fields).then(function () {
            if (vm.props.statistics) {
              _getStatisticsSummary(vm.props.list);
            }
          });
        })
        .catch(function (error) {
          console.error("Error@initPromises", error);
        });
    }
  };

  function _getListFilters(listId) {
    $inputListsFactory
      .getInputListFilters(listId)
      .then(function (res) {
        vm.columnfilters = res;
      })
      .catch(function (error) {
        console.error("Error@getInputListFilters", error);
      });
  }

  function _getStatisticsSummary(list) {
    vm.statistics = [];
    $inputListsFactory
      .getStatisticsSummary(list.listId)
      .then(function (res) {
        vm.props.statistics.forEach(function (e) {
          var selectedStatistic = JSON.parse(e);
          var values = res.find(function (e) {
            return e.name == selectedStatistic.field;
          });
          selectedStatistic.value = +parseFloat(
            values[selectedStatistic.aggregationType]
          ).toFixed(2);

          vm.statistics.push(selectedStatistic);
        });
      })
      .catch(function (err) {
        console.error("Error@getStatisticsSummary", err);
      });
  }

  function _setDefaultSorting() {
    if (vm.props.sortBy && vm.props.sortDirection) {
      var sortColumn = JSON.parse(vm.props.sortBy);
      vm.filters.pagination.sortBy = sortColumn.key;
      vm.filters.pagination.sort = vm.props.sortDirection;
      vm.filters.pagination.colType = sortColumn.type;
    }
  }

  function _setDefaultFilters() {
    if (vm.props.filterBy && vm.props.filterValue && vm.props.filterOperation) {
      var filterColumn = JSON.parse(vm.props.filterBy);

      vm.filters.predicates = [
        {
          label: filterColumn.displayName,
          fieldName: $listService.getFieldName(
            filterColumn.key,
            filterColumn.pk
          ),
          operation: vm.props.filterOperation,
          values: null,
          value: vm.props.filterValue,
          valuesLabels: null,
        },
      ];
      vm.isFiltered = true;
    }
  }

  vm.permissionError = null

  function _getListData(list) {
    return $inputListsFactory
      .getInputListDataFiltered(list.listId, vm.filters)
      .then(function (res) {
        vm.listData = res.data.map(function (e) {
          e.body = JSON.parse(e.body);
          e.body.__dataId = e.dataId;
          return e.body;
        });
        vm.gridOptions.data = vm.listData;
        vm.gridOptions.totalItems = res.pagination.totalRecords;
      })
      .catch(function (err) {
        // $toastr.error(err.message);
        if(err.status == 403) {
          vm.permissionError = err
        }

      });
  }

  function _setColumnDefs(fields) {
    return new Promise(function (resolve, reject) {
      vm.gridOptions.columnDefs = [];
      angular.forEach(fields, function (col) {
        col = JSON.parse(col);

        if (col.visible) {
          var field = col.pk ? "#" + col.key : col.key;

          var colDef = {
            order: col.order,
            name: col.key,
            displayName: col.displayName || col.key,
            field: field,
            cellFilter: $tableListConstants.cellFilters[col.type],
            // General column properties
            enableColumnMenu: true,
            enableSorting: true,
            enableHiding: false,
            aux: col,
            menuItems: [
              {
                title: $translationService.getTranslationController(
                  "Filtrar",
                  "Filter",
                  "Filtro"
                ),
                icon: "ui-grid-icon-filter",
                shown: function () {
                  var hasFilters = vm.columnfilters.find(function (e) {
                    return e.field == col.key || e.label == col.displayName;
                  });

                  return hasFilters ? true : false;
                },
                action: function ($event) {
                  this.context.addFilterTo($event, col);
                },
                context: vm,
              },
            ],
            aggregationHideLabel: true,
            aggregationType:
              col.type == "integer" || col.type == "double"
                ? $uiGridConstants.aggregationTypes.sum
                : null,
            footerCellTemplate:
              col.type == "integer" || col.type == "double"
                ? '<div class="ui-grid-cell-contents" >{{col.getAggregationValue() | number:2 }}</div>'
                : "",
          };

          colDef.cellTemplate = $cellTemplateFormatService.setTemplate(
            colDef,
            col,
            vm.schemasFormat
          );

          vm.gridOptions.columnDefs.push(colDef);
        }
      });

      vm.gridOptions.columnDefs = vm.gridOptions.columnDefs.sort(function (
        a,
        b
      ) {
        return a.order - b.order;
      });

      if (vm.gridOptions.columnDefs.length) {
        resolve();
      }
      reject();
    });
  }

  function _getConfigFormatSchema() {
    return new Promise(function (resolve, reject) {
      $ConfigurationFactory
        .getSchemaFormat()
        .then(function (res) {
          if (res.data.length == 0) {
            resolve([]);
          }
          var schemaMap = res.data.map(function (schema) {
            schema.body = JSON.parse(schema.body);
            return schema;
          });
          resolve(schemaMap);
        })
        .catch(function (err) {
          console.error("Error@getSchemaFormat", err);
          reject(err);
        });
    });
  }

  vm.addFilterTo = function (event, col) {
    col.name = col.displayName || col.key;
    var selectedColumnFilters = vm.columnfilters.find(function (e) {
      return e.field == col.key || e.label == col.displayName;
    });

    if (!selectedColumnFilters) {
      $toastr.warning(
        $translationService.getTranslationController(
          "No hay filtros disponibles para la columna ",
          "There is no filters available for column ",
          "Não há filtros disponíveis para coluna "
        ) + col.name
      );
      return;
    }

    $mdDialog
      .show({
        controller: "IssuesFiltersDialogController",
        controllerAs: "ctrl",
        templateUrl:
          "app/dashboard/components/issues-filters-dialog/issues-filters-dialog.html",
        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: false,
        locals: {
          column: col,
          columnFilters: selectedColumnFilters,
        },
      })
      .then(function (predicate) {
        vm.filters.predicates.push(predicate);
        vm.isFiltered = true;

        $rootScope.loading = true;
        _getListData(vm.props.list).finally(function () {
          $rootScope.loading = false;
        });
      });
  };

  vm.unFilterData = function () {
    vm.filters.predicates = [];
    vm.isFiltered = false;
    $rootScope.loading = true;

    _getListData(vm.props.list).finally(function () {
      $rootScope.loading = false;
    });
  };

  vm.removeFilter = function (index) {
    vm.filters.predicates.splice(index, 1);
    if (!vm.filters.predicates.length) {
      vm.isFiltered = false;
    }
    $rootScope.loading = true;

    _getListData(vm.props.list).finally(function () {
      $rootScope.loading = false;
    });
  };

  vm.validatePermission = function (permission) {
    return $permissionsFactory.hasPermission(permission);
  };

  vm.onClickRow = function (event, item) {
    if (!vm.validatePermission("list#" + vm.props.list.listId + ":update"))
      return;

    item = { body: item, dataId: item.__dataId };
    $mdDialog.show({
      controller: "clientCardController",
      controllerAs: "ctrl",
      templateUrl: "app/app-utils/components/client-card/client-card.html",
      targetEvent: event,
      clickOutsideToClose: false,
      locals: {
        title: $translationService.getTranslationController(
          "Editor de datos",
          "Data editor",
          "Editor de dados"
        ),
        listId: vm.props.list.listId,
        inputs: item,
        inputsTypes: vm.columns,
        groups: vm.groups,
        listSchema: $schemasService.parseSchema(vm.props.list.schema),
      },
    });
  };

  vm.showIssueDialog = function (event, issueUuid) {
    if (!issueUuid || issueUuid === "") return;
    var uuid = issueUuid.split("&")[1] || issueUuid.split("&")[0];
    $rootScope.loading = true;
    var promises = [_getIssuesByUuid(uuid), _getIssuesTypes()];
    Promise.allSettled(promises)
      .then(function (res) {
        var issue = res[0].status == "fulfilled" ? res[0].value : false;
        var issueTypes = res[1].status == "fulfilled" ? res[1].value : [];
        if (issue) {
          issue.cat;
          $mdDialog.show({
            controller: "IssuesDetailDialogController",
            controllerAs: "ctrl",
            templateUrl:
              "app/dashboard/components/issues-detail-dialog/issues-detail-dialog.html",
            parent: angular.element(document.body),
            targetEvent: null,
            clickOutsideToClose: false,
            multiple: true,
            locals: {
              issueTypes: issueTypes,
              currentIssueType: issueTypes.find(function (e) {
                return e.id == issue.issueType.id;
              }),
              issue: issue,
              issuesToLink: [],
              currentCategory: issue.category,
            },
          });
        } else {
          $toastr.warning(
            $translationService.getTranslationController(
              "No se pudo cargar el issue",
              "Can load issue",
              "Can load issue "
            )
          );
        }
      })
      .finally(function () {
        $rootScope.loading = false;
      });
  };

  vm.refresh = function () {
    vm.$onInit();
  };

  vm.startAutoRefresh = function () {
    vm.stopAutoRefresh();
    vm.autoRefresh = true;

    if (angular.isUndefined(vm.timeout)) {
      vm.timeout = $timeout(function () {
        vm.refresh();
        vm.determinateValue = 0;
        $interval.cancel(vm.loaderInterval);
      }, vm.delay);

      vm.determinateLoaderDelay = vm.delay / 100;
      vm.loaderInterval = $interval(function () {
        vm.determinateValue += 1;
      }, vm.determinateLoaderDelay);
    }
  };

  vm.stopAutoRefresh = function () {
    vm.autoRefresh = false;
    if (vm.timeout) {
      $timeout.cancel(vm.timeout);
      $interval.cancel(vm.loaderInterval);
      vm.determinateValue = 0;
      delete vm.loaderInterval;
      delete vm.timeout;
    }
  };

  function _getIssuesByUuid(issueUuid) {
    return new Promise(function (resolve, reject) {
      $issuesFactory
        .getIssueByUUID(issueUuid)
        .then(function (res) {
          resolve(res);
        })
        .catch(function (err) {
          console.error("Error@_getIssuesByUuid", err);
          reject(err);
        });
    });
  }

  function _getIssuesTypes() {
    return new Promise(function (resolve, reject) {
      $issuesFactory
        .getIssuesTypes()
        .then(function (res) {
          resolve(res);
        })
        .catch(function (err) {
          console.error("Error@_getIssuesTypes", err);
          reject(err);
        });
    });
  }

  function _getColumns() {
    var columns = [];
    var schema = $schemasService.parseSchema(
      angular.copy(vm.props.list.schema)
    );

    var noGroupTag = $translationService.getTranslationController(
      "otros",
      "others",
      "otros"
    );

    angular.forEach(schema, function (e, key) {
      
      var group = angular.isUndefined(e.group) ? noGroupTag : e.group;
      if (group == null) group = noGroupTag;
      if (group == "null") group = noGroupTag;

      columns.push({
        field: e.pk ? "#" + key : key,
        title: e.displayName || key,
        show: e.visible,
        group: group,
        order: e.order,
        type: e.type,
        readonly: e.readonly,
      });
    });
    
    return columns;
  }

  function _getGroups(columns) {
    var noGroupTag = $translationService.getTranslationController(
      "otros",
      "others",
      "otros"
    );

    var groups = columns
      .map(function (ele) {
        var item = ele.group || noGroupTag;
        return item;
      })
      .reduce(function (a, b) {
        if (a.indexOf(b) < 0) a.push(b);
        return a;
      }, []);

    return groups;
  }

  vm.$onDestroy = function () {
    vm.stopAutoRefresh();
  };
}

'use strict';

var app = angular.module('dashboard');
app.component('replayChartWidget', {
  templateUrl: 'app/home/widgets/replay-chart/replay-chart.html',
  controllerAs: 'ctrl',
  bindings: {
    props: '<',
  },
  controller: ReplayChartWidgetController,
});

ReplayChartWidgetController.$inject = [
  '$scope',
  '$rootScope',
  'translationService',
  'ReplayConfigurationFactory',
  'toastr',
];
function ReplayChartWidgetController(
  $scope,
  $rootScope,
  $translationService,
  ReplayConfigurationFactory,
  toastr
) {
  var vm = this;

  //-translationService.getTranslation($scope, 'replay');
  vm.$onInit = function () {
    if (angular.isDefined(vm.props.chart)) {
      $rootScope.loading = true;
      ReplayConfigurationFactory.getChartByReplayIdAndChartId(
        vm.props.chart.replayId,
        vm.props.chart.chartId
      )
        .then(function (response) {
          vm.chart = response;
          $rootScope.loading = false;
          $scope.$apply();
        })
        .catch(function (e) {
          toastr.error(e);
          $rootScope.loading = false;
          vm.chart = {};
        });
    }
  };
}

"use strict";

var app = angular.module("dashboard");
app.component("listReaderWidget", {
  templateUrl: "app/home/widgets/list-reader/list-reader.html",
  controllerAs: "ctrl",
  bindings: {
    props: "<",
  },
  controller: listReaderWidgetController,
});

listReaderWidgetController.$inject = ["$scope", "InputListsFactory", "$state"];
function listReaderWidgetController($scope, InputListsFactory, $state) {
  var vm = this;

  $scope.viewTable = function (listId, filter) {
    $state.go("app.tableList", {
      action: "GET",
      listId: listId,
      filter: filter,
      group: vm.props.list.group,
      backTo: "home",
    });
  };

  vm.isLoading = true;
  vm.dataList = [];
  vm.groupList = [];
  vm.topList = [];
  vm.operationTypes = ["contar"];
  vm.risk = ["SUPERIOR", "ALTO", "MEDIO", "BAJO"];
  vm.riskTypes = {
    SUPERIOR: { items: [], groups: {}, total: 0 },
    ALTO: { items: [], groups: {}, total: 0 },
    MEDIO: { items: [], groups: {}, total: 0 },
    BAJO: { items: [], groups: {}, total: 0 },
  };

  $scope.$watch("ctrl.props", function (nval, oval) {
    // console.warn(nval, oval)
    if (nval.list) {
      vm.isLoading = true;
      vm.getList();
    }
  });
  $scope.limit = 5;

  vm.$onInit = function () {
    vm.isLoading = true;
    vm.riskTypes = {
      SUPERIOR: { items: [], groups: [], total: 0 },
      ALTO: { items: [], groups: [], total: 0 },
      MEDIO: { items: [], groups: [], total: 0 },
      BAJO: { items: [], groups: [], total: 0 },
    };
    if (vm.props.list) vm.getList();
  };

  vm.permissionError = null
  vm.getList = function () {
    vm.isLoading = true;
    //Data
    var inputList = {
      queryFilters: {},
      pagination: { page: 1, itemsPerPage: 0, sort: "ASC" },
    };
    InputListsFactory.getInputListData(
      vm.props.list.listId,
      inputList.queryFilters,
      inputList.pagination
    )
      .then(function (res) {
        // console.log("getInputListData",res);
        vm.dataList = [];
        var datax = res.data || res.dataList;
        datax.forEach(function (ele, index) {
          var item = angular.fromJson(ele.body);
          vm.dataList.push(item);
        });
        vm.makeGruop();
        $scope.limit = vm.props.list.top ? vm.props.list.top : 5;
      })
      .catch(function (err) {
        console.error("Error@getInputListData", err);
        // $toastr.error(err.message);
        if (err.status == 403) {
          vm.permissionError = err
        }
        vm.isLoading = false;
      });
  };

  vm.makeGruop = function () {
    var ref_group = vm.props.list.group;
    var ref_label = vm.props.list.label;
    for (var index = 0; index < vm.risk.length; index++) {
      var risk_ref = vm.risk[index];
      vm.riskTypes[risk_ref].items = vm.dataList.filter(function (ele) {
        return ele[ref_label] === risk_ref;
      });

      vm.riskTypes[risk_ref].groups = groupByProperty(
        vm.riskTypes[risk_ref].items,
        ref_group,
        ref_label
      );

      vm.riskTypes[risk_ref].total = vm.riskTypes[risk_ref].items.length;
    }
    vm.toarray();
  };

  vm.list = [];
  vm.toarray = function () {
    vm.list = [];
    vm.list = vm.riskTypes["SUPERIOR"].groups.concat(
      vm.riskTypes["ALTO"].groups,
      vm.riskTypes["MEDIO"].groups,
      vm.riskTypes["BAJO"].groups
    );
    vm.isLoading = false;
  };

  function groupByProperty(list, grupo, label) {
    var groups = [];
    for (var i = 0; i < list.length; i++) {
      var ele = list[i];
      var slot = list[i][grupo];

      var indexRisk = vm.risk.indexOf(ele[label]);

      var found = groups.find(function (e) {
        return e.name == slot;
      });
      if (found) {
        found.val++;
      } else {
        var new_slot = {
          name: slot,
          val: 0,
          riskIndex: indexRisk,
          riskName: ele[label],
        };
        new_slot.val++;
        groups.push(new_slot);
      }
    }
    return groups;
  }
}

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller("subListDetailsController", subListDetailsController);

  subListDetailsController.$inject = [
    "$scope",
    "SchemasService",
    "$mdDialog",
    "lookup",
    "options",
  ];
  function subListDetailsController(
    $scope,
    $schemasService,
    $mdDialog,
    lookup,
    options
  ) {
    var vm = this;
    vm.options = options
    vm.lookup = lookup

    var schema = $schemasService.parseSchema(options.schema);
    var columnDefs = $schemasService.setColumnDefs(schema);

    var data = options.data.map(function (e) {
      e.body = JSON.parse(e.body);
      e.body.__dataId = e.dataId;
      return e.body;
    })

    vm.gridOptions = {
      // Columns
      columnDefs: columnDefs,
      // GridAPI
      data: data,
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

"use strict";

var app = angular.module("dashboard");

app.directive("ngRightClick", function ($parse) {
  return function (scope, element, attrs) {
    var fn = $parse(attrs.ngRightClick);
    element.bind("contextmenu", function (event) {
      scope.$apply(function () {
        event.preventDefault();
        fn(scope, { $event: event });
      });
    });
  };
});

app.component("listDetailsWidget", {
  templateUrl: "app/home/widgets/list-details/list-details.html",
  controllerAs: "ctrl",
  bindings: {
    props: "<",
    menu: "=?",
    size: "<",
  },
  controller: ListsDetailsController,
});

ListsDetailsController.$inject = [
  "$document",
  "$scope",
  "$rootScope",
  "$mdDialog",
  "translationService",
  "listService",
  "tableListConstants",
  "SchemasService",
  "InputListsFactory",
  "ConfigurationFactory",
  "cellTemplateFormatService",
  "IssuesFactory",
  "toastr",
  "$interval",
  "$timeout",
  "uiGridConstants",
  "PermissionsFactory",
];

function ListsDetailsController(
  $document,
  $scope,
  $rootScope,
  $mdDialog,
  $translationService,
  $listService,
  $tableListConstants,
  $schemasService,
  $inputListsFactory,
  $ConfigurationFactory,
  $cellTemplateFormatService,
  $issuesFactory,
  $toastr,
  $interval,
  $timeout,
  $uiGridConstants,
  $permissionsFactory
) {
  var vm = this;

  var filters = {
    luceneQueryId: "",
    predicates: [],
    pagination: {
      page: 1,
      sortBy: vm.props.lookupmatch,
      itemsPerPage: 1000,
      sort: "DESC",
    },
    exportToCSV: false,
  };

  vm.delay;
  vm.determinateValue = 0;
  vm.statistics = [];
  vm.schemasFormat = [];
  vm.widgetName =
    "list-searcher-widget-" +
    (Math.floor(Math.random() * (99999 - 10000)) + 10000);

  vm.menu = {};

  vm.menu.refresh = {
    label: $translationService.getTranslationController(
      "Actualizar",
      "Refresh",
      "Atualizar"
    ),
    fn: function () {
      vm.loading = true;
      vm.executions = [];
      vm.refresh();
    },
  };

  vm.translation = {
    statistics: $translationService.getTranslationController(
      "Estadísticas",
      "Statistics",
      "Estatisticas"
    ),
    remove_filters: $translationService.getTranslationController(
      "Quitar filtros",
      "Remove filters",
      "Remover filtros"
    ),
  };

  vm.columnfilters = [];

  vm.filters = angular.copy($tableListConstants.defaultFiltersTemplate);

  vm.gridOptions = {
    rowHeight: 30,
    headerHeight: 40,
    rowTemplate:
      '<div ng-right-click="grid.appScope.ctrl.onRightClickRow($event, row.entity)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell ng-ctx-menu-trigger" ui-grid-cell ></div>',
    // Grid pagination options
    useExternalPagination: true,
    paginationPageSizes: [15, 25, 50, 100],
    paginationPageSize: 15,
    totalItems: 0,
    // Grid sorting options
    useExternalSorting: true,
    //expandable
    enableExpandable: false,
    enableRowSelection: false,
    expandableRowTemplate: '<div ui-grid="row.entity.subGridOptions"></div>',
    expandableRowHeight: 70,
    expandableRowScope: {
      subGridVariable: "subGridOptions",
    },
    showGridFooter: true,
    showColumnFooter: true,
    // Columns
    columnDefs: [],
    // GridAPI
    onRegisterApi: function (gridApi) {
      $scope.gridApi = gridApi;
      gridApi.pagination.on.paginationChanged(
        $scope,
        function (newPage, pageSize) {
          vm.filters.pagination.page = newPage;
          vm.filters.pagination.itemsPerPage = pageSize;

          $rootScope.loading = true;
          _getListData(vm.props.mainTable.id).finally(function () {
            $rootScope.loading = false;
          });
        }
      );

      gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        if (sortColumns[0]) {
          var colField = sortColumns[0].field.split(".")[0];
          // var col = _getColumnDefinition(colField);

          vm.filters.pagination.sortBy = colField;
          vm.filters.pagination.sort = sortColumns[0].sort.direction;
          // vm.filters.pagination.colType = col.type;
        } else {
          vm.filters.pagination.sortBy = null;
        }

        $rootScope.loading = true;
        _getListData(vm.props.mainTable.id).finally(function () {
          $rootScope.loading = false;
        });
      });

      gridApi.expandable.on.rowExpandedStateChanged($scope, function (row) {
        if (row.isExpanded && vm.props.lookupTable != null) {
          var lookupTable = vm.props.lookupTable.id;
          var key = vm.props.lookupTable.column || vm.props.lookupTable.lookupmatch;
          var searchValue = row.entity[key];
          var lookupmatch = vm.props.lookupTable.lookupmatch;
          $inputListsFactory
            .searchLookupMatch(lookupTable, searchValue, lookupmatch, filters)
            .then(function (res) {
              if (res.data.length === 0) {
                $toastr.warning(
                  $translationService.getTranslationController(
                    "No se encontraron registros para la búsqueda ",
                    "No records found for search ",
                    "Nenhum registro encontrado para a busca "
                  ) +
                    lookupmatch +
                    ": " +
                    searchValue
                );
                row.isExpanded = false;
                return;
              }

              var setColumnDefs = [];
              var schema = $schemasService.parseSchema(res.schema);
              setColumnDefs = $schemasService.setColumnDefs(schema);

              vm.gridOptions.expandableRowHeight = res.data.length * 30 + 40;

              row.entity.subGridOptions = {
                columnDefs: setColumnDefs,

                data:
                  res.data.length === 0
                    ? []
                    : res.data.map(function (e) {
                        e.body = JSON.parse(e.body);
                        e.body.__dataId = e.dataId;
                        return e.body;
                      }),
              };
            });
        } else {
          row.isExpanded = false;
        }
      });
    },
  };

  vm.expandAllRows = function () {
    $scope.gridApi.expandable.expandAllRows();
  };

  vm.collapseAllRows = function () {
    $scope.gridApi.expandable.collapseAllRows();
  };

  $scope.$watchCollection(
    "ctrl.props",
    function (newCollection, oldCollection) {
      vm.$onInit();
    }
  );

  

  vm.$onInit = function () {
    if (vm.props.mainTable && vm.props.mainTable.id) {
      vm.isLoading = true;
      _getListById(vm.props.mainTable.id)
        .then(function () {
          var promises = [
            _setDefaultSorting(),
            _setDefaultFilters(),
            _getListFilters(vm.props.mainTable.id),
            _getConfigFormatSchema(),
          ];
          Promise.allSettled(promises)
            .then(function (res) {
              
              vm.schemasFormat =
                res[3].status == "fulfilled" ? res[3].value : [];

              _setColumnDefs()
                .then(function () {
                  if (vm.autoRefresh) {
                    vm.startAutoRefresh();
                  }
                  _getListData(vm.props.mainTable.id);
                  vm.isLoading = false;
                })
                .catch(function (e) {
                  console.log(e);
                  $toastr.warning(
                    $translationService.getTranslationController(
                      "No hay columnas visibles en el esquema.",
                      "There is no columns visible on schema",
                      "Não há colunas visíveis no esquema"
                    )
                  );
                  $rootScope.loading = false;
                });
            })
            .catch(function (error) {
              console.error("Error@initPromises", error);
            });
        })
        .catch(function (error) {
          console.error("Error@_getListById", error);
        });
    }
  };

  function _getListFilters(listId) {
    $inputListsFactory
      .getInputListFilters(listId)
      .then(function (res) {
        vm.columnfilters = res;
      })
      .catch(function (error) {
        console.error("Error@getInputListFilters", error);
        vm.permissionError = error
      });
  }

  function _setDefaultSorting() {
    if (vm.props.sortBy && vm.props.sortDirection) {
      var sortColumn = JSON.parse(vm.props.sortBy);
      vm.filters.pagination.sortBy = sortColumn.key;
      vm.filters.pagination.sort = vm.props.sortDirection;
      vm.filters.pagination.colType = sortColumn.type;
    }
  }

  function _setDefaultFilters() {
    if (vm.props.filterBy && vm.props.filterValue && vm.props.filterOperation) {
      var filterColumn = JSON.parse(vm.props.filterBy);

      vm.filters.predicates = [
        {
          label: filterColumn.displayName,
          fieldName: $listService.getFieldName(
            filterColumn.key,
            filterColumn.pk
          ),
          operation: vm.props.filterOperation,
          values: null,
          value: vm.props.filterValue,
          valuesLabels: null,
        },
      ];
      vm.isFiltered = true;
    }
  }

  function _getListData(listId) {
    return $inputListsFactory
      .getInputListDataFiltered(listId, vm.filters)
      .then(function (res) {
        vm.listData = res.data
          .map(function (e) {
            e.body = JSON.parse(e.body);
            e.body.__dataId = e.dataId;
            return e.body;
          })
          .map(function (e) {
            e.subGridOptions = {
              columnDefs: [],
              data: [],
            };
            return e;
          });

        vm.gridOptions.data = vm.listData;
        vm.gridOptions.totalItems = res.pagination.totalRecords;
      })
      .catch(function (err) {
        console.error("Error@getInputListData", err);
      });
  }

  vm.permissionError = null

  function _getListById(id) {
    vm.permissionError = null
    return new Promise(function (resolve, reject) {
      $inputListsFactory
        .getInputList(id)
        .then(function (response) {
          vm.lists = response;

          vm.schema = $schemasService.parseSchema(response.schema);

          var hasLookupColumns = Object.values(vm.schema).some(function (col) {
            return col.type === "lookup";
          });

          var lookupTable =
            vm.props.lookupTable && vm.props.lookupTable.id != null;

          if (hasLookupColumns && lookupTable) {
            vm.gridOptions.enableExpandable = true;
            vm.gridOptions.enableRowSelection = true;
            vm.gridOptions.onRegisterApi;
            // $scope.gridApi = gridApi;
          }
          resolve(response);
        })
        .catch(function (err) {
          console.error("Error@getInputList", err);
          // $toastr.error(err.message);
          if (err.status == 403) {
            vm.permissionError = err
          }
          vm.isLoading = false;
          reject(err);
        });
    });
  }

  function _setColumnDefs() {
    return new Promise(function (resolve, reject) {
      vm.gridOptions.columnDefs = [];

      angular.forEach(vm.schema, function (col, key) {
        if (col.visible) {
          var field = col.pk ? "#" + key : key;

          var colDef = {
            order: col.order,
            name: key,
            displayName: col.displayName || key,
            field: field,
            cellFilter: $tableListConstants.cellFilters[col.type],
            // General column properties
            enableColumnMenu: true,
            enableSorting: true,
            enableHiding: false,
            aux: col,
            menuItems: [
              {
                title: $translationService.getTranslationController(
                  "Filtrar",
                  "Filter",
                  "Filtro"
                ),
                icon: "ui-grid-icon-filter",
                shown: function () {
                  var hasFilters = vm.columnfilters.find(function (e) {
                    return e.field == col.key || e.label == col.displayName;
                  });

                  return hasFilters ? true : false;
                },
                action: function ($event) {
                  this.context.addFilterTo($event, col);
                },
                context: vm,
              },
            ],
            aggregationHideLabel: true,
            aggregationType:
              col.type == "integer" || col.type == "double"
                ? $uiGridConstants.aggregationTypes.sum
                : null,
            footerCellTemplate:
              col.type == "integer" || col.type == "double"
                ? '<div class="ui-grid-cell-contents" >{{col.getAggregationValue() | number:2 }}</div>'
                : "",
            headerCellTemplate:
              "<div class='ui-grid-cell-contents'> <md-tooltip md-direction='top'>{{col.displayName}}</md-tooltip> {{ col.displayName }}</div>",
          };

          colDef.cellTemplate = $cellTemplateFormatService.setTemplate(
            colDef,
            col,
            vm.schemasFormat
          );

          vm.gridOptions.columnDefs.push(colDef);
        }
      });

      if (vm.props.listlink != null && vm.props.listlink.listid) {
        vm.gridOptions.columnDefs.push({
          name: "listlink",
          displayName: vm.props.listlink.listid.name,
          field: "listlink",
          cellTemplate:
            '<button class="btn btn-link" ng-click="grid.appScope.ctrl.linkedListDialog($event, row.entity)"><i class="fa fa-link"></i>  <md-tooltip md-direction="left" md-z-index="9999" >linked list</md-tooltip></button>',
          width: 50,
          enableColumnMenu: false,
          enableSorting: true,
          enableHiding: false,
          pinnedRight: true,
          aux: vm.props.listlink,
          headerCellTemplate:
            "<div class='ui-grid-cell-contents'> <md-tooltip md-direction='top'>{{col.displayName}}</md-tooltip> {{ col.displayName }}</div>",
        });
      }

      if (vm.props.rulelink != null) {
        vm.gridOptions.columnDefs.push({
          name: "rulelink",
          displayName: vm.props.rulelink.name,
          field: "rulelink",
          cellTemplate:
            '<button class="btn btn-link" ng-click="grid.appScope.ctrl.rulelinkDialog($event, row.entity)"><i class="fa fa-play"></i>  <md-tooltip md-direction="left" md-z-index="9999" >Execute rule</md-tooltip> </button>',
          width: 50,
          enableColumnMenu: false,
          enableSorting: true,
          enableHiding: false,
          pinnedRight: true,
          aux: vm.props.rulelink,
          headerCellTemplate:
            "<div class='ui-grid-cell-contents'> <md-tooltip md-direction='top'>{{col.displayName}}</md-tooltip> {{ col.displayName }}</div>",
        });
      }

      vm.gridOptions.columnDefs = vm.gridOptions.columnDefs.sort(function (
        a,
        b
      ) {
        return a.order - b.order;
      });

      if (vm.gridOptions.columnDefs.length) {
        resolve();
      }
      reject();
    });
  }

  vm.addFilterTo = function (event, col) {
    col.name = col.displayName || col.key;
    var selectedColumnFilters = vm.columnfilters.find(function (e) {
      return e.field == col.key || e.label == col.displayName;
    });

    if (!selectedColumnFilters) {
      $toastr.warning(
        $translationService.getTranslationController(
          "No hay filtros disponibles para la columna ",
          "There is no filters available for column ",
          "Não há filtros disponíveis para coluna "
        ) + col.name
      );
      return;
    }

    $mdDialog
      .show({
        controller: "IssuesFiltersDialogController",
        controllerAs: "ctrl",
        templateUrl:
          "app/dashboard/components/issues-filters-dialog/issues-filters-dialog.html",
        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: false,
        locals: {
          column: col,
          columnFilters: selectedColumnFilters,
        },
      })
      .then(function (predicate) {
        vm.filters.predicates.push(predicate);
        vm.isFiltered = true;

        $rootScope.loading = true;
        _getListData(vm.props.mainTable.id).finally(function () {
          $rootScope.loading = false;
        });
      });
  };

  vm.unFilterData = function () {
    vm.filters.predicates = [];
    vm.isFiltered = false;
    $rootScope.loading = true;

    _getListData(vm.props.mainTable.id).finally(function () {
      $rootScope.loading = false;
    });
  };

  vm.removeFilter = function (index) {
    vm.filters.predicates.splice(index, 1);
    if (!vm.filters.predicates.length) {
      vm.isFiltered = false;
    }
    $rootScope.loading = true;

    _getListData(vm.props.mainTable.id).finally(function () {
      $rootScope.loading = false;
    });
  };

  vm.validatePermission = function (permission) {
    return $permissionsFactory.hasPermission(permission);
  };

  vm.showContextMenu = { show: false, style: null };
  vm.linkedLists = [];

  $document.bind("click", function () {
    vm.showContextMenu = { show: false, style: null };
  });

  vm.onRightClickRow = function (event, row) {
    vm.showContextMenu.show = true;
    vm.showContextMenu.style =
      "top: " + (event.clientY - 100) + "px; left: " + event.clientX + "px;";

    vm.linkedLists = [];

    var lookupCols = vm.gridOptions.columnDefs
      .filter(function (col) {
        return col.aux.type === "lookup";
      })
      .map(function (col) {
        col.value = row[col.name];
        col.lookup = col.aux.metadata;
        return col;
      });

    vm.linkedLists = lookupCols;
  };

  vm.loadLookUpData = function (row, keyValue) {
    vm.showContextMenu = { show: false, style: null };

    var lookupTable = keyValue ? keyValue[0].id : vm.props.lookupTable.id;

    var searchValue = "";
    var lookupmatch = "";

    if (keyValue) {
      searchValue = keyValue[1];
      lookupmatch = keyValue[0].lookupmatch;
    } else {
      searchValue = row[vm.props.lookupTable.lookupmatch];
      lookupmatch = vm.props.lookupTable.lookupmatch;
    }

    $inputListsFactory
      .searchLookupMatch(lookupTable, searchValue, lookupmatch, filters)
      .then(function (res) {
        if (res.data.length === 0) {
          $toastr.warning(
            $translationService.getTranslationController(
              "No se encontraron registros para la búsqueda ",
              "No records found for search ",
              "Nenhum registro encontrado para a busca "
            ) +
              lookupmatch +
              ": " +
              searchValue
          );
          return;
        }

        $mdDialog
          .show({
            controller: "subListDetailsController",
            controllerAs: "ctrl",
            templateUrl: "app/home/widgets/list-details/sub-list-details.html",
            parent: angular.element(document.body),
            targetEvent: null,
            clickOutsideToClose: true,
            locals: {
              lookup: {
                lookupTable: lookupTable,
                searchValue: searchValue,
                lookupmatch: lookupmatch,
              },
              options: {
                data: res.data,
                schema: res.schema,
              },
            },
          })
          .then(function () {});
      })
      .catch(function (err) {
        console.log(err);
      });
  };

  vm.linkedListDialog = function (event, row) {
    var initfilter = {
      label: vm.props.listlink.linkcolumn,
      fieldName: vm.props.listlink.linkcolumn,
      operation: "EQUAL",
      values: [null, null],
      value: row[vm.props.listlink.maincolumn],
      type: "string",
      valuesLabels: null,
      component: "text",
    };

    $mdDialog.show({
      // controller: "TableListController",
      controller: "LinkListController",
      controllerAs: "ctrl",
      templateUrl: "app/home/widgets/list-details/dialog/link-list.html",
      // "app/input-list/table/tableList.html",
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: false,
      multiple: true,
      locals: {
        listid: vm.props.listlink.listid.id,
        initfilter: initfilter,
      },
    });
  };

  vm.rulelinkDialog = function (event, row) {
    var properties = Object.keys(row).reduce(function (acc, key) {
      var def = vm.schema[key];
      var value = row[key];

      if (value === "$$hashKey") return acc;
      if (value === "__dataId") return acc;
      if (!def) return acc;

      if (def.visible) {
        acc.push({
          id: null,
          name: key,
          type: "string",
          value: value,
          status: false,
          description: "",
        });
      }
      return acc;
    }, []);

    $mdDialog.show({
      controller: "ExecuteDialogController",
      controllerAs: "ctrl",
      templateUrl: "app/rules/partials/execute-dialog/execute-dialog.html",
      locals: {
        rule: vm.props.rulelink,
        properties: properties,
      },
      parent: angular.element(document.body),
      multiple: true,
    });
  };

  vm.showIssueDialog = function (event, issueUuid) {
    if ($rootScope.loading) return;
    if (!issueUuid || issueUuid === "") return;
    var uuid = issueUuid.split("&")[1] || issueUuid.split("&")[0];
    $rootScope.loading = true;

    function _getIssuesByUuid(issueUuid) {
      return new Promise(function (resolve, reject) {
        $issuesFactory
          .getIssueByUUID(issueUuid)
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            console.error("Error@_getIssuesByUuid", err);
            reject(err);
          });
      });
    }

    function _getIssuesTypes() {
      return new Promise(function (resolve, reject) {
        $issuesFactory
          .getIssuesTypes()
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            console.error("Error@_getIssuesTypes", err);
            reject(err);
          });
      });
    }
    var promises = [_getIssuesByUuid(uuid), _getIssuesTypes()];
    Promise.allSettled(promises)
      .then(function (res) {
        var issue = res[0].status == "fulfilled" ? res[0].value : false;
        var issueTypes = res[1].status == "fulfilled" ? res[1].value : [];
        if (issue) {
          issue.cat;
          $mdDialog.show({
            controller: "IssuesDetailDialogController",
            controllerAs: "ctrl",
            templateUrl:
              "app/dashboard/components/issues-detail-dialog/issues-detail-dialog.html",
            parent: angular.element(document.body),
            targetEvent: null,
            clickOutsideToClose: false,
            multiple: true,
            locals: {
              issueTypes: issueTypes,
              currentIssueType: issueTypes.find(function (e) {
                return e.id == issue.issueType.id;
              }),
              issue: issue,
              issuesToLink: [],
              currentCategory: issue.category,
            },
          });
        } else {
          $toastr.warning(
            $translationService.getTranslationController(
              "No se pudo cargar el issue",
              "Can load issue",
              "Can load issue "
            )
          );
        }
      })
      .finally(function () {
        $rootScope.loading = false;
      });
  };

  vm.refresh = function () {
    vm.$onInit();
  };

  vm.startAutoRefresh = function () {
    vm.stopAutoRefresh();
    vm.autoRefresh = true;

    if (angular.isUndefined(vm.timeout)) {
      vm.timeout = $timeout(function () {
        vm.refresh();
        vm.determinateValue = 0;
        $interval.cancel(vm.loaderInterval);
      }, vm.delay);

      vm.determinateLoaderDelay = vm.delay / 100;
      vm.loaderInterval = $interval(function () {
        vm.determinateValue += 1;
      }, vm.determinateLoaderDelay);
    }
  };

  vm.stopAutoRefresh = function () {
    vm.autoRefresh = false;
    if (vm.timeout) {
      $timeout.cancel(vm.timeout);
      $interval.cancel(vm.loaderInterval);
      vm.determinateValue = 0;
      delete vm.loaderInterval;
      delete vm.timeout;
    }
  };

  function _getConfigFormatSchema() {
    return new Promise(function (resolve, reject) {
      $ConfigurationFactory
        .getSchemaFormat()
        .then(function (res) {
          if (res.data.length == 0) {
            resolve([]);
          }
          var schemaMap = res.data.map(function (schema) {
            schema.body = JSON.parse(schema.body);
            return schema;
          });
          resolve(schemaMap);
        })
        .catch(function (err) {
          console.error("Error@getSchemaFormat", err);
          if (err.status == 403) {
           vm.permissionError = err
          }
          reject(err);
        });
    });
  }
}


"use strict";

var app = angular.module("dashboard");

app.component("configListDetails", {
  templateUrl: "app/home/widgets/list-details/config-list-details.html",
  controllerAs: "ctrl",
  bindings: {
    widget: "=",
  },
  controller: ConfigListsDetailsController,
});

ConfigListsDetailsController.$inject = [
  "$scope",
  "$state",
  "InputListsFactory",
  "SchemasFactory",
  "FunctionFactory",
];
function ConfigListsDetailsController(
  $scope,
  $state,
  $inputListsFactory,
  $schemasFactory,
  $functionFactory
) {
  var vm = this;
  vm.lists = [];
  vm.rules = [];

  $scope.searchTextList = "";
  $scope.searchTextLinkList = "";
  $scope.searchTextRuleList = "";

  vm.loading = true;
  vm.schema = null;
  vm.linkListSchema = null;
  vm.uselistlink = false;
  vm.userulelink = false;

  vm.form = {
    title: null,
    mainTable: null,
    lookupTable: null,
    listlink: null,
    rulelink: null,
  };

  vm.mainTableItemChange = mainTableItemChange;
  vm.querySearchList = querySearchList;

  vm.linkTableItemChange = linkTableItemChange;
  vm.querySearchLinkList = querySearchLinkList;

  vm.ruleTableItemChange = ruleTableItemChange;
  vm.querySearchRuleList = querySearchRuleList;

  vm.onSelectLookup = function (key, schema) {
    var lookup = Object.assign(
      {
        column: key,
      },
      schema.metadata
    );

    if (vm.form.lookupTable != null) vm.form.lookupTable = null;
    else vm.form.lookupTable = lookup;
  };

  vm.uselistlinkChange = function () {
    vm.uselistlink = !vm.uselistlink;
    if (vm.uselistlink === false) {
      vm.form.listlink = null;
    } else {
      vm.form.listlink = {
        listid: null,
        maincolumn: null,
        linkcolumn: null,
        filterby: "EQUAL",
      };
    }
  };
  vm.userulelinkChange = function () {
    vm.userulelink = !vm.userulelink;
    vm.form.rulelink = null;
  };

  init();

  function init() {
    vm.widget.widget.props = vm.form;

    $inputListsFactory
      .getLists()
      .then(function (response) {
        vm.lists = response.lists.map(function (e) {
          return {
            id: e.listId,
            name: e.name,
            schema: {
              id: e.schema.id,
              name: e.schema.name,
            },
            totalRecords: e.totalRecords,
          };
        });
      })
      .catch(function (err) {
        console.error("Error@getLists", err);
      });

    $functionFactory
      .getFunctions()
      .then(function (response) {
        vm.rules = response.data;
      })
      .catch(function (err) {
        console.error("Error@getFunctions", err);
      });
  }

  function mainTableItemChange(listSelectd) {
    vm.linkListSchema = null;
    vm.lookupTable = null;
    vm.uselistlink = false;
    vm.form.listlink = null;
    vm.userulelink = false;
    vm.form.rulelink = null;
    if (!listSelectd) {
      return;
    }
    if (!listSelectd.schema) {
      return;
    }

    getSchemaByIdOrName(listSelectd.schema.name)
      .then(function (_SCHEMA_) {
        vm.schema = _SCHEMA_.properties;
        vm.form.schema = _SCHEMA_.name;

        var lookup_lists_ids = [];

        for (var key in _SCHEMA_.properties) {
          if (_SCHEMA_.properties.hasOwnProperty(key)) {
            var column = _SCHEMA_.properties[key];
            if (column.type === "lookup" && column.metadata.id) {
              lookup_lists_ids.push($inputListsFactory.getInputList(column.metadata.id));
            }
          }
        }

        _getListById(lookup_lists_ids);
      })
      .catch(function (err) {
        console.error("Error@getSchemaByIdOrName", err);
      });
  }

  function querySearchList(query) {
    var results = query
      ? vm.lists.filter(function (s) {
          var lowercaseQuery = query.toLowerCase();
          return s.name.toLowerCase().includes(lowercaseQuery);
        })
      : vm.lists;
    return results;
  }

  function linkTableItemChange(linklistSelected) {
    if (!linklistSelected) {
      return;
    }
    if (!linklistSelected.schema) {
      return;
    }

    getSchemaByIdOrName(linklistSelected.schema.name)
      .then(function (_SCHEMA_) {
        vm.linkListSchema = _SCHEMA_.properties;
      })
      .catch(function (err) {
        console.error("Error@getSchemaByIdOrName", err);
      });
  }

  function querySearchLinkList(query) {
    var listfilter = vm.lists.filter(function (e) {
      return e.id != vm.form.mainTable.id;
    });

    var results = query
      ? listfilter.filter(function (s) {
          var lowercaseQuery = query.toLowerCase();
          return s.name.toLowerCase().includes(lowercaseQuery);
        })
      : listfilter;

    return results;
  }

  function _getListById(array_ids) {
    Promise.all(array_ids)
      .then(function (response) {
        for (var key in vm.schema) {
          var col = vm.schema[key];
          if (col.type === "lookup")
            col.metadata.name = response.find(function (l) {
              return l.listId == col.metadata.id;
            }).name;
        }
      })
      .catch(function (err) {
        console.error("Error@getInputList", err);
      });
  }

  function getSchemaByIdOrName(name) {
    return new Promise(function (resolve, reject) {
      $schemasFactory
        .getSchemaByIdOrName(name)
        .then(function (schema) {
          schema.schema = JSON.parse(schema.schema);
          var _SCHEMA_ = schema.schema.definitions[schema.name];
          var PK = _SCHEMA_.$id.replace("#", "");
          var properties = _SCHEMA_.properties;
        
          for (var key in properties) {
            if (properties.hasOwnProperty(key)) {
              properties[key] = Object.assign({}, properties[key], {
                name: PK === key ? "#" + key : key,
                pk: PK === key,
              });
            }
          }

          resolve({ name: schema.name, properties: properties });
        })
        .catch(function (err) {
          reject(err);
        });
    });
  }

  function ruleTableItemChange(ruleSelected) {
    console.log("ruleSelected", ruleSelected, vm.rules);
  }

  function querySearchRuleList(query) {
    var rulesfiltered = vm.rules.filter(function (e) {
      return e.schema && e.schema.name == vm.form.mainTable.schema.name;
    });
    var results = query
      ? rulesfiltered.filter(function (s) {
          var lowercaseQuery = query.toLowerCase();
          return s.name.toLowerCase().includes(lowercaseQuery);
        })
      : rulesfiltered;
    return results;
  }
}

"use strict";

var app = angular.module("dashboard");

app
  .component("listChartsWidget", {
    templateUrl: "app/home/widgets/list-charts/list-charts.html",
    controllerAs: "ctrl",
    bindings: {
      props: "<",
      menu: "=?",
    },
    controller: listChartsWidgetController,
  })
  .directive("getHeight", function ($window) {
    return {
      link: function (scope, element, attrs) {
        scope.$watch(function () {
          scope.ctrl.height = element[0].offsetHeight - 40;
        });
      },
    };
  });

listChartsWidgetController.$inject = ["$rootScope", "translationService"];
function listChartsWidgetController($rootScope, $translationService) {
  var vm = this;
  vm.height = 250;
  vm.loading = true;
  vm.autoRefresh = false;
  vm.delay;
  vm.determinateValue = 0;
  vm.chart = null;
  vm.permissionError = {
    message: "",
    error: 403,
    show: false,
  };

  vm.widgetName = "chart-widget-" + (Math.floor(Math.random() * (99999 - 10000)) + 10000);
  vm.menu = {
    toogleChartTableView: {
      label: $translationService.getTranslationController(
        "Mostrar/Ocultar Tabla",
        "Show/Hide Table",
        "Mostrar/Ocultar Tabela"
      ),
      fn: function () {
        vm.props.display_table = !vm.props.display_table;
      },
    },
    toogleChartLabels: {
      label: $translationService.getTranslationController(
        "Mostrar/Ocultar etiquetas",
        "Show/Hide Labels",
        "Mostrar/Ocultar rótulos"
      ),
      fn: function () {
        vm.props.display_labels = !vm.props.display_labels;
      },
    },
    chartFilters: {
      label: $translationService.getTranslationController("Filters", "Filters", "Filters"),
      fn: function () {
        vm.props.display_filters = !vm.props.display_filters;
      },
    },
    refresh: {
      label: $translationService.getTranslationController("Actualizar", "Refresh", "Atualizar"),
      fn: function () {
        $rootScope.$broadcast("refresh_" + vm.chart.id);
      },
    },
    autoRefresh5: {
      label: $translationService.getTranslationController(
        "Actualizar cada (5s)",
        "AutoRefresh (5s)",
        "Atualizar a cada (5s)"
      ),
      fn: function () {
        $rootScope.$broadcast("startAutoRefresh_" + vm.chart.id, 5);
      },
    },
    autoRefresh10: {
      label: $translationService.getTranslationController(
        "Actualizar cada (10s)",
        "AutoRefresh (10s)",
        "Atualizar a cada (10s)"
      ),
      fn: function () {
        $rootScope.$broadcast("startAutoRefresh_" + vm.chart.id, 10);
      },
    },
    autoRefresh15: {
      label: $translationService.getTranslationController(
        "Actualizar cada (15s)",
        "AutoRefresh (15s)",
        "Atualizar a cada (15s)"
      ),
      fn: function () {
        $rootScope.$broadcast("startAutoRefresh_" + vm.chart.id, 15);
      },
    },
    stopAutoRefresh: {
      label: $translationService.getTranslationController(
        "Detener actualización automática",
        "Stop AutoRefresh",
        "Pare a atualização automática"
      ),
      fn: function () {
        $rootScope.$broadcast("stopAutoRefresh_" + vm.chart.id);
      },
    },
  };

  vm.$onInit = function () {
    if (!angular.isDefined(vm.props.chart)) {
      return false;
    }
    var chart_props = angular.isDefined(vm.props.chart) ? JSON.parse(vm.props.chart) : null;
    vm.chart = chart_props;

    setTimeout(function () {
      vm.loading = false;
    }, 500);
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('issuesChartWidget', {
  templateUrl: 'app/home/widgets/issues-chart/issues-chart.html',
  controllerAs: 'ctrl',
  bindings: {
    props: '<',
    menu: '=?',
  },
  controller: IssuesChartWidgetController,
});

IssuesChartWidgetController.$inject = [
  '$scope',
  '$localStorageService',
  '$timeout',
  'translationService',
  '$filter',
  'IssuesFactory',
];

function IssuesChartWidgetController(
  $scope,
  $localStorageService,
  $timeout,
  $translationService,
  $filter,
  IssuesFactory
) {
  var vm = this;
  vm.menu = {};
  vm.menu.refresh = {
    label: $translationService.getTranslationController(
      'Actualizar',
      'Refresh',
      'Atualizar'
    ),
    fn: function () {
      _getIssueData();
    },
  };

  vm.widgetName =
    'issues-chart-pie-widget-' +
    (Math.floor(Math.random() * (99999 - 10000)) + 10000);
  vm.graphData = [];

  $scope.$watchCollection('ctrl.props', function (e) {
    if (
      angular.isDefined(vm.props.category) &&
      !angular.isObject(vm.props.category)
    ) {
      vm.category = JSON.parse(vm.props.category);
    }

    if (
      angular.isDefined(vm.props.issue) &&
      !angular.isObject(vm.props.issue)
    ) {
      vm.issue = JSON.parse(vm.props.issue);
      if (vm.issue[vm.props.graphField]) {
        vm.graphData = vm.issue[vm.props.graphField]
          .map(function (e) {
            return { value: e.count || 0, name: e.name };
          })
          .sort(function (a, b) {
            return a.value - b.value;
          });

        $timeout(function () {
          _buildChartFn();
        }, 300);
      }
    }

    if (vm.category && vm.issue) {
      if (vm.loadDataTimeout) $timeout.cancel(vm.loadDataTimeout);
      vm.loadDataTimeout = $timeout(function () {
        _getIssueData();
      }, 1000);
    }
  });

  vm.$onInit = function () {
    if (
      !angular.isDefined(vm.props.issue) ||
      !angular.isDefined(vm.props.category)
    ) {
      console.log('Issue or Category undefined');
      return false;
    }

    vm.issue = angular.isObject(vm.props.issue)
      ? vm.props.issue
      : JSON.parse(vm.props.issue);
    vm.category = angular.isObject(vm.props.category)
      ? vm.props.category
      : JSON.parse(vm.props.category);

    _getIssueData();
  };

  $scope.$on('dateChange', function (e, dates) {
    vm.from = moment(dates.desde).toISOString();
    vm.to = moment(dates.hasta).toISOString();

    _getIssueData();
  });

  function _getIssueData() {
    var req = {};
    if (vm.category.id) {
      req.categoryId = vm.category.id;
    }
    if (vm.props.user) {
      req.assignedUsername = vm.props.user;
    }
    if (vm.from && vm.to) {
      req.from = vm.from;
      req.to = vm.to;
    }

    if (vm.echart) vm.echart.showLoading();
    IssuesFactory.getIssuesCounter(req)
      .then(function (res) {
        var dataRecordName =
          vm.props.graphField == 'status'
            ? 'byTypeAndStatus'
            : 'byTypeAndClassification';
        var data = res[dataRecordName][vm.issue.name];

        if (data) {
          vm.graphData = data
            .map(function (e) {
              return { value: e.count, name: e.name };
            })
            .sort(function (a, b) {
              return a.value - b.value;
            });

          $timeout(function () {
            _buildChartFn();
          }, 300);
        } else {
          console.log(
            'Without counters data in ' + dataRecordName + '.' + vm.issue.name
          );
        }
      })
      .catch(function (error) {
        console.log('Error@getIssuesCounter', error);
      });
  }

  function _buildChartFn() {
    var labelOption = {
      show: 'cross',
      position: 'inner',
      formatter: '{c} ({d}%)',
      rich: {
        name: {
          textBorderColor: '#fff',
        },
      },
    };

    if (vm.echart) vm.echart.dispose();

    vm.echart = echarts.init(document.getElementById(vm.widgetName));

    $(window).on('resize', resize);
    $scope.$on('homeWidgetRezised', resize);

    function resize() {
      setTimeout(function () {
        vm.echart.resize();
      }, 200);
    }

    vm.options = {
      title: {
        text: vm.props.title,
        left: 'center',
        align: 'right',
      },
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)',
      },
      legend: {
        bottom: 1,
        data: vm.graphData.map(function (e) {
          return e.name;
        }),
      },
      toolbox: {
        show: true,
        orient: 'vertical',
        left: 'right',
        top: 'center',
        feature: {
          saveAsImage: { title: 'Descargar', show: true },
        },
      },
      series: [
        {
          name: $filter('capitalize')(vm.props.graphField),
          type: 'pie',
          radius: '70%',
          center: ['50%', '50%'],
          data: vm.graphData.map(function (e) {
            e.value = e.value || '-';
            return e;
          }),
          label: labelOption,
          animationType: 'scale',
          animationEasing: 'elasticOut',
          animationDelay: function (idx) {
            return Math.random() * 200;
          },
        },
      ],
    };
    var ChartCustomColors = $localStorageService.getItem("ChartCustomColors");
    if (ChartCustomColors) {
      Object.assign(vm.options, { color: ChartCustomColors });
    }
    vm.echart.setOption(vm.options);
    vm.echart.hideLoading();
  }
}

'use strict';

var app = angular.module('dashboard');

app.component('issuesBarChartWidget', {
  templateUrl: 'app/home/widgets/issues-bar-chart/issues-bar-chart.html',
  controllerAs: 'ctrl',
  bindings: {
    props: '<',
    menu: '=?',
  },
  controller: IssuesBarChartWidgetController,
});

IssuesBarChartWidgetController.$inject = [
  '$scope',
  '$localStorageService',
  '$timeout',
  'translationService',
  'IssuesFactory',
  'UserFactory',
];

function IssuesBarChartWidgetController(
  $scope,
  $localStorageService,
  $timeout,
  $translationService,
  $issuesFactory,
  $userFactory
) {
  var vm = this;
  vm.users = [];
  vm.interval = 'DAY';
  vm.intervalDateFormat = {
    MINUTE: {
      value: 'MINUTE',
      label: $translationService.getTranslationController(
        'Minuto',
        'Minute',
        'Minuto'
      ),
      format: 'HH:mm',
    },
    HOUR: {
      value: 'HOUR',
      label: $translationService.getTranslationController(
        'Hora',
        'Hour',
        'Hora'
      ),
      format: 'HH:mm',
    },
    DAY: {
      value: 'DAY',
      label: $translationService.getTranslationController('Dia', 'Day', 'Dia'),
      format: 'DD-MM',
    },
    WEEK: {
      value: 'WEEK',
      label: $translationService.getTranslationController(
        'Semana',
        'Week',
        'Semana'
      ),
      format: 'ww',
    },
    MONTH: {
      value: 'MONTH',
      label: $translationService.getTranslationController(
        'Mes',
        'Month',
        'Mês'
      ),
      format: 'MM-YYYY',
    },
    YEAR: {
      value: 'YEAR',
      label: $translationService.getTranslationController('Año', 'Year', 'Ano'),
      format: 'YYYY',
    },
  };

  vm.menu = {};
  vm.menu.refresh = {
    label: $translationService.getTranslationController(
      'Actualizar',
      'Refresh',
      'Atualizar'
    ),
    fn: function () {
      _getIssueData();
    },
  };

  vm.widgetName =
    'issues-chart-pie-widget-' +
    (Math.floor(Math.random() * (99999 - 10000)) + 10000);
  vm.graphData = [];

  $scope.$watchCollection('ctrl.props', function (e) {
    if (
      angular.isDefined(vm.props.category) &&
      !angular.isObject(vm.props.category)
    ) {
      vm.category = JSON.parse(vm.props.category);
    }

    if (
      angular.isDefined(vm.props.issue) &&
      !angular.isObject(vm.props.issue)
    ) {
      vm.issue = JSON.parse(vm.props.issue);
    }

    if (vm.category && vm.issue && vm.props.graphField) {
      if (vm.loadDataTimeout) $timeout.cancel(vm.loadDataTimeout);
      vm.loadDataTimeout = $timeout(function () {
        _getIssueData();
      }, 1000);
    }
  });

  vm.$onInit = function () {
    if (
      !angular.isDefined(vm.props.issue) ||
      !angular.isDefined(vm.props.category)
    ) {
      console.log('Issue or Category undefined');
      return false;
    }

    vm.issue = angular.isObject(vm.props.issue)
      ? vm.props.issue
      : JSON.parse(vm.props.issue);
    vm.category = angular.isObject(vm.props.category)
      ? vm.props.category
      : JSON.parse(vm.props.category);

    _getSupervisedUsers();
    _getIssueData();
  };

  function _getSupervisedUsers() {
    var currentUser = $userFactory.getCurrentUser();
    var category = vm.category;

    if (category) {
      return $userFactory
        .getSupervisedUsers(currentUser.username)
        .then(function (res) {
          vm.users = res.data;

          if (vm.users) {
            vm.users = vm.users.map(function (e) {
              return { label: e.fullName, value: e.userId };
            });
          }
        })
        .catch(function (e) {
          console.log('Error@getSupervisedUsers', e);
        });
    }
  }

  $scope.$on('dateChange', function (e, dates) {
    vm.from = moment(dates.desde).toISOString();
    vm.to = moment(dates.hasta).toISOString();

    _getIssueData();
  });

  vm.reloadInterval = function () {
    _getIssueData();
  };

  vm.permissionError = null
  vm.isLoading = null

  function _getIssueData() {
    var predicates = [];
    if (vm.props.user && vm.props.user != 'false') {
      predicates.push({
        label: 'Assigned',
        fieldName: 'assigned_id',
        operation: 'IN',
        values: [vm.props.user],
      });
    }

    var filters = {
      issueTypeId: vm.issue.id,
      predicates: predicates,
      target: vm.props.graphField.toUpperCase(),
      interval: vm.interval,
    };

    if (vm.from && vm.to) {
      filters.from = vm.from;
      filters.to = vm.to;
      filters.datesInUTC = false;
    }

    if (vm.echart) vm.echart.showLoading();

    $issuesFactory
      .getIssuesTimeSeries(filters)
      .then(function (res) {
        vm.series = {};
        // Parse category
        vm.series.category = res
          .sort(function (a, b) {
            return a.xAxis - b.xAxis;
          })
          .map(function (e) {
            // return e.xAxis;
            return moment(e.xAxis).format(
              vm.intervalDateFormat[vm.interval].format
            );
          });

        // Remove duplicates
        vm.series.category = vm.series.category.filter(function (value, index) {
          return vm.series.category.indexOf(value) == index;
        });

        // Parse series
        vm.series.series = [];
        angular.forEach(res, function (value) {
          var serie = vm.series.series.find(function (e) {
            return e.name == value.series;
          });

          if (!serie) {
            vm.series.series.push({ name: value.series, data: [] });
          }
        });

        angular.forEach(vm.series.category, function (category) {
          angular.forEach(vm.series.series, function (serie) {
            var value = res.find(function (e) {
              return (
                e.series == serie.name &&
                moment(e.xAxis).format(
                  vm.intervalDateFormat[vm.interval].format
                ) == category
              );
            });
            if (value) {
              serie.data.push(value.yAxis);
            } else {
              serie.data.push(0);
            }
          });
        });

        vm.graphData = vm.series;
        vm.isLoading = false;
        _buildChartFn();
      })
      .catch(function (err) {
        console.log('Error@getIssuesTimeSeries', err);
        if (err.status == 403) {
          vm.permissionError = err
        }
        vm.isLoading = false;
      });
  }

  function _buildChartFn() {
    var labelOption = {
      show: 'cross',
      position: 'insideBottom',
      distance: 15,
      align: 'left',
      verticalAlign: 'middle',
      rotate: 0,
      formatter: '{c}',
      fontSize: 10,
      rich: {
        name: {
          textBorderColor: '#fff',
        },
      },
    };

    if (vm.echart) vm.echart.dispose();

    vm.echart = echarts.init(document.getElementById(vm.widgetName));

    $(window).on('resize', resize);
    $scope.$on('homeWidgetRezised', resize);

    function resize() {
      setTimeout(function () {
        vm.echart.resize();
      }, 200);
    }

    vm.options = {
      title: {
        text: vm.props.title,
        left: 'center',
        align: 'right',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      legend: {
        bottom: 1,
        data: vm.graphData.series.map(function (e) {
          return e.name;
        }),
      },
      toolbox: {
        show: true,
        orient: 'vertical',
        left: 'right',
        top: 'center',
        feature: {
          saveAsImage: { title: 'Descargar', show: true },
        },
      },
      xAxis: [
        {
          type: 'category',
          axisTick: { show: false },
          axisLabel: { interval: 0 },
          data: vm.graphData.category,
        },
      ],
      yAxis: [
        {
          type: 'value',
        },
      ],
      series: vm.graphData.series.map(function (e) {
        return {
          name: e.name,
          type: 'bar',
          stack: true,
          barGap: 0,
          label: labelOption,
          data: e.data.map(function (e) {
            return e || '-';
          }),
        };
      }),
    };

    if ($localStorageService.getItem("ChartCustomColors")) {
      Object.assign(vm.options, { color: $localStorageService.getItem("ChartCustomColors") });
    }
    vm.echart.setOption(vm.options);
    vm.echart.hideLoading();
  }
}

"use strict";

var app = angular.module("dashboard");

app.component("indicatorsListWidget", {
  templateUrl: "app/home/widgets/indicators-list/indicators-list.html",
  controllerAs: "ctrl",
  bindings: {
    props: "<",
    menu: "=?",
  },
  controller: IndicatorsListWidgetController,
});

IndicatorsListWidgetController.$inject = [
  "$scope",
  '$interval',
  '$timeout',
  "$localStorageService",
  "InputListsFactory",
  "IndicatorsFactory",
  "SchemasFactory",
  "SchemasService",
  "translationService",
];

function IndicatorsListWidgetController(
  $scope,
  $interval,
  $timeout,
  $localStorageService,
  $inputListsFactory,
  $indicatorsFactory,
  $schemasFactory,
  $schemasService,
  $translationService
) {
  var vm = this;

  vm.isLoading = false;
  vm.echart = null;
  vm.series = [];
  vm.dataList = [];
  vm.permissionError = null;

  vm.refresh = function () {
    vm.$onInit();
  };

  vm.menu = {};
  vm.menu.refresh = {
    label: $translationService.getTranslationController(
      "Actualizar",
      "Refresh",
      "Atualizar"
    ),
    fn: function () {
      vm.loading = true;
      vm.executions = [];
      vm.refresh();
    },
  };
  vm.menu.autoRefresh5 = {
    label: $translationService.getTranslationController(
      "Actualizar cada (5s)",
      "AutoRefresh (5s)",
      "Atualizar a cada (5s)"
    ),
    fn: function () {
      vm.delay = 5000;
      vm.startAutoRefresh();
    },
  };
  vm.menu.autoRefresh10 = {
    label: $translationService.getTranslationController(
      "Actualizar cada (10s)",
      "AutoRefresh (10s)",
      "Atualizar a cada (10s)"
    ),
    fn: function () {
      vm.delay = 15000;
      vm.startAutoRefresh();
    },
  };
  vm.menu.autoRefresh15 = {
    label: $translationService.getTranslationController(
      "Actualizar cada (15s)",
      "AutoRefresh (15s)",
      "Atualizar a cada (15s)"
    ),
    fn: function () {
      vm.delay = 15000;
      vm.startAutoRefresh(15000);
    },
  };
  vm.menu.stopAutoRefresh = {
    label: $translationService.getTranslationController(
      "Detener actualización automática",
      "Stop AutoRefresh",
      "Pare a atualização automática"
    ),
    fn: function () {
      vm.stopAutoRefresh();
    },
  };

  vm.$onDestroy = function () {
    vm.stopAutoRefresh();
  };

  vm.startAutoRefresh = function () {
    vm.stopAutoRefresh();
    vm.autoRefresh = true;

    if (angular.isUndefined(vm.timeout)) {
      vm.timeout = $timeout(function () {
        vm.refresh();
        vm.determinateValue = 0;
        $interval.cancel(vm.loaderInterval);
      }, vm.delay);

      vm.determinateLoaderDelay = vm.delay / 100;
      vm.loaderInterval = $interval(function () {
        vm.determinateValue += 1;
      }, vm.determinateLoaderDelay);
    }
  };

  vm.stopAutoRefresh = function () {
    vm.autoRefresh = false;
    if (vm.timeout) {
      $timeout.cancel(vm.timeout);
      $interval.cancel(vm.loaderInterval);
      vm.determinateValue = 0;
      delete vm.loaderInterval;
      delete vm.timeout;
    }
  };

  vm.widgetName =
    "indicators-list-widget-" +
    (Math.floor(Math.random() * (99999 - 10000)) + 10000);

  vm.$onInit = function () {
    vm.isLoading = true;

    if (vm.props.list && vm.props.list.listId) vm.getList();
  };

  vm.getList = function () {
    vm.isLoading = true;
    if (vm.echart) vm.echart.showLoading();

    var params = {
      queryFilters: {},
      pagination: { page: 1, itemsPerPage: 999, sort: "ASC" },
    };

    var promises = [
      $inputListsFactory.getInputListDataFiltered(
        vm.props.list.listId,
        params.queryFilters,
        params.pagination
      ),
      $schemasFactory.getSchemaByIdOrName(vm.props.list.schema),
      $indicatorsFactory.getIndicators(),
    ];

    Promise.all(promises)
      .then(function (res) {
        vm.dataList = [];
        vm.dataList = res[0].data;
        vm.schema = $schemasService.parseSchema(res[1]);
        vm.indicatorsDefs = res[2].data;
      })
      .then(function () {
        var data = vm.dataList.map(function (ele) {
          var item = angular.fromJson(ele.body);

          for (var key in item) {
            if (Object.hasOwnProperty.call(item, key)) {
              var val = item[key];
              var noHashName = key.replace("#", "");
              var schemType = Object.values(vm.schema).find(function (schema) {
                return schema.key === noHashName;
              });

              if (schemType) {
                if (schemType.pk) {
                  item[noHashName] = val;
                }
                if (schemType.type === "date") {
                  item[noHashName] = moment(val.replace("T00:00:00.000000000Z","")).format("YYYY-MM-DD");
                }
              }
            }
          }

          return item;
        });
        vm.dataList = data;
      })
      .then(function () {
        vm.dataList = vm.dataList.sort(_compare);
      })
      .then(function () {
        _toSerie(vm.dataList).then(function (series) {
          $timeout(function () {
            _buildChartFn();
          }, 300);
        });
      })
      .catch(function (err) {
        console.log("Error@getList", err);
        if (err.status == 403) {
          vm.permissionError = err;
        }
        vm.isLoading = false;
      });
  };

  function _compare(a, b) {
    if (a[vm.props.list.xAxis] > b[vm.props.list.xAxis]) return 1;
    if (a[vm.props.list.xAxis] < b[vm.props.list.xAxis]) return -1;
    return 0;
  }

  var labelOption = {
    show: true,
    rotate: vm.props.list && vm.props.list.type == "bar" ? 90 : 0,
    align: "left",
    verticalAlign: "middle",
    position: "insideBottom",
    distance: 15,
    formatter: function (params) {
      return params.value + "% " + params.data.name;
    },
    fontSize: 13,
    rich: {
      name: {},
    },
    color: "#000",
  };

  function _isInRange(value, intervals) {
    for (var i = 0; i < intervals.length; i++) {
      var interval = intervals[i];
      var range = Array(interval.max - interval.min + 1)
        .fill(interval.min)
        .map(function (x, y) {
          return x + y;
        });

      if (range.includes(value)) {
        return interval;
      } else {
        continue;
      }
    }
  }

  var intervalOutRAnge = {
    label: $translationService.getTranslationController(
      "Out Of Range",
      "Fuera De Rango",
      "Fora De Alcance"
    ),
    color: "#bdc3c7",
  };

  function _toSerie(data) {
    return new Promise(function (resolve, reject) {
      vm.series = [];
      for (var i = 0; i < vm.props.list.yAxis.length; i++) {
        var yAxis = vm.props.list.yAxis[i];
        var indicatorIs = vm.indicatorsDefs.find(function (ind) {
          return ind.name === yAxis;
        });
        var dataSerie = data.map(function (col) {
          var indicator =
            _isInRange(col[yAxis], indicatorIs.intervals) || intervalOutRAnge;
          return {
            value: col[yAxis],
            label: indicator.label,
            name: yAxis,
            itemStyle: {
              color: indicator.color,
              borderWidth: vm.props.list.type == "bar" ? 0 : 5,
            },
          };
        });

      

        var newSerie = {
          name: yAxis,
          type: vm.props.list.type || "bar",
          barGap: 0,
          label: labelOption,
          data: dataSerie,
        };
        vm.series.push(newSerie);
      }
      resolve(vm.series);
    });
  }

  function _buildChartFn() {
    if (vm.echart) vm.echart.dispose();

    vm.echart = echarts.init(document.getElementById(vm.widgetName));

    $(window).on("resize", resize);
    $scope.$on("homeWidgetRezised", resize);

    function resize() {
      setTimeout(function () {
        vm.echart.resize();
      }, 200);
    }

    vm.options = {
      title: {
        text: vm.props.list.descripcion,
        left: "center",
        align: "right",
      },
      toolbox: {
        show: true,
        orient: "vertical",
        left: "right",
        top: "top",
        feature: {
          saveAsImage: {
            title: $translationService.getTranslationController(
              "Descargar",
              "Download",
              "Descarga"
            ),
            show: true,
          },
        },
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        formatter: function (params) {
          var tooltip = "";

          for (var i = 0; i < params.length; i++) {
            if (i == 0) {
              tooltip += params[i].axisValue + "<br />";
            }
            var e = params[i];
            tooltip +=
              e.marker + "" + e.value + " : " + e.data.label + "<br />";
          }
          return tooltip;
        },
      },
      xAxis: [
        {
          name: vm.props.list.xAxis,
          nameLocation: "middle",
          nameGap: 30,
          nameTextStyle: {
            fontWeight: "bold",
            fontSize: 14,
          },
          type: "category",
          axisTick: { show: false },
          data: vm.dataList
            .map(function (e) {
              return e[vm.props.list.xAxis];
            })
        },
      ],
      yAxis: [
        {
          name: "",
          type: "value",
        },
      ],
      series: vm.series,
    };
    if ($localStorageService.getItem("ChartCustomColors")) {
      Object.assign(vm.options, { color: $localStorageService.getItem("ChartCustomColors") });
    }

    vm.echart.setOption(vm.options);
    vm.echart.hideLoading();
  }
}

"use strict";

var app = angular.module("dashboard");
app.component("executionsForm", {
  templateUrl: "app/home/widgets/executions-form/executions-form.html",
  controllerAs: "ctrl",
  bindings: {
    props: "=",
    type: "=",
  },
  controller: executionsFormWidgetController,
});

executionsFormWidgetController.$inject = [
  "$scope",
  "toastr",
  "FunctionFactory",
  "SchemasFactory",
];
function executionsFormWidgetController(
  $scope,
  $toastr,
  $functionFactory,
  $SchemasFactory
) {
  var vm = this;
  var rawSchema = null;
  // console.log(vm);

  vm.form = [];
  vm.rule = null;
  vm.schema = null;
  vm.loading = true;

  $scope.selectedIndex = 0;
  // console.log("executionsFormWidgetController");
  vm.init = function () {
    // console.log("init", vm.props);
    if (vm.props && vm.props.rule) {
      getSchema();
    }
  };
  vm.init();

  function createForm() {
    for (var key in vm.schema) {
      if (Object.hasOwnProperty.call(vm.schema, key)) {
        var prop = vm.schema[key];
        var isPk = rawSchema.$id.replace("#", "") == key;
        var hash = isPk ? "#" : "";
        var name = prop.displayName || key;
        var keyname = hash + name;
        vm.form.push(
          Object.assign(
            {
              name: key,
              pk: isPk,
              displayName: keyname,
              required: rawSchema.required.includes(hash + key),
              attributeId: null,
              attributeName: key,
              attributeType: prop.type,
              attributeValue: "",
              attributeDescription: prop.displayName,
            },
            prop
          )
        );
      }
    }
    vm.form = vm.form.reduce(function (acc, cur) {
      if (cur.group === undefined) cur.group = "Default";
      if (cur.group === null) cur.group = "Default";
      if (cur.group === "") cur.group = "Default";
      if (cur.group === "null") cur.group = "Default";
      if (!acc[cur.group]) acc[cur.group] = [];
      acc[cur.group].push(cur);
      return acc;
    }, {});
  }

  vm.permissionError = null

  function getSchema() {
    vm.loading = true;
    $functionFactory
      .getFunctionByID(vm.props.rule.id)
      .then(function (rule) {
        // console.log(rule);
        vm.rule = rule;
        vm.schema = rule.schema.schema;
        var parseSchema = JSON.parse(vm.schema);
        var _SCHEMA_ = parseSchema.definitions[rule.schema.name];
        vm.schema = angular.copy(_SCHEMA_.properties);
        rawSchema = angular.copy(_SCHEMA_);
        vm.loading = false;
        createForm();
      })
      .catch(function (err) {
        console.error("Error@getFunctionByID", err);
        // $toastr.error(err.message);
        if (err.status == 403) {
          vm.permissionError = err
        }
        vm.isLoading = false;
      });
  }

  vm.execute = function () {
    var attributes = [];

    for (var key in vm.form) {
      if (Object.hasOwnProperty.call(vm.form, key)) {
        var inputs = vm.form[key];
        for (var i = 0; i < inputs.length; i++) {
          var input = inputs[i];
          attributes.push({
            attributeId: input.attributeId,
            attributeName: input.attributeName,
            attributeType:
              input.attributeType != "string" ? "string" : input.attributeType,
            attributeValue: input.attributeValue,
            attributeDescription: input.attributeDescription,
          });
        }
      }
    }

    if (!$scope.executionform.$valid) {
      var input =
        rawSchema.properties[$scope.executionform.$error.required[0].$name];

      var tabs = Object.keys(vm.form);

      var errorTab = tabs.findIndex(function (e) {
        return e === input.group;
      });

      $scope.selectedIndex = errorTab === -1 ? tabs.length : errorTab;

      return;
    }

    vm.loading = true;

    $functionFactory
      .executeV2(
        vm.props.rule.id,
        vm.props.rule.liveVersion,
        JSON.stringify(attributes)
      )
      .then(function (res) {
        // console.log(res);
        $toastr.success("Regla ejecutada con exito");
      })
      .catch(function (error) {
        console.error("Error@execute", error);
        $toastr.error("Error al ejecutar la regla");
      })
      .finally(function () {
        vm.loading = false;
      });
  };
}

"use strict";

var app = angular.module("dashboard");
app.component("configExecutionsForm", {
  templateUrl: "app/home/widgets/executions-form/config-executions-form.html",
  controllerAs: "ctrl",
  bindings: {
    widget: "=",
  },
  controller: configExecutionsFormController,
});

configExecutionsFormController.$inject = [
  "$scope",
  "FunctionFactory",
  "SchemasFactory",
];
function configExecutionsFormController(
  $scope,
  $functionFactory,
  $SchemasFactory
) {
  var vm = this;

  $scope.searchTextrule = "";

  vm.form = {
    title: null,
    schema: null,
    rule: null,
  };

  vm.schema = null;

  vm.functions = [];

  vm.ruleItemChange = ruleItemChange;
  vm.querySearchRule = querySearchRule;
  vm.liveVersion = null;

  init();

  function init() {
    vm.widget.widget.props = vm.form;
    $functionFactory
      .getFunctions()
      .then(function (response) {
        vm.functions = response.data.filter(function (e) {
          return e.schema;
        });
      })
      .catch(function (err) {
        console.error("Error@getFunctions", err);
      });
  }

  function ruleItemChange(ruleSelectd) {
    if (!ruleSelectd) {
      return;
    }
    if (!ruleSelectd.schema) {
      return;
    }

    $functionFactory.getVersions(ruleSelectd.id).then(function (response) {
      vm.liveVersion = response.find(function (v) {
        return v.id == ruleSelectd.liveVersion;
      });
    });

    $SchemasFactory
      .getSchemaByIdOrName(ruleSelectd.schema.name)
      .then(function (schema) {
        schema.schema = JSON.parse(schema.schema);
        var _SCHEMA_ = schema.schema.definitions[schema.name];
        vm.schema = _SCHEMA_.properties;
        vm.form.schema = schema.name;
      })
      .catch(function (err) {
        console.error("Error@getSchemaByIdOrName", err);
      });
  }

  function querySearchRule(query) {
    var results = query
      ? vm.functions.filter(function (s) {
          var lowercaseQuery = query.toLowerCase();
          return s.name.toLowerCase().includes(lowercaseQuery);
        })
      : vm.functions;
    return results;
  }
}

"use strict";

var app = angular.module("dashboard");

app.component("executionsChartWidget", {
  templateUrl: "app/home/widgets/executions-chart/executions-chart.html",
  controllerAs: "ctrl",
  bindings: {
    menu: "=?",
    position: "=",
    props: "=",
  },
  controller: executionsChartWidgetController,
});

executionsChartWidgetController.$inject = [
  "$scope",
  "$rootScope",
  "$interval",
  "$timeout",
  "translationService",
  "FunctionFactory",
  "PermissionsFactory",
  "$localStorageService",
];
function executionsChartWidgetController(
  $scope,
  $rootScope,
  $interval,
  $timeout,
  $translationService,
  $functionFactory,
  $permissionsFactory,
  $localStorageService
) {
  var vm = this;
  $translationService.getTranslation(vm, "dashboard");
  vm.autoRefresh = false;
  vm.delay;
  vm.determinateValue = 0;

  var zoom = {
    start: 0,
    end: 100,
  };

  var options = {
    tooltip: {
      formatter: function (params) {
        var status = params.value[3].status;
        var time = params.value[3].time;
        var schedule = params.value[2].nowStr;
        var executed = moment(params.value[0]).format("HH:mm:ss a");
        var date = moment(params.value[0]).format("DD-MM-YYYY");
        var info = "";
        info += params.marker + ": <b>" + params.seriesName + "</b><br>";
        info += vm.translation.date + ": <b>" + date + "</b><br>";
        info += vm.translation.schedule + ": <b>" + schedule + "</b><br>";
        info += vm.translation.start + ": <b>" + executed + "</b><br>";
        info += vm.translation.time + ": <b>" + time + "</b><br>";
        info += vm.translation.status + ": <b>" + status + "</b>";

        if (params.value[3].errorMessage != "") {
          var errorMessage = params.value[3].errorMessage;
          info += "<br>" + "⚠️: " + errorMessage.split(":")[0] + "<br>";
        }
        return info;
      },
    },
    xAxis: {
      name: $translationService.getTranslationController(
        "Cronología",
        "Timeline",
        "Linha do tempo"
      ),
      type: "time",
      nameLocation: "middle",
      nameTextStyle: {
        verticalAlign: "top",
        lineHeight: 80,
      },
    },
    yAxis: {
      name: $translationService.getTranslationController(
        "Programación",
        "Schedule",
        "Cronograma"
      ),
      type: "category",
      data: null,
      splitLine: {
        show: true,
      },
    },
    dataZoom: [
      {
        start: zoom.start,
        end: zoom.end,
        type: "slider",
        filterMode: "weakFilter",
        showDataShadow: false,
        height: 6,
        borderColor: "transparent",
        backgroundColor: "#e2e2e2",
        handleIcon:
          "M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z", // jshint ignore:line
        handleSize: 20,
        handleStyle: {
          shadowBlur: 6,
          shadowOffsetX: 1,
          shadowOffsetY: 2,
          shadowColor: "#aaa",
        },
        labelFormatter: "",
      },
      {
        type: "inside",
        filterMode: "weakFilter",
      },
    ],
    grid: {
      bottom: "25%",
    },
    series: [],
  };

  vm.startDate = moment().hour(0).minute(0).second(0).subtract(1, "day");
  vm.endDate = moment().hour(23).minute(59).second(59);

  vm.widgetName =
    "executions-chart-widget-" +
    (Math.floor(Math.random() * (99999 - 10000)) + 10000);

  vm.request = {
    startDate: $rootScope.desde,
    endDate: $rootScope.hasta,
    pagination: {
      sort: "desc",
      page: 1,
      totalRecords: 0,
      itemsPerPage: 50,
    },
    exportToCsv: false,
    filters: [],
  };

  vm.loading = true;

  $scope.$on("dateChange", function (e, dates) {
    vm.startDate = dates.desde;
    vm.endDate = dates.desde;
    vm.init();
  });

  vm.refresh = function () {
    vm.init();
  };

  vm.startAutoRefresh = function () {
    vm.stopAutoRefresh();
    vm.autoRefresh = true;

    if (angular.isUndefined(vm.timeout)) {
      vm.timeout = $timeout(function () {
        vm.refresh();
        vm.determinateValue = 0;
        $interval.cancel(vm.loaderInterval);
      }, vm.delay);

      vm.determinateLoaderDelay = vm.delay / 100;
      vm.loaderInterval = $interval(function () {
        vm.determinateValue += 1;
      }, vm.determinateLoaderDelay);
    }
  };

  vm.stopAutoRefresh = function () {
    vm.autoRefresh = false;
    if (vm.timeout) {
      $timeout.cancel(vm.timeout);
      $interval.cancel(vm.loaderInterval);
      vm.determinateValue = 0;
      delete vm.loaderInterval;
      delete vm.timeout;
    }
  };

  vm.init = function () {
    vm.loading = false;

    if (!$permissionsFactory.hasPermission("function:read")) {
      return false;
    }

    if (!angular.isDefined(vm.props.rules)) {
      return false;
    }

    if (!Array.isArray(vm.props.rules)) {
      return false;
    }

    if (vm.props.rules.length === 0) {
      return false;
    }

    if (vm.echart) vm.echart.showLoading();

    vm.request.startDate = moment($rootScope.desde).format()
    vm.request.endDate = moment($rootScope.hasta).format()

    if ($localStorageService.getItem("ChartCustomColors")) {
      vm.chartCustomColors = $localStorageService.getItem("ChartCustomColors");
    }

    vm.loading = true;

    var PROMISES = [_getFunctions(), _getExecutions()];

    Promise.allSettled(PROMISES)
      .then(function (result) {
        vm.rules = result[0].value;
        vm.executions = result[1].value;
        _buildChart();
        if (vm.autoRefresh) {
          vm.startAutoRefresh();
        }
      })
      .catch(function (err) {
        console.error(err);
      });
  };

  function _getFunctions() {
    return new Promise(function (resolve, reject) {
      $functionFactory
        .getFunctions()
        .then(function (res) {
          var ruleIds = vm.props.rules.map(function (ele) {
            return ele.id;
          });
          var data = res.data;
          var byGroup = data.filter(function (rule) {
            return ruleIds.includes(rule.id);
          });

          var cfg = byGroup;
          cfg.forEach(function (c) {
            if (c.schedule) {
              var cronExpression =
                c.schedule.minute +
                " " +
                c.schedule.hour +
                " " +
                c.schedule.dayOfMonth +
                " " +
                c.schedule.month +
                " " +
                c.schedule.dayOfWeek;
              c.cronExpression = cronExpression;
              c.nowStr = prettyCron.toString(cronExpression);
              c.nowStr =
                c.schedule.year == "*"
                  ? c.nowStr
                  : c.nowStr + " in " + c.schedule.year;
              c.nextStr = prettyCron.getNext(cronExpression);
            }
          });

          cfg = cfg
            .map(function (e) {
              return {
                id: e.id,
                liveVersion: e.liveVersion,
                nowStr: e.nowStr,
                name: e.name,
                cronExpression: e.cronExpression,
              };
            })
            .sort(function (a, b) {
              var cronExpressionA = a.cronExpression;
              var cronExpressionB = b.cronExpression;
              if (cronExpressionA < cronExpressionB) {
                return -1;
              }
              if (cronExpressionA > cronExpressionB) {
                return 1;
              }
              return 0;
            });

          if (vm.autoRefresh) {
            vm.startAutoRefresh();
          }

          resolve(cfg);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  function _getExecutions() {
    return new Promise(function (resolve, reject) {
      $functionFactory
        .getExecutions("all", vm.request)
        .then(function (res) {
          var data = res.data
            .map(function (e) {
              var label = e.executionTime > 9999 ? "sec" : "ms";
              var time =
                e.executionTime > 9999
                  ? Math.floor(e.executionTime / 1000)
                  : e.executionTime;
              return {
                id: e.functionId,
                name: e.functionName,
                versionId: e.versionId,
                init: e.attributes.INIT_TIME,
                time: time + "" + label,
                errorMessage: e.errorMessage || "",
                status: e.status,
              };
            })
            .sort(function (a, b) {
              var initTimeA = a.init;
              var initTimeB = b.init;
              if (initTimeA < initTimeB) {
                return -1;
              }
              if (initTimeA > initTimeB) {
                return 1;
              }
              return 0;
            });
          resolve(data);
        })
        .catch(function (err) {
          reject(err);
        });
    });
  }

  vm.menu = {};
  vm.menu.refresh = {
    label: $translationService.getTranslationController(
      "Actualizar",
      "Refresh",
      "Atualizar"
    ),
    fn: function () {
      vm.loading = true;
      vm.executions = [];
      vm.refresh();
    },
  };
  vm.menu.autoRefresh5 = {
    label: $translationService.getTranslationController(
      "Actualizar cada (5s)",
      "AutoRefresh (5s)",
      "Atualizar a cada (5s)"
    ),
    fn: function () {
      vm.delay = 5000;
      vm.startAutoRefresh();
    },
  };
  vm.menu.autoRefresh10 = {
    label: $translationService.getTranslationController(
      "Actualizar cada (10s)",
      "AutoRefresh (10s)",
      "Atualizar a cada (10s)"
    ),
    fn: function () {
      vm.delay = 15000;
      vm.startAutoRefresh();
    },
  };
  vm.menu.autoRefresh15 = {
    label: $translationService.getTranslationController(
      "Actualizar cada (15s)",
      "AutoRefresh (15s)",
      "Atualizar a cada (15s)"
    ),
    fn: function () {
      vm.delay = 15000;
      vm.startAutoRefresh(15000);
    },
  };
  vm.menu.stopAutoRefresh = {
    label: $translationService.getTranslationController(
      "Detener actualización automática",
      "Stop AutoRefresh",
      "Pare a atualização automática"
    ),
    fn: function () {
      vm.stopAutoRefresh();
    },
  };

  vm.$onDestroy = function () {
    vm.stopAutoRefresh();
  };

  var hasChangeSize = false;

  $scope.$watch("ctrl.position.sizeY", function (nval) {
    if (hasChangeSize) return;
    hasChangeSize = true;
    setTimeout(function () {
      vm.refresh();
      hasChangeSize = false;
    }, 2000);
  });

  function _randColor(index) {
    var color = "#000000";
    if (vm.chartCustomColors && index <= vm.chartCustomColors.length - 1)
      color = vm.chartCustomColors.find(function (e, i) {
        return i == index;
      });
    else {
      color = "#000000".replace(/0/g, function () {
        return (~~(Math.random() * 16)).toString(16);
      });
    }
    return color;
  }

  function _buildChart() {
    // if (vm.echart) vm.echart.dispose();

    var categories = vm.rules.map(function (rule) {
      return rule.name;
    });

    vm.echart = echarts.init(document.getElementById(vm.widgetName));

    $(window).on("resize", resize);
    $scope.$on("homeWidgetRezised", resize);

    function resize() {
      setTimeout(function () {
        vm.echart.resize();
      }, 200);
    }

    vm.echart.showLoading();

    options.yAxis.data = categories;
    options.dataZoom[0].start = zoom.start;
    options.dataZoom[0].end = zoom.end;

    options.series = vm.rules.map(function (rule, index) {
      var color = _randColor(index);

      var executionsByRule =
        vm.executions.filter(function (execution) {
          return execution.id === rule.id;
        }) || [];

      var executionsData = executionsByRule.map(function (execution) {
        return {
          value: [execution.init, index, rule, execution],
          itemStyle: {
            color: execution.errorMessage === "" ? color : "#ff0000",
          },
          symbol: execution.errorMessage === "" ? "circle" : "triangle",
          symbolRotate: execution.errorMessage === "" ? 0 : 180,
        };
      });

      return {
        type: "scatter",
        symbolSize: 20,
        name: rule.name,
        data: executionsData,
        itemStyle: {
          color: color,
        },
      };
    });

    vm.echart.hideLoading();
    vm.echart.setOption(options);
    vm.echart.resize();
    vm.echart.on("datazoom", function (params) {
      zoom.start = params.start;
      zoom.end = params.end;
    });
  }
}

"use strict";

var app = angular.module("dashboard");

app.component("executionsWidget", {
  templateUrl: "app/home/widgets/executions/executions.html",
  controllerAs: "ctrl",
  bindings: {
    menu: "=?",
    position: "=",
  },
  controller: executionsWidgetController,
});

executionsWidgetController.$inject = [
  "$scope",
  "$rootScope",
  "$interval",
  "$timeout",
  "translationService",
  "FunctionFactory",
  "PermissionsFactory",
];
function executionsWidgetController(
  $scope,
  $rootScope,
  $interval,
  $timeout,
  $translationService,
  FunctionFactory,
  PermissionsFactory
) {
  var vm = this;
  $translationService.getTranslation(vm, "dashboard");
  vm.autoRefresh = false;
  vm.delay;
  vm.determinateValue = 0;

  vm.request = {
    startDate: $rootScope.desde,
    endDate: $rootScope.hasta,
    sort: "desc",
    pagination: {
      sortBy: "startTime",
      sort: "desc",
      page: 1,
      totalRecords: 0,
      itemsPerPage: 50,
    },
    exportToCsv: false,
    filters: [],
  };

  vm.loading = true;

  $scope.$on("dateChange", function (e, dates) {
    vm.startDate = dates.desde;
    vm.endDate = dates.hasta;
    vm.getExecutions();
  });

  vm.refresh = function () {
    vm.getExecutions();
  };

  vm.$onInit = function () {
    vm.getExecutions();
  };

  vm.startAutoRefresh = function () {
    vm.stopAutoRefresh();
    vm.autoRefresh = true;

    if (angular.isUndefined(vm.timeout)) {
      vm.timeout = $timeout(function () {
        vm.refresh();
        vm.determinateValue = 0;
        $interval.cancel(vm.loaderInterval);
      }, vm.delay);

      vm.determinateLoaderDelay = vm.delay / 100;
      vm.loaderInterval = $interval(function () {
        vm.determinateValue += 1;
      }, vm.determinateLoaderDelay);
    }
  };

  vm.stopAutoRefresh = function () {
    vm.autoRefresh = false;
    if (vm.timeout) {
      $timeout.cancel(vm.timeout);
      $interval.cancel(vm.loaderInterval);
      vm.determinateValue = 0;
      delete vm.loaderInterval;
      delete vm.timeout;
    }
  };

  vm.onChangedPage = function (page) {
    console.log("onChangedPage", page);
    vm.getExecutions(page);
  }

  vm.getExecutions = function (page) {
    if (!PermissionsFactory.hasPermission("function:read")) {
      vm.loading = false;
      return false;
    }

    vm.request.startDate = moment($rootScope.desde).format()
    vm.request.endDate = moment($rootScope.hasta).format()

    vm.request.pagination.page = page || 1;

    vm.loading = true;

    FunctionFactory.getExecutions("all", vm.request)
      .then(function (res) {
        vm.executions = [];
        vm.executions = res.data;
        vm.request.pagination.page = res.pagination.page;
        vm.request.pagination.itemsPerPage = res.pagination.itemsPerPage;
        vm.request.pagination.totalRecords = res.pagination.totalRecords;
        vm.executions = vm.executions.map(function (e) {
          e.executionTimeLabel = e.executionTime > 9999 ? "sec" : "ms";
          e.executionTime =
            e.executionTime > 9999
              ? Math.floor(e.executionTime / 1000)
              : e.executionTime;
          return e;
        });
        if (vm.autoRefresh) {
          vm.startAutoRefresh();
        }
      })
      .catch(function (err) {
        console.log("Error@getExecutions", err);
      })
      .finally(function () {
        vm.loading = false;
      });
  };

  vm.menu = {};
  vm.menu.refresh = {
    label: $translationService.getTranslationController(
      "Actualizar",
      "Refresh",
      "Atualizar"
    ),
    fn: function () {
      vm.loading = true;
      vm.executions = [];
      vm.refresh();
    },
  };
  vm.menu.autoRefresh5 = {
    label: $translationService.getTranslationController(
      "Actualizar cada (5s)",
      "AutoRefresh (5s)",
      "Atualizar a cada (5s)"
    ),
    fn: function () {
      vm.delay = 5000;
      vm.startAutoRefresh();
    },
  };
  vm.menu.autoRefresh10 = {
    label: $translationService.getTranslationController(
      "Actualizar cada (10s)",
      "AutoRefresh (10s)",
      "Atualizar a cada (10s)"
    ),
    fn: function () {
      vm.delay = 15000;
      vm.startAutoRefresh();
    },
  };
  vm.menu.autoRefresh15 = {
    label: $translationService.getTranslationController(
      "Actualizar cada (15s)",
      "AutoRefresh (15s)",
      "Atualizar a cada (15s)"
    ),
    fn: function () {
      vm.delay = 15000;
      vm.startAutoRefresh(15000);
    },
  };
  vm.menu.stopAutoRefresh = {
    label: $translationService.getTranslationController(
      "Detener actualización automática",
      "Stop AutoRefresh",
      "Pare a atualização automática"
    ),
    fn: function () {
      vm.stopAutoRefresh();
    },
  };

  vm.$onDestroy = function () {
    vm.stopAutoRefresh();
  };

  var hasChangeSize = false;

  $scope.$watch("ctrl.position.sizeY", function (nval) {
    if (hasChangeSize) return;
    hasChangeSize = true;
    setTimeout(function () {
      vm.refresh();
      hasChangeSize = false;
    }, 2000);
  });
}

"use strict";

var app = angular.module("dashboard");
app.component("tableDataWidget", {
  templateUrl:
    "app/home/widgets/data-management-table/data-management-table.html",
  controllerAs: "ctrl",
  bindings: {
    props: "=",
    type: "=",
  },
  controller: dataManagementWidgetController,
});

dataManagementWidgetController.$inject = ["$scope", "FunctionFactory"];
function dataManagementWidgetController($scope, $functionFactory) {
  var interval = null;
  var vm = this;
  var rulefunction;
  $scope.ruleStatus = false;
  vm.containerid = "widget-container-" + new Date().getTime();
  vm.loading = false;
  vm.rule = {
    active: false,
  };

  vm.init = function () {
    if (vm.props && vm.props.rule && vm.props.table && vm.props.schema)
      getFunction();
  };
  vm.init();

  function getFunction() {
    var ruleID = vm.props.rule.id;
    vm.loading = true;
    $functionFactory
      .getFunctionByID(ruleID)
      .then(function (res) {
        rulefunction = res;
        vm.rule = res;
        vm.loading = false;
      })
      .catch(function (err) {
        console.log("Error@getFunctionByID", err);
        vm.loading = false;
      });
  }

  function reloadTable() {
    $scope.$broadcast("reloadtabledata");
  }

  function resize() {
    reloadTable();
  }

  $scope.onChangeStatusRule = function () {
    console.log("onChangeStatusRule");
    toggleActiveFunction();
  };

  function toggleActiveFunction() {
    rulefunction.active = !rulefunction.active;
    vm.loading = true;
    $functionFactory
      .saveFunction(rulefunction)
      .then(function (res) {
        vm.rule = res;
        vm.loading = false;
      })
      .catch(function (err) {
        console.log("getFunctionByID", err);
        vm.loading = false;
      });
  }

  $(window).on("resize", resize);
  $scope.$on("homeWidgetRezised", resize);
}

'use strict';

var app = angular.module('dashboard');
app.component('configDataManagementTable', {
  templateUrl:
    'app/home/widgets/data-management-table/config-data-management-table.html',
  controllerAs: 'ctrl',
  bindings: {
    widget: '=',
  },
  controller: configDataManagementTableController,
});

configDataManagementTableController.$inject = [
  '$scope',
  'toastr',
  'DataTableFactory',
  'FunctionFactory',
];
function configDataManagementTableController(
  $scope,
  toastr,
  $dataTableFactory,
  $functionFactory
) {
  var vm = this;
  vm.schemas = [];
  vm.tables = [];
  vm.rules = [];
  vm.tableColumns = [];

  $scope.searchTextSchema = '';
  $scope.searchTextTable = '';
  $scope.searchTextRule = '';

  vm.schemaItemChange = schemaItemChange;
  vm.querySearchSchema = querySearchSchema;

  vm.tableItemChange = tableItemChange;
  vm.querySearchTable = querySearchTable;

  vm.querySearcRule = querySearcRule;

  vm.config = {
    title: 'table data',
    schema: null,
    table: null,
    rule: null,
    columns: [],
    filter: null,
  };

  vm.init = function () {
    vm.widget.widget.props = vm.config;
    vm.widget.widget.required = ['title', 'schema', 'table', 'rule', 'columns'];
    _getAllSchemas();
  };
  vm.init();

  function _getAllSchemas() {
    $dataTableFactory
      .getAllSchemas()
      .then(function (res) {
        vm.schemas = res;
      })
      .catch(function (err) {
        console.error('Error@getAllSchemas', err);
        toastr.error(err.message || 'Error getting schemas'); 
      });
  }

  function schemaItemChange(item) {
    $dataTableFactory
      .getAllTablesBySchemasName(item)
      .then(function (res) {
        vm.tables = res.map(function (t) {
          return t.tableName;
        });
      })
      .catch(function (err) {
        console.error('Error@schemaItemChange', err);
      });
  }

  function tableItemChange(item) {
    $functionFactory
      .getFunctions()
      .then(function (res) {
        vm.rules = res.data.map(function (r) {
          return { id: r.id, name: r.name };
        });
      })
      .catch(function (err) {
        console.error('Error@tableItemChange', err);
      });

    vm.config.columns = [];

    if (!item) {
      return;
    } else {
      var tableName = item;
      var schemaName = vm.config.schema;

      $dataTableFactory
        .getTable(tableName, schemaName)
        .then(function (res) {
          vm.tableColumns = res.columns.filter(function (c) {
            return c.colName != 'id_row';
          });
        })
        .catch(function (err) {
          console.error('Error@tableItemChange', err);
        });
    }
  }

  function querySearchSchema(query) {
    var results = query
      ? vm.schemas.filter(function (s) {
          var lowercaseQuery = s.toLowerCase();
          return query.indexOf(lowercaseQuery) === 0;
        })
      : vm.schemas;

    return results;
  }

  function querySearchTable(query) {
    var results = query
      ? vm.tables.filter(function (s) {
          var lowercaseQuery = s.toLowerCase();
          return query.indexOf(lowercaseQuery) === 0;
        })
      : vm.tables;

    return results;
  }

  function querySearcRule(query) {
    var results = query
      ? vm.rules.filter(function (s) {
          var lowercaseQuery = s.name.toLowerCase();
          return query.indexOf(lowercaseQuery) === 0;
        })
      : vm.rules;

    return results;
  }
}

'use strict';

var app = angular.module('dashboard');
app.component('chartDataWidget', {
  templateUrl:
    'app/home/widgets/data-management-chart/data-management-chart.html',
  controllerAs: 'ctrl',
  bindings: {
    props: '=',
  },
  controller: dataManagementChartWidgetController,
});

dataManagementChartWidgetController.$inject = [
  '$scope',
  '$mdDialog',
  'dataTableService',
];
function dataManagementChartWidgetController(
  $scope,
  $mdDialog,
  $dataTableService
) {
  // console.log('dataManagementChartWidgetController');
  var vm = this;
  // console.log(vm.props);
  // console.log($scope);

  var interval = null;
  var datatable = [];
  var columns;
  var onlinePredicate = {
    fieldName: vm.props.xAxis,
    operation: 'GREATER_OR_EQUAL_THAN',
    // value: '2023-07-03T15:58',
    value: moment($scope.desde).format('YYYY-MM-DD') + 'T10:30',
    values: [null, null],
  };
  var dalayInterval = 4000;

  var options = {
    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        params = params[0];
        var d = new Date(params.name);
        return params.data + '<br>' + formatDate(d);
      },
      axisPointer: {
        animation: false,
      },
    },
    grid: {
      top: 25,
      left: 40,
      right: 25,
      bottom: 25,
    },
    xAxis: {
      type: 'category',
      data: [],
    },
    yAxis: {
      type: 'value',
    },
    series: setSeries(),
  };

  var isTimeChart = false;
  var timeTypes = ['date', 'timestamp', 'time'];

  vm.height = '400px';

  vm.isOnline = false;

  vm.pagination = {
    page: 1,
    itemsPerPage: 100,
    sort: 'desc',
    sortBy: vm.props.xAxis,
    totalRecords: 0,
  };

  vm.predicates = vm.props.predicates || [];

  vm.echart;

  vm.widgetName =
    'issues-chart-pie-widget-' +
    (Math.floor(Math.random() * (99999 - 10000)) + 10000);

  function setSeries() {
    var series = [];
    vm.props.series.forEach(function (serie) {
      series.push({
        name: serie.name,
        data: [],
        type: serie.type,
      });
    });
    return series;
  }

  vm.init = function () {
    Promise.allSettled([
      $dataTableService.getDataTable(
        vm.props.table,
        vm.props.schema,
        vm.pagination,
        vm.predicates
      ),
      $dataTableService.getTable(vm.props.table, vm.props.schema),
      $dataTableService.getTableFilters(vm.props.table, vm.props.schema),
    ])
      .then(function (res) {
        // console.log(res);
        var data = res[0].value;
        var tbl = res[1].value;
        var flts = res[2].value;

        datatable = data.data || [];
        datatable = datatable.sort(function (a, b) {
          return a[vm.props.xAxis] - b[vm.props.xAxis];
        });

        vm.pagination.totalRecords = data.pagination.totalRecords;

        columns = $dataTableService.createColumns(tbl.columns, flts) || [];

        var xAxisColunn = tbl.columns.find(function (c) {
          return c.colName == vm.props.xAxis;
        });

        isTimeChart = xAxisColunn && timeTypes.includes(xAxisColunn.colType);
        options.xAxis.type == isTimeChart ? 'time' : 'value';

        clearSeriesValues();

        options.series.forEach(function (s) {
          s.data = getSerieValues(s.name);
        });

        if (isTimeChart) {
          options.xAxis.axisLabel = {
            formatter: function (value) {
              var d = new Date(value);
              return formatDate(d);
            },
          };
        }

        if (vm.isOnline) {
          updateChart();
        } else {
          buildChart();
        }

        // console.log(options);
      })
      .catch(function (err) {
        console.log(err);
      });
  };
  vm.init();

  function getSerieValues(key) {
    return datatable.map(function (item) {
      var prop = item[key];
      var xa = item[vm.props.xAxis];

      if (isTimeChart) {
        options.xAxis.data.push(new Date(xa));
      } else {
        options.xAxis.data.push(xa);
      }

      return prop;
    });
  }

  function formatDate(timestamp) {
    var date = new Date(timestamp);
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    return (
      day +
      '/' +
      month +
      '/' +
      year +
      ' ' +
      hours +
      ':' +
      minutes +
      ':' +
      seconds
    );
  }

  vm.filterTableManagement = function () {
    $mdDialog
      .show({
        controller: 'tableDataFilterController',
        controllerAs: 'ctrl',
        templateUrl:
          'app/app-utils/components/table-data/dialogs/filter/table-data-filter.html',
        locals: {
          table: vm.props.table,
          columns: columns,
          predicates: vm.predicates,
          translation: vm.translation,
        },
        parent: angular.element(document.body),
        hasBackdrop: true,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: true,
      })
      .then(function (predicates) {
        vm.predicates = predicates;
        vm.props.predicates = predicates;
        vm.init();
      });
  };

  vm.removePredicate = function (index) {
    cancelIntervalReload();
    vm.isOnline = false;
    vm.predicates.splice(index, 1);
    vm.init();
  };

  $scope.$on('dateChange', function (e, dates) {
    vm.startDate = moment(dates.desde).hour(0).minute(0).second(0);
    vm.endDate = moment(dates.hasta).hour(23).minute(59).second(59);
    onlinePredicate.value = moment(dates.desde).format('YYYY-MM-DD') + 'T10:30';
    if (vm.isOnline) {
      vm.isOnline = false;
      cancelIntervalReload();
    } else {
      vm.init();
    }
  });

  function buildChart() {
    if (vm.echart) vm.echart.dispose();

    vm.echart = echarts.init(document.getElementById(vm.widgetName));

    vm.echart.showLoading();
    vm.echart.setOption(options);
    vm.echart.hideLoading();

    vm.props.chartConfig = options;
  }

  function updateChart() {
    // console.log(options);
    vm.echart.setOption(options);
  }

  $scope.onChangeOnline = function () {
    if (vm.isOnline) startIntervalReload();
    else {
      cancelIntervalReload();
    }
  };

  function startIntervalReload() {
    clearSeriesValues();
    datatable = [];

    if (interval) clearInterval(interval);

    vm.predicates.push(onlinePredicate);

    interval = setInterval(function () {
      vm.init();
    }, dalayInterval);
  }

  function cancelIntervalReload() {
    clearInterval(interval);
    vm.predicates = [];
    interval = null;
    vm.init();
  }

  function resize() {
    setTimeout(function () {
      vm.echart.resize();
    }, 200);
  }

  function clearSeriesValues() {
    options.series.forEach(function (s) {
      s.data = [];
    });
    options.xAxis.data = [];
  }

  $(window).on('resize', resize);
  $scope.$on('homeWidgetRezised', resize);

  // console.log($scope);
}

'use strict';

var app = angular.module('dashboard');
app.component('configDataManagementChart', {
  templateUrl:
    'app/home/widgets/data-management-chart/config-data-management-chart.html',
  controllerAs: 'ctrl',
  bindings: {
    widget: '=',
  },
  controller: configDataManagementChartController,
});

configDataManagementChartController.$inject = ['$scope', 'DataTableFactory', 'toastr'];
function configDataManagementChartController($scope, $dataTableFactory, toastr) {
  var vm = this;
  vm.schemas = [];
  vm.tables = [];
  vm.tableColumns = [];

  $scope.searchTextSchema = '';
  $scope.searchTextTable = '';

  vm.schemaItemChange = schemaItemChange;
  vm.querySearchSchema = querySearchSchema;

  vm.tableItemChange = tableItemChange;
  vm.querySearchTable = querySearchTable;

  vm.chartTypes = ['bar', 'line'];

  vm.serieSelected = null;

  vm.config = {
    title: 'table chert',
    schema: null,
    table: null,
    series: [
      // {
      //   name: 'string',
      //   type: chartTypes,
      //   color: 'string',
      // },
    ],
    xAxis: null,
    chartConfig: null,
    predicates: [],
  };

  vm.init = function () {
    vm.widget.widget.props = vm.config;
    _getAllSchemas();
  };
  vm.init();

  vm.onSelectSerie = function () {
    vm.config.series.push({
      name: vm.serieSelected,
      type: vm.chartTypes[0],
    });
    vm.serieSelected = null;
  };

  vm.removeSerie = function (index) {
    vm.config.series.splice(index, 1);
  };

  function _getAllSchemas() {
    $dataTableFactory
      .getAllSchemas()
      .then(function (res) {
        vm.schemas = res;
      })
      .catch(function (err) {
        console.error('Error@getAllSchemas', err);
        toastr.error(err.message || 'Error getting schemas'); 
      });
  }

  function schemaItemChange(item) {
    $dataTableFactory
      .getAllTablesBySchemasName(item)
      .then(function (res) {
        vm.tables = res.map(function (t) {
          return t.tableName;
        });
      })
      .catch(function (err) {
        console.error('Error@schemaItemChange', err);
      });
  }

  function tableItemChange(item) {
    vm.config.columns = [];

    if (!item) {
      return;
    } else {
      var tableName = item;
      var schemaName = vm.config.schema;

      $dataTableFactory
        .getTable(tableName, schemaName)
        .then(function (res) {
          vm.tableColumns = res.columns;
        })
        .catch(function (err) {
          console.error('Error@tableItemChange', err);
        });
    }
  }

  function querySearchSchema(query) {
    var results = query
      ? vm.schemas.filter(function (s) {
          var lowercaseQuery = s.toLowerCase();
          return s.indexOf(lowercaseQuery) === 0;
        })
      : vm.schemas;

    return results;
  }

  function querySearchTable(query) {
    var results = query
      ? vm.tables.filter(function (s) {
          var lowercaseQuery = s.toLowerCase();
          return s.indexOf(lowercaseQuery) === 0;
        })
      : vm.tables;

    return results;
  }
}

'use strict';

var app = angular.module('dashboard');
app.component('counterBoxWidget', {
  templateUrl: 'app/home/widgets/counter-box/counter-box.html',
  controllerAs: 'ctrl',
  bindings: {
    props: '<',
  },
  controller: counterBoxController,
});

counterBoxController.$inject = ['$scope'];
function counterBoxController($scope) {
  var vm = this;
  vm.loadingStatus = false;

  $scope.$on('alerts_dashboard_data', function (e, data) {
    vm.props.data = data.filter(function (e) {
      return e.status.toLowerCase() == vm.props.label.toLowerCase();
    })[0];
  });
}

"use strict";

var app = angular.module("dashboard");

app.component("casesWidget", {
  templateUrl: "app/home/widgets/cases/casesWidget.html",
  controllerAs: "ctrl",
  bindings: {
    menu: "=?",
  },
  controller: casesWidgetController,
});

casesWidgetController.$inject = [
  "$scope",
  "$stateParams",
  "translationService",
  "CaseFactory",
  "PermissionsFactory",
];
function casesWidgetController(
  $scope,
  $stateParams,
  $translationService,
  CaseFactory,
  PermissionsFactory
) {
  $translationService.getTranslation($scope, "dashboard");
  var vm = this;
  $scope.loading = true;
  $scope.startDate =
    $stateParams.desde ||
    moment().hour(0).minute(0).second(0).subtract(1, "week");
  $scope.endDate =
    $stateParams.hasta || moment().hour(23).minute(59).second(59);

  $scope.$on("dateChange", function (e, dates) {
    $scope.startDate = dates.desde;
    $scope.endDate = dates.hasta;
    vm.getCases();
  });

  vm.$onInit = function () {
    vm.getCases();
  };
  vm.permissionError = null
  vm.getCases = function () {
    
    $scope.loading = true;
    var req = {
      startDate: $scope.startDate,
      endDate: $scope.endDate,
      state: "abierto",
      page: 1,
      itemsPerPage: 5,
    };

    CaseFactory.getSummary(req)
      .then(function (res) {
        vm.cases = res.cases;
      })
      .catch(function (err) {
        console.log("error@getSummary", err);
        if (err.status == 403) {
            vm.permissionError = err
          }
      })
      .finally(function () {
        $scope.loading = false;
      });
  };

  vm.menu = {};
  vm.menu.refresh = {
    label: $translationService.getTranslationController(
      "Actualizar",
      "Refresh",
      "Atualizar"
    ),
    fn: function () {
      vm.getCases();
    },
  };
}

"use strict";

var app = angular.module("dashboard");

app.component("userBookmarksWidget", {
  templateUrl: "app/home/widgets/bookmarks/bookmarks.html",
  controllerAs: "ctrl",
  bindings: {
    menu: "=?",
  },
  controller: userBookmarksWidgetController,
});

// Right click directive
// app.directive("ngRightClick", [
//   function () {
//     return function (scope, element, attrs) {
//       element.on("contextmenu", function (e) {
//         scope.$apply(function () {
//           e.preventDefault();
//           attrs.ngRightClick && scope.$eval(attrs.ngRightClick, { $event: e });
//         });
//       });
//     };
//   },
// ]);

userBookmarksWidgetController.$inject = [
  "$scope",
  "$state",
  "BookmarkService",
  "translationService",
  "$mdDialog",
  "$interval",
];

function userBookmarksWidgetController(
  $scope,
  $state,
  $bookmarkService,
  $translationService,
  $mdDialog,
  $interval
) {
  var vm = this;
  vm.loading = $bookmarkService.loading;
  vm.bookmarks = [];
  vm.bookmarksSelected = null;
  vm.isDragging = false;
  vm.isDragOverTrashArea = false;
  vm.showContextMenu = false;

  function $init() {
    vm.loading = true;
    vm.bookmarks = $bookmarkService.getBookmarks(function () {
      vm.loading = false;
    });
  }
  $init();

  vm.refreshInterval = $interval(function () {
    $init();
    console.log("Refreshing bookmarks...");
  }, 1 * 60 * 1000); // Refresh every 1 minute

  document.addEventListener("click", function (event) {
    var cm = document.querySelector("[data-context-menu]");
    if (cm && !cm.contains(event.target)) {
      vm.showContextMenu = false;
    }
  });

  $scope.sortableOptionsList = {
    placeholder: "app",
    connectWith: false,
    start: function (event, ui) {
      vm.isDragging = true;
      $scope.$apply();
    },
    stop: function (event, ui) {
      vm.isDragging = false;
      vm.isDragOverTrashArea = false;
      $scope.$apply();
      var target = event.target;
      var children = Array.from(target.children);
      var newOrder = children.map(function (child, index) {
        return {
          id: child.getAttribute("data-id"),
          type: child.getAttribute("data-type"),
          name: child.getAttribute("data-name"),
          order: index + 1,
        };
      });
      vm.reorderBookmarks(newOrder);
    },
  };

  vm.reorderBookmarks = function (newOrder) {
    $bookmarkService.reorderBookmarks(newOrder, false);
  };

  vm.openBookmark = function (bookmark, inNewTab) {
    var State = null;
    var url = null;
    if (bookmark.type === "list") {
      State = "app.tableList";
      url = { listId: bookmark.id, action: "GET", backTo: "home" };
    }

    if (bookmark.type === "rule") {
      State = "app.rule-editor";
      url = { functionId: bookmark.id, action: "GET", backTo: "home" };
    }

    if (bookmark.type === "custom-report") {
      State = "app.custom-report";
      url = { reportId: bookmark.id, report: bookmark.name, action: "GET", backTo: "home" };
    }

    if (bookmark.type === "chart") {
      State = "app.chart";
      url = { chartId: bookmark.id, action: "GET", backTo: "home" };
    }

    if (bookmark.type === "folder") {
      State = "app.folder";
      url = { FolderName: bookmark.name, action: "GET", backTo: "home" };
    }

    if (bookmark.type === "data-management") {
      var parts = (bookmark.id || "").split(".");
      State = "app.tableData";
      url = { schemaName: parts[0], tableName: parts[1], backTo: "home" };
    }

    if (inNewTab) {
      $state.href(State, url);
      window.open($state.href(State, url), "_blank");
    } else {
      $state.go(State, url);
    }

    vm.showContextMenu = false;
    vm.bookmarkSelected = null;
  };

  vm.removeBookmark = function (_bookmark) {
    var confirm = $mdDialog
      .confirm()
      .title(
        $translationService.getTranslationController(
          "Eliminar Marcador",
          "Delete Bookmark",
          "Excluir Marcador"
        )
      )
      .textContent(
        $translationService.getTranslationController(
          "¿Estas seguro que quieres borrarlo?",
          "Are you sure you want to delete?",
          "Tem certeza de que deseja excluir?"
        )
      )
      .ok($translationService.getTranslationController("Si", "Yes", "Sim"))
      .cancel($translationService.getTranslationController("No", "No", "Não"));

    $mdDialog.show(confirm).then(
      function () {
        $bookmarkService.removeBookmark(_bookmark, function () {
          $init();
        });
      },
      function () {}
    );
  };

  vm.iconByType = function (type) {
    switch (type) {
      case "list":
        return "cep-menu-data-list";
      case "schema":
        return "cep-menu-data-schemas";
      case "rule":
        return "cep-menu-rules";
      case "realtime-rules":
        return "cep-menu-rule-schedules";
      case "table":
        return "cep-menu-rules-list";
      case "custom-report":
        return "cep-menu-custom-reports";
      case "chart":
        return "cep-menu-graphic-charts";
      case "folder":
        return "cep-menu-files-storage";
      case "data-management":
        return "cep-menu-data-management";
      default:
        return "cep-menu-rules-list";
    }
  };

  $scope.menuOptions = [
    {
      text: "Abrir en una nueva pestaña",
      icon: "open_in_new",
      click: function (bookmark) {
        vm.openBookmark(bookmark, true);
      },
    },
    {
      text: "Eliminar",
      icon: "delete",
      click: function (bookmark) {
        vm.removeBookmark(bookmark);
      },
    },
  ];

  $scope.$on("$destroy", function () {
    $interval.cancel(vm.refreshInterval);
  });
}

"use strict";
var app = angular.module('dashboard');
app.component('alertsChartWidget', {
  templateUrl: 'app/home/widgets/alerts-chart/alerts-chart.html',
  controllerAs: 'ctrl',
  bindings: {
    props: '<'
  },
  controller: alertsChartWidgetController,
});

alertsChartWidgetController.$inject = ['$scope', 'translationService'];
function alertsChartWidgetController($scope, $translationService) {
  $translationService.getTranslation($scope, 'alerts-chart');
  var vm = this;
  vm.uid = Math.floor(Math.random() * (100 + 1))
  vm.loading = true;
  vm.chart = false;
  vm.series = [
    {
      name: 'Altas',
      type: 'bar',
      stack: 'z',
      label: { show: true, position: 'insideRight' },
      data: [],
      itemStyle: { normal: { color: '#e53935' } }
    },
    {
      name: 'Medias',
      type: 'bar',
      stack: 'z',
      label: { show: true, position: 'insideRight' },
      data: [],
      itemStyle: { normal: { color: '#ffb300' } }
    },
    {
      name: 'Bajas',
      type: 'bar',
      stack: 'z',
      label: { show: true, position: 'insideRight' },
      data: [],
      itemStyle: { normal: { color: '#43a047' } }
    }
  ]

  $scope.$on('alerts_dashboard_data', function (e, data) {
    vm.loading = true;
    vm.series.find(function (e) { e.data = [] });
    // console.log(data)
    for (var i = 0; i < data.length; i++) {
      var d = data[i];
      var values = Object.values(d.totalByColors)

      for (var j = 0; j < values.length; j++) {
        var v = values[j];
        vm.series[j].data.push(v)
      }
    }
    // console.log(vm.series)
    vm.initChart();
    vm.loading = false;
  });

  vm.initChart = function () {
    vm.echart = echarts.init(document.getElementById('echarts-bar-' + vm.uid));
    vm.option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        data: ['Altas', 'Medias', 'Bajas']
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'value'
      },
      yAxis: {
        type: 'category',
        data: ['No Visto', 'visto']
      },
      series: vm.series
    };
    vm.echart.setOption(vm.option);
  };
}
"use strict";
var app = angular.module('dashboard');
    app.component('alertsWidget', {
        templateUrl: 'app/home/widgets/alerts/alerts.html',
        controllerAs: 'ctrl',
        bindings: {},
        controller: alertsWidgetController,
    });

alertsWidgetController.$inject = ['$scope', '$rootScope', '$stateParams', 'translationService', 'AlertManagementFactory'];
function alertsWidgetController($scope, $rootScope, $stateParams, $translationService, AlertManagementFactory) {
    $translationService.getTranslation($scope, 'dashboard');
    var vm = this;
    $rootScope.loading = true;
    vm.loadingStatus = true;
    vm.errorResp = false;

    // vm.AlertTypes = ['altas', 'medias', 'baja'];
    // vm.AlertColors = ['red', 'green', 'yellow'];
    vm.statusTypes = [];
    vm.chartAlerts = [];
    vm.alertIcons = ['visibility_off', 'done_all', 'warning', 'search', 'visibility'];
    vm.CongfigAlertas = [];
    
    $scope.startDate = $stateParams.desde || moment().hour(0).minute(0).second(0).subtract(1, 'week');
    $scope.endDate = $stateParams.hasta || moment().hour(23).minute(59).second(59);

    $scope.$on('dateChange', function (e, dates) {
        $scope.startDate = dates.desde;
        $scope.endDate = dates.hasta;
        vm.statusTypes = [];
        vm.CongfigAlertas = [];
        vm.getMetaData();
    });

    $scope.range = function (n) {
        return new Array(n);
    };

    vm.getMetaData = function () {
        AlertManagementFactory.getReportMetaData()
        .then(function (res) {
            // console.log('getReportMetaData', res);
            res.statusList.forEach(function (ele) {
                var alertModel = {
                    status: ele.statusName,
                    totalAlerts:0,
                    hidden:false,
                    icon:'error_outline'
                }
                vm.statusTypes.push(alertModel);
            });
            vm.getData();
            // console.log('statusTypes', vm.statusTypes);
        })
        .catch(function (err) {
            console.error("Error@getMetaData", err);
        })
    };
    vm.getMetaData();
    
    vm.getData = function () {
        vm.loadingStatus = true;
        vm.params = {
            startDate: moment($scope.startDate).toISOString(),
            endDate: moment($scope.endDate).toISOString(),
        };
        AlertManagementFactory.getReportCount('alerts_dashboard', vm.params)
        .then(function (res) {
            console.log('getReportCount', res);
            console.log('statusTypes', vm.statusTypes );
            vm.statusTypes.forEach(function (ele, index) {
                ele.totalAlerts = 0;
                ele.hidden = false;
                // console.log('statusTypes', ele, index );
                vm.CongfigAlertas.push(ele);
            });
            vm.CongfigAlertas = res.reportDataList;
            // console.warn('CongfigAlertas',vm.CongfigAlertas);
            vm.loadingStatus = false;
        })
        .catch(function (err) {
            vm.loadingStatus = false;
            vm.errorResp = true;
        });
    }
}
"use strict";
var app = angular.module('dashboard');
app.component('alertsWidgetChart', {
    templateUrl: 'app/home/widgets/alerts/alerts-chart.html',
    controllerAs: 'ctrl',
    bindings: {},
    controller: alertChartsWidgetController,
});

alertChartsWidgetController.$inject = ['$scope', '$rootScope', '$stateParams', 'translationService', 'AlertManagementFactory'];
function alertChartsWidgetController($scope, $rootScope, $stateParams, $translationService, AlertManagementFactory) {
    $translationService.getTranslation($scope, 'dashboard');
    $rootScope.loading = true;
    var vm = this;
        vm.loadingStatus = true;
        vm.errorResp = false;

    $scope.startDate = $stateParams.desde || moment().hour(0).minute(0).second(0).subtract(1, 'week');
    $scope.endDate = $stateParams.hasta || moment().hour(23).minute(59).second(59);

    $scope.$on('dateChange', function (e, dates) {
        $scope.startDate = dates.desde;
        $scope.endDate = dates.hasta;
        vm.getData();
    });

    vm.dataChart = [];

    vm.chart = false;

    vm.initChart = function () {
        if (vm.chart) vm.chart.destroy();
        vm.chart = AmCharts.makeChart("AmCharts", {
            "type": "serial",
            "theme": "none",
            "legend": {
                "horizontalGap": 10,
                "maxColumns": 1,
                "position": "right",
                "useGraphSettings": true,
                "markerSize": 10
            },
            "dataProvider": vm.dataChart,
            "valueAxes": [{
                "stackType": "regular",
                "axisAlpha": 0.3,
                "gridAlpha": 0
            }],
            "graphs": [{
                "balloonText": "<b>[[title]]</b><br><span style='font-size:14px'>[[category]]: <b>[[value]]</b></span>",
                "fillAlphas": 1,
                "labelText": "[[value]]",
                "lineAlpha": 1,
                "title": "hight",
                "type": "column",
                "valueField": "hight"
            }, {
                "balloonText": "<b>[[title]]</b><br><span style='font-size:14px'>[[category]]: <b>[[value]]</b></span>",
                "fillAlphas": 1,
                "labelText": "[[value]]",
                "lineAlpha": 1,
                "title": "medium",
                "type": "column",
                "valueField": "medium"
            }, {
                "balloonText": "<b>[[title]]</b><br><span style='font-size:14px'>[[category]]: <b>[[value]]</b></span>",
                "fillAlphas": 1,
                "labelText": "[[value]]",
                "lineAlpha": 1,
                "title": "low",
                "type": "column",
                "valueField": "low"
            }],
            "rotate": true,
            "categoryField": "label",
            "categoryAxis": {
                "gridPosition": "start",
                "axisAlpha": 0,
                "gridAlpha": 0,
                "position": "left"
            },
            "export": {
                "enabled": true
            }
        });
    };

    vm.getMetaData = function () {
        AlertManagementFactory.getReportMetaData()
            .then(function (res) {
                // console.log('getReportMetaData', res);
                res.statusList.forEach(function (ele) {
                    var chartObj = {
                        label: ele.statusName,
                        hight: 100,
                        medium: 50,
                        low: 70,
                    }
                    vm.dataChart.push(chartObj);
                });
                vm.getData();
                // console.log('statusTypes', vm.statusTypes);
            })
            .catch(function (err) {
                console.error("Error@getMetaData", err);
            })
    };
    vm.getMetaData();

    vm.getData = function () {
        vm.loadingStatus = true;
        vm.params = {
            startDate: moment($scope.startDate).toISOString(),
            endDate: moment($scope.endDate).toISOString(),
        };
        AlertManagementFactory.getReportCount('alerts_dashboard', vm.params)
        .then(function (res) {
            console.log(res.reportDataList, res.reportDataList.length);
            if (res.reportDataList.length > 0){
                
                vm.dataChart.forEach(function (ele, index) {
                    ele.hight = res.reportDataList[index].totalByColors.red || 0;
                    ele.medium = res.reportDataList[index].totalByColors.yellow || 0;
                    ele.low = res.reportDataList[index].totalByColors.green || 0;
                });
                
                console.log(vm.dataChart);
                vm.loadingStatus = false;
                vm.errorResp = false;
                vm.initChart();
            }else{
                vm.loadingStatus = false;
                vm.errorResp = true;
            }
        })
        .catch(function (err) {
            vm.loadingStatus = false;
            vm.errorResp = true;
            console.error("err", err);
        });
    }
    vm.getData();
}
'use strict';

var app = angular.module('dashboard');

app.component('widgetConfigBox', {
  templateUrl: 'app/home/components/widget-config-box/widget-config-box.html',
  controllerAs: 'ctrl',
  bindings: {
    widget: '=',
  },
  controller: widgetConfigBoxController,
});

widgetConfigBoxController.$inject = [
  '$scope',
  '$rootScope',
  'translationService',
  '$element',
  '$compile',
];
function widgetConfigBoxController(
  $scope,
  $rootScope,
  $translationService,
  $element,
  $compile
) {
  $translationService.getTranslation($scope, 'dashboard');

  var vm = this;

  console.log('widgetConfigBoxController', vm.widget.widget.configComponent);

  var widget = $compile(
    '<' + vm.widget.widget.configComponent + " widget='ctrl.widget' >"
  )($scope);

  $element.find('#component-container').append(widget);

  vm.apply = function () {
    console.log(vm.widget);
    $rootScope.$broadcast('applyConfigComponent', vm.widget);
  };

  vm.close = function () {
    $rootScope.$broadcast('closeConfigComponent');
  };

  vm.prevPage = function () {
    $rootScope.$broadcast('prevPageConfigComponent');
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('widgetBox', {
  templateUrl: 'app/home/components/widget-box/widget-box.html',
  controllerAs: 'ctrl',
  bindings: {
    widget: '=',
    deleteWidget: '=',
    index: '<',
  },
  controller: widgetBoxController,
});

widgetBoxController.$inject = [
  '$scope',
  '$element',
  '$compile',
  'translationService',
];
function widgetBoxController($scope, $element, $compile, $translationService) {
  var vm = this;
  vm.translations = {
    deleteWidget: $translationService.getTranslationController(
      'Borrar widget',
      'Delete widget',
      'Deletar widget'
    ),
  };

  var mil = 92

  vm.size = {
    width: $element.width() - mil,
    height: $element.height() - mil,
  }

  var widget = $compile(
    '<' +
      vm.widget.widget.type +
      " props='ctrl.widget.widget.props' class='widget-box' size='ctrl.size' id='widget-box' position='ctrl.widget.position' menu='ctrl.menu' type='ctrl.widget.widget.type'>"
  )($scope);

  $element.append(widget);
  $(window).on('resize', resize);
  setTimeout(resize, 1000);

  function resize() {
    vm.size.width = $element.width() - mil;
    vm.size.height = $element.height() - mil;
  }
}

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller("ShareDashboardController", ShareDashboardController);

  ShareDashboardController.$inject = [
    "$scope",
    "$mdDialog",
    "UserFactory",
    "AclFactory",
    "toastr",
    "dashboard",
  ];
  function ShareDashboardController(
    $scope,
    $mdDialog,
    $userFactory,
    $aclFactory,
    toastr,
    dashboard
  ) {
    console.log(dashboard);
    var vm = this;
    var params = {
      page: 1,
      itemsPerPage: 999,
      sort: "desc",
      totalRecords: 0,
      orderBy: "id",
      active: true,
    };
    vm.dashboard = dashboard;
    vm.search = "";
    vm.users = [];
    var aclId = null;
    var users = [];
    vm.selectedUsers = [];

    function getUsers() {
      $userFactory
        .getUsers(params)
        .then(function (response) {
          
          vm.users = response.data.data.map(function (user) {
            return {
              userId: user.id,
              username: user.username,
              selected: false,
            };
          });

          users = response.data.data;
          getAcl();
        })
        .catch(function (error) {
          console.log(error);
          toastr.error("Error while fetching users", "Error");
        });
    }
    getUsers();

    vm.searchUsers = function () {
      vm.users = users.filter(function (user) {
        return user.username.toLowerCase().includes(vm.search.toLowerCase());
      });
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.save = function () {
      var userSelected = vm.users
        .filter(function (user) {
          return user.selected;
        })
        .map(function (user) {
          return {
            userId: user.userId,
            name: user.username,
          };
        });

      var resource = "dashboard";
      var _name = resource + "#" + dashboard.id;

      var policy = {
        name: _name,
        description: dashboard.name,
        active: true,
        policies: [
          {
            description: _name,
            resource: {
              name: resource,
              entityId: dashboard.id,
              actions: "share",
              granted: true,
            },
            appliesTo: {
              users: userSelected,
              groups: [],
            },
          },
        ],
      };

      policy.policies = JSON.stringify(policy.policies);

      if (aclId) {
        $aclFactory
          .edit(aclId, policy)
          .then(function (response) {
            toastr.success("Dashboard shared successfully", "Success");
            $mdDialog.hide();
          })
          .catch(function (error) {
            toastr.error("Error while sharing dashboard", "Error");
          });
      } else {
        $aclFactory
          .create(policy)
          .then(function (response) {
            toastr.success("Dashboard shared successfully", "Success");
            $mdDialog.hide();
          })
          .catch(function (error) {
            toastr.error("Error while sharing dashboard", "Error");
          });
      }
    };

    function getAcl() {
      $aclFactory
        .getAcls()
        .then(function (response) {
          var dasboardACL = response.data.data.find(function (acl) {
            return acl.name == "dashboard#" + dashboard.id;
          });
          console.log(dasboardACL);
          aclId = dasboardACL ? dasboardACL.id : null;
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('OrganizeDashboardsController', OrganizeDashboardsController);

  OrganizeDashboardsController.$inject = [
    '$scope',
    '$mdDialog',
    'UserFactory',
    'toastr'
  ];
  function OrganizeDashboardsController(
    $scope,
    $mdDialog,
    UserFactory,
    toastr
  ) {
    var vm = this;
    vm.dashboards = []
    vm.loading = true

    $scope.getUserDashboardsFn = function () {
      vm.loading = false
      UserFactory.getUserDashboards()
        .then(function (res) {
          // console.log("res", res)
          vm.dashboards = res.sort(function(a, b) {
            return a.dashboardOrder - b.dashboardOrder;
          });
          vm.loading = false
        })
        .catch(function (err) {
          console.error('err@getUserDashboards', err);
          vm.loading = false
        });
    };
    $scope.getUserDashboardsFn()

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    $scope.sortableOptionsList = {
      placeholder: "app",
      connectWith: '.list-dashboards',
      stop: function (event, ui) {
        // console.log(event, ui)
        // console.log("dashboards", vm.dashboards)
      }
    };

    vm.save = function () {
      var promises = [];
      for (var index = 0; index < vm.dashboards.length; index++) {
        var board = vm.dashboards[index];
        var send = {
          configs: angular.fromJson(board.dashboardConfig),
          id: board.dashboardId,
          name: board.dashboardName,
          status: board.dashboardStatus,
          widgets: angular.fromJson(board.dashboardConfig),
          order: index
        }
        // console.log(index, send)
        promises.push(UserFactory.saveUserDashboards('update', send));
      }
      Promise.all(promises).then(function (res) {
        // console.log('res', res);
        $mdDialog.hide("refresh");
        toastr.success('Dashboards Saved');
      })
    }
  }
})();

"use strict";

var app = angular.module("dashboard");

app.component("dashboardConfigBar", {
  templateUrl:
    "app/home/components/dashboard-config-bar/dashboard-config-bar.html",
  controllerAs: "ctrl",
  bindings: {
    api: "=?",
    props: "=?",
    addWidget: "=?",
    cancelWidget: "=?",
    previewWidget: "=?",
  },
  controller: dashboardConfigBarController,
});

dashboardConfigBarController.$inject = [
  "$scope",
  "$rootScope",
  "$mdSidenav",
  "translationService",
  "toastr",
  "SchemasService",
  "listService",
  "PermissionsFactory",
  "AlertManagementFactory",
  // 'ReplayConfigurationFactory',
  "IssuesFactory",
  "UserFactory",
  "InputListsFactory",
  "ChartsFactory",
  "FunctionFactory",
  "DataTableFactory",
];
function dashboardConfigBarController(
  $scope,
  $rootScope,
  $mdSidenav,
  $translationService,
  $toastr,
  $schemasService,
  $listService,
  $permissionsFactory,
  $alertManagementFactory,
  // $replayConfigurationFactory,
  $issuesFactory,
  $userFactory,
  $inputListsFactory,
  $chartsFactory,
  $functionFactory,
  $dataTableFactory
) {
  $translationService.getTranslation($scope, "dashboard");

  $scope.value = 0;
  var vm = this;
  vm.page = 1;
  vm.alertStatus = [];
  vm.issueCategories = [];
  vm.issueTypes = [];
  vm.chartList = [];
  vm.dataTableSchema = [];

  vm.selectedItem = null;
  vm.searchText = null;
  vm.chipsQuerySearch = chipsQuerySearch;
  function chipsQuerySearch(query) {
    var results = query
      ? vm.rules.filter(function (rule) {
          return rule.name.toLowerCase().indexOf(query) === 0;
        })
      : [];
    return results;
  }

  /**
   * Get issues categories
   * For issues chart widget configs
   */
  function _getIssuesCategories() {
    return $issuesFactory.getIssuesCategories().then(function (res) {
      vm.issueCategories = res.data.map(function (e) {
        return {
          label: e.name,
          value: {
            id: e.id,
            name: e.name,
          },
        };
      });
    });
  }
  /**
   * Get chart
   * For chart widget configs
   */
  function _getChartList() {
    return $chartsFactory.getChartsbyDomain().then(function (res) {
      vm.chartList = res.data.map(function (e) {
        return {
          label: e.name,
          value: e,
        };
      }).sort(function (a, b) {
        return a.label.localeCompare(b.label);
      });
    });
  }

  function _getSupervisedUsers(widget) {
    var currentUser = $userFactory.getCurrentUser();
    var category = JSON.parse(vm.selectedWidget.widget.props["category"]);

    if (category) {
      return $userFactory
        .getSupervisedUsers(currentUser.username)
        .then(function (res) {
          var users = res.data;
          if (users) {
            users = users.map(function (e) {
              if (widget == "issues-chart-widget") {
                return { label: e.fullName, value: e.username };
              }
              if (widget == "issues-bar-chart-widget") {
                return { label: e.fullName, value: e.userId };
              }
            });
            users.unshift({ label: "", value: "" });
          }

          var prop = vm.selectedWidget.widget.configs.find(function (e) {
            return e.name == "user";
          });

          if (prop) prop.values = users;
        })
        .catch(function (e) {
          console.error("Error@getUsers", e);
        });
    }
  }

  /**
   * Get issue type by category
   * For issues chart widget configs
   */
  function _getIssuesTypes() {
    var category = JSON.parse(vm.selectedWidget.widget.props["category"]);
    if (category) {
      return $issuesFactory
        .getIssuesTypes({ categoryId: category.id })
        .then(function (res) {
          vm.issueTypes = res.map(function (e) {
            return { label: e.name, value: e };
          });
          var prop = vm.selectedWidget.widget.configs.find(function (e) {
            return e.name == "issue";
          });
          if (prop) prop.values = vm.issueTypes;
        })
        .catch(function (e) {
          console.error("Error@getIssuesTypes", e);
        });
    }
  }

  /**
   * Alert Managment data
   * For counter box widget configs
   */
  vm.getMetaData = function () {
    return new Promise(function (resolve, reject) {
      $alertManagementFactory
        .getReportMetaData()
        .then(function (res) {
          var alertStatus = [];
          if (
            angular.isDefined(res.statusList) &&
            Array.isArray(res.statusList)
          ) {
            alertStatus = res.statusList.map(function (e) {
              return { value: e.statusName, label: e.statusName };
            });

            // Map label by lang
            alertStatus.map(function (e) {
              e.label = e.label
                .filter(function (label) {
                  return label.lang == $translationService.getLanguage();
                })
                .map(function (e) {
                  return e.value;
                })[0];

              e.value = e.label;
              return e;
            });
          }

          resolve(alertStatus);
        })
        .catch(function (err) {
          console.error("Error@getMetaData", err);
          reject([]);
        });
    });
  };

  // function _getReplays() {
  //   return $replayConfigurationFactory
  //     .getReplays({
  //       active: true,
  //       target: 'dashboard',
  //     })
  //     .then(function (res) {
  //       vm.replays = res.data;
  //     })
  //     .catch(function (e) {
  //       console.error('No se han podido cargar los replays', e.msg);
  //     });
  // }

  function _getRules() {
    return $functionFactory
      .getFunctions()
      .then(function (res) {
        vm.rules = res.data;
      })
      .catch(function (e) {
        console.error("No se han podido cargar las reglas", e.msg);
      });
  }

  vm.$onInit = function () {
    var promises = [];
    if ($permissionsFactory.hasPermission("list:read")) {
      $inputListsFactory
        .getLists()
        .then(function (res) {
          vm.lists = res.lists;
        })
        .catch(function (err) {
          console.error("Error@getLists", err);
        });
    }

    if ($permissionsFactory.hasPermission("issues:read")) {
      promises.push(_getIssuesCategories());
    }

    if ($permissionsFactory.hasPermission("casos:read")) {
      var getMetadata = vm
        .getMetaData()
        .then(function (res) {
          vm.alertStatus = res;
        })
        .catch(function (err) {
          console.error("err@getMetaData", err);
        });
      promises.push(getMetadata);
    }

    if ($permissionsFactory.hasPermission("graphic-report:read")) {
      // promises.push(_getReplays());
      promises.push(_getChartList());
    }

    if ($permissionsFactory.hasPermission("function:read")) {
      promises.push(_getRules());
    }

    Promise.allSettled(promises).then(function (res) {
      vm.constructor();
    });
  };

  vm.constructor = function () {
    vm.widgets = [];

    if ($permissionsFactory.hasPermission("list:read")) {
      vm.widgets.push(
        {
          name: "List searcher",
          acl: "list:read",
          group: $translationService.getTranslationController(
            "listas",
            "List",
            "Listas"
          ),
          icon: "search",
          widget: {
            type: "list-searcher-widget",
            props: {},
            configs: [
              {
                name: "title",
                label: "Title",
                type: "string",
                required: true,
              },
              {
                name: "list",
                label: "Lista",
                type: "autocomplete",
                values: vm.lists,
                callback: function () {
                  var selectedList = vm.selectedWidget.widget.props["list"];
                  if (selectedList) {
                    var listSchemaFields = $schemasService.parseSchema(
                      selectedList.schema
                    );

                    var fieldsProp = vm.selectedWidget.widget.configs.find(
                      function (e) {
                        return e.name == "fields";
                      }
                    );

                    var sortByProp = vm.selectedWidget.widget.configs.find(
                      function (e) {
                        return e.name == "sortBy";
                      }
                    );

                    var filterByProp = vm.selectedWidget.widget.configs.find(
                      function (e) {
                        return e.name == "filterBy";
                      }
                    );

                    var statisticsProp = vm.selectedWidget.widget.configs.find(
                      function (e) {
                        return e.name == "statistics";
                      }
                    );

                    fieldsProp.values = [];
                    sortByProp.values = [];
                    filterByProp.values = [];
                    angular.forEach(listSchemaFields, function (field, key) {
                      if (field.visible) {
                        field.key = key;
                        fieldsProp.values.push({ label: key, value: field });
                        sortByProp.values.push({ label: key, value: field });
                        filterByProp.values.push({ label: key, value: field });
                      }
                    });

                    $inputListsFactory
                      .getInputListFilters(selectedList.listId)
                      .then(function (res) {
                        vm.selectedWidget.widget.props["listFilters"] = res;
                      })
                      .catch(function (error) {
                        console.log("Error@getInputListFilters", error);
                      });

                    statisticsProp.values = [];
                    $inputListsFactory
                      .getStatisticsSummary(selectedList.listId)
                      .then(function (res) {
                        res.forEach(function (e) {
                          ["avg", "count", "max", "min", "sum"].forEach(
                            function (aggregationType) {
                              if (e[aggregationType] != "null") {
                                statisticsProp.values.push({
                                  label:
                                    e.displayName +
                                    " / " +
                                    aggregationType +
                                    ": " +
                                    e[aggregationType],
                                  value: {
                                    field: e.name,
                                    aggregationType: aggregationType,
                                    displayName: e.displayName,
                                  },
                                });
                              }
                            }
                          );
                        });
                      })
                      .catch(function (err) {
                        console.error("Error@getStatisticsSummary", err);
                      });
                  }
                },
                required: true,
              },
              {
                name: "fields",
                label: $translationService.getTranslationController(
                  "Campos a mostrar",
                  "Fields to show",
                  "Campos para mostrar"
                ),
                type: "multi-select",
                values: [],
                required: true,
              },
              {
                name: "sortBy",
                label: $translationService.getTranslationController(
                  "Ordenar por",
                  "Sort by",
                  "Ordenar por"
                ),
                type: "enum",
                values: [],
                required: false,
              },
              {
                name: "sortDirection",
                label: $translationService.getTranslationController(
                  "Orden",
                  "Order",
                  "Orden"
                ),
                type: "enum",
                values: [
                  {
                    value: "DESC",
                    label: $translationService.getTranslationController(
                      "Descendente",
                      "Descendant",
                      "Caindo"
                    ),
                  },
                  {
                    value: "ASC",
                    label: $translationService.getTranslationController(
                      "Ascendente",
                      "Ascending",
                      "Para cima"
                    ),
                  },
                ],
                required: false,
              },
              {
                name: "filterBy",
                label: $translationService.getTranslationController(
                  "Filtrar por",
                  "Filter by",
                  "Filtrar por"
                ),
                type: "enum",
                values: [],
                callback: function () {
                  var selectedList = vm.selectedWidget.widget.props["list"];
                  var filterBy = vm.selectedWidget.widget.props["filterBy"];
                  var listFilters =
                    vm.selectedWidget.widget.props["listFilters"];

                  if (selectedList && filterBy && listFilters) {
                    filterBy = angular.fromJson(filterBy);

                    var filterOperationProps =
                      vm.selectedWidget.widget.configs.find(function (e) {
                        return e.name == "filterOperation";
                      });

                    var fieldName = $listService.getFieldName(
                      filterBy.key,
                      filterBy.pk
                    );

                    filterOperationProps.values = listFilters
                      .find(function (e) {
                        return e.field == fieldName;
                      })
                      .operations.map(function (operation) {
                        return { label: operation, value: operation };
                      });
                  }
                },
                required: false,
              },
              {
                name: "filterOperation",
                label: $translationService.getTranslationController(
                  "Operación",
                  "Operation",
                  "Operação"
                ),
                type: "enum",
                values: [],
                required: false,
              },
              {
                name: "filterValue",
                label: $translationService.getTranslationController(
                  "Valor a filtrar",
                  "Value to filter",
                  "Valor para filtrar"
                ),
                type: "string",
                required: false,
              },
              {
                name: "statistics",
                label: $translationService.getTranslationController(
                  "Estadísticas",
                  "Statistics",
                  "Estadísticas"
                ),
                type: "multi-select",
                values: [],
                required: false,
              },
            ],
          },
          position: {
            sizeX: 6,
            sizeY: 4,
            minSizeX: 5,
            minSizeY: 2,
          },
        },
        {
          name: "Top lists",
          acl: "list:read",
          group: $translationService.getTranslationController(
            "listas",
            "List",
            "Listas"
          ),
          icon: "list",
          widget: {
            type: "top-lists-widget",
            props: {
              title: "Top list",
              selected: [],
            },
            configs: [
              {
                name: "topList",
                label: "Lists",
                type: "checkbox",
                values: vm.lists,
                selected: [],
                min: 1,
                max: 5,
              },
            ],
          },
          position: {
            sizeX: 3,
            sizeY: 3,
            minSizeX: 3,
            minSizeY: 3,
          },
        },
        {
          name: "List Details",
          acl: "list:read",
          group: $translationService.getTranslationController(
            "listas",
            "List",
            "Listas"
          ),
          icon: "list",
          widget: {
            type: "list-details-widget",
            props: {},
            configComponent: "config-list-details",
          },
          position: {
            sizeX: 12,
            sizeY: 6,
            minSizeX: 6,
            minSizeY: 6,
            maxSizeX: 12,
            maxSizeY: 6,
          },
        },
        {
          name: "Risk by Category",
          acl: "list:read",
          group: $translationService.getTranslationController(
            "listas",
            "List",
            "Listas"
          ),
          icon: "format_list_numbered",
          widget: {
            type: "list-reader-widget",
            props: {},
            configs: [],
          },
          position: { sizeX: 12, sizeY: 6, minSizeX: 6, minSizeY: 6 },
        },
        {
          name: "Indicators List",
          acl: "list:read",
          group: $translationService.getTranslationController(
            "listas",
            "List",
            "Listas"
          ),
          icon: "bar_chart",
          widget: {
            type: "indicators-list-widget",
            props: {},
            configs: [
              {
                name: "list",
                label: "List",
                type: "autocomplete",
              },
            ],
          },
          position: { sizeX: 6, sizeY: 4, minSizeX: 5, minSizeY: 2 },
        }
      );
    }
    if ($permissionsFactory.hasPermission("issues:read")) {
      vm.widgets.push(
        {
          name: "Issues pie chart",
          acl: "issues:read",
          group: $translationService.getTranslationController(
            "Issues",
            "Issues",
            "Issues"
          ),
          icon: "pie_chart",
          widget: {
            type: "issues-chart-widget",
            props: {},
            configs: [
              {
                name: "title",
                label: "Title",
                type: "string",
                required: true,
              },
              {
                name: "category",
                label: "Categoría de controles",
                type: "enum",
                values: vm.issueCategories,
                callback: function () {
                  _getIssuesTypes();
                  _getSupervisedUsers("issues-chart-widget");
                },
                required: true,
              },
              {
                name: "issue",
                label: "Tipo de issue",
                type: "enum",
                values: [],
                required: true,
              },
              {
                name: "graphField",
                label: "Campo gráficable",
                type: "enum",
                values: [
                  {
                    label: "Estado",
                    value: "status",
                  },
                  {
                    label: "Clasificación",
                    value: "classifications",
                  },
                ],
                required: true,
              },
              {
                name: "user",
                label: "Usuario",
                type: "enum",
                values: [],
              },
            ],
          },
          position: {
            sizeX: 6,
            sizeY: 4,
            minSizeX: 5,
            minSizeY: 2,
          },
        },
        {
          name: "Issues bar chart",
          acl: "issues:read",
          group: $translationService.getTranslationController(
            "Issues",
            "Issues",
            "Issues"
          ),
          icon: "insert_chart",
          widget: {
            type: "issues-bar-chart-widget",
            props: {},
            configs: [
              {
                name: "title",
                label: "Title",
                type: "string",
                required: true,
              },
              {
                name: "category",
                label: "Categoría de controles",
                type: "enum",
                values: vm.issueCategories,
                callback: function (e, a) {
                  _getIssuesTypes();
                  _getSupervisedUsers("issues-bar-chart-widget");
                },
                required: true,
              },
              {
                name: "issue",
                label: "Tipo de issue",
                type: "enum",
                values: [],
                required: true,
              },
              {
                name: "graphField",
                label: "Campo gráficable",
                type: "enum",
                values: [
                  {
                    label: "Estado",
                    value: "status",
                  },
                  {
                    label: "Clasificación",
                    value: "classification",
                  },
                ],
                required: true,
              },
              {
                name: "user",
                label: "Usuario",
                type: "enum",
                values: [],
              },
            ],
          },
          position: {
            sizeX: 6,
            sizeY: 4,
            minSizeX: 5,
            minSizeY: 2,
          },
        }
      );
    }
    if ($permissionsFactory.hasPermission("casos:read")) {
      vm.widgets.push({
        name: "Last Cases",
        acl: "casos:read",
        group: $translationService.getTranslationController(
          "Casos",
          "Cases",
          "Casos"
        ),
        icon: "work_outline",
        widget: {
          type: "cases-widget",
          props: {},
          configs: [],
        },
        position: {
          sizeX: 6,
          sizeY: 3,
          minSizeX: 5,
          minSizeY: 2,
        },
      });
    }
    if ($permissionsFactory.hasPermission("function:read")) {
      vm.widgets.push(
        {
          name: "Rule Executions",
          acl: "function:read",
          group: $translationService.getTranslationController(
            "Reglas",
            "Rules",
            "Reglas"
          ),
          icon: "video_library",
          widget: {
            type: "executions-widget",
            props: {},
            configs: [],
          },
          position: {
            sizeX: 6,
            sizeY: 3,
            minSizeX: 5,
            minSizeY: 2,
          },
        },
        {
          name: "Rule Executions Chart",
          acl: "function:read",
          group: $translationService.getTranslationController(
            "Reglas",
            "Rules",
            "Reglas"
          ),
          icon: "video_library",
          widget: {
            type: "executions-chart-widget",
            props: {
              rules: [],
            },
            configs: [
              {
                name: "title",
                label: "Title",
                type: "string",
                required: true,
              },
              {
                values: vm.rules,
                name: "rules",
                label: "Rules",
                required: true,
                type: "chips",
                callback: function (e, a) {
                  _getRules();
                },
              },
            ],
          },
          position: {
            sizeX: 4,
            sizeY: 6,
            minSizeX: 2,
            minSizeY: 3,
          },
        },
        {
          name: "Executions Queue",
          acl: "function:read",
          group: $translationService.getTranslationController(
            "Rules",
            "Reglas",
            "Reglas"
          ),
          icon: "playlist_play",
          widget: {
            type: "rules-queue-widget",
            props: {},
            configs: [],
          },
          position: {
            sizeX: 6,
            sizeY: 3,
            minSizeX: 5,
            minSizeY: 2,
          },
        },
        {
          name: "Work Queue",
          acl: "function:read",
          group: $translationService.getTranslationController(
            "Reglas",
            "Rules",
            "reglas"
          ),
          icon: "playlist_play",
          widget: {
            type: "work-queue-widget",
            props: {},
            configs: [],
          },
          position: {
            sizeX: 6,
            sizeY: 3,
            minSizeX: 2,
            minSizeY: 2,
          },
        },
        {
          name: "Executions Form",
          acl: "function:read",
          group: $translationService.getTranslationController(
            "Reglas",
            "Rules",
            "reglas"
          ),
          icon: "input",
          widget: {
            type: "executions-form",
            props: {},
            configs: [],
            configComponent: "config-executions-form",
          },
          position: {
            sizeX: 6,
            sizeY: 3,
            minSizeX: 2,
            minSizeY: 2,
          },
        }
      );
    }
    // if ($permissionsFactory.hasPermission('event:read')) {
    //   vm.widgets.push(
    //     {
    //       name: 'Alert Counter',
    //       acl: 'event:read',
    //       group: $translationService.getTranslationController(
    //         'Eventos',
    //         'Events',
    //         'Eventos'
    //       ),
    //       icon: 'filter_9_plus',
    //       widget: {
    //         type: 'counter-box-widget',
    //         props: {
    //           icon: 'warning',
    //           label: 'Visto',
    //           counter: '0',
    //         },
    //         configs: [
    //           {
    //             name: 'label',
    //             label: 'Label',
    //             type: 'enum',
    //             values: vm.alertStatus,
    //             required: true,
    //           },
    //           {
    //             name: 'icon',
    //             label: 'Icon',
    //             type: 'enum',
    //             required: true,
    //             values: [
    //               {
    //                 value: 'warning',
    //                 label: 'Warning',
    //               },
    //               {
    //                 value: 'error_outline',
    //                 label: 'Error',
    //               },
    //               {
    //                 value: 'check_circle_outline',
    //                 label: 'Check',
    //               },
    //               {
    //                 value: 'done_all',
    //                 label: 'Done',
    //               },
    //               {
    //                 value: 'favorite_border',
    //                 label: 'Favorite',
    //               },
    //               {
    //                 value: 'highlight_off',
    //                 label: 'Off',
    //               },
    //               {
    //                 value: 'help_outline',
    //                 label: 'Help',
    //               },
    //               {
    //                 value: 'work',
    //                 label: 'Work',
    //               },
    //             ],
    //           },
    //         ],
    //       },
    //       position: {
    //         sizeX: 4,
    //         sizeY: 2,
    //         minSizeX: 2,
    //         maxSizeX: 3,
    //         maxSizeY: 2,
    //       },
    //     },
    //     {
    //       name: 'Alert Chart',
    //       acl: 'event:read',
    //       group: $translationService.getTranslationController(
    //         'Eventos',
    //         'Events',
    //         'Eventos'
    //       ),
    //       icon: 'insert_chart_outlined',
    //       widget: {
    //         type: 'alerts-chart-widget',
    //         props: {},
    //         configs: [],
    //       },
    //       position: {
    //         sizeX: 6,
    //         sizeY: 5,
    //         minSizeX: 4,
    //         minSizeY: 4,
    //       },
    //     }
    //   );
    // }
    if ($permissionsFactory.hasPermission("graphic-report:read")) {
      vm.widgets.push(
        {
          name: "Charts",
          acl: "graphic-report:read",
          group: $translationService.getTranslationController(
            "Gráficas",
            "Charts",
            "Graficas"
          ),
          icon: "insert_chart_outlined",
          widget: {
            type: "list-charts-widget",
            props: {},
            configs: [
              {
                name: "chart",
                label: "chart list",
                type: "enum",
                values: vm.chartList,
                required: true,
              },
            ],
          },
          position: {
            sizeX: 6,
            sizeY: 5,
            minSizeX: 2,
            minSizeY: 2,
          },
        }
        // {
        //   name: 'Replay Chart',
        //   acl: 'graphic-report:read',
        //   group: $translationService.getTranslationController(
        //     'Gráficas',
        //     'Charts',
        //     'Graficas'
        //   ),
        //   icon: 'insert_chart_outlined',
        //   widget: {
        //     type: 'replay-chart-widget',
        //     props: {},
        //     configs: [
        //       {
        //         name: 'replay',
        //         label: 'Replay',
        //         type: 'select',
        //         required: true,
        //       },
        //     ],
        //   },
        //   position: {
        //     sizeX: 6,
        //     sizeY: 4,
        //     minSizeX: 6,
        //     minSizeY: 4,
        //     maxSizeX: 6,
        //     maxSizeY: 4,
        //   },
        // }
      );
    }

    if ($permissionsFactory.hasPermission("data-management:read")) {
      vm.widgets.push({
        name: "Data Table",
        acl: "data-management:read",
        group: $translationService.getTranslationController(
          "Data Management",
          "Data Management",
          "Data Management"
        ),
        icon: "insert_chart_outlined",
        widget: {
          type: "table-data-widget",
          props: {},
          configComponent: "config-data-management-table",
        },
        position: {
          sizeX: 6,
          sizeY: 5,
          minSizeX: 6,
          minSizeY: 5,
        },
      });
      vm.widgets.push({
        name: "Data Chart",
        acl: "data-management:read",
        group: $translationService.getTranslationController(
          "Data Management",
          "Data Management",
          "Data Management"
        ),
        icon: "insert_chart_outlined",
        widget: {
          type: "chart-data-widget",
          props: {},
          configComponent: "config-data-management-chart",
        },
        position: {
          sizeX: 6,
          sizeY: 5,
          minSizeX: 6,
          minSizeY: 5,
        },
      });
      vm.widgets.push({
        name: "Issues Risk",
        acl: "data-management:read",
        group: $translationService.getTranslationController(
          "Data Management",
          "Data Management",
          "Data Management"
        ),
        icon: "input",
        widget: {
          type: "risks-widget",
          props: {},
          configs: [],
          configComponent: "config-risks",
        },
        position: {
          sizeX: 6,
          sizeY: 3,
          minSizeX: 3,
          minSizeY: 3,
        },
      });
    }
    vm.widgets = _groupBy(vm.widgets, "acl");
  };

  vm.configure = function (widget) {
    vm.selectedWidget = widget;
    vm.previewWidget(widget);
    vm.page = 2;
  };

  vm.api = {};

  vm.api.toggle = function () {
    $mdSidenav("config-bar").toggle();
  };

  vm.api.close = function () {
    if (vm.page != 1) {
      vm.cancelWidget();
      vm.page = 1;
    }
    $mdSidenav("config-bar").close();
  };

  vm.prevPage = function () {
    vm.page = 1;
    vm.selectedWidget = null;
    vm.cancelWidget();
  };

  vm.apply = function () {
    if (_requiredParametersIncompletes()) {
      return;
    }
    vm.page = 1;
    if (vm.selectedWidget.widget.type == "list-reader-widget") {
      if (!vm.selectedList.listId) return;
      if (!vm.group) return;
      if (!vm.label) return;
      if (!vm.operation) return;
      if (!vm.bytop) return;
      vm.selectedWidget.widget.props["list"] = {
        listId: vm.selectedList.listId,
        name: vm.selectedList.name,
        group: vm.group,
        label: vm.label,
        operation: vm.operation,
        top: vm.bytop,
      };
    }
    if (vm.selectedWidget.widget.type == "indicators-list-widget") {
      if (!vm.selectedList.listId) return;
      if (!vm.selectedList.schema.id) return;
      if (!vm.indicatorsValues.yAxis) return;
      if (!vm.indicatorsValues.xAxis) return;
      if (!vm.indicatorsValues.typeChart) return;
      if (!vm.indicatorsValues.description) return;
      vm.selectedWidget.widget.props["list"] = {
        listId: vm.selectedList.listId,
        schema: vm.selectedList.schema.id,
        yAxis: vm.indicatorsValues.yAxis,
        xAxis: vm.indicatorsValues.xAxis,
        type: vm.indicatorsValues.typeChart,
        description: vm.indicatorsValues.description,
      };
    }
    var widget = angular.copy(vm.selectedWidget);

    vm.addWidget(widget);
    $mdSidenav("config-bar").close();
    vm.selectedWidget = null;
  };

  $scope.$on("applyConfigComponent", function (ev, widget) {
    delete widget.$$hashKey;
    console.log("applyConfigComponent");
    console.log(widget);
    vm.addWidget(widget);
    $mdSidenav("config-bar").close();
    vm.selectedWidget = null;
    setTimeout(function () {
      $rootScope.$broadcast("initWidget");
      vm.page = 1;
    }, 300);
  });

  $scope.$on("closeConfigComponent", function () {
    vm.api.close();
  });

  $scope.$on("prevPageConfigComponent", function () {
    vm.prevPage();
  });

  vm.expand_widget_block = function (index) {
    vm.widgets = vm.widgets.map(function (e) {
      e.display = false;
      return e;
    });
    vm.widgets[index].display = true;
  };

  function _groupBy(xs, key) {
    var groups = xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
    var widgets = [];
    for (var key in groups) {
      var arr = groups[key];
      widgets.push({
        id: key.split(":")[0],
        name: arr[0].group,
        display: false,
        widgets: arr,
      });
    }
    return widgets;
  }

  function _requiredParametersIncompletes() {
    var badParams = false;
    vm.selectedWidget.widget.configs.forEach(function (item) {
      if (item.required && !vm.selectedWidget.widget.props[item.name]) {
        $toastr.warning(
          item.label +
            " " +
            $translationService.getTranslationController(
              "requerido",
              "required",
              "requeridos"
            )
        );
        badParams = true;
      }
    });
    return badParams;
  }
  /***Replay Widget***************************************************************************************************************/
  // vm.changeReplay = function () {
  //   var replay = vm.replays.filter(function (_item) {
  //     return _item.id == vm.selectedReplay;
  //   });

  //   var charts = replay[0].settings.charts.filter(function (_item) {
  //     return _item.type != 'TABLE';
  //   });
  //   vm.charts = angular.copy(charts);
  // };

  // vm.changeChart = function () {
  //   var chart = vm.charts.filter(function (_item) {
  //     return _item.id == vm.selectedChart;
  //   });
  //   vm.selectedWidget.widget.props['chart'] = {
  //     replayId: vm.selectedReplay,
  //     chartId: vm.selectedChart,
  //   };
  // };

  vm.querySearch = function (query) {
    return query ? vm.lists.filter(createFilterFor(query)) : vm.lists;
  };

  /****List Reader Widget************************************************************************************************************/
  vm.lists = [];
  vm.selectedList = null;
  vm.currentschema = null;
  vm.group = null;
  vm.label = null;
  vm.bytop = 5;
  vm.operation = "contar";
  vm.operationTypes = ["contar"];
  vm.topTypes = [3, 5, 10];

  vm.indicatorsValues = {
    yAxis: null,
    xAxis: null,
    typeChart: "bar",
    description: null,
  };

  $scope.loading = true;

  function createFilterFor(query) {
    var lowercaseQuery = query.toLowerCase();
    return function filterFn(state) {
      return state.name.toLowerCase().indexOf(lowercaseQuery) === 0;
    };
  }

  /*checkbox*/
  $scope.onChangeTitle = function (text) {
    vm.selectedWidget.widget.props.title = text;
  };

  $scope.toggle = function (item, list, max) {
    var idx = list.indexOf(item);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      if (list.length == max) return;
      list.push(item);
    }
    vm.selectedWidget.widget.props.selected = list;
  };

  $scope.exists = function (item, list) {
    return list.indexOf(item) > -1;
  };

  $scope.$watch("ctrl.selectedList", function (nval, oval) {
    if (nval !== null) {
      var jsonToObj = angular.fromJson(nval.schema.schema);
      var definitions = jsonToObj.definitions;
      vm.currentschema = Object.values(definitions)[0];
    } else {
      vm.currentschema = null;
    }
  });
}

'use strict';

angular.module('dashboard').component('filesQueue', {
  templateUrl: 'app/files-storage/components/files-queue/files-queue.html',
  controllerAs: 'ctrl',
  bindings: {
    files: '=',
    folderId: '=',
  },

  controller: FilesQueueController,
});

FilesQueueController.$inject = [
  '$scope',
  '$rootScope',
  '$mdDialog',
  'toastr',
  'FileSaver',
  'FilesStorageFactory',
  'translationService',
  'PermissionsFactory',
];

function FilesQueueController(
  $scope,
  $rootScope,
  $mdDialog,
  toastr,
  FileSaver,
  $filesStorageFactory,
  $translationService,
  $permissionsFactory
) {
  var vm = this;
  $translationService.getTranslation(vm, 'files-storage');

  vm.downloadFile = function () {
    $rootScope.loading = true;
    Promise.allSettled(
      vm.files.map(function (f) {
        f.loading = true;
        return _downloadFile(vm.folderId, f.id);
      })
    )
      .then(function (res) {
        for (var i = 0; i < res.length; i++) {
          var item = res[i];
          if (item.status === 'fulfilled') {
            FileSaver.saveAs(new Blob([item.value.data]), vm.files[i].name);
            vm.files[i].loading = false;
          }
        }
        toastr.success(vm.translation.allDownloadedFiles);
      })
      .catch(function (err) {
        console.error('Error@downloadFile', err);
      })
      .finally(function () {
        $rootScope.loading = false;
        $scope.$emit('clearQueue');
      });
  };

  vm.filetoTrash = function () {
    $rootScope.loading = true;
    Promise.allSettled(
      vm.files.map(function (f) {
        f.loading = true;
        return _filesToTrash(vm.folderId, f.id);
      })
    )
      .then(function (res) {
        for (var i = 0; i < res.length; i++) {
          vm.files[i].loading = false;
        }
        toastr.success(vm.translation.allFilesMovedToTrash);
        $scope.$emit('clearQueue');
        $rootScope.$broadcast('refreshStorage');
        $rootScope.loading = false;
      })
      .catch(function (err) {
        console.error('Error@filetoTrash', err);
        $rootScope.loading = false;
      });
  };

  vm.confirmFileToTrash = function (ev) {
    var confirm = $mdDialog
      .confirm()
      .title(vm.translation.confirm_send_files_to_trash)
      .textContent('')
      .ariaLabel('filetoTrash')
      .targetEvent(ev)
      .ok(vm.translation.yes)
      .cancel(vm.translation.cancel);

    $mdDialog.show(confirm).then(
      function () {
        vm.filetoTrash();
      },
      function () {
        toastr.info(vm.translation.cancelled);
      }
    );
  };

  vm.validatePermission = function (action, folderType) {
    return (
      vm.folderType !== folderType &&
      $permissionsFactory.hasPermission(
        'files-storage-folder#' + vm.folderId + ':' + action
      )
    );
  };

  vm.dialogMoveFileToFolder = function (ev) {
    $mdDialog
      .show({
        controller: 'MoveFileController',
        controllerAs: 'ctrl',
        templateUrl: 'app/files-storage/folder/dialog/move-file/move-file.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          fileID: vm.files.map(function (file) {
            return file.id;
          }),
          fileName: vm.files.length + ' files selected',
          folderID: vm.folderId,
        },
      })
      .then(function () {
        vm.files = [];
      });
  };

  function _downloadFile(folderId, fileId) {
    return new Promise(function (resolve, reject) {
      $filesStorageFactory
        .downloadFile(folderId, fileId)
        .then(function (res) {
          resolve(res);
        })
        .catch(function (error) {
          reject(ErrorEvent);
        });
    });
  }

  function _filesToTrash(folderId, fileId) {
    return new Promise(function (resolve, reject) {
      $filesStorageFactory
        .moveFileToTrash(folderId, fileId)
        .then(function (res) {
          resolve(res);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
}

"use strict";
var app = angular.module("dashboard");
app.component("fileWidget", {
  templateUrl: "app/files-storage/components/file/file.html",
  controllerAs: "file",
  bindings: {
    data: "=",
    folderType: "=",
  },
  controller: fileWidgetController,
});

fileWidgetController.$inject = [
  "$rootScope",
  "$scope",
  "$mdDialog",
  "toastr",
  "FileSaver",
  "FilesStorageFactory",
  "$state",
  "translationService",
  "PermissionsFactory",
];

function fileWidgetController(
  $rootScope,
  $scope,
  $mdDialog,
  toastr,
  FileSaver,
  FilesStorageFactory,
  $state,
  $translationService,
  PermissionsFactory
) {
  var vm = this;
  $translationService.getTranslation(vm, "files-storage");

  vm.showShareEntityDialog = function () {
    $mdDialog.show({
      controller: "ShareEntityController",
      templateUrl: "app/acl/component/dialog-share-entity.html",
      parent: angular.element(document.body),
      clickOutsideToClose: false,
      locals: {
        selectedItem: {
          id: vm.data.id,
          resource: "files-storage-folder-file",
          name: vm.data.name,
        },
        actions: ["read", "update", "delete", "move", "download", "share"],
      },
    });
  };

  vm.downloadFile = function () {
    $rootScope.loading = true;
    FilesStorageFactory.downloadFile(vm.data.folderId, vm.data.id)
      .then(function (res) {
        FileSaver.saveAs(new Blob([res.data]), vm.data.name);
        toastr.success(vm.translation.fileDownloaded + ": " + vm.data.name);
        $rootScope.loading = false;
      })
      .catch(function (error) {
        $rootScope.loading = false;
        if (error.status == 404) {
          toastr.error(
            $translationService.getTranslationController(
              "Archivo no encontrado.",
              "File not found.",
              "Arquivo não encontrado."
            )
          );
        } else if (error.status == 403) {
          toastr.error(
            $translationService.getTranslationController(
              "No autorizado",
              "Unauthorized",
              "Não autorizado"
            )
          );
        } else {
          toastr.error(
            $translationService.getTranslationController(
              "No se pudo descargar el archivo",
              "Could not download file",
              "Não foi possível baixar o arquivo"
            )
          );
        }
      });
  };

  vm.confirmFileToTrash = function (ev) {
    var title = $translationService.getTranslationController(
      "¿Seguro deseas enviar este archivo a la papelera?",
      "Are you sure you want to send this file to the trash?",
      "Tem certeza de que deseja enviar este arquivo para a lixeira?"
    );

    var confirm = $mdDialog
      .confirm()
      .title(title)
      .textContent("")
      .ariaLabel("filetoTrash")
      .targetEvent(ev)
      .ok(vm.translation.yes)
      .cancel(vm.translation.cancel);

    $mdDialog.show(confirm).then(
      function () {
        _filesToTrash(vm.data.folderId, vm.data.id);
      },
      function () {
        toastr.info(vm.translation.cancelled);
      }
    );
  };

  function _filesToTrash(folderId, fileId) {
    $rootScope.loading = true;
    return new Promise(function (resolve, reject) {
      FilesStorageFactory.moveFileToTrash(folderId, fileId)
        .then(function (res) {
          resolve(res);
          $rootScope.loading = false;
          $state.reload();
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  vm.restoreFileToFolder = function () {
    $rootScope.loading = true;
    FilesStorageFactory.restoreFileToFolder(vm.data.folderId, vm.data.id)
      .then(function (res) {
        toastr.success(
          $translationService.getTranslationController(
            "Archivo restaurado en la carpeta " + res.folderName,
            "File restored in the folder " + res.folderName,
            "Arquivo restaurado na pasta " + res.folderName
          )
        );
        $rootScope.loading = false;
        $state.reload();
      })
      .catch(function (err) {
        console.error("Error@delteFolderbyID", err);
        toastr.error(
          $translationService.getTranslationController(
            "No se pudo enviar a la papalera!",
            "Could not send to trash!",
            "Não foi possível enviar para a lixeira!"
          )
        );
      });
  };

  vm.confirmRestoreFileToFolder = function (ev) {
    FilesStorageFactory.getFilesInFolder(vm.data.folderId)
      .then(function (res) {
        var foundFile = res.data.filter(function (e) {
          return e.name.toLowerCase() == vm.data.name.toLowerCase();
        });
        if (foundFile.length > 0) {
          var confirm = $mdDialog
            .confirm()
            .title(
              $translationService.getTranslationController(
                "En la carpeta  " +
                  vm.data.folderName +
                  " existe un archivo igual - ¿Seguro deseas restaurar este archivo?",
                "In the folder  " +
                  vm.data.folderName +
                  " there is an equal file - Are you sure you want to restore this file?",
                "Na pasta  " +
                  vm.data.folderName +
                  "  existe um arquivo igual - Tem certeza de que deseja restaurar este arquivo?"
              )
            )
            .textContent(
              $translationService.getTranslationController(
                "Éste reemplaza al existente en la carpeta  " + vm.data.folderName,
                "This replaces the existing one in the folder  " + vm.data.folderName,
                "Isso substitui o existente na pasta " + vm.data.folderName
              )
            )
            .ariaLabel("restoreFileToFolder")
            .targetEvent(ev)
            .ok($translationService.getTranslationController("Si!", "Yes!", "Si"))
            .cancel($translationService.getTranslationController("Cancelar", "Cancel", "Cancelar"));

          $mdDialog.show(confirm).then(
            function () {
              vm.restoreFileToFolder();
            },
            function () {
              toastr.info(
                $translationService.getTranslationController("Cancelado", "Cancelled", "Cancelado")
              );
            }
          );
        } else {
          var confirm = $mdDialog
            .confirm()
            .title(
              $translationService.getTranslationController(
                "¿Quieres restaurar este archivo a su carpeta original?",
                "Do you want to restore this file to its original folder?",
                "Deseja restaurar este arquivo para sua pasta original?"
              )
            )
            .textContent("")
            .ariaLabel("restoreFileToFolder")
            .targetEvent(ev)
            .ok($translationService.getTranslationController("Si!", "Yes!", "Si"))
            .cancel($translationService.getTranslationController("Cancelar", "Cancel", "Cancelar"));

          $mdDialog.show(confirm).then(
            function () {
              vm.restoreFileToFolder();
            },
            function () {
              toastr.info(
                $translationService.getTranslationController("Cancelado", "Cancelled", "Cancelado")
              );
            }
          );
        }
      })
      .catch(function (err) {
        console.error("Error@getFilesInFolder", err);
        toastr.error(err);
      });
  };

  vm.deleteFileInTrash = function () {
    $rootScope.loading = true;
    FilesStorageFactory.deleteFileInTrash(vm.data.folderId, vm.data.id)
      .then(function (res) {
        toastr.success(
          $translationService.getTranslationController(
            "Archivo eliminado completamente",
            "File completely deleted",
            "Arquivo completamente excluído"
          )
        );
        $rootScope.loading = false;
        $state.reload();
      })
      .catch(function (err) {
        console.error("Error@deleteFileInTrash", err);
        toastr.error(
          $translationService.getTranslationController(
            "No se pudo eliminar!",
            "It could not be deleted!",
            "Não foi possível excluir!"
          )
        );
        $rootScope.loading = false;
      });
  };

  vm.confirmDeleteFileInTrash = function (ev) {
    var confirm = $mdDialog
      .confirm()
      .title(
        $translationService.getTranslationController(
          "¿Quieres eliminar este archivo definitivamente?",
          "Do you want to delete this file permanently?",
          "Deseja excluir este arquivo permanentemente?"
        )
      )
      .textContent(
        $translationService.getTranslationController(
          "El archivo no podra ser recuperado",
          "The file cannot be recovered",
          "O arquivo não pode ser recuperado"
        )
      )
      .ariaLabel("deleteFileInTrash")
      .targetEvent(ev)
      .ok($translationService.getTranslationController("Si!", "Yes!", "Si"))
      .cancel($translationService.getTranslationController("Cancelar", "Cancel", "Cancelar"));

    $mdDialog.show(confirm).then(
      function () {
        vm.deleteFileInTrash();
      },
      function () {
        toastr.info(
          $translationService.getTranslationController("Cancelado", "Cancelled", "Cancelado")
        );
      }
    );
  };

  vm.dialogMoveFileToFolder = function (ev) {
    $mdDialog.show({
      controller: "MoveFileController",
      controllerAs: "ctrl",
      templateUrl: "app/files-storage/folder/dialog/move-file/move-file.html",
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose: false,
      locals: {
        fileID: vm.data.id,
        fileName: vm.data.name,
        folderID: vm.data.folderId,
      },
    });
  };

  vm.validatePermission = function (action) {
    if (
      PermissionsFactory.hasDenyPermission(
        "files-storage-folder-file#" + vm.data.id + ":" + action
      ) ||
      PermissionsFactory.hasDenyPermission(
        "files-storage-folder#" + vm.data.folderId + ":" + action + "-file"
      )
    ) {
      return false;
    } else if (
      PermissionsFactory.hasPermission("files-storage-folder-file#" + vm.data.id + ":" + action) ||
      PermissionsFactory.hasPermission(
        "files-storage-folder#" + vm.data.folderId + ":" + action + "-file"
      )
    ) {
      return true;
    } else {
      return false;
    }
  };

  vm.showPreview = false;

  $scope.$watch(
    function () {
      return vm.data;
    },
    function (nval) {
      if (nval) {
        vm.showPreview = false;
        setTimeout(function () {
          vm.showPreview = true;
        }, 50);
      }
    },
    true
  );
}

'use strict';

angular.module('dashboard').component('diskUsage', {
  templateUrl: 'app/files-storage/components/disk/disk-usage.html',
  controllerAs: 'ctrl',
  bindings: {
    show: '@',
  },

  controller: DiskUsageController,
});

DiskUsageController.$inject = [
  '$scope',
  '$rootScope',
  '$mdDialog',
  'toastr',
  'FilesStorageFactory',
  'translationService',
];

function DiskUsageController(
  $scope,
  $rootScope,
  $mdDialog,
  toastr,
  FilesStorageFactory,
  $translationService
) {
  var vm = this;
  $translationService.getTranslation(vm, 'files-storage');
  vm.loading = true;

  vm.storage = null;
  vm.diskUsagePercentage = 0;
  vm.storeInfo = null;

  vm.$onInit = function () {
    vm.getDiskInfo();
  };

  $scope.$on('refreshDiskUsage', function () {
    vm.getDiskInfo();
  });

  vm.getDiskInfo = function () {
    vm.loading = true;
    FilesStorageFactory.getConfigStorage({ info: vm.show })
      .then(function (res) {
        vm.storage = res;

        vm.diskUsagePercentage = parseFloat(
          (res.diskUsageInKb * 100) / res.diskSizeInKb
        ).toFixed(2);

        vm.storeInfo = {
          class: 'white lighten-4',
          progress: 'blue',
        };

        if (vm.diskUsagePercentage >= 29 && vm.diskUsagePercentage <= 49) {
          vm.storeInfo = {
            class: 'amber lighten-4',
            progress: 'amber',
          };
        }

        if (vm.diskUsagePercentage >= 50 && vm.diskUsagePercentage <= 70) {
          vm.storeInfo = {
            class: 'orange lighten-4',
            progress: 'orange',
          };
        }

        if (vm.diskUsagePercentage >= 71) {
          vm.storeInfo = {
            class: 'red lighten-4',
            progress: 'red',
          };
        }

        vm.loading = false;
      })
      .catch(function (err) {
        vm.loading = false;
        console.error('Error@getDiskInfo', err);
      });
  };

  // trash files
  $scope.deleteALLTrash = function () {
    FilesStorageFactory.deleteALLTrash()
      .then(function (res) {
        toastr.success(
          $translationService.getTranslationController(
            'Eliminación de archivos exitosa',
            'File Deletion Successful',
            'File Deletion Successful'
          )
        );
        $rootScope.$broadcast('refreshStorage');
      })
      .catch(function (err) {
        console.error('Error@deleteALLTrash', err);
        toastr.error(
          $translationService.getTranslationController(
            'No se pudo vaciar la papelera!',
            'Could not empty trash!',
            'Não foi possível esvaziar o lixo!'
          )
        );
      });
  };
  $scope.confirmDeleteALLTrash = function (ev) {
    var confirm = $mdDialog
      .confirm()
      .title(
        $translationService.getTranslationController(
          '¿Seguro quieres vaciar toda la papelera?',
          'Are you sure you want to empty all the trash?',
          'Tem certeza de que deseja esvaziar todo o lixo?'
        )
      )
      .textContent(
        $translationService.getTranslationController(
          'Los archivos no podra ser recuperados',
          'Files cannot be recovered',
          'Arquivos não podem ser recuperados'
        )
      )
      .ariaLabel('deleteALLTrash')
      .targetEvent(ev)
      .ok($translationService.getTranslationController('Si!', 'Yes!', 'Sim!'))
      .cancel(
        $translationService.getTranslationController(
          'Cancelar',
          'Cancel',
          'Cancelar'
        )
      );

    $mdDialog.show(confirm).then(
      function () {
        $scope.deleteALLTrash();
      },
      function () {
        toastr.info(
          $translationService.getTranslationController(
            'Cancelado',
            'Cancelled',
            'Cancelado'
          )
        );
      }
    );
  };
}

"use strict";

var app = angular.module("dashboard");

app.component("complaintForm", {
  templateUrl: "app/ethical-portal/components/complaintForm/complaintForm.html",
  controllerAs: "ctrl",
  bindings: {
    item: "=",
    form: "=",
    company: "=",
    update: "&",
    destroy: "&",
  },
  controller: EthicalPortalComplaintFormController,
});

EthicalPortalComplaintFormController.$inject = [
  "$scope",
  "$rootScope",
  "EthicalPortalFactory",
  "toastr",
  "$mdDialog",
  "translationService",
];
function EthicalPortalComplaintFormController(
  $scope,
  $rootScope,
  $ethicalPortalFactory,
  $toastr,
  $mdDialog,
  $translationService
) {
  var vm = this;
  vm.loading = true;

  function $init() {
    vm.form.forEach(function (section, i) {
      section.inputs.forEach(function (input, j) {
        if (input.type === "radio" || input.type === "checkbox") {
          input.options.forEach(function (option) {
            if (typeof option === "string") {
              // console.log("**");
              option = {
                value: option,
                tooltip: "",
                document: null,
              };
              // console.log("option", option);
            }
          });
        }
      });
    });

    vm.loading = false;
  }
  $init();

  var FormSection = {
    id: length,
    sectionName: "nueva section ",
    inputs: [],
  };

  var formField = {
    id: 0,
    answer: "",
    name: "",
    type: "text",
    options: [],
    required: false,
    maxlength: 100,
    answer_is_issue_description: false,
    document: null,
    tooltip: "",
  };

  $scope.inputTypes = [
    { name: "Text", value: "text" },
    { name: "Textarea", value: "textarea" },
    { name: "Number", value: "number" },
    { name: "Email", value: "email" },
    { name: "Date", value: "date" },
    { name: "Time", value: "time" },
    { name: "Select", value: "select" },
    { name: "Radio", value: "radio" },
    { name: "Checkbox", value: "checkbox" },
  ];

  vm.addSection = function () {
    var isArray = Array.isArray(vm.form);
    var copy = angular.copy(FormSection);
    if (!isArray) vm.form = [];

    copy.sectionName = "nueva section";
    copy.id = vm.form.length;
    if (isArray) vm.form.push(copy);
    else {
      vm.form = [];
      vm.form.push(copy);
    }
  };

  vm.removeSection = function (index) {
    vm.form.splice(index, 1);
  };

  vm.addFieldToSection = function (sectionIndex) {
    var copy = angular.copy(formField);
    copy.id = vm.form[sectionIndex].inputs.length;
    copy.name = "input name " + vm.form[sectionIndex].inputs.length;
    vm.form[sectionIndex].inputs.push(copy);
  };

  vm.removeFiedlFromSection = function (sectionIndex, fieldIndex) {
    vm.form[sectionIndex].inputs.splice(fieldIndex, 1);
  };

  vm.answerIsIssueDescription = function (sectionIndex, fieldIndex) {
    angular.forEach(vm.form, function (section, i) {
      angular.forEach(section.inputs, function (field, j) {
        if (i == sectionIndex && j == fieldIndex) {
          field.answer_is_issue_description =
            !field.answer_is_issue_description;
          field.required = field.answer_is_issue_description;
        } else {
          field.answer_is_issue_description = false;
        }
      });
    });

  
  };

  vm.addOptionFromField = function (sectionIndex, fieldIndex) {
    var copy = {
      value: "option value",
      document: null,
    };
    vm.form[sectionIndex].inputs[fieldIndex].options.push(copy);
  };

  vm.addOptionOtherOption = function (sectionIndex, fieldIndex) {
    var exist = vm.form[sectionIndex].inputs[fieldIndex].options.some(function (
      option
    ) {
      return option.other_required;
    });

    if (exist) return;

    var copy = {
      value: "Otro",
      document: null,
      other_required: true,
      question: "Es necesario especificar su respuesta",
    };
    vm.form[sectionIndex].inputs[fieldIndex].options.push(copy);
  };

  vm.removeOptionFromField = function (sectionIndex, fieldIndex, optionIndex) {
    vm.form[sectionIndex].inputs[fieldIndex].options.splice(optionIndex, 1);
  };

  vm.saveForm = function () {

    var copy = angular.copy(vm.company);
    copy.documentList = JSON.stringify(copy.documentList);
    copy.complaintForm = JSON.stringify(copy.complaintForm);

    $ethicalPortalFactory
      .updateCompany(copy)
      .then(function (res) {
        vm.update();
        $toastr.success(
          $translationService.getTranslationController(
            "Company updated successfully",
            "Empresa actualizada con éxito",
            "Empresa atualizada com sucesso"
          )
        );
      })
      .catch(function (err) {
        vm.loading = false;
        $toastr.error(err.data);
        console.error("err@updateCompany", err);
      });

  };

  vm.destroyForm = function () {
    vm.destroy();
  }
}

"use strict";

var app = angular.module('dashboard');

app.component('queryEditor', {
    templateUrl: 'app/data-conn/components/query-editor/query-editor.html',
    controllerAs: 'ctrl',
    bindings: {
        query: "="
    },
    controller: queryEditorController,
});

queryEditorController.$inject = ['$scope'];
function queryEditorController($scope) {
    var vm = this;
    vm.addQuery = function(){
        vm.query.push("");
    }

    vm.removeQuery = function(index){
        vm.query.splice(index, 1);
    }
}

(function () {
    'use strict';

    angular
    .module('dashboard')
    .controller('CreateConnectionController', CreateConnectionController)

    CreateConnectionController.$inject = ['$scope', '$rootScope', '$mdDialog', 'toastr', 'translationService', 'DataConnFactory', 'conex', 'PermissionsFactory'];
    function CreateConnectionController($scope, $rootScope, $mdDialog, toastr, $translationService, DataConnFactory, conex, PermissionsFactory) {
        $translationService.getTranslation($scope, 'data-conn');
        var vm = this;
        vm.connData = {};
        vm.tabQueries = false;
        vm.protocols = [];
        vm.subProtocols = [];
        vm.testlist = [];
        vm.loading = false;
        vm.stateMSG = "";
        vm.types = ['batch', 'stream'];
        vm.parameterFields = [];
        vm.settingsAndTypes = [];
        vm.secureSettingsAndTypes = [];

        vm.aceConfigs = {
            useWrapMode : true,
            showGutter: true,
            theme:'twilight',
            mode: 'json'
        };

        vm.$onInit = function () {
            vm.loading = true;
            DataConnFactory.getProtocols()
            .then(function (response) {
                vm.protocols = response;
            })
            .catch(function (e) {
                console.log("error@getProtocols", e);
            })
            .finally(function(e){
                vm.connData = conex || {};
                vm.evalSchemaDefinitions();
                if(vm.connData.protocolType){
                    vm.getSubprotocol(vm.connData.protocolType)
                }else{
                    vm.loading = false;
                }
            });
        }

        vm.evalSchemaDefinitions = function(){
            vm.connData.schemasCacheMap = [];
            vm.connData.schemasCacheAsJson = angular.toJson(vm.connData.schemasCacheAsList, 4);
            if(vm.connData.schemasCacheAsList){
                angular.forEach(vm.connData.schemasCacheAsList, function (item, key){
                    var definition = Object.keys(item.schemaDefinition.definitions)[0];
                    vm.connData.schemasCacheMap.push({
                        schemaDefinition: {
                            definition: Object.keys(item.schemaDefinition.definitions)[0].trim(),
                            data: item.schemaDefinition.definitions[definition]
                        }
                    })
                })
            }
        }

        vm.getSubprotocol = function(protocol){
            vm.loading = true; vm.tabQueries = false;
            var selectedProtocol = vm.protocols.filter(function(e){ return e.protocolName == protocol });
            vm.subProtocols = selectedProtocol[0].subProtocols;
            vm.parameterFields = selectedProtocol[0].parameterFields;
            vm.settingsAndTypes = selectedProtocol[0].settingsAndTypes;
            vm.secureSettingsAndTypes = selectedProtocol[0].secureSettingsAndTypes;
            
            vm.parameters = [];
            angular.forEach(vm.parameterFields, function (value, key) {
                if( (value == "[]" || value == "list") && key == "queries") vm.tabQueries = true; // High cohesion fail
                vm.parameters.push({
                    "name": key, 
                    "type": value,
                    "value": angular.isDefined(vm.secureSettingsAndTypes[key]) ? 
                        vm.connData.secureSettings ? vm.connData.secureSettings[key] : null : 
                        vm.connData.settings ? vm.connData.settings[key] : null
                    ,
                    "secure": angular.isDefined(vm.secureSettingsAndTypes[key]),
                });
                
                // Set default value for types
                var _param = vm.parameters[vm.parameters.length - 1];
                if(_param.type == '[]' || _param.type == 'list'){ // LIST
                    _param.value = _param.value || [];
                }
                if(angular.isObject(_param.type)){ // MAP
                    var defaultValue = {};
                    _param.gridOptions = angular.copy($scope.gridOptions);
                    _param.gridOptions.columnDefs = [];
                    angular.forEach(_param.type, function (colType, colName) {
                        _param.gridOptions.columnDefs.push({   
                            displayName:colName,
                            name:colName, 
                            field:colName, 
                            enableColumnMenu: false, 
                            enableSorting: false, 
                            enableHiding: false,
                        });
                        defaultValue[colName] = null;
                    });
                    // botón de eliminar
                    _param.gridOptions.columnDefs.push({
                        displayName: '', name: 'Delete', enableFiltering: false, enableSorting: false, enableCellEdit: false, enableColumnMenu: false,
                        cellTemplate: '<button type="button" ng-click="grid.appScope.deleteRow(row.entity, grid)"><md-icon md-font-set="material-icons" aria-label="BTN">delete</md-icon></button>', 
                        cellClass: 'schema-cell-content',
                        width: 42
                    })
                    _param.type = "{}";
                    _param.value = _param.value || [];
                    if(!_param.value.length) _param.value.push(defaultValue);
                    _param.gridOptions.data = _param.value;
                }
            });
            vm.loading = false;
        }

        vm.createConn = function(){
            vm.stateMSG = "Saving Connection";
            vm.loading = true;
            var settings = {};
            var secureSettings = {};
            // Map settings
            angular.forEach(vm.parameters, function(value, key){
                if(value.secure){
                    secureSettings[value.name] = value.value ||  null;
                }else{
                    settings[value.name] = value.value
                }
            })
            var request = {
                "id": vm.connData.id,
                "connectionType": "input",
                "protocolType": vm.connData.protocolType,
                "protocolDriverOrSubtype": vm.connData.protocolDriverOrSubtype,
                "dataProcessingType": vm.connData.dataProcessingType,
                "domainId": 1,
                "name": vm.connData.name,
                "description": vm.connData.description,
                "settings": settings,
                "secureSettings": secureSettings,
            };

            DataConnFactory.createConnection(request)
            .then(function (response) {
                vm.connData = response;
                $rootScope.$broadcast('refreshDataConn');
                vm.stateMSG = "Testing Connection, please wait.";

                PermissionsFactory.addPermission(
                  'data-connection',
                  vm.connData.name,
                  'all',
                  true
                );

                vm.testConnection();
            })
            .catch(function (e) {
                toastr.error("Operation failed")
                console.log("error@createConnection", e);
                vm.loading = false;
            });
        }

        vm.testConnection = function(){
            if(!vm.connData.id){
                toastr.warning("You must save the connection before test it");
                return false;
            }
            vm.loading = true;
            DataConnFactory.testConnection(vm.connData.id)
            .then(function (response) {
                toastr.success("Connection success");
                vm.stateMSG = "";
                vm.connData.schemasCache = response;
                vm.connData.schemasCacheAsJson = angular.toJson(vm.connData.schemasCache, 4);
                vm.connData.schemasCacheAsList = angular.fromJson(vm.connData.schemasCache);
                vm.connData.schemasCacheAsList = vm.connData.schemasCacheAsList.map(function(e){
                    return angular.fromJson(e);
                })
                vm.evalSchemaDefinitions();
                $rootScope.$broadcast('refreshDataConn');
            })
            .catch(function (e) {
                var msg = typeof e === 'string' ? e : '';
                toastr.error('Connection failed ' + msg);
                console.log("error@testConnection", e);
            })
            .finally(function(e){
                vm.loading = false;
            });   
        }

        vm.cancel = function(){
            $mdDialog.cancel();
        }
        
        $scope.deleteRow = function(row, grid) {
            var i = grid.options.data.indexOf(row);
            grid.options.data.splice(i, 1);
        }

        $scope.gridOptions = {
            showHeader: true,
            enableGridMenu: true,
            enableCellEditOnFocus: true,
            enableSelectAll: false,
            enableRowSelection: false, 
            enableRowHeaderSelection: false,
            multiSelect: false,
            columnDefs: [
                {   
                    displayName:'type',
                    name:'type', field: 'type', 
                    enableColumnMenu: false, 
                    enableSorting: false, 
                    enableHiding: false,
                },
                {   
                    displayName:'new-column',
                    name:'new-column', field: 'new-column', 
                    enableColumnMenu: false, 
                    enableSorting: false, 
                    enableHiding: false, 
                },
                {
                    displayName: '', name: 'Delete', enableFiltering: false, enableSorting: false, enableCellEdit: false, enableColumnMenu: false,
                    cellTemplate: '<button type="button" ng-click="grid.appScope.deleteRow(row.entity, grid)"><md-icon md-font-set="material-icons" aria-label="BTN">delete</md-icon></button>', 
                    cellClass: 'schema-cell-content',
                    width: 42
                }
            ],
            gridMenuShowHideColumns: false,
            gridMenuCustomItems: [
                {
                    title: $translationService.getTranslationController('Agregar Fila', 'Add Row', 'Adicionar linha'),
                    action: function ($event) {
                        this.grid.options.data.push({"type": "", "new-column": ""});
                    },
                    order: 210
                }
            ],
            onRegisterApi: function( gridApi ) { 
                gridApi.edit.on.afterCellEdit($scope,function(rowEntity, colDef, newValue, oldValue){
                    if(newValue != oldValue){
                        // rule.isChanged = true;
                    }
                })
            },
            data: [],
            // data: [{"type": "integer", "new-column": "int"}, {"type": "", "new-column": ""}, {"type": "", "new-column": ""}, {"type": "", "new-column": ""}],
        }
    }
})();

'use strict';

var app = angular.module('dashboard');

app.component('vinculatedIssues', {
  templateUrl:
    'app/dashboard/components/vinculated-issues/vinculated-issues.html',
  controllerAs: 'ctrl',
  bindings: {
    issueUuid: '<',
    issuesToLink: '<',
    linksCount: '=',
    issueType: '<',
    linkedIssueTypes: '=',
    isLocked: '<',
  },
  controller: vinculatedIssuesController,
});

vinculatedIssuesController.$inject = ['$scope'];
function vinculatedIssuesController($scope) {
  var vm = this;
  vm.linksCount = 0;

  $scope.$watchCollection('ctrl.linkedIssueCounters', function (values) {
    vm.linksCount = 0;
    angular.forEach(values, function (val) {
      vm.linksCount += val;
    });
  });

  $scope.$watchCollection(
    'ctrl.issuesToLink',
    function () {
      vm.linkedIssueTypes = _updateLinkedIssueTypes(
        vm.linkedIssueTypes,
        vm.issuesToLink
      );
    },
    true
  );

  function _updateLinkedIssueTypes(currentLinkedIssueTypes, issuesToLink) {
    currentLinkedIssueTypes = currentLinkedIssueTypes || [];
    issuesToLink.forEach(function (e) {
      if (
        !currentLinkedIssueTypes.find(function (type) {
          return type.id == e.issueType.id;
        })
      ) {
        currentLinkedIssueTypes.push(e.issueType);
      }
    });
    return currentLinkedIssueTypes;
  }
}

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller("IssuesReportDialogController", IssuesReportDialogController);

  IssuesReportDialogController.$inject = [
    "$rootScope",
    "$mdDialog",
    "toastr",
    "IssuesFactory",
    "SchemasService",
    "issue",
    "currentIssueType",
    "ConfigurationFactory",
    "translationService",
    "FilesStorageFactory",
    "FileSaver",
    "$filter",
  ];

  function IssuesReportDialogController(
    $rootScope,
    $mdDialog,
    toastr,
    IssuesFactory,
    $schemasService,
    issue,
    currentIssueType,
    ConfigurationFactory,
    $translationService,
    $filesStorageFactory,
    FileSaver,
    $filter
  ) {
    var converter = new showdown.Converter();
    var vm = this;
    // console.log(issue);
    // console.log(currentIssueType);
    $translationService.getTranslation(vm, "issues");
    vm.checkbox = {
      evidence: false,
      storage: false,
      link: false,
      comment: false,
      guest: false,
    };

    vm.gridOptions = {
      multiSelect: true,
      enableFullRowSelection: true,
      data: [],
    };
    vm.issue = issue;

    vm.issueReferences = {
      loading: true,
      data: [],
    };

    vm.reportLogo = false;

    vm.$onInit = function () {
      $rootScope.loading = true;

      var promises = [];
      // load data
      promises.push(_getGlobalConfiguration());
      promises.push(_getIssueFiles(vm.issue.uuid, vm.issue.issueType.name));
      promises.push(_getIssueGuests(vm.issue.uuid));
      promises.push(_getIssueEvidencesSummary(vm.issue.uuid));
      promises.push(_getLinkedIssuesByParentIssueUuid(vm.issue.uuid));
      promises.push(_getIssueComments(vm.issue.uuid));
      promises.push(_getIssueEvidences(vm.issue.uuid));

      currentIssueType.evidenceSchemas.forEach(function (e) {
        promises.push(_getIssueEvidencesById(vm.issue.uuid, e.id));
      });

      Promise.all(promises)
        .then(function (res) {
          console.log("res", res);
          $rootScope.loading = false;
        })
        .then(function () {
          if (vm.reportConfig) {
            var img = vm.reportConfig.split("/");
            _getImageFromStorage(img[0], img[1]);
          }
          _parseIssueEvidenceData();
        });

      vm.schemaDataHeader = angular.fromJson(vm.issue.head);

      vm.schemaHeader = $schemasService.parseSchemaByGroup(angular.copy(vm.issue.headSchema));

      vm.schemaDataBody = angular.fromJson(vm.issue.body);
      vm.schemaBody = $schemasService.parseSchemaByGroup(angular.copy(vm.issue.bodySchema));
    };

    function _getGlobalConfiguration() {
      return new Promise(function (resolve, reject) {
        ConfigurationFactory.getGlobalConfiguration()
          .then(function (res) {
            vm.theme = res.dashboard.theme || null;
            vm.reportConfig = res.issues.logo || null;
            resolve();
          })
          .catch(function (e) {
            vm.theme = "custom";
            reject();
          });
      });
    }

    vm.getFieldName = function (schema, props) {
      var _key = props.pk ? "#" + props.key : props.key;
      var _schema = vm[schema][_key];
      if (_schema == undefined) return "";
      return $filter("humanReadable")(_schema, props.type, _key);
    };

    vm.getPkValue = function (obj) {
      var pkvalue = "PK not found";
      for (var property in obj) {
        if (property.includes("#")) {
          pkvalue = obj[property];
        }
      }
      return pkvalue;
    };

    function _getLinkedIssuesByParentIssueUuid(issueUuid) {
      IssuesFactory.getLinkedIssuesByParentIssueUuid(issueUuid)
        .then(function (res) {
          vm.AllDataEvidences = [];
          vm.linkedIssues = res.data.issues.map(function (issue) {
            issue.schemaDataHeader = angular.fromJson(issue.head);
            issue.schemaHeader = $schemasService.parseSchema(angular.copy(issue.headSchema));

            issue.schemaDataBody = angular.fromJson(issue.body);
            issue.schemaBody = $schemasService.parseSchema(angular.copy(issue.bodySchema));

            return issue;
          });
        })
        .catch(function (err) {
          console.error("Error@getLinkedIssues", err);
        });
    }

    function _getIssueEvidencesSummary(issueUuid) {
      return new Promise(function (resolve, reject) {
        IssuesFactory.getIssueEvidencesSummary(issueUuid)
          .then(function (res) {
            vm.issueEvidenceTypes = [];
            angular.forEach(res.data, function (_item) {
              var _type = vm.issueEvidenceTypes.filter(function (_schema) {
                return _schema.id == _item.bodySchema.id;
              });
              if (_type.length == 0) {
                vm.issueEvidenceTypes.push(_item.bodySchema);
              }
            });

            resolve();
          })
          .catch(function (e) {
            console.error("Error@getIssueEvidences", e);
            reject();
          });
      });
    }

    function _getIssueEvidences(issueUuid) {
      return new Promise(function (resolve, reject) {
        IssuesFactory.getIssueAllEvidences(issueUuid)
          .then(function (res) {
            vm.issueEvidences = res.data;
            resolve();
          })
          .catch(function (e) {
            console.error("Error@getIssueEvidences", e);
            reject();
          });
      });
    }

    function _getIssueEvidencesById(issueUuid, schemaId) {
      var pagination = {
        page: 1,
        itemsPerPage: 1,
        schemaId: schemaId,
      };
      return new Promise(function (resolve, reject) {
        IssuesFactory.getIssueEvidences(issueUuid, pagination)
          .then(function (res) {
            res.data.schemaId = schemaId;
            resolve(res.data);
          })
          .catch(function (e) {
            console.log("Error@getIssueEvidences", e);
            reject(e);
          });
      });
    }

    function _getIssueGuests(issueUuid) {
      return new Promise(function (resolve, reject) {
        IssuesFactory.getIssueGuests(issueUuid)
          .then(function (res) {
            vm.issueGuests = res.users;
            resolve();
          })
          .catch(function (err) {
            console.error("Error@getIssueGuests", err);
            reject();
          });
      });
    }

    function _getIssueComments(issueUuid) {
      return new Promise(function (resolve, reject) {
        IssuesFactory.getIssueComments(issueUuid)
          .then(function (res) {
            vm.issueComments = res.data.map(function (e) {
              e.commentHtml = converter.makeHtml(_formatComment(e.comment));
              return e;
            });
            resolve();
          })
          .catch(function (err) {
            console.error("Error@getIssueComments", err);
            reject();
          });
      });
    }

    function _getIssueFiles(issueUuid, issueTypeName) {
      return new Promise(function (resolve, reject) {
        IssuesFactory.getIssueFiles(issueUuid)
          .then(function (res) {
            vm.issueStorage = res.data.map(function (e) {
              var folder = "issue_" + issueTypeName + "_" + issueUuid;
              e.path =
                "/risk-backend/rest/file/folder/" + folder + "/file/" + e.name + "/download/free";
              return e;
            });
            resolve();
          })
          .catch(function (err) {
            console.error("Error@getIssueFiles", err);
            reject();
          });
      });
    }

    function _getImageFromStorage(folder, file) {
      return new Promise(function (resolve, reject) {
        $filesStorageFactory
          .downloadFile(folder, file)
          .then(function (res) {
            vm.reportLogo = URL.createObjectURL(res.data) || false;
          })
          .catch(function (err) {
            console.error("Error@_getImageFromStorage", err);
            reject("Error@_getImageFromStorage");
          });
      });
    }

    function _parseIssueEvidenceData() {
      angular.forEach(vm.issueEvidenceTypes, function (item, index) {
        item.data = vm.issueEvidences
          .filter(function (e) {
            return e.bodySchema.id === item.id;
          })
          .map(function (e) {
            var body = angular.fromJson(e.body);
            body.uuid = e.uuid;
            body.gridIndex = index;
            return body;
          });

        var itemSchema = $schemasService.parseSchema(item);
        var columnDefs = _defineTableColumns(itemSchema);

        var columnPk = columnDefs.find(function (col) {
          return col.field.startsWith("#");
        }).field;

        item.data = item.data.sort(function (a, b) {
          var sortBy = columnPk;
          return (a[sortBy] + "").localeCompare(b[sortBy] + "");
        });

        item.gridOptions = angular.copy(vm.gridOptions);
        item.gridOptions.columnDefs = columnDefs;
        item.gridOptions.data = item.data;
      });
    }

    function _defineTableColumns(data) {
      var columnDefs = [];
      angular.forEach(data, function (item, key) {
        if (item.visible === false) return;
        columnDefs.push({
          displayName: item.displayName ? item.displayName : key,
          name: key,
          field: item.pk ? "#" + key : key,
        });
      });

      return columnDefs;
    }

    function _formatComment(comment) {
      if (angular.isUndefined(comment)) return;

      var result = "";
      var separator = " ";
      var items = comment.split(separator);
      angular.forEach(items, function (item) {
        if (item.startsWith("@")) {
          item = '<a href="#" target="_blank">' + item + "</a>";
        } else if (item.startsWith("http")) {
          item = '<a href="' + item + '" target="_blank">' + item + "</a>";
        }

        result = result === "" ? item : result + " " + item;
      });
      return result;
    }

    vm.print2 = function () {
      var obj = {
        uuid: vm.issue.uuid,
        guestList: vm.issueGuests.map(function (e) {
          return e.userId;
        }),
        evidenceList: vm.issueEvidenceTypes
          .filter(function (e) {
            return e.gridOptions.data.length > 0;
          })
          .flatMap(function (e) {
            return e.gridOptions.data.map(function (ee) {
              return ee.uuid;
            });
          }),
        linkedList: vm.linkedIssues.map(function (e) {
          return e.uuid;
        }),
        commentList: vm.issueComments.map(function (e) {
          return e.uuid;
        }),
        storageList: vm.issueStorage.map(function (e) {
          return e.id;
        }),
        sectionGuest: vm.checkbox.guest,
        sectionEvidence: vm.checkbox.evidence,
        sectionLinked: vm.checkbox.link,
        sectionComment: vm.checkbox.comment,
        sectionStorage: vm.checkbox.storage,
        attachPdf: vm.checkbox.attachPdf,
      };

      $rootScope.loading = true;
      IssuesFactory.exportIssue(vm.issue.uuid, obj)
        .then(function (res) {
          FileSaver.saveAs(
            new Blob([res.data], { type: "application/pdf" }),
            "issue-" +
              angular.lowercase(vm.issue.issueType.name) +
              "-" +
              moment().format("YYYY-MM-DD") +
              ".pdf"
          );
        })
        .catch(function (error) {
          if (error.status == 403) {
            toastr.error(
              $translationService.getTranslationController(
                "Usuario no autorizado.",
                "Unauthorized User.",
                "Usuário não autorizado."
              )
            );
          }
        })
        .finally(function () {
          $rootScope.loading = false;
        });
    };

    vm.print = function () {
      var css =
        "@media print {\n" +
        "  @page {\n" +
        "    margin: 1cm;\n" +
        "  }\n" +
        "  .noprint {\n" +
        "    display: none;\n" +
        "  }\n" +
        "  * {\n" +
        '    font-family: Arial,"Times New Roman";\n' +
        "  }\n" +
        "  span.normal {\n" +
        "    font-weight: normal;\n" +
        "  }\n" +
        "  span.bold {\n" +
        "    font-weight: bold;\n" +
        "  }\n" +
        "  .clearfix::after {\n" +
        '    content: "";\n' +
        "    clear: both;\n" +
        "    display: table;\n" +
        "  }\n" +
        "  img {\n" +
        "    width: 200px !important;\n" +
        "  }\n" +
        "  .flex-container {\n" +
        "    display: flex;\n" +
        "    flex-wrap: row;\n" +
        "  }\n" +
        "  .flex-container-wrap {\n" +
        "    display: flex;\n" +
        "    flex-wrap: wrap;\n" +
        "  }\n" +
        "  .pull-right {\n" +
        "    float: right !important;\n" +
        "  }\n" +
        "  table {\n" +
        "    border-collapse: collapse;\n" +
        "    width: 100%;\n" +
        "    border: 1px solid #ddd;\n" +
        "  }\n" +
        "  table, td, th {\n" +
        "    border: 1px solid #ddd;\n" +
        "    text-align: left;\n" +
        "  }\n" +
        "  th, td {\n" +
        "    padding: 5px;\n" +
        "  }\n" +
        "  tbody tr > td {\n" +
        "    border: 1px solid #ddd !important;\n" +
        "  }\n" +
        "}";
      var innerContents = document.getElementById("printSectionId").innerHTML;
      var newWin = document.getElementById("printf").contentWindow;
      newWin.document.open();
      newWin.document.write(
        "<html><head><style>" + css + "</style></head><body>" + innerContents + "</body></html>"
      );
      newWin.document.close();
      newWin.print();
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.onDeleteRow = function (list, index) {
      if (angular.isDefined(list)) {
        list.splice(index, 1);
      }
    };
  }
})();

'use strict';

var app = angular.module('dashboard');

app.component('issuesListLoader', {
  templateUrl:
    'app/dashboard/components/issues-list-loader/issues-list-loader.html',
  controllerAs: 'ctrl',
  bindings: {
    loading: '<',
    loaded: '<',
    total: '<',
    msg: '<',
    time: '<',
    step: '<',
  },
  controller: issuesListLoaderController,
});

issuesListLoaderController.$inject = ['$scope', 'translationService'];
function issuesListLoaderController($scope, $translationService) {
  $translationService.getTranslation($scope, 'input-list');
  var vm = this;
  vm.progress = 0;

  vm.$onChanges = function () {
    if (vm.total) vm.progress = (vm.loaded * 100) / vm.total;
    if (vm.time && vm.step) {
      vm.time = ((vm.total - vm.loaded) / vm.step) * vm.time;
      vm.timeScale = vm.time > 60000 ? 'min.' : vm.time > 1000 ? 'sec.' : 'ms.';
      vm.time =
        vm.time > 60000
          ? vm.time / 60000
          : vm.time > 1000
          ? vm.time / 1000
          : vm.time;
    }
  };
}

"use strict";

var app = angular.module("dashboard");

app.component("dashboardIssuesList", {
  templateUrl: "app/dashboard/components/issues-list/issues-list.html",
  controllerAs: "ctrl",
  bindings: {
    issueType: "=",
    issueTypes: "=",
    // selectedRows: '=',
    relatedBy: "=",
    manageIssueFn: "&",
  },
  controller: dashboardIssuesListController,
});

dashboardIssuesListController.$inject = [
  "$scope",
  "$rootScope",
  "$mdDialog",
  "toastr",
  "$timeout",
  "translationService",
  "tableListConstants",
  "IssuesListExporterService",
  "IssuesFactory",
  "$stateParams",
  "$interval",
  "cellTemplateFormatService",
  "ConfigurationFactory",
  "$localStorageService",
];
function dashboardIssuesListController(
  $scope,
  $rootScope,
  $mdDialog,
  $toastr,
  $timeout,
  $translationService,
  $tableListConstants,
  $issuesListExporterService,
  $issuesFactory,
  $stateParams,
  $interval,
  $cellTemplateFormatService,
  $ConfigurationFactory,
  $localStorageService
) {
  $translationService.getTranslation($scope, "dashboard");

  $scope.loader = {
    loading: true,
    loaded: 0,
    total: 0,
    msg: false,
    time: false,
    step: 100,
  };

  var vm = this;
  vm.issueCliked = null;
  vm.ShowIssueCliked = false;
  vm.selectedRows = [];
  vm.schemasFormat = [];

  vm.filters = {
    issueTypeId: vm.issueType.id,
    pagination: {
      itemsPerPage: 15,
      page: 1,
      sortBy: "createdAtLocal",
      sort: "desc",
      totalRecords: 0,
    },
    predicates: [],
    relatedBy: vm.relatedBy,
    archived: false,
  };

  vm.gridOptions = {
    rowTemplate:
      '<div ng-dblclick="grid.appScope.ctrl.showIssue($event, row.entity)" ng-click="grid.appScope.ctrl.sideView($event, row.entity)"  ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell ng-class="{ \'cep-issue-unseen\' : !row.entity.viewed ,  \'cep-issue-locked\' : row.entity.locked }"></div>',
    multiSelect: true,
    enableRowSelection: true,
    enableSelectAll: true,
    gridMenuShowHideColumns: false,
    showColumnFooter: true,
    // Grid pagination options
    useExternalPagination: true,
    paginationPageSizes: [15, 20, 25],
    paginationPageSize: 15,
    totalItems: 0,
    // Grid sorting options
    useExternalSorting: true,
    suppressMultiSort: true,
    isRowSelectable: function (row) {
      return !row.entity.locked;
    },
    // Grid menu
    enableGridMenu: true,
    gridMenuCustomItems: [
      {
        title: "Vincular",
        action: function ($event) {
          vm.linkIssues($event);
        },
        order: 1,
      },
      {
        title: $translationService.getTranslationController(
          "Asignar Responsable",
          "Assign Responsible",
          "Atribuir Responsável"
        ),
        action: function ($event) {
          vm.assignResponsible($event);
        },
        order: 100,
      },
      {
        title: $translationService.getTranslationController(
          "Asignar Clasificación",
          "Assign Classification",
          "Atribuir Classificação"
        ),
        action: function ($event) {
          vm.assignClasification($event);
        },
        order: 200,
      },
      {
        title: $translationService.getTranslationController(
          "Asignar Estatus",
          "Assign Status",
          "Atribuir status"
        ),
        action: function ($event) {
          vm.assignStatus($event);
        },
        order: 300,
      },
      {
        title: $translationService.getTranslationController(
          "Administrar columnas",
          "Manage columns",
          "Gerenciar colunas"
        ),
        action: function ($event) {
          vm.manageColumns($event);
        },
        order: 400,
      },
      {
        title: $translationService.getTranslationController(
          "Descargar como CSV",
          "Download as CSV",
          "Baixar como CSV"
        ),
        action: function () {
          vm.exportIssuesAsCsv();
        },
        order: 500,
      },
    ],
    // Grid api Options
    onRegisterApi: function (gridApi) {
      $scope.gridApi = gridApi;
      gridApi.selection.on.rowSelectionChanged($scope, function (row) {
        if (row.entity.locked) return;
        vm.selectedRows = gridApi.selection.getSelectedRows();
      });

      gridApi.selection.on.rowSelectionChangedBatch($scope, function () {
        vm.selectedRows = gridApi.selection.getSelectedRows().filter(function (row) {
          return !row.locked;
        });
      });

      gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
        vm.filters.pagination.page = newPage;
        vm.filters.pagination.itemsPerPage = pageSize;

        $rootScope.loading = true;
        $scope.loader.loading = true;
        vm.getIssues(vm.filters)
          .then(function (res) {
            vm.gridOptions.totalItems = res.pagination.totalRecords;
            vm.gridOptions.data = res.data;

            vm.gridOptions.footerData = res.footer || {};
            _renderTable(res.columns);
          })
          .finally(function () {
            _autoSelectRows();
          });
      });

      gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        var lastsortColumn = sortColumns[sortColumns.length - 1];
        if (lastsortColumn) {
          vm.filters.pagination.sortBy = lastsortColumn.field.split(".")[0];
          vm.filters.pagination.sort = lastsortColumn.sort.direction;
        } else {
          vm.filters.pagination.sortBy = "createdAtLocal";
        }

        $rootScope.loading = true;
        $scope.loader.loading = true;
        vm.getIssues(vm.filters)
          .then(function (res) {
            vm.gridOptions.totalItems = res.pagination.totalRecords;
            vm.gridOptions.data = res.data;
            vm.gridOptions.footerData = res.footer;
            _renderTable(res.columns);
          })
          .finally(function () {
            _autoSelectRows();
          });
      });

      gridApi.colMovable.on.columnPositionChanged($scope, function () {
        var gridState = gridApi.saveState.save();
        var gridColumnsState = gridState.columns.map(function (e) {
          return e.name;
        });
        $issuesFactory
          .setIssueColumnsOrder(vm.issueType.id, gridColumnsState)
          .catch(function (error) {
            console.error("Error@setIssueColumnsOrder", error);
          });
      });
    },
  };

  vm.$onInit = function () {
    vm.selectedRows = [];
    var lsFilters = "filters-" + vm.issueType.id + "-" + vm.relatedBy;
    var filtersInLS = $localStorageService.getItem(lsFilters);
    if (filtersInLS) {
      vm.filters = filtersInLS;
      vm.filters.issueTypeId = vm.issueType.id;
    }
    vm.getIssueTypeFilters();
  };

  vm.exportIssuesAsCsv = function () {
    console.log("exportIssuesAsCsv");
    if ($scope.loader.loading) {
      $toastr.info(
        $translationService.getTranslationController(
          "Por favor espere",
          "Please wait",
          "Por favor espere"
        )
      );
      return;
    }

    $rootScope.loading = true;
    $scope.loader.loading = true;
    $scope.loader.msg = $translationService.getTranslationController(
      "Comenzando descarga",
      "Starting download",
      "Comenzando descarga"
    );

    var exportFilters = angular.copy(vm.filters);
    exportFilters.pagination.itemsPerPage = 99999;
    exportFilters.pagination.page = 1;
    exportFilters.exportToCSV = true;

    vm.getIssuesCSV(exportFilters).then(function (res) {
      console.log(res);
      $rootScope.loading = false;
      $scope.loader.loading = false;
      $rootScope.$broadcast("refreshUserDocuments");
    });

    // getBulkIssues(1, [])
    //   .then(function (res) {
    //     $scope.loader.msg = $translationService.getTranslationController(
    //       'Creando Libro',
    //       'Creating Book',
    //       'Creando Libro'
    //     );

    //     $issuesListExporterService.exportCSV(
    //       'csv',
    //       res.columns,
    //       res.data,
    //       vm.gridOptions.columnDefs
    //     );
    //   })
    //   .finally(function () {
    //     $rootScope.loading = false;
    //     $scope.loader.loading = false;
    //   });
  };

  vm.getIssueTypeFilters = function () {
    return new Promise(function (resolve, reject) {
      $issuesFactory
        .getIssueTypeFilters(vm.issueType.id)
        .then(function (res) {
          vm.columnfilters = res;
          resolve();
        })
        .catch(function (err) {
          console.error("Error@getIssueTypeFilters", err);
          reject();
        });
    });
  };

  vm.linkIssues = function (event) {
    if (vm.selectedRows.length) {
      vm.manageIssueFn({ ev: event, issuesToLink: vm.selectedRows });
    } else {
      $toastr.info(
        $translationService.getTranslationController(
          "Debe seleccionar al menos un registro",
          "You must select at least one record",
          "Você deve selecionar pelo menos um registro"
        )
      );
    }
  };

  vm.manageColumns = function (event) {
    $rootScope.loading = true;
    $scope.loader.loading = true;
    // $issuesFactory
    //   .getAvailableColumns(vm.issueType.id)
    var promises = [
      $issuesFactory.getAvailableGroups(),
      $issuesFactory.getAvailableColumns(vm.issueType.id, vm.issueType.category.id),
    ];
    Promise.all(promises)
      .then(function (res) {
        var groups = res[0].data;
        var issueColumns = res[1].data;
        _openColumnsManageDialog(event, vm.issueType.id, issueColumns, groups);
      })
      .catch(function (err) {
        console.error("Error@getAvailableColumns", err);
      })
      .finally(function () {
        $rootScope.loading = false;
        $scope.loader.loading = false;
      });
  };

  function _openColumnsManageDialog(event, issueTypeId, issueColumns, groups) {
    // console.log("issueTypeId", issueTypeId);
    // console.log("issueType", vm.issueType);
    // console.log("issueColumns", issueColumns);
    // console.log("groups", groups);
    $mdDialog
      .show({
        controller: "IssueColumnsDialogController",
        controllerAs: "ctrl",
        templateUrl: "app/dashboard/components/issue-columns-dialog/issue-columns-dialog.html",
        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: false,
        locals: {
          issueTypeId: issueTypeId,
          issueColumns: issueColumns,
          groupId: vm.issueType.id,
          categoryId: vm.issueType.category.id,
          groups: groups,
        },
      })
      .then(function (data) {
        if (data.action == "saveColumns") {
          _saveIssueColumns(data.issueTypeId, data.issueColumns, data.toGroup);
        }
        if (data.action == "setDefaultColumns") {
          _setDefaultIssueColumns(data.issueTypeId);
        }
      });
  }

  function _saveIssueColumns(issueTypeId, issueColumns, toGroup) {
    $rootScope.loading = true;

    if (toGroup) {
      $issuesFactory
        .assignCustomColumnsGroup(issueTypeId, toGroup, vm.currentIssue.category.id, issueColumns)
        .then(function () {
          $rootScope.$broadcast("ReloadIssues");
          var msg = $translationService.getTranslationController(
            "Configuración de columnas guardada",
            "Column settings saved",
            "Configurações de coluna salvas"
          );
          $toastr.success(msg);
        })
        .catch(function (err) {
          $toastr.error(
            $translationService.getTranslationController(
              "Se ha producido un error, intente de nuevo",
              "An error has occurred, please try again",
              "Ocorreu um erro, por favor, tente novamente"
            )
          );

          console.error("Error@assignCustomColumns", err);
        })
        .finally(function () {
          $rootScope.loading = false;
        });
    } else {
      $issuesFactory
        .assignCustomColumns(issueTypeId, issueColumns)
        .then(function () {
          $rootScope.$broadcast("ReloadIssues");
          var msg = $translationService.getTranslationController(
            "Configuración de columnas guardada",
            "Column settings saved",
            "Configurações de coluna salvas"
          );
          $toastr.success(msg);
        })
        .catch(function (err) {
          $toastr.error(
            $translationService.getTranslationController(
              "Se ha producido un error, intente de nuevo",
              "An error has occurred, please try again",
              "Ocorreu um erro, por favor, tente novamente"
            )
          );

          console.error("Error@assignCustomColumns", err);
        })
        .finally(function () {
          $rootScope.loading = false;
        });
    }
  }

  function _setDefaultIssueColumns(issueTypeId) {
    $rootScope.loading = true;
    IssuesFactory.setDefaultIssueColumns(issueTypeId)
      .then(function () {
        $rootScope.$broadcast("ReloadIssues");
        var msg = $translationService.getTranslationController(
          "Columnas por defecto establecidas",
          "Default columns set",
          "Configurações de coluna padrão"
        );
        $toastr.success(msg);
      })
      .catch(function (err) {
        $toastr.error(
          $translationService.getTranslationController(
            "Se ha producido un error, intente de nuevo",
            "An error has occurred, please try again",
            "Ocorreu um erro, por favor, tente novamente"
          )
        );

        console.error("Error@assignCustomColumns", err);
      })
      .finally(function () {
        $rootScope.loading = false;
      });
  }

  vm.assignStatus = function (event) {
    _openAssignationDialog(event, "status");
  };

  vm.assignResponsible = function (event) {
    _openAssignationDialog(event, "responsible");
  };

  vm.assignClasification = function (event) {
    _openAssignationDialog(event, "classification");
  };

  function _openAssignationDialog(event, assignationType) {
    if (!vm.selectedRows.length) {
      $toastr.info(
        $translationService.getTranslationController(
          "Debe seleccionar al menos un registro",
          "You must select at least one record",
          "Você deve selecionar pelo menos um registro"
        )
      );
      return;
    }

    $mdDialog
      .show({
        controller: "IssuesAssignmentDialogController",
        controllerAs: "ctrl",
        templateUrl:
          "app/dashboard/components/issues-assignment-dialog/issues-assignment-dialog.html",
        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: false,
        multiple: true,
        locals: {
          assignationType: assignationType,
          selectedIssues: vm.selectedRows,
          currentIssue: vm.issueType,
        },
      })
      .then(
        function (action) {
          console.log("action", action);
          $rootScope.loading = true;
          $scope.loader.loading = true;
        },
        function () {}
      );
  }

  vm.reload = function () {
    $rootScope.loading = true;
    $scope.loader.loading = true;
    $timeout(function () {
      vm.getIssues(vm.filters)
        .then(function (res) {
          vm.gridOptions.totalItems = res.pagination.totalRecords;
          vm.gridOptions.data = res.data;
          vm.gridOptions.footerData = res.footer;
          _renderTable(res.columns);
        })
        .finally(function () {
          _autoSelectRows();
        });
    }, 500);
  };

  $scope.$on("ReloadIssues", function (e, args) {
    vm.issueCliked = null;
    vm.ShowIssueCliked = false;
    vm.clearSelected();
    vm.reload();
  });

  $scope.$on("issuesDateChange", function (e, dates) {
    vm.filters.from = moment(dates.desde).toISOString();
    vm.filters.to = moment(dates.hasta).toISOString();
    vm.filters.datesInUTC = false;

    if (dates.active == false) {
      delete vm.filters.from;
      delete vm.filters.to;
    }

    vm.getIssues(vm.filters)
      .then(function (res) {
        vm.gridOptions.totalItems = res.pagination.totalRecords;
        vm.gridOptions.data = res.data;
        vm.gridOptions.footerData = res.footer;
        _renderTable(res.columns);
      })
      .finally(function () {
        _autoSelectRows();
      });
  });

  $scope.$on("changeIssuesRelationship", function (e, options) {
    vm.filters.relatedBy = options.relatedBy;

    vm.getIssues(vm.filters)
      .then(function (res) {
        vm.gridOptions.totalItems = res.pagination.totalRecords;
        vm.gridOptions.data = res.data;
        vm.gridOptions.footerData = res.footer;
        _renderTable(res.columns);
      })
      .finally(function () {
        _autoSelectRows();
      });
  });

  vm.getIssues = function (filters) {
    // console.log("Fetching issues with filters:", filters);

    return new Promise(function (resolve, reject) {
      var promises = [$issuesFactory.getIssuesFiltered(filters), _getConfigFormatSchema()];
      Promise.all(promises)
        .then(function (res) {
          var issues = res[0] || [];
          var schemasF = res[1] || [];

          vm.schemasFormat = schemasF;

          if (filters ) {
            var lsFilters = "filters-" + vm.issueType.id + "-" + vm.relatedBy;
            $localStorageService.setItem(lsFilters, filters);
            // console.log("Filters saved in localStorage:", filters);
          }

          resolve({
            columns: issues.columns,
            data: issues.data,
            pagination: issues.pagination,
            footer: setFooter(issues.footer, issues.columns),
          });
        })
        .catch(function (err) {
          $toastr.error(
            $translationService.getTranslationController(
              "No se han podido cargar los datos",
              "Data could not be loaded",
              "Os dados não puderam ser carregados"
            )
          );
          console.error("Error@getIssuesFiltered", err);

          reject();
        });
    });
  };

  vm.getIssuesCSV = function (filters) {
    return new Promise(function (resolve, reject) {
      $issuesFactory
        .getIssuesFilteredV2(filters)
        .then(function (res) {
          resolve(res);
        })
        .catch(function (err) {
          $toastr.error(
            $translationService.getTranslationController(
              "No se han podido cargar los datos",
              "Data could not be loaded",
              "Os dados não puderam ser carregados"
            )
          );
          console.error("Error@getIssuesFiltered", err);

          reject();
        });
    });
  };

  vm.showIssue = function (ev, selectedIssue) {
    vm.issueCliked = null;
    vm.ShowIssueCliked = false;
    setTimeout(function () {
      vm.manageIssueFn({ ev: ev, selectedIssue: selectedIssue });
    }, 100);
  };

  vm.sideView = function (ev, issue) {
    vm.ShowIssueCliked = false;
    setTimeout(function () {
      vm.issueCliked = issue;
      vm.ShowIssueCliked = true;
    }, 100);
  };

  vm.addFilterTo = function (event, col) {
    var selectedColumnFilters = vm.columnfilters.find(function (e) {
      return e.field == col.key || e.label == col.name;
    });

    if (!selectedColumnFilters) {
      $toastr.warning(
        $translationService.getTranslationController(
          "No hay filtros disponibles para la columna ",
          "There is no filters available for column ",
          "Não há filtros disponíveis para coluna "
        ) + col.name
      );
      return;
    }

    $mdDialog
      .show({
        controller: "IssuesFiltersDialogController",
        controllerAs: "ctrl",
        templateUrl: "app/dashboard/components/issues-filters-dialog/issues-filters-dialog.html",

        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: false,
        locals: {
          column: col,
          columnFilters: selectedColumnFilters,
        },
      })
      .then(function (predicate) {
        vm.filters.predicates.push(predicate);

        $rootScope.loading = true;
        $scope.loader.loading = true;
        vm.getIssues(vm.filters)
          .then(function (res) {
            vm.gridOptions.totalItems = res.pagination.totalRecords;
            vm.gridOptions.data = res.data;
            vm.gridOptions.footerData = res.footer;
            _renderTable(res.columns);
          })
          .catch(function (err) {
            console.error("Error@getIssues", err);
          })
          .finally(function () {
            _autoSelectRows();
          });
      });
  };

  vm.removeFilter = function (index) {
    if (index == "ALL") {
      vm.filters.predicates = [];
    } else {
      vm.filters.predicates.splice(index, 1);
    }

    $rootScope.loading = true;
    $scope.loader.loading = true;
    vm.getIssues(vm.filters)
      .then(function (res) {
        vm.gridOptions.totalItems = res.pagination.totalRecords;
        vm.gridOptions.data = res.data;
        vm.gridOptions.footerData = res.footer;
        _renderTable(res.columns);
      })
      .catch(function (err) {
        console.error("Error@getIssues", err);
      })
      .finally(function () {
        _autoSelectRows();
      });
  };

  vm.clearSelected = function () {
    $scope.gridApi.selection.clearSelectedRows();
    vm.selectedRows = [];
  };

  vm.saveView = function () {
    alert("Not implemented yet");
  };

  function getHeaderDefinition(col) {
    var headSchema =
      vm.gridOptions.data.length > 0 && vm.gridOptions.data[0] && vm.gridOptions.data[0].headSchema
        ? vm.gridOptions.data[0].headSchema
        : null;

    if (!headSchema) return null;

    var name = headSchema ? headSchema.name : null;
    var schema = headSchema ? headSchema.schema : null;
    var parseSchema = JSON.parse(schema);
    var colField = col.key.replace("#", "").replace("header/", "");
    return parseSchema.definitions[name].properties[colField];
  }

  function getBodyDefinition(col) {
    var bodySchema =
      vm.gridOptions.data.length > 0 && vm.gridOptions.data[0] && vm.gridOptions.data[0].bodySchema
        ? vm.gridOptions.data[0].bodySchema
        : null;

    var name = bodySchema && bodySchema.name ? bodySchema.name : null;
    var schema = bodySchema.schema;
    var parseSchema = JSON.parse(schema);
    var colField = col.key.replace("#", "").replace("body/", "");
    return parseSchema.definitions[name].properties[colField];
  }

  function _renderTable(customColumns) {
    var tableColumns = [];
    var tableDefaultColumns = [
      {
        key: "description",
        name: "Description",
        displayName: $translationService.getTranslationController(
          "Descripción",
          "Description",
          "Descrição"
        ),
        field: "description",
        width: "15%",
      },
      {
        key: "classification",
        name: "Classification",
        displayName: $translationService.getTranslationController(
          "Clasificación",
          "Classification",
          "Classificação"
        ),
        field: "classification.name",
      },
      {
        key: "createdAt",
        name: "CreatedAt",
        displayName: $translationService.getTranslationController(
          "Creado el (UTC)",
          "Created at (UTC)",
          "Criado em (UTC)"
        ),
        field: "createdAt",
        width: "140",
        dataType: 'date: "dd/MM/yy HH:mm"',
      },
      {
        key: "createdAtLocal",
        name: "CreatedAtLocal",
        displayName: $translationService.getTranslationController(
          "Creado el",
          "Created at",
          "Criado em"
        ),
        field: "createdAtLocal",
        width: "140",
        dataType: 'date: "dd/MM/yy HH:mm"',
      },
      {
        key: "createdBy",
        name: "CreatedBy",
        displayName: $translationService.getTranslationController(
          "Creado por",
          "Created by",
          "Criado por"
        ),
        field: "createdBy.name",
      },
      {
        key: "source",
        name: "Source",
        displayName: $translationService.getTranslationController("Origen", "Source", "Origemr"),
        field: "source",
        width: "75",
      },
      {
        key: "assigned",
        name: "Assigned",
        displayName: $translationService.getTranslationController(
          "Asignado",
          "Assigned",
          "Atribuído"
        ),
        field: "assigned.name",
      },
      { key: "supervisor", name: "Supervisor", field: "supervisor.name" },
      {
        key: "category",
        name: "Category",
        displayName: $translationService.getTranslationController(
          "Categoría",
          "Category",
          "Categoria"
        ),
        field: "category.name",
        width: "100",
      },
      {
        key: "criticality",
        name: "Criticality",
        displayName: $translationService.getTranslationController(
          "Criticidad",
          "Criticality",
          "Criticidade"
        ),
        field: "criticality.name",
        width: "100",
      },
      {
        key: "status",
        name: "Status",
        displayName: $translationService.getTranslationController("Estado", "Status", "Status"),
        field: "status.name",
      },
      {
        key: "evidence_total",
        name: "Evidences",
        displayName: $translationService.getTranslationController(
          "Evidencias",
          "Evidences",
          "Evidências"
        ),
        field: "evidence_total",
      },
      {
        key: "group",
        name: "Group",
        displayName: $translationService.getTranslationController("Grupo", "Group", "Grupo"),
        field: "group.name",
      },
    ];
    // console.log('customColumns', customColumns);
    // Determine table columns
    if (customColumns.length) {
      angular.forEach(customColumns, function (col) {
        // console.log(col);

        var defaultField = tableDefaultColumns.find(function (e) {
          return e.key == col.key;
        });

        if (defaultField) {
          defaultField.sortable = col.sortable;
          tableColumns.push(defaultField);
        } else {
          var aux = {};
          if (col.key.includes("header/")) {
            var headerDefinition = getHeaderDefinition(col);
            aux = Object.assign(col, headerDefinition);
          }

          if (col.key.includes("body/")) {
            var bodyDefinition = getBodyDefinition(col);
            aux = Object.assign(col, bodyDefinition);
          }

          tableColumns.push({
            key: col.key,
            name: col.key,
            displayName: col.label,
            field: col.key,
            sortable: col.sortable,
            type: col.type,
            aux: aux,
          });
        }
      });
    } else {
      tableColumns = tableDefaultColumns;
    }

    vm.gridOptions.columnDefs = [];
    var columnDefs = [];

    tableColumns
      .filter(function (col) {
        return col.key != "footer";
      })
      .forEach(function (col) {
        // console.log(col);

        var currentColumnDefinition = {
          name: col.key,
          field: _getColField(col),
          width: col.width || 100,
          visible: col.visible || true,
          cellFilter: col.dataType || $tableListConstants.cellFilters[col.type] || null,
          headerTooltip: col.name,
          footerCellTemplate:
            '<div class="ui-grid-cell-contents"> {{ grid.appScope.ctrl.gridOptions.footerData[col.field] | numberFormater }}</div>',
          // General col properties
          enableColumnMenu: true,
          enableSorting: col.sortable,
          enableHiding: false,
          aux: col.aux,
          // Menu
          menuItems: [
            {
              title: $translationService.getTranslationController("Filtrar", "Filter", "Filtro"),
              icon: "ui-grid-icon-filter",
              shown: function () {
                var hasFilters =
                  vm.columnfilters &&
                  vm.columnfilters.find(function (e) {
                    return e.field == col.key || e.label == col.name;
                  });

                return hasFilters ? true : false;
              },
              action: function ($event) {
                this.context.addFilterTo($event, col);
              },
              context: vm,
            },
          ],
        };

        var isDefaultColumn = tableDefaultColumns.find(function (e) {
          return e.key == col.key;
        });

        if (col.name == "Criticality") {
          currentColumnDefinition.cellTemplate =
            '<span> <cep-icon icon="{{COL_FIELD.icon}}" color="{{COL_FIELD.color}}"></cep-icon>  {{COL_FIELD.name}}</span>';
        } else if (!isDefaultColumn) {
          currentColumnDefinition.cellTemplate = $cellTemplateFormatService.setTemplate(
            currentColumnDefinition,
            col,
            vm.schemasFormat
          );
        }

        if (col.displayName) {
          // console.log(col);
          currentColumnDefinition.displayName = col.displayName;
        }

        columnDefs.push(currentColumnDefinition);
      });

    vm.gridOptions.columnDefs = columnDefs;
    _totalFooterColumns();
  }

  function _totalFooterColumns() {
    // console.log(
    //   "Calculating total footer columns",
    //   vm.gridOptions.columnDefs,
    //   vm.gridOptions.footerData,
    //   vm.gridOptions.data
    // );
    for (var key in vm.gridOptions.footerData) {
      // console.log("key", key);
      var values = vm.gridOptions.data.map(function (c) {
        return c[key];
      });

      var total = values.reduce(function (acc, val) {
        return acc + (isNaN(val) ? 0 : Number(val));
      }, 0);
      // console.log(total);

      vm.gridOptions.footerData[key] = total;
    }
    // console.log("Final footer data", vm.gridOptions.footerData);
  }

  function _getColField(col) {
    if (col.type == "reference") {
      return col.field;
    }

    if (col.name == "Criticality") {
      return col.field.split(".")[0];
    }

    return col.field;
  }

  $scope.$watchCollection("ctrl.issueType.predicates", function (newPredicates) {
    $rootScope.loading = true;
    $scope.loader.loading = true;
    var lsFilters = "filters-" + vm.issueType.id + "-" + vm.relatedBy;
    var filtersInLS = $localStorageService.getItem(lsFilters);
    
    if (newPredicates == undefined) {
      vm.filters.predicates = [];
    } else {
      vm.filters.predicates = newPredicates;
    }
    
    if(filtersInLS) {
      vm.filters = filtersInLS;
      vm.filters.predicates = Array.isArray(newPredicates) && newPredicates.length > 0 ? newPredicates: filtersInLS.predicates
      vm.filters.issueTypeId = vm.issueType.id;
    }
    
    vm.getIssues(vm.filters)
      .then(function (res) {
        vm.gridOptions.totalItems = res.pagination.totalRecords;
        vm.gridOptions.data = res.data;
        vm.gridOptions.footerData = res.footer || {};
        _renderTable(res.columns);
        _hasCorreltiveFilter();
      })
      .catch(function (err) {
        console.error("Error@getIssues", err);
      })
      .finally(function () {
        _autoSelectRows();
      });
  });

  function _hasCorreltiveFilter() {
    if ($stateParams.filters == null || $stateParams.filters.correlative == null) return;
    var correlative = $stateParams.filters.correlative;
    var issue = vm.gridOptions.data.find(function (item) {
      return item.correlative == correlative;
    });
    if (!issue) return;
    vm.showIssue(null, issue);
  }

  function _removeDuplicatesByUuid(array) {
    var uniqueIds = [];

    return array.filter(function (element) {
      var isDuplicate = uniqueIds.includes(element.uuid);

      if (!isDuplicate) {
        uniqueIds.push(element.uuid);

        return true;
      }

      return false;
    });
  }

  function _autoSelectRows() {
    setTimeout(function () {
      vm.gridOptions.data.forEach(function (row) {
        var autoselect = vm.selectedRows.some(function (r) {
          return r.uuid == row.uuid;
        });
        if (autoselect) $scope.gridApi.selection.selectRow(row);
      });
      $rootScope.loading = false;
      $scope.loader.loading = false;
    }, 1000);
  }

  function _getConfigFormatSchema() {
    return new Promise(function (resolve, reject) {
      $ConfigurationFactory
        .getSchemaFormat()
        .then(function (res) {
          if (res.data.length == 0) {
            resolve([]);
          }
          var schemaMap = res.data.map(function (schema) {
            schema.body = JSON.parse(schema.body);
            return schema;
          });
          resolve(schemaMap);
        })
        .catch(function (err) {
          console.error("Error@getSchemaFormat", err);
          reject(err);
        });
    });
  }

  function setFooter(footer, columns) {
    // console.log(footer, columns);
    var ignoreColumns = ["criticality", "status", "assigned", "classification", "createdBy"];
    var columnsNumeric = columns.filter(function (col) {
      return (
        ["number", "integer", "double", "long"].includes(col.type) &&
        !ignoreColumns.includes(col.key)
      );
    });

    return Object.keys(footer).length > 0
      ? footer
      : columnsNumeric.reduce(function (acc, col) {
          acc[col.key] = 0;
          return acc;
        }, {});
  }
}

/* Servicio encargado de hacer operaciones con fechas */

(function () {
  'use strict';

  angular
    .module('dashboard')
    .service('IssuesListExporterService', IssuesListExporter);

  IssuesListExporter.$inject = ['FileSaver'];
  function IssuesListExporter($fileSaver) {
    this.exportCSV = function (extention, columns, data, columnDefs, prefix) {
      var prefixFileName = prefix ? prefix : 'issues';
      var fileName = getFileName(prefixFileName);
      var excel = { fileName: fileName, data: 'sep=, \n' + data };

      $fileSaver.saveAs(
        new Blob([excel.data], { type: 'application/octet-stream' }),
        excel.fileName + '.' + extention
      );
    };

    this.exportFile = function (extention, columns, data, columnDefs, prefix) {
      var dataToExport = [];
      var prefixFileName = prefix ? prefix : 'issues';
      var fileName = getFileName(prefixFileName);
      var headers = getHeaders(columns);
      var flattenedData = flatData(data, columnDefs);
      var cols = getCols(columns);
      var rows = getRows(flattenedData, cols);
      var wb = new Workbook();

      dataToExport.push(headers);
      var excel = { fileName: fileName, data: dataToExport.concat(rows) };
      var ws = getSheet(excel.data);

      /* add worksheet to workbook */
      wb.SheetNames.push(excel.fileName);
      wb.Sheets[excel.fileName] = ws;

      try {
        var wbout = XLSX.write(wb, {
          bookType: extention,
          bookSST: true,
          type: 'binary',
        });
        $fileSaver.saveAs(
          new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
          excel.fileName + '.' + extention
        );
      } catch (e) {
        console.log(e);
        $toastr.info('Se ha producido un error al exportar');
      }
      data = null;
      wbout = null;
    };

    function getRows(data, cols) {
      return data.map(function (e) {
        return eval(cols);
      });
    }

    function getCols(columns) {
      var cols = '';

      angular.forEach(columns, function (col) {
        var col = col.name ? col.name : col.key;
        cols += "e['" + col + "'],";
      });

      return '[' + cols + ']';
    }

    function getFileName(fileName) {
      var dateStamp = moment().format('YYYYMMDD_hhmmss');

      if (fileName.length > 31) {
        fileName = fileName.substring(-1, 31);
      }

      return fileName + '_' + dateStamp;
    }

    function getHeaders(columns) {
      var headers = columns.map(function (e) {
        return e.displayName || e.name || e.label;
      });

      return headers;
    }

    function flatData(data, columnDefs) {
      var flattenedData = data.map(function (val) {
        angular.forEach(val, function (value, key) {
          var _key = key.replace('#', '');

          var colDef = columnDefs.find(function (e) {
            return e.name == _key;
          });

          if (_key === 'criticality') {
            val[_key] = value.name;
          } else if (colDef && colDef.cellFilter == 'date: "dd/MM/yy HH:mm"') {
            val[_key] = moment(value).format('YYYY-MM-DDTHH:mm:ss.SSS');
          } else if (colDef && angular.isObject(value)) {
            var field = colDef.field.split('.');
            field = field[field.length - 1];

            val[_key] = value[field];
          } else {
            val[_key] = value;
          }
        });

        return val;
      });

      return flattenedData;
    }

    function getSheet(data) {
      var ws = {};
      var range = { s: { c: 10000000, r: 10000000 }, e: { c: 0, r: 0 } };

      for (var R = 0; R != data.length; ++R) {
        var C = -1;
        angular.forEach(data[R], function (col, key) {
          ++C;
          if (range.s.r > R) range.s.r = R;
          if (range.s.c > C) range.s.c = C;
          if (range.e.r < R) range.e.r = R;
          if (range.e.c < C) range.e.c = C;

          var cell = { v: data[R][key] };
          if (cell.v != null) {
            var cell_ref = XLSX.utils.encode_cell({ c: C, r: R });

            if (typeof cell.v === 'number') cell.t = 'n';
            else if (typeof cell.v === 'boolean') cell.t = 'b';
            else if (cell.v instanceof Date) {
              cell.t = 'n';
              cell.z = XLSX.SSF._table[14];
              cell.v = datenum(cell.v);
            } else cell.t = 's';

            ws[cell_ref] = cell;
          }
        });
      }
      if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
      return ws;
    }

    function datenum(v, date1904) {
      if (date1904) v += 1462;
      var epoch = Date.parse(v);
      return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
    }

    function Workbook() {
      if (!(this instanceof Workbook)) return new Workbook();
      this.SheetNames = [];
      this.Sheets = {};
    }

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('IssuesFiltersDialogController', IssuesFiltersDialogController);

  IssuesFiltersDialogController.$inject = [
    '$scope',
    '$mdDialog',
    'translationService',
    'column',
    'columnFilters',
  ];
  function IssuesFiltersDialogController(
    $scope,
    $mdDialog,
    $translationService,
    column,
    columnFilters
  ) {
    var vm = this;
    $translationService.getTranslation(vm, 'filters-dialog');
    vm.column = column;
    vm.columnFilters = columnFilters;

    vm.types = {
      time: 'time',
      date: 'date',
      timestamp: 'timestamp',
    };

    var defaultValue = {
      // calendar: new Date(),
      boolean: false,
    };

    vm.predicate = {
      label: vm.columnFilters.label,
      fieldName: vm.columnFilters.field,
      operation: vm.columnFilters.operations[0],
      values: ['TEXT', 'text', 'NUMBER', 'number', 'string'].includes(
        vm.columnFilters.component
      )
        ? [null, null]
        : null,
      value: defaultValue[vm.columnFilters.component] || null,
      type: column.type,
      valuesLabels: null,
    };

    vm.onPredicateValuesChanges = function () {
      if (vm.predicate.values != null) {
        vm.predicate.valuesLabels = vm.predicate.values.map(function (e) {
          return vm.columnFilters.metadata.find(function (i) {
            return i.key == e;
          })['value'];
        });
      }
    };

    vm.isDisabled = true;

    $scope.$watch(
      'ctrl.predicate',
      function (nval) {
        vm.isDisabled = false
        var operation = ['BETWEEN', 'IN'].includes(nval.operation);
        var check = ['selection','calendar','number']

        if (check.includes(vm.columnFilters.component) && operation ) {
          var _values_ = Object.values(nval.values);
          vm.isDisabled = _values_.length == 2 && _values_.includes(null);
          return
        }

        if (nval.value == null) vm.isDisabled = true;
        else vm.isDisabled = nval.value == null;
      },
      true
    );

    vm.onchangeOperation = function () {
      var operation = ['BETWEEN', 'IN'].includes(vm.predicate.operation);
      if (operation) {
        vm.predicate.value = null;
      } else {
        vm.predicate.values = [
          'TEXT',
          'text',
          'NUMBER',
          'number',
          'string',
        ].includes(vm.columnFilters.component)
          ? [null, null]
          : null;
      }
    };

    function momentByType(value) {
      if (column.type == 'date') return moment(value).format('YYYY-MM-DD');
      else if (column.type == 'timestamp')
        return moment(value).format('YYYY-MM-DDT00:00:00.000Z');
      else return value;
    }

    vm.applyFilters = function () {
      var predicates = angular.copy(vm.predicate);
      predicates.component = vm.columnFilters.component;
      if (vm.columnFilters.component == 'calendar') {
        if (predicates.operation == 'BETWEEN') {
          predicates.values = Object.values(predicates.values).map(function (e) {
            return momentByType(e);
          });
        } else {
          predicates.value = momentByType(predicates.value);
        }
      }

      $mdDialog.hide(predicates);
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller("IssuesDetailDialogController", IssuesDetailDialogController);

  IssuesDetailDialogController.$inject = [
    "$scope",
    "$rootScope",
    "$mdDialog",
    "$mdSidenav",
    "toastr",
    "translationService",
    "timezoneService",
    "IssuesFactory",
    "UserFactory",
    "ReferencesFactory",
    "PermissionsFactory",
    "issueTypes",
    "currentIssueType",
    "issue",
    "issuesToLink",
    "currentCategory",
    "GroupFactory",
    "SchemasService",
  ];
  function IssuesDetailDialogController(
    $scope,
    $rootScope,
    $mdDialog,
    $mdSidenav,
    $toastr,
    $translationService,
    $timezoneService,
    $issuesFactory,
    $userFactory,
    $referencesFactory,
    $permissionsFactory,
    issueTypes,
    currentIssueType,
    issue,
    issuesToLink,
    currentCategory,
    $groupFactory,
    $schemasService
  ) {
    $scope.dialogId = new Date().getTime();
    var vm = this;
    $translationService.getTranslation(vm, "issues");

    vm.gridOptions = {
      multiSelect: true,
      enableFullRowSelection: true,
      data: [],
    };

    vm.users = [];
    vm.issueTypes = issueTypes;

    vm.currentIssueType = currentIssueType;

    vm.hasPermissionIssueType = $permissionsFactory.hasPermission(
      "issues-type#" + vm.currentIssueType.id + ":" + "update"
    );
    vm.hasPermissionReadUser = $permissionsFactory.hasPermission(
      "user:read"
    );

    vm.classifications = vm.currentIssueType.classifications;
    vm.criticalities = vm.currentIssueType.criticalities;
    vm.status = vm.currentIssueType.status;

    vm.currentCategory = currentCategory;

    vm.issueReferences = {
      loading: true,
      data: [],
    };

    vm.issuesToLink = [];

    vm.issueActivityLog = {
      pagination: {
        itemsPerPage: 15,
        page: 1,
        sort: "asc",
        totalRecords: 0,
      },
      gridOptions: {
        useExternalPagination: true,
        paginationPageSizes: [15, 20, 25],
        paginationPageSize: 15,
        totalItems: 0,
        columnDefs: [
          {
            name: "Date",
            field: "createdAt",
            cellFilter: 'date: "dd/MM/yyyy HH:mm"',
            width: 150,
            enableColumnMenu: false,
            enableSorting: false,
          },
          {
            name: "User",
            field: "createdBy",
            width: 250,
            enableColumnMenu: false,
            enableSorting: false,
          },
          {
            name: "Operation",
            field: "operation",
            width: 150,
            enableColumnMenu: false,
            enableSorting: false,
          },
          {
            name: "Field",
            field: "fieldName",
            width: 150,
            enableColumnMenu: false,
            enableSorting: false,
          },
          { name: "New_Value", field: "newValue", enableColumnMenu: false },
        ],
        onRegisterApi: function (gridApi) {
          gridApi.pagination.on.paginationChanged(
            $scope,
            function (newPage, pageSize) {
              vm.issueActivityLog.pagination.page = newPage;
              vm.issueActivityLog.pagination.itemsPerPage = pageSize;
              $rootScope.loading = true;
              _getIssueActivityLog(vm.issue.uuid).finally(function () {
                $rootScope.loading = false;
              });
            }
          );
        },
      },
    };

    vm.counters = {
      evidences: 0,
      links: 0,
      files: 0,
      comments: 0,
      guests: 0,
    };

    vm.issueReport = angular.copy(issue);
    vm.issue = _parseIssue(issue);

    vm.issueIsLocked = vm.issue.locked || false;
    vm.issueType = vm.issue.locked || false;

    vm.issue.linkedIssueType = _expandLinkedIssueTypes(
      vm.issue.linkedIssueType,
      vm.issueTypes
    );

    vm.isUpdate = vm.issue.uuid ? true : false;

    vm.$onInit = function () {
      $rootScope.loading = true;
      var promises = [];

      if (issuesToLink) {
        vm.issuesToLink = issuesToLink;
      }

      promises.push(_getIssueTabCounter(vm.issue.uuid));
      promises.push(_getCategoryUsers());
      promises.push(_getUsersGroups());

      if (vm.issue.uuid) {
        promises.push(_getIssueReferences(vm.issue.uuid));
        promises.push(_getIssueActivityLog(vm.issue.uuid));
        promises.push(_getLinkedIssuesType(vm.issue.uuid));

        if (!vm.issue.viewed) {
          promises.push(_markIssueAsSeen(vm.issue.uuid, true));
        }
      }

      Promise.allSettled(promises)
        .then(function (results) {
          vm.counters =
            results[0].status === "fulfilled" ? results[0].value : [];
          vm.users = results[1].status === "fulfilled" ? results[1].value : [];
          vm.groups = results[2].status === "fulfilled" ? results[2].value : [];
        })
        .catch(function (err) {
          console.log("ErrorPromise", err);
        })
        .finally(function () {
          $rootScope.loading = false;
        });
    };

    $scope.$on("LinkIssuesToParent", function (event, data) {
      if (data.parentIssueUuid == vm.issue.uuid) {
        // Filter issues previosly added
        data.issuesToLink = data.issuesToLink.filter(function (e) {
          return !vm.issuesToLink
            .map(function (e) {
              return e.uuid;
            })
            .includes(e.uuid);
        });

        vm.issuesToLink = vm.issuesToLink.concat(data.issuesToLink);
      }
    });

    function _markIssueAsSeen(issueUuid, seen) {
      return new Promise(function (resolve, reject) {
        $issuesFactory
          .markIssueAsSeen(issueUuid, seen)
          .then(function () {
            resolve();
            $rootScope.$broadcast("ReloadIssues");
          })
          .catch(function (err) {
            console.log("Error@markIssueAsSeen", err);
            reject();
          });
      });
    }

    function _getIssueReferences(issueUuid) {
      return new Promise(function (resolve, reject) {
        $referencesFactory
          .getIssueReferencesCount(issueUuid)
          .then(function (res) {
            vm.issueReferences.data = res;
            resolve();
          })
          .catch(function (err) {
            console.log("Error@getIssueReferencesCount", err);
            reject();
          })
          .finally(function () {
            vm.issueReferences.loading = false;
          });
      });
    }

    function _getIssueActivityLog(issueUuid) {
      return new Promise(function (resolve, reject) {
        $issuesFactory
          .getActivityLog(issueUuid, vm.issueActivityLog.pagination)
          .then(function (res) {
            vm.issueActivityLog.pagination = res.data.pagination;
            vm.issueActivityLog.gridOptions.data = res.data.data;
            vm.issueActivityLog.gridOptions.totalItems =
              res.data.pagination.totalRecords;

            resolve();
          })
          .catch(function (err) {
            console.log("Error@getActivityLog", err);
            reject();
          });
      });
    }

    function _getLinkedIssuesType(issueUuid) {
      return new Promise(function (resolve, reject) {
        $issuesFactory
          .getLinkedIssuesType(issueUuid)
          .then(function (res) {
            vm.issue.linkedIssueType = res.data;
            resolve();
          })
          .catch(function (err) {
            console.log("Error@getActivityLog", err);
            reject();
          });
      });
    }

    function _getIssueTabCounter(issueUuid) {
      if (!vm.isUpdate) return;
      if (!issueUuid) return;
      return new Promise(function (resolve, reject) {
        $issuesFactory
          .getIssueTabCounter(issueUuid)
          .then(function (res) {
            vm.counters = res;
            resolve(res);
          })
          .catch(function (err) {
            console.log("Error@getIssueTabCounter", err);
            reject();
          });
      });
    }

    function _getCategoryUsers() {
      return $userFactory
        .getUsers({
          categoryId: vm.currentIssueType.category.id,
          active: true,
          itemsPerPage: 1000,
        })
        .then(function (res) {
          var users = res.data.data || [];
          users = users.map(function (e) {
            return {
              userId: e.userId,
              fullName: e.fullName,
              color: e.color,
            };
          });

          if (
            vm.issue.assigned &&
            !users.find(function (e) {
              return e.userId == vm.issue.assigned.userId;
            })
          ) {
            users.unshift({
              userId: vm.issue.assigned.userId,
              fullName: vm.issue.assigned.fullName,
              color: vm.issue.assigned.color,
            });
          }

          return users;
        })
        .catch(function (e) {
          console.log("Error@getUsers", e);
        });
    }

    function _getUsersGroups() {
      return $groupFactory
        .getAllGroups({
          active: true,
          itemsPerPage: 1000,
        })
        .then(function (res) {
          return res.data || [];
        })
        .catch(function (e) {
          console.log("Error@getUsersGroups", e);
        });
    }

    function _parseIssue(issueData) {
      var _issue = {};

      if (issueData) {
        _issue = angular.copy(issueData);
      } else {
        _issue.issueType = angular.copy(vm.currentIssueType);
        _issue.criticality = angular.copy(vm.currentIssueType.criticalities[0]);
        _issue.headSchema = angular.copy(vm.currentIssueType.headSchema);
        _issue.bodySchema = angular.copy(vm.currentIssueType.bodySchemas[0]);
      }

      return _issue;
    }

    function _expandLinkedIssueTypes(linkedIssueTypes, issueTypes) {
      var expandedLinkedIssueTypes = [];

      if (linkedIssueTypes) {
        linkedIssueTypes.forEach(function (linkedType) {
          var expandedType = issueTypes.find(function (type) {
            return type.id == linkedType.id;
          });
          if (expandedType) {
            expandedLinkedIssueTypes.push(expandedType);
          }
        });
      }
      return expandedLinkedIssueTypes;
    }

    vm.changeIssueType = function (id) {
      vm.issue.issueType = angular.copy(
        vm.issueTypes.find(function (e) {
          return e.id == id;
        })
      );

      vm.currentIssueType = vm.issue.issueType;
      vm.classifications = vm.currentIssueType.classifications;
      vm.criticalities = vm.currentIssueType.criticalities;
      vm.status = vm.currentIssueType.status;

      vm.issue.criticality = angular.copy(vm.currentIssueType.criticalities[0]);
      vm.issue.headSchema = angular.copy(vm.currentIssueType.headSchema);
      vm.issue.bodySchema = angular.copy(vm.currentIssueType.bodySchemas[0]);
      vm.setBodySchema(vm.issue.bodySchema);
    };

    vm.setBodySchema = function (schema) {
      vm.issue.bodySchema = schema;
    };

    vm.saveAsDraft = function () {
      alert("Servicio no implementado");
    };

    $scope.validatePermission = function () {
      return $permissionsFactory.hasPermission(
        "issues-type#" + vm.currentIssueType.id + ":" + "update"
      );
    };

    vm.saveIssue = function () {
      if ($scope.validatePermission() == false) {
        $toastr.error(
          $translationService.getTranslationController(
            "No tienes permisos para realizar esta acción",
            "You do not have permission to perform this action",
            "Você não tem permissão para executar esta ação"
          )
        );
        return;
      }

      if (vm.issuesToLink && vm.issuesToLink.length) {
        var confirm = $mdDialog
          .confirm()
          .multiple(true)
          .title(
            $translationService.getTranslationController(
              "¿seguro Quieres vincular " +
                vm.issuesToLink.length +
                " issues?",
              "are you sure you want to link " +
                vm.issuesToLink.length +
                " issues?",
              "tem certeza de que deseja atribuir " +
                vm.issuesToLink.length +
                " issues ?"
            )
          )
          .htmlContent(
            $translationService.getTranslationController(
              "Los cambios se ejecutarán de forma masiva",
              "The changes will be executed in bulk",
              "As alterações serão executadas em massa"
            )
          )
          .ariaLabel("ClearAll-Confirmation")
          .targetEvent(null)
          .ok(
            $translationService.getTranslationController(
              "Si, vincular " + vm.issuesToLink.length + " issues",
              "Yes, link " + vm.issuesToLink.length + " issues",
              "Sim, vincular " + vm.issuesToLink.length + " issues"
            )
          )
          .cancel(
            $translationService.getTranslationController(
              "Aún no",
              "Not yet",
              "Ainda não"
            )
          );

        $mdDialog.show(confirm).then(
          function () {
            if (vm.isUpdate) {
              vm.updateIssue();
            } else {
              vm.createIssue();
            }
          },
          function () {
            vm.cancel();
          }
        );
      } else {
        if (vm.isUpdate) {
          vm.updateIssue();
        } else {
          vm.createIssue();
        }
      }
    };

    vm.updateIssue = function () {
      var _issue = _prepareDataToSaveIssue(vm.issue);
      var _bodySchema = _issue.bodySchema.schema;
      var _headSchema = _issue.headSchema.schema;

      $rootScope.loading = true;
      $issuesFactory
        .updateIssue(_issue.uuid, _issue)
        .then(function () {
          _updateOriginalIssueData(_issue);

          if (vm.issuesToLink && vm.issuesToLink.length) {
            _linkIssues();
          }

          vm.issuesToLink = [];

          $rootScope.$broadcast("ReloadIssues");
          $toastr.success(
            $translationService.getTranslationController(
              "Issue actualizado",
              "Issue updated",
              "Issue atualizado"
            )
          );
          $rootScope.loading = false;
        })
        .catch(function (err) {
          console.log("Err@updateIssue", err);
          var msg = typeof err.data === "string" ? err.data : "";
          $toastr.error(
            $translationService.getTranslationController(
              "Error actualizando issue. " + msg,
              "Error updating issue. " + msg,
              "Erro ao atualizar problema. " + msg
            )
          );
        })
        .finally(function () {
          $rootScope.loading = false;
        });
    };

    vm.createIssue = function () {
      if (_validateIssueRequiredData(vm.issue)) {
        var _issue = _prepareDataToSaveIssue(vm.issue);
        _issue.createdAtLocal = $timezoneService.getUserCurrentISOString();
        _issue.createdAtTZ = "GMT" + $timezoneService.getUserTimeZoneOffset();

        $rootScope.loading = true;
        $issuesFactory
          .createIssue(_issue)
          .then(function (res) {
            vm.issue.uuid = res.data.uuid;
            vm.issue.status = res.data.status;
            vm.issue.classification = res.data.classification;
            vm.isUpdate = true;

            if (vm.issuesToLink && vm.issuesToLink.length) {
              _linkIssues();
            }

          vm.issuesToLink = [];

            vm.issueReport = angular.copy(vm.issue);
            _getIssueReferences(vm.issue.uuid);
            $rootScope.$broadcast("ReloadIssues");
            $toastr.success(
              $translationService.getTranslationController(
                "Issue creado",
                "Issue created",
                "Issue criado"
              )
            );
            $rootScope.loading = false;
          })
          .catch(function (err) {
            console.log("Err@createIssue", err);
            var msg = angular.isString(err.data) ? err.data : "";
            $toastr.error(
              $translationService.getTranslationController(
                "Error creando issue. " + msg,
                "Error creating issue. " + msg,
                "Erro ao criar problema. " + msg
              )
            );
            $rootScope.loading = false;
          });
      }
    };

    function _linkIssues() {
      $rootScope.loading = true;
      $issuesFactory
        .linkIssues(vm.issue.uuid, vm.issuesToLink)
        .then(function () {
          $toastr.success(
            $translationService.getTranslationController(
              "Issues vinculados",
              "Issues linked",
              "Problemas vinculados"
            )
          );
        })
        .catch(function (err) {
          console.log("Err@linkIssues", err);
        })
        .finally(function () {
          $rootScope.loading = false;
        });
    }

    function _validateIssueRequiredData(issueData) {
      if (!issueData.issueType) {
        $toastr.warning(
          $translationService.getTranslationController(
            "Tipo de problema requerido",
            "Issue type required",
            "Tipo de problema requerido"
          )
        );
        return false;
      }

      if (!vm.issue.description || vm.issue.description == "") {
        $toastr.warning(
          $translationService.getTranslationController(
            "Descripción requerida",
            "Description required",
            "Descrição requerida"
          )
        );
        return false;
      }

      if (!issueData.criticality) {
        $toastr.warning(
          $translationService.getTranslationController(
            "Criticidad requerida",
            "Criticality required",
            "Criticidade requerida"
          )
        );
        return false;
      }

      if (vm.isUpdate && !issueData.status) {
        $toastr.warning(
          $translationService.getTranslationController(
            "Estado requerido",
            "Status required",
            "Estado requerido"
          )
        );
        return false;
      }

      if (!vm.issue.assigned) {
        $toastr.warning(
          $translationService.getTranslationController(
            "Asignado requerido",
            "Assigned required",
            "Atribuído requerido"
          )
        );
        return false;
      }

      if (!issueData.classification) {
        $toastr.warning(
          $translationService.getTranslationController(
            "Clasificación requerida",
            "Classification required",
            "Classificação requerida"
          )
        );
        return false;
      }

      return true;
    }

    function normalizeValue(value, type) {
      if (type == "date") {
        value = moment(value).format("YYYY-MM-DD");
      }

      if (type == "timestamp") {
        value = moment(value).format("YYYY-MM-DD HH:mm:ss");
      }
      
      return value;
    }

    function validIssueSchema(objectValues, schema) {
      for (var key in objectValues) {
        var name = key.replace("#", "");
        var type = schema[name].type;
        var value = objectValues[key];
        objectValues[key] = normalizeValue(value, type);
      }
      return objectValues;
    }

    function _prepareDataToSaveIssue(issueData) {
      var _issue = angular.copy(issueData);

      var _headSchema = $schemasService.parseSchema(angular.copy(_issue.headSchema));
      var _bodySchema = $schemasService.parseSchema(angular.copy(_issue.bodySchema));

      _issue.head = validIssueSchema(_issue.head, _headSchema);

      _issue.head = angular.isObject(_issue.head)
        ? angular.toJson(_issue.head)
        : _issue.head;

      _issue.body = validIssueSchema(_issue.body, _bodySchema);

      _issue.body = angular.isObject(_issue.body)
        ? angular.toJson(_issue.body)
        : _issue.body;

      _issue.issueType = vm.issueTypes.find(function (e) {
        return e.id == _issue.issueType.id;
      });

      _issue.criticality = vm.criticalities.find(function (e) {
        return e.id == _issue.criticality.id;
      });

      if (_issue.status) {
        _issue.status = vm.status.find(function (e) {
          return e.id == _issue.status.id;
        });
      }

      _issue.classifications = vm.classifications.find(function (e) {
        return e.id == _issue.classification.id;
      });
      return _issue;
    }

    function _updateOriginalIssueData(updatedIssueData) {
      if (issue) {
        angular.forEach(updatedIssueData, function (value, key) {
          issue[key] = value;
        });
      }
    }

    vm.validatePermission = function (permissions) {
      var flag = false;
      for (var i = 0; i < permissions.length; i++) {
        flag = $permissionsFactory.hasPermission(permissions[i]);
        if (flag == true) {
          return flag;
        }
      }
      return flag;
    };

    vm.report = function (event) {
      $mdDialog.show({
        controller: "IssuesReportDialogController",
        controllerAs: "ctrl",
        templateUrl:
          "app/dashboard/components/issues-report-dialog/issues-report-dialog.html",
        parent: angular.element(document.body),
        targetEvent: event,
        multiple: true,
        clickOutsideToClose: false,
        locals: {
          issue: vm.issueReport,
          currentIssueType: vm.currentIssueType,
        },
      });
    };

    vm.showRelatedContent = function (event) {
      $mdDialog.show({
        controller: "IssuesRelatedContentDialogController",
        controllerAs: "ctrl",
        templateUrl:
          "app/dashboard/components/issue-related-content-dialog/issue-related-content-dialog.html",
        parent: angular.element(document.body),
        targetEvent: event,
        multiple: true,
        clickOutsideToClose: false,
        locals: {
          parentIssueUuid: vm.issue.uuid,
          relatedElements: vm.issueReferences.data,
        },
      });
    };

    vm.toggleSideNav = function () {
      $mdSidenav("issues-sidenav-" + $scope.dialogId).toggle();
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller(
      'IssuesAssignmentDialogController',
      IssuesAssignmentDialogController
    );

  IssuesAssignmentDialogController.$inject = [
    '$rootScope',
    '$mdDialog',
    'toastr',
    'UserFactory',
    'IssuesFactory',
    'assignationType',
    'selectedIssues',
    'currentIssue',
    'translationService',
  ];
  function IssuesAssignmentDialogController(
    $rootScope,
    $mdDialog,
    toastr,
    UserFactory,
    IssuesFactory,
    assignationType,
    selectedIssues,
    currentIssue,
    $translationService
  ) {
    var vm = this;
    vm.assignationType = assignationType;
    vm.selectedIssues = selectedIssues;
    vm.currentCategory = currentIssue.category.id;
    vm.classifications = currentIssue.classifications;
    vm.status = currentIssue.status;
    vm.users = [];

    var actions = {
      responsible: $translationService.getTranslationController(
        'asignar responsable',
        'assign responsible',
        'atribuir responsável'
      ),
      classification: $translationService.getTranslationController(
        'asignar clasificación',
        'assign classification',
        'atribuir classificação'
      ),
      status: $translationService.getTranslationController(
        'asignar estatus',
        'assign status',
        'atribuir status'
      ),
    };

    vm.assignationTitle = actions[assignationType] || "asignar"

    function _getCategoryUsers() {
      return UserFactory.getUsers({
        categoryId: vm.currentCategory,
        active: true,
        page: 1,
        itemsPerPage: 1000,
      })
        .then(function (res) {
          var users = res.data.data;
          if (users) {
            users = users.map(function (e) {
              return { fullName: e.fullName, username: e.username };
            });
          }

          vm.users = users;
        })
        .catch(function (e) {
          console.log('Error@getUsers', e);
        });
    }
    _getCategoryUsers();

    vm.save = function (ev) {
      if (!_validateRequiredFields()) {
        return;
      }


      var type = '?';
      if (vm.assignationType == 'responsible') {
        type = vm.selectedUser;
      }
      if (vm.assignationType == 'classification') {
        type = vm.classifications.find(function (e) {
          return e.id == vm.selectedClassification;
        }).name;
      }
      if (vm.assignationType == 'status') {
        type = vm.status.find(function (e) {
          return e.id == vm.selectedStatus;
        }).name;
      }

      var action = actions[vm.assignationType] || '?';

      var copy = $translationService.getTranslationController(
        '¿ESTÁS SEGURO DE CONTINUAR?',
        'ARE YOU SURE TO CONTINUE?',
        'TEM CERTEZA QUE CONTINUA?'
      );

      var confirm = $mdDialog
        .confirm()
        .multiple(true)
        .title(
          $translationService.getTranslationController(
            '¡IMPORTANTE!',
            'IMPORTANT!',
            'IMPORTANTE!'
          )
        )
        .htmlContent(
          $translationService.getTranslationController(
            'La acción que realizarás a continuación de ' +
              action +
              ' a  <strong>' +
              type +
              '</strong>, afectará en forma masiva a <strong>' +
              selectedIssues.length +
              '</strong> issues y será en forma irreversible.<br><br><h2 class="md-title">' +
              copy +
              '</h2>',
            'The action that you will carry out next from ' +
              action +
              ' to  <strong>' +
              type +
              '</strong> will massively affect <strong>' +
              selectedIssues.length +
              '</strong> issues and will be irreversible.<br><br><h2 class="md-title">' +
              copy +
              '</h2>',
            'A ação que você realizará a seguir de ' +
              action +
              ' a  <strong>' +
              type +
              '</strong> afetará massivamente os problemas de <strong>' +
              selectedIssues.length +
              '</strong> e será irreversível.<br><br><h2 class="md-title">' +
              copy +
              '</h2>'
          )
        )
        .ariaLabel('ClearAll-Confirmation')
        .targetEvent(ev)
        .ok(
          $translationService.getTranslationController(
            'Si, ' + action + ' de los issues ' + selectedIssues.length,
            'Yes, ' + action + ' for issues ' + selectedIssues.length,
            'Sim, ' + action + ' pelos issues ' + selectedIssues.length
          )
        )
        .cancel(
          $translationService.getTranslationController(
            'Aún no',
            'Not yet',
            'Ainda não'
          )
        );

      $mdDialog.show(confirm).then(
        function () {
          switch (vm.assignationType) {
            case 'responsible':
              _assignResponsible();
              break;
            case 'classification':
              _assignClassification();
              break;
            case 'status':
              _assignStatus();
              break;
          }
        },
        function () {}
      );
    };

    function _assignStatus() {
      if (!_validateRequiredFields()) {
        return;
      }

      var uuidList = vm.selectedIssues.map(function (e) {
        return e.uuid;
      });

      var req = {
        uuidList: uuidList,
        statusId: vm.selectedStatus,
        comment: vm.changeReason,
      };

      $rootScope.loading = true;
      IssuesFactory.assignIssuesToStatus(req)
        .then(function () {
          toastr.success('Status assigned');
          $mdDialog.hide("loading");
          $rootScope.$broadcast('ReloadIssues');
        })
        .catch(function (err) {
          console.log('Error@assignIssuesToStatus', err);
          toastr.error(err.data);
          $rootScope.loading = false;
        });
    }

    function _assignClassification() {
      if (!_validateRequiredFields()) {
        return;
      }

      var uuidList = vm.selectedIssues.map(function (e) {
        return e.uuid;
      });

      var req = {
        uuidList: uuidList,
        classificationId: vm.selectedClassification,
        comment: vm.changeReason,
      };

      $rootScope.loading = true;
      IssuesFactory.assignIssuesToClassification(req)
        .then(function () {
          toastr.success('Clasification assigned');
          $mdDialog.hide("loading");
          $rootScope.$broadcast('ReloadIssues');
        })
        .catch(function (err) {
          console.log('Error@assignIssuesToClassification', err);
          toastr.error(err.data);
          $rootScope.loading = false;
        });
    }

    function _validateRequiredFields() {
      if (!vm.selectedUser && vm.assignationType == 'responsible') {
        toastr.warning('You must select a user to assign as responsible');
        return false;
      }

      if (
        !vm.selectedClassification &&
        vm.assignationType == 'classification'
      ) {
        toastr.warning('You must select a classification to assign to issues');
        return false;
      }

      if (!vm.selectedStatus && vm.assignationType == 'status') {
        toastr.warning('You must select a status to assign to issues');
        return false;
      }

      if (!vm.changeReason) {
        toastr.warning('You must indicate the reason');
        return false;
      }

      return true;
    }

    function _assignResponsible() {
      if (!_validateRequiredFields()) {
        return;
      }

      var uuidList = vm.selectedIssues.map(function (e) {
        return e.uuid;
      });

      var req = {
        uuidList: uuidList,
        username: vm.selectedUser,
        comment: vm.changeReason,
        categoryId: vm.currentCategory,
      };

      $rootScope.loading = true;
      IssuesFactory.assignIssuesToUser(req)
        .then(function () {
          toastr.success('Responsible assigned');
          $mdDialog.hide("loading");
          $rootScope.$broadcast('ReloadIssues');
        })
        .catch(function (err) {
          console.log('Error@assignIssuesToUser', err);
          toastr.error(err.data);
          $rootScope.loading = false;
        });
    }

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

'use strict';

var app = angular.module('dashboard');

app.component('issueSideNav', {
  templateUrl: 'app/dashboard/components/issue-sidenav/issue-sidenav.html',
  controllerAs: 'ctrl',
  bindings: {
    issueData: '=',
    issueTypes: '=',
    onClose: '&',
  },
  controller: issueSideNav,
});

issueSideNav.$inject = [
  '$scope',
  '$rootScope',
  'toastr',
  'translationService',
  'UserFactory',
  'IssuesFactory',
  'PermissionsFactory',
];
function issueSideNav(
  $scope,
  $rootScope,
  $toastr,
  $translationService,
  $userFactory,
  $issuesFactory,
  PermissionsFactory
) {
  var vm = this;
  $translationService.getTranslation(vm, 'issues');
  vm.loading = true;

  vm.counters = {
    evidences: 0,
    links: 0,
    files: 0,
    comments: 0,
  };

  vm.users = [];
  vm.types = null;
  vm.status = null;
  vm.issue = null;
  vm.issueIsLocked = false;
  vm.issueTypePermission = false;

  $scope.validatePermission = function () {
    return PermissionsFactory.hasPermission(
      'issues-type#' + vm.issue.issueType.id + ':' + 'update'
    );
  };

  (function init() {
    setValues(vm.issueData);
    vm.issueIsLocked = vm.issueData.locked;
    vm.issueTypePermission = !$scope.validatePermission();
  })();

  function setValues(issue) {
    vm.loading = true;
    vm.issue = issue;

    vm.issueType = issue.issueType.id;

    vm.types = vm.issueTypes.find(function (e) {
      return e.id == issue.issueType.id;
    });
    _getCategoryUsers()
      .then(function (users) {
        vm.users = users;
      })
      .finally(function () {
        vm.loading = false;
      });
  }

  function _getCategoryUsers() {
    return $userFactory
      .getUsers({
        categoryId: vm.types.category.id,
        active: true,
      })
      .then(function (res) {
        var users = res.data.data || [];
        users = users.map(function (e) {
          return {
            userId: e.userId,
            fullName: e.fullName,
            color: e.color,
          };
        });

        if (
          vm.issue.assigned &&
          !users.find(function (e) {
            return e.userId == vm.issue.assigned.userId;
          })
        ) {
          users.unshift({
            userId: vm.issue.assigned.userId,
            fullName: vm.issue.assigned.fullName,
            color: vm.issue.assigned.color,
          });
        }

        return users;
      })
      .catch(function (e) {
        console.log('Error@getUsers', e);
      });
  }

  vm.onClickClose = function () {
    vm.loading = true;
    vm.issue = null;
    vm.onClose();
  };

  $scope.$watch('ctrl.issueData', function (nval) {
    setValues(nval);
  });

  function _prepareDataToSaveIssue(issueData) {
    var _issue = angular.copy(issueData);

    _issue.head = angular.isObject(_issue.head)
      ? angular.toJson(_issue.head)
      : _issue.head;

    _issue.body = angular.isObject(_issue.body)
      ? angular.toJson(_issue.body)
      : _issue.body;

    _issue.issueType = issueData.issueType.id;

    _issue.criticality = vm.types.criticalities.find(function (e) {
      return e.id == _issue.criticality.id;
    });

    if (_issue.status) {
      _issue.status = vm.types.status.find(function (e) {
        return e.id == _issue.status.id;
      });
    }

    _issue.classifications = vm.types.classifications.find(function (e) {
      return e.id == _issue.classification.id;
    });

    return _issue;
  }

  vm.saveIssue = function () {
    if ($scope.validatePermission() == false) {
      $toastr.error(
        $translationService.getTranslationController(
          'You do not have permission to update this issue',
          'Tu no tienes permiso para actualizar este issue',
          'Você não tem permissão para atualizar este issue'
        )
      );
      return;
    }

    var _issue = _prepareDataToSaveIssue(vm.issue);

    vm.loading = true;
    $rootScope.loading = true;
    $issuesFactory
      .updateIssue(_issue.uuid, _issue)
      .then(function () {
        $toastr.success(
          $translationService.getTranslationController(
            'Issue updated successfully',
            'Issue actualizado correctamente',
            'Issue atualizado com sucesso'
          )
        );
        vm.loading = false;
        $rootScope.loading = false;
        $rootScope.$broadcast('ReloadIssues');
      })
      .catch(function (err) {
        console.log('Err@updateIssue', err);
        var msg = typeof err.data === 'string' ? err.data : '';
        $toastr.error(
          $translationService.getTranslationController(
            'Error updating issue',
            'Error actualizando issue',
            'Erro ao atualizar issue'
          ) + msg
        );
      })
      .finally(function () {
        vm.loading = false;
        $rootScope.loading = false;
      });
  };
}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller(
      'IssuesRelatedContentDialogController',
      IssuesRelatedContentDialogController
    );

  IssuesRelatedContentDialogController.$inject = [
    '$rootScope',
    '$mdDialog',
    'toastr',
    'translationService',
    'IssuesFactory',
    'parentIssueUuid',
    'relatedElements',
  ];
  function IssuesRelatedContentDialogController(
    $rootScope,
    $mdDialog,
    $toastr,
    $translationService,
    $issuesFactory,
    parentIssueUuid,
    relatedElements
  ) {
    var vm = this;
    vm.translation = {
      related_content: $translationService.getTranslationController(
        'Contenido Relacionado',
        'Related Content',
        'Conteúdo Relacionado'
      ),
      link_selected_on_parent: $translationService.getTranslationController(
        'Vincular en Issue abierto',
        'Link on opened Issue',
        'Link em Issue aberto'
      ),
      link_selected_on_new_issue: $translationService.getTranslationController(
        'Vincular en nuevo Issue',
        'Link on a new Issue',
        'Link em um novo Issue'
      ),
    };
    vm.relatedContent = [];
    vm.showIssues = true;
    vm.parentIssueUuid = parentIssueUuid;

    (function init() {
      vm.relatedContent = relatedElements.map(function (e) {
        e.parentIssueUuid = vm.parentIssueUuid;
        return e;
      });
    })();

    vm.selectedIssues = [];
    vm.selectedReferences = [];
    vm.setSelectedIssuesFromChilds = function (data) {
      vm.selectedReferences = vm.selectedReferences.filter(function (e) {
        return e.referenceUuid != data.referenceUuid;
      });
      vm.selectedReferences.push(data);

      vm.selectedIssues = [];
      vm.selectedReferences.forEach(function (e) {
        vm.selectedIssues = vm.selectedIssues.concat(e.selectedIssues);
      });
    };

    function _validateIssuesToLink(issuesToLink) {
      if (issuesToLink.length) {
        return true;
      } else {
        $toastr.info(
          $translationService.getTranslationController(
            'Debe seleccionar al menos un registro',
            'You must select at least one record',
            'Você deve selecionar pelo menos um registro'
          )
        );
        return false;
      }
    }

    vm.linkIssuesToParent = function (issuesToLink) {
      if (!_validateIssuesToLink(issuesToLink)) {
        return;
      }

      $rootScope.$broadcast('LinkIssuesToParent', {
        parentIssueUuid: parentIssueUuid,
        issuesToLink: issuesToLink,
      });

      $mdDialog.hide();
    };

    vm.linkIssuesInNewIssue = function (issuesToLink) {
      if (!_validateIssuesToLink(issuesToLink)) {
        return;
      }

      $rootScope.loading = true;

      var item = issuesToLink[0];

      var promises = [];
      promises.push(_getIssuesTypes(item.category.id));
      Promise.all(promises).then(function () {
        $rootScope.loading = false;
        $mdDialog.show({
          controller: 'IssuesDetailDialogController',
          controllerAs: 'ctrl',
          templateUrl:
            'app/dashboard/components/issues-detail-dialog/issues-detail-dialog.html',
          parent: angular.element(document.body),
          clickOutsideToClose: false,
          multiple: true,
          locals: {
            issueTypes: vm.issueTypes,
            currentIssueType: vm.issueTypes.find(function (e) {
              return e.id == item.issueType.id;
            }),
            issue: null,
            issuesToLink: issuesToLink,
            currentCategory: item.category,
          },
        });
      });
    };

    function _getIssuesTypes(categoryId) {
      return new Promise(function (resolve, reject) {
        var req = {
          categoryId: categoryId,
        };
        $issuesFactory
          .getIssuesTypes(req)
          .then(function (res) {
            vm.issueTypes = res;
            resolve();
          })
          .catch(function (err) {
            console.log('Error@getIssuesTypes', err);
            reject();
          });
      });
    }

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

'use strict';

var app = angular.module('dashboard');

app.component('issueGuests', {
  templateUrl: 'app/dashboard/components/issue-guests/issue-guests.html',
  controllerAs: 'ctrl',
  bindings: {
    issue: '<',
    guestsCount: '=',
    isLocked: '<',
  },
  controller: issueGuests,
});

issueGuests.$inject = [
  '$rootScope',
  'toastr',
  'translationService',
  'UserFactory',
  'IssuesFactory',
];
function issueGuests(
  $rootScope,
  $toastr,
  $translationService,
  $userFactory,
  $issuesFactory
) {
  var vm = this;
  vm.translation = {
    send: $translationService.getTranslationController(
      'Enviar',
      'Send',
      'Enviar'
    ),
    write_a_comment: $translationService.getTranslationController(
      'Escribe un comentario',
      'Write a comment',
      'Escreva um comentário'
    ),
  };

  vm.selectedUsers = [];
  vm.categoryUsers = [];
  vm.issueGuests = [];
  vm.notifyInvitation = false;

  vm.$onInit = function () {
    if (vm.issue && vm.issue.category) {
      _getCategoryUsers(vm.issue.category.id);
      _getIssueGuests(vm.issue.uuid);
    }
  };

  function _getCategoryUsers(categoryId) {
    var req = { categoryId: categoryId, itemsPerPage: 1000 };
    return $userFactory
      .getUsers(req)
      .then(function (res) {
        var users = res.data.data;
        if (users) {
          users = users.map(function (e) {
            return {
              userId: e.userId,
              fullName: e.fullName,
              username: e.username,
            };
          });
        }
        vm.categoryUsers = users;
      })
      .catch(function (error) {
        console.log('Error@_getCategoryUsers', error);
      });
  }

  function _getIssueGuests(issueUuid) {
    return $issuesFactory
      .getIssueGuests(issueUuid, { itemsPerPage: 1000 })
      .then(function (res) {
        var users = res.users;
        vm.issueGuests = users;
        vm.guestsCount = users.length;
      })
      .catch(function (error) {
        console.log('Error@_getIssueGuests', error);
      });
  }

  vm.inviteUsersToIssue = function () {
    if (vm.isLocked) return;
    if (vm.selectedUsers.length == 0) return;

    var issueUuid = vm.issue.uuid;
    var usersToInvite = vm.selectedUsers.map(function (e) {
      return e.userId;
    });

    var request = {
      title: '',
      note: vm.invitationNote,
      notify: vm.notifyInvitation,
      users: usersToInvite,
    };

    $rootScope.loading = true;
    $issuesFactory
      .inviteUsersToIssue(issueUuid, request)
      .then(function () {
        vm.selectedUsers = [];
        vm.notifyInvitation = false;
        vm.invitationNote = '';
        _getIssueGuests(vm.issue.uuid);
        $toastr.success(
          $translationService.getTranslationController(
            'Usuarios Invitados',
            'Users invited',
            'Usuários convidados'
          )
        );
      })
      .catch(function (error) {
        console.log('Error@inviteUsersToIssue', error);
      })
      .finally(function () {
        $rootScope.loading = false;
      });
  };

  vm.removeIssueGuest = function (userToRemove) {
    $rootScope.loading = true;
    $issuesFactory
      .removeIssueGuest(vm.issue.uuid, userToRemove)
      .then(function () {
        _getIssueGuests(vm.issue.uuid);
        $toastr.success(
          $translationService.getTranslationController(
            'Invitado removido',
            'Guest removed',
            'Convidado removido'
          )
        );
      })
      .catch(function (error) {
        console.log('Error@removeIssueGuest', error);
      })
      .finally(function () {
        $rootScope.loading = false;
      });
  };

  vm.autocompleteValuesGetter = function (query) {
    return vm.categoryUsers.filter(function (e) {
      return e.fullName.toLowerCase().indexOf(query.toLowerCase()) > -1;
    });
  };
}

"use strict";

var app = angular.module("dashboard");

app.component("issueFiles", {
  templateUrl: "app/dashboard/components/issue-files/issue-files.html",
  controllerAs: "ctrl",
  bindings: {
    issueUuid: "<",
    filesCount: "=",
    isLocked: "<",
  },
  controller: issueFiles,
});

issueFiles.$inject = ["toastr", "translationService", "FileUploader", "IssuesFactory"];
function issueFiles($toastr, $translationService, FileUploader, $issuesFactory) {
  var vm = this;
  vm.translation = {
    load_file: $translationService.getTranslationController(
      "Cargar archivo",
      "Load file",
      "Carregar arquivo"
    ),
    load_all: $translationService.getTranslationController(
      "Cargar todo",
      "Load all",
      "Carregar tudo"
    ),
    cancel_all: $translationService.getTranslationController(
      "Cancelar todo",
      "Cancel all",
      "Cancelar tudo"
    ),
    clean_queue: $translationService.getTranslationController(
      "Limpiar cola",
      "Clear queue",
      "Limpar fila"
    ),
    dropFilesHere: $translationService.getTranslationController(
      "Soltar archivos aquí",
      "Drop files here",
      "Solte os arquivos aqui"
    ),
    filesOnQueue: $translationService.getTranslationController(
      "Archivos en cola",
      "Files On Queue",
      "Arquivos na fila"
    ),
  };
  vm.issueFiles = [];

  vm.$onInit = function () {
    if (vm.issueUuid) {
      vm.getFiles();
    }
  };

  vm.getFiles = function () {
    $issuesFactory
      .getIssueFiles(vm.issueUuid)
      .then(function (res) {
        vm.issueFiles = res.data;
        vm.filesCount = vm.issueFiles.length;
      })
      .catch(function (err) {
        console.log("Error@getIssueFiles", err);
      });
  };

  vm.uploader = new FileUploader({
    url: "/risk-backend/rest/issue/" + vm.issueUuid + "/storage",
    removeAfterUpload: true,
  });

  // console.log(vm.uploader);

  vm.uploader.onAfterAddingFile = function (item) {
    item.remove();
    if (vm.isLocked) {
      vm.uploader.queue = [];
      return;
    }

    var uploadQueue = vm.uploader.queue.filter(function (e) {
      return e.file.name.toLowerCase() == item.file.name.toLowerCase();
    });

    var alreadyLoaded = vm.issueFiles.filter(function (e) {
      return e.name.toLowerCase() == item.file.name.toLowerCase();
    });

    if (uploadQueue.length > 0) {
      $toastr.error(
        item.file.name +
          $translationService.getTranslationController(
            " ya esta en cola",
            " is already in queue",
            " já está na fila"
          )
      );
      return false;
    } else {
      //sanitize file name - replace url unsafe characters with underscores
      var sanitizedFileName = String(item.file.name)
        .normalize("NFD") // -> split accented characters into their base character and diacritical mark
        .replace(/[\u0300-\u036f]/g, "") //-> remove diacritical marks
        .replace(/[^A-Za-z0-9\-._~]/g, "_"); // -> replace any remaining url unsafe characters with underscores
      item.file.name = sanitizedFileName;

      vm.uploader.queue.push(item);
      $toastr.info(
        $translationService.getTranslationController(
          "Archivo añadido a la cola!",
          "File added to the queue!",
          "Arquivo adicionado à fila!"
        )
      );
      if (alreadyLoaded.length > 0) {
        for (var i = 0; i < alreadyLoaded.length; i++) {
          var message = $translationService.getTranslationController(
            "El archivo " +
              alreadyLoaded[i].name +
              " ya está cargado en el sistema. será reemplazado por el nuevo archivo.",
            "The file " +
              alreadyLoaded[i].name +
              " is already loaded in the system. It will be replaced by the new file.",
            "O arquivo " +
              alreadyLoaded[i].name +
              " já está carregado no sistema. Será substituído pelo novo arquivo."
          );
          $toastr.warning(message);
        }
      }
    }
  };

  function replaceSpecialCharacters(filename) {
    var parts = filename.split(".");
    var extension = parts.pop();
    var name = parts.join(".");
    name = name.toLowerCase();
    name = name.replace(/[^a-z0-9\s]/g, "");
    name = name.replace(/\s+/g, "_");
    return name + "." + extension;
  }

  vm.uploader.onAfterAddingAll = function (addedFileItems) {
    // addedFileItems.forEach(function (item) {
    //   var newName = replaceSpecialCharacters(item.file.name);
    //   item.file.name = newName;
    // });
    console.info("onAfterAddingAll", addedFileItems);
  };

  vm.uploader.onErrorItem = function (fileItem, response, status, headers) {
    if (response === "fileDuplicate") {
      var msg = $translationService.getTranslationController(
        "No se ha podido cargar, archivo duplicado en el sistema.",
        "Unable to load, duplicate file in the system.",
        "Não é possível carregar, duplicar arquivo no sistema."
      );
      $toastr.error(msg);
    } else {
      if (status == 403) {
        $toastr.error(
          $translationService.getTranslationController(
            "Usuario no autorizado.",
            "Unauthorized User.",
            "Usuário não autorizado."
          )
        );
      } else {
        $toastr.error(
          $translationService.getTranslationController(
            "No se ha podido cargar el archivo.",
            "The file could not be loaded.",
            "O arquivo não pôde ser carregado."
          )
        );
      }
    }
  };

  vm.uploader.onSuccessItem = function (item, response, status, headers) {
    if (status) {
      var msg = $translationService.getTranslationController(
        "Archivo cargado exitosamente",
        "File successfully loaded",
        "Arquivo carregado com sucesso"
      );
      $toastr.success(msg);
      vm.getFiles();
    }
  };

  vm.uploader.onProgressAll = function () {
    vm.loaderInProggres = true;
  };

  vm.uploader.onCompleteAll = function () {
    vm.loaderInProggres = false;
  };

  vm.onDeleteFile = function (fileId) {
    vm.issueFiles = vm.issueFiles.filter(function (e) {
      return e.id != fileId;
    });
    vm.filesCount = vm.issueFiles.length;
  };
}

"use strict";

var app = angular.module("dashboard");

app.component("issueEvidences", {
  templateUrl: "app/dashboard/components/issue-evidences/issue-evidences.html",
  controllerAs: "ctrl",
  bindings: {
    issueUuid: "<",
    issueType: "<",
    evidencesCount: "=",
    linkedIssueTypes: "<",
    api: "=?",
    isLocked: "<",
  },
  controller: issueEvidences,
});

issueEvidences.$inject = ["$scope", "$mdDialog", "IssuesFactory"];
function issueEvidences($scope, $mdDialog, $issuesFactory) {
  var vm = this;
  vm.api = {};
  vm.loading = false;

  vm.tab = 0;

  function _parseBodyData(data) {
    return data.map(function (e) {
      var i = angular.fromJson(e.body);
      i.source = e.source;
      return i;
    });
  }

  vm.$onInit = function () {
    if (!vm.issueUuid) return;
    vm.loading = true;
    vm.issueEvidenceTypesV2 = angular.copy(vm.issueType.evidenceSchemas);
    vm.issueEvidenceTypes = angular.copy(vm.issueType.evidenceSchemas);

    var promises = vm.issueEvidenceTypesV2.map(function (e) {
      return _getIssueEvidences(vm.issueUuid, e.id);
    });

    Promise.allSettled(promises).then(function (res) {
      _getIssueAllEvidences(vm.issueUuid).then(function (allEvidences) {
        var allEvidencesData = allEvidences;

        var response = res
          .filter(function (e) {
            return e.status == "fulfilled";
          })
          .map(function (e) {
            var sistemEvidences = allEvidencesData
              .filter(function (ev) {
                return ev.bodySchema.id == e.value.schemaId;
              })

            return {
              schemaId: e.value.schemaId,
              totalRecords: e.value.pagination.totalRecords + sistemEvidences.length,
              sistemEvidences: sistemEvidences.length,
              t: e.value.pagination.totalRecords,
            };
          });

        function totalRecords(tid) {
          return response.find(function (c) {
            return c.schemaId == tid;
          }).totalRecords;
        }

        vm.issueEvidenceTypes = vm.issueEvidenceTypes
          .map(function (item) {
            item.totalRecords = totalRecords(item.id);
            item.visible = item.totalRecords > 0;
            return item;
          })
          .filter(function (t) {
            return t.visible;
          });

        vm.issueEvidenceTypesV2 = vm.issueEvidenceTypesV2
          .filter(function (t) {
            var tr = totalRecords(t.id);
            return tr > 0;
          })
          .sort(function (a, b) {
            return a.id - b.id;
          })
          .map(function (item, index) {
            item.index = index;
            item.totalRecords = totalRecords(item.id);
            return item;
          });
        vm.loading = false;
      });
    });
    // });
  };

  vm.reload = function () {
    vm.evidencesCount -= 1;
    vm.$onInit();
  };

  vm.createEvidence = function (schema) {
    if (vm.isLocked) return;
    $mdDialog
      .show({
        controller: "EvidenceCreationDialogController",
        controllerAs: "ctrl",
        templateUrl:
          "app/dashboard/components/evidence-creation-dialog/evidence-creation-dialog.html",
        parent: angular.element(document.body),
        multiple: true,
        clickOutsideToClose: false,
        locals: {
          evidenceSchema: schema,
          issueUUID: vm.issueUuid,
        },
      })
      .then(function () {
        vm.tab = schema.id;
        vm.evidencesCount += 1;
        vm.$onInit();
      });
  };

  function _getIssueEvidences(issueUuid, schemaId) {
    var pagination = {
      page: 1,
      itemsPerPage: 1,
      schemaId: schemaId,
    };
    return new Promise(function (resolve, reject) {
      $issuesFactory
        .getIssueEvidences(issueUuid, pagination)
        .then(function (res) {
          res.data.schemaId = schemaId;
          resolve(res.data);
        })
        .catch(function (e) {
          console.log("Error@getIssueEvidences", e);
          reject(e);
        });
    });
  }

  function _getIssueAllEvidences(issueUuid) {
    return new Promise(function (resolve, reject) {
      $issuesFactory
        .getIssueAllEvidences(issueUuid)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          console.log("Error@_getIssueAllEvidences", error);
          reject(error);
        });
    });
  }
}

"use strict";

var app = angular.module("dashboard");

app.component("issueEvidenceTable", {
  templateUrl: "app/dashboard/components/issue-evidences/issue-evidence-table.html",
  controllerAs: "ctrl",
  bindings: {
    issueUuid: "<",
    evidenceTypeId: "<",
    config: "=",
    onRemoveRow: "&",
  },
  controller: issueEvidenceTable,
});

issueEvidenceTable.$inject = [
  "$scope",
  "$mdDialog",
  "toastr",
  "translationService",
  "IssuesListExporterService",
  "SchemasService",
  "IssuesFactory",
];
function issueEvidenceTable(
  $scope,
  $mdDialog,
  $toastr,
  $translationService,
  $issuesListExporterService,
  $schemasService,
  $issuesFactory
) {
  var vm = this;

  // console.log("issueEvidenceTable initialized", vm);

  vm.pagination = {
    page: 1,
    itemsPerPage: 10000,
    schemaId: vm.config.id,
    sortBy: null,
    sort: "asc",
  };
  var cellCliked = null;

  vm.settings = {
    licenseKey: "non-commercial-and-evaluation",
    stretchH: "all",
    renderAllRows: false,
    colWidths: 100,
    width: "100%",
    height: "auto",
    colHeaders: true,
    rowHeaders: false,
    currentRowClassName: "cep-selected-row",
    manualColumnResize: true,
    manualRowResize: true,
    persistentState: false,
    columnSorting: false,
    allowInvalid: true,
    columnHeaderHeight: 10,
    outsideClickDeselects: false,
    disableVisualSelection: true,
    contextMenu: {
      items: {
        export: {
          name: $translationService.getTranslationController(
            "Export csv",
            "Export csv",
            "Export csv"
          ),
          callback: function (key, selection, clickEvent) {
            vm.export(clickEvent);
          },
        },
      },
    },
    afterInit: function () {
      // console.log("Handsontable initialized", this);
      vm.hotInstance = this;
    },
    onAfterOnCellMouseDown: function (event, index) {
      cellCliked = null;
      if (index.row < 0) {
        vm.pagination.sortBy = vm.tableColumns[index.col].data;
        // vm.pagination.colType = vm.types[vm.cols[index.col].data];
        vm.pagination.sort = vm.pagination.sort == "asc" ? "desc" : "asc";
        vm.$onInit();
      } else {
        cellCliked = vm.gridOptions.data[index.row];
      }

      // if (vm.tableColumns.length - 1 == index.col) {
      //   vm.deleteRow(vm.config.gridOptions.data[index.row]);
      // }
    },
    beforeOnCellContextMenu: function (e, CellCoords, contextMenu) {
      // console.log("beforeOnCellContextMenu", e, CellCoords, contextMenu);
      var newContextMenu = {
        items: {
          filter: {
            name: $translationService.getTranslationController(
              "Export csv",
              "Export csv",
              "Export csv"
            ),
            callback: function (key, selection, clickEvent) {
              vm.export(clickEvent);
            },
          },
          delete: {
            name: $translationService.getTranslationController("Delete", "Delete", "Delete"),
            callback: function (key, selection, clickEvent) {
              var row = vm.gridOptions.data[selection[0].start.row];
              vm.deleteRow(row);
            },
          },
        },
      };
      var row = vm.gridOptions.data[CellCoords.row];
      if (row && row.source && (row.source === "SYSTEM" || row.source === "ETHICAL_PORTAL")) {
        delete newContextMenu.items.delete;
      }

      vm.settings.contextMenu = newContextMenu;
      vm.hotInstance.updateSettings(vm.settings);
    },
  };

  vm.gridOptions = {
    // enableFiltering: true,
    rowTemplate:
      '<div ng-dblclick="grid.appScope.ctrl.showDetail($event, row.entity)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell ng-class="{ \'cep-issue-unseen\' : !row.entity.viewed }"></div>',
    gridMenuShowHideColumns: false,
    // showColumnFooter: true,
    // Grid sorting options
    enableRowSelection: true,
    useExternalSorting: false,
    useExternalPagination: false,
    minimumColumnSize: 100,
    // Grid pagination options
    enableSorting: false,
    paginationPageSizes: [25, 50, 100],
    paginationPageSize: 50,
    totalItems: 0,
    data: [],
    columnDefs: [],
    enableGridMenu: true,
    onRegisterApi: function (gridApi) {
      gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
        console.log("paginationChanged", newPage, pageSize);
        // console.log("paginationChanged", vm.pagination
        vm.pagination.page = newPage;
        vm.pagination.itemsPerPage = pageSize;

        vm.$onInit();
      });
      gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        console.log("sortChanged", sortColumns);
        if (sortColumns[0]) {
          var colField = sortColumns[0].field.split(".")[0];
          vm.pagination.sortBy = colField;
          vm.pagination.sort = sortColumns[0].sort.direction;
        } else {
          vm.pagination.sortBy = null;
        }

        vm.$onInit();
      });
    },
  };

  vm.loading = true;

  vm.gridOptions.data = [];
  vm.gridOptions.totalItems = 0;
  vm.config.gridOptions = angular.copy(vm.gridOptions);

  vm.$onInit = function () {
    vm.loading = true;
    vm.gridOptions.data = [];
    vm.gridOptions.totalItems = 0;
    vm.config.gridOptions = angular.copy(vm.gridOptions);
    vm.config.gridOptions.data = [];
    vm.config.gridOptions.totalItems = 0;

    _defineTableColumns().then(function (columnDefs) {
      vm.config.gridOptions.columnDefs = columnDefs;

      vm.tableColumns = columnDefs.map(function (col) {
        return {
          type: "text",
          data: col.field,
          title: col.displayName || col.name,
          className: "rule-pipeline-schema-cell black-text",
          readOnly: true,
          renderer: "html",
          width: col.width,
        };
      });

      _getIssueEvidences(vm.issueUuid)
        .then(function (res) {
          var data = res.data.data;
          var pagination = res.data.pagination;

          _getIssueAllEvidences(vm.issueUuid).then(function (linkedIssues) {
            var allissues = linkedIssues;
            var merged = data.concat(allissues);
            var r = {
              data: merged,
              pagination: pagination,
            };

            var total = r.pagination.totalRecords + allissues.length;

            /// build
            vm.pagination.page = r.pagination.page;
            vm.pagination.totalRecords = total;

            vm.config.data = r.data;

            vm.config.totalRecords = total;

            vm.config.gridOptions.totalItems = total;

            vm.config.gridOptions.data = r.data
              .map(function (e, index) {
                var body = angular.fromJson(e.body);
                body.uuid = e.uuid;
                body.gridIndex = index;
                body.source = e.source;
                // body.linked = e.linked || false;
                body.linked = e.linked == true ? '<i class="fa fa-link"></i>' : "";
                body.delete = ["ETHICAL_PORTAL", "SYSTEM"].includes(e.source)
                  ? ""
                  : '<button type="button" ng-click="grid.appScope.ctrl.deleteRow(row.entity)"><i class="fa fa-trash"></i></button>';
                return body;
              })
              .sort(function (a, b) {
                var columnPk = vm.config.gridOptions.columnDefs.find(function (col) {
                  return col.pk === true;
                }).field
                var sortBy = vm.pagination.sortBy || columnPk 
                if (vm.pagination.sort == "asc") {
                  return (a[sortBy] + "").localeCompare(b[sortBy] + "");
                } else {
                  return (b[sortBy] + "").localeCompare(a[sortBy] + "");
                }
              });

            vm.loading = false;
          });
        })
        .catch(function (err) {
          console.error("get", err);
          vm.loading = false;
        });
    });
  };

  $scope.$watch("ctrl.config.data", function (nval) {
    vm.gridOptions.data = nval;
  });

  vm.export = function () {
    var copy = angular.copy(vm.config.gridOptions.data);
    var data = copy.map(function (e) {
      delete e.delete;
      delete e.linked;
      return e;
    });

    $issuesListExporterService.exportFile(
      "csv",
      vm.config.gridOptions.columnDefs,
      data,
      vm.config.gridOptions.columnDefs
    );
  };

  function _defineTableColumns() {
    return new Promise(function (resolve) {
      var columnDefs = [];

      if (typeof vm.config.schema == "string") {
        vm.config.schema = $schemasService.parseSchema(vm.config);
      }

      angular.forEach(vm.config.schema, function (item, key) {
        if (item.visible == true) {
          columnDefs.push({
            pk: item.pk,
            displayName: item.displayName,
            name: key,
            field: item.pk ? "#" + key : key,
            enableColumnMenu: false,
            enableSorting: true,
            enableCellEditOnFocus: true,
            enableHiding: false,
            cellFilter: ["integer", "double"].includes(item.type) ? "number" : null,
            width: "auto",
          });
        }
      });

      columnDefs.push({
        displayName: "Source",
        name: "source",
        field: "source",
        enableColumnMenu: false,
        enableSorting: true,
        enableCellEditOnFocus: true,
        enableHiding: false,
        width: 30,
      });

      columnDefs.push({
        displayName: "Linked",
        name: "linked",
        field: "linked",
        enableColumnMenu: false,
        enableSorting: true,
        enableCellEditOnFocus: true,
        enableHiding: false,
        cellTemplate:
          '<div style="text-align: center;"><md-icon ng-if="row.entity.linked" md-font-set="material-icons" aria-label="Linked evidence identificator">done</md-icon></div>',
        width: 30,
      });

      // columnDefs.push({
      //   displayName: "Del",
      //   name: "delete",
      //   field: "delete",
      //   enableFiltering: false,
      //   enableSorting: false,
      //   enableCellEdit: false,
      //   enableColumnMenu: false,
      //   cellTemplate:
      //     '<button type="button" ng-click="grid.appScope.ctrl.deleteRow(row.entity)"><md-icon md-font-set="material-icons" aria-label="BTN">delete</md-icon></button>',
      //   cellClass: "schema-cell-content",
      //   width: 30,
      // });

      resolve(columnDefs);
    });
  }

  function _getIssueEvidences(issueUuid) {
    return new Promise(function (resolve, reject) {
      $issuesFactory
        .getIssueEvidences(issueUuid, vm.pagination)
        .then(function (res) {
          resolve(res);
        })
        .catch(function (e) {
          console.error("Error@getIssueEvidences", e);
          reject(e);
        });
    });
  }

  function _getIssueAllEvidences(issueUuid) {
    return new Promise(function (resolve, reject) {
      $issuesFactory
        .getIssueAllEvidences(issueUuid, vm.pagination)
        .then(function (res) {
          // console.log("getIssueAllEvidences", res);
          // console.log(vm.pagination.schemaId);
          // console.log("_getIssueAllEvidences", res);
          var bySchemaId = res.data
            .filter(function (e) {
              return e.bodySchema.id == vm.pagination.schemaId && e.issueUUID != issueUuid;
            })
            .map(function (d) {
              d.linked = true;
              return d;
            });
          resolve(bySchemaId);
        })
        .catch(function (error) {
          console.error("Error@_getIssueAllEvidences", error);
          reject(error);
        });
    });
  }

  vm.deleteRow = function (row) {
    if (row.source && row.source === "SYSTEM") {
      var toastMsg = $translationService.getTranslationController(
        "Evidencias de sistema no pueden ser eliminadas",
        "System evidences cannot be deleted",
        "As evidências do sistema não podem ser excluídas"
      );
      return $toastr.info(toastMsg);
    }

    if (row.source && row.source === "ETHICAL_PORTAL") {
      var toastMsg = $translationService.getTranslationController(
        "Evidencias de portal ético no pueden ser eliminadas",
        "Ethical portal evidences cannot be deleted",
        "As evidências do portal ético não podem ser excluídas"
      );
      return $toastr.info(toastMsg);
    }

    if (row.linked && row.linked == true) {
      var toastMsg = $translationService.getTranslationController(
        "Evidencias vinculadas no pueden ser eliminadas",
        "Linked evidences cannot be deleted",
        "As evidências vinculadas não podem ser excluídas"
      );
      return $toastr.info(toastMsg);
    }

    var evidenceDeletedMsg = $translationService.getTranslationController(
      "Evidencia eliminada",
      "Evidence deleted",
      "Evidência removida"
    );

    if (row.uuid) {
      $issuesFactory
        .deleteIssueEvidence(vm.issueUuid, row.uuid)
        .then(function () {
          vm.onRemoveRow();
          $toastr.success(evidenceDeletedMsg);
          vm.$onInit();
        })
        .catch(function (err) {
          console.error("Error@deleteIssueEvidence", err);

          var toastMsg = $translationService.getTranslationController(
            "No se pudo eliminar la evidencia",
            "Could not delete evidence",
            "Não foi possível remover a evidência"
          );
          $toastr.error(toastMsg);
        });
    } else {
      delete row.gridIndex;

      $toastr.success(evidenceDeletedMsg);
    }
  };
}

var app = angular.module('dashboard');

app.component('issueDynamicSchema', {
  templateUrl:
    'app/dashboard/components/issue-dynamic-schema/issue-dynamic-schema.html',
  controllerAs: 'ctrl',
  bindings: {
    schema: '<',
    schemaData: '=',
    showTitle: '<',
    grid: '<',
    isLocked: '<',
  },
  controller: issueDynamicSchema,
});

issueDynamicSchema.$inject = ['SchemasService'];
function issueDynamicSchema($schemasService) {
  var vm = this;
  vm.grid = vm.grid ? vm.grid : '25';
  vm.schemaArray = [];
  vm.schemaGrouped = [];

  vm.$onInit = function () {
    var data = {};
    if (vm.schemaData) {
      data = angular.copy(angular.fromJson(vm.schemaData));
    }

    vm.schemaData = $schemasService.getDefaultSchemaData(vm.schema);
    angular.forEach(vm.schemaData, function (item, key) {
      var prop = key.replace('#', '');
      var type = vm.schema[prop].type;
      if (['timestamp', 'date'].includes(type)) {
        if (data[key]) vm.schemaData[key] = moment(data[key]).toDate();
      } else vm.schemaData[key] = data[key];
    });
    vm.schemaGrouped = _getSchemaGrouped(vm.schema);
  };

  vm.$onChanges = function (changed) {
    if (changed.schema && vm.schema) {
      vm.schemaTitle = vm.schema.description || vm.schema.name;
      vm.schema = $schemasService.parseSchema(angular.copy(vm.schema));
      vm.schemaGrouped = _getSchemaGrouped(vm.schema);
    }
  };

  function _getSchemaGrouped(schema) {
    var schemaArray = Object.entries(schema);
    schemaArray = schemaArray.map(function (e) {
      return e[1];
    });

    var schemaGrouped = _groupBy(schemaArray, 'group');

    return schemaGrouped;
  }

  function _groupBy(xs, key) {
    var unordered = xs.reduce(function (rv, x) {
      if(x.visible === false) return rv;
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});

    return Object.keys(unordered)
      .sort()
      .reduce(function (obj, key) {
        obj[key] = unordered[key];
        return obj;
      }, {});
  }

  vm.getFieldName = function (isPrimaryKey, fieldName) {
    return $schemasService.parseFieldName(isPrimaryKey, fieldName);
  };

  vm.onReferenceSelected = function (data) {
    Object.keys(vm.schema).forEach(function (key) {
      if (data.reference[key]) {
        vm.schemaData[key] = data.reference[key];
      }
    });
  };
}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller(
      'IssueCustomViewDialogController',
      IssueCustomViewDialogController
    );

  IssueCustomViewDialogController.$inject = [
    '$rootScope',
    '$mdDialog',
    'translationService',
    'toastr',
    'IssuesFactory',
    'issueTypeId',
    'issueFilters',
  ];
  function IssueCustomViewDialogController(
    $rootScope,
    $mdDialog,
    $translationService,
    $toastr,
    $issuesFactory,
    issueTypeId,
    issueFilters
  ) {
    var vm = this;
    $translationService.getTranslation(vm, 'issues');
    vm.issueTypeId = issueTypeId;
    vm.issueFilters = issueFilters;

    vm.customView = {
      name: null,
      description: '',
      body: JSON.stringify(vm.issueFilters),
    };

    vm.save = function () {
      if (!vm.customView.name) {
        $toastr.warning(
          $translationService.getTranslationController(
            'El nombre de la vista personalizada es requerido',
            'Custom view name is required',
            'O nome da visualização personalizada é obrigatório'
          )
        );
        return;
      }

      $rootScope.loading = true;
      $issuesFactory
        .createIssueCustomView(vm.customView)
        .then(function (res) {
          $rootScope.$broadcast('ReloadCustomViews');
          $toastr.success(
            $translationService.getTranslationController(
              'Vista personalizada creada',
              'Custom view created',
              'Visualização personalizada criada'
            )
          );
          $mdDialog.hide();
        })
        .catch(function (err) {
          if (err.data == 'RiskCustomTableDuplicate') {
            $toastr.error(
              $translationService.getTranslationController(
                'La vista ya existe, seleccione un nombre diferente',
                'View already exists, select a different name',
                'A vista já existe, selecione um nome diferente'
              )
            );
          } else {
            $toastr.error(
              $translationService.getTranslationController(
                'No se ha podido crear la vista',
                'View could not be created',
                'Não foi possível criar a visualização'
              )
            );
          }
          console.log('Error@createIssueCustomView', err);
        })
        .finally(function () {
          $rootScope.loading = false;
        });
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

"use strict";

var app = angular.module("dashboard");

app.component("issueComments", {
  templateUrl: "app/dashboard/components/issue-comments/issue-comments.html",
  controllerAs: "ctrl",
  bindings: {
    issueUuid: "<",
    commentsCount: "=",
    isLocked: "<",
  },
  controller: issueComments,
});

issueComments.$inject = [
  "$scope",
  "$rootScope",
  "toastr",
  "translationService",
  "IssuesFactory"
];
function issueComments(
  $scope,
  $rootScope,
  $toastr,
  $translationService,
  $issuesFactory
) {
  var converter = new showdown.Converter();
  var vm = this;

  vm.translation = {
    send: $translationService.getTranslationController(
      "Enviar",
      "Send",
      "Enviar"
    ),
    write_a_comment: $translationService.getTranslationController(
      "Escribe un comentario",
      "Write a comment",
      "Escreva um comentário"
    ),
    sortAsc : $translationService.getTranslationController(
      "Ultimos comentarios primero",
      "latest comments first",
      "Últimos comentários primeiro"
    ),
    sortDesc : $translationService.getTranslationController(
      "Comentarios antiguos primero",
      "oldest comments first",
      "Comentários antigos primeiro"
    )
  };
  vm.comment = {
    message: "",
    isPrivate: true,
  };

  vm.comments = [];
  vm.sort = "asc";

  vm.$onInit = function () {
    if (vm.issueUuid) {
      vm.getComments();
    }
  };

  $scope.tinymceOptions = {
    menubar: "edit tools",
    height: 300,
    paste_data_images: true,
    skin: "lightgray",
    theme: "modern",
    plugins: "link image code paste",
    toolbar:
      "undo redo | formatselect | " +
      "bold italic backcolor | alignleft aligncenter " +
      "alignright alignjustify | bullist numlist outdent indent | " +
      "removeformat |" +
      "code ",
    content_style:
      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
    statusbar: false,
  };

  vm.getComments = function () {
    $issuesFactory
      .getIssueComments(vm.issueUuid)
      .then(function (res) {
        vm.comments = res.data.map(function (comment) {
          comment.moment = getFormatedDate(comment.createdAt);
          comment.commentHtml = converter.makeHtml(
            _formatComment(comment.comment.replace(/\n/g, ""))
          );
          return comment;
        });

        vm.commentsCount = vm.comments.length;
      })
      .catch(function (err) {
        console.log("Error@getIssueComments", err);
      })
      .finally(function () {
        $rootScope.loading = false;
      });
  };

  function getFormatedDate(date) {
    var isSameDay = moment().isSame(date, "day");
    if (isSameDay) {
      return moment(date).fromNow();
    } else {
      return moment(date).format("DD-MM-YYYY HH:mm");
    }
  }

  function _formatComment(comment) {
    if (angular.isUndefined(comment)) return;

    var result = "";
    var separador = " ";
    var items = comment.split(separador);
    angular.forEach(items, function (item) {
      if (item.startsWith("@")) {
        item = '<a href="#" target="_blank">' + item + "</a>";
      } else if (item.startsWith("http")) {
        item = '<a href="' + item + '" target="_blank">' + item + "</a>";
      }

      result = result === "" ? item : result + " " + item;
    });
    return result;
  }

  vm.createComment = function () {
    if (angular.isUndefined(vm.issueUuid)) return;
    if (vm.isLocked) return;
    if (vm.comment.message == "") {
      $toastr.warning(
        $translationService.getTranslationController(
          "Escriba un comentario",
          "Write a comment",
          "Escreva um comentário"
        )
      );

      return;
    }

    var regex = /\n<p>&nbsp;<\/p>\n/g;
    
    var send = {
      comment: vm.comment.message.replace(regex, ""),
      isPrivate: vm.comment.isPrivate,
    }

    $rootScope.loading = true;
    $issuesFactory
      .createIssueComment(vm.issueUuid, send)
      .then(function () {
        vm.getComments();
        vm.comment = {
          message: "",
          isPrivate: true
        };
      })
      .catch(function (err) {
        console.log("Error@createIssueComment", err);
        $toastr.error(err.data);
        $rootScope.loading = false;
      });
  };

  vm.toogleSort = function () {
    vm.sort = vm.sort == "asc" ? "desc" : "asc";
    vm.comments = vm.comments.reverse();
  }
}

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller("IssueColumnsDialogController", IssueColumnsDialogController);

  IssueColumnsDialogController.$inject = [
    "$scope",
    "$mdDialog",
    "toastr",
    "issueTypeId",
    "issueColumns",
    "groupId",
    "categoryId",
    "groups",
    "translationService",
    "PermissionsFactory",
  ];
  function IssueColumnsDialogController(
    $scope,
    $mdDialog,
    $toastr,
    issueTypeId,
    issueColumns,
    groupId,
    categoryId,
    groups,
    $translationService,
    $permissionsFactory
  ) {
    var vm = this;
    $translationService.getTranslation(vm, "issues");
    vm.issueTypeId = issueTypeId;
    vm.columnsDefinitions = {};
    vm.folders = [
      {
        name: "root",
        items: [],
        folders: [],
      },
    ];
    vm.loading = true;
    vm.isSuperUser = $permissionsFactory.isSuperUser();
    vm.availableColumns = [];
    vm.groupsList = groups;

    vm.toGroup = null;

    vm.$onInit = function () {
      var columnsSettings = issueColumns.currentColumns.length
        ? issueColumns.currentColumns
        : issueColumns.defaultColumns;

      vm.selectedDef = issueColumns.currentColumns.length
        ? "currentColumns"
        : "defaultColumns";

      vm.columnsDefinitions = Object.keys(issueColumns).filter(function (key) {
        return key != "availableColumns";
      });

      vm.setupCurrentSelectedColumns(columnsSettings);
    };

    vm.setupCurrentSelectedColumns = function (columnsSettings) {
      vm.loading = true;

      vm.availableColumns = angular.copy(issueColumns.availableColumns);
      vm.availableColumns.forEach(function (col) {
        var key = col.key;
        var found = columnsSettings.find(function (e) {
          return e.key == key;
        });

        if (found != undefined) {
          col.selected = true;
          col.sortable = found.sortable;
        }
      });

      vm.createFolders(vm.availableColumns, false);
    };

    vm.createFolders = function (columnsDefined, displayColumns) {
      vm.loading = true;
      vm.folders = [
        {
          name: "root",
          items: [],
          folders: [],
          display: displayColumns ? displayColumns : false,
        },
      ];
      for (var index = 0; index < columnsDefined.length; index++) {
        var element = columnsDefined[index];
        var refs = element.key.split("/");
        var value = refs.pop();
        //-element.display = displayColumns ? displayColumns : false;
        element.name = value;
        var isRootFolder = refs == 0 ? true : false;
        if (isRootFolder == true) {
          var rootfolder = vm.folders.find(function (folder) {
            return folder.name == "root";
          });
          rootfolder.items.push(element);
        } else {
          var parent = vm.folders.filter(function (folder) {
            return folder.name == refs[0];
          });
          if (parent.length > 0) {
            if (refs[1] == undefined) {
              parent[0].items.push(element);
            } else {
              var nested = parent[0].folders.filter(function (nested) {
                return nested.name == refs[1];
              });
              if (nested.length > 0) {
                nested[0].items.push(element);
              } else {
                parent[0].folders.push({
                  name: refs[1],
                  items: [element],
                  folders: [],
                  display: displayColumns ? displayColumns : false,
                });
              }
            }
          } else {
            if (refs[1] == undefined) {
              vm.folders.push({
                name: refs[0],
                items: [element],
                folders: [],
                display: displayColumns ? displayColumns : false,
              });
            } else {
              vm.folders.push({
                name: refs[0],
                items: [],
                folders: [
                  {
                    name: refs[1],
                    items: [element],
                    folders: [],
                    display: displayColumns ? displayColumns : false,
                  },
                ],
                display: displayColumns ? displayColumns : false,
              });
            }
          }
        }
      }
      vm.loading = false;
    };

    vm.save = function (group) {
      var parsedColumns = _parseSelectedColumnsRequestByFolders();
      if (parsedColumns.length == 0) {
        var msg = $translationService.getTranslationController(
          "Selecciona al menos una columna",
          "Select at least one column",
          "Select at least one column"
        );
        $toastr.info(msg);
        return;
      }
      vm.loading = true;
      vm.searchText = "";
      setTimeout(function () {
        vm.loading = false;
        $mdDialog.hide({
          action: "saveColumns",
          issueTypeId: vm.issueTypeId,
          issueColumns: parsedColumns,
          toGroup: group ? vm.toGroup : null,
        });
      }, 100);
    };

    function _parseSelectedColumnsRequestByFolders() {
      var columnsSelected = [];

      vm.folders.forEach(function (folder) {
        if (folder.items.length > 0) {
          var itemsFiltered = _filterSelectedItems(folder.items);
          columnsSelected = columnsSelected.concat(itemsFiltered);
        }

        folder.folders.forEach(function (items) {
          var itemsFiltered = _filterSelectedItems(items.items);
          columnsSelected = columnsSelected.concat(itemsFiltered);
        });
      });

      return columnsSelected;
    }

    function _filterSelectedItems(array) {
      return array
        .filter(function (e) {
          return e.selected == true;
        })
        .map(function (e) {
          if (e.function) {
            return { key: e.key, value: e.label, function: e.function };
          }
          return { key: e.key, value: e.label };
        });
    }

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    /**
     *list filter
     */
    $scope.$watch("ctrl.searchText", function (nval) {
      if (nval && nval.trim().length > 0) {
        var columnsfiltered = vm.availableColumns.filter(function (e) {
          return e.label.toLowerCase().match(nval.toLowerCase());
        });
        vm.createFolders(columnsfiltered, true);
      } else {
        vm.createFolders(vm.availableColumns, false);
      }
    });

    vm.selectedDef = null;
    vm.querySearch = _querySearch;
    vm.selectedDefChange = _selectedDefChange;

    function _querySearch(query) {
      var results = query
        ? vm.columnsDefinitions.filter(function (col) {
            var colName = col.toLowerCase();
            if (colName.includes(query.toLowerCase())) {
              return col;
            }
          })
        : vm.columnsDefinitions;
      return results;
    }

    function _selectedDefChange() {
      console.log("vm.selectedDef", vm.selectedDef);
      if (!vm.selectedDef) return;
      if (vm.selectedDef === "defaultColumns") {
        vm.setupCurrentSelectedColumns(issueColumns.defaultColumns);
      }
      if (vm.selectedDef === "currentColumns") {
        vm.setupCurrentSelectedColumns(issueColumns.currentColumns);
      }
      if (issueColumns[vm.selectedDef]) {
        vm.setupCurrentSelectedColumns(issueColumns[vm.selectedDef]);
      }
    }
  }
})();

"use strict";

var app = angular.module("dashboard");

app.component("dashboardInboxBox", {
  templateUrl: "app/dashboard/components/inbox-box/inbox-box.html",
  controllerAs: "ctrl",
  bindings: {
    issueTypes: "<",
    counterValues: "<",
    viewAction: "&",
  },
  controller: dashboardInboxBoxController,
});

dashboardInboxBoxController.$inject = ["$scope", "IssueTypeFactory"];
function dashboardInboxBoxController($scope, IssueTypeFactory) {
  var vm = this;
  vm.loading = true;
  vm.issueGroups = [];

  $scope.sortableOptionsList = {
    placeholder: "app",
    connectWith: false,
    forcePlaceholderSize: true,
    stop: function (event, ui) {
      var children = document.querySelectorAll(".inbox-issues-types .issue-type-group-issues");
      var issueTypes = angular.copy(vm.issueTypes || []);
      issueTypes.forEach(function (item) {
        var $item = document.querySelector(
          '.inbox-issues-types .issue-type-group-issues[data-issue-type="' + item.id + '"]'
        );
        item.order = Array.prototype.indexOf.call(children, $item) + 1;
      });

      updateSortingOrder(issueTypes);
    },
  };

  $scope.$watch(
    function () {
      return vm.issueTypes;
    },
    function () {
      onChangeIssues();
    }
  );

  $scope.$watch(
    function () {
      return vm.counterValues;
    },
    function () {
      onChangeIssues();
    }
  );

  vm.toogleGroup = function (group) {
    group.show = !group.show;
  };

  function onChangeIssues() {
    // console.log("issueTypes changed:", vm.issueTypes);
    // console.log("counterValues:", vm.counterValues);
    var copy = angular.copy(vm.issueTypes || []);
    vm.issueGroups = (copy || [])
      .sort(function (a, b) {
        return (a.order || 999) - (b.order || 999);
      })
      .reduce(function (groups, item) {
        var group = item.group || "UN_GROUPED";
        var counter = angular.isDefined(vm.counterValues[item.name])
          ? vm.counterValues[item.name].count
          : 0;
        if (!groups[group]) {
          groups[group] = {
            name: group,
            items: [],
            counter: 0,
            show: false,
          };
        }
        groups[group].counter += counter;
        groups[group].items.push(item);
        return groups;
      }, {});
    vm.loading = false;
    // console.log(vm.issueGroups);
  }

  function updateSortingOrder(issueTypes) {
    vm.loading = true;
    var promises = issueTypes.map(function (item) {
      return IssueTypeFactory.edit(item.id, item);
    });
    Promise.all(promises)
      .then(function (res) {
        // console.log("All sorting orders updated", res);
        vm.loading = false;
      })
      .catch(function (err) {
        console.error("Error updating sorting orders", err);
        vm.loading = false;
      });
  }
}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller(
      'EvidenceCreationDialogController',
      EvidenceCreationDialogController
    );

  EvidenceCreationDialogController.$inject = [
    '$mdDialog',
    'IssuesFactory',
    'issueUUID',
    'evidenceSchema',
    'toastr',
  ];
  function EvidenceCreationDialogController(
    $mdDialog,
    $issuesFactory,
    issueUUID,
    evidenceSchema,
    $toastr
  ) {
    var vm = this;

    vm.$onInit = function () {
      vm.evidenceSchema = evidenceSchema;
      vm.evidenceData = false;
    };

    vm.save = function () {
      var evidence = {
        issueUUID: issueUUID,
        body: JSON.stringify(vm.evidenceData),
        bodySchema: evidenceSchema,
        source: 'USER',
      };
      _createEvidence(issueUUID, evidence)
        .then(function (res) {
          $mdDialog.hide(res.data);
        })
        .catch(function (err) {
          $toastr.info(err.data);
          console.log('err@_createEvidence', err);
        });
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    function _createEvidence(issueUuid, evidence) {
      return new Promise(function (resolve, reject) {
        $issuesFactory
          .createEvidence(issueUuid, evidence)
          .then(function (res) {
            resolve(res);
          })
          .catch(function (e) {
            console.log('Error@getIssueEvidences', e);
            reject(e);
          });
      });
    }
  }
})();

"use strict";

var app = angular.module("dashboard");

app.component("dashboardCounterBox", {
  templateUrl: "app/dashboard/components/counter-box/counter-box.html",
  controllerAs: "ctrl",
  bindings: {
    title: "@",
    icon: "@",
    color: "@",
    issueId: "<",
    viewAction: "&",
    counterValues: "=",
    clasifications: "=",
    titleStatus: "@",
    titleClasifications: "@",
  },
  controller: dashboardCounterBoxController,
});

dashboardCounterBoxController.$inject = ["$scope"];
function dashboardCounterBoxController($scope) {
  var vm = this;
  vm.tab = vm.title;

  $scope.$watch(
    function () {
      return vm.counterValues;
    },
    function (newValue, oldValue) {
      vm.totalCounterValues = vm.counterValues ? totalCounts(vm.counterValues) : 0;
    }
  );

  $scope.$watch(
    function () {
      return vm.clasifications;
    },
    function (newValue, oldValue) {
      vm.totalClasifications = vm.clasifications ? totalCounts(vm.clasifications) : 0;
    }
  );
}

function totalCounts(ele) {
  return ele.reduce(function (a, v) {
    return a + v.count;
  }, 0);
}

"use strict";

var app = angular.module("dashboard");

app.component("dashboardActionsMenu", {
  templateUrl: "app/dashboard/components/actions-menu/actions-menu.html",
  controllerAs: "ctrl",
  bindings: {
    title: "@",
    currentView: "<",
    currentIssue: "<",
    selectedRows: "<",
    linkIssuesFn: "&",
    exportIssuesFn: "&",
    issueListFilters: "=",
    reloadIssuesFn: "&",
  },
  controller: dashboardActionsMenuController,
});

dashboardActionsMenuController.$inject = [
  "$scope",
  "$rootScope",
  "$mdDialog",
  "toastr",
  "translationService",
  "IssuesFactory",
];
function dashboardActionsMenuController(
  $scope,
  $rootScope,
  $mdDialog,
  $toastr,
  $translationService,
  IssuesFactory
) {
  $translationService.getTranslation($scope, "dashboard");

  var vm = this;

  vm.canMarkAsSeen = angular.isDefined(vm.currentIssue.setIssuesAsRead)
    ? vm.currentIssue.setIssuesAsRead
    : false;

  function _openAssignationDialog(event, assignationType) {
    $mdDialog.show({
      controller: "IssuesAssignmentDialogController",
      controllerAs: "ctrl",
      templateUrl:
        "app/dashboard/components/issues-assignment-dialog/issues-assignment-dialog.html",
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: false,
      locals: {
        assignationType: assignationType,
        selectedIssues: vm.selectedRows,
        currentIssue: vm.currentIssue,
      },
    });
  }

  vm.manageColumns = function (event) {
    $rootScope.loading = true;
    // IssuesFactory.getAvailableColumns(vm.currentIssue.id, vm.currentIssue.category.id)
    var promises = [
      IssuesFactory.getAvailableGroups(),
      IssuesFactory.getAvailableColumns(vm.currentIssue.id, vm.currentIssue.category.id),
    ];
    Promise.all(promises)
      .then(function (res) {
        // console.log("res", res);
        var groups = res[0].data;
        var issueColumns = res[1].data;
        _openColumnsManageDialog(event, vm.currentIssue.id, issueColumns, groups);
      })
      .catch(function (err) {
        // console.log("Error@getAvailableColumns", err);
      })
      .finally(function () {
        $rootScope.loading = false;
      });
  };

  function _hasLokedIssues() {
    var haslokedIssues = vm.selectedRows.some(function (issue) {
      return issue.locked;
    });
    if (haslokedIssues) {
      var messaage = $translationService.getTranslationController(
        "No se puede realizar la acción sobre una o más incidencias bloqueadas",
        "The action cannot be performed on one or more locked issues",
        "A ação não pode ser executada em uma ou mais questões bloqueadas"
      );
      $toastr.info(messaage);
    }

    return haslokedIssues;
  }

  function _openColumnsManageDialog(event, issueTypeId, issueColumns, groups) {
    // console.log("currentView", vm.currentIssue);
    $mdDialog
      .show({
        controller: "IssueColumnsDialogController",
        controllerAs: "ctrl",
        templateUrl: "app/dashboard/components/issue-columns-dialog/issue-columns-dialog.html",
        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: false,
        locals: {
          issueTypeId: issueTypeId,
          issueColumns: issueColumns,
          groupId: vm.currentIssue.id,
          categoryId: vm.currentIssue.category.id,
          groups: groups,
        },
      })
      .then(function (data) {
        if (data.action == "saveColumns") {
          _saveIssueColumns(data.issueTypeId, data.issueColumns, data.toGroup);
        }
        if (data.action == "setDefaultColumns") {
          _setDefaultIssueColumns(data.issueTypeId);
        }
      });
  }

  function _saveIssueColumns(issueTypeId, issueColumns, toGroup) {
    $rootScope.loading = true;

    if (toGroup) {
      IssuesFactory.assignCustomColumnsGroup(
        issueTypeId,
        toGroup,
        vm.currentIssue.category.id,
        issueColumns
      )
        .then(function () {
          $rootScope.$broadcast("ReloadIssues");
          var msg = $translationService.getTranslationController(
            "Configuración de columnas guardada",
            "Column settings saved",
            "Configurações de coluna salvas"
          );
          $toastr.success(msg);
        })
        .catch(function (err) {
          $toastr.error(
            $translationService.getTranslationController(
              "Se ha producido un error, intente de nuevo",
              "An error has occurred, please try again",
              "Ocorreu um erro, por favor, tente novamente"
            )
          );

          console.error("Error@assignCustomColumns", err);
        })
        .finally(function () {
          $rootScope.loading = false;
        });
    } else {
      IssuesFactory.assignCustomColumns(issueTypeId, issueColumns)
        .then(function () {
          $rootScope.$broadcast("ReloadIssues");
          var msg = $translationService.getTranslationController(
            "Configuración de columnas guardada",
            "Column settings saved",
            "Configurações de coluna salvas"
          );
          $toastr.success(msg);
        })
        .catch(function (err) {
          $toastr.error(
            $translationService.getTranslationController(
              "Se ha producido un error, intente de nuevo",
              "An error has occurred, please try again",
              "Ocorreu um erro, por favor, tente novamente"
            )
          );

          console.error("Error@assignCustomColumns", err);
        })
        .finally(function () {
          $rootScope.loading = false;
        });
    }
  }

  function _setDefaultIssueColumns(issueTypeId) {
    $rootScope.loading = true;
    IssuesFactory.setDefaultIssueColumns(issueTypeId)
      .then(function () {
        $rootScope.$broadcast("ReloadIssues");
        var msg = $translationService.getTranslationController(
          "Columnas por defecto establecidas",
          "Default columns set",
          "Configurações de coluna padrão"
        );
        $toastr.success(msg);
      })
      .catch(function (err) {
        $toastr.error(
          $translationService.getTranslationController(
            "Se ha producido un error, intente de nuevo",
            "An error has occurred, please try again",
            "Ocorreu um erro, por favor, tente novamente"
          )
        );

        console.error("Error@assignCustomColumns", err);
      })
      .finally(function () {
        $rootScope.loading = false;
      });
  }

  vm.createCustomView = function (event) {
    $mdDialog.show({
      controller: "IssueCustomViewDialogController",
      controllerAs: "ctrl",
      templateUrl:
        "app/dashboard/components/issue-custom-view-dialog/issue-custom-view-dialog.html",
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: false,
      locals: {
        issueTypeId: vm.currentIssue.id,
        issueFilters: vm.issueListFilters,
      },
    });
  };

  vm.assignStatus = function (event) {
    if (_hasLokedIssues()) {
      return;
    }
    toastSelectedRows("assign");
    _openAssignationDialog(event, "status");
  };

  vm.assignResponsible = function (event) {
    if (_hasLokedIssues()) {
      return;
    }
    toastSelectedRows("assign");
    _openAssignationDialog(event, "responsible");
  };

  vm.assignClasification = function (event) {
    if (_hasLokedIssues()) {
      return;
    }
    toastSelectedRows("assign");
    _openAssignationDialog(event, "classification");
  };

  vm.markIssuesAsUnseen = function () {
    if (_hasLokedIssues()) {
      return;
    }
    toastSelectedRows("mark_unseen");
    var promises = [];
    vm.selectedRows.forEach(function (e) {
      // console.log("markIssuesAsUnseen", e);
      promises.push(IssuesFactory.markIssueAsSeen(e.uuid, false));
    });
    // console.log("promises", promises);
    if (promises.length) {
      $rootScope.loading = true;
      Promise.all(promises)
        .then(function () {
          $rootScope.$broadcast("ReloadIssues", true);
        })
        .catch(function (e) {
          // console.log("Error@markIssuesAsUnseen all");
        })
        .finally(function (e) {
          $rootScope.loading = false;
        });
    } else {
      $rootScope.loading = false;
    }
  };

  vm.markIssuesAsSeen = function () {
    if (_hasLokedIssues()) {
      // console.log("Issues locked, cannot mark as seen");
      return;
    }
    toastSelectedRows("mark_seen");
    var promises = [];
    vm.selectedRows.forEach(function (e) {
      // console.log("markIssuesAsSeen", e);
      promises.push(IssuesFactory.markIssueAsSeen(e.uuid, true));
    });
    // console.log("promises", promises);
    if (promises.length) {
      $rootScope.loading = true;
      Promise.all(promises)
        .then(function () {
          $rootScope.$broadcast("ReloadIssues", true);
        })
        .catch(function (e) {
          // console.log("Error@markIssuesAsUnseen all");
        })
        .finally(function (e) {
          $rootScope.loading = false;
        });
    } else {
      $rootScope.loading = false;
    }
  };

  vm.markAsArchived = function (event) {
    var isArchived = vm.issueListFilters.archived;
    var titleText = isArchived
      ? $translationService.getTranslationController(
          "¿Marcar las incidencias seleccionadas como no archivadas?",
          "Mark selected issues as unarchived?",
          "Marcar as questões selecionadas como não arquivadas?"
        )
      : $translationService.getTranslationController(
          "¿Marcar las incidencias seleccionadas como archivadas?",
          "Mark selected issues as archived?",
          "Marcar as questões selecionadas como arquivadas?"
        );
        
    var textContent = isArchived
      ? $translationService.getTranslationController(
          "Las incidencias se mostrarán en la lista principal de incidencias.",
          "The issues will be shown in the main issues list.",
          "As questões serão exibidas na lista principal de questões."
        )
      : $translationService.getTranslationController(
          "Las incidencias se ocultarán de la lista principal de incidencias.",
          "The issues will be hidden from the main issues list.",
          "As questões serão ocultadas da lista principal de questões."
        );

    var okText = isArchived
      ? $translationService.getTranslationController(
          "Sí, desarchivar " + vm.selectedRows.length + " incidencias",
          "Yes, unarchive " + vm.selectedRows.length + " issues",
          "Sim, desarquive-as " + vm.selectedRows.length + " questões"
        )
      : $translationService.getTranslationController(
          "Sí, archivar " + vm.selectedRows.length + " incidencias",
          "Yes, archive " + vm.selectedRows.length + " issues",
          "Sim, arquive-as " + vm.selectedRows.length + " questões"
        );

    var confirm = $mdDialog
      .confirm()
      .title(titleText)
      .textContent(textContent)
      .ariaLabel("Delete-Question")
      .ok(okText)
      .cancel($translationService.getTranslationController("No", "No", "Não"));

    $mdDialog.show(confirm).then(function () {
      console.log("Mark as archived issues", vm.selectedRows);
      var promises = [];
      vm.selectedRows.forEach(function (e) {
        promises.push(IssuesFactory.archiveIssue(e.uuid, !isArchived));
      });

      if (promises.length) {
        $rootScope.loading = true;
        Promise.all(promises)
          .then(function () {
            $rootScope.$broadcast("ReloadIssues", true);
          })
          .catch(function (e) {
            console.error("Error@markAsArchived all", e);
          })
          .finally(function (e) {
            $rootScope.loading = false;
          });
      } else {
        $rootScope.loading = false;
      }
    });
  };

  vm.toggleShowArchived = function () {
    vm.issueListFilters.archived = !vm.issueListFilters.archived;
    $rootScope.$broadcast("ReloadIssues", true);
  };

  vm.showIssues = function (type) {
    vm.issueListFilters = Object.assign({}, vm.issueListFilters, {  
      viewed:
        type === "viewed" ? true : type === "unviewed" ? false : null,
    });
    $rootScope.$broadcast("ReloadIssues", true);
  };

  vm.viewedMode = function() {
    if (vm.issueListFilters.viewed === true) {
      return $translationService.getTranslationController(
        "Issues vistos",
        "Seen issues",
        "Issues vistos"
      );
    } else if (vm.issueListFilters.viewed === false) {
      return $translationService.getTranslationController(
        "Issues no vistos",
        "Unseen issues",
        "Issues não vistos"
      );
    } else {
      return $translationService.getTranslationController(
        "Todos los issues",
        "All issues",
        "Todas as questões"
      );
    }
  };

  function toastSelectedRows(event) {
    var t = {
    "assign" : $translationService.getTranslationController(
        "Acción aplicada a",
        "Action applied to",
        "Ação aplicada a"
      ),
    "mark_unseen" : $translationService.getTranslationController(
        "Marcado como no visto",
        "Marked as unseen",
        "Marcado como não visto"
      ),
    "mark_seen" : $translationService.getTranslationController(
        "Marcado como visto",
        "Marked as seen",
        "Marcado como visto"  
      )
  }
    var t = $scope.translation[event] || "";
    var selected = $translationService.getTranslationController(
        "seleccionados",
        "selected",
        "selecionados"
      );
    var message = t + " " + vm.selectedRows.length + " " + selected;
    $toastr.info(message);
  }
}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('dialogSchemaFormatController', dialogSchemaFormatController);

  dialogSchemaFormatController.$inject = [
    '$rootScope',
    '$scope',
    '$mdDialog',
    'toastr',
    'translationService',
    'selectedItem',
    'PermissionsFactory',
    'ConfigurationFactory',
  ];
  function dialogSchemaFormatController(
    $rootScope,
    $scope,
    $mdDialog,
    toastr,
    $translationService,
    selectedItem,
    PermissionsFactory,
    ConfigurationFactory
  ) {
    $scope.editor = null;
    $scope.status = 'fail';

    $scope.editorLoaded = function (_editor) {
      $scope.editor = _editor;
      $scope.status = 'Loaded';
    };

    (function init() {
      console.log(selectedItem);
      $translationService.getTranslation($scope, 'configuration');
      $scope.permission = 'configuration:create';

      if (angular.isUndefined(selectedItem)) {
        $scope.readonly = false;
        $scope.permission = 'configuration:create';
        $scope.actionText = $translationService.getTranslationController(
          'Crear formato',
          'Create format',
          'Criar formato'
        );
        selectedItem = {
          name: '',
          body: '',
        };
        $scope.mySchemaJson = angular.toJson(selectedItem, true);
      } else {
        $scope.readonly = true;
        $scope.permission = 'configuration:update';
        $scope.actionText = $translationService.getTranslationController(
          'Actualizar formato ',
          'Update format',
          'Atualizar formato'
        );
        selectedItem.body =
          typeof selectedItem.body == 'string'
            ? JSON.parse(selectedItem.body)
            : selectedItem.body;
        $scope.mySchemaJson = angular.toJson(selectedItem, true);
      }
    })();

    $scope.loading = true;
    setTimeout(function () {
      $scope.loading = false;
    }, 1000);

    $scope.cancel = function (ev) {
      var confirm = $mdDialog
        .confirm()
        .multiple(true)
        .title(
          $translationService.getTranslationController(
            '¿Deseas cancelar?',
            'Do you want to cancel?',
            'Você quer cancelar?'
          )
        )
        .textContent(
          $translationService.getTranslationController(
            '¡Todos los cambios se perderán!',
            'All changes will be lost!',
            'Todas as alterações serão perdidas!'
          )
        )
        .ariaLabel('Cancel-Question')
        .targetEvent(ev)
        .ok(
          $translationService.getTranslationController(
            'Abandonar',
            'Leave',
            'Deixar'
          )
        )
        .cancel(
          $translationService.getTranslationController(
            'Cancelar',
            'Cancel',
            'Cancelar'
          )
        );

      $mdDialog.show(confirm).then(
        function () {
          $mdDialog.cancel();
        },
        function () {}
      );
    };

    $scope.save = function () {
      var format;
      try {
        if ($scope.tab == 'json') {
          format = angular.copy(angular.fromJson($scope.editor.getValue()));
        } else {
          format = angular.copy($scope.mySchemaForm)
        }
      } catch (error) {
        console.log('fromJson', error);
        toastr.error('fromJson'.error.toString());
        return;
      }
      console.log(format);
      
      if (format.name == '') {
        toastr.error('unnamed format');
        return;
      }
      if (format.body == '') {
        toastr.error('no data');
        return;
      }

      $rootScope.loading = true;
      format.body = JSON.stringify(format.body);

      $rootScope.loading = true;
      if (format.id) {
        ConfigurationFactory.updateSchemaFormat(format).then(
          function (response) {
            $rootScope.$broadcast('refreshNgTableDynamic', {
              tableId: 'schema-format-table',
            });
            var msg = $translationService.getTranslationController(
              'Formato actualizado exitosamente.',
              'Successfully updated format.',
              'Formato criado com sucesso.'
            );
            toastr.success(msg);
            $rootScope.loading = false;
            $mdDialog.hide();
          },
          function (error) {
            console.log(error);
            toastr.error(error.data);
            $rootScope.loading = false;
          }
        );
      } else {
        ConfigurationFactory.createSchemaFormat(format).then(
          function (response) {
            $rootScope.$broadcast('refreshNgTableDynamic', {
              tableId: 'schema-format-table',
            });
            var msg = $translationService.getTranslationController(
              'Formato creado exitosamente.',
              'Successfully created format.',
              'Formato criado com sucesso.'
            );
            toastr.success(msg);
            $rootScope.loading = false;
            $mdDialog.hide();
          },
          function (error) {
            console.log(error);
            toastr.error(error.data);
            $rootScope.loading = false;
          }
        );
      }
    };

    $scope.validatePermission = function () {
      return PermissionsFactory.hasPermission($scope.permission);
    };
    $scope.addSet = function () {
      if ($scope.mySchemaForm.body === '') $scope.mySchemaForm.body = [];
      $scope.mySchemaForm.body.push({
        key: '',
        icon: '',
        color: 'black',
        value: 0,
        format: 'normal',
      });
    };
    $scope.removeSet = function (index) {
      $scope.mySchemaForm.body.splice(index, 1);
    };

    $scope.tab = 'json';
    $scope.mySchemaForm = angular.fromJson(selectedItem);
    $scope.convert = function (tab) {
      if (tab == 'json') {
        $scope.mySchemaJson = angular.toJson($scope.mySchemaForm, true);
        $scope.tab = 'json';
      } else {
        $scope.mySchemaForm = angular.fromJson($scope.editor.getValue());
        $scope.tab = 'form';
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('dialogIssuesTypeController', dialogIssuesTypeController);

  dialogIssuesTypeController.$inject = [
    '$rootScope',
    '$scope',
    '$mdDialog',
    'toastr',
    'translationService',
    'selectedItem',
    'PermissionsFactory',
    'IssueTypeFactory',
    'SchemasFactory',
    'IssuesFactory',
  ];
  function dialogIssuesTypeController(
    $rootScope,
    $scope,
    $mdDialog,
    toastr,
    $translationService,
    selectedItem,
    PermissionsFactory,
    IssueTypeFactory,
    SchemasFactory,
    IssuesFactory
  ) {
    $scope.editor = null;
    $scope.status = 'fail';

    //- data refernces
    function _getSchemas() {
      return new Promise(function (resolve, reject) {
        SchemasFactory.getSchemas()
          .then(function (res) {
            var schemasList = res.data.map(function (e) {
              return {
                id: e.id,
                name: e.name,
              };
            });
            resolve(schemasList);
          })
          .catch(function (err) {
            console.error('Error@getSchemas', err);
            reject(err);
          });
      });
    }

    function _getIssuesCategories() {
      return new Promise(function (resolve, reject) {
        IssuesFactory.getIssuesCategories()
          .then(function (res) {
            var categoriesList = res.data;
            resolve(categoriesList);
          })
          .catch(function (err) {
            console.error('Error@getIssuesCategories', err);
            reject(err);
          });
      });
    }

    $scope.editorLoaded = function (_editor) {
      $scope.editor = _editor;
      $scope.status = 'Loaded';
    };

    (function init() {
      $scope.loading = true;
      $rootScope.loading = true;
      var promises = [];
      promises.push(_getSchemas());
      promises.push(_getIssuesCategories());

      Promise.all(promises).then(function (res) {
        $scope.schemasList = res[0];
        $scope.categoriesList = res[1];
        $translationService.getTranslation($scope, 'configuration');
        if (angular.isUndefined(selectedItem)) {
          $scope.actionText = $translationService.getTranslationController(
            'Agregar Tipo de Issue',
            'Add an Issues Type',
            'Adicionar uma Tipo do Issue'
          );
          selectedItem = {
            name: '',
            code: '',
            group: '',
            order: 999,
            color: '#fa0000',
            category: $scope.categoriesList[0],
            setIssuesAsRead: false,
            classifications: [
              {
                name: 'classification1',
                color: '#fa0000',
                icon: '',
                weight: 1,
              },
            ],
            criticalities: [
              { name: '', color: '#fa0000', icon: '', weight: 1 },
            ],
            status: [
              {
                name: '',
                color: '#fa0000',
                icon: '',
                weight: 1,
                type: 'PENDING',
                sla: {
                  active: false,
                  action: 'ALERT',
                  daysToSolve: 0,
                  daysForRetryNotification: 0,
                },
              },
            ],
            headSchema: {},
            bodySchemas: [],
            evidenceSchemas: [],
            sla: {
              active: false,
              action: 'ALERT',
              daysToSolve: 0,
              daysToNotify: 0,
              daysForRetryNotification: 0,
              businessDays: false,
            },
            lockByUser: {
              active: false,
              hoursToBlock: 0,
            },
          };
          $scope.mySchemaJson = angular.toJson(selectedItem, true);
        } else {
          $scope.actionText = $translationService.getTranslationController(
            'Actualizar Tipo de Issue',
            'Update an Issues Type',
            'Actualizar uma Tipo do Issue'
          );
          var selectedItemCopy = angular.copy(selectedItem);
          selectedItemCopy.category = $scope.categoriesList.find(function (e) {
            return e.id == selectedItem.category.id;
          });
          var bodySchemas = [];
          angular.forEach(selectedItem.bodySchemas, function (item, key) {
            bodySchemas.push({ id: item.id, name: item.name });
          });
          selectedItemCopy.bodySchemas = bodySchemas;
          selectedItemCopy.headSchema = {
            id: selectedItem.headSchema.id,
            name: selectedItem.headSchema.name,
          };

          var evidenceSchemas = [];
          angular.forEach(selectedItem.evidenceSchemas, function (item, key) {
            evidenceSchemas.push({ id: item.id, name: item.name });
          });
          selectedItemCopy.evidenceSchemas = evidenceSchemas;

          $scope.mySchemaJson = angular.toJson(selectedItemCopy, true);
        }
        $rootScope.loading = false;
        $scope.loading = false;
      });

      $scope.permission = 'issues-type:create';
    })();

    $scope.cancel = function (ev) {
      var confirm = $mdDialog
        .confirm()
        .multiple(true)
        .title(
          $translationService.getTranslationController(
            '¿Deseas cancelar?',
            'Do you want to cancel?',
            'Você quer cancelar?'
          )
        )
        .textContent(
          $translationService.getTranslationController(
            '¡Todos los cambios se perderán!',
            'All changes will be lost!',
            'Todas as alterações serão perdidas!'
          )
        )
        .ariaLabel('Cancel-Question')
        .targetEvent(ev)
        .ok(
          $translationService.getTranslationController(
            'Abandonar',
            'Leave',
            'Deixar'
          )
        )
        .cancel(
          $translationService.getTranslationController(
            'Cancelar',
            'Cancel',
            'Cancelar'
          )
        );

      $mdDialog.show(confirm).then(
        function () {
          $mdDialog.cancel();
        },
        function () {}
      );
    };

    $scope.save = function () {
      var format;
      try {
        if ($scope.tab == 'json') {
          format = angular.copy(angular.fromJson($scope.editor.getValue()));
        } else {
          format = angular.copy(angular.fromJson($scope.mySchemaForm));
        }
      } catch (error) {
        console.log('fromJson', error);
        toastr.error('fromJson'.error.toString());
        return;
      }

      console.log('format', JSON.stringify(format));

      if (format.name == '') {
        toastr.error('Name is requiered');
        return;
      }
      if (format.category == null) {
        toastr.error('no category');
        return;
      }
      if (angular.isUndefined(format.headSchema.id)) {
        toastr.error('no headSchema');
        return;
      }
      if (format.bodySchemas.length == 0) {
        toastr.error('no bodySchemas');
        return;
      }
      if (format.evidenceSchemas.length == 0) {
        toastr.error('no evidenceSchemas');
        return;
      }

      $rootScope.loading = true;

      if (format.id) {
        IssueTypeFactory.edit(format.id, format)
          .then(
            function (response) {
              $rootScope.$broadcast('refreshNgTableDynamic', {
                tableId: 'issues-type-table',
              });
              var msg = $translationService.getTranslationController(
                'Tipo de Issue actualizado exitosamente.',
                'Successfully updated Issues Type.',
                'Tipo do Issue criado com sucesso.'
              );
              toastr.success(msg);
              $mdDialog.hide();
            },
            function (error) {
              console.log(error);
              toastr.error(error.data);
            }
          )
          .finally(function () {
            $rootScope.loading = false;
          });
      } else {
        IssueTypeFactory.create(format)
          .then(
            function (response) {
              PermissionsFactory.addPermission('issues-type', format.id, 'all', true);
              $rootScope.$broadcast('refreshNgTableDynamic', {
                tableId: 'issues-type-table',
              });
              var msg = $translationService.getTranslationController(
                'Tipo de Issue creada exitosamente.',
                'Successfully created Issues Type.',
                'Tipo de Issue criado com sucesso.'
              );
              toastr.success(msg);
              $mdDialog.hide();
            },
            function (error) {
              toastr.error(error.data);
            }
          )
          .finally(function () {
            $rootScope.loading = false;
          });
      }
    };

    $scope.validatePermission = function () {
      return PermissionsFactory.hasPermission($scope.permission);
    };

    $scope.tab = 'json';
    $scope.mySchemaForm = angular.fromJson(selectedItem);

    $scope.convert = function (tab) {
      if (tab == 'json') {
        $scope.tab = 'json';
        $scope.mySchemaJson = angular.toJson($scope.mySchemaForm, true);
      } else {
        $scope.tab = 'form';
        $scope.mySchemaForm = angular.fromJson($scope.editor.getValue());
        if (Array.isArray($scope.mySchemaForm.category)) {
          $scope.mySchemaForm.category = $scope.categoriesList.find(function (
            e
          ) {
            return e.id == $scope.mySchemaForm.category.id;
          });
        }
      }
    };

    $scope.removeSchema = function (schema, index) {
      if (Array.isArray($scope.mySchemaForm[schema])) {
        $scope.mySchemaForm[schema].splice(index, 1);
      } else {
        $scope.mySchemaForm[schema] = {};
      }
    };

    $scope.showDialogSelecteSchema = function (ev, currentValue) {
      console.log(currentValue)
      var value = $scope.mySchemaForm[currentValue];
      var isMultiple = false;
      if (currentValue == 'bodySchemas' || currentValue == 'evidenceSchemas') {
        isMultiple = true;
      } else {
        isMultiple = false;
      }

      $mdDialog
        .show({
          controller: 'dialogSelect',
          targetEvent: ev,
          multiple: true,
          controllerAs: 'ctrl',
          templateUrl:
            'app/app-utils/components/dialog-select/dialog-select.html',
          parent: angular.element(document.body),
          clickOutsideToClose: false,
          locals: {
            title: 'Select a schema',
            currentValue: value,
            isMultiple: isMultiple,
            list: $scope.schemasList,
          },
        })
        .then(function (selection) {
          if (isMultiple) $scope.mySchemaForm[currentValue] = selection;
          else $scope.mySchemaForm[currentValue] = selection[0];
        });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller("dialogHolidayController", dialogHolidayController);

  dialogHolidayController.$inject = [
    "$rootScope",
    "$scope",
    "$mdDialog",
    "toastr",
    "translationService",
    "selectedItem",
    "HolidaysFactory",
  ];
  function dialogHolidayController(
    $rootScope,
    $scope,
    $mdDialog,
    toastr,
    $translationService,
    selectedItem,
    $holidaysFactory
  ) {
    
    $translationService.getTranslation($scope, 'configuration');
    var vm = this;

    
    vm.loading = true;
    vm.actionText = "Create";

    vm.holiday = {
      holiday: "",
    };

    if (selectedItem) {
      var item = angular.copy(selectedItem);
      item.holiday = moment(item.holiday, "DD-MM").toDate();
      vm.holiday = item;
      vm.actionText = "Edit";
    }

    $scope.save = function () {
      if (!vm.holiday.holiday)
        return toastr.error(
          $translationService.getTranslationController(
            "HOLIDAY_REQUIRED",
            "HOLIDAY_REQUIRED",
            "HOLIDAY_REQUIRED"
          )
        );

      var holiday =  angular.copy(vm.holiday)
      holiday.holiday = moment(holiday.holiday).format("DD-MM")

      if (holiday.id) {
        editHoliday(holiday).then(function (res) {
          $mdDialog.hide(res);
        });
      } else {
        createHoliday(holiday).then(function (res) {
          $mdDialog.hide(res);
        });
      }
    };

    function createHoliday(holiday) {
      return new Promise(function (resolve, reject) {
        $holidaysFactory
          .create(holiday)
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            console.error(err);
            reject(err);
          });
      });
    }

    function editHoliday(holiday) {
      return new Promise(function (resolve, reject) {
        $holidaysFactory
          .edit(holiday)
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            console.error(err);
            reject(err);
          });
      });
    }

    $scope.cancel = function (ev) {
      $mdDialog.cancel();
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller(
      "dialogConfigExternalLibrarieController",
      dialogConfigExternalLibrarieController
    );

  dialogConfigExternalLibrarieController.$inject = [
    "$rootScope",
    "$scope",
    "$mdDialog",
    "toastr",
    "ExternalLibrariesFactory",
    "PermissionsFactory",
    "selectedItem",
  ];
  function dialogConfigExternalLibrarieController(
    $rootScope,
    $scope,
    $mdDialog,
    toastr,
    $externalLibrariesFactory,
    $permissionsFactory,
    selectedItem
  ) {
    var vm = this;

    vm.selectedItem = selectedItem;

    vm.library = null;
    $scope.inputTypes = [
      "string",
      "number",
      "checkbox",
      "radio",
      "date",
      "time",
      "datetime",
      "email",
      "url",
      "tel",
      "textarea",
      "select",
    ];

    function getAllPythonLibrariesByID() {
      $externalLibrariesFactory
        .getPythonLibrary(vm.selectedItem.id)
        .then(function (response) {
          vm.library = response.data;
        })
        .catch(function (response) {
          console.error(response);
        });
    }
    getAllPythonLibrariesByID();

    vm.addSchema = function () {
      if (!vm.library.config || !Array.isArray(vm.library.config)) {
        vm.library.config = [];
      } else
        vm.library.config.push({
          ncode: "",
          display: "",
          description: "",
          type: "string",
          options: [],
          required: false,
        });
    };

    vm.removeSchema = function (index) {
      vm.library.config.splice(index, 1);
    };

    vm.onChangeType = function (index) {
      vm.library.config[index].options = [];
    };

    $scope.cancel = function () {
      $mdDialog.cancel();
    };

    $scope.save = function () {
      
      if (!$permissionsFactory.hasPermission("python-library:update")) {
        $mdDialog.hide();
        return;
      }

      if (!$scope.formPy.$valid) return;

      $externalLibrariesFactory
        .editPythonLibrary(vm.library)
        .then(function (response) {
          console.log(response);
          $mdDialog.hide();
          toastr.success("Library updated successfully");
        })
        .catch(function (response) {
          console.error("error@editPythonLibrary", response);
          $mdDialog.hide();
          toastr.error("Error updating library");
        });
    };
  }
})();

'use strict';

var app = angular.module('dashboard');

app.component('storageManager', {
  templateUrl:
    'app/configuration/components/storage-manager/storage-manager.html',
  controllerAs: 'ctrl',
  controller: storageManagerController,
});

storageManagerController.$inject = [
  '$scope',
  '$rootScope',
  'toastr',
  'translationService',
  'FilesStorageFactory',
];
function storageManagerController(
  $scope,
  $rootScope,
  $toastr,
  $translationService,
  $filesStorageFactory
) {
  var vm = this;
  $translationService.getTranslation(vm, 'configuration');

  vm.storageConfig = {
    id: 0,
    name: '',
    description: '',
    serverUrl: '',
    settings: {},
    diskSizeInKb: 0,
    diskSize: 0,
    connectionType: '',
  };

  vm.$onInit = function () {
    $filesStorageFactory.getConfigStorage().then(function (response) {
      var diskSize = getSizeInGb(response.diskSizeInKb);

      vm.storageConfig = {
        id: response.id,
        name: response.name,
        description: response.description,
        serverUrl: response.serverUrl,
        settings: response.settings,
        diskSizeInKb: response.diskSizeInKb,
        diskSize: diskSize,
        connectionType: response.connectionType,
      };
    });
  };

  function getSizeInGb(bytes) {
    var min = 1024;
    var val = parseInt(bytes);
    var i = Math.floor(Math.log(val) / Math.log(min));
    var size = (val / Math.pow(min, i)).toFixed(2) * 1;

    return size;
  }

  vm.setToLowercase = function (chip) {
    return chip.toLowerCase();
  };

  vm.save = function () {
    var storageConfig = angular.copy(vm.storageConfig);
    storageConfig.settings = angular.toJson(storageConfig.settings);

    $rootScope.loading = true;
    $filesStorageFactory
      .updateConfigGlobal(storageConfig)
      .then(function () {
        $rootScope.$broadcast('refreshDiskUsage');
        $toastr.success(
          $translationService.getTranslationController(
            'Configuración guardada',
            'Config saved',
            'Configuração salva'
          )
        );
      })
      .catch(function (error) {
        console.log('Error@updateConfigGlobal', error);
        $toastr.error(
          $translationService.getTranslationController(
            'Error al guardar: ',
            'Save failed: ',
            'Falha ao salvar: '
          ) +
            '<br>' +
            error
        );
      })
      .finally(function () {
        $rootScope.loading = false;
      });
  };
}

"use strict";

var app = angular.module("dashboard");

app.component("externalLibrariesConfig", {
  templateUrl:
    "app/configuration/components/ExternalLibraries/externalLibrariesConfig.html",
  controllerAs: "ctrl",
  controller: externalLibrariesConfigController,
});

externalLibrariesConfigController.$inject = [
  "$scope",
  "$rootScope",
  "toastr",
  "$mdDialog",
  "translationService",
  "ExternalLibrariesFactory",
];

function externalLibrariesConfigController(
  $scope,
  $rootScope,
  toastr,
  $mdDialog,
  $translationService,
  $externalLibrariesFactory
) {
  var vm = this;

  vm.libraries = [];

  vm.filters = {
    page: 1,
    itemsPerPage: 25,
    sort: "desc",
    totalRecords: 0,
    orderBy: "id",
  };

  vm.gridOptions = {
    data: [],
    height: 1000,
    minimumColumnSize: 100,
    // Grid pagination options
    useExternalPagination: true,
    paginationPageSizes: [25, 50, 100],
    paginationPageSize: vm.filters.itemsPerPage,
    totalItems: vm.filters.totalRecords,
    useExternalSorting: false,
    columnDefs: [
      {
        field: "id",
        title: "Id",
        show: true,
        width: "60",
      },
      {
        field: "name",
        title: "Nombre",
        show: true,
      },
      {
        field: "version",
        title: "Version",
        width: "100",
        show: true,
      },
      {
        field: "active",
        title: "Active",
        show: true,
        width: "100",
        align: "htCenter",
        cellClass: "text-center",
        cellTemplate:
          "<md-switch class='p0 m0 flex-buttons w100' ng-model='row.entity.active' ng-change='grid.appScope.ctrl.toggleActive(row.entity)' aria-label='Switch 1'></md-switch>",
      },
      {
        field: "isReady",
        title: "Ready",
        show: true,
        width: "100",
        align: "htCenter",
        cellClass: "text-center",
        cellTemplate:
          "<md-icon class='material-icons' >{{row.entity.isReady ? 'check' : 'close'}}</md-icon>",
      },
      {
        field: "Edit",
        title: "Edit",
        show: true,
        width: "100",
        align: "htCenter",
        cellClass: "text-center",
        cellTemplate:
          "<md-icon  md-font-set='material-icons', ng-click='grid.appScope.ctrl.showExternalLibraryDialog(row.entity)' >edit</md-icon>",
      },
      {
        field: "delete",
        title: "Delete",
        show: true,
        width: "100",
        align: "htCenter",
        cellClass: "text-center",
        cellTemplate:
          "<md-icon  md-font-set='material-icons', ng-click='grid.appScope.ctrl.confirmDeleteLibrary(row.entity)' >delete</md-icon>",
      },
    ],
    onRegisterApi: function (gridApi) {
      gridApi.pagination.on.paginationChanged(
        $scope,
        function (newPage, pageSize) {
          vm.filters.page = newPage;
          vm.filters.itemsPerPage = pageSize;
          vm.gridOptions.paginationPageSize = pageSize;

          _getAllPythonLibraries();
        }
      );
      gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        vm.filters.sort = vm.filters.sort === "asc" ? "desc" : "asc";
        vm.filters.orderBy = sortColumns[0].field;
        _getAllPythonLibraries();
      });

      gridApi.core.on.filterChanged($scope, function (col) {
        if (col.filters[0].term) {
          var term = col.filters[0].term;
          if (
            ["groups", "company", "lastLogin", "expirationDate"].includes(
              col.field
            )
          )
            return;

          if (["type", "region"].includes(col.field)) term = term.toUpperCase();

          vm.filters[col.field] = term;
        } else {
          delete vm.filters[col.field];
        }
        _getAllPythonLibraries();
      });
    },
  };

  vm.showExternalLibraryDialog = function (selectedItem) {
    $mdDialog
      .show({
        multiple: true,
        controller: "dialogConfigExternalLibrarieController",
        templateUrl:
          "app/configuration/dialog/external-librarie/external-librarie.html",
        parent: angular.element(document.body),
        controllerAs: "ctrl",
        // targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        locals: {
          selectedItem: selectedItem,
        },
        resolve: {
          selectedItem: function () {
            return selectedItem;
          },
        },
      })
      .then(function () {
        _getAllPythonLibraries()
        $rootScope.$broadcast("rebuildMainMenu");
        $mdDialog.hide();
      });
  };

  vm.removeExternalLibrary = function (_configuration) {
    var confirm = $mdDialog
      .confirm()
      .title(
        $translationService.getTranslationController(
          "Eliminar configuracion",
          "Delete configuracion",
          "Excluir configuracion"
        )
      )
      .textContent(
        $translationService.getTranslationController(
          "¿Estas seguro que quieres borrarlo?",
          "Are you sure you want to delete?",
          "Tem certeza de que deseja excluir?"
        )
      )
      .ok($translationService.getTranslationController("Si", "Yes", "Sim"))
      .cancel($translationService.getTranslationController("No", "No", "Não"));

    $mdDialog.show(confirm).then(
      function () {
        $rootScope.loading = true;
        $externalLibrariesFactory.deletePythonLibrary(_configuration.id).then(
          function () {
            $rootScope.loading = false;
            toastr.success(
              $translationService.getTranslationController(
                "Configuracion eliminada exitosamente.",
                "Successfully removed config.",
                "Config excluído com sucesso."
              )
            );
            $rootScope.$broadcast("rebuildMainMenu");
          },
          function (error) {
            $rootScope.loading = false;
            var msg = $translationService.getTranslationController(
              "No fue posible eliminar la Formato.",
              "It was not possible to delete the format.",
              "Não foi possível excluir o formato."
            );
            toastr.error(msg);
            console.log(error);
          }
        );
      },
      function () {}
    );
  };

  vm.initLibrary = function () {
    $externalLibrariesFactory.initLibrary().then(
      function () {
        toastr.success(
          $translationService.getTranslationController(
            "Manifest.json cargado exitosamente.",
            "Manifest.json loaded successfully.",
            "Manifest.json carregado com sucesso."
          )
        );
        _getAllPythonLibraries();
      },
      function (error) {
        toastr.error(error.data);
      }
    );
  };

  vm.toggleActive = function (library) {
    var hasRequiredFields = _checkRequiedFields(library.config);

    if (hasRequiredFields === false) {
      toastr.error(
        $translationService.getTranslationController(
          "Por favor, complete los campos requeridos.",
          "Please complete the required fields.",
          "Por favor, complete os campos obrigatórios."
        )
      );
      _getAllPythonLibraries();
      return;
    }

    $externalLibrariesFactory.editPythonLibrary(library).then(
      function () {
        var name = library.name;
        var active = library.active;
        toastr.success(
          $translationService.getTranslationController(
            name + " " + active ? "activada" : "desactivada" + "exitosamente.",
            name + " " + active ? "activated" : "deactivated" + "successfully.",
            name + " " + active ? "ativada" : "desativada" + "com sucesso."
          )
        );
        $rootScope.$broadcast("rebuildMainMenu");
      },
      function (error) {
        toastr.error(error.data);
      }
    );
  };

  function _getAllPythonLibraries() {
    $externalLibrariesFactory
      .getAllPythonLibraries()
      .then(function (response) {
        response.forEach(function (item) {
          item.isReady = _checkRequiedFields(item.config);
        });

        vm.libraries = response;
        vm.gridOptions.data = vm.libraries;
        $rootScope.$broadcast("rebuildMainMenu");
      })
      .catch(function (response) {
        console.error(response);
      });
  }
  _getAllPythonLibraries();

  function _checkRequiedFields(libraryConfig) {
    var allRequiredFilled = libraryConfig
      .filter(function (e) {
        return e.required === true;
      })
      .every(function (e) {
        return e.value;
      });

    if (allRequiredFilled) {
      return true;
    } else {
      return false;
    }
  }

  vm.confirmDeleteLibrary = function (library) {
    var confirm = $mdDialog
      .confirm()
      .title(
        $translationService.getTranslationController(
          "Eliminar configuracion: "+ library.name,
          "Delete configuracion: "+ library.name,
          "Excluir configuracion: "+ library.name
        )
      )
      .textContent(
        $translationService.getTranslationController(
          "¿Estas seguro que quieres borrarlo?",
          "Are you sure you want to delete?",
          "Tem certeza de que deseja excluir?"
        )
      )
      .ok($translationService.getTranslationController("Si", "Yes", "Sim"))
      .cancel($translationService.getTranslationController("No", "No", "Não"));

    $mdDialog.show(confirm).then(
      function () {
        _removeExternalLibrary(library.id);
      },
      function () {}
    );
  }

  function _removeExternalLibrary(id){
    $externalLibrariesFactory.deletePythonLibrary(id).then(
      function () {
        $rootScope.loading = false;
        toastr.success(
          $translationService.getTranslationController(
            "Configuracion eliminada exitosamente.",
            "Successfully removed config.",
            "Config excluído com sucesso."
          )
        );
        _getAllPythonLibraries()
        $rootScope.$broadcast("rebuildMainMenu");
      },
      function (error) {
        $rootScope.loading = false;
        var msg = $translationService.getTranslationController(
          "No fue posible eliminar la Formato.",
          "It was not possible to delete the format.",
          "Não foi possível excluir o formato."
        );
        toastr.error(msg);
        console.log(error);
      }
    );
  }
}

'use strict';

var app = angular.module('dashboard');
app.component('wizardStep', {
  templateUrl: 'app/charts/components/wizard-step/wizard-step.html',
  controllerAs: 'ctrl',
  bindings: {
    step: '<',
    config: '<',
    assets: '=',
    translation: '<',
    event : '@',
  },
  controller: wizardStepController,
});
wizardStepController.$inject = ['$scope', '$element', '$compile'];
function wizardStepController($scope, $element, $compile) {
  var vm = this;
  var step = $compile(
    '<' +
      vm.step.component +
      ' config="ctrl.config" assets="ctrl.assets" event="{{ctrl.event}}"  translation="ctrl.translation" />'
  )($scope);
  $element.append(step);
}


(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller("WizardDialogController", WizardDialogController);

  WizardDialogController.$inject = [
    "$scope",
    "$rootScope",
    "$mdDialog",
    "toastr",
    "ChartsFactory",
    "translationService",
    "chartConfig",
    "PermissionsFactory",
    "groupPath",
  ];
  function WizardDialogController(
    $scope,
    $rootScope,
    $mdDialog,
    toastr,
    ChartsFactory,
    $translationService,
    chartConfig,
    $permissionsFactory,
    groupPath
  ) {
    var steps = [
      {
        name: "general",
        component: "wizard-step-general",
        complete: false,
        types: ["multigrafico", "treemap"],
      },
      {
        name: "Data_sources",
        component: "wizard-step-data-source",
        complete: false,
        types: ["multigrafico", "treemap"],
      },
      {
        name: "xaxis",
        component: "wizard-step-xaxis",
        complete: false,
        types: ["multigrafico"],
      },
      {
        name: "Series",
        component: "wizard-step-yaxis",
        complete: false,
        types: ["multigrafico", "treemap"],
      },
      {
        name: "Group_and_filter",
        complete: false,
        component: "wizard-step-group-filter",
        types: ["multigrafico"],
      },
      {
        name: "levels",
        complete: false,
        component: "wizard-step-treemap",
        types: ["treemap"],
      },
    ];

    $translationService.getTranslation($scope, "charts");
    $scope.groupPath = groupPath || null;
    $scope.event = null;
    $scope.currentTab = 0;
    $scope.currenStep = "general"
    
    $scope.isDisabled = true;

    var vm = this;

    vm.assets = {
      chartType: "multigrafico",
      source: null,
      source2: [],
      sourceSchema: [],
      levels: [],
      event: null,
    };

    $scope.steps = steps;

    if (chartConfig && chartConfig.id) {
      $scope.event = "update";
      var copy = angular.copy(chartConfig);
      copy.group = copy.group && copy.group != "" ? copy.group : "";
      vm.chartConfig = copy;

      vm.chartConfig.series = vm.chartConfig.series.map(function (serie) {
        if (serie.metadata) {
          serie.metadata = JSON.parse(serie.metadata);
        }
        return serie;
      });

      vm.assets.chartType = copy.series.some(function (serie) {
        return serie.type == "treemap";
      })
        ? "treemap"
        : "multigrafico";

      if (vm.assets.chartType == "treemap") vm.assets.levels = copy.levels;
      else {
        delete vm.assets.levels;
      }
    } else {
      $scope.event = "create";

      vm.chartConfig = {
        id: null,
        name: "",
        description: "",
        group: $scope.groupPath ? $scope.groupPath : "",
        echartConfig: "null",
        series: [],
        filters: [],
        xAxis: [],
        yAxis: [],
        notes: [],
        links: [],
        levels: [],
      };
    }
    vm.assets.event = $scope.event;

    vm.selectStep = function (stepName) {
      $scope.currenStep = stepName;
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.prevStep = function () {
      if ($scope.currentTab > 0) $scope.currentTab--;
    };

    vm.nextStep = function () {
      var currentStepComponent = getCurrentStep("component");

      $rootScope.$broadcast("submit-" + currentStepComponent);
    };

    $scope.$on("stepResponse", function (e, data) {
      $scope.steps[$scope.currentTab].complete = data;

      if ($scope.steps[$scope.currentTab].complete == true) {
        if ($scope.currentTab < $scope.steps.length) {
          $scope.currentTab++;
        }
      }
    });

    $scope.$on("chartType", function (e, type) {});

    vm.saveChart = function () {
      $rootScope.loading = true;
      $scope.isLoading = true;
      var send = angular.copy(vm.chartConfig);

      if ($scope.event == "create" && vm.assets.chartType == "multigrafico") {
        delete send.levels;
      }

      send.series = send.series.map(function (serie) {
        if (serie.metadata) {
          serie.metadata = JSON.stringify(serie.metadata);
        }
        return serie;
      });

      send.echartConfig = "null";
      ChartsFactory.saveChart(send)
        .then(function (res) {
          toastr.success("Chart " + send.name + " saved");
          $permissionsFactory.addPermission(
            "graphic-report",
            res.id,
            "all",
            true
          );
          $rootScope.$broadcast("refreshChart_" + send.id, res);
          $rootScope.$broadcast("refreshListCharts", res);
          $mdDialog.hide();
        })
        .catch(function (err) {
          toastr.error("error:: " + err);
          console.error("Error@saveChart", err);
        })
        .finally(function () {
          $scope.isLoading = false;
        });
    };

    function getCurrentStep(key) {
      var stepsByType = $scope.steps.filter(function (step) {
        return step.types.includes(vm.assets.chartType);
      });
      if (key) {
        return stepsByType[$scope.currentTab][key];
      }
      return stepsByType[$scope.currentTab];
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('dashboard')
        .controller('SelectBoxplotDialogController', SelectBoxplotDialogController);

    SelectBoxplotDialogController.$inject = [
        '$mdDialog',
        'boxplotOptions',
    ];
    function SelectBoxplotDialogController(
        $mdDialog,
        boxplotOptions
    ) {
        var vm = this;
        vm.boxplotOptions = boxplotOptions
        vm.selected = null

        vm.save = function () {

            $mdDialog.hide(vm.selected);
        };
        vm.cancel = function () {
            $mdDialog.cancel();
        };
    }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('inputListDialogController', inputListDialogController);

  inputListDialogController.$inject = [
    '$scope',
    '$element',
    '$mdDialog',
    'InputListsFactory',
    'currentTables',
  ];
  function inputListDialogController(
    $scope,
    $element,
    $mdDialog,
    InputListsFactory,
    currentTables
  ) {
    var vm = this;
    vm.isLoading = false;
    vm.inputList = [];
    vm.inputListSelected = [];

    vm.selectedItem = null;
    vm.querySearch = _querySearch;
    vm.selectedItemChange = _selectedItemChange;

    $scope.searchTerm = '';

    function _querySearch(query) {
      var results = query
        ? vm.inputList.filter(function (list) {
            var listName = list.name.toLowerCase();
            if (listName.includes(query.toLowerCase())) {
              return list;
            }
          })
        : vm.inputList;
      return results;
    }

    function _selectedItemChange(item) {
      if (item != undefined && item.hasOwnProperty('id')) {
        var found = vm.inputListSelected.find(function (e) {
          return e.id == item.id;
        });
        if (found == undefined) {
          vm.inputListSelected.push(item);
          vm.selectedItem = null;
        }
      }
    }

    vm.getInputsListsDomain = function () {
      vm.isLoading = true;
      InputListsFactory.getLists()
        .then(function (res) {
          vm.inputList = vm.inputList.concat(
            res.lists.map(function (e) {
              return {
                id: e.listId,
                name: e.name,
              };
            })
          );
          if (currentTables != undefined) {
            if (currentTables.length > 0) {
              vm.inputListSelected = res.lists
                .filter(function (e) {
                  return currentTables.includes(e.listId);
                })
                .map(function (e) {
                  return {
                    id: e.listId,
                    name: e.name,
                  };
                });
            }
          }
          vm.isLoading = false;
        })
        .catch(function (err) {
          console.error('Error@getLists', err);
          vm.isLoading = false;
        });
    };

    vm.getInputsListsDomain();

    vm.removeLink = function (id) {
      vm.inputListSelected = vm.inputListSelected.filter(function (link) {
        if (link.id != id) return link;
      });
    };

    vm.save = function () {
      var listSelected = vm.inputListSelected.map(function (ele) {
        return ele.id;
      });
      $mdDialog.hide(listSelected);
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('ChartFilterDialogController', ChartFilterDialogController);

  ChartFilterDialogController.$inject = [
    '$scope',
    '$mdDialog',
    'config',
    'translation',
    'schema'
  ];
  function ChartFilterDialogController($scope, $mdDialog, config, translation, schema) {
    var vm = this;
    vm.isLoading = false;
    vm.isWidget = true;
    vm.config = config;
    vm.translation = translation;
    vm.schema = schema;
    
    $scope.$on('setChartFilters', function (e, filters) {
      $mdDialog.hide(filters);
    });

    vm.save = function () {
      $mdDialog.hide();
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

'use strict';

var app = angular.module('dashboard');

app.component('chartDataSerie', {
  templateUrl: 'app/charts/components/data-serie/data-serie.html',
  controllerAs: 'ctrl',
  bindings: {
    serie: '=',
    action: '&',
  },
  controller: chartDataSerieController,
});

chartDataSerieController.$inject = ['$scope'];
function chartDataSerieController($scope) {
  var vm = this;
  vm.chartTypes = ['bar', 'line', 'pie'];

  $scope.setValue = function () {
    vm.action();
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('checkboxList', {
  templateUrl: 'app/charts/components/checkbox-list/checkbox-list.html',
  controllerAs: 'ctrl',
  bindings: {
    selected: '=',
    items: '=',
    field: '@',
    action: '&',
  },
  controller: checkboxListController,
});

checkboxListController.$inject = ['$scope', 'translationService'];
function checkboxListController($scope, $translationService) {
  //-translationService.getTranslation($scope, 'replay');
  var vm = this;
  $scope.items = vm.items;
  $scope.selected = vm.selected;
  $scope.setValue = function () {
    vm.action();
  };

  $scope.toggle = function (item, list) {
    var idx = list.indexOf(item);
    if (idx > -1) {
      list.splice(idx, 1);
      $scope.setValue();
    } else {
      list.push(item);
      $scope.setValue();
    }
  };

  $scope.exists = function (item, list) {
    return list.indexOf(item) > -1;
  };

  $scope.isIndeterminate = function () {
    return (
      $scope.selected.length !== 0 &&
      $scope.selected.length !== $scope.items.length
    );
  };

  $scope.isChecked = function () {
    var isChecked = $scope.selected.length === $scope.items.length;
    return isChecked;
  };

  $scope.toggleAll = function () {
    if ($scope.selected.length === $scope.items.length) {
      $scope.selected = [];
    } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
      $scope.selected = $scope.items.slice(0);
    }
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('checkboxAxis', {
  templateUrl: 'app/charts/components/checkbox-axis/checkbox-axis.html',
  controllerAs: 'ctrl',
  bindings: {
    selected: '=',
    items: '=',
    action: '&',
  },
  controller: checkboxAxisController,
});

checkboxAxisController.$inject = ['$scope', 'translationService'];
function checkboxAxisController($scope, $translationService) {
  //-translationService.getTranslation($scope, 'replay');
  var vm = this;
  $scope.items = vm.selected;
  $scope.selected = vm.items;
  $scope.toggle = function (item, list) {
    var idx = list.indexOf(item);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push(item);
    }
  };

  $scope.exists = function (item, list) {
    return list.indexOf(item) > -1;
  };

  $scope.isIndeterminate = function () {
    return (
      $scope.selected.length !== 0 &&
      $scope.selected.length !== $scope.items.length
    );
  };

  $scope.isChecked = function () {
    var isChecked = $scope.selected.length === $scope.items.length;
    return isChecked;
  };

  $scope.toggleAll = function () {
    if ($scope.selected.length === $scope.items.length) {
      $scope.selected = [];
    } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
      $scope.selected = $scope.items.slice(0);
    }
  };

  $scope.setValue = function () {};
}

'use strict';

var app = angular.module('dashboard');

app.component('tableView', {
  templateUrl: 'app/charts/components/chart-tables/table-view.html',
  controllerAs: 'ctrl',
  bindings: {
    listId: '=',
  },
  controller: tableViewController,
});

tableViewController.$inject = [
  '$scope',
  '$rootScope',
  '$state',
  '$mdDialog',
  'toastr',
  'SchemasService',
  'listService',
  'translationService',
  'InputListsFactory',
];
function tableViewController(
  $scope,
  $rootScope,
  $state,
  $mdDialog,
  $toastr,
  $schemasService,
  $listService,
  $translationService,
  InputListsFactory
) {
  $translationService.getTranslation($scope, 'input-list');
  $rootScope.loading = true;
  var vm = this;
  vm.list = {};
  vm.dataList = [];
  vm.showTable = false;
  vm.columns = [];
  vm.schema = [];
  vm.groups = [];
  vm.showTable = false;
  vm.shouldShowFilters = false;
  vm.filters = {
    queryFilters: {},
    pagination: {
      page: 1,
      itemsPerPage: 100,
      sortBy: '',
      colType: '',
      sort: 'ASC',
      totalRecords: 0,
    },
  };

  vm.gridOptions = {
    rowTemplate:
      '<div ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>',
    minimumColumnSize: 100,
    // Grid pagination options
    useExternalPagination: true,
    paginationPageSizes: [25, 50, 100],
    paginationPageSize: 100,
    totalItems: 0,
    // Grid sorting options
    useExternalSorting: true,
    onRegisterApi: function (gridApi) {
      gridApi.pagination.on.paginationChanged(
        $scope,
        function (newPage, pageSize) {
          vm.filters.pagination.page = newPage;
          vm.filters.pagination.itemsPerPage = pageSize;

          _getListData();
        }
      );
      gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        if (sortColumns[0]) {
          var colField = sortColumns[0].field.split('.')[0];
          var col = _getColumnDefinition(colField);
          vm.filters.pagination.sortBy = colField;
          vm.filters.pagination.sort = sortColumns[0].sort.direction;
          vm.filters.pagination.colType = col.type;
        } else {
          vm.filters.pagination.sortBy = null;
        }

        _getListData();
      });
    },
  };

  vm.tableIsLoading = false;
  $scope.params = {
    listId: vm.listId,
    filter: null,
    group: null,
  };

  function _getColumnDefinition(key) {
    return vm.schema[key];
  }

  function _getList() {
    InputListsFactory.getInputList(vm.listId)
      .then(function (res) {
        vm.list = res;
        vm.schema = $schemasService.parseSchema(res.schema);

        _constructList();
        _setColumnDefs()
          .then(function () {
            if ($scope.params.filter && $scope.params.group) {
              _setDefaultFilters();
            }
            _getListData();
          })
          .catch(function () {
            $toastr.warning(
              $translationService.getTranslationController(
                'No hay columnas visibles en el esquema.',
                'There is no columns visible on schema',
                'Não há colunas visíveis no esquema'
              )
            );
            $rootScope.loading = false;
          });
      })
      .catch(function (err) {
        console.error('Error@getLists', err);
      });
  }
  _getList();

  function _setDefaultFilters() {
    var colDef = _getColumnDefinition($scope.params.group);

    vm.filters.queryFilters = {
      filterColumn: $scope.params.group,
      filterByConditions: [
        {
          operation: '=',
          value: $scope.params.filter,
          type: colDef.type || null,
        },
      ],
      filterByValues: [],
    };
    vm.isFiltered = true;
  }

  function _setColumnDefs() {
    return new Promise(function (resolve, reject) {
      vm.gridOptions.columnDefs = [];
      angular.forEach(vm.schema, function (col, key) {
        if (col.visible) {
          var colDef = {
            order: col.order,
            name: key,
            displayName: col.displayName || key,
            field: col.pk ? '#' + key : key,
            cellFilter:
              col.type == 'date'
                ? 'date: "dd/MM/yyyy": "UTC"'
                : col.type == 'double'
                ? 'number: 2'
                : null,
            // General column properties
            enableColumnMenu: false,
            enableSorting: true,
            enableHiding: false,
            menuItems: [],
          };

          if (col.type == 'url') {
            colDef.cellTemplate =
              '<div><a target="_blank" ng-href="{{ COL_FIELD }}" style="text-decoration: underline">{{ COL_FIELD }}</a></div>';
          }

          if (col.format && col.format.toLowerCase() === 'level-icons') {
            colDef.cellTemplate =
              '<div style="padding: 5px;" tipo-event-text="{{ COL_FIELD }}">{{ COL_FIELD }}</div>';
          }

          vm.gridOptions.columnDefs.push(colDef);
        }
      });
      vm.gridOptions.columnDefs = vm.gridOptions.columnDefs.sort(function (
        a,
        b
      ) {
        return a.order - b.order;
      });

      if (vm.gridOptions.columnDefs.length) {
        resolve();
      }
      reject();
    });
  }

  function _getListData() {
    vm.tableIsLoading = true;
    InputListsFactory.getInputListData(
      vm.listId,
      vm.filters.queryFilters,
      vm.filters.pagination
    )
      .then(function (res) {
        vm.gridOptions.totalItems = res.pagination.totalRecords;
        vm.dataList = res.dataList.map(function (e) {
          return {
            dataId: e.dataId,
            body: angular.fromJson(e.body),
          };
        });

        vm.gridOptions.data = vm.dataList.map(function (e) {
          e.body.__dataId = e.dataId;
          return e.body;
        });

        vm.filterlist = vm.dataList;
        _getMetadataList();
      })
      .catch(function (err) {
        console.error('Error@getInputListData', err);
      })
      .finally(function () {
        vm.tableIsLoading = false;
      });
  }

  function _getMetadataList() {
    var noGroupTag = $translationService.getTranslationController(
      'otros',
      'others',
      'otros'
    );
    InputListsFactory.getInputListMetadata(vm.listId)
      .then(function (res) {
        var mapData = res.columns.map(function (e) {
          var cleanColName = e.name.replace('#', '');
          var col = {
            field: e.name,
            title:
              vm.schema[cleanColName] && vm.schema[cleanColName].displayName
                ? vm.schema[cleanColName].displayName
                : e.name,
            type: e.type,
            show: true,
            group: vm.schema[cleanColName]
              ? angular.isUndefined(vm.schema[cleanColName].group)
                ? noGroupTag
                : vm.schema[cleanColName].group
              : noGroupTag,
            order: vm.schema[cleanColName]
              ? vm.schema[cleanColName].order
              : '1',
            sortable: e.name,
            filterable: { type: 'text' },
            width: 30,
          };
          return col;
        });

        vm.columns = mapData.sort(function (a, b) {
          return a.order - b.order;
        });

        vm.groups = vm.columns.map(function (ele) {
          var item = ele.group;
          if (typeof item === 'string' && item != undefined) {
            return item;
          }
        });

        _filterColumnsByParameters();

        //- grupos para cliente card
        vm.groups = vm.groups.filter(function (value, index) {
          return vm.groups.indexOf(value) == index;
        });

        $rootScope.loading = false;
      })
      .catch(function (err) {
        console.error('Error@getInputListMetadata', err);
      });
  }

  function _filterColumnsByParameters() {
    vm.columns.forEach(function (item) {
      var val = '';
      if ($scope.params.filter && $scope.params.group === item.field) {
        val = $scope.params.filter;
      }

      vm.filters[item.field] = val;
    });
  }

  vm.getBack = function () {
    $state.go('app.schemasLists');
  };

  function _constructList() {
    var inputList = {};
    inputList.cols = [];
    inputList.types = [];
    angular.forEach(vm.schema, function (col, key) {
      inputList.types[(col.pk ? '#' : '') + key] = col.type;
      var referencedListId = col.metadata ? col.metadata.id : null;
      var colDefinition = _getInputType(
        col.type,
        referencedListId,
        col.autocomplete,
        col.inputFormat,
        col.outputFormat,
        col.readonly
      );
      colDefinition.data = (col.pk ? '#' : '') + key;
      colDefinition.title = key + (col.required || col.pk ? '*' : '');
      inputList.cols.push(colDefinition);
    });
    vm.inputList = inputList;
  }

  function _getInputType(
    input,
    list,
    autocomplete,
    inputFormat,
    outputFormat,
    readonly
  ) {
    var sequentialSourceFn = function (query, process) {
      InputListsFactory.getInputListData(list, {}, false).then(function (res) {
        var source = res.data.map(function (e) {
          var res = angular.fromJson(e.body);
          if (res.$visible) delete res.$visible;
          return Object.values(res)[0];
        });
        process(source);
      });
    };

    return $listService.getInputType(
      input,
      autocomplete,
      inputFormat,
      outputFormat,
      readonly,
      sequentialSourceFn
    );
  }

  $scope.$on('listFiltered', function (e, filter) {
    if (filter.condition == '') {
      vm.unFilterData();
    } else {
      vm.filterData(vm.selectedCol, filter.condition, filter.conditionValue);
    }
  });

  vm.filterData = function (col, cond, val) {
    vm.filters.queryFilters = {
      filterColumn: col,
      filterByConditions: [
        { operation: cond, value: val, type: vm.inputList.types[col] },
      ],
      filterByValues: [],
    };
    vm.isFiltered = true;
    _getListData();
  };

  vm.unFilterData = function () {
    vm.filters.queryFilters = {};
    vm.isFiltered = false;
    _getListData();
  };

  vm.showFilterDialog = function (ev, col) {
    var inputList = vm.inputList;
    vm.selectedCol = col.pk ? '#' + col.key : col.key;
    vm.filters.queryFilters = {};
    var selection = col.key;

    var colDef = inputList.cols.find(function (col) {
      return (
        col.title == selection ||
        col.title == selection + '*' ||
        '#' + col.title.replace('*', '') == selection
      );
    });
    if (colDef.dateFormat) {
      var dateFormat = colDef.dateFormat;
    }

    InputListsFactory.setSelectedCol(vm.selectedCol);
    InputListsFactory.setFilters(vm.filters.queryFilters);
    $mdDialog.show({
      controller: 'ListFiltersController',
      templateUrl: 'app/input-list/components/list-filters/list-filters.html',
      locals: {
        cellValue: null,
        dateFormat: dateFormat,
        colTypes: inputList.types,
        schema: vm.schema,
      },
      parent: angular.element(document.body),
      targetEvent: ev,
      hasBackdrop: false,
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
    });
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('chartTables', {
  templateUrl: 'app/charts/components/chart-tables/chart-tables.html',
  controllerAs: 'ctrl',
  bindings: {
    tables: '=',
    chartId: '=',
    translation: '<',
  },
  controller: chartTablesController,
});

chartTablesController.$inject = ['$mdDialog', '$rootScope'];
function chartTablesController($mdDialog, $rootScope) {
  var vm = this;
  vm.removeTable = function (idTable) {
    vm.tables = vm.tables.filter(function (table) {
      return table != idTable;
    });
    setTimeout(function () {
      $rootScope.$broadcast('saveconfig_' + vm.chartId, null);
    }, 200);
  };
  vm.inputsListDialog = function () {
    $mdDialog
      .show({
        controller: 'inputListDialogController',
        controllerAs: 'ctrl',
        templateUrl:
          'app/charts/components/input-list-dialog/input-list-dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          currentTables: vm.tables,
        },
      })
      .then(
        function (listSelected) {
          vm.tables = listSelected;
          setTimeout(function () {
            $rootScope.$broadcast('saveconfig_' + vm.chartId, null);
          }, 200);
        },
        function () {}
      );
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('chartTableView', {
  templateUrl: 'app/charts/components/chart-table-view/chart-table-view.html',
  controllerAs: 'ctrl',
  bindings: {
    chartData: '<',
    hasGroupby: '<',
    hasPivot: '<',
    translation: '<',
    showTable: '=',
    isWidget: '=',
  },
  controller: chartTableViewController,
});

chartTableViewController.$inject = ['$scope'];
function chartTableViewController($scope) {
  var vm = this;
  $scope.onShowTable = function () {
    vm.showTable = !vm.showTable;
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('chartSources', {
  templateUrl: 'app/charts/components/chart-sources/chart-sources.html',
  controllerAs: 'ctrl',
  bindings: {
    sources: '<',
    translation: '<',
  },
  controller: chartSourcesController,
});

chartSourcesController.$inject = ['$state'];
function chartSourcesController($state) {
  var vm = this;
}

'use strict';

var app = angular.module('dashboard');

app.component('chartNotes', {
  templateUrl: 'app/charts/components/chart-notes/chart-notes.html',
  controllerAs: 'ctrl',
  bindings: {
    notes: '<',
    chartId: '<',
    translation: '<',
  },
  controller: chartNotesController,
});

chartNotesController.$inject = [
  '$scope',
  '$rootScope',
  '$mdDialog',
  'toastr',
  '$localStorageService',
];
function chartNotesController(
  $scope,
  $rootScope,
  $mdDialog,
  toastr,
  $localStorageService
) {
  var vm = this;
  vm.note = '';
  vm.currentUser = $localStorageService.getItem("currentUser.username");
  vm.sendNote = function (ev) {
    var confirm = $mdDialog
      .prompt()
      .title('Escribe una nota')
      .textContent('Mensajes para los demas usuarios')
      .placeholder('nota..')
      .ariaLabel('note')
      .initialValue('')
      .targetEvent(ev)
      .required(true)
      .ok('Guardar')
      .cancel('Cancelar');

    $mdDialog.show(confirm).then(function (result) {
      var newrecord = {
        date: moment().format('DD/MM/YYYY hh:mm:ss'),
        user: currentUser,
        message: result,
      };
      vm.notes.unshift(newrecord);
      $rootScope.$broadcast('saveconfig_' + vm.chartId, null);
    });
  };

  vm.deleteNote = function (index) {
    vm.notes.splice(index, 1);
  };
}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('chartListDialogController', chartListDialogController);

  chartListDialogController.$inject = [
    '$scope',
    '$element',
    '$mdDialog',
    'ChartsFactory',
    'idChart',
    'currentlinks',
  ];
  function chartListDialogController(
    $scope,
    $element,
    $mdDialog,
    ChartsFactory,
    idChart,
    currentlinks
  ) {
    var vm = this;
    vm.tabIndex = 0;
    vm.linkTypes = ['chart', 'url', 'files'];
    function _filterByType(type) {
      return currentlinks.filter(function (link) {
        return link.type == type;
      });
    }
    vm.currentlinks_Charts = _filterByType('chart');
    vm.currentlinks_Files = _filterByType('file');
    vm.currentlinks_Urls = _filterByType('url');

    vm.save = function () {
      vm.chartListSelected = vm.currentlinks_Charts.concat(
        vm.currentlinks_Files,
        vm.currentlinks_Urls
      );
      $mdDialog.hide(vm.chartListSelected);
    };
    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

'use strict';

var app = angular.module('dashboard');

app.component('chartLinks', {
  templateUrl: 'app/charts/components/chart-links/chart-links.html',
  controllerAs: 'ctrl',
  bindings: {
    idChart: '=',
    links: '=',
    translation: '<',
  },
  controller: chartLinksController,
});

chartLinksController.$inject = [
  '$scope',
  '$rootScope',
  '$mdDialog',
  'FilesStorageFactory',
  'FileSaver',
];
function chartLinksController(
  $scope,
  $rootScope,
  $mdDialog,
  FilesStorageFactory,
  FileSaver
) {
  var vm = this;

  vm.removeLink = function (item) {
    if (item.id != null) {
      vm.links = vm.links.filter(function (link) {
        if (link.id != item.id) return link;
      });
    } else {
      vm.links = vm.links.filter(function (link) {
        if (link.url != item.url) return link;
      });
    }
    setTimeout(function () {
      $rootScope.$broadcast('saveconfig_' + vm.idChart, null);
    }, 200);
  };

  vm.addLink = function () {
    $mdDialog
      .show({
        controller: 'chartListDialogController',
        controllerAs: 'ctrl',
        templateUrl:
          'app/charts/components/chart-list-dialog/chart-list-dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          currentlinks: vm.links,
          idChart: vm.idChart,
        },
      })
      .then(
        function (listSelected) {
          vm.links = listSelected;
          setTimeout(function () {
            $rootScope.$broadcast('saveconfig_' + vm.idChart, null);
          }, 200);
        },
        function () {}
      );
  };

  $scope.downloadFile = function (file) {
    $rootScope.loading = true;
    FilesStorageFactory.downloadFile(file.url, file.id)
      .then(function (res) {
        FileSaver.saveAs(new Blob([res]), file.name);
        $rootScope.loading = false;
      })
      .catch(function (err) {
        $rootScope.loading = false;
        console.error('Error@downloadFile', err);
      });
  };

  $scope.openChartTabByID = function (chartId) {
    $rootScope.$broadcast('openChartTabByID', chartId);
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('filterSelect', {
  templateUrl: 'app/charts/components/chart-filter/filter-select.html',
  controllerAs: 'ctrl',
  bindings: {
    label: '=',
    options: '=',
    ngModel: '=',
  },
  controller: filterSelectController,
});

filterSelectController.$inject = ['$scope', '$element'];
function filterSelectController($scope, $element) {
  var vm = this;
  $scope.searchTerm = '';
  $scope.clearSearchTerm = function () {
    $scope.searchTerm = '';
  };
  vm.selected = [];

  $element.find('input').on('keydown', function (ev) {
    ev.stopPropagation();
  });

  $scope.clearSelections = function () {
    vm.selected = [];
    $scope.setValue();
  };

  $scope.$on('removeSelectionsFilters_' + vm.configId, function (e) {
    vm.selected = [];
    $scope.setValue();
  });

  $scope.setValue = function () {
    vm.ngModel = vm.selected;
  };
}

"use strict";

var app = angular.module("dashboard");

app.component("chartFilter", {
  templateUrl: "app/charts/components/chart-filter/chart-filter.html",
  controllerAs: "ctrl",
  bindings: {
    config: "<", // chart configuration object two-way binding
    translation: "<", // translation object two-way binding
    widget: "<", // boolean to identify if the filter is in a widget
    filter: "&", // function to send filter data to parent component 
    schema: "<", // schema of the chart data two-way binding
  },
  controller: chartFilterController,
});

chartFilterController.$inject = [
  "$scope",
  "$rootScope",
  "ChartsFactory",
  "toastr",
];
function chartFilterController($scope, $rootScope, ChartsFactory, toastr) {
  var vm = this;
  vm.filters = null;
  vm.sendFilter = {};

  function removeDuplicates(array) {
    var unique = {};
    array.forEach(function (i) {
      if (!unique[i]) {
        unique[i] = true;
      }
    });
    return Object.keys(unique);
  }

  vm.getChartFilters = function () {
    $rootScope.loading = true;

    ChartsFactory.getChartFilters(vm.config.id)
      .then(function (res) {
        var process = res.map(function (ele) {
          var schema = vm.schema.properties[ele.field] || {};
          ele.selectedValues = removeDuplicates(ele.selectedValues);
          ele.selectedValues = ele.selectedValues
            .map(function (d) {
              return d.split("T")[0];
            })
            .sort();
          ele.schema = schema;
          ele.type = angular.isDefined(schema.type) ? schema.type : "string";

          if (ele.type === "date") {
            var first =
              ele.selectedValues.length > 0 ? ele.selectedValues[0] : null;
            var last =
              ele.selectedValues.length > 0
                ? ele.selectedValues[ele.selectedValues.length - 1]
                : null;

            ele.input = {
              type: "date",
              range: [moment(first).toDate(), moment(last).toDate()],
              selectedValues: ele.selectedValues,
              min: first,
              max: last,
              auxMin: first,
              onchange: function (x) {
                var desde = x.input.range[0];
                var hasta = x.input.range[1];

                if (desde > hasta) {
                  x.input.range[0] = hasta;
                  return;
                }

                if (hasta < desde) {
                  x.input.range[0] = hasta;
                  return;
                }

                x.input.auxMin = moment(desde).format("YYYY-MM-DD");

                vm.sendFilter[x.field] = {
                  fromDate:
                    moment(desde).format("YYYY-MM-DD") + "T00:00:00.000000000Z",
                  toDate:
                    moment(hasta).format("YYYY-MM-DD") + "T00:00:00.000000000Z",
                };
              },
            };
          }

          return ele;
        });
        vm.filters = process;
        $rootScope.loading = false;
      })
      .catch(function (err) {
        console.error("Error@getChartFilters", err);
        toastr.error("getChartFilters" + err);
        $rootScope.loading = false;
      });
  };

  vm.getChartFilters();

  vm.clearFilters = function () {
    vm.sendFilter = {};
    vm.getChartFilters();
    vm.filterChart();
  };

  vm.filterChart = function () {
    var filters = [];
    for (var key in vm.sendFilter) {
      if (vm.sendFilter.hasOwnProperty(key)) {
        var selections = vm.sendFilter[key];
        var schema = vm.schema.properties[key] || {};
        var type = angular.isDefined(schema.type) ? schema.type : "string";
        var filterModel = {
          selectedValues: selections,
          field: key,
          type: type,
        };
        filters.push(filterModel);
      }
    }

    if (vm.widget) $scope.$emit("setChartFilters", filters);
    else $rootScope.$broadcast("filterChart_" + vm.config.id, filters);
  };

  vm.removeFilters = function () {
    $rootScope.$broadcast("removeSelectionsFilters_" + vm.config.id);
  };

  // $scope.$watchCollection("ctrl.sendFilter", function () {
  //   if (!vm.filters) return;
  //   vm.filterChart();
  // });
}

(function () {
  'use strict';

  angular.module('dashboard').directive('whenScrolled', whenScrolledController);
  whenScrolledController.$inject = [];

  function whenScrolledController() {
    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        var raw = elem[0];
        elem.bind('scroll', function () {
          if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight) {
            scope.$apply(attrs.whenScrolled);
          }
        });
      },
    };
  }
})();

(function () {
  'use strict';

  angular.module('dashboard').directive('toHtml', toHtmlController);

  toHtmlController.$inject = [];
  function toHtmlController() {
    return {
      restrict: 'A',
      link: function (scope, el, attrs) {
        el.html(scope.$eval(attrs.toHtml));
      },
    };
  }
})();

(function () {
  "use strict";

  angular.module("dashboard").directive("staticImage", staticImageController);

  staticImageController.$inject = ["FilesStorageFactory"];

  function staticImageController($filesStorageFactory) {
    return {
      restrict: "A",
      link: function (scope, elem, attrs) {
        console.log("Static Image Directive", elem);
        var regex = /[^a-z A-z 0-9 .]+/g;
        var ele = elem[0].getAttribute("src");
        var value = ele.split(",");

        value = value.map(function (e) {
          return e.trim().replace(regex, "");
        });

        var folder = value[1];
        var file = value[2];

        $filesStorageFactory.downloadFile(folder, file).then(function (res) {
          blobToBase64(res.data).then(function (base64) {
            elem[0].src = "data:image/gif;base64," + base64;
          });
        });
      },
    };
  }
})();

function blobToBase64(blob) {
  return new Promise(function (resolve, _) {
    var reader = new FileReader();
    reader.onloadend = function () {
      return resolve(reader.result.split(";base64,").pop());
    };
    reader.readAsDataURL(blob);
  });
}

'use strict';

angular.module('dashboard').component('skeletonLoader', {
  bindings: {
    type: '@?', //sk-box, sk-form, sk-grid
    size: '=?',
    columns: '=?', //number
    rows: '=?', //number
    fields: '=?', // number
    largeText: '=?', // true or false
  },
  controllerAs: 'skCtrl',
  controller: function ($scope, $element) {
    var self = this;
    self.$onInit = function () {
      // Load default values

      // self.size = self.size || 's';
      self.type = self.type || 'sk-form';
      self.columns = self.columns || 1;
      self.fields = self.fields || 1;
      self.rows = self.columns * self.rows || self.columns * 2;
      self.largeText = self.largeText === 'true' || false;
      self.createElement();
    };

    self.createElement = function () {
      var main = document.createDocumentFragment();
      var container = document.createElement('div');
      container.classList.add('skeleton');

      self.evalType(container);
      self.evalColums(container);
      main.appendChild(container);
      $element[0].appendChild(main);
    };

    self.evalType = function (container) {
      //-console.log("self.evalType " + self.type)
      switch (self.type) {
        case 'sk-form':
          createFormItems(container);
          break;
        case 'sk-box':
          createBox(container);
          break;
        default:
          createGridItems(container);
          break;
      }
    };

    self.evalColums = function (container) {
      switch (self.type) {
        case 'form':
          container.setAttribute(
            'style',
            'grid-template-columns: repeat(' +
              self.columns +
              ',1fr) !important;'
          );
          break;
        default:
          break;
      }
    };

    function createFormItems(container) {
      container.classList.add(self.type);
      for (var index = 0; index < self.fields; index++) {
        var elementContainer = document.createElement('div');
        elementContainer.classList.add('sk-group');
        var label = document.createElement('div');
        label.classList.add('sk-base');
        label.classList.add('sk-label');
        var input = document.createElement('div');
        input.classList.add('sk-base');
        input.classList.add(
          self.largeText === true && index === 0 ? 'sk-big-input' : 'sk-input'
        );
        elementContainer.appendChild(label);
        elementContainer.appendChild(input);
        container.appendChild(elementContainer);
      }
    }

    function createBox(container) {
      var elementContainer = document.createElement('div');
      var input = document.createElement('div');
      input.classList.add('sk-base');
      input.classList.add(
        self.largeText === true && index === 0 ? 'sk-big-input' : 'sk-input'
      );
      elementContainer.appendChild(input);
      container.appendChild(input);
    }

    function createGridItems(container) {
      return true;
    }
  },
});

(function () {
  'use strict';

  angular.module('dashboard').directive('schemaFormat', schemaFormatController);

  schemaFormatController.$inject = ['$rootScope'];
  function schemaFormatController($rootScope) {
    return {
      restrict: 'A',
      link: function (scope, el, attrs) {
        var schemaFormat = attrs.schemaFormat;
        var type = attrs.type;
        var value = attrs.value;
        var def = $rootScope.schemasFormat.find(function (d) {
          return d.name == schemaFormat;
        });
        if (def && def.body) {
          var style;
          if (type == 'integer' || type == 'double') {
            style = def.body.find(function (d) {
              return d.value == parseFloat(value);
            });
          } else if (type == 'string') {
            style = def.body.find(function (d) {
              return d.key == value;
            });
          }
          if (style) {
            el[0].classList.add(style.icon);
            el[0].classList.add(style.color);
            el[0].classList.add(style.format);
          }
        }
      },
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .directive('myCurrentTime', myCurrentTimeController);

  myCurrentTimeController.$inject = [
    '$interval',
    'timezoneService',
    'dateFilter',
    '$localStorageService'
  ];
  function myCurrentTimeController($interval, $timezoneService, $dateFilter ,$localStorageService) {
    return function (scope, element, attrs) {
      var dateFormat, updateTimeInterval;

      function updateTime() {
        var currentUser = $localStorageService.getItem('currentUser');
        var timeZoneUser = currentUser.timeZone
        var timezone = currentUser.timeZone ? currentUser.timeZone : $timezoneService.zoneTimeUser()
        var datetime = $timezoneService.getTimeZone();
        element.text($dateFilter(datetime, dateFormat) + ' ' + timezone);
      }

      scope.$watch(attrs.myCurrentTime, function (value) {
        dateFormat = value;
        updateTime();
      });

      updateTimeInterval = $interval(updateTime, 1000);

      element.on('$destroy', function () {
        $interval.cancel(updateTimeInterval);
      });
    };
  }
})();

//** Import files as binaryString */
//** Returns an array of data stringified */

(function () {
  'use strict';

  angular.module('dashboard').directive('fileImport', FileImportDirective);

  FileImportDirective.$inject = [];
  function FileImportDirective() {
    return {
      scope: {
        fileImportedData: '=',
      },

      link: function ($scope, $elm) {
        $elm.on('change', function (event) {
          _processImport(event.target.files, 0, []).then(function (data) {
            $scope.fileImportedData = data;
          });
        });

        function _processImport(files, index, importedData) {
          return new Promise(function (resolve) {
            if (index >= files.length) {
              resolve(importedData);
            } else {
              var reader = new FileReader();

              reader.onload = function (e) {
                importedData.push(e.target.result);

                _processImport(files, ++index, importedData).then(function (
                  data
                ) {
                  resolve(data);
                });
              };

              reader.readAsText(files[index]);
            }
          });
        }
      },
    };
  }
})();

(function () {
  "use strict";

  angular.module("dashboard").directive("scheduleBuilder", scheduleBuilderController);

  scheduleBuilderController.$inject = ["$mdDialog", "translationService", "toastr"];
  function scheduleBuilderController($mdDialog, $translationService, toastr) {
    return {
      scope: {
        api: "=?",
        onUpdate: "&",
      },
      restrict: "E",
      replace: "true",
      link: function ($scope) {
        $scope.api = {};

        var scheduleDialogController = function ($scope, params, onUpdate) {
          $translationService.getTranslation($scope, "rules");

          var dialog = this;

          dialog.params = params;

          dialog.cronString = "";

          dialog.scheduleAdvanceMode = false;

          dialog.cron = {
            seconds: "0",
            minute: params.schedule.minute || "0",
            hour: params.schedule.hour || "*",
            dayOfMonth: params.schedule.dayOfMonth || "*",
            month: params.schedule.month || "*",
            dayOfWeek: params.schedule.dayOfWeek || "*",
            year: params.schedule.year || "*",
          };

          //basic mode
          dialog.basicModes = [
            { value: "everyHour", title: "Every hour" },
            { value: "onceADay", title: "Once a day" },
            { value: "onceAWeek", title: "Once a week" },
            { value: "onceAMonth", title: "Once a month" },
            { value: "onceAYear", title: "Once a year" },
          ];
          dialog.basicModeSelected = dialog.basicModes[0].value;

          dialog.scheduleAdvanceMode = params.form.scheduleAdvanceMode || false;
          dialog.basicModeSelected = params.form.basicModeSelected || dialog.basicModes[0].value;
          dialog.minuteMode = params.form.minuteMode || "specific_minute";
          dialog.hourMode = params.form.hourMode || "scpecific_hour";
          dialog.dayMode = params.form.dayMode || "every_day";

          dialog.min = 0;
          dialog.hour = 0;
          dialog.repeat = "daily";
          dialog.months = [];

          function stringToArray(string) {
            if (!string) return [0];
            if (string === "*") return [0];

            return string.split(",").map(function (e) {
              return Number(e);
            });
          }

          //advance mode
          dialog.minuteMode = "specific_minute";
          dialog.input_minute_from = params.schedule.minute || "1";
          dialog.input_minute_to = params.schedule.minute || "0";
          dialog.input_minute_checkbox = stringToArray(params.schedule.minute);

          dialog.input_minute_from_between = params.schedule.minute || "0";
          dialog.input_minute_to_between = params.schedule.minute || "0";

          dialog.hourMode = "specific_hour";
          dialog.input_hour_from = params.schedule.hour || "1";
          dialog.input_hour_to = params.schedule.hour || "0";
          dialog.input_hour_checkbox = stringToArray(params.schedule.hour);

          dialog.input_hour_fron_between_hour = params.schedule.hour || "0";
          dialog.input_hour_to_between_hour = params.schedule.hour || "0";

          dialog.dayMode = "every_day";
          dialog.input_day_on_fromday = "1";
          dialog.input_day_on_today = "1";
          dialog.input_day_onthe_fromday = "1";
          dialog.input_day_onthe_today = "1";
          dialog.input_day_week_checkbox = [];
          dialog.input_day_checkbox = [];
          dialog.input_day_last_day = "1";
          dialog.input_day_on_fromdaymonth = "1";

          dialog.minuteToCron = function () {
            if (dialog.minuteMode === "every_minute") dialog.cron.minute = "*";
            else if (dialog.minuteMode === "every_minute_starting_at_minute") {
              var v1 = dialog.input_minute_to;
              var v2 = dialog.input_minute_from;
              dialog.cron.minute = v1 + "/" + v2;
            } else if (
              dialog.minuteMode === "specific_minute" &&
              dialog.input_minute_checkbox != "*"
            ) {
              var values = angular.copy(dialog.input_minute_checkbox);
              dialog.cron.minute = values.sort().join(",") || "0";
            } else if (dialog.minuteMode === "every_minute_between_minute") {
              var v1 = dialog.input_minute_to_between;
              var v2 = dialog.input_minute_from_between;
              dialog.cron.minute = v1 + "-" + v2;
            } else dialog.cron.minute = "*";

            dialog.cron.seconds = "0";
            dialog.cron.hour = "*";
            dialog.cron.dayOfMonth = "*";
            dialog.cron.month = "*";
            dialog.cron.dayOfWeek = "?";
            dialog.cron.year = "*";
          };

          dialog.hourToCron = function () {
            if (dialog.hourMode === "every_hour") dialog.cron.hour = "*";
            else if (dialog.hourMode === "every_hour_starting_at_hour") {
              var v1 = dialog.input_hour_to;
              var v2 = dialog.input_hour_from;
              dialog.cron.hour = v1 + "/" + v2;
            } else if (dialog.hourMode === "specific_hour" && dialog.input_hour_checkbox != "*") {
              var values = angular.copy(dialog.input_hour_checkbox);
              dialog.cron.hour = values.sort().join(",") || "0";
            } else if (dialog.hourMode === "every_hour_between_hour_and_hour") {
              var v1 = dialog.input_hour_fron_between_hour;
              var v2 = dialog.input_hour_to_between_hour;
              dialog.cron.hour = v1 + "-" + v2;
            } else dialog.cron.hour = "*";
          };

          dialog.dayToCron = function () {
            if (dialog.dayMode === "every_day") {
              dialog.cron.month = "*";
              dialog.cron.dayOfWeek = "?";
              dialog.cron.dayOfMonth = "*";
            } else if (dialog.dayMode === "every_day_starting_on_wewkday") {
              var v1 = dialog.input_day_on_today;
              var v2 = dialog.input_day_on_fromday;
              dialog.cron.dayOfWeek = v1 + "/" + v2;
              dialog.cron.dayOfMonth = "?";
            } else if (dialog.dayMode === "every_day_starting_on_the_day") {
              var v1 = dialog.input_day_onthe_today;
              var v2 = dialog.input_day_onthe_fromday;
              dialog.cron.dayOfWeek = "?";
              dialog.cron.dayOfMonth = v1 + "/" + v2;
            } else if (dialog.dayMode === "specific_day_of_the_week") {
              var values = angular.copy(dialog.input_day_week_checkbox);
              dialog.cron.dayOfWeek = values.sort().join(",") || "0";
              dialog.cron.dayOfMonth = "?";
            } else if (dialog.dayMode === "specific_day_of_month") {
              var values = angular.copy(dialog.input_day_checkbox);
              dialog.cron.dayOfMonth = values.sort().join(",") || "0";
              dialog.cron.dayOfWeek = "?";
            } else if (dialog.dayMode === "on_the_last_day_of_the_month") {
              dialog.cron.dayOfWeek = "?";
              dialog.cron.dayOfMonth = "L";
            } else if (dialog.dayMode === "on_the_last_weekday_of_the_month") {
              dialog.cron.dayOfWeek = "?";
              dialog.cron.dayOfMonth = "LW";
            } else if (dialog.dayMode === "on_the_last_specific_day_of_the_month") {
              var v1 = dialog.input_day_last_day;
              dialog.cron.dayOfMonth = "?";
              dialog.cron.dayOfWeek = v1 + "L";
            } else if (dialog.dayMode === "on_the_last_day_before_the_end_of_the_month") {
              var v1 = dialog.input_day_on_fromdaymonth;
              dialog.cron.dayOfWeek = "?";
              dialog.cron.dayOfMonth = "L-" + v1;
            } else {
              dialog.cron.dayOfWeek = "*";
              dialog.cron.dayOfMonth = "?";
            }
          };

          dialog.toggleScheduleAdvanceMode = function () {
            if (dialog.scheduleAdvanceMode) {
              dialog.minuteMode = "specific_minute";
              var _minute = isNaN(dialog.cron.minute) ? null : Number(dialog.cron.minute);
              dialog.input_minute_checkbox = _minute ? [_minute] : [];

              dialog.hourMode = "specific_hour";
              var _hour = isNaN(dialog.cron.hour) ? null : Number(dialog.cron.hour);
              dialog.input_hour_checkbox = _minute ? [_hour] : [];

              if (dialog.repeat === "custom") {
                dialog.dayMode = "specific_day_of_month";
                dialog.input_day_checkbox = dialog.months;
              }
              if (dialog.repeat === "daily") {
                dialog.dayMode = "every_day";
                dialog.input_day_on_fromday = "1";
                dialog.input_day_on_today = "1";
                dialog.input_day_onthe_fromday = "1";
                dialog.input_day_onthe_today = "1";
                dialog.input_day_week_checkbox = [];
                dialog.input_day_checkbox = [];
                dialog.input_day_last_day = "1";
                dialog.input_day_on_fromdaymonth = "1";
              }

              if (dialog.repeat === "monToFri") {
                dialog.dayMode = "specific_day_of_the_week";
                dialog.input_day_week_checkbox = ["MON", "TUE", "WED", "THU", "FRI"];
              }
            }
          };

          function cronIsRepeated() {
            var cronString = Object.values(dialog.cron).join(" ");
            var exist = params.schedules
              .map(function (e) {
                return Object.values(e).join(" ");
              })
              .some(function (e) {
                return e === cronString;
              });
            return exist;
          }

          dialog.save = function () {
            if (cronIsRepeated() && params.action === "create") {
              toastr.error("Schedule already exist!");
            } else {
              var schedule = angular.copy(dialog.cron);

              schedule = Object.assign(schedule, {
                form: JSON.stringify({
                  scheduleAdvanceMode: dialog.scheduleAdvanceMode,
                  basicModeSelected: dialog.basicModeSelected,
                  minuteMode: dialog.minuteMode,
                  hourMode: dialog.hourMode,
                  dayMode: dialog.dayMode,
                }),
              });

              // console.log('schedule', schedule);

              onUpdate({
                schedule: schedule,
                action: params.action,
                index: params.index,
              });
            }
          };

          dialog.cancel = function () {
            $mdDialog.cancel();
          };

          $scope.toggleSelection = function toggleSelection(list, value) {
            if (list === "*") list = [];

            var idx = list.indexOf(value);

            if (idx > -1) {
              list.splice(idx, 1);
            } else {
              list.push(value);
            }
          };

          $scope.minutes = Array.from({ length: 60 }, function (v, k) {
            return k;
          });

          $scope.hours = Array.from({ length: 24 }, function (v, k) {
            return k;
          });

          $scope.days = Array.from({ length: 31 }, function (v, k) {
            return k + 1;
          });

          $scope.daysOfMonth = Array.from({ length: 31 }, function (v, k) {
            return k + 1;
          });

          $scope.daysOfWeek = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ];

          $scope.daysOfWeekAlies = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

          $scope.months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];
          $scope.monthsAlies = [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MA",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OCT",
            "NOV",
            "DEC",
          ];

          $scope.years = Array.from({ length: 10 }, function (v, k) {
            return k + $scope.currentyear;
          });
        };

        $scope.showDialog = function (ruleSelected) {
          $mdDialog.show({
            multiple: true,
            templateUrl: "app/app-utils/directives/cron-builder/schedule-builder.dialog.html",
            controller: scheduleDialogController,
            controllerAs: "dialog",
            locals: {
              params: ruleSelected,
              onUpdate: $scope.onUpdate,
            },
            clickOutsideToClose: false,
            escapeToClose: false,
          });
        };

        $scope.api.open = function (ruleSelected) {
          $scope.showDialog(ruleSelected);
        };

        $scope.api.close = function () {
          $mdDialog.hide();
        };
      },
    };
  }
})();

(function () {
  'use strict';

  angular.module('dashboard').directive('cronBuilder', CronBuilderController);
  CronBuilderController.$inject = ['$mdDialog', 'translationService'];
  function CronBuilderController($mdDialog, $translationService) {
    return {
      scope: {
        api: '=?',
        onUpdate: '&',
      },
      restrict: 'E',
      replace: 'true',
      link: function ($scope) {
        $scope.api = {};

        var cronDialogController = function ($scope, params, onUpdate) {
          $translationService.getTranslation($scope, 'rules');
          var dialog = this;
          dialog.params = params;

          dialog.cronExpression = dialog.params.schedule || '0 */1 * * *';
          dialog.cronString = prettyCron.toString(dialog.cronExpression);
          var arrExp = dialog.cronExpression.split(' ');
          dialog.cronState = {
            minute: arrExp[0] || '*',
            hour: arrExp[1] || '*',
            day: arrExp[2] || '*',
            month: arrExp[3] || '*',
            weekDay: arrExp[4] || '*',
          };

          dialog.regenerateCron = function () {
            dialog.cronExpression =
              dialog.cronState.minute +
              ' ' +
              dialog.cronState.hour +
              ' ' +
              dialog.cronState.day +
              ' ' +
              dialog.cronState.month +
              ' ' +
              dialog.cronState.weekDay;
          };

          $scope.$watchCollection(
            'dialog.cronState',
            function (nval) {
              dialog.regenerateCron();
            },
            true
          );

          $scope.$watch(
            'dialog.cronExpression',
            function (nval) {
              dialog.cronString = prettyCron.toString(nval);
            },
            true
          );

          dialog.save = function () {
            onUpdate({
              expression: dialog.cronExpression,
              id: dialog.params.id,
            });
          };

          dialog.reset = function () {
            dialog.cronExpression = '0 */1 * * *';
          };

          dialog.cancel = function () {
            $mdDialog.cancel();
          };
        };

        $scope.showDialog = function (label, name, id, schedule) {
          $mdDialog.show({
            multiple: true,
            templateUrl:
              'app/app-utils/directives/cron-builder/cron-builder.dialog.html',
            controller: cronDialogController,
            controllerAs: 'dialog',
            locals: {
              params: {
                label: label,
                name: name,
                id: id,
                schedule: schedule,
              },
              onUpdate: $scope.onUpdate,
            },
            clickOutsideToClose: true,
            escapeToClose: true,
          });
        };

        $scope.api.open = function (label, name, id, schedule) {
          $scope.showDialog(label, name, id, schedule);
        };

        $scope.api.close = function () {
          $mdDialog.hide();
        };
      },
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .directive('cepDatepicker', cepDatepickerController);

  cepDatepickerController.$inject = [];
  function cepDatepickerController() {
    function link($scope, element, attrs, ctrl) {
      var outputFormat = attrs.format || 'YYYY-MM-DD';
      // Init JQuery datepicker
      element.datepicker({ changeYear: true });

      ctrl.$formatters.push(formatter);
      ctrl.$parsers.push(parser);

      element.on('change', function (e) {
        var element = e.target;
        element.value = formatter(ctrl.$modelValue);
      });

      function formatter(value) {
        console.log("formatter", value);
        //convert data from model format to view format...
        if (!value || value == '') return '';
        return moment(value).format('DD-MM-YYYY');
      }

      function parser(value) {
        console.log("parser", value);
        if (!value || value == '') return '';
        // Format displayed value...
        if (!value) return '';
        return moment(value).format(outputFormat);
      }
    }
    return {
      restrict: 'A',
      require: 'ngModel',
      link: link,
    };
  }
})();

(function () {
  'use strict';

  angular.module('dashboard').directive('accordion', accordionController);

  accordionController.$inject = [];
  function accordionController() {
    return {
      scope: {
        ngModel: '=',
      },
      restrict: 'A',
      link: function ($scope, el, attr) {
        var target = document.querySelectorAll('.panel-collapse');
        angular.forEach(el, function (key, val) {
          key.addEventListener(
            'click',
            function () {
              angular.forEach(target, function (tgt, val) {
                tgt.classList.remove('in');
              });
              key.nextElementSibling.classList.add('in');
            },
            false
          );
        });
      },
    };
  }
})();

"use strict";
var app = angular.module("dashboard");
app.component("user2fa", {
  templateUrl: "app/app-utils/components/user-2fa/user-2fa.html",
  controllerAs: "ctrl",
  controller: user2Fa,
});
user2Fa.$inject = [
  "$scope",
  "toastr",
  "$localStorageService",
  "UserFactory",
  "$rootScope",
  "translationService",
];
function user2Fa(
  $scope,
  toastr,
  $localStorageService,
  UserFactory,
  $rootScope,
  $translationService
) {
  $translationService.getTranslation($scope, "login");
  var vm = this;
  var currentUser = $localStorageService.getItem('currentUser');
  var role = currentUser ? currentUser.company.role : null;
  var username = currentUser ? currentUser.username : null;
  vm.Is_2fa_Enable = false;
  vm.qr = null;
  vm.code = null;
  vm.loadingQr = false;
  vm.loading2fa = true;

  (function init() {
    vm.loading2fa = true;
    check2fa();
  })();

  function check2fa() {
    vm.loading2fa = true;
    UserFactory.requires2fa(role)
      .then(function (res) {
        // console.log('requires2fa res', res);
        vm.Is_2fa_Enable = true;
      })
      .catch(function (err) {
        // console.log('error@requires2fa', err);
        vm.Is_2fa_Enable = false;
      })
      .finally(function () {
        vm.loading2fa = false;
      });
  }

  vm.enable2fa = function () {
    vm.loadingQr = true;
    UserFactory.init2fa()
      .then(function (res) {
        // console.log('init2fa res', res);
        vm.qr = res.data.qr;
        vm.loadingQr = false;
      })
      .catch(function (err) {
        // console.log('error@init2fa', err);
        vm.loadingQr = false;
        toastr.error(
          $translationService.getTranslationController(
            "error al generar el código QR",
            "error generating QR code",
            "erro ao gerar o código QR"
          )
        );
      });
  };

  vm.confirm2fa = function () {
    vm.loading2fa = true;
    UserFactory.confirm2fa(vm.code)
      .then(function (res) {
        // console.log('confirm2fa res', res);
        vm.loading2fa = false;
        toastr.success(
          $translationService.getTranslationController(
            "autenticación de dos factores habilitada",
            "two-factor authentication enabled",
            "autenticação de dois fatores habilitada"
          )
        );
      })
      .catch(function (err) {
        // console.log('error@confirm2fa', err);
        vm.loading2fa = false;
        vm.code = null;
        toastr.error(
          $translationService.getTranslationController(
            "código de autenticación de dos factores incorrecto",
            "two-factor authentication code incorrect",
            "código de autenticação de dois fatores incorreto"
          )
        );
      })
      .finally(function () {
        check2fa();
      });
  };

  vm.disable2fa = function () {
    UserFactory.disable2fa(username)
      .then(function (res) {
        // console.log('disable2fa res', res);
        toastr.success(
          $translationService.getTranslationController(
            "autenticación de dos factores deshabilitada",
            "two factor authentication disabled",
            "autenticação de dois fatores desabilitada"
          )
        );
      })
      .catch(function (err) {
        console.log("error@disable2fa", err);
      })
      .finally(function () {
        check2fa();
      });
  };
}

"use strict";
var app = angular.module("dashboard");
app.component("uploader", {
  templateUrl: "app/app-utils/components/uploader/uploader.html",
  controllerAs: "ctrl",
  bindings: {
    label: "@",
    directory: "@",
    valid: "@",
  },
  controller: uploaderController,
});
uploaderController.$inject = [
  "$scope",
  "$cookies",
  "toastr",
  "FileUploader",
  "FileSaver",
];
function uploaderController($scope, $cookies, toastr, FileUploader, FileSaver) {
  var vm = this;
  vm.uploader = null;
  vm.uploader = new FileUploader({
    url: "/risk-backend/rest/" + vm.directory,
    headers: { token: $cookies.get("token") },
    formData: { creationDate: moment() },
    removeAfterUpload: true,
  });

  vm.uploader.onWhenAddingFileFailed = function (
    item /*{File|FileLikeObject}*/,
    filter,
    options
  ) {
    console.info("onWhenAddingFileFailed", item, filter, options);
  };
  vm.uploader.onAfterAddingFile = function (fileItem) {
    console.info("onAfterAddingFile", fileItem);
  };
  function replaceSpecialCharacters(filename) {
    var parts = filename.split(".");
    var extension = parts.pop();
    var name = parts.join(".");
    name = name.toLowerCase();
    name = name.replace(/[^a-z0-9\s]/g, "");
    name = name.replace(/\s+/g, "_");
    return name + "." + extension;
  }
  vm.uploader.onAfterAddingAll = function (addedFileItems) {
    // addedFileItems.forEach(function (item) {
    //   var newName = replaceSpecialCharacters(item.file.name);
    //   item.file.name = newName;
    // });
    console.info("onAfterAddingAll", addedFileItems);
  };
  vm.uploader.onBeforeUploadItem = function (item) {
    console.info("onBeforeUploadItem", item);
  };
  vm.uploader.onProgressItem = function (fileItem, progress) {
    console.info("onProgressItem", fileItem, progress);
  };
  vm.uploader.onProgressAll = function (progress) {
    console.info("onProgressAll", progress);
  };
  vm.uploader.onSuccessItem = function (fileItem, response, status, headers) {
    console.info("onSuccessItem", fileItem, response, status, headers);
  };
  vm.uploader.onErrorItem = function (fileItem, response, status, headers) {
    console.info("onErrorItem", fileItem, response, status, headers);
  };
  vm.uploader.onCancelItem = function (fileItem, response, status, headers) {
    console.info("onCancelItem", fileItem, response, status, headers);
  };
  vm.uploader.onCompleteItem = function (fileItem, response, status, headers) {
    console.info("onCompleteItem", fileItem, response, status, headers);
  };
  vm.uploader.onCompleteAll = function () {
    console.info("onCompleteAll");
  };

  console.info("uploader", vm.uploader);
}

"use strict";

var app = angular.module('dashboard');

app.component('toolBar', {
    templateUrl: 'app/app-utils/components/tool-bar/tool-bar.html',
    controllerAs: 'ctrl',
    bindings: {
        data: '@',
    },
    controller: toolBarController,
});

toolBarController.$inject = ['$scope', 'translationService'];
function toolBarController($scope, $translationService) {
	var vm = this;
}

"use strict";

var app = angular.module('dashboard');

app.component('tabsBar', {
  templateUrl: 'app/app-utils/components/tabs-bar/tabs-bar.html',
  controllerAs: 'ctrl',
  bindings: {
    tabs: "=",
    isActive: "=",
    setTab: "=",
    delTab: "=",
  },
  controller: tabsBarController,
});

tabsBarController.$inject = ['translationService'];
function tabsBarController($translationService) {
  var vm = this;
  vm.text = {
    close : $translationService.getTranslationController('Cerrar', 'Close', 'Fechar')
  }
}

'use strict';

var app = angular.module('dashboard');
app.component('tableInputList', {
  templateUrl:
    'app/app-utils/components/table-input-list/table-input-list.html',
  controllerAs: 'ctrl',
  bindings: {
    listId: '=',
    schemaId: '=',
  },
  controller: TableInputList,
});

TableInputList.$inject = [
  '$scope',
  '$rootScope',
  '$state',
  '$stateParams',
  '$mdDialog',
  'toastr',
  'formats',
  'SchemasService',
  'listService',
  'translationService',
  'tableListConstants',
  'InputListsFactory',
  'ConfigurationFactory',
  'cellTemplateFormatService',
  'IssuesFactory',
];

function TableInputList(
  $scope,
  $rootScope,
  $state,
  $stateParams,
  $mdDialog,
  $toastr,
  $formats,
  $schemasService,
  $listService,
  $translationService,
  $tableListConstants,
  $inputListsFactory,
  $ConfigurationFactory,
  $cellTemplateFormatService,
  $issuesFactory
) {
  var vm = this;

  // console.log('TableInputList');
  // console.log('listId', zId);
  // console.log('schemaId', vm.schemaId);
  // console.log('customReport', vm.customReport);

  var listID = $scope.params && $scope.params.listID ? listID : zId;
  $translationService.getTranslation($scope, 'input-list');
  $rootScope.loading = true;

  vm.schemasFormat = [];

  z = {};
  vm.dataList = [];
  vm.showTable = false;
  vm.columns = [];
  vm.schema = [];
  vm.groups = [];
  vm.showTable = false;
  vm.shouldShowFilters = false;
  vm.filters = $tableListConstants.defaultFiltersTemplate;
  vm.tableIsLoading = false;

  vm.gridOptions = {
    rowTemplate:
      '<div ng-click="grid.appScope.ctrl.showHtmlCard(row.entity)" ng-mouseover="grid.appScope.ctrl.onHover(row.entity)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>',
    minimumColumnSize: 100,
    // Grid pagination options
    useExternalPagination: true,
    paginationPageSizes: [25, 50, 100],
    paginationPageSize: 100,
    totalItems: 0,
    // Grid sorting options
    useExternalSorting: true,
    onRegisterApi: function (gridApi) {
      $scope.gridApi = gridApi;
      gridApi.pagination.on.paginationChanged(
        $scope,
        function (newPage, pageSize) {
          vm.filters.pagination.page = newPage;
          vm.filters.pagination.itemsPerPage = pageSize;

          _getListData();
        }
      );
      gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        if (sortColumns[0]) {
          var colField = sortColumns[0].field.split('.')[0];
          vm.filters.pagination.sortBy = colField;
          vm.filters.pagination.sort = sortColumns[0].sort.direction;
        } else {
          vm.filters.pagination.sortBy = null;
        }

        _getListData();
      });
    },
  };

  $scope.params = {
    listId: listID,
    filters: {
      luceneQueryId: $stateParams.luceneQueryId,
      predicates: JSON.parse($stateParams.filters),
    },
  };

  vm.hoveredRow = null;
  vm.onHover = function (row) {
    // console.log('onhover', row);
    vm.hoveredRow = row;
  };

  vm.clearHoveredRow = function () {
    vm.hoveredRow = null;
  };

  function _getColumnDefinition(key) {
    key = key.indexOf('#') === 0 ? key.substring(1) : key;

    return vm.schema[key];
  }

  $rootScope.$on('refresh', function () {
    console.log('okoo');
    vm.init();
  });

  vm.init = function () {
    vm.filters.predicates = [];
    var promises = [
      $inputListsFactory.getInputList(listID),
      $inputListsFactory.getInputListFilters(listID),
      _getConfigFormatSchema(),
    ];

    Promise.allSettled(promises)
      .then(function (res) {
        // console.log(promises);
        z = res[0].value;
        vm.schema = $schemasService.parseSchema(vm.list.schema);
        vm.columnfilters = res[1].value;
        vm.schemasFormat = res[2].status == 'fulfilled' ? res[2].value : [];
      })
      .then(function () {
        _renderList();
        _setColumnDefs()
          .then(function () {
            if (
              $scope.params.filters &&
              $scope.params.filters != null &&
              $scope.params.filters != 'null' &&
              $scope.params.filters.predicates
            ) {
              _setDefaultFilters();
            }

            _getListData();
          })
          .catch(function () {
            $toastr.warning(
              $translationService.getTranslationController(
                'No hay columnas visibles en el esquema.',
                'There is no columns visible on schema',
                'Não há colunas visíveis no esquema'
              )
            );
            $rootScope.loading = false;
          });
      })
      .catch(function (error) {
        console.error('Error@getInputList/getInputListFilters', error);
      });
  };
  vm.init();

  function _setDefaultFilters() {
    vm.filters.predicates = [];
    $scope.params.filters.predicates.forEach(function (filter) {
      if (filter.field == 'id') {
        vm.filters.predicates.push({
          label: filter.field,
          fieldName: filter.field,
          operation: 'IN',
          values: filter.values,
          value: null,
          valuesLabels: null,
        });
      } else {
        var colDef = _getColumnDefinition(filter.field);
        if (typeof filter.value == 'object') {
          filter.value.forEach(function (item) {
            vm.filters.predicates.push({
              label: colDef.displayName || colDef.key,
              fieldName: filter.field,
              operation: 'EQUAL',
              values: null,
              value: item,
              valuesLabels: null,
            });
          });
        } else {
          vm.filters.predicates.push({
            label: colDef.displayName || colDef.key,
            fieldName: filter.field,
            operation: 'EQUAL',
            values: null,
            value: filter.value,
            valuesLabels: null,
          });
        }
      }
    });
    vm.isFiltered = true;
  }

  function _setColumnDefs() {
    return new Promise(function (resolve, reject) {
      vm.gridOptions.columnDefs = [];

      angular.forEach(vm.schema, function (col, key) {
        if (col.visible) {
          var colDef = {
            order: col.order,
            name: key,
            displayName: col.displayName || key,
            field: col.pk ? '#' + key : key,
            cellFilter: $tableListConstants.cellFilters[col.type] || null,
            // General column properties
            enableColumnMenu: true,
            enableSorting: true,
            enableHiding: false,
            aux: col,
            menuItems: [
              {
                title: $translationService.getTranslationController(
                  'Reemplazar',
                  'Replace',
                  'Substituir'
                ),
                icon: 'ui-grid-icon-pencil',
                shown: function () {
                  var hasFilters = vm.columnfilters.find(function (e) {
                    return (
                      e.field.replace('#', '') == col.key ||
                      e.label == col.displayName
                    );
                  });

                  return hasFilters ? true : false;
                },
                action: function ($event) {
                  this.context.showReplaceDialog($event, col);
                },
                context: vm,
              },
              {
                title: $translationService.getTranslationController(
                  'Filtrar',
                  'Filter',
                  'Filtro'
                ),
                icon: 'ui-grid-icon-filter',
                shown: function () {
                  var hasFilters = vm.columnfilters.find(function (e) {
                    return e.field == col.key || e.label == col.displayName;
                  });

                  return hasFilters ? true : false;
                },
                action: function ($event) {
                  this.context.addFilterTo($event, col);
                },
                context: vm,
              },
            ],
          };

          colDef.cellTemplate = $cellTemplateFormatService.setTemplate(
            colDef,
            col,
            vm.schemasFormat
          );
          vm.gridOptions.columnDefs.push(colDef);
        }
      });

      vm.gridOptions.columnDefs = vm.gridOptions.columnDefs.sort(function (
        a,
        b
      ) {
        return a.order - b.order;
      });

      if (vm.gridOptions.columnDefs.length) {
        resolve();
      }
      reject();
    });
  }

  function _getListData() {
    vm.tableIsLoading = true;
    vm.filters.luceneQueryId = $scope.params.filters.luceneQueryId;
    $inputListsFactory
      .getInputListDataFiltered(listID, vm.filters)
      .then(function (res) {
        vm.gridOptions.totalItems = res.pagination.totalRecords;
        vm.dataList = res.data.map(function (e) {
          return {
            dataId: e.dataId,
            body: angular.fromJson(e.body),
          };
        });

        vm.gridOptions.data = vm.dataList.map(function (e) {
          e.body.__dataId = e.dataId;
          return e.body;
        });

        vm.filterlist = vm.dataList;
        _getMetadataList();
      })
      .catch(function (err) {
        console.error('Error@getInputListData', err);
      })
      .finally(function () {
        vm.tableIsLoading = false;
      });
  }

  function _getMetadataList() {
    var noGroupTag = $translationService.getTranslationController(
      'otros',
      'others',
      'otros'
    );

    $inputListsFactory
      .getInputListMetadata(listID)
      .then(function (res) {
        var mapData = res.columns.map(function (e) {
          var cleanColName = e.name.replace('#', '');

          var col = {
            field: e.name,
            title:
              vm.schema[cleanColName] && vm.schema[cleanColName].displayName
                ? vm.schema[cleanColName].displayName
                : e.name,
            type: e.type,
            show: vm.schema[cleanColName].visible || true,
            group: vm.schema[cleanColName]
              ? angular.isUndefined(vm.schema[cleanColName].group)
                ? noGroupTag
                : vm.schema[cleanColName].group
              : noGroupTag,
            order: vm.schema[cleanColName]
              ? vm.schema[cleanColName].order
              : '1',
            sortable: e.name,
            filterable: { type: 'text' },
            readonly: e.readonly,
            width: 30,
          };
          return col;
        });

        vm.columns = mapData.sort(function (a, b) {
          return a.order - b.order;
        });

        vm.groups = vm.columns.map(function (ele) {
          var item = ele.group;
          if (typeof item === 'string' && item != undefined) {
            return item;
          }
        });
        //- grupos para cliente card
        vm.groups = vm.groups.filter(function (value, index) {
          return vm.groups.indexOf(value) == index;
        });

        $rootScope.loading = false;
      })
      .catch(function (err) {
        console.error('Error@getInputListMetadata', err);
      });
  }

  vm.onClickListRow = function (item) {
    var _item = {
      dataId: item.__dataId,
      body: item,
    };
    $mdDialog.show({
      controller: 'clientCardController',
      controllerAs: 'ctrl',
      templateUrl: 'app/app-utils/components/client-card/client-card.html',
      clickOutsideToClose: false,
      locals: {
        title: $translationService.getTranslationController(
          'Editor de datos',
          'Data editor',
          'Editor de dados'
        ),
        listId: vm.list.listId,
        inputs: _item,
        inputsTypes: vm.columns,
        groups: vm.groups,
        listSchema: vm.schema,
      },
    });
  };

  vm.showIssueDialog = function (event, issueUuid) {
    if (!issueUuid || issueUuid === '') return;
    var uuid = issueUuid.split('&')[1] || issueUuid.split('&')[0];
    $rootScope.loading = true;
    var promises = [_getIssuesByUuid(uuid), _getIssuesTypes()];
    Promise.allSettled(promises)
      .then(function (res) {
        var issue = res[0].status == 'fulfilled' ? res[0].value : false;
        var issueTypes = res[1].status == 'fulfilled' ? res[1].value : [];
        if (issue) {
          issue.cat;
          $mdDialog.show({
            controller: 'IssuesDetailDialogController',
            controllerAs: 'ctrl',
            templateUrl:
              'app/dashboard/components/issues-detail-dialog/issues-detail-dialog.html',
            parent: angular.element(document.body),
            targetEvent: null,
            clickOutsideToClose: false,
            multiple: true,
            locals: {
              issueTypes: issueTypes,
              currentIssueType: issueTypes.find(function (e) {
                return e.id == issue.issueType.id;
              }),
              issue: issue,
              issuesToLink: [],
              currentCategory: issue.category,
            },
          });
        } else {
          $toastr.warning(
            $translationService.getTranslationController(
              'No se pudo cargar el issue',
              'Can load issue',
              'Can load issue '
            )
          );
        }
      })
      .finally(function () {
        $rootScope.loading = false;
      });
  };

  vm.getBack = function () {
    if ($stateParams.backTo) $state.go('app.' + $stateParams.backTo);
    else $state.go('app.schemasLists');
  };

  function _renderList() {
    var inputList = {
      cols: [],
      types: [],
    };

    angular.forEach(vm.schema, function (col, key) {
      inputList.types[(col.pk ? '#' : '') + key] = col.type;
      var referencedListId = col.metadata ? col.metadata.id : null;
      var colDefinition = _getInputType(
        col.type,
        referencedListId,
        col.autocomplete,
        col.inputFormat,
        col.outputFormat,
        col.readonly
      );
      colDefinition.data = (col.pk ? '#' : '') + key;
      colDefinition.title = key + (col.required || col.pk ? '*' : '');
      inputList.cols.push(colDefinition);
    });

    vm.inputList = inputList;
  }

  function _getInputType(
    input,
    list,
    autocomplete,
    inputFormat,
    outputFormat,
    readonly
  ) {
    var sequentialSourceFn = function (query, process) {
      $inputListsFactory.getInputListData(list, {}, false).then(function (res) {
        var source = res.data.map(function (e) {
          var res = angular.fromJson(e.body);
          if (res.$visible) delete res.$visible;
          return Object.values(res)[0];
        });
        process(source);
      });
    };

    return $listService.getInputType(
      input,
      autocomplete,
      inputFormat,
      outputFormat,
      readonly,
      sequentialSourceFn
    );
  }

  vm.unFilterData = function () {
    vm.filters.predicates = [];
    vm.isFiltered = false;
    _getListData();
  };

  vm.removeFilter = function (index) {
    vm.filters.predicates.splice(index, 1);
    if (!vm.filters.predicates.length) {
      vm.isFiltered = false;
    }
    _getListData();
  };

  vm.addFilterTo = function (event, col) {
    col.name = col.displayName || col.key;
    var selectedColumnFilters = vm.columnfilters.find(function (e) {
      return e.field == col.key || e.label == col.displayName;
    });

    if (!selectedColumnFilters) {
      $toastr.warning(
        $translationService.getTranslationController(
          'No hay filtros disponibles para la columna ',
          'There is no filters available for column ',
          'Não há filtros disponíveis para coluna '
        ) + col.name
      );
      return;
    }

    $mdDialog
      .show({
        controller: 'IssuesFiltersDialogController',
        controllerAs: 'ctrl',
        templateUrl:
          'app/dashboard/components/issues-filters-dialog/issues-filters-dialog.html',

        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: false,
        locals: {
          column: col,
          columnFilters: selectedColumnFilters,
        },
      })
      .then(function (predicate) {
        predicate.value = _formatPredicateValue(col, predicate.value);
        vm.filters.predicates.push(predicate);
        vm.isFiltered = true;

        _getListData();
      });
  };

  function _formatPredicateValue(col, value) {
    var formats = angular.copy($formats.defaults);
    formats.timestamp = 'YYYY-MM-DDTHH:mm:ssZ';

    if (
      ['date', 'time', 'timestamp'].includes(col.type) &&
      moment.isMoment(value)
    ) {
      return value.format(formats[col.type]);
    }

    return value;
  }

  vm.showReplaceDialog = function (ev, col) {
    var colTypes = [];
    angular.forEach(vm.columns, function (e) {
      colTypes[e.field] = e.type;
    });

    $inputListsFactory.setSelectedCol((col.pk ? '#' : '') + col.key);

    $mdDialog.show({
      controller: 'ListReplaceController',
      templateUrl: 'app/input-list/components/list-replace/list-replace.html',
      locals: {
        listId: vm.list.listId,
        cellValue: '',
        colTypes: colTypes,
      },
      parent: angular.element(document.body),
      targetEvent: ev,
      hasBackdrop: false,
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
    });
  };

  vm.parsePredicateValue = function (predicate) {
    if (vm.schema[predicate.fieldName.replace('#', '')].type == 'date') {
      return moment(predicate.value).format('DD-MM-YYYY');
    }

    return predicate.value;
  };

  $scope.$on('listFiltered', function (e, filter) {
    var predicate = {
      fieldName: filter.column,
      label: filter.column,
      operation: 'EQUAL',
      value: filter.conditionValue,
      values: null,
      valuesLabels: null,
    };

    vm.filters.predicates.push(predicate);
    vm.isFiltered = true;

    _getListData();
  });

  function _getConfigFormatSchema() {
    return new Promise(function (resolve, reject) {
      $ConfigurationFactory
        .getSchemaFormat()
        .then(function (res) {
          if (res.data.length == 0) {
            resolve([]);
          }
          var schemaMap = res.data.map(function (schema) {
            schema.body = JSON.parse(schema.body);
            return schema;
          });
          resolve(schemaMap);
        })
        .catch(function (err) {
          console.error('Error@getSchemaFormat', err);
          reject(err);
        });
    });
  }

  function _getIssuesByUuid(issueUuid) {
    return new Promise(function (resolve, reject) {
      $issuesFactory
        .getIssueByUUID(issueUuid)
        .then(function (res) {
          resolve(res);
        })
        .catch(function (err) {
          console.error('Error@_getIssuesByUuid', err);
          reject(err);
        });
    });
  }

  function _getIssuesTypes() {
    return new Promise(function (resolve, reject) {
      $issuesFactory
        .getIssuesTypes()
        .then(function (res) {
          resolve(res);
        })
        .catch(function (err) {
          console.error('Error@_getIssuesTypes', err);
          reject(err);
        });
    });
  }

  vm.showHtmlCard = function (row) {
    var tab = {
      row: angular.copy(row),
      schema: angular.copy(vm.schema),
      schemaId: z.schema.id,
    };
    vm.clickRow(tab);
  };
}

"use strict";

var app = angular.module("dashboard");

app.component("tableData", {
  templateUrl: "app/app-utils/components/table-data/table-data.html",
  controllerAs: "ctrl",
  bindings: {
    tableName: "@",
    schemaName: "@",
    isWidget: "@",
    widgetConfig: "<",
    reload: "@",
    container: "@",
  },
  controller: tableDataViewController,
});

tableDataViewController.$inject = [
  "$scope",
  "$state",
  "$mdDialog",
  "toastr",
  "$rootScope",
  "translationService",
  "dataTableService",
  "PermissionsFactory",
];

function tableDataViewController(
  $scope,
  $state,
  $mdDialog,
  $toastr,
  $rootScope,
  $translationService,
  $dataTableService,
  PermissionsFactory
) {
  var vm = this;
  var editionStatus = ["Autofill.fill", "edit", "imported"];
  vm.importedData = null;

  $translationService.getTranslation(vm, "data-management");

  $dataTableService.registerCustomEditors($scope);

  $rootScope.loading = false;

  $scope.$watchCollection("ctrl.importedData", function (newCollection) {
    if (!newCollection) return;
    if (newCollection.data.length == 0) return;
    else {
      var set = newCollection.addTocurrentData
        ? vm.data.concat(newCollection.data)
        : newCollection.data;

      _updateDataTable(set);
      vm.dataHasChanged = true;
      // document.getElementById('fileImportArea').value = null;
    }
  });

  vm.isLoading = true;
  vm.data = [];
  vm.cols = null;
  vm.filters = [];
  vm.pagination = {
    page: 1,
    itemsPerPage: vm.isWidget ? 1000 : 100,
    sort: "asc",
    sortBy: "",
  };
  vm.predicates =
    vm.widgetConfig && vm.widgetConfig.filter ? vm.widgetConfig.filter : [];
  vm.rowsToDelete = [];
  vm.indexRowSelected = null;
  vm.errorMsg = false;
  vm.dataHasChanged = false;
  vm.infoMessage = "...loading";

  vm.tableuuid = "data-table-" + new Date().getTime();

  var container;
  $scope.hot;

  vm.settings = {
    width: "100%",
    height: 600,
    stretchH: "all",
    colHeaders: true,
    rowHeaders: true,
    manualColumnResize: true,
    manualRowResize: true,
    allowInvalid: true,
    columnHeaderHeight: 10,
    className: "htCenter",
    outsideClickDeselects: false,
    hiddenColumns: null,
    licenseKey: "non-commercial-and-evaluation",
    copyPaste: true,

    contextMenu: {
      items: {
        row_above: {
          name: $translationService.getTranslationController(
            "Fila encima",
            "Row above",
            "Fila acima"
          ),
        },
        row_below: {
          name: $translationService.getTranslationController(
            "Fila debajo",
            "Row below",
            "Fila abaixo"
          ),
        },
        remove_row: {
          name: $translationService.getTranslationController(
            "Eliminar fila",
            "Remove row",
            "Remover fila"
          ),
        },
        divider1: {
          name: "---------",
        },
        edit: {
          name: $translationService.getTranslationController(
            "edición masiva",
            "Bulk edit",
            "Edição em massa"
          ),
          callback: function (key, selection, clickEvent) {
            var col = selection[0].end.col;
            vm.bulkEedit(clickEvent, col);
          },
        },
        filter: {
          name: $translationService.getTranslationController(
            "Filter",
            "Filter",
            "Filter"
          ),
          callback: function (key, selection, clickEvent) {
            vm.filterTableManagement();
          },
        },
        sorting: {
          name: $translationService.getTranslationController(
            "Orden",
            "Sort",
            "Sort"
          ),
          callback: function (key, selection, clickEvent) {
            var col = selection[0].end.col;
            vm.onSort(clickEvent, col);
          },
        },
        divider2: {
          name: "---------",
        },
        undo: {
          name: $translationService.getTranslationController(
            "Deshacer",
            "Undo",
            "Desfazer"
          ),
        },
        redo: {
          name: $translationService.getTranslationController(
            "Rehacer",
            "Redo",
            "Refazer"
          ),
        },
      },
    },
    columns: null,
    data: null,
    dataSchema: {},
    afterCreateRow: function (indexRow) {
      var hasBooleanColumn =
        vm.cols.filter(function (c) {
          return c.colType === "boolean";
        }) || false;

      if (hasBooleanColumn === false) return;

      hasBooleanColumn.forEach(function (c) {
        var order = c.order || 0;
        $scope.hot.setDataAtCell(indexRow, order, false);
        vm.data[indexRow][c.data] = false;
      });
    },
    afterSelectionEnd: function (x) {
      vm.indexRowSelected = x;
    },
    beforeRemoveRow: function (from, to, ArrayRemovedRows, source) {
      angular.forEach(ArrayRemovedRows, function (row) {
        vm.rowsToDelete.push({ id_row: vm.data[row].id_row });
      });

      vm.dataHasChanged = true;
      vm.infoMessage = vm.translation.changesNotSaved;
    },
    beforeChange: function (changes, source) {
      if (editionStatus.includes(source)) {
        changes.forEach(function (cellchanges) {
          var row = cellchanges[0];
          var col = $scope.hot.propToCol(cellchanges[1]);
          vm.data[row]._ROW_STATUS_ = source;
          vm.data[row][cellchanges[1]] = cellchanges[3];
          $scope.hot.getCellMeta(row, col).className = "htCenter cyan";
        });
        vm.dataHasChanged = true;
        vm.infoMessage = vm.translation.changesNotSaved;
      }
    },
    afterPaste: function (data, coords) {
      console.log("afterPaste", data, coords);
      var col = coords[0].startCol;
      var from = coords[0].startRow;
      var to = coords[0].endRow;
      for (var i = from; i <= to; i++) {
        vm.data[i]._ROW_STATUS_ = "edit";
        $scope.hot.getCellMeta(i, col).className = "htCenter cyan";
      }
      vm.dataHasChanged = true;
      vm.infoMessage = vm.translation.changesNotSaved;
      // vm.data = data;
      // _updateDataTable(data);
      console.log("afterPaste", vm.data);
    },
    afterOnCellMouseDown: function (event, index) {
      console.log("afterOnCellMouseDown", index);
      if (index.row === -1) {
        vm.onSort(event, index.col);
      }
    },
  };

  vm.init = function () {
    vm.isTextSearch = false;
    $rootScope.loading = true;
    vm.isLoading = true;
    vm.infoMessage = "loading...";

    var promises = [
      $dataTableService.getTable(vm.tableName, vm.schemaName),
      $dataTableService.getTableFilters(vm.tableName, vm.schemaName),
      $dataTableService.getDataTable(
        vm.tableName,
        vm.schemaName,
        vm.pagination,
        vm.predicates
      ),
    ];

    Promise.allSettled(promises)
      .then(function (res) {
        // console.log(res);
        var table = res[0].value;
        var filters = res[1].value;
        var data = res[2].value;

        vm.pagination.page = data.pagination.page;
        vm.pagination.totalRecords = data.pagination.totalRecords;
        vm.totalItems = data.pagination.totalRecords;

        vm.tableId = table.id;
        vm.table = table;
        vm.filters = filters;
        var cols = $dataTableService.createColumns(table.columns, vm.filters);

        if (vm.isWidget && vm.widgetConfig) {
          vm.cols = cols
            .filter(function (c) {
              if (c.data === "id_row") return c;
              return vm.widgetConfig.columns.includes(c.data);
            })
            .map(function (c) {
              c.readOnly = true;
              return c;
            });
          vm.settings.contextMenu = null;
        } else {
          vm.cols = cols.map(function (c) {
            c.readOnly = c.data === "id_row" ? true : false;
            c.hidden = c.data === "id_row" ? true : false;
            return c;
          });
        }

        if (
          !PermissionsFactory.hasPermission(
            "data-management#" + vm.tableId + ":update"
          )
        ) {
          vm.cols.forEach(function (c) {
            c.readOnly = true;
          });
        }

        vm.settings.columns = vm.cols;
        vm.settings.dataSchema = $dataTableService.createDataSchema(vm.cols);
        vm.settings.hiddenColumns = {
          columns: vm.cols
            .filter(function (c, i) {
              return c.hidden === true;
            })
            .map(function (c, i) {
              return i;
            }),
          indicators: false,
        };

        if ($scope.hot) $scope.hot.destroy();

        setTimeout(function () {
          $scope.hot = new Handsontable(container, vm.settings);
          // console.log('hot', vm.settings);
          _updateDataTable(data.data);
          vm.dataHasChanged = false;
          vm.infoMessage = "data loaded";
          vm.isLoading = false;
          // if (
          //   PermissionsFactory.hasPermission(
          //     "data-management#" + vm.tableId + ":edit"
          //   ) === false
          // ) {
          //   vm.settings = Object.assign(vm.settings, {
          //     readOnly: true,
          //     contextMenu: false,
          //     disableVisualSelection: true,
          //     manualColumnResize: false,
          //     manualRowResize: false,
          //     comments: false,
          //   });
          // }

          $scope.hot.updateSettings(vm.settings);
          $rootScope.loading = false;
        }, 500);
      })
      .catch(function (err) {
        console.error("Error@PRomise", err);
        vm.isLoading = false;
        $rootScope.loading = false;
        vm.infoMessage = vm.translation.errorReadingData;
      });
  };

  vm.beforeInit = function () {
    setTimeout(function () {
      container = document.getElementById(vm.tableuuid);
      vm.init();
    }, 500);
  };
  vm.beforeInit();

  vm.loadMore = function () {
    vm.init();
  };

  vm.reload = function () {
    vm.infoMessage = "loading";
    $rootScope.loading = true;
    vm.isLoading = true;
    $dataTableService
      .getDataTable(vm.tableName, vm.schemaName, vm.pagination, vm.predicates)
      .then(function (res) {
        vm.data = res.data.map(function (r) {
          r._ROW_STATUS_ = "load";
          return r;
        });

        vm.pagination.page = res.pagination.page;
        vm.pagination.totalRecords = res.pagination.totalRecords;

        _updateDataTable(vm.data);
        vm.dataHasChanged = false;
        vm.infoMessage = "data loaded";
        $rootScope.loading = false;
        vm.isLoading = false;
      })
      .catch(function (err) {
        $rootScope.loading = false;
        vm.isLoading = false;
        console.error("Error@getDataTable", err);
      });
  };

  $scope.$on("reloadTable", function () {
    vm.reload();
  });

  vm.bulkEedit = function (ev, col) {
    $mdDialog
      .show({
        controller: "bulkEditController",
        controllerAs: "ctrl",
        templateUrl:
          "app/app-utils/components/table-data/dialogs/bulk-edit/bulk-edit.html",
        locals: {
          tableName: vm.tableName,
          schemaName: vm.schemaName,
          column: vm.cols[col] || null,
          columns: vm.cols,
        },
        parent: angular.element(document.body),
        hasBackdrop: true,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: true,
      })
      .then(function () {
        vm.reload();
      });
  };

  vm.onSort = function (ev, col) {
    vm.pagination.sortBy = vm.cols[col].data;
    vm.pagination.sort = vm.pagination.sort == "asc" ? "desc" : "asc";
    vm.reload();
  };

  vm.onSaveData = function (exit) {
    var promises = [];
    console.log("vm.data", vm.data);

    var editedRows = vm.data
      .filter(function (e) {
        return e.id_row != null && editionStatus.includes(e._ROW_STATUS_);
      })
      .map(function (e) {
        e = $dataTableService.validObject(e);
        delete e._ROW_STATUS_;
        return e;
      });

    var newRows = vm.data
      .filter(function (e) {
        return e.id_row == null && editionStatus.includes(e._ROW_STATUS_);
      })
      .map(function (e) {
        e = $dataTableService.validObject(e);
        delete e._ROW_STATUS_;
        return e;
      });

    if (newRows.length > 0) {
      promises.push(
        $dataTableService.insertTableData(vm.tableName, vm.schemaName, newRows)
      );
    }

    if (editedRows.length > 0) {
      promises.push(
        $dataTableService.updateTableData(
          vm.tableName,
          vm.schemaName,
          editedRows
        )
      );
    }

    vm.rowsToDelete = vm.rowsToDelete.filter(function (e) {
      return e.id_row != null;
    });

    if (vm.rowsToDelete.length > 0) {
      promises.push(
        $dataTableService.deleteTableData(
          vm.tableName,
          vm.schemaName,
          vm.rowsToDelete
        )
      );
    }

    if (promises.length == 0) {
      $toastr.success("Sin cambios");
      if (exit) {
        vm._onGoBack();
      }
      return;
    }
    vm.infoMessage = vm.translation.savingData;

    Promise.allSettled(promises)
      .then(function (res) {
        vm.rowsToDelete = [];

        var allRequestFufilled = res.every(function (item) {
          return item.status == "fulfilled";
        });

        if (allRequestFufilled) {
          vm.loadMore();
          vm.dataHasChanged = false;
          vm.infoMessage = vm.translation.Dataloaded;
        } else {
          res.forEach(function (item) {
            if (item.status == "rejected") {
              $toastr.error(item.reason.error || item.reason.message);
            }
          });
          vm.infoMessage = vm.translation.changesNotSaved;
        }

        if (exit) {
          vm._onGoBack();
        }
      })
      .catch(function (err) {
        console.error("error@save", err);
        $toastr.error(err.message || "Error");
      });
  };

  vm.insertRow = function (direction) {
    if (vm.indexRowSelected) {
      if (direction == "above") {
        $scope.hot.alter("insert_row", vm.indexRowSelected);
      }
      if (direction == "below") {
        $scope.hot.alter("insert_row", vm.indexRowSelected - 1);
      }
    } else {
      $scope.hot.alter("insert_row");
    }
    _updateHeight();
  };

  vm._onGoBack = function () {
    if (
      vm.dataHasChanged &&
      PermissionsFactory.hasPermission(
        "data-management#" + vm.tableId + ":edit"
      )
    ) {
      var confirm = $mdDialog
        .confirm()
        .title(vm.translation.save_and_exit)
        .textContent(vm.translation.changes_will_be_lost)
        .ariaLabel("exit_without_save")
        .ok(vm.translation.save_and_exit)
        .cancel(vm.translation.exit_without_save);
      $mdDialog.show(confirm).then(
        function () {
          vm.onSaveData("exit");
        },
        function () {
          $state.go("app.schemasTables", { schemaName: vm.schemaName });
        }
      );
    } else {
      $state.go("app.schemasTables", { schemaName: vm.schemaName });
    }
  };

  function _updateHeight() {
    var h = container.getBoundingClientRect();

    var height = h.height;
    vm.settings.height = height;

    if (vm.isWidget) {
      var widgetBox = container.parentElement;
      while (widgetBox) {
        if (widgetBox.classList.contains("widget-box")) {
          widgetBox.getBoundingClientRect();
          vm.settings.height = widgetBox.clientHeight - 229;
          break;
        }
        widgetBox = widgetBox.parentElement;
      }
    }

    $scope.hot.updateSettings(vm.settings);
  }

  function _updateDataTable(data) {
    console.log("data", data);
    var ndata = $dataTableService.normalizeData(data, vm.cols);

    vm.settings.dataSchema = $dataTableService.createDataSchema(vm.cols);
    vm.settings.data = ndata;
    vm.data = ndata;
    // console.log(vm.data);
    $scope.hot.loadData(vm.data);
    _updateHeight();
    vm.importedData = null;
    // document.getElementById('fileImportArea').value = null;
  }

  vm.onClearAll = function (ev) {
    var confirm = $mdDialog
      .confirm()
      .title(vm.translation.clearAll)
      .htmlContent(vm.translation.clearAllContent)
      .ariaLabel("ClearAll-Confirmation")
      .targetEvent(ev)
      .ok(vm.translation.yesClearAll)
      .cancel(vm.translation.notYet);

    $mdDialog.show(confirm).then(function () {
      $rootScope.loading = true;
      $dataTableService
        .truncateTable(vm.tableName, vm.schemaName)
        .then(function () {
          vm.importedData = null;
          $toastr.info(vm.translation.datacleared);
          vm.data = [];
          vm.filters = [];
          vm.pagination.totalRecords = 0;
          vm.pagination.page = 1;
          vm.dataHasChanged = false;
          vm.init();
        })
        .catch(function () {
          vm.errorMsg = true;
          vm.infoMessage = vm.translation.errorOnDeleteData;
          $toastr.warning(vm.infoMessage);
        })
        .finally(function () {
          $rootScope.loading = false;
        });
    });
  };

  vm.tableManagement = function () {
    $mdDialog
      .show({
        controller: "DialogTableManagement",
        controllerAs: "ctrl",
        templateUrl:
          "app/data-management/dialog-table-management/dialog-table-management.html",
        locals: {
          table: vm.table,
        },
        parent: angular.element(document.body),
        hasBackdrop: true,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: true,
      })
      .then(function (table) {
        $state.go("app.tableData", {
          schemaName: table.schemaName,
          tableName: table.tableName,
        });
      });
  };

  vm.filterTableManagement = function () {
    $mdDialog
      .show({
        controller: "tableDataFilterController",
        controllerAs: "ctrl",
        templateUrl:
          "app/app-utils/components/table-data/dialogs/filter/table-data-filter.html",
        locals: {
          table: vm.table,
          columns: vm.cols,
          selected: null,
          predicates: vm.predicates,
          translation: vm.translation,
        },
        parent: angular.element(document.body),
        hasBackdrop: true,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: true,
      })
      .then(function (predicates) {
        // console.log(predicates);
        vm.predicates = predicates;
        if (vm.isWidget && vm.widgetConfig) vm.widgetConfig.filter = predicates;
        vm.reload();
      });
  };

  vm.removePredicate = function (index) {
    vm.predicates.splice(index, 1);
    vm.reload();
  };

  vm._onExport = function (ext) {
    if (ext == "csv") {
      $rootScope.loading = true;
      var pagination = {
        page: 1,
        itemsPerPage: 99999,
      };
      $dataTableService
        .getDataTable(
          vm.tableName,
          vm.schemaName,
          pagination,
          vm.predicates,
          true
        )
        .then(function (res) {
          $rootScope.loading = false;
          $rootScope.$broadcast("refreshUserDocuments");
        })
        .catch(function (err) {
          $rootScope.loading = false;
          console.error("Error@getDataTable", err);
        });
    } else {
      $mdDialog
        .show({
          controller: "exportTableSelectorController",
          controllerAs: "ctrl",
          templateUrl:
            "app/app-utils/components/table-data/dialogs/export-table-selector/export-table-selector.html",
          clickOutsideToClose: false,
        })
        .then(function (val) {
          $rootScope.loading = true;
          var pagination;
          if (val === "this") {
            pagination = angular.copy(vm.pagination);
          } else {
            pagination = {
              page: 1,
              itemsPerPage: 99999,
            };
          }
          $dataTableService
            .getDataTable(
              vm.tableName,
              vm.schemaName,
              pagination,
              vm.predicates,
              false
            )
            .then(function (res) {
              var table = {
                name: vm.tableName,
                headers: vm.cols,
                data: res.data,
              };

              $dataTableService.export(ext, table);
              $rootScope.loading = false;

              $rootScope.loading = false;
            })
            .catch(function (err) {
              $rootScope.loading = false;
              console.error("Error@getDataTable", err);
            });
        });
    }
  };

  //- paginations
  vm.nextPage = function () {
    vm.pagination.page++;
    vm.reload();
  };

  vm.prevPage = function () {
    vm.pagination.page--;
    vm.reload();
  };

  vm.goToPage = function (page) {
    vm.pagination.page = page;
    vm.reload();
  };

  $scope.$on("reloadtabledata", function (event) {
    vm.reload();
  });

  vm.isTextSearch = false;

  $scope.$on("textSearch", function (e, data) {
    vm.data = data.map(function (r) {
      r.status = "load";
      return r;
    });
    _updateDataTable(data);
    vm.infoMessage = "Search text records";
    vm.isTextSearch = true;
  });
}

'use strict';

var app = angular.module('dashboard');
app.component('searcher', {
  templateUrl: 'app/app-utils/components/searcher/searcher.html',
  controllerAs: 'ctrl',
  bindings: {
    value: '=',
    placeholder: '@',
  },
  controller: searcherController,
});

function searcherController() {}

"use strict";

var app = angular.module("dashboard");
app.component("ruleServices", {
  templateUrl: "app/app-utils/components/rule-services/rule-services.html",
  controllerAs: "ctrl",
  controller: ruleServicesController,
});

ruleServicesController.$inject = ["$scope", "$rootScope", "HealthyFactory"];

function ruleServicesController($scope, $rootScope, $healthyFactory) {
  var vm = this;

}

"use strict";

var app = angular.module('dashboard');

app.component('roundButton', {
    templateUrl: 'app/app-utils/components/round-button/round-button.html',
    bindings: {
        onClick: "&",
        ariaLabel: "@",
        icon: "@"
    },
});

"use strict";

var app = angular.module("dashboard");
app.component("riskView", {
  templateUrl: "app/app-utils/components/riskview/riskview.html",
  controllerAs: "ctrl",
  controller: riskviewController,
  bindings: {
    config: "=",
  },
});

riskviewController.$inject = ["$scope", "DataTableFactory"];

function riskviewController($scope, $dataTableFactory) {
  var vm = this;
  vm.loading = true;

  var schemaName = vm.config.schemaName;
  // var gridName = vm.config.tableName;
  var dataSource = vm.config.dataSource;

  var max = 0;

  var grid_defs = {
    name: null,
    risks: [],
    impacts: [],
    ranges: [],
  };

  vm.grid_defs = grid_defs;

  vm.matrix = [];

  vm.permissionError = null;

  var init = function () {
    vm.loading = true;
    var promises = [
      _getDataTable(vm.config.tableName, schemaName),
      _getDataTable(vm.config.dataSource, schemaName),
    ];

    _get_grid_defs(promises);
  };
  init();

  $scope.$on("refres-risk-view", function () {
    console.log("refres-risk-view");
    init();
  });

  function _get_grid_defs(promises) {
    return new Promise(function (resolve, reject) {
      Promise.all(promises)
        .then(function (results) {
          console.log("results", results);
          var gridRow = results[0].data.find(function (e) {
            return e.name === vm.config.gridName;
          });

          if (!gridRow) {
            throw new Error("Grid not found");
          }

          var indicador_x = gridRow.indicador_x;
          var indicador_y = gridRow.indicador_y;
          var range_name = gridRow.range_name;

          vm.assest = {
            indicador_x: indicador_x,
            indicador_y: indicador_y,
            range_name: range_name,
          };

          var promises = [
            _getDataTable(indicador_x, schemaName),
            _getDataTable(indicador_y, schemaName),
            _getDataTable(range_name, schemaName),
          ];
          _get_grid_structure(promises);
          vm.loading = false;
        })
        .catch(function (err) {
          console.error("Error@_get_grid_defs", err);
          if (err.status == 403) {
            vm.permissionError = err;
          }
          reject(err);
        });
    });
  }

  function _get_grid_structure(promises) {
    vm.loading = true;
    return new Promise(function (resolve, reject) {
      Promise.all(promises)
        .then(function (results) {
          grid_defs.indicador_x = results[0].data.sort(_sortByValue);
          grid_defs.indicador_y = results[1].data.sort(_sortByValue).reverse();
          grid_defs.ranges = results[2].data.sort(_sortByValue);
          max = grid_defs.indicador_y.length * grid_defs.indicador_x.length;
          vm.loading = false;
          _grid_data();
        })
        .catch(function (err) {
          console.error("Error@_get_grid_structure", err);
          if (err.status == 403) {
            vm.permissionError = err;
          }
          reject(err);
        });
    });
  }

  vm.isEmpty = false;
  function _grid_data() {
    return new Promise(function (resolve, reject) {
      vm.loading = true;
      _getDataTable(dataSource, schemaName)
        .then(function (res) {
          grid_defs.data = res.data;
          vm.isEmpty = res.data.length == 0;
          _generateMatrix();
          _generateStatistics();
          vm.loading = false;
        })
        .catch(function (err) {
          console.error("Error@_grid_data", err);
          if (err.status == 403) {
            vm.permissionError = err;
          }
          reject(err);
        });
    });
  }

  function _generateMatrix() {
    var _matrix = [];

    for (var index = 0; index < grid_defs.indicador_y.length; index++) {
      var indicador_y = grid_defs.indicador_y[index];
      var row = [];

      for (var j = 0; j < grid_defs.indicador_x.length; j++) {
        var indicador_x = grid_defs.indicador_x[j];

        var risk_level = indicador_y.value * indicador_x.value;

        var range_level = grid_defs.ranges.find(function (e) {
          var percent_to_value = (e.value * max) / 100;

          return percent_to_value >= risk_level;
        });

        var pos = [indicador_y.value, indicador_x.value];

        var value = grid_defs.data
          .filter(function (e) {
            return (
              e.indicador_y === indicador_y.value &&
              e.indicador_x === indicador_x.value
            );
          })
          .reduce(function (acc, e) {
            return acc + e.total;
          }, 0);

        var cell = {
          risk: indicador_y,
          impact: indicador_x,
          range_level: range_level,
          risk_level: risk_level,
          pos: pos,
          value: value,
        };

        row.push(cell);
      }
      _matrix.push(row);
    }

    vm.matrix = _matrix;
  }

  vm.issues_card = {};

  function _generateStatistics() {
    vm.grid_defs.data.forEach(function (e) {
      var _key = e.issue_name.replace(/ /g, "_").toLowerCase();

      var _rules = vm.grid_defs.data
        .filter(function (r) {
          return r.issue_name === e.issue_name;
        })
        .reduce(function (acc, r) {
          var _key_rule = r.rule_name.replace(/ /g, "_").toLowerCase();
          var _key_rue_impact = r.impact;
          var _key_rue_risk = r.risk;
          var __key = _key_rule + "_" + _key_rue_risk + "_" + _key_rue_impact;

          if (!acc[__key]) {
            acc[__key] = {
              name: r.rule_name,
              impact: r.indicador_y,
              risk: r.indicador_x,
              total: r.total,
              level: _getRiskLevel(r.indicador_x, r.indicador_y, vm.grid_defs.ranges),
            };
            return acc;
          }
          acc[__key].total += r.total;
          return acc;
        }, {});

      var totals = [];
      angular.copy(grid_defs.ranges).forEach(function (r) {
        var rules_values = Object.values(_rules)
          .filter(function (e) {
            if (!r) return false;
            if (!e.level) return false;
            return e.level.id_row === r.id_row;
          })
          .map(function (e) {
            return e.total;
          })
          .reduce(function (acc, e) {
            return acc + e;
          }, 0);

        r.value = rules_values;
        totals.push(r);
      });

      if (!vm.issues_card[_key]) {
        vm.issues_card[_key] = {
          name: e.issue_name,
          rules: _rules,
          totals: totals,
        };
      }
    });
  }

  function _getRiskLevel(_risk, _impact, ranges) {
    var risk_level = _risk * _impact;

    var range_level = ranges.find(function (e) {
      var percent_to_value = (e.value * max) / 100;

      return percent_to_value >= risk_level;
    });
    return range_level;
  }

  function _getDataTable(tableName, schemaName) {
    return new Promise(function (resolve, reject) {
      $dataTableFactory
        .getDataTable(tableName, schemaName, {
          page: 1,
          itemsPerPage: 1000,
        })
        .then(function (res) {
          resolve(res);
        })
        .catch(function (err) {
          console.error("Error@_getDataTable", err);
          if (err.status == 403) {
            vm.permissionError = err;
          }
          reject(err);
        });
    });
  }

  function _sortByValue(a, b) {
    return a.value - b.value;
  }
}

'use strict';

var app = angular.module('dashboard');
app.component('riskLevel', {
  templateUrl: 'app/app-utils/components/risk-level/risk-level.html',
  controllerAs: 'ctrl',
  bindings: {
    level: '=',
    criticalities: '<',
    layout: '@',
    isLocked: '=',
  },
  controller: riskLevelController,
});

function riskLevelController() {
  var vm = this;
  vm.selected = null;
  vm.has_criticalities = false;

  vm.layout = vm.layout ? vm.layout : 'isrow';
  vm.onClick = function (val) {
    if (vm.isLocked) return;
    vm.level = val;
    vm.getSelected();
  };

  vm.getSelected = function () {
    if (vm.criticalities && vm.criticalities.length > 0) {
      vm.has_criticalities = true;
      var found = vm.criticalities.find(function (e) {
        return e.id == vm.level;
      });
      if (found) {
        vm.selected = found.name;
      }
    } else {
      vm.has_criticalities = false;
    }
  };

  vm.getSelected();
}

"use strict";

var app = angular.module("dashboard");
app.component("redisAlert", {
  templateUrl: "app/app-utils/components/redis-alert/redis-alert.html",
  controllerAs: "ctrl",
  controller: redisAlertController,
  bindings: {
    small: "<",
  },
});

redisAlertController.$inject = ["$scope", "$rootScope", "HealthyFactory"];

function redisAlertController($scope, $rootScope, $healthyFactory) {
  var vm = this;
  vm.small = angular.isDefined(vm.small) ? true : false;
  vm.redisIsConnected = false;
  vm.redisStatus = "Checking...";
  vm.loading = false;
  vm.delay = 60000 // 1 minute
  var timeOut = null
  
  function redisStatus() {
    vm.redisStatus = "Checking...";
    vm.loading = true;
    $healthyFactory
    .redisStatus()
    .then(function (response) {
      vm.loading = false;
      vm.redisIsConnected = response.data['redis-connection'];
      vm.redisStatus = vm.redisIsConnected ? "Connected" : "Disconnected";
    })
    .catch(function (err) {
      console.log("erro@redisStatus", err);
      vm.loading = false;
      vm.redisIsConnected = false;
      vm.redisStatus = "Error"
    }).finally(function () {
      timeOut = setTimeout(redisStatus, vm.delay);
    });
  }
  redisStatus();

  $scope.$on("$destroy", function () {
    clearTimeout(timeOut);
  });
}

'use strict';

var app = angular.module('dashboard');
app.component('pagination', {
  templateUrl: 'app/app-utils/components/pagination/pagination.html',
  controllerAs: 'ctrl',
  bindings: {
    pagination: '=',
    onClick: '&',
  },
  controller: paginationController,
});

paginationController.$inject = ['$scope'];

function paginationController($scope) {
  var vm = this;
  vm.maxPage = 0;

  vm.totalPages = function () {
    var mp = Math.round(
      vm.pagination.totalRecords / vm.pagination.itemsPerPage
    );
    vm.maxPage = mp;
    return mp;
  };

  vm.onClickPage = function (pageEvent) {
    if (pageEvent == 'next') {
      vm.pagination.page++;
    } else if (pageEvent == 'prev') {
      vm.pagination.page--;
    } else {
      vm.pagination.page = 1;
    }
    vm.onClick(vm.pagination);
  };
}

(function () {
  "use strict";

  angular.module("dashboard").controller("ngDialog", ngDialog);

  ngDialog.$inject = ["$scope", "$mdDialog", "props"];
  function ngDialog($scope, $mdDialog, props) {
    var vm = this;
    console.log, ("props", props);

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.save = function () {
      $mdDialog.hide(selection);
    };
  }
})();

'use strict';

var app = angular.module('dashboard');

app.component('mainDatepicker', {
  templateUrl: 'app/app-utils/components/main-datepicker/main-datepicker.html',
  controllerAs: 'ctrl',
  bindings: {
    onchange: '&',
  },
  controller: mainDatepickerController,
});

mainDatepickerController.$inject = [
  '$scope',
  '$rootScope',
  'translationService',
  '$state',
];
function mainDatepickerController(
  $scope,
  $rootScope,
  $translationService,
  $state
) {
  $translationService.getTranslation($scope, 'includes');
  var vm = this;
  vm.isDisplayed = true;

  // Default date values
  vm.desde = moment().startOf('day')
  vm.hasta = moment().endOf('day');
  $rootScope.desde = vm.desde;
  $rootScope.hasta = vm.hasta;

  vm.minDate = moment()

  // Views where component must be displayed
  vm.displayIn = [
    'app.home',
    'app.alarmas',
    'app.casos',
    'app.cases',
    // 'app.dashboard',
    'app.rule-executions',
    'app.audit',
  ];

  $scope.$watch(
    function () {
      return $state.$current.name;
    },
    function (newVal) {
      if (vm.displayIn.includes(newVal)) {
        vm.isDisplayed = true;
      } else {
        vm.isDisplayed = false;
      }
    }
  );

  vm.dateChanged = function () {
    $rootScope.desde = vm.desde;
    $rootScope.hasta = vm.hasta;
    console.log('Date changed: ', vm.desde, vm.hasta);
    vm.minDate = moment(vm.desde)
    $rootScope.$broadcast('refreshDatepickers');
    $rootScope.$broadcast('dateChange', {
      desde: vm.desde,
      hasta: vm.hasta,
      searchBtn: true,
    });
  };
}

"use strict";

var app = angular.module("dashboard");
app.component("listGroupsTree", {
  templateUrl:
    "app/app-utils/components/list-groups-tree/list-groups-tree.html",
  controllerAs: "ctrl",
  bindings: {
    groups: "=",
    selected: "=",
    level: "=",
  },
  controller: listGroupsTreeController,
});

function listGroupsTreeController() {
  console.log("listGroupsTreeController");
  var vm = this;
  vm.display = false;
  vm.current_level = vm.level ? vm.level : 0;
  vm.onDisplay = function () {
    vm.display = !vm.display;
  };
}

'use strict';

var app = angular.module('dashboard');
app.component('letterAvatar', {
  templateUrl: 'app/app-utils/components/letter-avatar/letter-avatar.html',
  controllerAs: 'ctrl',
  bindings: {
    data: '@',
    color: '<',
  },
  controller: LetterAvatarController,
});

function LetterAvatarController() {
  var vm = this;

  vm.colorClass = vm.color ? '' : getRandomColorClass();
  vm.label = vm.data.toUpperCase().substring(0, 2);
}

function getRandomColorClass() {
  var colorClasses = [
    'red',
    'pink',
    'purple',
    'deep-purple',
    'indigo',
    'blue',
    'light-blue',
    'cyan',
    'teal',
    'green',
    'light-green',
    'lime',
    'yellow',
    'amber',
    'orange',
    'deep-orange',
    'brown',
    'blue-grey',
    'grey',
  ];

  return colorClasses[Math.floor(Math.random() * colorClasses.length)];
}

"use strict";
var app = angular.module("dashboard");
app.component("jsonInput", {
  templateUrl: "app/app-utils/components/json-input/json-input.html",
  controllerAs: "ctrl",
  bindings: {
    row: "<", // one way binding
    col: "<",
  },
  controller: jsonInputController,
});

jsonInputController.$inject = ["$scope"];

function jsonInputController($scope) {
  var vm = this;
  vm.id = "jsonInput" + vm.row + vm.col;
  var data = $scope.$parent.hot.getDataAtCell(vm.row, vm.col);

  $scope.myJson = JSON.parse(JSON.stringify(data, null,4));

  $scope.aceChanged = function () {
    if ($scope.myJson === null) {
      return;
    }

    if (!isValidJson($scope.myJson)) {
      return;
    }
    $scope.$parent.hot.setDataAtCell(
      vm.row,
      vm.col,
      normalizeJson($scope.myJson)
    );
  };

  vm.closeEditor = function () {
    document
      .getElementsByClassName("jsonInputWrapper" + vm.row + vm.col)
      .forEach(function (element) {
        element.style.display = "none";
      });
  };

  function isValidJson(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }

  function normalizeJson(str) {
    return JSON.stringify(JSON.parse(str), null, 4);
  }
}

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller("fullTextSearchController", fullTextSearchController);

  fullTextSearchController.$inject = [
    "$scope",
    "$mdDialog",
    "toastr",
    "SearcherConfigurationFactory",
    "target",
  ];

  function fullTextSearchController(
    $scope,
    $mdDialog,
    $toastr,
    $searcherConfigurationFactory,
    target
  ) {
    var vm = this;
    vm.target = target;
    vm.searchText = "";
    vm.searchResults = [];
    vm.loading = false;
    vm.empty = {
      message: "No results found",
      show: false,
    };

    vm.search = function () {
      vm.loading = true;
      vm.empty.show = false
      vm.header = [];

      var pagination = {
        page: 1,
        itemsPerPage: 50,
      };

      $searcherConfigurationFactory
        .fullTextSearch(target, vm.searchText, pagination)
        .then(function (response) {

          vm.searchResults = response[target];

          if (target === "LIST") {
            if (vm.searchResults.length === 0) {
              $toastr.info("No results", "No results found for search text");
              vm.empty.show = true;
              return;
            }

            vm.searchResults.forEach(function (result) {
              if (result.data.length === 0) return;

              result.header = Object.keys(JSON.parse(result.data[0].body));

              result.data.forEach(function (data) {
                data.body = JSON.parse(data.body);
              });
            });
          }
          if (target === "ISSUES") {
            if (vm.searchResults.data.length === 0) {
              $toastr.info("No results", "No results found for search text");
              vm.empty.show = true;
              return;
            }

            vm.searchResults.header = Object.keys(vm.searchResults.data[0]);
          }
          if (target === "TABLE") {

            if (vm.searchResults.length === 0) {
              $toastr.info("No results", "No results found for search text");
              vm.empty.show = true;
              return;
            }

            vm.searchResults.forEach(function (result) {
              result.header = Object.keys(result.data[0]);

            })

            
          }
        })
        .catch(function (error) {
          console.error(error);
          $toastr.error("Error", "Error in search text");
        })
        .finally(function () {
          vm.loading = false;
        });
    };

    vm.clearSearch = function () {
      vm.searchText = "";
      vm.searchResults = [];
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

"use strict";

var app = angular.module("dashboard");
app.component("fullTextSearchBtn", {
  templateUrl:
    "app/app-utils/components/full-text-search/full-text-search-btn.html",
  controllerAs: "ctrl",
  bindings: {
    target: "@",
  },
  controller: fullTextSearchBtnController,
});

fullTextSearchBtnController.$inject = [
  "$scope",
  "$mdDialog"
];

function fullTextSearchBtnController(
  $scope,
  $mdDialog
) {
  var vm = this;

 vm.showDialog = function () {
    $mdDialog.show({
      controller: "fullTextSearchController",
      controllerAs: "ctrl",
      templateUrl: "app/app-utils/components/full-text-search/full-text-search.html",
      clickOutsideToClose: true,
      locals: {
        target: vm.target,
      },
    });
  }
}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('folderSelectorController', folderSelectorController);

  folderSelectorController.$inject = ['$scope', '$mdDialog', 'item', 'list'];
  function folderSelectorController($scope, $mdDialog, item, list) {
    var vm = this;
    vm.item = item || null;
    vm.list = angular.copy(list) || [];
    vm.breadcrumbs = [];
    vm.newFolderName = '';
    vm.newFolderItems = false;

    vm.root = function () {
      vm.currentFolder = vm.list;
      vm.breadcrumbs = [];
    };

    vm.openFolder = function (folder) {
      var folderGroup = [];
      for (var key in folder) {
        var val = folder[key];
        if (key.includes('folder:')) folderGroup.push(val);
      }
      vm.currentFolder = folderGroup;
      if (!folder.groupName) return;
      vm.breadcrumbs.push(folder.groupName);
    };

    vm.toFolder = function (target) {
      var list = angular.copy(vm.list);
      var breadcrumbs = angular.copy(vm.breadcrumbs);
      vm.breadcrumbs = [];
      for (var index = 0; index < breadcrumbs.length; index++) {
        var path = breadcrumbs[index];
        if (path === target) break;
        else {
          vm.breadcrumbs.push(path);
          list = list['folder:' + path];
        }
      }
      vm.openFolder(list['folder:' + target]);
    };

    vm.init = function () {
      vm.openFolder(vm.list);
    };
    vm.init();

    vm.createNewFolder = function () {
      vm.newFolderName = '';
      vm.newFolderItems = true;
    };
    vm.cancelNewFolder = function () {
      vm.newFolderName = '';
      vm.newFolderItems = false;
    };
    vm.addNewFolder = function () {
      vm.breadcrumbs.push(angular.copy(vm.newFolderName));
      vm.currentFolder = [];
      vm.cancelNewFolder();
    };

    vm.save = function () {
      var path = angular.copy(vm.breadcrumbs);
      $mdDialog.hide(path.join());
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

"use strict";
var app = angular.module("dashboard");
app.component("filePreview", {
  templateUrl: "app/app-utils/components/file-preview/file-preview.html",
  controllerAs: "ctrl",
  bindings: {
    file: "<", // one way binding
    folder: "<", // one way binding
    issueUuid: "<", // one way binding
  },
  controller: filePreviewController,
});

filePreviewController.$inject = [
  "$sce",
  "IssuesFactory",
  "FilesStorageFactory",
];

function filePreviewController($sce, $issuesFactory, $filesStorageFactory) {
  var vm = this;
  // vm.file = file;
  // vm.issueUuid = issueUuid;
  vm.preview = null;
  vm.loading = true;
  vm.ext = "other";
  var validExtensions = {
    image: ["jpg", "jpeg", "png"],
    video: ["mp4", "avi", "mov"],
    audio: ["mp3", "wav"],
    document: ["pdf","txt"],
  };

  $onInit();
  function $onInit() {
    if (vm.issueUuid && vm.file) {
      downloadIssueFile();
    } else {
      downloadFile();
    }
  }

  function downloadIssueFile() {
    $filesStorageFactory
      .downloadFile(vm.issueUuid, vm.file.name)
      .then(function (res) {
        getFileType(res);
      })
      .catch(function (err) {
        console.error("Error@downloadFile", err);
      });
  }

  function downloadFile() {
    $filesStorageFactory
      .downloadFile(vm.file.folderId, vm.file.id)
      .then(function (res) {
        getFileType(res.data);
      })
      .catch(function (err) {
        console.error("Error@downloadFile", err);
      });
  }

  function getFileType(file) {
    var file = new Blob([file], {
      type: vm.file.mimeType,
    });

    for (var key in validExtensions) {
      if (validExtensions.hasOwnProperty(key)) {
        var extensions = validExtensions[key];
        if (extensions.includes(vm.file.extension)) {
          vm.ext = key;
          break;
        }
      }
    }

    handlePreview(file, vm.ext);
  }

  function handlePreview(file, type) {
    console.log("handlePreview", file, type);
    if (type === "image") {
      blobToBase64(file).then(function (base64) {
        vm.preview = "data:image/gif;base64," + base64;
      });
    } else if (type === "video") {
      vm.preview = URL.createObjectURL(file);
    } else if (type === "audio") {
      vm.preview = URL.createObjectURL(file);
    } else if (type === "text") {
      var reader = new FileReader();
      reader.onload = function () {
        vm.preview = reader.result;
      };
      reader.readAsText(file);
    } else if (type === "document") {
      var pdf = URL.createObjectURL(file);
      vm.preview = $sce.trustAsResourceUrl(pdf);
    } else {
      vm.preview = "No preview available for this file type.";
    }
    vm.ext = type;
    vm.loading = false;
  }

  function blobToBase64(blob) {
    return new Promise(function (resolve, _) {
      var reader = new FileReader();
      reader.onloadend = function () {
        return resolve(reader.result.split(";base64,").pop());
      };
      reader.readAsDataURL(blob);
    });
  }
}

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller("filePreviewDialogController", filePreviewDialogController);

  filePreviewDialogController.$inject = ["$mdDialog", "file", "issueUuid"];

  function filePreviewDialogController($mdDialog, file, issueUuid) {
    var vm = this;
    vm.file = file;
    vm.issueUuid = issueUuid;
    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

(function () {
  "use strict";

  angular.module("dashboard").controller("dialogSelect", dialogSelect);

  dialogSelect.$inject = [
    "$scope",
    "$mdDialog",
    "$element",
    "title",
    "currentValue",
    "isMultiple",
    "list",
  ];
  function dialogSelect(
    $scope,
    $mdDialog,
    $element,
    title,
    currentValue,
    isMultiple,
    list
  ) {
    var vm = this;

    if (!Array.isArray(currentValue)) currentValue = [currentValue];

    $scope.title = title;
    vm.value = isMultiple
      ? angular.copy(currentValue || [])
      : angular.copy(currentValue || {});

    vm.selected = 0;

    vm.list = angular
      .copy(list || [])
      .map(function (item) {
        item.selected = false;

        var isSelected = function() {
          if(Array.isArray(vm.value))
            return  vm.value.find(function (value) { return value.id == item.id; });
          else
            return  vm.value && vm.value.id == item.id;
        }

        if (isSelected()) {
          item.selected = true;
        }

        return item;
      })
      .sort(function (a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });

    vm.isMultiple = isMultiple || false;

    $scope.searchTerm = "";

    vm.countSelections = function () {
      vm.selected = vm.list.filter(function (item) {
        return item.selected;
      }).length;
    };
    vm.countSelections();

    vm.clearSelections = function () {
      vm.list = vm.list.map(function (item) {
        item.selected = false;
        return item;
      });
      vm.countSelections();
    };

    vm.pickItem = function (item) {
      if (vm.isMultiple) {
        item.selected = !item.selected;
      } else {
        vm.list = vm.list.map(function (item) {
          item.selected = false;
          return item;
        });
        item.selected = !item.selected;
        vm.save()
      }
      vm.countSelections();
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.save = function () {
      var selection = vm.list.filter(function (item) {
        return item.selected;
      });

      $mdDialog.hide(selection);
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller("clientCardController", clientCardController);

  clientCardController.$inject = [
    "$scope",
    "$rootScope",
    "$mdDialog",
    "$filter",
    "InputListsFactory",
    "ReferencesFactory",
    "translationService",
    "toastr",
    "title",
    "listId",
    "inputs",
    "inputsTypes",
    "groups",
    "listSchema",
    "PermissionsFactory",
  ];
  function clientCardController(
    $scope,
    $rootScope,
    $mdDialog,
    $filter,
    $inputListsFactory,
    $referencesFactory,
    $translationService,
    toastr,
    title,
    listId,
    inputs,
    inputsTypes,
    groups,
    listSchema,
    $permissionsFactory
  ) {
    var noGroupTag = $translationService.getTranslationController(
      "otros",
      "others",
      "otros"
    );
    var vm = this;
    vm.validatePermission = function (permission) {
      return $permissionsFactory.hasPermission(permission);
    };

    vm.printView = false;
    vm.title = title;
    vm.inputs = inputs;
    vm.listId = listId;
    vm.listSchema = listSchema;

    vm.canEdit = vm.validatePermission("list#" + listId + ":update");

    vm.inputsTypes = inputsTypes
      .filter(function (e) {
        return e.show === true;
      })
      .map(function (e) {
        if (e.field.indexOf("#") === 0) {
          vm.primaryKey = vm.inputs.body[e.field];
        }
        e.group = angular.isUndefined(e.group) ? noGroupTag : e.group;
        e.disabled = e.readonly && vm.canEdit;
        return e;
      });

    vm.inputDataValues = _parseInputDataValues(vm.inputs.body);

    vm.groups = groups
      .map(function (e) {
        return $filter("capitalize")(e);
      })
      .sort();

    function init() {
      _getReferences(listId, vm.primaryKey);
    }
    init();

    function _getReferences(referencedListId, referencedValue) {
      return new Promise(function (resolve, reject) {
        $referencesFactory
          .getListReferencesCount(referencedListId, referencedValue)
          .then(function (res) {
            vm.references = res;

            var promises = [];
            vm.references.forEach(function (e) {
              promises.push(_getReferenceData(e));
            });

            Promise.all(promises).then(function () {
              resolve();
            });
          })
          .catch(function (err) {
            console.log("Error@getIssueReferencesCount", err);
            reject();
          });
      });
    }

    function _getReferenceData(reference) {
      return new Promise(function (resolve, reject) {
        $referencesFactory
          .getReferenceData(reference.referenceUUID, {})
          .then(function (res) {
            reference.references = res;
            resolve();
          })
          .catch(function (err) {
            console.log("Error@getReferenceData", err);
            reject();
          });
      });
    }

    vm.showRelatedContent = function (event) {
      $mdDialog.show({
        controller: "IssuesRelatedContentDialogController",
        controllerAs: "ctrl",
        templateUrl:
          "app/dashboard/components/issue-related-content-dialog/issue-related-content-dialog.html",
        parent: angular.element(document.body),
        targetEvent: event,
        multiple: true,
        clickOutsideToClose: false,
        locals: {
          parentIssueUuid: "",
          relatedElements: vm.references,
        },
      });
    };

    vm.save = function () {
      if (!vm.validatePermission("list#" + listId + ":update")) return;

      var outputDataValues = _parseOutputDataValues(vm.inputDataValues);
      var dataToSave = [
        {
          dataId: vm.inputs.dataId,
          visible: true,
          body: JSON.stringify(outputDataValues),
        },
      ];

      $rootScope.loading = true;
      $inputListsFactory
        .saveInputListData(listId, dataToSave)
        .then(function (e) {
          console.log("saveInputListData", e);
          var msg = $translationService.getTranslationController(
            "Datos actualizados",
            "Data updated",
            "Dados atualizados"
          );
          toastr.success(msg);
          _updateOriginalData(outputDataValues);
          $mdDialog.hide();
        })
        .catch(function (err) {
          console.error("Error@saveInputListData", err);
          toastr.error(err.error);
        })
        .finally(function (e) {
          $rootScope.loading = false;
        });
    };

    function _updateOriginalData(newValues) {
      angular.forEach(vm.inputs.body, function (value, index) {
        if (!angular.isUndefined(newValues[index])) {
          vm.inputs.body[index] = newValues[index];
        }
      });
    }
    function _parseInputDataValues(data) {
      console.log("parseInputDataValues", data);
      var inputsData = angular.copy(data);

      angular.forEach(inputsData, function (dataValue, dataIndex) {
        var fieldDefinition = inputsTypes.find(function (e) {
          return e.field == dataIndex;
        });

        console.log("fieldDefinition", fieldDefinition);
        

        if (fieldDefinition && dataValue != null) {
          if (fieldDefinition.type == "timestamp") {
            var a = dataValue.split("T");
            inputsData[dataIndex] = moment(a[0]).toDate();
          }
          if (fieldDefinition.type == "date") {
            var a = dataValue.split("T");
            inputsData[dataIndex] = moment(a[0], "YYYY-MM-DD").format(
              "DD-MM-YYYY"
            );
            inputsData[dataIndex] = new Date(dataValue).toISOString().split("T")[0];
          }
        }
      });

      return inputsData;
    }

    function _parseOutputDataValues(data) {
      var inputsData = angular.copy(data);

      angular.forEach(inputsData, function (dataValue, dataIndex) {
        console.log("parseOutputDataValues", dataValue, dataIndex);
        var fieldDefinition = inputsTypes.find(function (e) {
          return e.field == dataIndex;
        });
        if (fieldDefinition) {
          if (["long", "integer", "double"].includes(fieldDefinition.type) ) {
            inputsData[dataIndex] = isNaN(dataValue) ? null : parseFloat(dataValue);
          }

          if (fieldDefinition.type == "time") {
            var time = dataValue ? dataValue : "00:00:00.000000000";
            var timeValue = moment(time);
            inputsData[dataIndex] = timeValue.format("HH:mm:ss.SSSSSSSSS");
          }

          if (fieldDefinition.type == "date") {
            var timeValue =
              moment(dataValue).format("YYYY-MM-DD") + "T00:00:00.000000000Z";
            inputsData[dataIndex] = timeValue;
          }

          if (fieldDefinition.type == "timestamp") {
            var timeValue = moment(dataValue);
            inputsData[dataIndex] = timeValue.format(
              "YYYY-MM-DDTHH:mm:ss.SSSSSSSSS"
            );
          }
        }
      });

      return inputsData;
    }

    vm.print = function () {
      var css =
        "@media print {\n" +
        "  @page {\n" +
        "    margin: 1cm;\n" +
        "  }\n" +
        "  .noprint {\n" +
        "    display: none;\n" +
        "  }\n" +
        "  * {\n" +
        '    font-family: Arial,"Times New Roman";\n' +
        "  }\n" +
        "  span.normal {\n" +
        "    font-weight: normal;\n" +
        "  }\n" +
        "  span.bold {\n" +
        "    font-weight: bold;\n" +
        "  }\n" +
        "  .clearfix::after {\n" +
        '    content: "";\n' +
        "    clear: both;\n" +
        "    display: table;\n" +
        "  }\n" +
        "  img {\n" +
        "    width: 200px !important;\n" +
        "  }\n" +
        "  .flex-container {\n" +
        "    display: flex;\n" +
        "    flex-wrap: row;\n" +
        "  }\n" +
        "  .flex-container-wrap {\n" +
        "    display: flex;\n" +
        "    flex-wrap: wrap;\n" +
        "  }\n" +
        "  .pull-right {\n" +
        "    float: right !important;\n" +
        "  }\n" +
        "  table {\n" +
        "    border-collapse: collapse;\n" +
        "    width: 100%;\n" +
        "    border: 1px solid #ddd;\n" +
        "  }\n" +
        "  table, td, th {\n" +
        "    border: 1px solid #ddd;\n" +
        "    text-align: left;\n" +
        "  }\n" +
        "  th, td {\n" +
        "    padding: 5px;\n" +
        "  }\n" +
        "  tbody tr > td {\n" +
        "    border: 1px solid #ddd !important;\n" +
        "  }\n" +
        "}";
      var innerContents = document.getElementById("print-area").innerHTML;
      var newWin = document.getElementById("printf").contentWindow;
      newWin.document.open();
      newWin.document.write(
        "<html><head><style>" +
          css +
          "</style></head><body>" +
          innerContents +
          "</body></html>"
      );
      newWin.document.close();
      newWin.print();
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

"use strict";
var app = angular.module("dashboard");
app.component("chatBot", {
  templateUrl: "app/app-utils/components/chat-bot/chat-bot.html",
  controllerAs: "ctrl",
  bindings: {},
  controller: chatBotController,
});

chatBotController.$inject = ["$scope", "SyncFactory", "ConfigurationFactory"];

function chatBotController($scope, SyncFactory, ConfigurationFactory) {
  var vm = this;

  var config = {};
  vm.message = "";
  vm.isOpen = false;
  vm.loading = false;
  vm.messages = [];
  vm.errorConfig = false;
  vm.isChatEnabled = false;

  var getConfig = function () {
    ConfigurationFactory.getGlobalConfiguration()
      .then(function (response) {
        if (angular.isDefined(response.security.chat)) {
          config = response.security.chat;
          vm.errorConfig = false;
          vm.isChatEnabled = config.enabled;
        } else {
          console.warn("Chat configuration not found in global settings.");
          vm.errorConfig = true;
          vm.isChatEnabled = false;
        }
      })
      .catch(function (error) {
        console.error("Error fetching global configuration:", error);
        vm.errorConfig = true;
        vm.isChatEnabled = false;
      });
  };
  getConfig();

  $scope.$on("chatbotIsEnabled", function (event, isEnabled) {
    console.log("Received chatbotIsEnabled event:", isEnabled);
    vm.isChatEnabled = isEnabled;
    getConfig();
  });

  vm.sendMessage = function () {
    if (vm.loading) return;
    if (vm.message.trim() === "") return;

    vm.loading = true;
    // console.log("Sending message:", vm.message);
    // Logic to send the message to the bot
    vm.messages.push({ user: "User", text: vm.message });

    var params = Object.assign({}, config, {
      documentacion: {
        entrada: vm.message,
      },
    });

    SyncFactory.syncTransaction(params)
      .then(function (response) {
        // console.log("Sync successful:", response);
        vm.botResponse(response.data.salida);
        vm.message = "";
        document.getElementById("chat-message-form").scrollTop =
          document.getElementById("chat-message-form").scrollHeight;
      })
      .catch(function (error) {
        console.error("Sync failed:", error);
      });

    //scroll to bottom
  };

  vm.botResponse = function (message) {
    // console.log("Bot response:", message);
    vm.messages.push({ user: "Bot", text: message });
    vm.loading = false;
  };

  vm.toggleChat = function () {
    vm.isOpen = !vm.isOpen;
  };
}

'use strict';
var app = angular.module('dashboard');
app.component('cepIcon', {
  templateUrl: 'app/app-utils/components/cep-icon/cep-icon.html',
  controllerAs: 'ctrl',
  bindings: {
    icon: '@',
    color: '@',
    scale: '@',
  },
  controller: cepIconController,
});

function cepIconController() {
  var vm = this;

  vm.$onChanges = function () {
    vm.iconPath = '#' + (vm.icon ? vm.icon : 'cep-question');
    vm.color = vm.color ? vm.color : 'ceptinel';
    vm.scale = vm.scale ? vm.scale : '1';
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('cepDatetimepickerV2', {
  templateUrl:
    'app/app-utils/components/cep-datetimepicker-v2/cep-datetimepicker-v2.html',
  controllerAs: 'ctrl',
  bindings: {
    type: '@',
    ngModel: '=',
  },
  controller: cepDatetimepickerV2Controller,
});

function cepDatetimepickerV2Controller() {
  var vm = this;
  vm.config = {
    date: {
      date: true,
      time: false,
      format: 'DD-MM-YYYY',
    },
    time: {
      date: false,
      time: true,
      format: 'HH:mm:ss',
    },
    timestamp: {
      date: true,
      time: true,
      format: 'DD-MM-YYYY HH:mm:ss',
    },
  };

  vm.onChange = function () {
    console.log(vm.ngModel)
  }
}

'use strict';

var app = angular.module('dashboard');

app.component('cepDatetimepicker', {
  templateUrl:
    'app/app-utils/components/cep-datetimepicker/cep-datetimepicker.html',
  controllerAs: 'ctrl',
  bindings: {
    date: '=',
    format: '@',
    startView: '@',
  },
  controller: cepDatetimepickerController,
});

function cepDatetimepickerController() {
  var vm = this;

  vm.config = {
    dropdownSelector: '#dropdown',
    startView: vm.startView || 'day',
    modelType: 'moment',
  };
}

/**
 * startView {string} The view that the datetimepicker should show when it is opened. Accepts values of :
 * 'minute' for the minute view
 * 'hour' for the hour view
 * 'day' for the day view (the default)
 * 'month' for the 12-month view
 * 'year' for the 10-year overview. Useful for date-of-birth datetimepickers
 */

"use strict";

var app = angular.module("dashboard");

app.component("btnBookmark", {
  templateUrl: "app/app-utils/components/btn-bookmark/btn-bookmark.html",
  controllerAs: "ctrl",
  bindings: {
    entityName: "=",
    entityId: "=",
    entityType: "=",
    extended: "=" || "false",
  },
  transclude: {
    extend: "?extendButtons",
  },
  controller: btnBookmarkController,
});
btnBookmarkController.$inject = ["$scope", "BookmarkService"];

function btnBookmarkController($scope, $bookmarkService) {
  var vm = this;
  vm.isBookmarked = false;
  vm.loading = false;

  vm.translation = {
    add_bookmark: $bookmarkService.translation.add_bookmark,
    remove_bookmark: $bookmarkService.translation.remove_bookmark,
  };

  vm.$onInit = function () {
    vm.loading = $bookmarkService.loading;
    $bookmarkService
      .getEntityBookmark(vm.entityId, vm.entityType)
      .then(function (bookmark) {
        vm.isBookmarked = bookmark ? true : false;
        vm.loading = false;
      })
      .catch(function (error) {
        vm.isBookmarked = false;
        vm.loading = false;
      });
  };
  vm.$onInit();

  vm.toggleBookmark = function () {
    if (vm.loading) return;
    vm.loading = true;
    vm.isBookmarked = !vm.isBookmarked;
    $bookmarkService.updateUserDashboardBookmarks(
      {
        id: vm.entityId,
        name: vm.entityName,
        type: vm.entityType,
      },
      function () {
        vm.loading = false;
      }
    );
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('alertAcl', {
  templateUrl:
    'app/app-utils/components/alert-acl/alert-acl.html',
  controllerAs: 'ctrl',
  bindings: {
    acl: '<',
  },
  controller: alertAclController,
});

function alertAclController() {
  var vm = this;

}


"use strict";

var app = angular.module("dashboard");

app.component("autoRefreshMenu", {
  templateUrl: "app/app-utils/components/auto-refresh/auto-refresh-menu.html",
  controllerAs: "ctrl",
  bindings: {
    onTick: "&", // This is the function that will be called on each tick
  },
  controller: autoRefreshController,
});

autoRefreshController.$inject = ["$scope", "translationService", "toastr"];

function autoRefreshController($scope, $translationService, $toastr) {
  var vm = this;

  vm.isActive = false;

  vm.textActive = $translationService.getTranslationController(
    "Actualizando cada",
    "Updating every",
    "Updating every"
  );

  vm.textInactive = $translationService.getTranslationController(
    "Iniciar auto refrescar",
    "start auto refresh",
    "start auto refresh"
  );

  vm.translationsRefresh = $translationService.getTranslationController(
    "Refrescar cada",
    "refresh every",
    "refresh every"
  );

  vm.translationsStop = $translationService.getTranslationController(
    "Parar auto refrescar",
    "stop auto refresh",
    "stop auto refresh"
  );

  vm.timer = null;

  var interval = null;

  var delays = {
    "5s": 5000,
    "10s": 10000,
    "15s": 15000,
  };

  vm.autoRefresh = function (delay) {
    if (interval) {
      clearInterval(interval);
    }

    vm.isActive = true;
    vm.timer = delay;
    var timeout = delays[delay];
    $toastr.warning(vm.textActive + " " + delay); 
    vm.onTick();
    interval = setInterval(function () {
      vm.onTick();
    }, timeout);
  };

  vm.stopAutoRefresh = function () {
    vm.isActive = false;
    $toastr.warning(vm.translationsStop);
    if (interval) clearInterval(interval);
  };

  vm.$onDestroy = function () {
    if (interval) clearInterval(interval);
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('helpDeskButton', {
  templateUrl: 'app/help-desk/components/buttons.html',
  controllerAs: 'ctrl',
  controller: helpDeskButtonController,
});

helpDeskButtonController.$inject = ['$scope', '$mdDialog'];
function helpDeskButtonController($scope, $mdDialog) {
  var vm = this;
  vm.open = function () {
    $mdDialog.show({
      controller: 'helpDeskDialogReportIssueController',
      controllerAs: 'ctrl',
      templateUrl: 'app/help-desk/dialogs/report-issue.html',
      parent: angular.element(document.body),
    });
  };
}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller(
      'helpDeskDialogReportIssueController',
      helpDeskDialogReportIssueController
    );

  helpDeskDialogReportIssueController.$inject = [
    '$mdDialog',
    '$localStorageService',
    '$state',
    '$window',
    '$cookies',
    'FileUploader',
    'FileSaver',
  ];
  function helpDeskDialogReportIssueController(
    $mdDialog,
    $localStorageService,
    $state,
    $window,
    $cookies,
    FileUploader,
    FileSaver
  ) {
    var vm = this;
    vm.loading = false;
    vm.displayForm = false;
    vm.showTicket = false;
    vm.ticket = null;

    vm.user = $localStorageService.getItem("currentUser");
    console.log($state);
    console.log(vm.user);
    console.log($window);

    vm.ticket_types = ['INQUIRY', 'TICKET'];
    vm.ticket = {
      type: 'TICKET',
      email: null,
      username: vm.user.username || null,
      ip: null,
      domain: $window.location.href,
      comment: null,
      files: [],
    };

    vm.submit = function () {
      vm.loading = true;
      vm.showTicket = false;
      vm.ticket = null;
      setInterval(function () {
        vm.ticket = 'bac82a42-71f8-4619-a510-ed2d85ded414';
        vm.loading = false;
        vm.showTicket = true;
      }, 500);
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    //-uploadder
    vm.uploader = new FileUploader({
      url: '/risk-backend/rest/case/file',
      headers: { token: $cookies.get('token') },
      formData: { creationDate: moment() },
      removeAfterUpload: true,
    });

    vm.uploader.filters.push({
      name: 'Extensions',
      fn: function (item, options) {
        var allowedType = [
          'text/csv',
          'image/jpeg',
          'image/png',
          'image/jpeg',
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.ms-powerpoint',
          'application/vnd.openxmlformats-officedocument.presentationml.presentation',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ];

        if (allowedType.indexOf(item.type) === -1) {
          toastr.error('Archivo no permitido');
        }

        return allowedType.indexOf(item.type) !== -1;
      },
    });

    vm.uploader.filters.push({
      name: 'Size',
      fn: function (item, options) {
        var maxSize = 31457280;
        var size = item.size;

        if (item.size >= 31457280) {
          var msg = $translationService.getTranslationController(
            'El archivo supera el límite de 30Mb',
            'The file exceeds the 30Mb limit',
            'O arquivo excede o limite de 30Mb'
          );
          toastr.error(msg);
        }

        return item.size < 31457280;
      },
    });

    vm.uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response === 'fileDuplicate') {
        var msg = $translationService.getTranslationController(
          'No se ha podido cargar, archivo duplicado en el sistema.',
          'Unable to load, duplicate file in the system.',
          'Não é possível carregar, duplicar arquivo no sistema.'
        );
        toastr.error(msg);
      } else {
        if (status == 403) {
          toastr.error(
            $translationService.getTranslationController(
              'Usuario no autorizado.',
              'Unauthorized User.',
              'Usuário não autorizado.'
            )
          );
        } else {
          toastr.error(
            $translationService.getTranslationController(
              'No se ha podido cargar el archivo.',
              'The file could not be loaded.',
              'O arquivo não pôde ser carregado.'
            )
          );
        }
      }
    };

    vm.uploader.onSuccessItem = function (item, response, status, headers) {
      if (status) {
        var msg = $translationService.getTranslationController(
          'Archivo cargado exitosamente',
          'File successfully loaded',
          'Arquivo carregado com sucesso'
        );
        toastr.success(msg);
        obtenerArchivosTabFn(vm.tab);
      }
    };
  }
})();

/**
 * Ceptinel base transformation types
 */
(function () {
  'use strict';

  angular.module('dashboard').constant('usersConstants', {
    userModel: {
      username: '',
      email: '',
      phone: '',
      lastName: '',
      name: '',
      fullName: '',
      lang: 'ES',
      timeZone: null,
      region: 'ES',
      color: null,
      address: '',
      active: 't',
      company: {
        companyId: 0,
      },
      profile: {
        type: 'U',
        groups: [],
        strGroups: '',
        permissions: [],
        categories: [],
      },
      expirationDate: '',
      sendPwsByMail: false,
      source: 'SYSTEM',
    },
    userTypes: [
      {
        name: 'Super Administrador',
        value: 'SA',
      },
      // {
      //   name: 'Super Usuario',
      //   value: 'SU',
      // },
      {
        name: 'Usuario',
        value: 'U',
      },
      {
        name: 'Servicio',
        value: 'SE',
      },
      {
        name: 'Auditor',
        value: 'AU',
      },
    ],
    userLangs: [
      {
        type: 'Spanish',
        value: 'ES',
      },
      {
        type: 'English',
        value: 'EN',
      },
      {
        type: 'Portuguese',
        value: 'PT',
      },
    ],
    regions: ['EN', 'ES', 'PT'],
    passwordPolicy: {
      showPasswordPolicy: false,
      expirePasswordInDays: 0,
      minimumPasswordLength: 0,
      rememberLastPasswords: 0,
      withAtLeastOneDigit: false,
      withAtLeastOneSymbol: false,
      withAtLeastOneLowercase: false,
      withAtLeastOneUppercase: false,
    },
  });
})();

(function () {
  'use strict';

  angular.module('dashboard').directive('rangeSlider', [
    function () {
      return {
        restrict: 'E',
        replace: true,
        scope: {
          config: '=?',
          model: '=',
        },

        template:
          '' +
          '<div class="range-slider">' +
          '<div class="label min-value"><span>{{config.min}}</span></div>' +
          '<div class="range-slider-set">' +
          '<div class="span-min" style="left:0;right:{{(100 - _handleMinX)}}%"></div>' +
          '<div class="span-gap" style="left:{{_handleMinX}}%;right:{{(100 - _handleMaxX)}}%"></div>' +
          '<div class="span-max" style="left:{{_handleMaxX}}%;right:0"></div>' +
          '<input type="range" class="slider-min" ng-change="_which=0" ng-model="_model[0]" min="{{_values.min}}" max="{{_values.max}}" step="{{_step}}" />' +
          '<input type="range" class="slider-max" ng-change="_which=1" ng-model="_model[1]" min="{{_values.min}}" max="{{_values.max}}" step="{{_step}}" />' +
          '<div class="handle from-value" style="left:{{_handleMinX}}%"><span>{{_model[0]|number:config.precision}}</span></div>' +
          '<div class="handle to-value" style="left:{{_handleMaxX}}%"><span>{{_model[1]|number:config.precision}}</span></div>' +
          '</div>' +
          '<div class="label max-value"><span>{{config.max}}</span></div>' +
          '</div>',

        link: function link(scope, element) {
          var defaultConfig = {
            min: 0,
            max: 100,
            gap: 10,
            step: 0.1,
            precision: 1,
          };

          scope.config = angular.extend(
            {},
            angular.copy(defaultConfig),
            scope.config
          );

          scope._model = [scope.model.from, scope.model.to];

          scope._values = {
            min: scope.config.min || 0,
            max: scope.config.max || 100,
          };

          scope._labels = {
            min: scope._values.min,
            max: scope._values.max,
          };

          scope._step = scope.config.step || 1;

          scope._gap = parseFloat(scope.config.gap) || 0;
          scope._which = 0;

          var _notInRunLoop = function _notInRunLoop() {
            return !scope.$root.$$phase;
          };

          var _reevaluateInputs = function () {
            var inputElements = element.find('input');

            angular.forEach(inputElements, function (inputElement, index) {
              inputElement = angular.element(inputElement);

              inputElement.val(scope._model[index]);
            });
          };

          var _updateModel = function _updateModel(model) {
            scope.model = {
              from: parseFloat(model[0].toFixed(scope.config.precision)),
              to: parseFloat(model[1].toFixed(scope.config.precision)),
            };

            scope._handleMinX =
              ((scope._model[0] - scope._values.min) /
                (scope._values.max - scope._values.min)) *
              100;
            scope._handleMaxX =
              ((scope._model[1] - scope._values.min) /
                (scope._values.max - scope._values.min)) *
              100;

            scope._handleMinX = scope._handleMinX < 0 ? 0 : scope._handleMinX;
            scope._handleMaxX =
              scope._handleMaxX > 100 ? 100 : scope._handleMaxX;

            if (_notInRunLoop()) {
              try {
                scope.$apply();
              } catch (e) {}
            }
          };

          scope.$watch(
            'config',
            function (n, o) {
              scope.config = angular.extend(
                {},
                angular.copy(defaultConfig),
                scope.config
              );
              if (n && o && n !== o) {
                scope.config.min = parseFloat(scope.config.min);
                scope.config.max = parseFloat(scope.config.max);
                scope.config.gap = parseFloat(scope.config.gap);

                if (scope.config.gap > scope.config.max - scope.config.min) {
                  scope.config.gap = scope.config.max - scope.config.min;
                }

                scope.config.step = parseFloat(scope.config.step);
                scope._gap = scope.config.gap;
                scope._step = scope.config.step;

                scope._values = {
                  min: scope.config.min || 0,
                  max: scope.config.max || 100,
                };

                _reevaluateInputs();
              }
            },
            true
          );

          scope.$watch(
            'model',
            function alteredValues() {
              scope._model = [scope.model.from, scope.model.to];
              _reevaluateInputs();
            },
            true
          );

          scope.$watchCollection('_model', function modelChanged() {
            scope._model[0] = parseFloat(scope._model[0]) * 1;
            scope._model[1] = parseFloat(scope._model[1]) * 1;

            if (
              scope._which === 0 &&
              scope._model[1] - scope._gap < scope._model[0]
            ) {
              scope._model[1] = scope._model[0] + scope._gap;
            }

            if (
              scope._which === 1 &&
              scope._model[0] + scope._gap > scope._model[1]
            ) {
              scope._model[0] = scope._model[1] - scope._gap;
            }

            (function constrainMinMax() {
              if (scope._model[0] < scope._values.min) {
                scope._model[0] = scope._values.min;
              }

              if (scope._model[1] < scope._values.min) {
                scope._model[1] = scope._values.min;
              }

              if (scope._model[0] > scope._values.max) {
                scope._model[0] = scope._values.max;
              }

              if (scope._model[1] > scope._values.max) {
                scope._model[1] = scope._values.max;
              }

              var _m0Gap = scope._model[0] + scope._gap;
              var _m1Gap = scope._model[1] - scope._gap;

              if (scope._model[0] > _m1Gap) {
                scope._model[0] = _m1Gap;
              }

              if (scope._model[1] < _m0Gap) {
                scope._model[1] = _m0Gap;
              }
            })();

            _updateModel(scope._model);
            _reevaluateInputs();
          });
        },
      };
    },
  ]);
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('SearcherConfigController', SearcherConfigController);

  SearcherConfigController.$inject = [
    '$rootScope',
    '$scope',
    'translationService',
    'SearcherConfigurationFactory',
    '$mdDialog',
    'toastr',
  ];

  function SearcherConfigController(
    $rootScope,
    // $stateParams,
    $scope,
    $translationService,
    SearcherConfigurationFactory,
    $mdDialog,
    toastr
  ) {
    var vm = this;

    vm.params = {
      filters: [],
      pagination: {
        page: 1,
        itemsPerPage: 25,
        sort: 'asc',
        sortBy: 'id',
      },
      target: null,
    };

    vm.loading = false;

    vm.gridOptions = {
      data: [],
      // rowTemplate:
      //   '<div ng-click="grid.appScope.showDetail(row.entity)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>',
      multiSelect: false,
      gridMenuShowHideColumns: false,
      // Grid menu
      enableGridMenu: false,
      minimumColumnSize: 100,
      // Grid pagination options
      useExternalPagination: true,
      paginationPageSizes: [25, 50, 100],
      paginationPageSize: vm.params.pagination.itemsPerPage,
      totalItems: vm.params.pagination.totalRecords,
      // Grid sorting options
      useExternalSorting: true,
      columnDefs: [
        {
          // enableSorting: true,
          enableHiding: false,
          key: 'id',
          name: 'id',
          displayName: 'Id',
          width: 100,
        },
        {
          // enableSorting: true,
          enableHiding: false,
          key: 'name',
          name: 'name',
          displayName: 'name',
        },
        {
          enableColumnMenu: true,
          // enableSorting: true,
          enableHiding: false,
          key: 'target',
          name: 'target',
          displayName: 'Type',
          cellClass: 'text-center',
          menuItems: [
            {
              title: $translationService.getTranslationController(
                'List',
                'List',
                'List'
              ),
              icon: 'ui-grid-icon-filter',
              shown: function () {
                return true;
              },
              action: function ($event) {
                this.context.addFilterTo($event, 'LIST');
              },
              context: vm,
            },
            {
              title: $translationService.getTranslationController(
                'Issues',
                'Issues',
                'Issues'
              ),
              icon: 'ui-grid-icon-filter',
              shown: function () {
                return true;
              },
              action: function ($event) {
                this.context.addFilterTo($event, 'ISSUES');
              },
              context: vm,
            },
          ],
        },
        {
          // enableSorting: true,
          enableHiding: false,
          key: 'inQueue',
          name: 'inQueue',
          displayName: 'Num. docs. in queue',
          width: 100,
        },
        {
          // enableSorting: true,
          enableHiding: false,
          key: 'numDocs',
          name: 'numDocs',
          displayName: 'Num. indexed docs.',
          width: 100,
        },
        {
          name: 'Action',
          displayName: 'Action',
          cellTemplate:
            '<div class="ui-grid-cell-contents text-center" title="rebuild" ng-click="grid.appScope.onBuildLuceneIndex(row)" ><i class="fa fa-cog blue-text"></i></div>',
          cellClass: 'text-center',
          width: 100,
        },
      ],
      onRegisterApi: function (gridApi) {
        gridApi.pagination.on.paginationChanged(
          $scope,
          function (newPage, pageSize) {
            // console.log(vm.params);
            vm.params.pagination.page = newPage;
            vm.params.pagination.itemsPerPage = pageSize;

            _getDataList();
          }
        );
        gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          var sort = vm.params.pagination.sort == 'desc' ? 'asc' : 'desc';
          vm.params.pagination.sort = sort;
          var sortBy = sortColumns.length > 0 ? sortColumns[0].field : '';
          vm.params.pagination.sortBy = sortBy || '';
          _getDataList();
        });
      },
    };

    (function init() {
      vm.loading = true;
      $translationService.getTranslation($scope, 'searcher');
      _getDataList();
    })();

    function _getDataList() {
      $rootScope.loading = true;
      vm.loading = true;
      if (vm.params.filters.length > 0) vm.isFiltered = true;
      else vm.isFiltered = false;

      var params = vm.params.pagination;
      params.target = vm.params.target;
      SearcherConfigurationFactory.searcherList(params)
        .then(function (res) {
          // console.log(res.data);
          vm.gridOptions.data = res.data.data;
          vm.gridOptions.totalItems = res.data.pagination.totalRecords;
          vm.params.pagination = res.data.pagination;
          vm.loading = false;
          $rootScope.loading = false;
        })
        .catch(function (err) {
          console.error('Error@_getDataList', err);
          vm.loading = false;
          $rootScope.loading = false;
        });
    }

    vm.removeFilter = function (index) {
      vm.params.filters.splice(index, 1);
      if (!vm.params.filters.length) {
        vm.isFiltered = false;
      }
      _getDataList();
    };

    vm.unFilterData = function () {
      vm.params.filters = [];
      vm.isFiltered = false;
      _getDataList();
    };

    $scope.onBuildLuceneIndex = function (row) {
      // console.log(row);
      var confirm = $mdDialog
        .confirm()
        .multiple(true)
        .title(
          $translationService.getTranslationController(
            '¿Está seguro de reconstruir el indice asociado al buscador?',
            'Are you sure to rebuild the index associated with this searcher?',
            'Tem certeza de que deseja reconstruir o índice associado a este buscador?'
          )
        )
        .ariaLabel('Cancel-Question')
        .ok($translationService.getTranslationController('Si', 'Yes', 'Si'))
        .cancel('No');

      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loading = true;
          SearcherConfigurationFactory.buildLuceneIndex(
            row.entity.target,
            row.entity.id
          )
            .then(function (response) {
              var msg = $translationService.getTranslationController(
                'La solicitud se ha agregado a la cola de trabajo.',
                'The request has been added to the work queue.',
                'O pedido foi adicionado à fila de trabalho.'
              );
              toastr.success(msg);
            })
            .catch(function (e) {
              toastr.error(e);
            })
            .finally(function () {
              $rootScope.loading = false;
            });
        },
        function () {}
      );
    };

    vm.addFilterTo = function (e, arg) {
      vm.params.target = arg;
      vm.params.pagination = {
        page: 1,
        itemsPerPage: 25,
      };
      _getDataList();
    };

    /********************************************** Modal search *******************************************/
    vm.showSearcherDialog = function (ev) {
      $mdDialog.show({
        multiple: true,
        controller: 'SearcherController',
        templateUrl: 'app/searcher/dialog-searcher.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        controllerAs: 'ctrl',
        targetEvent: ev,
      });
    };
  }
})();

(function() {
'use strict';

  angular
    .module('dashboard')
    .controller('RuleVersionsController', RuleVersionsController);

  RuleVersionsController.$inject = ['$scope', '$rootScope','toastr', 'translationService','$state', '$stateParams', 'FunctionFactory', '$mdDialog'];
  function RuleVersionsController($scope, $rootScope, toastr, $translationService, $state, $stateParams, FunctionFactory, $mdDialog) {
    $translationService.getTranslation($scope, 'rules');
    var rule = this;
    rule.loadingVersions = true; 
    $rootScope.loading = true;

    rule.getFunction = function(){
        FunctionFactory.getFunctionByID($stateParams.functionId)
        .then(function(res){
            rule.data = res;
            rule.getVersions();
        })
        .catch(function(err){
            console.log("Error@getFunctionByID", err);
        });
    }
    rule.getFunction();

    rule.getVersions = function(){
        FunctionFactory.getVersions(rule.data.id)
        .then(function(res){
            rule.data.versions = res.sort(function(a, b){return b.id - a.id});
            rule.loading = false;
      })
      .catch(function(err){ console.log("Error@getVersions", err); })
      .finally(function(err){ rule.loadingVersions = false; $rootScope.loading = false; });
    }

    rule.deleteVersion = function(ev, version){
        var confirm = $mdDialog.confirm()
                .title($translationService.getTranslationController('¿Elimininar versión "', 'Delete version "', 'Excluir versão "') + version.title + '"?')
                .textContent($translationService.getTranslationController('¡Cuidado!, Esta acción no puede revertirse', 'Warning!, This action cannot be reverted', 'Cuidado! Esta ação não pode ser revertida'))
                .ariaLabel('Delete-Question')
                .targetEvent(ev)
                .ok($translationService.getTranslationController('Si, Elimínala', 'Yes, Delete it', 'Sim, elimine'))
                .cancel($translationService.getTranslationController('Aún no', 'Not yet', 'Ainda não'));

        $mdDialog.show(confirm)
        .then(function() {
            $rootScope.loading = true;
            FunctionFactory.deleteVersion(version.id)
            .then(function(res){
                if(res){
                    rule.data.versions = rule.data.versions.filter(function(e){ return e.id != version.id })
                    toastr.success($translationService.getTranslationController('Versión eliminada', 'Version deleted', 'versão excluída'));
                }else{
                    toastr.error($translationService.getTranslationController('No se pudo eliminar la versión', 'The version could not be deleted', 'A versão não pôde ser excluída'));
                }
            })
            .catch(function(err){
                console.log("Error@deleteVersion", err);
                toastr.error($translationService.getTranslationController('No se pudo eliminar la versión', 'The version could not be deleted', 'A versão não pôde ser excluída') + err);
            })
            .finally(function(){ $rootScope.loading = false; });
        }, function() {});
    }

    $scope._onGoBack = function(){
        $state.go('app.rules');
    }
    $scope._onGoTo = function(to){
        $state.go(to, {functionId: rule.data.id});
    }
    // - Buscador
    $scope.querySearch = function(query) {
      var results = query ? rule.data.versions.filter( createFilterFor(query) ) : rule.data.versions, deferred;
      return results;
    }
    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(array) {
            return ( array.title.toLowerCase().indexOf(lowercaseQuery) > -1);
        };
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('RulesSchedulesController', RulesSchedulesController);

  RulesSchedulesController.$inject = [
    '$scope',
    '$rootScope',
    'translationService',
    '$state',
    'FunctionFactory',
    '$element',
    '$compile',
  ];
  function RulesSchedulesController(
    $scope,
    $rootScope,
    $translationService,
    $state,
    $functionFactory,
    $element,
    $compile
  ) {
    $translationService.getTranslation($scope, 'rules');
    $rootScope.loading = true;
    var rule = this;
    rule.ruleCRUD = {};
    rule.schedules = [];
    rule.getSchedules = function (id) {
      $rootScope.loading = true;
      $functionFactory
        .getSchedules()
        .then(function (res) {
          res = res.map(function (item) {
            // item.nextRun = prettyCron.getNext(item.schedule);
            // item.cronString = prettyCron.toString(item.schedule);
            // item.nextDates = prettyCron.getNextDates(item.schedule, 7);
            var rule = item.object.split('-');
            item.rule = rule[0];
            item.id = rule[1];
            item.name = rule[2];
            item.schedule = cronstrue.toString(item.schedule);

            return item;
          });

          rule.schedules = res.reduce(function (schedules, current) {
            var index = schedules.findIndex(function (item) {
              return item.id == current.id;
            });
            if (index == -1) {
              schedules.push({
                id: current.id,
                name: current.name,
                schedules: [current],
              });
            } else {
              schedules[index].schedules.push(current);
            }
            return schedules;
          }, []);

          rule.schedules.forEach(function (item) {
            item.schedules.sort(function (a, b) {
              return a.nextExecution - b.nextExecution;
            });
          });
        })
        .catch(function (err) {
          console.error('Error@getSchedules', err);
        })
        .finally(function (err) {
          $rootScope.loading = false;
        });
    };
    rule.getSchedules(false);

    rule.editRule = function ($event, id) {
      $functionFactory
        .getFunctionByID(id)
        .then(function (res) {
          rule.ruleCRUD.openEditor($event, res);
        })
        .catch(function (err) {
          console.log('Error@getFunctionByID', err);
        });
    };

    $scope._onGoTo = function (to) {
      $state.go(to);
    };

    $scope.weekDays = [
      {
        name: 'Sunday',
        value: 0,
      },
      {
        name: 'Monday',
        value: 1,
      },
      {
        name: 'Tuesday',
        value: 2,
      },
      {
        name: 'Wednesday',
        value: 3,
      },
      {
        name: 'Thursday',
        value: 4,
      },
      {
        name: 'Friday',
        value: 5,
      },
      {
        name: 'Saturday',
        value: 6,
      },
    ];

    $scope._renderWeeklyCalendar = function (data) {
      var today = moment();
      // var daysInMonth = new Date(
      //   new Date().getFullYear(),
      //   new Date().getMonth() + 1,
      //   0
      // ).getDate();
      var startOfWeek = moment().startOf('week').toDate();
      var endOfWeek = moment().endOf('week').toDate();

      var table = angular.element('<table class="table-calendar"></table>');
      // render a weekly calendar with 7 days from today
      var thead = angular.element('<thead></thead>');
      var tbody = angular.element('<tbody></tbody>');
      var time = angular.element('<th>TIME</th>');
      thead.append(time);
      table.append(thead);

      for (var i = 0; i < $scope.weekDays.length; i++) {
        var currentDay = moment(startOfWeek).add(i, 'days').format('DD');
        var day = $scope.weekDays[i];
        var th = angular.element('<th>' + day.name + '</th>');
        th.attr('data-day', i);
        th.css('width', 100 / 8 + '%');
        if (today.format('DD') == currentDay) {
          th.addClass('today');
        }

        var day = angular.element('<div>' + currentDay + '</div>');
        th.append(day);
        thead.append(th);
        table.append(thead);
      }

      for (var i = 0; i < 24; i++) {
        var tr = angular.element('<tr></tr>');
        for (var j = 0; j < $scope.weekDays.length + 1; j++) {
          var td = angular.element('<td></td>');
          td.attr('data-day', j);
          td.attr('data-hour', i);
          td.css('width', 100 / 8 + '%');
          if (j == 0) {
            var hour = angular.element('<div>' + i + ':00</div>');
            td.append(hour);
          }

          tr.append(td);
        }
        tbody.append(tr);
        table.append(tbody);
      }

      var html = $compile(table)($scope);
      $element.find('#calendar-container').append(html);
    };
    // $scope._renderWeeklyCalendar();
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('RuleExecController', RuleExecController);

  RuleExecController.$inject = [
    '$scope',
    '$rootScope',
    'toastr',
    'translationService',
    '$state',
    '$stateParams',
    '$mdDialog',
    'Paginator',
    'FunctionFactory',
  ];
  function RuleExecController(
    $scope,
    $rootScope,
    $toastr,
    $translationService,
    $state,
    $stateParams,
    $mdDialog,
    $paginator,
    $functionFactory
  ) {
    $translationService.getTranslation($scope, 'rules');
    $rootScope.loading = true;

    var rule = this;
    rule.show = {
      executions: true,
      versions: true,
    };
    rule.isLoading = {
      executions: true,
      versions: true,
    };

    rule.mustOrderBy = { field: 'executionCreationDate', reverse: true };

    rule.request = {
      startDate: null,
      endDate: null,
      pagination: {
        sortBy: '',
        sort: 'DESC',
        page: 1,
        totalRecords: 0,
        itemsPerPage: 5,
        rule: [],
      },
      exportToCsv: false,
      filters: [],
      // filters: [{ "column": "versionName", "operation": "=", "value": "LastCommit" }]
    };

    rule.getFunction = function () {
      $functionFactory
        .getFunctionByID($stateParams.functionId)
        .then(function (res) {
          rule.data = res;
          rule.getExecutions();
          rule.getVersions();
        })
        .catch(function (err) {
          console.log('Error@getFunctionByID', err);
        });
    };
    rule.getFunction();

    // ***** Ejecuciones
    rule.getExecutions = function () {
      rule.isLoading.executions = true;
      $rootScope.loading = true;
      rule.data.executions = [];
      $functionFactory
        .getExecutions(rule.data.id, rule.request)
        .then(function (res) {
          rule.request.pagination.page = res.pagination.page;
          rule.request.pagination.totalRecords = res.pagination.totalRecords;
          rule.setPaginationRule();

          rule.data.executions = res.data;
          rule.data.executions.map(function (e) {
            e.attrMap = Object.keys(e.attributes)
              .filter(function (e) {
                return e.indexOf('attribute_') > -1;
              })
              .map(function (x) {
                return {
                  key: x.replace('attribute_', ''),
                  value: e.attributes[x],
                };
              });
            return e;
          });
        })
        .catch(function (err) {
          console.log('Error@getExecutions', err);
        })
        .finally(function (err) {
          rule.isLoading.executions = false;
          $rootScope.loading = false;
        });
    };

    $scope.$on('dateChange', function (e, dates) {
      rule.request.startDate = moment(dates.desde).toISOString();
      rule.request.endDate = moment(dates.hasta).toISOString();
      rule.request.pagination.page = 1;

      if (dates.searchBtn) {
        $rootScope.loading = true;
        rule.getExecutions();
      }
    });

    rule.execute = function (rule) {
      $mdDialog.show({
        controller: 'ExecuteDialogController',
        controllerAs: 'ctrl',
        templateUrl: 'app/rules/partials/execute-dialog/execute-dialog.html',
        locals: {
          rule: rule,
          properties:[]
        },
        parent: angular.element(document.body),
        multiple: true,
      });
    };

    // **** Versiones
    rule.getVersions = function () {
      rule.isLoading.versions = true;
      $rootScope.loading = true;
      rule.data.versions = [];
      $functionFactory
        .getVersions(rule.data.id)
        .then(function (res) {
          rule.data.versions = res.sort(function (a, b) {
            return b.id - a.id;
          });
        })
        .catch(function (err) {
          console.log('Error@getVersions', err);
        })
        .finally(function (err) {
          rule.isLoading.versions = false;
          $rootScope.loading = false;
        });
    };

    rule.deleteVersion = function (ev, version) {
      var confirm = $mdDialog
        .confirm()
        .title(
          $translationService.getTranslationController(
            '¿Elimininar versión "',
            'Delete version "',
            'Excluir versão "'
          ) +
            version.title +
            '"?'
        )
        .textContent(
          $translationService.getTranslationController(
            '¡Cuidado!, Esta acción no puede revertirse',
            'Warning!, This action cannot be reverted',
            'Cuidado! Esta ação não pode ser revertida'
          )
        )
        .ariaLabel('Delete-Question')
        .targetEvent(ev)
        .ok(
          $translationService.getTranslationController(
            'Si, Elimínala',
            'Yes, Delete it',
            'Sim, elimine'
          )
        )
        .cancel(
          $translationService.getTranslationController(
            'Aún no',
            'Not yet',
            'Ainda não'
          )
        );

      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loading = true;
          $functionFactory
            .deleteVersion(version.id)
            .then(function (res) {
              if (res) {
                rule.data.versions = rule.data.versions.filter(function (e) {
                  return e.id != version.id;
                });
                $toastr.success(
                  $translationService.getTranslationController(
                    'Versión eliminada',
                    'Version deleted',
                    'versão excluída'
                  )
                );
              } else {
                $toastr.error(
                  $translationService.getTranslationController(
                    'No se pudo eliminar la versión',
                    'The version could not be deleted',
                    'A versão não pôde ser excluída'
                  )
                );
              }
            })
            .catch(function (err) {
              console.log('Error@deleteVersion', err);
              $toastr.error(
                $translationService.getTranslationController(
                  'No se pudo eliminar la versión',
                  'The version could not be deleted',
                  'A versão não pôde ser excluída'
                ) + err
              );
            })
            .finally(function () {
              $rootScope.loading = false;
            });
        },
        function () {}
      );
    };

    /**
     * Utils
     */
    $scope._onGoBack = function () {
      $state.go('app.rules');
    };
    $scope._onGoTo = function (to) {
      $state.go(to, { functionId: rule.data.id });
    };
    $scope._orderBy = function (field, reverse) {
      rule.mustOrderBy = { field: field, reverse: reverse };
    };

    /**
     * Paginator
     */
    rule.setPaginationRule = function () {
      var pagination = rule.request.pagination;
      pagination.inf = pagination.page * pagination.itemsPerPage - 10;
      pagination.sup = pagination.page * pagination.itemsPerPage;
      pagination.sup =
        pagination.sup > pagination.totalRecords
          ? pagination.totalRecords
          : pagination.sup;

      pagination.rule = $paginator.getPagesWindow(
        pagination.totalRecords,
        pagination.itemsPerPage,
        pagination.page
      );
    };

    rule.goToPage = function (destiny) {
      var totalPages =
        Math.ceil(
          rule.request.pagination.totalRecords /
            rule.request.pagination.itemsPerPage
        ) - 1;
      switch (destiny) {
        case 'start':
          rule.request.pagination.page = 1;
          break;
        case 'end':
          rule.request.pagination.page = totalPages;
          break;
        case '1more':
          rule.request.pagination.page++;
          break;
        case '1less':
          rule.request.pagination.page--;
          break;
        default:
          rule.request.pagination.page = destiny;
      }
      rule.setPaginationRule();
      rule.showLessArrow();
      rule.showMoreArrow();
      rule.getExecutions();
    };

    rule.showLessArrow = function () {
      return (
        rule.request.pagination.rule.length > 1 &&
        rule.request.pagination.rule[0] != 1
      );
    };

    rule.showMoreArrow = function () {
      return (
        rule.request.pagination.rule.length > 1 &&
        rule.request.pagination.rule[rule.request.pagination.rule.length - 1] !=
          Math.ceil(
            rule.request.pagination.totalRecords /
              rule.request.pagination.itemsPerPage
          )
      );
    };
  }
})();

(function () {
  'use strict';

  angular.module('dashboard').directive('ruleImporter', RuleImportDirective);

  RuleImportDirective.$inject = ['$rootScope'];
  function RuleImportDirective($rootScope) {
    return {
      scope: {
        ruleImportedData: '=',
      },
      link: function ($scope, $elm) {
        $elm.on('change', function (changeEvent) {
          var reader = new FileReader();
          reader.onloadstart = function () {
            $rootScope.loading = true;
          };

          reader.onloadend = function () {
            $rootScope.loading = false;
          };

          reader.onload = function (e) {
            $scope.ruleImportedData = e.target.result;
          };

          reader.readAsBinaryString(changeEvent.target.files[0]);
        });
      },
    };
  }
})();

(function () {
  "use strict";

  angular.module("dashboard").directive("ruleCrud", RuleCrudController);

  RuleCrudController.$inject = ["$mdDialog"];
  function RuleCrudController($mdDialog) {
    return {
      scope: {
        api: "=?",
        onUpdate: "&",
        realtime: "<?",
      },
      restrict: "E",
      replace: "true",
      link: function ($scope) {
        $scope.api = {};

        $scope.showFunctionModal = function (ev, _rule) {
          $mdDialog.show({
            multiple: true,
            templateUrl:
              "app/rules/components/rule-management-dialog/rule-management-dialog.html",
            controller: "RuleManagementDialogController",
            controllerAs: "rule",
            locals: {
              _rule: _rule,
              onUpdate: $scope.onUpdate,
              realtime: $scope.realtime || _rule.realtime || false,
              groupPath: null,
            },
            clickOutsideToClose: false,
            escapeToClose: false,
          });
        };

        $scope.api.openEditor = function (ev, rule) {
          $scope.showFunctionModal(ev, rule);
        };
      },
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .service('transformationsService', transformationsService);

  transformationsService.$inject = ['$filter', 'ruleEditorDefaults'];
  function transformationsService($filter, $ruleEditorDefaults) {
    var vm = this;
    /**
     * Define anchor of a transformation
     * @param {array} defaultAnchors
     * @param {array} schemas
     * @returns {array}
     */
    vm.getAnchors = function (defaultAnchors, schemas) {
      var anchors = schemas.length ? schemas.length : defaultAnchors;
      return anchors;
    };

    /**
     * Load properties of a transformation
     * @returns {array}
     */
    vm.loadProperties = function (
      clsName,
      label,
      tool,
      startpoints,
      endpoints,
      contenteditable,
      nameId,
      schema,
      params,
      types,
      optionalValues
    ) {
      var selectedTool = [];
      selectedTool.push({
        left: 0,
        top: 0,
        clsName: clsName,
        label: label,
        tool: tool,
        nameId: nameId,
        startpoints: startpoints,
        endpoints: endpoints,
        contenteditable: contenteditable,
        schema: schema,
        params: params,
        optValues: optionalValues,
        types: types,
      });
      return selectedTool;
    };

    /**
     * Define typeof transformation (input/output/transformation/parameters)
     * @param {array} transformation
     * @param {string} tool
     * @returns {string}
     */
    vm.defineType = function (
      transformations,
      tool,
      inputSchemas,
      outputSchemas
    ) {
      var selectedTool = transformations.find(function (e) {
        return e.name == tool;
      });

      inputSchemas = inputSchemas || [];
      outputSchemas = outputSchemas || [];

      var inputs = inputSchemas.length || selectedTool.defaultInputs;
      var outputs = outputSchemas.length || selectedTool.defaultOutputs;

      if (inputs == 0 && outputs == 0) {
        return 'parameters';
      }
      if (inputs < 1 && outputs > 0) {
        return 'input';
      }
      if (inputs > 0 && outputs > 0) {
        return 'transformation';
      }
      if (outputs < 1 && inputs > 0) {
        return 'output';
      }
    };

    vm.getDateTimeFromObject = function (dateTimeObject) {
      var timestamp = moment(
        dateTimeObject.date.year +
          '-' +
          $filter('padLeft')(dateTimeObject.date.month, 2) +
          '-' +
          $filter('padLeft')(dateTimeObject.date.day, 2) +
          'T' +
          $filter('padLeft')(dateTimeObject.time.hour, 2) +
          ':' +
          $filter('padLeft')(dateTimeObject.time.minute, 2) +
          ':' +
          $filter('padLeft')(dateTimeObject.time.second, 2) +
          '.' +
          dateTimeObject.time.nano +
          'Z'
      );

      return timestamp;
    };

    /**
     *
     * @param {
     *  ruleStructure: object,
     *  transformations: object[]
     * } opts
     */
    vm.buildTransformations = function (opts) {
      var transformations = [];
      var time = 0;
      var state = 'idle';

      var transformations = opts.ruleStructure.nodes.map(function (
        node,
        index
      ) {
        var nodeTransformation = opts.transformations.find(function (
          transformation
        ) {
          return transformation.name == node.nodeType;
        });

        var selectedTool = vm.loadProperties(
          node.clsName,
          node.label,
          node.nodeType,
          node.sources,
          node.targets,
          false,
          nodeTransformation.nameId,
          nodeTransformation.parameters,
          opts.ruleStructure.transformations[index].parameters,
          opts.ruleStructure.transformations[index].types,
          nodeTransformation.parametersOptionalValues
        )[0];

        var schema = angular.copy(selectedTool.schema);
        var params = angular.copy(selectedTool.params);
        var types = angular.copy(selectedTool.types);

        return {
          id: node.id,
          name: selectedTool.tool,
          label: node.label || selectedTool.tool,
          type: selectedTool.nameId,
          parameters: params,
          optValues: selectedTool.optValues,
          inputSchemas:
            opts.ruleStructure.transformations[index].inputSchemas || [],
          outputSchemas:
            opts.ruleStructure.transformations[index].outputSchemas || [],
          schema: schema,
          types: types,
          state: state,
          executionTime: time,
        };
      });

      return transformations;
    };

    /**
     *
     * @param {
     *  dom: instance of Document Object model
     *  panning: {
     *    x: number;
     *    y: number;
     *  }
     *  zoomLevel: number
     * } opts
     * @returns
     */
    vm.getDropPosition = function (opts) {
      return {
        top: _setDropPosition({
          domPosition: opts.dom.position.top,
          canvasOffset: $ruleEditorDefaults.canvasOffsetDelta.top,
          panning: opts.panning.y,
          zoomLevel: opts.zoomLevel,
        }),
        left: _setDropPosition({
          domPosition: opts.dom.offset.left,
          canvasOffset: $ruleEditorDefaults.canvasOffsetDelta.left,
          panning: opts.panning.x,
          zoomLevel: opts.zoomLevel,
        }),
      };
    };

    /**
     * Set node position after drop in canvas
     * @param {
     *  domPosition: number;
     *  canvasOffset: number;
     *  panning: number;
     *  zoomLevel: number
     * } opts
     * @returns
     */
    function _setDropPosition(opts) {
      return (
        (opts.domPosition - opts.canvasOffset - opts.panning) / opts.zoomLevel
      );
    }

    /**
     * Builds connections uuid
     * @param {
     *  source: number;
     *  sourceOutputSchema: number;
     *  target: number;
     *  targetInputSchema: number;
     * } stream
     * @returns
     */
    vm.getConnectionsUuid = function (stream) {
      var baseElementId = $ruleEditorDefaults.baseTransformationId;
      var sourceUuid =
        baseElementId + stream.source + '-source-' + stream.sourceOutputSchema;
      var targetUUID =
        baseElementId + stream.target + '-target-' + stream.targetInputSchema;

      return [sourceUuid, targetUUID];
    };

    /**
     * Build cep based stream data from JsPlumbConnectionInfo
     * @param {JsPlubConnectionInfo} connectionInfo
     * @returns
     */
    vm.buildStream = function (connectionInfo) {
      var sourceEndpointUuid = connectionInfo.sourceEndpoint._jsPlumb.uuid;
      var targetEndpointUuid = connectionInfo.targetEndpoint._jsPlumb.uuid;

      return {
        connectionId: connectionInfo.connection.id,
        source: sourceEndpointUuid.split('-')[2],
        target: targetEndpointUuid.split('-')[2],
        sourceOutputSchema: sourceEndpointUuid.split('-')[4],
        targetInputSchema: targetEndpointUuid.split('-')[4],
      };
    };
    /**
     * Remove existen stream to then add the new one with refreshed id
     * @param {object[]} streams
     * @param {object} newStream
     */
    vm.removePreviousStream = function (streams, newStream) {
      return streams.filter(function (stream) {
        return (
          stream.source != newStream.source &&
          stream.target != newStream.target &&
          stream.sourceOutputSchema != newStream.sourceOutputSchema &&
          stream.targetInputSchema != newStream.targetInputSchema
        );
      });
    };
  }
})();

/**
 * Rule editor canvas (JsPlumb) default configs
 */
(function () {
  'use strict';

  angular.module('dashboard').service('plumbProvider', plumbProvider);

  plumbProvider.$inject = [];
  function plumbProvider() {
    var primaryColor = '#4a148c'; 
    var secondaryColor = '#d81b60';
    /**
     * style for the connector
     */
    this.connectorPaintStyle = {
      stroke: '#b4d455',
      strokeWidth: 2,
      radius: 4,
    };

    /**
     * style for the connector hover
     */
    this.connectorHoverStyle = {
      stroke: '#ff9100',
      strokeWidth: 2,
      radius: 4,
    };

    /**
     * Style for the endpoints
     */
    this.endpointHoverStyle = {
      fill: '#ff9100',
      radius: 8,
    };

    /**
     * the source endpoint definition from which a connection can be started
     */
    this.sourceEndpoint = {
      paintStyle: { fill: '#4a148c', radius: 4 },
      isSource: true,
      maxConnections: 1,
      connector: [
        'Flowchart',
        {
          stub: [3, 3],
          gap: 3,
          cornerRadius: 4,
          alwaysRespectStubs: true,
          radius: 4,
        },
      ],
      connectorStyle: this.connectorPaintStyle,
      hoverPaintStyle: this.endpointHoverStyle,
      connectorHoverStyle: this.connectorHoverStyle,
      dragOptions: {},
      EndpointOverlays: [],
      connectorOverlays: [
        [
          'Custom',
          {
            create: function (component) {
              return $(
                '<div class="container-btn-conector"><button class="md-fab md-mini purple darken-3 m0 md-button btn-conector" type="button" title="Schemas">' +
                  '<md-icon md-font-set="material-icons" class="ng-scope material-icons" role="img" aria-hidden="true">list_alt</md-icon>' +
                  '</button><div>'
              );
            },
            location: 0.5,
            visible: true,
            id: 'ARROW',
            direction: 1,
          },
        ],
      ],
    };

    /**
     * Definition of the target endpoint the connector would end
     */
    this.targetEndpoint = {
      radius: 4,
      paintStyle: { fill: '#d81b60', radius: 4 },
      isTarget: true,
      maxConnections: 1,
      dropOptions: {
        hoverClass: 'endpointIshover',
        activeClass: 'endpointIsactive',
      },
      hoverPaintStyle: this.endpointHoverStyle,
    };

    /**
     * Default source getter
     * @param {boolean} realtime
     * @return {object} jsPlumb styles object
     */
    this.getSource = function (realtime) {
      this.sourceEndpoint.paintStyle.fill = realtime ? secondaryColor : primaryColor;
      this.sourceEndpoint.connectorStyle.stroke = realtime ? secondaryColor : primaryColor;
      return this.sourceEndpoint;
    };

    /**
     * Default target getter
     * @param {boolean} realtime
     * @return {object} jsPlumb styles object
     */
    this.getTarget = function (realtime) {
      this.targetEndpoint.paintStyle.fill = realtime ? secondaryColor : primaryColor;
      return this.targetEndpoint;
    };
  }
})();

/**
 * Transformation box directive
 * Used in transformations menu
 */

'use strict';

angular.module('dashboard').directive('transformation', function () {
  return {
    require: '^^transformationsBar',
    restrict: 'A',
    scope: {
      source: '=',
      target: '=',
    },
    link: function (scope, elem, attr, ctrl) {
      elem.draggable({
        helper: function () {
          return $('<div/>', {
            html: elem.html(),
            class: attr.class + ' custom-drag',
            'data-tool': attr.tool,
          });
        },
        zIndex: 999999,
        stack: '.custom-drag',
        revert: false,
      });

      elem.on('mousedown', function ($event) {
        ctrl.onClickTool(
          attr.class + ' custom jtk-node',
          elem.text(),
          attr.tool,
          scope.source || [],
          scope.target || [],
          false
        );
      });
    },
  };
});

/**
 * Format the date model on md-datepicker directive output
 * @param date {Date}
 * @returns {string} string representation of the provided date
 */

'use strict';

angular.module('dashboard').directive('appDatetime', function ($window) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attrs, ngModel) {
      ngModel.$formatters.push(formatter);
      ngModel.$parsers.push(parser);

      element.on('change', function (e) {
        var element = e.target;
        element.value = formatter(ngModel.$modelValue);
      });

      function parser(value) {
        var m = moment(value);
        var valid = m.isValid();
        ngModel.$setValidity('datetime', valid);
        if (valid) return m.format('YYYY-MM-DD');
        else return value;
      }

      function formatter(value) {
        var m = moment(value);
        var valid = m.isValid();
        if (valid) return m.format('YYYY-MM-DD');
        else return value;
      }
    }, //link
  };
}); //appDatetime

(function () {
    'use strict';

    angular
        .module('dashboard')
        .controller('SeriesConfigController', SeriesConfigController);

    SeriesConfigController.$inject = ['$scope', '$rootScope', '$stateParams', 'translationService', '$mdDialog', 'NgTableParams',
        'ngTableEventsChannel', 'toastr', 'EventsV2Factory', 'ReplayConfigurationFactory', '$filter', '$state', 'PermissionsFactory'];

    function SeriesConfigController($scope, $rootScope, $stateParams, $translationService, $mdDialog, NgTableParams, ngTableEventsChannel,
        toastr, EventsV2Factory, ReplayConfigurationFactory, $filter, $state, PermissionsFactory) {
        var vm = this;
        vm.shouldShowFilters = false;

        $scope.toGraphicReports = function () { $state.go('app.graphic-reports') };

        (function init() {
            $translationService.getTranslation($scope, 'replay');
            vm.selectedItems = {
                checked: false,
                items: {}
            };

            vm.config = {
                datasource: {
                    origin: "GET", //REST Methods, ARRAY, WS(WebSocket)
                    url: "/risk-backend/rest/multi-graphic/config/series", //solo para rest y ws
                    params: {
                        query: '',
                        sortBy: 'id',
                        sort: 'desc',
                        startDate: moment($stateParams.desde || (moment().subtract(1, 'week').hour(0).minute(0).second(0))),
                        endDate: moment($stateParams.hasta || (moment().hour(23).minute(59).second(59))),
                        page: 1,
                        itemsPerPage: 25,
                    },
                    paramsOut: {
                        data: "data",
                        pagination: "pagination"
                    }
                },
                pageSizes: [25, 50, 100],
                columns: [
                    {
                        field: "selected",
                        title: "",
                        type: "checkbox",
                        show: true,
                        headerTemplateURL: "headerCheckbox.html",
                        width: 1
                    },
                    { field: "id", title: "Id", type: "number", show: true, sortable: "id", width: 3 },
                    {
                        field: "name",
                        title: $translationService.getTranslationController('Nombre', 'Name', 'Nome'),
                        type: "text",
                        show: true,
                        sortable: "name",
                        filterable: { "type": "text" },
                        width: 20
                    },
                    {
                        field: "type",
                        title: $translationService.getTranslationController('Tipo', 'Type', 'Tipo'),
                        type: "string",
                        show: true,
                        filterable: {
                            "type": "select",
                            "options": [
                                { "key": "ALPHANUMERIC", "value": "ALPHANUMERIC" },
                                { "key": "TIME", "value": "TIME" }
                            ]
                        },
                        width: 5
                    },
                    {
                        field: "source",
                        title: $translationService.getTranslationController('Origen', 'Source', 'Origem'),
                        type: "string",
                        show: true,
                        filterable: {
                            "type": "select",
                            "options": [
                                { "key": "EVENT", "value": "EVENT" },
                                { "key": "LIST", "value": "LIST" },
                                { "key": "SYSTEM", "value": "SYSTEM" }
                            ]
                        },
                        width: 5
                    },
                    {
                        field: "settings",
                        title: $translationService.getTranslationController('Configuración', 'Settings', 'Configuração'),
                        type: "string",
                        show: true,
                        width: 5
                    },
                    {
                        field: "createdBy",
                        title: $translationService.getTranslationController('Creada por', 'Created by', 'Criado por'),
                        type: "string",
                        show: true,
                        width: 5
                    },
                    {
                        field: "totalData",
                        title: $translationService.getTranslationController('Total Datos', 'Total Data', 'Total de dados'),
                        type: "string",
                        show: true,
                        width: 5
                    },
                    {
                        field: "delete",
                        title: "",
                        type: "command",
                        show: true,
                        width: 1,
                        sortable: false
                    }
                ]
            };

        })();

        /*************************************************************************************************************/
        vm.getColumnData = function (_schemaId) {
            $rootScope.loading = true;
            EventsV2Factory.getColumnData(_schemaId).then(function (response) {
                vm.columns = response.columns;
                getTimeSeriesAndValueFn(vm.columns);
                getAutocompleteFieldsFn(vm.columns);
                $rootScope.loading = false;
            }, function (error) {
                $rootScope.loading = false;
            });
        };

        function getTimeSeriesAndValueFn(array) {
            vm.timestamp_fields = $filter('filter')(array, { 'type': 'date' });
            vm.value_fields = $filter('filter')(array, { type: 'integer' });
            array.forEach(function (_item) {
                if (_item.type == 'double') {
                    vm.value_fields.push(_item);
                }
            });
        }

        function getAutocompleteFieldsFn(array) {
            vm.autocompleteFields = $filter('filter')(array, { 'autocomplete': 'true', 'metadata': 'false' });
        }

        vm.remove = function (_series) {
            var confirm = $mdDialog.confirm()
                .title($translationService.getTranslationController('Eliminar Series', 'Delete Series', 'Excluir Série'))
                .textContent($translationService.getTranslationController('¿Estas seguro que quieres borrarlo?', 'Are you sure you want to delete?', 'Tem certeza de que deseja excluir?'))
                .ok($translationService.getTranslationController('Si', 'Yes', 'Sim'))
                .cancel($translationService.getTranslationController('No', 'No', 'Não'));

            $mdDialog.show(confirm).then(function () {
                $rootScope.loading = true;
                ReplayConfigurationFactory.deleteOne(_series.id).then(function (response) {
                    $rootScope.loading = false;
                    toastr.success($translationService.getTranslationController('Serie eliminada exitosamente.', 'Successfully removed series.', 'Serie excluído com sucesso.'));
                    $rootScope.$broadcast('refreshNgTableDynamic', { tableId: 'series-table' });
                }, function (error) {
                    $rootScope.loading = false;
                    if (error.status == 403) {
                        toastr.error($translationService.getTranslationController('Usuario no autorizado.', 'Unauthorized User.', 'Usuário não autorizado.'));
                    } else if (error.status == 412) {
                        toastr.error($translationService.getTranslationController('Serie asociado a uno o más Replay.', 'Series associated with one or more Replay.', 'Séries associadas a um ou mais Replay.'));
                    } else {
                        toastr.error(error);
                    }
                });
            }, function () {

            });
        };

        vm.removeRows = function () {
            var confirm = $mdDialog.confirm()
                .title($translationService.getTranslationController('Eliminar Series', 'Delete Series', 'Excluir Série'))
                .textContent($translationService.getTranslationController('¿Estas seguro que quieres borrarlo?', 'Are you sure you want to delete?', 'Tem certeza de que deseja excluir?'))
                .ok($translationService.getTranslationController('Si', 'Yes', 'Sim'))
                .cancel($translationService.getTranslationController('No', 'No', 'Não'));

            $mdDialog.show(confirm).then(function () {
                $rootScope.loading = true;
                ReplayConfigurationFactory.deleteMany(vm.selectedItems).then(function (response) {
                    toastr.success($translationService.getTranslationController('Series eliminadas exitosamente.', 'Successfully removed series.', 'Serie excluído com sucesso.'));
                }).catch(function (error) {
                    if (error.status == 403) {
                        toastr.error($translationService.getTranslationController('Usuario no autorizado.', 'Unauthorized User.', 'Usuário não autorizado.'));
                    } else if (error.status == 412) {
                        toastr.error($translationService.getTranslationController('Serie asociado a uno o más Replay.', 'Series associated with one or more Replay.', 'Séries associadas a um ou mais Replay.'));
                    } else {
                        toastr.error(error);
                    }
                }).finally(function () {
                    $rootScope.loading = false;
                    $rootScope.$broadcast('refreshNgTableDynamic', { tableId: 'series-table' });
                });
            }, function () {

            });
        };

        /**************************************************************************************************************/
        vm.onLoadDataFromHistory = function (ev) {
            var confirm = $mdDialog.confirm()
                .multiple(true)
                .title($translationService.getTranslationController('¿Está seguro de crear datos de series desde eventos históricos?', 'Are you sure to create series data from historical events?', 'Você tem certeza de criar uma série de dados de eventos históricos?'))
                .ariaLabel('Cancel-Question')
                .targetEvent(ev)
                .ok($translationService.getTranslationController('Si', 'Yes', 'Si'))
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                $rootScope.loading = true;
                ReplayConfigurationFactory.loadDataFromHistory().then(function (response) {
                    var msg = $translationService.getTranslationController('Proceso finalizado.', 'Ended process.', 'Processo finalizado.');
                    toastr.success(msg);
                }).catch(function (e) {
                    toastr.error(e);
                }).finally(function () {
                    $rootScope.loading = false;
                });
            }, function () {
            });
        }

        vm.buildDataByAggregate = function (ev) {
            var confirm = $mdDialog.confirm()
                .multiple(true)
                .title($translationService.getTranslationController('¿Está seguro que desea iniciar el proceso?', 'Are you sure you want to start the process?', 'Tem certeza que deseja iniciar o processo?'))
                .ariaLabel('Cancel-Question')
                .targetEvent(ev)
                .ok($translationService.getTranslationController('Si', 'Yes', 'Si'))
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                $rootScope.loading = true;
                ReplayConfigurationFactory.buildDataByAggregate().then(function (response) {
                    var msg = $translationService.getTranslationController('Proceso finalizado.', 'Ended process.', 'Processo finalizado.');
                    toastr.success(msg);
                }).catch(function (e) {
                    toastr.error(e);
                }).finally(function () {
                    $rootScope.loading = false;
                });
            }, function () {
            });
        }

        vm.validatePermission = function () {
            return PermissionsFactory.isSuperUser();
        }

        /********************************************** Modal Create Serie ********************************************/
        vm.showCreateOrUpdateSeriesDialog = function (selectedItem) {
            $rootScope.loading = true;
            $mdDialog.show({
                controller: 'DialogCreateSeriesController',
                templateUrl: 'app/replay/config/dialog-create-series.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                resolve: {
                    selectedItem: function () {
                        return selectedItem;
                    }
                }
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dashboard')
        .controller('ReplayConfigController', ReplayConfigController);

    ReplayConfigController.$inject = ['$scope', '$localStorageService', 'FileUploader', 'FileSaver', '$modal', '$rootScope',
        '$stateParams', 'Paginator', '$timeout', 'env', '$mdToast', 'EventsFactory', 'BaseUrl', 'translationService', '$mdDialog', '$document',
        'NgTableParams', 'ngTableEventsChannel', '$location', 'toastr', 'SchemasFactory', 'EventsV2Factory',
        'ReplayConfigurationFactory', '$filter', '$mdSidenav', 'DomainFactory'];

    function ReplayConfigController($scope, $localStorageService, FileUploader, FileSaver, $modal, $rootScope, $stateParams, Paginator, $timeout, env,
        $mdToast, EventsFactory, BaseUrl, $translationService, $mdDialog, $document, NgTableParams,
        ngTableEventsChannel, $location, toastr, SchemasFactory, EventsV2Factory,
        ReplayConfigurationFactory, $filter, $mdSidenav, DomainFactory) {

        var vm = this;

        (function init() {
            $translationService.getTranslation($scope, 'replay');

            showLangFn();
            vm.configReplay = {
                datasource: {
                    origin: "GET",
                    url: "/risk-backend/rest/multi-graphic/config/replay",
                    params: {
                        query: '',
                        sortBy: 'id',
                        sort: 'desc',
                        startDate: moment($stateParams.desde || (moment().subtract(1, 'week').hour(0).minute(0).second(0))),
                        endDate: moment($stateParams.hasta || (moment().hour(23).minute(59).second(59))),
                        page: 1,
                        itemsPerPage: 25,
                    },
                    paramsOut: {
                        data: "data",
                        pagination: "pagination"
                    }
                },
                pageSizes: [25, 50, 100],
                columns: [
                    { field: "id", title: "Id", type: "number", show: true, sortable: "id", width: 3 },
                    {
                        field: "name",
                        title: $translationService.getTranslationController('Nombre', 'Name', 'Nome'),
                        type: "text",
                        show: true,
                        sortable: "name",
                        filterable: { "type": "text" },
                        width: 20
                    },
                    {
                        field: "settings",
                        title: $translationService.getTranslationController('Total gráficos', 'Total charts', 'Total gráficos'),
                        type: "object",
                        key: "totalCharts",
                        show: true,
                        width: 5
                    },
                    {
                        field: "settings",
                        title: $translationService.getTranslationController('Objetivo', 'Target', 'Alvo'),
                        type: "object",
                        key: "target",
                        show: true,
                        width: 5
                    },
                    {
                        field: "active",
                        title: $translationService.getTranslationController('Estado', 'Status', 'Estado'),
                        type: "boolean",
                        show: true,
                        width: 5
                    },
                    {
                        field: "delete",
                        title: "",
                        type: "command",
                        show: true,
                        width: 2,
                        sortable: false
                    }
                ]
            };
        })();

        function showLangFn() {
            $rootScope.tabsReplays = [{ id: "index", name: "REPLAY" }];
            if ($rootScope.tabsReplays[0].id === 'index') {
                $rootScope.tabsReplays[0].name = $translationService.getTranslationController('TODOS', 'ALL', 'TODOS');
            }
        }

        vm.removeReplay = function (_replay) {
            var confirm = $mdDialog.confirm()
                .title($translationService.getTranslationController('Eliminar Replay', 'Delete Replay', 'Excluir Replay'))
                .textContent($translationService.getTranslationController('¿Estas seguro que quieres borrarlo?', 'Are you sure you want to delete?', 'Tem certeza de que deseja excluir?'))
                .ok($translationService.getTranslationController('Si', 'Yes', 'Sim'))
                .cancel($translationService.getTranslationController('No', 'No', 'Não'));

            $mdDialog.show(confirm).then(function () {
                $rootScope.loading = true;
                ReplayConfigurationFactory.deleteReplay(_replay.id).then(function (response) {
                    $rootScope.loading = false;
                    $rootScope.$broadcast('refreshNgTableDynamic', { tableId: 'replay-table' });
                    toastr.success($translationService.getTranslationController('Replay eliminado exitosamente.', 'Successfully removed replay.', 'Replay excluído com sucesso.'));
                }, function (error) {
                    $rootScope.loading = false;
                    var msg = $translationService.getTranslationController('No fue posible eliminar el replay.',
                        'It was not possible to delete the replay.', 'Não foi possível excluir o replay.');
                    toastr.error(msg);
                    console.log(error)
                });
            }, function () {

            });
        };

        /********************************************** Modal Create Replay ********************************************/
        vm.showCreateReplayDialog = function (selectedItem) {
            $mdDialog.show({
                controller: 'DialogCreateReplayController',
                templateUrl: 'app/replay/config/dialog-create-replay.html',
                parent: angular.element(document.body),
                //targetEvent: ev,
                clickOutsideToClose: false,
                multiple: true,
                resolve: {
                    selectedItem: function () {
                        return selectedItem;
                    }
                }
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dashboard')
        .controller('DialogCreateSeriesController', DialogCreateSeriesController)

    DialogCreateSeriesController.$inject = ['$q', '$scope', '$rootScope', 'toastr', '$mdDialog', 'translationService', 'LabelFactory', 'SchemasFactory', 'InputListsFactory', 'selectedItem', 'ReplayConfigurationFactory', '$timeout'];

    function DialogCreateSeriesController($q, $scope, $rootScope, toastr, $mdDialog, $translationService, LabelFactory, SchemasFactory, InputListsFactory, selectedItem, ReplayConfigurationFactory, $timeout) {

        $translationService.getTranslation($scope, 'replay');

        $scope.changeSchema = function (schemaId) {
            var schema = $scope.schemas.filter(function (_item) {
                return _item.id == schemaId;
            });

            $scope.selectedSchema = schema[0];
            buildLists();
            if ($scope.schemaId != $scope.series.settings.schemaId) {
                $scope.series.settings.timestamp = undefined;
                $scope.series.settings.value = undefined;
                $scope.series.settings.filter1 = { name: undefined, value: undefined };
                $scope.series.settings.filter2 = { name: undefined, value: undefined };
                $scope.series.settings.filter3 = { name: undefined, value: undefined };
            }
        };

        function buildLists() {
            $scope.keyList = ($scope.series.type == 'TIME' && $scope.series.source == 'EVENT') ? ["timestamp"] : [];
            $scope.valueList = [];
            $scope.autocompleteList = [];
            if (angular.isDefined($scope.selectedSchema)) {
                angular.forEach($scope.selectedSchema.properties, function (value, key) {
                    if ($scope.series.type == 'TIME') {
                        if (value.type == 'timestamp' || value.type == 'date') {
                            if (!$scope.keyList.includes(key))
                                $scope.keyList.push(key);
                        }
                    } else {
                        if (value.type == 'string' || value.type == 'double' || value.type == 'integer') {
                            if (!$scope.keyList.includes(key))
                                $scope.keyList.push(key);
                        }
                    }
                    if (value.type == 'double' || value.type == 'integer') {
                        if (!$scope.valueList.includes(key))
                            $scope.valueList.push(key);
                    }
                    if (value.type != 'timestamp' && value.type != 'date' && value.type != 'boolean') {
                        $scope.autocompleteList.push(getValue($scope.selectedSchema, key, value));
                    }
                });
            }
        }

        $scope.changeLabel = function (_labelId) {
            $rootScope.loading = true;
            $scope.schemas = [];
            SchemasFactory.getSchemasByLabelId(_labelId).then(function (response) {
                response.forEach(function (_item) {
                    var schema = angular.fromJson(_item);
                    schema.definitions = angular.fromJson(angular.fromJson(schema.schema).definitions);
                    schema.required = angular.fromJson(schema.definitions[schema.name].required);
                    schema.properties = angular.fromJson(schema.definitions[schema.name].properties);
                    $scope.schemas.push(schema);
                });
                if ($scope.isUpdated) {
                    $scope.changeSchema($scope.series.settings.schemaId)
                }
                $scope.$apply();
            }).catch(function (e) {
                toastr.error(e);
            }).finally(function () {
                $rootScope.loading = false;
            });
        }

        function getLabels() {
            $scope.countCall = $scope.countCall + 1;
            $rootScope.loading = true;
            LabelFactory.getLabels().then(function (response) {
                $scope.labels = response;
            }).catch(function (e) {
                console.log('DialogCreateSeriesController@getLabels' + e);
                toastr.error(e);
            }).finally(function () {
                $rootScope.loading = false;
                $scope.countCall = $scope.countCall - 1;
            });
        }

        function getListFn() {
            $scope.countCall = $scope.countCall + 1;
            $rootScope.loading = true;
            InputListsFactory.getLists().then(function (response) {
                $scope.lists = response.lists;
            }).catch(function (e) {
                toastr.error(e);
            }).finally(function () {
                $rootScope.loading = false;
                $scope.countCall = $scope.countCall - 1;
            });
        }

        (function init() {
            $scope.isLoading = true;
            $scope.labels = [];
            $scope.schemas = [];
            $scope.cronBuilder;
            $scope.cronConfig = { allowMultiple: true };
            $scope.sourceList = ["EVENT", "LIST", "SYSTEM"];
            if (angular.isUndefined(selectedItem)) {
                $scope.isUpdated = false;
                $scope.actionText = $translationService.getTranslationController('Crear Serie ', 'Create Series', 'Criar Serie');
            } else {
                $scope.isUpdated = true;
                $scope.actionText = $translationService.getTranslationController('Actualizar Series', 'Update Series', 'Atualizar Series');
            }

            $scope.listId = undefined;
            $scope.series = {
                source: 'EVENT',
                type: 'TIME',
                createdBy: 'USER',
                settings: {
                    labelId: undefined,
                    schemaId: undefined,
                    listId: undefined,
                    filter1: { name: undefined, value: undefined, type: undefined, autocomplete: false },
                    filter2: { name: undefined, value: undefined, type: undefined, autocomplete: false },
                    filter3: { name: undefined, value: undefined, type: undefined, autocomplete: false },
                    color: '#f00505',
                    displayTitle: undefined,
                    loadHistoricalData: false
                }
            }
            var promiseSchemasByLabelId = undefined;
            if (angular.isDefined(selectedItem)) {
                $scope.series = angular.copy(selectedItem);
                $scope.series.settings.timestamp = $scope.series.settings.timestamp.replace("#", "");
                $scope.series.settings.value = $scope.series.settings.value.replace("#", "");
                $scope.listId = $scope.series.settings.listId;
                $scope.schemaId = $scope.series.settings.schemaId;
                $scope.myTraceJson = angular.toJson($scope.series.trace, true);
                if (angular.isDefined($scope.series.settings.labelId) && angular.isUndefined($scope.listId)) {
                    promiseSchemasByLabelId = SchemasFactory.getSchemasByLabelId($scope.series.settings.labelId)
                }
            }

            var promiseList = InputListsFactory.getLists();
            var promiseLabel = LabelFactory.getLabels();

            $q.all([promiseList, promiseLabel, promiseSchemasByLabelId]).then(function (result) {
                $scope.lists = result[0].lists;
                $scope.labels = result[1];

                var schemas = result[2];
                if (angular.isDefined(schemas)) {
                    for (var i = 0; i < schemas.length; i++) {
                        var schema = angular.fromJson(schemas[i]);
                        schema.definitions = angular.fromJson(angular.fromJson(schema.schema).definitions);
                        schema.required = angular.fromJson(schema.definitions[schema.name].required);
                        schema.properties = angular.fromJson(schema.definitions[schema.name].properties);
                        $scope.schemas.push(schema);
                    }
                    if ($scope.isUpdated) {
                        $scope.changeSchema($scope.series.settings.schemaId)
                    }
                }
                if (angular.isDefined($scope.listId) && $scope.listId > 0) {
                    $scope.onChangeList($scope.listId);
                }
                $scope.isLoading = false;
            }).catch(function (e) {
                toastr.error(e);
            }).finally(function () {
                $rootScope.loading = false;
            });
        })();

        $scope.onChangeSource = function () {
            console.log('DialogCreateSeriesController@onChangeSource')
            $scope.series.settings.timestamp = undefined;
            $scope.series.settings.value = undefined;
            $scope.series.settings.filter1 = { name: undefined, value: undefined };
            $scope.series.settings.filter2 = { name: undefined, value: undefined };
            $scope.series.settings.filter3 = { name: undefined, value: undefined };
            $scope.series.settings.scheduler = undefined;
            $scope.series.settings.loadHistoricalData = false;
            $scope.keyList = [];
            $scope.series.settings.schemaId = undefined;
            $scope.series.settings.listId = undefined;
            if ($scope.series.type == 'TIME') {
                $scope.sourceList = ["EVENT", "LIST", "SYSTEM"];
            } else {
                $scope.sourceList = ["LIST", "SYSTEM"];
            }
        }

        $scope.createSeries = function () {
            if (angular.isUndefined($scope.selectedSchema)) {
                return;
            }
            $rootScope.loading = true;
            var series = angular.copy($scope.series);
            series.settings.timestamp = getValue($scope.selectedSchema, $scope.series.settings.timestamp, undefined);
            series.settings.value = getValue($scope.selectedSchema, $scope.series.settings.value, undefined);
            series.settings.filter1 = getFilter(series.settings.filter1);
            series.settings.filter2 = getFilter(series.settings.filter2);
            series.settings.filter3 = getFilter(series.settings.filter3);
            if (angular.isUndefined($scope.series.id)) {
                ReplayConfigurationFactory.create(series).then(function (response) {
                    $rootScope.$broadcast('refreshNgTableDynamic', { tableId: 'series-table' });
                    toastr.success($translationService.getTranslationController('Serie creada exitosamente.', 'Successfully created Series.', 'Série criada com sucesso.'));
                    $mdDialog.hide();
                }, function (error) {
                    if (error.status == 403) {
                        toastr.error($translationService.getTranslationController('Usuario no autorizado.', 'Unauthorized User.', 'Usuário não autorizado.'));
                    } else if (error.status == 406) {
                        toastr.error($translationService.getTranslationController('La Series ya existe.', 'Series already exists.', 'Série já existe.'));
                    } else if (error.status == 400) {
                        toastr.error(error.data);
                    } else {
                        toastr.error(error.data);
                    }
                }).finally(function () {
                    $rootScope.loading = false;
                });
            } else {
                ReplayConfigurationFactory.edit(series).then(function (response) {
                    toastr.success($translationService.getTranslationController('Serie actualizada exitosamente.', 'Successfully updated Series.', 'Série atualizada com sucesso.'));
                    $rootScope.$broadcast('refreshNgTableDynamic', { tableId: 'series-table' });
                    $mdDialog.hide();
                }, function (error) {
                    if (error.status == 403) {
                        toastr.error($translationService.getTranslationController('Usuario no autorizado.', 'Unauthorized User.', 'Usuário não autorizado.'));
                    } else if (error.status == 406) {
                        toastr.error($translationService.getTranslationController('La Series ya existe.', 'Series already exists.', 'Série já existe.'));
                    } else {
                        toastr.error(error.data);
                    }
                }).finally(function () {
                    $rootScope.loading = false;
                });
            }
        }

        $scope.onChangeList = function (listId) {
            console.log('DialogCreateSeriesController@onChangeList')
            if (angular.isDefined($scope.listId) && $scope.listId != $scope.series.settings.listId) {
                $scope.series.settings.timestamp = undefined;
                $scope.series.settings.value = undefined;
                $scope.series.settings.filter1 = {
                    name: undefined,
                    value: undefined,
                    type: undefined,
                    autocomplete: false
                };
                $scope.series.settings.filter2 = {
                    name: undefined,
                    value: undefined,
                    type: undefined,
                    autocomplete: false
                };
                $scope.series.settings.filter3 = {
                    name: undefined,
                    value: undefined,
                    type: undefined,
                    autocomplete: false
                };
            }
            if (angular.isDefined($scope.lists)) {
                var list = $scope.lists.filter(function (_item) {
                    return _item.listId == listId;
                });

                var schema = angular.fromJson(list[0].schema);
                schema.definitions = angular.fromJson(angular.fromJson(schema.schema).definitions);
                schema.required = angular.fromJson(schema.definitions[schema.name].required);
                schema.properties = angular.fromJson(schema.definitions[schema.name].properties);
                $scope.selectedSchema = schema;
                buildLists();
            }
        }

        $scope.cancel = function (ev) {
            var confirm = $mdDialog.confirm()
                .multiple(true)
                .title($translationService.getTranslationController('¿Deseas cancelar?', 'Do you want to cancel?', 'Você quer cancelar?'))
                .textContent($translationService.getTranslationController('¡Todos los cambios se perderán!', 'All changes will be lost!', 'Todas as alterações serão perdidas!'))
                .ariaLabel('Cancel-Question')
                .targetEvent(ev)
                .ok($translationService.getTranslationController('Abandonar', 'Leave', 'Deixar'))
                .cancel($translationService.getTranslationController('Cancelar', 'Cancel', 'Cancelar'));

            $mdDialog.show(confirm).then(function () {
                $mdDialog.cancel();
            }, function () {
            });
        }

        $scope.getAutocompleteFields = function (_field) {
            if (angular.isUndefined($scope.autocompleteList)) {
                return [];
            }
            return $scope.autocompleteList.filter(function (value, key) {
                if (_field == 1) {
                    if (angular.isUndefined($scope.series.settings.filter1) && angular.isUndefined($scope.series.settings.filter2) && angular.isUndefined($scope.series.settings.filter3)) {
                        return true;
                    } else if (angular.isUndefined($scope.series.settings.filter1) && angular.isDefined($scope.series.settings.filter2) && angular.isUndefined($scope.series.settings.filter3)
                        && value.name != $scope.series.settings.filter2.name) {
                        return true;
                    } else if (angular.isUndefined($scope.series.settings.filter1) && angular.isUndefined($scope.series.settings.filter2) && angular.isDefined($scope.series.settings.filter3)
                        && value.name != $scope.series.settings.filter3.name) {
                        return true;
                    } else {
                        return (angular.isDefined($scope.series.settings.filter1) && value.name == $scope.series.settings.filter1.name) ||
                            (angular.isDefined($scope.series.settings.filter2) && angular.isDefined($scope.series.settings.filter3) &&
                                value.name != $scope.series.settings.filter2.name && value.name != $scope.series.settings.filter3.name);
                    }
                } else if (_field == 2) {
                    if (angular.isUndefined($scope.series.settings.filter1) && angular.isUndefined($scope.series.settings.filter2) && angular.isUndefined($scope.series.settings.filter3)) {
                        return true;
                    } else if (angular.isDefined($scope.series.settings.filter1) && angular.isUndefined($scope.series.settings.filter2) && angular.isUndefined($scope.series.settings.filter3)
                        && value.name != $scope.series.settings.filter1.name) {
                        return true;
                    } else if (angular.isUndefined($scope.series.settings.filter1) && angular.isUndefined($scope.series.settings.filter2) && angular.isDefined($scope.series.settings.filter3)
                        && value.name != $scope.series.settings.filter3.name) {
                        return true;
                    } else {
                        return (angular.isDefined($scope.series.settings.filter2) && value.name == $scope.series.settings.filter2.name) ||
                            (angular.isDefined($scope.series.settings.filter1) && angular.isDefined($scope.series.settings.filter3) &&
                                value.name != $scope.series.settings.filter1.name && value.name != $scope.series.settings.filter3.name);
                    }
                } else {
                    if (angular.isUndefined($scope.series.settings.filter1) && angular.isUndefined($scope.series.settings.filter2) && angular.isUndefined($scope.series.settings.filter3)) {
                        return true;
                    } else if (angular.isDefined($scope.series.settings.filter1) && angular.isUndefined($scope.series.settings.filter2) && angular.isUndefined($scope.series.settings.filter3)
                        && value.name != $scope.series.settings.filter1.name) {
                        return true;
                    } else if (angular.isUndefined($scope.series.settings.filter1) && angular.isDefined($scope.series.settings.filter2) && angular.isUndefined($scope.series.settings.filter3)
                        && value.name != $scope.series.settings.filter2.name) {
                        return true;
                    } else {
                        return (angular.isDefined($scope.series.settings.filter3) && value.name == $scope.series.settings.filter3.name) ||
                            (angular.isDefined($scope.series.settings.filter1) && angular.isDefined($scope.series.settings.filter2) &&
                                value.name != $scope.series.settings.filter1.name && value.name != $scope.series.settings.filter2.name);
                    }
                }
            });
        }

        $scope.cronBuilderCallback = function (expression, id) {
            $scope.series.settings.scheduler = expression;
            $scope.cronBuilder.close();
        }

        function getValue(schema, key, value) {
            var result = schema.required.filter(function (_item) {
                return _item.includes('#' + key);
            });
            if (result.length > 0) {
                key = result[0];
            }
            if (value == undefined) {
                return key;
            }
            return { name: key, type: value.type, autocomplete: value.autocomplete };
        }

        function getFilter(filter) {
            if (angular.isUndefined(filter)) {
                return;
            }
            var result = $scope.autocompleteList.filter(function (_item) {
                return _item.name == filter.name;
            });
            if (result.length > 0) {
                return {
                    name: result[0].name,
                    value: filter.value,
                    type: result[0].type,
                    autocomplete: result[0].autocomplete
                };
            } else {
                return;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dashboard')
        .controller('DialogCreateReplayController', DialogCreateReplayController)

    DialogCreateReplayController.$inject = ['$rootScope', '$scope', '$mdDialog', 'translationService', 'ReplayConfigurationFactory', 'selectedItem', 'toastr', 'PermissionsFactory'];

    function DialogCreateReplayController($rootScope, $scope, $mdDialog, $translationService, ReplayConfigurationFactory, selectedItem, toastr, PermissionsFactory) {

        (function init() {
            console.log("------ DialogCreateReplayController -------");
            $translationService.getTranslation($scope, 'replay');

            if (angular.isUndefined(selectedItem)) {
                $scope.replay = {
                    id: undefined,
                    active: true,
                    settings: {
                        showHeader: true,
                        displayListModeCharts: true,
                        darkTheme: true,
                        target: ['replay'],
                        charts: []
                    }
                };
                $scope.actionText = $translationService.getTranslationController('Crear Reporte Gráfico', 'Create Graphic Report', 'Criar Relatório Gráfico');
            } else {
                $scope.replay = angular.copy(selectedItem);
                if (angular.isDefined($scope.replay.settings.target)) {
                    $scope.replay.settings.target = $scope.replay.settings.target.split(",");
                }
                $scope.actionText = $translationService.getTranslationController('Actualizar Reporte Gráfico', 'Update Graphic Report', 'Atualizar Relatório Gráfico');
            }
        })();

        $scope.createReplay = function () {
            var replay = {
                id: $scope.replay.id,
                name: $scope.replay.name,
                active: $scope.replay.active,
                settings: {
                    showHeader: $scope.replay.settings.showHeader,
                    displayListModeCharts: $scope.replay.settings.displayListModeCharts,
                    target: $scope.replay.settings.target.join(','),
                    charts: $scope.replay.settings.charts,
                    darkTheme: $scope.replay.settings.darkTheme
                }
            }
            for (var i = 0; i < replay.settings.charts.length; i++) {
                replay.settings.charts[i].id = i + 1;
            }
            console.log(replay)
            if (angular.isUndefined(replay.id)) {
                $rootScope.loading = true;
                ReplayConfigurationFactory.createReplay(replay).then(function (response) {
                    $rootScope.loading = false;
                    PermissionsFactory.addPermission('graphic-report', response.data, 'all', true);
                    $rootScope.$broadcast('refreshNgTableDynamic', { tableId: 'replay-table' });
                    toastr.success($translationService.getTranslationController('Reporte Gráfico creado exitosamente.', 'Successfully created Graphic Report.', 'Relatório Gráfico creado com sucesso.'));

                    $mdDialog.hide();
                }, function (error) {
                    $rootScope.loading = false;
                    if (error.status == 403) {
                        toastr.error($translationService.getTranslationController('Usuario no autorizado.', 'Unauthorized User.', 'Usuário não autorizado.'));
                    } else {
                        toastr.error(error);
                    }
                });
            } else {
                $rootScope.loading = true;
                ReplayConfigurationFactory.editReplay(replay).then(function (response) {
                    $rootScope.loading = false;
                    $rootScope.$broadcast('refreshNgTableDynamic', { tableId: 'replay-table' });
                    toastr.success($translationService.getTranslationController('Reporte Gráfico actualizado exitosamente.', 'Successfully updated Graphic Report.', 'Relatório Gráfico atualizada com sucesso.'));
                    $mdDialog.hide(replay);
                }, function (error) {
                    $rootScope.loading = false;
                    if (error.status == 403) {
                        toastr.error($translationService.getTranslationController('Usuario no autorizado.', 'Unauthorized User.', 'Usuário não autorizado.'));
                    } else {
                        toastr.error(error);
                    }
                });
            }
        }

        $scope.removeRow = function (ev, index) {
            var confirm = $mdDialog.confirm()
                .multiple(true)
                .title($translationService.getTranslationController('¿Deseas borrar el registro de la lista?', 'Do you want to delete the record from the list?', 'Você deseja excluir o registro da lista?'))
                .ariaLabel('Cancel-Question')
                .targetEvent(ev)
                .ok($translationService.getTranslationController('Si', 'Yes', 'Sim'))
                .cancel($translationService.getTranslationController('No', 'No', 'Não'));

            $mdDialog.show(confirm).then(function () {
                $scope.replay.settings.charts.splice(index, 1);
            }, function () {
            });
        }

        $scope.cancel = function (ev) {
            var confirm = $mdDialog.confirm()
                .multiple(true)
                .title($translationService.getTranslationController('¿Deseas cancelar?', 'Do you want to cancel?', 'Você quer cancelar?'))
                .textContent($translationService.getTranslationController('¡Todos los cambios se perderán!', 'All changes will be lost!', 'Todas as alterações serão perdidas!'))
                .ariaLabel('Cancel-Question')
                .targetEvent(ev)
                .ok($translationService.getTranslationController('Abandonar', 'Leave', 'Deixar'))
                .cancel($translationService.getTranslationController('Cancelar', 'Cancel', 'Cancelar'));

            $mdDialog.show(confirm).then(function () {
                $mdDialog.cancel();
            }, function () {
            });
        }

        $scope.showChartDialog = function (ev, selectedItem) {
            $mdDialog.show({
                controller: DialogChartController,
                templateUrl: 'app/replay/config/dialog-chart.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                multiple: true,
                resolve: {
                    selectedItem: function () {
                        return selectedItem;
                    }
                }
            }).then(function (_chart) {
                if (_chart.id != undefined) {
                    var index = 0;
                    for (var i = 0; i < $scope.replay.settings.charts.length; i++) {
                        if ($scope.replay.settings.charts[i].id == _chart.id) {
                            index = i;
                            break;
                        }
                    }
                    $scope.replay.settings.charts.splice(index, 1, _chart);
                } else {
                    $scope.replay.settings.charts.push(_chart);
                }
            });
        }

        $scope.moveUp = function (item, index) {
            $scope.replay.settings.charts.splice(index, 1);
            if (index == 0) {
                $scope.replay.settings.charts.push(item);
            } else {
                $scope.replay.settings.charts.splice(index - 1, 0, item);
            }
        }

        /********************************************** Modal Create chart ********************************************/

        DialogChartController.$inject = ['$scope', '$mdDialog', 'translationService', 'ReplayConfigurationFactory', 'LabelFactory', 'SchemasFactory', 'EventsV2Factory', 'selectedItem', '$timeout'];

        function DialogChartController($scope, $mdDialog, $translationService, ReplayConfigurationFactory, LabelFactory, SchemasFactory, EventsV2Factory, selectedItem, $timeout) {

            $scope.changeLabel = function (_labelId) {
                if (angular.isUndefined(_labelId)) return;

                $rootScope.loading = true;
                EventsV2Factory.getColumnData(_labelId).then(function (response) {
                    $scope.functions = response.functions;
                    $rootScope.loading = false;
                    $scope.$apply();
                }, function (error) {
                    $rootScope.loading = false;
                });
            };

            $scope.changeFunction = function (_functionId) {
                if (angular.isUndefined(_functionId)) return;

                var _function = $scope.functions.filter(function (_item) {
                    return _item.id == _functionId;
                });

                $scope.functionColumns = [];
                EventsV2Factory.getColumnData(_function[0].schemasIds.join(',')).then(function (response) {
                    $scope.chart.schemaIds = response.schemaIds;
                    $scope.functionColumnsView = response.columns;
                    $scope.functionColumns = angular.copy(response.columns);
                    $scope.$apply();
                }, function (error) {
                    toastr.error(e);
                    $rootScope.loading = false;
                });
            };

            $scope.onChangeSeriesType = function (seriesType) {
                if (angular.isUndefined(seriesType)) return;
                $scope.chart.seriesLine = [];
                $scope.chart.seriesColumn = [];
                $scope.chart.seriesBubble = [];

                $rootScope.loading = true;
                ReplayConfigurationFactory.getAllSeries(seriesType).then(function (response) {
                    $scope.seriesSource = response.data;
                    $scope.$apply();
                }, function (error) {
                    console.log('DialogChartController@onChangeSeriesType. ' + error)
                }).finally(function () {
                    $rootScope.loading = false;
                });
            };

            (function init() {

                $translationService.getTranslation($scope, 'replay');

                $rootScope.loading = true;
                LabelFactory.getLabels().then(function (response) {
                    $scope.labels = response;
                    $scope.$apply();
                }).catch(function (e) {
                    toastr.error(e);
                }).finally(function () {
                    $rootScope.loading = false;
                });

                if (angular.isUndefined(selectedItem)) {
                    $scope.chart = {
                        id: undefined,
                        name: undefined,
                        type: 'LINE',
                        source: 'SERIES',
                        showFilter: false,
                        timeInterval: ['tick'],
                        refreshSpeed: 0,
                        stacked: false,
                        stackType: 'normal',
                        multipleYaxis: false,
                        showLegend: false
                    };
                    $scope.actionText = $translationService.getTranslationController('Crear Gráfico', 'Create Chart', 'Criar Gráfico');
                } else {
                    $scope.chart = {
                        id: selectedItem.id,
                        name: selectedItem.name,
                        type: selectedItem.type,
                        seriesType: selectedItem.seriesType,
                        seriesLine: [],
                        seriesColumn: [],
                        seriesBubble: []
                    };
                    var tmp = JSON.parse(selectedItem.settings);
                    if ($scope.chart.type == 'TABLE') {
                        $scope.chart.source = tmp.source;
                        if ($scope.chart.source == 'EVENT') {
                            $scope.chart.labelId = tmp.labelId;
                            $scope.chart.schemaIds = tmp.schemaIds;
                            $scope.chart.functionId = tmp.functionId;
                            $scope.changeLabel($scope.chart.labelId);
                            $timeout(function () {
                                $scope.changeFunction($scope.chart.functionId);
                            }, 1000);
                            $scope.chart.columnFilter = tmp.columnFilter;
                            $scope.chart.columnTable = [];
                            tmp.columnTable.forEach(function (_item) {
                                $scope.chart.columnTable.push(_item.name);
                            });
                        } else {
                            $scope.chart.source = tmp.source;
                            $scope.chart.tableSeriesId = tmp.tableSeriesId;
                            $scope.chart.tableInterval = tmp.tableInterval;
                        }
                    } else {
                        $scope.onChangeSeriesType($scope.chart.seriesType);
                        $scope.chart.showFilter = tmp.showFilter;
                        $scope.chart.timeInterval = (angular.isDefined(tmp.timeInterval)) ? tmp.timeInterval.split(',') : undefined;
                        $scope.chart.refreshSpeed = tmp.refreshSpeed;
                        $scope.chart.stacked = tmp.stacked;
                        $scope.chart.stackType = tmp.stackType;
                        $scope.chart.multipleYaxis = tmp.multipleYaxis;
                        $scope.chart.showLegend = tmp.showLegend;
                        $scope.chart.seriesModeSelection = selectedItem.seriesModeSelection;
                        $scope.chart.prefixLine = selectedItem.prefixLine;
                        $scope.chart.prefixColumn = selectedItem.prefixColumn;
                        $scope.chart.prefixBubble = selectedItem.prefixBubble;
                        if ($scope.chart.seriesModeSelection == 'BY_SELECTION') {
                            selectedItem.series.forEach(function (_series) {
                                if (_series.type == 'LINE') {
                                    $scope.chart.seriesLine.push(_series.id);
                                } else if (_series.type == 'BAR') {
                                    $scope.chart.seriesColumn.push(_series.id);
                                } else {
                                    $scope.chart.seriesBubble.push(_series.id);
                                }
                            });
                        }
                    }
                    $scope.actionText = $translationService.getTranslationController('Actualizar Gráfico', 'Update Chart', 'Atualizar Gráfico');
                }
            })();

            $scope.onChangeSeriesModeSelection = function () {
                if ($scope.chart.seriesModeSelection == 'BY_PREFIX') {
                    $scope.chart.seriesLine = [];
                    $scope.chart.seriesColumn = [];
                    $scope.chart.seriesBubble = [];
                } else {
                    $scope.chart.prefixLine = undefined;
                    $scope.chart.prefixColumn = undefined;
                    $scope.chart.prefixBubble = undefined;
                }
            }

            function getColumnTable() {
                var array = [];
                $scope.chart.columnTable.forEach(function (_column) {
                    var columns = $scope.functionColumns.filter(function (_item) {
                        return _item.name == _column;
                    });
                    if (columns.length > 0) array.push(columns[0]);
                });
                return array;
            }

            $scope.createChart = function () {
                var chart = {
                    id: $scope.chart.id,
                    name: $scope.chart.name,
                    type: $scope.chart.type,
                    strSeries: '',
                    seriesType: $scope.chart.seriesType,
                    seriesModeSelection: $scope.chart.seriesModeSelection,
                    prefixLine: $scope.chart.prefixLine,
                    prefixColumn: $scope.chart.prefixColumn,
                    prefixBubble: $scope.chart.prefixBubble,
                    series: []
                };

                if (chart.type == 'TABLE') {
                    if ($scope.chart.source == 'SERIES') {
                        var series = $scope.seriesSource.filter(function (_item) {
                            return _item.id == $scope.chart.tableSeriesId;
                        });
                        chart.strSeries = series[0].name;
                        chart.settings = JSON.stringify({
                            source: $scope.chart.source,
                            tableSeriesId: $scope.chart.tableSeriesId,
                            tableInterval: $scope.chart.tableInterval,

                        })
                    } else {
                        chart.settings = JSON.stringify({
                            source: $scope.chart.source,
                            labelId: $scope.chart.labelId,
                            schemaIds: $scope.chart.schemaIds,
                            functionId: $scope.chart.functionId,
                            columnTable: getColumnTable(),
                            columnFilter: $scope.chart.columnFilter,
                        })
                    }
                } else {
                    chart.settings = JSON.stringify({
                        showFilter: $scope.chart.showFilter,
                        timeInterval: (chart.seriesType == 'TIME') ? $scope.chart.timeInterval.join(',') : undefined,
                        refreshSpeed: $scope.chart.refreshSpeed,
                        stacked: $scope.chart.stacked,
                        stackType: $scope.chart.stackType,
                        multipleYaxis: $scope.chart.multipleYaxis,
                        showLegend: $scope.chart.showLegend
                    })
                }

                if ($scope.chart.type == 'BAR' && angular.isDefined($scope.chart.seriesColumn)) {
                    $scope.chart.seriesColumn.forEach(function (_id) {
                        var series = $scope.seriesSource.filter(function (_item) {
                            return _item.id == _id;
                        });
                        chart.strSeries = (chart.strSeries == '') ? series[0].name : chart.strSeries + ', ' + series[0].name;
                        chart.series.push({
                            id: series[0].id,
                            name: series[0].name,
                            type: 'BAR'
                        });
                    });
                } else if ($scope.chart.type == 'LINE') {
                    if (angular.isDefined($scope.chart.seriesLine)) {
                        $scope.chart.seriesLine.forEach(function (_id) {
                            var series = $scope.seriesSource.filter(function (_item) {
                                return _item.id == _id;
                            });
                            chart.strSeries = (chart.strSeries == '') ? series[0].name + ' (line)' : chart.strSeries + ', ' + series[0].name + ' (line)';
                            chart.series.push({
                                id: series[0].id,
                                name: series[0].name,
                                type: 'LINE'
                            });
                        });
                    }
                    if (angular.isDefined($scope.chart.seriesColumn)) {
                        $scope.chart.seriesColumn.forEach(function (_id) {
                            var series = $scope.seriesSource.filter(function (_item) {
                                return _item.id == _id;
                            });
                            chart.strSeries = (chart.strSeries == '') ? series[0].name + ' (bar)' : chart.strSeries + ', ' + series[0].name + ' (bar)';
                            chart.series.push({
                                id: series[0].id,
                                name: series[0].name,
                                type: 'BAR'
                            });
                        });
                    }
                    if (angular.isDefined($scope.chart.seriesBubble)) {
                        $scope.chart.seriesBubble.forEach(function (_id) {
                            var series = $scope.seriesSource.filter(function (_item) {
                                return _item.id == _id;
                            });
                            chart.strSeries = (chart.strSeries == '') ? series[0].name + ' (scatter)' : chart.strSeries + ', ' + series[0].name + ' (scatter)';
                            chart.series.push({
                                id: series[0].id,
                                name: series[0].name,
                                type: 'SCATTER'
                            });
                        });
                    }
                }

                if (chart.type != 'TABLE' && chart.seriesModeSelection == 'BY_SELECTION' && chart.series.length == 0) {
                    toastr.error($translationService.getTranslationController('Lista de Series es requerida.', 'Series List is required.', 'Lista de séries é necessária.'));
                    return;
                }
                $mdDialog.hide(chart);
            }

            $scope.cancel = function (ev) {
                var confirm = $mdDialog.confirm()
                    .multiple(true)
                    .title($translationService.getTranslationController('¿Deseas cancelar?', 'Do you want to cancel?', 'Você quer cancelar?'))
                    .textContent($translationService.getTranslationController('¡Todos los cambios se perderán!', 'All changes will be lost!', 'Todas as alterações serão perdidas!'))
                    .ariaLabel('Cancel-Question')
                    .targetEvent(ev)
                    .ok($translationService.getTranslationController('Abandonar', 'Leave', 'Deixar'))
                    .cancel($translationService.getTranslationController('Cancelar', 'Cancel', 'Cancelar'));

                $mdDialog.show(confirm).then(function () {
                    $mdDialog.cancel();
                }, function () {
                });
            };
        }

    }
})();

"use strict";

angular.module('dashboard').component('chartTable', {
    templateUrl: 'app/replay/component/chart-table.html',
    controllerAs: 'ctrl',
    bindings: {
        chart: '='
    },
    controller: ChartTableController
});


ChartTableController.$inject = ['$scope', '$localStorageService', '$rootScope', '$stateParams', 'CaseFactory', '$timeout',
    'translationService', 'toastr', '$location', 'EventsV2Factory', 'WorkspaceFactory', '$mdDialog'];

function ChartTableController($scope, $localStorageService, $rootScope, $stateParams, CaseFactory, $timeout,
    $translationService, toastr, $location, EventsV2Factory, WorkspaceFactory, $mdDialog) {
    var vm = this;

    vm.$onInit = function () {

        //Método para realizar traducción
        $translationService.getTranslation($scope, 'replay');
    };

    vm.initGrid = function () {

        function getFilterType(item) {
            var operation;

            if (item.autocomplete == true && item.metadata == false) {
                operation = 'autocomplete';
            } else if (item.autocomplete == true && item.metadata == true) {
                operation = 'select';
            } else {
                operation = 'input';
            }
            return operation;
        }

        function getOperation(type) {
            var operation;
            switch (type) {
                case 'boolean':
                    operation = '=';
                    break;
                case 'string':
                    operation = '=';
                    break;
                case 'double':
                    operation = '>=';
                    break;
                case 'integer':
                    operation = '>=';
                    break;
                default:
                    operation = '=';
            }
            return operation;
        }

        var setting = JSON.parse(vm.chart.settings);
        if (setting.source == 'SERIES') {
            return new Promise(function (resolve, reject) {
                var config = {
                    datasource: {
                        origin: "GET",
                        url: "/risk-backend/rest/multi-graphic/ts/series/" + setting.tableSeriesId + '/?',
                        params: {
                            query: '',
                            sortBy: 'timestamp',
                            sort: 'asc',
                            page: 1,
                            itemsPerPage: 25,
                        },
                        paramsOut: {
                            data: "data",
                            pagination: "pagination"
                        }
                    },
                    pageSizes: [25, 50, 100],
                    columns: [
                        {
                            field: "aggregate",
                            col: "aggregate",
                            title: $translationService.getTranslationController('Intervalo de Tiempo', 'Time Interval', 'Intervalo de tempo'),
                            type: "radio",
                            show: false,
                            filterable: true,
                            filterType: 'simple-select',
                            metadata: {
                                type: 'string',
                                values: [{ id: 'TICK', value: 'TICK' },
                                { id: 'MINUTE', value: 'MINUTE' },
                                { id: 'HOUR', value: 'HOURS' },
                                { id: 'DAY', value: 'DAY' },
                                { id: 'WEEK', value: 'WEEK' },
                                { id: 'MONTH', value: 'MONTH' }
                                ]
                            }
                        },
                        {
                            field: "x",
                            col: "x",
                            title: $translationService.getTranslationController('Tiempo', 'TimeStamp', 'Tempo'),
                            type: "datetime",
                            show: true,
                            width: 20
                        },
                        {
                            field: "y",
                            col: "y",
                            title: $translationService.getTranslationController('Valor', 'Value', 'Valor'),
                            type: "integer",
                            show: true,
                            filterable: false,
                            width: 20
                        },
                        {
                            field: "filter1",
                            col: "filter1",
                            title: $translationService.getTranslationController('Filtro 1', 'Filter 1', 'Filter 1'),
                            type: "string",
                            show: true,
                            filterable: false,
                            width: 20
                        },
                        {
                            field: "filter2",
                            col: "filter2",
                            title: $translationService.getTranslationController('Filtro 2', 'Filter 2', 'Filter 2'),
                            type: "string",
                            show: true,
                            filterable: false,
                            width: 20
                        },
                        {
                            field: "filter3",
                            col: "filter3",
                            title: $translationService.getTranslationController('Filtro 3', 'Filter 3', 'Filter 3'),
                            type: "string",
                            show: true,
                            filterable: false,
                            width: 20
                        }
                    ]
                };
                resolve(config);
            });
        } else {
            return new Promise(function (resolve, reject) {
                var gridColumns = [];

                var config = {
                    datasource: {
                        origin: "POST",
                        url: "/risk-backend/rest/v2/event/filter",
                        params: {
                            query: '',
                            sortBy: 'timestamp',
                            sort: 'asc',
                            startDate: moment($stateParams.desde || (moment().subtract(1, 'week').hour(0).minute(0).second(0))),
                            endDate: moment($stateParams.hasta || (moment().hour(23).minute(59).second(59))),
                            page: 1,
                            itemsPerPage: 25,
                        },
                        paramsOut: {
                            data: "events",
                            pagination: "pagination"
                        }
                    },
                    pageSizes: [25, 50, 100],
                    columns: gridColumns,
                    style: {
                        trStyle: function (item) {
                            if (item.checked.toUpperCase() === "NO VISTO") {
                                switch (item.criticality.toUpperCase()) {
                                    case "ALTA":
                                        return "alta";
                                    case "MEDIA":
                                        return "media";
                                    case "BAJA":
                                        return "baja";
                                    default:
                                        return "";
                                }
                            } else {
                                switch (item.criticality.toUpperCase()) {
                                    case "ALTA":
                                        return "alta-checked";
                                    case "MEDIA":
                                        return "media-checked";
                                    case "BAJA":
                                        return "baja-checked";
                                    default:
                                        return "";
                                }
                                return "";
                            }
                        }
                    }
                };

                config.schemas = setting.schemaIds;
                angular.forEach(setting.columnTable, function (item, key) {

                    var column = {
                        col: (item.metadata == false) ? 'eventBody' : item.name,
                        key: (item.metadata == false) ? item.name : '',
                        title: item.name,
                        show: true,
                        filterable: setting.columnFilter.includes(item.name),
                        default: item.metadata,
                        filterType: getFilterType(item),
                        sortable: item.name
                    };
                    column.field = column.col + column.key;
                    column.metadata = item;
                    column.type = (item.metadata == false) ? 'object' : item.type;
                    column.metadata.operation = getOperation(item.type);

                    gridColumns.push(angular.copy(column));
                });
                resolve(config);
            });
        }
    }

}

'use strict';

angular.module('dashboard').component('chartLineEcharts', {
  templateUrl: 'app/replay/component/chart-line-echarts.html',
  controllerAs: 'ctrl',
  bindings: {
    replayId: '=',
    chart: '=',
    isDark: '=',
  },
  controller: ChartLineEchartsController,
});

ChartLineEchartsController.$inject = [
  '$scope',
  '$cookies',
  '$localStorageService',
  '$stateParams',
  'CaseFactory',
  '$timeout',
  'translationService',
  '$interval',
  '$mdSidenav',
  'AutocompleteFactory',
];

function ChartLineEchartsController(
  $scope,
  $cookies,
  $localStorageService,
  $stateParams,
  CaseFactory,
  $timeout,
  $translationService,
  $interval,
  $mdSidenav,
  AutocompleteFactory
) {
  var vm = this;
  vm.valuesAutocomplete = {};
  vm.columnValues = [];

  vm.$onInit = function () {
    $translationService.getTranslation($scope, 'replay');
    vm.startDate = moment()
      .hour(0)
      .minute(0)
      .second(0)
      .subtract(1, 'week')
      .toDate();
    vm.endDate = moment().hour(23).minute(59).second(59).toDate();
    vm.data = {};
    vm.eventSource = undefined;
    vm.control = {};
    vm.loading = false;
    vm.totalRows = 0;

    vm.settings = JSON.parse(angular.copy(vm.chart).settings);
    buildFiltersFn();
  };

  $timeout(function () {
    buildChartFn();
  }, 300);

  function buildFiltersFn() {
    vm.filters = {
      sortBy: 'id',
      sort: 'desc',
      startDate: vm.startDate,
      endDate: vm.endDate,
      query: [],
    };

    if (angular.isDefined(vm.settings.timeInterval)) {
      var timeInterval = vm.settings.timeInterval.toUpperCase();
      vm.intervals = timeInterval.split(',');
      vm.filters.aggregate = vm.intervals[0];
      vm.aggregate = vm.intervals[0];
    }

    if (vm.settings.showFilter) {
      vm.chart.series.forEach(function (_series, index) {
        if (
          angular.isDefined(_series.settings) &&
          _series.settings != null &&
          (_series.settings.filter1.name ||
            _series.settings.filter2.name ||
            _series.settings.filter3.name)
        ) {
          var add = false;

          for (var i = 0; i < vm.filters.query.length; i++) {
            var itemQuery = vm.filters.query[i];
            if (itemQuery.id == _series.id) {
              add = false;
              break;
            }
            if (
              angular.isUndefined(itemQuery.filter1) &&
              _series.settings.filter1.name
            ) {
              add = true;
            } else if (angular.isDefined(itemQuery.filter1)) {
              if (_series.settings.filter1.name) {
                add = true;
                if (
                  itemQuery.filter1.name == _series.settings.filter1.name &&
                  itemQuery.filter1.type ==
                  _series.settings.filter1.type.toLowerCase()
                ) {
                  if (angular.isDefined(itemQuery.filter2)) {
                    add = true;
                    if (
                      _series.settings.filter2.name &&
                      itemQuery.filter2.name == _series.settings.filter2.name &&
                      itemQuery.filter2.type ==
                      _series.settings.filter2.type.toLowerCase()
                    ) {
                      if (angular.isDefined(itemQuery.filter3)) {
                        if (
                          _series.settings.filter3.name &&
                          itemQuery.filter3.name ==
                          _series.settings.filter3.name &&
                          itemQuery.filter3.type ==
                          _series.settings.filter3.type.toLowerCase()
                        ) {
                          if (!itemQuery.shared.includes(_series.id)) {
                            if (!itemQuery.name.includes('+')) {
                              itemQuery.name += '+';
                            }
                            itemQuery.shared.push(_series.id);
                          }
                          add = false;
                          break;
                        }
                      } else {
                        if (
                          angular.isUndefined(_series.settings.filter3.name)
                        ) {
                          if (!itemQuery.shared.includes(_series.id)) {
                            if (!itemQuery.name.includes('+')) {
                              itemQuery.name += '+';
                            }
                            itemQuery.shared.push(_series.id);
                          }
                          add = false;
                          break;
                        }
                      }
                    }
                  } else {
                    //angular.isDefined(value.filter2)
                    add = true;
                    if (angular.isUndefined(_series.settings.filter2.name)) {
                      if (angular.isDefined(itemQuery.filter3)) {
                        if (
                          _series.settings.filter3.name &&
                          itemQuery.filter3.name ==
                          _series.settings.filter3.name &&
                          itemQuery.filter3.type ==
                          _series.settings.filter3.type.toLowerCase()
                        ) {
                          if (!itemQuery.shared.includes(_series.id)) {
                            if (!itemQuery.name.includes('+')) {
                              itemQuery.name += '+';
                            }
                            itemQuery.shared.push(_series.id);
                          }
                          add = false;
                          break;
                        }
                      } else {
                        //angular.isDefined(value.filter3)
                        if (
                          angular.isUndefined(_series.settings.filter3.name)
                        ) {
                          if (!itemQuery.shared.includes(_series.id)) {
                            if (!itemQuery.name.includes('+')) {
                              itemQuery.name += '+';
                            }
                            itemQuery.shared.push(_series.id);
                          }
                          add = false;
                          break;
                        }
                      }
                    }
                  }
                }
              } else {
                add =
                  angular.isUndefined(_series.settings.filter1.name) &&
                    (_series.settings.filter2.name ||
                      _series.settings.filter3.name)
                    ? true
                    : false;
              }
            } else if (angular.isDefined(itemQuery.filter2)) {
              add = true;
              if (
                _series.settings.filter2.name &&
                itemQuery.filter2.name == _series.settings.filter2.name &&
                itemQuery.filter2.type ==
                _series.settings.filter2.type.toLowerCase()
              ) {
                if (angular.isDefined(itemQuery.filter3)) {
                  if (
                    _series.settings.filter3.name &&
                    itemQuery.filter3.name == _series.settings.filter3.name &&
                    itemQuery.filter3.type ==
                    _series.settings.filter3.type.toLowerCase()
                  ) {
                    if (!itemQuery.shared.includes(_series.id)) {
                      if (!itemQuery.name.includes('+')) {
                        itemQuery.name += '+';
                      }
                      itemQuery.shared.push(_series.id);
                    }
                    add = false;
                    break;
                  }
                } else {
                  if (angular.isUndefined(_series.settings.filter3.name)) {
                    if (!itemQuery.shared.includes(_series.id)) {
                      if (!itemQuery.name.includes('+')) {
                        itemQuery.name += '+';
                      }
                      itemQuery.shared.push(_series.id);
                    }
                    add = false;
                    break;
                  }
                }
              }
            } else if (angular.isDefined(itemQuery.filter3)) {
              add = true;
              if (
                _series.settings.filter3.name &&
                itemQuery.filter3.name == _series.settings.filter3.name &&
                itemQuery.filter3.type ==
                _series.settings.filter3.type.toLowerCase()
              ) {
                if (!itemQuery.shared.includes(_series.id)) {
                  if (!itemQuery.name.includes('+')) {
                    itemQuery.name += '+';
                  }
                  itemQuery.shared.push(_series.id);
                }
                add = false;
                break;
              }
            }
          }

          if (vm.filters.query.length == 0 || add == true) {
            var item = {
              id: _series.id,
              name: _series.name,
              shared: [_series.id],
            };
            if (_series.settings.filter1 && _series.settings.filter1.name) {
              item.filter1 = {
                name: _series.settings.filter1.name,
                value: _series.settings.filter1.value,
                type: angular.isDefined(_series.settings.filter1.type)
                  ? _series.settings.filter1.type.toLowerCase()
                  : 'string',
                autocomplete: _series.settings.filter1.autocomplete,
              };
            }
            if (_series.settings.filter2 && _series.settings.filter2.name) {
              item.filter2 = {
                name: _series.settings.filter2.name,
                value: _series.settings.filter2.value,
                type: angular.isDefined(_series.settings.filter2.type)
                  ? _series.settings.filter2.type.toLowerCase()
                  : 'string',
                autocomplete: _series.settings.filter2.autocomplete,
              };
            }
            if (_series.settings.filter3 && _series.settings.filter3.name) {
              item.filter3 = {
                name: _series.settings.filter3.name,
                value: _series.settings.filter3.value,
                type: angular.isDefined(_series.settings.filter3.type)
                  ? _series.settings.filter3.type.toLowerCase()
                  : 'string',
                autocomplete: _series.settings.filter3.autocomplete,
              };
            }
            if (
              angular.isDefined(item.filter1) ||
              angular.isDefined(item.filter2) ||
              angular.isDefined(item.filter3)
            ) {
              vm.filters.query.push(angular.copy(item));
            }
          }
        }
      });
    }
  }

  vm.applyFilters = function () {
    graphFn();
  };

  vm.cleanFilter = function () {
    buildFiltersFn();
  };

  /*******************************************************************************************************************/

  $scope.$on('changeDisplay', function (e, dates) {
    if (vm.echart == undefined) return;
    $timeout(function () {
      vm.echart.resize();
    }, 100);
  });

  /*******************************************************************************************************************/
  function graphFn() {
    var seriesIds = [];
    vm.labels = {};
    vm.dataSize = 0;
    vm.loading = true;

    angular.forEach(vm.chart.series, function (_series, index) {
      if (!seriesIds.includes(_series.id)) {
        seriesIds.push(_series.id);
      }
      vm.data[_series.id] = { key: _series.settings.value };
      vm.data[_series.id].series = [];
    });

    if (vm.eventSource == undefined && seriesIds.length > 0) {
      vm.echart.showLoading();
      try {
        var chunkedUrl =
          '/risk-backend/rest/multi-graphic/ts/series/' +
          vm.chart.seriesType +
          '/' +
          seriesIds.join(',') +
          '/sse' +
          '?startDate=' +
          vm.startDate.toISOString() +
          '&endDate=' +
          vm.endDate.toISOString() +
          getFilterFn(seriesIds) +
          (angular.isDefined(vm.filters.aggregate)
            ? '&aggregate=' + vm.filters.aggregate
            : '');
        vm.eventSource = new EventSource(chunkedUrl, [
          { withCredentials: true },
        ]);

        vm.eventSource.onopen = function () {
          console.log('Conected');
        };
        vm.eventSource.onerror = function (e) {
          vm.eventSource.close();
          vm.eventSource = undefined;
          vm.echart.hideLoading();
          console.log('Conection closed', e);
        };
        vm.eventSource.onmessage = function (event) {
          console.log('onmessage ' + event.data);

          var trama = JSON.parse(event.data);
          vm.dataSize += trama.data.length;
          angular.forEach(trama.data, function (_item, index) {
            //var time = moment(parseFloat(_item.x)).format('YYYY-MM-DDTHH:mm');
            //if (vm.chart.seriesType == 'TIME') {
            vm.data[_item.seriesId].series.push([
              _item.x,
              _item.y,
              vm.data[_item.seriesId].key,
              _item.seriesId,
            ]);
            //} else {
            //    vm.labels[time] = _item.label;
            //   vm.data[_item.seriesId].series.push([time, _item.y, vm.data[_item.seriesId].key, _item.seriesId]);
            // }
          });

          var data = [];
          angular.forEach(vm.chart.series, function (_series, index) {
            if (angular.isDefined(vm.data[_series.id])) {
              data.push({
                name: _series.name,
                type: angular.isDefined(_series.type)
                  ? _series.type.toLowerCase()
                  : 'line',
                data: vm.data[_series.id].series,
              });
            }
          });
          if (vm.settings.multipleYaxis) {
            angular.forEach(vm.chart.series, function (_series, index) {
              if (vm.options.yAxis[index] != undefined) {
                vm.options.yAxis[index].min = 0;
                vm.options.yAxis[index].max = trama.maxY;
              }
            });
          }
          vm.options.xAxis.data = trama.labels;
          vm.options.series = angular.copy(data);
          if ($localStorageService.ChartCustomColors) {
            Object.assign(vm.options, {
              color: $localStorageService.ChartCustomColors,
            });
          }
          vm.echart.setOption(vm.options);
          if (trama.dataSize == vm.dataSize || trama.data.length == 0) {
            vm.eventSource.close();
            vm.eventSource = undefined;
            vm.echart.hideLoading();
            vm.aggregate = trama.aggregate;
            vm.totalPoints = trama.totalPoints;
          }
        };
      } catch (e) {
        vm.echart.hideLoading();
      }
    }
  }

  function getFilterFn(seriesIds) {
    var query = '';
    if (vm.settings.showFilter) {
      for (var i = 0; i < seriesIds.length; i++) {
        var list = vm.filters.query.filter(function (_query) {
          return (
            _query.id == seriesIds[i] || _query.shared.includes(seriesIds[i])
          );
        });
        var config = undefined;
        if (list.length > 0 && angular.isDefined(list[0])) {
          config = list[0];
          query = checkFilter(config.filter1, query, 'filter1');
          query = checkFilter(config.filter2, query, 'filter2');
          query = checkFilter(config.filter3, query, 'filter3');
        } else {
          query += '&filter1=';
          query += '&filter2=';
          query += '&filter3=';
        }
      }
    }
    return query;
  }

  function checkFilter(configFilter, strQuery, strFilter) {
    if (
      angular.isDefined(configFilter) &&
      (angular.isDefined(configFilter.value) ||
        angular.isDefined(configFilter.min) ||
        angular.isDefined(configFilter.max))
    ) {
      var json = {
        type: configFilter.type,
        value: configFilter.value,
        min: configFilter.min,
        max: configFilter.max,
      };
      strQuery += '&' + strFilter + '=' + JSON.stringify(json);
    } else {
      strQuery += '&' + strFilter + '=';
    }
    return strQuery;
  }

  function optionsTooltipFormatterSecondFn(configFilter, text) {
    if (angular.isDefined(configFilter)) {
      if (angular.isDefined(configFilter.value) && configFilter.value != null) {
        text +=
          '<br/>' +
          '&nbsp;&nbsp;&nbsp;&nbsp;' +
          configFilter.name +
          ' = ' +
          configFilter.value;
      }
      if (
        angular.isDefined(configFilter.min) &&
        configFilter.min != null &&
        configFilter.min.length > 0 &&
        angular.isDefined(configFilter.max) &&
        configFilter.max != null &&
        configFilter.max.length > 0
      ) {
        text +=
          '<br/>' +
          '&nbsp;&nbsp;&nbsp;&nbsp;' +
          configFilter.min +
          ' &le; ' +
          configFilter.name +
          ' &le; ' +
          configFilter.max;
      } else if (
        angular.isDefined(configFilter.min) &&
        configFilter.min != null &&
        configFilter.min.length > 0
      ) {
        text +=
          '<br/>' +
          '&nbsp;&nbsp;&nbsp;&nbsp;' +
          configFilter.name +
          ' &ge; ' +
          configFilter.min;
      } else if (
        angular.isDefined(configFilter.max) &&
        configFilter.max != null &&
        configFilter.max.length > 0
      ) {
        text +=
          '<br/>' +
          '&nbsp;&nbsp;&nbsp;&nbsp;' +
          configFilter.name +
          ' &le; ' +
          configFilter.max;
      }
    }
    return text;
  }

  function optionsTooltipFormatterFn(params) {
    var item = params[0];

    var text = '';
    for (var i = 0; i < params.length; i++) {
      item = params[i];
      text +=
        '<br/>' +
        item.marker +
        item.value[2] +
        ' : ' +
        item.value[1].toLocaleString().replace(/,/g, '.');

      if (vm.settings.showFilter) {
        var list = vm.filters.query.filter(function (_query) {
          return (
            _query.id == item.value[3] || _query.shared.includes(item.value[3])
          );
        });
        if (list.length > 0 && angular.isDefined(list[0])) {
          var config = list[0];
          text = optionsTooltipFormatterSecondFn(config.filter1, text);
          text = optionsTooltipFormatterSecondFn(config.filter2, text);
          text = optionsTooltipFormatterSecondFn(config.filter3, text);
        }
      }
    }
    return item.axisValue + text;
  }

  function buildChartFn() {
    var colors = [];
    var legend = [];
    angular.forEach(vm.chart.series, function (_series, index) {
      if (angular.isDefined(_series.settings) && _series.settings != null) {
        colors.push(_series.settings.color);
        legend.push(_series.name);
      }
    });

    vm.echart = echarts.init(
      document.getElementById(
        'echarts-line-' + vm.replayId + '-' + vm.chart.id
      ),
      vm.isDark == true ? 'dark' : ''
    );
    vm.options = {
      color: colors,
      title: {
        text: vm.chart.name,
        left: 'center',
      },
      tooltip: {
        position: 'top',
        trigger: 'axis',
        axisPointer: {
          type: 'line',
        },
        formatter: optionsTooltipFormatterFn,
      },
      animation: false,
      grid: {
        top: '50',
        right: '200',
        bottom: '70',
        left: '70',
        containLabel: true,
      },
      legend: {
        show: vm.settings.showLegend,
        orient: 'horizontal',
        left: 'center',
        top: 'bottom',
        data: legend,
      },
      yAxis: colors.length > 0 ? [] : {},
      xAxis: {
        type: 'category',
        name: 'Key',
        axisTick: {
          alignWithLabel: true,
        },
        splitLine: {
          lineStyle: {
            type: 'dashed',
          },
        },
      },
    };

    angular.forEach(vm.chart.series, function (_series, index) {
      if (index == 0) {
        vm.options.yAxis.push({
          type: 'value',
          name:
            angular.isDefined(_series.settings) &&
              _series.settings != null &&
              angular.isDefined(_series.settings.displayTitle) &&
              _series.settings.displayTitle != null
              ? _series.settings.displayTitle
              : _series.name,
          position: 'left',
          axisLine: {
            lineStyle: {
              color: colors[index],
            },
          },
          axisLabel: {
            formatter: '{value}',
          },
        });
      } else if (vm.settings.multipleYaxis) {
        vm.options.yAxis.push({
          type: 'value',
          name:
            angular.isDefined(_series.settings) &&
              _series.settings != null &&
              angular.isDefined(_series.settings.displayTitle) &&
              _series.settings.displayTitle != null
              ? _series.settings.displayTitle
              : _series.name,
          position: 'right',
          offset: (index - 1) * 120,
          axisLine: {
            lineStyle: {
              color: colors[index],
            },
          },
          axisLabel: {
            formatter: '{value}',
          },
        });
      }
    });
    vm.echart.setOption(vm.options);
  }

  vm.$onDestroy = function () {
    if (angular.isDefined(vm.eventSource)) {
      vm.eventSource.close();
    }
  };

  /********************************************* Functions autocomplete *********************************************/
  vm.querySearchAutocomplete = function (searchText, filter, targetIds) {
    if (angular.isUndefined(vm.columnValues[filter.name])) {
      return AutocompleteFactory.getValues(
        'series',
        targetIds,
        encodeURIComponent(filter.name),
        undefined
      )
        .then(function (response) {
          vm.columnValues[filter.name] = response;
          return vm.columnValues[filter.name];
        })
        .catch(function (e) {
          console.log(e);
          return e;
        });
    } else {
      return searchText
        ? vm.columnValues[filter.name].filter(createFilterFor(searchText))
        : vm.columnValues[filter.name];
    }
  };

  function createFilterFor(query) {
    var lowercaseQuery = angular.lowercase(query);
    return function filterFn(array) {
      return angular.lowercase(array).indexOf(lowercaseQuery) > -1;
    };
  }
}

'use strict';

angular.module('dashboard').component('chartBarEcharts', {
  templateUrl: 'app/replay/component/chart-bar-echarts.html',
  controllerAs: 'ctrl',
  bindings: {
    replayId: '=',
    chart: '=',
    isDark: '=',
  },
  controller: ChartBarEchartsController,
});

ChartBarEchartsController.$inject = [
  '$scope',
  '$localStorageService',
  '$timeout',
  'translationService',
  'AutocompleteFactory',
];

function ChartBarEchartsController(
  $scope,
  $localStorageService,
  $timeout,
  $translationService,
  AutocompleteFactory
) {
  var vm = this;
  vm.valuesAutocomplete = {};
  vm.columnValues = [];

  vm.$onInit = function () {
    $translationService.getTranslation($scope, 'replay');
    vm.startDate = moment().hour(0).minute(0).second(0).subtract(1, 'week');
    vm.endDate = moment().hour(23).minute(59).second(59);
    vm.data = {};
    vm.eventSource = undefined;
    vm.control = {};
    vm.loading = false;
    vm.totalRows = 0;

    vm.settings = JSON.parse(angular.copy(vm.chart).settings);
    buildFiltersFn();
  };

  $timeout(function () {
    buildChartFn();
  }, 300);

  function buildFiltersFn() {
    vm.filters = {
      sortBy: 'id',
      sort: 'desc',
      startDate: vm.startDate,
      endDate: vm.endDate,
      query: [],
    };

    if (angular.isDefined(vm.settings.timeInterval)) {
      var timeInterval = vm.settings.timeInterval.toUpperCase();
      vm.intervals = timeInterval.split(',');
      vm.filters.aggregate = vm.intervals[0];
      vm.aggregate = vm.intervals[0];
    }

    if (vm.settings.showFilter) {
      console.log('vm.chart.series ' + vm.chart.series.length);
      vm.chart.series.forEach(function (_series, index) {
        if (
          angular.isDefined(_series.settings) &&
          _series.settings != null &&
          (_series.settings.filter1.name ||
            _series.settings.filter2.name ||
            _series.settings.filter3.name)
        ) {
          var add = false;

          console.log('_series ' + JSON.stringify(_series));
          for (var i = 0; i < vm.filters.query.length; i++) {
            var itemQuery = vm.filters.query[i];
            if (itemQuery.id == _series.id) {
              add = false;
              break;
            }
            if (
              angular.isUndefined(itemQuery.filter1) &&
              _series.settings.filter1.name
            ) {
              add = true;
            } else if (angular.isDefined(itemQuery.filter1)) {
              if (_series.settings.filter1.name) {
                add = true;
                if (
                  itemQuery.filter1.name == _series.settings.filter1.name &&
                  itemQuery.filter1.type ==
                  _series.settings.filter1.type.toLowerCase()
                ) {
                  if (angular.isDefined(itemQuery.filter2)) {
                    add = true;
                    if (
                      _series.settings.filter2.name &&
                      itemQuery.filter2.name == _series.settings.filter2.name &&
                      itemQuery.filter2.type ==
                      _series.settings.filter2.type.toLowerCase()
                    ) {
                      if (angular.isDefined(itemQuery.filter3)) {
                        if (
                          _series.settings.filter3.name &&
                          itemQuery.filter3.name ==
                          _series.settings.filter3.name &&
                          itemQuery.filter3.type ==
                          _series.settings.filter3.type.toLowerCase()
                        ) {
                          if (!itemQuery.shared.includes(_series.id)) {
                            if (!itemQuery.name.includes('+')) {
                              itemQuery.name += '+';
                            }
                            itemQuery.shared.push(_series.id);
                          }
                          add = false;
                          break;
                        }
                      } else {
                        if (
                          angular.isUndefined(_series.settings.filter3.name)
                        ) {
                          if (!itemQuery.shared.includes(_series.id)) {
                            if (!itemQuery.name.includes('+')) {
                              itemQuery.name += '+';
                            }
                            itemQuery.shared.push(_series.id);
                          }
                          add = false;
                          break;
                        }
                      }
                    }
                  } else {
                    //angular.isDefined(itemQuery.filter2)
                    add = true;
                    if (angular.isUndefined(_series.settings.filter2.name)) {
                      if (angular.isDefined(itemQuery.filter3)) {
                        if (
                          _series.settings.filter3.name &&
                          itemQuery.filter3.name ==
                          _series.settings.filter3.name &&
                          itemQuery.filter3.type ==
                          _series.settings.filter3.type.toLowerCase()
                        ) {
                          if (!itemQuery.shared.includes(_series.id)) {
                            if (!itemQuery.name.includes('+')) {
                              itemQuery.name += '+';
                            }
                            itemQuery.shared.push(_series.id);
                          }
                          add = false;
                          break;
                        }
                      } else {
                        //angular.isDefined(itemQuery.filter3)
                        if (
                          angular.isUndefined(_series.settings.filter3.name)
                        ) {
                          if (!itemQuery.shared.includes(_series.id)) {
                            if (!itemQuery.name.includes('+')) {
                              itemQuery.name += '+';
                            }
                            itemQuery.shared.push(_series.id);
                          }
                          add = false;
                          break;
                        }
                      }
                    }
                  }
                }
              } else {
                add =
                  angular.isUndefined(_series.settings.filter1.name) &&
                    (_series.settings.filter2.name ||
                      _series.settings.filter3.name)
                    ? true
                    : false;
              }
            } else if (angular.isDefined(itemQuery.filter2)) {
              add = true;
              if (
                _series.settings.filter2.name &&
                itemQuery.filter2.name == _series.settings.filter2.name &&
                itemQuery.filter2.type ==
                _series.settings.filter2.type.toLowerCase()
              ) {
                if (angular.isDefined(itemQuery.filter3)) {
                  if (
                    _series.settings.filter3.name &&
                    itemQuery.filter3.name == _series.settings.filter3.name &&
                    itemQuery.filter3.type ==
                    _series.settings.filter3.type.toLowerCase()
                  ) {
                    if (!itemQuery.shared.includes(_series.id)) {
                      if (!itemQuery.name.includes('+')) {
                        itemQuery.name += '+';
                      }
                      itemQuery.shared.push(_series.id);
                    }
                    add = false;
                    break;
                  }
                } else {
                  if (angular.isUndefined(_series.settings.filter3.name)) {
                    if (!itemQuery.shared.includes(_series.id)) {
                      if (!itemQuery.name.includes('+')) {
                        itemQuery.name += '+';
                      }
                      itemQuery.shared.push(_series.id);
                    }
                    add = false;
                    break;
                  }
                }
              }
            } else if (angular.isDefined(itemQuery.filter3)) {
              add = true;
              if (
                _series.settings.filter3.name &&
                itemQuery.filter3.name == _series.settings.filter3.name &&
                itemQuery.filter3.type ==
                _series.settings.filter3.type.toLowerCase()
              ) {
                if (!itemQuery.shared.includes(_series.id)) {
                  if (!itemQuery.name.includes('+')) {
                    itemQuery.name += '+';
                  }
                  itemQuery.shared.push(_series.id);
                }
                add = false;
                break;
              }
            }
          }

          if (vm.filters.query.length == 0 || add == true) {
            var item = {
              id: _series.id,
              name: _series.name,
              shared: [_series.id],
            };
            if (_series.settings.filter1 && _series.settings.filter1.name) {
              item.filter1 = {
                name: _series.settings.filter1.name,
                value: _series.settings.filter1.value,
                type: angular.isDefined(_series.settings.filter1.type)
                  ? _series.settings.filter1.type.toLowerCase()
                  : 'string',
                autocomplete: _series.settings.filter1.autocomplete,
              };
            }
            if (_series.settings.filter2 && _series.settings.filter2.name) {
              item.filter2 = {
                name: _series.settings.filter2.name,
                value: _series.settings.filter2.value,
                type: angular.isDefined(_series.settings.filter2.type)
                  ? _series.settings.filter2.type.toLowerCase()
                  : 'string',
                autocomplete: _series.settings.filter2.autocomplete,
              };
            }
            if (_series.settings.filter3 && _series.settings.filter3.name) {
              item.filter3 = {
                name: _series.settings.filter3.name,
                value: _series.settings.filter3.value,
                type: angular.isDefined(_series.settings.filter3.type)
                  ? _series.settings.filter3.type.toLowerCase()
                  : 'string',
                autocomplete: _series.settings.filter3.autocomplete,
              };
            }
            if (
              angular.isDefined(item.filter1) ||
              angular.isDefined(item.filter2) ||
              angular.isDefined(item.filter3)
            ) {
              vm.filters.query.push(angular.copy(item));
            }
          }
        }
      });

      console.log('vm.filters.query ' + JSON.stringify(vm.filters.query));
    }
  }

  vm.applyFilters = function () {
    graphFn();
  };

  vm.cleanFilter = function () {
    buildFiltersFn();
  };

  /*******************************************************************************************************************/
  vm.bDate = function () {
    console.log(vm.startDate);
  };

  $scope.$on('changeDisplay', function (e, dates) {
    if (vm.echart == undefined) return;
    $timeout(function () {
      vm.echart.resize();
    }, 100);
  });

  function graphFn() {
    var seriesIds = [];
    vm.labels = {};
    vm.dataSize = 0;
    vm.loading = true;
    angular.forEach(vm.chart.series, function (_series, index) {
      if (!seriesIds.includes(_series.id)) {
        seriesIds.push(_series.id);
      }
      vm.data[_series.id] = { key: _series.settings.value };
      vm.data[_series.id].series = [];
    });

    if (vm.eventSource == undefined && seriesIds.length > 0) {
      vm.echart.showLoading();
      try {
        var chunkedUrl =
          '/risk-backend/rest/multi-graphic/ts/series/' +
          vm.chart.seriesType +
          '/' +
          seriesIds.join(',') +
          '/sse' +
          '?stack=' +
          vm.settings.stacked +
          '&startDate=' +
          vm.startDate.toISOString() +
          '&endDate=' +
          vm.endDate.toISOString() +
          getFilterFn(seriesIds) +
          (angular.isDefined(vm.filters.aggregate)
            ? '&aggregate=' + vm.filters.aggregate
            : '');
        vm.eventSource = new EventSource(chunkedUrl, [
          { withCredentials: true },
        ]);

        vm.eventSource.onopen = function () {
          console.log('Conected');
        };

        vm.eventSource.onerror = function (e) {
          vm.eventSource.close();
          vm.eventSource = undefined;
          vm.echart.hideLoading();
          console.log('Conection closed', e);
        };

        vm.eventSource.onmessage = function (event) {
          console.log('onmessage ' + event.data);

          var trama = JSON.parse(event.data);
          vm.dataSize += trama.data.length;
          angular.forEach(trama.data, function (_item, index) {
            vm.data[_item.seriesId].series.push([
              _item.x,
              _item.y,
              vm.data[_item.seriesId].key,
              _item.seriesId,
            ]);
          });

          var data = [];
          angular.forEach(vm.chart.series, function (_series, index) {
            if (angular.isDefined(vm.data[_series.id])) {
              data.push({
                name: _series.name,
                type: angular.isDefined(_series.type)
                  ? _series.type.toLowerCase()
                  : 'bar',
                data: vm.data[_series.id].series,
                stack: vm.settings.stacked ? 'stack' : false,
              });
            }
          });
          if (vm.settings.multipleYaxis) {
            angular.forEach(vm.chart.series, function (_series, index) {
              if (vm.options.yAxis[index] != undefined) {
                vm.options.yAxis[index].min = 0;
                vm.options.yAxis[index].max = trama.maxY;
              }
            });
          }
          console.log('data' + JSON.stringify(data));
          vm.options.xAxis.data = trama.labels;
          vm.options.series = angular.copy(data);
          if ($localStorageService.getItem("ChartCustomColors")) {
            Object.assign(vm.options, {
              color: $localStorageService.getItem("ChartCustomColors"),
            });
          }
          vm.echart.setOption(vm.options);
          if (trama.dataSize == vm.dataSize || trama.data.length == 0) {
            vm.eventSource.close();
            vm.eventSource = undefined;
            vm.echart.hideLoading();
            vm.aggregate = trama.aggregate;
            vm.totalPoints = trama.totalPoints;
          }
        };
      } catch (e) {
        vm.echart.hideLoading();
      }
    }
  }

  function getFilterFn(seriesIds) {
    var query = '';
    if (vm.settings.showFilter) {
      for (var i = 0; i < seriesIds.length; i++) {
        var list = vm.filters.query.filter(function (_query) {
          return (
            _query.id == seriesIds[i] || _query.shared.includes(seriesIds[i])
          );
        });
        var config = undefined;
        if (list.length > 0 && angular.isDefined(list[0])) {
          config = list[0];
          query = checkFilter(config.filter1, query, 'filter1');
          query = checkFilter(config.filter2, query, 'filter2');
          query = checkFilter(config.filter3, query, 'filter3');
        } else {
          query += '&filter1=';
          query += '&filter2=';
          query += '&filter3=';
        }
      }
    }
    return query;
  }

  function checkFilter(configFilter, strQuery, strFilter) {
    if (
      angular.isDefined(configFilter) &&
      (angular.isDefined(configFilter.value) ||
        angular.isDefined(configFilter.min) ||
        angular.isDefined(configFilter.max))
    ) {
      var json = {
        type: configFilter.type,
        value: configFilter.value,
        min: configFilter.min,
        max: configFilter.max,
      };
      strQuery += '&' + strFilter + '=' + JSON.stringify(json);
    } else {
      strQuery += '&' + strFilter + '=';
    }
    return strQuery;
  }

  function optionsTooltipFormatterSecondFn(configFilter, text) {
    if (angular.isDefined(configFilter)) {
      if (angular.isDefined(configFilter.value) && configFilter.value != null) {
        text +=
          '<br/>' +
          '&nbsp;&nbsp;&nbsp;&nbsp;' +
          configFilter.name +
          ' = ' +
          configFilter.value;
      }
      if (
        angular.isDefined(configFilter.min) &&
        configFilter.min != null &&
        configFilter.min.length > 0 &&
        angular.isDefined(configFilter.max) &&
        configFilter.max != null &&
        configFilter.max.length > 0
      ) {
        text +=
          '<br/>' +
          '&nbsp;&nbsp;&nbsp;&nbsp;' +
          configFilter.min +
          ' &le; ' +
          configFilter.name +
          ' &le; ' +
          configFilter.max;
      } else if (
        angular.isDefined(configFilter.min) &&
        configFilter.min != null &&
        configFilter.min.length > 0
      ) {
        text +=
          '<br/>' +
          '&nbsp;&nbsp;&nbsp;&nbsp;' +
          configFilter.name +
          ' &ge; ' +
          configFilter.min;
      } else if (
        angular.isDefined(configFilter.max) &&
        configFilter.max != null &&
        configFilter.max.length > 0
      ) {
        text +=
          '<br/>' +
          '&nbsp;&nbsp;&nbsp;&nbsp;' +
          configFilter.name +
          ' &le; ' +
          configFilter.max;
      }
    }
    return text;
  }

  function optionsTooltipFormatterFn(params) {
    var item = params[0];
    var text = '';
    for (var i = 0; i < params.length; i++) {
      item = params[i];
      text +=
        '<br/>' +
        item.marker +
        item.value[2] +
        ' : ' +
        item.value[1].toLocaleString().replace(/,/g, '.');

      if (vm.settings.showFilter) {
        var list = vm.filters.query.filter(function (_query) {
          return (
            _query.id == item.value[3] || _query.shared.includes(item.value[3])
          );
        });
        if (list.length > 0 && angular.isDefined(list[0])) {
          var config = list[0];
          text = optionsTooltipFormatterSecondFn(config.filter1, text);
          text = optionsTooltipFormatterSecondFn(config.filter2, text);
          text = optionsTooltipFormatterSecondFn(config.filter3, text);
        }
      }
    }
    return item.axisValue + text;
  }

  function buildChartFn() {
    console.log(
      '+++++++++++ ChartBarEchartsController.buildChartFn ++++++++++  '
    );
    var colors = [];
    var legend = [];
    angular.forEach(vm.chart.series, function (_series, index) {
      if (angular.isDefined(_series.settings) && _series.settings != null) {
        colors.push(_series.settings.color);
        legend.push(_series.name);
      }
    });

    vm.echart = echarts.init(
      document.getElementById('echarts-bar-' + vm.replayId + '-' + vm.chart.id),
      vm.isDark == true ? 'dark' : ''
    );
    // Define axis names on first configured serie data
    if (vm.chart.series[0]) {
      var axisNames = {
        y: vm.chart.series[0].settings.value,
        x: vm.chart.series[0].settings.timestamp,
      };
    }
    vm.options = {
      color: colors,
      title: {
        text: vm.chart.name,
        left: 'center',
      },
      tooltip: {
        position: 'top',
        trigger: 'axis',
        axisPointer: {
          type: 'line',
        },
        formatter: optionsTooltipFormatterFn,
      },
      animation: false,
      grid: {
        top: '50',
        right: '100',
        bottom: '70',
        left: '70',
        containLabel: true,
      },
      legend: {
        show: vm.settings.showLegend,
        orient: 'horizontal',
        left: 'center',
        top: 'bottom',
        data: legend,
      },
      yAxis: {
        type: 'value',
        name: axisNames.y || 'Value',
        axisLabel: {
          formatter: '{value}',
        },
        axisLine: { onZero: true },
      },
      xAxis: {
        type: 'category',
        name: axisNames.x || 'Key',
        axisTick: {
          alignWithLabel: true,
        },
        splitLine: {
          lineStyle: {
            type: 'dashed',
          },
        },
      },
    };
    vm.echart.setOption(vm.options);
  }

  vm.$onDestroy = function () {
    console.log('$onDestroy');
    if (angular.isDefined(vm.eventSource)) {
      vm.eventSource.close();
    }
  };

  /********************************************* Functions autocomplete *********************************************/
  vm.querySearchAutocomplete = function (searchText, filter, targetIds) {
    if (angular.isUndefined(vm.columnValues[filter.name])) {
      return AutocompleteFactory.getValues(
        'series',
        targetIds,
        encodeURIComponent(filter.name),
        undefined
      )
        .then(function (response) {
          vm.columnValues[filter.name] = response;
          return vm.columnValues[filter.name];
        })
        .catch(function (e) {
          console.log(e);
          return e;
        });
    } else {
      return searchText
        ? vm.columnValues[filter.name].filter(createFilterFor(searchText))
        : vm.columnValues[filter.name];
    }
  };

  function createFilterFor(query) {
    var lowercaseQuery = angular.lowercase(query);
    return function filterFn(array) {
      return angular.lowercase(array).indexOf(lowercaseQuery) > -1;
    };
  }
}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .directive('cepEditorDroppable', CepEditorDroppableController);

  CepEditorDroppableController.$inject = [];
  function CepEditorDroppableController() {
    return {
      restrict: 'A',
      replace: false,
      link: linkFn,
    };

    function linkFn($scope, element) {
      element.droppable({
        accept: '.window',
        over: function () {
          this.classList.add('drag-over');
        },
        out: function () {
          this.classList.remove('drag-over');
        },
        drop: function (event, dom) {
          this.classList.remove('drag-over');
          $scope.ctrl.onDrop(dom);
        },
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('passwordRecoveryController', passwordRecoveryController);

  passwordRecoveryController.$inject = [
    '$scope',
    '$state',
    '$rootScope',
    '$interval',
    '$localStorageService',
    '$stateParams',
    '$modal',
    '$http',
    'PasswordResetFactory',
    'toastr',
    'translationService',
    'LoginFactory',
  ];

  function passwordRecoveryController(
    $scope,
    $state,
    $rootScope,
    $interval,
    $localStorageService,
    $stateParams,
    $modal,
    $http,
    PasswordResetFactory,
    toastr,
    $translationService,
    LoginFactory
  ) {
    $scope.recovery = {
      password: '',
      password_confirmation: '',
    };

    $scope.inputType = 'password';
    $scope.togglePassView = function () {
      $scope.inputType = $scope.inputType == 'password' ? 'text' : 'password';
    };
    $scope.show = false;
    $scope.content = '';
    $scope.passwordPolicy = {
      showPasswordPolicy: false,
      expirePasswordInDays: 0,
      minimumPasswordLength: 0,
      rememberLastPasswords: 0,
      withAtLeastOneDigit: false,
      withAtLeastOneSymbol: false,
      withAtLeastOneLowercase: false,
      withAtLeastOneUppercase: false,
    };

    (function init() {
      //Método para realizar traducción
      $translationService.getTranslation($scope, 'login');

      LoginFactory.getPasswordPolicyByTokenUUID(
        $stateParams.username,
        $stateParams.token
      )
        .then(function (res) {
          $scope.passwordPolicy = res;
          $scope.$apply();
        })
        .catch(function (err) {
          console.log('Error@getIssuesTypes', err);
          $scope.passwordPolicy = {
            showPasswordPolicy: false,
            expirePasswordInDays: 0,
            minimumPasswordLength: 0,
            rememberLastPasswords: 0,
            withAtLeastOneDigit: false,
            withAtLeastOneSymbol: false,
            withAtLeastOneLowercase: false,
            withAtLeastOneUppercase: false,
          };
        });
    })();

    $scope.cambiarPassword = function () {
      $scope.validarCambiarPassword();
      if (!$scope.show) {
        $scope.request = true;
        PasswordResetFactory.changePassword(
          $stateParams.username,
          $stateParams.token,
          $scope.recovery.password,
          $scope.recovery.password_confirmation
        )
          .then(function (res) {
            toastr.success(
              $translationService.getTranslationController(
                'Cambio de clave exitoso!',
                'Successful password change!',
                'Mudança de senha bem sucedida!'
              )
            );
            $scope.request = false;
            $state.go('login');
          })
          .catch(function (error) {
            console.log(error);
            if (error.status == 403) {
              toastr.error(
                $translationService.getTranslationController(
                  'Token invalido intente recuperar su clave nuevamente',
                  'Invalid token try to recover your password again',
                  'Token inválido tente recuperar sua senha novamente'
                )
              );
            } else {
              $scope.content = error.data;
              $scope.show = true;
            }
            $scope.request = false;
          });
      }
    };

    $scope.validarCambiarPassword = function () {
      var validacion = { content: '', show: false };

      if (!$scope.recovery.password) {
        //validacion.content = 'Debe llenar el campo Contraseña Nueva.';
        validacion.content = $translationService.getTranslationController(
          'Debe llenar el campo Contraseña Nueva.',
          'You must fill in the Password New field.',
          'Você deve preencher o campo Password New.'
        );
        $scope.content = validacion.content;
        validacion.show = true;
        $scope.show = validacion.show;
        return validacion;
      } else if (!$scope.recovery.password_confirmation) {
        //validacion.content = 'Debe llenar el campo Confirmar Contraseña.';
        validacion.content = $translationService.getTranslationController(
          'Debe llenar el campo Confirmar Contraseña.',
          'You must fill in the Confirm Password field.',
          'Você deve preencher o campo Confirmar senha.'
        );
        $scope.content = validacion.content;
        validacion.show = true;
        $scope.show = validacion.show;
        return validacion;
      } else if (
        $scope.recovery.password !== $scope.recovery.password_confirmation
      ) {
        //validacion.content = 'La contraseñas deben ser iguales.';
        validacion.content = $translationService.getTranslationController(
          'La contraseñas deben ser iguales.',
          'The passwords must be the same.',
          'As senhas devem ser as mesmas.'
        );
        $scope.content = validacion.content;
        validacion.show = true;
        $scope.show = validacion.show;
        return validacion;
      }
      $scope.show = false;
    };

    $scope.$watch(
      'recovery.password',
      function (newValue, oldValue) {
        if (
          angular.isDefined($scope.passwordPolicy) &&
          angular.isDefined($scope.passwordPolicy.showPasswordPolicy) &&
          $scope.passwordPolicy.showPasswordPolicy
        ) {
          $scope.passwordPolicy.minimumPasswordLengthGreen = false;
          $scope.passwordPolicy.withAtLeastOneUppercaseGreen = false;
          $scope.passwordPolicy.withAtLeastOneLowercaseGreen = false;
          $scope.passwordPolicy.withAtLeastOneDigitGreen = false;
          $scope.passwordPolicy.withAtLeastOneSymbolGreen = false;
          if (
            $scope.passwordPolicy.minimumPasswordLength > 0 &&
            newValue.length >= $scope.passwordPolicy.minimumPasswordLength
          ) {
            $scope.passwordPolicy.minimumPasswordLengthGreen = true;
          }
          var regUppercase = /[A-Z]/;
          if (
            $scope.passwordPolicy.withAtLeastOneUppercase &&
            regUppercase.test(newValue)
          ) {
            $scope.passwordPolicy.withAtLeastOneUppercaseGreen = true;
          }
          var regLowercase = /[a-z]/;
          if (
            $scope.passwordPolicy.withAtLeastOneLowercase &&
            regLowercase.test(newValue)
          ) {
            $scope.passwordPolicy.withAtLeastOneLowercaseGreen = true;
          }
          var regDigit = /[0-9]/;
          if (
            $scope.passwordPolicy.withAtLeastOneDigit &&
            regDigit.test(newValue)
          ) {
            $scope.passwordPolicy.withAtLeastOneDigitGreen = true;
          }
          var regSymbol = /[^a-zA-Z0-9]/;
          if (
            $scope.passwordPolicy.withAtLeastOneSymbol &&
            regSymbol.test(newValue)
          ) {
            $scope.passwordPolicy.withAtLeastOneSymbolGreen = true;
          }
        }
      },
      false
    );
  }
})();

(function () {
  "use strict";

  angular.module("dashboard").controller("TableListController", TableListController);

  TableListController.$inject = [
    "$scope",
    "$rootScope",
    "$state",
    "$stateParams",
    "$mdDialog",
    "toastr",
    "formats",
    "SchemasService",
    "listService",
    "translationService",
    "tableListConstants",
    "InputListsFactory",
    "ConfigurationFactory",
    "listExporterService",
    "uiGridConstants",
    "cellTemplateFormatService",
    "IssuesFactory",
    "PermissionsFactory"
  ];

  function TableListController(
    $scope,
    $rootScope,
    $state,
    $stateParams,
    $mdDialog,
    $toastr,
    $formats,
    $schemasService,
    $listService,
    $translationService,
    $tableListConstants,
    $inputListsFactory,
    $ConfigurationFactory,
    $listExporterService,
    $uiGridConstants,
    $cellTemplateFormatService,
    $issuesFactory,
    $permissionsFactory
  ) {
    $translationService.getTranslation($scope, "input-list");
    $rootScope.loading = true;

    var vm = this;
    vm.schemasFormat = [];
    vm.list = {};
    vm.dataList = [];
    vm.showTable = false;
    vm.columns = [];
    vm.schema = [];
    vm.groups = [];
    vm.showTable = false;
    vm.shouldShowFilters = false;
    vm.filters = $tableListConstants.defaultFiltersTemplate;
    vm.tableIsLoading = false;

    vm.gridOptions = {
      rowTemplate:
        '<div ng-dblclick="grid.appScope.ctrl.onClickListRow(row.entity)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>',
      minimumColumnSize: 100,
      useExternalPagination: true,
      paginationPageSizes: [5, 10, 25, 50, 100],
      paginationPageSize: 100,
      paginationCurrentPage: 1,
      paginationOptions: {
        pageNumber: 1,
        itemsPerPage: 100,
      },
      totalItems: 0,
      useExternalSorting: true,
      showGridFooter: true,
      showColumnFooter: true,
      onRegisterApi: function (gridApi) {
        $scope.gridApi = gridApi;
        gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
          vm.filters.pagination.page = newPage;
          vm.filters.pagination.itemsPerPage = pageSize;
          vm.gridOptions.paginationOptions.pageNumber = newPage;
          vm.gridOptions.paginationCurrentPage = newPage;

          _getListData();
        });
        gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (sortColumns[0]) {
            var colField = sortColumns[0].field.split(".")[0];

            vm.filters.pagination.sortBy = colField;
            vm.filters.pagination.sort = sortColumns[0].sort.direction;
          } else {
            vm.filters.pagination.sortBy = null;
          }

          _getListData();
        });
      },
    };

    $scope.params = {
      listId: $stateParams.listId,
      filters: {
        luceneQueryId: $stateParams.luceneQueryId,
        predicates: JSON.parse($stateParams.filters),
      },
    };

    function _getColumnDefinition(key) {
      key = key.indexOf("#") === 0 ? key.substring(1) : key;

      return vm.schema[key];
    }

    function _init() {
      vm.filters.predicates = [];
      var promises = [
        $inputListsFactory.getInputList($scope.params.listId),
        $inputListsFactory.getInputListFilters($scope.params.listId),
        _getConfigFormatSchema(),
      ];

      Promise.allSettled(promises)
        .then(function (res) {
          vm.list = res[0].value;
          var hasSettings = res[0] && res[0].settings;
          var schemaSettings = hasSettings && angular.fromJson(res[0].settings);
          vm.schema = $schemasService.parseSchema(vm.list.schema, schemaSettings);
          vm.columnfilters = res[1].value;
          vm.schemasFormat = res[2].status == "fulfilled" ? res[2].value : [];
        })
        .then(function () {
          _renderList();
          _setColumnDefs()
            .then(function () {
              if (
                $scope.params.filters &&
                $scope.params.filters != null &&
                $scope.params.filters != "null" &&
                $scope.params.filters.predicates
              ) {
                _setDefaultFilters();
              }

              _getListData();
            })
            .catch(function (err) {
              $toastr.warning(
                $translationService.getTranslationController(
                  "No hay columnas visibles en el esquema.",
                  "There is no columns visible on schema",
                  "Não há colunas visíveis no esquema"
                )
              );
              $rootScope.loading = false;
            });
        })
        .catch(function (error) {
          console.error("Error@getInputList/getInputListFilters", error);
          $toastr.error(error.message);
          $rootScope.loading = false;
        });
    }
    _init();

    function _setDefaultFilters() {
      vm.filters.predicates = [];
      $scope.params.filters.predicates.forEach(function (filter) {
        if (filter.field === "time") {
          filter.value = moment(filter.value).format("HH:MM:SS");
        }

        if (filter.field == "id") {
          vm.filters.predicates.push({
            label: filter.field,
            fieldName: filter.field,
            operation: "IN",
            values: filter.values,
            value: null,
            valuesLabels: null,
          });
        } else {
          var colDef = _getColumnDefinition(filter.field);
          if (typeof filter.value == "object") {
            filter.value.forEach(function (item) {
              vm.filters.predicates.push({
                label: colDef.displayName || colDef.key,
                fieldName: filter.field,
                operation: "EQUAL",
                values: null,
                value: item,
                valuesLabels: null,
              });
            });
          } else {
            vm.filters.predicates.push({
              label: colDef.displayName || colDef.key,
              fieldName: filter.field,
              operation: "EQUAL",
              values: null,
              value: filter.value,
              valuesLabels: null,
            });
          }
        }
      });
      vm.isFiltered = true;
    }

    function _setColumnDefs() {
      return new Promise(function (resolve, reject) {
        vm.gridOptions.columnDefs = [];

        angular.forEach(vm.schema, function (col, key) {
          if (col.visible) {
            var field = col.pk ? "#" + key : key;

            var colDef = {
              order: col.order,
              name: key,
              displayName: col.displayName || key,
              field: field,
              cellFilter: $tableListConstants.cellFilters[col.type],
              // General column properties
              enableColumnMenu: true,
              enableSorting: true,
              enableHiding: false,
              aux: col,
              menuItems: [
                {
                  title: $translationService.getTranslationController(
                    "Reemplazar",
                    "Replace",
                    "Substituir"
                  ),
                  icon: "ui-grid-icon-pencil",
                  shown: function () {
                    var hasFilters = vm.columnfilters.find(function (e) {
                      return e.field.replace("#", "") == col.key || e.label == col.displayName;
                    });

                    return hasFilters ? true : false;
                  },
                  action: function ($event) {
                    this.context.showReplaceDialog($event, col);
                  },
                  context: vm,
                },
                {
                  title: $translationService.getTranslationController(
                    "Filtrar",
                    "Filter",
                    "Filtro"
                  ),
                  icon: "ui-grid-icon-filter",
                  shown: function () {
                    var hasFilters = vm.columnfilters.find(function (e) {
                      return e.field == col.key || e.label == col.displayName;
                    });

                    return hasFilters ? true : false;
                  },
                  action: function ($event) {
                    this.context.addFilterTo($event, col);
                  },
                  context: vm,
                },
              ],
              aggregationHideLabel: true,
              aggregationType:
                col.type == "integer" || col.type == "double"
                  ? $uiGridConstants.aggregationTypes.sum
                  : null,
              footerCellTemplate:
                col.type == "integer" || col.type == "double"
                  ? '<div class="ui-grid-cell-contents" >{{col.getAggregationValue() | number:2 }}</div>'
                  : "",
              headerCellTemplate: "app/input-list/templates/header-cell-template.html",
            };
            colDef.cellTemplate = $cellTemplateFormatService.setTemplate(
              colDef,
              col,
              vm.schemasFormat
            );

            vm.gridOptions.columnDefs.push(colDef);
          }
        });

        vm.gridOptions.columnDefs = vm.gridOptions.columnDefs.sort(function (a, b) {
          return a.order - b.order;
        });

        if (vm.gridOptions.columnDefs.length) {
          resolve();
        }
        reject();
      });
    }

    function _getListData() {
      vm.tableIsLoading = true;
      vm.filters.luceneQueryId = $scope.params.filters.luceneQueryId;
      $inputListsFactory
        .getInputListDataFiltered($scope.params.listId, vm.filters)
        .then(function (res) {
          vm.gridOptions.totalItems = res.pagination.totalRecords;
          vm.gridOptions.paginationOptions.pageNumber = vm.filters.pagination.page;
          vm.gridOptions.paginationCurrentPage = vm.filters.pagination.page;

          vm.dataList = res.data.map(function (e) {
            return {
              dataId: e.dataId,
              body: angular.fromJson(e.body),
            };
          });

          vm.dataList = vm.dataList.map(function (e) {
            e.body.__dataId = e.dataId;
            var body = e.body;
            return body;
          });

          var cols = $listService.getColumns(vm.schema);
          vm.dataList = $listService.unNormalizeData(vm.dataList, cols);

          vm.gridOptions.data = vm.dataList;

          vm.filterlist = vm.dataList;

          _getMetadataList();
          vm.tableIsLoading = false;
        })
        .catch(function (err) {
          console.error("Error@getInputListData", err);
          vm.tableIsLoading = false;
        })
        .finally(function () {
          vm.tableIsLoading = false;
        });
    }

    function _getMetadataList() {
      var noGroupTag = $translationService.getTranslationController("otros", "others", "otros");

      $inputListsFactory
        .getInputListMetadata($scope.params.listId)
        .then(function (res) {
          var mapData = res.columns.map(function (e) {
            var cleanColName = e.name.replace("#", "");

            var col = {
              field: e.name,
              title:
                vm.schema[cleanColName] && vm.schema[cleanColName].displayName
                  ? vm.schema[cleanColName].displayName
                  : e.name,
              type: e.type,
              show: true,
              group: vm.schema[cleanColName]
                ? angular.isUndefined(vm.schema[cleanColName].group)
                  ? noGroupTag
                  : vm.schema[cleanColName].group
                : noGroupTag,
              order: vm.schema[cleanColName] ? vm.schema[cleanColName].order : "1",
              sortable: e.name,
              filterable: { type: "text" },
              readonly: e.readonly,
              width: 30,
            };
            return col;
          });

          vm.columns = mapData.sort(function (a, b) {
            return a.order - b.order;
          });

          vm.groups = vm.columns.map(function (ele) {
            if (ele.show === false) return;

            var item = ele.group;
            if (
              typeof item === "string" &&
              item != undefined &&
              item != null &&
              item != "" &&
              item != "null"
            ) {
              return item;
            } else {
              return noGroupTag;
            }
          });

          vm.groups = vm.groups
            .filter(function (e) {
              return e;
            })
            .filter(function (value, index) {
              return vm.groups.indexOf(value) == index;
            });

          $rootScope.loading = false;
        })
        .catch(function (err) {
          console.error("Error@getInputListMetadata", err);
          vm.tableIsLoading = false;
        });
    }

    vm.validatePermission = function (permission) {
      return $permissionsFactory.hasPermission(permission);
    };

    vm.onClickListRow = function (item) {
      if (!vm.validatePermission("list#" + vm.list.listId + ":read")) return;

      var _item = {
        dataId: item.__dataId,
        body: item,
      };
      $mdDialog
        .show({
          controller: "clientCardController",
          controllerAs: "ctrl",
          templateUrl: "app/app-utils/components/client-card/client-card.html",
          clickOutsideToClose: false,
          locals: {
            title: $translationService.getTranslationController(
              "Editor de datos",
              "Data editor",
              "Editor de dados"
            ),
            listId: vm.list.listId,
            inputs: _item,
            inputsTypes: vm.columns,
            groups: vm.groups,
            listSchema: vm.schema,
          },
        })
        .then(function () {
          _init();
        });
    };

    vm.showIssueDialog = function (event, issueUuid) {
      if (!issueUuid || issueUuid === "") return;
      var uuid = issueUuid.split("&")[1] || issueUuid.split("&")[0];
      $rootScope.loading = true;
      var promises = [_getIssuesByUuid(uuid), _getIssuesTypes()];
      Promise.allSettled(promises)
        .then(function (res) {
          var issue = res[0].status == "fulfilled" ? res[0].value : false;
          var issueTypes = res[1].status == "fulfilled" ? res[1].value : [];
          if (issue) {
            issue.cat;
            $mdDialog.show({
              controller: "IssuesDetailDialogController",
              controllerAs: "ctrl",
              templateUrl:
                "app/dashboard/components/issues-detail-dialog/issues-detail-dialog.html",
              parent: angular.element(document.body),
              targetEvent: null,
              clickOutsideToClose: false,
              multiple: true,
              locals: {
                issueTypes: issueTypes,
                currentIssueType: issueTypes.find(function (e) {
                  return e.id == issue.issueType.id;
                }),
                issue: issue,
                issuesToLink: [],
                currentCategory: issue.category,
              },
            });
          } else {
            $toastr.warning(
              $translationService.getTranslationController(
                "No se pudo cargar el issue",
                "Can load issue",
                "Can load issue "
              )
            );
          }
        })
        .finally(function () {
          $rootScope.loading = false;
        });
    };

    vm.getBack = function () {
      if ($stateParams.backTo) $state.go("app." + $stateParams.backTo);
      else $state.go("app.schemasLists");
    };

    function _renderList() {
      var inputList = {
        cols: [],
        types: [],
      };

      angular.forEach(vm.schema, function (col, key) {
        inputList.types[(col.pk ? "#" : "") + key] = col.type;
        var referencedListId = col.metadata ? col.metadata.id : null;
        var colDefinition = _getInputType(
          col.type,
          referencedListId,
          col.autocomplete,
          col.inputFormat,
          col.outputFormat,
          col.readonly
        );
        colDefinition.data = (col.pk ? "#" : "") + key;
        colDefinition.title = key + (col.required || col.pk ? "*" : "");
        inputList.cols.push(colDefinition);
      });

      vm.inputList = inputList;
    }

    function _getInputType(input, list, autocomplete, inputFormat, outputFormat, readonly) {
      var sequentialSourceFn = function (query, process) {
        $inputListsFactory.getInputListData(list, {}, false).then(function (res) {
          var source = res.data.map(function (e) {
            var res = angular.fromJson(e.body);
            if (res.$visible) delete res.$visible;
            return Object.values(res)[0];
          });
          process(source);
        });
      };

      return $listService.getInputType(
        input,
        autocomplete,
        inputFormat,
        outputFormat,
        readonly,
        sequentialSourceFn
      );
    }

    vm.unFilterData = function () {
      vm.filters.predicates = [];
      vm.isFiltered = false;
      vm.filters.pagination.page = 1;
      _getListData();
    };

    vm.removeFilter = function (index) {
      vm.filters.predicates.splice(index, 1);
      if (!vm.filters.predicates.length) {
        vm.isFiltered = false;
      }
      vm.filters.pagination.page = 1;
      _getListData();
    };

    vm.addFilterTo = function (event, col) {
      col.name = col.displayName || col.key;
      var selectedColumnFilters = vm.columnfilters.find(function (e) {
        return e.field == col.key || e.label == col.displayName;
      });

      if (!selectedColumnFilters) {
        $toastr.warning(
          $translationService.getTranslationController(
            "No hay filtros disponibles para la columna ",
            "There is no filters available for column ",
            "Não há filtros disponíveis para coluna "
          ) + col.name
        );
        return;
      }

      $mdDialog
        .show({
          controller: "IssuesFiltersDialogController",
          controllerAs: "ctrl",
          templateUrl: "app/dashboard/components/issues-filters-dialog/issues-filters-dialog.html",

          parent: angular.element(document.body),
          targetEvent: event,
          clickOutsideToClose: false,
          locals: {
            column: col,
            columnFilters: selectedColumnFilters,
          },
        })
        .then(function (predicate) {
          vm.filters.predicates.push(predicate);
          vm.filters.pagination.page = 1;
          vm.isFiltered = true;
          _getListData();
        });
    };

    vm.showReplaceDialog = function (ev, col) {
      var colTypes = [];
      angular.forEach(vm.columns, function (e) {
        colTypes[e.field] = e.type;
      });

      $inputListsFactory.setSelectedCol((col.pk ? "#" : "") + col.key);

      $mdDialog.show({
        controller: "ListReplaceController",
        templateUrl: "app/input-list/components/list-replace/list-replace.html",
        locals: {
          listId: vm.list.listId,
          cellValue: "",
          colTypes: colTypes,
        },
        parent: angular.element(document.body),
        targetEvent: ev,
        hasBackdrop: false,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: true,
      });
    };

    vm.parsePredicateValue = function (predicate) {
      if (vm.schema[predicate.fieldName.replace("#", "")].type == "date") {
        return moment(predicate.value).format("DD-MM-YYYY");
      }

      return predicate.value;
    };

    $scope.$on("listFiltered", function (e, filter) {
      var predicate = {
        fieldName: filter.column,
        label: filter.column,
        operation: "EQUAL",
        value: filter.conditionValue,
        values: null,
        valuesLabels: null,
      };

      vm.filters.predicates.push(predicate);
      vm.isFiltered = true;

      _getListData();
    });

    function _getConfigFormatSchema() {
      return new Promise(function (resolve, reject) {
        $ConfigurationFactory
          .getSchemaFormat()
          .then(function (res) {
            if (res.data.length == 0) {
              resolve([]);
            }
            var schemaMap = res.data.map(function (schema) {
              schema.body = JSON.parse(schema.body);
              return schema;
            });
            resolve(schemaMap);
          })
          .catch(function (err) {
            console.error("Error@getSchemaFormat", err);
            reject(err);
          });
      });
    }

    vm.legacy_exportList = function (ext) {
      $rootScope.loading = true;
      var list = vm.list;

      $toastr.info(
        $translationService.getTranslationController(
          "Exportando lista: ",
          "Exporting list: ",
          "Exportando lista: "
        ) + vm.list.name
      );

      $listExporterService
        .execute(ext, false, list)
        .then(function () {
          $rootScope.loading = false;
          $toastr.success(
            $translationService.getTranslationController(
              "Lista descargadas",
              "List downloaded",
              "Lista baixadas"
            )
          );
        })
        .catch(function (error) {
          $rootScope.loading = false;
          console.error("Error@bulkExportLists", error);
          $toastr.error(
            $translationService.getTranslationController(
              "Se ha producido un error al exportar",
              "An error occurred while exporting",
              "Ocorreu um erro ao exportar"
            )
          );

          $rootScope.loading = false;
        });
    };

    function _getIssuesByUuid(issueUuid) {
      return new Promise(function (resolve, reject) {
        $issuesFactory
          .getIssueByUUID(issueUuid)
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            console.error("Error@_getIssuesByUuid", err);
            reject(err);
          });
      });
    }

    function _getIssuesTypes() {
      return new Promise(function (resolve, reject) {
        $issuesFactory
          .getIssuesTypes()
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            console.error("Error@_getIssuesTypes", err);
            reject(err);
          });
      });
    }

    vm.exportList = function (ext, templateOnly) {
      vm.cols = $listService.getColumns(vm.schema);
      vm.baseSchema = $listService.getBaseSchema(vm.schema);
      vm.types = $listService.getColumnsTypes(vm.schema);
      vm.headers = $listService.getHeaders(vm.schema);
      vm.colsToExport = $listService.getColumnsToExport(vm.schema);

      vm.selectedCol = vm.colsToExport[0];
      vm.baseSchema["$dataId"] = null;
      vm.baseSchema["$visible"] = true;

      var listToExport = {
        listId: vm.list.listId,
        name: vm.list.name,
        schema: vm.list.schema,
        headers: vm.headers,
        colsToExport: vm.colsToExport,
        data: [],
      };

      if (templateOnly) {
        $listExporterService.execute(ext, templateOnly, listToExport);
      } else {
        $mdDialog.show({
          controller: ["$mdDialog", exportSelectorController],
          controllerAs: "selCtrl",
          templateUrl: "app/input-list/templates/export-selector.html",
          scope: $scope,
          preserveScope: true,
          clickOutsideToClose: false,
        });

        function exportSelectorController($mdDialog) {
          this.selection = "this";
          this.selectSheet = function (selection) {
            // if (selection == 'all') {
            $rootScope.loading = true;
            var filters = angular.copy(vm.filters);

            filters.exportToCSV = true;

            if (selection == "all") {
              filters.pagination.page = 1;
              filters.pagination.itemsPerPage = 9000000;
            }

            $listExporterService
              .execute(ext, false, vm.list, filters)
              .then(function () {
                $toastr.success(
                  $translationService.getTranslationController(
                    "Lista descargada",
                    "List downloaded",
                    "Lista baixada"
                  )
                );
              })
              .catch(function (error) {
                console.log("Error@listExporterService", error);
                $toastr.error(
                  $translationService.getTranslationController(
                    "Se ha producido un error al exportar",
                    "An error occurred while exporting",
                    "Ocorreu um erro ao exportar"
                  )
                );
              })
              .finally(function () {
                $rootScope.loading = false;
              });

            $mdDialog.hide();
          };
          this.abortSelection = function () {
            $mdDialog.cancel();
          };
        }
      }
    };

    vm.reload = function () {
      _getListData();
    };
  }
})();

(function () {
  'use strict';
  angular.module('dashboard').constant('tableListConstants', {
    defaultFiltersTemplate: {
      predicates: [],
      pagination: {
        page: 1,
        itemsPerPage: 100,
        sortBy: '',
        colType: '',
        sort: 'ASC',
        totalRecords: 0,
      },
      exportToCSV: false,
    },
    cellFilters: {
      date: 'date: "dd-MM-yyyy ": "UTC"',
      time: 'asTime',
      timestamp: 'date: "dd-MM-yyyy HH:mm:ss"',
      integer: 'number: 0',
      double: 'number: 2',
    },
  });
})();

(function () {
  "use strict";

  angular
    .module("dashboard")
    .service("listExporterService", ListExporterService);

  ListExporterService.$inject = [
    "$rootScope",
    "FileSaver",
    "SchemasService",
    "listService",
    "InputListsFactory",
  ];
  function ListExporterService(
    $rootScope,
    $fileSaver,
    $schemasService,
    $listService,
    $inputListsFactory
  ) {
    var vm = this;

    vm.execute = function (ext, templateOnly, inputList, filters) {
      // console.log(ext, templateOnly, inputList, filters);

      if (templateOnly) {
        return _export(ext, templateOnly, inputList);
      }

      var schema = $schemasService.parseSchema(
        angular.fromJson(inputList.schema)
      );

      var listToExport = {
        name: inputList.name,
        schema: schema,
        headers: $listService.getHeaders(schema),
        cols: $listService.getColumns(schema),
        colsToExport: $listService.getColumnsToExport(schema),
        data: [],
      };

      var default_filters = {
        predicates: [],
        pagination: {
          page: 1,
          itemsPerPage: 1000000,
        },
        exportToCSV: true,
        luceneQueryId: null,
      };

      var _filters = angular.extend(default_filters, filters);

      var dataToExport = [];

      return $inputListsFactory
        .getInputListDataFiltered(inputList.listId, _filters)
        .then(function (res) {
          
          $rootScope.$broadcast("refreshUserDocuments");
          // if (_filters.exportToCSV) {

          // } else {
          //   dataToExport = angular.copy(
          //     res.data.map(function (e) {
          //       var res = angular.fromJson(e.body);
          //       res.$dataId = e.dataId;
          //       res.$visible = e.visible;
          //       return res;
          //     })
          //   );

          //   dataToExport = $listService.unNormalizeData(
          //     dataToExport,
          //     listToExport.cols
          //   );

          //   listToExport.data = angular.copy(dataToExport);

          //   return _export(ext, false, listToExport);
          // }
        })
        .catch(function (error) {
          console.log("Error@getInputListData", error);
        });
    };

    vm.export = function (ext, templateOnly, inputList) {
      return _export(ext, templateOnly, inputList);
    };

    function _export(ext, templateOnly, inputList) {
      return new Promise(function (resolve, reject) {
        var exportData = [];
        var rows = [];
        var fileName = inputList.name;

        if (fileName.length > 31) {
          fileName = fileName.substring(-1, 31);
        }

        if (templateOnly) {
          if (fileName.length > 27) fileName = fileName.substring(-1, 27);
          fileName += ".tpl";
        }

        exportData.push(inputList.headers);

        var cols = "";
        angular.forEach(inputList.colsToExport, function (col, key) {
          cols += "e['" + col + "'],";
        });
        cols = "[" + cols + "]";

        rows = inputList.data.map(function (e) {
          return eval(cols);
        });

        var excel = { fileName: fileName, data: exportData.concat(rows) };
        var wb = new Workbook();
        var ws = _getSheet(excel.data);
        /* add worksheet to workbook */
        wb.SheetNames.push(excel.fileName);
        wb.Sheets[excel.fileName] = ws;

        try {
          var wbout = XLSX.write(wb, {
            bookType: ext,
            bookSST: true,
            type: "binary",
          });

          $fileSaver.saveAs(
            new Blob([_stringToArrayBuffer(wbout)], {
              type: "application/octet-stream",
            }),
            excel.fileName + "." + ext
          );

          resolve();
        } catch (error) {
          reject(error);
        } finally {
          wbout = null;
        }
      });
    }

    function Workbook() {
      if (!(this instanceof Workbook)) return new Workbook();

      this.SheetNames = [];
      this.Sheets = {};
    }

    function _stringToArrayBuffer(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    }

    function _datenum(v, date1904) {
      if (date1904) v += 1462;
      var epoch = Date.parse(v);
      return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
    }

    function _getSheet(data) {
      var ws = {};
      var range = { s: { c: 10000000, r: 10000000 }, e: { c: 0, r: 0 } };

      for (var R = 0; R != data.length; ++R) {
        var C = -1;
        angular.forEach(data[R], function (col, key) {
          ++C;
          if (range.s.r > R) range.s.r = R;
          if (range.s.c > C) range.s.c = C;
          if (range.e.r < R) range.e.r = R;
          if (range.e.c < C) range.e.c = C;

          var cell = { v: data[R][key] };
          if (cell.v != null) {
            var cell_ref = XLSX.utils.encode_cell({ c: C, r: R });

            if (typeof cell.v === "number") {
              cell.t = "n";
            } else if (typeof cell.v === "boolean") {
              cell.t = "b";
            } else if (cell.v instanceof Date) {
              cell.t = "n";
              cell.z = XLSX.SSF._table[14];
              cell.v = _datenum(cell.v);
            } else cell.t = "s";

            ws[cell_ref] = cell;
          }
        });
      }

      if (range.s.c < 10000000) {
        ws["!ref"] = XLSX.utils.encode_range(range);
      }

      return ws;
    }
  }
})();

(function () {
  'use strict';

  angular.module('dashboard').service('importSheetsService', listService);

  listService.$inject = [];
  function listService() {
    this.csvMimeTypes = [
      'text/plain',
      'text/x-csv',
      'application/vnd.ms-excel',
      'application/csv',
      'application/x-csv',
      'text/csv',
      'text/comma-separated-values',
      'text/x-comma-separated-values',
      'text/tab-separated-values',
    ];

    /**
     * Decode special chars, only for raw csv
     * @param {string} CSVFile
     * @returns {string}
     */
    this.decodeUtf8 = function (bstr) {
      try {
        bstr = decodeURIComponent(escape(bstr));
      } catch (err) {
        console.log('Error decoding utf8', err);
      }

      return bstr;
    };

    /**
     * Remove BOM char on UTF8 csv
     * @param {string} CSVFile
     * @returns {string}
     */
    this.removeUtf8BOM = function (bstr) {
      if (bstr.charCodeAt(0) === 0xfeff) {
        bstr = bstr.substr(1);
      }

      return bstr;
    };

    this.setCsvSeparator = function (separator, bstr) {
      return 'sep=' + separator + '\n' + bstr;
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .directive('importSheetJs', SheetJSImportDirective);

  SheetJSImportDirective.$inject = [
    '$rootScope',
    '$mdDialog',
    'toastr',
    'translationService',
    'dateService',
    'listService',
    'importSheetsService',
  ];

  function SheetJSImportDirective(
    $rootScope,
    $mdDialog,
    $toastr,
    $translationService,
    $dateService,
    $listService,
    $importSheetsService
  ) {
    return {
      scope: {
        sheetData: '=',
        schema: '=',
        rowsRemove: '=',
        isImporting: '=',
        shouldReplaceData: '=',
      },
      link: function ($scope, $elm) {
        $translationService.getTranslation($scope, 'input-list');
        $scope.selectedSheet = 0;
        $scope.separator = ',';

        $elm.on('change', function (changeEvent) {
          var reader = new FileReader();

          reader.onloadstart = function () {
            $scope.workbook = false;
            $rootScope.loading = true;
          };

          reader.onloadend = function () {
            $rootScope.loading = false;
          };

          $scope.loadData = function (selSheet) {
            /* read workbook */
            $scope.isCsv = false;
            var e = $scope.data;
            var bstr = e.target.result;
            if (
              $importSheetsService.csvMimeTypes.includes($scope.workbookType)
            ) {
              $scope.isCsv = true;
              bstr = $importSheetsService.decodeUtf8(bstr);
              bstr = $importSheetsService.removeUtf8BOM(bstr);
              bstr = $importSheetsService.setCsvSeparator(
                $scope.separator,
                bstr
              );
              bstr = bstr.split('\r\n').join($scope.separator + '\n'); // Handler for PRM type isue
              var headBstr = bstr;
              headBstr = bstr.split('\n').slice(0, 2).join('\n'); // Takes only first row (header)
            } else {
              var headBstr = bstr;
            }
            $elm.val(null);

            var workbookHeaders = XLSX.read(headBstr, {
              type: 'binary',
              raw: 'true',
              cellHTML: 'false',
              sheetRows: 1,
            });

            $scope.workbook = XLSX.read(bstr, {
              type: 'binary',
              raw: 'true',
              cellHTML: 'false',
              dateNF: 'DD-MM-YYYY HH:mm:ss',
            });

            $scope.workbookInfo = [];
            $scope.workbookCols = [];

            angular.forEach(workbookHeaders.SheetNames, function (sheet) {
              $scope.workbookInfo[sheet] = workbookHeaders.Sheets[sheet];
              $scope.workbookCols[sheet] = Object.keys(
                $scope.workbookInfo[sheet]
              )
                .filter(function (e) {
                  return e.indexOf('1') > 0;
                })
                .map(function (e) {
                  return { col: e, val: $scope.workbookInfo[sheet][e].v };
                });
            });
            workbookHeaders = undefined;
            headBstr = undefined;
            bstr = undefined;
          };

          reader.onload = function (e) {
            $scope.data = e;
            $scope.workbookType = changeEvent.target.files[0].type;
            $scope.isImporting = true;
            $scope.fileName = changeEvent.target.files[0].name;
            $mdDialog
              .show({
                controller: ['$mdDialog', WbSelectorController],
                controllerAs: 'ctrl',
                templateUrl: 'app/input-list/templates/workbook-selector.html',
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose: false,
                onComplete: function () {
                  $scope.loadData($scope.data);
                },
                onRemoving: function () {
                  $rootScope.loading = true;
                },
              })
              .then(
                function () {
                  var myJson = XLSX.utils.sheet_to_json(
                    $scope.workbook.Sheets[
                      $scope.workbook.SheetNames[$scope.selectedSheet]
                    ]
                  );

                  if (myJson.length >= 30000) {
                    var msg = $translationService.getTranslationController(
                      'Los datos no se han podido cargar, limite de registros superado, máximo permitido 30k',
                      'Data could not be loaded, record limit exceeded, maximum allowed 30k',
                      'Dados não puderam ser carregados, limite de registro excedido, máximo permitido 30k'
                    );
                    $toastr.warning(msg);
                    $rootScope.loading = false;
                    $scope.isImporting = false;
                    return;
                  }

                  if ($scope.sheetData.length) {
                    $scope.rowsRemove = $scope.sheetData.map(function (col) {
                      return col.$dataId;
                    });
                  }

                  // Case-sensitivity parse
                  $scope.sheetData = myJson
                    .map(function (e) {
                      e.$dataId = null;
                      e.$visible = true;
                      angular.forEach(Object.keys(e), function (key) {
                        angular.forEach(
                          Object.keys($scope.schema),
                          function (colName) {
                            if (
                              key.trim().toLowerCase() ==
                              colName.trim().toLowerCase()
                            ) {
                              // TypeValidation&Parse
                              if ($scope.schema[colName].type == 'string')
                                e[key] = e[key].toString();
                              if (
                                $scope.schema[colName].type == 'integer' ||
                                $scope.schema[colName].type == 'double'
                              ) {
                                e[key] =
                                  e[key].toString().toLowerCase() == '' ||
                                  e[key].toString().toLowerCase() == 'null' ||
                                  e[key].toString().toLowerCase() == '"null"'
                                    ? ''
                                    : e[key];
                              }
                              if ($scope.schema[colName].type == 'boolean') {
                                e[key] =
                                  e[key] == 'TRUE' ||
                                  e[key] == 'true' ||
                                  e[key] == true
                                    ? true
                                    : false;
                              }

                              if (
                                $scope.schema[colName].type == 'integer' ||
                                $scope.schema[colName].type == 'double'
                              ) {
                                var format = $listService.parseFormat(
                                  $scope.schema[colName].inputFormat
                                );
                                var language = format.length
                                  ? format[0].lang
                                  : 'es-ES';

                                // Ajusta los decimales solo si es CSV
                                if (
                                  language == 'es-ES' &&
                                  $importSheetsService.csvMimeTypes.includes(
                                    $scope.workbookType
                                  )
                                ) {
                                  e[key] = parseFloat(
                                    e[key].replace(/\./g, '').replace(',', '.')
                                  );
                                } else {
                                  e[key] = Number(e[key]);
                                }
                              }
                              if ($scope.schema[colName].type == 'timestamp') {
                                e[key] = $dateService.timestampValidate(
                                  e[key],
                                  $scope.schema[colName].inputFormat ||
                                    'YYYY-MM-DD HH:mm:ss',
                                  $scope.schema[colName].outputFormat
                                );
                              }
                              if ($scope.schema[colName].type == 'date') {
                                e[key] = $dateService.dateValidate(
                                  e[key],
                                  $scope.schema[colName].inputFormat ||
                                    'YYYY-MM-DD',
                                  $scope.schema[colName].outputFormat
                                );
                              }
                              if ($scope.schema[colName].type == 'time') {
                                e[key] = $dateService.timeValidate(
                                  e[key],
                                  $scope.schema[colName].inputFormat ||
                                    'HH:mm:ss',
                                  $scope.schema[colName].outputFormat
                                );
                              }

                              if ($scope.schema[colName].pk) {
                                e['#' + colName] = e[key];
                                delete e[key];
                              } else {
                                e[colName] = e[key];
                                if (key != colName) delete e[key];
                              }
                            }
                          }
                        );
                      });
                      return e;
                    })
                    .sort(function (a, b) {
                      return a.__rowNum__ - b.__rowNum__;
                    });
                  $rootScope.loading = false;
                },
                function () {
                  $rootScope.loading = false;
                  $scope.isImporting = false;
                }
              );

            function WbSelectorController($mdDialog) {
              var vm = this;
              vm.selection = 0;
              vm.separator = $scope.separator;
              vm.shouldReplaceData = true;

              vm.selectSheet = function (selection) {
                $scope.shouldReplaceData = vm.shouldReplaceData;
                $scope.selectedSheet = selection;
                $mdDialog.hide();
              };

              vm.abortSelection = function () {
                $mdDialog.cancel();
              };

              vm.loadData = function () {
                $scope.separator = vm.separator;
                $scope.loadData(vm.selection);
              };
            }
          };

          reader.readAsBinaryString(changeEvent.target.files[0]);
        });
      },
    };
  }
})();

"use strict";

var app = angular.module("dashboard");

app.component("listPaginator", {
  templateUrl: "app/input-list/components/list-paginator.html",
  controllerAs: "ctrl",
  bindings: {
    totalRecords: "=",
    pageIndex: "=",
    pageSize: "=",
    nextFn: "=",
    prevFn: "=",
    gotoFn: "=",
  },
  controller: listPaginatorController,
});

listPaginatorController.$inject = ["$scope", "translationService"];
function listPaginatorController($scope, $translationService) {
  $translationService.getTranslation($scope, "list-paginator");
  var vm = this;
  vm.pages = [1];

  vm.setPaginationRule = function () {
    var numPages = Math.ceil(vm.totalRecords / vm.pageSize);
    if (numPages < 1) {
      numPages = 1;
    }
    vm.pages = new Array(numPages).fill(0).map(function (val, index) {
      return index + 1;
    });
  };
  vm.setPaginationRule();

  vm.$onChanges = function () {
    vm.setPaginationRule();
  };

  $scope.$watchCollection("ctrl.pageSize", function (newVal, oldVal) {
    vm.setPaginationRule();
  });
}

'use strict';

var app = angular.module('dashboard');

app.component('listLoader', {
  templateUrl: 'app/input-list/components/list-loader.html',
  controllerAs: 'ctrl',
  bindings: {
    loading: '<',
    loaded: '<',
    total: '<',
    msg: '<',
    time: '<',
    step: '<',
  },
  controller: listLoaderController,
});

listLoaderController.$inject = ['$scope', 'translationService'];
function listLoaderController($scope, $translationService) {
  $translationService.getTranslation($scope, 'input-list');
  var vm = this;
  vm.progress = 0;
  vm.$onChanges = function () {
    if (vm.total) vm.progress = (vm.loaded * 100) / vm.total;
    if (vm.time && vm.step) {
      vm.time = ((vm.total - vm.loaded) / vm.step) * vm.time;
      vm.timeScale = vm.time > 60000 ? 'min.' : vm.time > 1000 ? 'sec.' : 'ms.';
      vm.time =
        vm.time > 60000
          ? vm.time / 60000
          : vm.time > 1000
          ? vm.time / 1000
          : vm.time;
    }
  };
}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('IndicatorDialogController', IndicatorDialogController);

  IndicatorDialogController.$inject = [
    '$scope',
    '$rootScope',
    '$mdDialog',
    'translationService',
    'toastr',
    'IndicatorsFactory',
    'indicator',
  ];
  function IndicatorDialogController(
    $scope,
    $rootScope,
    $mdDialog,
    $translationService,
    $toastr,
    $indicatorsFactory,
    indicator
  ) {
    $translationService.getTranslation($scope, 'indicators');

    var vm = this;

    vm.isLoading = true;

    var defaultIndicator = {
      name: '',
      description: '',
      intervals: [
        {
          min: 0,
          max: 50,
          color: '#AA0000',
          label: 'start',
        },
      ],
      active: true,
    };

    if (indicator) {
      vm.indicator = indicator || defaultIndicator;
      vm.method = $translationService.getTranslationController(
        'Actualizar',
        'Update',
        'Actualizar'
      );
      vm.isLoading = false;
    } else {
      vm.indicator = defaultIndicator;
      vm.method = $translationService.getTranslationController(
        'Crear',
        'Create',
        'Crear'
      );
      vm.isLoading = false;
    }

    vm.save = function () {
      if (indicator) {
        editIndicator(vm.indicator);
      } else {
        createIndicator(vm.indicator);
      }
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.hide = function () {
      $mdDialog.hide();
    };

    vm.addInterval = function () {
      var lastInterval =
        vm.indicator.intervals[vm.indicator.intervals.length - 1];

      vm.indicator.intervals.push({
        min: lastInterval ? lastInterval.max + 1 : 0,
        max: lastInterval ? lastInterval.max * 2 : 10,
        color: '#1f225c',
        label: 'new',
      });
    };

    vm.removeInterval = function (index) {
      if (vm.indicator.intervals.length == 1) return;
      vm.indicator.intervals.splice(index, 1);
    };

    function editIndicator() {
      vm.isLoading = true;
      $indicatorsFactory
        .editIndicator(vm.indicator)
        .then(function (res) {
          vm.hide();
          vm.isLoading = false;
        })
        .catch(function (err) {
          vm.isLoading = false;
          console.error('Error@editIndicator', err);
        });
    }
    function createIndicator() {
      vm.isLoading = true;
      $indicatorsFactory
        .createIndicator(vm.indicator)
        .then(function (res) {
          vm.hide();
          vm.isLoading = false;
        })
        .catch(function (err) {
          vm.isLoading = false;
          console.error('Error@createIndicator', err);
        });
    }
  }
})();

/**
 * Dashboard configuration tile directive
 */

"use strict";

angular.module('dashboard')
.directive('widgetTile', function() {
  return {
    restrict: 'A',
    link: function(scope, elem, attr) {
      elem.mouseover(function ($event) {
        attr.$set('mdWhiteframe', 4);
        scope.$apply();
      });
      elem.mouseleave(function ($event) {
        attr.$set('mdWhiteframe', 1);
        scope.$apply();
      });
    }
  };
});

(function () {
    'use strict';

    angular
        .module('dashboard')
        .controller('GroupConfigController', GroupConfigController);

    GroupConfigController.$inject = ['$scope', '$localStorageService', '$modal', '$rootScope',
        '$stateParams', 'Paginator', '$timeout', 'env', '$mdToast', 'BaseUrl', 'translationService', '$mdDialog', '$document',
        'NgTableParams', 'ngTableEventsChannel', '$location', 'toastr',
        'GroupFactory', '$filter', '$state'];

    function GroupConfigController($scope, $localStorageService, $modal, $rootScope, $stateParams, Paginator, $timeout, env,
                                   $mdToast, BaseUrl, $translationService, $mdDialog, $document, NgTableParams,
                                   ngTableEventsChannel, $location, toastr, GroupFactory, $filter, $state) {

        var vm = this;

        vm.selectedTab = 'index';
        vm.lists = [];

        (function init() {
            console.log('++++++ GroupConfigController +++++++')

            //Método para realizar traducción
            $translationService.getTranslation($scope, 'group');

            showLangFn();
            vm.config = {
                datasource: {
                    origin: "GET", //REST Methods, ARRAY, WS(WebSocket)
                    url: "/risk-backend/rest/group", //solo para rest y ws
                    params: {
                        query: '',
                        sortBy: 'id',
                        sort: 'desc',
                        startDate: moment($stateParams.desde || (moment().subtract(1, 'week').hour(0).minute(0).second(0))),
                        endDate: moment($stateParams.hasta || (moment().hour(23).minute(59).second(59))),
                        page: 1,
                        itemsPerPage: 25,
                    },
                    paramsOut: {
                        data: "data",
                        pagination: "pagination"
                    }
                },
                pageSizes: [25, 50, 100],
                columns: [
                    {field: "id", title: "Id", type: "number", show: true, sortable: "id", width: 3},
                    {
                        field: "name",
                        title: $translationService.getTranslationController('Nombre', 'Name', 'Nome'),
                        type: "text",
                        show: true,
                        sortable: "name",
                        filterable: {"type": "text"},
                        width: 20
                    },
                    {
                        field: "company",
                        title: $translationService.getTranslationController('Compañia', 'Company', 'Compañia'),
                        type: 'object',
                        key: 'name',
                        show: true,
                        width: 10
                    },
                    {
                        field: "totalMembers",
                        title: $translationService.getTranslationController('Miembros', 'Members', 'Membros'),
                        type: "text",
                        show: true,
                        width: 10
                    },
                    {
                        field: "active",
                        title: $translationService.getTranslationController('Estado', 'Status', 'Estado'),
                        type: "boolean",
                        show: true,
                        width: 5
                    }
                ]
            };

        })();

        function showLangFn() {
            $rootScope.tabsGroups = [{id: "index", name: "GROUP_CONFIG_TITLE"}];
            if ($rootScope.tabsGroups[0].id === 'index') {
                $rootScope.tabsGroups[0].name = $translationService.getTranslationController('TODOS', 'ALL', 'TODOS');
            }
        }

        vm.setTab = function (newTab) {
            vm.selectedTab = newTab;
        };

        vm.isSet = function (tabNum) {
            return vm.selectedTab == tabNum;
        };

        vm.isActive = function (id) {
            return vm.isSet(id) && id != 'index';
        };

        vm.eliminarTab = function (tabId) {
            var indexTab = -2;
            for (var i = 0; i < $rootScope.tabsGroups.length; i++) {
                var actualTab = $rootScope.tabsGroups[i];
                if (actualTab.id === tabId) {
                    indexTab = i;
                    break;
                }
            }
            if (indexTab > 0) {
                $rootScope.tabsGroups.splice(indexTab, 1);
                vm.setTab('index');
            }
        };

        vm.crearTabDetalle = function (item) {
            //Se recorren los tabs existentes
            var existeTab = false;
            $rootScope.loading = true;
            for (var i = 0; i < $rootScope.tabsGroups.length; i++) {
                var actualTab = $rootScope.tabsGroups[i];
                if (actualTab.id === item.id) {
                    existeTab = true;
                    break;
                }
            }
            if (existeTab) {
                vm.setTab(actualTab.id);
                $rootScope.loading = false;
            } else {
                //Se crea el nuevo tab con el detalle del caso
                var newTab = {id: item.id, name: item.name.substring(0, 15) + ' - ' + item.id};
                //Se agrega el tab a la lista
                $rootScope.tabsGroups.push(newTab);
                newTab.group = angular.copy(item);

                vm.setTab(newTab.id);
                $rootScope.loading = false;
            }
        };

        /********************************************** Modal Create Group ********************************************/
        vm.showShareEntityDialog = function (selectedItem) {
            $mdDialog.show({
                controller: 'ShareEntityController',
                templateUrl: 'app/acl/component/dialog-share-entity.html',
                parent: angular.element(document.body),

                clickOutsideToClose: false,
                locals: {
                    selectedItem: {
                        id: selectedItem.id,
                        resource: 'group',
                        name: selectedItem.name,
                    },
                    actions: ['read', 'update', 'delete'],
                },
            });
        };

        /********************************************** Modal Create Group ********************************************/
        vm.showCreateGroupDialog = function (selectedItem) {
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'app/group/config/dialog-create-group.html',
                parent: angular.element(document.body),

                clickOutsideToClose: false,
                resolve: {
                    selectedItem: function () {
                        return selectedItem;
                    },
                },
            });
        };

        DialogController.$inject = ['$scope', '$mdDialog', 'translationService', 'GroupFactory', 'selectedItem', 'UserFactory', 'PermissionsFactory', 'CompanyFactory'];

        function DialogController($scope, $mdDialog, $translationService, GroupFactory, selectedItem, UserFactory, PermissionsFactory, CompanyFactory) {

            (function init() {
                $translationService.getTranslation($scope, 'group');
                $scope.dictionary = {};
                getCompaniesFn();
                $scope.companyId = undefined;
                if (angular.isUndefined(selectedItem)) {
                    $scope.permission = 'group:create';
                    $scope.actionText = $translationService.getTranslationController('Crear Grupo ', 'Create Group', 'Criar Grupo');
                    $scope.members = {};
                } else {
                    $scope.permission = 'group:update';
                    $scope.actionText = $translationService.getTranslationController('Actualizar Grupo ', 'Update Group', 'Atualizar Grupo');
                    if (selectedItem.company) {
                        $scope.dictionary[selectedItem.company.id] = {};
                    }
                    getGroupByIdFn(selectedItem.id);
                }
            })();

            function getGroupByIdFn(id) {
                $rootScope.loading = true;
                GroupFactory.getGroupById(id).then(function (response) {
                    $scope.id = response.id;
                    $scope.name = response.name;
                    $scope.active = response.active;
                    $scope.companyId = response.company.id;
                    $scope.getUsersByCompanyId();

                    response.members.forEach(function (_item) {
                        $scope.dictionary[$scope.companyId][_item.userId] = true;
                    });

                    console.log('$scope.dictionary[$scope.companyId] ' + JSON.stringify($scope.dictionary[$scope.companyId]))
                    $rootScope.loading = false;
                    $scope.$apply();
                }).catch(function (error) {
                    $rootScope.loading = false;
                    if (error.status == 403) {
                        toastr.error($translationService.getTranslationController('Usuario no autorizado.', 'Unauthorized User.', 'Usuário não autorizado.'));
                    } else {
                        toastr.error(error);
                    }
                });
            }

            function getCompaniesFn() {
                $scope.companies = [];
                $rootScope.loading = true;
                CompanyFactory.getAllCompanies().then(function (response) {
                    $scope.companies = response.data;
                    $scope.$apply();
                }).catch(function (error) {
                    if (error.status == 403) {
                        toastr.error($translationService.getTranslationController('Usuario no autorizado.', 'Unauthorized User.', 'Usuário não autorizado.'));
                    } else {
                        toastr.error(error);
                    }
                }).finally(function () {
                    $rootScope.loading = false;
                });
            }

            $scope.getUsersByCompanyId = function () {
                $scope.users = [];
                $rootScope.loading = true;
                UserFactory.getAllUsersByCompanyId($scope.companyId).then(function (response) {
                    $scope.users = response.data;
                    $rootScope.loading = false;
                    $scope.$apply();
                }).catch(function (error) {
                    $rootScope.loading = false;
                    if (error.status == 403) {
                        toastr.error($translationService.getTranslationController('Usuario no autorizado.', 'Unauthorized User.', 'Usuário não autorizado.'));
                    } else {
                        toastr.error(error);
                    }
                });
            }

            $scope.cancel = function (ev) {
                var confirm = $mdDialog
                    .confirm()
                    .multiple(true)
                    .title(
                        $translationService.getTranslationController(
                            '¿Deseas cancelar?',
                            'Do you want to cancel?',
                            'Você quer cancelar?'
                        )
                    )
                    .textContent(
                        $translationService.getTranslationController(
                            '¡Todos los cambios se perderán!',
                            'All changes will be lost!',
                            'Todas as alterações serão perdidas!'
                        )
                    )
                    .ariaLabel('Cancel-Question')
                    .targetEvent(ev)
                    .ok(
                        $translationService.getTranslationController(
                            'Abandonar',
                            'Leave',
                            'Deixar'
                        )
                    )
                    .cancel(
                        $translationService.getTranslationController(
                            'Cancelar',
                            'Cancel',
                            'Cancelar'
                        )
                    );

                $mdDialog.show(confirm).then(
                    function () {
                        $mdDialog.cancel();
                    },
                    function () {
                    }
                );
            };

            $scope.save = function () {
                var group = {
                    id: (angular.isDefined($scope.id)) ? $scope.id : undefined,
                    name: $scope.name,
                    active: $scope.active,
                    members: [],
                    company: {id: $scope.companyId}
                }

                if (angular.isDefined($scope.dictionary[$scope.companyId])) {
                    for (var key in $scope.dictionary[$scope.companyId]) {
                        if ($scope.dictionary[$scope.companyId][key] == true) {
                            group.members.push({
                                userId: key
                            });
                        }
                    }
                }

                if (angular.isUndefined($scope.id)) {
                    GroupFactory.create(group).then(function (response) {
                        $rootScope.$broadcast('refreshNgTableDynamic', {tableId: 'group-table'});
                        var msg = $translationService.getTranslationController('Grupo creado exitosamente.',
                            'Successfully created Group.',
                            'Grupo criado com sucesso.');
                        toastr.success(msg);

                        vm.loading = false;
                        $rootScope.loading = false;
                        $mdDialog.hide();
                    }, function (error) {
                        $rootScope.loading = false;
                        if (error.status == 409) {
                            toastr.error($translationService.getTranslationController('Grupo ya existe.', 'This group already exists.', 'Esta grupo já existe.'));
                        } else {
                            toastr.error(error);
                        }
                    });
                } else {
                    GroupFactory.edit($scope.id, group).then(function (response) {
                        vm.loading = false;
                        $rootScope.loading = false;
                        $rootScope.$broadcast('refreshNgTableDynamic', {tableId: 'group-table'});
                        var msg = $translationService.getTranslationController('Grupo actualizada exitosamente.',
                            'Successfully updated Group.',
                            'Grupo atualizado com sucesso.');
                        toastr.success(msg);
                        $mdDialog.hide();
                    }, function (error) {
                        $rootScope.loading = false;
                        if (error.status == 409) {
                            toastr.error($translationService.getTranslationController('Grupo ya existe.', 'This group already exists.', 'Esta grupo já existe.'));
                        } else {
                            toastr.error(error);
                        }
                    });
                }
            }

            $scope.validatePermission = function () {
                return PermissionsFactory.hasPermission($scope.permission);
            };

            $scope.onCheckItem = function (item) {
                if ($scope.members.length > 0 && $scope.members.indexOf(item) !== -1) {
                    $scope.members.splice($scope.members.indexOf(item), 1);
                } else {
                    $scope.members.push(item);
                }
            };
        }
    }
})();

(function () {
  'use strict';
  angular
    .module('dashboard')
    .controller('trashStorageController', trashStorageController);

  trashStorageController.$inject = [
    '$scope',
    '$mdDialog',
    '$state',
    'FilesStorageFactory',
    'translationService',
    '$localStorageService',
    '$filter',
  ];
  function trashStorageController(
    $scope,
    $mdDialog,
    $state,
    FilesStorageFactory,
    $translationService,
    $localStorageService,
    $filter
  ) {
    $translationService.getTranslation($scope, 'files-storage');
    var vm = this;

    vm.loadingFolders = null;
    vm.FoldersArray = [];
    vm.totalFolders = 0;

    vm.pagination = {
      page: 1,
      itemsPerPage: 50,
    };

    vm.gridOptions = {
      enableFiltering: true,
      data: [],
      rowTemplate:
        '<div ng-click="grid.appScope.ctrl.showFileDetails(row.entity)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>',
      multiSelect: true,
      gridMenuShowHideColumns: false,
      // Grid pagination options
      useExternalPagination: true,
      paginationPageSizes: [50, 100, 1000],
      paginationPageSize: 50,
      totalItems: 0,
      // Grid sorting options
      useExternalSorting: true,
      // Grid menu
      enableGridMenu: true,
      columnDefs: [
        {
          enableHiding: false,
          enableColumnMenu: false,
          key: 'name',
          name: 'name',
          displayName: $translationService.getTranslationController(
            'Nombre',
            'Name',
            'Nome'
          ),
          field: 'name',
          sort: {
            direction: 'asc',
            priority: 0,
          },
          headerCellClass: 'header-filtered',
        },
        {
          enableFiltering: false,
          enableHiding: false,
          enableColumnMenu: false,
          key: 'extension',
          name: 'extension',
          displayName: $translationService.getTranslationController(
            'extension',
            'extension',
            'extension'
          ),
          field: 'extension',
          cellClass: 'text-center',
          width: 100,
        },
        {
          enableFiltering: false,
          enableHiding: false,
          enableColumnMenu: false,
          key: 'size',
          name: 'size',
          displayName: $translationService.getTranslationController(
            'Size',
            'Tamaño',
            'Tamanho'
          ),
          field: 'size',
          cellClass: 'text-center',
          width: 100,
        },
        {
          enableFiltering: false,
          enableHiding: false,
          enableColumnMenu: false,
          key: 'creationDate',
          name: 'creationDate',
          displayName: $translationService.getTranslationController(
            'Creación',
            'Creation',
            'Criação'
          ),
          width: 200,
          field: 'creationDate',
          cellClass: 'text-center',
          cellFilter: 'date: "dd/MM/yy HH:mm"',
        },
      ],
      gridMenuCustomItems: [
        {
          title: 'Eliminar seleccion',
          action: function ($event) {
            vm.deleteselectedRows();
          },
          order: 1,
        },
      ],
      // Grid api Options
      onRegisterApi: function (gridApi) {
        gridApi.pagination.on.paginationChanged(
          $scope,
          function (newPage, pageSize) {
            vm.pagination.page = newPage;
            vm.pagination.itemsPerPage = pageSize;

            vm.getFoldersList();
          }
        );
        gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (sortColumns[0]) {
            var colField = sortColumns[0].field.split('.')[0];
            vm.pagination.sortBy = colField;
            vm.pagination.sort = sortColumns[0].sort.direction;
          } else {
            vm.pagination.sortBy = null;
          }

          vm.getFoldersList();
        });
        gridApi.core.on.filterChanged($scope, function (col) {
          vm.filters = null;
          if (col.filters[0].term) {
            vm.filters = {
              column: 'extension',
              operation: '%%',
              value: 'jpeg',
              sortBy: 'extension',
              sort: 'asc',
            };
            vm.filters.column = col.field;
            vm.filters.sortBy = col.field;
            vm.filters.value = col.filters[0].term;
            vm.filters.sort = vm.pagination.sort;
            vm.filters.folderName = col.filters[0].term;
          } else {
            vm.filters = null;
          }
          vm.getFoldersList();
        });
        gridApi.selection.on.rowSelectionChanged($scope, function (row, evt) {
          vm.selectedRows = gridApi.selection.getSelectedRows();
        });

        gridApi.selection.on.rowSelectionChangedBatch($scope, function (rows) {
          vm.selectedRows = gridApi.selection.getSelectedRows();
        });
      },
    };

    vm.deleteselectedRows = function () {
      if (vm.selectedRows.length == 0) {
        toastr.error(
          $translationService.getTranslationController(
            'Selecciona un item',
            'Select an row',
            'Selecione um item'
          )
        );
        return;
      }

      var promises = [];
      for (var index = 0; index < vm.selectedRows.length; index++) {
        var ele = vm.selectedRows[index];
        promises.push(deleteFileInTrash(ele.folderId, ele.id));
      }

      Promise.all(promises).then(function (res) {
        vm.getFoldersList();
      });
    };

    vm.getFoldersList = function () {
      vm.loadingFolders = true;
      var filters = Object.assign(vm.pagination, vm.filters);
      FilesStorageFactory.filesInTrash(filters)
        .then(function (res) {
          vm.FoldersArray = res.data;
          vm.gridOptions.data = res.data.map(function (ele) {
            ele.size = $filter('readableBytes')(ele.size);
            return ele;
          });
          vm.gridOptions.totalItems = res.pagination.totalRecords;
          vm.gridOptions.page = res.pagination.page;
          vm.pagination = res.pagination;
          vm.loadingFolders = false;
        })
        .catch(function (err) {
          console.error('Error@getFoldersList', err);
        });
    };
    vm.getFoldersList();

    $scope.$on('refreshStorage', function (e) {
      vm.getFoldersList();
    });

    vm.openFolder = function (row) {
      $state.go('app.folder', {
        FolderId: row.id,
        FolderName: row.name,
        goto: 'files-storage',
      });
    };

    vm.fileDetails = null;

    vm.showFileDetails = function (file) {
      vm.fileDetails = file;
    };
    vm.closeFileDetails = function () {
      vm.fileDetails = null;
    };

    function deleteFileInTrash(folderId, fileId) {
      return new Promise(function (resolve, reject) {
        FilesStorageFactory.deleteFileInTrash(folderId, fileId)
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            reject(err);
          });
      });
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('dashboard')
    .controller('systemStorageController', systemStorageController);
  systemStorageController.$inject = [
    '$scope',
    '$mdDialog',
    '$state',
    'FilesStorageFactory',
    'translationService',
    '$localStorageService',
    '$filter',
  ];
  function systemStorageController(
    $scope,
    $mdDialog,
    $state,
    FilesStorageFactory,
    $translationService,
    $localStorageService,
    $filter
  ) {
    $translationService.getTranslation($scope, 'files-storage');
    var vm = this;

    vm.pagination = {
      page: 1,
      itemsPerPage: 50,
    };

    vm.loadingFolders = null;
    vm.FoldersArray = [];
    vm.totalFolders = 0;

    vm.gridOptions = {
      enableFiltering: true,
      rowTemplate:
        '<div ng-click="grid.appScope.ctrl.openFolder(row.entity)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>',
      multiSelect: true,
      gridMenuShowHideColumns: false,
      // Grid pagination options
      useExternalPagination: true,
      paginationPageSizes: [50, 100, 1000],
      paginationPageSize: 50,
      totalItems: 0,
      // Grid sorting options
      useExternalSorting: true,
      // Grid menu
      enableGridMenu: true,
      columnDefs: [
        {
          enableHiding: false,
          enableColumnMenu: false,
          key: 'name',
          name: 'name',
          displayName: $translationService.getTranslationController(
            'Nombre',
            'Name',
            'Nome'
          ),
          field: 'name',
          cellTemplate:
            '<span style="line-height: 2;">' +
            '<i class="fa fa-folder" style="color:{{row.entity.color}}"></i>' +
            '{{ COL_FIELD }}' +
            '</span>',
          headerCellClass: 'header-filtered',
        },
        {
          enableFiltering: false,
          enableHiding: false,
          enableColumnMenu: false,
          key: 'Files',
          name: 'Files',
          displayName: $translationService.getTranslationController(
            'Archivos',
            'Files',
            'Archivos'
          ),
          field: 'totalFiles',
          cellClass: 'text-right',
          width: 100,
        },
        {
          enableFiltering: false,
          enableHiding: false,
          enableColumnMenu: false,
          key: 'size',
          name: 'size',
          displayName: $translationService.getTranslationController(
            'Size',
            'Tamaño',
            'Tamanho'
          ),
          field: 'size',
          cellClass: 'text-right',
          width: 100,
        },
        {
          enableFiltering: false,
          enableHiding: false,
          enableColumnMenu: false,
          key: 'creationDate',
          name: 'creationDate',
          displayName: $translationService.getTranslationController(
            'Creación',
            'Creation',
            'Criação'
          ),
          width: 200,
          field: 'creationDate',
          cellClass: 'text-center',
          cellFilter: 'date: "dd/MM/yy HH:mm"',
        },
      ],
      data: [],
      // Grid api Options
      onRegisterApi: function (gridApi) {
        gridApi.pagination.on.paginationChanged(
          $scope,
          function (newPage, pageSize) {
            vm.pagination.page = newPage;
            vm.pagination.itemsPerPage = pageSize;

            vm.getFoldersList();
          }
        );
        gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (sortColumns[0]) {
            var colField = sortColumns[0].field.split('.')[0];
            vm.pagination.sortBy = colField;
            vm.pagination.sort = sortColumns[0].sort.direction;
          } else {
            vm.pagination.sortBy = null;
          }

          vm.getFoldersList();
        });
        gridApi.core.on.filterChanged($scope, function (col) {
          vm.filters = null;
          if (col.filters[0].term) {
            vm.filters = {
              column: 'extension',
              operation: '%%',
              value: 'jpeg',
              sortBy: 'extension',
              sort: 'asc',
            };
            vm.filters.column = col.field;
            vm.filters.sortBy = col.field;
            vm.filters.value = col.filters[0].term;
            vm.filters.sort = vm.pagination.sort;
            vm.filters.folderName = col.filters[0].term;
          } else {
            vm.filters = null;
          }
          vm.getFoldersList();
        });
      },
    };

    vm.getFoldersList = function () {
      vm.loadingFolders = true;
      var filters = Object.assign(vm.pagination, vm.filters);
      FilesStorageFactory.getSystemFolders(filters)
        .then(function (res) {
          vm.FoldersArray = res.data;
          vm.gridOptions.data = res.data.map(function (ele) {
            ele.size = $filter('readableBytes')(ele.size);
            return ele;
          });
          vm.gridOptions.totalItems = res.pagination.totalRecords;
          vm.gridOptions.page = res.pagination.page;
          vm.pagination = res.pagination;
          vm.loadingFolders = false;
        })
        .catch(function (err) {
          console.error('Error@getFoldersList', err);
        });
    };
    vm.getFoldersList();

    $scope.$on('refreshStorage', function (e) {
      vm.getFoldersList();
    });

    vm.openFolder = function (row) {
      console.log(JSON.stringify(row))
      $state.go('app.folder', {
        FolderId: row.id,
        FolderName: row.name,
        totalFiles: row.totalFiles,
        goto: 'files-storage',
      });
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('dashboard')
    .controller('filesStorageController', filesStorageController);
  filesStorageController.$inject = [
    '$scope',
    '$mdDialog',
    '$state',
    'FilesStorageFactory',
    'translationService',
    '$localStorageService',
    '$filter',
  ];

  function filesStorageController(
    $scope,
    $mdDialog,
    $state,
    FilesStorageFactory,
    $translationService,
    $localStorageService,
    $filter
  ) {
    var vm = this;
    $translationService.getTranslation(vm, 'files-storage');
    vm.loggedUser = $localStorageService.getItem("currentUser");
    vm.loading = null;
    vm.pagination = {
      page: 1,
      itemsPerPage: 50,
    };
    vm.folder = {
      id: null,
      name: undefined,
      description: undefined,
      size: null,
      totalFiles: null,
      extensions: [],
      color: '#000000',
      files: [],
    };
    vm.folders = null;
    vm.totalFolders = 0;

    vm.filters = null;
    vm.gridOptions = {
      enableFiltering: true,
      rowTemplate:
        '<div ng-click="grid.appScope.ctrl.openFolder(row.entity)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>',
      multiSelect: true,
      gridMenuShowHideColumns: false,
      // Grid pagination options
      useExternalPagination: true,
      paginationPageSizes: [50, 100, 1000],
      paginationPageSize: 50,
      totalItems: 0,
      // Grid sorting options
      useExternalSorting: true,
      // Grid menu
      enableGridMenu: true,
      columnDefs: [
        {
          enableHiding: false,
          enableColumnMenu: false,
          key: 'name',
          name: 'name',
          displayName: $translationService.getTranslationController(
            'Nombre',
            'Name',
            'Nome'
          ),
          field: 'name',
          cellClass: 'truncate',
          cellTemplate:
            '<span style="line-height: 2;">' +
            '<i class="fa fa-folder" style="color:{{row.entity.color}}"></i>' +
            '{{ COL_FIELD }}' +
            '</span>',
          sort: {
            direction: 'asc',
            priority: 1,
          },
          headerCellClass: 'header-filtered',
          width: 150,
        },
        {
          enableFiltering: false,
          enableHiding: false,
          enableColumnMenu: false,
          key: 'Files',
          name: 'Files',
          displayName: $translationService.getTranslationController(
            'Archivos',
            'Files',
            'Archivos'
          ),
          field: 'totalFiles',
          cellClass: 'text-right',
        },
        {
          enableFiltering: false,
          enableHiding: false,
          enableColumnMenu: false,
          key: 'size',
          name: 'size',
          displayName: $translationService.getTranslationController(
            'Size',
            'Tamaño',
            'Tamanho'
          ),
          field: 'size',
          cellClass: 'text-right',
        },
        {
          enableFiltering: false,
          enableHiding: false,
          enableColumnMenu: false,
          key: 'userCreatorName',
          name: 'userCreatorName',
          displayName: $translationService.getTranslationController(
            'Propietario',
            'Owner',
            'Proprietário'
          ),

          field: 'userCreatorName',
          cellClass: 'text-center',
        },
        {
          enableFiltering: false,
          enableHiding: false,
          enableColumnMenu: false,
          key: 'updateDate',
          name: 'updateDate',
          displayName: $translationService.getTranslationController(
            'Última modificación',
            'Last Modified',
            'Última modificação'
          ),

          field: 'updateDate',
          cellClass: 'text-center',
          cellFilter: 'date: "dd/MM/yy HH:mm"',
        },
        {
          enableFiltering: false,
          enableHiding: false,
          enableColumnMenu: false,
          key: 'creationDate',
          name: 'creationDate',
          displayName: $translationService.getTranslationController(
            'Creación',
            'Creation',
            'Criação'
          ),

          field: 'creationDate',
          cellClass: 'text-center',
          cellFilter: 'date: "dd/MM/yy HH:mm"',
        },
      ],
      data: [],
      onRegisterApi: function (gridApi) {
        gridApi.pagination.on.paginationChanged(
          $scope,
          function (newPage, pageSize) {
            vm.pagination.page = newPage;
            vm.pagination.itemsPerPage = pageSize;

            vm.getFoldersList();
          }
        );
        gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (sortColumns[0]) {
            var colField = sortColumns[0].field.split('.')[0];
            vm.pagination.sortBy = colField;
            vm.pagination.sort = sortColumns[0].sort.direction;
          } else {
            vm.pagination.sortBy = null;
          }

          vm.getFoldersList();
        });
        gridApi.core.on.filterChanged($scope, function (col) {
          vm.filters = null;
          if (col.filters[0].term) {
            vm.filters = {
              column: 'extension',
              operation: '%%',
              value: 'jpeg',
              sortBy: 'extension',
              sort: 'asc',
            };
            vm.filters.column = col.field;
            vm.filters.sortBy = col.field;
            vm.filters.value = col.filters[0].term;
            vm.filters.sort = vm.pagination.sort;
          } else {
            vm.filters = null;
          }
          vm.getFoldersList();
        });
      },
    };

    vm.getFoldersList = function () {
      vm.loading = true;
      var filters = Object.assign(vm.pagination, vm.filters);
      FilesStorageFactory.getFolders(filters)
        .then(function (res) {
          vm.folders = res;
          vm.loading = false;
          vm.gridOptions.data = res.data.map(function (ele) {
            ele.size = $filter('readableBytes')(ele.size);
            return ele;
          });
          vm.gridOptions.totalItems = res.pagination.totalRecords;
          vm.gridOptions.page = res.pagination.page;
        })
        .catch(function (err) {
          console.error('Error@getFoldersList', err);
        });
    };
    vm.getFoldersList();

    $scope.$on('refreshStorage', function (e) {
      vm.getFoldersList();
    });

    $scope.modalFolderCreate = function (ev) {
      $mdDialog.show({
        controller: 'folderSettingsController',
        controllerAs: 'ctrl',
        templateUrl: 'app/files-storage/folder/dialog/settings/settings.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          folder: null,
        },
      });
    };

    vm.openFolder = function (row) {
      $state.go('app.folder', {
        FolderId: row.id,
        FolderName: row.name,
        totalFiles: row.totalFiles,
        goto: 'files-storage',
      });
    };
  }
})();

(function () {
  "use strict";
  angular.module("dashboard").controller("folderViewController", folderViewController);

  folderViewController.$inject = [
    "$scope",
    "$rootScope",
    "$stateParams",
    "toastr",
    "$cookies",
    "FileSaver",
    "FileUploader",
    "$mdDialog",
    "FilesStorageFactory",
    "$state",
    "PermissionsFactory",
    "translationService",
    "$filter",
    "IssuesListExporterService"
  ];
  function folderViewController(
    $scope,
    $rootScope,
    $stateParams,
    toastr,
    $cookies,
    FileSaver,
    FileUploader,
    $mdDialog,
    FilesStorageFactory,
    $state,
    PermissionsFactory,
    $translationService,
    $filter,
    $issuesListExporterService
  ) {
    var vm = this;
    vm.isready = false;

    (function init() {
      $translationService.getTranslation(vm, "files-storage");
      vm.loading = false;
      vm.errorReport = { status: false, error: "..." };
      vm.totalFiles = $stateParams.totalFiles == null ? 0 : $stateParams.totalFiles;
    })();

    vm.folder = {
      id: null,
      name: "",
      description: "...",
      size: 0,
      totalFiles: 0,
      extensions: [],
      color: "#ffffff",
      files: [],
      type: "USER",
    };

    vm.uploader = null;

    vm.selectedRows = [];

    vm.pagination = {
      page: 1,
      itemsPerPage: 50,
    };

    vm.filters = null;

    vm.gridOptions = {
      enableFiltering: true,
      data: [],
      rowTemplate:
        '<div ng-click="grid.appScope.ctrl.showFileDetails(row.entity)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>',
      multiSelect: true,
      gridMenuShowHideColumns: false,
      // Grid pagination options
      useExternalPagination: true,
      paginationPageSizes: [50, 100, 1000],
      paginationPageSize: 50,
      totalItems: 0,
      // Grid sorting options
      useExternalSorting: true,
      // Grid menu
      enableGridMenu: true,
      columnDefs: [
        {
          enableHiding: false,
          enableColumnMenu: false,
          key: "name",
          name: "name",
          displayName: $translationService.getTranslationController("Nombre", "Name", "Nome"),
          field: "name",
          sort: {
            direction: "asc",
            priority: 0,
          },
          headerCellClass: "header-filtered",
        },
        {
          enableFiltering: false,
          enableHiding: false,
          enableColumnMenu: false,
          key: "extension",
          name: "extension",
          displayName: $translationService.getTranslationController(
            "extension",
            "extension",
            "extension"
          ),
          field: "extension",
          cellClass: "text-center",
          width: 100,
        },
        {
          enableFiltering: false,
          enableHiding: false,
          enableColumnMenu: false,
          key: "size",
          name: "size",
          displayName: $translationService.getTranslationController("Size", "Tamaño", "Tamanho"),
          field: "size",
          cellClass: "text-center",
          width: 100,
        },
        {
          enableFiltering: false,
          enableHiding: false,
          enableColumnMenu: false,
          key: "creationDate",
          name: "creationDate",
          displayName: $translationService.getTranslationController(
            "Creación",
            "Creation",
            "Criação"
          ),
          width: 200,
          field: "creationDate",
          cellClass: "text-center",
          cellFilter: 'date: "dd/MM/yy HH:mm"',
        },
      ],
      gridMenuCustomItems: [
        {
          title: "Eliminar seleccion",
          action: function ($event) {
            vm.deleteSelectedRows();
          },
          order: 1,
        },
        {
          title: "Descargar seleccion",
          action: function ($event) {
            vm.downloadSelectedRows();
          },
          order: 1,
        },
      ],
      // Grid api Options
      onRegisterApi: function (gridApi) {
        $scope.gridApi = gridApi;
        gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
          vm.pagination.page = newPage;
          vm.pagination.itemsPerPage = pageSize;

          vm.getFilesFolder(true);
        });
        gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (sortColumns[0]) {
            var colField = sortColumns[0].field.split(".")[0];
            vm.pagination.sortBy = colField;
            vm.pagination.sort = sortColumns[0].sort.direction;
          } else {
            vm.pagination.sortBy = null;
          }

          vm.getFilesFolder(true);
        });
        gridApi.core.on.filterChanged($scope, function (col) {
          vm.filters = null;
          if (col.filters[0].term) {
            vm.filters = {
              column: "extension",
              operation: "%%",
              value: "jpeg",
              sortBy: "extension",
              sort: "asc",
              fileName: "jpeg",
            };
            vm.filters.column = col.field;
            vm.filters.sortBy = col.field;
            vm.filters.value = col.filters[0].term;
            vm.filters.sort = vm.pagination.sort;
            vm.filters.fileName = col.filters[0].term;
          } else {
            vm.filters = null;
          }
          vm.getFilesFolder(true);
        });
        gridApi.selection.on.rowSelectionChanged($scope, function (row, evt) {
          vm.selectedRows = gridApi.selection.getSelectedRows();
        });
        gridApi.selection.on.rowSelectionChangedBatch($scope, function (rows) {
          vm.selectedRows = gridApi.selection.getSelectedRows();
        });
      },
    };

    vm.deleteSelectedRows = function () {
      if (vm.selectedRows.length == 0) {
        toastr.error(
          $translationService.getTranslationController(
            "Selecciona un item",
            "Select an row",
            "Selecione um item"
          )
        )
        return;
      }
      vm.loading = true;
      var promises = [];
      for (var index = 0; index < vm.selectedRows.length; index++) {
        var ele = vm.selectedRows[index];
        promises.push(filetoTrash(ele.folderId, ele.id));
      }

      Promise.all(promises).then(function (res) {
        vm.getFolder();
        vm.loading = false;
      });
    };

    vm.downloadSelectedRows = function () {
      if (vm.selectedRows.length == 0) return;
      vm.loading = true;
      var promises = [];
      for (var index = 0; index < vm.selectedRows.length; index++) {
        var ele = vm.selectedRows[index];
        promises.push(downloadFile(ele.folderId, ele.id));
      }

      Promise.all(promises).then(function (res) {
        vm.loading = false;
        if (res.length == 0) return;

        for (var i = 0; i < vm.selectedRows.length; i++) {
          var ele = vm.selectedRows[i];
          FileSaver.saveAs(new Blob([res[i].data]), ele.name);
          delete vm.selectedRows[i];
        }
      });
    };

    vm.getFolder = function () {
      vm.isready = false;
      var folder;
      if ($stateParams.FolderId) {
        folder = $stateParams.FolderId;
      } else if ($stateParams.FolderName) {
        folder = $stateParams.FolderName;
      } else {
        toastr.error(
          $translationService.getTranslationController(
            "Se ha producido un error",
            "An error has occurred",
            "ocorreu um erro"
          )
        );
        return;
      }
      vm.loading = true;
      FilesStorageFactory.getFolderByID(folder)
        .then(function (res) {
          $stateParams.FolderId = res.id;
          vm.folder = {};
          vm.folder.id = res.id;
          vm.folder.name = res.name;
          vm.folder.description = res.description;
          vm.folder.color = res.color;
          vm.folder.extensions = res.extensions.map(extensionsTolowerCase);
          vm.folder.size = res.size;
          vm.folder.totalFiles = res.totalFiles;
          vm.totalFiles = res.totalFiles;
          vm.folder.type = res.type;
          vm.folder.creatorName = res.userCreatorName;
          $scope.selected = res.extensions;
          _createFileUploader();
          vm.getFilesFolder();
          setTimeout(function () {
            vm.isready = true;
          }, 1000);
        })
        .catch(function (err) {
          console.error("Error@getFolderByID", err);
          vm.folder = {};
          vm.loading = false;
        });
    };

    vm.getFilesFolder = function (userEvent) {
      vm.loading = true;
      var filters = Object.assign(vm.pagination, vm.filters);
      FilesStorageFactory.getFilesInFolder(vm.folder.id, filters)
        .then(function (res) {
          vm.folder.files = res.data;
          vm.gridOptions.data = res.data.map(function (ele) {
            ele.size = $filter("readableBytes")(ele.size);
            return ele;
          });
          vm.gridOptions.totalItems = res.pagination.totalRecords;
          vm.gridOptions.page = res.pagination.page;
          vm.pagination = res.pagination;
          vm.folder.totalFiles = res.pagination.totalRecords;

          if (userEvent === true) {
            vm.totalFiles = vm.totalFiles;
          } else {
            vm.totalFiles = res.pagination.totalRecords;
          }

          vm.loading = false;
          $scope.$apply();
        })
        .catch(function (err) {
          console.error("Error@getFilesInFolder", err);
          vm.loading = false;
          (vm.errorReport.status = true), (vm.errorReport.error = err);
        });
    };

    $scope.$on("clearQueue", function (e, data) {
      $scope.gridApi.selection.clearSelectedRows();
      vm.selectedRows = [];
      _createFileUploader();
    });

    $scope.$on("refreshStorage", function (e) {
      vm.getFolder();
      vm.selectedRows = [];
    });

    vm.getFolder();

    function _createFileUploader() {
      vm.uploader = new FileUploader({
        url: "/risk-backend/rest/file/folder/" + $stateParams.FolderId + "/file",
        headers: { token: $cookies.get("token") },
        formData: { creationDate: moment() },
        removeAfterUpload: true,
      });
      vm.uploader.onAfterAddingFile = function (item) {
        if ($stateParams.FolderName == null) {
          vm.uploader.removeFromQueue(item);
          toastr.error(
            $translationService.getTranslationController(
              "Se ha producido un error",
              "An error has occurred",
              "ocorreu um erro"
            )
          );
          return false;
        }
        // validar si se recibió el id de la carpeta
        // Validar la extención del archivo
        var file_ext = item.file.name.split(".").pop().toLowerCase();

        if (!vm.folder.extensions.includes(file_ext)) {
          vm.uploader.removeFromQueue(item);
          toastr.warning(
            $translationService.getTranslationController(
              "Archivo no permitido en esta carpeta",
              "File not allowed in this folder",
              "Arquivo não permitido nesta pasta"
            )
          );
          return false;
        }
        // Validar si ya exite en carpeta
        var checkDuplicate = vm.folder.files.filter(function (e) {
          return e.name == item.file.name;
        });
        if (checkDuplicate.length > 0) {
          toastr.warning(
            $translationService.getTranslationController(
              item.file.name + " ya existe y sera reemplazado por el que esta en cola",
              item.file.name + " already exists and will be replaced by the one in queue",
              item.file.name + " já existe e será substituído por aquele na fila"
            )
          );
          return false;
        }
        // Validar duplicado en cola
        var checkUploaderCola = vm.uploader.queue.filter(function (e) {
          return e.file.name == item.file.name;
        });
        if (checkUploaderCola.length > 1) {
          vm.uploader.removeFromQueue(item);
          toastr.warning(
            $translationService.getTranslationController(
              item.file.name + " ya esta en cola",
              "is already in queue",
              " já está na fila"
            )
          );
          return false;
        }

        // sanitize file name - replace url unsafe characters with underscores
        var sanitizedFileName = String(item.file.name)
          .normalize("NFD") // -> split accented characters into their base character and diacritical mark
          .replace(/[\u0300-\u036f]/g, "") //-> remove diacritical marks
          .replace(/[^A-Za-z0-9\-._~]/g, "_"); // -> replace any remaining url unsafe characters with underscores
        item.file.name = sanitizedFileName;
        // vm.uploader.queue.push(item);

        toastr.info(
          $translationService.getTranslationController(
            "Archivo añadido a la cola!",
            "File added to the queue!",
            "Arquivo adicionado à fila!"
          )
        );
      };

      function replaceSpecialCharacters(filename) {
        var parts = filename.split(".");
        var extension = parts.pop();
        var name = parts.join(".");
        name = name.toLowerCase();
        name = name.replace(/[^a-z0-9\s]/g, "");
        name = name.replace(/\s+/g, "_");
        return name + "." + extension;
      }

      vm.uploader.onAfterAddingAll = function (addedFileItems) {
        // addedFileItems.forEach(function (item) {
        //   var newName = replaceSpecialCharacters(item.file.name);
        //   item.file.name = newName;
        // });
        console.info("onAfterAddingAll", addedFileItems);
      };

      vm.uploader.onErrorItem = function (fileItem, response, status) {
        if (response === "fileDuplicate") {
          var msg = $translationService.getTranslationController(
            "No se ha podido cargar, archivo duplicado en el sistema.",
            "Unable to load, duplicate file in the system.",
            "Não é possível carregar, duplicar arquivo no sistema."
          );
          toastr.error(msg);
        } else {
          if (status == 413) {
            toastr.error(
              $translationService.getTranslationController(
                "No se ha podido cargar el archivo, entidad demasiado grande. ",
                "The file could not be loaded, entity too large. ",
                "O arquivo não pôde ser carregado, entidade muito grande. "
              ) + fileItem.file.name
            );
          } else if (status == 403) {
            toastr.error(
              $translationService.getTranslationController(
                "Usuario no autorizado.",
                "Unauthorized User.",
                "Usuário não autorizado."
              )
            );
          } else {
            toastr.error(
              $translationService.getTranslationController(
                "No se ha podido cargar el archivo.",
                "The file could not be loaded.",
                "O arquivo não pôde ser carregado."
              )
            );
          }
        }
      };
      vm.uploader.onSuccessItem = function (item, response, status, headers) {
        if (status) {
          var msg = $translationService.getTranslationController(
            "Archivo cargado exitosamente",
            "File successfully loaded",
            "Arquivo carregado com sucesso"
          );
          toastr.success(msg);

          PermissionsFactory.addPermission("files-storage-folder-file", response, "all", true);
        }
      };
      vm.uploader.onProgressAll = function () {
        vm.loading = true;
      };
      vm.uploader.onCompleteAll = function () {
        vm.loading = true;
        vm.getFilesFolder();
      };
    }

    $scope.uploadAll = function () {
      vm.loading = true;
      vm.uploader.uploadAll();
    };

    vm.fileDetails = null;
    vm.showFileDetails = function (file) {
      vm.fileDetails = file;
    };
    vm.closeFileDetails = function () {
      vm.fileDetails = null;
    };

    function filetoTrash(folderId, fileId) {
      return new Promise(function (resolve, reject) {
        FilesStorageFactory.moveFileToTrash(folderId, fileId)
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            reject(err);
          });
      });
    }
    function downloadFile(folderId, fileId) {
      return new Promise(function (resolve, reject) {
        FilesStorageFactory.downloadFile(folderId, fileId)
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            reject(err);
          });
      });
    }

    //borrado de la carpeta y archivos ** DELETE
    $scope.deleteFolder = function () {
      FilesStorageFactory.deleteFolderById(vm.folder.id)
        .then(function () {
          toastr.info(
            $translationService.getTranslationController(
              "Carpeta borrada",
              "Deleted folder",
              "Carpeta borrada"
            )
          );
          $state.go("app.files-storage");
        })
        .catch(function (err) {
          console.error("Error@deleteFolderById", err);
          toastr.error(
            $translationService.getTranslationController(
              "No se pudo borrar la carpeta!",
              "Could not delete folder!",
              "Não foi possível excluir a pasta!"
            )
          );
        });
    };

    $scope.confirmDeleteFolder = function (ev) {
      var confirm = $mdDialog
        .confirm()
        .title(
          $translationService.getTranslationController(
            "Seguro deseas Eliminar esta carpeta?",
            "Are you sure you want to delete this folder?",
            "Tem certeza de que deseja excluir esta pasta?"
          )
        )
        .textContent(
          $translationService.getTranslationController(
            "Se eliminaran todos los archivos contenidos permanentemente",
            "All files contained permanently will be deleted",
            "Todos os arquivos contidos permanentemente serão excluídos"
          )
        )
        .ariaLabel("deleteFolder")
        .targetEvent(ev)
        .ok(
          $translationService.getTranslationController(
            "Si, borrala!",
            "Yes, delete it!",
            "Sim, exclua-o!"
          )
        )
        .cancel($translationService.getTranslationController("Cancelar", "Cancel", "Cancelar"));

      $mdDialog.show(confirm).then(
        function () {
          $scope.deleteFolder();
        },
        function () {
          toastr.info(
            $translationService.getTranslationController("Cancelado", "Canceled", "Cancelado")
          );
          $scope.modalFolder();
        }
      );
    };

    $scope.validatePermission = function (action) {
      return PermissionsFactory.hasPermission(
        "files-storage-folder#" + vm.folder.id + ":" + action
      );
    };

    $scope.settingsModal = function (ev) {
      $mdDialog.show({
        controller: "folderSettingsController",
        controllerAs: "ctrl",
        templateUrl: "app/files-storage/folder/dialog/settings/settings.html",
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          folder: vm.folder,
        },
      });
    };

    $scope.export = function (ev) {
      $rootScope.loading = true;

      var filters = Object.assign(vm.pagination, vm.filters);
      filters.itemsPerPage = 1000;

      FilesStorageFactory.getFilesInFolder(vm.folder.id, filters)
        .then(function (res) {
          vm.folder.files = res.data;

          var data = res.data.map(function (ele) {
            ele.size = $filter("readableBytes")(ele.size);
            return ele;
          });

          $issuesListExporterService.exportFile(
            "xlsx",
            vm.gridOptions.columnDefs,
            data,
            vm.gridOptions.columnDefs,
            vm.folder.name
          );
          $rootScope.loading = false;
        })
        .catch(function (err) {
          $rootScope.loading = false;
        });
    };

    vm.showShareEntityDialog = function () {
      $mdDialog.show({
        controller: "ShareEntityController",
        templateUrl: "app/acl/component/dialog-share-entity.html",
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          selectedItem: {
            id: vm.folder.id,
            resource: "files-storage-folder",
            name: vm.folder.name,
          },
          actions: [
            "create-file",
            "delete",
            "update",
            "read",
            "move",
            "download",
            "restore",
            "share",
          ],
        },
      });
    };

    vm.closeFolder = function () {
      if (vm.folder.type === "CUSTOM_REPORT") {
        $state.go("app.custom-report-storage");
        return;
      } else if (vm.folder.type === "SYSTEM") {
        $state.go("app.system-storage");
        return;
      } else {
        $state.go("app.files-storage");
        return;
      }
    };

    function extensionsTolowerCase(ext) {
      return ext.toLowerCase();
    }
  }
})();

'use strict';

var app = angular.module('dashboard');

app.component('storeFilesSelector', {
  templateUrl:
    'app/files-storage/files-selector-dialog/files-selector-dialog.html',
  controllerAs: 'ctrl',
  bindings: {
    links: '=',
  },
  controller: storeFilesSelectorController,
});

storeFilesSelectorController.$inject = ['$scope', 'FilesStorageFactory'];
function storeFilesSelectorController($scope, FilesStorageFactory) {
  var vm = this;
  vm.isLoading = false;
  vm.FoldersArray = [];
  vm.filesOnFolder = [];
  vm.folderActive = null;
  vm.chartListSelected = [];
  vm.currentlinks_ids = [];

  vm.getFoldersList = function () {
    vm.isLoading = true;
    FilesStorageFactory.getFolders()
      .then(function (res) {
        vm.FoldersArray = res.data;
        vm.isLoading = false;
      })
      .catch(function (err) {
        vm.isLoading = false;
        console.error('Error@getFoldersList', err);
      });
  };

  vm.removeLink = function (id) {
    console.log('removeLink', id);
    vm.chartListSelected = vm.chartListSelected.filter(function (link) {
      if (link.id != id) return link;
    });
    vm.links = vm.chartListSelected;
  };

  vm.closeFolder = function () {
    vm.folderActive = null;
    vm.filesOnFolder = [];
  };

  $scope.toggleSelectionFIle = function (file) {
    if (file != undefined && file.hasOwnProperty('id')) {
      var found = vm.chartListSelected.find(function (e) {
        return e.id == file.id;
      });
      if (found == undefined) {
        var item = {
          id: file.id,
          name: file.name,
          type: 'file',
          url: vm.folderActive.id,
        };
        vm.chartListSelected.push(item);
        vm.links = vm.chartListSelected;
      } else {
        vm.removeLink(file.id);
      }
    }
  };

  vm.onSelecFolder = function (id) {
    vm.isLoading = true;
    vm.folderActive = vm.FoldersArray.find(function (folder) {
      return folder.id == id;
    });
    FilesStorageFactory.getFilesInFolder(id)
      .then(function (res) {
        vm.filesOnFolder = res.data;
        vm.isLoading = false;
      })
      .catch(function (err) {
        vm.isLoading = false;
        console.error('Error@getFilesInFolder', err);
      });
  };

  vm.$onInit = function () {
    vm.getFoldersList();
    if (vm.links.length > 0) {
      vm.chartListSelected = vm.links;
      vm.currentlinks_ids = vm.links.map(function (link) {
        return link.id;
      });
    } else {
      vm.chartListSelected = [];
    }
  };
}

/**
 * Transformation box directive
 */

"use strict";

angular.module("dashboard").directive("dropZone", function () {
  return {
    restrict: "A",
    link: function (scope, elem, attr, ctrl) {
      scope.counter = 0;
      elem.bind("dragenter", function (event) {
        event.preventDefault();
        scope.counter++;
        elem.addClass("drop-zone-active");
        return false;
      });
      elem.bind("dragleave", function (event) {
        scope.counter--;
        if (scope.counter === 0) {
          elem.removeClass("drop-zone-active");
        }
        return false;
      });
      elem.bind("drop", function (event) {
        scope.counter = 0;
        elem.removeClass("drop-zone-active");
        return false;
      });
    },
  };
});

(function () {
  'use strict';
  angular
    .module('dashboard')
    .controller('customReportStorageController', customReportStorageController);
  customReportStorageController.$inject = [
    '$scope',
    '$mdDialog',
    '$state',
    'FilesStorageFactory',
    'translationService',
    '$localStorageService',
    '$filter',
  ];
  function customReportStorageController(
    $scope,
    $mdDialog,
    $state,
    FilesStorageFactory,
    $translationService,
    $localStorageService,
    $filter
  ) {
    $translationService.getTranslation($scope, 'files-storage');
    var vm = this;

    vm.pagination = {
      page: 1,
      itemsPerPage: 50,
    };

    vm.loadingFolders = null;
    vm.FoldersArray = [];
    vm.totalFolders = 0;

    vm.gridOptions = {
      enableFiltering: true,
      rowTemplate:
        '<div ng-click="grid.appScope.ctrl.openFolder(row.entity)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>',
      multiSelect: true,
      gridMenuShowHideColumns: false,
      // Grid pagination options
      useExternalPagination: true,
      paginationPageSizes: [50, 100, 1000],
      paginationPageSize: 50,
      totalItems: 0,
      // Grid sorting options
      useExternalSorting: true,
      // Grid menu
      enableGridMenu: true,
      columnDefs: [
        {
          enableHiding: false,
          enableColumnMenu: false,
          key: 'name',
          name: 'name',
          displayName: $translationService.getTranslationController(
            'Nombre',
            'Name',
            'Nome'
          ),
          field: 'name',
          cellTemplate:
            '<span style="line-height: 2;">' +
            '<i class="fa fa-folder" style="color:{{row.entity.color}}"></i>' +
            '{{ COL_FIELD }}' +
            '</span>',
          headerCellClass: 'header-filtered',
        },
        {
          enableFiltering: false,
          enableHiding: false,
          enableColumnMenu: false,
          key: 'Files',
          name: 'Files',
          displayName: $translationService.getTranslationController(
            'Archivos',
            'Files',
            'Archivos'
          ),
          field: 'totalFiles',
          cellClass: 'text-right',
          width: 100,
        },
        {
          enableFiltering: false,
          enableHiding: false,
          enableColumnMenu: false,
          key: 'size',
          name: 'size',
          displayName: $translationService.getTranslationController(
            'Size',
            'Tamaño',
            'Tamanho'
          ),
          field: 'size',
          cellClass: 'text-right',
          width: 100,
        },
        {
          enableFiltering: false,
          enableHiding: false,
          enableColumnMenu: false,
          key: 'creationDate',
          name: 'creationDate',
          displayName: $translationService.getTranslationController(
            'Creación',
            'Creation',
            'Criação'
          ),
          width: 200,
          field: 'creationDate',
          cellClass: 'text-center',
          cellFilter: 'date: "dd/MM/yy HH:mm"',
        },
      ],
      data: [],
      // Grid api Options
      onRegisterApi: function (gridApi) {
        gridApi.pagination.on.paginationChanged(
          $scope,
          function (newPage, pageSize) {
            vm.pagination.page = newPage;
            vm.pagination.itemsPerPage = pageSize;

            vm.getFoldersList();
          }
        );
        gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (sortColumns[0]) {
            var colField = sortColumns[0].field.split('.')[0];
            vm.pagination.sortBy = colField;
            vm.pagination.sort = sortColumns[0].sort.direction;
          } else {
            vm.pagination.sortBy = null;
          }

          vm.getFoldersList();
        });
        gridApi.core.on.filterChanged($scope, function (col) {
          vm.filters = null;
          if (col.filters[0].term) {
            vm.filters = {
              column: 'extension',
              operation: '%%',
              value: 'jpeg',
              sortBy: 'extension',
              sort: 'asc',
            };
            vm.filters.column = col.field;
            vm.filters.sortBy = col.field;
            vm.filters.value = col.filters[0].term;
            vm.filters.sort = vm.pagination.sort;
            vm.filters.folderName = col.filters[0].term;
          } else {
            vm.filters = null;
          }
          vm.getFoldersList();
        });
      },
    };

    vm.getFoldersList = function () {
      vm.loadingFolders = true;
      var filters = Object.assign(vm.pagination, vm.filters);
      filters = Object.assign(filters, { type: 'CUSTOM_REPORT' });
      FilesStorageFactory.getFolders(filters)
        .then(function (res) {
          vm.FoldersArray = res.data;
          vm.gridOptions.data = res.data.map(function (ele) {
            ele.size = $filter('readableBytes')(ele.size);
            return ele;
          });
          vm.gridOptions.totalItems = res.pagination.totalRecords;
          vm.gridOptions.page = res.pagination.page;
          vm.pagination = res.pagination;
          vm.loadingFolders = false;
        })
        .catch(function (err) {
          console.error('Error@getFoldersList', err);
        });
    };
    vm.getFoldersList();

    $scope.$on('refreshStorage', function (e) {
      vm.getFoldersList();
    });

    vm.openFolder = function (row) {
      console.log(JSON.stringify(row))
      $state.go('app.folder', {
        FolderId: row.id,
        FolderName: row.name,
        totalFiles: row.totalFiles,
        goto: 'files-storage',
      });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller(
      "EthicalPortalCompanyDialogController",
      EthicalPortalCompanyDialogController
    );

  EthicalPortalCompanyDialogController.$inject = [
    "$scope",
    "EthicalPortalFactory",
    "$mdDialog",
    "toastr",
    "translationService",
    "$cookies",
    "FileUploader",
    "companyId",
  ];
  function EthicalPortalCompanyDialogController(
    $scope,
    $ethicalPortalFactory,
    $mdDialog,
    $toastr,
    $translationService,
    $cookies,
    FileUploader,
    companyId
  ) {
    var vm = this;
    vm.event = "Store";

    var complainType = {
      name: "Denuncia",
      required_user_data: false,
      active: false,
    };

    vm.complaintForm = [];

    vm.company = {
      rut: "",
      name: "",
      email: "",
      address: "",
      complaintRatification: false,
      complaintForm: [],
      phone: "",
      disclaimer: "",
      descriptionField: "",
      documentList: [],
      complaintTypes: [
        {
          name: "Denuncia",
          required_user_data: false,
          active: true,
        },
      ],
    };

    vm.logo = null;
    vm.loading = true;

    vm.uploaderLogo = new FileUploader({
      url: "/risk-backend/rest/ethical-portal/v2/documents/logo",
      headers: { token: $cookies.get("token") },
      formData: { creationDate: moment() },
      removeAfterUpload: true,
    });

    vm.uploaderDocs = new FileUploader({
      url: "/risk-backend/rest/ethical-portal/v2/documents",
      headers: { token: $cookies.get("token") },
      formData: { creationDate: moment() },
      removeAfterUpload: true,
    });

    function replaceSpecialCharacters(filename) {
      var parts = filename.split(".");
      var extension = parts.pop();
      var name = parts.join(".");
      name = name.toLowerCase();
      name = name.replace(/[^a-z0-9\s]/g, "");
      name = name.replace(/\s+/g, "_");
      return name + "." + extension;
    }

    vm.uploaderDocs.onAfterAddingAll = function (addedFileItems) {
      // addedFileItems.forEach(function (item) {
      //   var newName = replaceSpecialCharacters(item.file.name);
      //   item.file.name = newName;
      // });
      console.info("onAfterAddingAll", addedFileItems);
    };

    vm.uploaderDocs.onBeforeUploadItem = function (item) {
      console.info("onBeforeUploadItem", item);
    };

    $scope.tinymceOptions = {
      menubar: "edit tools",
      height: 300,
      paste_data_images: true,
      skin: "lightgray",
      theme: "modern",
      toolbar:
        "undo redo | formatselect | " +
        "bold italic backcolor | alignleft aligncenter " +
        "alignright alignjustify | bullist numlist outdent indent | " +
        "removeformat |" +
        "code ",
      content_style:
        "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
    };

    vm.$onInit = function () {
      getCompanyByID();
    };

    vm.save = function () {
      vm.loading = true;
      if (vm.company.id) {
        // console.log("Updating company", vm.company);
        // console.log("complaintForm", vm.complaintForm);
        var copy = angular.copy(vm.company);
        copy.documentList = JSON.stringify(vm.company.documentList);
        copy.complaintTypes = JSON.stringify([]);
        copy.complaintForm = JSON.stringify(vm.complaintForm);
        copy.disclaimer = "";
        // copy.descriptionField = "";
        // console.log("copy", copy);

        $ethicalPortalFactory
          .updateCompany(copy)
          .then(function (res) {
            var resCompany = res.data;

            $ethicalPortalFactory
              .updateCompanyComplaintForm(vm.complaintForm)
              .then(function (res) {
                $toastr.success(
                  $translationService.getTranslationController(
                    "Form updated successfully",
                    "Formulario actualizado con éxito",
                    "Formulário atualizado com sucesso"
                  )
                );

                $toastr.success(
                  $translationService.getTranslationController(
                    "Company updated successfully",
                    "Empresa actualizada con éxito",
                    "Empresa atualizada com sucesso"
                  )
                );
                $mdDialog.hide(resCompany);
                vm.loading = false;
              })
              .catch(function (err) {
                $toastr.error(err.data);
                // console.log("err@updateCompany", err);
              });
          })
          .catch(function (err) {
            vm.loading = false;
            $toastr.error(err.data);
            console.error("err@updateCompany", err);
          });
      } else {
        $ethicalPortalFactory
          .createCompany(vm.company)
          .then(function (res) {
            $toastr.success(
              $translationService.getTranslationController(
                "Company created successfully",
                "Empresa creada con éxitocreada",
                "Empresa criada com sucesso"
              )
            );
            vm.loading = true;
            $mdDialog.hide(res.data);
          })
          .catch(function (err) {
            vm.loading = true;
            $toastr.error(err.data);
            console.error("err@createCompany", err);
          });
      }

      if (vm.uploaderLogo.queue.length > 0) {
        vm.uploaderLogo.uploadAll();
      }

      if (vm.uploaderDocs.queue.length > 0) {
        vm.uploaderDocs.uploadAll();
      }
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    function getCompanyByID() {
      vm.loading = true;
      $ethicalPortalFactory
        .getAllCompanies()
        .then(function (res) {
          vm.company = Object.assign(vm.company, res.data[0]);
          vm.event = "Update";

          if (vm.company.complaintForm === null) vm.company.complaintForm = [];
          else if (typeof vm.company.complaintForm === "string")
            vm.company.complaintForm = JSON.parse(vm.company.complaintForm);

          if (vm.company.complaintTypes === null)
            vm.company.complaintTypes = [];
          else if (typeof vm.company.complaintTypes === "string")
            vm.company.complaintTypes = JSON.parse(vm.company.complaintTypes);

          // console.log("vm.company", vm.company);
          vm.complaintForm = vm.company.complaintForm;
          vm.loading = false;
        })
        .catch(function (err) {
          console.error("err@getCompanyByID", err);
          vm.loading = true;
          // $toastr.error(err.data);
        });
    }

    vm.uploaderLogo.filters.push({
      name: "Extensions",
      fn: function (item, options) {
        var allowedType = ["text/csv", "image/jpeg", "image/png", "image/jpeg"];

        if (allowedType.indexOf(item.type) === -1) {
          $toastr.error("Archivo no permitido");
        }

        return allowedType.indexOf(item.type) !== -1;
      },
    });

    vm.uploaderLogo.filters.push({
      name: "Size",
      fn: function (item, options) {
        var maxSize = 31457280;
        var size = item.size;

        if (item.size >= 31457280) {
          var msg = $translationService.getTranslationController(
            "El archivo supera el límite de 30Mb",
            "The file exceeds the 30Mb limit",
            "O arquivo excede o limite de 30Mb"
          );
          toastr.error(msg);
        }

        return item.size < 31457280;
      },
    });

    vm.uploaderLogo.onErrorItem = function (
      fileItem,
      response,
      status,
      headers
    ) {
      if (response === "fileDuplicate") {
        var msg = $translationService.getTranslationController(
          "No se ha podido cargar, archivo duplicado en el sistema.",
          "Unable to load, duplicate file in the system.",
          "Não é possível carregar, duplicar arquivo no sistema."
        );
        $toastr.error(msg);
      } else {
        if (status == 403) {
          $toastr.error(
            $translationService.getTranslationController(
              "Usuario no autorizado.",
              "Unauthorized User.",
              "Usuário não autorizado."
            )
          );
        } else {
          $toastr.error(
            $translationService.getTranslationController(
              "No se ha podido cargar el archivo.",
              "The file could not be loaded.",
              "O arquivo não pôde ser carregado."
            )
          );
        }
      }
    };

    vm.uploaderLogo.onSuccessItem = function (item, response, status, headers) {
      if (status) {
        var msg = $translationService.getTranslationController(
          "Archivo cargado exitosamente",
          "File successfully loaded",
          "Arquivo carregado com sucesso"
        );
        $toastr.success(msg);
        // obtenerArchivosTabFn(vm.tab);
      }
    };

    vm.uploaderDocs.filters.push({
      name: "Extensions",
      fn: function (item, options) {
        var allowedType = [
          "text/csv",
          "image/jpeg",
          "image/png",
          "image/jpeg",
          "application/pdf",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "application/vnd.ms-powerpoint",
          "application/vnd.openxmlformats-officedocument.presentationml.presentation",
          "application/vnd.ms-excel",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ];

        if (allowedType.indexOf(item.type) === -1) {
          $toastr.error("Archivo no permitido");
        }

        return allowedType.indexOf(item.type) !== -1;
      },
    });

    vm.uploaderDocs.filters.push({
      name: "Size",
      fn: function (item, options) {
        var maxSize = 31457280;
        var size = item.size;

        if (item.size >= 31457280) {
          var msg = $translationService.getTranslationController(
            "El archivo supera el límite de 30Mb",
            "The file exceeds the 30Mb limit",
            "O arquivo excede o limite de 30Mb"
          );
          toastr.error(msg);
        }

        return item.size < 31457280;
      },
    });

    vm.uploaderDocs.onErrorItem = function (
      fileItem,
      response,
      status,
      headers
    ) {
      if (response === "fileDuplicate") {
        var msg = $translationService.getTranslationController(
          "No se ha podido cargar, archivo duplicado en el sistema.",
          "Unable to load, duplicate file in the system.",
          "Não é possível carregar, duplicar arquivo no sistema."
        );
        $toastr.error(msg);
      } else {
        if (status == 403) {
          $toastr.error(
            $translationService.getTranslationController(
              "Usuario no autorizado.",
              "Unauthorized User.",
              "Usuário não autorizado."
            )
          );
        } else {
          $toastr.error(
            $translationService.getTranslationController(
              "No se ha podido cargar el archivo.",
              "The file could not be loaded.",
              "O arquivo não pôde ser carregado."
            )
          );
        }
      }
    };

    vm.uploaderDocs.onSuccessItem = function (item, response, status, headers) {
      if (status) {
        var msg = $translationService.getTranslationController(
          "Archivo cargado exitosamente",
          "File successfully loaded",
          "Arquivo carregado com sucesso"
        );
        $toastr.success(msg);
      }
    };

    vm.downloadDocument = function (doc) {
      $ethicalPortalFactory
        .downloadDocument(doc)
        .then(function (res) {
          $toastr.success(
            $translationService.getTranslationController(
              "File downloaded successfully",
              "Archivo descargado con éxito",
              "Arquivo baixado com sucesso"
            )
          );
        })
        .catch(function (err) {
          $toastr.error(err.data);
        });
    };

    vm.deleteDoc = function (doc) {
      var confirm = $mdDialog
        .confirm()
        .multiple(true)
        .title(
          $translationService.getTranslationController(
            "Delete document",
            "Eliminar documento",
            "Excluir documento"
          )
        )
        .textContent(
          $translationService.getTranslationController(
            "Are you sure you want to delete this document?",
            "¿Estás seguro de que deseas eliminar este documento?",
            "Tem certeza de que deseja excluir este documento?"
          )
        )
        .ok(
          $translationService.getTranslationController(
            "Delete",
            "Eliminar",
            "Excluir"
          )
        )
        .cancel(
          $translationService.getTranslationController(
            "Cancelar",
            "Cancel",
            "Cancelar"
          )
        );

      $mdDialog.show(confirm).then(function () {
        $ethicalPortalFactory
          .deleteDocument(doc)
          .then(function (res) {
            var msg = $translationService.getTranslationController(
              "Document deleted successfully",
              "Documento eliminado con éxito",
              "Documento excluído com sucesso"
            );
            $toastr.success(msg);

            vm.company.documentList = vm.company.documentList.filter(function (
              document
            ) {
              return document != doc;
            });

            getCompanyByID();
          })
          .catch(function (err) {
            // console.log("err@deleteDocument", err);
            $toastr.error(err.data);
          });
      });
    };

    vm.addComplaintType = function () {
      var clone = angular.copy(complainType);
      vm.company.complaintTypes.push(clone);
    };

    vm.removeComplaintType = function (index) {
      vm.company.complaintTypes.splice(index, 1);
    };

    vm.toggleActiveType = function (index) {
      // vm.company.complaintTypes.forEach(function (type) {
      //   type.active = false;
      // });
      vm.company.complaintTypes[index].active =
        !vm.company.complaintTypes[index].active;
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller(
      "EthicalPortalCompanyController",
      EthicalPortalCompanyController
    );

  EthicalPortalCompanyController.$inject = [
    "$scope",
    "$rootScope",
    "$stateParams",
    "$state",
    "EthicalPortalFactory",
    "toastr",
    "$mdDialog",
    "translationService",
  ];

  function EthicalPortalCompanyController(
    $scope,
    $rootScope,
    $stateParams,
    $state,
    $ethicalPortalFactory,
    $toastr,
    $mdDialog,
    $translationService
  ) {
    var vm = this;
    vm.loading = true;
    vm.loadingLogo = true;
    vm.error = false;
    vm.selectedTab = undefined;

    vm.company = {};
    vm.companyLogo = "./assets/images/avatar.png";

    vm.manageCompany = function () {
      $mdDialog
        .show({
          controller: "EthicalPortalCompanyDialogController",
          controllerAs: "ctrl",
          templateUrl: "app/ethical-portal/dialog/company-dialog.html",
          parent: angular.element(document.body),
          clickOutsideToClose: false,
          locals: {
            companyId: vm.company.id,
          },
          multiple: true,
        })
        .then(function (response) {
          init();
        });
    };

    function init() {
      vm.error = false;
      vm.loading = true;

      $ethicalPortalFactory
        .getAllCompanies()
        .then(function (response) {
          vm.company = response.data[0];

          if (vm.company.complaintForm === null) vm.company.complaintForm = [];
          else if (typeof vm.company.complaintForm === "string")
            vm.company.complaintForm = JSON.parse(vm.company.complaintForm);
          else {
          }

          if (vm.company.complaintForm === null) vm.company.complaintForm = [];
          else if (typeof vm.company.complaintForm === "string")
            vm.company.complaintForm = JSON.parse(vm.company.complaintForm);
          else {
          }

          vm.company.documentList = JSON.parse(vm.company.documentList);

          console.log("Company data:", vm.company);

          if (
            vm.company.complaintForm &&
            Array.isArray(vm.company.complaintForm) &&
            vm.company.complaintForm.length > 0
          ) {
            var old = false;
            if (vm.company.complaintForm[0]) {
              var oldkeys = ["inputs", "sectionName"];
              for (var key in vm.company.complaintForm[0]) {
                if (
                  Object.prototype.hasOwnProperty.call(
                    vm.company.complaintForm[0],
                    key
                  )
                ) {
                  if (oldkeys.includes(key)) {
                    old = true;
                    break;
                  }
                }
              }
            }

            if (old) {
              var newComplaintForm = [];
              vm.company.complaintForm.forEach(function (form, index) {
                if (angular.isDefined(form.sectionName)) {
                  var newForm = {
                    id: new Date().getTime(),
                    form: [form],
                    name: "Formulario " + (index + 1),
                    active: true,
                    disclaimer: "...",
                    descriptionField: "...",
                    required_user_data: true,
                    complaintRatification: false,
                  };
                  newComplaintForm.push(newForm);
                } else {
                  newComplaintForm.push(form);
                }
              });
              console.log("Company complaint form:", newComplaintForm);

              $ethicalPortalFactory
                .updateCompanyComplaintForm(newComplaintForm)
                .then(function (res) {
                  vm.selectedTab = 0;
                  vm.company.complaintForm = newComplaintForm;

                  var copy = angular.copy(vm.company);
                  copy.documentList = JSON.stringify(vm.company.documentList);
                  copy.complaintTypes = JSON.stringify([]);
                  copy.complaintForm = JSON.stringify(newComplaintForm);
                  copy.disclaimer = "";
                  copy.descriptionField = "";

                  $ethicalPortalFactory.updateCompany(copy);
                  vm.error = false;
                  vm.loading = false;

                  console.log("Updated company complaint form:", res.data);
                })
                .catch(function (err) {
                  console.error("Error updating company complaint form:", err);
                });
            } else {
              vm.selectedTab = 0;
              vm.error = false;
              vm.loading = false;
              console.log("No complaint forms found for the company.");
            }
          } else {
            vm.selectedTab = 0;
            vm.error = false;
            vm.loading = false;
            console.log("No complaint forms found for the company.");
          }

          $ethicalPortalFactory
            .getLogoCompany()
            .then(function (res) {
              vm.companyLogo = res.data;
              vm.loadingLogo = false;
            })
            .catch(function (err) {
              console.error(err);
            });
        })
        .catch(function (error) {
          console.error(error);
          vm.error = true;
          vm.loading = false;
        });
    }

    init();

    vm.addComplaintForm = function () {
      if (!vm.company.complaintForm) {
        vm.company.complaintForm = [];
      }

      var next = vm.company.complaintForm.length + 1;
      vm.company.complaintForm.push({
        id: new Date().getTime(),
        name: "Formulario " + next,
        required_user_data: true,
        active: true,
        descriptionField: "...",
        disclaimer: "...",
        complaintRatification: false,
        form: [
          {
            id: 0,
            sectionName: "Section 01",
            inputs: [
              {
                id: 0,
                name: "text",
                type: "text",
                answer: "",
                options: [],
                tooltip: "",
                required: false,
                maxlength: 100,
                answer_is_issue_description: false,
              },
            ],
          },
        ],
      });
    };

    vm.updateCompanyForm = function () {
      $ethicalPortalFactory
        .updateCompanyComplaintForm(vm.company.complaintForm)
        .then(function (res) {
          $toastr.success(
            $translationService.getTranslationController(
              "Form updated successfully",
              "Formulario actualizado con éxito",
              "Formulário atualizado com sucesso"
            )
          );
        })
        .catch(function (err) {
          $toastr.error(err.data);
          console.error("err@updateCompany", err);
        });
    };

    vm.deleteCompanyForm = function () {
      // console.log("Deleting form with id:", vm.selectedTab);
      var confirm = $mdDialog
        .confirm()
        .title("¿Estás seguro de que deseas eliminar este formulario?")
        .textContent("Esta acción no se puede deshacer.")
        .ariaLabel("Eliminar formulario")
        .targetEvent(event)
        .ok("Sí, eliminar")
        .cancel("Cancelar");

      $mdDialog.show(confirm).then(
        function () {
          if (
            vm.company.complaintForm &&
            vm.company.complaintForm.length > vm.selectedTab
          ) {
            vm.company.complaintForm.splice(vm.selectedTab, 1);
            // Ajustar el índice seleccionado si es necesario
            if (vm.selectedTab >= vm.company.complaintForm.length) {
              vm.selectedTab = Math.max(0, vm.company.complaintForm.length - 1);
            }
            // Guardar los cambios después de eliminar el formulario
            vm.updateCompanyForm();
          }
        },
        function () {
          // Cancelled
        }
      );
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller(
      "EthicalPortalCompaniesController",
      EthicalPortalCompaniesController
    );

  EthicalPortalCompaniesController.$inject = [
    "$scope",
    "$rootScope",
    "$stateParams",
    "$state",
    "EthicalPortalFactory",
    "toastr",
    "$mdDialog",
  ];

  function EthicalPortalCompaniesController(
    $scope,
    $rootScope,
    $stateParams,
    $state,
    $ethicalPortalFactory,
    $toastr,
    $mdDialog
  ) {
    console.log("EthicalPortalCompaniesController");
    var vm = this;
    vm.loading = false;
    
    vm.companies = [];
    
    vm.manageCompany = function (id) {
      $mdDialog.show({
        controller: "EthicalPortalCompanyDialogController",
        controllerAs: "ctrl",
        templateUrl: "app/ethical-portal/dialog/company-dialog.html",
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals:{
          companyId:id
        }
      }).
      then(function (response) {
        init();
      });
    };

    function init() {
      $ethicalPortalFactory
        .getAllCompanies()
        .then(function (response) {
          vm.companies = response.data;
          // if(vm.companies.length === 1){
          //   $state.go("app.ethical-portal-company", {
          //     id: vm.companies[0].id,
          //   });
          // }
        })
        .catch(function (error) {
          $toastr.error(error)
          console.log(error);
        });
    }

    init();


    

  
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .directive('cepNumberMask', cepNumberMaskController);

  cepNumberMaskController.$inject = ['$locale', '$filter'];
  function cepNumberMaskController($locale, $filter) {
    return {
      restrict: 'EA',
      require: 'ngModel',
      scope: {
        numericType: '=',
      },
      link: function (scope, element, attrs, ngModel) {
        var parseViewValue = function (value) {
          if (!isNaN(value)) {
            var viewValue = value;
            var modelValue = value
              .replaceAll($locale.NUMBER_FORMATS.GROUP_SEP, '')
              .replaceAll($locale.NUMBER_FORMATS.DECIMAL_SEP, '.');

            ngModel.$viewValue = viewValue;
            ngModel.$render();

            return modelValue;
          }
        };

        var formatModelValue = function (value) {
          if (!isNaN(value)) {
            ngModel.$modelValue = value;

            if (scope.numericType === 'double') {
              var valueSplit = value ? value.toString().split('.') : [value];
              var countDecimals =
                valueSplit[1] !== undefined ? valueSplit[1].length : 2;
              return $filter('number')(value, countDecimals);
            }

            return $filter('number')(value);
          }
        };

        ngModel.$parsers.push(parseViewValue);
        ngModel.$formatters.push(formatModelValue);
      },
    };
  }
})();

(function () {
  'use strict';
  // <!-- <span class="file-name"></span> -->

  angular.module('dashboard').directive('inputFile', [
    function () {
      return {
        restrict: 'E',
        scope: {
          ngModel: '=',
          ngDisabled: '=',
          fileTypes: '@',
        },
        template:
          '<div class="input-file">' +
          '<label>' +
          '<span class="button" ng-disabled="ngDisabled">Upload File</span>' +
          '<input type="file" ng-disabled="ngDisabled" id="attached_file"/>' +
          '</label>' +
          '</div>',

        link: function ($scope, element, attrs) {
          var fileInput = element[0].querySelector('[type=file]');
          var btnClass = element[0].querySelector('.button');

          if (attrs.btnClass.indexOf(' ') < 0) {
            btnClass.classList.add(attrs.btnClass);
          } else {
            var classArr = attrs.btnClass.split(' ');
            classArr.forEach(function (item) {
              btnClass.classList.add(item);
            });
          }
          // var fileName = element[0].querySelector('.file-name')
          // fileName.innerHTML = 'No file chosen'

          if ($scope.fileTypes) {
            fileInput.setAttribute('accept', $scope.fileTypes);
          }
          element.bind('change', function () {
            $scope.ngModel.path = fileInput.value;
            $scope.ngModel.info = fileInput.files;
            //console.log('changed: ', $scope.ngModel)
            // fileName.innerHTML = fileInput.files[0].name
          });
        },
      };
    },
  ]);
})();

(function () {
    'use strict';

    angular.module("dashboard")
        .directive('inputCounter', [function () {
            return {
                restrict: 'E',
                scope: { value: '=value' },
                template: '<a href="javascript:;" class="counter-minus" ng-click="minus()">-</a>' +
                    '<input type="text" class="counter-field" ng-model="value" ng-change="changed()" aria-label="input-counter" ng-readonly="readonly">' +
                    '<a  href="javascript:;" class="counter-plus" ng-click="plus()">+</a>',

                link: function (scope, element, attributes) {
                    // Make sure the value attribute is not missing.
                    if (angular.isUndefined(scope.value)) {
                        throw "Missing the value attribute on the counter directive.";
                    }

                    var min = angular.isUndefined(attributes.min) ? null : parseInt(attributes.min);
                    var max = angular.isUndefined(attributes.max) ? null : parseInt(attributes.max);
                    var step = angular.isUndefined(attributes.step) ? 1 : parseInt(attributes.step);

                    element.addClass('counter-container');

                    // If the 'editable' attribute is set, we will make the field editable.
                    scope.readonly = angular.isUndefined(attributes.editable) ? true : false;

                    /**
                     * Sets the value as an integer.
                     */
                    var setValue = function (val) {
                        scope.value = parseInt(val);
                    }

                    // Set the value initially, as an integer.
                    setValue(scope.value);

                    /**
                     * Decrement the value and make sure we stay within the limits, if defined.
                     */
                    scope.minus = function () {
                        if (min && (scope.value <= min || scope.value - step <= min) || min === 0 && scope.value < 1) {
                            setValue(min);
                            return false;
                        }
                        setValue(scope.value - step);
                    };

                    /**
                     * Increment the value and make sure we stay within the limits, if defined.
                     */
                    scope.plus = function () {
                        if (max && (scope.value >= max || scope.value + step >= max)) {
                            setValue(max);
                            return false;
                        }
                        setValue(scope.value + step);
                    };

                    /**
                     * This is only triggered when the field is manually edited by the user.
                     * Where we can perform some validation and make sure that they enter the
                     * correct values from within the restrictions.
                     */
                    scope.changed = function () {
                        // If the user decides to delete the number, we will set it to 0.
                        if (!scope.value) setValue(0);

                        // Check if what's typed is numeric or if it has any letters.
                        if (/[0-9]/.test(scope.value)) {
                            setValue(scope.value);
                        }
                        else {
                            setValue(scope.min);
                        }

                        // If a minimum is set, let's make sure we're within the limit.
                        if (min && (scope.value <= min || scope.value - step <= min)) {
                            setValue(min);
                            return false;
                        }

                        // If a maximum is set, let's make sure we're within the limit.
                        if (max && (scope.value >= max || scope.value + step >= max)) {
                            setValue(max);
                            return false;
                        }

                        // Re-set the value as an integer.
                        setValue(scope.value);
                    };
                }
            };
        }]);

})();
(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('TableDataController', TableDataController);

  TableDataController.$inject = ['$state'];
  function TableDataController($state) {
    var vm = this;
    vm.isLoading = true;

    vm.init = function () {
      vm.schemaName = $state.params.schemaName;
      vm.tableName = $state.params.tableName;
      vm.isLoading = false;
    };
    vm.init();

    vm.toSchemaList = function () {
      $state.go('app.schemasTables', {
        schemaName: vm.schemaName,
      });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('SchemasTablesController', SchemasTablesController);

  SchemasTablesController.$inject = [
    '$scope',
    '$rootScope',
    'translationService',
    '$state',
    'toastr',
    '$mdDialog',
    'DataTableFactory',
  ];

  function SchemasTablesController(
    $scope,
    $rootScope,
    $translationService,
    $state,
    toastr,
    $mdDialog,
    $dataTableFactory
  ) {
    var vm = this;
    $translationService.getTranslation(vm, 'data-management');

    vm.schemaName = null;
    vm.isLoading = false;
    vm.schemas = [];

    vm.init = function () {
      $rootScope.loading = true;
      vm.isLoading = true;
      var promises = [];
      if ($state.params.schemaName) {
        vm.schemaName = $state.params.schemaName;
        promises.push(_getAllTablesBySchemasName($state.params.schemaName));
      }

      Promise.allSettled(promises)
        .then(function (res) {
          vm.schemas = res[0].value;
        })
        .catch(function (err) {
          console.error('Error@promises', err);
        });
    };
    vm.init();

    vm.goToSchemaList = function () {
      $state.go('app.dataManagement');
    };

    vm.showTable = function (table) {
      $state.go('app.tableData', {
        schemaName: table.schemaName,
        tableName: table.tableName,
      });
    };

    vm.tableManagement = function (table) {
      $mdDialog
        .show({
          controller: 'DialogTableManagement',
          controllerAs: 'ctrl',
          templateUrl:
            'app/data-management/dialog-table-management/dialog-table-management.html',
          locals: {
            table: table || null,
          },
          parent: angular.element(document.body),
          // targetEvent: ev,
          hasBackdrop: true,
          clickOutsideToClose: true,
          escapeToClose: true,
          focusOnOpen: true,
        })
        .then(function () {
          vm.init();
        });
    };

    vm.confirmDeleteTable = function (table) {
      var confirm = $mdDialog
        .confirm()
        .title('do you want to delete this table??')
        .textContent('cannot be recovered')
        .ariaLabel('deleteTable')
        .ok('Yes')
        .cancel('Cancel');

      $mdDialog.show(confirm).then(function () {
        _deleteTable(table.tableName);
      });
    };

    vm.showShareEntityDialog = function (selectedItem) {
      $mdDialog.show({
        controller: 'ShareEntityController',
        templateUrl: 'app/acl/component/dialog-share-entity.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          selectedItem: {
            id: selectedItem.id,
            resource: 'data-management',
            name: "",
          },
          actions: ['read', 'update', 'delete', 'share'],
        },
      });
    };

    function _deleteTable(tableName) {
      $rootScope.loading = true;
      $dataTableFactory
        .removeTable(tableName, vm.schemaName)
        .then(function (res) {
          toastr.success('Table Delete ' + tableName);
          vm.schemaTables = vm.schemaTables.filter(function (e) {
            return e.tableName != tableName;
          });
        })
        .catch(function (err) {
          console.error('Error@removeTable', err);
          toastr.error(err.error);
        }).finally(function () {
        $rootScope.loading = false;
      });
    }

    function _getAllTablesBySchemasName(schemaName) {
      $rootScope.loading = true;
      $dataTableFactory
        .getAllTablesBySchemasName(schemaName)
        .then(function (res) {
          vm.schemaName = schemaName;
          vm.schemaTables = res.sort(function (a, b) {
            return a.tableName.localeCompare(b.tableName);
          });
        })
        .catch(function (err) {
          console.error('Error@getAllTablesBySchemasName', err);
        }).finally(function () {
        $rootScope.loading = false;
      });
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller("DialogTableManagement", DialogTableManagement);

  DialogTableManagement.$inject = [
    "$state",
    "translationService",
    "$mdDialog",
    "table",
    "toastr",
    "DataTableFactory",
    "PermissionsFactory",
  ];
  function DialogTableManagement(
    $state,
    $translationService,
    $mdDialog,
    table,
    toastr,
    $dataTableFactory,
    PermissionsFactory
  ) {
    var tableName, schemaName;
    var vm = this;
    $translationService.getTranslation(vm, "data-management");
    vm.isLoading = true;
    vm.tableId = table ? table.id : null;
    vm.table = {
      columns: [],
      tableName: "",
      schemaName: $state.params.schemaName || "",
      comment: "",
    };

    vm.tab = 0;
    vm.isCreation = true;
    vm.modeTranslation = "";
    vm.colTypes = [
      "string",
      "long",
      "integer",
      "double",
      "numeric",
      "boolean",
      "date",
      "timestamp",
      "time",
      "json",
      "uuid",
    ];

    vm.columnDef = {
      colName: "",
      colType: "",
      notNull: "",
      primaryKey: false,
      withTextSearch: false,
    };
    vm.showBtnSaveAndOpen = false;

    vm.schemasOptions = [];
    vm.schemaName = $state.params.schemaName || "";
    if ($state.params.schemaName) {
      vm.showBtnSaveAndOpen = true;
    }

    vm.sortableOptions = {
      items: "tr",
      placeholder: "app",
      connectWith: ".container-boxplot",
    };

    vm.init = function () {
      vm.isLoading = true;
      var promises = [_getAllSchemas()];

      if (table) {
        vm.isCreation = false;
        tableName = table.tableName;
        schemaName = table.schemaName;
        promises.push(_getTable(table.tableName, table.schemaName));
      } else {
        vm.isCreation = true;
      }

      Promise.allSettled(promises)
        .then(function (res) {
          vm.schemasOptions = res[0].value;
          if (table) vm.table = res[1].value;

          vm.isLoading = false;
          vm.modeTranslation = vm.isCreation
            ? vm.translation.create
            : vm.translation.update;
        })
        .catch(function (err) {
          console.error("Error@Promises", err);
        });
    };
    vm.init();

    vm.showTable = function () {
      $state.go("app.tableData", {
        schemaName: vm.table.schemaName,
        tableName: vm.table.tableName,
      });
    };

    function columnsValidation(col) {
      return col.colType && col.colName;
    }

    vm.save = function (autoOpen) {
      if (vm.table.tableName === "") {
        toastr.error(
          vm.translation.tableName + ": " + vm.translation.fieldIsRequied
        );
        return;
      }
      if (vm.table.schemaName === "") {
        toastr.error(
          vm.translation.schemaName + ": " + vm.translation.fieldIsRequied
        );
        return;
      }
      if (vm.table.columns.length === 0) {
        toastr.error(vm.translation.addColumnsToTable);
        vm.tab = 1;
        return;
      } else if (!vm.table.columns.every(columnsValidation)) {
        toastr.error(vm.translation.columnDefInvalid);
        return;
      }

      vm.table.columns = vm.table.columns.map(function (col, index) {
        col.order = index + 1;
        return col;
      });

      if (vm.isCreation) {
        $dataTableFactory
          .createTable(vm.table)
          .then(function (res) {
            toastr.success(vm.translation.tableCreatedSuccessfully);

            PermissionsFactory.addPermission(
              "data-management",
              vm.table.schemaName + "." + vm.table.tableName,
              "all",
              true
            );

            $mdDialog.hide(vm.table);
            if (autoOpen) vm.showTable();
          })
          .catch(function (err) {
            console.error("Error@updateTable", err);
            toastr.error(err.message);
          });
      } else {
        $dataTableFactory
          .updateTable(tableName, schemaName, vm.table)
          .then(function (res) {
            $mdDialog.hide(vm.table);
            if (autoOpen) vm.showTable();
          })
          .catch(function (err) {
            console.error("Error@updateTable", err);
            toastr.error(err.error);
          });
      }
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.validatePermission = function () {
      if (
        vm.isCreation === true &&
        PermissionsFactory.hasPermission("data-management:create")
      ) {
        return true;
      } else if (
        vm.isCreation === false &&
        PermissionsFactory.hasPermission(
          "data-management#" + vm.tableId + ":update"
        )
      ) {
        return true;
      } else {
        return false;
      }
    };

    vm.addCol = function () {
      var newColumn = angular.copy(vm.columnDef);
      newColumn.order = vm.table.columns.length + 1;
      vm.table.columns.push(newColumn);
    };

    vm.delCol = function (index) {
      vm.table.columns.splice(index, 1);
    };

    vm.colTypeChange = function (index) {
      console.log("colTypeChange", index);
      var col = vm.table.columns[index];

      if (col.colType != "string" || col.colType != "json")
        col.withTextSearch = false;
      console.log("col", col);
    };

    function _getTable(tableName, schemaName) {
      return new Promise(function (resolve, reject) {
        $dataTableFactory
          .getTable(tableName, schemaName)
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            console.error("Error@getTable", err);
            reject(err);
          });
      });
    }
    function _getAllSchemas() {
      return new Promise(function (resolve, reject) {
        $dataTableFactory
          .getAllSchemas()
          .then(function (res) {
            resolve(res);
          })
          .catch(function (err) {
            console.error("Error@getAllSchemas", err);
            reject(err);
          });
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('dashboard').service('IssuesService', IssuesService);

  IssuesService.$inject = ['$filter'];
  function IssuesService($filter) {
    /**
     * Get field name if is primary key
     * @param {boolean} isPrimaryKey
     * @param {string} fieldName
     *
     * @returns {string}
     */
    this.parseFieldName = function (isPrimaryKey, fieldName) {
      return (isPrimaryKey ? '#' : '') + fieldName;
    };

    this.parseSchema = function (_schema, _format) {
      _schema.schema = angular.fromJson(_schema.schema);
      if (typeof _schema.schema.definitions === 'string') {
        _schema.schema.definitions = angular.fromJson(
          _schema.schema.definitions
        );
        _schema.schema.definitions[_schema.name].properties = angular.fromJson(
          _schema.schema.definitions[_schema.name].properties
        );
      }
      var schema = _schema.schema.definitions[_schema.name].properties;

      angular.forEach(schema, function (col, index) {
        schema[index].required =
          _schema.schema.definitions[_schema.name].required.indexOf(index) > -1
            ? true
            : false;
        schema[index].pk =
          _schema.schema.definitions[_schema.name].required.indexOf(
            '#' + index
          ) > -1
            ? true
            : false;

        if (_format) {
          var colName = (schema[index].pk ? '#' : '') + index;
          schema[index].inputFormat = _format[colName]
            ? _format[colName].inputFormat || ''
            : '';
          schema[index].outputFormat = _format[colName]
            ? _format[colName].outputFormat || ''
            : '';
        }
      });
      schema = $filter('orderObjectBy')(schema, 'order');
      return schema;
    };

    /**
     *
     * @param {Record<string, any>[]} data
     */
    this.parseData = function (data) {
      var parsedData = data.map(function (e) {
        e.head = angular.fromJson(e.head);
        return e.head;
      });
      return parsedData;
    };
  }
})();

"use strict";

var app = angular.module("dashboard");
app.component("tableDataCard", {
  templateUrl: "app/custom-reports/table-card/table-card.html",
  controllerAs: "ctrl",
  bindings: {
    listId: "=",
    schemaId: "=",
    customReport: "=",
    clickRow: "&",
    removeRow: "&",
    html: "=",
    schemasFormats: "=",
  },
  controller: TableDataCard,
});

TableDataCard.$inject = [
  "$scope",
  "$rootScope",
  "$state",
  "$stateParams",
  "$mdDialog",
  "toastr",
  "formats",
  "SchemasService",
  "listService",
  "translationService",
  "tableListConstants",
  "InputListsFactory",
  "ConfigurationFactory",
  "cellTemplateFormatService",
  "IssuesFactory",
  "listExporterService",
  "$localStorageService"
];

function TableDataCard(
  $scope,
  $rootScope,
  $state,
  $stateParams,
  $mdDialog,
  $toastr,
  $formats,
  $schemasService,
  $listService,
  $translationService,
  $tableListConstants,
  $inputListsFactory,
  $ConfigurationFactory,
  $listExporterService,
  $uiGridConstants,
  $cellTemplateFormatService,
  $issuesFactory,
  $permissionsFactory,
  $localStorageService
) {
  $translationService.getTranslation($scope, "input-list");
  $rootScope.loading = false;

  var vm = this;
  vm.schemasFormat = [];
  vm.list = {};
  vm.dataList = [];
  vm.showTable = false;
  vm.columns = [];
  vm.schema = [];
  vm.groups = [];
  vm.showTable = false;
  vm.shouldShowFilters = false;
  vm.filters = [];
  vm.tableIsLoading = false;

  vm.showHtmlCard = function (row) {
    var tab = {
      row: angular.copy(row),
      schema: angular.copy(vm.schema),
      schemaId: vm.list.schema.id,
    };
    vm.clickRow(tab);
  };

  vm.hoveredRow = null;
  vm.onHover = function (row) {
    vm.hoveredRow = row;
  };

  vm.clearHoveredRow = function () {
    vm.hoveredRow = null;
  };

  vm.gridOptions = {
    rowTemplate:
      '<div ng-click="grid.appScope.ctrl.showHtmlCard(row.entity)" ng-mouseover="grid.appScope.ctrl.onHover(row.entity)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>',
    minimumColumnSize: 100,
    useExternalPagination: true,
    paginationPageSizes: [5, 10, 25, 50, 100],
    paginationPageSize: 100,
    totalItems: 0,
    useExternalSorting: true,
    showGridFooter: true,
    showColumnFooter: true,
    onRegisterApi: function (gridApi) {
      $scope.gridApi = gridApi;
      gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
        vm.filters.pagination.page = newPage;
        vm.filters.pagination.itemsPerPage = pageSize;

        _getListData();
      });
      gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        if (sortColumns[0]) {
          var colField = sortColumns[0].field.split(".")[0];

          vm.filters.pagination.sortBy = colField;
          vm.filters.pagination.sort = sortColumns[0].sort.direction;
        } else {
          vm.filters.pagination.sortBy = null;
        }

        _getListData();
      });
    },
  };

  $scope.params = {
    listId: $stateParams.listId,
    filters: {
      luceneQueryId: $stateParams.luceneQueryId,
      predicates: JSON.parse($stateParams.filters),
    },
  };

  function _getColumnDefinition(key) {
    key = key.indexOf("#") === 0 ? key.substring(1) : key;

    return vm.schema[key];
  }

  function _init() {
    var promises = [
      $inputListsFactory.getInputList(vm.listId),
      $inputListsFactory.getInputListFilters(vm.listId),
      _getConfigFormatSchema(),
    ];

    var lsFilters = "custom-report-filters-" + vm.customReport.id;
    var filtersInLS = $localStorageService.getItem(lsFilters);
    if (filtersInLS) {
      vm.filters = filtersInLS;
    } else {
      vm.filters = $tableListConstants.defaultFiltersTemplate;
    }

    Promise.allSettled(promises)
      .then(function (res) {
        vm.list = res[0].value;
        var hasSettings = res[0] && res[0].settings;
        var schemaSettings = hasSettings && angular.fromJson(res[0].settings);
        vm.schema = $schemasService.parseSchema(vm.list.schema, schemaSettings);
        vm.columnfilters = res[1].value;
        vm.schemasFormat = res[2].status == "fulfilled" ? res[2].value : [];
      })
      .then(function () {
        _renderList();
        _setColumnDefs()
          .then(function () {
            if (
              $scope.params.filters &&
              $scope.params.filters != null &&
              $scope.params.filters != "null" &&
              $scope.params.filters.predicates
            ) {
              _setDefaultFilters();
            }

            _getListData();
          })
          .catch(function (err) {
            $toastr.warning(
              $translationService.getTranslationController(
                "No hay columnas visibles en el esquema.",
                "There is no columns visible on schema",
                "Não há colunas visíveis no esquema"
              )
            );
            $rootScope.loading = false;
          });
      })
      .catch(function (error) {
        console.error("Error@getInputList/getInputListFilters", error);
        $toastr.error(error.message);
        $rootScope.loading = false;
      });
  }
  _init();

  function _setDefaultFilters() {
    vm.filters.predicates = [];
    $scope.params.filters.predicates.forEach(function (filter) {
      if (filter.field === "time") {
        filter.value = moment(filter.value).format("HH:MM:SS");
      }

      if (filter.field == "id") {
        vm.filters.predicates.push({
          label: filter.field,
          fieldName: filter.field,
          operation: "IN",
          values: filter.values,
          value: null,
          valuesLabels: null,
        });
      } else {
        var colDef = _getColumnDefinition(filter.field);
        if (typeof filter.value == "object") {
          filter.value.forEach(function (item) {
            vm.filters.predicates.push({
              label: colDef.displayName || colDef.key,
              fieldName: filter.field,
              operation: "EQUAL",
              values: null,
              value: item,
              valuesLabels: null,
            });
          });
        } else {
          vm.filters.predicates.push({
            label: colDef.displayName || colDef.key,
            fieldName: filter.field,
            operation: "EQUAL",
            values: null,
            value: filter.value,
            valuesLabels: null,
          });
        }
      }
    });
    vm.isFiltered = true;
  }

  function _setColumnDefs() {
    return new Promise(function (resolve, reject) {
      vm.gridOptions.columnDefs = [];

      angular.forEach(vm.schema, function (col, key) {
        if (col.visible) {
          var field = col.pk ? "#" + key : key;

          var colDef = {
            order: col.order,
            name: key,
            displayName: col.displayName || key,
            field: field,
            cellFilter: $tableListConstants.cellFilters[col.type],
            // General column properties
            enableColumnMenu: true,
            enableSorting: true,
            enableHiding: false,
            aux: col,
            menuItems: [
              {
                title: $translationService.getTranslationController(
                  "Reemplazar",
                  "Replace",
                  "Substituir"
                ),
                icon: "ui-grid-icon-pencil",
                shown: function () {
                  var hasFilters = vm.columnfilters.find(function (e) {
                    return e.field.replace("#", "") == col.key || e.label == col.displayName;
                  });

                  return hasFilters ? true : false;
                },
                action: function ($event) {
                  this.context.showReplaceDialog($event, col);
                },
                context: vm,
              },
              {
                title: $translationService.getTranslationController("Filtrar", "Filter", "Filtro"),
                icon: "ui-grid-icon-filter",
                shown: function () {
                  var hasFilters = vm.columnfilters.find(function (e) {
                    return e.field == col.key || e.label == col.displayName;
                  });

                  return hasFilters ? true : false;
                },
                action: function ($event) {
                  this.context.addFilterTo($event, col);
                },
                context: vm,
              },
            ],
            aggregationHideLabel: true,
            aggregationType:
              col.type == "integer" || col.type == "double"
                ? $uiGridConstants.aggregationTypes.sum
                : null,
            footerCellTemplate:
              col.type == "integer" || col.type == "double"
                ? '<div class="ui-grid-cell-contents" >{{col.getAggregationValue() | number:2 }}</div>'
                : "",
            headerCellTemplate: "app/input-list/templates/header-cell-template.html",
          };
          colDef.cellTemplate = $cellTemplateFormatService.setTemplate(
            colDef,
            col,
            vm.schemasFormat
          );

          vm.gridOptions.columnDefs.push(colDef);
        }
      });

      vm.gridOptions.columnDefs = vm.gridOptions.columnDefs.sort(function (a, b) {
        return a.order - b.order;
      });

      if (vm.gridOptions.columnDefs.length) {
        resolve();
      }
      reject();
    });
  }

  function _getListData() {
    vm.tableIsLoading = true;
    vm.filters.luceneQueryId = $scope.params.filters.luceneQueryId;
    $inputListsFactory
      .getInputListDataFiltered(vm.listId, vm.filters)
      .then(function (res) {
        vm.gridOptions.totalItems = res.pagination.totalRecords;

        vm.dataList = res.data.map(function (e) {
          return {
            dataId: e.dataId,
            body: angular.fromJson(e.body),
          };
        });

        vm.dataList = vm.dataList.map(function (e) {
          e.body.__dataId = e.dataId;
          var body = e.body;
          return body;
        });

        var cols = $listService.getColumns(vm.schema);
        vm.dataList = $listService.unNormalizeData(vm.dataList, cols);

        vm.gridOptions.data = vm.dataList;

        vm.filterlist = vm.dataList;

        _getMetadataList();
        vm.tableIsLoading = false;
      })
      .catch(function (err) {
        console.error("Error@getInputListData", err);
        vm.tableIsLoading = false;
      })
      .finally(function () {
        vm.tableIsLoading = false;
        $scope.loading = false;
      });
  }

  function _getMetadataList() {
    var noGroupTag = $translationService.getTranslationController("otros", "others", "otros");

    $inputListsFactory
      .getInputListMetadata(vm.listId)
      .then(function (res) {
        var mapData = res.columns.map(function (e) {
          var cleanColName = e.name.replace("#", "");

          var col = {
            field: e.name,
            title:
              vm.schema[cleanColName] && vm.schema[cleanColName].displayName
                ? vm.schema[cleanColName].displayName
                : e.name,
            type: e.type,
            show: true,
            group: vm.schema[cleanColName]
              ? angular.isUndefined(vm.schema[cleanColName].group)
                ? noGroupTag
                : vm.schema[cleanColName].group
              : noGroupTag,
            order: vm.schema[cleanColName] ? vm.schema[cleanColName].order : "1",
            sortable: e.name,
            filterable: { type: "text" },
            readonly: e.readonly,
            width: 30,
          };
          return col;
        });

        vm.columns = mapData.sort(function (a, b) {
          return a.order - b.order;
        });

        vm.groups = vm.columns.map(function (ele) {
          if (ele.show === false) return;

          var item = ele.group;
          if (
            typeof item === "string" &&
            item != undefined &&
            item != null &&
            item != "" &&
            item != "null"
          ) {
            return item;
          } else {
            return noGroupTag;
          }
        });

        vm.groups = vm.groups
          .filter(function (e) {
            return e;
          })
          .filter(function (value, index) {
            return vm.groups.indexOf(value) == index;
          });

        $rootScope.loading = false;
      })
      .catch(function (err) {
        console.error("Error@getInputListMetadata", err);
        vm.tableIsLoading = false;
      });
  }

  vm.validatePermission = function (permission) {
    return $permissionsFactory.hasPermission(permission);
  };

  vm.onClickListRow = function (item) {
    if (!vm.validatePermission("list#" + vm.list.listId + ":read")) return;

    var _item = {
      dataId: item.__dataId,
      body: item,
    };
    $mdDialog
      .show({
        controller: "clientCardController",
        controllerAs: "ctrl",
        templateUrl: "app/app-utils/components/client-card/client-card.html",
        clickOutsideToClose: false,
        locals: {
          title: $translationService.getTranslationController(
            "Editor de datos",
            "Data editor",
            "Editor de dados"
          ),
          listId: vm.list.listId,
          inputs: _item,
          inputsTypes: vm.columns,
          groups: vm.groups,
          listSchema: vm.schema,
        },
      })
      .then(function () {
        _init();
      });
  };

  vm.showIssueDialog = function (event, issueUuid) {
    if (!issueUuid || issueUuid === "") return;
    var uuid = issueUuid.split("&")[1] || issueUuid.split("&")[0];
    $rootScope.loading = false;
    var promises = [_getIssuesByUuid(uuid), _getIssuesTypes()];
    Promise.allSettled(promises)
      .then(function (res) {
        var issue = res[0].status == "fulfilled" ? res[0].value : false;
        var issueTypes = res[1].status == "fulfilled" ? res[1].value : [];
        if (issue) {
          issue.cat;
          $mdDialog.show({
            controller: "IssuesDetailDialogController",
            controllerAs: "ctrl",
            templateUrl: "app/dashboard/components/issues-detail-dialog/issues-detail-dialog.html",
            parent: angular.element(document.body),
            targetEvent: null,
            clickOutsideToClose: false,
            multiple: true,
            locals: {
              issueTypes: issueTypes,
              currentIssueType: issueTypes.find(function (e) {
                return e.id == issue.issueType.id;
              }),
              issue: issue,
              issuesToLink: [],
              currentCategory: issue.category,
            },
          });
        } else {
          $toastr.warning(
            $translationService.getTranslationController(
              "No se pudo cargar el issue",
              "Can load issue",
              "Can load issue "
            )
          );
        }
      })
      .finally(function () {
        $rootScope.loading = false;
      });
  };

  vm.getBack = function () {
    if ($stateParams.backTo) $state.go("app." + $stateParams.backTo);
    else $state.go("app.schemasLists");
  };

  function _renderList() {
    var inputList = {
      cols: [],
      types: [],
    };

    angular.forEach(vm.schema, function (col, key) {
      inputList.types[(col.pk ? "#" : "") + key] = col.type;
      var referencedListId = col.metadata ? col.metadata.id : null;
      var colDefinition = _getInputType(
        col.type,
        referencedListId,
        col.autocomplete,
        col.inputFormat,
        col.outputFormat,
        col.readonly
      );
      colDefinition.data = (col.pk ? "#" : "") + key;
      colDefinition.title = key + (col.required || col.pk ? "*" : "");
      inputList.cols.push(colDefinition);
    });

    vm.inputList = inputList;
  }

  function _getInputType(input, list, autocomplete, inputFormat, outputFormat, readonly) {
    var sequentialSourceFn = function (query, process) {
      $inputListsFactory.getInputListData(list, {}, false).then(function (res) {
        var source = res.data.map(function (e) {
          var res = angular.fromJson(e.body);
          if (res.$visible) delete res.$visible;
          return Object.values(res)[0];
        });
        process(source);
      });
    };

    return $listService.getInputType(
      input,
      autocomplete,
      inputFormat,
      outputFormat,
      readonly,
      sequentialSourceFn
    );
  }

  vm.unFilterData = function () {
    vm.filters.predicates = [];
    vm.isFiltered = false;
    _getListData();
  };

  vm.removeFilter = function (index) {
    vm.filters.predicates.splice(index, 1);
    if (!vm.filters.predicates.length) {
      vm.isFiltered = false;
    }
    _getListData();
  };

  vm.addFilterTo = function (event, col) {
    col.name = col.displayName || col.key;
    var selectedColumnFilters = vm.columnfilters.find(function (e) {
      return e.field == col.key || e.label == col.displayName;
    });

    if (!selectedColumnFilters) {
      $toastr.warning(
        $translationService.getTranslationController(
          "No hay filtros disponibles para la columna ",
          "There is no filters available for column ",
          "Não há filtros disponíveis para coluna "
        ) + col.name
      );
      return;
    }

    $mdDialog
      .show({
        controller: "IssuesFiltersDialogController",
        controllerAs: "ctrl",
        templateUrl: "app/dashboard/components/issues-filters-dialog/issues-filters-dialog.html",

        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: false,
        locals: {
          column: col,
          columnFilters: selectedColumnFilters,
        },
      })
      .then(function (predicate) {
        // predicate.value = _formatPredicateValue(col, predicate.value);
        vm.filters.predicates.push(predicate);
        vm.isFiltered = true;

        _getListData();
      });
  };

  // function _formatPredicateValue(col, value) {
  //   console.log(col, value);
  //   if (["date", "time"].includes(col.type))
  //     return moment(value).format($formats.defaults[col.type]);

  //   if (col.type == "timestamp")
  //     return moment(value).format("YYYY-MM-DDTHH:mm:ss.000000000");

  //   return value;
  // }

  vm.showReplaceDialog = function (ev, col) {
    var colTypes = [];
    angular.forEach(vm.columns, function (e) {
      colTypes[e.field] = e.type;
    });

    $inputListsFactory.setSelectedCol((col.pk ? "#" : "") + col.key);

    $mdDialog.show({
      controller: "ListReplaceController",
      templateUrl: "app/input-list/components/list-replace/list-replace.html",
      locals: {
        listId: vm.list.listId,
        cellValue: "",
        colTypes: colTypes,
      },
      parent: angular.element(document.body),
      targetEvent: ev,
      hasBackdrop: false,
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
    });
  };

  vm.parsePredicateValue = function (predicate) {
    console.log("parsePredicateValue", predicate);
    if (vm.schema[predicate.fieldName.replace("#", "")].type == "date") {
      return moment(predicate.value).format("DD-MM-YYYY");
    }
    return predicate.value;
  };

  $scope.$on("listFiltered", function (e, filter) {
    var predicate = {
      fieldName: filter.column,
      label: filter.column,
      operation: "EQUAL",
      value: filter.conditionValue,
      values: null,
      valuesLabels: null,
    };

    vm.filters.predicates.push(predicate);
    vm.isFiltered = true;

    _getListData();
  });

  function _getConfigFormatSchema() {
    return new Promise(function (resolve, reject) {
      $ConfigurationFactory
        .getSchemaFormat()
        .then(function (res) {
          if (res.data.length == 0) {
            resolve([]);
          }
          var schemaMap = res.data.map(function (schema) {
            schema.body = JSON.parse(schema.body);
            return schema;
          });
          resolve(schemaMap);
        })
        .catch(function (err) {
          console.error("Error@getSchemaFormat", err);
          reject(err);
        });
    });
  }

  vm.legacy_exportList = function (ext) {
    $rootScope.loading = false;
    var list = vm.list;

    $toastr.info(
      $translationService.getTranslationController(
        "Exportando lista: ",
        "Exporting list: ",
        "Exportando lista: "
      ) + vm.list.name
    );

    $listExporterService
      .execute(ext, false, list)
      .then(function () {
        $rootScope.loading = false;
        $toastr.success(
          $translationService.getTranslationController(
            "Lista descargadas",
            "List downloaded",
            "Lista baixadas"
          )
        );
      })
      .catch(function (error) {
        $rootScope.loading = false;
        console.error("Error@bulkExportLists", error);
        $toastr.error(
          $translationService.getTranslationController(
            "Se ha producido un error al exportar",
            "An error occurred while exporting",
            "Ocorreu um erro ao exportar"
          )
        );

        $rootScope.loading = false;
      });
  };

  function _getIssuesByUuid(issueUuid) {
    return new Promise(function (resolve, reject) {
      $issuesFactory
        .getIssueByUUID(issueUuid)
        .then(function (res) {
          resolve(res);
        })
        .catch(function (err) {
          console.error("Error@_getIssuesByUuid", err);
          reject(err);
        });
    });
  }

  function _getIssuesTypes() {
    return new Promise(function (resolve, reject) {
      $issuesFactory
        .getIssuesTypes()
        .then(function (res) {
          resolve(res);
        })
        .catch(function (err) {
          console.error("Error@_getIssuesTypes", err);
          reject(err);
        });
    });
  }

  vm.exportList = function (ext, templateOnly) {
    vm.cols = $listService.getColumns(vm.schema);
    vm.baseSchema = $listService.getBaseSchema(vm.schema);
    vm.types = $listService.getColumnsTypes(vm.schema);
    vm.headers = $listService.getHeaders(vm.schema);
    vm.colsToExport = $listService.getColumnsToExport(vm.schema);

    vm.selectedCol = vm.colsToExport[0];
    vm.baseSchema["$dataId"] = null;
    vm.baseSchema["$visible"] = true;

    var listToExport = {
      listId: vm.list.listId,
      name: vm.list.name,
      schema: vm.list.schema,
      headers: vm.headers,
      colsToExport: vm.colsToExport,
      data: [],
    };

    if (templateOnly) {
      $listExporterService.execute(ext, templateOnly, listToExport);
    } else {
      $mdDialog.show({
        controller: ["$mdDialog", exportSelectorController],
        controllerAs: "selCtrl",
        templateUrl: "app/input-list/templates/export-selector.html",
        scope: $scope,
        preserveScope: true,
        clickOutsideToClose: false,
      });

      function exportSelectorController($mdDialog) {
        this.selection = "this";
        this.selectSheet = function (selection) {
          // if (selection == 'all') {
          $rootScope.loading = false;
          var filters = angular.copy(vm.filters);

          filters.exportToCSV = true;

          if (selection == "all") {
            filters.pagination.page = 1;
            filters.pagination.itemsPerPage = 9000000;
          }

          $listExporterService
            .execute(ext, false, vm.list, filters)
            .then(function () {
              $toastr.success(
                $translationService.getTranslationController(
                  "Lista descargada",
                  "List downloaded",
                  "Lista baixada"
                )
              );
            })
            .catch(function (error) {
              console.log("Error@listExporterService", error);
              $toastr.error(
                $translationService.getTranslationController(
                  "Se ha producido un error al exportar",
                  "An error occurred while exporting",
                  "Ocorreu um erro ao exportar"
                )
              );
            })
            .finally(function () {
              $rootScope.loading = false;
            });

          $mdDialog.hide();
        };
        this.abortSelection = function () {
          $mdDialog.cancel();
        };
      }
    }
  };

  vm.reload = function () {
    _getListData();
  };
}

"use strict";

var app = angular.module("dashboard");
app.component("tableCard", {
  templateUrl: "app/custom-reports/table/table-card.html",
  controllerAs: "ctrl",
  bindings: {
    table: "=",
    customReport: "=",
    clickRow: "&",
    html: "=",
    removeRow: "&",
  },
  controller: TableCard,
});

TableCard.$inject = [
  "$scope",
  "$rootScope",
  "$state",
  "$stateParams",
  "$mdDialog",
  "toastr",
  "formats",
  "SchemasService",
  "listService",
  "translationService",
  "tableListConstants",
  "DataTableFactory",
  "ConfigurationFactory",
  "cellTemplateFormatService",
  "IssuesFactory",
  "listExporterService",
  "dataTableService",
  "$localStorageService"
];

function TableCard(
  $scope,
  $rootScope,
  $state,
  $stateParams,
  $mdDialog,
  $toastr,
  $formats,
  $schemasService,
  $listService,
  $translationService,
  $tableListConstants,
  $dataTableFactory,
  $ConfigurationFactory,
  $cellTemplateFormatService,
  $issuesFactory,
  $listExporterService,
  $dataTableService,
  $localStorageService
) {
  var vm = this;
  var configTableColumns = [];
  vm.showSideBar = false;

  var listID = $scope.params && $scope.params.listID ? listID : vm.listId;
  $translationService.getTranslation($scope, "input-list");
  $rootScope.loading = false;

  vm.schemasFormats = [];
  vm.list = {};
  vm.dataList = [];
  vm.showTable = false;
  vm.columns = [];
  vm.schema = [];
  vm.groups = [];
  vm.showTable = false;
  vm.shouldShowFilters = false;
  vm.filters = $tableListConstants.defaultFiltersTemplate;
  vm.tableIsLoading = false;

  vm.searchValue = "";

  vm.gridOptions = {
    rowTemplate:
      '<div ng-click="grid.appScope.ctrl.showHtmlCard(row.entity)" ng-mouseover="grid.appScope.ctrl.onHover(row.entity)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>',
    minimumColumnSize: 100,
    // Grid pagination options
    useExternalPagination: true,
    paginationPageSizes: [25, 50, 100],
    paginationPageSize: 100,
    totalItems: 0,
    // Grid sorting options
    useExternalSorting: true,
    onRegisterApi: function (gridApi) {
      $scope.gridApi = gridApi;
      gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
        vm.filters.pagination.page = newPage;
        vm.filters.pagination.itemsPerPage = pageSize;

        _getListData();
      });
      gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        if (sortColumns[0]) {
          var colField = sortColumns[0].field.split(".")[0];
          vm.filters.pagination.sortBy = colField;
          vm.filters.pagination.sort = sortColumns[0].sort.direction;
        } else {
          vm.filters.pagination.sortBy = null;
        }

        _getListData();
      });
    },
  };

  vm.hoveredRow = null;
  vm.onHover = function (row) {
    // console.log("onHover", row);
    vm.hoveredRow = row;
  };

  vm.clearHoveredRow = function () {
    vm.hoveredRow = null;
  };

  $rootScope.$on("refresh", function () {
    vm.init();
    // vm.removeRow();
  });

  vm.init = function () {
    var promises = [
      $dataTableFactory.getTable(vm.table.tableName, vm.table.schemaName),
      $dataTableFactory.getTableFilters(vm.table.tableName, vm.table.schemaName),
      _getConfigFormatSchema(),
    ];

    var lsFilters = "custom-report-filters-" + vm.customReport.id;
    var filtersInLS = $localStorageService.getItem(lsFilters);
    if (filtersInLS) {
      vm.filters = filtersInLS;
    } else {
      vm.filters = $tableListConstants.defaultFiltersTemplate;
    }

    configTableColumns = angular.isDefined(vm.customReport.configTableColumns)
      ? JSON.parse(vm.customReport.configTableColumns)
      : [];

    if (!Array.isArray(configTableColumns)) return;

    configTableColumns = configTableColumns.map(function (col) {
      return Object.assign({}, col, {
        type: col.colType,
      });
    });

    Promise.allSettled(promises)
      .then(function (res) {
        var cols = res[0].value.columns.filter(function (column) {
          return column.colName != "id_row";
        });

        vm.columns = cols;

        vm.columnfilters = res[1].value;

        vm.schemasFormats = res[2].status == "fulfilled" ? res[2].value : [];

        vm.gridOptions.columnDefs = [];
        var format = {
          boolean: "checkbox",
        };

        angular.forEach(cols, function (col, key) {
          col.type = col.colType;
          col.format = format[col.colType] || col.colType;

          var configCol =
            configTableColumns.find(function (c) {
              return c.colName === col.colName && c.colType === col.colType;
            }) || {};

          var THE_COL = Object.assign({}, col, configCol);

          var colDef = {
            order: THE_COL.order,
            name: THE_COL.colName,
            displayName: THE_COL.displayName || THE_COL.colName,
            field: THE_COL.colName,
            cellFilter: $tableListConstants.cellFilters[THE_COL.colType] || null,
            enableColumnMenu: true,
            enableSorting: true,
            enableHiding: false,
            aux: THE_COL,
            visible: THE_COL.visible !== false ? true : false,
            readonly: THE_COL.readonly !== false ? true : false,
            menuItems: [
              {
                title: $translationService.getTranslationController("Filtrar", "Filter", "Filtro"),
                icon: "ui-grid-icon-filter",
                shown: function () {
                  var hasFilters = vm.columnfilters.find(function (e) {
                    return e.field == col.colName;
                  });
                  return hasFilters ? true : false;
                },
                action: function ($event) {
                  this.context.addFilterTo($event, col);
                },
                context: vm,
              },
            ],
          };

          colDef.cellTemplate = $cellTemplateFormatService.setTemplate(
            colDef,
            THE_COL,
            vm.schemasFormats
          );

          vm.gridOptions.columnDefs.push(colDef);
        });

        vm.gridOptions.columnDefs = vm.gridOptions.columnDefs.sort(function (a, b) {
          return a.order - b.order;
        });

        vm.gridOptions.columnDefs = vm.gridOptions.columnDefs.filter(function (c) {
          return c.visible;
        });

        _getListData();
      })
      .catch(function (error) {
        console.error("Error@getInputList/getInputListFilters", error);
      });
  };
  vm.init();

  function _getListData() {
    vm.tableIsLoading = true;
    // vm.filters.luceneQueryId = $scope.params.filters.luceneQueryId;
    $dataTableFactory
      .getDataTable(
        vm.table.tableName,
        vm.table.schemaName,
        vm.filters.pagination,
        vm.filters.predicates,
        false
      )
      .then(function (res) {
        // console.log("res", res);
        vm.gridOptions.totalItems = res.pagination.totalRecords;
        vm.dataList = res.data;
        vm.gridOptions.data = vm.dataList;

        vm.tableIsLoading = false;

        if (vm.filters) {
          var lsFilters = "custom-report-filters-" + vm.customReport.id;
          $localStorageService.setItem(lsFilters, vm.filters);
          // console.log("Filters saved in localStorage:", vm.filters);
        }
        $scope.loading = false;
      })
      .catch(function (err) {
        console.error("Error@getDataTable", err);
      });
  }

  vm.getBack = function () {
    if ($stateParams.backTo) $state.go("app." + $stateParams.backTo);
    else $state.go("app.schemasLists");
  };

  $scope.$on("listFiltered", function (e, filter) {
    var predicate = {
      fieldName: filter.column,
      label: filter.column,
      operation: "EQUAL",
      value: filter.conditionValue,
      values: null,
      valuesLabels: null,
    };

    vm.filters.predicates.push(predicate);
    vm.isFiltered = true;

    _getListData();
  });

  vm.addFilterTo = function (event, col) {
    col.name = col.colName;
    var selectedColumnFilters = vm.columnfilters.find(function (e) {
      return e.field == col.colName;
    });

    if (!selectedColumnFilters) {
      $toastr.warning(
        $translationService.getTranslationController(
          "No hay filtros disponibles para la columna ",
          "There is no filters available for column ",
          "Não há filtros disponíveis para coluna "
        ) + col.name
      );
      return;
    }
    var cols = angular.copy(vm.columnfilters).map(function (col) {
      return {
        title: col.label,
        data: col.field,
        operations: col.operations,
      };
    });

    $mdDialog
      .show({
        controller: "tableDataFilterController",
        controllerAs: "ctrl",
        templateUrl: "app/app-utils/components/table-data/dialogs/filter/table-data-filter.html",
        locals: {
          table: vm.table,
          selected: vm.selectedColumnFilters,
          columns: cols,
          predicates: vm.predicates,
          translation: vm.translation,
        },
        parent: angular.element(document.body),
        hasBackdrop: true,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: true,
      })
      .then(function (predicates) {
        // console.log(predicates);
        vm.filters.predicates = predicates;
        vm.isFiltered = true;

        _getListData();
      });
  };

  $scope.$watch("ctrl.searchValue", function () {
    // vm.onSearch();
  });

  vm.showHtmlCard = function (row) {
    var tab = {
      row: angular.copy(row),
      // schema: angular.copy(vm.schema),
      // schemaId: vm.list.schema.id,
    };
    vm.clickRow(tab);
  };

  vm.hoveredRow = null;
  vm.onHover = function (row) {
    vm.hoveredRow = row;
  };

  vm.clearHoveredRow = function () {
    vm.hoveredRow = null;
  };

  vm.exportList = function (ext, templateOnly) {
    $rootScope.loading = false;
    var pagination = {
      page: 1,
      itemsPerPage: 99999,
    };
    $dataTableService
      .getDataTable(vm.table.tableName, vm.table.schemaName, pagination, vm.predicates, true)
      .then(function (res) {
        $rootScope.loading = false;
        $rootScope.$broadcast("refreshUserDocuments");
        $toastr.success(
          $translationService.getTranslationController(
            "Tabla descargada",
            "Table downloaded",
            "Tabela baixada"
          )
        );
      })
      .catch(function (err) {
        $rootScope.loading = false;
        console.error("Error@getDataTable", err);
      });
  };

  function _getConfigFormatSchema() {
    return new Promise(function (resolve, reject) {
      $ConfigurationFactory
        .getSchemaFormat()
        .then(function (res) {
          if (res.data.length == 0) {
            resolve([]);
          }
          var schemaMap = res.data.map(function (schema) {
            schema.body = JSON.parse(schema.body);
            return schema;
          });
          resolve(schemaMap);
        })
        .catch(function (err) {
          console.error("Error@getSchemaFormat", err);
          reject(err);
        });
    });
  }

  vm.unFilterData = function () {
    vm.filters.predicates = [];
    vm.isFiltered = false;
    _getListData();
  };

  vm.removeFilter = function (index) {
    vm.filters.predicates.splice(index, 1);
    if (!vm.filters.predicates.length) {
      vm.isFiltered = false;
    }
    _getListData();
  };
}

"use strict";

var app = angular.module("dashboard");
app.component("listCard", {
  templateUrl: "app/custom-reports/list/list-card.html",
  controllerAs: "ctrl",
  bindings: {
    listId: "=",
    schemaId: "=",
    customReport: "=",
    clickRow: "&",
    removeRow: "&",
    html: "=",
    schemasFormats: "=",
  },
  controller: ListCard,
});

ListCard.$inject = [
  "$scope",
  "$rootScope",
  "$state",
  "$stateParams",
  "$mdDialog",
  "toastr",
  "formats",
  "SchemasService",
  "listService",
  "translationService",
  "tableListConstants",
  "InputListsFactory",
  "ConfigurationFactory",
  "cellTemplateFormatService",
  "IssuesFactory",
  "listExporterService",
  "$localStorageService"
];

function ListCard(
  $scope,
  $rootScope,
  $state,
  $stateParams,
  $mdDialog,
  $toastr,
  $formats,
  $schemasService,
  $listService,
  $translationService,
  $tableListConstants,
  $inputListsFactory,
  $ConfigurationFactory,
  $cellTemplateFormatService,
  $issuesFactory,
  $listExporterService,
  $localStorageService
) {
  var vm = this;
  vm.showSideBar = false;

  // console.log('listCard', vm.listId, vm.schemaId, vm.customReport);

  var listID = $scope.params && $scope.params.listID ? listID : vm.listId;
  $translationService.getTranslation($scope, "input-list");
  $rootScope.loading = false;

  vm.schemasFormat = [];

  vm.list = {};
  vm.dataList = [];
  vm.showTable = false;
  vm.columns = [];
  vm.schema = [];
  vm.groups = [];
  vm.showTable = false;
  vm.shouldShowFilters = false;
  vm.filters = [];

  vm.tableIsLoading = false;
  vm.searchValue = "";

  vm.gridOptions = {
    rowTemplate:
      '<div ng-click="grid.appScope.ctrl.showHtmlCard(row.entity)" ng-mouseover="grid.appScope.ctrl.onHover(row.entity)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>',
    minimumColumnSize: 100,
    // Grid pagination options
    useExternalPagination: true,
    paginationPageSizes: [25, 50, 100],
    paginationPageSize: 100,
    paginationCurrentPage: 1,
    paginationOptions: {
      pageNumber: 1,
      itemsPerPage: 100,
    },
    totalItems: 0,
    // Grid sorting options
    useExternalSorting: true,
    onRegisterApi: function (gridApi) {
      $scope.gridApi = gridApi;
      gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
        vm.filters.pagination.page = newPage;
        vm.filters.pagination.itemsPerPage = pageSize;
        vm.gridOptions.paginationOptions.pageNumber = newPage;
        vm.gridOptions.paginationCurrentPage = newPage;

        _getListData();
      });
      gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        if (sortColumns[0]) {
          var colField = sortColumns[0].field.split(".")[0];
          vm.filters.pagination.sortBy = colField;
          vm.filters.pagination.sort = sortColumns[0].sort.direction;
        } else {
          vm.filters.pagination.sortBy = null;
        }

        _getListData();
      });
    },
  };

  $scope.params = {
    listId: listID,
    filters: {
      luceneQueryId: $stateParams.luceneQueryId,
      predicates: JSON.parse($stateParams.filters),
    },
  };

  vm.hoveredRow = null;
  vm.onHover = function (row) {
    vm.hoveredRow = row;
  };

  vm.clearHoveredRow = function () {
    vm.hoveredRow = null;
  };

  function _getColumnDefinition(key) {
    key = key.indexOf("#") === 0 ? key.substring(1) : key;

    return vm.schema[key];
  }

  $rootScope.$on("refresh", function () {
    vm.init();
    vm.removeRow();
  });

  vm.init = function () {
    vm.filters.predicates = [];
    var promises = [
      $inputListsFactory.getInputList(listID),
      $inputListsFactory.getInputListFilters(listID),
      _getConfigFormatSchema(),
    ];

    var lsFilters = "custom-report-filters-" + vm.customReport.id;
    var filtersInLS = $localStorageService.getItem(lsFilters);
    if (filtersInLS) {
      vm.filters = filtersInLS;
    } else {
      vm.filters = $tableListConstants.defaultFiltersTemplate;
    }

    Promise.allSettled(promises)
      .then(function (res) {
        vm.list = res[0].value;
        vm.schema = $schemasService.parseSchema(vm.list.schema);
        vm.columnfilters = res[1].value;
        vm.schemasFormat = res[2].status == "fulfilled" ? res[2].value : [];
      })
      .then(function () {
        _renderList();
        _setColumnDefs()
          .then(function () {
            if (
              $scope.params.filters &&
              $scope.params.filters != null &&
              $scope.params.filters != "null" &&
              $scope.params.filters.predicates
            ) {
              _setDefaultFilters();
            }

            _getListData();
          })
          .catch(function () {
            $toastr.warning(
              $translationService.getTranslationController(
                "No hay columnas visibles en el esquema.",
                "There is no columns visible on schema",
                "Não há colunas visíveis no esquema"
              )
            );
            $rootScope.loading = false;
          });
      })
      .catch(function (error) {
        console.error("Error@getInputList/getInputListFilters", error);
      });
  };
  vm.init();

  function _setDefaultFilters() {
    vm.filters.predicates = [];
    $scope.params.filters.predicates.forEach(function (filter) {
      if (filter.field == "id") {
        vm.filters.predicates.push({
          label: filter.field,
          fieldName: filter.field,
          operation: "IN",
          values: filter.values,
          value: null,
          valuesLabels: null,
        });
      } else {
        var colDef = _getColumnDefinition(filter.field);
        if (typeof filter.value == "object") {
          filter.value.forEach(function (item) {
            vm.filters.predicates.push({
              label: colDef.displayName || colDef.key,
              fieldName: filter.field,
              operation: "EQUAL",
              values: null,
              value: item,
              valuesLabels: null,
            });
          });
        } else {
          vm.filters.predicates.push({
            label: colDef.displayName || colDef.key,
            fieldName: filter.field,
            operation: "EQUAL",
            values: null,
            value: filter.value,
            valuesLabels: null,
          });
        }
      }
    });
    vm.isFiltered = true;
  }

  function _setColumnDefs() {
    return new Promise(function (resolve, reject) {
      vm.gridOptions.columnDefs = [];

      angular.forEach(vm.schema, function (col, key) {
        if (col.visible) {
          var colDef = {
            order: col.order,
            name: key,
            displayName: col.displayName || key,
            field: col.pk ? "#" + key : key,
            cellFilter: $tableListConstants.cellFilters[col.type] || null,
            enableColumnMenu: true,
            enableSorting: true,
            enableHiding: false,
            aux: col,
            menuItems: [
              {
                title: $translationService.getTranslationController("Filtrar", "Filter", "Filtro"),
                icon: "ui-grid-icon-filter",
                shown: function () {
                  var hasFilters = vm.columnfilters.find(function (e) {
                    return e.field == col.key || e.label == col.displayName;
                  });

                  return hasFilters ? true : false;
                },
                action: function ($event) {
                  this.context.addFilterTo($event, col);
                },
                context: vm,
              },
            ],
          };

          colDef.cellTemplate = $cellTemplateFormatService.setTemplate(
            colDef,
            col,
            vm.schemasFormat
          );

          vm.gridOptions.columnDefs.push(colDef);
        }
      });

      vm.gridOptions.columnDefs = vm.gridOptions.columnDefs.sort(function (a, b) {
        return a.order - b.order;
      });

      if (vm.gridOptions.columnDefs.length) {
        resolve();
      }
      reject();
    });
  }

  function _getListData() {
    vm.tableIsLoading = true;
    vm.filters.luceneQueryId = $scope.params.filters.luceneQueryId;
    $inputListsFactory
      .getInputListDataFiltered(listID, vm.filters)
      .then(function (res) {
        vm.gridOptions.totalItems = res.pagination.totalRecords;
        vm.gridOptions.paginationOptions.pageNumber = vm.filters.pagination.page; 
        vm.gridOptions.paginationCurrentPage = vm.filters.pagination.page;
        vm.dataList = res.data.map(function (e) {
          return {
            dataId: e.dataId,
            body: angular.fromJson(e.body),
          };
        });

        if (vm.filters) {
          var lsFilters = "custom-report-filters-" + vm.customReport.id;
          $localStorageService.setItem(lsFilters, vm.filters);
          
        }

        vm.gridOptions.data = vm.dataList.map(function (e) {
          e.body.__dataId = e.dataId;
          return e.body;
        });

        vm.filterlist = vm.dataList;
        _getMetadataList();
      })
      .catch(function (err) {
        console.error("Error@getInputListData", err);
      })
      .finally(function () {
        vm.tableIsLoading = false;
        $scope.loading = false;
      });
  }

  function _getMetadataList() {
    var noGroupTag = $translationService.getTranslationController("otros", "others", "otros");

    $inputListsFactory
      .getInputListMetadata(listID)
      .then(function (res) {
        var mapData = res.columns.map(function (e) {
          var cleanColName = e.name.replace("#", "");

          var col = {
            field: e.name,
            title:
              vm.schema[cleanColName] && vm.schema[cleanColName].displayName
                ? vm.schema[cleanColName].displayName
                : e.name,
            type: e.type,
            show: angular.isDefined(vm.schema[cleanColName].visible) ? vm.schema[cleanColName].visible : true,
            group: vm.schema[cleanColName]
              ? angular.isUndefined(vm.schema[cleanColName].group)
                ? noGroupTag
                : vm.schema[cleanColName].group
              : noGroupTag,
            order: vm.schema[cleanColName] ? vm.schema[cleanColName].order : "1",
            sortable: e.name,
            filterable: { type: "text" },
            readonly: e.readonly,
            width: 30,
          };
          return col;
        });

        vm.columns = mapData.sort(function (a, b) {
          return a.order - b.order;
        });

        vm.groups = vm.columns.map(function (ele) {
          var item = ele.group;
          if (typeof item === "string" && item != undefined) {
            return item;
          }
        });
        //- grupos para cliente card
        vm.groups = vm.groups.filter(function (value, index) {
          return vm.groups.indexOf(value) == index;
        });

        $rootScope.loading = false;
      })
      .catch(function (err) {
        console.error("Error@getInputListMetadata", err);
      });
  }

  vm.onClickListRow = function (item) {
    var _item = {
      dataId: item.__dataId,
      body: item,
    };
    $mdDialog.show({
      controller: "clientCardController",
      controllerAs: "ctrl",
      templateUrl: "app/app-utils/components/client-card/client-card.html",
      clickOutsideToClose: false,
      locals: {
        title: $translationService.getTranslationController(
          "Editor de datos",
          "Data editor",
          "Editor de dados"
        ),
        listId: vm.list.listId,
        inputs: _item,
        inputsTypes: vm.columns,
        groups: vm.groups,
        listSchema: vm.schema,
      },
    });
  };

  vm.showIssueDialog = function (event, issueUuid) {
    if (!issueUuid || issueUuid === "") return;
    var uuid = issueUuid.split("&")[1] || issueUuid.split("&")[0];
    $rootScope.loading = false;
    var promises = [_getIssuesByUuid(uuid), _getIssuesTypes()];
    Promise.allSettled(promises)
      .then(function (res) {
        var issue = res[0].status == "fulfilled" ? res[0].value : false;
        var issueTypes = res[1].status == "fulfilled" ? res[1].value : [];
        if (issue) {
          issue.cat;
          $mdDialog.show({
            controller: "IssuesDetailDialogController",
            controllerAs: "ctrl",
            templateUrl: "app/dashboard/components/issues-detail-dialog/issues-detail-dialog.html",
            parent: angular.element(document.body),
            targetEvent: null,
            clickOutsideToClose: false,
            multiple: true,
            locals: {
              issueTypes: issueTypes,
              currentIssueType: issueTypes.find(function (e) {
                return e.id == issue.issueType.id;
              }),
              issue: issue,
              issuesToLink: [],
              currentCategory: issue.category,
            },
          });
        } else {
          $toastr.warning(
            $translationService.getTranslationController(
              "No se pudo cargar el issue",
              "Can load issue",
              "Can load issue "
            )
          );
        }
      })
      .finally(function () {
        $rootScope.loading = false;
      });
  };

  vm.getBack = function () {
    if ($stateParams.backTo) $state.go("app." + $stateParams.backTo);
    else $state.go("app.schemasLists");
  };

  function _renderList() {
    var inputList = {
      cols: [],
      types: [],
    };

    angular.forEach(vm.schema, function (col, key) {
      inputList.types[(col.pk ? "#" : "") + key] = col.type;
      var referencedListId = col.metadata ? col.metadata.id : null;
      var colDefinition = _getInputType(
        col.type,
        referencedListId,
        col.autocomplete,
        col.inputFormat,
        col.outputFormat,
        col.readonly
      );
      colDefinition.data = (col.pk ? "#" : "") + key;
      colDefinition.title = key + (col.required || col.pk ? "*" : "");
      inputList.cols.push(colDefinition);
    });

    vm.inputList = inputList;
  }

  function _getInputType(input, list, autocomplete, inputFormat, outputFormat, readonly) {
    var sequentialSourceFn = function (query, process) {
      $inputListsFactory.getInputListData(list, {}, false).then(function (res) {
        var source = res.data.map(function (e) {
          var res = angular.fromJson(e.body);
          if (res.$visible) delete res.$visible;
          return Object.values(res)[0];
        });
        process(source);
      });
    };

    return $listService.getInputType(
      input,
      autocomplete,
      inputFormat,
      outputFormat,
      readonly,
      sequentialSourceFn
    );
  }

  vm.unFilterData = function () {
    vm.filters.predicates = [];
    vm.filters.pagination.page = 1;
    vm.isFiltered = false;
    _getListData();
  };

  vm.removeFilter = function (index) {
    vm.filters.predicates.splice(index, 1);
    if (!vm.filters.predicates.length) {
      vm.isFiltered = false;
    }
    vm.filters.pagination.page = 1;
    _getListData();
  };

  vm.addFilterTo = function (event, col) {
    col.name = col.displayName || col.key;
    var selectedColumnFilters = vm.columnfilters.find(function (e) {
      return e.field == col.key || e.label == col.displayName;
    });

    if (!selectedColumnFilters) {
      $toastr.warning(
        $translationService.getTranslationController(
          "No hay filtros disponibles para la columna ",
          "There is no filters available for column ",
          "Não há filtros disponíveis para coluna "
        ) + col.name
      );
      return;
    }

    $mdDialog
      .show({
        controller: "IssuesFiltersDialogController",
        controllerAs: "ctrl",
        templateUrl: "app/dashboard/components/issues-filters-dialog/issues-filters-dialog.html",

        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: false,
        locals: {
          column: col,
          columnFilters: selectedColumnFilters,
        },
      })
      .then(function (predicate) {
        predicate.value = _formatPredicateValue(col, predicate.value);
        vm.filters.predicates.push(predicate);
        vm.filters.pagination.page = 1;
        vm.isFiltered = true;
        _getListData();
      });
  };

  function _formatPredicateValue(col, value) {
    var formats = angular.copy($formats.defaults);
    formats.timestamp = "YYYY-MM-DDTHH:mm:ssZ";

    if (["date", "time", "timestamp"].includes(col.type) && moment.isMoment(value)) {
      return value.format(formats[col.type]);
    }

    return value;
  }

  vm.showReplaceDialog = function (ev, col) {
    var colTypes = [];
    angular.forEach(vm.columns, function (e) {
      colTypes[e.field] = e.type;
    });

    $inputListsFactory.setSelectedCol((col.pk ? "#" : "") + col.key);

    $mdDialog.show({
      controller: "ListReplaceController",
      templateUrl: "app/input-list/components/list-replace/list-replace.html",
      locals: {
        listId: vm.list.listId,
        cellValue: "",
        colTypes: colTypes,
      },
      parent: angular.element(document.body),
      targetEvent: ev,
      hasBackdrop: false,
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
    });
  };

  vm.parsePredicateValue = function (predicate) {
    if (vm.schema[predicate.fieldName.replace("#", "")].type == "date") {
      return moment(predicate.value).format("DD-MM-YYYY");
    }

    return predicate.value;
  };

  $scope.$on("listFiltered", function (e, filter) {
    var predicate = {
      fieldName: filter.column,
      label: filter.column,
      operation: "EQUAL",
      value: filter.conditionValue,
      values: null,
      valuesLabels: null,
    };

    vm.filters.predicates.push(predicate);
    vm.isFiltered = true;

    _getListData();
  });

  function _getConfigFormatSchema() {
    return new Promise(function (resolve, reject) {
      $ConfigurationFactory
        .getSchemaFormat()
        .then(function (res) {
          if (res.data.length == 0) {
            resolve([]);
          }
          var schemaMap = res.data.map(function (schema) {
            schema.body = JSON.parse(schema.body);
            return schema;
          });
          resolve(schemaMap);
        })
        .catch(function (err) {
          console.error("Error@getSchemaFormat", err);
          reject(err);
        });
    });
  }

  function _getIssuesByUuid(issueUuid) {
    return new Promise(function (resolve, reject) {
      $issuesFactory
        .getIssueByUUID(issueUuid)
        .then(function (res) {
          resolve(res);
        })
        .catch(function (err) {
          console.error("Error@_getIssuesByUuid", err);
          reject(err);
        });
    });
  }

  function _getIssuesTypes() {
    return new Promise(function (resolve, reject) {
      $issuesFactory
        .getIssuesTypes()
        .then(function (res) {
          resolve(res);
        })
        .catch(function (err) {
          console.error("Error@_getIssuesTypes", err);
          reject(err);
        });
    });
  }

  vm.showHtmlCard = function (row) {
    var tab = {
      row: angular.copy(row),
      schema: angular.copy(vm.schema),
      schemaId: vm.list.schema.id,
    };
    vm.clickRow(tab);
  };

  vm.onSearch = function () {
    if (vm.searchValue == "") {
      _getListData();
      return;
    }
    vm.tableIsLoading = true;

    var listID = $scope.params && $scope.params.listID ? listID : vm.listId;

    $inputListsFactory
      .searchOnInputlist(listID, vm.searchValue)
      .then(function (res) {
        vm.gridOptions.totalItems = res.pagination.totalRecords;
        vm.dataList = res.data.map(function (e) {
          return {
            dataId: e.dataId,
            body: angular.fromJson(e.body),
          };
        });

        vm.gridOptions.data = vm.dataList.map(function (e) {
          e.body.__dataId = e.dataId;
          return e.body;
        });
      })
      .catch(function (err) {
        console.error("searchOnInputlist@Error", err);
        _getListData();
      })
      .finally(function () {
        vm.tableIsLoading = false;
      });
  };

  $scope.$watch("ctrl.searchValue", function () {
    vm.onSearch();
  });

  vm.exportList = function (ext, templateOnly) {
    vm.cols = $listService.getColumns(vm.schema);
    vm.baseSchema = $listService.getBaseSchema(vm.schema);
    vm.types = $listService.getColumnsTypes(vm.schema);
    vm.headers = $listService.getHeaders(vm.schema);
    vm.colsToExport = $listService.getColumnsToExport(vm.schema);

    vm.selectedCol = vm.colsToExport[0];
    vm.baseSchema["$dataId"] = null;
    vm.baseSchema["$visible"] = true;

    var listToExport = {
      listId: vm.list.listId,
      name: vm.list.name,
      schema: vm.list.schema,
      headers: vm.headers,
      colsToExport: vm.colsToExport,
      data: [],
    };

    if (templateOnly) {
      $listExporterService.execute(ext, templateOnly, listToExport);
    } else {
      $mdDialog.show({
        controller: ["$mdDialog", exportSelectorController],
        controllerAs: "selCtrl",
        templateUrl: "app/input-list/templates/export-selector.html",
        scope: $scope,
        preserveScope: true,
        clickOutsideToClose: false,
      });

      function exportSelectorController($mdDialog) {
        this.selection = "all";
        this.selectSheet = function (selection) {
          // if (selection == 'all') {
          $rootScope.loading = false;
          var filters = angular.copy(vm.filters);

          filters.exportToCSV = true;

          // if (selection == "all") {
          filters.pagination.page = 1;
          filters.pagination.itemsPerPage = 9000000;
          // }
          if (selection == "all") {
            filters.predicates = [];
          }

          $listExporterService
            .execute(ext, false, vm.list, filters)
            .then(function () {
              $rootScope.$broadcast("refreshUserDocuments");
              $toastr.success(
                $translationService.getTranslationController(
                  "Lista descargada",
                  "List downloaded",
                  "Lista baixada"
                )
              );
            })
            .catch(function (error) {
              console.log("Error@listExporterService", error);
              $toastr.error(
                $translationService.getTranslationController(
                  "Se ha producido un error al exportar",
                  "An error occurred while exporting",
                  "Ocorreu um erro ao exportar"
                )
              );
            })
            .finally(function () {
              $rootScope.loading = false;
            });

          $mdDialog.hide();
        };
        this.abortSelection = function () {
          $mdDialog.cancel();
        };
      }
    }
  };
}

"use strict";

var app = angular.module("dashboard");

app.component("likendTable", {
  templateUrl: "app/custom-reports/linked-table/linked-table.html",
  controllerAs: "ctrl",
  bindings: {
    list: "=",
    filters: "=",
  },
  controller: likendTableController,
});

likendTableController.$inject = [
  "$rootScope",
  "$scope",
  "translationService",
  "$mdDialog",
  "toastr",
  "PermissionsFactory",
  "DataTableFactory",
  "cellTemplateFormatService",
  "tableListConstants",
  "ConfigurationFactory",
];
function likendTableController(
  $rootScope,
  $scope,
  $translationService,
  $mdDialog,
  $toastr,
  $permissionsFactory,
  $dataTableFactory,
  $cellTemplateFormatService,
  $tableListConstants,
  $ConfigurationFactory
) {
  var vm = this;

  $translationService.getTranslation(vm, "dashboard");

  vm.printable = false;
  vm.data = [];
  vm.columns = {};
  vm.loading = true;
  vm.showFilters = false;
  vm.columnfilters = [];
  vm.schemasFormats = [];

  vm.init = function () {
    var promises = [
      $dataTableFactory.getTable(vm.list.tableName, vm.list.schemaName),
      $dataTableFactory.getTableFilters(vm.list.tableName, vm.list.schemaName),
      _getConfigFormatSchema(),
    ];

    Promise.all(promises)
      .then(function (res) {
        // console.log("res", res);
        vm.columns = res[0].columns;
        vm.columnfilters = res[1];
        vm.schemasFormats = res[2] == "fulfilled" ? res[2].value : [];
        vm.list.columns = vm.columns;
        vm.list.filters = vm.columnfilters;

        getData();
      })
      .catch(function (err) {
        console.error("Err@columnDefs", err);
      });
  };
  vm.init();

  $scope.$on("reloadLinkedList", function (e, reload) {
    if (vm.list.listId == reload.id) {
      vm.filters = reload.filters;
      getData();
      return;
    }

    if (!vm.columns) return;

    var predicates = reload.filters.predicates.filter(function (e) {
      return vm.columns[e.fieldName.replace("#", "")];
    });

    if (predicates.length == 0) return;
    getData();
  });

  vm.gridOptions = {
    index: "grid",
    data: [],
    schema: {},
    // Grid pagination options
    paginationPageSizes: [25, 50, 100],
    paginationPageSize: 25,
    totalItems: 0,
    useExternalPagination: true,
    useExternalSorting: true,
    columnDefs: [],
    minimumColumnSize: 100,
    rowTemplate:
      '<div ng-dblclick="grid.appScope.ctrl.onClickListRow(row.entity)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>',
    onRegisterApi: function (gridApi) {
      $scope.gridApi = gridApi;
      gridApi.pagination.on.paginationChanged(
        $scope,
        function (newPage, pageSize) {
          vm.filters.pagination.page = newPage;
          vm.filters.pagination.itemsPerPage = pageSize;
          getData();
        }
      );
      gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        var sort = vm.filters.pagination.sort == "desc" ? "asc" : "desc";
        vm.filters.pagination.sort = sort;
        var sortBy = sortColumns.length > 0 ? sortColumns[0].field : "";
        vm.filters.pagination.sortBy = sortBy || "";
        getData();
      });
    },
  };

  vm.showFilterDialog = function (ev, col) {
    var xcol = col.colDef;
    var selectedColumnFilters = vm.columnfilters.find(function (e) {
      return e.field == xcol.field;
    });

    if (!selectedColumnFilters) {
      $toastr.warning("There is no filters available for column " + xcol.name);
      return;
    }

    $mdDialog
      .show({
        controller: "customReportFiltersDialogController",
        controllerAs: "ctrl",
        templateUrl: "app/custom-reports/linked-list/dialog-filters.html",
        locals: {
          column: xcol,
          columnFilters: selectedColumnFilters,
        },
        parent: angular.element(document.body),
        targetEvent: ev,
      })
      .then(function (predicate) {
        predicate.value = _formatPredicateValue(col, predicate.value);
        vm.filters.predicates.push(predicate);
        $rootScope.$broadcast("reloadLinkedList", {
          id: vm.list.listId,
          filters: vm.filters,
        });
        // getData();
      });
  };

  function _formatPredicateValue(col, value) {
    var formats = angular.copy($formats.defaults);
    formats.timestamp = "YYYY-MM-DDTHH:mm:ssZ";

    if (
      ["date", "time", "timestamp"].includes(col.type) &&
      moment.isMoment(value)
    ) {
      return value.format(formats[col.type]);
    }

    return value;
  }

  function getData() {
    vm.showFilters = false;
    vm.loading = true;
    vm.data = [];
    var f = angular.copy(vm.filters);
    f.pagination.itemsPerPage = f.pagination.itemsPerPage < 25 ? 25 : f.pagination.itemsPerPage;

    $dataTableFactory
      .searchLookupMatch(
        vm.list.tableName,
        vm.list.schemaName,
        vm.list.fieldName,
        vm.list.searchValue,
        f
      )
      .then(function (res) {
        // console.log("res", res);
        if (res.data.length == 0) {
          vm.list.data = vm.data;
          vm.gridOptions.data = vm.data;
          return;
        }

        // var parseSchema = $schemasService.parseInputListValues(
        //   res.data,
        //   res.schema
        // );

        vm.data = res.data;
        // vm.columns = parseSchema.schema;
        vm.filters.pagination = res.pagination;

        vm.list.data = res.data;
        // vm.list.schema = vm.columns;
        // vm.loading = true;
        columnDefs()
          .then(function () {
            vm.gridOptions.data = vm.data;
          })
          .catch(function (err) {
            console.error("Err@columnDefs", err);
          })
          .finally(function () {
            vm.loading = false;
          });
      })
      .catch(function (err) {
        console.error("Err@getData", err);
      })
      .finally(function () {
        vm.loading = false;
      });
  }

  function columnDefs() {
    return new Promise(function (resolve, reject) {
      vm.gridOptions.columnDefs = [];
      var format = {
        boolean: "checkbox",
      };
      angular.forEach(vm.columns, function (col, key) {
        col.type = col.colType;
        col.format = format[col.colType] || col.colType;

        var colDef = {
          order: col.order,
          name: col.colName,
          displayName: col.colName,
          field: col.colName,
          cellFilter: $tableListConstants.cellFilters[col.colType] || null,
          enableColumnMenu: true,
          enableSorting: true,
          enableHiding: false,
          aux: col,
          menuItems: [
            {
              title: $translationService.getTranslationController(
                "Filtrar",
                "Filter",
                "Filtro"
              ),
              icon: "ui-grid-icon-filter",
              shown: function () {
                var hasFilters = vm.columnfilters.find(function (e) {
                  return e.field == col.field;
                });
                return hasFilters ? true : false;
              },
              action: function ($event) {
                this.context.addFilterTo($event, col);
              },
              context: vm,
            },
          ],
        };

        colDef.cellTemplate = $cellTemplateFormatService.setTemplate(
          colDef,
          col,
          vm.schemasFormats
        );

        vm.gridOptions.columnDefs.push(colDef);
        // }
      });

      vm.gridOptions.columnDefs = vm.gridOptions.columnDefs.sort(function (
        a,
        b
      ) {
        return a.order - b.order;
      });

      if (vm.gridOptions.columnDefs.length) {
        resolve();
      }
      reject();
    });
  }

  vm.removePredicate = function (index) {
    vm.filters.predicates.splice(index, 1);
    getData();
    $rootScope.$broadcast("reloadLinkedList", {
      id: vm.list.listId,
      filters: vm.filters,
    });
  };

  function _getConfigFormatSchema() {
    return new Promise(function (resolve, reject) {
      $ConfigurationFactory
        .getSchemaFormat()
        .then(function (res) {
          if (res.data.length == 0) {
            resolve([]);
          }
          var schemaMap = res.data.map(function (schema) {
            schema.body = JSON.parse(schema.body);
            return schema;
          });
          resolve(schemaMap);
        })
        .catch(function (err) {
          console.error("Error@getSchemaFormat", err);
          reject(err);
        });
    });
  }
}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller(
      'customReportFiltersDialogController',
      customReportFiltersDialogController
    );

  customReportFiltersDialogController.$inject = [
    '$mdDialog',
    'translationService',
    'column',
    'columnFilters',
  ];
  function customReportFiltersDialogController(
    $mdDialog,
    $translationService,
    column,
    columnFilters
  ) {
    var vm = this;
    $translationService.getTranslation(vm, 'filters-dialog');
    vm.column = column;
    vm.columnFilters = columnFilters;

    vm.types = {
      time: 'time',
      date: 'date',
      timestamp: 'timestamp',
    };

    var defaultValue = {
      boolean: false,
    };

    vm.predicate = {
      label: vm.columnFilters.label,
      fieldName: vm.columnFilters.field,
      operation: vm.columnFilters.operations[0],
      values: null,
      value: defaultValue[vm.columnFilters.component] || null,
      valuesLabels: null,
      type: vm.columnFilters.component,
    };

    vm.onPredicateValuesChanges = function () {
      if (vm.predicate.values != null) {
        vm.predicate.valuesLabels = vm.predicate.values.map(function (e) {
          return vm.columnFilters.metadata.find(function (i) {
            return i.key == e;
          })['value'];
        });
      }
    };

    vm.applyFilters = function () {
      $mdDialog.hide(vm.predicate);
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

'use strict';

var app = angular.module('dashboard');

app.component('likendList', {
  templateUrl: 'app/custom-reports/linked-list/linked-list.html',
  controllerAs: 'ctrl',
  bindings: {
    list: '=',
    filters: '=',
  },
  controller: likendListController,
});

likendListController.$inject = [
  '$rootScope',
  '$scope',
  'translationService',
  '$mdDialog',
  'InputListsFactory',
  'toastr',
  'formats',
  'SchemasService',
  'tableListConstants',
  'cellTemplateFormatService',
  'PermissionsFactory',
  'IssuesFactory',
];
function likendListController(
  $rootScope,
  $scope,
  $translationService,
  $mdDialog,
  $inputListsFactory,
  $toastr,
  $formats,
  $schemasService,
  $tableListConstants,
  $cellTemplateFormatService,
  $permissionsFactory,
  $issuesFactory
) {
  var vm = this;

  $translationService.getTranslation(vm, 'dashboard');

  vm.printable = false;
  vm.data = [];
  vm.schema = {};
  vm.loading = true;

  vm.init = function () {
    getData();

    $inputListsFactory
      .getInputListFilters(vm.list.listId)
      .then(function (res) {
        vm.columnfilters = res;
      })
      .catch(function (err) {
        console.error('Err@columnDefs', err);
      });
  };
  vm.init();

  $scope.$on('reloadLinkedList', function (e, reload) {
    if (vm.list.listId == reload.id) {
      vm.filters = reload.filters;
      getData();
      return;
    }

    if (!vm.schema) return;

    var predicates = reload.filters.predicates.filter(function (e) {
      return vm.schema[e.fieldName.replace('#', '')];
    });

    if (predicates.length == 0) return;
    getData();
  });

  vm.gridOptions = {
    index: 'grid',
    data: [],
    schema: {},
    // Grid pagination options
    paginationPageSizes: [25, 50, 100],
    paginationPageSize: 25,
    totalItems: 0,
    useExternalPagination: true,
    useExternalSorting: true,
    columnDefs: [],
    minimumColumnSize: 100,
    rowTemplate:
      '<div ng-dblclick="grid.appScope.ctrl.onClickListRow(row.entity)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>',
    onRegisterApi: function (gridApi) {
      $scope.gridApi = gridApi;
      gridApi.pagination.on.paginationChanged(
        $scope,
        function (newPage, pageSize) {
          vm.filters.pagination.page = newPage;
          vm.filters.pagination.itemsPerPage = pageSize;
          getData();
        }
      );
      gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        var sort = vm.filters.pagination.sort == 'desc' ? 'asc' : 'desc';
        vm.filters.pagination.sort = sort;
        var sortBy = sortColumns.length > 0 ? sortColumns[0].field : '';
        vm.filters.pagination.sortBy = sortBy || '';
        getData();
      });
    },
  };

  vm.showFilterDialog = function (ev, col) {
    var xcol = col.colDef;
    var selectedColumnFilters = vm.columnfilters.find(function (e) {
      return e.field == xcol.field;
    });

    if (!selectedColumnFilters) {
      $toastr.warning('There is no filters available for column ' + xcol.name);
      return;
    }

    $mdDialog
      .show({
        controller: 'customReportFiltersDialogController',
        controllerAs: 'ctrl',
        templateUrl: 'app/custom-reports/linked-list/dialog-filters.html',
        locals: {
          column: xcol,
          columnFilters: selectedColumnFilters,
        },
        parent: angular.element(document.body),
        targetEvent: ev,
      })
      .then(function (predicate) {
        predicate.value = _formatPredicateValue(col, predicate.value);
        vm.filters.predicates.push(predicate);
        $rootScope.$broadcast('reloadLinkedList', {
          id: vm.list.listId,
          filters: vm.filters,
        });
        // getData();
      });
  };

  function _formatPredicateValue(col, value) {
    var formats = angular.copy($formats.defaults);
    formats.timestamp = 'YYYY-MM-DDTHH:mm:ssZ';

    if (
      ['date', 'time', 'timestamp'].includes(col.type) &&
      moment.isMoment(value)
    ) {
      return value.format(formats[col.type]);
    }

    return value;
  }

  function getData() {
    vm.showFilters = false;
    vm.loading = true;
    vm.data = [];
    var f = angular.copy(vm.filters);

    var hasSchemaField = Object.values(vm.list.schema).some(function (e) {
      var pk = e.pk == true ? '#' : '';
      var val = e.key;
      var field = pk + val;

      var fieldNames = f.predicates.map(function (i) {
        if (i.fieldName.replace('#', '') == e.key.replace('#', '')) {
          i.fieldName = field;
          return field;
        } else return i.fieldName;
      });

      return fieldNames.includes(field);
    });

    vm.showFilters = true;
    if (!hasSchemaField && f.predicates.length > 0) {
      f.predicates = [];
      vm.showFilters = false;
    }

    $inputListsFactory
      .searchLookupMatch(
        vm.list.listId,
        vm.list.searchValue,
        vm.list.lookupmatch,
        f
      )
      .then(function (res) {
        if (res.data.length == 0) {
          vm.list.data = vm.data;
          vm.gridOptions.data = vm.data;
          return;
        }

        var parseSchema = $schemasService.parseInputListValues(
          res.data,
          res.schema
        );

        vm.data = parseSchema.data;
        vm.schema = parseSchema.schema;
        vm.filters.pagination = res.pagination;

        vm.list.data = vm.data;
        vm.list.schema = vm.schema;
        vm.loading = true;
        columnDefs()
          .then(function () {
            vm.gridOptions.data = vm.data;
          })
          .catch(function (err) {
            console.error('Err@columnDefs', err);
          })
          .finally(function () {
            vm.loading = false;
          });
      })
      .catch(function (err) {
        console.error('Err@getData', err);
      })
      .finally(function () {
        vm.loading = false;
      });
  }

  function columnDefs() {
    return new Promise(function (resolve, reject) {
      vm.gridOptions.columnDefs = [];
      for (var key in vm.schema) {
        var col = vm.schema[key];
        if (col.visible) {
          var displayName = col.displayName || key;
          displayName = displayName.replace('#', '');
          var pk = col.pk == true ? '' : '';

          var colDef = {
            order: col.order,
            displayName: displayName + pk,
            type: col.type || 'string',
            field: col.pk ? '#' + key : key,
            enableColumnMenu: true,
            enableSorting: true,
            enableHiding: false,
            cellFilter: $tableListConstants.cellFilters[col.type] || null,
            aux: col,
            menuItems: [
              {
                title: 'Filtrar',
                icon: 'ui-grid-icon-filter',
                shown: function () {
                  return true;
                },
                action: function ($event) {
                  this.context.showFilterDialog($event, this.context.col);
                },
                context: vm,
              },
            ],
          };

          colDef.cellTemplate = $cellTemplateFormatService.setTemplate(
            colDef,
            col,
            vm.schemasFormat
          );

          vm.gridOptions.columnDefs.push(colDef);
        }
      }

      if (vm.gridOptions.columnDefs.length) {
        resolve();
      }
      reject();
    });
  }

  vm.removePredicate = function (index) {
    vm.filters.predicates.splice(index, 1);
    getData();
    $rootScope.$broadcast('reloadLinkedList', {
      id: vm.list.listId,
      filters: vm.filters,
    });
  };

  vm.showIssueDialog = function (event, issueUuid) {
    if (!issueUuid || issueUuid === '') return;
    var uuid = issueUuid.split('&')[1] || issueUuid.split('&')[0];
    $rootScope.loading = false;
    var promises = [_getIssuesByUuid(uuid), _getIssuesTypes()];
    Promise.allSettled(promises)
      .then(function (res) {
        var issue = res[0].status == 'fulfilled' ? res[0].value : false;
        var issueTypes = res[1].status == 'fulfilled' ? res[1].value : [];
        if (issue) {
          issue.cat;
          $mdDialog.show({
            controller: 'IssuesDetailDialogController',
            controllerAs: 'ctrl',
            templateUrl:
              'app/dashboard/components/issues-detail-dialog/issues-detail-dialog.html',
            parent: angular.element(document.body),
            targetEvent: null,
            clickOutsideToClose: false,
            multiple: true,
            locals: {
              issueTypes: issueTypes,
              currentIssueType: issueTypes.find(function (e) {
                return e.id == issue.issueType.id;
              }),
              issue: issue,
              issuesToLink: [],
              currentCategory: issue.category,
            },
          });
        } else {
          $toastr.warning(
            $translationService.getTranslationController(
              'No se pudo cargar el issue',
              'Can load issue',
              'Can load issue '
            )
          );
        }
      })
      .finally(function () {
        $rootScope.loading = false;
      });
  };

  function _getIssuesByUuid(issueUuid) {
    return new Promise(function (resolve, reject) {
      $issuesFactory
        .getIssueByUUID(issueUuid)
        .then(function (res) {
          resolve(res);
        })
        .catch(function (err) {
          console.error('Error@_getIssuesByUuid', err);
          reject(err);
        });
    });
  }

  function _getIssuesTypes() {
    return new Promise(function (resolve, reject) {
      $issuesFactory
        .getIssuesTypes()
        .then(function (res) {
          resolve(res);
        })
        .catch(function (err) {
          console.error('Error@_getIssuesTypes', err);
          reject(err);
        });
    });
  }
}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller(
      'customReportFiltersDialogController',
      customReportFiltersDialogController
    );

  customReportFiltersDialogController.$inject = [
    '$mdDialog',
    'translationService',
    'column',
    'columnFilters',
  ];
  function customReportFiltersDialogController(
    $mdDialog,
    $translationService,
    column,
    columnFilters
  ) {
    var vm = this;
    $translationService.getTranslation(vm, 'filters-dialog');
    vm.column = column;
    vm.columnFilters = columnFilters;

    vm.types = {
      time: 'time',
      date: 'date',
      timestamp: 'timestamp',
    };

    var defaultValue = {
      boolean: false,
    };

    vm.predicate = {
      label: vm.columnFilters.label,
      fieldName: vm.columnFilters.field,
      operation: vm.columnFilters.operations[0],
      values: null,
      value: defaultValue[vm.columnFilters.component] || null,
      valuesLabels: null,
      type: vm.columnFilters.component,
    };

    vm.onPredicateValuesChanges = function () {
      if (vm.predicate.values != null) {
        vm.predicate.valuesLabels = vm.predicate.values.map(function (e) {
          return vm.columnFilters.metadata.find(function (i) {
            return i.key == e;
          })['value'];
        });
      }
    };

    vm.applyFilters = function () {
      $mdDialog.hide(vm.predicate);
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

(function () {
  "use strict";

  angular.module("dashboard").controller("HtmlTemplateController", HtmlTemplateController);

  HtmlTemplateController.$inject = [
    "$scope",
    "$state",
    "$stateParams",
    "$compile",
    "$element",
    "CustomReportFactory",
    "FilesStorageFactory",
    "htmlLayouts",
    "FileUploader",
    "$cookies",
    "$mdDialog",
  ];

  function HtmlTemplateController(
    $scope,
    $state,
    $stateParams,
    $compile,
    $element,
    $customReportFactory,
    $filesStorageFactory,
    htmlLayouts,
    FileUploader,
    $cookies,
    $mdDialog
  ) {
    // console.log("HtmlTemplateController", vm);
    // console.log("HtmlTemplateController $stateParams", $stateParams);

    var vm = this;
    var folder = null;
    var file = null;
    vm.customReport = null;
    vm.htmlInput = "";
    vm.htmlOutput = "";
    vm.hasChanges = false;
    vm.showEditor = true;
    vm.htmlLayouts = htmlLayouts;
    vm.fields = [];
    vm.loading = false;
    vm.components = [
      { name: "Title", html: ' <h4 class="cr-border-bottom">Title</h4>' },
      { name: "Subtitle", html: ' <h5 class="cr-text-secondary">Subtitle</h5>' },
      {
        name: "Image",
        html: '<static-image  folder="CUSTOM_REPORT" file="FILE_NAME.ext" style="height: 65px; width: 140px; display: block"></static-image>',
      },
      { name: "Paragraph", html: " <p>Paragraph text...</p>" },
      { name: "Line Break", html: " <br/>" },
      { name: "Horizontal Line", html: " <hr/>" },
      { name: "Page Break", html: ' <div style="page-break-after: always;"></div>' },
    ];

    function $init() {
      vm.loading = true;
      $customReportFactory.getCustomReportById($stateParams.reportId).then(function (res) {
        // console.log("res", res);
        vm.customReport = res;

        if (res.tipo === "table") {
          vm.fields =
            typeof res.configTableColumns === "string"
              ? JSON.parse(res.configTableColumns)
              : res.configTableColumns;
        }

        if (res.tipo === "list") {
        }

        folder = res.folder;
        file = res.file;

        downloadHtmlFile(folder.id, file.id)
          .then(function (htmlTemplate) {
            vm.htmlInput = htmlTemplate;
            vm.updateHtmlOutput();
          })
          .catch(function (error) {
            console.error(error);
          })
          .finally(function () {
            vm.hasChanges = false;
            vm.loading = false;
          });
      });
    }
    $init();

    vm.toogleEditor = function () {
      vm.showEditor = !vm.showEditor;
    };

    vm.updateHtmlOutput = function (changed) {
      // console.log("updateHtmlOutput", changed);

      var copy = angular.copy(vm.htmlInput);
      copy = "<section> " + copy + "</section>";

      //ident and format html
      copy = 

      vm.htmlOutput = $compile(copy)($scope);

      // angular.element(document.getElementById("html-output")).empty();
      // angular.element(document.getElementById("html-output")).append(vm.htmlOutput);
      $element.find("#html-output").html(vm.htmlOutput);
      // console.log("Updated HTML Output:", vm.htmlOutput);
      vm.hasChanges = changed ? true : false;
    };

    vm.saveFile = function () {
      return new Promise(function (resolve, reject) {
        vm.loading = true;
        // console.log("Saving file to folder:", folder, file);
        var uploader = new FileUploader({
          url: "/risk-backend/rest/file/folder/" + folder.id + "/file",
          headers: { token: $cookies.get("token") },
          formData: { creationDate: moment() },
          removeAfterUpload: true,
        });
        uploader.queue.push(
          new FileUploader.FileItem(
            uploader,
            new File([vm.htmlInput], file.name + ".html", { type: "text/html" })
          )
        );
        uploader.onAfterAddingFile = function (item) {
          // console.log("onAfterAddingFile", item);
        };
        uploader.onBeforeUploadItem = function (item) {
          // console.log("onBeforeUploadItem", item);
        };
        uploader.onSuccessItem = function (item, response, status, headers) {
          // console.log("onSuccessItem", item, response, status, headers);
          vm.hasChanges = false;
          vm.loading = false;
          resolve(response);
        };
        uploader.onErrorItem = function (item, response, status, headers) {
          vm.loading = false;
          reject(response);
          console.error("onErrorItem", item, response, status, headers);
        };
        uploader.uploadAll();
        // console.log("uploader", uploader);
      });
    };

    vm.exitEditor = function () {
      var confirm = $mdDialog
        .confirm()
        .title("Save and exit?")
        .textContent("Do you want to save changes before exiting?")
        .ok("Yes, Save and Exit")
        .cancel("No, Exit without Saving");

      if (!vm.hasChanges) {
        goToreportIdle();
        return;
      }

      $mdDialog.show(confirm).then(
        function () {
          vm.saveFile().then(function () {
            goToreportIdle();
          });
        },
        function () {
          goToreportIdle();
        }
      );
    };

    function goToreportIdle() {
      $state.go("app.custom-report", { reportId: vm.customReport.id });
    }

    vm.downloadFile = function () {
      var blob = new Blob([vm.htmlInput], { type: "text/html" });
      var url = URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      a.download = file.name + ".html";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    };

    function downloadHtmlFile(folder, file) {
      return new Promise(function (resolve, reject) {
        $filesStorageFactory
          .downloadFile(folder, file)
          .then(function (res) {
            var reader = new FileReader();
            reader.onloadend = function () {
              var htmlText = reader.result;
              // console.log("htmlText", htmlText);
              resolve(htmlText);
            };
            reader.readAsText(res.data);
          })
          .catch(function (error) {
            console.log(error);
            reject(error);
          });
      });
    }

    vm.insertSchema = function (schema) {
      // console.log("Inserting schema:", schema);
      var value = schema.colName;
      var insertText =
        "        <p>\n" +
        "          <span ng-bind-html=\"label('" +value +"')\" ></span>\n" +
        "          <span ng-bind-html=\"text('" +value +"')\" ></span>\n" +
        "        </p>";
      vm.htmlInput += "\n" + insertText + "\n";
      vm.updateHtmlOutput(true);
    };

    vm.insertComponent = function (component) {
      // console.log("Inserting component:", component);
      vm.htmlInput += "\n" + component.html + "\n";
      vm.updateHtmlOutput(true);
    };

    vm.useLayout = function (layout) {
      // console.log("Using layout:", layout);
      vm.htmlInput = layout;
      vm.updateHtmlOutput(true);
    };
  }
})();

"use strict";

var app = angular
  .module("dashboard")
  .directive("staticImage", staticImageController)
  .directive("rowData", rowDataController);

rowDataController.$inject = [];
staticImageController.$inject = [];

function rowDataController() {
  return {
    restrict: "A",
    link: function (scope, elem, attrs) {
      // console.log(scope);
      // console.log(scope.ctrl.row);
      // console.log(scope.ctrl.schema);
      var regex = /[^a-z A-z 0-9]+/g;
      var value = elem[0].innerText.split("_");

      value = value.map(function (e) {
        return e.replace(regex, "");
      });
      // elem.html('hola');
      var display = value[0];
      // console.log('display', display);
      var field = value[1];
      // console.log('field', field);
      var txt = "";
      if (display == "text" && field) txt = scope.text(field);
      if (display == "label") txt = scope.label(field);
      // console.log(txt);
      elem.html(txt);
    },
  };
}

function staticImageController() {
  return {
    restrict: "A",
    link: function (scope, elem, attrs) {
      var regex = /[^a-z A-z 0-9 .]+/g;
      var ele = elem[0].getAttribute("src");
      var value = ele.split(",");

      value = value.map(function (e) {
        return e.trim().replace(regex, "");
      });

      var folder = value[1];
      var file = value[2];

      scope.loadImage(folder, file).then(function (res) {
        elem[0].src = "data:image/gif;base64," + res;
      });
    },
  };
}

app.component("htmlClientCard", {
  templateUrl: "app/custom-reports/html-client-card/html-client-card.html",
  controllerAs: "ctrl",
  bindings: {
    preview: "@",
    tab: "=",
    row: "=",
    schema: "=",
    schemaId: "=",
    customReport: "=",
    html: "=",
    schemasFormats: "=",
    columns: "=",
  },
  controller: htmlClientCardController,
});

htmlClientCardController.$inject = [
  "$window",
  "$rootScope",
  "$scope",
  "$mdDialog",
  // 'FilesStorageFactory',
  // 'ConfigurationFactory',
  "SchemasService",
  "InputListsFactory",
  "$element",
  "$compile",
  "$filter",
  "formats",
  "translationService",
  "PermissionsFactory",
  // 'toastr',
  "CustomReportFactory",
  "CommentsFactory",
  "FileSaver",
  "$http",
  "DataTableFactory"
];
function htmlClientCardController(
  $window,
  $rootScope,
  $scope,
  $mdDialog,
  // $filesStorageFactory,
  // $configurationFactory,
  $schemasService,
  $inputListsFactory,
  $element,
  $compile,
  $filter,
  $formats,
  $translationService,
  $permissionsFactory,
  // $toastr,
  $customReportFactory,
  $commentsFactory,
  FileSaver,
  $http,
  $dataTableFactory
) {
  var vm = this;
  var configTableColumns = [];
  vm.schema = vm.schema;

  $translationService.getTranslation(vm, "dashboard");

  vm.validatePermission = function (permission) {
    return $permissionsFactory.hasPermission(permission);
  };

  vm.listFilters = {
    pagination: {
      page: 1,
      itemsPerPage: 999999,
      sortBy: "createdAtLocal",
      sort: "desc",
    },
    predicates: [],
    exportToCSV: false,
  };

  vm.filters = {
    pagination: {
      page: 1,
      itemsPerPage: 99999,
      sortBy: "createdAtLocal",
      sort: "desc",
    },
    predicates: [],
    exportToCSV: false,
  };

  vm.filterFolder = {
    pagination: {
      page: 1,
      itemsPerPage: 1,
      sortBy: "folderName",
      sort: "asc",
    },
  };

  vm.loading = false;

  vm.init = function () {
    vm.selectedTab = null;
    // console.log("preview",vm.preview)
    // console.log("tab",vm.tab)
    // console.log("row",vm.row)
    // console.log("schema",vm.schema)
    // console.log("schemaId",vm.schemaId)
    // console.log("customReport",vm.customReport)
    // console.log("html",vm.html)
    // console.log("schemasFormats",vm.schemasFormats)
    if (!vm.customReport) return;
    if (!vm.row) return;

    if (vm.preview != "true") {
      vm.storageField = vm.row[vm.customReport.storageField];
      vm.linkedLists = [];
      vm.documents = {
        index: "docs",
        data: [],
        row: null,
        filterFolder: null,
        printable: false,
        attach: false,
        columnDefs: null,
        customReport: vm.customReport.id,
        storageField: vm.storageField,
        totalRecords: 0,
      };
      vm.comments = {
        index: "comments",
        data: [],
        row: null,
        filterFolder: null,
        printable: false,
        columnDefs: null,
        customReport: vm.customReport.id,
        storageField: vm.storageField,
        totalRecords: 0,
      };
      _loadTables();
    }

    if (vm.customReport.tipo == "table") {
      configTableColumns = angular.isDefined(vm.customReport.configTableColumns)
        ? JSON.parse(vm.customReport.configTableColumns)
        : [];

      if (!Array.isArray(configTableColumns)) return;

      configTableColumns = configTableColumns.map(function (col) {
        return Object.assign({}, col, {
          type: col.colType,
        });
      });
    }

    _setupHtml();
  };
  vm.init();

  $scope.$watch("ctrl.row", function (newValue) {
    vm.init();
  });

  $scope.$on("reloadcard", function () {
    //
    vm.init();
  });

  $scope.text = function (key) {
    if (!key) return;
    if (!vm.row) return;

    var kk = key.replace("#", "").split(":")[0];
    var customFormat = key.split(":")[1] || null;

    if (vm.customReport.tipo == "list") {
      if (!vm.schema) return;
      if (angular.isUndefined(vm.schema[kk])) return;
      var isPk = vm.schema[kk].pk == true ? "#" : "";
      var html = setHtmlTemplate({
        format: isEmpty(vm.schema[kk], "format"),
        type: isEmpty(vm.schema[kk], "type"),
        value: vm.row[isPk + kk],
        customFormat: customFormat,
      });
      return html;
    }

    if (vm.customReport.tipo == "table") {
      var column = vm.columns.find(function (f) {
        return f.colName == key;
      });

      var configCol =
        (column &&
          configTableColumns.find(function (c) {
            return c.colName === column.colName && c.colType === column.colType;
          })) ||
        {};

      var html = setHtmlTemplate({
        format: angular.isDefined(configCol) ? configCol.format : null,
        type: angular.isDefined(column) ? column.colType : null,
        value: vm.row[kk],
        customFormat: customFormat,
      });

      return html || "";
    }
  };

  $scope.label = function (key) {
    if (!key) return;

    if (vm.customReport.tipo == "list") {
      if (!vm.schema) return;
      var kk = key.replace("#", "").replace(":", "");
      if (!vm.schema[kk]) return;
      var label =
        vm.schema[kk] && vm.schema[kk].displayName ? vm.schema[kk].displayName : vm.schema[kk].key;
      return "<strong>" + label + ": </strong>";
    }

    if (vm.customReport.tipo == "table") {
      var label = configTableColumns.find(function (c) {
        return c.colName == key;
      });
      if (label) {
        return "<strong>" + label.displayName + ": </strong>";
      }
      return "<strong>" + key + ": </strong>";
    }
  };

  //- METHODS
  function isEmpty(object, prop) {
    if (!object) return null;
    if (!prop) return null;
    if (object[prop] === null) return null;
    if (object[prop] === undefined) return null;
    if (object[prop] === "") return null;
    if (!object.hasOwnProperty(prop)) return null;
    if (!object[prop]) return null;
    return object[prop];
  }

  function _setupHtml() {
    var _HTML_ = angular.copy(vm.html);

    var html = $compile(_HTML_)($scope);
    $element.find("#customHtmlTemplate").html(html);
  }

  function setHtmlTemplate(ctx) {
    // console.log("ctx", ctx);
    var item = angular.copy(ctx);
    if (!item.value && !item.type === "boolean") return "";
    if (item.value === "null") return "";
    if (item.value === "undefined") return "";
    if (item.value === "") return "";

    if (item.type === "url") {
      return '<a target="_blank" ng-href="' + item.value + '" class="link">' + item.value + "</a>";
    }

    if (item.type === "boolean") {
      var mdicon = item.value == true ? "fa-check-square-o" : "fa-square-o";
      return '<i class="fa ' + mdicon + ' ceptinel-text" ></i>';
    }

    if (item.type === "integer") {
      item.value = $filter("numberFormater")(item.value);
    }

    if (item.type === "long") {
      item.value = $filter("numberFormater")(item.value);
    }

    if (item.type === "double") {
      item.value = $filter("numberFormater")(item.value);
    }

    if (item.type === "date") {
      item.value = $filter("date")(item.value, "dd/MM/yyyy");
    }

    if (item.type === "timestamp") {
      item.value = $filter("date")(item.value, "dd/MM/yyyy HH:mm:ss");
    }

    var schemaFormat = vm.schemasFormats.find(function (format) {
      return format.name == item.format;
    });

    if (item.customFormat) {
      // console.log("customFormat", item.customFormat);
      schemaFormat = vm.schemasFormats.find(function (format) {
        return format.name == item.customFormat;
      });
    }

    var setSchemaFormat =
      schemaFormat && schemaFormat.body
        ? schemaFormat.body.find(function (f) {
            return f.key == item.value || f.value == item.value;
          })
        : null;

    var formatClass = "";

    if (setSchemaFormat) {
      formatClass =
        setSchemaFormat.icon + " " + setSchemaFormat.color + " " + setSchemaFormat.format;
    }

    if (item.value === "undefined" || item.value === undefined) item.value = "";
    if (item.value === "null" || item.value === null) item.value = "";

    return '<span class="' + formatClass + '">' + item.value + "</span>";
  }

  vm.loadingTabs = false;
  function _loadTables() {
    if (vm.preview === "true") return;
    if (vm.customReport.tipo === "list") {
      loadListType();
    }
    if (vm.customReport.tipo === "table") {
      loadTableType();
    }
  }

  function loadListType() {
    vm.loadingTabs = true;
    vm.linkedLists = [];

    vm.linkedLists = Object.entries(vm.schema)
      .filter(function (e) {
        return e[1].type === "lookup";
      })
      .map(function (e, i) {
        var key = e[0];
        var props = e[1];
        var isPk = props.pk ? "#" : "";
        var metadata = e[1].metadata;
        var field = vm.row[isPk + key];

        return {
          index: i,
          key: key,
          displayName: props.displayName,
          listId: metadata.id,
          lookupmatch: metadata.lookupmatch,
          searchValue: field,
          data: null,
          schemaLength: 0,
          schema: null,
          filters: null,
          printable: true,
          load: false,
          gridOptions: {
            data: [],
            totalRecords: 0,
          },
          visible: false,
        };
      });

    var promises = [];

    vm.linkedLists.forEach(function (values) {
      promises.push(
        $inputListsFactory.searchLookupMatch(
          values.listId,
          values.searchValue,
          values.lookupmatch,
          vm.listFilters
        )
      );
    });

    Promise.allSettled(promises)
      .then(function (res) {
        // connsole.log("res", res);
        res
          .filter(function (r) {
            return r.status == "fulfilled"
          })
          .map(function (r) {
            return r.value;
          })
          .forEach(function (r, index) {
            var parseSchema = $schemasService.parseInputListValues(r.data, r.schema);

            var list = vm.linkedLists.find(function (l) {
              return l.listId == r.request.listId && l.lookupmatch == r.request.lookupmatch;
            });

            list.data = parseSchema.data;
            list.schema = parseSchema.schema;
            list.schemaLength = angular.isDefined(parseSchema.schema)
              ? Object.keys(parseSchema.schema).length
              : 0;
            list.gridOptions.totalRecords = r.pagination.totalRecords;
            list.gridOptions.itemsPerPage = 999999999999;
            list.visible = list.gridOptions.totalRecords > 0;
          });

        var allListEmpty = res
          .filter(function (r) {
            return r.status == "fulfilled" && r.value.data && r.value.data.length > 0;
          })
          .map(function (e) {
            return e.value;
          })
          .every(function (e) {
            return e.pagination.totalRecords == 0;
          });

        var initTab = vm.linkedLists.findIndex(function (e) {
          return e.data && e.data.length > 0;
        });

        if (allListEmpty) vm.onTabSelected("docs");
        else vm.onTabSelected(initTab);
        // vm.onTabSelected("docs");
      })
      .catch(function (err) {
        console.error("Error@Promise", err);
      });

    _loadDocumentsAndComments();
    vm.loadingTabs = false;
  }

  function loadTableType() {
    vm.loadingTabs = true;
    // console.log("loadTableType", vm.customReport);
    var configLookup = angular.isDefined(vm.customReport.configLookup)
      ? JSON.parse(vm.customReport.configLookup)
      : [];

    if (configLookup.length > 0) {
      var schemaName = vm.customReport.table.schemaName;
      var promises = [];
      vm.linkedLists = [];
      configLookup.forEach(function (values, i) {
        var params = values.split(":");
        var fieldNames = params[0]; // source table fields name separated by comma
        var tableName = params[1]; // target table name
        var searchField = params[2]; // target table fields name separated by comma
        // var value = vm.row[fieldName];
        var fieldNamesArray = fieldNames.split(",");
        var values = "";
        for (var index = 0; index < fieldNamesArray.length; index++) {
          var fn = fieldNamesArray[index];
          var val = angular.isDefined(vm.row[fn]) ? vm.row[fn].toString().trim() : "";
          values += val + ",";
        }
        values = values.slice(0, -1); // remove last comma
        
        promises.push(
          $dataTableFactory.searchLookupMatch(tableName, schemaName, searchField, values, {})
        );

        vm.linkedLists.push({
          index: i,
          key: i,
          displayName: tableName,
          tableName: tableName,
          schemaName: schemaName,
          fieldName: searchField,
          searchValue: values,
          data: null,
          // schemaLength: 0,
          // schema: null,
          filters: null,
          printable: true,
          load: false,
          gridOptions: {
            data: [],
            totalRecords: 0,
          },
        });
      });

      Promise.allSettled(promises)
        .then(function (res) {
          // console.log("res", res);
          res
            // .filter(function (r) {
            //   return r.status == "fulfilled" && r.value.data && r.value.data.length > 0;
            // })
            // .map(function (r) {
            //   return r.value;
            // })
            .forEach(function (r, index) {
              // console.log("r", r);
              // console.log("index", index);
              vm.linkedLists[index].data = [];
              vm.linkedLists[index].gridOptions.data = [];
              vm.linkedLists[index].gridOptions.totalRecords = 0;
              if (r.status === "fulfilled") {
                vm.linkedLists[index].data = r.value.data;
                vm.linkedLists[index].gridOptions.data = r.value.data;
                vm.linkedLists[index].gridOptions.totalRecords = r.value.pagination.totalRecords;
              }
            });

          // console.log("vm.linkedLists", vm.linkedLists);
          vm.onTabSelected("docs");
        })
        .catch(function (err) {
          console.error("Error@Promise", err);
        });
    }

    _loadDocumentsAndComments();
    vm.loadingTabs = false;
  }

  function _loadDocumentsAndComments() {
    var target = "CLIENT_CARD";
    var storageField = "custom_report_" + vm.customReport.id + "_" + vm.storageField;

    var documentsAndComments = [
      $customReportFactory.getAllFilesInFolder(vm.customReport.id + "-" + vm.storageField, {
        pagination: {
          page: 1,
          itemsPerPage: 1,
        },
      }),
      $commentsFactory.getCommentsByTargetAndId(target, storageField),
    ];

    Promise.allSettled(documentsAndComments)
      .then(function (res) {
        vm.documents.totalRecords =
          res[0].status === "fulfilled" ? res[0].value.pagination.totalRecords : 0;

        vm.comments.totalRecords = res[1].status === "fulfilled" ? res[1].value.length : 0;
      })
      .catch(function (err) {
        console.error("Error@Promise", err);
      });
  }

  vm.editRow = function () {
    if (vm.customReport.tipo === "table") {
      var schema = angular.isDefined(vm.customReport.configTableColumns)
        ? JSON.parse(vm.customReport.configTableColumns)
        : [];
      if (!Array.isArray(schema)) schema = [];
      console.log("vm.row", vm.row);
      $mdDialog
        .show({
          controller: "dialogEditDataTable",
          controllerAs: "ctrl",
          templateUrl: "app/custom-reports/dialog/dialog-edit-card-table.html",
          clickOutsideToClose: false,
          locals: {
            title: "Data editor",
            data: vm.row,
            schema: schema,
            table: vm.customReport.table,
          },
        })
        .then(function (record) {
          vm.row = record;
          // $rootScope.$broadcast("refresh");
        });
    } else if (vm.customReport.tipo === "list") {
      $mdDialog
        .show({
          controller: "dialogEditData",
          controllerAs: "ctrl",
          templateUrl: "app/custom-reports/dialog/dialog-edit-card.html",
          clickOutsideToClose: false,
          locals: {
            title: "Data editor",
            data: vm.row,
            schema: vm.schema,
            list: vm.customReport.list,
          },
        })
        .then(function (record) {
          vm.row = record;
          // $rootScope.$broadcast("refresh");
        });
    } else {
      console.error("Tipo de reporte no soportado", vm.customReport.tipo);
    }
  };

  vm.exportToPdf = function () {
    var currentTitle = angular.copy(window.document.title);

    window.document.title = vm.storageField + "_ficha";
    window.print();
    setTimeout(function () {
      window.document.title = currentTitle;
    }, 500);

    if (!vm.documents.attach) return;

    var location = window.location.origin;
    // console.log(vm.customReport);

    var url =
      location +
      "/risk-backend/rest/custom-report/" +
      vm.customReport.id +
      "/storage/folder/" +
      vm.storageField +
      "/merge-pdfs";

    // var url =
    //   location +
    //   '/risk-backend/rest/custom-report/' +
    //   vm.customReport.id +
    //   '/data/' +
    //   vm.row.__dataId +
    //   '/folder/' +
    //   vm.customReport.folder.name +
    //   '/key/' +
    //   vm.storageField +
    //   '/export-to-pdf/?tab=attach' +

    // console.log("url", url);

    downloadURL(url);

    // window.open(url);
  };

  function downloadURL(url) {
    var hiddenIFrameID = "hiddenDownloader",
      iframe = document.getElementById(hiddenIFrameID);
    if (iframe === null) {
      iframe = document.createElement("iframe");
      iframe.id = hiddenIFrameID;
      iframe.style.display = "none";
      document.body.appendChild(iframe);
    }
    iframe.src = url;
  }

  vm.onTabSelected = function (tab) {
    vm.selectedTab = tab;

    if (tab == "comments") {
      $rootScope.$broadcast("reloadCommnets");
    }

    if (tab == "docs") {
      $rootScope.$broadcast("reloadDocuments");
    }

    // if (typeof tab === "number") {
    //   var list = vm.linkedLists.find(function (e) {
    //     return e.index == tab;
    //   });

    //   $rootScope.$broadcast("reloadLinkedList", {
    //     id: list.listId,
    //     filters: vm.filters,
    //   });
    // }
  };

  vm.showFilterDialog = function (ev, col, schema, listId) {
    $mdDialog
      .show({
        controller: "dialogFiltersCustomReport",
        controllerAs: "ctrl",
        templateUrl: "app/custom-reports/dialog/dialog-filters.html",
        locals: {
          column: col,
          schema: schema,
          listId: listId,
          predicates: vm.listFilters.predicates,
        },
        parent: angular.element(document.body),
        targetEvent: ev,
      })
      .then(function (predicates) {
        vm.listFilters.predicates = predicates;

        _loadTables();
      });
  };

  $scope.loadImage = function (folder, file) {
    return new Promise(function (resolve) {
      downloadFile(folder, file).then(function (imgBlob) {
        blobToBase64(imgBlob).then(function (base64) {
          resolve(base64);
        });
      });
    });
  };

  function downloadFile(folder, file) {
    return $filesStorageFactory
      .downloadFile(folder, file)
      .then(function (res) {
        return res.data;
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  function blobToBase64(blob) {
    return new Promise(function (resolve, _) {
      var reader = new FileReader();
      reader.onloadend = function () {
        return resolve(reader.result.split(";base64,").pop());
      };
      reader.readAsDataURL(blob);
    });
  }
}

"use strict";

var app = angular.module("dashboard");

app.component("documentsList", {
  templateUrl: "app/custom-reports/documents/documents.html",
  controllerAs: "ctrl",
  bindings: {
    documents: "=",
    predicates: "=",
  },
  controller: documentsListController,
});

documentsListController.$inject = [
  "$scope",
  "$mdDialog",
  "translationService",
  "FileSaver",
  "CustomReportFactory",
  "PermissionsFactory",
  "FilesStorageFactory",
  "toastr",
  "$localStorageService",
];
function documentsListController(
  $scope,
  $mdDialog,
  $translationService,
  FileSaver,
  $customReportFactory,
  PermissionsFactory,
  $filesStorageFactory,
  $toastr,
  $localStorageService
) {
  var vm = this;
  var folderId = null;
  vm.printable = false;
  vm.data = [];
  vm.schema = {};
  vm.loading = true;

  $translationService.getTranslation(vm, "dashboard");

  $scope.hasPermissionDeleteFile = function (folder_id) {
    return PermissionsFactory.hasPermission(
      "files-storage-folder-file#" + folder_id + ":" + "delete-file"
    );
  };

  vm.filters = {
    pagination: {
      page: 1,
      itemsPerPage: 50,
      sort: "asc",
    },
  };

  vm.columnDefs = [
    {
      name: "name",
      displayName: $translationService.getTranslationController("Nombre", "Name", "Name"),
      type: "string",
      field: "name",
      enableColumnMenu: true,
      enableSorting: true,
      enableHiding: false,
    },
    {
      name: "folder",
      displayName: $translationService.getTranslationController("Carpeta", "Folder", "Folder"),
      type: "string",
      field: "folderName",
      enableColumnMenu: true,
      enableSorting: true,
      enableHiding: false,
    },
    {
      name: "extension",
      displayName: $translationService.getTranslationController(
        "Extensión",
        "extension",
        "extension"
      ),
      type: "string",
      field: "extension",
      enableColumnMenu: true,
      enableSorting: true,
      enableHiding: false,
    },
    {
      name: "download",
      width: 100,
      displayName: $translationService.getTranslationController(
        "Descargar",
        "Download",
        "descagar"
      ),
      enableColumnMenu: false,
      enableSorting: false,
      enableHiding: false,
      cellTemplate:
        '<button type="button" ng-click="grid.appScope.downloadFile(row.entity, grid)" ><md-icon md-font-set="material-icons" aria-label="BTN-download">cloud_download</md-icon></button>',
    },
    {
      name: "delete",
      width: 100,
      displayName: $translationService.getTranslationController("Eliminar", "Delete", "Delete"),
      enableColumnMenu: false,
      enableSorting: false,
      enableHiding: false,
      cellTemplate:
        '<button type="button" ng-click="grid.appScope.deleteRow(row.entity, grid)" has-permission="files-storage-folder-file#{{row.entity.id}}:delete-file" ><md-icon md-font-set="material-icons" aria-label="BTN-delete">delete</md-icon></button>',
    },
  ];

  vm.init = function () {
    getData();
  };

  vm.init();

  vm.gridOptions = {
    index: "docs",
    data: [],
    schema: {},
    // Grid pagination options
    paginationPageSizes: [25, 50, 100],
    paginationPageSize: 25,
    totalItems: 0,
    useExternalPagination: true,
    useExternalSorting: true,
    columnDefs: vm.columnDefs,
    minimumColumnSize: 100,
    rowTemplate:
      '<div ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>',
    onRegisterApi: function (gridApi) {
      $scope.gridApi = gridApi;
      gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
        vm.filters.pagination.page = newPage;
        vm.filters.pagination.itemsPerPage = pageSize;
        getData();
      });
      gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        var sort = vm.filters.pagination.sort == "desc" ? "asc" : "desc";
        vm.filters.pagination.sort = sort;
        getData();
      });
    },
  };

  vm.showFilterDialog = function (ev, col, schema) {
    var selectedColumnFilters = {
      field: col.field,
      label: col.displayName,
      component: "text",
      operations: [
        "EQUAL",
        "NOT_EQUAL",
        "LIKE_CONTAINS",
        "LIKE_NOT_CONTAINS",
        "LIKE",
        "IS_EMPTY",
        "IS_NOT_EMPTY",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      sortable: false,
    };
    $mdDialog
      .show({
        controller: "documentsFiltersDialogController",
        controllerAs: "ctrl",
        templateUrl: "app/custom-reports/documents/dialog-filters.html",
        locals: {
          column: col.colDef,
          columnFilters: selectedColumnFilters,
        },
        parent: angular.element(document.body),
        targetEvent: ev,
      })
      .then(function (predicates) {
        vm.filters.pagination = Object.assign(vm.filters.pagination, predicates);

        getData();
      });
  };

  function getData() {
    vm.loading = true;
    if (!angular.isDefined(vm.documents)) vm.documents = {};

    vm.documents.columnDefs = vm.columnDefs;

    var folderName = vm.documents.customReport + "-" + vm.documents.storageField;

    $customReportFactory
      .getAllFilesInFolder(folderName, vm.filters)
      .then(function (res) {
        vm.documents.data = res.data;
        vm.gridOptions.data = res.data;
        vm.gridOptions.totalItems = res.pagination.totalItems;
        vm.filters.pagination = res.pagination;
        vm.documents.totalRecords = res.pagination.totalRecords;
        folderId = Array.isArray(res.data) && res.data.length > 0 ? res.data[0].folderId : null;
        vm.loading = false;
      })
      .catch(function (err) {
        console.error("Err@getFilesInFolder", err);
        vm.loading = false;
        $scope.loading = false;

        // if (err.status === 404) {
        // $filesStorageFactory
        //   .getConfigStorage()
        //   .then(function (config) {
        //     console.log("Storage config retrieved:", config.settings.extensions);

        //     $customReportFactory
        //       .createFolder({
        //         name: folderName,
        //         description: folderName,
        //         extensions: config.settings.extensions,
        //         color: "#5a2c7e",
        //         type: "CUSTOM_REPORT",
        //       })
        //       .then(function (folder) {
        //         console.log("Folder created:", folder);
        //         folderId = folder.id;
        //         getData(); // Retry getting data after creating the folder
        //       })
        //       .catch(function (error) {
        //         console.error("Error creating folder:", error);
        //         vm.loading = false;
        //         // $toastr.error("Error createFolder folder: " + error.message);
        //       });
        //   })
        //   .catch(function (error) {
        //     console.error("Error getting getConfigStorage config:", error);
        //     vm.loading = false;
        //     $toastr.error("Error getting getConfigStorage config: " + error.message);
        //   });
        // } else {
        //   console.error("Error getting files in folder:", err);
        //   $toastr.error("Error getting files in folder: " + err.message);
        // }
      });
  }

  $scope.downloadFile = function (row, grid) {
    $customReportFactory
      .downloadFile(vm.documents.customReport, row.folderName, row.name)
      .then(function (res) {
        FileSaver.saveAs(new Blob([res.data]), vm.documents.storageField + "-" + row.name);
      })
      .catch(function (err) {
        console.error("Error@downloadFile", err);
      });
  };

  vm.uploadFilesDialog = function () {
    $mdDialog
      .show({
        controller: "documentsUploaderDialogController",
        controllerAs: "ctrl",
        templateUrl: "app/custom-reports/documents/dialog-uploader.html",
        locals: {
          folderId: folderId,
          customreport: vm.documents.customReport,
          storagefield: vm.documents.storageField,
        },
        parent: angular.element(document.body),
        // targetEvent: ev,
      })
      .then(function () {
        getData();
      });
  };

  function _filesToTrash(folderId, fileId) {
    return new Promise(function (resolve, reject) {
      vm.loading = true;
      $customReportFactory
        .moveFileToTrash(folderId, fileId)
        .then(function (res) {
          vm.loading = false;
          resolve(res);
        })
        .catch(function (error) {
          vm.loading = false;
          console.log(error);
          $toastr.warning(error.data.message);
          reject(error);
        });
    });
  }

  $scope.deleteRow = function (row, grid) {
    //var hasPermissionDeleteFile = $scope.hasPermissionDeleteFile(row.id);

    //if (hasPermissionDeleteFile) {
    var title = $translationService.getTranslationController(
      "Confirmar eliminar el archivo",
      "Confirm delete file",
      "Confirme a exclusão do arquivo"
    );
    var textContent = $translationService.getTranslationController(
      "Será enviado a la papelera del sistema de archivos",
      "Will be sent to the file system trash",
      "Será enviado para a lixeira do sistema de arquivos"
    );
    var ok = $translationService.getTranslationController(
      "Si, elimina el archivo",
      "Yes, delete the file",
      "Sim, exclua o arquivo"
    );
    var cancel = $translationService.getTranslationController("Cancelar", "Cancel", "Cancel");

    var confirm = $mdDialog
      .confirm()
      .title(title)
      .textContent(textContent)
      .ariaLabel("confirm delete")
      .targetEvent()
      .ok(ok)
      .cancel(cancel);

    $mdDialog.show(confirm).then(
      function () {
        _filesToTrash(row.folderId, row.id).finally(function () {
          getData();
        });
      },
      function () {
        getData();
      }
    ); /*
    } else {
      var title = $translationService.getTranslationController(
        'Usted no tiene permiso de borrado para este archivo',
        'You do not have delete permission for this file',
        'Você não tem permissão para excluir este arquivo'
      );
      var textContent = $translationService.getTranslationController(
        'Contacte con un administrador',
        'Contact an administrator',
        'Entre em contato com um administrador'
      );
      $mdDialog.show(
        $mdDialog
          .alert()
          .parent('body')
          .clickOutsideToClose(true)
          .title(title)
          .textContent(textContent)
          .ariaLabel('no has permission to delete')
          .ok('Ok')
      );
    }*/
  };

  $scope.$on("reloadDocuments", function () {
    getData();
  });
}

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller("documentsUploaderDialogController", documentsUploaderDialogController);

  documentsUploaderDialogController.$inject = [
    "$mdDialog",
    "toastr",
    "FileUploader",
    "translationService",
    "CustomReportFactory",
    "FilesStorageFactory",
    "customreport",
    "storagefield",
    "folderId"
  ];
  function documentsUploaderDialogController(
    $mdDialog,
    $toastr,
    FileUploader,
    $translationService,
    $customReportFactory,
    $filesStorageFactory,
    customreport,
    storagefield,
    folderId
  ) {
    var vm = this;

    $translationService.getTranslation(vm, "dashboard");

    vm.customreport = customreport;
    vm.storagefield = storagefield;
    vm.folder = null;
    vm.accept = "";
    vm.folderFound = true;
    vm.errorMessage = "";
    var default_folder = {
      name: "",
      description: "",
      color: "#5a2c7e",
      extensions: ["xls", "xlsx", "pdf", "doc", "docx", "csv", "png", "jpg", "jpeg", "txt", "html"],
    };
    var folderName = vm.customreport + "-" + vm.storagefield;

    vm.$onInit = function () {
      vm.errorMessage = "";
      $filesStorageFactory
        .getFilesInFolder(folderName, {
          page: 1,
          itemsPerPage: 99999,
          sort: "asc",
          inTrash: false,
        })
        .then(function (result) {
          vm.folderFound = true;
          vm.accept = default_folder.extensions;
        })
        .catch(function (err) {
          if (err.status === 404) {
            vm.folderFound = false;
            vm.accept = default_folder.extensions;
          } else {
            $toastr.error(
              $translationService.getTranslationController(
                "Error al obtener la carpeta: " + err.message,
                "Error getting folder: " + err.message,
                "Erro ao obter a pasta: " + err.message
              )
            );
          }
          console.error("err@getFolderByID", err);
        });
    };

    vm.t = {
      load_file: $translationService.getTranslationController(
        "Cargar archivo",
        "Load file",
        "Carregar arquivo"
      ),
      load_all: $translationService.getTranslationController(
        "Cargar todo",
        "Load all",
        "Carregar tudo"
      ),
      cancel_all: $translationService.getTranslationController(
        "Cancelar todo",
        "Cancel all",
        "Cancelar tudo"
      ),
      clean_queue: $translationService.getTranslationController(
        "Limpiar cola",
        "Clear queue",
        "Limpar fila"
      ),
      dropFilesHere: $translationService.getTranslationController(
        "Soltar archivos aquí",
        "Drop files here",
        "Solte os arquivos aqui"
      ),
      filesOnQueue: $translationService.getTranslationController(
        "Archivos en cola",
        "Files On Queue",
        "Arquivos na fila"
      ),
    };
    vm.issueFiles = [];

    vm.uploader = new FileUploader({
      url: "/risk-backend/rest/file/folder/" + folderName + "/file",
      removeAfterUpload: true,
    });

    vm.uploader.onAfterAddingFile = function (item) {
      item.remove();

      var uploadQueue = vm.uploader.queue.filter(function (e) {
        return e.file.name.toLowerCase() == item.file.name.toLowerCase();
      });

      var file_ext = item.file.name.split(".").pop().toLowerCase();

      var invalidExtencion = !vm.accept.includes(file_ext);

      if (invalidExtencion) {
        $toastr.error(
          item.file.name +
            $translationService.getTranslationController(
              " no es una extension valida",
              " is not a valid extension",
              " não é uma extensão válida"
            )
        );
        return false;
      }

      if (uploadQueue.length > 0) {
        $toastr.error(
          item.file.name +
            $translationService.getTranslationController(
              " ya esta en cola",
              " is already in queue",
              " já está na fila"
            )
        );
        return false;
      } else {
        
        //sanitize file name - replace url unsafe characters with underscores
        var sanitizedFileName = String(item.file.name)
          .normalize("NFD") // -> split accented characters into their base character and diacritical mark
          .replace(/[\u0300-\u036f]/g, "") //-> remove diacritical marks
          .replace(/[^A-Za-z0-9\-._~]/g, "_"); // -> replace any remaining url unsafe characters with underscores

        item.file.name = sanitizedFileName;
        console.log("Sanitized file name:", item.file.name);

        vm.uploader.queue.push(item);
        $toastr.info(
          $translationService.getTranslationController(
            "Archivo añadido a la cola!",
            "File added to the queue!",
            "Arquivo adicionado à fila!"
          )
        );
      }
    };

    vm.uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response === "fileDuplicate") {
        var msg = $translationService.getTranslationController(
          "No se ha podido cargar, archivo duplicado en el sistema.",
          "Unable to load, duplicate file in the system.",
          "Não é possível carregar, duplicar arquivo no sistema."
        );
        $toastr.error(msg);
      } else {
        if (status == 403) {
          $toastr.error(
            $translationService.getTranslationController(
              "Usuario no autorizado.",
              "Unauthorized User.",
              "Usuário não autorizado."
            )
          );
        } else {
          $toastr.error(
            $translationService.getTranslationController(
              "No se ha podido cargar el archivo.",
              "The file could not be loaded.",
              "O arquivo não pôde ser carregado."
            )
          );
        }
      }
    };

    vm.uploader.onSuccessItem = function (item, response, status, headers) {
      if (status) {
        var msg = $translationService.getTranslationController(
          "Archivo cargado exitosamente",
          "File successfully loaded",
          "Arquivo carregado com sucesso"
        );
        $toastr.success(msg);
        vm.uploadSuccess();
      }
    };

    vm.uploader.onProgressAll = function () {
      vm.loaderInProggres = true;
    };

    vm.uploader.onCompleteAll = function () {
      vm.loaderInProggres = false;
    };

    vm.onDeleteFile = function (fileId) {
      vm.issueFiles = vm.issueFiles.filter(function (e) {
        return e.id != fileId;
      });
      vm.filesCount = vm.issueFiles.length;
    };

    vm.startUpload = function () {
      if (vm.folderFound == true) {
        vm.uploader.uploadAll();
      } else {
        var new_folder = angular.copy(default_folder);

        new_folder.name = vm.storagefield;
        new_folder.description = vm.storagefield;
        
        $customReportFactory
          .createFolder({
            name: folderName,
            description: folderName,
            extensions: default_folder.extensions,
            color: "#5a2c7e",
            type: "CUSTOM_REPORT",
          })
          .then(function (folder) {
            console.log("Folder created:", folder);
            // folderId = folder.id;
            vm.uploader.uploadAll();
          })
          .catch(function (error) {
            console.error("Error creating folder:", error);
            // vm.loading = false;
            // $toastr.error("Error createFolder folder: " + error.message);
          });
      }
    };

    vm.uploadSuccess = function () {
      $mdDialog.hide();
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.upload_file = $translationService.getTranslationController(
      "Cargar archivo en",
      "Load file in",
      "Carregar arquivo"
    );

    vm.accepted_extensions = $translationService.getTranslationController(
      "Extensiones aceptadas:",
      "Accepted extensions:",
      "Accepted extensions:"
    );

    vm.folder_not_exist = $translationService.getTranslationController(
      "No existe la carpeta",
      "The folder does not exist",
      "The folder does not exist"
    );

    vm.please_created_the_folder = $translationService.getTranslationController(
      "Por favor, creé la carpeta",
      "Please I created the folder",
      "Please I created the folder"
    );
    vm.so_that_the_document_can_be_uploaded = $translationService.getTranslationController(
      "para que se pueda cargar documento.",
      "so that the document can be uploaded.",
      "so that the document can be uploaded."
    );
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller(
      'documentsFiltersDialogController',
      documentsFiltersDialogController
    );

  documentsFiltersDialogController.$inject = [
    '$mdDialog',
    'translationService',
    'column',
    'columnFilters',
  ];
  function documentsFiltersDialogController(
    $mdDialog,
    $translationService,
    column,
    columnFilters
  ) {
    var vm = this;
    $translationService.getTranslation(vm, 'filters-dialog');
    vm.column = column;
    vm.columnFilters = columnFilters;

    vm.types = {
      time: 'time',
      date: 'date',
      timestamp: 'timestamp',
    };

    var defaultValue = {
      boolean: false,
    };

    vm.predicate = {
      label: vm.columnFilters.label,
      column: vm.columnFilters.field,
      operation: vm.columnFilters.operations[0],
      values: null,
      value: defaultValue[vm.columnFilters.component] || null,
      valuesLabels: null,
    };

    vm.onPredicateValuesChanges = function () {
      if (vm.predicate.values != null) {
        vm.predicate.valuesLabels = vm.predicate.values.map(function (e) {
          return vm.columnFilters.metadata.find(function (i) {
            return i.key == e;
          })['value'];
        });
      }
    };

    vm.applyFilters = function () {
      $mdDialog.hide(vm.predicate);
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

(function () {
  'use strict';

  angular.module('dashboard').controller('dialogEditData', dialogEditData);

  dialogEditData.$inject = [
    '$scope',
    '$rootScope',
    '$mdDialog',
    'InputListsFactory',
    'ConfigurationFactory',
    'IndicatorsFactory',
    'title',
    'data',
    'schema',
    'list',
    'toastr',
    "translationService"
  ];
  function dialogEditData(
    $scope,
    $rootScope,
    $mdDialog,
    $inputListsFactory,
    $configurationFactory,
    $IndicatorsFactory,
    title,
    data,
    schema,
    list,
    $toastr,
    $translationService
  ) {
    var vm = this;

    vm.title = title;
    vm.data = angular.copy(data);
    vm.schema = schema;
    vm.isloading = false;

    vm.init = function () {
      vm.data = _parseInputDataValues(data);
    };
    vm.init();

    function _parseInputDataValues(data) {
      var inputsData = angular.copy(data);

      angular.forEach(inputsData, function (dataValue, dataIndex) {
        var fieldDefinition = schema[dataIndex.replace('#', '')];

        if (fieldDefinition && dataValue != null) {
          if (fieldDefinition.type == 'timestamp') {
            var a = dataValue.split('T');
            inputsData[dataIndex] = moment(a[0]).toDate();
          }
          if (fieldDefinition.type == 'date') {
            var a = dataValue.split('T');
            inputsData[dataIndex] = moment(a[0], 'YYYY-MM-DD').format(
              'DD-MM-YYYY'
            );
          }
        }
      });

      return inputsData;
    }

    vm.groups = Object.values(schema).reduce(function (ccgroups, item) {
      var ele = item;
      ele.key = item.pk ? '#' + item.key : item.key;
      ele.group =
        !ele.group || ['null', 'NULL', 'undefined'].includes(ele.group)
          ? 'No Group'
          : ele.group;

      (ccgroups[item['group']] = ccgroups[item['group']] || []).push(ele);

      return ccgroups;
    }, {});

    vm.save = function () {
      vm.isloading = true;
      var data = angular.copy(vm.data);
      var listID = angular.copy(list.id);

      var parseData = _parseOutputDataValues(data);

      var dataToSave = {
        dataId: vm.data.__dataId,
        body: JSON.stringify(parseData),
        visible: false,
      };

      $rootScope.loading = false;
      $inputListsFactory
        .saveInputListData(listID, dataToSave)
        .then(function (res) {
          var record = JSON.parse(res[0].body);
            var msg = $translationService.getTranslationController(
            'Record updated successfully',
            'Registro actualizado correctamente',
            'Registro atualizado com sucesso'
            );
          var success = $translationService.getTranslationController(
            'Success',
            'Éxito',
            'sucesso'
          );
          $toastr.success(msg, success);
          $mdDialog.hide(record);
        })
        .catch(function (err) {
          console.error('Error@saveInputListData', err);
          var msg = $translationService.getTranslationController(
            'Error updating record',
            'Error al actualizar los datos',
            'Error en actualitzar el registre'
          );
          var error = $translationService.getTranslationController(
            'Error',
            'Error',
            'Error'
          );
          $toastr.error(msg, error);
        })
        .finally(function (e) {
          $rootScope.loading = false;
          vm.isloading = false;
        });
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    function _parseOutputDataValues(data) {
      var inputsData = angular.copy(data);
      var xschemas = Object.values(vm.schema);

      for (var key in inputsData) {
        var value = data[key];
        if (typeof value === 'boolean') continue;
        if (!value) continue;
        if (value === '') continue;
        if (value.length === 0) continue;

        var fieldDef = xschemas.find(function (sc) {
          return sc.key == key;
        });

        if (!fieldDef) continue;

        if (['long', 'integer', 'double'].includes(fieldDef.type)) {
          inputsData[key] = parseFloat(value);
        }

        if (fieldDef.type == 'time') {
          var timeValue = moment(value);
          inputsData[key] = timeValue.format('HH:mm:ss.SSSSSSSSS');
        }

        if (fieldDef.type == 'timestamp') {
          var timeValue = moment(value);
          inputsData[key] = timeValue.format('YYYY-MM-DDTHH:mm:ss.SSSSSSSSS');
        }

        if (fieldDef.type == 'date') {
          var timeValue = moment(value, 'DD-MM-YYYY');
          inputsData[key] =
            timeValue.format('YYYY-MM-DD') + 'T00:00:00.000000000Z';
        }
      }
      return inputsData;
    }
  }
})();

(function () {
  "use strict";

  angular.module("dashboard").controller("dialogEditDataTable", dialogEditDataTable);

  dialogEditDataTable.$inject = [
    "$scope",
    "$rootScope",
    "$mdDialog",
    "DataTableFactory",
    "title",
    "data",
    "schema",
    "table",
    "toastr",
    "translationService",
  ];
  function dialogEditDataTable(
    $scope,
    $rootScope,
    $mdDialog,
    $dataTableFactory,
    title,
    data,
    schema,
    table,
    $toastr,
    $translationService
  ) {
    var vm = this;
    vm.title = title;
    vm.data = angular.copy(data);
    vm.record = null;
    vm.schema = schema;
    vm.table = table;
    console.log(schema, table);
    vm.tableInfo = {
      columns: [],
    };
    vm.loading = false;
    var pagination = {
      page: 1,
      itemsPerPage: 1000,
      sort: "asc",
      sortBy: "",
    };

    vm.init = function () {
      vm.loading = true;

      var filters = [
        { fieldName: "id_row", operation: "EQUAL", value: vm.data.id_row, values: [null, null] },
      ];

      var promises = [
        $dataTableFactory.getTable(table.tableName, table.schemaName),
        $dataTableFactory.getDataTable(table.tableName, table.schemaName, pagination, filters),
      ];

      Promise.allSettled(promises)
        .then(function (results) {
          vm.tableInfo = results[0].status === "fulfilled" ? results[0].value : {};
          vm.record = results[1].status === "fulfilled" ? results[1].value.data[0] : {};

          vm.tableInfo.columns.forEach(function (col) {
            var extraConfig = vm.schema.find(function (schema) {
              return schema.colName === col.colName;
            });
            col.visible = true;
            col.readonly = false;

            if (extraConfig) {
              col.visible = extraConfig.visible;
              col.readonly = extraConfig.readonly;
            }
          });

          if (vm.record) {
            for (var key in vm.record) {
              if (Object.prototype.hasOwnProperty.call(vm.record, key)) {
                var element = vm.record[key];
                var column = vm.tableInfo.columns.find(function (col) {
                  return col.colName === key;
                });
                if (key === "id_row") continue;

                if (vm.record[key] === null) continue;

                if (!vm.record[key] && column && column.notNull === true) {
                  vm.record[key] = "";
                  continue;
                }

                if (column && column.colType === "date" && element) {
                  vm.record[key] = new Date(element);
                  continue;
                }

                if (column && column.colType === "timestamp" && element) {
                  vm.record[key] = new Date(element);
                  continue;
                }

                if (column && column.colType === "time" && element) {
                  vm.record[key] = new Date("1970-01-01T" + element + "Z");
                  continue;
                }

                if (column && column.colType === "boolean" && element !== null) {
                  vm.record[key] = element === 1 || element === true || element === "true";
                  continue;
                }

                if (["numeric", "integer", "long", "double"].includes(column.colType)) {
                  vm.record[key] = parseFloat(element) || 0;
                  continue;
                }
              }
            }
          }

          vm.loading = false;
        })
        .catch(function (error) {
          console.error(error);
          vm.loading = false;
        });
    };
    vm.init();

    vm.save = function () {
      vm.loading = true;
      var copy = angular.copy(vm.record);
      for (var key in copy) {
        if (Object.prototype.hasOwnProperty.call(copy, key)) {
          var element = copy[key];
          var column = vm.tableInfo.columns.find(function (col) {
            return col.colName === key;
          });

          // console.log(key, element, column);

          if (key === "id_row") continue;

          if (copy[key] === null && column && column.notNull === false) {
            copy[key] = column.colType === "json" ? "{}" : copy[key]
            continue;
          }

          if (copy[key] === null && column && column.notNull === true) {
            copy[key] = null
            continue;
          }

          if (!copy[key] && column.notNull === true) {
            copy[key] = "";
            continue;
          }

          if (column && column.colType === "date" && element) {
            copy[key] = moment(element).format("YYYY-MM-DD");
            continue;
          }

          if (column && column.colType === "timestamp" && element) {
            copy[key] = moment(element).format("YYYY-MM-DD HH:mm:ss");
            continue;
          }

          if (column && column.colType === "time" && element) {
            copy[key] = moment(element).format("HH:mm:ss");
            continue;
          }

          if (column && column.colType === "boolean" && element !== null) {
            copy[key] = element === 1 || element === true || element === "true";
            continue;
          }

          if (["numeric", "integer", "long", "double"].includes(column.colType)) {
            copy[key] = parseFloat(element) || 0;
            continue;
          }
        }
      }

      $dataTableFactory
        .updateTableData(table.tableName, table.schemaName, copy)
        .then(function (response) {
          var msg = $translationService.getTranslationController(
            "Record updated successfully",
            "Registro actualizado correctamente",
            "Registro atualizado com sucesso"
          );
          var success = $translationService.getTranslationController("Success", "Éxito", "Sucesso");
          $toastr.success(msg, success);
          vm.loading = false;
          $mdDialog.hide(copy);
        })
        .catch(function (error) {
          console.error(error);
          vm.loading = false;
          var msg = $translationService.getTranslationController(
            "Error updating record",
            "Error al actualizar los datos",
            "Error en actualitzar el registre"
          );
          var err = $translationService.getTranslationController("Error", "Error", "Error");
          $toastr.error(msg, err);
        });
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.getName = function (colName) {
      var col = vm.schema.find(function (c) {
        return c.colName === colName;
      });
      return col && col.displayName ? col.displayName : colName;
    };
  }
})();

(function () {
  "use strict";

  angular.module("dashboard").controller("dialogCustomReport", dialogCustomReport);

  dialogCustomReport.$inject = [
    "$scope",
    "$mdDialog",
    "FilesStorageFactory",
    "InputListsFactory",
    "SchemasFactory",
    "CustomReportFactory",
    "toastr",
    "selectedItem",
    "$compile",
    "$element",
    "iconsConstants",
    "DataTableFactory",
    "ConfigurationFactory",
  ];
  function dialogCustomReport(
    $scope,
    $mdDialog,
    $filesStorageFactory,
    $inputListsFactory,
    $schemasFactory,
    $customReportFactory,
    $toastr,
    selectedItem,
    $compile,
    $element,
    $iconsConstants,
    $dataTableFactory,
    $ConfigurationFactory
  ) {
    var vm = this;
    vm.currentTab = 0;
    vm.maxTabs = 2;
    vm.loading = true;
    vm.name = "";
    vm.weight = 0;
    vm.description = "";
    // icon
    vm.html = "cep-case";

    vm.types = ["list", "table"];
    vm.type = vm.types[0];

    vm.icons = $iconsConstants.icons;

    vm.reportType = vm.types[1];

    vm.folders = [];
    vm.searchFolderText = "";
    vm.folderSelected = null;
    vm.folderItemChange = folderItemChange;

    vm.fileSelected = null;
    vm.searchFileText = "";
    vm.filesInFolder = [];
    vm.filesInFolderTotalRecords = 0;
    vm.loadingFiles = false;

    vm.inputLists = [];
    vm.listSelected = null;
    vm.searchListText = "";
    vm.searchSchemaText = "";
    vm.searchTableText = "";

    vm.tableSchemaSelected = null;
    vm.tableSelected = null;
    vm.tableSchemas = [];
    vm.tableColumns = [];
    vm.tables = [];
    vm.tableSchemaSelectedChanged = tableSchemaSelectedChanged;
    vm.tableSelectedChanged = tableSelectedChanged;

    vm.storageField = null;
    vm.mode = "create";

    vm.querySearch = querySearch;
    vm.querySearchSchemaTable = querySearchSchemaTable;
    vm.querySearchTable = querySearchTable;
    vm.tableJoinSelectedChanged = tableJoinSelectedChanged;
    vm.querySearchTableJoin = querySearchTableJoin;

    vm.configLookup = [];
    vm.configTableColumns = [];

    vm.schemaFormats = [];

    vm.lookup = {
      columnSource: [],
      tableJoin: null,
      columnJoin: [],
    };

    vm.nextTab = function () {
      vm.currentTab = vm.currentTab + 1;
      if (vm.currentTab > 2) vm.currentTab = 0;
    };

    vm.previousTab = function () {
      vm.currentTab = vm.currentTab - 1;
      if (vm.currentTab < 0) vm.currentTab = 0;
    };

    vm.init = function () {
      vm.loading = true;
      var promises = [
        _getAllFolders(),
        _getLists(),
        getAllTableSchemas(),
        $ConfigurationFactory.getSchemaFormat(),
      ];
      // console.log(selectedItem);
      vm.currentReport = selectedItem;
      vm.mode = "create";

      if (vm.currentReport) {
        vm.mode = "update";
        vm.name = vm.currentReport.name;
        vm.description = vm.currentReport.description || "";
        vm.weight = vm.currentReport.weight || 0;
        vm.html = vm.currentReport.html || "";
        vm.folderSelected = vm.currentReport.folder;
        vm.fileSelected = vm.currentReport.file;
        vm.storageField = vm.currentReport.storageField;
        vm.weight = vm.currentReport.weight;
        vm.html = vm.currentReport.html;
        vm.active = vm.currentReport.active;
        vm.reportType = vm.currentReport.tipo || vm.types[0];
        vm.configLookup = angular.isDefined(vm.currentReport.configLookup)
          ? JSON.parse(vm.currentReport.configLookup)
          : [];
        vm.configTableColumns = angular.isDefined(vm.currentReport.configTableColumns)
          ? JSON.parse(vm.currentReport.configTableColumns)
          : [];

        if (vm.currentReport.tipo === "list") {
          vm.listSelected = vm.currentReport.list.id;
          vm.configTableColumns = [];
        }

        if (vm.currentReport.tipo === "table") {
          vm.tableSchemaSelected = vm.currentReport.table.schemaName;
          vm.tableSelected = vm.currentReport.table.tableName;
          tableSelectedChanged(vm.currentReport.table.tableName);
        }

        promises.push(_getCustomReportById(vm.currentReport.id));
      }

      Promise.allSettled(promises).then(function (res) {
        vm.loading = false;
        // console.log(res);
        if (res[3].status === "fulfilled") {
          vm.schemaFormats = res[3].value.data;
        }
      });
    };
    vm.init();

    $scope.cancel = function () {
      $mdDialog.cancel();
    };

    $scope.save = function () {
      if (!vm.name || vm.name.length === 0) {
        $toastr.warning("Field name is required");
        vm.currentTab = 0;
        return;
      }

      if (!vm.storageField) {
        $toastr.warning("Storage field is required");
        vm.currentTab = 1;
        return;
      }

      if (vm.reportType === "list") {
        if (!vm.listSelected) {
          $toastr.warning("Field name is required");
          vm.currentTab = 1;
          return;
        }
      }

      if (vm.reportType === "table") {
        if (!vm.tableSchemaSelected || !vm.tableSelected) {
          $toastr.warning("empty table schema");
          vm.currentTab = 1;
          return;
        }
      }

      if (!vm.folderSelected || !vm.fileSelected) {
        $toastr.warning("Storege config error");
        vm.currentTab = 2;
        return;
      }

      var report = {
        name: vm.name,
        folder: vm.folderSelected,
        description: vm.description,
        file: vm.fileSelected,
        storageField: vm.storageField,
        weight: vm.weight,
        html: vm.html,
        active: true,
        tipo: vm.reportType,
        configLookup: JSON.stringify(vm.configLookup),
        configTableColumns: JSON.stringify(vm.configTableColumns),
        list: null,
        table: null,
      };

      if (vm.reportType === "list") {
        report.list = {
          id: vm.listSelected.id,
          name: vm.listSelected.name,
        };
        delete report.table;
      }

      if (vm.reportType === "table") {
        report.table = {
          schemaName: vm.tableSchemaSelected,
          tableName: vm.tableSelected,
        };
        delete report.list;
      }

      if (vm.mode === "create") {
        _createCustomReport(report);
      } else {
        report.id = selectedItem.id;
        _updateCustomReport(selectedItem.id, report);
      }
    };

    //- methods
    function _getAllFolders() {
      $filesStorageFactory
        .getFolders()
        .then(function (result) {
          vm.folders = result.data.map(function (folder) {
            return {
              id: folder.id,
              name: folder.name,
              totalFiles: folder.totalFiles,
            };
          });
        })
        .catch(function (err) {});
    }

    function _getFilesInFolder(folderSelecetdId) {
      vm.loadingFiles = true;
      vm.filesInFolder = [];
      $filesStorageFactory
        .getFilesInFolder(folderSelecetdId, {
          pagination: {
            page: 1,
            sort: "asc",
            inTrash: false,
            itemsPerPage: 1000,
          },
          body: {
            column: "extension",
            operation: "=",
            value: "html",
            sortBy: "extension",
            sort: "desc",
          },
        })
        .then(function (result) {
          vm.filesInFolder = result.data
            .filter(function (file) {
              return file.extension === "html";
            })
            .map(function (file) {
              return {
                id: file.id,
                name: file.name,
                extension: file.extension,
              };
            });

          vm.filesInFolderTotalRecords = vm.filesInFolder.length;
          vm.loadingFiles = false;
        })
        .catch(function (err) {
          console.error("error@getFilesInFolder", err);
          vm.loadingFiles = false;
        });
    }

    function _getLists() {
      $inputListsFactory
        .getLists()
        .then(function (result) {
          vm.inputLists = result.lists.map(function (list) {
            var xschema = JSON.parse(list.schema.schema);

            var columns = xschema.definitions[list.schema.name];

            var definitions = Object.keys(columns.properties);

            definitions = definitions.map(function (col) {
              var colrequired = columns.required[0].replace("#", "");
              if (colrequired == col) return "#" + col;
              else return col;
            });

            return {
              id: list.listId,
              name: list.name,
              schema: list.schema.id,
              schemaName: list.schema.name,
              definitions: definitions,
              totalRecords: list.totalRecords,
            };
          });
        })
        .catch(function (err) {
          console.error("error@getLists", err);
        });
    }

    function getAllTableSchemas() {
      $dataTableFactory
        .getAllSchemas()
        .then(function (result) {
          // console.log(result);
          vm.tableSchemas = result;
          var promies = [];
          promies = result.map(function (schema) {
            return $dataTableFactory.getAllTablesBySchemasName(schema);
          });

          return Promise.allSettled(promies)
            .then(function (res) {
              vm.tables = res
                .map(function (item) {
                  if (item.status === "fulfilled") {
                    return item.value;
                  } else {
                    console.error("error@allSettled", item.reason);
                  }
                })
                .flat();
              // console.log(vm.tables);
            })
            .catch(function (err) {
              console.error("error@getAllTablesBySchemasName", err);
            });
        })
        .catch(function (err) {
          console.error("error@getAllTableSchemas", err);
        });
    }

    function _getCustomReportById(id) {
      $customReportFactory
        .getCustomReportById(id)
        .then(function (result) {
          vm.name = result.name;
          vm.description = result.description || "";
          vm.weight = result.weight || 0;
          vm.listSelected = result.list;
          vm.folderSelected = result.folder;
          vm.fileSelected = result.file;
          vm.storageField = result.storageField;
          vm.active = result.active;
          vm.html = result.html;
          vm.mode = "update";
          listItemChange(vm.listSelected);
        })
        .catch(function (err) {
          $state.go("app.custom-reports");
          console.error("error@getCustomReportById", err);
        });
    }

    function _createCustomReport(report) {
      $customReportFactory
        .createCustomReport(report)
        .then(function (res) {
          $mdDialog.hide(res);
        })
        .catch(function (err) {
          console.error("Error@createCustomReport", err);
          $toastr.error(err.response || "Error creating custom report");
        });
    }

    function _updateCustomReport(id, report) {
      $customReportFactory
        .editCustomReport(id, report)
        .then(function (res) {
          $mdDialog.hide(res);
        })
        .catch(function (err) {
          console.error("Error@editCustomReport", err);
          $toastr.error(err.response || "Error updating custom report");
        });
    }

    /// UI METHODS
    function folderItemChange(item) {
      if (item && item.id) _getFilesInFolder(item.id);
    }

    function listItemChange(item) {
      if (!item) return;
      $inputListsFactory
        .getInputList(item.id)
        .then(function (list) {
          var xschema = JSON.parse(list.schema.schema);
          var columns = xschema.definitions[list.schema.name];

          var definitions = Object.keys(columns.properties);

          definitions = definitions.map(function (col) {
            var colrequired = columns.required[0].replace("#", "");
            if (colrequired == col) return "#" + col;
            else return col;
          });

          vm.listSelected = {
            id: list.listId,
            name: list.name,
            schema: list.schema.id,
            schemaName: list.schema.name,
            definitions: definitions,
            totalRecords: list.totalRecords,
          };
        })
        .catch(function (err) {
          console.error("Error@getSchemaByIdOrName", err);
        });
    }

    function tableSchemaSelectedChanged() {
      console.log("tableSchemaSelectedChanged", vm.tableSchemaSelected);
      vm.tableSelected = null;
      vm.tableColumns = [];
      // vm.configTableColumns = [];
      vm.storageField = null;
    }

    function tableSelectedChanged(tableName) {
      console.log("tableSelectedChanged", tableName);

      if (!tableName) return;

      vm.tableColumns = [];
      // vm.configTableColumns = [];
      vm.storageField = null;

      var schemaName = vm.tableSchemaSelected;
      $dataTableFactory
        .getTable(tableName, schemaName)
        .then(function (result) {
          console.log(result);
          var COLUMNS = result.columns
            .filter(function (col) {
              return col.colName != "id_row";
            })
            .sort(function (a, b) {
              if (a.order < b.order) return -1;
              if (a.order > b.order) return 1;
              return 0;
            });

          vm.tableColumns = COLUMNS.map(function (col) {
            return col.colName;
          }).filter(function (col) {
            return col != "id_row";
          });

          if (vm.configTableColumns == null || vm.configTableColumns.length == 0) {
            vm.configTableColumns = COLUMNS.map(function (col) {
              return Object.assign(col, {
                displayName: col.colName,
                visible: true,
                format: null,
                readonly: false,
              });
            });
          }
        })
        .catch(function (err) {
          console.error("Error@getTable", err);
        });
    }
    vm.tableColumnsJoin = [];
    function tableJoinSelectedChanged(tableName) {
      console.log("tableJoinSelectedChanged", tableName);
      vm.tableColumnsJoin = [];
      var schemaName = vm.tableSchemaSelected;

      $dataTableFactory
        .getTable(tableName, schemaName)
        .then(function (result) {
          // console.log(result);
          vm.tableColumnsJoin = result.columns
            .map(function (col) {
              return col.colName;
            })
            .filter(function (col) {
              return col != "id_row";
            });
        })
        .catch(function (err) {
          console.error("Error@getTable", err);
        });
    }

    function querySearch(list, query) {
      if (!query) return list || [];
      if (query === undefined) return list || [];
      return list.filter(function (item) {
        return item.name.toLowerCase().includes(query.toLowerCase());
      });
    }

    function querySearchSchemaTable(list, query) {
      if (!query) return list;
      if (query === undefined) return list;
      return list.filter(function (item) {
        return item.toLowerCase().includes(query.toLowerCase());
      });
    }
    function querySearchTableJoin(list) {
      return list
        .filter(function (item) {
          return item.schemaName == vm.tableSchemaSelected;
        })
        .map(function (item) {
          return item.tableName;
        })
        .filter(function (item) {
          return item != vm.tableSelected;
        });
    }

    vm.tablesFound = 0;
    function querySearchTable(list, query) {
      if (!vm.tableSchemaSelected) return [];

      var listFiltered = list
        .filter(function (item) {
          return item.schemaName == vm.tableSchemaSelected;
        })
        .map(function (item) {
          return item.tableName;
        });
      vm.tablesFound = listFiltered.length;
      if (!query) return listFiltered;
      if (query === undefined) return listFiltered;
      return listFiltered.filter(function (item) {
        return item.toLowerCase().includes(query.toLowerCase());
      });
    }

    vm.addLookup = function () {
      if (!vm.lookup.columnSource || !vm.lookup.tableJoin || !vm.lookup.columnJoin) {
        return;
      }

      if (vm.lookup.columnSource.length === 0 || vm.lookup.columnJoin.length === 0) {
        return;
      }

      var string =
        vm.lookup.columnSource.join(",") +
        ":" +
        vm.lookup.tableJoin +
        ":" +
        vm.lookup.columnJoin.join(",");

      vm.configLookup.push(string);
      vm.lookup.columnSource = [];
      vm.lookup.tableJoin = null;
      vm.lookup.columnJoin = [];
    };

    vm.removeLookup = function (index) {
      vm.configLookup.splice(index, 1);
    };

    /// HTML
    vm.compileHtml = function () {
      // console.log("compileHtml");
      var html = $compile(vm.html)($scope);
      $element.find("#customHtmlTemplate").html(html);
    };

    vm.searchTextSource = "";
    vm.selectedItemSource = null;
    vm.querySearchSource = function (query) {
      if (!query) return vm.tableColumns || [];
      if (query === undefined) return vm.tableColumns || [];
      return vm.tableColumns.filter(function (item) {
        return item.toLowerCase().includes(query.toLowerCase());
      });
    };

    vm.searchTextJoin = "";
    vm.selectedItemJoin = null;
    vm.querySearchJoin = function (query) {
      if (!query) return vm.tableColumnsJoin || [];
      if (query === undefined) return vm.tableColumnsJoin || [];
      return vm.tableColumnsJoin.filter(function (item) {
        return item.toLowerCase().includes(query.toLowerCase());
      });
    };

  }
})();

"use strict";

var app = angular.module("dashboard");

app.component("customReportsList", {
  templateUrl: "app/custom-reports/custom-reports-list/custom-reports-list.html",
  controllerAs: "ctrl",
  controller: customReportsListController,
});

customReportsListController.$inject = [
  "$scope",
  "$rootScope",
  "$mdDialog",
  "toastr",
  "translationService",
  "$state",
  "CustomReportFactory",
];
function customReportsListController(
  $scope,
  $rootScope,
  $mdDialog,
  $toastr,
  $translationService,
  $state,
  $customReportFactory
) {
  var vm = this;
  var originatorEv;

  $translationService.getTranslation(vm, "dashboard");

  vm.customReports = [];
  _getAllCustomReport();

  vm.openMenu = function ($mdMenu, ev) {
    originatorEv = ev;
    $mdMenu.open(ev);
  };

  function _getAllCustomReport() {
    $customReportFactory
      .getCustomReports({
        active: true,
        itemsPerPage: 999,
        page: 1,
        orderBy: "name",
        sort: "asc",
      })
      .then(function (result) {
        vm.customReports = result.data.sort(function (a, b) {
          return parseFloat(a.weight) - parseFloat(b.weight);
        });
      })

      .catch(function (err) {
        console.error("error@_getAllCustomReport", err);
      });
  }

  vm.openCustomReport = function (report) {
    $state.go("app.custom-report", {
      // category: $state.params.category,
      report: report.name,
      reportId: report.id,
    });
  };

  vm.showCustomReportDialog = function (selectedItem) {
    $mdDialog
      .show({
        multiple: true,
        controller: "dialogCustomReport",
        templateUrl: "app/custom-reports/dialog/dialog-custom-report.html",
        parent: angular.element(document.body),
        controllerAs: "ctrl",
        // targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        resolve: {
          selectedItem: function () {
            return selectedItem;
          },
        },
      })
      .then(function (result) {
        console.log(result);
        var msg = $translationService.getTranslationController(
          "Configuracion creado exitosamente.",
          "Successfully created config.",
          "Configuração criado com sucesso."
        );
        $toastr.success(msg);
        $mdDialog.hide();
        _getAllCustomReport();
      });
  };

  vm.removeCustomReport = function (_configuration) {
    var confirm = $mdDialog
      .confirm()
      .title(
        $translationService.getTranslationController(
          "Eliminar configuracion",
          "Delete configuracion",
          "Excluir configuracion"
        )
      )
      .textContent(
        $translationService.getTranslationController(
          "¿Estas seguro que quieres borrarlo?",
          "Are you sure you want to delete?",
          "Tem certeza de que deseja excluir?"
        )
      )
      .ok($translationService.getTranslationController("Si", "Yes", "Sim"))
      .cancel($translationService.getTranslationController("No", "No", "Não"));

    $mdDialog.show(confirm).then(
      function () {
        $rootScope.loading = true;
        $customReportFactory.deleteCustomReport(_configuration.id).then(
          function (response) {
            $rootScope.loading = false;
            _getAllCustomReport();
            $state.go("app.custom-reports");
            $toastr.success(
              $translationService.getTranslationController(
                "Configuracion eliminada exitosamente.",
                "Successfully removed config.",
                "Config excluído com sucesso."
              )
            );
          },
          function (error) {
            $rootScope.loading = false;
            var msg = $translationService.getTranslationController(
              "No fue posible eliminar la Formato.",
              "It was not possible to delete the format.",
              "Não foi possível excluir o formato."
            );
            $toastr.error(msg);
            console.log(error);
          }
        );
      },
      function () {}
    );
  };

  vm.showShareCustomReportDialog = function (selectedItem) {
    $mdDialog.show({
      controller: "ShareEntityController",
      templateUrl: "app/acl/component/dialog-share-entity.html",
      parent: angular.element(document.body),

      clickOutsideToClose: false,
      locals: {
        selectedItem: {
          id: selectedItem.id,
          resource: "custom-report",
          name: selectedItem.name,
          rawitem: selectedItem,
        },
        actions: ["read", "read_storage", "upload", "download"],
      },
    });
  };

  vm.editHtml = function(report) {
    $state.go("app.custom-report-html", {
      reportId: report.id,
    });
  }
}

'use strict';

var app = angular.module('dashboard');

app.component('customReportInboxMenu', {
  templateUrl: 'app/custom-reports/components/inbox-menu.html',
  controllerAs: 'ctrl',
  bindings: {
    title: '@',
    currentView: '<',
    currentIssue: '<',
    selectedRows: '<',
    linkIssuesFn: '&',
    exportIssuesFn: '&',
    issueListFilters: '<',
  },
  controller: customReportInboxMenuController,
});

customReportInboxMenuController.$inject = [
  '$scope',
  '$rootScope',
  '$state',
  'translationService',
  'PermissionsFactory',
  'IssuesFactory',
  '$localStorageService',
];
function customReportInboxMenuController(
  $scope,
  $rootScope,
  $state,
  $translationService,
  $permissionsFactory,
  IssuesFactory,
  $localStorageService
) {
  var vm = this;
  vm.counters = {};
  $rootScope.loading = false;

  //* sidebar counter

  vm.init = function () {
    $rootScope.loading = false;
 
    // var promises = [];
    // // promises.push(vm.getIssuesTypes());
    // // promises.push(vm.getCounters());
    // promises.push(vm.getIssuesCustomViews());

    // Promise.all(promises).then(function () {
    //   $rootScope.loading = false;
    // });
  };


  vm.getIssuesCustomViews = function () {
    return new Promise(function (resolve, reject) {
      IssuesFactory.getIssuesCustomViews()
        .then(function (res) {
          vm.customViews = res.data;
          resolve();
        })
        .catch(function (err) {
          console.error('Error@getIssuesCustomViews', err);
          reject();
        });
    });
  };

  // vm.init();


  vm.openCustomView = function (view) {
    $state.go('app.dashboard', {
      category: $state.params.category,
      issue: view.name,
    });
  };

  vm.goToCatg = function (catg) {
    console.log(catg);
    $state.go('app.dashboard', { category: catg.name });
  };

  vm.openTab = function (type) {
    console.log(type);
    $state.go('app.dashboard', {
      category: $state.params.category,
      issue: type,
    });
  };
}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('commentsDialogController', commentsDialogController);

  commentsDialogController.$inject = [
    '$mdDialog',
    'translationService',
    'CommentsFactory',
    'toastr',
    'itemid',
    'target',
  ];
  function commentsDialogController(
    $mdDialog,
    $translationService,
    CommentsFactory,
    toastr,
    itemid,
    target
  ) {
    var vm = this;
    $translationService.getTranslation(vm, 'dashboard');

    vm.itemid = itemid;
    vm.target = target;

    vm.comment = '';

    vm.save = function () {
      CommentsFactory.sendCommentByTarget(vm.target, vm.itemid, vm.comment)
        .then(function () {
          $mdDialog.hide();
        })
        .catch(function (err) {
          console.error('Err@getcomments', err);
          toastr.warning(err.data);
        });
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

"use strict";

var app = angular.module("dashboard");

app.component("commentsList", {
  templateUrl: "app/custom-reports/comments/comments.html",
  controllerAs: "ctrl",
  bindings: {
    comments: "=",
  },
  controller: commentsListController,
});

commentsListController.$inject = [
  "$scope",
  "$mdDialog",
  "CommentsFactory",
  "translationService",
  "PermissionsFactory",
];

function commentsListController(
  $scope,
  $mdDialog,
  $commentsFactory,
  $translationService,
  $permissionsFactory
) {
  var vm = this;

  $translationService.getTranslation(vm, "dashboard");

  vm.validatePermission = function (permission) {
    return $permissionsFactory.hasPermission(permission);
  };

  vm.printable = false;
  vm.data = [];
  vm.schema = {};
  vm.loading = true;

  vm.filters = {
    pagination: {
      page: 1,
      itemsPerPage: 50,
    },
  };

  vm.columnDefs = [
    {
      name: "author",
      displayName: $translationService.getTranslationController("Autor", "Author", "Author"),
      type: "string",
      field: "author",
      // General column properties
      enableColumnMenu: true,
      enableSorting: true,
      enableHiding: false,
      width: "*",
    },
    {
      name: "comment",
      displayName: $translationService.getTranslationController("Comentario", "Comment", "Comente"),
      type: "string",
      field: "comment",
      // General column properties
      enableColumnMenu: true,
      enableSorting: true,
      enableHiding: false,
      width: "*",
      cellTemplate:
        '<div class="ui-grid-cell-contents" title="{{row.entity.comment}}"> <md-tooltip md-direction="top">ver mas</md-tooltip>{{row.entity.comment}}</div>',
    },
    {
      name: "Created",
      displayName: $translationService.getTranslationController("Creado", "Created", "Criado"),
      type: "date",
      field: "timestamp",
      // General column properties
      enableColumnMenu: true,
      enableSorting: true,
      enableHiding: false,
      width: "*",
    },
  ];

  vm.init = function () {
    getData();
  };

  vm.init();

  vm.gridOptions = {
    index: "docs",
    data: [],
    schema: {},
    // Grid pagination options
    paginationPageSizes: [25, 50, 100],
    paginationPageSize: 50,
    totalItems: 0,
    useExternalPagination: true,
    useExternalSorting: true,
    columnDefs: vm.columnDefs,
    minimumColumnSize: 100,
    enableColumnResizing: true,
    rowTemplate:
      '<div ng-click="grid.appScope.ctrl.showComment(row.entity)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>',
    onRegisterApi: function (gridApi) {
      $scope.gridApi = gridApi;
      gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
        vm.filters.pagination.page = newPage;
        vm.filters.pagination.itemsPerPage = pageSize;
        getData();
      });
      gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        var sort = vm.filters.pagination.sort == "desc" ? "asc" : "desc";
        vm.filters.pagination.sort = sort;
        getData();
      });
    },
  };

  function getData() {
    vm.loading = true;
    
    vm.comments = Object.assign({columnDefs:[]}, vm.comments);
    vm.comments.columnDefs = vm.columnDefs;
    
    var target = "CLIENT_CARD";
    var storageField = "custom_report_" + vm.comments.customReport + "_" + vm.comments.storageField;
    $commentsFactory
      .getCommentsByTargetAndId(target, storageField)
      .then(function (res) {
        var mapp = res.map(function (e) {
          e.author = e.author.fullName;
          e.timestamp = moment(e.timestamp).format("YYYY-MM-DD");
          return e;
        });
        vm.comments.data = mapp;
        vm.comments.totalRecords = mapp.length;
        vm.gridOptions.data = mapp;
        vm.loading = false;
      })
      .catch(function (err) {
        console.error("Err@getAllFilesInFolder", err);
      });
  }

  vm.sendComment = function () {
    var target = "CLIENT_CARD";
    var storageField = "custom_report_" + vm.comments.customReport + "_" + vm.comments.storageField;
    console.log("storageField", storageField);
    $mdDialog
      .show({
        controller: "commentsDialogController",
        controllerAs: "ctrl",
        templateUrl: "app/custom-reports/comments/dialog-comments.html",
        locals: {
          itemid: storageField,
          target: target,
        },
      })
      .then(function () {
        getData();
      });
  };

  $scope.$on("reloadCommnets", function () {
    getData();
  });

  vm.showComment = function (row) {
    console.log(row);
    $mdDialog.show(
      $mdDialog
        .alert()
        .parent(null)
        .clickOutsideToClose(true)
        .title(row.author + " - " + row.timestamp)
        .textContent(row.comment)
        .ariaLabel("Comment Dialog ")
        .ok("ok")
        .targetEvent(null)
    );
  };
}

/* Servicio encargado de hacer setear los URL */
(function () {
  "use strict";

  angular.module("dashboard").service("treeChartService", treeChartService);

  function treeChartService() {
    this.getLevelOption = function () {
      var color = "#313131";
      return [
        {
          itemStyle: {
            borderColor: color,
            borderWidth: 0,
            gapWidth: 1,
          },
          upperLabel: {
            show: true,
          },
        },
        {
          itemStyle: {
            borderColor: color,
            borderWidth: 5,
            gapWidth: 1,
          },
          emphasis: {
            itemStyle: {
              borderColor: color,
            },
          },
        },
        {
          // colorSaturation: [0.35, 0.5],
          itemStyle: {
            borderWidth: 5,
            gapWidth: 1,
            borderColorSaturation: 0.6,
          },
        },
      ];
    };
    this.labelFormatter = function (info) {
      var v = new Intl.NumberFormat("ES").format(info.data.value);
      return info.data.name + "\nValor: " + v;
    };
  }
})();

/* Servicio encargado de hacer setear los URL */
(function () {
  "use strict";

  angular.module("dashboard").service("chartTooltip", chartTooltip);

  var DEFAULT_TOOLTIP = {
    trigger: "axis",
    axisPointer: {
      type: "cross",
      label: {
        backgroundColor: "#283b56",
      },
    },
  };

  function DEFAULT_INFO(info) {
    return (
      info.marker +
      " " +
      info.name +
      "<br>" +
      new Intl.NumberFormat("ES").format(info.value)
    );
  }

  var tooltipByComponent = {
    treemap: function (info) {
      if (info.componentSubType != "treemap") return DEFAULT_INFO(info);
      return info.treePathInfo
        .map(function (item, i) {
          var isLast = i === info.treePathInfo.length - 1;
          return item.name + (isLast ? "<br>Valor : " + item.value : "<br>");
        })
        .join("\n");
    },
    boxplot: function (info) {
      if (info.componentSubType != "boxplot") return DEFAULT_INFO(info);

      var values = info.value.sort(function (a, b) {
        return a - b;
      });
      return (
        info.name +
        "<br>" +
        info.dimensionNames
          .map(function (e, i) {
            var v = new Intl.NumberFormat("ES").format(values[i]);
            return e + ": " + v;
          })
          .filter(function (e) {
            return e.startsWith("base") == false;
          })
          .reverse()
          .join("<br>")
      );
    },
  };

  function chartTooltip() {
    this.setTooltipByComponent = function (serieType) {
      if (serieType in tooltipByComponent) {
        return {
          formatter: tooltipByComponent[serieType],
        };
      } else {
        return DEFAULT_TOOLTIP;
      }
    };
  }
})();

/* Servicio encargado de hacer setear los URL */
(function () {
  "use strict";

  angular.module("dashboard").service("chartService", chartService);

  chartService.$inject = ["$filter"];

  function chartService($filter) {
    this.formatValueSerie = function (value, format) {
      var formats = {
        //- Decimal
        D: $filter("number")(parseFloat(value.toFixed(format.unid || 2))),
        //- thousands
        K: $filter("number")(parseFloat(value * 0.001), 0) + "K",
        //- millions
        M: $filter("number")(parseFloat(value * 0.000001), 0) + "M",
        // - billions
        B: $filter("number")(parseFloat(value * 0.0000001), 0) + "B",
        // - R (round)
        R: $filter("number")(value, 0),
        // - SF (Without Format - Sin formato UwU)
        SF: value,
      };

      return formats[format.format] || value;
    };

    this.formatNumber = function (number) {
      return $filter("number")(number, 0);
    };

    this.randColor = function (index, chartCustomColors) {
      var color = "#000000";
      if (chartCustomColors && index <= chartCustomColors.length - 1)
        color = chartCustomColors.find(function (e, i) {
          return i == index;
        });
      else {
        color = "#000000".replace(/0/g, function () {
          return (~~(Math.random() * 16)).toString(16);
        });
      }
      return color;
    };

    this.getColorStored = function (hasStoredData, name) {
      if (hasStoredData && hasStoredData.data && Array.isArray(hasStoredData.data)) {
        var stored = hasStoredData.data.find(function (e) {
          return e.name == name;
        }) || {
          itemStyle: {
            color: null,
          },
        };
        return angular.isDefined(stored.itemStyle.color) ? stored.itemStyle.color : null;
      }
      return null;
    };

    this.setBoxplotValues = function (chartData, hasStoredData, chartCustomColors, metadata) {
      var BOXPLOT = [];
      var self = this;

      if (!metadata) return;

      var MTD = JSON.parse(metadata);

      chartData.xAxis.forEach(function (e, i) {
        //[min,  Q1,  median,  Q3,  max]
        var set = [
          chartData.yAxis[MTD.max][i],
          chartData.yAxis[MTD.Q3][i],
          chartData.yAxis[MTD.mid][i],
          chartData.yAxis[MTD.Q1][i],
          chartData.yAxis[MTD.min][i],
        ];

        BOXPLOT.push({
          value: set,
          name: e,
          itemStyle: {
            borderWidth: "1",
            borderColor: "#000000",
            color: self.getColorStored(hasStoredData, e) || self.randColor(i, chartCustomColors),
          },
        });
      });

      return BOXPLOT;
    };

    this.setSerieValues = function (
      data,
      chartData,
      hasStoredData,
      chartCustomColors,
      metadata,
      serieColor
    ) {
      var self = this;
      var next_color = 0;
      return data.map(function (value, i) {
        var barName = chartData.xAxis[i];

        var _THE_COLOR = null;
        _THE_COLOR = self.getColorStored(hasStoredData, barName);

        if (!_THE_COLOR) {
          _THE_COLOR = serieColor;
          next_color++;
        }

        var set = {
          value: value,
          name: barName,
          itemStyle: {
            color: _THE_COLOR,
          },
        };
        return set;
      });
    };

    this.setTreeMapValues = function (data, chartData, hasStoredData, chartCustomColors) {
      var self = this;
      return data.map(function (item, i) {
        return {
          value: item.value,
          name: item.name,
          children: item.children,
          itemStyle: {
            color:
              self.getColorStored(hasStoredData, item.name) || self.randColor(i, chartCustomColors),
          },
        };
      });
    };

    this.max_min_yaxis = function (yAxis) {
      var values = [];
      for (var key in yAxis) {
        if (Object.hasOwnProperty.call(yAxis, key)) {
          values = values.concat(yAxis[key]);
        }
      }
      var maxValue = Math.max.apply(null, values);
      var minValue = Math.min.apply(null, values);
      var prom = maxValue / values.length;
      return {
        max: maxValue,
        min: minValue,
        prom: prom,
      };
    };

    this.calMinValue = function (yAxis) {
      var val = this.max_min_yaxis(yAxis);
      return parseFloat(val.min);
    };

    this.processMarkLineData = function (markLineDef) {
      var markLine = {
        data: [],
      };
      if (!markLineDef) return markLine;
      if (!markLineDef.length) return markLine;
      if (!markLineDef[0].data.length) return markLine;

      markLine.data = markLineDef[0].data.flat();

      return markLine;
    };

    this.seriesLegend = function (series) {
      if (series.length > 0) {
        if (series[0].type == "pie") {
          return {
            type: "scroll",
            orient: "vertical",
            right: 10,
            top: 20,
            bottom: 20,
            data: series[0].data.map(function (s) {
              return s.name;
            }),
          };
        } else {
          return {
            type: "scroll",
            data: series.map(function (s) {
              return s.name;
            }),
          };
        }
      }
    };
  }
})();

'use strict';

var app = angular.module('dashboard');

app.component('chartItem', {
  templateUrl: 'app/charts/list-componest/chart-item.html',
  controllerAs: 'ctrl',
  bindings: {
    chart: '=',
    translation: '<',
  },
  controller: chartItemController,
});

chartItemController.$inject = [
  '$scope',
  '$rootScope',
  'ChartsFactory',
  '$mdDialog',
  'toastr',
  'PermissionsFactory',
];
function chartItemController(
  $scope,
  $rootScope,
  ChartsFactory,
  $mdDialog,
  toastr,
  $permissionsFactory
) {
  var vm = this;

  vm.totab = function (item) {
    $rootScope.$broadcast('openChartTabByID', item.id);
  };
  vm.deleteChart = function (chartId) {
    $rootScope.loading = true;
    ChartsFactory.deleteChart(chartId)
      .then(function (res) {
        $rootScope.$broadcast('refreshListCharts', res);
        toastr.info('Grafica Eliminada');
        $rootScope.loading = false;
      })
      .catch(function (err) {
        console.error('Error@deleteChart', err);
        $rootScope.loading = false;
      });
  };

  vm.confirmDeleteChart = function (chartId, ev) {
    var confirm = $mdDialog
      .confirm()
      .title('Seguro deseas Eliminar esta Grafica?')
      .textContent(
        'Se eliminaran todos los archivos contenidos permanentemente'
      )
      .ariaLabel('deleteChart')
      .targetEvent(ev)
      .ok('Si, borrala!')
      .cancel('Cancelar');

    $mdDialog.show(confirm).then(
      function () {
        vm.deleteChart(chartId);
      },
      function () {
        toastr.info('Cancelado');
      }
    );
  };

  vm.saveChart = function (chart) {
    $rootScope.loading = true;
    $scope.isLoading = true;
    ChartsFactory.saveChart(chart)
      .then(function (res) {
        toastr.success('Chart ' + chart.name + ' saved');
        $rootScope.loading = false;
        $scope.isLoading = false;
        $permissionsFactory.addPermission(
          'graphic-report',
          res.id,
          'all',
          true
        );
        $rootScope.$broadcast('refreshListCharts', res);
        $mdDialog.cancel();
      })
      .catch(function (err) {
        toastr.error('error:: ' + err);
        console.error('Error@saveChart', err);
        $rootScope.loading = false;
      });
  };

  vm.duplicate = function (chart) {
    var confirm = $mdDialog
      .prompt()
      .title('Quieres duplicar esta grafica?')
      .textContent('Nombre')
      .placeholder('name')
      .ariaLabel('name')
      .initialValue(chart.name + ' - copy')
      .required(true)
      .ok('Ok')
      .cancel('Cancel');

    $mdDialog.show(confirm).then(function (result) {
      var copyChart = angular.copy(chart);
      copyChart.name = result;
      copyChart.id = null;
      vm.saveChart(copyChart);
    });
  };

  vm.manageChart = function (chart) {
    var chartConfig = angular.copy(chart);
    $mdDialog.show({
      controller: 'WizardDialogController',
      controllerAs: 'ctrl',
      templateUrl: 'app/charts/components/wizard-dialog/wizard-dialog.html',
      parent: angular.element(document.body),
      clickOutsideToClose: false,
      locals: {
        chartConfig: chartConfig,
        groupPath: null,
      },
    });
  };

  vm.showShareEntityDialog = function (selectedItem) {
    $mdDialog.show({
      controller: 'ShareEntityController',
      templateUrl: 'app/acl/component/dialog-share-entity.html',
      parent: angular.element(document.body),
      clickOutsideToClose: false,
      locals: {
        selectedItem: {
          id: selectedItem.id,
          resource: 'graphic-report',
          name: selectedItem.name,
        },
        actions: ['read', 'update', 'delete'],
      },
    });
  };
}

'use strict';

var app = angular.module('dashboard');

app.component('chartGroups', {
  templateUrl: 'app/charts/list-componest/chart-groups.html',
  controllerAs: 'ctrl',
  bindings: {
    group: '=',
    translation: '<',
  },
  controller: chartGroupsController,
});

chartGroupsController.$inject = ['$scope', '$rootScope'];
function chartGroupsController($scope, $rootScope) {
  var vm = this;

  vm.group.subGroup = [];
  for (var key in vm.group) {
    var val = vm.group[key];
    if (key.includes('folder:')) vm.group.subGroup.push(val);
  }

  vm.toggleItems = function () {
    vm.group.isOpen = !vm.group.isOpen;
  };

  $scope.$on('displayItems', function (e, display) {
    vm.displayItems = display;
    vm.group.isOpen = display;
    vm.group.subGroup = [];
    for (var key in vm.group) {
      var val = vm.group[key];
      if (key.includes('folder:')) vm.group.subGroup.push(val);
    }
  });

  vm.newChart = function () {
    $rootScope.$broadcast('newChart', vm.group.path);
  };
}

/**
 * Ceptinel base transformation types
 */
(function () {
  "use strict";

  angular.module("dashboard").constant("chartConstants", {
    echartConfig: {
      xAxis: {
        type: "category",
        data: [],
        boundaryGap: true,
        nameGap: 30,
        splitArea: {
          show: false,
        },
        axisLabel: {
          formatter: "{value}",
        },
        splitLine: {
          show: false,
        },
      },
      yAxis: {
        type: "value",
        splitArea: {
          show: true,
        },
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          label: {
            backgroundColor: "#283b56",
          },
        },
      },
      legend: {
        left: "right",
        top: "top",
        type: "scroll",
      },
      dataZoom: [
        {
          type: "inside",
        },
        {
          type: "slider",
          start: 10,
          end: 90,
          zlevel: 99,
          z: 99,
          showDetail: false,
        },
      ],
      grid: {
        left: 5,
        right: 5,
        containLabel: true,
      },
      formatValuesBy: { format: "R", unid: 2 },
      markline: [
        {
          data: [],
        },
      ],
    },
    pieChartMultiChart: {
      radius: "20%",
      center: ["84%", "20%"],
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b} : {c} ({d}%)",
      },
      label: {
        show: false,
      },
    },
    pieChartSingle: {
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b} : {c} ({d}%)",
      },
      legend: {
        type: "scroll",
        orient: "vertical",
        right: 10,
        top: 20,
        bottom: 20,
      },
    },
    serieDefault: {
      name: "",
      type: "",
      connectNulls: true,
      label: {
        show: false,
        fontWeight: "bold",
        fontSize: 18,
        position: "top",
      },
      color: "#000000",
      markLine: [],
    },
  });
})();

"use strict";

var app = angular.module('dashboard');

app.component('casesKanban', {
  templateUrl: 'app/cases/components/kanban.html',
  controllerAs: 'kanban',
  bindings:{
    ref:'<',
    data:'=',
  },
  controller: casesKanbanController,
});

casesKanbanController.$inject = ['$scope','$mdDialog','CaseFactory','translationService','toastr','$rootScope'];
function casesKanbanController($scope,$mdDialog,CaseFactory,$translationService,toastr,$rootScope) {
    $translationService.getTranslation($scope, 'cases');

    var vm = this;
    vm.max = vm.data.length-1;
    vm.slots = vm.data.map(function(e){return e.name});
    $scope.isloading = false;

    $scope.sortableOptionsList = {
      placeholder: "app",
      connectWith: '.container-'+vm.ref,
      receive: function (event, ui) {
        var target = event.target.id;
        var sender = ui.sender[0].id;
        var item_case = JSON.parse(ui.item[0].dataset.case);
        var indexTarget = vm.slots.indexOf(target);
        var indexSender = vm.slots.indexOf(sender);

        if(indexTarget === vm.max){ // case closed
          vm.closeCase(item_case,target,sender,event)

        }else if(indexSender === vm.max && indexTarget != vm.max ){// case reopen
          vm.reOpenCase(item_case,target,event)
          
        }else{ // moved - no closed
          vm.movedCase(item_case,target,event)
          var msg = $translationService.getTranslationController('Caso movido a ', 'Case moved to', 'Caso movido para ')
          var caseMovedTo = msg;
          toastr.info(caseMovedTo+' '+target);
        }
      }
    };

    vm.details = function(itemCase){
      $scope.$parent.$parent.cases.crearTabDetalleCaso(itemCase)
    }

    vm.closeCase = function (tab,target,sender, ev) {
      var confirm = $mdDialog.prompt()
          .title($translationService.getTranslationController('Cerrar caso', 'Close case', 'Fechar caso'))
          .textContent($translationService.getTranslationController(
              'Ingrese un pequeño mensaje que justifique el cierre del caso.',
              'Enter a small message justifying the closure of the case.',
              'Digite uma pequena mensagem justificando o encerramento do caso.')
          )
          .placeholder($translationService.getTranslationController('Comentario aquí', 'Comment here', 'Comente aqui'))
          .ariaLabel('Close case dialog')
          .targetEvent(ev)
          .required(true)
          .ok($translationService.getTranslationController('Cerrar caso', 'Close case', 'Fechar caso'))
          .cancel($translationService.getTranslationController('Cancelar', 'Cancel', 'Cancelar'));

      $mdDialog.show(confirm)
      .then(function (comment) {
          performCloseCase(tab,target,comment);
      },function(){//cancel
          vm.data[vm.slots.indexOf(sender)].cases.unshift(tab);
          vm.data[vm.slots.indexOf(target)].cases.pop();
          toastr.info($translationService.getTranslationController('Cierre cancelado', 'Closure canceled', 'Encerramento cancelado'));
      });
    };

    function performCloseCase(tab, status,comment) {
        $scope.isloading = true;
        CaseFactory.updateStatusCase(
            tab.caseId,
            status,
            comment).then(function (res){
              tab.state = status;
              //-console.log(res);
              
              vm.data[vm.slots.indexOf(status)].cases.find(function(item){return item.caseId === tab.caseId})
              .closingReason = comment;

              vm.data[vm.slots.indexOf(status)].cases.find(function(item){return item.caseId === tab.caseId})
              .state = status;

              //-console.log(itemcase);

              var msg = $translationService.getTranslationController('Caso cerrado', 'Case closed', 'Caso encerrado');
              toastr.success(msg);        }).catch(function (error) {
            if (error.status == 403) {
                toastr.error($translationService.getTranslationController('Usuario no autorizado.', 'Unauthorized User.', 'Usuário não autorizado.'));
            } else {
                toastr.error(error);
            }
        }).finally(function () {
            $rootScope.loading = false;
            $scope.isloading = false;
        })
    }

    vm.reOpenCase = function (tab,status) {
        $scope.isloading = true;
        CaseFactory.updateStatusCase(tab.caseId, status, undefined).then(function (res) {
            tab.state = status;
            vm.data[vm.slots.indexOf(status)].cases.find(function(item){return item.caseId === tab.caseId}).state = status;
            $scope.$apply();
            var msg = $translationService.getTranslationController('Caso abierto', 'Case opened', 'Caso aberto');
            toastr.success(msg);
        }).catch(function (error) {
            $rootScope.loading = false;
            if (error.status == 403) {
                toastr.error($translationService.getTranslationController('Usuario no autorizado.', 'Unauthorized User.', 'Usuário não autorizado.'));
            } else {
                toastr.error(error);
            }
        }).finally(function(){
          $scope.isloading = false;
        })
    };

    vm.movedCase = function (tab,status) {
        $scope.isloading = true;
        CaseFactory.updateStatusCase(tab.caseId, status, undefined).then(function (res) {
            tab.state = status;
            vm.data[vm.slots.indexOf(status)].cases.find(function(item){return item.caseId === tab.caseId}).state = status;
            $scope.$apply();
            // var msg = $translationService.getTranslationController('Caso abierto', 'Case opened', 'Caso aberto');
            toastr.success(msg);
        }).catch(function (error) {
            $rootScope.loading = false;
            if (error.status == 403) {
                toastr.error($translationService.getTranslationController('Usuario no autorizado.', 'Unauthorized User.', 'Usuário não autorizado.'));
            } else {
                toastr.error(error);
            }
        }).finally(function(){
          $scope.isloading = false;
        })
    };


}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('auditFiltersDialog', auditFiltersDialog);

  auditFiltersDialog.$inject = ['$scope', '$mdDialog', 'column', 'UserFactory'];
  function auditFiltersDialog($scope, $mdDialog, column, UserFactory) {
    var vm = this;
    var col = angular.copy(column);
    vm.column = angular.copy(column);

    vm.filter = {
      column: col.key,
      operation: col.operation,
      value: [],
    };

    vm.actionsOptions = [
      { key: 'create', value: 'Create' },
      { key: 'read', value: 'Read' },
      { key: 'update', value: 'Update' },
      { key: 'delete', value: 'Delete' },
      { key: 'import', value: 'Import' },
      { key: 'export', value: 'Export' },
      { key: 'token', value: 'Token' },
      { key: 'execution finished', value: 'Execution Finished' },
      { key: 'execute', value: 'Execute' },
      { key: 'batch', value: 'Batch' },
      { key: 'upload', value: 'Upload' },
      { key: 'download', value: 'Download' },
    ];

    vm.usersOptions = [];
    function getUsersFn() {
      vm.usersOptions = [];
      UserFactory.getAllUsers({})
        .then(function (response) {
          response.data.data.forEach(function (_item) {
            vm.usersOptions.push({
              key: _item.userId,
              value: _item.fullName,
            });
          });
          $scope.$apply();
        })
        .catch(function (e) {
          console.log(e);
        });
    }
    getUsersFn();

    vm.applyFilters = function () {
      $mdDialog.hide(vm.filter);
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

/* Servicio encargado de hacer las traducciones */

(function () {
  'use strict';

  angular.module('dashboard').service('translationService', translationService);

  translationService.$inject = [
    '$resource',
    '$localStorageService',
    'moment',
    'localeEn',
    'localeEs',
    'localePt',
  ];

  function translationService(
    $resource,
    $localStorageService,
    $moment,
    $localeEn,
    $localeEs,
    $localePt
  ) {
    var locales = {
      en: $localeEn,
      es: $localeEs,
      pt: $localePt,
    };

    this.getTranslation = function ($scope, name) {
      var language = this.getLanguage();
      $moment.locale(language);
      var languageFilePath =
        './assets/translations/' + name + '/' + name + '_' + language + '.json';
      $resource(languageFilePath).get(function (data) {
        $scope.translation = data;
      });
    };

    this.getTranslationController = function (spanish, english, portuguese) {
      var language = this.getLanguage();
      if (language == 'es') {
        return spanish;
      } else if (language == 'pt') {
        return portuguese;
      } else {
        return english;
      }
    };

    this.getLanguage = function () {
      var lang;
      var currentUser = $localStorageService.getItem("currentUser");
      // console.log("getLanguage",  currentUser);
      if (
        currentUser == undefined ||
        currentUser.lenguaje == undefined
      ) {
        lang = navigator.language.substr(0, 2);
        if (lang != 'es' && lang != 'en' && lang != 'pt') {
          lang = 'en';
        }
      } else {
        lang = currentUser.lenguaje.toLowerCase();
      }
      return lang;
    };

    this.setLanguage = function (lang) {
      lang = lang.toLowerCase();

      $localStorageService.setItem("currentUser.lenguaje", lang);
      $moment.locale(lang);
    };

    this.getRegion = function () {
      var currentUser = $localStorageService.getItem("currentUser");
      if (currentUser && currentUser.region) {
        return currentUser.region.toLowerCase();
      }

      return 'en';
    };

    this.setRegionalConfigs = function (region, currentLocale) {
      region = region.toLowerCase();

      angular.forEach(currentLocale, function (value, key) {
        currentLocale[key] = locales[region][key];
      });
    };
  }
})();

/* Timezone utils service */

(function () {
  'use strict';

  angular.module('dashboard').service('timezoneService', timezoneService);

  timezoneService.$inject = ['$localStorageService', 'translationService'];
  function timezoneService($localStorageService, $translationService) {
    /**
     * Gets timezones list by user lang
     * @returns {Record<string,string>}
     */
    this.getListTimeZone = function () {
      var list = [
        {
          type: '(GMT-10:00) Hawai',
          value: 'Pacific/Honolulu',
        },
        {
          type: '(GMT-10:00) Isla Aleutianas',
          value: 'America/Adak',
        },
        {
          type: '(GMT-09:30) Islas Marquesas',
          value: 'Pacific/Marquesas',
        },
        {
          type: '(GMT-09:00) Alaska',
          value: 'America/Anchorage',
        },
        {
          type: '(GMT-08:00) Baja California, Tijuana',
          value: 'America/Tijuana',
        },
        {
          type: '(GMT-08:00) Hora del Pacífico (EEUU y Canadá)',
          value: 'America/Los_Angeles',
        },
        {
          type: '(GMT-08:00) Vancouver',
          value: 'America/Vancouver',
        },
        {
          type: '(GMT-07:00) Arizona',
          value: 'America/Phoenix',
        },
        {
          type: '(GMT-07:00) Chihuahua',
          value: 'America/Chihuahua',
        },
        {
          type: '(GMT-07:00) Mazatlán',
          value: 'America/Mazatlan',
        },
        {
          type: '(GMT-07:00) Hora de las Montañas Rocosas (EEUU y Canadá)',
          value: 'America/Denver',
        },
        {
          type: '(GMT-06:00) América Central',
          value: 'America/Chicago',
        },
        {
          type: '(GMT-06:00) Guadalajara',
          value: 'America/Mexico_City',
        },
        {
          type: '(GMT-06:00) Ciudad de México',
          value: 'America/Mexico_City',
        },
        {
          type: '(GMT-06:00) Hora central (EEUU y Canadá)',
          value: 'America/Chicago',
        },
        {
          type: '(GMT-06:00) Monterrey',
          value: 'America/Monterrey',
        },
        {
          type: '(GMT-06:00) Saskatchewan',
          value: 'America/Regina',
        },
        {
          type: '(GMT-05:00) Bogotá',
          value: 'America/Bogota',
        },
        {
          type: '(GMT-05:00) Hora del este (EEUU y Canadá)',
          value: 'America/New_York',
        },
        {
          type: '(GMT-05:00) Indiana (este)',
          value: 'America/Indianapolis',
        },
        {
          type: '(GMT-05:00) Lima',
          value: 'America/Lima',
        },
        {
          type: '(GMT-05:00) Quito',
          value: 'America/Guayaquil',
        },
        {
          type: '(GMT-04:00) Hora del Atlántico',
          value: 'America/Halifax',
        },
        {
          type: '(GMT-04:00) Caracas',
          value: 'America/Caracas',
        },
        {
          type: '(GMT-04:00) Georgetown',
          value: 'America/Guyana',
        },
        {
          type: '(GMT-04:00) La Paz',
          value: 'America/La_Paz',
        },
        {
          type: '(GMT-04:00) Santiago',
          value: 'America/Santiago',
        },
        {
          type: '(GMT-03:00) Punta Arenas',
          value: 'America/Punta_Arenas',
        },
        {
          type: '(GMT-03:30) Terranova',
          value: 'America/St_Johns',
        },
        {
          type: '(GMT-03:00) Brasilia',
          value: 'America/Sao_Paulo',
        },
        {
          type: '(GMT-03:00) Ciudad de Buenos Aires',
          value: 'America/Buenos_Aires',
        },
        {
          type: '(GMT-03:00) Groelandia',
          value: 'America/Godthab',
        },
        {
          type: '(GMT-03:00) Montevideo',
          value: 'America/Montevideo',
        },
        {
          type: '(GMT-02:00) Atlántico Medio',
          value: 'Atlantic/South_Georgia',
        },
        {
          type: '(GMT-01:00) Azores',
          value: 'Atlantic/Azores',
        },
        {
          type: '(GMT-01:00) Cabo Varde',
          value: 'Atlantic/Cape_Verde',
        },
        {
          type: '(GMT+00:00) Casablanca',
          value: 'Africa/Casablanca',
        },
        {
          type: '(GMT+00:00) Dublín',
          value: 'Europe/Dublin',
        },
        {
          type: '(GMT+00:00) Edimburgo',
          value: 'Europe/London',
        },
        {
          type: '(GMT+00:00) Lisboa',
          value: 'Europe/Lisbon',
        },
        {
          type: '(GMT+00:00) Londres',
          value: 'Europe/London',
        },
        {
          type: '(GMT+00:00) Monrovia',
          value: 'Africa/Monrovia',
        },
        {
          type: '(GMT+00:00) UTC',
          value: 'UTC',
        },
        {
          type: '(GMT+01:00) Amsterdam',
          value: 'Europe/Amsterdam',
        },
        {
          type: '(GMT+01:00) Belgrado',
          value: 'Europe/Belgrade',
        },
        {
          type: '(GMT+01:00) Berlín',
          value: 'Europe/Berlin',
        },
        {
          type: '(GMT+01:00) Berna',
          value: 'Europe/Zurich',
        },
        {
          type: '(GMT+01:00) Bratislava',
          value: 'Europe/Bratislava',
        },
        {
          type: '(GMT+01:00) Bruselas',
          value: 'Europe/Brussels',
        },
        {
          type: '(GMT+01:00) Budapest',
          value: 'Europe/Budapest',
        },
        {
          type: '(GMT+01:00) Copenhague',
          value: 'Europe/Copenhagen',
        },
        {
          type: '(GMT+01:00) Liubliana',
          value: 'Europe/Ljubljana',
        },
        {
          type: '(GMT+01:00) Madrid',
          value: 'Europe/Madrid',
        },
        {
          type: '(GMT+01:00) París',
          value: 'Europe/Paris',
        },
        {
          type: '(GMT+01:00) Praga',
          value: 'Europe/Prague',
        },
        {
          type: '(GMT+01:00) Roma',
          value: 'Europe/Rome',
        },
        {
          type: '(GMT+02:00) Ammán',
          value: 'Asia/Amman',
        },
        {
          type: '(GMT+02:00) Atenas',
          value: 'Europe/Athens',
        },
        {
          type: '(GMT+02:00) Bucarest',
          value: 'Europe/Bucharest',
        },
        {
          type: '(GMT+02:00) Beirut',
          value: 'Asia/Beirut',
        },
        {
          type: '(GMT+02:00) Chisinau',
          value: 'Europe/Chisinau',
        },
        {
          type: '(GMT+02:00) Damasco',
          value: 'Asia/Damascus',
        },
        {
          type: '(GMT+02:00) El Cairo',
          value: 'Africa/Cairo',
        },
        {
          type: '(GMT+02:00) Johanesburgo',
          value: 'Africa/Johannesburg',
        },
        {
          type: '(GMT+02:00) Jerusalén',
          value: 'Asia/Jerusalem',
        },
        {
          type: '(GMT+02:00) Jartum',
          value: 'Africa/Khartoum',
        },
        {
          type: '(GMT+02:00) Sofía',
          value: 'Europe/Sofia',
        },
        {
          type: '(GMT+02:00) Tallin',
          value: 'Europe/Tallinn',
        },
        {
          type: '(GMT+02:00) Gaza',
          value: 'Asia/Gaza',
        },
        {
          type: '(GMT+02:00) Hebron',
          value: 'Asia/Hebron',
        },
        {
          type: '(GMT+02:00) Helsinki',
          value: 'Europe/Helsinki',
        },
        {
          type: '(GMT+02:00) Kiev',
          value: 'Europe/Kiev',
        },
        {
          type: '(GMT+02:00) Riga',
          value: 'Europe/Riga',
        },
        {
          type: '(GMT+02:00) Kaliningrado',
          value: 'Europe/Kaliningrad',
        },
        {
          type: '(GMT+02:00) Trípoli',
          value: 'Africa/Tripoli',
        },
        {
          type: '(GMT+02:00) Windhoek',
          value: 'Africa/Windhoek',
        },
        {
          type: '(GMT+03:00) Bagdad',
          value: 'Asia/Baghdad',
        },
        {
          type: '(GMT+03:00) Estambul',
          value: 'Europe/Istanbul',
        },
        {
          type: '(GMT+03:00) Kuwait',
          value: 'Asia/Kuwait',
        },
        {
          type: '(GMT+03:00) Riad',
          value: 'Asia/Riyadh',
        },
        {
          type: '(GMT+03:00) Minsk',
          value: 'Europe/Minsk',
        },
        {
          type: '(GMT+03:00) Moscú',
          value: 'Europe/Moscow',
        },
        {
          type: '(GMT+03:00) Volgogrado',
          value: 'Europe/Volgograd',
        },
        {
          type: '(GMT+03:00) Nairobi',
          value: 'Africa/Nairobi',
        },
        {
          type: '(GMT+03:30) Teherán',
          value: 'Asia/Tehran',
        },
        {
          type: '(GMT+04:00) Abu Dabi',
          value: 'Asia/Dubai',
        },
        {
          type: '(GMT+04:00) Mascate',
          value: 'Asia/Muscat',
        },
        {
          type: '(GMT+04:00) Astrakhan',
          value: 'Europe/Astrakhan',
        },
        {
          type: '(GMT+04:00) Bakú',
          value: 'Asia/Baku',
        },
        {
          type: '(GMT+04:30) Kabul',
          value: 'Asia/Kabul',
        },
        {
          type: '(GMT+05:00) Asjabad, Tashkent',
          value: 'Asia/Tashkent',
        },
        {
          type: '(GMT+05:00) Ekaterimburgo',
          value: 'Asia/Yekaterinburg',
        },
        {
          type: '(GMT+05:00) Islamabad, Karachi',
          value: 'Asia/Karachi',
        },
        {
          type: '(GMT+05:30) Chennai, Kolkata (Calculta), Mumbai, Nueva Delhi',
          value: 'Asia/Calcutta',
        },
        {
          type: '(GMT+05:30) Sri Jayawardenepura',
          value: 'Asia/Colombo',
        },
        {
          type: '(GMT+05:45) Katmandú',
          value: 'Asia/Katmandu',
        },
        {
          type: '(GMT+06:00) Astaná',
          value: 'Asia/Almaty',
        },
        {
          type: '(GMT+06:00) Dacca',
          value: 'Asia/Dhaka',
        },
        {
          type: '(GMT+06:00) Omsk',
          value: 'Asia/Omsk',
        },
        {
          type: '(GMT+06:30) Rangún',
          value: 'Asia/Rangoon',
        },
        {
          type: '(GMT+07:00) Bangkok, Hanói, Yakarta',
          value: 'Asia/Bangkok',
        },
        {
          type: '(GMT+07:00) Barnaul, Gorno-Altaysk',
          value: 'Asia/Barnaul',
        },
        {
          type: '(GMT+07:00) Hovd',
          value: 'Asia/Hovd',
        },
        {
          type: '(GMT+07:00) Krasnoyarsk',
          value: 'Asia/Krasnoyarsk',
        },
        {
          type: '(GMT+07:00) Novosibirsk',
          value: 'Asia/Novosibirsk',
        },
        {
          type: '(GMT+07:00) Tomsk',
          value: 'Asia/Tomsk',
        },
        {
          type: '(GMT+08:00) Irkutsk',
          value: 'Asia/Irkutsk',
        },
        {
          type: '(GMT+08:00) Kuala Lumpur, Singapur',
          value: 'Asia/Singapore',
        },
        {
          type: '(GMT+08:00) Pekín, Chongqing, Hong Kong, Urumqi',
          value: 'Asia/Shanghai',
        },
        {
          type: '(GMT+08:00) Perth',
          value: 'Australia/Perth',
        },
        {
          type: '(GMT+08:00) Taipéi',
          value: 'Asia/Taipei',
        },
        {
          type: '(GMT+08:00) Ulán Bator',
          value: 'Asia/Ulaanbaatar',
        },
        {
          type: '(GMT+08:30) Pyongyang',
          value: 'Asia/Pyongyang',
        },
        {
          type: '(GMT+08:45) Eucla',
          value: 'Australia/Eucla',
        },
        {
          type: '(GMT+09:00) Chita',
          value: 'Asia/Chita',
        },
        {
          type: '(GMT+09:00) Osaka, Sapporo, Tokio',
          value: 'Asia/Tokyo',
        },
        {
          type: '(GMT+09:00) Seúl',
          value: 'Asia/Seoul',
        },
        {
          type: '(GMT+09:00) Yakutsk',
          value: 'Asia/Yakutsk',
        },
        {
          type: '(GMT+09:30) Adelaida',
          value: 'Australia/Adelaide',
        },
        {
          type: '(GMT+09:30) Darwin',
          value: 'Australia/Darwin',
        },
        {
          type: '(GMT+10:00) Brisbane',
          value: 'Australia/Brisbane',
        },
        {
          type: '(GMT+10:00) Canberra, Melbourne, Sídney',
          value: 'Australia/Sydney',
        },
        {
          type: '(GMT+10:00) Guam, Port Moresby',
          value: 'Pacific/Port_Moresby',
        },
        {
          type: '(GMT+10:00) Hobart',
          value: 'Australia/Hobart',
        },
        {
          type: '(GMT+10:00) Vladivostok',
          value: 'Asia/Vladivostok',
        },
        {
          type: '(GMT+10:30) Isla Lord Howe',
          value: 'Australia/Lord_Howe',
        },
        {
          type: '(GMT+11:00) Chokurdakh',
          value: 'Asia/Srednekolymsk',
        },
        {
          type: '(GMT+11:00) Isla Bougainville',
          value: 'Pacific/Bougainville',
        },
        {
          type: '(GMT+11:00) Isla Norfolk',
          value: 'Pacific/Norfolk',
        },
        {
          type: '(GMT+11:00) Isla Salomón, Nueva Caledonia',
          value: 'Pacific/Guadalcanal',
        },
        {
          type: '(GMT+11:00) Magadán',
          value: 'Asia/Magadan',
        },
        {
          type: '(GMT+11:00) Sajalín',
          value: 'Asia/Sakhalin',
        },
        {
          type: '(GMT+12:00) Anadyr, Petropavlovsk-Kamchatsky',
          value: 'Asia/Kamchatka',
        },
        {
          type: '(GMT+12:00) Auckland, Wellington',
          value: 'Pacific/Auckland',
        },
        {
          type: '(GMT+12:00) Fiji',
          value: 'Pacific/Fiji',
        },
        {
          type: '(GMT+12:45) Isla Chatham',
          value: 'Pacific/Chatham',
        },
        {
          type: "(GMT+13:00) Nukuo'lafa",
          value: 'Pacific/Tongatapu',
        },
        {
          type: '(GMT+13:00) Samoa',
          value: 'Pacific/Apia',
        },
        {
          type: '(GMT+13:00) Isla Kiritimati',
          value: 'Pacific/Kiritimati',
        },
      ];

      var list2 = [
        {
          type: '(GMT-10:00) Hawaii',
          value: 'Pacific/Honolulu',
        },
        {
          type: '(GMT-10:00) Aleutian Island',
          value: 'America/Adak',
        },
        {
          type: '(GMT-09:30) Marquesas Islands',
          value: 'Pacific/Marquesas',
        },
        {
          type: '(GMT-09:00) Alaska',
          value: 'America/Anchorage',
        },
        {
          type: '(GMT-08:00) Lower California, Tijuana',
          value: 'America/Tijuana',
        },
        {
          type: '(GMT-08:00) Pacific Time (US y Canada)',
          value: 'America/Los_Angeles',
        },
        {
          type: '(GMT-08:00) Vancouver',
          value: 'America/Vancouver',
        },
        {
          type: '(GMT-07:00) Arizona',
          value: 'America/Phoenix',
        },
        {
          type: '(GMT-07:00) Chihuahua',
          value: 'America/Chihuahua',
        },
        {
          type: '(GMT-07:00) Mazatlan',
          value: 'America/Mazatlan',
        },
        {
          type: '(GMT-07:00) Rocky Mountain Time (US y Canada)',
          value: 'America/Denver',
        },
        {
          type: '(GMT-06:00) Central America',
          value: 'America/Chicago',
        },
        {
          type: '(GMT-06:00) Guadalajara',
          value: 'America/Mexico_City',
        },
        {
          type: '(GMT-06:00) Mexico City',
          value: 'America/Mexico_City',
        },
        {
          type: '(GMT-06:00) Central Time (US y Canada)',
          value: 'America/Chicago',
        },
        {
          type: '(GMT-06:00) Monterrey',
          value: 'America/Monterrey',
        },
        {
          type: '(GMT-06:00) Saskatchewan',
          value: 'America/Regina',
        },
        {
          type: '(GMT-05:00) Bogota',
          value: 'America/Bogota',
        },
        {
          type: '(GMT-05:00) Eastern Time (US y Canada)',
          value: 'America/New_York',
        },
        {
          type: '(GMT-05:00) Indiana (east)',
          value: 'America/Indianapolis',
        },
        {
          type: '(GMT-05:00) Lima',
          value: 'America/Lima',
        },
        {
          type: '(GMT-05:00) Quito',
          value: 'America/Guayaquil',
        },
        {
          type: '(GMT-04:00) Atlantic Standard Time',
          value: 'America/Halifax',
        },
        {
          type: '(GMT-04:00) Caracas',
          value: 'America/Caracas',
        },
        {
          type: '(GMT-04:00) Georgetown',
          value: 'America/Guyana',
        },
        {
          type: '(GMT-04:00) La Paz',
          value: 'America/La_Paz',
        },
        {
          type: '(GMT-04:00) Santiago',
          value: 'America/Santiago',
        },
        {
          type: '(GMT-03:00) Punta Arenas',
          value: 'America/Punta_Arenas',
        },
        {
          type: '(GMT-03:30) Newfoundland',
          value: 'America/St_Johns',
        },
        {
          type: '(GMT-03:00) Brasilia',
          value: 'America/Sao_Paulo',
        },
        {
          type: '(GMT-03:00) Buenos Aires',
          value: 'America/Buenos_Aires',
        },
        {
          type: '(GMT-03:00) Greenland',
          value: 'America/Godthab',
        },
        {
          type: '(GMT-03:00) Montevideo',
          value: 'America/Montevideo',
        },
        {
          type: '(GMT-02:00) Middle Atlantic',
          value: 'Atlantic/South_Georgia',
        },
        {
          type: '(GMT-01:00) Azores',
          value: 'Atlantic/Azores',
        },
        {
          type: '(GMT-01:00) Cape Verde',
          value: 'Atlantic/Cape_Verde',
        },
        {
          type: '(GMT+00:00) Casablanca',
          value: 'Africa/Casablanca',
        },
        {
          type: '(GMT+00:00) Dublin',
          value: 'Europe/Dublin',
        },
        {
          type: '(GMT+00:00) Edinburgh',
          value: 'Europe/London',
        },
        {
          type: '(GMT+00:00) Lisbon',
          value: 'Europe/Lisbon',
        },
        {
          type: '(GMT+00:00) London',
          value: 'Europe/London',
        },
        {
          type: '(GMT+00:00) Monrovia',
          value: 'Africa/Monrovia',
        },
        {
          type: '(GMT+00:00) UTC',
          value: 'UTC',
        },
        {
          type: '(GMT+01:00) Amsterdam',
          value: 'Europe/Amsterdam',
        },
        {
          type: '(GMT+01:00) Belgrade',
          value: 'Europe/Belgrade',
        },
        {
          type: '(GMT+01:00) Berlin',
          value: 'Europe/Berlin',
        },
        {
          type: '(GMT+01:00) Bern',
          value: 'Europe/Zurich',
        },
        {
          type: '(GMT+01:00) Bratislava',
          value: 'Europe/Bratislava',
        },
        {
          type: '(GMT+01:00) Brussels',
          value: 'Europe/Brussels',
        },
        {
          type: '(GMT+01:00) Budapest',
          value: 'Europe/Budapest',
        },
        {
          type: '(GMT+01:00) Copenhagen',
          value: 'Europe/Copenhagen',
        },
        {
          type: '(GMT+01:00) Ljubljana',
          value: 'Europe/Ljubljana',
        },
        {
          type: '(GMT+01:00) Madrid',
          value: 'Europe/Madrid',
        },
        {
          type: '(GMT+01:00) Paris',
          value: 'Europe/Paris',
        },
        {
          type: '(GMT+01:00) Prague',
          value: 'Europe/Prague',
        },
        {
          type: '(GMT+01:00) Roma',
          value: 'Europe/Rome',
        },
        {
          type: '(GMT+02:00) Amman',
          value: 'Asia/Amman',
        },
        {
          type: '(GMT+02:00) Athens',
          value: 'Europe/Athens',
        },
        {
          type: '(GMT+02:00) Bucharest',
          value: 'Europe/Bucharest',
        },
        {
          type: '(GMT+02:00) Beirut',
          value: 'Asia/Beirut',
        },
        {
          type: '(GMT+02:00) Chisinau',
          value: 'Europe/Chisinau',
        },
        {
          type: '(GMT+02:00) Damascus',
          value: 'Asia/Damascus',
        },
        {
          type: '(GMT+02:00) Cairo',
          value: 'Africa/Cairo',
        },
        {
          type: '(GMT+02:00) Johannesburg',
          value: 'Africa/Johannesburg',
        },
        {
          type: '(GMT+02:00) Jerusalem',
          value: 'Asia/Jerusalem',
        },
        {
          type: '(GMT+02:00) Khartoum',
          value: 'Africa/Khartoum',
        },
        {
          type: '(GMT+02:00) Sofia',
          value: 'Europe/Sofia',
        },
        {
          type: '(GMT+02:00) Tallinn',
          value: 'Europe/Tallinn',
        },
        {
          type: '(GMT+02:00) Gaza',
          value: 'Asia/Gaza',
        },
        {
          type: '(GMT+02:00) Hebron',
          value: 'Asia/Hebron',
        },
        {
          type: '(GMT+02:00) Helsinki',
          value: 'Europe/Helsinki',
        },
        {
          type: '(GMT+02:00) Kiev',
          value: 'Europe/Kiev',
        },
        {
          type: '(GMT+02:00) Riga',
          value: 'Europe/Riga',
        },
        {
          type: '(GMT+02:00) Kaliningrad',
          value: 'Europe/Kaliningrad',
        },
        {
          type: '(GMT+02:00) Tripoli',
          value: 'Africa/Tripoli',
        },
        {
          type: '(GMT+02:00) Windhoek',
          value: 'Africa/Windhoek',
        },
        {
          type: '(GMT+03:00) Baghdad',
          value: 'Asia/Baghdad',
        },
        {
          type: '(GMT+03:00) Istanbul',
          value: 'Europe/Istanbul',
        },
        {
          type: '(GMT+03:00) Kuwait',
          value: 'Asia/Kuwait',
        },
        {
          type: '(GMT+03:00) Riyadh',
          value: 'Asia/Riyadh',
        },
        {
          type: '(GMT+03:00) Minsk',
          value: 'Europe/Minsk',
        },
        {
          type: '(GMT+03:00) Moscow',
          value: 'Europe/Moscow',
        },
        {
          type: '(GMT+03:00) Volgograd',
          value: 'Europe/Volgograd',
        },
        {
          type: '(GMT+03:00) Nairobi',
          value: 'Africa/Nairobi',
        },
        {
          type: '(GMT+03:30) Tehran',
          value: 'Asia/Tehran',
        },
        {
          type: '(GMT+04:00) Abu Dhabi',
          value: 'Asia/Dubai',
        },
        {
          type: '(GMT+04:00) Muscat',
          value: 'Asia/Muscat',
        },
        {
          type: '(GMT+04:00) Astrakhan',
          value: 'Europe/Astrakhan',
        },
        {
          type: '(GMT+04:00) Baku',
          value: 'Asia/Baku',
        },
        {
          type: '(GMT+04:30) Kabul',
          value: 'Asia/Kabul',
        },
        {
          type: '(GMT+05:00) Asjabad, Tashkent',
          value: 'Asia/Tashkent',
        },
        {
          type: '(GMT+05:00) Yekaterinburg',
          value: 'Asia/Yekaterinburg',
        },
        {
          type: '(GMT+05:00) Islamabad, Karachi',
          value: 'Asia/Karachi',
        },
        {
          type: '(GMT+05:30) Chennai, Kolkata (Calcultta), Mumbai, New Delhi',
          value: 'Asia/Calcutta',
        },
        {
          type: '(GMT+05:30) Sri Jayawardenepura',
          value: 'Asia/Colombo',
        },
        {
          type: '(GMT+05:45) Katmandu',
          value: 'Asia/Katmandu',
        },
        {
          type: '(GMT+06:00) Astana',
          value: 'Asia/Almaty',
        },
        {
          type: '(GMT+06:00) Dhaka',
          value: 'Asia/Dhaka',
        },
        {
          type: '(GMT+06:00) Omsk',
          value: 'Asia/Omsk',
        },
        {
          type: '(GMT+06:30) Rangoon',
          value: 'Asia/Rangoon',
        },
        {
          type: '(GMT+07:00) Bangkok, Hanoi, Yakarta',
          value: 'Asia/Bangkok',
        },
        {
          type: '(GMT+07:00) Barnaul, Gorno-Altaysk',
          value: 'Asia/Barnaul',
        },
        {
          type: '(GMT+07:00) Hovd',
          value: 'Asia/Hovd',
        },
        {
          type: '(GMT+07:00) Krasnoyarsk',
          value: 'Asia/Krasnoyarsk',
        },
        {
          type: '(GMT+07:00) Novosibirsk',
          value: 'Asia/Novosibirsk',
        },
        {
          type: '(GMT+07:00) Tomsk',
          value: 'Asia/Tomsk',
        },
        {
          type: '(GMT+08:00) Irkutsk',
          value: 'Asia/Irkutsk',
        },
        {
          type: '(GMT+08:00) Kuala Lumpur, Singapure',
          value: 'Asia/Singapore',
        },
        {
          type: '(GMT+08:00) Pekin, Chongqing, Hong Kong, Urumqi',
          value: 'Asia/Shanghai',
        },
        {
          type: '(GMT+08:00) Perth',
          value: 'Australia/Perth',
        },
        {
          type: '(GMT+08:00) Taipei',
          value: 'Asia/Taipei',
        },
        {
          type: '(GMT+08:00) Ulaanbaatar',
          value: 'Asia/Ulaanbaatar',
        },
        {
          type: '(GMT+08:30) Pyongyang',
          value: 'Asia/Pyongyang',
        },
        {
          type: '(GMT+08:45) Eucla',
          value: 'Australia/Eucla',
        },
        {
          type: '(GMT+09:00) Chita',
          value: 'Asia/Chita',
        },
        {
          type: '(GMT+09:00) Osaka, Sapporo, Tokio',
          value: 'Asia/Tokyo',
        },
        {
          type: '(GMT+09:00) Seoul',
          value: 'Asia/Seoul',
        },
        {
          type: '(GMT+09:00) Yakutsk',
          value: 'Asia/Yakutsk',
        },
        {
          type: '(GMT+09:30) Adelaide',
          value: 'Australia/Adelaide',
        },
        {
          type: '(GMT+09:30) Darwin',
          value: 'Australia/Darwin',
        },
        {
          type: '(GMT+10:00) Brisbane',
          value: 'Australia/Brisbane',
        },
        {
          type: '(GMT+10:00) Canberra, Melbourne, Sydney',
          value: 'Australia/Sydney',
        },
        {
          type: '(GMT+10:00) Guam, Port Moresby',
          value: 'Pacific/Port_Moresby',
        },
        {
          type: '(GMT+10:00) Hobart',
          value: 'Australia/Hobart',
        },
        {
          type: '(GMT+10:00) Vladivostok',
          value: 'Asia/Vladivostok',
        },
        {
          type: '(GMT+10:30) Lord Howe Island',
          value: 'Australia/Lord_Howe',
        },
        {
          type: '(GMT+11:00) Srednekolymsk',
          value: 'Asia/Srednekolymsk',
        },
        {
          type: '(GMT+11:00) Bougainville',
          value: 'Pacific/Bougainville',
        },
        {
          type: '(GMT+11:00) Norfolk Island',
          value: 'Pacific/Norfolk',
        },
        {
          type: '(GMT+11:00) Salomon Island, New Caledonia',
          value: 'Pacific/Guadalcanal',
        },
        {
          type: '(GMT+11:00) Magadan',
          value: 'Asia/Magadan',
        },
        {
          type: '(GMT+11:00) Sakhalin',
          value: 'Asia/Sakhalin',
        },
        {
          type: '(GMT+12:00) Anadyr, Petropavlovsk-Kamchatsky',
          value: 'Asia/Kamchatka',
        },
        {
          type: '(GMT+12:00) Auckland, Wellington',
          value: 'Pacific/Auckland',
        },
        {
          type: '(GMT+12:00) Fiji',
          value: 'Pacific/Fiji',
        },
        {
          type: '(GMT+12:45) Chatham Island',
          value: 'Pacific/Chatham',
        },
        {
          type: "(GMT+13:00) Nukuo'lafa",
          value: 'Pacific/Tongatapu',
        },
        {
          type: '(GMT+13:00) Samoa',
          value: 'Pacific/Apia',
        },
        {
          type: '(GMT+13:00) Kiritimati Island',
          value: 'Pacific/Kiritimati',
        },
      ];

      var lang = $translationService.getLanguage();
      if (lang == 'es') {
        return list;
      } else {
        return list2;
      }
    };

    /**
     * Get user timezone
     */
    this.zoneTimeUser = function () {
      var timezoneq = Intl.DateTimeFormat().resolvedOptions().timeZone;
      var currentUser = $localStorageService.getItem('currentUser');
      var timezone = currentUser.timeZone
        ? currentUser.timeZone
        : '';
      if (timezone == '' || timezone == undefined) {
        return timezoneq;
      } else {
        return timezone;
      }
    };

    /**
     * Get user timezone offset
     */
    this.getUserTimeZoneOffset = function () {
      var defaultTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      var currentUser = $localStorageService.getItem('currentUser');
      var timeZone =
        angular.isDefined(currentUser.timeZone) &&
          currentUser.timeZone != ''
          ? currentUser.timeZone
          : defaultTimeZone;

      return moment().tz(timeZone).format('Z');
    };

    /**
     * Get current iso date in user time zone
     */
    this.getUserCurrentISOString = function () {
      var tz = this.zoneTimeUser();
      return moment().tz(tz).format('YYYY-MM-DDTHH:mm:ss');
    };

    /**
     * Get current datetime in user tz and language
     */
    this.getTimeZone = function () {
      var lang = $translationService.getLanguage();
      var timeZone = this.zoneTimeUser();

      return new Date().toLocaleString(lang, {
        timeZone: timeZone,
      });
    };

    /**
     * Get current datetime in user tz
     */
    this.getTimestamp = function (timestamp) {
      var timez = this.zoneTimeUser();
      return moment(timestamp).tz(timez).format('DD/MM/YYYY HH:mm:ss');
    };

    /**
     * Get current time in user tz
     */
    this.getTime = function (timestamp) {
      var timez = this.zoneTimeUser();
      var timeutc = timestamp.substr(0, 19) + 'Z';
      return moment(timeutc).tz(timez).format('HH:mm:ss');
    };

    /**
     * Get current date in user tz
     */
    this.getDate = function (timestamp) {
      var timez = this.zoneTimeUser();
      var timeutc = timestamp.substr(0, 19) + 'Z';
      return moment(timeutc).tz(timez).format('DD/MM/YYYY');
    };
  }
})();

/* Agrupa las reglas en un arbol recursivo por grupos */

(function () {
  'use strict';

  angular.module('dashboard').service('sortingService', sortingService);

  sortingService.$inject = [];
  /**
   * Function to sort alphabetically an array of objects by some specific key.
   *
   * @param {String} property Key of the object to sort.
   */
  function dynamicSort(property) {
    var sortOrder = 1;

    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }

    return function (a, b) {
      if (b[property] && a[property]) {
        if (sortOrder == -1) {
          return b[property].localeCompare(a[property]);
        } else {
          return a[property].localeCompare(b[property]);
        }
      }
    };
  }
  function sortingService() {
    var vm = this;
    vm.sorting = function (array, property) {
      return array.sort(dynamicSort(property));
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("dashboard")
    .service("sessionService", sessionService)
    .controller("RecoverSessionController", RecoverSessionController);

  sessionService.$inject = [
    "$rootScope",
    "$localStorageService",
    "translationService",
    "$interval",
    "$mdDialog",
    "toastr",
    "LoginFactory",
  ];

  function sessionService(
    $rootScope,
    $localStorageService,
    $translationService,
    $interval,
    $mdDialog,
    $toastr,
    $loginFactory
  ) {
    var vm = this;
    vm.isOnRecovery = false;
    $rootScope.$on("TokenMismatch", function () {
      console.log("info@TokenMismatch");
      vm.recoverSession();
    });

    vm.checkToken = function (target) {
      if ($localStorageService.getItem("currentUser")) {
        if (
          new Date($localStorageService.getItem("currentUser.tokenInfo.expiration")).getTime() -
          new Date().getTime() <
          0
        ) {
          vm.recoverSession(target);
        } else if (
          new Date($localStorageService.getItem("currentUser.tokenInfo.expiration")).getTime() -
          new Date().getTime() <
          1 * 60000
        ) {
          $loginFactory.refreshToken().catch(function (err) {
            console.log("error@refreshToken", err);
          });
        }
      }
    };

    vm.recoverSession = function (target) {

      if (window.location.href.includes("login")) {
        return;
      }

      if (vm.isOnRecovery) {
        return;
      }

      vm.isOnRecovery = true;
      if ($rootScope.tokenTimer) {
        $interval.cancel($rootScope.tokenTimer);
        $rootScope.tokenTimer = false;
      }
      $mdDialog
        .show({
          controller: "LoginController",
          controllerAs: "login",
          templateUrl: "app/login/login.html",
          parent: angular.element(document.body),
          clickOutsideToClose: false,
          escapeToClose: false,
          multiple: false,
          locals: {
            dialogProps: {
              isDialog: true,
              mode: "recoverSession",
            },
          },
        })
        .then(function () {
          $toastr.info(
            $translationService.getTranslationController(
              "Sesión iniciada",
              "Session started",
              "Sessão iniciada"
            )
          );
          setTimeout(function () {
            $rootScope.tokenTimer = $interval(vm.checkToken, 5000);
            console.log("recoveredTo", target);
            $rootScope.$broadcast("refreshMaiMenu");
            if (target && isNaN(target)) {
              location.reload();
            }
          }, 500);

        })
        .catch(function () {
          console.log("CancelSessionRecoverModal");
          $loginFactory.Logout();
        })
        .finally(function () {
          vm.isOnRecovery = false;
        });
    };

    vm.startCheck = function () {
      if (!$rootScope.tokenTimer) {
        var currentUser = $localStorageService.getItem("currentUser");
        if (currentUser) {
          var tokenExpiration = new Date(currentUser.tokenInfo.expiration).getTime();
          var currentTime = new Date().getTime();

          if (tokenExpiration - currentTime > 0) {
            $rootScope.tokenTimer = $interval(vm.checkToken, 5000);
          }
        }
      }
    };
    vm.startCheck();

    vm.isLogedIn = function () {
      var currentUser = $localStorageService.getItem("currentUser");
      return !!currentUser;
    };
  }

  RecoverSessionController.$inject = [
    "$scope",
    "$localStorageService",
    "$mdDialog",
    "toastr",
    "translationService",
    "LoginFactory",
  ];

  function RecoverSessionController(
    $scope,
    $localStorageService,
    $mdDialog,
    $toastr,
    $translationService,
    $loginFactory
  ) {
    $translationService.getTranslation($scope, "includes");
    var recover = this;
    recover.loading = false;
    recover.user = $localStorageService.getItem("currentUser")
      ? $localStorageService.getItem("currentUser.username")
      : undefined;
    recover.txt = {
      cancel: $translationService.getTranslationController("Cancelar", "Cancel", "Cancelar"),
      enter: $translationService.getTranslationController("Entrar", "Enter", "Entrar"),
      session_expired: $translationService.getTranslationController(
        "Sesión expirada",
        "Session Expired",
        "Sessão expirada"
      ),
      session_expired_msg: $translationService.getTranslationController(
        "Su sesión ha caducado, escriba su contraseña para continuar.",
        "Your session was expired, type your password to continue.",
        "Sua sessão expirou, digite sua senha para continuar."
      ),
    };

    recover.login = function () {
      if (!recover.pass) {
        $toastr.info(
          $translationService.getTranslationController(
            "Contraseña requerida",
            "Password required",
            "Senha requerida"
          )
        );
        return false;
      }
      recover.loading = true;
      $loginFactory
        .login(recover.user, recover.pass)
        .then(function (response) {
          $loginFactory.setCurrentUser(response);
          $mdDialog.hide();
        })
        .catch(function () {
          $toastr.error(
            $translationService.getTranslationController(
              "Usuario o contraseña inválida",
              "Username or password invalid",
              "Nome de usuário ou senha inválidos"
            )
          );
        })
        .finally(function () {
          recover.loading = false;
        });
    };

    recover.cancel = function (ev) {
      $mdDialog.cancel();
    };
  }
})();

(function () {
  "use strict";

  angular.module("dashboard").service("SchemasService", SchemasService);

  SchemasService.$inject = ["$filter", "cellTemplateFormatService"];
  function SchemasService($filter, $cellTemplateFormatService) {
    var vm = this;
    /**
     * Get field name if is primary key
     * @param {boolean} isPrimaryKey
     * @param {string} fieldName
     *
     * @returns {string}
     */
    vm.parseFieldName = function (isPrimaryKey, fieldName) {
      return (isPrimaryKey ? "#" : "") + fieldName;
    };

    function validSchemaAndGetProperties(_schema) {
      _schema = angular.isObject(_schema) ? _schema : angular.fromJson(_schema);
      _schema.schema = angular.isObject(_schema.schema)
        ? _schema.schema
        : angular.fromJson(_schema.schema);

      if (angular.isString(_schema.schema.definitions)) {
        _schema.schema.definitions = angular.fromJson(
          _schema.schema.definitions
        );
        _schema.schema.definitions[_schema.name].properties = angular.fromJson(
          _schema.schema.definitions[_schema.name].properties
        );
      }
      return _schema.schema.definitions[_schema.name].properties;
    }

    /**
     *  Convert plain schema to js handled object
     * @param {string | object} _schema
     * @param {array} _format
     * @returns {object} plain schema
     */
    vm.parseSchema = function (_schema, _format) {
      var schemaProperties = validSchemaAndGetProperties(_schema);

      angular.forEach(schemaProperties, function (col, index) {
        schemaProperties[index].key = index;

        schemaProperties[index].required =
          _schema.schema.definitions[_schema.name].required.indexOf(index) > -1
            ? true
            : false;

        schemaProperties[index].pk =
          _schema.schema.definitions[_schema.name].required.indexOf(
            "#" + index
          ) > -1
            ? true
            : false;
      });

      if (_format) {
        schemaProperties = vm.parseFormats(schemaProperties, _format);
      }

      schemaProperties = $filter("orderObjectBy")(schemaProperties, "order");

      return schemaProperties;
    };

    /**
     *  Return schema by group
     * @param {string | object} _schema
     * @param {array} _format
     * @returns {object} schema Groups
     */
    vm.parseSchemaByGroup = function (_schema, _format) {
      var schemaProperties = vm.parseSchema(_schema);

      var schemaGroups = Object.entries(schemaProperties).reduce(function (
        group,
        curr
      ) {
        var props = Object.assign({}, curr[1], { key: curr[0] });
        var groupKey = props.group || "";
        if(props.visible == false) return group;
        group[groupKey] = group[groupKey] || [];
        group[groupKey].push(props);
        return group;
      },
      {});
      console.log(schemaGroups);
      return schemaGroups;
    };

    vm.parseFormats = function (schema, formats) {
      angular.forEach(schema, function (col, index) {
        var colFormat = _parseColumnFormat(index, schema, formats);
        schema[index].inputFormat = colFormat.inputFormat;
        schema[index].outputFormat = colFormat.outputFormat;
      });

      return schema;
    };

    function _parseColumnFormat(colIndex, schema, formats) {
      var colName = (schema[colIndex].pk ? "#" : "") + colIndex;

      var inputFormat = formats[colName]
        ? formats[colName].inputFormat || ""
        : "";
      var outputFormat = formats[colName]
        ? formats[colName].outputFormat || ""
        : "";

      return { inputFormat: inputFormat, outputFormat: outputFormat };
    }

    /**
     * Get default empty schema data
     * @param {object} schema
     */
    vm.getDefaultSchemaData = function (schema) {
      var schemaData = {};
      angular.forEach(schema, function (item, key) {
        var fieldName = vm.parseFieldName(item.pk, key);
        schemaData[fieldName] = "";
      });
      return schemaData;
    };

    vm.isValidSchema = function (schema) {
      if (
        schema.hasOwnProperty("schema") &&
        schema.hasOwnProperty("type") &&
        schema.hasOwnProperty("name") &&
        schema.hasOwnProperty("description") &&
        schema.hasOwnProperty("schemaReference") &&
        schema.hasOwnProperty("schemaType")
      ) {
        return schema.schema.hasOwnProperty("definitions");
      }

      return false;
    };

    vm.parseInputListValues = function (listData, schema) {
      var p_schema = schema ? vm.parseSchema(schema) : null;

      var p_data = listData.map(function (e) {
        var props = JSON.parse(e.body);
        for (var key in props) {
          var k = key.replace("#", "");
          var schemaDefs = p_schema[k];
          if (!schemaDefs) continue;
          if (schemaDefs == null) continue;
          if (schemaDefs == undefined) continue;
          if (schemaDefs == "") continue;

          if (schemaDefs.type == "date") {
            var date = props[key].slice(0, 10);
            props[key] = moment(date).format("DD-MM-YYYY");
          }

          if (schemaDefs.type == "integer") {
            props[key] = parseFloat(props[key]);
          }
        }
        return props;
      });

      return { data: p_data , schema: p_schema || [] };
    };

    vm.setColumnDefs = function (schemaObject) {
      var columnDefs = [];
      angular.forEach(schemaObject, function (col) {
        if (col.visible) {
          var field = col.pk ? "#" + col.key : col.key;

          var colDef = {
            isPk: col.pk,
            order: col.order,
            name: col.key,
            displayName: col.displayName || col.key,
            field: field,
            // General column properties
            enableColumnMenu: true,
            enableSorting: true,
            enableHiding: false,
            aux: col,
          };

          colDef.cellTemplate = $cellTemplateFormatService.setTemplate(
            colDef,
            col,
            []
          );

          columnDefs.push(colDef);
        }
      });

      return columnDefs;
    };

    vm.createDataSchema = function (columns) {
      var schema = {};
      angular.forEach(columns, function (col) {
        // console.log(col);
        schema[col.type] = null;
        if (["boolean", "checkbox"].includes(col.type)) {
          schema[col.type] = false;
        }
        if (["json"].includes(col.type)) {
          schema[col.type] = "{}"
        }
      });
      console.log(schema);
      return schema;
    };
  }
})();

/* Servicio encargado de hacer las diversas validaciones en las distintas rutas
    del archivo index.route.js */

(function() {
'use strict';

  angular
  .module('dashboard')
  .service('RouteService', RouteService)

  RouteService.$inject = ['$q', '$localStorageService'];

    function RouteService ($q, $localStorageService){
        return {
            profileAuthorized: function(idFuncion){
              var currentUser = $localStorageService.getItem("currentUser");

              if (angular.isUndefined(currentUser)) {
                return $q.reject('NotLoggedIn');
              }
              
              if(currentUser.userType == "SA"){
                var currentMenu = currentUser.opcionesMenu.find(function(opcion){
                  return opcion.idFuncion === idFuncion;
                })
                if (!currentMenu){
                    return $q.reject('NotAccess');
                }
              }
            }
          }
        }
      })();

/**/

(function() {
    'use strict';
    
    angular
    .module('dashboard')
    .service('Paginator', Paginator)


  Paginator.$inject = [];
  
    function Paginator() {
      var service = {};
  
      service.getPagesWindow = function (total, limit, active) {
        var totalPages = Math.ceil(total/limit);
        if(totalPages <= 10) {
          var res = [];
          for(var i = 0 ; i < totalPages ; i++) {
            res.push(i+1);
          }
          return res;
        }
        else {
          if(active > 6) {
            if(totalPages - active < 4) {
              return [
                totalPages - 9,
                totalPages - 8,
                totalPages - 7,
                totalPages - 6,
                totalPages - 5,
                totalPages - 4,
                totalPages - 3,
                totalPages - 2,
                totalPages - 1,
                totalPages
              ];
            }
            else {
              return [
                active - 5,
                active - 4,
                active - 3,
                active - 2,
                active - 1,
                active,
                active + 1,
                active + 2,
                active + 3,
                active + 4
              ];
            }
          }
          else {
            return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
          }
        }
      };
      return service;
    }
})();
/* Service for localStorage management and encryption */
(function () {
  "use strict";

  angular.module("dashboard").service("$localStorageService", localStorageService);

  localStorageService.$inject = ["$localStorage"];
  function localStorageService($localStorage) {
    var service = this;
    var secretKey = "th1s_1s_4_s3cr3t_k3y_f0r_3ncrypt10n_d0nt_3v3r_us3_th1s_1n_pr0duct10n"; // Ideally, use a more secure method to manage this key.

    service.setItem = function (key, newValue) {
      if (!newValue) {
        console.warn("No value provided for key:", key);
        return;
      }
      
      var path = key.split(".")
      var baseKey = path[0];
      var subPath = path[1]
      var ls = null;


      if ($localStorage[baseKey] === undefined) {
        if (subPath) {
          var obj = {};
          obj[subPath] = newValue;
          $localStorage[baseKey] = obj;
        } else {
          $localStorage[baseKey] = newValue;
        }

        $localStorage[baseKey] = encryptObject($localStorage[baseKey], secretKey);
        return;
      } 


      if ($localStorage[baseKey] && typeof $localStorage[baseKey] === "string") {
        ls = decryptObject($localStorage[baseKey], secretKey);
      }

      if (newValue && subPath && typeof ls === "object") {
        $localStorage[baseKey] = setDeepValue(ls, subPath, newValue);
      } else {
        $localStorage[baseKey] = newValue;
      }

    
      $localStorage[baseKey] = encryptObject(ls, secretKey);
    };

    service.getItem = function (key) {
      var baseKey = key.split(".")[0];
      var deepKey = key.split(".").slice(1).join(".");
      var decryptedStorageKey = decryptObject($localStorage[baseKey], secretKey);
      // console.log("Decrypted localStorage :", decryptedStorageKey);
      var value = decryptedStorageKey;
      if (deepKey !== "") value = getDeepValue(decryptedStorageKey, deepKey);

      // console.log("Getting item from localStorage:", key, value);
      return value;
    };

    service.removeItem = function (key) {
      delete $localStorage[key];
    };
  }
})();

/**
 *  Sets a deep value in an object based on a dot-separated path.
 * @param {Object} obj - The object to modify.
 * @param {string} path - The dot-separated path (e.g., "currentUser.permissions").
 * @param {*} value - The value to set at the specified path.
 * @return {Object} The modified object with the new value set at the specified path.
 */
function setDeepValue(obj, path, value) {
  var keys = path.split(".");
  var current = obj;
  for (var i = 0; i < keys.length - 1; i++) {
    if (typeof current[keys[i]] !== "object" || current[keys[i]] === null) {
      current[keys[i]] = {};
    }
    current = current[keys[i]];
  }
  current[keys[keys.length - 1]] = value;
  return obj;
}

/**
 * Retrieves a deep value from an object based on a dot-separated path.
 * @param {Object} obj - The object to query.
 * @param {string} path - The dot-separated path (e.g., "currentUser.permissions").
 * @returns {*} The value at the specified path, or undefined if not found.
 */
function getDeepValue(obj, path) {
  var keys = path.split(".");
  var current = obj;
  for (var i = 0; i < keys.length; i++) {
    if (current[keys[i]] === undefined) {
      return undefined;
    }
    current = current[keys[i]];
  }
  return current;
}

/**
 * Encrypts an object using a simple XOR-based method and Base64 encoding.
 * @param {Object} obj - The object to encrypt.
 * @param {string} password - The password used for encryption.
 * @returns {string} The encrypted Base64 string.
 */
function encryptObject(obj, password) {
  try {
    var jsonStr = JSON.stringify(obj);
    var encrypted = btoa(
      jsonStr
        .split("")
        .map(function (char, i) {
          return String.fromCharCode(char.charCodeAt(0) ^ password.charCodeAt(i % password.length));
        })
        .join("")
    );

    return encrypted;
  } catch (error) {
    console.error("Encryption error:", error);
    return obj;
  }
}

/**
 * Decrypts an object that was encrypted using a simple XOR-based method and Base64 encoding.
 * @param {string} encryptedBase64 - The encrypted Base64 string.
 * @param {string} password - The password used for decryption.
 * @returns {Object|null} The decrypted object, or null if decryption fails.
 */
function decryptObject(encryptedBase64, password) {
  try {
    if (encryptedBase64 === undefined) {
      return null;
    }

    if (typeof encryptedBase64 !== "string") {
      return encryptedBase64;
    }

    delete encryptedBase64.$apply;
    delete encryptedBase64.$default;
    delete encryptedBase64.$reset;
    delete encryptedBase64.$supported;
    delete encryptedBase64.$sync;
    delete encryptedBase64.$then;

    var decrypted = atob(encryptedBase64)
      .split("")
      .map(function (char, i) {
        return String.fromCharCode(char.charCodeAt(0) ^ password.charCodeAt(i % password.length));
      })
      .join("");

    var obj = JSON.parse(decrypted);
    return obj;
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
}

/* Agrupa las listas en un arbol recursivo por grupos */
(function () {
  'use strict';

  angular.module('dashboard').service('listsToGroups', listsToGroups);

  listsToGroups.$inject = [];
  function listsToGroups() {
    var vm = this;
    vm.getGroups = function (list, key) {
      return list
        .map(function (e) {
          return e[key];
        })
        .filter(function (e) {
          return e;
        })
        .map(function (e) {
          return e.toLowerCase();
        });
    };

    vm.getUnGroups = function (list, key) {
      return list.filter(function (e) {
        return e[key] === '' || e[key] === undefined || e[key] === null;
      });
    };

    vm.createGroups = function (list, key, sort, autoOpen) {
      var groups = vm.getGroups(list, key);

      var unGroups = vm.getUnGroups(list, key);
      unGroups = vm.sortItems(unGroups, 'name', sort);

      var root = {
        name: 'folder:ROOT',
        items: unGroups,
        subGroup: [],
        groupName: 'ROOT',
        isOpen: false,
      };

      var folders = groups.reduce(function (FoldersTree, ele) {
        var path = ele;
        var foldersTree = FoldersTree;

        path.split(',').forEach(function (item) {
          var isOpen = function () {
            if (autoOpen && autoOpen[key]) {
              return autoOpen[key].toLowerCase().includes(item);
            } else {
              return false;
            }
          };

          var name = 'folder:' + item.trim().replaceAll(' ', '-');
          if (!foldersTree[name]) {
            foldersTree[name] = {
              name: item,
              items: [],
              subGroup: [],
              isOpen: isOpen(),
            };
          }
          foldersTree = foldersTree[name];
          foldersTree.groupName = item;
          foldersTree.path = path;
        });
        var itemsGroup = list
          .filter(function (e) {
            return e[key];
          })
          .filter(function (e) {
            return e[key].toLowerCase() === path;
          });

        foldersTree.items = vm.sortItems(itemsGroup, 'name', sort);
        foldersTree = vm.sortProps(foldersTree, sort);
        return FoldersTree;
      }, {});
      folders['folder:ROOT'] = root;
      folders = vm.sortProps(folders, sort);

      return folders;
    };

    vm.sortProps = function (obj, sortBy) {
      var items = Object.keys(obj).sort();

      if (sortBy === 'desc') {
        items.reverse();
      }

      return items.reduce(function (accumulator, key) {
        accumulator[key] = obj[key];
        return accumulator;
      }, {});
    };

    vm.sortItems = function (list, key, sort) {
      if (sort === 'desc') {
        return list.sort(function (a, b) {
          return a[key].toLowerCase() < b[key].toLowerCase() ? 1 : -1;
        });
      } else {
        return list.sort(function (a, b) {
          return a[key].toLowerCase() > b[key].toLowerCase() ? 1 : -1;
        });
      }
    };
  }
})();

/* Handsontable configuration service */

(function (Handsontable) {
  "use strict";

  angular.module("dashboard").service("listService", listService);

  listService.$inject = [
    "dateService",
    "formats",
    "handsontableService",
    "InputListsFactory",
  ];
  function listService(
    $dateService,
    formats,
    $handsontableService,
    $inputListsFactory
  ) {
    var vm = this;

    vm.registerCustomEditors = function (scope) {
      var CepTimePicker =
        $handsontableService.getCepTimePickerCustomCell(scope);
      Handsontable.editors.CepTimePicker = CepTimePicker;
      Handsontable.editors.registerEditor("ceptimepicker", CepTimePicker);
    };

    vm.unNormalizeData = function (data, colsInfo) {
      // des-Normalizar la data al formato que acepta el backend
      data = data.map(function (e) {
        angular.forEach(e, function (value, key) {
          var colDef = colsInfo.find(function (col) {
            return col.data == key;
          });
          if (colDef != null || colDef != undefined) {
            switch (colDef.schemaType) {
              case "date":
                e[key] = $dateService.dateValidate(
                  e[key],
                  false,
                  colDef.dateFormat
                );
                break;
              case "time":
                colDef.dateFormat = colDef.dateFormat
                  ? colDef.dateFormat
                  : "HH:mm:ss";
                e[key] = $dateService.timeValidate(
                  e[key],
                  false,
                  colDef.dateFormat
                );
                break;
              case "timestamp":
                e[key] = $dateService.timestampValidate(
                  e[key],
                  false,
                  colDef.dateFormat
                );
                break;
            }
          }
        });
        return e;
      });
      return data;
    };

    vm.normalizeData = function (data, colsInfo) {
      // Normalizar la data al formato que acepta el backend
      data = data.map(function (e) {
        angular.forEach(e, function (value, key) {
          var colDef = colsInfo.find(function (col) {
            return col.data == key;
          });

          if (colDef != null || colDef != undefined) {
            switch (colDef.schemaType) {
              case "date":
                if (e[key]) {
                  e[key] =
                    moment(e[key], colDef.dateFormat).format(
                      "YYYY-MM-DDTHH:mm:ss.SSSSSSSSS"
                    ) + "Z";
                }
                break;
              case "time":
                if (e[key]) {
                  e[key] = moment(e[key], colDef.dateFormat).format(
                    "HH:mm:ss.SSSSSSSSS"
                  );
                }
                break;
              case "timestamp":
                if (e[key]) {
                  e[key] = moment(e[key], colDef.dateFormat).format(
                    "YYYY-MM-DDTHH:mm:ss.SSSSSSSSS"
                  );
                }
                break;
            }
          }
        });
        return e;
      });
      return data;
    };

    vm.parseFormat = function (format) {
      var posibleFormats = [
        { label: "0000", lang: "en-US", format: "0", type: "integer" },
        {
          label: "0,000",
          lang: "en-US",
          format: "[0,00]0.[00]",
          type: "integer",
        },
        {
          label: "0.000",
          lang: "es-ES",
          format: "[0,00]0.[00]",
          type: "integer",
        },
        { label: "0000,00", lang: "es-ES", format: "0.00[00]", type: "double" },
        { label: "0000.00", lang: "en-US", format: "0.00[00]", type: "double" },
        {
          label: "0.000,00",
          lang: "es-ES",
          format: "[0,00]0.00[00]",
          type: "double",
        },
        {
          label: "0,000.00",
          lang: "en-US",
          format: "[0,00]0.00[00]",
          type: "double",
        },
        {
          label: "0,000.00",
          lang: "en-US",
          format: "[0,00]0.00[00]",
          type: "long",
        },
      ];
      return posibleFormats.filter(function (e) {
        return e.label == format;
      });
    };

    vm.getInputType = function (
      input,
      autocomplete,
      inputFormat,
      outputFormat,
      readonly,
      sequentialSourceFn
    ) {
      var format = vm.parseFormat(outputFormat);
      if (format.length) {
        var language = format[0].lang;
        var format = format[0].format;
      } else {
        var format = input != "double" ? "0" : "0.00[00]";
        var language = "en-US";
      }

      var typeHash = {
        autoincrement: {
          schemaType: input,
          type: "numeric",
          align: "htRight",
          inputFormat: "",
          format: "0.[000000]",
          allowInvalid: true,
          readOnly: true,
        },
        string: {
          schemaType: input,
          type: "text",
          align: "htLeft",
          inputFormat: "",
          format: "",
          allowInvalid: true,
          readOnly: readonly,
        },
        sequential: {
          schemaType: input,
          type: autocomplete ? "autocomplete" : "dropdown",
          align: "htLeft",
          strict: true,
          allowInvalid: true,
          source: sequentialSourceFn,
          width: "30",
          trimDropdown: true,
          readOnly: readonly,
        },
        boolean: {
          schemaType: input,
          type: "checkbox",
          align: "htCenter",
          inputFormat: "",
          format: "",
          width: "25",
          allowInvalid: true,
          readOnly: readonly,
        },
        integer: {
          schemaType: input,
          type: "numeric",
          align: "htRight",
          inputFormat: inputFormat,
          outputFormat: outputFormat,
          format: format,
          language: language,
          allowInvalid: true,
          readOnly: readonly,
          numericFormat: {
            pattern: format,
            culture: language,
          },
        },
        long: {
          schemaType: input,
          type: "numeric",
          align: "htRight",
          inputFormat: inputFormat,
          format: format,
          language: language,
          allowInvalid: true,
          readOnly: readonly,
        },
        double: {
          schemaType: input,
          type: "numeric",
          align: "htRight",
          inputFormat: inputFormat,
          outputFormat: outputFormat,
          format: format,
          language: language,
          allowInvalid: true,
          readOnly: readonly,
          numericFormat: {
            pattern: format,
            culture: language,
          },
        },
        date: {
          schemaType: input,
          type: "date",
          align: "htCenter",
          inputFormat: inputFormat,
          dateFormat: outputFormat || formats.defaults.date,
          correctFormat: true,
          readOnly: readonly,
        },
        time: {
          schemaType: input,
          type: "text",
          customEditorType: "time",
          editor: Handsontable.editors.CeptimepickerEditor,
          align: "htCenter",
          inputFormat: inputFormat,
          dateFormat: outputFormat || formats.defaults.time,
          correctFormat: true,
          readOnly: readonly,
        },
        timestamp: {
          schemaType: input,
          type: "text",
          customEditorType: "datetime",
          editor: Handsontable.editors.CeptimepickerEditor,
          align: "htCenter",
          inputFormat: inputFormat,
          dateFormat: outputFormat || formats.defaults.timestamp,
          correctFormat: true,
          readOnly: readonly,
        },
        url: {
          schemaType: input,
          type: "text",
          align: "htLeft",
          inputFormat: "",
          format: "",
          allowInvalid: true,
          readOnly: readonly,
        },
        reference: {
          schemaType: input,
          type: "text",
          align: "htLeft",
          inputFormat: "",
          format: "",
          allowInvalid: true,
          readOnly: readonly,
        },
        lookup: {
          schemaType: input,
          type: "text",
          align: "htLeft",
          inputFormat: "",
          format: "",
          allowInvalid: true,
          readOnly: readonly,
        },
        complex: {
          schemaType: input,
          type: "text",
          align: "htLeft",
          inputFormat: "",
          format: "",
          allowInvalid: true,
          readOnly: readonly,
        },
      };

      return typeHash[input];
    };

    vm.getHeaders = function (schema) {
      var headers = [];

      angular.forEach(schema, function (col, key) {
        headers.push((col.pk ? "" : "") + key);
      });

      return headers;
    };

    vm.getColumns = function (schema) {
      var columns = [];

      angular.forEach(schema, function (col, key) {
        var referencedListId = col.metadata ? col.metadata.id : null;
        var colDefinition = _getInputType(
          col.type,
          referencedListId,
          col.autocomplete,
          col.inputFormat,
          col.outputFormat,
          col.readonly
        );
        colDefinition.data = (col.pk ? "#" : "") + key;
        colDefinition.title = key + (col.required || col.pk ? "*" : "");
        colDefinition.validator = _setValidatorByType(
          col.type,
          col.pk,
          col.required,
          col.outputFormat
        );

        columns.push(colDefinition);
      });

      return columns;
    };

    function _getInputType(
      input,
      list,
      autocomplete,
      inputFormat,
      outputFormat,
      readonly
    ) {
      var sequentialSourceFn = function (query, process) {
        var filters = {
          pagination: {
            page: 1,
            itemsPerPage: 1000,
          },
        };

        $inputListsFactory
          .getInputListDataFiltered(list, filters)
          .then(function (res) {
            var source = res.data
              .map(function (e) {
                var res = angular.fromJson(e.body);
                if (res.$visible) delete res.$visible;
                return Object.values(res)[0];
              })
              .sort();
            process(source);
          });
      };

      return vm.getInputType(
        input,
        autocomplete,
        inputFormat,
        outputFormat,
        readonly,
        sequentialSourceFn
      );
    }

    function _setValidatorByType(input, pk, required, format) {
      switch (input) {
        case "integer":
          return function (value, callback, index) {
            if (required || pk || value) {
              callback(Number.isInteger(value), index);
            } else {
              callback(true, index);
            }
          };
        case "double":
          return function (value, callback, index) {
            if ((required || pk) && !value) {
              callback(false, index);
            } else if (required || pk || value) {
              callback(!isNaN(value), index);
            } else {
              callback(true, index);
            }
          };
        case "long":
          return function (value, callback, index) {
            if ((required || pk) && !value) {
              callback(false, index);
            } else if (required || pk || value) {
              callback(!isNaN(value), index);
            } else {
              callback(true, index);
            }
          };
        case "date":
          return function (value, callback, index) {
            format = format ? format : formats.defaults.date;
            if (required || pk || value) {
              callback(moment(value, format, true).isValid(), index);
            } else {
              callback(true, index);
            }
          };
        case "time":
          return function (value, callback, index) {
            format = format ? format : formats.defaults.time;
            if (required || pk || value) {
              callback(moment(value, format, true).isValid(), index);
            } else {
              callback(true, index);
            }
          };
        case "timestamp":
          return function (value, callback, index) {
            format = format ? format : formats.defaults.timestamp;
            if (required || pk || value) {
              callback(moment(value, format, true).isValid(), index);
            } else {
              callback(true, index);
            }
          };
        case "sequential":
          return function (value, callback, index) {
            if (value == null) {
              value = "";
            }
            if (this.allowEmpty && value === "") {
              callback(true, index);
              return;
            }
            // if (this.strict && this.source) {
            //   if (typeof this.source === 'function') {
            //     this.source(value, process(value, callback));
            //   } else {
            //     process(value, callback)(this.source);
            //   }
            // } else {
            callback(true, index);
            // }
          };
      }
    }

    vm.getColumnsToExport = function (schema) {
      var columns = [];

      angular.forEach(schema, function (col, key) {
        columns.push((col.pk ? "#" : "") + key);
      });

      return columns;
    };

    vm.getColumnsTypes = function (schema) {
      var columnTypes = [];

      angular.forEach(schema, function (col, key) {
        columnTypes[(col.pk ? "#" : "") + key] = col.type;
      });

      return columnTypes;
    };

    vm.getBaseSchema = function (schema) {
      var baseSchema = {};

      angular.forEach(schema, function (col, key) {
        baseSchema[(col.pk ? "#" : "") + key] =
          col.type == "boolean" ? false : "";
      });

      return baseSchema;
    };

    vm.getFieldName = function (name, pk) {
      return pk ? "#" + name : name;
    };

    vm.formatImportedData = function (data, schema) {
      console.log(data, schema);
      data.forEach(function (row, i) {
        row.forEach(function (cell, j) {
          var type = schema[j].type;
          console.log(type, cell);

          if (cell === null) return;
          if (cell === "") return;
          if (cell === "null") {
            data[i][j] = "";
          }

          switch (type) {
            case "date":
              data[i][j] = $dateService.dateValidate(
                cell,
                false,
                schema[j].outputFormat
              );
              break;
            case "time":
              data[i][j] = $dateService.timeValidate(
                cell,
                false,
                schema[j].outputFormat
              );
              break;
            case "timestamp":
              data[i][j] = $dateService.timestampValidate(
                cell,
                false,
                schema[j].outputFormat
              );
              break;
            case "checkbox":
            case "boolean":
              data[i][j] = ["true", "1", "yes", "verdadero"].includes(
                cell.toLowerCase()
              )
                ? true
                : false;
              break;
            case "numeric":
            case "double":
            case "long":
            case "integer":
              data[i][j] = Number(cell.replace(",", "."));
              break;
          }
        });
      });
      return data;
    };
  }
})(Handsontable);

(function () {
  'use strict';

  angular
    .module('dashboard')
    .service('JsonExporterService', JsonExporterService);

  JsonExporterService.$inject = ['$timeout'];
  function JsonExporterService($timeout) {
    var vm = this;

    function _getFileName(fileName, suffix) {
      return (
        _replaceWhiteSpacesToUnderscores(fileName) + '_' + suffix + '.json'
      );
    }

    function _replaceWhiteSpacesToUnderscores(string) {
      string = string.replace(/ /gi, '_');
      return string;
    }

    function _prepareDataToExport(data) {
      return (
        'data:text/json;charset=utf-8,' +
        encodeURIComponent(angular.toJson(data, 4))
      );
    }

    /**
     *
     * @param {json} dataToExport
     * @param {string} fileName
     * @param {string} suffix - sufix to add to the file name
     */
    vm.execute = function (dataToExport, fileName, suffix) {
      var fileName = _getFileName(fileName, suffix);
      var data = _prepareDataToExport(dataToExport);

      return new Promise(function (resolve) {
        var downloader = document.createElement('a');
        downloader.setAttribute('href', data);
        downloader.setAttribute('download', fileName);
        downloader.click();

        $timeout(function () {
          resolve();
        }, 500);
      });
    };
  }
})();

/* Handsontable configuration service */
(function (Handsontable) {
  "use strict";

  angular
    .module("dashboard")
    .service("handsontableService", handsontableService);

  handsontableService.$inject = ["$compile","$mdDialog"];
  function handsontableService($compile,  $mdDialog) {
    this.getCepTimePickerCustomCell = function (scope) {
      var CepTimePicker = Handsontable.editors.BaseEditor.prototype.extend();
      CepTimePicker.prototype.init = function () {};
      CepTimePicker.prototype.prepare = function () {
        Handsontable.editors.BaseEditor.prototype.prepare.apply(
          this,
          arguments
        );
        var startViewsByType = { time: "hour", datetime: "day" };
        var startView = startViewsByType[this.cellProperties.customEditorType];

        this.component = $compile(
          '<cep-datetimepicker date="dateTimePickerValue" start-view="' +
            startView +
            '"></cep-datetimepicker>'
        )(scope);

        this.component.css("display", "none");
        this.component.appendTo(".ht_master");
      };
      CepTimePicker.prototype.getValue = function () {
        if (!moment(scope.dateTimePickerValue).isValid()) return null;

        this.component.value = moment(scope.dateTimePickerValue).format(
          this.cellProperties.dateFormat
        );

        return this.component.value;
      };
      CepTimePicker.prototype.setValue = function (value) {
        if (!value) return null;
        if (value == "") return null;

        this.component.value = value;
        if (value) {
          var formatedValue =
            this.cellProperties.customEditorType == "time"
              ? moment(moment().format("YYYY-MM-DD ") + value)
              : moment(value);

          scope.dateTimePickerValue = formatedValue;
        }
      };
      CepTimePicker.prototype.open = function () {
        var width = Handsontable.dom.outerWidth(this.TD);
        var height = Handsontable.dom.outerHeight(this.TD);
        var rootOffset = Handsontable.dom.offset(
          this.instance.rootElement.parentElement
        );
        var tdOffset = this.TD.getBoundingClientRect();

        this.component.css({
          display: "",
          width: width + "px",
          height: height + "px",
          top: tdOffset.top - rootOffset.top + "px",
          left: tdOffset.left - rootOffset.left + "px",
          margin: "0px",
          position: "absolute",
        });
      };
      CepTimePicker.prototype.focus = function () {
        this.component.focus();
      };
      CepTimePicker.prototype.close = function () {
        this.component.css("display", "none");
      };

      return CepTimePicker;
    };
    this.inputDateEditor = function (scope) {
      var inputDateEditor = Handsontable.editors.BaseEditor.prototype.extend();
      inputDateEditor.prototype.init = function () {
        this.component = null;
      };
      inputDateEditor.prototype.prepare = function () {
        Handsontable.editors.BaseEditor.prototype.prepare.apply(
          this,
          arguments
        );
        this.component = $compile(
          '<div class="hdialog"><input class="w100" type="date" value="' +
            this.originalValue +
            '"/></div>'
        )(scope);

        this.component.css("display", "none");
        this.component.appendTo(".ht_master");
      };
      inputDateEditor.prototype.getValue = function () {
        return this.component[0].children[0].value;
      };
      inputDateEditor.prototype.setValue = function (value) {
        if (!value) return null;
        if (value == "") return null;
        if (value == "Invalid date") return null;
        if (moment(value).isValid()) return null;
        this.component[0].children[0].value = value;
      };
      inputDateEditor.prototype.open = function () {
        var height = Handsontable.dom.outerHeight(this.TD);
        var rootOffset = Handsontable.dom.offset(
          this.instance.rootElement.parentElement
        );
        var tdOffset = this.TD.getBoundingClientRect();

        this.component.css({
          display: "",
          width: "auto",
          height: height + "px",
          top: tdOffset.top - rootOffset.top - 20 + "px",
          left: tdOffset.left - rootOffset.left + "px",
          margin: "0px",
          position: "absolute",
        });
      };
      inputDateEditor.prototype.focus = function () {
        this.component.find("input").focus();
      };
      inputDateEditor.prototype.close = function () {
        this.component.css("display", "none");
      };

      return inputDateEditor;
    };
    this.inputTimeStampEditor = function (scope) {
      var inputTimeStampEditor =
        Handsontable.editors.BaseEditor.prototype.extend();
      inputTimeStampEditor.prototype.init = function () {
        this.component = null;
      };
      inputTimeStampEditor.prototype.prepare = function () {
        Handsontable.editors.BaseEditor.prototype.prepare.apply(
          this,
          arguments
        );
        this.component = $compile(
          '<div class="hdialog"><input class="w100" type="datetime-local" step="2" value="' +
            this.originalValue +
            '"/></div>'
        )(scope);

        this.component.css("display", "none");
        this.component.appendTo(".ht_master");
      };
      inputTimeStampEditor.prototype.getValue = function () {
        var timestamValue = this.component[0].children[0].value;
        if(timestamValue == '') return null
        if(moment(timestamValue).isValid())
          return moment(timestamValue).format('YYYY-MM-DD HH:mm:ss'); 
        else
          return timestamValue;
        
      };
      inputTimeStampEditor.prototype.setValue = function (value) {
        if (!value) return null;
        if (value == "") return null;
        if (value == "Invalid date") return null;
        if (moment(value).isValid()) return null;
        this.component[0].children[0].value = value;
      };
      inputTimeStampEditor.prototype.open = function () {
        var height = Handsontable.dom.outerHeight(this.TD);
        var rootOffset = Handsontable.dom.offset(
          this.instance.rootElement.parentElement
        );
        var tdOffset = this.TD.getBoundingClientRect();

        this.component.css({
          display: "",
          width: "auto",
          height: height + "px",
          top: tdOffset.top - rootOffset.top - 20 + "px",
          left: tdOffset.left - rootOffset.left + "px",
          margin: "0px",
          position: "absolute",
        });
      };
      inputTimeStampEditor.prototype.focus = function () {
        this.component.find("input").focus();
      };
      inputTimeStampEditor.prototype.close = function () {
        this.component.css("display", "none");
      };

      return inputTimeStampEditor;
    };
    this.inputTimeEditor = function (scope) {
      var inputTimeEditor = Handsontable.editors.BaseEditor.prototype.extend();
      inputTimeEditor.prototype.init = function () {
        this.component = null;
      };
      inputTimeEditor.prototype.prepare = function () {
        Handsontable.editors.BaseEditor.prototype.prepare.apply(
          this,
          arguments
        );
        this.component = $compile(
          '<div class="hdialog"><input class="w100" type="time" step="2" value="' +
            this.originalValue +
            '"/></div>'
        )(scope);

        this.component.css("display", "none");
        this.component.appendTo(".ht_master");
      };
      inputTimeEditor.prototype.getValue = function () {
        return this.component[0].children[0].value;
      };
      inputTimeEditor.prototype.setValue = function (value) {
        if (!value) return null;
        if (value == "") return null;
        this.component[0].children[0].value = value;
      };
      inputTimeEditor.prototype.open = function () {
        var height = Handsontable.dom.outerHeight(this.TD);
        var rootOffset = Handsontable.dom.offset(
          this.instance.rootElement.parentElement
        );
        var tdOffset = this.TD.getBoundingClientRect();

        this.component.css({
          display: "",
          width: "auto",
          height: height + "px",
          top: tdOffset.top - rootOffset.top - 20 + "px",
          left: tdOffset.left - rootOffset.left + "px",
          margin: "0px",
          position: "absolute",
        });
      };
      inputTimeEditor.prototype.focus = function () {
        this.component.find("input").focus();
      };
      inputTimeEditor.prototype.close = function () {
        this.component.css("display", "none");
      };

      return inputTimeEditor;
    };
    this.inputJsonEditor = function (scope) {
      var inputJsonEditor = Handsontable.editors.BaseEditor.prototype.extend();
      inputJsonEditor.prototype.init = function () {
        this.component = null;
      };
      inputJsonEditor.prototype.prepare = function () {
        Handsontable.editors.BaseEditor.prototype.prepare.apply(
          this,
          arguments
        );
        var row = this.row;
        var col = this.col;
        
        this.originalValue = this.component = $compile(
          '<div class="jsonInputWrapper'+row+col+'" >'+
          '<json-input row="' + row + '" col="' + col + '" ></json-input>'+
          '</div>'
        )(scope);

        this.component.css("display", "none");
        this.component.appendTo(".ht_master");
      };
      inputJsonEditor.prototype.getValue = function () {
        return this.hot.getDataAtCell(this.row, this.col)
      };
      inputJsonEditor.prototype.setValue = function () {
        var data =this.hot.getDataAtCell(this.row, this.col)
        this.TD.innerHTML = JSON.stringify(data)
      };
      inputJsonEditor.prototype.open = function () {
        var height = Handsontable.dom.outerHeight(this.TD);
        var width = Handsontable.dom.outerWidth(this.TD);
        var rootOffset = Handsontable.dom.offset(
          this.instance.rootElement.parentElement
        );
        var tdOffset = this.TD.getBoundingClientRect();

        this.component.css({
          display: "block",
          width: width + "px",
          height: height + "px",
          top: tdOffset.top - rootOffset.top  - 38 + "px",
          left: tdOffset.left - rootOffset.left + "px",
          margin: "0px",
          zIndex: 100,  
          position: "absolute",
        });

      };
      inputJsonEditor.prototype.focus = function () {};
      inputJsonEditor.prototype.close = function () {
        if(!document.activeElement.classList.contains("ace_text-input"))
          this.component.css("display", "none");
      };
      return inputJsonEditor;
    };
  }
})(Handsontable);

/* SERVICIO SIN USO - DEBE SER ELIMINADO (Daniel 24-sep-18) */

(function() {
    'use strict';
    
    angular
    .module('dashboard')
    .service('EventosAlerta', EventosAlerta)
    
    EventosAlerta.$inject = ['$http'];
    function EventosAlerta($http) {
      var eventosAlerta = [];
      eventosAlerta['1'] = [
        {id: '1', fecha: '2016-06-10', hora: '10:56:45.213',
         texto: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'},
        {id: '2', fecha: '2016-06-10', hora: '10:58:46.213',
          texto: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'},
        {id: '7', fecha: '2016-08-10', hora: '10:58:46.213',
          texto: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'},
        {id: '10', fecha: '2016-11-10', hora: '10:58:46.213',
          texto: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'}];
      eventosAlerta['2'] = [
        {id: '3', fecha: '2016-07-10', hora: '11:56:45.213',
          texto: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'},
        {id: '4', fecha: '2016-08-10', hora: '10:56:45.213',
          texto: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'},
        {id: '8', fecha: '2016-08-10', hora: '10:58:46.213',
          texto: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'}];
      eventosAlerta['3'] = [
        {id: '5', fecha: '2016-09-10', hora: '09:56:45.213',
          texto: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'},
        {id: '6', fecha: '2016-10-10', hora: '10:56:45.213',
          texto: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'},
        {id: '9', fecha: '2016-11-10', hora: '10:58:46.213',
          texto: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'}];
      eventosAlerta['4'] = [
        {id: '11', fecha: '2016-09-10', hora: '09:56:45.213',
          texto: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'},
        {id: '12', fecha: '2016-10-10', hora: '10:56:45.213',
          texto: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'},
        {id: '13', fecha: '2016-11-10', hora: '10:58:46.213',
          texto: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'}];
      eventosAlerta['5'] = [
        {id: '14', fecha: '2016-09-10', hora: '09:56:45.213',
          texto: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'},
        {id: '15', fecha: '2016-10-10', hora: '10:56:45.213',
          texto: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'},
        {id: '16', fecha: '2016-11-10', hora: '10:58:46.213',
          texto: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'}];
  
      this.obtenerEventosAlerta = function(idAlerta, callback) {
        callback({header: {code: 0, message: ''}, body: eventosAlerta[idAlerta]});
      };
  
      this.obtenerEventsByIdAlerta = function(idAlerta) {
        for(var key in eventosAlerta) {
          if(key==idAlerta) {
            return JSON.parse( JSON.stringify( eventosAlerta[key] ) );
            //return eventosAlerta[key];
          }
        }
        return null;
      };
    }


})();
/* Servicio encargado de hacer las diversas validaciones en las distintas rutas
    del archivo index.route.js */

(function() {
    'use strict';
    
    angular
    .module('dashboard')
    .service('Discussion', Discussion)

	Discussion.$inject = [];
	function Discussion() {
    this.allDiscussion = allDiscussion;
    var data = [
        {
            "fecha": "2015-10-12T20:32:08-07:00",
            "user": "Luis Ramos",
            "messages": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus pharetra suscipit eleifend."
        },
        {
            "fecha": "2015-10-12T20:32:08-07:00",
            "user": "Jaime Tobar",
            "messages": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus pharetra suscipit eleifend."
        },
        {
            "fecha": "2015-10-12T20:32:08-07:00",
            "user": "Eugenio Contreras",
            "messages": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus pharetra suscipit eleifend."
        }]

		function allDiscussion() {
			return data;
		}
	}
})();
/* Servicio encargado de hacer las diversas validaciones en las distintas rutas
    del archivo index.route.js */

(function() {
    'use strict';
    
    angular
    .module('dashboard')
    .service('DetalleAlerta', DetalleAlerta)
        
    DetalleAlerta.$inject = ['$http'];
    function DetalleAlerta($http) {
    
      var parametrosAlertas = [];
        parametrosAlertas['1'] = [
            {name: 'parametro1', value:'value1', description: 'description parametro1'},
            {name: 'p2', value: 'value2', description: 'description p2'}];
        parametrosAlertas['2'] = [
            {name: 'parametro8', value:'value1', description: 'description parametro8'},
            {name: 'p6', value: 'value2', description: 'description p6'}];
        parametrosAlertas['3'] = [
            {name: 'param345', value:'value1', description: 'description param345'},
            {name: 'tasa', value: '3.25', description: 'description tasa'}];
        parametrosAlertas['4'] = [
            {name: 'param4', value:'value1', description: 'description param345'},
            {name: 'tasa4', value: '3.25', description: 'description tasa'}];
        parametrosAlertas['5'] = [
            {name: 'param5', value:'value1', description: 'description param345'},
            {name: 'tasa5', value: '3.25', description: 'description tasa'}];
    
        var archivosAlerta = [];
        archivosAlerta['1'] = [
            {name: 'archivo.docx', url:'http://localhost/archivo.docx', uploadedBy: 'HTasd', fecha: '2016-06-10', hora: '10:56:45.213'},
            {name: 'archivo_2.docx', url:'http://localhost/archivo_2.docx', uploadedBy: 'Pepe', fecha: '2016-06-11', hora: '16:15:00.001'}];
        archivosAlerta['2'] = [
            {name: 'archivo1.docx', url:'http://localhost/archivo1.docx', uploadedBy: 'UUrrtia', fecha: '2016-06-10', hora: '10:56:45.213'},
            {name: 'archivo_1_2.docx', url:'http://localhost/archivo_1_2.docx', uploadedBy: 'JGomez', fecha: '2016-06-11', hora: '16:15:00.001'}];
        archivosAlerta['3'] = [
            {name: 'archivo3.docx', url:'http://localhost/archivo3.docx', uploadedBy: 'PVillal', fecha: '2016-06-10', hora: '10:56:45.213'},
            {name: 'archivo_3_2.docx', url:'http://localhost/archivo_3_2.docx', uploadedBy: 'Afirtz', fecha: '2016-06-11', hora: '16:15:00.001'}];
        archivosAlerta['4'] = [
            {name: 'archivo4.docx', url:'http://localhost/archivo4.docx', uploadedBy: 'PVillal', fecha: '2016-06-10', hora: '10:56:45.213'},
            {name: 'archivo_4_2.docx', url:'http://localhost/archivo_4_2.docx', uploadedBy: 'Afirtz', fecha: '2016-06-11', hora: '16:15:00.001'},
            {name: 'archivo_4_3.docx', url:'http://localhost/archivo_4_2.docx', uploadedBy: 'Afirtz', fecha: '2016-06-11', hora: '16:15:00.001'}];
        archivosAlerta['5'] = [
            {name: 'archivo5.docx', url:'http://localhost/archivo3.docx', uploadedBy: 'PVillal', fecha: '2016-06-10', hora: '10:56:45.213'},
            {name: 'archivo_5_2.docx', url:'http://localhost/archivo_3_2.docx', uploadedBy: 'Afirtz', fecha: '2016-06-11', hora: '16:15:00.001'}];
    
      this.obtenerParametros = function(idAlerta, callback) {
        callback({header: {code: 0, message:''}, body: parametrosAlertas[idAlerta]});
      };
    
      this.obtenerArchivos = function(idAlerta, callback) {
        callback({header: {code: 0, message: ''}, body: archivosAlerta[idAlerta]});
      };
    
    }
})();

/* Servicio encargado de hacer operaciones con fechas */

(function () {
  'use strict';

  angular.module('dashboard').service('dateService', dateService);

  dateService.$inject = ['formats'];
  function dateService(formats) {
    // Verifica si un campo timestamp cumple con un formato válido
    /**
     *
     * @param {string} value
     * @param {string} inputFormat
     * @param {string} outputFormat
     * @returns strinmg
     */
    this.timestampValidate = function (value, inputFormat, outputFormat) {
      // console.log(value, inputFormat, outputFormat);
      if (value != 'null') {
        inputFormat = inputFormat
          ? inputFormat
          : [
              'DD-MM-YYYY',
              'YYYY-MM-DD',
              'DD/MM/YYYY',
              'YYYY/MM/DD',
              'DD/MM/YYYY HH',
              'DD/MM/YYYY HH:mm',
              'DD/MM/YYYY HH:mm:ss',
              'DD/MM/YYYY HH:mm:ss.SSSSSSSSS',
              'YYYY-MM-DD HH',
              'YYYY-MM-DD HH:mm',
              'YYYY-MM-DD HH:mm:ss',
              'YYYY-MM-DD HH:mm:ss.SSSSSSSSS',
              'DD-MM-YYYY HH',
              'DD-MM-YYYY HH:mm',
              'DD-MM-YYYY HH:mm:ss',
              'DD-MM-YYYY HH:mm:ss.SSSSSSSSS',
              'YYYY/MM/DD HH',
              // 'YYYY/MM/DD HH:mm',
              'YYYY/MM/DD HH:mm:ss',
              'YYYY/MM/DD HH:mm:ss.SSSSSSSSS',
              'YYYY-MM-DDTHH:mm:ss.SSSSSSSSS',
              'YYYY-MM-DD HH:mm',
              // 'YYYY/MM/DD HH:mm',
              'DD-MM-YYYY HH:mm',
              'DD/MM/YYYY HH:mm',
              'MM-DD-YYYY HH:mm',
            ];

        var ts = moment(value, inputFormat, true).format(
          outputFormat ? outputFormat : formats.defaults.timestamp
        );

        return ts == 'Invalid date' ? value : ts;
      }
      return '';
    };

    //Verifica si un campo date cumple con un formato válido
    this.dateValidate = function (value, inputFormat, outputFormat) {
      if (value != 'null') {
        inputFormat = inputFormat
          ? inputFormat
          : [
              'YYYY-MM-DD',
              'YYYY/MM/DD',
              'DD-MM-YYYY',
              'DD/MM/YYYY',
              'MM-DD-YYYY',
              'YYYY-MM-DD HH:mm:ss.SSSSSSSSSZ',
              'YYYY-MM-DDTHH:mm:ss.SSSSSSSSSZ',
            ];
        // Do not convert TZ to local time
        var ts = moment(value, inputFormat, true)
          .utc()
          .format(outputFormat ? outputFormat : formats.defaults.date);

        return ts == 'Invalid date' ? value : ts;
      }
      return '';
    };

    //Verifica si un campo time cumple con un formato válido
    this.timeValidate = function (value, inputFormat, outputFormat) {
      if (value != 'null') {
        inputFormat = inputFormat
          ? inputFormat
          : ['HH', 'HH:mm', 'HH:mm:ss', 'HH:mm:ss.SSSSSSSSS'];
        var ts = moment(value, inputFormat, true).format(
          outputFormat ? outputFormat : formats.defaults.time
        );
        return ts == 'Invalid date' ? value : ts;
      }
      return '';
    };
  }
})();

/* Servicio encargado de hacer las diversas validaciones en las distintas rutas
  del archivo index.route.js */
(function () {
  "use strict";

  angular.module("dashboard").service("DashboardService", DashboardService);

  DashboardService.$inject = [
    "$state",
    "ConfigurationFactory",
    "FilesStorageFactory",
    "$localStorageService"
  ];
  function DashboardService(
    $state,
    ConfigurationFactory,
    FilesStorageFactory,
    $localStorageService
  ) {
    this.storeCompanyConfiguration = function () {
      return new Promise(function (resolve, reject) {
        ConfigurationFactory.getGlobalConfiguration()
          .then(function (res) {
            var systeamConfig = res;
            var configDashboard = res.dashboard;
            $("[data-theme]").attr("data-theme", configDashboard.theme);
            $localStorageService.setItem(
              "theme",
              configDashboard.theme == ""
                ? "ceptinel"
                : configDashboard.theme || "ceptinel"
            );
            $localStorageService.setItem("customLogo", configDashboard.logo);
            $localStorageService.setItem(
              "ChartCustomColors",
              configDashboard.chartTheme
            );
            $localStorageService.setItem("HomePage", configDashboard.homePage);

            var includeFileACLs = systeamConfig.storage && angular.isDefined(systeamConfig.storage.includeFileACLs) ? systeamConfig.storage.includeFileACLs : true
            $localStorageService.setItem("System", {
              systemType: systeamConfig.systemType,
              includeFileACLs: includeFileACLs
            });

            if (
              configDashboard.logo &&
              configDashboard.logo.folder &&
              configDashboard.logo.file
            ) {
              FilesStorageFactory.downloadFile(
                configDashboard.logo.folder,
                configDashboard.logo.file
              )
                .then(function (res) {
                  blobToBase64(res.data).then(function (base64) {
                    var customLogo = base64;

                    resolve(configDashboard);
                  });
                })
                .catch(function (err) {
                  console.error("Error@getCustomLogo", err);
                  reject("Custom logo not found");
                });
            } else {
              resolve(configDashboard);
            }
          })
          .catch(function (e) {
            console.log("ConfigurationFactory", e.msg);
          });
      });
    };
    this.toHomePage = function () {
      console.log("Redirecting to home page");
      const currentUser = $localStorageService.getItem("currentUser");
      const profileType =
        currentUser && currentUser.userType ? currentUser.userType : "U";
      var lsHomePage = $localStorageService.getItem("HomePage") || {
        SA: "/home",
        U: "/home"
      };
      var homePage = lsHomePage[profileType] || "/home";
      // $state.go(homePage);
      console.log("Redirecting to home page:", homePage);
      window.location.href = homePage;
    };
  }
})();

function blobToBase64(blob) {
  return new Promise(function (resolve, _) {
    var reader = new FileReader();
    reader.onloadend = function () {
      return resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  });
}

(function () {
  "use strict";

  angular.module("dashboard").service("CustomReportService", CustomReportService);

  CustomReportService.$inject = ["AclFactory", "$localStorageService", "UserFactory", "toastr"];
  function CustomReportService($aclFactory, $localStorageService, $userFactory, $toastr) {
    var vm = this;
    // share custom report after creation
    vm.createCustomReportAcl = function (customReport) {
      shareCustomReport(customReport, "created", null);
    };

    // share custom report by share
    vm.asignPersimionsToUserGroup = function (customReport, aclResponse) {
      console.log(
        "Asigning permissions to user groups for custom report:",
        customReport,
        aclResponse
      );
      shareCustomReport(customReport, "shared", aclResponse.policies);
    };

    // share custom report folder after creation
    vm.createCustomReportFolder = function (folder) {
      // console.log("Creating custom report folder:", folder);
      var user = $localStorageService.getItem("currentUser");
      var groups = (user.groups || []).map(function (group) {
        return {
          id: group.id,
          name: group.name,
        };
      });
      createOrUpdateFolderAcl(folder, groups);
    };

    function shareCustomReport(customReport, action, existingPolicies) {
      action = action || "created";
      var user = $localStorageService.getItem("currentUser");
      var groups = (user.groups || []).map(function (group) {
        return {
          id: group.id,
          name: group.name,
        };
      });

      var id = customReport.id;
      var shareResource = "custom-report#" + id;
      var acl = {
        name: shareResource,
        description: shareResource,
        active: true,
        policies:
          action == "shared"
            ? existingPolicies
            : [
                {
                  description: shareResource,
                  resource: {
                    name: "custom-report",
                    entityId: id,
                    actions: "read,read_storage,upload,download",
                    granted: true,
                  },
                  appliesTo: { users: [], groups: groups },
                },
              ],
      };

      // shares poclicies allready stringified
      if (action == "created") acl.policies = JSON.stringify(acl.policies);

      $aclFactory
        .getPermissionsShare("custom-report", id)
        .then(function (response) {
          console.log("Permissions retrieved successfully", response);

          var aclId = angular.isDefined(response.id) ? response.id : null;
          if (aclId) {
            $aclFactory
              .edit(aclId, acl)
              .then(function (response) {
                console.log("Permissions edited successfully", response);
                createOrUpdateListAcl(customReport, action, acl.policies);
              })
              .catch(function (error) {
                console.error("Error creating permissions:", error);
              });
          } else {
            $aclFactory
              .createShareEntity("custom-report", id, acl)
              .then(function (response) {
                console.log("Permissions created successfully", response);
                createOrUpdateListAcl(customReport, action, acl.policies);
              })
              .catch(function (error) {
                console.error("Error creating permissions:", error);
              });
          }
        })
        .catch(function (error) {
          console.error("Error retrieving permissions:", error);
        });
    }

    function createOrUpdateListAcl(customReport, action, policies) {
      action = action || "created";
      var _SOURCE_ = angular.isDefined(customReport.list)
        ? "list"
        : angular.isDefined(customReport.table)
        ? "data-management"
        : null;
      if (!_SOURCE_) {
        console.error("No valid source found for custom report:", customReport);
        return;
      }


      var _NAME_KEY_ =
        _SOURCE_ === "list"
          ? customReport.list.id
          : customReport.table.schemaName + "." + customReport.table.tableName;

      var _DESCRIPTION_ =
        _SOURCE_ === "list" ? customReport.list.name : customReport.table.tableName;

      if (typeof policies === "string") {
        policies = JSON.parse(policies);
      }
      

      var acl = {
        name: _SOURCE_ + "#" + _NAME_KEY_,
        description: _DESCRIPTION_,
        active: true,
        policies: Array.isArray(policies) ? policies.map(function (policy) {
          return {
            description: _SOURCE_ + "#" + _NAME_KEY_,
            resource: {
              name: _SOURCE_,
              entityId: _NAME_KEY_,
              actions: "read,upload,delete",
              granted: true,
            },
            appliesTo: policy.appliesTo || { users: [], groups: [] },
          };
        }) : null,
      };

      acl.policies = JSON.stringify(acl.policies);
      if(acl.policies === "null") delete acl.policies;
      
      $aclFactory
        .getPermissionsShare(_SOURCE_, _NAME_KEY_)
        .then(function (response) {
          var aclId = angular.isDefined(response.id) ? response.id : null;
          if (aclId) {
            $aclFactory
              .edit(aclId, acl)
              .then(function (response) {
                console.log(_SOURCE_ + " Permissions edited successfully", response);
              })
              .catch(function (error) {
                console.error(_SOURCE_ + " Error assigning permissions:", error);
              });
          } else {
            $aclFactory
              .createShareEntity(_SOURCE_, _NAME_KEY_, acl)
              .then(function (response) {
                // console.log(_SOURCE_ + " Permissions created successfully", response);
              })
              .catch(function (error) {
                console.error(_SOURCE_ + " Error creating permissions:", error);
              });
          }
        })
        .catch(function (error) {
          console.error(_SOURCE_ + " Error retrieving permissions:", error);
        });
    }

    function createOrUpdateFolderAcl(folder, groups) {
      var _SOURCE_ = "files-storage-folder";
      var id = folder.id;
      var shareResource = _SOURCE_ + "#" + id;
      var acl = {
        name: shareResource,
        description: folder.name,
        active: true,
        policies: [
          {
            description: shareResource,
            resource: {
              name: _SOURCE_,
              entityId: Number(id),
              actions: "create-file,update,read,download,share",
              granted: true,
            },
            appliesTo: {
              users: [],
              groups: groups,
            },
          },
        ],
      };

      // update local storage permissions
      var loggedUserPermission = $localStorage.currentUser.permissions || [];
      loggedUserPermission.push({
        name: "files-storage-folder-file",
        actions: "read,update,delete",
        entityId: Number(id),
        granted: true,
      });

      $aclFactory
        .getPermissionsShare(_SOURCE_, id)
        .then(function (response) {
          var aclId = angular.isDefined(response.id) ? response.id : null;
          if (aclId) {
            var policies = JSON.parse(response.policies || "[]");
            acl.policies = acl.policies.concat(policies).filter(function (policy, index, self) {
              return (
                self.findIndex(function (p) {
                  return p.description === policy.description;
                }) === index
              );
            });
            acl.policies = JSON.stringify(acl.policies);

            $aclFactory
              .edit(aclId, acl)
              .then(function (response) {
              })
              .catch(function (error) {
                console.error(_SOURCE_ + " Error assigning permissions:", error);
              });
          } else {
            acl.policies = JSON.stringify(acl.policies);
            $aclFactory
              .createShareEntity(_SOURCE_, id, acl)
              .then(function (response) {
              })
              .catch(function (error) {
                console.error(_SOURCE_ + " Error creating permissions:", error);
              });
          }
        })
        .catch(function (error) {
          console.error(_SOURCE_ + " Error retrieving permissions:", error);
        });
    }
  }
})();

/* */

(function() {
    'use strict';
    
    angular
    .module('dashboard')
    .service('Comentarios', Comentarios)    

    Comentarios.$inject = ['$http'];
    function Comentarios($http) {
      var comentarios = [];
      //llaves compuestas
      //c = caso / a = alerta / e = evento
      //c1a5 -> 3 comentarios
      //c1a4 -> 2 comentarios
      //c2a3 -> 3 comentarios
      //c3a4 -> 1 comentario
      //c4a1 -> 2 comentarios
      //c3a5 -> 2 comentarios
      comentarios['c1a5e14'] = [
        {id: 1, autor: 'MPerez', fecha: '2016-06-09', hora: '10:25:36', texto: 'Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto.'},
        {id: 2, autor: 'JRock', fecha: '2016-06-09', hora: '10:25:37', texto: 'Lorem Ipsum ha sido el texto de relleno estándar de las industrias desde el año 1500.'},
        {id: 3, autor: 'MPerez', fecha: '2016-06-09', hora: '10:25:38', texto: 'Fue popularizado en los 60s con la creación de las hojas "Letraset".'}
      ];
      comentarios['c1a4e12'] = [
        {id: 1, autor: 'GGGGGG', fecha: '2016-06-09', hora: '10:25:38', texto: 'Hay muchas variaciones de los pasajes de Lorem Ipsum disponibles.'},
        {id: 2, autor: 'FReyes', fecha: '2016-06-09', hora: '10:25:38', texto: 'Al contrario del pensamiento popular, el texto de Lorem Ipsum no es simplemente texto aleatorio.'}
      ];
      comentarios['c2a3e6'] = [
        {id: 1, autor: 'TGardel', fecha: '2016-06-09', hora: '10:25:36', texto: 'Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto.'},
        {id: 2, autor: 'JRock', fecha: '2016-06-09', hora: '10:25:37', texto: 'Lorem Ipsum ha sido el texto de relleno estándar de las industrias desde el año 1500.'},
        {id: 3, autor: 'Wilson', fecha: '2016-06-09', hora: '10:25:38', texto: 'Fue popularizado en los 60s con la creación de las hojas "Letraset".'}
      ];
      comentarios['c3a4e5'] = [
        {id: 1, autor: 'GGGGGG', fecha: '2016-06-09', hora: '10:25:36', texto: 'Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto.'}
      ];
      comentarios['c4a1e10'] = [
        {id: 1, autor: 'FReyes', fecha: '2016-06-09', hora: '10:25:38', texto: 'Hay muchas variaciones de los pasajes de Lorem Ipsum disponibles.'},
        {id: 2, autor: 'TGardel', fecha: '2016-06-09', hora: '10:25:38', texto: 'Al contrario del pensamiento popular, el texto de Lorem Ipsum no es simplemente texto aleatorio.'}
      ];
      comentarios['c3a5e16'] = [
        {id: 1, autor: 'Wilson', fecha: '2016-06-09', hora: '10:25:38', texto: 'Hay muchas variaciones de los pasajes de Lorem Ipsum disponibles.'},
        {id: 2, autor: 'FReyes', fecha: '2016-06-09', hora: '10:25:38', texto: 'Al contrario del pensamiento popular, el texto de Lorem Ipsum no es simplemente texto aleatorio.'}
      ];
  
      this.comentar = function(llaveComentario, autor, texto, callback) {
        var comentario = obtenerComentario(llaveComentario);
        if(comentario && comentario.length>0) {
          comentario.push({id:0, autor: autor, fecha: '2016-06-21', hora: '21:30', texto: texto});
        }
        else {
          comentarios[llaveComentario] = [];
          comentarios[llaveComentario].push({id:0, autor: autor, fecha: '2016-06-21', hora: '21:30', texto: texto});
        }
  
        callback({header: {code:0}, body:{}});
      }
  
      this.obtenerLlaveComentarios = function(idCaso, idAlerta, idEvento) {
        return 'c' + idCaso + 'a' + idAlerta + 'e' + idEvento;
      }
  
      this.comentariosCasoAlarmaEvento = function(idCaso, idAlerta, idEvento, callback) {
        var comentarios = obtenerComentario('c' + idCaso + 'a' + idAlerta + 'e' + idEvento);
        if (comentarios) {
          callback({header: {code:0}, body: comentarios});
        }
        else {
          callback({header: {code:1, message: 'Sin comentarios'}});
        }
      };
  
      this.obtenerQtyComentariosCasoAlertaEvento = function (idCaso, idAlerta, idEvento) {
        return obtenerComentario('c' + idCaso + 'a' + idAlerta + 'e' + idEvento).length;
      };
  
      function obtenerComentario(idCompuesto) {
        var comments = comentarios[idCompuesto];
        if(comments) {
          return comments
        }
        return [];
      }
    }
})();
/**/

(function() {
    'use strict';    
    
    angular
    .module('dashboard')
    .service('clipboardService', clipboardService)

    clipboardService.$inject = ['$window', 'toastr', 'translationService'];
  
    function clipboardService($window, toastr, $translationService) {
      var
          body = angular.element($window.document.body),
          textarea = angular.element('<textarea/>');
          textarea.css({ position: 'fixed', opacity: '0' });
      var
          copy = function (value) {
              textarea.val(value);
              body.append(textarea);
              textarea[0].select();
              try {
                  var successful = document.execCommand('copy');
                  if (!successful) throw successful;
                  toastr.success($translationService.getTranslationController("¡Copiado al portapapeles!", "Copied to clipboard!", "Copiado para a clipboard!"));
              } catch (err) {
                  console.log("errCopy", err);
                  toastr.success("Error al copiar al portapapeles!", "Error copying to clipboard!", "Erro ao copiar para a clipboard!");
              }
              textarea.remove();
          };
   
      return {
          copy: copy
      };
    }
})();
/* define el template para las celdas ui-grid*/
(function () {
  "use strict";

  angular.module("dashboard").service("cellTemplateFormatService", cellTemplateFormatService);

  cellTemplateFormatService.$inject = [];
  function cellTemplateFormatService() {
    var filtersByType = {
      time: "| asTime",
      date: "| asDate",
      timestamp: "| asDateHour",
      integer: "| numberFormater:0",
      double: "| numberFormater",
      long: "| numberFormater:0",
    };

    var typesFormats = {
      "url:undefined":
        '<div md-truncate><a target="_blank" ng-href="{{ COL_FIELD }}" style="text-decoration: underline; color: blue;padding:5px">{{ COL_FIELD }}</a></div>',
      "string:issueLink":
        '<center><div md-truncate ng-click="grid.appScope.ctrl.showIssueDialog($event,  COL_FIELD )" style="text-decoration: underline; color: blue;padding:5px"> {{COL_FIELD.split("&")[0] || "" }} </div></center>',
      "boolean:checkbox":
        '<center><md-icon class="text-main-color">{{ COL_FIELD ? "check_box" : "check_box_outline_blank" }}</md-icon></center>',
      "boolean:undefined":
        '<center><md-icon class="text-main-color">{{ COL_FIELD ? "check_box" : "check_box_outline_blank" }}</md-icon></center>',
    };

    var defaultTemplate = function (baseValue) {
      return '<div md-truncate class="ui-grid-cell-contents">' + baseValue + "</div md-truncate>";
    };

    this.setTemplate = function (colDef, col, schemasFormat) {
      // console.log(colDef, col, schemasFormat);

      schemasFormat = Array.isArray(schemasFormat) ? schemasFormat : [];
      // console.log(colDef);
      col.prefix = col.prefix || "";
      col.suffix = col.suffix || "";

      var prefix = col.prefix + " " || "";
      var suffix = " " + col.suffix || "";
      var filter = filtersByType[col.type] || "";

      var baseValue = prefix + "{{ COL_FIELD " + filter + " }}" + suffix;

      var key = col.type + ":" + col.format;

      // colDef.cellFilter = function (value) {
      //   if (value && value.includes('&')) return value.split('&')[0];
      //   else return value;
      // };

      colDef.cellClass = function (grid, row, col) {
        var style;
        var format = col.colDef.aux && col.colDef.aux.format ? col.colDef.aux.format : null;
        if (!format) return;

        var CELL_VALUE = grid.getCellValue(row, col);

        var def = schemasFormat.find(function (d) {
          return d.name == format;
        });

        if (def && def.body) {
          var style =
            def.body.find(function (sh) {
              var testa = CELL_VALUE + sh.key + sh.value;
              var testb = '"' + CELL_VALUE + '"' + sh.key + '"' + sh.value + '"';
              try {
                if (sh.type == "numeric") return eval(testa);
                if (sh.type == "string") return eval(testb);
              } catch (e) {
                return false;
              }
            }) || false;

          if (style) {
            return "cell-cutom-format " + style.icon + " " + style.color + " " + style.format;
          }
        }
      };
      // console.log("key", key, typesFormats[key]);
      return typesFormats[key] || defaultTemplate(baseValue);
    };
  }
})();

/* Servicio encargado de hacer las diversas validaciones en las distintas rutas
    del archivo index.route.js */

(function() {
    'use strict';
    
    angular
    .module('dashboard')
    .service('Casos', Casos)
    
    Casos.$inject = ['$http', 'Alertas', 'EventosAlerta', 'Comentarios'];
    function Casos($http, Alertas, EventosAlerta, Comentarios) {
      var casos = [
        {id: 1, estado: 'Abierto', nombre: 'Transacciones inusuales', fecha: '2016-06-10', hora: '10:46:57.123', tipo: 'Normal', criticidad: 'Alta', ejecutivo: 'UUrrtia'},
        {id: 2, estado: 'Abierto', nombre: 'Conflicto interés empresas ATR', fecha: '2016-07-10', hora: '10:46:57.123', tipo: 'Normal', criticidad: 'Media', ejecutivo: 'Afirtz'},
        {id: 3, estado: 'Abierto', nombre: 'Caso tres', fecha: '2016-08-10', hora: '10:46:57.123', tipo: 'Normal', criticidad: 'Alta', ejecutivo: 'PVillal'},
        {id: 4, estado: 'Abierto', nombre: 'Caso cuatro', fecha: '2016-09-10', hora: '10:46:57.123', tipo: 'Normal', criticidad: 'Baja', ejecutivo: 'UUrrtia'}
      ];
    
      var archivosCaso = [];
      archivosCaso['1'] = [
        {name: 'archivo.docx', url:'http://localhost/archivo.docx', uploadedBy: 'HTasd', fecha: '2016-06-10', hora: '10:56:45.213'},
        {name: 'archivo_2.docx', url:'http://localhost/archivo_2.docx', uploadedBy: 'Pepe', fecha: '2016-06-11', hora: '16:15:00.001'}];
      archivosCaso['2'] = [
        {name: 'archivo1.docx', url:'http://localhost/archivo1.docx', uploadedBy: 'UUrrtia', fecha: '2016-06-10', hora: '10:56:45.213'},
        {name: 'archivo_1_2.docx', url:'http://localhost/archivo_1_2.docx', uploadedBy: 'JGomez', fecha: '2016-06-11', hora: '16:15:00.001'}];
      archivosCaso['3'] = [
        {name: 'archivo3.docx', url:'http://localhost/archivo3.docx', uploadedBy: 'PVillal', fecha: '2016-06-10', hora: '10:56:45.213'},
        {name: 'archivo_3_2.docx', url:'http://localhost/archivo_3_2.docx', uploadedBy: 'Afirtz', fecha: '2016-06-11', hora: '16:15:00.001'}];
      archivosCaso['4'] = [
        {name: 'archivo4.docx', url:'http://localhost/archivo1.docx', uploadedBy: 'UUrrtia', fecha: '2016-06-10', hora: '10:56:45.213'},
        {name: 'archivo_4_2.docx', url:'http://localhost/archivo_1_2.docx', uploadedBy: 'JGomez', fecha: '2016-06-11', hora: '16:15:00.001'}];
    
      var alertasCasos = [];
      alertasCasos[1] = {alertas: [5, 4]};
      alertasCasos[2] = {alertas: [3]};
      alertasCasos[3] = {alertas: [4]};
      alertasCasos[4] = {alertas: [1, 5]};
      
      var comentarioCasos = [];
      comentarioCasos[1] = {
        uploadedBy: 'HTasd',
        comment: 'Completamente de acuerdo.',
        fecha: '2016-06-10',
        hora: '10:56:45.213'
        };
        comentarioCasos[2] = {
        uploadedBy: 'HTasd',
        comment: 'Completamente de acuerdo con el comentario de arriba.',
        fecha: '2016-06-10',
        hora: '11:02:45.213'
        };
        comentarioCasos[3] = {
        uploadedBy: 'Gcarrillo',
        comment: 'Revisión a la hora actual.',
        fecha: '2016-08-11',
        hora: '10:56:45.213'
        };
        comentarioCasos[4] = {
        uploadedBy: 'Jlopez',
        comment: 'Nueva revisión del caso con subida de archivo.',
        fecha: '2017-01-10',
        hora: '12:56:45.213'
        };
    
      this.obtenerCasosAlerta = function(idAlerta, callback) {
        var checkedCasos = [];
        var casosAlert = [];
        for(var i=1; i<alertasCasos.length; i++) {
          if(!alertasCasos[i]) {
            continue;
          }
          var a_alertas = alertasCasos[i].alertas;
          if(a_alertas) {
            for (var j = 0; j < a_alertas.length; j++) {
              if(a_alertas[j]===idAlerta && !checkedCasos[i]) {
                checkedCasos[i] = i;
                console.log(casos[i-1]);
                casosAlert.push(casos[i-1]);
              }
            }
          }
        }
        callback({header: {code:0}, body: casosAlert});
      };
    
      this.crearCaso = function(casoData, idAlerta, callback) {
        var idNewCaso = casos[casos.length-1].id + 1;
        var newCaso = {id: idNewCaso, nombre: casoData.nombre,
          fecha: '2016-06-10', hora: '10:46:57.123', tipo: 'Normal', estado: 'Abierto',
          criticidad: casoData.criticidad, ejecutivo: casoData.ejecutivo};
          casos.push(newCaso);
          if(idAlerta) {
            if(!alertasCasos[idNewCaso]) {
              alertasCasos[idNewCaso] = {alertas: []};
            }
            alertasCasos[idNewCaso].alertas.push(idAlerta);
          }
        //Se retorna llamado
        callback({header: {code: 0}, body: newCaso});
      };
    
      this.vincularAlertasCaso = function(idCaso, idAlertas, callback) {
        var actualCaso = casos[idCaso];
        if(actualCaso) {
          for(var i=0 ; i<idAlertas.length ; i++) {
            var idNewAlerta = idAlertas[i];
            //se asocia alerta al caso
            alertasCasos[idCaso].alertas.push(idNewAlerta);
          }
        }
        callback({header: {code: 0}});
      };
    
      this.desvincularAlertaCaso = function(idCaso, idAlerta, callback) {
        var actualCaso = casos[idCaso];
        if(actualCaso) {
          var indexDelete = -1;
          for(var i=0 ; i<alertasCasos[idCaso].alertas.length ; i++) {
            if(idAlerta===alertasCasos[idCaso].alertas[i]) {
              indexDelete = i;
              break;
            }
          }
          if(indexDelete>-1) {
            alertasCasos[idCaso].alertas.splice(indexDelete, 1);
          }
          callback({header: {code: 0}});
        }
      };
    
      this.obtenerAlertasCaso = function(idCaso, callback) {
        //Representa un servicio que retorna todas las alertas, con sus eventos y numero de comentarios por evento
        var alertasComments = alertasCasos[idCaso];
        if(alertasComments) {
          var alerts = Alertas.obtenerAlertasByIds(alertasComments.alertas);
          for(var i=0; i<alerts.length; i++) {
            var forAlert = alerts[i];
            var eventos = EventosAlerta.obtenerEventsByIdAlerta(forAlert.id);
            if(eventos) {
              for(var j=0; j<eventos.length; j++) {
                var forEvent = eventos[j];
                if(!forEvent) {
                  continue;
                }
                forEvent.comentariosQty = Comentarios.obtenerQtyComentariosCasoAlertaEvento(idCaso, alerts[i].id, forEvent.id);
              }
              forAlert.eventos = eventos;
            }
          }
          //callback({header: {code: 0}, body: alerts});
          callback({header: {code: 0}, body: JSON.parse(JSON.stringify(alerts))});
        }
      };
    
      this.searchCasos = function(sinceDate, untilDate, callback) {
        callback({header: {code: 0, message: ''}, body: casos});
      };
    
      this.obtenerArchivos = function(idCaso, callback) {
        callback({header: {code: 0, message: ''}, body: archivosCaso[idCaso]});
      };
      
      this.obtenerComentarios = function(idCaso, callback) {
        callback({header: {code: 0, message: ''}, body: comentarioCasos});
      };
    
    }
})();

/* Servicio encargado de hacer las diversas validaciones en las distintas rutas
  del archivo index.route.js */
(function () {
  "use strict";

  angular.module("dashboard").service("BookmarkService", BookmarkService);

  BookmarkService.$inject = ["$rootScope", "$state", "UserFactory", "toastr", "translationService"];
  function BookmarkService($rootScope, $state, $userFactory, $toastr, $translationService) {
    var DASHBOARD_NAME = "DESKTOP";
    var dashboard = null;
    var WIDGET_DEFAULT = {
      id: 1,
      acl: "",
      group: "Desktop",
      widget: {
        type: "user-bookmarks-widget",
        props: {
          title: "User Bookmarks",
          bookmarks: [],
        },
      },
      position: {
        col: 0,
        row: 0,
        sizeX: 12,
        sizeY: 6,
        minSizeX: 2,
        minSizeY: 2,
      },
    };
    var self = this;

    this.loading = false;

    this.translation = {
      add_bookmark: $translationService.getTranslationController(
        "Add Bookmark",
        "Agregar a Favoritos",
        "Adicionar aos favoritos"
      ),
      remove_bookmark: $translationService.getTranslationController(
        "Remove Bookmark",
        "Eliminar de Favoritos",
        "Remover dos favoritos"
      ),
    };

    this.getDashboard = function () {
      self.init();
      // console.log("getDashboard", dashboard);
      return dashboard;
    };

    this.getBookmarks = function (callback) {
      dashboard = self.getDashboard();
      // console.log("getBookmarks", dashboard);
      var bookmarks = [];
      if (dashboard && dashboard.dashboardConfig && dashboard.dashboardConfig.length > 0) {
        var w = dashboard.dashboardConfig.find(function (w) {
          return w.id == 1;
        });
        if (w && w.widget && w.widget.props && w.widget.props.bookmarks) {
          bookmarks = w.widget.props.bookmarks;
        }
      }
      callback();
      return (bookmarks || [])
        .map(function (b, index) {
          b.order = b.order || 99;
          return b;
        })
        .sort(function (a, b) {
          return a.order - b.order;
        });
    };

    this.init = function () {
      self.loading = false;
      getUserDashboardBookmarks().then(function (res) {
        dashboard = res;
        if (dashboard) {
          dashboard.dashboardConfig = JSON.parse(dashboard.dashboardConfig);
        } else {
          dashboard = {
            dashboardId: null,
            dashboardName: DASHBOARD_NAME,
            dashboardStatus: true,
            dashboardConfig: [WIDGET_DEFAULT],
            dashboardOrder: 0,
          };
        }
        self.loading = false;
        // console.log("init", res);
        return dashboard;
      });
    };

    this.getEntityBookmark = function (id, type) {
      // self.init();
      dashboard = dashboard || { dashboardConfig: [WIDGET_DEFAULT] };
      var bookmark = null;
      
      if (dashboard && dashboard.dashboardConfig && dashboard.dashboardConfig.length > 0) {
        var w = dashboard.dashboardConfig.find(function (w) {
          return w.id == 1;
        });
        
        if (w && w.widget && w.widget.props && w.widget.props.bookmarks) {
          bookmark = w.widget.props.bookmarks.find(function (b) {
            return b.id == id && b.type == type;
          });
        }
      }
      // console.log("getEntityBookmark", id, type, bookmark);
      
      return new Promise(function (resolve) {
        resolve(bookmark);
      });
    };

    this.updateUserDashboardBookmarks = function (entity, callback) {
      if (!dashboard) {
        console.error("Error: Desktop dashboard does not exist");
        return;
      }

      var widget = getWidget();
      if (!widget) {
        // return;
        dashboard.dashboardConfig.push(WIDGET_DEFAULT);
        console.error("Error: Widget does not exist in dashboard, creating default");
        // widget = getWidget();
      }

      updateUserDashboardBookmarks(entity, callback);
    };

    this.removeBookmark = function (_bookmark, callback) {
      if (!dashboard) {
        return;
      }

      var w = dashboard.dashboardConfig.find(function (w) {
        return w.id == 1;
      });

      if (!w) {
        return;
      }

      if (!w.widget.props.bookmarks) {
        w.widget.props.bookmarks = [];
      }
      
      w.widget.props.bookmarks = w.widget.props.bookmarks.filter(function (b) {
        return !(b.id == _bookmark.id && b.type == _bookmark.type);
      });
      saveOrUpdateDashboard(dashboard, false);
      callback();
    };

    this.reorderBookmarks = function (newOrder) {
      if (!dashboard) {
        console.error("Error: Widget does not exist in dashboard");
        return;
      }

      var w = dashboard.dashboardConfig.find(function (w) {
        return w.id == 1;
      });

      if (!w) {
        console.error("Error: Widget does not exist in dashboard");
        return;
      }

      w.widget.props.bookmarks = newOrder;debugger

      saveOrUpdateDashboard(dashboard, false);
    };

    function updateUserDashboardBookmarks(entity, callback) {
      self.init();
      var createDashboard = dashboard && dashboard.dashboardId == null;

      var w = dashboard.dashboardConfig.find(function (w) {
        return w.id == 1;
      });

      setupEntity(entity)
        .then(function (ent) {
          if (createDashboard) {
            w.widget.props.bookmarks.push(ent);
          } else {
            var hasBookmark = w.widget.props.bookmarks.some(function (b) {
              return b.id == entity.id && b.type == entity.type;
            });

            if (hasBookmark) {
              w.widget.props.bookmarks = w.widget.props.bookmarks.filter(function (b) {
                return !(b.id == entity.id && b.type == entity.type);
              });
            } else {
              w.widget.props.bookmarks.push(ent);
            }
          }
          // console.log("Bookmarks to save", dashboard);;
          saveOrUpdateDashboard(dashboard, !dashboard.dashboardId).then(function () {
            callback();
          });
        })
        .catch(function (err) {
          console.error("Error setting up entity", err);
        });
    }

    function saveOrUpdateDashboard(dashboard, isNew) {
      return new Promise(function (resolve, reject) {
        var send = angular.copy(dashboard);
        if (!isNew) {
          send.id = dashboard.dashboardId;
        }
        self.loading = true;
        // console.log("Saving dashboard...", send);
        // console.log("Is new?", isNew);
        $userFactory
          .saveUserDashboardsV2(isNew ? "create" : "update", send)
          .then(function (res) {
            dashboard.dashboardId = res.dashboardId;
            dashboard.dashboardConfig = JSON.parse(res.dashboardConfig);
            var created = $translationService.getTranslationController(
              "Dashboard Created",
              "Tablero Creado",
              "Painel criado"
            );

            var updated = $translationService.getTranslationController(
              "Dashboard Updated",
              "Tablero Actualizado",
              "Painel atualizado"
            );

            if (isNew) {
              $toastr.success(created);
            } else {
              $toastr.success(updated);
            }
            return true;
          })
          .catch(function (err) {
            console.error("err@saveUserDashboards", err);
            $toastr.error("Error saving dashboard");
            reject(err);
          })
          .finally(function () {
            self.loading = false;
            self.init();
            resolve();
          });
      });
    }

    function getWidget() {
      if (!dashboard || !dashboard.dashboardConfig || dashboard.dashboardConfig.length == 0) {
        dashboard.dashboardConfig = [WIDGET_DEFAULT];
      }

      return dashboard.dashboardConfig.find(function (w) {
        return w.id == 1;
      });
    }

    function getUserDashboardBookmarks() {
      return new Promise(function (resolve, reject) {
        $userFactory
          .getUserDashboards()
          .then(function (res) {
            var dashboard =
              res.find(function (d) {
                return d.dashboardName == DASHBOARD_NAME;
              }) || null;

            resolve(dashboard);
          })
          .catch(function (err) {
            console.error("err@getUserDashboards", err);
            reject(err);
          });
      });
    }

    function setupEntity(entity) {
      return new Promise(function (resolve, reject) {
        if (!entity || !entity.id || !entity.type || !entity.name) {
          console.error("Error: Invalid entity", entity);
          reject("Invalid entity");
          return;
        }

        resolve({
          name: entity.name,
          id: entity.id,
          type: entity.type,
          order: 99999,
        });
      });
    }
  }
})();

/* Servicio encargado de hacer setear los URL */
(function () {
  "use strict";

  angular.module("dashboard").service("BaseUrl", BaseUrl);

  BaseUrl.$inject = [];

  function BaseUrl() {
    this.path = {
      URL_AUTH_TOKEN: "/risk-backend/rest/auth/token",
      URL_AUTH_REFRESH_TOKEN: "/risk-backend/rest/auth/refresh-token",
      URL_OAUTH2_PROVIDERS: "/risk-backend/rest/auth/oauth2/providers",
      URL_OAUTH2_TOKEN: "/risk-backend/rest/auth/oauth2/token",
      URL_USER_DASHBOARD: "/risk-backend/rest/user/dashboard",
      // - DataConnection
      URL_DATACONN: "/risk-backend/rest/config/dataconnection",
      URL_DATACONN_PROTOCOLS:
        "/risk-backend/rest/config/dataconnectionprotocols",
      // - Eventos
      URL_EVENTS_SUMMARY: "/risk-backend/rest/events/summary",
      URL_EVENTS_LIST: "/risk-backend/rest/events/filteredlist",
      URL_EVENTS_AGGREGATION_DATA:
        "/risk-backend/rest/events/aggregationquerydata",
      URL_EVENTS_AGGREGATION_KEYS:
        "/risk-backend/rest/events/aggregationKeyValues",
      URL_EVENTS_AGGREGATION: "/risk-backend/rest/events/aggregate",
      URL_EVENTS_V2: "/risk-backend/rest/v2/event/",
      URL_EVENTS_ALL_BY_FILTERS: "/risk-backend/rest/v2/event/eventsFiltered",
      // - Casos
      URL_CASES_SUMMARY: "/risk-backend/rest/case/summary",
      URL_CASES_CREATE: "/risk-backend/rest/case",
      URL_DASHBOARD: "/risk-backend/rest/dashboard",
      URL_PROFILE_ROLES: "/risk-backend/rest/perfilamiento/listarRoles",
      URL_CREAR_USUARIO: "/risk-backend/rest/perfilamiento/crearUsuario",
      URL_EDITAR_USUARIO: "/risk-backend/rest/perfilamiento/editarUsuario",
      URL_LISTADO_USUARIOS: "/risk-backend/rest/perfilamiento/listadoUsuarios",
      URL_LISTADO_USUARIOS_ROLES:
        "/risk-backend/rest/perfilamiento/listarUsuariosRoles",
      URL_ELIMINAR_USUARIO: "/risk-backend/rest/perfilamiento/eliminarUsuario",
      URL_CAMBIAR_PASSWORD_USUARIO:
        "/risk-backend/rest/perfilamiento/cambiarPassword",
      URL_BUSCAR_USUARIO: "/risk-backend/rest/perfilamiento/buscarUsuario",
      URL_BUSCAR_PERFIL_POR_ID: "/risk-backend/rest/perfilamiento/buscarPerfil",
      URL_PROFILE_PERFILES: "/risk-backend/rest/perfilamiento/listadoPerfiles",
      URL_PERFILES_ROLES_OPCIONES:
        "/risk-backend/rest//perfilamiento/listaPerfilesRolesOpciones",
      URL_PERFILES_ROLES_OPCIONES_ACTIVOS:
        "/risk-backend/rest//perfilamiento/listaPerfilesRolesOpcionesActivos",
      URL_CREAR_PERFIL_ROL_OPCION:
        "/risk-backend/rest//perfilamiento/crearPerfilRolOpcion",
      URL_EDITAR_PERFIL_ROL_OPCION:
        "/risk-backend/rest//perfilamiento/editarPerfilRolOpcion",
      URL_CREAR_PERFIL: "/risk-backend/rest/perfilamiento/crearPerfil",
      URL_EDITAR_PERFIL: "/risk-backend/rest/perfilamiento/editarPerfil",
      URL_PROFILE_OPTIONS: "/risk-backend/rest/perfilamiento/listarOpciones",
      URL_BUSCAR_PERFIL_POR_ROL:
        "/risk-backend/rest/perfilamiento/buscarPerfilPorRol",
      URL_PERFIL_ELIMINAR_POR_ID:
        "/risk-backend/rest/perfilamiento/eliminarPerfil",
      URL_LISTADO_USUARIO_ROL_PERFIL:
        "/risk-backend/rest/perfilamiento/listarUsuarioRolPerfil",
      URL_UP_FILE: "/risk-backend/rest/case",
      // - Casos
      URL_COMMENT_LIST: "/risk-backend/rest/case",
      // -- PowerBI methods
      URL_PWBI: "/risk-backend/rest/report/powerbi",
      URL_LOGIN_PWBI: "/risk-backend/rest/report/powerbi/login",
      URL_GRUPOS_PWBI: "/risk-backend/rest/report/powerbi/groups",
      // -- Auditoría
      URL_AUDITORIA: "/risk-backend/rest/audit",
      URL_AUDITORIA_FILTROS: "/risk-backend/rest/audit/filters",
      // -- EventReplay methods
      URL_EVENT_REPLAY: "/risk-backend/rest/replay/",
      // -- Workspaces methods
      URL_WORKSPACES: "/risk-backend/rest/workspace/",
      // -- Filtros de Exclusion
      URL_FUNCTION_FILTERS_GETALL: "/risk-backend/rest/function/filter/all",
      URL_FUNCTION_FILTERS_CREATE: "/risk-backend/rest/function/filter/create/",
      URL_FUNCTION_FILTERS_UPDATE: "/risk-backend/rest/function/filter/update/",
      // -- Schemas
      URL_SCHEMA_SERVICES: "/risk-backend/rest/schema/",
      // -- InputLists
      URL_INPUT_LISTS_SERVICES: "/risk-backend/rest/inputlist/",
      URL_INPUT_LISTS_DATA: "/risk-backend/rest/inputlist/data",
      // -- Functions (RuleEditor)
      URL_FUNCTION: "/risk-backend/rest/function/",
      URL_FUNCTION_TRANSFORMATIONS:
        "/risk-backend/rest/function/transformations/",
      URL_FUNCTION_SCHEDULES: "/risk-backend/rest/schedules",
      URL_FUNCTION_QUEUE: "/risk-backend/rest/function/executions/queue/v2",
      URL_FUNCTION_STOP: "/risk-backend/rest/function/stopexecute/v2/",
      // -- Replay
      URL_SERIES_CONFIG: "/risk-backend/rest/multi-graphic/config/series",
      URL_REPLAY_CONFIG: "/risk-backend/rest/multi-graphic/config/replay",
      // -- Domain methods
      URL_DOMAINS: "/risk-backend/rest/domain/",
      URL_LABEL: "/risk-backend/rest/label/",
      // -- Seacher
      URL_SEARCHER: "/risk-backend/rest/searchers",
      // -- Dashboard Reports
      URL_REPORT: "/risk-backend/rest/report/config",
      URL_REPORT_METADATA: "/risk-backend/rest/report/config/status-metadata",
      URL_REPORT_DASHBOARD: "/risk-backend/rest/report/",
      // -- FILE STORAGE
      URL_FILE_STORAGE_CONFIG: "/risk-backend/rest/file/config",
      URL_FILE_STORAGE_INFO: "/risk-backend/rest/file/global/info",
      URL_FILE_STORAGE_FOLDER: "/risk-backend/rest/file/folder",
      URL_FILE_STORAGE_TRASH: "/risk-backend/rest/file/trash",
      URL_FILE_STORAGE_SYSTEM: "/risk-backend/rest/file/system",
      // -- ISSUE
      URL_ISSUE: "/risk-backend/rest/issue",
      // -- ISSUE REFERENCES
      URL_REFERENCES: "/risk-backend/rest/references",
      // -- CHARTS
      URL_CHARTS: "/risk-backend/rest/v2/chart/",
      // -- COMMENTS
      URL_COMMENTS: "/risk-backend/rest/comments",
      // -- NOTIFICATIONS
      URL_NOTIFICATIONS: "/risk-backend/rest/notifications",
      // -- DATA TABLES
      URL_TABLES: "/risk-backend/rest/tables/",
      // -- INDICATORS
      URL_INDICATORS: '/risk-backend/rest/indicators',
      URL_CUSTOM_REPORTS: '/risk-backend/rest/custom-report',
      URL_TOKENS: '/risk-backend/rest/auth/tokens',
      URL_HOLIDAYS: '/risk-backend/rest/holidays',
      ETHICAL_PORTAL: '/risk-backend/rest/ethical-portal/v2',
      ETHICAL_PORTAL_V3: '/risk-backend/rest/ethical-portal/v3',
      //- EXTERNAL LIBRARIES - python-library
      URL_EXTERNAL_LIBRARIES_PYTHON: '/risk-backend/rest/python-library',
      DOCUMETS: '/risk-backend/rest/documents/',
      HEALTHY: '/risk-backend/rest/healthy',
      URL_SYNC: '/risk-backend/rest/sync'
    };

    this.base64Encode = function (input) {
      var keyStr =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      var output = "";
      var chr1,
        chr2,
        chr3 = "";
      var enc1,
        enc2,
        enc3,
        enc4 = "";
      var i = 0;

      do {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);

        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;

        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }

        output =
          output +
          keyStr.charAt(enc1) +
          keyStr.charAt(enc2) +
          keyStr.charAt(enc3) +
          keyStr.charAt(enc4);
        chr1 = chr2 = chr3 = "";
        enc1 = enc2 = enc3 = enc4 = "";
      } while (i < input.length);

      return output;
    };

    // - DataConnection
    this.urlDataConn = function (id) {
      return "/risk-backend/rest/config/dataconnection/" + id;
    };
    this.urlTestDataConn = function (id) {
      return "/risk-backend/rest/config/dataconnectiontest/" + id;
    };

    // Dashboard Reports
    this.urlReport = function (id) {
      return "/risk-backend/rest/report/config/" + id;
    };

    this.urlReportDashboard = function (id) {
      return "/risk-backend/rest/report/" + id;
    };

    // Function
    this.urlFunction = function (functionId) {
      return "/risk-backend/rest/function/" + functionId;
    };

    this.urlFunctionName = function (urlFunctionName) {
      return "/risk-backend/rest/function/name/" + urlFunctionName;
    };

    this.urlFunctionTypecheck = function (functionId) {
      return "/risk-backend/rest/function/" + functionId + "/typecheck";
    };

    this.urlFunctionExecute = function (functionId) {
      return "/risk-backend/rest/function/execute/" + functionId;
    };

    this.urlFunctionExecuteV2 = function (functionId) {
      return "/risk-backend/rest/function/execute/v2/" + functionId;
    };

    this.urlFunctionStopExecute = function (functionId) {
      return "/risk-backend/rest/function/stopexecute/" + functionId;
    };

    this.urlFunctionStopExecuteV2 = function (executionId) {
      return "/risk-backend/rest/function/stopexecute/v2/" + executionId;
    };

    this.urlFunctionVersion = function (functionId) {
      return "/risk-backend/rest/function/" + functionId + "/version";
    };

    this.urlVersion = function (versionId) {
      return "/risk-backend/rest/function/version/" + versionId;
    };

    this.urlFunctionUpdateVersion = function (functionId, version) {
      return (
        "/risk-backend/rest/function/" + functionId + "/version/" + version
      );
    };

    this.urlFunctionEnvironment = function (functionId) {
      return "/risk-backend/rest/function/" + functionId + "/environment";
    };

    this.urlFunctionExecutions = function (functionId, executionId) {
      if (executionId) {
        return (
          "/risk-backend/rest/function/" +
          functionId +
          "/executions/" +
          executionId
        );
      }
      return "/risk-backend/rest/function/" + functionId + "/executions";
    };

    this.urlFunctionAttributes = function (functionId) {
      return "/risk-backend/rest/function/" + functionId + "/attribute/";
    };

    // Lists
    this.urlInputList = function (listId) {
      return "/risk-backend/rest/inputlist/" + listId;
    };
    this.urlInputListFilters = function (listId) {
      return "/risk-backend/rest/inputlist/" + listId + "/filters";
    };
    /** @deprecated */
    this.urlInputListData = function (listId) {
      return "/risk-backend/rest/inputlist/" + listId + "/data/filtered";
    };
    this.urlInputListDataFiltered = function (listId) {
      return "/risk-backend/rest/inputlist/" + listId + "/data/custom-filter";
    };

    this.urlInputListMetadata = function (listId) {
      return "/risk-backend/rest/inputlist/" + listId + "/metadata";
    };

    this.urlInputListSaveData = function (listId) {
      return "/risk-backend/rest/inputlist/" + listId + "/data";
    };

    this.urlInputListImportData = function (listId) {
      return "/risk-backend/rest/inputlist/" + listId + "/importData";
    };
    this.urlInputListClearData = function (listId) {
      return "/risk-backend/rest/inputlist/" + listId + "/data/remove-all";
    };
    this.urlInputListDeleteRows = function (listId) {
      return "/risk-backend/rest/inputlist/" + listId + "/data/remove";
    };
    this.urlGetInputDataById = function (inputDataId) {
      return "/risk-backend/rest/inputlist/data/" + inputDataId;
    };
    this.urlInputListSettings = function (listId) {
      return "/risk-backend/rest/inputlist/settings/" + listId;
    };
    this.urlInputListStatisticsSumary = function (listId) {
      return (
        "/risk-backend/rest/inputlist/" + listId + "/data/summary-statistics"
      );
    };
    this.urlInputListFindAndReplace = function (listId) {
      return "/risk-backend/rest/inputlist/" + listId + "/data/replace-with";
    };

    // Schemas
    this.urlDeleteSchema = function (schemaId) {
      return "/risk-backend/rest/schema/" + schemaId;
    };
    // Filtros de exclusión
    this.urlDeleteFunctionFilter = function (filterId) {
      return "/risk-backend/rest//function/filter/delete/" + filterId;
    };

    // Workspaces
    this.urlCreateUserWorkspace = function (name) {
      return "/risk-backend/rest/workspace/" + name;
    };
    this.urlUpdateUserWorkspace = function (id, name) {
      return (
        "/risk-backend/rest/workspace/updateUserWorkspace/" + id + "/" + name
      );
    };

    // Event Replay
    this.urlEventReplayData = function (replay) {
      return "/risk-backend/rest/replay/" + replay + "/data";
    };
    this.urlEventReplayMultigraphs = function (replay) {
      return "/risk-backend/rest/replay/" + replay + "/multigraph";
    };
    this.urlEventReplayGraphData = function (multigraph) {
      return "/risk-backend/rest/events/" + multigraph + "/events";
    };
    this.urlEventReplaySymbols = function (replay, multigraph) {
      return (
        "/risk-backend/rest/replay/" +
        replay +
        "/multigraph/" +
        multigraph +
        "/symbols"
      );
    };
    this.urlEventReplaySetInterval = function (replay, multigraph) {
      return (
        "/risk-backend/rest/replay/" +
        replay +
        "/multigraph/" +
        multigraph +
        "/bookmarks"
      );
    };
    this.urlEventReplayDelInterval = function (replay, multigraph, bookmark) {
      return (
        "/risk-backend/rest/replay/" +
        replay +
        "/multigraph/" +
        multigraph +
        "/bookmarks/" +
        bookmark
      );
    };
    // Related Events
    this.urlEventRelatedEvents = function (id) {
      var URL = "/risk-backend/rest/events/";
      return URL + id + "/related";
    };

    this.urlCheckEvents = function (id) {
      var URL = "/risk-backend/rest/events/";
      return URL + id + "/check";
    };

    this.urlCaseRelatedEvents = function (id) {
      var URL = "/risk-backend/rest/case/$id/events";
      return URL.replace("$id", id);
    };

    // Users
    this.urlPasswordReset = function (username) {
      return "/risk-backend/rest/user/" + username.trim() + "/reset-password";
    };

    this.urlPasswordChange = function (username, token) {
      return "/risk-backend/rest/user/" + username + "/reset-password/" + token;
    };

    // Reports
    this.urlPowerBIReports = function (groupId) {
      return "/risk-backend/rest/report/powerbi/" + groupId + "/reports";
    };

    this.urlPowerBIReportToken = function (groupId, reportId) {
      return (
        "/risk-backend/rest/report/powerbi/" +
        groupId +
        "/reports/" +
        reportId +
        "/embedToken"
      );
    };
  }
})();

/* Servicio encargado de hacer las diversas validaciones en las distintas rutas
    del archivo index.route.js */

(function() {
    'use strict';
    
    angular
    .module('dashboard')
    .service('Alertas', Alertas)

    Alertas.$inject = ['$http'];
    function Alertas($http) {
    
        var alertas = [
            {id: 1, fecha: '2016-02-15', hora: '16:45:46.213', tipo: 'Incidente', ejecutivo: 'JBurks', criticidad: 'Alta'},
            {id: 2, fecha: '2016-02-16', hora: '16:45:46.213', tipo: 'Notificacion', ejecutivo: 'JBurks', criticidad: 'Baja'},
            {id: 3, fecha: '2016-04-17', hora: '16:45:46.213', tipo: 'Incidente', ejecutivo: 'HBurns', criticidad: 'Baja'},
            {id: 4, fecha: '2016-05-19', hora: '16:45:46.213', tipo: 'Incidente', ejecutivo: 'HBurns', criticidad: 'Media'},
            {id: 5, fecha: '2016-06-01', hora: '18:42:46.213', tipo: 'Incidente', ejecutivo: 'JJones', criticidad: 'Alta'}
        ];
    
        this.obtenerAlertas = function(callback) {
            callback({header: {code: 0, message: ''}, body: alertas});
        };
    
        this.searchAlerts = function(sinceDate, untilDate, callback) {
        //Funcion que permite buscar las alertas a partir de los rangos de fecha
        //TODO si la fecha untilDate es igual a la fecha actual, entonces agregar listener a websocket
            callback({header: {code: 0, message: ''}, body: alertas});
        };
    
        this.obtenerAlertasByIds = function(idAlertas) {
            var arrayResponse = [];
            for(var i=0; i<alertas.length; i++) {
                for(var j=0; j<idAlertas.length; j++) {
                    if(alertas[i].id == idAlertas[j]) {
                        arrayResponse.push(alertas[i]);
                    }
                }
            }
            return arrayResponse.slice();
        }
    }
})();
/*  */

(function() {
    'use strict';
    
    angular
    .module('dashboard')
    .service('AlertasConfig', AlertasConfig)

    AlertasConfig.$inject = ['$http'];
    function AlertasConfig($http) {
  
      var alertas = [
        {id: 1, nombre: 'Conflicto de interés', tipo: 'Incidente', descripcion: 'Descripcion conflicto de interés', estado: true},
        {id: 2, nombre: 'Sobregiro cuenta', tipo: 'Incidente', descripcion: 'Sobregiro en la cuenta de cliente', estado: true},
        {id: 3, nombre: 'Posible transacción tarjeta clonada', tipo: 'Notificacion', descripcion: 'Posible detección de tarjeta clonada', estado: true},
        {id: 4, nombre: 'Transacción no habitual', tipo: 'Incidente', descripcion: 'Transacción fuera de los rangos habituales de un cliente', estado: true},
        {id: 5, nombre: 'Incidente test', tipo: 'Incidente', descripcion: 'Descripcion.....', estado: true}
      ];
  
      var parametrosAlertas = [];
      parametrosAlertas['1'] = [
        {name: 'parametro1', value:'value1', description: 'description parametro1'},
        {name: 'p2', value: 'value2', description: 'description p2'}];
      parametrosAlertas['2'] = [
        {name: 'parametro8', value:'value1', description: 'description parametro8'},
        {name: 'p6', value: 'value2', description: 'description p6'}];
      parametrosAlertas['3'] = [
        {name: 'param345', value:'value1', description: 'description param345'},
        {name: 'tasa', value: '3.25', description: 'description tasa'}];
      parametrosAlertas['4'] = [
        {name: 'param4', value:'value1', description: 'description param345'},
        {name: 'tasa4', value: '3.25', description: 'description tasa'}];
      parametrosAlertas['5'] = [
        {name: 'param5', value:'value1', description: 'description param345'},
        {name: 'tasa5', value: '3.25', description: 'description tasa'}];
  
      this.obtenerAlertas = function(callback) {
        callback({header: {code:0}, body: alertas});
      }
  
      this.obtenerParametrosAlerta = function(idAlerta, callback) {
        callback({header: {code:0}, body: parametrosAlertas[idAlerta]});
      }
  
      this.obtenerAlertaPorId = function(idAlerta, callback) {
        callback({header: {code:0}, body: getAlertaById(idAlerta)});
      }
  
      function getAlertaById(id) {
        for(var i=0; i<alertas.length; i++) {
          if(alertas[i].id == id) {
            return alertas[i];
          }
        }
        return null;
      }
    }
})();
/* Servicio encargado de hacer las diversas validaciones en las distintas rutas
    del archivo index.route.js */

(function() {
    'use strict';
    
    angular
    .module('dashboard')
    .service('Alarmas', Alarmas)

    Alarmas.$inject = [];

    function Alarmas() {
        this.allAlarmas = allAlarmas;


        var data = [
        {
            "id": "",
            "fecha": "2016-04-02T06:55:08-07:00",
            "ejecutivo": "Gay Key",
            "descripcion": "ante ipsum primis in faucibus orci luctus et ultrices posuere"
        },
        {
            "id": "",
            "fecha": "2015-10-12T20:32:08-07:00",
            "ejecutivo": "Hillary Cabrera",
            "descripcion": "semper erat, in consectetuer ipsum nunc id enim. Curabitur massa."
        },
        {
            "id": "",
            "fecha": "2016-05-12T03:07:48-07:00",
            "ejecutivo": "Iris Burks",
            "descripcion": "metus urna convallis erat, eget tincidunt dui augue eu tellus."
        },
        {
            "id": "",
            "fecha": "2016-02-11T11:05:11-08:00",
            "ejecutivo": "Orla Levy",
            "descripcion": "vitae risus. Duis a mi fringilla mi lacinia mattis. Integer"
        },
        {
            "id": "",
            "fecha": "2015-09-07T23:08:05-07:00",
            "ejecutivo": "Phoebe Moody",
            "descripcion": "dolor. Nulla semper tellus id nunc interdum feugiat. Sed nec"
        },
        {
            "id": "",
            "fecha": "2015-12-24T03:04:50-08:00",
            "ejecutivo": "Ivan Barber",
            "descripcion": "nisi a odio semper cursus. Integer mollis. Integer tincidunt aliquam"
        },
        {
            "id": "",
            "fecha": "2016-01-12T20:42:53-08:00",
            "ejecutivo": "Victor Barron",
            "descripcion": "lectus. Nullam suscipit, est ac facilisis facilisis, magna tellus faucibus"
        },
        {
            "id": "",
            "fecha": "2015-08-04T02:09:16-07:00",
            "ejecutivo": "Ina Phillips",
            "descripcion": "blandit enim consequat purus. Maecenas libero est, congue a, aliquet"
        },
        {
            "id": "",
            "fecha": "2015-09-24T16:16:10-07:00",
            "ejecutivo": "Eugenia Marsh",
            "descripcion": "egestas. Aliquam fringilla cursus purus. Nullam scelerisque neque sed sem"
        },
        {
            "id": "",
            "fecha": "2016-04-13T14:40:13-07:00",
            "ejecutivo": "Oliver Sellers",
            "descripcion": "risus. Donec nibh enim, gravida sit amet, dapibus id, blandit"
        },
        {
            "id": "",
            "fecha": "2016-04-29T01:52:44-07:00",
            "ejecutivo": "Dana Hodges",
            "descripcion": "Nullam lobortis quam a felis ullamcorper viverra. Maecenas iaculis aliquet"
        },
        {
            "id": "",
            "fecha": "2015-08-28T07:42:23-07:00",
            "ejecutivo": "Chaim Stevenson",
            "descripcion": "gravida non, sollicitudin a, malesuada id, erat. Etiam vestibulum massa"
        },
        {
            "id": "",
            "fecha": "2016-03-03T10:24:19-08:00",
            "ejecutivo": "Justine Madden",
            "descripcion": "purus, in molestie tortor nibh sit amet orci. Ut sagittis"
        },
        {
            "id": "",
            "fecha": "2016-02-10T03:45:46-08:00",
            "ejecutivo": "Brennan Wise",
            "descripcion": "diam at pretium aliquet, metus urna convallis erat, eget tincidunt"
        },
        {
            "id": "",
            "fecha": "2015-07-04T21:25:50-07:00",
            "ejecutivo": "Robin Pitts",
            "descripcion": "eu turpis. Nulla aliquet. Proin velit. Sed malesuada augue ut"
        },
        {
            "id": "",
            "fecha": "2016-02-17T22:49:48-08:00",
            "ejecutivo": "Janna Crawford",
            "descripcion": "dolor quam, elementum at, egestas a, scelerisque sed, sapien. Nunc"
        },
        {
            "id": "",
            "fecha": "2016-04-29T19:40:19-07:00",
            "ejecutivo": "Meghan Brown",
            "descripcion": "mi pede, nonummy ut, molestie in, tempus eu, ligula. Aenean"
        },
        {
            "id": "",
            "fecha": "2016-04-16T09:03:12-07:00",
            "ejecutivo": "Lani Marshall",
            "descripcion": "velit in aliquet lobortis, nisi nibh lacinia orci, consectetuer euismod"
        },
        {
            "id": "",
            "fecha": "2016-04-09T21:01:18-07:00",
            "ejecutivo": "Carson Levine",
            "descripcion": "eleifend non, dapibus rutrum, justo. Praesent luctus. Curabitur egestas nunc"
        },
        {
            "id": "",
            "fecha": "2016-01-29T04:35:31-08:00",
            "ejecutivo": "India Langley",
            "descripcion": "Nam consequat dolor vitae dolor. Donec fringilla. Donec feugiat metus"
        },
        {
            "id": "",
            "fecha": "2016-05-08T16:56:32-07:00",
            "ejecutivo": "Jeanette English",
            "descripcion": "nec, mollis vitae, posuere at, velit. Cras lorem lorem, luctus"
        },
        {
            "id": "",
            "fecha": "2015-07-23T00:52:39-07:00",
            "ejecutivo": "Emma Wilson",
            "descripcion": "aliquam adipiscing lacus. Ut nec urna et arcu imperdiet ullamcorper."
        },
        {
            "id": "",
            "fecha": "2015-08-10T05:08:01-07:00",
            "ejecutivo": "Isabelle Conway",
            "descripcion": "sed tortor. Integer aliquam adipiscing lacus. Ut nec urna et"
        },
        {
            "id": "",
            "fecha": "2016-04-30T21:59:58-07:00",
            "ejecutivo": "Fay Burch",
            "descripcion": "vestibulum nec, euismod in, dolor. Fusce feugiat. Lorem ipsum dolor"
        },
        {
            "id": "",
            "fecha": "2015-07-31T03:20:08-07:00",
            "ejecutivo": "Quentin Guzman",
            "descripcion": "sapien, cursus in, hendrerit consectetuer, cursus et, magna. Praesent interdum"
        },
        {
            "id": "",
            "fecha": "2015-10-24T05:38:04-07:00",
            "ejecutivo": "Ann Freeman",
            "descripcion": "augue scelerisque mollis. Phasellus libero mauris, aliquam eu, accumsan sed,"
        },
        {
            "id": "",
            "fecha": "2015-06-23T22:12:25-07:00",
            "ejecutivo": "Veda Rodriquez",
            "descripcion": "Phasellus vitae mauris sit amet lorem semper auctor. Mauris vel"
        },
        {
            "id": "",
            "fecha": "2015-06-14T10:20:19-07:00",
            "ejecutivo": "Sylvester Flynn",
            "descripcion": "erat neque non quam. Pellentesque habitant morbi tristique senectus et"
        },
        {
            "id": "",
            "fecha": "2015-09-29T23:39:37-07:00",
            "ejecutivo": "Anastasia Finley",
            "descripcion": "adipiscing lobortis risus. In mi pede, nonummy ut, molestie in,"
        },
        {
            "id": "",
            "fecha": "2015-10-29T10:09:15-07:00",
            "ejecutivo": "Roth Wise",
            "descripcion": "amet ante. Vivamus non lorem vitae odio sagittis semper. Nam"
        },
        {
            "id": "",
            "fecha": "2016-04-15T03:52:07-07:00",
            "ejecutivo": "Theodore Romero",
            "descripcion": "erat nonummy ultricies ornare, elit elit fermentum risus, at fringilla"
        },
        {
            "id": "",
            "fecha": "2016-02-08T14:02:49-08:00",
            "ejecutivo": "Jakeem Hammond",
            "descripcion": "nonummy ac, feugiat non, lobortis quis, pede. Suspendisse dui. Fusce"
        },
        {
            "id": "",
            "fecha": "2015-07-18T16:54:57-07:00",
            "ejecutivo": "Haviva Robertson",
            "descripcion": "aliquet, metus urna convallis erat, eget tincidunt dui augue eu"
        },
        {
            "id": "",
            "fecha": "2016-04-08T00:16:48-07:00",
            "ejecutivo": "Ryder Monroe",
            "descripcion": "sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus"
        },
        {
            "id": "",
            "fecha": "2016-04-13T19:46:51-07:00",
            "ejecutivo": "Murphy Hardin",
            "descripcion": "nunc nulla vulputate dui, nec tempus mauris erat eget ipsum."
        },
        {
            "id": "",
            "fecha": "2015-10-23T23:32:28-07:00",
            "ejecutivo": "Keelie Montoya",
            "descripcion": "Ut sagittis lobortis mauris. Suspendisse aliquet molestie tellus. Aenean egestas"
        },
        {
            "id": "",
            "fecha": "2015-10-25T07:31:06-07:00",
            "ejecutivo": "Melanie Clark",
            "descripcion": "dictum placerat, augue. Sed molestie. Sed id risus quis diam"
        },
        {
            "id": "",
            "fecha": "2015-09-28T17:26:21-07:00",
            "ejecutivo": "Lev Shaffer",
            "descripcion": "dui nec urna suscipit nonummy. Fusce fermentum fermentum arcu. Vestibulum"
        },
        {
            "id": "",
            "fecha": "2016-01-12T09:37:59-08:00",
            "ejecutivo": "Brooke Mitchell",
            "descripcion": "fames ac turpis egestas. Aliquam fringilla cursus purus. Nullam scelerisque"
        },
        {
            "id": "",
            "fecha": "2016-01-03T17:46:28-08:00",
            "ejecutivo": "Emmanuel Bass",
            "descripcion": "sapien molestie orci tincidunt adipiscing. Mauris molestie pharetra nibh. Aliquam"
        },
        {
            "id": "",
            "fecha": "2016-01-21T09:43:54-08:00",
            "ejecutivo": "Gail Clark",
            "descripcion": "pharetra, felis eget varius ultrices, mauris ipsum porta elit, a"
        },
        {
            "id": "",
            "fecha": "2016-03-29T05:35:19-07:00",
            "ejecutivo": "Dante Pratt",
            "descripcion": "fermentum arcu. Vestibulum ante ipsum primis in faucibus orci luctus"
        },
        {
            "id": "",
            "fecha": "2015-07-04T15:04:05-07:00",
            "ejecutivo": "Lesley Hensley",
            "descripcion": "eu, euismod ac, fermentum vel, mauris. Integer sem elit, pharetra"
        },
        {
            "id": "",
            "fecha": "2016-01-25T19:04:27-08:00",
            "ejecutivo": "Sopoline Sears",
            "descripcion": "vitae, aliquet nec, imperdiet nec, leo. Morbi neque tellus, imperdiet"
        },
        {
            "id": "",
            "fecha": "2016-04-13T21:22:55-07:00",
            "ejecutivo": "Basil Howard",
            "descripcion": "sed leo. Cras vehicula aliquet libero. Integer in magna. Phasellus"
        },
        {
            "id": "",
            "fecha": "2015-07-21T10:15:02-07:00",
            "ejecutivo": "Willow Richmond",
            "descripcion": "sem, consequat nec, mollis vitae, posuere at, velit. Cras lorem"
        },
        {
            "id": "",
            "fecha": "2015-09-04T05:19:42-07:00",
            "ejecutivo": "Keefe Fulton",
            "descripcion": "ut, sem. Nulla interdum. Curabitur dictum. Phasellus in felis. Nulla"
        },
        {
            "id": "",
            "fecha": "2015-11-05T10:03:53-08:00",
            "ejecutivo": "Charde Oneil",
            "descripcion": "et malesuada fames ac turpis egestas. Fusce aliquet magna a"
        },
        {
            "id": "",
            "fecha": "2015-08-09T01:51:06-07:00",
            "ejecutivo": "Damon Bell",
            "descripcion": "et tristique pellentesque, tellus sem mollis dui, in sodales elit"
        },
        {
            "id": "",
            "fecha": "2015-07-26T01:39:51-07:00",
            "ejecutivo": "Scarlet Gray",
            "descripcion": "rhoncus id, mollis nec, cursus a, enim. Suspendisse aliquet, sem"
        },
        {
            "id": "",
            "fecha": "2015-10-02T16:56:51-07:00",
            "ejecutivo": "Derek Ashley",
            "descripcion": "convallis erat, eget tincidunt dui augue eu tellus. Phasellus elit"
        },
        {
            "id": "",
            "fecha": "2015-06-16T09:06:15-07:00",
            "ejecutivo": "Isaiah Phelps",
            "descripcion": "libero mauris, aliquam eu, accumsan sed, facilisis vitae, orci. Phasellus"
        },
        {
            "id": "",
            "fecha": "2015-09-17T17:02:52-07:00",
            "ejecutivo": "Forrest Collier",
            "descripcion": "tempus, lorem fringilla ornare placerat, orci lacus vestibulum lorem, sit"
        },
        {
            "id": "",
            "fecha": "2015-11-25T16:27:15-08:00",
            "ejecutivo": "Rhiannon Medina",
            "descripcion": "Fusce dolor quam, elementum at, egestas a, scelerisque sed, sapien."
        },
        {
            "id": "",
            "fecha": "2015-08-17T02:33:36-07:00",
            "ejecutivo": "Sophia Cook",
            "descripcion": "augue id ante dictum cursus. Nunc mauris elit, dictum eu,"
        },
        {
            "id": "",
            "fecha": "2015-06-14T17:06:12-07:00",
            "ejecutivo": "Bell Clements",
            "descripcion": "ante blandit viverra. Donec tempus, lorem fringilla ornare placerat, orci"
        },
        {
            "id": "",
            "fecha": "2015-08-21T15:06:37-07:00",
            "ejecutivo": "Jolie Garrett",
            "descripcion": "semper auctor. Mauris vel turpis. Aliquam adipiscing lobortis risus. In"
        },
        {
            "id": "",
            "fecha": "2016-01-03T02:59:47-08:00",
            "ejecutivo": "Taylor Bradley",
            "descripcion": "eu, odio. Phasellus at augue id ante dictum cursus. Nunc"
        },
        {
            "id": "",
            "fecha": "2015-07-25T05:25:54-07:00",
            "ejecutivo": "Zoe Walker",
            "descripcion": "Ut semper pretium neque. Morbi quis urna. Nunc quis arcu"
        },
        {
            "id": "",
            "fecha": "2015-09-28T22:42:53-07:00",
            "ejecutivo": "Ronan Good",
            "descripcion": "neque sed sem egestas blandit. Nam nulla magna, malesuada vel,"
        },
        {
            "id": "",
            "fecha": "2015-12-20T17:43:51-08:00",
            "ejecutivo": "Lewis Griffin",
            "descripcion": "et magnis dis parturient montes, nascetur ridiculus mus. Donec dignissim"
        },
        {
            "id": "",
            "fecha": "2016-02-19T02:00:11-08:00",
            "ejecutivo": "Nicole Watson",
            "descripcion": "mollis. Duis sit amet diam eu dolor egestas rhoncus. Proin"
        },
        {
            "id": "",
            "fecha": "2015-08-22T13:16:32-07:00",
            "ejecutivo": "Alika Rivers",
            "descripcion": "urna. Ut tincidunt vehicula risus. Nulla eget metus eu erat"
        },
        {
            "id": "",
            "fecha": "2016-05-05T23:00:51-07:00",
            "ejecutivo": "Demetria Wilder",
            "descripcion": "sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus"
        },
        {
            "id": "",
            "fecha": "2015-05-23T06:57:47-07:00",
            "ejecutivo": "Hadley Lindsay",
            "descripcion": "faucibus. Morbi vehicula. Pellentesque tincidunt tempus risus. Donec egestas. Duis"
        },
        {
            "id": "",
            "fecha": "2015-10-18T02:04:23-07:00",
            "ejecutivo": "Noah Hudson",
            "descripcion": "sapien. Aenean massa. Integer vitae nibh. Donec est mauris, rhoncus"
        },
        {
            "id": "",
            "fecha": "2016-01-19T05:28:07-08:00",
            "ejecutivo": "Amanda Harmon",
            "descripcion": "ac, eleifend vitae, erat. Vivamus nisi. Mauris nulla. Integer urna."
        },
        {
            "id": "",
            "fecha": "2016-02-26T14:57:04-08:00",
            "ejecutivo": "Azalia Gates",
            "descripcion": "aliquet. Proin velit. Sed malesuada augue ut lacus. Nulla tincidunt,"
        },
        {
            "id": "",
            "fecha": "2015-08-11T10:27:36-07:00",
            "ejecutivo": "Rudyard Suarez",
            "descripcion": "hendrerit id, ante. Nunc mauris sapien, cursus in, hendrerit consectetuer,"
        },
        {
            "id": "",
            "fecha": "2015-07-17T19:52:56-07:00",
            "ejecutivo": "Rudyard Mann",
            "descripcion": "eu odio tristique pharetra. Quisque ac libero nec ligula consectetuer"
        },
        {
            "id": "",
            "fecha": "2015-11-05T01:39:28-08:00",
            "ejecutivo": "Wallace Drake",
            "descripcion": "ullamcorper magna. Sed eu eros. Nam consequat dolor vitae dolor."
        },
        {
            "id": "",
            "fecha": "2015-11-22T17:58:06-08:00",
            "ejecutivo": "Hilary Gill",
            "descripcion": "sed, sapien. Nunc pulvinar arcu et pede. Nunc sed orci"
        },
        {
            "id": "",
            "fecha": "2015-07-04T04:24:29-07:00",
            "ejecutivo": "Cullen Roach",
            "descripcion": "diam nunc, ullamcorper eu, euismod ac, fermentum vel, mauris. Integer"
        },
        {
            "id": "",
            "fecha": "2015-07-18T03:56:11-07:00",
            "ejecutivo": "Kieran Rodriquez",
            "descripcion": "diam. Proin dolor. Nulla semper tellus id nunc interdum feugiat."
        },
        {
            "id": "",
            "fecha": "2015-07-28T14:47:27-07:00",
            "ejecutivo": "Fletcher Thomas",
            "descripcion": "eget magna. Suspendisse tristique neque venenatis lacus. Etiam bibendum fermentum"
        },
        {
            "id": "",
            "fecha": "2015-11-24T06:07:02-08:00",
            "ejecutivo": "Lyle Kidd",
            "descripcion": "erat. Sed nunc est, mollis non, cursus non, egestas a,"
        },
        {
            "id": "",
            "fecha": "2015-08-08T17:56:49-07:00",
            "ejecutivo": "Ori Moses",
            "descripcion": "ipsum primis in faucibus orci luctus et ultrices posuere cubilia"
        },
        {
            "id": "",
            "fecha": "2016-02-03T20:29:12-08:00",
            "ejecutivo": "Ronan Henson",
            "descripcion": "sem, vitae aliquam eros turpis non enim. Mauris quis turpis"
        },
        {
            "id": "",
            "fecha": "2015-07-27T06:30:08-07:00",
            "ejecutivo": "Yasir Johnson",
            "descripcion": "eget metus eu erat semper rutrum. Fusce dolor quam, elementum"
        },
        {
            "id": "",
            "fecha": "2015-10-22T06:15:25-07:00",
            "ejecutivo": "Levi Jenkins",
            "descripcion": "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices"
        },
        {
            "id": "",
            "fecha": "2015-11-10T02:11:54-08:00",
            "ejecutivo": "Harriet Castaneda",
            "descripcion": "Quisque ornare tortor at risus. Nunc ac sem ut dolor"
        },
        {
            "id": "",
            "fecha": "2016-04-12T13:25:18-07:00",
            "ejecutivo": "Jasmine Camacho",
            "descripcion": "molestie arcu. Sed eu nibh vulputate mauris sagittis placerat. Cras"
        },
        {
            "id": "",
            "fecha": "2015-06-09T12:56:02-07:00",
            "ejecutivo": "Merritt Travis",
            "descripcion": "at, egestas a, scelerisque sed, sapien. Nunc pulvinar arcu et"
        },
        {
            "id": "",
            "fecha": "2016-01-23T15:13:07-08:00",
            "ejecutivo": "Carly Simpson",
            "descripcion": "placerat eget, venenatis a, magna. Lorem ipsum dolor sit amet,"
        },
        {
            "id": "",
            "fecha": "2016-02-13T20:27:55-08:00",
            "ejecutivo": "Laurel Gamble",
            "descripcion": "malesuada vel, venenatis vel, faucibus id, libero. Donec consectetuer mauris"
        },
        {
            "id": "",
            "fecha": "2015-11-30T21:10:19-08:00",
            "ejecutivo": "Chandler Higgins",
            "descripcion": "mollis. Integer tincidunt aliquam arcu. Aliquam ultrices iaculis odio. Nam"
        },
        {
            "id": "",
            "fecha": "2015-12-31T09:19:32-08:00",
            "ejecutivo": "Bruce Hamilton",
            "descripcion": "diam eu dolor egestas rhoncus. Proin nisl sem, consequat nec,"
        },
        {
            "id": "",
            "fecha": "2016-02-18T04:49:13-08:00",
            "ejecutivo": "Amethyst Griffith",
            "descripcion": "id, mollis nec, cursus a, enim. Suspendisse aliquet, sem ut"
        },
        {
            "id": "",
            "fecha": "2015-08-07T06:04:38-07:00",
            "ejecutivo": "Driscoll Barber",
            "descripcion": "elit elit fermentum risus, at fringilla purus mauris a nunc."
        },
        {
            "id": "",
            "fecha": "2016-02-05T04:20:43-08:00",
            "ejecutivo": "Jasmine Quinn",
            "descripcion": "luctus vulputate, nisi sem semper erat, in consectetuer ipsum nunc"
        },
        {
            "id": "",
            "fecha": "2015-09-06T22:48:48-07:00",
            "ejecutivo": "Stephanie Hurst",
            "descripcion": "Mauris eu turpis. Nulla aliquet. Proin velit. Sed malesuada augue"
        },
        {
            "id": "",
            "fecha": "2015-11-09T14:23:04-08:00",
            "ejecutivo": "Austin Mack",
            "descripcion": "est, vitae sodales nisi magna sed dui. Fusce aliquam, enim"
        },
        {
            "id": "",
            "fecha": "2015-09-28T08:10:30-07:00",
            "ejecutivo": "Marshall Mendez",
            "descripcion": "molestie tortor nibh sit amet orci. Ut sagittis lobortis mauris."
        },
        {
            "id": "",
            "fecha": "2016-03-24T00:55:10-07:00",
            "ejecutivo": "Jaime Nolan",
            "descripcion": "sed, sapien. Nunc pulvinar arcu et pede. Nunc sed orci"
        },
        {
            "id": "",
            "fecha": "2015-07-05T15:30:12-07:00",
            "ejecutivo": "Ora Henderson",
            "descripcion": "Donec porttitor tellus non magna. Nam ligula elit, pretium et,"
        },
        {
            "id": "",
            "fecha": "2016-02-16T12:21:22-08:00",
            "ejecutivo": "Ayanna Alford",
            "descripcion": "Nunc pulvinar arcu et pede. Nunc sed orci lobortis augue"
        },
        {
            "id": "",
            "fecha": "2015-10-15T02:07:38-07:00",
            "ejecutivo": "Drew Knight",
            "descripcion": "ac mattis semper, dui lectus rutrum urna, nec luctus felis"
        },
        {
            "id": "",
            "fecha": "2015-12-31T20:29:33-08:00",
            "ejecutivo": "Owen Vaughan",
            "descripcion": "vulputate, posuere vulputate, lacus. Cras interdum. Nunc sollicitudin commodo ipsum."
        },
        {
            "id": "",
            "fecha": "2015-07-25T13:55:15-07:00",
            "ejecutivo": "Nash Le",
            "descripcion": "nibh lacinia orci, consectetuer euismod est arcu ac orci. Ut"
        },
        {
            "id": "",
            "fecha": "2015-11-28T07:29:46-08:00",
            "ejecutivo": "Shana Mcintosh",
            "descripcion": "non, luctus sit amet, faucibus ut, nulla. Cras eu tellus"
        }]
        
        function allAlarmas() {
            return data;
        }
    }
})();
(function () {
  'use strict';

  angular.module('dashboard');
  app.provider('gRecaptcha', function () {
    var service = this;

    service.$get = [
      '$window',
      '$q',
      '$document',
      '$interval',
      function ($window, $q, $document, $interval) {
        var key = null;
        var url = 'https://www.google.com/recaptcha/api.js';
        var onLoadFunctionName = 'onGRecaptchaScriptLoaded';
        var defered = $q.defer();
        var initializing = false;
        var initialized = false;

        function writeScript() {
          var tag = document.createElement('script');
          tag.src =
            url +
            '?render=' +
            key +
            '&onload=' +
            onLoadFunctionName +
            '&render=explicit';
          $document.find('body')[0].appendChild(tag);
        }

        function isExecuteAvailable() {
          return angular.isFunction(($window.grecaptcha || {}).execute);
        }

        function scriptExists() {
          return $window.document.querySelector('script[src^="' + url + '"]');
        }

        function execute(params) {
          if (isInitializing()) {
            return defered.promise.then(function () {
              return execute(params);
            });
          }
          return $window.grecaptcha.execute(key, params);
        }

        function isInitialized() {
          return !!initialized;
        }

        function isInitializing() {
          return !!initializing;
        }

        function reset() {
          return $window.grecaptcha.reset();
        }

        function initialize(params) {
          setTimeout(function () {
            try {
              if (!params || !params.key) {
                throw new Error('Missing required public key for reCaptcha.');
              }

              key = params.key + '';

              if (isExecuteAvailable()) {
                initialized = true;
                initializing = false;
                defered.resolve();
              } else if (scriptExists()) {
                initializing = true;
                var wait = $interval(function () {
                  if (isExecuteAvailable()) {
                    $interval.cancel(wait);

                    initialized = true;
                    initializing = false;
                    defered.resolve();
                  }
                }, 50);
              } else {
                initializing = true;
                $window[onLoadFunctionName] = function () {
                  initialized = true;
                  initializing = false;
                  defered.resolve();
                };

                writeScript();
              }
            } catch (e) {
              defered.reject(e);
            }
          });

          return defered.promise;
        }

        return {
          initialize: initialize,
          execute: execute,
          reset: reset,
          isInitialized: isInitialized,
          isInitializing: isInitializing,
        };
      },
    ];
  });
})();

(function () {
  'use strict';

  angular.module('dashboard');
  app.provider('localePt', function () {
    var service = this;
    var PLURAL_CATEGORY = {
      ZERO: 'zero',
      ONE: 'one',
      TWO: 'two',
      FEW: 'few',
      MANY: 'many',
      OTHER: 'other',
    };

    service.$get = [
      function () {
        return {
          DATETIME_FORMATS: {
            AMPMS: ['AM', 'PM'],
            DAY: [
              'domingo',
              'segunda-feira',
              'ter\u00e7a-feira',
              'quarta-feira',
              'quinta-feira',
              'sexta-feira',
              's\u00e1bado',
            ],
            ERANAMES: ['Antes de Cristo', 'Ano do Senhor'],
            ERAS: ['a.C.', 'd.C.'],
            FIRSTDAYOFWEEK: 6,
            MONTH: [
              'janeiro',
              'fevereiro',
              'mar\u00e7o',
              'abril',
              'maio',
              'junho',
              'julho',
              'agosto',
              'setembro',
              'outubro',
              'novembro',
              'dezembro',
            ],
            SHORTDAY: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 's\u00e1b'],
            SHORTMONTH: [
              'jan',
              'fev',
              'mar',
              'abr',
              'mai',
              'jun',
              'jul',
              'ago',
              'set',
              'out',
              'nov',
              'dez',
            ],
            STANDALONEMONTH: [
              'janeiro',
              'fevereiro',
              'mar\u00e7o',
              'abril',
              'maio',
              'junho',
              'julho',
              'agosto',
              'setembro',
              'outubro',
              'novembro',
              'dezembro',
            ],
            WEEKENDRANGE: [5, 6],
            fullDate: "EEEE, d 'de' MMMM 'de' y",
            longDate: "d 'de' MMMM 'de' y",
            medium: "d 'de' MMM 'de' y HH:mm:ss",
            mediumDate: "d 'de' MMM 'de' y",
            mediumTime: 'HH:mm:ss',
            short: 'dd/MM/yy HH:mm',
            shortDate: 'dd/MM/yy',
            shortTime: 'HH:mm',
          },
          NUMBER_FORMATS: {
            CURRENCY_SYM: 'R$',
            DECIMAL_SEP: ',',
            GROUP_SEP: '.',
            PATTERNS: [
              {
                gSize: 3,
                lgSize: 3,
                maxFrac: 3,
                minFrac: 0,
                minInt: 1,
                negPre: '-',
                negSuf: '',
                posPre: '',
                posSuf: '',
              },
              {
                gSize: 3,
                lgSize: 3,
                maxFrac: 2,
                minFrac: 2,
                minInt: 1,
                negPre: '-\u00a4',
                negSuf: '',
                posPre: '\u00a4',
                posSuf: '',
              },
            ],
          },
          id: 'pt-br',
          localeID: 'pt_BR',
          pluralCat: function (n, opt_precision) {
            if (n >= 0 && n <= 2 && n != 2) {
              return PLURAL_CATEGORY.ONE;
            }
            return PLURAL_CATEGORY.OTHER;
          },
        };
      },
    ];
  });
})();

(function () {
  'use strict';

  angular.module('dashboard');
  app.provider('localeEs', function () {
    var service = this;
    var PLURAL_CATEGORY = {
      ZERO: 'zero',
      ONE: 'one',
      TWO: 'two',
      FEW: 'few',
      MANY: 'many',
      OTHER: 'other',
    };

    service.$get = [
      function () {
        return {
          DATETIME_FORMATS: {
            AMPMS: ['a. m.', 'p. m.'],
            DAY: [
              'domingo',
              'lunes',
              'martes',
              'mi\u00e9rcoles',
              'jueves',
              'viernes',
              's\u00e1bado',
            ],
            ERANAMES: ['antes de Cristo', 'despu\u00e9s de Cristo'],
            ERAS: ['a. C.', 'd. C.'],
            FIRSTDAYOFWEEK: 0,
            MONTH: [
              'enero',
              'febrero',
              'marzo',
              'abril',
              'mayo',
              'junio',
              'julio',
              'agosto',
              'septiembre',
              'octubre',
              'noviembre',
              'diciembre',
            ],
            SHORTDAY: [
              'dom.',
              'lun.',
              'mar.',
              'mi\u00e9.',
              'jue.',
              'vie.',
              's\u00e1b.',
            ],
            SHORTMONTH: [
              'ene.',
              'feb.',
              'mar.',
              'abr.',
              'may.',
              'jun.',
              'jul.',
              'ago.',
              'sept.',
              'oct.',
              'nov.',
              'dic.',
            ],
            STANDALONEMONTH: [
              'enero',
              'febrero',
              'marzo',
              'abril',
              'mayo',
              'junio',
              'julio',
              'agosto',
              'septiembre',
              'octubre',
              'noviembre',
              'diciembre',
            ],
            WEEKENDRANGE: [5, 6],
            fullDate: "EEEE, d 'de' MMMM 'de' y",
            longDate: "d 'de' MMMM 'de' y",
            medium: 'd MMM y H:mm:ss',
            mediumDate: 'd MMM y',
            mediumTime: 'H:mm:ss',
            short: 'd/M/yy H:mm',
            shortDate: 'd/M/yy',
            shortTime: 'H:mm',
          },
          NUMBER_FORMATS: {
            CURRENCY_SYM: '\u20ac',
            DECIMAL_SEP: ',',
            GROUP_SEP: '.',
            PATTERNS: [
              {
                gSize: 3,
                lgSize: 3,
                maxFrac: 3,
                minFrac: 0,
                minInt: 1,
                negPre: '-',
                negSuf: '',
                posPre: '',
                posSuf: '',
              },
              {
                gSize: 3,
                lgSize: 3,
                maxFrac: 2,
                minFrac: 2,
                minInt: 1,
                negPre: '-',
                negSuf: '\u00a0\u00a4',
                posPre: '',
                posSuf: '\u00a0\u00a4',
              },
            ],
          },
          id: 'es',
          localeID: 'es',
          pluralCat: function (n, opt_precision) {
            if (n == 1) {
              return PLURAL_CATEGORY.ONE;
            }
            return PLURAL_CATEGORY.OTHER;
          },
        };
      },
    ];
  });
})();

(function () {
  'use strict';

  angular.module('dashboard');
  app.provider('localeEn', function () {
    var service = this;
    var PLURAL_CATEGORY = {
      ZERO: 'zero',
      ONE: 'one',
      TWO: 'two',
      FEW: 'few',
      MANY: 'many',
      OTHER: 'other',
    };

    function getDecimals(n) {
      n = n + '';
      var i = n.indexOf('.');
      return i == -1 ? 0 : n.length - i - 1;
    }

    function getVF(n, opt_precision) {
      var v = opt_precision;

      if (undefined === v) {
        v = Math.min(getDecimals(n), 3);
      }

      var base = Math.pow(10, v);
      var f = ((n * base) | 0) % base;
      return { v: v, f: f };
    }
    service.$get = [
      function () {
        return {
          DATETIME_FORMATS: {
            AMPMS: ['AM', 'PM'],
            DAY: [
              'Sunday',
              'Monday',
              'Tuesday',
              'Wednesday',
              'Thursday',
              'Friday',
              'Saturday',
            ],
            ERANAMES: ['Before Christ', 'Anno Domini'],
            ERAS: ['BC', 'AD'],
            FIRSTDAYOFWEEK: 6,
            MONTH: [
              'January',
              'February',
              'March',
              'April',
              'May',
              'June',
              'July',
              'August',
              'September',
              'October',
              'November',
              'December',
            ],
            SHORTDAY: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            SHORTMONTH: [
              'Jan',
              'Feb',
              'Mar',
              'Apr',
              'May',
              'Jun',
              'Jul',
              'Aug',
              'Sep',
              'Oct',
              'Nov',
              'Dec',
            ],
            STANDALONEMONTH: [
              'January',
              'February',
              'March',
              'April',
              'May',
              'June',
              'July',
              'August',
              'September',
              'October',
              'November',
              'December',
            ],
            WEEKENDRANGE: [5, 6],
            fullDate: 'EEEE, MMMM d, y',
            longDate: 'MMMM d, y',
            medium: 'MMM d, y h:mm:ss a',
            mediumDate: 'MMM d, y',
            mediumTime: 'h:mm:ss a',
            short: 'M/d/yy h:mm a',
            shortDate: 'M/d/yy',
            shortTime: 'h:mm a',
          },
          NUMBER_FORMATS: {
            CURRENCY_SYM: '$',
            DECIMAL_SEP: '.',
            GROUP_SEP: ',',
            PATTERNS: [
              {
                gSize: 3,
                lgSize: 3,
                maxFrac: 3,
                minFrac: 0,
                minInt: 1,
                negPre: '-',
                negSuf: '',
                posPre: '',
                posSuf: '',
              },
              {
                gSize: 3,
                lgSize: 3,
                maxFrac: 2,
                minFrac: 2,
                minInt: 1,
                negPre: '-\u00a4',
                negSuf: '',
                posPre: '\u00a4',
                posSuf: '',
              },
            ],
          },
          id: 'en',
          localeID: 'en',
          pluralCat: function (n, opt_precision) {
            var i = n | 0;
            var vf = getVF(n, opt_precision);
            if (i == 1 && vf.v == 0) {
              return PLURAL_CATEGORY.ONE;
            }
            return PLURAL_CATEGORY.OTHER;
          },
        };
      },
    ];
  });
})();

angular.module('dashboard').filter('readableBytes', function () {
    // return function (input) {
        //     return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1) : '';
        // }
        
    return function (bytes) {
        // var min = 1024;
        if (bytes <= 0) {
            return '1 kb';
        }else{
            var min = 1024;
            var val = parseInt(bytes);
            var i = Math.floor(Math.log(val) / Math.log(min));
            // var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            var sizes = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            return (val / Math.pow(min, i)).toFixed(2) * 1 + ' ' + sizes[i];
        }
    }
});

angular.module('dashboard').filter('prettyCron', function () {
  return function (cron, type) {
    type = type || 'human';
    if (typeof cron === 'undefined' || cron === null) return '??';

    if (cron === null || cron === undefined) return '??';

    if (typeof cron != 'object') return '??';
    var c = angular.copy(cron);
    delete c.id;
    delete c.$$hashKey;
    delete c.form;

    var _cron = Object.values(c).join(' ');

    var cronString = _cron
    

    var huamnReadable = cronstrue.toString(cronString);

    var nextStr = moment(
      prettyCron.getNextDate(cronString.substring(1))
    ).format('LLLL');

    return type == 'next' ? nextStr : huamnReadable;
  };
});
/**
 * Adds zeros (0) to complete the value
 * inputs (value<varchar>, length<integer>)
 * Author: daniel@ceptinel.com
 */
angular.module('dashboard')
.filter('padLeft', function() {
    return function(value, length) {
    	function PadLeft(value, length) {
            return (value.toString().length < length) ? PadLeft("0" + value, length) : value;
        }
        return PadLeft(value, length);
    };
});

/**
 * Retorna un objeto ordenado por la propiedad indicada
 * inputs (Object<Object>, propertie<Value>)
 * Author: daniel@ceptinel.com
 */
angular.module('dashboard')
    .filter('orderObjectBy', function() {
        return function(obj, sortValue) {
            var keysSorted = Object.keys(obj).sort(function(a,b){return obj[a][sortValue]-obj[b][sortValue]});
            var objSorted = {};
            for(var i = 0; i < keysSorted.length; i++){
              objSorted[keysSorted[i]] = obj[keysSorted[i]];
            }
            return objSorted;
        };
    });
/**
 * Retorna el de una propiedad de un objeto
 * inputs (strinh<string>, object<Value>)
 * Author: daniel@ceptinel.com
 */
angular.module('dashboard').filter('objectKey', function () {
  return function (obj, searchKey) {
    var arrayKeys = searchKey.split('.');
    var result = '?';

    for (var index = 0; index < arrayKeys.length; index++) {
      var key = arrayKeys[index];

      var prop = prop ? prop[key] : obj[key];

      if (!prop) break;

      result = prop;
    }

    return result;
  };
});

/**
 * numberFormater
 *
 * @input - numberFormater
 */

angular.module("dashboard").filter("numberFormater", numberFormater);
numberFormater.$inject = ["$localStorageService"];

function numberFormater($localStorageService) {
  return function (number, decimals) {
    if (!number) return number;
    if (isNaN(number)) return number;

    var d = decimals == undefined ? 2 : decimals;

    var currentUser = $localStorageService.getItem("currentUser") || {};
    var lenguaje = currentUser.lenguaje || "es";
    var locale = lenguaje.toLowerCase() + "-" + lenguaje.toUpperCase();
    var format = new Intl.NumberFormat(locale, {
      minimumFractionDigits: d,
      maximumFractionDigits: d,
    }).format(number);
    return format;
  };
}

/**
 * Capitaliza el primer string de un string
 *
 * @input - String que se desea capitalizar
 */
angular.module('dashboard').filter('numberFormat', function () {
  //-return function (number, decimals = 2, dec_point = ',', thousands_sep = '.') {
  return function (number, decimals, dec_point, thousands_sep) {
    decimals = decimals ? decimals : 2;
    dec_point = dec_point ? dec_point : ',';
    thousands_sep = thousands_sep ? thousands_sep : '.';
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
      sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
      dec = typeof dec_point === 'undefined' ? '.' : dec_point,
      s = '',
      toFixedFix = function (n, prec) {
        var k = Math.pow(10, prec);
        return '' + (Math.round(n * k) / k).toFixed(prec);
      };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
  };
});

/**
 * Convert time in millisecond to human readable format.
 */
angular.module('dashboard').filter('msToTime', function () {
  return function (ms) {
    var seconds = (ms / 1000).toFixed(1);
    var minutes = (ms / (1000 * 60)).toFixed(1);
    var hours = (ms / (1000 * 60 * 60)).toFixed(1);
    var days = (ms / (1000 * 60 * 60 * 24)).toFixed(1);
    if (seconds < 60) return seconds + ' Sec';
    else if (minutes < 60) return minutes + ' Min';
    else if (hours < 24) return hours + ' Hrs';
    else return days + ' Days';
  };
});

/**
 * MapTypes to test for ui-grid selectors
 */
angular.module('dashboard')
.filter('mapType', function() {
  var typeHash = {
    'autoincrement': 'Autoincrement',
    'boolean': 'Boolean',
    'date': 'Date',
    'double': 'Double',
    'integer': 'Integer',
    'list': 'List',
    'long': 'Long',
    'string': 'String',
    'sequential': 'Sequential',
    'time': 'Time',
    'timestamp': 'Timestamp',
    'url': 'URL',
    '[]': 'List',
    'reference': 'Reference',
    'complex': 'Complex',
  };
  return function(input) {
    if (!input)
      return '';
    return typeHash[input];
  };
});

/**
 * format value to human Readable expression
 *
 * @value - data type for tests
 */
angular.module('dashboard').filter('humanReadable', function ($filter) {
  return function (value, type, key) {
    var formated = value;

    switch (type) {
      case 'string':
        formated = '<b>' + value + '</b>';
        break;
      case 'number':
        formated = '<b>' + $filter('number')(value) + '</b>';
        break;
      case 'date':
        formated = '<b>' + $filter('asMDate')(value, 'DD-MM-YYYY') + '</b>';
        break;
      case 'reference':
        formated = '<b>' + value[key] + '</b>';
      break;
      case 'undefined':
        formated = '<b>--</b>';
        break;
        default:
      formated = '<b>' + value + '</b>';
      break;
    }
    return formated;
  };
});

/**
 * Retorna un objeto producto del filtrado de un map
 * inputs (Object<Object>, value<Value>)
 * Author: daniel@ceptinel.com
 */
angular.module('dashboard').filter('getFieldById', function () {
  return function (obj, index, field) {
    var object = obj.filter(function (e) {
      return e.id == index;
    })[0];
    if (object) {
      if (field.includes('.')) {
        var splitField = field.split('.');
        return obj.filter(function (e) {
          return e.id == index;
        })[0][splitField[0]][splitField[1]];
      } else {
        return obj.filter(function (e) {
          return e.id == index;
        })[0][field];
      }
    }
  };
});

/**
 * icon chart by type
 *
 * @value - material icon name
 */
angular.module('dashboard').filter('chartIcon', function () {
  return function (value) {
    var DEFAULT_ICON = 'add_chart';
    var setIcon = {
      line: 'multiline_chart',
      bar: 'bar_chart',
      pie: 'pie_chart',
      boxplot: 'stacked_bar_chart',
      treemap: 'view_quilt',
    };
    var icon = setIcon[value] || DEFAULT_ICON;

    return icon;
  };
});

/**
 * Capitaliza el primer string de un string
 *
 * @input - String que se desea capitalizar
 */
angular.module('dashboard').filter('capitalize', function() {
    return function(input) {
        return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1) : '';
    }
});
/**
 * asTime
 *
 * @input - asTime
 */
angular.module('dashboard').filter('asTime', function () {
  return function (time, format) {
    if (!time) return '??';
    format = format ? format : 'HH:mm:ss a';
    return moment(time, 'hh:mm:ss').format(format);
  };
});

/**
 * asMDate
 *
 * @input - asMDate
 */
angular.module('dashboard').filter('asMDate', function () {
  return function (date, format) {
    if (!date) return date;
    format = format ? format : 'DD-MM-YYYY';
    if (moment(date).isValid())
      return moment(date, 'YYYY-MM-DD').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format(format);
    else return date 
  };
});

/**
 * format url has link button
 *
 * @value - data type for tests
 */
angular.module('dashboard').filter('asLink', function () {
  return function (link) {
    formated =
      '<a class="link" href="' + link + '" target="_blank" >Ir al link </a>';
    return formated;
  };
});

/**
 * Retorna un String con el formato de la hora
 */
angular.module('dashboard').filter('asHour', function ($filter) {
  return function (theDate, format) {
    format = format ? format : 'hh:mm a';
    if (theDate == null) {
      return '';
    } else {
      return $filter('date')(new Date(theDate), format);
    }
  };
});

/**
 * Retorna un String con el formato de fecha
 */
angular.module('dashboard')
    .filter('asDateHour', function ($filter) {
        var angularDateFilter = $filter('date');
        return function (theDate) {
            if (theDate == undefined || theDate == null || theDate == '')
                return "";
            else
                return angularDateFilter(theDate, 'dd/MM/yyyy hh:mm:ss a');
        }
    });

/**
 * Retorna un String con el formato de fecha
 * Maneja correctamente las fechas UTC evitando problemas de zona horaria
 */
angular.module('dashboard')
    .filter('asDate', function ($filter) {
        var angularDateFilter = $filter('date');
        return function (theDate, format) {
            if (theDate == undefined || theDate == null || theDate == '')
                return "";
            
            // Si es una cadena ISO con Z (UTC), tratarla como fecha local
            if (typeof theDate === 'string' && theDate.endsWith('Z')) {
                // Opción 1: Remover la Z para tratarla como fecha local
                var localDateString = theDate.slice(0, -1);
                var date = new Date(localDateString);
                return angularDateFilter(date, format || 'dd/MM/yyyy');
            }
            
            // Para otros formatos de fecha, usar comportamiento normal
            var date = new Date(theDate);
            return angularDateFilter(date, format || 'dd/MM/yyyy');
        }
    });

/**
 * format array to text
 *
 * @value - data type for tests
 */
angular.module('dashboard').filter('arrayText', function () {
  return function (value) {
    var max = 3;
    formated = value
    .slice(0, max)
    .map(function (v) {
      return v.split('T00')[0];
    }).join(', ');
    return formated + (value.length > max ? '...' : '');
  };
});

/**
 * format array slip to comma values
 *
 * @value - data type for tests
 */
angular.module('dashboard').filter('arraySplit', function () {
  return function (value) {
    formated = value.join(',');
    return formated;
  };
});

/**
 * format array to html badge
 *
 * @value - data type for tests
 */
angular.module('dashboard').filter('arrayBadge', function () {
  return function (value) {
    formated = value.map(function (v) {
      return '<span class="badge">' + v + '</span>';
    });
    return formated;
  };
});

angular
.module('dashboard')
.factory('WorkspaceFactory', WorkspaceFactory)

WorkspaceFactory.$inject = ['$http', '$localStorageService', 'BaseUrl'];

    function WorkspaceFactory($http, $localStorageService, BaseUrl) {
        var service = {};

        service.getWorkspaces = function () {
            return new Promise(function (resolve, reject) {
                $http({
                    url: BaseUrl.path['URL_WORKSPACES'],
                    method: 'GET',
                })
                .success(function (response, status, headers) {
                    resolve(response);
                })
                .error(function (response, status, headers) {
                    reject(response);
                });
            });
        };

        service.setWorkspace = function (req) {
            return new Promise(function (resolve, reject) {
                $http({
                    url: BaseUrl.urlUpdateUserWorkspace(req.id, req.workspaceName),
                    method: 'PUT',
                    data: req.workspaceSchema,
                })
                .success(function (response, status, headers) {
                    resolve(response);
                })
                .error(function (response, status, headers) {
                    reject(response);
                });
            });
        };

        service.createWorkspace = function (req) {
            return new Promise(function (resolve, reject) {
                $http({
                    url: BaseUrl.urlCreateUserWorkspace(req.workspaceName),
                    method: 'POST',
                    data: req.workspaceSchema,
                })
                .success(function (response, status, headers) {
                    resolve(response);
                })
                .error(function (response, status, headers) {
                    reject(response);
                });
            });
        };

        return service;
    }
angular
.module('dashboard')
.factory('UserTrackingFactory', UserTrackingFactory)


UserTrackingFactory.$inject = ['$http', '$state', '$localStorageService', 'BaseUrl', 'moment'];

function UserTrackingFactory($http, $state, $localStorageService, BaseUrl, moment) {
    var service = {};


    service.findUserTrackings = function (paramQuery) {
        
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_AUDITORIA'],
                method: 'GET',
                params: paramQuery,
            }).success(function (response, status, headers) {
                response.data.forEach(function(value, index) {
                    response.data[index].created = 
                        moment(response.data[index].created).format('DD/MM/YYYY');
                });
                resolve(response);
            }).error(function (response, status, headers) {
                reject(response);
            });
        });
    };//end findUserTrackings
    return service;
}

angular.module("dashboard").factory("UserFactory", UserFactory);

UserFactory.$inject = ["$http", "BaseUrl", "$localStorageService"];

function UserFactory($http, BaseUrl, $localStorageService) {
  function getRandomColor() {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  var service = {};

  service.getCurrentUser = function () {
    return $localStorageService.getItem("currentUser");
  };

  service.create = function (user) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/user",
        method: "POST",
        data: user,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.edit = function (userId, user) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/user/" + userId,
        method: "PUT",
        data: user,
      }).then(
        function (response) {
          if (user.username == $localStorageService.getItem("currentUser.username")) {
            $localStorageService.setItem("currentUser.lenguaje", user.lang);
            $localStorageService.setItem("currentUser.timeZone", response.timeZone);
            $localStorageService.setItem("currentUser.name", user.fullName);
            $localStorageService.setItem("currentUser.region", user.region);
          }
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getUser = function (username, params) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/user/" + username,
        method: "GET",
        params: params,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  //  Resetear usuario.
  service.cambiarPassword = function (id, c) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/user/change-password",
        method: "POST",
        headers: {
          currentPassword: BaseUrl.base64Encode(c.passwordAntigua),
          newPassword: BaseUrl.base64Encode(c.passwordNueva),
        },
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  //  Resetear usuario.
  service.changePasswordV2 = function (id, pws) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/user/" + id + "/change-password",
        method: "POST",
        headers: {
          newPassword: BaseUrl.base64Encode(pws),
        },
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getAllUsers = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/user/",
        method: "GET",
      }).then(
        function (response) {
          if (response.data.data) {
            response.data.data = response.data.data.map(function (user) {
              user.color = user.color || getRandomColor();
              return user;
            });
          }

          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getUsers = function (req) {
    if (req.active) {
      req.active = req.active == "t" || true ? true : false;
    }
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/user/",
        method: "GET",
        params: req,
      }).then(
        function (response) {
          if (response.data.data) {
            response.data.data = response.data.data.map(function (user) {
              user.color = user.color || getRandomColor();
              return user;
            }).sort(function (a, b) {
              return a.fullName.localeCompare(b.fullName);
            });
          }

          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getSupervisedUsers = function (supervisorUsername) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/user/supervised",
        method: "GET",
        params: {
          supervisorUsername: supervisorUsername,
        },
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getUserDashboards = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_USER_DASHBOARD"],
        method: "GET",
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.shareUserDashboard = function (dashboard, userSelected) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_USER_DASHBOARD"] + "/chared",
        method: "PUT",
        data: {
          dashboard: dashboard,
          users: userSelected
        },
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.saveUserDashboards = function (action, request) {
    var board = {
      dashboardName: request.name,
      dashboardStatus: request.status,
      dashboardId: request.id,
      dashboardConfig: JSON.stringify(request.widgets),
      dashboardOrder: request.order,
    };
    return new Promise(function (resolve, reject) {
      var url = BaseUrl.path["URL_USER_DASHBOARD"];

      if (action == "update") {
        url += "/" + request.id;
      }
      
      $http({
        url: url,
        method: action == "update" ? "PUT" : "POST",
        data: board,
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.saveUserDashboardsV2 = function (action, request) {
    var board = {
      dashboardName: request.dashboardName,
      dashboardStatus: request.dashboardStatus,
      dashboardId: request.dashboardId,
      dashboardConfig: JSON.stringify(request.dashboardConfig),
      dashboardOrder: request.dashboardOrder,
    };
    return new Promise(function (resolve, reject) {
      var url = BaseUrl.path["URL_USER_DASHBOARD"];

      if (action == "update") {
        url += "/" + request.dashboardId;
      }
      
      $http({
        url: url,
        method: action == "update" ? "PUT" : "POST",
        data: board,
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.deleteUserDashboards = function (request) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_USER_DASHBOARD"] + "/" + request.id,
        method: "DELETE",
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.getRoles = function (req) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/user/roles",
        method: "GET",
        params: req,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getAllUsersByCompanyId = function (companyId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/user/company/" + companyId,
        method: "GET",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.importUsersCsv = function (body) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/user/import-csv",
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: body,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  // 2fa
  service.confirm2fa = function (code) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/user/confirm-2fa",
        method: "POST",
        params: { code: code },
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  service.disable2fa = function (username) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/user/disable-2fa",
        method: "POST",
        params: { username: username },
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  service.requires2fa = function (role) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/user/requires-2fa",
        method: "POST",
        data: role,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  service.init2fa = function (body) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/user/init-2fa",
        method: "GET",
        data: body,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  return service;
}

angular.module("dashboard").factory("TokensFactory", TokensFactory);

TokensFactory.$inject = [
  "$http",
  "$state",
  "$localStorageService",
  "BaseUrl",
  "moment",
];

function TokensFactory($http, $state, $localStorageService, BaseUrl, moment) {
  var service = {};

  service.getAllTokens = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_TOKENS"]+"/all",
        method: "GET",
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  }; 
  service.invalidateAll = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_TOKENS"]+"/invalidate-all",
        method: "POST",
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };
  service.invalidateToken = function (token, username) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_TOKENS"]+"/invalidate/"+token+"/username/"+username,
        method: "POST",
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };
  service.invalidateUserTokens = function ( username) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_TOKENS"]+"/invalidate/username/"+username,
        method: "POST",
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };
  service.myTokens = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_TOKENS"]+"/me",
        method: "GET",
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };
  return service;
}

angular.module("dashboard").factory("SyncFactory", SyncFactory);

SyncFactory.$inject = ["$http", "$state", "$localStorage", "BaseUrl"];

function SyncFactory($http, $state, $localStorage, BaseUrl) {
  var service = {};

  service.syncTransaction = function (body) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_SYNC"] + '/transaccion',
        method: "POST",
        data: body,
        params: {
          timeoutSeconds: 30,
          pollIntervalMs: 300
        }
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };


  return service;
}

angular
  .module('dashboard')
  .factory('SessionInterceptor', SessionInterceptorFactory);

SessionInterceptorFactory.$inject = ['$q', '$localStorageService', '$rootScope'];
var resposeStatus = null;
function SessionInterceptorFactory($q, $localStorageService, $rootScope) {
  return {
    request: function (config) {
      if (
        config.url.indexOf('app/usuarios/dialog-recover-session.html') == 0 ||
        config.url.indexOf('/assets') == 0 ||
        config.url.indexOf('directives') == 0 ||
        config.url.indexOf('/risk-backend/rest/auth/token') == 0 ||
        config.url.indexOf('directives/progressbar') == 0) {
        return config;
      }

      var currentUser = $localStorageService.getItem("currentUser");

      if (currentUser && currentUser.tokenInfo) {
        if (
          new Date() > new Date(currentUser.tokenInfo.expiration)
        ) {
          return $q.reject('TokenExpired');
        }
      }
      return config
    },
    responseError: function (data) {
      resposeStatus = data.status;
      if (data.status == 401 && !(data.config.url.indexOf('app/usuarios/dialog-recover-session.html') == 0 ||
          data.config.url.indexOf('/assets') == 0 ||
          data.config.url.indexOf('directives') == 0 ||
          data.config.url.indexOf('directives/progressbar') == 0)) {
          console.log('info@TokenMismatch');
        $rootScope.$broadcast('TokenMismatch');
      }
      return $q.reject(data);
    }
  };
}

angular
  .module("dashboard")
  .factory("SearcherConfigurationFactory", SearcherConfigurationFactory);

SearcherConfigurationFactory.$inject = [
  '$http',
  '$state',
  '$localStorageService',
  'BaseUrl',
];
function SearcherConfigurationFactory($http, $state, $localStorageService, BaseUrl) {
  var service = {};

  service.searcherList = function (paramQuery) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_SEARCHER"],
        method: "GET",
        params: paramQuery,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.search = function (search) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_SEARCHER"] + "/lookup/",
        method: "POST",
        data: search,
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.buildSearchers = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_SEARCHER"] + "/auto-create",
        method: "POST",
      }).then(
        function (response) {
          resolve();
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.buildLuceneIndex = function (target, targetId) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["URL_SEARCHER"] + "/lucene/" + target + "/" + targetId,
        method: "POST",
      }).then(
        function (response) {
          resolve();
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  /**
   * search by full text
   * @param {"LIST"|"TABLE"|"ISSUE"} target
   * @param {String} query
   * @param {{page: Number, size: Number}} pagination
   * @returns Array of objects
   */
  service.fullTextSearch = function (target, query, pagination) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_SEARCHER"] + "/full-text-search",
        params: {
          query: query,
          target: target,
          page: pagination.page,
          itemsPerPage: pagination.itemsPerPage,
        },
        method: "POST",
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  return service;
}

angular.module('dashboard').factory('SchemasFactory', SchemasFactory);

SchemasFactory.$inject = ['$http', '$localStorageService', 'BaseUrl'];

function SchemasFactory($http, $localStorageService, BaseUrl) {
  var service = {};

  service.getSchemas = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_SCHEMA_SERVICES'],
        method: 'GET',
        params: {
          page: 1,
          itemsPerPage: null,
        },
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.createSchema = function (request) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_SCHEMA_SERVICES'],
        method: 'POST',
        data: request,
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.updateSchema = function (request) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_SCHEMA_SERVICES'] + request.id,
        method: 'PUT',
        data: request,
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.deleteSchema = function (schemaId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlDeleteSchema(schemaId),
        method: 'DELETE',
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.getSchemaAutocomplete = function (
    clusterType,
    fieldKey,
    schemaId,
    filterKey
  ) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path['URL_SCHEMA_SERVICES'] +
          'autocomplete/' +
          clusterType +
          '/field/' +
          fieldKey +
          '/values',
        method: 'GET',
        params: {
          schemaId: schemaId,
          filterValue: filterKey,
        },
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.getSchemasByLabelId = function (labelId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_SCHEMA_SERVICES'] + 'label/' + labelId,
        method: 'GET',
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.getSchemaByIdOrName = function (schemaIdOrName) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_SCHEMA_SERVICES'] + '/' + schemaIdOrName,
        method: 'GET',
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };
  return service;
}

angular
.module('dashboard')
.factory('ResourceFactory', ResourceFactory)

ResourceFactory.$inject = ['$http', '$localStorageService', 'BaseUrl'];

    function ResourceFactory($http, $localStorageService, BaseUrl) {
        var service = {};

        service.create = function (object) {
            return new Promise(function (resolve, reject) {
                $http({
                    url: '/risk-backend/rest/acl/resource',
                    method: 'POST',
                    data: object,
                }).then(function(response) {
                    resolve(response);
                }, function(response) {
                    reject(response);
                });
            });
        }

        service.edit = function (id, object) {
            return new Promise(function (resolve, reject) {
                $http({
                    url: '/risk-backend/rest/acl/resource/' + id,
                    method: 'PUT',
                    data: object,
                }).then(function(response) {
                    resolve(response);
                }, function(response) {
                    reject(response);
                });
            });
        }

        service.getAll = function () {
            return new Promise(function (resolve, reject) {
                $http({
                    url: '/risk-backend/rest/acl/functionalities',
                    method: 'GET',
                    cache: true
                }).then(function (response) {
                    resolve(response);
                }, function (response) {
                    reject(response);
                });
            });
        }


        return service;
    }
angular
    .module('dashboard')
    .factory('ReportsFactory', ReportsFactory)

ReportsFactory.$inject = ['$http', '$localStorageService', 'BaseUrl'];

function ReportsFactory($http, $localStorageService, BaseUrl) {
    var service = {};

    // -- Leer datos de las paginas del informe embebido
    // -- Must be in a service instead of a factory
    service.getPages = function (page) {
        var self = this;

        self.name = page.name;
        self.displayName = page.displayName;

        return self;
    };

    // -- Obtener credenciales
    service.getAccess = function (req) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_PWBI'],
                method: 'GET',
            }).then(function (response) {
                var pbi = {
                    accessId: response.data.accessId,
                    username: response.data.username,
                    active: response.data.active,
                    clientId: response.data.clientId,
                    clientSecret: response.data.clientSecret,
                }
                resolve(pbi);
            }, function (response) {
                reject(response);
            });
        });
    };

    // -- Guardar las credenciales
    service.saveCredentials = function (req) {
        return new Promise(function (resolve, reject) {
            // -- Guardar/Actualizar credenciales
            $http({
                url: BaseUrl.path['URL_PWBI'],
                method: req.accessId ? "PUT" : "POST",
                data: {
                    accessId: req.accessId || 0,
                    username: req.username,
                    password: req.password,
                    clientId: req.clientId,
                    clientSecret: req.clientSecret,
                },
            }).then(function (response) {
                $localStorageService.setItem("currentUser.tokenPBI", undefined);
                service.login();
                resolve(response);
            }, function (response) {
                reject(response);
            });
        });
    };

    // -- Login a plataforma powerBI
    service.login = function () {
        return new Promise(function (resolve, reject) {
            var currentUser = $localStorageService.getItem("currentUser");
            // -- Si hay tokenPBI verificar su expiración
            if (angular.isDefined(currentUser) && angular.isDefined(currentUser.tokenPBI) && angular.isDefined(currentUser.tokenPBI.expiration)) {
                d = new Date();
                if ((new Date(currentUser.tokenPBI.expiration)).getTime() >= d.getTime()) {
                    resolve(true);
                }
            }

            $http({
                url: BaseUrl.path['URL_LOGIN_PWBI'],
                method: 'POST',
            })
            .success(function (response, status, headers) {
                $localStorageService.setItem("currentUser.tokenPBI", {
                    token: response.access_token,
                    expiration: new Date(Number(response.expires_on) * 1000),
                });
                resolve(true);
            })
            .error(function (response, status, headers) {
                reject(response);
            });
        });
    };

    // -- Obtener los grupos disponibles
    service.getGroups = function (req) {
        return new Promise(function (resolve, reject) {
            service.login()
                .then(function () {
                    $http({
                        url: BaseUrl.path['URL_GRUPOS_PWBI'],
                        method: 'GET',
                        headers: {
                            powerBiToken: $localStorageService.getItem("currentUser.tokenPBI.token")
                        }
                    })
                        .success(function (response, status, headers) {
                            resolve(response);
                        })
                        .error(function (response, status, headers) {
                            reject(response);
                        });
                })
                .catch(function (e) {
                    console.log("error@PBIlogin");
                    console.log(e.msg);
                    reject(e);
                });
        });

    };

    // -- Obtener los reportes disponibles
    service.getReports = function (req) {
        return new Promise(function (resolve, reject) {
            service.login()
                .then(function () {
                    $http({
                        url: BaseUrl.urlPowerBIReports(req.groupId),
                        method: 'GET',
                        headers: {
                            powerBiToken: $localStorageService.getItem("currentUser.tokenPBI.token")
                        }
                    })
                        .success(function (response, status, headers) {
                            resolve(response);
                        })
                        .error(function (response, status, headers) {
                            reject(response);
                        });
                });
        });
    };

    // -- Obtener/validar token del reporte seleccionado
    service.getReportToken = function (req) {
        return new Promise(function (resolve, reject) {
            service.login()
                .then(function () {
                    $http({
                        url: BaseUrl.urlPowerBIReportToken(req.groupId, req.reportId),
                        method: 'GET',
                        headers: {
                            powerBiToken: $localStorageService.getItem("currentUser.tokenPBI.token")
                        }
                    })
                        .success(function (response, status, headers) {
                            resolve(response);
                        })
                        .error(function (response, status, headers) {
                            reject(response);
                        });
                });
        });
    };

    return service;
}
angular
    .module('dashboard')
    .factory('ReplayConfigurationFactory', ReplayConfigurationFactory)

ReplayConfigurationFactory.$inject = ['$http', '$state', '$localStorageService', 'BaseUrl'];

function ReplayConfigurationFactory($http, $state, $localStorageService, BaseUrl) {
    var service = {};

    service.create = function (c) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_SERIES_CONFIG'],
                method: 'POST',
                data: c,
            }).then(function (response) {
                resolve(response);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.edit = function (c) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_SERIES_CONFIG'] + '/' + c.id,
                method: 'PUT',
                data: c,
            }).then(function (response) {
                resolve(response);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.deleteOne = function (seriesId) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_SERIES_CONFIG'] + '/' + seriesId,
                method: 'DELETE',
            }).then(function (response) {
                resolve(response);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.deleteMany = function (selectedItems) {
        var seriesIds = "";
        angular.forEach(selectedItems.items, function(key, value) {
            if(key == true) {
                seriesIds += "seriesId=" + value + '&';
            }
        })
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_SERIES_CONFIG'] + '?'+ seriesIds,
                method: 'DELETE',
            }).then(function (response) {
                resolve(response);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.createReplay = function (c) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_REPLAY_CONFIG'],
                method: 'POST',
                data: c,
            }).then(function (response) {
                resolve(response);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.editReplay = function (c) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_REPLAY_CONFIG'] + '/' + c.id,
                method: 'PUT',
                data: c,
            }).then(function (response) {
                resolve(response);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.getReplayById = function (id) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_REPLAY_CONFIG'] + '/' + id,
                method: 'GET',
            }).then(function (response) {
                resolve(response.data);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.getReplays = function (req) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_REPLAY_CONFIG'],
                method: 'GET',
                params: {
                    active: req.active,
                    target: req.target
                }
            }).then(function (response) {
                resolve(response.data);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.deleteReplay = function (replayId) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_REPLAY_CONFIG'] + '/' + replayId,
                method: 'DELETE',
            }).then(function (response) {
                resolve(response);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.createChart = function (replayId, object) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_REPLAY_CONFIG'] + '/' + replayId + "/chart/",
                method: 'POST',
                data: object,
            }).then(function (response) {
                resolve(response);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.getChartByReplayIdAndChartId = function (replayId, chartId) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_REPLAY_CONFIG'] + '/' + replayId + '/chart/' + chartId,
                method: 'GET',
            }).then(function (response) {
                resolve(response);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.deleteChart = function (replayId, chartId) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_REPLAY_REPLAYS'] + '/' + replayId + "/chart/" + chartId,
                method: 'DELETE',
            }).then(function (response) {
                resolve(response);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.getAllSeries = function (type) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_SERIES_CONFIG'] + '?type=' + type + '&itemsPerPage=1000',
                method: 'GET',
            }).then(function (response) {
                resolve(response.data);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.getSeriesById = function (id) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_SERIES_CONFIG'] + '/' + id,
                method: 'GET',
            }).then(function (response) {
                resolve(response.data);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.loadDataFromHistory = function () {
        return new Promise(function (resolve, reject) {
            $http({
                url: '/risk-backend/rest/multi-graphic/ts/series/load-historical-data',
                method: 'POST',
            }).then(function (response) {
                resolve(response);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.buildDataByAggregate = function () {
        return new Promise(function (resolve, reject) {
            $http({
                url: '/risk-backend/rest/multi-graphic/ts/series/time-interval',
                method: 'POST',
            }).then(function (response) {
                resolve(response);
            }, function (response) {
                reject(response);
            });
        });
    };

    return service;
}

'use strict';

angular.module('dashboard').factory('ReferencesFactory', ReferencesFactory);

ReferencesFactory.$inject = ['$http', 'BaseUrl'];

function ReferencesFactory($http, BaseUrl) {
  var service = {};

  service.getIssueReferencesCount = function (issueUuid) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path['URL_REFERENCES'] + '/issues/' + issueUuid + '/counter',
        method: 'GET',
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getListReferencesCount = function (listId, referencedValue) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path['URL_REFERENCES'] +
          '/list/' +
          listId +
          '/value/' +
          referencedValue +
          '/counter',
        method: 'GET',
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getReferenceData = function (referenceUuid, filters) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_REFERENCES'] + '/' + referenceUuid,
        method: 'GET',
        params: filters.pagination,
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  return service;
}

"use strict";
var SUPER_USERS_TYPES = ["SA", "SU"];
angular.module("dashboard").factory("PermissionsFactory", function ($localStorageService) {
  function actions(_actions, value) {
    return _actions.split(",").find(function (element) {
      return element.trim() == value.trim();
    });
  }

  return {
    isAuditor: function () {
      var currentUser = $localStorageService.getItem("currentUser");
      if (
        angular.isDefined(currentUser) &&
        currentUser.userType == "AU"
      ) {
        return true;
      }
      return false;
    },

    isSuperUser: function () {
      var currentUser = $localStorageService.getItem("currentUser");
      if (
        angular.isDefined(currentUser) &&
        currentUser.userType == "SA"
      ) {
        return true;
      }
      return false;
    },
    /**
     * Checks if the current user has the specified permission.
     * Versión optimizada para Node 8.17.0 con soporte condicional de '#'
     */
    hasPermission: function (permission) {
      var currentUser = $localStorageService.getItem("currentUser");
      if (!currentUser) return false;

      var userType = currentUser.userType;
      if (userType === "SA") return true;

      
      // 1. Parsing de la cadena de permiso
      var parts = permission.trim().split(":");
      var resourcePart = parts[0] || "";
      var action = parts[1] || "";
      var resourceName;
      var entityId;
      
      // Condicionamos el split del '#'
      if (resourcePart.indexOf("#") !== -1) {
        var tmp = resourcePart.split("#");
        resourceName = tmp[0];
        entityId = tmp[1];
      } else {
        resourceName = resourcePart;
        entityId = undefined; // No hay ID de entidad específico
      }
      
      var systemConfigStorage = $localStorageService.getItem("System")
      
      if(systemConfigStorage && systemConfigStorage.includeFileACLs === false && resourceName === "files-storage-folder-file" && entityId != undefined){
        // Si la configuración del sistema indica que no se deben incluir ACLs de archivos, y el recurso es "files-storage-folder-file" con un entityId definido, 
        console.warn("Permisos de ACL de archivos deshabilitados por configuración del sistema. Permitido acceso a:", permission);
        return true;
      }
      
      // 2. Obtención de permisos
      var rawPermissions = $localStorageService.getItem("currentUser.permissions");
      var permissionList;

      if (typeof rawPermissions === "string") {
        try {
          permissionList = JSON.parse(rawPermissions);
        } catch (e) {
          return false;
        }
      } else {
        permissionList = rawPermissions;
      }

      if (!Array.isArray(permissionList) || permissionList.length === 0) {
        return false;
      }

      // 3. Helper para validar acciones
      var checkAction = function (itemActions, target) {
        return actions(itemActions, target) || actions(itemActions, "all");
      };

      // 4. Evaluación de la lista
      // console.log(permissionList)
      return permissionList.some(function (item) {
        if (item.granted === false) return false;

        var isActionMatch = checkAction(item.actions, action);

        // Verificación de Recurso y Entidad
        // Usamos == para que null coincida con undefined en caso de que entityId no exista
        var isResourceMatch =
          (item.name === "all" || item.name === resourceName) && item.entityId == entityId;

        // Caso Auditor (AU) - Lógica específica del código original
        if (
          userType === "AU" &&
          item.granted &&
          item.name === resourceName &&
          actions(item.actions, action)
        ) {
          return true;
        }

        // Caso General (Admin/User)
        if (item.granted && isResourceMatch && isActionMatch) {
          return true;
        }

        return false;
      });
    },

    hasDenyPermission: function (permission) {
      var currentUser = $localStorageService.getItem("currentUser");
      if (!currentUser) return false;
      if (angular.isUndefined(currentUser)) {
        return true;
      }
      if (currentUser.userType == "SA") {
        return false;
      }
      var flagPermision = false;
      permission = permission.trim();
      var array = permission.split(":");
      var tmp = array[0].split("#");
      var resourceName = tmp[0];
      if (tmp.length > 1) {
        var entityId = tmp[1];
      }
      var action = array[1];
      var userPermissions = currentUser.permissions;

      if (userPermissions !== null) {
        var permissionList =
          typeof userPermissions === "string" ? JSON.parse(userPermissions) : userPermissions;
        if (angular.isDefined(permissionList) && permissionList.length > 0) {
          permissionList.forEach(function (item) {
            if (
              item.granted == false &&
              (item.name == "all" ||
                (item.name == resourceName &&
                  angular.isUndefined(entityId) &&
                  angular.isUndefined(item.entityId)) ||
                (item.name == resourceName &&
                  angular.isDefined(item.entityId) &&
                  item.entityId == entityId)) &&
              (actions(item.actions, action) || actions(item.actions, "all"))
            ) {
              flagPermision = true;
            }
          });
        }
      }
      return flagPermision;
    },

    addPermission: function (resourceName, entityId, actions, granted) {
      var userPermissions = $localStorageService.getItem("currentUser.permissions");
      var newUserPermission = {
        actions: actions,
        entityId: entityId,
        granted: granted,
        name: resourceName,
      };

      userPermissions.push(newUserPermission);

      if (userPermissions !== null) {
        $localStorageService.setItem("currentUser.permissions", userPermissions);
      }
    },

    hasCategory: function (category) {
      var currentUser = $localStorageService.getItem("currentUser");
      if (!currentUser) return false;
      if (currentUser.userType == "SA") {
        return true;
      }
      var flagCategory = false;
      category = category.trim();

      if (currentUser.categories !== null) {
        var categoriesList =
          typeof currentUser.categories === "string"
            ? JSON.parse(currentUser.categories)
            : currentUser.categories;
        if (angular.isDefined(categoriesList) && categoriesList.length > 0) {
          categoriesList.forEach(function (catg) {
            if (catg.name === category) {
              flagCategory = true;
            }
          });
        }
      }
      return flagCategory;
    }
  };
});

angular
.module('dashboard')
.factory('PerfilesFactory', PerfilesFactory)

PerfilesFactory.$inject = ['$http', '$q', 'BaseUrl', '$localStorageService'];

function PerfilesFactory($http, $q, BaseUrl, $localStorageService) {
    var service = {};
    var deferred = $q.defer();

    service.listadoRoles = function() {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_PROFILE_ROLES'],
                method: 'POST',
                cache: true
            }).then(function(response) {
                resolve(response);
            }, function(response) {
                reject(response);
            });
        });
    };

    // -- Listado de todos los perfiles con sus roles y opciones.
    service.listadoPerfilesRolesOpciones = function() {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_PERFILES_ROLES_OPCIONES'],
                method: 'POST'
            })
            .success(function (response, status) {
                resolve(response);
                return response;
            })
            .error(function (response, status) {
                reject(response);
            });
        });
    };
    
    //  Listado de todas los perfiles activos con sus roles y opciones
    service.listadoPerfilesRolesOpcionesActivos = function() {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_PERFILES_ROLES_OPCIONES_ACTIVOS'],
                method: 'POST'
            })
            .success(function (response, status) {
                resolve(response);
                return response;
            })
            .error(function (response, status) {
                reject(response);
            });
        });
    };

    service.crearUsuario = function (object) {
        return new Promise(function (resolve, reject) {
            $http({
                url: '/risk-backend/rest/user',
                method: 'POST',
                data: object
            }).then(function(response) {
                resolve(response);
            }, function(response) {
                reject(response);
            });
        })
    };

    service.editarUsuario = function (c) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_EDITAR_USUARIO'],
                method: 'POST',
                data: c,
                params: {
                    id: c.userId,
                    username: c.username,
                    name: c.userName,
                    lastName: c.userLastname,
                    estado: c.userState,
                    email: c.email,
                    telefono: c.userPhone,
                    codigoRol: c.riskRole.roleId,
                    codigoPerfil: c.usroProfileId.profileId,
                    tipoUsuario: c.userType,
                    lenguaje: c.userLang,
                    timezone: c.userTz,
                    groups: c.groups
                }
            })
            .success(function (response, status) {
                if (c.username == $localStorageService.getItem("currentUser.username")) {
                    $localStorageService.setItem("currentUser.lenguaje", response.userLang);
                    $localStorageService.setItem("currentUser.timeZone", response.userTz);
                    $localStorageService.setItem("currentUser.name", response.userName);
                };
                resolve(response);
                return response;

            })
            .error(function (response, status) {
                reject(response);
            });
        });
    };

    service.buscarUsuario = function (username) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_BUSCAR_USUARIO'],
                method: 'POST',
                data: username,
                params: {
                    username: username
                }
            })
            .success(function (response, status) {
                resolve(response);
                return response;
            })
            .error(function (response, status) {
                reject(response);
            });
        });
    };
    
    service.pruebaCrearUsuario = function (c) {
        $http({
            url: BaseUrl.path['URL_CREAR_USUARIO'],
            method: 'POST',
            data: c,
            params: {
                username: c.username,
                name: c.userName,
                lastName: c.userLastname,
                estado: c.userState,
                email: c.email,
                telefono: c.userPhone
            },
        })
        .success(function (response, status) {
            deferred.resolve(response);
            return response;
        })
        .error(function (response, status) {
            deferred.reject(response);
        });
        return deferred.promise;
    };
    
    service.crearUsuarioRolPerfil = function (c) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_CREAR_USUARIO'],
                method: 'POST',
                data: c,
                params: {
                    username: c.username,
                    name: c.userName,
                    lastName: c.userLastname,
                    estado: c.userState,
                    email: c.email,
                    telefono: c.userPhone,
                    codigoRol: c.riskRole.roleId,
                    codigoPerfil: c.usroProfileId.profileId,
                    tipoUsuario: c.userType,
                    lenguaje: c.userLang,
                    timezone: c.userTz
                },
            })
            .success(function (response, status) {
                resolve(response);
                return response;
            })
            .error(function (response, status) {
                reject(response);
            });
        });

    };
    
    service.modificarUsuarioRolPerfil = function (c, codigoPerfil) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_EDITAR_USUARIO'],
                method: 'POST',
                data: c,
                params: {
                    id: c.userId,
                    username: c.username,
                    name: c.userName,
                    lastName: c.userLastname,
                    estado: c.userState,
                    email: c.email,
                    telefono: c.userPhone,
                    codigoRol: c.riskRole.roleId,
                    codigoPerfil: c.usroProfileId.profileId
                }
            })
            .success(function (response, status) {
                resolve(response);
                return response;
            })
            .error(function (response, status) {
                reject(response);
            });
        });

    };
    
    service.pruebaEditarUsuario = function (c) {
            $http({
                url: BaseUrl.path['URL_EDITAR_USUARIO'],
                method: 'POST',
                data: c,
                params: {
                    id: c.userId,
                    username: c.username,
                    name: c.userName,
                    lastName: c.userLastname,
                    estado: c.userState,
                    email: c.email,
                    telefono: c.userPhone
                },
            })
            .success(function (response, status) {
                deferred.resolve(response);
                return response;
            })
            .error(function (response, status) {
                deferred.reject(response);
            });

        return deferred.promise;
    };
    
    service.eliminarUsuario = function (id) {
        return new Promise(function (resolve, status) {
            $http({
                url: BaseUrl.path['URL_ELIMINAR_USUARIO'],
                method: 'POST',
                data: id,
                params: {
                    id: id
                }
            })
            .success(function (response, status) {
                console.log(id);
                resolve(response);
                return response;
            })
            .error(function (response, status) {
                console.log(id);
                reject(response);
            });
        });

    };

    //  Resetear usuario.
    service.cambiarPassword = function (id, c) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_CAMBIAR_PASSWORD_USUARIO'],
                method: 'POST',
                params: {
                    id: id,
                    passwordAntiguo: c.passwordAntigua,
                    passwordNuevo: c.passwordNueva,
                    passwordConfirmarNuevo: c.passwordConfirmar
                },
            })
            .success(function (response, status) {
                resolve(response);
                return response;
            })
            .error(function (response, status) {
                console.log(response);
                reject(response);
            });
        });
    };

    service.listarOpciones = function() {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_PROFILE_OPTIONS'],
                method: 'POST'
            })
            .success(function (response, status) {
                resolve(response);
                return response;
            })
            .error(function (response, status) {
                reject(response);
            });
        });
    };
    
    service.crearPerfilRolOpcion = function (c, listadoRoles, listadoOpciones, listadoGrupos){
         return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_CREAR_PERFIL_ROL_OPCION'],
                method: 'POST',
                data: {
                    profileId: c.profileId,
                    profileName: c.profileName,
                    originalProfileId: c.originalProfileId,
                    activo: c.activo,
                    esPersonalizado: c.esPersonalizado,
                    descripcion: c.descripcion,
                    riskRoleList: listadoRoles,
                    riskOptionList: listadoOpciones,
                    riskWorkspaceList: listadoGrupos
                },
            })
            .success(function (response, status) {
                resolve(response);
                return response;
            })
            .error(function (response, status) {
                console.log(response);
                reject(response);
            });                 
         });
        
    };
    
    service.editarPerfilRolOpcion = function (codigoPerfil, c, listadoRoles, listadoOpciones, listadoGrupos){
            $http({
                url: BaseUrl.path['URL_EDITAR_PERFIL_ROL_OPCION'],
                method: 'POST',
                data: {
                    profileId: codigoPerfil,
                    profileName: c.profileName,
                    originalProfileId: c.originalProfileId,
                    activo: c.activo,
                    esPersonalizado: c.esPersonalizado,
                    descripcion: c.descripcion,
                    riskRoleList: listadoRoles,
                    riskOptionList: listadoOpciones,
                    riskWorkspaceList: listadoGrupos
                },
            })
            .success(function (response, status) {
                deferred.resolve(response);
                return response;
            })
            .error(function (response, status) {
                console.log(response);
                deferred.reject(response);
            });        
            return deferred.promise;
    };

    service.crearPerfil = function (id, c, listadoRoles, listadoOpciones) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_CREAR_PERFIL'],
                method: 'POST',
                params: {
                    idUsuario: id,
                    codigoPerfil: c.profileId,
                    perfilOrigen: c.originalProfileId,
                    activo: c.activoPerfil,
                    personalizado: c.esPersonalizado,
                    defecto: c.defecto,
                    descripcion: c.descripcion,
                    listadoRoles: listadoRoles,
                    listadoOpciones: listadoOpciones
                },
            })
            .success(function (response, status) {
                resolve(response);
                return response;
            })
            .error(function (response, status) {
                console.log(response);
                reject(response);
            });

        });
    };
    
    //  Editar perfil con sus roles y opciones.
    service.editarPerfil = function (id, c, listadoRoles, listadoOpciones) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_EDITAR_PERFIL'],
                method: 'POST',
                params: {
                    idUsuario: id,
                    codigoPerfil: c.profileId,
                    perfilOrigen: c.originalProfileId,
                    activo: c.activoPerfil,
                    personalizado: c.esPersonalizado,
                    defecto: c.defecto,
                    descripcion: c.descripcion,
                    listadoRoles: listadoRoles,
                    listadoOpciones: listadoOpciones
                },
            })
            .success(function (response, status) {
                resolve(response);
                return response;
            })
            .error(function (response, status) {
                console.log(response);
                reject(response);
            });
        });
    };
    
    //  La eliminación es de manera lógica no física.
    service.eliminarPerfil = function (idPerfil) {
        console.log("EL CÓDGIO DEL PERFIL ES");
        console.log(idPerfil);
        return new Promise(function (resolve, status) {
            $http({
                url: BaseUrl.path['URL_PERFIL_ELIMINAR_POR_ID'],
                method: 'POST',
                data: idPerfil,
                params: {
                    idPerfil: idPerfil
                }
            })
                    .success(function (response, status) {
                        resolve(response);
                        return response;
                    })
                    .error(function (response, status) {
                        console.log(response);
                        reject(response);
                    });
        });

    };
    
    service.listadoUsuarios = function(){
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_LISTADO_USUARIOS'],
                method: 'POST',
                cache: true
            })
                    .success(function (response, status) {
                        resolve(response);
                        return response;
                    })
                    .error(function (response, status) {
                        reject(response);
                    });
        });
        
    };
    
    service.pruebaListadoUsuarios = function(){
            $http({
                url: BaseUrl.path['URL_LISTADO_USUARIOS'],
                method: 'POST',
            })
            .success(function (response, status) {
                deferred.resolve(response);
                return response;
            })
            .error(function (response, status) {
                deferred.reject(response);
            });
        return deferred.promise;
    };
    
    //  Listado de usuarios con roles.
    service.listadoUsuariosRoles = function(){
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_LISTADO_USUARIOS_ROLES'],
                method: 'POST'
            })
            .success(function (response, status) {
                resolve(response);
                return response;
            })
            .error(function (response, status) {
                reject(response);
            });
        });
    };
 
    //  Buscar perfil por codigo o id.
    service.buscarPerfil = function (id) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_BUSCAR_PERFIL_POR_ID'],
                method: 'POST',
                params: {
                    idPerfil: id
                },
            })
                    .success(function (response, status) {
                        resolve(response);
                        return response;
                    })
                    .error(function (response, status) {
                        reject(response);
                    });
        });
    };
    
    service.listadoPerfilesPorRol = function(roleId){
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_BUSCAR_PERFIL_POR_ROL'],
                method: 'POST',
                params: {
                    codigoRol: roleId
                }
            })
                    .success(function (response, status) {
                        resolve(response);
                        return response;
                    })
                    .error(function (response, status) {
                        reject(response);
                    });
        });
        
    };

    return service;
};
angular
    .module('dashboard')
    .factory('PasswordResetFactory', PasswordResetFactory)

PasswordResetFactory.$inject = ['$http', '$q', 'BaseUrl'];

function PasswordResetFactory($http, $q, BaseUrl) {
    var service = {};

    service.changePassword = function (username, token, password, passConfirmation) {
        var defered = $q.defer();
        var promise = defered.promise;

        $http({
            method: 'PUT',
            url: BaseUrl.urlPasswordChange(username, token),
            params: {
                password: BaseUrl.base64Encode(password),
                password_confirmation: BaseUrl.base64Encode(passConfirmation)
            },
            transformRequest: function (obj) {
                var str = [];
                for (var p in obj)
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                return str.join("&");
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(function (response) {
            defered.resolve(response);
        }, function (response) {
            defered.reject(response);
        });

        return promise;
    };

    service.passwordResetRequest = function (username, recaptcha) {
        var defered = $q.defer();
        var promise = defered.promise;

        $http({
            method: 'POST',
            url: BaseUrl.urlPasswordReset(username),
            headers: {
                recaptcha: recaptcha
            },
        }).then(function (response) {
            defered.resolve(response);
        }, function (response) {
            defered.reject(response);
        });

        return promise;
    };

    return service;
}

angular
.module('dashboard')
.factory('OAuthProviderFactory', OAuthProviderFactory)

OAuthProviderFactory.$inject = ['$http', '$localStorageService', 'BaseUrl'];

    function OAuthProviderFactory($http, $localStorageService, BaseUrl) {
        var service = {};

        service.create = function (object) {
            return new Promise(function (resolve, reject) {
                $http({
                    url: '/risk-backend/rest/oauth2-providers',
                    method: 'POST',
                    data: object,
                }).then(function(response) {
                    resolve(response);
                }, function(response) {
                    reject(response);
                });
            });
        }

        service.edit = function (id, object) {
            return new Promise(function (resolve, reject) {
                $http({
                    url: '/risk-backend/rest/oauth2-providers/' + id,
                    method: 'PUT',
                    data: object,
                }).then(function(response) {
                    resolve(response);
                }, function(response) {
                    reject(response);
                });
            });
        }

        return service;
    }
angular
  .module('dashboard')
  .factory('NotificationsFactory', NotificationsFactory);

NotificationsFactory.$inject = ['$http', 'BaseUrl'];

function NotificationsFactory($http, BaseUrl) {
  var service = {};

  service.getNotificationsCount = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_NOTIFICATIONS'] + '/count',
        method: 'GET',
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getNotifications = function (pagination, onlyUnread, target) {
    var params = {
      page: pagination.page || 1,
      itemsPerPage: pagination.itemsPerPage || 100,
      sort: 'asc',
      isRead: !onlyUnread || false,
      target: target,
    };
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_NOTIFICATIONS'],
        method: 'GET',
        params: params,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  service.markAllRead = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_NOTIFICATIONS'] + '/mark-all-as-read/',
        method: 'PUT',
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  service.markReadById = function (id) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_NOTIFICATIONS'] + '/mark-as-read/' + id,
        method: 'PUT',
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  service.removeAll = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_NOTIFICATIONS'] + '/remove-all',
        method: 'DELETE',
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  service.removeById = function (id) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_NOTIFICATIONS'] + '/remove/' + id,
        method: 'DELETE',
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  service.removeByIdList = function (idlist) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_NOTIFICATIONS'] + '/remove',
        method: 'POST',
        data: idlist,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  return service;
}

angular.module("dashboard").factory("LoginFactory", LoginFactory);

LoginFactory.$inject = ["$http", "$localStorageService", "$state", "BaseUrl"];
function LoginFactory($http, $localStorageService, $state, BaseUrl) {
  var service = {};

  service.getProviders = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_OAUTH2_PROVIDERS"],
        method: "GET",
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.loginByOAuth2 = function (providerName, code) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_OAUTH2_TOKEN"] + "/" + providerName + "?code=" + code,
        method: "POST",
        data: { withCredentials: false },
      }).then(
        function (response) {
          var currentDate = new Date();
          currentDate.setMinutes(
            currentDate.getMinutes() + parseInt(response.headers("expiration"))
          );
          response.data.tokenInfo = {
            timeout: Number(response.headers("expiration")),
            expiration: currentDate,
            authenticationType: response.headers("authentication-type"),
          };
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.login = function (username, password, recaptcha) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_AUTH_TOKEN"] + "?username=" + username,
        method: "POST",
        data: { withCredentials: false },
        headers: { password: base64Encode(password), recaptcha: recaptcha },
      }).then(
        function (response) {
          var currentDate = new Date();
          currentDate.setMinutes(
            currentDate.getMinutes() + parseInt(response.headers("expiration"))
          );
          response.data.tokenInfo = {
            timeout: Number(response.headers("expiration")),
            expiration: currentDate,
            authenticationType: response.headers("authentication-type"),
          };
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getPasswordPolicy = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/user/password-policy",
        method: "GET",
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getPasswordPolicyByTokenUUID = function (username, tokenUUID) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/user/password-policy/" + username + "/" + tokenUUID,
        method: "GET",
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.refreshToken = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_AUTH_REFRESH_TOKEN"],
        method: "POST",
      })
        .success(function (response, status, headers) {
          if (status == 200) {
            var currentDate = new Date();
            currentDate.setMinutes(currentDate.getMinutes() + parseInt(headers("expiration")));

            response.tokenInfo = {
              timeout: Number(headers("expiration")),
              expiration: currentDate,
              authenticationType: headers("authentication-type"),
            };
            service.setCurrentUser(response);

            resolve(response);
          } else {
            reject(response);
          }
        })
        .error(function (response, status) {
          if (status === 401) {
            reject(response);
          }
          reject(status);
        });
    });
  };

  service.Logout = function () {
    $localStorageService.removeItem("currentUser");
    $localStorageService.removeItem("HomePage");
    $localStorageService.removeItem("System");
    $state.go("login");
    // return new Promise(function (resolve, reject) {
    //   $http({
    //     url: "/risk-backend/rest/auth/logout",
    //     method: "POST",
    //   }).then(
    //     function (response) {
    //       delete $localStorageService.currentUser;
    //       $state.go("login");
    //       resolve(response);
    //     },
    //     function (response) {
    //       reject(response);
    //     }
    //   );
    // });
  };

  service.LogoutSession = function () {
    // $state.go('login');
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/auth/logout",
        method: "POST",
      }).then(
        function (response) {
          $localStorageService.removeItem("currentUser");
          $localStorageService.removeItem("HomePage");
          $localStorageService.removeItem("System");
          $state.go("login");
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.setCurrentUser = function (user) {
    $localStorageService.setItem("currentUser", {
      userId: user.userId,
      username: user.username,
      name: user.fullName,
      tokenInfo: user.tokenInfo,
      lenguaje: user.lang,
      region: user.region,
      timeZone: user.timeZone,
      userType: user.profile.type,
      domain: user.domain,
      permissions: user.profile.permissions,
      categories: user.profile.categories,
      groups: user.profile.groups,
      company: user.company,
    });
  };

  function base64Encode(input) {
    var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var output = "";
    var chr1,
      chr2,
      chr3 = "";
    var enc1,
      enc2,
      enc3,
      enc4 = "";
    var i = 0;
    do {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);
      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;
      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }
      output =
        output +
        keyStr.charAt(enc1) +
        keyStr.charAt(enc2) +
        keyStr.charAt(enc3) +
        keyStr.charAt(enc4);
      chr1 = chr2 = chr3 = "";
      enc1 = enc2 = enc3 = enc4 = "";
    } while (i < input.length);
    return output;
  }

  return service;
}

angular
.module('dashboard')
.factory('LabelFactory', LabelFactory)

LabelFactory.$inject = ['$http', '$localStorageService', 'BaseUrl'];

    function LabelFactory($http, $localStorageService, BaseUrl) {
        var service = {};

        service.getLabels = function () {
            return new Promise(function (resolve, reject) {
                $http({
                    url: BaseUrl.path['URL_LABEL'],
                    method: 'GET',
                    cache: true
                })
                .success(function (response, status, headers) {
                    resolve(response);
                })
                .error(function (response, status, headers) {
                    reject(response);
                });
            });
        };
        return service;
    }

"use strict";

angular.module("dashboard").factory("IssuesFactory", IssuesFactory);

IssuesFactory.$inject = ["$http", "BaseUrl"];

function IssuesFactory($http, BaseUrl) {
  var service = {};

  service.getIssuesTypes = function (req) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/admin/type",
        method: "GET",
        params: req,
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getIssueTypeById = function (id) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/admin/type/" + id,
        method: "GET",
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getIssuesCategories = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/admin/category",
        method: "GET",
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getIssuesCounter = function (req) {
    var queryParams = {};
    if (req.datesInUTC) {
      queryParams.datesInUTC = false;
    }
    if (req.assignedUsername) {
      queryParams.assignedUsername = req.assignedUsername;
    }
    if (req.categoryId) {
      queryParams.categoryId = req.categoryId;
    }
    if (req.from) {
      queryParams.from = req.from;
    }
    if (req.to) {
      queryParams.to = req.to;
    }
    if (req.relatedBy) {
      queryParams.relatedBy = req.relatedBy;
    }

    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/accountant",
        method: "GET",
        params: queryParams,
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getIssuesSummary = function (filters) {
    var params = {};
    if (filters) {
      params.issueType = filters.issueType ? filters.issueType : null;

      if (filters.date) {
        params.from = filters.date.from ? filters.date.from : null;
        params.to = filters.date.to ? filters.date.to : null;
      }
    }

    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/summary",
        method: "GET",
        params: params,
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getIssuesFiltered = function (filters) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/custom/filter",
        method: "POST",
        data: filters,
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getIssuesFilteredV2 = function (filters) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/custom/filter",
        method: "POST",
        data: filters,
        // responseType: 'string',
        // headers: {
        //   Accept: 'text/plain',
        // },
      }).then(
        function (response) {
          // response.pagination = filters;
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.exportToCSV = function (token) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/custom/filter",
        method: "POST",
        data: filters,
        // responseType: 'string',
        // headers: {
        //   Accept: 'text/plain',
        // },
      }).then(
        function (response) {
          // response.pagination = filters;
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getIssueTypeFilters = function (issueTypeId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/type/" + issueTypeId + "/filters",
        method: "GET",
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.assignIssuesToUser = function (req) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/batch/assigned",
        method: "PUT",
        data: req,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.assignIssuesToClassification = function (req) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/batch/classification",
        method: "PUT",
        data: req,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.assignIssuesToStatus = function (req) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/batch/status",
        method: "PUT",
        data: req,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.createIssue = function (body) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"],
        method: "POST",
        data: body,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.exportIssue = function (uuid, body) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + uuid + "/export",
        method: "POST",
        data: body,
        responseType: "arraybuffer",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.updateIssue = function (issueUuid, body) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + issueUuid,
        method: "PUT",
        data: body,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  service.archiveIssue = function (issueUuid, archived) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + issueUuid + "/archived/" + archived,
        method: "PUT",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getIssueByUUID = function (issueUuid) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + issueUuid,
        method: "GET",
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.markIssueAsSeen = function (issueUuid, seen) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + issueUuid + "/viewed/" + seen,
        method: "PUT",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.createEvidence = function (issueUuid, evidence) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + issueUuid + "/evidence",
        method: "POST",
        data: evidence,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.createEvidencesBatch = function (issueUuid, evidences) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + issueUuid + "/evidence/batch",
        method: "POST",
        data: evidences,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getIssueEvidencesSummary = function (issueUuid) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + issueUuid + "/evidence/summary",
        method: "GET",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getIssueAllEvidences = function (issueUuid) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + issueUuid + "/evidence/all",
        method: "GET",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getIssueEvidences = function (issueUuid, pagination) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + issueUuid + "/evidence",
        method: "GET",
        params: pagination,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.deleteIssueEvidence = function (issueUuid, evidenceUuid) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + issueUuid + "/evidence/" + evidenceUuid,
        method: "DELETE",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.linkIssues = function (parentIssueUuid, issuesToLink) {
    var data = {
      issueParentUUID: parentIssueUuid,
      relationshipName: "",
      issues: JSON.parse(JSON.stringify(issuesToLink)),
    };

    data.issues.forEach(function (issue) {
      if (typeof issue.body === "object") {
        issue.body = JSON.stringify(issue.body);
      }
      if (issue.head && typeof issue.head === "object") {
        issue.head = JSON.stringify(issue.head);
      }
    });

    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + parentIssueUuid + "/linked",
        method: "POST",
        data: data,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getLinkedIssuesByParentIssueUuid = function (parentIssueUuid) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + parentIssueUuid + "/linked",
        method: "GET",
        params: {
          page: 1,
          itemsPerPage: 99999,
        },
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.unlinkIssue = function (parentIssueUuid, linkedIssueUuid) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + parentIssueUuid + "/linked/" + linkedIssueUuid,
        method: "DELETE",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getLinkedIssues = function (parentIssueUuid, filters) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + parentIssueUuid + "/linked/custom-filter",
        method: "POST",
        data: filters,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getLinkedIssuesAvailableColumns = function (parentIssueUuid) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + parentIssueUuid + "/linked/available-columns",
        method: "GET",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.assignLinkedIssuesCustomColumns = function (parentIssueUuid, columnsConfig) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + parentIssueUuid + "/linked/custom-columns",
        method: "POST",
        data: columnsConfig,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.setLinkedIssuesColumnsOrder = function (parentIssueUuid, orderedColumns) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + parentIssueUuid + "/linked/custom-columns/drag-drop",
        method: "POST",
        data: orderedColumns,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.setLinkedIssuesDefaultIssueColumns = function (parentIssueUuid) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + parentIssueUuid + "/linked/custom-columns",
        method: "DELETE",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getLinkedIssuesType = function (parentIssueUuid) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + parentIssueUuid + "/linked/vinculated-issues-type",
        method: "GET",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getActivityLog = function (issueUuid, pagination) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + issueUuid + "/audit",
        method: "GET",
        params: {
          page: pagination.page,
          itemsPerPage: pagination.itemsPerPage,
        },
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getAvailableColumns = function (issueTypeId, issueCatagoryId) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["URL_ISSUE"] +
          "/type/" +
          issueCatagoryId +
          "/" +
          issueTypeId +
          "/available-columns",
        method: "GET",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.assignCustomColumns = function (issueTypeId, columnsConfig) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/type/" + issueTypeId + "/custom-columns",
        method: "POST",
        data: columnsConfig,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.assignCustomColumnsGroup = function (issueTypeId, groupId, categoryId, columnsConfig) {
    console.log("issueTypeId", issueTypeId);
    console.log("groupId", groupId);
    console.log("categoryId", categoryId);
    console.log("columnsConfig", columnsConfig);
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["URL_ISSUE"] +
          "/type/" +
          groupId +
          "/" +
          categoryId +
          "/" +
          issueTypeId +
          "/" +
          "add-custom-columns-by-group",
        method: "POST",
        data: columnsConfig,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.setDefaultIssueColumns = function (issueTypeId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/type/" + issueTypeId + "/custom-columns",
        method: "DELETE",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.setIssueColumnsOrder = function (issueTypeId, orderedColumns) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/type/" + issueTypeId + "/custom-columns/drag-drop",
        method: "POST",
        data: orderedColumns,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getIssueComments = function (issueUuid) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_COMMENTS"] + "/ISSUE/" + issueUuid,
        method: "GET",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.createIssueComment = function (issueUuid, comment) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_COMMENTS"] + "/ISSUE/" + issueUuid,
        method: "POST",
        data: comment,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getIssueFiles = function (issueUuid) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + issueUuid + "/storage",
        method: "GET",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.downloadIssueFile = function (issueUuid, fileName) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + issueUuid + "/storage/" + fileName,
        method: "GET",
        responseType: "blob",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.deleteIssueFile = function (issueUuid, fileName) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + issueUuid + "/storage/" + fileName,
        method: "DELETE",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getIssuesTimeSeries = function (filters) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/ts",
        method: "POST",
        data: filters,
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(Object.assign(response, { status: status }));
        });
    });
  };

  service.createIssueCustomView = function (body) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/custom-table",
        method: "POST",
        data: body,
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getIssuesCustomViews = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/custom-table",
        method: "GET",
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.deleteIssueCustomView = function (customViewId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/custom-table/" + customViewId,
        method: "DELETE",
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getIssueGuests = function (issueUuid, params) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + issueUuid + "/guest-user",
        method: "GET",
        params: params,
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.inviteUsersToIssue = function (issueUuid, inviteUsersRequest) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + issueUuid + "/guest-user",
        method: "POST",
        data: inviteUsersRequest,
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.removeIssueGuest = function (issueUuid, userToRemove) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + issueUuid + "/guest-user/" + userToRemove,
        method: "DELETE",
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getIssueTabCounter = function (issueUuid) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_ISSUE"] + "/" + issueUuid + "/counters",
        method: "GET",
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getAvailableGroups = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/group",
        method: "GET",
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  return service;
}

angular
.module('dashboard')
.factory('IssueTypeFactory', IssueTypeFactory)

IssueTypeFactory.$inject = ['$http', '$localStorageService', 'BaseUrl'];

    function IssueTypeFactory($http, $localStorageService, BaseUrl) {
        var service = {};

        service.getAll = function () {
            return new Promise(function (resolve, reject) {
                $http({
                    url: '/risk-backend/rest/issue/admin/type',
                    method: 'GET'
                }).then(function (response) {
                    resolve(response.data);
                }, function (response) {
                    reject(response);
                });
            });
        }

        service.create = function (object) {
            return new Promise(function (resolve, reject) {
                $http({
                    url: '/risk-backend/rest/issue/admin/type',
                    method: 'POST',
                    data: object,
                }).then(function(response) {
                    resolve(response);
                }, function(response) {
                    reject(response);
                });
            });
        }

        service.edit = function (id, object) {
            return new Promise(function (resolve, reject) {
                $http({
                    url: '/risk-backend/rest/issue/admin/type/' + id,
                    method: 'PUT',
                    data: object,
                }).then(function(response) {
                    resolve(response);
                }, function(response) {
                    reject(response);
                });
            });
        }

        service.delete = function (id) {
            return new Promise(function (resolve, reject) {
                $http({
                    url: '/risk-backend/rest/issue/admin/type/' + id,
                    method: 'DELETE'
                }).then(function(response) {
                    resolve(response);
                }, function(response) {
                    reject(response);
                });
            });
        }
        return service;
    }

angular
.module('dashboard')
.factory('IssueCategoryFactory', IssueCategoryFactory)

IssueCategoryFactory.$inject = ['$http', '$localStorageService', 'BaseUrl'];

    function IssueCategoryFactory($http, $localStorageService, BaseUrl) {
        var service = {};

        service.getAllCategory = function () {
            return new Promise(function (resolve, reject) {
                $http({
                    url: '/risk-backend/rest/issue/admin/category',
                    method: 'GET',
                    cache: true
                }).then(function (response) {
                    resolve(response.data);
                }, function (response) {
                    reject(response);
                });
            });
        }

        service.create = function (object) {
            return new Promise(function (resolve, reject) {
                $http({
                    url: '/risk-backend/rest/issue/admin/category',
                    method: 'POST',
                    data: object,
                }).then(function(response) {
                    resolve(response);
                }, function(response) {
                    reject(response);
                });
            });
        }

        service.edit = function (id, object) {
            return new Promise(function (resolve, reject) {
                $http({
                    url: '/risk-backend/rest/issue/admin/category/' + id,
                    method: 'PUT',
                    data: object,
                }).then(function(response) {
                    resolve(response);
                }, function(response) {
                    reject(response);
                });
            });
        }

        service.delete = function (id) {
            return new Promise(function (resolve, reject) {
                $http({
                    url: '/risk-backend/rest/issue/admin/category/' + id,
                    method: 'DELETE'
                }).then(function(response) {
                    resolve(response);
                }, function(response) {
                    reject(response);
                });
            });
        }

        return service;
    }

angular.module("dashboard").factory("InputListsFactory", InputListsFactory);

InputListsFactory.$inject = ["$http", "BaseUrl"];

function InputListsFactory($http, BaseUrl) {
  var service = {};

  var filters = [];
  service.getFilters = function () {
    return filters;
  };
  service.setFilters = function (value) {
    filters = value;
  };

  var selectedCol = null;
  service.getSelectedCol = function () {
    return selectedCol;
  };
  service.setSelectedCol = function (value) {
    selectedCol = value;
  };

  service.getSelectedList = function () {
    return selectedSchema;
  };
  service.setSelectedList = function (value) {
    selectedSchema = value;
  };

  service.getLists = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_INPUT_LISTS_SERVICES"],
        method: "GET",
        params: {
          page: 1,
          itemsPerPage: null,
          sort: "asc",
        },
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(Object.assign(response, { status: status }));
        });
    });
  };

  service.createList = function (request) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_INPUT_LISTS_SERVICES"],
        method: "POST",
        data: angular.toJson(request),
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(Object.assign(response, { status: status }));
        });
    });
  };

  service.updateList = function (request) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_INPUT_LISTS_SERVICES"] + request.listId,
        method: "PUT",
        data: angular.toJson(request),
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(Object.assign(response, { status: status }));
        });
    });
  };

  service.deleteList = function (listId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlInputList(listId),
        method: "DELETE",
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.getInputList = function (listId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlInputList(listId),
        method: "GET",
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(Object.assign(response, { status: status }));
        });
    });
  };

  service.getInputListFilters = function (listId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlInputListFilters(listId),
        method: "GET",
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(Object.assign(response, { status: status }));
        });
    });
  };

  /**
   * @deprecated
   * Recomedended to use the new getInputListDataFiltered()
   * */
  service.getInputListData = function (listId, filters, pagination) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlInputListData(listId),
        method: "POST",
        params: pagination,
        data: filters,
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(Object.assign(response, { status: status }));
        });
    });
  };

  service.getInputListDataFiltered = function (listId, filters) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlInputListDataFiltered(listId),
        method: "POST",
        data: filters,
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response, status) {
          reject(Object.assign(response, { status: status }));
        });
    });
  };

  service.getInputListMetadata = function (listId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlInputListMetadata(listId),
        method: "GET",
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.importInputListData = function (listId, body) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlInputListImportData(listId),
        method: "POST",
        data: body,
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(Object.assign(response, { status: status }));
        });
    });
  };

  service.saveInputListData = function (listId, body) {
    console.log("saveInputListData", listId, body);
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlInputListSaveData(listId),
        method: "POST",
        data: body,
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(Object.assign(response, { status: status }));
        });
    });
  };

  service.deleteInputListData = function (listId, dataId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlInputListDeleteRows(listId),
        method: "POST",
        data: dataId,
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.clearInputListData = function (listId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlInputListClearData(listId),
        method: "DELETE",
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.getInputDataById = function (inputDataId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlGetInputDataById(inputDataId),
        method: "GET",
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.setSettings = function (listId, listSettings) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlInputListSettings(listId),
        method: "POST",
        data: listSettings,
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.getStatisticsSummary = function (listId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlInputListStatisticsSumary(listId),
        method: "POST",
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.findAndReplace = function (listId, options) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlInputListFindAndReplace(listId),
        method: "PUT",
        data: options,
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };
  service.getDataById = function (listId, recordId) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["URL_INPUT_LISTS_SERVICES"] +
          listId +
          "/data/" +
          recordId,
        method: "GET",
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };
  service.searchLookupMatch = function (
    listId,
    searchValue,
    lookupmatch,
    filters
  ) {
    return new Promise(function (resolve, reject) {
      var l = lookupmatch.replace("#", "%23");

      $http({
        url:
          BaseUrl.path["URL_INPUT_LISTS_SERVICES"] +
          listId +
          "/lookup/value/" +
          searchValue +
          "/field/" +
          l,
        data: filters,
        method: "POST",
      })
        .success(function (response) {
          response.request = {
            listId: listId,
            searchValue: searchValue,
            lookupmatch: lookupmatch,
            filters: filters,
          };
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };
  service.searchOnInputlist = function (listId, searchValue) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["URL_INPUT_LISTS_SERVICES"] +
          listId +
          "/data/search-text/" +
          searchValue,
        method: "GET",
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };
  service.getListById = function (listId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_INPUT_LISTS_SERVICES"] + listId,
        method: "GET",
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          console.log(response, status, headers);
          reject(Object.assign(response, { status: status }));
        });
    });
  };

  service.getListById = function (listId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_INPUT_LISTS_SERVICES"] + listId,
        method: "GET",
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(Object.assign(response, { status: status }));
        });
    });
  };

  return service;
}

angular.module('dashboard').factory('IndicatorsFactory', IndicatorsFactory);

IndicatorsFactory.$inject = ['$http', 'BaseUrl'];

function IndicatorsFactory($http, BaseUrl) {
  var service = {};

  service.getIndicators = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_INDICATORS'],
        method: 'GET',
        params: {
          itemsPerPage: 999,
        },
      })
        .success(function (response, status, headers) {
          resolve(response, status);
        })
        .error(function (response, status, headers) {
          reject(Object.assign(response, { status: status }));
        });
    });
  };
  service.createIndicator = function (indicator) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_INDICATORS'],
        method: 'POST',
        data: indicator,
      })
        .success(function (response, status, headers) {
          resolve(response, status);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };
  service.editIndicator = function (indicator) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_INDICATORS'] + '/' + indicator.id,
        method: 'PUT',
        data: indicator,
      })
        .success(function (response, status, headers) {
          resolve(response, status);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };
  service.deleteIndicator = function (indicatorId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_INDICATORS'] + '/' + indicatorId,
        method: 'DELETE',
      })
        .success(function (response, status, headers) {
          resolve(response, status);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  return service;
}

angular.module("dashboard").factory("HolidaysFactory", HolidaysFactory);

HolidaysFactory.$inject = ["$http", "$localStorageService", "BaseUrl"];

function HolidaysFactory($http, $localStorageService, BaseUrl) {
  var service = {};

  service.get = function (object) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_HOLIDAYS"],
        method: "GET",
        data: object,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.create = function (holadyData) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_HOLIDAYS"],
        method: "POST",
        data: holadyData,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.edit = function (holadyData) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_HOLIDAYS"] + "/" + holadyData.id,
        method: "PUT",
        data: holadyData,
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.delete = function (id) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_HOLIDAYS"] + "/" + id,
        method: "delete",
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };



  return service;
}

angular.module('dashboard').factory('HealthyFactory', HealthyFactory);

HealthyFactory.$inject = ['$http', '$localStorageService', 'BaseUrl'];

function HealthyFactory($http, $localStorageService, BaseUrl) {
  var service = {};

  service.healthy = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['HEALTHY'],
        method: 'GET',
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  service.redisStatus = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['HEALTHY']+ "/redis-status",
        method: 'GET',
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  service.tmp = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['HEALTHY']+ "/tmp",
        method: 'GET',
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };



  return service;
}

angular.module('dashboard').factory('GroupFactory', GroupFactory);

GroupFactory.$inject = ['$http', '$localStorageService', 'BaseUrl'];

function GroupFactory($http, $localStorageService, BaseUrl) {
  var service = {};

  service.create = function (object) {
    return new Promise(function (resolve, reject) {
      $http({
        url: '/risk-backend/rest/group',
        method: 'POST',
        data: object,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.edit = function (id, object) {
    return new Promise(function (resolve, reject) {
      $http({
        url: '/risk-backend/rest/group/' + id,
        method: 'PUT',
        data: object,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getAllGroups = function (req) {
    return new Promise(function (resolve, reject) {
      $http({
        url: '/risk-backend/rest/group',
        method: 'GET',
        params: req,
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getAllByCompanyId = function (companyId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: '/risk-backend/rest/group/company/' + companyId,
        method: 'GET',
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getGroupById = function (id) {
    return new Promise(function (resolve, reject) {
      $http({
        url: '/risk-backend/rest/group/' + id,
        method: 'GET',
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  return service;
}

angular
.module('dashboard')
.factory('FunctionFiltersFactory', FunctionFiltersFactory)

FunctionFiltersFactory.$inject = ['$http', '$localStorageService', 'BaseUrl'];

    function FunctionFiltersFactory($http, $localStorageService, BaseUrl) {
        var service = {};

        service.createFilter = function (req) {
            return new Promise(function (resolve, reject) {
                $http({
                    url: BaseUrl.path['URL_FUNCTION_FILTERS_CREATE'],
                    method: 'POST',
                    data: req,
                })
                .success(function (response, status, headers) {
                    resolve(response);
                })
                .error(function (response, status, headers) {
                    reject(response);
                });
            });
        };

        service.updateFilter = function (req) {
            return new Promise(function (resolve, reject) {
                $http({
                    url: BaseUrl.path['URL_FUNCTION_FILTERS_UPDATE'],
                    method: 'PUT',
                    data: req,
                })
                .success(function (response, status, headers) {
                    resolve(response);
                })
                .error(function (response, status, headers) {
                    reject(response);
                });
            });
        };

        service.deleteFilter = function (filterId) {
            return new Promise(function (resolve, reject) {
                $http({
                    url: BaseUrl.urlDeleteFunctionFilter(filterId),
                    method: 'DELETE',
                })
                .success(function (response, status, headers) {
                    resolve(response);
                })
                .error(function (response, status, headers) {
                    reject(response);
                });
            });
        };

        service.getFilters = function () {
            return new Promise(function (resolve, reject) {
                $http({
                    url: BaseUrl.path['URL_FUNCTION_FILTERS_GETALL'],
                    method: 'GET',
                })
                .success(function (response, status, headers) {
                    resolve(response);
                })
                .error(function (response, status, headers) {
                    reject(response);
                });
            });
        };

        return service;
    }
angular.module('dashboard').factory('FunctionFactory', FunctionFactory);

FunctionFactory.$inject = ['$http', 'BaseUrl'];

function FunctionFactory($http, BaseUrl) {
  var service = {};

  service.execute = function (id, live) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlFunctionExecute(id),
        method: 'POST',
        params: { executeLiveVersion: live },
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.executeV2 = function (functionId, versionId, testingAtributes) {
    var params = versionId ? { functionVersionId: versionId } : {};
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlFunctionExecuteV2(functionId),
        method: 'POST',
        params: params,
        data: testingAtributes,
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.getExecutionStatus = function (executionId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_FUNCTION'] + 'status/' + executionId,
        method: 'GET',
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.stopExecution = function (id, live) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlFunctionStopExecute(id),
        method: 'POST',
        params: { executeLiveVersion: live },
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.stopExecutionV2 = function (executionId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlFunctionStopExecuteV2(executionId),
        method: 'POST',
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.getFunctions = function (realtime) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_FUNCTION'],
        method: 'GET',
        params: {
          realtime: realtime,
          itemsPerPage: 0,
          page: 0,
        },
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.saveFunction = function (request) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_FUNCTION'],
        method: 'POST',
        data: request,
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.saveFunctionAttributes = function (id, data) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlFunctionAttributes(id),
        method: 'POST',
        data: data,
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.deleteFunctionAttributes = function (id, data) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlFunctionAttributes(id),
        method: 'DELETE',
        params: {
          attributes: data,
        },
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.getFunctionByID = function (id) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlFunction(id),
        method: 'GET',
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response, status) {
          reject(Object.assign(response, { status: status }));
        });
    });
  };
  service.getFunctionByName = function (name) {
    return new Promise(function (resolve, reject) {
      var encodeName = window.encodeURIComponent(window.encodeURIComponent(name));
      $http({
        url: BaseUrl.urlFunctionName(encodeName),
        method: 'GET',
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.getTransformations = function (req) {
    return new Promise(function (resolve, reject) {
      $http({
        cache: true,
        url: BaseUrl.path['URL_FUNCTION_TRANSFORMATIONS'],
        method: 'GET',
        params: req,
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.createFunction = function (fn) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_FUNCTION'],
        method: 'POST',
        data: fn,
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.deleteFunction = function (functionId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlFunction(functionId),
        method: 'DELETE',
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.typeCheck = function (functionId, request, realtime) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlFunctionTypecheck(functionId),
        method: 'POST',
        params: {
          realtime: realtime,
        },
        data: request,
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.createVersion = function (request) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlFunctionVersion(request.functionId),
        method: 'POST',
        data: request,
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.getVersions = function (id) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlFunctionVersion(id),
        method: 'GET',
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.setCurrentVersion = function (id, version) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlFunctionUpdateVersion(id, version),
        method: 'PUT',
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.deleteVersion = function (versionId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlVersion(versionId),
        method: 'DELETE',
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.getVersionByID = function (functionId, versionId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlFunctionUpdateVersion(functionId, versionId),
        method: 'GET',
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.getExecutions = function (functionId, request) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlFunctionExecutions(functionId),
        method: 'POST',
        data: request,
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.getExecutionByID = function (functionId, executionId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.urlFunctionExecutions(functionId, executionId),
        method: 'GET',
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.getSchedules = function (id) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_FUNCTION_SCHEDULES'],
        method: 'GET',
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.getExecutionsQueue = function (request) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_FUNCTION_QUEUE'],
        method: 'GET',
        
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response, status) {
          reject(Object.assign(response, { status: status }));
        });
    });
  };

  return service;
}

angular.module("dashboard").factory("FilesStorageFactory", FilesStorageFactory);

FilesStorageFactory.$inject = ["$http", "BaseUrl"];

function FilesStorageFactory($http, BaseUrl) {
  var service = {};

  service.createConfigGlobal = function (config) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_FILE_STORAGE_CONFIG"],
        method: "POST",
        data: config,
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.getConfigStorage = function (filters) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_FILE_STORAGE_CONFIG"],
        method: "GET",
        params: filters,
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.updateConfigGlobal = function (config) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_FILE_STORAGE_CONFIG"],
        method: "PUT",
        data: config,
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.getFolders = function (filters) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_FILE_STORAGE_FOLDER"],
        params: filters,
        method: "GET",
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.createFolder = function (folder) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_FILE_STORAGE_FOLDER"],
        method: "POST",
        data: folder,
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.editFolder = function (id, folder) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_FILE_STORAGE_FOLDER"] + "/" + id,
        method: "PUT",
        data: folder,
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.getFolderByID = function (id) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_FILE_STORAGE_FOLDER"] + "/" + id,
        method: "GET",
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(Object.assign({response:response}, { status: status }));
        });
    });
  };

  service.deleteFolderById = function (id) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_FILE_STORAGE_FOLDER"] + "/" + id,
        method: "DELETE",
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.getFilesInFolder = function (iDfolder, filters) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_FILE_STORAGE_FOLDER"] + "/" + iDfolder + "/file",
        params: filters,
        method: "GET",
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(Object.assign(response, { status: status }));
        });
    });
  };

  service.getFileInFolderByID = function (iDfolder, fileID) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["URL_FILE_STORAGE_FOLDER"] +
          "/" +
          iDfolder +
          "/file/" +
          fileID,
        method: "GET",
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(Object.assign(response, { status: status }));
        });
    });
  };

  service.uploadFileInFolder = function (folder, file) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_FILE_STORAGE_FOLDER"] + "/" + folder + "/file",
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: file,
        // transformRequest: function (data) {
        //   var formData = new FormData();
        //   angular.forEach(data, function (value, key) {
        //     formData.append(key, value);
        //   });
        //   return formData;
        // },
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.deleteFileInTrash = function (folderID, fileID) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["URL_FILE_STORAGE_FOLDER"] +
          "/" +
          folderID +
          "/file/" +
          fileID,
        method: "DELETE",
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.moveFileToTrash = function (folderID, fileID) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["URL_FILE_STORAGE_FOLDER"] +
          "/" +
          folderID +
          "/file/" +
          fileID +
          "/move-to-trash",
        method: "PUT",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.restoreFileToFolder = function (folderID, fileID) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["URL_FILE_STORAGE_FOLDER"] +
          "/" +
          folderID +
          "/file/" +
          fileID +
          "/restore-from-trash",
        method: "PUT",
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.moveFileToFolder = function (folderID, fileID, destinationFolderID) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["URL_FILE_STORAGE_FOLDER"] +
          "/" +
          folderID +
          "/file/" +
          fileID +
          "/move/" +
          destinationFolderID,
        method: "PUT",
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.downloadFile = function (folderID, fileID) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["URL_FILE_STORAGE_FOLDER"] +
          "/" +
          folderID +
          "/file/" +
          fileID +
          "/download",
        method: "GET",
        responseType: "blob",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.filesInTrash = function (filters) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_FILE_STORAGE_TRASH"],
        method: "GET",
        params: filters,
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.deleteALLTrash = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_FILE_STORAGE_TRASH"],
        method: "DELETE",
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.getSystemFolders = function (filters) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_FILE_STORAGE_SYSTEM"],
        method: "GET",
        params: filters,
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  return service;
}

angular
  .module("dashboard")
  .factory("ExternalLibrariesFactory", ExternalLibrariesFactory);

ExternalLibrariesFactory.$inject = ["$http", "$localStorageService", "BaseUrl"];

function ExternalLibrariesFactory($http, $localStorageService, BaseUrl) {
  var service = {};

  service.getAllPythonLibraries = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_EXTERNAL_LIBRARIES_PYTHON"],
        method: "GET",
      })
        .then(function (response) {
          resolve(response.data.data)
        })
        .catch(function (response) {
          reject(response);
        });
    });
  };
  service.getAllActivePythonLibraries = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_EXTERNAL_LIBRARIES_PYTHON"]+"/active",
        method: "GET",
      })
        .then(function (response) {
          resolve(response.data)
        })
        .catch(function (response) {
          reject(response);
        });
    });
  };

  service.initLibrary = function (config) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_EXTERNAL_LIBRARIES_PYTHON"] + "/init",
        method: "POST",
        data: config,
      })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (response) {
          reject(response);
        });
    });
  };

  service.getPythonLibrary = function (id) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_EXTERNAL_LIBRARIES_PYTHON"] +"/"+id,
        method: "GET",
      })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (response) {
          reject(response);
        });
    });
  };

  service.editPythonLibrary = function (config) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_EXTERNAL_LIBRARIES_PYTHON"] +"/"+config.id,
        method: "PUT",
        data: config,
      })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (response) {
          reject(response);
        });
    });
  };

  service.deletePythonLibrary = function (id) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_EXTERNAL_LIBRARIES_PYTHON"] + "/" + id,
        method: "DELETE",
      })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (response) {
          reject(response);
        });
    });
  };

  service.executePythonLibrary = function (libraryId, inputId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_EXTERNAL_LIBRARIES_PYTHON"] + "/" + libraryId+"/"+inputId+"/execute",
        method: "POST",
      })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (response) {
          reject(response);
        });
    });
  };
  service.generateInput = function (libraryId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_EXTERNAL_LIBRARIES_PYTHON"] + "/" + libraryId+"/generate-input",
        method: "POST",
      })
        .then(function (response) {
          resolve(response.data.schema);
        })
        .catch(function (response) {
          reject(response);
        });
    });
  };
  service.saveInput = function (libraryId, schema) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_EXTERNAL_LIBRARIES_PYTHON"] + "/" + libraryId+"/save-input",
        method: "POST",
        data:schema
      })
        .then(function (response) {
          resolve(response.data.id);
        })
        .catch(function (response) {
          reject(response);
        });
    });
  };

  return service;
}

angular
    .module('dashboard')
    .factory('EventsV2Factory', EventsV2Factory)

EventsV2Factory.$inject = ['$http', '$localStorageService', 'BaseUrl'];

function EventsV2Factory($http, $localStorageService, BaseUrl) {

    var service = {};

    service.getColumnData = function (labelOrSchemaIds) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_EVENTS_V2'] + 'column-data/' + labelOrSchemaIds,
                method: 'GET',
            })
            .success(function (response, status, headers) {
                resolve(response);
            })
            .error(function (response, status, headers) {
                reject(response);
            });
        });
    };

    service.checkEvent = function (eventId) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_EVENTS_V2'] + eventId + '/check',
                method: 'PUT',
            })
            .success(function (response, status, headers) {
                resolve(response);
            })
            .error(function (response, status, headers) {
                reject(response);
            });
        });
    };

    service.getEventsRelated = function (eventId) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_EVENTS_V2'] + eventId + '/related',
                method: 'GET',
            })
            .success(function (response, status, headers) {
                resolve(response);
            })
            .error(function (response, status, headers) {
                reject(response);
            });
        });
    };

    service.getEventById = function (eventId) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_EVENTS_V2'] + eventId,
                method: 'GET',
            })
            .success(function (response, status, headers) {
                resolve(response);
            })
            .error(function (response, status, headers) {
                reject(response);
            });
        });
    };


    return service;
}
angular
.module('dashboard')
.factory('EventsFactory', EventsFactory)

EventsFactory.$inject = ['$http', '$localStorageService', 'BaseUrl'];

  function EventsFactory ($http, $localStorageService, BaseUrl) {

    var service = {};

    service.getAllByFilters = function(f) {
      f = f || {};
      var rQuery = f.query || '',
          rPage = f.page,
          rItemsPerPage = f.itemsPerPage,
          rSortBy = f.sortBy || 'criticality',
          rFilterBy = f.filterBy || '',
          rSort = f.sort || 'desc',
          rStartDate = f.startDate || (new Date(0)),
          rEndDate = f.endDate || (new Date(Date.now()));

      moment().local();
      rStartDate = moment(rStartDate).format();
      rEndDate = moment(rEndDate).format();

      return new Promise(function(resolve, reject){
        $http({
          url: BaseUrl.path['URL_EVENTS_ALL_BY_FILTERS'],
          method: 'POST',
          data:{
            "sortBy":{
              "name": "eventId",
              "type": "integer",
              "metadata": "true"
            },
            "sort": "desc",
            "startDate": "2018-12-01T09:00:00.000Z",
            "endDate": "2019-12-10T09:00:00.000Z",
            "filters":[
              {
                "name": "eventId",
                "type": "integer",
                "metadata": "true",
                "operation":">=",
                "value": "1"
              }
            ],
            "pagination":{
              "page": "1",
              "itemsPerPage": 10
            },
            "schemaIds": [5]
          },
        })
            .success(function(response, status, headers){
              resolve({
                events: service.correctSummary(response.events),
                pagination: response.pagination
              });
            })
            .error(function(response, status, headers){
              reject(response);
            });
      });
    };

    service.getSummary = function(f) {
      f = f || {};
      var rQuery = f.query || '',
          rPage = f.page,
          rItemsPerPage = f.itemsPerPage,
          rSortBy = f.sortBy || 'criticality',
          rFilterBy = f.filterBy || '',
          rSort = f.sort || 'desc',
          rStartDate = f.startDate || (new Date(0)),
          rEndDate = f.endDate || (new Date(Date.now()));

          moment().local();
          rStartDate = moment(rStartDate).format();
          rEndDate = moment(rEndDate).format();

      return new Promise(function(resolve, reject){
        $http({
          url: BaseUrl.path['URL_EVENTS_SUMMARY'],
          method: 'GET',
          params: {
            query: rQuery,
            page: rPage,
            itemsPerPage: rItemsPerPage,
            sortBy: rSortBy,
            filterBy: rFilterBy,
            sort: rSort,
            startDate: rStartDate,
            endDate: rEndDate
          },
        })
        .success(function(response, status, headers){
          resolve({
            events: service.correctSummary(response.events),
            pagination: response.pagination
          });
        })
        .error(function(response, status, headers){
          reject(response);
        });
      });
    };

    service.correctSummary = function(summary) {
      var res = [];
      summary.forEach(function(e){
        var timestamp = moment(e.timestamp);
        res.push({
          id: e.id,
          fecha: timestamp.local().format('DD/MM/YYYY HH:mm:ss'),
          //hora: timestamp.local().format('HH:mm:ss'),
          tipo: e.labels[0] || '',
          criticidad: e.criticality,
          estadoCaso: e.caseStatus,
          parameters: e.eventBody ? e.eventBody.entry : undefined,
          estado: e.status,
          visto: e.checked,
          descripcionRegla: e.ruleDescription,
          descripcionReglaTooltip: '#'+e.ruleCode,//+':'+e.ruleDescription,
          nombreRegla: e.ruleName
        });
      });
      return res;
    };

    service.getRelatedEvents = function(id) {
      return new Promise(function(resolve, reject){
        $http({
          method: 'GET',
          url: BaseUrl.urlEventRelatedEvents(id),
        })
        .success(function(response, status, headers){
          resolve(service.correctRelatedEvents(response));
        })
        .error(function(response, status, headers){
          reject(response);
        });
      });
    };

    service.correctRelatedEvents = function(data) {
      var res = [];
      data.forEach(function(obj){
        var timestamp = moment(obj.timestamp);
        var params = [];
        obj.eventBody.entry.forEach(function(param){
          params.push({
            key: param.key,
            value: param.value
          });
        });

        res.push({
          id: obj.id,
          fecha: timestamp.format('DD/MM/YYYY'),
          hora: timestamp.format('HH:mm:ss'),
          tipo: obj.labels[0] || '',
          criticidad: obj.criticality,
          params: params
        });
      });
      return res;
    };

    service.checkEvent = function(c) {
      return new Promise(function(resolve, reject){
        $http({
            url: BaseUrl.urlCheckEvents(c.id),
            method: 'PUT',
            data: c,
        })
        .success(function(response, status, headers){
            resolve(service.correctSummary([response])[0]);
        })
        .error(function(response, status, headers){
            reject(response);
        });
      });
    };

    service.getAggregationQueryData = function() {
      return new Promise(function(resolve, reject){
        $http({
          url: BaseUrl.path['URL_EVENTS_AGGREGATION_DATA'],
          method: 'GET',
        })
        .success(function(response, status, headers){
          resolve(response);
        })
        .error(function(response, status, headers){
          reject(response);
        });
      });
    };

    service.getAggregationDataKeys = function(req) {
      return new Promise(function(resolve, reject){
        $http({
          url: BaseUrl.path['URL_EVENTS_AGGREGATION_KEYS'],
          method: 'POST',
          data: req
        })
        .success(function(response, status, headers){
          resolve(response);
        })
        .error(function(response, status, headers){
          reject(response);
        });
      });
    };

    service.getAggregatedEvents = function(req) {
      return new Promise(function(resolve, reject){
        $http({
          url: BaseUrl.path['URL_EVENTS_AGGREGATION'],
          method: 'POST',
          data: req,
        })
        .success(function(response, status, headers){
          resolve(response);
        })
        .error(function(response, status, headers){
          reject(response);
        });
      });
    };

    return service;
  }
angular
  .module("dashboard")
  .factory("EthicalPortalFactory", EthicalPortalFactory);

EthicalPortalFactory.$inject = ["$http", "$localStorageService", "BaseUrl"];

function EthicalPortalFactory($http, $localStorageService, BaseUrl) {
  var service = {};
  /**
   * getCompanies
   * @returns
   */
  service.getAllCompanies = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["ETHICAL_PORTAL"] + "/companies",
        method: "GET",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  service.createCompany = function (company) {
    var companyCopy = angular.copy(company);
    companyCopy.complaintForm = JSON.stringify(companyCopy.complaintForm);
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["ETHICAL_PORTAL"] + "/companies",
        method: "POST",
        data: companyCopy,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  /**
   * getCompanyById
   * @param {String} companyId
   * @returns
   */
  service.getCompanyById = function (companyId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["ETHICAL_PORTAL"] + "/companies/" + companyId,
        method: "GET",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  /**
   * updateCompany
   * @param {NUmber} id
   * @param {Object} company
   * @returns
   */
  service.updateCompany = function (company) {
    var companyCopy = angular.copy(company);
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["ETHICAL_PORTAL"] + "/companies/",
        method: "PUT",
        data: companyCopy,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  service.addDocumentCompany = function (document) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["ETHICAL_PORTAL_V3"] + "/documents",
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: document,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  service.updateLogoCompany = function (logo) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["ETHICAL_PORTAL_V3"] + "/documents/logo",
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: logo,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  service.getLogoCompany = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["ETHICAL_PORTAL_V3"] + "/documents/logo?base64=true",
        method: "GET",
        // headers:{
        //   Accept: "image/*",
        // },
        // responseType: 'blob',
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  /**
   * deleteCompany
   * @param {Number} companyId
   * @returns
   */
  service.deleteCompany = function (companyId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["ETHICAL_PORTAL"] + "/companies/" + companyId,
        method: "DELETE",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  /**
   * createCompanyComplaint
   * @param {Object} company
   * @returns
   */
  service.createCompanyComplaint = function (company) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["ETHICAL_PORTAL"] +
          "/companies/" +
          company.name +
          "/complaint",
        method: "POST",
        data: company,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  /**
   * updateCompanyComplaintForm
   * @param {Object} complaintForm
   * @returns
   */
  service.updateCompanyComplaintForm = function (complaintForm) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["ETHICAL_PORTAL"] + "/companies/complaint-form",
        method: "POST",
        data: JSON.stringify(complaintForm),
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  /**
   * getCompanyComplaintForm
   * @param {Object} company
   * @returns
   */
  service.getCompanyComplaintForm = function (company) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["ETHICAL_PORTAL"] +
          "/companies/" +
          company.name +
          "/complaint-form",
        method: "GET",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  /**
   * comfirmComplaint
   * @param {String} companyName
   * @param {Number} complaintId
   * @returns
   */
  service.comfirmComplaint = function (companyName, complaintId) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["ETHICAL_PORTAL"] +
          "/companies/" +
          companyName +
          "/complaint" +
          complaintId +
          "/confirm",
        method: "PUT",
        data: companie,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  /**
   * @param {String} companyName
   * @param {Number} complaintId
   * @param {Object} data
   */
  service.addFileToComplaint = function (companyName, complaintId, data) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["ETHICAL_PORTAL"] +
          "/companies/" +
          companyName +
          "/complaint" +
          complaintId +
          "/file",
        method: "POST",
        data: data,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  /**
   * addDocumentToComplaint
   * @param {String} companyName
   * @param {Number} complaintId
   * @param {{name:String,creationDate:String,readDate:String,modificationDate:String,type:String,parameters:[String],size:Number,fileName:String }} data
   */
  service.addDocumentToComplaint = function (companyName, complaintId, data) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["ETHICAL_PORTAL_V3"] +
          "/companies/" +
          companyName +
          "/complaint" +
          complaintId +
          "/document",
        method: "POST",
        data: data,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  /**
   * downloadDocument
   * @param {String} companyName
   * @param {String} documentName
   * @returns
   */
  service.downloadDocument = function (documentName) {
    console.log(documentName);
    window.open(
      BaseUrl.path["ETHICAL_PORTAL_V3"] +
        "/documents/" +
        documentName +
        "/download",
      "_blank"
    );
  };
  /**
   * deleteDocument
   * @param {String} companyName
   * @param {String} documentName
   * @returns
   */
  service.deleteDocument = function (documentName) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["ETHICAL_PORTAL"] + "/documents/" + documentName,
        method: "DELETE",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  /**
   * @param {String}
   * @param {{name:String,creationDate:String,readDate:String,modificationDate:String,type:String,parameters:[String],size:Number,fileName:String }}
   */
  service.addCompanyLogo = function (companyName, data) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["ETHICAL_PORTAL"] +
          "/companies/" +
          companyName +
          "/logo",
        method: "POST",
        data: data,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  /**
   * @param {String}
   */
  service.getCompanyLogo = function (companyName) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["ETHICAL_PORTAL"] +
          "/companies/" +
          companyName +
          "/logo",
        method: "GET",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  /**
   * @param {String}
   */
  service.getCompanyStatistics = function (companyName) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["ETHICAL_PORTAL"] +
          "/companies/" +
          companyName +
          "/statistics",
        method: "GET",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  /**
   * @param {String}
   */
  service.getIssue = function (uuid) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["ETHICAL_PORTAL"] + "/complaint/" + uuid,
        method: "GET",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  /**
   *
   * @param {String} uuid
   * @param {{comment:String}} data
   * @returns {{Promise}}
   */
  service.addComplaintComments = function (uuid, data) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["ETHICAL_PORTAL"] + "/complaint/" + uuid + "/comment",
        method: "POST",
        data: data,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  service.getComplaintComments = function (uuid) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["ETHICAL_PORTAL"] + "/complaint/" + uuid + "/comment",
        method: "GET",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };
  /**
   *
   * @param {{plan: String,client: String,email: String,phone: String,company: String}}
   * @returns {Promise}
   */
  service.sendQuote = function (data) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["ETHICAL_PORTAL"] + "/quote",
        method: "POST",
        data: data,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  return service;
}

angular
.module('dashboard')
.factory('DomainFactory', DomainFactory)

DomainFactory.$inject = ['$http', '$localStorageService', 'BaseUrl'];

    function DomainFactory($http, $localStorageService, BaseUrl) {
        var service = {};

        service.getDomains = function () {
            return new Promise(function (resolve, reject) {
                $http({
                    url: BaseUrl.path['URL_DOMAINS'],
                    method: 'GET',
                })
                .success(function (response, status, headers) {
                    resolve(response);
                })
                .error(function (response, status, headers) {
                    reject(response);
                });
            });
        };

        return service;
    }
angular.module("dashboard").factory("DocumentsFactory", DocumentsFactory);

DocumentsFactory.$inject = ["$http", "$state", "$localStorageService", "BaseUrl"];

function DocumentsFactory($http, $state, $localStorageService, BaseUrl) {
  var service = {};

  service.getAllDocumentsUser = function (pagination) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["DOCUMETS"],
        method: "GET",
        params: pagination,
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.DownloadDocument = function (token) {
    return new Promise(function (resolve, reject) {
      if (!token) {
        reject("Token is required to download the document");
        return;
      }

      window.open(BaseUrl.path["DOCUMETS"] + token + "/download", "_blank");
      setTimeout(function () {
        resolve("Document downloaded successfully");
      }, 200);
    });
  };

  service.cleanDocuments = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["DOCUMETS"] + "clean",
        method: "POST",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  return service;
}

angular.module("dashboard").factory("DataTableFactory", DataTableFactory);

DataTableFactory.$inject = ["$http", "BaseUrl"];

function DataTableFactory($http, BaseUrl) {
  var service = {};

  service.getAllSchemas = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_TABLES"] + "/schemas",
        method: "GET",
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.getAllTablesBySchemasName = function (schemaName) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_TABLES"] + "schemas/" + schemaName,
        method: "GET",
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.getTable = function (tableName, schemaName) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_TABLES"] + tableName + "/schemas/" + schemaName,
        method: "GET",
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.getTableFilters = function (tableName, schemaName) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["URL_TABLES"] +
          tableName +
          "/schemas/" +
          schemaName +
          "/filters",
        method: "GET",
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.getDataTable = function (
    tableName,
    schemaName,
    pagination,
    predicates,
    exportToCSV
  ) {
    return new Promise(function (resolve, reject) {
      var configRequest = {
        url:
          BaseUrl.path["URL_TABLES"] +
          tableName +
          "/schemas/" +
          schemaName +
          "/custom-filter",
        method: "POST",
        data: {
          pagination: pagination,
          exportToCSV: exportToCSV ? true : false,
          predicates: predicates,
        },
      };
      // if (exportToCSV) {
      //   configRequest = Object.assign(configRequest, {
      //     responseType: 'string',
      //     headers: {
      //       Accept: 'text/plain',
      //     },
      //   });
      // }
      $http(configRequest)
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.updateTableData = function (tableName, schemaName, records) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["URL_TABLES"] +
          tableName +
          "/schemas/" +
          schemaName +
          "/data/update",
        method: "POST",
        data: records,
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.deleteTableData = function (tableName, schemaName, deleteRows) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["URL_TABLES"] +
          tableName +
          "/schemas/" +
          schemaName +
          "/data/delete",
        method: "POST",
        data: deleteRows,
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.insertTableData = function (tableName, schemaName, insertRows) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["URL_TABLES"] +
          tableName +
          "/schemas/" +
          schemaName +
          "/data/insert",
        method: "POST",
        data: insertRows,
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.getTable = function (tableName, schemaName) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_TABLES"] + tableName + "/schemas/" + schemaName,
        method: "GET",
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.createTable = function (newTable) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_TABLES"],
        method: "POST",
        data: newTable,
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.updateTable = function (tableName, schemaName, table) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_TABLES"] + tableName + "/schemas/" + schemaName,
        method: "PUT",
        data: table,
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.removeTable = function (tableName, schemaName) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_TABLES"] + tableName + "/schemas/" + schemaName,
        method: "DELETE",
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };
  service.truncateTable = function (tableName, schemaName) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["URL_TABLES"] +
          tableName +
          "/schemas/" +
          schemaName +
          "/truncate",
        method: "PUT",
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };
  service.replaceWith = function (tableName, schemaName, body) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["URL_TABLES"] +
          tableName +
          "/schemas/" +
          schemaName +
          "/data/replace-with",
        method: "PUT",
        data: body,
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };
  service.searchLookupMatch = function (
    tableName,
    schemaName,
    fieldName,
    value,
    filters
  ) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["URL_TABLES"] +
          tableName +
          "/schemas/" +
          schemaName +
          "/field/" +
          fieldName +
          "/value/" +
          value +
          "/lookup",
        data: filters,
        method: "POST",
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  return service;
}

angular
    .module('dashboard')
    .factory('DataConnFactory', DataConnFactory)

DataConnFactory.$inject = ['$http', 'BaseUrl'];

function DataConnFactory ($http, BaseUrl) {
    var service = {};
    
    service.getProtocols = function () {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_DATACONN_PROTOCOLS'],
                method: 'GET',
            }).success(function (response, status, headers) {
                resolve(response);
            })
            .error(function (response, status, headers) {
                reject(response);
            });
        });
    };

    service.createConnection = function (request) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_DATACONN'],
                method: request.id ? 'PUT' : 'POST', // UPDATES OR CREATES
                data: request
            }).success(function (response, status, headers) {
                resolve(response);
            })
            .error(function (response, status, headers) {
                reject(response);
            });
        });
    };

    service.getConnections = function () {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_DATACONN'],
                method: 'GET'
            }).success(function (response, status, headers) {
                resolve(response);
            })
            .error(function (response, status, headers) {
                reject(response);
            });
        });
    };
    
    service.deleteConnection = function (id) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.urlDataConn(id),
                method: 'DELETE'
            })
            .success(function (response, status, headers) {
                resolve(response);
            })
            .error(function (response, status, headers) {
                reject(response);
            });
        });
    };

    service.testConnection = function (id) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.urlTestDataConn(id),
                method: 'GET',
                transformResponse: function(res){
                    return res;
                }
            })
            .success(function (response, status, headers) {
                resolve(response);
            })
            .error(function (response, status, headers) {
                reject(response);
            });
        });
    };
    
    return service;
}
angular.module("dashboard").factory("DashboardFactory", DashboardFactory);

DashboardFactory.$inject = ["$http", "$localStorageService", "BaseUrl"];

function DashboardFactory($http, $localStorageService, BaseUrl) {
  var service = {};

  service.getDashboard = function (startDate, endDate) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_DASHBOARD"],
        method: "GET",
        params: {
          startDate: encodeURI(startDate.toISOString()),
          endDate: encodeURI(endDate.toISOString()),
        },
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.getWorkQueue = function (c) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/dashboard/work-queue",
        method: "GET",
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response, status) {
          reject(Object.assign(response, { status: status }));
        }
      );
    });
  };

  service.removeTaskFromQueue = function (canonicalName) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/dashboard/work-queue/" + canonicalName,
        method: "DELETE",
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  return service;
}

angular.module("dashboard").factory("CustomReportFactory", CustomReportFactory);

CustomReportFactory.$inject = ["$http", "BaseUrl", "CustomReportService"];

function CustomReportFactory($http, BaseUrl, $customReportService) {
  var service = {};

  service.getCustomReports = function (params) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_CUSTOM_REPORTS"],
        method: "GET",
        params: params
          ? params
          : {
              itemsPerPage: 999,
            },
      })
        .success(function (response, status, headers) {
          resolve(response, status);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.getCustomReportById = function (id) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_CUSTOM_REPORTS"] + "/" + id,
        method: "GET",
        params: {
          itemsPerPage: 999,
        },
      })
        .success(function (response, status, headers) {
          resolve(response, status);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.createCustomReport = function (report) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_CUSTOM_REPORTS"],
        method: "POST",
        data: report,
      })
        .success(function (response, status, headers) {
          //share permissions with user groups
          $customReportService.createCustomReportAcl(response);
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(Object.assign({}, { response: response, status: status }));
        });
    });
  };

  service.editCustomReport = function (id, report) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_CUSTOM_REPORTS"] + "/" + id,
        method: "PUT",
        data: report,
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(Object.assign({}, { response: response, status: status }));
        });
    });
  };

  service.deleteCustomReport = function (reportId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_CUSTOM_REPORTS"] + "/" + reportId,
        method: "DELETE",
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(Object.assign({}, { response: response, status: status }));
        });
    });
  };

  service.getAllFilesInFolder = function (folderName, filters) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_FILE_STORAGE_FOLDER"] + "/" + folderName + "/file",
        params: filters,
        method: "GET",
      })
        .success(function (response) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(Object.assign({}, { response: response, status: status }));
        });
    });
  };

  service.getFolderByID = function (id) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_FILE_STORAGE_FOLDER"] + "/" + id,
        method: "GET",
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(Object.assign({}, { response: response, status: status }));
        });
    });
  };

  service.downloadFile = function (id, folderNameOrID, fileName) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["URL_CUSTOM_REPORTS"] +
          "/" +
          id +
          "/storage/folder/" +
          folderNameOrID +
          "/file/" +
          fileName +
          "/download",
        method: "GET",
        responseType: "blob",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.uploadFile = function (id, folderNameOrID) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_CUSTOM_REPORTS"] + "/" + id + "/storage/folder/" + folderNameOrID,
        method: "POST",
      })
        .success(function (response, status, headers) {
          resolve(response.data);
        })
        .error(function (response, status, headers) {
          reject(Object.assign({}, { response: response, status: status }));
        });
    });
  };

  service.moveFileToTrash = function (folderID, fileID) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["URL_CUSTOM_REPORTS"] +
          "/folder/" +
          folderID +
          "/file/" +
          fileID +
          "/move-to-trash",
        method: "PUT",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.createFolder = function (folder) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path["URL_FILE_STORAGE_FOLDER"],
        method: "POST",
        data: folder,
      })
        .success(function (response) {
          
          $customReportService.createCustomReportFolder(response);
          resolve(response);
        })
        .error(function (response) {
          reject(response);
        });
    });
  };

  service.exportToPdf = function (customReportId, recordId, folderName, key, tabs) {
    return new Promise(function (resolve, reject) {
      $http({
        url:
          BaseUrl.path["URL_CUSTOM_REPORTS"] +
          "/" +
          customReportId +
          "/data/" +
          recordId +
          "/folder/" +
          folderName +
          "/key/" +
          key +
          "/export-to-pdf/?" +
          tabs,
        method: "GET",
        // data: html,
        headers: {
          "Content-Type": "text/plain;charset=UTF-8",
        },
        responseType: "blob",
      })
        .success(function (response, status, headers) {
          resolve(response.data);
        })
        .error(function (response, status, headers) {
          reject(Object.assign({}, { response: response, status: status }));
        });
    });
  };

  return service;
}

angular
  .module('dashboard')
  .factory('ConfigurationFactory', ConfigurationFactory);

ConfigurationFactory.$inject = ['$http', '$localStorageService', 'BaseUrl'];

function ConfigurationFactory($http, $localStorageService, BaseUrl) {
  var service = {};

  service.create = function (object) {
    return new Promise(function (resolve, reject) {
      $http({
        url: '/risk-backend/rest/config/system',
        method: 'POST',
        data: object,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.delete = function (id) {
    return new Promise(function (resolve, reject) {
      $http({
        url: '/risk-backend/rest/config/system/' + id,
        method: 'DELETE',
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getAllConfigurations = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: '/risk-backend/rest/config/system',
        method: 'GET',
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getGlobalConfiguration = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: '/risk-backend/rest/config/system/global',
        method: 'GET',
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.createKeyStorage = function (object) {
    return new Promise(function (resolve, reject) {
      $http({
        url: '/risk-backend/rest/config/keystorage',
        method: 'POST',
        data: object,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.updateKeyStorage = function (object) {
    return new Promise(function (resolve, reject) {
      $http({
        url: '/risk-backend/rest/config/keystorage',
        method: 'PUT',
        data: object,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.deleteKeyStorage = function (path) {
    return new Promise(function (resolve, reject) {
      $http({
        url: '/risk-backend/rest/config/keystorage/' + path,
        method: 'DELETE',
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getSchemaFormat = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: '/risk-backend/rest/config/system/level-icons',
        method: 'GET',
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response, status) {
          reject(Object.assign(response, { status: status }));
        }
      );
    });
  };

  service.createSchemaFormat = function (object) {
    return new Promise(function (resolve, reject) {
      $http({
        url: '/risk-backend/rest/config/system/level-icons',
        method: 'POST',
        data: object,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.updateSchemaFormat = function (object) {
    return new Promise(function (resolve, reject) {
      $http({
        url: '/risk-backend/rest/config/system/level-icons/' + object.id,
        method: 'PUT',
        data: object,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.deleteSchemaFormat = function (id) {
    return new Promise(function (resolve, reject) {
      $http({
        url: '/risk-backend/rest/config/system/level-icons/' + id,
        method: 'DELETE',
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

   service.getPublicKeyRecaptcha = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/documents/recaptcha-sitekey",
        method: "GET",
      }).then(
        function (response) {
          var keys = response.data && Array.isArray(response.data) && response.data.length > 0 ? response.data[0] : {secret:null};
          resolve(keys.secret);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  return service;
}

angular
.module('dashboard')
.factory('CompanyFactory', CompanyFactory)

CompanyFactory.$inject = ['$http', '$localStorageService', 'BaseUrl'];

    function CompanyFactory($http, $localStorageService, BaseUrl) {
        var service = {};

        service.create = function (object) {
            return new Promise(function (resolve, reject) {
                $http({
                    url: '/risk-backend/rest/companies',
                    method: 'POST',
                    data: object,
                }).then(function(response) {
                    resolve(response);
                }, function(response) {
                    reject(response);
                });
            });
        }

        service.edit = function (id, object) {
            return new Promise(function (resolve, reject) {
                $http({
                    url: '/risk-backend/rest/companies/' + id,
                    method: 'PUT',
                    data: object,
                }).then(function(response) {
                    resolve(response);
                }, function(response) {
                    reject(response);
                });
            });
        }

        service.getAllCompanies = function () {
            return new Promise(function (resolve, reject) {
                $http({
                    url: '/risk-backend/rest/companies?active=true&itemsPerPage=100&sortBy=name',
                    method: 'GET'
                }).then(function (response) {
                    resolve(response.data);
                }, function (response) {
                    reject(response);
                });
            });
        }

        service.createHome = function (companyName) {
            return new Promise(function (resolve, reject) {
                $http({
                    url: '/risk-backend/rest/companies/default/' + companyName,
                    method: 'POST'
                }).then(function(response) {
                    resolve(response);
                }, function(response) {
                    reject(response);
                });
            });
        }

        return service;
    }
angular.module('dashboard').factory('CommentsFactory', CommentsFactory);

CommentsFactory.$inject = ['$http', '$state', '$localStorageService', 'BaseUrl'];

function CommentsFactory($http, $state, $localStorageService, BaseUrl) {
  var service = {};

  service.getCommentsByTargetAndId = function (target, id) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_COMMENTS'] + '/' + target + '/' + id,
        method: 'GET',
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.sendCommentByTarget = function (target, id, comment) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_COMMENTS'] + '/' + target + '/' + id,
        method: 'POST',
        data: {
          comment: comment,
          isPrivate: true,
        },
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.deleteCommentByTarget = function (id) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_COMMENTS'] + '/' + id,
        method: 'DELETE',
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  return service;
}

angular.module('dashboard').factory('ChartsFactory', ChartsFactory);

ChartsFactory.$inject = ['$http', 'BaseUrl'];

function ChartsFactory($http, BaseUrl) {
  var service = {};

  service.saveChart = function (chart) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_CHARTS'],
        method: 'POST',
        data: chart,
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.deleteChart = function (chartId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_CHARTS'] + chartId,
        method: 'DELETE',
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.getChartsbyDomain = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_CHARTS'],
        method: 'GET',
        params: {
          sort: 'desc',
        },
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.getChartData = function (chartId, arrfilters, extraConf) {
    // console.warn(chartId);
    // console.warn(arrfilters);
    // console.warn(extraConf);
    var setFilters = arrfilters ? JSON.stringify(arrfilters) : null;
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_CHARTS'] + chartId + '/data',
        method: 'GET',
        params: {
          filters: setFilters,
          extraConf: extraConf,
        },
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(Object.assign(response, { status: status }));
        });
    });
  };
  service.getChartFilters = function (chartId) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_CHARTS'] + chartId + '/filters',
        method: 'GET',
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  return service;
}

angular
    .module('dashboard')
    .factory('CaseUserFactory', CaseUserFactory)

CaseUserFactory.$inject = ['$http', '$state', '$localStorageService', 'BaseUrl'];

function CaseUserFactory($http, $state, $localStorageService, BaseUrl) {
    var service = {};

    // Cases
    service.create = function (c) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_CASES_CREATE'] + '/' + c.caseId + '/guest-users',
                method: 'POST',
                data: c,
            }).then(function (response) {
                resolve(response);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.get = function (caseId) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_CASES_CREATE'] + '/' + caseId + '/guest-users',
                method: 'GET'
            }).then(function (response) {
                resolve(response.data);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.delete = function (caseId, userId) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_COMMENT_LIST'] + '/' + caseId + '/guest-users/' + userId,
                method: 'DELETE',
            })
                .then(function (response) {
                    resolve(response);
                }, function (response) {
                    reject(response);
                });
        });
    };

    return service;
}

angular
    .module('dashboard')
    .factory('CaseFactory', CaseFactory)

CaseFactory.$inject = ['$http', '$state', '$localStorageService', 'BaseUrl'];

function CaseFactory($http, $state, $localStorageService, BaseUrl) {
    var service = {};

    // Cases
    service.createCase = function (c) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_CASES_CREATE'],
                method: 'POST',
                data: c
            }).then(function (response) {
                resolve(response);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.updateCase = function (c) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_CASES_CREATE'] + '/' + c.id,
                method: 'PUT',
                data: c                
            }).then(function (response) {
                resolve(response);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.deleteEvent = function (c) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_COMMENT_LIST'] + '/' + c.id + '/events/' + c.eventId,
                method: 'DELETE'
            }).then(function (response) {
                resolve(response);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.updateStatusCase = function (caseId, status, reason) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_CASES_CREATE'] + '/' + caseId + '/status/' + status + (angular.isDefined(reason) ? '?reason=' + reason : ''),
                method: 'PUT'
            }).then(function (response) {
                resolve(response);
            }, function (response) {
                reject(response);
            });
        });
    };

    // Comments
    service.createComment = function (c) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_COMMENT_LIST'] + '/' + c.id + '/createComment',
                method: 'POST',
                data: c
            }).then(function (response) {
                resolve(response.data);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.getComments = function (id) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_COMMENT_LIST'] + '/' + id + '/comments',
                method: 'GET'
            }).then(function (response) {
                resolve(response.data);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.uploadComment = function (c) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_COMMENT_LIST'] + '/' + c.id + '/updateComment/' + c.caseId,
                method: 'PUT',
                data: c,
            })
                .then(function (response) {
                    resolve(response);
                }, function (response) {
                    reject(response);
                });
        });
    };

    service.deleteComment = function (c) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_COMMENT_LIST'] + '/' + c.caseId + '/deleteComment/' + c.id + '?justified=' + c.justified,
                method: 'DELETE'
            })
                .then(function (response) {
                    resolve(response);
                }, function (response) {
                    reject(response);
                });
        });
    };

    // Files
    service.getFiles = function (c) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_UP_FILE'] + '/' + c.id + '/file',
                method: 'GET',
            }).then(function (response) {
                resolve(response.data);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.uploadFile = function (c) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_UP_FILE'] + '/' + c.id,
                method: 'POST',
                data: c,
            }).then(function (response) {
                resolve(response);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.downloadFile = function (c) {
        return new Promise(function (resolve, reject) {
            delete $http.defaults.headers.common['X-Requested-With'];
            $http({
                url: BaseUrl.path['URL_UP_FILE'] + '/' + c.id + '/file/' + c.fileId,
                method: 'GET',
                data: c,
                responseType: "blob",
            }).then(function (response) {
                resolve(response);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.deleteFile = function (c) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_COMMENT_LIST'] + '/' + c.caseId + '/file/' + c.id + '?justified=' + c.justified,
                method: 'DELETE'
            })
                .then(function (response) {
                    resolve(response);
                }, function (response) {
                    reject(response);
                });
        });
    };

    // Events
    service.getRelatedEvents = function (id) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.urlCaseRelatedEvents(id),
                method: 'GET',
                params: {
                    id: id
                },
            })
                .then(function (response) {
                    resolve(response);
                }, function (response) {
                    reject(response);
                });
        });
    };

    service.upsertEvents = function (id, newEvents, done) {
        var add = [];
        var rem = [];
        service.getRelatedEvents(id).then(function (rEvents) {
            Object.keys(newEvents).forEach(function (ne) {
                var found = false;
                rEvents.forEach(function (re) {
                    if (re.id == ne) {
                        found = true;
                    }
                });
                if (found && !newEvents[ne]) {
                    rem.push(ne);
                }
                if (!found && newEvents[ne]) {
                    add.push(ne);
                }
            });
            var promises = [];

            promises.push(new Promise(function (resolve, reject) {
                var addArr = [];
                add.forEach(function (a) {
                    addArr.push({eventId: a});
                });
                $http({
                    url: BaseUrl.urlCaseRelatedEvents(id),
                    method: 'POST',
                    data: addArr,
                })
                    .success(function (response, status, headers) {
                        resolve(response);
                    })
                    .error(function (response, status, headers) {
                        reject(response);
                    });
            }));

            rem.forEach(function (r) {
                promises.push(new Promise(function (resolve, reject) {
                    $http({
                        url: BaseUrl.urlCaseRelatedEvents(id) + '/' + r,
                        method: 'DELETE',
                    })
                        .success(function (response, status, headers) {
                            resolve(response);
                        })
                        .error(function (response, status, headers) {
                            reject(response);
                        });
                }));
            });

            Promise.all(promises).then(function (responses) {
                done(responses);
            });

        });

    };

    service.correctRelatedEvents = function (summary) {
        var res = [];
        summary.forEach(function (e) {
            var timestamp = moment(e.timestamp)

            res.push({
                id: e.id,
                nombre: e.ruleName,
                descripcion: e.ruleDescription,
                fecha: timestamp.format('D MMM YYYY, h:mm a'),
                hora: timestamp.format('HH:mm:ss'),
                // tipo: e.labels[0] || '',
                criticidad: e.criticality,
                estadoCaso: e.caseStatus
            });
        });
        return res;
    };

    // Summary
    service.getSummary = function (f) {
        f = f || {};
        var rQuery = f.query || '',
            rPage = f.page || 1,
            rItemsPerPage = f.itemsPerPage || 20,
            rSortBy = f.sortBy,
            rSort = f.sort || 'desc',
            rStartDate = f.startDate || (new Date(0)).toISOString(),
            rEndDate = f.endDate || (new Date(Date.now())).toISOString(),
            rState = f.state || null;

        rStartDate = moment(rStartDate).toISOString();
        rEndDate = moment(rEndDate).toISOString();

        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_CASES_SUMMARY'],
                method: 'GET',
                params: {
                    query: rQuery,
                    page: rPage,
                    itemsPerPage: rItemsPerPage,
                    sortBy: rSortBy,
                    sort: rSort,
                    startDate: rStartDate,
                    endDate: rEndDate,
                    state: rState
                },
            })
                .success(function (response, status, headers) {
                    resolve(response);
                })
                .error(function (response, status, headers) {
                    reject(Object.assign(response, { status: status }));
                });
        });
    };

    /**
     * @deprecated
     */
    service.correctSummary = function (summary) {
        var res = [];
        summary.forEach(function (e) {
            var timestamp = moment(e.creationDate);

            var tmpCase = {
                id: e.caseId,
                titulo: e.title,
                descripcion: e.description,
                estado: e.state,
                fecha: timestamp.format('DD/MM/YYYY'),
                hora: timestamp.format('HH:mm:ss'),
                criticidad: e.criticality
            }
            if(e.assigned != null || angular.isDefined(e.assigned)) {
                tmpCase.usuario = {
                    id: e.assigned.userId,
                    username: e.assigned.username,
                    email: e.assigned.email,
                    nombre: e.assigned.name
                };
            }
            if(e.group != null || angular.isDefined(e.group)) {
                tmpCase.group = {
                    id: e.group.id,
                    name: e.group.name
                };
            }
            res.push(tmpCase);
        });
        return res;
    };

    // Cases' owner
    service.reassignAssigned = function (caseId, userId, note) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_CASES_CREATE'] + '/' + caseId + '/reassign-assigned/' + userId,
                method: 'PUT',
                data: note,
            }).then(function (response) {
                resolve(response.data);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.deleteReassignAssigned = function (caseId) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_CASES_CREATE'] + '/' + caseId + '/reassign-assigned',
                method: 'DELETE'
            }).then(function (response) {
                resolve(response.data);
            }, function (response) {
                reject(response);
            });
        });
    };

    // Cases' owner
    service.reassignGroup = function (caseId, groupId, note) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_CASES_CREATE'] + '/' + caseId + '/reassign-group/' + groupId,
                method: 'PUT',
                data: note,
            }).then(function (response) {
                resolve(response.data);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.deleteReassignGroup = function (caseId) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_CASES_CREATE'] + '/' + caseId + '/reassign-group',
                method: 'DELETE'
            }).then(function (response) {
                resolve(response.data);
            }, function (response) {
                reject(response);
            });
        });
    };

    service.addEvents = function (caseId, eventsId) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.urlCaseRelatedEvents(caseId),
                method: 'POST',
                data: eventsId,
            })
                .then(function (response) {
                    resolve(response.data);
                }, function (response) {
                    reject(response);
                });
        });
    };

    service.exportCase = function (caseId) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_UP_FILE'] + '/' + caseId + '/export',
                method: 'GET',
                responseType: "arraybuffer",
            }).then(function (response) {
                resolve(response.data);
            }, function (response) {
                reject(response);
            });
        });
    };

    return service;
}

angular.module('dashboard').factory('CaseCommentsFactory', CaseCommentsFactory);

CaseCommentsFactory.$inject = ['$localStorageService'];

function CaseCommentsFactory($localStorageService) {
  return {
    result: false,
    // socket: io('/wsCasos')
  };
}

angular
.module('dashboard')
.factory('AutocompleteFactory', AutocompleteFactory)

AutocompleteFactory.$inject = ['$http', '$localStorageService', 'BaseUrl'];

    function AutocompleteFactory($http, $localStorageService, BaseUrl) {
        var service = {};

        service.getValues = function (target, targetIds, key, textValue) {
            return new Promise(function (resolve, reject) {
                $http({
                    url: '/risk-backend/rest/autocomplete/' + target + '/field/' + key + '/values',
                    method: 'GET',
                    params: {
                        targetId: targetIds,
                        filterValue: textValue,
                    }
                    //cache: true
                })
                .success(function (response, status, headers) {
                    resolve(response);
                })
                .error(function (response, status, headers) {
                    reject(response);
                });
            });
        };
        return service;
    }

angular.module('dashboard').factory('AuditFactory', AuditFactory);

AuditFactory.$inject = [
  '$http',
  '$state',
  '$localStorageService',
  'BaseUrl',
  'moment',
];

function AuditFactory($http, $state, $localStorageService, BaseUrl, moment) {
  var service = {};

  service.findAudits = function (paramQuery) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_AUDITORIA'],
        method: 'GET',
        params: paramQuery,
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  service.getAudit = function (paramQuery) {
    return new Promise(function (resolve, reject) {
      $http({
        url: BaseUrl.path['URL_AUDITORIA'],
        method: 'POST',
        data: paramQuery,
      })
        .success(function (response, status, headers) {
          resolve(response);
        })
        .error(function (response, status, headers) {
          reject(response);
        });
    });
  };

  return service;
}

angular
.module('dashboard')
.factory('AlertManagementFactory', AlertManagementFactory)

AlertManagementFactory.$inject = ['$http', '$localStorageService', 'BaseUrl'];

function AlertManagementFactory($http, $localStorageService, BaseUrl) {
    var service = {};

    service.getReports = function () {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_REPORT'],
                method: 'GET',
                // params: {
                //     page: null,
                //     itemsPerPage: null,
                // }
            })
            .success(function (response, status, headers) {
                resolve(response);
            })
            .error(function (response, status, headers) {
                reject(response);
            });
        });
    };

    service.getReportMetaData = function () {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_REPORT_METADATA'],
                method: 'GET',
            })
            .success(function (response, status, headers) {
                resolve(response);
            })
            .error(function (response, status, headers) {
                reject(response);
            });
        });
    };

    service.getReportById = function (id) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.urlReport(id),
                method: 'GET',
            })
            .success(function (response, status, headers) {
                resolve(response);
            })
            .error(function (response, status, headers) {
                reject(response);
            });
        });
    };
   
    service.setReport = function (req) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_REPORT'],
                method: 'POST',
                data: {
                  "id": req.id,
                  "reportId": req.reportId,
                  "conf": req.conf
                },
               
            })
            .success(function (response, status, headers) {
                resolve(response);
            })
            .error(function (response, status, headers) {
                reject(response);
            });
        });
    }

    service.getReport = function (req) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_REPORT'],
                method: 'GET',
               
            })
            .success(function (response, status, headers) {
                resolve(response);
            })
            .error(function (response, status, headers) {
                reject(response);
            });
        });
    }

    service.getReportCount = function (id,request) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.urlReportDashboard(id),
                method: 'GET',
                params: {
                    startDate: request.startDate,
                    endDate: request.endDate
                },
                headers: {
                    token: $localStorageService.getItem("currentUser.tokenInfo.token")
                }
            })
            .success(function (response, status, headers) {
                resolve(response);
            })
            .error(function (response, status, headers) {
                reject(response);
            });
        });
    };

    service.resetReportByID = function (reportID) {
        return new Promise(function (resolve, reject) {
            $http({
                url: BaseUrl.path['URL_REPORT']+'/'+reportID+'/reset',
                method: 'GET'
            })
            .success(function (response, status, headers) {
                resolve(response);
            })
            .error(function (response, status, headers) {
                reject(response);
            });
        });
    };

    

    return service;
}
angular.module("dashboard").factory("AclFactory", AclFactory);

AclFactory.$inject = ["$http", "$localStorageService", "BaseUrl"];

function AclFactory($http, $localStorageService, BaseUrl) {
  var service = {};

  service.validate = function (object) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/acl/config/validate",
        method: "POST",
        data: object,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.create = function (object) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/acl/config",
        method: "POST",
        data: object,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.edit = function (id, object) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/acl/config/" + id,
        method: "PUT",
        data: object,
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.delete = function (id) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/acl/config/" + id,
        method: "DELETE",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getAcls = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/acl/config?sortBy=id&itemsPerPage=100&sort=desc",
        method: "GET",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getAcl = function (id) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/acl/config/" + id,
        method: "GET",
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getPermissions = function () {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/acl/user/permissions",
        method: "GET",
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.createShareEntity = function (resourceName, id, object) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/acl/share-entity/" + resourceName + "/" + id,
        method: "POST",
        data: object,
        headers: {
          token: $localStorageService.getItem("currentUser.tokenInfo.token"),
        },
      }).then(
        function (response) {
          resolve(response);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.getPermissionsShare = function (resourceName, id) {
    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/acl/share-entity/" + resourceName + "/" + id,
        method: "GET",
        headers: {
          token: $localStorageService.getItem("currentUser.tokenInfo.token"),
        },
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  service.search = function (users, groups, resources, actions, grant) {
    var strUrl = "";
    if (angular.isDefined(users)) {
      strUrl += "users=" + users + "&";
    }
    if (angular.isDefined(groups)) {
      strUrl += "groups=" + groups + "&";
    }
    if (angular.isDefined(resources)) {
      strUrl += "resources=" + resources + "&";
    }
    if (angular.isDefined(actions)) {
      strUrl += "actions=" + actions + "&";
    }
    if (angular.isDefined(grant)) {
      strUrl += "grant=" + grant + "&";
    }

    return new Promise(function (resolve, reject) {
      $http({
        url: "/risk-backend/rest/acl/search?" + strUrl,
        method: "GET",
      }).then(
        function (response) {
          resolve(response.data);
        },
        function (response) {
          reject(response);
        }
      );
    });
  };

  return service;
}

(function () {
  'use strict';

  angular
  .module('dashboard')
  .constant('widgetsDefault', [
    {
      id: 0,
      position : { sizeX: 3, sizeY: 1, row: 0, col: 0, minSizeX: 2, maxSizeX: 3, maxSizeY:2 },
      widget: {
        type: 'counter-box-widget',
        props: { icon:"warning", label:"Visto", counter:0 }
      }
    },
    {
      id: 1,
      position : { sizeX: 3, sizeY: 1, row: 0, col: 3, minSizeX: 2, maxSizeX: 3, maxSizeY:2 },
      widget: {
        type: 'counter-box-widget',
        props: { icon:"error_outline", label:"No Visto", counter:0 }
      }
    },
    {
      id: 2,
      position : { sizeX: 6, sizeY: 3, row: 0, col: 6, minSizeX: 5, minSizeY:2 },
      widget: {
        type: 'executions-widget',
        props: {}
      }
    },
    {
      id: 3,
      position : { sizeX: 6, sizeY: 5, row: 1, col: 0, minSizeX: 5, minSizeY:2 },
      widget: {
        type: 'alerts-chart-widget',
        props: {}
      }
    },
    {
      id: 4,
      position : { sizeX: 6, sizeY: 3, row: 3, col: 6, minSizeX: 5, minSizeY:2 },
      widget: {
        type: 'cases-widget',
        props: {}
      }
    }
  ])
})();

/**
 * Ceptinel base transformation types
 */
(function () {
  'use strict';

  angular.module('dashboard').constant('types', [
    { id: 'autoincrement', type: 'Autoincrement' },
    { id: 'boolean', type: 'Boolean' },
    { id: 'complex', type: 'Complex' },
    { id: 'date', type: 'Date' },
    { id: 'double', type: 'Double' },
    { id: 'integer', type: 'Integer' },
    { id: 'list', type: 'List' },
    { id: 'long', type: 'Long' },
    { id: 'lookup', type: 'Lookup' },
    { id: 'reference', type: 'Reference' },
    { id: 'sequential', type: 'Sequential' },
    { id: 'string', type: 'String' },
    { id: 'time', type: 'Time' },
    { id: 'timestamp', type: 'Timestamp' },
    { id: 'url', type: 'URL' },
  ]);
})();

(function () {
  'use strict';

  angular.module('dashboard').constant('printStyles', {
    css: '<style>* {font-family:helvetica,font-size:11px}; .report .noprint{width:3%}.report span.normal{font-weight:400}.report span.bold{font-weight:700}.report .clearfix::after{content:"";clear:both;display:table}.report img{width:200px!important}.report .flex-container{display:flex;flex-wrap:row}.report .flex-container-wrap{display:flex;flex-wrap:wrap}.report table{border-collapse:collapse;width:100%}.report table,.report td,.report th{border:1px solid #ddd;text-align:left}.report td,.report th{padding:5px}.report tbody tr>td{border:1px solid #ddd!important}.report .gallery{display:flex;flex-flow:wrap;justify-content:center}.report .gallery .desc{padding:15px;text-align:center}.report .gallery .image{width:500px!important}.show-in-print{display:none}@media print{@page{margin:.5cm;position:relative}*{print-color-adjust:exact!important}#mainFooter,#mainHeader,.noprint,custom-report-inbox-menu{width:1%;opacity:0;display:none;position:absolute;right:9999}span.normal{font-weight:400}span.bold{font-weight:700}.clearfix::after{content:"";clear:both;display:table}img{width:200px!important}.flex-container{display:flex;flex-wrap:row}.flex-container-wrap{display:flex;flex-wrap:wrap}.pull-right{float:right!important}table{border-collapse:collapse;width:100%}table,td,th{border:1px solid #ddd;text-align:left}td,th{padding:5px}tbody tr>td{border:1px solid #ddd!important}tr:nth-child(2n){background:#ccc}tr:nth-child(odd){background:#fff}.pagebreak{clear:both;page-break-after:always}.printSection{position:absolute;left:0;top:0;width:100%}.show-in-print{display:block}.static-image{display:inline}}</style>',
  });
})();

(function () {
    'use strict';

    angular
    .module('dashboard')
    .constant('keys', {
      "recaptchaPublicKey": "6LeU9LMUAAAAAISsLBmTXsHb5gmJoV_w_gzj_orZ",
    })
})();
(function () {
  "use strict";

  angular.module("dashboard").constant("iconsConstants", {
    icons: [
      "cep-aml",
      "cep-aml-alert",
      "cep-aml-alert-high",
      "cep-aml-alert-low",
      "cep-aml-alert-medium",
      "cep-aml-bank",
      "cep-aml-clients",
      "cep-aml-control",
      "cep-aml-money",
      "cep-aml-payment",
      "cep-aml-transfer",
      "cep-analysis",
      "cep-alert",
      "cep-alert-high",
      "cep-alert-low",
      "cep-alert-medium",
      "cep-aml-bank",
      "cep-aml-clients",
      "cep-aml-control",
      "cep-aml-money",
      "cep-aml-payment",
      "cep-aml-transfer",
      "cep-analysis",
      "cep-audit-paper",
      "cep-ban-circle",
      "cep-bell",
      "cep-case",
      "cep-channel-people",
      "cep-clip",
      "cep-closed",
      "cep-compilance-people",
      "cep-config",
      "cep-debugging",
      "cep-discarded",
      "cep-done",
      "cep-emo-alert",
      "cep-emo-happy",
      "cep-emo-scare",
      "cep-error",
      "cep-fire",
      "cep-folder-open",
      "cep-fraud-card",
      "cep-fraud-fire",
      "cep-fraud-pc",
      "cep-high-fire",
      "cep-high-temp",
      "cep-inbox",
      "cep-inform",
      "cep-information",
      "cep-issue",
      "cep-link",
      "cep-low-fire",
      "cep-low-temp",
      "cep-manage",
      "cep-market-tranfer",
      "cep-medical-case",
      "cep-medium-fire",
      "cep-medium-temp",
      "cep-menu-acl",
      "cep-menu-cases",
      "cep-menu-custom",
      "cep-menu-custom",
      "cep-menu-dashboard",
      "cep-menu-data",
      "cep-menu-data",
      "cep-menu-data",
      "cep-menu-data",
      "cep-menu-data",
      "cep-menu-data",
      "cep-menu-data",
      "cep-menu-documetation",
      "cep-menu-ethical",
      "cep-menu-ethical",
      "cep-menu-ethical",
      "cep-menu-events",
      "cep-menu-files",
      "cep-menu-global",
      "cep-menu-graphic",
      "cep-menu-graphic",
      "cep-menu-graphic",
      "cep-menu-graphics",
      "cep-menu-groups",
      "cep-menu-indicators",
      "cep-menu-issue",
      "cep-menu-log",
      "cep-menu-python",
      "cep-menu-rankings",
      "cep-menu-realtime",
      "cep-menu-rule",
      "cep-menu-rules",
      "cep-menu-rules",
      "cep-menu-rules",
      "cep-menu-security",
      "cep-menu-system",
      "cep-menu-tokens",
      "cep-menu-users",
      "cep-monitor-card",
      "cep-monitor-panel",
      "cep-monitor-pc",
      "cep-monitor-pc",
      "cep-opt-diligence",
      "cep-opt-money",
      "cep-pen",
      "cep-pending",
      "cep-preparation",
      "cep-progress",
      "cep-python",
      "cep-question",
      "cep-rank",
      "cep-redis",
      "cep-review",
      "cep-rule",
      "cep-rule-realtime",
      "cep-seg-secure",
      "cep-seg-user",
      "cep-sent",
      "cep-shield",
      "cep-shield-o",
      "cep-tag",
      "cep-thumbs-up",
      "cep-time",
      "cep-timer",
      "cep-unmanaged",
      "cep-user",
      "cep-users",
      "cep-warning",
    ],
  });
})();

// Configuraciónes grid (gridster) Dashboard
(function () {
  "use strict";

angular.module("dashboard").constant("htmlLayouts", {
    grid: '<div class="cr-flex">\n'+
        '   <div class="cr-item">\n'+
        '       <div class="cr-box">\n'+
        '           --- YOUR CONTENT --- \n'+
        '       </div>\n'+
        '   </div>\n'+
        '</div>',
    table: '<table class="table">\n' + "    <tr>\n" + "     <td> --- YOUR CONTENT ---</td>\n" + "</tr>\n" + "</table>",
    list:
        '<ul class="list-group">\n' +
        '   <li class="list-group-item"> --- YOUR CONTENT --- </li>\n' +
        "</ul>",
});
})();

// Configuraciónes grid (gridster) Dashboard
(function () {
  'use strict';

  angular.module('dashboard').constant('gridConfig', {
    columns: 12,
    minRows: 1,
    floating: false,
    swapping: true,
    pushing: false,
    resizable: true,
    draggable: {
      handle: '.widget-box-header'
  }
  });
})();

(function () {
  'use strict';

  angular.module('dashboard').constant('formats', {
    defaults: {
      integer: '0000',
      double: '0000.00',
      date: 'YYYY-MM-DD',
      time: 'HH:mm:ss',
      // timestamp: 'YYYY-MM-DD HH:mm:ss',
      timestamp: 'YYYY-MM-DDTHH:mm:ss.000000000',
    },
    date: {
      input: {
        integer: ['0000'],
        double: ['0000,00', '0000.00'],
        date: [
          'YYYY-M-D',
          'YYYY/M/D',
          'D-M-YYYY',
          'D/M/YYYY',
          'M-D-YYYY',
          'M/D/YYYY',
          'YYYY-MM-DD',
          'YYYY/MM/DD',
          'DD-MM-YYYY',
          'DD/MM/YYYY',
          'MM-DD-YYYY',
          'MM/DD/YYYY',
        ],
        time: ['HH:mm:ss', 'HH:mm:ss.SSSSSS', 'HH:mm'],
        timestamp: [
          'YYYY-M-D HH:mm:ss',
          'YYYY-M-D HH:mm:ss.SSSSSS',
          'YYYY-M-D HH:mm',
          'YYYY/M/D HH:mm:ss',
          'YYYY/M/D HH:mm:ss.SSSSSS',
          'YYYY/M/D HH:mm',
          'D-M-YYYY HH:mm:ss',
          'D-M-YYYY HH:mm:ss.SSSSSS',
          'D-M-YYYY HH:mm',
          'D/M/YYYY HH:mm:ss',
          'D/M/YYYY HH:mm:ss.SSSSSS',
          'D/M/YYYY HH:mm',
          'M-D-YYYY HH:mm:ss',
          'M-D-YYYY HH:mm:ss.SSSSSS',
          'M-D-YYYY HH:mm',
          'M/D/YYYY HH:mm:ss',
          'M/D/YYYY HH:mm:ss.SSSSSS',
          'M/D/YYYY HH:mm',
          'YYYY-MM-DD HH:mm:ss',
          'YYYY-MM-DD HH:mm:ss.SSSSSS',
          'YYYY-MM-DD HH:mm',
          'YYYY/MM/DD HH:mm:ss',
          'YYYY/MM/DD HH:mm:ss.SSSSSS',
          'YYYY/MM/DD HH:mm',
          'DD-MM-YYYY HH:mm:ss',
          'DD-MM-YYYY HH:mm:ss.SSSSSS',
          'DD-MM-YYYY HH:mm',
          'DD/MM/YYYY HH:mm:ss',
          'DD/MM/YYYY HH:mm:ss.SSSSSS',
          'DD/MM/YYYY HH:mm',
          'MM-DD-YYYY HH:mm:ss',
          'MM-DD-YYYY HH:mm:ss.SSSSSS',
          'MM-DD-YYYY HH:mm',
          'MM/DD/YYYY HH:mm:ss',
          'MM/DD/YYYY HH:mm:ss.SSSSSS',
          'MM/DD/YYYY HH:mm',
        ],
        autoincrement: [],
        boolean: [],
        sequentual: [],
        url: [],
        string: [],
      },
      output: {
        integer: ['0000', '0,000', '0.000'],
        double: ['0000,00', '0000.00', '0.000,00', '0,000.00'],
        date: [
          'YYYY-MM-DD',
          'YYYY/MM/DD',
          'DD-MM-YYYY',
          'DD/MM/YYYY',
          'MM-DD-YYYY',
          'MM/DD/YYYY',
        ],
        time: ['HH:mm:ss', 'HH:mm:ss.SSSSSS', 'HH:mm'],
        timestamp: [
          'YYYY-MM-DD HH:mm:ss',
          'YYYY-MM-DD HH:mm:ss.SSSSSS',
          'YYYY-MM-DD HH:MMMM',
          'YYYY/MM/DD HH:mm:ss',
          'YYYY/MM/DD HH:mm:ss.SSSSSS',
          'YYYY/MM/DD HH:MMMM',
          'DD-MM-YYYY HH:mm:ss',
          'DD-MM-YYYY HH:mm:ss.SSSSSS',
          'DD-MM-YYYY HH:MMMM',
          'DD/MM/YYYY HH:mm:ss',
          'DD/MM/YYYY HH:mm:ss.SSSSSS',
          'DD/MM/YYYY HH:MMMM',
          'MM-DD-YYYY HH:mm:ss',
          'MM-DD-YYYY HH:mm:ss.SSSSSS',
          'MM-DD-YYYY HH:MMMM',
          'MM/DD/YYYY HH:mm:ss',
          'MM/DD/YYYY HH:mm:ss.SSSSSS',
          'MM/DD/YYYY HH:mm',
        ],
        autoincrement: [],
        boolean: [],
        sequentual: [],
        url: [],
        string: [],
      },
    },
  });
})();


(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('ShareEntityController', ShareEntityController);

  ShareEntityController.$inject = [
    '$scope',
    '$localStorageService',
    'FileUploader',
    'FileSaver',
    '$modal',
    '$rootScope',
    '$stateParams',
    'Paginator',
    '$timeout',
    'env',
    '$mdToast',
    'BaseUrl',
    'translationService',
    '$mdDialog',
    '$document',
    'NgTableParams',
    'ngTableEventsChannel',
    '$location',
    'toastr',
    'GroupFactory',
    '$filter',
    '$state',
    'UserFactory',
    'AclFactory',
    'selectedItem',
    'actions',
    "CustomReportService"
  ];

  function ShareEntityController(
    $scope,
    $localStorageService,
    FileUploader,
    FileSaver,
    $modal,
    $rootScope,
    $stateParams,
    Paginator,
    $timeout,
    env,
    $mdToast,
    BaseUrl,
    $translationService,
    $mdDialog,
    $document,
    NgTableParams,
    ngTableEventsChannel,
    $location,
    toastr,
    GroupFactory,
    $filter,
    $state,
    UserFactory,
    AclFactory,
    selectedItem,
    actions,
    $customReportService
  ) {
    (function init() {
      console.log('++++++ ShareEntityController +++++++');

      $scope.currentUser = $localStorageService.getItem('currentUser');

      $translationService.getTranslation($scope, 'acl');
      $scope.actionText =
        $filter('uppercase')(
          $translationService.getTranslationController(
            'Compartir',
            'Share',
            'Compartilhar'
          )
        ) +
        ': ' +
        $filter('uppercase')(selectedItem.resource) +
        '::' +
        selectedItem.id +
        ' | ' +
        selectedItem.name;

      $scope.actions = actions;
      $scope.rule = {
        actions: [],
        users: [],
        groups: [],
        granted: true,
      };
      getPermissionsShareFn();
      getGroupsByCompanyIdFn();
      getUsersByCompanyIdFn();
    })();

    function getPermissionsShareFn() {
      $rootScope.loading = true;
      AclFactory.getPermissionsShare(selectedItem.resource, selectedItem.id)
        .then(function (response) {
          $scope.acl = {
            id: response.id,
            name: response.name,
            active: response.active,
          };

          if (angular.isDefined(response.policies)) {
            $scope.acl.policies = angular.fromJson(response.policies);
          } else {
            $scope.acl.policies = [];
          }
          $scope.$apply();
        })
        .catch(function (error) {
          if (error.status == 403) {
            toastr.error(
              $translationService.getTranslationController(
                'Usuario no autorizado.',
                'Unauthorized User.',
                'Usuário não autorizado.'
              )
            );
          } else {
            toastr.error(error);
          }
        })
        .finally(function () {
          $rootScope.loading = false;
        });
    }

    function getGroupsByCompanyIdFn() {
      if (
        !$scope.currentUser ||
        !$scope.currentUser.company ||
        !$scope.currentUser.company.companyId
      ) {
        return;
      }
      $scope.groups = [];
      $rootScope.loading = true;
      GroupFactory.getAllByCompanyId($scope.currentUser.company.companyId)
        .then(function (response) {
          $scope.groups = response;
          $scope.$apply();
        })
        .catch(function (error) {
          if (error.status == 403) {
            toastr.error(
              $translationService.getTranslationController(
                'Usuario no autorizado.',
                'Unauthorized User.',
                'Usuário não autorizado.'
              )
            );
          } else {
            toastr.error(error);
          }
        })
        .finally(function () {
          $rootScope.loading = false;
        });
    }

    function getUsersByCompanyIdFn() {
      if (
        !$scope.currentUser ||
        !$scope.currentUser.company ||
        !$scope.currentUser.company.companyId
      ) {
        return;
      }
      $scope.users = [];
      $rootScope.loading = true;
      UserFactory.getAllUsersByCompanyId($scope.currentUser.company.companyId)
        .then(function (response) {
          $scope.users = response.data.filter(function (value, index, arr) {
            return value.userId != $scope.currentUser.userId;
          });

          $scope.$apply();
        })
        .catch(function (error) {
          if (error.status == 403) {
            toastr.error(
              $translationService.getTranslationController(
                'Usuario no autorizado.',
                'Unauthorized User.',
                'Usuário não autorizado.'
              )
            );
          } else {
            toastr.error(error);
          }
        })
        .finally(function () {
          $rootScope.loading = false;
        });
    }

    $scope.cancel = function (ev) {
      var confirm = $mdDialog
        .confirm()
        .multiple(true)
        .title(
          $translationService.getTranslationController(
            '¿Deseas cancelar?',
            'Do you want to cancel?',
            'Você quer cancelar?'
          )
        )
        .textContent(
          $translationService.getTranslationController(
            '¡Todos los cambios se perderán!',
            'All changes will be lost!',
            'Todas as alterações serão perdidas!'
          )
        )
        .ariaLabel('Cancel-Question')
        .targetEvent(ev)
        .ok(
          $translationService.getTranslationController(
            'Abandonar',
            'Leave',
            'Deixar'
          )
        )
        .cancel(
          $translationService.getTranslationController(
            'Cancelar',
            'Cancel',
            'Cancelar'
          )
        );

      $mdDialog.show(confirm).then(
        function () {
          $mdDialog.cancel();
        },
        function () {}
      );
    };

    $scope.add = function () {
      if (
        ($scope.rule.users.length == 0 && $scope.rule.groups.length == 0) ||
        $scope.rule.actions.length == 0
      ) {
        return;
      }

      var rule = {
        description: selectedItem.resource + '#' + selectedItem.id,
        resource: {
          name: selectedItem.resource,
          entityId: selectedItem.id,
          actions: $scope.rule.actions.join(),
          granted: $scope.rule.granted,
        },
        appliesTo: {
          users: [],
          groups: [],
        },
      };

      if (angular.isDefined($scope.rule.users)) {
        $scope.rule.users.forEach(function (_userId) {
          var user = $scope.users.filter(function (_item) {
            return _item.userId == _userId;
          });
          rule.appliesTo.users.push({
            userId: user[0].userId,
            name: user[0].username,
          });
        });
      }
      if (angular.isDefined($scope.rule.groups)) {
        $scope.rule.groups.forEach(function (_groupId) {
          var group = $scope.groups.filter(function (_item) {
            return _item.id == _groupId;
          });
          rule.appliesTo.groups.push({
            id: group[0].id,
            name: group[0].name,
          });
        });
      }

      if (angular.isDefined($scope.acl.policies)) {
        var findRule = $scope.acl.policies.filter(function (_item) {
          return hashFn(JSON.stringify(_item)) == hashFn(JSON.stringify(rule));
        });

        if (findRule.length == 0) {
          $scope.acl.policies.push(rule);
          $scope.rule = {
            actions: [],
            users: [],
            groups: [],
            granted: true,
          };
        }
      }
    };

    function hashFn(s) {
      /* Simple hash function. */
      var a = 1,
        c = 0,
        h,
        o;
      if (s) {
        a = 0;
        /*jshint plusplus:false bitwise:false*/
        for (h = s.length - 1; h >= 0; h--) {
          o = s.charCodeAt(h);
          a = ((a << 6) & 268435455) + o + (o << 14);
          c = a & 266338304;
          a = c !== 0 ? a ^ (c >> 21) : a;
        }
      }
      return String(a);
    }

    $scope.getBY = function (_item) {
      var user = '';
      var group = '';
      if (
        angular.isDefined(_item.appliesTo.users) &&
        _item.appliesTo.users.length > 0
      ) {
        user =
          '<span><i class="material-icons">person</i> <strong>' +
          arrayToStringFn(_item.appliesTo.users) +
          '</strong></span>';
      }
      if (
        angular.isDefined(_item.appliesTo.groups) &&
        _item.appliesTo.groups.length > 0
      ) {
        group =
          '<span><i class="material-icons">group</i> <strong>' +
          arrayToStringFn(_item.appliesTo.groups) +
          '</strong></span>';
      }
      return user + '<br>' + group;
    };

    function arrayToStringFn(array) {
      if (angular.isUndefined(array)) {
        return '';
      }
      var tmp = [];
      array.forEach(function (_item) {
        tmp.push(_item.name);
      });
      return tmp;
    }

    $scope.getAction = function (_item) {
      var grant =
        _item.resource.granted == true || _item.resource.granted == 'true'
          ? 'add'
          : 'remove';
      var str = '<span><strong>' + _item.resource.actions + '</strong></span>';
      return str;
    };

    $scope.getFOR = function (_item) {
      var rules = '';
      if (angular.isDefined(_item.resource.rule)) {
        angular.forEach(_item.resource.rule, function (item, key) {
          rules =
            rules +
            '<span>' +
            key +
            "<span class='font-color-blue'> equals </span>" +
            item +
            '</span><br>';
        });
      }
      var str =
        '<p><strong>' + _item.resource.name + '</strong><br>' + rules + '</p>';
      return str;
    };

    $scope.removePolicy = function (ev, index) {
      var confirm = $mdDialog
        .confirm()
        .multiple(true)
        .title(
          $translationService.getTranslationController(
            '¿Deseas borrar el registro de la lista?',
            'Do you want to delete the record from the list?',
            'Você deseja excluir o registro da lista?'
          )
        )
        .ariaLabel('Cancel-Question')
        .targetEvent(ev)
        .ok($translationService.getTranslationController('Si', 'Yes', 'Sim'))
        .cancel(
          $translationService.getTranslationController('No', 'No', 'Não')
        );

      $mdDialog.show(confirm).then(
        function () {
          $scope.acl.policies.splice(index, 1);
        },
        function () {}
      );
    };

    function buildAclFn() {
      var acl = {
        id: $scope.acl.id,
        name: $scope.acl.name,
        description: selectedItem.name,
        active: $scope.acl.active,
      };

      if (
        angular.isDefined($scope.acl.policies) &&
        $scope.acl.policies.length > 0
      ) {
        acl.policies = JSON.stringify($scope.acl.policies);
      }
      return acl;
    }

    $scope.save = function () {
      $rootScope.loading = true;
      var acl = buildAclFn();
      AclFactory.createShareEntity(
        selectedItem.resource,
        selectedItem.id,
        acl
      ).then(
        function (response) {
          $rootScope.loading = false;
          toastr.success(
            $translationService.getTranslationController(
              'ACL creada exitosamente.',
              'Successfully updated ACL.',
              'ACL criada com sucesso.'
            )
          );

          // console.log('response:', response.config.data);
          // console.log('Selected Item:', selectedItem);
          
          if(selectedItem.resource === 'custom-report') {
            // console.log('Custom Report ACL created:', response.config.data);
            $customReportService.asignPersimionsToUserGroup(selectedItem.rawitem, response.config.data);
          }

          $mdDialog.cancel();
        },
        function (error) {
          $rootScope.loading = false;
          if (error.status == 403) {
            toastr.error(
              $translationService.getTranslationController(
                'Usuario no autorizado.',
                'Unauthorized User.',
                'Usuário não autorizado.'
              )
            );
          } else if (error.status == 400) {
            toastr.error(
              $translationService.getTranslationController(
                'ACL tiene uno o mas errores',
                'This ACL has one or more errors',
                'Esta ACL tem um ou mais erros'
              )
            );
          } else if (error.status == 409) {
            toastr.error(
              $translationService.getTranslationController(
                'Esta ACL ya existe.',
                'This ACL already exists.',
                'Esta ACL já existe.'
              )
            );
          } else {
            toastr.error(error);
          }
        }
      );
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('helpDeskController', helpDeskController);

  helpDeskController.$inject = [];
  function helpDeskController() {
    var vm = this;
    console.log('helpDeskController', vm);

    var ISSUES_SAMPLE = {
      pagination: {
        page: 1,
        itemsPerPage: 15,
        sort: 'asc',
        totalRecords: 3,
      },
      data: [
        {
          uuid: 'ca2b773f-54fb-444b-9812-677affa2b0f9',
          correlative: 'IN4-1-2',
          description: 'Prueba multi link',
          issueType: {
            id: 4,
            name: 'Informe Comite',
            color: 'green lighten-4',
            icon: 'cep-inform',
          },
          category: {
            id: 3,
            name: 'AML',
            color: 'black',
            icon: 'cep-monitor-panel',
          },
          domain: {
            domainId: 1,
            domainName: 'test',
            domainRoot: false,
          },
          createdBy: {
            userId: 1,
            username: 'ceptinel',
            email: 'admin@variacode.com',
            lastName: 'Administrador',
            name: 'Administrador',
            fullName: 'Administrador Administrador',
            lang: 'EN',
            profile: {
              type: 'SA',
            },
          },
          supervisor: {
            userId: 1,
            username: 'ceptinel',
            email: 'admin@variacode.com',
            lastName: 'Administrador',
            name: 'Administrador',
            fullName: 'Administrador Administrador',
            lang: 'EN',
            profile: {
              type: 'SA',
            },
          },
          assigned: {
            userId: 1,
            username: 'ceptinel',
            email: 'admin@variacode.com',
            lastName: 'Administrador',
            name: 'Administrador',
            fullName: 'Administrador Administrador',
            lang: 'EN',
            profile: {
              type: 'SA',
            },
          },
          createdAt: 1618943868566,
          createdAtLocal: 1618929470000,
          createdAtTZ: 'GMT-04:00',
          head: '{"#TITULO": "asdfasd", "TEXTO_PRINCIPAL": "asdfasdf"}',
          body: '{"Sexo": "asdasd", "Nombres": "asda", "Telefono": "asdasd", "Actividad": "checoslovaquia", "Apellidos": "dasd", "Domicilio": {}, "Profesion": "Zapatero", "TotalCasos": "asdfasdf", "#RutPersona": "asdasd", "Responsable": "asdfasd", "#Observaciones": "adfasd", "PaisNacimiento": "asdasd", "DireccionComercial": {}}',
          headSchema: {
            id: 303,
            schema:
              '{"definitions": {"SYS_HEADER_INFORME": {"$id": "#TITULO", "type": "object", "required": ["#TITULO"], "properties": {"TITULO": {"type": "string", "order": "0", "visible": true, "displayName": "Titulo del informe", "autocomplete": false}, "FECHA_CREACION": {"type": "date", "order": "2", "visible": true, "displayName": "Fecha creación", "autocomplete": false}, "TEXTO_PRINCIPAL": {"type": "string", "order": "1", "visible": true, "displayName": "Texto Principal del Informe", "autocomplete": false}, "FECHA_PRESENTACION": {"type": "date", "order": "3", "visible": true, "displayName": "Fecha presentacion", "autocomplete": false}}}}}',
            name: 'SYS_HEADER_INFORME',
            description: 'HEADER INFORE',
            icon: 'done_all',
          },
          bodySchema: {
            id: 329,
            schema:
              '{"definitions": {"INFORME_COMITE": {"$id": "#Observaciones", "type": "object", "required": ["#Observaciones"], "properties": {"TotalCasos": {"type": "string", "order": "2", "tooltip": true, "visible": true, "readonly": false, "displayName": "Numero de casos vinculados", "autocomplete": false}, "Responsable": {"type": "string", "order": "0", "tooltip": true, "visible": true, "readonly": false, "displayName": "Responsable", "autocomplete": false}, "Observaciones": {"type": "string", "order": "1", "tooltip": true, "visible": true, "readonly": false, "displayName": "Observaciones", "autocomplete": false}}}}}',
            name: 'INFORME_COMITE',
            display: 'Informe Comite Interno',
            description: 'Informe Comite Interno',
            icon: 'cep-inform',
          },
          status: {
            id: 16,
            name: 'En Elaboracion',
            color: 'ceptinel',
            icon: 'cep-issue',
            weight: 1,
          },
          classification: {
            id: 8,
            name: 'Informe Comite Riesgo',
            weight: 1,
          },
          criticality: {
            id: 9,
            name: 'En preparación',
            color: 'blue',
            weight: 1,
            icon: 'cep-low-fire',
          },
          isUpdatable: false,
          evidenceTotal: 6,
          source: 'USER',
          viewed: true,
          'body/CASOS_OPERACIONES_SOSPECHOSAS/#NO_OPERACIONES': '',
        },
        {
          uuid: 'bac82a42-71f8-4619-a510-ed2d85ded414',
          correlative: 'IN4-1-1',
          description: 'Prueba Issues de otro tipo',
          issueType: {
            id: 4,
            name: 'Informe Comite',
            color: 'green lighten-4',
            icon: 'cep-inform',
          },
          category: {
            id: 3,
            name: 'AML',
            color: 'black',
            icon: 'cep-monitor-panel',
          },
          domain: {
            domainId: 1,
            domainName: 'test',
            domainRoot: false,
          },
          createdBy: {
            userId: 1,
            username: 'ceptinel',
            email: 'admin@variacode.com',
            lastName: 'Administrador',
            name: 'Administrador',
            fullName: 'Administrador Administrador',
            lang: 'EN',
            profile: {
              type: 'SA',
            },
          },
          supervisor: {
            userId: 1,
            username: 'ceptinel',
            email: 'admin@variacode.com',
            lastName: 'Administrador',
            name: 'Administrador',
            fullName: 'Administrador Administrador',
            lang: 'EN',
            profile: {
              type: 'SA',
            },
          },
          assigned: {
            userId: 40,
            username: 'fprado',
            email: 'felipe.prado@ceptinel.cl',
            lastName: 'Prado',
            name: 'Felipe',
            fullName: 'Felipe Prado',
            lang: 'ES',
            profile: {
              type: 'U',
            },
          },
          createdAt: 1616780031485,
          createdAtLocal: 1616769233000,
          createdAtTZ: 'GMT-03:00',
          head: '{"#TITULO": "asd", "TEXTO_PRINCIPAL": "asd"}',
          body: '{"RELACION": "asd", "#NO_OPERACIONES": "6561"}',
          headSchema: {
            id: 303,
            schema:
              '{"definitions": {"SYS_HEADER_INFORME": {"$id": "#TITULO", "type": "object", "required": ["#TITULO"], "properties": {"TITULO": {"type": "string", "order": "0", "visible": true, "displayName": "Titulo del informe", "autocomplete": false}, "FECHA_CREACION": {"type": "date", "order": "2", "visible": true, "displayName": "Fecha creación", "autocomplete": false}, "TEXTO_PRINCIPAL": {"type": "string", "order": "1", "visible": true, "displayName": "Texto Principal del Informe", "autocomplete": false}, "FECHA_PRESENTACION": {"type": "date", "order": "3", "visible": true, "displayName": "Fecha presentacion", "autocomplete": false}}}}}',
            name: 'SYS_HEADER_INFORME',
            description: 'HEADER INFORE',
            icon: 'done_all',
          },
          bodySchema: {
            id: 301,
            schema:
              '{"definitions": {"CASOS_OPERACIONES_SOSPECHOSAS": {"$id": "#NO_OPERACIONES", "type": "object", "required": ["#NO_OPERACIONES"], "properties": {"RELACION": {"type": "string", "order": "1", "visible": true, "autocomplete": false}, "NO_OPERACIONES": {"type": "integer", "order": "0", "visible": true, "displayName": "NO OPERACIONES", "autocomplete": false}}}}}',
            name: 'CASOS_OPERACIONES_SOSPECHOSAS',
            description: 'OPERACIONES SOSPECHOSAS',
            icon: 'cep-emo-alert',
          },
          status: {
            id: 16,
            name: 'En Elaboracion',
            color: 'ceptinel',
            icon: 'cep-issue',
            weight: 1,
          },
          classification: {
            id: 8,
            name: 'Informe Comite Riesgo',
            weight: 1,
          },
          criticality: {
            id: 9,
            name: 'En preparación',
            color: 'blue',
            weight: 1,
            icon: 'cep-low-fire',
          },
          isUpdatable: false,
          evidenceTotal: 0,
          source: 'USER',
          viewed: true,
          'body/CASOS_OPERACIONES_SOSPECHOSAS/#NO_OPERACIONES': '6561',
        },
        {
          uuid: 'fc2bb18c-cc99-498e-ae98-196565007a9c',
          description: 'Informe prueba',
          issueType: {
            id: 4,
            name: 'Informe Comite',
            color: 'green lighten-4',
            icon: 'cep-inform',
          },
          category: {
            id: 3,
            name: 'AML',
            color: 'black',
            icon: 'cep-monitor-panel',
          },
          domain: {
            domainId: 1,
            domainName: 'test',
            domainRoot: false,
          },
          createdBy: {
            userId: 1,
            username: 'ceptinel',
            email: 'admin@variacode.com',
            lastName: 'Administrador',
            name: 'Administrador',
            fullName: 'Administrador Administrador',
            lang: 'EN',
            profile: {
              type: 'SA',
            },
          },
          supervisor: {
            userId: 1,
            username: 'ceptinel',
            email: 'admin@variacode.com',
            lastName: 'Administrador',
            name: 'Administrador',
            fullName: 'Administrador Administrador',
            lang: 'EN',
            profile: {
              type: 'SA',
            },
          },
          assigned: {
            userId: 40,
            username: 'fprado',
            email: 'felipe.prado@ceptinel.cl',
            lastName: 'Prado',
            name: 'Felipe',
            fullName: 'Felipe Prado',
            lang: 'ES',
            profile: {
              type: 'U',
            },
          },
          createdAt: 1605877897560,
          createdAtLocal: 1605867096000,
          createdAtTZ: 'GMT-03:00',
          head: '{"#TITULO": "Titulo prueba", "OBSERVACION": "", "FECHA_CREACION": "2020-11-11T03:00:00.000Z", "TEXTO_PRINCIPAL": "asdasdasd", "FECHA_RESOLUCION": "", "PLAZO_RESOLUCION": "", "#FECHA_OCURRENCIA": "", "FECHA_PRESENTACION": "2020-11-18T03:00:00.000Z", "FECHA_REAL_RESOLUCION": ""}',
          body: '{"#id": "", "FECHA_IFO": "", "RUT_ORIGEN": "", "TotalCasos": "asdfasdfasdf", "#Responsable": "adfadf", "MONTO_DIARIO": "", "Observaciones": "asdfasdf"}',
          headSchema: {
            id: 303,
            schema:
              '{"definitions": {"SYS_HEADER_INFORME": {"$id": "#TITULO", "type": "object", "required": ["#TITULO"], "properties": {"TITULO": {"type": "string", "order": "0", "visible": true, "displayName": "Titulo del informe", "autocomplete": false}, "FECHA_CREACION": {"type": "date", "order": "2", "visible": true, "displayName": "Fecha creación", "autocomplete": false}, "TEXTO_PRINCIPAL": {"type": "string", "order": "1", "visible": true, "displayName": "Texto Principal del Informe", "autocomplete": false}, "FECHA_PRESENTACION": {"type": "date", "order": "3", "visible": true, "displayName": "Fecha presentacion", "autocomplete": false}}}}}',
            name: 'SYS_HEADER_INFORME',
            description: 'HEADER INFORE',
            icon: 'done_all',
          },
          bodySchema: {
            id: 329,
            schema:
              '{"definitions": {"INFORME_COMITE": {"$id": "#Observaciones", "type": "object", "required": ["#Observaciones"], "properties": {"TotalCasos": {"type": "string", "order": "2", "tooltip": true, "visible": true, "readonly": false, "displayName": "Numero de casos vinculados", "autocomplete": false}, "Responsable": {"type": "string", "order": "0", "tooltip": true, "visible": true, "readonly": false, "displayName": "Responsable", "autocomplete": false}, "Observaciones": {"type": "string", "order": "1", "tooltip": true, "visible": true, "readonly": false, "displayName": "Observaciones", "autocomplete": false}}}}}',
            name: 'INFORME_COMITE',
            display: 'Informe Comite Interno',
            description: 'Informe Comite Interno',
            icon: 'cep-inform',
          },
          status: {
            id: 16,
            name: 'En Elaboracion',
            color: 'ceptinel',
            icon: 'cep-issue',
            weight: 1,
          },
          classification: {
            id: 7,
            name: 'Informe UAF',
            weight: 1,
          },
          criticality: {
            id: 9,
            name: 'En preparación',
            color: 'blue',
            weight: 1,
            icon: 'cep-low-fire',
          },
          isUpdatable: false,
          evidenceTotal: 4,
          source: 'USER',
          viewed: true,
          'body/CASOS_OPERACIONES_SOSPECHOSAS/#NO_OPERACIONES': '',
        },
      ],
      columns: [
        {
          key: 'description',
          label: 'Description',
          sortable: true,
          type: 'string',
        },
        {
          key: 'category',
          label: 'Category',
          sortable: false,
          type: 'integer',
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
          type: 'integer',
        },
        {
          key: 'classification',
          label: 'Classification',
          sortable: true,
          type: 'integer',
        },
        {
          key: 'criticality',
          label: 'Criticality',
          sortable: true,
          type: 'integer',
        },
        {
          key: 'supervisor',
          label: 'Supervisor',
          sortable: true,
          type: 'integer',
        },
        {
          key: 'assigned',
          label: 'Assigned',
          sortable: true,
          type: 'integer',
        },
        {
          key: 'createdBy',
          label: 'CreatedBy',
          sortable: true,
          type: 'integer',
        },
        {
          key: 'createdAt',
          label: 'CreatedAt',
          sortable: true,
          type: 'date',
        },
        {
          key: 'source',
          label: 'Origin',
          sortable: true,
          type: 'string',
        },
        {
          key: 'evidenceTotal',
          label: 'Evidence Total',
          sortable: true,
          type: 'integer',
        },
        {
          key: 'body/CASOS_OPERACIONES_SOSPECHOSAS/#NO_OPERACIONES',
          label: 'Body.CASOS_OPERACIONES_SOSPECHOSAS.NO OPERACIONES',
          sortable: true,
          type: 'integer',
        },
      ],
      footer: {
        'body/CASOS_OPERACIONES_SOSPECHOSAS/#NO_OPERACIONES': 6561,
        evidenceTotal: 10,
      },
    };

    var tableDefaultColumns = [
      {
        key: 'description',
        name: 'Description',
        displayName: 'Descrição',
        field: 'description',
        width: '15%',
      },
      {
        key: 'classification',
        name: 'Classification',
        displayName: 'Classificação',
        field: 'classification.name',
      },
      {
        key: 'createdAt',
        name: 'CreatedAt',
        displayName: 'Criado em (UTC)',
        field: 'createdAt',
        width: '140',
        dataType: 'date: "dd/MM/yy HH:mm"',
      },
      {
        key: 'createdAtLocal',
        name: 'CreatedAtLocal',
        displayName: 'Criado em',
        field: 'createdAtLocal',
        width: '140',
        dataType: 'date: "dd/MM/yy HH:mm"',
      },
      {
        key: 'createdBy',
        name: 'CreatedBy',
        displayName: 'Criado por',
        field: 'createdBy.name',
      },
      {
        key: 'source',
        name: 'Source',
        displayName: 'Origemr',
        field: 'source',
        width: '75',
      },
      {
        key: 'assigned',
        name: 'Assigned',
        displayName: 'Atribuído',
        field: 'assigned.name',
      },
      { key: 'supervisor', name: 'Supervisor', field: 'supervisor.name' },
      {
        key: 'category',
        name: 'Category',
        displayName: 'Categoria',
        field: 'category.name',
        width: '100',
      },
      {
        key: 'criticality',
        name: 'Criticality',
        displayName: 'Criticidade',
        field: 'criticality.name',
        width: '100',
      },
      {
        key: 'status',
        name: 'Status',
        displayName: 'Status',
        field: 'status.name',
      },
      {
        key: 'evidence_total',
        name: 'Evidences',
        displayName: 'Evidências',
        field: 'evidence_total',
      },
    ];

    var columns = [];

    ISSUES_SAMPLE.columns.forEach(function (col) {
      var def = tableDefaultColumns.find(function (dcol) {
        return dcol.key == col.key;
      });
      if (def) {
        def.sortable = col.sortable;
        def.type = col.type;
        columns.push(def);
      } else {
        var gridCol = {
          key: col.key,
          name: col.key,
          displayName: col.label,
          field: col.key,
          sortable: col.sortable,
          type: col.type,
        };
        columns.push(gridCol);
      }
    });

    vm.gridOptions = {
      multiSelect: true,
      enableFullRowSelection: true,
      gridMenuShowHideColumns: false,
      showColumnFooter: true,
      // Grid pagination options
      useExternalPagination: true,
      paginationPageSizes: [15, 20, 25],
      paginationPageSize: 15,
      totalItems: ISSUES_SAMPLE.pagination.totalRecords,
      // Grid sorting options
      useExternalSorting: true,
      // Grid menu
      enableGridMenu: true,
      columnDefs: columns,
      data: ISSUES_SAMPLE.data,
      footerData: ISSUES_SAMPLE.footer || {},
    };
  }
})();

(function () {
  'use strict';

  angular.module('dashboard').controller('UsersController', UsersController);

  UsersController.$inject = [
    '$scope',
    '$rootScope',
    '$cookies',
    'UserFactory',
    'uiGridConstants',
    'translationService',
    'usersConstants',
    'CompanyFactory',
    'FileSaver',
    'FileUploader',
    'toastr',
  ];

  function UsersController(
    $scope,
    $rootScope,
    $cookies,
    $userFactory,
    uiGridConstants,
    $translationService,
    $usersConstants,
    $companyFactory,
    FileSaver,
    FileUploader,
    toastr
  ) {
    var vm = this;
    $translationService.getTranslation(vm, 'users');

    vm.editActive = false;
    vm.user = null;
    vm.companies = [];

    vm.filters = {
      page: 1,
      itemsPerPage: 25,
      sort: 'desc',
      totalRecords: 0,
      orderBy: 'id',
    };

    vm.gridOptions = {
      data: [],
      height: 1000,
      multiSelect: false,
      enableFullRowSelection: true,
      minimumColumnSize: 100,
      // Grid pagination options
      useExternalPagination: true,
      paginationPageSizes: [25, 50, 100],
      paginationPageSize: vm.filters.itemsPerPage,
      totalItems: vm.filters.totalRecords,
      // Grid sorting options
      useExternalSorting: true,
      // useExternalFiltering: true,
      enableFiltering: true,
      useExternalFiltering: true,
      columnDefs: [
        {
          displayName: 'id',
          width: '5%',
          name: 'id',
          field: 'id',
          headerCellClass: 'text-center',
          align: 'htCenter',
        },
        {
          displayName: 'fullName',
          name: 'name',
          field: 'name',
        },
        {
          displayName: 'username',
          name: 'username',
          field: 'username',
        },
        {
          displayName: 'email',
          name: 'email',
          field: 'email',
        },
        {
          displayName: 'groups',
          name: 'groups',
          field: 'groups',
        },
        {
          displayName: 'type',
          width: '5%',
          name: 'type',
          field: 'type',
          headerCellClass: 'text-center',
          filter: {
            term: '',
            type: uiGridConstants.filter.SELECT,
            selectOptions: $usersConstants.userTypes.map(function (e) {
              return {
                label: e.name,
                value: e.value,
              };
            }),
          },
        },
        {
          displayName: 'company',
          name: 'company',
          field: 'company',
          headerCellClass: 'text-center',
          align: 'htCenter',
        },
        {
          displayName: 'region',
          name: 'region',
          field: 'region',
          headerCellClass: 'text-center',
          align: 'htCenter',
        },
        {
          displayName: 'lastLogin',
          name: 'lastLogin',
          field: 'lastLogin',
          headerCellClass: 'text-center',
          align: 'htCenter',
        },
        {
          displayName: 'expirationDate',
          name: 'expirationDate',
          field: 'expirationDate',
          headerCellClass: 'text-center',
        },
        {
          displayName: 'status',
          width: '5%',
          name: 'active',
          field: 'active',
          headerCellClass: 'text-center',
          align: 'htCenter',
          filter: {
            term: '',
            type: uiGridConstants.filter.SELECT,
            selectOptions: [
              { value: '', label: 'All' },
              { value: 't', label: 'Active' },
              { value: 'f', label: 'Inactive' },
            ],
          },
          cellTemplate:
            '<div class="text-center {{COL_FIELD}}-text" title="status">{{COL_FIELD == "t" ? "active":"inactive"}}</div>',
        },
      ],
      onRegisterApi: function (gridApi) {
        gridApi.selection.on.rowSelectionChanged($scope, function (row) {
          vm.onSelectUser(row.entity);
        });
        gridApi.pagination.on.paginationChanged(
          $scope,
          function (newPage, pageSize) {
            vm.filters.page = newPage;
            vm.filters.itemsPerPage = pageSize;
            vm.gridOptions.paginationPageSize = pageSize;

            _getUsers();
          }
        );
        gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          vm.filters.sort = vm.filters.sort === 'asc' ? 'desc' : 'asc';
          vm.filters.orderBy = sortColumns[0].field;
          _getUsers();
        });

        gridApi.core.on.filterChanged($scope, function (col) {
          if (col.filters[0].term) {
            var term = col.filters[0].term;
            if (
              ['groups', 'company', 'lastLogin', 'expirationDate'].includes(
                col.field
              )
            )
              return;

            if (['type', 'region'].includes(col.field))
              term = term.toUpperCase();

            vm.filters[col.field] = term;
          } else {
            delete vm.filters[col.field];
          }
          _getUsers();
        });
      },
    };

    function _getUsers() {
      $rootScope.loading = true;
      $userFactory
        .getUsers(vm.filters)
        .then(function (res) {
          var pagination = res.data.pagination;

          var users = res.data.data
          .filter(function (e) {
            return e.profile && e.profile.type !== 'SU';
          })
          .map(function (e) {
            var groups = Array.isArray(e.profile.groups)
              ? e.profile.groups
                  .map(function (g) {
                    return g.name;
                  })
                  .join(', ')
              : '';

            var lastLogin = e.lastLogin
              ? moment(e.lastLogin).format('DD-MM-YYYY')
              : '';

            var expirationDate = e.expirationDate
              ? moment(e.expirationDate).format('DD-MM-YYYY')
              : '';

            return {
              id: e.userId,
              company: e.company.companyName,
              email: e.email,
              expirationDate: expirationDate,
              groups: groups,
              lastLogin: lastLogin,
              name: e.fullName,
              active: e.active,
              type: e.profile.type,
              username: e.username,
              region: e.region,
              raw: e,
            };
          });
          vm.gridOptions.data = users;
          vm.gridOptions.totalItems = pagination.totalRecords;
          vm.gridOptions.paginationPageSize = pagination.itemsPerPage;
          vm.filters = pagination;
        })
        .catch(function (err) {
          console.error(err);
        })
        .finally(function () {
          $rootScope.loading = false;
        });
    }

    vm.$onInit = function () {
      var promises = [_getAllCompanies()];

      Promise.allSettled(promises)
        .then(function (res) {
          _getUsers();
          // console.log(res);
        })
        .catch(function (err) {
          console.log(err);
        });
    };
    vm.$onInit();

    function _getAllCompanies() {
      $companyFactory
        .getAllCompanies()
        .then(function (response) {
          vm.companies = response.data.map(function (e) {
            return {
              label: e.name,
              value: e.id,
            };
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    vm.onSelectUser = function (user) {
      vm.editActive = true;
      vm.user = user.raw;
    };
    vm.cancelEdition = function () {
      _getUsers();
      vm.editActive = false;
      vm.user = null;
    };
    vm.newUser = function () {
      vm.editActive = true;
      vm.user = null;
    };

    vm.export = function () {
      $rootScope.loading = true;
      $userFactory
        .getUsers({
          exportToCSV: true,
        })
        .then(function (res) {
          FileSaver.saveAs(
            new Blob([res.data], { type: 'application/csv' }),
            'users.csv'
          );
        })
        .catch(function (err) {
          console.error(err);
        })
        .finally(function () {
          $rootScope.loading = false;
        });
    };

    vm.import = function (file) {
      $rootScope.loading = true;
      $userFactory
        .importUsersCsv(file)
        .then(function (res) {
          FileSaver.saveAs(
            new Blob([res.data], { type: 'application/csv' }),
            'users.csv'
          );
        })
        .catch(function (err) {
          console.error(err);
        })
        .finally(function () {
          $rootScope.loading = false;
        });
    };

    //-uploadder
    vm.uploader = new FileUploader({
      url: '/risk-backend/rest/user/import-csv',
      headers: {
        token: $cookies.get('Authorization'),

        'X-Requested-With': 'XMLHttpRequest',
      },
      formData: { creationDate: moment() },
      removeAfterUpload: true,
    });

    vm.uploader.filters.push({
      name: 'Extensions',
      fn: function (item, options) {
        var allowedType = [
          'text/csv',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ];

        if (allowedType.indexOf(item.type) === -1) {
          toastr.error('Archivo no permitido');
        }

        return allowedType.indexOf(item.type) !== -1;
      },
    });

    vm.uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response === 'fileDuplicate') {
        var msg = $translationService.getTranslationController(
          'No se ha podido cargar, archivo duplicado en el sistema.',
          'Unable to load, duplicate file in the system.',
          'Não é possível carregar, duplicar arquivo no sistema.'
        );
        toastr.error(msg);
      } else {
        if (status == 403) {
          toastr.error(
            $translationService.getTranslationController(
              'Usuario no autorizado.',
              'Unauthorized User.',
              'Usuário não autorizado.'
            )
          );
        } else {
          toastr.error(
            $translationService.getTranslationController(
              'No se ha podido cargar el archivo.',
              'The file could not be loaded.',
              'O arquivo não pôde ser carregado.'
            )
          );
        }
      }
    };

    vm.uploader.onAfterAddingAll = function (addedFileItems) {
      addedFileItems = addedFileItems.map(function (e) {
        delete e.formData;
        return e;
      });
      vm.uploader.uploadAll();
    };

    vm.uploader.onProgressAll = function (progress) {
      toastr.info('Uploading file...');
    };

    vm.uploader.onCompleteItem = function (
      fileItem,
      response,
      status,
      headers
    ) {
      document.getElementById('file').value = null;
      if (status == 200) {
        toastr.success('Success file...');
        _getUsers();
      } else {
        toastr.error('Error uploading');
        console.log('headers', response);
      }
    };

    $scope.$on('cancelEdition', function (evt, reload) {
      vm.cancelEdition();
      if (reload) {
        vm.filters = {
          page: 1,
          itemsPerPage: 25,
          sort: 'asc',
          totalRecords: 33,
          orderBy: 'name',
        };
        vm.$onInit();
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('UsuarioPasswordController', UsuarioPasswordController);

  UsuarioPasswordController.$inject = [
    '$scope',
    'toastr',
    '$localStorageService',
    'UserFactory',
    '$rootScope',
    'translationService',
    'LoginFactory',
  ];
  function UsuarioPasswordController(
    $scope,
    toastr,
    $localStorageService,
    UserFactory,
    $rootScope,
    $translationService,
    LoginFactory
  ) {
    $scope.riskUserPassword = {};
    $scope.idUser = $localStorageService.getItem("currentUser.userId");
    $scope.passwordPolicy = {
      showPasswordPolicy: false,
      expirePasswordInDays: 0,
      minimumPasswordLength: 0,
      rememberLastPasswords: 0,
      withAtLeastOneDigit: false,
      withAtLeastOneSymbol: false,
      withAtLeastOneLowercase: false,
      withAtLeastOneUppercase: false,
    };

    (function init() {
      //Método para realizar traducción
      $translationService.getTranslation($scope, 'users');

      LoginFactory.getPasswordPolicy()
        .then(function (res) {
          $scope.passwordPolicy = res;
          $scope.$apply();
        })
        .catch(function (err) {
          console.log('Error@getIssuesTypes', err);
          $scope.passwordPolicy = {
            showPasswordPolicy: false,
            expirePasswordInDays: 0,
            minimumPasswordLength: 0,
            rememberLastPasswords: 0,
            withAtLeastOneDigit: false,
            withAtLeastOneSymbol: false,
            withAtLeastOneLowercase: false,
            withAtLeastOneUppercase: false,
          };
        });
    })();

    $scope.closeModalPassword = function () {
      $rootScope.$broadcast('closeModalUserPassword');
    };

    $scope.validarCambiarPassword = function (id, riskUserPassword) {
      var validacion = { content: '', show: false };
      if (!id) {
        var msgs = $translationService.getTranslationController(
          'Debe elegir el usuario a cambiar el password.',
          'The user must choose to change the password.',
          'O usuário deve optar por alterar a senha.'
        );
        validacion.content = msgs;
        $rootScope.loading = false;
        $scope.content = validacion.content;

        validacion.show = true;

        $scope.show = validacion.show;
      } else if (!riskUserPassword.passwordAntigua) {
        var msgs = $translationService.getTranslationController(
          'Debe llenar el campo Password Antiguo.',
          'You must fill in the Old Password field.',
          'Você deve preencher o campo Old Password.'
        );
        validacion.content = msgs;
        $rootScope.loading = false;
        $scope.content = validacion.content;

        validacion.show = true;

        $scope.show = validacion.show;
      } else if (!riskUserPassword.passwordNueva) {
        $rootScope.loading = false;
        var msgs = $translationService.getTranslationController(
          'Debe llenar el campo Password Nuevo.',
          'You must fill in the Password New field.',
          'Você deve preencher o campo Password New.'
        );
        validacion.content = msgs;
        $scope.content = validacion.content;

        validacion.show = true;

        $scope.show = validacion.show;
      } else if (!riskUserPassword.passwordConfirmar) {
        $rootScope.loading = false;
        var msgs = $translationService.getTranslationController(
          'Debe llenar el campo Confirmar Password.',
          'You must fill in the Confirm Password field.',
          'Você deve preencher o campo Confirmar senha.'
        );
        validacion.content = msgs;
        $scope.content = validacion.content;

        validacion.show = true;

        $scope.show = validacion.show;
      } else if (
        riskUserPassword.passwordConfirmar !== riskUserPassword.passwordNueva
      ) {
        $rootScope.loading = false;
        var msgs = $translationService.getTranslationController(
          'La contraseñas deben ser iguales.',
          'The passwords must be the same.',
          'As senhas devem ser as mesmas.'
        );
        validacion.content = msgs;
        $scope.content = validacion.content;

        validacion.show = true;

        $scope.show = validacion.show;
      }
      return validacion;
    };

    //  Método de ingreso de cambio de PASSWORD.
    $scope.cambiarPassword = function () {
      $rootScope.loading = true;
      var v = $scope.validarCambiarPassword(
        $scope.idUser,
        $scope.riskUserPassword
      );
      $scope.validacion = v;
      if (!v.show) {
        //  Llamado a servicios, en este caso de reseteo de contraseña.
        $scope.request = true;
        UserFactory.cambiarPassword($scope.idUser, $scope.riskUserPassword)
          .then(function (res) {
            $scope.riskUserPassword = [];
            $rootScope.loading = false;
            toastr.success(
              $translationService.getTranslationController(
                'Se modifico el password exitosamente',
                'The password was modified successfully',
                'A senha foi modificada com sucesso'
              )
            );
            $rootScope.$broadcast('closeModalUserPassword');
            $scope.request = false;
            return res;
          })
          .catch(function (error) {
            $rootScope.loading = false;
            if (error.status == 403) {
              toastr.error(
                $translationService.getTranslationController(
                  'Usuario no autorizado.',
                  'Unauthorized User.',
                  'Usuário não autorizado.'
                )
              );
            } else if (error.status == 406) {
              toastr.error(error.data);
            } else if (error.status == 409) {
              toastr.error(
                $translationService.getTranslationController(
                  'Clave actual incorrecta.',
                  'Wrong Current Password.',
                  'Senha atual incorreta.'
                )
              );
            } else {
              toastr.error(
                $translationService.getTranslationController(
                  'Error en el servidor, intente más tarde.',
                  'Server error, try again later.',
                  'Erro no servidor, tente novamente mais tarde.'
                )
              );
              console.log(error);
            }
          });
      }
    };

    $scope.$watch(
      'riskUserPassword.passwordNueva',
      function (newValue, oldValue) {
        if (
          angular.isDefined($scope.passwordPolicy) &&
          angular.isDefined($scope.passwordPolicy.showPasswordPolicy) &&
          $scope.passwordPolicy.showPasswordPolicy
        ) {
          $scope.passwordPolicy.minimumPasswordLengthGreen = false;
          $scope.passwordPolicy.withAtLeastOneUppercaseGreen = false;
          $scope.passwordPolicy.withAtLeastOneLowercaseGreen = false;
          $scope.passwordPolicy.withAtLeastOneDigitGreen = false;
          $scope.passwordPolicy.withAtLeastOneSymbolGreen = false;
          if (
            $scope.passwordPolicy.minimumPasswordLength > 0 &&
            newValue.length >= $scope.passwordPolicy.minimumPasswordLength
          ) {
            $scope.passwordPolicy.minimumPasswordLengthGreen = true;
          }
          var regUppercase = /[A-Z]/;
          if (
            $scope.passwordPolicy.withAtLeastOneUppercase &&
            regUppercase.test(newValue)
          ) {
            $scope.passwordPolicy.withAtLeastOneUppercaseGreen = true;
          }
          var regLowercase = /[a-z]/;
          if (
            $scope.passwordPolicy.withAtLeastOneLowercase &&
            regLowercase.test(newValue)
          ) {
            $scope.passwordPolicy.withAtLeastOneLowercaseGreen = true;
          }
          var regDigit = /[0-9]/;
          if (
            $scope.passwordPolicy.withAtLeastOneDigit &&
            regDigit.test(newValue)
          ) {
            $scope.passwordPolicy.withAtLeastOneDigitGreen = true;
          }
          var regSymbol = /[^a-zA-Z0-9]/;
          if (
            $scope.passwordPolicy.withAtLeastOneSymbol &&
            regSymbol.test(newValue)
          ) {
            $scope.passwordPolicy.withAtLeastOneSymbolGreen = true;
          }
        }
      },
      false
    );
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('ListadoUsuariosController', ListadoUsuariosController);

  ListadoUsuariosController.$inject = [
    '$scope',
    'listaUsuarios',
    '$rootScope',
    '$filter',
    'toastr',
    'translationService',
  ];
  function ListadoUsuariosController(
    $scope,
    listaUsuarios,
    $rootScope,
    $filter,
    toastr,
    $translationService
  ) {
    $scope.listadoUsuariosRoles = listaUsuarios;

    $scope.filtrarUsuario = '';

    $scope.busquedaPorFiltro = function () {
      if ($scope.filterUsers.length !== 1) {
        var msgs = $translationService.getTranslationController(
          'Debe seleccionar un registro',
          'You must select a record',
          'Você deve selecionar um registro'
        );
        toastr.error(msgs);
      } else {
        $rootScope.$broadcast('select-user', $scope.filterUsers);
      }
    };

    $scope.closeModalListadoUsuarios = function () {
      $rootScope.$broadcast('close-modal', $scope.filterUsers);
    };

    //Método para realizar traducción
    $translationService.getTranslation($scope, 'users');
  }

  angular.module('dashboard').filter('filterByUsername', function () {
    return function (array, text) {
      if (text) {
        return array.filter(function (user) {
          return user.riskUser.username.indexOf(text) > -1;
        });
      }
      return array;
    };
  });
})();

(function () {

    'use strict';

    angular
        .module('dashboard')
        .controller('UserTrackingController', UserTrackingController);

    UserTrackingController.$inject = ['$rootScope', '', '$stateParams', '$scope', '$state', 'UserTrackingFactory', 'Paginator', 'env', '$localStorageService', 'BaseUrl', 'translationService'];

    function UserTrackingController($rootScope, $modal, $stateParams, $scope, $state, UserTrackingFactory, Paginator, env, $localStorageService, BaseUrl, $translationService) {
        var vm = this;
        var dateFormat = "YYYY-MM-DD";
        vm.user = $localStorageService.getItem("currentUser.username");

        vm.refreshtable = {};

        vm.events = [];
        vm.pagination = {
            rule: [1]
        };

        //Realizar traducción para datapicker y vista
        $translationService.getTranslation($scope, 'user-tracking');

        $rootScope.tabs = $rootScope.tabsUserTracking;
        vm.filters = {
            page: 1,
            itemsPerPage: 10,
            sortBy: 'id', //'criticality',
            sort: 'desc',
            startDate: moment($stateParams.desde || (moment().hour(0).minute(0).second(0).subtract(1, 'week'))),
            endDate: moment($stateParams.hasta || (moment().hour(23).minute(59).second(59)))
        };

        vm.api = {};
        vm.filtros = $rootScope.filters.filterBy;


        vm.configUserTracking = {
            datasource: {
                origin: "GET", //REST Methods, ARRAY, WS o WSS(WebSocket).Desde localhost usar WS, con seguridad WSS
                //url: (env.ssl ? "https://" : "http://") + env.domain + (env.port ? ":" + env.port : "") + "/risk-backend/rest/audit",//"localhost:30249/risk-backend/websockets/events"//reemplazar localhost por ubicacion backend,solo para rest y ws
                url: BaseUrl.path['URL_AUDITORIA'],
                //optional values
                //autoLoad: false,
                paramsDefault: {
                    query: vm.filters.query || '',
                    sortBy: vm.filters.sortBy,
                    sort: vm.filters.sort || 'desc',
                    startDate: vm.filters.startDate.local().format(),
                    endDate: vm.filters.endDate.format(),
                    page: 1,
                    itemsPerPage: 10
                },
                params: {
                    page: 1,
                    itemsPerPage: 10,
                    sortBy: vm.filters.sortBy,
                    sort: vm.filters.sort || 'desc',
                    startDate: vm.filters.startDate.local().format(),
                    endDate: vm.filters.endDate.format(),
                },
                paramsOut: {
                    data: "content",
                    pagination: "pagination"
                }
            },
            filterDatasource: {
                //servicio utilizado para construir solamente los checkbox de los filtros
                url: BaseUrl.path['URL_AUDITORIA_FILTROS'], // "/risk-backend/rest/audit/filters",
                paramsDefault: {
                    // checked : $rootScope.filters.filterBy.event
                    checked: vm.filtros
                }
            },
            style: {
                trTooltip: function (item) { }
            },
            columns: [//columnas de la tabla, tipo de datos, header, visible/no visible.
                { name: "id", title: "Id", type: "number", hidden: false, sortable: true, filterable: { "type": "number" } },
                { name: "created", title: $translationService.getTranslationController('Fecha/Hora', 'Date/Hour', 'Data/Hora'), type: "date", hidden: false, sortable: true },
                { name: "module", title: $translationService.getTranslationController('Módulo', 'Module', 'Módulo'), type: "string", hidden: false, sortable: true, filterable: { "type": "checkbox" } },
                { name: "moduleFunction", title: $translationService.getTranslationController('Función', 'Function', 'Função'), type: "string", hidden: false, sortable: true, filterable: { "type": "checkbox" } },
                { name: "action", title: $translationService.getTranslationController('Acción', 'Action', 'Açao'), type: "String", hidden: false, sortable: true, filterable: { "type": "checkbox" } },
                { name: "logStatus", title: "Status", type: "String", hidden: false, sortable: true, filterable: { "type": "checkbox" } },
                { name: "originUrl", title: "Url", type: "string", hidden: false, sortable: true, filterable: { "type": "string" } },
            ]
        }

        vm.getSummary = function () {
            var f = vm.filters || {};
            f.query = f.query || '';
            f.sortBy = f.sortBy || 'id',//'criticality',
                f.sort = f.sort || 'desc',
                f.startDate = f.startDate || moment().format(),
                f.endDate = f.endDate || moment().format();

            moment().local();
            f.startDate = moment(f.startDate).format();
            f.endDate = moment(f.endDate).format();
            vm.api.filter(f);
        };

        vm.getSummaryExcel = function () {
            var f = vm.filters || {};
            f.query = f.query || '';
            f.sortBy = f.sortBy || 'id',//'criticality',
                f.sort = f.sort || 'desc',
                f.startDate = f.startDate || moment().format(),
                f.endDate = f.endDate || moment().format();

            moment().local();
            f.startDate = moment(f.startDate).format();
            f.endDate = moment(f.endDate).format();
            vm.api.filterExcel(f);

        }


        vm.prepareExcel = function () {
            vm.getSummaryExcel();

            var filters = angular.copy(vm.filters);
            filters.itemsPerPage = undefined;
            filters.page = undefined;
            UserTrackingFactory.findUserTrackings(filters).then(function (res) {


                var excel = {//mandatory return
                    filename: "Registos_Sistema",
                    data: []
                };

                var events = res.data;
                if (events && events.length > 0) {
                    var tfecha = $translationService.getTranslationController('Fecha', 'Date', 'Data');
                    var tusuario = $translationService.getTranslationController('Usuario', 'User', 'Usuário');
                    var ttipo = $translationService.getTranslationController('Tipo', 'Type', 'Tipo');
                    var tentidad = $translationService.getTranslationController('Entidad', 'Entity', 'Entidade');
                    var cols = [
                        { title: "Id", field: "id" },
                        { title: tfecha, field: "created" },
                        { title: tusuario, field: "userName" },
                        { title: ttipo, field: "tipo" },
                        { title: "Url", field: "url" },
                        { title: tentidad, field: "entidad" }
                    ];


                    var filname = "registro_Sistema";
                    var exportData = [];
                    exportData.push(["Id", tfecha, tusuario, ttipo, "Url", tentidad]);//"Symbol", "Window", "Cause"]);
                    for (var i = 0; i < events.length; i++) {
                        var row = [];
                        var event = events[i];

                        for (var c = 0; c < cols.length; c++) {
                            row.push(events[i][cols[c].field]);
                        }
                        var col = ["", "", ""];
                        exportData.push(row);
                    }
                    excel.data = exportData;
                    vm.api.downloadExcel(excel.filename, excel.data);
                } else {
                    console.log("sin registros de sitema");
                    return {};
                }
            });
        };




        vm.search = function () {
            vm.filters.query = vm.searchUserTracking;
            vm.filters.page = 1;
            vm.getSummary();
        };

        vm.searchOnChange = function () {
            if (vm.searchUserTracking.length == 0) {
                vm.search();
            }
        };

        vm.selectedTab = 'index';

        vm.setTab = function (newTab) {
            vm.selectedTab = newTab;
        };

        vm.isSet = function (tabNum) {
            return vm.selectedTab === tabNum;
        };

        vm.isActive = function (id) {
            return vm.isSet(id) && id != 'index';
        };

        vm.eliminarTabUserTracking = function (tabId) {
            var indexTab = -2;
            for (var i = 0; i < $rootScope.tabs.length; i++) {
                var actualTab = $rootScope.tabs[i];
                if (actualTab.id === tabId) {
                    indexTab = i;
                    break;
                }
            }
            if (indexTab > 0) {
                $rootScope.tabs.splice(indexTab, 1);
                vm.setTab('index');
            }
        };

        vm.crearTabDetalleUserTracking = function (rowUserTracking) {
            //Se recorren los tabs existentes
            var existeTab = false;
            for (var i = 0; i < $rootScope.tabs.length; i++) {
                var actualTab = $rootScope.tabs[i];
                if (actualTab.id === rowUserTracking.id) {
                    existeTab = true;
                    break;
                }
            }

            if (existeTab) {
                vm.setTab(actualTab.id);
            } else {
                // -- Se crea el nuevo tab con el detalle
                var newTab = { id: rowUserTracking.id, name: 'Tipo ' + rowUserTracking.tipo + ' - ' + rowUserTracking.id };
                // -- Se agrega el tab a la lista
                $rootScope.tabs.push(newTab);
                newTab.auditoria = rowUserTracking;
                newTab.auditoria.moment = moment(newTab.auditoria.timestamp, "DD/MM/YYYY hh:mm:ss");
                // -- newTab.auditoria.files = [];
                // -- newTab.auditoria.events = [];
                // -- newTab.uploader = new FileUploader();
                // -- newTab.uploader.onCompleteAll(function(){
                // -- obtenerArchivosTab(newTab);
                // -- });
                // -- Se obtienen los casos asociados a la alerta
                // --   obtenerCasosAsociadosAlerta(newTab);
                // -- Se obtienen los parametros de la alerta
                // --   Se obtienen los archivos de la alerta
                // --   obtenerArchivosTab(newTab);
                // -- Se obtienen los eventos de la alerta
                // --   obtenerEventosTab(newTab);
                // -- Se hace visible el nuevo tab
                vm.setTab(newTab.id);
            }

        };

        /* function obtenerEventosTab(newTab) {
            EventsFactory.getRelatedEvents(newTab.id)
                .then(function(res){
                    //console.log(res);
                    newTab.auditoria.events = res;
                    $scope.$apply();
                })
                .catch(function(err){
                    console.log("Error@obtenerEventosTab");
                    console.log(err);
                });
        }*/

        // -- Este codigo sirve para poder abrir/cargar automaticamente la pestaña de una alerta especifica
        if ($stateParams.idAlerta) {
            var alerta = $rootScope.getAlertaById($stateParams.idAlerta);
            if (alerta) {
                vm.crearTabDetalleAlerta(alerta);
            }
        }

        vm.updateTable = function () {
            vm.refreshtable();
        }
    }

})();
(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller("TokensManagerController", TokensManagerController);

  TokensManagerController.$inject = [
    "$scope",
    "$rootScope",
    "TokensFactory",
    "$mdDialog",
    "toastr",
  ];

  function TokensManagerController(
    $scope,
    $rootScope,
    $TokensFactory,
    $mdDialog,
    $toastr
  ) {
    var vm = this;
    vm.mytokens = {};
    vm.selections = [];
    vm.loading = false;

    vm.gridOptions = {
      data: [],
      multiSelect: true,
      columnDefs: [
        {
          displayName: "My Tokens",
          name: "mytoken",
          field: "mytoken",
          headerCellClass: "text-center",
          cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) {
            return row.entity.mytoken == true
              ? "text-center amber lighten-3"
              : "text-center grey lighten-3";
          },
          align: "htCenter",
          width: 100,
          cellTemplate:
            '<div class="ui-grid-cell-contents ng-binding ng-scope">{{row.entity.mytoken ? "You":"Other"}}</div>',
        },
        {
          displayName: "Owner",
          name: "owner",
          field: "owner",
          headerCellClass: "text-center",
          align: "htCenter",
        },
        {
          displayName: "Token",
          name: "shortToken",
          field: "shortToken",
          headerCellClass: "text-center",
          align: "htCenter",
          width: 300,
        },
        {
          displayName: "Expiration",
          name: "expiration",
          field: "expiration",
          headerCellClass: "text-center",
          align: "htCenter",
          width: 100,
        },
        {
          displayName: "Authenticationtype",
          name: "authenticationType",
          field: "authenticationType",
          headerCellClass: "text-center",
          align: "htCenter",
        },
        {
          displayName: "Status",
          name: "active",
          field: "active",
          headerCellClass: "text-center",
          cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) {
            return row.entity.active == true
              ? "text-center green white-text"
              : "text-center red white-text";
          },
          align: "htCenter",
          width: 100,
          cellTemplate:
            '<div class="ui-grid-cell-contents ng-binding ng-scope">{{row.entity.active ? "active":"inactive"}}</div>',
        },
        {
          displayName: "Created At",
          name: "createdAt",
          field: "createdAt",
          headerCellClass: "text-center",
          align: "htCenter",
        },
        {
          displayName: "Invalidate",
          name: "invalidate",
          headerCellClass: "text-center",
          cellClass: "text-center",
          align: "htCenter",
          width: 100,
          cellTemplate:
            '<div ng-if="row.entity.active" class="ui-grid-cell-contents ng-binding ng-scope"><button class="btn btn-danger btn-xs" ng-click="grid.appScope.invalidateToken(row.entity)">Invalidate</button></div>',
        },
      ],
      onRegisterApi: function (gridApi) {
        gridApi.selection.on.rowSelectionChanged($scope, function (row) {
          vm.selections = gridApi.selection.getSelectedRows();
        });
        gridApi.selection.on.rowSelectionChangedBatch($scope, function (row) {
          vm.selections = gridApi.selection.getSelectedRows();
        });
      },
    };

    vm.init = function () {
      myTokens();
    };
    vm.init();

    vm.invalidateSelections = function () {
      vm.loading = true;
      var Promises = [];
      vm.selections.forEach(function (e) {
        Promises.push($TokensFactory.invalidateToken(e.shortToken, e.owner));
      });

      console.log(Promises);

      Promise.all(Promises).then(function (res) {
        console.log(res);
        getAllTokens();

        $toastr.success("Tokens invalidated");
        vm.loading = false;
      });
    };

    vm.invelidateAll = function (ev) {
      var confirm = $mdDialog
        .confirm()
        .title("Would you like to invalidate all tokens?")
        .textContent("All tokens will be invalidated")
        .ariaLabel("Invalidate all tokens")
        .targetEvent(ev)
        .ok("Yes")
        .cancel("No");

      $mdDialog.show(confirm).then(
        function () {
          vm.loading = true;
          $TokensFactory.invalidateAll().then(
            function (response) {
              
                getAllTokens();
              

              $toastr.success("All tokens invalidated");
              vm.loading = false;
            },
            function (error) {
              console.error("invelidateAll", error);
            }
          );
        },
        function () {}
      );
    };

    $scope.invalidateToken = function (row) {
      var username = row.owner;
      var token = row.shortToken;
      vm.loading = true;
      $TokensFactory.invalidateToken(token, username).then(
        function (response) {
          getAllTokens();
          $toastr.success(username + "' token invalidated");
          vm.loading = false;
        },
        function (error) {
          console.error("invalidateToken", error);
        }
      );
    };

    function getAllTokens() {
      vm.loading = true;
      $TokensFactory.getAllTokens().then(
        function (response) {
          vm.gridOptions.data = response.map(function (e) {
            e.mytoken = vm.mytokens.some(function (f) {
              return f.shortToken === e.shortToken;
            });

            e.createdAt = moment(e.createdAt.replace("GMT", "")).format("lll");

            return e;
          });
          vm.loading = false;
        },
        function (error) {
          console.error("getAllTokens", error);
        }
      );
    }

    function myTokens() {
      $TokensFactory.myTokens().then(
        function (response) {
          vm.mytokens = response;
          getAllTokens();
        },
        function (error) {
          console.error("myTokens", error);
        }
      );
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('UserSecurityController', UserSecurityController);

  UserSecurityController.$inject = [
    '$scope',
    '$rootScope',
    'translationService',
  ];
  function UserSecurityController($scope, $rootScope, $translationService) {
    $translationService.getTranslation($scope, 'login');
    var vm = this;
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('SearcherController', SearcherController);

  SearcherController.$inject = [
    '$scope',
    '$state',
    '$rootScope',
    '$stateParams',
    'env',
    'SearcherConfigurationFactory',
    'toastr',
    'translationService',
    '$mdDialog',
    'IssuesFactory',
  ];

  function SearcherController(
    $scope,
    $state,
    $rootScope,
    $stateParams,
    env,
    SearcherConfigurationFactory,
    toastr,
    $translationService,
    $mdDialog,
    IssuesFactory
  ) {
    var vm = this;

    (function init() {
      //Método para realizar traducción
      $translationService.getTranslation($scope, 'searcher');

      vm.page = 1;
      vm.size = 25;
      vm.targetType = 'ISSUES';
      vm.value = undefined;
      vm.targets = ['ALL', 'LIST', 'EVIDENCE', 'ISSUES'];
      vm.targetName = undefined;
      vm.loading = false;
    })();

    vm.cancel = function (ev) {
      $mdDialog.cancel();
    };

    vm.onSearch = function () {
      if (angular.isUndefined(vm.value) || vm.value.length == 0) {
        return;
      }
      vm.loading = true;
      var search = {
        search: vm.value,
        targetType: vm.targetType != 'ALL' ? vm.targetType : null,
        targetName: vm.targetType == 'LIST' ? vm.targetName : null,
        page: vm.page,
        size: vm.size,
      };
      vm.searchResult = [];
      SearcherConfigurationFactory.search(search)
        .then(function (response) {
          vm.searchResult = response;
          $scope.$apply();
        })
        .catch(function (e) {
          toastr.error(e);
        })
        .finally(function () {
          vm.loading = false;
        });
    };

    vm.onClear = function () {
      vm.targetType = 'ISSUES';
      vm.value = undefined;
      vm.searchResult = undefined;
    };

    vm.onChangeSource = function (target) {
      vm.targetType = target;
    };

    vm.onPrevious = function () {
      vm.page = vm.page - 1;
      vm.onSearch();
    };

    vm.onNext = function () {
      vm.page = vm.page + 1;
      vm.onSearch();
    };

    vm.showDetail = function (item, ev) {
      if (item.target == 'LIST') {
        $mdDialog.cancel();
        $state.go('app.tableList', { listId: item.id, luceneQueryId: item.luceneQueryId });
      } else if (item.target != 'LIST') {
        var promises = [];
        vm.loading = true;
        promises.push(_getIssuesByUUID(item.id));
        promises.push(_getIssuesTypes(item.categoryId));
        Promise.all(promises).then(function () {
          vm.loading = false;
          $mdDialog.show({
            controller: 'IssuesDetailDialogController',
            controllerAs: 'ctrl',
            templateUrl:
              'app/dashboard/components/issues-detail-dialog/issues-detail-dialog.html',
            parent: angular.element(document.body),
            targetEvent: ev || null,
            clickOutsideToClose: false,
            multiple: true,
            locals: {
              issueTypes: vm.issueTypes,
              currentIssueType: vm.issueTypes.find(function (e) {
                return e.id == vm.selectedIssue.issueType.id;
              }),
              issue: vm.selectedIssue,
              issuesToLink: [],
              currentCategory: vm.selectedIssue.category,
            },
          });
        }, function (reason) {
          vm.loading = false;
        });
      }
    };

    function _getIssuesTypes(categoryId) {
      return new Promise(function (resolve, reject) {
        var req = {
          categoryId: categoryId,
        };
        IssuesFactory.getIssuesTypes(req)
          .then(function (res) {
            vm.issueTypes = res;
            resolve();
          })
          .catch(function (err) {
            console.log('Error@getIssuesTypes', err);
            reject();
          });
      });
    }

    function _getIssuesByUUID(uuid) {
      return new Promise(function (resolve, reject) {
        IssuesFactory.getIssueByUUID(uuid)
          .then(function (response) {
            vm.selectedIssue = response;
            vm.selectedIssue.issueType.category = vm.selectedIssue.category;
            resolve();
          })
          .catch(function (err) {
            console.log('Error@getIssuesByUUID', err);
            reject();
          });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('SchemasController', SchemasController)
    .factory('SelectedSchema', function () {
      var selectedSchema = null,
        refCols = [],
        inputLists = [],
        newRuleSchema = null;
      return {
        setNewRuleSchema: function (value) {
          newRuleSchema = value;
        },
        getNewRuleSchema: function (value) {
          return newRuleSchema;
        },
        setSchema: function (value) {
          selectedSchema = value;
        },
        getSchema: function () {
          return selectedSchema;
        },
        setRefCols: function (value) {
          refCols = value;
        },
        getRefCols: function () {
          return refCols;
        },
        setInputLists: function (value) {
          inputLists = value;
        },
        getInputLists: function (value) {
          return inputLists;
        },
        clear: function () {
          selectedSchema = null;
          refCols = [];
          inputLists = [];
          newRuleSchema = null;
        },
      };
    });

  SchemasController.$inject = [
    '$scope',
    '$rootScope',
    '$mdDialog',
    'toastr',
    'translationService',
    'SchemasFactory',
    'SelectedSchema',
    'InputListsFactory',
    'listsToGroups',
  ];
  function SchemasController(
    $scope,
    $rootScope,
    $mdDialog,
    toastr,
    $translationService,
    SchemasFactory,
    SelectedSchema,
    InputListsFactory,
    $listsToGroups
  ) {
    var vm = this;
    vm.searchText = $rootScope.schemaListSearchText || null;
    vm.displayItems = false;
    vm.collapseAll = function () {
      vm.displayItems = false;
      $rootScope.$broadcast('displayItems', false);
    };

    vm.expandAll = function () {
      vm.displayItems = true;
      $rootScope.$broadcast('displayItems', true);
    };
    vm.sort = 'asc';
    vm.toggleSort = function () {
      if (vm.sort == 'asc') vm.sort = 'desc';
      else vm.sort = 'asc';
      $scope.getSchemas();
    };

    vm.on_search_text_change = function (nval) {
      if (nval === undefined || nval === '') {
        $rootScope.schemaListSearchText = '';
        if ($scope.schemasList == null) return;
        vm.schemasTree = [];
        vm.schemasTree = $listsToGroups.createGroups(
          $scope.schemasList.data,
          'group',
          vm.sort
        );
        setTimeout(function () {
          vm.collapseAll();
        }, 200);
        return;
      }
      $rootScope.schemaListSearchText = nval;
      if ($scope.schemasList == null) return;

      var filteredItems = $scope.schemasList.data.filter(function (e) {
        nval = angular.lowercase(nval);
        return angular.lowercase(e.name).indexOf(nval) >= 0;
      }) || [null];

      vm.schemasTree = [];
      vm.schemasTree = $listsToGroups.createGroups(
        filteredItems,
        'group',
        vm.sort,
        filteredItems[0]
      );
      setTimeout(function () {
        vm.expandAll();
      }, 200);
    };

    $translationService.getTranslation($scope, 'schemas');
    $scope.mustOrderBy = { field: 'id', reverse: true };

    $scope._orderBy = function (field, reverse) {
      $scope.mustOrderBy = { field: field, reverse: reverse };
    };

    $scope.getLists = function () {
      $rootScope.loading = true;

      InputListsFactory.getLists()
        .then(function (res) {
          var inputLists = [{ id: '', name: '' }];
          inputLists = inputLists.concat(
            res.lists.map(function (e) {
              return {
                id: e.listId,
                name: e.name,
                schema: 'definitions/' + e.schema.name,
                rawSchema: e.schema,
                type: e.schema.type,
              };
            })
          );
          SelectedSchema.setInputLists(inputLists);
          $rootScope.loading = false;
        })
        .catch(function (err) {
          $rootScope.loading = false;
          toastr.info(
            $translationService.getTranslationController(
              'No se han podido obtener las listas.',
              'The lists could not be loaded.',
              'As listas não puderam ser carregadas.'
            )
          );
          console.error('Error@getLists', err);
        });
    };
    $scope.getLists();

    $scope.getSchemas = function (schema) {
      vm.schemasTree = [];
      vm.searchText = null;
      $rootScope.loading = true;
      SchemasFactory.getSchemas()
        .then(function (res) {
          $scope.schemasList = res;

          $scope.schemasList.data = $scope.schemasList.data.map(function (
            e,
            index
          ) {
            e.schemaType = e.type;
            e.schema = angular.fromJson(e.schema);
            if (typeof e.schema.definitions === 'string') {
              e.schema.definitions = angular.fromJson(e.schema.definitions);
              e.schema.definitions[e.name].properties = angular.fromJson(
                e.schema.definitions[e.name].properties
              );
            }
            return e;
          });

          $scope.refCols = [{ id: '', type: '', dataType: '' }];
          angular.forEach($scope.schemasList.data, function (col) {
            if (col.schema.definitions[col.name]) {
              angular.forEach(
                col.schema.definitions[col.name].properties,
                function (row, index) {
                  $scope.refCols.push({
                    id: 'definitions/' + col.name + '/' + index,
                    type: col.name + '.' + index,
                    dataType: row.type,
                  });
                }
              );
            }
          });
          SelectedSchema.setRefCols($scope.refCols);

          vm.schemasTree = [];
          vm.schemasTree = $listsToGroups.createGroups(
            $scope.schemasList.data,
            'group',
            vm.sort,
            schema
          );
          $rootScope.loading = false;
          setTimeout(function () {
            vm.searchText = $rootScope.schemaListSearchText || null;
          }, 2000);
        })
        .catch(function (err) {
          $rootScope.loading = false;
          toastr.info(
            $translationService.getTranslationController(
              'No se han podido obtener los datos.',
              'The data could not be loaded.',
              'Os dados não puderam ser obtidos.'
            )
          );
          console.error('Error@getSchemas', err);
        });
    };
    $scope.getSchemas();

    $scope.$on('schemaUpdated', function (ev, schema) {
      vm.schemasTree = [];
      $scope.getSchemas(schema);
    });

    $scope.showCreateSchemaDialog = function (ev, schema, copy, path) {
      if (schema) schema.copy = copy ? true : false;
      SelectedSchema.setSchema(schema);
      $mdDialog.show({
        controller: 'HotCreateSchemasController',
        controllerAs: 'ctrl',
        templateUrl:
          'app/schemas/partials/hot-create-schema/hot-dialog-create-schemas.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        locals: {
          complexSchemas: $scope.schemasList.data
            .filter(function (e) {
              return e.type == 'COMPLEX';
            })
            .map(function (e) {
              return { id: e.id, name: e.name };
            }),
          groupPath: path || null,
        },
      });
    };

    vm.openBulkSchemasImportDialog = function (ev, schema, copy, path) {
      $mdDialog.show({
        controller: 'BulkSchemasImportDialog',
        controllerAs: 'ctrl',
        templateUrl:
          'app/schemas/components/bulk-schemas-import-dialog/bulk-schemas-import-dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {},
      });
    };

    /**
     *list filter
     */
    $scope.$watch('schemas.searchText', function (nval) {
      if (nval === null) return;
      vm.on_search_text_change(nval);
    });

    $scope.$on('getSchemas', function (e) {
      $scope.getSchemas();
    });

    $scope.$on('showCreateSchemaDialog', function (e, schema, copy, path) {
      $scope.showCreateSchemaDialog(e, schema, copy, path);
    });
  }
})();

/* Agrupa las reglas en un arbol recursivo por grupos */

(function () {
  'use strict';

  angular.module('dashboard').service('schemasTreeService', schemasTreeService);

  schemasTreeService.$inject = [];
  function schemasTreeService() {
    var vm = this;
    vm.group = function (schemas) {
      vm.schemasTree = {
        type: 'group',
        groupName: 'root',
        items: [],
      };

      schemas.forEach(function (val) {
        vm.evalItem(val);
      });

      return vm.schemasTree;
    };
    vm.evalItem = function (val) {
      if (val.group && val.group != '') {
        var paths = val.group.split('/').filter(function (e) {
          return e != '';
        });
        var element = vm.schemasTree.items;
        paths.forEach(function (group, depth) {
          var max = paths.length,
            level = depth + 1;
          var _element = element.filter(function (e) {
            return e.groupName == group;
          });
          if (!_element.length) {
            element = vm.createGroup(element, group);
          } else {
            element = _element[0].items;
          }
          if (level == max) {
            val.type = 'schema';
            element.push(val);
          }
        });
      } else {
        val.type = 'schema';
        vm.schemasTree.items.push(val);
      }
    };
    vm.createGroup = function (element, group) {
      element.push({
        type: 'group',
        groupName: group,
        items: [],
      });

      return element[element.length - 1].items;
    };
  }
})();

(function () {
  'use strict';

  angular.module('dashboard').controller('RulesController', RulesController);

  RulesController.$inject = [
    '$scope',
    '$rootScope',
    '$stateParams',
    'toastr',
    'translationService',
    'timezoneService',
    'FunctionFactory',
    'listsToGroups',
    '$mdDialog',
  ];
  function RulesController(
    $scope,
    $rootScope,
    $stateParams,
    toastr,
    $translationService,
    $timezoneService,
    FunctionFactory,
    $listsToGroups,
    $mdDialog
  ) {
    $translationService.getTranslation($scope, 'rules');
    var vm = this;
    vm.isLoading = false;
    vm.realtime = $stateParams.realtime || false;
    vm.selectedAlert;
    vm.status = false;
    vm.paramsConfAlerta = [];
    vm.config = [];
    vm.searchText = $rootScope.rulesListSearchText || null;
    vm.schemaList = [];
    vm.filter = { values: [] };
    vm.newRule = {
      active: false,
      schemaIds: [],
    };
    vm.mustOrderBy = { field: 'id', reverse: false };
    vm._orderBy = function (field, reverse) {
      vm.mustOrderBy = { field: field, reverse: reverse };
    };

    vm.rulePreview = null
    $scope.$on('rulePreview', function (e, rule) {
      vm.rulePreview = rule;
    });
    

    vm.displayItems = false;
    vm.collapseAll = function () {
      vm.displayItems = false;
      $rootScope.$broadcast('displayItems', false);
    };

    vm.expandAll = function () {
      vm.displayItems = true;
      $rootScope.$broadcast('displayItems', true);
    };

    vm.sort = 'asc';
    vm.toggleSort = function () {
      if (vm.sort == 'asc') vm.sort = 'desc';
      else vm.sort = 'asc';
      vm.getFunctions();
    };

    vm.onSearchTextChange = function (nval) {
      vm.isLoading = true;
      if (nval == undefined || nval == null || nval == '') {
        $rootScope.rulesListSearchText = '';
        if (vm.config == null) return;
        vm.rulesTree = [];
        vm.rulesTree = $listsToGroups.createGroups(
          vm.config,
          'groups',
          "asc"
        );
        setTimeout(function () {
          vm.collapseAll();
          vm.isLoading = false;
        }, 200);
        return;
      }
      $rootScope.rulesListSearchText = nval;

      if (vm.config == null) return;

      var filteredItems = vm.config.filter(function (e) {
        nval = angular.lowercase(nval);
        return angular.lowercase(e.name).indexOf(nval) >= 0 || e.groups != null && e.groups.toLowerCase().indexOf(nval) >= 0;
      }) || [null];
      vm.isLoading = true;
      vm.rulesTree = [];
      vm.rulesTree = $listsToGroups.createGroups(
        filteredItems,
        'groups',
        vm.sort,
        filteredItems[0]
      );

      vm.rulePreview= null

      setTimeout(function () {
        vm.expandAll();
        vm.isLoading = false;
      }, 200);
    };

    /**
     * Rules list filter
     */
    $scope.$watch('rules.searchText', function (nval) {
      vm.onSearchTextChange(nval);
    });

    vm.getFunctions = function (rule) {
      vm.isLoading = true;
      $rootScope.loading = true;
      vm.rulesTree;
      FunctionFactory.getFunctions(vm.realtime)
        .then(function (res) {
          var cfg = res.data;
          cfg.forEach(function (c) {
            c.origintalAttr = JSON.parse(JSON.stringify(c.attributes));
            c.originalActive = c.active;
            c.filters = c.attributes.filter(function (e) {
              return e.name == 'exclude';
            });
            c.attributes = c.attributes.filter(function (e) {
              return e.name != 'exclude';
            });
            c.attributes.forEach(function (at) {
              if (at.type == 'boolean') {
                at.value == 'true' ? true : false;
              } else if (at.type == 'time') {
                var now = new Date();
                var timez = $timezoneService.zoneTimeUser();
                at.tz = moment(
                  String(now.getFullYear()) +
                    '-' +
                    String(('00' + (now.getMonth() + 1)).slice(-2)) +
                    '-' +
                    String(('00' + now.getDate()).slice(-2)) +
                    'T' +
                    at.value.split(':')[0] +
                    ':' +
                    at.value.split(':')[1] +
                    'Z'
                )
                  .tz(timez)
                  .format('Z');
                at.localTime = moment(
                  String(now.getFullYear()) +
                    '-' +
                    String(('00' + (now.getMonth() + 1)).slice(-2)) +
                    '-' +
                    String(('00' + now.getDate()).slice(-2)) +
                    'T' +
                    at.value.split(':')[0] +
                    ':' +
                    at.value.split(':')[1] +
                    'Z'
                )
                  .tz(timez)
                  .format('HH:mm');
              }
            });
            // To deprecate
            c.version = c.attributes.find(function (e) {
              return e.name == 'LIVE_VERSION';
            });
            // To deprecate
            c.attrSchedule = c.attributes.find(function (e) {
              return e.name == 'SCHEDULE';
            });
            // To deprecate
            if (c.attrSchedule) {
              c.attrSchedule.nowStr = prettyCron.toString(c.attrSchedule.value);
              c.attrSchedule.nextStr = prettyCron.getNext(c.attrSchedule.value);
            }

            if (c.schedule) {
              var cronExpression =
                c.schedule.minute +
                ' ' +
                c.schedule.hour +
                ' ' +
                c.schedule.dayOfMonth +
                ' ' +
                c.schedule.month +
                ' ' +
                c.schedule.dayOfWeek;
              c.nowStr = prettyCron.toString(cronExpression);
              c.nowStr =
                c.schedule.year == '*'
                  ? c.nowStr
                  : c.nowStr + ' in ' + c.schedule.year;
              c.nextStr = prettyCron.getNext(cronExpression);
            }
          });
          vm.config = cfg;
          vm.rulesTree = [];
          vm.rulesTree = $listsToGroups.createGroups(
            vm.config,
            'groups',
            vm.sort,
            rule
          );
        })
        .catch(function (err) {
          toastr.error(
            $translationService.getTranslationController(
              'No se han podido cargar las reglas',
              'Rules could not be loaded',
              'As regras não puderam ser carregadas'
            )
          );
          console.log('Error@getFunctions', err);
        })
        .finally(function () {
          $rootScope.loading = false;
          vm.isLoading = false;
          vm.searchText = $rootScope.rulesListSearchText;
          if (vm.searchText != '') vm.onSearchTextChange(vm.searchText);
          if (rule) {
            var elem = 'rule-' + rule.id;
            setTimeout(function () {
              document.getElementById(elem).scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              });
            }, 3000);
          }
        });
    };
    vm.getFunctions();

    vm.parseTime = function (attr) {
      // convierte la hora de localTime a UTC
      var now = new Date();
      attr.value = moment(
        String(now.getFullYear()) +
          '-' +
          String(('00' + (now.getMonth() + 1)).slice(-2)) +
          '-' +
          String(('00' + now.getDate()).slice(-2)) +
          'T' +
          String(('00' + attr.localTime.split(':')[0]).slice(-2)) +
          ':' +
          String(('00' + attr.localTime.split(':')[1]).slice(-2)) +
          attr.tz
      )
        .utc()
        .format('HH:mm');
    };

    vm.cancelar = function () {
      vm.selectedAlert = null;
    };

    vm.valType = function (t) {
      if (t == 'boolean' || t == 'time' || t == 'listime' || t == 'week')
        return t;
      return 'string';
    };

    vm.addChange = function (rule) {
      vm.config.forEach(function (r) {
        if (r.id == rule.id) {
          if (r.changes) {
            r.changes++;
          } else {
            r.changes = 1;
          }
        }
      });
      $rootScope.loading = true;
      vm.isLoading = true;
      if (rule.attributes.length) {
        for (var i = 0; i < rule.attributes.length; i++) {
          if (rule.attributes[i].type == 'week') {
            rule.attributes[i].value = rule.attributes[i].value.toString();
            delete rule.attributes[i].value.$$mdSelectId;
          }
        }
      }
      vm.saveRule(rule, []);
    };

    vm.cancelChanges = function (rule) {
      // usar un filter
      vm.config.forEach(function (r) {
        if (r.id == rule.id) {
          r.changes = 0;
          r.attributes = JSON.parse(JSON.stringify(r.origintalAttr));
          r.active = r.originalActive;
          $rootScope.loading = false;
          vm.isLoading = false;
        }
      });
      $scope.$hide();
    };

    $rootScope.saveRule = function (action, rule) {
      if (action) {
        vm.saveRule(rule, []);
      } else {
        vm.cancelChanges(rule);
      }
    };

    $scope.$on('ruleDeleted', function (e, rule) {
      vm.config = vm.config.filter(function (e) {
        return e.id != rule.id;
      });
      vm.rulesTree = [];
      // vm.rulesTree = $listsToGroups.createGroups(
      //   vm.config,
      //   'groups',
      //   vm.sort,
      //   rule
      // );
      vm.getFunctions(rule);
    });

    $scope.$on('ruleUpdated', function (event, rule) {
      var editedRule = vm.config.find(function (e) {
        return e.id == rule.id;
      });
      if (editedRule.schedule) {
        var cronExpression =
          editedRule.schedule.minute +
          ' ' +
          editedRule.schedule.hour +
          ' ' +
          editedRule.schedule.dayOfMonth +
          ' ' +
          editedRule.schedule.month +
          ' ' +
          editedRule.schedule.dayOfWeek;
        editedRule.nowStr = prettyCron.toString(cronExpression);
        editedRule.nowStr =
          editedRule.schedule.year == '*'
            ? editedRule.nowStr
            : editedRule.nowStr + ' in ' + editedRule.schedule.year;
        editedRule.nextStr = prettyCron.getNext(cronExpression);
      }
      vm.rulesTree = [];
      // vm.rulesTree = $listsToGroups.createGroups(vm.config, 'groups', vm.sort);
      vm.getFunctions(rule);
    });

    $scope.$on('onUpdate', function (e, rule) {
      vm.rulesTree = [];
      vm.getFunctions(rule);
    });
  }
})();

/* Agrupa las reglas en un arbol recursivo por grupos */

(function() {
    'use strict';
    
    angular
    .module('dashboard')
    .service('ruleTreeService', ruleTreeService);

    ruleTreeService.$inject = [];
    function ruleTreeService() {   
        var vm = this;
        vm.group = function(rules){
            vm.rulesTree = {
                type:"group",
                groupName: "root",
                items:[]
            };
            
            rules.forEach(function(val){
                vm.evalItem(val);
            })

            return vm.rulesTree;
        }
        vm.evalItem = function(val) {
            if(val.groups){
                var paths = val.groups.split("/").filter(function(e){ return e != ""});
                var element = vm.rulesTree.items;
                paths.forEach(function(group, depth){
                    var max = paths.length, level = depth + 1;
                    var _element = element.filter(function(e){ return e.groupName == group});
                    if(!_element.length){
                        element = vm.createGroup(element, group);
                    }else{
                        element = _element[0].items;
                    }
                    if(level == max){
                        val.type = "rule";
                        element.push(val);
                    }
                })
            }else{
                val.type = "rule";
                vm.rulesTree.items.push(val);
            }
        }
        vm.createGroup = function(element, group) {
            element.push({
                type:"group",
                groupName: group,
                items:[]
            });

            return element[element.length-1].items;
        }
    };
})();
(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller("RuleEditorController", RuleEditorController)
    .config(function ($mdDateLocaleProvider) {
      /**
       * @param date {Date}
       * @returns {string} string representation of the provided date
       */
      $mdDateLocaleProvider.formatDate = function (date) {
        return date ? moment(date).format("YYYY-MM-DD") : "";
      };

      /**
       * @param dateString {string} string that can be converted to a Date
       * @returns {Date} JavaScript Date object created from the provided dateString
       */
      $mdDateLocaleProvider.parseDate = function (dateString) {
        var m = moment(dateString, "L", true);
        return "m.isValid() ? m.toDate() : new Date(NaN)";
      };
    });

  RuleEditorController.$inject = [
    "$document",
    "$scope",
    "$rootScope",
    "$state",
    "$stateParams",
    "$localStorageService",
    "translationService",
    "$timeout",
    "$interval",
    "toastr",
    "$mdDialog",
    "$compile",
    "FunctionFactory",
    "PanZoomService",
    "$location",
    "plumbProvider",
    "clipboardService",
    "PermissionsFactory",
    "transformationsService",
  ];
  function RuleEditorController(
    $document,
    $scope,
    $rootScope,
    $state,
    $stateParams,
    $localStorageService,
    $translationService,
    $timeout,
    $interval,
    toastr,
    $mdDialog,
    $compile,
    $functionFactory,
    $panZoomService,
    $location,
    $plumbProvider,
    $clipboardService,
    $permissionsFactory,
    $transformationsService
  ) {
    $translationService.getTranslation($scope, "rule-editor");
    $scope.ruleCRUD = {};
    // -- Panzoom  constructor config
    $scope.pz_config = {
      zoomOnMouseWheel: false,
      keepInBounds: false,
      panOnClickDrag: true,
      zoomOnDoubleClick: false,
    };
    $scope.pz_model = {}; // PanZoom constructor model

    $scope.clicked = false;
    $scope.showCode = false;
    $scope.showBoxStats = false;
    $scope.showTransformationBar = true;
    $scope.isDarkMode = false;
    $scope.source = null;
    var currentUser = $localStorageService.getItem('currentUser');

    if (currentUser.preferences) {
      $scope.showBoxStats =
        currentUser.preferences.showBoxStats || false;
      $scope.showTransformationBar =
        currentUser.preferences.showTransformationBar || true;
      $scope.isDarkMode =
        currentUser.preferences.isDarkMode || false;
    }

    $scope.jsonOutput = "";

    var rule = this;
    rule.selectedTool = [];
    rule.transformations = [];
    rule._consoleLog = "";
    rule._consoleLogCount = 0;
    rule.hasError = false;
    rule.isChanged = false;
    rule.zoomLevel = 1;
    rule.isVersioned = false;
    rule.version = {};
    rule.multiSelection = [];
    rule.firstRun = true;
    rule.executionOutput = {};
    rule.executionData = {};
    rule.realtime = $stateParams.realtime || false;
    rule.overallBench = [];
    rule.overallBenchLabels = [];
    rule.keysPressed = {};

    $scope.$watchCollection(
      "ruleEditor.transformations",
      function (nval, oval) {
        if (angular.equals(nval, oval)) return;
        rule.buildPipeline(false, false);
      }
    );

    $scope._onGoBack = function () {
      if (rule.isVersioned || rule.isExecution) {
        $state.go("app.rule-executions", { functionId: rule.functionData.id });
      } else {
        if (rule.realtime) {
          $state.go("app.realtime-rules");
        } else {
          $state.go("app.rules");
        }
      }
    };

    $scope._onGoTo = function (to) {
      $state.go(to, { functionId: rule.functionData.id });
    };

    var transformations;
    rule.getTransformations = function () {
      $functionFactory
        .getTransformations({ realtime: rule.realtime })
        .then(function (res) {
          transformations = res;
          rule.getFunction();
        })
        .catch(function (err) {
          console.error("Error@getTransformations", err);
        });
    };

    $scope.showProperties = function () {
      $scope.propsBar.toggle();
    };

    $scope.showSchemas = function () {
      $scope.schemaBar.toggle();
    };

    $scope.chartClick = function (item, $event) {
      var boxID = item[0]._view.label.split(".")[0];
      if (!isNaN(boxID)) $("#flowchartWindow" + boxID).click();
    };

    var elementCount = 0,
      element;
    $scope.writeLog = function (type, msg, err) {
      switch (type) {
        case "success":
          rule._consoleLog =
            '<span class="typecheck-success-msg">' +
            ++rule._consoleLogCount +
            ") " +
            msg +
            "</span>" +
            "<br>" +
            rule._consoleLog;
          break;
        case "info":
          rule._consoleLog =
            '<span class="typecheck-info-msg">' +
            ++rule._consoleLogCount +
            ") " +
            msg +
            "</span>" +
            "<br>" +
            rule._consoleLog;
          break;
        case "error":
          $(".window").removeClass("has-error");
          if (err) {
            var errorBox = rule.transformations.filter(function (e) {
              return e.id == err.objectId;
            })[0];
            if (errorBox)
              $("#flowchartWindow" + err.objectId).addClass("has-error");
            rule._consoleLog =
              '<span class="typecheck-error-msg">' +
              ++rule._consoleLogCount +
              ") " +
              (errorBox ? errorBox.name : "Typecheck") +
              "." +
              err.objectId +
              " > " +
              err.msg +
              "</span><br>" +
              '<span class="typecheck-error-detail">' +
              "ErrorCode: " +
              err.errorCode +
              "<br> RelatedObject: " +
              err.relatedObject +
              "<br> System: " +
              err.system +
              "<br> Subsystem: " +
              err.subsystem +
              "<br> Object: " +
              err.object +
              "</span><br>" +
              rule._consoleLog;
          } else {
            rule._consoleLog =
              '<span class="typecheck-error-msg">' +
              ++rule._consoleLogCount +
              ") " +
              msg +
              "</span>" +
              "<br>" +
              rule._consoleLog;
          }
          break;
      }
    };

    function createElement(id, elemNum, label, inputSchemas, outputSchemas) {
      var _schema = angular.copy(rule.selectedTool[0].schema);
      var _params = angular.copy(rule.selectedTool[0].params);
      var _types = angular.copy(rule.selectedTool[0].types);

      var time = 0;
      if (
        !rule.isExecution &&
        rule.functionData.context &&
        rule.functionData.context.transformationStats[elemNum]
      ) {
        time =
          rule.functionData.context.transformationStats[elemNum].executionTime;
      }
      // Execution states
      var state = "idle";
      if (rule.isExecution) {
        if (
          rule.execution &&
          rule.execution.context.transformationStats[elemNum]
        ) {
          if (
            rule.execution.context.transformationStats[elemNum].startTime &&
            rule.execution.context.transformationStats[elemNum].finishTime
          ) {
            var startTime = $transformationsService.getDateTimeFromObject(
              rule.execution.context.transformationStats[elemNum].startTime
            );

            var finishTime = $transformationsService.getDateTimeFromObject(
              rule.execution.context.transformationStats[elemNum].finishTime
            );

            rule.execution.context.transformationStats[elemNum].executionTime =
              finishTime.diff(startTime, "ms", true);

            rule.execution.context.transformationStats[elemNum].state =
              "success";

            time =
              rule.execution.context.transformationStats[elemNum].executionTime;

            state = "success";
          } else {
            rule.execution.context.transformationStats[elemNum].state =
              "failed";
            time = 0;
            state = "failed";
          }
        }
      }

      rule.transformations.push({
        id: elemNum,
        name: rule.selectedTool[0].tool,
        label: label || rule.selectedTool[0].tool,
        type: rule.selectedTool[0].nameId,
        parameters: _params,
        optValues: rule.selectedTool[0].optValues,
        inputSchemas: inputSchemas || [],
        outputSchemas: outputSchemas || [],
        schema: _schema,
        types: _types,
        state: state,
        executionTime: time,
      });

      rule.selectedTool[0].type = $transformationsService.defineType(
        transformations,
        rule.selectedTool[0].tool,
        inputSchemas,
        outputSchemas
      );

      if (rule.selectedTool[0].tool == "Comment") {
        var elm = $(
          "<notes-widget " +
            'label="{{ ruleEditor.transformations | getFieldById:' +
            elemNum +
            ":'label' }}\"" +
            'class="note_box jtk-node"' +
            'id="' +
            id +
            '"' +
            'data-id="' +
            elemNum +
            '"' +
            'data-tool="' +
            rule.selectedTool[0].tool +
            '"' +
            'data-type="' +
            rule.selectedTool[0].type +
            '"' +
            'state="{{ ruleEditor.transformations | getFieldById:' +
            elemNum +
            ":'state' }}\"" +
            'click-handler="ruleEditor.setSelectedTransformation"' +
            'dbl-click-handler="showProperties"' +
            'ctrl-click-handler="ruleEditor.addToDragSelection"' +
            'on-progress="ruleEditor.onProgress"' +
            ">"
        ).css({
          top: rule.selectedTool[0].top,
          left: rule.selectedTool[0].left,
        });
      } else {
        var elm = $(
          "<transform-box " +
            'label="{{ ruleEditor.transformations | getFieldById:' +
            elemNum +
            ":'label' }}\"" +
            'time="ruleEditor.transformations | getFieldById:' +
            elemNum +
            ":'executionTime'\"" +
            'class="' +
            rule.selectedTool[0].clsName +
            '"' +
            'id="' +
            id +
            '"' +
            'data-id="' +
            elemNum +
            '"' +
            'data-tool="' +
            rule.selectedTool[0].tool +
            '"' +
            'data-type="' +
            rule.selectedTool[0].type +
            '"' +
            'debug="{{ ruleEditor.transformations | getFieldById:' +
            elemNum +
            ":'parameters.debug' }}\"" +
            'process-disabled="{{ ruleEditor.transformations | getFieldById:' +
            elemNum +
            ":'parameters.process-disabled' }}\"" +
            'show-stats="showBoxStats"' +
            'state="{{ ruleEditor.transformations | getFieldById:' +
            elemNum +
            ":'state' }}\"" +
            'click-handler="ruleEditor.setSelectedTransformation"' +
            'dbl-click-handler="showProperties"' +
            'ctrl-click-handler="ruleEditor.addToDragSelection"' +
            'on-progress="ruleEditor.onProgress"' +
            'realtime="' +
            rule.realtime +
            '"' +
            ">"
        ).css({
          top: rule.selectedTool[0].top,
          left: rule.selectedTool[0].left,
        });
      }
      elm = $compile(elm)($scope);
      return elm;
    }

    rule.getContext = function () {
      $functionFactory
        .getFunctionByID($stateParams.functionId)
        .then(function (res) {
          rule.functionData.context = angular.fromJson(res.context);
          rule.calculeStats();
        })
        .catch(function (err) {
          console.error("Error@getContext", err);
        });
    };

    rule.getFunction = function () {
      $functionFactory
        .getFunctionByID($stateParams.functionId)
        .then(function (res) {
          rule.isVersioned = false;
          rule.isExecution = false;
          rule.isRunning = res.running;
          rule.realtime = res.realtime;
          rule.execution = {};
          rule.execution.state = rule.realtime && res.running ? "is Running" :"Ready";

          rule.functionData = res;
          rule.functionData.structure = angular.fromJson(
            rule.functionData.structure
          );
          rule.functionData.context = angular.fromJson(
            rule.functionData.context
          );
          rule.calculeStats();
          $scope.jsonOutput = angular.toJson(rule.functionData.structure, 4);
          rule.hasError = !rule.functionData.typeCheck;

          if ($stateParams.execution) {
            $functionFactory
              .getExecutionByID($stateParams.functionId, $stateParams.execution)
              .then(function (res) {
                rule.loadExecution(res);
              })
              .catch(function (err) {
                console.error("Error@getExecutionByID", err);
                toastr.error(err);
                $state.go("app.rule-executions", {
                  functionId: rule.functionData.id,
                });
              });
          } else if ($stateParams.version) {
            $functionFactory
              .getVersionByID($stateParams.functionId, $stateParams.version)
              .then(function (res) {
                rule.loadVersion(res);
              })
              .catch(function (err) {
                console.error("Error@getVersionByID", err);
                toastr.error(err);
                $state.go("app.rule-executions", {
                  functionId: rule.functionData.id,
                });
              });
          } else {
            rule.loadFlowchart();
          }
        })
        .catch(function (err) {
          console.error("Error@getFunctionByID", err);
        });
    };

    /**
     * Execution statistics calculations
     */
    rule.calculeStats = function () {
      if (
        rule.functionData.context &&
        rule.functionData.context.startTime &&
        rule.functionData.context.finishTime
      ) {
        rule.functionData.context.executionTime = 0;

        var startTime = $transformationsService.getDateTimeFromObject(
          rule.functionData.context.startTime
        );

        var finishTime = $transformationsService.getDateTimeFromObject(
          rule.functionData.context.finishTime
        );

        rule.functionData.context.executionTime = finishTime.diff(
          startTime,
          "ms",
          true
        );
      }

      if (rule.functionData.context) {
        rule.overallBench = [];
        rule.overallBenchLabels = [];
        angular.forEach(
          rule.functionData.context.transformationStats,
          function (item, key) {
            if (item && item.startTime && item.finishTime) {
              if (typeof rule.functionData.structure === "string") {
                rule.functionData.structure = angular.fromJson(
                  rule.functionData.structure
                );
              }
              if (
                rule.functionData.structure.transformations.filter(function (
                  e
                ) {
                  return e.id == key;
                })[0]
              ) {
                item.executionTime = 0;
                if (item.startTime.date) {
                  var startTime = $transformationsService.getDateTimeFromObject(
                    item.startTime
                  );

                  var finishTime =
                    $transformationsService.getDateTimeFromObject(
                      item.finishTime
                    );
                } else {
                  var startTime = $transformationsService.getDateTimeFromObject(
                    {
                      date: {
                        day: item.startTime.dayOfMonth,
                        month: item.startTime.monthValue,
                        year: item.startTime.year,
                      },
                      time: {
                        hour: item.startTime.hour,
                        minute: item.startTime.minute,
                        second: item.startTime.minute,
                        nano: item.startTime.nano,
                      },
                    }
                  );

                  var finishTime =
                    $transformationsService.getDateTimeFromObject({
                      date: {
                        day: item.finishTime.dayOfMonth,
                        month: item.finishTime.monthValue,
                        year: item.finishTime.year,
                      },
                      time: {
                        hour: item.finishTime.hour,
                        minute: item.finishTime.minute,
                        second: item.finishTime.minute,
                        nano: item.finishTime.nano,
                      },
                    });
                }

                item.executionTime = finishTime.diff(startTime, "ms", true);

                item.executionPerecent = +(
                  (item.executionTime * 100) /
                  rule.functionData.context.executionTime
                ).toFixed(2);

                rule.overallBench.push(item.executionPerecent);
                rule.overallBenchLabels.push(
                  key +
                    "." +
                    rule.functionData.structure.transformations.filter(
                      function (e) {
                        return e.id == key;
                      }
                    )[0].label
                );
              }
              if (rule.transformations.length > 0) {
                var transf =
                  rule.transformations.find(function (t) {
                    return t.id === key;
                  }) || false;
                if (transf) transf.executionTime = item.executionTime;
              }
            }
          }
        );
      }
    };

    rule.toggleBoxStats = function () {
      var currentUser = $localStorageService.getItem('currentUser');
      if (!currentUser.preferences) {
        currentUser.preferences = {};
      }
      $scope.showBoxStats = !$scope.showBoxStats;
      currentUser.preferences.showBoxStats = $scope.showBoxStats;
    };

    rule.toggleTransformationBar = function () {
      var currentUser = $localStorageService.getItem('currentUser');
      if (!currentUser.preferences) {
        currentUser.preferences = {};
      }
      $scope.showTransformationBar = !$scope.showTransformationBar;
      currentUser.preferences.showTransformationBar =
        $scope.showTransformationBar;
    };

    rule.toggleDarkMode = function () {
      var currentUser = $localStorageService.getItem('currentUser');
      if (!currentUser.preferences) {
        currentUser.preferences = {};
      }
      $scope.isDarkMode = !$scope.isDarkMode;
      currentUser.preferences.isDarkMode = $scope.isDarkMode;
    };

    rule.addToDragSelection = function (id, dataId) {
      if (
        rule.selectedTransform &&
        dataId != rule.selectedTransform.id &&
        !rule.multiSelection.filter(function (e) {
          return e.dataId == rule.selectedTransform.id;
        }).length
      ) {
        var selectedDOMId = "flowchartWindow" + rule.selectedTransform.id;
        rule.instance.addToDragSelection(selectedDOMId);
        rule.multiSelection.push({
          id: selectedDOMId,
          dataId: rule.selectedTransform.id,
        });
        rule.selectedTransform = undefined;
      }

      if (
        !rule.multiSelection.filter(function (e) {
          return e.dataId == dataId;
        }).length
      ) {
        rule.instance.addToDragSelection(id);
        rule.multiSelection.push({ id: id, dataId: dataId });
      } else {
        rule.instance.removeFromDragSelection(id);
        rule.multiSelection = rule.multiSelection.filter(function (e) {
          return e.dataId != dataId;
        });
      }

      $scope.propsBar.close();
      $scope.schemaBar.close();
    };

    rule.setSelectedTransformation = function (dataId) {
      rule.selectedTransform = null;

      rule.instance.clearDragSelection();
      rule.multiSelection = [];

      angular.forEach(rule.instance.getConnections(), function (connection) {
        connection.removeClass("stream-active stream-success");
      });

      rule.selectedTransform = rule.transformations.find(function (e) {
        if (e && e.types && !e.types.predicate && e.id == dataId){
          return e.id == dataId;
        }
        if(e.id == dataId){
          $timeout(function(){
            rule.selectedTransform = e;
          }, 1000);
        }
      });

      if (rule.functionData.context) {
        var transformationStats =
          rule.functionData.context.transformationStats[parseInt(dataId)] ||
          undefined;

        rule.selectedContext = transformationStats;

        if (rule.selectedContext) rule.selectedContext.dataId = dataId;
      }
    };

    function drawElement(element, canvasId, name, elemNum) {
      $(canvasId).append(element);
      _addEndpoints(
        name,
        rule.selectedTool[0].startpoints,
        rule.selectedTool[0].endpoints,
        elemNum
      );
      rule.instance.draggable(rule.instance.getSelector(".jtk-node"), {
        grid: [10, 10],
      });
    }

    // -- Add the endpoints for the elements
    var ep,
      sourcepointList = [],
      endpointList = [];
    var _addEndpoints = function (toId, sourceAnchors, targetAnchors, elemNum) {
      var tics = 1 / (sourceAnchors * 2),
        offset = 0;

      for (var i = 0; i < sourceAnchors; i++) {
        var sourceOutputSchema = toId + "_source_" + i;
        ep = rule.instance.addEndpoint(
          "flowchart" + toId,
          $plumbProvider.getSource(rule.realtime),
          {
            radius: 4,
            anchor: [1, tics + tics * offset, 1, 0],
            uuid: sourceOutputSchema,
          }
        );
        offset += 2;

        sourcepointList.push(["flowchart" + toId, ep]);
        ep.canvas.setAttribute(
          "title",
          $translationService.getTranslationController(
            "Arrastra una conexión desde aquí",
            "Drag a connection from here",
            "Arraste uma conexão daqui"
          )
        );
        ep = null;
      }

      var tics = 1 / (targetAnchors * 2),
        offset = 0;
      for (var j = 0; j < targetAnchors; j++) {
        var targetInputSchema = toId + "_target_" + j;
        ep = rule.instance.addEndpoint(
          "flowchart" + toId,
          $plumbProvider.getTarget(rule.realtime),
          {
            radius: 4,
            anchor: [0, tics + tics * offset, -1, 0],
            uuid: targetInputSchema,
          }
        );
        offset += 2;

        endpointList.push(["flowchart" + toId, ep]);
        ep.canvas.setAttribute(
          "title",
          $translationService.getTranslationController(
            "Deja una conexión aquí",
            "Drop a connection here",
            "Solte uma conexão aqui"
          )
        );
        ep = null;
      }
    };

    function repositionElement(id, posX, posY) {
      $("#" + id).css("left", posX);
      $("#" + id).css("top", posY);
      rule.instance.repaint(id);
    }

    rule.clear = function (ev) {
      if (!rule.checkState()) return false;
      var confirm = $mdDialog
        .confirm()
        .title(
          $translationService.getTranslationController(
            "¿Limpiar Todo?: ",
            "Clear All?",
            "Limpar tudo?"
          )
        )
        .textContent(
          $translationService.getTranslationController(
            "¡Cuidado!, Esta acción no puede revertirse",
            "Warning!, This action cannot be reverted",
            "Cuidado! Esta ação não pode ser revertida"
          )
        )
        .ariaLabel("Clear-Question")
        .targetEvent(ev)
        .ok(
          $translationService.getTranslationController(
            "Si, elimina todo",
            "Yes, clear all",
            "Sim, limpa tudo"
          )
        )
        .cancel(
          $translationService.getTranslationController(
            "Aún no",
            "Not yet",
            "Ainda não"
          )
        );

      $mdDialog.show(confirm).then(
        function () {
          rule.cleanAll();
          $scope.propsBar.close();
          $scope.schemaBar.close();
        },
        function () {}
      );
    };

    rule.cleanAll = function () {
      $scope.isCleaning = true;
      rule.instance.deleteEveryEndpoint();
      $("#canvas").empty();
      elementCount = 0;
      rule.transformations = [];
    };

    rule.typeCheck = function (req) {
      rule.firstRun = false;
      if (!rule.checkState()) return false;
      rule.isChecking = true;
      // -- convertir a string los valores de los parametros
      angular.forEach(req.transformations, function (item, key) {
        angular.forEach(item.parameters, function (value, _key) {
          if (typeof value == "object" && value != null) {
            req.transformations[key].parameters[_key] = angular.toJson(value);
            value = angular.toJson(value);
          }
        });
      });

      $functionFactory
        .typeCheck(rule.functionData.id, req, rule.realtime)
        .then(function (res) {
          angular.forEach(res.transformations, function (value, key) {
            rule.transformations[key].inputSchemas = value.inputSchemas;
            rule.transformations[key].outputSchemas = value.outputSchemas;
          });
          rule.isChecking = false;
          rule.hasError = false;
          rule.buildPipeline(false, false, true);
          $(".window").removeClass("has-error");

          toastr.success(
            $translationService.getTranslationController(
              "Typecheck exitoso",
              "Typecheck success",
              "Typecheck sucesso"
            )
          );
          $scope.writeLog(
            "success",
            $translationService.getTranslationController(
              "Typecheck exitoso",
              "Typecheck success",
              "Typecheck sucesso"
            )
          );
        })
        .catch(function (err) {
          $scope.writeLog("error", "", err);
          rule.hasError = true;
          rule.isChecking = false;
          rule.terminal.open();
          console.error("Error@typeCheck", err);

          var res = angular.fromJson(err.optionalEntity);
          angular.forEach(res.transformations, function (value, key) {
            rule.transformations[key].inputSchemas = value.inputSchemas;
            rule.transformations[key].outputSchemas = value.outputSchemas;
          });
        });
    };

    /**
     * Executes a rule
     * @returns {boolean|void}
     */
    rule.execute = function () {
      $scope.propsBar.close();
      $scope.schemaBar.close();
      if (!rule.functionData.id) {
        toastr.info(
          $translationService.getTranslationController(
            "Regla no encontrada",
            "Rule not found",
            "Regra não encontrada"
          )
        );
        return false;
      }
      if (!rule.checkState()) return false;
      if (rule.hasError) {
        toastr.warning("Typecheck error.");
        return false;
      }
      rule.prepareExecution();

      $scope.writeLog(
        "info",
        $translationService.getTranslationController(
          "Iniciando...",
          "Starting...",
          "Iniciando..."
        )
      );

      $rootScope.loading = true;
      rule.onProgress = true;
      // console.log("Executing rule", rule.functionData.id);
      rule.executionTracking();
      $timeout(function () {
        // Wait for sse connection
        $functionFactory
          .executeV2(rule.functionData.id, false)
          .then(function (res) {
            console.log("Success@executeV2", res);
            rule.executionData = res;

            if (rule.executionData.executionId) {
              rule.getExecutionStatus(rule.executionData.executionId);
            }

            $scope.writeLog(
              "info",
              $translationService.getTranslationController(
                "Ejecutando...",
                "Executing...",
                "Executando..."
              )
            );
            $rootScope.loading = false;
            if(rule.realtime) rule.isRunning = false;
            else rule.isRunning = false;
          })
          .catch(function (err) {
            console.error("Error@executeV2");
            _onExecutionFinished();

            toastr.warning(
              $translationService.getTranslationController(
                "La regla no pudo ser ejecutada",
                "The rule could not be executed",
                "A regra não pôde ser executada"
              )
            );
            rule.execution.state = $translationService.getTranslationController(
              "Ejecución fallida",
              "Execution failed",
              "Execução falhou"
            );

            $scope.writeLog("error", "", err);
            rule.terminal.open();

            $rootScope.loading = false;
            rule.hasError = true;
            rule.onProgress = false;
            if(rule.realtime === true) rule.isRunning = true;
            else rule.isRunning = false;
          });
      }, 500);
    };

    rule.checkState = function () {
      if (rule.onProgress) {
        toastr.info(
          $translationService.getTranslationController(
            "Ejecución en progreso, por favor espere.",
            "Execution in progress, please wait.",
            "Execução em andamento, por favor aguarde."
          )
        );
        return false;
      }
      if (rule.isChecking) {
        toastr.info(
          $translationService.getTranslationController(
            "Typecheck en progreso, por favor espere.",
            "Typecheck in progress, please wait.",
            "Typecheck em andamento, por favor aguarde."
          )
        );
        return false;
      }
      if (rule.isSaving) {
        toastr.info(
          $translationService.getTranslationController(
            "Guardando regla, por favor espere.",
            "Saving rule, please wait.",
            "Salvo em andamento, por favor aguarde."
          )
        );
        return false;
      }
      if (rule.isVersioned) {
        toastr.info(
          $translationService.getTranslationController(
            "La versión de la regla no es editable.",
            "Rule version is not editable.",
            "A versão da regra não é editável."
          )
        );
        return false;
      }
      if (rule.isExecution) {
        toastr.info(
          $translationService.getTranslationController(
            "La ejecución de la regla no es editable.",
            "Rule executiom is not editable.",
            "A execução da regra não é editável."
          )
        );
        return false;
      }
      return true;
    };

    /**
     * Stop the execution
     * @returns {boolean|void}
     */
    rule.stopExecution = function () {
      if (!rule.realtime && !rule.executionData.executionId) {
        var msg = $translationService.getTranslationController(
          "No se puede detener, intente de nuevo",
          "Can't stop, try again",
          "Não pode parar, tente novamente"
        );
        toastr.warning(msg);
        return;
      }

      rule.isStoping = true;
      var id = rule.executionData.executionId;
      if (rule.realtime) id = rule.functionData.id;

      $functionFactory
        .stopExecutionV2(id)
        .then(function (res) {
          rule.executionData.executionId = false;
          var msg = $translationService.getTranslationController(
            "Ejecución detenida",
            "Execution stopped",
            "Execução interrompida"
          );
          $scope.writeLog("info", msg);
          toastr.warning(msg);

          _onExecutionFinished();
          $rootScope.loading = false;
        })
        .catch(function (err) {
          console.error("Error@stop_execution");
          var msg = $translationService.getTranslationController(
            "No se ha podido detener",
            "Could not stop",
            "Não foi possível parar"
          );
          toastr.warning(msg);
          rule.execution.state =
            $translationService.getTranslationController(msg);

          $scope.writeLog("error", "", msg);
        })
        .finally(function () {
          rule.isStoping = false;
          rule.getFunction()
        });
    };

    rule.setVersion = function (version) {
      if (rule.realtime) {
        $location.path(
          "rules/realtime/editor/" +
            rule.functionData.id +
            "/version/" +
            version.id
        );
      } else {
        $location.path(
          "rules/editor/" + rule.functionData.id + "/version/" + version.id
        );
      }
    };

    rule.loadExecution = function (execution) {
      rule.isExecution = false;
      if (rule.checkState()) {
        if (!execution.code) {
          toastr.warning(
            $translationService.getTranslationController(
              "Pipeline inválido, imposible cargar la ejecución.",
              "Invalid Pipeline, impossible to load execution.",
              "Pipeline inválido, impossível de carregar a execução"
            )
          );
          return false;
        }
        rule.execution = execution;
        rule.execution.context = angular.fromJson(rule.execution.context);
        rule.functionData.context = rule.execution.context;
        rule.calculeStats();
        $scope.jsonOutput = execution.code;
        rule.loadFlowchart();
        rule.isExecution = true;
        $scope.showBoxStats = true;
        return true;
      } else {
        return false;
      }
    };

    rule.loadVersion = function (version) {
      rule.isVersioned = false;
      if (rule.checkState()) {
        if (!version.pipeline) {
          toastr.warning(
            $translationService.getTranslationController(
              "Pipeline inválido, imposible cargar la versión.",
              "Invalid Pipeline, impossible to load version.",
              "Pipeline inválido, impossível de carregar a versão"
            )
          );
          return false;
        }
        rule.version = version;
        $scope.jsonOutput = version.pipeline;
        rule.loadFlowchart();
        rule.isVersioned = true;
        return true;
      } else {
        return false;
      }
    };

    rule.getCurrentVersion = function () {
      $location.path("rules/editor/" + rule.functionData.id);
    };

    rule.setCurrentVersion = function () {
      if (rule.isExecution) {
        toastr.info("Can't set version in execution mode");
        return false;
      }
      $functionFactory
        .setCurrentVersion(rule.functionData.id, rule.version.id)
        .then(function (res) {
          rule.getCurrentVersion();
          toastr.info("Pipeline updated");
        })
        .catch(function (err) {
          $rootScope.loading = false;
          toastr.error(
            $translationService.getTranslationController(
              "No se ha podido actualizar",
              "Could not update",
              "Não foi possível atualizar"
            )
          );
          console.error("Error@setCurrentVersion", err);
        });
    };

    rule.loadFlowchart = function () {
      if (!rule.checkState()) return false;
      if ($scope.jsonOutput == undefined) return false;
      if ($scope.jsonOutput.length < 5) {
        toastr.info(
          $translationService.getTranslationController(
            "Por favor, rellene el código",
            "Please fill the pipeline code",
            "Por favor, preencha o código"
          )
        );
        return false;
      }
      rule.cleanAll();
      $scope.showCode = false;
      $timeout(function () {
        try {
          var flowChart = JSON.parse($scope.jsonOutput);
        } catch (e) {
          var errMsg = $translationService.getTranslationController(
            "No se ha podido cargar el pipeline, JSON inválido; ",
            "Could not load pipeline, invalid JSON; ",
            "Não foi possível carregar o pipeline, JSON inválido; "
          );
          // console.log(errMsg, e);
          $scope.writeLog("error", errMsg + e);
          toastr.error(errMsg);
          rule.terminal.open();
          return false;
        }

        var nodes = flowChart.nodes;

        rule.zoomLevel = flowChart.layout ? flowChart.layout.zoom : 1;
        if (rule.zoomLevel != 1) rule.setZoom(rule.zoomLevel);

        $.each(nodes, function (index, elem) {
          var params = transformations.filter(function (e) {
            return e.name == elem.nodeType;
          });

          if (params.length) {
            elem.clsName =
              "window step jsplumb-connected-step md-truncate custom jtk-node jtk-endpoint-anchor jtk-managed jtk-draggable jtk-connected";
            elem.sources = $transformationsService.getAnchors(
              elem.sources,
              flowChart.transformations[index].outputSchemas
            );
            elem.targets = $transformationsService.getAnchors(
              elem.targets,
              flowChart.transformations[index].inputSchemas
            );
            rule.selectedTool = $transformationsService.loadProperties(
              elem.clsName,
              elem.label,
              elem.nodeType,
              elem.sources,
              elem.targets,
              false,
              params[0].nameId,
              params[0].parameters,
              flowChart.transformations[index].parameters,
              flowChart.transformations[index].types,
              params[0].parametersOptionalValues
            );
            var name = "Window" + elem.id;
            element = createElement(
              elem.elementId,
              elem.id,
              flowChart.transformations[index].label,
              flowChart.transformations[index].inputSchemas,
              flowChart.transformations[index].outputSchemas
            );
            $("#canvas").append(element);

            var pan = { x: 0, y: 0 };
            if (flowChart.layout && rule.firstRun) {
              var pan = {
                x: flowChart.layout.pan.x || 0,
                y: flowChart.layout.pan.y || 0,
              };
            }

            repositionElement(
              elem.elementId,
              elem.positionX + pan.x,
              elem.positionY + pan.y
            );

            _addEndpoints(
              name,
              rule.selectedTool[0].startpoints,
              rule.selectedTool[0].endpoints,
              elem.id
            );

            rule.instance.draggable(rule.instance.getSelector(".jtk-node"), {
              grid: [10, 10],
            });

            elementCount = Number(elem.id) + 1;
            element = "";
          } else {
            var errMsg = $translationService.getTranslationController(
              'Transformación "' + elem.nodeType + '" no encontrada',
              'Transformation "' + elem.nodeType + '" not found',
              'Transformação "' + elem.nodeType + '" não encontrada'
            );
            $scope.writeLog("error", errMsg);
            toastr.error(errMsg);
            rule.terminal.open();
          }
        });

        var connections = flowChart.streams;
        $.each(connections, function (index, elem) {
          var sourceUUID =
            "Window" + elem.source + "_source_" + elem.sourceOutputSchema;
          var targetUUID =
            "Window" + elem.target + "_target_" + elem.targetInputSchema;
          rule.instance.connect({
            uuids: [sourceUUID, targetUUID],
          });
        });
        if (rule.selectedTransform && rule.selectedTransform.id) {
          rule.setSelectedTransformation(rule.selectedTransform.id);
        }
      }, 50);
    };

    rule.duplicateTransformation = function () {
      if (!rule.checkState()) {
        return false;
      }
      rule.buildPipeline(false, false);
      var flowChart = JSON.parse($scope.jsonOutput);
      var nodes = flowChart.nodes;
      var selectedNode = flowChart.nodes.filter(function (e) {
        return e.id == rule.selectedTransform.id;
      })[0];

      selectedNode.clsName =
        "window step jsplumb-connected-step md-truncate custom jtk-node jtk-endpoint-anchor jtk-managed jtk-draggable jtk-connected";
      rule.selectedTool = $transformationsService.loadProperties(
        selectedNode.clsName,
        "CopyOf" + rule.selectedTransform.label,
        rule.selectedTransform.name,
        selectedNode.sources,
        selectedNode.targets,
        false,
        rule.selectedTransform.type,
        rule.selectedTransform.schema,
        rule.selectedTransform.parameters,
        rule.selectedTransform.types,
        rule.selectedTransform.optValues
      );

      var name = "Window" + elementCount;
      var id = "flowchartWindow" + elementCount;
      rule.selectedTool[0].top = selectedNode.positionY - 25;
      rule.selectedTool[0].left = selectedNode.positionX - 25;
      element = createElement(
        id,
        elementCount,
        "CopyOf" + rule.selectedTransform.label
      );
      drawElement(element, "#canvas", name, elementCount);
      elementCount++;
      element = "";
      rule.isChanged = true;
    };

    rule.copyTransformation = function () {
      if (!rule.checkState()) {
        return false;
      }

      rule.buildPipeline(false, false);
      var flowChart = JSON.parse($scope.jsonOutput);

      if (rule.multiSelection.length) {
        var selectedTools = [];

        rule.multiSelection.forEach(function (elem) {
          var selectedNode = flowChart.nodes.find(function (e) {
            return e.id == elem.dataId;
          });
          var selectedTransformation = (rule.selectedTransform =
            rule.transformations.find(function (e) {
              return e.id == elem.dataId;
            }));

          var selectedTool = $transformationsService.loadProperties(
            selectedNode.clsName,
            "CopyOf" + selectedTransformation.label,
            selectedTransformation.name,
            selectedNode.sources,
            selectedNode.targets,
            false,
            selectedTransformation.type,
            selectedTransformation.schema,
            selectedTransformation.parameters,
            selectedTransformation.types,
            selectedTransformation.optValues
          );

          selectedTools = selectedTools.concat(selectedTool);
        });

        $clipboardService.copy(angular.toJson(selectedTools));
      } else if (rule.selectedTransform) {
        var selectedNode = flowChart.nodes.find(function (e) {
          return e.id == rule.selectedTransform.id;
        });

        rule.selectedTool = $transformationsService.loadProperties(
          selectedNode.clsName,
          "CopyOf" + rule.selectedTransform.label,
          rule.selectedTransform.name,
          selectedNode.sources,
          selectedNode.targets,
          false,
          rule.selectedTransform.type,
          rule.selectedTransform.schema,
          rule.selectedTransform.parameters,
          rule.selectedTransform.types,
          rule.selectedTransform.optValues
        );

        $clipboardService.copy(angular.toJson(rule.selectedTool));
      } else {
        toastr.info(
          $translationService.getTranslationController(
            "Seleccione una transformación a copiar",
            "Select a transformation to copy",
            "Selecione uma transformação para copiar"
          )
        );
      }
    };

    rule.pasteTransformation = function (ev) {
      if (!rule.checkState()) {
        return false;
      }

      var confirm = $mdDialog
        .prompt()
        .title(
          $translationService.getTranslationController(
            "Paste Transformation",
            "Paste Transformation",
            "Colar Transformação"
          )
        )
        .textContent(
          $translationService.getTranslationController(
            "Por favor, pegue aquí la transformación copiada.",
            "Please paste here the copied transformation.",
            "Por favor, cole aqui a transformação copiada."
          )
        )
        .placeholder(
          $translationService.getTranslationController(
            "Pega el código JSON aquí",
            "Paste JSON code here",
            "Cole o código JSON aqui"
          )
        )
        .ariaLabel("Transformation json code area")
        .targetEvent(ev)
        .required(true)
        .ok(
          $translationService.getTranslationController(
            "Insertar",
            "Insert",
            "Inserir"
          )
        )
        .cancel(
          $translationService.getTranslationController(
            "Cancelar",
            "Cancel",
            "Cancelar"
          )
        );

      $mdDialog.show(confirm).then(function (result) {
        rule.buildPipeline(false, false);
        try {
          var selectedNodes = angular.fromJson(result);
          var itemHorizontalOffset = 0;
          selectedNodes.forEach(function (selectedNode) {
            selectedNode.clsName =
              "window step jsplumb-connected-step md-truncate custom jtk-node jtk-endpoint-anchor jtk-managed jtk-draggable jtk-connected";
            rule.selectedTool = $transformationsService.loadProperties(
              selectedNode.clsName,
              selectedNode.label,
              selectedNode.tool,
              selectedNode.startpoints,
              selectedNode.endpoints,
              false,
              selectedNode.nameId,
              selectedNode.schema,
              selectedNode.params,
              selectedNode.types,
              selectedNode.optValues
            );
            var name = "Window" + elementCount;
            var id = "flowchartWindow" + elementCount;

            // Handle panning of pipeline
            itemHorizontalOffset += 150;
            rule.selectedTool[0].top =
              (25 - $scope.pz_model.pan.y) / rule.zoomLevel;
            rule.selectedTool[0].left =
              (225 - $scope.pz_model.pan.x + itemHorizontalOffset) /
              rule.zoomLevel;

            element = createElement(id, elementCount, selectedNode.label);
            drawElement(element, "#canvas", name, elementCount);
            elementCount++;
            element = "";
            rule.isChanged = true;
          });
        } catch (err) {
          toastr.warning(
            $translationService.getTranslationController(
              "No se ha podido insertar la transformación",
              "The transformation could not be inserted",
              "A transformação não pôde ser inserida"
            )
          );
          console.error(err);
        }
      });
    };

    rule.deleteTransformation = function (ev) {
      if (!rule.checkState()) {
        return false;
      }
      var confirm = $mdDialog
        .confirm()
        .title(
          $translationService.getTranslationController(
            "¿Elimininar transformación?: ",
            "Delete transformation?",
            "Excluir transformação?"
          )
        )
        .textContent(
          $translationService.getTranslationController(
            "¡Cuidado!, Esta acción no puede revertirse",
            "Warning!, This action cannot be reverted",
            "Cuidado! Esta ação não pode ser revertida"
          )
        )
        .ariaLabel("Delete-Question")
        .targetEvent(ev)
        .ok(
          $translationService.getTranslationController(
            "Si, elimínala",
            "Yes, delete it",
            "Sim, elimine"
          )
        )
        .cancel(
          $translationService.getTranslationController(
            "Aún no",
            "Not yet",
            "Ainda não"
          )
        );

      $mdDialog.show(confirm).then(
        function () {
          rule.instance.remove("flowchartWindow" + rule.selectedTransform.id);
          rule.transformations = rule.transformations.filter(function (value) {
            return value.id != rule.selectedTransform.id;
          });
          $scope.propsBar.close();
          rule.isChanged = true;
          rule.buildPipeline(false, false);
        },
        function () {}
      );
    };

    rule.deleteMultiTransformation = function (ev) {
      if (!rule.checkState()) {
        return false;
      }
      var confirm = $mdDialog
        .confirm()
        .title(
          $translationService.getTranslationController(
            "¿Elimininar transformación(es)?: ",
            "Delete transformation(s)?",
            "Excluir transformação(s)?"
          )
        )
        .textContent(
          $translationService.getTranslationController(
            "¡Cuidado!, Esta acción no puede revertirse",
            "Warning!, This action cannot be reverted",
            "Cuidado! Esta ação não pode ser revertida"
          )
        )
        .ariaLabel("Delete-Question")
        .targetEvent(ev)
        .ok(
          $translationService.getTranslationController(
            "Si, elimínala(s)",
            "Yes, delete it",
            "Sim, elimine"
          )
        )
        .cancel(
          $translationService.getTranslationController(
            "Aún no",
            "Not yet",
            "Ainda não"
          )
        );

      $mdDialog.show(confirm).then(
        function () {
          angular.forEach(rule.multiSelection, function (transform, key) {
            rule.instance.remove(transform.id);
            rule.transformations = rule.transformations.filter(function (
              value,
              index,
              arr
            ) {
              return value.id != transform.dataId;
            });
          });
          $scope.propsBar.close();
          rule.isChanged = true;
          rule.buildPipeline(false, false);
          rule.multiSelection = [];
        },
        function () {}
      );
    };

    rule.removeOutputs = function (key) {
      //-- ToDo -> Set item.Uuid to persist conection on refresh
      var sourceAnchors = Number(rule.selectedTransform.parameters[key]) - 1;
      var tics = 1 / (sourceAnchors * 2),
        offset = 0;
      var deleted = false;
      angular.forEach(
        rule.instance.getEndpoints(
          "flowchartWindow" + rule.selectedTransform.id
        ),
        function (item) {
          if (
            item.isSource &&
            item.connections.length == 0 &&
            deleted == false
          ) {
            rule.instance.deleteEndpoint(item.getUuid());
            deleted = true;
          }
        }
      );

      angular.forEach(
        rule.instance.getEndpoints(
          "flowchartWindow" + rule.selectedTransform.id
        ),
        function (item) {
          if (item.isSource) {
            item.setAnchor([1, tics + tics * offset, 1, 0]);
            offset += 2;
          }
        }
      );
      rule.selectedTransform.parameters[key]--;
    };

    rule.addOutputs = function (key) {
      var sourceAnchors = Number(rule.selectedTransform.parameters[key]) + 1;
      var tics = 1 / (sourceAnchors * 2),
        offset = 0;
      var targetsCount = 0;
      angular.forEach(
        rule.instance.getEndpoints(
          "flowchartWindow" + rule.selectedTransform.id
        ),
        function (item) {
          if (item.isSource) {
            item.setAnchor([1, tics + tics * offset, 1, 0]);
            offset += 2;
            targetsCount++;
          }
        }
      );

      var toId = "Window" + rule.selectedTransform.id;
      for (var i = targetsCount; i < sourceAnchors; i++) {
        var sourceOutputSchema = toId + "_source_" + i;
        ep = rule.instance.addEndpoint(
          "flowchart" + toId,
          $plumbProvider.getSource(rule.realtime),
          {
            anchor: [1, tics + tics * offset, 1, 0],
            uuid: sourceOutputSchema,
          }
        );
        offset += 2;

        sourcepointList.push(["flowchart" + toId, ep]);
        ep.canvas.setAttribute(
          "title",
          $translationService.getTranslationController(
            "Arrastra una conexión desde aquí",
            "Drag a connection from here",
            "Arraste uma conexão daqui"
          )
        );

        ep = null;
      }

      rule.selectedTransform.parameters[key]++;
    };

    rule.buildPipeline = function (
      _save,
      _check,
      _load,
      _autoSelectTranformation
    ) {
      var totalCount = 0;
      if (elementCount > 0) {
        var nodes = [];
        var elm = $(".step.jtk-node");
        if (elm.length == 0) {
          toastr.info(
            $translationService.getTranslationController(
              "El diagrama de tener al menos un elemento",
              "The flowchart diagram should have at least one element",
              "O diagrama deve ter pelo menos um elemento"
            )
          );
        } else {
          $(".jtk-node").each(function (index, element) {
            totalCount++;
            var $element = $(element);
            var _endpts = rule.instance.getEndpoints($element.attr("id"));

            nodes.push({
              id: $element.attr("data-id"),
              elementId: $element.attr("id"),
              nodeType: $element.attr("data-tool"),
              positionX: parseInt($element.css("left"), 10),
              positionY: parseInt($element.css("top"), 10),
              label: $element.text(),
              width: $element.outerWidth(),
              height: $element.outerHeight(),
              sources: _endpts.filter(function (e) {
                return e.isSource == true;
              }).length,
              targets: _endpts.filter(function (e) {
                return e.isTarget == true;
              }).length,
            });
          });

          var connections = [];
          $.each(rule.instance.getConnections(), function (index, connection) {
            connections.push({
              connectionId: connection.id,

              sourceOutputSchema: connection.endpoints[0]
                .getUuid()
                .split("_")[2],
              targetInputSchema: connection.endpoints[1]
                .getUuid()
                .split("_")[2],

              source: connection.source.dataset.id,
              target: connection.target.dataset.id,
            });
          });

          var flowchart = {};
          flowchart.transformations = angular.copy(rule.transformations);

          // Convertir objectArray to Map del parametro tipo tabla
          angular.forEach(flowchart.transformations, function (item, i) {
            angular.forEach(item.types, function (schema, j) {
              if (schema == "table") {
                if (flowchart.transformations[i].parameters[j].length) {
                  flowchart.transformations[i].parameters[j] =
                    flowchart.transformations[i].parameters[j]
                      .map(function (e) {
                        if (e.$$hashKey) delete e.$$hashKey;
                        return e;
                      })
                      .filter(function (e) {
                        var mustSave = false;
                        angular.forEach(e, function (value) {
                          if (value != "") mustSave = true;
                        });
                        if (mustSave) return e;
                      });
                }
              }
            });
          });

          flowchart.streams = connections;
          flowchart.nodes = nodes;
          flowchart.layout = {
            pan: {
              x: $scope.pz_model.pan.x,
              y: $scope.pz_model.pan.y,
            },
            zoom: rule.zoomLevel,
          };

          flowchart.numberOfElements = totalCount;
          $scope.jsonOutput = angular.toJson(flowchart, 4);

          if (_check) {
            rule.typeCheck(angular.copy(flowchart));
          }
          if (_save) {
            rule.saveFlowchart(_autoSelectTranformation);
          }
          if (_load) {
            rule.loadFlowchart(_autoSelectTranformation);
          }
        }
      } else {
        if (!$scope.isCleaning) {
          toastr.info(
            $translationService.getTranslationController(
              "El diagrama debe tener al menos un elemento",
              "The pipeline diagram should have at least one element",
              "O diagrama deve ter pelo menos um elemento"
            )
          );
        }
        $scope.isCleaning = false;
      }
      return "done";
    };

    rule.saveFlowchart = function (_autoSelectTranformation) {
      if (!rule.checkState()) return false;
      $rootScope.loading = true;
      rule.isSaving = true;
      // -- Save on DB
      rule.functionData.structure = angular.copy($scope.jsonOutput);
      rule.functionData.structure = angular.fromJson(
        rule.functionData.structure
      );
      // Limpiar request
      angular.forEach(
        rule.functionData.structure.transformations,
        function (value, key) {
          delete value.gridOptions;
        }
      );
      rule.functionData.structure = angular.toJson(rule.functionData.structure);

      if (!rule.functionData.context) {
        rule.functionData.context = "";
      } else {
        rule.functionData.context = angular.toJson(rule.functionData.context);
      }

      delete rule.functionData.running

      $functionFactory
        .saveFunction(rule.functionData)
        .then(function (res) {
          
          rule.isChanged = false;
          $scope.writeLog(
            "info",
            $translationService.getTranslationController(
              "Pipeline guardado",
              "Pipeline saved",
              "Pipeline salvou"
            )
          );
          toastr.success(
            $translationService.getTranslationController(
              "Pipeline guardado",
              "Pipeline saved",
              "Pipeline salvou"
            )
          );
          
          if (rule.exit) {
            $state.go("app.rules");
          }
        })
        .catch(function (err) {
          $rootScope.loading = false;
          toastr.error(
            $translationService.getTranslationController(
              "No se ha podido guardar: ",
              "Could not save: ",
              "Não foi possível salvar: "
            ) + err
          );
          console.error("Error@saveFunction", err);
        })
        .finally(function () {
          rule.isSaving = false;
          rule.functionData.context =
          rule.functionData.context != ""
          ? angular.fromJson(rule.functionData.context)
          : rule.functionData.context;
          rule.functionData.structure = angular.fromJson(
            rule.functionData.structure
          );
          
          if (
            _autoSelectTranformation &&
            rule.selectedTransform &&
            rule.selectedTransform.id
          )
          rule.setSelectedTransformation(rule.selectedTransform.id);
          setTimeout(function () {
            // console.log("getFunction");
            rule.getFunction();
            $rootScope.loading = false;
          },1000)
        });
      };
      
      rule.setZoom = function (zoom) {
        var transformOrigin = [0, 0];
      var el = el || rule.instance.getContainer();
      var p = ["webkit", "moz", "ms", "o"],
        s = "scale(" + zoom + ")",
        oString =
          transformOrigin[0] * 100 + "% " + transformOrigin[1] * 100 + "%";

      for (var i = 0; i < p.length; i++) {
        el.style[p[i] + "Transform"] = s;
        el.style[p[i] + "TransformOrigin"] = oString;
      }

      el.style["transform"] = s;
      el.style["transformOrigin"] = oString;

      rule.instance.setZoom(zoom);
    };

    rule.zoom = function (type) {
      if (type === "in") {
        rule.zoomLevel += 0.02;
        rule.setZoom(rule.zoomLevel);
      } else if (type === "out") {
        rule.zoomLevel -= 0.02;
        rule.setZoom(rule.zoomLevel);
      } else if (type === "reset") {
        // Set Initial Pan
        $panZoomService.getAPI("zoomCanvas").then(function (api) {
          api.setPanning({
            x: api.model.pan.x * -1,
            y: api.model.pan.y * -1,
          });
        });
      }
    };

    rule.createVersion = function (e) {
      if (rule.hasError) {
        toastr.warning("Typecheck error.");
        return false;
      }
      if (!rule.checkState()) return false;
      $mdDialog.show({
        controller: ["$mdDialog", createVersionModalController],
        controllerAs: "ctrl",
        templateUrl: "app/rule-editor/components/dialog-create-version.html",
        scope: $scope,
        preserveScope: true,
        clickOutsideToClose: false,
      });

      function createVersionModalController($mdDialog) {
        var vm = this;
        vm.version = { rule: rule.functionData.id, env: "", title: "" };
        vm.loading = true;

        $functionFactory
          .getVersions(rule.functionData.id)
          .then(function (res) {
            vm.versions = res.sort(function (a, b) {
              return b.id - a.id;
            });
            vm.loading = false;
          })
          .catch(function (err) {
            console.error("Error@getVersions", err);
          });

        vm.saveVersion = function () {
          if (vm.version.env == "") {
            toastr.info(
              $translationService.getTranslationController(
                "Nombre del entorno requerido",
                "Environment name required",
                "Nome do ambiente requerido"
              )
            );
          } else if (vm.version.title == "") {
            toastr.info(
              $translationService.getTranslationController(
                "Titulo requerido",
                "Title required",
                "Título obrigatório"
              )
            );
          } else {
            $rootScope.loading = true;
            var request = {
              environment: vm.version.env,
              title: vm.version.title,
              functionId: vm.version.rule,
            };
            $functionFactory
              .createVersion(request)
              .then(function (res) {
                res.new = true;
                vm.versions.unshift(res);
                vm.version.env = "";
                vm.version.title = "";
                toastr.info(
                  "Version " +
                    vm.version.title +
                    " added to env. " +
                    vm.version.env
                );
              })
              .catch(function (err) {
                console.error("Error@createVersion", err);
                toastr.error(
                  $translationService.getTranslationController(
                    "No se pudo crear la versión: ",
                    "Could not create version: ",
                    "Não foi possível criar a versão: "
                  ) + err
                );
              })
              .finally(function () {
                $rootScope.loading = false;
              });
          }
        };
        vm.cancel = function () {
          $mdDialog.cancel();
        };
      }
    };

    rule.showVersions = function (e) {
      $mdDialog.show({
        controller: ["$mdDialog", versionModalController],
        controllerAs: "ctrl",
        templateUrl: "app/rule-editor/components/dialog-versions.html",
        scope: $scope,
        preserveScope: true,
        clickOutsideToClose: false,
      });

      function versionModalController($mdDialog) {
        var vm = this;
        vm.searchText = "";
        vm.searchEnv = "_all";
        vm.ruleVersions = [];
        vm.version = { rule: rule.functionData.id, env: "", title: "" };
        vm.loading = true;
        $functionFactory
          .getVersions(rule.functionData.id)
          .then(function (res) {
            vm.versions = res.sort(function (a, b) {
              return b.id - a.id;
            });
            vm.ruleVersions = angular.copy(vm.versions);
            vm.ruleEnvironments = res
              .map(function (e) {
                return e.environment;
              })
              .filter(function (elem, pos, arr) {
                return arr.indexOf(elem) == pos;
              });
            vm.loading = false;
          })
          .catch(function (err) {
            console.error("Error@getVersions", err);
          });
        vm.filterByEnv = function () {
          if (vm.searchEnv != "_all") {
            vm.ruleVersions = vm.versions.filter(function (e) {
              return e.environment == vm.searchEnv;
            });
          } else {
            vm.ruleVersions = vm.versions;
          }
        };
        vm.setVersion = function (version) {
          if (rule.setVersion(version)) $mdDialog.hide();
        };
        vm.deleteVersion = function (ev, version) {
          if (rule.isVersioned && rule.version.id == version.id) {
            toastr.error(
              $translationService.getTranslationController(
                "No se puede eliminar la versión activa",
                "The active version cannot be deleted",
                "A versão ativa não pode ser excluída"
              )
            );
            return false;
          }
          var confirm = $mdDialog
            .confirm()
            .title(
              $translationService.getTranslationController(
                "¿Elimininar versión?: ",
                "Delete rule version?",
                "Excluir versão?"
              )
            )
            .textContent(
              $translationService.getTranslationController(
                "¡Cuidado!, Esta acción no puede revertirse",
                "Warning!, This action cannot be reverted",
                "Cuidado! Esta ação não pode ser revertida"
              )
            )
            .ariaLabel("Delete-Question")
            .targetEvent(ev)
            .multiple(true)
            .ok(
              $translationService.getTranslationController(
                "Si, Elimínala",
                "Yes, Delete it",
                "Sim, elimine"
              )
            )
            .cancel(
              $translationService.getTranslationController(
                "Aún no",
                "Not yet",
                "Ainda não"
              )
            );

          $mdDialog.show(confirm).then(
            function () {
              $functionFactory
                .deleteVersion(version.id)
                .then(function (res) {
                  if (res) {
                    vm.ruleVersions = vm.ruleVersions.filter(function (e) {
                      return e.id != version.id;
                    });
                    vm.versions = vm.versions.filter(function (e) {
                      return e.id != version.id;
                    });
                    toastr.success(
                      $translationService.getTranslationController(
                        "Versión eliminada",
                        "Version deleted",
                        "versão excluída"
                      )
                    );
                  } else {
                    toastr.error(
                      $translationService.getTranslationController(
                        "No se pudo eliminar la versión",
                        "The version could not be deleted",
                        "A versão não pôde ser excluída"
                      )
                    );
                  }
                })
                .catch(function (err) {
                  console.error("Error@deleteVersion", err);
                  toastr.error(
                    $translationService.getTranslationController(
                      "No se pudo eliminar la versión",
                      "The version could not be deleted",
                      "A versão não pôde ser excluída"
                    ) + err
                  );
                });
            },
            function () {}
          );
        };
        vm.cancel = function () {
          $mdDialog.cancel();
        };
      }
    };

    rule.prepareExecution = function () {
      return new Promise(function () {
        rule.execution = {};
        rule.execution.state = "starting";
        rule.execution.box = null;
        rule.execution.progress = 0;
        angular.forEach(rule.transformations, function (value) {
          value.state = "idle";
          value.executionTime = 0;
        });
        angular.forEach(rule.instance.getConnections(), function (connection) {
          connection.removeClass("stream-active stream-success stream-empty");
        });
        $scope.propsBar.close();
        $scope.schemaBar.close();
        // rule.selectedContext = undefined;
        // rule.selectedTransform = undefined;
        rule.buildPipeline(true, false);
      });
    };

    rule.getExecutionStatus = function (executionId) {
      rule.getExecutionStatusInterval = $interval(function () {
        $functionFactory
          .getExecutionStatus(executionId)
          .then(function (res, status) {
            // console.log("getExecutionStatus", res);

            if (res.errorMessage) {
              $scope.writeLog("error", res.errorMessage);
              rule.hasError = true;
              rule.terminal.open();
            }

            if (rule.realtime===true) {
              _onExecutionFinished();
            }

            _onExecutionMessage(res);
          })
          .catch(function (e) {
            console.error("Error@getExecutionStatus", e);
          });
      }, 1500);
    };

    //** rule execution tracking services */
    function _onExecutionFinished() {
      if (rule.getExecutionStatusInterval) {
        // Close Long pull
        $interval.cancel(rule.getExecutionStatusInterval);
        rule.getExecutionStatusInterval = false;
      }

      if ($scope.source) {
        // Close SSE
        $scope.source.close();
        $scope.source = null;
      }

      rule.isChecking = false;
      rule.onProgress = false;
      if(rule.realtime===true) rule.isRunning = true;
      else rule.isRunning = false;
      rule.execution.progress = 0;

      _setTransformationToSuccessOnFinishRule();
    }

    function _setTransformationToSuccessOnFinishRule() {
      var transformationsIdle = rule.transformations.filter(function (e) {
        return e.state != "success";
      });

      angular.forEach(transformationsIdle, function (item) {
        item.state = "success";

        var _endpts = rule.instance
          .getEndpoints("flowchartWindow" + item.id)
          .filter(function (e) {
            return e.isSource == true;
          });

        angular.forEach(_endpts, function (item) {
          if (item.connections[0]) {
            item.connections[0].addClass("stream-success");
          }
        });
      });
    }

    function _onExecutionMessage(data) {
      // console.log("ExecutionMessage", data);
      if (typeof data === "string") return;

      rule.execution.state = data.parameters.STATUS;

      if (rule.execution.state == "started") {
        // Don't do anything
      } else if (rule.execution.state == "finished") {
        _onExecutionFinished();

        var processingTransform = rule.transformations.find(function (e) {
          return e.id == rule.execution.box;
        });

        if (processingTransform) {
          processingTransform.state = "success";
        }

        var msg = $translationService.getTranslationController(
          "Ejecución finalizada, ver logs para obtener los resultados",
          "Execution finished, see logs to get the results",
          "Execução concluída, veja os logs para obter os resultados"
        );
        toastr.success(msg);
        $scope.writeLog("success", msg);

        // Update stats
        rule.setContext(data.transformationStats);
        // setTimeout(function () {
        //   rule.buildPipeline(true, false);
        // }, 1500);
        if (rule.selectedTransform && rule.selectedTransform.id)
          rule.setSelectedTransformation(rule.selectedTransform.id);
      } else if (rule.execution.state == "error") {
        _onExecutionFinished();
        if (rule.execution.box != null) {
          var processingTransform = rule.transformations.find(function (e) {
            return e.id == rule.execution.box;
          });

          if (processingTransform) {
            processingTransform.state = "failed";
            angular.forEach(
              rule.instance.getConnections(),
              function (connection) {
                connection.removeClass("stream-active");
              }
            );
          }
        }

        var msg = $translationService.getTranslationController(
          "Ejecución fallida",
          "Execution failed",
          "Execução falhou"
        );
        toastr.error(msg);

        $functionFactory
          .getExecutionStatus(rule.executionData.executionId)
          .then(function (res) {
            if (res.errorMessage) {
              $scope.writeLog("error", res.errorMessage);
              rule.hasError = true;
              rule.terminal.open();
            }
          })
          .catch(function (error) {
            console.error("Error@getExecutionStatus", error);
            $scope.writeLog("error", msg);
          });

        // Update stats
        rule.setContext(data.transformationStats);
      } else {
        // OUTPUT
        if (rule.execution.step && rule.execution.box != null) {
          var processingTransform = rule.transformations.find(function (e) {
            return e.id == rule.execution.box;
          });
          if (rule.execution.state.split(": ")[0] == "processing") {
            rule.executionOutput[processingTransform.id] =
              data.transformationStats[rule.execution.box];
          }
        }

        rule.execution.progress =
          (Number(rule.execution.state.split(": ")[1].split("/")[0]) /
            Number(rule.execution.state.split(": ")[1].split("/")[1])) *
          100;
        rule.execution.step = Number(
          rule.execution.state.split(": ")[1].split("/")[0]
        );

        rule.execution.box = data.parameters.CURRENT_PROCESSING_TRANSFORMATION;
        var processingTransform = rule.transformations.find(function (e) {
          return e.id == rule.execution.box;
        });

        if (processingTransform) {
          if (rule.execution.state.split(": ")[0] == "processing") {
            processingTransform.state = "active";
            angular.forEach(
              rule.instance.getConnections(),
              function (connection) {
                connection.removeClass("stream-active");
              }
            );
            var _endpts = rule.instance
              .getEndpoints("flowchartWindow" + processingTransform.id)
              .filter(function (e) {
                return e.isSource == true;
              });
            angular.forEach(_endpts, function (item) {
              if (item.connections[0]) {
                item.connections[0].addClass("stream-active");
              }
            });
          } else if (rule.execution.state.split(": ")[0] == "processed") {
            processingTransform.state = "success";

            var _endpts = rule.instance
              .getEndpoints("flowchartWindow" + processingTransform.id)
              .filter(function (e) {
                return e.isSource == true;
              });
            var sucessStat = data.transformationStats[rule.execution.box];
            var startTime = moment(sucessStat.startTime);
            var finishTime = moment(sucessStat.finishTime);
            var executionTime = finishTime.diff(startTime, "ms", true);
            processingTransform.executionTime = executionTime;

            angular.forEach(_endpts, function (item, index) {
              if (item.connections[0]) {
                if (sucessStat.outputDataCount[index]) {
                  item.connections[0].addClass("stream-success");
                } else {
                  item.connections[0].addClass("stream-empty");
                }
              }
            });
          }
        } else {
          rule.execution.box = null;
        }
      }
    }

    rule.executionTracking = function () {
      rule.executionOutput = [];
      var chunkedUrl =
        "/risk-backend/rest/function/sse_events/" + $stateParams.functionId;
      $scope.source = new EventSource(chunkedUrl, [{ withCredentials: true }]);

      $scope.source.onopen = function () {
        rule.execution.state = "Running";
      };

      $scope.source.onerror = function (e) {
        // console.log("SSE FINISH", e);

        if (e.type == "error") {
          // console.log("Rule error on SSE");
          // rule.execution.state = 'finished';

          var transformationsIdle = rule.transformations.filter(function (e) {
            e.executionTime;
            return e.state != "success";
          });

          if (transformationsIdle.length) {
            if (!rule.getExecutionStatusInterval) {
              // Connect to longPull execution stats
              if (rule.executionData.executionId) {
                rule.getExecutionStatus(rule.executionData.executionId);
              }
            }
          } else {
            _onExecutionFinished();
          }
        }
      };

      $scope.source.onmessage = function (e) {
        var data = angular.fromJson(e.data);
        _onExecutionMessage(data);
      };
    };

    rule.setContext = function (stats) {
      rule.getContext();
      if (rule.selectedContext) {
        var ctx = stats[rule.selectedContext.dataId];
        rule.selectedContext["executionTime"] = ctx ? ctx.executionTime : null;
      }
    };

    $scope.myData = [];
    $scope.gridOptions = {
      showHeader: true,
      enableGridMenu: true,
      enableCellEditOnFocus: true,
      enableSelectAll: false,
      enableRowSelection: false,
      enableRowHeaderSelection: false,
      multiSelect: false,
      columnDefs: [
        {
          displayName: "key",
          name: "Key",
          field: "key",
          enableColumnMenu: false,
          enableSorting: false,
          enableHiding: false,
        },
        {
          displayName: "value",
          name: "Value",
          field: "value",
          enableColumnMenu: false,
          enableSorting: false,
          enableHiding: false,
        },
      ],
      gridMenuShowHideColumns: false,
      onRegisterApi: function (gridApi) {
        $scope.gridApi = gridApi;
        gridApi.edit.on.afterCellEdit(
          $scope,
          function (rowEntity, colDef, newValue, oldValue) {
            if (newValue != oldValue) {
              rule.isChanged = true;
            }
          }
        );
      },
      data: "myData",
    };

    function replaceWhiteSpacesToUnderscores(string) {
      string = string.replace(/ /gi, "_");
      return string;
    }

    function prepareDataToExport(data) {
      data =
        "data:text/json;charset=utf-8," +
        encodeURIComponent(angular.toJson(rule.functionData));
      return data;
    }

    rule.exportRule = function () {
      var fileName = replaceWhiteSpacesToUnderscores(rule.functionData.name);
      var data = prepareDataToExport(rule.functionData);

      var downloader = document.createElement("a");
      downloader.setAttribute("href", data);
      downloader.setAttribute("download", fileName + ".json");
      downloader.click();
    };

    $timeout(function () {
      jsPlumb.ready(function () {
        rule.instance = jsPlumb.getInstance({
          DragOptions: {
            cursor: "pointer",
            zIndex: 99999,
          },
          Container: "canvas",
          ConnectionsDetachable: true,
        });

        rule.instance.bind("click", function (conn) {
          var source = $(conn.source).attr("data-id");
          var sourceEndpoint = conn.endpoints[0].getUuid().split("_")[2];
          var outputSchemas = rule.transformations.filter(function (e) {
            return e.id == source;
          })[0].outputSchemas;
          rule.activeConn = conn.id;
          rule.selectedOutputSchema = outputSchemas[sourceEndpoint];
        });

        rule.instance.bind("dblclick", function (conn) {
          $scope.showSchemas();
        });

        $("#zoomCanvas").droppable({
          accept: ".window",
          over: function () {
            this.classList.add("drag-over");
          },
          out: function () {
            this.classList.remove("drag-over");
          },
          drop: function (event, ui) {
            if (rule.checkState()) {
              this.classList.remove("drag-over");
              if ($scope.clicked) {
                $scope.clicked = false;
                var name = "Window" + elementCount;
                var id = "flowchartWindow" + elementCount;

                // constants to fix the position where transformations positions in canvas after drop
                var offsetDelta = {
                  top: -9,
                  left: 11,
                };
                // Calc of position where transformation must be dropped
                rule.selectedTool[0].top =
                  (ui.position.top - offsetDelta.top - $scope.pz_model.pan.y) /
                  rule.zoomLevel;
                rule.selectedTool[0].left =
                  (ui.offset.left - offsetDelta.left - $scope.pz_model.pan.x) /
                  rule.zoomLevel;

                element = createElement(id, elementCount);
                drawElement(element, "#canvas", name, elementCount);
                elementCount++;
                element = "";
                rule.isChanged = true;
              }
            }
          },
        });

        rule.getTransformations();
      }); // JSPlumbReady

      /**
       * Bind "hotkeys" to rule-editor functions
       */
      $document.bind("keydown", function (e) {
        rule.keysPressed[e.keyCode] = true;

        if (
          _isCmdBckPressed() ||
          _isCtlBckPressed() ||
          _isCmdDelPressed() ||
          _isCtlDelPressed()
        ) {
          if (rule.selectedTransform) {
            rule.deleteTransformation();
          }
          if (rule.multiSelection.length) {
            rule.deleteMultiTransformation();
          }
        }
      });

      $document.bind("keyup", function (e) {
        rule.keysPressed = {};
      });

      function _isCmdBckPressed() {
        return rule.keysPressed[93] && rule.keysPressed[8];
      }
      function _isCtlBckPressed() {
        return rule.keysPressed[17] && rule.keysPressed[46];
      }
      function _isCmdDelPressed() {
        return rule.keysPressed[93] && rule.keysPressed[46];
      }
      function _isCtlDelPressed() {
        return rule.keysPressed[17] && rule.keysPressed[8];
      }

      /**
       * Functions thats triggers when leave view
       */
      $scope.$on("$stateChangeStart", function (event, next, current) {
        if (rule.onProgress && !rule.exit) {
          event.preventDefault();
          $mdDialog.show({
            targetEvent: event,
            template:
              "<md-dialog>" +
              '<md-dialog-content class="md-dialog-content" role="document">' +
              '   <h2 class="md-title ng-binding">' +
              $translationService.getTranslationController(
                "¡La regla está en ejecución!",
                "Rule is in execution!",
                "A regra está em execução!"
              ) +
              "   </h2>" +
              '   <div class="md-dialog-content-body ng-scope">' +
              '       <p class="ng-binding">' +
              $translationService.getTranslationController(
                "Salir en este momento podría provocar resultados inesperados",
                "Exiting at this time could lead to unexpected results",
                "Sair neste momento pode levar a resultados inesperados"
              ) +
              "       </p>" +
              "   </div>" +
              "</md-dialog-content>" +
              '<md-dialog-actions layout="row">' +
              '   <md-button ng-click="dialog.exitAnyway()">' +
              $translationService.getTranslationController(
                "Salir de todos modos",
                "Exit anyway",
                "Sair de qualquer maneira"
              ) +
              "    </md-button>" +
              "   <span flex></span>" +
              '   <md-button ng-click="dialog.abort()">' +
              $translationService.getTranslationController(
                "Cancelar",
                "Cancel",
                "Cancelar"
              ) +
              "   </md-button>" +
              "</md-dialog-actions>" +
              "</md-dialog>",
            controllerAs: "dialog",
            controller: function ($mdDialog) {
              var vm = this;
              vm.abort = function () {
                $mdDialog.hide();
              };
              vm.exitAnyway = function () {
                if (rule.getExecutionStatusInterval) {
                  // Close Long pull
                  $interval.cancel(rule.getExecutionStatusInterval);
                  rule.getExecutionStatusInterval = false;
                }
                $document.unbind("keyup");
                $panZoomService.unregisterAPI("zoomCanvas");
                rule.exit = true;
                $mdDialog.hide();
                $state.go(next.name);
              };
            },
          });
        } else if (rule.isChanged && !rule.exit) {
          event.preventDefault();
          $mdDialog.show({
            targetEvent: event,
            template:
              "<md-dialog>" +
              '<md-dialog-content class="md-dialog-content" role="document">' +
              '   <h2 class="md-title ng-binding">' +
              $translationService.getTranslationController(
                "¿Desea guardar los cambios realizados?",
                "Do you want to save the changes made?",
                "Você quer salvar as alterações feitas?"
              ) +
              "   </h2>" +
              '   <div class="md-dialog-content-body ng-scope">' +
              '       <p class="ng-binding">' +
              $translationService.getTranslationController(
                "¡Sus cambios se perderán si no son guardados!",
                "Your changes will be lost if you dont save then!",
                "Suas mudanças serão perdidas se você não salvar!"
              ) +
              "       </p>" +
              "   </div>" +
              "</md-dialog-content>" +
              '<md-dialog-actions layout="row">' +
              '   <md-button ng-click="dialog.exitWithoutSave()">' +
              $translationService.getTranslationController(
                "Salir sin guardar",
                "Exit without save",
                "Sair sem salvar"
              ) +
              "    </md-button>" +
              "   <span flex></span>" +
              '   <md-button ng-click="dialog.abort()">' +
              $translationService.getTranslationController(
                "Cancelar",
                "Cancel",
                "Cancelar"
              ) +
              "   </md-button>" +
              '   <md-button ng-click="dialog.saveAndExit()" md-autofocus>' +
              $translationService.getTranslationController(
                "Guardar y salir",
                "Save and exit",
                "Salvar e sair"
              ) +
              "   </md-button>" +
              "</md-dialog-actions>" +
              "</md-dialog>",
            controllerAs: "dialog",
            controller: function ($mdDialog) {
              var vm = this;
              vm.abort = function () {
                $mdDialog.hide();
              };
              vm.saveAndExit = function () {
                $document.off("keyup");
                $document.off("keydown");
                $panZoomService.unregisterAPI("zoomCanvas");
                rule.exit = true;
                rule.buildPipeline(false, false);
                $mdDialog.hide();
              };
              vm.exitWithoutSave = function () {
                $document.off("keyup");
                $document.off("keydown");
                $panZoomService.unregisterAPI("zoomCanvas");
                rule.exit = true;
                $mdDialog.hide();
                $state.go(next.name);
              };
            },
          });
        } else {
          $document.off("keyup");
          $document.off("keydown");
          $panZoomService.unregisterAPI("zoomCanvas");
        }
      });
    }, 200);

    rule.validatePermission = function (permission) {
      if (!angular.isDefined(rule.functionData)) {
        return false;
      }
      return $permissionsFactory.hasPermission(
        "function#" + rule.functionData.id + ":" + permission
      );
    };

    $scope.$on("buildPipeline", function () {
      rule.buildPipeline(false, false, true);
    });
  }
})();

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller("riskviewController", riskviewController);

  riskviewController.$inject = ["$scope"];

  function riskviewController($scope) {
    var vm = this;
    vm.config = {
      title: "Risk View",
      description: "Risk View lore ipsum",
      schemaName: "portal_etico_1",
      tableName: "grid_defs",
      gridName: "grid5x5",
      dataSource: "data",
      type: "risk-heatmap",
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('GraphicReportsController', GraphicReportsController);

  GraphicReportsController.$inject = [
    '$scope',
    'ReplayConfigurationFactory',
    '$mdDialog',
    'translationService',
    '$state',
    '$rootScope',
    'toastr',
  ];
  function GraphicReportsController(
    $scope,
    ReplayConfigurationFactory,
    $mdDialog,
    $translationService,
    $state,
    $rootScope,
    toastr
  ) {
    $translationService.getTranslation($scope, 'replay');

    var vm = this;
    vm.reports = [];
    vm.filteredReports = [];
    vm.searchText = '';
    vm.isLoading = false;
    vm.isEmpty = false;
    vm.hasError = '';
    vm.tabsReports = [{ id: 'index', name: 'ALL' }];
    vm.selectedTab = 'index';

    $scope.toSeries = function () {
      $state.go('app.series');
    };

    vm.getReplays = function () {
      vm.isLoading = true;
      vm.reports = [];
      ReplayConfigurationFactory.getReplays({ target: 'replay' })
        .then(function (res) {
          if (res.data.length > 0) {
            vm.reports = res.data;
          } else {
            vm.isEmpty = true;
          }
        })
        .catch(function (e) {
          console.error(e);
          vm.hasError = e.response.data.error;
        })
        .finally(function () {
          vm.isLoading = false;
        });
    };
    vm.getReplays();

    vm.setTab = function (newTab) {
      vm.selectedTab = newTab;
    };

    vm.isSet = function (tabNum) {
      return vm.selectedTab === tabNum;
    };

    vm.isActive = function (id) {
      return vm.isSet(id) && id != 'index';
    };

    vm.totab = function (item) {
      var exist = vm.tabsReports.find(function (e) {
        return e.id === item.id;
      });
      if (exist) {
        vm.setTab(item.id);
      } else {
        var newTAb = item;
        vm.tabsReports.push(newTAb);
        vm.setTab(item.id);
      }
    };

    vm.eliminarTabReport = function (tabId) {
      // TODO: Cambiar a un filter
      var indexTab = -2;
      for (var i = 0; i < vm.tabsReports.length; i++) {
        var actualTab = vm.tabsReports[i];
        if (actualTab.id === tabId) {
          indexTab = i;
          break;
        }
      }
      if (indexTab > 0) {
        vm.tabsReports.splice(indexTab, 1);
        vm.setTab('index');
      }
    };

    /********************************************** Modal remove Replay ********************************************/
    vm.removeReplay = function (_replay) {
      var confirm = $mdDialog
        .confirm()
        .title(
          $translationService.getTranslationController(
            'Eliminar Reporte Gráfico',
            'Delete Graphic Report',
            'Excluir Relatório Gráfico'
          )
        )
        .textContent(
          $translationService.getTranslationController(
            '¿Estas seguro que quieres borrarlo?',
            'Are you sure you want to delete?',
            'Tem certeza de que deseja excluir?'
          )
        )
        .ok($translationService.getTranslationController('Si', 'Yes', 'Sim'))
        .cancel(
          $translationService.getTranslationController('No', 'No', 'Não')
        );

      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loading = true;
          ReplayConfigurationFactory.deleteReplay(_replay.id).then(
            function () {
              $rootScope.loading = false;
              vm.getReplays();
              toastr.success(
                $translationService.getTranslationController(
                  'Reporte Gráfico eliminado exitosamente.',
                  'Successfully removed Graphic Report.',
                  'Relatório Gráfico excluído com sucesso.'
                )
              );
            },
            function (error) {
              console.log('Error@deleteReplay', error);
              $rootScope.loading = false;
              var msg = $translationService.getTranslationController(
                'No fue posible eliminar el Reporte Gráfico.',
                'It was not possible to delete the Graphic Report.',
                'Não foi possível excluir o Relatório Gráfico.'
              );
              toastr.error(msg);
            }
          );
        },
        function () {}
      );
    };

    /********************************************** Modal Create Replay ********************************************/
    vm.showCreateReplayDialog = function (selectedItem) {
      $mdDialog
        .show({
          controller: 'DialogCreateReplayController',
          templateUrl: 'app/replay/config/dialog-create-replay.html',
          parent: angular.element(document.body),
          clickOutsideToClose: false,
          multiple: true,
          resolve: {
            selectedItem: function () {
              return selectedItem;
            },
          },
        })
        .then(function (_replay) {
          vm.getReplays();
        });
    };

    /********************************************** Modal Share searcher*******************************************/
    vm.showShareEntityDialog = function (selectedItem) {
      $mdDialog.show({
        controller: 'ShareEntityController',
        templateUrl: 'app/acl/component/dialog-share-entity.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          selectedItem: {
            id: selectedItem.id,
            resource: 'graphic-report',
            name: selectedItem.name,
          },
          actions: ['read', 'update', 'delete'],
        },
      });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('BiReportsController', BiReportsController);

  BiReportsController.$inject = [
    '$scope',
    'ReportsFactory',
    'translationService',
    '$state',
  ];

  function BiReportsController(
    $scope,
    $reportsFactory,
    $translationService,
    $state
  ) {
    $translationService.getTranslation($scope, 'reports');

    var vm = this;
    var report = null;
    vm.pbi = {};
    vm.tipoReportes = [{ id: 'PBI', label: 'PowerBi' }];

    $scope.toSeries = function () {
      $state.go('app.credenciales');
    };

    vm.getGroups = function () {
      return new Promise(function (resolve, reject) {
        if (vm.pbi.groups) {
          resolve(true);
          return true;
        }

        $reportsFactory
          .getGroups()
          .then(function (res) {
            vm.pbi.groups = res.filter(function (elem) {
              return elem.activo == true;
            });
            $scope.$apply();
            resolve(true);
          })
          .catch(function (err) {
            console.log('Error al obtener los grupos');
            console.log(err);
            reject(false);
          });
      });
    };

    vm.getReports = function () {
      return new Promise(function (resolve, reject) {
        $reportsFactory
          .getReports({
            groupId: vm.grupo.workspaceId,
          })
          .then(function (res) {
            vm.pbi.reports = res;
            $scope.$apply();
            resolve(true);
          })
          .catch(function (err) {
            console.log('Error al obtener los grupos');
            console.log(err);
            reject(false);
          });
      });
    };

    vm.getReport = function () {
      $reportsFactory
        .getReportToken({
          groupId: vm.grupo.workspaceId,
          reportId: vm.reporte.id,
        })
        .then(function (res) {
          vm.reporte.token = res.token;
          vm.reporte.expiration = new Date(res.expiration);

          renderReport();
        });
    };

    var renderReport = function () {
      var models = window['powerbi-client'].models;
      var config = {
        type: 'report',
        tokenType: models.TokenType.Embed,
        accessToken: vm.reporte.token,
        embedUrl: vm.reporte.embedUrl,
        id: vm.reporte.id,
        settings: {
          filterPaneEnabled: true,
          navContentPaneEnabled: true,
        },
      };

      var $reportContainer = $('#reportContainer');
      report = powerbi.embed($reportContainer.get(0), config);
      report.off('loaded');
      report.on('loaded', OnloadedReport);
      report.on('error', OnErrorReport);
    };

    var OnloadedReport = function (c) {
      setTokenExpirationListener(
        vm.reporte.expiration,
        5,
        vm.reporte.id,
        vm.grupo.workspaceId
      );
      return false;
    };

    var OnErrorReport = function (e) {
      console.log(e);
      report.off('error');
    };

    var setTokenExpirationListener = function (
      tokenExpiration,
      minutesToRefresh,
      reportId,
      groupId
    ) {
      var currentTime = Date.now();
      var expiration = Date.parse(tokenExpiration);
      var safetyInterval = minutesToRefresh * 60 * 1000;
      var timeout = expiration - currentTime - safetyInterval;

      if (timeout <= 0) {
        updateToken(reportId, groupId);
      } else {
        setTimeout(function () {
          updateToken(reportId, groupId);
        }, timeout);
      }
    };

    function updateToken(reportId, groupId) {
      $reportsFactory
        .getReportToken({
          groupId: groupId,
          reportId: reportId,
        })
        .then(function (res) {
          report.setAccessToken(res.token).then(function () {
            setTokenExpirationListener(
              new Date(res.expiration),
              5,
              reportId,
              groupId
            );
          });
        });
    }
  }
})();

'use strict';

angular.module('dashboard').component('replay', {
  templateUrl: 'app/replay/replay.html',
  controllerAs: 'ctrl',
  bindings: {
    replayId: '=',
  },
  controller: ReplayController,
});

ReplayController.$inject = [
  '$scope',
  '$rootScope',
  '$stateParams',
  'ReplayConfigurationFactory',
  'toastr',
  'translationService',
  '$mdDialog',
];

function ReplayController(
  $scope,
  $rootScope,
  $stateParams,
  ReplayConfigurationFactory,
  toastr,
  $translationService,
  $mdDialog
) {
  var vm = this;
  // vm.replayId = $stateParams.replayId;

  vm.$onInit = function () {

    $translationService.getTranslation($scope, 'replay');
    getReplayFn();
  };

  vm.changeDisplay = function () {
    $rootScope.$broadcast('changeDisplay', undefined);
  };

  function getReplayFn() {
    $rootScope.loading = true;
    ReplayConfigurationFactory.getReplayById(vm.replayId)
      .then(function (response) {
        vm.replay = response;
        vm.shouldShowList = vm.replay.settings.displayListModeCharts;
        vm.showHeader = vm.replay.settings.showHeader;
        // $scope.$apply();
      })
      .catch(function (e) {
        toastr.error(e);
      })
      .finally(function () {
        $rootScope.loading = false;
      });
  }

  /********************************************** Modal Create Replay ********************************************/
  vm.showCreateReplayDialog = function (selectedItem) {
    $mdDialog
      .show({
        controller: 'DialogCreateReplayController',
        templateUrl: 'app/replay/config/dialog-create-replay.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        multiple: true,
        resolve: {
          selectedItem: function () {
            return selectedItem;
          },
        },
      })
      .then(function (_replay) {
        getReplayFn();
      });
  };
}

(function () {
  'use strict';

  angular
    .module('dashboard')
    .service('realtimeRuleEditorService', RealtimeRuleEditorService);

  RealtimeRuleEditorService.$inject = [
    'PanZoomService',
    'ruleEditorDefaults',
    'FunctionFactory',
  ];
  function RealtimeRuleEditorService(
    $panZoomService,
    $ruleEditorDefaults,
    $functionFactory
  ) {
    var vm = this;

    vm.getEditorTransformations = function (opts) {
      return $functionFactory
        .getTransformations({ realtime: opts.realtime })
        .then(function (transformations) {
          return transformations;
        })
        .catch(function (error) {
          console.log('Error@getTransformations', error);
        });
    };

    /**
     * Get rule by id from
     * @param {ruleId: number;} opts
     * @returns {Rule} rule
     */
    vm.getRule = function (opts) {
      return $functionFactory
        .getFunctionByID(opts.ruleId)
        .then(function (rule) {
          rule.structure = angular.fromJson(rule.structure);
          rule.context = angular.fromJson(rule.context);

          return rule;
        })
        .catch(function (error) {
          console.log('Error@getFunctionByID', error);
        });
    };

    /**
     * Set editor zoom
     * @param {
     *   zoomLevel: number
     *   editorInstance: JsPlumbInstance
     * } opts
     */
    vm.setZoom = function (opts) {
      var transformOrigin = [0, 0];
      var el = el || opts.editorInstance.getContainer();
      var p = ['webkit', 'moz', 'ms', 'o'],
        s = 'scale(' + opts.zoomLevel + ')',
        oString =
          transformOrigin[0] * 100 + '% ' + transformOrigin[1] * 100 + '%';

      for (var i = 0; i < p.length; i++) {
        el.style[p[i] + 'Transform'] = s;
        el.style[p[i] + 'TransformOrigin'] = oString;
      }

      el.style['transform'] = s;
      el.style['transformOrigin'] = oString;

      opts.editorInstance.setZoom(opts.zoomLevel);
    };

    /**
     * @param {
     *  x: number;
     *  y: number
     * } opts
     */
    vm.setEditorPanning = function (opts) {
      $panZoomService.getAPI('zoomCanvas').then(function (api) {
        api.setPanning(opts);
      });
    };

    vm.resetEditorPanning = function () {
      $panZoomService.getAPI('zoomCanvas').then(function (api) {
        api.setPanning({
          x: api.model.pan.x * -1,
          y: api.model.pan.y * -1,
        });
      });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('RealtimeRuleEditorController', RealtimeRuleEditorController);

  RealtimeRuleEditorController.$inject = [
    '$rootScope',
    '$stateParams',
    '$interval',
    'toastr',
    'ruleEditorDefaults',
    'translationService',
    'PanZoomService',
    'realtimeRuleEditorService',
    'transformationsService',
    'FunctionFactory',
  ];
  function RealtimeRuleEditorController(
    $rootScope,
    $stateParams,
    $interval,
    $toastr,
    $ruleEditorDefaults,
    $translationService,
    $panZoomService,
    $realtimeRuleEditorService,
    $transformationsService,
    $functionFactory
  ) {
    var vm = this;
    $translationService.getTranslation(vm, 'rule-editor');
    vm.editorStates = $ruleEditorDefaults.editorStates;

    vm.editor = {
      instance: undefined,
      zoomLevel: 1,
      isRealtime: true,
      isChanged: false,
      showTransformationsBar: true,
      selectedTools: [],
      elementCount: 0,
      element: undefined,
      hasError: false,
      showCode: false,
      transformations: [],
      firstRun: true,
      state: vm.editorStates.IDLE,
      darkMode: true,
    };

    vm.rule = {
      id: $stateParams.functionId,
      name: undefined,
      description: undefined,
      realtime: true,
      structure: {},
      context: {},
      typeCheck: true,
      transformations: [],
      execution: {},
    };

    vm.tools = {
      clicked: false,
      selected: [],
    };

    (function init() {
      var promises = [
        $realtimeRuleEditorService.getEditorTransformations({
          realtime: vm.editor.isRealtime,
        }),
        $realtimeRuleEditorService.getRule({ ruleId: vm.rule.id }),
      ];

      Promise.all(promises).then(function (results) {
        vm.editor.transformations = results[0];

        vm.rule.name = results[1].name;
        vm.rule.description = results[1].description;
        vm.rule.realtime = results[1].realtime;
        vm.rule.structure = results[1].structure;
        vm.rule.context = results[1].context;
        vm.rule.typeCheck = results[1].typeCheck;

        vm.editor.hasError = !vm.rule.typeCheck;
        vm.editor.zoomLevel = vm.rule.structure.layout
          ? vm.rule.structure.layout.zoom
          : 1;

        vm.rule.transformations = $transformationsService.buildTransformations({
          ruleStructure: vm.rule.structure,
          transformations: vm.editor.transformations,
        });

        _setInitialEditorPanning();
      });
    })();

    function _setInitialEditorPanning() {
      $realtimeRuleEditorService.setEditorPanning({
        x: vm.rule.structure.layout.pan.x || 0,
        y: vm.rule.structure.layout.pan.y || 0,
      });
    }

    vm.typeCheck = function () {
      $rootScope.loading = true;
      var ruleStructure = angular.copy(vm.rule.structure);

      // rule.firstRun = false;
      // if (!rule.checkState()) return false;
      // rule.isChecking = true;

      // -- convertir a string los valores de los parametros
      // angular.forEach(ruleStructure.transformations, function (item, key) {
      //   angular.forEach(item.parameters, function (value, _key) {
      //     if (typeof value == 'object' && value != null) {
      //       ruleStructure.transformations[key].parameters[
      //         _key
      //       ] = angular.toJson(value);
      //     }
      //   });
      // });

      vm.editor.state = vm.editorStates.TYPE_CHECKING;
      console.log('req', angular.toJson(ruleStructure));
      $functionFactory
        .typeCheck(vm.rule.id, ruleStructure, vm.editor.isRealtime)
        .then(function (res) {
          // Add response input/output schemas to current rule structure
          // This action should be in a encapsulated method in the ruleEditorService
          angular.forEach(res.transformations, function (value, key) {
            vm.rule.structure.transformations[key].inputSchemas =
              value.inputSchemas;
            vm.rule.structure.transformations[key].outputSchemas =
              value.outputSchemas;
          });
          vm.rule.typeCheck = true;
          $toastr.success(vm.translation.typecheck_success);
          $('.window').removeClass('has-error');

          // rule.isChecking = false;
          // rule.hasError = false;

          // rule.buildPipeline(false, false, true);

          // $scope.writeLog(
          //   'success',
          //   $translationService.getTranslationController(
          //     'Typecheck exitoso',
          //     'Typecheck success',
          //     'Typecheck sucesso'
          //   )
          // );
        })
        .catch(function (error) {
          console.log('Error@typeCheck', error);
          vm.rule.typeCheck = false;
          $toastr.error(vm.translation.typecheck_failed);

          // $scope.writeLog('error', '', err);
          // rule.hasError = true;
          // rule.isChecking = false;
          // rule.terminal.open();
        })
        .finally(function () {
          $rootScope.loading = false;
          vm.editor.state = vm.editorStates.IDLE;
        });
    };

    vm.executeRule = function () {
      // if (!vm.rule) {
      //   $toastr.info(
      //     $translationService.getTranslationController(
      //       'Regla no encontrada',
      //       'Rule not found',
      //       'Regra não encontrada'
      //     )
      //   );
      //   return false;
      // }
      // if (!rule.checkState()) return false;
      // if (rule.hasError) {
      //   $toastr.warning('Typecheck error.');
      //   return false;
      // }

      // rule.prepareExecution();

      // $scope.writeLog(
      //   'info',
      //   $translationService.getTranslationController(
      //     'Iniciando...',
      //     'Starting...',
      //     'Iniciando...'
      //   )
      // );

      // $rootScope.loading = true;
      // rule.onProgress = true;

      // rule.executionTracking();

      // $timeout(function () {
      //   // Wait for sse connection
      $functionFactory
        .executeV2(vm.rule.id)
        .then(function (res) {
          vm.rule.execution = res;
          vm.editor.state = vm.editorStates.RUNNING;
          $toastr.info(vm.translation.execution_in_progress);

          if (vm.rule.execution.executionId) {
            _getExecutionStatus(vm.rule.execution.executionId);
          }

          // $scope.writeLog(
          //   'info',
          //   $translationService.getTranslationController(
          //     'Ejecutando...',
          //     'Executing...',
          //     'Executando...'
          //   )
          // );
          // $rootScope.loading = false;
          // rule.isRunning = true;
        })
        .catch(function (error) {
          console.log('Error@executeV2', error);
          $toastr.warning(vm.translation.execution_failed);

          // _onExecutionFinished();

          // rule.execution.state = $translationService.getTranslationController(
          //   'Ejecución fallida',
          //   'Execution failed',
          //   'Execução falhou'
          // );

          // $scope.writeLog('error', '', err);
          // rule.terminal.open();

          // $rootScope.loading = false;
          // rule.hasError = true;
          // rule.onProgress = false;
          // rule.isRunning = false;
        });
      // }, 500);
    };

    function _getExecutionStatus(executionId) {
      vm.rule.execution.interval = $interval(function () {
        $functionFactory
          .getExecutionStatus(executionId)
          .then(function (res) {
            console.log('getExecutionStatus', res);

            // if (res.errorMessage) {
            //   $scope.writeLog('error', res.errorMessage);
            //   rule.hasError = true;
            //   rule.terminal.open();
            // }

            // _onExecutionMessage(res);
          })
          .catch(function (e) {
            console.log('Error@getExecutionStatus', e);
          });
      }, 3000);
    }

    vm.stopExecution = function () {
      if (!vm.rule.execution.executionId) {
        $toastr.warning(vm.translation.no_execution);
        return;
      }

      // rule.isStoping = true;
      $functionFactory
        .stopExecutionV2(vm.rule.execution.executionId)
        .then(function () {
          vm.rule.execution.executionId = false;
          $toastr.warning(vm.translation.execution_stopped);

          // var msg = vm.translation.execution_stopped;
          // $scope.writeLog('info', msg);
          // _onExecutionFinished();
          // $rootScope.loading = false;
        })
        .catch(function (error) {
          console.log('Error@stop_execution', error);
          // var msg = $translationService.getTranslationController(
          //   'No se ha podido detener',
          //   'Could not stop',
          //   'Não foi possível parar'
          // );
          // toastr.warning(msg);
          // rule.execution.state = $translationService.getTranslationController(
          //   msg
          // );

          // $scope.writeLog('error', '', msg);
        })
        .finally(function () {
          // rule.isStoping = false;
          _onExecutionFinished();
        });
    };

    function _onExecutionFinished() {
      $interval.cancel(vm.rule.execution.interval);
      vm.rule.execution.interval = false;
      vm.editor.state = vm.editorStates.IDLE;
    }

    vm.saveRule = function () {
      // if (!rule.checkState()) return false;
      $rootScope.loading = true;
      vm.editor.state = vm.editorStates.SAVING;

      var ruleDataObject = angular.copy(vm.rule);
      // Limpiar request
      angular.forEach(ruleDataObject.structure.transformations, function (
        value
      ) {
        delete value.gridOptions;
      });
      ruleDataObject.structure = angular.toJson(ruleDataObject.structure);

      if (!ruleDataObject.context) {
        ruleDataObject.context = '';
      } else {
        ruleDataObject.context = angular.toJson(ruleDataObject.context);
      }

      $functionFactory
        .saveFunction(ruleDataObject)
        .then(function () {
          $toastr.success(vm.translation.save_success);
          // rule.isChanged = false;
          // $scope.writeLog(
          //   'info',
          //   $translationService.getTranslationController(
          //     'Pipeline guardado',
          //     'Pipeline saved',
          //     'Pipeline salvou'
          //   )
          // );

          // if (rule.exit) {
          //   $state.go('app.rules');
          // }
        })
        .catch(function (error) {
          console.log('Error@saveFunction', error);
          $toastr.error(vm.translation.save_failed + ' ' + error);
        })
        .finally(function () {
          $rootScope.loading = false;
          vm.editor.state = vm.editorStates.IDLE;
        });
    };

    vm.editor.setZoom = function (action) {
      var actions = {
        in: function () {
          vm.editor.zoomLevel += 0.02;
          $realtimeRuleEditorService.setZoom({
            zoomLevel: vm.editor.zoomLevel,
            editorInstance: vm.editor.instance,
          });
        },
        out: function () {
          vm.editor.zoomLevel -= 0.02;
          $realtimeRuleEditorService.setZoom({
            zoomLevel: vm.editor.zoomLevel,
            editorInstance: vm.editor.instance,
          });
        },
        reset: function () {
          $realtimeRuleEditorService.resetEditorPanning();
        },
      };

      actions[action]();
    };
  }
})();

(function () {
  'use strict';

  angular.module('dashboard').constant('ruleEditorDefaults', {
    // constants to fix the transformation position in canvas after drop
    baseTransformationId: 'editor-transformation-',
    canvasOffsetDelta: {
      top: -9,
      left: 11,
    },
    editorStates: {
      IDLE: 'idle',
      TYPE_CHECKING: 'typeChecking',
      SAVING: 'saving',
      RUNNING: 'running',
    },
  });
})();

(function () {
    'use strict';

    angular
        .module('dashboard')
        .controller('RankingsController', RankingsController)

    RankingsController.$inject = ['$filter', '$scope', '$rootScope', '$state', 'toastr', 'translationService', 'Paginator', 'EventsFactory'];
    function RankingsController($filter, $scope, $rootScope, $state, toastr, $translationService, Paginator, EventsFactory) {
        $rootScope.loading = true;
        $translationService.getTranslation($scope, 'rankings');

        var vm = this;
        vm.txtparametro = "param";
        vm.pagination = { rule: [1] };
        vm.visibleColumns = 0;

        vm.from = $rootScope.desde ? moment($rootScope.desde) : moment().subtract(1, 'week').toISOString();
        vm.to = $rootScope.hasta ? moment($rootScope.hasta) : moment().toISOString();
        vm.query = {
            "groupBy": [],
            "orderBy": [],
            "operation": "",
            "field": "",
            "filters": [
                {
                    "function": false,
                    "columnName": ""
                }
            ],
            "from": vm.from,
            "to": vm.to
        };

        EventsFactory.getAggregationQueryData()
            .then(function (res) {
                vm.criterias = res;
                $rootScope.loading = false;
            })
            .catch(function (e) {
                toastr.warning(e);
                $rootScope.loading = false;
            })

        vm.parseEnt = function (entrie) {
            if (isNaN(entrie))
                return entrie;
            return $filter('number')(entrie);
        }

        vm.cleanColumnValues = function () {
            vm.query.filters._columnValue = false;
            vm.columnValues = false;
        };

        vm.cleanOp = function () {
            vm.query.field = '';
            vm.query.operation = '';
            vm.operation = false;
        };

        vm.cleanGroupBy = function () {
            vm.query.groupBy = [];
            vm.groupBy = [];
        };

        vm.cleanOrderBy = function () {
            vm.query.orderBy = [];
            vm.orderBy = [];
        };

        vm.querySearch = function (query) {
            if (!vm.columnValues) {
                var req = { "columnName": vm.query.filters.columnName, "functionName": vm.query.filters.function.name }
                return EventsFactory.getAggregationDataKeys(req)
                    .then(function (res) {
                        vm.columnValues = res.map(function (e) { return { value: e.toLowerCase(), text: e }; })
                        return vm.columnValues;
                    })
                    .catch(function (e) { console.log(e); return e; })
            } else {
                var results = query ? vm.columnValues.filter(createFilterFor(query)) : vm.columnValues, deferred;
                return results;
            }
        }

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(array) {
                return (array.value.indexOf(lowercaseQuery) > -1);
            };
        }

        $scope.$on('dateChange', function (e, dates) {
            vm.from = moment(dates.desde);
            vm.to = moment(dates.hasta);
        });

        vm.setParamsByRule = function () {
            vm.query.filters.columnName = "";
            vm.cleanColumnValues();
            vm.cleanGroupBy();
            vm.cleanOrderBy();
            vm.criterias.selectedRule = angular.copy(vm.query.filters.function);
            vm.criterias.selectedRule.groupBy = angular.copy(vm.query.filters.function.groupBy);
            vm.criterias.selectedRule.orderBy = angular.copy(vm.query.filters.function.groupBy);
            vm.criterias.selectedRule.groupBy.push("month");
            vm.criterias.selectedRule.groupBy.sort();
            vm.criterias.selectedRule.orderBy.sort();
        }

        vm.lookForParams = function () {
            if (!vm.query.filters.function)
                toastr.warning($translationService.getTranslationController('Primero seleccione una función (regla).', 'You must select a function (rule) first.'));
        }

        vm.cancel = function () {
            $state.go('app.alarmas');
        }

        vm.setQuery = function () {
            if (!vm.query.filters.function) {
                toastr.info($translationService.getTranslationController('Debe seleccionar una función (regla).', 'You must select a function (rule).'));
                return false;
            }
            if (!vm.query.groupBy.length) {
                toastr.info($translationService.getTranslationController('Debe seleccionar al menos un parametro de agrupación.', 'You must select at least one "groupBy" parameter.'));
                return false;
            }

            if (vm.query._field && !vm.query.operation) {
                toastr.info($translationService.getTranslationController('Debe seleccionar una operación.', 'You must select an operation.'));
                return false;
            }

            if (vm.query.filters._columnValue) {
                console.log(vm.query.filters._columnValue);
                vm.query.filters.columnValue = vm.query.filters._columnValue.text.trim();
            } else {
                if (vm.searchText) {
                    vm.query.filters.columnValue = vm.searchText;
                } else {
                    if (vm.query.filters.columnValue) delete vm.query.filters.columnValue;
                }
            }

            // -- Parse data
            vm.query.from = moment(vm.from).toISOString();
            vm.query.to = moment(vm.to).toISOString();

            if (vm.query._field) vm.query.field = vm.query._field.value;
            if (!vm.query.field) {
                delete vm.query.field;
                delete vm.query.operation;
            }
            vm.query.filters[0].function = vm.query.filters.function.name;
            vm.query.filters[0].columnName = vm.query.filters.columnName;
            vm.query.filters[0].columnValue = vm.query.filters.columnValue;

            $rootScope.loading = true;

            // vm.query = {"groupBy":["symbol"],"orderBy":[],"operation":"max","field":"price","filters":[{"function":"LarraTransaccionesRelacionadosBatchRule"}],"from":"2018-08-01T14:47:50.851Z","to":"2018-11-13T13:47:50.851Z"};
            EventsFactory.getAggregatedEvents(vm.query)
                .then(function (res) {
                    vm.renderResults(res);
                    $rootScope.loading = false;
                })
                .catch(function (e) {
                    // Possible errors
                    // - Function false Does Not Found
                    // - Operation Fieldfalse Does Not Found in Function LarraTransaccionesRelacionadosBatchRule
                    // - Group by values does not found in Function LarraTransaccionesRelacionadosBatchRule
                    console.log(e)
                    toastr.info(e);
                    $rootScope.loading = false;
                })
        }

        vm.renderResults = function (res) {
            vm.res = [];
            vm.res.page = 1;
            vm.res.itemsPerPage = 10;
            vm.res.totalRecords = res.entries.length;
            vm.res.keys = res.entries.length ? Object.keys(res.entries[0]) : [];
            vm.res.recordSet = res.entries;
            vm.setPaginationRule();
        }

        vm.sort = function (column, direcction) {
            vm.sortReverse = !vm.sortReverse;
            vm.sortColumn = column;
            if (isNaN(vm.res.recordSet[0][column])) {
                if (vm.sortReverse) {
                    vm.res.recordSet = vm.res.recordSet.sort(function (a, b) { return a[column] > b[column] ? -1 : a[column] < b[column] ? 1 : 0 });
                } else {
                    vm.res.recordSet = vm.res.recordSet.sort(function (a, b) { return a[column] < b[column] ? -1 : a[column] > b[column] ? 1 : 0 });
                }
            } else {
                if (vm.sortReverse) {
                    vm.res.recordSet = vm.res.recordSet.sort(function (a, b) { return (a[column] - b[column]) });
                } else {
                    vm.res.recordSet = vm.res.recordSet.sort(function (a, b) { return (b[column] - a[column]) });
                }
            }
            vm.setPaginationRule();
            vm.showLessArrow();
            vm.showMoreArrow();
        }

        vm.goToAlarms = function (rowData) {
            //var filterBy = {ruleName: { query: vm.query.filters.function.name }};
            var columnNames = [];
            var columnValues = [];
            if (vm.query.filters.columnName == '') {
                for (var i = 0; i < vm.query.groupBy.length; i++) {
                    columnNames.push(vm.query.groupBy[i]);
                }
            } else {
                columnNames.push(vm.query.filters.columnName);
            }

            if (!vm.query.filters.columnValue === undefined || !vm.query.filters.columnValue == '') {
                columnValues.push(vm.query.filters.columnValue);
            }

            if (columnNames.length == 1 && columnNames.includes('month')) {
                toastr.info($translationService.getTranslationController('Debe seleccionar otro grupo diferente.', 'You must select another groupBy.'));
                return false;
            }

            var index = columnNames.indexOf('month');
            if (index > -1) {
                columnNames.splice(index, 1);
            }

            var filterBy = { ruleName: vm.query.filters.function.name };
            //var dinamicFilters = vm.query.groupBy.filter(function(e){return e != "month"}).map(function (e) { var obj = {}; obj[e] = {query: rowData[e]}; return obj; });
            var dinamicFilters = vm.query.groupBy.filter(function (e) { return e != "month" }).map(function (e) { var obj = rowData[e]; return obj; });
            var valueSelected = [];

            valueSelected = Object.keys(rowData);

            for (var i = 0; i < columnNames.length; i++) {
                if (valueSelected.includes(columnNames[i])) {
                    columnValues.push(rowData[columnNames[i]]);
                }
            }

            var columnType = "";

            if (vm.query.filters.function.operationValues.length > 0) {
                for (var i = 0; i < vm.query.filters.function.operationValues.length; i++) {
                    if (vm.query.filters.function.operationValues[i].value == columnNames[0]) {
                        if (isInt(vm.query.filters.columnValue)) {
                            columnType = "integer";
                        } else if (isFloat(vm.query.filters.columnValue)) {
                            columnType = "double";
                        } else {
                            columnType = "string";
                        }
                    }
                }
            }

            if (vm.query.filters.columnValue === undefined) {
                for (var i = 0; i < vm.query.filters.function.operationValues.length; i++) {
                    if (vm.query.filters.function.operationValues[i].value == columnNames[0]) {
                        if (isInt(columnValues[0])) {
                            columnType = "integer";
                        } else if (isFloat(columnValues[i])) {
                            columnType = "double";
                        } else {
                            columnType = "string";
                        }
                    }
                }
            }

            if (columnType == "") {
                columnType = "string";
            }

            var filters = [];
            for (var i = 0; i < columnNames.length; i++) {
                filters = filters.concat([{ name: columnNames[i], type: columnType, metadata: 'false', operation: '=', value: columnValues[i], autocomplete: columnType === 'string' }]);
            }

            $state.go('app.alarmas', {
                dinamicFilters: filters,
                filterBy: filterBy,
                desde: vm.query.from, hasta: vm.query.to
            });
        }

        function isInt(value) {
            return !isNaN(value) && (function (x) { return (x | 0) === x; })(parseFloat(value))
        }

        function isFloat(value) {
            var x = parseFloat(value);
            return !isNaN(value) && (x | 0) === x;
        }

        /*Pagination*/
        vm.setPaginationRule = function () {
            vm.res.inf = (vm.res.page * vm.res.itemsPerPage) - 10;
            vm.res.sup = (vm.res.page * vm.res.itemsPerPage);
            vm.res.sup = vm.res.sup > vm.res.totalRecords ? vm.res.totalRecords : vm.res.sup;
            vm.res.entries = vm.res.recordSet.slice(vm.res.inf, vm.res.sup);
            vm.pagination.rule = Paginator.getPagesWindow(vm.res.totalRecords, vm.res.itemsPerPage, vm.res.page);
        };

        vm.goToPage = function (destiny) {
            var totalPages = Math.ceil(vm.res.totalRecords / vm.res.itemsPerPage) - 1;
            switch (destiny) {
                case 'start':
                    vm.res.page = 1;
                    break;
                case 'end':
                    vm.res.page = totalPages;
                    break;
                case '1more':
                    vm.res.page++;
                    break;
                case '1less':
                    vm.res.page--;
                    break;
                default:
                    vm.res.page = destiny;
            }
            vm.setPaginationRule();
            vm.showLessArrow();
            vm.showMoreArrow();
        };

        vm.showLessArrow = function () {
            return vm.pagination.rule.length > 1 && vm.pagination.rule[0] != 1;
        };

        vm.showMoreArrow = function () {
            return vm.pagination.rule.length > 1 && vm.pagination.rule[vm.pagination.rule.length - 1] != Math.ceil(vm.res.totalRecords / vm.res.itemsPerPage);
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('dashboard')
        .controller('ProfilesController', ProfilesController);

    ProfilesController.$inject = ['$scope', '$state', '$rootScope', '$interval', '$localStorageService', '$stateParams', '$modal', 'PerfilesFactory', '$http', '$log', 'toastr', '$timeout', '$mdDialog', 'LoginFactory', 'ReportsFactory', 'translationService'];
    function ProfilesController($scope, $state, $rootScope, $interval, $localStorageService, $stateParams, $modal, PerfilesFactory, $http, $log, toastr, $timeout, $mdDialog, LoginFactory, ReportsFactory, $translationService) {
        var vm = this;
        $scope.listadoOpcion = [];
        $scope.listadoOpcionRespaldo = [];
        $scope.listadoRol = [];
        $scope.listadoRolRespaldo = [];
        $scope.listadoUsuarios = [];
        $scope.listadoUsuariosRespaldo = [];
        $scope.listadoUsuariosEditar = [];
        $scope.listadoUsuariosRoles = [];
        $scope.listadoPerfilesRolesOpciones = [];
        $scope.mensajeServicio = "";
        $scope.editActive = false;
        $scope.settings = { filtroGrupos: true };
        $scope.botonesDeAccion = {
            crear: true,
            guardar: false,
            editar: false,
            eliminar: false,
            cancelar: false
        }

        $scope.codPerfil = true;

        //Método para realizar traducción
        $translationService.getTranslation($scope, 'profiles');

        /**
         * Variables hidden utilizadas para comporar los username y email ocultos para la validación edicicón.
         * 
         * **/
        $scope.codigoPerfilHidden = "";

        $scope.riskUserPassword = {};

        $scope.userStore = $localStorageService.getItem("currentUser");
        $scope.mensajeEliminarUsuario = "";

        $scope.searchUsername = {};     //  Listado de usernames del sistema.
        $scope.searchEmail = {};        //  Listado de email del sistema.
        $scope.searchCodigoPerfil = {}; //  Listado de codigo de perfiles del sistema.

        //  Método encargado de convertir un arreglo en un JSON.
        $scope.createArrayToJSON = function (array) {
            var result = JSON.stringify(array);
            return result;
        };

        //  Método encargado de eliminar una propiedad del objecto Javascript, solo sirve para un Objecto.
        $scope._objectWithoutProperties = function (obj, keys) {
            var target = {};
            for (var i in obj) {
                if (keys.indexOf(i) >= 0)
                    continue;
                if (!Object.prototype.hasOwnProperty.call(obj, i))
                    continue;
                target[i] = obj[i];
            }
            return target;
        };

        vm.verificarCodigoPerfil = function (codigoPerfil) {
            var result = false;
            var idPerfil = "";
            var listado = $scope.listadoPerfilesRolesOpciones.length;
            if (null !== codigoPerfil || codigoPerfil !== "") {
                for (var i = 0; i < listado; i++) {
                    idPerfil = $scope.searchCodigoPerfil[i];
                    if (idPerfil === codigoPerfil) {
                        console.log($scope.searchCodigoPerfil[i] + " = " + codigoPerfil);
                        result = true;
                        break;
                    }
                }
            }
            return result;
        };

        $scope.buscar = [];
        $scope.seleccionado = {};

        $scope.settings.cargarGruposPBI = function () {
            $scope.grupoSelect = '';
            $scope.loaderGroups = true;
            ReportsFactory.getGroups()
                .then(function (res) {

                    $scope.loaderGroups = false;
                    $scope.pbi = { groups: res };
                    $scope.$apply();

                })
                .catch(function (e) {
                    $scope.loaderGroups = false;
                    console.log("ERRORES EN EL ReportsFactory.getGroups");
                    console.log(e);
                });
        }
        //  Método donde inicializamos nuestros servicios al ingresar al módulo.
        vm.initProfilesController = function () {
            // -- Lipiar le formulario
            $scope.resetearFormularioPerfil;

            // -- Listado de Roles
            PerfilesFactory.listadoRoles()
                .then(function (res) {
                    $scope.listadoRol = res;
                    for (var i = 0; i < $scope.listadoRol.length; i++) {
                        $scope.listadoRol[i].value = false;
                    };
                    // console.log($scope.listadoRol);
                    $scope.listadoRolRespaldo = $scope.listadoRol;
                    return res;
                })
                .catch(function (e) {
                    console.log("ERRORES EN EL PerfilesFactory.listadoRoles");
                    console.log(e);
                    $scope.listadoRol = [];
                });

            // -- Listado de Opciones
            PerfilesFactory.listarOpciones()
                .then(function (res) {
                    $scope.listadoOpcion = res;
                    for (var i = 0; i < $scope.listadoOpcion.length; i++) {
                        $scope.listadoOpcion[i].habilitado = false;
                    }
                    // console.log($scope.listadoOpcion);
                    $scope.listadoOpcionRespaldo = $scope.listadoOpcion;
                    $scope.$apply();
                    return res;
                })
                .catch(function (e) {
                    console.log("ERRORES EN EL PerfilesFactory.listadoOpciones");
                    console.log(e);
                });


            // -- Listado grupos de informes PBI
            if (!$scope.pbi) {
                $scope.settings.cargarGruposPBI();
            }

            // -- Listado de perfiles con roles y opciones relacionadas (para el buscador)
            PerfilesFactory.listadoPerfilesRolesOpcionesActivos()
                .then(function (res) {
                    $scope.listadoPerfilesRolesOpciones = res;
                    for (var i = 0; i < $scope.listadoPerfilesRolesOpciones.length; i++) {
                        $scope.searchCodigoPerfil[i] = $scope.listadoPerfilesRolesOpciones[i].profileId;
                    }

                    if ($stateParams.perfil) {
                        $scope.profile = $scope.listadoPerfilesRolesOpciones.find(function (profile) {
                            return profile.profileId === $stateParams.perfil.profileId
                        })
                        $scope.busquedaPerfil();
                    }

                    $scope.$apply();
                    return res;
                }).catch(function (e) {
                    console.log("ERROR EN PerfilesFactory.listadoUsuariosRoles");
                    console.log(e);
                    $scope.listadoPerfilesRolesOpciones = [];
                });
        };


        vm.initProfilesController(); // -- Inicializar el modulo

        //-- Definición del modelo de perfiles para el CRUD.
        $scope.riskProfile = {};
        $scope.riskProfile.activo = true;
        $scope.riskListadoRoles = {};
        $scope.riskListadoOpcionesMenu = {};

        // -- Parece no estar en uso @Daniel
        $scope.isActivo = function () {
            if ($scope.riskProfile.activo) {
                $scope.riskProfile.activo = true;
            } else {
                $scope.riskProfile.activo = false;
            }
        };

        // -- Parece no estar en uso @Daniel
        $scope.isPersonalizado = function () {
            if ($scope.riskProfile.esPersonalizado) {
                $scope.riskProfile.esPersonalizado = true;
            } else {
                $scope.riskProfile.esPersonalizado = false;
            }
        };

        // -- Parece no estar en uso @Daniel
        $scope.isDefecto = function () {
            if ($scope.riskProfile.defecto) {
                $scope.riskProfile.defecto = true;

            } else {
                $scope.riskProfile.defecto = false;

            }
        };


        $scope.cerrarVentanaPerfilRol = function () {
            $scope.habilitarOpcionRoles = false;
        };

        $scope.mensajeErrorValidacion = "";

        $scope.habilitarEditarUsuario = function () {
            $scope.habilitarEditarUsuario = true;
        };

        $scope.irPerfilesRoles = function () {
            $scope.habilitarOpcionRoles = true;
        };

        $scope.listadoRolesSeleccionados = [];

        $scope.seleccionarRoles = function (item) {
            // console.log(item);
            var idx = $scope.listadoRolesSeleccionados.findIndex(function (rol) {
                return rol.roleId === item.roleId;
            })
            if (idx > -1) {
                $scope.listadoRolesSeleccionados.splice(idx, 1);

            } else {
                $scope.listadoRolesSeleccionados.push(item);

            }
        };

        $scope.listadoOpcionesSeleccionados = [];
        //  Cambiar el estado del listado de opciones.
        $scope.seleccionarOpciones = function (item) {
            var idx = $scope.listadoOpcionesSeleccionados.indexOf(item);
            if (idx > -1) {
                $scope.listadoOpcionesSeleccionados.splice(idx, 1);
            } else {
                $scope.listadoOpcionesSeleccionados.push(item);
            }
        };

        $scope.listadoGruposSeleccionados = [];
        //  Cambiar el estado del listado de grupos.
        $scope.seleccionarGruposPBI = function (item) {
            var idx = $scope.listadoGruposSeleccionados.indexOf(item);
            if (idx > -1) {
                $scope.listadoGruposSeleccionados.splice(idx, 1);
            } else {
                $scope.listadoGruposSeleccionados.push(item);
            }
        };

        $scope.listarReportes = function (grupo) {
            $scope.loaderReports = true;
            $scope.pbi.reports = {};
            $scope.grupoSelect = grupo.name;
            // -- Obtener los reportes
            ReportsFactory.getReports({
                groupId: grupo.workspaceId
            }).then(function (res) {
                $scope.loaderReports = false;
                $scope.pbi.reports = res;
                $scope.$apply();
            }).catch(function (e) {
                $scope.loaderReports = false;
                console.log("ERROR @ ReportsFactory.getReports")
            });
        }

        $scope.eliminarPerfil = function () {
            if (null == $scope.riskProfile.profileId) {
                var msg = $translationService.getTranslationController('Debe seleccionar un perfil para eliminar.', 'You must select a profile to delete.', 'Você deve selecionar um perfil para excluir.');
                $scope.mensajeServicio = msg;
            } else {
                alert("PERFECTO COMENZAMOS A ELIMINAR EL PERFIL");
                PerfilesFactory.eliminarPerfil($scope.riskProfile.profileId)
                    .then(function (res) {
                        var msg = $translationService.getTranslationController('Se elimino el perfil exitosamente', 'The profile was successfully deleted', 'O perfil foi eliminido com sucesso');
                        $scope.mensajeServicio = msg;
                        $scope.resetearFormularioPerfil();
                        $scope.riskProfile = {};
                        toastr.success($scope.mensajeServicio);
                        $scope.habilitarBotones('eliminar');
                        $scope.editActive = false;
                        $scope.codPerfil = true;
                        $scope.profile = '';
                        vm.initProfilesController();
                    })
                    .catch(function (e) {
                        var msg = $translationService.getTranslationController('Error en la eliminación del perfil', 'Error removing profile', 'Erro ao remover o perfil');
                        $scope.mensajeServicio = msg;
                        $scope.riskProfile = [];

                    });

                //                vm.initProfilesController;
                $scope.resetearFormularioPerfil;

                $scope.riskProfile = [];
                $scope.listadoOpcion = $scope.listadoOpcionRespaldo;
                $scope.listadoRol = $scope.listadoRolRespaldo;
            }
        };

        $scope.guardarPerfil = function () {
            //            console.log($scope.listadoRol);
            //            var listado;
            //            for (var i = 0, listado = $scope.listadoRol.length; i < listado; i++) {
            //                console.log("NUESTRO ROL ES ");
            //                console.log($scope.listadoRol[i]);
            //                console.log($scope.listadoRol[i].value);
            //            }
            //            console.log("NUESTROS ROLES FINALES SON = ");
            //            console.log($scope.listadoRol);
            var v = $scope.validarCamposPerfiles($scope.listadoOpcionesSeleccionados, $scope.listadoRolesSeleccionados, $scope.riskProfile);
            var validarCodigoPerfil = vm.verificarCodigoPerfil($scope.riskProfile.profileId);
            $scope.validacion = v;
            var listadoRoles = $scope.listadoRol;
            var listadoOpciones = $scope.listadoOpcion;
            //  Eliminamos las propiedades innecesarias para el envio correcto como consumo de servicio.
            //  Listado de Roles
            for (var i = 0, len = $scope.listadoRolesSeleccionados.length; i < len; i++) {
                delete $scope.listadoRolesSeleccionados[i].$$hashKey;
            }

            //  Listado de Opciones.
            for (var i = 0, len = $scope.listadoOpcionesSeleccionados.length; i < len; i++) {
                delete $scope.listadoOpcionesSeleccionados[i].$$hashKey;
            }

            // Listado de GruposPBI
            $scope.listadoGruposSeleccionados = $scope.listadoGruposSeleccionados.filter(function (grupo) { return grupo.activo == true })
            for (var i = 0, len = $scope.listadoGruposSeleccionados.length; i < len; i++) {
                delete $scope.listadoGruposSeleccionados[i].$$hashKey;
                //delete $scope.listadoGruposSeleccionados[i].activo;
                delete $scope.listadoGruposSeleccionados[i].isReadOnly;
                delete $scope.listadoGruposSeleccionados[i].riskDomain;
            }


            //  Convertimos nuestro resultado en json para luego enviarlo a nuestro consumo de servicio.
            var listadoOpcionesSeleccionados = $scope.createArrayToJSON($scope.listadoOpcionesSeleccionados);
            var listadoRolesSeleccionados = $scope.createArrayToJSON($scope.listadoRolesSeleccionados);
            var listadoGruposSeleccionados = $scope.createArrayToJSON($scope.listadoGruposSeleccionados);

            $scope.data = [];
            if (validarCodigoPerfil) {
                var msg = $translationService.getTranslationController('No puede crear un perfil con el mismo código, por favor ingrese otro diferente', 'You can not create a profile with the same code, please enter a different one', 'Você não pode criar um perfil com o mesmo código, por favor digite um diferente');
                $scope.mensajeServicio = msg;
            } else if (!v.showPerfil) {


                PerfilesFactory.crearPerfilRolOpcion($scope.riskProfile, $scope.listadoRolesSeleccionados, $scope.listadoOpcionesSeleccionados, $scope.listadoGruposSeleccionados)
                    .then(function (res) {
                        var msg = $translationService.getTranslationController('Se creo el perfil exitosamente', 'The profile was created successfully', 'O perfil foi criado com sucesso');
                        $scope.mensajeServicio = msg;
                        // $scope.riskProfile = {};
                        // vm.initProfilesController();
                        $scope.$apply();
                        toastr.success($scope.mensajeServicio)
                        $scope.habilitarBotones('editar');
                        $scope.editActive = false;
                        $scope.codPerfil = true;
                        $scope.actualizarPerfiles();
                        return res;
                    })
                    .catch(function (e) {
                        if (e.msg) {
                            switch (e.msg) {
                                case "Profile Repeated":
                                    $scope.mensajeServicio = $translationService.getTranslationController('Código de perfil duplicado intente con otro', 'Duplicate profile code try another', 'Código de perfil duplicado tente outro');
                                    break;
                                default:
                                    break;
                            }
                        } else {
                            $scope.mensajeServicio = $translationService.getTranslationController('Error en la creación del perfil', 'Error creating the profile', 'Erro ao criar o perfil');
                        }
                        console.log(e)
                        toastr.error($scope.mensajeServicio)
                    });

            }
        };


        $scope.chequearEditarPerfil = function () {
            // ARREGLAR LUEGO DE CAMBIAR EL HABILITADO
            if ($scope.riskProfile.profileId === $scope.userStore.opcionesMenu[0].profileId) {
                var confirm = $mdDialog.confirm()
                $scope.modalPerfilRepetido = $modal({
                    templateUrl: 'app/profiles/same-profile.html',
                    backdrop: 'static',
                    size: 'md',
                    scope: $scope,
                    keyboard: false,
                    show: true
                });
            } else {
                $scope.editarPerfil(false);
            }
        }

        //  Método para editar el perfil seleccionado.
        $scope.editarPerfil = function (mismoPerfil) {
            var v = $scope.validarCamposPerfiles($scope.listadoOpcionesSeleccionados, $scope.listadoRolesSeleccionados, $scope.riskProfile);
            var validarCodigoPerfil = vm.verificarCodigoPerfil($scope.riskProfile.profileId);
            $scope.validacion = v;
            var listadoRoles = $scope.listadoRol;
            var listadoOpciones = $scope.listadoOpcion;


            //  Eliminamos las propiedades innecesarias para el envio correcto como consumo de servicio.
            //  Listado de Roles
            for (var i = 0, len = $scope.listadoRolesSeleccionados.length; i < len; i++) {
                delete $scope.listadoRolesSeleccionados[i].$$hashKey;
            }

            //  Listado de Opciones.
            for (var i = 0, len = $scope.listadoOpcionesSeleccionados.length; i < len; i++) {
                delete $scope.listadoOpcionesSeleccionados[i].$$hashKey;
            }

            // Listado de GruposPBI
            $scope.listadoGruposSeleccionados = $scope.listadoGruposSeleccionados.filter(function (grupo) { return grupo.activo == true })
            for (var i = 0, len = $scope.listadoGruposSeleccionados.length; i < len; i++) {
                delete $scope.listadoGruposSeleccionados[i].$$hashKey;
                //delete $scope.listadoGruposSeleccionados[i].activo;
                delete $scope.listadoGruposSeleccionados[i].isReadOnly;
                delete $scope.listadoGruposSeleccionados[i].riskDomain;
            }


            //  Convertimos nuestro resultado en json para luego enviarlo a nuestro consumo de servicio.
            var listadoOpcionesSeleccionados = $scope.createArrayToJSON($scope.listadoOpcionesSeleccionados);
            var listadoRolesSeleccionados = $scope.createArrayToJSON($scope.listadoRolesSeleccionados);
            var listadoGruposSeleccionados = $scope.createArrayToJSON($scope.listadoGruposSeleccionados);

            //VERIFICAMOS SI EXISTE EL MODAL Y LO CERRAMOS 
            //ANTES DE MODIFICAR
            if ($scope.modalPerfilRepetido) {
                $scope.modalPerfilRepetido.$promise.then($scope.modalPerfilRepetido.hide)
            }

            if (!v.showPerfil) {

                if ($scope.codigoPerfilHidden === $scope.riskProfile.profileId) {

                    //  Consumimos nuestro servicio de modificar o editar perfil.
                    PerfilesFactory.editarPerfilRolOpcion($scope.codigoPerfilHidden, $scope.riskProfile, $scope.listadoRolesSeleccionados, $scope.listadoOpcionesSeleccionados, $scope.listadoGruposSeleccionados)
                        .then(function (res) {
                            var msg = $translationService.getTranslationController('Se edito el perfil exitosamente.', 'The profile was successfully edited.', 'O perfil foi editado com sucesso.');
                            $scope.mensajeServicio = msg;

                            // $scope.resetearFormularioPerfil();
                            toastr.success($scope.mensajeServicio);
                            $scope.habilitarBotones('editar');
                            $scope.editActive = false;
                            $scope.codPerfil = true;
                            //REFRESCAR LOS CAMBIOS QUE SE HAN HECHO EN LOS PERFILES
                            var indexToPop = $scope.listadoPerfilesRolesOpciones.findIndex(function (option) {
                                return option.originalProfileId === $scope.riskProfile.originalProfileId
                            })


                            $scope.actualizarPerfiles();
                            if (mismoPerfil) {
                                LoginFactory.Logout();
                            }
                            return res;

                        })
                        .catch(function (e) {
                            var msg = $translationService.getTranslationController('Problemas al editar el perfil.', 'Problems editing the profile.', 'Problemas na edição do perfil.');
                            $scope.mensajeServicio = msg;
                            toastr.error($scope.mensajeServicio);
                            $scope.resetearFormularioPerfil;
                            $scope.riskProfile = [];
                        })


                } else {

                    if (validarCodigoPerfil) {
                        var msg = $translationService.getTranslationController('Ya existe el perfil en sistema, por favor ingrese otro diferente', 'The system profile already exists, please enter a different one', 'O perfil do sistema já existe, por favor insira um diferente');
                        $scope.mensajeServicio = msg;
                    } else {
                        var msg = $translationService.getTranslationController('El código del perfil es unico y no puede modificarse.', 'The profile code is unique and can not be modified.', 'O código do perfil é único e não pode ser modificado.');
                        $scope.mensajeServicio = msg;
                        //  Consumimos nuestro servicio de modificar o editar perfil.
                    }
                }
                $scope.resetearFormularioPerfil;

            }
        };

        $scope.resetearFormularioPerfil = function () {

            $scope.riskProfile = [];
            $scope.profile = [];
            $scope.listadoOpcionesSeleccionados = [];
            $scope.listadoRol.map(function (elem) { elem.value = false; });

            $scope.listadoOpcion.map(function (elem) { elem.habilitado = false; });

            if ($scope.pbi) {
                $scope.pbi.groups.map(function (elem) { elem.habilitado = false; });
            }

            $scope.listadoRolesSeleccionados = [];

            for (var i = 0; i < $scope.listadoOpcionesSeleccionados.length; i++) {
                $scope.listadoRol[i].value = false;
                $scope.listadoOpcion[i].habilitado = false;
                $scope.listadoOpcionesSeleccionados[i].habilitado = false;
            };
            $scope.riskProfile.activo = true;
        };

        $scope.profile = [];
        $scope.mensajePerfil = "";

        $scope.limpiarFormulario = function () {
            $scope.botonesDeAccion = {
                crear: true,
                guardar: false,
                editar: false,
                eliminar: false,
                cancelar: false
            }
            $scope.editActive = false;
            $scope.resetearFormularioPerfil();
        };

        $scope.setPerfil = function (perfil) {
            $scope.profile = perfil;
            $scope.busquedaPerfil();

        };

        $scope.busquedaPerfil = function () {
            $rootScope.loading = true;
            $scope.profileEdit = [];
            $scope.riskOptionList = [];
            $scope.riskRoleList = [];
            if (null == $scope.profile.profileId) {
                toastr.warning("Seleccione un perfil");
                $scope.riskProfile = [];
                $scope.listadoOpcion = $scope.listadoOpcionRespaldo;
                $scope.listadoRol = $scope.listadoRolRespaldo;
                $scope.codigoPerfilHidden = ""
                $rootScope.loading = false;
            } else {
                //  Comenzamos con nuestra la búsqueda y realizamos las modificaciones correspondientes.
                $scope.editActive = true;

                $scope.habilitarBotones('busqueda');
                $scope.riskProfile = $scope.profile;
                $scope.riskOptionList = [];
                $scope.riskOptionList = $scope.profile.riskOptionList;


                $scope.riskWorkspaceList = $scope.profile.riskWorkspaceList;


                if ($scope.pbi) { // Si no hay datos de PoweBI salta esta sección
                    // -- Limpiar los grupos PBI previamente seleccionados
                    $scope.pbi.groups.map(function (opcion) {
                        opcion.habilitado = false;
                    })
                    // -- Cargar los grupos PBI seleccionados del usuario actual
                    $scope.listadoGruposSeleccionados = [];
                    if ($scope.riskWorkspaceList) {
                        $scope.riskWorkspaceList.forEach(function (gruposUsuario) {
                            var currentOption = $scope.pbi.groups.find(function (grupo) {
                                return gruposUsuario.workspaceId === grupo.workspaceId;
                            })
                            if (currentOption) {
                                currentOption.habilitado = true;
                                $scope.listadoGruposSeleccionados.push(currentOption);
                            }
                        })
                    }
                }

                $scope.riskRoleList = $scope.profile.riskRoleList || [];
                $scope.listadoRolesSeleccionados = [];
                $scope.riskRoleList.forEach(function (role) {
                    role.value = true;
                    $scope.listadoRolesSeleccionados.push(role);
                })


                // VERIFICAR SI SE HA BUSCADO ANTERIORMENTE Y SETEAR LAS OPCIONES A FALSE
                if (Object.keys($scope.listadoOpcion[0]).includes('habilitado')) {
                    $scope.listadoOpcion.map(function (opcion) {
                        opcion.habilitado = false;
                    })
                }

                if ($scope.riskOptionList) {
                    $scope.riskOptionList.forEach(function (opcionUsuario) {
                        var currentOption = $scope.listadoOpcion.find(function (opcion) {
                            return opcionUsuario.idFuncion === opcion.idFuncion;
                        })
                        if (currentOption) currentOption.habilitado = true;
                    })
                }

                // $scope.listadoOpcion = $scope.riskOptionList;
                $scope.listadoOpcionesSeleccionados = [];
                $scope.listadoOpcion.forEach(function (opcion) {
                    if (opcion.habilitado) {
                        $scope.listadoOpcionesSeleccionados.push(opcion);
                    }
                })

                if (Object.keys($scope.listadoRol[0]).includes('value')) {
                    $scope.listadoRol.map(function (rol) {
                        rol.value = false;
                    })
                }

                // VERIFICAR LOS ROLES DEL SISTEMA CON LOS ROLES QUE TIENE EL PERFIL
                $scope.listadoRol.map(function (currentRol) {
                    var rol = $scope.riskRoleList.find(function (role) {
                        return role.roleId === currentRol.roleId;
                    })
                    if (rol) currentRol.value = rol.value;
                })
                $scope.codigoPerfilHidden = $scope.profile.profileId;
                $rootScope.loading = false;
                $scope.editActive = true;
            }

        };


        //ngModel value
        $scope.selected = undefined;

        $scope.select = [];

        $scope.exist = function (item) {
            return $scope.select.indexOf(item);
        };

        $scope.toggleSelection = function (item) {
            var idx = $scope.select.indexOf(item);
            if (idx > -1) {
                $scope.select.splice(idx, 1);
            } else {
                $scope.select.push(item);
            }
        };

        //  Validaciones para crearUsuario.
        $scope.show = false;
        $scope.content = '';
        $scope.mensajeErrorValidacion = '';

        //  Validar formulario Crear Perfil.
        $scope.validarCamposPerfiles = function (listadoOpcionesSeleccionados, listadoRolesSeleccionados, riskProfile) {
            var validacion = { contentPerfil: '', showPerfil: false };
            var cantidadOpcionesSeleccionadas = listadoOpcionesSeleccionados.length;
            var cantidadRolesSeleccionados = listadoRolesSeleccionados.length;
            $scope.resultadoPerfil = [];

            if (!riskProfile.profileName) {
                var msg = $translationService.getTranslationController('Escriba el nombre de su perfil.', 'Enter the name of your profile.', 'Digite o nome do seu perfil.');
                validacion.contentPerfil = msg;
                $scope.contentPerfil = validacion.contentPerfil;

                validacion.showPerfil = true;

                $scope.showPerfil = validacion.showPerfil;
            } else if (!riskProfile.profileId) {
                var msg = $translationService.getTranslationController('Escriba el nombre de su perfil.', 'Enter the name of your profile.', 'Escreva a nome do seu perfil.');
                validacion.contentPerfil = msg;
                $scope.contentPerfil = validacion.contentPerfil;

                validacion.showPerfil = true;

                $scope.showPerfil = validacion.showPerfil;
            } else if (!riskProfile.originalProfileId) {
                var msg = $translationService.getTranslationController('Escriba el origen de su perfil.', 'Write the origin of your profile.', 'Escreva a origem do seu perfil.');
                validacion.contentPerfil = msg;
                $scope.contentPerfil = validacion.contentPerfil;

                validacion.showPerfil = true;

                $scope.showPerfil = validacion.showPerfil;
            } else if (!riskProfile.descripcion) {
                var msg = $translationService.getTranslationController('Escriba la descricpción de su perfil.', 'Write the description of your profile.', 'Escreva a descrição do seu perfil.');
                validacion.contentPerfil = msg;
                $scope.contentPerfil = validacion.contentPerfil;

                validacion.showPerfil = true;

                $scope.showPerfil = validacion.showPerfil;
            } else if (cantidadOpcionesSeleccionadas <= 0) {
                var msg = $translationService.getTranslationController('Seleccione al menos una opción del ménu de opciones del sistema.', 'Select at least one option of the number of system options.', 'Selecione pelo menos uma opção do número de opções do sistema.');
                validacion.contentPerfil = msg;
                $scope.contentPerfil = validacion.contentPerfil;

                validacion.showPerfil = true;

                $scope.showPerfil = validacion.showPerfil;
            } else if (cantidadRolesSeleccionados <= 0) {
                var msg = $translationService.getTranslationController('Seleccione al menos un rol para su perfil.', 'Select at least one role for your profile.', 'Seleccione al menos un rol para su perfil.');
                validacion.contentPerfil = msg;
                $scope.contentPerfil = validacion.contentPerfil;

                validacion.showPerfil = true;

                $scope.showPerfil = validacion.showPerfil;
            }

            if (validacion.showPerfil) {
                // $timeout(function () {
                //     $('body').scrollTo(('#alert-msg'), 200);
                // }, 100)
            }
            return validacion;
        };

        $scope.habilitarCrear = function () {
            $scope.resetearFormularioPerfil();
            vm.initProfilesController();
            $scope.editActive = true;
            $scope.habilitarBotones('crear');
        }

        $scope.habilitarBotones = function (tipo) {

            $scope.contentPerfil = '';
            switch (tipo) {
                case 'crear':
                    $scope.botonesDeAccion.guardar = true
                    // $scope.botonesDeAccion.cancelar = true;
                    $scope.botonesDeAccion.crear = false;
                    $scope.botonesDeAccion.editar = false;
                    $scope.botonesDeAccion.eliminar = false;
                    $scope.codPerfil = true;
                    break;
                case 'editar':
                case 'guardar':
                case 'eliminar':
                    $scope.botonesDeAccion.crear = true;
                    $scope.botonesDeAccion.guardar = false;
                    $scope.botonesDeAccion.editar = false;
                    $scope.botonesDeAccion.eliminar = false;
                    $scope.botonesDeAccion.cancelar = false;
                    break
                case 'busqueda':
                    $scope.botonesDeAccion.editar = true;
                    $scope.botonesDeAccion.cancelar = true;
                    $scope.botonesDeAccion.eliminar = true;
                    $scope.botonesDeAccion.crear = false;
                    $scope.botonesDeAccion.guardar = false;
                    $scope.codPerfil = false;
                    break;
                default:
                    break;
            }
        }

        $scope.actualizarPerfiles = function () {
            $timeout(function () {
                PerfilesFactory.listadoPerfilesRolesOpcionesActivos()
                    .then(function (res) {
                        $scope.listadoPerfilesRolesOpciones = res;
                        for (var i = 0; i < $scope.listadoPerfilesRolesOpciones.length; i++) {
                            $scope.searchCodigoPerfil[i] = $scope.listadoPerfilesRolesOpciones[i].profileId;
                            if ($scope.profile.profileId === $scope.listadoPerfilesRolesOpciones[i].profileId) {
                                $scope.profile = $scope.listadoPerfilesRolesOpciones[i];
                            }
                        }
                        $scope.$apply();
                    })
            }, 800)
        }

    }
})();
(function () {
  "use strict";

  angular.module("dashboard").controller("PerfilesController", PerfilesController);

  PerfilesController.$inject = [
    "$scope",
    "$state",
    "$rootScope",
    "$interval",
    "$localStorageService",
    "$stateParams",
    "$modal",
    "PerfilesFactory",
    "$http",
    "$log",
    "toastr",
    "$timeout",
    "$mdDialog",
    "LoginFactory",
    "ReportsFactory",
    "translationService",
  ];

  function PerfilesController(
    $scope,
    $state,
    $rootScope,
    $interval,
    $localStorageService,
    $stateParams,
    $modal,
    PerfilesFactory,
    $http,
    $log,
    toastr,
    $timeout,
    $mdDialog,
    LoginFactory,
    ReportsFactory,
    $translationService
  ) {
    var vm = this;
    $scope.listadoOpcion = [];
    $scope.listadoOpcionRespaldo = [];
    $scope.listadoRol = [];
    $scope.listadoRolRespaldo = [];
    $scope.listadoUsuarios = [];
    $scope.listadoUsuariosRespaldo = [];
    $scope.listadoUsuariosEditar = [];
    $scope.listadoUsuariosRoles = [];
    $scope.listadoPerfilesRolesOpciones = [];
    $scope.mensajeServicio = "";
    $scope.editActive = false;
    $scope.settings = { filtroGrupos: true };
    $scope.botonesDeAccion = {
      crear: true,
      guardar: false,
      editar: false,
      eliminar: false,
      cancelar: false,
    };

    $scope.codPerfil = true;

    //Método para realizar traducción
    $translationService.getTranslation($scope, "profiles");

    /**
     * Variables hidden utilizadas para comporar los username y email ocultos para la validación edicicón.
     *
     * **/
    $scope.codigoPerfilHidden = "";

    $scope.riskUserPassword = {};

    $scope.userStore = $localStorageService.getItem("currentUser");
    console.log($scope.userStore);
    $scope.mensajeEliminarUsuario = "";

    $scope.searchUsername = {}; //  Listado de usernames del sistema.
    $scope.searchEmail = {}; //  Listado de email del sistema.
    $scope.searchCodigoPerfil = {}; //  Listado de codigo de perfiles del sistema.

    //  Método encargado de convertir un arreglo en un JSON.
    $scope.createArrayToJSON = function (array) {
      var result = JSON.stringify(array);
      return result;
    };

    //  Método encargado de eliminar una propiedad del objecto Javascript, solo sirve para un Objecto.
    $scope._objectWithoutProperties = function (obj, keys) {
      var target = {};
      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }
      return target;
    };

    vm.verificarCodigoPerfil = function (codigoPerfil) {
      var result = false;
      var idPerfil = "";
      var listado = $scope.listadoPerfilesRolesOpciones.length;
      if (null !== codigoPerfil || codigoPerfil !== "") {
        for (var i = 0; i < listado; i++) {
          idPerfil = $scope.searchCodigoPerfil[i];
          if (idPerfil === codigoPerfil) {
            console.log($scope.searchCodigoPerfil[i] + " = " + codigoPerfil);
            result = true;
            break;
          }
        }
      }
      return result;
    };

    $scope.buscar = [];
    $scope.seleccionado = {};

    $scope.settings.cargarGruposPBI = function () {
      $scope.grupoSelect = "";
      $scope.loaderGroups = true;
      ReportsFactory.getGroups()
        .then(function (res) {
          $scope.loaderGroups = false;
          $scope.pbi = { groups: res };
          $scope.$apply();
        })
        .catch(function (e) {
          $scope.loaderGroups = false;
          console.log(e);
        });
    };
    //  Método donde inicializamos nuestros servicios al ingresar al módulo.
    vm.initPerfilesController = function () {
      // -- Lipiar le formulario
      $scope.resetearFormularioPerfil;

      // -- Listado de Roles
      PerfilesFactory.listadoRoles()
        .then(function (res) {
          $scope.listadoRol = res;
          for (var i = 0; i < $scope.listadoRol.length; i++) {
            $scope.listadoRol[i].value = false;
          }
          $scope.listadoRolRespaldo = $scope.listadoRol;
          return res;
        })
        .catch(function (e) {
          console.log(e);
          $scope.listadoRol = [];
        });

      // -- Listado de Opciones
      PerfilesFactory.listarOpciones()
        .then(function (res) {
          $scope.listadoOpcion = res;
          for (var i = 0; i < $scope.listadoOpcion.length; i++) {
            $scope.listadoOpcion[i].habilitado = false;
          }

          $scope.listadoOpcionRespaldo = $scope.listadoOpcion;
          $scope.$apply();
          return res;
        })
        .catch(function (e) {
          console.log(e);
        });

      // -- Listado grupos de informes PBI
      if (!$scope.pbi) {
        $scope.settings.cargarGruposPBI();
      }

      // -- Listado de perfiles con roles y opciones relacionadas (para el buscador)
      PerfilesFactory.listadoPerfilesRolesOpcionesActivos()
        .then(function (res) {
          $scope.listadoPerfilesRolesOpciones = res;
          for (var i = 0; i < $scope.listadoPerfilesRolesOpciones.length; i++) {
            $scope.searchCodigoPerfil[i] = $scope.listadoPerfilesRolesOpciones[i].profileId;
          }

          if ($stateParams.perfil) {
            $scope.profile = $scope.listadoPerfilesRolesOpciones.find(function (profile) {
              return profile.profileId === $stateParams.perfil.profileId;
            });
            $scope.busquedaPerfil();
          }

          $scope.$apply();
          return res;
        })
        .catch(function (e) {
          console.log("ERROR EN PerfilesFactory.listadoUsuariosRoles");
          console.log(e);
          $scope.listadoPerfilesRolesOpciones = [];
        });
    };

    vm.initPerfilesController(); // -- Inicializar el modulo

    $scope.riskProfile = {}; //-- Definición del modelo de perfiles para el CRUD.
    $scope.riskProfile.activo = true;
    $scope.riskListadoRoles = {};
    $scope.riskListadoOpcionesMenu = {};

    // -- Parece no estar en uso @Daniel
    $scope.isActivo = function () {
      if ($scope.riskProfile.activo) {
        $scope.riskProfile.activo = true;
      } else {
        $scope.riskProfile.activo = false;
      }
    };

    // -- Parece no estar en uso @Daniel
    $scope.isPersonalizado = function () {
      if ($scope.riskProfile.esPersonalizado) {
        $scope.riskProfile.esPersonalizado = true;
      } else {
        $scope.riskProfile.esPersonalizado = false;
      }
    };

    // -- Parece no estar en uso @Daniel
    $scope.isDefecto = function () {
      if ($scope.riskProfile.defecto) {
        $scope.riskProfile.defecto = true;
      } else {
        $scope.riskProfile.defecto = false;
      }
    };

    $scope.cerrarVentanaPerfilRol = function () {
      $scope.habilitarOpcionRoles = false;
    };

    $scope.mensajeErrorValidacion = "";

    $scope.habilitarEditarUsuario = function () {
      $scope.habilitarEditarUsuario = true;
    };

    $scope.irPerfilesRoles = function () {
      $scope.habilitarOpcionRoles = true;
    };

    $scope.listadoRolesSeleccionados = [];

    $scope.seleccionarRoles = function (item) {
      var idx = $scope.listadoRolesSeleccionados.findIndex(function (rol) {
        return rol.roleId === item.roleId;
      });
      if (idx > -1) {
        $scope.listadoRolesSeleccionados.splice(idx, 1);
      } else {
        $scope.listadoRolesSeleccionados.push(item);
      }
    };

    $scope.listadoOpcionesSeleccionados = [];
    //  Cambiar el estado del listado de opciones.
    $scope.seleccionarOpciones = function (item) {
      var idx = $scope.listadoOpcionesSeleccionados.indexOf(item);
      if (idx > -1) {
        $scope.listadoOpcionesSeleccionados.splice(idx, 1);
      } else {
        $scope.listadoOpcionesSeleccionados.push(item);
      }
    };

    $scope.listadoGruposSeleccionados = [];
    //  Cambiar el estado del listado de grupos.
    $scope.seleccionarGruposPBI = function (item) {
      var idx = $scope.listadoGruposSeleccionados.indexOf(item);
      if (idx > -1) {
        $scope.listadoGruposSeleccionados.splice(idx, 1);
      } else {
        $scope.listadoGruposSeleccionados.push(item);
      }
    };

    $scope.listarReportes = function (grupo) {
      $scope.loaderReports = true;
      $scope.pbi.reports = {};
      $scope.grupoSelect = grupo.name;
      // -- Obtener los reportes
      ReportsFactory.getReports({
        groupId: grupo.workspaceId,
      })
        .then(function (res) {
          $scope.loaderReports = false;
          $scope.pbi.reports = res;
          $scope.$apply();
        })
        .catch(function (e) {
          $scope.loaderReports = false;
          console.log("ERROR @ ReportsFactory.getReports", e);
        });
    };

    $scope.eliminarPerfil = function () {
      if (null == $scope.riskProfile.profileId) {
        var msg = $translationService.getTranslationController(
          "Debe seleccionar un perfil para eliminar.",
          "You must select a profile to delete.",
          "Você deve selecionar um perfil para excluir."
        );
        $scope.mensajeServicio = msg;
      } else {
        alert("PERFECTO COMENZAMOS A ELIMINAR EL PERFIL");
        PerfilesFactory.eliminarPerfil($scope.riskProfile.profileId)
          .then(function (res) {
            var msg = $translationService.getTranslationController(
              "Se elimino el perfil exitosamente",
              "The profile was successfully deleted",
              "O perfil foi eliminido com sucesso"
            );
            $scope.mensajeServicio = msg;
            $scope.resetearFormularioPerfil();
            $scope.riskProfile = {};
            toastr.success($scope.mensajeServicio);
            $scope.habilitarBotones("eliminar");
            $scope.editActive = false;
            $scope.codPerfil = true;
            $scope.profile = "";
            vm.initPerfilesController();
          })
          .catch(function (e) {
            var msg = $translationService.getTranslationController(
              "Error en la eliminación del perfil",
              "Error removing profile",
              "Erro ao remover o perfil"
            );
            $scope.mensajeServicio = msg;
            $scope.riskProfile = [];
          });

        //                vm.initPerfilesController;
        $scope.resetearFormularioPerfil;

        $scope.riskProfile = [];
        $scope.listadoOpcion = $scope.listadoOpcionRespaldo;
        $scope.listadoRol = $scope.listadoRolRespaldo;
      }
    };

    $scope.guardarPerfil = function () {
      var v = $scope.validarCamposPerfiles(
        $scope.listadoOpcionesSeleccionados,
        $scope.listadoRolesSeleccionados,
        $scope.riskProfile
      );
      var validarCodigoPerfil = vm.verificarCodigoPerfil($scope.riskProfile.profileId);
      $scope.validacion = v;
      var listadoRoles = $scope.listadoRol;
      var listadoOpciones = $scope.listadoOpcion;
      //  Eliminamos las propiedades innecesarias para el envio correcto como consumo de servicio.
      //  Listado de Roles
      for (var i = 0, len = $scope.listadoRolesSeleccionados.length; i < len; i++) {
        delete $scope.listadoRolesSeleccionados[i].$$hashKey;
      }

      //  Listado de Opciones.
      for (var i = 0, len = $scope.listadoOpcionesSeleccionados.length; i < len; i++) {
        delete $scope.listadoOpcionesSeleccionados[i].$$hashKey;
      }

      // Listado de GruposPBI
      $scope.listadoGruposSeleccionados = $scope.listadoGruposSeleccionados.filter(function (
        grupo
      ) {
        return grupo.activo == true;
      });
      for (var i = 0, len = $scope.listadoGruposSeleccionados.length; i < len; i++) {
        delete $scope.listadoGruposSeleccionados[i].$$hashKey;
        //delete $scope.listadoGruposSeleccionados[i].activo;
        delete $scope.listadoGruposSeleccionados[i].isReadOnly;
        delete $scope.listadoGruposSeleccionados[i].riskDomain;
      }

      //  Convertimos nuestro resultado en json para luego enviarlo a nuestro consumo de servicio.
      var listadoOpcionesSeleccionados = $scope.createArrayToJSON(
        $scope.listadoOpcionesSeleccionados
      );
      var listadoRolesSeleccionados = $scope.createArrayToJSON($scope.listadoRolesSeleccionados);
      var listadoGruposSeleccionados = $scope.createArrayToJSON($scope.listadoGruposSeleccionados);

      $scope.data = [];
      if (validarCodigoPerfil) {
        var msg = $translationService.getTranslationController(
          "No puede crear un perfil con el mismo código, por favor ingrese otro diferente",
          "You can not create a profile with the same code, please enter a different one",
          "Você não pode criar um perfil com o mesmo código, por favor digite um diferente"
        );
        $scope.mensajeServicio = msg;
      } else if (!v.showPerfil) {
        PerfilesFactory.crearPerfilRolOpcion(
          $scope.riskProfile,
          $scope.listadoRolesSeleccionados,
          $scope.listadoOpcionesSeleccionados,
          $scope.listadoGruposSeleccionados
        )
          .then(function (res) {
            var msg = $translationService.getTranslationController(
              "Se creo el perfil exitosamente",
              "The profile was created successfully",
              "O perfil foi criado com sucesso"
            );
            $scope.mensajeServicio = msg;

            $scope.$apply();
            toastr.success($scope.mensajeServicio);
            $scope.habilitarBotones("editar");
            $scope.editActive = false;
            $scope.codPerfil = true;
            $scope.actualizarPerfiles();

            return res;
          })
          .catch(function (e) {
            if (e.msg) {
              switch (e.msg) {
                case "Profile Repeated":
                  $scope.mensajeServicio = $translationService.getTranslationController(
                    "Código de perfil duplicado intente con otro",
                    "Duplicate profile code try another",
                    "Código de perfil duplicado tente outro"
                  );
                  break;
                default:
                  break;
              }
            } else {
              $scope.mensajeServicio = $translationService.getTranslationController(
                "Error en la creación del perfil",
                "Error creating the profile",
                "Erro ao criar o perfil"
              );
            }
            console.log(e);
            toastr.error($scope.mensajeServicio);
          });
      }
    };

    $scope.chequearEditarPerfil = function () {
      // $scope.editarPerfil(false);

      // ARREGLAR LUEGO DE CAMBIAR EL HABILITADO
      if ($scope.riskProfile.profileId === $scope.userStore.opcionesMenu[0].profileId) {
        var confirm = $mdDialog.confirm();
        $scope.modalPerfilRepetido = $modal({
          templateUrl: "app/perfiles/same-profile.html",
          backdrop: "static",
          size: "md",
          scope: $scope,
          keyboard: false,
          show: true,
        });
      } else {
        $scope.editarPerfil(false);
      }
    };

    //  Método para editar el perfil seleccionado.
    $scope.editarPerfil = function (mismoPerfil) {
      var v = $scope.validarCamposPerfiles(
        $scope.listadoOpcionesSeleccionados,
        $scope.listadoRolesSeleccionados,
        $scope.riskProfile
      );
      var validarCodigoPerfil = vm.verificarCodigoPerfil($scope.riskProfile.profileId);
      $scope.validacion = v;
      var listadoRoles = $scope.listadoRol;
      var listadoOpciones = $scope.listadoOpcion;

      //  Eliminamos las propiedades innecesarias para el envio correcto como consumo de servicio.
      //  Listado de Roles
      for (var i = 0, len = $scope.listadoRolesSeleccionados.length; i < len; i++) {
        delete $scope.listadoRolesSeleccionados[i].$$hashKey;
      }

      //  Listado de Opciones.
      for (var i = 0, len = $scope.listadoOpcionesSeleccionados.length; i < len; i++) {
        delete $scope.listadoOpcionesSeleccionados[i].$$hashKey;
      }

      // Listado de GruposPBI
      $scope.listadoGruposSeleccionados = $scope.listadoGruposSeleccionados.filter(function (
        grupo
      ) {
        return grupo.activo == true;
      });
      for (var i = 0, len = $scope.listadoGruposSeleccionados.length; i < len; i++) {
        delete $scope.listadoGruposSeleccionados[i].$$hashKey;
        //delete $scope.listadoGruposSeleccionados[i].activo;
        delete $scope.listadoGruposSeleccionados[i].isReadOnly;
        delete $scope.listadoGruposSeleccionados[i].riskDomain;
      }

      //  Convertimos nuestro resultado en json para luego enviarlo a nuestro consumo de servicio.
      var listadoOpcionesSeleccionados = $scope.createArrayToJSON(
        $scope.listadoOpcionesSeleccionados
      );
      var listadoRolesSeleccionados = $scope.createArrayToJSON($scope.listadoRolesSeleccionados);
      var listadoGruposSeleccionados = $scope.createArrayToJSON($scope.listadoGruposSeleccionados);

      //VERIFICAMOS SI EXISTE EL MODAL Y LO CERRAMOS
      //ANTES DE MODIFICAR
      if ($scope.modalPerfilRepetido) {
        $scope.modalPerfilRepetido.$promise.then($scope.modalPerfilRepetido.hide);
      }

      if (!v.showPerfil) {
        if ($scope.codigoPerfilHidden === $scope.riskProfile.profileId) {
          //  Consumimos nuestro servicio de modificar o editar perfil.
          PerfilesFactory.editarPerfilRolOpcion(
            $scope.codigoPerfilHidden,
            $scope.riskProfile,
            $scope.listadoRolesSeleccionados,
            $scope.listadoOpcionesSeleccionados,
            $scope.listadoGruposSeleccionados
          )
            .then(function (res) {
              var msg = $translationService.getTranslationController(
                "Se edito el perfil exitosamente.",
                "The profile was successfully edited.",
                "O perfil foi editado com sucesso."
              );
              $scope.mensajeServicio = msg;

              // $scope.resetearFormularioPerfil();
              toastr.success($scope.mensajeServicio);
              $scope.habilitarBotones("editar");
              $scope.editActive = false;
              $scope.codPerfil = true;
              //REFRESCAR LOS CAMBIOS QUE SE HAN HECHO EN LOS PERFILES
              var indexToPop = $scope.listadoPerfilesRolesOpciones.findIndex(function (option) {
                return option.originalProfileId === $scope.riskProfile.originalProfileId;
              });

              // $scope.listadoOpcionesSeleccionados

              $scope.actualizarPerfiles();

              // var currentProfileId = $scope.profile.profileId
              // $scope.profile = {profileId: currentProfileId};
              // console.log($scope.profile);

              // $scope.riskProfile.riskOptionList = $scope.listadoOpcionesSeleccionados;
              if (mismoPerfil) {
                LoginFactory.Logout();
              }
              return res;
            })
            .catch(function (e) {
              var msg = $translationService.getTranslationController(
                "Problemas al editar el perfil.",
                "Problems editing the profile.",
                "Problemas na edição do perfil."
              );
              $scope.mensajeServicio = msg;
              toastr.error($scope.mensajeServicio);
              $scope.resetearFormularioPerfil;
              $scope.riskProfile = [];
            });
        } else {
          if (validarCodigoPerfil) {
            var msg = $translationService.getTranslationController(
              "Ya existe el perfil en sistema, por favor ingrese otro diferente",
              "The system profile already exists, please enter a different one",
              "O perfil do sistema já existe, por favor insira um diferente"
            );
            $scope.mensajeServicio = msg;
          } else {
            var msg = $translationService.getTranslationController(
              "El código del perfil es unico y no puede modificarse.",
              "The profile code is unique and can not be modified.",
              "O código do perfil é único e não pode ser modificado."
            );
            $scope.mensajeServicio = msg;
            //  Consumimos nuestro servicio de modificar o editar perfil.
          }
        }

        $scope.resetearFormularioPerfil;
      }
    };

    $scope.resetearFormularioPerfil = function () {
      $scope.riskProfile = [];
      $scope.profile = [];
      $scope.listadoOpcionesSeleccionados = [];

      $scope.listadoRol.map(function (elem) {
        elem.value = false;
      });

      $scope.listadoOpcion.map(function (elem) {
        elem.habilitado = false;
      });

      if ($scope.pbi) {
        $scope.pbi.groups.map(function (elem) {
          elem.habilitado = false;
        });
      }

      $scope.listadoRolesSeleccionados = [];

      for (var i = 0; i < $scope.listadoOpcionesSeleccionados.length; i++) {
        $scope.listadoRol[i].value = false;
        $scope.listadoOpcion[i].habilitado = false;
        $scope.listadoOpcionesSeleccionados[i].habilitado = false;
      }
    };

    $scope.profile = [];
    $scope.mensajePerfil = "";

    $scope.limpiarFormulario = function () {
      $scope.botonesDeAccion = {
        crear: true,
        guardar: false,
        editar: false,
        eliminar: false,
        cancelar: false,
      };
      $scope.editActive = false;
      $scope.resetearFormularioPerfil();
    };

    $scope.busquedaPerfil = function () {
      $rootScope.loading = true;
      $scope.profileEdit = [];
      $scope.riskOptionList = [];
      $scope.riskRoleList = [];
      if (null == $scope.profile.profileId) {
        $scope.riskProfile = [];
        $scope.listadoOpcion = $scope.listadoOpcionRespaldo;
        $scope.listadoRol = $scope.listadoRolRespaldo;
        $scope.codigoPerfilHidden = "";
        $rootScope.loading = false;
      } else {
        //  Comenzamos con nuestra la búsqueda y realizamos las modificaciones correspondientes.
        $scope.editActive = true;
        $scope.habilitarBotones("busqueda");
        $scope.riskProfile = $scope.profile;
        $scope.riskOptionList = [];
        $scope.riskOptionList = $scope.profile.riskOptionList;
        $scope.riskWorkspaceList = $scope.profile.riskWorkspaceList;
        if ($scope.pbi) {
          // Si no hay datos de PoweBI salta esta sección
          // -- Limpiar los grupos PBI previamente seleccionados
          //if (Object.keys($scope.pbi.groups[0]).includes('habilitado')){
          $scope.pbi.groups.map(function (opcion) {
            opcion.habilitado = false;
          });
          //}
          // -- Cargar los grupos PBI seleccionados del usuario actual
          $scope.listadoGruposSeleccionados = [];
          if ($scope.riskWorkspaceList) {
            $scope.riskWorkspaceList.forEach(function (gruposUsuario) {
              var currentOption = $scope.pbi.groups.find(function (grupo) {
                return gruposUsuario.workspaceId === grupo.workspaceId;
              });
              if (currentOption) {
                currentOption.habilitado = true;
                $scope.listadoGruposSeleccionados.push(currentOption);
              }
            });
          }
        }

        $scope.riskRoleList = $scope.profile.riskRoleList || [];
        $scope.listadoRolesSeleccionados = [];
        $scope.riskRoleList.forEach(function (role) {
          role.value = true;
          $scope.listadoRolesSeleccionados.push(role);
        });

        ///VERIFICAR SI SE HA BUSCADO ANTERIORMENTE
        // Y SETEAR LAS OPCIONES A FALSE
        if (Object.keys($scope.listadoOpcion[0]).includes("habilitado")) {
          $scope.listadoOpcion.map(function (opcion) {
            opcion.habilitado = false;
          });
        }

        if ($scope.riskOptionList) {
          $scope.riskOptionList.forEach(function (opcionUsuario) {
            var currentOption = $scope.listadoOpcion.find(function (opcion) {
              return opcionUsuario.idFuncion === opcion.idFuncion;
            });
            if (currentOption) currentOption.habilitado = true;
          });
        }
        // $scope.listadoOpcion = $scope.riskOptionList;
        $scope.listadoOpcionesSeleccionados = [];
        $scope.listadoOpcion.forEach(function (opcion) {
          if (opcion.habilitado) {
            $scope.listadoOpcionesSeleccionados.push(opcion);
          }
        });

        if (Object.keys($scope.listadoRol[0]).includes("value")) {
          $scope.listadoRol.map(function (rol) {
            rol.value = false;
          });
        }

        // VERIFICAR LOS ROLES DEL SISTEMA CON LOS ROLES QUE TIENE EL PERFIL
        $scope.listadoRol.map(function (currentRol) {
          var rol = $scope.riskRoleList.find(function (role) {
            return role.roleId === currentRol.roleId;
          });
          if (rol) currentRol.value = rol.value;
        });
        $scope.codigoPerfilHidden = $scope.profile.profileId;
        $rootScope.loading = false;
      }
    };

    //ngModel value
    $scope.selected = undefined;

    $scope.select = [];

    $scope.exist = function (item) {
      return $scope.select.indexOf(item);
    };

    $scope.toggleSelection = function (item) {
      var idx = $scope.select.indexOf(item);
      if (idx > -1) {
        $scope.select.splice(idx, 1);
      } else {
        $scope.select.push(item);
      }
    };

    //  Validaciones para crearUsuario.
    $scope.show = false;
    $scope.content = "";
    $scope.mensajeErrorValidacion = "";

    //  Validar formulario Crear Perfil.
    $scope.validarCamposPerfiles = function (
      listadoOpcionesSeleccionados,
      listadoRolesSeleccionados,
      riskProfile
    ) {
      var validacion = { contentPerfil: "", showPerfil: false };
      var cantidadOpcionesSeleccionadas = listadoOpcionesSeleccionados.length;
      var cantidadRolesSeleccionados = listadoRolesSeleccionados.length;
      $scope.resultadoPerfil = [];

      if (!riskProfile.profileName) {
        var msg = $translationService.getTranslationController(
          "Escriba el nombre de su perfil.",
          "Enter the name of your profile.",
          "Digite o nome do seu perfil."
        );
        validacion.contentPerfil = msg;
        $scope.contentPerfil = validacion.contentPerfil;

        validacion.showPerfil = true;

        $scope.showPerfil = validacion.showPerfil;
      } else if (!riskProfile.profileId) {
        var msg = $translationService.getTranslationController(
          "Escriba el nombre de su perfil.",
          "Enter the name of your profile.",
          "Escreva a nome do seu perfil."
        );
        validacion.contentPerfil = msg;
        $scope.contentPerfil = validacion.contentPerfil;
        validacion.showPerfil = true;
        $scope.showPerfil = validacion.showPerfil;
      } else if (!riskProfile.originalProfileId) {
        var msg = $translationService.getTranslationController(
          "Escriba el origen de su perfil.",
          "Write the origin of your profile.",
          "Escreva a origem do seu perfil."
        );
        validacion.contentPerfil = msg;
        $scope.contentPerfil = validacion.contentPerfil;
        validacion.showPerfil = true;
        $scope.showPerfil = validacion.showPerfil;
      } else if (!riskProfile.descripcion) {
        var msg = $translationService.getTranslationController(
          "Escriba la descricpción de su perfil.",
          "Write the description of your profile.",
          "Escreva a descrição do seu perfil."
        );
        validacion.contentPerfil = msg;
        $scope.contentPerfil = validacion.contentPerfil;

        validacion.showPerfil = true;

        $scope.showPerfil = validacion.showPerfil;
      } else if (cantidadOpcionesSeleccionadas <= 0) {
        var msg = $translationService.getTranslationController(
          "Seleccione al menos una opción del ménu de opciones del sistema.",
          "Select at least one option of the number of system options.",
          "Selecione pelo menos uma opção do número de opções do sistema."
        );
        validacion.contentPerfil = msg;
        $scope.contentPerfil = validacion.contentPerfil;

        validacion.showPerfil = true;

        $scope.showPerfil = validacion.showPerfil;
      } else if (cantidadRolesSeleccionados <= 0) {
        var msg = $translationService.getTranslationController(
          "Seleccione al menos un rol para su perfil.",
          "Select at least one role for your profile.",
          "Seleccione al menos un rol para su perfil."
        );
        validacion.contentPerfil = msg;
        $scope.contentPerfil = validacion.contentPerfil;

        validacion.showPerfil = true;

        $scope.showPerfil = validacion.showPerfil;
      }

      if (validacion.showPerfil) {
        // $timeout(function () {
        //     $('body').scrollTo(('#alert-msg'), 200);
        // }, 100)
      }
      return validacion;
    };

    $scope.habilitarCrear = function () {
      $scope.resetearFormularioPerfil();
      vm.initPerfilesController();
      $scope.editActive = true;
      $scope.habilitarBotones("crear");
    };

    $scope.habilitarBotones = function (tipo) {
      $scope.contentPerfil = "";
      switch (tipo) {
        case "crear":
          $scope.botonesDeAccion.guardar = true;
          // $scope.botonesDeAccion.cancelar = true;
          $scope.botonesDeAccion.crear = false;
          $scope.botonesDeAccion.editar = false;
          $scope.botonesDeAccion.eliminar = false;
          $scope.codPerfil = true;
          break;
        case "editar":
        case "guardar":
        case "eliminar":
          $scope.botonesDeAccion.crear = true;
          $scope.botonesDeAccion.guardar = false;
          $scope.botonesDeAccion.editar = false;
          $scope.botonesDeAccion.eliminar = false;
          $scope.botonesDeAccion.cancelar = false;
          break;
        case "busqueda":
          $scope.botonesDeAccion.editar = true;
          $scope.botonesDeAccion.cancelar = true;
          $scope.botonesDeAccion.eliminar = true;
          $scope.botonesDeAccion.crear = false;
          $scope.botonesDeAccion.guardar = false;
          $scope.codPerfil = false;
          break;
        default:
          break;
      }
    };

    $scope.actualizarPerfiles = function () {
      $timeout(function () {
        PerfilesFactory.listadoPerfilesRolesOpcionesActivos().then(function (res) {
          $scope.listadoPerfilesRolesOpciones = res;

          for (var i = 0; i < $scope.listadoPerfilesRolesOpciones.length; i++) {
            $scope.searchCodigoPerfil[i] = $scope.listadoPerfilesRolesOpciones[i].profileId;
            if ($scope.profile.profileId === $scope.listadoPerfilesRolesOpciones[i].profileId) {
              $scope.profile = $scope.listadoPerfilesRolesOpciones[i];
            }
          }

          $scope.$apply();
        });
      }, 800);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .run(function (translationService, $locale) {
      var region = translationService.getRegion();
      translationService.setRegionalConfigs(region, $locale);
    })
    .controller('MainController', MainController);

  MainController.$inject = [
    '$scope',
    '$cookies',
    '$state',
    'Alertas',
    '$rootScope',
    'moment',
    '$interval',
    'Casos',
    'AlertasConfig',
    'LoginFactory',
    '$localStorageService',
    '$modal',
    // 'ReplayConfigurationFactory',
    'env',
    'translationService',
    'PermissionsFactory',
    '$window',
    'toastr',
    'version',
    "BookmarkService"
  ];

  function MainController(
    $scope,
    $cookies,
    $state,
    Alertas,
    $rootScope,
    moment,
    $interval,
    Casos,
    AlertasConfig,
    LoginFactory,
    $localStorageService,
    $modal,
    // ReplayConfigurationFactory,
    env,
    $translationService,
    PermissionsFactory,
    $window,
    $toastr,
    $version,
    $bookmarkService
  ) {
    $translationService.getTranslation($scope, 'includes');
    $bookmarkService.init()
    var dateFormat = 'YYYY-MM-DD';

    var vm = this;
    vm.user = $localStorageService.getItem("currentUser");
    vm.version = $version;

    $scope.openDocumentation = function () {
      if (PermissionsFactory.hasPermission('documentation:read')) {
        $window.open('docs/', 'docs', 'width=800,height=800');
      } else {
        $toastr.info(
          $translationService.getTranslationController(
            'no tienes permiso para ver la documentacion.',
            "you don't have permission to see the documentation.",
            'no tienes permiso para ver la documentacion.'
          )
        );
      }
    };

    vm.customLogo = $localStorageService.getItem("customLogo") || false;
    vm.desdeMinimo = '2000-01-01';
    $scope.format = 'HH:mm';

    vm.favs = [];
    $scope.$watch(
      function () {
        return vm.favs;
      },
      function (newValue) {
        vm.favs = newValue;
      }
    );

    //  Declaramos variables para el obtener el estado de las opciones.
    vm.opcionMenuHabilitado = false;
    vm.menuOpen = null;
    vm.opcionDasboardHabilitada = false;
    vm.opcionIncidenciasHabilitada = false;
    vm.opcionCasosHabilitada = false;
    vm.opcionConfiguracionHabilitada = false;
    vm.opcionCredencialesHabilitada = false;
    vm.opcionAuditoriaHabilitada = false;
    vm.opcionUserTrackHabilitada = false;
    vm.opcionBovedaHabilitada = false;
    vm.opcionReportesHabilitada = false;
    vm.opcionEsquemasHabilitada = false;
    vm.opcionListasHabilitada = false;
    vm.opcionSeguridadHabilitada = false;
    vm.opcionSeguridadUsuarioHabilitada = false;
    vm.opcionSeguridadPerfilHabilitada = false;
    vm.opcionSeguridadAclHabilitada = true;
    vm.habilitarSubMenu = false;
    vm.habilitarSubMenuConf = false;
    vm.habilitarSubMenuEsquemas = false;
    vm.habilitarSubMenuReglas = false;
    // vm.habilitarSubMenuReplay = false;
    // vm.opcionReplaysHabilitada = false;
    // vm.opcionRankingsHabilitada = false;
    vm.opcionesHabilitadas = [];
    // vm.replays = [];

    $rootScope.debug = false;

    var modalTimezone2 = $modal({
      templateUrl:
        'app/main/components/timezone-edition-dialog/timezone.template.html',
      controller: 'TimeZoneController',
      keyboard: false,
      show: false,
    });

    vm.validatePermission = function (permissions) {
      var flag = false;
      for (var i = 0; i < permissions.length; i++) {
        flag = PermissionsFactory.hasPermission(permissions[i]);
        if (flag == true) {
          return flag;
        }
      }
      return flag;
    };

    // function init() {
    //   if (vm.validatePermission(['graphic-report:read'])) {
    //     ReplayConfigurationFactory.getReplays({
    //       active: true,
    //       target: 'replay',
    //     })
    //       .then(function (res) {
    //         vm.replays = res.data;
    //       })
    //       .catch(function (e) {
    //         console.log('No se han podido cargar los replays');
    //         console.log(e.msg);
    //         vm.opcionReplaysHabilitada = false;
    //       });
    //   }
    // }

    // init();

    //rangos de fechas para header
    vm.desde = moment().hour(0).minute(0).second(0).subtract(1, 'week');
    vm.hasta = moment().hour(23).minute(59).second(59);
    vm.desdeMinimo = '2000-01-01';

    /*WEBSOCKET CONFIG*/
    var config = {
      datasource: {
        origin: env.ssl ? 'WSS' : 'WS', //REST Methods, ARRAY, WS o WSS(WebSocket).Desde localhost usar WS, con seguridad WSS
        url:
          env.domain +
          (env.port ? ':' + env.port : '') +
          '/risk-backend/websockets/events', //"localhost:30249/risk-backend/websockets/events"//reemplazar localhost por ubicacion backend,solo para rest y ws
        paramsDefault: {},
        paramsOut: {
          data: 'events',
          pagination: 'pagination',
        },
      },
    };

    $scope.close = false;

    vm.toggleMenu = function () {
      vm.menuOpen = !vm.menuOpen;
      $rootScope.$broadcast('toggleMenu');
    };

    $scope.start = function () {
      var url = config.datasource.url;
      var ws = '';
      if (config.datasource.origin === 'WS') ws = 'ws://' + url;
      else ws = 'wss://' + url;

      var webSocket = new WebSocket(ws);
      config.datasource.params = config.datasource.paramsDefault;
      config.datasource.params.token = $cookies.get('token');

      //Al abrir enviar KEY
      webSocket.onopen = function (message) {
        console.log('Websocket: Comunicacion iniciada');
      };

      webSocket.onerror = function (err) {
        console.log('Websocket error:');
        console.log(err);
      };

      //Mensaje Recibido
      webSocket.onmessage = function (message) {
        var data = {};
        try {
          data = JSON.parse(message.data);
        } catch (err) { }
      };

      //renovar la conexion cada 60 segundos
      $scope.interval = $interval(function () {
        webSocket.send(JSON.stringify(config.datasource.params));
      }, 1000 * 60);

      //Conexion cerrada
      webSocket.onclose = function (message) {
        $interval.cancel(scope.interval);
        if ($scope.close == false) {
          $timeout(function () {
            $scope.websocket = scope.start();
          }, 5000);
        }
      };
      return webSocket;
    };

    // -- Inicia el Websocket
    //$scope.websocket = $scope.start();

    /** @deprecated */
    vm.bDate = function () {
      $rootScope.desde = vm.desde;
      $rootScope.hasta = vm.hasta;
      $scope.$broadcast('refreshDatepickers');
    };
    vm.bDate();

    $rootScope.filters = {
      sortBy: 'id',
      filterBy: {
        criticality: {
          alta: false,
          media: false,
          baja: false,
          desconocida: false,
        },
        status: {
          auditoria: false,
          'en curso': false,
          asignada: false,
          desconocido: false,
        },
        checked: {
          'no visto': false,
          visto: false,
        },
      },
    };

    //Lista de alertas para el home con los dashboards
    var jusShowQty = 10;
    vm.alertas = [];
    vm.alertasSrc = [];
    //Datos para los graficos del home
    vm.labelsEventos = [];
    vm.dataEventos = [];
    vm.labelsCriticidad = [];
    vm.dataEventosCriticidad = [];
    //Datos para la seccion de alertas
    vm.alertasDetalle = [];
    vm.alertasDetalleSrc = [];
    $rootScope.tabsAlerts = [{ id: 'index', name: 'ALERTAS' }];
    //Datos para la seccion de casos
    vm.casosDetalle = [];
    vm.casosDetalleSrc = [];
    $rootScope.tabsCasos = [{ id: 'index', name: 'CASOS' }];
    //Datos para la seccion de configuracion
    vm.alertasConfig = [];
    vm.alertasConfigSrc = [];
    //datos de auditoria
    $rootScope.tabsAuditoria = [{ id: 'index', name: 'REGISTRO DE SISTEMA' }];
    //datos de series
    $rootScope.tabsSeries = [{ id: 'index', name: 'SERIES' }];
    //datos de replay
    // $rootScope.tabsReplays = [{ id: 'index', name: 'REPLAY' }];
    //datos de searcher
    $rootScope.tabsSearchers = [{ id: 'index', name: 'SEARCHER' }];
    $rootScope.tabsGroups = [{ id: 'index', name: 'GROUP' }];

    function processAlertas(arrayAlertas) {
      //Se reciben las alertas filtradas por los rangos de fecha
      var mapEvents = {};
      var mapCriticidad = {};
      vm.alertas = [];
      vm.alertasSrc = [];
      vm.alertasDetalle = [];
      vm.alertasDetalleSrc = [];
      vm.dataEventos = [];
      vm.labelsEventos = [];
      for (var i = 0; i < arrayAlertas.length; i++) {
        //Se muestran las primeras N alertas pero se procesan todas para calcular la info de los graficos
        if (i < jusShowQty) {
          vm.alertasSrc.push(arrayAlertas[i]);
        }
        vm.alertasDetalleSrc.push(arrayAlertas[i]);
        var countEvents = mapEvents[arrayAlertas[i].tipo];
        if (!countEvents) {
          countEvents = 0;
        }
        countEvents++;
        mapEvents[arrayAlertas[i].tipo] = countEvents;
        var countCriticidad = mapCriticidad[arrayAlertas[i].criticidad];
        if (!countCriticidad) {
          countCriticidad = 0;
        }
        countCriticidad++;
        mapCriticidad[arrayAlertas[i].criticidad] = countCriticidad;
      }
      //Se obtienen datos para grafico de eventos
      //Se utiliza interval para evitar bug con la animacion de los graficos
      $interval(
        function () {
          vm.labelsEventos = [].concat(Object.keys(mapEvents));
          vm.dataEventos = [].concat(
            vm.labelsEventos.map(function (v) {
              return mapEvents[v];
            })
          );
          //Se obtienen datos para grafico de criticidad
          $interval(
            function () {
              vm.labelsCriticidad = [].concat(Object.keys(mapCriticidad));
              vm.dataCriticidad = [].concat(
                vm.labelsCriticidad.map(function (v) {
                  return mapCriticidad[v];
                })
              );
            },
            1000,
            1
          );
        },
        500,
        1
      );
      //Se obtienen datos para actualizar la tabla
      vm.alertas = [].concat(vm.alertasSrc);
      vm.alertasDetalle = [].concat(vm.alertasDetalleSrc);
    }

    function buscarAlertas() {
      //Se buscan todas las alertas que cumplan con el filtro
      Alertas.searchAlerts(
        moment(vm.desde).format(dateFormat),
        moment(vm.hasta).format(dateFormat),
        function (response) {
          if (response.header.code == 0 && response.body != null) {
            processAlertas(response.body);
          }
        }
      );
    }

    function processCasos(arrayCasos) {
      //Se reciben los casos filtrados por los rangos de fecha
      vm.casosDetalle = [];
      vm.casosDetalleSrc = [];
      for (var i = 0; i < arrayCasos.length; i++) {
        vm.casosDetalleSrc.push(arrayCasos[i]);
      }
      vm.casosDetalle = [].concat(vm.casosDetalleSrc);
    }

    function buscarCasos() {
      //Se buscan todos los casos que cumplan con el filtro
      Casos.searchCasos(
        moment(vm.desde).format(dateFormat),
        moment(vm.hasta).format(dateFormat),
        function (response) {
          if (response.header.code == 0 && response.body != null) {
            processCasos(response.body);
          }
        }
      );
    }

    vm.existeFiltro = function () {
      return vm.desde && vm.hasta && vm.desde != '' && vm.hasta != '';
    };

    vm.search = function () {
      $rootScope.$broadcast('dateChange', {
        desde: vm.desde,
        hasta: vm.hasta,
        searchBtn: true,
      });
    };

    /**
     * @deprecated With new tiles menu
     * */
    vm.clickSubMenu = function (submenu) {
      vm.habilitarSubMenu =
        submenu == 'habilitarSubMenu' ? !vm.habilitarSubMenu : false;
      vm.habilitarSubMenuConf =
        submenu == 'habilitarSubMenuConf' ? !vm.habilitarSubMenuConf : false;
      vm.habilitarSubMenuEsquemas =
        submenu == 'habilitarSubMenuEsquemas'
          ? !vm.habilitarSubMenuEsquemas
          : false;
      // vm.habilitarSubMenuReplay =
      //   submenu == 'habilitarSubMenuReplay'
      //     ? !vm.habilitarSubMenuReplay
      //     : false;
      vm.habilitarSubMenuReglas =
        submenu == 'habilitarSubMenuReglas'
          ? !vm.habilitarSubMenuReglas
          : false;
    };

    vm.clickMenu = function (state, goEvent) {
      goEvent ? false : resetFilters();
      if (state == 'app.rules') {
        AlertasConfig.obtenerAlertas(function (response) {
          if (response.header.code == 0) {
            vm.alertasConfigSrc = response.body;
            vm.alertasConfig = [].concat(vm.alertasConfigSrc);
          }
          $state.go(state, {}, { reload: false });
        });
      } else {
        $state.go(
          state,
          { desde: moment(vm.desde), hasta: moment(vm.hasta) },
          { reload: false }
        );
      }

      var securityModules = [
        'app.profiles',
        'app.usuarios',
        'app.auditoria',
        'app.acl',
        'app.group-list',
      ];
      if (securityModules.includes(state)) {
        vm.habilitarSubMenu = true;
      } else {
        vm.habilitarSubMenu = false;
      }

      var configurationModules = [
        'app.credenciales',
        'app.series',
        // 'app.replay-list',
        'app.configuration',
      ];
      if (configurationModules.includes(state)) {
        vm.habilitarSubMenuConf = true;
      } else {
        vm.habilitarSubMenuConf = false;
      }

      var entriesModules = [
        'app.schemas',
        'app.schemasLists',
        'app.searcher',
        'app.searcher-list',
      ];
      if (entriesModules.includes(state)) {
        vm.habilitarSubMenuEsquemas = true;
      } else {
        vm.habilitarSubMenuEsquemas = false;
      }

      var rulesModules = ['app.rules', 'app.filtersList', 'app.rule-schedules'];
      if (rulesModules.includes(state)) {
        vm.habilitarSubMenuReglas = true;
      } else {
        vm.habilitarSubMenuReglas = false;
      }

      // if (state === 'app.event-replay') {
      //   vm.habilitarSubMenuReplay = true;
      // } else {
      //   vm.habilitarSubMenuReplay = false;
      // }
    };

    /**
     * @deprecated Without use
     */
    vm.clickEvents = function (event, n) {
      if (n > 0) {
        // -- OLD risk-grid
        $rootScope.filters.filterBy.event = event;
        $rootScope.filters.filterBy.seen = false;

        // -- NEW risk-grid
        var filterBy = {
          criticality: {
            baja: event == 'baja',
            media: event == 'media',
            alta: event == 'alta',
          },
        };
        $state.go('app.alarmas', { filterBy: filterBy });
      }
    };

    function resetFilters() {
      $rootScope.filters.filterBy.event = undefined;
      $rootScope.filters.filterBy.seen = undefined;
    }

    $rootScope.startLoader = function () {
      $rootScope.loader = { show: true, value: 0 };
      if (!angular.isDefined($rootScope.loaderTimer)) {
        $rootScope.loaderTimer = $interval(function () {
          $rootScope.loader.value++;
        }, 100);
      }
    };

    $rootScope.stopLoader = function () {
      $rootScope.loader.show = false;
      if (angular.isDefined($rootScope.loaderTimer)) {
        $interval.cancel($rootScope.loaderTimer);
        $rootScope.loaderTimer = undefined;
      }
    };

    vm.logout = function () {
      $interval.cancel($rootScope.tokenTimer);
      LoginFactory.LogoutSession();
      $rootScope.loading = false;
    };

    $rootScope.getAlertaById = function (idAlerta) {
      for (var i = 0; i < vm.alertasDetalle.length; i++) {
        var alerta = vm.alertasDetalle[i];
        if (alerta.id == idAlerta) {
          return alerta;
        }
      }
      return null;
    };

    $rootScope.getCasoById = function (idCaso) {
      for (var i = 0; i < vm.casosDetalle.length; i++) {
        var caso = vm.casosDetalle[i];
        if (caso.id == idCaso) {
          return caso;
        }
      }
      return null;
    };

    $rootScope.crearCaso = function (casoData, idAlerta, callback) {
      Casos.crearCaso(casoData, idAlerta, function (response) {
        if (response.header.code == 0) {
          //Se agrega el nuevo caso a la lista
          vm.casosDetalleSrc.push(response.body);
          vm.casosDetalle = [].concat(vm.casosDetalleSrc);
          callback(response);
        }
      });
    };

    $rootScope.validarCaso = function (casoData) {
      var validacion = { content: '', show: false };
      if (!casoData.nombre) {
        validacion.content = $translationService.getTranslationController(
          'Es requerido especificar el nombre del caso',
          'It is required to specify the name of the case',
          'É necessário especificar o nome do caso'
        );
        validacion.show = true;
      } else if (!casoData.criticidad) {
        validacion.content = $translationService.getTranslationController(
          'Es requerido especificar la criticidad del caso',
          'It is required to specify the criticality of the case',
          'É necessário especificar a criticidade do caso'
        );
        validacion.show = true;
      }
      return validacion;
    };

    $rootScope.sortcriticidad = function (value) {
      var cri = value.criticidad;
      if (cri) {
        if (cri.toLowerCase() === 'alta') {
          return 3;
        } else if (cri.toLowerCase() === 'media') {
          return 2;
        } else if (cri.toLowerCase() === 'baja') {
          return 1;
        }
      }
      return 0;
    };

    var URL_CAMBIAR_PASSWORD = 'app/usuarios/cambiarPassword.html';
    var modalPassword;

    $scope.$on('profileState', function (evt, perfil) {
      $state.go('app.profiles', { perfil: perfil }, { reload: false });
    });

    $scope.$on('closeModalUserPassword', function () {
      modalPassword.$promise.then(modalPassword.hide);
    });

    vm.showModalPassword = function () {
      modalPassword = $modal({
        templateUrl: URL_CAMBIAR_PASSWORD,
        controller: 'UsuarioPasswordController',
        keyboard: false,
      });

      modalPassword.$promise.then(modalPassword.show);
    };

    vm.showModalTimezone = function () {
      modalTimezone2.$promise.then(modalTimezone2.show);
    };

    $scope.$on('closeModalZone', function () {
      modalTimezone2.$promise.then(modalTimezone2.hide);
    });

    vm.search();

    // vm.keyboardCheatSheet = function () {
    //   hotkeys.toggleCheatSheet();
    // };
  }
})();

(function () {
  "use strict";
  angular.module("dashboard").controller("PasswordResetController", PasswordResetController);

  PasswordResetController.$inject = [
    "$scope",
    "translationService",
    "PasswordResetFactory",
    "gRecaptcha",
    "ConfigurationFactory",
  ];
  function PasswordResetController(
    $scope,
    $translationService,
    $passwordResetFactory,
    gRecaptcha,
    $ConfigurationFactory
  ) {
    $translationService.getTranslation($scope, "login");
    $scope.showParticles = true;
    $scope.loading = false;
    $scope.request = false;
    $scope.recaptcha = false;
    $scope.username = "";
    
    $scope.message = $scope.$parent.$parent.login.errorPolicies  ||  $translationService.getTranslationController(
      "Para recuperar su contraseña ingrese su nombre de usuario y le enviaremos un enlace para restablecer su contraseña",
      "To recover your password enter your username and we will send you a link to reset your password",
      "Para recuperar sua senha, insira seu nome de usuário e enviaremos um link para redefinir sua senha"
    )

    if (!gRecaptcha.isInitialized()) {
      $ConfigurationFactory.getPublicKeyRecaptcha().then(function (keys) {
        gRecaptcha.initialize({ key: keys });
      });
    } else {
      var element = angular.element(".grecaptcha-badge");
      element.show();
    }

    $scope.cancel = function () {
      var element = angular.element(".grecaptcha-badge");
      element.hide();
    };

    $scope.startReset = function () {
      $scope.loading = true;
      try {
        gRecaptcha.execute({ action: "resetpassword" }).then(function (token) {
          $scope.recaptcha = token;

          $passwordResetFactory
            .passwordResetRequest($scope.username, $scope.recaptcha)
            .then(function (r) {
              $scope.request = true;
            })
            .catch(function (error) {
              console.log("Error@passwordResetRequest", error);
              $scope.request = false;
            })
            .finally(function () {
              $scope.loading = false;
            });
        });
      } catch (error) {
        $scope.loading = false;
        console.log("gRecaptchaEror", error);

        return false;
      }
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller("OautLoginController", OautLoginController);

  OautLoginController.$inject = [
    "$scope",
    "$location",
    "LoginFactory",
    "$stateParams",
    "$localStorageService",
    "translationService",
    "sessionService",
    "$state",
    "DashboardService"
  ];
  function OautLoginController(
    $scope,
    $location,
    $loginFactory,
    $stateParams,
    $localStorageService,
    $translationService,
    $sessionService,
    $state,
    $dashboardService
  ) {
    var vm = this;
    vm.traslation = {
      loginWith: $translationService.getTranslationController(
        "Iniciar sesión con",
        "Login with",
        "Iniciar sessão com"
      ),
      pleaseWait: $translationService.getTranslationController(
        "Por favor espere...",
        "Please wait...",
        "Por favor aguarde..."
      ),
      redirecting : $translationService.getTranslationController(
        "Redireccionando al proveedor de autenticación",
        "Redirecting to authentication provider",
        "Redirecionando para o provedor de autenticação"
      )
    }
    vm.providerName = $stateParams.providerName;

    console.log("OAuth Login Controller", $location);
    var code = $location.search().code;
    var state = $location.search().state;

    setTimeout(function () {
      loginByOAuth2Fn($stateParams.providerName, code, state);
    }, 500);


    function loginByOAuth2Fn(providerName, code, state) {
      console.log("Login by OAuth2", providerName, code, state);
      vm.providerName = providerName;
      $scope.loading = true;
      $loginFactory
        .loginByOAuth2(providerName, code)
        .then(function (response) {
          if (response.active != "t") {
            vm.error = $translationService.getTranslationController(
              "Usuario Inactivo",
              "Inactive User",
              "Usuário Inativo"
            );
          } else {
            
            $localStorageService.setItem("currentUser", {
              userId: response.userId,
              username: response.username,
              name: response.fullName,
              tokenInfo: response.tokenInfo,
              lenguaje: response.lang,
              region: response.region,
              timeZone: response.timeZone,
              userType: response.profile.type,
              domain: response.domain,
              permissions: response.profile.permissions,
              categories: response.profile.categories,
              groups: response.profile.groups,
              company: response.company
            });
            $dashboardService.storeCompanyConfiguration()
              .then(function () {
                console.log("Company configuration stored successfully");
                setTimeout(function () {
                  $sessionService.startCheck();
                  setTimeout(function () {
                    $dashboardService.toHomePage();
                  }, 250);
                }, 500);
              })
              .catch(function (error) {
                console.error("Error@storeCompanyConfiguration", error);
              });
          }
        })
        .catch(function (error) {
          console.error("Error@loginByOAuth2", error);
          if (error.status == 404) {
            vm.error = $translationService.getTranslationController(
              "Usuario no encontrado",
              "User not found",
              "Usuário não encontrado"
            );
          } else if (error.status == 412) {
            vm.error = $translationService.getTranslationController(
              "Usuario Inactivo",
              "Inactive User",
              "Usuário Inativo"
            );
          } else {
            console.error("Error@loginByOAuth2", error);
            $state.go("login");
          }
          $state.go("login", { id: 2, message: vm.error });
        })
        .finally(function () {
          $scope.loading = false;
        });
    }
  }
})();

(function () {
  "use strict";
  angular.module("dashboard").controller("LoginController", LoginController);

  LoginController.$inject = [
    "$location",
    "LoginFactory",
    "$state",
    "$stateParams",
    "$modal",
    "$scope",
    "PasswordResetFactory",
    "$rootScope",
    "translationService",
    "sessionService",
    "$localStorageService",
    "toastr",
    "$mdDialog",
    "UserFactory",
    "gRecaptcha",
    "keys",
    "ConfigurationFactory",
    "DashboardService"
  ];
  function LoginController(
    $location,
    $loginFactory,
    $state,
    $stateParams,
    $modal,
    $scope,
    $passwordResetFactory,
    $rootScope,
    $translationService,
    $sessionService,
    $localStorageService,
    $toastr,
    $mdDialog,
    UserFactory,
    gRecaptcha,
    keys,
    $ConfigurationFactory,
    $dashboardService
  ) {
    $translationService.getTranslation($scope, "login");
    var isLoginPath =
      $state && $state.current && $state.current.name === "login";

    var vm = this;
    vm.isRecoveringSession = isLoginPath ? false : true;
    vm.mode = isLoginPath ? "login" : "recoverSession";
    vm.login = beforeloginV2;
    vm.errorPassChange = "";
    vm.successPassChange = "";
    vm.changePassword1 = "";
    vm.changePassword2 = "";
    vm.code2fa = "";
    vm.passwordPolicies = null;
    vm.habilitarCambioPassword = false;
    $scope.login = false;
    $scope.showPasswordEdit = false;
    $scope.showVerifyTwoFa = false;

    var userlogin = null;

    getProvidersFn();
    // getPasswordPolicies();

    if ($localStorageService.getItem("currentUser")) {
      $loginFactory.LogoutSession();
    }

    var searchObject = $location.search();

    if (searchObject.user == null && searchObject.token == null) {
      vm.habilitarCambioPassword = false;
      $scope.showPasswordEdit = false;
    } else {
      vm.habilitarCambioPassword = true;
      $scope.showPasswordEdit = true;
    }

    if ($rootScope.passChangeData) {
      $scope.showPasswordEdit = true;
    }

    $("[data-theme]").attr("data-theme", $localStorageService.getItem("theme"));

    var defaultLogo = false;
    vm.customLogo = $localStorageService.getItem("customLogo")
      ? $localStorageService.getItem("customLogo")
      : defaultLogo;

    vm.cambiarPasswordModal = function () {
      $modal({
        templateUrl: "app/login/cambiarPassword.html",
        backdrop: "static",
        size: "md",
        scope: $scope,
        keyboard: false,
        show: true
      });
    };

    $scope.validarCambiarPassword = function () {
      var validacion = { content: "", show: false };
      if (!vm.passwordAntigua) {
        validacion.content = $translationService.getTranslationController(
          "Debe llenar el campo Password Antiguo.",
          "You must fill in the Old Password field.",
          "Você deve preencher o campo Old Password."
        );
        $scope.content = validacion.content;
        validacion.show = true;
        $scope.show = validacion.show;
      } else if (!vm.passwordNueva) {
        validacion.content = $translationService.getTranslationController(
          "Debe llenar el campo Password Nuevo.",
          "You must fill in the Password New field.",
          "Você deve preencher o campo Password New."
        );
        $scope.content = validacion.content;

        validacion.show = true;
        $scope.show = validacion.show;
      } else if (!vm.passwordConfirmar) {
        validacion.content = $translationService.getTranslationController(
          "Debe llenar el campo Confirmar Password.",
          "You must fill in the Confirm Password field.",
          "Você deve preencher o campo Confirmar senha."
        );
        $scope.content = validacion.content;
        validacion.show = true;
        $scope.show = validacion.show;
      } else if (vm.passwordConfirmar !== vm.passwordNueva) {
        validacion.content = $translationService.getTranslationController(
          "La contraseñas deben ser iguales.",
          "The passwords must be the same.",
          "As senhas devem ser as mesmas."
        );
        $scope.content = validacion.content;
        validacion.show = true;
        $scope.show = validacion.show;
      }
      return validacion;
    };

    $scope.cancel2fa = function () {
      $scope.showVerifyTwoFa = false;
    };

    vm.passwordResetModal = function (message) {
      $modal({
        templateUrl: "app/login/modal-reset-password.html",
        show: true,
        controller: "PasswordResetController",
        keyboard: false,
        backdrop: "static",
        scope: $scope,
        resolve: {
          errorMessage: function () {
            return message;
          }
        }
      });
    };

    vm.changePassword = function () {
      if (vm.changePassword1 != vm.changePassword2) {
        vm.errorPassChange = $translationService.getTranslationController(
          "Las contraseñas no coinciden",
          "Passwords do not match",
          "As senhas não coincidem"
        );
      } else {
        vm.errorPassChange = "";
        $passwordResetFactory
          .changePassword(
            searchObject.user.trim(),
            searchObject.token.trim(),
            vm.changePassword1,
            vm.changePassword2
          )
          .then(function (r, s) {
            vm.successPassChange = $translationService.getTranslationController(
              "Contraseña modificada correctamente.",
              "Password modified correctly.",
              "Senha modificada corretamente."
            );
            $scope.$apply();
            setTimeout(function () {
              $scope.showPasswordEdit = false;
              $scope.$apply();
            }, 3000);
          })
          .catch(function (e, s) {
            vm.errorPassChange = $translationService.getTranslationController(
              "Ocurrió un error cambiando la contraseña.",
              "An error occurred changing the password.",
              "Ocorreu um erro ao alterar a senha."
            );
            $scope.$apply();
          });
      }
    };

    var sessionExpired = $modal({
      templateUrl: "app/login/modal-expired.html",
      show: false
    });

    if ($stateParams.id == 1) {
      vm.error = $stateParams.message;
      sessionExpired.$promise.then(sessionExpired.show);
    } else if ($stateParams.id == 2) {
      vm.error = $stateParams.message;
    }

    $scope.showCaptcha = false;
    function initializeRecaptcha() {
      $scope.showCaptcha = true;
      if (!gRecaptcha.isInitialized()) {
        $ConfigurationFactory.getPublicKeyRecaptcha().then(function (keys) {
          gRecaptcha.initialize({ key: keys });
        });
      } else {
        var element = angular.element(".grecaptcha-badge");
        element.show();
      }
    }

    function beforeloginV2(ev) {
      $scope.loading = true;
      try {
        if ($scope.showCaptcha === true) {
          gRecaptcha.execute({ action: "login" }).then(function (recaptcha) {
            login(recaptcha);
          });
        } else {
          login();
        }

        // });
      } catch (error) {
        $scope.loading = false;
        console.error("gRecaptchaEror", error);

        return false;
      }
    }

    function login(recaptcha) {
      // console.log("Recaptcha Token:", recaptcha);
      $loginFactory
        .login(vm.username, vm.password, recaptcha)
        .then(function (response) {
          vm.errorPolicies = null;
          vm.username = null;
          vm.password = null;
          if (response.active != "t") {
            vm.error = $translationService.getTranslationController(
              "Usuario Inactivo",
              "Inactive User",
              "Usuário Inativo"
            );
          } else {
            userlogin = response;
            if (
              userlogin.twoFactorAuthEnabled &&
              userlogin.twoFactorAuthEnabled === true
            ) {
              $scope.showVerifyTwoFa = true;
              $scope.loading = false;
            } else {
              $loginFactory.setCurrentUser(userlogin);
              $dashboardService
                .storeCompanyConfiguration()
                .then(function () {
                  setTimeout(function () {
                    if (vm.mode == "recoverSession") {
                      $mdDialog.hide();
                    } else {
                      $sessionService.startCheck();
                      $dashboardService.toHomePage();
                      $scope.$apply();
                    }
                    $scope.loading = false;
                    var element = angular.element(".grecaptcha-badge");
                    element.hide();
                  }, 500);
                })
                .catch(function (error) {
                  console.error("Error@storeCompanyConfiguration", error);
                  $scope.loading = false;
                });
            }
          }
        })
        .catch(function (error) {
          console.error("Error@Login", error);
          if (error && error.data && error.data.requiresCaptcha === true) {
            initializeRecaptcha();
          }

          // console.log(JSON.stringify(error));
          if (
            error.status == 400 &&
            error.data &&
            typeof error.data === "string"
          ) {
            vm.error = $translationService.getTranslationController(
              "El password no cumple con la política de contraseñas ",
              "The password does not comply with the password policy ",
              "A senha não cumpre a política de senhas "
            );
            setTimeout(function () {
              vm.errorPolicies = vm.error;
              vm.passwordResetModal(vm.error);
            }, 500);
          } else if (error.status == 401) {
            vm.error = $translationService.getTranslationController(
              "Usuario o contraseña incorrecta",
              "Incorrect username or password",
              "Usuário ou senha incorretos"
            );
          } else if (error.status == 412) {
            vm.error = $translationService.getTranslationController(
              "Usuario Inactivo",
              "Inactive User",
              "Usuário Inativo"
            );
          } else if (error.status == 406) {
            // console.log("ENTREA");
            var title = $translationService.getTranslationController(
              "Alerta",
              "Alert",
              "Alerta"
            );

            var content = $translationService.getTranslationController(
              "Su contraseña ha caducado, debe proceder a actualizar su contraseña",
              "Your password has expired, you must proceed to update your password",
              "Sua senha expirou, você deve continuar a atualizá-la"
            );

            var alert = $mdDialog
              .confirm()
              .title(title)
              .textContent(content)
              .ariaLabel("expired password")
              .targetEvent(null)
              .ok("Ok");

            $mdDialog.show(alert).then(
              function () {
                $state.go("recoveryPassword", error.data);
              },
              function () {
                console.log("REVISAR. " + JSON.stringify(error));
              }
            );
          } else {
            vm.error = $translationService.getTranslationController(
              "Se ha producido un error",
              "An error has occurred",
              "Ocorreu um erro"
            );
            console.error("Error@Login", error);
          }
          $scope.loading = false;
        })
        .finally(function () {
          $scope.loading = false;
          $scope.$apply();
        });
    }

    vm.loadingProviders = true;
    vm.providers = [];
    function getProvidersFn() {
      $loginFactory
        .getProviders()
        .then(function (response) {
          vm.providers = response.map(function (provider) {
            provider.uri = provider.uri + "&state=" + window.location.pathname;
            return provider;
          });
          vm.loadingProviders = false;
          $scope.$apply();
        })
        .catch(function (error) {
          if (error.status == 403) {
            $toastr.error(
              $translationService.getTranslationController(
                "Usuario no autorizado.",
                "Unauthorized User.",
                "Usuário não autorizado."
              )
            );
          } else {
            $toastr.error(error);
          }
          vm.loadingProviders = false;
        });
    }

    function getPasswordPolicies() {
      $loginFactory
        .getPasswordPolicy()
        .then(function (res) {
          vm.passwordPolicies = res;
        })
        .catch(function (err) {
          console.log("Error@getPasswordPolicy", err);
          vm.passwordPolicies = null;
        });
    }

    vm.verify2fa = function () {
      vm.loading2fa = true;
      UserFactory.confirm2fa(vm.code2fa)
        .then(function (res) {
          // console.log("confirm2fa res", res);
          vm.loading2fa = false;
          $loginFactory.setCurrentUser(userlogin);
          $sessionService.startCheck();
          $dashboardService.toHomePage();
        })
        .catch(function (err) {
          // console.log("error@confirm2fa", err);
          vm.loading2fa = false;
          vm.code2fa = null;
          $toastr.error(
            $translationService.getTranslationController(
              "error de código",
              "code error",
              "erro de código"
            )
          );
        });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('SchemasListController', SchemasListController);

  SchemasListController.$inject = [
    '$scope',
    '$rootScope',
    '$mdDialog',
    'toastr',
    'translationService',
    'SchemasFactory',
    'InputListsFactory',
    'listsToGroups',
  ];
  function SchemasListController(
    $scope,
    $rootScope,
    $mdDialog,
    toastr,
    $translationService,
    $schemasFactory,
    $inputListsFactory,
    $listsToGroups
  ) {
    $translationService.getTranslation($scope, 'schemas');

    var vm = this;

    vm.searchText = $rootScope.inputlistSearchText || null;
    vm.schemas = { data: [] };
    vm.schemasList = null;

    vm.displayItems = false;
    vm.collapseAll = function () {
      vm.displayItems = false;
      $rootScope.$broadcast('displayItems', false);
    };

    vm.expandAll = function () {
      vm.displayItems = true;
      $rootScope.$broadcast('displayItems', true);
    };

    vm.sort = 'asc';
    vm.toggleSort = function () {
      if (vm.sort == 'asc') vm.sort = 'desc';
      else vm.sort = 'asc';
      $scope.getLists();
    };

    vm.on_search_text_change = function (nval) {
      if (nval == undefined || nval == null || nval == '') {
        $rootScope.inputlistSearchText = '';
        if (vm.schemasList == null) return;
        vm.listsTree = [];
        vm.listsTree = $listsToGroups.createGroups(
          vm.schemasList.lists,
          'groups',
          vm.sort
        );
        setTimeout(function () {
          vm.collapseAll();
        }, 200);
        return;
      }
      $rootScope.inputlistSearchText = nval;
      if (vm.schemasList == null) return;

      vm.listsTree = [];
      var filteredItems = vm.schemasList.lists.filter(function (e) {
        nval = angular.lowercase(nval);
        return angular.lowercase(e.name).indexOf(nval) >= 0;
      }) || [null];

      vm.listsTree = $listsToGroups.createGroups(
        filteredItems,
        'groups',
        vm.sort,
        filteredItems[0]
      );

      setTimeout(function () {
        vm.expandAll();
      }, 300);
    };

    $schemasFactory
      .getSchemas()
      .then(function (res) {
        vm.schemas = res;
        vm.schemas.data = vm.schemas.data.map(function (e) {
          e.schema = angular.fromJson(e.schema);
          if (typeof e.schema.definitions === 'string') {
            e.schema.definitions = angular.fromJson(e.schema.definitions);
            e.schema.definitions[e.name].properties = angular.fromJson(
              e.schema.definitions[e.name].properties
            );
          }
          return e;
        });
      })
      .catch(function (err) {
        console.error('Error@getSchemas@ListListItem', err);
      });

    $scope.mustOrderBy = { field: 'id', reverse: true };

    $scope._orderBy = function (field, reverse) {
      $scope.mustOrderBy = { field: field, reverse: reverse };
    };

    $scope.getLists = function (list) {
      vm.listsTree = [];
      var x = angular.copy($rootScope.inputlistSearchText);
      vm.searchText = null;
      $rootScope.loading = true;
      $inputListsFactory
        .getLists()
        .then(function (res) {
          // if (vm.searchText) vm.searchText = '';
          vm.schemasList = res;
          vm.listsTree = [];
          vm.listsTree = $listsToGroups.createGroups(
            res.lists,
            'groups',
            vm.sort,
            list
          );
          $rootScope.loading = false;
          setTimeout(function () {
            // console.log(x);
            vm.searchText = x || null;
          }, 2000);
        })
        .catch(function (err) {
          $rootScope.loading = false;
          toastr.info(
            $translationService.getTranslationController(
              'No se han podido obtener las listas.',
              'The lists could not be loaded.',
              'As listas não puderam ser carregadas.'
            )
          );
          console.error('Error@getLists', err);
        });
    };
    $scope.getLists();

    $scope.$on('listUpdated', function (ev, list) {
      $scope.listsTree = [];
      $scope.getLists(list);
    });

    $scope.showCreateListDialog = function (ev, list) {
      $inputListsFactory.setSelectedList(list);
      $mdDialog.show({
        controller: 'ListDialogController',
        templateUrl: 'app/lists/components/create-list/dialog-create-list.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          groupPath: null,
        },
      });
    };

    /**
     * Lists filter
     */

    $scope.$watch('schemasList.searchText', function (nval, oldval) {
      vm.on_search_text_change(nval);
    });
  }
})();

/* Agrupa las listas en un arbol recursivo por grupos */

(function () {
  'use strict';

  angular.module('dashboard').service('listsTreeService', listsTreeService);

  listsTreeService.$inject = [];
  function listsTreeService() {
    var vm = this;
    vm.group = function (items) {
      vm.tree = {
        type: 'group',
        groupName: 'root',
        items: [],
      };

      items.forEach(function (val) {
        vm.evalItem(val);
      });

      return vm.tree;
    };
    vm.evalItem = function (val) {
      if (val.groups) {
        var paths = val.groups.split('/').filter(function (e) {
          return e != '';
        });
        var element = vm.tree.items;
        paths.forEach(function (group, depth) {
          var max = paths.length,
            level = depth + 1;
          var _element = element.filter(function (e) {
            return e.groupName == group;
          });
          if (!_element.length) {
            element = vm.createGroup(element, group);
          } else {
            element = _element[0].items;
          }
          if (level == max) {
            val.type = 'item';
            element.push(val);
          }
        });
      } else {
        val.type = 'item';
        vm.tree.items.push(val);
      }
    };
    vm.createGroup = function (element, group) {
      element.push({
        type: 'group',
        groupName: group,
        items: [],
      });

      return element[element.length - 1].items;
    };
  }
})();

(function () {
  'use strict';
  angular.module('dashboard').controller('issuesController', issuesController);

  issuesController.$inject = ['$scope', 'toastr', '$mdDialog'];
  function issuesController($scope, toastr, $mdDialog) {
    $scope.selectedIssue = [];

    var self = this;
    self.issuesList = [];
    self.customViewList = [];
    self.typeView = 'tabla';

    self.viewType = function (type) {
      self.typeView = type;
    };

    self.genFakeIssue = function () {
      var catg = ['posible fraude', 'fraude', 'lavado de dinero'];
      var criticidad = ['alta', 'media', 'baja'];
      var estado = ['visto', 'no visto'];
      var linked = [true, false];
      var FakeIssue = {
        id: Math.floor(Math.random() * 999),
        indicio: 'MOVIMIENTOS SOSPECHOSO EN CUENTA DE AHORRO',
        created: moment(new Date()).format('DD/MM/YYYY,h:mm:ss a'),
        by: 'system',
        asigned: 'OMARTINEZ',
        catg: catg[Math.floor(Math.random() * catg.length)],
        criticidad: criticidad[Math.floor(Math.random() * criticidad.length)],
        estado: estado[Math.floor(Math.random() * estado.length)],
        linked: linked[Math.floor(Math.random() * linked.length)],
      };
      return FakeIssue;
    };

    ////////////////////////////////// CUSTOM VIEWS
    self.listCustomView = function () {
      var rname = ['Mis casos', 'Fraudes', 'Clientes VIP'];
      for (var i = 0; i < rname.length; i++) {
        var fakeview = {
          id: Math.floor(Math.random() * 999),
          name: rname[i],
          descripcion: 'tab ramdom',
          data: [],
        };
        fakeview.data.push(self.genFakeIssue());
        fakeview.data.push(self.genFakeIssue());
        fakeview.data.push(self.genFakeIssue());
        fakeview.data.push(self.genFakeIssue());
        self.customViewList.push(fakeview);
      }
    };
    self.listCustomView();

    console.log('customViewList', self.customViewList);
    ///////////////////////////////CONTROL CANVAS
    self.estados = ['visto', 'novisto'];
    self.canvas_data = {
      visto: [],
      novisto: [],
    };
    self.canvasChange = function (itemId, canvasStatus) {
      self.issuesList.forEach(function (ele) {
        if (ele.id == itemId) {
          ele.status = canvasStatus;
        }
      });
    };

    $scope.sortableOptionsList = {
      placeholder: 'app',
      connectWith: '.apps-container',
      update: function (event, ui) {
        self.canvasChange(parseInt(ui.item[0].id), event.target.id);
      },
    };

    self.createCanvasRecords = function () {
      self.issuesList.forEach(function (ele) {
        console.log(self.canvas_data, ele.estado);
        var estado = ele.estado.replace(/\s/g, '');
        self.canvas_data[estado].push(ele);
      });
    };

    ///////////////////////////////INIT
    self.randomList = function () {
      var cant = 6;
      for (var i = 0; i < cant; i++) {
        self.issuesList.push(self.genFakeIssue());
      }
      self.createCanvasRecords();
    };

    self.randomList();
    console.log('issuesList', self.issuesList);
    ///////////////////////////////CONTROL CHECKBOX
    $scope.toggle = function (item) {
      var idx = $scope.selectedIssue.indexOf(item);
      if (idx > -1) {
        $scope.selectedIssue.splice(idx, 1);
      } else {
        $scope.selectedIssue.push(item);
      }
    };

    $scope.exists = function (item) {
      return $scope.selectedIssue.indexOf(item) > -1;
    };

    ///////////////////////////////ACTIONS
    self.issuesAclActions = [
      { name: 'Edit', action: 'edit' },
      { name: 'Share', action: 'share' },
      { name: 'Remove', action: 'remove' },
    ];
    self.issuesTblActions = [
      { name: 'Crear indicio', icon: 'share', action: 'createIssue' },
      { name: 'Agregar columna', icon: 'view_array', action: 'addColumn' },
      {
        name: 'Asignar responsable',
        icon: 'account_circle',
        action: 'asigResp',
      },
      { name: 'Asignar categoría', icon: 'bookmark', action: 'asigCatg' },
      { name: 'vincular', icon: 'link', action: 'linkedIssues' },
      { name: 'Generar informe', icon: 'file_copy', action: 'genInform' },
    ];

    self.btn = function (act) {
      // console.log('btn ',act)
      // console.log('selectedIssue ', $scope.selectedIssue)
      switch (act) {
        //issuesTblActionsD
        case 'createIssue':
          $scope.createIssue();
          break;
        case 'addColumn':
          $scope.addColumn();
          break;
        case 'asigResp':
          if ($scope.selectedIssue.length > 0) {
            $scope.asigResp();
          } else {
            toastr.info(
              'Debes seleccionar uno o varios indicios para esta accion'
            );
          }
          break;
        case 'asigCatg':
          if ($scope.selectedIssue.length > 0) {
            $scope.asigCatg();
          } else {
            toastr.info(
              'Debes seleccionar uno o varios indicios para esta accion'
            );
          }
          break;
        case 'linkedIssues':
          if ($scope.selectedIssue.length > 0) {
            $scope.linkedIssues();
          } else {
            toastr.info(
              'Debes seleccionar uno o varios indicios para esta accion'
            );
          }
          break;
        case 'genInform':
          $scope.generateInform();
          break;
        default:
          break;
      }
    };

    ////////////////////////////////// tab control
    self.selectedTab = 'index';
    self.tabsIssues = [];
    self.tabsIssues.push({
      id: 'index',
      name: 'Todo',
      descripcion: 'tab ramdom',
      data: [],
    });

    self.setTab = function (newTab) {
      self.selectedTab = newTab;
    };
    self.isSet = function (tabNum) {
      return self.selectedTab == tabNum;
    };
    self.isActive = function (id) {
      return self.isSet(id) && id != 'index';
    };
    self.eliminarTabIssue = function (tabId) {
      var indexTab = -2;
      for (var i = 0; i < self.tabsIssues.length; i++) {
        var actualTab = self.tabsIssues[i];
        if (actualTab.id === tabId) {
          indexTab = i;
          break;
        }
      }
      if (indexTab > 0) {
        self.tabsIssues.splice(indexTab, 1);
        self.setTab('index');
      }
    };

    self.listarViewTab = function (id) {
      var exits = self.tabsIssues.filter(function (tab) {
        return tab.id === id;
      });

      if (exits.length == 0) {
        var newTab = self.customViewList.filter(function (tab) {
          return tab.id == id;
        });

        self.tabsIssues.push(newTab[0]);
        self.setTab(newTab[0].id);
      }
    };
    ////////////////////////////////// buscador tbal
    $scope.querySearch = function (query) {
      var results = query
          ? self.issuesList.filter(createFilterForFile(query))
          : self.issuesList,
        deferred;
      return results;
    };
    function createFilterForFile(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(array) {
        return array.name.toLowerCase().indexOf(lowercaseQuery) > -1;
      };
    }
    ////////////////////////////////// CREATE INDICIO
    $scope.createIssue = function (ev) {
      $mdDialog.show({
        controller: createIssueController,
        controllerAs: 'issue',
        templateUrl: 'app/issues/dialog/create-issue.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
      });
    };
    createIssueController.$inject = ['$scope'];
    function createIssueController($scope) {
      var vm = this;
      vm.loading = true;
      vm.form = {
        tipo: '',
        motivo: '',
        categorias: [],
        criticidad: '',
        estado: '',
        entidad: '',
        rut: '',
        cargo: '',
        nombre: '',
        comentarios: '',
        evidencias: '',
      };
      vm.categoriasOption = [
        'PEP',
        'Posible fraude',
        'N/A',
        'Terrorismo',
        'Lavado',
      ];

      $scope.cancel = function () {
        $mdDialog.cancel();
      };
      vm.saveIssue = function () {
        console.log('saveIssue', vm.form);
      };
    }

    ////////////////////////////////// Asigna responsable
    $scope.asigResp = function (ev) {
      $mdDialog.show({
        controller: asigRespController,
        controllerAs: 'ctrl',
        templateUrl: 'app/issues/dialog/assigResp.html',
        parent: angular.element(document.body),
        locals: {
          list: self.issuesList,
          selt: $scope.selectedIssue,
        },
        targetEvent: ev,
        clickOutsideToClose: false,
      });
    };
    asigRespController.$inject = ['$scope', 'list', 'selt'];
    function asigRespController($scope, list, selt) {
      var vm = this;
      vm.loading = true;
      vm.assigned = [];
      vm.users = ['OMARTINEZ', 'KATHY', 'YULI', 'LERT'];
      $scope.list = list;
      $scope.selt = selt;
      vm.selecteds = [];
      vm.selecteds = $scope.list.filter(function (e) {
        if ($scope.selt.includes(e.id)) {
          return e;
        }
      });
      $scope.toAssign = function () {
        toastr.success('Indicios asigandoa a ' + vm.selecteds);
        $mdDialog.cancel();
      };
      $scope.cancel = function () {
        vm.selecteds = [];
        $mdDialog.cancel();
      };
    }
    ////////////////////////////////// vincualr
    $scope.linkedIssues = function (ev) {
      $mdDialog.show({
        controller: linkedIssuesController,
        controllerAs: 'ctrl',
        templateUrl: 'app/issues/dialog/linkedIssues.html',
        parent: angular.element(document.body),
        locals: {
          list: self.issuesList,
          selt: $scope.selectedIssue,
        },
        targetEvent: ev,
        clickOutsideToClose: false,
      });
    };
    linkedIssuesController.$inject = ['$scope', 'list', 'selt'];
    function linkedIssuesController($scope, list, selt) {
      var vm = this;
      vm.loading = true;
      vm.assigned = [];
      vm.users = ['OMARTINEZ', 'KATHY', 'YULI', 'LERT'];
      $scope.list = list;
      $scope.selt = selt;
      vm.selecteds = [];
      vm.selecteds = $scope.list.filter(function (e) {
        if ($scope.selt.includes(e.id)) {
          return e;
        }
      });
      $scope.toAssign = function () {
        toastr.success('Indicios asigandoa a ' + vm.selecteds);
        $mdDialog.cancel();
      };
      $scope.cancel = function () {
        vm.selecteds = [];
        $mdDialog.cancel();
      };
    }

    ////////////////////////////////// detalle indicio
    $scope.issueDetail = function (ev, idIssue) {
      $mdDialog.show({
        controller: issueDetailController,
        controllerAs: 'issue',
        templateUrl: 'app/issues/dialog/issue-detail.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
      });
    };
    issueDetailController.$inject = ['$scope'];
    function issueDetailController($scope) {
      var vm = this;
      vm.loading = true;
      $scope.cancel = function () {
        $mdDialog.cancel();
      };
    }
    ////////////////////////////////// AYUDA
    $scope.helperDialog = function (ev) {
      $mdDialog.show({
        controller: helperDialogController,
        controllerAs: 'issue',
        templateUrl: 'app/issues/dialog/helperDialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
      });
    };
    helperDialogController.$inject = ['$scope'];
    function helperDialogController($scope) {
      var vm = this;
      vm.loading = true;
      $scope.cancel = function () {
        $mdDialog.cancel();
      };
    }
    ////////////////////////////////// AYUDA
    $scope.advanceSearch = function (ev) {
      $mdDialog.show({
        controller: advanceSearchController,
        controllerAs: 'adv',
        templateUrl: 'app/issues/dialog/advance-search.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
      });
    };
    advanceSearchController.$inject = ['$scope'];
    function advanceSearchController($scope) {
      var vm = this;
      vm.loading = true;
      vm.search = function () {
        // self.listarViewTab();
        $mdDialog.cancel();
      };

      $scope.cancel = function () {
        $mdDialog.cancel();
      };

      ///////////////////save view
      $scope.saveTab = function (ev) {
        $mdDialog.show({
          controller: saveSearchController,
          controllerAs: 'ctrl',
          templateUrl: 'app/issues/dialog/save-search.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: false,
        });
      };
      saveSearchController.$inject = ['$scope'];
      function saveSearchController($scope) {
        var vm = this;
        vm.tab = {
          id: Math.floor(Math.random() * 999),
          name: '',
          descripcion: '',
          data: self.issuesList,
        };
        vm.save = function () {
          // self.listarViewTab(vm.tab);
          self.customViewList.push(vm.tab);
          $mdDialog.cancel();
        };
        $scope.cancel = function () {
          $mdDialog.cancel();
        };
      }
    }
  }
})();

(function (Handsontable) {
  "use strict";

  angular
    .module("dashboard")
    .controller("InputListController", InputListController);

  InputListController.$inject = [
    "$scope",
    "$rootScope",
    "$state",
    "$stateParams",
    "$timeout",
    "toastr",
    "translationService",
    "$mdDialog",
    "$interval",
    "SchemasService",
    "InputListsFactory",
    "PermissionsFactory",
    "listService",
    "listExporterService",
    "formats",
    "tableListConstants",
    "$location"
  ];

  function InputListController(
    $scope,
    $rootScope,
    $state,
    $stateParams,
    $timeout,
    $toastr,
    $translationService,
    $mdDialog,
    $interval,
    $schemasService,
    $inputListsFactory,
    $permissionsFactory,
    $listService,
    $listExporterService,
    formats,
    $tableListConstants,
    $location
  ) {
    $listService.registerCustomEditors($scope);
    $translationService.getTranslation($scope, "input-list");

    $scope.dataWasChanged = false;
    $scope.errorMsg = false;
    $scope.loader = { loaded: 0, total: 0, msg: false, time: false, step: 100 };
    $scope.autoSaveMessage = $translationService.getTranslationController(
      "Todos los cambios han sido guardados",
      "All changes has been saved",
      "Todas as alterações foram salvas"
    );

    $scope.searchText = $rootScope.searchText;

    var inputList = this;
    var raw_schema;
    inputList.initialLoad = true;
    inputList.autoSaving = false;
    inputList.selectedRowMin = 0;
    inputList.selectedRowMax = 0;
    inputList.isFiltered = false;
    inputList.queryFilters = {};
    inputList.filters = [];
    inputList.filteredData = [];
    inputList.hiddenData = [];
    inputList.importedData = [];
    inputList.isImporting = false;
    inputList.shouldReplaceData = true;
    inputList.mustShowHiddenRows = false;
    inputList.rowsToRemove = [];
    inputList.leave = false;
    inputList.updatingData = false;
    inputList.pagination = { page: 1, itemsPerPage: 100, sort: "ASC" };

    $scope.$watchCollection("inputList.importedData", function (newCollection) {
      console.log("newCollection", newCollection);

      if (inputList.shouldReplaceData) {
        inputList.pagination.totalRecords = inputList.importedData.length;
      } else {
        inputList.pagination.totalRecords += inputList.importedData.length;
      }

      inputList.pagination.page =
        inputList.pagination.page <=
        Math.floor(
          inputList.pagination.totalRecords /
            inputList.pagination.itemsPerPage +
            1
        )
          ? inputList.pagination.page
          : Math.floor(
              inputList.pagination.totalRecords /
                inputList.pagination.itemsPerPage +
                1
            );

      if (inputList.shouldReplaceData) {
        inputList.data = inputList.importedData;
      } else {
        inputList.data = inputList.importedData.concat(inputList.data);
      }

      // newCollection = $listService.formatImportedData(newCollection, inputList.cols);

      if (newCollection.length) {
        $scope.autoSaveMessage = $translationService.getTranslationController(
          "Los cambios realizados no se han guardado",
          "Changes made has not been saved",
          "As alterações feitas não foram salvas"
        );
        $scope.dataWasChanged = true;
      }
    });

    $scope.getInputList = function () {
      $rootScope.loading = true;

      $inputListsFactory
        .getInputList($stateParams.listId)
        .then(function (res) {
          inputList.listId = res.listId;
          inputList.name = res.name;
          inputList.updatingData = res.updatingData;
          inputList.schemaInfo = angular.fromJson(res.schema);

          raw_schema = res.schema;

          inputList.schema = $schemasService.parseSchema(
            angular.fromJson(res.schema),
            angular.fromJson(res.settings)
          );

          if ($scope.areFormatsChanged) {
            $scope.areFormatsChanged = false;
            $rootScope.loading = false;
          } else {
            $scope.getInputListData();
          }
          _renderList();
        })
        .catch(function (err) {
          $rootScope.loading = false;
          $toastr.info(
            $translationService.getTranslationController(
              "No se han podido obtener los datos.",
              "The data could not be loaded.",
              "Os dados não puderam ser obtidos."
            )
          );
        });
    };

    $scope.getInputListData = function () {
      $rootScope.loading = true;
      $inputListsFactory
        .getInputListData(
          $stateParams.listId,
          inputList.queryFilters,
          inputList.pagination
        )
        .then(function (res) {
          if (inputList.pagination.colType)
            res.pagination.colType = inputList.pagination.colType;
          inputList.pagination = res.pagination;
          inputList.data = res.dataList.map(function (e) {
            var res = angular.fromJson(e.body);
            res.$dataId = e.dataId;
            res.$visible = e.visible;
            return res;
          });

          _parseListData();

          $rootScope.loading = false;
          $scope.autoSaveMessage = $translationService.getTranslationController(
            "Datos cargados",
            "Data loaded",
            "Dados carregados"
          );
        })
        .catch(function (err) {
          inputList.data = [inputList.baseSchema];
          $rootScope.loading = false;
          if (err !== "No Data Was Found With listId " + $stateParams.listId) {
            $toastr.info(
              $translationService.getTranslationController(
                "No se han podido obtener los datos.",
                "The data could not be loaded.",
                "Os dados não puderam ser obtidos."
              )
            );
          }
        })
        .finally(function () {
          inputList.initialLoad = false;
        });
    };

    inputList.reload = function () {
      $scope.getInputListData();
    };

    // Simple pagination
    inputList.nextPage = function () {
      if (
        inputList.pagination.page >=
        Math.ceil(
          inputList.pagination.totalRecords / inputList.pagination.itemsPerPage
        )
      )
        return;

      inputList.pagination.page++;
      var start =
        (inputList.pagination.page - 1) * inputList.pagination.itemsPerPage;

      var end = inputList.pagination.page * inputList.pagination.itemsPerPage;

      if (inputList.isImporting) {
        inputList.data = inputList.importedData.filter(function (e, index) {
          if (index >= start && index < end) return e;
        });
      } else {
        $scope.getInputListData();
      }
    };

    inputList.prevPage = function () {
      inputList.pagination.page--;
      var start =
        (inputList.pagination.page - 1) * inputList.pagination.itemsPerPage;
      var end = inputList.pagination.page * inputList.pagination.itemsPerPage;
      if (inputList.isImporting) {
        inputList.data = inputList.importedData.filter(function (e, index) {
          if (index >= start && index < end) return e;
        });
      } else {
        $scope.getInputListData();
      }
    };

    inputList.goToPage = function (page) {
      inputList.pagination.page = page;
      var start =
        (inputList.pagination.page - 1) * inputList.pagination.itemsPerPage;
      var end = inputList.pagination.page * inputList.pagination.itemsPerPage;
      if (inputList.isImporting) {
        inputList.data = inputList.importedData.filter(function (e, index) {
          if (index >= start && index < end) return e;
        });
      } else {
        $scope.getInputListData();
      }
    };
    // ***

    inputList._onGoBack = function () {
      $state.go("app.schemasLists");
    };

    inputList.showInfo = function (ev) {
      $mdDialog.show({
        controller: function () {
          this.hide = function () {
            $mdDialog.hide();
          };
        },
        controllerAs: "ctrl",
        bindToController: true,
        locals: { schemaInfo: inputList.schemaInfo },
        templateUrl: "app/input-list/templates/dialog-shema-info.html",
        parent: angular.element(document.body),
        targetEvent: ev,
        hasBackdrop: false,
        clickOutsideToClose: true,
        escapeToClose: true,
      });
    };

    inputList.validateData = function () {
      inputList.instance.validateCells();
    };

    inputList.showFormatDialog = function (ev) {
      $mdDialog
        .show({
          controller: "ListFormatController",
          controllerAs: "ctrl",
          templateUrl: "app/input-list/components/list-format/list-format.html",
          locals: {
            listId: inputList.listId,
            schema: inputList.schema,
          },
          parent: angular.element(document.body),
          targetEvent: ev,
          hasBackdrop: false,
          clickOutsideToClose: true,
          escapeToClose: true,
          focusOnOpen: true,
        })
        .then(function (updatedFormats) {
          inputList.schema = $schemasService.parseFormats(
            inputList.schema,
            updatedFormats
          );
          _renderList();
          _parseListData();
          inputList.instance.validateCells();
        });
    };

    function _parseListData() {
      inputList.data = $listService.unNormalizeData(
        inputList.data,
        inputList.cols
      );

      inputList.initialData = angular.copy(inputList.data);
      inputList.hiddenData = inputList.data.filter(function (e) {
        return e.$visible == false;
      });
      inputList.data = inputList.data.filter(function (e) {
        return e.$visible != false;
      });
    }

    inputList.showFilterDialog = function (ev) {
      var selection = inputList.instance.getSelected();
      if (selection) {
        var selectionVal = inputList.instance.getValue(
          selection[0],
          selection[1]
        );
        var colDef = inputList.cols.find(function (col) {
          return (
            col.title == inputList.selectedCol ||
            col.title == inputList.selectedCol + "*" ||
            "#" + col.title.replace("*", "") == inputList.selectedCol
          );
        });
        if (colDef.dateFormat) {
          var dateFormat = colDef.dateFormat;
        }
      }

      $inputListsFactory.setSelectedCol(inputList.selectedCol);
      $inputListsFactory.setFilters(inputList.queryFilters);
      $mdDialog.show({
        controller: "ListFiltersController",
        templateUrl: "app/input-list/components/list-filters/list-filters.html",
        locals: {
          cellValue: selectionVal,
          dateFormat: dateFormat,
          colTypes: inputList.types,
          schema: inputList.schema,
        },
        parent: angular.element(document.body),
        targetEvent: ev,
        hasBackdrop: false,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: true,
      });
    };

    inputList.showReplaceDialog = function (ev) {
      var selection = inputList.instance.getSelected();
      if (selection) {
        var selectionVal = inputList.instance.getValue(
          selection[0],
          selection[1]
        );
      }

      $inputListsFactory.setSelectedCol(inputList.selectedCol);
      $inputListsFactory.setFilters(inputList.queryFilters);

      $mdDialog.show({
        controller: "ListReplaceController",
        templateUrl: "app/input-list/components/list-replace/list-replace.html",
        locals: {
          listId: inputList.listId,
          cellValue: selectionVal,
          colTypes: inputList.types,
        },
        parent: angular.element(document.body),
        targetEvent: ev,
        hasBackdrop: false,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: true,
      });
    };

    $scope.$on("listFiltered", function (e, filter) {
      inputList.pagination.page = 1;
      if (filter.condition == "") {
        inputList.unFilterData();
      } else {
        inputList.filterData(
          inputList.selectedCol,
          filter.condition,
          filter.conditionValue
        );
      }
    });

    inputList.filterData = function (col, cond, val) {
      inputList.queryFilters = {
        filterColumn: col,
        filterByConditions: [
          { operation: cond, value: val, type: inputList.types[col] },
        ],
        filterByValues: [],
      };
      inputList.isFiltered = true;
      $scope.getInputListData();
    };

    inputList.unFilterData = function (clear) {
      inputList.queryFilters = {};
      inputList.isFiltered = false;
      $scope.getInputListData();
    };

    inputList.onSaveData = function (exit) {
      $rootScope.loading = true;
      $scope.autoSaveMessage = "Saving...";
      if (inputList.isImporting) {
        if (inputList.shouldReplaceData) {
          $scope.loader.loaded = 0;
          inputList.clearData(exit);
        } else {
          inputList.deleteRows(exit);
        }
      } else {
        inputList.deleteRows(exit);
      }
    };

    inputList.onClearAll = function (ev) {
      var confirm = $mdDialog
        .confirm()
        .title(
          $translationService.getTranslationController(
            "¿Limpiar todo?",
            "Clear All?",
            "Limpar Tudo?"
          )
        )
        .htmlContent(
          $translationService.getTranslationController(
            "Todos los datos de la lista serán eliminados;<br><b>¡Cuidado!, Esta acción no puede revertirse.</b>",
            "All data in the list will be deleted;<br><b>Warning!, This action cannot be reverted.<b>",
            "Todos os dados serão excluídos;<br><b>Cuidado! Esta ação não pode ser revertida.<b>"
          )
        )
        .ariaLabel("ClearAll-Confirmation")
        .targetEvent(ev)
        .ok(
          $translationService.getTranslationController(
            "Si, elimína todo",
            "Yes, clear all",
            "Sim, limpa tudo"
          )
        )
        .cancel(
          $translationService.getTranslationController(
            "Aún no",
            "Not yet",
            "Ainda não"
          )
        );

      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loading = true;
          $inputListsFactory
            .clearInputListData(inputList.listId)
            .then(function () {
              inputList.importedData = [];
              $toastr.info(
                $translationService.getTranslationController(
                  "Datos eliminados",
                  "Data cleared",
                  "Dados apagados"
                )
              );
              inputList.data = [];
              inputList.hiddenData = [];
              inputList.filteredData = [];
              inputList.pagination.totalRecords = 0;
              inputList.pagination.page = 1;
              inputList.selectedRows = false;
              $scope.dataWasChanged = false;
            })
            .catch(function (err) {
              $scope.errorMsg = true;
              $scope.autoSaveMessage =
                $translationService.getTranslationController(
                  "Hubo un error al borrar los datos",
                  "There was an error on clear the data",
                  "Houve um erro ao limpar os dados"
                );
              $toastr.warning($scope.autoSaveMessage);
            })
            .finally(function () {
              $rootScope.loading = false;
            });
        },
        function () {}
      );
    };

    inputList.clearData = function (exit) {
      $rootScope.loading = true;
      $scope.loader.loaded = 0;
      $scope.loader.msg = $translationService.getTranslationController(
        "Limpiando data",
        "Cleaning data",
        "Limpeza de dados"
      );
      $inputListsFactory
        .clearInputListData(inputList.listId)
        .then(function () {
          inputList.rowsToRemove = [];
          inputList.pagination.totalRecords = 0;
          inputList.selectedRows = false;
        })
        .catch(function (err) {
          $scope.autoSaveMessage = $translationService.getTranslationController(
            "Hubo un error al borrar los datos",
            "There was an error on clear the data",
            "Houve um erro ao limpar os dados"
          );
          $toastr.warning("Error on clear " + err);
          $scope.errorMsg = true;
        })
        .finally(function () {
          inputList.saveData(exit);
        });
    };

    inputList.deleteRows = function (exit) {
      inputList.rowsToRemove = inputList.rowsToRemove.filter(function (row) {
        return row != null;
      });
      if (inputList.rowsToRemove.length) {
        $inputListsFactory
          .deleteInputListData(inputList.listId, inputList.rowsToRemove)
          .then(function (res) {
            inputList.rowsToRemove = [];
            inputList.selectedRows = false;
          })
          .catch(function (err) {
            $rootScope.loading = false;
            $scope.errorMsg = true;
            $scope.autoSaveMessage = "There was an error deleting the data";
            $toastr.warning($scope.autoSaveMessage);
          })
          .finally(function () {
            inputList.saveData(exit);
          });
      } else {
        inputList.saveData(exit);
      }
    };

    function validateBeforeSave(data) {
      $scope.loader.msg = $translationService.getTranslationController(
        "Validando data",
        "Validating data",
        "Validando dados"
      );

      inputList.error = { count: 0, page: 0 };
      if (!inputList.isImporting) {
        // Voltear la data por que el handonsable es zurdo
        data = data
          .map(function (e, i) {
            return { index: i, value: e };
          })
          .sort(function (a, b) {
            return b.index - a.index;
          })
          .map(function (e) {
            return e.value;
          });
      }

      inputList.isDataValid = true;
      var cells = inputList.instance.getCellsMeta();
      angular.forEach(data, function (row, key) {
        angular.forEach(row, function (value, col) {
          var cell = cells.filter(function (e) {
            return e.prop == col;
          })[0];
          if (
            cell != undefined &&
            !["autoincrement", "sequential"].includes(inputList.types[col])
          ) {
            var validator = inputList.instance.getCellValidator(
              cell.row,
              cell.col
            );
            if (validator) {
              validator(value, validatorCB, key);
            }
          }
        });
      });
    }

    function validatorCB(valid, index) {
      if (!valid) {
        inputList.error.count++;
      }
      if (inputList.isDataValid) {
        inputList.isDataValid = valid;
        inputList.error.page =
          Math.floor(index / inputList.pagination.itemsPerPage) + 1;
      }
    }

    inputList.saveData = function (exit) {
      $scope.loader.msg = $translationService.getTranslationController(
        "Preparando data",
        "Preparing data",
        "Preparando dados"
      );

      $rootScope.loading = true;
      var dataToSave = angular.copy(
        inputList.data
          .concat(inputList.hiddenData, inputList.filteredData)
          .sort(function (a, b) {
            return a.$dataId - b.$dataId;
          })
      );

      validateBeforeSave(dataToSave);
      if (!inputList.isDataValid) {
        $rootScope.loading = false;
        $toastr.warning(
          $translationService.getTranslationController(
            "Datos invalidos, se encontraron " +
              inputList.error.count +
              " error(es), desde pag. " +
              inputList.error.page +
              "; no se puede guardar la lista.",
            "Invalid data, " +
              inputList.error.count +
              " errors found, from page " +
              inputList.error.page +
              ", the list cannot be saved.",
            "Dados inválidos, " +
              inputList.error.count +
              "erros encontrados en pag. " +
              inputList.error.page +
              ", a lista não pode ser salva."
          )
        );
        $scope.autoSaveMessage = $translationService.getTranslationController(
          "Ocurrió un error al guardar los datos",
          "There was an error saving the data",
          "Ocorreu um erro ao salvar os dados"
        );
        if (inputList.isImporting) {
          var start =
            (inputList.pagination.page - 1) * inputList.pagination.itemsPerPage;
          var end =
            inputList.pagination.page * inputList.pagination.itemsPerPage;
          inputList.pagination.totalRecords = inputList.importedData.length;
          inputList.data = inputList.importedData.filter(function (e, index) {
            if (index >= start && index < end) return e;
          });
        }
        return false;
      }

      dataToSave = $listService.normalizeData(dataToSave, inputList.cols);

      dataToSave = dataToSave.filter(function (e, key) {
        // Filtrar solo por los que tienen datos cambiados
        if (
          !angular.equals(
            e,
            inputList.initialData.filter(function (y) {
              return y["$dataId"] == e["$dataId"];
            })[0]
          )
        )
          return e;
      });
      if (dataToSave.length) {
        dataToSave = dataToSave.map(function (e) {
          angular.forEach(e, function (value, index) {
            // Eliminar del request los campos que son autoincrement, son manejados por el backend
            if (inputList.types[index] == "autoincrement") delete e[index];
          });
          var res = {
            dataId: e.$dataId,
            visible: e.$visible != undefined ? e.$visible : true,
            body: e,
          };
          delete res.body.$dataId;
          res.body = angular.toJson(res.body);
          return res;
        });

        $scope.errorMsg = false;
        $scope.res = [];
        if (inputList.isImporting) {
          $rootScope.loading = true;
        }

        inputList._processData(exit, dataToSave, 0);
      } else {
        $rootScope.loading = false;
        $toastr.info(
          $translationService.getTranslationController(
            "Cambios Guardados.",
            "Changes saved.",
            "Alterações salvas."
          )
        );
        $scope.autoSaveMessage = $translationService.getTranslationController(
          "Todos los cambios han sido guardados",
          "All changes has been saved",
          "Todas as alterações foram salvas"
        );
        $scope.dataWasChanged = false;
        inputList.isFiltered = false;
        if (exit && !$scope.errorMsg) {
          $state.go("app.schemasLists");
        }
      }
    };

    function chunkArray(array, chunkSize) {
      // This function splits the array into chunks of specified size
      var result = [];
      for (var i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
      }
      return result;
    }

    inputList._processData = function (exit, dataToSave, start) {
      $scope.loader.msg = $translationService.getTranslationController(
        "Guardando datos, no cierre esta ventana hasta finalizar el proceso",
        "Saving data, don't close this window until the process was finished",
        "Salvando dados, não feche esta janela até que o processo seja concluído"
      );

      var dataToSaveChunks = chunkArray(dataToSave, 50);
      var Promises = [];
      console.log(inputList.isImporting);

      // if (inputList.isImporting) {
      //   Promises = dataToSaveChunks.map(function (chunk) {
      //     return $inputListsFactory.importInputListData(
      //       $stateParams.listId,
      //       chunk
      //     );
      //   });
      // } else {
      // }
      Promises = dataToSaveChunks.map(function (chunk) {
        return $inputListsFactory.saveInputListData($stateParams.listId, chunk);
      });

      Promise.allSettled(Promises)
        .then(function (res) {
          console.log("res", res);
          if (
            res.some(function (e) {
              return e.status == "rejected";
            })
          ) {
            throw new Error("Error on save data");
          }

          if (inputList.isImporting) {
            $scope.dataWasChanged = false;
            inputList.isFiltered = false;
            inputList.isImporting = false;
            inputList.pagination.page = 1;

            $toastr.info(
              $translationService.getTranslationController(
                "Datos importados.",
                "Data imported.",
                "Dados importados."
              )
            );
            $scope.autoSaveMessage =
              $translationService.getTranslationController(
                "Todos los cambios han sido guardados",
                "All changes has been saved",
                "Todas as alterações foram salvas"
              );
            $scope.dataWasChanged = false;
            inputList.isFiltered = false;

            if (!exit) {
              $scope.getInputListData();
            } else {
              $state.go("app.schemasLists");
            }
          } else {
            inputList._onFinishSave($scope.res, exit);
          }
        })
        .catch(function (err) {
          console.log("err", err);
          $rootScope.loading = false;
          $scope.errorMsg = true;
          $toastr.warning(err.error);
          inputList._onFinishSave(false, exit);
        });
    };

    inputList._onFinishSave = function (res, exit) {
      if (!$scope.errorMsg) {
        // Insertar Autoincrement & dataId a nuevos registros
        angular.forEach(inputList.data, function (row, key) {
          if (row.$dataId == null) {
            var compareRow = {};
            angular.forEach(row, function (col, name) {
              if (
                name != "$dataId" &&
                name != "$visible" &&
                inputList.types[name] != "autoincrement"
              ) {
                compareRow[name] = col;
              }
            });
            angular.forEach(res, function (rowRes, keyRes) {
              var compareRes = {};
              angular.forEach(rowRes, function (resCol, resName) {
                if (
                  resName != "$dataId" &&
                  resName != "$visible" &&
                  inputList.types[resName] != "autoincrement"
                ) {
                  compareRes[resName] = resCol;
                }
              });
              if (angular.equals(compareRow, compareRes)) {
                angular.forEach(inputList.data[key], function (col, name) {
                  inputList.data[key].$dataId = res[keyRes].$dataId;
                  if (inputList.types[name] == "autoincrement") {
                    inputList.data[key][name] = res[keyRes][name];
                    compareRow[name] = res[keyRes][name];
                  }
                });
                delete res[keyRes];
              }
            });
          }
        });
        inputList.initialData = angular.copy(inputList.data);
        $toastr.info(
          $translationService.getTranslationController(
            "Cambios Guardados.",
            "Changes saved.",
            "Alterações salvas."
          )
        );
        $scope.autoSaveMessage = $translationService.getTranslationController(
          "Todos los cambios han sido guardados",
          "All changes has been saved",
          "Todas as alterações foram salvas"
        );
        $scope.dataWasChanged = false;
        inputList.isFiltered = false;
        if (exit) {
          $state.go("app.schemasLists");
        }
      } else {
        $scope.autoSaveMessage = $translationService.getTranslationController(
          "Ocurrió un error al guardar los datos",
          "There was an error saving the data",
          "Ocorreu um erro ao salvar os dados"
        );
        $toastr.error(
          $translationService.getTranslationController(
            "Ocurrió un error al guardar los datos",
            "The data could not be saved",
            "Os dados não puderam ser salvos"
          )
        );
        $rootScope.loading = false;
      }
      delete $scope.res;
      $rootScope.loading = false;
    };

    inputList._onAutoSavePressed = function () {
      inputList.autoSaving = !inputList.autoSaving;
      if (inputList.autoSaving == true) {
        inputList.autoSave = $interval(function () {
          if (!inputList.isImporting) inputList.onSaveData(false);
        }, 5 * 60000);
      } else {
        $interval.cancel(inputList.autoSave);
      }
    };

    inputList.selectAll = function () {
      inputList.instance.selectCell(
        0,
        0,
        inputList.instance.countRows() - 1,
        inputList.instance.countCols() - 1
      );
    };

    inputList.insertRow = function (direction) {
      if (direction == "final") {
        inputList.instance.alter("insert_row");
      } else if (direction == "below") {
        inputList.instance.alter(
          "insert_row",
          inputList.selectedRowMax + 1,
          inputList.selectedRows || 1
        );
      } else {
        inputList.instance.alter(
          "insert_row",
          inputList.selectedRowMin,
          inputList.selectedRows || 1
        );
        inputList.selectedRowMin++;
      }
    };

    inputList.removeRow = function () {
      inputList.instance.alter(
        "remove_row",
        inputList.selectedRowMin,
        inputList.selectedRows
      );
    };

    inputList.unhideRows = function () {
      var row = inputList.selectedRowMin;
      for (var i = 0; i < inputList.selectedRows; i++) {
        var baseRow = inputList.instance.toPhysicalRow(row++);
        inputList.data[baseRow].$visible = true;
      }
    };

    inputList.hideRows = function () {
      var row = inputList.selectedRowMin;
      for (var i = 0; i < inputList.selectedRows; i++) {
        var baseRow = inputList.instance.toPhysicalRow(row++);
        inputList.data[baseRow].$visible = false;
      }

      var hot2 = inputList.instance;
      hot2.updateSettings({
        cells: function (row, col) {
          var cellProperties = {};
          if (
            hot2.getSourceData()[row] &&
            !hot2.getSourceData()[row].$visible
          ) {
            cellProperties.readOnly = true;
          } else {
            cellProperties.readOnly = false;
          }
          return cellProperties;
        },
      });
      if (!inputList.mustShowHiddenRows) {
        stopShowHiddenRows();
      }
    };

    inputList.showHiddenRows = function () {
      inputList.mustShowHiddenRows = !inputList.mustShowHiddenRows;
      if (inputList.mustShowHiddenRows) {
        inputList.data = inputList.data.concat(inputList.hiddenData);
        inputList.hiddenData = [];

        var hot2 = inputList.instance;
        hot2.updateSettings({
          cells: function (row, col) {
            var cellProperties = {};
            if (
              hot2.getSourceData()[row] &&
              !hot2.getSourceData()[row].$visible
            ) {
              cellProperties.readOnly = true;
            } else {
              cellProperties.readOnly = false;
            }
            return cellProperties;
          },
        });
      } else {
        stopShowHiddenRows();
      }
    };

    function stopShowHiddenRows() {
      inputList.data = inputList.data.concat(inputList.hiddenData);
      inputList.hiddenData = inputList.data.filter(function (e) {
        return e.$visible == false;
      });
      inputList.data = inputList.data.filter(function (e) {
        return e.$visible != false;
      });
    }

    inputList._onExport = function (ext, templateOnly) {
      inputList.cols = $listService.getColumns(inputList.schema);
      inputList.baseSchema = $listService.getBaseSchema(inputList.schema);
      inputList.types = $listService.getColumnsTypes(inputList.schema);
      inputList.headers = $listService.getHeaders(inputList.schema);
      inputList.colsToExport = $listService.getColumnsToExport(
        inputList.schema
      );

      inputList.selectedCol = inputList.colsToExport[0];
      inputList.baseSchema["$dataId"] = null;
      inputList.baseSchema["$visible"] = true;

      var listToExport = {
        listId: inputList.listId,
        name: inputList.name,
        schema: raw_schema,
        headers: inputList.headers,
        colsToExport: inputList.colsToExport,
        data: [],
      };

      if (templateOnly) {
        $listExporterService.execute(ext, templateOnly, listToExport);
      } else {
        $mdDialog.show({
          controller: ["$mdDialog", exportSelectorController],
          controllerAs: "selCtrl",
          templateUrl: "app/input-list/templates/export-selector.html",
          scope: $scope,
          preserveScope: true,
          clickOutsideToClose: false,
        });

        function exportSelectorController($mdDialog) {
          this.selection = "all";
          this.selectSheet = function (selection) {
            // if (selection == 'all') {
            $rootScope.loading = true;
            var filters = angular.copy(
              $tableListConstants.defaultFiltersTemplate
            );

            filters.exportToCSV = true;

            // if (selection == "all") {
            filters.pagination.page = 1;
            filters.pagination.itemsPerPage = 9000000;
            // }
            if (selection == "all") {
              filters.predicates = [];
            }

            var copy = {
              listId: inputList.listId,
              name: inputList.name,
              schema: raw_schema,
            };

            if (
              inputList.queryFilters &&
              inputList.queryFilters.filterColumn &&
              inputList.queryFilters.filterByConditions.length > 0
            ) {
              var operations = {
                "=": "EQUAL",
                "!=": "NOT_EQUAL",
                IS_EMPTY: "IS_EMPTY",
                IS_NOT_EMPTY: "IS_NOT_EMPTY",
                IS_NULL: "IS_NULL",
                IS_NOT_NULL: "IS_NOT_NULL",
                ">": "GREATER_THAN",
                "<": "LESS_THAN",
                ">=": "GREATER_OR_EQUAL_THAN",
                "<=": "LESS_OR_EQUAL_THAN",
                LIKE_CONTAINS: "LIKE_CONTAINS",
                LIKE_NOT_CONTAINS: "LIKE_NOT_CONTAINS",
                IN: "IN",
                BETWEEN: "BETWEEN",
              };

              var operation =
                operations[
                  inputList.queryFilters.filterByConditions[0].operation
                ] || "=";

              filters.predicates = [
                {
                  label: inputList.queryFilters.filterColumn,
                  fieldName: inputList.queryFilters.filterColumn,
                  operation: operation,
                  values: [null, null],
                  value: inputList.queryFilters.filterByConditions[0].value,
                  type: inputList.queryFilters.filterByConditions[0].type,
                  valuesLabels: null,
                  component: "text",
                },
              ];
            }

            $listExporterService
              .execute(ext, false, copy, filters)
              .then(function () {
                $toastr.success(
                  $translationService.getTranslationController(
                    "Lista descargada",
                    "List downloaded",
                    "Lista baixada"
                  )
                );
              })
              .catch(function (error) {
                $toastr.error(
                  $translationService.getTranslationController(
                    "Se ha producido un error al exportar",
                    "An error occurred while exporting",
                    "Ocorreu um erro ao exportar"
                  )
                );
              })
              .finally(function () {
                $rootScope.loading = false;
              });

            $mdDialog.hide();
          };
          this.abortSelection = function () {
            $mdDialog.cancel();
          };
        }
      }
    };

    function _getInputType(
      input,
      list,
      autocomplete,
      inputFormat,
      outputFormat,
      readonly
    ) {
      var sequentialSourceFn = function (query, process) {
        var filters = {
          pagination: {
            page: 1,
            itemsPerPage: 1000,
          },
        };

        $inputListsFactory
          .getInputListDataFiltered(list, filters)
          .then(function (res) {
            var source = res.dataList
              .map(function (e) {
                var res = angular.fromJson(e.body);
                if (res.$visible) delete res.$visible;
                return Object.values(res)[0];
              })
              .sort(function (a, b) {
                return a - b;
              });
            process(source);
          });
      };

      return $listService.getInputType(
        input,
        autocomplete,
        inputFormat,
        outputFormat,
        readonly,
        sequentialSourceFn
      );
    }

    function stringify(value) {
      switch (typeof value) {
        case "string":
        case "number":
          return value + "";
        case "object":
          if (value === null) {
            return "";
          } else {
            return value.toString();
          }
        case "undefined":
          return "";
        default:
          return value.toString();
      }
    }

    function process(value, callback) {
      var originalVal = value;
      var lowercaseVal =
        typeof originalVal === "string" ? originalVal.toLowerCase() : null;
      return function (source) {
        var found = false;
        for (var s = 0, slen = source.length; s < slen; s++) {
          if (originalVal === source[s]) {
            found = true;
            break;
          } else if (lowercaseVal === stringify(source[s]).toLowerCase()) {
            found = true;
            break;
          }
        }
        callback(found);
      };
    }

    function _renderList() {
      inputList.cols = $listService.getColumns(inputList.schema);
      inputList.baseSchema = $listService.getBaseSchema(inputList.schema);
      inputList.types = $listService.getColumnsTypes(inputList.schema);
      inputList.headers = $listService.getHeaders(inputList.schema);
      inputList.colsToExport = $listService.getColumnsToExport(
        inputList.schema
      );
      inputList.selectedCol = inputList.colsToExport[0];
      inputList.baseSchema["$dataId"] = null;
      inputList.baseSchema["$visible"] = true;

      if (inputList.instance) {
        inputList.instance.updateSettings({
          columns: inputList.cols,
        });
      }
    }

    function setValidatorByType(input, pk, required, format) {
      switch (input) {
        case "integer":
          return function (value, callback, index) {
            if (required || pk || value) {
              callback(Number.isInteger(value), index);
            } else {
              callback(true, index);
            }
          };
        case "double":
          return function (value, callback, index) {
            if ((required || pk) && !value) {
              callback(false, index);
            } else if (required || pk || value) {
              callback(!isNaN(value), index);
            } else {
              callback(true, index);
            }
          };
        case "date":
          return function (value, callback, index) {
            format = format ? format : formats.defaults.date;
            if (required || pk || value) {
              callback(moment(value, format, true).isValid(), index);
            } else {
              callback(true, index);
            }
          };
        case "time":
          return function (value, callback, index) {
            format = format ? format : formats.defaults.time;
            if (required || pk || value) {
              callback(moment(value, format, true).isValid(), index);
            } else {
              callback(true, index);
            }
          };
        case "timestamp":
          return function (value, callback, index) {
            format = format ? format : formats.defaults.timestamp;
            if (required || pk || value) {
              callback(moment(value, format, true).isValid(), index);
            } else {
              callback(true, index);
            }
          };
        case "sequential":
          return function (value, callback, index) {
            if (value == null) {
              value = "";
            }
            if (this.allowEmpty && value === "") {
              callback(true, index);
              return;
            }
            // if (this.strict && this.source) {
            //   if (typeof this.source === 'function') {
            //     this.source(value, process(value, callback));
            //   } else {
            //     process(value, callback)(this.source);
            //   }
            // } else {
            callback(true, index);
            // }
          };
      }
    }

    inputList.settings = {
      licenseKey: "non-commercial-and-evaluation",
      stretchH: "last",
      renderAllRows: false,
      colWidths: 100,
      colHeaders: true,
      rowHeaders: true,
      persistentState: true,
      columnSorting: false,
      allowInvalid: true,
      columnHeaderHeight: 10,
      className: "htCenter",
      outsideClickDeselects: false,
      dataSchema: {},
      manualColumnResize: true,
      preventOverflow: "horizontal",
      contextMenu: {
        items: {
          row_above: {
            name: $translationService.getTranslationController(
              "Fila encima",
              "Row above",
              "Fila acima"
            ),
          },
          row_below: {
            name: $translationService.getTranslationController(
              "Fila debajo",
              "Row below",
              "Fila abaixo"
            ),
          },
          remove_row: {
            name: $translationService.getTranslationController(
              "Eliminar fila",
              "Remove row",
              "Remover fila"
            ),
          },
          divider1: {
            name: "---------",
          },
          filter: {
            name: $translationService.getTranslationController(
              "Filtrar",
              "Filter",
              "Filtrar"
            ),
            callback: function (key, selection, clickEvent) {
              inputList.showFilterDialog(clickEvent);
            },
          },
          replace: {
            name: $translationService.getTranslationController(
              "Reemplazar",
              "Replace",
              "Substituir"
            ),
            callback: function (key, selection, clickEvent) {
              inputList.showReplaceDialog(clickEvent);
            },
          },
          divider2: {
            name: "---------",
          },
          undo: {
            name: $translationService.getTranslationController(
              "Deshacer",
              "Undo",
              "Desfazer"
            ),
          },
          redo: {
            name: $translationService.getTranslationController(
              "Rehacer",
              "Redo",
              "Refazer"
            ),
          },
        },
      },
      onAfterInit: function () {
        inputList.instance = this;
        inputList.instance.updateSettings({
          dataSchema: $schemasService.createDataSchema(inputList.schema),
        });
        inputList.instance.validateCells();
      },
      onAfterOnCellMouseDown: function (event, index) {
        if (index.row < 0) {
          if (!inputList.isImporting) {
            $rootScope.loading = true;
            inputList.pagination.sortBy = inputList.cols[index.col].data;
            inputList.pagination.colType =
              inputList.types[inputList.cols[index.col].data];
            inputList.pagination.sort =
              inputList.pagination.sort == "ASC" ? "DESC" : "ASC";
            $scope.getInputListData();
          }
        }
      },
      onAfterSelectionEnd: function (x, y, z, w) {
        inputList.selectedRowMin = x >= z ? z : x;
        inputList.selectedRowMax = x > z ? x : z;
        inputList.selectedRows = Math.abs(x - z) + 1;
        inputList.selectedCol = inputList.colsToExport[y];
      },
      onAfterCreateRow: function (index, amount) {
        for (var i = 0; i < amount; i++) {
          inputList.data[index].$dataId = null;
          inputList.data[index].$visible = true;
          index++;
          inputList.pagination.totalRecords++;
        }
        $timeout(function () {
          inputList.instance.validateCells();
        }, 5);
      },
      onBeforeRemoveRow: function (index, amount, removedRows) {
        angular.forEach(removedRows, function (row) {
          if (inputList.data[row].$dataId) {
            inputList.rowsToRemove.push(inputList.data[row].$dataId);
          }
          if (inputList.isImporting) {
            var start =
              index +
              inputList.pagination.itemsPerPage *
                (inputList.pagination.page - 1);
            inputList.importedData = inputList.importedData.filter(function (
              e,
              index
            ) {
              if (index != start) return e;
            });
          }
          inputList.pagination.totalRecords--;
        });

        $scope.autoSaveMessage = $translationService.getTranslationController(
          "Los cambios realizados no se han guardado",
          "Changes made has not been saved",
          "As alterações feitas não foram salvas"
        );
        $scope.dataWasChanged = true;
      },
      onBeforeChange: function (changes, type) {
        var colIndex = changes[0][0];
        var colName = changes[0][1];
        var colDef = inputList.cols.find(function (col) {
          return (
            col.title == colName ||
            col.title == colName + "*" ||
            "#" + col.title.replace("*", "") == colName
          );
        });
      },
      onAfterChange: function (index, amount) {
        if (
          inputList.instance &&
          (amount == "external" || amount == "loadData")
        ) {
          if (inputList.data.length > 0) {
            Object.keys(inputList.data[0]).forEach(function (key) {
              var colDef = inputList.cols.find(function (col) {
                return col.data == key;
              });
            });
          }

          inputList.instance.validateCells();
        }

        if (index != null) {
          inputList.instance.validateCells();
          $scope.autoSaveMessage = $translationService.getTranslationController(
            "Los cambios realizados no se han guardado",
            "Changes made has not been saved",
            "As alterações feitas não foram salvas"
          );
          $scope.dataWasChanged = true;
        }
      },
      onBeforePaste: function (values, range) {
        var startRow = range[0].startRow;
        var startCol = range[0].startCol;
        console.log(values);
        console.time("paste");
        var content = [];

        var normalized = $listService.normalizeData(values, inputList.cols);
        // console.log(normalized);
        normalized.forEach(function (row, i) {
          row.forEach(function (value, x) {
            content.push([startRow + i, startCol + x, value]);
          });
        });
        console.timeEnd("paste");
        this.setDataAtCell(content);

        return false;
      },
    };

    inputList.validatePermission = function (permission) {
      return $permissionsFactory.hasPermission(permission);
    };

    if (!$stateParams.listId) {
      inputList._onGoBack();
    }
    if (
      !inputList.validatePermission("list#" + $stateParams.listId + ":update")
    ) {
      $toastr.error(
        $translationService.getTranslationController(
          "No tienes permitido ver esta lista.",
          "You are not allowed to see this list.",
          "Você não tem permissão para ver esta lista."
        )
      );
      inputList._onGoBack();
    } else {
      $scope.getInputList();
    }

    $scope.$on("toggleMenu", function () {
      if (inputList.instance) {
        $timeout(function () {
          inputList.instance.render();
        }, 50);
      }
    });

    $scope.$on("$stateChangeStart", function (event, next, current) {
      if (inputList.leave == true || $scope.dataWasChanged == false) {
        $interval.cancel(inputList.autoSave);
        inputList.autoSave = null;
      } else {
        event.preventDefault();
        $mdDialog.show({
          targetEvent: event,
          templateUrl: "app/input-list/templates/dialog-save-and-exit.html",
          controllerAs: "dialog",
          controller: function ($scope, $mdDialog) {
            $translationService.getTranslation($scope, "input-list");
            var vm = this;
            vm.abort = function () {
              $mdDialog.hide();
            };
            vm.saveAndExit = function () {
              inputList.onSaveData(true);
              $mdDialog.hide();
            };
            vm.exitWithoutSave = function () {
              $mdDialog.hide();
              inputList.leave = true;
              $state.go(next.name);
            };
          },
        });
      }
    });
  }
})(Handsontable);

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('indicatorsController', IndicatorsController);

  IndicatorsController.$inject = [
    '$scope',
    'toastr',
    '$mdDialog',
    'translationService',
    'IndicatorsFactory',
    'PermissionsFactory',
  ];

  function IndicatorsController(
    $scope,
    toastr,
    $mdDialog,
    $translationService,
    $indicatorsFactory,
    $permissionsFactory
  ) {
    var vm = this;

    $translationService.getTranslation(vm, 'indicators');

    vm.isLoading = true;
    vm.indicators = null;

    vm.ACL = {
      canCreate: !$permissionsFactory.hasPermission('indicators:create'),
      canUpdate: !$permissionsFactory.hasPermission('indicators:update'),
      canDelete: !$permissionsFactory.hasPermission('indicators:delete'),
    };

    vm.$onInit = function () {
      getIndicators();
    };
    vm.$onInit();

    vm.indicatorDialog = function (indicator) {
      $mdDialog
        .show({
          controller: 'IndicatorDialogController',
          controllerAs: 'ctrl',
          templateUrl: 'app/indicators/dialog/indicator-dialog.html',
          parent: angular.element(document.body),
          locals: {
            indicator: indicator || null,
          },
        })
        .then(function () {
          getIndicators();
        });
    };

    vm.deleteIndicator = function (indicatorId) {
      vm.isLoading = true;
      $indicatorsFactory
        .deleteIndicator(indicatorId)
        .then(function (res) {
          getIndicators();
          vm.isLoading = false;
        })
        .catch(function (err) {
          vm.isLoading = false;
          toastr.error(err.message);
          console.error('Error@deleteIndicator', err);
        });
    };

    vm.validatePermission = function (permission) {
      return $permissionsFactory.hasPermission(permission);
    };

    function getIndicators() {
      vm.isLoading = true;
      $indicatorsFactory
        .getIndicators()
        .then(function (res) {
          vm.isLoading = false;
          vm.indicators = res;
        })
        .catch(function (err) {
          vm.isLoading = false;
          toastr.error(err.message);
          console.error('Error@getIndicators', err);
        });
    }
  }
})();

(function () {
  "use strict";

  angular.module("dashboard").controller("HomeController", HomeController);

  HomeController.$inject = [
    "$scope",
    "$rootScope",
    "$location",
    "$anchorScroll",
    "$stateParams",
    "$state",
    "$timeout",
    "toastr",
    "translationService",
    "gridConfig",
    "AlertManagementFactory",
    "UserFactory",
    "PermissionsFactory",
    "$mdDialog",
    "BookmarkService"
  ];

  function HomeController(
    $scope,
    $rootScope,
    $location,
    $anchorScroll,
    $stateParams,
    $state,
    $timeout,
    toastr,
    $translationService,
    gridConfig,
    AlertManagementFactory,
    UserFactory,
    PermissionsFactory,
    $mdDialog,
    $bookmarkService
  ) {
    var vm = this;
    vm.hasChanges = false;
    vm.isOpen = false;
    vm.ActiveBoard = null;
    vm.dashboards = [];
    vm.loadingDashboards = true;

    vm.toggleMenu = function () {
      vm.isOpen = !vm.isOpen;
    };

    $scope.toAlertManagement = function () {
      $state.go("app.alert-management");
    };

    $scope.getUserDashboardsFn = function () {
      vm.loadingDashboards = true;

      UserFactory.getUserDashboards()
        .then(function (res) {
          vm.dashboards = [];
          if (res.length > 0) {
            for (var i = 0; i < res.length; i++) {
              var _widgets = res[i].dashboardConfig
                ? angular.fromJson(res[i].dashboardConfig)
                : [];
              var board = {
                id: res[i].dashboardId,
                name: res[i].dashboardName,
                configs: _widgets,
                widgets: _widgets ? newWidgetsFn(_widgets) : [],
                status: res[i].dashboardStatus,
                order: res[i].dashboardOrder
              };

              vm.dashboards.push(board);
            }
          }

          vm.dashboards = vm.dashboards
            .sort(function (a, b) {
              return b.order - a.order;
            })
            .reverse();

          vm.ActiveBoard = vm.dashboards[$scope.activeTab];
          $timeout(function () {
            vm.getData();
          }, 600);
        })
        .catch(function (err) {
          console.error("err@getUserDashboards", err);
        })
        .finally(function () {
          //action to do if user has no dashboards
          if (vm.dashboards && vm.dashboards.length === 0) {
            setTimeout(function () {
              document.getElementById("dashboardOpenMainMenu").click();
            }, 500);
          }
          vm.loadingDashboards = false;
        });
    };

    function newWidgetsFn(configs) {
      var tmp = [];
      configs.forEach(function (_widget) {
        if (_widget.widget.type == "alerts-chart-widget") {
          if (PermissionsFactory.hasPermission("event:read")) {
            tmp.push(_widget);
          }
        } else if (_widget.widget.type == "executions-widget") {
          if (PermissionsFactory.hasPermission("function:read-runs")) {
            tmp.push(_widget);
          }
          // } else if (_widget.widget.type == 'cases-widget') {
          //   if (PermissionsFactory.hasPermission('cases:read')) {
          //     tmp.push(_widget);
          //   }
          // } else if (_widget.widget.type == 'replay-chart-widget') {
          //   if (PermissionsFactory.hasPermission('graphic-report:read')) {
          //     tmp.push(_widget);
          //   }
        } else {
          tmp.push(_widget);
        }
      });
      return tmp;
    }

    vm.loadingDashboards = false;
    vm.saveUserDashboards = function (action) {
      vm.loadingDashboards = true;

      var dashboardData;
      if (action == "create") {
        dashboardData = {
          id: null,
          name: "new Dashboard",
          configs: [],
          widgets: [],
          order: vm.dashboards.length + 1
        };
      } else {
        dashboardData = vm.ActiveBoard;
      }

      UserFactory.saveUserDashboards(action, dashboardData)
        .then(function (res) {
          if (action == "create") {
            PermissionsFactory.addPermission(
              "dashboard",
              res.dashboardId,
              "all",
              true
            );
            vm.dashboards.push({
              id: res.dashboardId,
              name: res.dashboardName,
              configs: [],
              widgets: [],
              status: res.dashboardStatus,
              order: res.dashboardOrder
            });
            $scope.activeTab = vm.dashboards.length - 1;
            vm.ActiveBoard = vm.dashboards[$scope.activeTab];
          } else {
            console.log("update@saveUserDashboards", res);

            var updatedBoard = vm.dashboards.find(function (board) {
              return board.id == res.dashboardId;
            });

            if (updatedBoard) {
              updatedBoard.name = res.dashboardName;
              updatedBoard.configs = angular.copy(vm.ActiveBoard.configs);
              updatedBoard.widgets = angular.copy(vm.ActiveBoard.widgets);
            }
          }
          toastr.success("Dashboard Saved");
          vm.hasChanges = false;
          return res;
        })
        .catch(function (err) {
          toastr.error("Error saving dashboard");
          console.error("err@saveUserDashboards", err);
        })
        .finally(function () {
          vm.loadingDashboards = false;
          vm.hasChanges = false;
          $bookmarkService.init();
        });
    };

    vm.deleteUserDashboards = function () {
      if (validDashboard("delete") == false) return;

      vm.ActiveBoard.status = false;
      UserFactory.deleteUserDashboards(vm.ActiveBoard)
        .then(function (res) {
          vm.dashboards = vm.dashboards.filter(function (board) {
            return board.id !== vm.ActiveBoard.id;
          });
          $scope.activeTab = 0;
          toastr.success("Dashboard deleted");
        })
        .catch(function (err) {
          toastr.error("Error deleting dashboard");
          console.error("err@deleteUserDashboards", err);
        })
        .finally(function () {
          vm.hasChanges = false;
          $bookmarkService.init();
        });
    };

    (function init() {
      $translationService.getTranslation($scope, "dashboard");

      vm.dashboards = [];
      $scope.activeTab = $rootScope.homeBoardActive || 0;
      vm.gridConfig = gridConfig;
      vm.gridConfig.resizable = {
        enabled: true,
        stop: function () {
          $rootScope.$broadcast("homeWidgetRezised");
        }
      };

      if (PermissionsFactory.hasPermission("dashboard:read")) {
        $scope.getUserDashboardsFn();
      } else {
        setTimeout(function () {
          document.getElementById("dashboardOpenMainMenu").click();
        }, 500);
      }
    })();

    $scope.evet = function () {
      vm.hasChanges = true;
    };

    // -- Datos  (todo -> pasar a servicio)
    $scope.startDate =
      $stateParams.desde ||
      moment().hour(0).minute(0).second(0).subtract(1, "week");
    $scope.endDate =
      $stateParams.hasta || moment().hour(23).minute(59).second(59);

    vm.getData = function () {
      vm.CongfigAlertas = [];
      vm.params = {
        startDate: moment($scope.startDate).toISOString(),
        endDate: moment($scope.endDate).toISOString()
      };
      AlertManagementFactory.getReportCount("alerts_dashboard", vm.params)
        .then(function (res) {
          vm.CongfigAlertas = res.reportDataList;
          $rootScope.$broadcast("alerts_dashboard_data", vm.CongfigAlertas);
        })
        .catch(function (err) {
          vm.errorResp = true;
        });
    };

    $scope.$on("dateChange", function (e, dates) {
      $scope.startDate = dates.desde;
      $scope.endDate = dates.hasta;
      vm.getData();
    });

    $scope.$on("refreshMaiMenu", function () {
      if (PermissionsFactory.hasPermission("dashboard:read")) {
        $scope.getUserDashboardsFn();
      }
    });

    function _getNextWidgetId() {
      var widgetsIds = vm.ActiveBoard.widgets.map(function (e) {
        return parseInt(e.id.toString().slice(1));
      });

      var maxWidgetsId = widgetsIds.length
        ? Math.max.apply(null, widgetsIds)
        : 0;

      return parseInt(vm.ActiveBoard.id + "" + (maxWidgetsId + 1));
    }

    vm.previewWidget = function (widget) {
      var newWidget = widget;
      newWidget.id = _getNextWidgetId();

      vm.ActiveBoard.widgets.push(newWidget);
      vm.ActiveBoard.configs = vm.ActiveBoard.widgets;

      $timeout(function () {
        $location.hash("dashboard-end");
        $anchorScroll();
      }, 300);
    };

    vm.addWidget = function () {
      var widget = angular.copy(
        vm.ActiveBoard.widgets[vm.ActiveBoard.widgets.length - 1]
      );
      delete widget.icon;
      delete widget.name;
      delete widget.widget.configs;

      vm.ActiveBoard.widgets.splice(
        vm.ActiveBoard.widgets.length - 1,
        1,
        widget
      );

      vm.getData();
      vm.hasChanges = true;
    };

    vm.cancelWidget = function () {
      console.log(vm.ActiveBoard.widgets);
      vm.ActiveBoard.widgets.pop();
      vm.ActiveBoard.configs = vm.ActiveBoard.widgets;
    };

    vm.deleteWidget = function (id) {
      if (validDashboard("delete") == false) return;

      vm.ActiveBoard.widgets = vm.ActiveBoard.widgets.filter(function (e) {
        return e.id != id;
      });

      vm.ActiveBoard.configs = angular.copy(vm.ActiveBoard.widgets);
      vm.hasChanges = true;
    };

    // vm.keyboardCheatSheet = function () {
    //   hotkeys.toggleCheatSheet();
    // };

    $scope.onTabSelected = function (tab) {
      vm.ActiveBoard = null;
      $rootScope.homeBoardActive = tab;
      var currentindexTab = vm.dashboards.indexOf(tab);
      $rootScope.homeBoardActive = currentindexTab;
      setTimeout(function () {
        vm.ActiveBoard = tab;
      }, 100);
    };

    vm.editDashboardName = function (ev, id) {
      if (validDashboard("update") == false) return;

      var confirm = $mdDialog
        .prompt()
        .title("Cambia el nombre de este dashboard")
        .textContent("ingresa el nombre de tu dashboard")
        .placeholder("nombre")
        .ariaLabel("dashboardname")
        .initialValue(vm.ActiveBoard.name)
        .targetEvent(ev)
        .required(true)
        .ok("Aceptar")
        .cancel("Cancelar");

      $mdDialog.show(confirm).then(function (result) {
        vm.ActiveBoard.name = result;
        vm.hasChanges = true;
        vm.saveUserDashboards("update");
      });
    };

    vm.deleteDashboard = function (ev) {
      if (validDashboard("delete") == false) return;
      var title =
        "Seguro deseas eliminar el dashboard " +
        vm.ActiveBoard.id +
        " - " +
        vm.ActiveBoard.name;
      var confirm = $mdDialog
        .confirm()
        .title(title)
        .textContent("todos sus widgets seran eliminados")
        .ariaLabel("deleteDashboard")
        .targetEvent(ev)
        .ok("Aceptar")
        .cancel("Cancelar");

      $mdDialog.show(confirm).then(function (result) {
        vm.deleteUserDashboards();
      });
    };

    vm.newDashboard = function () {
      vm.saveUserDashboards("create");
    };

    vm.organizeDashboard = function () {
      $mdDialog
        .show({
          controller: "OrganizeDashboardsController",
          controllerAs: "ctrl",
          templateUrl:
            "app/home/components/organize-dashboards/organize-dashboards.html",
          clickOutsideToClose: false
        })
        .then(function () {
          $scope.getUserDashboardsFn();
        });
    };

    vm.shareDashboard = function () {
      if (validDashboard("share") == false) return;

      var dashboard = vm.dashboards[$scope.activeTab];

      $mdDialog.show({
        controller: "ShareEntityController",
        templateUrl: "app/acl/component/dialog-share-entity.html",
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          selectedItem: {
            id: dashboard.id,
            resource: "dashboard",
            name: dashboard.name
          },
          actions: ["read", "update", "delete"]
        }
      });
    };

    function validDashboard(action) {
      var dashboard = vm.dashboards[$scope.activeTab];

      var hasPermission = PermissionsFactory.hasPermission(
        "dashboard#" + dashboard.id + ":" + action
      );
      if (hasPermission == true) {
        return true;
      } else {
        toastr.error("No tienes permisos para " + action + " este dashboard");
        return false;
      }
    }
  }
})();

(function () {
  "use strict";

  angular.module("dashboard").controller("GestionAlertas", GestionAlertas);

  GestionAlertas.$inject = [
    "$scope",
    "$localStorageService",
    "toastr",
    "AlertManagementFactory",
    "translationService",
    "$state",
    "DashboardService",
  ];
  function GestionAlertas(
    $scope,
    $localStorageService,
    toastr,
    AlertManagementFactory,
    $translationService,
    $state,
    $dashboardService
  ) {
    $translationService.getTranslation($scope, "gestion-alertas");
    var vm = this;
    vm.currentLang = angular.lowercase($localStorageService.getItem("currentUser.lenguaje"));
    vm.loading = false;
    vm.errorReporting = { status: false, error: "" };
    vm.rangeSlider = {
      config: { min: 30, max: 60, gap: 3, step: 1, precision: 1 },
      model: { from: 30, to: 40 },
    };
    vm.metadata = [];
    vm.reportData = {
      reportId: "alerts_dashboard",
      conf: {
        minOcurrence: vm.rangeSlider.config.min,
        maxOcurrence: vm.rangeSlider.config.max,
        breach: vm.rangeSlider.config.gap,
        minOcurrenceColor: vm.rangeSlider.model.from,
        maxOcurrenceColor: vm.rangeSlider.model.to,
        settings: [],
      },
    };
    $scope.rawMetadata = {
      statusList: [
        {
          statusId: 0,
          statusName: [
            { lang: "es", value: "No Visto" },
            { lang: "pt", value: "Não Visto" },
            { lang: "en", value: "Not Seen" },
          ],
        },
        {
          statusId: 1,
          statusName: [
            { lang: "es", value: "Visto" },
            { lang: "pt", value: "Visto" },
            { lang: "en", value: "Seen" },
          ],
        },
      ],
    };

    vm.styleAlert = function (num) {
      var min = vm.rangeSlider.model.from;
      var max = vm.rangeSlider.model.to;
      var inRange = (num - min) * (num - max) <= 0;
      if (!inRange) {
        if (num >= max) {
          return "mayor";
        } else if (num <= min) {
          return "menor";
        } else {
          return "??";
        }
      } else {
        return "inrange";
      }
    };

    $scope.toHome = function () {
      $dashboardService.toHomePage()
    };

    vm.getMetaData = function () {
      vm.loading = true;
      AlertManagementFactory.getReportMetaData()
        .then(function (res) {
          // console.log("getMetaData",res)

          if (res.statusList) {
            res.statusList.forEach(function (ele) {
              var seLangtName = ele.statusName
                .filter(function (e) {
                  return e.lang == vm.currentLang;
                })
                .map(function (e) {
                  return e.value;
                })
                .toString();
              var objStatus = {
                statusId: ele.statusId,
                statusName: seLangtName,
                hidden: false,
                severity: 0,
                weighing: 0,
              };
              vm.reportData.conf.settings.push(objStatus);
              vm.metadata.push(objStatus);
            });
            vm.setConfig();
          } else {
            $scope.rawMetadata.statusList.forEach(function (ele) {
              var seLangtName = ele.statusName
                .filter(function (e) {
                  return e.lang == vm.currentLang;
                })
                .map(function (e) {
                  return e.value;
                })
                .toString();
              var objStatus = {
                statusId: ele.statusId,
                statusName: seLangtName,
                hidden: false,
                severity: 0,
                weighing: 0,
              };
              vm.reportData.conf.settings.push(objStatus);
              vm.metadata.push(objStatus);
            });
            vm.setConfig();
          }
        })
        .catch(function (err) {
          vm.loading = false;
          vm.errorReporting.status = true;
          vm.errorReporting.error = err;
          console.error("Error@getMetaData", err);
        });
    };
    vm.getMetaData();

    vm.resetReportByID = function () {
      vm.loading = true;
      AlertManagementFactory.resetReportByID(vm.reportData.reportId)
        .then(function (res) {
          // console.log("resetReportByID",res)
          toastr.success(
            $translationService.getTranslationController(
              vm.reportData.reportId + " ha sido reseteado",
              vm.reportData.reportId + " has been reset",
              vm.reportData.reportId + " ha sido reseteado"
            )
          );
          vm.setConfig();
          vm.loading = false;
        })
        .catch(function (err) {
          vm.loading = false;
          vm.errorReporting.status = true;
          vm.errorReporting.error = err;
          console.error("Error@resetReportByID", err);
        });
    };

    vm.setConfig = function () {
      AlertManagementFactory.getReportById(vm.reportData.reportId)
        .then(function (res) {
          // console.log("setConfig",res)
          if (res.conf) {
            vm.reportData = res;
            vm.reportData.conf = angular.fromJson(vm.reportData.conf);
            vm.rangeSlider.config.min = vm.reportData.conf.minOcurrence;
            vm.rangeSlider.config.max = vm.reportData.conf.maxOcurrence;
            vm.rangeSlider.config.gap = vm.reportData.conf.breach;
            vm.rangeSlider.model.from = vm.reportData.conf.minOcurrenceColor;
            vm.rangeSlider.model.to = vm.reportData.conf.maxOcurrenceColor;
            vm.loading = false;
          } else {
            toastr.info(
              $translationService.getTranslationController(
                "reseteando configuracion para " + vm.reportData.reportId,
                "resetting settings for " + vm.reportData.reportId,
                "reseteando configuracion para " + vm.reportData.reportId
              )
            );
            vm.resetReportByID(vm.reportData.reportId);
          }
        })
        .catch(function (err) {
          vm.loading = false;
          vm.errorReporting.status = true;
          vm.errorReporting.error = err;
          console.log("Error@setConfig", err);
        });
    };
    // vm.setConfig()

    vm.getReport = function () {
      AlertManagementFactory.getReport()
        .then(function (res) {
          // console.log("getReport",res)
          vm.reportData.id = res.data[0].id;
          vm.reportData.reportId = res.data[0].reportId;
          vm.reportData.conf = angular.fromJson(res.data[0].conf);

          vm.rangeSlider.config.min = vm.reportData.conf.minOcurrence;
          vm.rangeSlider.config.max = vm.reportData.conf.maxOcurrence;
          vm.rangeSlider.config.gap = vm.reportData.conf.breach;
          vm.rangeSlider.model.from = vm.reportData.conf.minOcurrenceColor;
          vm.rangeSlider.model.to = vm.reportData.conf.maxOcurrenceColor;
        })
        .catch(function (err) {
          // console.log("Error@getReport", err);
        });
    };
    // vm.getReport()

    vm.saveData = function () {
      vm.reportData.conf = {
        minOcurrence: vm.rangeSlider.config.min,
        maxOcurrence: vm.rangeSlider.config.max,
        breach: vm.rangeSlider.config.gap,
        minOcurrenceColor: vm.rangeSlider.model.from,
        maxOcurrenceColor: vm.rangeSlider.model.to,
        settings: vm.reportData.conf.settings,
      };
      var reportData = vm.reportData;
      reportData.conf = angular.toJson(reportData.conf);
      vm.loading = true;
      AlertManagementFactory.setReport(reportData)
        .then(function (res) {
          // console.log("saveData",res)
          vm.reportData = res;
          vm.reportData.conf = angular.fromJson(vm.reportData.conf);
          toastr.success(
            $translationService.getTranslationController(
              "Guardado",
              "Save",
              "Guardado"
            )
          );
          vm.loading = false;
        })
        .catch(function (err) {
          if (typeof err === "string") toastr.warning(err);
          vm.loading = false;
          console.error("Error@saveData", err);
        });
    };
  }
})();

(function () {
    'use strict';

    angular
        .module('dashboard')
        .controller('FilterConfigurationController', FilterConfigurationController)
        .controller('FiltersListController', FiltersListController);

    FilterConfigurationController.$inject = ['$scope','$rootScope', 'toastr','translationService', 'FunctionFactory', 'FunctionFiltersFactory', 'timezoneService','$mdDialog'];
    function FilterConfigurationController($scope, $rootScope, toastr, $translationService, FunctionFactory, FunctionFiltersFactory, $timezoneService, $mdDialog) {
        $rootScope.loading = true;
        var vm = this;

        vm.config = [];
        vm.filter = {values:[]};

        FunctionFactory.getFunctions()
        .then(function(res){
            vm.config = res.data;
            if($scope.exclusionFilter){
                vm.filter = $scope.exclusionFilter;
                vm.filter.values = $scope.exclusionFilter.value.split(",");
                vm.parseRuleParams(vm.filter.functionId);
            }else{
                vm.filter.id = null;
            }
        })
        .catch(function(err){
            toastr.error($translationService.getTranslationController('No se han podido cargar las reglas', 'Rules could not be loaded', 'As regras não puderam ser carregadas'));
            console.log("Error@getFunctions", err);
        })
        .finally(function(){ $rootScope.loading = false; });

        vm.parseRuleParams = function(ruleId) {
            var rule = vm.config.filter(function(e){ return e.id == ruleId })[0];
            vm.filter.functionName = rule.name;
            vm.filter.functionDescription = rule.description;
            vm.filter.functionId = rule.id;
            if(rule.structure){
                vm.params = angular.fromJson(rule.structure);
            }
        }

        vm.saveFilter = function() {
            $rootScope.loading = true;
            vm.filter.timestamp = moment().toISOString();
            vm.filter.status = true;
            vm.filter.value = vm.filter.values.join().toUpperCase();
            vm.filter.type = "String"

            if(vm.filter.filterName == undefined){
                var errMsg = $translationService.getTranslationController('Agregue un nombre al filtro.', 'Add a name to the filter.', 'Adicione um nome ao filtro.');
            }else if(vm.filter.functionId == undefined){
                var errMsg = $translationService.getTranslationController('Debe seleccionar una regla.', 'You must select a rule.', 'Você deve selecionar uma regra.');
            }else if(vm.filter.filterFunction == undefined){
                var errMsg = $translationService.getTranslationController('Debe seleccionar una función.', 'YOu must select a function.', 'Você deve selecionar uma função.');
            }else if(vm.filter.param == undefined){
                var errMsg = $translationService.getTranslationController('Debe seleccionar un parametro.', 'You must select a param.', 'Você deve selecionar um parâmetro.');
            }else if(vm.filter.values.length < 1){
                var errMsg = $translationService.getTranslationController('Debe agregar al menos un valor.', 'You must add at leas one value.', 'Você deve adicionar pelo menos um valor.');
            }else if(vm.filter.action == undefined){
                var errMsg = $translationService.getTranslationController('Debe seleccionar una acción', 'YOu must select an action', 'Você deve selecionar uma ação');
            }else if(vm.filter.type == undefined){
                var errMsg = $translationService.getTranslationController('Debe indicar el tipo de campo.', 'You must select a value type.', 'Você deve indicar o tipo de campo.');
            }

            if(errMsg){
                toastr.warning(errMsg);
                $rootScope.loading = false;
                return false;
            }

            if(vm.filter.id){   // -- Update Filters
                FunctionFiltersFactory.updateFilter(vm.filter)
                .then(function(res){ saveSuccess(res) })
                .catch(function(e){ saveErr(e); console.log("Error@updateFilter", e); })
            }else{              // -- Create Filters
                FunctionFiltersFactory.createFilter(vm.filter)
                .then(function(res){ $rootScope.$broadcast('exclusionFilterCreated'); saveSuccess(res) })
                .catch(function(e){ saveErr(e); console.log("Error@createFilter", e); })
            }
        };
        
        function saveSuccess(res){
            var msg = $translationService.getTranslationController('Cambios Guardados', 'Changes Saved', 'Mudanças salvas');
            toastr.success(msg);
            // $scope.$hide();
            $mdDialog.cancel();
            $rootScope.loading = false;
        }

        function saveErr(e){
            $rootScope.loading = false;
            var msg = $translationService.getTranslationController('Se ha producido un error', 'An error has occurred', 'Ocorreu um erro');
            toastr.error(msg);
            // $scope.$hide();
            $mdDialog.cancel();
        }
        
        $scope.cancel = function () {
            $mdDialog.cancel();
        }
    }

    FiltersListController.$inject = ['$scope', '$state', '$rootScope', '$modal', 'toastr', '$http', 'translationService','$mdDialog', 'FunctionFiltersFactory'];
    function FiltersListController($scope, $state, $rootScope, $modal, toastr, $http, $translationService, $mdDialog, FunctionFiltersFactory) {
        $translationService.getTranslation($scope, 'filters');
        $rootScope.loading = true;
        var vm = this;

        vm.getFilters = function(){
            FunctionFiltersFactory.getFilters()
            .then(function(res){
                vm.filters = res.sort(function (a, b){ return (b.id - a.id) });
                $rootScope.loading = false;
            })
            .catch(function(e){
                toastr.error($translationService.getTranslationController('Se ha producido un error', 'An error has occurred', 'Ocorreu um erro'));
                console.log("Error@getConfig");
                console.log(e);
                $rootScope.loading = false;
            });
        }
        vm.getFilters();
        
        $scope.$on('exclusionFilterCreated', function(){
            vm.getFilters();
        });

        // vm.ModalCrearFiltros = function(filter) {
        //     $scope.exclusionFilter = filter;
        //     var modalFiltros = $modal({
            //         templateUrl: 'app/filtros/modal-crear-filtros.html',
            //         backdrop: 'static',
            //         size: 'md',
            //         scope: $scope,
            //         keyboard: true,
            //         show: true,
            //         controller: FilterConfigurationController,
            //         controllerAs: 'config'
            //     });
            // }
            
        vm.showModal = function (ev, filter) {
            $scope.exclusionFilter = filter;
            $mdDialog.show({
                templateUrl: 'app/filtros/modal-crear-filtros.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                controller: FilterConfigurationController,
                scope: $scope,
                preserveScope: true, 
                controllerAs: 'config',
                clickOutsideToClose: false
            })
        };
        
        vm.hideModal = function () {
            $mdDialog.cancel();
        };

        vm.deleteFilter = function(filterId){
            var confirm = $mdDialog.confirm()
                .title($translationService.getTranslationController('¿Eliminar filtro: ', 'Delete filter ', 'Excluir filtro?') + filterId + '?')
                .textContent($translationService.getTranslationController('¡Cuidado!, Esta acción no puede revertirse.', 'Atention!, This action can not be reversed.', 'Atenção!, esta ação não pode ser revertida.'))
                .ariaLabel('Delete-Question')
                .ok($translationService.getTranslationController('Si, Elimínala', 'Yes, Delete it', "Sim, exclua"))
                .cancel($translationService.getTranslationController('Aún no', 'Not yet', 'Ainda não'));
            // ToDo. Prompt confirm deletion
            $mdDialog.show(confirm).then(function () {
                $rootScope.loading = true;
                FunctionFiltersFactory.deleteFilter(filterId)
                .then(function(res){
                    toastr.error($translationService.getTranslationController('Filtro Eliminado', 'Filter deleted', 'Filtro eliminado'));
                    vm.getFilters();
                })
                .catch(function(e){
                    toastr.error($translationService.getTranslationController('Se ha producido un error', 'An error has occurred', 'Ocorreu um erro'));
                    console.log("Error@deleteFilter", e);
                    $rootScope.loading = false;
                });
            }, function () { });
        }
    }
})();
(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller("ExternalLibrariesController", ExternalLibrariesController);

  ExternalLibrariesController.$inject = [
    "$scope",
    "$stateParams",
    "$state",
    "$compile",
    "$element",
    "toastr",
    "translationService",
    "ExternalLibrariesFactory",
    "PermissionsFactory",
    "DashboardService",
  ];

  function ExternalLibrariesController(
    $scope,
    $stateParams,
    $state,
    $compile,
    $element,
    toastr,
    $translationService,
    $externalLibrariesFactory,
    $permissionsFactory,
    $dashboardService
  ) {
    var vm = this;
    $scope.responseHtml = null;

    vm.translate = {
      loading: $translationService.getTranslationController(
        "Loading, please wait...",
        "Cargando, por favor espera...",
        "Carregando, por favor aguarde..."
      ),
      send: $translationService.getTranslationController("Send", "Enviar", "Enviar"),
    };

    if (!$permissionsFactory.hasPermission("python-library:read")) {
      toastr.error(
        $translationService.getTranslationController(
          "You do not have permission to access this page",
          "No tienes permiso para acceder a esta página",
          "Você não tem permissão para acessar esta página"
        )
      );
      $dashboardService.toHomePage()
      return;
    }

    vm.title = "External Libraries";
    vm.loading = false;
    vm.library = null;
    vm.schema = [];

    function getLibrary() {
      vm.loading = true;
      $externalLibrariesFactory
        .getPythonLibrary($stateParams.libraryId)
        .then(function (response) {
          vm.library = response.data;

          $externalLibrariesFactory
            .generateInput(vm.library.id)
            .then(function (schema) {
              vm.schema = schema || [];
              vm.loading = false;
            })
            .catch(function (error) {
              vm.loading = false;
              console.error("error@generateInput", error);
              if (error.status === 403) {
                $dashboardService.toHomePage()
                return;
              }
              if (error.status === 500) {
                var err_msg = $translationService.getTranslationController(
                  "Error Python process",
                  "Error en el proceso de Python",
                  "Erro no processo Python"
                );
                toastr.error(err_msg);
                return;
              }
              toastr.error(error.data.message);
            });
        })
        .catch(function (error) {
          vm.loading = false;
          console.error("getLibrary", error);
          toastr.error(error.data.message);
        });
    }
    getLibrary();

    vm.submit = function () {
      vm.loading = true;

      if (!$scope.formPy.$valid) return;

      var mapObejct = null;

      if (vm.schema.length > 0) {
        mapObejct = {};
        vm.schema.forEach(function (field) {
          mapObejct[field.key] = field.value;
        });
      }
      $scope.responseHtml = null;
      resetHtml();

      var TitleInfoToast = $translationService.getTranslationController(
        "Executing library",
        "Ejecutando librería",
        "Executando biblioteca"
      );

      var textInfoToast = $translationService.getTranslationController(
        "Please wait",
        "Por favor espera",
        "Por favor aguarde"
      );

      var TitleSuccessToast = $translationService.getTranslationController(
        "Process completed",
        "Proceso completado",
        "Processo concluído"
      );

      var textSuccessToast = $translationService.getTranslationController(
        "The library has been executed successfully",
        "La librería se ha ejecutado correctamente",
        "A biblioteca foi executada com sucesso"
      );

      $externalLibrariesFactory
        .saveInput(vm.library.id, mapObejct)
        .then(function (inputId) {
          toastr.info(textInfoToast, TitleInfoToast);
          // EXECUTE
          $externalLibrariesFactory
            .executePythonLibrary(vm.library.id, inputId)
            .then(function (response) {
              setHtml(response.data);
              toastr.success(textSuccessToast, TitleSuccessToast);
              $scope.responseHtml = response.data;
              vm.loading = false;
            })
            .catch(function (error) {
              vm.loading = false;
              console.error("error@executePythonLibrary", error);

              if (error.status === 500) {
                var err_msg = $translationService.getTranslationController(
                  "Error Python process",
                  "Error en el proceso de Python",
                  "Erro no processo Python"
                );
                toastr.error(err_msg);
                return;
              }

              toastr.error(error.statusText);
            });
        })
        .catch(function (error) {
          console.error("error@saveInput", error);
          toastr.error(error.statusText);
          vm.loading = false;
        });
    };

    function setHtml(html) {
      console.log("html", html);

      var html = $compile(html)($scope);

      $element.find("#inputHtml").html(html);
    }

    function resetHtml() {
      $element.find("#inputHtml").html("");
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('dashboard')
        .controller('EventReplayController', EventReplayController);

    EventReplayController.$inject = ['$scope', '$state', '$rootScope', '$stateParams', 'ReplaysFactory', 'env', '$mdSidenav',
                                    /*-> de Más, purgar*/ 'toastr', '$timeout', '$modal', 'ReportsFactory'];
    
    function EventReplayController($scope, $state, $rootScope, $stateParams, ReplaysFactory, env, $mdSidenav, 
                                    /*  -> de Más, purgar */ toastr, $timeout, $modal, ReportsFactory) {
        
        $scope.replayName = $stateParams.replayName;
        $scope.replayId = $stateParams.replayId;

        $scope.crearReplay = function () {
            $rootScope.loading = true;
            return new Promise(function (resolve, reject) {
                // -- Obtener instancias de Multigraficos
                ReplaysFactory.getReplay({
                  replayId: $scope.replayId
                })
                .then(function (res) {
                    $scope.eventReplay = res;
                    $scope.eventReplay.replayId = $scope.replayId;
                    
                    var promises = [];
                    angular.forEach($scope.eventReplay.multigraphList, function(_multigraph, key) {
                        var req = {
                            replayId: $scope.eventReplay.replayId, 
                            multiGraphId: _multigraph.multigraphId,
                        }

                        promises.push(new Promise(function (resolve, reject) {
                            ReplaysFactory.getSymbols(req)
                            .then(function (res) {
                                $scope.eventReplay.multigraphList[key].symbols = res;
                                resolve(true);
                            })
                            .catch(function (e) {
                                console.log('Event-Replay control, error@obtenerSymbols');
                                console.log(e);
                                reject(e);
                            });
                        }));
                    });

                    Promise.all(promises).then(function(values) { 
                        $scope.$apply();
                        resolve(true);
                    });
                })
                .catch(function (err) {
                    console.log('Event-Replay control, error@getReplay');
                    console.log(err);  
                    $rootScope.loading = true; 
                    reject(false);
                });
            });
        }

        $scope.obtenerSymbols = function (req) {
            return new Promise(function (resolve, reject) {
                ReplaysFactory.getSymbols(req)
                .then(function (res) {
                    resolve(res);
                })
                .catch(function (e) {
                    console.log('Event-Replay control, error@obtenerSymbols');
                    console.log(e);
                    reject(e);
                });
            });
        }

        $scope.obtenerData = function (req) {
            return new Promise(function (resolve, reject) {
                ReplaysFactory.getGraphData(req)
                .then(function (res) {
                    resolve(res);
                })
                .catch(function (e) {
                    console.log('Event-Replay control, error@getGraphData');
                    console.log(e);
                    reject(e);
                });            
            });
        }

        $scope.crearIntervalo = function (req) {
            return new Promise(function (resolve, reject) {
                ReplaysFactory.setInterval(req)
                .then(function (res) {
                    resolve(res);
                })
                .catch(function (e) {
                    console.log('Event-Replay control, error@setInterval');
                    console.log(e);
                    reject(e);
                });            
            });
        }

        $scope.eliminarIntervalo = function (req) {
            return new Promise(function (resolve, reject) {
                ReplaysFactory.delInterval(req)
                .then(function (res) {
                    resolve(res);
                })
                .catch(function (e) {
                    console.log('Event-Replay control, error@delInterval');
                    console.log(e);
                    reject(e);
                });            
            });
        }

        $scope.configReplay = {
            datasource:{
                //origin: "GET", //REST Methods, ARRAY, WS(WebSocket)
                //url: "/risk-backend/rest/events/summary", //solo para rest y ws
                origin: env.ssl ? "WSS" : "WS", //REST Methods, ARRAY, WS o WSS(WebSocket).Desde localhost usar WS, con seguridad WSS
                url: env.domain + (env.port ? ":" + env.port : "") + "/risk-backend/websockets/events",//"localhost:30249/risk-backend/websockets/events"//reemplazar localhost por ubicacion backend,solo para rest y ws
                //optional values
                //autoLoad: false,
                paramsDefault: {
                    // query : vm.filters.query || '',
                    // sortBy :  vm.filters.sortBy,
                    // sort : vm.filters.sort || 'desc',
                    // startDate : vm.filters.startDate.local().format(),
                    // endDate : vm.filters.endDate.format(),
                    page: 1,
                    itemsPerPage: 10
                },
                paramsOut:{
                    data : "events",
                    pagination: "pagination"
                }
            },
            filterDatasource:{
                //servicio utilizado para construir solamente los checkbox de los filtros
                // url:"/risk-backend/rest/events/filters",
                // paramsDefault:{
                //     checked : $rootScope.filters.filterBy.event
                // }
            },
            columns:[ // -- columnas de la tabla, tipo de datos, header, visible/no visible.
                // {name:"id", title:"Id", type:"number", hidden:false, sortable: true, filterable: {"type": "number"} },
                // {name:"timestamp", title:"Fecha/Hora", type:"date", hidden:false, sortable: true},
                // {name:"labels", title:"Tipo", type:"array", hidden:false, sortable: true},
                // {name:"caseStatus", title:"Estado Caso", type:"string", hidden:true},
                // {name:"status", title:"Estado", type:"string", hidden:false, sortable: true, filterable: {"type": "checkbox"}},
                // {name:"checked", title:"Estado Atencion", type:"string", hidden:true, filterable: {"type": "checkbox"}},
                // {name:"ruleDescription", title:"descripcionRegla", type:"string", hidden:true},
                // {name:"ruleCode", title:"descripcionReglaTooltip", type:"string", hidden:true},
                // {name:"ruleName", title:"nombreRegla", type:"string", hidden:true}
            ]
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('DocsController', DocsController);
    DocsController.$inject = ['$scope', '$rootScope', '$location','$stateParams'];

  function DocsController($scope, $rootScope, $location,$stateParams) {
    var vm = this;

    // - ramdom number to add to iframe rute to avoid cache
    vm.cache = Math.random();

    if($stateParams.rute == null){
      vm.rute = 'index.html';
    }else {
      var rute = '';
      var hash = '';
      if($stateParams.rute.indexOf('-') != -1){
        var split =$stateParams.rute.split('-');
        rute= split[0];
        hash= '#'+split[1].toLowerCase();
      }else{
        rute= $stateParams.rute;
      }
      switch (rute) {
        case 'transformations':
          vm.rute = 'visuallang/transformations.html'+hash;
          break;
        default:
          vm.rute = 'index.html';
      }
    }
  }
})();

(function () {
    'use strict';

    angular.module("dashboard")
        .directive('riskGrid', ['$filter', '$state', 'translationService', 'WorkspaceFactory', '$rootScope', '$http',
            '$cookies', '$sce', 'Paginator', '$timeout', '$interval', '$httpParamSerializer',
            'timezoneService', 'FileSaver', '$modal', 'toastr', 'EventsFactory',
            function ($filter, $state, $translationService, WorkspaceFactory, $rootScope, $http, $cookies, $sce,
                      Paginator, $timeout, $interval, $httpParamSerializer, $timezoneService, FileSaver, $modal, toastr, EventsFactory) {
                return {
                    scope: {
                        id: "@?",
                        tableCss: "@?",
                        config: "=",
                        fnInit: "=?",
                        fnClick: "=?",
                        fnDblClick: "=?",
                        toExcel: "=?",
                        api: "=?",
                        fnRefresh: "=?",
                        asignacion: "@",
                        selectedItms: "=",
                        withMultipleSelection: "=",
                        fnAddEventsToCase: "=?"
                    },
                    restrict: 'E',
                    replace: 'true',
                    templateUrl: "app/directives/risk-grid.html",
                    link: function (scope, elem, attr) {
                        scope.toExcel = angular.isFunction(scope.toExcel) ? scope.toExcel : false;
                        scope.columnTypes = {};
                        scope.data = [];
                        scope.api = {};
                        scope.pagination = {rule: [1]};
                        scope.visibleColumns = 0;
                        // -- sortableOps
                        scope.sortReverse = false;
                        scope.filters = {};
                        scope.dynamicFilters = {};
                        scope.innerQuery = {};
                        // -- configuraciones para los filtros de la grilla
                        scope.defaultFilters = {
                            filter: []
                        };
                        var existeCheckboxes = false;
                        scope.shouldShowFilters = false;
                        scope.selectedAll = false;

                        // -- Método para realizar traducción
                        $translationService.getTranslation(scope, 'directives');

                        // -- Funciones autocomplete
                        scope.autoKey;
                        scope.querySearch = function (query, key) {
                            console.log(scope.autoKey, key);
                            if (!scope.columnValues || scope.autoKey != key) {
                                scope.autoKey = key;
                                var req = {"columnName": key}
                                return EventsFactory.getAggregationDataKeys(req)
                                    .then(function (res) {
                                        scope.columnValues = res.map(function (e) {
                                            return {value: e.toLowerCase(), text: e};
                                        })
                                        return scope.columnValues;
                                    })
                                    .catch(function (e) {
                                        console.log(e);
                                        return e;
                                    })
                            } else {
                                var results = query ? scope.columnValues.filter(createFilterFor(query)) : scope.columnValues,
                                    deferred;
                                return results;
                            }
                        }

                        function createFilterFor(query) {
                            var lowercaseQuery = angular.lowercase(query);
                            return function filterFn(array) {
                                return (array.value.indexOf(lowercaseQuery) > -1);
                            };
                        }

                        // -- Funciones loader
                        scope.startLoader = function () {
                            scope.loader = {show: true, value: 0};
                            if (!angular.isDefined(scope.loaderTimer)) {
                                scope.loaderTimer = $interval(function () {
                                    scope.loader.value++;
                                    if (scope.loader.value == 100) {
                                        toastr.info($translationService.getTranslationController("Umn... parece que esta tardando más de lo normal.", "Umn ... seems to be taking longer than usual.", 'Umn ... parece estar demorando mais que o normal.'));
                                    }
                                    if (scope.loader.value == 150) {
                                        toastr.warning($translationService.getTranslationController("Procesando grandes cantidades de eventos, por favor espere solo un poco más.", "Processing large amounts of events, please wait just a little longer.", 'Processando grandes quantidades de eventos, aguarde mais um pouco.'));
                                    }
                                }, 100);
                            }
                        }
                        scope.stopLoader = function () {
                            scope.loader.show = false;
                            if (angular.isDefined(scope.loaderTimer)) {
                                $interval.cancel(scope.loaderTimer);
                                scope.loaderTimer = undefined;
                            }
                        }

                        scope.goToRankings = function () {
                            $state.go('app.rankings');
                        }

                        scope.parseNum = function (entrie, col) {
                            if (isNaN(entrie))
                                return entrie;
                            if (col == "id")
                                return $filter('number')(entrie);
                            return $filter('number')((Math.floor(entrie * 100) / 100), 2); // Redondea solo abajo, pedido por oscar y kathy 10-12-18
                        }

                        // -- Constructor
                        scope.fnInit()
                            .then(function (res) {
                                // $rootScope.loading = true;
                                scope.msgLoader = "Loading Data...";
                                scope.startLoader();
                                $rootScope.startLoader();
                                // -- Espacios de trabajo personalizados
                                if (scope.config.schemas) {
                                    scope.config.schemas.sort(function (a, b) {
                                        return (a.id - b.id)
                                    });
                                }

                                // -- Filtros por defecto para iniciar la tabla
                                if (scope.config.datasource.paramsDefault.filterBy) {
                                    scope.filters = angular.copy(scope.config.datasource.paramsDefault.filterBy);
                                    scope.config.datasource.paramsDefault.filterBy = JSON.stringify(scope.config.datasource.paramsDefault.filterBy);
                                    // Mostrar columnas filtradas que no son visibles en el workspace
                                    angular.forEach(scope.filters, function (val, key) {
                                        angular.forEach(scope.config.columns, function (a, b) {
                                            if (!scope.config.columns.filter(function (e) {
                                                return e.type != "object" && e.name == key && e.show == true;
                                            }).length) {
                                                if (a.type != "object" && a.name == key) {
                                                    scope.config.columns[b].show = true;
                                                }
                                            }
                                        })
                                    })

                                }
                                // -- Filtros dinamicos por defecto para iniciar la tabla
                                if (scope.config.datasource.paramsDefault.dynamicFilter.filters) {
                                    angular.forEach(scope.config.datasource.paramsDefault.dynamicFilter.filters, function (value, key) {
                                        angular.forEach(value, function (val, k) {
                                            // Mostrar columnas filtradas que no son visibles en el workspace
                                            angular.forEach(scope.config.columns, function (a, b) {
                                                if (!scope.config.columns.filter(function (e) {
                                                    return e.type == "object" && e.key == k && e.show == true;
                                                }).length) {
                                                    if (a.type == "object" && a.key == k) {
                                                        scope.config.columns[b].show = true;
                                                    }
                                                }
                                            })
                                            // Parsear filtro con formato requerido
                                            scope.config.datasource.paramsDefault.dynamicFilter.filters[key] = {
                                                "field": k,
                                                "operation": "=",
                                                "value": val.query,
                                                "event_body": true
                                            }
                                            scope.dynamicFilters[k] = val;
                                        })
                                    });

                                    // Limpiar los filtros legacy
                                    angular.forEach(scope.filters, function (value, key) {
                                        if (key != "labelName" && key != "ruleName" && scope.filters[key].query) scope.filters[key].query = "";
                                    });
                                }

                                angular.forEach(scope.config.columns, function (value, key) {
                                    // -- construir los filtros segun tipo
                                    if (value.filterable !== undefined) {
                                        console.log(' scope.filters '  +  scope.filters)
                                        console.log('scope.filters[value.name] '  + JSON.stringify( angular.copy(scope.filters[value.name] || {})))
                                        var item = angular.copy(scope.filters[value.name] || {})
                                        scope.filters[value.name] = item;
                                        if (value.filterable.type === "number") {
                                            scope.filters[value.name].min = scope.filters[value.name].min || "";
                                            scope.filters[value.name].max = scope.filters[value.name].max || "";
                                        } else if (value.filterable.type === "string") {
                                            scope.filters[value.name].query = scope.filters[value.name].query || "";
                                        } else if (value.filterable.type === "checkbox") {
                                            existeCheckboxes = true;
                                            scope.innerQuery[value.name] = "";
                                            scope.defaultFilters.filter.push({
                                                name: value.name,
                                                checked: scope.config.filterDatasource.paramsDefault.checked || ""
                                            });
                                        }
                                    }
                                    // -- ultima fila, buscar los filtros checkeados por defecto
                                    if ((scope.config.columns.length - 1) === key) {
                                        /* Servicio para determinar los posibles valores de checkboxes
                                            ** actualmente esta super lento con respecto a los datos que trae
                                            ** fueron declarados los valores en la implementación (filterBy)
                                            ** (Daniel)
                                        */
                                        // if(existeCheckboxes){
                                        //     var resolve = new Promise(function(resolve, reject){
                                        //         $http({
                                        //             url: scope.config.filterDatasource.url,
                                        //             method: "POST",
                                        //             data: scope.defaultFilters.filter,
                                        //             headers: {
                                        //                 token: $cookies.get('token')
                                        //             }
                                        //         })
                                        //         .success(function(response, status, headers){
                                        //             //identificar checkbox por defecto
                                        //             console.log("res", response);
                                        //             if(response && response.filters!==undefined && response.filters.length>0){
                                        //                 $.each(response.filters, function(key, value){
                                        //                     $.each(value.filters, function(keyCheck, valueCheck){
                                        //                         scope.filters[value.name][valueCheck.name] = (valueCheck.checked === "true");
                                        //                     });
                                        //                 });
                                        //             }
                                        //             createWatchFilters();
                                        //         })
                                        //         .error(function(response, status, headers){
                                        //             createWatchFilters();
                                        //             reject(response);
                                        //         });
                                        //     });
                                        // }else{
                                        // createWatchFilters();
                                        // }

                                        scope.autoRefresh = false;
                                        scope.config.datasource.params = scope.config.datasource.params ? scope.config.datasource.params : angular.copy(scope.config.datasource.paramsDefault);
                                        createWatchFilters();
                                        scope.watchTimeout = $timeout(function () {
                                            scope.api.queryFilters();
                                        }, 500);
                                    }
                                });

                                scope.toogleAutoRefresh = function () {
                                    scope.autoRefresh = !scope.autoRefresh;
                                    if (scope.autoRefresh) {
                                        queryREST();
                                        toastr.info("Actualización automática activada");
                                    } else {
                                        if (scope.watchTimeout) {
                                            $timeout.cancel(scope.watchTimeout);
                                            scope.watchTimeout = false;
                                        }
                                        toastr.warning("Actualización automática desactivada");
                                    }
                                }

                                function createWatchFilters() {
                                    scope.$watch("config.columns", function (nval, oval) {
                                        scope.visibleCols = scope.config.columns.filter(function (e) {
                                            return e.show == true
                                        }).length + 1;
                                    }, true);

                                    scope.$watch("filters", function (nval, oval) {
                                        if (nval !== oval) {
                                            // scope.msgLoader = "Loading Data...";
                                            // scope.startLoader();
                                            // $rootScope.startLoader();
                                            scope.config.datasource.params.filterBy = JSON.stringify(nval || "{}");
                                            // if(scope.watchTimeout) $timeout.cancel(scope.watchTimeout);
                                            // scope.watchTimeout = $timeout(function() {
                                            //     scope.api.queryFilters();
                                            // },5000);
                                            // -- Condición para que solo use legacy filter en caso de enviar datos
                                            if (nval.criticality && angular.equals(nval.criticality, oval.criticality)) {
                                                scope.config.datasource.params.dynamicFilter = {};
                                                scope.dynamicFilters = {};
                                            }
                                        }
                                    }, true);

                                    scope.$watch("dynamicFilters", function (nval, oval) {
                                        if (nval !== oval) {
                                            // scope.msgLoader = "Loading Data...";
                                            // scope.startLoader();
                                            // $rootScope.startLoader();
                                            scope.config.datasource.params.dynamicFilter = {"filters": []};
                                            angular.forEach(nval, function (value, key) {
                                                if (value.query) {
                                                    scope.config.datasource.params.dynamicFilter.filters.push(
                                                        {
                                                            "field": key,
                                                            "operation": "=",
                                                            "value": value.query,
                                                            "event_body": true
                                                        }
                                                    )
                                                } else if (value.autocomplete) {
                                                    console.log(value);
                                                    scope.config.datasource.params.dynamicFilter.filters.push(
                                                        {
                                                            "field": key,
                                                            "operation": "=",
                                                            "value": value.autocomplete.value,
                                                            "event_body": true
                                                        }
                                                    )
                                                } else if (angular.isNumber(value.min) || angular.isNumber(value.max)) {
                                                    scope.config.datasource.params.dynamicFilter.filters.push(
                                                        {
                                                            "field": key,
                                                            "event_body": true,
                                                            "type": "number",
                                                            "min": angular.isNumber(value.min) ? value.min : '',
                                                            "max": angular.isNumber(value.max) ? value.max : ''
                                                        }
                                                    )
                                                }
                                            });
                                            // if(scope.watchTimeout) $timeout.cancel(scope.watchTimeout);
                                            // scope.watchTimeout = $timeout(function() {
                                            //     scope.api.queryFilters();
                                            // },5000);

                                            // -- Condición para que solo use dinamic filter en caso de enviar datos
                                            if (scope.config.datasource.params.dynamicFilter.filters.length == 0) {
                                                scope.config.datasource.params.dynamicFilter = {};
                                            }
                                        }
                                    }, true);

                                }

                                scope.search = function () {
                                    scope.config.datasource.params.query = scope.searchCase;
                                    scope.config.datasource.params.page = 1;
                                    queryREST();
                                };

                                scope.searchOnChange = function () {
                                    if (scope.searchCase.searchOnChange == 0) {
                                        queryREST();
                                    }
                                };

                                scope.showFilter = function (query, value) {
                                    if (query !== undefined && query !== "") {
                                        return value.indexOf(query) >= 0 ? true : false;
                                    } else {
                                        return true;
                                    }
                                };

                                scope.sort = function (column) {
                                    // $rootScope.loading = true;
                                    scope.msgLoader = "Loading Data...";
                                    scope.startLoader();
                                    $rootScope.startLoader();
                                    scope.config.datasource.params.sortByDynamicFilter = column.type == 'object' ? true : false;
                                    if (column.sortable) {
                                        scope.config.datasource.params.sort = (!scope.sortReverse) ? "asc" : "desc";
                                        scope.sortReverse = !scope.sortReverse;
                                        scope.config.datasource.params.sortBy = column.type == 'object' ? column.key : column.name;
                                    }
                                    // if(scope.watchTimeout) $timeout.cancel(scope.watchTimeout);
                                    // scope.watchTimeout = $timeout(function() {
                                    scope.api.queryFilters();
                                    // },5000);
                                }

                                scope.checkEvent = function (id) {
                                    if (scope.selectedItms.length > 0  && scope.selectedItms.indexOf(id) !== -1) {
                                        scope.selectedItms.splice(scope.selectedItms.indexOf(id), 1);
                                    } else {
                                        scope.selectedItms.push(id)
                                    }
                                }

                                scope.checkAll = function (selected) {
                                    scope.selectedAll = selected;
                                    scope.selectedItms = [];
                                    angular.forEach(scope.data, function (item) {
                                        if (selected) {
                                            scope.selectedItms.push(item.id);
                                        }
                                        item.selected = selected;
                                    });
                                }

                                // *** COMMON API METHODS *** //
                                // -- Get data currently in grid
                                scope.api.data = function () {
                                    return scope.data;
                                };

                                // *** REST API METHODS *** //
                                scope.api.query = function () {
                                    if (scope.config.datasource.origin === "WS" || scope.config.datasource.origin === "WSS") {
                                        scope.config.datasource.params.token = $cookies.get('token');
                                        scope.websocket.send(JSON.stringify(scope.config.datasource.params));
                                    } else if (scope.config.datasource.origin !== "ARRAY") {
                                        queryREST();
                                    }
                                };

                                // -- Uso solo para filtros, setea una pagina inicial, previo a ir a buscar la data.
                                scope.api.queryFilters = function () {
                                    scope.msgLoader = "Loading Data...";
                                    scope.startLoader();
                                    $rootScope.startLoader();

                                    if (scope.config.datasource.origin === "WS" || scope.config.datasource.origin === "WSS") {
                                        scope.config.datasource.params.page = 1;
                                        scope.config.datasource.params.token = $cookies.get('token');

                                        scope.socketWatcher = $interval(function () {
                                            scope.api.sendMessage();
                                        }, 1000);

                                        scope.api.sendMessage();
                                    } else if (scope.config.datasource.origin !== "ARRAY") {
                                        queryREST();
                                    }
                                };

                                scope.api.sendMessage = function () {
                                    if (scope.websocket !== undefined && scope.websocket.readyState == 1) {
                                        $interval.cancel(scope.socketWatcher);
                                        scope.websocket.send(JSON.stringify(scope.config.datasource.params));
                                    }
                                }

                                scope.api.filter = function (filters) {
                                    // -- Filtros estaticos
                                    scope.config.datasource.params.startDate = filters.startDate;
                                    scope.config.datasource.params.endDate = filters.endDate;

                                    // scope.config.datasource.params = filters || {};
                                    // scope.config.datasource.params.filterBy = JSON.stringify(scope.filters || "{}");
                                    // -- Filtros dinamicos
                                    // scope.config.datasource.params.dynamicFilter = { "filters":[] };
                                    // angular.forEach(scope.dynamicFilters, function(value, key) {
                                    //     if(value.query){
                                    //         scope.config.datasource.params.dynamicFilter.filters.push(
                                    //                 {
                                    //                     "field": key,
                                    //                     "operation": "=",
                                    //                     "value": value.query,
                                    //                     "event_body": true
                                    //                 }
                                    //             )
                                    //         }else if(value.autocomplete){
                                    //             scope.config.datasource.params.dynamicFilter.filters.push(
                                    //                 {
                                    //                     "field": key,
                                    //                     "operation": "=",
                                    //                     "value": value.autocomplete.value,
                                    //                     "event_body": true
                                    //                 }
                                    //             )
                                    //         }else{
                                    //             scope.config.datasource.params.dynamicFilter.filters.push(
                                    //                 {
                                    //                     "field": key,
                                    //                     "event_body": true,
                                    //                     "type": "number",
                                    //                     "min": value.min,
                                    //                     "max": value.max
                                    //                 }
                                    //             )
                                    //         }
                                    // });
                                    scope.api.query();
                                };

                                scope.api.filterExcel = function (filters) {
                                    scope.config.datasource.params = filters || {};
                                    scope.config.datasource.params.filterBy = JSON.stringify(scope.filters || "{}");
                                };

                                // -- Add element to grid
                                scope.api.add = function (item) {
                                    scope.data.unshift(item);
                                    if (scope.data.length >= 10)
                                        scope.data.splice(scope.data.length - 1, 1);
                                    scope.pagination.totalRecords++;
                                    scope.setPaginationRule();
                                    return 0;
                                }

                                //- clean grid data
                                scope.api.deleteAll = function () {
                                    scope.data.remove();
                                }

                                /** INNER API METHODS **/
                                function fieldParser(type, subItem, key) {
                                    var func;
                                    if (type !== undefined) {
                                        switch (type.toUpperCase()) {
                                            case "NUMBER":
                                                func = function (number) {
                                                    return parseInt(number)
                                                };
                                                break;
                                            case "DATE":
                                                func = function (timestamp) {
                                                    return moment.utc(timestamp).tz($timezoneService.zoneTimeUser()).format("YYYY/MM/DD");
                                                };
                                                break
                                            case "TIME":
                                                func = function (timestamp) {
                                                    return moment.utc(timestamp).tz($timezoneService.zoneTimeUser()).format("HH:mm:ss");
                                                };
                                                break
                                            case "DATETIME":
                                                func = function (timestamp) {
                                                    return moment.utc(timestamp).tz($timezoneService.zoneTimeUser()).format("YYYY/MM/DD HH:mm:ss");
                                                };
                                                break
                                            case "ARRAY":
                                                func = function (arr) {
                                                    return (arr && arr.length > 0) ? arr.join(", ") : "";
                                                }
                                                break;
                                            case "OBJECT":
                                                func = function (arr) {
                                                    if (subItem == undefined)
                                                        return arr[key];
                                                    return arr[subItem].filter(function (e) {
                                                        return e.key == key
                                                    }).map(function (e) {
                                                        return e.value
                                                    }).join(", ");
                                                }
                                                break;
                                            case "OBJECT.DATE":
                                                func = function (arr) {
                                                    if (subItem == undefined)
                                                        return moment.utc(arr[key]).tz($timezoneService.zoneTimeUser()).format('DD/MM/YYYY');
                                                    return moment.utc(arr[subItem].filter(function (e) {
                                                        return e.key == key
                                                    }).map(function (e) {
                                                        return e.value
                                                    })[0]).tz($timezoneService.zoneTimeUser()).format('DD/MM/YYYY');
                                                }
                                                break;
                                            case "OBJECT.TIME":
                                                func = function (arr) {
                                                    if (subItem == undefined)
                                                        return moment.utc(arr[key]).tz($timezoneService.zoneTimeUser()).format('HH:mm:ss');
                                                    return moment.utc(arr[subItem].filter(function (e) {
                                                        return e.key == key
                                                    }).map(function (e) {
                                                        return e.value
                                                    })[0]).tz($timezoneService.zoneTimeUser()).format('HH:mm:ss');
                                                }
                                                break;
                                            case "OBJECT.DATETIME":
                                                func = function (arr) {
                                                    if (subItem == undefined)
                                                        return moment.utc(arr[key]).tz($timezoneService.zoneTimeUser()).format('DD/MM/YYYY HH:mm:ss');
                                                    return moment.utc(arr[subItem].filter(function (e) {
                                                        return e.key == key
                                                    }).map(function (e) {
                                                        return e.value
                                                    })[0]).tz($timezoneService.zoneTimeUser()).format('HH:mm:ss');
                                                }
                                                break;
                                            default:
                                                func = function (s) {
                                                    return s
                                                };
                                                break;
                                        }
                                    }
                                    return func;
                                }

                                var queryREST = function (interval) {
                                    if (!interval) {
                                        //$rootScope.loading = true;
                                        scope.msgLoader = "Loading Data...";
                                        scope.startLoader();
                                        $rootScope.startLoader();
                                    }
                                    var resolve = new Promise(function (resolve, reject) {
                                        $http({
                                            url: scope.config.datasource.url,
                                            method: scope.config.datasource.origin,
                                            headers: {
                                                token: $cookies.get('token')
                                            },
                                            data: (scope.config.datasource.origin == "POST" ? scope.config.datasource.params : scope.config.datasource.data)
                                        })
                                            .success(function (response) {
                                                scope.data = parseResponse(response[scope.config.datasource.paramsOut.data]);
                                                console.log('ENTRA ' + scope.selectedAll)
                                                if (scope.selectedAll) {
                                                    console.log('ENTRA1')
                                                    angular.forEach(scope.data, function (item) {
                                                        scope.selectedItms.push(item.id);
                                                        item.selected = true;
                                                    });
                                                }

                                                scope.pagination = response[scope.config.datasource.paramsOut.pagination];
                                                scope.setPaginationRule();
                                                if (scope.pagination.totalRecords > 0 && (Math.floor(scope.pagination.totalRecords / scope.pagination.itemsPerPage) + 1) < scope.config.datasource.params.page) {
                                                    // Si no hay datos en la pagina va a la última pag posible
                                                    scope.config.datasource.params.page = Math.floor(scope.pagination.totalRecords / scope.pagination.itemsPerPage);
                                                    scope.config.datasource.params.page = scope.config.datasource.params.page == 0 ? 1 : scope.config.datasource.params.page;
                                                    queryREST();
                                                } else {
                                                    if (scope.autoRefresh) {
                                                        if (scope.watchTimeout && !scope.watchTimeout.$$state.status) {
                                                            // console.log("Programado");
                                                            // console.log(scope.watchTimeout);
                                                        } else {
                                                            scope.watchTimeout = $timeout(function () {
                                                                queryREST(true);
                                                            }, 60000); // 600000
                                                        }
                                                    }
                                                    // $rootScope.loading = false;

                                                    scope.msgLoader = $translationService.getTranslationController("No hay datos para mostrar",
                                                        'There is no data to display',
                                                        'Não há dados para exibir');
                                                    scope.stopLoader();
                                                    $rootScope.stopLoader();
                                                }
                                                resolve();
                                            })
                                            .error(function (response, status, headers) {
                                                scope.autoRefresh = false;
                                                // $rootScope.loading = false;
                                                scope.msgLoader = $translationService.getTranslationController("No hay datos para mostrar",
                                                    'There is no data to display',
                                                    'Não há dados para exibir');
                                                scope.stopLoader();
                                                $rootScope.stopLoader();
                                                reject(response);
                                            });
                                    });
                                }

                                // -- Refresh method
                                if (scope.fnRefresh !== undefined && scope.fnRefresh !== null) {
                                    scope.fnRefresh = scope.api.query;
                                }

                                function correctSummary(summary) {
                                    var res = [];
                                    summary.forEach(function (e) {
                                        var timestamp = moment(e.creationDate);
                                        res.push({
                                            id: e.caseId,
                                            titulo: e.title,
                                            descripcion: e.description,
                                            estado: e.state,
                                            fecha: timestamp.format('DD/MM/YYYY'),
                                            hora: timestamp.format('HH:mm:ss'),
                                            criticidad: e.criticality,
                                            usuario: e.user.name,
                                            userId: e.user.userId
                                        });
                                    });
                                    return res;
                                };

                                function parseResponse(data) {
                                    var res = [];
                                    angular.forEach(data, function (row) {
                                        var parsedRow = {};
                                        for (var key in scope.columnTypes) {
                                            if (scope.columnTypes[key].type === "html") {
                                                for (var key in scope.config.columns) {
                                                    if (scope.config.columns[key].name === key) {
                                                        //buscar una forma de transformar el string html en html
                                                        row[key] = scope.config.columns[key].html;
                                                    }
                                                }
                                            }
                                        }

                                        // parse data by column type, can throw errors
                                        for (var key in scope.columnTypes) {
                                            var parser = scope.columnTypes[key];
                                            parsedRow[key] = (parser) ? parser.call(row[parser.col]) : row[parser.col];
                                        }

                                        res.push(parsedRow);
                                    });
                                    return res;
                                };

                                /** Asignar **/
                                scope.asignarCaso = function () {
                                    console.log("asignar")
                                };

                                /*Export to excel*/
                                scope.exportExcel = function () {
                                    var excel = scope.toExcel();
                                    if (excel) {
                                        scope.api.downloadExcel(excel.filename, excel.data);
                                    }
                                };

                                scope.api.downloadExcel = function (fileName, data) {
                                    function datenum(v, date1904) {
                                        if (date1904) v += 1462;
                                        var epoch = Date.parse(v);
                                        return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
                                    };

                                    function getSheet(data, opts) {
                                        var ws = {};
                                        var range = {s: {c: 10000000, r: 10000000}, e: {c: 0, r: 0}};
                                        for (var R = 0; R != data.length; ++R) {
                                            for (var C = 0; C != data[R].length; ++C) {
                                                if (range.s.r > R) range.s.r = R;
                                                if (range.s.c > C) range.s.c = C;
                                                if (range.e.r < R) range.e.r = R;
                                                if (range.e.c < C) range.e.c = C;
                                                var cell = {v: data[R][C]};
                                                if (cell.v == null) continue;
                                                var cell_ref = XLSX.utils.encode_cell({c: C, r: R});

                                                if (typeof cell.v === 'number') cell.t = 'n';
                                                else if (typeof cell.v === 'boolean') cell.t = 'b';
                                                else if (cell.v instanceof Date) {
                                                    cell.t = 'n';
                                                    cell.z = XLSX.SSF._table[14];
                                                    cell.v = datenum(cell.v);
                                                } else cell.t = 's';

                                                ws[cell_ref] = cell;
                                            }
                                        }
                                        if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
                                        return ws;
                                    };

                                    function Workbook() {
                                        if (!(this instanceof Workbook)) return new Workbook();
                                        this.SheetNames = [];
                                        this.Sheets = {};
                                    }

                                    var wb = new Workbook(), ws = getSheet(data);
                                    /* add worksheet to workbook */
                                    wb.SheetNames.push(fileName);
                                    wb.Sheets[fileName] = ws;
                                    var wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'binary'});

                                    function s2ab(s) {
                                        var buf = new ArrayBuffer(s.length);
                                        var view = new Uint8Array(buf);
                                        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                                        return buf;
                                    }

                                    FileSaver.saveAs(new Blob([s2ab(wbout)], {type: "application/octet-stream"}), fileName + '.xlsx');
                                };

                                /*Pagination*/
                                scope.setPaginationRule = function () {
                                    scope.pagination.rule = Paginator.getPagesWindow(scope.pagination.totalRecords, scope.config.datasource.params.itemsPerPage, scope.config.datasource.params.page);
                                };

                                scope.goToPage = function (destiny) {
                                    var totalPages = Math.ceil(scope.pagination.totalRecords / scope.config.datasource.params.itemsPerPage) - 1;
                                    switch (destiny) {
                                        case 'start':
                                            scope.config.datasource.params.page = 1;
                                            break;
                                        case 'end':
                                            scope.config.datasource.params.page = totalPages;
                                            break;
                                        case '1more':
                                            scope.config.datasource.params.page++;
                                            break;
                                        case '1less':
                                            scope.config.datasource.params.page--;
                                            break;
                                        default:
                                            scope.config.datasource.params.page = destiny;
                                    }
                                    scope.api.query();
                                };

                                scope.showLessArrow = function () {
                                    return scope.pagination.rule.length > 1 && scope.pagination.rule[0] != 1;
                                };

                                scope.showMoreArrow = function () {
                                    return scope.pagination.rule.length > 1 && scope.pagination.rule[scope.pagination.rule.length - 1] != Math.ceil(scope.pagination.totalRecords / scope.config.datasource.params.itemsPerPage);
                                };

                                scope.openFilters = function () {
                                    var modalFiltros = $modal({
                                        templateUrl: 'app/directives/modal-workspaces.html',
                                        backdrop: true,
                                        size: 'md',
                                        scope: scope,
                                        keyboard: false,
                                        show: true
                                    });
                                };

                                scope.setDefaultSchema = function () {
                                    angular.forEach(scope.config.columns, function (value, key) {
                                        scope.config.columns[key].show = value.default ? true : false;
                                    });
                                };

                                scope.saveSchema = function (schema) {
                                    schema.workspaceSchema = scope.config.columns.map(function (e) {
                                        return {
                                            "rule": e.rule ? e.rule : "",
                                            "key": e.key,
                                            "col": e.col,
                                            "name": e.name,
                                            "title": e.title,
                                            "show": e.show
                                        }
                                    });
                                    if (schema.id) {
                                        WorkspaceFactory.setWorkspace(schema)
                                            .then(function (res) {
                                                if (res == 200) {
                                                    toastr.success("Cambios Guardados");
                                                } else {
                                                    toastr.error("Se ha producido un error");
                                                }
                                            })
                                            .catch(function (err) {
                                                console.log("Error@setWorkspaces");
                                            });
                                    } else {
                                        WorkspaceFactory.createWorkspace(schema)
                                            .then(function (res) {
                                                if (res == 200) {
                                                    toastr.success("Cambios Guardados");
                                                } else {
                                                    toastr.error("Se ha producido un error");
                                                }
                                            })
                                            .catch(function (err) {
                                                console.log("Error@createWorkspace");
                                            });
                                    }
                                }

                                scope.addWorkspace = function (title, view) {
                                    view = view || title + " Content View";
                                    var newSchema = angular.copy(scope.config.schemas[0]);
                                    newSchema.id = null;
                                    newSchema.workspaceName = "new";
                                    scope.config.schemas.push(newSchema);
                                };

                                // *** WEBSOCKET CONFIG *** //
                                if (scope.config && scope.config.datasource && (scope.config.datasource.origin === 'WS' || scope.config.datasource.origin === 'WSS')) {
                                    scope.close = false;
                                    scope.start = function () {
                                        var url = scope.config.datasource.url;
                                        var ws = scope.config.datasource.origin === 'WS' ? "ws://" + url : "wss://" + url;
                                        var webSocket = new WebSocket(ws);
                                        scope.config.datasource.params = scope.config.datasource.params || scope.config.datasource.paramsDefault;
                                        scope.config.datasource.params.token = $cookies.get('token');

                                        webSocket.onopen = function (message) {
                                            console.log("Websocket: Comunicacion iniciada");
                                            //se utiliza para esperar la construccion de los filtros asociados a la grilla
                                            if (scope.config.datasource.autoLoad === true) {
                                                webSocket.send(JSON.stringify(scope.config.datasource.params));
                                            }
                                        };

                                        webSocket.onerror = function (err) {
                                            console.log("Websocket error:");
                                            console.log(err);
                                        };

                                        // -- Mensaje Recibido
                                        webSocket.onmessage = function (message) {
                                            var data = {};
                                            try {
                                                data = JSON.parse(message.data);
                                            } catch (err) {
                                            }

                                            if (data !== undefined) {
                                                scope.data = parseResponse(data[scope.config.datasource.paramsOut.data]);
                                                scope.pagination = data[scope.config.datasource.paramsOut.pagination];
                                                scope.setPaginationRule();
                                                scope.$apply();
                                            }
                                        };

                                        // -- Renovar la conexion cada 60 segundos
                                        scope.interval = $interval(function () {
                                            webSocket.send(JSON.stringify(scope.config.datasource.params));
                                        }, 1000 * 60);

                                        // -- Conexion cerrada
                                        webSocket.onclose = function (message) {
                                            console.log("Conexión perdida");
                                            $interval.cancel(scope.interval);
                                            if (scope.close == false) {
                                                $timeout(function () {
                                                    console.log("Reanudando conexión");
                                                    scope.websocket = scope.start();
                                                }, 2000);
                                            }
                                        };
                                        return webSocket;
                                    };

                                    // -- Inicia el Websocket
                                    scope.websocket = scope.start();

                                    // -- Cierra el WebSocket al destruir
                                    scope.$on('$destroy', function () {
                                        console.log("Websocket: Comunicacion cerrada");
                                        scope.close = true;
                                        scope.websocket.onclose("exit");
                                        $interval.cancel(scope.interval);
                                    });
                                }

                                scope.$on('$destroy', function () {
                                    scope.autoRefresh = false;
                                });

                                // *** Configuración Inicial *** //
                                if (scope.config) {
                                    // -- Identify parsers for each column of the grid
                                    scope.visibleColumns = 0;
                                    scope.config.columns.forEach(function (c) {
                                        if (c.col) {
                                            scope.columnTypes[c.name] = {
                                                type: c.type,
                                                col: c.col,
                                                call: fieldParser(c.type, c.subItem, c.key)
                                            };
                                        } else {
                                            scope.columnTypes[c.name] = {
                                                type: c.type,
                                                col: c.name,
                                                call: fieldParser(c.type, c.subItem, c.key)
                                            };
                                        }
                                        if (!c.hidden)
                                            scope.visibleColumns++;
                                    });

                                    if (scope.config.datasource.autoLoad === true) {
                                        scope.api.filter(scope.config.datasource.paramsDefault);
                                    }
                                }
                            });

                        $rootScope.$on('riskGridCleanSelection', function () {
                            angular.forEach(scope.data, function (item) {
                                item.selected = false;
                            });
                        });
                    }
                };
            }]);
})();

(function() {
    'use strict';

    angular.module("dashboard")
        .directive('riskGridLegacy',['translationService', '$rootScope', '$http', '$cookies', '$sce', 'Paginator', '$timeout', '$interval', '$httpParamSerializer', 'FileSaver', 'timezoneService',
            function ($translationService, $rootScope, $http, $cookies, $sce, Paginator, $timeout, $interval, $httpParamSerializer, FileSaver, $timezoneService) {
        return {
            scope:{
                id: "@?",
                tableCss: "@?",
                config: "=",
                fnClick: "=?",
                fnDblClick: "=?",
                toExcel : "=?",
                api: "=?",
                fnRefresh: "=?",
                asignacion: "@",
                selectedItms: "="
            },
            restrict: 'E',
            replace: 'true',
            templateUrl: "app/directives/risk-grid-legacy.html",
            link: function (scope, elem, attr) {
                scope.toExcel = angular.isFunction(scope.toExcel) ? scope.toExcel : false;
                scope.columnTypes = {};
                scope.data = [];
                scope.api = {};
                scope.pagination = {rule: [1]};
                scope.visibleColumns = 0;
                // -- sortableOps
                scope.sortReverse  = false;
                scope.filters = {};
                scope.innerQuery = {};
                // -- configuraciones para los filtros de la grilla
                scope.defaultFilters = {
                    filter:[]
                };

                var existeCheckboxes = false;

                // CABLE PARA PRUEBA UAT SOLO LISTAR EVENTOS TIPO ALERTA
                // if(scope.id == 'alertas'){
                //     scope.filters = {"labelName": {"query":"alerta"} };
                // }
                
                // Filtros por defecto para iniciar la tabla
                if(scope.config.datasource.paramsDefault.filterBy){
                    scope.filters = scope.config.datasource.paramsDefault.filterBy;
                }
                
                $.each(scope.config.columns, function(key, value){
                    //construir los filtros segun tipo
                    if(value.filterable !== undefined){
                        scope.filters[value.name] = {};
                        if(value.filterable.type === "number"){
                            scope.filters[value.name].min = "";
                            scope.filters[value.name].max = "";
                        }else if(value.filterable.type === "string"){
                            scope.filters[value.name].query = "";
                        }else if(value.filterable.type === "checkbox"){
                            existeCheckboxes = true;
                            scope.innerQuery[value.name] = "";
                            scope.defaultFilters.filter.push({name : value.name, checked: scope.config.filterDatasource.paramsDefault.checked || "" });
                        }
                    }
                    //ultima fila, buscar los filtros checkeados por defecto
                    if(scope.config.columns.length-1 === key){
                        if(existeCheckboxes){
                            var resolve = new Promise(function(resolve, reject){
                                $http({
                                    url: scope.config.filterDatasource.url,
                                    method: "POST",
                                    data: scope.defaultFilters.filter,
                                })
                                .success(function(response, status, headers){
                                    //identificar checkbox por defecto
                                    if(response && response.filters!==undefined && response.filters.length>0){
                                        $.each(response.filters, function(key, value){
                                            $.each(value.filters, function(keyCheck, valueCheck){
                                                scope.filters[value.name][valueCheck.name] = (valueCheck.checked==="true");
                                            });
                                        });
                                    }
                                    createWatchFilters();
                                })
                                .error(function(response, status, headers){
                                    createWatchFilters();
                                    reject(response);
                                });
                            });
                        }else{
                            createWatchFilters();
                        }
                    }
                });

                //Método para realizar traducción
                $translationService.getTranslation(scope, 'directives');

                function createWatchFilters(){
                    scope.$watch("filters", function(nval, oval){
                        if(nval){
                            scope.config.datasource.params.filterBy = JSON.stringify(nval || "{}");
                            scope.api.queryFilters();
                        }
                    }, true);
                }
                
                scope.search = function() {
                    scope.config.datasource.params.query = scope.searchCase;
                    scope.config.datasource.params.page = 1;
                    queryREST();
                };
                
                scope.searchOnChange = function() {
                    if(scope.searchCase.length == 0) {
                      queryREST();
                    }
                };

                scope.showFilter = function(query, value){
                    if(query!==undefined && query!==""){
                        if(value.indexOf(query)>=0){
                            return true;
                        }else{
                            return false;
                        }
                    }else{
                        return true;
                    }
                };

                scope.sort = function(column){
                    if(column.sortable){
                        scope.config.datasource.params.sort = (!scope.sortReverse) ? "asc" : "desc";
                        scope.sortReverse = !scope.sortReverse;
                        scope.config.datasource.params.sortBy = column.name;
                    }
                    scope.api.query();
                }
                
                scope.checkEvent = function(id) {
                    if (scope.selectedItms.indexOf(id) !== -1) {
                        scope.selectedItms.splice(scope.selectedItms.indexOf(id), 1);
                    }else {
                        scope.selectedItms.push(id)
                    }
                    // console.log(scope.selectedItms)
                }

                // *** COMMON API METHODS *** //
                // -- Get data currently in grid
                scope.api.data = function(){
                    return scope.data;
                };

                // *** REST API METHODS *** //
                scope.api.query = function(){
                    if(scope.config.datasource.origin === "WS" || scope.config.datasource.origin === "WSS"){
                        scope.config.datasource.params.token = $cookies.get('token');
                        scope.websocket.send(JSON.stringify(scope.config.datasource.params));
                    }else if(scope.config.datasource.origin !== "ARRAY"){
                        queryREST();
                    }
                };

                //Uso solo para filtros, setea una pagina inicial, previo a ir a buscar la data.
                scope.api.queryFilters = function(){
                    if(scope.config.datasource.origin === "WS" || scope.config.datasource.origin === "WSS"){            
                        scope.config.datasource.params.page=1;
                        scope.config.datasource.params.token = $cookies.get('token');
                        
                        scope.socketWatcher = $interval(function () {
                            scope.api.sendMessage();
                        }, 1000);
                        
                        scope.api.sendMessage();
                    }else if(scope.config.datasource.origin!=="ARRAY"){
                        queryREST();
                    }
                };

                scope.api.sendMessage = function(){
                    if(scope.websocket!==undefined && scope.websocket.readyState==1){
                      $interval.cancel(scope.socketWatcher);
                      scope.websocket.send(JSON.stringify(scope.config.datasource.params));
                    }
                }

                scope.api.filter = function(filters){
                    scope.config.datasource.params = filters || {};
                    scope.config.datasource.params.filterBy = JSON.stringify(scope.filters || "{}");
                    scope.api.query();
                };

                scope.api.filterExcel = function(filters){
                    scope.config.datasource.params = filters || {};
                    scope.config.datasource.params.filterBy = JSON.stringify(scope.filters || "{}");                    
                };

                // -- Add element to grid
                scope.api.add = function(item){
                    // console.log(item);
                    
                    scope.data.unshift(item);
                    if(scope.data.length >= 10) 
                        scope.data.splice(scope.data.length - 1, 1);
                    scope.pagination.totalRecords++;
                    scope.setPaginationRule();
                    return 0;

                    // console.log(Object.keys(item).length, scope.config.columns.length);
                    
                    // if(item && Object.keys(item).length === scope.config.columns.length){
                    //     scope.data.add(item);
                    //     return 0;
                    // }else{
                    //     console.error("Can't add the item, missing columns");
                    //     return -1;
                    // }
                }

                //clean grid data
                scope.api.deleteAll = function(){
                    scope.data.remove();
                }
                 
                /*INNER API METHODS*/
                function fieldParser(type, subItem, key){
                    var func;
                    if (type !== undefined) {
                        switch (type.toUpperCase()){
                            case "NUMBER":
                                func = function(number){
                                        return parseInt(number)
                                    };
                                break;
                            case "DATE":
                                func = function(timestamp){
                                        return moment.utc(timestamp).tz($timezoneService.zoneTimeUser()).format("YYYY/MM/DD");
                                    };
                                break
                            case "TIME":
                                func = function(timestamp){
                                        return moment.utc(timestamp).tz($timezoneService.zoneTimeUser()).format("HH:mm:ss");
                                    };
                                break
                            case "DATETIME":
                                func = function(timestamp){
                                        return moment.utc(timestamp).tz($timezoneService.zoneTimeUser()).format("YYYY/MM/DD HH:mm:ss");
                                    };
                                break
                            case "ARRAY":
                                func = function(arr){
                                    return (arr && arr.length > 0) ? arr.join(", ") : "";
                                }
                                break;
                            case "OBJECT":
                                func = function(arr){
                                    if(subItem == undefined)
                                        return arr[key];
                                    return arr[subItem].filter(function(e){ return e.key == key }).map(function(e){ return e.value }).join(", ");
                                }
                                break;
                            case "OBJECT.DATE":
                                func = function(arr){
                                    if(subItem == undefined)
                                        return moment.utc(arr[key]).tz($timezoneService.zoneTimeUser()).format("YYYY/MM/DD");
                                    return moment.utc(arr[subItem].filter(function(e){ return e.key == key }).map(function(e){ return e.value })[0]).tz($timezoneService.zoneTimeUser()).format('DD/MM/YYYY');
                                }
                                break;
                            case "OBJECT.TIME":
                                func = function(arr){
                                    if(subItem == undefined)
                                        return moment.utc(arr[key]).tz($timezoneService.zoneTimeUser()).format('HH:mm:ss');
                                    return moment.utc(arr[subItem].filter(function(e){ return e.key == key }).map(function(e){ return e.value })[0]).tz($timezoneService.zoneTimeUser()).format('HH:mm:ss');
                                }
                                break;
                            case "OBJECT.DATETIME":
                                func = function(arr){
                                    if(subItem == undefined)
                                        return moment.utc(arr[key]).tz($timezoneService.zoneTimeUser()).format('DD/MM/YYYY HH:mm:ss');
                                    return moment.utc(arr[subItem].filter(function(e){ return e.key == key }).map(function(e){ return e.value })[0]).tz($timezoneService.zoneTimeUser()).format('HH:mm:ss');
                                }
                                break;
                            default:
                                func = function(s){return s};
                                break;
                        }
                    }
                    return func;
                }

                var queryREST = function(){
                    // console.log("queryREST");
                    // console.log(scope.config.datasource.params);
                    var resolve = new Promise(function(resolve, reject){
                        $http({
                            url: scope.config.datasource.url,
                            method: scope.config.datasource.origin,
                            params: scope.config.datasource.params,
                            headers: {
                                token: $cookies.get('token'),
                            },
                            data: scope.config.datasource.data,
                        })
                        .success(function(response, status, headers){
                            scope.data = parseResponse(response[scope.config.datasource.paramsOut.data]);
                            
                            // if (scope.config.datasource.paramsOut.data === 'cases') {
                                // scope.data = correctSummary(scope.data);
                            // }
                            
                            scope.pagination = response[scope.config.datasource.paramsOut.pagination];
                            scope.setPaginationRule();
                            $rootScope.loading = false;
                            resolve();
                        })
                        .error(function(response, status, headers){
                            $rootScope.loading = false;
                            reject(response);
                        });
                    });

                }
                
                // -- Refresh method
                if(scope.fnRefresh !== undefined && scope.fnRefresh !== null){
                    scope.fnRefresh = scope.api.query;
                }
                
                function correctSummary(summary) {
                    var res = [];
                    summary.forEach(function (e) {
                        var timestamp = moment(e.creationDate);
                        res.push({
                            id: e.caseId,
                            titulo: e.title,
                            descripcion: e.description,
                            estado: e.state,
                            fecha: timestamp.format('DD/MM/YYYY'),
                            hora: timestamp.format('HH:mm:ss'),
                            criticidad: e.criticality,
                            usuario: e.user.name,
                            userId: e.user.userId
                        });
                    });
                    return res;
                };

                function parseResponse(data){
                    var res = [];
                    angular.forEach(data, function(row) {
                        var parsedRow = {};

                        for(var key in scope.columnTypes){
                            if(scope.columnTypes[key].type === "html"){
                                for(var key in scope.config.columns){
                                    if(scope.config.columns[key].name === key){
                                        //buscar una forma de transformar el string html en html
                                        row[key] = scope.config.columns[key].html;
                                    }
                                }
                            }
                        }
                        
                        // parse data by column type, can throw errors
                        // for(var key in row){
                        //     var parser = scope.columnTypes[key];
                        //     parsedRow[key] = (parser) ? parser.call(row[key]) : row[key];
                        // }

                        for(var key in scope.columnTypes){
                            var parser = scope.columnTypes[key];
                            parsedRow[key] = (parser) ? parser.call(row[parser.col]) : row[parser.col];
                        }

                        res.push(parsedRow);
                    });
                    return res;
                };
                
                /*Asignar*/
                scope.asignarCaso = function(){
                  console.log("asignar")
                };

                /*Export to excel*/
                scope.exportExcel = function(){
                  var excel = scope.toExcel();
                  if(excel){
                      scope.api.downloadExcel(excel.filename, excel.data);
                  }
                };
                scope.api.downloadExcel = function(fileName, data) {

                    function datenum(v, date1904) {
                        if(date1904) v+=1462;
                        var epoch = Date.parse(v);
                        return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
                    };

                    function getSheet(data, opts) {
                        var ws = {};
                        var range = {s: {c:10000000, r:10000000}, e: {c:0, r:0 }};
                        for(var R = 0; R != data.length; ++R) {
                            for(var C = 0; C != data[R].length; ++C) {
                                if(range.s.r > R) range.s.r = R;
                                if(range.s.c > C) range.s.c = C;
                                if(range.e.r < R) range.e.r = R;
                                if(range.e.c < C) range.e.c = C;
                                var cell = {v: data[R][C] };
                                if(cell.v == null) continue;
                                var cell_ref = XLSX.utils.encode_cell({c:C,r:R});

                                if(typeof cell.v === 'number') cell.t = 'n';
                                else if(typeof cell.v === 'boolean') cell.t = 'b';
                                else if(cell.v instanceof Date) {
                                    cell.t = 'n'; cell.z = XLSX.SSF._table[14];
                                    cell.v = datenum(cell.v);
                                }
                                else cell.t = 's';

                                ws[cell_ref] = cell;
                            }
                        }
                        if(range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
                        return ws;
                    };

                    function Workbook() {
                        if(!(this instanceof Workbook)) return new Workbook();
                        this.SheetNames = [];
                        this.Sheets = {};
                    }

                    var wb = new Workbook(), ws = getSheet(data);
                    /* add worksheet to workbook */
                    wb.SheetNames.push(fileName);
                    wb.Sheets[fileName] = ws;
                    var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'});

                    function s2ab(s) {
                        var buf = new ArrayBuffer(s.length);
                        var view = new Uint8Array(buf);
                        for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                        return buf;
                    }

                    FileSaver.saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), fileName+'.xlsx');
                };

                /*Pagination*/
                scope.setPaginationRule = function() {
                    scope.pagination.rule = Paginator.getPagesWindow(scope.pagination.totalRecords, scope.config.datasource.params.itemsPerPage, scope.config.datasource.params.page);
                };

                scope.goToPage = function(destiny) {
                    var totalPages = Math.ceil(scope.pagination.totalRecords/scope.config.datasource.params.itemsPerPage) - 1;
                    switch (destiny) {
                        case 'start':
                            scope.config.datasource.params.page = 1;
                            break;
                        case 'end':
                            scope.config.datasource.params.page = totalPages;
                            break;
                        case '1more':
                            scope.config.datasource.params.page++;
                            break;
                        case '1less':
                            scope.config.datasource.params.page--;
                            break;
                        default:
                            scope.config.datasource.params.page = destiny;
                    }
                    scope.api.query();
                };

                scope.showLessArrow = function() {
                    return scope.pagination.rule.length > 1 && scope.pagination.rule[0] != 1;
                };

                scope.showMoreArrow = function() {
                    return scope.pagination.rule.length > 1 && scope.pagination.rule[scope.pagination.rule.length-1] != Math.ceil(scope.pagination.totalRecords/scope.config.datasource.params.itemsPerPage);
                };

                // *** WEBSOCKET CONFIG *** //
                if(scope.config && scope.config.datasource && (scope.config.datasource.origin === 'WS' || scope.config.datasource.origin === 'WSS')){
                    scope.close = false;
                    scope.start = function() {
                        var url = scope.config.datasource.url;
                        var ws = "";
                        if(scope.config.datasource.origin === 'WS')
                            ws = "ws://"+url;
                        else
                            ws = "wss://"+url;

                        var webSocket = new WebSocket(ws);
                        scope.config.datasource.params = scope.config.datasource.params || scope.config.datasource.paramsDefault;
                        scope.config.datasource.params.token = $cookies.get('token');

                        webSocket.onopen = function(message){
                            console.log("Websocket: Comunicacion iniciada");
                            //se utiliza para esperar la construccion de los filtros asociados a la grilla
                            // if(scope.config.datasource.autoLoad === true) {
                                // webSocket.send(JSON.stringify(scope.config.datasource.params));
                            // }
                        };

                        webSocket.onerror = function(err){
                            console.log("Websocket error:");
                            console.log(err);
                        };

                        // -- Mensaje Recibido
                        webSocket.onmessage = function(message){
                            var data = {};
                            try { data = JSON.parse(message.data); }
                            catch(err) {}

                            if (data!== undefined) {
                                scope.data = parseResponse(data[scope.config.datasource.paramsOut.data]);
                                scope.pagination = data[scope.config.datasource.paramsOut.pagination];
                                scope.setPaginationRule();
                                scope.$apply();
                            }
                        };
                        
                        // -- Renovar la conexion cada 60 segundos
                        scope.interval = $interval(function(){
                            webSocket.send(JSON.stringify(scope.config.datasource.params));
                        }, 1000 * 60);

                        // -- Conexion cerrada
                        webSocket.onclose = function(message){
                            console.log("Conexión perdida");
                            $interval.cancel(scope.interval);
                            if (scope.close==false) {
                                $timeout(function() {
                                    console.log("Reanudando conexión");
                                    scope.websocket = scope.start();
                                }, 5000);
                            }
                        };
                        return webSocket;
                    };

                    // -- Inicia el Websocket
                    scope.websocket = scope.start();

                    // -- Cierra el WebSocket al destruir
                    scope.$on('$destroy', function() {
                        console.log("Websocket: Comunicacion cerrada");
                        scope.close=true;
                        scope.websocket.onclose("exit");
                        $interval.cancel(scope.interval);
                    });
                }

                // *** INIT CONFIG *** //
                if(scope.config){
                    // -- Identify parsers for each column of the grid
                    scope.visibleColumns = 0;
                    scope.config.columns.forEach(function(c){
                        if(c.col){
                            scope.columnTypes[c.name] = {type:c.type, col:c.col, call: fieldParser(c.type, c.subItem, c.key)};
                        }else{
                            scope.columnTypes[c.name] = {type:c.type, col:c.name, call: fieldParser(c.type, c.subItem, c.key)};    
                        }
                        if(!c.hidden)
                            scope.visibleColumns++;
                    });

                    if(scope.config.datasource.autoLoad===true){
                        scope.api.filter(scope.config.datasource.paramsDefault);
                    }
                }
            }
        };
    }]);
})();

(function() {
    'use strict';

    angular.module("dashboard")
        .directive('riskDatatable', function ($http, $cookies, $sce, Paginator,$timeout, $interval, $httpParamSerializer) {
        return {
            scope:{
                id: "@?",
                tableCss: "@?",
                config: "=",
                fnClick: "=?",
                fnDblClick: "=?",
                toExcel : "=?",
                api: "=?",
                selected: "="
            },
            restrict: 'E',
            replace: 'true',
            templateUrl: "app/directives/risk-datatable.html",
            link: function (scope, elem, attr) {
                scope.columnTypes = {};
                scope.data = [];
                scope.api = {};
                scope.pagination = {rule: [1]};
                scope.visibleColumns = 0;
                //sortableOps
                scope.sortReverse  = false;
                scope.filters = {};
                scope.innerQuery = {};

                //configuraciones para los filtros de la grilla
                scope.defaultFilters = {
                    filter:[]
                };
                var existeCheckboxes = false;
                $.each(scope.config.columns, function(key, value){
                    //construir los filtros segun tipo
                    if(value.filterable!==undefined){
                        scope.filters[value.name] = {};
                        if(value.filterable.type==="number"){
                            scope.filters[value.name].min = "";
                            scope.filters[value.name].max = "";
                        }else if(value.filterable.type==="string"){
                            scope.filters[value.name].query = "";
                        }else if(value.filterable.type==="checkbox"){
                            existeCheckboxes = true;
                            scope.innerQuery[value.name]= "";
                            scope.defaultFilters.filter.push({name : value.name, checked: scope.config.filterDatasource.paramsDefault.checked || "" });
                        }
                    }
                    //ultima fila, buscar los filtros checkeados por defecto
                    if(scope.config.columns.length-1 === key){
                        if(existeCheckboxes){
                            var resolve = new Promise(function(resolve, reject){
                                $http({
                                    url: scope.config.filterDatasource.url,
                                    method: "POST",
                                    data: scope.defaultFilters.filter,
                                    headers: {
                                        token: $cookies.get('token')
                                    }
                                })
                                    .success(function(response, status, headers){
                                        //identificar checkbox por defecto
                                        if(response && response.filters!==undefined && response.filters.length>0){
                                            $.each(response.filters, function(key, value){
                                                $.each(value.filters, function(keyCheck, valueCheck){
                                                    scope.filters[value.name][valueCheck.name] = (valueCheck.checked==="true");
                                                });
                                            });
                                        }
                                        createWatchFilters();
                                    })
                                    .error(function(response, status, headers){
                                        createWatchFilters();
                                        reject(response);
                                    });
                            });
                        }else{
                            createWatchFilters();
                        }
                    }
                });

                function createWatchFilters(){
                    scope.$watch("filters", function(nval, oval){
                        if(nval){
                            scope.config.datasource.params.filterBy = JSON.stringify(nval || "{}");
                            scope.api.queryFilters();
                        }
                    },true);
                }

                scope.showFilter = function(query, value){
                    if(query!==undefined && query!==""){
                        if(value.indexOf(query)>=0){
                            return true;
                        }else{
                            return false;
                        }
                    }else{
                        return true;
                    }
                };

                scope.sort = function(column){
                    if(column.sortable){
                        scope.config.datasource.params.sort = (!scope.sortReverse) ? "asc" : "desc";
                        scope.sortReverse = !scope.sortReverse;
                        scope.config.datasource.params.sortBy = column.name;
                    }
                    scope.api.query();
                }
                
                scope.checkEvent = function(id) {
                    if (scope.selected.indexOf(id) !== -1) {
                        delete scope.selected[scope.selected.indexOf(id)];
                    }
                    else {
                        scope.selected.push(id)
                    }
                    
                    console.log(scope.selected)
                }

                /*COMMON API METHODS*/
                //Get data currently in grid
                scope.api.data = function(){
                    return scope.data;
                };


                /*REST API METHODS*/
                scope.api.query = function(){
                    if(scope.config.datasource.origin==="WS" || scope.config.datasource.origin==="WSS"){
                        scope.config.datasource.params.token = $cookies.get('token');
                        scope.websocket.send(JSON.stringify(scope.config.datasource.params));
                    }else if(scope.config.datasource.origin!=="ARRAY"){
                        queryREST();
                    }

                };

                //Uso solo para filtros, setea una pagina inicial, previo a ir a buscar la data.
                scope.api.queryFilters = function(){

                    scope.socketWatcher = $interval(function () {
                        scope.api.sendMessage();
                      }, 1000);
                    
                    if(scope.config.datasource.origin==="WS" || scope.config.datasource.origin==="WSS"){
                        
                       scope.config.datasource.params.page=1;
                       scope.config.datasource.params.token = $cookies.get('token');
                        
                       scope.api.sendMessage();
          
                     
                   }else if(scope.config.datasource.origin!=="ARRAY"){
                        queryREST();
                    }

               };

               scope.api.sendMessage = function(){

                   if(scope.websocket.readyState==1){
                      $interval.cancel(scope.socketWatcher);
                      scope.websocket.send(JSON.stringify(scope.config.datasource.params));
                  }

             }

                scope.api.filter = function(filters){
                    scope.config.datasource.params = filters || {};
                    scope.config.datasource.params.filterBy = JSON.stringify(scope.filters || "{}");
                    scope.api.query();
                };
                scope.api.filterExcel = function(filters){
                    scope.config.datasource.params = filters || {};
                    scope.config.datasource.params.filterBy = JSON.stringify(scope.filters || "{}");
                    //scope.api.query();
                };



                
                //Add element to grid
                scope.api.add = function(item){
                    if(item && Object.keys(item).length===scope.config.columns.length){
                        scope.data.add(item);
                        return 0;
                    }else{
                        console.error("Can't add the item, missing columns");
                        return -1;
                    }
                }

                //clean grid data
                scope.api.deleteAll = function(){
                    scope.data.remove();
                }
                 
                /*INNER API METHODS*/
                function fieldParser(type){
                    var func;
                    switch (type.toUpperCase()){
                        case "NUMBER":
                            func = function(number){
                                    return parseInt(number)
                                };
                            break;
                        case "DATE":
                            func = function(timestamp){
                                    return moment(timestamp).local().format('DD/MM/YYYY HH:mm:ss')
                                };
                            break
                        case "ARRAY":
                            func = function(arr){
                                //display array elements concated by ","
                                return (arr && arr.length>0) ? arr.join(", ") : "";
                            }
                            break;
                        default:
                            func= function(s){return s};
                            break;
                    }
                    return func;
                }

                function queryREST(){
                    var resolve = new Promise(function(resolve, reject){
                        $http({
                            url: scope.config.datasource.url,
                            method: scope.config.datasource.origin,
                            params: scope.config.datasource.params,
                            headers: {
                                token: $cookies.get('token'),
                            }
                        })
                        .success(function(response, status, headers){
                            scope.data = parseResponse(response[scope.config.datasource.paramsOut.data]);
                            scope.pagination = response[scope.config.datasource.paramsOut.pagination];
                            scope.setPaginationRule();
                        })
                        .error(function(response, status, headers){
                            reject(response);
                        });
                    });
                }

                function parseResponse(data){
                    var res = [];
                    data.forEach(function(row){
                        var parsedRow = {};

                        for(var key in scope.columnTypes){
                            if(scope.columnTypes[key].type==="html"){
                                for(var ckey in scope.config.columns){
                                    if(scope.config.columns[ckey].name===key){
                                        //buscar una forma de transformar el string html en html
                                        row[key] = scope.config.columns[ckey].html;
                                    }
                                }
                            }
                        }
                        //parse data by column type, can throw errors
                        for(var key in row){
                            var parser = scope.columnTypes[key];
                            parsedRow[key] = (parser)? parser.call(row[key]) : row[key];
                        }

                        res.push(parsedRow);
                    });
                    return res;
                };

                /*Export to excel*/
                scope.exportExcel = function(){
                  var excel = scope.toExcel();
                  if(excel){
                      scope.api.downloadExcel(excel.filename, excel.data);
                  }
                };
                scope.api.downloadExcel = function(fileName, data) {

                    function datenum(v, date1904) {
                        if(date1904) v+=1462;
                        var epoch = Date.parse(v);
                        return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
                    };

                    function getSheet(data, opts) {
                        var ws = {};
                        var range = {s: {c:10000000, r:10000000}, e: {c:0, r:0 }};
                        for(var R = 0; R != data.length; ++R) {
                            for(var C = 0; C != data[R].length; ++C) {
                                if(range.s.r > R) range.s.r = R;
                                if(range.s.c > C) range.s.c = C;
                                if(range.e.r < R) range.e.r = R;
                                if(range.e.c < C) range.e.c = C;
                                var cell = {v: data[R][C] };
                                if(cell.v == null) continue;
                                var cell_ref = XLSX.utils.encode_cell({c:C,r:R});

                                if(typeof cell.v === 'number') cell.t = 'n';
                                else if(typeof cell.v === 'boolean') cell.t = 'b';
                                else if(cell.v instanceof Date) {
                                    cell.t = 'n'; cell.z = XLSX.SSF._table[14];
                                    cell.v = datenum(cell.v);
                                }
                                else cell.t = 's';

                                ws[cell_ref] = cell;
                            }
                        }
                        if(range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
                        return ws;
                    };

                    function Workbook() {
                        if(!(this instanceof Workbook)) return new Workbook();
                        this.SheetNames = [];
                        this.Sheets = {};
                    }

                    var wb = new Workbook(), ws = getSheet(data);
                    /* add worksheet to workbook */
                    wb.SheetNames.push(fileName);
                    wb.Sheets[fileName] = ws;
                    var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'});

                    function s2ab(s) {
                        var buf = new ArrayBuffer(s.length);
                        var view = new Uint8Array(buf);
                        for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                        return buf;
                    }

                    saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), fileName+'.xlsx');
                };

                /*Pagination*/
                scope.setPaginationRule = function() {
                              
                    scope.pagination.rule = Paginator.getPagesWindow(scope.pagination.totalRecords, scope.config.datasource.params.itemsPerPage, scope.config.datasource.params.page);
                };

                scope.goToPage = function(destiny) {
                    var totalPages = Math.ceil(scope.pagination.totalRecords/scope.config.datasource.params.itemsPerPage);
                    switch (destiny) {
                        case 'start':
                            scope.config.datasource.params.page = 1;
                            break;
                        case 'end':
                            scope.config.datasource.params.page = totalPages;
                            break;
                        case '1more':
                            scope.config.datasource.params.page++;
                            break;
                        case '1less':
                            scope.config.datasource.params.page--;
                            break;
                        default:
                            scope.config.datasource.params.page = destiny;
                    }
                    scope.api.query();
                };

                scope.showLessArrow = function() {
                    return scope.pagination.rule.length > 1 && scope.pagination.rule[0] != 1;
                };

                scope.showMoreArrow = function() {
                    return scope.pagination.rule.length > 1 && scope.pagination.rule[scope.pagination.rule.length-1] != Math.ceil(scope.pagination.totalRecords/scope.config.datasource.params.itemsPerPage);
                };

                /*WEBSOCKET CONFIG*/
                if(scope.config && scope.config.datasource && (scope.config.datasource.origin ==='WS' || scope.config.datasource.origin ==='WSS')){
                    scope.close=false;

                    scope.start = function() {
                        var url = scope.config.datasource.url;
                        var ws = "";
                        if(scope.config.datasource.origin==='WS')
                            ws = "ws://"+url;
                        else
                            ws= "wss://"+url;

                        var webSocket = new WebSocket(ws);
                        scope.config.datasource.params = scope.config.datasource.paramsDefault;
                        scope.config.datasource.params.token = $cookies.get('token');

                        //Al abrir enviar KEY
                        webSocket.onopen = function(message){
                            console.log("Websocket: Comunicacion iniciada");
                            //se utiliza para esperar la construccion de los filtros asociados a la grilla
                            // if(scope.config.datasource.autoLoad===true) {
                                // console.log("Websocket: Comunicacion iniciada");
                                // webSocket.send(JSON.stringify(scope.config.datasource.params));
                            // }
                        };

                        webSocket.onerror = function(err){
                            console.log("Websocket error:");
                            console.log(err);
                        };

                        //Mensaje Recibido
                        webSocket.onmessage = function(message){
                            var data={};
                            try { data=JSON.parse(message.data); }
                            catch(err) {}
                            if (data!== undefined) {
                                scope.data = parseResponse(data[scope.config.datasource.paramsOut.data]);
                                scope.pagination = data[scope.config.datasource.paramsOut.pagination];
                                scope.setPaginationRule();
                                scope.$apply();
                            }
                        };
                        
                        //renovar la conexion cada 60 segundos
                        scope.interval = $interval(function(){
                            webSocket.send(JSON.stringify(scope.config.datasource.params));
                        }, 1000 * 60);

                        //Conexion cerrada
                        webSocket.onclose = function(message){
                            console.log("Conexión perdida");
                            $interval.cancel(scope.interval);
                            if (scope.close==false) {
                                $timeout(function() {
                                    console.log("Reanudando conexión");
                                    scope.websocket = scope.start();
                                }, 5000);
                            }
                        };
                        return webSocket;
                    };

                    // -- Inicia el Websocket
                    scope.websocket = scope.start();

                    // -- Cierra el WebSocket al destruir
                    scope.$on('$destroy', function() {
                        console.log("Websocket: Comunicacion cerrada");
                        scope.close=true;
                        scope.websocket.onclose("exit");
                        $interval.cancel(scope.interval);
                    });
                }

                /*INIT CONFIG*/
                if(scope.config){
                    // -- Identify parsers for each column of the grid
                    scope.visibleColumns = 0;
                    scope.config.columns.forEach(function(c){
                        scope.columnTypes[c.name] = {type:c.type, call: fieldParser(c.type)};
                        if(!c.hidden)
                            scope.visibleColumns++;
                    });

                    if(scope.config.datasource.autoLoad===true){
                        scope.api.filter(scope.config.datasource.paramsDefault);
                    }
                }
            }
        };
    });

})();
"use strict";

angular.module("dashboard").component("ngTableDynamic", {
  templateUrl: "app/directives/ngtable-dynamic.html",
  controllerAs: "ctrl",
  transclude: {
    extend: "?extendButtons",
  },
  bindings: {
    id: "@?",
    config: "<",
    selectedItems: "=?",
    onClick: "=?",
    showTopBar: "<",
    showRemoveRowsButton: "<",
    showFilterButton: "<",
    showExportCsvButton: "<",
    showExportJsonButton: "<",
    showImportJsonButton: "<",
    showRefreshButton: "<",
    onDeleteRow: "=",
    onExportRow: "=",
    onImport: "=",
    onDeleteManyRow: "=",
    onSearch: "=",
    onShare: "=",
    onBuild: "=",
    ngClass: "<",
  },
  controller: NgTableDynamicController,
});

NgTableDynamicController.$inject = [
  "$scope",
  "$cookies",
  "$rootScope",
  "NgTableParams",
  "$http",
  "$q",
  "translationService",
  "toastr",
  "FileSaver",
];

function NgTableDynamicController(
  $scope,
  $cookies,
  $rootScope,
  NgTableParams,
  $http,
  $q,
  $translationService,
  toastr,
  FileSaver
) {
  var vm = this;
  vm.labelRowsTotal = "";
  vm.clearSearchTerm = function () {
    vm.searchTerm = "";
  };

  vm.shouldShowFilters = false;

  vm.$onInit = function () {
    //Método para realizar traducción
    $translationService.getTranslation($scope, "directives");

    vm.filters = {
      page: 1,
      itemsPerPage: vm.config.pageSizes[0] || 25,
      sortBy: "id",
      orderBy: "id",
      sort: "desc",
      startDate: moment(
        $rootScope.desde || moment().subtract(1, "week").hour(0).minute(0).second(0)
      ),
      endDate: moment($rootScope.hasta || moment().hour(23).minute(59).second(59)),
    };

    // Filtros por defecto para iniciar la tabla
    if (vm.config.datasource.params) {
      vm.filters = angular.copy(vm.config.datasource.params);
    }

    angular.forEach(vm.config.columns, function (value, key) {
      //construir los filtros segun tipo
      if (value.filterable !== undefined) {
        vm.filters[value.field] = vm.filters[value.field] || {};
        if (value.filterable.type === "number") {
          vm.filters[value.field] = undefined;
        } else if (value.filterable.type === "text") {
          vm.filters[value.field] = undefined;
        } else if (value.filterable.type === "select") {
          if (value.filterable.options) {
            vm.filters[value.field] = [];
            value.filterable.options.forEach(function (_value) {
              if (_value.selected) {
                vm.filters[value.field].push(_value.key);
              }
            });
          } else {
            vm.filters[value.field] = undefined;
          }
        }
      }
    });

    iniTableFn();

    /*********************************************** Multiselection ***********************************************/
    // watch for check all checkbox
    if (angular.isDefined(vm.selectedItems)) {
      $scope.$watch(
        "ctrl.selectedItems.checked",
        function (nval, oval) {
          angular.forEach(vm.selectedItems.items, function (_item, key) {
            vm.selectedItems.items[key] = vm.selectedItems.checked;
          });
        },
        true
      );
    }
  };

  $scope.$on("dateChange", function (e, dates) {
    vm.filters.startDate = moment(dates.desde);
    vm.filters.endDate = moment(dates.hasta);
    vm[vm.id].reload();
  });

  $scope.$on("refreshNgTableDynamic", function (e, table) {
    console.log("refreshNgTableDynamic " + table.tableId + " " + vm.id);
    if (table.tableId == vm.id) {
      vm[vm.id].reload();
    }
  });

  vm.search = function () {
    $rootScope.$broadcast("dateChange", {
      desde: vm.desde,
      hasta: vm.hasta,
      searchBtn: true,
    });
  };

  function iniTableFn() {
    vm[vm.id] = new NgTableParams(
      {
        page: vm.filters.page || 1,
        count: vm.filters.itemsPerPage || vm.config.pageSizes[0],
      },
      {
        getData: function (params) {
          vm.selectedItems = {
            checked: false,
            items: {},
          };
          vm.loadedCaseTable = false;
          vm.filters.page = params.page();
          vm.filters.itemsPerPage = params.count();
          if (angular.isDefined(params.orderBy()) && params.orderBy().length > 0) {
            params.orderBy().forEach(function (item, index) {
              vm.filters.sortBy = item.substring(1);
              vm.filters.orderBy = item.substring(1);
              vm.filters.sort = item.substring(0, 1) === "+" ? "asc" : "desc";
            });
          }
          return queryRESTfn()
            .then(function (response) {
              vm.loadedCaseTable = true;
              if (angular.isDefined(response[vm.config.datasource.paramsOut.pagination])) {
                params.total(response[vm.config.datasource.paramsOut.pagination].totalRecords);

                vm.labelRowsTotal = "";
                if (params.total() > 0) {
                  var start = (params.page() - 1) * params.count();
                  var lengthData = response[vm.config.datasource.paramsOut.data].length;
                  var msg = $translationService.getTranslationController(" de ", " of ", " do ");
                  vm.labelRowsTotal =
                    start + 1 + " - " + (start + lengthData) + msg + params.total();
                }

                /*multi selection*/
                if (angular.isDefined(vm.selectedItems)) {
                  angular.forEach(response[vm.config.datasource.paramsOut.data], function (_item) {
                    vm.selectedItems.items[_item.id] = vm.selectedItems.checked;
                  });
                }

                return response[vm.config.datasource.paramsOut.data];
              }
              return response.sort(function (a, b) {
                var sort = vm.filters.sort || "desc";
                var sortBy = vm.filters.sortBy || "id";
                if (sortBy === "id") {
                  return sort === "asc" ? a.id - b.id : b.id - a.id;
                } else {
                  // Support nested properties like "category.name"
                  var key = sortBy.split(".").reduce(function (obj, prop) {
                    return obj && obj[prop] !== undefined ? obj[prop] : "";
                  }, a);
                  var keyB = sortBy.split(".").reduce(function (obj, prop) {
                    return obj && obj[prop] !== undefined ? obj[prop] : "";
                  }, b);
                  var keyB = b[sortBy] || "";
                  if(typeof key === "number" && typeof keyB === "number"){
                    return sort === "asc" ? key - keyB : keyB - key;
                  }
                  return sort === "asc" ? key.localeCompare(keyB) : keyB.localeCompare(key);
                }
              });
            })
            .catch(function (error) {
              vm.loadedCaseTable = true;
              if (error.status == 403) {
                toastr.error(
                  $translationService.getTranslationController(
                    "Usuario no autorizado.",
                    "Unauthorized User.",
                    "Usuário não autorizado."
                  )
                );
              }
            });
        },
      }
    );
    vm[vm.id].settings({ counts: vm.config.pageSizes });
  }

  function queryRESTfn() {
    var defered = $q.defer();
    var params = undefined;
    var data = {};

    if (vm.config.datasource.origin == "GET") {
      params = {
        query: vm.filters.query || "",
        sortBy: vm.filters.sortBy,
        orderBy: vm.filters.orderBy,
        sort: vm.filters.sort || "desc",
        page: vm.filters.page,
        itemsPerPage: vm.filters.itemsPerPage,
        exportToCsv: vm.filters.exportToCsv,
      };
      if (angular.isDefined(vm.filters.startDate)) {
        params.startDate = vm.filters.startDate.local().format();
      }
      if (angular.isDefined(vm.filters.endDate)) {
        params.endDate = vm.filters.endDate.local().format();
      }

      angular.forEach(vm.config.columns, function (value, key) {
        if (
          angular.isDefined(vm.filters[value.field]) &&
          (vm.filters[value.field] !== "" || !angular.isArray(vm.filters[value.field]))
        ) {
          params[value.field] = vm.filters[value.field];
        }
      });
    } else {
      data.sortBy = vm.filters.sortBy;
      data.orderBy = vm.filters.orderBy;
      data.sort = vm.filters.sort || "desc";
      data.startDate = vm.filters.startDate.local().format();
      data.endDate = vm.filters.endDate.format();
      data.exportToCsv = vm.filters.exportToCsv;
      data.pagination = {};
      data.pagination.page = vm.filters.page;
      data.pagination.itemsPerPage = vm.filters.itemsPerPage;
      data.filters = [];

      angular.forEach(vm.config.columns, function (value, key) {
        if (value.filterable !== undefined && value.filterable.filter !== undefined) {
          if (
            vm.filters[value.field] !== undefined &&
            vm.filters[value.field] !== "" &&
            !angular.isArray(vm.filters[value.field])
          )
            data.filters.push({
              column: value.field,
              operation: value.filterable.filter.operation,
              value: [vm.filters[value.field]],
            });

          if (angular.isArray(vm.filters[value.field]) && vm.filters[value.field].length !== 0) {
            data.filters.push({
              column: value.filterable.filter.column,
              operation: value.filterable.filter.operation,
              value: vm.filters[value.field],
            });
          }
        }
      });
    }

    $http({
      url: vm.config.datasource.url,
      method: vm.config.datasource.origin,
      params: params,
      responseType: vm.filters.exportToCsv ? "arraybuffer" : "application/json",
      headers: {
        token: $cookies.get("token"),
      },
      data: data,
    }).then(
      function (response) {
        vm.filters.exportToCsv = false;
        defered.resolve(response.data);
      },
      function (error) {
        vm.filters.exportToCsv = false;
        defered.reject(error);
      }
    );
    return defered.promise;
  }

  vm.applyFilters = function () {
    vm[vm.id].reload();
  };

  vm.cleanFilter = function () {
    angular.forEach(vm.config.columns, function (item, key) {
      vm.filters[item.field] = vm.filters[item.field] || {};
      vm.filters[item.field] = undefined;
    });
  };

  vm.onRefresh = function () {
    vm[vm.id].reload();
  };

  vm.onExportCsv = function () {
    vm.filters.exportToCsv = true;
    vm.loadedCaseTable = false;
    queryRESTfn()
      .then(function (response) {
        vm.filters.exportToCsv = false;
        vm.loadedCaseTable = true;
        FileSaver.saveAs(new Blob([response], { type: "application/csv" }), vm.id + ".csv");
      })
      .catch(function (error) {
        vm.loadedCaseTable = true;
        vm.filters.exportToCsv = false;
        if (error.status == 403) {
          toastr.error(
            $translationService.getTranslationController(
              "Usuario no autorizado.",
              "Unauthorized User.",
              "Usuário não autorizado."
            )
          );
        } else {
          toastr.error(
            $translationService.getTranslationController(
              "No hay datos para mostrar",
              "There is no data to display",
              "Não há dados para exibir"
            )
          );
        }
      });
  };

  vm.onCheckItem = function (item) {
    if (angular.isUndefined(vm.selectedItems)) {
      return;
    }
    if (vm.selectedItems.length > 0 && vm.selectedItems.indexOf(item.id) !== -1) {
      vm.selectedItems.splice(vm.selectedItems.indexOf(item.id), 1);
    } else {
      vm.selectedItems.push(item.id);
    }
  };
}

/**
 * Directiva para validar que el usuario tiene el permiso requerido para
 * visualizar una opcion dentro del Sistema
 */
angular.module('dashboard').directive('isSuperUser', function(PermissionsFactory, $rootScope) {
	return {
		link : function(scope, element, attrs) {
			if (PermissionsFactory.isSuperUser()) {
				element[0].style.display = "";

			} else {
				element[0].style.display = "none";
			}
		}
	};
});
/**
 * Directiva para validar que el usuario tiene el permiso requerido para
 * visualizar una opcion dentro del Sistema
 */
angular.module("dashboard").directive("hasPermission", function (PermissionsFactory, $rootScope) {
  return {
    link: function (scope, element, attrs) {
      var value = attrs.hasPermission.trim();
      if (PermissionsFactory.hasPermission(value)) {
        element[0].style.display = "";
      } else {
        element[0].style.display = "none";
      }
      $rootScope.$watch("permisos", function () {
        if (PermissionsFactory.hasPermission(value)) {
          element[0].style.display = "";
        } else {
          element[0].style.display = "none";
        }
      });
    },
  };
});

/**
 * Directiva para validar que el usuario tiene el permiso requerido para
 * visualizar una categoria dentro del Sistema
 */
angular
  .module('dashboard')
  .directive('hasCategory', function (PermissionsFactory, $rootScope) {
    return {
      link: function (scope, element, attrs) {
        var value = attrs.hasCategory.trim();
        console.log('hasCategory', value);
        if (PermissionsFactory.hasCategory(value)) {
          element[0].style.display = '';
        } else {
          element[0].style.display = 'none';
        }
        $rootScope.$watch('permisos', function () {
          if (PermissionsFactory.hasCategory(value)) {
            element[0].style.display = '';
          } else {
            element[0].style.display = 'none';
          }
        });
      },
    };
  });

app.directive('customOnChange', function() {
return {
    restrict: 'A',
    link: function (scope, element, attrs) {
    var onChangeHandler = scope.$eval(attrs.customOnChange);
    element.on('change', onChangeHandler);
    element.on('$destroy', function() {
        element.off();
    });

    }
};
});
(function() {
    'use strict';

    angular.module("dashboard")
        .component('myMenu', {
            templateUrl: "app/directives/menu-replay.html",
            bindings: {
                title: '@',
                states: '=',
                symbols: '=',
                symbolLista: '=',
                bookmarks: '=',
                fnView: "=?",
                fnMouse: "=?",
                fnGoToday: "=?",
                fnAgregation: "=?",
                fnMarginal: "=?",
                fnSetInterval: "=?",
                fnDelInterval: "=?",
                fnGoInterval: "=?",
                fnSetCase: "=?",
                fnStartSocket: "=?",
                fnStopSocket: "=?",
            },
            controller: function($scope, toastr, $mdPanel, $mdSidenav, $timeout, $q, translationService){
                var self = this;
                self.selectedItem = null;
                self.searchText = null;
                self.querySearch = querySearch;
                self._symbolList = loadSymbols();
                self.selectedSymbols = [];
                self.transformChip = transformChip;
                translationService.getTranslation($scope, 'directives');

                mapBookmarks();

                // -- NavSlider (Bookmarks)
                self.toggleRight = buildToggler('right');
                function buildToggler(componentId) {
                	return function() {
                        $mdSidenav(componentId).toggle();
                    };
                }

                /** Return the proper object when the append is called. **/
                function transformChip(chip) {
                    // If it is an object, it's already a known chip
                    if (angular.isObject(chip)) {
                        return chip;
                    }
                    // Otherwise, create a new one
                    return { name: chip };
                }

                /**
                 * Search for symbols.
                 */
                function querySearch (query) {
                    var results = query ? self._symbolList.filter(createFilterFor(query)) : self._symbolList.filter(createFilterFor(''));
                    return results;
                }

                /**
                 * Create filter function for a query string
                 */
                function createFilterFor(query) {
                  var lowercaseQuery = angular.lowercase(query);

                  return function filterFn(smbl) {
                    return (smbl._lowername.indexOf(lowercaseQuery) === 0);
                  };

                }

                function loadSymbols() {
                    var _symbolList = [];
                    return $scope.$ctrl.symbolLista.map(function (smb) {
                        _symbolList = { name: smb, _lowername: smb.toLowerCase() };
                        return _symbolList;
                    });
                }

                function mapBookmarks() {
                    angular.forEach($scope.$ctrl.bookmarks, function(bmrk, key){
                        $scope.$ctrl.bookmarks[key].symbols = bmrk.symbolList.map(function(smb) { return smb.symbolName })
                    });
                }
            }
        })
        .directive('eventReplay', EventReplayController);
        EventReplayController.$inject = ["$http", "$cookies", "$sce", "Paginator", "$timeout", "$interval", "$httpParamSerializer", "$compile", "toastr", "$rootScope", "$modal", "DetalleAlerta", "EventosAlerta", "$stateParams", "$state", "Casos", "EventsFactory", "env", "translationService", "timezoneService"];
        function EventReplayController($http, $cookies, $sce, Paginator, $timeout, $interval, $httpParamSerializer, $compile, toastr, $rootScope, $modal, DetalleAlerta, EventosAlerta, $stateParams, $state, Casos, EventsFactory, env, $translationService, $timezoneService){
            return {
                scope:{
                    id: "@?",
                    config: "=",
                    eventReplay: "=",
                    fnInit: "=?", // -- Función para construir el replay
                    fnGetdata: "=?", // -- Función para recopilar la data
                    fnSaveInterval: "=?", // -- Función para guardar intervalos
                    fnDeleteInterval: "=?", // -- Función para eliminar intervalos
                },
                restrict: 'E',
                replace: 'true',
                templateUrl: "app/directives/event-replay.html",
                link: function (scope, elem, attr) {
                    // -- Context Menú
                    scope.periods = {'1S':'ss', '1M':'mm', '1H':'hh', '1D':'DD', '1W':'WW'};
                    scope.states = {
                        tipoVista: 'solapada',
                        tipoMouse: 'zoom',
                        tipoEscala: 'natural',
                        tipoAgregacion: "1D",
                        porcentajeMarginal: "5",
                        conexion: 0
                    };

                    scope.verEventos = true;
                    scope.selected = 'None'; // Sin uso
                    scope.render = true; // Pronto sin uso
                    
                    // Menú desplegable
                    scope.menuOptions = [
                        {
                            text: $translationService.getTranslationController('Vista', 'View'),
                            children: [
                                {
                                    text: $translationService.getTranslationController('Solapada', 'Overlap'),
                                    click: function ($itemScope, $event, modelValue, text, $li) {
                                        scope.toggleView('solapada');
                                    },
                                    displayed: function() {
                                        return scope.states.tipoVista != 'solapada';
                                    }
                                },
                                {
                                    text: $translationService.getTranslationController('Apilada', 'Stacked'),
                                    click: function ($itemScope, $event, modelValue, text, $li) {
                                        scope.toggleView('apilada');
                                    },
                                    displayed: function() {
                                        return scope.states.tipoVista != 'apilada';
                                    }
                                }
                            ],
                            hasTopDivider: false,
                            hasBottomDivider: false,
                        },
                        // {
                        //     text: 'Escala',
                        //     children: [
                        //         {
                        //             text: 'Natural',
                        //             click: function ($itemScope, $event, modelValue, text, $li) {
                        //                 scope.states.tipoEscala = 'natural';
                        //                 toggleScale();
                        //             },
                        //             displayed: function() {
                        //                 return scope.states.tipoEscala != 'natural';
                        //             }
                        //         },
                        //         {
                        //             text: 'Logarítmica',
                        //             click: function ($itemScope, $event, modelValue, text, $li) {
                        //                 //console.log(JSON.stringify($itemScope.item));
                        //                 scope.states.tipoEscala = 'logaritmica';
                        //                 toggleScale();
                        //             },
                        //             displayed: function() {
                        //                 return scope.states.tipoEscala != 'logaritmica';
                        //             }
                        //         }
                        //     ],
                        //     hasTopDivider: false,
                        //     hasBottomDivider: false,
                        // },
                        {
                            text: 'Mouse',
                            children: [
                                {
                                    text: $translationService.getTranslationController('Navegar', 'Navigate'),
                                    click: function ($itemScope, $event, modelValue, text, $li) {
                                        scope.setPanSelect('pan');
                                    },
                                    displayed: function() {
                                        return scope.states.tipoMouse != 'pan';
                                    }
                                },
                                {
                                    text: 'Zoom',
                                    click: function ($itemScope, $event, modelValue, text, $li) {
                                        scope.setPanSelect('zoom');
                                    },
                                    displayed: function() {
                                        return scope.states.tipoMouse != 'zoom';
                                    }
                                }
                            ],
                            hasTopDivider: false,
                            hasBottomDivider: false,
                        },

                        // {
                        //     text: 'Mostrar Eventos',
                        //     click: function ($itemScope, $event, modelValue, text, $li) {
                        //         toggleEvents();
                        //     },
                        //     displayed: function() {
                        //         return !scope.verEventos;
                        //     }
                        // },
                        // {
                        //     text: 'Ocultar Eventos',
                        //     click: function ($itemScope, $event, modelValue, text, $li) {
                        //         toggleEvents();
                        //     },
                        //     displayed: function() {
                        //         return scope.verEventos;
                        //     }
                        // },
                        // {
                        //     text: 'Scroll Bar',
                        //     click: function ($itemScope, $event, modelValue, text, $li) {
                        //         toggleScrollBar();
                        //     }
                        // },
                    ];

                    // Mostrar u ocutlar eventos
                    function toggleEvents() {
                        scope.verEventos = !scope.verEventos;
                        scope.verEventos ? chart.showStockEvents() : chart.hideStockEvents();
                    }
                    
                    // Cambiar de vista solapada/apilada
                    scope.toggleView = function(type) {
                        if(scope.states.tipoVista == type) return false;

                        $cookies.put('replay'+scope.eventReplay.replayId+'tipoVista', type);
                        if(scope.websocket){
                            scope.websocket.onclose = function () {};
                            scope.websocket.close();
                            console.log("Websocket: Comunicacion cerrada");  
                        }

                        scope.states.tipoVista = type; scope.render = true;
                        if(scope.states.tipoVista == 'solapada'){
                            crearMultigraficoSolapado();
                        }else{
                            crearMultigraficoApilado();
                        }
                    }

                    // Ir a Hoy
                    scope.goToday = function() {
                        var _chart = scope.selectedChart || scope.charts[0];
                        // el rango devería darse por la agrupación
                        _chart.zoomToIndexes( _chart.dataProvider.length - _chart.range , _chart.dataProvider.length - 1 );
                    }

                    scope.delInterval = function(bookmark) {
                        $rootScope.loading = true;
                        var params = {
                            replayId: scope.eventReplay.replayId,
                            multiGraphId: scope.eventReplay.multigraphList[0].multigraphId,
                            bookmarkId: bookmark.id
                        }
                        
                        scope.fnDeleteInterval(params)
                        .then(function (res) {
                            var pos = scope.bookmarks.map(function(e) { return e.id; }).indexOf(bookmark.id);
                            scope.bookmarks.splice(pos, 1);
                            toastr.success("Intervalo eliminado!");
                            $rootScope.loading = false;
                        })
                        .catch(function (e) {
                            console.log('err@fnDeleteInterval');
                            console.log(e);
                            toastr.error("No se ha podido eliminar el intervalo!")
                            $rootScope.loading = false;
                        });
                    }

                    scope.setInterval = function(tag) {
                        if(tag == undefined){
                            toastr.warning("Debe agregar una etiqueta")
                            return false;
                        }

                        var _chart = scope.selectedChart || scope.charts[0];
                        var startTime = _chart.dataProvider[_chart.startIndex].timestamp;
                        var endTime = _chart.dataProvider[_chart.endIndex].timestamp;

                        if(!startTime || !endTime){
                            toastr.warning("Rango de fechas inválido")
                            return false;
                        }

                        var startInterval = moment(startTime).toISOString();
                        var endInterval = moment(endTime).add(1, "millisecond").toISOString();
                        var symbolList = scope.symbols.map(function(s){ return { symbolName:s, actve:true } });
                        
                        var params = {
                            replayId: scope.eventReplay.replayId,
                            multiGraphId: scope.eventReplay.multigraphList[0].multigraphId, 
                            body: {
                                "title": tag,
                                "symbolList": symbolList,
                                "symbols": scope.symbols,
                                "fromDate": startInterval,
                                "toDate": endInterval,
                                "overlap": scope.states.tipoVista == 'solapada' ? true : false,
                            }
                        }

                        $rootScope.loading = true;
                        scope.fnSaveInterval(params)
                        .then(function (res) {
                            params.body.id = res;
                            scope.bookmarks.unshift(params.body);
                            toastr.success("Intervalo guardado!");
                            $rootScope.loading = false;
                        })
                        .catch(function (e) {
                            if(e == 'FromDateIsAfterThanToDateOrEqual'){
                                toastr.info("Debe seleccionar un rango de fechas válido!");
                            }else{
                                console.log('err@fnSaveInterval', e);
                            }
                            toastr.error("No se ha podido guardar el intervalo!");
                            $rootScope.loading = false;
                        });
                    }

                    scope.fnGoInterval = function(interval){
                        // $rootScope.desde = interval.fromDate;
                        // $rootScope.hasta = interval.toDate;
                        // scope.$emit('refreshDatepickers');

                        if(scope.chartFilters){
                            scope.chartFilters.startDate = moment(interval.fromDate).startOf('day');
                            scope.chartFilters.endDate = moment(interval.toDate).endOf('day');
                        }
                        
                        if(scope.filters){
                            scope.filters.startDate = moment(interval.fromDate).startOf('day');
                            scope.filters.endDate = moment(interval.toDate).endOf('day');
                        }

                        scope._symbols = interval.symbols.map(function(s){ return { name:s } });
                        // var _chart = scope.selectedChart || scope.charts[0];
                        // _chart.zoomToDates(new Date(interval.fromDate), new Date(interval.toDate));
                    }

                    scope.fnSetCase = function(interval){
                        // var _chart = scope.selectedChart || scope.charts[0];
                        interval.replayId = scope.eventReplay.replayId;
                        interval.replayName = scope.eventReplay.replayName;
                        var CrearCasoModal = $modal({
                            templateUrl: 'app/casos/modal.crear-caso-intervalo.html',
                            show: true,
                            size: 'md',
                            animation: true,
                            controller: 'CrearCasoController',
                            scope: CrearCasoModal,
                            resolve: {
                                interval: function() {
                                    return interval;
                                }
                            }
                        });
                    }

                    scope.setMarginal = function(percent) {
                        scope.states.porcentajeMarginal = percent;
                        $cookies.put('replay'+scope.eventReplay.replayId+'Marginal', percent);
                        scope.setAgregation(scope.states.tipoAgregacion);
                    }

                    // Establecer periodo de agregación
                    scope.setAgregation = function(period) {
                        scope.states.tipoAgregacion = period;
                        $cookies.put('replay'+scope.eventReplay.replayId+'Interval', period);
                        
                        var AGchartData = [];
                        AGchartData = agregation(period, scope.chartData);

                        var AGtransactionsData = [];
                        AGtransactionsData = agregationT(period, scope.transactionsData);
                        
                        angular.forEach(scope.charts, function(ws_chart, key){
                            switch(ws_chart.dataProviderTarget){
                                case "scope.chartData":
                                    ws_chart.dataProvider = AGchartData;
                                break;
                                case "scope.transactionsData":
                                    ws_chart.dataProvider = AGtransactionsData;
                                break;
                            }
                            // ws_chart.chartCursor.categoryBalloonDateFormat = "MMM DD";
                            ws_chart.categoryAxis.minPeriod = scope.periods[period];
                            ws_chart.validateData();
                        });
                    }

                    function agregation( period, orgData ) {
                        var _orgData = angular.copy(orgData);
                        var periods = {'1S': 'second', '1M':'minute', '1H':'hour', '1D':'day', '1W':'week'};
                        var aggData = [];

                        angular.forEach(_orgData, function(_event, key) {
                            var date = moment(_event['timestamp']);
                            _event['timestamp'] = Number(date.startOf(periods[period]).tz($timezoneService.zoneTimeUser()).format('x'));
                            _event['date'] = date.startOf(periods[period]).tz($timezoneService.zoneTimeUser()).format('YYYY-MM-DDTHH:mm:ss');
                            _event['moment'] = date.startOf(periods[period]).tz($timezoneService.zoneTimeUser()).format('MMMM D YYYY, H:mm:ss');
                            var pos = aggData.map(function(e) { return e.timestamp; }).indexOf(_event['timestamp']);
                            if( pos < 0 ){
                                aggData.push(_event);
                            }else{
                                angular.merge(aggData[pos], _event);
                            }
                        });
                        return aggData.sort(function (a, b){ return (a.timestamp - b.timestamp) });
                    }

                    function agregationT( period, orgData ) {
                        var _orgData = angular.copy(orgData);
                        var periods = {'1S': 'second', '1M':'minute', '1H':'hour', '1D':'day', '1W':'week'};
                        var aggData = [];
                        
                        angular.forEach(_orgData, function(_event, key) {
                            var date = moment(_event['timestamp']);
                            _event['timestamp'] = Number(date.startOf(periods[period]).tz($timezoneService.zoneTimeUser()).format('x'));
                            _event['date'] = date.startOf(periods[period]).tz($timezoneService.zoneTimeUser()).format('YYYY-MM-DDTHH:mm:ss');
                            _event['moment'] = date.startOf(periods[period]).tz($timezoneService.zoneTimeUser()).format('MMMM D YYYY, H:mm:ss');

                            // _event['timestamp'] = Number(date.startOf(periods[period]).format('x'));
                            // _event['moment'] = date.startOf(periods[period]);
                            // _event['moment'] = moment.utc(_event['moment']).tz($timezoneService.zoneTimeUser()).format('MMMM D YYYY, H:mm:ss');
                            
                            var pos = aggData.map(function(e) { return e.timestamp; }).indexOf(_event['timestamp']);
                            if( pos < 0 ){
                                aggData.push(_event);
                            }else{
                                angular.merge(aggData[pos], _event);
                            }
                        });
                        
                        angular.forEach(aggData, function(_event, key) {
                            var buyTotal = 0; var sellTotal = 0;
                            angular.forEach(_event, function(ev, key) {
                                buyTotal = key.indexOf("buy") == 0 ? buyTotal + ev : buyTotal;
                                sellTotal = key.indexOf("sell") == 0 ? sellTotal + ev : sellTotal;
                            })
                            
                            // Discriminar según porcentaje marginal
                            angular.forEach(_event, function(ev, key) {
                                if(key.indexOf("buy") == 0){
                                    var percent = ev * 100 / buyTotal;
                                    if(percent < scope.states.porcentajeMarginal){
                                        _event["buy : OTHERS"] = _event["buy : OTHERS"] ? _event["buy : OTHERS"] + _event[key] : _event[key];
                                        delete _event[key];  
                                    } 
                                }
                                if(key.indexOf("sell") == 0){
                                    var percent = ev * 100 / sellTotal;
                                    if(percent < scope.states.porcentajeMarginal){
                                        _event["sell : OTHERS"] = _event["sell : OTHERS"] ? _event["sell : OTHERS"] + _event[key] : _event[key];
                                        delete _event[key];
                                    } 
                                }
                            })
                        })
                        
                        return aggData.sort(function (a, b){ return (a.timestamp - b.timestamp) });
                    }

                    // Cambiar la acción del cursor (zoom/pan)
                    scope.setPanSelect = function(type) {
                        var _chart = scope.selectedChart || scope.charts[0];
                        scope.states.tipoMouse = type;
                        if (scope.states.tipoMouse === 'zoom') {
                            _chart.chartCursor.pan = false;
                            _chart.chartCursor.zoomable = true;
                        } else {
                            _chart.chartCursor.pan = true;
                        }
                        _chart.validateNow();
                    }

                    // Activar/Desactivar la barra de navegación
                    function toggleScrollBar() {
                        var _chart = scope.selectedChart || scope.charts[0];
                        _chart.chartScrollbar.enabled = !_chart.chartScrollbar.enabled;
                        _chart.validateNow();
                    }

                    // Cambiar el tipo de escala (natural/logaritmica)
                    function toggleScale() {
                        var _chart = scope.selectedChart || scope.charts[0];
                        _chart.valueAxes[0].logarithmic = !_chart.valueAxes[0].logarithmic;
                        _chart.validateNow();
                    }

                    function selectChart(chart) {
                        scope.selectedChart = chart;
                    }

                    // Mostrar el último valor en la guía
                    AmCharts.addInitHandler(function(chart) { 
                        
                        return false; // --LoDev

                        // Mostrar el último valor en la guía (al llegar nuevos eventos)
                        chart.addListener("dataUpdated", function() {
                            var dataSet = chart.dataProvider; // get data set
                            var dataPoint = dataSet[dataSet.length - 1]; // get last data point
                            
                            // if (typeof chart.valueAxes[0].guides !== "object") // If not exist
                                chart.valueAxes[0].guides = []; // Create guide 
                            
                            for (var x = 0; x < chart.graphs.length; x++) { // iterate through all graphs in chart
                                var graph = chart.graphs[x]; // get graph
                                if (graph.type === undefined || graph.type === "line" || graph.type === "smoothedLine") { // add separate field for label
                                    // add a guide at this value
                                    chart.valueAxes[0].guides.push({
                                        value: dataPoint[graph.valueField],
                                        inside: false,
                                        label: dataPoint[graph.valueField],
                                        lineAlpha: 0,
                                        color: chart.colors[x],
                                        balloonColor: chart.colors[x],
                                    });
                                }
                            }
                        });
                    }, ["serial"]);              

                    // ****** Instancia de MultiGraph ****** //
                    scope.fnInit()
                    .then(function (res) {
                        $rootScope.loading = true;
                        
                        if(!scope.eventReplay.multigraphList.length){
                            var msg = $translationService.getTranslationController('No se han asignado graficos a este Event Replay',
                                'No graphics have been assigned to this Event Replay',
                                'Nenhum gráfico foi atribuído a este Evento Replay')
                            toastr.error(msg);
                            $rootScope.loading = false;
                            return false;
                        }

                        scope.states.porcentajeMarginal = $cookies.get('replay'+scope.eventReplay.replayId+'Marginal') || scope.states.porcentajeMarginal;
                        scope.states.tipoAgregacion = $cookies.get('replay'+scope.eventReplay.replayId+'Interval') || scope.states.tipoAgregacion;
                        scope.states.tipoVista = $cookies.get('replay'+scope.eventReplay.replayId+'tipoVista') || scope.states.tipoVista;
                        scope.symbols = angular.fromJson($cookies.get('replay'+scope.eventReplay.replayId+'Symbols')) || []; // Para la consuta
                        scope._symbols = scope.symbols.map(function(s){ return { name:s } }); // Para el autocomplete

                        scope.$watchCollection('_symbols', function(newCollection, oldCollection) {
                            if (newCollection === oldCollection) return;
                            $rootScope.loading = true;
                            scope.symbols = scope._symbols.map(function(s){ return s.name; })
                            
                            if(scope.websocket){
                                var socketRequest = { 
                                    replayId: Number(scope.eventReplay.replayId),
                                    token: $cookies.get('token'),
                                    to: "", 
                                    from: "", 
                                    symbolList: scope.symbols
                                };
                                scope.websocket.send(angular.toJson(socketRequest));
                            }

                            $cookies.put('replay'+scope.eventReplay.replayId+'Symbols', angular.toJson(scope.symbols));
                            obtenerData();
                        });

                        var req = {
                            replayId: scope.eventReplay.replayId,
                            multiGraphId: scope.eventReplay.multigraphList[0].multigraphId,
                        }                    
                        obtenerData();
                    })
                    .catch(function (e) {
                        console.log('error al iniciar eventReplay');
                        console.log(e);
                        toastr.error('Se ha producido un error<br>No se puede iniciar Event Replay');
                        $rootScope.loading = false;
                    });
                            
                    // Propiedades generales para los graficos
                    var chartsColor = ["#55bdc6", "#af7df8", "#81c824", "#f8cb3c", "#CD0D74", "#0D8ECF", "#2A0CD0", "#B0DE09", "#CC0000", "#00CC00", "#0000CC", "#DDDDDD", "#999999", "#333333", "#990000", "#FCD202"];
                    var chartsProperties = {
                       "line": {
                            "fillAlphas": 0.1,
                            "lineThickness": 2,
                            "bullet": "round", // round, square, triangle
                        },
                        "column": {
                            "fillAlphas": 0.7,
                            "lineThickness": 1,                                                                                                                                                    
                            "bullet": "none",
                        }
                    };
                    var myOperators = [
                        {name: "LARRA", color: "#c70001"},
                        {name: "BANCHILE", color: "#2888e4"},
                        {name: "BANESTADO", color: "#f7c133"},
                        {name: "BBVA", color: "#214d41"},
                        {name: "BCI", color: "#1f4c52"},
                        {name: "BICE", color: "#c7548c"},
                        {name: "BTG", color: "#638e99"},
                        {name: "CONSORCIO", color: "#5cc8d2"},
                        {name: "CREDICORP", color: "#4f9d4c"},
                        {name: "EUROAMER", color: "#5a5cd4"},
                        {name: "ITAU", color: "#3136bc"},
                        {name: "JP MORGAN", color: "#6dd020"},
                        {name: "LARRAGAR", color: "#7ff243"},
                        {name: "MBI", color: "#1744a4"},
                        {name: "NEVASA", color: "#995f8a"},
                        {name: "SANTANDER", color: "#b6edfd"},
                        {name: "SCOTIA", color: "#b1f0f5"},
                        {name: "SECURITY", color: "#EB962D"},
                        {name: "TANNER", color: "#d4adf0"},
                        {name: "VECTOR", color: "#a4cc17"},
                    ];

                    // Funciones inherentes al comportamiento de los graficos
                    function syncZoom(e) { // Sincronizar el Zoom y movimiento
                        if (e.chart.ignoreZoom) {
                            e.chart.ignoreZoom = false;
                            return;
                        }
                        
                        for(var i = 0; i < scope.charts.length; i++) {
                            scope.charts[i].range = e.chart.endIndex - e.chart.startIndex;
                            if(scope.charts[i] !== e.chart) {
                                if(e.startDate.getTime() != e.endDate.getTime()){
                                    scope.charts[i].ignoreZoom = true;
                                    scope.charts[i].zoomToDates(e.startDate, e.endDate);
                                    
                                    scope.charts[i].zoomStartDate = e.startDate;
                                    scope.charts[i].zoomEndDate = e.endDate;
                                }
                            }
                        }
                    }

                    function syncCursors(e) { // Sincronizar los cursores (barras horizontales)
                        for(var i = 0; i < scope.charts.length; i++) {
                            if(scope.charts[i] !== e.chart) {
                                scope.charts[i].chartCursor.syncWithCursor(e.chart.chartCursor);
                            }
                        }
                    }

                    function hideCursors(e) { // Ocultar los cursores al salir del grafico principal
                        for(var i = 0; i < scope.charts.length; i++) {
                            if(scope.charts[i] !== e.chart) {
                                scope.charts[i].chartCursor.hideCursor();
                                scope.charts[i].chartCursor.clearSelection();
                            }
                        }
                    }
                    // ** ** //
                                            
                    scope.charts; scope.chartData = []; scope.operators = []; scope.transactionsData = [];
                    scope.chartFilters = {
                        page: 1,
                        itemsPerPage: 2000,
                        sortBy: 'id',
                        sort: 'desc',
                        startDate : moment($rootScope.desde || (moment().startOf('day').subtract(1, 'week'))),
                        endDate : moment($rootScope.hasta || (moment().endOf('day')))
                    };

                    scope.$on('dateChange', function(e, dates){
                        if(dates.searchBtn){
                            $rootScope.loading = true;
                            if(scope.chartFilters){
                                scope.chartFilters.startDate = moment(dates.desde).startOf('day');
                                scope.chartFilters.endDate = moment(dates.hasta).endOf('day');
                            }
                            
                            if(scope.filters){
                                scope.filters.startDate = moment(dates.desde).startOf('day');
                                scope.filters.endDate = moment(dates.hasta).endOf('day');
                            }
                            
                            if(scope.eventReplay.multigraphList[0].functionName == 'LarraOperacionesBatchRule'){
                                scope.getSummary();
                            }else{
                                obtenerData();
                            }
                        }
                    });

                    function obtenerData(){
                        scope.settings = [];
                        if(scope.eventReplay.multigraphList[0].settings)
                            scope.settings = scope.eventReplay.multigraphList[0].settings.entry.map(function(e) { var obj = {}; obj[e.key] = e.value; return obj } ).reduce(function(a, b){ return angular.merge(a, b) }, []);
                        scope.params = [];
                        if(scope.eventReplay.multigraphList[0].params)
                            scope.params = scope.eventReplay.multigraphList[0].params.entry.map(function(e) { var obj = {}; obj[e.key] = e.value; return obj } ).reduce(function(a, b){ return angular.merge(a, b) }, []);

                        scope.chartData = [];
                        scope.operators = [];
                        scope.transactionsData = [];
                        
                        if(scope.states.tipoVista == 'solapada'){
                            crearMultigraficoSolapado();
                        }else{
                            crearMultigraficoApilado();
                        }
                        return false;
                    }

                    var itemCount = 0;
                    function cargarData(_multiGraph, m_key, page) {
                        _multiGraph.bookmarks = _multiGraph.bookmarks.map(function(e){
                            e.from = moment.utc(e.fromDate).tz($timezoneService.zoneTimeUser()).format("DD/MM/YY HH:mm");
                            e.to = moment.utc(e.toDate).tz($timezoneService.zoneTimeUser()).format("DD/MM/YY HH:mm");
                            return e;
                        })

                        if(scope.websocket){
                            scope.websocket.onclose = function () {};
                            scope.websocket.close();
                            console.log("WS Cerrado");
                        }

                        if(scope.eventReplay.multigraphList[0].functionName == 'LarraOperacionesBatchRule'){
                            crearMultigraficoSolapado();
                        }else if(scope.symbols.length){
                            // chunked SSE
                            var replay = scope.eventReplay.multigraphList[0].multigraphId;
                            var symbolList = scope.symbols.map(function(e){ return "&symbolList=" + e }).join('');
                            var itemsPerPage = 5000;
                            var itemCountPage = 0;
                            var chunkedUrl = '/risk-backend/rest/events/'+replay+'/sse_events/?startDate='+scope.chartFilters.startDate.toISOString()+'&endDate='+scope.chartFilters.endDate.toISOString()+'&page='+page+'&dateParam=datetime%20%3A&itemsPerPage='+itemsPerPage+'&aggregate=false'+symbolList;

                            var source = new EventSourcePolyfill(chunkedUrl, {headers: {'token': $cookies.get('token')}});

                            var eventResponse = [];
                            source.addEventListener("message",function(res){
                                res = angular.fromJson(res.data);
                                eventResponse = eventResponse.concat(res.events);
                                var totalPages = Math.ceil(res.pagination.totalRecords / res.pagination.itemsPerPage);
                                itemCount += res.events.length;
                                itemCountPage += res.events.length;
                                // console.log(res.pagination.page + " of " + totalPages, itemCount + "/" + res.events.length);
                                
                                if(itemCountPage >= itemsPerPage || itemCount >= res.pagination.totalRecords){
                                    angular.forEach(eventResponse, function(_event, e_key) {
                                        var _data = _event.eventBody.entry;
                                        // var date = new Date(_data.filter(function (e) { return e.key == 'datetime : '; }).map(function(e) { return e.value; })[0]);
                                        var date = moment.utc(_data.filter(function (e) { return e.key == 'datetime : '; }).map(function(e) { return e.value; })[0])
                                                        .tz($timezoneService.zoneTimeUser());
                                        var symbol = _data.filter(function (e) { return e.key == scope.params.symbol; }).map(function(e) { return e.value; })[0];
                                        
                                        var buyer = _data.filter(function (e) { return e.key == scope.settings.leftSide; }).map(function(e) { return e.value; })[0];
                                        if(buyer == undefined) buyer = _data.filter(function (e) { return e.key == 'buyerCode: '; }).map(function(e) { return e.value; })[0];
                                        var seller = _data.filter(function (e) { return e.key == scope.settings.rightSide; }).map(function(e) { return e.value; })[0];
                                        if (seller == undefined) seller = _data.filter(function (e) { return e.key == 'sellerCode: '; }).map(function(e) { return e.value; })[0];

                                        var posA = scope.chartData.map(function(e) { return e.timestamp; }).indexOf(Number(date.format('x')));
                                        var posB = scope.transactionsData.map(function(e) { return e.timestamp; }).indexOf(Number(date.format('x')));

                                        // -- Data de operadores
                                        if(buyer != undefined && !scope.operators.includes(buyer))
                                            scope.operators.push(buyer);
                                        if(seller != undefined && !scope.operators.includes(seller))
                                            scope.operators.push(seller);

                                        if(posA >= 0){ // Precios
                                            angular.forEach(_data, function(_param, p_key) {
                                               scope.chartData[posA][_param.key + symbol] = _param.value;
                                            });
                                        }else{
                                            var evalData = {};
                                            evalData['timestamp'] = Number(date.format('x'));
                                            evalData['date'] = _data.filter(function (e) { return e.key == 'datetime : '; }).map(function(e) { return e.value; })[0];
                                            evalData['moment'] = moment.utc(evalData['timestamp']).tz($timezoneService.zoneTimeUser()).format('MMMM D YYYY, H:mm:ss');
                                            angular.forEach(_data, function(_param, p_key) {
                                               evalData[_param.key + symbol] = _param.value; // ****** OJO param.key
                                            });
                                            scope.chartData.push(evalData);
                                        }  

                                        if(posB >= 0){ // Transacciones
                                            if(buyer != undefined)
                                                scope.transactionsData[posB]["buy : " + buyer] = Number(
                                                Number(scope.transactionsData[posB]["buy : " + buyer] || 0) + 
                                                Number( _data.filter(function (e) { return e.key == scope.params.axisY; }).map(function(e) { return e.value; })[0] || 0));
                                            if(seller != undefined)
                                                scope.transactionsData[posB]["sell : " + seller] = Number(
                                                Number( scope.transactionsData[posB]["sell : " + seller] || 0 ) + 
                                                Number( _data.filter(function (e) { return e.key == scope.params.axisY; }).map(function(e) { return e.value; })[0] || 0));
                                        }else{
                                            if(buyer != undefined){
                                                var transData = {};
                                                transData['timestamp'] = Number(date.format('x'));
                                                transData['date'] = _data.filter(function (e) { return e.key == 'datetime : '; }).map(function(e) { return e.value; })[0];
                                                transData["buy : " + buyer] = Number( _data.filter(function (e) { return e.key == scope.params.axisY; }).map(function(e) { return e.value; })[0] || 0 );
                                                transData["sell : " + seller] = Number( _data.filter(function (e) { return e.key == scope.params.axisY; }).map(function(e) { return e.value; })[0] || 0);
                                                scope.transactionsData.push(transData);
                                            }
                                        }  
                                    });
                                    scope.chartData.sort(function (a, b){ return (a.timestamp - b.timestamp) });
                                    scope.transactionsData.sort(function (a, b){ return (a.timestamp - b.timestamp) });
                                    scope.operators.push("OTHERS");
                                    scope.operators.sort();

                                    scope.AGchartData = [];
                                    scope.AGchartData = agregation(scope.states.tipoAgregacion, scope.chartData);
                                    scope.AGtransactionsData = [];
                                    scope.AGtransactionsData = agregationT(scope.states.tipoAgregacion, scope.transactionsData);

                                    // console.log("** Chart Data **");
                                    // console.log(scope.chartData);
                                    // console.log("** Transact Data **");
                                    // console.log(scope.transactionsData);
                                    // console.log("** Operators **");
                                    // console.log(scope.operators);
                                    
                                    switch(_multiGraph.chartType) {
                                        case 'line':
                                            // lineas solapadas/apiladas
                                            var _param = _multiGraph.params.entry.filter(function (e) { return e.key == 'axisY'; }).map(function(e) { return e.value; })[0];
                                            angular.forEach(scope.symbols, function(_symbol, s_key) {
                                                var chartKey = scope.states.tipoVista == 'solapada' ? 0 : s_key;
                                                if( scope.charts[chartKey].graphs.map(function(e){return e.title}).indexOf(_symbol) < 0){
                                                    var g = new AmCharts.AmGraph();
                                                    g.id = "g" + s_key;
                                                    g.title = _symbol;
                                                    g.valueField = _param + _symbol;
                                                    g.balloonText = "<b style='font-size:.7em'>[[moment]]</b> <br> [[title]]: $[[value]]";
                                                    g.type = _multiGraph.chartType;
                                                    g.fillAlphas = chartsProperties[_multiGraph.chartType].fillAlphas;
                                                    g.lineThickness = chartsProperties[_multiGraph.chartType].lineThickness;
                                                    g.bullet = chartsProperties[_multiGraph.chartType].bullet;
                                                    g.hidden = false;
                                                    g.lineColor = chartsColor[s_key];
                                                    g.hideBulletsCount = 30;
                                                    g.labelText = _multiGraph.chartType == "line" ? "" : "[[percents]]%";
                                                    scope.charts[chartKey].addGraph(g);
                                                }
                                            });                              
                                        break;
                                        case 'column':
                                            // Barras Solapadas
                                            angular.forEach(scope.operators, function(_operator, o_key) {
                                                if( scope.charts[0].graphs.map(function(e){return e.title}).indexOf(_operator) < 0){
                                                    var g = new AmCharts.AmGraph();
                                                        g.valueAxis = "compras"; // -- multigrapSettings
                                                        g.id = "gc" + o_key;
                                                        g.title = _operator;
                                                        g.valueField = "buy : " + _operator;
                                                        g.type = _multiGraph.chartType;
                                                        g.fillAlphas = chartsProperties[_multiGraph.chartType].fillAlphas;
                                                        g.lineThickness = chartsProperties[_multiGraph.chartType].lineThickness;
                                                        g.bullet = chartsProperties[_multiGraph.chartType].bullet;
                                                        g.hidden = false;
                                                        g.lineColor = (myOperators.filter(function(e) { return e.name == _operator }).map(function(e) { return e.color })[0] || "#ECECEC");//chartsColor[o_key];
                                                        g.hideBulletsCount = 30;
                                                        g.labelText = _multiGraph.chartType == "line" ? "" : "[[percents]]%<br>"+_operator;
                                                        g.balloonFunction = function(graphDataItem, graph) {
                                                            var ballonText = "";
                                                            var total = scope.operators.reduce(function(prev, act){
                                                                if(graphDataItem.dataContext["buy : " + act] != undefined && graphDataItem.dataContext["buy : " + act] > 0){
                                                                    prev += graphDataItem.dataContext["buy : " + act];
                                                                } return prev;
                                                            }, 0);
                                                            
                                                            var percents = [];
                                                            angular.forEach(scope.operators, function(b_operator, bo_key) {
                                                                if(graphDataItem.dataContext["buy : " + b_operator] != undefined && graphDataItem.dataContext["buy : " + b_operator] > 0){
                                                                    var percent = (graphDataItem.dataContext["buy : " + b_operator] * 100 / total).toFixed(2);
                                                                    if(percent >= 1){
                                                                        var color = graphDataItem.graph.chart.graphs.filter(function(e){ return e.title == b_operator; })[0]["fillColorsR"];
                                                                        percents.push({ operator: b_operator, value: graphDataItem.dataContext["buy : " + b_operator], percent:percent, color:color });
                                                                    }
                                                                }
                                                            });
                                                            
                                                            percents
                                                            .sort(function (a, b){ return (b.percent - a.percent) })
                                                            .reduce(function(prev, act, index, percents){
                                                                ballonText += "<b style='color:"+percents[index]['color']+"'>&#9635</b> " + percents[index]['operator'] + ": <b>" + percents[index]['percent'] + "%</b> ("+ percents[index]['value'].toFixed(2) + ")<br>";
                                                                return ballonText;
                                                            }, "");
                                                            return "<b style='font-size:.75em'>"+graphDataItem.dataContext.moment+"</b><br>"+$translationService.getTranslationController('Compras', 'Buys')+"<br>"+ballonText;
                                                        };
                                                    scope.charts[0].addGraph(g);

                                                    var g = new AmCharts.AmGraph();
                                                        g.valueAxis = "ventas"; // -- multigrapSettings
                                                        g.id = "gv" + o_key;
                                                        g.title = _operator;
                                                        g.valueField = "sell : " + _operator;
                                                        g.type = _multiGraph.chartType;
                                                        g.fillAlphas = chartsProperties[_multiGraph.chartType].fillAlphas;
                                                        g.lineThickness = chartsProperties[_multiGraph.chartType].lineThickness;
                                                        g.bullet = chartsProperties[_multiGraph.chartType].bullet;
                                                        g.hidden = false;
                                                        g.lineColor = (myOperators.filter(function(e) { return e.name == _operator }).map(function(e) { return e.color })[0] || "#ECECEC");//chartsColor[o_key];
                                                        g.hideBulletsCount = 30;
                                                        g.labelText =  _multiGraph.chartType == "line" ? "" : "[[percents]]%<br>"+_operator;
                                                        g.balloonFunction = function(graphDataItem, graph) {
                                                            var ballonText = "";
                                                            var total = scope.operators.reduce(function(prev, act){
                                                                if(graphDataItem.dataContext["sell : " + act] != undefined && graphDataItem.dataContext["sell : " + act] > 0){
                                                                    prev += graphDataItem.dataContext["sell : " + act];
                                                                } return prev;
                                                            }, 0);

                                                            var percents = [];
                                                            angular.forEach(scope.operators, function(b_operator, bo_key) {
                                                                if(graphDataItem.dataContext["sell : " + b_operator] != undefined && graphDataItem.dataContext["sell : " + b_operator] > 0){
                                                                    var percent = (graphDataItem.dataContext["sell : " + b_operator] * 100 / total).toFixed(2);
                                                                    if(percent >= 1){
                                                                        var color = graphDataItem.graph.chart.graphs.filter(function(e){ return e.title == b_operator; })[0]["fillColorsR"];
                                                                        percents.push({ operator: b_operator, value: graphDataItem.dataContext["sell : " + b_operator], percent:percent, color:color });
                                                                    }
                                                                }
                                                            });
                                                            
                                                            percents
                                                            .sort(function (a, b){ return (b.percent - a.percent) })
                                                            .reduce(function(prev, act, index, percents){
                                                                ballonText += "<b style='color:"+percents[index]['color']+"'>&#9635</b> " + percents[index]['operator'] + ": <b>" + percents[index]['percent'] + "%</b> ("+ percents[index]['value'].toFixed(2) + ")<br>";
                                                                return ballonText;
                                                            }, "");
                                                            return "<b style='font-size:.75em'>"+graphDataItem.dataContext.moment+"</b><br>"+$translationService.getTranslationController('Ventas', 'Sells')+"<br>"+ballonText;
                                                        };
                                                    scope.charts[0].addGraph(g);
                                                }
                                            })
                                        break;
                                    }
                                    
                                    angular.forEach(scope.charts, function(ws_chart, key){
                                        switch(ws_chart.dataProviderTarget){
                                            case "scope.chartData":
                                                ws_chart.dataProvider = scope.AGchartData;
                                            break;
                                            case "scope.transactionsData":
                                                ws_chart.dataProvider = scope.AGtransactionsData;
                                            break;
                                        }
                                        
                                        ws_chart.categoryAxis.minPeriod = scope.periods[scope.states.tipoAgregacion];
                                        ws_chart.validateData();

                                        ws_chart.ignoreZoom = true;
                                        ws_chart.zoomToIndexes( ws_chart.dataProvider.length - ws_chart.range, ws_chart.dataProvider.length - 1 );
                                    });
                                
                                    source.close();
                                    if(++page <= totalPages){
                                        cargarData(_multiGraph, m_key, page);
                                    }else{
                                    	// scope.startWS();
                                        itemCount = 0;
                                        $rootScope.loading = false;
                                        console.log("FinishStream");
                                    }
                                }
                            })
                            // chunked SSE 

                            // console.time("obtenerData");
                            // scope.fnGetdata(getData)
                            // .then(function (res) {
                            //     console.timeEnd("obtenerData");
                                
                            // })
                            // .catch(function (e) {
                            //     console.log('err@fnGetdata_');
                            //     console.log(e);
                            //     toastr.error("No se han podido cargar los datos!")
                            //     $rootScope.loading = false;
                            // });
                        }else{
                            // Mostrar mensaje de sin elementos que graficar
                            $rootScope.loading = false;
                            toastr.warning("Seleccione un elemento para ver los datos!");
                        }
                    }

                    scope.startWS = function(){
                    	scope.websocket = scope.start(); // - B/S
                    }
                    // Grafo operaciones
                    function tablasSolapadas(_multiGraph, m_key){
                        var _chartId = m_key;
                        var _param = _multiGraph.params.entry.filter(function (e) { return e.key == 'axisY'; }).map(function(e) { return e.value; })[0];
                        
                        // ********************* Configuración tabla operaciones
                        if(scope.filters == undefined){
                            scope.filters = {
                                page: 1,
                                itemsPerPage: 10,
                                sortBy: 'id',
                                sort: 'desc',
                                startDate : moment($rootScope.desde || (moment().startOf('day').subtract(1, 'week').format())),
                                endDate : moment($rootScope.hasta || (moment().endOf('day').format()))
                            };
                        }

                        // Definición estatica de los campos de las tablas, se debe mejorar para que trabaje dinamico
                        if(_multiGraph.functionName == "LarraOperacionesBatchRule"){ // "OrigenMarketReplayTxBCSRule"
                            // Campos de operaciones
                            var chartColumns = [
                                {col:"id", name:"id", title:"Id", type:"number", hidden:false, sortable: false},
                                {col:"eventBody", name:"side", title:"Side", type:"object", subItem:"entry", key:"side: ", hidden:false, sortable: false},
                                {col:"eventBody", name:"symbol", title:"Symbol", type:"object", subItem:"entry", key:"symbol: ", hidden:false, sortable: false},
                                // {col:"eventBody", name:"fecha1", title:"Fecha", type:"object.date", subItem:"entry", key:"date :", hidden:false, sortable: false},
                                {col:"issueDate", name:"fecha", title:"Fecha", type:"date", hidden:false, sortable: false},
                                {col:"eventBody", name:"clientRut", title:"Cliente-RUT", type:"object", subItem:"entry", key:"clientRut: ", hidden:false, sortable: false},
                                {col:"eventBody", name:"clientName", title:"Cliente", type:"object", subItem:"entry", key:"clientName: ", hidden:false, sortable: false},
                                {col:"eventBody", name:"amount", title:"Monto", type:"object", subItem:"entry", key:"amount: ", hidden:false, sortable: false},
                                {col:"eventBody", name:"volume", title:"Volumen", type:"object", subItem:"entry", key:"volume: ", hidden:false, sortable: false},
                                {col:"eventBody", name:"price", title:"Precio", type:"object", subItem:"entry", key:"price: ", hidden:false, sortable: false},
                                {col:"eventBody", name:"executive", title:"Ejecutivo", type:"object", subItem:"entry", key:"executiveName: ", hidden:false, sortable: false},
                                {col:"eventBody", name:"counterpartName", title:"Contraparte", type:"object", subItem:"entry", key:"counterpartName: ", hidden:false, sortable: false},
                            ];
                        }else{
                            // Campos de transacción
                            var chartColumns = [
                                {col:"id", name:"id", title:"Id", type:"number", hidden:false, sortable: false},
                                {col:"eventBody", name:"symbol", title:"Symbol", type:"object", subItem:"entry", key:"symbol: ", hidden:false, sortable: false},
                                {col:"issueDate", name:"fecha", title:"Fecha", type:"date", hidden:false, sortable: false},
                                {col:"issueDate", name:"hora", title:"Hora", type:"time", hidden:false, sortable: false},
                                // {col:"eventBody", name:"fecha", title:"Fecha", type:"object.date", subItem:"entry", key:"datetime : ", hidden:false, sortable: false},
                                // {col:"eventBody", name:"hora", title:"Hora", type:"object.time", subItem:"entry", key:"datetime : ", hidden:false, sortable: false},
                                {col:"ruleDescription", name:"ruleDescription", title:"Descripción", type:"string", hidden:true, sortable: false},
                                {col:"eventBody", name:"compra", title:"Compra", type:"object", subItem:"entry", key:"buyerName: ", hidden:false, sortable: false},
                                {col:"eventBody", name:"vende", title:"Vende", type:"object", subItem:"entry", key:"sellerName: ", hidden:false, sortable: false},
                                {col:"eventBody", name:"volumen", title:"Volumen", type:"object", subItem:"entry", key:"volume : ", hidden:false, sortable: false},
                                {col:"eventBody", name:"price", title:"Precio", type:"object", subItem:"entry", key:"price: ", hidden:false, sortable: false},
                            ];
                        }

                        scope.api = {};
                        scope.configTabla = 
                        {
                            datasource:{
                                origin: "POST",
                                url: "/risk-backend/rest/events/"+_multiGraph.multigraphId+"/events",
                                paramsDefault: {
                                    query: scope.filters.query || '',
                                    sortBy: scope.filters.sortBy || 'id',
                                    sort: scope.filters.sort || 'desc', 
                                    startDate: moment.isMoment(scope.filters.startDate) ? scope.filters.startDate.utc().toISOString() : '',
                                    endDate: moment.isMoment(scope.filters.endDate) ? scope.filters.endDate.utc().toISOString() : '',
                                    page: scope.filters.page || 1,
                                    itemsPerPage: scope.filters.itemsPerPage || 10,
                                },
                                params: {
                                    query: scope.filters.query || '',
                                    sortBy: scope.filters.sortBy || 'id',
                                    sort: scope.filters.sort || 'desc',
                                    startDate: moment.isMoment(scope.filters.startDate) ? scope.filters.startDate.utc().toISOString() : '',
                                    endDate: moment.isMoment(scope.filters.endDate) ? scope.filters.endDate.utc().toISOString() : '',
                                    page: scope.filters.page || 1,
                                    itemsPerPage: scope.filters.itemsPerPage || 10,
                                },
                                data: {
                                    symbolList: scope.symbols.length > 0 ? scope.symbols : ["VACIO"],
                                    aggregate: false,
                                },
                                paramsOut:{ // Parametros por los cuales sera "parseada" la data
                                    data: "events",
                                    pagination: "pagination"
                                }
                            },
                            // filterDatasource:{
                            //     // servicio utilizado para construir solamente los checkbox de los filtros
                            //     url:"/risk-backend/rest/events/filters",
                            //     paramsDefault:{
                            //         checked: $rootScope.filters.filterBy.event
                            //     }
                            // },
                            style:{ trStyle : function(item){ return "normal" }, },
                            columns:chartColumns,
                        }
                        
                        scope.listaSymbols = _multiGraph.symbols;
                        var content = $compile('<my-menu symbol-lista="listaSymbols" title="'+_multiGraph.title+'" states="states" bookmarks="false" symbols="_symbols"></my-menu>'+
                                                '<div id="er-mc-'+_chartId+'" style="width:auto; height:auto;">'+
                                                    '<risk-grid-legacy id="alertas" layout="row" layout-align="center none" table-css="table table-striped table-hover table-striped table-colors" config="configTabla" api="api", fn-click="alarmas.checkEvent" fn-dbl-click="alarmas.crearTabDetalleAlerta" to-excel="prepareExcel"></risk-grid-legacy>'+
                                                '</div><hr>')(scope);
                        elem.append(content);
                    }

                    // Grafo Volumen
                    function dobleBarrasSolapadas(_multiGraph, m_key){
                            var settings = _multiGraph.settings.entry.map(function(e) { var obj = {}; obj[e.key] = e.value; return obj } ).reduce(function(a, b){ return angular.merge(a, b) }, []);

                            var _chartId = m_key;
                            var _graphs = [];
                            var _param = _multiGraph.params.entry.filter(function (e) { return e.key == 'axisY'; }).map(function(e) { return e.value; })[0];
                            
                            scope.listaSymbols = _multiGraph.symbols;
                            scope.bookmarks = _multiGraph.bookmarks.sort(function (a, b){ return (b.id - a.id) });
                            var content = $compile('<my-menu symbol-lista="listaSymbols" title="'+_multiGraph.title+'" bookmarks="bookmarks" fn-marginal="setMarginal" fn-agregation="setAgregation" fn-mouse="setPanSelect" fn-view="toggleView" fn-go-today="goToday" fn-set-interval="setInterval" fn-del-interval="delInterval" fn-go-interval="fnGoInterval" fn-set-case="fnSetCase" fn-start-socket="startWS" fn-stop-socket="stop" states="states" symbols="_symbols"></my-menu>'+
                                                    '<div id="er-mc-'+_chartId+'" style="width:100%; height:70vh;">'+_chartId+'</div><hr>')(scope);
                            elem.append(content);

                            scope.charts.push(AmCharts.makeChart("er-mc-"+_chartId, {
                                "dataDateFormat": "YYYY-MM-DDTHH:NN:SS",
                                "type": "serial",
                                "range": 7,
                                "synchronizeGrid": false,
                                "baseHref": true,
                                "pathToImages": "/assets/icons/amcharts/",
                                "language": "es",
                                "marginRight": 80,
                                "dataProviderTarget": "scope.transactionsData",
                                "dataProvider": agregationT(scope.states.tipoAgregacion, scope.transactionsData),
                                "graphs": _graphs,
                                "balloon": {
                                    "textAlign": "middle",
                                    "fixedPosition": false,
                                },
                                "valueAxes": [
                                {
                                    "id": "compras",    // -- multigrapSettings
                                    "title": $translationService.getTranslationController('Compras', 'Buys'),
                                    "stackType": _multiGraph.chartType == "line" ? "none" : "100%",
                                    "logarithmic": false,
                                    "axisAlpha": 1,
                                    "position": "left",
                                    "showLastLabel":true,
                                },
                                {
                                    "id": "ventas",     // -- multigrapSettings
                                    "title": $translationService.getTranslationController('Ventas', 'Sells'),
                                    "stackType": _multiGraph.chartType == "line" ? "none" : "100%",
                                    "logarithmic": false,
                                    "axisAlpha": 1,
                                    "position": "right",
                                    "showLastLabel":true,
                                }],
                                "categoryField": "date",
                                "categoryAxis": {
                                    "minPeriod": scope.periods[scope.states.tipoAgregacion],
                                    "parseDates": true,
                                    "equalSpacing": true,
                                    "twoLineMode": false,
                                    "startOnAxis": false,
                                    
                                    "markPeriodChange": true,
                                    "boldPeriodBeginning": true,
                                    "ignoreAxisWidth": true,
                                    "showLastLabel": true,
                                },
                                "zoomOutButtonRollOverAlpha": 0.15,
                                "legend": {
                                    "enabled": false,
                                    "useGraphSettings": true,
                                    "rollOverGraphAlpha": 0.3,
                                    "position": "bottom",
                                },
                                "chartCursor": {
                                    "categoryBalloonDateFormat": "MMM DD JJ:NN:SS",
                                    "cursorPosition": "mouse",
                                    // "showNextAvailable": true,
                                    "pan": true,
                                    "valueBalloonsEnabled": false,
                                    "valueLineEnabled": true,
                                    "valueLineBalloonEnabled": true,
                                    "oneBalloonOnly": true,
                                },
                                "chartScrollbar": {
                                    // "graph": "g0",
                                    "updateOnReleaseOnly": false,
                                    "enabled": true,
                                    "scrollDuration": 2,
                                    "autoGridCount": true,
                                    "hideResizeGrips": false,
                                    "oppositeAxis": false,
                                    "offset": 30,
                                    "usePeriod": "WW",
                                    // Apariencia
                                    "dragIcon": "dragIconRoundBig",
                                    "graphFillColor": "#FD09E4",
                                    "graphFillAlpha": 0.15,
                                    "selectedGraphFillColor": "#FD09E4",
                                },
                                "autoMarginOffset": 5,
                                // "columnWidth": 1,
                                "mouseWheelZoomEnabled": false,
                                "mouseWheelScrollEnabled":false,
                                "export": {
                                    "enabled": true
                                },
                                "zoomOutOnDataUpdate": false,
                                "listeners": [
                                    {
                                        "event": "zoomed",
                                        "method": syncZoom
                                    },
                                    {
                                        "event": "rendered",
                                        "method": function(e) {
                                            $( "a[title='JavaScript charts']" ).text('CEPTINEL Risk Manager').attr("href", "javascript:void(0)");
                                            var _chart = e.chart;
                                            e.chart.div.addEventListener("mousedown", function( e ) {
                                                selectChart(_chart);
                                            })
                                        }
                                    },
                                    {
                                        "event": "init",
                                        "method": function( e ) {
                                            // Pre-zoom
                                            e.chart.zoomToIndexes( e.chart.dataProvider.length - 7, e.chart.dataProvider.length - 1 );
                                        }
                                    }, {
                                        "event": "drawn",
                                        "method": function( e ) {
                                            $( "a[title='JavaScript charts']" ).text('CEPTINEL Risk Manager').attr("href", "javascript:void(0)");
                                            /**
                                            * Log cursor's last known position
                                            */
                                            e.chart.lastCursorPosition = e.index;
                                        }
                                    } 
                                ],
                            }));
                        cargarData(_multiGraph, m_key, 1);
                    }
                    
                    // Grafo precios
                    function lineasSolapadas(_multiGraph, m_key){
                        var _chartId = m_key;
                        var _graphs = [];
                        // -- Agregar los graficos
                        var _param = _multiGraph.params.entry.filter(function (e) { return e.key == 'axisY'; }).map(function(e) { return e.value; })[0];
                        scope.listaSymbols = _multiGraph.symbols;
                        scope.bookmarks = _multiGraph.bookmarks.sort(function (a, b){ return (b.id - a.id) });
                        var content = $compile('<my-menu symbol-lista="listaSymbols" title="'+_multiGraph.title+'" bookmarks="bookmarks" fn-agregation="setAgregation" fn-mouse="setPanSelect" fn-view="toggleView" fn-go-today="goToday" fn-set-interval="setInterval" fn-del-interval="delInterval" fn-go-interval="fnGoInterval" fn-set-case="fnSetCase" fn-start-socket="startWS" fn-stop-socket="stop" states="states" symbols="_symbols"></my-menu>'+
                                                '<div id="er-mc-'+_chartId+'" style="width:100%; height:70vh;">'+_chartId+'</div><hr>')(scope);
                        elem.append(content);
                        scope.charts.push(AmCharts.makeChart("er-mc-"+_chartId, {
                            "dataDateFormat": "YYYY-MM-DDTHH:NN:SS",
                            "type": "serial",
                            "range": 100,
                            "synchronizeGrid": false,
                            "baseHref": true,
                            "pathToImages": "/assets/icons/amcharts/",
                            "language": "es",
                            "marginRight": 80,
                            "dataProviderTarget": "scope.chartData",
                            "dataProvider": agregation(scope.states.tipoAgregacion, scope.chartData),
                            "graphs": _graphs,
                            "valueAxes": [{
                                "title": _param,
                                "stackType": _multiGraph.chartType == "line" ? "none" : "regular",
                                "logarithmic": false,
                                "axisAlpha": 1,
                                "position": "right",
                                "showLastLabel":true,
                            }],
                            "categoryField": "date",
                            "categoryAxis": {
                                "minPeriod": scope.periods[scope.states.tipoAgregacion],
                                "parseDates": true,
                                "equalSpacing": true,
                                "twoLineMode": false,
                                "startOnAxis": false,
                                // "markPeriodChange": true,
                                // "boldPeriodBeginning": true,
                                // "ignoreAxisWidth": true,
                                "showLastLabel": true,
                                "dateFormats": [{"period":"ss","format":"MMMDD,JJ:NN:SS"},{"period":"mm","format":"MMMDD,JJ:NN"},{"period":"hh","format":"MMMDD,JJ:NN"},{"period":"DD","format":"MMM DD"},{"period":"WW","format":"MMM DD"},{"period":"MM","format":"MMM"},{"period":"YYYY","format":"YYYY"}],
                                "labelRotation": 12,
                            },
                            "zoomOutButtonRollOverAlpha": 0.15,
                            "legend": {
                                "useGraphSettings": true,
                                "rollOverGraphAlpha": 0.3,
                                "position": "bottom",
                            },
                            "chartCursor": {
                                "categoryBalloonDateFormat": "MMM DD JJ:NN:SS",
                                "cursorPosition": "mouse",
                                "showNextAvailable": true,
                                "pan":true,
                                "valueBalloonsEnabled": true,
                                "valueLineEnabled":true,
                                "valueLineBalloonEnabled":true,
                                "oneBalloonOnly": false,
                            },
                            "chartScrollbar": {
                                // "graph": "g0",
                                "updateOnReleaseOnly": false,
                                "enabled": true,
                                "scrollDuration": 2,
                                "autoGridCount": true,
                                "hideResizeGrips": false,
                                "oppositeAxis": false,
                                "offset": 30,
                                "usePeriod": "WW",
                                // Apariencia
                                "dragIcon": "dragIconRoundBig",
                                "graphFillColor": "#FD09E4",
                                "graphFillAlpha": 0.15,
                                "selectedGraphFillColor": "#FD09E4",
                            },

                            "autoMarginOffset": 5,
                            // "columnWidth": 1,
                            "mouseWheelZoomEnabled": false,
                            "mouseWheelScrollEnabled":false,
                            "export": {
                                "enabled": true
                            },
                            "zoomOutOnDataUpdate": false,
                            "listeners": [
                                {
                                    "event": "zoomed",
                                    "method": syncZoom
                                },
                                {
                                    "event": "dataUpdated",
                                    "method": function( e ) {
                                        if(e.chart.zoomStartDate != undefined)
                                            e.chart.zoomToDates(e.chart.zoomStartDate, e.chart.zoomEndDate);
                                    }
                                },
                                {
                                    "event": "rendered",
                                    "method": function(e) {
                                        $( "a[title='JavaScript charts']" ).text('CEPTINEL Risk Manager').attr("href", "javascript:void(0)");
                                        var _chart = e.chart;
                                        e.chart.div.addEventListener("mousedown", function( e ) {
                                            selectChart(_chart);
                                        })
                                    }
                                },
                                {
                                    "event": "init",
                                    "method": function( e ) {
                                        // Pre-zoom
                                        e.chart.zoomToIndexes( e.chart.dataProvider.length - e.chart.range, e.chart.dataProvider.length - 1 );
                                    }
                                }, {
                                    "event": "changed",
                                    "method": function( e ) {
                                        $( "a[title='JavaScript charts']" ).text('CEPTINEL Risk Manager').attr("href", "javascript:void(0)");
                                        /**
                                        * Log cursor's last known position
                                        */
                                        e.chart.lastCursorPosition = e.index;
                                    }
                                } 
                            ],
                        }));
                        cargarData(_multiGraph, m_key, 1);
                    }

                    function crearMultigraficoSolapado(key, eventReplay){
                        if(scope.render){ scope.charts = []; elem.empty(); }
                        // -- Filtro:solo multigraficos activos
                        scope.eventReplay.multigraphList = scope.eventReplay.multigraphList.filter(function (arr) { return arr.active == true });
                        angular.forEach(scope.eventReplay.multigraphList, function(_multiGraph, m_key) {
                            switch(_multiGraph.chartType) {
                                case 'line':
                                    lineasSolapadas(_multiGraph, m_key);
                                    break;
                                case 'column':
                                    dobleBarrasSolapadas(_multiGraph, m_key);
                                    tablasSolapadas(_multiGraph, m_key); // risk-grid
                                    break;
                                case 'table':
                                    tablasSolapadas(_multiGraph, m_key); // risk-grid
                                    break;
                            }                     
                        });
                        // Arrancar el streaming
                        // scope.websocket = scope.start();
                        // $rootScope.loading = false;
                    }
                    
                    function lineasApiladas(_multiGraph, m_key) {
                        var _graphs = [], _chartId;
                        scope.listaSymbols = _multiGraph.symbols;
                        scope.bookmarks = _multiGraph.bookmarks.sort(function (a, b){ return (b.id - a.id) });
                        var content = $compile('<my-menu symbol-lista="listaSymbols" title="'+_multiGraph.title+'" bookmarks="bookmarks" fn-agregation="setAgregation" fn-mouse="setPanSelect" fn-view="toggleView" fn-go-today="goToday" fn-set-interval="setInterval" fn-del-interval="delInterval" fn-go-interval="fnGoInterval" fn-set-case="fnSetCase" fn-start-socket="startWS" fn-stop-socket="stop" states="states" symbols="_symbols"></my-menu>')(scope);
                        elem.append(content);
                        
                        var _param = _multiGraph.params.entry.filter(function (e) { return e.key == 'axisY'; }).map(function(e) { return e.value; })[0];
                        angular.forEach(scope.symbols, function(_symbol, s_key) {
                            _chartId = m_key+""+s_key;
                            
                            var content = $compile('<div id="er-mc-'+_chartId+'" style="width:100%; height:20vw;">'+_chartId+'</div>')(scope);
                            elem.append(content);
                            scope.charts.push(AmCharts.makeChart("er-mc-"+_chartId, {
                                "dataDateFormat": "YYYY-MM-DDTHH:NN:SS",
                                "type": "serial",
                                "range": 100,
                                "baseHref": true,
                                "pathToImages": "/assets/icons/amcharts/",
                                "language": "es",
                                "marginRight": 80,
                                "dataProviderTarget": "scope.chartData",
                                "dataProvider": scope.chartData,
                                "graphs": [],
                                "valueAxes": [{
                                    "title": _param,
                                    "stackType": _multiGraph.chartType == "line" ? "none" : "regular",
                                    "logarithmic": false,
                                    "axisAlpha": 1,
                                    "position": "right",
                                    "showLastLabel":true,
                                }],
                                "categoryField": "date",
                                "categoryAxis": {
                                    "minPeriod": scope.periods[scope.states.tipoAgregacion],
                                    "parseDates": true,
                                    "equalSpacing": true,
                                    "twoLineMode": false,
                                    "startOnAxis": false,
                                    "showLastLabel": true,
                                    "dateFormats": [{"period":"ss","format":"MMMDD,JJ:NN:SS"},{"period":"mm","format":"MMMDD,JJ:NN"},{"period":"hh","format":"MMMDD,JJ:NN"},{"period":"DD","format":"MMM DD"},{"period":"WW","format":"MMM DD"},{"period":"MM","format":"MMM"},{"period":"YYYY","format":"YYYY"}],
                                    "labelRotation": 12,
                                },
                                "zoomOutButtonRollOverAlpha": 0.15,
                                "chartCursor": {
                                    "categoryBalloonDateFormat": "MMM DD JJ:NN:SS",
                                    "cursorPosition": "mouse",
                                    "showNextAvailable": true,
                                    "pan": true,
                                    "valueBalloonsEnabled": true,
                                    "valueLineEnabled": true,
                                    "valueLineBalloonEnabled": true,
                                    "oneBalloonOnly": false,
                                    "listeners": [{
                                        "event": "moved",
                                        "method": handleMoved
                                    }, {
                                        "event": "onHideCursor",
                                        "method": handleHide
                                    }]
                                },
                                "legend": {
                                    "useGraphSettings": true,
                                    "rollOverGraphAlpha": 0.3,
                                    "position": "bottom",
                                },
                                "chartScrollbar": {
                                    // "graph":"g"+_chartId,
                                    "updateOnReleaseOnly": false,
                                    "enabled": true,
                                    "scrollDuration": 2,
                                    "autoGridCount": true,
                                    "hideResizeGrips": false,
                                    "oppositeAxis": false,
                                    "offset": 30,
                                    "usePeriod": "WW",
                                    // Apariencia
                                    "dragIcon": "dragIconRoundBig",
                                    "graphFillColor": "#FD09E4",
                                    "graphFillAlpha": 0.15,
                                    "selectedGraphFillColor": "#FD09E4",
                                },
                                "autoMarginOffset": 5,
                                // "columnWidth": 5,
                                "mouseWheelZoomEnabled": false,
                                "mouseWheelScrollEnabled":false,
                                "export": {
                                    "enabled": true
                                },
                                "listeners": [
                                    {
                                        "event": "zoomed",
                                        "method": syncZoom
                                    },
                                    {
                                        "event": "dataUpdated",
                                        "method": function( e ) {
                                            if(e.chart.zoomStartDate != undefined)
                                                e.chart.zoomToDates(e.chart.zoomStartDate, e.chart.zoomEndDate);
                                        }
                                    },
                                    {
                                        "event": "rendered",
                                        "method": function( e ) {
                                            $( "a[title='JavaScript charts']" ).text('CEPTINEL Risk Manager').attr("href", "javascript:void(0)");
                                            var _chart = e.chart;
                                            e.chart.div.addEventListener("mousedown", function( e ) {
                                                selectChart(_chart);
                                            })
                                        }
                                    },
                                    {
                                        "event": "init",
                                        "method": function( e ) {
                                            // Pre-zoom
                                            e.chart.zoomToIndexes( e.chart.dataProvider.length - e.chart.range, e.chart.dataProvider.length - 1 );
                                        }
                                    }, 
                                        {
                                        "event": "changed",
                                        "method": function( e ) {
                                            $( "a[title='JavaScript charts']" ).text('CEPTINEL Risk Manager').attr("href", "javascript:void(0)");
                                            /**
                                            * Log cursor's last known position
                                            */
                                            e.chart.lastCursorPosition = e.index;
                                        }
                                    } 
                                ],
                            }));
                        });
                        function handleMoved(e){ syncCursors(e); }
                        function handleHide(e){ hideCursors(e); }
                        cargarData(_multiGraph, m_key, 1);
                    }
                    
                    function crearMultigraficoApilado(key, eventReplay){
                        elem.empty();
                        if(scope.render){
                            scope.charts = []; elem.empty();
                        }
                        var _chartId;
                        scope.eventReplay.multigraphList = scope.eventReplay.multigraphList.filter(function (arr) { return arr.active == true });
                        angular.forEach(scope.eventReplay.multigraphList, function(_multiGraph, m_key) {
                            switch(_multiGraph.chartType) {
                                case 'line':
                                    lineasApiladas(_multiGraph, m_key);
                                    break;
                                case 'column':
                                    dobleBarrasSolapadas(_multiGraph, m_key);
                                    tablasSolapadas(_multiGraph, m_key); // risk-grid
                                    break;
                                case 'table':
                                    // code block
                                    break;
                            }
                        });
                        // Arrancar el streaming
                        // scope.websocket = scope.start();
                        // $rootScope.loading = false;
                    }

                    scope.getSummary = function(){
                        var f = scope.filters || {};
                        f.query = f.query || '';
                        f.sortBy =  f.sortBy || 'id',//'criticality',
                        f.sort = f.sort || 'desc',
                        f.startDate = f.startDate || moment(),
                        f.endDate = f.endDate || moment();

                        moment().local();
                        f.startDate = moment(f.startDate).format();
                        f.endDate = moment(f.endDate).format();
                        
                        scope.api.filter(f);
                    };

                    // -- EXPORTAR A EXCEL
                    scope.getSummaryExcel=function(){
                      var f = scope.filters || {};
                      f.query = f.query || '';
                      f.sortBy =  f.sortBy || 'id', //'criticality',
                      f.sort = f.sort || 'desc',
                      f.startDate = f.startDate || moment(),
                      f.endDate = f.endDate || moment();

                      moment().local();
                      f.startDate = moment(f.startDate).format();
                      f.endDate = moment(f.endDate).format();
                      scope.api.filterExcel(f);
                    }

                    scope.prepareExcel = function() {
                        scope.getSummaryExcel();
                        
                        var filters = angular.copy(scope.filters);
                        filters.itemsPerPage = undefined;

                        var getData = {
                            multiGraphId: scope.eventReplay.multigraphList[0].multigraphId,
                            startDate: scope.chartFilters.startDate.toISOString(), 
                            endDate: scope.chartFilters.endDate.toISOString(), 
                            body: {
                                symbolList: scope.symbols,
                                aggregate: false
                            },
                        }
                        
                        scope.fnGetdata(getData).then(function (res) {
                            var excel = {
                                filename : "Operaciones",
                                data : []
                            };
                            var events = res.events;
                            if(events && events.length>0){
                                
                                var cols = scope.configTabla.columns.filter(function(e){return e.hidden == false}).map(function(e){ return {
                                                                                        title:e.title, 
                                                                                        field: e.col,
                                                                                        parse: e.type == "object" ? e.key : false,
                                                                                        format: e.type
                                                                                      }
                                                                                  })
                                
                                var exportData = []; 
                                exportData.push(cols.map(function(e){return e.title})); // Encabezado
                                
                                angular.forEach(events, function(event, i) { // Contenido
                                    var row = [];
                                    angular.forEach(cols, function(col, c) {
                                        if(!col.parse){
                                            // row.push(event[col.field]);
                                            var _col = event[col.field]
                                        }else{
                                            var parse = col.parse;
                                            var _col = angular.fromJson(event[col.field]);
                                            _col = _col.entry.filter(function (e) { return e.key == parse; }).map(function(e) { return e.value; })[0];
                                        }
                                        
                                        if(col.format){
                                            switch (col.format.toUpperCase()){
                                                case "DATE":
                                                    _col = moment(_col).local().format('DD/MM/YYYY');
                                                break;
                                                case "TIME":
                                                    _col = moment(_col).local().format('HH:mm:ss');
                                                break;
                                            }
                                        }

                                        if(_col != undefined){
                                            row.push(_col);
                                        }
                                    });
                                    exportData.push(row);
                                });

                                excel.data = exportData;
                                scope.api.downloadExcel(excel.filename, excel.data);
                            }else{
                                toastr.warning("Sin eventos que descargar!")
                                return {};
                            }
                        });
                    }

                    // -- WEBSOCKET CONFIG
                    if(scope.config && scope.config.datasource && (scope.config.datasource.origin === 'WS' || scope.config.datasource.origin === 'WSS')){
                        scope.close = false;
                        scope.start = function() {
                            var url = scope.config.datasource.url;
                            var ws = scope.config.datasource.origin === 'WS' ? "ws://"+url : "wss://"+url;
                            var webSocket = new WebSocket(ws);

                            var socketRequest = {
                                replayId: Number(scope.eventReplay.replayId),
                                token: $cookies.get('token'),
                                to: "",
                                from: "",
                                symbolList: scope.symbols
                            };

                            webSocket.onopen = function(message){
                                console.log("Replay - Websocket: Comunicacion estabecida");
                                scope.states.conexion = 1;
                                webSocket.send(JSON.stringify(socketRequest));
                            };

                            webSocket.onerror = function(err){
                                console.log("Websocket error:");
                                console.log(err);
                            };
                            
                            webSocket.onmessage = function(message){
                                scope.wsData = angular.fromJson(message.data);
                                console.log("*****scope.wsData*****");
                                console.log(scope.wsData);

                                angular.forEach(scope.wsData, function(_event, e_key) {
                                    // scope.replayData.push(_event);

                                    var _data = _event.eventBody;
                                    // var date = new Date(_data['datetime : ']);
                                    var date = moment.utc(_data['datetime : ']).tz($timezoneService.zoneTimeUser());
                                    var symbol = _data[scope.params.symbol];
                                    
                                    var buyer = _data[scope.settings.leftSide];
                                    if(buyer == undefined) buyer = _data['buyerCode: '];
                                    var seller = _data[scope.settings.rightSide];
                                    if(seller == undefined) seller = _data['sellerCode: '];

                                    var posA = scope.chartData.map(function(e) { return e.timestamp; }).indexOf(Number(date.format('x')));
                                    var posB = scope.transactionsData.map(function(e) { return e.timestamp; }).indexOf(Number(date.format('x')));

                                    if(buyer != undefined && !scope.operators.includes(buyer))
                                        scope.operators.push(buyer);
                                    if(seller != undefined && !scope.operators.includes(seller))
                                        scope.operators.push(seller);

                                    // agregarElemento a tabla de transacciones
                                    if(scope.api){
                                        var _tableItem = { id:_event['id'],
                                                    symbol: symbol,
                                                    fecha: moment(_data['datetime : ']).local().format('DD/MM/YYYY'), 
                                                    hora: moment(_data['datetime : ']).local().format('HH:mm:ss'),
                                                    ruleDescription:_event['ruleDescription'], 
                                                    compra:buyer, 
                                                    vende:seller, 
                                                    price:_data['price: '], 
                                                    volumen:_data['volume : '] };
                                        scope.api.add(_tableItem);
                                    }


                                    if(posA >= 0){ 
                                        angular.forEach(_data, function(_param, p_key) {
                                           scope.chartData[posA][p_key + symbol] = _param;
                                        });
                                    }else{
                                        var evalData = {};
                                        evalData['timestamp'] = Number(date.format('x'));
                                        // evalData['date'] = _data['datetime : '];
                                        evalData['date'] = date.toISOString();
                                        evalData['moment'] = moment.utc(evalData['timestamp']).tz($timezoneService.zoneTimeUser()).format('MMMM D YYYY, H:mm:ss');

                                        angular.forEach(_data, function(_param, p_key) {
                                           evalData[p_key + symbol] = _param;
                                        });
                                        scope.chartData.push(evalData);
                                    }

                                    if(posB >= 0){
                                        if(buyer != undefined){
                                            scope.transactionsData[posB]['buy : ' + buyer] = Number( 
                                            Number(scope.transactionsData[posB]['buy : ' + buyer] || 0) + 
                                            Number( _data['volume : '] || 0 ) );
                                        }
                                        if(seller != undefined){
                                            scope.transactionsData[posB]['sell : ' + seller] = Number( 
                                            Number(scope.transactionsData[posB]['sell : ' + seller] || 0) + 
                                            Number( _data['volume : '] || 0 ) );
                                        }
                                    }else{
                                        if(buyer != undefined){
                                            var transData = {};
                                            transData['timestamp'] = Number(date.format('x'));
                                            transData['date'] = _data['datetime : '];
                                            transData['buy : ' + buyer] = Number( _data['volume : '] );
                                            transData['sell : ' + seller] = Number( _data['volume : '] );
                                            scope.transactionsData.push(transData);
                                        }
                                    }
                                });
                                scope.chartData = scope.chartData.sort(function (a, b){ return (a.timestamp - b.timestamp) });
                                scope.transactionsData.sort(function (a, b){ return (a.timestamp - b.timestamp) });
                                scope.operators.sort();
                                
                                scope.AGchartData = [];
                                scope.AGchartData = agregation(scope.states.tipoAgregacion, scope.chartData);
                                scope.AGtransactionsData = [];
                                scope.AGtransactionsData = agregationT(scope.states.tipoAgregacion, scope.transactionsData);

                                // if (scope.chartData.length >= 20) scope.chartData.splice(0, 1); // Mantener una cantidad de eventos

                                angular.forEach(scope.charts, function(ws_chart, key){
                                    switch(ws_chart.dataProviderTarget){
                                        case "scope.chartData":
                                            ws_chart.dataProvider = scope.AGchartData;
                                        break;
                                        case "scope.transactionsData":
                                            ws_chart.dataProvider = scope.AGtransactionsData;
                                        break;
                                    }
                                    
                                    ws_chart.categoryAxis.minPeriod = scope.periods[scope.states.tipoAgregacion];
                                    ws_chart.validateData();

                                    // HotlineBlinkBlink
                                    // console.log(ws_chart.range);
                                    ws_chart.ignoreZoom = true;
                                    ws_chart.zoomToIndexes( ws_chart.dataProvider.length - ws_chart.range, ws_chart.dataProvider.length - 1 );
                                    
                                    // var newStartDate = new Date(ws_chart.startDate);
                                    // newStartDate.setDate(newStartDate.getDate() + 1);
                                    // var newEndDate = new Date(ws_chart.endDate.getTime());
                                    // newEndDate.setDate(newEndDate.getDate() + 1);
                                    // ws_chart.zoom(newStartDate, newEndDate);

                                    // var newStartDate = new Date(ws_chart.startDate.getTime());
                                    // newStartDate.setDate(newStartDate.getDate() + 1);
                                    // var newEndDate = new Date(ws_chart.endDate.getTime());
                                    // newEndDate.setDate(newEndDate.getDate() + 1);
                                    // ws_chart.zoom(newStartDate, newEndDate);
                                });
                            };
                            
                            webSocket.onclose = function(message){
                                scope.states.conexion = 0;
                                $interval.cancel(scope.interval);
                                if(scope.close == false) {
                                    console.log("Conexión perdida");
                                    $timeout(function() {
                                        console.log("Reanudando conexión");
                                        scope.websocket = scope.start();
                                        scope.states.conexion = 2;
                                    }, 5000);
                                }
                            };
                            // Renovar la conexion cada 60 segundos
                            // scope.interval = $interval(function(){
                            //     if(webSocket.readyState == 1){
                            //         console.log("Renovando JWT");
                            //         webSocket.send(JSON.stringify(socketRequest));
                            //     }
                            // }, 1000 * 60);

                            return webSocket;
                        };

                        // -- Inicia el Websocket
                        // scope.websocket = scope.start();

                        scope.stop = function(){
                        	scope.close = true;
                        	scope.states.conexion = 0;
                        	if(scope.websocket){
                                console.log("Websocket: Comunicacion cerrada");  
                                scope.websocket.onclose = function () {};
                                scope.websocket.close();
                                console.log("Bye");
                            }
                            $interval.cancel(scope.interval);
                            $interval.cancel(scope.curl);
                        }

                        // -- Cierra el WebSocket al destruir (salir de la vista)
                        scope.$on('$destroy', function() {
                            scope.stop();
                        });
                    }


                    function parseResponse(data){
                        var res = [];
                        
                        data.forEach(function(row){
                            var parsedRow = {};

                            for(var key in scope.columnTypes){
                                if(scope.columnTypes[key].type==="html"){
                                    for(var ckey in scope.config.columns){
                                        if(scope.config.columns[ckey].name===key){
                                            //buscar una forma de transformar el string html en html
                                            row[key] = scope.config.columns[ckey].html;
                                        }
                                    }
                                }
                            }
                            
                            res.push(row);
                        });
                        return res;
                    };
                }
            };
        }
})();
(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('DataManagementController', DataManagementController);

  DataManagementController.$inject = [
    '$scope',
    'toastr', 
    'translationService',
    '$rootScope',
    '$state',
    '$mdDialog',
    'DataTableFactory',
  ];
  function DataManagementController(
    $scope,
    toastr,
    $translationService,
    $rootScope,
    $state,
    $mdDialog,
    $dataTableFactory
  ) {
    var vm = this;
    vm.isLoading = false;
    vm.schemas = [];

    $translationService.getTranslation(vm, 'data-management');

    vm.init = function () {
      _getAllSchemas();
    };
    vm.init();

    vm.goToSchema = function (schemaName) {
      $state.go('app.schemasTables', { schemaName: schemaName });
    };

    vm.tableManagement = function () {
      $mdDialog.show({
        controller: 'DialogTableManagement',
        controllerAs: 'ctrl',
        templateUrl:
          'app/data-management/dialog-table-management/dialog-table-management.html',
        locals: {
          table: null,
        },
        parent: angular.element(document.body),
        // targetEvent: ev,
        hasBackdrop: true,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: true,
      });
    };

    function _getAllSchemas() {
      vm.isLoading = true;
      $rootScope.loading = true;
      $dataTableFactory
        .getAllSchemas()
        .then(function (res) {
          vm.schemas = res.sort().map(function (s) {
            return { name: s };
          });
        })
        .catch(function (err) {
          console.error('Error@getAllSchemas', err);
          toastr.error(err.message || 'Error getting schemas'); 
        })
        .finally(function () {
          $rootScope.loading = false;
          vm.isLoading = false;
        });
    }

    vm.showShareEntityDialog = function (selectedItem) {
      $mdDialog.show({
        controller: 'ShareEntityController',
        templateUrl: 'app/acl/component/dialog-share-entity.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          selectedItem: {
            id: selectedItem,
            resource: 'data-management-schemas',
            name: '',
          },
          actions: ['read', 'share'],
        },
      });
    };

    vm.dialogSearchTable = function () {
      $mdDialog.show({
        controller: 'dialogTextSearchController',
        controllerAs: "ctrl",
        templateUrl: 'app/app-utils/components/table-data/dialogs/text-search/text-search.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
      });
    };
  }
})();

(function () {
    'use strict';

    angular
    .module('dashboard')
    .controller('DataConnController', DataConnController)
    
    DataConnController.$inject = ['$scope', '$rootScope', 'translationService', '$mdDialog', 'toastr', 'DataConnFactory'];
    function DataConnController($scope, $rootScope, $translationService, $mdDialog, toastr, DataConnFactory) {
        $translationService.getTranslation($scope, 'data-conn');
        var vm = this;
        vm.connections = []
        
        vm.openEditor = function(ev, conex) {
            $mdDialog.show({
                controller: 'CreateConnectionController',
                controllerAs: 'ctrl',
                templateUrl: 'app/data-conn/components/create-conection/dialog-create-conection.html',
                locals: { 
                    conex: conex
                },
                parent: angular.element(document.body),
                targetEvent: ev,
                hasBackdrop: true,
                clickOutsideToClose: false,
                escapeToClose: false,
                focusOnOpen: true,
            })
        }

        vm.getConnections = function(){
            $rootScope.loading = true;
            DataConnFactory.getConnections()
            .then(function (response) {
                vm.connections = response;
            })
            .catch(function (e) {
                console.log("error@getConnections", e);
            })
            .finally(function(e){
                $rootScope.loading = false;
            });
        }
        vm.getConnections();

        $scope.$on('refreshDataConn', function (e) {
            vm.getConnections();
        });

        vm.testConnection = function(conex){
            $rootScope.loading = true;
            DataConnFactory.testConnection(conex.id)
            .then(function (response) {
                conex.schemasCache = response;
                toastr.success("Connection test success")
            })
            .catch(function (e) {
                console.log("error@testConnection", e);
                toastr.error("Connection test failed");
            })
            .finally(function(e){
                $rootScope.loading = false;
            });   
        }

        vm.deleteConnection = function(conex){
            var confirm = $mdDialog.confirm()
                    .title($translationService.getTranslationController('¿Eliminar conexión: ', 'Delete connection: ', 'Excluir conexão: ') + conex.name  + '?')
                    .textContent($translationService.getTranslationController('¡Cuidado!, Esta acción no puede revertirse.', 'Atention!, This action can not be reversed.', 'Atenção!, esta ação não pode ser revertida.'))
                    .ariaLabel('Delete-Question')
                    .ok($translationService.getTranslationController('Si, Elimínala', 'Yes, Delete it', "Sim, exclua"))
                    .cancel($translationService.getTranslationController('Aún no', 'Not yet', 'Ainda não'));

            $mdDialog.show(confirm).then(function() {
                $rootScope.loading = true;
                DataConnFactory.deleteConnection(conex.id)
                .then(function (response) {
                    console.log(response);
                    vm.getConnections();
                    toastr.success($translationService.getTranslationController('Conexión eliminada', 'Connection deleted', 'Conexão excluída'));
                })
                .catch(function (e) {
                    console.log("error@getConnections", e);
                    toastr.error($translationService.getTranslationController('Error al eliminar', 'Deletion Failed', 'Falha na exclusão'));
                })
                .finally(function(e){
                    $rootScope.loading = false;
                });
            }, function() {});
        }

        vm.showShareEntityDialog = function (selectedItem) {
            $mdDialog.show({
                controller: 'ShareEntityController',
                templateUrl: 'app/acl/component/dialog-share-entity.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                locals: {
                    selectedItem: {
                        id: selectedItem,
                        resource: 'data-connection',
                        name: '',
                    },
                    actions: ['read', 'create', 'update', 'delete'],
                },
            });
        };
    }
})();

(function () {
  "use strict";

  angular.module("dashboard").controller("DashboardController", DashboardController);

  DashboardController.$inject = [
    '$scope',
    '$rootScope',
    '$state',
    'translationService',
    '$mdDialog',
    'toastr',
    'PermissionsFactory',
    'IssuesFactory',
    '$localStorageService',
    'ConfigurationFactory',
  ];
  function DashboardController(
    $scope,
    $rootScope,
    $state,
    $translationService,
    $mdDialog,
    $toastr,
    $permissionsFactory,
    IssuesFactory,
    $localStorageService,
    $ConfigurationFactory
  ) {
    $translationService.getTranslation($scope, "dashboard");
    var vm = this;
    vm.relatedBy = $localStorageService.getItem("relatedBy") || "assigned";

    vm.tabs = [
      {
        // Default tab
        id: "index",
        name: "Inbox",
        icon: "cep-inbox",
        color: "ceptinel",
      },
    ];
    vm.selectedTab = "index";
    vm.counters = {};
    // vm.selectedRows = [];
    vm.activeTabs = [];
    $rootScope.loading = true;

    $scope.sortableOptionsList = {
      containment: ".issue-container",
      update: function () {
        _setupLocalStore();
      },
      stop: function () {
        _setupLocalStore();
      },
      change: function () {
        _setupLocalStore();
      },
    };

    $rootScope.issueDates = {
      from: new Date(),
      to: new Date(),
      active: false,
    };
    var $issuesFromDatepicker = $(".issue_from_datepicker");
    var $issuesToDatepicker = $(".issue_to_datepicker");

    $issuesFromDatepicker.datepicker("setDate", $rootScope.issueDates.from);
    $issuesFromDatepicker.datepicker("option", "maxDate", $rootScope.issueDates.to);

    $issuesToDatepicker.datepicker("setDate", $rootScope.issueDates.to);
    $issuesToDatepicker.datepicker("option", "minDate", $rootScope.issueDates.from);

    $issuesFromDatepicker.datepicker({
       changeMonth: true,
      changeYear: true,
      onSelect: function () {
        var date = $(this).datepicker("getDate");
        console.log(date);
        $rootScope.issueDates.from = date;
        $(this).datepicker("option", "maxDate", $rootScope.issueDates.to);
        $issuesToDatepicker.datepicker("option", "minDate", $rootScope.issueDates.from);
        $broadcastDateChange();
      },
    });

    $issuesToDatepicker.datepicker({
      changeMonth: true,
      changeYear: true,
      onSelect: function () {
        var date = $(this).datepicker("getDate");
        console.log(date);
        $rootScope.issueDates.to = date;
        $(this).datepicker("option", "minDate", $rootScope.issueDates.from);
        $issuesFromDatepicker.datepicker("option", "maxDate", $rootScope.issueDates.to);
        $broadcastDateChange();
      },
    });

    function $broadcastDateChange() {
      $scope.$broadcast("issuesDateChange", {
        desde: $rootScope.issueDates.from,
        hasta: $rootScope.issueDates.to,
        active: $rootScope.issueDates.active,
      });
    }

    vm.openMenu = function ($mdMenu, ev) {
      if (!$rootScope.issueDates.active) return;
      $mdMenu.open(ev);
    };

    vm.toggleIssueDatesActive = function () {
      $rootScope.issueDates.active = !$rootScope.issueDates.active;
      if (!$rootScope.issueDates.active) {
        $rootScope.issueDates.from = new Date();
        $rootScope.issueDates.to = new Date();
        $issuesFromDatepicker.datepicker("setDate", $rootScope.issueDates.from);
        $issuesToDatepicker.datepicker("setDate", $rootScope.issueDates.to);
      }
      $broadcastDateChange();
    };

    vm.init = function () {
      $rootScope.loading = true;
      vm.getIssuesCategories()
        .then(function () {
          if ($state.params.category) {
            vm.currentCategory = vm.issueCategories.find(function (e) {
              return e.name == $state.params.category;
            });
          }

          var promises = [];
          promises.push(vm.getIssuesTypes());
          promises.push(vm.getCounters());
          promises.push(vm.getIssuesCustomViews());

          Promise.all(promises).then(function () {
            if ($state.params.issue) {
              if ($state.params.issue != "index") {
                var activeIssue = vm.issueTypes.find(function (ele) {
                  return ele.name == $state.params.issue;
                });

                if (activeIssue) {
                  vm.activeTabs.push(activeIssue);

                  vm.openTab(activeIssue.name, activeIssue.icon, activeIssue.color, activeIssue.id);
                } else {
                  var activeIssue = vm.customViews.find(function (e) {
                    return e.name == $state.params.issue;
                  });
                  if (activeIssue) {
                    vm.openCustomView(activeIssue);
                  }
                }
              }
            }
            $rootScope.loading = false;
          });
        })
        .finally(function () {
          // $ConfigurationFactory.getGlobalConfiguration().then(function (res) {
          //   if (res) {
          //     // var relatedBy = res.issues.relatedBy || "assigned";
          //   }
          // });
          vm.changeRelationship(vm.relatedBy);
        });
    };

    $scope.$on("ReloadIssues", function () {
      $rootScope.loading = true;
      vm.getCounters().finally(function () {
        $rootScope.loading = false;
      });
    });

    $scope.$on("ReloadCustomViews", function () {
      vm.getIssuesCustomViews();
    });

    vm.getIssuesCustomViews = function () {
      return new Promise(function (resolve, reject) {
        IssuesFactory.getIssuesCustomViews()
          .then(function (res) {
            vm.customViews = res.data;
            resolve();
          })
          .catch(function (err) {
            console.error("Error@getIssuesCustomViews", err);
            reject();
          });
      });
    };

    vm.openCustomView = function (view) {
      // console.log(view);
      view.body = typeof view.body == "string" ? JSON.parse(view.body) : view.body;

      var customViewIssue = angular.copy(
        vm.issueTypes.find(function (e) {
          return e.id == view.body.issueTypeId;
        })
      );
      customViewIssue.name = view.name;
      customViewIssue.filters = view.body;
      customViewIssue.predicates = view.body.predicates;

      vm.openTab(
        customViewIssue.name,
        customViewIssue.icon,
        customViewIssue.color,
        customViewIssue.id,
        customViewIssue.filters,
        customViewIssue.predicates
      );
    };

    vm.deleteCustomView = function (view) {
      $rootScope.loading = true;
      IssuesFactory.deleteIssueCustomView(view.id)
        .then(function () {
          $toastr.success(
            $translationService.getTranslationController(
              "Vista eliminada",
              "View Deleted",
              "Visualização excluída"
            )
          );
          vm.customViews = vm.customViews.filter(function (e) {
            return e.id != view.id;
          });
        })
        .catch(function (err) {
          console.error("Error@deleteIssueCustomView", err);
          $toastr.error(
            $translationService.getTranslationController(
              "No se pudo eliminar",
              "Could not be removed",
              "Não foi possível remover"
            )
          );
        })
        .finally(function () {
          $rootScope.loading = false;
        });
    };

    vm.getIssuesCategories = function () {
      return new Promise(function (resolve, reject) {
        IssuesFactory.getIssuesCategories()
          .then(function (res) {
            var userAssignedCategories = res.data.filter(function (catg) {
              if ($permissionsFactory.hasCategory(catg.name)) {
                return catg;
              }
            });
            vm.issueCategories = userAssignedCategories;
            resolve();
          })
          .catch(function (err) {
            console.error("Error@getIssuesCategories", err);
            reject();
          });
      });
    };

    vm.getIssuesRelationships = function () {
      var relationships = [
        {
          value: "assigned",
          label: $translationService.getTranslationController("Asignado", "Assigned", "Atribuído"),
        },
        {
          value: "supervisor",
          label: $translationService.getTranslationController(
            "Supervisor",
            "Supervisor",
            "Supervisor"
          ),
        },
        {
          value: "invited",
          label: $translationService.getTranslationController("Invitado", "Invited", "Convidado"),
        },
        {
          value: "creator",
          label: $translationService.getTranslationController("Creador", "Creator", "Criador"),
        },
        {
          value: "group",
          label: $translationService.getTranslationController("Grupo", "Group", "Grupo"),
        },
      ];

      if (_hasAuditorRole()) {
        relationships.push({
          value: "admin",
          label: $translationService.getTranslationController(
            "Administrador",
            "Admin",
            "Administrador"
          ),
        });
      }

      return relationships;
    };

    function _hasAuditorRole() {
      if ($permissionsFactory.isAuditor() || $permissionsFactory.isSuperUser()) {
        return true;
      }
      return false;
    }

    vm.relationships = vm.getIssuesRelationships();

    vm.getRelationshipName = function (relationship) {
      var relation = vm.relationships.find(function (e) {
        return e.value == relationship;
      });

      return relation.label;
    };

    vm.changeRelationship = function (relationship) {
      vm.relatedBy = relationship;
      $localStorageService.setItem("relatedBy", relationship);
      $rootScope.$broadcast("changeIssuesRelationship", {
        relatedBy: vm.relatedBy,
      });

      vm.filterCounters();
    };

    vm.getIssuesTypes = function () {
      return new Promise(function (resolve, reject) {
        var req = {};

        if (vm.currentCategory) {
          req = {
            categoryId: vm.currentCategory.id,
          };
        }
        IssuesFactory.getIssuesTypes(req)
          .then(function (res) {
            vm.issueTypes = [];
            var issueLocalStorageKey = 'issue-' + vm.currentCategory.id;
            var valueInLocalStorage = $localStorageService.getItem(issueLocalStorageKey);

            if (valueInLocalStorage) {
              vm.issueTypes = res.sort(function (a, b) {
                return (
                  valueInLocalStorage.indexOf(
                    a.id
                  ) -
                  valueInLocalStorage.indexOf(b.id)
                );
              });
            } else {
              vm.issueTypes = res;
              _setupLocalStore();
            }
            resolve();
          })
          .catch(function (err) {
            console.error("Error@getIssuesTypes", err);
            reject();
          });
      });
    };

    vm.filterCounters = function () {
      $rootScope.loading = true;
      vm.getCounters().finally(function () {
        $rootScope.loading = false;
      });
    };

    $scope.$on("issuesDateChange", function (e, dates) {
      vm.getCounters();
    });

    vm.getCounters = function () {
      var req = {};

      if (vm.currentCategory) {
        req = {
          categoryId: vm.currentCategory.id,
          relatedBy: vm.relatedBy,
        };
      }

      if ($rootScope.issueDates.active) {
        req = Object.assign(req, {
          from: $rootScope.issueDates.from,
          to: $rootScope.issueDates.to,
        });
      }

      return new Promise(function (resolve, reject) {
        IssuesFactory.getIssuesCounter(req)
          .then(function (res) {
            vm.counters = res;
            resolve();
          })
          .catch(function (err) {
            reject();
          });
      });
    };

    vm.changeCategory = function (category) {
      $state.go(
        "app.dashboard",
        { category: category.name, issue: vm.selectedTab },
        { notify: true }
      );
    };

    vm.openTab = function (tab, icon, color, issueId, filters, predicates) {
      if (!_validateIssueExistence(issueId)) {
        return false;
      }
      var tabAlreadyExists = _tabAlreadyExists(tab);

      if (tabAlreadyExists) {
        if (predicates) {
          var findTab = vm.activeTabs.find(function (e) {
            return e.name == tab;
          });

          findTab.predicates = predicates;
        }
      } else {
        var activeTabExists = vm.activeTabs.find(function (e) {
          return e.name == tab;
        });

        if (!activeTabExists) {
          var tabToActivate = angular.copy(
            vm.issueTypes.find(function (e) {
              return e.id == issueId;
            })
          );
          tabToActivate.name = tab;
          tabToActivate.filters = filters;
          tabToActivate.predicates = predicates;
          vm.activeTabs.push(tabToActivate);
        } else {
          activeTabExists.filters = filters;
          activeTabExists.predicates = predicates;
        }

        vm.tabs.push({
          id: tab,
          name: tab,
          icon: icon,
          color: color,
        });
      }

      vm.setTabAndCurrentIssue(tab);
    };

    function _setupLocalStore() {
      var issueLocalStorageKey = 'issue-' + vm.currentCategory.id;
      $localStorageService.setItem(issueLocalStorageKey, vm.issueTypes.map(
        function (e) {
          return e.id;
        }
      ));
    }

    function _validateIssueExistence(issueId) {
      return vm.issueTypes.find(function (e) {
        return e.id == issueId;
      })
        ? true
        : false;
    }

    function _tabAlreadyExists(tab) {
      var tabAlreadyExists = vm.tabs.find(function (e) {
        return e.id == tab;
      });
      return tabAlreadyExists;
    }

    vm.setTabAndCurrentIssue = function (tab) {
      vm.selectedTab = tab;
      vm.currentIssue = vm.issueTypes.concat(vm.activeTabs).find(function (e) {
        return e.name == tab;
      });
      $state.go(
        "app.dashboard",
        { category: $state.params.category, issue: tab },
        { notify: false }
      );
    };

    vm.isTabSet = function (id) {
      return vm.selectedTab == id;
    };

    vm.isTabActive = function (id) {
      return vm.isTabSet(id) && id != "index";
    };

    vm.closeTab = function () {
      vm.tabs.splice(1, 1);
      vm.setTabAndCurrentIssue("index");
    };

    vm.manageIssue = function (data) {
      if (data.issuesToLink && data.issuesToLink.length > 0) {
        $toastr.info(
          $translationService.getTranslationController(
            data.issuesToLink.length + " issues vinculadas",
            data.issuesToLink.length + " issues linked",
            data.issuesToLink.length + " issues linked"
          )
        );
      }

      $mdDialog.show({
        controller: "IssuesDetailDialogController",
        controllerAs: "ctrl",
        templateUrl: "app/dashboard/components/issues-detail-dialog/issues-detail-dialog.html",
        parent: angular.element(document.body),
        targetEvent: data.ev || null,
        clickOutsideToClose: false,
        locals: {
          issueTypes: vm.issueTypes,
          currentIssueType: vm.currentIssue,
          issue: data.selectedIssue,
          issuesToLink: data.issuesToLink,
          currentCategory: vm.currentCategory,
        },
      });
    };

    vm.init();

    $scope.$on("refreshMaiMenu", function () {
      vm.init();
    });

    /********************************************** Modal search *******************************************/
    vm.onSearch = function (ev) {
      $mdDialog.show({
        multiple: true,
        controller: "SearcherController",
        templateUrl: "app/searcher/dialog-searcher.html",
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        controllerAs: "ctrl",
        targetEvent: ev,
      });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller("CustomReportsController", CustomReportsController);

  CustomReportsController.$inject = [
    "$scope",
    "$rootScope",
    "$mdDialog",
    "toastr",
    "$state",
    "FilesStorageFactory",
    "ConfigurationFactory",
    "$element",
    "$compile",
    "translationService",
    "CustomReportFactory",
    "DataTableFactory",
  ];
  function CustomReportsController(
    $scope,
    $rootScope,
    $mdDialog,
    toastr,
    $state,
    $filesStorageFactory,
    $configurationFactory,
    $element,
    $compile,
    $translationService,
    $customReportFactory,
    $dataTableFactory
  ) {
    var vm = this;

    $translationService.getTranslation(vm, "dashboard");

    vm.loading = true;
    vm.loadingCard = true;
    vm.currentCustomReport = null;
    vm.html = null;
    vm.reportType = "list";
    vm.columns = [];

    _getCustomReportById($state.params.reportId);

    vm.tabs = [
      {
        // Default tab
        id: "index",
        name: $state.params.report,
        icon: "cep-aml-clients",
        color: "ceptinel",
      },
    ];
    vm.selectedTab = 0;
    vm.currentTab = null;

    vm.onTabSelected = function (tab) {
      vm.loadingCard = true;
      vm.currentTab = tab;
      setTimeout(function () {
        vm.loadingCard = false;
      }, 50);
    };

    vm.onDeselect = function () {
      vm.currentTab = null;
    };

    vm.delTab = function (index) {
      // console.log("delTab", index);
      vm.tabs.splice(index, 1);
      vm.selectedTab = 0;
    };

    vm.clearTabs = function () {
      vm.tabs = [
        {
          id: "index",
          name: $state.params.report,
          icon: "cep-aml-clients",
          color: "ceptinel",
        },
      ];
      vm.selectedTab = 0;
      vm.currentTab = null;
    };

    vm.setRowTab = function (record) {
      // console.log("setRowTab", record);

      if (vm.currentCustomReport.tipo == "table") {
        var rowIsTab = vm.tabs.findIndex(function (t) {
          return t.id == record.row.id_row;
        });

        if (rowIsTab != -1) {
          vm.selectedTab = rowIsTab;
          return;
        }

        var newTabData = record;

        var name = record.row[vm.currentCustomReport.storageField] || "?";

        newTabData.id = record.row.id_row;
        newTabData.name = name;
        newTabData.schemaId = null;

        vm.tabs.push(newTabData);
        vm.selectedTab = vm.tabs.length - 1;
        $scope.$broadcast("init");
      }

      if (vm.currentCustomReport.tipo == "list") {
        var rowIsTab = vm.tabs.findIndex(function (t) {
          return t.id == record.row.__dataId;
        });

        if (rowIsTab != -1) {
          vm.selectedTab = rowIsTab;
          return;
        }
        var newTabData = record;

        var pk = Object.keys(record.row).find(function (e) {
          return e.startsWith("#");
        });

        var name =
          record.row[pk] ||
          record.row[vm.currentCustomReport.storageField] ||
          "?";

        newTabData.id = record.row.__dataId;
        newTabData.name = name;
        newTabData.schemaId = record.schemaId;

        vm.tabs.push(newTabData);
        vm.selectedTab = vm.tabs.length - 1;
        $scope.$broadcast("init");
      }
    };

    function _getCustomReportById(id) {
      vm.loading = true;
      if (!id) {
        console.error("error@_getCustomReportById", "id is null or undefined");
        toastr.error("id is null or undefined");
        vm.loading = false;
        return;
      }

      $customReportFactory
        .getCustomReportById(id)
        .then(function (result) {
          vm.currentCustomReport = result
          vm.currentCustomReport.tipo = vm.currentCustomReport.tipo || "list";

          //! **** TEST TABLE DATA ****
          // vm.currentCustomReport = {
          //   id: 3,
          //   name: "TABLE-SAMPLE",
          //   html: "cep-case",
          //   storageField: "integer",
          //   list: {},
          //   table: {
          //     schemaName: "canal_de_denuncias_1",
          //     tableName: "alldatatypes",
          //   },
          //   folder: {
          //     id: 16,
          //     name: "CUSTOM_REPORT",
          //   },
          //   file: {
          //     id: 51,
          //     name: "alldatatypes",
          //   },
          //   active: true,
          //   weight: 0,
          //   type: "table",
          // };

          vm.reportType = vm.currentCustomReport.tipo || "list";
          vm.loading = false;

          _getConfigFormatSchema();
          _getHtmlTemplate(result.folder.id, result.file.id);

          if (vm.currentCustomReport.tipo == "table") {
            $dataTableFactory
              .getTable(
                vm.currentCustomReport.table.tableName,
                vm.currentCustomReport.table.schemaName
              )
              .then(function (tableData) {
                vm.columns = tableData.columns;
              })
              .catch(function (err) {
                console.error("error@getTable", err);
              });
          }
        })
        .catch(function (err) {
          $state.go("app.custom-reports");
          console.error("error@getCustomReportById", err);
        });
    }

    function _getHtmlTemplate(folderId, fileId) {
      $rootScope.loading = false;
      vm.loading = true;
      $filesStorageFactory
        .downloadFile(folderId, fileId)
        .then(function (res) {
          vm.loading = false;
          $rootScope.loading = false;
          var reader = new FileReader();
          reader.onloadend = function () {
            vm.html = reader.result;
            var _HTML_ = angular.copy(vm.html);
            var regex = /<static-image[^>]+\/>/g;
            var matches = _HTML_.match(regex);
            if (Array.isArray(matches)) {
              for (var i = 0; i < matches.length; i++) {
                var match = matches[i];

                var regex_values = /folder="([^"]+)"\s+file="([^"]+)"\s+/;
                var matches_values = match.match(regex_values);
                var folder = matches_values[1];
                var file = matches_values[2];

                $filesStorageFactory
                  .downloadFile(folder, file)
                  .then(function (res) {
                    blobToBase64(res.data).then(function (base64) {
                      var imgdom =
                        "img src='data:image/jpg;base64," + base64 + "'";
                      var newHtml = match.replace("static-image", imgdom);
                      vm.html = _HTML_.replace(match, newHtml);
                    });
                  })
                  .catch(function (error) {
                    console.log(error);
                  });
              }
            }
          };

          reader.readAsText(res.data);
        })
        .catch(function (err) {
          console.error("error@downloadFile", err);
          vm.loading = false;
          $rootScope.loading = false;
        });
    }

    vm.schemasFormats = [];
    function _getConfigFormatSchema() {
      $configurationFactory
        .getSchemaFormat()
        .then(function (res) {
          vm.schemasFormats = res.data.map(function (schema) {
            schema.body = JSON.parse(schema.body);
            return schema;
          });
        })
        .catch(function (err) {
          console.error("Error@getSchemaFormat", err);
        });
    }

    function blobToBase64(blob) {
      return new Promise(function (resolve, _) {
        var reader = new FileReader();
        reader.onloadend = function () {
          return resolve(reader.result.split(";base64,").pop());
        };
        reader.readAsDataURL(blob);
      });
    }

    vm.showCustomReportDialog = function (selectedItem) {
      $mdDialog
        .show({
          multiple: true,
          controller: "dialogCustomReport",
          templateUrl: "app/custom-reports/dialog/dialog-custom-report.html",
          parent: angular.element(document.body),
          controllerAs: "ctrl",
          // targetEvent: ev,
          clickOutsideToClose: false,
          escapeToClose: false,
          resolve: {
            selectedItem: function () {
              return selectedItem;
            },
          },
        })
        .then(function (result) {
          console.log("result", result);
          vm.loadingCard = true;
          setTimeout(function () {
            vm.loadingCard = false;
          }, 100);
          var msg = $translationService.getTranslationController(
            "Configuracion creado exitosamente.",
            "Successfully created config.",
            "Configuração criado com sucesso."
          );
          toastr.success(msg);
          $mdDialog.hide();
          _getCustomReportById($state.params.reportId);
        });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("dashboard")
    .controller("CustomReportsHomeController", CustomReportsHomeController);

  CustomReportsHomeController.$inject = [
    "translationService",
    "$mdDialog",
    "toastr",
    "CustomReportFactory",
    "$state", 
  ];
  function CustomReportsHomeController(
    $translationService,
    $mdDialog,
    toastr,
    $customReportFactory,
    $state
  ) {
    var vm = this;

    $translationService.getTranslation(vm, "dashboard");

    vm.loading = true;
    vm.reports = [];
    vm.selecCustomReport = $translationService.getTranslationController(
      "Selecionar un custom report",
      "Select a custom report",
      "Selecionar um custom report"
    );

    vm.init = function () {
      vm.loading = true;
      getCustomReports()
        .then(function (data) {
          vm.reports = data;
          vm.loading = false;
        })
        .catch(function () {
          vm.loading = false;
        });
    };
    vm.init();

    vm.showCustomReportDialog = function (selectedItem) {
      $mdDialog
        .show({
          multiple: true,
          controller: "dialogCustomReport",
          templateUrl: "app/custom-reports/dialog/dialog-custom-report.html",
          parent: angular.element(document.body),
          controllerAs: "ctrl",
          // targetEvent: ev,
          clickOutsideToClose: false,
          escapeToClose: false,
          resolve: {
            selectedItem: function () {
              return selectedItem;
            },
          },
        })
        .then(function (result) {
          console.log("result", result);
          $state.go("app.custom-report", {
            // category: $state.params.category,
            report: result.name,
            reportId: result.id,
          });
          vm.loadingCard = true;
          setTimeout(function () {
            vm.loadingCard = false;
          }, 150);
          var msg = $translationService.getTranslationController(
            "Configuracion creado exitosamente.",
            "Successfully created config.",
            "Configuração criado com sucesso."
          );
          toastr.success(msg);
          $mdDialog.hide();
        });
    };

    function getCustomReports() {
      return new Promise(function (resolve, reject) {
        $customReportFactory
          .getCustomReports()
          .then(function (res) {
            resolve(res.data);
          })
          .catch(function (err) {
            console.error("Error@getCustomReports", err);
            reject();
          });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('CredencialesController', CredencialesController);

  CredencialesController.$inject = [
    '$scope',
    '$rootScope',
    'toastr',
    '$modal',
    'ReportsFactory',
    'translationService',
    '$state',
  ];

  function CredencialesController(
    $scope,
    $rootScope,
    toastr,
    $modal,
    ReportsFactory,
    $translationService,
    $state
  ) {
    $translationService.getTranslation($scope, 'credentials');

    $scope.initialLoad = true;
    $scope.loaderPBI = true;
    $scope.editorPowerBi = false;
    $scope.pbiInfo = {
      active: false,
      username: '',
      orgUsername: '',
    };

    $scope.toReports = function () {
      $state.go('app.bi-reports');
    };

    var mostrarAlert = function (tipo, msg) {
      $scope.msgAlert = msg;
      $scope.tipoAlert = tipo;
      $modal({
        templateUrl: 'app/credenciales/alert-credenciales.html',
        backdrop: 'static',
        size: 'md',
        scope: $scope,
        keyboard: true,
      });
    };

    var obtenerAcceso = function () {
      ReportsFactory.getAccess()
        .then(function (res) {
          $scope.pbiInfo = res;
          $scope.pbiInfo.orgUsername = res.username;
        })
        .catch(function (error) {
          if (error.status == 403) {
            toastr.error(
              $translationService.getTranslationController(
                'Usuario no autorizado.',
                'Unauthorized User.',
                'Usuário não autorizado.'
              )
            );
          } else {
            // Handle to no show toast if module is starting
            if (!$scope.initialLoad) {
              toastr.error(error.data.msg);
            } else {
              $scope.initialLoad = false;
            }
          }
        })
        .finally(function () {
          $scope.loaderPBI = false;
          $scope.$apply();
        });
    };
    obtenerAcceso();

    $scope.guardarCredencialesPBI = function () {
      if ($scope.pbiInfo.clientId === undefined) {
        toastr.error('error - Application Id');
      } else if ($scope.pbiInfo.clientSecret === undefined) {
        toastr.error('error - Application Id');
      } else if ($scope.pbiInfo.username === undefined) {
        toastr.error('error - username');
      } else if ($scope.pbiInfo.password === undefined) {
        toastr.error('error - password');
      } else {
        $scope.loaderPBI = true;
        ReportsFactory.saveCredentials(this.pbiInfo)
          .then(function (res) {
            toastr.success(
              $translationService.getTranslationController(
                'Su configuración de credenciales ha sido guardada exitosamente',
                'Your credentials configuration has been successfully saved',
                'Sua configuração de credenciais foi salva com sucesso'
              )
            );
            obtenerAcceso();
            $scope.loaderPBI = false;
            $scope.editorPowerBi = false;
          })
          .catch(function (error) {
            console.log(error);
            $scope.pbiInfo.active = false;
            $scope.loaderPBI = false;
            $scope.$apply();
            if (error.status == 403) {
              toastr.error(
                $translationService.getTranslationController(
                  'Usuario no autorizado.',
                  'Unauthorized User.',
                  'Usuário não autorizado.'
                )
              );
            } else {
              toastr.error(error.data.msg);
            }
            $scope.cancelarEdicion();
          });
      }
    };
    $scope.cancelarEdicion = function () {
      if ($scope.pbiInfo) {
        $scope.pbiInfo.username = $scope.pbiInfo.orgUsername;
      }
      $scope.editorPowerBi = false;
    };
  }
})();

(function () {
  "use strict";

  angular.module("dashboard").controller("ConfigurationController", ConfigurationController);

  ConfigurationController.$inject = [
    "$rootScope",
    "$stateParams",
    "translationService",
    "$mdDialog",
    "toastr",
    "ConfigurationFactory",
    "IssueCategoryFactory",
    "IssueTypeFactory",
    "PermissionsFactory",
    "CustomReportFactory",
    "ExternalLibrariesFactory",
    "HolidaysFactory",
  ];

  function ConfigurationController(
    $rootScope,
    $stateParams,
    $translationService,
    $mdDialog,
    toastr,
    ConfigurationFactory,
    IssueCategoryFactory,
    IssueTypeFactory,
    PermissionsFactory,
    $customReportFactory,
    $externalLibrariesFactory,
    $holidaysFactory
  ) {
    var vm = this;

    (function init() {
      $translationService.getTranslation(vm, "configuration");
      vm.config = {
        datasource: {
          origin: "GET", //REST Methods, ARRAY, WS(WebSocket)
          url: "/risk-backend/rest/config/system", //solo para rest y ws
          params: {
            query: "",
            sortBy: "id",
            sort: "desc",
            startDate: moment(
              $stateParams.desde || moment().subtract(1, "week").hour(0).minute(0).second(0)
            ),
            endDate: moment($stateParams.hasta || moment().hour(23).minute(59).second(59)),
            page: 1,
            itemsPerPage: 25,
          },
          paramsOut: {
            data: "data",
            pagination: "pagination",
          },
        },
        pageSizes: [25, 50, 100],
        columns: [
          { field: "id", title: "Id", type: "number", show: true, width: 3 },
          {
            field: "createAt",
            title: $translationService.getTranslationController(
              "Fecha Creación",
              "Created date",
              "Data de criação"
            ),
            type: "date",
            show: true,
            width: 5,
          },
          {
            field: "delete",
            title: "",
            type: "command",
            show: true,
            width: 2,
            sortable: false,
          },
        ],
      };

      vm.configKeyStorage = {
        datasource: {
          origin: "GET", //REST Methods, ARRAY, WS(WebSocket)
          url: "/risk-backend/rest/config/keystorage", //solo para rest y ws
          params: {
            query: "",
            sortBy: "id",
            sort: "desc",
            startDate: moment(
              $stateParams.desde || moment().subtract(1, "week").hour(0).minute(0).second(0)
            ),
            endDate: moment($stateParams.hasta || moment().hour(23).minute(59).second(59)),
            page: 1,
            itemsPerPage: 25,
          },
          paramsOut: {
            data: "data",
            pagination: "pagination",
          },
        },
        pageSizes: [25, 50, 100],
        columns: [
          {
            field: "path",
            title: "path",
            type: "text",
            show: true,
            width: 80,
          },
          {
            field: "type",
            title: $translationService.getTranslationController("Tipo", "Type", "Tipo"),
            type: "text",
            show: true,
            width: 10,
          },
          {
            field: "subtype",
            title: $translationService.getTranslationController("Subtipo", "Subtype", "Subtipo"),
            type: "text",
            show: true,
            width: 10,
          },
          {
            field: "delete",
            title: "",
            type: "command",
            show: true,
            width: 2,
            sortable: false,
          },
        ],
      };

      vm.configCategory = {
        datasource: {
          origin: "GET", //REST Methods, ARRAY, WS(WebSocket)
          url: "/risk-backend/rest/issue/admin/category", //solo para rest y ws
          params: {
            query: "",
            sortBy: "id",
            sort: "desc",
            startDate: moment(
              $stateParams.desde || moment().subtract(1, "week").hour(0).minute(0).second(0)
            ),
            endDate: moment($stateParams.hasta || moment().hour(23).minute(59).second(59)),
            page: 1,
            itemsPerPage: 25,
          },
          paramsOut: {
            data: "data",
            pagination: "pagination",
          },
        },
        pageSizes: [25, 50, 100],
        columns: [
          {
            field: "id",
            title: "id",
            type: "number",
            show: true,
            sortable: false,
            width: 3,
          },
          {
            field: "code",
            title: "code",
            type: "text",
            show: true,
            sortable: false,
            width: 10,
          },
          {
            field: "name",
            title: $translationService.getTranslationController("Nombre", "Name", "Nome"),
            type: "text",
            show: true,
            sortable: "name",
            width: 30,
          },
          {
            field: "label",
            title: $translationService.getTranslationController(
              "Label",
              "Label",
              "Etiqueta"
            ),
            type: "text",
            show: true,
            sortable: "label",
            width: 30,
          },
          {
            field: "color",
            title: $translationService.getTranslationController("Color", "Color", "Color"),
            type: "text",
            show: true,
            sortable: "color",
            width: 10,
          },
          {
            field: "icon",
            title: $translationService.getTranslationController("Icono", "Icon", "Icono"),
            type: "text",
            show: true,
            sortable: "icon",
            width: 10,
          },
          {
            field: "delete",
            title: "",
            type: "command",
            show: true,
            width: 2,
            sortable: false,
          },
        ],
      };

      vm.configIssueType = {
        datasource: {
          origin: "GET", //REST Methods, ARRAY, WS(WebSocket)
          url: "/risk-backend/rest/issue/admin/type", //solo para rest y ws
          params: {
            query: "",
            sortBy: "name",
            sort: "desc",
            startDate: moment(
              $stateParams.desde || moment().subtract(1, "week").hour(0).minute(0).second(0)
            ),
            endDate: moment($stateParams.hasta || moment().hour(23).minute(59).second(59)),
            page: 1,
            itemsPerPage: 25,
          },
          paramsOut: {
            data: "data",
            pagination: "pagination",
          },
        },
        pageSizes: [25, 50, 100],
        columns: [
          {
            field: "id",
            title: "id",
            type: "number",
            show: true,
            sortable: "id",
            width: 3,
          },
          {
            field: "code",
            title: "code",
            type: "text",
            show: true,
            sortable: "code",
            width: 10,
          },
          {
            field: "name",
            title: $translationService.getTranslationController("Nombre", "Name", "Nome"),
            type: "text",
            show: true,
            sortable: "name",
            width: 30,
          },
          {
            field: "category",
            title: $translationService.getTranslationController(
              "Categoria",
              "Category",
              "Categoria"
            ),
            type: "object",
            key: "name",
            show: true,
            width: 10,
            sortable: "category.name",
          },
          {
            field: "group",
            title: $translationService.getTranslationController(
              "Grupo",
              "Group",
              "Grupo"
            ),
            type: "text",
            key: "group",
            show: true,
            sortable: "group",
            width: 10,
          },
          {
            field: "order",
            title: $translationService.getTranslationController(
              "Orden",
              "Order",
              "Ordem"
            ),
            type: "text",
            key: "order",
            show: true,
            sortable: "order",
            width: 10,
          },
          {
            field: "share",
            title: "",
            type: "command",
            show: true,
            width: 2,
            sortable: false,
          },
          {
            field: "delete",
            title: "",
            type: "command",
            show: true,
            width: 2,
            sortable: false,
          },
        ],
      };

      vm.configHolidays = {
        datasource: {
          origin: "GET", //REST Methods, ARRAY, WS(WebSocket)
          url: "/risk-backend/rest/holidays", //solo para rest y ws
          params: {
            itemsPerPage: 25,
            page: 1,
            orderBy: "weight",
            sort: "asc",
          },
          paramsOut: {
            data: "data",
            pagination: "pagination",
          },
        },
        pageSizes: [25, 50, 100],
        columns: [
          {
            field: "id",
            title: "id",
            type: "number",
            show: true,
            sortable: false,
            width: 3,
          },
          {
            field: "holiday",
            title: "name",
            type: "text",
            show: true,
            sortable: false,
            width: 10,
          },
          {
            field: "delete",
            title: "",
            type: "command",
            show: true,
            width: 2,
            sortable: false,
          },
        ],
      };

      vm.configCompany = {
        datasource: {
          origin: "GET", //REST Methods, ARRAY, WS(WebSocket)
          url: "/risk-backend/rest/companies", //solo para rest y ws
          params: {
            query: "",
            sortBy: "id",
            sort: "desc",
            startDate: moment(
              $stateParams.desde || moment().subtract(1, "week").hour(0).minute(0).second(0)
            ),
            endDate: moment($stateParams.hasta || moment().hour(23).minute(59).second(59)),
            page: 1,
            itemsPerPage: 25,
          },
          paramsOut: {
            data: "data",
            pagination: "pagination",
          },
        },
        pageSizes: [25, 50, 100],
        columns: [
          {
            field: "id",
            title: "Id",
            type: "number",
            show: true,
            sortable: "id",
            width: 3,
          },
          {
            field: "name",
            title: $translationService.getTranslationController("Nombre", "Name", "Nome"),
            type: "text",
            show: true,
            sortable: "name",
            width: 20,
          },
          {
            field: "root",
            title: $translationService.getTranslationController("Casa", "Home", "Casa"),
            type: "text",
            show: true,
            width: 5,
          },
          {
            field: "active",
            title: $translationService.getTranslationController("Estado", "Status", "Estado"),
            type: "boolean",
            show: true,
            width: 5,
          },
        ],
      };

      vm.configShemaFormat = {
        datasource: {
          origin: "GET", //REST Methods, ARRAY, WS(WebSocket)
          url: "/risk-backend/rest/config/system/level-icons", //solo para rest y ws
          params: {
            query: "",
            sortBy: "id",
            sort: "desc",
            startDate: moment(
              $stateParams.desde || moment().subtract(1, "week").hour(0).minute(0).second(0)
            ),
            endDate: moment($stateParams.hasta || moment().hour(23).minute(59).second(59)),
            page: 1,
            itemsPerPage: 25,
          },
          paramsOut: {
            data: "data",
            pagination: "pagination",
          },
        },
        pageSizes: [25, 50, 100],
        columns: [
          {
            field: "id",
            title: "id",
            type: "number",
            show: true,
            sortable: false,
            width: 3,
          },
          {
            field: "name",
            title: $translationService.getTranslationController("Nombre", "Name", "Nome"),
            type: "text",
            show: true,
            sortable: "name",
            width: 10,
          },
          {
            field: "delete",
            title: "",
            type: "command",
            show: true,
            width: 2,
            sortable: false,
          },
        ],
      };

      vm.configProviders = {
        datasource: {
          origin: "GET", //REST Methods, ARRAY, WS(WebSocket)
          url: "/risk-backend/rest/oauth2-providers", //solo para rest y ws
          params: {
            query: "",
            sortBy: "id",
            sort: "desc",
            startDate: moment(
              $stateParams.desde || moment().subtract(1, "week").hour(0).minute(0).second(0)
            ),
            endDate: moment($stateParams.hasta || moment().hour(23).minute(59).second(59)),
            page: 1,
            itemsPerPage: 25,
          },
          paramsOut: {
            data: "data",
            pagination: "pagination",
          },
        },
        pageSizes: [25, 50, 100],
        columns: [
          {
            field: "id",
            title: "Id",
            type: "number",
            show: true,
            sortable: "id",
            width: 3,
          },
          {
            field: "providerName",
            title: $translationService.getTranslationController("Nombre", "Name", "Nome"),
            type: "text",
            show: true,
            sortable: "name",
            width: 10,
          },
          {
            field: "active",
            title: $translationService.getTranslationController("Estado", "Status", "Estado"),
            type: "boolean",
            show: true,
            width: 5,
          },
        ],
      };

      vm.configCustomReports = {
        datasource: {
          origin: "GET", //REST Methods, ARRAY, WS(WebSocket)
          url: "/risk-backend/rest/custom-report", //solo para rest y ws
          params: {
            active: true,
            itemsPerPage: 25,
            page: 1,
            orderBy: "weight",
            sort: "asc",
          },
          paramsOut: {
            data: "data",
            pagination: "pagination",
          },
        },
        pageSizes: [25, 50, 100],
        columns: [
          {
            field: "id",
            title: "Id",
            type: "number",
            show: false,
            sortable: "id",
            width: 3,
          },
          {
            field: "html",
            title: "Icon",
            type: "cepicon",
            show: true,
            width: 5,
          },
          {
            field: "weight",
            title: "order",
            type: "number",
            sortable: "weight",
            show: true,
            width: 5,
          },
          {
            field: "name",
            title: $translationService.getTranslationController("Nombre", "Name", "Nome"),
            type: "text",
            show: true,
            sortable: "name",
            width: 10,
          },
          {
            field: "list",
            key: "name",
            title: "List",
            type: "object",
            show: true,
            width: 10,
          },
          {
            field: "file",
            key: "name",
            title: "Template",
            type: "object",
            show: true,
            width: 10,
          },
          {
            field: "share",
            title: "",
            type: "command",
            show: true,
            width: 2,
            sortable: false,
          },
          {
            field: "delete",
            title: "",
            type: "command",
            show: true,
            width: 2,
            sortable: false,
          },
        ],
      };
    })();

    vm.validatePermission = function (permission) {
      return PermissionsFactory.hasPermission(permission);
    };

    vm.remove = function (_schemaFormat) {
      var confirm = $mdDialog
        .confirm()
        .title(
          $translationService.getTranslationController(
            "Eliminar Configuración",
            "Delete Configuration",
            "Excluir Configuração"
          )
        )
        .textContent(
          $translationService.getTranslationController(
            "¿Estas seguro que quieres borrarlo?",
            "Are you sure you want to delete?",
            "Tem certeza de que deseja excluir?"
          )
        )
        .ok($translationService.getTranslationController("Si", "Yes", "Sim"))
        .cancel($translationService.getTranslationController("No", "No", "Não"));

      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loading = true;
          ConfigurationFactory.delete(_schemaFormat.id).then(
            function (response) {
              $rootScope.loading = false;
              $rootScope.$broadcast("refreshNgTableDynamic", {
                tableId: "configuration-table",
              });
              toastr.success(
                $translationService.getTranslationController(
                  "Configuración eliminado exitosamente.",
                  "Successfully removed Configuration.",
                  "Configuração excluído com sucesso."
                )
              );
            },
            function (error) {
              $rootScope.loading = false;
              var msg = $translationService.getTranslationController(
                "No fue posible eliminar la Configuración.",
                "It was not possible to delete the Configuration.",
                "Não foi possível excluir o Configuração."
              );
              toastr.error(msg);
              console.log(error);
            }
          );
        },
        function () {}
      );
    };

    vm.removeKeyStorage = function (_configuration) {
      var confirm = $mdDialog
        .confirm()
        .title(
          $translationService.getTranslationController(
            "Eliminar KeyStorage",
            "Delete KeyStorage",
            "Excluir KeyStorage"
          )
        )
        .textContent(
          $translationService.getTranslationController(
            "¿Estas seguro que quieres borrarlo?",
            "Are you sure you want to delete?",
            "Tem certeza de que deseja excluir?"
          )
        )
        .ok($translationService.getTranslationController("Si", "Yes", "Sim"))
        .cancel($translationService.getTranslationController("No", "No", "Não"));

      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loading = true;
          ConfigurationFactory.deleteKeyStorage(_configuration.path).then(
            function (response) {
              $rootScope.loading = false;
              $rootScope.$broadcast("refreshNgTableDynamic", {
                tableId: "keystorage-table",
              });
              toastr.success(
                $translationService.getTranslationController(
                  "KeyStorage eliminado exitosamente.",
                  "Successfully removed KeyStorage.",
                  "KeyStorage excluído com sucesso."
                )
              );
            },
            function (error) {
              $rootScope.loading = false;
              var msg = $translationService.getTranslationController(
                "No fue posible eliminar la KeyStorage.",
                "It was not possible to delete the KeyStorage.",
                "Não foi possível excluir o KeyStorage."
              );
              toastr.error(msg);
              console.log(error);
            }
          );
        },
        function () {}
      );
    };

    vm.removeCategory = function (_category) {
      var confirm = $mdDialog
        .confirm()
        .title(
          $translationService.getTranslationController(
            "Eliminar Categoría",
            "Delete Category",
            "Excluir Categoría"
          )
        )
        .textContent(
          $translationService.getTranslationController(
            "¿Estas seguro que quieres borrarlo?",
            "Are you sure you want to delete?",
            "Tem certeza de que deseja excluir?"
          )
        )
        .ok($translationService.getTranslationController("Si", "Yes", "Sim"))
        .cancel($translationService.getTranslationController("No", "No", "Não"));

      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loading = true;
          IssueCategoryFactory.delete(_category.id).then(
            function (response) {
              $rootScope.loading = false;
              $rootScope.$broadcast("refreshNgTableDynamic", {
                tableId: "category-table",
              });
              toastr.success(
                $translationService.getTranslationController(
                  "Categoría eliminado exitosamente.",
                  "Successfully removed Category.",
                  "Categoría excluído com sucesso."
                )
              );
            },
            function (error) {
              $rootScope.loading = false;
              var msg = $translationService.getTranslationController(
                "No fue posible eliminar la Categoría.",
                "It was not possible to delete the Category.",
                "Não foi possível excluir o Categoría."
              );
              toastr.error(msg);
              console.log(error);
            }
          );
        },
        function () {}
      );
    };

    vm.removeIssueType = function (_category) {
      var confirm = $mdDialog
        .confirm()
        .title(
          $translationService.getTranslationController(
            "Eliminar Tipo de problema",
            "Delete Issue Type",
            "Excluir Tipo de problema"
          )
        )
        .textContent(
          $translationService.getTranslationController(
            "¿Estas seguro que quieres borrarlo?",
            "Are you sure you want to delete?",
            "Tem certeza de que deseja excluir?"
          )
        )
        .ok($translationService.getTranslationController("Si", "Yes", "Sim"))
        .cancel($translationService.getTranslationController("No", "No", "Não"));

      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loading = true;
          IssueTypeFactory.delete(_category.id).then(
            function (response) {
              $rootScope.loading = false;
              $rootScope.$broadcast("refreshNgTableDynamic", {
                tableId: "issues-type-table",
              });
              toastr.success(
                $translationService.getTranslationController(
                  "Tipo eliminado exitosamente.",
                  "Successfully removed Type.",
                  "Tipo excluído com sucesso."
                )
              );
            },
            function (error) {
              $rootScope.loading = false;
              var msg = $translationService.getTranslationController(
                "No fue posible eliminar el Tipo.",
                "It was not possible to delete the Type.",
                "Não foi possível excluir o Tipo."
              );
              toastr.error(msg);
              console.log(error);
            }
          );
        },
        function () {}
      );
    };

    /********************************************** Password policy ***********************************************/
    vm.passwordPolicy = {
      isPasswordLength: false,
      passwordLength: 0,
      isUpperCaseCharacter: false,
      isLowerCaseCharacter: false,
      isNumericCharacter: false,
      isSpecialCharacter: false,

      isExpiredPassword: false,
      expiredPassword: 0,
      isReusedPassword: false,
      reusedPassword: 0,
    };

    /********************************************** Modal Create Configuration ************************************/
    vm.showCreateConfigurationDialog = function (selectedItem) {
      $mdDialog.show({
        controller: DialogController,
        templateUrl: "app/configuration/dialog-create-configuration.html",
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        resolve: {
          selectedItem: function () {
            return selectedItem;
          },
        },
      });
    };

    DialogController.$inject = [
      "$scope",
      "$mdDialog",
      "translationService",
      "selectedItem",
      "PermissionsFactory",
      "ConfigurationFactory",
      "DashboardService",
    ];

    function DialogController(
      $scope,
      $mdDialog,
      $translationService,
      selectedItem,
      PermissionsFactory,
      ConfigurationFactory,
      DashboardService
    ) {
      $translationService.getTranslation($scope, "configuration");

      $scope.relationships = [
        {
          value: "assigned",
          label: $translationService.getTranslationController("Asignado", "Assigned", "Atribuído"),
        },
        {
          value: "supervisor",
          label: $translationService.getTranslationController(
            "Supervisor",
            "Supervisor",
            "Supervisor"
          ),
        },
        {
          value: "invited",
          label: $translationService.getTranslationController("Invitado", "Invited", "Convidado"),
        },
        {
          value: "creator",
          label: $translationService.getTranslationController("Creador", "Creator", "Criador"),
        },
        {
          value: "group",
          label: $translationService.getTranslationController("Grupo", "Group", "Grupo"),
        },
      ];

      (function init() {
        $scope.tab = "json";
        if (angular.isUndefined(selectedItem)) {
          selectedItem = {
            systemType: "Cumplimiento",
            emailFrom: {
              email: "security@ceptinel.com",
              name: "Ceptinel - Regtech suite",
            },
            cases: {
              status: ["abierto", "cerrado"],
              category: ["AML"],
              notificationByEmailActive: true,
              notificationTemplateIdExecutive: "d-a7aa2ca469174fd0b8be476f9141764d",
              notificationMonitor: "security@ceptinel.com",
              notificationUriDomain: "https://dev.ceptinel.com/cases",
            },
            issues: {
              activateNotificationByEmail: true,
              notificationDomainURL: "https://dev.ceptinel.com/cases",
              logo: null,
              relatedBy: "assigned",
            },
            storage: {
              downloadFileWithoutAuthentication: true,
              includeFileACLs: true,
            },
            ethicalPortal: {
              notificationByEmail: false,
              emailTo: "security@ceptinel.com",
              emailFrom: "security@ceptinel.com",
              issueTypeId: 903,
              evidenceSchemaId: 50006,
              labelAuthorCommentPublic: "Anonymous Anonymous",
              labelAuthorCommentPrivate: "Portal Ético",
              assignedUser: "ceptinel",
              creatorUser: "ceptinel",
              assignedGroup: "Administrator",
            },
            dashboard: {
              logo: {
                file: null,
                folder: null,
              },
              theme: "ceptinel",
              chartTheme: ["#ef414b", "#5a2c7e", "#fbb03b", "#39b54a", "#808080"],
            },
            passwordPolicy: {
              showPasswordPolicy: false,
              minimumPasswordLength: 0,
              withAtLeastOneUppercase: false,
              withAtLeastOneLowercase: false,
              withAtLeastOneDigit: false,
              withAtLeastOneSymbol: false,
              expirePasswordInDays: 0,
              rememberLastPasswords: 0,
            },
            notificationsByEmail: {
              enable: false,
            },
            security: {
              openSessionQuantity: 0,
              serviceUserTokenExpirationTime: 30,
              commonUserTokenExpirationTime: 30,
            },
            documents: { timeToLiveInDays: 30}
          };
          $scope.myConfigSchemaJson = angular.toJson(selectedItem, true);
        } else {
          $scope.myConfigSchemaJson = angular.toJson(selectedItem.body, true);
        }
        $scope.actionText = $translationService.getTranslationController(
          "Agregar una Configuración",
          "Add a Configuration",
          "Adicionar uma Configuração"
        );
        $scope.permission = "configuration:create";
      })();

      $scope.loading = true;

      setTimeout(function () {
        $scope.loading = false;
      }, 1000);

      $scope.editor = null;
      $scope.status = "fail";

      $scope.convert = function (tab) {
        if (tab == "json") {
          $scope.mySchemaJson = angular.toJson($scope.mySchemaForm, true);
          $scope.tab = "json";
        } else {
          $scope.tab = "form";
          $scope.mySchemaForm = angular.fromJson($scope.editor.getValue());
          if (
            angular.isUndefined($scope.mySchemaForm.passwordPolicy) ||
            angular.isUndefined($scope.mySchemaForm.passwordPolicy.showPasswordPolicy)
          ) {
            $scope.mySchemaForm.passwordPolicy = {
              showPasswordPolicy: false,
              minimumPasswordLength: 0,
              withAtLeastOneUppercase: false,
              withAtLeastOneLowercase: false,
              withAtLeastOneDigit: false,
              withAtLeastOneSymbol: false,
              expirePasswordInDays: 0,
              rememberLastPasswords: 0,
            };
          } else {
            $scope.mySchemaForm.passwordPolicy.minimumPasswordLength = parseFloat(
              $scope.mySchemaForm.passwordPolicy.minimumPasswordLength
            );
            $scope.mySchemaForm.passwordPolicy.expirePasswordInDays = parseFloat(
              $scope.mySchemaForm.passwordPolicy.expirePasswordInDays
            );
            $scope.mySchemaForm.passwordPolicy.rememberLastPasswords = parseFloat(
              $scope.mySchemaForm.passwordPolicy.rememberLastPasswords
            );
          }
          if (angular.isUndefined($scope.mySchemaForm.issues)) {
            $scope.mySchemaForm.issues = {};
          }
          if (angular.isUndefined($scope.mySchemaForm.ethicalPortal)) {
            $scope.mySchemaForm.ethicalPortal = {
              emailTo: "security@ceptinel.com",
              emailFrom: "security@ceptinel.com",
              issueTypeId: 903,
              evidenceSchemaId: 50006,
              labelAuthorCommentPublic: "Anonymous Anonymous",
              labelAuthorCommentPrivate: "Portal Ético",
              assignedUser: "ceptinel",
            };
          } else {
            $scope.mySchemaForm.ethicalPortal.issueTypeId = parseFloat(
              $scope.mySchemaForm.ethicalPortal.issueTypeId
            );
            $scope.mySchemaForm.ethicalPortal.evidenceSchemaId = parseFloat(
              $scope.mySchemaForm.ethicalPortal.evidenceSchemaId
            );
          }
          if (angular.isUndefined($scope.mySchemaForm.chartTheme)) {
            $scope.mySchemaForm.chartTheme = [];
          }
          if (angular.isUndefined($scope.mySchemaForm.security)) {
            $scope.mySchemaForm.security = {
              openSessionQuantity: 0,
              serviceUserTokenExpirationTime: 30,
              commonUserTokenExpirationTime: 30,
              chat: {
                enabled: false,
                inputTable: "",
                inputSchema: "",
                outputTable: "",
                outputSchema: "",
              },
            };
          }
          //dashboard
          if (angular.isUndefined($scope.mySchemaForm.dashboard)) {
            $scope.mySchemaForm.dashboard = {
              logo: {
                file: null,
                folder: null,
              },
              theme: "ceptinel",
              chartTheme: [
                "#ef414b",
                "#5a2c7e",
                "#fbb03b",
                "#39b54a",
                "#808080",
              ],
              homePage: {
                SA: "",
                U: "",
              }
            };
          }
          if (angular.isUndefined($scope.mySchemaForm.dashboard.chartTheme)) {
            $scope.mySchemaForm.dashboard.chartTheme = [
                "#ef414b",
                "#5a2c7e",
                "#fbb03b",
                "#39b54a",
                "#808080",
              ]
          }
          if (angular.isUndefined($scope.mySchemaForm.dashboard.logo)) {
            $scope.mySchemaForm.dashboard.logo = {
              file: null,
              folder: null,
            };
          }
          if (angular.isUndefined($scope.mySchemaForm.dashboard.homePage)) {
            $scope.mySchemaForm.dashboard.homePage = {
              SA: "",
              U: "",
            };
          }
          if (angular.isUndefined($scope.mySchemaForm.issues)) {
            $scope.mySchemaForm.issues = {};
          }
        }
      };

      $scope.editorLoaded = function (_editor) {
        $scope.editor = _editor;
        $scope.status = "Loaded";
      };

      $scope.cancel = function (ev) {
        var confirm = $mdDialog
          .confirm()
          .multiple(true)
          .title(
            $translationService.getTranslationController(
              "¿Deseas cancelar?",
              "Do you want to cancel?",
              "Você quer cancelar?"
            )
          )
          .textContent(
            $translationService.getTranslationController(
              "¡Todos los cambios se perderán!",
              "All changes will be lost!",
              "Todas as alterações serão perdidas!"
            )
          )
          .ariaLabel("Cancel-Question")
          .targetEvent(ev)
          .ok($translationService.getTranslationController("Abandonar", "Leave", "Deixar"))
          .cancel($translationService.getTranslationController("Cancelar", "Cancel", "Cancelar"));

        $mdDialog.show(confirm).then(
          function () {
            $mdDialog.cancel();
          },
          function () {}
        );
      };

      $scope.save = function () {
        var configuration;
        if ($scope.tab == "form") {
          configuration = angular.toJson($scope.mySchemaForm);
        }
        if ($scope.tab == "json") {
          configuration = angular.fromJson($scope.editor.getValue());
        }

        $rootScope.loading = true;
        ConfigurationFactory.create(configuration)
          .then(
            function (response) {
              console.log(response);
              var configuration = typeof response.config.data === "string" ? JSON.parse(response.config.data) : response.config.data;
              var chatbotIsEnabled = configuration.security.chat.enabled;
              $rootScope.$broadcast("refreshNgTableDynamic", {
                tableId: "configuration-table",
              });
              $rootScope.$broadcast("chatbotIsEnabled", chatbotIsEnabled);
              var msg = $translationService.getTranslationController(
                "Configuración creada exitosamente.",
                "Configuration successfully created.",
                "Configuração criado com sucesso."
              );
              toastr.success(msg);
              $mdDialog.hide();
            },
            function (error) {
              toastr.error(error);
            }
          )
          .finally(function () {
            $rootScope.loading = false;
          });
      };

      $scope.validatePermission = function () {
        return PermissionsFactory.hasPermission($scope.permission);
      };

      /********************************************** Form Control ********************************************/
      $scope.onChangeDashboardTheme = function () {
        $scope.mySchemaForm.dashboard.logo.folder = "";
        $scope.mySchemaForm.dashboard.logo.file = "";
      };

      function _randColor() {
        var color = "#000000".replace(/0/g, function () {
          return (~~(Math.random() * 16)).toString(16);
        });
        return color;
      }

      $scope.onChangeColor = function (color, index) {
        $scope.mySchemaForm.dashboard.chartTheme[index] = color;
      };
      $scope.removeColor = function (index) {
        $scope.mySchemaForm.dashboard.chartTheme.splice(index, 1);
      };
      $scope.addColor = function () {
        $scope.mySchemaForm.dashboard.chartTheme.push(_randColor());
      };
    }

    /********************************************** Modal Create KeyStorage ***************************************/
    vm.showCreateKeyStorageDialog = function (selectedItem) {
      $mdDialog.show({
        controller: DialogKeyStorageController,
        templateUrl: "app/configuration/dialog-create-keystorage.html",
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        resolve: {
          selectedItem: function () {
            return selectedItem;
          },
        },
      });
    };

    DialogKeyStorageController.$inject = [
      "$scope",
      "$mdDialog",
      "translationService",
      "selectedItem",
      "PermissionsFactory",
      "ConfigurationFactory",
    ];

    function DialogKeyStorageController(
      $scope,
      $mdDialog,
      $translationService,
      selectedItem,
      PermissionsFactory,
      ConfigurationFactory
    ) {
      $translationService.getTranslation($scope, "configuration");

      (function init() {
        console.log("++++++ ConfigurationController->crate key-storage +++++++");

        if (angular.isUndefined(selectedItem)) {
          $scope.readonly = false;
          $scope.permission = "configuration:create";
          $scope.actionText = $translationService.getTranslationController(
            "Crear Key-Storage",
            "Create Key-Storage",
            "Criar Key-Storage"
          );
          $scope.keystorage = { type: "secret", subtype: "generic_secret" };
        } else {
          $scope.readonly = true;
          $scope.permission = "configuration:update";
          $scope.actionText = $translationService.getTranslationController(
            "Actualizar Key-Storage ",
            "Update Key-Storage",
            "Atualizar Key-Storage"
          );
          $scope.keystorage = angular.copy(selectedItem);
        }
      })();

      $scope.cancel = function (ev) {
        var confirm = $mdDialog
          .confirm()
          .multiple(true)
          .title(
            $translationService.getTranslationController(
              "¿Deseas cancelar?",
              "Do you want to cancel?",
              "Você quer cancelar?"
            )
          )
          .textContent(
            $translationService.getTranslationController(
              "¡Todos los cambios se perderán!",
              "All changes will be lost!",
              "Todas as alterações serão perdidas!"
            )
          )
          .ariaLabel("Cancel-Question")
          .targetEvent(ev)
          .ok($translationService.getTranslationController("Abandonar", "Leave", "Deixar"))
          .cancel($translationService.getTranslationController("Cancelar", "Cancel", "Cancelar"));

        $mdDialog.show(confirm).then(
          function () {
            $mdDialog.cancel();
          },
          function () {}
        );
      };

      $scope.save = function () {
        if (angular.isUndefined(selectedItem)) {
          ConfigurationFactory.createKeyStorage($scope.keystorage).then(
            function (response) {
              $rootScope.$broadcast("refreshNgTableDynamic", {
                tableId: "keystorage-table",
              });
              var msg = $translationService.getTranslationController(
                "KeyStorage creado exitosamente.",
                "Successfully created KeyStorage.",
                "KeyStorage criado com sucesso."
              );
              toastr.success(msg);
              $rootScope.loading = false;
              $mdDialog.hide();
            },
            function (error) {
              console.log(error);
              toastr.error(error.data);
              $rootScope.loading = false;
            }
          );
        } else {
          ConfigurationFactory.updateKeyStorage($scope.keystorage).then(
            function (response) {
              $rootScope.$broadcast("refreshNgTableDynamic", {
                tableId: "keystorage-table",
              });
              var msg = $translationService.getTranslationController(
                "KeyStorage actualizado exitosamente.",
                "Successfully updated KeyStorage.",
                "KeyStorage criado com sucesso."
              );
              toastr.success(msg);
              $rootScope.loading = false;
              $mdDialog.hide();
            },
            function (error) {
              console.log(error);
              toastr.error(error.data);
              $rootScope.loading = false;
            }
          );
        }
      };

      $scope.validatePermission = function () {
        return PermissionsFactory.hasPermission($scope.permission);
      };
    }

    /********************************************** Modal Create Category ********************************************/
    vm.showCreateCategoryDialog = function (selectedItem) {
      $mdDialog.show({
        controller: DialogCategoryController,
        templateUrl: "app/configuration/dialog-create-category.html",
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        resolve: {
          selectedItem: function () {
            return selectedItem;
          },
        },
      });
    };

    DialogCategoryController.$inject = [
      "$scope",
      "$mdDialog",
      "translationService",
      "selectedItem",
      "PermissionsFactory",
      "IssueCategoryFactory",
    ];

    function DialogCategoryController(
      $scope,
      $mdDialog,
      $translationService,
      selectedItem,
      PermissionsFactory,
      IssueCategoryFactory
    ) {
      $translationService.getTranslation($scope, "configuration");

      (function init() {
        console.log("++++++ DialogCategoryController->add +++++++");

        if (angular.isUndefined(selectedItem)) {
          $scope.readonly = false;
          $scope.permission = "category:create";
          $scope.actionText = $translationService.getTranslationController(
            "Agregar una Categoría",
            "Add a Category",
            "Adicionar uma Categoria"
          );
          $scope.category = {
            id: undefined,
            name: undefined,
            code: undefined,
            color: undefined,
            icon: undefined,
          };
        } else {
          $scope.readonly = true;
          $scope.permission = "category:update";
          $scope.actionText = $translationService.getTranslationController(
            "Actualizar una Categoría",
            "Update a Category",
            "Actualizar uma Categoria"
          );
          $scope.category = angular.copy(selectedItem);
        }
      })();

      $scope.cancel = function (ev) {
        var confirm = $mdDialog
          .confirm()
          .multiple(true)
          .title(
            $translationService.getTranslationController(
              "¿Deseas cancelar?",
              "Do you want to cancel?",
              "Você quer cancelar?"
            )
          )
          .textContent(
            $translationService.getTranslationController(
              "¡Todos los cambios se perderán!",
              "All changes will be lost!",
              "Todas as alterações serão perdidas!"
            )
          )
          .ariaLabel("Cancel-Question")
          .targetEvent(ev)
          .ok($translationService.getTranslationController("Abandonar", "Leave", "Deixar"))
          .cancel($translationService.getTranslationController("Cancelar", "Cancel", "Cancelar"));

        $mdDialog.show(confirm).then(
          function () {
            $mdDialog.cancel();
          },
          function () {}
        );
      };

      $scope.save = function () {
        $rootScope.loading = true;
        if (angular.isUndefined($scope.category.id)) {
          IssueCategoryFactory.create($scope.category)
            .then(
              function (response) {
                $rootScope.$broadcast("refreshNgTableDynamic", {
                  tableId: "category-table",
                });
                var msg = $translationService.getTranslationController(
                  "Categoría creada exitosamente.",
                  "Category successfully created.",
                  "Categoria criado com sucesso."
                );
                toastr.success(msg);
                $mdDialog.hide();
              },
              function (error) {
                console.log(error);
                toastr.error(error.data);
              }
            )
            .finally(function () {
              $rootScope.loading = false;
            });
        } else {
          IssueCategoryFactory.edit($scope.category.id, $scope.category)
            .then(
              function (response) {
                $rootScope.$broadcast("refreshNgTableDynamic", {
                  tableId: "category-table",
                });
                var msg = $translationService.getTranslationController(
                  "Categoría actualizada exitosamente.",
                  "Category successfully created.",
                  "Categoria actualizada com sucesso."
                );
                toastr.success(msg);
                $mdDialog.hide();
              },
              function (error) {
                console.log(error);
                toastr.error(error.data);
              }
            )
            .finally(function () {
              $rootScope.loading = false;
            });
        }
      };

      $scope.validatePermission = function () {
        return PermissionsFactory.hasPermission($scope.permission);
      };

      setTimeout(function () {
        $scope.showEditor = true;
      }, 1000);
    }

    /********************************************** Modal Create Issue Type ********************************************/
    vm.showCreateIssueTypeDialog = function (selectedItem) {
      $mdDialog.show({
        controller: "dialogIssuesTypeController",
        templateUrl: "app/configuration/dialog/issues-type/issues-type.html",
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        resolve: {
          selectedItem: function () {
            return selectedItem;
          },
        },
      });
    };

    /********************************************** Modal Create Company ********************************************/
    vm.showCreateCompanyDialog = function (selectedItem) {
      $mdDialog.show({
        controller: DialogCompanyController,
        templateUrl: "app/configuration/dialog-create-company.html",
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        resolve: {
          selectedItem: function () {
            return selectedItem;
          },
        },
      });
    };

    DialogCompanyController.$inject = [
      "$scope",
      "$mdDialog",
      "translationService",
      "selectedItem",
      "PermissionsFactory",
      "CompanyFactory",
      "$log",
    ];

    function DialogCompanyController(
      $scope,
      $mdDialog,
      $translationService,
      selectedItem,
      PermissionsFactory,
      CompanyFactory,
      $log
    ) {
      $translationService.getTranslation($scope, "configuration");

      (function init() {
        console.log("++++++ DialogCompanyController->add +++++++");
        $scope.id = undefined;

        $scope.tab = {
          selectedIndex: 0,
          firstLocked: false,
          secondLocked: false,
        };
        if (angular.isUndefined(selectedItem)) {
          $scope.actionText = $translationService.getTranslationController(
            "Agregar Compañia",
            "Add Company",
            "Adicionar Companhia"
          );
        } else {
          $scope.tab.selectedIndex = 1;
          $scope.tab.firstLocked = true;
          $scope.actionText = $translationService.getTranslationController(
            "Actualizar Compañia",
            "Update Company",
            "Actualizar Companhia"
          );
          $scope.id = selectedItem.id;
          $scope.name = selectedItem.name;
          $scope.active = selectedItem.active;
        }
        $scope.permission = "category:create";
      })();

      $scope.$watch("selectedIndex", function (newVal, oldVal) {
        $scope.tab.selectedIndex = newVal;
        $log.log("Goodbye " + $scope.tab.selectedIndex + "! newVal=" + newVal);
      });

      $scope.cancel = function (ev) {
        var confirm = $mdDialog
          .confirm()
          .multiple(true)
          .title(
            $translationService.getTranslationController(
              "¿Deseas cancelar?",
              "Do you want to cancel?",
              "Você quer cancelar?"
            )
          )
          .textContent(
            $translationService.getTranslationController(
              "¡Todos los cambios se perderán!",
              "All changes will be lost!",
              "Todas as alterações serão perdidas!"
            )
          )
          .ariaLabel("Cancel-Question")
          .targetEvent(ev)
          .ok($translationService.getTranslationController("Abandonar", "Leave", "Deixar"))
          .cancel($translationService.getTranslationController("Cancelar", "Cancel", "Cancelar"));

        $mdDialog.show(confirm).then(
          function () {
            $mdDialog.cancel();
          },
          function () {}
        );
      };

      $scope.save = function () {
        if ($scope.tab.selectedIndex == 0) {
          //Home Company
          $rootScope.loading = true;
          CompanyFactory.createHome($scope.name)
            .then(
              function (response) {
                $rootScope.$broadcast("refreshNgTableDynamic", {
                  tableId: "company-table",
                });
                var msg = $translationService.getTranslationController(
                  "Compañia creada exitosamente.",
                  "Successfully created company.",
                  "Empresa criada com sucesso."
                );
                toastr.success(msg);
                $mdDialog.hide();
              },
              function (error) {
                console.log(error);
                toastr.error(error.data);
              }
            )
            .finally(function () {
              $rootScope.loading = false;
            });
        } else {
          //Affiliated Company
          var company = {
            id: angular.isDefined($scope.id) ? $scope.id : undefined,
            name: $scope.name,
            active: $scope.active,
          };
          if (angular.isUndefined(company.id)) {
            $rootScope.loading = true;
            CompanyFactory.create(company)
              .then(
                function (response) {
                  $rootScope.$broadcast("refreshNgTableDynamic", {
                    tableId: "company-table",
                  });
                  var msg = $translationService.getTranslationController(
                    "Compañia creada exitosamente.",
                    "Successfully created company.",
                    "Empresa criada com sucesso."
                  );
                  toastr.success(msg);
                  $mdDialog.hide();
                },
                function (error) {
                  console.log(error);
                  toastr.error(error.data);
                }
              )
              .finally(function () {
                $rootScope.loading = false;
              });
          } else {
            $rootScope.loading = true;
            CompanyFactory.edit(company.id, company)
              .then(
                function (response) {
                  $rootScope.$broadcast("refreshNgTableDynamic", {
                    tableId: "company-table",
                  });
                  var msg = $translationService.getTranslationController(
                    "Compañia actualizada exitosamente.",
                    "Successfully created Company.",
                    "Compañia actualizada com sucesso."
                  );
                  toastr.success(msg);
                  $mdDialog.hide();
                },
                function (error) {
                  console.log(error);
                  toastr.error(error.data);
                }
              )
              .finally(function () {
                $rootScope.loading = false;
              });
          }
        }
      };
    }

    /********************************************** Modal Create SCHEMA FORMAT ********************************************/
    vm.showSchemaFormatDialog = function (selectedItem) {
      $mdDialog.show({
        controller: "dialogSchemaFormatController",
        templateUrl: "app/configuration/dialog/schema-format/schema-format.html",
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        resolve: {
          selectedItem: function () {
            return selectedItem;
          },
        },
      });
    };

    vm.removeSchemaFormat = function (_configuration) {
      var confirm = $mdDialog
        .confirm()
        .title(
          $translationService.getTranslationController(
            "Eliminar Formato",
            "Delete Format",
            "Excluir Formato"
          )
        )
        .textContent(
          $translationService.getTranslationController(
            "¿Estas seguro que quieres borrarlo?",
            "Are you sure you want to delete?",
            "Tem certeza de que deseja excluir?"
          )
        )
        .ok($translationService.getTranslationController("Si", "Yes", "Sim"))
        .cancel($translationService.getTranslationController("No", "No", "Não"));

      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loading = true;
          ConfigurationFactory.deleteSchemaFormat(_configuration.id).then(
            function (response) {
              $rootScope.loading = false;
              $rootScope.$broadcast("refreshNgTableDynamic", {
                tableId: "schema-format-table",
              });
              toastr.success(
                $translationService.getTranslationController(
                  "Formato eliminado exitosamente.",
                  "Successfully removed format.",
                  "formato excluído com sucesso."
                )
              );
            },
            function (error) {
              $rootScope.loading = false;
              var msg = $translationService.getTranslationController(
                "No fue posible eliminar la Formato.",
                "It was not possible to delete the format.",
                "Não foi possível excluir o formato."
              );
              toastr.error(msg);
              console.log(error);
            }
          );
        },
        function () {}
      );
    };

    /********************************************** Modal Create OAuth2 Provider ********************************************/
    vm.showCreateProviderDialog = function (selectedItem) {
      $mdDialog.show({
        controller: DialogProviderController,
        templateUrl: "app/configuration/dialog-create-oauth-provider.html",
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        resolve: {
          selectedItem: function () {
            return selectedItem;
          },
        },
      });
    };

    DialogProviderController.$inject = [
      "$scope",
      "$mdDialog",
      "translationService",
      "selectedItem",
      "OAuthProviderFactory",
    ];

    function DialogProviderController(
      $scope,
      $mdDialog,
      $translationService,
      selectedItem,
      OAuthProviderFactory
    ) {
      $translationService.getTranslation($scope, "configuration");

      (function init() {
        console.log("++++++ DialogProvideerController->add +++++++");
        $scope.id = undefined;
        $scope.provider = {};
        if (angular.isUndefined(selectedItem)) {
          $scope.actionText = $translationService.getTranslationController(
            "Agregar Proveedor OAuth2",
            "Add OAuth2 Provider",
            "Adicionar Provedor OAuth2"
          );
        } else {
          $scope.actionText = $translationService.getTranslationController(
            "Actualizar Proveedor OAuth2",
            "Update OAuth2 Provider",
            "Actualizar Provedor OAuth2"
          );
          $scope.provider = angular.copy(selectedItem);
        }
      })();

      $scope.cancel = function (ev) {
        var confirm = $mdDialog
          .confirm()
          .multiple(true)
          .title(
            $translationService.getTranslationController(
              "¿Deseas cancelar?",
              "Do you want to cancel?",
              "Você quer cancelar?"
            )
          )
          .textContent(
            $translationService.getTranslationController(
              "¡Todos los cambios se perderán!",
              "All changes will be lost!",
              "Todas as alterações serão perdidas!"
            )
          )
          .ariaLabel("Cancel-Question")
          .targetEvent(ev)
          .ok($translationService.getTranslationController("Abandonar", "Leave", "Deixar"))
          .cancel($translationService.getTranslationController("Cancelar", "Cancel", "Cancelar"));

        $mdDialog.show(confirm).then(
          function () {
            $mdDialog.cancel();
          },
          function () {}
        );
      };

      $scope.save = function () {
        if (angular.isUndefined($scope.provider.id)) {
          $rootScope.loading = true;
          OAuthProviderFactory.create($scope.provider)
            .then(
              function (response) {
                $rootScope.$broadcast("refreshNgTableDynamic", {
                  tableId: "oauth-providers-table",
                });
                var msg = $translationService.getTranslationController(
                  "Proveedor creado exitosamente.",
                  "Successfully created OAuth2 Provider.",
                  "Provedor criada com sucesso."
                );
                toastr.success(msg);
                $mdDialog.hide();
              },
              function (error) {
                console.log(error);
                toastr.error(error.data);
              }
            )
            .finally(function () {
              $rootScope.loading = false;
            });
        } else {
          $rootScope.loading = true;
          OAuthProviderFactory.edit($scope.provider.id, $scope.provider)
            .then(
              function (response) {
                $rootScope.$broadcast("refreshNgTableDynamic", {
                  tableId: "oauth-providers-table",
                });
                var msg = $translationService.getTranslationController(
                  "Proveedor actualizado exitosamente.",
                  "Successfully updated OAuth2 Provider.",
                  "Provedor actualizada com sucesso."
                );
                toastr.success(msg);
                $mdDialog.hide();
              },
              function (error) {
                console.log(error);
                toastr.error(error.data);
              }
            )
            .finally(function () {
              $rootScope.loading = false;
            });
        }
      };
    }

    /********************************************** Modal Create HOLIDAY ********************************************/
    vm.showCreateHolidayDialog = function (selectedItem) {
      console.log("showCreateHolidayDialog", selectedItem);

      $mdDialog
        .show({
          multiple: true,
          controller: "dialogHolidayController",
          templateUrl: "app/configuration/dialog/holiday/dialog-holiday.html",
          parent: angular.element(document.body),
          controllerAs: "ctrl",
          // targetEvent: ev,
          clickOutsideToClose: false,
          escapeToClose: false,
          resolve: {
            selectedItem: function () {
              return selectedItem;
            },
          },
        })
        .then(function (result) {
          console.log("refreshNgTableDynamic");
          $rootScope.$broadcast("refreshNgTableDynamic", {
            tableId: "holiday-table",
          });
          var msg = $translationService.getTranslationController(
            "holiday creado exitosamente.",
            "holiday criado com sucesso."
          );
          toastr.success(msg);
          $mdDialog.hide();
        });
    };
    vm.removeHoliday = function (row) {
      var confirm = $mdDialog
        .confirm()
        .title(
          $translationService.getTranslationController(
            "Eliminar holiday",
            "Delete holiday",
            "Excluir holiday"
          )
        )
        .textContent(
          $translationService.getTranslationController(
            "¿Estas seguro que quieres borrarlo?",
            "Are you sure you want to delete?",
            "Tem certeza de que deseja excluir?"
          )
        )
        .ok($translationService.getTranslationController("Si", "Yes", "Sim"))
        .cancel($translationService.getTranslationController("No", "No", "Não"));

      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loading = true;
          $holidaysFactory.delete(row.id).then(
            function (response) {
              $rootScope.loading = false;
              $rootScope.$broadcast("refreshNgTableDynamic", {
                tableId: "holiday-table",
              });
              toastr.success(
                $translationService.getTranslationController(
                  "holiday eliminada exitosamente.",
                  "Successfully removed config.",
                  "Config excluído com sucesso."
                )
              );
            },
            function (error) {
              $rootScope.loading = false;
              var msg = $translationService.getTranslationController(
                "No fue posible eliminar la Formato.",
                "It was not possible to delete the format.",
                "Não foi possível excluir o formato."
              );
              toastr.error(msg);
              console.log(error);
            }
          );
        },
        function () {}
      );
    };

    /********************************************** Modal Create CUSTOM REPORTS ********************************************/
    vm.showCustomReportDialog = function (selectedItem) {
      $mdDialog
        .show({
          multiple: true,
          controller: "dialogCustomReport",
          templateUrl: "app/custom-reports/dialog/dialog-custom-report.html",
          parent: angular.element(document.body),
          controllerAs: "ctrl",
          // targetEvent: ev,
          clickOutsideToClose: false,
          escapeToClose: false,
          resolve: {
            selectedItem: function () {
              return selectedItem;
            },
          },
        })
        .then(function (result) {
          console.log("refreshNgTableDynamic");
          $rootScope.$broadcast("refreshNgTableDynamic", {
            tableId: "custom-reports-table",
          });
          var msg = $translationService.getTranslationController(
            "Configuracion creado exitosamente.",
            "Successfully created config.",
            "Configuração criado com sucesso."
          );
          toastr.success(msg);
          $mdDialog.hide();
        });
    };

    vm.removeCustomReport = function (_configuration) {
      var confirm = $mdDialog
        .confirm()
        .title(
          $translationService.getTranslationController(
            "Eliminar configuracion",
            "Delete configuracion",
            "Excluir configuracion"
          )
        )
        .textContent(
          $translationService.getTranslationController(
            "¿Estas seguro que quieres borrarlo?",
            "Are you sure you want to delete?",
            "Tem certeza de que deseja excluir?"
          )
        )
        .ok($translationService.getTranslationController("Si", "Yes", "Sim"))
        .cancel($translationService.getTranslationController("No", "No", "Não"));

      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loading = true;
          $customReportFactory.deleteCustomReport(_configuration.id).then(
            function (response) {
              $rootScope.loading = false;
              $rootScope.$broadcast("refreshNgTableDynamic", {
                tableId: "custom-reports-table",
              });
              toastr.success(
                $translationService.getTranslationController(
                  "Configuracion eliminada exitosamente.",
                  "Successfully removed config.",
                  "Config excluído com sucesso."
                )
              );
            },
            function (error) {
              $rootScope.loading = false;
              var msg = $translationService.getTranslationController(
                "No fue posible eliminar la Formato.",
                "It was not possible to delete the format.",
                "Não foi possível excluir o formato."
              );
              toastr.error(msg);
              console.log(error);
            }
          );
        },
        function () {}
      );
    };

    /********************************************** Share Modal ********************************************/
    vm.showShareCustomReportDialog = function (selectedItem) {
      $mdDialog.show({
        controller: "ShareEntityController",
        templateUrl: "app/acl/component/dialog-share-entity.html",
        parent: angular.element(document.body),

        clickOutsideToClose: false,
        locals: {
          selectedItem: {
            id: selectedItem.id,
            resource: "custom-report",
            name: selectedItem.name,
          },
          actions: ["read", "read_storage", "upload", "download"],
        },
      });
    };

    vm.showShareIssueTypeDialog = function (selectedItem) {
      $mdDialog.show({
        controller: "ShareEntityController",
        templateUrl: "app/acl/component/dialog-share-entity.html",
        parent: angular.element(document.body),

        clickOutsideToClose: false,
        locals: {
          selectedItem: {
            id: selectedItem.id,
            resource: "issues-type",
            name: selectedItem.name,
          },
          actions: ["read", "update", "delete", "share"],
        },
      });
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('dashboard')
    .controller('chartsListController', chartsListController);
  chartsListController.$inject = [
    '$scope',
    '$rootScope',
    'ChartsFactory',
    'toastr',
    '$mdDialog',
    'translationService',
    'listsToGroups',
  ];

  function chartsListController(
    $scope,
    $rootScope,
    ChartsFactory,
    toastr,
    $mdDialog,
    $translationService,
    $listsToGroups
  ) {
    var vm = this;
    $translationService.getTranslation(vm, 'charts');
    $rootScope.loading = false;
    vm.chartList = [];
    vm.searchText = '';
    vm.isLoading = false;
    vm.isEmpty = false;
    vm.hasError = '';
    vm.tabChart = [{ id: 'index', name: 'ALL' }];
    vm.selectedTab = 'index';

    vm.displayItems = false;
    vm.collapseAll = function () {
      vm.displayItems = false;
      $rootScope.$broadcast('displayItems', false);
    };

    vm.expandAll = function () {
      vm.displayItems = true;
      $rootScope.$broadcast('displayItems', true);
    };

    vm.sort = 'asc';
    vm.toggleSort = function () {
      vm.sort = vm.sort == 'desc' ? 'asc' : 'desc';
      vm.getChartsbyDomain();
    };

    vm.getChartsbyDomain = function (chart) {
      $rootScope.loading = true;
      vm.isLoading = true;

      ChartsFactory.getChartsbyDomain()
        .then(function (res) {
          if (res.data.length > 0) {
            vm.chartList = res.data;
            vm.chartTree = [];
            vm.chartTree = $listsToGroups.createGroups(
              res.data,
              'group',
              vm.sort,
              chart
            );

            vm.isEmpty = false;
          } else {
            vm.isEmpty = true;
          }
          $rootScope.loading = false;
          vm.isLoading = false;
        })
        .catch(function (err) {
          console.error('Error@getChartsbyDomain', err);
          $rootScope.loading = false;
          vm.isLoading = false;
        });
    };
    vm.getChartsbyDomain();

    vm.setTab = function (newTab) {
      vm.selectedTab = newTab;
    };

    vm.isSet = function (tabNum) {
      return vm.selectedTab === tabNum;
    };

    vm.isActive = function (id) {
      return vm.isSet(id) && id != 'index';
    };

    vm.totab = function (item) {
      var exist = vm.tabChart.find(function (e) {
        return e.id === item.id;
      });
      if (exist) {
        vm.setTab(item.id);
      } else {
        var newTAb = item;
        vm.tabChart.push(newTAb);
        vm.setTab(item.id);
      }
    };

    vm.eliminarTabReport = function (tabId) {
      // TODO: Cambiar a un filter
      var indexTab = -2;
      for (var i = 0; i < vm.tabChart.length; i++) {
        var actualTab = vm.tabChart[i];
        if (actualTab.id === tabId) {
          indexTab = i;
          break;
        }
      }
      if (indexTab > 0) {
        vm.tabChart.splice(indexTab, 1);
        vm.setTab('index');
      }
    };

    vm.deleteChart = function (chartid) {
      $rootScope.loading = true;
      ChartsFactory.deleteChart(chartid)
        .then(function (res) {
          vm.eliminarTabReport(chartid);
          vm.getChartsbyDomain();
          toastr.info('Grafica Eliminada');
          $rootScope.loading = false;
        })
        .catch(function (err) {
          console.error('Error@deleteChart', err);
          $rootScope.loading = false;
        });
    };

    vm.confirmDeleteChart = function (chartid, ev) {
      var confirm = $mdDialog
        .confirm()
        .title('Seguro deseas Eliminar esta Grafica?')
        .textContent(
          'Se eliminaran todos los archivos contenidos permanentemente'
        )
        .ariaLabel('deleteChart')
        .targetEvent(ev)
        .ok('Si, borrala!')
        .cancel('Cancelar');

      $mdDialog.show(confirm).then(
        function () {
          vm.deleteChart(chartid);
        },
        function () {
          toastr.info('Cancelado');
        }
      );
    };

    $scope.$on('refreshListCharts', function (e, chart) {
      vm.chartTree = [];
      vm.getChartsbyDomain(chart);
    });

    $scope.$on('refreshMaiMenu', function (e) {
      vm.chartTree = [];
      vm.getChartsbyDomain();
    });

    $scope.$on('openChartTabByID', function (e, chartId) {
      var chartConfig = vm.chartList.find(function (e) {
        return e.id == chartId;
      });
      vm.totab(chartConfig);
    });

    $scope.$on('openSaveChart', function (e, chartId) {
      ChartsFactory.getChartsbyDomain()
        .then(function (res) {
          if (res.data.length > 0) {
            vm.chartList = res.data;
            vm.chartTree = [];
            vm.chartTree = $listsToGroups.createGroups(
              res.data,
              'group',
              vm.sort
            );
            vm.isEmpty = false;
            var chartConfig = res.data.find(function (e) {
              return e.id == chartId;
            });
            vm.totab(chartConfig);
          } else {
            vm.isEmpty = true;
          }
          $rootScope.loading = false;
          vm.isLoading = false;
        })
        .catch(function (err) {
          console.error('Error@getChartsbyDomain', err);
          $rootScope.loading = false;
          vm.isLoading = false;
        });
    });

    vm.manageChart = function (chart, groupPath) {
      var chartConfig = angular.copy(chart);
      $mdDialog
        .show({
          controller: 'WizardDialogController',
          controllerAs: 'ctrl',
          templateUrl: 'app/charts/components/wizard-dialog/wizard-dialog.html',
          parent: angular.element(document.body),
          clickOutsideToClose: false,
          multiple: true,
          locals: {
            chartConfig: chartConfig,
            groupPath: groupPath,
          },
        })
        .then(function () {
          vm.getChartsbyDomain();
        });
    };
    $scope.$on('newChart', function (e, path) {
      vm.manageChart(null, path);
    });

    vm.showShareEntityDialog = function (selectedItem) {
      $mdDialog.show({
        controller: 'ShareEntityController',
        templateUrl: 'app/acl/component/dialog-share-entity.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          selectedItem: {
            id: selectedItem.id,
            resource: 'graphic-report',
            name: selectedItem.name,
          },
          actions: ['read', 'update', 'delete'],
        },
      });
    };

    /**
     *list filter
     */
    $scope.$watch('ctrl.searchText', function (nval) {
      var filtered = [];
      if (vm.chartList && nval != null && nval != '') {
        filtered = vm.chartList.filter(function (e) {
          nval = angular.lowercase(nval);
          return angular.lowercase(e.name).indexOf(nval) >= 0;
        }) || [null];
        vm.chartTree = [];
        vm.chartTree = $listsToGroups.createGroups(filtered, 'group', vm.sort);
        setTimeout(function () {
          vm.expandAll();
        }, 200);
      } else {
        vm.chartTree = [];
        vm.chartTree = $listsToGroups.createGroups(
          vm.chartList,
          'group',
          vm.sort,
          filtered[0]
        );
        setTimeout(function () {
          vm.collapseAll();
        }, 200);
      }
    });
  }
})();

"use strict";

angular.module("dashboard").component("chartView", {
  templateUrl: "app/charts/chart-view.html",
  controllerAs: "ctrl",
  bindings: {
    chartId: "<", //id of the chart to load
    isWidget: "@",
    showChartTableView: "<",
    showChartLabels: "<",
    showChartFiltersDialog: "=",
    chartHeight: "<",
  },

  controller: ChartViewController,
});

ChartViewController.$inject = [
  "$scope",
  "$state",
  "$rootScope",
  "ConfigurationFactory",
  "$mdDialog",
  "$filter",
  "translationService",
  "toastr",
  "ChartsFactory",
  "InputListsFactory",
  "PermissionsFactory",
  "chartService",
  "treeChartService",
  "chartConstants",
  "chartTooltip",
];

function ChartViewController(
  $scope,
  $state,
  $rootScope,
  $ConfigurationFactory,
  $mdDialog,
  $filter,
  $translationService,
  $toastr,
  $chartsFactory,
  $inputListsFactory,
  $permissionsFactory,
  $chartService,
  $treeChartService,
  $chartConstants,
  $chartTooltip
) {
  $translationService.getTranslation($scope, "charts");

  var vm = this;

  $rootScope.loading = true;
  $scope.isLoading = true;
  $scope.uuid =
    vm.chartId + new Date().getTime() + (Math.floor(Math.random() * (99999 - 10000)) + 10000);

  vm.chartHeight = vm.chartHeight || 450;
  vm.isWidget = vm.isWidget ? true : false;
  vm.showChartTableView = !vm.isWidget;
  vm.showChartLabels = true;
  vm.showChartFiltersDialog = false;
  vm.sidenav_is_open = true;
  vm.displayToolbar = !vm.isWidget;
  vm.echart = null;
  vm.chartData = null;
  vm.echartConfig = null;
  vm.FiltersOptions = ["String", "Double", "Date", "List", "Time", "Interger"];
  vm.chartTypes = ["bar", "line", "pie"];
  vm.chartActivefilters = null;
  vm.chartDataIsFiltered = false;
  vm.echartCurrentConfig = "null";
  vm.hasPivot = false;
  vm.formatValuesBy = { format: "R", unid: 2 };
  vm.pivotFunction = null;
  vm.showPivotBtn = true;

  $scope.$watch("ctrl.showChartLabels", function (newValue, oldValue) {
    if (newValue != oldValue) {
      vm.showChartLabels = newValue;
      vm.drawChart(vm.chartActivefilters, _resizeChart);
    }
  });

  $scope.$watch("ctrl.showChartFiltersDialog", function (newValue, oldValue) {
    console.log("showChartFiltersDialog changed:", newValue);
    if (newValue) {
      $scope.filterDialog();
    }
  });

  $scope.$watch("ctrl.showChartTableView", function (newValue, oldValue) {
    _resizeChart();
  });

  $(window).on("resize", _resizeChart);
  $scope.$on("homeWidgetRezised", _resizeChart);

  function _initializeEChart() {
    var domid = "echart-container-" + $scope.uuid;
    vm.echart = echarts.init(document.getElementById(domid));

    vm.echart.on("dblclick", function (params) {
      
      var type = vm.chartList.schema.properties[vm.chart.xAxis[0]].type
      var value = params.name;

      switch (type) {
        case "date":
          value = moment(value, "DD-MM-YYYY").format("YYYY-MM-DD");
          break;
      }

      console.log(value);
      
      if (params.targetType == "axisName") {
        vm.onDblClickYaxis(params.name);
      } else {
        var arrFilters = [];

        var xAxisClicked = {
          field: vm.chart.xAxis[0],
          value: value,
        };

        arrFilters.push(xAxisClicked);

        var listId = vm.chart.series[0].source;
        var filters = angular.copy(vm.chartActivefilters || []);

        filters = filters.map(function (f) {
          return {
            field: f.field,
            value: f.selectedValues,
          };
        });

        arrFilters = arrFilters.concat(filters);

        _navigateToList(listId, arrFilters);
      }
      var domid = "echart-container-" + $scope.uuid;
      vm.echart = echarts.init(document.getElementById(domid));
      vm.echart.on("dblclick", function (params) {
        if (params.targetType == "axisName") {
          vm.onDblClickYaxis(params.name);
        } else {
          var arrFilters = [];

          var xAxisClicked = {
            field: vm.chart.xAxis[0],
            value: params.name,
          };

          arrFilters.push(xAxisClicked);

          var listId = vm.chart.series[0].source;
          var filters = angular.copy(vm.chartActivefilters || []);

          filters = filters.map(function (f) {
            return {
              field: f.field,
              value: f.selectedValues,
            };
          });

          arrFilters = arrFilters.concat(filters);

          _navigateToList(listId, arrFilters);
        }
      });
      resolve();
    });
  }

  function _setChartHeight() {
    if (vm.isWidget)
      if (vm.showChartTableView) return "300px";
      else return vm.chartHeight - 90 + "px";
    else return vm.chartHeight - 90 + "px";
  }

  vm.drawChart = function (filters, callback) {
    vm.echartConfig = {};
    _initializeEChart()
      .then(function () {
        vm.echart.showLoading();
        var _CHART_CONSTANTS_ = angular.copy(JSON.parse(JSON.stringify($chartConstants)));
        _createSeries().then(function (series) {
          if (series.length == 0) {
            $toastr.info(
              $translationService.getTranslationController("Sin datos", "No data", "Sin data")
            );
            return;
          }
          var xAxis = angular.copy(JSON.parse(JSON.stringify(_CHART_CONSTANTS_.echartConfig.xAxis)));
          
          vm.echartConfig =
            _CHART_CONSTANTS_.echartConfig &&
            Object.assign(_CHART_CONSTANTS_.echartConfig, {
              chartName: vm.chart.name,
              chartId: vm.chart.id,
              chartUUID: $scope.uuid,
              height: vm.height,
              xAxis:
                xAxis &&
                Object.assign(xAxis, {
                  data: vm.chartData.xAxis,
                }),
              series: series,
            });

          vm.echartConfig.tooltip = vm.echartConfig.tooltip = $chartTooltip.setTooltipByComponent();

          if (series[0].type == "treemap" && series.length == 1) {
            delete vm.echartConfig.xAxis;
            delete vm.echartConfig.yAxis;
            delete vm.echartConfig.legend;
            delete vm.echartConfig.dataZoom;
            delete vm.echartConfig.grid;
            delete vm.echartConfig.formatValuesBy;
            delete vm.echartConfig.markline;
            vm.echartConfig.tooltip = $chartTooltip.setTooltipByComponent("treemap");
          }

          if (vm.chart.series[0].type == "pie" && series.length === 1) {
            delete vm.echartConfig.xAxis;
            delete vm.echartConfig.yAxis;
            delete vm.echartConfig.dataZoom;
            delete vm.echartConfig.grid;
            delete vm.echartConfig.formatValuesBy;
            delete vm.echartConfig.markline;
            delete vm.echartConfig.tooltip;
            vm.echartConfig = Object.assign(vm.echartConfig, _CHART_CONSTANTS_.pieChartSingle);
          }

          if (
            series.some(function (e) {
              return e.type == "boxplot";
            })
          ) {
            vm.echartConfig.tooltip = $chartTooltip.setTooltipByComponent("boxplot");
          }

          vm.echart.setOption(vm.echartConfig);
          vm.echart.hideLoading();
          vm.echart.resize({
            height: _setChartHeight(),
            padding: "1rem",
          });

          vm.showPivotBtn = vm.chart.series.some(function (e) {
            return ["boxplot", "treemap"].includes(e.type) ? false : true;
          });

          console.log("Echart Config:", vm.echartConfig);
          
          callback();
        });

      })
      .catch(function (err) {
        console.error("Error@_initializeEChart", err);
      });
  };

  $scope.onChangeFormat = function () {
    vm.echart.setOption(vm.echartConfig);
  };

  vm.updateChart = function () {
    console.log("Update Chart Echart Config:", vm.echartConfig);
    vm.echart.setOption(vm.echartConfig);
  };

  function _navigateToList(listId, filters) {
    var hasPermission = $permissionsFactory.hasPermission("list#" + listId + ":" + "read");

    if (!hasPermission) {
      $toastr.error(
        $translationService.getTranslationController(
          "No tienes permisos para var esta lista: " + listId,
          "You do not have permission to view this list: " + listId,
          "Você não tem permissão para ver esta lista: " + listId
        )
      );
      return;
    }
    var url = $state.href("app.tableList", {
      action: "GET",
      listId: listId,
      filters: JSON.stringify(filters),
    });
    window.open(url, "_blank");
  }

  function _resizeChart() {
    if (!vm.echart) return;
    setTimeout(function () {
      vm.echart.resize({ height: _setChartHeight() });
    }, 200);
  }

  function _loadStoreSerie(serie) {
    if (vm.echartCurrentConfig == null) return null;
    if (vm.echartCurrentConfig == {}) return null;
    if (vm.echartCurrentConfig.hasOwnProperty("series") == false) return null;

    return vm.echartCurrentConfig.series.find(function (e) {
      return e.name == serie.label;
    });
  }

  function _createSeries() {
    return new Promise(function (resolve) {
      var arr_series = [];

      if (vm.chart.series[0].type == "treemap") {
        var level_color = $chartService.randColor(0, vm.chartCustomColors);
        var serie = vm.chart.series[0];
        var hasStoredData = _loadStoreSerie(serie);
        var metadata = angular.isDefined(vm.chart.series[0].metadata)
          ? JSON.parse(vm.chart.series[0].metadata)
          : null;
        arr_series.push(
          Object.assign(
            {
              name: serie.label,
              type: "treemap",
              visibleMin: 1,
              leafDepth: 1,
              upperLabel: {
                show: true,
                height: 30,
                fontSize: 15,
              },
              label: {
                normal: {
                  position: "insideTopLeft",
                  show: true,
                  fontSize: 15,
                  formatter: $treeChartService.labelFormatter,
                },
              },
              color: level_color,
              itemStyle: {
                borderColor: "#fff",
                color: level_color,
              },
              levels: $treeChartService.getLevelOption(),
              data: $chartService.setTreeMapValues(
                vm.chartData.treeMap.children,
                vm.chartData,
                hasStoredData,
                vm.chartCustomColors
              ),
            },
            metadata
          )
        );
      } else {
        vm.chart.series.forEach(function (serieConfig, index, arraySeries) {
          if (serieConfig.groupBy.length > 0) {
            var i = 0;
            var next_color = 0;
            for (var serieName in vm.chartData.yAxis) {
              if (vm.chartData.yAxis.hasOwnProperty(serieName)) {
                var hasStoredData = _loadStoreSerie({
                  label: serieName,
                  type: serieConfig.type,
                });

                var _SERIE_DATA_ = [];
                if (serieConfig.type == "boxplot") {
                  _SERIE_DATA_ = $chartService.setBoxplotValues(
                    vm.chartData,
                    hasStoredData,
                    vm.chartCustomColors,
                    serieConfig.metadata
                  );
                } else {
                  _SERIE_DATA_ = vm.chartData.yAxis[serieName].map(function (e) {
                    return e;
                  });
                }
                var color = hasStoredData ? hasStoredData.color : null;
                if (!color) {
                  color = $chartService.randColor(next_color, vm.chartCustomColors);
                  next_color++;
                }

                var serie = {
                  name: serieName,
                  type: hasStoredData ? hasStoredData.type : serieConfig.type,
                  groupBy: true,
                  connectNulls: true,
                  label: {
                    show: vm.showChartLabels,
                    fontWeight: "bold",
                    fontSize: 18,
                    position: "top",
                    formatter: function (params) {
                      var fmt =
                        vm.hasPivot == false
                          ? $chartService.formatValueSerie(params.value, vm.formatValuesBy)
                          : $chartService.formatNumber(params.value) + " %";
                      return fmt;
                    },
                  },
                  color: color,
                  data: _SERIE_DATA_,
                  markLine: $chartService.processMarkLineData(serieConfig.markline),
                };
              }

              arr_series.push(serie);
              i++;
            }
          } else {
            var _SERIE_DATA_ = [];

            var hasStoredData = _loadStoreSerie(serieConfig);

            if (serieConfig.type == "boxplot") {
              _SERIE_DATA_ = $chartService.setBoxplotValues(
                vm.chartData,
                hasStoredData,
                vm.chartCustomColors,
                serieConfig.metadata,
                serieConfig.color
              );
            } else {
              var data = vm.chartData.yAxis[serieConfig.label];

              _SERIE_DATA_ = $chartService.setSerieValues(
                data,
                vm.chartData,
                hasStoredData,
                vm.chartCustomColors,
                serieConfig.metadata,
                serieConfig.color
              );
            }

            var serie = {
              name: serieConfig.label,
              type: serieConfig.type,
              groupBy: false,
              data: _SERIE_DATA_,
              connectNulls: true,
              label: {
                show: vm.showChartLabels,
                fontWeight: "bold",
                fontSize: 18,
                position: "top",
                formatter: function (params) {
                  return vm.hasPivot == false
                    ? $chartService.formatValueSerie(params.value, vm.formatValuesBy)
                    : $chartService.formatNumber(params.value) + " %";
                },
              },
              color: serieConfig.color,
              markLine: $chartService.processMarkLineData(serieConfig.markline),
              itemStyle:
                serieConfig.type == "boxplot"
                  ? {
                      borderWidth: "1",
                      borderColor: "#000000",
                      color: serieConfig.color,
                    }
                  : null,
            };

            if (serieConfig.type == "pie") {
              serie =
                arraySeries.length == 1
                  ? Object.assign(serie, $chartConstants.pieChartSingle)
                  : Object.assign(serie, $chartConstants.pieChartMultiChart);
            }

            arr_series.push(serie);
          }
        });
      }
      resolve(arr_series);
    });
  }

  function _getChartData(filters, extraConf) {
    $rootScope.loading = true;

    //!dates filters are passed as extraConf
    if (filters && filters.length > 0) {
      filters.forEach(function (e) {
        if (e.type == "date") {
          extraConf = extraConf || {};
          extraConf = {
            dateField: e.field,
            fromDate: e.selectedValues.fromDate,
            toDate: e.selectedValues.toDate,
          };
        }
      });

      filters = filters.filter(function (e) {
        return e.type != "date";
      });
    }

    return new Promise(function (resolve, reject) {
      $chartsFactory
        .getChartData(vm.chartId, filters, extraConf)
        .then(function (res) {
          setTimeout(function () {
            if (
              vm.chart.series[0].type != "treemap" &&
              vm.chartList &&
              vm.chartList.schema &&
              vm.chartList.schema.properties
            ) {
              var x = (vm.chart.xAxis.length && vm.chart.xAxis[0].replace("#", "")) || "x";

              var prop = vm.chartList.schema.properties || null;
              if (!prop) return e;

              if (prop[x].type == "date") {
                res.xAxis = res.xAxis.map(function (e) {
                  return moment(e.split("T")[0]).format("DD-MM-YYYY");
                });
              }
              if (prop[x].type == "time") {
                res.xAxis = res.xAxis.map(function (e) {
                  return moment(e.split("T")[0]).format("HH:mm:ss");
                });
              }
              if (prop[x].type == "timestamp") {
                res.xAxis = res.xAxis.map(function (e) {
                  return moment(e.split("T")[0]).format();
                });
              }
              if (prop[x].type == "boolean") {
                res.xAxis = res.xAxis.map(function (e) {
                  return e == true ? "1" : "0";
                });
              }
            }

            vm.chartData = res;

            $rootScope.loading = false;
            $scope.isLoading = false;
            resolve(res);
          }, 500);
        })
        .catch(function (err) {
          $toastr.error("error:: getChartData" + err);
          console.error("Error@getChartData", err);
          $rootScope.loading = false;
          $scope.isLoading = false;
          if (err.startsWith("Error calculating pivot")) {
            vm.hasPivot = false;
            if (vm.echartConfig.hasOwnProperty("pivotFunction"))
              vm.echartConfig.pivotFunction = null;

            vm.pivotFunction = null;
            vm.removePivot();
            vm.saveChart();
          }
          reject(err);
        });
    });
  }

  vm.saveChart = function () {
    if (vm.echart != null) vm.echart.showLoading();
    var config = angular.copy(vm.chart);

    // for (var i = 0; i < config.series.length; i++) {
    //   config.series[i].type = vm.echartConfig.series[i].type;
    //   config.series[i].color = vm.echartConfig.series[i].color;
    // }

    //has filters
    if(vm.chartActivefilters){
      vm.echartConfig.hasFilters = vm.chartActivefilters;
    }
    

    config.echartConfig = JSON.stringify(angular.copy(vm.echartConfig));

    $rootScope.loading = true;
    $chartsFactory
      .saveChart(config)
      .then(function (res) {
        $toastr.success(
          $translationService.getTranslationController(
            "Grafica guardada",
            "Chart Saved",
            "Gráfico salvo"
          )
        );
        if (vm.echart != null) vm.echart.hideLoading();
        vm.chart = res;
        vm.initChart().then(function () {
          $rootScope.loading = false;
          vm.Has_unsavedChanges = false;
        });
      })
      .catch(function (err) {
        if (vm.echart != null) vm.echart.hideLoading();
        $toastr.error(err);
        console.error("Error@saveChart", err);
        $rootScope.loading = false;
      });
  };

  vm.saveAs = function () {
    var confirm = $mdDialog
      .prompt()
      .title($translationService.getTranslationController("Guardar como", "Save as", "Salvar como"))
      .textContent($translationService.getTranslationController("Nombre", "Name", "Nome"))
      .placeholder($translationService.getTranslationController("Nombre", "Name", "Nome"))
      .ariaLabel("name")
      .initialValue("")
      .required(true)
      .ok("Ok")
      .cancel($translationService.getTranslationController("Cancelar", "Cancel", "Cancelar"));

    $mdDialog.show(confirm).then(function (result) {
      if (result.toLowerCase().trim() == vm.chart.name.toLowerCase().trim()) {
        $toastr.warning(
          $translationService.getTranslationController(
            "El nombre no puede ser igual a ",
            "The name cannot be equal to ",
            "O nome não pode ser igual a "
          ) + vm.chart.name
        );
        vm.saveAs();
      } else {
        var saveAs = angular.copy(vm.chart);
        saveAs.id = null;
        saveAs.name = result;
        var echartConfig = angular.copy(vm.echartConfig);
        saveAs.echartConfig = JSON.stringify(echartConfig);
        vm.saveCopyConfig(saveAs);
      }
    });
  };

  vm.saveCopyConfig = function (copyChart) {
    var config = copyChart;
    $rootScope.loading = true;
    $chartsFactory
      .saveChart(config)
      .then(function (res) {
        $toastr.success(
          $translationService.getTranslationController(
            "Guardada como ",
            "Saved as ",
            "Salvo como "
          ) + config.name
        );
        $rootScope.loading = false;
        $rootScope.$broadcast("openSaveChart", res.id);
      })
      .catch(function (err) {
        $toastr.error(err);
        console.error("Error@saveChart", err);
        $rootScope.loading = false;
      });
  };

  vm.saveConfig = function () {
    var config = angular.copy(vm.chart);
    $rootScope.loading = true;
    $chartsFactory
      .saveChart(config)
      .then(function (res) {
        $toastr.success(
          $translationService.getTranslationController(
            "Exito al guardar",
            "Save success",
            "Salve o sucesso"
          )
        );
        $rootScope.loading = false;
      })
      .catch(function (err) {
        $toastr.error(err);
        console.error("Error@saveChart", err);
        $rootScope.loading = false;
      });
  };

  vm.initChart = function () {
    $scope.isLoading = true;
    return new Promise(function (resolve) {
      $chartsFactory
        .getChartsbyDomain()
        .then(function (res) {
          vm.loading = false;
          var chart = res.data.find(function (ele) {
            return ele.id == vm.chartId;
          });

          if (!chart && !vm.isWidget) {
            $toastr.error("Chart not found");
            $state.go("app.charts");
            return;
          }

          vm.chart = chart;

          vm.loadchart().then(function () {
            resolve();
          });
        })
        .catch(function (err) {
          console.error("Error@getChartsbyDomain", err);
          $rootScope.loading = false;
        });
    });
  };

  vm.loadchart = function () {
    return new Promise(function (resolve) {
      $scope.isLoading = true;

      if (vm.chart.hasOwnProperty("notes") == false) {
        vm.chart.notes = [];
      }
      if (vm.chart.hasOwnProperty("group") == false) {
        vm.chart.group = "";
      }
      if (vm.chart.hasOwnProperty("echartConfig") == false) {
        vm.chart.echartConfig = "null";
      } else {
        if (vm.chart.echartConfig != "" && vm.chart.echartConfig != "null") {
          vm.echartCurrentConfig = JSON.parse(vm.chart.echartConfig);
          if (vm.echartCurrentConfig.hasOwnProperty("hasFilters") == true) {
            var hasFilters = vm.echartCurrentConfig.hasFilters;
            vm.chartActivefilters = hasFilters;
          }
          if (vm.echartCurrentConfig.hasOwnProperty("formatValuesBy") == true) {
            var formatvalue = vm.echartCurrentConfig.formatValuesBy;
            vm.formatValuesBy = formatvalue.hasOwnProperty("format")
              ? formatvalue
              : angular.copy(JSON.parse(JSON.stringify($chartConstants.echartConfig.formatValuesBy)));
          }
          if (
            vm.echartCurrentConfig.hasOwnProperty("pivotFunction") == true &&
            vm.echartCurrentConfig.pivotFunction != null
          ) {
            vm.pivotFunction =
              typeof vm.echartCurrentConfig.pivotFunction == "string"
                ? JSON.parse(vm.echartCurrentConfig.pivotFunction)
                : vm.echartCurrentConfig.pivotFunction;
            vm.hasPivot = true;
            vm.formatValuesBy = "R";
          } else {
            vm.hasPivot = false;
          }
        }
      }
      if (vm.chart.hasOwnProperty("links") == false) {
        vm.chart.links = [];
      }
      vm.hasGroupby = vm.chart.series.some(function (e) {
        return angular.isDefined(e.groupBy) && e.groupBy.length > 0;
      });

      var promises = [];
      promises.push(_getLists());
      promises.push(_getChartConfigColors());
      promises.push(_getChartData(vm.chartActivefilters, vm.pivotFunction));
      Promise.allSettled(promises)
        .then(function (res) {
          var hasRejected = res.find(function (e) {
            return e.status == "rejected";
          });

          if (hasRejected) {
            throw new Error("Error@loadchart", hasRejected.reason);
          }

          $scope.isLoading = false;
          vm.drawChart(vm.chartActivefilters, _resizeChart);
          vm.filterChart(vm.chartActivefilters, false);

          resolve();
        })
        .catch(function (err) {
          console.error("Error@loadchart", err);
          $rootScope.loading = false;
          $scope.isLoading = false;
        });

      vm.Has_unsavedChanges = false;
    });
  };

  vm.$onInit = function () {
    vm.initChart();
  };

  vm.autoRefreshActive = false;
  vm.delay;
  var timeout;

  vm.startAutoRefresh = function (delay) {
    vm.autoRefreshActive = true;
    vm.delay = delay;
    vm.autoRefresh();
  };

  vm.autoRefresh = function () {
    if (vm.autoRefreshActive) {
      vm.initChart().then(function () {
        timeout = setTimeout(function () {
          vm.autoRefresh();
        }, vm.delay * 1000);
      });
    } else {
      vm.stopAutoRefresh();
    }
  };
  vm.stopAutoRefresh = function () {
    clearTimeout(timeout);
    vm.autoRefreshActive = false;
    vm.delay = null;
    timeout = null;
  };

  vm.panelActive = "";
  vm.sourcesList = [];
  vm.chartList = [];

  function _getLists() {
    return new Promise(function (resolve, reject) {
      $rootScope.loading = true;

      var promises = [];

      promises.push($inputListsFactory.getListById(vm.chart.series[0].source));

      vm.chart.series[0].source2.forEach(function (e) {
        promises.push($inputListsFactory.getListById(e));
      });

      Promise.all(promises)
        .then(function (res) {
          vm.chartList = res[0];

          var schema = JSON.parse(res[0].schema.schema);
          var schemaName = res[0].schema.name;

          vm.chartList.schema = schema.definitions[schemaName];

          vm.sourcesList = res;
          resolve(vm.chartList);
        })
        .catch(function (err) {
          console.error("promise", err);
          reject();
        });
    });
  }
  function _getChartConfigColors() {
    return new Promise(function (resolve, reject) {
      $rootScope.loading = true;
      $ConfigurationFactory
        .getGlobalConfiguration()
        .then(function (res) {
          vm.chartCustomColors = res.dashboard.chartTheme || null;
          resolve(res);
        })
        .catch(function (err) {
          console.error("Error@getLists", err);
          reject();
        });
    });
  }

  vm.reloadChart = function () {
    return new Promise(function (resolve) {
      $rootScope.$broadcast("refreshListCharts", null);
      vm.initChart().then(function () {
        resolve();
      });
    });
  };

  $scope.validatePermission = function (action) {
    return $permissionsFactory.hasPermission("graphic-report#" + vm.chartId + ":" + action);
  };

  vm.onClickPanel = function (panel) {
    if (vm.panelActive == panel) {
      vm.panelActive = "";
    } else {
      vm.panelActive = panel;
    }
  };

  vm.clearFilters = function () {
    vm.sendFilter = null;
    vm.chartActivefilters = null;

    vm.filterChart(null);
  };

  $scope.$on("filterChart_" + vm.chartId, function (e, filters) {
    vm.filterChart(filters);
    vm.showChartFiltersDialog = false;
  });

  $scope.$on("removeFilters_" + vm.chartId, function (e) {
    vm.clearFilters();
  });
  $scope.$on("refresh_" + vm.chartId, function (e) {
    vm.initChart();
  });
  $scope.$on("startAutoRefresh_" + vm.chartId, function (e, time) {
    vm.startAutoRefresh(time);
  });
  $scope.$on("stopAutoRefresh_" + vm.chartId, function (e) {
    vm.stopAutoRefresh();
  });

  vm.removePivot = function () {
    vm.hasPivot = false;
    if (vm.echartConfig && vm.echartConfig.hasOwnProperty("pivotFunction"))
      vm.echartConfig.pivotFunction = null;

    vm.pivotFunction = null;
    vm.saveChart();
  };

  $scope.$on("applyPercentageValue_" + vm.chartId, function (e, action, value) {
    vm.hasPivot = false;
    vm.echartConfig.pivotFunction = value;
    vm.saveChart();
  });

  vm.filterChart = function (filters, save) {
    if (filters == null) {
      vm.chartDataIsFiltered = false;
      vm.echartConfig.hasFilters = null;
      vm.chartActivefilters = null;
    }

    if (filters != null) {
      vm.chartDataIsFiltered = true;
      vm.echartConfig.hasFilters = filters;
      vm.chartActivefilters = filters;
    }

    var promises = [];
    promises.push(_getChartData(filters, vm.pivotFunction));
    Promise.all(promises).then(function () {
      $scope.isLoading = false;
      vm.drawChart(vm.chartActivefilters, _resizeChart);
      if (save) vm.saveChart();
    });
  };

  $scope.toggleSideNav = function () {
    if (vm.isWidget == false) vm.sidenav_is_open = !vm.sidenav_is_open;
    _resizeChart();
  };

  $scope.filterDialog = function () {
    $mdDialog
      .show({
        controller: "ChartFilterDialogController",
        controllerAs: "ctrl",
        templateUrl: "app/charts/components/filter-dialog/filter-dialog.html",
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        escapeToClose: false,
        locals: {
          config: vm.chart,
          translation: vm.translation,
          schema : vm.chartList.schema,
        },
      })
      .then(function (filters) {
        vm.showChartFiltersDialog = false;

        vm.filterChart(filters, true);
      });
  };

  function _getShemafromSources() {
    if (vm.sourcesList.length == 0) {
      $toastr.error("No source list data");
      return;
    }
    var source = vm.sourcesList[0];
    // var name = source.schema.name;
    var schema = source.schema.properties;
    var fields = Object.keys(schema);
    return fields;
  }

  $scope.assignPivot = function () {
    var currentPivot = undefined;
    var hasGroupby = vm.chart.series.some(function (e) {
      return angular.isDefined(e.groupBy) && e.groupBy.length > 0;
    });
    $mdDialog.show({
      controller: "assignPivotDialogController",
      controllerAs: "ctrl",
      templateUrl: "app/charts/components/assign-pivot-dialog/assign-pivot-dialog.html",
      parent: angular.element(document.body),
      clickOutsideToClose: false,
      locals: {
        chartValues: vm.chartData,
        hasGroupby: hasGroupby,
        currentPivot: currentPivot,
        chartId: vm.chartId,
        schemaFields: _getShemafromSources(),
      },
    });
  };

  $scope.$on("saveconfig_" + vm.chartId, function (e) {
    vm.saveConfig();
  });

  $scope.$on("refreshChart_" + vm.chartId, function (e, newConfig) {
    vm.chart = newConfig;
    vm.initChart();
  });

  ///- action chart toolbar
  vm.closeTab = function (chart) {
    $scope.$parent.$parent.$parent.ctrl.eliminarTabReport(chart);
  };

  vm.manageChart = function (chart) {
    if ($state.current.name == "app.chart") vm.dialogManageChart(chart);
    else $scope.$parent.$parent.$parent.ctrl.manageChart(chart);
  };

  vm.showShareEntityDialog = function (chart) {
    if ($state.current.name == "app.chart") vm.showShareEntityDialog(chart);
    else $scope.$parent.$parent.$parent.ctrl.showShareEntityDialog(chart);
  };

  vm.confirmDeleteChart = function (chart) {
    $scope.$parent.$parent.$parent.confirmDeleteChart(chart);
  };

  $scope.print = function () {
    vm.sidenav_is_open = false;
    vm.echart.resize({ height: _setChartHeight() });
    setTimeout(function () {
      window.print();
      vm.sidenav_is_open = true;
    }, 500);
  };

  vm.onDblClickYaxis = function (yAxisName) {
    var confirm = $mdDialog
      .prompt()
      .title(
        $translationService.getTranslationController(
          "Nombre del valor eje Y",
          "Y axis value name",
          "Nome do valor do eixo Y"
        )
      )
      .textContent(
        $translationService.getTranslationController(
          "Escribe el nombre",
          "Write the name",
          "Escreva o nome"
        )
      )
      .placeholder($translationService.getTranslationController("Nombre", "Name", "Nome"))
      .ariaLabel("yaxisName")
      .initialValue(yAxisName)
      .required(true)
      .ok("Ok")
      .cancel($translationService.getTranslationController("Cancelar", "Cancel", "Cancelar"))
      .targetEvent(this);

    $mdDialog.show(confirm).then(function (result) {
      vm.echartConfig.yAxis.name = result;
      vm.echart.setOption(vm.echartConfig);
      setTimeout(function () {
        vm.saveChart();
      }, 100);
    });
  };

  vm.$onDestroy = function () {
    vm.stopAutoRefresh();
  };

  vm.dialogManageChart = function () {
    // var chartConfig = angular.copy(vm.echartConfig);
    $mdDialog
      .show({
        controller: "WizardDialogController",
        controllerAs: "ctrl",
        templateUrl: "app/charts/components/wizard-dialog/wizard-dialog.html",
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        multiple: true,
        locals: {
          chartConfig: vm.chart,
          groupPath: vm.chart.group,
        },
      })
      .then(function () {
        vm.initChart();
      });
  };

  vm.showShareEntityDialog = function (selectedItem) {
    $mdDialog.show({
      controller: "ShareEntityController",
      templateUrl: "app/acl/component/dialog-share-entity.html",
      parent: angular.element(document.body),
      clickOutsideToClose: false,
      locals: {
        selectedItem: {
          id: selectedItem.id,
          resource: "graphic-report",
          name: selectedItem.name,
        },
        actions: ["read", "update", "delete"],
      },
    });
  };

  vm.resetColorSerie = function (serie, index) {
    var serie = vm.echartConfig.series.find(function (e, i) {
      return e.name == serie.name
    });
    var serieColor = serie.color;
    serie.data.forEach(function (d) {
      d.itemStyle = { color: serieColor };
    });
    vm.updateChart();
  };

  vm.onChangeColor = function (newColor, parentIndex ,index) {
    console.log("Change color:", newColor, parentIndex ,index);
    // console.log("Echart Config before color change:", vm.echartConfig.series);
    // var _serie = vm.echartConfig.series.find(function (e, i) {
    //   return e.name == serie.name && parentIndex== i;
    // });

    // if (type == "serie") {
    //   _serie.color = serie.color;
    // }

    // if (type == "data") {
    //   _serie.data.find(function (d, i) {
    //     if (i == index) {
    //       d.itemStyle = { color: data.color };
    //     }
    //   });
    // }

    vm.updateChart();
  };
}

/* Agrupa las reglas en un arbol recursivo por grupos */

(function () {
  'use strict';

  angular.module('dashboard').service('chartTreeService', chartTreeService);

  chartTreeService.$inject = [];
  function chartTreeService() {
    var vm = this;
    vm.group = function (schemas) {
      vm.schemasTree = {
        type: 'group',
        groupName: 'root',
        items: [],
      };

      schemas.forEach(function (val) {
        vm.evalItem(val);
      });

      return vm.schemasTree;
    };
    vm.evalItem = function (val) {
      if (val.group && val.group != '') {
        var paths = val.group.split('/').filter(function (e) {
          return e != '';
        });
        var element = vm.schemasTree.items;
        paths.forEach(function (group, depth) {
          var max = paths.length,
            level = depth + 1;
          var _element = element.filter(function (e) {
            return e.groupName == group;
          });
          if (!_element.length) {
            element = vm.createGroup(element, group);
          } else {
            element = _element[0].items;
          }
          if (level == max) {
            val.type = 'chart';
            element.push(val);
          }
        });
      } else {
        val.type = 'chart';
        vm.schemasTree.items.push(val);
      }
    };
    vm.createGroup = function (element, group) {
      element.push({
        type: 'group',
        groupName: group,
        items: [],
      });
      return element[element.length - 1].items;
    };
  }
})();

(function () {
  "use strict";
  angular
    .module("dashboard")
    .controller("chartIdController", chartIdController);
  chartIdController.$inject = [
    "$scope",
    "$rootScope",
    "$state",
    "$stateParams",
    "ChartsFactory",
    "toastr",
    "PermissionsFactory",
  ];

  function chartIdController(
    $scope,
    $rootScope,
    $state,
    $stateParams,
    $chartsFactory,
    $toastr,
    $permissionsFactory
  ) {
    var vm = this;
    vm.loading = true;
    vm.chartId = null;

    vm.$onInit = function () {
      if (!$stateParams.chartId) {
        $toastr.error("Invalid Chart ID");
        $state.go("app.charts");
        return;
      }

      vm.chartId = $stateParams.chartId;

      // _getChart($stateParams.chartId)
      //   .then(function (res) {
      //     vm.chart = res;
      //     console.log("vm.chart", vm.chart);
      //     vm.loading = false;
      //   })
      //   .catch(function (err) {
      //     console.error("Error@_getChart", err);
      //   });
      vm.loading = false;
    };
    vm.$onInit();

    // function _getChart(chartId) {
    //   return new Promise(function (resolve, reject) {
    //     vm.loading = true;
    //     $chartsFactory
    //       .getChartsbyDomain()
    //       .then(function (res) {
    //         vm.loading = false;
    //         var chart_id = res.data.find(function (ele) {
    //           return ele.id == chartId;
    //         });

    //         if (!chart_id) {
    //           $toastr.error("Chart not found");
    //           $state.go("app.charts");
    //           return;
    //         }

    //         resolve(chart_id);
    //       })
    //       .catch(function (err) {
    //         reject(null);
    //         console.error("Error@getChartsbyDomain", err);
    //         vm.loading = false;
    //       });
    //   });
    // }
  }
})();

(function () {
    'use strict';

    angular
        .module('dashboard')
        .controller('CreateCaseController', CreateCaseController);

    CreateCaseController.$inject = ['$rootScope', '$scope', '$state', '$localStorageService', 'toastr', '$mdDialog', 'CaseFactory', 'translationService', 'GroupFactory', 'UserFactory', 'inputData', 'ConfigurationFactory'];

    function CreateCaseController($rootScope, $scope, $state, $localStorageService, toastr, $mdDialog, CaseFactory, $translationService, GroupFactory, UserFactory, inputData, ConfigurationFactory) {
        $scope.validacion = {};
        $scope.inputs = {};
        $scope.categories = [];

        (function init() {

            $scope.inputs.createdBy = $localStorageService.getItem("currentUser.name");

            //Método para realizar traducción
            $translationService.getTranslation($scope, 'cases');
            $rootScope.loading = true;
            GroupFactory.getAllGroups().then(function (response) {
                $scope.groups = response.data;
                $scope.$apply();
            }).catch(function (error) {
                if (error.status == 403) {
                    toastr.error($translationService.getTranslationController('Usuario no autorizado.', 'Unauthorized User.', 'Usuário não autorizado.'));
                } else {
                    toastr.error(error);
                }
            }).finally(function () {
                $rootScope.loading = false;
            });

            UserFactory.getAllUsers().then(function (response) {
                $scope.users = response.data.data;
                $scope.$apply();
            }).catch(function (error) {
                if (error.status == 403) {
                    toastr.error($translationService.getTranslationController('Usuario no autorizado para leer usuarios', 'Unauthorized User to read users.', 'Usuário não autorizado para ler usuários.'));
                } else {
                    toastr.error(error);
                }
            }).finally(function () {
                $rootScope.loading = false;
            });

            ConfigurationFactory.getGlobalConfiguration().then(function (res) {
                $scope.categories = res.cases.category;
                $scope.$apply();
            }).catch(function (e) {
                console.log('ConfigurationFactory', e.msg);
            });
        })();

        $scope.cancel = function () {
            $mdDialog.cancel();
        }

        $scope.crearCasoController = function () {
            var v = $rootScope.validarCaso($scope.inputs);
            $scope.validacion = v;
            if (!v.show) {
                $rootScope.loading = true;
                var caseIn = {
                    title: $scope.inputs.nombre,
                    criticality: $scope.inputs.criticidad,
                    //state: 'abierto',
                    description: $scope.inputs.descripcion,
                    category: $scope.inputs.category
                };
                if ($scope.inputs.assigned != "") {
                    caseIn.assigned = { username: $scope.inputs.assigned };
                }
                if ($scope.inputs.group != "") {
                    caseIn.group = { id: $scope.inputs.group };
                }
                CaseFactory.createCase(caseIn).then(function (res) {
                    if (inputData.source == 'ALERT') {
                        saveEvents(res.data.caseId);
                    } else {
                        toastr.success($translationService.getTranslationController("Caso creado.", "Case created.", 'Caso criado.'));
                        refreshNgTableDynamicFn();
                        $scope.cancel();
                    }
                }).catch(function (error) {
                    console.log("CreateCases@SaveEvent. " + error)
                    if (error.status == 403) {
                        toastr.error($translationService.getTranslationController('Usuario no autorizado.', 'Unauthorized User.', 'Usuário não autorizado.'));
                    } else {
                        toastr.error($translationService.getTranslationController("No se ha podido guardar el caso.", "The case was not created.", 'O caso não foi criado.'));
                    }
                }).finally(function () {
                    $rootScope.loading = false;
                });
            }
        };

        function refreshNgTableDynamicFn() {
            $rootScope.$broadcast('refreshNgTableDynamic', { tableId: 'cases-table' });
        }

        function saveEvents(caseId) {
            var eventsId = []
            eventsId.push({ eventId: inputData.eventId });
            CaseFactory.addEvents(caseId, eventsId).then(function (response) {
                toastr.success($translationService.getTranslationController('Alertas asociadas', 'Associated alerts', 'Alertas associados'));
                $scope.cancel();
            }, function (error) {
                console.log("CreateCases@SaveEvent. " + error)
                if (error.status == 403) {
                    toastr.error($translationService.getTranslationController('Usuario no autorizado.', 'Unauthorized User.', 'Usuário não autorizado.'));
                } else {
                    toastr.error($translationService.getTranslationController("No se ha podido asociar la Alerta al Caso.", "The Alert could not be associated with the Case.", 'O alerta não pôde ser associado ao caso.'));
                }
            });
        }
    }
})();

// - Usado para crear casos desde intervalos eventReplay
// - TODO hacer generico para todos los casos de creación de casos
(function() {
'use strict';

  angular
    .module('dashboard')
    .controller('CrearCasoController', CrearCasoController);

  CrearCasoController.$inject = ['$scope', 'interval', 'CaseFactory', '$localStorageService', 'toastr', 'translationService'];
  function CrearCasoController($scope, interval, CaseFactory, $localStorageService, toastr, $translationService) {
        // $scope.bookmarkId = bookmark.id;
        $scope.interval = interval;
        $scope.casoCreado = false;
        $scope.caseProcessing = false;
        $scope.criticidad = 'Alta';
        $scope.ejecutivo = $localStorageService.getItem("currentUser.name");
        var symbols = interval.symbolList.map(function(smb){ return smb.symbolName });

        $scope.inputChange = function(type, value) {
            $scope[type] = value;
        };
        
        $scope.createCase = function() {
            $scope.caseProcessing = true;
            CaseFactory.createCase({
                title: "Interval: " + interval.title + " -> " + $scope.nombre,
                criticality: $scope.criticidad,
                state: 'abierto',
                description: interval.replayName + ", symbols (" + symbols + ")" + " -> " + $scope.descripcion,
            }).then(function(res){
                console.log(res);
                toastr.success($translationService.getTranslationController("Caso creado.", "Case created.", 'Caso criado.'));
                $scope.$hide();
                $scope.$apply();
            }).catch(function (e) {
                console.log('err@createCase');
                console.log(e);
                toastr.error($translationService.getTranslationController("No se ha podido guardar el caso.", "The case was not created.", 'O caso não foi criado.'));
            });
        };
    };
})();

(function () {
  'use strict';

  angular.module('dashboard').controller('CasosController', CasosController);

  CasosController.$inject = [
    '$scope',
    '$localStorageService',
    '$modal',
    '$rootScope',
    'Comentarios',
    '$stateParams',
    'CaseFactory',
    '$timeout',
    'UserFactory',
    'translationService',
    '$mdDialog',
    'NgTableParams',
    'ngTableEventsChannel',
    '$location',
    'toastr',
    'PermissionsFactory',
    'GroupFactory',
  ];

  function CasosController(
    $scope,
    $localStorageService,
    $modal,
    $rootScope,
    Comentarios,
    $stateParams,
    CaseFactory,
    $timeout,
    UserFactory,
    $translationService,
    $mdDialog,
    NgTableParams,
    ngTableEventsChannel,
    $location,
    toastr,
    PermissionsFactory,
    GroupFactory
  ) {
    var vm = this;
    vm.api = {};
    vm.usuarios = [];
    vm.selectedTab = 'index';
    vm.currentUserId = $localStorageService.getItem('currentUser').userId;
    vm.resumeUsers = [];
    vm.resumeGroups = [];

    vm.init = function () {
      //Método para realizar traducción
      $translationService.getTranslation($scope, 'cases');

      obtenerUsuariosTabFn();
      getGroupList();
      showLangFn();
      vm.configCases = {
        datasource: {
          origin: 'GET',
          url: '/risk-backend/rest/case/summary',
          params: {
            query: '',
            sortBy: 'caseId',
            sort: 'desc',
            startDate: moment(
              $rootScope.desde ||
                moment().subtract(1, 'week').hour(0).minute(0).second(0)
            ),
            endDate: moment(
              $rootScope.hasta || moment().hour(23).minute(59).second(59)
            ),
            page: 1,
            itemsPerPage: 25,
          },
          paramsOut: {
            data: 'cases',
            pagination: 'pagination',
          },
        },
        pageSizes: [25, 50, 100],
        columns: [
          {
            field: 'caseId',
            title: 'Id',
            type: 'number',
            show: true,
            sortable: false,
            width: 3,
          },
          {
            field: 'title',
            title: $translationService.getTranslationController(
              'Nombre',
              'Name',
              'Nome'
            ),
            type: 'text',
            show: true,
            sortable: 'title',
            filterable: { type: 'text' },
            width: 30,
          },
          {
            field: 'creationDate',
            title: $translationService.getTranslationController(
              'Fecha',
              'Date',
              'Data'
            ),
            type: 'datetime',
            show: true,
            sortable: 'creationDate',
            width: 5,
          },
          {
            field: 'state',
            title: $translationService.getTranslationController(
              'Estado',
              'Status',
              'Estado'
            ),
            type: 'text',
            show: true,
            sortable: 'state',
            filterable: {
              type: 'select',
              options: [
                { key: 'abierto', value: 'Abierto' },
                { key: 'cerrado', value: 'Cerrado' },
              ],
            },
            width: 5,
          },
          {
            field: 'criticality',
            title: $translationService.getTranslationController(
              'Criticidad',
              'Criticality',
              'Nível de criticidade'
            ),
            type: 'string',
            show: true,
            sortable: 'criticality',
            width: 5,
          },
          {
            field: 'assigned',
            title: $translationService.getTranslationController(
              'Asignado',
              'Assigned',
              'Gerente de relacionamento'
            ),
            type: 'object',
            key: 'fullName',
            show: true,
            sortable: 'username',
            filterable: {
              type: 'select',
              options: vm.resumeUsers,
            },
            width: 5,
          },
          {
            field: 'group',
            title: $translationService.getTranslationController(
              'Grupo',
              'Group',
              'Gerente de relacionamento'
            ),
            type: 'object',
            key: 'name',
            show: true,
            sortable: 'groupName',
            filterable: {
              type: 'select',
              options: vm.resumeGroups,
            },
            width: 5,
          },
          {
            field: 'createdBy',
            title: $translationService.getTranslationController(
              'Creado por',
              'Created By',
              'Gerente de relacionamento'
            ),
            type: 'object',
            key: 'fullName',
            show: true,
            width: 5,
          },
          {
            field: 'closingDate',
            title: $translationService.getTranslationController(
              'Fecha de cierre',
              'Closing Date',
              'Data de fechamento'
            ),
            type: 'date',
            show: true,
            width: 5,
          },
          {
            field: 'closingReason',
            title: $translationService.getTranslationController(
              'Motivo de cierre',
              'Reason for closure',
              'Motivo do fechamento'
            ),
            type: 'string',
            show: true,
            width: 5,
          },
        ],
      };

      if ($rootScope.eventRecivedPutAlertToCaseId == null) {
        $rootScope.eventRecivedPutAlertToCaseId = $rootScope.$on(
          'addEventsToCaseId',
          function (event, object) {
            event.stopPropagation();
            assignEventsToCaseIdFn(object.caseId, object.items);
          }
        );
      }
    };

    vm.init();

    function assignEventsToCaseIdFn(caseId, selectedEvents) {
      $rootScope.loading = true;
      var eventsId = [];
      selectedEvents.forEach(function (_item) {
        eventsId.push({ eventId: _item });
      });

      CaseFactory.addEvents(caseId, eventsId).then(function (response) {
        var msg = $translationService.getTranslationController(
          'Alertas asociadas',
          'Associated alerts',
          'Alertas associados'
        );
        toastr.success(msg);
        $rootScope.loading = false;
        $rootScope.$broadcast('riskGridCleanSelection');
        $location
          .path('/casos/' + caseId)
          .search('')
          .replace();
      });
    }

    function showLangFn() {
      if ($rootScope.tabsCasos[0].id === 'index') {
        $rootScope.tabsCasos[0].name =
          $translationService.getTranslationController('TODOS', 'ALL', 'TODOS');
      }
    }

    function validarEstado(tab) {
      if (tab.caso.state == 'cerrado') {
        var msg = $translationService.getTranslationController(
          'No disponible, el caso esta cerrado.',
          'Not available, the case is closed.',
          'Não disponível, o caso está fechado.'
        );
        $scope.showSimpleToast(msg);
        return false;
      }
      return true;
    }

    vm.setTab = function (newTab) {
      vm.selectedTab = newTab;
    };

    vm.isSet = function (tabNum) {
      return vm.selectedTab == tabNum;
    };

    vm.isActive = function (id) {
      return vm.isSet(id) && id != 'index';
    };

    vm.eliminarTabCaso = function (tabId) {
      var indexTab = -2;
      for (var i = 0; i < $rootScope.tabsCasos.length; i++) {
        var actualTab = $rootScope.tabsCasos[i];
        if (actualTab.id === tabId) {
          indexTab = i;
          break;
        }
      }
      if (indexTab > 0) {
        $rootScope.tabsCasos.splice(indexTab, 1);
        vm.setTab('index');
      }
    };

    vm.crearTabDetalleCaso = function (rowCaso) {
      //Se recorren los tabs existentes
      var existeTab = false;
      $rootScope.loading = true;
      for (var i = 0; i < $rootScope.tabsCasos.length; i++) {
        var actualTab = $rootScope.tabsCasos[i];
        if (actualTab.id === rowCaso.caseId) {
          existeTab = true;
          break;
        }
      }
      if (existeTab) {
        vm.setTab(actualTab.id);
        $rootScope.loading = false;
      } else {
        //Se crea el nuevo tab con el detalle del caso
        var newTab = {
          id: rowCaso.caseId,
          name: rowCaso.title.substring(0, 15) + ' - ' + rowCaso.caseId,
        };
        //Se agrega el tab a la lista
        $rootScope.tabsCasos.push(newTab);
        newTab.caso = rowCaso;
        newTab.caso.showMensajes = true;
        newTab.caso.showComments = true;
        newTab.caso.comentarios = {
          titulo: '',
          comArray: [],
          llaveComentario: '',
          texto: '',
          alerta: {},
          evento: {},
        };
        newTab.caso.activePosition;
        newTab.caso.files = [];
        newTab.caso.comments = [];
        newTab.caso.alerts = [];

        vm.setTab(newTab.id);
        $rootScope.loading = false;
      }
    };

    function obtenerUsuariosTabFn() {
      vm.usuarios = [];
      UserFactory.getAllUsers({})
        .then(function (response) {
          vm.usuarios = response.data.data;
          var currentUser = $localStorageService.getItem("currentUser");
          if (currentUser.userType === 'SA') {
            vm.usuarios.forEach(function (_item) {
              vm.resumeUsers.push({
                key: _item.userId,
                value: _item.fullName,
              });
            });
          } else {
            vm.usuarios.forEach(function (_item) {
              if (currentUser.userId != _item.userId)
                vm.resumeUsers.push({
                  key: _item.userId,
                  value: _item.fullName,
                });
            });
          }
        })
        .catch(function (error) {
          $rootScope.loading = false;
          if (error.status == 403) {
            toastr.error(
              $translationService.getTranslationController(
                'Usuario no autorizado para leer usuarios',
                'Unauthorized User to read users.',
                'Usuário não autorizado para ler usuários.'
              )
            );
          } else {
            toastr.error(error);
          }
        });
    }

    function getGroupList() {
      vm.groups = [];
      $rootScope.loading = true;
      GroupFactory.getAllGroups()
        .then(function (response) {
          vm.groups = response.data;
          vm.groups.forEach(function (_item) {
            vm.resumeGroups.push({
              key: _item.id,
              value: _item.name,
            });
          });

          $scope.$apply();
        })
        .catch(function (error) {
          if (error.status == 403) {
            toastr.error(
              $translationService.getTranslationController(
                'Usuario no autorizado.',
                'Unauthorized User.',
                'Usuário não autorizado.'
              )
            );
          } else {
            toastr.error(error);
          }
        })
        .finally(function () {
          $rootScope.loading = false;
        });
    }

    vm.toggleDetail = function (tabCaso, $index) {
      tabCaso.activePosition = tabCaso.activePosition == $index ? -1 : $index;
    };

    vm.toggleMensaje = function (tabCaso, openClose, alert, evento) {
      // $timeout(function () {
      //   $('.discussion.comments-box').scrollTop(
      //     $('.discussion.comments-box').prop('scrollHeight')
      //   );
      // });
      if (!openClose) {
        if (!tabCaso.showMensajes) {
          tabCaso.showMensajes = true;
        }
      } else {
        tabCaso.showMensajes = !tabCaso.showMensajes;
      }
      if (alert && evento) {
        tabCaso.comentarios = {
          titulo: '',
          comArray: [],
          llaveComentario: '',
          texto: '',
          alerta: alert,
          evento: evento,
        };
        Comentarios.comentariosCasoAlarmaEvento(
          tabCaso.id,
          alert.id,
          evento.id,
          function (response) {
            if (response.header.code == 0) {
              var llaveCom = Comentarios.obtenerLlaveComentarios(
                tabCaso.id,
                alert.id,
                evento.id
              );
              evento.comentariosQty = response.body.length;
              tabCaso.comentarios = {
                titulo:
                  $translationService.getTranslationController(
                    'Comentarios Alerta ',
                    'Comments Alert ',
                    'Alerta de comentários '
                  ) +
                  alert.id +
                  $translationService.getTranslationController(
                    ' Evento ',
                    ' Event ',
                    ' Evento '
                  ) +
                  evento.id,
                comArray: response.body,
                llaveComentario: llaveCom,
                alerta: alert,
                evento: evento,
              };
            }
          }
        );
      }
    };

    vm.toggleComments = function (tabCaso, openClose, alert, evento) {
      // $timeout(function () {
      //   $('.discussion.comments-box').scrollTop(
      //     $('.discussion.comments-box').prop('scrollHeight')
      //   );
      // });
      if (!openClose) {
        if (!tabCaso.showComments) {
          tabCaso.showComments = true;
        }
      } else {
        tabCaso.showComments = !tabCaso.showComments;
      }
      if (alert && evento) {
        tabCaso.comentarios = {
          titulo: '',
          comArray: [],
          llaveComentario: '',
          texto: '',
          alerta: alert,
          evento: evento,
        };
        Comentarios.comentariosCasoAlarmaEvento(
          tabCaso.id,
          alert.id,
          evento.id,
          function (response) {
            if (response.header.code == 0) {
              var llaveCom = Comentarios.obtenerLlaveComentarios(
                tabCaso.id,
                alert.id,
                evento.id
              );
              evento.comentariosQty = response.body.length;
              tabCaso.comentarios = {
                titulo:
                  $translationService.getTranslationController(
                    'Comentarios Alerta ',
                    'Comments Alert ',
                    'Alerta de comentários '
                  ) +
                  alert.id +
                  $translationService.getTranslationController(
                    ' Evento ',
                    ' Event ',
                    ' Evento '
                  ) +
                  evento.id,
                comArray: response.body,
                llaveComentario: llaveCom,
                alerta: alert,
                evento: evento,
              };
            }
          }
        );
      }
    };

    vm.validatePermission = function () {
      return PermissionsFactory.hasPermission('cases:export');
    };

    /************************************* modal crear caso ****************************************************/
    vm.showModal = function (ev) {
      $mdDialog.show({
        controller: 'CreateCaseController',
        templateUrl: 'app/casos/templates/dialog-create-case.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          inputData: {
            source: 'CASES',
            eventId: undefined,
          },
        },
      });
    };

    /***********************************************************************************************************/
    //Este codigo sirve para poder abrir/cargar automaticamente la pestaña de una alerta especifica
    if ($stateParams.idCaso) {
      var myCase = $rootScope.getCasoById($stateParams.idCaso);
      if (myCase) {
        vm.crearTabDetalleCaso(myCase);
      }
    }
  }
})();

'use strict';

angular.module('dashboard').component('casesRelatedFiles', {
  templateUrl: 'app/casos/templates/section-related-files.html',
  controllerAs: 'ctrl',
  bindings: {
    tab: '=',
  },
  controller: CasesReletedFilesController,
});

CasesReletedFilesController.$inject = [
  '$scope',
  '$cookies',
  '$localStorageService',
  'FileUploader',
  'FileSaver',
  '$modal',
  '$rootScope',
  'Casos',
  'Comentarios',
  '$stateParams',
  'CaseCommentsFactory',
  'CaseFactory',
  'Paginator',
  '$timeout',
  'env',
  'PerfilesFactory',
  '$mdToast',
  'EventsFactory',
  'BaseUrl',
  'translationService',
  '$mdDialog',
  '$document',
  'toastr',
  'PermissionsFactory',
];

function CasesReletedFilesController(
  $scope,
  $cookies,
  $localStorageService,
  FileUploader,
  FileSaver,
  $modal,
  $rootScope,
  Casos,
  Comentarios,
  $stateParams,
  CaseCommentsFactory,
  CaseFactory,
  Paginator,
  $timeout,
  env,
  PerfilesFactory,
  $mdToast,
  EventsFactory,
  BaseUrl,
  $translationService,
  $mdDialog,
  $document,
  toastr,
  PermissionsFactory
) {
  var vm = this;

  vm.$onInit = function () {
    //Método para realizar traducción
    $translationService.getTranslation($scope, 'cases');

    //Se obtienen los archivos de la alerta
    if (vm.tab.caso.files.length == 0) {
      obtenerArchivosTabFn(vm.tab);
    }

    vm.uploader = new FileUploader({
      url: '/risk-backend/rest/case/' + vm.tab.caso.caseId + '/file',
      headers: { token: $cookies.get('token') },
      formData: { creationDate: moment() },
      removeAfterUpload: true,
    });

    vm.uploader.filters.push({
      name: 'Extensions',
      fn: function (item, options) {
        var allowedType = [
          'text/csv',
          'image/jpeg',
          'image/png',
          'image/jpeg',
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.ms-powerpoint',
          'application/vnd.openxmlformats-officedocument.presentationml.presentation',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ];

        if (allowedType.indexOf(item.type) === -1) {
          toastr.error('Archivo no permitido');
        }

        return allowedType.indexOf(item.type) !== -1;
      },
    });

    vm.uploader.filters.push({
      name: 'Size',
      fn: function (item, options) {
        var maxSize = 31457280;
        var size = item.size;

        if (item.size >= 31457280) {
          var msg = $translationService.getTranslationController(
            'El archivo supera el límite de 30Mb',
            'The file exceeds the 30Mb limit',
            'O arquivo excede o limite de 30Mb'
          );
          toastr.error(msg);
        }

        return item.size < 31457280;
      },
    });

    vm.uploader.onAfterAddingFile = function (item) {
      if (!validarEstadoFn(vm.tab)) {
        vm.uploader.removeFromQueue(item);
        return false;
      }
    };

    vm.uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (response === 'fileDuplicate') {
        var msg = $translationService.getTranslationController(
          'No se ha podido cargar, archivo duplicado en el sistema.',
          'Unable to load, duplicate file in the system.',
          'Não é possível carregar, duplicar arquivo no sistema.'
        );
        toastr.error(msg);
      } else {
        if (status == 403) {
          toastr.error(
            $translationService.getTranslationController(
              'Usuario no autorizado.',
              'Unauthorized User.',
              'Usuário não autorizado.'
            )
          );
        } else {
          toastr.error(
            $translationService.getTranslationController(
              'No se ha podido cargar el archivo.',
              'The file could not be loaded.',
              'O arquivo não pôde ser carregado.'
            )
          );
        }
      }
    };

    vm.uploader.onSuccessItem = function (item, response, status, headers) {
      if (status) {
        var msg = $translationService.getTranslationController(
          'Archivo cargado exitosamente',
          'File successfully loaded',
          'Arquivo carregado com sucesso'
        );
        toastr.success(msg);
        obtenerArchivosTabFn(vm.tab);
      }
    };
  };

  function validarEstadoFn(tab) {
    if (tab.caso.state == 'cerrado') {
      var msg = $translationService.getTranslationController(
        'No disponible, el caso esta cerrado.',
        'Not available, the case is closed.',
        'Não disponível, o caso está fechado.'
      );
      toastr.error(msg);
      return false;
    }
    return true;
  }

  vm.eliminarArchivo = function (file, tab) {
    if (!validarEstadoFn(tab)) {
      return false;
    }

    if (file.edit.justificacion.length < 3) {
      var msg = $translationService.getTranslationController(
        'Debe justificar esta acción!',
        'You must justify this action!',
        'Você deve justificar esta ação!'
      );
      toastr.error(msg);
      return false;
    }
    $rootScope.loading = true;
    CaseFactory.deleteFile({
      id: file.fileId,
      caseId: file.fileCaseId,
      justified: file.edit.justificacion,
    })
      .then(function (res) {
        obtenerArchivosTabFn(tab);
        var msg = $translationService.getTranslationController(
          'Eliminando Archivo',
          'Deleting File',
          'Excluindo o arquivo'
        );
        toastr.success(msg);
        $rootScope.loading = false;
      })
      .catch(function (error) {
        $rootScope.loading = false;
        if (error.status == 403) {
          toastr.error(
            $translationService.getTranslationController(
              'Usuario no autorizado.',
              'Unauthorized User.',
              'Usuário não autorizado.'
            )
          );
        } else {
          toastr.error(e);
        }
      });
  };

  vm.cancelarElimArchivo = function (file) {
    file.eliminando = false;
  };

  vm.descargarArchivo = function (file) {
    CaseFactory.downloadFile({
      id: file.fileCaseId,
      fileId: file.fileId,
      fileName: file.fileName,
    })
      .then(function (res) {
        FileSaver.saveAs(new Blob([res.data]), file.fileName);
      })
      .catch(function (err) {
        $rootScope.loading = false;
        if (err.status == 403) {
          toastr.error(
            $translationService.getTranslationController(
              'Usuario no autorizado.',
              'Unauthorized User.',
              'Usuário não autorizado.'
            )
          );
        } else {
          toastr.error(err);
        }
      });
  };

  vm.eliminandoArchivo = function (file) {
    file.edit = {
      justificacion: '',
    };
    file.eliminando = true;
  };

  function obtenerArchivosTabFn(newTab) {
    // Se buscan los archivos relacionados con el caso.
    newTab.caso.filesLoaded = false;
    CaseFactory.getFiles({
      id: newTab.id,
    })
      .then(function (res) {
        newTab.caso.files = [];
        //Se obtienen los archivos de la alerta
        if (res != null) {
          for (var i in res) {
            if (res[i].fileStatus !== 'DELETE') {
              res[i].fileCreationDate = moment(res[i].fileCreationDate);
              res[i].eliminando = false;
              (res[i].url =
                BaseUrl.path['URL_UP_FILE'] +
                '/' +
                newTab.id +
                '/file/' +
                res[i].fileId),
                newTab.caso.files.push(res[i]);
            }
          }
          newTab.caso.files.sort(function (a, b) {
            return b.fileId - a.fileId;
          });
          newTab.caso.filesLoaded = true;
        }
      })
      .catch(function (error) {
        newTab.caso.filesLoaded = true;
        if (error.status == 403) {
          toastr.error(
            $translationService.getTranslationController(
              'Usuario no autorizado.',
              'Unauthorized User.',
              'Usuário não autorizado.'
            )
          );
        } else {
          toastr.error(error);
        }
      });
  }

  //============== DRAG & DROP =============
  $scope.setFiles = function (element) {
    $scope.$apply(function ($scope) {
      // Turn the FileList object into an Array
      $scope.files = [];
      var sizeAllFile = 0;
      for (var i = 0; i < element.files.length; i++) {
        var fileName = element.files[i].name.toLowerCase();
        var fileType = element.files[i].type.toLowerCase();
        sizeAllFile = sizeAllFile + element.files[i].size;

        if (
          !fileName.match(
            /(\.jpg|\.png|\.jpeg|\.doc|\.docx|\.pdf|\.ppt|\.xls)$/
          ) &&
          !(
            fileType === 'image/jpeg' ||
            fileType === 'image/png' ||
            fileType === 'application/msword' ||
            fileType === 'application/pdf' ||
            fileType === 'application/vnd.ms-powerpoint' ||
            fileType === 'application/vnd.ms-excel'
          )
        ) {
          $scope.errorExt = true;
          $scope.files = [];
          break;
        } else if (sizeAllFile > 31457280) {
          $scope.errorSize = true;
          $scope.files = [];
          break;
        } else {
          $scope.errorSize = false;
          $scope.errorExt = false;
          $scope.files.push(element.files[i]);
        }
      }
      $scope.progressVisible = false;
    });
  };

  $scope.uploadFile = function () {
    var fd = new FormData();

    for (var i in $scope.files) {
      fd.append('uploadedFile', $scope.files[i]);
    }

    // Antigua función de subida con barra de progreso.
    var xhr = new XMLHttpRequest();
    xhr.upload.addEventListener('progress', uploadProgress, false);
    xhr.addEventListener('load', uploadComplete, false);
    xhr.addEventListener('error', uploadFailed, false);
    xhr.addEventListener('abort', uploadCanceled, false);
    xhr.open('POST', '/fileupload');
    $scope.progressVisible = true;

    // Función de subida del archivo
    CaseFactory.uploadFile({
      fis: '',
      fdcd: fd,
      id: $scope.$id,
    }).then(function (res) {
      console.log('Archivo cargado!');
    });
    xhr.send(fd);
  };

  $scope.checkEvent = function (rowAlerta) {
    EventsFactory.checkEvent(rowAlerta).then(function (res) {
      if (res) {
        vm.api.query();
        for (var i = 0; i < vm.events.length; i++) {
          if (vm.events[i].id === res.id) {
            vm.events[i].visto = res.visto;
          }
        }
        $scope.$apply();
      }
    });
  };

  function uploadProgress(evt) {
    $scope.$apply(function () {
      if (evt.lengthComputable) {
        $scope.progress = Math.round((evt.loaded * 100) / evt.total);
      } else {
        $scope.progress = 'unable to compute';
      }
    });
  }

  function uploadComplete(evt) {
    /* This event is raised when the server send back a response */
    alert(evt.target.responseText);
  }

  function uploadFailed(evt) {
    var msg = $translationService.getTranslationController(
      'Se produjo un error al intentar cargar el archivo.',
      'There was an error attempting to upload the file.',
      'Ocorreu um erro ao tentar carregar o arquivo.'
    );
    alert(msg);
  }

  function uploadCanceled(evt) {
    $scope.$apply(function () {
      $scope.progressVisible = false;
    });
    var msg = $translationService.getTranslationController(
      'La carga ha sido cancelada por el usuario o el navegador ha desconectado la conexión.',
      'The upload has been canceled by the user or the browser dropped the connection.',
      "A carga foi cancelada pelo usuário ou o navegador desconectou a conexão. '"
    );
    alert(msg);
  }

  vm.validatePermission = function () {
    return PermissionsFactory.hasPermission('cases:update');
  };
}

"use strict";

angular.module('dashboard').component('casesComment', {
    templateUrl: 'app/casos/templates/section-comment.html',
    controllerAs: 'ctrl',
    bindings: {
        tab: '=',
        users: '<'
    },
    controller: CasesCommentController
});


CasesCommentController.$inject = ['$scope', '$rootScope', 'CaseFactory', 'translationService', 'toastr', '$mdPanel', 'PermissionsFactory'];

function CasesCommentController($scope, $rootScope, CaseFactory, $translationService, toastr, $mdPanel, PermissionsFactory) {
    var vm = this;
    var converter = new showdown.Converter();
    vm._mdPanel = $mdPanel;

    vm.$onInit = function () {
        vm.isOpen = false;

        //Método para realizar traducción
        $translationService.getTranslation($scope, 'cases');

        //Se obtiene los comentarios asociados al caso
        if(vm.tab.caso.comments.length == 0) {
            obtenerComentariosTab(vm.tab);
        }
    };

    // comments
    vm.commentEditable = function (comment) {
        vm.editComment = comment.comment;
        comment.editando = true;
        comment.eliminando = false;
    };

    vm.removeComment = function (comment) {
        comment.edit = {
            justificacion: ""
        };
        comment.eliminando = true;
        comment.editando = false;
    };

    vm.CancelarEdiElimComentario = function (comment) {
        comment.eliminando = false;
        comment.editando = false;
        vm.editComment = undefined;
    };

    function renderComment(tab, res){
        res.moment = moment(res.timestamp).fromNow();
        res.editando = false;
        res.eliminando = false;
        res.isUpdatable = true;
        res.commentHtml = converter.makeHtml(formatCommentFn(res.comment));
        tab.caso.comment = "";
        tab.caso.comments.unshift(res);
        vm.comment = '';
    }

    $scope.$on('renderCaseComment', function (e, data) {
        renderComment(data.tab, data.res);
    });

    vm.publicarComentario = function (tab) {
        if (!validarEstado(tab)) {
            return false
        }

        if (vm.comment == undefined || vm.comment == '') {
            var msg = $translationService.getTranslationController('Debe insertar un comentario válido!', 'You must insert a valid comment!', 'Você deve inserir um comentário válido!');
            toastr.error(msg);
            return false;
        }
        $rootScope.loading = true;
        CaseFactory.createComment({
            id: tab.caso.caseId,
            comment: vm.comment
        }).then(function (res) {
            if (res) {
                renderComment(tab, res);
            }
            $rootScope.loading = false;
            $scope.$apply();
        }).catch(function (error) {
            $rootScope.loading = false;
            if(error.status == 403) {
                toastr.error($translationService.getTranslationController('Usuario no autorizado.', 'Unauthorized User.', 'Usuário não autorizado.'));
            } else {
                toastr.error(error);
            }
        });
    };

    function editarComentarioFn(comment, tab) {
        if (!validarEstado(tab)) {
            return false
        }

        $rootScope.loading = true;
        CaseFactory.uploadComment({
            id: comment.id,
            caseId: comment.commentCase.caseId,
            comment: vm.editComment,
        }).then(function (res) {
            comment.editando = false;
            comment.comment = vm.editComment;
            comment.commentHtml = converter.makeHtml(formatCommentFn(comment.comment));
            comment.status = 'MODIFIED';
            comment.edited = ' (editado)';
            comment.timestamp = comment.timestamp;
            comment.moment = moment(comment.timestamp).fromNow();
            var msg = $translationService.getTranslationController('Cambios guardados', 'Changes saved', 'Mudanças salvas');
            toastr.success(msg);
            $rootScope.loading = false;
            vm.editComment = undefined;
            $scope.$apply();
        }).catch(function (error) {
            vm.editComment = undefined;
            $rootScope.loading = false;
            if(error.status == 403) {
                toastr.error($translationService.getTranslationController('Usuario no autorizado.', 'Unauthorized User.', 'Usuário não autorizado.'));
            } else {
                toastr.error(error);
            }
        });
    }

    function validarEstado(tab) {
        if (tab.caso.state == 'cerrado') {
            var msg = $translationService.getTranslationController('No disponible, el caso esta cerrado.', 'Not available, the case is closed.', 'Não disponível, o caso está fechado.');
            toastr.error(msg);
            return false;
        }
        return true;
    }

    function eliminarComentarioFn(comment, tab) {
        if (!validarEstado(tab)) {
            return false
        }

        if (comment.edit.justificacion < 3) {
            var msg = $translationService.getTranslationController('Debe justificar esta acción!', 'You must justify this action!', 'Você deve justificar esta ação!');
            toastr.error(msg);
            return false;
        }
        $rootScope.loading = true;
        CaseFactory.deleteComment({
            id: comment.id,
            caseId: comment.commentCase.caseId,
            justified: comment.edit.justificacion
        }).then(function (res) {
            obtenerComentariosTab(tab);
            var msg = $translationService.getTranslationController('Eliminando Comentario', 'Deleting Comment', 'Excluindo Comentário');
            toastr.success(msg);
            $rootScope.loading = false;
        }).catch(function (error) {
            $rootScope.loading = false;
            if(error.status == 403) {
                toastr.error($translationService.getTranslationController('Usuario no autorizado.', 'Unauthorized User.', 'Usuário não autorizado.'));
            } else {
                toastr.error(error);
            }
        });
    }

    vm.updateComment = function (comment, tab) {
        if (comment.editando) {
            editarComentarioFn(comment, tab);
        } else {
            eliminarComentarioFn(comment, tab);
        }
    };

    function formatCommentFn(comment) {
        if (angular.isUndefined(comment)) return;

        var result = '';
        var separador = " ";
        var items = comment.split(separador);
        angular.forEach(items, function (item) {
            if (item.startsWith("@")) {
                item = '<a href=\"#\" target="_blank">' + item + '</a>';
            } else if (item.startsWith("http")) {
                item = '<a href=\"' + item + '\" target="_blank">' + item + '</a>';
            }

            result = (result === '') ? item : result + ' ' + item;
        });
        return result;
    }

    function obtenerComentariosTab(newTab) {
        newTab.caso.commentsLoaded = false;
        CaseFactory.getComments(newTab.id)
            .then(function (res) {
                newTab.caso.comments = [];
                for (var i in res) {
                    if (res[i].status !== 'DELETE') {
                        res[i].moment = moment(res[i].timestamp).fromNow()
                        res[i].edited = res[i].status === 'MODIFIED' ? ' (editado)' : '';
                        res[i].editando = false
                        res[i].eliminando = false
                        res[i].commentHtml = converter.makeHtml(formatCommentFn(res[i].comment));
                        newTab.caso.comments.push(res[i]);
                    }
                }
                newTab.caso.comments.sort(function (a, b) {
                    return (b.id - a.id)
                });
                newTab.caso.commentsLoaded = true;
            })
            .catch(function (error) {
                newTab.caso.commentsLoaded = true;
                if(error.status == 403) {
                    toastr.error($translationService.getTranslationController('Usuario no autorizado.', 'Unauthorized User.', 'Usuário não autorizado.'));
                } else {
                    toastr.error(error);
                }
            })
    }

    vm.ngFocus = function (clazz) {
        vm.clazz = clazz;
    }

    $scope.$watch("ctrl.comment", function(newValue, oldValue) {
        showModalUserList('.add-menu-open-button', newValue);
    }, true);

    $scope.$watch("ctrl.editComment", function(newValue, oldValue) {
        showModalUserList(vm.clazz, newValue);
    }, true);

    function showModalUserList(relativeTo, newValue) {
        if (newValue != undefined && ((newValue.length == 1 && newValue.endsWith('@')) || newValue.endsWith(' @'))) {
            var position = vm._mdPanel.newPanelPosition()
                .relativeTo(relativeTo)
                .addPanelPosition(vm._mdPanel.xPosition.ALIGN_START, vm._mdPanel.yPosition.ABOVE);

            var config = {
                attachTo: angular.element(document.body),
                controller: PanelUsersCtrl,
                controllerAs: 'ctrl',
                templateUrl: 'app/casos/templates/panel-user-list.html',
                position: position,
                locals: {
                    'users': vm.users
                },
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 2
            };

            var $res = vm._mdPanel.open(config);
            $res.then(function(ref) {
                $scope.ref = ref;
            })
        } else if (angular.isDefined($scope.ref)) {
            $scope.ref.close();
        }
    }

    PanelUsersCtrl.$inject = ['mdPanelRef'];
    function PanelUsersCtrl (mdPanelRef) {
        this._mdPanelRef = mdPanelRef;
    }

    PanelUsersCtrl.prototype.selectUser = function(user) {
        if (vm.editComment != undefined) {
            vm.editComment = vm.editComment + user.username;
        } else {
            vm.comment = vm.comment + user.username;
        }

        this._mdPanelRef && this._mdPanelRef.close().then(function() {
            angular.element(vm.clazz).focus();
        });
    };


    vm.validatePermission = function() {
        return PermissionsFactory.hasPermission('cases:update');
    }

}
'use strict';

angular.module('dashboard').component('casesBasicData', {
  templateUrl: 'app/casos/templates/section-basic-data.html',
  controllerAs: 'ctrl',
  bindings: {
    tab: '=',
    users: '<',
    groups: '<',
  },
  controller: CasesBasicDataController,
});

CasesBasicDataController.$inject = [
  '$scope',
  '$localStorageService',
  'FileSaver',
  '$rootScope',
  'CaseFactory',
  'translationService',
  '$mdDialog',
  'toastr',
  '$mdSidenav',
  'CaseUserFactory',
  '$filter',
  'PermissionsFactory',
  'ConfigurationFactory',
];

function CasesBasicDataController(
  $scope,
  $localStorageService,
  FileSaver,
  $rootScope,
  CaseFactory,
  $translationService,
  $mdDialog,
  toastr,
  $mdSidenav,
  CaseUserFactory,
  $filter,
  PermissionsFactory,
  ConfigurationFactory
) {
  var vm = this;
  vm.localStore = undefined;

  $scope.scheduledResolutionDate = new Date(
    vm.tab.caso.scheduledResolutionDate
  );
  $scope.creationDate = new Date(vm.tab.caso.creationDate);
  // $scope.datechange = function(val){console.log('$datechange',val)}

  // $scope.$watch("scheduledResolutionDate",function(newValue,oldValue) {
  //   console.log(newValue,oldValue)
  // })

  vm.$onInit = function () {
    $translationService.getTranslation($scope, 'cases');
    vm.localStore = $localStorageService.getItem('currentUser');
    ConfigurationFactory.getGlobalConfiguration()
      .then(function (res) {
        vm.categories = res.cases.category;
        vm.statusList = res.cases.status;
      })
      .catch(function (e) {
        // console.log('ConfigurationFactory', e.msg);
      });
  };

  vm.cancelarEdicion = function (tab) {
    tab.caso.editando = false;
  };

  vm.saveEdit = function (tab) {
    $rootScope.loading = true;
    // console.log(tab)
    CaseFactory.updateCase({
      id: tab.caso.caseId,
      title: tab.casoEdit.titulo,
      criticality: tab.casoEdit.criticidad,
      description: tab.casoEdit.descripcion,
      category: tab.casoEdit.category,
      scheduledResolutionDate: tab.caso.scheduledResolutionDate,
      //userId: tab.caso.idUsuario,
      // state: tab.caso.state
    })
      .then(function (res) {
        //-console.log(res)
        tab.caso.title = res.data.title;
        tab.caso.criticality = res.data.criticality;
        tab.caso.description = res.data.description;
        tab.caso.category = res.data.category;
        tab.caso.scheduledResolutionDate = res.data.scheduledResolutionDate;
        tab.caso.editando = false;
        // tab.caso.state          = res.data.state;
        $rootScope.loading = false;
        var msg = $translationService.getTranslationController(
          'Cambios guardados.',
          'Changes saved.',
          'Mudanças salvas.'
        );
        toastr.success(msg);
        $scope.$apply();
        $rootScope.$broadcast('refreshNgTableDynamic', {
          tableId: 'cases-table',
        });
      })
      .catch(function (error) {
        $rootScope.loading = false;
        if (error.status == 403) {
          toastr.error(
            $translationService.getTranslationController(
              'Usuario no autorizado.',
              'Unauthorized User.',
              'Usuário não autorizado.'
            )
          );
        } else {
          toastr.error(error);
        }
      });
  };

  vm.onChangeState = function (tab) {
    if (vm.statusList[0] === tab.caso.state) {
      //-fist state
      // console.log('re open')
      vm.reOpenCase(tab);
    } else if (vm.statusList[vm.statusList.length - 1] === tab.caso.state) {
      //-last state
      // console.log('close')
      vm.closeCase(tab);
    } else {
      // console.log('update')
      vm.updateStateCase(tab, tab.caso.state);
    }
  };

  vm.updateStateCase = function (tab, state) {
    // console.warn(state)
    CaseFactory.updateStatusCase(tab.caso.caseId, state, undefined)
      .then(function (res) {
        tab.caso.state = vm.statusList[state];
        $scope.$apply();
        // console.log('updateStateCase',res)
        var msg = $translationService.getTranslationController(
          'Caso Actualizado',
          'Updated Case',
          'Caso atualizado'
        );
        toastr.success(msg);
        tab.caso.state = state;
        $rootScope.$broadcast('refreshNgTableDynamic', {
          tableId: 'cases-table',
        });
      })
      .catch(function (error) {
        $rootScope.loading = false;
        if (error.status == 403) {
          toastr.error(
            $translationService.getTranslationController(
              'Usuario no autorizado.',
              'Unauthorized User.',
              'Usuário não autorizado.'
            )
          );
        } else {
          toastr.error(error);
        }
      });
  };

  vm.reOpenCase = function (tab) {
    // console.warn(vm.statusList[0])
    CaseFactory.updateStatusCase(tab.caso.caseId, vm.statusList[0], undefined)
      .then(function (res) {
        tab.caso.state = vm.statusList[0];
        $scope.$apply();
        var msg = $translationService.getTranslationController(
          'Caso abierto',
          'Case opened',
          'Caso aberto'
        );
        toastr.success(msg);
        $rootScope.$broadcast('refreshNgTableDynamic', {
          tableId: 'cases-table',
        });
      })
      .catch(function (error) {
        $rootScope.loading = false;
        if (error.status == 403) {
          toastr.error(
            $translationService.getTranslationController(
              'Usuario no autorizado.',
              'Unauthorized User.',
              'Usuário não autorizado.'
            )
          );
        } else {
          toastr.error(error);
        }
      });
  };

  vm.closeCase = function (tab, ev) {
    // console.log("tab",tab)
    var confirm = $mdDialog
      .prompt()
      .title(
        $translationService.getTranslationController(
          'Cerrar caso',
          'Close case',
          'Fechar caso'
        )
      )
      .textContent(
        $translationService.getTranslationController(
          'Ingrese un pequeño mensaje que justifique el cierre del caso.',
          'Enter a small message justifying the closure of the case.',
          'Digite uma pequena mensagem justificando o encerramento do caso.'
        )
      )
      .placeholder(
        $translationService.getTranslationController(
          'Comentario aquí',
          'Comment here',
          'Comente aqui'
        )
      )
      .ariaLabel('Close case dialog')
      .targetEvent(ev)
      .required(true)
      .ok(
        $translationService.getTranslationController(
          'Cerrar caso',
          'Close case',
          'Fechar caso'
        )
      )
      .cancel(
        $translationService.getTranslationController(
          'Cancelar',
          'Cancel',
          'Cancelar'
        )
      );

    $mdDialog.show(confirm).then(
      function (comment) {
        performCloseCase(tab, comment);
      },
      function () {
        tab.caso.state = tab.casoEdit.estado;
      }
    );
  };

  function performCloseCase(tab, comment) {
    // console.warn(vm.statusList[vm.statusList.length-1])
    CaseFactory.updateStatusCase(
      tab.caso.caseId,
      vm.statusList[vm.statusList.length - 1],
      comment
    )
      .then(function (res) {
        tab.caso.state = vm.statusList[vm.statusList.length - 1];
        var msg = $translationService.getTranslationController(
          'Caso cerrado',
          'Case closed',
          'Caso encerrado'
        );
        toastr.success(msg);
        tab.caso.editando = false;
        $rootScope.$broadcast('refreshNgTableDynamic', {
          tableId: 'cases-table',
        });
      })
      .catch(function (error) {
        if (error.status == 403) {
          toastr.error(
            $translationService.getTranslationController(
              'Usuario no autorizado.',
              'Unauthorized User.',
              'Usuário não autorizado.'
            )
          );
        } else {
          toastr.error(error);
        }
      })
      .finally(function () {
        $rootScope.loading = false;
      });
  }

  vm.caseEditable = function (tab) {
    // console.log('caseEditable',tab)
    $('select').dropdown({ autoinit: '.select' });
    tab.casoEdit = {
      titulo: tab.caso.title,
      criticidad: tab.caso.criticality,
      category: tab.caso.category,
      estado: tab.caso.state,
      descripcion: tab.caso.description,
      scheduledResolutionDate: tab.caso.scheduledResolutionDate,
    };
    tab.caso.editando = true;
    $('select').dropdown({ autoinit: '.select' });
  };

  vm.exportCase = function (tab) {
    $rootScope.loading = true;
    CaseFactory.exportCase(tab.caso.caseId)
      .then(function (res) {
        FileSaver.saveAs(
          new Blob([res], { type: 'application/pdf' }),
          'case-detail-' + tab.caso.caseId + '.pdf'
        );
      })
      .catch(function (error) {
        if (error.status == 403) {
          toastr.error(
            $translationService.getTranslationController(
              'Usuario no autorizado.',
              'Unauthorized User.',
              'Usuário não autorizado.'
            )
          );
        } else {
          toastr.error(error);
        }
      })
      .finally(function () {
        $rootScope.loading = false;
      });
  };

  vm.showUsersGuestdDialog = function (event, tab) {
    $mdSidenav('guest-user' + tab.caso.caseId).toggle();
    getCaseUsers();
  };

  /* Invite users */
  vm.selectedItem = null;
  vm.searchText = null;
  vm.querySearch = querySearchFn;
  vm.selectedUsers = [];

  /**
   * Autocomplete query search fn.
   */
  function querySearchFn(query) {
    return query ? vm.users.filter(createFilterForFn(query)) : [];
  }

  /**
   * Create filter function for a query string
   */
  function createFilterForFn(query) {
    var lowercaseQuery = query.toLowerCase();

    return function filterFn(user) {
      var guests = $filter('filter')(vm.guestList, { userId: user.userId });
      return (
        (angular.isUndefined(vm.tab.caso.assigned) ||
          user.userId !== vm.tab.caso.assigned.userId) &&
        guests.length == 0 &&
        (user.name.toLowerCase().indexOf(lowercaseQuery) === 0 ||
          user.lastName.toLowerCase().indexOf(lowercaseQuery) === 0)
      );
    };
  }

  vm.createCaseUsers = function () {
    $rootScope.loading = true;
    CaseUserFactory.create({
      caseId: vm.tab.caso.caseId,
      users: parseUsersFn(),
      note: vm.note,
      notify: vm.notify,
    })
      .then(function (response) {
        var msg = $translationService.getTranslationController(
          'Usuarios Invitados.',
          'Guest Users.',
          'Usuários convidados.'
        );
        toastr.success(msg);
        vm.note = undefined;
        vm.selectedUsers = [];
        getCaseUsers();
        $scope.$apply();
      })
      .catch(function (error) {
        if (error.status == 403) {
          toastr.error(
            $translationService.getTranslationController(
              'Usuario no autorizado.',
              'Unauthorized User.',
              'Usuário não autorizado.'
            )
          );
        } else {
          toastr.error(error);
        }
      })
      .finally(function () {
        $rootScope.loading = false;
      });
  };

  function getCaseUsers() {
    vm.loadedCaseTable = false;
    vm.usersInvited = undefined;
    CaseUserFactory.get(vm.tab.caso.caseId)
      .then(function (response) {
        vm.guestList = response.users;
        $scope.$apply();
      })
      .catch(function (error) {
        if (error.status == 403) {
          toastr.error(
            $translationService.getTranslationController(
              'Usuario no autorizado.',
              'Unauthorized User.',
              'Usuário não autorizado.'
            )
          );
        } else {
          toastr.error(error);
        }
      })
      .finally(function () {
        vm.loadedCaseTable = true;
        $rootScope.loading = false;
      });
  }

  vm.deleteCaseUser = function (userId) {
    var confirm = $mdDialog
      .confirm()
      .title('Confirm')
      .textContent('Are you sure?')
      .ok($scope.translation.CONFIRM_YES)
      .cancel($scope.translation.CONFIRM_NO);

    $mdDialog.show(confirm).then(
      function () {
        vm.loadedCaseTable = false;
        CaseUserFactory.delete(vm.tab.caso.caseId, userId)
          .then(function (response) {
            getCaseUsers();
            var msg = $translationService.getTranslationController(
              'Invitado eliminado.',
              'Guest deleted.',
              'Invitado eliminado.'
            );
            toastr.success(msg);
            $scope.$apply();
          })
          .catch(function (error) {
            if (error.status == 403) {
              toastr.error(
                $translationService.getTranslationController(
                  'Usuario no autorizado.',
                  'Unauthorized User.',
                  'Usuário não autorizado.'
                )
              );
            } else {
              toastr.error(error);
            }
          })
          .finally(function () {
            vm.loadedCaseTable = true;
            $rootScope.loading = false;
          });
      },
      function () {}
    );
  };

  function parseUsersFn() {
    var list = [];
    if (angular.isDefined(vm.selectedUsers)) {
      angular.forEach(vm.selectedUsers, function (value, key) {
        list.push({
          userId: value.userId,
          email: value.email,
        });
      });
    }
    return list;
  }

  /***************************************************************************************************************/
  vm.showOwnerUserDialog = function (event, tab) {
    $mdSidenav('owner-user' + tab.caso.caseId).toggle();
  };

  vm.reassignAssigned = function () {
    var confirm = $mdDialog
      .confirm()
      .title('Confirm')
      .textContent('Are you sure?')
      .ok($scope.translation.CONFIRM_YES)
      .cancel($scope.translation.CONFIRM_NO);

    $mdDialog.show(confirm).then(
      function () {
        $rootScope.loading = true;
        CaseFactory.reassignAssigned(vm.tab.caso.caseId, vm.newUser, vm.note)
          .then(function (response) {
            var _user = vm.users.filter(function (e) {
              return e.userId == vm.newUser;
            })[0];
            vm.tab.caso.assigned = angular.copy(_user);
            var msg = $translationService.getTranslationController(
              'Cambio existoso.',
              'Successful change.',
              'Cambio exitoso.'
            );
            toastr.success(msg);
            vm.note = undefined;

            $rootScope.$broadcast('refreshNgTableDynamic', {
              tableId: 'cases-table',
            });
            $scope.$apply();
          })
          .catch(function (error) {
            if (error.status == 403) {
              toastr.error(
                $translationService.getTranslationController(
                  'Usuario no autorizado.',
                  'Unauthorized User.',
                  'Usuário não autorizado.'
                )
              );
            } else {
              toastr.error(error);
            }
          })
          .finally(function () {
            $rootScope.loading = false;
          });
      },
      function () {}
    );
  };

  vm.deleteReassignAssigned = function () {
    var confirm = $mdDialog
      .confirm()
      .title('Confirm')
      .textContent('Are you sure?')
      .ok($scope.translation.CONFIRM_YES)
      .cancel($scope.translation.CONFIRM_NO);

    $mdDialog.show(confirm).then(
      function () {
        $rootScope.loading = true;
        CaseFactory.deleteReassignAssigned(vm.tab.caso.caseId)
          .then(function (response) {
            vm.tab.caso.assigned.fullName = undefined;
            var msg = $translationService.getTranslationController(
              'Cambio existoso.',
              'Successful change.',
              'Cambio exitoso.'
            );
            toastr.success(msg);

            $rootScope.$broadcast('refreshNgTableDynamic', {
              tableId: 'cases-table',
            });
            $scope.$apply();
          })
          .catch(function (error) {
            if (error.status == 403) {
              toastr.error(
                $translationService.getTranslationController(
                  'Usuario no autorizado.',
                  'Unauthorized User.',
                  'Usuário não autorizado.'
                )
              );
            } else if (error.status == 406) {
              toastr.error(
                $translationService.getTranslationController(
                  'Cambio no aceptado.',
                  'Change not accepted.',
                  'Alteração não aceita.'
                )
              );
            } else {
              toastr.error(error);
            }
          })
          .finally(function () {
            $rootScope.loading = false;
          });
      },
      function () {}
    );
  };

  /*****************************************************************************************************************/
  vm.showOwnerGroupDialog = function (event, tab) {
    $mdSidenav('owner-group' + tab.caso.caseId).toggle();
  };

  vm.reassignGroup = function () {
    var confirm = $mdDialog
      .confirm()
      .title('Confirm')
      .textContent('Are you sure?')
      .ok($scope.translation.CONFIRM_YES)
      .cancel($scope.translation.CONFIRM_NO);

    $mdDialog.show(confirm).then(
      function () {
        $rootScope.loading = true;
        CaseFactory.reassignGroup(vm.tab.caso.caseId, vm.newGroupId, vm.note)
          .then(function (response) {
            var _group = vm.groups.filter(function (e) {
              return e.id == vm.newGroupId;
            })[0];
            vm.tab.caso.group = angular.copy(_group);
            var msg = $translationService.getTranslationController(
              'Cambio existoso.',
              'Successful change.',
              'Cambio exitoso.'
            );
            toastr.success(msg);
            vm.note = undefined;
            $scope.$apply();
          })
          .catch(function (error) {
            if (error.status == 403) {
              toastr.error(
                $translationService.getTranslationController(
                  'Usuario no autorizado.',
                  'Unauthorized User.',
                  'Usuário não autorizado.'
                )
              );
            } else {
              toastr.error(error);
            }
          })
          .finally(function () {
            $rootScope.loading = false;
          });
      },
      function () {}
    );
  };

  vm.deleteReassignGroup = function () {
    var confirm = $mdDialog
      .confirm()
      .title('Confirm')
      .textContent('Are you sure?')
      .ok($scope.translation.CONFIRM_YES)
      .cancel($scope.translation.CONFIRM_NO);

    $mdDialog.show(confirm).then(
      function () {
        $rootScope.loading = true;
        CaseFactory.deleteReassignGroup(vm.tab.caso.caseId)
          .then(function (response) {
            vm.tab.caso.group = undefined;
            var msg = $translationService.getTranslationController(
              'Cambio existoso.',
              'Successful change.',
              'Cambio exitoso.'
            );
            toastr.success(msg);
            $scope.$apply();
          })
          .catch(function (error) {
            if (error.status == 403) {
              toastr.error(
                $translationService.getTranslationController(
                  'Usuario no autorizado.',
                  'Unauthorized User.',
                  'Usuário não autorizado.'
                )
              );
            } else if (error.status == 406) {
              toastr.error(
                $translationService.getTranslationController(
                  'Cambio no aceptado.',
                  'Change not accepted.',
                  'Alteração não aceita.'
                )
              );
            } else {
              toastr.error(error);
            }
          })
          .finally(function () {
            $rootScope.loading = false;
          });
      },
      function () {}
    );
  };

  vm.validatePermission = function () {
    return PermissionsFactory.hasPermission('cases:update');
  };
}

"use strict";

angular.module('dashboard').component('casesAlerts', {
    templateUrl: 'app/casos/templates/section-associated-events.html',
    controllerAs: 'ctrl',
    bindings: {
        tab: '='
    },
    controller: CasesAlertsController
});


CasesAlertsController.$inject = ['$scope', '$localStorageService', '$rootScope', '$stateParams', 'CaseFactory', '$timeout',
    'translationService', 'toastr', '$location', 'EventsV2Factory', 'WorkspaceFactory', '$mdDialog', 'PermissionsFactory'];

function CasesAlertsController($scope, $localStorageService, $rootScope, $stateParams, CaseFactory, $timeout,
    $translationService, toastr, $location, EventsV2Factory, WorkspaceFactory, $mdDialog, PermissionsFactory) {
    var vm = this;

    vm.$onInit = function () {

        //Método para realizar traducción
        $translationService.getTranslation($scope, 'cases');

        vm.myDate = new Date();
        vm.fromDate = moment().hour(0).minute(0).second(0).subtract(1, 'month');
        vm.toDate = moment().hour(23).minute(59).second(59);
        vm.minFrom = "2000-01-01";
    };

    vm.initGrid = function () {

        function getFilterType(item) {
            var operation;

            if (item.autocomplete == true && item.metadata == false) {
                operation = 'autocomplete';
            } else if (item.autocomplete == true && item.metadata == true) {
                operation = 'select';
            } else {
                operation = 'input';
            }
            return operation;
        }

        function getOperation(type) {
            var operation;
            switch (type) {
                case 'boolean':
                    operation = '=';
                    break;
                case 'string':
                    operation = '=';
                    break;
                case 'double':
                    operation = '>=';
                    break;
                case 'integer':
                    operation = '>=';
                    break;
                default:
                    operation = '=';
            }
            return operation;
        }

        return new Promise(function (resolve, reject) {
            var config = {
                datasource: {
                    origin: "POST",
                    url: '/risk-backend/rest/case/' + vm.tab.id + '/associated-events',
                    params: {
                        query: '',
                        sortBy: 'id',
                        sort: 'desc',
                        startDate: vm.fromDate,
                        endDate: vm.toDate,
                        page: 1,
                        itemsPerPage: 25,
                    },
                    paramsOut: {
                        data: "data",
                        pagination: "pagination"
                    }
                },
                pageSizes: [25, 50, 100],
                columns: [],
                style: {
                    trStyle: function (item) {
                        if (item.checked.toUpperCase() === "NO VISTO") {
                            switch (item.criticality.toUpperCase()) {
                                case "ALTA":
                                    return "alta";
                                case "MEDIA":
                                    return "media";
                                case "BAJA":
                                    return "baja";
                                default:
                                    return "";
                            }
                        } else {
                            switch (item.criticality.toUpperCase()) {
                                case "ALTA":
                                    return "alta-checked";
                                case "MEDIA":
                                    return "media-checked";
                                case "BAJA":
                                    return "baja-checked";
                                default:
                                    return "";
                            }
                            return "";
                        }
                    }
                }
            };
            config.workspaces = {
                items: [{
                    id: null,
                    userId: null,
                    workspaceName: "DEFAULT",
                    workspaceSchema: {
                        columns: []
                    }
                },
                {
                    id: null,
                    userId: null,
                    workspaceName: "CURRENT VIEW",
                    workspaceSchema: {
                        columns: []
                    }
                }]
            };

            EventsV2Factory.getColumnData('alerta').then(function (response) {
                config.schemas = response.schemaIds;
                config.functions = response.functions;

                var columnsDefault = [];
                angular.forEach(response.columns, function (item, key) {

                    if (item.metadata == true) {
                        var column = {
                            col: (item.metadata == false) ? 'eventBody' : item.name,
                            key: (item.metadata == false) ? item.name : '',
                            title: item.name,
                            show: item.metadata,
                            filterable: item.metadata,
                            default: item.metadata,
                            filterType: getFilterType(item),
                            sortable: item.name
                        };
                        column.field = column.col + column.key;
                        column.metadata = item;
                        column.type = (item.metadata == false) ? 'object' : item.type;
                        column.metadata.operation = getOperation(item.type);
                        columnsDefault.push(angular.copy(column));
                    }
                });
                columnsDefault.push({
                    field: "delete",
                    title: "",
                    type: "command",
                    show: true,
                    width: 5,
                    sortable: false
                });
                config.workspaces.items[0].workspaceSchema.columns = columnsDefault;

                //config.columns = angular.copy(config.workspaces.items[0].workspaceSchema.columns);


                WorkspaceFactory.getWorkspaces().then(function (response) {
                    if (angular.isDefined(response) && response.length > 0) {
                        response.sort(function (a, b) { return b.id - a.id; });
                        config.workspaces.items[1].id = response[0].id;
                        config.workspaces.items[1].workspaceSchema = angular.copy(angular.fromJson(response[0].workspaceSchema));
                    } else {
                        config.workspaces.items[1].workspaceSchema.columns = angular.copy(config.workspaces.items[0].workspaceSchema.columns);
                    }
                    config.workspaces.selected = {
                        id: config.workspaces.items[1].workspaceSchema.id,
                        workspaceName: "CURRENT VIEW"
                    }
                    config.columns = angular.copy(config.workspaces.items[1].workspaceSchema.columns);

                    console.log("WorkspaceFactory")
                }).catch(function (error) {
                    console.log("WorkspaceFactory@error. " + error);
                    config.columns = config.workspaces.items[0].workspaceSchema.columns;
                }).finally(function () {
                    resolve(config);
                });
            }, function (error) {
                console.log("EventsV2Factory@error. " + error)
                reject(config);
            });
        });
    }

    vm.bDate = function () {
        $rootScope.$broadcast('dateChange', {
            desde: vm.fromDate,
            hasta: vm.toDate
        });
    };

    vm.removeEvent = function (alerta) {
        if (!vm.validatePermission()) {
            return;
        }

        var confirm = $mdDialog.confirm()
            .title($scope.translation.DESASIGNAR_ALERTA)
            .textContent($scope.translation.CONFIRMAR_DESVINCULAR)
            .ok($scope.translation.CONFIRM_YES)
            .cancel($scope.translation.CONFIRM_NO);

        $mdDialog.show(confirm).then(function () {
            $rootScope.loading = true;
            CaseFactory.deleteEvent({
                id: vm.tab.id,
                eventId: alerta.id
            }).then(function (response) {
                $rootScope.loading = false;
                $rootScope.$broadcast('refreshNgTableDynamic');
                toastr.success($translationService.getTranslationController('Evento borrado exitosamente.', 'Event successfully deleted.', 'Evento excluído com sucesso.'));
            }, function (error) {
                $rootScope.loading = false;
                if (error.status == 403) {
                    toastr.error($translationService.getTranslationController('Usuario no autorizado.', 'Unauthorized User.', 'Usuário não autorizado.'));
                } else {
                    toastr.error(error);
                }
            });
        }, function () {

        });
    };

    vm.showModalAddAlert = function () {
        if (!validarEstado(vm.tab)) {
            return false
        }
        $location.path('/alarmas').search('caseId=' + vm.tab.caso.caseId).replace();
    };

    function validarEstado(tab) {
        if (tab.caso.state == 'cerrado') {
            toastr.error($translationService.getTranslationController('No disponible, el caso esta cerrado.', 'Not available, the case is closed.', 'Não disponível, o caso está fechado.'));
            return false;
        }
        return true;
    }

    vm.validatePermission = function () {
        return PermissionsFactory.hasPermission('event:read');
    }
}

(function () {
  'use strict';

  angular.module('dashboard').controller('CasesController', CasesController);

  CasesController.$inject = [
    '$scope',
    '$localStorageService',
    '$rootScope',
    'Comentarios',
    '$state',
    '$stateParams',
    'CaseFactory',
    '$timeout',
    'UserFactory',
    'translationService',
    '$mdDialog',
    '$location',
    'toastr',
    'PermissionsFactory',
    'GroupFactory',
    'ConfigurationFactory',
  ];
  function CasesController(
    $scope,
    $localStorageService,
    $rootScope,
    Comentarios,
    $state,
    $stateParams,
    CaseFactory,
    $timeout,
    UserFactory,
    $translationService,
    $mdDialog,
    $location,
    toastr,
    PermissionsFactory,
    GroupFactory,
    ConfigurationFactory
  ) {
    var vm = this;
    if (!PermissionsFactory.hasPermission('cases:read')) return;

    vm.api = {};
    vm.isLoading = false;
    vm.usuarios = [];
    vm.selectedTab = 'index';
    vm.currentUserId = $localStorageService.getItem("currentUser.userId");
    vm.resumeUsers = [];
    vm.resumeGroups = [];
    vm.categoriesTypes = null;
    vm.statusTypes = null;
    vm.casesData = null;
    vm.pagiantion = null;
    vm.errorConfig = false;

    vm.init = function () {
      vm.isLoading = true;
      vm.errorConfig = false;
      ConfigurationFactory.getGlobalConfiguration()
        .then(function (res) {
          if (
            res.cases &&
            res.cases.category.length > 0 &&
            res.cases.status.length > 0
          ) {
            var str_noCategory = $translationService.getTranslationController(
              'sin categoría',
              'Without category',
              'Sem categoria'
            );
            var ref_noCategory = 'nocategory';

            var configCases = res.cases;

            var status = configCases.status.map(function (ele) {
              return { name: ele, cases: [] };
            });
            vm.statusTypes = configCases.status;

            var catg = configCases.category.map(function (ele) {
              var idref = ele.replace(/\s/g, '_').toLowerCase();
              var CatgObj = {
                ref: idref,
                name: ele,
                display: false,
                status: angular.copy(status),
              };
              return CatgObj;
            });
            var noCategory = {
              ref: ref_noCategory,
              name: str_noCategory,
              display: false,
              status: angular.copy(status),
            };

            // vm.categoriesTypes = configCases.category.map(function(ele){return ele.replace(/\s/g, '_').toLowerCase();});
            vm.categoriesTypes = configCases.category;
            vm.categoriesTypes.push(ref_noCategory);

            vm.casesData = catg;
            vm.casesData.push(noCategory);

            vm.kanbanData();
          } else {
            vm.isLoading = false;
            vm.errorConfig = true;
            var msg = $translationService.getTranslationController(
              'Error de configuracion global',
              'Error global config',
              'Error de configuracion global'
            );
            toastr.error(msg);
          }
        })
        .catch(function (e) {
          vm.isLoading = false;
          vm.errorConfig = true;
          console.error('error@ConfigurationFactory', e);
        });

      $scope.toGlobalConfig = function () {
        $state.go('app.configuration');
      };

      //Método para realizar traducción
      $translationService.getTranslation($scope, 'cases');

      obtenerUsuariosTabFn();
      getGroupList();
      showLangFn();
      vm.params = {
        query: '',
        sortBy: 'caseId',
        sort: 'desc',
        startDate: moment(
          $rootScope.desde ||
          moment().subtract(1, 'week').hour(0).minute(0).second(0)
        ),
        endDate: moment(
          $rootScope.hasta || moment().hour(23).minute(59).second(59)
        ),
        page: 1,
        itemsPerPage: 9999,
      };
      vm.kanbanData = function () {
        vm.isLoading = true;
        vm.tabla_data = null;
        clearCasesKanban();

        CaseFactory.getSummary(vm.params)
          .then(function (res) {
            var cases = res.cases;
            vm.pagiantion = res.pagination;
            vm.tabla_data = res.cases;
            cases.forEach(function (ele_case) {
              var slot = findSlots(ele_case);
              vm.casesData[slot.ref].status[slot.state].cases.push(ele_case);
            });
            vm.isLoading = false;
          })
          .catch(function (err) {
            console.error('Error@kanbanData', err);
          });
      };

      if ($rootScope.eventRecivedPutAlertToCaseId == null) {
        $rootScope.eventRecivedPutAlertToCaseId = $rootScope.$on(
          'addEventsToCaseId',
          function (event, object) {
            event.stopPropagation();
            assignEventsToCaseIdFn(object.caseId, object.items);
          }
        );
      }
    };

    vm.init();

    function clearCasesKanban() {
      vm.casesData.forEach(function (catg) {
        catg.status.forEach(function (status) {
          status.cases = [];
        });
      });
    }

    function findSlots(obj_case) {
      var slot_default = {
        ref:
          vm.categoriesTypes.indexOf(obj_case.category) >= 0
            ? vm.categoriesTypes.indexOf(obj_case.category)
            : vm.categoriesTypes.length - 1, //-sin categoria
        state:
          vm.statusTypes.indexOf(obj_case.state) >= 0
            ? vm.statusTypes.indexOf(obj_case.state)
            : 0, //-primer state
      };
      return slot_default;
    }

    function findStateInSlot(search, arrStatus) {
      var found = arrStatus.findIndex(function (sta) {
        return sta.name === search;
      });
      if (found > 0) {
        return found;
      } else {
        return 0;
      }
    }

    function assignEventsToCaseIdFn(caseId, selectedEvents) {
      $rootScope.loading = true;
      var eventsId = [];
      selectedEvents.forEach(function (_item) {
        eventsId.push({ eventId: _item });
      });

      CaseFactory.addEvents(caseId, eventsId).then(function (response) {
        var msg = $translationService.getTranslationController(
          'Alertas asociadas',
          'Associated alerts',
          'Alertas associados'
        );
        toastr.success(msg);
        $rootScope.loading = false;
        $rootScope.$broadcast('riskGridCleanSelection');
        $location
          .path('/casos/' + caseId)
          .search('')
          .replace();
      });
    }

    function showLangFn() {
      if ($rootScope.tabsCasos[0].id === 'index') {
        $rootScope.tabsCasos[0].name = $translationService.getTranslationController(
          'TODOS',
          'ALL',
          'TODOS'
        );
      }
    }

    function validarEstado(tab) {
      if (tab.caso.state == 'cerrado') {
        var msg = $translationService.getTranslationController(
          'No disponible, el caso esta cerrado.',
          'Not available, the case is closed.',
          'Não disponível, o caso está fechado.'
        );
        $scope.showSimpleToast(msg);
        return false;
      }
      return true;
    }

    vm.setTab = function (newTab) {
      vm.selectedTab = newTab;
    };

    vm.isSet = function (tabNum) {
      return vm.selectedTab == tabNum;
    };

    vm.isActive = function (id) {
      return vm.isSet(id) && id != 'index';
    };

    vm.eliminarTabCaso = function (tabId) {
      var indexTab = -2;
      for (var i = 0; i < $rootScope.tabsCasos.length; i++) {
        var actualTab = $rootScope.tabsCasos[i];
        if (actualTab.id === tabId) {
          indexTab = i;
          break;
        }
      }
      if (indexTab > 0) {
        $rootScope.tabsCasos.splice(indexTab, 1);
        vm.setTab('index');
      }
    };

    vm.crearTabDetalleCaso = function (rowCaso) {
      //Se recorren los tabs existentes
      // console.warn(rowCaso)
      var existeTab = false;
      $rootScope.loading = true;
      for (var i = 0; i < $rootScope.tabsCasos.length; i++) {
        var actualTab = $rootScope.tabsCasos[i];
        if (actualTab.id === rowCaso.caseId) {
          existeTab = true;
          break;
        }
      }
      if (existeTab) {
        vm.setTab(actualTab.id);
        $rootScope.loading = false;
      } else {
        //Se crea el nuevo tab con el detalle del caso
        var newTab = {
          id: rowCaso.caseId,
          name: rowCaso.title.substring(0, 15) + ' - ' + rowCaso.caseId,
        };
        //Se agrega el tab a la lista
        $rootScope.tabsCasos.push(newTab);
        newTab.caso = rowCaso;
        newTab.caso.showMensajes = true;
        newTab.caso.showComments = true;
        newTab.caso.comentarios = {
          titulo: '',
          comArray: [],
          llaveComentario: '',
          texto: '',
          alerta: {},
          evento: {},
        };
        newTab.caso.activePosition;
        newTab.caso.files = [];
        newTab.caso.comments = [];
        newTab.caso.alerts = [];

        vm.setTab(newTab.id);
        $rootScope.loading = false;
      }
    };

    function obtenerUsuariosTabFn() {
      vm.usuarios = [];
      UserFactory.getAllUsers({})
        .then(function (response) {
          vm.usuarios = response.data.data;
          var currentUser = $localStorageService.getItem("currentUser");
          if (currentUser.userType === 'SA') {
            vm.usuarios.forEach(function (_item) {
              vm.resumeUsers.push({
                key: _item.userId,
                value: _item.fullName,
              });
            });
          } else {
            vm.usuarios.forEach(function (_item) {
              if (currentUser.userId != _item.userId)
                vm.resumeUsers.push({
                  key: _item.userId,
                  value: _item.fullName,
                });
            });
          }
        })
        .catch(function (error) {
          $rootScope.loading = false;
          if (error.status == 403) {
            toastr.error(
              $translationService.getTranslationController(
                'Usuario no autorizado para leer usuarios',
                'Unauthorized User to read users.',
                'Usuário não autorizado para ler usuários.'
              )
            );
          } else {
            toastr.error(error);
          }
        });
    }

    function getGroupList() {
      vm.groups = [];
      $rootScope.loading = true;
      GroupFactory.getAllGroups()
        .then(function (response) {
          vm.groups = response.data;
          vm.groups.forEach(function (_item) {
            vm.resumeGroups.push({
              key: _item.id,
              value: _item.name,
            });
          });

          $scope.$apply();
        })
        .catch(function (error) {
          if (error.status == 403) {
            toastr.error(
              $translationService.getTranslationController(
                'Usuario no autorizado.',
                'Unauthorized User.',
                'Usuário não autorizado.'
              )
            );
          } else {
            toastr.error(error);
          }
        })
        .finally(function () {
          $rootScope.loading = false;
        });
    }

    vm.toggleDetail = function (tabCaso, $index) {
      tabCaso.activePosition = tabCaso.activePosition == $index ? -1 : $index;
    };

    vm.toggleMensaje = function (tabCaso, openClose, alert, evento) {
      // $timeout(function () {
      //   $('.discussion.comments-box').scrollTop(
      //     $('.discussion.comments-box').prop('scrollHeight')
      //   );
      // });
      if (!openClose) {
        if (!tabCaso.showMensajes) {
          tabCaso.showMensajes = true;
        }
      } else {
        tabCaso.showMensajes = !tabCaso.showMensajes;
      }
      if (alert && evento) {
        tabCaso.comentarios = {
          titulo: '',
          comArray: [],
          llaveComentario: '',
          texto: '',
          alerta: alert,
          evento: evento,
        };
        Comentarios.comentariosCasoAlarmaEvento(
          tabCaso.id,
          alert.id,
          evento.id,
          function (response) {
            if (response.header.code == 0) {
              var llaveCom = Comentarios.obtenerLlaveComentarios(
                tabCaso.id,
                alert.id,
                evento.id
              );
              evento.comentariosQty = response.body.length;
              tabCaso.comentarios = {
                titulo:
                  $translationService.getTranslationController(
                    'Comentarios Alerta ',
                    'Comments Alert ',
                    'Alerta de comentários '
                  ) +
                  alert.id +
                  $translationService.getTranslationController(
                    ' Evento ',
                    ' Event ',
                    ' Evento '
                  ) +
                  evento.id,
                comArray: response.body,
                llaveComentario: llaveCom,
                alerta: alert,
                evento: evento,
              };
            }
          }
        );
      }
    };

    vm.toggleComments = function (tabCaso, openClose, alert, evento) {
      // $timeout(function () {
      //   $('.discussion.comments-box').scrollTop(
      //     $('.discussion.comments-box').prop('scrollHeight')
      //   );
      // });
      if (!openClose) {
        if (!tabCaso.showComments) {
          tabCaso.showComments = true;
        }
      } else {
        tabCaso.showComments = !tabCaso.showComments;
      }
      if (alert && evento) {
        tabCaso.comentarios = {
          titulo: '',
          comArray: [],
          llaveComentario: '',
          texto: '',
          alerta: alert,
          evento: evento,
        };
        Comentarios.comentariosCasoAlarmaEvento(
          tabCaso.id,
          alert.id,
          evento.id,
          function (response) {
            if (response.header.code == 0) {
              var llaveCom = Comentarios.obtenerLlaveComentarios(
                tabCaso.id,
                alert.id,
                evento.id
              );
              evento.comentariosQty = response.body.length;
              tabCaso.comentarios = {
                titulo:
                  $translationService.getTranslationController(
                    'Comentarios Alerta ',
                    'Comments Alert ',
                    'Alerta de comentários '
                  ) +
                  alert.id +
                  $translationService.getTranslationController(
                    ' Evento ',
                    ' Event ',
                    ' Evento '
                  ) +
                  evento.id,
                comArray: response.body,
                llaveComentario: llaveCom,
                alerta: alert,
                evento: evento,
              };
            }
          }
        );
      }
    };

    vm.validatePermission = function () {
      return PermissionsFactory.hasPermission('cases:export');
    };

    /************************************* modal crear caso ****************************************************/
    vm.showModal = function (ev) {
      $mdDialog.show({
        controller: 'CreateCaseController',
        templateUrl: 'app/casos/templates/dialog-create-case.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          inputData: {
            source: 'CASES',
            eventId: undefined,
          },
        },
      });
    };

    /***********************************************************************************************************/
    //Este codigo sirve para poder abrir/cargar automaticamente la pestaña de una alerta especifica
    if ($stateParams.idCaso) {
      var myCase = $rootScope.getCasoById($stateParams.idCaso);
      if (myCase) {
        vm.crearTabDetalleCaso(myCase);
      }
    }

    $scope.$on('dateChange', function (e, dates) {
      vm.params.startDate = moment(dates.desde);
      vm.params.endDate = moment(dates.hasta);
      // console.log( "dateChange",vm.params)
      vm.kanbanData();
    });

    $scope.$on('refreshNgTableDynamic', function (e, table) {
      vm.kanbanData();
    });

    vm.search = function () {
      $rootScope.$broadcast('dateChange', {
        desde: vm.desde,
        hasta: vm.hasta,
        searchBtn: true,
      });
    };
  }
})();

(function () {
    'use strict';

    angular
        .module('dashboard')
        .controller('BovedaDatosController', BovedaDatosController);

    BovedaDatosController.$inject = ['$scope', '$state', '$rootScope', '$interval', '$localStorageService', '$stateParams', '$modal', '$http', 'translationService'];
    function BovedaDatosController($scope, $state, $rootScope, $interval, $localStorageService, $stateParams, $modal, $http, $translationService) {
        var vm = this;
        //Realizar traducción para datapicker y vista
        $translationService.getTranslation($scope, 'includes');

        //    var cont = 0;
        //    var token = 'eyJhbGciOiJSUzI1NiJ9.eyJ1c2VyX2lkIjoxLCJ1c2VyX2RvbWFpbiI6MSwidXNlcl91c2VybmFtZSI6ImNlcHRpbmVsIiwidXNlcl9kb21haW5fcm9sZXMiOlsiQWRtaW5pc3RyYWRvciJdLCJleHAiOjE1MzQ0OTc2OTZ9.FPBN69Fc_rH2YrkQFuMZH-IBXVFQRNxvuQYJUxVaHgYe3iN9Xk6nSMTFjJ7SqhtO8ANI6x4RxT14KjOLC-Y3UMwiJKPwKvBwq7TMUqBQDKr64SgpgduF_wG7-B7lEYIwPq85VgiZpByqOgB8b7mPjKpK8z9tW6y2HkXnlyh7WP6KDYAU9hda7nZxpQXe0-6pKRxWwEZFUICiqsBK2qU2Jor7dRJZwv6zG5Wn6BUkXqVEBwmfPJEfCpgrS2feBZuGqdK_diRMhWAHPK1_kbbxcB0UEHo8LkzGwS0ibbLFsn-g425mw9u1i73_QBnwV30a8RMatcbW1a1fhSx9XwD0lw';
        //    var replay = 1;
        //    var itemsPerPage = 1;

        // // var chunkedUrl = 'http://localhost:8080/risk-backend/rest/events/2/events/?startDate=2018-05-12T04%3A00%3A00.000Z&endDate=2018-08-13T03%3A59%3A59.999Z&page=1&dateParam=datetime%20%3A&itemsPerPage=10000&aggregate=false&symbolList=COPEC&token='+token;
        //    var chunkedUrl = 'http://localhost:8080/risk-backend/rest/events/'+replay+'/events/?token='+token+'&page=1&dateParam=datetime%20%3A&itemsPerPage='+itemsPerPage+'&aggregate=false&symbolList=COPEC';

        //    var source = new EventSource(chunkedUrl);
        //    source.onopen = function(evt){
        //        console.log("OPEN CONNECTION");
        //    }

        //    source.addEventListener("message",function(dat){
        //      console.log(JSON.parse(dat.data))
        //      cont++;
        //        // if(cont == 10){
        //        //   source.close();
        //        // }
        //    })
    }
})();
(function () {
    'use strict';
    angular
        .module('dashboard')
        .controller('backupController', backupController);

    backupController.$inject = ['$scope'];

    function backupController($scope) {
        var vm = this;
        vm.loading = false;
        vm.backupConfig = {
            days:20
        }
        vm.historicBackups = [
            {date: moment().subtract(7,'d').format('DD/MM/YYYY') ,success:true},
            {date: moment().subtract(14,'d').format('DD/MM/YYYY') ,success:true},
            {date: moment().subtract(21,'d').format('DD/MM/YYYY') ,success:true},
            {date: moment().subtract(28,'d').format('DD/MM/YYYY') ,success:false},
            {date: moment().subtract(35,'d').format('DD/MM/YYYY') ,success:false},
            {date: moment().subtract(42,'d').format('DD/MM/YYYY') ,success:true},
            {date: moment().subtract(49,'d').format('DD/MM/YYYY') ,success:true}
        ]

    }
})();
(function () {
  'use strict';

  angular.module('dashboard').service('auditService', auditService);

  auditService.$inject = ['translationService'];

  function auditService($translationService) {
    var autidSchema = [
      {
        type: 'integer',
        key: 'auditId',
        displayName: 'Id',
        filter: { key: 'auditId', name: 'id', alias: 'LIKE' },
      },
      {
        type: 'timestamp',
        key: 'creationDate',
        displayName: 'Date',
        filter: { key: 'creationDate', name: 'Creación', alias: 'LIKE' },
      },
      {
        type: 'string',
        key: 'moduleName',
        displayName: 'Module',
        filter: {
          key: 'moduleName',
          name: 'Module',
          operation: '%%',
          alias: 'LIKE',
        },
      },
      {
        type: 'string',
        key: 'moduleFunction',
        displayName: 'Function',
        filter: {
          key: 'moduleFunction',
          name: 'Function',
          operation: '%%',
          alias: 'LIKE',
        },
      },
      {
        type: 'string',
        key: 'actionName',
        displayName: 'Action',
        filter: {
          key: 'actionName',
          name: 'Action',
          operation: 'in',
          alias: 'IN',
        },
      },
      {
        type: 'string',
        key: 'detailedMessage',
        displayName: 'Message',
        filter: {
          key: 'detailedMessage',
          name: 'Message',
          operation: '%%',
          alias: 'LIKE',
        },
      },
      {
        type: 'string',
        key: 'authorName',
        displayName: 'Author',
        filter: {
          key: 'authorId',
          name: 'User',
          operation: 'in',
          alias: 'IN',
        },
      },
    ];

    var vm = this;

    vm.auditSchema = function () {
      return autidSchema;
    };

    vm.colDefs = function (ctx) {
      var columns = [];
      angular.forEach(autidSchema, function (col, key) {
        var column = {
          enableColumnMenu: true,
          enableSorting: true,
          enableHiding: false,
          key: col.key,
          name: col.key,
          displayName: col.displayName,
          type: col.type,
        };

        if (
          [
            'moduleName',
            'moduleFunction',
            'actionName',
            'detailedMessage',
            'authorName',
          ].includes(col.key)
        ) {
          column.menuItems = [
            {
              title: $translationService.getTranslationController(
                'Filtrar',
                'Filter',
                'Filtro'
              ),
              icon: 'ui-grid-icon-filter',
              shown: function () {
                return true;
              },
              action: function ($event) {
                this.context.addFilterTo($event, col.key);
              },
              context: ctx,
            },
          ];
        }
        if (col.type == 'timestamp') {
          column.cellFilter = 'date: "dd/MM/yy HH:mm"';
        }
        if (key == 0) column.sort = { direction: 'asc', priority: 0 };
        columns.push(column);
      });
      return columns;
    };

    vm.columnFilters = function (key) {
      return autidSchema.find(function (e) {
        return e.key == key;
      }).filter;
    };
  }
})();

(function () {
  'use strict';

  angular.module('dashboard').controller('AuditController', AuditController);

  AuditController.$inject = [
    '$rootScope',
    '$stateParams',
    '$scope',
    'translationService',
    'AuditFactory',
    '$mdDialog',
    'auditService',
    'IssuesListExporterService',
    'PermissionsFactory',
  ];

  function AuditController(
    $rootScope,
    $stateParams,
    $scope,
    $translationService,
    $auditFactory,
    $mdDialog,
    $auditService,
    $issuesListExporterService,
    $permissionsFactory
  ) {
    var vm = this;

    vm.validatePermission = function (permission) {
      return $permissionsFactory.hasPermission(permission);
    };

    $scope.startDate =
      $stateParams.desde ||
      moment().hour(0).minute(0).second(0).subtract(1, 'week');
    $scope.endDate =
      $stateParams.hasta || moment().hour(23).minute(59).second(59);

    $scope.$on('dateChange', function (e, dates) {
      vm.params.startDate = dates.desde;
      vm.params.endDate = dates.hasta;
      _getAuditLog();
    });

    vm.params = {
      query: '',
      sortBy: 'auditId',
      sort: 'desc',
      startDate: $scope.desde,
      endDate: $scope.hasta,
      filters: [],
      pagination: {
        page: 1,
        itemsPerPage: 15,
      },
    };

    vm.loading = false;

    vm.gridOptions = {
      data: [],
      enableFiltering: false,
      rowTemplate:
        '<div ng-click="grid.appScope.showDetail(row.entity)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>',
      multiSelect: false,
      gridMenuShowHideColumns: false,
      // Grid menu
      enableGridMenu: false,
      minimumColumnSize: 100,
      // Grid pagination options
      useExternalPagination: true,
      paginationPageSizes: [15, 30, 50, 100],
      paginationPageSize: 15,
      totalItems: 0,
      // Grid sorting options
      useExternalSorting: true,
      onRegisterApi: function (gridApi) {
        gridApi.pagination.on.paginationChanged(
          $scope,
          function (newPage, pageSize) {
            vm.params.pagination.page = newPage;
            vm.params.pagination.itemsPerPage = pageSize;

            _getAuditLog();
          }
        );
        gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (sortColumns[0]) {
            var colField = sortColumns[0].field.split('.')[0];
            vm.params.sortBy = colField;
            vm.params.sort = sortColumns[0].sort.direction;
          } else {
            vm.params.sortBy = null;
          }

          _getAuditLog();
        });
      },
      columnDefs: [],
    };

    (function init() {
      vm.loading = true;
      $translationService.getTranslation($scope, 'audit');
      _getAuditLog();
    })();

    function _getAuditLog() {
      vm.loading = true;
      if (vm.params.filters.length > 0) vm.isFiltered = true;
      else vm.isFiltered = false;

      $auditFactory
        .getAudit(vm.params)
        .then(function (res) {
          vm.auditSchema = $auditService.auditSchema();
          vm.gridOptions.columnDefs = $auditService.colDefs(vm);
          vm.gridOptions.totalItems = res.pagination.totalRecords;
          vm.params.pagination = res.pagination;
          vm.gridOptions.data = res.data;
          vm.loading = false;
        })
        .catch(function (err) {
          console.error('Error@_getAuditLog', err);
          vm.loading = false;
        });
    }

    $scope.showDetail = function (item) {
      $mdDialog
        .show({
          controller: DialogController,
          controllerAs: 'ctrl',
          templateUrl: 'app/audit/audit-detail.tmpl.html',
          parent: angular.element(document.body),
          attachTo: angular.element(document.body),
          clickOutsideToClose: true,
          fullscreen: true,
          locals: {
            itemSelected: item,
          },
        })
        .then(
          function (answer) {
            $scope.status = 'You said the information was "' + answer + '".';
          },
          function () {
            $scope.status = 'You cancelled the dialog.';
          }
        );
    };

    vm.addFilterTo = function (event, col) {
      var coldef = $auditService.columnFilters(col);
      $mdDialog
        .show({
          controller: 'auditFiltersDialog',
          controllerAs: 'ctrl',
          templateUrl: 'app/audit/dialog/audit-filters-dialog.html',

          parent: angular.element(document.body),
          targetEvent: event,
          clickOutsideToClose: false,
          locals: {
            column: coldef,
          },
        })
        .then(function (predicate) {
          vm.params.filters.push(predicate);
          _getAuditLog();
        });
    };

    vm.removeFilter = function (index) {
      vm.params.filters.splice(index, 1);
      if (!vm.params.filters.length) {
        vm.isFiltered = false;
      }
      _getAuditLog();
    };

    vm.unFilterData = function () {
      vm.params.filters = [];
      vm.isFiltered = false;
      _getAuditLog();
    };

    //- export
    vm._onExport = function (ext) {
      $rootScope.loading = true;
      var params = angular.copy(vm.params);
      delete params.pagination;
      $auditFactory
        .getAudit(params)
        .then(function (res) {
          var columnDefs = $auditService.colDefs(vm);
          var data = res.data;
          $issuesListExporterService.exportFile(
            ext,
            columnDefs,
            data,
            columnDefs,
            'log'
          );
          $rootScope.loading = false;
        })
        .catch(function (err) {
          console.error('Error@_onExport', err);
          $rootScope.loading = false;
        });
    };

    // DIALOG DETAIL CONTROLLER
    DialogController.$inject = [
      '$scope',
      '$mdDialog',
      'translationService',
      'itemSelected',
    ];
    function DialogController(
      $scope,
      $mdDialog,
      $translationService,
      itemSelected
    ) {
      var vm = this;
      vm.itemSelected = itemSelected;

      $translationService.getTranslation($scope, 'audit');

      vm.cancel = function () {
        $mdDialog.cancel();
      };
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('dashboard')
        .filter('moment', moment)
        .filter('reverse', reverse);

    /** @ngInject */
    function moment(moment) {
        return function (dateString, format) {
            return moment(dateString).format(format);
        };
    }

    function reverse() {
        return function (list) {
            return list.slice().reverse();
        };
    }

})();

(function() {
  'use strict';

  angular
    .module('dashboard')
    .directive('inpuFile', inpuFile)
    .directive('onEnter', onEnter);
    
  inpuFile.$inject = [];
  function inpuFile() {
    // Usage:
    //
    // Creates:
    //
    var directive = {
        restrict: 'A',
        link: link,
        scope: {
        }
    };
    return directive;

    function link(scope, element) {
      var inputs = element;

      Array.prototype.forEach.call( inputs, function( input )
        {
          var label	 = input.nextElementSibling,
            labelVal = label.innerHTML;

          input.addEventListener( 'change', function( e )
          {
            var fileName = '';
            if( this.files && this.files.length > 1 )
              fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
            else
              fileName = e.target.value.split( '\\' ).pop();

            if( fileName )
              label.querySelector( 'span' ).innerHTML = fileName;
            else
              label.innerHTML = labelVal;
          });
        });
    }
  }

  function onEnter() {
    return function (scope, element, attrs) {
      element.bind("keydown keypress", function (event) {
        if(event.which === 13) {
          scope.$apply(function (){
            scope.$eval(attrs.onEnter);
          });
          event.preventDefault();
        }
      });
    };
  };

})();

'use strict';

angular.module('dashboard').component('ngTableDynamic2', {
  templateUrl: 'app/alarmas/ngtable-dynamic.html',
  controllerAs: 'ctrl',
  bindings: {
    id: '@?',
    selectedItems: '=?',
    onAddEventsToCase: '=?',
    withMultipleSelection: '<',
    onClick: '=',
    onDblClick: '=',
    showTopBar: '<',
    showWorkspacesButton: '<',
    showFilterButton: '<',
    showExportCsvButton: '<',
    showRankingButton: '<',
    showAutoRefreshButton: '<',
    showRefreshButton: '<',
    onDeleteRow: '=',
    fnConfig: '=',
    refreshSchemas: '<',
  },
  controller: NgTableDynamicController2,
});

NgTableDynamicController2.$inject = [
  '$scope',
  '$rootScope',
  'NgTableParams',
  '$http',
  '$q',
  'translationService',
  'toastr',
  'FileSaver',
  'SchemasFactory',
  'EventsV2Factory',
  'WorkspaceFactory',
  '$filter',
  '$interval',
  '$state',
  '$mdSidenav',
];

function NgTableDynamicController2(
  $scope,
  $rootScope,
  NgTableParams,
  $http,
  $q,
  $translationService,
  toastr,
  FileSaver,
  SchemasFactory,
  EventsV2Factory,
  WorkspaceFactory,
  $filter,
  $interval,
  $state,
  $mdSidenav
) {
  var vm = this;
  vm.columnValues = [];
  vm.labelRowsTotal = '';

  vm.$onInit = function () {
    //Método para realizar traducción
    $translationService.getTranslation($scope, 'directives');

    vm.fnConfig().then(function (config) {
      vm.config = config;
      vm.filters = {
        page: 1,
        itemsPerPage: vm.config.pageSizes[0] || 25,
        //sortBy: 'id',
        sort: 'desc',
        startDate: moment(
          $rootScope.desde ||
            moment().subtract(1, 'week').hour(0).minute(0).second(0)
        ),
        endDate: moment(
          $rootScope.hasta || moment().hour(23).minute(59).second(59)
        ),
      };

      // Filtros por defecto para iniciar la tabla
      if (vm.config.datasource.params) {
        vm.filters = angular.copy(vm.config.datasource.params);
      }

      angular.forEach(vm.config.columns, function (item, key) {
        //construir los filtros segun tipo
        if (item.filterable) {
          vm.filters[item.field] = vm.filters[item.field] || {};
          if (item.type === 'integer') {
            vm.filters[item.field] = undefined;
          } else if (item.type === 'string') {
            vm.filters[item.field] = undefined;
          } else if (item.type === 'checkbox') {
            vm.filters[item.field] = undefined;
          } else {
            vm.filters[item.field] = undefined;
          }
        }
      });

      iniTableFn();
    });

    /*********************************************** Multiselection ***********************************************/
    // watch for check all checkbox
    if (angular.isDefined(vm.selectedItems)) {
      $scope.$watch(
        'ctrl.selectedItems.checked',
        function (nval, oval) {
          angular.forEach(vm.selectedItems.items, function (_item, key) {
            vm.selectedItems.items[key] = vm.selectedItems.checked;
          });
        },
        true
      );
    }
  };

  $scope.$on('dateChange', function (e, dates) {
    vm.filters.startDate = moment(dates.desde);
    vm.filters.endDate = moment(dates.hasta);
    vm[vm.id].page(1); //reset page
    vm[vm.id].reload();
  });

  $scope.$on('refreshNgTableDynamic', function () {
    vm[vm.id].page(1); //reset page
    vm[vm.id].reload();
  });

  $scope.$on('$destroy', function () {
    $interval.cancel(vm.interval);
  });

  vm.applyFilters = function () {
    vm.filters.page = 1;
    vm.filters.itemsPerPage = vm.config.pageSizes[0];
    if (angular.isUndefined(vm.refreshSchemas) || vm.refreshSchemas == true) {
      vm.onRefresh();
    } else {
      vm[vm.id].page(1); //reset page
      vm[vm.id].reload();
    }
  };

  function iniTableFn() {
    vm[vm.id] = new NgTableParams(
      {
        page: vm.filters.page || 1,
        count: vm.filters.itemsPerPage || vm.config.pageSizes[0],
      },
      {
        getData: function (params) {
          vm.loadedCaseTable = false;
          vm.filters.page = params.page();
          vm.filters.itemsPerPage = params.count();

          if (
            angular.isDefined(params.orderBy()) &&
            params.orderBy().length > 0
          ) {
            params.orderBy().forEach(function (item, index) {
              vm.filters.sortBy = item.substring(1);
              vm.filters.sort = item.substring(0, 1) === '+' ? 'asc' : 'desc';
            });
          }
          return queryRESTfn()
            .then(function (response) {
              params.total(
                response[vm.config.datasource.paramsOut.pagination].totalRecords
              );
              vm.loadedCaseTable = true;

              if (angular.isDefined(vm.selectedItems)) {
                angular.forEach(
                  response[vm.config.datasource.paramsOut.data],
                  function (_item) {
                    vm.selectedItems.items[_item.id] = vm.selectedItems.checked;
                  }
                );
              }

              vm.labelRowsTotal = '';
              if (params.total() > 0) {
                var start = (params.page() - 1) * params.count();
                var lengthData =
                  response[vm.config.datasource.paramsOut.data].length;
                var msg = $translationService.getTranslationController(
                  ' de ',
                  ' of ',
                  ' do '
                );
                vm.labelRowsTotal =
                  start +
                  1 +
                  ' - ' +
                  (start + lengthData) +
                  msg +
                  params.total();
              }
              return response[vm.config.datasource.paramsOut.data];
            })
            .catch(function (error) {
              vm.loadedCaseTable = true;
            });
        },
      }
    );
    vm[vm.id].settings({ counts: vm.config.pageSizes });
  }

  function queryRESTfn() {
    var defered = $q.defer();
    var params = undefined;
    var data = {};

    if (vm.config.datasource.origin == 'GET') {
      params = {
        query: vm.filters.query || '',
        sortBy: vm.filters.sortBy,
        sort: vm.filters.sort || 'desc',
        page: vm.filters.page,
        itemsPerPage: vm.filters.itemsPerPage,
        exportToCsv: vm.filters.exportToCsv,
      };
      if (angular.isDefined(vm.filters.startDate)) {
        params.startDate = vm.filters.startDate.local().format();
      }
      if (angular.isDefined(vm.filters.endDate)) {
        params.endDate = vm.filters.endDate.local().format();
      }

      angular.forEach(vm.config.columns, function (column, key) {
        if (
          column.filterable &&
          angular.isDefined(vm.filters[column.field]) &&
          (vm.filters[column.field] !== '' ||
            !angular.isArray(vm.filters[column.field]))
        ) {
          params[column.col] = vm.filters[column.field];
        }
      });
    } else {
      data.sortBy = vm.filters.sortBy;
      data.startDate = vm.filters.startDate.local().format();
      data.endDate = vm.filters.endDate.format();
      data.exportToCsv = vm.filters.exportToCsv;
      data.pagination = {
        page: vm.filters.page,
        itemsPerPage: vm.filters.itemsPerPage,
      };

      if (vm.config.schemas) {
        data.schemaIds = vm.config.schemas;
      }

      data.sort = vm.filters.sort || 'desc';
      if (angular.isDefined(vm.filters.sortBy)) {
        angular.forEach(vm.config.columns, function (item, key) {
          if (
            (item.col == vm.filters.sortBy || item.key == vm.filters.sortBy) &&
            angular.isDefined(item.metadata)
          ) {
            data.sortBy = item.metadata;
          }
        });
      }

      data.filters = [];

      angular.forEach(vm.config.columns, function (item, key) {
        if (
          vm.filters[item.field] != undefined &&
          vm.filters[item.field] != null
        ) {
          //List
          if (item.filterType == 'select') {
            var values = [];
            angular.forEach(vm.filters[item.field], function (item, key) {
              if (item) {
                values.push(key);
              }
            });
            if (values.length > 0) {
              data.filters.push({
                type: item.metadata.type,
                metadata: item.metadata.metadata,
                name: item.metadata.name,
                operation: 'in',
                autocomplete: item.metadata.autocomplete,
                value: new Array(values).join(','),
              });
            }
          } else if (item.filterType == 'input') {
            // integer or double
            if (
              item.metadata.type === 'integer' ||
              item.metadata.type === 'double'
            ) {
              data.filters.push({
                type: item.metadata.type,
                metadata: item.metadata.metadata,
                name: item.metadata.name,
                operation: '>=',
                autocomplete: item.metadata.autocomplete,
                value: vm.filters[item.field].min || 1,
              });
              data.filters.push({
                type: item.metadata.type,
                metadata: item.metadata.metadata,
                name: item.metadata.name,
                operation: '<=',
                autocomplete: item.metadata.autocomplete,
                value: vm.filters[item.field].max || 2147483647,
              });
            } else if (vm.filters[item.field].length > 0) {
              data.filters.push({
                type: item.metadata.type,
                metadata: item.metadata.metadata,
                name: item.metadata.name,
                operation: item.metadata.operation, //'%',
                autocomplete: item.metadata.autocomplete,
                value: vm.filters[item.field],
              });
            }
          } else if (
            item.filterType == 'autocomplete' &&
            vm.filters[item.field].length > 0
          ) {
            data.filters.push({
              type: item.metadata.type,
              metadata: item.metadata.metadata,
              name: item.metadata.name,
              operation: item.metadata.operation,
              autocomplete: item.metadata.autocomplete,
              value: vm.filters[item.field],
            });
          }
        }
      });

      if (data.exportToCsv) {
        if (
          data.filters.length == 0 &&
          vm.config.datasource.params.filters != null
        ) {
          vm.config.datasource.params.filters = data.filters;
        } else if (
          data.filters.length > 0 &&
          vm.config.datasource.params.filters == null
        ) {
          vm.config.datasource.params.filters = data.filters;
        } else {
          data.filters = [];
        }
      }

      if (data.exportToCsv == undefined) {
        if (
          data.filters.length == 0 &&
          vm.config.datasource.params.filters != null
        ) {
          data.filters = vm.config.datasource.params.filters;
        }
        if (data.filters.length == 0) {
          data.filters = [];
        }
        vm.config.datasource.params.filters = null;
      }
    }

    $http({
      url: vm.config.datasource.url,
      method: vm.config.datasource.origin,
      params: params,
      responseType: vm.filters.exportToCsv ? 'arraybuffer' : 'application/json',
      data: data,
    })
      .success(function (response) {
        vm.filters.exportToCsv = false;
        defered.resolve(response);
      })
      .error(function (error) {
        vm.filters.exportToCsv = false;
        defered.reject(error);
      });

    return defered.promise;
  }

  vm.cleanFilter = function () {
    angular.forEach(vm.config.columns, function (item, key) {
      if (item.filterable) {
        //vm.filters[item.field] = vm.filters[item.field] || {};
        vm.filters[item.field] = undefined;
      }
    });
  };

  vm.goToRankings = function () {
    $state.go('app.rankings');
  };

  /******************************************** REFRESH *************************************************************/
  vm.onRefresh = function () {
    $rootScope.loading = true;
    EventsV2Factory.getColumnData('alerta').then(
      function (response) {
        vm.config.schemas = response.schemaIds;
        vm.config.functions = response.functions;

        vm[vm.id].page(1); //reset page
        vm[vm.id].reload();
        $rootScope.loading = false;
      },
      function (error) {
        $rootScope.loading = false;
        console.log(error);
      }
    );
  };

  vm.toogleAutoRefresh = function () {
    vm.autoRefresh = !vm.autoRefresh;
    if (vm.autoRefresh) {
      if (angular.isUndefined(vm.interval)) {
        vm.interval = $interval(function () {
          vm.onRefresh();
        }, 30000);
      }
      toastr.info('Actualización automática activada');
    } else {
      if (vm.interval) {
        $interval.cancel(vm.interval);
        vm.interval = false;
      }
      toastr.warning('Actualización automática desactivada');
    }
  };

  /******************************************************************************************************************/
  vm.onExportCsv = function () {
    vm.filters.exportToCsv = true;
    vm.loadedCaseTable = false;
    queryRESTfn()
      .then(function (response) {
        vm.filters.exportToCsv = false;
        vm.loadedCaseTable = true;
        FileSaver.saveAs(
          new Blob([response], { type: 'application/csv' }),
          vm.id + '.csv'
        );
        vm.config.datasource.params.filters = null;
      })
      .catch(function (error) {
        var msg = $translationService.getTranslationController(
          'No hay datos para mostrar',
          'There is no data to display',
          'Não há dados para exibir'
        );
        toastr.error(msg);
        vm.loadedCaseTable = true;
        vm.filters.exportToCsv = false;
      });
  };

  vm.onCheckItem = function (item) {
    if (
      vm.selectedItems.length > 0 &&
      vm.selectedItems.indexOf(item.id) !== -1
    ) {
      vm.selectedItems.splice(vm.selectedItems.indexOf(item.id), 1);
    } else {
      vm.selectedItems.push(item.id);
    }
  };

  /********************************************* Functions autocomplete *********************************************/
  vm.querySearchAutocomplete = function (searchText, field) {
    if (angular.isUndefined(vm.columnValues[field])) {
      return SchemasFactory.getSchemaAutocomplete(
        'event',
        encodeURIComponent(field)
      )
        .then(function (response) {
          vm.columnValues[field] = response;
          return vm.columnValues[field];
        })
        .catch(function (e) {
          console.log(e);
          return e;
        });
    } else {
      return searchText
        ? vm.columnValues[field].filter(createFilterFor(searchText))
        : vm.columnValues[field];
    }
  };

  function createFilterFor(query) {
    var lowercaseQuery = angular.lowercase(query);
    return function filterFn(array) {
      return angular.lowercase(array).indexOf(lowercaseQuery) > -1;
    };
  }

  /********************** WORKSPACE ********************************************************************************/
  vm.openWorkspacesForm = function () {
    vm.selectedIndex = 1;
    $mdSidenav('workspace-event').toggle();
  };

  function getFilterType(item) {
    var operation;

    if (item.autocomplete == true && item.metadata == false) {
      operation = 'autocomplete';
    } else if (item.autocomplete == true && item.metadata == true) {
      operation = 'select';
    } else {
      operation = 'input';
    }
    return operation;
  }

  function getOperation(type) {
    var operation;
    switch (type) {
      case 'boolean':
        operation = '=';
        break;
      case 'string':
        operation = '=';
        break;
      case 'double':
        operation = '>=';
        break;
      case 'integer':
        operation = '=';
        break;
      default:
        operation = '=';
    }
    return operation;
  }

  vm.setSchema = function (schema) {
    vm.config.workspaces.items[1].workspaceSchema.columns = angular.copy(
      schema.workspaceSchema.columns
    );
    vm.config.columns = angular.copy(schema.workspaceSchema.columns);
    saveWorkspaceFn(vm.config.workspaces.items[1]);
  };

  function saveWorkspaceFn(_workspace) {
    vm.loading = true;
    $rootScope.loading = true;

    console.log('_workspace.id ' + _workspace.id);
    if (_workspace.id !== null) {
      WorkspaceFactory.setWorkspace(_workspace).then(
        function (response) {
          toastr.success('Workspace Guardado.');
          $rootScope.loading = false;
          vm.loading = false;
        },
        function (error) {
          toastr.error('Se ha producido un error');
          $rootScope.loading = false;
          vm.loading = false;
        }
      );
    } else {
      WorkspaceFactory.createWorkspace(_workspace)
        .then(function (response) {
          toastr.success('Workspace creado.');
          vm.config.workspaces.id = response.id;
          $rootScope.loading = false;
          vm.loading = false;
        })
        .catch(function (err) {
          toastr.error('Se ha producido un error');
          $rootScope.loading = false;
          vm.loading = false;
        });
    }
  }

  vm.getColumnData = function () {
    if (
      angular.isUndefined(vm.selectedFunctions) ||
      vm.selectedFunctions.length == 0
    ) {
      return;
    }

    vm.loading = true;
    $rootScope.loading = true;

    var schemasIds = [];
    vm.selectedFunctions.forEach(function (_item) {
      _item.schemasIds.forEach(function (_item_2) {
        schemasIds.push(_item_2);
      });
    });
    schemasIds = schemasIds.filter(function (item, index, array) {
      return array.indexOf(item) === index;
    });
    schemasIds = $filter('orderBy')(schemasIds);

    var strSchemasIds = new Array(schemasIds).join(',');
    var defaultWorkspace = vm.config.workspaces.items.filter(function (_item) {
      return _item.workspaceName.localeCompare('Schema-' + strSchemasIds) == 0;
    });

    if (defaultWorkspace.length > 0) {
      vm.loading = false;
      $rootScope.loading = false;
      return;
    }

    EventsV2Factory.getColumnData(strSchemasIds).then(
      function (response) {
        var gridColumns = [];
        angular.forEach(response.columns, function (item, key) {
          var column = {
            col: item.metadata == false ? 'eventBody' : item.name,
            key: item.metadata == false ? item.name : '',
            title: item.name,
            show: false,
            filterable: true,
            default: item.metadata,
            filterType: getFilterType(item),
            sortable: item.name,
          };
          column.field = column.col + column.key;
          column.metadata = angular.copy(item);
          column.type = item.metadata == false ? 'object' : item.type;
          column.metadata.operation = getOperation(item.type);
          gridColumns.push(angular.copy(column));
        });

        vm.config.workspaces.items.push({
          id: null,
          userId: null,
          workspaceName: 'Schema-' + $filter('orderBy')(response.schemaIds),
          workspaceSchema: {
            columns: gridColumns,
          },
        });
        $rootScope.loading = false;
        vm.loading = false;
      },
      function (error) {
        $rootScope.loading = false;
        vm.loading = false;
      }
    );
  };

  vm.applySchema = function (schema) {
    var result = schema.workspaceSchema.columns.filter(function (_item) {
      return _item.show == true;
    });
    if (result.length > 0) {
      result.map(function (_item) {
        var index = -1;
        for (var i = 0; i < vm.config.columns.length; i++) {
          if (vm.config.columns[i].field == _item.field) {
            index = i;
            break;
          }
        }
        if (index > 0) vm.config.columns.splice(index, 1);
        vm.config.columns.push(angular.copy(_item));
      });
    }
    vm.config.workspaces.items[1].workspaceSchema.columns = angular.copy(
      vm.config.columns
    );
    saveWorkspaceFn(vm.config.workspaces.items[1]);
    vm.selectedIndex = 1;
  };

  /************************************ filter palette **************************************************************/
  vm.isFilterChange = function (item) {
    var flag = false;
    if (
      vm.filters[item.field] == null ||
      angular.isUndefined(vm.filters[item.field])
    ) {
      return false;
    }
    if (angular.isObject(vm.filters[item.field])) {
      angular.forEach(vm.filters[item.field], function (item, key) {
        if (item) {
          flag = true;
        }
      });
    } else if (
      vm.filters[item.field].min ||
      vm.filters[item.field].max ||
      vm.filters[item.field].length > 0
    ) {
      flag = true;
    }
    return flag;
  };

  vm.isNumberKey = function (evt) {
    var charCode = evt.which ? evt.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
    return true;
  };

  vm.onGoBack = function () {
    $state.go('app.casos');
  };
}

(function () {
    'use strict';

    angular
        .module('dashboard')
        .controller('AlarmasController', AlarmasController);

    AlarmasController.$inject = ['$rootScope', '$filter', '$modal', 'FileUploader', 'DetalleAlerta', '$stateParams',
        '$scope', '$state', 'Casos', 'EventsFactory', 'WorkspaceFactory', 'Paginator', 'env',
        'translationService', '$location', '$mdDialog', 'EventsV2Factory', 'toastr', 'PermissionsFactory'];

    function AlarmasController($rootScope, $filter, $modal, FileUploader, DetalleAlerta, $stateParams,
        $scope, $state, Casos, EventsFactory, WorkspaceFactory, Paginator, env,
        $translationService, $location, $mdDialog, EventsV2Factory, toastr, PermissionsFactory) {
        var vm = this;
        var eventSendPutAlertToCaseId = null;
        vm.caseId = $location.search().caseId;

        vm.events = [];
        vm.selectedItems = {
            checked: false,
            items: {}
        };

        vm.filters = {
            page: 1,
            itemsPerPage: 10,
            sort: 'desc',
            startDate: moment($stateParams.desde || (moment().hour(0).minute(0).second(0).subtract(1, 'months'))),
            endDate: moment($stateParams.hasta || (moment().hour(23).minute(59).second(59)))
        };

        (function init() {
            //- Método para realizar traducción
            $translationService.getTranslation($scope, 'alerts');

        })();

        vm.initGrid = function () {

            function getFilterType(item) {
                var operation;

                if (item.autocomplete == true && item.metadata == false) {
                    operation = 'autocomplete';
                } else if (item.autocomplete == true && item.metadata == true) {
                    operation = 'select';
                } else {
                    operation = 'input';
                }
                return operation;
            }

            function getOperation(type) {
                var operation;
                switch (type) {
                    case 'boolean':
                        operation = '=';
                        break;
                    case 'string':
                        operation = '=';
                        break;
                    case 'double':
                        operation = '>=';
                        break;
                    case 'integer':
                        operation = '=';
                        break;
                    default:
                        operation = '=';
                }
                return operation;
            }

            return new Promise(function (resolve, reject) {
                var config = {
                    datasource: {
                        origin: "POST",
                        url: "/risk-backend/rest/v2/event/filter",
                        params: {
                            sortBy: {
                                "name": "id",
                                "type": "integer",
                                "metadata": "true"
                            },
                            filters: $state.params.dinamicFilters,
                            //filterBy:$state.params.filterBy,
                            sort: 'desc',
                            startDate: moment($stateParams.desde || (moment().subtract(1, 'week').hour(0).minute(0).second(0))),
                            endDate: moment($stateParams.hasta || (moment().hour(23).minute(59).second(59))),
                            page: 1,
                            itemsPerPage: 25,
                        },
                        paramsOut: {
                            data: "events",
                            pagination: "pagination"
                        }
                    },
                    pageSizes: [25, 50, 100],
                    columns: [],
                    style: {
                        trStyle: function (item) {
                            if (item.checked.toUpperCase() === "NO VISTO") {
                                switch (item.criticality.toUpperCase()) {
                                    case "ALTA":
                                        return "alta";
                                    case "MEDIA":
                                        return "media";
                                    case "BAJA":
                                        return "baja";
                                    default:
                                        return "";
                                }
                            } else {
                                switch (item.criticality.toUpperCase()) {
                                    case "ALTA":
                                        return "alta-checked";
                                    case "MEDIA":
                                        return "media-checked";
                                    case "BAJA":
                                        return "baja-checked";
                                    default:
                                        return "";
                                }
                                return "";
                            }
                        }
                    }
                };
                config.workspaces = {
                    items: [{
                        id: null,
                        userId: null,
                        workspaceName: "DEFAULT",
                        workspaceSchema: {
                            columns: []
                        }
                    },
                    {
                        id: null,
                        userId: null,
                        workspaceName: "CURRENT VIEW",
                        workspaceSchema: {
                            columns: []
                        }
                    }]
                };

                EventsV2Factory.getColumnData('alerta').then(function (response) {
                    config.schemas = response.schemaIds;
                    config.functions = response.functions;
                    var columnsDefault = [];
                    angular.forEach(response.columns, function (item, key) {

                        if (item.metadata == true) {
                            var column = {
                                col: (item.metadata == false) ? 'eventBody' : item.name,
                                key: (item.metadata == false) ? item.name : '',
                                title: item.name,
                                show: item.metadata,
                                filterable: item.metadata,
                                default: item.metadata,
                                filterType: getFilterType(item),
                                sortable: item.name
                            };
                            column.field = column.col + column.key;
                            column.metadata = item;
                            column.type = (item.metadata == false) ? 'object' : item.type;
                            column.metadata.operation = getOperation(item.type);
                            columnsDefault.push(angular.copy(column));
                        }
                    });
                    config.workspaces.items[0].workspaceSchema.columns = columnsDefault;

                    WorkspaceFactory.getWorkspaces().then(function (response) {

                        if (angular.isDefined(response) && response.length > 0) {
                            response.sort(function (a, b) { return b.id - a.id; });
                            config.workspaces.items[1].id = response[0].id;
                            config.workspaces.items[1].workspaceSchema = angular.copy(angular.fromJson(response[0].workspaceSchema));
                        } else {
                            config.workspaces.items[1].workspaceSchema.columns = angular.copy(config.workspaces.items[0].workspaceSchema.columns);
                        }
                        config.workspaces.selected = {
                            id: config.workspaces.items[1].workspaceSchema.id,
                            workspaceName: "CURRENT VIEW"
                        }

                        if (vm.isTableWithMultipleSelection() == true) {
                            var gridColumns = [];
                            gridColumns.push({
                                field: "selected",
                                title: "",
                                type: "checkbox",
                                show: true,
                                headerTemplateURL: "headerCheckbox.html"
                            });
                            config.workspaces.items[1].workspaceSchema.columns.forEach(function (_item) {
                                gridColumns.push(_item);
                            });
                            config.columns = gridColumns;
                        } else {
                            config.columns = angular.copy(config.workspaces.items[1].workspaceSchema.columns);
                        }
                    }).catch(function (error) {
                        console.log("error " + error);
                        config.columns = config.workspaces.items[0].workspaceSchema.columns;
                    }).finally(function () {
                        resolve(config);
                    });

                }, function (error) {
                    console.log("EventsV2Factory@error. " + error)
                    reject(config);
                });
            });
        }

        vm.isTableWithMultipleSelection = function () {
            return (vm.caseId > 0) ? true : false;
        }

        vm.addEventsToCaseId = function () {
            var selectedItms = [];
            angular.forEach(vm.selectedItems.items, function (_item, key) {
                if (vm.selectedItems.items[key] == true) {
                    selectedItms.push(key);
                }
            });

            if (selectedItms.length == 0) return;

            var confirm = $mdDialog.confirm()
                .title('Confirm')
                .textContent('Are you sure?')
                .ok($scope.translation.CONFIRM_YES)
                .cancel($scope.translation.CONFIRM_NO);

            $mdDialog.show(confirm).then(function () {
                eventSendPutAlertToCaseId = $rootScope.$emit('addEventsToCaseId', {
                    caseId: vm.caseId,
                    items: selectedItms
                });
            }, function () {

            });
        }

        $scope.$on('$destroy', function () {
            eventSendPutAlertToCaseId;
        });

        //- Traduciendo título del cuadro
        vm.showLang = function () {
            if ($rootScope.tabsAlerts[0].id === 'index') {
                $rootScope.tabsAlerts[0].name = $translationService.getTranslationController('TODOS', 'ALL', 'TODOS');
            }
        };
        vm.showLang();

        vm.parseNum = function (entrie, col) {
            if (isNaN(entrie))
                return entrie;
            if (col == "id")
                return $filter('number')(entrie);
            return $filter('number')((Math.floor(entrie * 100) / 100), 2); // Redondea solo abajo, pedido por oscar y kathy 10-12-18
        }


        /**************** modal crear caso *********************************/
        vm.crearCaso = function (ev, alert) {
            $mdDialog.show({
                controller: 'CreateCaseController',
                templateUrl: 'app/casos/templates/dialog-create-case.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    inputData: {
                        source: 'ALERT',
                        eventId: alert.id
                    }
                },
            })
        };

        vm.selectedTab = 'index';

        vm.setTab = function (newTab) {
            vm.selectedTab = newTab;
        };

        vm.isSet = function (tabNum) {
            return vm.selectedTab === tabNum;
        };

        vm.isActive = function (id) {
            return vm.isSet(id) && id != 'index';
        };

        vm.eliminarTabAlerta = function (tabId) {
            var indexTab = -2;
            for (var i = 0; i < $rootScope.tabsAlerts.length; i++) {
                var actualTab = $rootScope.tabsAlerts[i];
                if (actualTab.id === tabId) {
                    indexTab = i;
                    break;
                }
            }
            if (indexTab > 0) {
                $rootScope.tabsAlerts.splice(indexTab, 1);
                vm.setTab('index');
            }
        };

        vm.crearTabDetalleAlerta = function (rowAlerta) {
            //Se recorren los tabs existentes
            var existeTab = false;
            for (var i = 0; i < $rootScope.tabsAlerts.length; i++) {
                var actualTab = $rootScope.tabsAlerts[i];
                if (actualTab.id === rowAlerta.id) {
                    existeTab = true;
                    break;
                }
            }
            if (existeTab) {
                vm.setTab(actualTab.id);
            } else {
                //Se crea el nuevo tab con el detalle de la alerta
                var newTab = { id: rowAlerta.id, name: 'Detalle ' + ' - ' + rowAlerta.id };
                //Se agrega el tab a la lista
                $rootScope.tabsAlerts.push(newTab);
                newTab.alert = rowAlerta;
                newTab.alert.moment = moment(newTab.alert.timestamp, "YYYY/MM/DD hh:mm:ss");
                newTab.alert.files = [];
                newTab.alert.events = [];
                newTab.uploader = new FileUploader();
                newTab.uploader.onCompleteAll(function () {
                    obtenerArchivosTab(newTab);
                });
                //Se obtienen los casos asociados a la alerta
                obtenerCasosAsociadosAlerta(newTab);
                //Se obtienen los archivos de la alerta
                obtenerArchivosTab(newTab);
                //Se obtienen los eventos de la alerta
                obtenerEventosTab(newTab);
                //Se hace visible el nuevo tab
                vm.setTab(newTab.id);
            }
        };

        vm.checkEvent = function (row) {
            if (row.checked == 'visto' || $rootScope.loading == true) {
                return;
            }

            $rootScope.loading = true;
            EventsV2Factory.checkEvent(row.id).then(function (response) {
                if (response) {
                    $rootScope.$broadcast('refreshNgTableDynamic');
                    var msg = $translationService.getTranslationController('Evento actualizado exitosamente.', 'Updated event.', 'Evento atualizado.');
                    toastr.success(msg);
                }
                $rootScope.loading = false;
            });
        }

        function obtenerCasosAsociadosAlerta(newTab) {
            Casos.obtenerCasosAlerta(newTab.id, function (response) {
                newTab.alert.casosLink = [];
                if (response.header.code == 0 && response.body != null) {
                    for (var i = 0; i < response.body.length; i++) {
                        newTab.alert.casosLink.push(response.body[i]);
                    }
                }
            });
        }

        function obtenerArchivosTab(newTab) {
            //Se van a buscar los archivos relacionados a la alerta
            DetalleAlerta.obtenerArchivos(newTab.id, function (response) {
                newTab.alert.files = [];
                //Se obtienen los archivos de la alerta
                if (response.header.code == 0 && response.body != null) {
                    for (var i = 0; i < response.body.length; i++) {
                        newTab.alert.files.push(response.body[i]);
                    }
                }
            });
        }

        function obtenerEventosTab(newTab) {
            EventsV2Factory.getEventsRelated(newTab.id)
                .then(function (res) {
                    newTab.name = $translationService.getTranslationController('Detalle Alerta ', 'Detail Alert ', 'Alerta de detalhes ') + newTab.id;
                    newTab.alert.events = res;
                    $scope.$apply();
                })
                .catch(function (err) {
                    console.log("Error@obtenerEventosTab");
                    console.log(err);
                });
        }

        //Este codigo sirve para poder abrir/cargar automaticamente la pestaña de una alerta especifica
        if ($stateParams.idCaso) {
            var alerta = $rootScope.getAlertaById($stateParams.idAlerta);
            if (alerta) {
                vm.crearTabDetalleAlerta(alerta);
            }
        }

        vm.validatePermission = function () {
            return PermissionsFactory.hasPermission('event:update');
        }
    }

})();

(function () {
  'use strict';

  angular.module('dashboard').controller('AclController', AclController);

  AclController.$inject = [
    '$scope',
    '$state',
    '$rootScope',
    '$interval',
    '$localStorageService',
    '$stateParams',
    '$modal',
    'UserFactory',
    '$http',
    '$log',
    'toastr',
    '$timeout',
    '$mdDialog',
    'LoginFactory',
    'ReportsFactory',
    'translationService',
    'AclFactory',
    'FileSaver'
  ];

  function AclController(
    $scope,
    $state,
    $rootScope,
    $interval,
    $localStorageService,
    $stateParams,
    $modal,
    UserFactory,
    $http,
    $log,
    toastr,
    $timeout,
    $mdDialog,
    LoginFactory,
    ReportsFactory,
    $translationService,
    AclFactory,
    FileSaver
  ) {
    var vm = this;

    vm.editActive = false;
    vm.botonesDeAccion = {
      crear: true,
      guardar: false,
      eliminar: false,
      cancelar: false,
      import: true,
    };
    vm.acl = {
      policies: [],
      category: 'ACCESS',
    };
    vm.isValid = false;

    (function init() {
      console.log('++++++ AclController +++++++');
      $translationService.getTranslation($scope, 'acl');

      vm.config = {
        datasource: {
          origin: 'GET',
          url: '/risk-backend/rest/acl/config',
          params: {
            query: '',
            sortBy: 'id',
            sort: 'desc',
            startDate: moment(
              $stateParams.desde ||
                moment().subtract(1, 'week').hour(0).minute(0).second(0)
            ),
            endDate: moment(
              $stateParams.hasta || moment().hour(23).minute(59).second(59)
            ),
            page: 1,
            itemsPerPage: 25,
          },
          paramsOut: {
            data: 'data',
            pagination: 'pagination',
          },
        },
        pageSizes: [25, 50, 100],
        columns: [
          {
            field: 'id',
            title: 'Id',
            type: 'number',
            show: true,
            sortable: 'id',
            width: 3,
          },
          {
            field: 'name',
            title: $translationService.getTranslationController(
              'Nombre',
              'Name',
              'Nome'
            ),
            type: 'text',
            show: true,
            sortable: 'name',
            filterable: { type: 'text' },
            width: 20,
          },
          {
            field: 'description',
            title: $translationService.getTranslationController(
              'Descripcion',
              'Description',
              'Nome'
            ),
            type: 'text',
            show: true,
            width: 20,
          },
          {
            field: 'category',
            title: $translationService.getTranslationController(
              'Categoria',
              'Category',
              'Nome'
            ),
            type: 'text',
            show: true,
            sortable: 'category',
            filterable: {
              type: 'select',
              options: [
                { key: 'ACCESS', value: 'Access', selected: 'Access' },
                { key: 'OWNER', value: 'Owner' },
                { key: 'SHARE', value: 'Share' },
                { key: 'AUDITOR', value: 'Auditor' },
              ],
            },
            width: 20,
          },
          {
            field: 'totalPolicies',
            title: $translationService.getTranslationController(
              'Políticas',
              'Policies',
              'Políticas'
            ),
            type: 'text',
            show: true,
            width: 10,
          },
          {
            field: 'active',
            title: $translationService.getTranslationController(
              'Estado',
              'Status',
              'Estado'
            ),
            type: 'boolean',
            show: true,
            filterable: {
              type: 'select',
              options: [
                {
                  key: 'true',
                  value: $translationService.getTranslationController(
                    'Activo',
                    'Active',
                    'Ativo'
                  ),
                },
                {
                  key: 'false',
                  value: $translationService.getTranslationController(
                    'Inactivo',
                    'Inactive',
                    'Inativo'
                  ),
                },
              ],
            },
            width: 5,
          },
          {
            field: 'delete',
            title: '',
            type: 'command',
            show: true,
            width: 2,
            sortable: false,
          },
          
          {
            field: 'export',
            title: '',
            type: 'export',
            show: true,
            width: 2,
            sortable: false,
          },

        ],
      };
    })();

    vm.habilitarCrear = function () {
      vm.clearForm();
      vm.editActive = true;
      vm.habilitarBotones('create');
    };

    vm.availableEdit = function (_item, isImport) {
      if(isImport){
        delete _item.id;
        delete _item.name;
        delete _item.updatedBy;        ;
        delete _item.createdBy;        ;
      }

      vm.acl = angular.copy(_item);
      if (angular.isDefined(vm.acl.policies)) {
        vm.acl.policies = isImport ? vm.acl.policies : angular.fromJson(vm.acl.policies);
      } else {
        vm.acl.policies = [];
      }
      vm.editActive = true;
      if(isImport)
        vm.habilitarBotones('create');
      else
        vm.habilitarBotones('edit');
    };

    vm.habilitarBotones = function (tipo) {
      switch (tipo) {
        case 'create':
          vm.botonesDeAccion.crear = true;
          vm.botonesDeAccion.guardar = false;
          vm.botonesDeAccion.eliminar = false;
          vm.botonesDeAccion.import = true;
          break;
        case 'edit':
        case 'eliminar':
          vm.botonesDeAccion.crear = false;
          vm.botonesDeAccion.guardar = true;
          vm.botonesDeAccion.eliminar = true;
          vm.botonesDeAccion.cancelar = true;
          vm.botonesDeAccion.import = false;
          break;
        default:
          break;
      }
    };

    vm.clearForm = function () {
      //vm.aclForm.$setUntouched();
      vm.botonesDeAccion = {
        crear: true,
        guardar: false,
        editar: false,
        eliminar: false,
        cancelar: false,
        import: true,
      };
      vm.editActive = false;
      vm.acl = {
        policies: [],
        category: 'ACCESS',
      };
      vm.myErrorsJson = undefined;
      vm.myPoliciesJson = undefined;
      vm.isValid = false;
    };

    function buildAclFn() {
      var acl = {
        id: vm.acl.id,
        name: vm.acl.name,
        description: vm.acl.description,
        active: vm.acl.active,
      };

      if (angular.isDefined(vm.acl.policies) && vm.acl.policies.length > 0) {
        acl.policies = JSON.stringify(vm.acl.policies);
      }
      return acl;
    }

    vm.createAcl = function () {
      var acl = buildAclFn();

      $rootScope.loading = true;
      AclFactory.create(acl).then(
        function (response) {
          $rootScope.loading = false;
          toastr.success(
            $translationService.getTranslationController(
              'ACL creada exitosamente.',
              'Successfully created ACL.',
              'ACL criada com sucesso.'
            )
          );
          vm.clearForm();
          $rootScope.$broadcast('refreshNgTableDynamic', {
            tableId: 'acl-table',
          });
        },
        function (error) {
          $rootScope.loading = false;
          if (error.status == 403) {
            toastr.error(
              $translationService.getTranslationController(
                'Usuario no autorizado.',
                'Unauthorized User.',
                'Usuário não autorizado.'
              )
            );
          } else if (error.status == 400) {
            toastr.error(JSON.stringify(error.data));
          } else if (error.status == 409) {
            toastr.error(
              $translationService.getTranslationController(
                'Esta ACL ya existe.',
                'This ACL already exists.',
                'Esta ACL já existe.'
              )
            );
          } else {
            toastr.error(error);
          }
        }
      );
    };

    vm.updateAcl = function () {
      var acl = buildAclFn();

      $rootScope.loading = true;
      AclFactory.edit(vm.acl.id, acl).then(
        function (response) {
          $rootScope.loading = false;
          toastr.success(
            $translationService.getTranslationController(
              'ACL actualizada exitosamente.',
              'Successfully updated ACL.',
              'ACL atualizada com sucesso.'
            )
          );
          vm.clearForm();
          $rootScope.$broadcast('refreshNgTableDynamic', {
            tableId: 'acl-table',
          });
        },
        function (error) {
          $rootScope.loading = false;
          if (error.status == 403) {
            toastr.error(
              $translationService.getTranslationController(
                'Usuario no autorizado.',
                'Unauthorized User.',
                'Usuário não autorizado.'
              )
            );
          } else if (error.status == 400) {
            toastr.error(
              $translationService.getTranslationController(
                'ACL tiene uno o mas errores',
                'This ACL has one or more errors',
                'Esta ACL tem um ou mais erros'
              )
            );
          } else if (error.status == 409) {
            toastr.error(
              $translationService.getTranslationController(
                'Esta ACL ya existe.',
                'This ACL already exists.',
                'Esta ACL já existe.'
              )
            );
          } else {
            toastr.error(error);
          }
        }
      );
    };

    vm.removeAcl = function (_acl) {
      var confirm = $mdDialog
        .confirm()
        .title(
          $translationService.getTranslationController(
            'Eliminar ACL',
            'Delete ACL',
            'Excluir ACL'
          )
        )
        .textContent(
          $translationService.getTranslationController(
            '¿Estas seguro que quieres borrarlo?',
            'Are you sure you want to delete?',
            'Tem certeza de que deseja excluir?'
          )
        )
        .ok($translationService.getTranslationController('Si', 'Yes', 'Sim'))
        .cancel(
          $translationService.getTranslationController('No', 'No', 'Não')
        );

      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loading = true;
          AclFactory.delete(_acl.id).then(
            function (response) {
              $rootScope.loading = false;
              $rootScope.$broadcast('refreshNgTableDynamic', {
                tableId: 'acl-table',
              });
              toastr.success(
                $translationService.getTranslationController(
                  'ACL eliminado exitosamente.',
                  'Successfully removed ACL.',
                  'ACL excluído com sucesso.'
                )
              );
            },
            function (error) {
              $rootScope.loading = false;
              var msg = $translationService.getTranslationController(
                'No fue posible eliminar el ACL.',
                'It was not possible to delete the replay.',
                'Não foi possível excluir o replay.'
              );
              toastr.error(msg);
              console.log(error);
            }
          );
        },
        function () {}
      );
    };

    vm.removePolicy = function (ev, index) {
      var confirm = $mdDialog
        .confirm()
        .multiple(false)
        .title(
          $translationService.getTranslationController(
            '¿Deseas borrar el registro de la lista?',
            'Do you want to delete the record from the list?',
            'Você deseja excluir o registro da lista?'
          )
        )
        .ariaLabel('Cancel-Question')
        .targetEvent(ev)
        .ok($translationService.getTranslationController('Si', 'Yes', 'Sim'))
        .cancel(
          $translationService.getTranslationController('No', 'No', 'Não')
        );

      $mdDialog.show(confirm).then(
        function () {
          vm.acl.policies.splice(index, 1);
        },
        function () {}
      );
    };

    vm.exportRow = function (row) {
      var acl = angular.copy(row);
      delete acl.$$hashKey;
      delete acl.id;
      delete acl.createdBy;
      delete acl.updatedBy;

      acl.policies = angular.fromJson(acl.policies);
      var data = angular.toJson(acl, true);
      FileSaver.saveAs(
        new Blob([data], { type: 'application/json' }),
        'acl-' + acl.name + '.json'
      );
    }

    vm.inputUpload = function () {
      document.getElementById('uploadacl').click()
    }

    vm.importedData = []

    $scope.$watchCollection("ctrl.importedData", function (newCollection) {
      if (!newCollection) return;
      if (newCollection.length === 0) return
      else {
        vm.onImportedData(newCollection);
      }
    });

    vm.onImportedData = function (data) {
      vm.availableEdit(JSON.parse(data), true);
    };
 
    vm.validate = function () {
      vm.isValid = false;
      try {
        var acl = angular.fromJson(vm.myPoliciesJson);
        var object = {
          name: acl.name,
          active: acl.active,
        };

        if (angular.isDefined(acl.policies) && acl.policies.length > 0) {
          object.policies = JSON.stringify(acl.policies);
        }

        $rootScope.loading = true;
        AclFactory.validate(object)
          .then(function (response) {
            $rootScope.loading = false;
            vm.myErrorsJson = undefined;
            vm.isValid = true;
          })
          .catch(function (error) {
            vm.myErrorsJson = angular.toJson(error, true);
            $rootScope.loading = false;
          });
      } catch (err) {
        vm.myErrorsJson = err;
      }
    };

    vm.buildPolicies = function () {
      vm.myPoliciesJson = angular.toJson(angular.copy(vm.acl), true);
    };

    vm.loadPolicies = function (rule) {
      if (rule) {
        vm.acl = angular.copy(angular.fromJson(rule));
      }
    };

    vm.getBY = function (_item) {
      var user = '';
      var group = '';
      if (
        angular.isDefined(_item.appliesTo.users) &&
        _item.appliesTo.users.length > 0
      ) {
        user =
          '<span><i class="material-icons">person</i> <strong>' +
          arrayToStringFn(_item.appliesTo.users) +
          '</strong></span>';
      }
      if (
        angular.isDefined(_item.appliesTo.groups) &&
        _item.appliesTo.groups.length > 0
      ) {
        group =
          '<span><i class="material-icons">group</i> <strong>' +
          arrayToStringFn(_item.appliesTo.groups) +
          '</strong></span>';
      }
      return user + '<br>' + group;
    };

    function arrayToStringFn(array) {
      if (angular.isUndefined(array)) {
        return '';
      }
      var tmp = [];
      array.forEach(function (_item) {
        tmp.push(_item.name);
      });
      return tmp;
    }

    vm.getAction = function (_item) {
      var grant =
        _item.resource.granted == true || _item.resource.granted == 'true'
          ? 'add'
          : 'remove';
      var str =
        '<span><i class="material-icons">' +
        grant +
        '</i> <strong>' +
        _item.resource.actions +
        '</strong></span>';
      return str;
    };

    vm.getFOR = function (_item) {
      var rules = '';
      if (angular.isDefined(_item.resource.entityId)) {
        rules = '#' + _item.resource.entityId;
      }
      var str = '<p><strong>' + _item.resource.name + rules + '</strong></p>';
      return str;
    };

    /********************************************** Modal Create Rule ********************************************/
    vm.showCreateRuleDialog = function (ev) {
      $mdDialog
        .show({
          controller: DialogController,
          templateUrl: 'app/acl/dialog-create-rule.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: false,
          locals: {
            itemSelected: vm.acl,
          },
        })
        .then(function (rule) {
          vm.acl.policies.push(rule);
        });
    };

    DialogController.$inject = [
      '$scope',
      '$mdDialog',
      'translationService',
      'AclFactory',
      'UserFactory',
      'itemSelected',
      'GroupFactory',
      'ResourceFactory',
      '$localStorageService',
    ];

    function DialogController(
      $scope,
      $mdDialog,
      $translationService,
      AclFactory,
      UserFactory,
      itemSelected,
      GroupFactory,
      ResourceFactory,
      $localStorageService
    ) {
      $scope.resources = [];
      $scope.groups = [];
      $scope.rule = { entityId: undefined, action: 'true' };
      $scope.itemSelected = itemSelected;

      $scope.currentUser = $localStorageService.getItem("currentUser");

      (function init() {
        //Método para realizar traducción
        $translationService.getTranslation($scope, 'acl');
        $scope.actionText = $translationService.getTranslationController(
          'Crear Regla ',
          'Create Rule',
          'Criar Regla'
        );

        getGroupsByCompanyIdFn();
        getUsersByCompanyIdFn();
        getAllPermissionsFn();
      })();

      function getAllPermissionsFn() {
        $rootScope.loading = true;
        ResourceFactory.getAll()
          .then(function (response) {
            $scope.originResources = (response.data || []).sort(function (a, b) {
              return a.name.localeCompare(b.name);
            });
            $rootScope.loading = false;
            $scope.$apply();
          })
          .catch(function (error) {
            if (error.status == 403) {
              toastr.error(
                $translationService.getTranslationController(
                  'Usuario no autorizado.',
                  'Unauthorized User.',
                  'Usuário não autorizado.'
                )
              );
            } else {
              toastr.error(error);
            }
          })
          .finally(function () {
            $rootScope.loading = false;
          });
      }

      function getGroupsByCompanyIdFn() {
        if (
          !$scope.currentUser ||
          !$scope.currentUser.company ||
          !$scope.currentUser.company.companyId
        ) {
          return;
        }
        $scope.groups = [];
        $rootScope.loading = true;
        GroupFactory.getAllByCompanyId($scope.currentUser.company.companyId)
          .then(function (response) {
            $scope.groups = response;
            $scope.$apply();
          })
          .catch(function (error) {
            if (error.status == 403) {
              toastr.error(
                $translationService.getTranslationController(
                  'Usuario no autorizado.',
                  'Unauthorized User.',
                  'Usuário não autorizado.'
                )
              );
            } else {
              toastr.error(error);
            }
          })
          .finally(function () {
            $rootScope.loading = false;
          });
      }

      function getUsersByCompanyIdFn() {
        if (
          !$scope.currentUser ||
          !$scope.currentUser.company ||
          !$scope.currentUser.company.companyId
        ) {
          return;
        }
        $scope.users = [];
        $rootScope.loading = true;
        UserFactory.getAllUsersByCompanyId($scope.currentUser.company.companyId)
          .then(function (response) {
            $scope.users = response.data;
            $scope.$apply();
          })
          .catch(function (error) {
            if (error.status == 403) {
              toastr.error(
                $translationService.getTranslationController(
                  'Usuario no autorizado.',
                  'Unauthorized User.',
                  'Usuário não autorizado.'
                )
              );
            } else {
              toastr.error(error);
            }
          })
          .finally(function () {
            $rootScope.loading = false;
          });
      }

      $scope.changeResource = function (resourceId) {
        var resource = $scope.originResources.find(function (_item) {
          return _item.id == resourceId;
        });
        if(!resource) return;

        $scope.originActions = resource.permissions
      }
        
      $scope.addRule = function () {
        if (
          ((angular.isUndefined($scope.rule.users) ||
            $scope.rule.users.length == 0) &&
            (angular.isUndefined($scope.rule.groups) ||
              $scope.rule.groups.length == 0)) ||
          $scope.rule.actions.length == 0
        ) {
          return;
        }
        var resource = $scope.originResources.filter(function (_item) {
          return _item.id == $scope.rule.resource;
        });
        var rule = {
          description: $scope.rule.description,
          resource: {
            name: resource[0].name,
            actions: $scope.rule.actions.join(),
            granted: $scope.rule.action,
            entityId: $scope.rule.entityId,
          },
          appliesTo: { users: [], groups: [] },
        };

        if (angular.isDefined($scope.rule.users)) {
          $scope.rule.users.forEach(function (_userId) {
            var user = $scope.users.filter(function (_item) {
              return _item.userId == _userId;
            });
            rule.appliesTo.users.push({
              userId: user[0].userId,
              name: user[0].username,
            });
          });
        }
        if (angular.isDefined($scope.rule.groups)) {
          $scope.rule.groups.forEach(function (_groupId) {
            var group = $scope.groups.filter(function (_item) {
              return _item.id == _groupId;
            });
            rule.appliesTo.groups.push({
              id: group[0].id,
              name: group[0].name,
            });
          });
        }
        $mdDialog.hide(rule);
      };

      $scope.cancel = function (ev) {
        var confirm = $mdDialog
          .confirm()
          .multiple(true)
          .title(
            $translationService.getTranslationController(
              '¿Deseas cancelar?',
              'Do you want to cancel?',
              'Você quer cancelar?'
            )
          )
          .textContent(
            $translationService.getTranslationController(
              '¡Todos los cambios se perderán!',
              'All changes will be lost!',
              'Todas as alterações serão perdidas!'
            )
          )
          .ariaLabel('Cancel-Question')
          .targetEvent(ev)
          .ok(
            $translationService.getTranslationController(
              'Abandonar',
              'Leave',
              'Deixar'
            )
          )
          .cancel(
            $translationService.getTranslationController(
              'Cancelar',
              'Cancel',
              'Cancelar'
            )
          );

        $mdDialog.show(confirm).then(
          function () {
            $mdDialog.cancel();
          },
          function () {}
        );
      };
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('dashboard')
    .controller('AclSearcherController', AclSearcherController);

  AclSearcherController.$inject = [
    '$scope',
    '$state',
    '$rootScope',
    '$interval',
    '$localStorageService',
    '$stateParams',
    '$modal',
    'UserFactory',
    '$http',
    '$log',
    'toastr',
    '$timeout',
    '$mdDialog',
    'LoginFactory',
    'ReportsFactory',
    'translationService',
    'AclFactory',
    '$filter',
    'GroupFactory',
    'ResourceFactory',
  ];

  function AclSearcherController(
    $scope,
    $state,
    $rootScope,
    $interval,
    $localStorageService,
    $stateParams,
    $modal,
    UserFactory,
    $http,
    $log,
    toastr,
    $timeout,
    $mdDialog,
    LoginFactory,
    ReportsFactory,
    $translationService,
    AclFactory,
    $filter,
    GroupFactory,
    ResourceFactory
  ) {
    var vm = this;

    function init() {
      console.log('++++++ AclSearcherController +++++++');
      //Método para realizar traducción
      $translationService.getTranslation($scope, 'acl');

      $rootScope.loading = true;
      GroupFactory.getAllGroups()
        .then(function (response) {
          $scope.groups = response.data;
          $rootScope.loading = false;
          $scope.$apply();
        })
        .catch(function (error) {
          $rootScope.loading = false;
          if (error.status == 403) {
            toastr.error(
              $translationService.getTranslationController(
                'Usuario no autorizado.',
                'Unauthorized User.',
                'Usuário não autorizado.'
              )
            );
          } else {
            toastr.error(error);
          }
        });

      $rootScope.loading = true;
      UserFactory.getAllUsers()
        .then(function (response) {
          $scope.users = response.data.data;
          $rootScope.loading = false;
          $scope.$apply();
        })
        .catch(function (error) {
          $rootScope.loading = false;
          if (error.status == 403) {
            toastr.error(
              $translationService.getTranslationController(
                'Usuario no autorizado para leer usuarios',
                'Unauthorized User to read users.',
                'Usuário não autorizado para ler usuários.'
              )
            );
          } else {
            toastr.error(error);
          }
        });

      $rootScope.loading = true;
      ResourceFactory.getAll()
        .then(function (response) {
          vm.originResources = response.data;
          $rootScope.loading = false;
          $scope.$apply();
        })
        .catch(function (error) {
          $rootScope.loading = false;
          if (error.status == 403) {
            toastr.error(
              $translationService.getTranslationController(
                'Usuario no autorizado.',
                'Unauthorized User.',
                'Usuário não autorizado.'
              )
            );
          } else {
            toastr.error(error);
          }
        });
    }

    init();

    vm.clean = function () {
      vm.users =
        vm.groups =
        vm.resources =
        vm.actions =
        vm.grant =
        vm.policies =
          undefined;
    };

    vm.search = function () {
      $rootScope.loading = true;
      AclFactory.search(
        vm.users,
        vm.groups,
        vm.resources,
        vm.actions,
        vm.grant
      ).then(
        function (response) {
          vm.policies = response;
          $rootScope.loading = false;
        },
        function (error) {
          $rootScope.loading = false;
          if (error.status == 403) {
            toastr.error(
              $translationService.getTranslationController(
                'Usuario no autorizado.',
                'Unauthorized User.',
                'Usuário não autorizado.'
              )
            );
          } else if (error.status == 400) {
            toastr.error(
              $translationService.getTranslationController(
                'Filtro vacio',
                'Empty filter',
                'Filtro vazio'
              )
            );
          } else {
            toastr.error(error);
          }
        }
      );
    };

    vm.getBY = function (_item) {
      var user = '';
      var group = '';
      if (
        angular.isDefined(_item.appliesTo.users) &&
        _item.appliesTo.users.length > 0
      ) {
        user =
          '<span><i class="material-icons">person</i> <strong>' +
          arrayToStringFn(_item.appliesTo.users) +
          '</strong></span>';
      }
      if (
        angular.isDefined(_item.appliesTo.groups) &&
        _item.appliesTo.groups.length > 0
      ) {
        group =
          '<span><i class="material-icons">group</i> <strong>' +
          arrayToStringFn(_item.appliesTo.groups) +
          '</strong></span>';
      }
      return user + '<br>' + group;
    };

    vm.getAction = function (_item) {
      var grant =
        _item.resource.granted == true || _item.resource.granted == 'true'
          ? 'add'
          : 'remove';
      var str =
        '<span><i class="material-icons">' +
        grant +
        '</i> <strong>' +
        _item.resource.actions +
        '</strong></span>';
      return str;
    };

    vm.getFOR = function (_item) {
      var rules = '';
      if (
        angular.isDefined(_item.resource.entityId) &&
        _item.resource.entityId > 0
      ) {
        rules = '#' + _item.resource.entityId;
      }
      var str = '<p><strong>' + _item.resource.name + rules + '</strong></p>';
      return str;
    };

    vm.getCategory = function (_item) {
      return _item.resource.entityId > 0 ? 'SHARE' : 'ACCESS';
    };

    function arrayToStringFn(array) {
      if (angular.isUndefined(array)) {
        return '';
      }
      var tmp = [];
      array.forEach(function (_item) {
        tmp.push(_item.name);
      });
      return tmp;
    }

    $scope._onGoBack = function () {
      $state.go('app.acl');
    };
  }
})();

angular.module("dashboard")
.constant("version", "4.88.0");

(function () {
  "use strict";

  angular.module("dashboard").run(runBlock);

  /** @ngInject */
  function runBlock(
    $window,
    $location,
    $rootScope,
    $state,
    LoginFactory,
    sessionService,
    DashboardService,
    toastr,
    translationService
  ) {
    // keep user logged in after page refresh

    // redirect to login page if not logged in and trying to access a restricted page
    $rootScope.$on("$stateChangeStart", function (event, fromState) {
      var target = false;
      if (fromState.url == "^") {
        target = $location.path();
      }

      var url = $location.absUrl();

      if (url.indexOf("login") < 0 || url.indexOf("/login") < 0) {
        sessionService.checkToken(target);
      }
    });

    $rootScope.$on(
      "$stateChangeError",
      function (event, toState, toParams, fromState, fromParams, error) {
        var url = $location.absUrl();
        console.log("event", event);
        console.log("toState", toState);
        console.log("toParams", toParams);
        console.log("fromState", fromState);
        console.log("fromParams", fromParams);
        console.log("error", error);
        if (angular.isString(error)) {
          event.preventDefault();
          console.log("stateChangeError", error);
          switch (error) {
            case "NotAuthorized":
              if (sessionService.isLogedIn()) {
                //can access to home page but not to the requested page, so redirect to home page
                $state.go("app.home");
                toastr.error(
                  translationService.getTranslationController(
                    "Usuario no autorizado.",
                    "Unauthorized User.",
                    "Usuário não autorizado."
                  ) + "- " + toState.meta.pageTitle
                );
              } else {
                $state.go("login");
              }
              break;
            case "TokenExpired":
              var url = $location.absUrl();
              if (url.indexOf("login") > -1 || url.indexOf("/login") > -1) {
                // console.log('TokenExpired@Logout');
                LoginFactory.Logout();
                $state.go("login");
              }
              break;
            case "NotAccess":
            case "Authenticated":
              fromState.name
                ? $state.go(fromState.name)
                : DashboardService.toHomePage();
              break;
            case "RecoveryPassword":
              $state.go("recoveryPassword");
              break;
            case "HomePageRedirect":
              DashboardService.toHomePage();
              break;
          }
        } else {
          console.log("error@stateChangeError", error);
          // LoginFactory.Logout();
          // $state.go('login');
        }
      }
    );

    $rootScope.$on(
      "$stateChangeSuccess",
      function (event, toState, toParams, fromState, fromParams) {
        var pageTitle = "Regtech Suite";
        if (toState.meta.pageTitle) {
          pageTitle = toState.meta.pageTitle;
        }
        $window.document.title = "Ceptinel - " + pageTitle;
      }
    );
  }
})();

(function () {
  "use strict";

  angular.module("dashboard").config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.html5Mode(true);
    $locationProvider.hashPrefix("#");
    $stateProvider
      .state("login", {
        url: "/login",
        templateUrl: "app/login/login.html",
        controller: "LoginController",
        controllerAs: "login",
        params: {
          id: 0,
          message: null,
        },
        resolve: {
          NotAuthenticated: function ($q, $localStorageService) {
            if ($localStorageService.getItem("currentUser")) {
              return $q.reject("Authenticated");
            }
          },
        },
        meta: { pageTitle: "Login" },
      })
      .state("oauth2", {
        url: "/oauth2/:providerName",
        templateUrl: "app/login/oauth-login.html",
        controller: "OautLoginController",
        controllerAs: "login",
        meta: { pageTitle: "OAuth2" },
      })
      .state("recoveryPassword", {
        url: "/reset/:username/:token",
        templateUrl: "app/login/password-recovery/password-recovery.html",
        controller: "passwordRecoveryController",
        resolve: {
          NotAuthenticated: function ($q, $localStorageService) {
            if ($localStorageService.getItem("currentUser")) {
              return $q.reject("RecoveryPassword");
            }
          },
        },
        meta: { pageTitle: "Recovery Password" },
      })
      .state("app", {
        url: "/",
        abstract: true,
        templateUrl: "app/main/main.html",
        controller: "MainController",
        controllerAs: "main",
        resolve: {
          isAuthenticated: function ($q, $localStorageService) {
            if (!$localStorageService.getItem("currentUser")) {
              return $q.reject("NotAuthorized");
            } else {
              return $q.resolve();
            }
          },
        },
        meta: { pageTitle: "Dashboard" },
      })
      .state("app.home", {
        url: "home",
        views: {
          layoutContent: {
            templateUrl: "app/home/home.html",
            controller: "HomeController",
            controllerAs: "home",
          },
        },
        params: {
          desde: null,
          hasta: null,
        },
        reloadOnSearch: false,
        resolve: {
          isAuthenticated: function ($q, $localStorageService) {
            if (!$localStorageService.getItem("currentUser")) {
              return $q.reject("NotAuthorized");
            } else{
              return $q.resolve();
            }
          }
        },
        meta: { pageTitle: "Dashboard" },
      })
      .state("app.alarmas", {
        url: "alarmas",
        views: {
          layoutContent: {
            templateUrl: "app/alarmas/alarmas.html",
            controller: "AlarmasController",
            controllerAs: "alarmas",
          },
        },
        params: {
          desde: null,
          hasta: null,
          filterBy: null,
          dinamicFilters: null,
        },
        reloadOnSearch: false,
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("event:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Alerts" },
      })
      .state("app.casos", {
        url: "casos/:idCaso",
        views: {
          layoutContent: {
            templateUrl: "app/casos/casos.html",
            controller: "CasosController",
            controllerAs: "casos",
          },
        },
        reloadOnSearch: false,
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("cases:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Cases" },
      })
      ///cases beta ///////////////
      .state("app.cases", {
        url: "cases",
        views: {
          layoutContent: {
            templateUrl: "app/cases/cases.html",
            controller: "CasesController",
            controllerAs: "cases",
          },
        },
        reloadOnSearch: false,
        meta: { pageTitle: "Cases" },
      })
      ///cases beta ///////////////
      .state("app.filtersList", {
        url: "config/filters",
        views: {
          layoutContent: {
            templateUrl: "app/filtros/filters.list.html",
            controller: "FiltersListController",
            controllerAs: "filterList",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("function:read-filter")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Configuration" },
      })
      .state("app.perfiles", {
        url: "perfiles",
        views: {
          layoutContent: {
            templateUrl: "app/perfiles/perfiles.html",
            controller: "PerfilesController",
            controllerAs: "perfiles",
          },
        },
        params: {
          perfil: "",
        },
        meta: { pageTitle: "Profiles" },
      })
      .state("app.profiles", {
        url: "profiles",
        views: {
          layoutContent: {
            templateUrl: "app/profiles/profiles.html",
            controller: "ProfilesController",
            controllerAs: "profiles",
          },
        },
        params: {
          perfil: "",
        },
        meta: { pageTitle: "Profiles" },
      })
      .state("app.credenciales", {
        url: "credenciales",
        views: {
          layoutContent: {
            templateUrl: "app/credenciales/credenciales.html",
            controller: "CredencialesController",
            controllerAs: "credenciales",
          },
        },
        params: {
          perfil: "",
        },
        meta: { pageTitle: "Credentials" },
      })
      .state("app.files-storage", {
        url: "files-storage",
        views: {
          layoutContent: {
            templateUrl: "app/files-storage/storage/files-storage.html",
            controller: "filesStorageController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("files-storage:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Files storage" },
      })
      .state("app.trash-storage", {
        url: "trash-storage",
        views: {
          layoutContent: {
            templateUrl: "app/files-storage/trash/trash-storage.html",
            controller: "trashStorageController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("files-storage:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Files storage" },
      })
      .state("app.system-storage", {
        url: "system-storage",
        views: {
          layoutContent: {
            templateUrl: "app/files-storage/system/system-storage.html",
            controller: "systemStorageController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("files-storage:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Files storage" },
      })
      .state("app.custom-report-storage", {
        url: "custom-report-storage",
        views: {
          layoutContent: {
            templateUrl: "app/files-storage/custom-report/custom-report-storage.html",
            controller: "customReportStorageController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("files-storage:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Custom report storage" },
      })

      .state("app.folder", {
        url: "files-storage/:FolderName",
        params: {
          FolderName: null,
          FolderId: null,
          totalFiles: null,
          goto: null,
        },
        views: {
          layoutContent: {
            templateUrl: "app/files-storage/folder/folderview.html",
            controller: "folderViewController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("files-storage:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Files storage" },
      })
      .state("app.backup", {
        url: "backup",
        params: {},
        views: {
          layoutContent: {
            templateUrl: "app/backup/backup.html",
            controller: "backupController",
            controllerAs: "ctrl",
          },
        },
        resolve: {},
        meta: { pageTitle: "Backup" },
      })
      // .state('app.event-replay', {
      //   url: 'event-replay/:replayId',
      //   params: {
      //     //replayName: null,
      //     replayID: null,
      //   },
      //   views: {
      //     layoutContent: {
      //       templateUrl: 'app/replay/replay.html',
      //       controller: 'ReplayController',
      //       controllerAs: 'ctrl',
      //     },
      //   },
      //   meta: { pageTitle: 'Replay' },
      // })
      .state("app.usuarios", {
        url: "usuarios",
        views: {
          layoutContent: {
            templateUrl: "app/usuarios/users.html",
            controller: "UsersController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("user:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Users" },
      })
      .state("app.audit", {
        url: "audit",
        views: {
          layoutContent: {
            templateUrl: "app/audit/audit.html",
            controller: "AuditController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("audit:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        reloadOnSearch: false,
        meta: { pageTitle: "Audit" },
      })
      .state("app.boveda", {
        url: "boveda",
        views: {
          layoutContent: {
            templateUrl: "app/boveda/boveda.html",
            controller: "BovedaDatosController",
            controllerAs: "bovedaDatos",
          },
        },
        meta: { pageTitle: "Vault" },
      })
      .state("app.rankings", {
        url: "rankings",
        views: {
          layoutContent: {
            templateUrl: "app/rankings/rankings.html",
            controller: "RankingsController",
            controllerAs: "rankings",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("ranking:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Rankings" },
      })
      .state("app.user-tracking", {
        url: "user-tracking",
        views: {
          layoutContent: {
            templateUrl: "app/user-tracking/user-tracking.html",
            controller: "UserTrackingController",
            controllerAs: "userTracking",
          },
        },
        meta: { pageTitle: "User tracking" },
      })
      .state("app.bi-reports", {
        url: "bi-reports",
        views: {
          layoutContent: {
            templateUrl: "app/reports/bi-reports.html",
            controller: "BiReportsController",
            controllerAs: "reportes",
          },
        },
        reloadOnSearch: false,
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("report:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Reports BI" },
      })
      .state("app.schemas", {
        url: "entries/schemas",
        views: {
          layoutContent: {
            templateUrl: "app/schemas/schemas.html",
            controller: "SchemasController",
            controllerAs: "schemas",
          },
        },
        reloadOnSearch: false,
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("schema:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Schemas" },
      })
      .state("app.schemasLists", {
        url: "entries/lists",
        views: {
          layoutContent: {
            templateUrl: "app/lists/schemas-list.html",
            controller: "SchemasListController",
            controllerAs: "schemasList",
          },
        },
        reloadOnSearch: false,
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("list:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Lists" },
      })
      .state("app.inputList", {
        url: "entries/lists/view/:listId",
        params: {
          listId: null,
        },
        views: {
          layoutContent: {
            templateUrl: "app/input-list/inputlist.html",
            controller: "InputListController",
            controllerAs: "inputList",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("list:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Lists" },
      })
      .state("app.tableList", {
        url: "entries/lists/table/:listId?{filters}&{luceneQueryId}",
        params: {
          listId: null,
          filters: null,
          backTo: null,
          luceneQueryId: null,
        },
        views: {
          layoutContent: {
            templateUrl: "app/input-list/table/tableList.html",
            controller: "TableListController",
            controllerAs: "ctrl",
          },
        },
        meta: { pageTitle: "Lists" },
      })
      // .state('app.tableListFiltered', {
      //   url: 'entries/lists/table/:listId?filter={filters}',
      //   params: {
      //     listId: null,
      //   },
      //   views: {
      //     layoutContent: {
      //       templateUrl: 'app/input-list/table/tableList.html',
      //       controller: 'TableListController',
      //       controllerAs: 'tableList',
      //     },
      //   },
      // })
      // Rules routes
      .state("app.rules", {
        url: "rules",
        views: {
          layoutContent: {
            templateUrl: "app/rules/rules.html",
            controller: "RulesController",
            controllerAs: "rules",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("function:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Rules" },
      })
      .state("app.rule-executions", {
        url: "rule/:functionId/executions",
        params: {
          functionId: null,
        },
        views: {
          layoutContent: {
            templateUrl: "app/rules/executions/rule-executions.html",
            controller: "RuleExecController",
            controllerAs: "rule",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("function:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Rule executions" },
      })
      .state("app.rule-schedules", {
        url: "rules/schedules",
        params: {
          functionId: null,
        },
        views: {
          layoutContent: {
            templateUrl: "app/rules/schedules/rule-schedules.html",
            controller: "RulesSchedulesController",
            controllerAs: "rule",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("function:read-schedule")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Rule schedules" },
      })
      // Rule editor routes
      .state("app.rule-editor", {
        url: "rules/editor/{functionId:int}",
        params: {
          functionId: null,
        },
        views: {
          layoutContent: {
            templateUrl: "app/rule-editor/rule-editor.html",
            controller: "RuleEditorController",
            controllerAs: "ruleEditor",
          },
        },
        meta: { pageTitle: "Rule editor" },
      })
      .state("app.rule-editor-version", {
        url: "rules/editor/{functionId:int}/version/{version:int}",
        params: {
          functionId: null,
          version: null,
        },
        views: {
          layoutContent: {
            templateUrl: "app/rule-editor/rule-editor.html",
            controller: "RuleEditorController",
            controllerAs: "ruleEditor",
          },
        },
        meta: { pageTitle: "Rule editor version" },
      })
      .state("app.rule-editor-execution", {
        url: "rules/editor/{functionId:int}/execution/{execution:int}",
        params: {
          functionId: null,
          execution: null,
        },
        views: {
          layoutContent: {
            templateUrl: "app/rule-editor/rule-editor.html",
            controller: "RuleEditorController",
            controllerAs: "ruleEditor",
          },
        },
        meta: { pageTitle: "Rule editor execution" },
      })
      // Realtime rules routes
      .state("app.realtime-rules", {
        url: "rules/realtime",
        params: { realtime: true },
        views: {
          layoutContent: {
            templateUrl: "app/rules/rules.html",
            controller: "RulesController",
            controllerAs: "rules",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("function:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Realtime rules" },
      })
      // Realtime rule editor routes
      .state("app.realtime-rule-editor", {
        url: "rules/realtime/editor/{functionId:int}",
        params: {
          functionId: null,
          realtime: true,
        },
        views: {
          layoutContent: {
            templateUrl: "app/rule-editor/rule-editor.html",
            controller: "RuleEditorController",
            controllerAs: "ruleEditor",
          },
        },
        meta: { pageTitle: "Realtime rules editor" },
      })
      .state("app.realtime-rule-editor-version", {
        url: "rules/realtime/editor/{functionId:int}/version/{version:int}",
        params: {
          functionId: null,
          version: null,
          realtime: true,
        },
        views: {
          layoutContent: {
            templateUrl: "app/rule-editor/rule-editor.html",
            controller: "RuleEditorController",
            controllerAs: "ruleEditor",
          },
        },
        meta: { pageTitle: "Realtime rules editor" },
      })
      .state("app.realtime-rule-editor-execution", {
        url: "rules/realtime/editor/{functionId:int}/execution/{execution:int}",
        params: {
          functionId: null,
          execution: null,
          realtime: true,
        },
        views: {
          layoutContent: {
            templateUrl: "app/rule-editor/rule-editor.html",
            controller: "RuleEditorController",
            controllerAs: "ruleEditor",
          },
        },
        meta: { pageTitle: "Realtime rules editor" },
      })
      // Realtime rule editor v2
      .state("app.realtime-rule-editor-v2", {
        url: "rules/realtime/editor/v2/{functionId:int}",
        params: {
          functionId: null,
          realtime: true,
        },
        views: {
          layoutContent: {
            templateUrl: "app/realtime-rule-editor/realtime-rule-editor.html",
            controller: "RealtimeRuleEditorController",
            controllerAs: "ctrl",
          },
        },
        meta: { pageTitle: "Realtime rules editor v2" },
      })
      // // Series routes
      // .state('app.series', {
      //   url: 'replay/config/series',
      //   views: {
      //     layoutContent: {
      //       templateUrl: 'app/replay/config/series.list.html',
      //       controller: 'SeriesConfigController',
      //       controllerAs: 'ctrl',
      //     },
      //   },
      //   resolve: {
      //     hasPermission: function ($q, PermissionsFactory) {
      //       if (!PermissionsFactory.hasPermission('series:read')) {
      //         return $q.reject('NotAuthorized');
      //       }
      //     },
      //   },
      //   meta: { pageTitle: 'Config series' },
      // })
      // .state('app.replay-list', {
      //   url: 'replay/config/replay',
      //   views: {
      //     layoutContent: {
      //       templateUrl: 'app/replay/config/replay.list.html',
      //       controller: 'ReplayConfigController',
      //       controllerAs: 'ctrl',
      //     },
      //   },
      //   resolve: {
      //     hasPermission: function ($q, PermissionsFactory) {
      //       if (!PermissionsFactory.hasPermission('graphic-report:read')) {
      //         return $q.reject('NotAuthorized');
      //       }
      //     },
      //   },
      //   meta: { pageTitle: 'Replay list' },
      // })
      .state("app.searcher-list", {
        url: "entries/searcher/config",
        views: {
          layoutContent: {
            templateUrl: "app/searcher/config/searcher.list.html",
            controller: "SearcherConfigController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("searcher:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Searcher" },
      })
      .state("app.alert-management", {
        url: "alert-management",
        params: {},
        views: {
          layoutContent: {
            templateUrl: "app/gestion-alertas/gestion-alertas.html",
            controller: "GestionAlertas",
            controllerAs: "ctrl",
          },
        },
        resolve: {},
        meta: { pageTitle: "Alert management" },
      })
      .state("app.acl", {
        url: "access-control-list",
        views: {
          layoutContent: {
            templateUrl: "app/acl/acl.html",
            controller: "AclController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("acl:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Access control list" },
      })
      .state("app.acl-searcher", {
        url: "access-control-list/searcher",
        views: {
          layoutContent: {
            templateUrl: "app/acl/acl-searcher.html",
            controller: "AclSearcherController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("acl:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Acl searcher" },
      })
      .state("app.group-list", {
        url: "group/config",
        views: {
          layoutContent: {
            templateUrl: "app/group/config/group.list.html",
            controller: "GroupConfigController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("group:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Groups" },
      })
      .state("app.issues", {
        url: "issues",
        views: {
          layoutContent: {
            templateUrl: "app/issues/issues.html",
            controller: "issuesController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("issues:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Issues" },
      })
      .state("app.data-conn", {
        url: "connections",
        views: {
          layoutContent: {
            templateUrl: "app/data-conn/data-conn.html",
            controller: "DataConnController",
            controllerAs: "dataConn",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("configuration:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Data connection" },
      })
      .state("app.configuration", {
        url: "configuration",
        views: {
          layoutContent: {
            templateUrl: "app/configuration/configuration.list.html",
            controller: "ConfigurationController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("configuration:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Configuration" },
      })
      // Issues management dashboard routes
      .state("app.dashboard", {
        url: "dashboard/:category/:issue",
        params: {
          filters: null,
        },
        views: {
          layoutContent: {
            templateUrl: "app/dashboard/dashboard.html",
            controller: "DashboardController",
            controllerAs: "ctrl",
            data: {
              css: "app/css/_dashboard.css",
            },
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("issues:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Issue Dashboard" },
      })
      .state("app.dashboard-landing", {
        url: "dashboard/",
        views: {
          layoutContent: {
            templateUrl: "app/dashboard/dashboard.html",
            controller: "DashboardController",
            controllerAs: "ctrl",
            data: {
              css: "app/css/_dashboard.css",
            },
          },
        },
        meta: { pageTitle: "Issues Dashboard" },
      })
      // Docs management dashboard routes
      .state("app.docs", {
        url: "docs",
        views: {
          layoutContent: {
            templateUrl: "app/docs/docs.html",
            controller: "DocsController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("documentation:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Documentation" },
      })
      .state("docs", {
        url: "/docs/:rute",
        params: {
          rute: null,
        },
        templateUrl: "app/docs/docs.html",
        controller: "DocsController",
        controllerAs: "ctrl",
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("documentation:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Documentation" },
      })
      .state("app.graphic-reports", {
        url: "graphic-reports",
        views: {
          layoutContent: {
            templateUrl: "app/reports/graphic-reports.html",
            controller: "GraphicReportsController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("graphic-report:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Graphic Reports" },
      })
      .state("app.charts", {
        url: "charts/",
        views: {
          layoutContent: {
            templateUrl: "app/charts/charts-list.html",
            controller: "chartsListController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("graphic-report:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Graphics" },
      })
      .state("app.chart", {
        url: "chart/:chartId",
        params: {
          chartId: null,
        },
        views: {
          layoutContent: {
            templateUrl: "app/charts/chart-id.html",
            controller: "chartIdController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("graphic-report:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Graphics" },
      })
      .state("app.helpDesk", {
        url: "help-desk/tickets",
        params: {
          chart: null,
        },
        views: {
          layoutContent: {
            templateUrl: "app/help-desk/tickets-list.html",
            controller: "helpDeskController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("help-desk:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Graphics" },
      })
      .state("app.dataManagement", {
        url: "data-management",
        views: {
          layoutContent: {
            templateUrl: "app/data-management/data-management.html",
            controller: "DataManagementController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("data-management:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "data-management" },
      })
      .state("app.schemasTables", {
        url: "data-management/:schemaName",
        params: {
          schemaName: null,
        },
        views: {
          layoutContent: {
            templateUrl: "app/data-management/schemas-tables/schemas-tables.html",
            controller: "SchemasTablesController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("data-management:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "schemas-tables" },
      })
      .state("app.tableData", {
        url: "data-management/:schemaName/:tableName",
        params: {
          schemaName: null,
          tableName: null,
        },
        views: {
          layoutContent: {
            templateUrl: "app/data-management/table-data/table-data.html",
            controller: "TableDataController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("data-management:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "schemas-tables" },
      })
      .state("app.indicators", {
        url: "indicators",
        params: {
          chart: null,
        },
        views: {
          layoutContent: {
            templateUrl: "app/indicators/indicators.html",
            controller: "indicatorsController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("indicators:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Graphics" },
      })
      .state("app.riskview", {
        url: "riskview",
        params: {
          chart: null,
        },
        views: {
          layoutContent: {
            templateUrl: "app/riskview/riskview.html",
            controller: "riskviewController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("riskview:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Graphics" },
      })
      .state("app.custom-reports", {
        url: "custom-report",
        views: {
          layoutContent: {
            templateUrl: "app/custom-reports/custom-reports-home.html",
            controller: "CustomReportsHomeController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("custom-report:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Custom reports" },
      })
      .state("app.custom-report", {
        // url: 'custom-report/:report',
        url: "custom-report/report/:reportId/:report",
        params: {
          filters: null,
          report: null,
          reportId: null,
        },
        views: {
          layoutContent: {
            templateUrl: "app/custom-reports/custom-reports.html",
            controller: "CustomReportsController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("custom-report:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Custom report" },
      })
      .state("app.custom-report-html", {
        // url: 'custom-report/:report',
        url: "custom-report/html/:reportId",
        params: {
          reportId: null,
        },
        views: {
          layoutContent: {
            templateUrl: "app/custom-reports/html-template/html-template.html",
            controller: "HtmlTemplateController",
            controllerAs: "ctrl",
          },
        },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.isSuperUser()) {
              return $q.reject("NotAuthorized");
            }
          },
        },
        meta: { pageTitle: "Custom report HTML" },
      })
      .state("app.security", {
        url: "security",
        views: {
          layoutContent: {
            templateUrl: "app/security/security.html",
            controller: "UsuarioPasswordController",
            controllerAs: "ctrl",
          },
        },
        resolve: {},
        meta: { pageTitle: "User Security" },
      })
      .state("app.tokens-manager", {
        url: "tokens-manager",
        views: {
          layoutContent: {
            templateUrl: "app/tokens-manager/tokens-manager.html",
            controller: "TokensManagerController",
            controllerAs: "ctrl",
          },
        },
        resolve: {},
        meta: { pageTitle: "User tokens-manager" },
        hasPermission: function ($q, PermissionsFactory) {
          if (!PermissionsFactory.isSuperUser()) {
            return $q.reject("NotAuthorized");
          }
        },
      })
      .state("app.external-libraries", {
        url: "external-libraries/:libraryId",
        views: {
          layoutContent: {
            templateUrl: "app/external-libraries/external-libraries.html",
            controller: "ExternalLibrariesController",
            controllerAs: "ctrl",
          },
        },
        meta: { pageTitle: "External libraries" },
        resolve: {
          hasPermission: function ($q, PermissionsFactory) {
            if (!PermissionsFactory.hasPermission("python-library:read")) {
              return $q.reject("NotAuthorized");
            }
          },
        },
      })
      .state("app.ethical-portal-companies", {
        url: "ethical-portal/companies",
        views: {
          layoutContent: {
            templateUrl: "app/ethical-portal/companies/companies.html",
            controller: "EthicalPortalCompaniesController",
            controllerAs: "ctrl",
          },
        },
        resolve: {},
        meta: { pageTitle: "Ethical Portal companies" },
        hasPermission: function ($q, PermissionsFactory) {
          if (!PermissionsFactory.isSuperUser()) {
            return $q.reject("NotAuthorized");
          }
        },
      })
      .state("app.ethical-portal-company", {
        url: "ethical-portal/company",
        views: {
          layoutContent: {
            templateUrl: "app/ethical-portal/company/company.html",
            controller: "EthicalPortalCompanyController",
            controllerAs: "ctrl",
          },
        },
        resolve: {},
        meta: { pageTitle: "Ethical Portal companies" },
        hasPermission: function ($q, PermissionsFactory) {
          if (!PermissionsFactory.isSuperUser()) {
            return $q.reject("NotAuthorized");
          }
        },
      });

    $urlRouterProvider.otherwise("/login");
  }
})();

/* global malarkey:false, moment:false */
(function () {
  'use strict';

  angular
    .module('dashboard')
    .constant('malarkey', malarkey)
    .constant('moment', moment);
})();

(function () {
  'use strict';

  angular.module('dashboard').config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $httpProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // $httpProvider config
    $httpProvider.defaults.withCredentials = true;
    $httpProvider.interceptors.push('SessionInterceptor');

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-center toast-style';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = true;
  }
})();

angular.module("dashboard")
.constant("env", {
  "domain": "10.200.3.236",
  "port": "",
  "ssl": true
});

angular.module("dashboard").run(["$templateCache", function($templateCache) {$templateCache.put("app/acl/acl-searcher.html","<md-card><md-toolbar class=\"white-text main-color\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" ng-click=_onGoBack() class=main-color><md-icon>list_alt</md-icon><md-tooltip md-z-index=9999 md-delay=200>{{translation.get_back}}</md-tooltip></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white text-main-color\"><span>{{translation.ACL}} - {{translation.SEARCH}}</span></h2></div></md-toolbar><form name=\"\" novalidate><section layout=row layout-padding=\"\" layout-wrap=\"\" style=\"margin-top: 10px\"><div flex=50><md-input-container class=w100><label>{{translation.USERS}}</label><md-select ng-model=ctrl.users placeholder=User multiple><md-option ng-value=item.userId ng-repeat=\"item in users\">{{item.fullName}} ({{item.profile.type}})</md-option></md-select></md-input-container></div><div flex=50><md-input-container class=w100><label>{{translation.GROUPS}}</label><md-select ng-model=ctrl.groups placeholder=Group multiple><md-option ng-value=item.id ng-repeat=\"item in groups\">{{item.name}}</md-option></md-select></md-input-container></div><div flex=50><md-input-container class=w100><label>{{translation.RESOURCES}}</label><md-select ng-model=ctrl.resources placeholder=Resource multiple><md-option ng-value=option.name ng-repeat=\"option in ctrl.originResources\">{{option.name}}</md-option></md-select></md-input-container></div><div flex=50><md-input-container class=w100><label>{{translation.ACTIONS}}</label><input type=text ng-model=ctrl.actions placeholder=\"create, read, update, delete, etc\" md-maxlength=30 maxlength=30></md-input-container></div><div flex=50><md-input-container class=w100><label>{{translation.GRANT}}</label><md-select ng-model=ctrl.grant placeholder=Grant><md-option ng-value=\"\">None</md-option><md-option ng-value=true>Allow</md-option><md-option ng-value=false>Deny</md-option></md-select></md-input-container></div></section><section layout=row layout-padding=\"\" layout-wrap=\"\" layout-align=\"end center\"><div><md-button aria-label=CLEAN ng-click=ctrl.clean() class=\"md-raised red white-text pull-right\"><md-icon md-font-set=material-icons md-menu-align-target class=white-text>format_clear</md-icon>clean</md-button></div><div><md-button aria-label=SEARCH ng-click=ctrl.search() ng-disabled=loading class=\"md-raised pull-right\"><md-icon md-font-set=material-icons md-menu-align-target>search</md-icon>search</md-button></div></section><section layout=row layout-padding=\"\"><div flex=100><table class=table><thead><tr><th width=20%>{{translation.DESCRIPTION}}</th><th width=25%>{{translation.BY}}</th><th width=20%>{{translation.RESOURCE}}</th><th width=25%>{{translation.ACTION}}</th><th width=10%>{{translation.CATEGORY}}</th></tr></thead><tbody><tr ng-repeat=\"item in ctrl.policies track by $index\"><td>{{item.description}}</td><td ng-bind-html=ctrl.getBY(item)></td><td ng-bind-html=ctrl.getFOR(item)></td><td ng-bind-html=ctrl.getAction(item)></td><td ng-bind-html=ctrl.getCategory(item)></td></tr></tbody></table></div></section></form></md-card>");
$templateCache.put("app/acl/acl.html","<div class=\"bs-component sticky-parent\"><md-card><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler ng-if=!ctrl.editActive layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-acl scale=2></cep-icon></md-toolbar-filler><md-toolbar-filler ng-if=ctrl.editActive layout=row layout-align=\"center center\" ng-click=\"ctrl.editActive = false\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-acl scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>{{ translation.ACL }}</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button href=access-control-list/searcher aria-label=buscador class=\"pull-right md-raised\"><md-icon md-font-set=material-icons md-menu-align-target>search</md-icon>Buscador</md-button><md-button has-permission=acl:create ng-click=\"noBusqueda = true; ctrl.habilitarCrear()\" aria-label=\"{{ translation.CREAR }}\" class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>{{ translation.CREATE }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></md-toolbar-filler></div></md-toolbar><ng-table-dynamic id=acl-table ng-show=!ctrl.editActive config=ctrl.config show-top-bar=true show-filter-button=true show-refresh-button=true show-export-csv-button=false show-export-json-button=true show-import-json-button=true on-click=ctrl.availableEdit on-delete-row=ctrl.removeAcl on-export-row=ctrl.exportRow on-import=ctrl.importedData></ng-table-dynamic><md-card style=\"padding-top: 20px\" ng-show=ctrl.editActive class=m0><input id=uploadacl hidden type=file rule-importer rule-imported-data=ctrl.importedData multiple accept=.json style=\"display: none\"><form name=aclForm novalidate><section layout=row layout-padding=\"\" layout-wrap=\"\"><div flex=50><md-input-container class=\"w100 m0\"><label>{{ translation.NAME }}</label><input type=text ng-model=ctrl.acl.name md-maxlength=50 maxlength=50 ng-disabled=\"ctrl.botonesDeAccion.guardar &amp;&amp; (ctrl.acl.category == &quot;SHARE&quot; || ctrl.acl.category == &quot;OWNER&quot;)\" required></md-input-container></div><div flex=10><md-checkbox ng-model=ctrl.acl.active ng-checked=false ng-disabled=!ctrl.editActive md-no-ink aria-label=acl-checkbox>{{ translation.ACTIVE }}</md-checkbox></div><div flex=40><md-input-container class=\"w100 m0\"><label>{{ translation.CATEGORY }}</label><input type=text ng-model=ctrl.acl.category ng-disabled=true></md-input-container></div></section><section layout=row layout-padding=\"\" layout-wrap=\"\"><div flex=100><md-input-container class=\"w100 m0\"><label>{{ translation.DESCRIPTION }}</label><input type=text ng-model=ctrl.acl.description md-maxlength=100 maxlength=100 ng-disabled=!ctrl.editActive></md-input-container></div></section><section layout=row layout-padding=\"\" layout-wrap=\"\"><div flex=50><md-button type=button ng-click=ctrl.clearForm() class=\"md-raised red white-text\"><md-icon md-font-set=material-icons md-menu-align-target class=white-text>keyboard_return</md-icon>{{ translation.cancel_get_back }}</md-button></div><div flex=50 class=text-right><md-button has-permission=acl:create type=button ng-disabled=\"aclForm.$invalid || loading\" ng-if=ctrl.botonesDeAccion.crear ng-click=ctrl.createAcl() class=md-raised><md-icon md-font-set=material-icons md-menu-align-target>create_new_folder</md-icon>{{ translation.CREATE }}</md-button><md-button has-permission=acl:update type=button ng-disabled=\"aclForm.$invalid || loading || ctrl.acl.category == &quot;OWNER&quot;\" ng-if=ctrl.botonesDeAccion.guardar ng-click=ctrl.updateAcl() class=\"md-raised green white-text\"><md-icon md-font-set=material-icons md-menu-align-target class=white-text>save</md-icon>{{ translation.SAVE }}</md-button><md-button has-permission=acl:update type=button ng-disabled=\"ctrl.acl.category == &quot;OWNER&quot;\" ng-click=ctrl.showCreateRuleDialog() class=\"md-raised blue white-text\"><md-icon md-font-set=material-icons md-menu-align-target class=white-text>add</md-icon>Add Rule</md-button><md-button ng-click=ctrl.inputUpload() ng-if=ctrl.botonesDeAccion.import class=\"md-raised grey white-text\"><md-icon md-font-set=material-icons>file_upload</md-icon>{{ translation.IMPORT }}</md-button></div></section></form><section layout=row layout-padding=\"\"><md-content flex=100><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"{{ translation.POLICIES }}\" md-on-select=ctrl.loadPolicies(ctrl.myPoliciesJson);><table class=table><thead><tr><th>{{ translation.DESCRIPTION }}</th><th>{{ translation.BY }}</th><th>{{ translation.ACTIONS }}</th><th>{{ translation.RESOURCE }}</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in ctrl.acl.policies track by $index\"><td>{{ item.description }}</td><td ng-bind-html=ctrl.getBY(item)></td><td ng-bind-html=ctrl.getAction(item)></td><td ng-bind-html=ctrl.getFOR(item)></td><td><md-button has-permission=acl:update ng-if=\"ctrl.acl.category != &quot;OWNER&quot;\" type=button ng-click=\"ctrl.removePolicy($event, $index)\" class=\"md-raised md-warn\">remove</md-button></td></tr></tbody></table></md-tab></md-tabs></md-content></section></md-card></md-card></div>");
$templateCache.put("app/acl/dialog-create-rule.html","<md-dialog aria-label=\"{{ translation.add_schema }}\" style=\"width: 800px\"><form name=ruleForm novalidate><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ actionText }}</h2><span flex></span><md-button ng-click=cancel($event) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding-top: 10px\"><form name=ruleForm novalidate><section layout=row layout-padding=\"\"><div flex=60><md-input-container class=\"w100 m0\"><label>Description</label><input type=text ng-model=rule.description md-maxlength=30 maxlength=30 required></md-input-container><section layout=row layout-padding=\"\" layout-wrap=\"\" style=\"border-bottom: dashed 1px solid #eaeaea\"><div flex=20><h4>BY *</h4></div><div flex=80 layout=column layout-padding=\"\" layout-wrap=\"\"><md-input-container class=\"w100 m0\"><md-select ng-model=rule.users placeholder=User multiple><md-option ng-value=item.userId ng-repeat=\"item in users | orderBy:&quot;fullName&quot;\">{{ item.fullName }} ({{ item.profile.type }})</md-option></md-select></md-input-container><md-input-container class=\"w100 m0\"><md-select ng-model=rule.groups placeholder=Group multiple><md-option ng-value=item.id ng-repeat=\"item in groups | orderBy:&quot;name&quot;\">{{ item.name }}</md-option></md-select></md-input-container></div></section></div><div flex=40 class=\"grey lighten-4\"><h4>ACTION</h4><md-input-container class=\"w100 m0\"><label>Resource</label><md-select ng-model=rule.resource ng-change=changeResource(rule.resource) required><md-option ng-value=option.id ng-repeat=\"option in originResources\">{{ option.name }}</md-option></md-select></md-input-container><md-input-container ng-if=\"itemSelected.category == &quot;SHARE&quot;\" md-no-float=\"\" class=w100><input type=text ng-model=rule.entityId placeholder=\"Entity Id\" md-maxlength=30 maxlength=30 required></md-input-container><br><br><md-radio-group ng-model=rule.action layout=row><md-radio-button value=true class=md-primary>{{ translation.allow }}</md-radio-button><md-radio-button value=false>{{ translation.deny }}</md-radio-button></md-radio-group><br><br><md-input-container class=\"w100 m0\"><label>Actions</label><md-select ng-model=rule.actions multiple required><md-option ng-value=option ng-repeat=\"option in originActions\">{{ option }}</md-option></md-select></md-input-container></div></section></form></md-dialog-content><md-dialog-actions><md-button ng-click=cancel($event)>Cancel</md-button><md-button ng-click=addRule() ng-disabled=ruleForm.$invalid>Add Rule</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/alarmas/alarmas.1.html","<md-toolbar class=main-color><div class=md-toolbar-tools><h2 flex=\"\" md-truncate=\"\">Alerts</h2></div></md-toolbar><md-card class=m0><div layout=row ng-show=\"alarmas.isSet(\'index\')\"><div flex=100><ng-table-dynamic_2 id=alerts-table fn-config=alarmas.initGrid selected-items=alarmas.selectedItems on-add-events-to-case=alarmas.addEventsToCaseId with-multiple-selection=alarmas.isTableWithMultipleSelection show-top-bar=true show-workspaces-button=true show-filter-button=true show-auto-refresh-button=true show-export-csv-button=true show-ranking-button=true on-click=alarmas.checkEvent on-dbl-click=alarmas.crearTabDetalleAlerta></ng-table-dynamic_2></div></div><div layout=row ng-repeat=\"tab in tabs\" ng-if=\"tab.id!=\'index\'\" ng-show=\"tab.id!=\'index\' &amp;&amp; alarmas.isSet(tab.id)\"><div flex=100 class=\"critic _{{tab.alert.criticality}}\"></div></div></md-card>");
$templateCache.put("app/alarmas/alarmas.html","<div class=\"bs-component sticky-parent\"><md-card><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-events scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=md-toolbar-tools><span>{{ translation.ALERTAS }}</span></h2></div></md-toolbar><tabs-bar tabs=tabsAlerts is-active=alarmas.isActive set-tab=alarmas.setTab del-tab=alarmas.eliminarTabAlerta></tabs-bar><section layout=row ng-show=alarmas.isSet(&quot;index&quot;)><div flex=100><ng-table-dynamic_2 id=alerts-table fn-config=alarmas.initGrid selected-items=alarmas.selectedItems on-add-events-to-case=alarmas.addEventsToCaseId with-multiple-selection=alarmas.isTableWithMultipleSelection show-top-bar=true show-workspaces-button=true show-filter-button=true show-auto-refresh-button=true show-export-csv-button=true show-ranking-button=true on-click=alarmas.checkEvent on-dbl-click=alarmas.crearTabDetalleAlerta></ng-table-dynamic_2></div></section><section ng-repeat=\"tab in tabsAlerts\" ng-if=\"tab.id!=&quot;index&quot;\" ng-show=\"tab.id!=&quot;index&quot; &amp;&amp; alarmas.isSet(tab.id)\"><md-toolbar style=\"padding: 30px 0\" class=\"critic _{{tab.alert.criticality}}\"><div class=md-toolbar-tools><div flex=20><h3>{{ translation.CRITICIDAD }}: {{ tab.alert.criticality }}</h3><h2><b>{{ tab.alert.id }}</b></h2></div><div flex=\"\"><h4>{{ tab.alert.ruleDescription }}</h4><h4>{{ translation.FECHA_EMISION }}: {{ tab.alert.moment.format(\'DD/MM/YYYY HH:mm:ss\') + \', \' + tab.alert.moment.fromNow() }}</h4></div><div flex=10><md-button ng-disabled=!alarmas.validatePermission() ng-click=\"alarmas.crearCaso($event, tab.alert)\" class=\"md-raised md-warn\"><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon>{{ translation.CREAR_CASO }}</md-button></div></div></md-toolbar><md-toolbar style=\"background-color: #424040\"><div class=md-toolbar-tools><h2 flex=\"\" md-truncate=\"\">{{ translation.PARAMETROS }}</h2></div></md-toolbar><article layout=row layout-padding=\"\"><div flex=100><table class=\"table table-striped table-hover\"><thead><tr><th>{{ translation.NOMBRE }}</th><th>{{ translation.VALOR }}</th></tr></thead><tbody><tr ng-repeat=\"(key, value) in tab.alert.eventBody\"><td>{{ key }}</td><td ng-bind-html=value></td></tr></tbody></table></div></article><section ng-if=\"tab.alert.events.length &gt; 0\"><md-toolbar style=\"background-color: #424040\"><div class=md-toolbar-tools><h2 flex=\"\" md-truncate=\"\">{{ translation.EVENTOS_RELACIONADOS }}</h2></div></md-toolbar><article layout=row layout-padding=\"\"><div flex=100><ul class=list-eventos><li ng-repeat=\"event in tab.alert.events\" class=\"item-evento panel\"><div class=panel-heading><h3 class=\"panel-title text-capitalize\">{{ event.tipo }} {{ event.id }}</h3><span>{{ translation.CRITICIDAD }}: {{ event.criticality }} / {{ translation.FECHA }}: {{ event.timestamp | asDateHour }}</span></div><div class=panel-body><div class=evento-block></div><ul><li ng-repeat=\"(key, value) in event.eventBody\"><span>{{ key }}: {{ value }}</span></li></ul></div></li></ul></div></article></section></section></md-card></div>");
$templateCache.put("app/alarmas/modal-workspaces.html","<div tabindex=-1 role=dialog class=modal><div class=\"modal-dialog modal-lg\"><div class=modal-content><div class=modal-header><a type=button abm-component ng-click=$hide() class=close>×</a><h4 class=\"modal-title small-header\">{{ translation.Workspaces }}: {{ctrl.config.workspaces.selected.workspaceName}}</h4></div><div class=modal-body><div ng-cloak=\"\"><md-content><div layout=row layout-align=\"center center\"><md-select placeholder=\"Function Selector\" ng-model=ctrl.selectedFunction multiple style=\"min-width: 90%\"><md-option ng-value=option ng-repeat=\"option in ctrl.config.functions\">{{option.name}})</md-option></md-select><md-button title={{translation.SEND_MSG}} ng-click=ctrl.getColumnData() ng-disabled=\"ctrl.loading || !ctrl.selectedFunction\" class=\"md-fab md-mini\"><md-icon md-font-set=material-icons class=\"md-icon-button md-secondary md-hue-3\">search</md-icon></md-button></div><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-autoselect=true><md-tab ng-repeat=\"schema in ctrl.config.workspaces.items\" ng-click=\"alert(\'label\')\" label={{schema.workspaceName}}><md-content class=md-padding><div layout=row layout-align=\"start start\" layout-wrap><div ng-repeat=\"(key, item) in schema.workspaceSchema.columns\" flex=100 flex-gt-sm=33 ng-if=!item.hidden><md-checkbox ng-model=item.show aria-label=\"{{ item.title }}\"><span>{{ translation[item.title] || item.title }}&nbsp;</span></md-checkbox></div></div><div layout=row layout-align=\"start start\" layout-wrap class=pull-right><md-button ng-click=ctrl.applySchema(schema) ng-disabled=ctrl.loading class=\"md-raised md-warn\">{{ translation.apply_schema }}</md-button><md-button ng-click=ctrl.setDefaultSchema(schema) class=md-raised>{{ translation.set_defaults }}</md-button><!--md-button(class=\"md-primary md-raised\" ng-click=\"ctrl.saveSchema(schema)\") {{ translation.Save_changes }}--></div></md-content></md-tab></md-tabs></md-content></div></div></div></div></div>");
$templateCache.put("app/alarmas/modal.alarmas-crear-caso.html","<div tabindex=-1 role=dialog class=modal><div class=modal-dialog><div class=modal-content><div class=modal-header><a type=button abm-component ng-click=$hide() class=close>×</a><h4 class=modal-title>{{translation.CREAR_CASO}} - {{translation.INCIDENCIA}} {{ alertaId }}</h4></div><div class=modal-body><div><div ng-if=\"alerta.casosLink &amp;&amp; alerta.casosLink.length&gt;0\" class=row><div class=col-xs-12><div class=\"panel panel-warning\"><div class=panel-heading><h3 class=panel-title><i class=icon-notifications></i>{{translation.ALERTA_TIENE_ASOCIADOS}}</h3></div></div></div></div><div ng-if=validacion.show class=row><div class=col-xs-12><div class=\"panel panel-primary\"><div class=panel-heading><h3 class=panel-title><i class=icon-notifications></i>{{validacion.content}}</h3></div></div></div></div></div><form name=newCaseForm novalidate><abm-form-group><label data-abm-label=\"\">{{translation.NOMBRE}}</label><input type=text ng-model=nombre required ng-change=\"inputChange(&quot;nombre&quot;, nombre)\" abm-form-control=\"\" placeholder={{translation.NOMBRE_CASO}} class=form-control></abm-form-group><abm-form-group><label for=select data-abm-label=\"\" class=\"control-label label-static\">{{translation.CRITICIDAD}}</label><div><select id=select ng-model=criticidad required ng-change=\"inputChange(&quot;criticidad&quot;, criticidad)\" class=form-control><option value=Alta>{{translation.ALTA}}</option><option value=Media>{{translation.MEDIA}}</option><option value=Baja>{{translation.BAJA}}</option></select></div></abm-form-group><abm-form-group><label data-abm-label=\"\">{{translation.EJECUTIVO}}</label><input type=text readonly required ng-model=ejecutivo abm-form-control=\"\" placeholder={{translation.EJECUTIVO}} class=form-control></abm-form-group><abm-form-group><label data-abm-label=\"\">{{translation.DESCRIPCION}}</label><textarea rows=4 ng-model=descripcion required ng-change=\"inputChange(&quot;descripcion&quot;, descripcion)\" class=form-control></textarea></abm-form-group></form><form action=\"\" ng-if=hasAlert><div class=row><div class=col-xs-8><div class=row><div class=col-xs-12><div class=\"panel panel-primary\"><div class=panel-heading><h3 class=panel-title>{{alerta.tipo + \' \' + alerta.id}}</h3></div><div class=panel-body><div class=row-block><div label class=col-block>{{translation.FECHA}}:</div><div data class=col-block>{{alerta.fecha}}</div></div><div class=row-block><div label class=col-block>{{translation.HORA}}:</div><div data class=col-block>{{alerta.hora}}</div></div><div class=row-block><div label class=col-block>{{translation.TIPO}}:</div><div data class=col-block>{{alerta.tipo}}</div></div><div class=row-block><div label class=col-block>{{translation.CRITICIDAD}}:</div><div data class=col-block>{{alerta.criticidad}}</div></div><div class=row-block></div></div></div></div></div></div></div></form></div><div class=modal-footer><div class=row><div class=col-md-12><div ng-show=casoCreado class=\"alert alert-dismissible alert-success text-center\">{{translation.CASO_EXITOSO}}.</div></div><div ng-hide=caseProcessing class=col-md-12><button type=button ng-click=$hide() class=\"btn btn-default\">{{translation.CANCELAR}}</button> <button type=button ng-click=createCase() ng-disabled=newCaseForm.$invalid class=\"btn btn-primary\">{{translation.CREAR_CASO}}</button></div></div></div></div></div></div><script>$(\'select\').dropdown({ \"autoinit\" : \".select\" });</script>");
$templateCache.put("app/alarmas/ngtable-dynamic.html","<div layout=column ng-cloak=\"\" style=\"min-height: 400px\"><script id=headerCheckbox.html type=text/ng-template><input type=\"checkbox\" ng-model=\"ctrl.selectedItems.checked\" value=\"\" style=\"width: 18px; height: 18px\"></script><ng-include src=\"\'app/alarmas/sidenav-workspace.html\'\"></ng-include><md-card-content><div ng-if=ctrl.showTopBar><div layout=row layout-align=\"space-between center\"><div><md-button ng-show=ctrl.showFilterButton style=\"margin: 0px\" aria-label=filter_list ng-click=\"shouldShowFilters = !shouldShowFilters\"><md-icon md-font-set=material-icons class=\"md-icon-button md-secondary\">filter_list</md-icon><span>Filters</span></md-button></div><div md-position-mode=\"target-right target\"><label>{{ ctrl.labelRowsTotal }}</label><md-menu ng-if=\"ctrl.showExportCsvButton || ctrl.showRefreshButton || ctrl.showAutoRefreshButton\"><md-button aria-label=More ng-click=$mdMenu.open() class=md-icon-button><md-icon md-font-set=material-icons class=\"md-icon-button md-secondary\">more_vert</md-icon></md-button><md-menu-content width=2 ng-mouseleave=$mdMenu.close()><md-menu-item ng-if=ctrl.showWorkspacesButton><md-button ng-click=ctrl.onRefresh()>{{ translation.REFRESH }}</md-button></md-menu-item><md-menu-item ng-if=ctrl.showAutoRefreshButton><md-button ng-click=ctrl.toogleAutoRefresh()>{{ translation.automatic_refresh }}<md-icon md-font-set=material-icons ng-show=ctrl.autoRefresh>done</md-icon></md-button></md-menu-item><md-menu-item ng-if=ctrl.showWorkspacesButton><md-button ng-click=ctrl.openWorkspacesForm()>Workspaces</md-button></md-menu-item><md-menu-item ng-if=ctrl.showRankingButton><md-button ng-click=ctrl.goToRankings()>Rankings</md-button></md-menu-item><md-menu-item ng-if=ctrl.showExportCsvButton><md-button ng-click=ctrl.onExportCsv()>{{ translation.EXPORT }}</md-button></md-menu-item><md-menu-item ng-if=ctrl.showRefreshButton><md-button ng-click=ctrl.onRefresh()>{{ translation.REFRESH }}</md-button></md-menu-item><md-menu-item ng-if=\"ctrl.withMultipleSelection()==true &amp;&amp; ctrl.selectedItems.items\"><md-button ng-click=ctrl.onAddEventsToCase()>{{ translation.ADD_EVENTS_TO_CASE }}</md-button></md-menu-item><md-menu-item ng-if=\"ctrl.withMultipleSelection()==true\"><md-button ng-click=ctrl.onGoBack()>{{ translation.get_back }}</md-button></md-menu-item></md-menu-content></md-menu></div></div><div ng-if=shouldShowFilters layout=column style=\"border: 1px #dedede solid; padding: 0px 10px 10px 10px\"><div layout=row layout-xs=column layout-wrap><div ng-repeat=\"item in ctrl.config.columns\" ng-if=\"item.metadata &amp;&amp; item.filterable &amp;&amp; item.metadata.type!=\'date\' &amp;&amp; item.metadata.type!=\'timestamp\' \"><div class=dropdown><md-button id=dropdown{{item.field}} style=\"border: 0px solid gray; margin-bottom: 0px\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=true ng-class=\"{ &quot;filter-active&quot; : ctrl.isFilterChange(item) }\" class=\"md-raised btn dropdown-toggle\">{{ translation[item.title] || item.title }}<span style=\"margin-left: 5px\" class=caret></span></md-button><ul style=\"width: 280px\" class=dropdown-menu><div ng-if=\"item.filterType==\'autocomplete\'\"><md-autocomplete style=\"margin: 0px\" md-input-name=autocompleteField placeholder=\"{{ translation.BUSCAR }}\" md-no-cache=false md-selected-item=ctrl.filters[item.field] md-search-text=searchText md-items=\"text in ctrl.querySearchAutocomplete(searchText, item.metadata.name)\" md-item-text=text md-min-length=0 md-clear-button=true><md-item-template><span md-highlight-text=searchText>{{ text }}</span></md-item-template><md-not-found>Without results for \"{{ searchText }}\".</md-not-found></md-autocomplete></div><div ng-if=\"item.filterType==\'input\'\" style=\"padding: 5px\"><div ng-if=\"item.metadata.type===\'integer\'\"><li style=\"width: 95%\" class=input-group>Min <input type=text minlength=1 onkeypress=\"return event.charCode &gt;= 48 &amp;&amp; event.charCode &lt;= 57\" placeholder=\"{{ translation.BUSCAR }}\" ng-model=ctrl.filters[item.field].min class=form-control></li><li style=\"width: 95%\" class=input-group>Max <input type=text minlength=1 onkeypress=\"return event.charCode &gt;= 48 &amp;&amp; event.charCode &lt;= 57\" placeholder=\"{{ translation.BUSCAR }}\" ng-model=ctrl.filters[item.field].max class=form-control></li></div><div ng-if=\"item.metadata.type===\'double\'\"><li style=\"width: 95%\" class=input-group>Min <input type=number min=0 placeholder=\"{{ translation.BUSCAR }}\" ng-model=ctrl.filters[item.field].min class=form-control></li><li style=\"width: 95%\" class=input-group>Max <input type=number min=0 placeholder=\"{{ translation.BUSCAR }}\" ng-model=ctrl.filters[item.field].max class=form-control></li></div><div ng-if=\"item.metadata.type===\'string\'\" style=\"width: 95%\"><input type=text ng-model=ctrl.filters[item.field] class=form-control></div></div><div flex style=\"width: 100%\" ng-if=\"item.filterType==\'select\'\"><li class=input-group><input type=text placeholder=\"{{ translation.BUSCAR }}\" ng-model=ctrl.searchTerm class=form-control><div class=input-group-addon><i class=\"glyphicon glyphicon-search\"></i></div></li><li role=separator class=divider></li><li ng-repeat=\"option in item.metadata.values | filter: ctrl.searchTerm\" value=\"{{ option.id }}\" class=input-group><div class=input-group-addon><input type=checkbox ng-model=ctrl.filters[item.field][option.id] style=\"width: 18px; height: 18px\"></div><span style=\"width: 95%; height: 60px; border: none\" class=\"form-control text-capitalize\">{{ option.value }}</span></li></div><div flex style=\"width: 100%\" ng-if=\"item.filterType==\'simple-select\'\"><li class=input-group><input type=text placeholder=\"{{ translation.BUSCAR }}\" ng-model=ctrl.searchTerm class=form-control><div class=input-group-addon><i class=\"glyphicon glyphicon-search\"></i></div></li><li role=separator class=divider></li><li ng-repeat=\"option in item.metadata.values | filter: ctrl.searchTerm\" value=\"{{ option.id }}\" class=input-group><div class=input-group-addon><input type=radio name=myRadio ng-model=ctrl.filters[item.field] value=\"{{ option.id }}\" style=\"width: 18px; height: 18px\"></div><span style=\"width: 95%; height: 60px; border: none\" class=\"form-control text-capitalize\">{{ option.value }}</span></li></div></ul></div></div></div><div layout=row layout-align=\"end start\" layout-wrap style=\"margin-top: 20px\"><md-button ng-click=ctrl.cleanFilter() class=md-raised>{{ translation.CLEAN }}</md-button><md-button ng-click=ctrl.applyFilters() class=cep-background>{{ translation.APPLY_FILTERS }}</md-button></div></div></div><md-progress-linear ng-hide=ctrl.loadedCaseTable></md-progress-linear><md-content layout-padding=\"\"><table ng-table-dynamic=\"ctrl[ctrl.id] with ctrl.config.columns\" class=\"table table-condensed table-bordered table-hover\"><colgroup><col ng-repeat=\"col in ctrl.config.columns\" width={{col.width}}%></colgroup><tr ng-repeat=\"item in $data track by $index\" ng-class=ctrl.config.style.trStyle(item) ng-dblclick=ctrl.onDblClick(item)><td ng-repeat=\"itemCol in ctrl.config.columns\" ng-if=itemCol.show title=\"{{ item.eventBody }}\" sortable><span ng-switch on=itemCol.type><div ng-switch-when=checkbox><input type=checkbox ng-model=ctrl.selectedItems.items[item.id] aria-label=\"Select Event\" style=\"width: 18px; height: 18px\"></div><div ng-switch-when=date ng-click=ctrl.onClick(item)>{{ item[itemCol.col] | asDateHour }}</div><div ng-switch-when=time ng-click=ctrl.onClick(item)>{{ item[itemCol.col] | asHour }}</div><div ng-switch-when=datetime ng-click=ctrl.onClick(item)>{{ item[itemCol.col] | asDateHour }}</div><div ng-switch-when=object ng-click=ctrl.onClick(item)>{{ item[itemCol.col][itemCol.key] }}</div><div ng-switch-when=integer ng-click=ctrl.onClick(item)>{{ item[itemCol.col] }}</div><div ng-switch-when=command><md-icon md-font-set=material-icons ng-click=ctrl.onDeleteRow(item)>delete</md-icon></div><div ng-switch-default ng-click=ctrl.onClick(item)>{{ item[itemCol.col] | capitalize }}</div></span></td></tr></table></md-content></md-card-content></div>");
$templateCache.put("app/alarmas/sidenav-workspace.html","<md-sidenav md-component-id=workspace-event style=max-height:600px;left:20px;top:10px;width:100%;max-width:50% class=md-sidenav-left><md-toolbar class=md-theme-left><h1 class=md-toolbar-tools>{{ translation.Workspaces }}: {{ctrl.config.workspaces.selected.workspaceName}}</h1></md-toolbar><md-content layout-padding><div layout=row layout-align=\"start center\"><md-select placeholder=\"Function Selector\" ng-model=ctrl.selectedFunctions multiple flex=70><md-option ng-value=option ng-repeat=\"option in ctrl.config.functions\">{{option.name}}</md-option></md-select><md-button title={{translation.SEND_MSG}} ng-click=ctrl.getColumnData() ng-disabled=\"ctrl.loading || !ctrl.selectedFunctions\" class=\"md-fab md-mini\"><md-icon md-font-set=material-icons class=\"md-icon-button md-secondary md-hue-3\">search</md-icon></md-button></div><md-tabs md-dynamic-height=\"\" md-border-bottom md-autoselect md-swipe-content md-selected=ctrl.selectedIndex><md-tab ng-repeat=\"schema in ctrl.config.workspaces.items\" ng-click=\"alert(\'label\')\" label=\"{{translation[schema.workspaceName] || schema.workspaceName}}\"><md-content class=md-padding><div layout=row layout-align=\"start start\" layout-wrap ng-if=\"schema.workspaceName == \'DEFAULT\'\"><div ng-repeat=\"item in schema.workspaceSchema.columns\" flex=100 flex-gt-sm=33><md-checkbox ng-model=item.show aria-label=\"{{ item.title }}\" disabled><span>{{ translation[item.title] || item.title }}&nbsp;</span></md-checkbox></div></div><div layout=row layout-align=\"start start\" layout-wrap ng-if=\"schema.workspaceName == \'CURRENT_VIEW\'\"><div ng-repeat=\"item in schema.workspaceSchema.columns\" flex=100 flex-gt-sm=33><md-checkbox ng-model=item.show aria-label=\"{{ item.title }}\"><span>{{ translation[item.title] || item.title }}&nbsp;</span></md-checkbox></div></div><div layout=row layout-align=\"start start\" layout-wrap ng-if=\"schema.workspaceName != \'CURRENT_VIEW\' &amp;&amp; schema.workspaceName != \'DEFAULT\'\"><div ng-repeat=\"item in schema.workspaceSchema.columns\" flex=100 flex-gt-sm=33 ng-if=!item.hidden><md-checkbox ng-model=item.show aria-label=\"{{ item.title}}\"><span>{{ translation[item.title] || item.title + \' (\' + item.metadata.type + \')\' }}&nbsp;</span></md-checkbox></div></div><div layout=row layout-align=\"start start\" layout-wrap class=pull-right><md-button ng-if=\"schema.workspaceName == \'CURRENT VIEW\'\" ng-click=ctrl.setSchema(schema) ng-disabled=ctrl.loading class=md-raised>Set changes</md-button><md-button ng-if=\"schema.workspaceName != \'CURRENT VIEW\' &amp;&amp; schema.workspaceName != \'DEFAULT\'\" ng-click=ctrl.applySchema(schema) ng-disabled=ctrl.loading class=md-raised>Set on current view</md-button><md-button ng-if=\"schema.workspaceName == \'DEFAULT\'\" ng-click=ctrl.setSchema(schema) ng-disabled=ctrl.loading class=md-raised>{{ translation.set_defaults }}</md-button></div></md-content></md-tab></md-tabs></md-content></md-sidenav>");
$templateCache.put("app/audit/audit-detail.tmpl.html","<md-dialog style=\"width: 600px\"><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ translation.audit_detail_title }}: {{ ctrl.itemSelected.auditId }}</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons>clear</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=column class=md-dialog-content><div layout=row><md-input-container flex=50 style=\"margin-top: 5px\" class=no-padding-no-margin><label>{{ translation.date }}</label><input ng-value=\"ctrl.itemSelected.creationDate | asDate\" disabled></md-input-container><md-input-container flex=50 style=\"margin-top: 5px\" class=no-padding-no-margin><label>{{ translation.hour }}</label><input ng-value=\"ctrl.itemSelected.creationDate | asHour\" disabled></md-input-container></div><div layout=row><md-input-container flex=50 style=\"margin-top: 5px\" class=no-padding-no-margin><label>{{ translation.system_name }}</label><input ng-value=ctrl.itemSelected.systemName disabled></md-input-container><md-input-container flex=50 style=\"margin-top: 5px\" class=no-padding-no-margin><label>{{ translation.action_name }}</label><input ng-value=ctrl.itemSelected.actionName disabled></md-input-container></div><md-input-container flex=100 style=\"margin-top: 5px\" class=no-padding-no-margin><label>{{ translation.module_name }}</label><input ng-value=ctrl.itemSelected.moduleName disabled></md-input-container><md-input-container flex=100 style=\"margin-top: 5px\" class=no-padding-no-margin><label>{{ translation.module_function }}</label><input ng-model=ctrl.itemSelected.moduleFunction disabled></md-input-container><md-input-container flex=100 style=\"margin-top: 5px\" class=no-padding-no-margin><label>{{ translation.origin_url }}</label><input ng-value=ctrl.itemSelected.originUrl disabled></md-input-container><md-input-container flex=100 style=\"margin-top: 5px\" class=no-padding-no-margin><label>{{ translation.author_name }}</label><input ng-value=ctrl.itemSelected.authorName disabled></md-input-container><md-input-container flex=100 style=\"margin-top: 5px\" class=no-padding-no-margin><label>{{ translation.author_role }}</label><input ng-value=ctrl.itemSelected.authorRole disabled></md-input-container><md-input-container flex=100 style=\"margin-top: 5px\" class=no-padding-no-margin><label>{{ translation.detailed_message }}</label><textarea ng-model=ctrl.itemSelected.detailedMessage rows=3 disabled></textarea></md-input-container><md-input-container flex=100 style=\"margin-top: 5px\" class=no-padding-no-margin><label>{{ translation.entity_name_related }}</label><textarea ng-model=ctrl.itemSelected.entityNameRelated rows=3 disabled></textarea></md-input-container></div></md-dialog-content><md-dialog-actions class=md-dialog-content><md-button ng-click=ctrl.cancel() class=md-raised>{{ translation.close }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/audit/audit.html","<md-card id=auditReader ng-cloak><md-content class=content_blocks><div><md-toolbar class=md-menu-toolbar><div layout=row><md-toolbar-filler layout layout-align=\"center center\" class=white><cep-icon icon=cep-menu-log scale=2></cep-icon></md-toolbar-filler><div class=w100><h2 class=md-toolbar-tools><div class=md-title>{{ translation.system_registry }}</div></h2><md-menu-bar id=table-list-main-menu-bar layout=row><md-menu><button ng-click=$mdMenu.open()>{{ translation.tools }}</button><md-menu-content width=3><md-menu-item><md-button ng-click=ctrl.unFilterData()>{{ translation.remove_filters }}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-menu><md-button ng-disabled=!ctrl.validatePermission(&quot;list#&quot;+ctrl.listId+&quot;:read&quot;) ng-click=$mdMenu.open()>{{ translation.export_as }}...</md-button><md-menu-content width=3><md-menu-item><md-button ng-click=ctrl._onExport(&quot;xlsx&quot;)>{{ ctrl.translation.export }} (.csv .xlsx)</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item></md-menu-content></md-menu><button ng-if=ctrl.list.updatingData style=\"color: orange\"><span>{{ translation.updating_list_msg }}</span></button><div flex></div><section layout=row style=\"padding: 5px\"><div ng-repeat=\"(key, predicate) in ctrl.params.filters\" style=\"margin-right: 5px; font-size: 0.7em; line-height: 2em\" class=\"text-center cep-badge\">{{ predicate.column }} : {{ predicate.value[0] }}<div style=\"margin-left: 5px\" ng-click=ctrl.removeFilter(key) class=\"fa fa-times\"></div></div><div ng-if=ctrl.isFiltered ng-click=ctrl.unFilterData() style=\"margin-right: 5px; font-size: 0.7em; line-height: 2em\" class=\"text-center cep-badge\">{{ translation.remove_filters }}</div></section></md-menu-bar></div></div></md-toolbar></div></md-content><md-divider></md-divider><md-content><md-content ng-if=ctrl.loading><md-progress-linear></md-progress-linear></md-content><div ng-if=!ctrl.loading class=w100><div ui-grid-pagination ui-grid-resize-columns ui-grid-auto-resize ui-grid=ctrl.gridOptions style=\"min-height: 70vh\" class=listGrid></div></div></md-content></md-card>");
$templateCache.put("app/backup/backup.html","<div ng-cloak class=\"bs-component animated fadeInLeft\"><md-card id=backup><md-toolbar class=main-color><div class=md-toolbar-tools><h2 flex=\"\" md-truncate=\"\"><md-icon md-font-set=material-icons md-menu-align-target>backup</md-icon>&nbsp; configuracion de backups</h2></div></md-toolbar><md-card-content><section layout=row layout-padding=\"\"><div flex=40><h3>El backups se realizara cada<input-counter value=ctrl.backupConfig.days min=0 style=\"margin:0 .3em\"></input-counter>días.</h3></div><div flex=60><h4>Historico de backups</h4><md-list><md-list-item ng-repeat=\"backup in ctrl.historicBackups\" layout=row layout-padding=\"\" class=p0><div flex=50 md-truncate><md-icon md-font-set=material-icons md-menu-align-target>date_range</md-icon><b>{{ backup.date }}</b></div><div flex=50 class=text-right><b ng-if=\"backup.success == false\" class=text-danger>Error<md-icon md-font-set=material-icons class=text-danger>error_outline</md-icon></b><b ng-if=\"backup.success == true\" class=text-success>OK<md-icon md-font-set=material-icons class=text-success>done_all</md-icon></b></div></md-list-item></md-list></div></section></md-card-content></md-card></div>");
$templateCache.put("app/boveda/boveda.html","<h1>{{translation.BOVEDA_DE_DATOS}}</h1>");
$templateCache.put("app/cases/cases.html","<div class=\"bs-component sticky-parent\"><md-card><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-cases scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>CASOS</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button id=tolist href=casos/ aria-label=tolist class=\"md-fab md-mini blue\"><md-tooltip md-direction=left>Listado</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>view_list</md-icon></md-button><md-button id=create-new-cases-modal ng-click=cases.showModal($event) aria-label=CREAR_CASO class=\"md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>CREAR_CASO</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></md-toolbar-filler></div></md-toolbar><div id=cases-section ng-if=\" cases.errorConfig == false\" class=relative><tabs-bar tabs=tabsCasos is-active=cases.isActive set-tab=cases.setTab del-tab=cases.eliminarTabCaso></tabs-bar><div ng-show=cases.isSet(&quot;index&quot;)><div ng-repeat=\"item in cases.casesData\" ng-if=\" cases.isLoading == false\" style=\"border-bottom: 1px solid rgb(197, 197, 197)\"><div layout=row layout-align=\"start center\" ng-click=\"item.display = !item.display\" style=\"position: sticky;top: 129px;z-index: 20;box-shadow: 0px 1px 2px 1px rgba(95,95,95,0.5)\" class=white><div flex=50><h4><md-icon class=text-main-color>{{ item.display ? \"keyboard_arrow_right\" : \"keyboard_arrow_up\" }}</md-icon><b>{{ item.name | capitalize }}</b></h4></div><div flex=50 style=\"padding-right: 3rem\" class=text-right><div ng-repeat=\"stats in item.status\" style=\"margin-right: 10px\" class=\"badge grey black-text lighten-2\"><b>{{ stats.name | capitalize }} - {{ stats.cases.length }}</b></div></div></div><div ng-show=item.display><cases-kanban ref=item.ref data=item.status></cases-kanban></div></div><div layout=row layout-align=\"end center\" layout-padding><div>Total &nbsp;<b>{{ cases.pagiantion.totalRecords }}</b>&nbsp; Casos &nbsp;</div></div></div><section layout=row ng-if=\" cases.isLoading == true\"><div flex=100 class=text-center><h4>{{ translation.loading_config }}</h4><md-progress-linear md-mode=indeterminate></md-progress-linear></div></section></div><section ng-repeat=\"tab in tabsCasos\" ng-if=\"tab.id!=&quot;index&quot;\" ng-show=\"tab.id!=&quot;index&quot; &amp;&amp; cases.isSet(tab.id)\"><div layout=row><md-card flex=60><cases-basic-data tab=tab users=cases.usuarios groups=cases.groups></cases-basic-data></md-card><md-card flex=40><cases-comment tab=tab users=cases.usuarios></cases-comment></md-card></div><div layout=row><md-card flex=60><cases-alerts tab=tab></cases-alerts></md-card><md-card flex=40><cases-related-files tab=tab></cases-related-files></md-card></div></section><div id=cases-error-section ng-if=\" cases.errorConfig == true\"><section layout=row><div flex=100 class=text-center><h4>Error global config</h4><md-button ng-click=toGlobalConfig() aria-label=global-config class=\"md-button md-raised\"><md-icon md-font-set=material-icons md-menu-align-target>vpn_lock</md-icon>Go to Global settings</md-button></div></section></div></md-card></div>");
$templateCache.put("app/cases/modal_create_case.html","<md-dialog style=width:500px><md-toolbar class=main-color><div class=md-toolbar-tools><h2>CREAR_CASO<span flex></span><md-button ng-click=cancel() class=md-icon-button><md-icon md-font-set=material-icons>clear</md-icon></md-button></h2></div></md-toolbar><md-dialog-content><div layout=column><div style=\"padding:20px 10px 0 10px\"><form name=newCaseForm novalidate><div layout=column style=\"padding: 0px 16px\"><md-input-container class=\"no-padding-no-margin w100\"><label>NOMBRE</label><input ng-model=newCase.nombre placeholder=NOMBRE_CASO aria-label=\"Case name field\" required></md-input-container></div><div layout=row><md-input-container class=\"no-padding-no-margin w100\"><label>CRITICIDAD *</label><select ng-model=newCase.criticidad placeholder=CRITICIDAD aria-label=\"Criticity Selector\" required class=select-filters-modal><option value=alta>ALTA</option><option value=media>MEDIA</option><option value=baja>BAJA</option></select></md-input-container><md-input-container class=\"no-padding-no-margin w100\"><label>EJECUTIVO</label><input ng-model=newCase.ejecutivo placeholder=EJECUTIVO aria-label=\"Executive field\" readonly disabled></md-input-container></div><div layout=row><md-input-container class=\"no-padding-no-margin w100\"><label>DESCRIPCION</label><textarea ng-model=newCase.descripcion placeholder=DESCRIPCION aria-label=\"Description field\" required></textarea></md-input-container></div></form></div></div><md-divider></md-divider></md-dialog-content><md-dialog-actions><md-button type=button ng-click=cancel() class=\"md-raised pull-right\"><span>CANCELAR</span></md-button><md-button type=button ng-disabled=newCaseForm.$invalid ng-click=createCase() class=\"md-raised md-primary pull-right\"><span>CREAR_CASO</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/casos/casos.html","<div class=\"bs-component sticky-parent\"><md-card><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-cases scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>CASOS</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button id=tokanban href=cases aria-label=tokanban class=\"md-fab md-mini blue\"><md-tooltip md-direction=left>Kanban</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>view_column</md-icon></md-button><md-button id=create-new-cases-modal ng-click=casos.showModal($event) aria-label=CREAR_CASO class=\"md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>CREAR_CASO</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></md-toolbar-filler></div></md-toolbar><tabs-bar tabs=tabsCasos is-active=casos.isActive set-tab=casos.setTab del-tab=casos.eliminarTabCaso></tabs-bar><section layout=row><div flex=100 ng-show=casos.isSet(&quot;index&quot;)><ng-table-dynamic id=cases-table config=casos.configCases show-top-bar=true show-filter-button=true show-refresh-button=true show-export-csv-button=casos.validatePermission() on-click=casos.crearTabDetalleCaso></ng-table-dynamic></div></section></md-card></div><section ng-repeat=\"tab in tabsCasos\" ng-if=\"tab.id!=&quot;index&quot;\" ng-show=\"tab.id!=&quot;index&quot; &amp;&amp; casos.isSet(tab.id)\"><div layout=row><md-card flex=60><cases-basic-data tab=tab users=casos.usuarios groups=casos.groups></cases-basic-data></md-card><md-card flex=40><cases-comment tab=tab users=casos.usuarios></cases-comment></md-card></div><div layout=row><md-card flex=60><cases-alerts tab=tab></cases-alerts></md-card><md-card flex=40><cases-related-files tab=tab></cases-related-files></md-card></div></section>");
$templateCache.put("app/casos/modal.agregar-alerta.html","<div tabindex=-1 role=dialog class=modal><div class=modal-dialog><div class=modal-content><div class=modal-header><a type=button abm-component ng-click=$hide() class=close>×</a><h4 class=modal-title>{{translation.LISTADO_EVENTOS}}</h4></div><div class=modal-body><ng-table-dinamic id=alerts-table config=configAlarmas on-click=null on-select=onSelect></ng-table-dinamic></div><div class=modal-footer><md-button type=button ng-click=$hide()>{{translation.CERRAR}}</md-button><md-button type=button ng-click=assignEvents() ng-disabled=\"selectedItems.length == 0\">{{translation.ASIGNAR}}</md-button></div></div></div></div>");
$templateCache.put("app/casos/modal.crear-caso-intervalo.html","<div tabindex=-1 role=dialog class=modal><div class=modal-dialog><div class=modal-content><div class=modal-header><a type=button abm-component ng-click=$hide() class=close>×</a><h4 class=modal-title>{{translation.CREAR_CASO}} - Intervalo: {{ interval.title }}</h4><div>{{ interval.fromDate | date:\'short\' }} -> {{ interval.toDate | date:\'short\' }}</div></div><div class=modal-body><div><div ng-if=\"alerta.casosLink &amp;&amp; alerta.casosLink.length&gt;0\" class=row><div class=col-xs-12><div class=\"panel panel-warning\"><div class=panel-heading><h3 class=panel-title><i class=icon-notifications></i>{{translation.ALERTA_TIENE_ASOCIADOS}}</h3></div></div></div></div><div ng-if=validacion.show class=row><div class=col-xs-12><div class=\"panel panel-primary\"><div class=panel-heading><h3 class=panel-title><i class=icon-notifications></i>{{validacion.content}}</h3></div></div></div></div></div><form action=\"\"><abm-form-group><label data-abm-label=\"\">{{translation.NOMBRE}}</label><input type=text ng-model=nombre ng-change=\"inputChange(&quot;nombre&quot;, nombre)\" abm-form-control=\"\" placeholder={{translation.NOMBRE_CASO}} class=form-control></abm-form-group><abm-form-group><label for=select data-abm-label=\"\" class=\"control-label label-static\">{{translation.CRITICIDAD}}</label><div><select id=select ng-model=criticidad ng-change=\"inputChange(&quot;criticidad&quot;, criticidad)\" class=form-control><option value=Alta>{{translation.ALTA}}</option><option value=Media>{{translation.MEDIA}}</option><option value=Baja>{{translation.BAJA}}</option></select></div></abm-form-group><abm-form-group><label data-abm-label=\"\">{{translation.EJECUTIVO}}</label><input type=text readonly ng-model=ejecutivo abm-form-control=\"\" placeholder={{translation.EJECUTIVO}} class=form-control></abm-form-group><abm-form-group><label data-abm-label=\"\">{{translation.DESCRIPCION}}</label><textarea rows=4 ng-model=descripcion ng-change=\"inputChange(&quot;descripcion&quot;, descripcion)\" class=form-control></textarea></abm-form-group></form><form action=\"\" ng-if=hasAlert><div class=row><div class=col-xs-8><div class=row><div class=col-xs-12><div class=\"panel panel-primary\"><div class=panel-heading><h3 class=panel-title>{{alerta.tipo + \' \' + alerta.id}}</h3></div><div class=panel-body><div class=row-block><div label class=col-block>{{translation.FECHA}}:</div><div data class=col-block>{{alerta.fecha}}</div></div><div class=row-block><div label class=col-block>{{translation.HORA}}:</div><div data class=col-block>{{alerta.hora}}</div></div><div class=row-block><div label class=col-block>{{translation.TIPO}}:</div><div data class=col-block>{{alerta.tipo}}</div></div><div class=row-block><div label class=col-block>{{translation.CRITICIDAD}}:</div><div data class=col-block>{{alerta.criticidad}}</div></div><div class=row-block></div></div></div></div></div></div></div></form></div><div class=modal-footer><div class=row><div class=col-md-12><div ng-show=casoCreado class=\"alert alert-dismissible alert-success text-center\">{{translation.CASO_EXITOSO}}.</div></div><div ng-hide=caseProcessing class=col-md-12><button type=button ng-click=$hide() class=\"btn btn-default\">{{translation.CANCELAR}}</button> <button type=button ng-click=createCase() class=\"btn btn-primary\">{{translation.CREAR_CASO}}</button></div></div></div></div></div></div><script>$(\'select\').dropdown({ \"autoinit\" : \".select\" });</script>");
$templateCache.put("app/casos/modal.crear-caso.html","<div tabindex=-1 role=dialog class=modal><md-progress-linear md-mode=indeterminate ng-show=loading class=\"md-accent md-hue-2\"></md-progress-linear><div aria-label={{translation.CREAR_CASO}} class=modal-dialog><div class=modal-content><md-toolbar><div class=\"md-toolbar-tools nav-tabs\"><h2 class=modal-title>{{translation.CREAR_CASO}}</h2><span flex=\"\"></span><md-button ng-click=$hide()>X</md-button></div></md-toolbar><div class=modal-body><div><div ng-if=\"alerta.casosLink &amp;&amp; alerta.casosLink.length&gt;0\" class=row><div class=col-xs-12><div class=\"panel panel-warning\"><div class=panel-heading><h3 class=panel-title><i class=icon-notifications></i>{{translation.ALERTA_TIENE_ASOCIADOS}}</h3></div></div></div></div><div ng-if=validacion.show class=row><div class=col-xs-12><div class=\"panel panel-primary\"><div class=panel-heading><h3 class=panel-title><i class=icon-notifications></i>{{validacion.content}}</h3></div></div></div></div></div><form name=newCaseForm novalidate><abm-form-group><label data-abm-label=\"\">{{translation.NOMBRE}}</label><input type=text ng-model=inputs.nombre required abm-form-control=\"\" placeholder={{translation.NOMBRE_CASO}} class=form-control></abm-form-group><abm-form-group><label for=select data-abm-label=\"\" class=\"control-label label-static\">{{translation.CRITICIDAD}}</label><div><select ng-model=inputs.criticidad required class=form-control><option disabled selected value=\"\">{{translation.EJECUTIVO}}</option><option value=alta>{{translation.ALTA}}</option><option value=media>{{translation.MEDIA}}</option><option value=baja>{{translation.BAJA}}</option></select></div></abm-form-group><abm-form-group><label data-abm-label=\"\">{{translation.EJECUTIVO}}</label><input type=text readonly ng-model=inputs.ejecutivo required abm-form-control=\"\" placeholder={{translation.EJECUTIVO}} class=form-control></abm-form-group><abm-form-group><label data-abm-label=\"\">{{translation.DESCRIPCION}}</label><textarea rows=4 ng-model=inputs.descripcion required class=form-control></textarea></abm-form-group></form><form action=\"\" ng-if=hasAlert><div class=row><div class=col-xs-8><div class=row><div class=col-xs-12><div class=\"panel panel-primary\"><div class=panel-heading><h3 class=panel-title>{{alerta.tipo + \' \' + alerta.id}}</h3></div><div class=panel-body><div class=row-block><div label class=col-block>{{translation.FECHA}}:</div><div data class=col-block>{{alerta.fecha}}</div></div><div class=row-block><div label class=col-block>{{translation.HORA}}:</div><div data class=col-block>{{alerta.hora}}</div></div><div class=row-block><div label class=col-block>{{translation.TIPO}}:</div><div data class=col-block>{{alerta.tipo}}</div></div><div class=row-block><div label class=col-block>{{translation.CRITICIDAD}}:</div><div data class=col-block>{{alerta.criticidad}}</div></div></div></div></div></div></div></div></form></div><div class=modal-footer></div><md-dialog-actions layout=row><span flex=\"\"></span><md-button ng-click=$hide() class=md-raised>{{translation.CANCELAR}}</md-button><md-button ng-disabled=newCaseForm.$invalid ng-click=crearCasoController() class=\"md-raised md-primary\">{{translation.CREAR_CASO}}</md-button></md-dialog-actions></div></div></div><script>$(\'select\').dropdown({\"autoinit\": \".select\"});</script>");
$templateCache.put("app/casos/modal.mensajes.html","<div tabindex=-1 role=dialog class=\"modal text-left\"><div class=modal-dialog><div class=modal-content><div class=modal-header><a type=button abm-component ng-click=$hide() class=close>×</a><h4 class=modal-title>{{ translation.ULTIMOS_MENSAJES }}</h4></div><div style=\"padding: 0\" class=modal-body><div class=\"panel panel-info panel-chart\"><div class=panel-body><ul class=discussion><li ng-repeat=\"item in casos.discussions\"><div class=avatar><!--img(src=\"assets/images/avatar.jpg\")--><ng-letter-avatar data=\"{{ item.user }}\" shape=round></ng-letter-avatar></div><div class=messages><h4>#caso dos</h4><p>yeah, they do early flights cause they connect with big airports. they wanna get u to your connection</p><time>{{ item.fecha | moment:\'DD/MM/YYYY\' }}</time></div></li></ul><abm-form-group class=form-textarea><label data-abm-label=\"\" type=floating>{{ translation.COMENTAR }}</label><textarea abm-form-control=\"\" ng-model=textarea></textarea><span class=input-group-btn><button type=button class=\"btn btn-fab btn-primary btn-fab-mini\"><i class=material-icons>send</i></button></span></abm-form-group></div></div></div></div></div></div>");
$templateCache.put("app/charts/chart-id.html","<span ng-if=\"ctrl.loading==false\" style=\"outline: 1px solid red\"><chart-view chart-id=ctrl.chartId show-chart-table-view=true show-chart-labels=true show-chart-filters-dialog=false></chart-view></span><md-progress-linear ng-if=\"ctrl.loading==true\" md-mode=indeterminate></md-progress-linear>");
$templateCache.put("app/charts/chart-view.html","<section layout=row class=relative><article id=printSection flex=\"{{ ctrl.sidenav_is_open }}\" style=\"position: relative; display: flex; flex-direction: column; flex-wrap: nowrap; align-content: center; justify-content: flex-start; align-items: stretch\" ng-style=\"ctrl.isWidget &amp;&amp;  { \'height\': ctrl.chartHeight +\'px\' }\"><div layout=row><md-toolbar class=\"grey lighten-5\"><ng-include src=\"\'app/charts/includes/chart-tool-bar.html\'\"></ng-include></md-toolbar></div><md-card-content ng-if=\"isLoading == true\"><section layout=row><div flex=100 class=text-center><h4>{{ translation.loading }}</h4><md-progress-linear md-mode=indeterminate></md-progress-linear></div></section></md-card-content><div id=\"echart-container-{{ uuid}}\" style=\"width: 100%; flex: 1\"></div><chart-table-view ng-if=!isLoading style=\"width: 100%; flex: 1\" chart-id=ctrl.chart.id chart-data=ctrl.echartConfig has-groupby=ctrl.hasGroupby has-pivot=ctrl.hasPivot translation=translation show-table=ctrl.showChartTableView is-widget=ctrl.isWidget></chart-table-view><chart-tables ng-if=!ctrl.isWidget style=\"margin-top: 15px\" tables=ctrl.chart.tables chart-id=ctrl.chart.id translation=translation></chart-tables></article><aside flex=25 ng-if=\"!ctrl.isWidget &amp;&amp; ctrl.sidenav_is_open\" class=\"relative noprint\"><ng-include src=\"\'app/charts/includes/chart-side-panel.html\'\"></ng-include></aside></section>");
$templateCache.put("app/charts/charts-list.html","<div ng-cloak class=\"bs-component sticky-parent\"><md-card><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-graphic-charts scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>{{ ctrl.translation.graphic_reports }}</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button id=btn-create-chart has-permission=graphic-report:create abm-component aria-label=manageChart ng-click=ctrl.manageChart() class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>{{ ctrl.translation.create_chart }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></md-toolbar-filler></div></md-toolbar><tabs-bar tabs=ctrl.tabChart is-active=ctrl.isActive set-tab=ctrl.setTab del-tab=ctrl.eliminarTabReport></tabs-bar><section ng-repeat=\"tab in ctrl.tabChart\" ng-if=\"tab.id!=\'index\'\" ng-show=\"tab.id!=\'index\' &amp;&amp; ctrl.isSet(tab.id)\"><chart-view chart-id=tab.id reload=ctrl.getChartsbyDomain() show-chart-filters-dialog=false></chart-view></section><div id=index-tab ng-show=\"ctrl.isSet(\'index\')\" style=\"background-color: #fafafa\"><div layout=row layout-align=\"end center\" ng-if=!ctrl.isLoading class=md-toolbar-tools><div><searcher value=ctrl.searchText placeholder=\"{{ ctrl.translation.find }}\"></searcher></div><div flex=1 ng-if=!ctrl.displayItems><md-button ng-click=ctrl.expandAll() aria-label=\"Unfold all button\" class=\"md-raised p0 w_auto md-mini grey lighten-4\"><md-tooltip>Expand all</md-tooltip><md-icon md-font-set=material-icons class=grey-text>unfold_more</md-icon></md-button></div><div flex=1 ng-if=ctrl.displayItems><md-button ng-click=ctrl.collapseAll() aria-label=\"Fold all button\" class=\"md-raised p0 w_auto md-mini grey lighten-4\"><md-tooltip>Collapse all</md-tooltip><md-icon md-font-set=material-icons class=grey-text>unfold_less</md-icon></md-button></div><div flex=1 ng-if=\"ctrl.sort==\'desc\'\"><md-button ng-click=ctrl.toggleSort() aria-label=\"sort asc\" class=\"md-raised p0 w_auto md-mini grey lighten-4 grey-text\"><md-tooltip>sort asc</md-tooltip><div class=\"fa fa-sort-alpha-desc\"></div></md-button></div><div flex=1 ng-if=\"ctrl.sort==\'asc\'\"><md-button ng-click=ctrl.toggleSort() aria-label=\"sort desc\" class=\"md-raised p0 w_auto md-mini grey lighten-4 grey-text\"><md-tooltip>sort desc</md-tooltip><div class=\"fa fa-sort-alpha-asc\"></div></md-button></div></div><div id=charts-config-list ng-if=!ctrl.isLoading><ng-include src=&quot;app/charts/template/tree-view.html&quot;></ng-include></div></div></md-card></div>");
$templateCache.put("app/configuration/configuration.list.html","<md-card><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-global-settings scale=2></cep-icon></md-toolbar-filler><h2 flex md-truncate class=\"md-toolbar-tools white-text main-color\"><span>{{ ctrl.translation.configuration }}</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"></md-toolbar-filler></div></md-toolbar><md-tabs md-selected=0 md-dynamic-height md-border-bottom style=\"width: 100%\"><md-tab label=Global><ng-table-dynamic id=configuration-table config=ctrl.config show-top-bar=true show-filter-button=false show-refresh-button=true show-export-csv-button=false on-click=ctrl.showCreateConfigurationDialog on-delete-row=ctrl.remove><extend-buttons><md-button has-permission=configuration:create ng-click=ctrl.showCreateConfigurationDialog() aria-label=\"{{ ctrl.translation.crear }}\" class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>Add</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></extend-buttons></ng-table-dynamic></md-tab><md-tab label=KeyStorage><ng-table-dynamic id=keystorage-table config=ctrl.configKeyStorage show-top-bar=true show-filter-button=false show-refresh-button=true show-export-csv-button=false on-click=ctrl.showCreateKeyStorageDialog on-delete-row=ctrl.removeKeyStorage><extend-buttons><md-button ng-click=ctrl.showCreateKeyStorageDialog() aria-label=\"{{ ctrl.translation.crear }}\" class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>Add</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></extend-buttons></ng-table-dynamic></md-tab><md-tab label=Category ng-if=ctrl.validatePermission(&quot;category:read&quot;)><ng-table-dynamic id=category-table config=ctrl.configCategory show-top-bar=true show-filter-button=false show-refresh-button=true show-export-csv-button=false on-click=ctrl.showCreateCategoryDialog on-delete-row=ctrl.removeCategory><extend-buttons><md-button ng-click=ctrl.showCreateCategoryDialog() has-permission=category:create aria-label=\"{{ ctrl.translation.crear }}\" class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>Add</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></extend-buttons></ng-table-dynamic></md-tab><md-tab label=\"Issues Type\" ng-if=ctrl.validatePermission(&quot;issues-type:read&quot;)><ng-table-dynamic id=issues-type-table config=ctrl.configIssueType show-top-bar=true show-filter-button=false show-refresh-button=true show-export-csv-button=false on-click=ctrl.showCreateIssueTypeDialog on-share=ctrl.showShareIssueTypeDialog on-delete-row=ctrl.removeIssueType><extend-buttons><md-button ng-click=ctrl.showCreateIssueTypeDialog() has-permission=issues-type:create aria-label=\"{{ ctrl.translation.crear }}\" class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>Add</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></extend-buttons></ng-table-dynamic></md-tab><md-tab label=Holidays ng-if=ctrl.validatePermission(&quot;issues-type:read&quot;)><ng-table-dynamic id=holiday-table config=ctrl.configHolidays show-top-bar=true show-filter-button=false show-refresh-button=true show-export-csv-button=false on-click=ctrl.showCreateHolidayDialog on-delete-row=ctrl.removeHoliday><extend-buttons><md-button ng-click=ctrl.showCreateHolidayDialog() has-permission=issues-type:create aria-label=\"{{ ctrl.translation.crear }}\" class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>Add</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></extend-buttons></ng-table-dynamic></md-tab><md-tab label=\"Schema formats\"><ng-table-dynamic id=schema-format-table config=ctrl.configShemaFormat show-top-bar=true show-filter-button=false show-refresh-button=true show-export-csv-button=false on-click=ctrl.showSchemaFormatDialog on-delete-row=ctrl.removeSchemaFormat><extend-buttons><md-button has-permission=configuration:create ng-click=ctrl.showSchemaFormatDialog() aria-label=\"{{ ctrl.translation.crear }}\" class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>Add</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></extend-buttons></ng-table-dynamic></md-tab><md-tab label=\"{{ ctrl.translation.storage }}\" ng-if=ctrl.validatePermission(&quot;configuration:read&quot;)><md-content layout=column class=md-padding><div flex=100><storage-manager></storage-manager></div></md-content></md-tab><md-tab label=Companies><ng-table-dynamic id=company-table config=ctrl.configCompany show-top-bar=true show-filter-button=false show-refresh-button=true show-export-csv-button=false show-remove-rows-button=false on-click=ctrl.showCreateCompanyDialog><extend-buttons><md-button ng-click=ctrl.showCreateCompanyDialog() is-super-user aria-label=\"{{ ctrl.translation.crear }}\" class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>Add</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></extend-buttons></ng-table-dynamic></md-tab><md-tab label=\"OAuth2 Providers\"><ng-table-dynamic id=oauth-providers-table config=ctrl.configProviders show-top-bar=true show-filter-button=false show-refresh-button=true show-export-csv-button=false show-remove-rows-button=false on-click=ctrl.showCreateProviderDialog><extend-buttons><md-button ng-click=ctrl.showCreateProviderDialog() is-super-user aria-label=\"{{ ctrl.translation.crear }}\" class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>Add</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></extend-buttons></ng-table-dynamic></md-tab><md-tab label=\"External Libraries\" has-permission=python-library:read><external-libraries-config></external-libraries-config></md-tab></md-tabs></md-card>");
$templateCache.put("app/configuration/dialog-create-category.html","<md-dialog aria-label=\"{{ actionText }}\" style=\"width: 800px\"><md-toolbar><div class=md-toolbar-tools><h2>{{ actionText }}</h2><span flex></span><md-button ng-click=cancel($event) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column layout-padding><md-content class=md-padding><form id=keystorageForm name=keystorageForm ng-submit=save($event)><div layout=column flex=100><md-input-container class=w100><label>name</label><input type=text ng-model=category.name required md-maxlength=50></md-input-container></div><div layout=column flex=100><md-input-container class=w100><label>label</label><input type=text ng-model=category.label required md-maxlength=50></md-input-container><md-input-container class=w100><label>code</label><input type=text ng-model=category.code required md-minlength=3 md-maxlength=3></md-input-container><md-input-container class=w100><label>color</label><input type=text ng-model=category.color required></md-input-container><md-input-container class=w100><label>icon</label><input type=text ng-model=category.icon></md-input-container></div></form></md-content></md-dialog-content><md-dialog-actions><md-button md-colors=green ng-click=cancel($event)>{{ translation.cancel_button }}</md-button><md-button md-colors=green type=submit form=keystorageForm ng-show=validatePermission()>{{ translation.save_button }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/configuration/dialog-create-company.html","<md-dialog aria-label=\"{{ translation.add_schema }}\" style=\"width: 500px\"><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ actionText }}</h2><span flex></span><md-button ng-click=cancel($event) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column layout-padding style=\"padding-top: 10px\"><md-tabs id=dialog-create-replay-tab md-selected=selectedIndex md-dynamic-height md-border-bottom md-autoselect md-swipe-content><md-tab id=home label=\"Home Company\" ng-disabled=tab.firstLocked><md-content class=md-padding><form name=companyForm1 novalidate><div layout=column style=\"z-index: 3\" class=\"sticky-top white\"><md-input-container><label>Name</label><input type=text ng-model=name required md-maxlength=50></md-input-container></div></form><div><span style=\"color: darkred\">If you want to create the home company, it will be associated to all users and groups</span></div></md-content></md-tab><md-tab id=affiliated label=\"Affiliated Company\" ng-disabled=tab.secondLocked><md-content class=md-padding><form name=companyForm2 novalidate><div layout=column style=\"z-index: 3\" class=\"sticky-top white\"><md-input-container><label>Name</label><input type=text ng-model=name required md-maxlength=50></md-input-container><md-input-container><md-checkbox ng-model=active aria-label=Active>Active</md-checkbox></md-input-container></div></form></md-content></md-tab></md-tabs></md-dialog-content><md-dialog-actions><md-button md-colors=green ng-click=cancel($event)>Cancel</md-button><md-button md-colors=green ng-click=save() is-super-user class=\"md-raised green white-text\"><md-icon md-font-set=material-icons md-menu-align-target>save</md-icon>Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/configuration/dialog-create-configuration.html","<md-dialog aria-label=\"{{ actionText }}\" style=\"width: 1000px\"><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ actionText }}</h2><span flex></span><md-button ng-click=cancel($event) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column layout-padding><md-content><md-tabs md-selected=0 md-dynamic-height md-border-bottom style=\"width: 100%\"><md-tab label=JSON ng-click=convert(&quot;json&quot;)><md-progress-linear ng-if=loading></md-progress-linear><md-content style=\"height: 400px\" ng-if=!loading class=md-padding><div ng-model=myConfigSchemaJson style=\"height: 580px\" ui-ace=\"{ useWrapMode : false, showGutter: true, theme:&quot;twilight&quot;, mode: &quot;json&quot; ,onLoad : editorLoaded }\"></div></md-content></md-tab><md-tab label=FORM ng-click=convert(&quot;form&quot;)><md-content layout-xs=column layout=row style=\"height: 400px\"><div flex-xs flex-gt-xs=50 layout=column><md-card><md-card-title><md-card-title-text><span class=md-headline>System Type</span></md-card-title-text></md-card-title><md-card-content layout=column><md-input-container class=m0><label>Type</label><input type=text ng-model=mySchemaForm.systemType></md-input-container></md-card-content></md-card><md-card><md-card-title><md-card-title-text><span class=md-headline>Password Policy</span><span class=md-subhead>The password policy is a set of rules that define the complexity requirements and mandatory rotation periods for user passwords.</span></md-card-title-text></md-card-title><md-card-content><h5>Select users password policy requirements</h5><md-input-container class=\"m0 md-block\"><md-checkbox name=tos ng-model=mySchemaForm.passwordPolicy.showPasswordPolicy>Show password policies</md-checkbox></md-input-container><md-input-container class=\"m0 md-block\"><md-checkbox name=tos ng-model=mySchemaForm.passwordPolicy.isPasswordLength>Set the minimum password length (0 = unlimited)</md-checkbox></md-input-container><md-input-container ng-if=mySchemaForm.passwordPolicy.isPasswordLength class=m0><label>Length</label><input type=number ng-model=mySchemaForm.passwordPolicy.minimumPasswordLength></md-input-container><md-input-container class=\"m0 md-block\"><md-checkbox name=isUpperCaseCharacter ng-model=mySchemaForm.passwordPolicy.withAtLeastOneUppercase>Require at least one uppercase character of the Latin alphabet (A-Z)</md-checkbox></md-input-container><md-input-container class=\"m0 md-block\"><md-checkbox name=isLowerCaseCharacter ng-model=mySchemaForm.passwordPolicy.withAtLeastOneLowercase>Require at least one lowercase character from the Latin alphabet (a-z)</md-checkbox></md-input-container><md-input-container class=\"m0 md-block\"><md-checkbox name=isNumericCharacter ng-model=mySchemaForm.passwordPolicy.withAtLeastOneDigit>Require at least one digit (0-9)</md-checkbox></md-input-container><md-input-container class=\"m0 md-block\"><md-checkbox name=isSpecialCharacter ng-model=mySchemaForm.passwordPolicy.withAtLeastOneSymbol>Require at least one symbol (! @ # $% ^ & * () _- + * = / [] {} |)</md-checkbox></md-input-container><md-input-container class=\"m0 md-block\"><md-checkbox name=isExpiredPassword ng-model=mySchemaForm.passwordPolicy.isExpiredPassword>Enable password expiration (0 = unlimited)</md-checkbox></md-input-container><md-input-container ng-if=mySchemaForm.passwordPolicy.isExpiredPassword class=m0><label>Days</label><input type=number ng-model=mySchemaForm.passwordPolicy.expirePasswordInDays></md-input-container><md-input-container class=\"m0 md-block\"><md-checkbox name=tos ng-model=mySchemaForm.passwordPolicy.isReusedPassword>Avoid password reuse (0 = unlimited)</md-checkbox></md-input-container><md-input-container ng-if=mySchemaForm.passwordPolicy.isReusedPassword class=m0><label>Remember</label><input type=number ng-model=mySchemaForm.passwordPolicy.rememberLastPasswords></md-input-container></md-card-content></md-card><md-card><md-card-title><md-card-title-text><span class=md-headline>Ethical Portal</span></md-card-title-text></md-card-title><md-card-content layout=column><md-input-container class=m0><label>Send quote email, from</label><input type=email ng-model=mySchemaForm.ethicalPortal.emailFrom></md-input-container><md-input-container class=m0><label>Send quote email, to</label><input type=email ng-model=mySchemaForm.ethicalPortal.emailTo></md-input-container><md-input-container class=m0><label>Issue Type</label><input type=number ng-model=mySchemaForm.ethicalPortal.issueTypeId></md-input-container><md-input-container class=m0><label>Evidence Schema</label><input type=number ng-model=mySchemaForm.ethicalPortal.evidenceSchemaId></md-input-container><md-input-container class=m0><label>Assigned User</label><input type=text ng-model=mySchemaForm.ethicalPortal.assignedUser></md-input-container><md-input-container class=m0><label>Creator User</label><input type=text ng-model=mySchemaForm.ethicalPortal.creatorUser></md-input-container><md-input-container class=m0><label>Assigned Group</label><input type=text ng-model=mySchemaForm.ethicalPortal.assignedGroup></md-input-container><md-input-container class=m0><label>labelAuthorCommentPublic</label><input type=text ng-model=mySchemaForm.ethicalPortal.labelAuthorCommentPublic></md-input-container><md-input-container class=m0><label>labelAuthorCommentPrivate</label><input type=text ng-model=mySchemaForm.ethicalPortal.labelAuthorCommentPrivate></md-input-container><md-input-container style=\"padding-bottom: 2rem\" class=m0><md-checkbox name=tos ng-model=mySchemaForm.ethicalPortal.notificationByEmail>Activate notification by email</md-checkbox></md-input-container></md-card-content></md-card><md-card><md-card-title><md-card-title-text><span class=md-headline>Chat</span></md-card-title-text></md-card-title><md-card-content layout=column><md-input-container class=\"m0 md-block\"><md-checkbox name=chatEnabled ng-model=mySchemaForm.security.chat.enabled>Enabled</md-checkbox></md-input-container><md-input-container class=m0><label>inputTable</label><input type=text ng-model=mySchemaForm.security.chat.inputTable></md-input-container><md-input-container class=m0><label>inputSchema</label><input type=text ng-model=mySchemaForm.security.chat.inputSchema></md-input-container><md-input-container class=m0><label>outputTable</label><input type=text ng-model=mySchemaForm.security.chat.outputTable></md-input-container><md-input-container class=m0><label>outputSchema</label><input type=text ng-model=mySchemaForm.security.chat.outputSchema></md-input-container></md-card-content></md-card></div><div flex-xs flex-gt-xs=50 layout=column><md-card><md-card-title><md-card-title-text><span class=md-headline>Email From</span></md-card-title-text></md-card-title><md-card-content layout=column><md-input-container class=m0><label>email</label><input type=email ng-model=mySchemaForm.emailFrom.email></md-input-container><md-input-container class=m0><label>Name</label><input type=text ng-model=mySchemaForm.emailFrom.name></md-input-container></md-card-content></md-card><md-card><md-card-title><md-card-title-text><span class=md-headline>Issues</span></md-card-title-text></md-card-title><md-card-content layout=column><md-input-container class=\"m0 md-block\"><md-checkbox name=tos ng-model=mySchemaForm.issues.activateNotificationByEmail>Activate notification by email</md-checkbox></md-input-container><md-input-container class=m0><label>Domain URL</label><input type=url ng-model=mySchemaForm.issues.notificationDomainURL></md-input-container><md-input-container class=m0><label>Related By</label><md-select name=relatedBy ng-model=mySchemaForm.issues.relatedBy><md-option ng-repeat=\"option in relationships\" value=\"{{ option.value }}\">{{ option.label }}</md-option></md-select></md-input-container></md-card-content></md-card><md-card><md-card-title><md-card-title-text><span class=md-headline>Storage</span></md-card-title-text></md-card-title><md-card-content layout=column><md-input-container class=\"m0 md-block\"><md-checkbox name=includeFileACLs ng-model=mySchemaForm.storage.includeFileACLs>Include File ACLs</md-checkbox></md-input-container><md-input-container class=\"m0 md-block\"><md-checkbox name=storage ng-model=mySchemaForm.storage.downloadFileWithoutAuthentication>Download files without authentication</md-checkbox></md-input-container></md-card-content></md-card><md-card><md-card-title><md-card-title-text><span class=md-headline>Notification by email</span></md-card-title-text></md-card-title><md-card-content layout=column><md-input-container class=\"m0 md-block\"><md-checkbox name=notificationsByEmail ng-model=mySchemaForm.notificationsByEmail.enable>Enable</md-checkbox></md-input-container></md-card-content></md-card><md-card><md-card-title><md-card-title-text><span class=md-headline>{{ translation.report_config }}</span></md-card-title-text></md-card-title><md-card-content layout=column><md-input-container class=m0><label>{{ translation.logo_location }}</label><input type=text placeholder=\"file store folder\" ng-model=mySchemaForm.issues.logo></md-input-container></md-card-content></md-card><md-card><md-card-title><md-card-title-text><span class=md-headline>Dashboard UI</span></md-card-title-text></md-card-title><md-card-content layout=column><md-input-container class=m0><label>Home Page - SA</label><input type=text placeholder=\"file store folder\" ng-model=mySchemaForm.dashboard.homePage.SA></md-input-container><md-input-container class=m0><label>Home Page - User</label><input type=text placeholder=\"file store folder\" ng-model=mySchemaForm.dashboard.homePage.U></md-input-container><md-input-container class=m0><label>Theme</label><input type=text list=themeOptions ng-model=mySchemaForm.dashboard.theme ng-change=onChangeDashboardTheme()><datalist id=themeOptions><option value=ceptinel></option><option value=antifraude></option><option value=cumplimiento></option><option value=industria></option><option value=portaletico></option><option value=prevencion></option><option value=plain></option><option value=custom></option></datalist></md-input-container><md-input-container ng-if=\"mySchemaForm.dashboard.theme==&quot;custom&quot;\" class=m0><label>Logo folder</label><input type=text placeholder=\"file store folder\" ng-model=mySchemaForm.dashboard.logo.folder></md-input-container><md-input-container ng-if=\"mySchemaForm.dashboard.theme==&quot;custom&quot;\" class=m0><label>Logo file</label><input type=text placeholder=file-name.png ng-model=mySchemaForm.dashboard.logo.file></md-input-container></md-card-content><md-card-content layout=column><md-input-container class=m0><label>Chart colors</label></md-input-container></md-card-content><md-card-content layout=row><div><div style=\"margin: 0.5rem\" ng-repeat=\"color in mySchemaForm.dashboard.chartTheme track by $index\" class=\"badge grey\"><input type=color ng-model=color ng-change=\"onChangeColor(color, $index)\"><div ng-click=removeColor($index) class=\"fa fa-times\"></div></div><div style=\"margin: 0.5rem 0.8rem\" ng-click=addColor() class=\"badge blue\"><div class=\"fa fa-plus\"></div></div></div></md-card-content></md-card><md-card><md-card-title><md-card-title-text><span class=md-headline>Security</span></md-card-title-text></md-card-title><md-card-content layout=column><md-input-container class=m0><label>Service User Token Expiration Time</label><input type=number ng-model=mySchemaForm.security.serviceUserTokenExpirationTime></md-input-container><md-input-container class=m0><label>Ordinary User Token Expiration Time</label><input type=number ng-model=mySchemaForm.security.commonUserTokenExpirationTime></md-input-container><md-input-container class=m0><label>Tokens quantity by user</label><input type=number ng-model=mySchemaForm.security.openSessionQuantity></md-input-container></md-card-content></md-card><md-card><md-card-title><md-card-title-text><span class=md-headline>Documents</span></md-card-title-text></md-card-title><md-card-content layout=column><md-input-container class=m0><label>timeToLiveInDays</label><input type=number ng-model=mySchemaForm.documents.timeToLiveInDays></md-input-container><md-input-container class=m0><label>maxRows</label><input type=number ng-model=mySchemaForm.documents.maxRows></md-input-container></md-card-content></md-card></div></md-content></md-tab></md-tabs></md-content></md-dialog-content><md-dialog-actions><md-button md-colors=green ng-click=cancel($event)>{{ translation.cancel_button }}</md-button><md-button id=save-global-configuration md-colors=green ng-click=save() ng-show=validatePermission()>{{ translation.save_button }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/configuration/dialog-create-issue-type.html","<md-dialog aria-label=\"{{ actionText }}\" style=\"width: 800px\"><md-toolbar><div class=md-toolbar-tools><h2>{{ actionText }}</h2><span flex></span><md-button ng-click=cancel($event) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column layout-padding><md-progress-linear ng-if=!showEditor></md-progress-linear><md-content style=\"min-height: 450px\" ng-if=showEditor class=md-padding><div style=\"height: 580px\" ng-model=mySchemaJson ui-ace=\"{ useWrapMode : true, showGutter: true, theme:&quot;twilight&quot;, mode: &quot;json&quot;, rendererOptions: { minLines: 3 } ,onLoad : editorLoaded}\"></div></md-content></md-dialog-content><md-dialog-actions><md-button md-colors=green ng-click=cancel($event)>{{ translation.cancel_button }}</md-button><md-button md-colors=green ng-click=save() ng-show=validatePermission()>{{ translation.save_button }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/configuration/dialog-create-keystorage.html","<md-dialog aria-label=\"{{ translation.add_schema }}\" style=\"width: 500px\"><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ actionText }}</h2><span flex></span><md-button ng-click=cancel($event) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column layout-padding style=\"padding-top: 10px\"><md-content class=md-padding><form name=keystorageForm novalidate><div layout=column flex=100><md-input-container class=w100><label>{{ translation.path }}</label><input type=text ng-model=keystorage.path required md-maxlength=100 maxlength=100 ng-readonly=readonly></md-input-container><md-input-container class=w100><label>{{ translation.value }}</label><textarea rows=4 ng-model=keystorage.value required></textarea></md-input-container></div></form></md-content></md-dialog-content><md-dialog-actions><md-button md-colors=green ng-click=cancel($event)>{{ translation.cancel_button }}</md-button><md-button id=save-key-storage-button md-colors=green ng-click=save() ng-show=validatePermission() ng-disabled=keystorageForm.$invalid>{{ translation.save_button }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/configuration/dialog-create-oauth-provider.html","<md-dialog aria-label=\"{{ translation.add_schema }}\" style=\"width: 600px\"><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ actionText }}</h2><span flex></span><md-button ng-click=cancel($event) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column layout-padding style=\"padding-top: 10px\"><md-content class=md-padding><form name=providerForm novalidate><div layout=column flex=100><md-input-container><md-checkbox ng-model=provider.active aria-label=Active>Active</md-checkbox></md-input-container><md-input-container class=w100><label>Provider Name</label><input type=text ng-model=provider.providerName required md-maxlength=100 maxlength=100></md-input-container><md-input-container class=w100><label>Auth Endpoint</label><input type=text ng-model=provider.authEndpoint required md-maxlength=200 maxlength=200></md-input-container><md-input-container class=w100><label>Token Endpoint</label><input type=text ng-model=provider.tokenEndpoint required md-maxlength=200 maxlength=200></md-input-container><md-input-container class=w100><label>ClientInfo Endpoint</label><input type=text ng-model=provider.clientInfoEndpoint required md-maxlength=200 maxlength=200></md-input-container><md-input-container class=w100><label>Client Id</label><input type=text ng-model=provider.clientId required md-maxlength=200 maxlength=200></md-input-container><md-input-container class=w100><label>Client Secret</label><input type=text ng-model=provider.clientSecret required md-maxlength=200 maxlength=200></md-input-container><md-input-container class=w100><label>Redirect URI</label><input type=text ng-model=provider.redirectURI required md-maxlength=200 maxlength=200></md-input-container><md-input-container class=w100><label>Scope</label><input type=text ng-model=provider.scope md-maxlength=200 maxlength=200></md-input-container><md-input-container class=w100><label>State</label><input type=text ng-model=provider.state md-maxlength=200 maxlength=200></md-input-container></div></form></md-content></md-dialog-content><md-dialog-actions><md-button md-colors=green ng-click=cancel($event)>{{ translation.cancel_button }}</md-button><md-button md-colors=green ng-click=save() ng-disabled=providerForm.$invalid>{{ translation.save_button }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/credenciales/alert-credenciales.html","<div tabindex=-1 role=dialog class=modal><div class=modal-dialog><div style=\"text-align: center\" class=\"modal-content x-small-modal\"><div class=modal-header><img src=./assets/images/icons/success.svg style=\"width: 50px\" ng-show=\"tipoAlert==\'success\'\"><img src=./assets/images/icons/error.svg style=\"width: 50px\" ng-show=\"tipoAlert==\'error\'\"></div><div class=modal-body>{{ msgAlert }}<br><br></div><div style=\"margin-bottom: 22px; text-align: center\" class=modal-footer><button ng-click=$hide() style=\"min-width: 100px\" class=\"btn btn-primary btn-raised active recovery-button\">OK</button></div></div></div></div>");
$templateCache.put("app/credenciales/credenciales.html","<div class=\"bs-component sticky-parent\"><md-card><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-graphic-bi scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>{{ translation.ADMINISTRADOR_DE_CREDENCIALES }}</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button id=btn-go-to-reports abm-component ng-click=toReports() class=\"pull-right md-fab md-mini blue\"><md-tooltip md-direction=left>Ir a reportes</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>assignment</md-icon></md-button></md-toolbar-filler></div></md-toolbar></md-card><section layout=row layout-align=\"center center\"><md-card flex=50><md-toolbar class=\"border-detail white text-main-color\"><div layout=row><h4 flex=\"\" md-truncate=\"\" class=md-toolbar-tools><span ng-show=editorPowerBi>{{ translation.EDITAR_PARAMETROS }}</span><span ng-show=!editorPowerBi>{{ translation.ESTATUS_CONEXION }}</span></h4></div></md-toolbar><form id=credential-form novalidate ng-show=editorPowerBi><md-card-content layout=column><md-input-container class=m0><label>{{ translation.ID_APLICACION }}</label><input id=input-clientId type=text ng-model=pbiInfo.clientId ng-required=true></md-input-container><md-input-container class=m0><label>{{ translation.CLAVE_APLICACION }}</label><input id=input-clientSecret type=text ng-model=pbiInfo.clientSecret ng-required=true></md-input-container><md-input-container class=m0><label>{{ translation.NOMBRE_USUARIO }}</label><input id=input-username type=text ng-model=pbiInfo.username ng-required=true></md-input-container><md-input-container class=m0><label>{{ translation.CLAVE_USUARIO }}</label><input id=input-password type=password ng-model=pbiInfo.password ng-required=true></md-input-container><div layout=row layout-align=\"end center\"><div><md-button id=creditial-btn-save type=submit ng-show=!loaderPBI ng-click=guardarCredencialesPBI() class=\"md-raised green white-text\"><md-icon class=white-text>save</md-icon>{{ translation.GUARDAR }}</md-button></div><div><md-button id=creditial-btn-cancel type=button ng-show=!loaderPBI ng-click=cancelarEdicion() class=\"md-raised red white-text\"><md-icon class=white-text>close</md-icon>{{ translation.CANCELAR }}</md-button></div></div></md-card-content><md-progress-linear md-mode=indeterminate ng-show=loaderPBI class=\"md-accent md-hue-2\"></md-progress-linear></form><md-card-content ng-show=!editorPowerBi layout=column><img src=./assets/images/logo_powerbi.png style=\"width: 50%\"><section ng-show=loaderPBI><div style=\"text-align: center; height: 300px\"><md-progress-linear md-mode=indeterminate ng-show=loaderPBI class=\"md-accent md-hue-2\"></md-progress-linear></div></section><section ng-show=!loaderPBI><div id=image-status-connection style=\"text-align: center\"><img src=./assets/images/icons/connect_success.svg style=\"height: 120px; border-radius: 40px\" ng-show=pbiInfo.active><img src=./assets/images/icons/connect_failed.svg style=\"height: 120px; border-radius: 40px\" ng-show=!pbiInfo.active></div><div><br><span style=\"color: grey\">{{ translation.CREDENCIAL_POWER_BI }}&nbsp;</span><span ng-style=\"pbiInfo.active ? {color:\'green\'} : {color:\'red\'}\">{{ pbiInfo.active ? translation.HABILITADA : translation.DESABILITADA }}&nbsp;</span><span style=\"color: grey\">{{ translation.WORKSPACE }}</span><hr></div><div style=\"text-align: center\"><md-button id=creditial-btn-edit type=button ng-click=\"editorPowerBi = !editorPowerBi\" class=\"md-raised main-color white-text\">{{ translation.EDITAR_PARAMETROS }}</md-button></div></section></md-card-content></md-card></section></div>");
$templateCache.put("app/custom-reports/custom-reports-home.html","<main ng-cloak><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-custom-reports scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>{{ ctrl.translation.custom_reports }}</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button has-permission=custom-report:create ng-click=ctrl.showCustomReportDialog() class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>New Custom Report</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></md-toolbar-filler></div></md-toolbar><section layout=row layout-align=\"center stretch\"><md-card flex=20 class=\"cep-dashboard-box w100 relative\"><custom-report-inbox-menu ng-if=!ctrl.loadingCard></custom-report-inbox-menu></md-card><md-divider></md-divider><div flex ng-if=ctrl.loading><md-progress-linear></md-progress-linear></div><md-card flex ng-if=!ctrl.loading class=text-center><div class=text-center><br><br><br><md-icon style=\"font-size: 6rem\" class=text-info>person</md-icon><p><strong>{{ ctrl.selecCustomReport }}</strong></p><br><br></div></md-card></section></main>");
$templateCache.put("app/custom-reports/custom-reports.html","<main ng-cloak><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-custom-reports scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>{{ ctrl.translation.custom_reports }}</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button has-permission=custom-report:create ng-click=ctrl.showCustomReportDialog() class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>New Custom Report</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></md-toolbar-filler></div></md-toolbar><section layout=row layout-align=\"center stretch\"><md-card flex=20 style=\"margin: 0\" class=\"cep-dashboard-box w100 relative noprint\"><custom-report-inbox-menu ng-if=!ctrl.loadingCard></custom-report-inbox-menu></md-card><div flex ng-if=ctrl.loading><md-progress-linear></md-progress-linear></div><div id=cutom-report-tab flex ng-if=!ctrl.loading><md-tabs md-selected=ctrl.selectedTab md-dynamic-height class=noprint><md-tab ng-repeat=\"tab in ctrl.tabs track by $index\" md-on-select=ctrl.onTabSelected(tab) md-on-deselect=ctrl.onDeselect(tab)><md-tab-label>{{ tab.name }}<span ng-show=\"tab.id != \'index\'\" ng-click=ctrl.delTab($index) class=close-tab><md-icon md-font-set=material-icons md-menu-align-target style=\"font-size: 1em\" class=text-danger>cancel<md-tooltip md-direction=bottom>{{ ctrl.text.close }} Tab</md-tooltip></md-icon></span></md-tab-label></md-tab></md-tabs><div ng-if=\"ctrl.currentTab.id == \'index\' &amp;&amp; !ctrl.loadingCard \" class=m0><list-card ng-if=\"ctrl.reportType == \'list\'\" list-id=ctrl.currentCustomReport.list.id schema-id=ctrl.currentCustomReport.list.schema custom-report=ctrl.currentCustomReport html=ctrl.html schemas-formats=ctrl.schemasFormats click-row=\"ctrl.setRowTab({row, schema, schemaId})\" remove-row=ctrl.clearTabs()></list-card><table-card ng-if=\"ctrl.reportType == \'table\'\" table=ctrl.currentCustomReport.table custom-report=ctrl.currentCustomReport html=ctrl.html schemas-formats=ctrl.schemasFormats click-row=\"ctrl.setRowTab({row, schema, schemaId})\" remove-row=ctrl.clearTabs()></table-card></div><md-card ng-if=\"ctrl.currentTab.id != \'index\' &amp;&amp; !ctrl.loadingCard\" class=\"m0 printSection\"><html-client-card row=ctrl.currentTab.row schema=ctrl.currentTab.schema schema-id=ctrl.currentTab.schemaId custom-report=ctrl.currentCustomReport html=ctrl.html schemas-formats=ctrl.schemasFormats columns=ctrl.columns class=w100><pre>{{ ctrl.html }}</pre></html-client-card></md-card></div></section></main>");
$templateCache.put("app/dashboard/dashboard.html","<main ng-cloak><md-toolbar class=main-color><div class=md-toolbar-tools><h2 flex md-truncate>&nbsp;{{ translation.management_panel | uppercase }}:<md-menu md-position-mode=\"target-right bottom\" md-offset=\"0 2\"><md-button style=\"min-width: 100px; padding: 0\" ng-click=$mdMenu.open($event) aria-label=\"Category selector\" class=\"md-raised white-text ceptinel lighten-1\"><div layout=row layout-align=\"space-between stretch\"><span flex=noshrink style=\"padding: 0 1rem 0 0.5rem\" class=\"ceptinel lighten-1\"><cep-icon icon=\"{{ ctrl.currentCategory.icon }}\" color=white style=\"top: 3px; position: relative\"></cep-icon>{{ ctrl.currentCategory.label || ctrl.currentCategory.name }}</span><span class=\"ceptinel darken-1\"><md-icon md-font-set=material-icons style=\"top: 3px\" class=white-text>keyboard_arrow_down</md-icon></span></div></md-button><md-menu-content class=md-dense><md-menu-item ng-repeat=\"item in ctrl.issueCategories\"><md-button ng-click=ctrl.changeCategory(item)><cep-icon icon=\"{{ item.icon }}\" color=\"{{ item.color }}\"></cep-icon>{{ item.label || item.name }}</md-button></md-menu-item></md-menu-content></md-menu><md-menu md-position-mode=\"target-right bottom\" md-offset=\"0 2\"><md-button style=\"min-width: 100px; padding: 0\" ng-click=$mdMenu.open($event) aria-label=\"Relationship selector\" class=\"md-raised white-text ceptinel lighten-1\"><div layout=row layout-align=\"space-between stretch\"><span flex=noshrink style=\"padding: 0 1rem 0 0.5rem\" class=\"ceptinel lighten-1\">{{ ctrl.getRelationshipName(ctrl.relatedBy) }}</span><span class=\"ceptinel darken-1\"><md-icon md-font-set=material-icons style=\"top: 3px\" class=white-text>keyboard_arrow_down</md-icon></span></div></md-button><md-menu-content class=md-dense><md-menu-item ng-repeat=\"item in ctrl.relationships\"><md-button ng-click=ctrl.changeRelationship(item.value)>{{ item.label }}</md-button></md-menu-item></md-menu-content></md-menu><md-menu md-position-mode=\"right bottom\" md-offset=\"0 2\"><md-button style=\"padding: 0\" aria-label=\"Date filter\" class=\"md-raised white-text\"><div layout=row layout-align=\"space-between stretch\"><span ng-click=\"ctrl.openMenu($mdMenu, $event)\" ng-class=\"{ \'lighten-1\': issueDates.active , \'darken-1\': !issueDates.active }\" flex=noshrink style=\"padding: 0 1rem 0 0.5rem\" class=ceptinel>{{ issueDates.from | asDate }} - {{ issueDates.to | asDate }}</span><span class=\"ceptinel darken-1\"><md-tooltip>{{ issueDates.active ? translation.filter_by_date_active : translation.filter_by_date_inactive }}</md-tooltip><md-icon md-font-set=material-icons style=\"top: 3px\" ng-click=ctrl.toggleIssueDatesActive() class=white-text>{{ issueDates.active ? \"check_box\" : \"check_box_outline_blank\" }}</md-icon></span></div></md-button><md-menu-content style=\"padding: 0\"><md-menu-item style=\"height: auto; padding: 0\"><div style=\"padding: 0px; margin: 0px\" class=issue_from_datepicker></div><div style=\"padding: 0px; margin: 0px\" class=issue_to_datepicker></div></md-menu-item></md-menu-content></md-menu></h2><div id=search-input class=text-right><input type=search placeholder=\"Search Ceptinel\" readonly ng-click=ctrl.onSearch($event) style=\"background: #2b303b; border: none; font-size: 14pt; color: #63717f; padding-left: 10px; -moz-border-radius: 5px; border-radius: 5px\"></div><div id=create-hint-button class=text-right><md-button has-permission=issues:create ng-click=\"ctrl.manageIssue({ ev })\" aria-label=\"Crete hint button\" ng-hide=\"ctrl.selectedTab == &quot;index&quot;\" class=\"pull-right md-fab md-mini md-hue-2\"><md-tooltip md-direction=left>{{ translation.create_hint }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target class=white-text>add</md-icon></md-button></div></div></md-toolbar><section layout=row layout-align=\"center stretch\"><aside flex=15 class=\"w100 relative noprint\"><div style=\"top: 70px !important\" class=sticky-top><dashboard-inbox-box issue-types=ctrl.issueTypes counter-values=ctrl.counters.byInbox view-action=\"ctrl.openTab(tab, icon, color, issueId)\" class=stiky></dashboard-inbox-box><md-card class=cep-dashboard-box><div style=\"padding: 5px; font-weight: 600\" class=\"grey lighten-4\"><cep-icon icon=cep-review></cep-icon>{{ translation.custom_views }}</div><md-divider></md-divider><div layout=row style=\"padding: 5px\" ng-repeat=\"view in ctrl.customViews | orderBy:&quot;id&quot;\" class=cep-hover><div flex=20 ng-click=ctrl.openCustomView(view) style=\"padding-top: 10px\" class=text-center><cep-icon icon=cep-tag></cep-icon></div><div flex=auto ng-click=ctrl.openCustomView(view) md-truncate style=\"padding-top: 10px\">{{ view.name | capitalize }}</div><div flex=20><md-menu><md-button aria-label=More ng-click=$mdMenu.open() style=\"margin: 0; padding: 0\" class=md-icon-button><md-icon md-font-set=material-icons class=md-icon-button>more_vert</md-icon></md-button><md-menu-content width=2 ng-mouseleave=$mdMenu.close()><md-menu-item><md-button ng-click=ctrl.deleteCustomView(view)>{{ translation.delete }}</md-button></md-menu-item></md-menu-content></md-menu></div><md-tooltip>{{ view.description ? view.description : view.name }}</md-tooltip></div></md-card></div></aside><md-divider></md-divider><div id=main-tab-dashboard flex><tabs-bar tabs=ctrl.tabs set-tab=ctrl.setTabAndCurrentIssue is-active=ctrl.isTabActive del-tab=ctrl.closeTab></tabs-bar><ng-include src=&quot;app/dashboard/includes/main.html&quot;></ng-include><section id=\"{{ issue.name }}\" ng-repeat=\"issue in ctrl.activeTabs track by $index\" ng-show=\"ctrl.isTabSet(&quot;{{ issue.name }}&quot;)\"><dashboard-issues-list related-by=ctrl.relatedBy issue-type=issue issue-types=ctrl.issueTypes selected-rows=ctrl.selectedRows manage-issue-fn=\"ctrl.manageIssue({ ev, selectedIssue, issuesToLink })\"></dashboard-issues-list></section></div></section></main>");
$templateCache.put("app/data-conn/data-conn.html","<div ng-cloak class=\"bs-component sticky-parent\"><md-card><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-data-connection scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>{{ translation.data_connection | uppercase }}</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button id=create-conex-btn ng-click=\"dataConn.openEditor($event, false)\" aria-label=\"Add connection button\" class=\"md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>{{ translation.add_connection }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></md-toolbar-filler></div></md-toolbar><md-toolbar style=\"background-color:#fafafa; color:black\"><div layout=row layout-align=\"end center\" class=md-toolbar-tools><div flex=1 style=\"display:inline-flex; position:relative; top:5px\"><md-icon md-font-set=material-icons style=top:23px class=text-main-color>search</md-icon><md-input-container style=\"padding-left:5px; top:12px\"><label>{{ translation.find }} {{ translation.rule }}</label><input ng-model=searchText autocomplete=off></md-input-container></div><div flex=1 style=display:inline-flex><md-menu md-position-mode=\"target-right target\"><button ng-click=$mdMenu.open($event) style=\"padding: .8rem\" aria-label=\"{{ translation.edit }}\" class=\"md-secondary text-main-color btn md-raised\"><md-tooltip>Sort by</md-tooltip><i class=material-icons>sort_by_alpha</i></button><md-menu-content width=4><md-menu-item><md-button ng-click=\"rules._orderBy(\'id\', false)\"><div layout=row flex><p flex>ID ASC</p><md-icon md-menu-align-target md-font-set=material-icons ng-if=\"mustOrderBy.field == \'id\' &amp;&amp; mustOrderBy.reverse == false\">done</md-icon></div></md-button></md-menu-item><md-menu-item><md-button ng-click=\"rules._orderBy(\'id\', true)\"><div layout=row flex><p flex>ID DESC</p><md-icon md-menu-align-target md-font-set=material-icons ng-if=\"mustOrderBy.field == \'id\' &amp;&amp; mustOrderBy.reverse == true\">done</md-icon></div></md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button ng-click=\"rules._orderBy(\'name\', false)\"><div layout=row flex><p flex>{{ translation.name }} ASC</p><md-icon md-menu-align-target md-font-set=material-icons ng-if=\"mustOrderBy.field == \'name\' &amp;&amp; mustOrderBy.reverse == false\">done</md-icon></div></md-button></md-menu-item><md-menu-item><md-button ng-click=\"rules._orderBy(\'name\', true)\"><div layout=row flex><p flex>{{ translation.name }} DESC</p><md-icon md-menu-align-target md-font-set=material-icons ng-if=\"mustOrderBy.field == \'name\' &amp;&amp; mustOrderBy.reverse == true\">done</md-icon></div></md-button></md-menu-item></md-menu-content></md-menu></div></div></md-toolbar><md-list flex><md-list-item style=\"border-bottom: 1px solid #eaeaea;padding: 1.8rem\" layout=row ng-if=!dataConn.connections.length class=md-no-proxy><div flex>&nbsp;</div><h4 class=panel-title>{{ translation.msg_withoutConex }} &nbsp; &nbsp;</h4><md-button id=create-first-conex-btn has-permission=function:create ng-click=\"dataConn.openEditor($event, false)\" aria-label=\"Add function button\" class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=right>{{ translation.add_connection }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button><div flex>&nbsp;</div></md-list-item><md-list-item ng-repeat=\"conex in dataConn.connections | filter:searchText | orderBy:mustOrderBy.field:mustOrderBy.reverse\" style=\"border-bottom: 1px solid #eaeaea;padding: 1.8rem\" class=md-no-proxy><div class=\"row w100\"><div class=col-md-6><div layout=row><div><md-icon md-font-set=material-icons ng-style=\"true ? {\'background-color\':\'#2E7D32\'} : {\'background-color\':\'red\'}\" class=md-avatar-icon>usb</md-icon></div><div><span>ID: {{ conex.id }} /&nbsp;</span><span>{{ conex.protocolType }}</span><br><span>{{ translation.conex }}:</span><b style=font-size:1.2em>{{ conex.name }}</b><br><span>{{ conex.description }}</span></div></div></div><div class=col-md-2><button style=\"padding: .8rem\" aria-label=\"Connection status\" class=\"md-secondary text-main-color btn md-raised\"><i ng-style=\"conex.schemasCache ? {color:\'#2E7D32\'} : {color:\'red\'}\" class=material-icons>{{ conex.schemasCache ? \"done\" : \"error\" }}</i><md-tooltip>{{ conex.schemasCache ? \"Connection tested\" : \"Not tested\" }}</md-tooltip></button> <button has-permission=data-connection#{{conex.name}}:read ng-click=\"dataConn.openEditor($event, conex)\" style=\"padding: .8rem\" aria-label=\"{{ translation.edit }}\" class=\"md-secondary text-main-color btn md-raised\"><i class=material-icons>apps</i><md-tooltip>{{ translation.properties }}</md-tooltip></button> <button has-permission=data-connection#{{conex.name}}:delete ng-click=dataConn.deleteConnection(conex) style=\"padding: .8rem\" aria-label=\"{{ translation.delete }}\" class=\"md-secondary text-main-color btn md-raised\"><i class=material-icons>delete</i><md-tooltip>{{ translation.delete }} {{ translation.conex }}</md-tooltip></button> <button has-permission=data-connection#{{conex.name}}:run ng-click=dataConn.testConnection(conex) style=\"padding: .8rem\" aria-label=\"Test connection button\" class=\"md-secondary text-main-color btn md-raised\"><i ng-if=!rule.onProgress class=material-icons>play_arrow</i><md-tooltip>{{ translation.test }} {{ translation.conex }}</md-tooltip></button> <button has-permission=data-connection#{{conex.name}}:share ng-click=dataConn.showShareEntityDialog(conex.name) style=\"padding: 0.8rem\" aria-label=share class=\"md-secondary text-main-color btn md-raised\"><i class=material-icons>share</i><md-tooltip>share</md-tooltip></button></div></div></md-list-item></md-list></md-card></div>");
$templateCache.put("app/data-management/data-management.html","<div class=\"bs-component sticky-parent\"><md-card><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-data-management scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=md-toolbar-tools><span>{{ ctrl.translation.schemas }}</span></h2><div style=\"display: flex;flex-direction: row;align-content: center;align-items: center\"><md-button has-permission=data-management:create aria-label=newTable ng-click=ctrl.tableManagement() class=md-raised><md-icon md-font-set=material-icons>add</md-icon>{{ ctrl.translation.createTable }}</md-button></div></div></md-toolbar><md-card-content><md-content ng-if=isLoading><p>{{ ctrl.translation.loading }}</p><md-progress-linear md-mode=indeterminate></md-progress-linear></md-content><md-content ng-if=\"!isLoading &amp;&amp; showSchemaTables == null\"><md-list flex=\"\"><md-list-item ng-repeat=\"schema in ctrl.schemas track by $id(schema)\" ng-click=ctrl.goToSchema(schema.name) class=md-3-line><div layout=column class=md-list-item-text><h3>{{ schema.name }}</h3></div><md-button has-permission=data-management-schemas#{{schema.name}}:share ng-click=ctrl.showShareEntityDialog(schema.name) style=\"padding: 0.8rem\" aria-label=share class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>share</md-icon><md-tooltip>{{ ctrl.translation.share }}</md-tooltip></md-button></md-list-item></md-list></md-content></md-card-content></md-card></div>");
$templateCache.put("app/directives/event-replay.html","<div context-menu=menuOptions><div style=\"height: 75vh\" layout=row layout-align=\"center center\"><div class=themeLogo></div></div></div>");
$templateCache.put("app/directives/menu-replay.html","<md-toolbar class=md-hue-2><div class=md-toolbar-tools><md-menu><md-button aria-label=\"Open menu\" ng-click=$mdMenu.open(); class=md-icon-button><md-icon md-font-set=material-icons>menu</md-icon></md-button><md-menu-content width=3></md-menu-content></md-menu><h2 flex md-truncate>{{$ctrl.title}}</h2><md-chips ng-model=$ctrl.symbols md-autocomplete-snap md-transform-chip=$ctrl.transformChip($chip) md-require-match=false md-highlight-flags=i ng-hide=$root.isFullScreen><md-autocomplete md-selected-item=$ctrl.selectedItem md-search-text=$ctrl.searchText md-items=\"item in $ctrl.querySearch($ctrl.searchText)\" md-item-text=item.name md-min-length=\"$ctrl.symbols.length ? 1 : 0\" placeholder={{translation.select_item}}><span md-highlight-text=$ctrl.searchText>{{item.name}}</span><md-not-found>{{translation.no_matches}}</md-not-found></md-autocomplete><md-chip-template><span><strong>{{$chip.name}}</strong></span></md-chip-template></md-chips><section layout=row layout-align=\"center center\"><md-menu ng-show=\"$ctrl.fnMarginal &amp;&amp; !$root.isFullScreen\"><md-button aria-label=\"Cambiar Escala\" ng-click=$mdMenu.open();><md-tooltip>{{translation.tooltip_filter}}</md-tooltip>{{ $ctrl.states.porcentajeMarginal }}% ▼</md-button><md-menu-content width=2><md-menu-item><md-button ng-click=\"$ctrl.fnMarginal(\'0\')\">0%</md-button></md-menu-item><md-menu-item><md-button ng-click=\"$ctrl.fnMarginal(\'5\')\">5%</md-button></md-menu-item><md-menu-item><md-button ng-click=\"$ctrl.fnMarginal(\'10\')\">10%</md-button></md-menu-item><md-menu-item><md-button ng-click=\"$ctrl.fnMarginal(\'20\')\">20%</md-button></md-menu-item><md-menu-item><md-button ng-click=\"$ctrl.fnMarginal(\'30\')\">30%</md-button></md-menu-item><md-menu-item><md-button ng-click=\"$ctrl.fnMarginal(\'40\')\">40%</md-button></md-menu-item><md-menu-item><md-button ng-click=\"$ctrl.fnMarginal(\'50\')\">50%</md-button></md-menu-item></md-menu-content></md-menu><md-menu ng-show=\"$ctrl.fnAgregation &amp;&amp; !$root.isFullScreen\"><md-button aria-label=\"Cambiar Escala\" ng-click=$mdMenu.open();><md-tooltip>{{translation.aggregation_period}}</md-tooltip>{{ $ctrl.states.tipoAgregacion }} ▼</md-button><md-menu-content width=2><md-menu-item><md-button ng-click=\"$ctrl.fnAgregation(\'1S\')\">1 {{translation.Sec}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"$ctrl.fnAgregation(\'1M\')\">1 {{translation.Min}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"$ctrl.fnAgregation(\'1H\')\">1 {{translation.Hour}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"$ctrl.fnAgregation(\'1D\')\">1 {{translation.Day}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"$ctrl.fnAgregation(\'1W\')\">1 {{translation.Week}}</md-button></md-menu-item></md-menu-content></md-menu><md-button style=margin:0 ng-click=\"$ctrl.fnView(\'solapada\')\" ng-show=\"$ctrl.fnView &amp;&amp; $ctrl.states.tipoVista == \'apilada\'\" aria-label={{translation.change_view}} class=groupX><md-tooltip>{{translation.change_view}}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>web</md-icon></md-button><md-button style=margin:0 ng-click=\"$ctrl.fnView(\'apilada\')\" ng-show=\"$ctrl.fnView &amp;&amp; $ctrl.states.tipoVista == \'solapada\'\" aria-label={{translation.change_view}} class=groupX><md-tooltip>{{translation.change_view}}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>&#xE069;</md-icon></md-button><md-button style=margin:0 ng-click=\"$ctrl.fnMouse(\'zoom\')\" ng-show=\"$ctrl.fnMouse &amp;&amp; $ctrl.states.tipoMouse == \'pan\'\" aria-label={{translation.mouse_action}} class=groupX><md-tooltip>{{translation.mouse_action}}</md-tooltip><md-icon md-font-set=material-icons>swap_horiz</md-icon></md-button><md-button style=margin:0 ng-click=\"$ctrl.fnMouse(\'pan\')\" ng-show=\"$ctrl.fnMouse &amp;&amp; $ctrl.states.tipoMouse == \'zoom\'\" aria-label={{translation.mouse_action}} class=groupX><md-tooltip>{{translation.mouse_action}}</md-tooltip><md-icon md-font-set=material-icons>select_all</md-icon></md-button><md-button style=margin:0 ng-click=$ctrl.toggleRight() ng-show=$ctrl.bookmarks aria-label={{translation.intervals}} class=groupX><md-tooltip>{{translation.intervals}}</md-tooltip><md-icon md-font-set=material-icons>bookmarks</md-icon></md-button><md-button style=margin:0 ng-click=\"$root.isFullScreen = !$root.isFullScreen\" aria-label={{translation.full_screen}} class=groupX><md-tooltip>{{translation.full_screen}}</md-tooltip><md-icon md-font-set=material-icons>aspect_ratio</md-icon></md-button><md-button style=margin:0 ng-show=\"$ctrl.states.conexion === 1\" aria-label={{translation.connected}} ng-click=$ctrl.fnStopSocket() class=groupX><md-tooltip>{{translation.connected}} - Click to Disconect</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target style=color:#55e455>wifi</md-icon></md-button><md-button style=margin:0 ng-show=\"$ctrl.states.conexion === 2\" aria-label={{translation.connecting}} class=groupX><md-tooltip>{{translation.connecting}}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target class=fa-spin>autorenew</md-icon></md-button><md-button style=margin:0 ng-show=\"$ctrl.states.conexion === 0\" aria-label={{translation.disconnected}} ng-click=$ctrl.fnStartSocket() class=groupX><md-tooltip>{{translation.disconnected}} - Click to Connect</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target style=color:red>sync_disabled</md-icon></md-button></section></div></md-toolbar><md-sidenav md-component-id=right md-whiteframe=4 style=height:70vh class=md-sidenav-right><md-toolbar style=\"background-color:white; color: black\"><div style=display:initial class=md-toolbar-tools><h6>Event Replay</h6><h1 flex>{{$ctrl.title}}</h1></div></md-toolbar><md-list><md-subheader style=font-size:.7em class=md-no-sticky>BOOKMARKS<md-menu><md-button ng-click=$mdMenu.open(); aria-label={{translation.save_interval}} class=md-icon-button><md-tooltip>{{translation.save_interval}}</md-tooltip><md-icon md-font-set=material-icons>add_circle_outline</md-icon></md-button><md-menu-content width=3><md-menu-item style=margin-top:15px><md-input-container><label>{{translation.label}}</label><input type=text ng-model=intervalTag></md-input-container></md-menu-item><md-menu-item><md-button ng-click=$ctrl.fnSetInterval(intervalTag)><md-icon md-font-set=material-icons md-menu-align-target>save</md-icon>{{translation.save}}</md-button></md-menu-item></md-menu-content></md-menu></md-subheader><md-list-item ng-repeat=\"bookmark in $ctrl.bookmarks\" ng-click=$ctrl.fnGoInterval(bookmark) class=md-2-line><div class=md-list-item-text><h3>{{ bookmark.title || \"Bookmark: \" + bookmark.id }}</h3><p style=font-size:.8em>{{ bookmark.from }} - {{ bookmark.to }}</p><p>Itms: {{ bookmark.symbols.join(\", \") }}</p><md-menu class=md-secondary><md-button aria-label=\"Open menu\" ng-click=$mdMenu.open(); class=md-icon-button><md-icon md-font-set=material-icons>more_vert</md-icon></md-button><md-menu-content width=3><md-menu-item><md-button ng-click=$ctrl.fnDelInterval(bookmark) aria-label={{translation.delete}}><md-icon md-font-set=material-icons md-menu-align-target>delete</md-icon>{{translation.delete}}</md-button></md-menu-item></md-menu-content></md-menu></div></md-list-item></md-list><md-divider></md-divider><md-content layout-margin><md-button ng-click=$ctrl.toggleRight() aria-label={{translation.close}} class=md-accent>{{translation.close}}</md-button></md-content></md-sidenav>");
$templateCache.put("app/directives/modal-workspaces.html","<div tabindex=-1 role=dialog class=modal><div class=\"modal-dialog modal-lg\"><div class=modal-content><div class=modal-header><a type=button abm-component ng-click=$hide() class=close>×</a><h4 class=\"modal-title small-header\">{{ translation.Workspaces }}</h4></div><div class=modal-body><div ng-cloak=\"\"><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-autoselect=true><md-tab ng-repeat=\"schema in config.schemas\" ng-click=\"alert(\'label\')\" label={{schema.workspaceName}}><md-content class=md-padding><div layout=row layout-align=\"start start\" layout-wrap><div ng-repeat=\"(key, item) in config.columns\" flex=100 flex-gt-sm=33 ng-if=!item.hidden><md-checkbox ng-model=config.columns[key].show aria-label=\"{{ item.title }}\"><span>{{ translation[item.title] || item.title }}&nbsp;</span><span style=\"font-size:.8em; width: 25px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis\" ng-show=\"{{ item.rule ? true : false }}\">({{ item.ruleDesc }})</span></md-checkbox></div></div><div layout=row layout-align=\"start start\" layout-wrap><md-input-container><label>{{ translation.Name }}</label><input ng-model=schema.workspaceName></md-input-container></div><div layout=row layout-align=\"start start\" layout-wrap class=pull-right><md-button ng-click=setDefaultSchema() class=\"md-primary md-raised\">{{ translation.set_defaults }}</md-button><md-button ng-click=\"saveSchema( schema )\" class=\"md-primary md-raised\">{{ translation.Save_changes }}</md-button></div></md-content></md-tab></md-tabs></md-content></div></div></div></div></div>");
$templateCache.put("app/directives/ngtable-dynamic.html","<div layout=column ng-cloak=\"\"><script id=headerCheckbox.html type=text/ng-template><input type=\"checkbox\" ng-model=\"ctrl.selectedItems.checked\" value=\"\" style=\"width: 18px; height: 18px\"></script><md-card-content><div ng-if=ctrl.showTopBar><div layout=row layout-align=\"space-between center\"><div flex md-position-mode=\"target-right target\" ng-if=\"ctrl.showExportCsvButton || ctrl.showRefreshButton\"><md-menu><md-button aria-label=More ng-click=$mdMenu.open() class=md-icon-button><md-icon md-font-set=material-icons class=\"md-icon-button md-secondary\">more_vert</md-icon></md-button><md-menu-content width=2 ng-mouseleave=$mdMenu.close()><md-menu-item ng-if=\"ctrl.showRemoveRowsButton &amp;&amp; ctrl.selectedItems.items\"><md-button ng-click=ctrl.onDeleteManyRow()>Remove rows</md-button></md-menu-item><md-menu-item ng-if=ctrl.showExportCsvButton><md-button ng-click=ctrl.onExportCsv()>{{ translation.EXPORT }}</md-button></md-menu-item><md-menu-item ng-if=ctrl.showRefreshButton><md-button ng-click=ctrl.onRefresh()>{{ translation.REFRESH }}</md-button></md-menu-item></md-menu-content></md-menu><label>{{ ctrl.labelRowsTotal }}</label></div><div flex ng-if=ctrl.showFilterButton><md-button style=\"margin: 0px\" aria-label=filter_list ng-click=\"ctrl.shouldShowFilters = !ctrl.shouldShowFilters\"><md-icon md-font-set=material-icons class=\"md-icon-button md-secondary\">filter_list</md-icon><span>{{ translation.Filters }} -</span></md-button></div><div flex><div ng-transclude=extend></div></div></div><div ng-if=\"ctrl.shouldShowFilters === true\" layout=column style=\"border: 1px #dedede solid; padding: 30px 10px 10px 10px\"><div layout=row layout-xs=column layout-wrap><div ng-repeat=\"col in ctrl.config.columns track by $index\" ng-if=\"col.filterable !== undefined\" style=\"margin: 0px\" flex=25 flex-xs=100><md-input-container ng-if=\"col.filterable.type===\'number\'\" style=\"margin: 0px; width: 100%\"><label>{{ col.title }}</label><input type=text ng-model=ctrl.filters[col.field]></md-input-container><md-input-container ng-if=\"col.filterable.type===\'text\'\" style=\"margin: 0px; width: 100%\"><label>{{ col.title }}</label><input type=text ng-model=ctrl.filters[col.field]></md-input-container><md-input-container style=\"margin: 0px; width: 100%\" ng-if=\"col.filterable.type===\'select\'\"><label>{{ col.title }}</label><md-select style=\"text-transform: uppercase\" ng-model=ctrl.filters[col.field] data-md-container-class=selectSelectHeader md-on-close=ctrl.clearSearchTerm() multiple><md-select-header class=select-header><input ng-model=ctrl.searchTerm type=search placeholder=Search... ng-keydown=$event.stopPropagation() class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=\"{{ col.title }}\"><md-option ng-repeat=\"option in col.filterable.options | filter: ctrl.searchTerm\" value=\"{{ option.key }}\" ng-selected=option.selected>{{ option.value }}</md-option></md-optgroup></md-select></md-input-container></div></div><div layout=row layout-align=\"end start\" layout-wrap style=\"margin-top: 20px\"><md-button ng-click=ctrl.cleanFilter() class=md-raised>{{ translation.CLEAN }}</md-button><md-button ng-click=ctrl.applyFilters() class=cep-background>{{ translation.APPLY_FILTERS }}</md-button></div></div></div><md-progress-linear ng-hide=ctrl.loadedCaseTable></md-progress-linear><md-content layout-padding=\"\"><table ng-table-dynamic=\"ctrl[ctrl.id] with ctrl.config.columns\" class=\"table table-condensed table-bordered table-hover\"><colgroup><col ng-repeat=\"col in ctrl.config.columns\" width={{col.width}}%></colgroup><tr ng-repeat=\"item in $data track by $index\" ng-class=ctrl.ngClass><td ng-repeat=\"col in ctrl.config.columns\" ng-if=col.show title=\"{{ col.title }}\" sortable><span ng-switch on=col.type><div ng-switch-when=checkbox class=text-center><input type=checkbox ng-model=ctrl.selectedItems.items[item.id] aria-label=\"Select Event\" style=\"width: 18px; height: 18px\"></div><div ng-switch-when=cepicon ng-click=ctrl.onClick(item)><cep-icon icon=\"{{ item[col.field] }}\"></cep-icon></div><div ng-switch-when=date ng-click=ctrl.onClick(item)>{{ item[col.field] | asDate }}</div><div ng-switch-when=time ng-click=ctrl.onClick(item)>{{ item[col.field] | asHour }}</div><div ng-switch-when=datetime ng-click=ctrl.onClick(item)>{{ item[col.field] | asDateHour }}</div><div ng-switch-when=object ng-click=ctrl.onClick(item)>{{ item[col.field][col.key] | capitalize }}</div><div ng-switch-when=number ng-click=ctrl.onClick(item)>{{ item[col.field] }}</div><div ng-switch-when=boolean ng-click=ctrl.onClick(item) ng-style=\"item[col.field] == \'f\' || item[col.field] == false ? {\'color\':\'red\'} : {\'color\':\'#2E7D32\'}\">{{ item[col.field] == \"t\" || item[col.field] == true ? translation.active : translation.inactive }}</div><div ng-switch-when=command class=text-center><span ng-switch on=col.field><md-icon ng-switch-when=delete has-permission={{item.resource}}#{{item.id}}:delete md-font-set=material-icons ng-click=ctrl.onDeleteRow(item)>delete<md-tooltip md-direction=left>Delete</md-tooltip></md-icon><md-icon ng-switch-when=search md-font-set=material-icons ng-click=ctrl.onSearch(item)>search<md-tooltip md-direction=left>Search</md-tooltip></md-icon><md-icon ng-switch-when=share has-permission={{item.resource}}#{{item.id}}:share md-font-set=material-icons ng-click=ctrl.onShare(item)>share<md-tooltip md-direction=left>Share</md-tooltip></md-icon><md-icon ng-switch-when=build md-font-set=material-icons ng-click=ctrl.onBuild(item)>settings_suggest<md-tooltip md-direction=left>Build index<div ng-switch-when=export></div></md-tooltip></md-icon></span></div><div ng-switch-when=export><md-icon md-font-set=material-icons ng-click=ctrl.onExportRow(item)>file_download</md-icon><md-tooltip md-direction=left>{{ translation.EXPORT_JSON }}</md-tooltip></div><div ng-switch-default ng-click=ctrl.onClick(item) tipo-event-text=\"{{ item[col.field] }}\">{{ item[col.field] }}</div></span></td></tr></table></md-content></md-card-content></div>");
$templateCache.put("app/directives/risk-datatable.html","<div><table id={{id}} datatable=ng style=width:100% class=mdl-data-table><thead><tr><th></th><th>id</th><th>Fecha/Hora</th><th>Descripción</th><th>Tipo</th><th>Criticidad</th><th>Estado</th></tr></thead><tbody><tr ng-repeat=\"(keyData, data) in data\" ng-attr-title={{config.style.trTooltip(data)}} class={{config.style.trStyle(data)}}><td><input type=checkbox ng-click=\"checkEvent(data[\'id\'])\"></td><td class=text-capitalize>{{data[\'id\']}}</td><td class=text-capitalize>{{data[\'timestamp\']}}</td><td class=text-capitalize>{{data[\'ruleDescription\']}}</td><td class=text-capitalize>{{data[\'labels\']}}</td><td class=text-capitalize>{{data[\'criticality\']}}</td><td class=text-capitalize>{{data[\'status\']}}</td></tr></tbody></table></div>");
$templateCache.put("app/directives/risk-grid-legacy.html","<div><div class=filters><div class=header><form class=form-inline><div style=\"margin-top:0px; padding-bottom:0px\" class=\"form-group pull-left\"><div ng-repeat=\"(key, value) in config.columns\" ng-if=\"value.filterable!==undefined\" class=input-group><div class=dropdown><button type=button id=dropdown{{value.name}} data-toggle=dropdown aria-haspopup=true aria-expanded=true class=\"btn dropdown-toggle\">{{value.title}}<span class=caret></span></button><ul class=dropdown-menu><div ng-if=\"value.filterable.type===\'number\'\"><li class=input-group>Min <input type=text placeholder={{translation.BUSCAR}} ng-model=filters[value.name].min class=form-control></li><li class=input-group>Max <input type=text placeholder={{translation.BUSCAR}} ng-model=filters[value.name].max class=form-control></li></div><div ng-if=\"value.filterable.type===\'string\'\"><li class=input-group>{{translation.CONTIENE}} <input type=text placeholder={{translation.BUSCAR}} ng-model=filters[value.name].query class=form-control></li></div><div ng-if=\"value.filterable.type===\'checkbox\'\"><li class=input-group><input type=text placeholder={{translation.BUSCAR}} ng-model=innerQuery[value.name] class=form-control><div class=input-group-addon><i class=\"glyphicon glyphicon-search\"></i></div></li><li role=separator class=divider></li><li ng-repeat-start=\"(innerKey, innerValue) in filters[value.name]\" ng-show=\"showFilter(innerQuery[value.name], innerKey)\" class=input-group><div class=input-group-addon><input type=checkbox ng-model=filters[value.name][innerKey]></div><div class=\"form-control text-capitalize\">{{ innerKey }}</div></li><div ng-repeat-end></div></div></ul></div></div></div><div ng-show=\"id===\'casos-table\'\" class=search-content><input id=btn-search name=search type=search ng-model=searchCase on-enter=search() ng-change=searchOnChange() placeholder={{translation.QUE_BUSCAMOS}}> <input id=btn-search-icon value=Rechercher type=submit></div></form></div></div><table id={{id}} cellspacing=100px class=\"risk-table {{tableCss}}\"><thead><tr><th ng-repeat=\"(key, value) in config.columns\" ng-show=!value.hidden><span ng-click=sort(value)>{{value.title}}<span style=\"font-size:10px; padding:5px\" ng-show=value.sortable><span ng-show=\"(config.datasource.params.sortBy == value.name &amp;&amp; sortReverse) \" class=\"glyphicon glyphicon-chevron-up\"></span><span ng-show=\"(config.datasource.params.sortBy == value.name &amp;&amp; !sortReverse) || (config.datasource.params.sortBy===\'\' || config.datasource.params.sortBy !== value.name)\" class=\"glyphicon glyphicon-chevron-down\"></span></span></span></th></tr></thead><tbody ng-hide=asignacion><tr ng-repeat=\"(keyData, data) in data\" ng-click=fnClick(data) ng-dblclick=fnDblClick(data) ng-attr-title={{config.style.trTooltip(data)}} class={{config.style.trStyle(data)}}><td ng-repeat=\"(keyColumn, column) in config.columns\" ng-show=!column.hidden class=text-capitalize>{{data[column.name]}}</td></tr></tbody><tbody ng-show=asignacion><tr ng-repeat=\"(keyData, data) in data\" ng-attr-title={{config.style.trTooltip(data)}} class={{config.style.trStyle(data)}}><td class=text-capitalize>{{data[\'id\']}}</td><td class=text-capitalize>{{data[\'timestamp\']}}</td><td class=text-capitalize>{{data[\'ruleDescription\']}}</td><td class=text-capitalize>{{data[\'labels\']}}</td><td class=text-capitalize>{{data[\'criticality\']}}</td><td class=text-capitalize>{{data[\'status\']}}</td><td><md-checkbox ng-click=\"checkEvent(data[\'id\'])\" ng-checked=\"selectedItms.indexOf(data[\'id\']) &gt;= 0\" aria-label=\"Select Event\" class=md-primary></md-checkbox></td></tr></tbody><tfoot><tr><td colspan={{visibleColumns-2}} class=text-center><ul class=pagination><li ng-show=showLessArrow()><a ng-click=goToPage(&quot;start&quot;)>«</a></li><li ng-show=showLessArrow()><a ng-click=goToPage(&quot;1less&quot;)>&lt;</a></li><li ng-repeat=\"pagina in pagination.rule\" ng-class=\"{ active: pagina == pagination.page }\"><a ng-click=goToPage(pagina)>{{ pagina }}</a></li><li ng-show=showMoreArrow()><a ng-click=goToPage(&quot;1more&quot;)>&gt;</a></li><li ng-show=showMoreArrow()><a ng-click=goToPage(&quot;end&quot;)>»<div class=ripple-container></div></a></li></ul></td><td colspan=2 ng-hide=asignacion><a ng-click=exportExcel() ng-show=toExcel class=\"btn btn-rosado pull-right\">{{translation.EXPORTAR_EXCEL}} {{ toExcel }}</a><a ng-click=fnRefresh() ng-show=fnRefresh class=\"btn btn-rosado pull-right\"> {{translation.REFRESCAR}}</a></td></tr></tfoot></table></div>");
$templateCache.put("app/directives/risk-grid.html","<div><md-menu><md-button aria-label=\"Open menu with custom trigger\" ng-click=$mdMenu.open() class=\"md-primary pull-right\"><i class=\"fa fa-ellipsis-v\"></i></md-button><md-menu-content width=4 ng-mouseleave=$mdMenu.close()><md-menu-item><md-button ng-click=toogleAutoRefresh() ng-if=toExcel>{{translation.automatic_refresh}}<md-icon md-font-set=material-icons ng-show=autoRefresh>done</md-icon></md-button></md-menu-item><md-menu-item><md-button ng-click=openFilters()>Workspaces</md-button></md-menu-item><md-menu-item><md-button ng-click=goToRankings()>Rankings</md-button></md-menu-item><md-menu-item><md-button ng-click=exportExcel() ng-if=toExcel>{{translation.EXPORTAR_EXCEL}} {{ toExcel }}</md-button></md-menu-item><md-menu-item ng-if=\"fnAddEventsToCase &amp;&amp; withMultipleSelection()==\'true\'\"><md-button ng-click=fnAddEventsToCase()>{{translation.ADD_EVENTS_TO_CASE}}</md-button></md-menu-item></md-menu-content></md-menu><md-button ng-click=\"shouldShowFilters = !shouldShowFilters\"><md-icon md-font-set=material-icons>filter_list</md-icon><span>&nbsp; {{translation.Filters}}</span></md-button><div ng-show=shouldShowFilters class=filters><div class=header><form class=form-inline><div style=\"margin-top:0px; padding-bottom:0px; width: 100%\" class=\"form-group pull-left\"><div ng-repeat=\"(key, value) in config.columns\" ng-if=\"value.filterable !== undefined &amp;&amp; value.filterable !== \'false\' &amp;&amp; value.show == true\" style=padding:2px class=input-group><div class=dropdown><md-button style=\"border:0px solid gray\" type=button id=dropdown{{value.name}} data-toggle=dropdown aria-haspopup=true aria-expanded=true ng-class=\"{ &quot;filter-active&quot; : filters[value.name][&quot;query&quot;] || filters[value.name][&quot;min&quot;] || filters[value.name][&quot;max&quot;] || dynamicFilters[value.key][&quot;query&quot;] || filters[value.name][&quot;visto&quot;] || filters[value.name][&quot;no visto&quot;] || filters[value.name][&quot;baja&quot;] || filters[value.name][&quot;media&quot;] || filters[value.name][&quot;alta&quot;] || dynamicFilters[value.key][&quot;min&quot;] || dynamicFilters[value.key][&quot;max&quot;] || dynamicFilters[value.key][&quot;autocomplete&quot;] }\" class=\"md-raised btn dropdown-toggle\">{{ translation[value.title] || value.title}}<span class=caret></span></md-button><ul class=dropdown-menu><div ng-if=\"value.filterable.type===\'autocomplete\'\"><li class=input-group><div class=col-md-9><md-autocomplete md-input-name=autocompleteField md-floating-label=Value md-no-cache=false md-selected-item=dynamicFilters[value.key].autocomplete md-search-text=dynamicFilters[value.key].query md-items=\"item in querySearch(dynamicFilters[value.key].query, value.key)\" md-item-text=item.text md-min-length=0 md-clear-button=true><md-item-template><span md-highlight-text=searchText>{{item.text}}</span></md-item-template><md-not-found>Without results for \"{{searchText}}\".</md-not-found></md-autocomplete></div></li></div><div ng-if=\"value.filterable.type===\'number\'\"><li class=input-group>Min <input type=number step=0.01 placeholder={{translation.BUSCAR}} ng-if=\"value.type==\'object\'\" ng-model=dynamicFilters[value.name].min class=form-control> <input type=number step=0.01 placeholder={{translation.BUSCAR}} ng-if=\"value.type!=\'object\'\" ng-model=filters[value.name].min class=form-control></li><li class=input-group>Max <input type=number placeholder={{translation.BUSCAR}} ng-if=\"value.type==\'object\'\" ng-model=dynamicFilters[value.name].max class=form-control> <input type=number placeholder={{translation.BUSCAR}} ng-if=\"value.type!=\'object\'\" ng-model=filters[value.name].max class=form-control></li></div><div ng-if=\"value.filterable.type===\'string\'\"><li class=input-group>{{translation.CONTIENE}} <input type=text placeholder={{translation.BUSCAR}} ng-if=\"value.type==\'object\'\" ng-model=dynamicFilters[value.key].query class=form-control> <input type=text placeholder={{translation.BUSCAR}} ng-if=\"value.type!=\'object\'\" ng-model=filters[value.name].query class=form-control></li></div><div ng-if=\"value.filterable.type===\'checkbox\'\"><li class=input-group><input type=text placeholder={{translation.BUSCAR}} ng-model=innerQuery[value.name] class=form-control><div class=input-group-addon><i class=\"glyphicon glyphicon-search\"></i></div></li><li role=separator class=divider></li><li ng-repeat-start=\"(innerKey, innerValue) in filters[value.name]\" ng-show=\"showFilter(innerQuery[value.name], innerKey)\" class=input-group><div class=input-group-addon><input type=checkbox ng-model=filters[value.name][innerKey]></div><div class=\"form-control text-capitalize\">{{innerKey}}</div></li><div ng-repeat-end></div></div></ul></div></div><br><md-button ng-click=api.queryFilters() class=\"cep-background md-raised pull-right\">Aplicar Filtros</md-button></div><div ng-show=\"id===\'casos-table\'\" class=search-content><input id=btn-search name=search type=search ng-model=searchCase on-enter=search() ng-change=searchOnChange() placeholder={{translation.QUE_BUSCAMOS}}> <input id=btn-search-icon value=Rechercher type=submit></div></form></div></div><table id={{id}} cellspacing=100px class=\"risk-table {{tableCss}}\"><thead><tr><th ng-if=\"withMultipleSelection()==\'true\'\"><md-checkbox ng-model=selectedAll ng-click=checkAll(selectedAll) style=\"width: 18px;height: 18px\"></md-checkbox></th><th ng-repeat=\"(key, value) in config.columns\" ng-show=value.show><span ng-if=!value.sortable>{{ translation[value.title] || value.title}}</span><span ng-click=sort(value) ng-if=value.sortable>{{ translation[value.title] || value.title}}<span style=\"font-size:10px; padding:5px\"><span ng-show=\"(config.datasource.params.sortBy == value.name &amp;&amp; sortReverse) \" class=\"glyphicon glyphicon-chevron-up\"></span><span ng-show=\"(config.datasource.params.sortBy == value.name &amp;&amp; !sortReverse) || (config.datasource.params.sortBy===\'\' || config.datasource.params.sortBy !== value.name)\" class=\"glyphicon glyphicon-chevron-down\"></span></span></span></th></tr></thead><tbody ng-if=!asignacion><tr ng-if=!data.length><td style=\"text-align:center; padding:25vh\" colspan={{visibleCols}}><div class=themeLogo></div><md-progress-linear md-mode=query ng-disabled=!loader.show></md-progress-linear><md-progress-linear md-mode=determinate ng-value=loader.value ng-show=loader.show class=\"md-accent md-hue-2\"></md-progress-linear><div class=bottom-block><span style=font-weight:700>{{msgLoader}}</span></div></td></tr><tr ng-repeat=\"(keyData, data) in data\" ng-dblclick=fnDblClick(data) ng-attr-title={{config.style.trTooltip(data)}} class={{config.style.trStyle(data)}}><td ng-if=\"withMultipleSelection()==\'true\'\"><input type=checkbox ng-checked=\"data[\'selected\']\" ng-click=\"checkEvent(data[\'id\'])\" aria-label=\"Select Event\" style=\"width: 18px;height: 18px\"></td><td ng-repeat=\"(keyColumn, column) in config.columns\" ng-show=column.show ng-click=fnClick(data) class=text-capitalize>{{ parseNum(data[column.name], column.col) }}</td></tr></tbody><tbody ng-if=asignacion><tr ng-repeat=\"(keyData, data) in data\" ng-attr-title={{config.style.trTooltip(data)}} class={{config.style.trStyle(data)}}><td class=text-capitalize>{{data[\'id\']}}</td><td class=text-capitalize>{{data[\'timestamp\']}}</td><td class=text-capitalize>{{data[\'ruleDescription\']}}</td><td class=text-capitalize>{{data[\'labels\']}}</td><td class=text-capitalize>{{data[\'criticality\']}}</td><td class=text-capitalize>{{data[\'status\']}}</td><td><md-checkbox ng-click=\"checkEvent(data[\'id\'])\" ng-checked=\"selectedItms.indexOf(data[\'id\']) &gt;= 0\" aria-label=\"Select Event\" class=md-primary></md-checkbox></td></tr></tbody><tfoot ng-show=\"pagination.totalRecords &gt; 0\"><tr><td style=font-size:.8em colspan={{visibleCols}} class=text-right>({{ (pagination.itemsPerPage*pagination.page)-pagination.itemsPerPage+1 }}-{{ pagination.itemsPerPage*pagination.page }} / {{pagination.totalRecords}} records)</td></tr></tfoot></table><div style=padding-right:15px class=pull-right><ul class=pagination><li ng-show=showLessArrow()><a ng-click=goToPage(&quot;start&quot;)>«</a></li><li ng-show=showLessArrow()><a ng-click=goToPage(&quot;1less&quot;)>&lt;</a></li><li ng-repeat=\"pagina in pagination.rule\" ng-class=\"{ active: pagina == pagination.page }\"><a ng-click=goToPage(pagina)>{{ pagina }}</a></li><li ng-show=showMoreArrow()><a ng-click=goToPage(&quot;1more&quot;)>&gt;</a></li><li ng-show=showMoreArrow()><a ng-click=goToPage(&quot;end&quot;)>»<div class=ripple-container></div></a></li></ul><div colspan=2 ng-hide=asignacion><a ng-click=fnRefresh() ng-show=fnRefresh class=\"btn btn-rosado pull-right\">{{translation.REFRESCAR}}</a></div></div></div>");
$templateCache.put("app/docs/docs.html","<iframe id=docs-frame src=\"{{\'./assets/docs/\'+ctrl.rute+\'?cache=\'+ctrl.cache}}\" style=\"width: 100%; height: 99vh; border: none\"></iframe>");
$templateCache.put("app/event-replay/alert-credenciales.html","<div tabindex=-1 role=dialog class=modal><div class=modal-dialog><div style=text-align:center class=\"modal-content x-small-modal\"><div class=modal-header><img src=./assets/images/icons/success.svg style=width:50px ng-show=\"tipoAlert==\'success\'\"><img src=./assets/images/icons/error.svg style=width:50px ng-show=\"tipoAlert==\'error\'\"></div><div class=modal-body>{{msgAlert}}<br><br></div><div style=\"margin-bottom: 22px; text-align:center\" class=modal-footer><button ng-click=$hide() style=min-width:100px class=\"btn btn-primary btn-raised active recovery-button\">OK</button></div></div></div></div>");
$templateCache.put("app/event-replay/config.html","<div class=bs-component><ul class=\"nav nav-tabs\"><li ng-class={activeTab}><a href=javascript:; data-toggle=tab abm-component=abm-component class=btn-raised><span class=title>EVENT REPLAY</span></a></li></ul><div class=row><!-- -- Pestañas--><div class=col-md-12><md-button ng-click=eventReplay.crearReplay() style=\"background-color: white; color: black\" class=\"pull-right md-raised md-primary md-fab md-mini md-ink-ripple\"><md-tooltip md-direction=left>New Event Replay</md-tooltip><i aria-hidden=true class=\"fa fa-plus\"></i></md-button><div class=\"tab-content box-title separate\"><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Event Replay\'s\"><md-content class=md-padding><div class=row><div class=col-md-6><md-list style=\"border:1px solid #e0e0e0\"><md-subheader style=height:60px class=md-no-sticky>Instancias Creadas</md-subheader><md-list-item ng-click=null ng-repeat=\"listadoOpciones in listadoOpcion\" class=btn-ceptinel><p>{{listadoOpciones.tipoFuncion}} - {{listadoOpciones.contenedor}} <span style=font-size:.8em>&nbsp;({{listadoOpciones.idFuncion}})</span></p><md-checkbox ng-model=listadoOpciones.habilitado ng-click=seleccionarOpciones(listadoOpciones) ng-disabled=!editActive md-no-ink aria-label={{listadoOpciones.idFuncion}} class=white></md-checkbox><md-divider ng-if=!$last></md-divider></md-list-item><md-list-item ng-show=!listadoOpcionesSeleccionados.length style=min-height:53px class=btn-ceptinel><p>Sin instancias creadas</p></md-list-item></md-list></div><div class=col-md-6><md-list style=\"border:1px solid #e0e0e0\"><md-subheader style=height:60px class=md-no-sticky>Módulos Habilitados</md-subheader><md-list-item ng-click=null ng-repeat=\"listadoOpciones in listadoOpcionesSeleccionados\" class=btn-ceptinel><p>{{listadoOpciones.tipoFuncion}} - {{listadoOpciones.contenedor}} <span style=font-size:.8em>&nbsp;({{listadoOpciones.idFuncion}})</span></p><md-divider ng-if=!$last></md-divider></md-list-item><md-list-item ng-show=!listadoOpcionesSeleccionados.length style=min-height:53px class=btn-ceptinel><p>Sin secciones habilitadas</p></md-list-item></md-list></div></div></md-content></md-tab></md-tabs></div></div></div></div>");
$templateCache.put("app/event-replay/edit.html","<div class=bs-component><ul class=\"nav nav-tabs\"><li ng-class={activeTab}><a href=javascript:; data-toggle=tab abm-component=abm-component class=btn-raised><span class=title>EVENT REPLAY</span></a></li></ul><div class=row><!-- -- Sección del datos del perfil--><div class=col-md-12><div class=\"tab-content box-title separate\"><!--.row(ng-show=\"contentPerfil\")\n        .col-md-10\n          .alert.alert-danger#alert-msg\n            |{{ contentPerfil }}\n        --><div class=row><div class=col-md-12><div class=row><div class=col-md-12><label class=\"text-title underline\">Crear/Editar</label></div></div><div class=row><br><div class=col-md-1></div><div style=line-height:25px class=\"col-md-10 col-sm-12\"><div class=row><div class=\"col-md-4 col-sm-12\"><div class=input-icon><input type=text ng-model=profile placeholder=\"BUSCAR PERFIL ...\" uib-typeahead=\"listaPerfilRolOpcion as listaPerfilRolOpcion.profileId for listaPerfilRolOpcion in listadoPerfilesRolesOpciones | filter:{profileId:$viewValue}\" typeahead-show-hint=true typeahead-min-length=0 class=form-control><div ng-click=busquedaPerfil() class=box-icon><i class=\"fa fa-search search-icon\"></i></div></div></div></div><div class=row><div class=\"col-md-4 col-sm-6\"><label>Perfil</label><input type=text ng-model=riskProfile.profileName ng-disabled=!editActive class=form-control></div><div class=\"col-md-4 col-sm-6\"><label>Codigo Perfil</label><input type=text ng-model=riskProfile.profileId ng-disabled=\"!editActive || !codPerfil\" class=form-control></div><div class=\"col-md-4 col-sm-6\"><label>Perfil Origen</label><input type=text ng-model=riskProfile.originalProfileId ng-disabled=!editActive class=form-control></div><div class=\"col-md-12 col-sm-6\"><label>Descripcion</label><input type=text ng-model=riskProfile.descripcion ng-disabled=!editActive class=form-control></div><div class=col-md-1><md-checkbox ng-model=riskProfile.activo ng-checked=false ng-disabled=!editActive md-no-ink aria-label=\"Checkbox 2\" class=white></md-checkbox></div><div class=\"col-md-3 text-left\"><label>ACTIVO</label></div><div class=col-md-12><label>Roles del perfil</label><md-select ng-model=listadoRolesSeleccionados ng-model-options=\"{trackBy: \'$value.roleId\'}\" multiple><md-optgroup label=Roles><!--ng-click=\'seleccionarRoles(listadoRoles)\'--></md-optgroup><md-option ng-value=listadoRoles ng-disabled=!editActive ng-repeat=\"listadoRoles in listadoRol\">{{listadoRoles.roleDescription}}</md-option></md-select></div><div style=text-align:right class=col-md-12><button type=button ng-disabled=!botonesDeAccion.crear ng-click=habilitarCrear() class=\"btn-rosado btn btn-default btn-group-sm\">Crear</button> <button type=button ng-disabled=!botonesDeAccion.guardar ng-show=!botonesDeAccion.editar ng-click=guardarPerfil() class=\"btn-rosado btn btn-default btn-group-sm\">Guardar</button> <button type=button ng-disabled=!botonesDeAccion.editar ng-show=botonesDeAccion.editar ng-click=chequearEditarPerfil() class=\"btn-rosado btn btn-default btn-group-sm\">Guardar</button> <button type=button ng-disabled=!botonesDeAccion.cancelar ng-click=limpiarFormulario() class=\"btn-rosado btn btn-default btn-group-sm\">Cancelar</button></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/event-replay/event-replay.html","<div fullscreen=$root.isFullScreen only-watched-property style=\"width:100%; height:100%; display:grid\" class=bs-component><div layout=row><div flex=20 ng-show=$root.isFullScreen style=\"background: #ef4264 !important\" class=logo-app><div class=themeLogo></div></div><ul flex class=\"nav nav-tabs\"><li ng-class={activeTab}><a href=javascript:; data-toggle=tab abm-component=abm-component class=btn-raised><span ng-hide=$root.isFullScreen class=title>{{replayName}} </span></a></li></ul></div><md-content style=min-height:100vh><event-replay config=configReplay event-replay=eventReplay fn-init=crearReplay fn-getdata=obtenerData fn-save-interval=crearIntervalo fn-delete-interval=eliminarIntervalo api=alarmas.api fn-click=crearReplay fn-dbl-click=alarmas.crearTabDetalleAlerta to-excel=alarmas.prepareExcel></event-replay></md-content></div>");
$templateCache.put("app/external-libraries/external-libraries.html","<div><md-card><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-python scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>{{ ctrl.library.name }}</span></h2></div></md-toolbar><md-content class=md-padding><form name=formPy ng-submit=\"formPy.$valid &amp;&amp; ctrl.submit()\" novalidate layout=row layout-wrap layout-padding ng-disabled=ctrl.loading><div flex=50 ng-repeat=\"input in ctrl.schema track by $index\"><div ng-switch=input.type><div flex ng-switch-when=text|string ng-switch-when-separator=|><md-input-container class=\"w100 m0\"><label>{{ input.label }}</label><input ng-required=\"{{ input.required }}\" name=\"{{ input.key }}\" ng-model=input.value><small ng-if=input.required class=grey-text>This is required.*</small></md-input-container></div><div flex ng-switch-when=number><md-input-container class=\"w100 m0\"><label>{{ input.label }}</label><input ng-required=\"{{ input.required }}\" name=\"{{ input.key }}\" ng-model=input.value><small ng-if=input.required class=grey-text>This is required.*</small></md-input-container></div><div flex ng-switch-when=email><md-input-container class=\"w100 m0\"><label>{{ input.label }}</label><input ng-required=\"{{ input.required }}\" name=\"{{ input.key }}\" ng-model=input.value><small ng-if=input.required class=grey-text>This is required.*</small></md-input-container></div><div flex ng-switch-when=date><md-input-container class=\"w100 m0\"><label>{{ input.label }}</label><input ng-required=\"{{ input.required }}\" name=\"{{ input.key }}\" ng-model=input.value><small ng-if=input.required class=grey-text>This is required.*</small></md-input-container></div><div flex ng-switch-when=time><md-input-container class=\"w100 m0\"><label>{{ input.label }}</label><input ng-required=\"{{ input.required }}\" name=\"{{ input.key }}\" ng-model=input.value><small ng-if=input.required class=grey-text>This is required.*</small></md-input-container></div><div flex layout=row layout-padding ng-switch-when=select><div flex><md-input-container class=\"w100 p0 m0\"><label>{{ input.label }}</label><md-select name=\"{{ input.key }}\" ng-model=input.value class=w100><md-option ng-value=\"\">none</md-option><md-option ng-repeat=\"opt in input.options track by $index\" ng-value=opt.value>{{ opt.label }}</md-option></md-select><small ng-if=input.required class=grey-text>This is required.*</small><span ng-if=\"input.options.length === 0\" class=red-text>add some options</span></md-input-container></div></div><div flex layout=row layout-padding ng-switch-when=radio><div flex><h5 class=bold-text>{{ input.label }}</h5><md-radio-group ng-model=input.value aria-labelledby=radiooptions><md-radio-button ng-repeat=\"opt in input.options track by $index\" value=\"{{ opt }}\">{{ opt }}</md-radio-button></md-radio-group><small ng-if=input.required class=grey-text>This is required.*</small><span ng-if=\"input.options.length === 0\" class=red-text>add some options</span></div></div><div flex layout=row layout-padding ng-switch-when=checkbox><div flex><h5 class=bold-text>{{ input.label }}</h5><md-checkbox ng-repeat=\"opt in input.options track by $index\">{{ opt }}</md-checkbox><small ng-if=input.required class=grey-text>This is required.*</small><span ng-if=\"input.options.length === 0\" class=red-text>add some options</span></div></div><div flex ng-switch-default><md-input-container class=\"w100 m0\"><label>{{ input.label }}</label><input ng-required=\"{{ input.required }}\" name=\"{{ input.key }}\" ng-model=input.value><small ng-if=input.required class=grey-text>This is required.*</small></md-input-container></div><small>{{ input.description }}</small></div></div><div flex=100 class=text-right><md-button type=submit ng-disabled=ctrl.loading has-permission=python-library:execute class=\"green md-raised\">{{ ctrl.translate.send }}</md-button></div></form></md-content><md-content ng-if=ctrl.loading class=md-padding><div layout=column layout-align=\"center center\"><md-progress-circular md-mode=indeterminate md-diameter=40px class=\"md-primary md-hue-2\"></md-progress-circular><p class=ml-10><strong>{{ ctrl.translate.loading }}</strong></p></div></md-content><md-content class=md-padding><div id=inputHtml></div></md-content></md-card></div>");
$templateCache.put("app/filtros/filters.list.html","<div class=\"bs-component sticky-parent\"><md-card><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon ng-hide=rules.realtime icon=cep-menu-rules-filters scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>{{ translation.Filters }}</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button ng-click=\"filterList.showModal($event, null)\" aria-label=\"Add Filter\" class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>{{ translation.ADD_FILTER }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></md-toolbar-filler></div></md-toolbar><md-list class=p0><md-list-item ng-repeat=\"filter in filterList.filters\" style=\"border-bottom: 1px solid #eaeaea;padding: 1.8rem\"><p><b>{{ filter.filterName }}</b><span>- {{ translation.Rule }}: {{ filter.functionName }}</span><br><span>{{ filter.action }} when:</span><br>-<span>{{ filter.param }}</span><span style=\"color:orange; font-weight:700\">{{ filter.filterFunction }}</span><span>{{ filter.value }}</span></p><br><button ng-click=\"filterList.showModal($event, filter)\" style=\"padding: .8rem\" aria-label=\"Edit button\" class=\"md-secondary text-main-color btn md-raised\"><i class=material-icons>edit</i>{{ translation.Edit }}</button> <button ng-click=filterList.deleteFilter(filter.id) style=\"padding: .8rem\" aria-label=\"Delete button\" class=\"md-secondary text-main-color btn md-raised\"><i class=material-icons>delete</i>{{ translation.Delete }}</button></md-list-item><md-list-item ng-show=!filterList.filters.length style=\"border-bottom: 1px solid #eaeaea;padding: 1.8rem\"><h4><md-icon md-font-set=material-icons md-menu-align-target>info</md-icon>No records found</h4></md-list-item></md-list></md-card></div>");
$templateCache.put("app/filtros/modal-crear-filtros.1.html","<div tabindex=-1 role=dialog class=modal><div class=modal-dialog><div class=\"modal-content small-modal\"><div class=modal-header><a type=button abm-component ng-click=$hide() class=close>×</a><h4 class=\"modal-title small-header\">{{translation.ADD_FILTER}}</h4></div><div class=modal-body><div layout=row><md-input-container flex=50 class=md-block><label>{{translation.NOMBRE}}</label><input ng-model=config.filter.filterName aria-label=translation.NOMBRE required></md-input-container><md-input-container flex=50 class=md-block><select name=filterRule ng-model=config.filter.functionId ng-change=config.parseRuleParams(config.filter.functionId) aria-label=translation.REGLA required class=select-filters-modal><option ng-repeat=\"rule in config.config\" ng-value=rule.id>{{rule.name}}</option></select></md-input-container></div><div layout=row><md-input-container flex=50 class=md-block><label>Param.</label><md-select ng-model=config.filter.param aria-label=Param. required><md-option value=symbol selected>symbol</md-option></md-select></md-input-container><md-input-container flex=50 class=md-block><label>{{translation.FUNCTION}}</label><md-select ng-model=config.filter.filterFunction aria-label=translation.FUNCTION required><md-option value=equals selected><em>{{translation.EQUALS}}</em></md-option></md-select></md-input-container></div><div layout=row><md-input-container flex=100 class=md-block><md-chips ng-model=config.filter.values md-add-on-blur=true placeholder={{translation.VALUES}} delete-button-label=\"Remove Value\" delete-hint=\"Press delete to remove a value\" secondary-placeholder=+Val input-aria-label=\"Filter Values\" ng-required style=\"text-transform: uppercase\"></md-chips></md-input-container></div><div layout=row><md-input-container flex=100 class=md-block><label>{{translation.ACTION}}</label><md-select ng-model=config.filter.action aria-label=translation.EXCLUDE required><md-option value=exclude selected aria-label=exclude><em>{{translation.EXCLUDE}}</em></md-option></md-select></md-input-container></div><div layout=row><md-input-container flex=100 class=\"md-block text-right\"><md-button md-colors=green ng-click=config.saveFilter()>{{translation.GUARDAR}}</md-button></md-input-container></div></div></div></div></div>");
$templateCache.put("app/filtros/modal-crear-filtros.html","<md-dialog style=width:500px><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{translation.ADD_FILTER}}</h2><span flex></span><md-button ng-click=cancel() class=md-icon-button><md-icon md-font-set=material-icons>clear</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding:20px 10px 0 10px\"><div layout=row><md-input-container flex=50 class=md-block><label>{{translation.Name}}</label><input ng-model=config.filter.filterName aria-label=\"Filter name field\" required></md-input-container><md-input-container flex=50 class=md-block><label>{{translation.Rule}}</label><select name=filterRule placeholder=\"\" ng-model=config.filter.functionId ng-change=config.parseRuleParams(config.filter.functionId) aria-label=\"Rule selector field\" required class=select-filters-modal><option ng-repeat=\"rule in config.config\" ng-value=rule.id>{{rule.name}}</option></select></md-input-container></div><div layout=row><md-input-container flex=50 class=md-block><label>Param.</label><md-select ng-model=config.filter.param aria-label=\"Parameters selector\" required><md-option value=symbol selected>symbol</md-option></md-select></md-input-container><md-input-container flex=50 class=md-block><label>{{translation.function}}</label><md-select ng-model=config.filter.filterFunction aria-label=\"Function selector\" required><md-option value=equals selected><em>{{translation.equals}}</em></md-option></md-select></md-input-container></div><div layout=row><md-input-container flex=100 class=md-block><md-chips ng-model=config.filter.values md-add-on-blur=true placeholder={{translation.values}} delete-button-label=\"Remove Value\" delete-hint=\"Press delete to remove a value\" secondary-placeholder=+Val input-aria-label=\"Filter Values\" ng-required style=\"text-transform: uppercase\"></md-chips></md-input-container></div><div layout=row><md-input-container flex=100 class=md-block><label>{{translation.action}}</label><md-select ng-model=config.filter.action aria-label=\"Action selector\" required><md-option value=exclude selected aria-label=exclude><em>{{translation.exclude}}</em></md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions><md-button type=button ng-click=cancel() class=\"md-raised pull-right\">{{translation.cancel}}</md-button><md-button type=button ng-click=config.saveFilter() class=\"md-raised md-primary pull-right\">{{translation.save}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/gestion-alertas/gestion-alertas.html","<div class=bs-component><md-card><md-toolbar class=white><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" ng-click=toHome() class=main-color><md-icon>notification_important</md-icon><md-tooltip>Dashboard</md-tooltip></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools cep_text\"><span>{{ translation.alert_config }}</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button ng-click=ctrl.saveData() aria-label=\"guardar cambios\" ng-if=\" ctrl.loading == false\" class=\"pull-right md-fab md-mini green\"><md-tooltip md-direction=left>{{ translation.save_changes }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>save</md-icon></md-button></md-toolbar-filler></div></md-toolbar><md-card-content ng-if=\"ctrl.errorReporting.status == true &amp;&amp; ctrl.loading == false\"><section layout=row><div flex=100 class=text-center><h4><div style=\"color: #ffeb3b\" class=\"fa fa-warning fa-3x\"></div></h4><h4>{{ ctrl.errorReporting.error }}</h4></div></section></md-card-content><md-card-content ng-if=\" ctrl.loading == true\"><section layout=row><div flex=100 class=text-center><h4>{{ translation.loading_config }}</h4><md-progress-linear md-mode=indeterminate></md-progress-linear></div></section></md-card-content><md-card-content ng-if=\"ctrl.errorReporting.status == false &amp;&amp; ctrl.loading == false\"><section layout=row><div flex=100 style=\"overflow: auto\"><table id=gestion-alertas-table class=\"table table-center\"><thead><tr><th style=\"width: 260px\">{{ translation.status }}</th><th style=\"width: 260px\">{{ translation.active }}</th><th style=\"width: 180px\">{{ translation.severity }}</th><th colspan=\"{{ ctrl.rangeSlider.config.max + 1 }}\" class=text-center>{{ translation.criticality }}</th></tr></thead><tbody><tr ng-repeat=\"item in ctrl.reportData.conf.settings track by $index \"><td style=\"width: 260px\"><span data-status=\"{{ item.statusName }}\" class=material-icons></span>{{ item.statusName }}</td><td style=\"width: 180px\"><md-switch ng-model=item.hidden aria-label=settings-status-hidden class=\"switch-invert p0 m0\"></md-switch></td><td style=\"width: 180px\"><input-counter value=item.severity min=0></input-counter></td><td ng-repeat=\"i in [].constructor((ctrl.rangeSlider.config.max - ctrl.rangeSlider.config.min)+1) track by $index\" ng-class=ctrl.styleAlert((item.severity)*(ctrl.rangeSlider.config.min+$index)) data-hidden=\"{{ item.hidden }}\" class=\"text-center severidad\"><span>{{ item.severity * (ctrl.rangeSlider.config.min + $index) }}</span></td></tr></tbody><tfoot><tr><th colspan=3 class=text-right>{{ translation.occurrences }}</th><th ng-repeat=\"i in [].constructor((ctrl.rangeSlider.config.max - ctrl.rangeSlider.config.min)+1) track by $index \" class=\"text-center ocurrencia\">{{ ctrl.rangeSlider.config.min + $index }}</th></tr></tfoot></table></div></section><section layout=row layout-padding=\"\"><div flex=50><h4>{{ translation.occurrences_config }}</h4><section><div layout=row><div flex=33 class=text-center><label class=w100>{{ translation.min }}</label><input-counter value=ctrl.rangeSlider.config.min min=0></input-counter></div><div flex=33 class=text-center><label class=w100>{{ translation.gap }}</label><input-counter value=ctrl.rangeSlider.config.gap min=0></input-counter></div><div flex=33 class=text-center><label class=w100>{{ translation.max }}</label><input-counter value=ctrl.rangeSlider.config.max min=0></input-counter></div></div><range-slider config=ctrl.rangeSlider.config model=ctrl.rangeSlider.model></range-slider></section></div><div flex=50><h4>{{ translation.weights_per_day }}</h4><md-list><md-list-item ng-repeat=\"item in ctrl.reportData.conf.settings track by $index\"><div flex=20><span data-status=\"{{ item.statusName }}\" class=material-icons></span>{{ item.statusName }}</div><div flex=70><md-slider-containe><md-slider min=0 max=100 ng-model=item.weighing aria-label=severidad_{{item.status}} style=\"position: relative; top: 6px\" class=md-primary></md-slider></md-slider-containe></div><div flex=5><b>{{ item.weighing }}%</b></div></md-list-item></md-list></div></section></md-card-content></md-card></div>");
$templateCache.put("app/help-desk/tickets-list.html","<md-card id=help-desk-tickets ng-cloak><md-content class=content_blocks><div><md-toolbar class=md-menu-toolbar><div layout=row><md-toolbar-filler id=btnInputListonGoBack layout layout-align=\"center center\" ng-click=ctrl.getBack() class=main-color><md-tooltip md-z-index=9999 md-delay=200>{{ translation.get_back }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>bug_report</md-icon></md-toolbar-filler><div class=w100><h2 class=md-toolbar-tools><div class=md-title>Tickets</div></h2></div></div></md-toolbar></div></md-content><md-divider></md-divider><md-content style=\"max-height: 76vh\"><md-content ng-if=ctrl.tableIsLoading><md-progress-linear></md-progress-linear></md-content><div ui-grid-pagination ui-grid-resize-columns ui-grid-auto-resize ui-grid=ctrl.gridOptions style=\"height: 70vh\" class=listGrid></div></md-content></md-card>");
$templateCache.put("app/includes/header.html","<md-toolbar id=mainHeader class=md-whiteframe-2dp><div class=md-toolbar-tools><div flex=20 class=relative><a href=home layout=column><div id=logo-app-ux ng-if=!main.customLogo></div><div id=logo-app-ux ng-if=main.customLogo style=\"background-size: contain;background-image: url({{ main.customLogo }})\"></div></a></div><div flex><main-datepicker></main-datepicker></div><div flex class=text-right><span ng-repeat=\"ele in main.favs track by $index\" class=favorites-wrapper><md-button id=fav-{{ele.url}} ng-if=\"ele.fav &amp;&amp; ele.url !== &quot;docs&quot;\" aria-label=\"{{ ele.icon }}\" href=\"{{ ele.url }}\" class=\"m0 md-icon-button\"><span ng-switch on=ele.id><cep-icon ng-switch-when=issues icon=\"{{ ele.cepIcon }}\" color=\"{{ ele.cepColor }}\"></cep-icon><cep-icon ng-switch-when=custom-reports icon=\"{{ ele.icon }}\"></cep-icon><cep-icon ng-switch-default icon=\"cep-menu-{{ ele.icon }}\"></cep-icon></span><md-tooltip md-direction=bottom>{{ ele.name }}</md-tooltip></md-button><md-button id=fav-{{sub.url}} ng-repeat=\"sub in ele.submenu.rutes\" ng-if=sub.fav aria-label=\"cep-menu-{{ sub.icon }}\" href=\"{{ sub.url }}\" class=\"m0 md-icon-button\"><span ng-switch on=ele.id><cep-icon ng-switch-when=issues icon=\"{{ sub.cepIcon }}\" color=\"{{ sub.cepColor }}\"></cep-icon><cep-icon ng-switch-when=custom-reports icon=\"{{ sub.icon }}\"></cep-icon><cep-icon ng-switch-default icon=\"cep-menu-{{ sub.icon }}\"></cep-icon></span><md-tooltip md-direction=bottom>{{ sub.name }}</md-tooltip></md-button><md-button id=fav-{{ele.url}} ng-if=\"ele.fav &amp;&amp; ele.url === &quot;docs&quot;\" aria-label=\"cep-menu-{{ ele.icon }}\" target=_blank href=docs/ onclick=\"return window.open(this.href, &quot;_blank&quot;)\" class=\"m0 md-icon-button\"><cep-icon icon=\"cep-menu-{{ ele.icon }}\"></cep-icon><md-tooltip md-direction=bottom>{{ ele.name }}</md-tooltip></md-button></span></div><div flex=1 style=\"border-left: 1px solid #cfcfcf\" class=text-right><md-menu-bar class=p0><md-menu><md-button id=header-usermenu-btn ng-click=$mdMenu.open() class=\"m0 p0\"><md-icon md-font-set=material-icons>person</md-icon><span class=\"hide-sm hide-md\">{{ main.user.name }}</span></md-button><md-menu-content width=3 class=p0><md-menu-item><md-button id=header-changepass-btn href=security aria-label=SEGURIDAD>{{ translation.SEGURIDAD }}</md-button></md-menu-item><md-menu-item><md-button id=header-timezone-btn ng-click=main.showModalTimezone() aria-label=\"Timezone dialog button\" class=m0>{{ translation.CAMBIAR_ZH }}</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button id=header-logout-btn ng-click=main.logout() aria-label=\"{{ translation.edit }}\">{{ translation.SALIR }}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div><div flex=1 style=\"border-left: 1px solid #cfcfcf; border-right: 1px solid #cfcfcf\" class=text-left><notification></notification><user-documents></user-documents></div><div flex=1 class=text-right><md-button id=dashboardOpenMainMenu aria-label=\"Abrir Menú\" ng-click=main.toggleMenu() class=\"md-fab md-mini cep_color\"><md-icon md-font-set=material-icons class=white-text>menu</md-icon><md-tooltip md-direction=bottom>Menú</md-tooltip></md-button></div></div></md-toolbar>");
$templateCache.put("app/includes/loader.html","<div style=\"position:fixed; z-index:999; width:100%\"><md-progress-linear id=general-progress-indeterminated md-mode=indeterminate ng-show=loading class=\"md-accent md-hue-2\"></md-progress-linear></div><div style=\"position:fixed; z-index:999; width:100%\"><md-progress-linear id=general-progress-determinated md-mode=determinate ng-value=loader.value ng-show=loader.show class=\"md-accent md-hue-2\"></md-progress-linear></div>");
$templateCache.put("app/includes/menu.html","<nav class=menu><div id=logo-app></div><md-divider></md-divider><ul id=sideNavMenu class=btn-group><risk-menu-item has-permission=dashboard:read ng-click=main.clickSubMenu(&quot;habilitarSubMenuDashboard&quot;) must-show=true must-deactivate=!main.existeFiltro() app-name=app.home app-link=home menu-icon=dashboard menu-label=DASHBOARD></risk-menu-item><risk-menu-item has-permission=event:read ng-click=main.clickSubMenu(&quot;habilitarSubMenuEvent&quot;) must-show=true must-deactivate=!main.existeFiltro() app-name=app.alarmas app-link=alarmas menu-icon=error_outline menu-label=\"{{ translation.ALERTAS }}\"></risk-menu-item><risk-menu-item has-permission=ranking:read ng-click=main.clickSubMenu(&quot;habilitarSubMenuRanking&quot;) must-show=true must-deactivate=!main.existeFiltro() app-name=app.rankings app-link=rankings menu-icon=bar_chart menu-label=RANKINGS></risk-menu-item><risk-menu-item has-permission=cases:read ng-click=main.clickSubMenu(&quot;habilitarSubMenuCases&quot;) must-show=true must-deactivate=!main.existeFiltro() app-name=app.casos app-link=casos/ menu-icon=work_outline menu-label=\"{{ translation.CASOS }}\"></risk-menu-item><div><li has-permission=function:read ng-class=\"{deshabilitado: !main.existeFiltro()}\"><md-button ng-click=main.clickSubMenu(&quot;habilitarSubMenuReglas&quot;) abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">device_hub</i>&nbsp;{{ translation.REGLAS | uppercase }}</md-button></li><li ng-if=main.habilitarSubMenuReglas class=red-bar><ul><li has-permission=function:read data-match-route=/rules/*><md-button href=rules ng-click=main.clickMenu(&quot;app.rules&quot;) abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">picture_in_picture</i>&nbsp;{{ translation.REGLAS }}</md-button></li><li has-permission=function:read-filter data-match-route=/config/filters/* ng-class=\"{deshabilitado: !main.existeFiltro()}\"><md-button href=config/filters ng-click=main.clickMenu(&quot;app.filtersList&quot;) abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">filter_list</i>&nbsp;{{ translation.FILTERS }}</md-button></li><li has-permission=function:read data-match-route=/entries/schemas/*><md-button href=connections ng-click=main.clickMenu(&quot;app.data-conn&quot;) abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">usb</i>&nbsp;{{ translation.dataConn }}</md-button></li></ul></li></div><div><li has-permission=graphic-report:read><md-button ng-click=main.clickSubMenu(&quot;habilitarSubMenuReplay&quot;) abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">repeat</i>&nbsp;EVENT REPLAY</md-button></li><li ng-if=main.habilitarSubMenuReplay class=red-bar><ul><li ng-repeat=\"(key, value) in main.replays\" data-match-route=/event-replay.*><md-button id=chart-{{value.name}} href=event-replay/{{value.id}} abm-component=abm-component class=\"btn btn-raised\"><md-icon md-font-set=material-icons>restore</md-icon>&nbsp;&nbsp;{{ value.name }}</md-button></li></ul></li></div><div><li ng-if=\"main.validatePermission([&quot;list:read&quot;,&quot;schema:read&quot;,&quot;searcher:read&quot;, &quot;data-management:read&quot;])\" ng-class=\"{deshabilitado: !main.existeFiltro()}\"><md-button ng-click=main.clickSubMenu(&quot;habilitarSubMenuEsquemas&quot;) abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">input</i>&nbsp;{{ translation.ENTRADAS | uppercase }}</md-button></li><li ng-if=main.habilitarSubMenuEsquemas class=red-bar><ul><li has-permission=list:read data-match-route=/entries/lists/*><md-button href=entries/lists ng-click=main.clickMenu(&quot;app.schemasLists&quot;) abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">format_list_numbered</i>&nbsp;{{ translation.LISTAS }}</md-button></li><li has-permission=schema:read data-match-route=/entries/schemas/*><md-button href=entries/schemas ng-click=main.clickMenu(&quot;app.schemas&quot;) abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">library_books</i>&nbsp;{{ translation.ESQUEMAS }}</md-button></li><li has-permission=searcher:read data-match-route=/entries/searcher/config*><md-button href=entries/searcher/config ng-click=main.clickMenu(&quot;app.searcher-list&quot;) abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">search</i>&nbsp;{{ translation.SEARCHER }}</md-button></li></ul></li></div><risk-menu-item has-permission=report:read ng-click=main.clickSubMenu(&quot;habilitarSubMenuReport&quot;) must-show=true must-deactivate=!main.existeFiltro() app-name=app.bi-reports app-link=bi-reports menu-icon=assignment menu-label=\"{{ translation.REPORTES }}\"></risk-menu-item><risk-menu-item has-permission=function:read-schedule must-show=true must-deactivate=!main.existeFiltro() app-name=app.rule-schedules app-link=rules/schedules menu-icon=update menu-label=\"{{ translation.schedules | uppercase }}\"></risk-menu-item><div><li ng-if=\"main.validatePermission([&quot;documentation:read&quot;,&quot;power-bi:read&quot;,&quot;series:read&quot;,&quot;graphic-report:read&quot;,&quot;alert-management:read&quot;,&quot;files-storage:read&quot;,&quot;backup:read&quot;, &quot;configuration:read&quot;])\" ng-class=\"{deshabilitado: !main.existeFiltro()}\"><md-button ng-click=main.clickSubMenu(&quot;habilitarSubMenuConf&quot;) abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">build</i>&nbsp;{{ translation.CONFIGURACION }}</md-button></li><li ng-if=main.habilitarSubMenuConf class=red-bar><ul><li has-permission=documentation:read data-match-route=/docs/*><md-button href=docs ng-click=main.clickMenu(&quot;app.docs&quot;) abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">chrome_reader_mode</i>&nbsp;{{ translation.documentation }}</md-button></li><li has-permission=power-bi:read data-match-route=/credenciales/* ng-class=\"{deshabilitado: !main.existeFiltro()}\"><md-button href=credenciales ng-click=main.clickMenu(&quot;app.credenciales&quot;) abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">assignment_ind</i>&nbsp;{{ translation.CREDENCIALES }}</md-button></li><li has-permission=series:read data-match-route=/replay/config/series/* ng-class=\"{deshabilitado: !main.existeFiltro()}\"><md-button href=replay/config/series ng-click=main.clickMenu(&quot;app.series&quot;) abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">linear_scale</i>&nbsp;{{ translation.SERIES }}</md-button></li><li has-permission=graphic-report:read data-match-route=/replay/config/replay/* ng-class=\"{deshabilitado: !main.existeFiltro()}\"><md-button href=replay/config/replay ng-click=main.clickMenu(&quot;app.replay-list&quot;) abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">bar_chart</i>&nbsp;{{ translation.REPLAY }}</md-button></li><li has-permission=alert-management:read data-match-route=/alert-management/* ng-class=\"{deshabilitado: !main.existeFiltro()}\"><md-button href=alert-management ng-click=main.clickMenu(&quot;app.alert-management&quot;) abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">notification_important</i>&nbsp;{{ translation.config_alerts }}</md-button></li><li has-permission=files-storage:read data-match-route=/files-storage/* ng-class=\"{deshabilitado: !main.existeFiltro()}\"><md-button href=files-storage ng-click=main.clickMenu(&quot;app.files-storage&quot;) abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">how_to_vote</i>&nbsp;{{ translation.storage }}</md-button></li><li has-permission=configuration:read data-match-route=/configuration/* ng-class=\"{deshabilitado: !main.existeFiltro()}\"><md-button href=configuration ng-click=main.clickMenu(&quot;app.configuration&quot;) abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">vpn_lock</i>&nbsp;{{ translation.CONFIGURATION }}</md-button></li></ul></li></div><div><li ng-if=main.validatePermission([&quot;user:read&quot;,&quot;acl:read&quot;,&quot;group:read&quot;,&quot;audit:read&quot;])><md-button ng-click=main.clickSubMenu(&quot;habilitarSubMenu&quot;) abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">security</i>&nbsp;{{ translation.SEGURIDAD }}</md-button></li><li ng-if=main.habilitarSubMenu class=red-bar><ul><li has-permission=user:read data-match-route=/usuarios/* ng-class=\"{deshabilitado: !main.existeFiltro()}\"><md-button href=usuarios ng-click=main.clickMenu(&quot;app.usuarios&quot;) abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">person_pin</i>{{ translation.USUARIOS }}</md-button></li><li has-permission=acl:read data-match-route=/acl/* ng-class=\"{deshabilitado: !main.existeFiltro()}\"><md-button href=access-control-list ng-click=main.clickMenu(&quot;app.acl&quot;) abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">list_alt</i>{{ translation.ACL }}</md-button></li><li has-permission=group:read data-match-route=/group/* ng-class=\"{deshabilitado: !main.existeFiltro()}\"><md-button href=group ng-click=main.clickMenu(&quot;app.group-list&quot;) abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">group</i>{{ translation.GROUP }}</md-button></li><li has-permission=audit:read data-match-route=/auditoria/* ng-class=\"{deshabilitado: !main.existeFiltro()}\"><md-button href=auditoria ng-click=main.clickMenu(&quot;app.auditoria&quot;) abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">folder_open</i>{{ translation.REGISTRO_SISTEMA }}</md-button></li></ul></li></div></ul></nav>");
$templateCache.put("app/home/home.html","<dashboard-config-bar api=configBar preview-widget=home.previewWidget add-widget=home.addWidget cancel-widget=home.cancelWidget props=home.dashboard.props></dashboard-config-bar><div layout=row class=w100><div id=widgetsGrid flex=95 class=relative><md-tabs id=dashboarsdTab md-dynamic-height md-border-bottom md-selected=activeTab ng-model=home.activeTab class=w100><md-tab ng-repeat=\"board in home.dashboards | orderBy:\'board.order\'\" md-on-select=onTabSelected(board)><md-tab-label><div ng-dblclick=home.editDashboardName()>{{ board.name }}</div></md-tab-label><md-tab-body><div gridster=home.gridConfig ng-if=\"home.ActiveBoard.id === board.id\"><ul><li id=li-{{widget.widget.type}} ng-repeat=\"widget in board.widgets\" gridster-item=widget.position md-whiteframe=1 data-widget=\"{{ widget.id }}\" class=white><widget-box id=w-box-{{widget.widget.type}} widget=widget index=widget.id delete-widget=home.deleteWidget class=\"white widget-box\"></widget-box></li></ul></div></md-tab-body></md-tab></md-tabs><section ng-if=\"home.dashboards.length === 0 &amp;&amp; !home.loadingDashboards\" class=text-center><h4><strong>{{ translation.no_dashboards }}</strong></h4><md-button ng-click=home.newDashboard() class=\"md-raised md-primary\">{{ translation.new_dashboard }}</md-button></section></div><div id=widgetsToolbar flex=5 style=\"position: relative\"><div id=widgetsToolbarStiky style=\"position: sticky; top: 71px\" class=text-center><md-button id=btn-dashboard-events aria-label=menu ng-click=home.toggleMenu() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target ng-if=!home.isOpen>more_vert</md-icon><md-icon md-font-set=material-icons md-menu-align-target ng-if=home.isOpen>more_horiz</md-icon><md-tooltip md-direction=bottom>{{ translation.dashboard }}</md-tooltip></md-button><div ng-if=home.isOpen style=\"margin: 1rem 0\" class=\"grey lighten-5\"><md-button ng-if=\"home.ActiveBoard != null\" ng-click=home.deleteDashboard() aria-label=\"new Dashboard\" has-permission=dashboard#{{home.ActiveBoard.id}}:delete class=md-icon-button><md-tooltip md-direction=left>{{ translation.delete_dashboard }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target class=red-text>remove_from_queue</md-icon></md-button><md-button ng-click=home.newDashboard() aria-label=\"new Dashboard\" class=md-icon-button><md-tooltip md-direction=left>{{ translation.new_dashboard }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target class=green-text>add_to_queue</md-icon></md-button><md-button ng-click=home.editDashboardName() ng-if=\"home.ActiveBoard != null\" aria-label=\"new Dashboard\" has-permission=dashboard#{{home.ActiveBoard.id}}:update class=md-icon-button><md-tooltip md-direction=left>{{ translation.edit_name }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target class=green-text>edit</md-icon></md-button><md-button ng-click=home.shareDashboard() ng-if=\"home.ActiveBoard != null\" aria-label=\"share Dashboard\" has-permission=dashboard#{{home.ActiveBoard.id}}:share class=md-icon-button><md-tooltip md-direction=left>share</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target class=blue-text>share</md-icon></md-button></div><md-button id=btn-dashboard-widgets ng-click=configBar.toggle() aria-label=\"Dashboard widgets\" ng-if=\"home.ActiveBoard != null\" has-permission=dashboard#{{home.ActiveBoard.id}}:update class=md-icon-button><md-tooltip md-direction=left>Widgets</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target class=blue-text>widgets</md-icon></md-button><md-button ng-if=\"home.ActiveBoard != null\" ng-click=\"home.saveUserDashboards(\'update\')\" aria-label=\"Dashboard widgets\" ng-class=\"{ \'green animated pulse infinite lighten-4\': home.hasChanges,\'grey lighten-2\': !home.hasChanges }\" has-permission=dashboard#{{home.ActiveBoard.id}}:update class=\"md-icon-button grey lighten-2\"><md-tooltip md-direction=left>{{ translation.save_changes }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target ng-class=\"{ \'green-text animated shake infinite\': home.hasChanges,\'grey-text\': !home.hasChanges }\" class=grey-text>save</md-icon></md-button><md-button ng-click=toAlertManagement() aria-label=alert-management class=md-icon-button><md-tooltip md-direction=left>{{ translation.alert_settings }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>notification_important</md-icon></md-button><md-button ng-click=home.organizeDashboard() aria-label=\"Keyboard Shortcuts\" class=md-icon-button><md-tooltip md-direction=left>{{ translation.organize_dashboards }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>view_carousel</md-icon></md-button></div></div></div>");
$templateCache.put("app/indicators/indicators.html","<div><md-card><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-indicators scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>{{ ctrl.translation.indicators }}</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button id=create-indicator aria-label=create-indicator ng-click=ctrl.indicatorDialog() ng-disabled=ctrl.ACL.canCreate abm-component class=\"pull-right md-fab md-mini blue\"><md-tooltip md-direction=left>{{ ctrl.translation.create }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target class=white-text>add</md-icon></md-button></md-toolbar-filler></div></md-toolbar><md-content ng-if=ctrl.isLoading><div style=\"padding: 2rem 1rem\" class=text-center><p>{{ ctrl.translation.loading }}</p><md-progress-linear id=general-progress-indeterminated></md-progress-linear></div></md-content><md-content ng-if=!ctrl.isLoading><md-list id=indicators-list class=w100><md-list-item style=\"border-bottom: 1px solid #eaeaea; padding: 1.8rem\" ng-repeat=\"indicator in ctrl.indicators.data\"><div><h4><small>{{ indicator.id }} -</small><strong>{{ indicator.name }}</strong></h4><p>{{ ctrl.translation.intervals }} : {{ indicator.intervals.length }}</p><p>{{ ctrl.translation.description }} : {{ indicator.description }}</p></div><md-button ng-disabled=ctrl.ACL.canUpdate ng-click=ctrl.indicatorDialog(indicator) class=\"md-icon-button md-secondary\"><md-icon style=margin: md-font-set=material-icons md-menu-align-target aria-label=Edit>edit</md-icon></md-button><md-button ng-disabled=ctrl.ACL.canDelete ng-click=ctrl.deleteIndicator(indicator.id) class=\"md-icon-button md-secondary\"><md-icon style=margin: md-font-set=material-icons md-menu-align-target aria-label=delete>delete</md-icon></md-button></md-list-item></md-list></md-content></md-card></div>");
$templateCache.put("app/input-list/inputlist.html","<md-card id=InputListEdition><md-content class=content_blocks><div><md-toolbar class=md-menu-toolbar><div layout=row><md-toolbar-filler id=btnInputListonGoBack layout layout-align=\"center center\" ng-click=inputList._onGoBack() class=main-color><md-tooltip md-z-index=9999 md-delay=200>{{ translation.get_back }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>domain</md-icon></md-toolbar-filler><div class=w100><h2 class=md-toolbar-tools><div class=md-title>{{ inputList.name }}</div></h2><ng-include src=&quot;app/input-list/templates/input-list-main-menu.html&quot;></ng-include></div></div></md-toolbar></div></md-content><md-content flex class=content_blocks><div style=\"height: calc(100vh - 290px); overflow: auto\" ng-if=!inputList.initialLoad class=w100><hot-table hot-id=inputList-{{inputList.listId}} settings=inputList.settings datarows=inputList.data columns=inputList.cols class=w100></hot-table></div></md-content><md-divider></md-divider><md-content class=\"content_blocks inputList_footer\"><div layout=row layout-align=\"end center\"><div flex=1><md-button id=saveInputList ng-disabled=!inputList.validatePermission(&quot;list#&quot;+inputList.listId+&quot;:update&quot;) ng-click=inputList.onSaveData() class=md-raised>{{ translation.save }} {{ translation.list }}</md-button></div><div flex=1><md-button ng-disabled=!inputList.validatePermission(&quot;list#&quot;+inputList.listId+&quot;:update&quot;) ng-click=inputList.insertRow(&quot;final&quot;) role=button-add-row class=md-raised>{{ translation.insert }} {{ translation.row_below | lowercase }}</md-button></div><div flex></div><div flex=1 ng-if=inputList.selectedRows><p style=\"padding: 0 12px; position: relative; top: 7px\">{{ translation.selected }}: {{ inputList.selectedRows }}</p></div><div flex=1 ng-if=inputList.hiddenData.length><p style=\"padding: 0 12px\">{{ translation.hidden }}: {{ inputList.hiddenData.length }}</p></div><div flex=1><p style=\"padding: 0 12px; position: relative; top: 7px\">{{ translation.rows }}: {{ inputList.data.length }}</p></div><list-paginator ng-if=!loading page-index=inputList.pagination.page total-records=inputList.pagination.totalRecords page-size=inputList.pagination.itemsPerPage next-fn=inputList.nextPage prev-fn=inputList.prevPage goto-fn=inputList.goToPage></list-paginator><div flex=1 ng-if=inputList.isImporting style=\"color: orange\"><p style=\"padding: 0 12px\">Importing Data</p></div></div></md-content></md-card>");
$templateCache.put("app/issues/issues.html","<div ng-cloak class=bs-component><md-card id=gestion-alertas><md-toolbar class=main-color><div class=md-toolbar-tools><h2 flex=\"\" md-truncate=\"\"><md-icon md-font-set=material-icons md-menu-align-target>find_in_page</md-icon>INDICIOS</h2><md-button ng-click=helperDialog() aria-label=help class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>ayuda</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>help_outline</md-icon></md-button></div></md-toolbar></md-card><section layout=row><div id=indicios flex=20><md-card><md-card-content><section layout=row layout-align=\"end center\"><div flex=90 style=display:inline-flex><p>indicios Nuevos<b>0</b></p></div><div flex=10 style=display:inline-flex></div></section><section layout=row style=height:200px><p flex style=\"align-self: center\" class=text-center>No tienes indicios</p></section></md-card-content></md-card><md-card><md-card-content><section layout=row style=height:200px ng-if=\"ctrl.customViewList.length == 0\"><p flex style=\"align-self: center\" class=text-center>No tienes vistas personalizadas aún, empieza a crearlas Aqui</p></section><section layout=column ng-if=\"ctrl.customViewList.length &gt; 0\"><div flex=90 style=display:inline-flex><p>indicios personalizadas<b>{{ ctrl.customViewList.length }}</b></p></div><section ng-repeat=\"cvl in ctrl.customViewList track by $index\" layout=row style=border-bottom><div flex=60><h5>{{ cvl.name }}</h5></div><div flex=40><md-menu-bar><md-menu><button ng-click=$mdMenu.open()><md-icon md-font-set=material-icons md-menu-align-target>more_vert</md-icon></button><md-menu-content width=1><md-menu-item><md-button ng-click=ctrl.listarViewTab(cvl.id)><md-icon md-font-set=material-icons md-menu-align-target>edit</md-icon></md-button></md-menu-item><md-menu-item><md-button ng-click=ctrl.listarViewTab(cvl.id)><md-icon md-font-set=material-icons md-menu-align-target>share</md-icon></md-button></md-menu-item><md-menu-item><md-button ng-click=ctrl.listarViewTab(cvl.id)><md-icon md-font-set=material-icons md-menu-align-target>delete</md-icon></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></section></section></md-card-content></md-card></div><div id=tbl flex=80><md-card><md-card-content><section layout=row layout-align=\"end center\"><div flex=40 style=display:inline-flex><md-autocomplete md-require-match=false md-floating-label=search md-search-text=searchText md-items=\"item in querySearch(searchText)\" md-item-text=item.indicio md-min-length=0 md-clear-button=true style=\"padding-left:5px; top:12px\"><md-item-template><span md-highlight-text=searchText md-highlight-flags=^i>{{ item.name }}</span></md-item-template><md-not-found>sin resultados \"{{ searchText }}\".</md-not-found></md-autocomplete></div><div flex=50 style=display:inline-flex><md-button ng-click=advanceSearch() class=md-raised>Busqueda avanzada</md-button><md-button ng-click=\"ctrl.viewType(\'tabla\')\" aria-label=tabla class=pull-right>Tabla</md-button><md-button ng-click=\"ctrl.viewType(\'canvas\')\" aria-label=canvas class=pull-right>Canvas</md-button></div><div flex=10 style=display:inline-flex><md-menu-bar><md-menu><button ng-click=$mdMenu.open()><md-icon md-font-set=material-icons md-menu-align-target>more_vert</md-icon></button><md-menu-content width=1><md-menu-item ng-repeat=\"item in ctrl.issuesTblActions track by $index\"><md-button ng-click=ctrl.btn(item.action)><md-icon md-font-set=material-icons md-menu-align-target>{{ item.icon }}</md-icon><p>{{ item.name }}</p></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></section><tabs-bar tabs=ctrl.tabsIssues is-active=ctrl.isActive set-tab=ctrl.setTab del-tab=ctrl.eliminarTabIssue></tabs-bar><table ng-show=\"ctrl.isSet(\'index\') &amp;&amp; ctrl.typeView==\'tabla\'\" class=\"table table-striped w100\"><thead><tr><th>-</th><th>Indicio</th><th>Categoria</th><th>Criticidad</th><th>Estado</th><th>Accion</th></tr></thead><tbody><tr ng-repeat=\"issue in ctrl.issuesList track by $index \"><td><md-checkbox ng-checked=exists(issue.id) ng-click=toggle(issue.id) aria-label=\"{{ issue.indicio }}\"></md-checkbox></td><td><span ng-if=issue.linked><md-icon md-font-set=material-icons class=pull-right>link</md-icon></span><p>{{ issue.indicio }}</p><small>created at {{ issue.created }} by {{ issue.by }}, a asignado a {{ issue.asigned }}</small></td><td>{{ issue.catg }}</td><td><div tipo-criticidad=\"{{ issue.criticidad | lowercase }}\" class=chip>{{ issue.criticidad }}</div></td><td><div tipo-estado=\"{{ issue.estado | lowercase }}\" class=chip>{{ issue.estado }}</div></td><td><md-button ng-click=issueDetail($event,issue.id)>ver</md-button></td></tr></tbody></table><div ng-show=\"ctrl.typeView==\'canvas\'\" class=canvas-view><div ng-repeat=\"state in ctrl.estados\" style=\"width: calc(100%/{{ctrl.estados.length}})\" class=canvas-panel><div class=canvas-head><h5 class=text-center>{{ state }}</h5></div><div id={{state}} ui-sortable=sortableOptionsList ng-model=ctrl.canvas_data[state] class=\"canvas-drop-area apps-container\"><div id={{data.id}} ng-repeat=\"data in ctrl.canvas_data[state]\" class=canvas-element><md-checkbox ng-checked=exists(data.id) ng-click=toggle(data.id) aria-label=\"{{ data.indicio }}\"></md-checkbox><span ng-if=data.linked><md-icon md-font-set=material-icons class=pull-right>link</md-icon></span><article layout=row><div flex=80><p>{{ data.indicio }}</p><small>created at {{ data.created }} by {{ data.by }}, a asignado a {{ data.asigned }}</small><p><b>{{ data.catg }}</b></p></div><div flex=20><p>criticidad</p><p></p><div tipo-criticidad=\"{{ data.criticidad | lowercase }}\" class=chip>{{ data.criticidad }}</div><p></p><p></p><div tipo-estado=\"{{ data.estado | lowercase }}\" class=chip>{{ data.estado }}</div><p></p></div></article><article layout=row><md-button ng-click=issueDetail($event,data.id) class=\"md-mini md-primary text-center w100\">ver detalles</md-button></article></div></div></div></div><section ng-repeat=\"tab in ctrl.tabsIssues track by $index\" ng-if=\"tab.id!=\'index\'\" ng-show=\"tab.id!=\'index\' &amp;&amp; ctrl.isSet(tab.id)\"><table class=\"table table-striped w100\"><thead><tr><th>-</th><th>Indicio</th><th>Categoria</th><th>Criticidad</th><th>Estado</th><th>Accion</th></tr></thead><tbody><tr ng-repeat=\"item in tab.data track by $index\"><td><md-checkbox ng-model=data.cb1 aria-label=\"Checkbox 1\"></md-checkbox></td><td><span ng-if=item.linked><md-icon md-font-set=material-icons class=pull-right>link</md-icon></span><p>{{ item.indicio }}</p><small>created at {{ item.created }} by {{ item.by }}, a asignado a {{ item.asigned }}</small></td><td>{{ item.catg }}</td><td><div tipo-criticidad=\"{{ item.criticidad | lowercase }}\" class=chip>{{ item.criticidad }}</div></td><td><div tipo-estado=\"{{ item.estado | lowercase }}\" class=chip>{{ item.estado }}</div></td><td><md-button ng-click=tabDetail($event,item.id)>ver</md-button></td></tr></tbody></table></section></md-card-content></md-card></div></section></div>");
$templateCache.put("app/lists/schemas-list.html","<md-card><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-data-list scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>{{ translation.custom_lists }}</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button has-permission=list:create ng-click=showCreateListDialog($event) aria-label=\"{{ translation.add_list }}\" class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>{{ translation.add_list }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></md-toolbar-filler></div></md-toolbar><md-toolbar style=\"background-color: #fafafa; color: black\"><div layout=row layout-align=\"end center\" class=md-toolbar-tools><div flex=1><md-button ng-click=getLists() aria-label=\"Refresh button\" class=\"md-raised p0 w_auto md-mini grey lighten-4\"><md-tooltip>Refresh</md-tooltip><md-icon md-font-set=material-icons class=grey-text>autorenew</md-icon></md-button></div><div><searcher value=schemasList.searchText placeholder=\"{{ translation.find }} {{ translation.list }}\"></searcher></div><div flex=1 ng-if=!schemasList.displayItems><md-button ng-click=schemasList.expandAll() aria-label=\"Unfold all button\" class=\"md-raised p0 w_auto md-mini grey lighten-4\"><md-tooltip>Expand all</md-tooltip><md-icon md-font-set=material-icons class=grey-text>unfold_more</md-icon></md-button></div><div flex=1 ng-if=schemasList.displayItems><md-button ng-click=schemasList.collapseAll() aria-label=\"Fold all button\" class=\"md-raised p0 w_auto md-mini grey lighten-4\"><md-tooltip>Collapse all</md-tooltip><md-icon md-font-set=material-icons class=grey-text>unfold_less</md-icon></md-button></div><div flex=1 ng-if=\"schemasList.sort==&quot;desc&quot;\"><md-button ng-click=schemasList.toggleSort() aria-label=\"sort asc\" class=\"md-raised p0 w_auto md-mini grey lighten-4 grey-text\"><md-tooltip>sort asc</md-tooltip><div class=\"fa fa-sort-alpha-desc\"></div></md-button></div><div flex=1 ng-if=\"schemasList.sort==&quot;asc&quot;\"><md-button ng-click=schemasList.toggleSort() aria-label=\"sort desc\" class=\"md-raised p0 w_auto md-mini grey lighten-4 grey-text\"><md-tooltip>sort desc</md-tooltip><div class=\"fa fa-sort-alpha-asc\"></div></md-button></div><div><md-button id=btnInputListonGoBack has-permission=schema:read ng-click=main.clickMenu(&quot;app.schemas&quot;) href=entries/schemas class=\"md-raised md-primary\">View Schemas</md-button></div></div></md-toolbar><ng-include src=&quot;app/lists/templates/input-list-tree-view.html&quot;></ng-include></md-card>");
$templateCache.put("app/login/cambiarPassword.html","<div tabindex=-1 role=dialog class=modal><div class=modal-dialog><div class=modal-content><div class=modal-header><a type=button abm-component=abm-component ng-click=$hide() class=close>×</a><h4 class=modal-title>{{ translation.CAMBIAR_PASSWORD }}</h4><div class=modal-body><div ng-if=validacion.show class=row><div class=col-xs-12><div class=\"panel panel-primary\"><div class=panel-heading><h3 class=panel-title><i class=icon-notifications></i>{{ validacion.content }}</h3></div></div></div></div></div><form action=\"\"><abm-form-group><label data-abm-label=\"\">{{ translation.PASSWORD_ANTIGUO }}</label><input type=password ng-model=login.passwordAntigua abm-form-control=\"\" placeholder=\"Password Antiguo\" class=form-control></abm-form-group><abm-form-group><label data-abm-label=\"\">{{ translation.PASSWORD_ANTIGUO }}</label><input type=password ng-model=login.passwordNueva abm-form-control=\"\" placeholder=\"Password Nuevo\" class=form-control></abm-form-group><abm-form-group><label data-abm-label=\"\">{{ translation.CONFIRMAR_PASSWORD }}</label><input type=password ng-model=login.passwordConfirmar abm-form-control=\"\" placeholder=\"Confirmar Password\" class=form-control></abm-form-group></form></div><div class=modal-footer><button type=button ng-click=closeModalPassword() class=\"btn btn-default\">{{ translation.CANCELAR }}</button> <button type=button ng-click=cambiarPassword() class=\"btn btn-primary\">{{ translation.CAMBIAR_PASSWORD2 }}</button></div></div></div></div>");
$templateCache.put("app/login/login.html","<div id=login-app-view-container data-form=\"{{ login.mode }}\"><section ng-show=!showPasswordEdit layout=row layout-align=\"center stretch\" layout-gt-lg layout-md layout-xs class=w100><div id=login style=\"width: 500px\" ng-if=!login.loadingProviders class=\"animated fadeInUp\"><br><div id=logo-app-ux data-logo=default ng-if=!login.customLogo style=\"height: 50px; background-size: contain ; background-image: url(\'/assets/images/logo/imagotipo.png\' ); background-repeat: no-repeat; background-position: center\"></div><div id=logo-app-ux ng-if=login.customLogo data-logo=custom style=\"height: 150px; background-size: contain; background-image: url({{ login.customLogo }}); background-repeat: no-repeat; background-position: center\"></div><div ng-show=\"login.providers.length &gt; 0 &amp;&amp; !showVerifyTwoFa\" style=\"margin-top: 2rem\" class=oauth><div class=login-with-group><a ng-repeat=\"provider in login.providers track by $index\" ng-href=\"{{ provider.uri }}\"><span>{{ translation.continue_with }} {{ provider.providerName }}</span><figure><img ng-src=\"/assets/images/login/logo-{{ provider.providerName.split(\'-\')[0] | lowercase}}.svg\" alt=\"{{ provider.providerName }}\" class=img-full></figure></a></div></div><form id=formLogin ng-show=\"login.providers.length === 0 &amp;&amp; !showVerifyTwoFa\" name=formLogin novalidate style=\"margin-top: 2rem\"><md-input-container ng-class=\"{ \'has-error\': form.$submitted &amp;&amp; form.username.$invalid }\" class=\"w100 m0\"><label class=active>{{ translation.username }}</label><md-icon md-font-set=material-icons md-menu-align-target>person</md-icon><input type=text name=username ng-model=login.username ng-required=true placeholder=. aria-label=\"Username field\" autocomplete=username autofocus></md-input-container><md-input-container ng-class=\"{ \'has-error\': form.$submitted &amp;&amp; form.password.$invalid }\" class=\"w100 m0\"><label class=active>{{ translation.password }}</label><md-icon md-font-set=material-icons md-menu-align-target>lock</md-icon><input type=password name=password ng-model=login.password ng-required=true placeholder=. aria-label=\"Password field\" autocomplete=current-password></md-input-container><md-input-container class=\"w100 m0\"><md-button id=login-button type=submit form=formLogin ng-disabled=\"formLogin.$invalid || loading\" ng-click=login.login() style=\"color: #fff\" class=\"md-raised main-color w100 m0\">{{ translation.login }}</md-button></md-input-container><md-input-container class=\"w100 m0 text-right\"><md-progress-linear md-mode=indeterminate ng-show=loading class=\"md-accent md-hue-2\"></md-progress-linear><br><a ng-if=\"login.isRecoveringSession === false\" ng-click=login.passwordResetModal()>{{ translation.recuperar_contrasena }}</a></md-input-container><div ng-if=login.error class=\"alert alert-danger ceptinel-error\">{{ login.error }}</div></form><form id=form2fa name=form2fa novalidate style=\"margin-top: 2rem\" ng-show=showVerifyTwoFa><md-input-container class=\"w100 m0\"><label class=active>{{ translation.security_check }}</label><md-icon md-font-set=material-icons md-menu-align-target>lock</md-icon><input name=securitycheck ng-model=login.code2fa ng-required=true placeholder=****** aria-label=\"code field\" autocomplete=off><p style=\"padding: 5rem 0 0 0\">{{ translation.input_code_2fa }}</p></md-input-container><md-input-container class=\"w100 m0\"><md-button id=login2fa-button type=submit form=form2fa ng-disabled=\"form2fa.$invalid || login.loading2fa\" ng-click=login.verify2fa() style=\"color: #fff\" class=\"md-raised main-color w100 m0\">{{ translation.confirm }}</md-button></md-input-container><md-input-container class=\"w100 m0 text-right\"><md-progress-linear md-mode=indeterminate ng-show=login.loading2fa class=\"md-accent md-hue-2\"></md-progress-linear><br><a ng-click=cancel2fa()>{{ translation.cancelar }}</a></md-input-container></form></div></section><section ng-show=showPasswordEdit layout=row layout-align=\"center center\"><div class=\"col-sm-8 col-sm-offset-2\"><div class=\"col-md-6 col-md-offset-3\"><div id=login><div id=login-header><h2>CEPTINEL</h2></div><div id=login-form-container><h2>{{ translation.cambiar_contrasena }}</h2><form name=form ng-submit=\"form.$valid &amp;&amp; login.login($event)\" novalidate><div ng-class=\"{ \'has-error\': form.$submitted &amp;&amp; form.username.$invalid }\" class=\"row form-group\"><div class=col-md-4><label for=changePassword1 style=\"color: #000; font-size: 14px\">{{ translation.nueva }}:</label></div><div class=col-md-8><input style=\"width: 100%\" type=password name=changePassword1 ng-model=login.changePassword1 required aria-label=\"New password field\" autocomplete=new-password></div></div><div ng-class=\"{ \'has-error\': form.$submitted &amp;&amp; form.password.$invalid }\" class=\"row form-group\"><div class=col-md-4><label for=changePassword2 style=\"color: #000; font-size: 14px\">{{ translation.confirmar }}:</label></div><div class=col-md-8><input style=\"width: 100%\" type=password name=changePassword2 ng-model=login.changePassword2 required aria-label=\"Confirm password field\" autocomplete=new-password><div ng-messages=\"form.$submitted &amp;&amp; form.password.$error\" class=help-block><div ng-message=required>Password is required</div></div></div></div><div class=login-btn-container><div class=form-group><a ng-disabled=login.loadingChangePassword ng-click=login.changePassword() class=\"btn btn-primary btn-raised active\">{{ translation.cambiar_contrasena }}</a></div></div><div ng-if=login.errorPassChange class=\"alert alert-error ceptinel-error\">{{ login.errorPassChange }}</div><div ng-if=login.successPassChange class=\"alert alert-success ceptinel-error\">{{ login.successPassChange }}</div></form></div></div></div></div></section></div>");
$templateCache.put("app/login/modal-expired.html","<div tabindex=-1 role=dialog class=modal><div class=modal-dialog><div class=modal-content><div class=modal-header><a type=button abm-component ng-click=$hide() class=close>×</a><h4 class=modal-title>{{translation.ALERTA}}</h4></div><div class=modal-body>{{translation.SESION_EXPIRTADA}}</div><div class=modal-footer><button type=button ng-click=$hide() class=\"btn btn-default\">{{translation.CONTINUAR}}</button></div></div></div></div>");
$templateCache.put("app/login/modal-reset-password.html","<div tabindex=-1 role=dialog class=modal><md-progress-linear md-mode=indeterminate ng-show=loading class=\"md-accent md-hue-2\"></md-progress-linear><div style=\"width: 300px\" class=\"modal-dialog modal-reset\"><div ng-show=!request class=modal-content><div class=modal-header><h4 class=text-main-color>{{ translation.recuperar_contrasena2 }}</h4></div><div class=modal-body><p>{{ message }}</p><br><md-input-container ng-class=\"{ &quot;has-error&quot;: form.$submitted &amp;&amp; form.username.$invalid }\" class=\"w100 m0 md-block\"><label class=active>{{ translation.username }}</label><md-icon md-font-set=material-icons md-menu-align-target>lock</md-icon><input id=recovery-password type=text ng-model=username placeholder=\"{{ translation.coloque_usuario }}\" class=input-recovery></md-input-container><div class=text-right><md-button ng-click=startReset() ng-disabled=loading style=\"color: #fff\" class=\"md-raised main-color\">{{ translation.enviar }}</md-button><md-button type=button ng-click=\"$hide(); cancel();\" ng-disabled=loading class=\"md-raised btn-default\">{{ translation.cancelar }}</md-button></div></div></div><div ng-show=request class=modal-content><div class=modal-header><h4 class=text-main-color>{{ translation.recuperacion_enviada }}</h4></div><div class=modal-body><p>{{ translation.msj5 }}</p><p style=\"color: #888888\">{{ translation.msj4 }}.</p></div><div class=\"modal-footer text-right\"><md-button type=button ng-click=\"$hide(); cancel();\" class=\"md-raised btn-default\">OK</md-button></div></div></div></div>");
$templateCache.put("app/login/oauth-login.html","<div id=login-app-view-container><section layout=row layout-align=\"center stretch\" layout-gt-lg layout-md layout-xs class=w100><div id=login style=\"width: 500px\" ng-if=!login.loadingProviders class=\"animated fadeInUp\"><br><div id=logo-app-ux data-logo=default ng-if=!login.customLogo style=\"height: 50px; background-size: contain ; background-image: url(\'/assets/images/logo/imagotipo.png\' ); background-repeat: no-repeat; background-position: center\"></div><div id=logo-app-ux ng-if=login.customLogo data-logo=custom style=\"height: 150px; background-size: contain; background-image: url({{ login.customLogo }}); background-repeat: no-repeat; background-position: center\"></div><div class=text-center><div style=\"font-size: 24px; font-weight: 500; margin-top: 20px;display: flex; align-items: center; justify-content: center; gap: 10px\"><span>{{ login.traslation.loginWith }} {{ login.providerName }}</span><figure><img ng-src=\"/assets/images/login/logo-{{ login.providerName.split(\'-\')[0] | lowercase}}.svg\" alt=\"{{ login.providerName }}\" class=img-full></figure></div><p>{{ login.traslation.redirecting }}</p><p>{{ login.traslation.pleaseWait }}</p><md-progress-linear md-mode=indeterminate></md-progress-linear></div></div></section></div>");
$templateCache.put("app/main/main.html","<ng-include src=&quot;app/includes/loader.html&quot;></ng-include><main id=mainLayout flex layout=column data-theme=\"{{ main.DashboardTheme }}\"><main-menu is-open=\"{{ main.menuOpen }}\" on-update-favs=main.favs></main-menu><ng-include src=&quot;app/includes/header.html&quot;></ng-include><div id=mainContent flex ui-view=layoutContent></div><chat-bot></chat-bot></main><footer id=mainFooter layout=row layout-align=\"center center\"><div flex=25><img ng-if=main.customLogo src=./assets/theme_image/powered.png style=\"object-fit: contain\" class=powered-by></div><div flex class=text-right><a ng-click=openDocumentation() target=_blank style=\"margin-right: 0.5rem\" class=social_share_link><i class=\"material-icons theme_color\">chrome_reader_mode</i>&nbsp;{{ translation.documentation }}</a><span style=\"margin-left: 2rem\" my-current-time=format></span></div><div flex=15 class=text-right><p style=white class=\"m0 p0\">&nbsp; version: &nbsp;<strong>{{ main.version }}</strong></p></div></footer>");
$templateCache.put("app/perfiles/perfiles - copia.html","<div class=bs-component><ul class=\"nav nav-tabs\"><li ng-class={activeTab}><a href=javascript:; data-toggle=tab abm-component=abm-component class=btn-raised><span class=title>{{translation.SEGURIDAD_PERFILES}}</span></a></li></ul><div class=row><!-- -- Sección del datos del perfil--><div class=col-md-12><div class=\"tab-content box-title separate\"><div ng-show=contentPerfil class=row><div class=col-md-10><div id=alert-msg class=\"alert alert-danger\">{{contentPerfil}}</div></div></div><div class=row><div class=col-md-12><div class=row><div class=col-md-12><label class=\"text-title underline\">{{translation.PERFIL}}</label></div></div><div class=row><br><div class=col-md-1></div><div style=line-height:25px class=\"col-md-10 col-sm-12\"><div class=row><div class=\"col-md-4 col-sm-12\"><div class=input-icon><input type=text ng-model=profile placeholder=\"{{translation.BUSCAR_PERFIL}} ...\" uib-typeahead=\"listaPerfilRolOpcion as listaPerfilRolOpcion.profileId for listaPerfilRolOpcion in listadoPerfilesRolesOpciones | filter:{profileId:$viewValue}\" typeahead-show-hint=true typeahead-min-length=0 class=form-control><div ng-click=busquedaPerfil() class=box-icon><i class=\"fa fa-search search-icon\"></i></div></div></div></div><div class=row><div class=\"col-md-4 col-sm-6\"><label>{{translation.PERFIL}}</label><input type=text ng-model=riskProfile.profileName ng-disabled=!editActive class=form-control></div><div class=\"col-md-4 col-sm-6\"><label>{{translation.CODIGO_PERFIL}}</label><input type=text ng-model=riskProfile.profileId ng-disabled=\"!editActive || !codPerfil\" class=form-control></div><div class=\"col-md-4 col-sm-6\"><label>{{translation.PERFIL_ORIGEN}}</label><input type=text ng-model=riskProfile.originalProfileId ng-disabled=!editActive class=form-control></div><div class=\"col-md-12 col-sm-6\"><label>{{translation.DESCRIPCION}}</label><input type=text ng-model=riskProfile.descripcion ng-disabled=!editActive class=form-control></div><div class=col-md-1><md-checkbox ng-model=riskProfile.activo ng-checked=false ng-disabled=!editActive md-no-ink aria-label=\"Checkbox 2\" class=white></md-checkbox></div><div class=\"col-md-3 text-left\"><label>{{translation.ACTIVO}}</label></div><div class=col-md-12><label>{{translation.ROLES_PERFIL}}</label><md-select ng-model=listadoRolesSeleccionados ng-model-options=\"{trackBy: \'$value.roleId\'}\" multiple><md-optgroup label=Roles><!--ng-click=\'seleccionarRoles(listadoRoles)\'--></md-optgroup><md-option ng-value=listadoRoles ng-disabled=!editActive ng-repeat=\"listadoRoles in listadoRol\">{{listadoRoles.roleDescription}}</md-option></md-select></div><div style=text-align:right class=col-md-12><button type=button ng-disabled=!botonesDeAccion.crear ng-click=habilitarCrear() class=\"btn-rosado btn btn-default btn-group-sm\">{{translation.CREAR}}</button> <button type=button ng-disabled=!botonesDeAccion.guardar ng-show=!botonesDeAccion.editar ng-click=guardarPerfil() class=\"btn-rosado btn btn-default btn-group-sm\">{{translation.GUARDAR}}</button> <button type=button ng-disabled=!botonesDeAccion.editar ng-show=botonesDeAccion.editar ng-click=chequearEditarPerfil() class=\"btn-rosado btn btn-default btn-group-sm\">{{translation.GUARDAR}}</button> <button type=button ng-disabled=!botonesDeAccion.cancelar ng-click=limpiarFormulario() class=\"btn-rosado btn btn-default btn-group-sm\">{{translation.CANCELAR}}</button></div></div></div></div></div></div></div></div><!--.col-md-6\n    .tab-content.box-title.separate\n      .row(style=\"margin-bottom:15px;\")\n        .col-md-12\n          label.text-title.underline PERFIL HABILITADO PARA\n      .row(ng-repeat=\'listadoRoles in listadoRol\')\n        .col-md-2.col-sm-2.col-xs-2\n          md-checkbox(ng-model=\'listadoRoles.value\'\n                      ng-click=\'seleccionarRoles(listadoRoles)\'\n                      class=\"white\"\n                      ng-disabled=\"!editActive\"\n                      md-no-ink\n                      aria-label=\"Checkbox 2\" )\n        .col-md-10.col-sm-10.col-xs-10\n          label {{listadoRoles.roleDescription}}\n    \n    \n    --><!-- -- Pestañas / Opciones de Sistemas - Opciones de Informes--><div class=col-md-12><div class=\"tab-content box-title separate\"><md-tabs md-dynamic-height md-border-bottom><md-tab label={{translation.OPCIONES_SISTEMA}}><md-content class=md-padding><div class=row><div class=col-md-6><md-list style=\"border:1px solid #e0e0e0\"><md-subheader style=height:60px class=md-no-sticky>{{translation.MODULOS_DISPONIBLES}}</md-subheader><md-list-item ng-click=null ng-repeat=\"listadoOpciones in listadoOpcion\" class=btn-ceptinel><p>{{listadoOpciones.tipoFuncion}} - {{listadoOpciones.contenedor}} <span style=font-size:.8em>&nbsp;({{listadoOpciones.idFuncion}})</span></p><md-checkbox ng-model=listadoOpciones.habilitado ng-click=seleccionarOpciones(listadoOpciones) ng-disabled=!editActive md-no-ink aria-label={{listadoOpciones.idFuncion}} class=white></md-checkbox><md-divider ng-if=!$last></md-divider></md-list-item></md-list></div><div class=col-md-6><md-list style=\"border:1px solid #e0e0e0\"><md-subheader style=height:60px class=md-no-sticky>{{translation.MODULOS_HABILITADOS}}</md-subheader><md-list-item ng-click=null ng-repeat=\"listadoOpciones in listadoOpcionesSeleccionados\" class=btn-ceptinel><p>{{listadoOpciones.tipoFuncion}} - {{listadoOpciones.contenedor}} <span style=font-size:.8em>&nbsp;({{listadoOpciones.idFuncion}})</span></p><md-divider ng-if=!$last></md-divider></md-list-item><md-list-item ng-show=!listadoOpcionesSeleccionados.length style=min-height:53px class=btn-ceptinel><p>{{translation.SIN_SECCIONES}}</p></md-list-item></md-list></div></div></md-content></md-tab><md-tab label={{translation.OPCIONES_INFORMES}}><md-content class=\"md-padding row\"><!-- -- Listado de grupos--><div class=col-md-6><md-list style=\"border:1px solid #e0e0e0\"><md-subheader style=height:60px class=md-no-sticky><!-- -- Menú emergente-->{{translation.GRUPOS}}<md-menu style=\"position:relative; top:-10px\" md-position-mode=\"target-right target\" class=pull-right><md-button ng-click=$mdMenu.open($event) aria-label={{translation.ABRIR_MENU}} class=\"md-icon-button md-ink-ripple\"><i aria-hidden=true class=\"fa fa-ellipsis-v\"></i></md-button><md-menu-content><md-menu-item><md-button ng-click=null><md-checkbox ng-model=settings.filtroGrupos ng-click=$mdMenu.close() ng-true-value=true ng-false-value=undefined aria-label={{translation.FILTRAR_GRUPOS}}></md-checkbox>{{translation.GRUPOS_ACTIVOS}}</md-button></md-menu-item><md-menu-item><md-button ng-click=settings.cargarGruposPBI() aria-label={{translation.RECARGAR_GRUPOS}}><md-icon md-font-set=material-icons>autorenew</md-icon>{{translation.RECARGAR_GRUPOS}}</md-button></md-menu-item></md-menu-content></md-menu></md-subheader><md-list-item ng-click=listarReportes(gruposPBI) ng-repeat=\"gruposPBI in pbi.groups | orderBy:&quot;-activo&quot; | filter: {activo:settings.filtroGrupos}\" ng-show=!loaderGroups class=btn-ceptinel><p>{{gruposPBI.name}} <span style=font-size:.8em ng-show=!gruposPBI.activo>&nbsp;({{translation.GRUPO_INACTIVO}})</span></p><md-checkbox ng-model=gruposPBI.habilitado ng-click=seleccionarGruposPBI(gruposPBI) ng-disabled=\"!editActive || !gruposPBI.activo\" md-no-ink aria-label={{gruposPBI.name}} class=white></md-checkbox><md-divider ng-if=!$last></md-divider></md-list-item><md-list-item ng-show=\"!pbi.groups.length &amp;&amp; !loaderGroups\" class=btn-ceptinel><p>{{translation.SIN_GRUPOS}}</p></md-list-item><md-list-item ng-show=loaderGroups><p><md-progress-linear md-mode=indeterminate class=\"md-accent md-hue-2\"></md-progress-linear></p></md-list-item></md-list></div><!-- -- Listado de informes--><div class=col-md-6><md-list style=\"border:1px solid #e0e0e0\"><md-subheader style=height:60px class=md-no-sticky>{{translation.INFORMES_DISPONIBLES}} {{grupoSelect}}</md-subheader><md-list-item ng-click=null ng-repeat=\"reportesPBI in pbi.reports\" style=min-height:53px class=btn-ceptinel><p>{{reportesPBI.name}}</p><md-divider ng-if=!$last></md-divider></md-list-item><md-list-item ng-click=null ng-show=\"!pbi.reports.length &amp;&amp; !loaderReports\" style=min-height:53px class=btn-ceptinel><p>{{translation.SIN_INFORMES}}</p></md-list-item><md-list-item ng-click=null ng-show=loaderReports style=min-height:53px><p><md-progress-linear md-mode=indeterminate class=\"md-accent md-hue-2\"></md-progress-linear></p></md-list-item></md-list></div></md-content></md-tab></md-tabs></div></div><!-- -- Botones de acción --><!--.row\n    .col-md-6\n    .col-md-6.pull-right\n      button.btn-rosado.btn.btn-default.btn-group-sm(type=\'button\'\n                                                     ng-disabled=\"!botonesDeAccion.crear\"\n                                                     ng-click=\'habilitarCrear()\') \n                                                     |Crear\n        button.btn-rosado.btn.btn-default.btn-group-sm(type=\'button\'\n                                                       ng-disabled=\"!botonesDeAccion.guardar\"       \n                                                       ng-show=\"!botonesDeAccion.editar\"\n                                                       ng-click=\'guardarPerfil()\') \n                                                       |Guardar\n        button.btn-rosado.btn.btn-default.btn-group-sm(type=\'button\' \n                                                        ng-disabled=\"!botonesDeAccion.editar\"\n                                                        ng-show=\"botonesDeAccion.editar\"  \n                                                        ng-click=\'chequearEditarPerfil()\') \n                                                        |Guardar\n        button.btn-rosado.btn.btn-default.btn-group-sm(type=\'button\'\n                                                        ng-disabled=\"!botonesDeAccion.cancelar\"\n                                                        ng-click=\'limpiarFormulario()\') \n                                                        |Cancelar\n    \n    \n        \n    --></div></div>");
$templateCache.put("app/perfiles/perfiles.html","<div class=bs-component><md-card class=m0><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{translation.SEGURIDAD_PERFILES}}</h2></div></md-toolbar><section layout=row layout-padding=\"\"><div flex=20><input type=text ng-model=profile placeholder=\"{{translation.BUSCAR_PERFIL}} ...\" uib-typeahead=\"listaPerfilRolOpcion as listaPerfilRolOpcion.profileId for listaPerfilRolOpcion in listadoPerfilesRolesOpciones | filter:{profileId:$viewValue}\" typeahead-show-hint=true typeahead-min-length=0 class=form-control></div><div flex=20><md-input-container class=\"w100 m0\"><md-button ng-click=busquedaPerfil() class=md-raised><md-icon md-font-set=material-icons md-menu-align-target>search</md-icon>{{translation.SEARCH}}</md-button></md-input-container></div></section><section layout=row layout-padding=\"\"><div flex=20><md-input-container class=\"w100 m0\"><label>{{translation.PERFIL}}</label><input type=text ng-model=riskProfile.profileName ng-disabled=!editActive></md-input-container></div><div flex=20><md-input-container class=\"w100 m0\"><label>{{translation.CODIGO_PERFIL}}</label><input type=text ng-model=riskProfile.profileId ng-disabled=\"!editActive || !codPerfil\"></md-input-container></div><div flex=20><md-input-container class=\"w100 m0\"><label>{{translation.PERFIL_ORIGEN}}</label><input type=text ng-model=riskProfile.originalProfileId ng-disabled=!editActive></md-input-container></div><div flex=30><md-input-container class=\"w100 m0\"><label>{{translation.DESCRIPCION}}</label><input type=text ng-model=riskProfile.descripcion ng-disabled=!editActive></md-input-container></div><div flex=10><md-checkbox ng-model=riskProfile.activo ng-checked=false ng-disabled=!editActive md-no-ink aria-label=\"Checkbox 2\">{{translation.ACTIVO}}</md-checkbox></div></section><section layout=row layout-padding=\"\"><div flex=100><label>{{translation.ROLES_PERFIL}}</label><md-select ng-model=listadoRolesSeleccionados ng-model-options=\"{trackBy: \'$value.roleId\'}\" multiple aria-label=listadoRolesSeleccionados><md-optgroup label=Roles><md-option ng-value=listadoRoles ng-disabled=!editActive ng-repeat=\"listadoRoles in listadoRol\">{{listadoRoles.roleDescription}}</md-option></md-optgroup></md-select></div></section><section layout=row layout-padding=\"\" layout-align=\"end center\"><div flex=100 class=text-right><md-button type=button ng-disabled=!botonesDeAccion.crear ng-click=habilitarCrear() class=\"md-raised md-primary\">{{translation.CREAR}}</md-button><md-button type=button ng-disabled=!botonesDeAccion.guardar ng-show=!botonesDeAccion.editar ng-click=guardarPerfil() class=md-raised>{{translation.GUARDAR}}</md-button><md-button type=button ng-disabled=!botonesDeAccion.editar ng-show=botonesDeAccion.editar ng-click=chequearEditarPerfil() class=md-raised>{{translation.GUARDAR}}</md-button><md-button type=button ng-disabled=!botonesDeAccion.cancelar ng-click=limpiarFormulario() class=\"md-raised md-warn\">{{translation.CANCELAR}}</md-button></div></section><section layout=row layout-padding=\"\"><div flex=100><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label={{translation.OPCIONES_SISTEMA}}><md-content class=md-padding><section layout=row layout-padding=\"\"><div flex=50><md-list style=\"border:1px solid #e0e0e0\"><md-subheader>{{translation.MODULOS_DISPONIBLES}}</md-subheader><md-list-item ng-click=null ng-repeat=\"listadoOpciones in listadoOpcion\"><p>{{listadoOpciones.tipoFuncion}} - {{listadoOpciones.contenedor}} <span>&nbsp;({{listadoOpciones.idFuncion}})</span></p><md-checkbox ng-model=listadoOpciones.habilitado ng-click=seleccionarOpciones(listadoOpciones) ng-disabled=!editActive md-no-ink aria-label={{listadoOpciones.idFuncion}}></md-checkbox><md-divider ng-if=!$last></md-divider></md-list-item></md-list></div><div flex=50><md-list style=\"border:1px solid #e0e0e0\"><md-subheader>{{translation.MODULOS_HABILITADOS}}</md-subheader><md-list-item ng-click=null ng-repeat=\"listadoOpciones in listadoOpcionesSeleccionados\"><p>{{listadoOpciones.tipoFuncion}} - {{listadoOpciones.contenedor}} <span>&nbsp;({{listadoOpciones.idFuncion}})</span></p><md-divider ng-if=!$last></md-divider></md-list-item><md-list-item ng-show=!listadoOpcionesSeleccionados.length><p>{{translation.SIN_SECCIONES}}</p></md-list-item></md-list></div></section></md-content></md-tab><md-tab label={{translation.OPCIONES_INFORMES}}><md-content class=md-padding><section layout=row layout-padding=\"\"><div flex=50><md-list style=\"border:1px solid #e0e0e0\"><md-subheader>{{translation.GRUPOS}}<md-menu style=\"position:relative; top:-10px\" md-position-mode=\"target-right target\" class=pull-right><md-button ng-click=$mdMenu.open($event) aria-label={{translation.ABRIR_MENU}} class=\"md-icon-button md-ink-ripple\"><i aria-hidden=true class=\"fa fa-ellipsis-v\"></i></md-button><md-menu-content><md-menu-item><md-button ng-click=null><md-checkbox ng-model=settings.filtroGrupos ng-click=$mdMenu.close() ng-true-value=true ng-false-value=undefined aria-label={{translation.FILTRAR_GRUPOS}}></md-checkbox>{{translation.GRUPOS_ACTIVOS}}</md-button></md-menu-item><md-menu-item><md-button ng-click=settings.cargarGruposPBI() aria-label={{translation.RECARGAR_GRUPOS}}><md-icon md-font-set=material-icons>autorenew</md-icon>{{translation.RECARGAR_GRUPOS}}</md-button></md-menu-item></md-menu-content></md-menu></md-subheader></md-list></div><div flex=50><md-list style=\"border:1px solid #e0e0e0\"><md-subheader>{{translation.INFORMES_DISPONIBLES}} {{grupoSelect}}</md-subheader><md-list-item ng-click=null ng-repeat=\"reportesPBI in pbi.reports\"><p>{{reportesPBI.name}}</p><md-divider ng-if=!$last></md-divider></md-list-item><md-list-item ng-click=null ng-show=\"!pbi.reports.length &amp;&amp; !loaderReports\"><p>{{translation.SIN_INFORMES}}</p></md-list-item><md-list-item ng-click=null ng-show=loaderReports><p><md-progress-linear md-mode=indeterminate class=\"md-accent md-hue-2\"></md-progress-linear></p></md-list-item></md-list></div></section></md-content></md-tab></md-tabs></md-content></div></section></md-card></div>");
$templateCache.put("app/perfiles/same-profile.html","<div tabindex=-1 role=dialog class=modal><div class=modal-dialog><div class=\"modal-content medium-modal\"><div class=modal-header><a type=button abm-component ng-click=$hide() class=close>×</a><h4 class=text-title>{{translation.MODIFCACION_PERFIL}}<div class=\"dashboard-badge-indicador dashboard-badge title-badge\"><div class=dashboard-bagde></div></div></h4></div><div class=modal-body>{{translation.MSJ1}}<br><br>{{translation.MSJ2}}.<br><br>{{translation.MSJ3}}.</div><div style=\"margin-bottom: 22px\" class=modal-footer><button ng-click=editarPerfil(true) class=\"btn btn-primary btn-raised active recovery-button\">{{translation.CONTINUAR}}</button> <button ng-click=$hide() class=\"btn btn-primary btn-raised active recovery-button\">{{translation.CANCELAR}}</button></div></div></div></div>");
$templateCache.put("app/profiles/profiles.html","<div ng-cloak class=\"animated fadeInLeft\"><md-card class=m0><md-toolbar class=main-color><div class=md-toolbar-tools><h2 flex=\"\" md-truncate=\"\">{{translation.SEGURIDAD_PERFILES}}</h2><md-button ng-click=habilitarCrear() aria-label={{translation.CREAR}} class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>{{translation.CREAR}}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></div></md-toolbar><section layout=row layout-padding=\"\" style=\"border-bottom:solid 1px #eaeaea\" ng-show=!editActive><table class=table><thead><tr><th>profileId</th><th>Name</th><th>Descripcion</th><th>Activo</th><th>Accion</th></tr></thead><tbody><tr ng-repeat=\"item in listadoPerfilesRolesOpciones | filter:{profileId:$viewValue}\"><td>{{item.profileId}}</td><td>{{item.profileName}}</td><td>{{item.descripcion}}</td><td>{{item.activo}}</td><td><md-button type=button ng-click=setPerfil(item) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target class=\"text-danger md-primary\">edit<md-tooltip md-direction=bottom>{{translation.edit}}</md-tooltip></md-icon></md-button></td></tr></tbody></table></section></md-card><md-card style=padding-top:20px ng-show=editActive class=m0><section layout=row layout-padding=\"\" layout-wrap=\"\"><div flex=50><md-input-container class=\"w100 m0\"><label>{{translation.PERFIL}}</label><input type=text ng-model=riskProfile.profileName ng-disabled=!editActive></md-input-container></div><div flex=50><md-input-container class=\"w100 m0\"><label>{{translation.CODIGO_PERFIL}}</label><input type=text ng-model=riskProfile.profileId ng-disabled=\"!editActive || !codPerfil\"></md-input-container></div><div flex=50><md-input-container class=\"w100 m0\"><label>{{translation.PERFIL_ORIGEN}}</label><input type=text ng-model=riskProfile.originalProfileId ng-disabled=!editActive></md-input-container></div><div flex=40><md-input-container class=\"w100 m0\"><label>{{translation.DESCRIPCION}}</label><input type=text ng-model=riskProfile.descripcion ng-disabled=!editActive></md-input-container></div><div flex=10><md-checkbox ng-model=riskProfile.activo ng-checked=false ng-disabled=!editActive md-no-ink aria-label=\"Checkbox 2\">{{translation.ACTIVO}}</md-checkbox></div><div flex=100><label>{{translation.ROLES_PERFIL}}</label><md-select ng-model=listadoRolesSeleccionados ng-model-options=\"{trackBy: \'$value.roleId\'}\" multiple aria-label=listadoRolesSeleccionados><md-optgroup label=Roles><md-option ng-value=listadoRoles ng-disabled=!editActive ng-repeat=\"listadoRoles in listadoRol\">{{listadoRoles.roleDescription}}</md-option></md-optgroup></md-select></div></section><section layout=row layout-padding=\"\" layout-align=\"end center\"><div flex=100 class=text-right><md-button type=button ng-disabled=!botonesDeAccion.guardar ng-show=!botonesDeAccion.editar ng-click=guardarPerfil() class=\"md-raised md-primary\">{{translation.GUARDAR}}</md-button><md-button type=button ng-disabled=!botonesDeAccion.editar ng-show=botonesDeAccion.editar ng-click=chequearEditarPerfil() class=\"md-raised md-primary\">{{translation.GUARDAR}}</md-button><md-button type=button ng-click=limpiarFormulario() class=\"md-raised md-warn\">{{translation.CANCELAR}}</md-button></div></section><section layout=row layout-padding=\"\"><div flex=100><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label={{translation.OPCIONES_SISTEMA}}><md-content class=md-padding><section layout=row layout-padding=\"\"><div flex=50><md-list style=\"border:1px solid #e0e0e0\"><md-subheader>{{translation.MODULOS_DISPONIBLES}}</md-subheader><md-list-item ng-click=null ng-repeat=\"listadoOpciones in listadoOpcion\"><p>{{listadoOpciones.tipoFuncion}} - {{listadoOpciones.contenedor}} <span>&nbsp;({{listadoOpciones.idFuncion}})</span></p><md-checkbox ng-model=listadoOpciones.habilitado ng-click=seleccionarOpciones(listadoOpciones) ng-disabled=!editActive md-no-ink aria-label={{listadoOpciones.idFuncion}}></md-checkbox><md-divider ng-if=!$last></md-divider></md-list-item></md-list></div><div flex=50><md-list style=\"border:1px solid #e0e0e0\"><md-subheader>{{translation.MODULOS_HABILITADOS}}</md-subheader><md-list-item ng-click=null ng-repeat=\"modSelected in listadoOpcionesSeleccionados\"><p>{{modSelected.tipoFuncion}} - {{modSelected.contenedor}} <span>&nbsp;({{modSelected.idFuncion}})</span></p><md-divider ng-if=!$last></md-divider></md-list-item><md-list-item ng-show=!listadoOpcionesSeleccionados.length><p>{{translation.SIN_SECCIONES}}</p></md-list-item></md-list></div></section></md-content></md-tab><md-tab label={{translation.OPCIONES_INFORMES}}><md-content class=md-padding><section layout=row layout-padding=\"\"><div flex=50><md-list style=\"border:1px solid #e0e0e0\"><md-subheader>{{translation.GRUPOS}}<md-menu style=\"position:relative; top:-10px\" md-position-mode=\"target-right target\" class=pull-right><md-button ng-click=$mdMenu.open($event) aria-label={{translation.ABRIR_MENU}} class=\"md-icon-button md-ink-ripple\"><i aria-hidden=true class=\"fa fa-ellipsis-v\"></i></md-button><md-menu-content><md-menu-item><md-button ng-click=null><md-checkbox ng-model=settings.filtroGrupos ng-click=$mdMenu.close() ng-true-value=true ng-false-value=undefined aria-label={{translation.FILTRAR_GRUPOS}}></md-checkbox>{{translation.GRUPOS_ACTIVOS}}</md-button></md-menu-item><md-menu-item><md-button ng-click=settings.cargarGruposPBI() aria-label={{translation.RECARGAR_GRUPOS}}><md-icon md-font-set=material-icons>autorenew</md-icon>{{translation.RECARGAR_GRUPOS}}</md-button></md-menu-item></md-menu-content></md-menu></md-subheader></md-list></div><div flex=50><md-list style=\"border:1px solid #e0e0e0\"><md-subheader>{{translation.INFORMES_DISPONIBLES}} {{grupoSelect}}</md-subheader><md-list-item ng-click=null ng-repeat=\"reportesPBI in pbi.reports\"><p>{{reportesPBI.name}}</p><md-divider ng-if=!$last></md-divider></md-list-item><md-list-item ng-click=null ng-show=\"!pbi.reports.length &amp;&amp; !loaderReports\"><p>{{translation.SIN_INFORMES}}</p></md-list-item><md-list-item ng-click=null ng-show=loaderReports><p><md-progress-linear md-mode=indeterminate class=\"md-accent md-hue-2\"></md-progress-linear></p></md-list-item></md-list></div></section></md-content></md-tab></md-tabs></md-content></div></section></md-card></div>");
$templateCache.put("app/profiles/same-profile.html","<div tabindex=-1 role=dialog class=modal><div class=modal-dialog><div class=\"modal-content medium-modal\"><div class=modal-header><a type=button abm-component ng-click=$hide() class=close>×</a><h4 class=text-title>{{translation.MODIFCACION_PERFIL}}<div class=\"dashboard-badge-indicador dashboard-badge title-badge\"><div class=dashboard-bagde></div></div></h4></div><div class=modal-body>{{translation.MSJ1}}<br><br>{{translation.MSJ2}}.<br><br>{{translation.MSJ3}}.</div><div style=\"margin-bottom: 22px\" class=modal-footer><button ng-click=editarPerfil(true) class=\"btn btn-primary btn-raised active recovery-button\">{{translation.CONTINUAR}}</button> <button ng-click=$hide() class=\"btn btn-primary btn-raised active recovery-button\">{{translation.CANCELAR}}</button></div></div></div></div>");
$templateCache.put("app/rankings/rankings.html","<div class=\"bs-component sticky-parent\"><md-card><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-rankings scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=md-toolbar-tools><span>{{ translation.rankings }}</span></h2></div></md-toolbar><md-card-content layout=row layout-wrap><form><md-radio-group ng-model=data.group1><section class=row><article style=\"border:0px solid black\" class=col-md-6><h4>{{ translation.filters }}:</h4><md-select placeholder=\"{{translation.function}} ({{translation.rule | lowercase}})\" ng-model=rankings.query.filters.function style=\"min-width: 200px\" ng-change=rankings.setParamsByRule() required><md-option ng-repeat=\"filterBy in rankings.criterias.filterBy[0].items | filter:searchTerm\" ng-value=filterBy>{{ filterBy.name }}</md-option></md-select><div class=row><div class=col-md-3><md-select ng-model=rankings.query.filters.columnName placeholder=Column ng-change=rankings.cleanColumnValues() md-on-open=rankings.lookForParams() aria-label=\"ColumnName selector\"><md-option ng-value=column ng-repeat=\"column in rankings.criterias.selectedRule.orderBy | filter:searchTerm\">{{ column }}</md-option></md-select></div><div class=col-md-9><md-autocomplete md-input-name=autocompleteField md-floating-label=Value ng-disabled=!rankings.query.filters.columnName md-no-cache=true md-selected-item=rankings.query.filters._columnValue md-search-text=rankings.searchText md-items=\"item in rankings.querySearch(rankings.searchText)\" md-item-text=item.text md-min-length=0 md-clear-button=true><md-item-template><span md-highlight-text=rankings.searchText>{{ item.text }}</span></md-item-template><md-not-found>Without results for \"{{ rankings.searchText }}\".</md-not-found></md-autocomplete></div></div></article><article style=\"border:0px solid black\" class=col-md-6><h4>{{ translation.param }}:</h4><md-select placeholder={{translation.select}}... ng-model=rankings.query._field md-on-open=rankings.lookForParams() ng-change=rankings.cleanOp() style=\"min-width: 200px\" aria-label=\"Parameters selector\"><md-option ng-value=\"\"><span ng-if=!rankings.criterias.selectedRule.operationValues.length>Empty</span></md-option><md-option ng-repeat=\"param in rankings.criterias.selectedRule.operationValues | filter:searchTerm\" ng-value=param>{{ param.value || title }}</md-option></md-select><h4>{{ translation.operation }}</h4><div layout=row><md-radio-group ng-model=rankings.query.operation><md-input-container flex=33><md-radio-button value=sum ng-disabled=\"!(rankings.query._field.operations.indexOf(\'sum\') &gt; -1)\" class=md-primary>Sum.</md-radio-button></md-input-container><md-input-container flex=33><md-radio-button value=max ng-disabled=\"!(rankings.query._field.operations.indexOf(\'max\') &gt; -1)\" class=md-primary>Max.</md-radio-button></md-input-container><md-input-container flex=33><md-radio-button value=min ng-disabled=\"!(rankings.query._field.operations.indexOf(\'min\') &gt; -1)\" class=md-primary>Min.</md-radio-button></md-input-container></md-radio-group></div></article><article style=\"border:0px solid black\" class=col-md-6><h4>{{ translation.groupBy }}:</h4><md-select ng-model=rankings.query.groupBy md-on-open=rankings.lookForParams() md-on-close=clearSearchTerm() data-md-container-class=\"\" placeholder={{translation.select}}... multiple required><md-option ng-value=groupBy ng-repeat=\"groupBy in rankings.criterias.selectedRule.groupBy | filter:searchTerm\">{{ groupBy }}</md-option></md-select><h4>{{ translation.orderBy }}:</h4><md-select ng-model=rankings.query.orderBy md-on-open=rankings.lookForParams() md-on-close=clearSearchTerm() data-md-container-class=\"\" placeholder={{translation.select}}... multiple><md-option ng-value=orderBy ng-repeat=\"orderBy in rankings.criterias.selectedRule.orderBy | filter:searchTerm\">{{ orderBy }}</md-option></md-select></article><article style=\"border:0px solid black\" class=col-md-6><h4>{{ translation.range }}</h4><div layout=row><abm-form-group flex=50 class=form-group><input type=text bs-datepicker placeholder=\"{{ translation.from }}\" ng-model=main.desde abm-form-control=\"\" data-min-date=\"{{ main.desdeMinimo }}\" data-max-date=\"{{ main.hasta }}\" data-autoclose=1 data-date-format=dd-MM-yyyy ng-change=main.bDate() class=form-control></abm-form-group><abm-form-group flex=50 class=form-group><input type=text bs-datepicker placeholder=\"{{ translation.to }}\" ng-model=main.hasta abm-form-control=\"\" data-min-date=\"{{ main.desde }}\" data-autoclose=1 data-date-format=dd-MM-yyyy data-max-date=today ng-change=main.bDate() class=form-control></abm-form-group></div></article></section></md-radio-group></form></md-card-content><div layout-align=\"end center\" class=\"md-toolbar-tools isSticky inBottom white\"><md-button ng-click=rankings.setQuery() class=\"md-raised md-primary main-color\">{{ translation.apply }}</md-button><md-button ng-click=rankings.cancel()>{{ translation.cancel }}</md-button></div><md-card-content layout=row><div ng-if=!rankings.res.entries.length><div ng-show=!loading>Sin registros que mostrar</div><md-progress-linear md-mode=indeterminate ng-show=loading></md-progress-linear></div><div ng-if=rankings.res.entries.length><table class=\"table table-striped table-hover\"><thead><tr><th ng-repeat=\"title in rankings.res.keys\"><span ng-click=rankings.sort(title)>{{ translation[title] || title }}<span style=\"font-size:10px; padding:5px\"><span ng-show=\"rankings.sortReverse &amp;&amp; title == rankings.sortColumn\" class=\"glyphicon glyphicon-chevron-up\"></span><span ng-show=\"!rankings.sortReverse &amp;&amp; title == rankings.sortColumn\" class=\"glyphicon glyphicon-chevron-down\"></span></span></span></th></tr></thead><tbody><tr ng-repeat=\"entries in rankings.res.entries\"><th ng-repeat=\"entrie in entries\">{{ rankings.parseEnt(entrie) }}</th><th style=width:1%><md-button ng-click=rankings.goToAlarms(entries) aria-label=\"GoTo Alarms\" class=md-raised><i class=\"fa fa-eye\"></i></md-button></th></tr></tbody><tfoot><tr><td style=font-size:.8em colspan=\"{{ rankings.res.keys.length }}\" class=text-right>({{ rankings.res.inf }}-{{ rankings.res.sup }} / {{ rankings.res.totalRecords }} records)</td></tr></tfoot></table><div class=pull-right><ul class=pagination><li ng-show=rankings.showLessArrow()><a ng-click=rankings.goToPage(&quot;start&quot;)>«</a></li><li ng-show=rankings.showLessArrow()><a ng-click=rankings.goToPage(&quot;1less&quot;)>&lt;</a></li><li ng-repeat=\"pagina in rankings.pagination.rule\" ng-class=\"{ active: pagina == rankings.res.page }\"><a ng-click=rankings.goToPage(pagina)>{{ pagina }}</a></li><li ng-show=rankings.showMoreArrow()><a ng-click=rankings.goToPage(&quot;1more&quot;)>&gt;</a></li><li ng-show=rankings.showMoreArrow()><a ng-click=rankings.goToPage(&quot;end&quot;)>»<div class=ripple-container></div></a></li></ul></div></div></md-card-content></md-card></div>");
$templateCache.put("app/realtime-rule-editor/realtime-rule-editor.html","<md-card flex layout=column style=\"height: 99%\"><md-toolbar class=md-menu-toolbar><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" ng-click=_onGoBack() class=main-color><md-tooltip md-z-index=9999 md-delay=200>{{ ctrl.translation.get_back }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>device_hub</md-icon></md-toolbar-filler><div class=w100><h2 style=\"padding-bottom: 0; padding-top: 25px\" class=md-toolbar-tools><div class=md-title>{{ ctrl.rule.name }}</div><div flex></div><div ng-show=ctrl.rule.realtime style=\"font-weight: 600; color: #5a2c7e\">{{ ctrl.editor.state | uppercase }}</div></h2><div layout=row><ng-include src=&quot;app/realtime-rule-editor/templates/realtime-rule-editor-menu.html&quot;></ng-include><rule-editor-toolbar flex translation=ctrl.translation editor-state=ctrl.editor.state type-check-state=ctrl.rule.typeCheck execute-rule-fn=ctrl.executeRule() stop-rule-fn=ctrl.stopExecution() type-check-rule-fn=ctrl.typeCheck() save-rule-fn=ctrl.saveRule() show-code=ctrl.editor.showCode dark-mode=ctrl.editor.darkMode has-error=ctrl.editor.hasError on-progress=ctrl.editor.onProgress is-checking=ctrl.editor.isChecking is-changed=ctrl.editor.isChanged is-running=ctrl.editor.isRunning execution-state=false></rule-editor-toolbar></div></div></div></md-toolbar><div id=canvas-wrapper flex class=realtime><div id=transformations-bar ng-show=ctrl.editor.showTransformationsBar><transformations-bar translation=ctrl.translation realtime=ctrl.editor.isRealtime clicked=ctrl.tools.clicked selected-tool=ctrl.tools.selected></transformations-bar></div><rule-editor-canvas editor=ctrl.editor rule=ctrl.rule tools=ctrl.tools dark-mode=ctrl.editor.darkMode ng-show=!ctrl.editor.showCode></rule-editor-canvas><rule-editor-code rule-structure=ctrl.rule.structure ng-show=ctrl.editor.showCode></rule-editor-code><div style=\"position: absolute;right: 0;bottom: 0;z-index: 2;width: 59px;margin: 10px;margin-bottom: 4rem\"><md-button ng-click=ctrl.editor.setZoom(&quot;in&quot;) aria-label=\"Zoom in button\" class=\"md-fab md-mini white zoom-in\"><md-tooltip md-direction=bottom>Zoom in</md-tooltip><i class=\"fa fa-search-plus grey-text\"></i></md-button><md-button ng-click=ctrl.editor.setZoom(&quot;reset&quot;) aria-label=\"Reset in button\" class=\"md-fab md-mini white zoom-in\"><md-tooltip md-direction=bottom>Reset layout</md-tooltip><i class=\"fa fa-crosshairs grey-text\"></i></md-button><md-button ng-click=ctrl.editor.setZoom(&quot;out&quot;) aria-label=\"Zoom out button\" class=\"md-fab md-mini white zoom-out\"><md-tooltip md-direction=bottom>Zoom out</md-tooltip><i class=\"fa fa-search-minus grey-text\"></i></md-button></div></div></md-card>");
$templateCache.put("app/replay/replay.html","<md-card class=m0><md-toolbar class=white><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=main-color><md-icon>restore</md-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white cep_text\"><span>{{ctrl.replay.name}}</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button title={{translation.view_list}} ng-click=ctrl.showCreateReplayDialog(ctrl.replay) class=\"md-icon-button cep_text\"><md-icon class=cep_text>settings</md-icon></md-button><md-button title={{translation.view_list}} ng-click=\"ctrl.shouldShowList = true; ctrl.changeDisplay()\" class=\"md-icon-button cep_text\"><md-icon class=cep_text>view_list</md-icon></md-button><md-button title={{translation.view_grid}} ng-click=\"ctrl.shouldShowList = false; ctrl.changeDisplay()\" class=\"md-icon-button cep_text\"><md-icon class=cep_text>view_module</md-icon></md-button></md-toolbar-filler></div></md-toolbar></md-card><div layout=row layout-wrap=\"\"><div ng-repeat=\"chart in ctrl.replay.settings.charts\" flex=\"{{ctrl.shouldShowList || chart.type==\'TABLE\' ? 100 : 50}}\"><md-card ng-if=\"chart.type == \'LINE\'\" class=\"m0 relative\"><chart-line-echarts replay-id=ctrl.replay.id chart=chart is-dark=ctrl.replay.settings.darkTheme></chart-line-echarts></md-card><md-card ng-if=\"chart.type == \'BAR\'\" class=\"m0 relative\"><chart-bar-echarts replay-id=ctrl.replay.id chart=chart is-dark=ctrl.replay.settings.darkTheme></chart-bar-echarts></md-card><md-card ng-if=\"chart.type== \'TABLE\'\" class=\"m0 relative\"><chart-table chart=chart></chart-table></md-card></div></div>");
$templateCache.put("app/reports/bi-reports.html","<div class=\"bs-component sticky-parent\"><md-card><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-graphic-bi scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>{{ translation.INFORMES }}</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button id=btn-go-to-series abm-component ng-click=toSeries() class=\"pull-right md-fab md-mini blue\"><md-tooltip md-direction=left>Configurar credenciales</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>assignment_ind</md-icon></md-button></md-toolbar-filler></div></md-toolbar><section layout=row layout-padding=\"\" layout-wrap=\"\"><div flex=25><md-input-container class=\"w100 m0\"><h4>{{ translation.TIPO_DE_INFORME }}</h4></md-input-container></div><div flex=25><md-input-container class=\"w100 m0\"><md-select placeholder=\"{{ translation.TIPO_DE_INFORME }}\" ng-model=reportes.tipoReporte ng-model-options=\"{ trackBy: \'$value.id\' }\"><md-option ng-value=tipo ng-repeat=\"tipo in reportes.tipoReportes\" ng-attr-selected=\"{{ tipo.id === &quot;PBI&quot; }}\">{{ tipo.label }}</md-option></md-select></md-input-container></div><div flex=25><md-input-container class=\"w100 m0\"><md-select placeholder=\"{{ translation.GRUPO }}\" md-on-open=reportes.getGroups() ng-model=reportes.grupo ng-model-options=\"{ trackBy: group.workspaceId }\"><md-option ng-value=group ng-repeat=\"group in reportes.pbi.groups\">{{ group.name }}</md-option></md-select></md-input-container></div><div flex=25><md-input-container class=\"w100 m0\"><md-select placeholder=\"{{ translation.REPORTE_GRUPO }}\" md-on-open=reportes.getReports() ng-model=reportes.reporte ng-change=reportes.getReport() ng-model-options=\"{ trackBy: \'$value.id\' }\" ng-disabled=!reportes.grupo><md-option ng-value=report ng-repeat=\"report in reportes.pbi.reports\">{{ report.name }}</md-option></md-select></md-input-container></div></section><section id=report-panel layout=row style=\"border-top: solid 1px #eaeaea\"><div flex=100><uib-tabset active=active style=\"padding: 0\"><uib-tab index=0 heading=\"{{ translation.INFORME }}\" abm-component><div class=\"tab-content box-title\"><div id=reportContainer style=\"width: 100%; height: 60vh\"><div style=\"position: relative; top: 50%; -webkit-transform: translateY(-50%); -o-transform: translateY(-50%); transform: translateY(-50%)\" class=text-center><span style=\"border-radius: 100px; width: 160px; display: inline-block; height: 160px; background: #8c6ca526\"><div class=themeLogo></div></span></div></div></div></uib-tab><uib-tab index=1 heading=Dashboard abm-component ng-show=false><div style=\"padding: 0; margin: 0\" class=\"tab-content box-title\"><div id=dashboardContainer style=\"width: 100%; height: 60vh\"><div style=\"position: relative; top: 50%; -webkit-transform: translateY(-50%); -o-transform: translateY(-50%); transform: translateY(-50%)\" class=text-center><span style=\"border-radius: 100px; width: 160px; display: inline-block; height: 160px; background: #8c6ca526\"><div class=themeLogo></div></span></div></div></div></uib-tab></uib-tabset></div></section></md-card></div>");
$templateCache.put("app/reports/graphic-reports.html","<div class=\"bs-component sticky-parent\"><md-card><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-graphic-reports scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>{{ translation.graphic_reports }}</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button abm-component ng-click=toSeries() class=\"pull-right md-fab md-mini blue\"><md-tooltip md-direction=left>{{ translation.go_to_series }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>linear_scale</md-icon></md-button><md-button abm-component ng-click=ctrl.showCreateReplayDialog(undefined) class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>{{ translation.add_replay }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></md-toolbar-filler></div></md-toolbar><tabs-bar tabs=ctrl.tabsReports is-active=ctrl.isActive set-tab=ctrl.setTab del-tab=ctrl.eliminarTabReport></tabs-bar><section ng-repeat=\"tab in ctrl.tabsReports\" ng-if=\"tab.id!=&quot;index&quot;\" ng-show=\"tab.id!=&quot;index&quot; &amp;&amp; ctrl.isSet(tab.id)\"><replay replay-id=tab.id></replay></section><div id=index-tab ng-show=ctrl.isSet(&quot;index&quot;)><div layout=row layout-align=\"end center\" ng-if=!ctrl.isLoading class=md-toolbar-tools><div><searcher value=ctrl.searchText placeholder=\"{{ translation.find }} {{ translation.rule }}\"></searcher></div></div><md-list><md-list-item ng-repeat=\"report in ctrl.reports | filter:ctrl.searchText\" ng-if=\"!ctrl.isLoading &amp;&amp; !ctrl.isEmpty\" class=\"md-3-line item-report\"><div layout=row layout-align=\"center center\" layout-padding><div><md-icon ng-if=report.active md-font-set=material-icons class=green-text>check_circle</md-icon><md-icon ng-if=!report.active md-font-set=material-icons class=red-text>cancel</md-icon><md-tooltip>{{ translation.status }} {{ report.active }}</md-tooltip></div><h4><small>{{ report.id }}:&nbsp;</small><b>{{ report.name }}</b></h4><h5>{{ translation.total_charts }}:&nbsp;<b>{{ report.settings.totalCharts }}</b></h5><h5>Target:&nbsp;<b>{{ report.settings.target }}</b></h5></div><md-button has-permission=graphic-report#{{report.id}}:read ng-if=report.active ng-click=ctrl.totab(report) style=\"padding: 0.8rem\" aria-label=show-{{report.name}} class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>remove_red_eye</md-icon><md-tooltip>{{ translation.show }}</md-tooltip></md-button><md-button has-permission=graphic-report#{{report.id}}:update ng-click=ctrl.showCreateReplayDialog(report) style=\"padding: 0.8rem\" aria-label=edit-{{report.name}} class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>edit</md-icon><md-tooltip>{{ translation.edit }}</md-tooltip></md-button><md-button has-permission=graphic-report#{{report.id}}:share ng-click=ctrl.showShareEntityDialog(report) style=\"padding: 0.8rem\" aria-label=share-{{report.name}} class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>share</md-icon><md-tooltip>{{ translation.share }}</md-tooltip></md-button><md-button has-permission=graphic-report#{{report.id}}:delete ng-click=ctrl.removeReplay(report) style=\"padding: 0.8rem\" aria-label=delete-{{report.name}} class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>delete</md-icon><md-tooltip>{{ translation.delete }}</md-tooltip></md-button></md-list-item><md-list-item ng-if=ctrl.hasError class=md-3-line><div class=\"w100 text-center\"><h4>Error</h4><code>{{ ctrl.error }}</code></div></md-list-item><md-list-item ng-if=ctrl.isLoading class=md-3-line><div class=\"w100 text-center\"><h4>{{ translation.loading }}</h4><md-progress-linear id=loading-in-progress md-mode=indeterminate></md-progress-linear></div></md-list-item><md-list-item ng-if=\"!ctrl.isLoading &amp;&amp; ctrl.isEmpty\" class=md-3-line><div class=\"w100 text-center\"><h4>{{ translation.no_records_replays }}</h4></div></md-list-item></md-list></div></md-card></div>");
$templateCache.put("app/riskview/riskview.html","<pre>{{ctrl.config}}</pre><risk-view config=ctrl.config></risk-view>");
$templateCache.put("app/rule-editor/rule-editor-menu.html","<md-menu-bar class=rule-editor-menu><md-menu><button id=rule-editor-file-menu ng-click=$mdMenu.open() ng-disabled=loading>{{ translation.file }}</button><md-menu-content width=3><md-menu-item><md-button ng-click=ruleEditor.saveFlowchart() ng-disabled=loading>{{ translation.save }}</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button ng-disabled=\"loading || !ruleEditor.validatePermission(\'update\')\" ng-click=\"ruleCRUD.openEditor($event, ruleEditor.functionData)\">{{ translation.edit_rule_attr }}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"_onGoTo(\'app.rule-executions\')\" ng-disabled=loading>{{ translation.versions }} & {{ translation.executions }}</md-button></md-menu-item><md-menu-item><md-button ng-click=ruleEditor.exportRule() ng-disabled=loading>{{ translation.export_as_json }}</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button ng-click=_onGoBack() ng-disabled=loading>{{ translation.exit }}</md-button></md-menu-item></md-menu-content></md-menu><md-menu><button id=rule-editor-pipeline-menu ng-click=$mdMenu.open()>Pipeline</button><md-menu-content width=3><md-menu-item><md-button ng-click=ruleEditor.showVersions() ng-disabled=\"loading || !ruleEditor.validatePermission(\'read-version\')\">{{ translation.versioning }}</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button ng-click=ruleEditor.createVersion() ng-disabled=\"loading || !ruleEditor.validatePermission(\'create-version\') || ruleEditor.isVersioned\">{{ translation.create_version }}</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button ng-click=ruleEditor.getCurrentVersion() ng-disabled=\"loading || !ruleEditor.isVersioned\">{{ translation.return_current }}</md-button></md-menu-item><md-menu-item><md-button ng-click=ruleEditor.setCurrentVersion() ng-disabled=\"loading || !ruleEditor.isVersioned\">{{ translation.set_current }}</md-button></md-menu-item></md-menu-content></md-menu><md-menu><button id=rule-editor-selection-menu ng-click=$mdMenu.open()>{{ translation.selection }}</button><md-menu-content width=3><md-menu-item><md-button ng-click=ruleEditor.deleteMultiTransformation() ng-disabled=\"loading || !ruleEditor.multiSelection.length\">{{ translation.delete }} {{ translation.selected | lowercase }} ({{ ruleEditor.multiSelection.length }})</md-button></md-menu-item><md-menu-item><md-button ng-click=showProperties() ng-disabled=loading>{{ translation.properties }}</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button ng-click=ruleEditor.copyTransformation() ng-disabled=loading>{{ translation.copy }} {{ translation.transformation }}</md-button></md-menu-item><md-menu-item><md-button ng-click=ruleEditor.pasteTransformation($event) ng-disabled=loading>{{ translation.paste }} {{ translation.transformation }}</md-button></md-menu-item></md-menu-content></md-menu><md-menu><button id=rule-editor-window-menu ng-click=$mdMenu.open()>{{ translation.windows }}</button><md-menu-content width=3><md-menu-item><md-button ng-click=ruleEditor.toggleBoxStats() ng-disabled=loading><div layout=row flex><p flex><b>{{ showBoxStats ? translation.hide : translation.show }}</b>{{ translation.box_stats }}</p></div></md-button></md-menu-item><md-menu-item><md-button ng-click=ruleEditor.toggleTransformationBar() ng-disabled=loading><div layout=row flex><p flex><b>{{ showTransformationBar ? translation.hide : translation.show }}</b>&nbsp; {{ translation.rules_transformation_box }}</p></div></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>");
$templateCache.put("app/rule-editor/rule-editor.html","<rule-crud api=ruleCRUD realtime=ruleEditor.realtime></rule-crud><md-card><md-toolbar class=md-menu-toolbar><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" ng-click=_onGoBack() class=\"layout layout-align-center-center {{ ruleEditor.realtime ? \'second-color\' : \'main-color\' }}\"><md-tooltip md-z-index=9999 md-delay=200>{{ translation.get_back }}</md-tooltip><cep-icon icon=\"{{ ruleEditor.realtime ? \'cep-rule-realtime\' : \'cep-rule\' }}\" scale=2 color=white></cep-icon></md-toolbar-filler><div class=w100><h2 style=\"padding-bottom: 0; padding-top: 25px\" class=md-toolbar-tools><div layout=column><div class=md-title>{{ translation.rule_editor }} - {{ ruleEditor.functionData.name }}</div></div><div flex></div><strong ng-if=ruleEditor.realtime class=\"badge grey lighten-3 text-second-color animated infinite pulse\">REALTIME</strong></h2><div layout=row><ng-include src=&quot;app/rule-editor/rule-editor-menu.html&quot;></ng-include><rules-toolbar flex translation=translation has-error=ruleEditor.hasError on-progress=ruleEditor.onProgress is-checking=ruleEditor.isChecking is-changed=ruleEditor.isChanged is-running=ruleEditor.isRunning is-dark-mode=isDarkMode execution-state=ruleEditor.execution.state realtime=ruleEditor.realtime loading=loading></rules-toolbar></div></div></div></md-toolbar><section layout=row><div flex=100><section layout=row layout-wrap=\"\"><md-progress-linear ng-if=\"ruleEditor.realtime &amp;&amp; ruleEditor.isRunning\" md-mode=indeterminate class=md-secondary></md-progress-linear><md-progress-linear ng-if=\"!ruleEditor.realtime &amp;&amp; ruleEditor.onProgress\" md-mode=buffer value=\"{{ ruleEditor.execution.progress }}\" md-buffer-value=\"{{ ruleEditor.execution.progress + 10 }}\" class=md-primary></md-progress-linear></section><div id=canvas-wrapper><md-card id=transformations-bar ng-show=showTransformationBar><transformations-bar translation=translation realtime=ruleEditor.realtime clicked=clicked selected-tool=ruleEditor.selectedTool></transformations-bar></md-card><div style=\"position: absolute;right: 0;top: 0;z-index: 2;width: 59px;margin: 5px;margin-top: 1rem\"><rule-services></rule-services></div><div style=\"position: absolute;right: 0;bottom: 0;z-index: 2;width: 59px;margin: 5px;margin-bottom: 4rem\"><md-button ng-click=ruleEditor.zoom(&quot;in&quot;) class=\"md-fab md-mini white zoom-in\"><md-tooltip md-direction=bottom>Zoom in</md-tooltip><i class=\"fa fa-search-plus grey-text\"></i></md-button><md-button ng-click=ruleEditor.zoom(&quot;reset&quot;) class=\"md-fab md-mini white zoom-in\"><md-tooltip md-direction=bottom>Reset layout</md-tooltip><i class=\"fa fa-crosshairs grey-text\"></i></md-button><md-button ng-click=ruleEditor.zoom(&quot;out&quot;) class=\"md-fab md-mini white zoom-out\"><md-tooltip md-direction=bottom>Zoom out</md-tooltip><i class=\"fa fa-search-minus grey-text\"></i></md-button></div><rule-schema-bar translation=translation conn-name=ruleEditor.activeConn conn-output-schema=ruleEditor.selectedOutputSchema api=schemaBar></rule-schema-bar><rule-props-bar translation=translation transform-props=ruleEditor.selectedTransform is-changed=ruleEditor.isChanged api=propsBar></rule-props-bar><panzoom id=zoomCanvas realtime={{ruleEditor.realtime}} config=pz_config model=pz_model style=\"height: 78vh; overflow:hidden\" ng-show=!showCode darken-mode=\"{{ isDarkMode }}\" class=w100><section id=canvas class=\"jtk-demo-canvas canvas-wide drag-drop-demo jtk-surface\"></section></panzoom><md-card ng-show=showCode class=m0><div id=acePanel style=\"height: 76vh\" ng-model=jsonOutput ui-ace=\"{ useWrapMode : true, showGutter: true, theme:&quot;twilight&quot;, mode: &quot;json&quot;, rendererOptions: { minLines: 3 } }\"></div></md-card><div class=terminal-wrapper><rule-terminal translation=translation api=ruleEditor.terminal console-log=ruleEditor._consoleLog context=ruleEditor.functionData.context selected-transform=ruleEditor.selectedTransform selected-context=ruleEditor.selectedContext overall-bench=ruleEditor.overallBench overall-bench-labels=ruleEditor.overallBenchLabels execution-output=ruleEditor.executionOutput></rule-terminal></div></div></div></section></md-card>");
$templateCache.put("app/rules/rules.html","<div class=bs-component><rule-crud api=rules.ruleCRUD on-update=rules.onUpdate(rule) realtime=rules.realtime></rule-crud><md-card><md-content style=\"min-height: 80vh\" class=sticky-parent><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon ng-hide=rules.realtime icon=cep-menu-rules-list scale=2></cep-icon><cep-icon ng-show=rules.realtime icon=cep-menu-realtime-rules scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=md-toolbar-tools><span ng-hide=rules.realtime>{{ translation.rules | uppercase }}</span><span ng-show=rules.realtime>{{ translation.realtime_rules | uppercase }}</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button has-permission=function:create ng-click=\"rules.ruleCRUD.openEditor($event, false)\" aria-label=\"Add function button\" class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>CREAR</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button><div ng-if=rules.realtime><rule-services></rule-services></div></md-toolbar-filler></div></md-toolbar><div layout=row layout-align=\"end center\" class=md-toolbar-tools><div><searcher value=rules.searchText placeholder=\"{{ translation.find }} {{ translation.rule }}\"></searcher></div><div flex=1 ng-if=!rules.displayItems><md-button ng-click=rules.expandAll() aria-label=\"Unfold all button\" class=\"md-raised p0 w_auto md-mini grey lighten-4\"><md-tooltip>Expand all</md-tooltip><md-icon md-font-set=material-icons class=grey-text>unfold_more</md-icon></md-button></div><div flex=1 ng-if=rules.displayItems><md-button ng-click=rules.collapseAll() aria-label=\"Fold all button\" class=\"md-raised p0 w_auto md-mini grey lighten-4\"><md-tooltip>Collapse all</md-tooltip><md-icon md-font-set=material-icons class=grey-text>unfold_less</md-icon></md-button></div><div flex=1 ng-if=\"rules.sort==&quot;desc&quot;\"><md-button ng-click=rules.toggleSort() aria-label=\"sort asc\" class=\"md-raised p0 w_auto md-mini grey lighten-4 grey-text\"><md-tooltip>sort asc</md-tooltip><div class=\"fa fa-sort-alpha-desc\"></div></md-button></div><div flex=1 ng-if=\"rules.sort==&quot;asc&quot;\"><md-button ng-click=rules.toggleSort() aria-label=\"sort desc\" class=\"md-raised p0 w_auto md-mini grey lighten-4 grey-text\"><md-tooltip>sort desc</md-tooltip><div class=\"fa fa-sort-alpha-asc\"></div></md-button></div></div><div id=list-rules-loading ng-if=rules.isLoading><md-progress-linea md-mode=indeterminate></md-progress-linea></div><div id=list-rules ng-if=!rules.isLoading><ng-include src=&quot;app/rules/templates/tree-view.html&quot;></ng-include></div></md-content></md-card></div>");
$templateCache.put("app/schemas/schemas.html","<div class=\"bs-component sticky-parent\"><md-card><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-data-schemas scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>{{ translation.data_schemas }}</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button id=btn-create-schema has-permission=schema:create ng-click=\"showCreateSchemaDialog($event, false, false)\" aria-label=\"Create schema button\" class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>{{ translation.add_schema }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button><md-button id=btn-create-schema has-permission=schema:create ng-click=\"schemas.openBulkSchemasImportDialog($event, false, false)\" aria-label=\"Bulk add schemas button\" class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>{{ translation.add_schema }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>file_upload</md-icon></md-button></md-toolbar-filler></div></md-toolbar><md-toolbar style=\"background-color: #fafafa; color: black\"><div layout=row layout-align=\"end center\" class=md-toolbar-tools><div><searcher value=schemas.searchText placeholder=\"{{ translation.find }} {{ translation.schemas }}\"></searcher></div><div flex=1 ng-if=!schemas.displayItems><md-button ng-click=schemas.expandAll() aria-label=\"Unfold all button\" class=\"md-raised p0 w_auto md-mini grey lighten-4\"><md-tooltip>Expand all</md-tooltip><md-icon md-font-set=material-icons class=grey-text>unfold_more</md-icon></md-button></div><div flex=1 ng-if=schemas.displayItems><md-button ng-click=schemas.collapseAll() aria-label=\"Fold all button\" class=\"md-raised p0 w_auto md-mini grey lighten-4\"><md-tooltip>Collapse all</md-tooltip><md-icon md-font-set=material-icons class=grey-text>unfold_less</md-icon></md-button></div><div flex=1 ng-if=\"schemas.sort==&quot;desc&quot;\"><md-button ng-click=schemas.toggleSort() aria-label=\"sort asc\" class=\"md-raised p0 w_auto md-mini grey lighten-4 grey-text\"><md-tooltip>sort asc</md-tooltip><div class=\"fa fa-sort-alpha-desc\"></div></md-button></div><div flex=1 ng-if=\"schemas.sort==&quot;asc&quot;\"><md-button ng-click=schemas.toggleSort() aria-label=\"sort desc\" class=\"md-raised p0 w_auto md-mini grey lighten-4 grey-text\"><md-tooltip>sort desc</md-tooltip><div class=\"fa fa-sort-alpha-asc\"></div></md-button></div><div flex=1 style=\"display: inline-flex\"><md-button id=btnInputListonGoBack has-permission=list:read ng-click=main.clickMenu(&quot;app.schemasLists&quot;) href=entries/lists class=\"md-raised md-primary\">View Lists</md-button></div></div></md-toolbar><ng-include src=&quot;app/schemas/templates/schemas-tree-view.html&quot;></ng-include></md-card></div>");
$templateCache.put("app/security/security.html","<div><md-card><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-security scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>{{ translation.SEGURIDAD }}</span></h2></div></md-toolbar><md-content><user-2fa></user-2fa></md-content><md-content><strong style=\"padding: 0 0 0 2rem; font-size: 1.7rem\">{{ translation.CAMBIAR_CONTRASENA }}</strong><div flex-xs layout=row ng-cloak layout-margin><div flex=50><md-input-container flex-sm=\"\" class=md-block><label>{{ translation.CONTRASENA_ANTIGUA }}</label><input ng-model=riskUserPassword.passwordAntigua type=password></md-input-container><md-input-container flex-sm=\"\" class=md-block><label>{{ translation.CONTRASENA_NUEVA }}</label><input ng-model=riskUserPassword.passwordNueva type=password></md-input-container><md-input-container flex-sm=\"\" class=md-block><label>{{ translation.CONFIRMAR_CONTRASENA }}</label><input ng-model=riskUserPassword.passwordConfirmar type=password></md-input-container></div><div ng-if=passwordPolicy.showPasswordPolicy flex=50 style=\"padding-left: 10px\"><span>{{ translation.password_rules }}</span><p ng-if=\"passwordPolicy.minimumPasswordLength &amp;&amp; passwordPolicy.minimumPasswordLength &gt; 0\" ng-class=\"passwordPolicy.minimumPasswordLengthGreen ? &quot;green-text&quot;:&quot;red-text&quot;\"><md-icon ng-class=\"passwordPolicy.minimumPasswordLengthGreen ? &quot;green-text&quot;:&quot;red-text&quot;\">{{ passwordPolicy.minimumPasswordLengthGreen ? \'check_circle\' : \'cancel\' }}</md-icon>{{ translation.password_length_1 }} {{ passwordPolicy.minimumPasswordLength }} {{ translation.password_length_2 }}</p><p ng-if=passwordPolicy.withAtLeastOneUppercase ng-class=\"passwordPolicy.withAtLeastOneUppercaseGreen ? &quot;green-text&quot;:&quot;red-text&quot;\"><md-icon ng-class=\"passwordPolicy.withAtLeastOneUppercaseGreen ? &quot;green-text&quot;:&quot;red-text&quot;\">{{ passwordPolicy.withAtLeastOneUppercaseGreen ? \'check_circle\' : \'cancel\' }}</md-icon>{{ translation.at_least_one_uppercase_character }}</p><p ng-if=passwordPolicy.withAtLeastOneLowercase ng-class=\"passwordPolicy.withAtLeastOneLowercaseGreen ? &quot;green-text&quot;:&quot;red-text&quot;\"><md-icon ng-class=\"passwordPolicy.withAtLeastOneLowercaseGreen ? &quot;green-text&quot;:&quot;red-text&quot;\">{{ passwordPolicy.withAtLeastOneLowercaseGreen ? \'check_circle\' : \'cancel\' }}</md-icon>{{ translation.at_least_one_lowercase_character }}</p><p ng-if=passwordPolicy.withAtLeastOneDigit ng-class=\"passwordPolicy.withAtLeastOneDigitGreen ? &quot;green-text&quot;:&quot;red-text&quot;\"><md-icon ng-class=\"passwordPolicy.withAtLeastOneDigitGreen ? &quot;green-text&quot;:&quot;red-text&quot;\">{{ passwordPolicy.withAtLeastOneDigitGreen ? \'check_circle\' : \'cancel\' }}</md-icon>{{ translation.at_least_one_digit }}</p><p ng-if=passwordPolicy.withAtLeastOneSymbol ng-class=\"passwordPolicy.withAtLeastOneSymbolGreen ? &quot;green-text&quot;:&quot;red-text&quot;\"><md-icon ng-class=\"passwordPolicy.withAtLeastOneSymbolGreen ? &quot;green-text&quot;:&quot;red-text&quot;\">{{ passwordPolicy.withAtLeastOneSymbolGreen ? \'check_circle\' : \'cancel\' }}</md-icon>{{ translation.at_least_one_special_character }}</p></div></div><div layout=row layout-margin layout-align=\"start center\"><div flex=3><md-button type=button ng-click=cambiarPassword() class=\"w100 md-raised\">{{ translation.ENVIAR }}</md-button></div><div flex ng-show=validacion.show><div class=\"red text-center\"><strong>{{ validacion.content }}</strong></div></div></div></md-content></md-card></div>");
$templateCache.put("app/searcher/dialog-searcher.html","<md-dialog aria-label=Searcher style=width:1000px><md-toolbar class=\"white-text main-color\"><div style=\"background-color: white;padding: 0px 20px\" class=md-toolbar-tools><span><i style=\"color: lightgrey;font-size: 1em\" class=\"fa fa-search\"></i></span> <input type=search ng-model=ctrl.value style=\"border: none;outline:none;color:black\" maxlength=80 placeholder={{translation.PLACEHOLDER}} class=w100><span flex ng-if=\"ctrl.targetType == \'LIST\'\"><input type=text ng-model=ctrl.targetName style=\"border: none;outline:none;color:black\" maxlength=80 placeholder=\"Target Name\" class=w50></span><span flex></span><md-menu><md-button aria-label=More ng-click=$mdMenu.open() style=width:100px;color:black><md-tooltip md-direction=left>I\'m looking for...</md-tooltip>{{ctrl.targetType}}</md-button><md-menu-content width=2 ng-mouseleave=$mdMenu.close()><md-menu-item ng-repeat=\"item in ctrl.targets\"><md-button ng-click=ctrl.onChangeSource(item)>{{item}}</md-button></md-menu-item></md-menu-content></md-menu><md-button ng-click=ctrl.onSearch() class=\"md-raised green white-text\">{{translation.SEARCH_BUTTON}}</md-button><md-button ng-click=ctrl.onClear() class=\"md-raised gray black-text\">{{translation.RESET_BUTTON}}</md-button></div></md-toolbar><md-dialog-content layout=column layout-padding style=\"padding-top:10px;min-height:300px;max-height:700px;border-top: 1px solid #eeeeee\"><div ng-if=!ctrl.searchResult><h3>Query syntax examples</h3><br><table><tr><th style=width:30%>Query expression</th><th style=width:70%>Document matches if...</th></tr><tr><th>java</th><th>Contains the term java in the default (content) field</th></tr><tr><th><strong>java junit</strong><br><strong>java OR junit</strong></th><th>Contains the term java or junit or both in the default field (the default operator can be changed to AND)</th></tr><tr><th><strong>+java +junit</strong><br><strong>java AND junit</strong></th><th>Contains both java and junit in the default field</th></tr><tr><th><strong>filedName:ant</strong></th><th>Contains the term ant in the field</th></tr><tr><th><strong>title:extreme –subject:sports</strong></th><th>Contains extreme in the title and not sports in subject</th></tr><tr><th><strong>(agile OR extreme) AND java</strong></th><th>Boolean expression matches</th></tr><tr><th><strong>title:”junit in action”</strong></th><th>Phrase matches in title</th></tr><tr><th><strong>title:”junit action”~5</strong></th><th>Proximity matches (within 5) in title</th></tr><tr><th><strong>java*</strong></th><th>Wildcard matches</th></tr><tr><th><strong>java~</strong></th><th>Fuzzy matches</th></tr></table></div><div ng-show=ctrl.loading layout=row layout-align=space-around><md-progress-circular ng-disabled=!ctrl.loading md-diameter=50 class=md-accent></md-progress-circular></div><div ng-show=\"ctrl.searchResult.length == 0 &amp;&amp; !ctrl.loading\" layout=row layout-align=\"center center\"><h3>{{translation.MSG_ERROR}}</h3></div><div ng-if=\"ctrl.searchResult.length &gt; 0\" ng-cloak><md-content style=height:550px class=md-padding><md-list><md-list-item ng-repeat=\"data in ctrl.searchResult\" ng-click=\"ctrl.showDetail(data, $event)\"><div ng-if=\"data.target == \'LIST\'\" layout=row class=md-list-item-text><div><cep-icon icon={{data.icon}}>GeneralData</cep-icon></div><div><p style=\"margin:0 0 2px; 0\">{{data.title}}<span class=cep-badge>{{data.total}}</span></p></div></div><div ng-if=\"data.target != \'LIST\'\" layout=row class=md-list-item-text><div><cep-icon icon={{data.icon}}>GeneralData</cep-icon></div><div><h4 style=\"margin:2px 0 0 0\">{{ data.title }}</h4><p style=\"margin:0 0 2px; 0\">{{data.subtitle}}</p></div></div><md-divider ng-if=!$last></md-divider></md-list-item></md-list></md-content></div></md-dialog-content></md-dialog>");
$templateCache.put("app/searcher/search-detail.tmpl.html","<md-dialog style=\"width: 600px\" ng-cloak><md-toolbar class=\"white-text main-color\"><div class=md-toolbar-tools><h2>{{translation.DETAIL_TITLE}}: {{ctrl.itemSelected.inputId}}</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons>clear</md-icon></md-button></div></md-toolbar><md-dialog-content ng-cloak><div layout=column class=md-dialog-content><md-input-container flex=100 ng-repeat=\"(key, value) in ctrl.inputData\" style=\"margin-top: 5px\" class=no-padding-no-margin><label>{{key}}</label><input ng-value=value disabled></md-input-container></div></md-dialog-content><md-dialog-actions class=md-dialog-content><md-button ng-click=ctrl.cancel() class=md-raised>{{translation.CLOSE_BUTTON}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/searcher/searcherXXX.html","<div class=bs-component><md-card><md-toolbar class=\"white-text main-color\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=main-color><md-icon>search</md-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>{{translation.LOOKUP_TITLE}}</span></h2></div></md-toolbar><section layout=row layout-padding=\"\"><div flex=50><label>SELECT SEARCHER</label><md-input-container class=\"w100 m0\"><select name=field_searcher ng-model=ctrl.selectedSearcher ng-change=ctrl.onLoad() ng-options=\"(item.name + \' - BY \' + item.type) for item in ctrl.searchers track by item.id\" class=\"w100 m0\"><option disabled selected value=\"\">{{translation.SELECT_SEARCHER}}</option></select></md-input-container></div></section><section ng-if=ctrl.selectedSearcher style=\"border-top:solid #eaeaea;padding-top:20px\"><article layout=row layout-padding=\"\"><div flex=25 ng-repeat=\"field in ctrl.searchFields\"><md-input-container class=\"w100 m0\"><label>{{field}}</label><input type=text ng-model=ctrl.filters[field] md-maxlength=50></md-input-container></div></article><article layout=row layout-padding=\"\"><div flex=25><label>{{translation.SIZE}}</label><md-input-container class=\"w100 m0\"><md-slider min=0 max=100 ng-model=ctrl.size aria-label=blue id=blue-slider class=md-warn></md-slider></md-input-container></div><div flex=10><label>.</label><md-input-container class=\"w100 m0\"><input type=number ng-model=ctrl.size aria-label=blue aria-controls=blue-slider></md-input-container></div></article><article layout=row layout-padding=\"\" layout-align=end><div flex=50 class=text-right><md-button ng-click=ctrl.onReset() class=md-raised>{{translation.RESET_BUTTON}}</md-button><md-button ng-click=ctrl.onSearch() class=\"md-raised md-primary\">{{translation.SEARCH_BUTTON}}</md-button></div></article></section><section ng-if=ctrl.selectedSearcher layout=row layout-padding=\"\" style=\"border-top:solid #eaeaea\"><div flex=100><label>{{translation.RESULT_TITLE_1}} {{ctrl.searchTotal}} {{translation.RESULT_TITLE_2}}</label><table class=\"table table-striped table-hover\"><thead><tr><th>{{translation.DISPLAY}}</th><th>{{(ctrl.selectedSearcher.type == \'LIST\') ? \'LIST NAME\' : \'RULE\'}}</th><th>{{translation.INPUT_DATA_ID}}</th></tr></thead><tbody><tr ng-repeat=\"item in ctrl.searchResult\" ng-click=ctrl.showDetail(item)><td>{{item.displayField}}</td><td>{{item.name}}</td><td>{{item.inputId}}</td></tr></tbody></table></div></section></md-card></div>");
$templateCache.put("app/tokens-manager/tokens-manager.html","<div><md-card><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-tokens scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>Users Tokens Manager</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button abm-component ng-click=ctrl.cancelEdition() aria-label=editActive class=\"pull-right md-fab md-mini blue\"><md-icon class=white-text>keyboard_return</md-icon><md-tooltip>return</md-tooltip></md-button></md-toolbar-filler></div></md-toolbar><md-content><div layout=row layout-align=\"end center\"><md-button ng-click=ctrl.init() aria-label=refresh ng-disabled=ctrl.loading class=\"second-color white-text\"><md-icon class=white-text>refresh</md-icon>Refresh</md-button><md-button ng-if=\"ctrl.selections.length &gt; 0\" ng-click=ctrl.invalidateSelections() aria-label=invalidateSelections ng-disabled=ctrl.loading class=amber><md-icon class=white-text>person</md-icon>invalidate selections ({{ctrl.selections.length}})</md-button><md-button ng-click=ctrl.invelidateAll() aria-label=invelidateAll ng-disabled=ctrl.loading class=\"red white-text\"><md-icon class=white-text>delete</md-icon>invalidate all</md-button></div><md-progress-linear md-mode=indeterminate ng-if=ctrl.loading></md-progress-linear><div id=tokens-list ui-grid-selection ui-grid-resize-columns ui-grid-auto-resize ui-grid=ctrl.gridOptions style=\"height: 80vh\"></div></md-content></md-card></div>");
$templateCache.put("app/user-tracking/user-tracking.html","<div class=\"bs-component animated fadeInLeft\"><ul class=\"nav nav-tabs\"><li ng-repeat=\"tab in tabs\" ng-class=\"{ activeTab: userTracking.isActive(tab.id) }\"><a href=javascript:; data-toggle=tab ng-click=userTracking.setTab(tab.id) abm-component class=btn-raised><span class=title>{{tab.name}}</span><span ng-show=\"tab.id!=\'index\'\" ng-click=userTracking.eliminarTabAuditoria(tab.id) class=close-tab><i class=icon-close></i></span></a></li></ul><div class=tab-content><!-- -- Grid de listado de alertas--><div ng-show=\"userTracking.isSet(\'index\')\" class=\"tab-pane fade active in tab-pane-filters\"><div class=row><div class=col-md-12><div style=overflow:hidden class=\"panel panel-info\"><risk-grid-legacy id=userTracking table-css=\"table table-striped table-hover table-striped table-colors\" config=userTracking.configUserTracking api=userTracking.api fn-dbl-click=userTracking.crearTabDetalleUserTracking fn-refresh=userTracking.updateTable></risk-grid-legacy><div class=clearfix></div></div></div></div></div><!-- -- Sección de detalle--><div ng-repeat=\"tab in tabs\" ng-if=\"tab.id!=\'index\'\" ng-show=\"tab.id!=\'index\' &amp;&amp; userTracking.isSet(tab.id)\" class=\"tab-pane fade active in\"><div class=row><div class=col-md-12><div class=\"well panel panel-info panel-chart\"><div class=panel-body><h3>{{tab.id}}</h3><div class=ficha-info><div class=row-block><div label class=col-block>{{translation.USUARIO}}:</div><div data class=col-block>{{tab.userTracking.author}}</div></div><div style=margin-top:10px class=row-block><div label class=col-block>{{translation.FECHA}}:</div><div data class=col-block>{{tab.userTracking.created}}</div></div><div style=margin-top:10px class=row-block><div label class=col-block>{{translation.TIPO}}:</div><div data class=col-block>{{tab.userTracking.action}}</div></div><div style=margin-top:10px class=row-block><div label class=col-block>{{translation.MENSAJE}}:</div><div data class=col-block>{{tab.userTracking.logMessage}}</div></div><div style=margin-top:10px class=row-block><div label class=col-block>Url:</div><div data class=col-block>{{tab.userTracking.originUrl}}</div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/usuarios/cambiarPassword.html","<div tabindex=-1 role=dialog class=modal><md-progress-linear md-mode=indeterminate ng-show=loading class=\"md-accent md-hue-2\"></md-progress-linear><div ng-class=\"{ &quot;modal-md&quot;: passwordPolicy.showPasswordPolicy==true, &quot;modal-sm&quot;: passwordPolicy.showPasswordPolicy==false }\" class=\"modal-dialog modal-reset\"><div class=modal-content><md-toolbar><div class=\"md-toolbar-tools nav-tabs\"><h2 class=modal-title>{{ translation.CAMBIAR_CONTRASENA }}</h2></div></md-toolbar><div class=modal-body><div flex-xs layout=row ng-cloak><div flex=\"{ &quot;50&quot;: passwordPolicy.showPasswordPolicy==true, &quot;100&quot;: passwordPolicy.showPasswordPolicy==false }\"><md-input-container flex-sm=\"\" class=md-block><label>{{ translation.CONTRASENA_ANTIGUA }}</label><input ng-model=riskUserPassword.passwordAntigua type=password></md-input-container><md-input-container flex-sm=\"\" class=md-block><label>{{ translation.CONTRASENA_NUEVA }}</label><input ng-model=riskUserPassword.passwordNueva type=password></md-input-container><md-input-container flex-sm=\"\" class=md-block><label>{{ translation.CONFIRMAR_CONTRASENA }}</label><input ng-model=riskUserPassword.passwordConfirmar type=password></md-input-container><div ng-show=validacion.show class=row><div class=col-md-12><h5>{{ validacion.content }}</h5></div></div></div><div ng-if=passwordPolicy.showPasswordPolicy flex=50 style=\"padding-left: 10px\"><span>{{ translation.password_rules }}</span><p ng-if=\"passwordPolicy.minimumPasswordLength &amp;&amp; passwordPolicy.minimumPasswordLength &gt; 0\" ng-class=\"passwordPolicy.minimumPasswordLengthGreen ? &quot;green-text&quot;:&quot;red-text&quot;\"><md-icon ng-class=\"passwordPolicy.minimumPasswordLengthGreen ? &quot;green-text&quot;:&quot;red-text&quot;\">{{ passwordPolicy.minimumPasswordLengthGreen ? \'check_circle\' : \'cancel\' }}</md-icon>{{ translation.password_length_1 }} {{ passwordPolicy.minimumPasswordLength }} {{ translation.password_length_2 }}</p><p ng-if=passwordPolicy.withAtLeastOneUppercase ng-class=\"passwordPolicy.withAtLeastOneUppercaseGreen ? &quot;green-text&quot;:&quot;red-text&quot;\"><md-icon ng-class=\"passwordPolicy.withAtLeastOneUppercaseGreen ? &quot;green-text&quot;:&quot;red-text&quot;\">{{ passwordPolicy.withAtLeastOneUppercaseGreen ? \'check_circle\' : \'cancel\' }}</md-icon>{{ translation.at_least_one_uppercase_character }}</p><p ng-if=passwordPolicy.withAtLeastOneLowercase ng-class=\"passwordPolicy.withAtLeastOneLowercaseGreen ? &quot;green-text&quot;:&quot;red-text&quot;\"><md-icon ng-class=\"passwordPolicy.withAtLeastOneLowercaseGreen ? &quot;green-text&quot;:&quot;red-text&quot;\">{{ passwordPolicy.withAtLeastOneLowercaseGreen ? \'check_circle\' : \'cancel\' }}</md-icon>{{ translation.at_least_one_lowercase_character }}</p><p ng-if=passwordPolicy.withAtLeastOneDigit ng-class=\"passwordPolicy.withAtLeastOneDigitGreen ? &quot;green-text&quot;:&quot;red-text&quot;\"><md-icon ng-class=\"passwordPolicy.withAtLeastOneDigitGreen ? &quot;green-text&quot;:&quot;red-text&quot;\">{{ passwordPolicy.withAtLeastOneDigitGreen ? \'check_circle\' : \'cancel\' }}</md-icon>{{ translation.at_least_one_digit }}</p><p ng-if=passwordPolicy.withAtLeastOneSymbol ng-class=\"passwordPolicy.withAtLeastOneSymbolGreen ? &quot;green-text&quot;:&quot;red-text&quot;\"><md-icon ng-class=\"passwordPolicy.withAtLeastOneSymbolGreen ? &quot;green-text&quot;:&quot;red-text&quot;\">{{ passwordPolicy.withAtLeastOneSymbolGreen ? \'check_circle\' : \'cancel\' }}</md-icon>{{ translation.at_least_one_special_character }}</p></div></div><user-2fa></user-2fa></div><div class=modal-footer><button type=button ng-click=cambiarPassword() class=\"btn-rosado btn btn-default btn-group-sm\">{{ translation.ENVIAR }}</button> <button type=button ng-click=closeModalPassword() class=\"btn-rosado btn btn-default btn-group-sm\">{{ translation.CANCELAR }}</button></div></div></div></div>");
$templateCache.put("app/usuarios/confirmarEliminarUsuario.html","<div tabindex=-1 role=dialog class=modal><div class=modal-dialog><div class=modal-content><div class=modal-header><a type=button abm-component=abm-component ng-click=$hide() class=close>×</a><h4 class=modal-title>{{translation.PREGUNTA_ELIMINAR}}</h4><div class=modal-body><div ng-if=validacion.show class=row><div class=col-xs-12><div class=\"panel panel-primary\"><div class=panel-heading><h3 class=panel-title><i class=icon-notifications></i>{{validacion.content}}<br>{{mensajeEliminarUsuario}}</h3></div></div></div></div></div></div><div class=modal-footer><button type=button ng-click=cerrarModalEliminarUsuario() class=\"btn btn-default\">{{translation.NO}}</button> <button type=button ng-click=deleteUser() class=\"btn btn-primary\">{{translation.SI}}</button></div></div></div></div>");
$templateCache.put("app/usuarios/dialog-recover-session.html","<md-dialog aria-label=\"Recover session dialog\"><form name=recoverySessionForm ng-submit=\"recoverySessionForm.$valid &amp;&amp; recover.login()\" novalidate><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ recover.txt.session_expired }}</h2><span flex></span><md-button ng-click=recover.cancel() aria-label=\"Close dialog button\" class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class=md-padding><div layout=row><span>{{ recover.txt.session_expired_msg }}</span></div><br><div layout=column><md-input-container style=\"margin: 0\"><label>User</label><input type=text aria-label=\"User field\" required value=\"{{ recover.user }}\" readonly></md-input-container><md-input-container style=\"margin: 0\"><label>Pass</label><input ng-model=recover.pass name=pass type=password autocomplete=current-password aria-label=\"Password field\" placeholder=\"\" required><div ng-messages=recoverySessionForm.pass.$error><div ng-message=required>{{ translation.field_required }}</div></div></md-input-container></div><div class=pull-right><a ng-click=recover.cancel() abm-component=abm-component>Not {{ recover.user }}?</a></div></md-content></md-dialog-content><md-dialog-actions><md-progress-linear ng-show=recover.loading></md-progress-linear><md-button ng-show=!recover.loading md-colors=green ng-click=recover.cancel() aria-label=\"Cancel button\">{{ recover.txt.cancel }}</md-button><md-button ng-show=!recover.loading md-colors=green type=submit aria-label=\"Enter button\">{{ recover.txt.enter }}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/usuarios/listadoUsuarios.html","<div tabindex=-1 role=dialog class=modal><div class=modal-dialog><div class=modal-content><div class=modal-header><a type=button abm-component=abm-component ng-click=$hide() class=close>×</a><h4 class=\"modal-title text-title\">{{ translation.BUSCAR }}<div class=\"dashboard-badge-indicador dashboard-badge title-badge\"><div class=dashboard-bagde></div></div></h4></div><div class=modal-body><div class=\"row system-title\"><div class=col-md-8><label>{{ translation.USERNAME }}</label><div class=input-icon><input type=text placeholder=\"Buscar ...\" ng-model=filtrarUsuario class=form-control><div class=box-icon><i class=\"fa fa-search search-icon\"></i></div></div></div></div><div class=\"row text-center system-title\"><div class=\"col-md-3 col-sm-3 col-xs-3\">{{ translation.USERNAME2 }}</div><div class=\"col-md-3 col-sm-3 col-xs-3\">{{ translation.NOMBRE2 }}</div><div class=\"col-md-3 col-sm-3 col-xs-3\">{{ translation.APELLIDO2 }}</div><div class=\"col-md-3 col-sm-3 col-xs-3\">{{ translation.ROL2 }}</div></div><div ng-repeat=\"usuarioRol in filterUsers = (listadoUsuariosRoles | filterByUsername: filtrarUsuario)\" class=\"row row-system-options text-center\"><div class=\"col-md-3 col-sm-3 col-xs-3\"><div class=option-box>{{ usuarioRol.riskUser.username }}</div></div><div class=\"col-md-3 col-sm-3 col-xs-3\"><div class=option-box>{{ usuarioRol.riskUser.userName }}</div></div><div class=\"col-md-3 col-sm-3 col-xs-3\"><div class=option-box>{{ usuarioRol.riskUser.userLastname }}</div></div><div class=\"col-md-3 col-sm-3 col-xs-3\"><div class=option-box>{{ usuarioRol.riskRole.roleDescription }}</div></div></div></div><div class=modal-footer><button type=button ng-click=busquedaPorFiltro() class=\"btn-rosado btn btn-default btn-group-sm\">{{ translation.ACEPTAR }}</button> <button type=button ng-click=closeModalListadoUsuarios() class=\"btn-rosado btn btn-default btn-group-sm\">{{ translation.CANCELAR }}</button></div></div></div></div>");
$templateCache.put("app/usuarios/users.html","<div><md-card><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-users scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>{{ ctrl.translation.USUARIOS }}</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button abm-component ng-if=ctrl.editActive ng-click=ctrl.cancelEdition() aria-label=editActive class=\"pull-right md-fab md-mini blue\"><md-icon class=white-text>keyboard_return</md-icon><md-tooltip>{{ ctrl.translation.get_back }}</md-tooltip></md-button><md-button has-permission=user:create abm-component ng-if=!ctrl.editActive ng-click=ctrl.newUser() aria-label=newUser class=\"pull-right md-fab md-mini blue\"><md-tooltip md-direction=left>{{ ctrl.translation.CREAR }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target class=white-text>add</md-icon></md-button><md-button has-permission=user:create abm-component ng-if=!ctrl.editActive ng-click=ctrl.export() aria-label=export class=\"pull-right md-fab md-mini green\"><md-tooltip md-direction=left>Export csv</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target class=white-text>file_download</md-icon></md-button><input id=file type=file name=file nv-file-select uploader=ctrl.uploader input-file file-types=.csv,application/vnd.ms-excel filters=Extensions,Size style=\"display: none\"><md-button has-permission=user:create abm-component ng-if=!ctrl.editActive onclick=document.getElementById(&quot;file&quot;).click() aria-label=export class=\"pull-right md-fab md-mini blue\"><md-tooltip md-direction=left>Import csv</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target class=white-text>file_upload</md-icon></md-button></md-toolbar-filler></div></md-toolbar><md-content ng-show=!ctrl.editActive><div id=user-list ui-grid-selection ui-grid-pagination ui-grid-resize-columns ui-grid-auto-resize ui-grid=ctrl.gridOptions style=\"height: 80vh\"></div></md-content></md-card><md-content ng-if=ctrl.editActive><user-form user=ctrl.user></user-form></md-content></div>");
$templateCache.put("app/acl/component/dialog-share-entity.html","<md-dialog aria-label=\"{{ translation.add_schema }}\" style=\"width: 800px\"><md-toolbar class=main-color><div class=md-toolbar-tools><h3>{{ actionText }}</h3><span flex></span><md-button ng-click=cancel($event) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column layout-padding=8 style=\"padding-top: 10px\"><form name=shareForm novalidate><section layout=column layout-wrap=\"\"><div layout=row layout-margin><h4>{{ translation.BY }}:</h4><md-input-container class=\"w100 m0\"><md-select ng-model=rule.users placeholder=User multiple><md-option ng-value=item.userId ng-repeat=\"item in users | orderBy:&quot;fullName&quot;\">{{ item.fullName }} ({{ item.profile.type }})</md-option></md-select></md-input-container><md-input-container class=\"w100 m0\"><md-select ng-model=rule.groups placeholder=Group multiple><md-option ng-value=item.id ng-repeat=\"item in groups | orderBy:&quot;name&quot;\">{{ item.name }}</md-option></md-select></md-input-container></div><div layout=row layout-margin><h4>{{ translation.ACTION }}:</h4><md-input-container class=\"w100 m0\"><md-select ng-model=rule.actions multiple><md-option ng-value=item ng-repeat=\"item in actions\">{{ item }}</md-option></md-select></md-input-container></div><div layout=row layout-margin><h4>{{ translation.GRANT }}:</h4><md-input-container class=m0><md-select name=grant ng-model=rule.granted><md-option value=true>{{ translation.allow }}</md-option><md-option value=false>{{ translation.deny }}</md-option></md-select></md-input-container></div></section><section layout=row layout-align=\"end center\"><md-button ng-click=add() class=\"md-raised md-primary\">{{ translation.ADD }}</md-button></section><br><md-divider></md-divider></form><section layout=row><div flex=100><md-content><md-tabs><md-tab label=\"{{ translation.POLICIES }}\"><md-content><section layout=column><div flex=100><table class=table><thead><tr><th>{{ translation.GRANT }}</th><th>{{ translation.BY }}</th><th>{{ translation.ACTION }}</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in acl.policies track by $index\"><td ng-bind-html=\"item.resource.granted==true ? translation.allow: translation.deny\"></td><td ng-bind-html=getBY(item)></td><td ng-bind-html=getAction(item)></td><td><md-button type=button ng-click=\"removePolicy($event, $index)\">{{ translation.REMOVE }}</md-button></td></tr></tbody></table></div></section></md-content></md-tab></md-tabs></md-content></div></section></md-dialog-content><md-dialog-actions><md-button ng-click=cancel($event)>{{ translation.CANCEL }}</md-button><md-button ng-click=save($event)>{{ translation.SAVE }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/audit/dialog/audit-filters-dialog.html","<md-dialog aria-label=\"Issues filters dialog\"><form><md-dialog-content style=\"min-width: 600px; max-width: 800px; max-height: 810px; padding: 5px\"><b style=\"font-weight: 600\">Filter by {{ ctrl.column.name }}</b><md-divider style=\"margin-bottom: 5px\"></md-divider><div layout=row><div flex><md-input-container class=w100><label>Condition</label><input ng-model=ctrl.column.alias disabled></md-input-container></div><div flex><md-input-container ng-if=\"ctrl.column.key == &quot;actionName&quot;\" class=w100><label>Value</label><md-select ng-model=ctrl.filter.value multiple><md-option ng-value=val.key ng-repeat=\"val in ctrl.actionsOptions | filter:actionsSearchTerm\">{{ val.value }}</md-option></md-select></md-input-container><md-input-container ng-if=\"ctrl.column.key == &quot;authorId&quot;\" class=w100><label>Value*</label><md-select ng-model=ctrl.filter.value multiple><md-option ng-value=val.key ng-repeat=\"val in ctrl.usersOptions | filter:userSearchTerm\">{{ val.value }}</md-option></md-select></md-input-container><md-input-container ng-if=\"ctrl.column.alias == &quot;LIKE&quot;\" class=w100><label>Value</label><input ng-model=ctrl.filter.value[0]></md-input-container></div></div></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button ng-click=ctrl.cancel() class=md-raised>Cancel</md-button><md-button ng-click=ctrl.applyFilters() class=\"md-raised green white-text\">Filter</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/cases/components/kanban.html","<div data-slots=\"{{ kanban.slots.length }}\" class=canvas-view><div ng-repeat=\"estado in kanban.data \" class=\"canvas-panel grey lighten-3\"><div class=canvas-head><h4 class=text-center>{{ estado.name | capitalize }} - {{ estado.cases.length }}</h4></div><div id={{estado.name}} ui-sortable=sortableOptionsList ng-model=estado.cases style=\"height: 100%\" class=\"canvas-drop-area m0 container-{{kanban.ref}}\"><div id={{case.caseId}} layout=row layout-wrap layout-align=\"center stretch\" ng-repeat=\"case in estado.cases\" data-case=\"{{ case }}\" style=\"pointer-events:{{isloading?\'none\':\'all\'}}\" class=canvas-element><div layout=row><div flex=20 layout=row layout-align=\"center center\" layout-padding class=\"critic _{{case.criticality}}\">{{ case.criticality | uppercase }}</div><div flex=80 style=\"padding:0 9px\"><h5><b>{{ case.caseId }} :</b>{{ case.title }}</h5></div></div><div layout=row layout-wrap layout-padding><div><p>{{ translation.ASSIGNED }}:&nbsp;&nbsp;<b>{{ case.assigned.name }}</b></p><p>{{ translation.FECHA }}:&nbsp;&nbsp;<b>{{ case.creationDate | asDate }}</b></p><p ng-if=\"case.state === \'cerrado\'\">{{ translation.CLOSING_REASON }}:&nbsp; &nbsp;<b>{{ case.closingReason }}</b></p></div><div><p>{{ translation.RESOLUTION_DATE }}:&nbsp;&nbsp;<b>{{ case.scheduledResolutionDate | asDate }}</b></p></div><div ng-if=\"kanban.ref === &quot;nocategory&quot;\"><small>{{ translation.CATEGORY }}</small><code>{{ case.category }}</code></div></div><article layout=row layout-align=\"end center\"><md-button ng-click=kanban.details(case) ng-disabled=isloading style=\"z-index: 1\" class=\"md-fab md-mini md-primary\"><md-icon md-font-set=material-icons md-menu-align-target>edit</md-icon></md-button></article></div></div></div></div>");
$templateCache.put("app/casos/templates/dialog-create-case.html","<md-dialog style=width:500px><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{translation.CREAR_CASO}}</h2><span flex></span><md-button ng-click=cancel() class=md-icon-button><md-icon md-font-set=material-icons>clear</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=column><div style=\"padding:20px 10px 0 10px\"><form name=newCaseForm novalidate><div layout=column style=\"padding: 0px 16px\"><md-input-container class=\"no-padding-no-margin w100\"><label>{{translation.NOMBRE}}</label><input ng-model=inputs.nombre placeholder={{translation.NOMBRE_CASO}} aria-label=\"Case name field\" required></md-input-container><div layout=row><md-input-container class=\"no-padding-no-margin w100\"><label>{{translation.CRITICIDAD}} *</label><select ng-model=inputs.criticidad placeholder={{translation.CRITICIDAD}} aria-label=\"Criticity Selector\" required class=select-filters-modal><option selected value=\"\">Select</option><option value=alta>{{translation.ALTA}}</option><option value=media>{{translation.MEDIA}}</option><option value=baja>{{translation.BAJA}}</option></select></md-input-container><md-input-container class=\"no-padding-no-margin w100\"><label>Created By</label><input ng-model=inputs.createdBy placeholder={{translation.EJECUTIVO}} aria-label=\"Executive field\" readonly disabled></md-input-container></div><md-input-container class=\"no-padding-no-margin w100\"><label>Category *</label><select ng-model=inputs.category placeholder=Category required class=select-filters-modal><option selected value=\"\">Select</option><option ng-value=item ng-repeat=\"item in categories\">{{item}}</option></select></md-input-container><md-input-container class=\"no-padding-no-margin w100\"><label>Assigned</label><select ng-model=inputs.assigned placeholder=Assigned class=select-filters-modal><option selected value=\"\">Select</option><option ng-value=item.username ng-repeat=\"item in users | orderBy:\'fullName\'\">{{item.fullName}}</option></select></md-input-container><md-input-container class=\"no-padding-no-margin w100\"><label>Group</label><select ng-model=inputs.group placeholder=Group class=select-filters-modal><option selected value=\"\">Select</option><option ng-value=item.id ng-repeat=\"item in groups\">{{item.name}}</option></select></md-input-container><md-input-container class=\"no-padding-no-margin w100\"><label>{{translation.DESCRIPCION}}</label><textarea ng-model=inputs.descripcion placeholder={{translation.DESCRIPCION}} aria-label=\"Description field\" required></textarea></md-input-container></div></form><md-divider></md-divider></div></div></md-dialog-content><md-dialog-actions><md-button type=button ng-click=cancel() class=\"md-raised pull-right\"><span>{{translation.CANCELAR}}</span></md-button><md-button id=saveCase type=button ng-disabled=newCaseForm.$invalid ng-click=crearCasoController() class=\"md-raised md-primary pull-right\"><span>{{translation.CREAR_CASO}}</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/casos/templates/panel-user-list.html","<div aria-label=\"Select a user.\" role=listbox class=demo-menu-example><md-content style=\"height: 200px;overflow-y:auto;border: 1px solid #d2d2d2;background-color: wheat\"><md-list flex><md-list-item ng-repeat=\"user in ctrl.users\" ng-click=ctrl.selectUser(user)><ng-letter-avatar charcount=2 height=25 width=25 fontsize=10px data={{user.name}} shape=round></ng-letter-avatar><div layout=column style=padding-left:10px class=md-list-item-text><p style=\"line-height: 15px\"><span>{{user.fullName}}</span><br><span>@{{user.username}}</span></p></div></md-list-item></md-list></md-content></div>");
$templateCache.put("app/casos/templates/section-associated-events.html","<section><md-toolbar class=\"border-detail white text-main-color\"><div layout=row style=\"align-items: center\"><h4 flex=\"\" md-truncate=\"\" class=md-toolbar-tools><span>{{translation.EVENTOS_ASOCIADOS}}</span></h4><form role=search style=\"margin-right: 1rem\"><md-icon md-font-set=material-icons md-menu-align-target>date_range</md-icon><aabm-form-group class=form-group><label>{{translation.FROM_DATE}}</label><input style=width:126px type=text bs-datepicker title=From placeholder=From ng-model=ctrl.fromDate abm-form-control=\"\" data-min-date={{ctrl.minFrom}} data-max-date={{ctrl.toDate}} data-autoclose=1 data-date-format=dd-MM-yyyy ng-change=ctrl.bDate()></aabm-form-group><aabm-form-group class=form-group><label>{{translation.TO_DATE}}</label><input style=width:126px type=text bs-datepicker title=To placeholder=To ng-model=ctrl.toDate abm-form-control=\"\" data-min-date={{ctrl.fromDate}} data-autoclose=1 data-date-format=dd-MM-yyyy data-max-date=today ng-change=ctrl.bDate()></aabm-form-group></form></div></md-toolbar><div><ng-table-dynamic_2 id=alerts-case-table fn-config=ctrl.initGrid on-delete-row=ctrl.removeEvent show-top-bar=true show-workspaces-button=false show-filter-button=false show-refresh-button=true show-export-csv-button=false></ng-table-dynamic_2></div><div layout-align=\"end center\" class=\"md-toolbar-tools isSticky inBottom\"><md-button md-no-ink ng-click=ctrl.showModalAddAlert() ng-hide=\"!ctrl.validatePermission() || ctrl.tab.caso.state == \'cerrado\' || ctrl.tab.caso.isUpdatable == false\" class=\"md-raised md-primary pull-right\">{{translation.ASIGNAR_EVENTOS}}</md-button></div></section>");
$templateCache.put("app/casos/templates/section-basic-data.html","<section><ng-include src=&quot;app/casos/templates/sidenav-guest-user-case.html&quot;></ng-include><ng-include src=&quot;app/casos/templates/sidenav-owner-user-case.html&quot;></ng-include><ng-include src=&quot;app/casos/templates/sidenav-owner-group-case.html&quot;></ng-include><md-toolbar class=\"border-detail white text-main-color\"><div layout=row><h4 flex=\"\" md-truncate=\"\" class=md-toolbar-tools><span>{{ translation.BASIC_DATA }}</span></h4></div></md-toolbar><form layout=row layout-padding=\"\" layout-wrap=\"\" name=caseForm novalidate><div flex=70><md-input-container class=w100><label>{{ translation.NOMBRE }}</label><input ng-show=ctrl.tab.caso.editando type=text draggable=false ng-model=ctrl.tab.casoEdit.titulo md-maxlength=100 maxlength=100 required><h5 style=\"margin-top: 1.8rem; font-size: 1.5em\" ng-show=!ctrl.tab.caso.editando>{{ ctrl.tab.caso.title }}</h5></md-input-container><md-input-container class=w100><label>{{ translation.DESCRIPCION }}</label><textarea ng-show=ctrl.tab.caso.editando type=text draggable=false ng-model=ctrl.tab.casoEdit.descripcion md-maxlength=300 maxlength=300 rows=2 required></textarea><h5 style=\"margin-top: 1.8rem; font-size: 1.3em\" ng-show=!ctrl.tab.caso.editando>{{ ctrl.tab.caso.description }}</h5></md-input-container></div><md-input-container flex=30><h5>{{ translation.ESTADO }}:&nbsp;&nbsp;<b>{{ ctrl.tab.caso.state | uppercase }}</b></h5><md-radio-group ng-show=ctrl.tab.caso.editando ng-model=ctrl.tab.caso.state ng-change=ctrl.onChangeState(ctrl.tab)><md-radio-button ng-value=state ng-repeat=\"state in ctrl.statusList\" ng-if=\"state != ctrl.statusList[ctrl.statusList.length-1]\">{{ state | capitalize }}</md-radio-button></md-radio-group><h5>{{ translation.FECHA }}:&nbsp;&nbsp;</h5><b>{{ ctrl.tab.caso.creationDate | asDateHour }}</b><h5>{{ translation.CREATED_BY }}:&nbsp;&nbsp;<b>{{ ctrl.tab.caso.createdBy.name }}</b></h5></md-input-container><md-input-container flex=50><label>{{ translation.ASSIGNED }}</label><h5 style=\"margin-top: 1.8rem\"><md-button id=showOwnerUserDialog ng-show=ctrl.tab.caso.editando aria-label=\"Change Assigned\" ng-disabled=\"ctrl.tab.caso.state == &quot;cerrado&quot; || !ctrl.tab.caso.isUpdatable\" ng-click=\"ctrl.showOwnerUserDialog($event, ctrl.tab)\" class=\"md-fab md-mini white\"><md-icon class=\"grey-text md-icon-button\">person</md-icon><md-tooltip md-direction=bottom>{{ translation.MODIFICAR }}</md-tooltip></md-button>{{ ctrl.tab.caso.assigned.name.length > 0 ? ctrl.tab.caso.assigned.name : \'no user assigned\' }}</h5></md-input-container><md-input-container flex=50><label>{{ translation.GROUP }}</label><h5 style=\"margin-top: 1.8rem\"><md-button ng-show=ctrl.tab.caso.editando aria-label=\"Change Group\" ng-disabled=\"ctrl.tab.caso.state == &quot;cerrado&quot; || !ctrl.tab.caso.isUpdatable\" ng-click=\"ctrl.showOwnerGroupDialog($event, ctrl.tab)\" class=\"md-fab md-mini white\"><md-icon class=\"grey-text md-icon-button\">group</md-icon><md-tooltip md-direction=bottom>{{ translation.MODIFICAR }}</md-tooltip></md-button>{{ ctrl.tab.caso.group.name.length > 0 ? ctrl.tab.caso.group.name : \'No group assigned\' }}</h5></md-input-container><md-input-container flex=50><label>{{ translation.RESOLUTION_DATE }}</label><input ng-if=ctrl.tab.caso.editando style=\"max-width: 100px; text-align: center\" type=text bs-datepicker placeholder=\"scheduled resolution date\" ng-model=ctrl.tab.caso.scheduledResolutionDate data-min-date=\"{{ ctrl.tab.caso.creationDate }}\" data-autoclose=1 required data-date-format=dd-MM-yyyy><h5 style=\"margin-top: 1.8rem\" ng-if=!ctrl.tab.caso.editando>{{ ctrl.tab.caso.scheduledResolutionDate | asDate }}</h5></md-input-container><md-input-container flex=25><label>{{ translation.CATEGORY }}</label><md-select ng-if=ctrl.tab.caso.editando ng-model=ctrl.tab.casoEdit.category><md-option ng-value=item ng-repeat=\"item in ctrl.categories\">{{ item }}</md-option></md-select><h5 style=\"margin-top: 1.8rem\" ng-if=!ctrl.tab.caso.editando>{{ ctrl.tab.caso.category }}</h5></md-input-container><md-input-container flex=25><label>{{ translation.CRITICIDAD }}</label><md-select ng-if=ctrl.tab.caso.editando ng-model=ctrl.tab.casoEdit.criticidad><md-option value=alta><span tipo-event-text=alta>{{ translation.ALTA }}</span></md-option><md-option value=media><span tipo-event-text=media>{{ translation.MEDIA }}</span></md-option><md-option value=baja><span tipo-event-text=baja>{{ translation.BAJA }}</span></md-option></md-select><h5 style=\"margin-top: 1.8rem\" ng-if=!ctrl.tab.caso.editando tipo-event-text=\"{{ ctrl.tab.caso.criticality }}\">{{ ctrl.tab.caso.criticality }}</h5></md-input-container></form><div layout-align=\"end center\" class=\"md-toolbar-tools isSticky inBottom\"><md-button id=showUsersGuestdDialog ng-disabled=!ctrl.validatePermission() aria-label=\"{{ translation.GUESTS }}\" title=\"{{ translation.GUESTS }}\" ng-click=\"ctrl.showUsersGuestdDialog($event, ctrl.tab)\" class=\"md-fab md-mini white\"><md-icon md-font-set=material-icons md-menu-align-target class=grey-text>group</md-icon></md-button><md-button id=exportCase has-permission=cases:export aria-label=\"{{ translation.EXPORT }}\" title=\"{{ translation.EXPORT }}\" ng-click=ctrl.exportCase(ctrl.tab) class=\"md-fab md-mini white\"><md-icon md-font-set=material-icons md-menu-align-target class=grey-text>cloud_download</md-icon></md-button><md-button id=cancelarEdicion ng-show=ctrl.tab.caso.editando ng-click=ctrl.cancelarEdicion(ctrl.tab) class=\"md-raised red white-text\"><div class=\"fa fa-times\"></div>&nbsp;{{ translation.CANCELAR }}</md-button><md-button id=saveEdit ng-show=ctrl.tab.caso.editando ng-disabled=!ctrl.validatePermission() ng-click=ctrl.saveEdit(ctrl.tab) class=\"md-raised green white-text\"><div class=\"fa fa-floppy-o\"></div>&nbsp;{{ translation.GUARDAR }}</md-button><md-button id=reOpenCase ng-disabled=!ctrl.validatePermission() ng-show=\"ctrl.tab.caso.state == &quot;cerrado&quot; &amp;&amp; !ctrl.tab.caso.editando\" ng-click=ctrl.reOpenCase(ctrl.tab) class=\"md-raised blue darken-3 white-text\"><div class=\"fa fa-folder-open\"></div>&nbsp;{{ translation.REABRIR_CASO }}</md-button><md-button id=caseEditable ng-disabled=!ctrl.validatePermission() ng-show=\"ctrl.tab.caso.state != &quot;cerrado&quot; &amp;&amp; !ctrl.tab.caso.editando &amp;&amp; ctrl.tab.caso.isUpdatable\" ng-click=ctrl.caseEditable(ctrl.tab) class=\"md-raised blue darken-3 white-text\"><div class=\"fa fa-pencil\"></div>&nbsp;{{ translation.MODIFICAR }}</md-button><md-button id=closeCase ng-disabled=!ctrl.validatePermission() ng-show=\"ctrl.tab.caso.state != &quot;cerrado&quot; &amp;&amp; !ctrl.tab.caso.editando &amp;&amp; ctrl.tab.caso.isUpdatable\" ng-click=\"ctrl.closeCase(ctrl.tab, $event)\" class=\"md-raised red white-text\"><div class=\"fa fa-folder\"></div>&nbsp;{{ translation.CERRAR }}</md-button></div></section>");
$templateCache.put("app/casos/templates/section-comment.html","<section><md-toolbar class=\"border-detail white text-main-color\"><div class=md-toolbar-tools><h2 flex=\"\" md-truncate=\"\">{{ translation.COMENTARIOS }}</h2><b ng-show=ctrl.tab.caso.comments.length><md-icon md-font-set=material-icons md-menu-align-target>comment</md-icon>{{ ctrl.tab.caso.comments.length }}</b></div></md-toolbar><section layout=row layout-padding=\"\" layout-wrap=\"\" class=p0><md-progress-linear ng-hide=ctrl.tab.caso.commentsLoaded></md-progress-linear><md-list flex=100 style=\"max-height: 400px;overflow: auto\" class=p0><md-list-item ng-repeat=\"comment in ctrl.tab.caso.comments\" class=p0><article layout=row layout-padding=\"\" class=w100><div flex=20 class=text-center><md-tooltip>{{ comment.author.name }}</md-tooltip><letter-avatar data=\"{{ comment.author.name }}\"></letter-avatar></div><div flex=60 ng-show=\"!comment.editando &amp;&amp; !comment.eliminando\"><b class=m0>{{ comment.author.name }} {{ comment.author.lastName }}</b><p style=text-align:justify ng-bind-html=comment.commentHtml></p><p class=text-right><b>{{ comment.moment }} {{ comment.edited }}</b></p></div><form flex=60 ng-show=\"comment.editando || comment.eliminando\"><md-input-container ng-show=comment.editando class=\"p0 m0 md-block\"><label>Edit Comment</label><textarea id=item_{{comment.id}} type=text md-maxlength=1000 maxlength=1000 rows=2 ng-model=ctrl.editComment ng-required=true ng-focus=\"ctrl.ngFocus(\'#item_\' + comment.id)\"></textarea></md-input-container><md-input-container ng-show=comment.eliminando class=\"p0 m0 md-block\"><label>{{ translation.POR_QUE_ELIMINARLO }}</label><input type=text md-maxlength=100 maxlength=100 ng-model=comment.edit.justificacion ng-required=true></md-input-container><md-input-container class=\"p0 m0 md-block text-right\"><md-button aria-label=Acept ng-click=\"ctrl.updateComment(comment, ctrl.tab)\" g-disabled=\"(comment.editando == true &amp;&amp; !ctrl.editComment) || (comment.eliminando == true &amp;&amp; !comment.edit.justificacion)\"><md-icon class=md-icon-button>check</md-icon></md-button><md-button aria-label=Cancel ng-click=ctrl.CancelarEdiElimComentario(comment) ng-disabled=\"ctrl.tab.caso.state == \'cerrado\'\"><md-icon class=md-icon-button>clear</md-icon></md-button></md-input-container></form><div flex=20 ng-disabled=\"ctrl.tab.caso.state === \'cerrado\'\"><md-button style=\"min-width: auto\" aria-label=edit ng-click=ctrl.commentEditable(comment) ng-disabled=\"ctrl.tab.caso.state == \'cerrado\' || (ctrl.tab.caso.state == \'abierto\' &amp;&amp; comment.isUpdatable === false)\" class=\"w100 p0 m0\"><md-icon class=md-icon-button>edit</md-icon><md-tooltip md-direction=right>edit</md-tooltip></md-button><md-button style=\"min-width: auto\" aria-label=delete ng-click=ctrl.removeComment(comment) ng-disabled=\"ctrl.tab.caso.state == \'cerrado\' || (ctrl.tab.caso.state == \'abierto\' &amp;&amp; comment.isUpdatable === false)\" class=\"w100 p0 m0\"><md-icon class=md-icon-button>delete</md-icon><md-tooltip md-direction=right>delete</md-tooltip></md-button></div></article></md-list-item><md-divider></md-divider></md-list></section><section layout=row layout-padding=\"\" layout-wrap=\"\"><div flex=100><md-input-container class=\"w100 m0\"><textarea type=text ng-model=ctrl.comment md-maxlength=1000 maxlength=1000 placeholder=\"{{ translation.PLACEHOLDER_TEXTAREA }}\" ng-disabled=\"ctrl.tab.caso.state == \'cerrado\'\" class=add-menu-open-button></textarea></md-input-container></div><div flex=100 class=text-right><md-button ng-click=ctrl.publicarComentario(ctrl.tab) ng-disabled=\"!ctrl.validatePermission() || ctrl.tab.caso.state == \'cerrado\'\" class=\"md-raised md-primary\"><md-icon md-font-set=material-icons class=\"md-icon-button md-secondary md-hue-3\">send</md-icon>{{ translation.SEND_MSG }}</md-button></div></section></section>");
$templateCache.put("app/casos/templates/section-related-files.html","<section></section><md-toolbar class=\"border-detail white text-main-color\"><div class=md-toolbar-tools><h2 flex=\"\" md-truncate=\"\">{{translation.ARCHIVOS_RELACIONADOS}}</h2><div flex=20 class=box-upload><input type=file name=file id=file nv-file-select uploader=ctrl.uploader input-file filters=Extensions,Size multiple ng-disabled=\"!ctrl.validatePermission() || ctrl.tab.caso.state == \'cerrado\'\"><label for=file class=pull-right><a style=\"background-color:#f5f5f5 !important\" class=\"btn btn-success btn-fab btn-upload-file md-mini\"><md-icon md-font-set=material-icons style=\"margin-top:27%; color: black\" class=md-icon-button>cloud_upload</md-icon></a></label></div></div></md-toolbar><md-progress-linear ng-hide=ctrl.tab.caso.filesLoaded></md-progress-linear><section layout=row layout-padding=\"\" layout-wrap=\"\" ng-show=ctrl.uploader.getNotUploadedItems().length><div flex=100><md-list><md-list-item ng-repeat=\"item in ctrl.uploader.queue\" class=p0><p><md-icon md-font-set=material-icons md-menu-align-target>file_copy</md-icon><span ng-bind=item.file.name></span><a ng-click=item.upload() title=\"Subir archivo {{item.file.name}}\"><i class=icon-file_upload></i></a></p></md-list-item></md-list></div><div flex=100 ng-show=!ctrl.uploader.isUploading><md-progress-linear md-mode=determinate value={{ctrl.uploader.progress}}></md-progress-linear></div><div flex=100><md-button type=button ng-click=ctrl.uploader.uploadAll() ng-disabled=!ctrl.uploader.getNotUploadedItems().length class=\"md-raised md-primary\"><md-icon md-font-set=material-icons md-menu-align-target>done</md-icon>{{translation.SUBIR_TODO}}</md-button><md-button type=button ng-click=ctrl.uploader.cancelAll() ng-disabled=!ctrl.uploader.isUploading class=\"md-raised md-warn\"><md-icon md-font-set=material-icons md-menu-align-target>close</md-icon>{{translation.CANCELAR_TODO}}</md-button><md-button type=button ng-click=ctrl.uploader.clearQueue() ng-disabled=!ctrl.uploader.queue.length class=\"md-raised md-warn\"><md-icon md-font-set=material-icons md-menu-align-target>delete</md-icon>{{translation.BORRAR_TODO}}</md-button></div></section><md-list><md-list-item ng-repeat=\"uploadedFile in ctrl.tab.caso.files\" ng-click=\"goToPerson(person.name, $event)\" class=p0><section layout=row layout-padding=\"\" layout-wrap=\"\"><div flex=100><p class=truncate>{{uploadedFile.fileName}}</p></div><div flex=50 ng-show=uploadedFile.eliminando><md-input-container class=w100><label>{{translation.POR_QUE_ELIMINARLO}}</label><input type=text ng-model=uploadedFile.edit.justificacion></md-input-container></div><div flex=50 ng-show=uploadedFile.eliminando><md-button ng-click=\"ctrl.eliminarArchivo(uploadedFile, ctrl.tab)\" title={{translation.ENVIAR_COMENTARIO}} class=\"md-raised md-warn\">{{translation.ELIMINAR}}</md-button><md-button ng-click=ctrl.cancelarElimArchivo(uploadedFile) class=md-raised>{{translation.CANCELAR}}</md-button></div><md-icon flex=25 ng-show=!uploadedFile.eliminando ng-disabled=\"ctrl.tab.caso.state == \'cerrado\'\" md-font-set=material-icons ng-click=ctrl.descargarArchivo(uploadedFile) aria-label={{translation.DESCARGAR_ARCHIVO}} class=\"md-icon-button md-secondary md-hue-3\">cloud_download</md-icon><md-icon flex=25 ng-show=!uploadedFile.eliminando ng-disabled=\"!ctrl.validatePermission() || ctrl.tab.caso.state == \'cerrado\'\" md-font-set=material-icons ng-click=ctrl.eliminandoArchivo(uploadedFile) aria-label={{translation.ELIMINAR_ARCHIVO}} class=\"md-icon-button md-secondary md-hue-3\">delete</md-icon></section></md-list-item><md-divider></md-divider></md-list>");
$templateCache.put("app/casos/templates/sidenav-guest-user-case.html","<md-sidenav id=case-invite-sidenav md-component-id=\"{{ &quot;guest-user&quot; + ctrl.tab.caso.caseId }}\" style=\"max-height: 40%;left: 20px;top: 68px;width:50em\" class=md-sidenav-left><md-toolbar class=md-theme-left><h1 class=md-toolbar-tools>{{ translation.GUESTS }}</h1></md-toolbar><md-dialog-content style=width:50em;max-height:810px><md-tabs md-dynamic-height md-border-bottom md-selected=0><md-tab label=\"{{ translation.GUESTS_LIST }}\"><md-content style=\"height: 200px;overflow-y:auto\" class=md-padding><md-progress-linear ng-hide=ctrl.loadedCaseTable></md-progress-linear><md-list iclass=md-dense flex><md-list-item ng-repeat=\"user in ctrl.guestList\" ng-click=null><ng-letter-avatar charcount=2 height=25 width=25 fontsize=10px data=\"{{ user.username }}\" shape=round></ng-letter-avatar><div layout=column style=padding-left:10px class=md-list-item-text><p style=\"line-height: 15px\"><span>{{ user.name }} {{ user.lastName }}</span><br><span>@{{ user.username }}</span></p></div><md-button aria-label=Delete ng-disabled=\"ctrl.tab.caso.state == \'cerrado\'\" ng-click=ctrl.deleteCaseUser(user.userId) class=\"md-secondary md-icon-button\"><md-icon clas=md-icon-button>delete</md-icon></md-button><md-divider ng-if=!$last></md-divider></md-list-item></md-list></md-content></md-tab><md-tab label=\"{{ translation.GUESTS_SEND }}\" ng-disabled=\"ctrl.tab.caso.state == \'cerrado\' || ctrl.tab.caso.isUpdatable == false\"><md-content><div layout=column style=margin:15px><span>People</span><md-chips ng-model=ctrl.selectedUsers md-autocomplete-snap md-require-match=true input-aria-label=\"Users to invite\"><md-autocomplete md-selected-item=ctrl.selectedItem md-no-cache md-search-text=ctrl.searchText md-items=\"item in ctrl.querySearch(ctrl.searchText)\" md-item-text=item.name input-aria-describedby=autocompleteTitle placeholder=\"Enter names\"><span md-highlight-text=ctrl.searchText>{{ item.name }} {{ item.lastName }}</span></md-autocomplete><md-chip-template><span>{{ $chip.name }} {{ $chip.lastName }}</span></md-chip-template></md-chips><br><textarea type=text ng-show=ctrl.notify ng-model=ctrl.note rows=5 cols=50 style=\"resize: none\" placeholder=\"Add a note\"></textarea><br><md-checkbox ng-model=ctrl.notify aria-label=\"Notify people\">{{ translation.GUESTS_NOTIFY }}</md-checkbox></div></md-content><md-card-actions layout=row layout-align=\"end end\"><md-button ng-disabled=\"(ctrl.notify &amp;&amp; !ctrl.note) || ctrl.selectedUsers.length === 0 || $rootScope.loading\" ng-click=ctrl.createCaseUsers() md-no-ink class=\"md-raised md-primary\">Send</md-button></md-card-actions></md-tab></md-tabs></md-dialog-content></md-sidenav>");
$templateCache.put("app/casos/templates/sidenav-owner-group-case.html","<md-sidenav id=case-asignation-group-sidenav md-component-id=\"{{\'owner-group\'+ctrl.tab.caso.caseId}}\" style=\"max-height: 40%;left: 20px;top: 68px;width:50em\" class=md-sidenav-left><md-toolbar class=md-theme-left><h1 class=md-toolbar-tools>{{translation.OWNER}}</h1></md-toolbar><md-content layout-padding><md-input-container class=md-block><label>Groups</label><md-select ng-model=ctrl.newGroupId><md-option ng-repeat=\"group in ctrl.groups\" value={{group.id}} ng-selected=\"group.id === ctrl.tab.caso.group.id\">{{group.name}}</md-option></md-select></md-input-container></md-content><md-card-actions layout=row layout-align=\"end end\"><md-button ng-disabled=\"!ctrl.tab.caso.group || $rootScope.loading\" ng-click=ctrl.deleteReassignGroup() md-no-ink class=\"md-raised md-primary\">{{translation.CLEAR}}</md-button><md-button ng-disabled=\"ctrl.newGroupId == ctrl.tab.caso.group.id || !ctrl.newGroupId || $rootScope.loading\" ng-click=ctrl.reassignGroup() md-no-ink class=\"md-raised md-primary\">{{translation.ASSIGN}}</md-button></md-card-actions></md-sidenav>");
$templateCache.put("app/casos/templates/sidenav-owner-user-case.html","<md-sidenav id=case-asignation-sidenav md-component-id=\"{{\'owner-user\'+ctrl.tab.caso.caseId}}\" style=\"max-height: 40%;left: 20px;top: 68px;width:50em\" class=md-sidenav-left><md-toolbar class=md-theme-left><h1 class=md-toolbar-tools>{{translation.OWNER}}</h1></md-toolbar><md-content layout-padding><md-input-container class=md-block><label>{{translation.EJECUTIVO}}</label><md-select ng-model=ctrl.newUser><md-option ng-repeat=\"user in ctrl.users\" value={{user.userId}} ng-selected=\"user.userId === ctrl.tab.caso.assigned.userId\">{{user.fullName}}</md-option></md-select></md-input-container><textarea type=text ng-model=ctrl.note rows=5 cols=50 style=\"resize: none\" placeholder=\"Add a note\"></textarea></md-content><md-card-actions layout=row layout-align=\"end end\"><md-button ng-disabled=\"!ctrl.tab.caso.assigned || $rootScope.loading\" ng-click=ctrl.deleteReassignAssigned() md-no-ink class=\"md-raised md-primary\">{{translation.CLEAR}}</md-button><md-button ng-disabled=\"ctrl.newUser == ctrl.tab.caso.assigned.userId || !ctrl.note || !ctrl.newUser || $rootScope.loading\" ng-click=ctrl.reassignAssigned() md-no-ink class=\"md-raised md-primary\">{{translation.ASSIGN}}</md-button></md-card-actions></md-sidenav>");
$templateCache.put("app/charts/includes/chart-side-panel.html","<md-card ng-if=\"isLoading == false\"><section ng-if=!loading><div class=collapse-container><div ng-click=\"ctrl.onClickPanel(\'general\')\" has-permission=graphic-report#{{ctrl.chart.id}}:update class=collapse-head><md-icon ng-if=\"ctrl.panelActive!=\'general\'\" md-font-set=material-icons md-menu-align-target>chevron_right</md-icon><md-icon ng-if=\"ctrl.panelActive==\'general\'\" md-font-set=material-icons md-menu-align-target>expand_more</md-icon>{{ translation.general }}</div><div ng-show=\"ctrl.panelActive==\'general\'\" class=collapse-panel><div class=panel-ctn><md-content layout=row layout-wrap><md-input-container flex=100 class=m0><label>{{ translation.Title }}</label><input ng-model=ctrl.chart.name></md-input-container><md-input-container flex=100 class=m0><label>{{ translation.Description }}</label><textarea ng-model=ctrl.chart.description></textarea></md-input-container></md-content></div></div><div ng-click=\"ctrl.onClickPanel(\'series\')\" class=collapse-head><md-icon ng-if=\"ctrl.panelActive!=\'series\'\" md-font-set=material-icons md-menu-align-target>chevron_right</md-icon><md-icon ng-if=\"ctrl.panelActive==\'series\'\" md-font-set=material-icons md-menu-align-target>expand_more</md-icon><b>{{ ctrl.echartConfig.series.length }} &nbsp;</b>{{ translation.series }} &nbsp;</div><div ng-show=\"ctrl.panelActive==\'series\'\" class=\"collapse-panel p0\"><div class=panel-ctn><details ng-repeat=\"serie in ctrl.echartConfig.series track by $index\" ng-init=\"parentIndex = $index\"><summary layout=row layout-align=\"center center\" style=\"padding: 4px\" class=\"grey lighten-2\"><div flex><h4>{{ serie.name }}</h4><h6 ng-if=\"[ \'pie\', \'boxplot\' , \'treemap\'].includes(serie.type)\"><strong>{{ serie.type }}</strong></h6><div style=\"display: flex; justify-content: flex-start; flex-direction: row; flex-wrap: nowrap\"><select ng-if=\"[ \'line\', \'bar\'].includes(serie.type)\" ng-model=serie.type ng-change=ctrl.updateChart()><option value=line>line</option><option value=bar>bar</option></select></div></div><div flex class=text-right><input type=color ng-model=serie.color ng-change=\"ctrl.onChangeColor(serie.color, parentIndex, null)\"> <button aria-label=reset-color ng-click=\"ctrl.resetColorSerie(serie, $index)\" ng-if=\"serie.groupBy === false\"><md-tooltip md-direction=bottom>reset color</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>refresh</md-icon></button><div ng-if=\"serie.groupBy === false || [ \'pie\', \'boxplot\' , \'treemap\'].includes(serie.type)\" class=v100>Ver {{ serie.type === \"bar\" ? \"Barras\" : \"Puntos\" }} {{ serie.data.length }}</div></div></summary><div layout=column style=\"padding: 4px\" ng-if=\"serie.groupBy === false || [ \'pie\', \'boxplot\' , \'treemap\'].includes(serie.type)\"><div layout=row layout-align=\"center center\" ng-repeat=\"data in serie.data track by $index \"><div flex><h4>{{ data.name }}</h4></div><div flex class=text-right><input type=color ng-model=data.itemStyle.color ng-change=\"ctrl.onChangeColor(data.itemStyle.color, parentIndex, $index)\"></div></div></div><md-divider></md-divider></details></div></div><div ng-click=\"ctrl.onClickPanel(\'filters\')\" class=collapse-head><md-icon ng-if=\"ctrl.panelActive!=\'filters\'\" md-font-set=material-icons md-menu-align-target>chevron_right</md-icon><md-icon ng-if=\"ctrl.panelActive==\'filters\'\" md-font-set=material-icons md-menu-align-target>expand_more</md-icon>{{ translation.filters }}</div><div ng-show=\"ctrl.panelActive==\'filters\'\" class=collapse-panel><div class=panel-ctn><chart-filter config=ctrl.chart translation=translation schema=ctrl.chartList.schema></chart-filter></div></div><div ng-click=\"ctrl.onClickPanel(\'links\')\" class=collapse-head><md-icon ng-if=\"ctrl.panelActive!=\'links\'\" md-font-set=material-icons md-menu-align-target>chevron_right</md-icon><md-icon ng-if=\"ctrl.panelActive==\'links\'\" md-font-set=material-icons md-menu-align-target>expand_more</md-icon><b>{{ ctrl.chart.links.length }} &nbsp;&nbsp;</b>{{ translation.Hyperlinks }}</div><div ng-show=\"ctrl.panelActive==\'links\'\" class=collapse-panel><div class=panel-ctn><chart-links links=ctrl.chart.links id-chart=ctrl.chart.id translation=translation></chart-links></div></div><div ng-click=\"ctrl.onClickPanel(\'sources\')\" ng-if=\"ctrl.sourcesList.length &gt; 0\" class=collapse-head><md-icon ng-if=\"ctrl.panelActive!=\'sources\'\" md-font-set=material-icons md-menu-align-target>chevron_right</md-icon><md-icon ng-if=\"ctrl.panelActive==\'sources\'\" md-font-set=material-icons md-menu-align-target>expand_more</md-icon><b>{{ ctrl.sourcesList.length }} &nbsp;</b>{{ translation.Data_sources }}</div><div ng-show=\"ctrl.panelActive==\'sources\'\" class=collapse-panel><div class=panel-ctn><chart-sources sources=ctrl.sourcesList translation=translation></chart-sources></div></div><div ng-click=\"ctrl.onClickPanel(\'format\')\" class=collapse-head><md-icon ng-if=\"ctrl.panelActive!=\'format\'\" md-font-set=material-icons md-menu-align-target>chevron_right</md-icon><md-icon ng-if=\"ctrl.panelActive==\'format\'\" md-font-set=material-icons md-menu-align-target>expand_more</md-icon>{{ translation.Express_values }}</div><div ng-show=\"ctrl.panelActive==\'format\'\" class=collapse-panel><div class=panel-ctn><md-radio-group ng-model=ctrl.formatValuesBy.format aria-labelledby=favoriteFruit ng-change=onChangeFormat()><md-radio-button value=SF ng-disabled=ctrl.hasPivot class=md-primary>{{ translation.Without_format }}</md-radio-button><md-radio-button value=R ng-disabled=ctrl.hasPivot>{{ translation.Round }}</md-radio-button><md-radio-button value=K ng-disabled=ctrl.hasPivot>{{ translation.Thousands }}</md-radio-button><md-radio-button value=M ng-disabled=ctrl.hasPivot>{{ translation.Millions }}</md-radio-button><md-radio-button value=B ng-disabled=ctrl.hasPivot>{{ translation.Billions }}</md-radio-button><md-radio-button value=D ng-disabled=ctrl.hasPivot>{{ translation.decimals }} {{ ctrl.formatValuesBy.unid }}</md-radio-button></md-radio-group><md-input-container ng-if=\"ctrl.formatValuesBy.format ==\'D\'\" class=md-block><input type=range name=D ng-model=ctrl.formatValuesBy.unid min=0 max=10 ng-change=onChangeFormat()></md-input-container></div></div></div><md-divier></md-divier><section ng-if=\"!loading &amp;&amp; ctrl.showPivotBtn\"><md-button ng-click=assignPivot() class=\"md-raised w100 m0 ceptinel text-left\"><md-icon md-font-set=material-icons md-menu-align-target class=white-text>addchart</md-icon><span class=white-text>{{ translation.Graph_by_percentage }}</span></md-button></section></section><section ng-if=!loading style=\"position: sticky; bottom: 0\"><md-button has-permission=graphic-report#{{ctrl.chart.id}}:update aria-label=save ng-click=ctrl.saveChart() class=\"md-raised w100 m0 green white-text text-left\"><md-icon md-font-set=material-icons md-menu-align-target class=white-text>save</md-icon>{{ translation.save_changes }}</md-button></section></md-card><md-divider></md-divider><br><md-card ng-if=\"isLoading == false\"><section ng-if=!loading style=\"padding: 8px\" class=w100><chart-notes notes=ctrl.chart.notes chart-id=ctrl.chart.id translation=translation></chart-notes></section></md-card>");
$templateCache.put("app/charts/includes/chart-tool-bar.html","<md-toolbar class=md-menu-toolbar><div layout=row layout-padding ng-if=!ctrl.isWidget><div flex=100><h2 style=\"font-size: 23px\">{{ ctrl.chart.name }}</h2><p style=\"font-size: 18px\">{{ ctrl.chart.description }}</p></div></div><div layout=row class=noprint><div flex=70 ng-if=!ctrl.isWidget><md-toolbar><div class=\"md-toolbar-tools grey lighten-4\"><md-menu-bar flex=auto><md-menu><button ng-click=$mdMenu.open() class=\"grey lighten-4\">{{ translation.graph }}<md-icon md-font-set=material-icons class=black-text>arrow_drop_down</md-icon></button><md-menu-content width=3><md-menu-item has-permission=graphic-report#{{ctrl.chart.id}}:update><md-button ng-click=ctrl.saveChart()><div class=\"fa fa-floppy-o\"></div><b>{{ translation.save }}</b></md-button></md-menu-item><md-menu-item has-permission=graphic-report#{{ctrl.chart.id}}:update><md-button ng-click=ctrl.saveAs()><div class=\"fa fa-files-o\"></div><b>{{ translation.saveAs }}</b></md-button></md-menu-item><md-menu-item has-permission=graphic-report#{{ctrl.chart.id}}:read><md-button ng-click=ctrl.reloadChart()><div class=\"fa fa-refresh\"></div><b>{{ translation.reload }}</b></md-button></md-menu-item></md-menu-content></md-menu><md-menu><button ng-click=$mdMenu.open() class=\"grey lighten-4\">{{ translation.manage }}<md-icon md-font-set=material-icons class=black-text>arrow_drop_down</md-icon></button><md-menu-content width=3><md-menu-item has-permission=graphic-report#{{ctrl.chart.id}}:update><md-button ng-click=ctrl.manageChart(ctrl.chart)><div class=\"fa fa-pencil-square-o\"></div><b>{{ translation.edit }}</b></md-button></md-menu-item><md-menu-item has-permission=graphic-report#{{ctrl.chart.id}}:share><md-button ng-click=ctrl.showShareEntityDialog(ctrl.chart)><div class=\"fa fa-share-alt\"></div><b>{{ translation.share }}</b></md-button></md-menu-item><md-menu-item><md-button ng-click=print()><div class=\"fa fa-print\"></div><b>{{ translation.print }}</b></md-button></md-menu-item></md-menu-content></md-menu><md-menu><button ng-click=$mdMenu.open() class=\"grey lighten-4\">{{ translation.actions }}<md-icon md-font-set=material-icons class=black-text>arrow_drop_down</md-icon></button><md-menu-content width=3><md-menu-item><md-button ng-click=toggleSideNav()><b>{{ ctrl.sidenav_is_open ? translation.hide : translation.show }} {{ translation.filters }}</b></md-button></md-menu-item><md-menu-item><md-button ng-click=ctrl.startAutoRefresh(5)><b>{{ translation.refresh }} 5s</b></md-button></md-menu-item><md-menu-item><md-button ng-click=ctrl.startAutoRefresh(10)><b>{{ translation.refresh }} 10s</b></md-button></md-menu-item><md-menu-item><md-button ng-click=ctrl.startAutoRefresh(15)><b>{{ translation.refresh }} 15s</b></md-button></md-menu-item><md-menu-divider ng-if=ctrl.autoRefreshActive></md-menu-divider><md-menu-item ng-if=ctrl.autoRefreshActive><md-button ng-click=ctrl.stopAutoRefresh()><b>{{ translation.stopSynchronization }}</b></md-button></md-menu-item></md-menu-content></md-menu><md-menu ng-if=ctrl.autoRefreshActive><button ng-click=ctrl.stopAutoRefresh() class=\"grey lighten-4\">{{ translation.stopSynchronization }} {{ ctrl.delay }}s<md-icon md-font-set=material-icons class=\"black-text fa-spin\">sync</md-icon></button></md-menu></md-menu-bar></div></md-toolbar></div><div flex=\"{{ ctrl.isWidget ? 100 : 40 }}\" class=\"grey lighten-4\"><section layout=column layout-align=\"end center\" ng-if=!isLoading style=\"font-size: 1.2rem\"><div flex=100><div ng-if=ctrl.chartActivefilters><span class=m0>&nbsp;&nbsp; {{ translation.applying_filters_by }}: &nbsp;&nbsp;</span><span ng-repeat=\"filter in ctrl.chartActivefilters track by $index\" style=\"margin-right: 5px\" class=\"badge black-text grey lighten-1\"><span ng-if=\"filter.type == &quot;date&quot;\"><b>{{ filter.field }} : &nbsp;&nbsp;</b><span>{{ filter.selectedValues.fromDate | asMDate }} - {{ filter.selectedValues.toDate | asMDate }}</span></span><span ng-if=\"filter.type != &quot;date&quot;\"><b>{{ filter.field }} : &nbsp;&nbsp;</b><span to-html=\"filter.selectedValues | arrayText\"></span></span><span><md-icon md-font-set=material-icons ng-click=ctrl.filterChart() class=\"noprint red-text\">close</md-icon><md-tooltip>{{ translation.remove_filter }}</md-tooltip></span></span></div></div><div flex=100><span ng-if=ctrl.pivotFunction.hasOwnProperty(&quot;xAxisPercentageValueRef&quot;) class=\"text-right badge\">{{ translation.show_values_percentage }} {{ translation.xaxis }}:<b>{{ ctrl.pivotFunction.xAxisPercentageValueRef }}</b><span><md-icon md-font-set=material-icons ng-click=ctrl.removePivot() class=\"noprint red-text\">delete</md-icon><md-tooltip>{{ translation.remove_filter }}</md-tooltip></span></span><span ng-if=ctrl.pivotFunction.hasOwnProperty(&quot;xAxisDiffPercentageValueRef&quot;) class=\"text-right badge\">{{ translation.show_values_difference }} {{ translation.xaxis }}:<b>{{ ctrl.pivotFunction.xAxisDiffPercentageValueRef }}</b><span><md-icon md-font-set=material-icons ng-click=ctrl.removePivot() class=\"noprint red-text\">delete</md-icon><md-tooltip>{{ translation.remove_filter }}</md-tooltip></span></span><span ng-if=ctrl.pivotFunction.hasOwnProperty(&quot;seriesPercentageValueRef&quot;) class=\"text-right badge\">{{ translation.show_values_percentage }} {{ translation.series }}:<b>{{ ctrl.pivotFunction.seriesPercentageValueRef }}</b><span><md-icon md-font-set=material-icons ng-click=ctrl.removePivot() class=\"noprint red-text\">delete</md-icon><md-tooltip>{{ translation.remove_filter }}</md-tooltip></span></span><span ng-if=ctrl.pivotFunction.hasOwnProperty(&quot;seriesDiffPercentageValueRef&quot;) class=\"text-right badge\">{{ translation.show_values_difference }} {{ translation.series }}:<b>{{ ctrl.pivotFunction.seriesDiffPercentageValueRef }}</b><span><md-icon md-font-set=material-icons ng-click=ctrl.removePivot() class=\"noprint red-text\">delete</md-icon><md-tooltip>{{ translation.remove_filter }}</md-tooltip></span></span><span ng-if=ctrl.pivotFunction.hasOwnProperty(&quot;percentageFilterPivotField&quot;) class=\"text-right badge\"><b>{{ ctrl.pivotFunction.percentageFilterPivotField }}</b>:<b>{{ ctrl.pivotFunction.percentageFilterPivotValue }}</b><span><md-icon md-font-set=material-icons ng-click=ctrl.removePivot() class=\"noprint red-text\">delete</md-icon><md-tooltip>{{ translation.remove_filter }}</md-tooltip></span></span></div></section></div></div></md-toolbar>");
$templateCache.put("app/charts/list-componest/chart-groups.html","<md-list-item style=\"border-bottom: 1px solid #dedcdc\" ng-click=ctrl.toggleItems() class=\"md-3-line item-report\"><div layout=row layout-align=\"center center\" layout-padding><div><md-icon ng-if=\"ctrl.group.isOpen==false\" md-font-set=material-icons class=color-reports>folder_open</md-icon><md-icon ng-if=\"ctrl.group.isOpen==true\" md-font-set=material-icons class=color-reports>folder</md-icon></div><div><h3><b>{{ ctrl.group.groupName }}:&nbsp;</b></h3><span>{{ ctrl.group.items.length }} Items</span></div></div><md-button style=\"padding: 0.8rem\" aria-label=\"Display items button\" title=\"Toggle group\" class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>{{ ctrl.displayItems ? \'keyboard_arrow_up\' : \'keyboard_arrow_down\' }}</md-icon></md-button></md-list-item><section ng-show=\"ctrl.group.isOpen==true\" style=\"margin: 0px 0px 0px 4rem; border-left: 4px solid rgb(202 196 196)\"><div><md-list-item style=\"border-bottom: 1px solid #eaeaea; padding: 1.8rem\" class=md-2-line><div layout=column class=md-list-item-text><p><md-button has-permission=graphic-report:create abm-component aria-label=manageChart ng-click=ctrl.newChart()><md-icon md-font-set=material-icons>add</md-icon><b>New chart</b></md-button></p></div></md-list-item></div><div ng-repeat=\"group in ctrl.group.subGroup\"><chart-groups group=group translation=ctrl.translation></chart-groups></div><div ng-repeat=\"chart in ctrl.group.items\"><chart-item chart=chart translation=ctrl.translation></chart-item></div></section>");
$templateCache.put("app/charts/list-componest/chart-item.html","<md-list-item id=chart-config-{{ctrl.chart.name}} style=\"border-bottom: 1px solid #eaeaea\" class=\"md-3-line item-report\"><div layout=column><div><h4><small>{{ ctrl.chart.id }}:&nbsp;</small><b>{{ ctrl.chart.name }}</b></h4></div><div><p>{{ctrl.chart.description}}</p></div></div><md-button href=chart/{{ctrl.chart.id}} target=_blank has-permission=graphic-report#{{ctrl.chart.id}}:read style=\"padding: .8rem\" aria-label=show-{{ctrl.chart.name}} class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons md-menu-align-target>open_in_new</md-icon><md-tooltip>{{ ctrl.translation.show }}</md-tooltip></md-button><md-button has-permission=graphic-report#{{ctrl.chart.id}}:read ng-click=ctrl.totab(ctrl.chart) style=\"padding: .8rem\" aria-label=show-{{ctrl.chart.name}} class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>remove_red_eye</md-icon><md-tooltip>{{ ctrl.translation.show }}</md-tooltip></md-button><md-button has-permission=graphic-report#{{ctrl.chart.id}}:read ng-click=ctrl.duplicate(ctrl.chart) style=\"padding: .8rem\" aria-label=duplicate-{{ctrl.chart.name}} class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>content_copy</md-icon><md-tooltip>{{ ctrl.translation.duplicate }}</md-tooltip></md-button><md-button has-permission=graphic-report#{{ctrl.chart.id}}:update ng-click=ctrl.manageChart(ctrl.chart) style=\"padding: .8rem\" aria-label=edit-{{ctrl.chart.name}} class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>edit</md-icon><md-tooltip>{{ ctrl.translation.edit }}</md-tooltip></md-button><md-button has-permission=graphic-report#{{ctrl.chart.id}}:share ng-click=ctrl.showShareEntityDialog(ctrl.chart) style=\"padding: .8rem\" aria-label=share-{{ctrl.chart.name}} class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>share</md-icon><md-tooltip>{{ ctrl.translation.share }}</md-tooltip></md-button><md-button has-permission=graphic-report#{{ctrl.chart.id}}:delete ng-click=ctrl.confirmDeleteChart(ctrl.chart.id) style=\"padding: .8rem\" aria-label=delete-{{ctrl.chart.name}} class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>delete</md-icon><md-tooltip>{{ ctrl.translation.delete }}</md-tooltip></md-button><btn-bookmark style=\"padding: 0.8rem\" entity-id=ctrl.chart.id entity-name=ctrl.chart.name entity-type=\"\'chart\'\" role=button-chart-bookmark has-permission=chart#{{ctrl.chart.id}}:read class=\"md-icon-button md-secondary text-main-color md-button md-ink-ripple\"></btn-bookmark></md-list-item><md-list-item ng-if=ctrl.hasError class=md-3-line><div class=\"w100 text-center\"><h4>Error</h4><code>{{ ctrl.error }}</code></div></md-list-item><md-list-item ng-if=ctrl.isLoading class=md-3-line><div class=\"w100 text-center\"><h4>{{ ctrl.translation.loading }}</h4><md-progress-linear id=loading-in-progress md-mode=indeterminate></md-progress-linear></div></md-list-item><md-list-item ng-if=\"!ctrl.isLoading &amp;&amp; ctrl.isEmpty\" class=md-3-line><div class=\"w100 text-center\"><h4>{{ ctrl.translation.no_records_chart }}</h4></div></md-list-item>");
$templateCache.put("app/charts/template/tree-view.html","<md-list id=chartTree><div ng-repeat=\"(key, val) in ctrl.chartTree\"><chart-groups ng-if=!key.includes(&quot;ROOT&quot;) group=val display-items=ctrl.displayItems translation=ctrl.translation></chart-groups></div><div ng-repeat=\"item in ctrl.chartTree[&quot;folder:ROOT&quot;].items\"><chart-item chart=item translation=ctrl.translation></chart-item></div></md-list>");
$templateCache.put("app/custom-reports/comments/comments.html","<div class=noprint><div layout=row layout-aling=\"center center\"><div flex class=text-right><md-button ng-click=\"ctrl.comments.printable = !ctrl.comments.printable\" ng-class=\"{ &quot;green-text&quot;:ctrl.comments.printable==true }\">{{ ctrl.translation.add_to_print }} {{ ctrl.translation.comments }}: &nbsp;<strong>{{ ctrl.comments.printable ? \'Si\' : \'No\' }}</strong><md-icon ng-class=\"{ &quot;green-text&quot;:ctrl.comments.printable==true }\">{{ ctrl.comments.printable ? \'check\' : \'close\' }}</md-icon></md-button>&nbsp;<md-button ng-click=ctrl.sendComment() class=green-text><md-icon class=green-text>comment</md-icon>&nbsp; {{ ctrl.translation.add_comment }}</md-button></div></div></div><md-progress-linear md-mode=indeterminate ng-if=ctrl.loading></md-progress-linear><div class=noprint><div id=grid-comments ui-grid-pagination ui-grid-resize-columns ui-grid-auto-resize ui-grid-move-columns ui-grid=ctrl.gridOptions class=listGrid></div></div>");
$templateCache.put("app/custom-reports/comments/dialog-comments.html","<md-dialog aria-label=\"customreport uploader dialog\" style=\"overflow: unset\"><md-dialog-content style=\"min-width: 600px; max-width: 800px; max-height: 810px; padding: 5px; overflow: unset\"><h3>{{ ctrl.translation.write_comment }}</h3><md-divider style=\"margin-bottom: 5px\"></md-divider><form id=commentsform layout=column ng-submit=ctrl.save()><md-input-container flex class=\"md-block w100\"><label>{{ ctrl.translation.comments }}</label><textarea ng-model=ctrl.comment rows=5 md-select-on-focus=\"\" requried></textarea></md-input-container></form></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button ng-click=ctrl.cancel() aria-label=\"Cancel button\" class=md-raised>{{ ctrl.translation.cancel }}</md-button><md-button type=submit form=commentsform aria-label=\"Apply filter button\" class=\"md-raised green white-text\">{{ ctrl.translation.save_changes }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/custom-reports/components/inbox-menu.html","<div style=\"top: 2px !important\" class=sticky-top><custom-reports-list></custom-reports-list></div>");
$templateCache.put("app/custom-reports/custom-reports-list/custom-reports-list.html","<div style=\"padding: 5px; font-weight: 600; height: 41px\" class=\"grey lighten-4\"><cep-icon icon=cep-rank></cep-icon>{{ ctrl.translation.custom_reports }}</div><md-divider></md-divider><div layout=row style=\"padding: 5px\" ng-repeat=\"view in ctrl.customReports track by $index\" has-permission=custom-report#{{view.id}}:read class=cep-hover><div style=\"display: flex; align-items: center; justify-content: space-between; width: 100%\"><div ng-click=ctrl.openCustomReport(view) style=\"flex: 0 0 auto\"><cep-icon icon=\"{{ view.html }}\">&nbsp;</cep-icon></div><div ng-click=ctrl.openCustomReport(view) md-truncate=\"\" style=\"flex: 1 1 0; white-space: nowrap\">{{ view.name | capitalize }}</div><md-menu style=\"flex: 0 0 auto\"><md-button ng-click=\"ctrl.openMenu($mdMenu, $event)\" style=\"width: 20px\" class=\"md-icon-button m0 p0\"><md-icon class=\"m0 p0\">more_vert</md-icon></md-button><md-menu-content width=4><md-menu-item has-permission=custom-report#{{view.id}}:read><md-button ng-click=ctrl.showCustomReportDialog(view) has-permission=custom-report#{{view.id}}:read><md-icon>edit</md-icon>Edit</md-button></md-menu-item><md-menu-item is-super-user><md-button ng-click=ctrl.editHtml(view)><md-icon>code</md-icon>Edit HTML</md-button></md-menu-item><md-menu-item has-permission=custom-report#{{view.id}}:share><md-button ng-click=ctrl.showShareCustomReportDialog(view)><md-icon>share</md-icon>Share</md-button></md-menu-item><md-menu-item has-permission=custom-report#{{view.id}}:delete><md-button ng-click=ctrl.removeCustomReport(view)><md-icon>delete</md-icon>Delete</md-button></md-menu-item><md-menu-item has-permission=custom-report#{{view.id}}:read><btn-bookmark entity-id=view.id entity-name=view.name entity-type=\"\'custom-report\'\" role=button-custom-report-bookmark extended=true></btn-bookmark></md-menu-item></md-menu-content></md-menu></div><md-tooltip md-direction=right>{{ view.description ? view.description : view.name }}</md-tooltip></div>");
$templateCache.put("app/custom-reports/dialog/dialog-custom-report.html","<md-dialog id=selector-dialog aria-label=selector-dialog style=\"width: 80vw\"><md-toolbar><div class=md-toolbar-tools><h2>Custom report</h2><span flex></span><md-button ng-click=cancel($event) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column><form name=customReportForm><md-content layout=row ng-if=ctrl.loading><md-progress-linear></md-progress-linear></md-content></form><md-tabs md-selected=ctrl.currentTab md-dynamic-height md-border-bottom><md-tab label=Data><md-content class=md-padding><md-content layout=row layout-align=\"center center\" ng-if=!ctrl.loading><div flex=50><md-input-container style=\"margin-bottom: 0\" class=w100><label for=name>Name</label><input ng-model=ctrl.name required name=name></md-input-container></div><div flex=50><md-input-container style=\"margin-bottom: 0\" class=w100><label for=orden>Orden</label><input ng-model=ctrl.weight required name=orden type=number min=0></md-input-container></div><div flex=50><md-input-container style=\"margin-bottom: 0\" class=w100><label for=html>Icon</label><input ng-model=ctrl.html name=html type=text list=icons><datalist id=icons><option ng-repeat=\"icon in ctrl.icons track by $index\" value=\"{{ icon }}\"></option></datalist></md-input-container></div><div flex=5><cep-icon icon=\"{{ ctrl.html }}\"></cep-icon></div></md-content><md-content layout=row layout-align=\"center center\" ng-if=!ctrl.loading><div flex=30><label>Type</label><md-radio-group ng-model=ctrl.reportType aria-labelledby=report-type ng-disabled=\"ctrl.mode === \'update\'\" required><md-radio-button ng-repeat=\"type in ctrl.types track by $index\" value=\"{{ type }}\">{{ type }}</md-radio-button></md-radio-group></div><div flex=70><md-input-container style=\"margin-bottom: 0\" class=w100><label for=description>Description</label><textarea ng-model=ctrl.description name=description rows=2></textarea></md-input-container></div></md-content></md-content></md-tab><md-tab label=Lookups><md-content><div ng-if=\"ctrl.reportType === \'list\'\"><ng-include src=\"\'app/custom-reports/dialog/list-report.html\'\"></ng-include></div><div ng-if=\"ctrl.reportType === \'table\'\"><ng-include src=\"\'app/custom-reports/dialog/table-report.html\'\"></ng-include></div></md-content></md-tab><md-tab label=\"Table Columns\" ng-if=\"ctrl.reportType === \'table\'\"><div ng-if=\"ctrl.tableColumns.length === 0\"><div><h6 class=text-center>No columns found</h6><p class=text-center>Please select a table and a schema to see the columns</p></div></div><div ng-if=\"ctrl.tableColumns.length &gt; 0\"><table style=\"padding: 1rem\" class=w100><thead><tr><th class=text-center>Type</th><th class=text-center>Name</th><th class=text-center>Display Name</th><th class=text-center>Schema Format</th><th class=text-center>Visible</th><th class=text-center>readonly</th></tr></thead><tbody><tr ng-repeat=\"column in ctrl.configTableColumns track by $index\"><td class=text-center>{{ column.colType }}</td><td class=text-center>{{ column.colName }}</td><td class=text-center><md-input-container style=\"margin-bottom: 0\" class=w100><input ng-model=column.displayName required name=displayName aria-label=display-name></md-input-container></td><td class=text-center><md-select ng-model=column.format name=format aria-label=format><md-option ng-value=\"\">Sin formato</md-option><md-option ng-repeat=\"format in ctrl.schemaFormats track by $index\" ng-value=format.name>{{ format.name }}</md-option></md-select></td><td class=text-center><md-checkbox ng-model=column.visible aria-label=visible></md-checkbox></td><td class=text-center><md-checkbox ng-model=column.readonly aria-label=readonly></md-checkbox></td></tr></tbody></table></div></md-tab><md-tab label=Storage><md-content><md-content layout=row layout-align=\"space-between start\" layout-padding ng-if=!ctrl.loading><div flex=50><label for=folder>Folders</label><md-autocomplete ng-disabled=ctrl.loadingFiles md-selected-item=ctrl.folderSelected md-search-text=ctrl.searchFolderText md-selected-item-change=ctrl.folderItemChange(item) md-items=\"item in ctrl.querySearch(ctrl.folders, ctrl.searchFolderText)\" md-item-text=item.name md-min-length=0 placeholder=folders input-aria-labelledby=folders required name=folder><md-item-template><span md-highlight-text=ctrl.searchFolderText md-highlight-flags=^i>{{ item.name }}</span></md-item-template></md-autocomplete></div><div flex=50><div ng-if=ctrl.folderSelected><label for=file><span ng-if=ctrl.loadingFiles>Loading files</span><span ng-if=!ctrl.loadingFiles>{{ ctrl.filesInFolderTotalRecords }} Html Templates in {{ ctrl.folderSelected.name }}</span></label><md-autocomplete ng-disabled=ctrl.loadingFiles md-selected-item=ctrl.fileSelected md-search-text=ctrl.searchFileText md-items=\"item in ctrl.querySearch(ctrl.filesInFolder, ctrl.searchFileText)\" md-item-text=item.name md-min-length=0 placeholder=\"{{ctrl.filesInFolderTotalRecords}} html Templates\" input-aria-labelledby=html-templates md-autofocus md-autoselect required name=file><md-item-template><span md-highlight-text=ctrl.searchFileText md-highlight-flags=^i>{{ item.name }}</span></md-item-template></md-autocomplete></div><div ng-if=!ctrl.folderSelected><p>Select a folder</p></div></div></md-content></md-content></md-tab></md-tabs></md-dialog-content><md-dialog-actions style=\"display: flex; justify-content: space-between\"><md-button ng-click=cancel($event) class=red>Cancel</md-button><div><md-button ng-click=\"ctrl.currentTab = ctrl.currentTab - 1\" ng-disabled=\"!ctrl.loading &amp;&amp; ctrl.currentTab == 0\" class=blue>Prev</md-button><md-button ng-click=\"ctrl.currentTab = ctrl.currentTab + 1\" ng-disabled=\"!ctrl.loading &amp;&amp; ctrl.currentTab &gt; 3\" class=blue>Next</md-button><md-button ng-click=save() ng-if=!ctrl.loading class=green>Save</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/custom-reports/dialog/dialog-edit-card-table.html","<md-dialog aria-label=\"edit data\" style=\"width: 90vw\"><md-toolbar class=main-color><div class=md-toolbar-tools><h2>Edit Data</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><form layout=column layout-wrap layout-padding><div layout=row layout-wrap layout-padding><div flex=33 ng-repeat=\"col in ctrl.tableInfo.columns track by $index\" ng-if=\"![\'id_row\'].includes(col.colName) &amp;&amp; col.visible === true\"><md-input-container class=\"w100 m0\"><div ng-switch=col.colType><label ng-if=\"![\'boolean\'].includes(col.colType)\">{{ ctrl.getName(col.colName) }}<small class=grey-text>&nbsp; ({{ col.colType }})</small></label><span ng-switch-when=boolean><md-switch ng-model=ctrl.record[col.colName] ng-required=col.notNull ng-disabled=col.readonly aria-label=\"{{ col.colName }}\" class=m0>{{ col.colName }}</md-switch></span><span ng-switch-when=date><input type=date ng-model=ctrl.record[col.colName] ng-required=col.notNull ng-disabled=col.readonly></span><span ng-switch-when=timestamp><input type=datetime-local ng-model=ctrl.record[col.colName] ng-required=col.notNull ng-disabled=col.readonly></span><span ng-switch-when=time><input type=time ng-model=ctrl.record[col.colName] ng-required=col.notNull ng-disabled=\"col.readonly \"></span><span ng-switch-when=numeric|integer|long|double ng-switch-when-separator=|><input type=number ng-model=ctrl.record[col.colName] ng-required=col.notNull ng-disabled=col.readonly></span><span ng-switch-default><input type=text ng-model=ctrl.record[col.colName] ng-required=col.notNull ng-disabled=col.readonly></span></div><div></div></md-input-container></div></div></form></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button ng-click=ctrl.cancel() class=md-raised>Cancel</md-button><md-button ng-click=ctrl.save() ng-disabled=ctrl.isloading class=md-raised>Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/custom-reports/dialog/dialog-edit-card.html","<md-dialog aria-label=\"edit data\" style=\"width: 90vw\"><md-toolbar class=main-color><div class=md-toolbar-tools><h2>Edit</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><form layout=column layout-wrap layout-padding><fieldset flex=100 ng-repeat=\"(key, props) in ctrl.groups\" class=relative><legend style=\"z-index: 10\" class=\"sticky-top white cep_text\">{{ key }}</legend><div layout=row layout-wrap layout-padding><div flex=33 ng-repeat=\"input in props\"><md-input-container ng-switch=input.type class=w100><label ng-if=\"![&quot;lookup&quot;,&quot;reference&quot;, &quot;sequential&quot;].includes(input.type)\">{{ input.displayName }} ({{ input.type }})</label><span ng-switch-when=reference><issue-reference-selector model=ctrl.data[input.key] field=ctrl.schema[input.key] key=input.key style=\"position: relative; top: -20px\" disabled></issue-reference-selector></span><span ng-switch-when=sequential><issue-sequential-selector model=ctrl.data[input.key] field=ctrl.schema[input.key] key=input.key style=\"position: relative; top: -20px\" disabled></issue-sequential-selector></span><span ng-switch-when=autoincrement><input ng-model=ctrl.data[input.key] disabled></span><span ng-switch-when=string|url ng-switch-when-separator=|><input ng-if=\"ctrl.schema[input.key].format!=&quot;textarea&quot;\" ng-model=ctrl.data[input.key] ng-disabled=input.readonly><textarea ng-if=\"ctrl.schema[input.key].format==&quot;textarea&quot;\" ng-disabled=input.readonly>{{ ctrl.data[input.key] }}</textarea></span><span ng-switch-when=integer|double|long ng-switch-when-separator=|><input type=number ng-model=ctrl.data[input.key] style=\"padding: 0 10px\" autocomplete=off ng-disabled=input.readonly></span><span ng-switch-when=date ng-class=\"{ &quot;read-only&quot;: input.readonly }\"><input mdc-datetime-picker type=text date=true seconds=false short-time=false show-todays-date=false click-outside-to-close=true placeholder=Time auto-ok=true minute-steps=1 format=DD/MM/YYYY ng-model=ctrl.data[input.key] edit-input=true show-icon=true ng-model-options=\"{ timezone: &quot;utc&quot; }\" ng-disabled=input.readonly class=md-input></span><span ng-switch-when=time ng-class=\"{ &quot;read-only&quot;: input.readonly }\"><input mdc-datetime-picker type=text date=false seconds=true short-time=false show-todays-date=false click-outside-to-close=true placeholder=Time auto-ok=true minute-steps=1 format=HH:mm:ss ng-model=ctrl.data[input.key] edit-input=true show-icon=true ng-model-options=\"{ timezone: &quot;utc&quot; }\" ng-disabled=input.readonly class=md-input></span><spam ng-switch-when=timestamp ng-class=\"{ &quot;read-only&quot;: input.readonly }\"><input mdc-datetime-picker type=text date=true short-time=false show-todays-date=false click-outside-to-close=true placeholder=Time auto-ok=true minute-steps=1 format=\"DD-MM-YYYY HH:mm:ss\" ng-model=ctrl.data[input.key] edit-input=true show-icon=true ng-model-options=\"{ timezone: &quot;utc&quot; }\" ng-disabled=input.readonly class=md-input></spam><span ng-switch-when=boolean><md-switch ng-model=ctrl.data[input.key] aria-label=\"{{ input.title }} ({{ input.type }})\" ng-disabled=input.readonly>{{ ctrl.data[input.key] ? \'true\' : \'false\' }}</md-switch></span></md-input-container></div></div></fieldset></form></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button ng-click=ctrl.cancel() class=md-raised>Cancel</md-button><md-button ng-click=ctrl.save() ng-disabled=ctrl.isloading class=md-raised>Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/custom-reports/dialog/list-report.html","<md-content layout=row layout-align=\"space-between start\" ng-if=!ctrl.loading layout-padding><div flex=50><label for=list>Lists</label><md-autocomplete md-selected-item=ctrl.listSelected md-search-text=ctrl.searchListText md-items=\"item in ctrl.querySearch(ctrl.inputLists, ctrl.searchListText)\" md-item-text=item.name md-min-length=0 placeholder=lists input-aria-labelledby=lists required name=list><md-item-template><span md-highlight-text=ctrl.searchListText md-highlight-flags=^i>{{ item.name }}</span></md-item-template></md-autocomplete></div><div flex=50><md-input-container style=\"margin-bottom: 0\" class=w100><label for=storageField>Get stored documents by field</label><md-select ng-model=ctrl.storageField name=storageField class=w100><md-option ng-repeat=\"field in ctrl.listSelected.definitions\" ng-value=field>{{ field }}</md-option></md-select></md-input-container></div></md-content>");
$templateCache.put("app/custom-reports/dialog/table-report.html","<md-content layout=row layout-align=\"space-between start\" ng-if=!ctrl.loading layout-padding><div flex=50><label for=Schemas>Schema</label><md-autocomplete md-selected-item=ctrl.tableSchemaSelected md-search-text=ctrl.searchSchemaText md-items=\"item in ctrl.querySearchSchemaTable(ctrl.tableSchemas, ctrl.searchSchemaText)\" md-item-text=item md-min-length=0 placeholder=schemas input-aria-labelledby=schemas required name=schemas md-selected-item-change=ctrl.tableSchemaSelectedChanged(item)><md-item-template><span md-highlight-text=ctrl.searchSchemaText md-highlight-flags=^i>{{ item }}</span></md-item-template></md-autocomplete></div><div flex=50><label for=tables>Table Source {{ ctrl.tablesFound }}</label><md-autocomplete md-selected-item=ctrl.tableSelected md-search-text=ctrl.searchTableText md-items=\"item in ctrl.querySearchTable(ctrl.tables, ctrl.searchTableText)\" md-item-text=item md-min-length=0 placeholder=Tables input-aria-labelledby=tables required name=tables md-selected-item-change=ctrl.tableSelectedChanged(item) ng-if=ctrl.tableSchemaSelected><md-item-template><span md-highlight-text=ctrl.searchTableText md-highlight-flags=^i>{{ item }}</span></md-item-template></md-autocomplete></div><div flex=50><md-input-container style=\"margin-bottom: 0\" class=w100><label for=storageField>Get stored documents by field</label><md-select ng-model=ctrl.storageField name=storageField ng-disabled=!ctrl.tableColumns.length aria-label=storage-field class=w100><md-option ng-repeat=\"field in ctrl.tableColumns\" ng-value=field>{{ field }}</md-option></md-select></md-input-container></div></md-content><md-content layout=row ng-if=!ctrl.loading layout-padding><div flex style=\"display: flex; flex-direction: column; flex-wrap: nowrap; justify-content: space-between\"><h6>Lookup source column {{ ctrl.tableSelected }}</h6><md-chips ng-model=ctrl.lookup.columnSource md-autocomplete-snap input-aria-label=lookup-column-source><md-autocomplete md-selected-item=ctrl.selectedItemSource md-search-text=ctrl.searchTextSource md-items=\"item in ctrl.querySearchSource(ctrl.searchTextSource)\" md-item-text=item input-aria-describedby=autocompleteTitle placeholder=search md-min-length=0 required md-no-cache><span md-highlight-text=ctrl.searchTextSource>{{ item }}</span></md-autocomplete><md-chip-template><span><strong>{{ $chip }}</strong></span></md-chip-template></md-chips></div><div flex style=\"display: flex; flex-direction: column; flex-wrap: nowrap; justify-content: space-between\"><h6>Lookup join table {{ ctrl.tablesFound }}</h6><md-select ng-model=ctrl.lookup.tableJoin name=tableJoin ng-disabled=\"!ctrl.lookup.columnSource || !ctrl.tableSelected\" aria-label=lookup-table-join ng-change=ctrl.tableJoinSelectedChanged(ctrl.lookup.tableJoin) class=w100><md-option ng-repeat=\"item in ctrl.querySearchTableJoin(ctrl.tables) track by $index\" ng-value=item>{{ item }}</md-option></md-select></div><div flex style=\"display: flex; flex-direction: column; flex-wrap: nowrap; justify-content: space-between\"><h6>Lookup join column</h6><md-chips ng-model=ctrl.lookup.columnJoin md-autocomplete-snap input-aria-label=lookup-column-join><md-autocomplete md-selected-item=ctrl.selectedItemJoin md-search-text=ctrl.searchTextJoin md-items=\"item in ctrl.querySearchJoin(ctrl.searchTextJoin)\" md-item-text=item input-aria-describedby=autocompleteTitle placeholder=search md-min-length=0 required md-no-cache><span md-highlight-text=ctrl.searchTextJoin>{{ item }}</span></md-autocomplete><md-chip-template><span><strong>{{ $chip }}</strong></span></md-chip-template></md-chips></div><div flex=15 style=\"display: flex; flex-direction: column; flex-wrap: nowrap; justify-content: space-between\" class=text-center><h6>Add Lookup</h6><md-button ng-click=ctrl.addLookup() class=\"md-raised blue white-text\"><md-icon>add</md-icon></md-button></div></md-content><md-content layout=row ng-if=!ctrl.loading layout-padding><div flex=100><h6>Lookups</h6><table class=\"table table-condensed table-bordered table-hover\"><thead><tr><th>Lookup</th><th>Delete</th></tr></thead><tbody><tr ng-repeat=\"lookup in ctrl.configLookup track by $index\"><td>{{ lookup }}</td><td><md-icon ng-click=ctrl.removeLookup($index)>delete</md-icon></td></tr></tbody></table></div></md-content>");
$templateCache.put("app/custom-reports/documents/dialog-filters.html","<md-dialog aria-label=\"customreport filters dialog\" style=\"overflow: unset\"><md-dialog-content style=\"min-width: 600px; max-width: 800px; max-height: 810px; padding: 5px; overflow: unset\"><h3>Filter by: &nbsp;<strong>{{ ctrl.column.name }}</strong></h3><md-divider style=\"margin-bottom: 5px\"></md-divider><div layout=row><md-input-container flex class=no-padding-no-margin><label>{{ ctrl.translation.condition }}</label><md-select ng-model=ctrl.predicate.operation placeholder=\"\" aria-label=\"Filter operation selection\" required><md-option ng-repeat=\"operation in ctrl.columnFilters.operations\" ng-value=operation>{{ operation }}</md-option></md-select></md-input-container><md-input-container flex=60 ng-switch=ctrl.columnFilters.component><label ng-if=\"ctrl.columnFilters.component != &quot;boolean&quot;\">{{ ctrl.translation.value }}</label><input ng-switch-when=TEXT|text|NUMBER|number|string ng-switch-when-separator=| ng-model=ctrl.predicate.value name=filterConditionValue ng-required=$parent.valueRequired autocomplete=off aria-label=\"Filter value field\"><md-select ng-switch-when=SELECTION|selection ng-switch-when-separator=| ng-model=ctrl.predicate.values ng-change=ctrl.onPredicateValuesChanges() multiple placeholder=\"\" aria-label=\"Filter value selector\" required><md-option ng-repeat=\"metadata in ctrl.columnFilters.metadata\" ng-value=metadata.key>{{ metadata.value }}</md-option></md-select><section ng-switch-when=calendar ng-switch-when-separator=|><span ng-if=\"ctrl.types[ctrl.column.type] == &quot;date&quot;\"><input mdc-datetime-picker type=text date=true seconds=false short-time=false show-todays-date=false click-outside-to-close=true placeholder=Time auto-ok=true minute-steps=1 format=DD/MM/YYYY ng-model=ctrl.predicate.value edit-input=true show-icon=true ng-model-options=\"{ timezone: &quot;utc&quot; }\" class=md-input></span><span ng-if=\"ctrl.types[ctrl.column.type] == &quot;time&quot;\"><input mdc-datetime-picker type=text date=false seconds=true short-time=false show-todays-date=false click-outside-to-close=true placeholder=Time auto-ok=true minute-steps=1 format=HH:mm:ss ng-model=ctrl.predicate.value edit-input=true show-icon=true ng-model-options=\"{ timezone: &quot;utc&quot; }\" ng-disabled=input.readonly class=md-input></span><spam ng-if=\"ctrl.types[ctrl.column.type] == &quot;timestamp&quot;\"><cep-datetimepicker date=ctrl.predicate.value format=\"DD-MM-YYYY HH:mm:ss\"></cep-datetimepicker></spam></section><div ng-switch-when=boolean style=\"position: absolute; top: -10px\"><label style=\"font-size: 0.7em; color: #5a2c7e; margin-bottom: 16px\">{{ ctrl.translation.value }}</label><md-switch ng-model=ctrl.predicate.value value=true aria-label=\"Boolean filter selector\">{{ ctrl.predicate.value ? \'true\' : \'false\' }}</md-switch></div><input ng-switch-default aria-label=\"Unhandled value field\" placeholder=\"Unhandled filter type: {{ ctrl.columnFilters.component }}\" readonly></md-input-container></div></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button ng-click=ctrl.cancel() aria-label=\"Cancel button\" class=md-raised>Cancel</md-button><md-button ng-click=ctrl.applyFilters() aria-label=\"Apply filter button\" class=\"md-raised green white-text\">{{ ctrl.translation.filter }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/custom-reports/documents/dialog-uploader.html","<md-dialog aria-label=\"customreport uploader dialog\" style=\"overflow: unset\"><md-dialog-content style=\"max-width: 800px; max-height: 810px; padding: 5px; overflow: unset\"><h3><md-icon md-font-set=material-icons ng-style=\"{ \'color\':ctrl.folder.color }\"></md-icon>folder &nbsp; {{ ctrl.upload_file }} &nbsp;<strong>{{ ctrl.storagefield }}</strong></h3><h4 ng-if=\"ctrl.folder \">{{ ctrl.accepted_extensions }}: &nbsp;<strong to-html=\"ctrl.folder.extensions | arrayBadge\"></strong></h4><md-divider style=\"margin-bottom: 5px\"></md-divider><div drop-zone nv-file-drop uploader=ctrl.uploader><section id=file-upload><div layout=row layout-wrap=\"\" layout-align=\"center end\"><div flex=100 flex-gt-sm=66><p>{{ ctrl.accepted_extensions }}</p><div ng-repeat=\"extensions in ctrl.accept track by $index \" style=\"margin: 2px\" class=badge>.{{ extensions }}</div></div><div flex=100 flex-gt-sm=33><div class=\"box-upload text-right\"><input id=file type=file name=file nv-file-select uploader=ctrl.uploader input-file multiple accept=ctrl.accept><md-button style=\"background-color: #49a847\" aria-label=\"Select file to upload button\" onclick=\"document.getElementById(\'file&quot;).click()\"><md-icon md-font-set=material-icons>cloud_upload</md-icon>&nbsp; {{ ctrl.t.load_file }}</md-button></div></div></div><div layout=row><div flex=100 ng-if=\"ctrl.uploader.queue.length == 0\" onclick=\"document.getElementById(\'file\').click()\" class=text-center><h2 class=\"grey-text text-lighten-1\"><md-icon md-font-set=material-icons class=\"grey-text text-lighten-1\">cloud_upload</md-icon></h2><h2 class=\"grey-text text-lighten-1\"><strong>{{ ctrl.t.dropFilesHere }}</strong></h2><h3 class=\"grey-text text-lighten-1\"><strong>{{ ctrl.uploader.queue.length }}</strong>&nbsp; {{ ctrl.t.filesOnQueue }}</h3></div></div><section layout=row layout-wrap=\"\"><div flex=100><md-list><md-list-item ng-repeat=\"item in ctrl.uploader.queue\" md-truncate=\"\" class=p0><p><md-icon md-font-set=material-icons md-menu-align-target>file_copy</md-icon><span ng-bind=item.file.name></span><a ng-click=item.upload() title=\"Subir archivo {{item.file.name}}\"><i class=icon-file_upload></i></a></p></md-list-item></md-list></div><div flex=100 ng-show=ctrl.uploader.isUploading><md-progress-linear md-mode=determinate value=\"{{ ctrl.uploader.progress }}\"></md-progress-linear></div><div flex=100 class=text-right><md-button type=button ng-click=ctrl.uploader.cancelAll() ng-disabled=!ctrl.uploader.isUploading aria-label=\"Cancel upload button\" class=\"md-icon-button md-warn\"><md-icon md-font-set=material-icons md-menu-align-target>close</md-icon>&nbsp;{{ ctrl.t.cancel_all }}</md-button><md-button type=button ng-click=ctrl.uploader.clearQueue() ng-disabled=!ctrl.uploader.queue.length aria-label=\"Clear queue button\" class=\"md-icon-button md-warn\"><md-icon md-font-set=material-icons md-menu-align-target>delete</md-icon>&nbsp;{{ ctrl.t.clean_queue }}</md-button></div></section></section></div></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button ng-click=ctrl.cancel() aria-label=\"Cancel button\" class=md-raised>Cancel</md-button><md-button ng-click=ctrl.startUpload() ng-disabled=!ctrl.uploader.getNotUploadedItems().length aria-label=\"Apply filter button\" class=\"md-raised green white-text\"><md-icon md-font-set=material-icons md-menu-align-target>don</md-icon>&nbsp;{{ ctrl.t.load_all }} & {{ ctrl.translation.save_changes }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/custom-reports/documents/documents.html","<div class=noprint><div layout=row layout-aling=\"center center\"><div flex class=text-right><md-button ng-click=\"ctrl.documents.printable = !ctrl.documents.printable\" ng-class=\"{ &quot;green-text&quot;:ctrl.documents.printable==true }\">{{ ctrl.translation.add_to_print }} {{ ctrl.translation.documents }}: &nbsp;<strong>{{ ctrl.documents.printable ? ctrl.translation.yes : ctrl.translation.no }}</strong><md-icon ng-class=\"{ &quot;green-text&quot;:ctrl.documents.printable==true }\">{{ ctrl.documents.printable ? \'check\' : \'close\' }}</md-icon></md-button><md-button ng-click=\"ctrl.documents.attach = !ctrl.documents.attach\" ng-class=\"{ &quot;green-text&quot;:ctrl.documents.attach==true }\">{{ ctrl.translation.export }} {{ ctrl.translation.documents }} .pdf: &nbsp;<strong>{{ ctrl.documents.attach ? ctrl.translation.yes : ctrl.translation.no }}</strong><md-icon ng-class=\"{ &quot;green-text&quot;:ctrl.documents.attach==true }\">{{ ctrl.documents.attach ? \'check\' : \'close\' }}</md-icon></md-button>&nbsp;<md-button ng-click=ctrl.uploadFilesDialog() class=green-text><md-icon class=green-text>drive_folder_upload</md-icon>{{ ctrl.translation.upload_files }}</md-button></div></div></div><md-progress-linear md-mode=indeterminate ng-if=ctrl.loading></md-progress-linear><div class=noprint><div id=grid-documents ui-grid-pagination ui-grid-resize-columns ui-grid-auto-resize ui-grid-move-columns ui-grid=ctrl.gridOptions class=listGrid></div></div>");
$templateCache.put("app/custom-reports/html-client-card/html-client-card.html","<div layout=column layout-align=\"center center\" layout-padding ng-if=ctrl.loading><p>{{ ctrl.translation.loading }}</p><md-progress-linear></md-progress-linear></div><section><div class=\"html-content relative\"><div id=custom-report-tamplate-container ng-show=!ctrl.loading><div id=customHtmlTemplate style=\"padding: 1rem\"></div></div><md-button ng-click=ctrl.editRow() ng-if=!ctrl.loading style=\"position: absolute; right: 10px; bottom: 60px\" class=\"md-fab md-primary md-mini hide-in-preview noprint\"><md-icon>edit</md-icon><md-tooltip md-z-index=9999 md-delay=200 class=noprint>{{ ctrl.translation.edit }}</md-tooltip></md-button><md-button ng-click=ctrl.exportToPdf() ng-if=\"!ctrl.loading \" style=\"position: absolute; right: 10px; bottom: 10px\" class=\"md-fab md-primary md-mini hide-in-preview noprint\"><md-icon>print</md-icon><md-tooltip md-z-index=9999 md-delay=200 class=noprint>{{ ctrl.translation.print }}</md-tooltip></md-button></div><div ng-if=\"ctrl.preview!=\'true\' &amp;&amp; !ctrl.loading &amp;&amp; !ctrl.loadingTabs\" class=\"grid-list hide-in-preview\"><md-tabs md-dynamic-height md-stretch-tabs=always md-autoselect class=noprint><md-tab ng-repeat=\"list in ctrl.linkedLists track by $index\" ng-if=\"list.gridOptions.totalRecords &gt; 0\" ng-click=ctrl.onTabSelected($index) md-tab-class=\"black-text blue bold-text lighten-4\" class=p0><md-tab-label>{{ list.displayName || list.key }} - &nbsp;<span ng-if=\"ctrl.filters.predicates.length == 0\">{{ list.gridOptions.totalRecords }}</span><span ng-if=\"ctrl.filters.predicates.length &gt; 0\">{{ list.data.length }} / {{ list.gridOptions.totalRecords }}</span></md-tab-label><md-tab-body><likend-list ng-if=\"ctrl.customReport.tipo === \'list\'\" list=list filters=ctrl.filters></likend-list><likend-table ng-if=\"ctrl.customReport.tipo === \'table\'\" list=list filters=ctrl.filters></likend-table></md-tab-body></md-tab><md-tab ng-click=\"ctrl.onTabSelected(\'docs\')\" md-tab-class=\"black-text green bold-text lighten-4\" class=p0><md-tab-label>{{ ctrl.translation.documents }} - {{ ctrl.documents.totalRecords }}</md-tab-label><md-tab-body><documents-list documents=ctrl.documents></documents-list></md-tab-body></md-tab><md-tab ng-click=\"ctrl.onTabSelected(\'comments\')\" md-tab-class=\"black-text yellow bold-text lighten-4\" class=p0><md-tab-label>{{ ctrl.translation.comments }} - {{ ctrl.comments.totalRecords }}</md-tab-label><md-tab-body><comments-list comments=ctrl.comments></comments-list></md-tab-body></md-tab></md-tabs></div><section class=\"print-section hide-in-preview\"><div ng-if=\"ctrl.customReport.tipo === \'list\'\"><md-content ng-repeat=\"list in ctrl.linkedLists track by $index\" ng-if=\"list.printable &amp;&amp; list.gridOptions.totalRecords &gt; 0\" ng-class=\"{ \'noprint\': list.printable == false }\" class=\"w100 hide-in-preview show-in-print\"><table class=\"table printtable w100\"><thead class=\"blue-grey white-text\"><tr><th colspan=\"{{ list.schemaLength }}\">{{ list.displayName || list.key }}</th></tr><tr><th ng-repeat=\"(key, props) in list.schema\" ng-if=props.visible>{{ props.displayName || key }}</th></tr></thead><tbody><tr ng-if=\"list.data.length == 0\"><td>sin datos</td></tr><tr ng-repeat=\"item in list.data\"><td style=\"word-break: break-word\" ng-repeat=\"(key, props) in list.schema\" ng-if=props.visible><span ng-if=\"props.type == \'boolean\'\">{{ item[key] ? \"true\" : \"false\" }}</span><span ng-if=\"props.type != \'boolean\'\">{{ props.pk ? item[\"#\" + key] : item[key] }}</span></td></tr></tbody></table></md-content></div><div ng-if=\"ctrl.customReport.tipo === \'table\'\"><md-content ng-repeat=\"list in ctrl.linkedLists track by $index\" ng-if=\"list.printable &amp;&amp; list.gridOptions.totalRecords &gt; 0\" ng-class=\"{ \'noprint\': list.printable == false }\" class=\"w100 hide-in-preview show-in-print\"><table class=\"table printtable w100\"><thead class=\"blue-grey white-text\"><tr><th colspan=\"{{ list.columns.length }}\">{{ list.displayName || list.key }} - {{ list.fieldName }}</th></tr><tr><th ng-repeat=\"col in list.columns track by $index\">{{ col.colName }}</th></tr></thead><tbody><tr ng-if=\"list.gridOptions.data.length == 0\"><td>sin datos</td></tr><tr ng-repeat=\"item in list.gridOptions.data track by $index\"><td style=\"word-break: break-word\" ng-repeat=\"col in list.columns track by $index\"><span ng-if=\"col.colType == \'boolean\'\">{{ item[col.colName] ? \"true\" : \"false\" }}</span><span ng-if=\"col.colType == \'date\'\">{{ item[col.colName] | asDate }}</span><span ng-if=\"col.colType == \'timestamp\'\">{{ item[col.colName] | asDateHour }}</span><span ng-if=\"col.colType == \'time\'\">{{ item[col.colName] }}</span><span ng-if=\"![\'boolean\',\'date\',\'timestamp\',\'time\'].includes(col.colType)\">{{ item[col.colName] }}</span></td></tr></tbody></table></md-content></div><md-content ng-if=\"ctrl.documents.printable &amp;&amp; ctrl.documents.data.length &gt; 0\" ng-class=\"{ \'noprint\': ctrl.documents.printable == false }\" class=\"w100 hide-in-preview show-in-print\"><table class=\"table printtable w100\"><thead class=\"blue-grey white-text\"><tr><th colspan=\"{{ ctrl.documents.data.length }}\">{{ ctrl.translation.documents }}</th></tr><tr><th ng-repeat=\"col in ctrl.documents.columnDefs\">{{ col.displayName }}</th></tr></thead><tbody><tr ng-if=\"ctrl.documents.data.length == 0\"><td>sin documentos</td></tr><tr ng-repeat=\"item in ctrl.documents.data\"><td style=\"word-break: break-word\" ng-repeat=\"col in ctrl.documents.columnDefs\">{{ item[col.field] }}</td></tr></tbody></table></md-content><md-content ng-if=\"ctrl.comments.printable &amp;&amp; ctrl.comments.data.length &gt; 0\" ng-class=\"{ \'noprint\': ctrl.comments.printable == false }\" class=\"w100 hide-in-preview show-in-print\"><table class=\"table printtable w100\"><thead class=\"blue-grey white-text\"><tr><th colspan=\"{{ ctrl.comments.data.length }}\">{{ ctrl.translation.comments }}</th></tr><tr><th ng-repeat=\"col in ctrl.comments.columnDefs\">{{ col.displayName }}</th></tr></thead><tbody><tr ng-if=\"ctrl.comments.data.length == 0\"><td>sin comentarios</td></tr><tr ng-repeat=\"item in ctrl.comments.data\"><td style=\"word-break: break-word\" ng-repeat=\"col in ctrl.comments.columnDefs\">{{ item[col.field] }}</td></tr></tbody></table></md-content></section></section>");
$templateCache.put("app/custom-reports/html-template/html-template.html","<div layout=row layout-align=\"space-between center\" class=white><div><md-menu-bar><md-menu><button ng-click=$mdMenu.open()>File</button><md-menu-content><md-menu-item><md-button ng-click=ctrl.saveFile()>Save</md-button></md-menu-item><md-menu-item><md-button ng-click=ctrl.downloadFile()>Download</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=ctrl.exitEditor()>Exit</md-button></md-menu-item></md-menu-content></md-menu><md-menu><button ng-click=$mdMenu.open()>View</button><md-menu-content><md-menu-item><md-button ng-click=ctrl.toogleEditor()>Toggle Editor {{ ctrl.showEditor ? \'Off\' : \'On\' }}</md-button></md-menu-item></md-menu-content></md-menu><md-menu><button ng-click=$mdMenu.open()>Layouts</button><md-menu-content><md-menu-item ng-repeat=\"(key, layout) in ctrl.htmlLayouts track by $index\"><md-button ng-click=ctrl.useLayout(layout)>{{ key }}</md-button></md-menu-item></md-menu-content></md-menu><md-menu ng-if=\"ctrl.fields.length &gt; 0\"><button ng-click=$mdMenu.open()>Schema</button><md-menu-content><md-menu-item ng-repeat=\"schema in ctrl.fields track by $index\"><md-button ng-click=ctrl.insertSchema(schema)>{{ schema.displayName || schema.colName }}</md-button></md-menu-item></md-menu-content></md-menu><md-menu ng-if=\"ctrl.fields.length &gt; 0\"><button ng-click=$mdMenu.open()>Add</button><md-menu-content><md-menu-item ng-repeat=\"comp in ctrl.components track by $index\"><md-button ng-click=ctrl.insertComponent(comp)>{{ comp.name }}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div><div layout=row layout-align=\"start center\" layout-gap=10px><span style=\"font-weight: bold; padding: 0 5px\">Custom Report: {{ ctrl.customReport.name || \'New Report\' }}</span>- <span style=\"font-weight: bold; padding: 0 5px\">{{ ctrl.customReport.folder.name || \'No Folder\' }}</span>/<span style=\"font-weight: bold; padding: 0 5px\">{{ ctrl.customReport.file.name || \'New Report\' }}</span></div><div><md-button>{{ ctrl.hasChanges ? \'has Changes\' : \'no Changes\' }}</md-button></div></div><md-progress-linear md-mode=indeterminate ng-if=ctrl.loading></md-progress-linear><section class=html-template-editor><div ng-if=ctrl.showEditor class=html-code-editor><div ng-model=ctrl.htmlInput style=\"height: 80vh; width: 100%; border: 1px solid #ddd\" ui-ace=\"{ useWrapMode : true, showGutter: true, theme:\'twilight\', mode: \'html\' ,onLoad : editorLoaded, onChange: ctrl.updateHtmlOutput }\"></div></div><div id=html-output class=html-code-preview></div></section>");
$templateCache.put("app/custom-reports/linked-list/dialog-filters.html","<md-dialog aria-label=\"Issues filters dialog\" style=\"overflow: unset\"><md-dialog-content style=\"min-width: 600px; max-width: 800px; max-height: 810px; padding: 5px; overflow: unset\"><b style=\"font-weight: 600\">Filter by: {{ ctrl.column.name }}</b><md-divider style=\"margin-bottom: 5px\"></md-divider><div layout=row><md-input-container flex class=no-padding-no-margin><label>{{ ctrl.translation.condition }}</label><md-select ng-model=ctrl.predicate.operation placeholder=\"\" aria-label=\"Filter operation selection\" required><md-option ng-repeat=\"operation in ctrl.columnFilters.operations\" ng-value=operation>{{ ctrl.translation[operation] }}</md-option></md-select></md-input-container><md-input-container flex=60 ng-switch=ctrl.columnFilters.component><label ng-if=\"ctrl.columnFilters.component != &quot;boolean&quot;\">{{ ctrl.translation.value }}</label><input ng-switch-when=TEXT|text|NUMBER|number|string ng-switch-when-separator=| ng-model=ctrl.predicate.value name=filterConditionValue ng-required=$parent.valueRequired autocomplete=off aria-label=\"Filter value field\"><md-select ng-switch-when=SELECTION|selection ng-switch-when-separator=| ng-model=ctrl.predicate.values ng-change=ctrl.onPredicateValuesChanges() multiple placeholder=\"\" aria-label=\"Filter value selector\" required><md-option ng-repeat=\"metadata in ctrl.columnFilters.metadata\" ng-value=metadata.key>{{ metadata.value }}</md-option></md-select><section ng-switch-when=calendar ng-switch-when-separator=|><span ng-if=\"ctrl.types[ctrl.column.type] == &quot;date&quot;\"><input mdc-datetime-picker type=text date=true seconds=false short-time=false show-todays-date=false click-outside-to-close=true placeholder=date auto-ok=true minute-steps=1 format=DD/MM/YYYY ng-model=ctrl.predicate.value edit-input=true show-icon=true ng-model-options=\"{ timezone: &quot;utc&quot; }\" class=md-input></span><span ng-if=\"ctrl.types[ctrl.column.type] == &quot;time&quot;\"><input mdc-datetime-picker type=text date=false seconds=true short-time=false show-todays-date=false click-outside-to-close=true placeholder=Time auto-ok=true minute-steps=1 format=HH:mm:ss ng-model=ctrl.predicate.value edit-input=true show-icon=true ng-model-options=\"{ timezone: &quot;utc&quot; }\" class=md-input></span><spam ng-if=\"ctrl.types[ctrl.column.type] == &quot;timestamp&quot;\"><cep-datetimepicker date=ctrl.predicate.value format=\"DD-MM-YYYY HH:mm:ss\"></cep-datetimepicker></spam></section><div ng-switch-when=boolean style=\"position: absolute; top: -10px\"><label style=\"font-size: 0.7em; color: #5a2c7e; margin-bottom: 16px\">{{ ctrl.translation.value }}</label><md-switch ng-model=ctrl.predicate.value value=true aria-label=\"Boolean filter selector\">{{ ctrl.predicate.value ? \'true\' : \'false\' }}</md-switch></div><input ng-switch-default aria-label=\"Unhandled value field\" placeholder=\"Unhandled filter type: {{ ctrl.columnFilters.component }}\" readonly></md-input-container></div></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button ng-click=ctrl.cancel() aria-label=\"Cancel button\" class=md-raised>Cancel</md-button><md-button ng-click=ctrl.applyFilters() aria-label=\"Apply filter button\" class=\"md-raised green white-text\">{{ ctrl.translation.filter }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/custom-reports/linked-list/linked-list.html","<div class=noprint><div layout=row layout-aling=\"center center\"><div flex style=\"margin-top: 8px; margin-left: 8px\"><div ng-if=ctrl.showFilters ng-repeat=\"predicate in ctrl.filters.predicates track by $index\" style=\"margin-right: 8px\" ng-click=ctrl.removePredicate($index) class=\"badge grey lighten-3 black-text\">{{ predicate.label || predicate.fieldName }}&nbsp; {{ ctrl.translation[predicate.operation] }} :&nbsp;<span ng-if=\"predicate.operation == &quot;BETWEEN&quot;\">{{ predicate.values }}</span><span ng-if=\"predicate.operation != &quot;BETWEEN&quot;\"><span ng-if=\"predicate.type == &quot;calendar&quot;\">{{ predicate.value | asDate }}</span><span ng-if=\"predicate.type != &quot;calendar&quot;\">{{ predicate.value }}</span></span><md-icon>close</md-icon></div></div><div flex=20 class=text-right><md-button ng-click=\"ctrl.list.printable = !ctrl.list.printable\" ng-class=\"{ &quot;green-text&quot;:ctrl.list.printable==true }\">{{ ctrl.translation.print }} {{ ctrl.translation.lists }}: &nbsp;<strong>{{ ctrl.list.printable ? \'Si\' : \'No\' }}</strong><md-icon ng-class=\"{ &quot;green-text&quot;:ctrl.list.printable==true }\">{{ ctrl.list.printable ? \'check\' : \'close\' }}</md-icon></md-button>&nbsp;</div></div></div><md-progress-linear md-mode=indeterminate ng-if=\"ctrl.loading &amp;&amp; ctrl.gridOptions.data.length == 0\"></md-progress-linear><strong style=\"padding: 12px\" ng-if=\"!ctrl.loading &amp;&amp; ctrl.gridOptions.data.length == 0\" class=\"w100 noprint\">Sin data</strong><div class=noprint><div id=grid-{{list.listId}}-{{list.key}} ui-grid-pagination ui-grid-resize-columns ui-grid-auto-resize ui-grid-move-columns ui-grid=ctrl.gridOptions class=listGrid></div></div>");
$templateCache.put("app/custom-reports/linked-table/dialog-filters.html","<md-dialog aria-label=\"Issues filters dialog\" style=\"overflow: unset\"><md-dialog-content style=\"min-width: 600px; max-width: 800px; max-height: 810px; padding: 5px; overflow: unset\"><b style=\"font-weight: 600\">Filter by: {{ ctrl.column.name }}</b><md-divider style=\"margin-bottom: 5px\"></md-divider><div layout=row><md-input-container flex class=no-padding-no-margin><label>{{ ctrl.translation.condition }}</label><md-select ng-model=ctrl.predicate.operation placeholder=\"\" aria-label=\"Filter operation selection\" required><md-option ng-repeat=\"operation in ctrl.columnFilters.operations\" ng-value=operation>{{ ctrl.translation[operation] }}</md-option></md-select></md-input-container><md-input-container flex=60 ng-switch=ctrl.columnFilters.component><label ng-if=\"ctrl.columnFilters.component != &quot;boolean&quot;\">{{ ctrl.translation.value }}</label><input ng-switch-when=TEXT|text|NUMBER|number|string ng-switch-when-separator=| ng-model=ctrl.predicate.value name=filterConditionValue ng-required=$parent.valueRequired autocomplete=off aria-label=\"Filter value field\"><md-select ng-switch-when=SELECTION|selection ng-switch-when-separator=| ng-model=ctrl.predicate.values ng-change=ctrl.onPredicateValuesChanges() multiple placeholder=\"\" aria-label=\"Filter value selector\" required><md-option ng-repeat=\"metadata in ctrl.columnFilters.metadata\" ng-value=metadata.key>{{ metadata.value }}</md-option></md-select><section ng-switch-when=calendar ng-switch-when-separator=|><span ng-if=\"ctrl.types[ctrl.column.type] == &quot;date&quot;\"><input mdc-datetime-picker type=text date=true seconds=false short-time=false show-todays-date=false click-outside-to-close=true placeholder=date auto-ok=true minute-steps=1 format=DD/MM/YYYY ng-model=ctrl.predicate.value edit-input=true show-icon=true ng-model-options=\"{ timezone: &quot;utc&quot; }\" class=md-input></span><span ng-if=\"ctrl.types[ctrl.column.type] == &quot;time&quot;\"><input mdc-datetime-picker type=text date=false seconds=true short-time=false show-todays-date=false click-outside-to-close=true placeholder=Time auto-ok=true minute-steps=1 format=HH:mm:ss ng-model=ctrl.predicate.value edit-input=true show-icon=true ng-model-options=\"{ timezone: &quot;utc&quot; }\" class=md-input></span><spam ng-if=\"ctrl.types[ctrl.column.type] == &quot;timestamp&quot;\"><cep-datetimepicker date=ctrl.predicate.value format=\"DD-MM-YYYY HH:mm:ss\"></cep-datetimepicker></spam></section><div ng-switch-when=boolean style=\"position: absolute; top: -10px\"><label style=\"font-size: 0.7em; color: #5a2c7e; margin-bottom: 16px\">{{ ctrl.translation.value }}</label><md-switch ng-model=ctrl.predicate.value value=true aria-label=\"Boolean filter selector\">{{ ctrl.predicate.value ? \'true\' : \'false\' }}</md-switch></div><input ng-switch-default aria-label=\"Unhandled value field\" placeholder=\"Unhandled filter type: {{ ctrl.columnFilters.component }}\" readonly></md-input-container></div></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button ng-click=ctrl.cancel() aria-label=\"Cancel button\" class=md-raised>Cancel</md-button><md-button ng-click=ctrl.applyFilters() aria-label=\"Apply filter button\" class=\"md-raised green white-text\">{{ ctrl.translation.filter }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/custom-reports/linked-table/linked-table.html","<div class=noprint><div layout=row layout-aling=\"center center\"><div flex style=\"margin-top: 8px; margin-left: 8px\"><div ng-if=ctrl.showFilters ng-repeat=\"predicate in ctrl.filters.predicates track by $index\" style=\"margin-right: 8px\" ng-click=ctrl.removePredicate($index) class=\"badge grey lighten-3 black-text\">{{ predicate.label || predicate.fieldName }}&nbsp; {{ ctrl.translation[predicate.operation] }} :&nbsp;<span ng-if=\"predicate.operation == &quot;BETWEEN&quot;\">{{ predicate.values }}</span><span ng-if=\"predicate.operation != &quot;BETWEEN&quot;\"><span ng-if=\"predicate.type == &quot;calendar&quot;\">{{ predicate.value | asDate }}</span><span ng-if=\"predicate.type != &quot;calendar&quot;\">{{ predicate.value }}</span></span><md-icon>close</md-icon></div></div><div flex=20 class=text-right><md-button ng-click=\"ctrl.list.printable = !ctrl.list.printable\" ng-class=\"{ &quot;green-text&quot;:ctrl.list.printable==true }\">{{ ctrl.translation.print }} {{ ctrl.translation.lists }}: &nbsp;<strong>{{ ctrl.list.printable ? \'Si\' : \'No\' }}</strong><md-icon ng-class=\"{ &quot;green-text&quot;:ctrl.list.printable==true }\">{{ ctrl.list.printable ? \'check\' : \'close\' }}</md-icon></md-button>&nbsp;</div></div></div><md-progress-linear md-mode=indeterminate ng-if=\"ctrl.loading &amp;&amp; ctrl.gridOptions.data.length == 0\"></md-progress-linear><strong style=\"padding: 12px\" ng-if=\"!ctrl.loading &amp;&amp; ctrl.gridOptions.data.length == 0\" class=\"w100 noprint\">Sin data</strong><div class=noprint><div id=grid-{{list.listId}}-{{list.key}} ui-grid-pagination ui-grid-resize-columns ui-grid-auto-resize ui-grid-move-columns ui-grid=ctrl.gridOptions class=listGrid></div></div>");
$templateCache.put("app/custom-reports/list/list-card.html","<md-card id=InputListReader ng-cloak class=m0><md-content class=content_blocks><div><md-toolbar class=md-menu-toolbar><div layout=row><md-toolbar-filler id=btnInputListonGoBack layout layout-align=\"center center\" ng-click=ctrl.getBack() class=main-color><md-tooltip md-z-index=9999 md-delay=200>{{ translation.get_back }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>table_rows</md-icon></md-toolbar-filler><div layout=row layout-align=\"center center\" class=w100><div flex=70><h2 class=md-toolbar-tools><div class=md-title>{{ ctrl.list.name }}</div></h2><ng-include src=&quot;app/custom-reports/table-card/table-list-main-menu.html&quot;></ng-include></div><div flex></div></div></div></md-toolbar></div></md-content><md-divider></md-divider><section><md-content ng-if=ctrl.tableIsLoading><md-progress-linear></md-progress-linear></md-content><div layout=row class=relative><button ng-click=\"ctrl.showSideBar = !ctrl.showSideBar\" class=btn-toggle-html-card><md-icon md-font-set=material-icons md-menu-align-target>{{ ctrl.showSideBar ? \'chevron_left\' : \'chevron_right\' }}</md-icon></button><section flex=\"{{ ctrl.showSideBar ? \'70\' : \'100\' }}\"><div ui-grid-pagination ui-grid-resize-columns ui-grid-auto-resize ui-grid=ctrl.gridOptions style=\"height: 70vh\" class=listGrid></div></section><aside flex=30 ng-if=ctrl.showSideBar class=aside-html-card><div ng-if=ctrl.hoveredRow><html-client-card preview=true row=ctrl.hoveredRow schema=ctrl.schema custom-report=ctrl.customReport html=ctrl.html schemas-formats=ctrl.schemasFormats columns=ctrl.columns class=cr-preview><pre>{{ ctrl.html }}</pre></html-client-card></div></aside></div></section></md-card>");
$templateCache.put("app/custom-reports/list/list-list-main-menu.html","<md-menu-bar id=table-list-main-menu-bar layout=row><md-menu><button ng-click=$mdMenu.open()>{{ translation.tools }}</button><md-menu-content width=3><md-menu-item><md-button ng-click=ctrl.unFilterData()>{{ translation.remove_filters }}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=ctrl.exportList(&quot;xlsx&quot;)>{{ translation.export }} (.csv .xlsx)</md-button></md-menu-item></md-menu-content></md-menu><button ng-if=ctrl.list.updatingData style=\"color: orange\"><span>{{ translation.updating_list_msg }}</span></button><div flex></div><section layout=row style=\"padding: 5px\"><div ng-repeat=\"(key, predicate) in ctrl.filters.predicates\" style=\"margin-right: 5px; font-size: 0.7em; line-height: 2em\" class=\"text-center cep-badge\">{{ predicate.label }} {{ predicate.operation | lowercase }} &nbsp;<span ng-if=\"predicate.value != null\"><b ng-switch=\"\" on=predicate.label><span ng-switch-when=data|time ng-switch-when-separator=|>{{ ctrl.parsePredicateValue(predicate) | asDate }}</span><span ng-switch-when=timestamp ng-switch-when-separator=|>{{ ctrl.parsePredicateValue(predicate) | asDateHour }}</span><span ng-switch-default=\"\">{{ ctrl.parsePredicateValue(predicate) }}</span></b></span><span ng-if=\"predicate.value == null\">{{ predicate.valuesLabels.join(\', \') }}</span>&nbsp;<div style=\"margin-left: 5px\" ng-click=ctrl.removeFilter(key) class=\"fa fa-times\"></div></div><div ng-if=ctrl.isFiltered ng-click=ctrl.unFilterData() style=\"margin-right: 5px; font-size: 0.7em; line-height: 2em\" class=\"text-center cep-badge\">Remove filters</div></section></md-menu-bar>");
$templateCache.put("app/custom-reports/table/table-card.html","<md-card id=InputListReader ng-cloak class=m0><md-content class=content_blocks><div><md-toolbar class=md-menu-toolbar><div layout=row><md-toolbar-filler id=btnInputListonGoBack layout layout-align=\"center center\" ng-click=ctrl.getBack() class=main-color><md-tooltip md-z-index=9999 md-delay=200>{{ translation.get_back }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>table_rows</md-icon></md-toolbar-filler><div layout=row layout-align=\"center center\" class=w100><div flex=70><h2 class=md-toolbar-tools><div class=md-title>{{ ctrl.table.tableName }}</div></h2><ng-include src=\"\'app/custom-reports/table-card/table-list-main-menu.html\'\"></ng-include></div><div flex></div></div></div></md-toolbar></div></md-content><md-divider></md-divider><section><md-content ng-if=ctrl.tableIsLoading><md-progress-linear></md-progress-linear></md-content><div layout=row class=relative><button ng-click=\"ctrl.showSideBar = !ctrl.showSideBar\" class=btn-toggle-html-card><md-icon md-font-set=material-icons md-menu-align-target>{{ ctrl.showSideBar ? \'chevron_left\' : \'chevron_right\' }}</md-icon></button><section flex=\"{{ ctrl.showSideBar ? \'70\' : \'100\' }}\"><div ui-grid-pagination ui-grid-resize-columns ui-grid-auto-resize ui-grid=ctrl.gridOptions style=\"height: 70vh\" class=listGrid></div></section><aside flex=30 ng-if=ctrl.showSideBar class=aside-html-card><div ng-if=ctrl.hoveredRow><html-client-card preview=true row=ctrl.hoveredRow schema=ctrl.schema custom-report=ctrl.customReport html=ctrl.html schemas-formats=ctrl.schemasFormats columns=ctrl.columns class=cr-preview><pre>{{ ctrl.html }}</pre></html-client-card></div></aside></div></section></md-card>");
$templateCache.put("app/custom-reports/table/table-list-main-menu.html","<md-menu-bar id=table-list-main-menu-bar layout=row><md-menu><button ng-click=$mdMenu.open()>{{ translation.tools }}</button><md-menu-content width=3><md-menu-item><md-button ng-click=ctrl.unFilterData()>{{ translation.remove_filters }}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=ctrl.exportList(&quot;xlsx&quot;)>{{ translation.export }} (.csv .xlsx)</md-button></md-menu-item></md-menu-content></md-menu><button ng-if=ctrl.list.updatingData style=\"color: orange\"><span>{{ translation.updating_list_msg }}</span></button><div flex></div><section layout=row style=\"padding: 5px\"><div ng-repeat=\"(key, predicate) in ctrl.filters.predicates\" style=\"margin-right: 5px; font-size: 0.7em; line-height: 2em\" class=\"text-center cep-badge\">{{ predicate.label }} {{ predicate.operation | lowercase }} &nbsp;<span ng-if=\"predicate.value != null\"><b ng-switch=\"\" on=predicate.label><span ng-switch-when=data|time ng-switch-when-separator=|>{{ ctrl.parsePredicateValue(predicate) | asDate }}</span><span ng-switch-when=timestamp ng-switch-when-separator=|>{{ ctrl.parsePredicateValue(predicate) | asDateHour }}</span><span ng-switch-default=\"\">{{ ctrl.parsePredicateValue(predicate) }}</span></b></span><span ng-if=\"predicate.value == null\">{{ predicate.valuesLabels.join(\', \') }}</span>&nbsp;<div style=\"margin-left: 5px\" ng-click=ctrl.removeFilter(key) class=\"fa fa-times\"></div></div><div ng-if=ctrl.isFiltered ng-click=ctrl.unFilterData() style=\"margin-right: 5px; font-size: 0.7em; line-height: 2em\" class=\"text-center cep-badge\">Remove filters</div></section></md-menu-bar>");
$templateCache.put("app/custom-reports/table-card/table-card.html","<md-card id=InputListReader ng-cloak class=m0><md-content class=content_blocks><div><md-toolbar class=md-menu-toolbar><div layout=row><md-toolbar-filler id=btnInputListonGoBack layout layout-align=\"center center\" ng-click=ctrl.getBack() class=main-color><md-tooltip md-z-index=9999 md-delay=200>{{ translation.get_back }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>table_rows</md-icon></md-toolbar-filler><div layout=row layout-align=\"center center\" class=w100><div flex=70><h2 class=md-toolbar-tools><div class=md-title>{{ ctrl.list.name }}</div></h2><ng-include src=&quot;app/custom-reports/table-card/table-list-main-menu.html&quot;></ng-include></div><div flex></div></div></div></md-toolbar></div></md-content><md-divider></md-divider><section><md-content ng-if=ctrl.tableIsLoading><md-progress-linear></md-progress-linear></md-content><div layout=row><section flex=70><div ui-grid-pagination ui-grid-resize-columns ui-grid-auto-resize ui-grid=ctrl.gridOptions style=\"height: 70vh\" class=listGrid></div></section><aside flex=30 ng-if=ctrl.hoveredRow><button><md-icon md-font-set=material-icons md-menu-align-target>chevron_left</md-icon></button><html-client-card preview=true row=ctrl.hoveredRow schema=ctrl.schema custom-report=ctrl.customReport html=ctrl.html schemas-formats=ctrl.schemasFormats columns=ctrl.columns class=cr-preview><pre>{{ctrl.html}}</pre></html-client-card></aside></div></section></md-card>");
$templateCache.put("app/custom-reports/table-card/table-list-main-menu.html","<md-menu-bar id=table-list-main-menu-bar layout=row><md-menu><button ng-click=$mdMenu.open()>{{ translation.tools }}</button><md-menu-content width=3><md-menu-item><md-button ng-click=ctrl.unFilterData()>{{ translation.remove_filters }}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=ctrl.exportList(&quot;xlsx&quot;)>{{ translation.export }} (.csv .xlsx)</md-button></md-menu-item></md-menu-content></md-menu><button ng-if=ctrl.list.updatingData style=\"color: orange\"><span>{{ translation.updating_list_msg }}</span></button><div flex></div><section layout=row style=\"padding: 5px\"><div ng-repeat=\"(key, predicate) in ctrl.filters.predicates\" style=\"margin-right: 5px; font-size: 0.7em; line-height: 2em\" class=\"text-center cep-badge\">{{ predicate.fieldName }} {{ predicate.operation | lowercase }} &nbsp; {{ predicate.value }}<div style=\"margin-left: 5px\" ng-click=ctrl.removeFilter(key) class=\"fa fa-times\"></div></div><div ng-if=ctrl.isFiltered ng-click=ctrl.unFilterData() style=\"margin-right: 5px; font-size: 0.7em; line-height: 2em\" class=\"text-center cep-badge\">Remove filters</div></section></md-menu-bar>");
$templateCache.put("app/dashboard/includes/main.html","<section id=inbox , ng-show=ctrl.isTabSet(&quot;index&quot;)><md-content layout=column><section layout=row layout-wrap layout-align=\"start stretch\" ng-if=loading class=w100><div flex=33 ng-repeat=\"i in [1, 2, 3, 4, 5, 6]\"><div style=\"padding: 1rem\" class=skeleton><div style=\"height: 240px; margin: 0\" class=\"sk-base sk-input\"></div></div></div></section><section ui-sortable=sortableOptionsList ng-model=ctrl.issueTypes ng-if=\"!loading &amp;&amp; ctrl.issueTypes.length &gt; 0\" class=\"w100 ng-grid grid-x3 issue-container\"><dashboard-counter-box id=\"{{ issue.id }}\" ng-repeat=\"issue in ctrl.issueTypes\" title=\"{{ issue.name }}\" icon=\"{{ issue.icon }}\" color=\"{{ issue.color }}\" issue-id=issue.id view-action=\"ctrl.openTab(tab, icon, color, issueId, filters, predicates)\" counter-values=ctrl.counters.byTypeAndStatus[issue.name] clasifications=ctrl.counters.byTypeAndClassification[issue.name] title-clasifications=\"{{ translation.classifications }}\" title-status=\"{{ translation.status }}\" class=\"card md-whiteframe-2dp white\"></dashboard-counter-box></section><section ng-if=\"!loading &amp;&amp; ctrl.issueTypes.length == 0\" class=w100><div flex layout=column style=\"padding: 6px 16px\"><div flex class=text-center><i class=\"fa fa-exclamation-circle\"></i></div><div flex class=text-center>{{ translation.there_is_no_issues }}</div></div></section></md-content></section>");
$templateCache.put("app/data-management/dialog-table-management/dialog-table-management.html","<md-dialog aria-label=\"Issues custom view dialog\"><form name=tableForm novalidate><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ ctrl.modeTranslation }} &nbsp;<strong>{{ ctrl.table.tableName }}</strong></h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"width: 800px; padding: 5px\"><md-content ng-if=ctrl.isLoading><p>{{ ctrl.translation.loading }}</p><md-progress-linear md-mode=indeterminate></md-progress-linear></md-content><md-content ng-if=!ctrl.isLoading><md-tabs md-selected=ctrl.tab md-dynamic-height><md-tab label=Data><section layout=row layout-margin layout-padding><div flex><md-input-container class=\"w100 m0\"><label>{{ ctrl.translation.tableName }}</label><input ng-model=ctrl.table.tableName required></md-input-container></div><div flex><md-input-container class=\"w100 m0\"><label>{{ ctrl.translation.schemaName }}</label><md-select required ng-model=ctrl.table.schemaName ng-change=ctrl.loadColumns()><md-option ng-repeat=\"schema in ctrl.schemasOptions\" ng-value=schema>{{ schema }}</md-option></md-select></md-input-container></div></section><section layout=column layout-margin layout-padding><div flex><md-input-container class=\"w100 m0\"><label>{{ ctrl.translation.comment }}</label><input ng-model=ctrl.table.comment></md-input-container></div></section></md-tab><md-tab label=Columns><label>{{ ctrl.translation.columns }}</label><table class=\"table w100\"><thead><tr><th class=text-center>Order</th><th ng-repeat=\"(key, val) in ctrl.columnDef track by $index\" class=text-center>{{ key }}</th><th class=text-center>-</th></tr></thead><tbody ui-sortable=ctrl.sortableOptions ng-model=ctrl.table.columns class=columnsDef><tr ng-repeat=\"col in ctrl.table.columns.length === 0\"><td colspan=7 class=text-center>{{ ctrl.translation.addColumnsToTable }}</td></tr><tr ng-repeat=\"col in ctrl.table.columns track by $index\"><td style=\"cursor: grab\" class=text-center><md-icon>drag_indicator</md-icon>{{ $index + 1 }}</td><td class=text-center><md-input-container class=\"w100 m0\"><input type=text ng-model=\" col.colName\" ng-disabled=\"col.colName === \'id_row\'\" required aria-label={{col.colName}}></md-input-container></td><td class=text-center><md-input-container class=\"w100 m0\"><select name=colType ng-model=col.colType ng-change=ctrl.colTypeChange($index) ng-disabled=\"col.colName === \'id_row\'\" required><option ng-repeat=\"col in ctrl.colTypes\" value=\"{{ col }}\">{{ col }}</option></select></md-input-container></td><td class=text-center><input type=checkbox ng-model=\" col.notNull\" ng-disabled=\"col.colName === \'id_row\'\"></td><td class=text-center><input type=checkbox ng-model=\" col.primaryKey\" ng-disabled=\"col.colName === \'id_row\'\"></td><td class=text-center><input type=checkbox ng-model=\" col.withTextSearch\" ng-disabled=\"col.colName === \'id_row\' || col.colType != \'string\' &amp;&amp; col.colType != \'json\'\"></td><td class=text-center><md-button ng-click=ctrl.delCol($index) ng-disabled=\"col.colName === \'id_row\'\" class=md-icon-button><md-icon>delete</md-icon></md-button></td></tr></tbody></table></md-tab></md-tabs></md-content></md-dialog-content><md-dialog-actions style=\"justify-content: space-between\"><div><md-button ng-if=\"ctrl.tab == 1\" ng-click=ctrl.addCol() class=md-raised>{{ ctrl.translation.addNewColumn }}</md-button></div><div ng-if=!ctrl.isLoading><md-button type=submit form=tableForm ng-click=ctrl.save(true) ng-if=ctrl.showBtnSaveAndOpen class=\"md-raised green white-text\">{{ ctrl.translation.saveAndOpen }}</md-button>&nbsp; |<md-button ng-if=ctrl.validatePermission() ng-disabled=ctrl.loading type=submit form=tableForm ng-click=ctrl.save() class=\"md-raised green white-text\">{{ ctrl.translation.save }}</md-button><md-button ng-click=ctrl.cancel() ng-disabled=ctrl.loading class=md-raised>{{ ctrl.translation.cancel }}</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/data-management/schemas-tables/schemas-tables.html","<div class=\"bs-component sticky-parent\"><md-card><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" ng-click=ctrl.goToSchemaList() class=\"grey lighten-3\"><cep-icon icon=cep-menu-data-management scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=md-toolbar-tools><span>{{ ctrl.schemaName }}</span></h2><div style=\"margin-top: 8px\"><md-button has-permission=data-management:create aria-label=newTable ng-click=ctrl.tableManagement() class=md-raised>{{ ctrl.translation.createTable }}<md-icon md-font-set=material-icons>table</md-icon></md-button></div><div style=\"margin-top: 8px\"><md-button aria-label=goToSchemaList ng-click=ctrl.goToSchemaList() class=md-icon-button><md-icon md-font-set=material-icons>close</md-icon></md-button></div></div></md-toolbar><md-card-content><md-content ng-if=isLoading><p>{{ ctrl.translation.loading }}</p><md-progress-linear md-mode=indeterminate></md-progress-linear></md-content><md-content ng-if=\"!isLoading &amp;&amp; ctrl.schemaTables.length === 0\"><div class=text-center><p>{{ ctrl.translation.noTablesFound }}</p><md-button aria-label=newTable ng-click=ctrl.tableManagement() class=md-raised>{{ ctrl.translation.createTable }}<md-icon md-font-set=material-icons>table</md-icon></md-button></div></md-content><md-content ng-if=!isLoading><md-list flex=\"\"><md-list-item ng-repeat=\"table in ctrl.schemaTables\" class=md-3-line><div layout=row layout-align=\"center center\" layout-padding><div><h3>{{ table.tableName }}</h3><h5>{{ ctrl.translation.schema }}:&nbsp;<strong>{{ table.schemaName }}</strong></h5><p>{{ ctrl.translation.rows }}:&nbsp;<strong>{{ table.rows }}</strong></p></div></div><md-button has-permission=data-management#{{table.id}}:read ng-click=ctrl.showTable(table) style=\"padding: 0.8rem\" aria-label=remove_red_eye class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>remove_red_eye</md-icon><md-tooltip>{{ ctrl.translation.table }}</md-tooltip></md-button><md-button has-permission=data-management#{{table.id}}:update ng-click=ctrl.tableManagement(table) style=\"padding: 0.8rem\" aria-label=edit class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>edit</md-icon><md-tooltip>{{ ctrl.translation.edit }}</md-tooltip></md-button><md-button has-permission=data-management#{{table.id}}:share ng-click=ctrl.showShareEntityDialog(table) style=\"padding: 0.8rem\" aria-label=edit class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>share</md-icon><md-tooltip>{{ ctrl.translation.share }}</md-tooltip></md-button><md-button has-permission=data-management#{{table.id}}:delete ng-click=ctrl.confirmDeleteTable(table) style=\"padding: 0.8rem\" aria-label=edit class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>delete</md-icon><md-tooltip>{{ ctrl.translation.delete }}</md-tooltip></md-button></md-list-item></md-list></md-content></md-card-content></md-card></div>");
$templateCache.put("app/data-management/table-data/table-data.html","<md-card id=tableManagement ng-cloak><md-content class=content_blocks><div><md-toolbar class=md-menu-toolbar><div layout=row><md-toolbar-filler layout layout-align=\"center center\" ng-click=ctrl.toSchemaList() class=white><md-tooltip md-direction=right>get back</md-tooltip><cep-icon icon=cep-menu-data-management scale=2></cep-icon></md-toolbar-filler><div class=w100><h2 class=md-toolbar-tools><div class=md-title>{{ ctrl.tableName }}</div></h2></div></div></md-toolbar></div></md-content><section><table-data table-name=\"{{ ctrl.tableName }}\" schema-name=\"{{ ctrl.schemaName }}\"></table-data></section></md-card>");
$templateCache.put("app/ethical-portal/companies/companies.html","<div id=menu-ethical-portal-form><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-ethical-portal-form scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>Companies</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button ng-click=ctrl.manageCompany(null) aria-label=menu-ethical-portal-subscription class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>create company</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></md-toolbar-filler></div></md-toolbar></div><md-card><md-list flex><md-list-item ng-repeat=\"company in ctrl.companies\" ng-click=null class=md-3-line><div layout=column class=md-list-item-text><h2>{{ company.name }}</h2><p>rut:<strong>{{ company.rut }}</strong></p><p>email:<strong>{{ company.email }}</strong></p><p>phone:<strong>{{ company.phone }}</strong></p><p>address:<strong>{{ company.address }}</strong></p><p>complaintRatification:<strong>{{ company.complaintRatification }}</strong></p></div><a style=\"padding: 0.8rem\" aria-label=edit href=/ethical-portal/company/{{company.id}} class=\"md-secondary text-main-color btn md-raised\"><md-icon md-font-set=material-icons>table_rows</md-icon><md-tooltip>edit</md-tooltip></a></md-list-item></md-list></md-card>");
$templateCache.put("app/ethical-portal/company/company.html","<div id=menu-ethical-portal-form><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" ng-click=ctrl.toCompanies() class=\"grey lighten-3\"><cep-icon icon=cep-menu-ethical-portal-form scale=2></cep-icon><md-tooltip md-direction=right>exit</md-tooltip></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>Company &nbsp;</span><strong>{{ ctrl.company.name }}</strong></h2></div></md-toolbar><md-card><md-list flex><md-list-item style=\"align-items: center\" class=md-3-line><img ng-src=\"{{ ctrl.companyLogo }}\" alt=companyLogo style=\"width: 120px; padding: 0 1rem\"><div layout=column class=md-list-item-text><p>Rut:<strong>{{ ctrl.company.rut }}</strong></p><p>Email:<strong>{{ ctrl.company.email }}</strong></p><p>Phone:<strong>{{ ctrl.company.phone }}</strong></p><p>Address:<strong>{{ ctrl.company.address }}</strong></p><p>Ratification:<strong>{{ ctrl.company.complaintRatification === true ? \"SI\" : \"NO\" }}</strong></p></div><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button ng-disabled=ctrl.loading ng-click=ctrl.manageCompany() aria-label=menu-ethical-portal-subscription class=\"md-secondary md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>update company</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></md-toolbar-filler></md-list-item></md-list></md-card><md-card ng-if=ctrl.company.id><div layout=row layout-align=\"end center\"><div flex=20 class=text-right><md-button ng-click=ctrl.addComplaintForm() class=\"md-raised blue white-text\"><md-icon md-font-set=material-icons class=white-text>add</md-icon>Agregar Formulario</md-button></div></div><md-tabs md-dynamic-height md-border-bottom md-selected=ctrl.selectedTab ng-if=\"ctrl.selectedTab !== undefined\"><md-tab ng-repeat=\"item in ctrl.company.complaintForm track by $index\" label=\"{{ item.name }}\"><complaint-form item=item form=item.form company=ctrl.company update=ctrl.updateCompanyForm() destroy=ctrl.deleteCompanyForm()></complaint-form></md-tab></md-tabs></md-card></div>");
$templateCache.put("app/ethical-portal/dialog/company-dialog.html","<md-dialog aria-label=\"Company Dialog\" flex=100 style=\"width: 90vw\"><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ ctrl.event }} Company - {{ ctrl.company.name }}</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-width: 90vw; max-width: 90vw; max-height: 90vw; padding: 5px\"><md-tabs md-dynamic-height md-autoselect><md-tab label=datos><form id=formcampany name=formcampany ng-submit=\"formcampany.$valid &amp;&amp; ctrl.save()\" novalidate layout=row layout-wrap layout-align=\"center center\" layout-padding style=\"margin-top: 1rem\"><div flex=50><md-input-container class=\"w100 p0 m0\"><label>rut</label><input ng-model=ctrl.company.rut name=rut type=text required aria-label=rut></md-input-container><md-input-container class=\"w100 p0 m0\"><label>Logo</label><input id=file type=file name=file nv-file-select uploader=ctrl.uploaderLogo input-file aria-label=logo></md-input-container></div><div flex=50><md-input-container class=\"w100 p0 m0\"><label>Nombre</label><input ng-model=ctrl.company.name name=name type=text required aria-label=name></md-input-container></div><div flex=50><md-input-container class=\"w100 p0 m0\"><label>Email</label><input ng-model=ctrl.company.email name=email type=email required aria-label=email></md-input-container></div><div flex=50><md-input-container class=\"w100 p0 m0\"><label>Telefono</label><input ng-model=ctrl.company.phone name=phone type=phone required aria-label=phone></md-input-container></div><div flex=100><md-input-container class=\"w100 p0 m0\"><label>Dirección</label><input ng-model=ctrl.company.address name=address type=text required aria-label=address></md-input-container></div><div flex=100><md-input-container class=\"w100 p0 m0\"><label>Description</label><textarea ui-tinymce=tinymceOptions ng-model=ctrl.company.descriptionField></textarea></md-input-container></div></form></md-tab><md-tab label=\"Formularios de denuncia\"><md-tabs md-dynamic-height><md-tab ng-repeat=\"form in ctrl.complaintForm track by $index\" label=\"{{ form.name }}\"><div layout=row layout-wrap><div flex=100><h4 style=\"display: flex; flex-direction: row; flex-wrap: nowrap; align-content: center; justify-content: flex-start; align-items: center\">Ratification<md-checkbox ng-model=form.complaintRatification name=complaintRatification aria-label=complaintRatification>{{ opt }}</md-checkbox><small>El usuario debe ingresar un correo electrónico válido, al cual se le enviara link de confirmación.</small></h4></div><div flex=50><md-input-container class=\"w100 p0 m0\"><label>Disclaimer</label><textarea ui-tinymce=tinymceOptions ng-model=form.disclaimer></textarea></md-input-container></div><div flex=50><md-input-container class=\"w100 p0 m0\"><label>Description</label><textarea ui-tinymce=tinymceOptions ng-model=form.descriptionField></textarea></md-input-container></div></div></md-tab></md-tabs></md-tab><md-tab label=documentos><div flex=100><label>Documents</label><md-input-container class=\"w100 p0 m0\"><input id=file type=file name=file nv-file-select uploader=ctrl.uploaderDocs input-file multiple aria-label=documents></md-input-container></div><aside><md-list-item ng-repeat=\"doc in ctrl.company.documentList track by $index\" ng-if=\"doc[1] === \'DOCUMENT\'\"><p>{{ doc[0] }}</p><md-button ng-click=ctrl.downloadDocument(doc[0]) class=md-secondary><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"download doc\">cloud_download</md-icon></md-button><md-button ng-click=ctrl.deleteDoc(doc[0]) class=md-secondary><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"delete doc\">delete</md-icon></md-button></md-list-item></aside></md-tab></md-tabs></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button ng-click=ctrl.cancel() class=md-raised>Cancel</md-button><md-button type=submit form=formcampany ng-disabled=formcampany.$invalid class=md-raised>Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/files-storage/custom-report/custom-report-storage.html","<section layout=row><md-card flex=75><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-files-storage scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\">Custom Reports files</h2></div></md-toolbar><div flex=100><div id=grid-folder-list style=\"height: 75vh\" ui-grid-resize-columns ui-grid-auto-resize ui-grid-pagination ui-grid=ctrl.gridOptions></div></div></md-card><aside flex=25><disk-usage show=&quot;diskInfo&quot; style=\"margin-bottom: 0\"></disk-usage><md-card id=actions-storage-btns style=\"margin-top: 0\"><md-button id=btn-to-files-storage href=files-storage aria-label=files-storage class=\"w100 m0 text-left\"><md-icon md-font-set=material-icons class=cep_text>folder</md-icon>&nbsp;<b>Files Storage</b></md-button></md-card></aside></section>");
$templateCache.put("app/files-storage/files-selector-dialog/files-selector-dialog.html","<div ng-if=\"ctrl.isLoading== true\"><md-progress-linear id=loading-in-progress md-mode=indeterminate></md-progress-linear></div><div ng-if=\"ctrl.isLoading== false\"><section layout=row layout-aling=\"center center\" layout-wrap=\"\" ng-if=\"ctrl.folderActive==null\"><md-card flex=45 ng-repeat=\"folder in ctrl.FoldersArray\"><md-card-content ng-click=ctrl.onSelecFolder(folder.id)><p class=m0><md-icon md-font-set=material-icons ng-style=\"{ &quot;color&quot;:folder.color }\">folder</md-icon>&nbsp; {{ folder.name }}</p><small>{{ folder.totalFiles }} archivos</small></md-card-content></md-card></section><section ng-if=\"ctrl.folderActive!=null\"><div layout=row layout-wrap=\"\"><div flex=60><h5>{{ ctrl.folderActive.name }} &nbsp;</h5></div><div flex=20><p class=m0>{{ ctrl.folderActive.totalFiles }} &nbsp;</p></div><div flex=20><md-icon md-font-set=material-icons ng-click=ctrl.closeFolder()>close</md-icon></div></div><md-divider></md-divider><div layout=row layout-aling=\"center center\" layout-wrap=\"\"><md-card flex=30 ng-repeat=\"file in ctrl.filesOnFolder\"><md-card-content ng-click=toggleSelectionFIle(file) class=text-center><p class=m0><b>{{ file.name }}</b></p><p class=\"m0 text-right\"><small>{{ file.size | readableBytes }}</small></p></md-card-content></md-card></div></section><md-divider></md-divider><div class=w100><md-list flex><md-list-item ng-repeat=\"item in ctrl.chartListSelected\" ng-click=null class=md-3-line><p class=m0><b>{{ item.name }}</b></p><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\" ng-click=ctrl.removeLink(item.id) class=md-secondary>delete</md-icon></md-list-item></md-list></div></div>");
$templateCache.put("app/files-storage/folder/folderview.html","<section layout=row layout-align=\"start start\"><section flex=70><md-card><md-toolbar class=main-color><div class=md-toolbar-tools><h2 flex=\"\" md-truncate=\"\"><md-icon md-font-set=material-icons ng-style=\"{ \'color\':ctrl.folder.color }\">folder</md-icon>&nbsp; {{ ctrl.folder.name }}</h2><div flex=20 ng-show=\"ctrl.folder.type == \'USER\'\" class=box-upload><input id=file ng-if=!ctrl.loading type=file name=file nv-file-select uploader=ctrl.uploader input-file multiple><md-button style=\"background-color: #49a847\" aria-label=\"Select file to upload button\" onclick=\"document.getElementById(\'file\').click()\" ng-if=\"validatePermission(\'create-file\')\" class=\"md-fab md-mini pull-right\"><md-icon md-font-set=material-icons>cloud_upload</md-icon><md-tooltip md-direction=bottom>{{ ctrl.translation.load_file }}</md-tooltip></md-button></div><md-button ng-click=ctrl.closeFolder() aria-label=\"cerrar carpeta\" class=\"md-warn md-icon-button pull-right\"><md-icon md-font-set=material-icons>closes</md-icon><md-tooltip md-direction=bottom>{{ ctrl.translation.close }}</md-tooltip></md-button></div></md-toolbar><div id=loading-content layout=row ng-if=ctrl.loading><md-progress-linear md-mode=indeterminate></md-progress-linear></div><div id=drop-area-wrapper ng-if=ctrl.isready drop-zone nv-file-drop uploader=ctrl.uploader style=\"position: relative\" class=w100><div class=w100><md-card-content ng-show=ctrl.uploader.getNotUploadedItems().length><div layout=row><h4 flex=60>{{ ctrl.translation.files_queue }}</h4><div flex=40><md-button type=button ng-click=uploadAll() ng-disabled=!ctrl.uploader.getNotUploadedItems().length ng-if=\"ctrl.folder.type == \'USER\' &amp;&amp; validatePermission(\'create-file\')\" class=\"md-raised md-primary\"><md-icon md-font-set=material-icons md-menu-align-target>file_upload</md-icon>{{ ctrl.translation.upload_all }}</md-button><md-button type=button ng-click=ctrl.uploader.cancelAll() ng-disabled=!ctrl.uploader.isUploading class=\"md-icon-button md-warn\"><md-icon md-font-set=material-icons md-menu-align-target>close</md-icon>{{ ctrl.translation.cancel_all }}</md-button><md-button type=button ng-click=ctrl.uploader.clearQueue() ng-disabled=!ctrl.uploader.queue.length class=\"md-icon-button md-warn\"><md-icon md-font-set=material-icons md-menu-align-target>delete</md-icon>{{ ctrl.translation.cancel_all }}</md-button></div></div><section layout=row layout-wrap=\"\"><div flex=100><md-list><md-list-item ng-repeat=\"item in ctrl.uploader.queue\" md-truncate=\"\" class=p0><p><md-icon md-font-set=material-icons md-menu-align-target>file_copy</md-icon>{{ item.file.name }}</p><md-icon md-font-set=material-icons md-menu-align-target ng-click=\" ctrl.uploader.removeFromQueue(item)\">delete</md-icon></md-list-item></md-list></div><div ng-show=ctrl.uploader.isUploading><md-progress-linear md-mode=determinate value=\"{{ ctrl.uploader.progress }}\"></md-progress-linear></div></section></md-card-content></div><div id=empty-folder-box ng-show=\"ctrl.totalFiles == 0 &amp;&amp; !ctrl.loading\" style=\"padding: 10px\" onclick=\"document.getElementById(\'file\').click()\" ng-if=\"validatePermission(\'create-file\')\" class=w100><div style=\"border: dashed 1px; cursor: pointer; margin: 3rem 1rem\" class=text-center><h2>{{ ctrl.translation.empty_folder }}</h2><h3>{{ ctrl.translation.drop_here }}</h3><md-icon md-font-set=material-icons style=\"font-size: 10em\">cloud_upload</md-icon></div></div><div class=w100><div id=grid-files-list ng-if=\"ctrl.totalFiles &gt; 0\" style=\"height: 75vh\" ui-grid-resize-columns ui-grid-auto-resize ui-grid-pagination ui-grid-selection ui-grid=ctrl.gridOptions></div></div></div></md-card></section><aside flex=30><div ng-if=\"ctrl.selectedRows.length===0\"><md-card ng-if=ctrl.fileDetails><md-card-content><md-button type=button ng-click=ctrl.closeFileDetails() class=\"md-icon-button md-warn\"><md-icon md-font-set=material-icons md-menu-align-target>close</md-icon></md-button><file-widget data=ctrl.fileDetails folder-type=ctrl.folder.type></file-widget></md-card-content></md-card><md-card ng-if=!ctrl.fileDetails><md-card-content id=folder-details><h4>{{ ctrl.translation.owner }}<b class=pull-right>{{ ctrl.folder.creatorName }}</b></h4><hr><h4>{{ ctrl.translation.size }}<b class=pull-right>{{ ctrl.folder.size | readableBytes }}</b></h4><hr><h4>{{ ctrl.translation.file_length }}<b class=pull-right>{{ ctrl.totalFiles }}</b></h4><hr><h4>{{ ctrl.translation.valid_files }}</h4><div ng-repeat=\"extensions in ctrl.folder.extensions track by $index \" style=\"margin: 2px\" class=badge>.{{ extensions }}</div><hr><h4>{{ ctrl.translation.description }}</h4><p>{{ ctrl.folder.description }}</p><hr><div layout=row layout-align=\"end center\" ng-show=\"ctrl.loading == false\"><md-button ng-click=settingsModal($event) aria-label=\"Edit file button\" ng-if=\"ctrl.folder.type == \'USER\' &amp;&amp; validatePermission(\'update\')\"><md-icon md-font-set=material-icons>edit</md-icon><md-tooltip md-direction=bottom>{{ ctrl.translation.edit }}</md-tooltip></md-button><md-button ng-click=export($event) aria-label=\"Export file button\" ng-if=\"ctrl.folder.type == \'USER\' &amp;&amp; validatePermission(\'update\')\" class=\"green-text md-icon-button\"><md-icon md-font-set=material-icons class=green-text>file_download</md-icon><md-tooltip md-direction=bottom>Export</md-tooltip></md-button><md-button ng-click=ctrl.showShareEntityDialog() aria-label=\"Share folder button\" class=\"md-primary md-icon-button\"><md-icon md-font-set=material-icons>share</md-icon><md-tooltip md-direction=bottom>{{ ctrl.translation.share_folder }}</md-tooltip></md-button><md-button ng-click=confirmDeleteFolder() aria-label=\"Delete file button\" ng-if=\"ctrl.folder.type == \'USER\' &amp;&amp; validatePermission(\'delete\')\" class=\"md-warn md-icon-button\"><md-icon md-font-set=material-icons>delete</md-icon><md-tooltip md-direction=bottom>{{ ctrl.translation.delete_folder }}</md-tooltip></md-button><btn-bookmark ng-if=\"ctrl.folder.type == \'USER\'\" style=\"padding: 0.8rem\" entity-id=ctrl.folder.id entity-name=ctrl.folder.name entity-type=\"\'folder\'\" role=button-folder-bookmark has-permission=files-storage#{{ctrl.folder.id}}:read class=\"md-icon-button md-secondary text-main-color md-button md-ink-ripple\"></btn-bookmark></div></md-card-content></md-card></div><div ng-if=\"ctrl.selectedRows.length &gt; 0\"><files-queue folder-id=ctrl.folder.id files=ctrl.selectedRows></files-queue></div></aside></section>");
$templateCache.put("app/files-storage/storage/files-storage.html","<section layout=row><md-card flex=75><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-files-storage scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\">{{ ctrl.translation.files_storage }}</h2></div></md-toolbar><div id=loading-content layout=row ng-if=ctrl.loading><div flex=100><md-progress-linear md-mode=indeterminate></md-progress-linear></div></div><section layout=row layout-wrap=\"\" ng-show=\"ctrl.FoldersArray.length == 0 &amp;&amp; ctrl.loading == false\" has-permission=files-storage:create-folder><div flex=auto class=text-center><br><h3 class=text-center>{{ ctrl.translation.no_folders_found }}</h3><h4 class=text-center>{{ ctrl.translation.create_folder_to_save_files }}</h4><md-button style=\"background-color: #49a847; color: #fff\" ng-click=modalFolderCreate() aria-label=\"nueva carpeta\" class=md-raised><md-icon md-font-set=material-icons>create_new_folder</md-icon>{{ ctrl.translation.new_folder }}</md-button></div></section><div flex=100><div id=grid-folder-list style=\"height: 75vh\" ui-grid-resize-columns ui-grid-auto-resize ui-grid-pagination ui-grid=ctrl.gridOptions></div></div></md-card><aside flex=25><disk-usage show=&quot;diskInfo&quot;></disk-usage><md-card id=actions-storage-btns><md-button id=btn-create-new-folder ng-click=modalFolderCreate() aria-label=new-fodler has-permission=files-storage:create-folder class=\"w100 m0 text-left green-text\"><md-icon md-font-set=material-icons class=green-text>create_new_folder</md-icon>&nbsp;<b>{{ ctrl.translation.new_folder }}</b></md-button><md-button id=btn-to-trash-folder href=trash-storage aria-label=trash-folder has-permission=files-storage:read-trash class=\"w100 m0 text-left orange-text\"><md-icon md-font-set=material-icons class=orange-text>delete</md-icon>&nbsp;<b>{{ ctrl.translation.trash }}</b></md-button><md-button id=btn-to-system-folder ng-show=\"ctrl.loggedUser.userType == &quot;SA&quot;\" href=system-storage aria-label=system-folder class=\"w100 m0 text-left cep_text\"><md-icon md-font-set=material-icons class=cep_text>developer_board</md-icon>&nbsp;<b>{{ ctrl.translation.system }}</b></md-button><md-button id=btn-to-custom-report-folder ng-show=\"ctrl.loggedUser.userType == &quot;SA&quot;\" href=custom-report-storage aria-label=custom-report-storage class=\"w100 m0 text-left\"><md-icon md-font-set=material-icons class=cep_text>folder</md-icon>&nbsp;<b>Custom Reports files</b></md-button></md-card></aside></section>");
$templateCache.put("app/files-storage/system/system-storage.html","<section layout=row><md-card flex=75><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-files-storage scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\">{{ translation.system }}</h2></div></md-toolbar><div flex=100><div id=grid-folder-list style=\"height: 75vh\" ui-grid-resize-columns ui-grid-auto-resize ui-grid-pagination ui-grid=ctrl.gridOptions></div></div></md-card><aside flex=25><disk-usage show=&quot;diskInfo&quot; style=\"margin-bottom: 0\"></disk-usage><md-card id=actions-storage-btns style=\"margin-top: 0\"><md-button id=btn-to-files-storage href=files-storage aria-label=files-storage class=\"w100 m0 text-left\"><md-icon md-font-set=material-icons class=cep_text>folder</md-icon>&nbsp;<b>Files Storage</b></md-button></md-card></aside></section>");
$templateCache.put("app/files-storage/trash/trash-storage.html","<section layout=row><md-card flex=75><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-files-storage scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\">{{ translation.trash }}</h2><md-button href=files-storage aria-label=\"files storage\" has-permission=files-storage:read class=pull-righ><md-icon md-font-set=material-icons>how_to_vote</md-icon>{{ translation.go_to_files_storage }}</md-button></div></md-toolbar><div layout=row><div flex=100 ng-if=ctrl.loading style=\"margin: 10px\"><div style=\"padding: 10px\" class=text-center><h4>{{ translation.loading_files }}</h4><md-progress-linear md-mode=indeterminate></md-progress-linear></div></div></div><div class=w100><div id=grid-files-list style=\"height: 75vh\" ui-grid-selection ui-grid-resize-columns ui-grid-auto-resize ui-grid-pagination ui-grid=ctrl.gridOptions></div></div></md-card><aside flex=25 ng-cloak><disk-usage show=\"\'trashInfo\'\" ng-if=!ctrl.fileDetails></disk-usage><md-card ng-if=ctrl.fileDetails><md-card-content><md-button type=button ng-click=ctrl.closeFileDetails() class=\"md-icon-button md-warn\"><md-icon md-font-set=material-icons md-menu-align-target>close</md-icon></md-button><file-widget data=ctrl.fileDetails folder-type=ctrl.folder.type uploader=disabled></file-widget></md-card-content></md-card></aside></section>");
$templateCache.put("app/group/config/dialog-create-group.html","<md-dialog aria-label=\"{{ translation.add_schema }}\" style=width:500px><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ actionText }}</h2><span flex></span><md-button ng-click=cancel($event) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column layout-padding style=\"padding-top: 10px\"><md-content class=p0><form name=groupForm novalidate><div layout=column style=z-index:3 class=\"sticky-top white\"><md-input-container><label>{{ translation.NAME_FIELD }}</label><input type=text ng-model=name required md-maxlength=50></md-input-container><md-input-container><label>Company</label><md-select name=company ng-model=companyId placeholder=\"company name\" required ng-change=getUsersByCompanyId()><md-option ng-value=company.id ng-repeat=\"company in companies\">{{ company.name }}</md-option></md-select></md-input-container><md-input-container><md-checkbox ng-model=active aria-label=Active>{{ translation.ACTIVE_FIELD }}</md-checkbox></md-input-container></div><div layout=row layout-fill ng-cloak><md-content flex=100><md-list flex=100><md-subheader><h4>Members</h4></md-subheader><md-list-item ng-repeat=\"item in users\" class=md-2-line><div flex=10><letter-avatar data=\"{{ item.fullName }}\" color=item.color></letter-avatar></div><div flex=80><b>{{ item.fullName }}</b><br><span>{{ item.email }}</span><br><span>{{ item.username }}</span></div><div flex=10><md-checkbox ng-model=dictionary[companyId][item.userId] class=md-secondary></md-checkbox></div></md-list-item></md-list></md-content></div></form></md-content></md-dialog-content><md-dialog-actions><md-button md-colors=green ng-click=cancel($event)>{{ translation.CANCEL_BUTTON }}</md-button><md-button md-colors=green ng-click=save() ng-show=validatePermission() ng-disabled=groupForm.$invalid class=\"md-raised green white-text\"><md-icon md-font-set=material-icons md-menu-align-target>save</md-icon>{{ translation.SAVE_BUTTON }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/group/config/group.list.html","<div class=\"bs-component sticky-parent\"><md-card><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-groups scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>Group</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button has-permission=group:create abm-component ng-click=ctrl.showCreateGroupDialog() class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>Create Searcher</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></md-toolbar-filler></div></md-toolbar><tabs-bar tabs=tabsGroups is-active=ctrl.isActive set-tab=ctrl.setTab del-tab=ctrl.eliminarTab></tabs-bar><section ng-show=\"ctrl.isSet(\'index\')\"><div flex=100><ng-table-dynamic id=group-table , config=ctrl.config show-top-bar=true show-filter-button=true show-refresh-button=true show-export-csv-button=false on-click=ctrl.showCreateGroupDialog on-share=ctrl.showShareEntityDialog></ng-table-dynamic></div></section></md-card></div>");
$templateCache.put("app/help-desk/components/buttons.html","<md-menu-item><md-button aria-label=\"Report Issue\" ng-click=ctrl.open()>Report Issue</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Report Issue\" href=help-desk/tickets>My Tickets</md-button></md-menu-item>");
$templateCache.put("app/help-desk/dialogs/report-issue.html","<md-dialog id=help-desk-dialog aria-label=\"help desk\" style=width:35vw class=control-dialog><md-toolbar class=main-color><div class=md-toolbar-tools><h2>Report a issue</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-card ng-if=!ctrl.showTicket><form><div layout=column><div flex><div layout=row layout-margin><div flex><label>Issue type</label><md-input-container class=w100><md-radio-group ng-model=ctrl.ticket.type aria-labelledby=ticket.type><md-radio-button value=TICKET class=md-primary>TICKET</md-radio-button><md-radio-button value=INQUIRY>INQUIRY</md-radio-button></md-radio-group></md-input-container></div><div flex><div class=w100><label>Ususario</label><h4>{{ ctrl.ticket.username }}</h4></div><div class=w100><label>Location</label><h4>{{ ctrl.ticket.domain }}</h4></div></div></div></div><div flex><md-input-container class=w100><label>Email</label><input name=email ng-model=ctrl.ticket.email></md-input-container></div><div flex><md-input-container class=w100><label>Comment</label><textarea name=commnet placeholder=\"Describe the issue detail\" ng-model=ctrl.ticket.commnet rows=2> </textarea></md-input-container></div><div flex><md-input-container class=w100>Attach file <input id=file type=file name=file nv-file-select uploader=ctrl.uploader input-file filters=Extensions,Size multiple></md-input-container></div><div flex><md-button ng-click=ctrl.submit() ng-disabled=ctrl.loading class=\"md-raised w100 green m0\">Enviar</md-button></div></div></form></md-card><md-card ng-if=ctrl.showTicket><div layout=column><div flex class=text-center><h3>Issue Enviado</h3><h4>Ticket de seguimiento</h4><h3 class=font-monospace><b>{{ ctrl.ticket }}</b></h3></div></div></md-card></md-dialog-content></md-dialog>");
$templateCache.put("app/indicators/dialog/indicator-dialog.html","<md-dialog aria-label=\"indicator dialog\" style=\"min-width: 50vw; min-height: 50vh\" class=control-dialog><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ ctrl.method }}: {{ ctrl.indicator.name }}</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-width: 600px; padding: 5px\" ng-if=ctrl.isLoading><div style=\"padding: 2rem 1rem\" class=text-center><p>{{ translation.loading }}</p><md-progress-linear></md-progress-linear></div></md-dialog-content><md-dialog-content style=\"min-width: 600px; padding: 5px\" ng-if=!ctrl.isLoading><form layout=row layout-padding><div flex><md-input-container class=\"w100 m0\"><label>{{ translation.name }}</label><input ng-model=ctrl.indicator.name></md-input-container></div><div flex><md-input-container class=\"w100 m0\"><label>{{ translation.description }}</label><input ng-model=ctrl.indicator.description></md-input-container></div><div flex><md-switch ng-model=ctrl.indicator.active aria-label=active>{{ translation.active }}: {{ ctrl.indicator.active }}</md-switch></div></form><section layout=column layout-padding><div flex layout=row ng-repeat=\"interval in ctrl.indicator.intervals track by $index\"><div flex><md-input-container class=\"w100 m0\"><label>{{ translation.indicator }} {{ $index }}</label><input ng-model=interval.label></md-input-container></div><div flex=20><div style=\"display: flex; flex-direction: row; gap: 10px; flex-wrap: nowrap; align-content: flex-start; padding: 0 12px; justify-content: center; align-items: center\"><p class=\"w10 m0\"><strong>{{ translation.min }}</strong></p><p ng-if=\"$index == 0\" class=\"w10 m0\">{{ interval.min }}</p><p ng-if=\"$index &gt; 0\" class=\"w10 m0\">{{ interval.min = ctrl.indicator.intervals[$index - 1].max + 1 }}</p></div></div><div flex=20><md-input-container class=\"w100 m0\"><label>{{ translation.max }}</label><input ng-model=interval.max type=number required min=\"{{ interval.min + 1 }}\" max=\"{{ ctrl.indicator.intervals[$index + 1].max }}\"></md-input-container></div><div flex><md-input-container class=\"w100 m0\"><label>{{ translation.color }}</label><input ng-model=interval.color type=color></md-input-container></div><div flex=10><md-button ng-click=ctrl.removeInterval($index) ng-if=\"$index &gt; 0\" class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=delete>delete</md-icon></md-button></div></div></section><div layout=row layout-padding layout-aling=\"center end\"><div class=text-center><md-button ng-click=ctrl.addInterval() class=md-raised>{{ translation.addInterval }}</md-button></div></div></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button id=cancel ng-click=ctrl.cancel() class=md-raised>{{ translation.cancel }}</md-button><md-button id=save ng-click=ctrl.save() class=\"md-raised green white-text\">{{ translation.save }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/input-list/components/list-loader.html","<div style=\"height: calc(100vh - 290px); position: absolute; z-index: 999; background-color: rgba(255, 255, 255, 0.70)\" ng-if=ctrl.loading class=w100><div style=\"text-align:center; padding:25vh\"><div class=themeLogo></div><md-progress-linear md-mode=indeterminate ng-disabled=!ctrl.loading></md-progress-linear><div ng-if=ctrl.total><span style=\"font-size: 1.3em; font-weight: 700\">{{ ctrl.progress | number: 0 }}%</span><span>({{ ctrl.loaded }} / {{ ctrl.total }})</span></div><div ng-if=ctrl.msg>{{ ctrl.msg }}</div><div ng-if=ctrl.time>Aprox. {{ ctrl.time | number: 0 }}{{ ctrl.timeScale }} remaining</div></div></div>");
$templateCache.put("app/input-list/components/list-paginator.html","<div layout=row layout-align=\"end center\"><div flex=1 class=footer_info><p style=\"padding: 0 10px; position: relative; top: 7px\">{{ translation.records }}: {{ ctrl.totalRecords }}</p></div><div flex=1 class=footer_info><span style=\"position: relative; top: 4px\">Page:</span><md-input-container style=\"padding: 0 10px\"><md-select ng-model=ctrl.pageIndex ng-change=ctrl.gotoFn(ctrl.pageIndex) aria-label=\"Page selector\"><md-option ng-repeat=\"page in ctrl.pages\" ng-value=page>{{ page }}</md-option></md-select></md-input-container></div><div flex=1 style=\"margin-right: 0\" class=footer_info><md-button ng-click=ctrl.prevFn() title=\"Prev page\" ng-disabled=\"ctrl.pageIndex &lt;= 1\" aria-label=\"Prev page button\" class=md-icon-button><md-tooltip md-direction=top>{{ translation.prev }}</md-tooltip><md-icon md-font-set=material-icons>keyboard_arrow_left</md-icon></md-button></div><div flex=1 style=\"margin-right: 0\" class=footer_info><md-button ng-click=ctrl.nextFn() title=\"Next page\" ng-disabled=\"ctrl.pageIndex &gt;= Math.ceil(ctrl.totalRecords / ctrl.pageSize)\" aria-label=\"Next page button\" class=md-icon-button><md-tooltip md-direction=top>{{ translation.next }}</md-tooltip><md-icon md-font-set=material-icons>keyboard_arrow_right</md-icon></md-button></div></div>");
$templateCache.put("app/input-list/table/tableList.html","<md-card id=InputListReader ng-cloak><md-content class=content_blocks><div><md-toolbar class=md-menu-toolbar><div layout=row><md-toolbar-filler id=btnInputListonGoBack layout layout-align=\"center center\" ng-click=ctrl.getBack() class=main-color><md-tooltip md-z-index=9999 md-delay=200>{{ translation.get_back }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>table_rows</md-icon></md-toolbar-filler><div class=w100><h2 class=md-toolbar-tools><div class=md-title>{{ ctrl.list.name }}</div></h2><ng-include src=&quot;app/input-list/templates/table-list-main-menu.html&quot;></ng-include></div></div></md-toolbar></div></md-content><md-divider></md-divider><md-content style=\"max-height: 76vh\"><md-content ng-if=ctrl.tableIsLoading><md-progress-linear></md-progress-linear></md-content><div ui-grid-pagination ui-grid-resize-columns ui-grid-auto-resize ui-grid=ctrl.gridOptions style=\"height: 70vh\" class=listGrid></div></md-content></md-card>");
$templateCache.put("app/input-list/templates/dialog-filter-inputlist.html","<md-dialog aria-label=\"{{ translation.add_list }}\"><form name=filterListForm ng-submit=\"filterListForm.$valid &amp;&amp; filter()\" novalidate><md-dialog-content style=\"min-width: 600px; max-width: 800px; max-height: 810px\"><md-content layout=column><div class=md-padding><div><b>{{ selectedCol }}</b>({{ colTypes[selectedCol] }}) - {{ translation.filter_by }} {{ translation.condition | lowercase }}</div><div layout=row><md-input-container flex=40><select ng-model=filterCondition name=filterCondition ng-change=isValueRequired(); aria-label=\"Filter operation field\" class=select-filters-modal><option ng-repeat=\"operation in operations\" value=\"{{ operation.operation }}\" ng-disabled=\"{{ operation.disabled }}\">{{ translation[operation.title] }}</option></select><div ng-messages=filterListForm.filterCondition.$error><div ng-message=required>{{ translation.field_required }}</div></div></md-input-container><md-input-container flex=60 ng-if=\"![\'date\', \'time\', \'timestamp\'].includes(colTypes[selectedCol])\"><label>Value</label><input ng-model=$parent.filterConditionValue name=filterConditionValue ng-required=$parent.valueRequired autocomplete=off aria-label=\"Filter value field\"><div ng-messages=filterListForm.filterConditionValue.$error><div ng-message=required>{{ translation.field_required }}</div></div></md-input-container><md-input-container flex ng-if=\"[\'date\', \'timestamp\'].includes(colTypes[selectedCol])\"><label>Date</label><input mdc-datetime-picker=\"\" date=true time=false type=text short-time=true show-todays-date=true click-outside-to-close=true placeholder=Date auto-ok=true format=DD-MM-YYYY ng-model=$parent.filterConditionValue edit-input=false show-icon=true ng-model-options=\"{ timezone: \'utc\' }\" class=md-input></md-input-container><md-input-container flex ng-if=\"[\'time\', \'timestamp\'].includes(colTypes[selectedCol])\"><label>Time</label><input mdc-datetime-picker date=false seconds=true type=text short-time=false show-todays-date=false click-outside-to-close=true placeholder=Time auto-ok=true minute-steps=1 format=HH:mm:ss.SSSSSSSSS ng-model=$parent.filterConditionValue edit-input=false show-icon=true ng-model-options=\"{ timezone: \'utc\' }\" class=md-input></md-input-container></div></div><md-divider></md-divider></md-content></md-dialog-content><md-dialog-actions><md-button ng-click=cancel() class=md-raised>{{ translation.cancel }}</md-button><md-button type=submit class=\"md-raised md-primary\">{{ translation.apply }}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/input-list/templates/dialog-save-and-exit.html","<md-dialog><md-dialog-content id=dialogContent_7 role=document tabindex=-1 class=md-dialog-content><h2 class=\"md-title ng-binding\">{{translation.save_changes_question}}</h2><div class=\"md-dialog-content-body ng-scope\"><p class=ng-binding>{{translation.changes_will_be_lost}}</p></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=dialog.exitWithoutSave()>{{translation.exit_without_save}}</md-button><span flex=\"\"></span><md-button ng-click=dialog.abort()>{{translation.cancel}}</md-button><md-button ng-click=dialog.saveAndExit() md-autofocus=\"\">{{translation.save_and_exit}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/input-list/templates/dialog-shema-info.html","<md-dialog aria-label={{translation.add_list}}><md-dialog-content style=min-width:600px;max-width:800px;max-height:810px><md-content layout=column><div class=md-padding><div layout=row><b class=md-title>Schema: PruebaFiltrosTipo</b><span flex class=flex></span><round-button on-click=ctrl.hide() aria-label=Close icon=clear></round-button></div><md-divider></md-divider><div>Name: {{ctrl.schemaInfo.name}}<br>Description: {{ctrl.schemaInfo.description}}<br>Schema:<br><pre style=\"white-space: pre\">{{ctrl.schemaInfo.schema | json}}</pre></div></div><md-divider></md-divider></md-content></md-dialog-content><md-dialog-actions><a ng-href=entries/schemas target=_blank class=\"md-raised md-button\">Go to schemas</a><md-button ng-click=ctrl.hide() class=md-raised>Close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/input-list/templates/export-selector.html","<md-dialog><md-dialog-content id=dialogContent_7 role=document tabindex=-1 class=md-dialog-content><h2 class=\"md-title ng-binding\">{{ translation.title_export }}</h2><md-divider></md-divider><div class=md-dialog-content-body><p>{{ translation.export_quest }}</p><br><md-radio-group ng-model=selCtrl.selection><md-radio-button value=all class=md-primary>{{ translation.export_the_complete_list}}</md-radio-button><md-radio-button value=this class=md-primary>{{ translation.export_the_list_with_the_applied_filters }}</md-radio-button></md-radio-group></div></md-dialog-content><md-dialog-actions><section ng-show=workbook><span>{{ translation.reading_file_data }}</span><md-progress-linear></md-progress-linear></section><section ng-hide=workbook><md-button type=button ng-click=selCtrl.abortSelection()><span>{{ translation.cancel }}</span></md-button><md-button type=button ng-click=selCtrl.selectSheet(selCtrl.selection)><span>{{ translation.export }}</span></md-button></section></md-dialog-actions></md-dialog>");
$templateCache.put("app/input-list/templates/header-cell-template.html","<div role=columnheader ng-class=\"{ \'sortable\': sortable, \'ui-grid-header-cell-last-col\': isLastCol }\" ui-grid-one-bind-aria-labelledby-grid=\"col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'\" aria-sort=\"{{ col.sort.direction == asc ? \'ascending\' : col.sort.direction == desc ? \'descending\' : !col.sort.direction ? \'none\' : \'other\' }}\"><div role=button tabindex=0 ng-keydown=handleKeyDown($event) col-index=renderIndex title=TOOLTIP class=\"ui-grid-cell-contents ui-grid-header-cell-primary-focus\"><span ui-grid-one-bind-id-grid=\"col.uid + \'-header-text\'\" class=ui-grid-header-cell-label>{{ col.displayName }}<md-tooltip md-direction=top>{{ col.displayName }}</md-tooltip></span><span ui-grid-one-bind-id-grid=\"col.uid + \'-sortdir-text\'\" ui-grid-visible=col.sort.direction aria-label=\"{{ getSortDirectionAriaLabel() }}\"><i ng-class=\"{ \'ui-grid-icon-up-dir\': col.sort.direction == asc, \'ui-grid-icon-down-dir\': col.sort.direction == desc, \'ui-grid-icon-blank\': !col.sort.direction }\" title=\"{{ isSortPriorityVisible() ? i18n.headerCell.priority + \' \' + (col.sort.priority + 1) : null }}\" aria-hidden=true></i><sub ui-grid-visible=isSortPriorityVisible() class=ui-grid-sort-priority-number>{{ col.sort.priority + 1 }}</sub></span></div><div role=button tabindex=0 ui-grid-one-bind-id-grid=\"col.uid + \'-menu-button\'\" ng-if=\"grid.options.enableColumnMenus &amp;&amp; !col.isRowHeader  &amp;&amp; col.colDef.enableColumnMenu !== false\" ng-click=toggleMenu($event) ng-keydown=headerCellArrowKeyDown($event) ui-grid-one-bind-aria-label=i18n.headerCell.aria.columnMenuButtonLabel aria-haspopup=true class=ui-grid-column-menu-button><i aria-hidden=true class=ui-grid-icon-angle-down></i></div><div ui-grid-filter></div></div>");
$templateCache.put("app/input-list/templates/input-list-main-menu.html","<md-menu-bar id=input-list-main-menu-bar flex layout=row><md-menu><button ng-click=$mdMenu.open()>{{ translation.file }}</button><md-menu-content width=3><md-menu-item><md-button ng-click=inputList.onSaveData() ng-disabled=\"!inputList.validatePermission(\'list#\'+inputList.listId+\':update\')\">{{ translation.save }}</md-button></md-menu-item><md-menu-item><md-button ng-click=inputList.onSaveData(true) ng-disabled=\"!inputList.validatePermission(\'list#\'+inputList.listId+\':update\')\">{{ translation.save_and_exit }}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button onclick=\"document.getElementById(\'fileImportArea\').click()\" ng-disabled=\"!inputList.validatePermission(\'list#\'+inputList.listId+\':update\')\">{{ translation.import }}...</md-button><div style=\"display: none\"><input id=fileImportArea type=file rows-remove=inputList.rowsToRemove import-sheet-js=\"\" schema=inputList.schema sheet-data=inputList.importedData is-importing=inputList.isImporting should-replace-data=inputList.shouldReplaceData multiple accept=\".xlsx, .csv\"></div></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-disabled=\"!inputList.validatePermission(\'list#\'+inputList.listId+\':read\')\" ng-click=\"inputList._onExport(\'xlsx\')\">{{ translation.export_as }} (.csv .xlsx)</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button id=btnInputListonGoBack ng-disabled=\"!inputList.validatePermission(\'list#\'+inputList.listId+\':read\')\" ng-click=inputList._onGoBack()>{{ translation.exit }} ??</md-button></md-menu-item></md-menu-content></md-menu><md-menu><button ng-click=$mdMenu.open()>{{ translation.edit }}</button><md-menu-content width=3><md-menu-item><md-button ng-click=\"inputList.insertRow(\'above\')\">{{ translation.insert }} {{ inputList.selectedRows || 1 }} {{ translation.row_above | lowercase }}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"inputList.insertRow(\'below\')\">{{ translation.insert }} {{ inputList.selectedRows || 1 }} {{ translation.row_below | lowercase }}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=inputList.selectAll()>Select All</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=inputList.hideRows() ng-disabled=!inputList.selectedRows>{{ translation.hide_row }}<span ng-if=\"inputList.selectedRows &gt; 1\">s {{ inputList.selectedRowMin + 1 }} - {{ inputList.selectedRowMax + 1 }}</span><span ng-if=\"inputList.selectedRows == 1\">&nbsp;{{ inputList.selectedRowMin + 1 }}</span></md-button></md-menu-item><md-menu-item><md-button ng-click=inputList.unhideRows() ng-disabled=!inputList.selectedRows>{{ translation.unhide_selected }}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=inputList.removeRow() ng-disabled=!inputList.selectedRows>{{ translation.remove_row }}<span ng-if=\"inputList.selectedRows &gt; 1\">s {{ inputList.selectedRowMin + 1 }} - {{ inputList.selectedRowMax + 1 }}</span><span ng-if=\"inputList.selectedRows == 1\">&nbsp;{{ inputList.selectedRowMin + 1 }}</span></md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=inputList.onClearAll($event)>{{ translation.clear_all }}</md-button></md-menu-item></md-menu-content></md-menu><md-menu><button ng-disabled=\"!inputList.validatePermission(\'list#\'+inputList.listId+\':read\')\" ng-click=$mdMenu.open()>{{ translation.tools }}</button><md-menu-content width=3><md-menu-item><md-button ng-click=inputList.validateData()>{{ translation.validate }}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=inputList.showFormatDialog($event)>{{ translation.format }}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=inputList.showFilterDialog($event)><span>{{ translation.filter_by }}</span><b style=\"margin-left: 5px\">{{ inputList.selectedCol }}</b></md-button></md-menu-item><md-menu-item><md-button ng-click=inputList.showReplaceDialog($event)><span>{{ translation.find_and_replace }}</span><b style=\"margin-left: 5px\">{{ inputList.selectedCol }}</b></md-button></md-menu-item><md-menu-item><md-button ng-click=inputList.unFilterData(true)>{{ translation.remove_filters }}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=inputList.showHiddenRows()><div layout=row flex><p flex>{{ translation.show_hidden_rows }}</p><md-icon md-menu-align-target md-font-set=material-icons ng-show=inputList.mustShowHiddenRows>done</md-icon></div></md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=inputList._onAutoSavePressed()><div layout=row flex><p flex>{{ translation.auto_save }}</p><md-icon md-menu-align-target md-font-set=material-icons ng-show=inputList.autoSaving>done</md-icon></div></md-button></md-menu-item></md-menu-content></md-menu><md-menu><button ng-disabled=\"!inputList.validatePermission(\'list#\'+inputList.listId+\':read\')\" ng-click=$mdMenu.open()>{{ translation.help }}</button><md-menu-content width=3><md-menu-item><md-button ng-click=inputList.showInfo($event)>{{ translation.schema }} {{ translation.info | lowercase }}</md-button></md-menu-item></md-menu-content></md-menu><button ng-class=\"errorMsg ? &quot;autoSave_error&quot; : &quot;autoSave_ok&quot;\">{{ autoSaveMessage }}</button><md-menu ng-if=inputList.isFiltered><button ng-click=$mdMenu.open() style=\"color: orange\"><md-icon style=\"color: orange\" md-font-set=material-icons>filter_list</md-icon><span>Data Filtered</span></button><md-menu-content width=3><md-menu-item><md-button ng-click=inputList.showFilterDialog($event)><span>{{ translation.filter_by }}</span><b style=\"margin-left: 5px\">{{ inputList.selectedCol }}</b></md-button></md-menu-item><md-menu-item><md-button ng-click=inputList.unFilterData(true)>{{ translation.remove_filters }}</md-button></md-menu-item></md-menu-content></md-menu><div style=\"margin-left: auto;flex-grow: 1\"></div><auto-refresh-menu on-tick=inputList.reload()></auto-refresh-menu><button style=\"color: orange\" ng-if=inputList.updatingData><span>{{ translation.updating_list_msg }}</span></button></md-menu-bar>");
$templateCache.put("app/input-list/templates/table-list-main-menu.html","<md-menu-bar id=table-list-main-menu-bar layout=row><md-menu><button ng-click=$mdMenu.open()>{{ translation.tools }}</button><md-menu-content width=3><md-menu-item><md-button ng-click=ctrl.unFilterData()>{{ translation.remove_filters }}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=ctrl.exportList(&quot;xlsx&quot;)>{{ translation.export }} (.csv .xlsx)</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=ctrl.getBack()>{{ translation.exit }}</md-button></md-menu-item></md-menu-content></md-menu><button ng-if=ctrl.list.updatingData style=\"color: orange\"><span>{{ translation.updating_list_msg }}</span></button><section layout=row style=\"padding: 5px\"><div ng-repeat=\"(key, predicate) in ctrl.filters.predicates\" style=\"margin-right: 5px; font-size: 0.7em; line-height: 2em\" class=\"text-center cep-badge\">{{ predicate.label }} {{ predicate.operation | lowercase }} &nbsp;<span ng-if=\"predicate.value != null\"><b ng-switch=\"\" on=predicate.label><span ng-switch-when=data|time ng-switch-when-separator=|>{{ ctrl.parsePredicateValue(predicate) | asDate }}</span><span ng-switch-when=timestamp ng-switch-when-separator=|>{{ ctrl.parsePredicateValue(predicate) | asDateHour }}</span><span ng-switch-default=\"\">{{ ctrl.parsePredicateValue(predicate) }}</span></b></span><span ng-if=\"predicate.value == null\">{{ predicate.valuesLabels.join(\', \') }}</span>&nbsp;<div style=\"margin-left: 5px\" ng-click=ctrl.removeFilter(key) class=\"fa fa-times\"></div></div><div ng-if=ctrl.isFiltered ng-click=ctrl.unFilterData() style=\"margin-right: 5px; font-size: 0.7em; line-height: 2em\" class=\"text-center cep-badge\">Remove filters</div></section><div style=\"margin-left: auto;flex-grow: 1\"></div><auto-refresh-menu on-tick=ctrl.reload()></auto-refresh-menu></md-menu-bar>");
$templateCache.put("app/input-list/templates/workbook-selector.html","<md-dialog aria-label=\"Import to lists\" style=\"min-width: 40vw\"><md-dialog-content><md-toolbar layout=row style=\"border-bottom: 1px solid #e8e8e8\" class=md-menu-toolbar><md-toolbar-filler layout layout-align=\"center center\" class=main-color><md-icon md-font-set=material-icons md-menu-align-target>cloud_upload</md-icon></md-toolbar-filler><div class=w100><div layout=row class=w100><h2 flex class=md-toolbar-tools><span>{{ translation.title_import }}</span></h2><round-button on-click=ctrl.abortSelection() aria-label=Close icon=clear style=\"position:relative; top:10px\"></round-button></div></div></md-toolbar><md-content class=md-dialog-content><div style=font-size:1.3em>{{ translation.file }}: {{ fileName }}</div><md-divider></md-divider><br><div layout=column><section flex layout=row><div flex ng-if=isCsv layout=column style=\"padding: 0px 15px\"><md-input-container style=\"margin-bottom:0px; padding:0px\"><label>{{ translation.separator }} (CSV)</label><input type=text ng-model=ctrl.separator style=\"font-weight: 800; padding-left: 50%; padding-bottom: 10px; font-size: 1.5em\"></md-input-container><md-button type=button ng-click=ctrl.loadData() class=\"md-raised md-warn\"><span>{{ translation.parse }}</span></md-button></div><div flex ng-if=\"workbook.SheetNames.length &gt; 1\" style=\"padding: 0px 15px\"><p>{{ translation.msg_select_sheet }}</p><div class=\"md-dialog-content-body ng-binding ng-scope\"><md-radio-group ng-model=ctrl.selection ng-change=ctrl.loadData()><md-radio-button ng-repeat=\"(key, sheet) in workbook.SheetNames\" ng-value=key class=md-primary>{{ sheet }}</md-radio-button></md-radio-group></div></div><div flex style=\"padding: 0px 15px\"><p>{{ translation.import_options }}</p><div class=\"md-dialog-content-body ng-binding ng-scope\"><md-radio-group ng-model=ctrl.shouldReplaceData><md-radio-button ng-value=true class=md-primary>{{ translation.replace_current_data }}</md-radio-button><md-radio-button ng-value=false class=md-primary>{{ translation.add_to_current_data }}</md-radio-button></md-radio-group></div></div><div flex style=\"padding: 0px 15px\"><span>Total {{ translation.cols }}:&nbsp;&nbsp;</span><b>{{ workbookCols[workbook.SheetNames[ctrl.selection]].length }}</b><ul><li ng-repeat=\"column in workbookCols[workbook.SheetNames[ctrl.selection]]\">{{ column.val }}</li></ul></div></section></div></md-content></md-dialog-content><md-dialog-actions layout=column layout-align=\"end end\" style=height:90px><div style=text-align:right class=w100><md-divider></md-divider>{{ translation.msg_import }};<b>{{ translation.warn_import }}</b></div><div><section ng-hide=workbook><span>{{ translation.reading_file_data }}</span><md-progress-linear></md-progress-linear></section><section ng-show=workbook><md-button type=button ng-click=ctrl.abortSelection() class=md-raised><span>{{ translation.cancel }}</span></md-button><md-button type=button ng-click=ctrl.selectSheet(ctrl.selection) class=md-raised><span>{{ translation.import }}</span></md-button></section></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/issues/dialog/advance-search.html","<md-dialog aria-label=createIssue><form><md-toolbar><div class=md-toolbar-tools><h2>Busqueda avanzada</h2><span flex=\"\"></span><md-button ng-click=cancel() class=md-icon-button>X</md-button></div></md-toolbar><md-dialog-content style=width:70vw><section layout=row layout-padding=\"\"><div flex=100><md-input-container class=w100><label>Entidad</label><md-select ng-model=xxxx><md-option><em>None</em></md-option><md-option ng-value=0>Entidad financiera</md-option></md-select></md-input-container></div></section><section layout=row layout-padding=\"\"><div flex=100><h4>Filtros</h4></div></section><section layout=row layout-padding=\"\"><div flex=30><md-input-container class=w100><label>Criterio</label><md-select ng-model=xxxx><md-option><em>None</em></md-option><md-option ng-value=0>Nombre</md-option></md-select></md-input-container></div><div flex=30><md-input-container class=w100><label>Operacion</label><md-select ng-model=xxxx><md-option><em>None</em></md-option><md-option ng-value=0>IS</md-option></md-select></md-input-container></div><div flex=30><md-input-container class=w100><label>Valor</label><md-select ng-model=xxxx><md-option><em>None</em></md-option><md-option ng-value=0>Santander</md-option></md-select></md-input-container></div><div flex=10><md-button><md-icon md-font-set=material-icons md-menu-align-target>delete</md-icon></md-button></div></section><section layout=row layout-align=\"center center\"><div flex=50 class=text-center><md-button class=md-primary>Agregar filtro</md-button></div></section><section layout=row layout-padding=\"\"><div flex=60><md-input-container class=w100><label>Sorting</label><md-select ng-model=xxxx><md-option><em>None</em></md-option><md-option ng-value=0>Nombre</md-option><md-option ng-value=0>prodcuto</md-option><md-option ng-value=0>rut</md-option></md-select></md-input-container></div><div flex=40><md-input-container class=w100><label>Order</label><md-select ng-model=xxxx><md-option><em>None</em></md-option><md-option ng-value=0>DESC</md-option><md-option ng-value=0>ACS</md-option></md-select></md-input-container></div></section></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel()>cancelar</md-button><md-button ng-click=cancel() style=margin-right:20px class=\"md-raised md-primary\">Buscar</md-button><md-button ng-click=saveTab() style=margin-right:20px class=\"md-raised md-primary\">Buscar y crear vista</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/issues/dialog/assigResp.html","<md-dialog aria-label=createIssue><form><md-toolbar><div class=md-toolbar-tools><h2>Asignar responsable</h2><span flex=\"\"></span><md-button ng-click=cancel() class=md-icon-button>X</md-button></div></md-toolbar><md-dialog-content style=width:70vw><section layout=row layout-padding=\"\"><div flex=50><md-input-container class=w100><label>Usuarios</label><md-select ng-model=ctrl.assigned multiple><md-option ng-repeat=\"user in ctrl.users track by $index\" ng-value=user>{{user}}</md-option></md-select></md-input-container></div><div flex=50><h4>Lista de indicios -<b>{{ctrl.selecteds.lenght}}</b></h4><div ng-repeat=\"selected in ctrl.selecteds track by selected.id\" class=\"w100 md-block\"><p>{{selected.indicio}}</p></div></div></section></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel()>cancelar</md-button><md-button ng-click=toAssign() style=margin-right:20px class=\"md-raised md-primary\">Asignar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/issues/dialog/create-issue.html","<md-dialog aria-label=createIssue><form><md-toolbar><div class=md-toolbar-tools><h2>Crear indicio</h2><span flex=\"\"></span><md-button ng-click=cancel() class=md-icon-button>X</md-button></div></md-toolbar><md-dialog-content style=width:70vw><section layout=row layout-padding=\"\"><div flex=50><md-input-container class=w100><label>Tipo de indicio</label><md-select ng-model=issue.form.tipo><md-option><em>None</em></md-option><md-option ng-value=0>Movimiento bancario</md-option></md-select></md-input-container><md-input-container class=w100><label>Motivo</label><md-select ng-model=issue.form.motivo><md-option><em>None</em></md-option><md-option ng-value=0>Mal uso de cuenta de ahorro</md-option></md-select></md-input-container><md-input-container class=w100><label>Categorias</label><md-select ng-model=issue.form.categorias multiple><md-optgroup label=Categorias><md-option ng-repeat=\"catg in issue.categoriasOption\" ng-value=catg>{{catg}}</md-option></md-optgroup></md-select></md-input-container><md-input-container class=w100><label>Criticidad</label><md-select ng-model=issue.form.criticidad><md-option><em>None</em></md-option><md-option ng-value=0>Alta</md-option></md-select></md-input-container><md-input-container class=w100><label>Estado</label><md-select ng-model=issue.form.estado><md-option><em>None</em></md-option><md-option ng-value=0>No visto</md-option></md-select></md-input-container><md-input-container class=w100><label>Comentarios</label><textarea ng-model=issue.form.comentarios md-maxlength=150 rows=3 md-select-on-focus=\"\"></textarea></md-input-container></div><div flex=50><md-input-container class=w100><label>Entidad</label><md-select ng-model=issue.form.entidad><md-option><em>None</em></md-option><md-option ng-value=0>Entidades financieras</md-option></md-select></md-input-container><md-input-container class=w100><label>RUT</label><input ng-model=issue.form.rut type=text></md-input-container><md-input-container class=w100><label>Cargo</label><input ng-model=issue.form.cargo type=text></md-input-container><md-input-container class=w100><label>Nombre</label><input ng-model=issue.form.nombre type=text></md-input-container><md-input-container class=w100><uploader label=\"carga archivos de evidencias\" directory=issues/files valid=[pdf,png] multiple></uploader></md-input-container></div></section></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel()>cancelar</md-button><md-button ng-click=issue.saveIssue() style=margin-right:20px class=\"md-raised md-primary\">Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/issues/dialog/helperDialog.html","<md-dialog aria-label=createIssue><form><md-toolbar><div class=md-toolbar-tools><h2><md-icon md-font-set=material-icons md-menu-align-target>help_outline</md-icon>Indicios</h2><span flex=\"\"></span><md-button ng-click=cancel() class=md-icon-button>X</md-button></div></md-toolbar><md-dialog-content style=width:70vw><section layout=row layout-padding=\"\"><div flex><p>En esta vista podrás ver todos los indicios que te han sido asignados, como opción default hemos dejado los indicios nuevos.</p><p>También puedes crear tus propias vistas personalizadas de indicios basadas en determinados criterios</p></div></section></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel()>Salir</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/issues/dialog/issue-detail.html","<md-dialog aria-label=createIssue><form><md-toolbar><div class=md-toolbar-tools><h2>#10 - Movimientos sospechosos en cuenta de ahorro</h2><span flex=\"\"></span><md-button ng-click=cancel() class=md-icon-button>X</md-button></div></md-toolbar><md-dialog-content style=width:75vw><section layout=row layout-padding=\"\" layout-wrap=\"\"><div flex=70><p class=w100>Motivo</p><h3 class=m0>Movimientos sospechosos en cuenta de ahorro</h3><md-tabs style=\"min-height: 430px !important\" class=w100><md-tab label=Evidencias><md-content class=md-padding><evidences></evidences></md-content></md-tab><md-tab label=Comentarios><md-content class=md-padding><comments></comments></md-content></md-tab><md-tab label=Historial><md-content class=md-padding><historical></historical></md-content></md-tab><md-tab label=\"Indicios vinculaos\"><md-content class=md-padding><linked-issues></linked-issues></md-content></md-tab></md-tabs></div><div flex=30 style=\"background: #efefef\"><section layout=row layout-padding=\"\" layout-wrap=\"\"><md-input-container class=w100><label>Estado</label><md-select ng-model=issue.form.estado><md-option><em>None</em></md-option><md-option ng-value=0 selected>No visto</md-option></md-select></md-input-container><p class=w100>RUT: <b>112233-44</b></p><p class=w100>Nombres: <b>Pedro Andres</b></p><p class=w100>Apellidos: <b>Perez Rojas</b></p><p class=w100>Cargo: <b>Ministro de tecnologia</b></p><p class=w100>Asignado a: <b>OMARTINEZ</b></p><p class=w100>Criticidad <b>ALTA</b></p><p class=w100>Fecha de creacion <b>10/10/2019</b></p><div flex=50><md-button ng-click=exportPDF() style=margin-right:20px class=\"md-raised md-primary\">Exoratar PDF</md-button></div><div flex=50><md-button ng-click=cancel()>cancelar</md-button></div></section></div></section></md-dialog-content></form></md-dialog>");
$templateCache.put("app/issues/dialog/linkedIssues.html","<md-dialog aria-label=createIssue><form><md-toolbar><div class=md-toolbar-tools><h2>Vincular</h2><span flex=\"\"></span><md-button ng-click=cancel() class=md-icon-button>X</md-button></div></md-toolbar><md-dialog-content style=width:70vw><section layout=row layout-padding=\"\"><div flex=50><md-input-container class=w100><label>Nombre</label><input ng-model=ctrl.nombre type=text></md-input-container><md-input-container class=w100><label>Comentarios</label><textarea ng-model=ctrl.comentarios md-maxlength=150 rows=3></textarea></md-input-container><md-input-container class=w100><label>vincular a</label><md-select ng-model=ctrl.linked><md-option><em>None</em></md-option><md-option ng-value=1>casos</md-option><md-option ng-value=2>reporte</md-option></md-select></md-input-container><md-input-container class=w100><label>Usuarios</label><md-select ng-model=ctrl.assigned multiple><md-option ng-repeat=\"user in ctrl.users track by $index\" ng-value=user>{{user}}</md-option></md-select></md-input-container></div><div flex=50><h4>Lista de indicios -<b>{{ctrl.selecteds.lenght}}</b></h4><div ng-repeat=\"selected in ctrl.selecteds track by selected.id\" class=\"w100 md-block\"><p>{{selected.indicio}}</p></div></div></section><section layout=row layout-align=\"center center\"><md-toolbar class=alert-media><div class=md-toolbar-tools><p style=color:#000 class=\"w100 text-center\"><md-icon md-font-set=material-icons md-menu-align-target style=color:#000>warning</md-icon>IMPORTANTE: Los indicios vinculados serán bloquedos</p></div></md-toolbar></section></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel()>cancelar</md-button><md-button ng-click=toAssign() style=margin-right:20px class=\"md-raised md-primary\">Asignar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/issues/dialog/save-search.html","<md-dialog aria-label=createIssue><form><md-toolbar><div class=md-toolbar-tools><h2>Nueva vista personalizada</h2><span flex=\"\"></span><md-button ng-click=cancel() class=md-icon-button>X</md-button></div></md-toolbar><md-dialog-content style=width:20vw><section layout=row layout-padding=\"\"><div flex=100><md-input-container class=w100><label>Nombre</label><input ng-model=ctrl.tab.nombre type=text></md-input-container><md-input-container class=w100><label>descripcion</label><input ng-model=ctrl.tab.descripcion type=text></md-input-container></div></section></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel()>cancelar</md-button><md-button ng-click=ctrl.save() style=margin-right:20px class=\"md-raised md-primary\">Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/lists/templates/input-list-tree-view.html","<md-list id=listsTree><div ng-repeat=\"(key, val) in schemasList.listsTree\"><lists-group-item ng-if=!key.includes(&quot;ROOT&quot;) group=val display-items=schemasList.displayItems schemas=schemasList.schemas translation=translation></lists-group-item></div><div ng-repeat=\"item in schemasList.listsTree[&quot;folder:ROOT&quot;].items\"><lists-list-item item=item schemas=schemasList.schemas translation=translation></lists-list-item></div></md-list>");
$templateCache.put("app/login/password-recovery/password-recovery.html","<div id=login-app-view><div></div><section layout=column layout-align=\"center stretch\" style=\"width: 70vw; margin: 0 auto\"><section flex layout-align=\"center stretch\"><section layout=row layout-align=\"center stretch\"><div flex=80><div style=\"margin: 2rem 0\" class=\"themeLogo themeLogo\"></div></div></section></section><section flex layout=row layout-wrap><form action=\"\" flex=100 flex-sm=\"{{ passwordPolicy.showPasswordPolicy ? 40 : 100 }}\" flex-md=\"{{ passwordPolicy.showPasswordPolicy ? 40 : 100 }}\"><md-input-container ng-class=\"{ &quot;has-error&quot;: form.$submitted &amp;&amp; form.username.$invalid }\" class=\"w100 m0 md-block\"><label class=active>{{ translation.new_password }}</label><md-icon md-font-set=material-icons md-menu-align-target>lock</md-icon><input id=recovery-password-c type=\"{{ inputType }}\" ng-model=recovery.password class=input-recovery><md-icon md-font-set=material-icons md-menu-align-target ng-click=togglePassView() class=text-muted>{{ inputType == \'password\' ? \'visibility_off\' : \'visibility\' }}<md-tooltip md-direction=right>{{ translation.show_password }}</md-tooltip></md-icon></md-input-container><md-input-container ng-class=\"{ &quot;has-error&quot;: form.$submitted &amp;&amp; form.password.$invalid }\" class=\"w100 m0 md-block\"><label class=active>{{ translation.confirm_password }}</label><md-icon md-font-set=material-icons md-menu-align-target>lock</md-icon><input id=recovery-password-confirmation type=\"{{ inputType }}\" ng-model=recovery.password_confirmation class=input-recovery><md-icon class=text-muted></md-icon></md-input-container><md-input-container class=\"w100 m0 text-right\"></md-input-container><md-input-container class=\"w100 m0\"><md-button autofocus tabindex=1 type=submit ng-disabled=request ng-click=cambiarPassword() style=\"color: #fff\" class=\"md-raised main-color w100 m0\">{{ translation.reset_password_cep }}</md-button></md-input-container></form><div ng-if=passwordPolicy.showPasswordPolicy flex=100 flex-sm=50 flex-md=50 style=\"padding-left: 2rem; border-left: 4px solid #eaeaea; margin-left: 2rem\"><span>{{ translation.password_rules }}<p ng-if=\"passwordPolicy.minimumPasswordLength &amp;&amp; passwordPolicy.minimumPasswordLength &gt; 0\" ng-class=\"passwordPolicy.minimumPasswordLengthGreen ? &quot;green-text&quot;:&quot;red-text&quot;\"><md-icon ng-class=\"passwordPolicy.minimumPasswordLengthGreen ? &quot;green-text&quot;:&quot;red-text&quot;\">{{ passwordPolicy.minimumPasswordLengthGreen ? \'check_circle\' : \'cancel\' }}</md-icon>{{ translation.password_length_1 }} {{ passwordPolicy.minimumPasswordLength }} {{ translation.password_length_2 }}</p><p ng-if=passwordPolicy.withAtLeastOneUppercase ng-class=\"passwordPolicy.withAtLeastOneUppercaseGreen ? &quot;green-text&quot;:&quot;red-text&quot;\"><md-icon ng-class=\"passwordPolicy.withAtLeastOneUppercaseGreen ? &quot;green-text&quot;:&quot;red-text&quot;\">{{ passwordPolicy.withAtLeastOneUppercaseGreen ? \'check_circle\' : \'cancel\' }}</md-icon>{{ translation.at_least_one_uppercase_character }}</p><p ng-if=passwordPolicy.withAtLeastOneLowercase ng-class=\"passwordPolicy.withAtLeastOneLowercaseGreen ? &quot;green-text&quot;:&quot;red-text&quot;\"><md-icon ng-class=\"passwordPolicy.withAtLeastOneLowercaseGreen ? &quot;green-text&quot;:&quot;red-text&quot;\">{{ passwordPolicy.withAtLeastOneLowercaseGreen ? \'check_circle\' : \'cancel\' }}</md-icon>{{ translation.at_least_one_lowercase_character }}</p><p ng-if=passwordPolicy.withAtLeastOneDigit ng-class=\"passwordPolicy.withAtLeastOneDigitGreen ? &quot;green-text&quot;:&quot;red-text&quot;\"><md-icon ng-class=\"passwordPolicy.withAtLeastOneDigitGreen ? &quot;green-text&quot;:&quot;red-text&quot;\">{{ passwordPolicy.withAtLeastOneDigitGreen ? \'check_circle\' : \'cancel\' }}</md-icon>{{ translation.at_least_one_digit }}</p><p ng-if=passwordPolicy.withAtLeastOneSymbol ng-class=\"passwordPolicy.withAtLeastOneSymbolGreen ? &quot;green-text&quot;:&quot;red-text&quot;\"><md-icon ng-class=\"passwordPolicy.withAtLeastOneSymbolGreen ? &quot;green-text&quot;:&quot;red-text&quot;\">{{ passwordPolicy.withAtLeastOneSymbolGreen ? \'check_circle\' : \'cancel\' }}</md-icon>{{ translation.at_least_one_special_character }}</p></span></div></section><div ng-show=show class=\"alert alert-danger ceptinel-error\">{{ content }}</div></section></div>");
$templateCache.put("app/realtime-rule-editor/templates/realtime-rule-editor-menu.html","<md-menu-bar class=rule-editor-menu><md-menu><button id=rule-editor-file-menu ng-click=$mdMenu.open()>{{ ctrl.translation.file }}</button><md-menu-content width=3><md-menu-item><md-button ng-click=ruleEditor.saveFlowchart()>{{ ctrl.translation.save }}</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button ng-disabled=!ruleEditor.validatePermission(&quot;update&quot;) ng-click=\"ruleCRUD.openEditor($event, ruleEditor.functionData)\">{{ ctrl.translation.edit_rule_attr }}</md-button></md-menu-item><md-menu-item><md-button ng-click=_onGoTo(&quot;app.rule-executions&quot;)>{{ ctrl.translation.versions }} & {{ ctrl.translation.executions }}</md-button></md-menu-item><md-menu-item><md-button ng-click=ruleEditor.exportRule()>{{ ctrl.translation.export_as_json }}</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button ng-click=_onGoBack()>{{ ctrl.translation.exit }}</md-button></md-menu-item></md-menu-content></md-menu><md-menu><button id=rule-editor-pipeline-menu ng-click=$mdMenu.open()>Pipeline</button><md-menu-content width=3><md-menu-item><md-button ng-click=ruleEditor.showVersions() ng-disabled=!ruleEditor.validatePermission(&quot;read-version&quot;)>{{ ctrl.translation.versioning }}</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button ng-click=ruleEditor.createVersion() ng-disabled=\"!ruleEditor.validatePermission(&quot;create-version&quot;) || ruleEditor.isVersioned\">{{ ctrl.translation.create_version }}</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button ng-click=ruleEditor.getCurrentVersion() ng-disabled=!ruleEditor.isVersioned>{{ ctrl.translation.return_current }}</md-button></md-menu-item><md-menu-item><md-button ng-click=ruleEditor.setCurrentVersion() ng-disabled=!ruleEditor.isVersioned>{{ ctrl.translation.set_current }}</md-button></md-menu-item></md-menu-content></md-menu><md-menu><button id=rule-editor-selection-menu ng-click=$mdMenu.open()>{{ ctrl.translation.selection }}</button><md-menu-content width=3><md-menu-item><md-button ng-click=ruleEditor.deleteMultiTransformation() ng-disabled=!ruleEditor.multiSelection.length>{{ ctrl.translation.delete }} {{ ctrl.translation.selected | lowercase }} ({{ ruleEditor.multiSelection.length }})</md-button></md-menu-item><md-menu-item><md-button ng-click=showProperties()>{{ ctrl.translation.properties }}</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button ng-click=ruleEditor.copyTransformation()>{{ ctrl.translation.copy }} {{ ctrl.translation.transformation }}</md-button></md-menu-item><md-menu-item><md-button ng-click=ruleEditor.pasteTransformation($event)>{{ ctrl.translation.paste }} {{ ctrl.translation.transformation }}</md-button></md-menu-item></md-menu-content></md-menu><md-menu><button id=rule-editor-window-menu ng-click=$mdMenu.open()>{{ ctrl.translation.windows }}</button><md-menu-content width=3><md-menu-item><md-button ng-click=ruleEditor.toggleBoxStats()><div layout=row flex><p flex><b>{{ showBoxStats ? ctrl.translation.hide : ctrl.translation.show }}</b>{{ ctrl.translation.box_stats }}</p></div></md-button></md-menu-item><md-menu-item><md-button ng-click=ruleEditor.toggleTransformationBar()><div layout=row flex><p flex><b>{{ showTransformationBar ? ctrl.translation.hide : ctrl.translation.show }}</b>&nbsp; {{ ctrl.translation.rules_transformation_box }}</p></div></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>");
$templateCache.put("app/replay/component/chart-bar-echarts.html","<div layout=column layout-padding><ng-include src=\"\'app/replay/component/includes/menu.html\'\"></ng-include><div id=echarts-bar-{{ctrl.replayId}}-{{ctrl.chart.id}} style=\"width:100%; height:500px\"></div></div>");
$templateCache.put("app/replay/component/chart-line-echarts.html","<div layout=column layout-padding=\"\"><ng-include src=\"\'app/replay/component/includes/menu.html\'\"></ng-include><div id=echarts-line-{{ctrl.replayId}}-{{ctrl.chart.id}} style=\"width:100%; height:500px\"></div></div>");
$templateCache.put("app/replay/component/chart-table.html","<md-card><div layout=column><h3 style=\"text-align: center\">{{ctrl.chart.name}}</h3><ng-table-dynamic_2 id=alerts-replay-table fn-config=ctrl.initGrid show-top-bar=true show-workspaces-button=false show-filter-button=true show-refresh-button=false show-export-csv-button=false show-ranking-button=false refresh-schemas=false></ng-table-dynamic_2></div></md-card>");
$templateCache.put("app/replay/config/dialog-chart.html","<md-dialog aria-label={{translation.chart}} style=width:700px ng-cloak=\"\"><form name=chartForm novalidate id=dialog-chart><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{actionText}}</h2><span flex></span><md-button ng-click=cancel($event) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout-padding=19 style=\"margin:15px 0px 0px 0px\"><div layout=row><md-input-container flex=60 class=m0><label>{{translation.name}}</label><input type=text ng-model=chart.name required md-maxlength=50 maxlength=50></md-input-container><md-input-container flex=20 class=\"md-block m0\"><label>{{translation.chart_type}}</label><md-select ng-model=chart.type ng-disabled=chart.id required><md-option value=LINE>{{translation.chart_type_line}}</md-option><md-option value=BAR>{{translation.chart_type_bar}}</md-option><md-option value=TABLE>{{translation.chart_type_table}}</md-option></md-select></md-input-container><md-input-container flex=20 class=m0><label>Series Type</label><md-select ng-model=chart.seriesType required ng-change=onChangeSeriesType(chart.seriesType)><md-option value=TIME>TIME</md-option><md-option value=ALPHANUMERIC>ALPHANUMERIC</md-option></md-select></md-input-container></div><div layout=column ng-if=\"chart.type ==\'TABLE\'\"><div layout=row><div flex=30><md-input-container class=\"w100 m0\"><label>Source</label><md-select ng-model=chart.source ng-required=\"chart.type ==\'TABLE\'\"><md-option value=EVENT>EVENT</md-option><md-option value=SERIES>SERIES</md-option></md-select></md-input-container></div><div flex=70 ng-if=\"chart.source ==\'SERIES\'\"><md-input-container class=\"w100 m0\"><label>{{translation.line_type_series}}</label><md-select ng-model=chart.tableSeriesId ng-required=\"chart.source ==\'SERIES\'\"><md-option ng-value=option.id ng-repeat=\"option in seriesSource\">{{option.name}}</md-option></md-select></md-input-container></div></div><div ng-if=\"chart.source ==\'EVENT\'\" style=\"margin:25px 0px 0px 0px\"><div layout=row><div flex=50><md-input-container class=\"w100 m0\"><label>{{translation.label}}</label><md-select ng-model=chart.labelId ng-change=changeLabel(chart.labelId) ng-required=\"chart.type ==\'TABLE\'\"><md-option ng-value=label.labelName ng-repeat=\"label in labels\">{{label.labelName}}</md-option></md-select></md-input-container></div><div flex=50><md-input-container class=\"w100 m0\"><label>Functions</label><md-select ng-model=chart.functionId ng-change=changeFunction(chart.functionId) ng-required=\"chart.type ==\'TABLE\'\"><md-option ng-value=item.id ng-repeat=\"item in functions\">{{item.name}}</md-option></md-select></md-input-container></div></div><div layout=row style=\"margin-top: 25px\"><div flex=50><md-input-container class=\"w100 m0\"><label>Display</label><md-select ng-model=chart.columnTable multiple required><md-option ng-value=item.name ng-repeat=\"item in functionColumnsView\">{{item.name}}</md-option></md-select></md-input-container></div><div flex=50><md-input-container class=\"w100 m0\"><label>Filter</label><md-select ng-model=chart.columnFilter multiple required><md-option ng-value=item.name ng-repeat=\"item in functionColumnsView\">{{item.name}}</md-option></md-select></md-input-container></div></div></div></div><div layout=row ng-if=\"chart.type !=\'TABLE\' &amp;&amp; chart.seriesType == \'TIME\'\"><md-input-container flex=50 class=m0><label>{{translation.time_interval}}</label><md-select ng-model=chart.timeInterval multiple ng-required=\"chart.seriesType == \'TIME\'\"><md-option value=tick>TICK</md-option><md-option value=minute>MINUTE</md-option><md-option value=hour>HOUR</md-option><md-option value=day>DAY</md-option><md-option value=week>WEEK</md-option><md-option value=month>MONTH</md-option></md-select></md-input-container></div><div layout=row ng-if=\"chart.type ==\'LINE\'\"><md-input-container flex=30 class=m0><md-checkbox ng-model=chart.showFilter aria-label=\"Show Search Filter\">{{translation.show_search_filter}}</md-checkbox></md-input-container><md-input-container flex=30 class=m0><md-checkbox ng-model=chart.showLegend aria-label=\"Show Legend\">{{translation.show_legend}}</md-checkbox></md-input-container><md-input-container flex=30 class=m0><md-checkbox ng-model=chart.multipleYaxis aria-label=\"Multiple Y-Axis\">{{translation.multiple_y_axis}}</md-checkbox></md-input-container></div><div layout=row ng-if=\"chart.type ==\'BAR\'\"><md-input-container flex=30 class=m0><md-checkbox ng-model=chart.showFilter aria-label=\"Show Search Filter\">{{translation.show_search_filter}}</md-checkbox></md-input-container><md-input-container flex=50 class=m0><md-checkbox ng-model=chart.stacked aria-label=Stacked>{{translation.stacked}}</md-checkbox></md-input-container><md-input-container flex=50 class=\"md-block m0\"><md-checkbox ng-model=chart.showLegend aria-label=\"Show Legend\">{{translation.show_legend}}</md-checkbox></md-input-container></div><div layout=column ng-if=\"chart.type ==\'LINE\'\"><div layout=row><label>Series:&#32;</label><md-radio-group ng-model=chart.seriesModeSelection ng-change=onChangeSeriesModeSelection() style=\"display: inline-flex\"><md-radio-button value=BY_PREFIX class=md-primary>By prefix&#32;</md-radio-button><md-radio-button value=BY_SELECTION>By selection</md-radio-button></md-radio-group></div><div layout=row ng-if=\"chart.seriesModeSelection == \'BY_PREFIX\'\"><md-input-container style=\"margin-right: 10px\" flex=50><label>{{translation.line_type_series}}</label><input type=text ng-model=chart.prefixLine md-maxlength=50 maxlength=50></md-input-container><md-input-container style=\"margin-right: 10px\" flex=50><label>{{translation.column_type_series}}</label><input type=text ng-model=chart.prefixColumn md-maxlength=50 maxlength=50></md-input-container><md-input-container style=\"margin-right: 10px\" flex=50><label>{{translation.bubble_type_series}}</label><input type=text ng-model=chart.prefixBubble md-maxlength=50 maxlength=50></md-input-container></div><div layout=row ng-if=\"chart.seriesModeSelection == \'BY_SELECTION\'\"><md-input-container style=\"margin-right: 10px\" flex=50><label>{{translation.line_type_series}}</label><md-select ng-model=chart.seriesLine placeholder={{translation.line_type_series}} data-md-container-class=selectSelectHeader multiple><md-select-header class=select-header><input ng-model=searchTermLine type=search ng-keydown=$event.stopPropagation() placeholder=Search... class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=series><md-option ng-value=option.id ng-repeat=\"option in seriesSource | filter: searchTermLine\">{{option.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container style=\"margin-right: 10px\" flex=50><label>{{translation.column_type_series}}</label><md-select ng-model=chart.seriesColumn placeholder={{translation.column_type_series}} data-md-container-class=selectSelectHeader multiple><md-select-header class=select-header><input ng-model=searchTermColumn type=search ng-keydown=$event.stopPropagation() placeholder=Search... class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=series><md-option ng-value=option.id ng-repeat=\"option in seriesSource | filter: searchTermColumn\">{{option.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container style=\"margin-right: 10px\" flex=50><label>{{translation.bubble_type_series}}</label><md-select ng-model=chart.seriesBubble placeholder={{translation.bubble_type_series}} data-md-container-class=selectSelectHeader multiple><md-select-header class=select-header><input ng-model=searchTermBubble type=search ng-keydown=$event.stopPropagation() placeholder=Search... class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=series><md-option ng-value=option.id ng-repeat=\"option in seriesSource | filter: searchTermBubble\">{{option.name}}</md-option></md-optgroup></md-select></md-input-container></div></div><div layout=column ng-if=\"chart.type ==\'BAR\'\"><div layout=row><label>Series:&#32;</label><md-radio-group ng-model=chart.seriesModeSelection ng-change=onChangeSeriesModeSelection() style=\"display: inline-flex\"><md-radio-button value=BY_PREFIX class=md-primary>By prefix&#32;</md-radio-button><md-radio-button value=BY_SELECTION>By selection</md-radio-button></md-radio-group></div><div layout=row ng-if=\"chart.seriesModeSelection == \'BY_PREFIX\'\"><md-input-container style=\"margin-right: 10px\" flex=50><label>{{translation.column_type_series}}</label><input type=text ng-model=chart.prefixColumn md-maxlength=50 maxlength=50></md-input-container></div><div layout=row ng-if=\"chart.seriesModeSelection == \'BY_SELECTION\'\"><md-input-container style=\"margin-right: 10px\" flex=100><label>{{translation.column_type_series}}</label><md-select ng-model=chart.seriesColumn placeholder={{translation.column_type_series}} data-md-container-class=selectSelectHeader multiple><md-select-header class=select-header><input ng-model=searchTerm type=search ng-keydown=$event.stopPropagation() placeholder=Search... class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=series><md-option ng-value=option.id ng-repeat=\"option in seriesSource | filter: searchTerm\">{{option.name}}</md-option></md-optgroup></md-select></md-input-container></div></div></md-dialog-content><md-dialog-actions><md-button ng-click=cancel($event)>{{translation.cancel}}</md-button><md-button ng-click=createChart() ng-disabled=chartForm.$invalid class=\"green md-raised white-text\">{{translation.save}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/replay/config/dialog-create-replay.html","<md-dialog aria-label={{translation.add_replay}} style=width:800px><form name=replayForm novalidate id=dialog-create-replay><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{actionText}}</h2><span flex></span><md-button ng-click=cancel($event) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-tabs id=dialog-create-replay-tab md-selected=selectedIndex md-dynamic-height md-border-bottom md-autoselect md-swipe-content><md-tab id=replay-tab-info label={{translation.tab_info}}><md-content class=md-padding><section layout=column style=\"border-bottom:dashed 1px solid #eaeaea\"><div layout=row><md-input-container flex=80><input type=text ng-model=replay.name placeholder={{translation.name}} required md-maxlength=100></md-input-container><md-input-container flex=20><md-checkbox ng-model=replay.active aria-label=Active>{{translation.active}}</md-checkbox></md-input-container></div><div layout=row><md-input-container flex=40 class=text-center><md-checkbox ng-model=replay.settings.target ng-true-value=\"[\'replay\',\'dashboard\']\" ng-false-value=\"[\'replay\']\" aria-label=target>{{translation.enable_as_widget}} Dashboard</md-checkbox></md-input-container><md-input-container flex=30 class=text-center><md-checkbox ng-model=replay.settings.showHeader aria-label=\"Show Header\">{{translation.show_header}}</md-checkbox></md-input-container><md-input-container flex=30 class=text-center><md-checkbox ng-model=replay.settings.displayListModeCharts aria-label=\"Display List Mode Charts\">{{translation.display_list_mode_charts}}</md-checkbox></md-input-container><md-input-container flex=20><md-checkbox ng-model=replay.settings.darkTheme aria-label=\"Dark Theme\">Dark Theme</md-checkbox></md-input-container></div></section></md-content></md-tab><md-tab id=replay-tab-chart label={{translation.charts}}><div layout=row flex=100 layout-fill ng-cloak class=md-padding><md-content flex=100><md-list flex=100><md-subheader><h4><md-button d-no-ink ng-click=showChartDialog($event) class=\"pull-right md-raised md-primary\"><md-icon>add</md-icon>{{translation.add_chart}}</md-button>Charts</h4></md-subheader><md-list-item ng-repeat=\"item in replay.settings.charts track by $index\" class=\"md-3-line md-long-text\"><div class=md-list-item-text><div><span style=\"font-weight: bold\">Chart name:&nbsp;<span style=\"font-weight:normal;word-wrap: break-word\">{{item.name}}</span></span><br><span style=font-weight:bold>Chart type:&nbsp;<span style=font-weight:normal>{{item.type}}</span></span><br><span style=font-weight:bold>Mode selection series:&nbsp;<span style=font-weight:normal>{{item.seriesModeSelection}}</span></span><br><span style=\"font-weight: bold\">Series Type:&nbsp;<span style=\"font-weight:normal;word-wrap: break-word\">{{item.seriesType}}</span></span><br><span ng-if=\"item.strSeries.length &gt; 0\" style=\"font-weight: bold\">Series:&nbsp;<span style=\"font-weight:normal;word-wrap: break-word\">{{item.strSeries}}</span></span><br ng-if=\"item.strSeries.length &gt; 0\"><span style=\"font-weight: bold\">Setting:&nbsp;<p style=\"font-weight:normal;word-wrap: break-word\">{{item.settings}}</p></span></div><div><md-button aria-label=Delete ng-click=\"removeRow($event, $index)\" class=\"md-secondary md-icon-button\"><md-icon class=md-icon-button>delete</md-icon></md-button><md-button aria-label=Delete ng-click=\"showChartDialog($event, item)\" class=\"md-secondary md-icon-button\"><md-icon class=md-icon-button>edit</md-icon></md-button><md-button aria-label=Delete ng-click=\"moveUp(item, $index)\" class=\"md-secondary md-icon-button\"><md-icon class=md-icon-button>arrow_upward</md-icon></md-button></div></div></md-list-item></md-list></md-content></div></md-tab></md-tabs></md-dialog-content><md-dialog-actions><md-button ng-click=cancel($event)>{{translation.cancel}}</md-button><md-button ng-click=createReplay() ng-disabled=replayForm.$invalid class=\"green md-raised white-text\">{{translation.save}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/replay/config/dialog-create-series.html","<md-dialog aria-label={{translation.add_series}} style=\"width: 900px\"><cron-builder api=cronBuilder on-update=\"cronBuilderCallback(expression, id)\"><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{actionText}}</h2><span flex></span><md-button ng-click=cancel($event) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column><md-tabs md-selected=selectedIndex md-border-bottom md-dynamic-height><md-tab label={{translation.tab_info}}><md-content class=md-padding><ng-include ng-hide=!isLoading src=\"\'app/replay/component/includes/skeleton-loader-series-config.html\'\"></ng-include><form ng-show=!isLoading name=seriesForm novalidate><section layout=row layout-padding=\"\" layout-wrap=\"\" style=\"border-bottom:dashed 1px solid #eaeaea\"><div flex=30><md-input-container class=\"w100 m0\"><input type=text ng-model=series.name required md-maxlength=50 maxlength=50 placeholder={{translation.name}}></md-input-container></div><div flex=30><md-input-container class=\"w100 m0\"><label>{{translation.display_title}}</label><input type=text ng-model=series.settings.displayTitle md-maxlength=50 maxlength=50></md-input-container></div><div flex=15><md-input-container class=\"w100 m0\"><label>Type</label><md-select ng-model=series.type ng-change=onChangeSource() ng-disabled=series.id required class=md-no-underline><md-option value=TIME>TIME</md-option><md-option value=ALPHANUMERIC>ALPHANUMERIC</md-option></md-select></md-input-container></div><div flex=15><md-input-container class=\"w100 m0\"><label>{{translation.source}}</label><md-select ng-model=series.source ng-change=onChangeSource() ng-disabled=series.id required placeholder={{translation.source}} class=md-no-underline><md-option ng-value=item ng-repeat=\"item in sourceList\">{{item}}</md-option></md-select></md-input-container></div><div flex=10><md-input-container class=\"w100 m0\"><label>{{translation.color}}</label><input color-picker color-picker-model=series.settings.color color-picker-position=left ng-style={background:series.settings.color} type=text ng-model=series.settings.color readonly required></md-input-container></div></section><section ng-if=\"series.createdBy == \'USER\'\"><div ng-if=\"series.source != \'LIST\'\"><div layout=row layout-padding=\"\" layout-wrap=\"\" style=\"border-bottom:dashed 1px solid #eaeaea\"><div flex=50><md-input-container class=\"w100 m0\"><label>{{translation.label}}</label><md-select ng-model=series.settings.labelId ng-change=changeLabel(series.settings.labelId) ng-required=\"series.source != \'LIST\'\" placeholder={{translation.label}}><md-option ng-value=label.labelId ng-repeat=\"label in labels\">{{label.labelName}}</md-option></md-select></md-input-container></div><div flex=50><md-input-container class=\"w100 m0\"><label>{{translation.schema}}</label><md-select ng-model=series.settings.schemaId ng-change=changeSchema(series.settings.schemaId) ng-required=\"series.source != \'LIST\'\" placeholder={{translation.schema}}><md-option ng-value=option.id ng-repeat=\"option in schemas\">{{option.name}}</md-option></md-select></md-input-container></div></div></div><div ng-if=\"series.source == \'LIST\'\"><div layout=row layout-padding=\"\" layout-wrap=\"\" style=\"border-bottom:dashed 1px solid #eaeaea\"><div flex=50><md-input-container class=\"w100 m0\"><label>{{translation.list}}</label><md-select ng-model=series.settings.listId ng-change=onChangeList(series.settings.listId) ng-required=\"series.source == \'LIST\'\"><md-option ng-value=option.listId ng-repeat=\"option in lists\">{{option.name}}</md-option></md-select></md-input-container></div></div></div><div><div layout=row layout-padding=\"\" layout-wrap=\"\" style=\"border-bottom:dashed 1px solid #eaeaea\"><h4 flex=10>{{translation.value}}:</h4><div layout=row flex=90><md-input-container class=\"w100 m0\"><label>Key</label><md-select ng-model=series.settings.timestamp required placeholder=Key><md-option ng-value=option ng-repeat=\"option in keyList\">{{option}}</md-option></md-select></md-input-container><md-input-container class=\"w100 m0\"><label>{{translation.value}}</label><md-select ng-model=series.settings.value required placeholder={{translation.value}}><md-option ng-value=option ng-repeat=\"option in valueList\">{{option}}</md-option></md-select></md-input-container></div></div><div layout=row layout-padding=\"\" layout-wrap=\"\" style=\"border-bottom:dashed 1px solid #eaeaea\"><h4 flex=10>{{translation.filters}}:</h4><div flex=90><div layout=row ng-if=\"autocompleteList.length &gt; 0\" class=\"w100 m0\"><div layout=row flex=50><md-input-container class=\"w100 m0\"><label>{{translation.filter1}}</label><md-select ng-model=series.settings.filter1.name placeholder={{translation.filter1}}><md-option><em>None</em></md-option><md-option ng-repeat=\"item in getAutocompleteFields(1)\" ng-value=item.name>{{item.name}}</md-option></md-select></md-input-container><md-input-container class=\"w100 m0\"><label>{{translation.value1}}</label><input ng-model=series.settings.filter1.value maxlength=30 md-maxlength=30></md-input-container></div><div layout=row flex=50 ng-if=\"autocompleteList.length &gt; 1\" class=\"w100 m0\"><md-input-container class=\"w100 m0\"><label>{{translation.filter2}}</label><md-select ng-model=series.settings.filter2.name placeholder={{translation.filter2}}><md-option><em>None</em></md-option><md-option ng-repeat=\"item in getAutocompleteFields(2)\" ng-value=item.name>{{item.name}}</md-option></md-select></md-input-container><md-input-container class=\"w100 m0\"><label>{{translation.value2}}</label><input ng-model=series.settings.filter2.value maxlength=30 md-maxlength=30></md-input-container></div></div><div layout=row ng-if=\"autocompleteList.length &gt; 2\"><md-input-container class=\"w100 m0\"><label>{{translation.filter3}}</label><md-select ng-model=series.settings.filter3.name placeholder={{translation.filter3}}><md-option><em>None</em></md-option><md-option ng-repeat=\"item in getAutocompleteFields(3)\" ng-value=item.name>{{item.name}}</md-option></md-select></md-input-container><md-input-container class=\"w100 m0\"><label>{{translation.value3}}</label><input ng-model=series.settings.filter3.value maxlength=30 md-maxlength=30></md-input-container></div></div></div><div ng-if=\"series.source == \'EVENT\'\" layout=row layout-padding=\"\" layout-wrap=\"\" style=\"border-bottom:dashed 1px solid #eaeaea\"><h4 flex=15>{{translation.data_load}}:</h4><div flex=85 layout=row layout-padding=\"\"><div flex=20><md-input-container class=\"w100 m0\"><label>{{translation.scheduler}}</label><input ng-model=series.settings.scheduler maxlength=30 md-maxlength=30></md-input-container></div><div flex=20><md-button type=button ng-click=\"cronBuilder.open(\'Serie\', series.name, series.id, series.settings.scheduler)\" style=\"margin-right: 25px\" class=\"md-raised pull-right\">EDIT SCHEDULE</md-button></div><div flex=20><md-checkbox ng-model=series.settings.runScheduler md-no-ink>{{translation.run_scheduler}}</md-checkbox></div><div flex=20><md-checkbox ng-model=series.settings.loadHistoricalData md-no-ink>{{translation.load_historical_data}}</md-checkbox></div></div></div></div></section><section ng-if=\"series.createdBy == \'SYSTEM\'\"><div layout=row layout-padding=\"\" layout-wrap=\"\" style=\"border-bottom:dashed 1px solid #eaeaea\"><h4 flex=10>{{translation.value}}:</h4><div layout=row flex=90><md-input-container class=\"w100 m0\"><label>Key</label><input type=text ng-model=series.settings.timestamp readonly></md-input-container><md-input-container class=\"w100 m0\"><label>{{translation.value}}</label><input type=text ng-model=series.settings.value readonly></md-input-container></div></div><div layout=row layout-padding=\"\" layout-wrap=\"\" style=\"border-bottom:dashed 1px solid #eaeaea\"><h4 flex=10>{{translation.filters}}:</h4><div layout=row flex=90><md-input-container class=\"w100 m0\"><label>{{translation.filter1}}</label><input type=text ng-model=series.settings.filter1.name readonly></md-input-container><md-input-container class=\"w100 m0\"><label>{{translation.filter2}}</label><input type=text ng-model=series.settings.filter2.name readonly></md-input-container><md-input-container class=\"w100 m0\"><label>{{translation.filter3}}</label><input type=text ng-model=series.settings.filter3.name readonly></md-input-container></div></div></section></form></md-content></md-tab><md-tab label={{translation.tab_trace}}><md-content style=min-height:450px class=md-padding><textarea ng-model=myTraceJson readonly style=\"height:450px; width:100%; color: white; background: #000000cf;font-family: monospace\"></textarea></md-content></md-tab></md-tabs></md-dialog-content><md-dialog-actions><md-button md-colors=green ng-click=cancel($event)>{{translation.cancel}}</md-button><md-button md-colors=green ng-click=createSeries() ng-disabled=seriesForm.$invalid>{{translation.save}}</md-button></md-dialog-actions></cron-builder></md-dialog>");
$templateCache.put("app/replay/config/replay.list.html","<div class=bs-component><md-card><md-toolbar class=\"white-text main-color\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=main-color><md-icon>bar_chart</md-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools white-text main-color\"><span>{{translation.replay}}</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button abm-component ng-click=ctrl.showCreateReplayDialog(undefined) class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>{{translation.add_replay}}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></md-toolbar-filler></div></md-toolbar><section layout=row layout-wrap=\"\"><div flex=100><ng-table-dynamic id=replay-table config=ctrl.configReplay show-top-bar=true show-filter-button=true show-refresh-button=true show-export-csv-button=false on-click=ctrl.showCreateReplayDialog on-delete-row=ctrl.removeReplay></ng-table-dynamic></div></section></md-card></div>");
$templateCache.put("app/replay/config/series.list.html","<div class=bs-component><md-card><md-content style=\"min-height: 80vh\" class=sticky-parent><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-data-series scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=md-toolbar-tools><span>{{ translation.series }}</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button abm-component ng-click=ctrl.buildDataByAggregate($event) ng-if=ctrl.validatePermission() class=\"pull-right md-fab md-mini orange\"><md-tooltip md-direction=left>build AVG data by aggregation</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>build</md-icon></md-button><md-button abm-component ng-click=ctrl.onLoadDataFromHistory($event) ng-if=ctrl.validatePermission() class=\"pull-right md-fab md-mini orange\"><md-tooltip md-direction=left>load data from historical events</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>build</md-icon></md-button><md-button abm-component ng-click=toGraphicReports() class=\"pull-right md-fab md-mini blue\"><md-tooltip md-direction=left>{{ translation.go_to_graphic_reports }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>insert_chart</md-icon></md-button><md-button abm-component ng-click=ctrl.showCreateOrUpdateSeriesDialog() class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>{{ translation.tooltip_series }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></md-toolbar-filler></div></md-toolbar><ng-table-dynamic id=series-table config=ctrl.config selected-items=ctrl.selectedItems show-remove-rows-button=true show-top-bar=true show-filter-button=true show-refresh-button=true show-export-csv-button=false on-click=ctrl.showCreateOrUpdateSeriesDialog on-delete-row=ctrl.remove on-delete-many-row=ctrl.removeRows></ng-table-dynamic></md-content></md-card></div>");
$templateCache.put("app/rule-editor/components/dialog-create-version.html","<md-dialog style=\"width: 80vw\"><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{translation.create_version}}</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons>clear</md-icon></md-button></div></md-toolbar><md-dialog-content><br><div layout=row style=\"padding:0 10px 0 10px\"><div layout=column layout-align=\"center center\" flex=30 ng-if=loading style=height:270px><br><md-progress-circular md-mode=indeterminate></md-progress-circular><br></div><div layout=column flex=30 ng-if=!loading><div>{{translation.new}} {{translation.version}}</div><br><md-input-container class=no-padding-no-margin><label>{{translation.environment}}</label><input ng-model=ctrl.version.env required></md-input-container><md-input-container class=no-padding-no-margin><label>{{translation.title}}</label><input ng-model=ctrl.version.title required></md-input-container><div ng-hide=loading layout=row><md-button type=button ng-click=ctrl.cancel()><span>{{translation.cancel}}</span></md-button><md-button type=button ng-click=ctrl.saveVersion()><span>{{translation.create}}</span></md-button></div></div><div layout=column flex=70 style=margin-left:25px><span>{{translation.latests}} {{translation.versions}}</span><md-divider><span ng-if=ctrl.loading>{{translation.loading}} {{translation.versions}}</span><span ng-if=\"!ctrl.versions.length &amp;&amp; !ctrl.loading\">{{translation.without_versions}}</span></md-divider><ul style=\"height: 100%; overflow: scroll\"><li ng-repeat=\"version in ctrl.versions track by $index\"><span>{{version.environment}} - {{version.title}} </span><span style=color:#f6001f ng-if=version.new>- {{translation.new}} **</span></li></ul><div ng-hide=loading><md-button type=button ng-click=ruleEditor.showVersions() class=pull-right><span>{{translation.versions}}</span></md-button></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/rule-editor/components/dialog-versions.html","<md-dialog style=\"width: 80vw\"><md-toolbar class=main-color><div class=md-toolbar-tools><h2>Pipeline versioning</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons>clear</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=column><div layout=row style=\"background-color: #e4e4e4; padding: 20px 10px 0 10px\"><div flex><md-input-container class=\"no-padding-no-margin w100\"><label>{{translation.filter_by}} {{translation.environment}}</label><select ng-model=ctrl.searchEnv placeholder=\"\" ng-change=ctrl.filterByEnv() aria-label=\"Environment filter selector\" class=select-filters-modal><option value=_all>{{translation.all}}</option><option ng-repeat=\"env in ctrl.ruleEnvironments\" ng-value=env>{{env}}</option></select></md-input-container></div><div flex style=display:inline-flex><md-icon md-font-set=material-icons style=\"position:relative; top:5px\" class=\"text-main-color no-padding-no-margin\">search</md-icon><md-input-container class=\"no-padding-no-margin w100\"><label>{{translation.find}} {{translation.version}}</label><input ng-model=ctrl.searchText placeholder=\"\" aria-label=\"Search box\"></md-input-container></div></div><div style=\"padding: 20px 10px 0 10px\"><div layout=row style=\"padding: 0px 16px\"><div flex=5>ID</div><div flex>{{translation.title}}</div><div flex>Env.</div><div style=width:100px>&nbsp;</div></div><md-divider></md-divider><md-list style=\"max-height: 250px; overflow: scroll\" class=md-dense><span ng-if=ctrl.loading>{{translation.loading}} {{translation.versions}}</span><span ng-if=\"!ctrl.versions.length &amp;&amp; !ctrl.loading\">{{translation.without_versions}}</span><md-list-item ng-repeat=\"version in ctrl.ruleVersions | filter:{title:ctrl.searchText}\"><div layout=row class=w100><b flex=5>{{version.id}}</b><div flex md-truncate>{{version.title}}</div><div flex md-truncate>{{version.environment}}</div></div><button ng-click=ctrl.setVersion(version); style=\"padding: .8rem\" aria-label=\"Load version button\" class=\"md-secondary text-main-color btn md-raised\"><i class=material-icons>launch</i><md-tooltip>{{translation.view}} {{translation.version}}</md-tooltip></button> <button ng-click=\"ctrl.deleteVersion($event, version);\" style=\"padding: .8rem\" aria-label=\"Load version button\" class=\"md-secondary text-main-color btn md-raised\"><i class=material-icons>delete</i><md-tooltip>{{translation.delete}} {{translation.version}}</md-tooltip></button><md-divider></md-divider></md-list-item></md-list></div></div></md-dialog-content><md-dialog-actions><md-button type=button ng-click=ctrl.cancel(); class=pull-right><span>{{translation.close}}</span></md-button><md-button has-permission=function:create-version type=button ng-click=ruleEditor.createVersion() class=pull-right><span>{{translation.create_version}}</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/rules/directives/edit-rule.tpl.html","<div></div>");
$templateCache.put("app/rules/executions/rule-executions.html","<div ng-cloak layout=column layout-align=\"space-between stretch\" style=height:auto><md-card class=m0><md-content class=content_blocks><rule-crud api=rule.ruleCRUD on-update=rule.onUpdate(rule.data)></rule-crud><div><md-toolbar layout=row class=md-menu-toolbar><md-toolbar-filler layout layout-align=\"center center\" ng-click=_onGoBack() class=main-color><md-tooltip md-z-index=9999 md-delay=200>{{ translation.get_back }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target style=font-size:1.5em>video_library</md-icon></md-toolbar-filler><div layout=row class=w100><div flex=50><h2 class=md-toolbar-tools><section ng-show=rule.data.id><span>{{ translation.rule }}:&nbsp;</span><b>{{ rule.data.name }}</b><span style=\"font-size: 1rem\">({{ rule.data.id }})</span></section><section ng-show=!rule.data.id><span>{{ translation.loading }} {{ translation.rule }}</span></section></h2><md-menu-bar><md-menu><button ng-click=$mdMenu.open()>{{ translation.file }}</button><md-menu-content width=3><md-menu-item><md-button ng-click=_onGoBack()>{{ translation.get_back }}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"_onGoTo(\'app.rule-editor\')\">{{ translation.view_current_pipeline }}</md-button></md-menu-item></md-menu-content></md-menu><md-menu><button ng-click=$mdMenu.open()>{{ translation.rule }}</button><md-menu-content width=3><md-menu-item><md-button ng-click=rule.execute(rule.data)>{{ translation.execute }}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"rule.ruleCRUD.openEditor($event, rule.data)\">{{ translation.edit_rule_attr }}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div></md-toolbar></div></md-content><md-divider></md-divider><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"{{ translation.versions }}\"><md-card><div layout=row class=md-toolbar-tools><h2 flex>{{ translation.versions }}</h2><div flex=50 layout=row layout-align=\"end center\"><div flex=1 style=display:inline-flex><md-button ng-click=rule.getVersions() style=\"padding: .8rem\" aria-label=\"Refresh versions button\" class=\"md-icon-button md-secondary\"><md-icon md-font-set=material-icons class=text-main-color>refresh</md-icon></md-button></div></div></div><md-divider></md-divider><md-card-content><md-list style=\"max-height: 500px; overflow-y: scroll\"><md-list-item ng-show=rule.isLoading.versions>{{ translation.loading }} {{ translation.versions }}</md-list-item><md-list-item ng-show=\"!rule.data.versions.length &amp;&amp; !rule.isLoading.versions\">{{ rule.data.name }} - {{ translation.without_versions }}</md-list-item><md-list-item ng-repeat=\"version in rule.data.versions | filter:rule.searchVersion | orderBy:mustOrderBy.field:mustOrderBy.reverse\" style=\"border-bottom: 1px solid #eaeaea;padding: 1.8rem\"><div style=width:100% class=row><div class=col-md-4><div layout=row><div><md-icon md-font-set=material-icons style=\"background-color: #2E7D32\" class=md-avatar-icon>label_important</md-icon></div><div><span>{{ translation.version }}ID: {{ version.id }}</span><br><span>{{ translation.date }}: {{ version.creationDate | moment: \"DD-MM-YYYY HH:mm A\" }}</span></div></div></div><div class=col-md-3><div layout=row><div><span>{{ translation.title }}:</span><b style=font-size:1.2em>{{ version.title }}</b><br><span>{{ translation.environment }}: {{ version.environment }}</span></div></div></div><div class=col-md-3><a href=rules/editor/{{rule.data.id}}/version/{{version.id}} style=\"padding: .8rem\" aria-label=\"Open viewer button\" class=\"md-secondary text-main-color btn md-raised\"><i class=material-icons>launch</i><md-tooltip>{{ translation.view }} {{ translation.version }}</md-tooltip></a><md-button ng-click=\"rule.deleteVersion($event, version)\" style=\"padding: .8rem\" aria-label=\"Delete executions button\" class=\"md-icon-button md-secondary\"><md-icon md-font-set=material-icons class=text-main-color>delete</md-icon></md-button><md-tooltip>{{ translation.delete }} {{ translation.version }}</md-tooltip></div></div></md-list-item></md-list></md-card-content></md-card></md-tab><md-tab label=\"{{ translation.executions }}\"><md-card><div class=md-toolbar-tools><h2 flex>{{ translation.executions }}</h2><div flex layout=row layout-align=\"end center\"><div flex=1 style=display:inline-flex><md-button ng-click=rule.getExecutions() style=\"padding: .8rem\" aria-label=\"Refresh executions button\" class=\"md-icon-button md-secondary\"><md-icon md-font-set=material-icons class=text-main-color>refresh</md-icon></md-button></div></div></div><md-divider></md-divider><md-card-content><md-list><md-list-item ng-if=rule.isLoading.executions>{{ translation.loading }} {{ translation.executions }}</md-list-item><md-list-item ng-if=\"!rule.data.executions.length &amp;&amp; !rule.isLoading.executions\">{{ rule.data.name }} - {{ translation.without_executions }}</md-list-item><md-list-item ng-if=!rule.isLoading.executions ng-repeat=\"execution in rule.data.executions | filter:rule.searchExecution | orderBy:rule.mustOrderBy.field:rule.mustOrderBy.reverse\" style=\"border-bottom: 1px solid #eaeaea; padding: 1.8rem\"><div style=width:100%><div style=width:100% class=row><div class=col-md-2><div layout=row><div><md-icon md-font-set=material-icons ng-style=\"execution.status != \'finished\' ? {\'background-color\':\'red\'} : {\'background-color\':\'#2E7D32\'}\" class=md-avatar-icon>play_arrow</md-icon></div><div><span>{{ translation.execution }}:&nbsp;</span><b>{{ execution.executionId | padLeft: 3 }}</b><br><span>{{ translation.date }}:&nbsp;</span><b>{{ execution.startTime | moment: \"DD-MM-YYYY HH:mm\" }}</b><br><span>Status:&nbsp;</span><b>{{ execution.status }}</b></div></div></div><div class=col-md-2><div><span>{{ translation.version }}:&nbsp;</span><b>{{ execution.versionId }} - {{ execution.versionTitle }}</b><br><span>Env:&nbsp;</span><b>{{ execution.environment }}</b></div></div><div class=col-md-2><div><span>ExecutionTime:&nbsp;</span><b>{{ execution.executionTime }}ms</b><br><span>StartTime:&nbsp;</span><b>{{ execution.startTime | moment: \"HH:mm:ss.SSS\" }}</b><br><span>EndTime:&nbsp;</span><b>{{ execution.finishTime | moment: \"HH:mm:ss.SSS\" }}</b></div></div><div class=col-md-4><div>Execution attributes<div style=\"height:55px; overflow:auto\"><ul><li ng-repeat=\"attr in execution.attrMap\">{{ attr.key }}: {{ attr.value }}</li></ul></div></div></div><div class=col-md-2><a href=rules/editor/{{rule.data.id}}/execution/{{execution.executionId}} style=\"padding: .8rem\" aria-label=\"Open viewer button\" class=\"text-main-color btn md-raised\"><i class=material-icons>launch</i><span>&nbsp;{{ translation.view }} {{ translation.execution }}</span></a></div></div><div style=width:100% ng-if=execution.errorMessage class=row><div style=\"border: 1px solid gray; position: relative; left: 15px; background: #1f1e1f; color: #d8d8d8\" class=col-md-12>{{ execution.errorMessage }}</div></div></div></md-list-item><div style=\"margin: 10px\" class=pull-right><ul class=pagination><li ng-show=rule.showLessArrow()><a ng-click=rule.goToPage(&quot;start&quot;)>«</a></li><li ng-show=rule.showLessArrow()><a ng-click=rule.goToPage(&quot;1less&quot;)>&lt;</a></li><li ng-repeat=\"page in rule.request.pagination.rule\" ng-class=\"{ active: page == rule.request.pagination.page }\"><a ng-click=rule.goToPage(page)>{{ page }}</a></li><li ng-show=rule.showMoreArrow()><a ng-click=rule.goToPage(&quot;1more&quot;)>&gt;</a></li><li ng-show=rule.showMoreArrow()><a ng-click=rule.goToPage(&quot;end&quot;)>»<div class=ripple-container></div></a></li></ul></div></md-list></md-card-content></md-card></md-tab></md-tabs></md-card></div>");
$templateCache.put("app/rules/schedules/rule-schedules.html","<div class=\"bs-component sticky-parent\"><rule-crud api=rule.ruleCRUD on-update=rule.getSchedules(rule)></rule-crud><md-card><md-content><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-rule-schedules scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=md-toolbar-tools>{{ translation.scheduled_tasks }}</h2></div></md-toolbar><section><div id=calendar-container></div></section><section layout=column layout-align=\"start center\" layout-wrap><div flex=100 ng-repeat=\"item in rule.schedules\" class=\"list-group-item w100\"><h4><small>{{ item.id }}.</small><strong>{{ item.name }}</strong></h4><p>Schedules {{ item.schedules.length }}</p><section layout=row layout-wrap layout-align=\"start center\" style=\"gap: 1rem\"><div flex=30 ng-repeat=\"schedule in item.schedules\" style=\"margin: 1rem 0\" class=list-group-item><p><span>{{ translation.next }} {{ translation.execution }}: &nbsp;</span><strong>{{ schedule.nextExecution }}</strong></p><p>CRON: &nbsp;<strong>{{ schedule.schedule }}</strong></p><button ng-click=\"rule.editRule($event, item.id)\" style=\"padding: 0.8rem; float: right\" aria-label=\"Edit Rul button\" class=\"md-secondary text-main-color btn md-raised\"><i class=material-icons>edit</i><md-tooltip>{{ translation.open }} {{ translation.rule }}</md-tooltip></button></div></section></div></section></md-content></md-card></div>");
$templateCache.put("app/rules/templates/tree-view.html","<md-list id=listsTree><div ng-repeat=\"(key, val) in rules.rulesTree\"><rule-group-item ng-if=!key.includes(&quot;ROOT&quot;) group=val display-items=rules.displayItems translation=translation></rule-group-item></div><div class=rule-list-grid><rule-list-item ng-repeat=\"item in rules.rulesTree[&quot;folder:ROOT&quot;].items\" rule=item translation=translation class=rule-item-list></rule-list-item></div></md-list>");
$templateCache.put("app/rules/versions/rule-versions.html","<div ng-cloak layout=column layout-align=\"space-between stretch\" style=height:auto><md-card class=m0><md-content class=content_blocks><div ng-if=!inputList.isLoading><md-toolbar layout=row class=md-menu-toolbar><md-toolbar-filler layout layout-align=\"center center\" ng-click=_onGoBack() class=main-color><md-tooltip md-z-index=9999 md-delay=200>{{ translation.get_back }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target style=font-size:1.5em>label_important</md-icon></md-toolbar-filler><div layout=row class=w100><div flex=50><h2 class=md-toolbar-tools>{{ translation.rule_versions }} - {{ rule.data.name }}</h2><md-menu-bar><md-menu><button ng-click=$mdMenu.open()>{{ translation.file }}</button><md-menu-content width=3><md-menu-item><md-button ng-click=_onGoBack()>{{ translation.get_back }}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"_onGoTo(\'app.rule-executions\')\">{{ translation.go_to }} {{ translation.executions }}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"_onGoTo(\'app.rule-editor\')\">{{ translation.view_current_pipeline }}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div><div flex=50 layout=row layout-align=\"end center\" class=md-toolbar-tools><div flex=1 style=display:inline-flex><md-icon md-font-set=material-icons style=top:23px class=text-main-color>search</md-icon><md-autocomplete md-require-match=false md-floating-label=\"{{ translation.find }} {{ translation.version }}\" md-search-text=rule.searchText md-items=\"item in querySearch(rule.searchText)\" md-item-text=item.title md-min-length=0 md-clear-button=true style=\"padding-left:5px; top:12px\"><md-item-template><span md-highlight-text=rule.searchText md-highlight-flags=^i>{{ item.title }}</span></md-item-template><md-not-found>{{ translation.without_results }} \"{{ rule.searchText }}\".</md-not-found></md-autocomplete></div></div></div></md-toolbar></div></md-content><md-divider></md-divider><md-card><md-list><md-list-item ng-if=rule.loadingVersions>{{ translation.loading }} {{ translation.versions }}</md-list-item><md-list-item ng-if=\"!rule.data.versions.length &amp;&amp; !rule.loadingVersions\">{{ rule.data.name }} - {{ translation.without_versions }}</md-list-item><md-list-item ng-repeat=\"version in rule.data.versions | filter:rule.searchText | orderBy:mustOrderBy.field:mustOrderBy.reverse\" style=\"border-bottom: 1px solid #eaeaea;padding: 1.8rem\"><div style=width:100% class=row><div class=col-md-4><div layout=row><div><md-icon md-font-set=material-icons style=\"background-color: #2E7D32\" class=md-avatar-icon>label_important</md-icon></div><div><span>{{ translation.version }}ID: {{ version.id }}</span><br><span>{{ translation.date }}: {{ version.creationDate | moment: \"DD-MM-YYYY HH:mm A\" }}</span></div></div></div><div class=col-md-3><div layout=row><div><span>{{ translation.title }}:</span><b style=font-size:1.2em>{{ version.title }}</b><br><span>{{ translation.environment }}: {{ version.environment }}</span></div></div></div><div class=col-md-3><a href=rules/editor/{{rule.data.id}}/version/{{version.id}} style=\"padding: .8rem\" aria-label=\"Open viewer button\" class=\"md-secondary text-main-color btn md-raised\"><i class=material-icons>launch</i><md-tooltip>{{ translation.open }} {{ translation.version }}</md-tooltip></a><button has-permission=function#:delete-version ng-click=\"rule.deleteVersion($event, version)\" style=\"padding: .8rem\" aria-label=\"Delete version button\" class=\"md-secondary text-main-color btn md-raised\"><i class=material-icons>delete</i><md-tooltip>{{ translation.delete }} {{ translation.version }}</md-tooltip></button></div></div></md-list-item></md-list></md-card></md-card></div>");
$templateCache.put("app/schemas/templates/schemas-tree-view.html","<md-list id=schemasTree><div ng-repeat=\"(key, val) in schemas.schemasTree\"><schema-group-item ng-if=!key.includes(&quot;ROOT&quot;) group=val display-items=schemas.displayItems translation=translation></schema-group-item></div><div ng-repeat=\"item in schemas.schemasTree[&quot;folder:ROOT&quot;].items\"><schema-list-item schema=item translation=translation></schema-list-item></div></md-list>");
$templateCache.put("app/searcher/config/dialog-create-searcher.html","<md-dialog aria-label={{translation.add_schema}} style=width:900px><md-toolbar class=\"white-text main-color\"><div class=md-toolbar-tools><h2>{{actionText}}</h2><span flex></span><md-button ng-click=cancel($event) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column layout-padding style=\"padding-top: 10px\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=selectedTab><md-tab label=List ng-click=setType(0) ng-disabled=\"action == \'update\' &amp;&amp; selectedTab != 0\"><md-content class=md-padding><form name=searcherForListForm novalidate><div layout=row flex=100><md-input-container class=w100><label>{{translation.NAME_FIELD}}</label><input type=text ng-model=object.name required md-maxlength=50></md-input-container><md-input-container class=w100><md-checkbox ng-model=object.active aria-label=Active>{{translation.ACTIVE_FIELD}}</md-checkbox></md-input-container></div><div flex=100><div layout=row><div flex=40><md-input-container class=w100><label style=top:-50px>{{translation.AVAILABLE_LIST_FIELD}}</label><select size=10 name=field_list ng-model=selectedItem ng-options=\"(item.name + \' - \' + item.totalRecords)  for item in lists | orderBy:\'name\'\" class=w100><option disabled selected value=\"\">Select a item</option></select></md-input-container></div><div flex=20 class=text-center><br><br><br><md-button title={{translation.SEND_MSG}} ng-click=onClickRight() class=\"md-raised md-mini\"><md-icon md-font-set=material-icons class=\"md-icon-button md-secondary\">keyboard_arrow_right</md-icon></md-button><md-button title={{translation.SEND_MSG}} ng-click=onClickLeft() class=\"md-raised md-mini\"><md-icon md-font-set=material-icons class=\"md-icon-button md-secondary\">keyboard_arrow_left</md-icon></md-button></div><div flex=40><md-input-container class=w100><label style=top:-50px>{{translation.INDEX_LIST_FIELD}}</label><select size=10 name=field_selected_list required ng-model=selectedIndexedItem ng-options=\"(item.name + \' - \' + item.totalRecords)  for item in object.indexedItems\" class=w100><option disabled selected value=\"\">Select a item</option></select></md-input-container></div></div></div><div layout=row flex=100><md-input-container flex=50><label>{{translation.DISPLAY_FIELD}}</label><md-select ng-model=selectedIndexedItem.displayField placeholder={{translation.DISPLAY_FIELD}}><md-option ng-repeat=\"(key, value) in selectedIndexedItem.schema.schema.properties\" ng-value=key>{{key}}</md-option></md-select></md-input-container><md-input-container flex=50><label>{{translation.INDEX_FIELD}}</label><md-select ng-model=selectedIndexedItem.indexedFields placeholder={{translation.INDEX_FIELD}} multiple><md-option ng-repeat=\"(key, value) in selectedIndexedItem.schema.schema.properties\" ng-value=key>{{key}}</md-option></md-select></md-input-container></div></form></md-content></md-tab><md-tab label=Event ng-click=setType(1) ng-disabled=\"action == \'update\' &amp;&amp; selectedTab != 1\"><md-content class=md-padding><form name=searcherForEventForm novalidate><div layout=row flex=100><md-input-container class=w100><label>{{translation.NAME_FIELD}}</label><input type=text ng-model=object.name required md-maxlength=50></md-input-container><md-input-container flex=10 class=w100><md-checkbox ng-model=object.active aria-label=Active>{{translation.ACTIVE_FIELD}}</md-checkbox></md-input-container><md-input-container class=w100><label>{{translation.LABEL_FIELD}}</label><md-select ng-model=labelId ng-change=changeLabel(labelId) placeholder=Label required><md-option ng-value=label.labelId ng-repeat=\"label in labels\">{{label.labelName}}</md-option></md-select></md-input-container></div><div flex=100><div layout=row><div flex=40><md-input-container class=w100><label style=top:-50px>{{translation.AVAILABLE_SCHEMA_FIELD}}</label><select size=10 name=field_list ng-model=selectedItem ng-options=\"(item.name) for item in schemas | orderBy:\'name\'\" class=w100><option disabled selected value=\"\">Select a item</option></select></md-input-container></div><div flex=20 class=text-center><br><br><br><md-button title={{translation.SEND_MSG}} ng-click=onClickRight() class=\"md-raised md-mini\"><md-icon md-font-set=material-icons class=\"md-icon-button md-secondary\">keyboard_arrow_right</md-icon></md-button><md-button title={{translation.SEND_MSG}} ng-click=onClickLeft() class=\"md-raised md-mini\"><md-icon md-font-set=material-icons class=\"md-icon-button md-secondary\">keyboard_arrow_left</md-icon></md-button></div><div flex=40><md-input-container class=w100><label style=top:-50px>{{translation.INDEX_SCHEMA_FIELD}}</label><select size=10 name=field_selected_list required ng-model=selectedIndexedItem ng-options=\"(item.name) for item in object.indexedItems\" class=w100><option disabled selected value=\"\">Select a item</option></select></md-input-container></div></div></div><div layout=row flex=100><md-input-container flex=50><label>{{translation.DISPLAY_FIELD}}</label><md-select ng-model=selectedIndexedItem.displayField placeholder={{translation.DISPLAY_FIELD}}><md-option ng-repeat=\"key in selectedIndexedItem.properties\" ng-value=key>{{key}}</md-option></md-select></md-input-container><md-input-container flex=50><label>{{translation.INDEX_FIELD}}</label><md-select ng-model=selectedIndexedItem.indexedFields placeholder={{translation.INDEX_FIELD}} multiple><md-option ng-repeat=\"key in selectedIndexedItem.properties\" ng-value=key>{{key}}</md-option></md-select></md-input-container></div></form></md-content></md-tab></md-tabs></md-dialog-content><md-dialog-actions><md-button md-colors=green ng-click=cancel($event)>{{translation.CANCEL_BUTTON}}</md-button><md-button md-colors=green ng-click=save() ng-show=\"selectedTab == 1 &amp;&amp; action == \'create\' &amp;&amp; validatePermission(\'searcher:create\')\" ng-disabled=searcherForEventForm.$invalid>{{translation.SAVE_BUTTON}}</md-button><md-button md-colors=green ng-click=save() ng-show=\"selectedTab == 0 &amp;&amp; action == \'create\' &amp;&amp; validatePermission(\'searcher:create\')\" ng-disabled=searcherForListForm.$invalid>{{translation.SAVE_BUTTON}}</md-button><md-button md-colors=green ng-click=save() ng-show=\"selectedTab == 1 &amp;&amp; action == \'update\' &amp;&amp; (validatePermission(\'searcher#\'+ object.id + \':create\') || validatePermission(\'searcher#\'+ object.id + \':update\'))\" ng-disabled=searcherForEventForm.$invalid>{{translation.SAVE_BUTTON}}</md-button><md-button md-colors=green ng-click=save() ng-show=\"selectedTab == 0 &amp;&amp; action == \'update\' &amp;&amp; (validatePermission(\'searcher#\'+ object.id + \':create\') || validatePermission(\'searcher#\'+ object.id + \':update\'))\" ng-disabled=searcherForListForm.$invalid>{{translation.SAVE_BUTTON}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/searcher/config/searcher.list.html","<div class=bs-component><md-card><md-content class=sticky-parent><md-toolbar class=\"white-text main-color toolbar-sticky\"><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-3\"><cep-icon icon=cep-menu-data-searcher scale=2></cep-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=md-toolbar-tools><span>{{ translation.SEARCHER_TITLE }}</span></h2><md-toolbar-filler flex=auto layout=row layout-align=\"end center\"><md-button abm-component ng-click=ctrl.showSearcherDialog($event) class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>Search</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>search</md-icon></md-button></md-toolbar-filler></div></md-toolbar><br><div ng-if=ctrl.loading class=w100><md-progress-linear></md-progress-linear></div><div ng-if=!ctrl.loading class=w100><div ui-grid-resize-columns ui-grid-auto-resize ui-grid-pagination ui-grid=ctrl.gridOptions style=\"min-height: 70vh\" class=listGrid></div></div></md-content></md-card></div>");
$templateCache.put("app/app-utils/directives/cron-builder/cron-builder.dialog.html","<md-dialog style=\"width:80vw; max-width: 800px\"><md-toolbar class=main-color><div class=md-toolbar-tools><h2>Schedule to: {{dialog.params.name}}</h2><span flex></span><md-button ng-disabled=dialog.isSaving ng-click=dialog.cancel() class=md-icon-button><md-icon md-font-set=material-icons>clear</md-icon></md-button></div></md-toolbar><form name=ruleCreateForm ng-submit=\"ruleCreateForm.$valid &amp;&amp; dialog.saveRule()\" novalidate><md-dialog-content class=md-padding><div>&nbsp;</div><div style=\"font-size:1.5em; text-align:center; font-style:italic; font-weight:600\" class=w100>“{{ dialog.cronString }}”</div><md-input-container style=margin-bottom:0px class=w100><label>Cron Expression</label><input type=text ng-model=dialog.cronExpression style=\"font-size:2em; text-align:center; background-color: gainsboro; border: 1px solid black; border-radius: 15px; height: 40px\"></md-input-container><md-divider></md-divider><md-tabs md-border-bottom><md-tab label=Minutes><md-tab-content class=md-padding><cron-time expression=dialog.cronState.minute type=minute class=w100></cron-time></md-tab-content></md-tab><md-tab label=Hours><md-tab-content class=md-padding><cron-time expression=dialog.cronState.hour type=hour class=w100></cron-time></md-tab-content></md-tab><md-tab label=Days><md-tab-content class=md-padding><cron-time expression=dialog.cronState.day type=day class=w100></cron-time></md-tab-content></md-tab><md-tab label=Months><md-tab-content class=md-padding><cron-time expression=dialog.cronState.month type=month class=w100></cron-time></md-tab-content></md-tab><md-tab label=WeekDay><md-tab-content class=md-padding><cron-week expression=dialog.cronState.weekDay class=w100></cron-week></md-tab-content></md-tab></md-tabs></md-dialog-content><md-dialog-actions><md-button type=button ng-disabled=dialog.isSaving ng-click=dialog.cancel() class=\"md-raised pull-right\">{{translation.cancel}}</md-button><md-button type=button ng-click=dialog.reset() class=\"md-raised pull-right\">Reset</md-button><md-button ng-click=dialog.save() ng-disabled=dialog.isSaving class=\"md-raised md-primary pull-right\">{{translation.save}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/app-utils/directives/cron-builder/schedule-builder.dialog.html","<md-dialog style=\"width: 800px\"><md-toolbar class=main-color><div class=md-toolbar-tools><h2 flex=80>{{ dialog.params.action === \'update\' ? \'Update\' : \'Create\' }} Schedule</h2><div flex><md-switch ng-model=dialog.scheduleAdvanceMode aria-label=scheduleAdvanceMode ng-change=dialog.toggleScheduleAdvanceMode()>{{ dialog.scheduleAdvanceMode ? \'Advanced\' : \'Basic\' }}</md-switch></div></div></md-toolbar><form name=ruleCreateForm ng-submit=\"ruleCreateForm.$valid &amp;&amp; dialog.saveRule()\" novalidate><md-dialog-content class=md-padding><section layout=row layout-align=\"center center\" layout-margin><div flex><strong>Execute at {{ dialog.cron | prettyCron }}</strong><div class=badge>{{dialog.cron.seconds}} {{dialog.cron.minute}} {{dialog.cron.hour}} {{dialog.cron.dayOfMonth}} {{dialog.cron.month}} {{dialog.cron.dayOfWeek}} {{dialog.cron.year}}</div></div></section><!--! BASIC SCHEDULE--><div id=basic-schedule ng-if=\"dialog.scheduleAdvanceMode === false\" class=list-group-item><section layout=row layout-align=\"space-between center\" class=m0><div flex=100 class=w100><md-input-container class=w100><label for=basicModeSelected>Repeat</label><md-select ng-model=dialog.basicModeSelected class=w100><md-option ng-repeat=\"mode in dialog.basicModes\" ng-value=mode.value>{{ mode.title }}</md-option></md-select></md-input-container></div></section><section layout=column><div flex=100 ng-if=\"dialog.basicModeSelected === &quot;everyHour&quot;\" class=w100><cron-every-hour cron=dialog.cron></cron-every-hour></div><div flex=100 ng-if=\"dialog.basicModeSelected === &quot;onceADay&quot;\" class=w100><cron-once-a-day cron=dialog.cron></cron-once-a-day></div><div flex=100 ng-if=\"dialog.basicModeSelected === &quot;onceAWeek&quot;\" class=w100><cron-once-a-week cron=dialog.cron></cron-once-a-week></div><div flex=100 ng-if=\"dialog.basicModeSelected === &quot;onceAMonth&quot;\" class=w100><cron-once-a-month cron=dialog.cron></cron-once-a-month></div><div flex=100 ng-if=\"dialog.basicModeSelected === &quot;onceAYear&quot;\" class=w100><cron-once-a-year cron=dialog.cron></cron-once-a-year></div></section></div><!--! ADVANCED SCHEDULE--><md-tabs md-dynamic-height ng-if=\"dialog.scheduleAdvanceMode === true\"><md-tab label=minutes ng-click=dialog.minuteToCron()><md-content><ng-include src=&quot;app/app-utils/directives/cron-builder/includes/minutes_form.html&quot;></ng-include></md-content></md-tab><md-tab label=Hours ng-click=dialog.hourToCron()><md-content><ng-include src=&quot;app/app-utils/directives/cron-builder/includes/hours_form.html&quot;></ng-include></md-content></md-tab><md-tab label=Day ng-click=dialog.dayToCron()><md-content><ng-include src=&quot;app/app-utils/directives/cron-builder/includes/days_form.html&quot;></ng-include></md-content></md-tab></md-tabs><div class=list-group-item><div layout=row layout-align=\"space-between center\"><div flex class=text-center>Seconds</div><div flex class=text-center>Minutes</div><div flex class=text-center>Hours</div><div flex class=text-center>Day</div><div flex class=text-center>Month</div><div flex class=text-center>Week</div><div flex class=text-center>Year</div></div></div><div class=list-group-item><div layout=row layout-padding layout-align=\"space-between center\"><div flex><input ng-model=dialog.cron.seconds style=\"font-size: 3rem\" class=\"w100 text-center\"></div><div flex><input ng-model=dialog.cron.minute style=\"font-size: 3rem\" class=\"w100 text-center\"></div><div flex><input ng-model=dialog.cron.hour style=\"font-size: 3rem\" class=\"w100 text-center\"></div><div flex><input ng-model=dialog.cron.dayOfMonth style=\"font-size: 3rem\" class=\"w100 text-center\"></div><div flex><input ng-model=dialog.cron.month style=\"font-size: 3rem\" class=\"w100 text-center\"></div><div flex><input ng-model=dialog.cron.dayOfWeek style=\"font-size: 3rem\" class=\"w100 text-center\"></div><div flex><input ng-model=dialog.cron.year style=\"font-size: 3rem\" class=\"w100 text-center\"></div></div></div></md-dialog-content><md-dialog-actions style=\"padding: 1rem\" class=\"cep-top-border layout-align-space-between\"><md-button type=button ng-disabled=dialog.isSaving ng-click=dialog.cancel() class=\"md-raised orange pull-right\"><strong>{{ translation.exit_without_save }}</strong></md-button><md-button ng-click=dialog.save() ng-disabled=dialog.isSaving class=\"md-raised md-primary pull-right\"><strong>{{ translation.save_and_create_schedule }}</strong></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/app-utils/components/alert-acl/alert-acl.html","<md-content flex layout=column><div class=text-center><br><md-icon style=\"font-size: 50px\" class=\"md-warn md-hue-1\">warning</md-icon><br><p>no permissions</p></div></md-content>");
$templateCache.put("app/app-utils/components/auto-refresh/auto-refresh-menu.html","<md-menu><md-button ng-click=$mdMenu.open() ng-class=\"{ \'orange white-text\': ctrl.isActive }\" class=m0><md-icon ng-class=\"{ \'animated-spin white-text\': ctrl.isActive }\">{{ ctrl.isActive ? \"autorenew\" : \"refresh\" }}</md-icon><span>{{ ctrl.isActive ? ctrl.textActive+\" \"+ctrl.timer : ctrl.textInactive }}</span></md-button><md-menu-content width=3><md-menu-item><md-button ng-click=\"ctrl.autoRefresh(\'5s\')\">{{ ctrl.translationsRefresh }} 5s</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.autoRefresh(\'10s\')\">{{ ctrl.translationsRefresh }} 10s</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.autoRefresh(\'15s\')\">{{ ctrl.translationsRefresh }} 15s</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=ctrl.stopAutoRefresh()>{{ ctrl.translationsStop }}</md-button></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("app/app-utils/components/btn-bookmark/btn-bookmark.html","<span ng-click=ctrl.toggleBookmark()><md-icon aria-label=bookmark role=button-list-view md-font-set=material-icons ng-class=\"{ \'amber-text\': ctrl.isBookmarked }\" ng-if=!ctrl.loading>start</md-icon><md-progress-circular md-diameter=20px style=\"margin: 0 auto\" ng-if=ctrl.loading class=md-hue-2></md-progress-circular><md-tooltip ng-if=\"ctrl.extended != true\">{{ ctrl.isBookmarked ? ctrl.translation.remove_bookmark : ctrl.translation.add_bookmark }}</md-tooltip><div ng-if=\"ctrl.extended == true\" ng-transclude=extend style=\"display: inline-block\"><span style=\"margin-left: 15px\">{{ ctrl.isBookmarked ? ctrl.translation.remove_bookmark : ctrl.translation.add_bookmark }}</span></div></span>");
$templateCache.put("app/app-utils/components/cep-datetimepicker/cep-datetimepicker.html","<div class=\"dropdown w100 h100\"><a id=dropdown role=button data-toggle=dropdown data-target=.dropdown href=void() class=\"dropdown-toggle w100 h100\"><div class=\"w100 h100\"><input id=date type=text name=datetimepicker-input data-ng-model=ctrl.date data-date-time-input=\"{{ ctrl.format }}\" class=\"w100 h100\"></div></a><ul role=menu aria-labelledby=dLabel class=dropdown-menu><datetimepicker data-ng-model=ctrl.date data-datetimepicker-config=ctrl.config></datetimepicker></ul></div>");
$templateCache.put("app/app-utils/components/cep-datetimepicker-v2/cep-datetimepicker-v2.html","<input type=text aria-label=DateTimePickerV2 placeholder=Select... mdc-datetime-picker ng-model=ctrl.ngModel ng-model-options=\"{ timezone: &quot;utc&quot; }\" date=ctrl.config[ctrl.type][&quot;date&quot;] time=ctrl.config[ctrl.type][&quot;time&quot;] format=\"{{ ctrl.config[ctrl.type][&quot;format&quot;] }}\" minute-steps=1 short-time=true show-todays-date=false click-outside-to-close=true auto-ok=true edit-input=false show-icon=true class=md-input>");
$templateCache.put("app/app-utils/components/cep-icon/cep-icon.html","<svg viewBox=\"0 0 100 100\" role=img class=\"cep-icon {{ &quot;svg-fill-color-&quot; + ctrl.color }} {{ &quot;icon-scale-&quot; + ctrl.scale }}\"><title>{{ ctrl.icon }}</title><use xlink:href=\"{{ ctrl.iconPath }}\"></use></svg>");
$templateCache.put("app/app-utils/components/chat-bot/chat-bot.html","<div ng-class=\"{ \'chat-open\': ctrl.isOpen, \'chat-closed\': !ctrl.isOpen }\" ng-if=ctrl.isChatEnabled class=chat-bot><div ng-click=ctrl.toggleChat() class=chat-icon><svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 96.71 96.71\"><defs><style>.cls-1 {\n            fill: #fff;\n          }\n          .cls-2 {\n            fill: #e7434c;\n          }\n          .cls-3 {\n            fill: #5a2c80;\n          }</style></defs><g id=out><g><path d=m30.29,78.94l-6.94,10.82C9.36,81.28,0,65.91,0,48.36,0,29.18,11.16,12.61,27.34,4.79l5.54,11.59c-11.86,5.75-20.04,17.91-20.04,31.98,0,13.02,7.01,24.4,17.45,30.58Z class=cls-2></path><path d=m86.32,18.41l-10.72,7.17c-6.51-7.79-16.31-12.74-27.25-12.74-.34,0-.68,0-1.02.02V.01c.34,0,.68-.01,1.02-.01,15.4,0,29.12,7.2,37.97,18.41Z class=cls-3></path><path d=m42.59,83.4l-.98,12.84c-6.6-.92-12.78-3.17-18.25-6.49l6.94-10.82c3.72,2.2,7.87,3.74,12.3,4.47Z class=cls-1></path><path d=m96.71,48.36c0,11.82-4.24,22.65-11.29,31.05l-11.49-6.4c6.16-6.39,9.94-15.08,9.94-24.65,0-8.66-3.1-16.61-8.26-22.78l10.72-7.17c6.5,8.23,10.38,18.63,10.38,29.94Z class=cls-1></path><path d=m47.33.01v12.84c-5.17.14-10.06,1.39-14.45,3.52l-5.54-11.59C33.4,1.86,40.17.16,47.33.01Z class=cls-1></path><path d=m85.42,79.41c-8.86,10.58-22.18,17.3-37.07,17.3-2.29,0-4.54-.16-6.74-.47l.98-12.84c1.88.3,3.8.47,5.76.47,10.04,0,19.11-4.17,25.57-10.87l11.49,6.4Z class=cls-3></path></g></g><g id=in><g><path d=m40.67,32.68c-3.03,1.49-5.58,3.84-7.31,6.72l-6.98-4.47c2.56-4.18,6.28-7.58,10.71-9.74l3.58,7.48Z class=cls-1></path><path d=m74.1,48.36c0,7.89-3.54,14.94-9.13,19.67l-8.02-4.47c5.29-3,8.86-8.68,8.86-15.2,0-4.96-2.07-9.44-5.39-12.62l7.01-4.68c4.15,4.57,6.68,10.64,6.68,17.3Z class=cls-1></path><path d=m35.14,59.76l-6.54,5.12c-2.44-2.92-4.25-6.39-5.21-10.19l7.98-2.27c.66,2.76,1.97,5.26,3.77,7.35Z class=cls-1></path><path d=m64.97,68.02c-4.48,3.79-10.29,6.08-16.62,6.08-7.93,0-15.03-3.59-19.75-9.23l6.54-5.12c3.2,3.71,7.93,6.05,13.21,6.05,3.13,0,6.06-.82,8.6-2.26l8.02,4.47Z class=cls-2></path><path d=m30.9,48.36c0,1.4.17,2.76.47,4.06l-7.98,2.27c-.51-2.02-.78-4.14-.78-6.33,0-4.92,1.38-9.52,3.77-13.42l6.98,4.47c-1.57,2.62-2.47,5.68-2.47,8.96Z class=cls-3></path><path d=m67.42,31.05l-7.01,4.68h0c-3.13-2.99-7.38-4.83-12.06-4.83-2.76,0-5.36.64-7.68,1.78l-3.58-7.48c3.4-1.65,7.22-2.59,11.26-2.59,7.56,0,14.36,3.26,19.07,8.44Z class=cls-2></path></g></g></svg></div><div class=chat-panel><div ng-if=ctrl.errorConfig style=\"height: 100%; flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center\"><div class=text-center><md-icon md-font-set=material-icons md-menu-align-target aria-label=warning style=\"font-size: 8rem\">warning</md-icon><h4 class=error-message>Chat configuration is not available.</h4></div></div><form id=chat-message-form ng-submit=ctrl.sendMessage() ng-if=!ctrl.errorConfig class=chat-messages><div ng-repeat=\"message in ctrl.messages track by $index\" ng-class=\"{ \'message-user\': message.user === \'User\', \'message-bot\': message.user === \'Bot\' }\" class=message><div ng-bind-html=message.text style=\"white-space: pre-wrap\"></div></div><div style=\"display: flex; align-items: center; justify-content: center\"><md-progress-circular ng-if=ctrl.loading md-mode=indeterminate md-diameter=20px></md-progress-circular></div></form><textarea ng-if=!ctrl.errorConfig ng-model=ctrl.message name=message placeholder=\"\" rows=6 required class=chat-input></textarea><div ng-if=!ctrl.errorConfig class=chat-actions><button type=submit form=chat-message-form ng-disabled=ctrl.loading class=chat-button>Send</button></div></div></div>");
$templateCache.put("app/app-utils/components/client-card/client-card.html","<md-dialog id=client-card aria-label=ClientCard style=\"min-width: 50vw\"><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ ctrl.title }}</h2><span flex></span><round-button on-click=ctrl.cancel() aria-label=Close icon=close ng-disabled=loading></round-button></div></md-toolbar><section id=screen-card ng-if=!ctrl.printView><form ng-cloak><md-dialog-content layout=row layout-wrap layout-align=\"center stretch\" class=\"grey lighten-3 m0\"><md-card flex=100 flex-gt-sm=50 ng-repeat=\"group in ctrl.groups track by $index\"><md-toolbar class=\"border-detail white text-main-color\"><div layout=row><h4 flex=\"\" md-truncate=\"\" class=md-toolbar-tools><span ng-if=\"group!=undefined\">{{ group }}</span></h4></div></md-toolbar><md-card-content layout=row layout-wrap layout-padding><md-input-container ng-repeat=\"input in ctrl.inputsTypes | filter: { \'group\' : group }\" ng-switch=input.type flex=\"{{ ctrl.listSchema[input.field].format != \'textarea\' ? \'45\' : \'100\' || \'45\' }}\"><label ng-if=\"![\'lookup\',\'reference\', \'sequential\'].includes(input.type)\">{{ input.title }} ({{ input.type }})</label><span ng-switch-when=reference><issue-reference-selector model=ctrl.inputDataValues[input.field] field=ctrl.listSchema[input.field] key=input.field style=\"position: relative; top: -19px\" disabled></issue-reference-selector></span><span ng-switch-when=sequential><issue-sequential-selector model=ctrl.inputDataValues[input.field] field=ctrl.listSchema[input.field] key=input.field style=\"position: relative; top: -19px\" disabled></issue-sequential-selector></span><span ng-switch-when=autoincrement><input ng-model=ctrl.inputDataValues[input.field] disabled></span><span ng-switch-when=string|url ng-switch-when-separator=|><input ng-if=\"ctrl.listSchema[input.field].format!=\'textarea\'\" ng-model=ctrl.inputDataValues[input.field] ng-disabled=input.disabled><textarea ng-if=\"ctrl.listSchema[input.field].format==\'textarea\'\" ng-model=ctrl.inputDataValues[input.field] ng-disabled=input.disabled>{{ ctrl.inputDataValues[input.field] }}</textarea></span><span ng-switch-when=integer|double|long ng-switch-when-separator=|><input type=number ng-model=ctrl.inputDataValues[input.field] style=\"padding: 0 10px\" autocomplete=off ng-disabled=\"input.readonly || !ctrl.canEdit\"></span><span ng-switch-when=date ng-class=\"{ \'read-only\': input.disabled }\"><input mdc-datetime-picker type=text date=true short-time=false time=false minutes=false seconds=false show-todays-date=true click-outside-to-close=true placeholder=date auto-ok=true minute-steps=1 ng-model=ctrl.inputDataValues[input.field] edit-input=true show-icon=true ng-model-options=\"{ timezone: \'utc\' }\" ng-disabled=input.disabled class=w100></span><span ng-switch-when=time ng-class=\"{ \'read-only\': input.disabled }\"><input mdc-datetime-picker type=text date=false seconds=true short-time=true show-todays-date=false click-outside-to-close=true placeholder=Time auto-ok=true minute-steps=1 format=HH:mm:ss ng-model=ctrl.inputDataValues[input.field] edit-input=true show-icon=true ng-model-options=\"{ timezone: \'utc\' }\" ng-disabled=input.disabled class=md-input></span><spam ng-switch-when=timestamp ng-class=\"{ \'read-only\': input.disabled }\"><input mdc-datetime-picker type=text date=true short-time=false show-todays-date=false click-outside-to-close=true placeholder=Time auto-ok=true minute-steps=1 format=\"DD-MM-YYYY HH:mm:ss\" ng-model=ctrl.inputDataValues[input.field] edit-input=true show-icon=true ng-model-options=\"{ timezone: \'utc\' }\" ng-disabled=input.disabled class=md-input></spam><span ng-switch-when=boolean><md-switch ng-model=ctrl.inputDataValues[input.field] aria-label=\"{{ input.title }} ({{ input.type }})\" ng-disabled=input.disabled>{{ ctrl.inputDataValues[input.field] ? \"true\" : \"false\" }}</md-switch></span><span ng-switch-default><label for=\"{{ input.field }}\">{{ input.title }} ({{ input.type }})</label><input ng-model=ctrl.inputDataValues[input.field] disabled></span></md-input-container></md-card-content></md-card><md-card flex=45 ng-if=\"ctrl.references.length &gt; 0\"><md-toolbar class=\"border-detail white text-main-color\"><div layout=row><h4 flex=\"\" md-truncate=\"\" class=md-toolbar-tools><span>References</span></h4></div></md-toolbar><md-card-content layout=row layout-wrap layout-padding><div layout=row layout-wrap layout-align=\"start stretch\" class=w100><div style=\"width: 80px; text-align: center\" ng-repeat=\"item in ctrl.references\" ng-click=ctrl.showRelatedContent($event) class=icon-box><div style=\"float: right; position: relative; top: 20px; background-color: rgb(255, 64, 129); font-weight: 600; color: white\" class=cep-badge>{{ item.count }}</div><md-tooltip>{{ item.schema.name | lowercase | capitalize }}</md-tooltip><cep-icon icon=\"{{ item.schema.icon ? item.schema.icon : \'cep-clip\' }}\" scale=2></cep-icon><br><div style=\"font-size: 0.85em; padding: 2px\" class=md-truncate>{{ item.schema.name | lowercase | capitalize }}</div></div></div></md-card-content></md-card></md-dialog-content><md-dialog-actions layout=row style=\"border: 1px solid #eaeaea\"><md-button ng-click=\"ctrl.printView = !ctrl.printView\" class=md-raised>print view</md-button><md-button ng-click=ctrl.cancel() ng-disabled=loading class=md-raised>close</md-button><md-button ng-click=ctrl.save() ng-disabled=loading has-permission=list#{{ctrl.listId}}:update class=\"md-raised md-primary\">save</md-button></md-dialog-actions></form></section><section id=print-card ng-if=ctrl.printView><md-dialog-content id=print-area class=\"grey lighten-3 m0\"><section layout=row layout-aling=\"center center\"><div flex=30><img ng-src=../assets/theme_image/custom.png loading=eager alt=logotipo class=w100></div><div flex=70><h3 class=pull-right>{{ ctrl.issue.issueType.name }}</h3></div></section><section style=\"display: block; border-bottom: 1px dashed #eaeaea; padding: 10px; margin: 10px 0; page-break-after: always\"><div style=\"text-align: center\"><h2>Data</h2></div><div ng-repeat=\"group in ctrl.groups track by $index\"><h3 style=\"border-bottom: 1px solid grey\"><b>{{ group }}</b></h3><article style=\"display: grid; grid-template-columns: repeat(4, 1fr); grid-gap: 1rem\"><div ng-repeat=\"input in ctrl.inputsTypes | filter: { \'group\' : group }\" ng-switch=input.type><span ng-switch-when=date><p class=m0>{{ input.title }}</p><b>{{ ctrl.inputDataValues[input.field] | date: \"dd-MM-yyyy\":\"UTC\" }}</b></span><span ng-switch-when=time><p class=m0>{{ input.title }}</p><b>{{ ctrl.inputDataValues[input.field] | date: \"dd hh:mm a\":\"UTC\" }}</b></span><span ng-switch-when=timestamp><p class=m0>{{ input.title }}</p><b>{{ ctrl.inputDataValues[input.field] | date: \"dd-MM-yyyy hh:mm a\":\"UTC\" }}</b></span><span ng-switch-when=integer|double ng-switch-when-separator=|><p class=m0>{{ input.title }}</p><b>{{ ctrl.inputDataValues[input.field] | number }}</b></span><span ng-switch-default><p class=m0>{{ input.title }}</p><b>{{ ctrl.inputDataValues[input.field] }}</b></span></div></article></div><div style=\"text-align: center\"><h2>References</h2></div><div ng-repeat=\"reference in ctrl.references track by $index\"><h3 style=\"border-bottom: 1px solid grey\"><b>{{ reference.schema.name | lowercase | capitalize }} ({{ reference.count }})</b></h3><div><table class=\"table w100\"><thead><tr><th>Description</th><th>Category</th><th>Clasification</th><th>Date</th><th>Criticality</th></tr></thead><tbody><tr ng-repeat=\"item in reference.references.data\"><td>{{ item.item.description }}</td><td>{{ item.item.category.label || item.item.category.name }}</td><td>{{ item.item.classification.name }}</td><td>{{ item.item.createdAtLocal | date: \"dd-MM-yyyy\" }}</td><td>{{ item.item.criticality.name }}</td></tr></tbody></table></div></div></section></md-dialog-content><md-dialog-actions layout=row style=\"border: 1px solid #eaeaea\"><md-button ng-click=\"ctrl.printView = !ctrl.printView\" class=md-raised>form view</md-button><md-button ng-click=ctrl.cancel() class=md-raised>close</md-button><md-button ng-click=ctrl.print() class=\"md-raised white-text blue\">print</md-button></md-dialog-actions><div style=\"display: none; visibility: hidden\"><iframe id=printf , loading=lazy></iframe></div></section></md-dialog>");
$templateCache.put("app/app-utils/components/dialog-select/dialog-select.html","<md-dialog id=selector-dialog aria-label=selector-dialog style=\"width: 35vw\"><md-toolbar><div class=md-toolbar-tools><h2>{{ title || \'Select a item \' }}</h2><span flex></span><md-button ng-click=ctrl.cancel($event) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column layout-padding><md-content><div layout=column><div flex style=\"position: sticky; top: -10px; z-index: 2\" class=white><md-input-container style=\"margin-bottom: 0\" class=w100><input ng-model=searchTerm aria-label=\"schema filter\" type=search placeholder=Search class=md-text></md-input-container><div layout=row layout-align=\"center center\"><div flex ng-if=ctrl.isMultiple><strong>{{ ctrl.selected }} selections</strong></div><div flex class=text-right><md-button ng-click=ctrl.clearSelections() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=clear_all>clear_all</md-icon></md-button></div></div></div><div flex><md-list><md-list-item ng-repeat=\"item in ctrl.list | filter: {name: searchTerm}\" ng-click=ctrl.pickItem(item) class=noright><p>{{ item.name }}</p><md-checkbox ng-if=ctrl.isMultiple ng-model=item.selected class=md-secondary></md-checkbox><md-radio ng-if=!ctrl.isMultiple ng-model=item.selected class=md-secondary></md-radio></md-list-item></md-list></div></div></md-content></md-dialog-content><md-dialog-actions><md-button md-colors=green ng-click=ctrl.cancel($event)>Cancel</md-button><md-button md-colors=green ng-click=ctrl.save()>Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/app-utils/components/folder-selector/folder-selector.html","<md-dialog aria-label=\"Folder selector\"><form><md-toolbar class=main-color><div class=md-toolbar-tools><h2>Folder selector</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-width: 600px; max-width: 800px; max-height: 810px; padding: 5px\"><div layou=row layout-wrap class=\"grey lighten-3\"><span><md-button ng-click=ctrl.root()>ROOT</md-button></span><span ng-if=\"ctrl.breadcrumbs.length &gt; 0\">/</span><span ng-repeat=\"crumb in ctrl.breadcrumbs track by $index\"><md-button ng-click=ctrl.toFolder(crumb) ng-disabled=\"$index === ctrl.breadcrumbs.length-1\">{{ crumb }}</md-button><span ng-if=\"$index &lt; ctrl.breadcrumbs.length\">/</span></span></div><section layout=row layout-wrap style=\"grid-gap: 0\" class=\"w100 ng-grid grid-x3\"><md-button ng-click=ctrl.save() class=\"md-raised text-left green lighten-5\"><md-icon md-font-set=material-icons class=green-text>save</md-icon>&nbsp; Store here</md-button><md-button ng-repeat=\"folder in ctrl.currentFolder track by $index\" ng-click=ctrl.openFolder(folder) class=\"md-raised text-left\"><md-icon md-font-set=material-icons class=\"grey-text lighten-3\">folder</md-icon>&nbsp; {{ folder.groupName }}</md-button></section><section layout=row layout-wrap layout-align=\"start center\" class=w100><div><md-button ng-click=ctrl.createNewFolder() ng-if=!ctrl.newFolderItems class=\"md-raised green lighten-5\"><md-icon md-font-set=material-icons>create_new_folder</md-icon>&nbsp; New Folder</md-button></div><div><md-input-container ng-if=ctrl.newFolderItems><label>Folder name</label><input ng-model=ctrl.newFolderName></md-input-container><md-button ng-click=ctrl.addNewFolder() ng-disabled=\"ctrl.newFolderName == &quot;&quot;\" ng-if=ctrl.newFolderItems class=\"md-fab md-raised md-mini green white-text\"><md-icon md-font-set=material-icons class=white-text>save</md-icon></md-button><md-button ng-click=ctrl.cancelNewFolder() ng-if=ctrl.newFolderItems class=\"md-fab md-raised md-mini red white-text\"><md-icon md-font-set=material-icons class=white-text>cancel</md-icon></md-button></div></section></md-dialog-content></form></md-dialog>");
$templateCache.put("app/app-utils/components/full-text-search/full-text-search-btn.html","<md-button ng-click=ctrl.showDialog($event) aria-label=showdialog class=\"md-raised second-color white-text border-radius\"><i class=\"fa fa-search search-icon\"></i>Text Search</md-button>");
$templateCache.put("app/app-utils/components/full-text-search/full-text-search.html","<md-dialog aria-label=full-text-search><md-toolbar class=main-color><div class=md-toolbar-tools><h2>Full Text Search<strong style=\"font-size: 2rem; margin: 0 1rem\" class=badge>{{ ctrl.target }}</strong></h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"width: 80vw\"><form layout=row layout-align=\"center center\" layout-margin ng-submit=ctrl.search() class=full-text-search><div layout=row layout-align=\"center center\" flex class=finder><div class=finder-icon><md-icon md-font-set=material-icons ng-click=ctrl.onclick() class=white-text>search</md-icon></div><div class=\"finder-input w100\"><input id=root-scope-searcher autofocus style=\"height: 4rem; font-size: 1.5em\" ng-model=ctrl.searchText autocomplete=off placeholder=Search... class=w100></div></div><div flex=1><md-button type=submit ng-disabled=ctrl.loading class=\"md-raised white-text green\">Search</md-button><md-button ng-click=ctrl.clearSearch() ng-disabled=ctrl.loading class=\"md-raised white-text red\">Clear</md-button></div></form><md-progress-linear md-mode=indeterminate ng-if=ctrl.loading></md-progress-linear><section id=result ng-if=ctrl.empty.show style=\"padding: 1rem 4rem\" class=\"amber lighten-1\"><h4><i class=\"fa fa-exclamation-triangle\"></i><strong>{{ ctrl.empty.message }}</strong></h4></section><section id=result ng-if=\"ctrl.target === \'LIST\' &amp;&amp; ctrl.searchResults.length &gt; 0\" style=\"padding: 1rem\"><div ng-repeat=\"result in ctrl.searchResults track by $index\"><div layout=row layout-align=\"start center\" style=\"gap: 1rem; align-items: baseline\" class=m0><h3>{{ result.target }}</h3><small>{{ result.pagination.totalRecords }} records found</small></div><table ng-if=\"result.data.length &gt; 0\" class=\"table-condensed table-bordered table-hover w100\"><thead><tr><th ng-repeat=\"head in result.header track by $index\">{{ head }}</th></tr></thead><tbody><tr ng-repeat=\"item in result.data track by $index\"><td ng-repeat=\"head in result.header track by $index\">{{ item.body[head] }}</td></tr></tbody></table></div></section><section id=result ng-if=\"ctrl.target === \'ISSUES\' &amp;&amp; ctrl.searchResults.data.length &gt; 0\" style=\"padding: 1rem\"><table class=\"table-condensed table-bordered table-hover w100\"><thead><tr><th ng-repeat=\"head in ctrl.searchResults.header track by $index\">{{ head }}</th></tr></thead><tbody><tr ng-repeat=\"item in ctrl.searchResults.data track by $index\"><td ng-repeat=\"head in ctrl.searchResults.header track by $index\">{{ item[head] }}</td></tr></tbody></table></section><section id=result ng-if=\"ctrl.target === \'TABLE\' &amp;&amp; ctrl.searchResults.length &gt; 0\" style=\"padding: 1rem\"><div ng-repeat=\"result in ctrl.searchResults track by $index\"><div layout=row layout-align=\"start center\" style=\"gap: 1rem; align-items: baseline\" class=m0><h3>{{ result.target }}</h3><small>{{ result.pagination.totalRecords }} records found</small></div><table ng-if=\"result.data.length &gt; 0\" class=\"table-condensed table-bordered table-hover w100\"><thead><tr><th ng-repeat=\"head in result.header track by $index\">{{ head }}</th></tr></thead><tbody><tr ng-repeat=\"item in result.data track by $index\"><td ng-repeat=\"head in result.header track by $index\">{{ item[head] }}</td></tr></tbody></table></div></section></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button ng-click=ctrl.cancel() class=md-raised>Cancel</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/app-utils/components/json-input/json-input.html","<div style=\"position: relative\" class=hot-json-editor><div style=\"height: 250px\" tabindex=-1 id={{ctrl.id}} ng-model=myJson ui-ace=\"{ useWrapMode : true, showGutter: true, theme:\'monokai\', mode: \'json\', rendererOptions: { minLines: 10 },onChange: aceChanged }\"></div><md-button ng-click=ctrl.closeEditor() style=\"position: absolute; bottom: 0; right: 0\" class=\"m0 md-raised md-primary\">close</md-button></div>");
$templateCache.put("app/app-utils/components/letter-avatar/letter-avatar.html","<div ng-class=ctrl.colorClass ng-style=\"ctrl.color ? { &quot;background-color&quot;: ctrl.color } : {}\" style=\"margin: 0 0.5rem 0 0; border-radius: 100px; padding: 0.5rem; color: white; width: auto; display: inline-block\"><span>{{ ctrl.label }}</span></div>");
$templateCache.put("app/app-utils/components/list-groups-tree/list-groups-tree.html","<ul class=treeMenu><li ng-repeat=\"g in ctrl.groups track by $index\"><div><div ng-click=ctrl.onDisplay() class=treeTitle><strong>{{ctrl.current_level +1}}</strong>&nbsp; - &nbsp; {{g.groupName}} {{ctrl.selected[ctrl.current_level] == g.groupName? \"********\":\"\"}}</div><span ng-if=ctrl.display><list-groups-tree ng-if=\"g.groupName!=\'ROOT\'\" groups=g.subGroup selected level=ctrl.current_level+1></list-groups-tree></span></div></li><li ng-if=\"ctrl.current_level&gt;0 \"><div><div class=treeTitle>+</div></div></li></ul>");
$templateCache.put("app/app-utils/components/main-datepicker/main-datepicker.html","<form role=search class=navbar-form><div ng-if=ctrl.isDisplayed><i class=icon-date_range></i><abm-form-group class=\"form-group m0 p0\"><input style=\"max-width: 100px; text-align: center\" type=text bs-datepicker placeholder=Desde ng-model=ctrl.desde abm-form-control=\"\" data-max-date=\"{{ ctrl.hasta }}\" data-autoclose=1 data-date-format=dd-MM-yyyy ng-change=ctrl.dateChanged() class=form-control></abm-form-group><abm-form-group class=\"form-group m0 p0\"><input style=\"max-width: 100px; text-align: center\" type=text bs-datepicker placeholder=Hasta ng-model=ctrl.hasta abm-form-control=\"\" data-min-date=\"{{ ctrl.minDate }}\" data-autoclose=1 data-date-format=dd-MM-yyyy ng-change=ctrl.dateChanged() class=form-control></abm-form-group></div></form>");
$templateCache.put("app/app-utils/components/ng-dialog/ng-dialog.html","<md-dialog id=selector-dialog aria-label=selector-dialog style=\"width: 35vw\"><md-toolbar><div class=md-toolbar-tools><h2>ng dialog</h2><span flex></span><md-button ng-click=ctrl.cancel($event) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column layout-padding><md-content><div id=dy-component></div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/app-utils/components/pagination/pagination.html","<div class=pagination-iu><div layout=row layout-align=\"end center\" label-padding><div flex=none><md-button ng-disabled=\"ctrl.pagination.page == 1\" aria-label=page-prev ng-click=ctrl.onClickPage(&quot;prev&quot;) class=\"md-fab md-raised md-mini\"><md-icon md-font-set=material-icons md-menu-align-target class=text-warning>arrow_back</md-icon></md-button></div><div flex=none><md-button ng-disabled=\"ctrl.maxPage &lt;= ctrl.pagination.page\" aria-label=page-next ng-click=ctrl.onClickPage(&quot;next&quot;) class=\"md-fab md-raised md-mini\"><md-icon md-font-set=material-icons md-menu-align-target class=text-warning>arrow_forward</md-icon></md-button></div><div flex=none style=\"padding-right: 20px\">&nbsp;<span>{{ ctrl.pagination.page }}</span>&nbsp;/&nbsp;<span>{{ ctrl.totalPages(ctrl.pagination.totalRecords, ctrl.pagination.itemsPerPage) }}</span>&nbsp; Total {{ ctrl.pagination.totalRecords }} &nbsp;</div></div></div>");
$templateCache.put("app/app-utils/components/redis-alert/redis-alert.html","<div style=\"display: flex; align-items: center; flex-direction: row; gap: 1rem\"><span><span ng-if=\"ctrl.loading === true\"><md-progress-circular md-mode=indeterminate md-diameter=25px></md-progress-circular></span><span ng-if=\"ctrl.loading === false\"><img src=assets/images/icons/redis.svg style=\"height: 25px\" ng-class=\"{ \'grayscale\': !ctrl.redisIsConnected, \'\': ctrl.redisIsConnected }\"></span><md-tooltip ng-if=ctrl.small md-z-index=9999 md-delay=200>Redis is {{ ctrl.redisStatus }}</md-tooltip></span><h6 ng-if=!ctrl.small class=\"m0 p0\"><strong>Redis is {{ ctrl.redisStatus }}</strong></h6></div>");
$templateCache.put("app/app-utils/components/risk-level/risk-level.html","<div ng-if=\"ctrl.has_criticalities==true\" ng-class=\"{ &quot;is-locked&quot;: ctrl.isLocked }\"><h6>Risk level: &nbsp;<b>{{ ctrl.selected }}</b></h6><div ng-class=ctrl.layout class=risk-level><div ng-repeat=\"critical in ctrl.criticalities track by critical.id\" ng-class=\"{ active: ctrl.level == critical.id }\" class=level><div ng-class=critical.color ng-click=ctrl.onClick(critical.id) class=box><cep-icon icon=\"{{ critical.icon }}\" color=white></cep-icon><md-tooltip md-direction=bottom>{{ critical.name }}</md-tooltip></div></div></div></div><div ng-if=\"ctrl.has_criticalities==false\"><code>criticalities types not setted =( {{ ctrl.criticalities }}</code></div>");
$templateCache.put("app/app-utils/components/riskview/riskview.html","<md-content flex layout=column ng-if=ctrl.permissionError><div class=text-center><br><md-icon style=\"font-size: 50px\" class=\"md-warn md-hue-1\">warning</md-icon><br><p>{{ ctrl.permissionError.message }}</p></div></md-content><md-content flex layout=column ng-if=ctrl.isEmpty><p class=text-center><md-icon style=\"font-size: 30px\" class=\"md-warn md-hue-1\">info</md-icon>NO DATA IN TABLE &nbsp;<strong>{{ ctrl.config.dataSource }}</strong></p></md-content><md-progress-linear md-mode=indeterminate ng-if=ctrl.loading></md-progress-linear><md-card ng-if=\"ctrl.config.type === \'risk-heatmap\'\"><table class=w100><thead><tr><th colspan=\"{{ ctrl.grid_defs.indicador_x.length + 2 }}\" class=text-center><strong>{{ ctrl.assest.indicador_x }}</strong></th></tr><tr><th></th><th></th><th ng-repeat=\"impact in ctrl.grid_defs.indicador_x\" class=text-center>{{ impact.name }} {{ impact.value }}</th></tr></thead><tbody><tr ng-repeat=\"risk in ctrl.grid_defs.indicador_y track by $index\"><th rowspan=\"{{ ctrl.matrix[$index].length + 1 }}\" ng-if=\"$index === 0\"><strong class=v-text>{{ ctrl.assest.indicador_y }}</strong></th><td class=text-center>{{ risk.name }} {{ risk.value }}</td><td ng-repeat=\"item in ctrl.matrix[$index]\" ng-style=\"{ \'background-color\': item.range_level.color }\" class=text-center><h4>{{ item.range_level.name }}</h4><h6>{{ item.value }}</h6></td></tr></tbody></table></md-card><section layout=row ng-if=\"ctrl.config.type === \'risk-stats\'\"><md-card flex=33 ng-repeat=\"(key,value) in ctrl.issues_card\" style=\"display: flex; flex-direction: column; justify-content: space-between\"><div style=\"padding: 1rem\"><h4><strong>{{ key }}</strong></h4><div layout=row ng-repeat=\"(k,v) in value.rules\" style=\"border-bottom: 1px solid #d1d1d1; padding: 0.3rem 0; margin-bottom: 0.3rem\"><div flex=80><strong>{{ v.name }}</strong></div><div flex=20 class=text-center><span ng-style=\"{ \'background-color\': v.level.color }\" class=badge>{{ v.total }}</span></div></div></div><div layout=row><div flex=100 flex-md=50 flex-gt-md=25 ng-repeat=\"t in value.totals\" ng-style=\"{ \'background-color\': t.color }\" class=text-center><h6>{{ t.name }}</h6><strong>{{ t.value }}</strong></div></div></md-card></section>");
$templateCache.put("app/app-utils/components/round-button/round-button.html","<md-button type=button ng-click=$ctrl.onClick() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=$ctrl.ariaLabel>{{$ctrl.icon}}</md-icon><div class=md-ripple-container></div></md-button>");
$templateCache.put("app/app-utils/components/rule-services/rule-services.html","<md-menu md-position-mode=\"left bottom\"><md-button aria-label=rule-services ng-click=$mdMenu.open() class=\"md-fab md-mini white\"><i class=\"fa fa-cog grey-text\"></i></md-button><md-menu-content width=2 ng-mouseleave=$mdMenu.close()><md-menu-item><redis-alert></redis-alert></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("app/app-utils/components/searcher/searcher.html","<div layout=row class=finder><div class=finder-icon><md-icon md-font-set=material-icons ng-click=ctrl.onclick() class=white-text>search</md-icon></div><div class=\"finder-input w100\"><input id=root-scope-searcher ng-model=ctrl.value autocomplete=off placeholder=\"{{ ctrl.placeholder }}\" class=w100></div></div>");
$templateCache.put("app/app-utils/components/table-data/table-data.html","<div ng-cloak class=table-data><div layout=column layout-aling=\"center center\" ng-if=ctrl.isLoading><div class=text-center><h5>{{ ctrl.ctrl.translation.loading }}</h5></div></div><div class=table-data-container><ng-include src=&quot;app/app-utils/components/table-data/includes/table-data-main-menu.html&quot;></ng-include><div ng-if=ctrl.isLoading><md-progress-linear md-mode=indeterminate></md-progress-linear></div><div id={{ctrl.tableuuid}}></div><ng-include ng-if=!ctrl.isLoading src=&quot;app/app-utils/components/table-data/includes/table-data-pagination.html&quot;></ng-include></div></div>");
$templateCache.put("app/app-utils/components/table-input-list/table-input-list.html","<md-card id=InputListReader ng-cloak><md-content class=content_blocks><div><md-toolbar class=md-menu-toolbar><div layout=row><md-toolbar-filler id=btnInputListonGoBack layout layout-align=\"center center\" ng-click=ctrl.getBack() class=main-color><md-tooltip md-z-index=9999 md-delay=200>{{ translation.get_back }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>table_rows</md-icon></md-toolbar-filler><div class=w100><h2 class=md-toolbar-tools><div class=md-title>{{ ctrl.list.name }}</div></h2><ng-include src=&quot;app/app-utils/components/table-input-list/table-list-main-menu.html&quot;></ng-include></div></div></md-toolbar></div></md-content><md-divider></md-divider><section><md-content ng-if=ctrl.tableIsLoading><md-progress-linear></md-progress-linear></md-content><div layout=row><section flex=70><div ui-grid-pagination ui-grid-resize-columns ui-grid-auto-resize ui-grid=ctrl.gridOptions style=\"height: 70vh\" class=listGrid></div></section></div></section></md-card>");
$templateCache.put("app/app-utils/components/table-input-list/table-list-main-menu.html","<md-menu-bar id=table-list-main-menu-bar layout=row><md-menu><button ng-click=$mdMenu.open()>{{ translation.tools }}</button><md-menu-content width=3><md-menu-item><md-button ng-click=ctrl.unFilterData()>{{ translation.remove_filters }}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=ctrl.exportList(&quot;xlsx&quot;)>{{ translation.export }} (.csv .xlsx)</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=ctrl.getBack()>{{ translation.exit }}</md-button></md-menu-item></md-menu-content></md-menu><button ng-if=ctrl.list.updatingData style=\"color: orange\"><span>{{ translation.updating_list_msg }}</span></button><div flex></div><section layout=row style=\"padding: 5px\"><div ng-repeat=\"(key, predicate) in ctrl.filters.predicates\" style=\"margin-right: 5px; font-size: 0.7em; line-height: 2em\" class=\"text-center cep-badge\">{{ predicate.label }} {{ predicate.operation | lowercase }} {{ predicate.value != null ? ctrl.parsePredicateValue(predicate) : predicate.valuesLabels.join(\', \') }}<div style=\"margin-left: 5px\" ng-click=ctrl.removeFilter(key) class=\"fa fa-times\"></div></div><div ng-if=ctrl.isFiltered ng-click=ctrl.unFilterData() style=\"margin-right: 5px; font-size: 0.7em; line-height: 2em\" class=\"text-center cep-badge\">Remove filters</div></section></md-menu-bar>");
$templateCache.put("app/app-utils/components/tabs-bar/tabs-bar.html","<md-tabs md-dynamic-height md-border-bottom class=w100><md-tab ng-repeat=\"tab in ctrl.tabs\" ng-class=\"{ activeTab: ctrl.isActive(tab.id) }\" md-active=ctrl.isActive(tab.id) ng-click=ctrl.setTab(tab.id)><md-tab-label><cep-icon ng-if=tab.icon icon=\"{{ tab.icon }}\" color=\"{{ tab.color }}\"></cep-icon>{{ tab.name | capitalize }}<span ng-show=\"tab.id != \'index\'\" ng-click=ctrl.delTab(tab.id) style=\"vertical-align: -webkit-baseline-middle\" class=close-tab><md-icon md-font-set=material-icons md-menu-align-target style=\"font-size: 1em\" class=text-danger>cancel<md-tooltip md-direction=bottom>{{ ctrl.text.close }} Tab</md-tooltip></md-icon></span></md-tab-label></md-tab></md-tabs>");
$templateCache.put("app/app-utils/components/tool-bar/tool-bar.html","<md-toolbar class=white><div layout=row><md-toolbar-filler layout=row layout-align=\"center center\" class=main-color><md-icon>person_pin</md-icon><md-tooltip>get_back</md-tooltip></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=\"md-toolbar-tools grey-text\"><span>TITULO</span></h2><md-toolbar-filler layout=row layout-align=\"center center\" class=\"grey lighten-4\"><md-button ng-click=\"noBusqueda = true; habilitarCrear()\" aria-label={{translation.CREAR}} class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>CREAR</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></md-toolbar-filler></div></md-toolbar>");
$templateCache.put("app/app-utils/components/uploader/uploader.html","<p>{{ctrl.label}}</p><div ng-show=!ctrl.uploader.getNotUploadedItems().length><input type=file name=file id=file nv-file-select uploader=ctrl.uploader input-file multiple></div><div ng-show=ctrl.uploader.getNotUploadedItems().length><p>files_queue</p><section layout=row layout-wrap=\"\"><div flex=100><md-list><md-list-item ng-repeat=\"item in ctrl.uploader.queue\" md-truncate=\"\" class=p0><p><md-icon md-font-set=material-icons md-menu-align-target>file_copy</md-icon><span ng-bind=item.file.name></span><a ng-click=item.upload() title=\"Subir archivo\"><i class=icon-file_upload></i></a></p></md-list-item></md-list></div><div flex=100 ng-show=ctrl.uploader.isUploading><md-progress-linear md-mode=determinate value={{ctrl.uploader.progress}}></md-progress-linear></div><div flex=60><md-button type=button ng-click=ctrl.uploader.uploadAll() ng-disabled=!ctrl.uploader.getNotUploadedItems().length class=\"md-raised md-primary\"><md-icon md-font-set=material-icons md-menu-align-target>done</md-icon>upload_all</md-button></div><div flex=20><md-button type=button ng-click=ctrl.uploader.cancelAll() ng-disabled=!ctrl.uploader.isUploading class=\"md-icon-button md-warn\"><md-icon md-font-set=material-icons md-menu-align-target>close</md-icon><md-tooltip md-direction=bottom>cancel_all</md-tooltip></md-button></div><div flex=20><md-button type=button ng-click=ctrl.uploader.clearQueue() ng-disabled=!ctrl.uploader.queue.length class=\"md-icon-button md-warn\"><md-icon md-font-set=material-icons md-menu-align-target>delete</md-icon><md-tooltip md-direction=bottom>delete_all</md-tooltip></md-button></div></section></div>");
$templateCache.put("app/app-utils/components/user-2fa/user-2fa.html","<br><strong style=\"padding: 2rem 0 0 2rem; font-size: 1.7rem\">{{ translation.two_factor_authentication }}</strong><div layout=column layout-margin layout-align=\"start center\" ng-if=ctrl.loading2fa><div flex><h5>{{ translation.checking_two_factor_authentication }}</h5><md-progress-linear md-mode=indeterminate></md-progress-linear></div></div><div ng-if=\"!ctrl.loading2fa &amp;&amp; ctrl.Is_2fa_Enable\" layout=column layout-margin layout-align=\"center center\"><div flex=100 class=text-center><strong style=\"border-radius: 100px; padding: 1rem 3rem\" class=green-text><md-icon class=green-text>check_circle</md-icon>&nbsp;{{ translation.two_factor_authentication_is_enabled }}</strong><md-button type=button ng-click=ctrl.disable2fa() ng-disabled=ctrl.loadingdisable2fa class=\"md-raised amber\"><md-icon>lock</md-icon>Disable 2FA</md-button></div></div><div ng-if=\"!ctrl.loading2fa &amp;&amp; !ctrl.Is_2fa_Enable\" layout=column layout-margin layout-align=\"start center\"><p class=text-center><md-icon>lock</md-icon></p><h5 class=text-center><strong>{{ translation.two_factor_authentication_is_not_enable_yet }}</strong></h5><p class=text-center>{{ translation.two_factor_info }}</p><div ng-if=!ctrl.qr class=text-center><md-button ng-click=ctrl.enable2fa() ng-disabled=ctrl.loadingQr class=\"md-raised green white-text\">{{ translation.enable_two_factor_authentication }}</md-button></div><md-progress-linear md-mode=indeterminate ng-if=ctrl.loadingQr></md-progress-linear><div layout=row layout-margin layout-align=\"start center\" ng-if=\"ctrl.qr &amp;&amp; !ctrl.loadingQr\"><div flex><strong>{{ translation.setup_authenticator_app }}</strong><p>{{ translation.two_factor_copy }}</p><strong>{{ translation.scan_the_qr_code }}</strong><p>{{ translation.two_factor_info_qr }}</p><img ng-if=\"ctrl.qr &amp;&amp; !ctrl.loadingQr\" src=\"{{ ctrl.qr }}\" alt=2faqr><br><strong>{{ translation.verify_the_code_from_the_app }}</strong><md-input-container class=w100><label>{{ translation.code }}</label><input ng-model=ctrl.code placeholder=**** ng-disabled=ctrl.loading type=text autocomplete=off style=\"width: 350px\"><md-button ng-click=ctrl.confirm2fa() ng-disabled=ctrl.loading style=\"margin: 0 0 0 1rem\" class=\"md-raised green white-text\">{{ translation.confirm }}</md-button></md-input-container></div></div></div><hr>");
$templateCache.put("app/charts/components/assign-pivot-dialog/assign-pivot-dialog.html","<md-dialog aria-label=assign-pivot-dialog><form><md-toolbar class=main-color><div class=md-toolbar-tools><h2>Asignación de pivote</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-width: 400px; max-width: 600px; max-height: 810px; padding: 5px\"><md-input-container class=w100><label>Elige como visualizar los datos</label><br><br><md-radio-group ng-model=ctrl.pivotFunctionSelected aria-labelledby=selectedValue ng-change=ctrl.onChangeFunction()><md-radio-button ng-repeat=\"function in ctrl.pivotFunctionsOptions\" ng-value=function ng-disabled=function.disabled>{{ function.name }}</md-radio-button></md-radio-group></md-input-container><div ng-if=\"ctrl.pivotFunctionSelected.option == &quot;schemaFields&quot;\"><md-content layout=row><md-input-container flex=50><md-select ng-model=ctrl.field aria-label=field required><md-option ng-repeat=\"value in ctrl.schemaFields\" ng-value=value>{{ value }}</md-option></md-select></md-input-container><md-input-container flex=50><label>Valor</label><input ng-model=ctrl.value required><p>El valor a pivotear es sensible a las mayúsculas y minúsculas</p></md-input-container></md-content></div><md-input-container ng-if=\"ctrl.pivotFunctionSelected.option == &quot;xAxis&quot;\" class=w100><label>Elige el valor a usar como pivote</label><md-select ng-model=ctrl.chartValueSelected aria-label=selectchartValueSelected required><md-option ng-repeat=\"value in ctrl.chartValues.xAxis\" ng-value=value>{{ value }}</md-option></md-select></md-input-container><md-input-container ng-if=\"ctrl.pivotFunctionSelected.option == &quot;yAxis&quot;\" class=w100><label>Elige el valor a usar como pivote</label><md-select ng-model=ctrl.chartValueSelected aria-label=selectchartValueSelected required><md-option ng-repeat=\"value in ctrl.chartValues.yAxis\" ng-value=value>{{ value }}</md-option></md-select></md-input-container></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button ng-click=ctrl.removePivot() ng-if=\"ctrl.haspivot != null\" class=\"md-raised red white-text\"><md-icon md-font-set=material-icons>delete</md-icon>Eliminar pivote</md-button><md-button ng-click=ctrl.cancel() class=md-raised>Cancel</md-button><md-button ng-click=ctrl.save() class=md-raised>Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/charts/components/chart-filter/chart-filter.html","<section><div ng-if=\"ctrl.filters.length == 0\"><code>{{ ctrl.translation.No_filters_configured }}</code></div><div ng-if=\"ctrl.filters.length &gt; 0\" ng-repeat=\"item in ctrl.filters track by item.field\"><div ng-switch on=item.type><div ng-switch-when=date><label class=\"relative w100\">{{ item.field }}<md-button ng-click=ctrl.clearFilters() style=\"transform: scale(0.4); position: absolute; right: -14px; top: -15px\" class=\"md-fab md-mini\"><md-icon md-font-set=material-icons md-menu-align-target>clear</md-icon></md-button></label><section style=\"display: flex; justify-content: space-between; align-items: center\"><div><label for=item.field><span>Desde</span></label><input type=date ng-model=item.input.range[0] ng-change=item.input.onchange(item) placeholder=item.field min={{item.input.min}} max={{item.input.max}} class=\"md-input w100\"></div><div><label for=item.field><span>Hasta</span></label><input type=date ng-model=item.input.range[1] ng-change=item.input.onchange(item) placeholder=item.field min={{item.input.auxMin}} max={{item.input.max}} class=\"md-input w100\"></div></section></div><div ng-switch-default><filter-select label=item.field options=item.selectedValues ng-model=ctrl.sendFilter[item.field] config-id=ctrl.config.id></filter-select></div></div></div><div layout=column layout-margin ng-if=\"ctrl.filters.length &gt; 0\"><div flex=100 class=text-center><md-button ng-click=ctrl.filterChart() ng-disabled=\"ctrl.sendFilter == null\" class=\"w100 md-raised\"><md-icon md-font-set=material-icons md-menu-align-target>filter_list</md-icon><span>Filter Data</span></md-button></div></div></section>");
$templateCache.put("app/charts/components/chart-filter/filter-select.html","<md-input-container class=w100><md-button ng-click=clearSelections() style=\"transform: scale(0.4); position: absolute; right: -14px; top: -24px\" class=\"md-fab md-mini\"><md-icon md-font-set=material-icons md-menu-align-target>clear</md-icon></md-button><label>{{ ctrl.label }}</label><md-select ng-model=ctrl.selected multiple md-on-close=clearSearchTerm() md-container-class=selectdemoSelectHeader ng-change=setValue()><md-select-header class=demo-select-header><input ng-model=searchTerm aria-label=\"{{ ctrl.label }}\" type=search placeholder=\"Buscar {{ ctrl.label }}\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"option in ctrl.options | filter:searchTerm\" ng-value=option>{{ option }}</md-option></md-select></md-input-container>");
$templateCache.put("app/charts/components/chart-links/chart-links.html","<table class=\"table w100\"><tbody><tr colspan=2 ng-if=\"ctrl.links.length == 0\"><td><p><b>{{ ctrl.translation.There_are_no_hyperlinks }}</b></p></td></tr><tr ng-repeat=\"link in ctrl.links track by $index\"><td ng-if=\"link.type==&quot;chart&quot;\"><a ng-click=openChartTabByID(link.id)><md-icon md-font-set=material-icons md-menu-align-target>bar_chart</md-icon><b>&nbsp;&nbsp; {{ link.name }}</b></a></td><td ng-if=\"link.type==&quot;url&quot;\"><a href=\"{{ link.url }}\" target=_blank><md-icon md-font-set=material-icons md-menu-align-target>link</md-icon><b>&nbsp;&nbsp; {{ link.name }}</b></a></td><td ng-if=\"link.type==&quot;file&quot;\"><a ng-click=downloadFile(link)><md-icon md-font-set=material-icons md-menu-align-target>photo</md-icon><b>&nbsp;&nbsp; {{ link.name }}</b></a></td><td style=width:1%><md-icon md-font-set=material-icons md-menu-align-target ng-click=ctrl.removeLink(link)>delete</md-icon></td></tr></tbody><tfoot><tr><td colspan=2><md-button ng-click=ctrl.addLink() class=\"green w100 white-text\"><md-icon md-font-set=material-icons md-menu-align-target class=white-text>send</md-icon>{{ ctrl.translation.Add_hyperlink }}</md-button></td></tr></tfoot></table>");
$templateCache.put("app/charts/components/chart-list-dialog/chart-list-dialog.html","<md-dialog aria-label=chart-list-dialog ng-cloak><md-toolbar class=main-color><div class=md-toolbar-tools><h2>Hipervinculos</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-width: 400px; max-width: 600px; max-height: 810px; padding: 5px\"><md-tabs md-selected=ctrl.tabIndex md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=Graficas><md-content class=md-padding><chart-selector links=ctrl.currentlinks_Charts></chart-selector></md-content></md-tab><md-tab label=URL><md-content class=md-padding><url-link links=ctrl.currentlinks_Urls></url-link></md-content></md-tab><md-tab label=Archivos><md-content class=\"md-padding grey lighten-4\"><store-files-selector links=ctrl.currentlinks_Files></store-files-selector></md-content></md-tab></md-tabs><md-divider></md-divider><md-dialog-actions><md-button ng-click=ctrl.cancel() class=md-raised>Cancel</md-button><md-button ng-click=ctrl.save() class=md-raised>Save</md-button></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/charts/components/chart-notes/chart-notes.html","<section id=chart-notes><div layout=column><div layout=row layout-align=\"center center\"><p flex class=m0>{{ ctrl.translation.notes }}</p><p flex class=\"m0 text-right\"><md-button ng-click=ctrl.sendNote() class=\"md-fab md-mini green\"><md-icon md-font-set=material-icons md-menu-align-target class=white-text>send</md-icon><md-tooltip>{{ ctrl.translation.Write_a_note }}</md-tooltip></md-button></p></div></div><div layout=column ng-if=\"ctrl.notes.length == 0\"><p class=text-red>{{ ctrl.translation.No_notes_have_been_registered }}</p></div><div style=\"max-height:500px;overflow: auto\"><div layout=column ng-repeat=\"note in ctrl.notes track by $index\"><div ng-if=\"note.user == ctrl.currentUser\"><div layout=row layout-wrap layout-align=\"center center\" style=\"box-shadow: 0 0 2px 0px #333333;border-radius: 10px;padding: 8px;width: 90%;float: right;margin: 5px\" class=\"green lighten-4\"><span flex=60><b>{{ ctrl.translation.Me }}</b></span><span flex=40 class=text-right><small>{{ note.date }}</small></span><span flex=100>{{ note.message }}<md-icon md-font-set=material-icons md-menu-align-target ng-click=ctrl.deleteNote($index)>delete</md-icon></span></div></div><div ng-if=\"note.user != ctrl.currentUser\"><div layout=row layout-wrap layout-align=\"center center\" style=\"box-shadow: 0 0 2px 0px #333333;border-radius: 10px;padding: 8px;width: 90%;float: left;margin: 5px\" class=\"grey lighten-4\"><span flex=60><b>{{ note.user }}:</b></span><span flex=40 class=text-right><small>{{ note.date }}</small></span><span flex=100>{{ note.message }}<md-icon md-font-set=material-icons md-menu-align-target ng-click=ctrl.deleteNote($index)>delete</md-icon></span></div></div></div></div></section>");
$templateCache.put("app/charts/components/chart-sources/chart-sources.html","<table class=\"table w100\"><tbody><tr ng-repeat=\"source in ctrl.sources track by $index\"><td><p><a href=entries/lists/table/{{source.listId}} target=_blank><md-icon>library_books</md-icon><b>{{ source.name }}</b><md-tooltip>{{ ctrl.translation.show }}</md-tooltip></a></p></td></tr></tbody></table>");
$templateCache.put("app/charts/components/chart-table-view/chart-table-view.html","<div ng-if=!ctrl.isWidget class=\"w100 text-right\"><md-button ng-click=onShowTable() class=\"md-raised white\">{{ ctrl.showTable ? ctrl.translation.hide_data_table : ctrl.translation.show_data_table }}<md-icon md-font-set=material-icons md-menu-align-target>{{ ctrl.showTable ? \'keyboard_arrow_down\' : \'keyboard_arrow_up\' }}</md-icon></md-button></div><div id=chart-tabla-view style=\"overflow: auto\" ng-if=ctrl.showTable class=w100><table ng-if=\"ctrl.hasGroupby==true\" class=\"table-condensed table-bordered table-hover w100\"><thead><tr><th>{{ ctrl.chartData.xAxis.name }}</th><th ng-repeat=\"xAxis in ctrl.chartData.xAxis.data\" class=text-right>{{ xAxis }}</th></tr></thead><tbody><tr ng-repeat=\"serie in ctrl.chartData.series\"><td><svg height=20 width=20><circle cx=10 cy=10 r=8 fill=\"{{ serie.color }}\"></circle></svg><b style=\"font-size: 18px\">{{ serie.name }}</b></td><td ng-repeat=\"val in serie.data track by $index\" class=text-right><span ng-if=\"val != null\"><b style=\"font-size: 18px\">{{ val | numberFormat }}</b><b style=\"font-size: 18px\">{{ ctrl.hasPivot ? \'%\' : \'\' }}</b></span><span ng-if=\"val == null\">{{ ctrl.translation.no_records }}</span></td></tr></tbody></table><table ng-if=\"ctrl.hasGroupby==false\" class=\"table-condensed table-bordered table-hover w100\"><thead><tr><th>{{ ctrl.chartData.xAxis.name }}</th><th colspan=ctrl.chartData.series[0].data.length class=text-right>{{ ctrl.chartData.series[0].name }}</th></tr></thead><tbody><tr ng-repeat=\"serie in ctrl.chartData.series[0].data\"><td><svg height=20 width=20><circle cx=10 cy=10 r=8 fill=\"{{ serie.itemStyle.color }}\"></circle></svg><b style=\"font-size: 18px\">{{ serie.name }}</b></td><td class=text-right><span ng-if=\"serie.value != null\"><b style=\"font-size: 18px\">{{ serie.value | numberFormat }}</b><b style=\"font-size: 18px\">{{ ctrl.hasPivot ? \'%\' : \'\' }}</b></span><span ng-if=\"serie.value == null\">{{ ctrl.translation.no_records }}</span></td></tr></tbody></table></div>");
$templateCache.put("app/charts/components/chart-tables/chart-tables.html","<div id=tables-related><section ng-repeat=\"tableid in ctrl.tables\" class=\"w100 relative\"><md-icon md-font-set=material-icons ng-click=ctrl.removeTable(tableid) style=\"position: absolute;right: 0;margin: 6px;z-index:10\">delete</md-icon><table-view list-id=tableid></table-view></section><section class=\"w100 text-center\"><md-button ng-click=ctrl.inputsListDialog() class=\"md-raised white\">{{ ctrl.translation.Add_data_table }}</md-button></section></div>");
$templateCache.put("app/charts/components/chart-tables/table-view.html","<md-card id=InputListReader ng-cloak><md-content class=content_blocks><div><md-toolbar class=md-menu-toolbar><div layout=row><div class=w100><h2 class=md-toolbar-tools><div class=md-title>{{ ctrl.list.name }}</div></h2></div></div></md-toolbar></div></md-content><md-divider></md-divider><md-content style=\"max-height: 76vh\"><md-content ng-if=ctrl.tableIsLoading><md-progress-linear></md-progress-linear></md-content><md-content ng-if=!ctrl.tableIsLoading><div ui-grid-pagination ui-grid-resize-columns ui-grid-auto-resize ui-grid=ctrl.gridOptions class=listGrid></div></md-content></md-content></md-card>");
$templateCache.put("app/charts/components/checkbox-axis/checkbox-axis.html","<md-checkbox aria-label=\"Select All\" ng-checked=isChecked() md-indeterminate=isIndeterminate() ng-click=toggleAll()><span ng-if=isChecked()>{{ translation.UnSelect }}</span>{{ translation.selectAll }}</md-checkbox><div ng-repeat=\"item in items\" class=demo-select-all-checkboxes><md-checkbox ng-checked=\"exists(item, selected)\" ng-click=\"toggle(item, selected)\">{{ item }}</md-checkbox></div>");
$templateCache.put("app/charts/components/checkbox-list/checkbox-list.html","<md-checkbox aria-label=\"Select All\" ng-checked=isChecked() md-indeterminate=isIndeterminate() ng-click=toggleAll()><span ng-if=isChecked()>{{ translation.UnSelect }}</span>{{ translation.selectAll }}</md-checkbox><div layout=row layout-wrap ng-repeat=\"item in ctrl.items\" class=w100><div flex=50><md-checkbox ng-checked=\"exists(item, selected)\" ng-click=\"toggle(item, selected)\"><spam ng-if=!ctrl.field>{{ item }}</spam><spam ng-if=ctrl.field>{{ item[ctrl.field] }}</spam></md-checkbox></div></div>");
$templateCache.put("app/charts/components/data-serie/data-serie.html","<md-content layout=row><div flex=40><h5>{{ ctrl.serie.name }}</h5></div><div flex=20><md-input-container class=\"w100 m0\"><label>Color</label><input type=color ng-model=ctrl.serie.color ng-change=setValue()></md-input-container></div><div flex=20><md-input-container class=\"w100 m0\"><label>Tipo</label><md-select ng-model=ctrl.serie.type ng-change=setValue() aria-label=updateChart><md-option ng-repeat=\"type in ctrl.chartTypes\" ng-value=type>{{ type }}</md-option></md-select></md-input-container></div></md-content>");
$templateCache.put("app/charts/components/filter-dialog/filter-dialog.html","<md-dialog aria-label=input-list-dialog><form><md-toolbar class=main-color><div class=md-toolbar-tools><h2>Filters</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-width: 400px; max-width: 600px; max-height: 810px; padding: 5px\"><chart-filter config=ctrl.config translation=ctrl.translation widget=ctrl.isWidget filter=ctrl.save(filters) schema=ctrl.schema></chart-filter></md-dialog-content></form></md-dialog>");
$templateCache.put("app/charts/components/input-list-dialog/input-list-dialog.html","<md-dialog aria-label=input-list-dialog><form><md-toolbar class=main-color><div class=md-toolbar-tools><h2>Tablas</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-width: 400px; max-width: 600px; max-height: 810px; padding: 5px\"><div ng-if=\"ctrl.isLoading== true\"><md-progress-linear id=loading-in-progress md-mode=indeterminate></md-progress-linear></div><div ng-if=\"ctrl.isLoading== false\"><md-input-container class=w100><label>Listas</label><md-autocomplete md-selected-item=ctrl.selectedItem md-search-text=ctrl.searchText md-selected-item-change=ctrl.selectedItemChange(item) md-items=\"item in ctrl.querySearch(ctrl.searchText)\" md-item-text=item.name md-min-length=0 placeholder=\"Listas de datos\" input-aria-labelledby=favoriteStateLabel><md-item-template><span md-highlight-text=ctrl.searchText md-highlight-flags=^i>{{ item.name }}</span></md-item-template><md-not-found>Sin resultados para \"{{ ctrl.searchText }}\" .</md-not-found></md-autocomplete></md-input-container><div class=w100><md-list flex><md-list-item ng-repeat=\"item in ctrl.inputListSelected\" ng-click=null class=md-3-line><p>{{ item.id }} -<b>{{ item.name }}</b></p><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\" ng-click=ctrl.removeLink(item.id) class=md-secondary>delete</md-icon></md-list-item></md-list></div></div></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button ng-click=ctrl.cancel() class=md-raised>Cancel</md-button><md-button ng-click=ctrl.save() class=md-raised>Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/charts/components/select-boxplot/select-boxplot.html","<md-dialog aria-label=\"select boxplot dialog\"><md-toolbar class=main-color><div class=md-toolbar-tools><h2>Hipervinculos</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-width: 400px; max-width: 600px; max-height: 810px; padding: 5px\"><md-select aria-label=\"select boxplot option\" ng-model=ctrl.selected></md-select><md-option ng-repeat=\"opt in ctrl.boxplotOptions track by $index \" value=\"{{ opt.name }}\">{{ opt.name }}</md-option><md-divider></md-divider><md-dialog-actions><md-button ng-click=ctrl.cancel() class=md-raised>Cancel</md-button><md-button ng-click=ctrl.save() class=md-raised>Save</md-button></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/charts/components/wizard-dialog/wizard-dialog.html","<md-dialog aria-label=\"wizard chart dialog\" style=\"width: 80%\"><md-toolbar class=main-color><div class=md-toolbar-tools><span flex=80><span ng-if=\"event==\'create\'\">{{ translation.new_config }} &nbsp;</span><span ng-if=\"event==\'update\'\">{{ translation.update }}: &nbsp;<b>{{ ctrl.chartConfig.name }}</b></span></span><div flex=20 class=text-right><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></div></md-toolbar><md-dialog-content class=relative><form id=form-wizard-dialog name=formWizardDialog novalidate><md-tabs id=wizard-tabs md-selected=currentTab md-border-bottom md-no-pagination md-dynamic-height md-stretch-tabs=always class=disable-tab-navigation><md-tab ng-repeat=\"step in steps track by $index\" md-on-select=ctrl.selectStep(step.name) ng-if=step.types.includes(ctrl.assets.chartType)><md-tab-label><strong>{{ step.name }}</strong></md-tab-label><md-tab-body><div ng-if=\"currenStep === step.name\"><wizard-step step=step config=ctrl.chartConfig assets=ctrl.assets translation=translation event={{event}}></wizard-step></div></md-tab-body></md-tab><md-tab label=Validación><br><br><br><div class=text-center><md-button id=btn-save-chart-config ng-click=ctrl.saveChart() class=\"md-raised green white-text\"><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\" class=white-text>save</md-icon>{{ translation.save_chart_settings }}</md-button></div><br><br><br></md-tab></md-tabs></form></md-dialog-content><md-dialog-actions layout=row><span flex=\"\" ng-if=\"event == \'update\'\"><md-button ng-click=ctrl.saveChart() class=\"md-raised green white-text\"><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\" class=white-text>save</md-icon>{{ translation.save_chart_settings }}</md-button></span><md-button ng-click=ctrl.prevStep() ng-disabled=\"currentTab == 0\">{{ translation.prev }}</md-button><md-button id=btn-valid-step type=submit form=form-wizard-dialog ng-click=ctrl.nextStep() ng-disabled=\"steps.length == currentTab\" class=\"md-raised green white-text\">{{ translation.next }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/charts/components/wizard-step/wizard-step.html","<div id=ctrl.name></div>");
$templateCache.put("app/configuration/components/ExternalLibraries/externalLibrariesConfig.html","<md-content layout=column class=md-padding><div><md-button has-permission=python-library:init ng-click=ctrl.initLibrary() aria-label=initLibrary class=\"pull-right md-fab md-mini md-hue-3\"><md-tooltip md-direction=left>Test</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>replay</md-icon></md-button></div></md-content><md-content layout=column class=md-padding><div id=external-libraries-config ui-grid-pagination ui-grid-resize-columns ui-grid-auto-resize ui-grid=ctrl.gridOptions style=\"height: 80vh\"></div></md-content>");
$templateCache.put("app/configuration/components/storage-manager/storage-manager.html","<section layout=row ng-cloak><div flex=75 layout=row layout-wrap=\"\" layout-align=\"start start\"><md-card class=w100><md-card-title><md-card-title-text><span class=md-headline>{{ ctrl.translation.storage }}</span></md-card-title-text></md-card-title><md-divider style=\"margin-bottom: 15px\"></md-divider><md-card-content><div layout=row><md-input-container flex=30 class=m0><label>{{ ctrl.translation.name }}</label><input type=text ng-model=ctrl.storageConfig.name></md-input-container><md-input-container flex=40 class=m0><label>{{ ctrl.translation.description }}</label><input type=text ng-model=ctrl.storageConfig.description></md-input-container><md-input-container flex=30 class=m0><label>Server</label><input type=text ng-model=ctrl.storageConfig.serverUrl></md-input-container></div><b>{{ ctrl.translation.settings }}</b><md-divider style=\"margin-bottom: 25px\"></md-divider><div layout=row><md-input-container flex=20 class=m0><label>{{ ctrl.translation.file_max_size }} (MB)</label><input type=text ng-model=ctrl.storageConfig.settings.fileMaxSizeInMB></md-input-container><md-input-container flex=20 class=m0><label>{{ ctrl.translation.folder_max_size }} (MB)</label><input type=text ng-model=ctrl.storageConfig.settings.folderMaxSizeInMB></md-input-container><md-input-container flex=20 class=m0><label>{{ ctrl.translation.disk_size }} (GB)</label><input type=text ng-model=ctrl.storageConfig.diskSize></md-input-container></div><b>{{ ctrl.translation.extensions }}</b><md-divider style=\"margin-bottom: 25px\"></md-divider><div><md-chips ng-model=ctrl.storageConfig.settings.extensions md-removable=true placeholder=\"{{ ctrl.translation.add_item_hint }}\" secondary-placeholder=\"{{ ctrl.translation.add_item_hint }}\" md-add-on-blur=true md-transform-chip=ctrl.setToLowercase($chip)></md-chips></div></md-card-content><md-card-actions layout=row layout-align=\"end end\"><md-button ng-click=ctrl.save() ng-disabled=loading md-no-ink class=\"md-raised md-primary\">{{ ctrl.translation.save_button }}</md-button></md-card-actions></md-card></div><aside flex=25><disk-usage show=\"diskInfo, systemInfo\"></disk-usage></aside></section>");
$templateCache.put("app/configuration/dialog/external-librarie/external-librarie.html","<md-dialog id=python-form aria-label=external-librarie style=\"width: 80vw\"><md-toolbar><div class=md-toolbar-tools><h2><small class=white-text>{{ ctrl.library.id }}.</small>{{ ctrl.library.name }} - version {{ ctrl.library.version }}</h2><span flex></span><md-button ng-click=cancel($event) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column layout-padding><form id=formPy novalidate name=formPy ng-submit=\"formPy.$valid &amp;&amp; save()\"><md-content layout=row layout-padding><div flex><h4>{{ ctrl.library.name }}</h4><p>{{ ctrl.library.description }}</p></div><div flex><md-switch ng-model=ctrl.library.active aria-label=active class=\"p0 m0\">active: {{ ctrl.library.active }}</md-switch></div></md-content><h4>Config</h4><md-content layout=row layout-wrap layout-padding><div flex=33 ng-repeat=\"input in ctrl.library.config track by $index\" ng-switch=input.type><div style=\"display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: space-between;align-items: center\">{{ input.display }} - {{ input.type }}<md-icon md-font-set=material-icons md-menu-align-target>info<md-tooltip>{{ input.description }}</md-tooltip></md-icon></div><div ng-switch-when=text|string ng-switch-when-separator=|><md-input-container class=\"w100 m0\"><input name=\"{{ input.ncode }}\" ng-model=input.value ng-required=\"{{ input.required }}\" list=list-{{input.ncode}}><datalist id=\"list-{{ input.ncode }}\"><option ng-repeat=\"opt in input.options\" value=\"{{ opt }}\">{{ opt }}</option></datalist></md-input-container></div><div ng-switch-when=number><md-input-container class=\"w100 m0\"><input name=\"{{ input.ncode }}\" ng-model=input.value ng-required=\"{{ input.required }}\"></md-input-container></div><div ng-switch-when=email><md-input-container class=\"w100 m0\"><input name=\"{{ input.ncode }}\" ng-model=input.value ng-required=\"{{ input.required }}\"></md-input-container></div><div ng-switch-when=date><md-input-container class=\"w100 m0\"><input name=\"{{ input.ncode }}\" ng-model=input.value ng-required=\"{{ input.required }}\"></md-input-container></div><div ng-switch-when=time><md-input-container class=\"w100 m0\"><input name=\"{{ input.ncode }}\" ng-model=input.value ng-required=\"{{ input.required }}\"></md-input-container></div><div layout=row layout-padding ng-switch-when=select><div flex><md-input-container class=\"w100 p0 m0\"><md-select name=\"{{ input.ncode }}\" ng-model=input.value ng-required=\"{{ input.required }}\" class=w100><md-option ng-value=\"\">none</md-option><md-option ng-repeat=\"opt in input.options track by $index\" value=\"{{ opt }}\">{{ opt }}</md-option></md-select></md-input-container></div></div><div layout=row layout-padding ng-switch-when=radio><div flex><h5 class=bold-text>{{ input.ncode }}</h5><md-radio-group ng-model=input.value aria-labelledby=radiooptions><md-radio-button ng-repeat=\"opt in input.options track by $index\" value=\"{{ opt }}\">{{ opt }}</md-radio-button></md-radio-group></div></div><div layout=row layout-padding ng-switch-when=checkbox><div flex><h5 class=bold-text>{{ input.ncode }}</h5><md-checkbox ng-repeat=\"opt in input.options track by $index\">{{ opt }}</md-checkbox><small ng-if=input.required class=grey-text>This is required.*</small></div></div><div ng-switch-default><md-input-container class=\"w100 m0\"><input name=\"{{ input.ncode }}\" ng-model=input.value ng-required=\"{{ input.required }}\"></md-input-container></div><div style=\"display: flex; flex-direction: column\"><small ng-if=input.required class=grey-text>This is required.*</small><small ng-if=\"input.options.length === 0\" class=red-text>add some options</small></div></div></md-content></form></md-dialog-content><md-dialog-actions><md-button md-colors=green ng-click=cancel($event)>Cancel</md-button><md-button md-colors=green form=formPy type=submit has-permission=python-library:update>Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/configuration/dialog/holiday/dialog-holiday.html","<md-dialog id=issues-type-form aria-label=\"{{ actionText }}\" style=\"width: 250px\"><md-toolbar><div class=md-toolbar-tools><h2>{{ actionText }}</h2><span flex></span><md-button ng-click=cancel($event) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column layout-padding><md-content><div><md-input-container class=w100><label>holiday</label><input ng-model=ctrl.holiday.holiday type=date></md-input-container></div></md-content></md-dialog-content><md-dialog-actions><md-button md-colors=green ng-click=cancel($event)>{{ translation.cancel_button }}</md-button><md-button md-colors=green ng-click=save()>{{ translation.save_button }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/configuration/dialog/issues-type/issues-type.html","<md-dialog id=issues-type-form aria-label=\"{{ actionText }}\" style=\"width: 80vw\"><md-toolbar><div class=md-toolbar-tools><h2>{{ actionText }}</h2><span flex></span><md-button ng-click=cancel($event) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column layout-padding><md-content><md-tabs md-selected=0 md-dynamic-height md-border-bottom style=\"width: 100%\" ng-disabled=loading><md-tab label=JSON ng-click=convert(&quot;json&quot;)><md-progress-linear ng-if=loading></md-progress-linear><md-content style=\"min-height: 450px\" ng-if=!loading class=md-padding><div name=category style=\"height: 580px\" ng-model=mySchemaJson ui-ace=\"{ useWrapMode : false, showGutter: true, theme:&quot;twilight&quot;, mode: &quot;json&quot; ,onLoad : editorLoaded }\"></div></md-content></md-tab><md-tab label=FORM ng-click=convert(&quot;form&quot;)><br><!-- general--><section layout=row ng-if=loading><div flex><md-progress-linear md-mode=indeterminate></md-progress-linear></div></section><section layout=row ng-if=!loading><div flex><md-input-container class=w100><label>Name</label><input ng-model=mySchemaForm.name></md-input-container></div><div flex><md-input-container class=w100><label>code</label><input ng-model=mySchemaForm.code></md-input-container></div><div flex><md-input-container class=w100><label>Color</label><input ng-model=mySchemaForm.color></md-input-container></div><div flex><md-input-container class=w100><label>Icon</label><input ng-model=mySchemaForm.icon></md-input-container></div></section><section layout=row ng-if=!loading><div flex><md-input-container class=w100><label>Group</label><input ng-model=mySchemaForm.group></md-input-container></div><div flex><md-input-container class=w100><label>Order</label><input ng-model=mySchemaForm.order type=number min=0 step=1></md-input-container></div><div flex><md-input-container class=w100><label>Category</label><md-select ng-model=mySchemaForm.category.id><md-option ng-repeat=\"item in categoriesList track by $id(item.id)\" ng-value=item.id>{{item.name}}</md-option></md-select></md-input-container></div></section><section layout=row ng-if=!loading><div flex><md-switch ng-model=mySchemaForm.setIssuesAsRead aria-label=setIssuesAsRead>Set Issues As Read: {{ mySchemaForm.setIssuesAsRead }}</md-switch></div></section><section layout=row ng-if=!loading><div flex><md-switch ng-model=mySchemaForm.lockByUser.active aria-label=lockByUser ng-change=\"mySchemaForm.lockByUser.hoursToBlock = 0\">Lock by user: {{ mySchemaForm.lockByUser.active }}</md-switch></div><div flex><md-input-container class=w100><label>Hours to block</label><input ng-model=mySchemaForm.lockByUser.hoursToBlock ng-disabled=!mySchemaForm.lockByUser.active type=number min=0 step=1></md-input-container></div></section><br><md-divider></md-divider><br><!-- visual--><section layout=row ng-if=!loading><md-tabs md-selected=0 md-dynamic-height md-border-bottom style=\"width: 100%\"><!--! status--><md-tab label=status><md-content class=md-padding><article flex><label>Status</label><status-grid data=mySchemaForm.status></status-grid></article></md-content></md-tab><!--! classifications--><md-tab label=classifications><md-content style=\"min-height: 120px\" class=md-padding><article flex><label>Classifications</label><classifications-grid data=mySchemaForm.classifications></classifications-grid></article></md-content></md-tab><!--! criticalities--><md-tab label=criticalities><md-content style=\"min-height: 120px\" class=md-padding><article flex><label>Criticalities</label><criticalities-grid data=mySchemaForm.criticalities></criticalities-grid></article></md-content></md-tab></md-tabs></section><br><md-divider></md-divider><br><!-- headSchema--><!-- bodySchemas--><!-- evidenceSchemas--><section layout=row ng-if=!loading><div flex><section layout=column><div flex><label>Headschema</label><div ng-if=mySchemaForm.headSchema class=w100><p>{{mySchemaForm.headSchema.id}} &nbsp;<b>{{mySchemaForm.headSchema.name}}</b><md-button ng-click=\"removeSchema(\'headSchema\', 0)\" class=md-icon-button><md-icon>delete</md-icon></md-button></p></div></div><div flex><md-button ng-click=\"showDialogSelecteSchema($event, \'headSchema\')\" class=md-icon-button><md-icon>add</md-icon></md-button></div></section></div><div flex><section layout=column><div flex><label>Bodyschemas</label><div ng-repeat=\"item in mySchemaForm.bodySchemas\" multiple class=w100><p>{{item.id}} &nbsp;<b>{{item.name}}</b><md-button ng-click=\"removeSchema(\'bodySchemas\', $index)\" class=md-icon-button><md-icon>delete</md-icon></md-button></p></div></div><div flex><md-button ng-click=\"showDialogSelecteSchema($event, \'bodySchemas\')\" class=md-icon-button><md-icon>add</md-icon></md-button></div></section></div><div flex><section layout=column><div flex><label>Evidenceschemas</label><div ng-repeat=\"item in mySchemaForm.evidenceSchemas\" multiple class=w100><p>{{item.id}} &nbsp;<b>{{item.name}}</b><md-button ng-click=\"removeSchema(\'evidenceSchemas\', $index)\" class=md-icon-button><md-icon>delete</md-icon></md-button></p></div></div><div flex><md-button ng-click=\"showDialogSelecteSchema($event, \'evidenceSchemas\')\" class=md-icon-button><md-icon>add</md-icon></md-button></div></section></div></section><br><md-divider></md-divider><br><!-- sla--><section layout=column><div flex><label>SLA</label></div><section flex layout=row layout-aling=\"center center\" ng-if=!loading><div flex><md-checkbox ng-model=mySchemaForm.sla.active aria-label=SLA_active>Active &nbsp;<strong>{{ mySchemaForm.sla.active }}</strong></md-checkbox><md-checkbox ng-model=mySchemaForm.sla.businessDays aria-label=sla_businessDays>Apply Business Days &nbsp;<strong>{{mySchemaForm.sla.businessDays}}</strong></md-checkbox></div><div flex><md-input-container class=w100><label>Days to Solve issues</label><input ng-model=mySchemaForm.sla.daysToSolve></md-input-container></div><div flex><md-input-container class=w100><label>Action</label><input ng-model=mySchemaForm.sla.action></md-input-container></div><div flex><md-input-container class=w100><label>Days to Notify</label><input ng-model=mySchemaForm.sla.daysToNotify></md-input-container></div><div flex><md-input-container class=w100><label>Retry Notification in Days</label><input ng-model=mySchemaForm.sla.daysForRetryNotification></md-input-container></div></section></section></md-tab></md-tabs></md-content></md-dialog-content><md-dialog-actions><md-button md-colors=green ng-click=cancel($event)>{{ translation.cancel_button }}</md-button><md-button md-colors=green ng-click=save() ng-show=validatePermission()>{{ translation.save_button }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/configuration/dialog/schema-format/schema-format.html","<md-dialog aria-label=\"{{ actionText }}\" style=\"width: 80vw\"><md-toolbar><div class=md-toolbar-tools><h2>{{ actionText }}</h2><span flex></span><md-button ng-click=cancel($event) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column layout-padding><md-content><md-tabs md-selected=0 md-dynamic-height md-border-bottom style=\"width: 100%\"><md-tab label=JSON ng-click=convert(&quot;json&quot;)><md-progress-linear ng-if=loading></md-progress-linear><md-content style=\"min-height: 450px\" ng-if=!loading class=md-padding><div name=category style=\"height: 580px\" ng-model=mySchemaJson ui-ace=\"{ useWrapMode : false, showGutter: true, theme:&quot;twilight&quot;, mode: &quot;json&quot; ,onLoad : editorLoaded }\"></div></md-content></md-tab><md-tab label=FORM ng-click=convert(&quot;form&quot;)><br><section layout=row><div flex=60><md-input-container class=w100><label>name</label><input ng-model=mySchemaForm.name></md-input-container></div><div flex><md-button ng-click=addSet()><md-icon md-font-set=material-icons md-menu-align-target class=md-raised>add</md-icon>Add set</md-button></div></section><br><section layout=row ng-repeat=\"set in mySchemaForm.body track by $index\"><div flex><md-input-container class=w100><label>type</label><md-select ng-model=set.type><md-option value=string>String</md-option><md-option value=numeric>numeric</md-option></md-select></md-input-container></div><div flex><md-input-container class=w100><label>macht condition</label><md-select ng-model=set.key><md-option value=\"==\">igual a</md-option><md-option value=\"&lt;=\" ng-show=\"set.type == &quot;numeric&quot;\">menor igual a</md-option><md-option value=&lt; ng-show=\"set.type == &quot;numeric&quot;\">menor a</md-option><md-option value=\"&gt;=\" ng-show=\"set.type == &quot;numeric&quot;\">mayor igual a</md-option><md-option value=&gt; ng-show=\"set.type == &quot;numeric&quot;\">mayor que</md-option><md-option value=\"!=\" ng-show=\"set.type == &quot;numeric&quot;\">no igual a</md-option></md-select></md-input-container></div><div flex><md-input-container class=w100><label>macht value</label><input ng-model=set.value type=\"{{ set.type == &quot;string&quot; ? &quot;text&quot; : &quot;number&quot; }}\"></md-input-container></div><div flex><md-input-container class=w100><label>icon</label><input ng-model=set.icon></md-input-container></div><div flex><md-input-container class=w100><label>color</label><input ng-model=set.color></md-input-container></div><div flex><md-input-container class=w100><label>format</label><md-select ng-model=set.format><md-option value=normal-text>normal-text</md-option><md-option value=italic-text>italic-text</md-option><md-option value=bold-text>bold-text</md-option></md-select></md-input-container></div><div flex><div ng-class=\"set.icon+&quot; &quot;+set.color+&quot; &quot;+set.format\">Sample 123</div></div><div flex=none><md-button ng-click=removeSet($index) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target>delete</md-icon></md-button></div></section></md-tab></md-tabs></md-content></md-dialog-content><md-dialog-actions><md-button md-colors=green ng-click=cancel($event)>{{ translation.cancel_button }}</md-button><md-button md-colors=green ng-click=save() ng-show=validatePermission()>{{ translation.save_button }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/dashboard/components/actions-menu/actions-menu.html","<div style=\"display: flex; flex-direction: row; flex-wrap: wrap; justify-content: flex-end\"><md-button ng-click=\"ctrl.linkIssuesFn({ &quot;ev&quot;: $event, &quot;issuesToLink&quot;: ctrl.selectedRows })\" ng-if=\"ctrl.selectedRows.length &gt;= 1\" aria-label=\"Vinculate button\" class=\"md-icon-button grey-text grey lighten-5\"><div class=\"fa fa-link\"></div><md-tooltip>{{ translation.vinculate }} - {{ ctrl.selectedRows.length }} records</md-tooltip></md-button><md-button ng-click=ctrl.assignResponsible($event) ng-if=\"ctrl.selectedRows.length &gt;= 1\" aria-label=\"Assign responsible button\" class=\"md-icon-button grey-text grey lighten-5\"><div class=\"fa fa-user-circle-o\"></div><md-tooltip>{{ translation.assign }} {{ translation.responsible }} - {{ ctrl.selectedRows.length }} records</md-tooltip></md-button><md-button ng-click=ctrl.assignClasification($event) ng-if=\"ctrl.selectedRows.length &gt;= 1\" aria-label=\"Assign classification button\" class=\"md-icon-button grey-text grey lighten-5\"><div class=\"fa fa-tag\"></div><md-tooltip>{{ translation.assign }} {{ translation.classification }} - {{ ctrl.selectedRows.length }} records</md-tooltip></md-button><md-button ng-click=ctrl.assignStatus($event) ng-if=\"ctrl.selectedRows.length &gt;= 1\" aria-label=\"Assign status button\" class=\"md-icon-button grey-text grey lighten-5\"><div class=\"fa fa-edit\"></div><md-tooltip>{{ translation.assign }} {{ translation.status }} - {{ ctrl.selectedRows.length }} records</md-tooltip></md-button><md-menu ng-if=\"ctrl.selectedRows.length &gt;= 1\"><md-button aria-label=\"mark as seen menu\" ng-click=$mdMenu.open($event) class=\"md-icon-button grey-text grey lighten-5\"><div class=\"fa fa-eye\"></div><md-tooltip>{{ translation.mark_seen }}/{{ translation.mark_unseen }} {{ ctrl.selectedRows.length }} records</md-tooltip></md-button><md-menu-content><md-menu-item><md-button ng-click=ctrl.markIssuesAsUnseen() aria-label=\"Mark as unseen button\"><div class=\"fa fa-eye-slash\"></div>{{ translation.mark_unseen }} - {{ ctrl.selectedRows.length }} records</md-button></md-menu-item><md-menu-item ng-if=ctrl.canMarkAsSeen><md-button ng-click=ctrl.markIssuesAsSeen() aria-label=\"Mark as seen button\"><div class=\"fa fa-eye\"></div>{{ translation.mark_seen }} - {{ ctrl.selectedRows.length }} records</md-button></md-menu-item></md-menu-content></md-menu><md-menu><md-button aria-label=\"menu to show viewed/unviewed/all issues\" ng-click=$mdMenu.open($event) class=m0><div ng-class=\"{ \'text-second-color\' : ctrl.issueListFilters.viewed != null }\" class=\"fa fa-filter\"></div>{{ ctrl.viewedMode() }}</md-button><md-menu-content><md-menu-item><md-button ng-click=\"ctrl.showIssues(\'viewed\')\" ng-class=\"{ \'main-color white-text\' : ctrl.issueListFilters.viewed === true }\" aria-label=\"show viewed issues button\">{{ translation.show_viewed_issues }}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.showIssues(\'unviewed\')\" ng-class=\"{ \'main-color white-text\' : ctrl.issueListFilters.viewed === false }\" aria-label=\"show unviewed issues button\">{{ translation.show_unviewed_issues }}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.showIssues(\'all\')\" ng-class=\"{ \'main-color white-text\' : ctrl.issueListFilters.viewed === null }\" aria-label=\"show all issues button\">{{ translation.show_all_issues }}</md-button></md-menu-item></md-menu-content></md-menu><md-button ng-click=ctrl.createCustomView($event) aria-label=\"Create custom view button\" ng-if=ctrl.issueListFilters.predicates.length class=\"md-icon-button grey-text grey lighten-5\"><div class=\"fa fa-bookmark\"></div><md-tooltip>{{ translation.create }} {{ translation.custom_views | lowercase }}</md-tooltip></md-button><md-button is-super-user ng-click=ctrl.markAsArchived($event) ng-if=\"ctrl.selectedRows.length &gt;= 1\" aria-label=\"Mark as archived button\" class=\"md-icon-button red-text grey lighten-5\"><div class=\"fa fa-list\"></div><md-tooltip>{{ ctrl.issueListFilters.archived ? translation.mark_as_unarchived : translation.mark_as_archived }} - {{ ctrl.selectedRows.length }} records</md-tooltip></md-button><md-button is-super-user ng-click=ctrl.toggleShowArchived() aria-label=\"Toggle show archived issues button\" ng-class=\"{ \'red-text\': ctrl.issueListFilters.archived }\" class=\"md-icon-button grey lighten-5\"><div ng-class=\"ctrl.issueListFilters.archived ? \'fa-folder-open\' : \'fa-folder\' \" class=fa></div><md-tooltip>{{ ctrl.issueListFilters.archived ? translation.hide_archived_issues : translation.show_archived_issues }}</md-tooltip></md-button><md-button ng-click=ctrl.exportIssuesFn($event) aria-label=\"Manage columns button\" class=\"md-icon-button grey-text grey lighten-5\"><div class=\"fa fa-files-o\"></div><md-tooltip>{{ translation.export }} Issues (.csv .xlsx)</md-tooltip></md-button><md-button ng-click=ctrl.manageColumns($event) aria-label=\"Manage columns button\" class=\"md-icon-button grey-text grey lighten-5\"><div class=\"fa fa-columns\"></div><md-tooltip>{{ translation.columns }}</md-tooltip></md-button><div><auto-refresh-menu on-tick=ctrl.reloadIssuesFn()></auto-refresh-menu></div></div>");
$templateCache.put("app/dashboard/components/counter-box/counter-box.html","<article style=\"height: 100%\" ng-class=\"{ \'lighten-3\': ctrl.totalCounterValues &lt; 1 &amp;&amp; ctrl.totalClasifications &lt; 1 }\" class=\"grey lighten-4\"><md-toolbar style=\"min-height: 40px; height: 40px\" ng-class=\"{ \'lighten-3\': ctrl.totalCounterValues &lt; 1 &amp;&amp; ctrl.totalClasifications &lt; 1 }\" class=\"grey lighten-4\"><div class=md-toolbar-tools><h2 flex md-truncate class=text-main-color><cep-icon icon=\"{{ ctrl.icon }}\" color=\"{{ ctrl.totalCounterValues &lt; 1 &amp;&amp; ctrl.totalClasifications &lt; 1 ? \'grey\' : ctrl.color }}\"></cep-icon><strong ng-style=\"{ \'color\': ctrl.totalCounterValues &lt; 1 &amp;&amp; ctrl.totalClasifications &lt; 1 ? \'grey\': \'inherit\' }\">{{ ctrl.title }}</strong></h2><span flex=10><md-button ng-click=\"ctrl.viewAction({tab: ctrl.tab, icon: ctrl.icon, color: ctrl.color, issueId: ctrl.issueId, filters: false, predicates: []})\" class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\" class=text-main-color>open_in_new</md-icon><md-tooltip>Open Issue</md-tooltip></md-button></span></div></md-toolbar><md-divider></md-divider><div ng-if=\"ctrl.counterValues.length &gt; 0\"><div style=\"font-size: 14px; height: 30px\" class=md-toolbar-tools><h2 flex md-truncate class=ceptinel-text><strong>{{ ctrl.titleStatus }}</strong></h2></div><div class=list><div flex layout=row style=\"padding: 6px 16px\" ng-repeat=\"status in ctrl.counterValues\" ng-click=\"ctrl.viewAction({tab: ctrl.tab, icon: ctrl.icon, color: ctrl.color, issueId: ctrl.issueId, filters: false, predicates: [{&quot;label&quot;: &quot;Status&quot;, &quot;fieldName&quot;: &quot;issue_status_id&quot;, &quot;operation&quot;: &quot;IN&quot;, &quot;values&quot;: [status.id],&quot;value&quot;: null, &quot;valuesLabels&quot;: [status.name] }] })\" class=list-item><div flex=10 class=text-center><cep-icon icon=\"{{ status.icon }}\" color=\"{{ status.color }}\"></cep-icon></div><div flex>{{ status.name | capitalize }}</div><div flex=15><div class=\"text-center cep-badge\">{{ status.count | number }}</div></div></div></div><div flex layout=row style=\"padding: 6px 16px\" ng-class=\"{ \'grey lighten-3\': ctrl.totalCounterValues &lt; 1 }\" class=\"grey lighten-5\"><div flex></div><div flex=15><div style=\"font-weight: 600\" class=text-center>{{ ctrl.totalCounterValues | number }}</div></div></div></div><div ng-if=\"ctrl.counterValues.length == 0\"><div flex layout=row style=\"padding: 6px 16px\"><div flex><div class=\"fa fa-exclamation-triangle\"></div><span>No registered states</span></div></div></div><md-divider></md-divider><div ng-if=\"ctrl.clasifications.length &gt; 0\"><div style=\"font-size: 14px; height: 30px\" class=md-toolbar-tools><h2 flex md-truncate class=ceptinel-text><strong>{{ ctrl.titleClasifications }}</strong></h2></div><div class=list><div flex layout=row style=\"padding: 6px 16px\" ng-repeat=\"classification in ctrl.clasifications | orderBy:weight\" ng-click=\"ctrl.viewAction({tab: ctrl.tab,icon: ctrl.icon,color: ctrl.color,issueId: ctrl.issueId,filters: false, predicates: [{&quot;label&quot;: &quot;classification&quot;, &quot;fieldName&quot;: &quot;issue_classification_id&quot;, &quot;operation&quot;: &quot;IN&quot;, &quot;values&quot;: [classification.id],&quot;value&quot;: null, &quot;valuesLabels&quot;: [classification.name] }] })\" class=list-item><div flex>{{ classification.name | capitalize }}</div><div flex=15><div class=\"text-center cep-badge\">{{ classification.count | number }}</div></div></div></div><div flex layout=row style=\"padding: 6px 16px\" ng-class=\"{ \'grey lighten-3\': ctrl.totalClasifications &lt; 1 }\" class=\"grey lighten-5\"><div flex></div><div flex=15><div style=\"font-weight: 600\" class=text-center>{{ ctrl.totalClasifications | number }}</div></div></div></div><div ng-if=\"ctrl.clasifications.length == 0\"><div flex layout=row style=\"padding: 6px 16px\"><div flex><div class=\"fa fa-exclamation-triangle\"></div><span>No classifications registered</span></div></div></div></article>");
$templateCache.put("app/dashboard/components/evidence-creation-dialog/evidence-creation-dialog.html","<md-dialog aria-label=\"Evidence creation dialog\"><form><md-toolbar class=main-color><div class=md-toolbar-tools><h2>Add evidence</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-width: 600px; max-width: 800px; max-height: 810px; padding: 5px\"><issue-dynamic-schema schema=ctrl.evidenceSchema schema-data=ctrl.evidenceData></issue-dynamic-schema></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button ng-click=ctrl.cancel() class=md-raised>Cancel</md-button><md-button ng-click=ctrl.save() class=md-raised>Add</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/dashboard/components/inbox-box/inbox-box.html","<md-card ng-cloak class=cep-dashboard-box><div style=\"padding: 5px; font-weight: 600\" class=\"grey lighten-4\"><cep-icon icon=cep-inbox></cep-icon>Inbox</div><md-divider></md-divider><div ui-sortable=sortableOptionsList data-sort=group class=inbox-issues-types><div ng-repeat=\"(group, issues) in ctrl.issueGroups\" data-group=\"{{ group }}\" class=\"issues-types-groups item-sortable\"><div ng-if=\"group != \'UN_GROUPED\'\" style=\"border-left: solid #5a2c7e 2px\"><div class=issue-type-group-title><strong>{{ group }}</strong><div style=\"font-size: 11px; padding: 2px; cursor: pointer\" ng-click=ctrl.toogleGroup(issues)><i ng-if=!issues.show aria-hidden=true class=\"fa fa-chevron-down\"></i><i ng-if=issues.show aria-hidden=true class=\"fa fa-chevron-up\"></i></div></div><div ui-sortable=sortableOptionsList data-sort=issues ng-model=issues.items ng-show=issues.show class=issues-types><div ng-repeat=\"issue in issues.items\" data-issue-type=\"{{ issue.id }}\" ng-click=\"ctrl.viewAction({tab: issue.name, icon: issue.icon, color: issue.color, issueId: issue.id})\" class=\"issue-type-group-issues item-sortable\"><div class=text-center><cep-icon icon=\"{{ issue.icon }}\" color=\"{{ issue.color }}\"></cep-icon></div><div class=issue-type-name>{{ issue.name }}</div><div><div class=\"text-center cep-badge\">{{ ctrl.counterValues[issue.name].count }}</div></div></div></div><div class=issue-type-group-footer><small>No leidos:<span class=cep-badge>{{ issues.counter }}</span></small></div></div><div ng-if=\"group == \'UN_GROUPED\'\"><div style=\"margin-top: 0.5rem\" ng-repeat=\"issue in issues.items | orderBy: \'order\'\" data-issue-type=\"{{ issue.id }}\" ng-click=\"ctrl.viewAction({tab: issue.name, icon: issue.icon, color: issue.color, issueId: issue.id})\" class=issue-type-group-issues><div class=text-center><cep-icon icon=\"{{ issue.icon }}\" color=\"{{ issue.color }}\"></cep-icon></div><div class=issue-type-name>{{ issue.name }}</div><div><div class=\"text-center cep-badge\">{{ ctrl.counterValues[issue.name].count }}</div></div></div></div></div></div></md-card>");
$templateCache.put("app/dashboard/components/issue-columns-dialog/issue-columns-dialog.html","<md-dialog aria-label=\"Issues assignment dialog\"><form><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ ctrl.translation.manageTableColumns }}</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-width: 600px; max-width: 800px; max-height: 810px; padding: 5px; overflow-x: hidden\"><md-input-container class=w100><label>{{ ctrl.translation.SelectASetting }}</label><md-select ng-model=ctrl.selectedDef placeholder=\"Select a setting\" style=\"width: 100%\" ng-change=ctrl.selectedDefChange()><md-option ng-repeat=\"def in ctrl.columnsDefinitions track by $index\" ng-value=def>{{ def }}</md-option></md-select></md-input-container><md-divider></md-divider><div class=relative><searcher value=ctrl.searchText placeholder=\"{{ translation.find }}\" class=\"isSticky inTop\"></searcher></div><md-progress-linear ng-if=ctrl.loading md-mode=indeterminate class=\"md-accent md-hue-2\"></md-progress-linear><column-folder ng-repeat=\"folder in ctrl.folders track by $index\" folder=folder ng-init=\"folderIndex = $index\"></column-folder></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-select ng-model=ctrl.toGroup placeholder=group ng-if=ctrl.isSuperUser><md-option ng-repeat=\"group in ctrl.groupsList\" ng-value=group.id>{{ group.name }}</md-option></md-select><md-button has-permission=issues:update ng-click=ctrl.save(true) ng-if=ctrl.isSuperUser ng-disabled=\"ctrl.toGroup === null\" style=\"margin-left: 10px\" class=\"md-raised green white-text\">{{ ctrl.translation.AssingToGroup }}</md-button><md-divider style=\"margin: 0 auto\"></md-divider><md-button has-permission=issues:update ng-click=ctrl.save(false) class=\"md-raised green white-text\">{{ ctrl.translation.AssingToMe }}</md-button><md-button ng-click=ctrl.cancel() class=md-raised>{{ ctrl.translation.exit }}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/dashboard/components/issue-comments/issue-comments.html","<div layout=column><div class=\"cep-rounded-border md-whiteframe-2dp w100 relative\"><section id=comments ng-if=\"ctrl.comments.length == 0\"><br><div style=\"padding: 5vh\" class=text-center><md-icon md-font-set=material-icons md-menu-align-target>info</md-icon><h4>There are no comments</h4></div></section><div layout=row layout-align=\"end center\" ng-if=\"ctrl.comments.length &gt; 0\"><div><md-button ng-click=ctrl.toogleSort() class=md-secondary><md-icon md-font-set=material-icons>{{ ctrl.sort == \'asc\' ? \'arrow_upward\' : \'arrow_downward\' }}</md-icon>{{ ctrl.sort == \'asc\' ? ctrl.translation.sortAsc : ctrl.translation.sortDesc }}</md-button></div></div><section id=issues-comments layout=row ng-if=\"ctrl.comments.length &gt; 0\"><md-list flex class=p0><md-list-item ng-repeat=\"comment in ctrl.comments\" class=p0><article layout=row layout-padding=\"\" class=w100><div flex=100><article layout=row style=\"margin-bottom: 10px\" class=w100><div flex=60><letter-avatar data=\"{{ comment.author.name }}\" color=comment.author.color></letter-avatar><b style=\"text-decoration: underline\" class=m0>{{ comment.author.name }} {{ comment.author.lastName }}</b></div><div flex=40 class=text-right><p class=m0><b>{{ comment.moment }} {{ comment.edited }} - &nbsp;</b><b ng-class=\"{ \'purple\' : comment.isPrivate, \'amber black-text\' : !comment.isPrivate }\" class=badge>{{ comment.isPrivate ? \"Private\" : \"Public\" }}</b></p></div></article><div style=\"text-align: justify; word-break: break-word\" ng-bind-html=comment.commentHtml class=commentHtml></div></div></article><md-divider></md-divider></md-list-item></md-list></section><md-divider></md-divider><section id=compose ng-show=\"ctrl.isLocked == false\" ng-if=ctrl.issueUuid><div class=w100><textarea id=commnet-input ui-tinymce=tinymceOptions ng-model=ctrl.comment.message class=w100></textarea></div><section layout=row layout-align=\"end end\"><div flex=50 style=\"display: flex; flex-direction: row; align-content: flex-start; justify-content: flex-end; align-items: center; gap: 10px\"><md-select ng-model=ctrl.comment.isPrivate><md-option ng-value=true>Private</md-option><md-option ng-value=false>Public</md-option></md-select><md-button ng-click=ctrl.createComment() ng-disabled=\"loading || ctrl.isLocked || !ctrl.comment.message || ctrl.comment.message.length == 0 \" class=\"md-raised md-primary\">{{ ctrl.translation.send }}&nbsp;<md-icon md-font-set=material-icons class=\"md-icon-button md-secondary md-hue-3\">send</md-icon></md-button></div></section></section></div></div>");
$templateCache.put("app/dashboard/components/issue-custom-view-dialog/issue-custom-view-dialog.html","<md-dialog aria-label=\"Issues custom view dialog\"><form><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ ctrl.translation.create }} {{ ctrl.translation.custom_view | lowercase }}</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-width: 600px; max-width: 800px; max-height: 810px; padding: 5px\"><div><md-input-container style=\"padding-bottom: 0; margin-bottom: 0\" class=w100><label>{{ ctrl.translation.name }}</label><input type=text ng-model=ctrl.customView.name autocomplete=off placeholder=\"\" style=\"padding: 5px\" class=cep-rounded-border></md-input-container><md-input-container style=\"padding-bottom: 0; margin-bottom: 0\" class=w100><label>{{ ctrl.translation.description }}</label><input type=text ng-model=ctrl.customView.description autocomplete=off placeholder=\"\" style=\"padding: 5px\" class=cep-rounded-border></md-input-container></div><md-divider></md-divider><md-list><md-list-item ng-repeat=\"item in ctrl.issueFilters.predicates\" ng-click=null class=md-1-line><md-list-item-text><div class=\"fa fa-filter\"></div><span>&nbsp; {{ item.label }} >> {{ item.operation }} >> {{ item.valuesLabels ? item.valuesLabels : item.value }}</span></md-list-item-text></md-list-item></md-list></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button ng-click=ctrl.cancel() class=md-raised>{{ ctrl.translation.cancel }}</md-button><md-button ng-click=ctrl.save() class=\"md-raised green white-text\">{{ ctrl.translation.create }}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/dashboard/components/issue-dynamic-schema/issue-dynamic-schema.html","<section layout=row layout-wrap ng-if=ctrl.showTitle ng-cloak><div flex=grow><b>{{ ctrl.schemaTitle }}</b><hr style=\"margin: 0 0 18px 0\"></div></section><fieldset layout=row layout-wrap layout-padding ng-cloak style=\"border: 1px solid #bbbbbb; padding: 1.5rem; margin: 0.5rem 0; border-radius: 0.8rem\" ng-repeat=\"(key, group) in ctrl.schemaGrouped\" ng-disabled=\"ctrl.isLocked || field.readonly\"><legend flex-=100 style=\"all: revert\">{{ key == \"undefined\" ? \"\" : key }}</legend><div ng-repeat=\"field in group\" ng-switch=field.type flex=\"{{ field.format != \'textarea\' ? ctrl.grid : \'100\' || ctrl.grid }}\"><md-input-container ng-switch-when=string|autoincrement ng-switch-when-separator=| class=md-block><label>{{ field.displayName || field.key | capitalize }} - {{ field.type }}<md-tooltip md-direction=top>{{ field.displayName || field.key | capitalize }} - {{ field.type }}</md-tooltip></label><input ng-if=\"field.format != \'textarea\'\" type=text placeholder=\"\" ng-model=\"ctrl.schemaData[ctrl.getFieldName(field.pk, field.key)]\" ng-readonly=\"field.type == \'autoincrement\' || field.readonly\" style=\"padding: 0 10px\" autocomplete=off ng-disabled=\"ctrl.isLocked || field.readonly\" class=\"cep-rounded-border cep-input-bg\"><textarea ng-if=\"field.format == \'textarea\'\" type=text placeholder=\"\" ng-model=\"ctrl.schemaData[ctrl.getFieldName(field.pk, field.key)]\" ng-readonly=\"field.type == \'autoincrement\' || field.readonly\" style=\"padding: 0 10px\" autocomplete=off rows=2 ng-disabled=\"ctrl.isLocked || field.readonly\" class=\"cep-rounded-border cep-input-bg\"></textarea></md-input-container><md-input-container ng-switch-when=integer|double|long ng-switch-when-separator=| class=md-block><label>{{ field.displayName || field.key | capitalize }} - {{ field.type }}<md-tooltip md-direction=top>{{ field.displayName || field.key | capitalize }} - {{ field.type }}</md-tooltip></label><input type=text placeholder=\"\" ng-model=\"ctrl.schemaData[ctrl.getFieldName(field.pk, field.key)]\" ng-readonly=\"field.type == \'autoincrement\' || field.readonly\" style=\"padding: 0 10px\" autocomplete=off cep-number-mask numeric-type=field.type ng-disabled=\"ctrl.isLocked || field.readonly\" class=\"cep-rounded-border cep-input-bg\"></md-input-container><issue-sequential-selector ng-switch-when=sequential model=\"ctrl.schemaData[ctrl.getFieldName(field.pk, field.key)]\" field=field key=key disabled></issue-sequential-selector><issue-reference-selector ng-switch-when=reference model=\"ctrl.schemaData[ctrl.getFieldName(field.pk, field.key)]\" on-reference-selected=ctrl.onReferenceSelected({reference}) field=field key=key disabled></issue-reference-selector><md-input-container ng-switch-when=date ng-class=\"{ \'read-only\': field.readonly }\" class=md-block><label>{{ field.displayName || key | capitalize }} - {{ field.type }}<md-tooltip md-direction=top>{{ field.displayName || key | capitalize }} - {{ field.type }}</md-tooltip></label><input mdc-datetime-picker type=text date=true time=false minutes=false seconds=false short-time=false show-todays-date=false click-outside-to-close=true placeholder=date auto-ok=true minute-steps=1 format=DD/MM/YYYY ng-model=\"ctrl.schemaData[ctrl.getFieldName(field.pk, field.key, field.type)]\" edit-input=true show-icon=true ng-model-options=\"{ timezone: \'utc\' }\" style=\"padding: 0 10px\" ng-disabled=\"ctrl.isLocked || field.readonly\" disabled class=md-input></md-input-container><md-input-container ng-switch-when=time ng-class=\"{ \'read-only\': field.readonly }\" class=md-block><label>{{ field.displayName || key | capitalize }} - {{ field.type }}<md-tooltip md-direction=top>{{ field.displayName || key | capitalize }} - {{ field.type }}</md-tooltip></label><input mdc-datetime-picker type=text date=false seconds=true short-time=false show-todays-date=false click-outside-to-close=true placeholder=Time auto-ok=true minute-steps=1 format=HH:mm:ss ng-model=\"ctrl.schemaData[ctrl.getFieldName(field.pk, field.key, field.type)]\" edit-input=\"{{ field.readonly }}\" show-icon=\"{{ field.readonly }}\" ng-model-options=\"{ timezone: \'utc\' }\" style=\"padding: 0 10px\" ng-disabled=\"ctrl.isLocked || field.readonly\" class=md-input></md-input-container><div layout=row class=w100><md-input-container ng-switch-when=timestamp flex ng-class=\"{ \'read-only\': field.readonly }\" class=md-block><label>{{ field.displayName || key | capitalize }} - {{ field.type }}<md-tooltip md-direction=top>{{ field.displayName || key | capitalize }} - {{ field.type }}</md-tooltip></label><input type=datetime-local placeholder=\"\" ng-model=\"ctrl.schemaData[ctrl.getFieldName(field.pk, field.key, field.type)]\" style=\"padding: 0 10px\" ng-disabled=\"ctrl.isLocked || field.readonly\" class=\"cep-rounded-border cep-input-bg\"></md-input-container></div><md-input-container ng-switch-when=boolean layout=row style=\"position: relative; top: -24px\" ng-class=\"{ \'read-only\': field.readonly }\" class=md-block><label style=\"font-size: 0.8em; color: #5a2c7e\">{{ field.displayName || key | capitalize }} - {{ field.type }}<md-tooltip md-direction=top>{{ field.displayName || key | capitalize }} - {{ field.type }}</md-tooltip></label><md-switch ng-model=\"ctrl.schemaData[ctrl.getFieldName(field.pk, field.key)]\" aria-label=\"{{ key }}\" style=\"position: relative; top: 5px\" ng-disabled=\"ctrl.isLocked || field.readonly\">{{ ctrl.schemaData[ctrl.getFieldName(field.pk, field.key)] ? \"true\" : \"false\" }}</md-switch></md-input-container><md-input-container ng-switch-when=url class=md-block><label>{{ field.displayName || field.key | capitalize }} - {{ field.type }}<md-tooltip md-direction=top>{{ field.displayName || field.key | capitalize }} - {{ field.type }}</md-tooltip></label><input type=url placeholder=URL ng-model=\"ctrl.schemaData[ctrl.getFieldName(field.pk, field.key)]\" style=\"padding: 0 10px\" autocomplete=off pattern=https://.* ng-disabled=\"ctrl.isLocked || field.readonly\" class=\"cep-rounded-border cep-input-bg\"><md-button aria-label=urllink class=icon-button><a href=\"{{ ctrl.schemaData[ctrl.getFieldName(field.pk, field.key)] }}\" target=_blank rel=\"noopener noreferrer\"><md-icon>near_me</md-icon></a></md-button></md-input-container><md-input-container ng-switch-default class=md-block><input aria-label=\"Unhandled value field\" placeholder=\"Unhandled type: {{ field.type }}\" style=\"padding: 0 10px\" readonly></md-input-container></div><div flex=100 ng-repeat=\"field in group\" ng-if=\"field.format == \'Complex\'\" ng-switch=field.type><issue-complex-field ng-switch-when=complex model=\"ctrl.schemaData[ctrl.getFieldName(field.pk, field.key)]\" field=field key=key disabled></issue-complex-field></div></fieldset>");
$templateCache.put("app/dashboard/components/issue-evidences/issue-evidence-table.html","<md-progress-linear md-mode=indeterminate ng-if=ctrl.loading></md-progress-linear><hot-table hot-id=evidence-{{ctrl.config.name}} settings=ctrl.settings datarows=ctrl.config.gridOptions.data columns=ctrl.tableColumns class=w100></hot-table><div layout=row layout-aling=\"end end\"><div flex=20><md-button ng-click=ctrl.export() class=\"md-raised green white-text\">export .csv<md-icon md-font-set=material-icons md-menu-align-target class=white-text>cloud_download</md-icon></md-button></div><div flex=\"\"><pagination pagination=ctrl.pagination on-click=ctrl.$onInit></pagination></div></div>");
$templateCache.put("app/dashboard/components/issue-evidences/issue-evidences.html","<div ng-cloak><div ng-if=ctrl.loading><p>Loading evidences</p><md-progress-linear md-mode=indeterminate></md-progress-linear></div><md-menu><md-button ng-click=$mdMenu.open($event) aria-label=\"Evidence type selector\" class=\"pull-right md-raised md-accent md-hue-2 white-text\">Add evidence<md-icon md-font-set=material-icons style=\"position: relative; top: 3px\" class=white-text>keyboard_arrow_down</md-icon></md-button><md-menu-content class=md-dense><md-menu-item ng-repeat=\"item in ctrl.issueType.evidenceSchemas\"><md-button ng-click=ctrl.createEvidence(item) ng-disabled=ctrl.isLocked>{{ item.id }} - {{ item.display ? item.display : item.name }}</md-button></md-menu-item></md-menu-content></md-menu><md-tabs md-selected=ctrl.tab md-border-bottom md-dynamic-height ng-if=!ctrl.loading><md-tab ng-repeat=\"evidenceType in ctrl.issueEvidenceTypes track by $index\" md-tab-class=tab-full-width><md-tab-label><cep-icon icon=cep-user></cep-icon>({{ evidenceType.totalRecords }}) - {{ evidenceType.display ? evidenceType.display : evidenceType.name }}</md-tab-label></md-tab></md-tabs><div ng-if=!ctrl.loading><div ng-repeat=\"evidenceType in ctrl.issueEvidenceTypes track by $index\" ng-if=\"ctrl.tab === $index\"><issue-evidence-table ng-if=!ctrl.loading issue-uuid=ctrl.issueUuid evidence-type-id=evidenceType.id name=evidenceType.name config=evidenceType on-remove-row=ctrl.reload()></issue-evidence-table></div></div></div>");
$templateCache.put("app/dashboard/components/issue-files/issue-files.html","<div layout=row layout-align=\"start start\"><section id=drop-area-wrapper drop-zone nv-file-drop uploader=ctrl.uploader layout=row layout-wrap style=\"position: relative; min-height: 62vh\" class=w100><issue-file-box flex=25 ng-repeat=\"file in ctrl.issueFiles\" data=file issue-uuid=ctrl.issueUuid on-delete=ctrl.onDeleteFile(fileId)></issue-file-box><div flex=100 ng-if=\"ctrl.issueFiles.length == 0\" class=text-center><h2 class=\"grey-text text-lighten-1\"><md-icon md-font-set=material-icons class=\"grey-text text-lighten-1\">cloud_upload</md-icon></h2><h2 class=\"grey-text text-lighten-1\"><strong>{{ ctrl.translation.dropFilesHere }}</strong></h2><h3 class=\"grey-text text-lighten-1\"><strong>{{ ctrl.uploader.queue.length }}</strong>&nbsp; {{ ctrl.translation.filesOnQueue }}</h3></div></section><section id=file-upload flex=30 layout=column><md-card><md-card-content><h4>Archivos en cola</h4><section layout=row layout-wrap=\"\"><div flex=100><md-list><md-list-item ng-repeat=\"item in ctrl.uploader.queue\" md-truncate=\"\" class=p0><p><md-icon md-font-set=material-icons md-menu-align-target>file_copy</md-icon><span ng-bind=item.file.name></span><a ng-click=item.upload() title=\"Subir archivo {{item.file.name}}\"><i class=icon-file_upload></i></a></p></md-list-item></md-list></div><div flex=100 ng-show=ctrl.uploader.isUploading><md-progress-linear md-mode=determinate value=\"{{ ctrl.uploader.progress }}\"></md-progress-linear></div><div flex=60><md-button type=button ng-click=ctrl.uploader.uploadAll() ng-disabled=!ctrl.uploader.getNotUploadedItems().length aria-label=\"Upload button\" class=\"md-raised md-primary\"><span>{{ ctrl.translation.load_all }}&nbsp;</span><md-icon md-font-set=material-icons md-menu-align-target>done</md-icon></md-button></div><div flex=20><md-button type=button ng-click=ctrl.uploader.cancelAll() ng-disabled=!ctrl.uploader.isUploading aria-label=\"Cancel upload button\" class=\"md-icon-button md-warn\"><md-icon md-font-set=material-icons md-menu-align-target>close</md-icon><md-tooltip md-direction=bottom>{{ ctrl.translation.cancel_all }}</md-tooltip></md-button></div><div flex=20><md-button type=button ng-click=ctrl.uploader.clearQueue() ng-disabled=!ctrl.uploader.queue.length aria-label=\"Clear queue button\" class=\"md-icon-button md-warn\"><md-icon md-font-set=material-icons md-menu-align-target>delete</md-icon><md-tooltip md-direction=bottom>{{ ctrl.translation.clean_queue }}</md-tooltip></md-button></div></section><div class=\"box-upload w100\"><input id=file type=file name=file nv-file-select uploader=ctrl.uploader input-file multiple ng-disabled=ctrl.isLocked><md-button style=\"background-color: #49a847\" aria-label=\"Select file to upload button\" onclick=document.getElementById(&quot;file&quot;).click() ng-disabled=ctrl.isLocked class=w100><md-icon md-font-set=material-icons>cloud_upload</md-icon><md-tooltip md-direction=bottom>{{ ctrl.translation.load_file }}</md-tooltip></md-button></div></md-card-content></md-card></section></div>");
$templateCache.put("app/dashboard/components/issue-guests/issue-guests.html","<div layout=column><div layout=row layout-align=\"start start\"><md-chips ng-model=ctrl.selectedUsers md-autocomplete-snap md-require-match=true input-aria-label=\"Users to invite\"><md-autocomplete md-selected-item=ctrl.selectedItem md-no-cache md-search-text=ctrl.searchText md-items=\"item in ctrl.autocompleteValuesGetter(ctrl.searchText)\" md-item-text=item.fullName input-aria-describedby=autocompleteTitle placeholder=\"Search for uses to invite\" md-min-length=0><span md-highlight-text=ctrl.searchText>{{ item.fullName }}</span></md-autocomplete><md-chip-template><span>{{ $chip.fullName }}</span></md-chip-template></md-chips><md-button ng-disabled=\"(ctrl.notify &amp;&amp; !ctrl.note) || ctrl.selectedUsers.length === 0 || $rootScope.loading || ctrl.isLocked\" ng-click=ctrl.inviteUsersToIssue() md-no-ink aria-label=\"Invite users to issue button\" class=\"md-raised md-primary\">Invite</md-button><md-checkbox ng-model=ctrl.notifyInvitation aria-label=\"Notify invitation selector\" ng-disabled=ctrl.isLocked>Notify invitation</md-checkbox></div><md-divider></md-divider><div ng-if=ctrl.notifyInvitation><md-input-container class=\"w100 no-padding-no-margin\"><label>Invitation note</label><textarea ng-model=ctrl.invitationNote rows=3></textarea></md-input-container></div><md-divider ng-if=ctrl.notifyInvitation></md-divider><div><md-list><md-list-item ng-repeat=\"user in ctrl.issueGuests\" ng-click=null><div layout=column style=\"padding-left: 10px\" class=md-list-item-text><p style=\"line-height: 15px\"><span>{{ user.fullName }}</span><br><span>@{{ user.username }}</span></p></div><md-button aria-label=Delete ng-disabled=\"ctrl.tab.caso.state == \'cerrado\'\" ng-click=ctrl.removeIssueGuest(user.userId) class=\"md-secondary md-icon-button\"><md-icon clas=md-icon-button>delete</md-icon></md-button><md-divider></md-divider></md-list-item></md-list></div></div>");
$templateCache.put("app/dashboard/components/issue-related-content-dialog/issue-related-content-dialog.html","<md-dialog id=issues-related-content aria-label=\"Issues related content dialog\" style=\"min-width: 50vw; min-height: 50vh\" class=control-dialog><form><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ ctrl.translation.related_content }}</h2><span flex></span><md-button ng-if=ctrl.parentIssueUuid has-permission=issues:report ng-disabled=loading ng-click=ctrl.linkIssuesToParent(ctrl.selectedIssues) aria-label=\"Link selected issues button\" style=\"text-transform: none !important\" class=\"md-raised white-text blue\">{{ ctrl.translation.link_selected_on_parent }}</md-button><md-button has-permission=issues:report ng-disabled=loading ng-click=ctrl.linkIssuesInNewIssue(ctrl.selectedIssues) aria-label=\"Link selected issues button\" style=\"text-transform: none !important\" class=\"md-raised white-text blue\">{{ ctrl.translation.link_selected_on_new_issue }}</md-button><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-width: 600px; max-height: 810px; padding: 5px\"><md-card ng-repeat=\"content in ctrl.relatedContent\"><div layout=row><div style=\"padding: 10px; font-weight: 600\">{{ content.schema.description || content.schema.name }}</div><div flex></div><md-button ng-click=\"content.show = !content.show\" class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">keyboard_arrow_down</md-icon></md-button></div><div layout=column ng-if=content.show><related-issues-list reference=content set-selected-issues-fn=\"ctrl.setSelectedIssuesFromChilds({ referenceUuid, selectedIssues })\"></related-issues-list></div></md-card></md-dialog-content></form></md-dialog>");
$templateCache.put("app/dashboard/components/issue-sidenav/issue-sidenav.html","<div layout=column layout-margin ng-if=ctrl.loading><div flex><skeleton-loader></skeleton-loader></div><div flex><skeleton-loader></skeleton-loader></div><div flex><skeleton-loader></skeleton-loader></div><div flex><skeleton-loader></skeleton-loader></div><div flex><skeleton-loader></skeleton-loader></div></div><form layout=column ng-if=!ctrl.loading><md-toolbar class=sticky-top><div ng-class=\"{ &quot;main-color&quot;: ctrl.issueIsLocked==false , &quot;red&quot;: ctrl.issueIsLocked==true }\" class=md-toolbar-tools><h2 flex=\"\" md-truncate=\"\">{{ ctrl.issue.correlative }}</h2><md-button aria-label=close ng-click=ctrl.onClickClose() class=md-icon-button><md-icon>close</md-icon></md-button></div></md-toolbar><md-content class=layout-margin><div layout=column><h5>{{ ctrl.translation.source }}: &nbsp;<br><b>{{ ctrl.issue.source }}</b></h5><h5>{{ ctrl.translation.date }}: &nbsp;<br><b>{{ ctrl.issue.createdAtLocal | date: \"dd/MM/yy hh:mm a\" }}</b></h5><h5>{{ ctrl.translation.resolutionDate }}: &nbsp;<br><b>{{ ctrl.issue.resolutionDate | date: \"dd/MM/yy hh:mm a\" }}</b></h5><risk-level criticalities=ctrl.types.criticalities level=ctrl.issue.criticality.id is-locked=\"ctrl.issueIsLocked || ctrl.issueTypePermission\"></risk-level></div><div flex=100><div ng-if=ctrl.issue.uuid class=\"w100 vertical-tab\"><h5 class=m0>{{ ctrl.translation.selected_schema }}</h5><h4></h4><b>{{ ctrl.issue.bodySchema.display || ctrl.issue.bodySchema.name }}</b></div><h3><b>Header</b></h3><issue-dynamic-schema schema=ctrl.issue.headSchema schema-data=ctrl.issue.head show-title=false grid=100 is-locked=\"ctrl.issueIsLocked || ctrl.issueTypePermission\"></issue-dynamic-schema><h3><b>Body</b></h3><issue-dynamic-schema schema=ctrl.issue.bodySchema schema-data=ctrl.issue.body show-title=true grid=100 is-locked=\"ctrl.issueIsLocked || ctrl.issueTypePermission\"></issue-dynamic-schema></div><div flex=100><md-input-container class=w100><label>{{ ctrl.translation.assigned }}</label><md-select ng-model=ctrl.issue.assigned.userId placeholder=\"\" required aria-label=\"Assigned user selector\" ng-disabled=\"ctrl.issueIsLocked || ctrl.issueTypePermission\"><md-option ng-value=item.userId ng-repeat=\"item in ctrl.users\"><letter-avatar data=\"{{ item.fullName }}\" color=item.color></letter-avatar>{{ item.fullName }}</md-option></md-select></md-input-container><md-input-container class=w100><label>{{ ctrl.translation.classification }}</label><md-select ng-model=ctrl.issue.classification.id placeholder=\"\" required aria-label=\"Classification selector\" ng-disabled=\"ctrl.issueIsLocked || ctrl.issueTypePermission\"><md-option ng-value=item.id ng-repeat=\"item in ctrl.types.classifications\">{{ item.name }}</md-option></md-select></md-input-container><md-input-container style=\"margin-bottom: 0px\" class=w100><label>{{ ctrl.translation.description }}</label><textarea type=text ng-model=ctrl.issue.description ng-change=\"ctrl.isChanged = true\" rows=1 required ng-disabled=\"ctrl.issueIsLocked || ctrl.issueTypePermission\"></textarea></md-input-container><md-input-container class=w100><label>{{ ctrl.translation.status }}</label><md-select ng-model=ctrl.issue.status.id aria-label=\"Status selector\" ng-disabled=\"ctrl.issueIsLocked || ctrl.issueTypePermission\"><md-option ng-value=item.id ng-repeat=\"item in ctrl.types.status\">{{ item.name }}</md-option></md-select></md-input-container></div></md-content><md-toolbar style=\"position: sticky; bottom: 0\" class=\"grey lighten-4\"><div style=\"justify-content: end\" class=md-toolbar-tools><md-button ng-click=ctrl.saveIssue() has-permission=issues-type#{{ctrl.issueType}}:update ng-disabled=\"ctrl.loading || ctrl.issueIsLocked || ctrl.issueTypePermission\" aria-label=\"Save issue button\" class=\"md-raised white-text green\">{{ ctrl.translation.save }}</md-button></div></md-toolbar></form>");
$templateCache.put("app/dashboard/components/issues-assignment-dialog/issues-assignment-dialog.html","<md-dialog aria-label=\"Issues assignment dialog\"><form><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ctrl.assignationTitle | capitalize}}</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-width: 600px; max-width: 800px; max-height: 810px; padding: 5px\"><div><md-input-container ng-if=\"ctrl.assignationType == &quot;responsible&quot;\" class=\"no-padding-no-margin w100\"><label>New responsible</label><md-select ng-model=ctrl.selectedUser placeholder=\"Select a responsible\" aria-label=\"Responsible selector\" required><md-option ng-repeat=\"user in ctrl.users\" ng-value=user.username>{{ user.fullName }}</md-option></md-select></md-input-container><md-input-container ng-if=\"ctrl.assignationType == &quot;classification&quot;\" class=\"no-padding-no-margin w100\"><label>New classification</label><md-select ng-model=ctrl.selectedClassification placeholder=\"Select a classification\" aria-label=\"classification selector\" required><md-option ng-repeat=\"classification in ctrl.classifications\" ng-value=classification.id>{{ classification.name }}</md-option></md-select></md-input-container><md-input-container ng-if=\"ctrl.assignationType == &quot;status&quot;\" class=\"no-padding-no-margin w100\"><label>New status</label><md-select ng-model=ctrl.selectedStatus placeholder=\"Select a status\" aria-label=\"status selector\" required><md-option ng-repeat=\"status in ctrl.status\" ng-value=status.id>{{ status.name }}</md-option></md-select></md-input-container><md-input-container class=\"no-padding-no-margin w100\"><label>Change Reason</label><input type=text ng-model=ctrl.changeReason autocomplete=off required></md-input-container></div><table class=\"table w100\"><thead><tr><th>classification</th><th>date</th><th>assigned</th><th>criticality</th><th>status</th></tr></thead><tbody><tr ng-repeat=\"issue in ctrl.selectedIssues\"><td>{{ issue.classification.name }}</td><td>{{ issue.createdAt | date }}</td><td>{{ issue.assigned.fullName }}</td><td>{{ issue.criticality.name }}</td><td>{{ issue.status.name }}</td></tr></tbody></table></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button ng-click=ctrl.cancel() class=md-raised>Cancel</md-button><md-button ng-click=ctrl.save($event) class=\"md-raised green white-text\">Assign</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/dashboard/components/issues-detail-dialog/issues-detail-dialog.html","<md-dialog id=issues-detail-dialog aria-label=\"Issues detail dialog\" style=\"width: 90%; min-height: unset; max-height: unset\" class=control-dialog><md-toolbar><div ng-class=\"{ \'main-color\': ctrl.issueIsLocked==false , \'red\': ctrl.issueIsLocked==true }\" class=md-toolbar-tools><span flex=60><span><cep-icon icon=\"{{ ctrl.currentCategory.icon }}\" color=white></cep-icon>{{ ctrl.currentCategory.name }}</span><md-menu md-position-mode=\"target-right bottom\" md-offset=\"0 2\" ng-style=\"{ \'pointer-events\': (ctrl.isUpdate) ? \'none\' : \'initial\' }\"><md-button style=\"min-width: 100px; padding: 0\" ng-click=$mdMenu.open($event) aria-label=\"issue type selector\" class=\"md-raised white-text ceptinel lighten-1\"><div layout=row layout-align=\"space-between stretch\"><span flex=noshrink style=\"padding: 0 1rem 0 0.5rem\" class=\"ceptinel lighten-1\"><cep-icon icon=\"{{ ctrl.currentIssueType.icon }}\" color=white style=\"top: 3px; position: relative\"></cep-icon>{{ ctrl.currentIssueType.name }}</span><span class=\"ceptinel darken-1\"><md-icon md-font-set=material-icons style=\"top: 3px\" class=white-text>keyboard_arrow_down</md-icon></span></div><md-tooltip>Click to change issue type</md-tooltip></md-button><md-menu-content class=md-dense><md-menu-item ng-repeat=\"item in ctrl.issueTypes\"><md-button ng-click=ctrl.changeIssueType(item.id)><cep-icon icon=\"{{ item.icon }}\" color=\"{{ item.color }}\"></cep-icon>{{ item.name }}</md-button></md-menu-item></md-menu-content></md-menu><span>{{ ctrl.isUpdate ? ctrl.issue.classification.name : \"Create \" }}</span></span><div flex=40 class=\"text-right flex-buttons\"><md-button ng-if=\"ctrl.validatePermission([\'issues:create\', \'issues:update\'])\" ng-click=ctrl.saveIssue() ng-disabled=\"loading || ctrl.issueIsLocked ? true : !ctrl.hasPermissionIssueType\" aria-label=\"Save issue button\" has-permission=issues-type#{{ctrl.currentIssueType.id}}:update class=\"md-raised white-text green\">{{ ctrl.translation.save }}</md-button><md-button has-permission=issues:report ng-disabled=\"loading || !ctrl.issueReport\" ng-click=ctrl.report($event) aria-label=\"Issue repport button\" class=\"md-raised white-text blue\">{{ ctrl.translation.report }}</md-button><md-button ng-click=ctrl.cancel() ng-disabled=$root.loading class=\"md-raised white-text red\">{{ ctrl.translation.cancel }}</md-button><md-button ng-click=ctrl.cancel() ng-disabled=$root.loading class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></div></md-toolbar><md-dialog-content class=relative><div ng-if=ctrl.issueIsLocked class=locked-message>{{ ctrl.translation.locked_message }}</div><md-tabs md-border-bottom class=issues-tabs><md-tab><md-tab-label><cep-icon icon=cep-inform></cep-icon>General</md-tab-label><md-tab-body><form id=issuesDetailDialog layout=row layout-margin novalidate autocomplete=off class=relative><div flex=80><md-sidenav md-component-id=\"issues-sidenav-{{ dialogId }}\" class=md-sidenav-left><md-toolbar class=sticky-top><div class=md-toolbar-tools><h2 flex=\"\" md-truncate=\"\">&nbsp; Schemas Selector</h2><md-button aria-label=\"Close nav\" ng-click=ctrl.toggleSideNav() class=md-icon-button><md-icon md-font-set=material-icons>close</md-icon></md-button></div></md-toolbar><md-content class=md-padding><div style=\"display: grid; grid-template-columns: repeat(auto-fit, minmax(80px, 1fr)); grid-gap: 1rem\" class=\"w100 vertical-tab\"><md-button ng-repeat=\"item in ctrl.currentIssueType.bodySchemas\" ng-click=ctrl.setBodySchema(item) ng-disabled=ctrl.isUpdate ng-class=\"{ \'tab-selected\' :ctrl.issue.bodySchema.id == item.id }\" class=\"icon-box w100 is-tab\"><md-tooltip>{{ item.description || item.name }}</md-tooltip><cep-icon icon=\"{{ item.icon }}\" scale=1></cep-icon><div md-truncate>{{ item.description || item.name }}</div></md-button></div></md-content></md-sidenav><div layout=row><div flex=noshrink><div class=\"w100 vertical-tab\"><md-button ng-click=ctrl.toggleSideNav() style=\"min-width: 100px; padding: 0\" aria-label=\"schema selector\" ng-disabled=ctrl.issue.uuid class=\"md-raised white\"><div layout=row layout-align=\"space-between stretch\"><span class=\"grey lighten-4\"><md-icon md-font-set=material-icons>keyboard_arrow_right</md-icon></span><span flex=noshrink style=\"padding: 0 1rem 0 0.5rem\" class=white><cep-icon icon=\"{{ ctrl.issue.bodySchema.icon }}\" scale=1></cep-icon><span md-truncate>{{ ctrl.issue.bodySchema.description || ctrl.issue.bodySchema.name }}</span></span></div><md-tooltip>{{ ctrl.issue.bodySchema.display || ctrl.issue.bodySchema.name }}</md-tooltip></md-button></div></div><div flex=noshrink style=\"font-size: 1.5rem\"><md-input-container style=\"margin-bottom: 0px\" class=w100><label>{{ ctrl.translation.description }}</label><textarea type=text ng-model=ctrl.issue.description ng-change=\"ctrl.isChanged = true\" rows=1 required ng-disabled=\"ctrl.issueIsLocked == true ? true : !ctrl.hasPermissionIssueType\"></textarea></md-input-container></div></div><h3><b>{{ ctrl.issue.headSchema.display || \"Header\" }}</b></h3><issue-dynamic-schema schema=ctrl.issue.headSchema schema-data=ctrl.issue.head show-title=false is-locked=\"ctrl.issueIsLocked == true ? true : !ctrl.hasPermissionIssueType\"></issue-dynamic-schema><h3><b>{{ ctrl.issue.bodySchema.display || \"Body\" }}</b></h3><issue-dynamic-schema schema=ctrl.issue.bodySchema schema-data=ctrl.issue.body show-title=true is-locked=\"ctrl.issueIsLocked == true ? true : !ctrl.hasPermissionIssueType\"></issue-dynamic-schema><md-divider></md-divider><section layout=row layout-align=\"center start\" ng-cloak class=w100><div layout=row style=\"padding: 5px\" flex=20 class=\"cep-hover cep-border\"><div flex=20 class=text-center><cep-icon icon=cep-clip></cep-icon></div><div flex=auto>{{ ctrl.translation.evidences }}</div><div flex=20><div class=\"text-center cep-badge\">{{ ctrl.counters.evidences }}</div></div></div><div layout=row style=\"padding: 5px\" flex=20 class=\"cep-hover cep-border\"><div flex=20 class=text-center><cep-icon icon=cep-link></cep-icon></div><div flex=auto>{{ ctrl.translation.links }}</div><div flex=20><div class=\"text-center cep-badge\">{{ ctrl.counters.links }}</div></div></div><div layout=row style=\"padding: 5px\" flex=20 class=\"cep-hover cep-border\"><div flex=20 class=text-center><cep-icon icon=cep-case></cep-icon></div><div flex=auto>{{ ctrl.translation.files }}</div><div flex=20><div class=\"text-center cep-badge\">{{ ctrl.counters.files }}</div></div></div><div layout=row style=\"padding: 5px\" flex=20 class=\"cep-hover cep-border\"><div flex=20 class=text-center><cep-icon icon=cep-sent></cep-icon></div><div flex=auto>{{ ctrl.translation.comments }}</div><div flex=20><div class=\"text-center cep-badge\">{{ ctrl.counters.comments }}</div></div></div></section></div><div flex=20 ng-cloak><div layout=column><h6 style=\"margin: 2px 0\">{{ ctrl.translation.correlative }}: &nbsp;<b>{{ ctrl.issue.correlative }}</b></h6><h6 style=\"margin: 2px 0\">{{ ctrl.translation.source }}: &nbsp;<b>{{ ctrl.issue.source }}</b></h6><h6 style=\"margin: 2px 0\">{{ ctrl.translation.date }}: &nbsp;<b>{{ ctrl.issue.createdAtLocal | date: \"dd/MM/yy hh:mm a\" }}</b></h6><h6 style=\"margin: 2px 0\">{{ ctrl.translation.resolutionDate }}: &nbsp;<b>{{ ctrl.issue.resolutionDate | date: \"dd/MM/yy hh:mm a\" }}</b></h6></div><risk-level criticalities=ctrl.criticalities level=ctrl.issue.criticality.id is-locked=\"ctrl.issueIsLocked == true ? true : !ctrl.hasPermissionIssueType\"></risk-level><md-input-container class=w100><label>{{ ctrl.translation.assigned }}</label><md-select ng-if=ctrl.hasPermissionReadUser ng-model=ctrl.issue.assigned.userId placeholder=\"\" required aria-label=\"Assigned user selector\" ng-disabled=\"ctrl.issueIsLocked ? true : !ctrl.hasPermissionIssueType\"><md-option ng-value=item.userId ng-repeat=\"item in ctrl.users\"><letter-avatar data=\"{{ item.fullName }}\" color=item.color></letter-avatar>{{ item.fullName }}</md-option></md-select><h4 ng-if=!ctrl.hasPermissionReadUser style=\"margin: 2rem 0 0 0\">{{ ctrl.issue.assigned.name }} {{ ctrl.issue.assigned.lastName }}</h4></md-input-container><md-input-container class=w100><label>{{ ctrl.translation.classification }}</label><md-select ng-model=ctrl.issue.classification.id placeholder=\"\" required aria-label=\"Classification selector\" ng-disabled=\"ctrl.issueIsLocked ? true : !ctrl.hasPermissionIssueType\"><md-option ng-value=item.id ng-repeat=\"item in ctrl.classifications\">{{ item.name }}</md-option></md-select></md-input-container><md-input-container class=w100><label>{{ ctrl.translation.status }}</label><md-select ng-model=ctrl.issue.status.id ng-show=ctrl.isUpdate aria-label=\"Status selector\" ng-disabled=\"ctrl.issueIsLocked ? true : !ctrl.hasPermissionIssueType\"><md-option ng-value=item.id ng-repeat=\"item in ctrl.status\">{{ item.name }}</md-option></md-select></md-input-container><md-input-container class=w100><label>{{ ctrl.translation.group }}</label><md-select ng-model=ctrl.issue.group.id aria-label=\"group selector\" ng-disabled=\"ctrl.issueIsLocked ? true : !ctrl.hasPermissionIssueType\"><md-option ng-value=item.id ng-repeat=\"item in ctrl.groups\">{{ item.name }}</md-option></md-select></md-input-container><div id=related-content><div class=md-title>{{ ctrl.translation.related_content }}</div><md-divider></md-divider><div ng-show=\"ctrl.isUpdate &amp;&amp; ctrl.issueReferences.loading\" class=w100>{{ ctrl.translation.looking_for }} {{ ctrl.translation.related_content | lowercase }}...</div><div ng-show=\"!ctrl.issueReferences.loading &amp;&amp; !ctrl.issueReferences.data.length\" class=w100>{{ ctrl.translation.there_is_no }} {{ ctrl.translation.related_content | lowercase }}</div><div layout=row layout-wrap layout-align=\"start stretch\" class=w100><div style=\"width: 80px; text-align: center\" ng-repeat=\"item in ctrl.issueReferences.data\" ng-click=ctrl.showRelatedContent($event) class=icon-box><div style=\"float: right; position: relative; top: 20px; background-color: rgb(255, 64, 129); font-weight: 600; color: white\" class=cep-badge>{{ item.count }}</div><md-tooltip>{{ item.schema.display || item.schema.name }}</md-tooltip><cep-icon icon=\"{{ item.schema.icon ? item.schema.icon : \'cep-clip\' }}\" scale=2></cep-icon><br><div style=\"font-size: 0.85em; padding: 2px\" class=md-truncate>{{ item.schema.display || item.schema.name }}</div></div></div></div></div><div ng-show=ctrl.issueIsLocked class=locked-overlay></div></form></md-tab-body></md-tab><md-tab><md-tab-label><cep-icon icon=cep-clip></cep-icon><span>{{ ctrl.translation.evidences }}</span><span ng-if=ctrl.counters.evidences>&nbsp;({{ ctrl.counters.evidences }})</span></md-tab-label><md-tab-body><issue-evidences issue-uuid=ctrl.issue.uuid issue-type=ctrl.currentIssueType linked-issue-types=ctrl.issue.linkedIssueType api=ctrl.evidencesApi evidences-count=ctrl.counters.evidences is-locked=\"ctrl.issueIsLocked == true ? true : !ctrl.hasPermissionIssueType\" class=w100></issue-evidences></md-tab-body></md-tab><md-tab label=Links md-active=ctrl.issuesToLink.length><md-tab-label><cep-icon icon=cep-link></cep-icon><span>{{ ctrl.translation.links }}</span><span ng-if=ctrl.counters.links>&nbsp;({{ ctrl.counters.links }})</span></md-tab-label><md-tab-body><vinculated-issues issue-uuid=ctrl.issue.uuid issues-to-link=ctrl.issuesToLink links-count=ctrl.counters.links issue-type=ctrl.currentIssueType linked-issue-types=ctrl.issue.linkedIssueType is-locked=\"ctrl.issueIsLocked == true ? true : !ctrl.hasPermissionIssueType\"></vinculated-issues></md-tab-body></md-tab><md-tab><md-tab-label><cep-icon icon=cep-case></cep-icon><spam>{{ ctrl.translation.files }}</spam><span ng-if=ctrl.counters.files>&nbsp;({{ ctrl.counters.files }})</span></md-tab-label><md-tab-body><issue-files issue-uuid=ctrl.issue.uuid files-count=ctrl.counters.files is-locked=\"ctrl.issueIsLocked == true ? true : !ctrl.hasPermissionIssueType\"></issue-files></md-tab-body></md-tab><md-tab><md-tab-label><cep-icon icon=cep-sent></cep-icon><span>{{ ctrl.translation.comments }}</span><span ng-if=ctrl.counters.comments>&nbsp;({{ ctrl.counters.comments }})</span></md-tab-label><md-tab-body><issue-comments issue-uuid=ctrl.issue.uuid comments-count=ctrl.counters.comments is-locked=\"ctrl.issueIsLocked == true ? true : !ctrl.hasPermissionIssueType\"></issue-comments></md-tab-body></md-tab><md-tab><md-tab-label><cep-icon icon=cep-users></cep-icon><span>{{ ctrl.translation.guests }}</span><span ng-if=ctrl.counters.guests>&nbsp;({{ ctrl.counters.guests }})</span></md-tab-label><md-tab-body><issue-guests issue=ctrl.issue guests-count=ctrl.counters.guests is-locked=\"ctrl.issueIsLocked == true ? true : !ctrl.hasPermissionIssueType\"></issue-guests></md-tab-body></md-tab><md-tab><md-tab-label><cep-icon icon=cep-review></cep-icon>{{ ctrl.translation.activity }}</md-tab-label><md-tab-body><div style=\"height: 100%\" ui-grid-pagination ui-grid=ctrl.issueActivityLog.gridOptions is-locked=\"ctrl.issueIsLocked == true ? true : !ctrl.hasPermissionIssueType\" class=issueGrid></div></md-tab-body></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/dashboard/components/issues-filters-dialog/issues-filters-dialog.html","<md-dialog aria-label=\"Issues filters dialog\" style=\"overflow: unset\"><md-dialog-content style=\"min-width: 600px; max-width: 800px; max-height: 810px; padding: 5px; overflow: unset\"><b style=\"font-weight: 600\">Filter by: {{ ctrl.column.name }} - {{ ctrl.columnFilters.component }}</b><md-divider style=\"margin-bottom: 5px\"></md-divider><div layout=row layout-margin layout-aling=\"center center\"><div flex><md-input-container class=w100><label>{{ ctrl.translation.condition }}</label><md-select ng-model=ctrl.predicate.operation placeholder=\"\" aria-label=\"Filter operation selection\" required ng-change=ctrl.onchangeOperation()><md-option ng-repeat=\"operation in ctrl.columnFilters.operations\" ng-value=operation>{{ operation }}</md-option></md-select></md-input-container></div><div flex=60 ng-switch=ctrl.columnFilters.component><div ng-switch-when=TEXT|text|NUMBER|number|string ng-switch-when-separator=|><div ng-if=\"ctrl.predicate.operation == &quot;BETWEEN&quot;\"><md-input-container class=w100><label>{{ ctrl.translation.value }} from</label><input ng-model=ctrl.predicate.values[0] name=filterConditionValue0 autocomplete=off aria-label=\"Filter value field\"></md-input-container><md-input-container class=w100><label>{{ ctrl.translation.value }} to</label><input ng-model=ctrl.predicate.values[1] name=filterConditionValue1 autocomplete=off aria-label=\"Filter value field\"></md-input-container></div><div ng-if=\"ctrl.predicate.operation != &quot;BETWEEN&quot;\"><md-input-container class=w100><label>{{ ctrl.translation.value }}</label><input ng-model=ctrl.predicate.value name=filterConditionValue ng-required=$parent.valueRequired autocomplete=off aria-label=\"Filter value field\"></md-input-container></div></div><md-input-container ng-switch-when=SELECTION|selection ng-switch-when-separator=| class=w100><label>{{ ctrl.translation.value }}</label><md-select ng-model=ctrl.predicate.values ng-change=ctrl.onPredicateValuesChanges() multiple placeholder=\"\" aria-label=\"Filter value selector\" required><md-option ng-repeat=\"metadata in ctrl.columnFilters.metadata\" ng-value=metadata.key>{{ metadata.value }}</md-option></md-select></md-input-container><section ng-switch-when=calendar ng-switch-when-separator=|><div ng-if=\"ctrl.types[ctrl.column.type] == &quot;date&quot;\"><div ng-if=\"ctrl.predicate.operation != &quot;BETWEEN&quot;\"><md-input-container class=w100><label>{{ ctrl.translation.value }}</label><input mdc-datetime-picker type=text date=true time=false minutes=false seconds=false short-time=false show-todays-date=false click-outside-to-close=true placeholder=date auto-ok=true minute-steps=1 format=DD/MM/YYYY ng-model=ctrl.predicate.value edit-input=true show-icon=true ng-model-options=\"{ timezone: &quot;utc&quot; }\" class=md-input></md-input-container></div><div ng-if=\"ctrl.predicate.operation == &quot;BETWEEN&quot;\"><md-input-container class=w100><input mdc-datetime-picker type=text date=true time=false minutes=false seconds=false short-time=false show-todays-date=false click-outside-to-close=true placeholder=date auto-ok=true minute-steps=1 format=DD/MM/YYYY ng-model=ctrl.predicate.values[0] edit-input=true show-icon=true ng-model-options=\"{ timezone: &quot;utc&quot; }\" max-date=ctrl.predicate.values[1] class=md-input></md-input-container><md-input-container class=w100><label>{{ ctrl.translation.value }} to</label><input mdc-datetime-picker type=text date=true time=false minutes=false seconds=false short-time=false show-todays-date=false click-outside-to-close=true placeholder=date auto-ok=true minute-steps=1 format=DD/MM/YYYY ng-model=ctrl.predicate.values[1] edit-input=true show-icon=true ng-model-options=\"{ timezone: &quot;utc&quot; }\" min-date=ctrl.predicate.values[0] class=md-input></md-input-container></div></div><div ng-if=\"ctrl.types[ctrl.column.type] == &quot;time&quot;\"><md-input-container class=w100><label>{{ ctrl.translation.value }}</label><input mdc-datetime-picker type=text date=false seconds=true short-time=false show-todays-date=false click-outside-to-close=true placeholder=Time auto-ok=true minute-steps=1 format=HH:mm:ss ng-model=\"ctrl.schemaData[ctrl.getFieldName(field.pk, field.key, field.type)]\" edit-input=true show-icon=true ng-model-options=\"{ timezone: &quot;utc&quot; }\" class=md-input></md-input-container></div><div ng-if=\"ctrl.types[ctrl.column.type] == &quot;timestamp&quot;\"><div ng-if=\"ctrl.predicate.operation != &quot;BETWEEN&quot;\"><md-input-container class=w100><label>{{ ctrl.translation.value }}</label><input type=datetime-local ng-model=ctrl.predicate.value style=\"padding: 0 10px\" class=w100></md-input-container></div><div ng-if=\"ctrl.predicate.operation == &quot;BETWEEN&quot;\"><md-input-container class=w100><label>{{ ctrl.translation.value }} 1</label><input type=datetime-local ng-model=ctrl.predicate.values[0] style=\"padding: 0 10px\" class=w100></md-input-container><md-input-container class=w100><label>{{ ctrl.translation.value }} 2</label><input type=datetime-local ng-model=ctrl.predicate.values[1] style=\"padding: 0 10px\" class=w100></md-input-container></div></div></section><md-input-container ng-switch-when=boolean style=\"position: absolute; top: -10px\" class=w100><label style=\"font-size: 0.7em; color: #5a2c7e; margin-bottom: 16px\">{{ ctrl.translation.value }}</label><md-switch ng-model=ctrl.predicate.value value=true aria-label=\"Boolean filter selector\">{{ ctrl.predicate.value ? \'true\' : \'false\' }}</md-switch></md-input-container><md-input-container ng-switch-default class=w100><label>{{ ctrl.translation.value }}</label><input aria-label=\"Unhandled value field\" placeholder=\"Unhandled filter type: {{ ctrl.columnFilters.component }}\" readonly></md-input-container></div></div></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button ng-click=ctrl.cancel() aria-label=\"Cancel button\" class=md-raised>Cancel</md-button><md-button ng-click=ctrl.applyFilters() ng-disabled=ctrl.isDisabled aria-label=\"Apply filter button\" class=\"md-raised green white-text\">{{ ctrl.translation.filter }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/dashboard/components/issues-list/issues-list.html","<section><md-card><div layout=row class=w100><h2 flex style=\"margin-left: 10px\" class=md-title><cep-icon icon=\"{{ ctrl.issueType.icon }}\" color=\"{{ ctrl.issueType.color }}\" scale=1></cep-icon><span style=\"font-weight: 600; margin-left: 5px\">{{ ctrl.issueType.name | uppercase }}</span></h2><h2 flex class=md-title><dashboard-actions-menu title=\"{{ translation.actions }}\" current-view=ctrl.selectedTab selected-rows=ctrl.selectedRows current-issue=ctrl.issueType create-issue-fn=\"ctrl.manageIssueFn({ ev })\" link-issues-fn=\"ctrl.manageIssueFn({ ev, issuesToLink })\" export-issues-fn=ctrl.exportIssuesAsCsv() issue-list-filters=ctrl.filters reload-issues-fn=ctrl.reload()></dashboard-actions-menu></h2></div><section layout=row style=\"padding: 5px\" ng-if=\"ctrl.filters.predicates.length || ctrl.selectedRows.length&gt;0\" layout-align=\"start center\"><div ng-repeat=\"(key, predicate) in ctrl.filters.predicates\" style=\"margin-right: 5px\" class=\"text-center cep-badge\"><span ng-if=\"predicate.operation == &quot;BETWEEN&quot;\">{{ predicate.label }}: {{ predicate.values[0] }} - {{ predicate.values[1] }}<div style=\"margin-left: 5px\" ng-click=ctrl.removeFilter(key) class=\"fa fa-times\"></div></span><span ng-if=\"predicate.operation != &quot;BETWEEN&quot;\">{{ predicate.label }}: {{ predicate.value != null ? predicate.value : predicate.valuesLabels.join(\", \") }}<div style=\"margin-left: 5px\" ng-click=ctrl.removeFilter(key) class=\"fa fa-times\"></div></span></div><div ng-if=ctrl.filters.predicates.length style=\"margin-right: 5px\" ng-click=ctrl.removeFilter(&quot;ALL&quot;) class=\"text-center cep-badge\">Remove filters</div><div ng-if=ctrl.selectedRows.length&gt;0 class=\"text-center cep-badge\">{{ ctrl.selectedRows.length }} issues seleccionados<div style=\"margin-left: 5px\" ng-click=ctrl.clearSelected() class=\"fa fa-times\"></div></div></section><section style=\"padding: 5px\" ng-if=ctrl.filters.archived class=bg-danger><strong>{{ translation.showing_archived_issues }}</strong></section></md-card><md-card><div layout=row><div flex><div style=\"height: 560px\" ng-if=ctrl.gridOptions.columnDefs.length ui-grid-selection ui-grid-resize-columns ui-grid-auto-resize ui-grid-pagination ui-grid-move-columns ui-grid-save-state ui-grid=ctrl.gridOptions></div></div><div flex=25 ng-if=ctrl.ShowIssueCliked><issue-side-nav issue-data=ctrl.issueCliked issue-types=ctrl.issueTypes style=\"display: block; overflow: scroll; max-height: 560px\" on-close=\"ctrl.ShowIssueCliked = false\"></issue-side-nav></div></div></md-card></section>");
$templateCache.put("app/dashboard/components/issues-list-loader/issues-list-loader.html","<div style=\"width: 84%; height: calc(100vh - 350px); position: absolute; z-index: 999; background-color: rgba(255, 255, 255, 0.70)\" ng-if=ctrl.loading><div style=\"text-align:center; padding:25vh\"><div class=themeLogo></div><md-progress-linear md-mode=indeterminate ng-disabled=!ctrl.loading></md-progress-linear><div ng-if=ctrl.total><span style=\"font-size: 1.3em; font-weight: 700\">{{ ctrl.progress | number: 0 }}%</span><span>({{ ctrl.loaded }} / {{ ctrl.total }})</span></div><div ng-if=ctrl.msg>{{ ctrl.msg }}</div><div ng-if=ctrl.time>Aprox. {{ ctrl.time | number: 0 }}{{ ctrl.timeScale }} remaining</div></div></div>");
$templateCache.put("app/dashboard/components/issues-report-dialog/issues-report-dialog.html","<md-dialog aria-label=\"Issues report dialog\" style=\"max-height: 90%; height: 90vh\" flex><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ ctrl.translation.report }}</h2><span flex></span><md-button ng-click=ctrl.cancel() ng-disabled=$root.loading class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content flex style=\"min-width: 60vw\" layout-padding=10 class=relative><div id=printSectionId .report><section layout=row layout-aling=\"center center\"><div flex=30><img ng-if=!ctrl.reportLogo ng-src=/assets/theme_image/custom.png alt=logotipo class=w100><img ng-if=ctrl.reportLogo ng-src=\"{{ ctrl.reportLogo }}\" alt=logotipo style=\"height: 60px; object-fit: contain; object-position: left\" class=w100></div><div flex=70><h3 class=pull-right>{{ ctrl.issue.issueType.name }}</h3></div></section><section style=\"display: block; border-bottom: 1px dashed #eaeaea; padding: 10px; margin: 10px 0; page-break-after: always\"><h3 style=\"border-bottom: 1px solid grey\"><b>{{ ctrl.issue.description || ctrl.translation.description }}</b></h3><br><article style=\"display: grid; grid-template-columns: repeat(4, 1fr); grid-gap: 1rem\"><div><p class=m0>{{ ctrl.translation.category }}</p><b>{{ ctrl.issue.category.name }}</b></div><div><p class=m0>{{ ctrl.translation.issueType }}</p><b>{{ ctrl.issue.issueType.name }}</b></div><div><p class=m0>{{ ctrl.translation.classification }}</p><b>{{ ctrl.issue.classification.name }}</b></div><div><p class=m0>{{ ctrl.translation.criticality }}</p><b>{{ ctrl.issue.criticality.name }}</b></div><div><p class=m0>{{ ctrl.translation.assigned }}</p><b>{{ ctrl.issue.assigned.fullName }}</b></div><div><p class=m0>{{ ctrl.translation.createdBy }}</p><b>{{ ctrl.issue.createdBy.fullName }}</b></div><div><p class=m0>{{ ctrl.translation.supervisor }}</p><b>{{ ctrl.issue.supervisor.fullName }}</b></div><div><p class=m0>{{ ctrl.translation.source }}</p><b>{{ ctrl.issue.source }}</b></div></article><br><div style=\"border-bottom: 1px solid grey\"><h5><b>{{ ctrl.issue.headSchema.display || \"Header\" }}</b></h5><p>{{ ctrl.issue.headSchema.description }}</p></div><fieldset ng-repeat=\"(groupName, schemasProps) in ctrl.schemaHeader\" style=\"margin: 2rem 0\"><legend style=\"font-size: small; margin-bottom: 1rem\"><strong ng-if=groupName>{{ groupName }}:&#32;</strong></legend><article style=\"display: grid; grid-template-columns: repeat(4, 1fr); grid-gap: 1rem\"><div ng-repeat=\"props in schemasProps\" ng-if=props.visible><p class=m0>{{ props.displayName || props.key }}:&#32;</p><div ng-bind-html=\"ctrl.getFieldName(\'schemaDataHeader\', props)\"></div></div></article></fieldset><br><div style=\"border-bottom: 1px solid grey\"><h5><b>{{ ctrl.issue.bodySchema.display || \"Body\" }}</b></h5><p>{{ ctrl.issue.bodySchema.description }}</p></div><fieldset ng-repeat=\"(groupName, schemasProps) in ctrl.schemaBody\" style=\"margin: 2rem 0\"><legend style=\"font-size: small; margin-bottom: 1rem\"><strong ng-if=groupName>{{ groupName }}:&#32;</strong></legend><article style=\"display: grid; grid-template-columns: repeat(4, 1fr); grid-gap: 1rem\"><div ng-repeat=\"props in schemasProps\" ng-if=props.visible><p class=m0>{{ props.displayName || props.key }}:&#32;</p><div ng-bind-html=\"ctrl.getFieldName(\'schemaDataBody\', props)\"></div></div></article></fieldset></section><section ng-if=ctrl.checkbox.guest style=\"display: block; border-bottom: 1px dashed #eaeaea; padding: 10px; margin: 10px 0; page-break-after: always\" class=pagebreak><h3 style=\"border-bottom: 1px solid grey\"><b>{{ ctrl.translation.guests }}</b></h3><table style=\"word-wrap: break-word; table-layout: fixed\" class=\"table w100\"><thead><tr><th>Usuario</th><th>Nombre</th><th class=noprint>&#32;</th></tr></thead><tbody><tr ng-repeat=\"guest in ctrl.issueGuests\"><td>{{ guest.username }}</td><td>{{ guest.fullName }}</td><td class=\"noprint text-right\"><md-icon md-font-set=material-icons ng-click=\"ctrl.onDeleteRow(ctrl.issueGuests, $index)\">delete</md-icon></td></tr></tbody></table></section><section ng-if=ctrl.checkbox.evidence style=\"display: block; border-bottom: 1px dashed #eaeaea; padding: 10px; margin: 10px 0; page-break-after: always\" class=pagebreak><h4 style=\"border-bottom: 1px solid grey\"><b>{{ ctrl.translation.evidence }}</b></h4><div ng-repeat=\"schema in ctrl.issueEvidenceTypes\" ng-if=\"schema.gridOptions.data.length &gt; 0 &amp;&amp; schema.gridOptions.columnDefs.length &gt; 0\" class=w100><table style=\"word-wrap: break-word; table-layout: fixed\" class=\"table w100\"><thead><tr><th colspan=\"{{ schema.gridOptions.columnDefs.length + 1 }}\">{{ schema.name }}</th></tr><tr><th ng-repeat=\"label in schema.gridOptions.columnDefs\" style=\"width: 180px\">{{ label.displayName }}</th><th style=\"width: 1%\" class=noprint></th></tr></thead><tbody><tr ng-repeat=\"row in schema.gridOptions.data \"><td ng-repeat=\"label in schema.gridOptions.columnDefs\">{{ row[label.field] }}</td><td class=\"noprint text-right\"><md-icon md-font-set=material-icons ng-click=\"ctrl.onDeleteRow(schema.gridOptions.data, $index)\">delete</md-icon></td></tr></tbody><tbody ng-repeat=\"linkeds in ctrl.AllDataEvidences track by $index\"><tr ng-if=\"linkeds.ref == schema.name\" ng-init=\"indexEvidence = $index\"><td ng-repeat=\"cel in linkeds.data track by $index\">{{ cel }}</td><td class=\"noprint text-right\"><md-icon md-font-set=material-icons ng-click=\"ctrl.onDeleteRow(ctrl.AllDataEvidences, indexEvidence)\">delete</md-icon></td></tr></tbody></table><br></div></section><section ng-if=ctrl.checkbox.link style=\"display: block; border-bottom: 1px dashed #eaeaea; padding: 10px; margin: 10px 0\"><div ng-repeat=\"issue in ctrl.linkedIssues track by $index\" ng-init=\"linkedIndex = $index\" style=\"display: block; margin: 2rem 0; page-break-after: always\" class=pagebreak><fieldset style=\"all: revert; border: 1px solid #afacac\"><legend style=\"all: revert; top: -9px; position: relative\"><h3><b>{{ ctrl.translation.linked }} {{ linkedIndex + 1 }} : {{ issue.issueType.name }}</b></h3></legend><div><article style=\"display: grid; grid-template-columns: repeat(4, 1fr); grid-gap: 1rem\"><div><p class=m0>Tipo de Issue:&#32;</p><b>{{ issue.issueType.name }}</b></div><div><p class=m0>Descripción:&#32;</p><b>{{ issue.description }}</b></div><div><p class=m0>Categoria:&#32;</p><b>{{ issue.category.name }}</b></div><div><p class=m0>Clasificación:&#32;</p><b>{{ issue.classification.name }}</b></div><div><p class=m0>Criticidad:&#32;</p><b>{{ issue.criticality.name }}</b></div><div><p class=m0>Asignado:&#32;</p><b>{{ issue.assigned.fullName }}</b></div><div><p class=m0>Creado por:&#32;</p><b>{{ issue.createdBy.fullName }}</b></div><div><p class=m0>Supervisor:&#32;</p><b>{{ issue.supervisor.fullName }}</b></div><div><p class=m0>Origin:&#32;</p><b>{{ issue.source }} ////</b></div></article><br><article style=\"display: grid; grid-template-columns: repeat(4, 1fr); grid-gap: 1rem\"><div ng-repeat=\"(key, field) in issue.schemaHeader\"><p class=m0>{{ field.displayName || key | capitalize }} :&#32;</p><div ng-bind-html=\"ctrl.getFieldName(\'schemaDataHeader\', field)]\"></div></div></article><br><article style=\"display: grid; grid-template-columns: repeat(4, 1fr); grid-gap: 1rem\"><div ng-repeat=\"(key, field) in issue.schemaBody\"><p class=m0>{{ field.displayName || key | capitalize }} :&#32;</p><div ng-bind-html=\"ctrl.getFieldName(\'schemaDataBody\', field)]\"></div></div></article><br><article ng-repeat=\"table in issue.TableEvidences track by $index\" ng-init=\"tableIndex = $index\" class=w100><table style=\"word-wrap: break-word; table-layout: fixed\" class=\"table w100\"><thead><tr><th colspan=\"{{ table.head.length }}\">{{ table.name }}</th><th style=\"width: 1%\" class=noprint><md-icon md-font-set=material-icons ng-click=\"ctrl.onDeleteRow(issue.TableEvidences, tableIndex)\">delete</md-icon></th></tr><tr><th ng-repeat=\"field in table.head track by $index\" style=\"width: 180px\">{{ field | capitalize }}:&#32;</th><th style=\"width: 1%\" class=noprint>&#32;</th></tr></thead><tbody><tr ng-repeat=\"field in table.body track by $index\" ng-init=\"bodyIndex = $index\"><td ng-repeat=\"value in field track by $index\">{{ value }}</td><td class=\"noprint text-right\"><md-icon md-font-set=material-icons ng-click=\"ctrl.onDeleteRow(issue.TableEvidences[tableIndex].body, bodyIndex)\">delete</md-icon></td></tr></tbody></table></article><br><br></div></fieldset></div></section><section ng-if=ctrl.checkbox.comment style=\"display: block; border-bottom: 1px dashed #eaeaea; padding: 10px; margin: 10px 0; page-break-after: always\" class=pagebreak><h3 style=\"border-bottom: 1px solid grey\"><b>{{ ctrl.translation.commentary }}</b></h3><table style=\"word-wrap: break-word; table-layout: fixed\" class=\"table w100\"><thead><tr><th style=\"width: 15%\">Autor</th><th style=\"width: 15%\">Fecha</th><th style=\"width: 65%\">Comentario</th><th class=noprint>&#32;</th></tr></thead><tbody><tr ng-repeat=\"comment in ctrl.issueComments\"><td>{{ comment.author.fullName }}</td><td>{{ comment.createdAt | asDateHour }}</td><td><div ng-bind-html=comment.comment></div></td><td class=\"noprint text-right\"><md-icon md-font-set=material-icons ng-click=\"ctrl.onDeleteRow(ctrl.issueComments, $index)\">delete</md-icon></td></tr></tbody></table></section><section ng-if=ctrl.checkbox.storage style=\"display: block; border-bottom: 1px dashed #eaeaea; padding: 10px; margin: 10px 0; page-break-after: always\" class=pagebreak><h3 style=\"border-bottom: 1px solid grey\"><b>{{ ctrl.translation.storage }}</b></h3><table style=\"word-wrap: break-word; table-layout: fixed\" class=\"table w100\"><tbody><tr ng-repeat=\"file in ctrl.issueStorage\"><td>{{ file.name }}</td><td><img ng-src=\"{{ file.path }}\" alt=file.name></td><td style=\"width: 1%\" class=\"noprint text-right\"><md-icon md-font-set=material-icons ng-click=\"ctrl.onDeleteRow(ctrl.issueStorage, $index)\">delete</md-icon></td></tr></tbody></table></section></div></md-dialog-content><md-dialog-actions><div layout=row flex class=w100><div layout=row><md-checkbox aria-label=guests ng-model=ctrl.checkbox.guest>{{ ctrl.translation.guests }}</md-checkbox><md-checkbox aria-label=evidence ng-model=ctrl.checkbox.evidence>{{ ctrl.translation.evidence }}</md-checkbox><md-checkbox aria-label=linked ng-model=ctrl.checkbox.link>{{ ctrl.translation.linked }}</md-checkbox><md-checkbox aria-label=commentary ng-model=ctrl.checkbox.comment>{{ ctrl.translation.commentary }}</md-checkbox><md-checkbox aria-label=storage ng-model=ctrl.checkbox.storage>{{ ctrl.translation.storage }}</md-checkbox></div><div layout=row flex=\"\" flex-offset=20><md-checkbox aria-label=storage ng-model=ctrl.checkbox.attachPdf>{{ ctrl.translation.attachPDF }}</md-checkbox></div></div><md-button ng-click=ctrl.print2() class=\"md-raised white-text blue\">{{ ctrl.translation.print }}</md-button><md-button ng-click=ctrl.cancel()>{{ ctrl.translation.close }}</md-button></md-dialog-actions><div style=\"display: none; visibility: hidden\"><iframe id=printf , loading=lazy></iframe></div></md-dialog>");
$templateCache.put("app/dashboard/components/vinculated-issues/vinculated-issues.html","<div ng-cloak><md-tabs md-border-bottom md-dynamic-height ng-if=\"ctrl.linkedIssueTypes.length &gt; 0\"><md-tab ng-repeat=\"issueType in ctrl.linkedIssueTypes\"><md-tab-label><cep-icon icon=cep-link></cep-icon>{{ issueType.name }}</md-tab-label><md-tab-body><vinculated-issues-list issue-uuid=ctrl.issueUuid issues-to-link=ctrl.issuesToLink links-count=ctrl.linkedIssueCounters[issueType.id] issue-type=issueType></vinculated-issues-list></md-tab-body></md-tab></md-tabs><div ng-if=\"ctrl.linkedIssueTypes.length == 0\" style=\"padding: 5vh\" class=text-center><md-icon md-font-set=material-icons md-menu-align-target>info</md-icon><h4>There are no linked issues</h4></div></div>");
$templateCache.put("app/data-conn/components/create-conection/dialog-create-conection.html","<md-dialog aria-label={{translation.add_schema}} style=width:1750px><form><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ctrl.connData.id ? translation.update : translation.create}} {{translation.conex}} - {{ctrl.connData.name}} {{ctrl.connData.id}}</h2></div></md-toolbar><md-dialog-content style=min-height:300px><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label={{translation.conex}} md-on-select=ctrl.loadPolicies(ctrl.myPoliciesJson);><ng-include src=&quot;app/data-conn/components/create-conection/templates/connection-tab.html&quot;></ng-include></md-tab><md-tab label=Queries ng-if=ctrl.tabQueries><ng-include src=&quot;app/data-conn/components/create-conection/templates/queries-tab.html&quot;></ng-include></md-tab><md-tab label=Definitions><ng-include src=&quot;app/data-conn/components/create-conection/templates/definitions-tab.html&quot;></ng-include></md-tab><md-tab label=Schema><md-content class=md-padding><div ng-model=ctrl.connData.schemasCacheAsJson ui-ace=\"{ useWrapMode : true, showGutter: true, theme:\'twilight\', mode: \'json\' }\" style=\"height:430px; width:100%\" readonly></div></md-content></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=columns class=w100><section ng-show=ctrl.loading class=w100><span>{{ctrl.stateMSG}}</span><md-progress-linear></md-progress-linear></section><section ng-hide=ctrl.loading><md-button ng-click=ctrl.createConn() class=\"md-raised md-primary\">{{translation.save}} & {{translation.test}} {{translation.conex}}</md-button><md-button ng-click=ctrl.cancel() class=md-raised>{{translation.close}}</md-button></section></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/data-conn/components/query-editor/query-editor.html","<div style=\"position: relative\"><div style=\"position: absolute; bottom: 0; z-index: 2; width: auto; right: 0; margin: 1rem 2rem 0 0\" class=text-right><md-button ng-click=ctrl.addQuery() class=md-raised><i class=material-icons>add</i>Add Query</md-button></div><md-tabs md-dynamic-height md-stretch-tabs=never><md-tab ng-repeat=\"_query in ctrl.query track by $index\" label=\"query {{$index + 1}}\"><section style=\"position: relative\" class=w100><div style=\"position: absolute; z-index: 2; width: auto; right: 0; margin: 1rem 2rem 0 0\" class=text-right><button ng-click=ctrl.removeQuery($index) aria-label=\"Button delete query\" class=\"md-secondary text-main-color btn md-raised\"><i class=material-icons>delete</i>query {{ $index + 1 }}</button></div><div ng-model=ctrl.query[$index] ui-ace=\"{ useWrapMode : true, showGutter: true, theme:\'twilight\', mode: \'sql\' }\" style=\"height: 430px\" class=md-whiteframe-2dp></div></section></md-tab></md-tabs></div>");
$templateCache.put("app/ethical-portal/components/complaintForm/complaintForm.html","<div id=menu-ethical-portal-form ng-if=!ctrl.loading class=md-dense><section layout=row style=\"margin-top: 0px\"><md-card flex=30 style=\"padding: 1.5rem\" class=relative><div style=\"padding-top: 2rem\"><div><md-input-container class=\"w100 p0 m0\"><label>Nombre del Formulario</label><input ng-model=ctrl.item.name placeholder=Name></md-input-container></div><div><md-input-container class=\"w100 p0 m0\"><label>Descripción</label><input ng-model=ctrl.item.description placeholder=Description></md-input-container></div><div><md-switch ng-model=ctrl.item.required_user_data aria-label=ctrl.item.required_user_data>Datos del usuario obligatorios: {{ ctrl.item.required_user_data }}</md-switch></div><div><md-switch ng-model=ctrl.item.active aria-label=ctrl.item.active>Activo: {{ ctrl.item.active ? \'Sí\' : \'No\' }}</md-switch></div><div><md-switch ng-model=ctrl.item.complaintRatification aria-label=ctrl.item.complaintRatification>Ratificación: {{ ctrl.item.complaintRatification ? \'Sí\' : \'No\' }}</md-switch><md-tooltip>El usuario debe ingresar un correo electrónico válido, al cual se le enviará un link de confirmación.</md-tooltip></div><hr><h6 style=\"display: flex; justify-content: space-between\"><strong>Form Sections</strong><md-button ng-click=ctrl.addSection() class=\"m0 blue white-text md-raised\"><md-icon md-font-set=material-icons md-menu-align-target class=white-text>add</md-icon></md-button></h6><div ng-repeat=\"section in ctrl.form track by $index\" class=panel><h6 style=\"display: flex; justify-content: space-between\"><strong>{{ section.sectionName }}</strong><span class=chip>Questions {{ section.inputs.length }}</span></h6></div><div><md-button ng-click=ctrl.saveForm() class=\"m0 w100 green white-text md-raised\"><md-icon md-font-set=material-icons md-menu-align-target class=white-text>add</md-icon>Guardar formulario</md-button><hr><md-button ng-click=ctrl.destroyForm() class=\"m0 w100 red white-text md-raised\"><md-icon md-font-set=material-icons md-menu-align-target class=white-text>trash</md-icon>Eliminar formulario</md-button></div></div></md-card><md-card flex=80 class=relative><div id=form-sections ng-repeat=\"section in ctrl.form track by $index\" ng-init=\"formSection = $index\" class=relative><div layout=row layout-align=\"center center\" layout-padding style=\"padding-top: 2rem\" class=\"grey lighten-2\"><div flex=60><md-input-container class=\"w100 p0 m0\"><label>Section {{ formSection + 1 }}</label><input ng-model=section.sectionName></md-input-container></div><div flex class=\"layout-row layout-align-end-center\"><md-button ng-click=ctrl.addFieldToSection($index) class=\"m0 blue white-text\"><md-tooltip md-direction=top>add field</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target class=white-text>add</md-icon></md-button><md-button ng-click=ctrl.removeSection($index) class=m0><md-tooltip md-direction=top>delete</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>delete</md-icon></md-button></div></div><section ng-repeat=\"input in section.inputs track by $index\" ng-init=\"sectionQuestion = $index\" style=\"border-bottom: 3px solid #e0e0e0; padding-bottom: 1rem; padding-top: 1.4rem\"><section layout=row layout-padding style=\"padding: 1rem\"><div flex><md-input-container class=\"w100 p0 m0\"><label>Question {{ sectionQuestion + 1 }}</label><input ng-model=input.name></md-input-container></div><div flex><md-input-container class=\"w100 p0 m0\"><label>Type</label><md-select ng-model=input.type><md-option ng-repeat=\"type in inputTypes track by $index\" ng-value=type.value>{{ type.name }}</md-option></md-select></md-input-container></div></section><!--preview input--><section layout=row layout-padding ng-switch=input.type><div flex ng-switch-when=text><md-input-container class=\"w100 m0\"><label>{{ input.name }}</label><input required name=fake ng-model=input.answer><small ng-if=input.required class=grey-text>This is required.*\\</small></md-input-container></div><div flex ng-switch-when=textarea><md-input-container class=\"w100 m0\"><label>{{ input.name }}</label><textarea required name=fake ng-model=input.answer rows=5 cols=6></textarea><small ng-if=input.required class=grey-text>This is required.*</small></md-input-container></div><div flex ng-switch-when=number><md-input-container class=\"w100 m0\"><label>{{ input.name }}</label><input required name=fake ng-model=input.answer><small ng-if=input.required class=grey-text>This is required.*</small></md-input-container></div><div flex ng-switch-when=email><md-input-container class=\"w100 m0\"><label>{{ input.name }}</label><input required name=fake ng-model=input.answer><small ng-if=input.required class=grey-text>This is required.*</small></md-input-container></div><div flex ng-switch-when=date><md-input-container class=\"w100 m0\"><label>{{ input.name }}</label><input required name=fake ng-model=input.answer><small ng-if=input.required class=grey-text>This is required.*</small></md-input-container></div><div flex ng-switch-when=time><md-input-container class=\"w100 m0\"><label>{{ input.name }}</label><input required name=fake ng-model=input.answer><small ng-if=input.required class=grey-text>This is required.*</small></md-input-container></div><div flex layout=row layout-padding ng-switch-when=select><div flex><md-input-container class=\"w100 p0 m0\"><label>{{ input.name }}</label><md-select name=fake ng-model=input.answer class=w100><md-option ng-value=\"\">none</md-option><md-option ng-repeat=\"opt in input.options track by $index\" ng-value=\"{{ opt }}\">{{ opt }}</md-option></md-select><small ng-if=input.required class=grey-text>This is required.*</small><span ng-if=\"input.options.length === 0\" class=red-text>add some options</span></md-input-container></div><div flex=40><label>Options</label><md-chips ng-model=input.options input-aria-label=options></md-chips></div></div><div flex layout=row layout-padding ng-switch-when=radio><div flex><h5 class=bold-text>{{ input.name }}</h5><md-radio-group ng-model=input.answer aria-labelledby=radiooptions><div ng-repeat=\"opt in input.options track by $index\" style=\"border-bottom: 1px solid #e0e0e0\"><div flex layout=row layout-padding layout-align=\"center center\"><div flex=1><md-radio-button flex value=\"{{ opt.value }}\" aria-label=\"{{ opt.value }}\"></md-radio-button></div><div flex=40><label>Opción</label><textarea ng-model=opt.value placeholder=option style=\"padding: 0.5rem; font-size: 1.2rem; font-weight: 500; color: #000000\" class=w100></textarea><div ng-if=\"opt.other_required === true\"><label>Respuesta</label><textarea ng-model=opt.question placeholder=option style=\"padding: 0.5rem; font-size: 1.2rem; font-weight: 500; color: #000000\" class=w100></textarea></div></div><div flex=25><label>Mensaje de ayuda</label><textarea ng-model=opt.tooltip placeholder=tooltip style=\"padding: 0.5rem; font-size: 1.2rem; font-weight: 500; color: #000000\" class=w100></textarea></div><div flex=20><md-input-container class=\"w100 p0 m0\"><label>Documento</label><md-select ng-model=opt.document><md-option ng-value=\"\">Sin documento</md-option><md-option ng-repeat=\"doc in ctrl.company.documentList track by $index\" ng-value=doc>{{ doc[0] }}</md-option></md-select></md-input-container></div><div flex=1><md-button ng-click=\"ctrl.removeOptionFromField( formSection, sectionQuestion, $index)\"><md-tooltip md-direction=top>delete</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>delete</md-icon></md-button></div></div></div></md-radio-group><div layout=row layout-padding layout-align=\"start center\"><div flex><small ng-if=input.required class=grey-text>This is required.*</small><br><span ng-if=\"input.options.length === 0\" class=red-text>add some options</span><br><md-button ng-click=\"ctrl.addOptionOtherOption( formSection, sectionQuestion)\">add other option<md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></div><div><md-button ng-click=\"ctrl.addOptionFromField( formSection, sectionQuestion)\" class=blue><md-tooltip md-direction=top>add option</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></div></div></div></div><div flex layout=column layout-padding ng-switch-when=checkbox><div flex><h5 class=bold-text>{{ input.name }}</h5><div ng-repeat=\"opt in input.options track by $index\" style=\"border-bottom: 1px solid #e0e0e0\"><div flex layout=row layout-padding layout-align=\"center center\"><div flex=1><md-checkbox flex value=\"{{ opt.value }}\" aria-label=\"{{ opt.value }}\"></md-checkbox></div><div flex=40><label>Opción</label><textarea ng-model=opt.value placeholder=option style=\"padding: 0.5rem; font-size: 1.2rem; font-weight: 500; color: #000000\" class=w100></textarea></div><div flex=25><label>Mensaje de ayuda</label><textarea ng-model=opt.tooltip placeholder=tooltip style=\"padding: 0.5rem; font-size: 1.2rem; font-weight: 500; color: #000000\" class=w100></textarea></div><div flex=20><md-input-container class=\"w100 p0 m0\"><label>Documento</label><md-select ng-model=opt.document><md-option ng-value=\"\">Sin documento</md-option><md-option ng-repeat=\"doc in ctrl.company.documentList track by $index\" ng-value=doc>{{ doc[0] }}</md-option></md-select></md-input-container></div><div flex=1><md-button ng-click=\"ctrl.removeOptionFromField( formSection, sectionQuestion, $index)\"><md-tooltip md-direction=top>delete</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>delete</md-icon></md-button></div></div></div></div><div layout=row layout-padding layout-align=\"start center\"><div flex><small ng-if=input.required class=grey-text>This is required.*</small><br><span ng-if=\"input.options.length === 0\" class=red-text>add some options</span></div><div><md-button ng-click=\"ctrl.addOptionFromField( formSection, sectionQuestion)\" class=blue><md-tooltip md-direction=top>add option</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></div></div></div><div flex ng-switch-default><md-input-container class=\"w100 m0\"><label>{{ input.name }}</label><input required name=fake ng-model=input.answer><small ng-if=input.required class=grey-text>This is required.*</small></md-input-container></div></section><section layout=row layout-padding layout-align=\"center center\" class=\"amber lighten-5\"><div flex><md-switch ng-model=input.required aria-label=input.required>Required: {{ input.required }}</md-switch></div><div flex=40><label>Mensaje de ayuda</label><textarea ng-model=input.tooltip placeholder=tooltip rows=3 cols=6 style=\"padding: 0.5rem; font-size: 1.2rem; font-weight: 500; color: #000000\" class=w100></textarea></div><div flex><md-input-container class=\"w100 p0 m0\"><label>Documento</label><md-select ng-model=input.document><md-option ng-value=\"\">Sin documento</md-option><md-option ng-repeat=\"doc in ctrl.company.documentList track by $index\" ng-value=doc>{{ doc[0] }}</md-option></md-select></md-input-container></div><div flex=1 class=text-right><md-button ng-click=\"ctrl.removeFiedlFromSection( formSection, sectionQuestion)\" class=m0><md-tooltip md-direction=top>delete</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target>delete</md-icon></md-button></div></section></section></div></md-card></section></div>");
$templateCache.put("app/files-storage/components/disk/disk-usage.html","<md-card id=DiskUsage><md-toolbar class=\"grey lighten-2\"><div class=md-toolbar-tools><h2 flex=\"\" md-truncate=\"\" style=\"color: #000\" class=text-center>{{ ctrl.translation.storage }}</h2></div></md-toolbar><section layout=column layout-padding=\"\" ng-if=!ctrl.loading ng-class=ctrl.storeInfo.class><div id=diskInfo flex=\"\" ng-if=ctrl.show.includes(&quot;diskInfo&quot;)><h1 class=text-right>{{ ctrl.diskUsagePercentage }} %</h1><progress id=file ng-class=ctrl.storeInfo.progress max=100 value=\"{{ ctrl.diskUsagePercentage }}\"></progress><h4 class=text-right>&nbsp;<b>{{ ctrl.storage.diskUsageInKb | readableBytes }} /</b>{{ ctrl.storage.diskSizeInKb | readableBytes }}</h4></div><div id=systemInfo ng-if=ctrl.show.includes(&quot;systemInfo&quot;)><h5><md-icon md-font-set=material-icons>dynamic_feed</md-icon>&nbsp;<b>{{ ctrl.translation.systemInfo }}</b></h5><p>{{ ctrl.translation.sizeOndisk }}: &nbsp;<b>{{ ctrl.storage.systemUsageInKb | readableBytes }}</b></p></div><div id=trashInfo ng-if=ctrl.show.includes(&quot;trashInfo&quot;)><h5><md-icon md-font-set=material-icons>delete</md-icon>&nbsp;<b>{{ ctrl.translation.trash }}</b></h5><p>{{ ctrl.translation.sizeOndisk }}: &nbsp;<b>{{ ctrl.storage.trashUsageInKb | readableBytes }}</b></p><md-button aria-label=confirmDeleteALLTrash ng-click=confirmDeleteALLTrash() class=\"w100 m0 text-left red\"><md-icon md-font-set=material-icons>delete_forever</md-icon>&nbsp;<b>{{ ctrl.translation.empty_trash }}</b></md-button></div></section></md-card>");
$templateCache.put("app/files-storage/components/file/file.html","<div id=file-widget><section layout=row layout-align=\"center center\" layout-padding=\"\" layout-wrap=\"\"><div flex=100 class=p0><h3>{{ file.data.name }}</h3></div><div flex=100 class=p0><p md-truncate=\"\"><b>Owner</b>&nbsp; {{ file.data.ownerName }}</p></div><div flex=100 class=p0><p md-truncate=\"\"><b>Size</b>&nbsp;<small>{{ file.data.size | readableBytes }}</small></p></div></section><file-preview ng-if=file.showPreview file=file.data></file-preview><md-list flex><md-list-item ng-click=file.downloadFile() aria-label=\"descargar archivo\" ng-show=file.validatePermission(&quot;download&quot;)><md-icon md-font-set=material-icons>cloud_download</md-icon><p>{{ file.translation.download }}</p></md-list-item><md-list-item ng-if=!file.data.trash ng-click=file.dialogMoveFileToFolder($event) aria-label=\"mover archivo\" ng-show=file.validatePermission(&quot;move&quot;)><md-icon md-font-set=material-icons>move_to_inbox</md-icon><p>{{ file.translation.move }}</p></md-list-item><md-list-item ng-if=!file.data.trash ng-click=file.showShareEntityDialog() aria-label=\"compartir archivo\" ng-show=file.validatePermission(&quot;share&quot;)><md-icon md-font-set=material-icons>share</md-icon><p>{{ file.translation.file_share }}</p></md-list-item><md-list-item ng-if=!file.data.trash ng-click=file.confirmFileToTrash() aria-label=\"papelera archivo\" ng-show=file.validatePermission(&quot;delete&quot;)><md-icon md-font-set=material-icons>delete</md-icon><p>{{ file.translation.send_to_trash }}</p></md-list-item><md-list-item ng-if=file.data.trash ng-click=file.confirmDeleteFileInTrash() aria-label=\"eliminar archivo\" ng-show=file.validatePermission(&quot;delete&quot;)><md-icon md-font-set=material-icons>blur_on</md-icon><p>{{ file.translation.delete }}</p></md-list-item><md-list-item ng-if=file.data.trash ng-click=file.confirmRestoreFileToFolder() aria-label=\"restaurar archivo\" ng-show=file.validatePermission(&quot;restore&quot;)><md-icon md-font-set=material-icons>replay</md-icon><p>{{ file.translation.restore }}</p></md-list-item></md-list></div>");
$templateCache.put("app/files-storage/components/files-queue/files-queue.html","<md-card class=relative><md-card-content><h4><b>{{ ctrl.files.length }} {{ ctrl.translation.selected_files }}</b></h4><md-list flex=\"\" style=\"max-height: 64vh; overflow: auto\" class=md-dense><md-list-item ng-repeat=\"file in ctrl.files\"><div layout=column class=\"md-list-item-text w100\"><div flex=100><h5>{{ file.name }}</h5><md-progress-linear ng-if=file.loading></md-progress-linear></div></div></md-list-item><md-divider></md-divider></md-list></md-card-content><md-card-content class=\"isSticky inBottom\"><div layout=row><md-button ng-click=ctrl.downloadFile() aria-label=\"download button\" ng-if=\"ctrl.validatePermission(&quot;download&quot;, &quot;SYSTEM&quot;)\" class=\"md-fab md-mini white\"><md-icon md-font-set=material-icons>cloud_download</md-icon><md-tooltip>{{ ctrl.translation.download }} {{ ctrl.translation.all }}</md-tooltip></md-button><md-button ng-click=ctrl.confirmFileToTrash() aria-label=\"delete button\" ng-show=\"ctrl.validatePermission(&quot;delete&quot;, &quot;SYSTEM&quot;)\" class=\"md-fab md-mini white\"><md-icon md-font-set=material-icons>delete</md-icon><md-tooltip>{{ ctrl.translation.send_to_trash }} {{ ctrl.translation.all }}</md-tooltip></md-button><md-button ng-click=ctrl.dialogMoveFileToFolder() aria-label=\"delete button\" ng-show=\"ctrl.validatePermission(&quot;move&quot;, &quot;SYSTEM&quot;)\" class=\"md-fab md-mini white\"><md-icon md-font-set=material-icons>move_to_inbox</md-icon><md-tooltip>{{ ctrl.translation.move }} {{ ctrl.translation.all }}</md-tooltip></md-button></div></md-card-content></md-card>");
$templateCache.put("app/home/components/dashboard-config-bar/dashboard-config-bar.html","<md-sidenav md-component-id=config-bar md-disable-close-events md-whiteframe=8 style=\"width: 40vw; position: fixed\" layout=column class=md-sidenav-right><md-toolbar class=\"main-color sticky-top\"><div class=md-toolbar-tools><h1 flex>{{ translation.addWidget }}</h1><round-button on-click=ctrl.api.close() aria-label=Close icon=clear></round-button></div></md-toolbar><div flex class=\"grey lighten-4\"><section ng-show=\"ctrl.page == 1\"><md-subheader class=\"md-no-sticky p0\"><div style=\"margin: 0\">{{ translation.selectOrigin }}</div></md-subheader><div ng-repeat=\"item in ctrl.widgets track by $index\" class=user-widgets-list><md-toolbar class=\"white black-text\"><div ng-click=ctrl.expand_widget_block($index) class=md-toolbar-tools><h2 flex md-truncate>{{ item.name | capitalize }}</h2><md-button aria-label=Favorite class=md-icon-button><md-icon class=grey-text>{{ item.display ? \'expand_more\' : \'expand_less\' }}</md-icon></md-button></div></md-toolbar><div style=\"padding: 10px\" ng-if=item.display><md-grid-list md-cols-xs=1 md-cols-sm=2 md-cols-md=3 md-cols-gt-md=3 md-row-height-gt-md=1:1 md-row-height=2:2 md-gutter=12px md-gutter-gt-sm=8px><md-grid-tile ng-repeat=\"widget in item.widgets\" widget-tile md-whiteframe=1 ng-click=ctrl.configure(widget) class=white><div layout=column class=white><md-icon md-font-set=material-icons flex>{{ widget.icon }}</md-icon><div class=text-center>{{ widget.name }}</div></div></md-grid-tile></md-grid-list></div></div></section><section ng-show=\"ctrl.page == 2\"><md-subheader class=\"md-no-sticky p0\"><div class=m0>{{ translation.configWidget }}</div></md-subheader><section ng-if=ctrl.selectedWidget.widget.configComponent><widget-config-box widget=ctrl.selectedWidget></widget-config-box></section><section ng-if=\"ctrl.selectedWidget.widget.configComponent==null\"><div layout=column layout-padding ng-if=\"![&quot;list-reader-widget&quot; ,&quot;indicators-list-widget&quot;].includes(ctrl.selectedWidget.widget.type)\"><div ng-repeat=\"field in ctrl.selectedWidget.widget.configs\"><md-input-container ng-if=\"field.type == &quot;string&quot;\" class=\"no-padding-no-margin w100\"><label>{{ field.label }}</label><input ng-model=ctrl.selectedWidget.widget.props[field.name] type=text ng-required=field.required></md-input-container><div ng-if=\"field.type == &quot;autocomplete&quot;\"><label>{{ field.label }}</label><md-autocomplete md-selected-item=ctrl.selectedWidget.widget.props[field.name] md-search-text=searchText md-selected-item-change=field.callback() md-floating-label=\"{{ field.label }}\" md-require-match=true md-items=\"item in ctrl.querySearch(searchText)\" md-item-text=item.name md-min-length=0 placeholder=\"{{ field.label }}\" input-aria-describedby=\"{{ field.label }}\" class=m0><md-item-template><span md-highlight-text=searchText md-highlight-flags=^i>{{ item.name }}</span></md-item-template></md-autocomplete></div><md-input-container ng-if=\"field.type == &quot;enum&quot;\" class=\"no-padding-no-margin w100\"><label>{{ field.label }}</label><md-select ng-model=ctrl.selectedWidget.widget.props[field.name] placeholder=\"{{ field.label }}\" aria-label=\"{{field.name}} Selector\" ng-change=field.callback() ng-required=field.required><md-option ng-repeat=\"opt in field.values\" value=\"{{ opt.value }}\">{{ opt.label }}</md-option></md-select></md-input-container><md-input-container ng-if=\"field.type == &quot;multi-select&quot;\" class=\"no-padding-no-margin w100\"><label>{{ field.label }}</label><md-select ng-model=ctrl.selectedWidget.widget.props[field.name] placeholder=\"{{ field.label }}\" aria-label=\"{{field.name}} Selector\" ng-change=field.callback() ng-required=field.required multiple><md-option ng-repeat=\"opt in field.values\" value=\"{{ opt.value }}\">{{ opt.label }}</md-option></md-select></md-input-container><md-input-container ng-if=\"field.type == &quot;select&quot; &amp;&amp; ctrl.selectedWidget.widget.type != &quot;replay-chart-widget&quot;\" class=\"no-padding-no-margin w100\"><label>{{ field.label }}</label><md-select ng-model=ctrl.selectedWidget.widget.props[field.name] placeholder=\"{{ field.label }}\" aria-label=\"{{field.name}} Selector\" ng-change=field.callback() ng-required=field.required><md-option ng-repeat=\"opt in field.values\" value=\"{{ opt }}\">{{ opt }}</md-option></md-select></md-input-container><div ng-if=\"field.type == &quot;select&quot; &amp;&amp; ctrl.selectedWidget.widget.type == &quot;replay-chart-widget&quot;\"><md-input-container class=\"no-padding-no-margin w100\"><label>{{ field.label }}</label><select ng-model=ctrl.selectedReplay ng-change=ctrl.changeReplay() placeholder=\"{{ field.label }}\" aria-label=\"{{field.name}} Selector\" required class=select-filters-modal><option ng-repeat=\"item in ctrl.replays\" value=\"{{ item.id }}\">{{ item.name }}</option></select></md-input-container><md-input-container class=\"no-padding-no-margin w100\"><label>{{ field.label }}</label><select ng-model=ctrl.selectedChart ng-change=ctrl.changeChart() placeholder=\"{{ field.label }}\" aria-label=\"{{field.name}} Selector\" required class=select-filters-modal><option ng-repeat=\"item in ctrl.charts\" value=\"{{ item.id }}\">{{ item.name + \'-\' + item.type }}</option></select></md-input-container></div><div ng-if=\"field.type == &quot;checkbox&quot;\"><div layout=column layout-wrap=\"\" flex=\"\"><div layout=row><md-input-container class=\"no-padding-no-margin w100\"><label>{{ field.label }}</label><input ng-model=ctrl.selectedWidget.widget.props.title type=text ng-required=field.required></md-input-container></div></div><div layout=row><div flex=60><md-input-container class=w100><label>{{ translation.search }}</label><input ng-model=searchText class=w100></md-input-container></div><div flex=40><label>{{ translation.selected }}</label><p>{{ field.selected.length }} / {{ field.max }}</p></div></div><fieldset style=\"max-height: 45vh; overflow: auto\" class=standard><div layout=column layout-wrap=\"\" flex=\"\"><div flex ng-repeat=\"item in ctrl.querySearch(searchText)\"><md-checkbox ng-checked=\"exists(item, field.selected , field.max)\" ng-click=\"toggle(item, field.selected , field.max)\">{{ item.name }}</md-checkbox></div></div></fieldset></div><div ng-if=\"field.type == &quot;chips&quot;\"><label>{{ field.label }}</label><md-chips ng-model=ctrl.selectedWidget.widget.props[field.name] md-require-match=true><md-autocomplete md-selected-item=ctrl.selectedItem md-search-text=ctrl.searchText md-items=\"item in ctrl.chipsQuerySearch(ctrl.searchText)\" md-item-text=item.name input-aria-describedby=autocompleteTitle><span md-highlight-text=ctrl.searchText>{{ item.name }}</span></md-autocomplete><md-chip-template><span><strong>{{ $chip.name }}</strong></span></md-chip-template></md-chips></div></div></div><div layout=column layout-padding ng-if=\"[&quot;list-reader-widget&quot; ,&quot;indicators-list-widget&quot;].includes(ctrl.selectedWidget.widget.type)\"><div><label>{{ field.label }}</label><md-autocomplete ng-disabled=ctrl.isDisabled md-no-cache=ctrl.noCache md-selected-item=ctrl.selectedList md-search-text=searchText md-selected-item-change=getInputList() md-input-name=autocompleteField md-items=\"item in ctrl.querySearch(searchText)\" md-item-text=item.name md-min-length=0 placeholder=list input-aria-describedby=listas class=m0><md-item-template><span md-highlight-text=searchText md-highlight-flags=^i>{{ item.name }}</span></md-item-template></md-autocomplete></div><div ng-if=ctrl.currentschema layout=column><div ng-if=\"ctrl.selectedWidget.widget.type == &quot;indicators-list-widget&quot;\" layout=column><md-input-container><div>Yaxis</div><md-select multiple ng-model=ctrl.indicatorsValues.yAxis><md-option style=\"margin: 1rem\" ng-repeat=\"(key,val) in ctrl.currentschema.properties\" ng-value=key ng-if=val.format>{{ key }}</md-option></md-select></md-input-container><md-input-container><div>Xaxis</div><md-select ng-model=ctrl.indicatorsValues.xAxis><md-option style=\"margin: 1rem\" ng-repeat=\"(key,val) in ctrl.currentschema.properties\" ng-value=key ng-if=!val.format>{{ key }}</md-option></md-select></md-input-container><br><md-radio-group ng-model=ctrl.indicatorsValues.typeChart aria-labelledby=typeChart><md-radio-button value=bar class=md-primary>{{ translation.bar }}</md-radio-button><md-radio-button value=line>{{ translation.line }}</md-radio-button></md-radio-group><md-input-container><label>{{ translation.description }}</label><input ng-model=ctrl.indicatorsValues.description></md-input-container></div><div ng-if=\"ctrl.selectedWidget.widget.type == &quot;list-reader-widget&quot;\" layout=column><md-input-container><div>{{ translation.group }}</div><md-select ng-model=ctrl.group><md-option style=\"margin: 1rem\" ng-repeat=\"(key,val) in ctrl.currentschema.properties\" ng-if=\"key.indexOf(&quot;Riesgo&quot;) == -1\" ng-value=key>{{ key }}</md-option></md-select></md-input-container><md-input-container><div>{{ translation.label }}</div><md-select ng-model=ctrl.label><md-option style=\"margin: 1rem\" ng-repeat=\"(key,val) in ctrl.currentschema.properties\" ng-if=\"key.indexOf(&quot;Riesgo&quot;) == 0\" ng-value=key>{{ key }}</md-option></md-select></md-input-container><md-input-container><label>{{ translation.operation }}</label><md-select ng-model=ctrl.operation><md-option ng-repeat=\"name in ctrl.operationTypes\" ng-value=name>{{ name }}</md-option></md-select></md-input-container><md-input-container><label>{{ translation.top }}</label><md-select ng-model=ctrl.bytop><md-option ng-repeat=\"name in ctrl.topTypes\" ng-value=name>{{ name }}</md-option></md-select></md-input-container></div></div></div></section></section></div><md-divider style=\"margin-top: 30px\"></md-divider><div layout=\"row \" layout-align=\"end end\" style=\"margin-bottom: 15px\" ng-if=\"ctrl.selectedWidget.widget.configComponent==null\"><div flex><md-button ng-show=\"ctrl.page == 2\" ng-click=ctrl.prevPage() aria-label=\"Prev page button\" class=\"md-raised white-text orange\"><div class=\"fa fa-undo\"></div>&nbsp;&nbsp; {{ translation.return }}</md-button></div><div flex><md-button ng-show=\"ctrl.page == 2\" ng-click=ctrl.apply() aria-label=\"Prev page button\" class=\"md-raised white-text green\"><div class=\"fa fa-floppy-o\"></div>&nbsp;&nbsp; {{ translation.apply }}</md-button></div><div flex><md-button ng-click=ctrl.api.close() aria-label=\"Cancel widget config button\" class=\"md-raised white-text red\"><div class=\"fa fa-times\"></div>&nbsp;&nbsp; {{ translation.cancel }}</md-button></div></div></md-sidenav>");
$templateCache.put("app/home/components/organize-dashboards/organize-dashboards.html","<md-dialog aria-label=organize-dashboard><form><md-toolbar class=main-color><div class=md-toolbar-tools><h2>Organize dashboards</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-width: 600px; max-width: 800px; max-height: 810px; padding: 5px; min-height: 150px\"><div ng-if=\"ctrl.loading == true\"><br><br><md-progress-linear md-mode=indeterminate></md-progress-linear><br><br></div><div ng-if=\"ctrl.loading == false\"><md-list flex ui-sortable=sortableOptionsList ng-model=ctrl.dashboards class=list-dashboards><md-list-item ng-repeat=\"dashboard in ctrl.dashboards\" class=md-3-line><div layout=column class=md-list-item-text><div><p></p><div class=\"fa fa-arrows-v\"></div>&nbsp; &nbsp; {{ $index + 1 }} &nbsp; &nbsp; - &nbsp;<b>{{ dashboard.dashboardName }}</b><p></p></div></div><md-divider></md-divider></md-list-item></md-list></div><div ng-if=\"ctrl.loading == false\" class=text-right><md-button ng-click=ctrl.save() aria-label=\"Save button\" class=\"md-raised white-text green\">save</md-button><md-button ng-click=ctrl.cancel() class=\"md-raised white-text red\">cancel</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/home/components/share-dashboard/share-dashboard.html","<md-dialog aria-label=share-dashboard><form><md-toolbar class=main-color><div class=md-toolbar-tools><h2>share &nbsp;<strong>{{ ctrl.dashboard.name }}</strong></h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-width: 600px; max-width: 800px; max-height: 810px; padding: 5px; min-height: 150px\"><div layout=row><div layout=column flex><md-input-container style=\"position: sticky; top: 0; background: white; z-index: 2\" class=m0><label>{{ \"share_with\" }}</label><input ng-model=ctrl.search ng-change=ctrl.searchUsers()></md-input-container><md-list><md-list-item ng-repeat=\"user in ctrl.users\" ng-click=ctrl.toggleUser(user)><p>{{ user.username }}</p><md-checkbox ng-model=user.selected aria-label=\"Select user\"></md-checkbox></md-list-item></md-list></div></div></md-dialog-content><md-dialog-actions style=\"position: sticky; bottom: 0; background: white; z-index: 2\"><md-button ng-click=ctrl.save() aria-label=\"Save button\" class=\"md-raised white-text green\">share with selected users</md-button><md-button ng-click=ctrl.cancel() class=\"md-raised white-text red\">cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/home/components/widget-box/widget-box.html","<div><md-menu style=\"position: absolute; right: -5px; z-index: 1\"><md-button aria-label=More ng-click=$mdMenu.open() class=md-icon-button><md-icon md-font-set=material-icons class=\"md-icon-button md-secondary\">more_vert</md-icon></md-button><md-menu-content width=2 ng-mouseleave=$mdMenu.close()><md-menu-item ng-repeat=\"item in ctrl.menu\"><md-button ng-click=item.fn()>{{ item.label }}</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button ng-click=ctrl.deleteWidget(ctrl.index)>{{ ctrl.translations.deleteWidget }}</md-button></md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/home/components/widget-config-box/widget-config-box.html","<form id=widget-config-box name=widgetConfigBox ng-submit=ctrl.apply() style=\"padding: 1rem; background: white\"><div id=component-container></div></form><md-divider style=\"margin-top: 30px\"></md-divider><div layout=row layout-align=\"end end\" style=\"margin-bottom: 15px\"><div flex><md-button ng-click=ctrl.prevPage() aria-label=\"Prev page button\" class=\"md-raised white-text orange\"><div class=\"fa fa-undo\"></div>&nbsp;&nbsp; {{ translation.return }}</md-button></div><div flex><md-button type=submit form=widget-config-box aria-label=\"Prev page button\" class=\"md-raised white-text green\"><div class=\"fa fa-floppy-o\"></div>&nbsp;&nbsp; {{ translation.apply }}</md-button></div><div flex><md-button ng-click=ctrl.close() aria-label=\"Cancel widget config button\" class=\"md-raised white-text red\"><div class=\"fa fa-times\"></div>&nbsp;&nbsp; {{ translation.cancel }}</md-button></div></div>");
$templateCache.put("app/home/widgets/alerts/@deprecated-alerts-chart.html","<section flex=auto><md-card style=\"padding: 1.3em; height:-webkit-fill-available; height:-moz-available; margin:0; flex:auto\" ng-if=\"!ctrl.loadingStatus &amp;&amp; !ctrl.errorResp\"><div id=AmCharts class=w100></div></md-card><md-card style=\"padding: 1.3em; height:-webkit-fill-available; height:-moz-available; margin:0; flex:auto\" ng-if=\"ctrl.loadingStatus &amp;&amp; !ctrl.errorResp\"><div class=w100><p>Cargando grafica de eventos</p><md-progress-linear md-mode=indeterminate></md-progress-linear><br></div></md-card><md-card style=\"padding: 1.3em; height:-webkit-fill-available; height:-moz-available; margin:0; flex:auto\" ng-if=\"!ctrl.loadingStatus &amp;&amp; ctrl.errorResp\"><div class=\"w100 text-center\"><p></p><md-icon md-font-set=material-icons md-menu-align-target class=text-warning>info</md-icon>Sin datos.. Load {{ctrl.loadingStatus }} Err {{ctrl.errorResp}}</div></md-card></section>");
$templateCache.put("app/home/widgets/alerts/@deprecated-alerts.html","<md-content layout=row ng-if=!ctrl.loadingStatus><div ng-repeat=\"alert in ctrl.CongfigAlertas\" flex=auto><md-card ng-if=\"alert.hidden == false\"><div layout=row layout-padding=\"\" class=p0><div flex=40 tipo-estado={{alert.status}}><md-icon md-font-set=material-icons md-menu-align-target style=\"width: 100%;height: 60px;text-align:center;font-size: 4.7em;line-height:1.3\">{{alert.icon}}</md-icon></div><div flex=60 class=text-center><h4 class=text-center>{{alert.status}}</h4><h3 style=font-size:2em><b>{{alert.totalAlerts}} </b></h3></div></div></md-card></div></md-content><md-content layout=row ng-if=ctrl.loadingStatus><md-card ng-repeat=\"a in ctrl.statusTypes track by $index\" flex=20 style=height:105px class=fakeload></md-card></md-content>");
$templateCache.put("app/home/widgets/alerts-chart/alerts-chart.html","<div style=\"padding: 1.3em\" class=\"m0 h100\"><h4 class=widget-box-header>{{ translation.alerts }}</h4><div id=echarts-bar-{{ctrl.uid}} style=\"width:100%; height:500px\"></div></div>");
$templateCache.put("app/home/widgets/bookmarks/bookmarks.html","<div style=\"padding: 2.5em 1.3em; overflow: auto\" class=\"m0 h100 relative-off\"><div ui-sortable=sortableOptionsList data-sort=\"bookmark in ctrl.bookmarks\" ng-model=ctrl.bookmarks class=bookmarks-grid><div ng-repeat=\"bookmark in ctrl.bookmarks track by $index\" ng-dblclick=ctrl.openBookmark(bookmark) role=button-bookmark-item data-order=\"{{ bookmark.order }}\" data-id=\"{{ bookmark.id }}\" data-type=\"{{ bookmark.type }}\" data-name=\"{{ bookmark.name }}\" class=\"bookmark-item relative\"><div class=bookmarks-context-menu><md-menu><md-button aria-label=More ng-click=$mdMenu.open() class=\"md-icon-button m0 p0\"><md-icon md-font-set=material-icons class=\"md-icon-button md-secondary\">more_vert</md-icon></md-button><md-menu-content><md-menu-item ng-repeat=\"option in menuOptions\"><md-button ng-click=option.click(bookmark)><md-icon md-font-set=material-icons>{{ option.icon }}</md-icon><span>{{ option.text }}</span></md-button></md-menu-item></md-menu-content></md-menu></div><cep-icon icon=\"{{ ctrl.iconByType(bookmark.type) }}\" scale=2></cep-icon><strong>{{ bookmark.name || \"--\" }}</strong></div></div></div>");
$templateCache.put("app/home/widgets/cases/casesWidget.html","<div style=\"padding: 1.3em\" layout=column class=\"m0 h100\"><h4 layout=row class=widget-box-header><div flex>{{translation.last}} {{translation.cases}}</div></h4><md-content flex layout=column ng-if=ctrl.permissionError><div class=text-center><br><md-icon style=\"font-size: 50px\" class=\"md-warn md-hue-1\">warning</md-icon><br><p>{{ ctrl.permissionError.message }}</p></div></md-content><div ng-if=!ctrl.permissionError><md-list flex style=overflow:scroll><md-list-item ng-if=loading style=height:245px class=w100><div class=\"w100 text-center\"><p>{{translation.loading}} {{translation.cases | lowercase}}</p><md-progress-linear md-mode=indeterminate></md-progress-linear><br></div></md-list-item><md-list-item flex ng-if=\"!ctrl.cases.length &amp;&amp; !loading\" class=w100><div class=\"w100 text-center\"><md-icon md-font-set=material-icons md-menu-align-target class=text-warning>info</md-icon><b>{{translation.without_cases}}</b></div></md-list-item><md-list-item ng-repeat=\"case in ctrl.cases\" layout=row layout-padding=\"\" class=p0><div flex md-truncate><md-tooltip>{{case.description}}</md-tooltip><b>{{case.caseId}} - {{case.title}}</b><br><span>{{case.description}}</span></div><div flex=20 class=text-center>{{case.creationDate | date}}</div></md-list-item></md-list><md-button href=casos/ ng-click=\"main.clickMenu(\'app.casos\')\" abm-component=abm-component class=\"md-primary md-raised\">{{translation.go_to}} {{translation.cases | lowercase}}</md-button></div></div>");
$templateCache.put("app/home/widgets/counter-box/counter-box.html","<md-content layout=row ng-if=!ctrl.loadingStatus style=overflow:hidden class=widget-box-header><md-card style=\"height:-webkit-fill-available; height:-moz-available; margin:0; flex:auto\"><div layout=row layout-padding=\"\" class=p0><div flex=40 tipo-estado=Visto><md-icon md-font-set=material-icons md-menu-align-target style=\"width: 100%;height: 60px;text-align:center;font-size: 4.7em;line-height:1.3\">{{ctrl.props.icon}}</md-icon></div><div flex=60 class=text-center><h4 class=text-center>{{ctrl.props.label}}</h4><h3 style=font-size:2em><b>{{ctrl.props.data.totalAlerts || 0}}</b></h3></div></div></md-card></md-content><md-content layout=row ng-if=ctrl.loadingStatus><md-card style=\"height:-webkit-fill-available; height:-moz-available; margin:0; flex:auto\" class=fakeload></md-card></md-content>");
$templateCache.put("app/home/widgets/data-management-chart/config-data-management-chart.html","<md-content><md-input-container class=\"w100 mb-0\"><input ng-model=ctrl.config.title placeholder=title required></md-input-container><md-input-container class=\"w100 mb-0\"><label>Schemas</label><md-autocomplete md-selected-item=ctrl.config.schema md-search-text=searchTextSchema md-selected-item-change=ctrl.schemaItemChange(item) md-floating-label=schema md-require-match=true md-items=\"item in ctrl.querySearchSchema(searchTextSchema)\" md-item-text=item md-min-length=0 placeholder=schema input-aria-describedby=schema required><md-item-template><span md-highlight-text=ctrl.searchTextSchema md-highlight-flags=^i>{{ item }}</span></md-item-template><md-not-found>No states matching \"{{ ctrl.searchTextSchema }}\" were found</md-not-found></md-autocomplete></md-input-container><md-input-container class=\"w100 mb-0\"><label>Tables</label><md-autocomplete ng-disabled=\"ctrl.config.schema == null\" md-selected-item=ctrl.config.table md-search-text=searchTextTable md-selected-item-change=ctrl.tableItemChange(item) md-floating-label=table md-require-match=true md-items=\"item in ctrl.querySearchTable(searchTextTable)\" md-item-text=item md-min-length=0 placeholder=table input-aria-describedby=table required class=mb-0><md-item-template><span md-highlight-text=ctrl.searchTextTable md-highlight-flags=^i>{{ item }}</span></md-item-template><md-not-found>No states matching \"{{ ctrl.searchTextTable }}\" were found</md-not-found></md-autocomplete></md-input-container><md-input-container class=w100><label>x Axis</label><md-select ng-disabled=\"ctrl.config.table == null\" ng-model=ctrl.config.xAxis required><md-option ng-value=col.colName ng-repeat=\"col in ctrl.tableColumns\">{{ col.colName }} &nbsp;<small><strong>{{ col.colType }}</strong></small></md-option></md-select></md-input-container><section class=\"w100 mb-0\"><table class=table><thead><tr><th colspan=4><md-input-container class=\"w100 mb-0\"><label>Series</label><md-select ng-disabled=\"ctrl.config.table == null\" ng-model=ctrl.serieSelected ng-change=ctrl.onSelectSerie()><md-option ng-value=col.colName ng-repeat=\"col in ctrl.tableColumns\">{{ col.colName }}</md-option></md-select></md-input-container></th></tr><tr><th>Series</th><th>Type</th><th style=\"width: 1%\">-</th></tr></thead><tbody><tr ng-repeat=\"serie in ctrl.config.series track by $index\"><td>{{ serie.name }}</td><td><select ng-model=serie.type class=w100><option ng-repeat=\"type in ctrl.chartTypes\">{{ type }}</option></select></td><td><md-button ng-click=ctrl.removeSerie($index) class=\"md-fab md-mini red\"><md-icon md-font-set=material-icons>delete</md-icon></md-button></td></tr></tbody></table></section></md-content>");
$templateCache.put("app/home/widgets/data-management-chart/data-management-chart.html","<div id=tbl-chart ng-if=\"ctrl.props.table &amp;&amp; ctrl.props.schema\"><div layout=row layout-padding class=widget-box-header><div flex><h3 class=m0><strong>{{ ctrl.props.title }}</strong></h3></div></div><section layout=row layout-padding><div flex>table: &nbsp;<strong>{{ ctrl.props.table }}</strong></div><div flex><md-switch ng-model=ctrl.isOnline aria-label=rule style=\"justify-content: flex-end\" ng-change=onChangeOnline() class=m0><strong>{{ ctrl.isOnline ? \'on line\' : \'off\' }}</strong></md-switch></div></section><section layout=row layout-padding><div flex><md-button ng-click=ctrl.filterTableManagement()>Filter</md-button><div ng-repeat=\"predicate in ctrl.predicates track by $index\" style=\"margin-right: 8px\" ng-click=ctrl.removePredicate($index) class=\"badge grey\">{{ predicate.fieldName }} {{ predicate.operation }} : {{ predicate.operation === \'BETWEEN\' ? predicate.values : predicate.value }}<md-icon>close</md-icon></div></div></section><div id=\"{{ ctrl.widgetName }}\" style=\"height: 300px\" class=w100></div></div>");
$templateCache.put("app/home/widgets/data-management-table/config-data-management-table.html","<md-content><md-input-container class=\"w100 mb-0\"><input ng-model=ctrl.config.title placeholder=title required></md-input-container><md-input-container class=\"w100 mb-0\"><label>Schemas</label><md-autocomplete md-selected-item=ctrl.config.schema md-search-text=searchTextSchema md-selected-item-change=ctrl.schemaItemChange(item) md-floating-label=schema md-require-match=true md-items=\"item in ctrl.querySearchSchema(searchTextSchema)\" md-item-text=item md-min-length=0 placeholder=schema input-aria-describedby=schema required><md-item-template><span md-highlight-text=ctrl.searchTextSchema md-highlight-flags=^i>{{ item }}</span></md-item-template><md-not-found>No states matching \"{{ ctrl.searchTextSchema }}\" were found</md-not-found></md-autocomplete></md-input-container><md-input-container class=\"w100 mb-0\"><label>Tables</label><md-autocomplete ng-disabled=\"ctrl.config.schema == null\" md-selected-item=ctrl.config.table md-search-text=searchTextTable md-selected-item-change=ctrl.tableItemChange(item) md-floating-label=table md-require-match=true md-items=\"item in ctrl.querySearchTable(searchTextTable)\" md-item-text=item md-min-length=0 placeholder=table input-aria-describedby=table required><md-item-template><span md-highlight-text=ctrl.searchTextTable md-highlight-flags=^i>{{ item }}</span></md-item-template><md-not-found>No states matching \"{{ ctrl.searchTextTable }}\" were found</md-not-found></md-autocomplete></md-input-container><md-input-container class=\"w100 mb-0\"><label>Columns</label><md-select ng-model=ctrl.config.columns multiple required><md-optgroup label=columns><md-option ng-value=col.colName ng-repeat=\"col in ctrl.tableColumns\">{{ col.colName }}</md-option></md-optgroup></md-select></md-input-container><md-input-container class=\"w100 mb-0\"><label>Rules</label><md-autocomplete ng-disabled=\"ctrl.config.table == null\" md-selected-item=ctrl.config.rule md-search-text=searchTextRule md-floating-label=Rule md-require-match=true md-items=\"item in ctrl.querySearcRule(searchTextRule)\" md-item-text=item.name md-min-length=0 placeholder=Rule input-aria-describedby=Rule required><md-item-template><span md-highlight-text=ctrl.searchTextRule md-highlight-flags=^i>{{ item.name }}</span></md-item-template><md-not-found>No states matching \"{{ ctrl.searchTextRule }}\" were found</md-not-found></md-autocomplete></md-input-container></md-content>");
$templateCache.put("app/home/widgets/data-management-table/data-management-table.html","<div ng-if=\"ctrl.props.table &amp;&amp; ctrl.props.schema\"><div layout=row layout-padding class=widget-box-header><div flex><h3 class=m0><strong>{{ ctrl.props.title }}</strong></h3></div></div><section layout=row layout-padding><div flex>table: &nbsp;<strong>{{ ctrl.props.table }}</strong></div><div flex><md-switch ng-model=ctrl.rule.active aria-label=rule style=\"justify-content: flex-end\" ng-change=onChangeStatusRule() ng-disabled=ctrl.loading class=m0>Rule: &nbsp;<strong>{{ ctrl.props.rule.name }} &nbsp;</strong>{{ ctrl.rule.active ? \"active\" : \"inactive\" }}</md-switch></div></section><table-data table-name=\"{{ ctrl.props.table }}\" schema-name=\"{{ ctrl.props.schema }}\" is-widget=true widget-config=ctrl.props container=\"li-{{ ctrl.type }}\"></table-data></div>");
$templateCache.put("app/home/widgets/executions/executions.html","<div style=\"padding: 1.3em\" layout=column class=\"m0 h100\"><h4 class=widget-box-header>{{ ctrl.translation.executions }}</h4><md-list flex style=\"overflow: scroll\"><md-list-item ng-if=ctrl.loading style=\"height: 245px\" class=w100><div class=w100><p>{{ ctrl.translation.loading }} {{ ctrl.translation.executions | lowercase }}</p><md-progress-linear md-mode=indeterminate></md-progress-linear><br></div></md-list-item><md-list-item ng-if=\"!ctrl.executions.length &amp;&amp; !ctrl.loading\" class=w100><div class=\"w100 text-center\"><md-icon md-font-set=material-icons md-menu-align-target class=text-warning>info</md-icon><b>{{ ctrl.translation.without_executions }}</b></div></md-list-item><md-list-item layout=row layout-padding=\"\" ng-if=\"ctrl.executions.length &gt; 0 &amp;&amp; !ctrl.loading\" style=\"position: sticky; top: -10px; background: #fff; z-index: 3\" class=p0><div flex=30 md-truncate>{{ ctrl.translation.name | capitalize }}</div><div flex=20 class=text-center>{{ ctrl.translation.start | capitalize }}</div><div flex=20 class=text-center>{{ ctrl.translation.finish | capitalize }}</div><div flex=15 class=text-right>{{ ctrl.translation.time | capitalize }}</div><div flex=15 class=text-right>{{ ctrl.translation.status | capitalize }}</div></md-list-item><md-list-item ng-if=!ctrl.loading ng-repeat=\"execution in ctrl.executions | orderBy:&quot;-startTime&quot;\" layout=row class=p0><div flex=30 md-truncate><span><span ng-if=execution.errorMessage><md-tooltip>{{ execution.errorMessage.split(\':\')[0] }}</md-tooltip>⚠️ &nbsp;</span><a href=rules/editor/{{execution.functionId}}/execution/{{execution.executionId}} target=_blank class=link><b>{{ execution.functionName }} &nbsp;</b><span>{{ execution.versionTitle }}</span></a></span></div><div flex=20 class=text-center>{{ execution.startTime | moment: \"DD-MM-YYYY HH:mm:ss\" }}</div><div flex=20 class=text-center>{{ execution.finishTime | moment: \"DD-MM-YYYY HH:mm:ss\" }}</div><div flex=15 class=text-right><b>{{ execution.executionTime | padLeft: 4 }} {{ execution.executionTimeLabel }}</b></div><div flex=15 class=text-right><b ng-if=\"execution.status == &quot;error&quot;\" class=text-danger>Error<md-icon md-font-set=material-icons class=text-danger>error_outline</md-icon></b><b ng-if=\"execution.status == &quot;finished&quot;\" class=text-success>Finished<md-icon md-font-set=material-icons class=text-success>done_all</md-icon></b><b ng-if=\"execution.status == &quot;initialized&quot;\" class=orange-text>Initialized<md-icon md-font-set=material-icons class=orange-text>alarm</md-icon></b></div></md-list-item></md-list><md-progress-linear ng-if=ctrl.autoRefresh md-mode=determinate value=\"{{ ctrl.determinateValue }}\"></md-progress-linear><pagination pagination=ctrl.request.pagination ng-if=!ctrl.loading on-click=ctrl.onChangedPage(page)></pagination><md-button href=rules abm-component=abm-component class=\"md-primary md-raised\">{{ ctrl.translation.go_to }} {{ ctrl.translation.rules | lowercase }}</md-button></div>");
$templateCache.put("app/home/widgets/executions-chart/executions-chart.html","<div style=\"padding: 1.3em\" layout=column class=\"executions-chart m0 h100\"><h4 class=widget-box-header>{{ ctrl.props.title }}</h4><div id={{ctrl.widgetName}} style=\"height: 85%\"></div><md-progress-linear ng-if=ctrl.autoRefresh md-mode=determinate value=\"{{ ctrl.determinateValue }}\"></md-progress-linear><pagination pagination=ctrl.request.pagination ng-if=!loading on-click=ctrl.getExecutions(page)></pagination><md-button href=rules abm-component=abm-component class=\"md-primary md-raised\">{{ ctrl.translation.go_to }} {{ ctrl.translation.rules | lowercase }}</md-button></div>");
$templateCache.put("app/home/widgets/executions-form/config-executions-form.html","<md-content><md-input-container class=\"w100 mb-0\"><input ng-model=ctrl.form.title placeholder=title required></md-input-container><md-input-container class=\"w100 mb-0\"><label>Rules</label><md-autocomplete md-selected-item=ctrl.form.rule md-search-text=searchTextRule md-selected-item-change=ctrl.ruleItemChange(item) md-floating-label=Rule md-require-match=true md-items=\"item in ctrl.querySearchRule(searchTextRule)\" md-item-text=item.name md-min-length=0 placeholder=Rule input-aria-describedby=Rule required><md-item-template><span md-highlight-text=searchTextRule md-highlight-flags=^i>{{ item.name }}</span></md-item-template><md-not-found>No states matching \"{{ searchTextRule }}\" were found</md-not-found></md-autocomplete></md-input-container><div ng-if=ctrl.form.rule><p>description: &nbsp;<strong>{{ ctrl.form.rule.description }}</strong></p><p>ACTIVE:&nbsp;<strong>{{ ctrl.form.rule.active }}</strong></p><p>REALTIME:&nbsp;<strong>{{ ctrl.form.rule.realtime }}</strong></p><p>TYPECHECK:&nbsp;<strong>{{ ctrl.form.rule.typeCheck }}</strong></p><p ng-if=ctrl.liveVersion>LIVEVERSION:&nbsp;<small>{{ ctrl.liveVersion.id }} - &nbsp;</small><strong>{{ ctrl.liveVersion.title }}</strong></p></div><table ng-if=\"ctrl.form.rule &amp;&amp; ctrl.form.schema\" class=\"table table-striped table-hover\"><thead><tr><th colspan=4>Schema</th></tr><tr><th>Name</th><th>Type</th><th>Required</th><th>Visible</th></tr></thead><tbody><tr ng-repeat=\"(key, value) in ctrl.schema\"><td>{{ key }}: &nbsp;</td><td><strong>{{ value.type }}</strong></td><td><strong>{{ value.required }}</strong></td><td><strong>{{ value.visible }}</strong></td></tr></tbody></table><div ng-if=\"!ctrl.form.rule &amp;&amp; !ctrl.form.schema\"><p>No rule dont have schema</p></div></md-content>");
$templateCache.put("app/home/widgets/executions-form/executions-form.html","<form name=executionform ng-submit=ctrl.execute() style=\"padding: 1.3em; max-height: -webkit-fill-available; overflow: auto\"><h4 class=widget-box-header>{{ ctrl.props.title }}</h4><h5 ng-if=ctrl.rule>Rule name:<strong>{{ ctrl.rule.name }}</strong></h5><small ng-if=ctrl.rule>Schema name:<strong>{{ ctrl.rule.schema.name }}</strong></small><md-progress-linear md-mode=indeterminate ng-if=\"!ctrl.permissionError &amp;&amp; ctrl.loading === true\"></md-progress-linear><md-content flex layout=column ng-if=ctrl.permissionError><div class=text-center><br><md-icon style=\"font-size: 50px\" class=\"md-warn md-hue-1\">warning</md-icon><br><p>{{ ctrl.permissionError.message }}</p></div></md-content><div ng-if=\"!ctrl.permissionError &amp;&amp; ctrl.loading === false\"><div ng-repeat=\"(groupName , inputs) in ctrl.form track by $index\"><h6><strong>{{ groupName }}</strong></h6><hr style=\"margin: 0 0 18px 0\"><md-content class=\"md-padding form-grid\"><section ng-repeat=\"input in inputs track by $index\" class=form-input-grid><md-input-container ng-switch=input.type class=\"w100 p0 m0\"><label ng-if=\"![\'lookup\',\'reference\', \'sequential\'].includes(input.type)\" for=\"{{ input.name }}\">{{ input.displayName }} ({{ input.type }}) {{ input.required ? \"*\" : \"\" }}</label><span ng-switch-when=reference><issue-reference-selector model=input.attributeValue field=input key=input.name style=\"position: relative; top: -19px\" ng-required=input.required disabled name=\"{{ input.name }}\"></issue-reference-selector></span><span ng-switch-when=sequential><issue-sequential-selector model=input.attributeValue field=input key=input.name style=\"position: relative; top: -19px\" ng-required=input.required disabled name=\"{{ input.name }}\"></issue-sequential-selector></span><span ng-switch-when=autoincrement><input ng-model=input.attributeValue disabled name=\"{{ input.name }}\"></span><span ng-switch-when=string|url ng-switch-when-separator=|><input ng-if=\"input.format!=\'textarea\'\" ng-model=input.attributeValue ng-required=input.required ng-disabled=\"input.readonly || ctrl.loading || ctrl.permissionError\" name=\"{{ input.name }}\"><textarea ng-if=\"input.format==\'textarea\'\" ng-required=input.required ng-disabled=\"input.readonly || ctrl.loading || ctrl.permissionError\" name=\"{{ input.name }}\">{{ input.attributeValue }}</textarea></span><span ng-switch-when=integer|double|long ng-switch-when-separator=|><input type=text ng-model=input.attributeValue style=\"padding: 0 10px\" autocomplete=off ng-required=input.required ng-disabled=\"input.readonly || ctrl.loading || ctrl.permissionError\" cep-number-mask numeric-type=input.type name=\"{{ input.name }}\"></span><span ng-switch-when=date ng-class=\"{ \'read-only\': input.readonly || ctrl.loading || ctrl.permissionError }\"><input type=date ng-model=input.attributeValue ng-model-options=\"{ timezone: \'utc\' }\" ng-disabled=\"input.readonly || ctrl.loading || ctrl.permissionError\" ng-required=input.required name=\"{{ input.name }}\" class=w100></span><span ng-switch-when=time ng-class=\"{ \'read-only\': input.readonly || ctrl.loading || ctrl.permissionError }\"><input type=time ng-model=input.attributeValue ng-disabled=\"input.readonly || ctrl.loading || ctrl.permissionError\" ng-required=input.required name=\"{{ input.name }}\" class=md-input></span><spam ng-switch-when=timestamp ng-class=\"{ \'read-only\': input.readonly || ctrl.loading || ctrl.permissionError }\"><input type=datetime-local ng-model=input.attributeValue ng-disabled=\"input.readonly || ctrl.loading || ctrl.permissionError\" ng-required=input.required name=\"{{ input.name }}\" class=md-input></spam><span ng-switch-when=boolean><md-switch ng-model=input.attributeValue aria-label=\"{{ input.title }} ({{ input.type }})\" ng-disabled=\"input.readonly || ctrl.loading || ctrl.permissionError\" ng-required=input.required name=\"{{ input.name }}\">{{ input.attributeValue ? \"true\" : \"false\" }}</md-switch></span><spam ng-switch-default>{{ input.name }} ({{ input.type }})</spam></md-input-container></section></md-content></div><div layout=column style=\"position: sticky; bottom: 0\"><md-button type=submit has-permission=function#{{ctrl.props.rule.id}}:run class=\"md-raised md-primary\">Save and execute</md-button></div></div></form>");
$templateCache.put("app/home/widgets/indicators-list/indicators-list.html","<div style=\"padding: 1.3em\" layout=column class=\"m0 h100\"><h4 class=widget-box-header>{{ ctrl.props.list.description }}</h4><md-content flex layout=column ng-if=ctrl.permissionError><div class=text-center><br><md-icon style=\"font-size: 50px\" class=\"md-warn md-hue-1\">warning</md-icon><br><p>{{ ctrl.permissionError.message }}</p></div></md-content><section flex layout=row layout-align=\"center center\" class=w100><div id=\"{{ ctrl.widgetName }}\" style=\"height: 85%\" class=w100></div></section></div>");
$templateCache.put("app/home/widgets/issues-bar-chart/issues-bar-chart.html","<div style=\"padding: 2.5em 1.3em\" layout=column class=\"m0 h100\"><md-content flex layout=column ng-if=ctrl.permissionError><div class=text-center><br><md-icon style=\"font-size: 50px\" class=\"md-warn md-hue-1\">warning</md-icon><br><p>{{ ctrl.permissionError.message }}</p></div></md-content><md-content flex layout=column ng-if=\"!ctrl.isLoading &amp;&amp; !ctrl.permissionError\"><section flex layout=row layout-align=\"center center\" class=w100><div id=\"{{ ctrl.widgetName }}\" style=\"height: 85%\" class=\"w100 widget-box-header\"></div></section><section layout=row layout-align=\"space-between center\" style=\"margin-right: 5px; height: 72px\"><section flex layout=row layout-align=\"start center\"><div flex=20><md-input-container class=\"no-padding-no-margin w100\"><select ng-model=ctrl.interval aria-label=\"Interval Selector\" ng-change=ctrl.reloadInterval() class=select-filters-modal><option ng-repeat=\"interval in ctrl.intervalDateFormat\" value=\"{{ interval.value }}\">{{ interval.label }}</option></select></md-input-container></div><div flex=40><md-input-container class=\"no-padding-no-margin w100\"><select ng-model=ctrl.props.user aria-label=\"User Selector\" class=select-filters-modal><option value=false>&nbsp;</option><option ng-repeat=\"user in ctrl.users\" value=\"{{ user.value }}\">{{ user.label }}</option></select></md-input-container></div></section><div flex=20 style=\"text-align: right\"><spam style=\"font-weight: 600\">{{ ctrl.category.name }} / {{ ctrl.issue.name }}</spam></div></section></md-content></div>");
$templateCache.put("app/home/widgets/issues-chart/issues-chart.html","<div style=\"padding: 2.5em 1.3em\" layout=column class=\"m0 h100\"><md-content flex layout=column><section flex layout=row layout-align=\"center center\" class=\"w100 widget-box-header\"><div id=\"{{ ctrl.widgetName }}\" style=\"height: 85%\" class=w100></div></section><section layout=row layout-align=\"space-between center\" style=\"margin-right: 5px; height: 72px\"><div flex></div><div flex=20 style=\"text-align: right\"><spam style=\"font-weight: 600\">{{ ctrl.category.name }} / {{ ctrl.issue.name }}</spam></div></section></md-content></div>");
$templateCache.put("app/home/widgets/list-charts/list-charts.html","<div get-height class=\"m0 h100 chart-view-container\"><h4 style=\"padding: 1rem 0 0 2rem\" class=widget-box-header><a href=chart/{{ctrl.chart.id}} target=_blank><md-icon md-font-set=material-icons md-menu-align-target style=\"margin-right: 1rem\">open_in_new</md-icon>{{ ctrl.chart.name }}</a></h4><md-content ng-if=ctrl.loading><md-progress-linear md-mode=indeterminate></md-progress-linear></md-content><md-content ng-if=ctrl.permissionError.show><div class=text-center><br><md-icon style=\"font-size: 50px\" class=\"md-warn md-hue-1\">warning</md-icon><br><p>{{ ctrl.permissionError.message }}</p></div></md-content><md-content ng-if=\"ctrl.chart &amp;&amp; ctrl.chart.id\" style=\"overflow: hidden\" class=h100><div id=\"{{ ctrl.widgetName }}\" class=w100><span ng-if=\"ctrl.loading==false\" style=\"outline: 1px solid red\"><chart-view chart-id=ctrl.chart.id is-widget=true show-chart-table-view=ctrl.props.display_table show-chart-labels=ctrl.props.display_labels show-chart-filters-dialog=ctrl.props.display_filters chart-height=ctrl.height></chart-view></span><md-progress-linear ng-if=\"ctrl.loading==true\" md-mode=indeterminate></md-progress-linear></div></md-content></div>");
$templateCache.put("app/home/widgets/list-details/config-list-details.html","<md-content><md-input-container class=\"w100 mb-0\"><input ng-model=ctrl.form.title placeholder=title required></md-input-container><md-input-container class=\"w100 mb-0\"><label>Main List</label><md-autocomplete md-selected-item=ctrl.form.mainTable md-search-text=searchTextList md-selected-item-change=ctrl.mainTableItemChange(item) md-require-match=true md-items=\"item in ctrl.querySearchList(searchTextList)\" md-item-text=item.name md-min-length=0 placeholder=list input-aria-describedby=list required><md-item-template><span md-highlight-text=searchTextList md-highlight-flags=^i>{{ item.name }}</span></md-item-template><md-not-found>No states matching \"{{ searchTextList }}\" were found</md-not-found></md-autocomplete></md-input-container><md-tabs md-stretch-tabs=always dinamic-height><md-tab label=list ng-if=ctrl.form.mainTable><md-content><p>List: &nbsp;<span>{{ ctrl.form.mainTable.is }}</span><strong>{{ ctrl.form.mainTable.name }}</strong></p><p>Schema:&nbsp;<strong>{{ ctrl.form.mainTable.schema.name }}</strong></p><p>Total Records:&nbsp;<strong>{{ ctrl.form.mainTable.totalRecords }}</strong></p></md-content></md-tab><md-tab label=schema ng-if=\"ctrl.form.mainTable &amp;&amp; ctrl.form.schema\"><md-content><div style=\"max-height: 280px; overflow: auto\"><table class=\"table table-striped table-hover\"><thead><tr style=\"position: sticky; top: 0; z-index: 2; background: white !important\"><th colspan=4>Schema</th></tr><tr style=\"position: sticky; top: 35px; z-index: 1; background: white !important\"><th>Name</th><th>Type</th><th>list</th></tr></thead><tbody><tr ng-repeat=\"(key, value) in ctrl.schema\"><td>{{ key }}: &nbsp;</td><td><strong>{{ value.type }}</strong></td><td><div ng-if=\"value.type === \'lookup\'\"><md-button ng-class=\"{ \'md-raised md-primary\' : ctrl.form.lookupTable.id === value.metadata.id }\" ng-click=ctrl.onSelectLookup(key,value) class=m0><strong>{{ value.metadata.name }}</strong></md-button></div><div ng-if=\"value.type != \'lookup\'\"><strong>-</strong></div></td></tr></tbody></table></div></md-content></md-tab></md-tabs><md-tabs md-stretch-tabs=always dinamic-height><md-tab label=\"Link list\" ng-if=ctrl.form.mainTable><md-content><div ng-if=ctrl.form.mainTable><md-checkbox ng-model=ctrl.uselistlink aria-label=\"Use List Link\" ng-change=ctrl.uselistlinkChange>Link a list</md-checkbox></div><div ng-if=\"ctrl.form.mainTable &amp;&amp; ctrl.uselistlink\"><md-input-container class=\"w100 mb-0\"><label>Linked List</label><md-autocomplete md-selected-item=ctrl.form.listlink.listid md-search-text=searchTextLinkList md-selected-item-change=ctrl.linkTableItemChange(item) md-require-match=true md-items=\"item in ctrl.querySearchLinkList(searchTextLinkList)\" md-item-text=item.name md-min-length=0 placeholder=list input-aria-describedby=list required><md-item-template><span md-highlight-text=searchTextLinkList md-highlight-flags=^i>{{ item.name }}</span></md-item-template><md-not-found>No states matching \"{{ searchTextLinkList }}\" were found</md-not-found></md-autocomplete></md-input-container><div layout=row ng-if=ctrl.form.listlink.listid><p>Filter relation</p></div><div layout=row ng-if=ctrl.form.listlink.listid><div flex><md-input-container class=w100><label>Main list schema</label><md-select ng-model=ctrl.form.listlink.maincolumn required><md-option ng-repeat=\"(key, value) in ctrl.schema\" ng-value=value.name>{{ value.name }}</md-option></md-select></md-input-container></div><div flex><md-input-container class=w100><label>Linked list schema</label><md-select ng-model=ctrl.form.listlink.linkcolumn required><md-option ng-repeat=\"(key, value) in ctrl.linkListSchema\" ng-value=value.name>{{ value.name }}</md-option></md-select></md-input-container></div></div></div></md-content></md-tab><md-tab label=\"Link to rule\" ng-if=ctrl.form.mainTable><md-content><div ng-if=ctrl.form.mainTable><md-checkbox ng-model=ctrl.userulelink aria-label=\"Use Rule Link\" ng-change=ctrl.userulelinkChange>Link to rule</md-checkbox></div><div ng-if=\"ctrl.form.mainTable &amp;&amp; ctrl.userulelink\"><md-input-container class=\"w100 mb-0\"><label>Linked Rule</label><md-autocomplete md-selected-item=ctrl.form.rulelink md-search-text=searchTextRuleList md-selected-item-change=ctrl.ruleTableItemChange(item) md-require-match=true md-items=\"item in ctrl.querySearchRuleList(searchTextRuleList)\" md-item-text=item.name md-min-length=0 placeholder=rule input-aria-describedby=rule required><md-item-template><span md-highlight-text=searchTextRuleList md-highlight-flags=^i>{{ item.name }}</span></md-item-template><md-not-found>No states matching \"{{ searchTextRuleList }}\" were found</md-not-found></md-autocomplete></md-input-container><div layout=row ng-if=ctrl.form.rulelink.ruleid><p>Filter relation</p></div><div layout=row ng-if=ctrl.form.rulelink.ruleid><div flex><md-input-container class=w100><label>Main list schema</label><md-select ng-model=ctrl.form.rulelink.maincolumn required><md-option ng-repeat=\"(key, value) in ctrl.schema\" ng-value=key>{{ key }}</md-option></md-select></md-input-container></div><div flex><md-input-container class=w100><label>Linked rule schema</label><md-select ng-model=ctrl.form.rulelink.linkcolumn required><md-option ng-repeat=\"(key, value) in ctrl.ruleLinkSchema\" ng-value=key>{{ key }}</md-option></md-select></md-input-container></div></div></div></md-content></md-tab></md-tabs><div ng-if=\"!ctrl.form.mainTable &amp;&amp; !ctrl.form.schema\"><p>No rule dont have schema</p></div></md-content>");
$templateCache.put("app/home/widgets/list-details/list-details.html","<div style=\"padding: 1.3em\" layout=column class=\"m0 h100\"><h4 class=widget-box-header><div class=\"fa fa-list-ol\"></div>&nbsp;&nbsp;<b>{{ ctrl.props.title }}</b></h4><md-content ng-if=ctrl.isLoading><div class=\"w100 text-center\"><p>{{ translation.loading }}</p><md-progress-linear md-mode=indeterminate></md-progress-linear><br></div></md-content><md-content><md-content flex layout=column ng-if=ctrl.permissionError><div class=text-center><br><md-icon style=\"font-size: 50px\" class=\"md-warn md-hue-1\">warning</md-icon><br><p>{{ ctrl.permissionError.message }}</p></div></md-content><md-content ng-if=ctrl.isLoading><md-progress-linear></md-progress-linear></md-content><div ng-if=\"ctrl.isLoading === false &amp;&amp; !ctrl.permissionError\"><div ui-grid-pagination ui-grid-resize-columns ui-grid-auto-resize ui-grid-expandable ui-grid=ctrl.gridOptions ng-style=\"{ height: ctrl.size.height }\" class=widget-list-details></div><div id=menu-uno ng-if=ctrl.showContextMenu.show style=\"{{ ctrl.showContextMenu.style }}\" class=ng-ctx-menu><md-list flex=\"\" class=\"p0 m0\"><md-subheader>Linked list</md-subheader><md-list-item ng-repeat=\"list in ctrl.linkedLists\" ng-click=\"ctrl.loadLookUpData(list.row, [list.lookup,list.value])\">{{ list.name }}: {{ list.value }}</md-list-item></md-list></div></div></md-content></div>");
$templateCache.put("app/home/widgets/list-details/sub-list-details.html","<md-dialog id=sub-list-details aria-label=sub-list-details style=\"width: 80vw\"><md-toolbar><div class=md-toolbar-tools><h2>{{ ctrl.lookup.lookupmatch }}: <strong>{{ ctrl.lookup.searchValue }}</strong></h2><span flex></span><md-button ng-click=ctrl.cancel($event) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content><div ui-grid=ctrl.gridOptions style=\"width: 100%;height: 230px\" class=listGrid></div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/home/widgets/list-reader/list-reader.html","<div style=\"padding: 1.3em\" layout=column class=\"m0 h100\"><h4 class=widget-box-header><div class=\"fa fa-list-ol\"></div>&nbsp;&nbsp;<b>{{ ctrl.props.list.name }}</b>&nbsp; {{ translation.Segmented_by }} &nbsp;<b>{{ ctrl.props.list.group }} &nbsp; {{ ctrl.props.list.label }}</b></h4><p>Top: {{ ctrl.props.list.top }}</p><md-content flex layout=column ng-if=ctrl.permissionError><div class=text-center><br><md-icon style=\"font-size: 50px\" class=\"md-warn md-hue-1\">warning</md-icon><br><p>{{ ctrl.permissionError.message }}</p></div></md-content><md-content ng-if=ctrl.isLoading><div class=\"w100 text-center\"><p>{{ translation.loading }}</p><md-progress-linear md-mode=indeterminate></md-progress-linear><br></div></md-content><md-content ng-if=\"!ctrl.isLoading &amp;&amp; !ctrl.permissionError\"><md-list ng-if=\"ctrl.list.length &gt; 0\"><md-list-item ng-repeat=\"item in ctrl.list | orderBy:[\'riskIndex\',\'-val\'] | limitTo:limit\" layout=row style=\"min-height: 0; height: 30px\"><div flex><a ng-click=viewTable(ctrl.props.list.listId,item.name)>{{ item.name }}</a></div><div flex=40 class=text-right>{{ item.riskName }} &nbsp; {{ item.val }} &nbsp;<div tipo-event-text=\"{{ item.riskName }}\" class=\"fa fa-circle\"></div></div></md-list-item></md-list><div ng-if=\"ctrl.list.length == 0\" class=\"w100 text-center\"><h5>{{ ctrl.list.lengt }}</h5><h5>sin datos</h5></div></md-content></div>");
$templateCache.put("app/home/widgets/list-searcher/list-searcher.html","<div style=\"padding: 1.3em\" layout=column aria-label=\"List searcher widget\" ng-cloak class=\"m0 h100\"><h4 layout=row class=widget-box-header><div flex>{{ ctrl.props.title || \'List Searcher\' }}</div></h4><md-content flex layout=column ng-if=ctrl.permissionError><div class=text-center><br><md-icon style=\"font-size: 50px\" class=\"md-warn md-hue-1\">warning</md-icon><br><p>{{ ctrl.permissionError.message }}</p></div></md-content><md-content flex layout=column ng-if=!ctrl.permissionError><section flex layout=column class=w100><md-progress-linear ng-if=ctrl.autoRefresh md-mode=determinate value=\"{{ ctrl.determinateValue }}\"></md-progress-linear><section layout=row><div ng-repeat=\"(key, predicate) in ctrl.filters.predicates\" style=\"margin-right: 5px; font-size: 0.7em; line-height: 2em\" class=\"text-center cep-badge\">{{ predicate.label }}: {{ predicate.value != null ? predicate.value : predicate.valuesLabels.join(\', \') }}<div style=\"margin-left: 5px\" ng-click=ctrl.removeFilter(key) class=\"fa fa-times\"></div></div><div ng-if=ctrl.isFiltered ng-click=ctrl.unFilterData() style=\"margin-right: 5px; font-size: 0.7em; line-height: 2em\" class=\"text-center cep-badge\">{{ ctrl.translation.remove_filters }}</div></section><div id=\"{{ ctrl.widgetName }}\" style=\"height: 75%\" class=w100><div ui-grid-auto-resize ui-grid-pagination ui-grid-resize-columns ui-grid=ctrl.gridOptions style=\"height: 100%\" class=listGrid></div></div><div flex style=\"margin-top: 10px; padding: 5px; overflow-y: scroll\" ng-if=ctrl.statistics.length class=\"w100 cep-border\"><h4>{{ ctrl.translation.statistics }}</h4><div layout=row style=\"margin-top: 5px; padding: 0 10px\" ng-repeat=\"statistic in ctrl.statistics\"><div flex>{{ statistic.displayName }} / {{ statistic.aggregationType }}</div><div class=cep-badge>{{ statistic.value }}</div></div></div></section></md-content></div>");
$templateCache.put("app/home/widgets/replay-chart/replay-chart.html","<div style=\"padding: 2.5em 1.3em\" layout=column class=\"m0 h100\"><md-content flex=100 class=widget-box-header><div ng-if=\"ctrl.chart.type==\'LINE\'\"><chart-line-echarts chart=ctrl.chart is-dark=false></chart-line-echarts></div><div ng-if=\"ctrl.chart.type==\'BAR\'\"><chart-bar-echarts chart=ctrl.chart is-dark=false></chart-bar-echarts></div></md-content></div>");
$templateCache.put("app/home/widgets/risks/config-risks.html","<md-content><md-input-container class=\"w100 mb-0\"><label>title</label><input ng-model=ctrl.config.title placeholder=title required ng-disabled=ctrl.loading></md-input-container><md-input-container class=\"w100 mb-0\"><label>description</label><input ng-model=ctrl.config.description placeholder=description required ng-disabled=ctrl.loading></md-input-container><div ng-if=\"!ctrl.loading &amp;&amp; !ctrl.config.schemaName\" style=\"padding: 10px; margin: 10px 0; border-radius: 5px\" class=\"red white-text\"><h4>Schema <strong>{{ ctrl.defaultSchema }} </strong>not found</h4><p>Please, check data-management configuration</p></div><md-input-container ng-if=\"!ctrl.loading &amp;&amp; ctrl.config.schemaName\" class=\"w100 mb-0\"><label>TIPO_INDICADORS in schema &nbsp;<strong>{{ ctrl.config.schemaName }}</strong></label><md-autocomplete ng-if=!ctrl.loading md-selected-item=ctrl.config.tableName md-search-text=searchTable md-selected-item-change=ctrl.tableNameChange(item) md-require-match=true md-items=\"item in ctrl.queryTable(searchTable)\" md-item-text=item md-min-length=0 placeholder=tableNames input-aria-describedby=tableNames required ng-disabled=\"ctrl.loading || !ctrl.config.schemaName\"><md-item-template><span md-highlight-text=searchTable md-highlight-flags=^i>{{ item }}</span></md-item-template><md-not-found>No states matching \"{{ searchTable }}\" were found</md-not-found></md-autocomplete></md-input-container><br><br><table class=w100><thead><tr><th colspan=\"{{ ctrl.table.columns.length }}\"><strong>SELECT TIPO_INDICADOR</strong></th></tr><tr><th ng-repeat=\"column in ctrl.table.columns\" class=text-center>{{ column.colName }}</th></tr></thead><tbody><tr ng-repeat=\"row in ctrl.table.data\" ng-click=ctrl.rowClick(row) ng-class=\"{ \'second-color white-text\': ctrl.config.gridName == row.name }\"><td ng-repeat=\"column in ctrl.table.columns\" class=text-center>{{ row[column.colName] }}</td></tr></tbody></table><br><div></div><md-input-container class=\"w100 mb-0\"><label>SELECT DATA</label><md-autocomplete ng-if=!ctrl.loading md-selected-item=ctrl.config.dataSource md-search-text=searchDataSource md-selected-item-change=ctrl.dataSourceChange(item) md-require-match=true md-items=\"item in ctrl.queryDataSource(searchDataSource)\" md-item-text=item md-min-length=0 placeholder=dataSources input-aria-describedby=dataSources required ng-disabled=\"ctrl.loading || !ctrl.config.schemaName\"><md-item-template><span md-highlight-text=searchDataSource md-highlight-flags=^i>{{ item }}</span></md-item-template><md-not-found>No states matching \"{{ searchDataSource }}\" were found</md-not-found></md-autocomplete></md-input-container><br><br><md-input-container class=\"w100 mb-0\"><label>Select a type</label><md-select ng-if=!ctrl.loading ng-model=ctrl.config.type ng-disabled=!ctrl.config.dataSource required><md-option ng-repeat=\"type in ctrl.risksTypes\" ng-value=type>{{ type }}</md-option></md-select></md-input-container><md-progress-linear md-mode=indeterminate ng-if=ctrl.loading></md-progress-linear></md-content>");
$templateCache.put("app/home/widgets/risks/risks.html","<div style=\"padding: 1.3em\" layout=column class=\"m0 h100\"><h4 class=widget-box-header><div class=\"fa fa-list-ol\"></div>&nbsp;&nbsp;<b>{{ ctrl.props.title }}</b></h4><p>{{ ctrl.props.description }}</p><md-content ng-if=\"ctrl.props &amp;&amp; ctrl.props.schemaName &amp;&amp; ctrl.props.tableName &amp;&amp; ctrl.props.gridName &amp;&amp; ctrl.props.dataSource &amp;&amp; ctrl.props.type\"><risk-view config=ctrl.props></risk-view></md-content></div>");
$templateCache.put("app/home/widgets/rules-queue/rules-queue.html","<div style=\"padding: 1.3em\" layout=column class=\"m0 h100\"><h4 class=widget-box-header>{{ ctrl.translation.queued_executions }}</h4><md-content flex layout=column ng-if=ctrl.permissionError><div class=text-center><br><md-icon style=\"font-size: 50px\" class=\"md-warn md-hue-1\">warning</md-icon><br><p>{{ ctrl.permissionError.message }}</p></div></md-content><md-list flex style=\"overflow: scroll\"><md-list-item ng-if=loading style=\"height: 245px\" class=w100><div class=w100><p>{{ ctrl.translation.loading }} {{ ctrl.translation.executions | lowercase }}</p><md-progress-linear md-mode=indeterminate></md-progress-linear><br></div></md-list-item><md-list-item ng-if=\"!ctrl.executions.length &amp;&amp; !loading\" class=w100><div class=\"w100 text-center\"><md-icon md-font-set=material-icons md-menu-align-target class=text-warning>info</md-icon><b>{{ ctrl.translation.without_queue }}</b></div></md-list-item><md-list-item layout=row layout-padding=\"\" ng-if=\"ctrl.executions.length &gt; 0 &amp;&amp; !loading\" style=\"position: sticky; top: -10px; background: #fff; z-index: 3\" class=p0><div flex=35 md-truncate>{{ ctrl.translation.name | capitalize }}</div><div flex=25 class=text-center>{{ ctrl.translation.submit_at | capitalize }}</div><div flex=30 class=text-center>{{ ctrl.translation.estimated_finish | capitalize }}</div><div flex=10 class=text-center>{{ ctrl.translation.order | capitalize }}</div><div flex=10 class=text-center></div></md-list-item><md-list-item ng-repeat=\"execution in ctrl.executions track by $index\" layout=row layout-padding=\"\" ng-if=!loading class=p0><div flex=35 md-truncate><b>{{ execution.functionName }}</b><br><span>{{ execution.versionTitle }}</span></div><div flex=35 class=text-center>{{ execution.submitTime | moment: \'DD-MM-YYYY HH:mm:ss\' }}</div><div flex=20 class=text-right>{{ execution.executionEstimatedFinishMilis | msToTime }}</div><div flex=10 class=text-center>{{ execution.executionOrder }}<md-progress-linear ng-if=\"$index === 0\"></md-progress-linear></div><div flex=10 class=text-center><md-button ng-click=ctrl.stopExecution(execution) aria-label=\"Stop rule execution rule button\" class=md-icon-button><md-tooltip md-direction=bottom>Stop Executión</md-tooltip><md-progress-circular md-diameter=20px style=\"margin: 0 auto\" ng-if=ctrl.isStoping class=md-hue-2></md-progress-circular><md-icon ng-if=!ctrl.isStoping md-font-set=material-icons md-menu-align-target class=text-warning>cancel</md-icon></md-button></div></md-list-item></md-list><md-progress-linear ng-if=ctrl.autoRefresh md-mode=determinate value=\"{{ ctrl.determinateValue }}\"></md-progress-linear><pagination pagination=ctrl.request.pagination ng-if=!loading on-click=ctrl.getExecutions(page)></pagination><md-button href=rules abm-component=abm-component class=\"md-primary md-raised\">{{ ctrl.translation.go_to }} {{ ctrl.translation.rules | lowercase }}</md-button></div>");
$templateCache.put("app/home/widgets/work-queue/work-queue.html","<div style=\"padding: 1.3em\" layout=column class=\"m0 h100\"><h4 class=widget-box-header>{{ translation.work_queue }}</h4><md-content flex layout=column ng-if=ctrl.permissionError><div class=text-center><br><md-icon style=\"font-size: 50px\" class=\"md-warn md-hue-1\">warning</md-icon><br><p>{{ ctrl.permissionError.message }}</p></div></md-content><md-list flex style=\"overflow: scroll\" ng-if=!ctrl.permissionError><md-list-item ng-if=loading style=\"height: 245px\" class=w100><div class=w100><p>{{ translation.loading }} {{ translation.executions | lowercase }}</p><md-progress-linear md-mode=indeterminate></md-progress-linear><br></div></md-list-item><md-list-item ng-if=\"!ctrl.executions.length &amp;&amp; !loading\" class=w100><div class=\"w100 text-center\"><md-icon md-font-set=material-icons md-menu-align-target class=text-warning>info</md-icon><b>{{ translation.without_task }}</b></div></md-list-item><md-list-item ng-repeat=\"execution in ctrl.executions track by $index\" layout=row layout-padding=\"\" class=p0><div md-truncate><b>{{ execution.simpleName }}<span style=\"margin: 5px\" class=cep-badge>{{ execution.size }}</span><md-icon ng-if=\"execution.remove==\'true\'\" md-font-set=material-icons md-menu-align-target ng-click=ctrl.removeTask(execution.canonicalName) class=text-raised>delete</md-icon></b></div></md-list-item></md-list><md-progress-linear ng-if=ctrl.autoRefresh md-mode=determinate value=\"{{ ctrl.determinateValue }}\"></md-progress-linear></div>");
$templateCache.put("app/input-list/components/list-filters/list-filters.html","<md-dialog aria-label=\"{{ translation.add_list }}\"><form name=filterListForm ng-submit=\"filterListForm.$valid &amp;&amp; filter()\" novalidate><md-dialog-content style=min-width:700px;max-width:800px;max-height:810px><md-content layout=column><div class=md-padding><div><b>{{ selectedCol }}</b>({{ colTypes[selectedCol] }}) - {{ translation.filter_by }} {{ translation.condition | lowercase }}</div><div layout=row><md-input-container flex=40><select ng-model=filterCondition name=filterCondition ng-change=isValueRequired(); aria-label=\"Filter operation field\" class=select-filters-modal><option ng-repeat=\"operation in operations\" value=\"{{ operation.operation }}\" ng-disabled=\"{{ operation.disabled }}\">{{ translation[operation.title] }}</option></select><div ng-messages=filterListForm.filterCondition.$error><div ng-message=required>{{ translation.field_required }}</div></div></md-input-container><md-input-container flex=80 ng-if=\"![\'date\', \'time\', \'timestamp\'].includes(colTypes[selectedCol]) &amp;&amp; !autocomplete\"><label>Value</label><input ng-model=$parent.filterConditionValue name=filterConditionValue ng-required=$parent.valueRequired autocomplete=off aria-label=\"Filter value field\"><div ng-messages=filterListForm.filterConditionValue.$error><div ng-message=required>{{ translation.field_required }}</div></div></md-input-container><md-input-container flex ng-if=\"[\'date\', \'timestamp\'].includes(colTypes[selectedCol])\"><label>Date</label><input mdc-datetime-picker=\"\" date=true time=false type=text short-time=true show-todays-date=true click-outside-to-close=true placeholder=Date auto-ok=true format=\"{{ colTypes[selectedCol] == &quot;timestamp&quot; ? $parent.dateFormat[0] : $parent.dateFormat }}\" ng-model=$parent.filterConditionValue edit-input=false show-icon=true ng-model-options=\"{timezone: &quot;utc&quot;}\" class=md-input></md-input-container><md-input-container flex ng-if=\"[\'time\', \'timestamp\'].includes(colTypes[selectedCol])\"><label>Time</label><input mdc-datetime-picker date=false seconds=true type=text short-time=false show-todays-date=false click-outside-to-close=true placeholder=Time auto-ok=true minute-steps=1 format=\"{{ colTypes[selectedCol] == &quot;timestamp&quot; ? $parent.dateFormat[1] : $parent.dateFormat }}\" ng-model=$parent.filterConditionValue edit-input=false show-icon=true ng-model-options=\"{timezone: &quot;utc&quot;}\" class=md-input></md-input-container><div flex ng-if=\"![\'date\', \'time\', \'timestamp\'].includes(colTypes[selectedCol]) &amp;&amp; autocomplete\"><md-autocomplete flex required md-input-name=autocompleteField md-input-minlength=1 md-no-cache=false md-selected-item=selectedItem md-search-text=$parent.filterConditionValue md-items=\"item in querySearch($parent.filterConditionValue)\" md-item-text=item md-require-match=false md-floating-label=\"Value (autocomplete)\" input-aria-describedby=\"Value autocomplete\"><md-item-template><span md-highlight-text=$parent.filterConditionValue>{{ item }}</span><div ng-messages=searchForm.autocompleteField.$error ng-if=searchForm.autocompleteField.$touched><div ng-message=required>{{ translation.field_required }}</div><div ng-message=minlength>Your entry is not long enough.</div></div></md-item-template></md-autocomplete></div></div></div><md-divider></md-divider></md-content></md-dialog-content><md-dialog-actions><md-button ng-click=cancel() class=md-raised>{{ translation.cancel }}</md-button><md-button type=submit class=\"md-raised md-primary\">{{ translation.apply }}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/input-list/components/list-format/list-format.html","<md-dialog aria-label=\"{{ translation.add_list }}\"><form name=listFormatForm ng-submit=\"listFormatForm.$valid &amp;&amp; ctrl.save()\" novalidate><md-dialog-content style=min-width:600px;max-width:800px;max-height:810px><md-content layout=column><div class=md-padding><div layout=row><b class=md-title>{{ translation.column_format_config_title }}</b><span flex class=flex></span><round-button on-click=ctrl.cancel() aria-label=Close icon=clear></round-button></div><md-divider></md-divider><div><md-list><md-list-item layout=row><div flex=50>{{ translation.col }}</div><div flex=50>inputFormat</div><div flex=50>outputFormat</div></md-list-item><md-list-item layout=row ng-repeat=\"(key, column) in ctrl.schema\" ng-if=ctrl.inputFormats[column.type].length><div flex=50><b>{{ key }} &nbsp;</b><span>({{ column.type }})</span></div><md-input-container flex=50 style=\"margin:10px 0 20px 0\"><select ng-model=ctrl.schema[key].inputFormat aria-label=\"Input format field\" class=select-filters-modal><option ng-repeat=\"value in ctrl.inputFormats[column.type]\" value=\"{{ value }}\">{{ value }}</option></select></md-input-container><md-input-container flex=50 style=\"margin:10px 0 20px 0\"><select ng-model=ctrl.schema[key].outputFormat aria-label=\"Output format field\" class=select-filters-modal><option ng-repeat=\"value in ctrl.outputFormats[column.type]\" value=\"{{ value }}\">{{ value }}</option></select></md-input-container><div><md-button ng-click=\"ctrl.bindFormat(key, column.type)\" style=\"top: -5px\" aria-label=\"Bind formats button\" class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>link</md-icon><md-tooltip>{{ ctrl.translation.bindFormatTooltip }}</md-tooltip></md-button></div></md-list-item></md-list></div></div><md-divider></md-divider></md-content></md-dialog-content><md-dialog-actions><md-button ng-click=ctrl.cancel() class=md-raised>{{ translation.cancel }}</md-button><md-button type=submit class=\"md-raised md-primary\">{{ translation.apply }}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/input-list/components/list-replace/list-replace.html","<md-dialog aria-label=\"{{ translation.add_list }}\"><form name=filterReplaceForm ng-submit=\"filterReplaceForm.$valid &amp;&amp; findAndReplace()\" novalidate><md-dialog-content style=min-width:700px;max-width:800px;max-height:810px><md-content layout=column><div class=md-padding><div><b>{{ selectedCol }}</b>({{ colTypes[selectedCol] }}) - {{ translation.find_and_replace }}</div><br><div layout=row><md-input-container flex=80><label>Value</label><input ng-model=cellValue name=filterConditionValue ng-required=true autocomplete=off aria-label=\"Value to replace\"><div ng-messages=filterReplaceForm.filterConditionValue.$error><div ng-message=required>{{ translation.field_required }}</div></div></md-input-container></div><div layout=row><md-input-container flex=80><label>{{ translation.replace_with }}</label><input ng-model=replaceValue name=replaceValue ng-required=true autocomplete=off aria-label=\"Replace value\"><div ng-messages=filterReplaceForm.replaceValue.$error><div ng-message=required>{{ translation.field_required }}</div></div></md-input-container></div></div><md-divider></md-divider></md-content></md-dialog-content><md-dialog-actions><span ng-if=recordsReplaced>{{ translation.records_replaced }} : {{ recordsReplaced }}</span><md-button ng-click=close() class=md-raised>{{ translation.close }}</md-button><md-button type=submit class=\"md-raised md-primary\">{{ translation.apply }}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/issues/components/comments/comments.html","<section style=max-height:200x;overflow:auto><article layout=row layout-align=\"start center\" layout-padding=\"\"><div flex=90 response=true class=chat><b class=m0>OMARTINEZ</b><p style=text-align:justify class=m0>You\'ve mentioned the reasons for changing the name. But what were the reasons for holding onto the old name so long?</p><p class=\"m0 text-right\"><b>Oct 14, 2019</b></p></div></article><article layout=row layout-align=\"end center\" layout-padding=\"\"><div flex=90 response=false class=chat><b class=m0>OMARTINEZ</b><p style=text-align:justify class=m0>You\'ve mentioned the reasons for changing the name. But what were the reasons for holding onto the old name so long?</p><p class=\"m0 text-right\"><b>Oct 14, 2019</b></p></div></article><article layout=row layout-align=\"start center\" layout-padding=\"\"><div flex=90 response=true class=chat><b class=m0>OMARTINEZ</b><p style=text-align:justify class=m0>You\'ve mentioned the reasons for changing the name. But what were the reasons for holding onto the old name so long?</p><p class=\"m0 text-right\"><b>Oct 14, 2019</b></p></div></article></section><section layout=row layout-padding=\"\" layout-align=\"end center\"><div flex=80><md-input-container class=w100><label>mensaje</label><textarea ng-model=message md-maxlength=150 rows=2 md-select-on-focus=\"\"></textarea></md-input-container></div><div flex=20><md-button class=md-raised>Agregar</md-button></div></section>");
$templateCache.put("app/issues/components/evidences/evidences.html","<section layout=row layout-wrap=\"\" layout-padding=\"\"><div flex=100><p>Transferencias bancarias</p></div><div flex=50><p>Cuenta emisor:<b>6661112222</b></p></div><div flex=50><p>Cuenta receptor:<b>3334551111</b></p></div><div flex=50><p>Nombres y apellidos emisor:<b>Pedro Perez</b></p><p>Nombres y apellidos receptor:<b>Andres Iniesta</b></p></div><div flex=50><uploader label=\"carga mas eviencias\" url=issues/evidencias valid=pdf></uploader></div><div flex=100><md-icon md-font-set=material-icons>arrow_right</md-icon>PDF capture movimientos de cuenta</div><div flex=100><md-icon md-font-set=material-icons>arrow_right</md-icon>PDF capture movimientos de cuenta</div><div flex=100><md-icon md-font-set=material-icons>arrow_right</md-icon>PDF capture movimientos de cuenta</div></section><section layout=row layout-align=\"end center\"><md-button class=md-raised><md-icon md-font-set=material-icons>add</md-icon>Agregar</md-button></section>");
$templateCache.put("app/issues/components/historical/historical.html","<section layout=row layout-wrap=\"\" layout-padding=\"\"><div flex=100 style=\"border-bottom: 1px solid #565656\"><b class=pull-right>Oct 14, 2019</b><h4><md-icon md-font-set=material-icons>account_circle</md-icon>OMARTINEZ</h4><p>has edited the issue....</p></div><div flex=100 style=\"border-bottom: 1px solid #565656\"><b class=pull-right>Oct 14, 2019</b><h4><md-icon md-font-set=material-icons>account_circle</md-icon>OMARTINEZ</h4><p>has edited the issue</p></div><div flex=100 style=\"border-bottom: 1px solid #565656\"><b class=pull-right>Oct 14, 2019</b><h4><md-icon md-font-set=material-icons>account_circle</md-icon>OMARTINEZ</h4><p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dolorum porro quod non error, officiis tempora. Provident facere est accusantium exercitationem ipsum eius veniam asperiores, aliquid nobis totam a nostrum similique!</p></div></section>");
$templateCache.put("app/issues/components/linkedIssues/linkedIssues.html","<section layout=row layout-wrap=\"\" layout-padding=\"\"><div flex=100 style=\"border-bottom: 1px solid #565656\"><p><md-icon md-font-set=material-icons>bookmark</md-icon>#10 - MOVIMIENTOS SOSPECHOSO EN CUENTA DE AHORRO</p></div><div flex=100 style=\"border-bottom: 1px solid #565656\"><p><md-icon md-font-set=material-icons>bookmark</md-icon>#10 - MOVIMIENTOS SOSPECHOSO EN CUENTA DE AHORRO</p></div></section>");
$templateCache.put("app/lists/components/create-list/dialog-create-list.html","<md-dialog aria-label=\"Dialog create list\"><form><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{actionText + listName}}</h2><span flex></span><md-button ng-click=cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-width: 800px; max-width: 800px; max-height: 810px\"><md-tabs md-dynamic-height md-border-bottom><md-tab label={{translation.general}} md-on-select=\"activeTab = \'info\'\"><md-content class=md-padding><div layout=row style=\"border-bottom: 1px solid #e0e0e0; margin-top: 10px\"><md-input-container flex=50 class=\"m0 p0\"><md-switch name=generateLucene ng-model=generateLucene style=\"position:relative; top:-15px\" aria-label=\"generate lucene\" class=\"m0 p0 md-primary\">{{ translation.lucene }}</md-switch></md-input-container></div><div layout=row><md-input-container flex=50><label>{{translation.name}}</label><input ng-model=listName name=listName aria-label={{translation.name}} required></md-input-container><div flex><md-autocomplete md-selected-item=selectedSchemaObject md-require-match=true md-floating-label=Schema md-search-text=searchText md-items=\"item in querySearch(searchText)\" md-item-text=item.name md-min-length=0 md-clear-button=true md-selected-item-change=getSelectedSchema(item.id)><md-item-template><span md-highlight-text=searchText md-highlight-flags=^i>{{item.name}}</span></md-item-template></md-autocomplete></div></div><div layout=row><div flex=45><label>Group</label><div ng-if=\"loadingDialog == false\"><span>{{listGroups }}</span><md-button ng-click=moveItemGroup() class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>folder_copy</md-icon><md-tooltip>Move</md-tooltip></md-button></div><div ng-if=\"loadingDialog == true\"><md-progress-circular md-mode=indeterminate md-diameter=20px></md-progress-circular><br></div></div><div flex=45 style=\"margin-left: 5px\"><div>{{translation.schema}}</div><div><ul><li ng-repeat=\"(key, item) in selectedSchema\"><b>{{key}}</b>({{item.type}})<span ng-if=item.pk>[pk]</span><span ng-if=item.required>[required]</span><span ng-if=item.ref><md-icon md-font-set=material-icons>keyboard_arrow_right<md-tooltip>Reference</md-tooltip></md-icon>{{item.ref}}</span><span ng-if=item.description>&nbsp;- {{item.description}}</span></li></ul></div></div></div></md-content></md-tab></md-tabs></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button ng-click=cancel() class=md-raised>{{translation.cancel}}</md-button><md-button ng-click=createList($event) class=md-raised>{{translation.save}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/lists/components/lists-group-item/lists-group-item.html","<md-list-item style=\"border-bottom: 1px solid #dedcdc\" ng-click=ctrl.toggleItems() class=\"md-3-line item-report\"><div layout=row layout-align=\"center center\" layout-padding><div><md-icon ng-if=\"ctrl.displayItems==false\" md-font-set=material-icons class=color-data>folder_open</md-icon><md-icon ng-if=\"ctrl.displayItems==true\" md-font-set=material-icons class=color-data>folder</md-icon></div><div><h3><b>{{ ctrl.group.groupName }}:&nbsp;</b></h3><span><b>{{ ctrl.group.subGroup.length }}&nbsp;</b>Folders</span>&nbsp; &nbsp;<span><b>{{ ctrl.group.items.length }}&nbsp;</b>Items</span></div></div><md-button style=\"padding: 0.8rem\" aria-label=\"Display items button\" title=\"Toggle group\" class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>{{ ctrl.displayItems ? \'keyboard_arrow_up\' : \'keyboard_arrow_down\' }}</md-icon></md-button></md-list-item><section ng-show=\"ctrl.group.isOpen==true\" style=\"margin: 0px 0px 0px 4rem; border-left: 4px solid rgb(202 196 196)\"><div><md-list-item style=\"border-bottom: 1px solid #eaeaea; padding: 1.8rem\" class=md-2-line><div layout=row class=md-list-item-text><md-button has-permission=list:create ng-click=ctrl.showGroupCreateListDialog($event) aria-label=\"Add list button\"><md-icon md-font-set=material-icons>add</md-icon><b>{{ ctrl.translation.add_list }}</b></md-button><md-button has-permission=list:read ng-click=\"ctrl.bulkExportLists(0, &quot;xlsx&quot;)\" aria-label=\"Bulk export lists (.csv .xlsx)\"><div style=\"color: gray; font-size: 1.5em; position: relative; top: 2px\" class=\"fa fa-files-o\"></div><b>{{ ctrl.translation.export }} (.csv .xlsx)</b><md-progress-linear md-mode=indeterminate ng-if=\"ctrl.exportingLists == &quot;xlsx&quot;\"></md-progress-linear></md-button></div></md-list-item></div><div ng-repeat=\"group in ctrl.group.subGroup\"><lists-group-item group=group schemas=ctrl.schemas translation=ctrl.translation display-items=ctrl.displayItems></lists-group-item></div><div ng-repeat=\"item in ctrl.group.items\"><lists-list-item item=item schemas=ctrl.schemas translation=ctrl.translation></lists-list-item></div></section>");
$templateCache.put("app/lists/components/lists-list-item/lists-list-item.html","<md-list-item id=list-{{ctrl.item.listId}} style=\"border-bottom: 1px solid #eaeaea; padding: 1.8rem\" data-name=\"{{ ctrl.item.name }}\" role=listitem class=md-2-line><div layout=column class=md-list-item-text>{{ ctrl.item.listId }} -<b>{{ ctrl.item.name }}<span ng-if=ctrl.item.sequencial>- {{ ctrl.translation.sequential }}</span></b><span>{{ ctrl.translation.schema }}: {{ ctrl.item.schema.name }}</span><span>{{ ctrl.translation.entries }}: {{ ctrl.item.totalRecords }}</span><md-button ng-if=ctrl.item.updatingData style=\"padding: 0.8rem\" aria-label=\"Updating indicator\" layout=row class=\"md-secondary text-main-color\"><md-progress-circular md-mode=indeterminate md-diameter=20 style=\"margin-right: 3px\"></md-progress-circular><span>{{ ctrl.translation.updating_list_msg }}</span></md-button><md-button has-permission=list#{{ctrl.item.listId}}:read ng-click=ctrl.viewTable(ctrl.item.listId) style=\"padding: 0.8rem\" aria-label=\"{{ ctrl.translation.edit }}\" class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>table_rows</md-icon><md-tooltip>{{ ctrl.translation.reading }}</md-tooltip></md-button><md-button has-permission=list#{{ctrl.item.listId}}:update ng-click=ctrl.viewList(ctrl.item.listId) style=\"padding: 0.8rem\" aria-label=\"{{ ctrl.translation.edit }}\" role=button-list-view class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>launch</md-icon><md-tooltip>{{ ctrl.translation.edition }}</md-tooltip></md-button><md-button role=button-list-edit has-permission=list#{{ctrl.item.listId}}:update ng-click=\"ctrl.showCreateListDialog($event, ctrl.item)\" style=\"padding: 0.8rem\" aria-label=\"{{ ctrl.translation.edit }}\" class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>edit</md-icon><md-tooltip>{{ ctrl.translation.edit }}</md-tooltip></md-button><md-button has-permission=schema#{{ctrl.item.schema.id}}:read ng-click=\"ctrl.showSchemaDialog($event, ctrl.item.schema)\" style=\"padding: 0.8rem\" aria-label=\"{{ ctrl.translation.edit }}\" class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>assignment</md-icon><md-tooltip>Schema</md-tooltip></md-button><md-button has-permission=list#{{ctrl.item.listId}}:delete ng-click=\"ctrl.deleteList($event, ctrl.item)\" style=\"padding: 0.8rem\" aria-label=\"{{ ctrl.translation.delete }}\" role=button-list-delete class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>delete</md-icon><md-tooltip>{{ ctrl.translation.delete }}</md-tooltip></md-button><md-button has-permission=list#{{ctrl.item.listId}}:share ng-click=\"ctrl.showShareEntityDialog($event, ctrl.item)\" style=\"padding: 0.8rem\" aria-label=\"{{ ctrl.translation.share }}\" class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>share</md-icon><md-tooltip>{{ ctrl.translation.share }}</md-tooltip></md-button><md-button has-permission=list#{{ctrl.item.listId}}:read ng-click=\"ctrl.exportList(ctrl.item, \'xlsx\')\" style=\"padding: 0.8rem\" aria-label=\"{{ ctrl.translation.share }}\" class=\"md-icon-button md-secondary text-main-color\"><div style=\"color: gray; font-size: 1.5em; position: relative; top: 2px\" ng-if=\"ctrl.exportingList != \'xlsx\'\" class=\"fa fa-files-o\"></div><md-progress-circular md-diameter=20px style=\"margin: 0 auto\" ng-if=\"ctrl.exportingList == \'xlsx\'\" class=md-hue-2></md-progress-circular><md-tooltip>{{ ctrl.translation.export }} (.csv .xlsx)</md-tooltip></md-button><btn-bookmark style=\"padding: 0.8rem\" entity-id=ctrl.item.listId entity-name=ctrl.item.name entity-type=\"\'list\'\" role=button-list-bookmark has-permission=list#{{ctrl.item.listId}}:read class=\"md-icon-button md-secondary text-main-color md-button md-ink-ripple\"></btn-bookmark></div></md-list-item>");
$templateCache.put("app/main/components/main-menu/main-menu.html","<div id=modal-menu ng-class=\"{ &quot;out&quot; : !menu.isOpen }\" ng-show=menu.isOpen class=five><div class=modal-menu-backdrop><div id=dashboardCloseMainMenu aria-label=\"close Menú\" ng-click=menu.toggleMenu() class=\"modal-menu-close fa fa-times\"></div><md-card layout=row layout-padding=\"\" layout-wrap=\"\" class=\"modal-menu-content p0\"><div id=no-menu ng-if=menu.noMenu flex=100><div class=\"text-center white-text bold-text\"><md-icon style=\"font-size: 48px\" class=white-text>warning</md-icon><h4>{{ translation.no_menu_items }}</h4><p>{{ translation.no_menu_items_info }}</p></div></div><div flex=25 ng-repeat=\"ele in menu.mainMenu\" ng-init=\"parentIndex = $index\" ng-if=\"menu.validatePermission(ele.hasPermission) &amp;&amp; ele.url !== &quot;docs&quot; &amp;&amp; ele.show === true \" class=modal-menu-btn><a ng-class=\"{ deshabilitado: !menu.existeFiltro() }\" href=\"{{ ele.submenu.rutes.length &gt; 0 ? &quot;&quot; : ele.url }}\" aria-label=menuitem-{{ele.id}} class=\"modal-menu-card {{ ele.submenu.rutes.length &gt; 0 ? &quot;canflip&quot; : &quot;zzzz&quot; }}\"><div class=modal-menu-card-front><br><cep-icon icon=\"cep-menu-{{ ele.icon }}\" scale=3></cep-icon><h4>{{ ele.name }}</h4></div><div ng-if=\"ele.submenu.rutes.length &gt; 0\" class=modal-menu-card-back><div layout=row ng-repeat=\"item in ele.submenu.rutes track by $index\" ng-if=menu.validatePermission(item.hasPermission) class=layout-align-space-between-stretch><md-button href=\"{{ item.url }}\" ng-click=\"menu.isOpen = false\" aria-label=submenuitem style=\"text-align: left;flex-grow: 1\" ng-class=\"{ deshabilitado: !menu.existeFiltro() }\" class=\"btn text-left m0\"><span ng-switch on=ele.id><cep-icon ng-switch-when=issues icon=\"{{ item.cepIcon }}\" color=\"{{ item.cepColor }}\"></cep-icon><cep-icon ng-switch-when=custom-reports icon=\"{{ item.icon }}\"></cep-icon><cep-icon ng-switch-default icon=\"cep-menu-{{ item.icon }}\"></cep-icon></span><b style=\"font-size: 1.3em\">{{ item.name }}</b></md-button><md-button ng-if=\"ele.submenu.rutes.length &gt; 0\" data-fav=\"{{ item.url }}\" ng-click=\"toggleFav(parentIndex, $index)\" aria-label=submenufavitem class=\"md-icon-button m0\"><div class=\"fa fa-star {{ item.fav ? &quot;orange-text&quot; : &quot;grey-text&quot; }}\"></div><md-tooltip md-direction=top>Add Fav.</md-tooltip></md-button></div></div></a><md-button ng-if=\"ele.submenu.rutes.length == 0\" data-fav=\"{{ ele.url }}\" ng-click=toggleFav(parentIndex) aria-label=menufavitem class=\"btn-fav md-icon-button\"><div class=\"fa fa-star {{ ele.fav ? &quot;orange-text&quot; : &quot;grey-text&quot; }}\"></div><md-tooltip md-direction=top>Add Fav.</md-tooltip></md-button></div><div flex=25 ng-repeat=\"ele in menu.mainMenu\" ng-init=\"parentIndex = $index\" ng-if=\"menu.validatePermission(ele.hasPermission) &amp;&amp; ele.url === &quot;docs&quot;\" class=modal-menu-btn><a target=_blank href=docs/ onclick=\"return window.open(this.href, &quot;_blank&quot;)\" aria-label=menuitem-docs class=modal-menu-card><div class=modal-menu-card-front><br><cep-icon icon=\"cep-menu-{{ ele.icon }}\" scale=3></cep-icon><h4>{{ ele.name }}</h4></div></a><md-button data-fav=docs ng-click=toggleFav(parentIndex) aria-label=menufavitem class=\"btn-fav md-icon-button\"><div class=\"fa fa-star {{ ele.fav ? &quot;orange-text&quot; : &quot;grey-text&quot; }}\"></div><md-tooltip md-direction=top>Add Fav.</md-tooltip></md-button></div></md-card></div></div>");
$templateCache.put("app/main/components/notification/notification.html","<md-button ng-click=toggleNoty($event) style=\"min-width: 45px\" aria-label=\"togle notifications button\" class=\"p0 text-center\"><md-icon ng-if=!ctrl.loading md-font-set=material-icons ng-class=\"{ &quot;text-second-color&quot;: ctrl.notificationsCount &gt; 0 ,&quot;grey-text&quot;: !ctrl.hasUnreadNotifications , &quot;swing&quot;:ctrl.hasUnreadNotifications }\" class=\"animated infinite\">{{ ctrl.notificationsCount > 0 ? \'notifications_active\' : \'notifications_none\' }}</md-icon><span ng-if=\"!ctrl.loading &amp;&amp; ctrl.notificationsCount &gt; 0\" class=\"badge second-color\">{{ ctrl.notificationsCount }}</span></md-button><div ng-class=\"{ &quot;is-open&quot;: isOpen }\" class=noti-menu-wrap><section layout=column><div flex><div layout=row layout-align=\"end center\" layout-padding style=\"padding: 0px 12px\"><div flex style=\"font-size: 1.5rem\" class=\"p0 grey-text\"><strong>{{ translation.notifications }}</strong></div><div flex style=\"font-size: 1.3rem\" class=\"p0 text-right grey-text\"><p ng-if=ctrl.hasUnreadNotifications><strong>{{ translation.markAllAsRead }}</strong><md-icon md-font-set=material-icons ng-click=ctrl.markAllAsRead()>message</md-icon></p></div></div><div layout=row layout-align=\"end center\" layout-padding style=\"padding: 0px 12px\"><div flex style=\"font-size: 1.3rem\" class=\"p0 grey-text\"><md-checkbox ng-model=ctrl.allSelected aria-label=selectAll ng-change=ctrl.onSelectAll() class=checkbox-fix><strong>{{ ctrl.allSelected ? translation.unSelectAll : translation.selectAll }}</strong></md-checkbox></div><div flex=30 style=\"font-size: 1.3rem\" class=\"p0 grey-text\"><md-switch md-invert ng-model=ctrl.showonlyUnread aria-label=showonlyUnread ng-change=ctrl.onChangeShowonlyUnread() class=\"md-warn p0 m0\"><strong>{{ ctrl.showonlyUnread ? translation.showonlyUnread : translation.showonlyRead }}:</strong></md-switch></div></div></div><small flex ng-if=\"ctrl.notificationsTabs.length == 0\" class=\"black-text text-right\"><md-button aria-label=\"no noty\" class=\"w100 m0 text-center\">{{ translation.dontHaveNotifications }}</md-button></small><md-divider></md-divider><div flex><div layout=row layout-align=\"center center\"><div flex ng-repeat=\"tab in ctrl.notificationsTabs track by $index \" ng-if=\"tab.notifications.length &gt; 0\" ng-class=\"{ &quot;active-tab&quot;: ctrl.currentTab == $index }\"><md-button ng-click=ctrl.setab($index) class=\"w100 text-center m0\">{{ tab.name }} - {{ tab.pagination.totalRecords }}</md-button></div></div></div><md-divider></md-divider><notifications-list is-loading=ctrl.isLoading notifications=ctrl.currentNotifications pagination=ctrl.pagination load-more=ctrl.loadMore() refresh-list=ctrl.refreshList() translation=translation></notifications-list></section></div>");
$templateCache.put("app/main/components/risk-menu-item/risk-menu-item.html","<div ng-if=ctrl.mustShow><li ng-class=\"{deshabilitado: ctrl.mustDeactivate}\"><md-button href={{ctrl.appLink}} ng-click=\"main.clickMenu(\'{{ctrl.appName}}\')\" abm-component=abm-component class=\"btn btn-raised\"><i class=\"material-icons theme_color\">{{ctrl.menuIcon}}</i>&nbsp;{{ctrl.menuLabel}}</md-button></li></div>");
$templateCache.put("app/main/components/timezone-edition-dialog/timezone.template.html","<div tabindex=-1 role=dialog class=modal><div class=modal-dialog><div class=modal-content><div class=modal-header><a type=button abm-component ng-click=$hide() class=close>×</a><h4 class=modal-title>{{ translation.CAMBIO_ZH }}</h4></div><div class=modal-body><label>{{ translation.SELEC_ZH }}</label><md-autocomplete id=select-timezone required name=timeuser md-selected-item=timeuser md-search-text=searchText md-items=\"item in querySearch(searchText)\" md-clear-button=true md-item-text=item md-min-length=0 placeholder=\"choose from a list of timezones\" input-aria-labelledby=TimezoneS md-require-match=true><md-item-template><span md-highlight-text=searchText md-highlight-flags=^i>{{ item }}</span></md-item-template><md-not-found>{{ \"not found\" }} \"{{ searchText }}\".</md-not-found></md-autocomplete></div><div class=\"modal-footer recovery-footer\"><md-button type=button ng-click=updateUserTimezone() ng-disabled=loading class=\"md-raised green white-text\">{{ translation.GUARDAR }}</md-button><md-button type=button ng-click=$hide() ng-disabled=loading class=\"md-raised red white-text\">{{ translation.CANCELAR }}</md-button></div></div></div></div>");
$templateCache.put("app/main/components/user-documents/user-documents.html","<md-button ng-click=ctrl.toggleNoty($event) style=\"min-width: 45px\" aria-label=\"togle documents button\" class=\"p0 text-center\"><md-icon md-font-set=material-icons ng-class=\"{ \'blue-text\': ctrl.documents.length ,\'grey-text\': !ctrl.documents.length }\" class=\"animated infinite\">file_copy</md-icon><span ng-class=\"{ \'blue\': ctrl.documents.length ,\'grey\': !ctrl.documents.length, \'swing\':ctrl.newDocument }\" class=badge>{{ ctrl.documents.length }}</span><md-progress-linear md-mode=indeterminate ng-if=ctrl.hasInProgress></md-progress-linear></md-button><div ng-class=\"{ \'is-open\': ctrl.isOpen }\" class=noti-menu-wrap><md-progress-linear md-mode=indeterminate ng-if=ctrl.loading></md-progress-linear><section layout=row layout-align=\"center center\" style=\"padding: 0px 12px\"><div flex=80><div flex style=\"font-size: 1.5rem\" class=\"p0 grey-text\"><strong>Documents</strong></div></div></section><section layout=column ng-if=!ctrl.documents.length><div flex></div><div flex style=\"font-size: 1.3rem; padding: 1rem\" class=grey-text><strong>No documents available</strong></div></section><section ng-if=\"ctrl.documents.length &gt; 0 &amp;&amp; !ctrl.loading\"><div style=\"max-height: 500px; overflow-y: auto; overflow-x: hidden\"><div ng-repeat=\"document in ctrl.documents\"><document-card document=document></document-card></div></div><div><md-button ng-click=ctrl.cleanDocuments() class=\"w100 m0 p0 text-center\"><md-icon md-font-set=material-icons>delete</md-icon>clear old documents</md-button></div></section></div>");
$templateCache.put("app/realtime-rule-editor/components/rule-editor-canvas/rule-editor-canvas.template.html","<panzoom id=zoomCanvas config=ctrl.panZoom.config model=ctrl.panZoom.model style=\"height: 100%; overflow:hidden\" ng-show=true darken-mode=\"{{ ctrl.darkMode }}\" cep-editor-droppable class=\"realtime w100\"><div id=canvas-area class=\"canvas-wide jtk-surface\"><transformation-box ng-repeat=\"node in ctrl.rule.structure.nodes\" label=\"{{ node.label }}\" node=node rule=ctrl.rule editor=ctrl.editor on-transformation-created=ctrl.onTransformationCreated({}) click-handler=\"ctrl.onTransformationClicked({ id })\" dbl-click-handler=ctrl.onTransformationDoubleClicked() ctrl-click-handler=\"ctrl.onTransformationCtrlClicked({ elementId, transformationId })\"></transformation-box></div></panzoom>");
$templateCache.put("app/realtime-rule-editor/components/rule-editor-code/rule-editor-code.template.html","<div id=acePanel ng-model=ctrl.ruleStructureJson ui-ace=ctrl.editorConfig class=h100></div><md-button type=button ng-click=ctrl.saveChanges() aria-label=\"Save editor changes\" class=\"md-fab md-fab-bottom-right main-color\"><md-icon class=white-text>save</md-icon></md-button>");
$templateCache.put("app/realtime-rule-editor/components/rule-editor-toolbar/rule-editor-toolbar.html","<div class=rule-toolbar><md-menu-bar><md-menu><button id=rule-editor-window-menu ng-click=$mdMenu.open()>View</button><md-menu-content width=3><md-menu-item><md-button ng-click=\"ctrl.showCode = !ctrl.showCode\" aria-label=\"Toggle view button\"><div layout=row flex><p flex><b>{{ ctrl.showCode ? \"Editor View\" : \"Code View\" }}</b></p></div></md-button></md-menu-item><md-menu-item><md-button ng-click=ctrl.toggleTerminal() aria-label=\"Toggle terminal button\"><div layout=row flex><p flex><b>Terminal</b></p></div></md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.darkMode = !ctrl.darkMode\"><div layout=row flex><p flex><b>Dark Mode</b>&nbsp; - {{ ctrl.darkMode ? \"active\" : \"disabled\" }}</p></div></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-button ng-disabled=!ctrl.validatePermission(&quot;run&quot;) ng-click=ctrl.executeRule() aria-label=\"Execute rule button\" class=md-icon-button><md-tooltip md-direction=bottom>{{ ctrl.translation.execute }}</md-tooltip><md-progress-circular md-diameter=20px style=\"margin:0 auto\" ng-if=ctrl.onProgress class=md-hue-2></md-progress-circular><i class=\"fa fa-play cep_text\"></i></md-button><md-button ng-disabled=!ctrl.validatePermission(&quot;run&quot;) ng-click=ctrl.stopRule() aria-label=\"Stop rule execution rule button\" class=md-icon-button><md-tooltip md-direction=bottom>Stop Executión</md-tooltip><md-progress-circular md-diameter=20px style=\"margin:0 auto\" ng-if=ctrl.isStoping class=md-hue-2></md-progress-circular><i class=\"fa fa-stop red-text\"></i></md-button><md-button ng-click=ctrl.typeCheckRule() aria-label=\"Typecheck button\" class=md-icon-button><md-tooltip md-direction=bottom>Typecheck</md-tooltip><md-progress-circular md-diameter=20px style=\"margin:0 auto\" ng-if=ctrl.isTypeCheckInProgress() class=md-hue-2></md-progress-circular><i ng-if=\"!ctrl.isTypeCheckInProgress() &amp;&amp; ctrl.typeCheckState\" class=\"fa fa-check-circle green-text\"></i><i ng-if=\"!ctrl.isTypeCheckInProgress() &amp;&amp; !ctrl.typeCheckState\" class=\"fa fa-info-circle red-text\"></i></md-button><md-button ng-disabled=!ctrl.validatePermission(&quot;update&quot;) ng-click=ctrl.saveRule() aria-label=\"Save rule button\" class=md-icon-button><md-tooltip md-direction=bottom>{{ ctrl.translation.save }}</md-tooltip><i ng-if=!ctrl.isChanged class=\"fa fa-floppy-o green-text\"></i><i ng-if=ctrl.isChanged class=\"fa fa-floppy-o green-text\"></i></md-button><md-button ng-click=\"ctrl.loadFlowchart(); ctrl.showCode = !ctrl.showCode\" ng-disabled=!ctrl.showCode aria-label=\"Load pipeline button\" class=md-icon-button><md-tooltip md-direction=bottom>{{ ctrl.translation.load }}</md-tooltip><i class=\"fa fa-cloud-upload\"></i></md-button><div style=\"border-left:1px solid #e8e8e8;display:inline-block\"><md-button ng-click=ctrl.showProperties() aria-label=\"Show properties button\" class=md-icon-button><md-tooltip md-direction=bottom>{{ ctrl.translation.properties }}</md-tooltip><i class=\"fa fa-tasks\"></i></md-button></div><div style=\"border-left:1px solid #e8e8e8;align-self: flex-end\"><md-button ng-click=ctrl.clear($event) aria-label=\"Clear pipeline button\" class=\"md-icon-button reset\"><md-tooltip md-direction=bottom>{{ ctrl.translation.clear_all }}</md-tooltip><i class=\"fa fa-trash red-text\"></i></md-button></div></div>");
$templateCache.put("app/realtime-rule-editor/components/transformation-box/transformation-box.html","<div ng-cloak><span style=\"text-align: left; display: flex; user-select: none; pointer-events: none\"><p style=\"white-space: normal\" class=transform-label>{{ $ctrl.label }}</p></span></div>");
$templateCache.put("app/replay/component/includes/menu.html","<section layout=column><div layout=row layout-align=end><section layout=row style=\"font-size: .8em; text-decoration: underline\"><span style=\"padding: 9px\" ng-if=ctrl.filters.query[0].filter1.value>{{ ctrl.filters.query[0].filter1.name | capitalize }}: {{ ctrl.filters.query[0].filter1.value }}</span><span style=\"padding: 9px\" ng-if=ctrl.filters.query[0].filter2.value>{{ ctrl.filters.query[0].filter2.name | capitalize }}: {{ ctrl.filters.query[0].filter2.value }}</span><span style=\"padding: 9px\" ng-if=ctrl.filters.query[0].filter3.value>{{ ctrl.filters.query[0].filter3.name | capitalize }}: {{ ctrl.filters.query[0].filter3.value }}</span><span style=\"padding: 9px\" ng-if=ctrl.filters.query[0].filter1.min>{{ ctrl.filters.query[0].filter1.name | capitalize }}: Min {{ ctrl.filters.query[0].filter1.min }}</span><span style=\"padding: 9px\" ng-if=ctrl.filters.query[0].filter2.min>{{ ctrl.filters.query[0].filter2.name | capitalize }}: Min {{ ctrl.filters.query[0].filter2.min }}</span><span style=\"padding: 9px\" ng-if=ctrl.filters.query[0].filter3.min>{{ ctrl.filters.query[0].filter3.name | capitalize }}: Min {{ ctrl.filters.query[0].filter3.min }}</span><span style=\"padding: 9px\" ng-if=ctrl.filters.query[0].filter1.max>{{ ctrl.filters.query[0].filter1.name | capitalize }}: Max {{ ctrl.filters.query[0].filter1.max }}</span><span style=\"padding: 9px\" ng-if=ctrl.filters.query[0].filter2.max>{{ ctrl.filters.query[0].filter2.name | capitalize }}: Max {{ ctrl.filters.query[0].filter2.max }}</span><span style=\"padding: 9px\" ng-if=ctrl.filters.query[0].filter3.max>{{ ctrl.filters.query[0].filter3.name | capitalize }}: Max {{ ctrl.filters.query[0].filter3.max }}</span></section><md-button style=margin:0px aria-label=filter_list ng-click=\"shouldShowFilters = !shouldShowFilters\"><md-icon md-font-set=material-icons class=\"md-icon-button md-secondary\">filter_list</md-icon><span>{{translation.filters}} - ({{ctrl.totalPoints}}) points - {{ctrl.aggregate}}</span></md-button></div></section><md-sidenav md-component-id=menu-replay-sidebar md-disable-backdrop=false md-is-open=shouldShowFilters ng-cloak style=\"height: 89%;top: 11%\" class=md-sidenav-right><md-toolbar class=\"main-color isSticky inTop\"><div class=md-toolbar-tools><h2 flex=\"\" md-truncate=\"\">{{translation.filters}}</h2><md-button ng-click=\"shouldShowFilters = !shouldShowFilters\" class=\"md-fab md-mini\"><md-icon md-font-set=material-icons class=\"md-icon-button md-secondary\">close</md-icon></md-button></div></md-toolbar><md-content layout-padding=\"\"><div layout=row ng-if=\"ctrl.chart.seriesType == \'TIME\'\"><div flex=50><h5>From</h5><abm-form-group class=form-group><input style=\"max-width:100px; text-align:center\" type=text bs-datepicker placeholder=Desde ng-model=ctrl.startDate abm-form-control=\"\" data-min-date={{ctrl.desdeMinimo}} data-max-date={{ctrl.endDate}} data-autoclose=1 data-date-format=dd-MM-yyyy ng-change=ctrl.bDate() class=form-control></abm-form-group></div><div flex=50><h5>To</h5><abm-form-group class=form-group><input style=\"max-width:100px; text-align:center\" type=text bs-datepicker placeholder=Desde ng-model=ctrl.endDate abm-form-control=\"\" data-min-date={{ctrl.startDate}} data-max-date={{ctrl.endDate}} data-autoclose=1 data-date-format=dd-MM-yyyy ng-change=ctrl.bDate() class=form-control></abm-form-group></div></div><div layout=row layout-xs=column layout-wrap ng-if=\"ctrl.chart.seriesType == \'TIME\'\"><md-input-container flex=100><label>{{translation.time_interval}}</label><md-select ng-model=ctrl.filters.aggregate><md-option ng-value=item ng-repeat=\"item in ctrl.intervals\">{{item}}</md-option></md-select></md-input-container></div><div layout=row layout-xs=column layout-wrap ng-repeat=\"filter in ctrl.filters.query\"><fieldset ng-if=\"filter.filter1 || filter.filter2 || filter.filter3\" style=\"width: 100%;border: 1px solid #c0c0c0;padding-inline-start: 0.75em\" class=standard><legend style=\"width: auto;border: none\"><span style=\"font-size: 18px\">{{filter.name}}</span></legend><div layout=column><div ng-if=filter.filter1><div ng-if=\"filter.filter1.autocomplete == true\"><md-autocomplete md-floating-label=\"{{filter.filter1.name}} (autocomplete)\" md-input-name=autocompleteField placeholder=Search... md-no-cache=false md-selected-item=filter.filter1.value md-search-text=searchText md-items=\"text in ctrl.querySearchAutocomplete(searchText, filter.filter1, filter.shared)\" md-item-text=text md-min-length=0 md-escape-options=clear md-clear-button=true><md-item-template><span md-highlight-text=searchText>{{text}}</span></md-item-template><md-not-found>Without results for \"{{searchText}}\".</md-not-found></md-autocomplete></div><div ng-if=\"filter.filter1.autocomplete == false\"><div layout=row ng-if=\"filter.filter1.type.toLowerCase()==\'integer\'\"><md-input-container flex=30 class=m0><label>Min</label><input ng-model=filter.filter1.min md-maxlength=50 maxlength=50></md-input-container><span>&le; {{filter.filter1.name}} &le;</span><md-input-container flex=30 class=m0><label>Max</label><input ng-model=filter.filter1.max md-maxlength=50 maxlength=50></md-input-container></div><div ng-if=\"filter.filter1.type.toLowerCase()==\'double\'\"><md-input-container flex=50 class=m0><label>Min</label><input ng-model=filter.filter1.min md-maxlength=50 maxlength=50></md-input-container><span>&le; {{filter.filter1.name}} &le;</span><md-input-container flex=50 class=m0><label>Max</label><input ng-model=filter.filter1.max md-maxlength=50 maxlength=50></md-input-container></div><div ng-if=\"filter.filter1.type.toLowerCase()==\'string\'\" style=\"width: 95%\"><md-input-container flex=50 class=m0><label>{{filter.filter1.name}} (text)</label><input ng-model=filter.filter1.value md-maxlength=50 maxlength=50></md-input-container></div></div></div><div ng-if=filter.filter2><div ng-if=\"filter.filter2.autocomplete == true\"><md-autocomplete md-floating-label=\"{{filter.filter2.name}} (autocomplete)\" md-input-name=autocompleteField placeholder=Search... md-no-cache=false md-selected-item=filter.filter2.value md-search-text=searchText md-items=\"text in ctrl.querySearchAutocomplete(searchText, filter.filter2, filter.shared)\" md-item-text=text md-min-length=0 md-escape-options=clear md-clear-button=true><md-item-template><span md-highlight-text=searchText>{{text}}</span></md-item-template><md-not-found>Without results for \"{{searchText}}\".</md-not-found></md-autocomplete></div><div ng-if=\"filter.filter2.autocomplete == false\"><div layout=row ng-if=\"filter.filter2.type.toLowerCase()==\'integer\'\"><md-input-container flex=30 class=m0><label>Min</label><input ng-model=filter.filter2.min md-maxlength=50 maxlength=50></md-input-container><span>&le; {{filter.filter2.name}} &le;</span><md-input-container flex=30 class=m0><label>Max</label><input ng-model=filter.filter2.max md-maxlength=50 maxlength=50></md-input-container></div><div ng-if=\"filter.filter2.type.toLowerCase()==\'double\'\"><md-input-container flex=50 class=m0><label>Min</label><input ng-model=filter.filter2.min md-maxlength=50 maxlength=50></md-input-container><span>&le; {{filter.filter2.name}} &le;</span><md-input-container flex=50 class=m0><label>Max</label><input ng-model=filter.filter2.max md-maxlength=50 maxlength=50></md-input-container></div><div ng-if=\"filter.filter2.type.toLowerCase()==\'string\'\" style=\"width: 95%\"><md-input-container flex=50 class=m0><label>{{filter.filter2.name}} (text)</label><input ng-model=filter.filter2.value md-maxlength=50 maxlength=50></md-input-container></div></div></div><div ng-if=filter.filter3><div ng-if=\"filter.filter3.autocomplete == true\"><md-autocomplete md-floating-label=\"{{filter.filter3.name}} (autocomplete)\" md-input-name=autocompleteField placeholder=Search... md-no-cache=false md-selected-item=filter.filter3.value md-search-text=searchText md-items=\"text in ctrl.querySearchAutocomplete(searchText, filter.filter3, filter.shared)\" md-item-text=text md-min-length=0 md-escape-options=clear md-clear-button=true><md-item-template><span md-highlight-text=searchText>{{text}}</span></md-item-template><md-not-found>Without results for \"{{searchText}}\".</md-not-found></md-autocomplete></div><div ng-if=\"filter.filter3.autocomplete == false\"><div layout=row ng-if=\"filter.filter3.type.toLowerCase()==\'integer\'\"><md-input-container flex=30 class=m0><label>Min</label><input ng-model=filter.filter3.min md-maxlength=50 maxlength=50></md-input-container><span>&le; {{filter.filter3.name}}&le;</span><md-input-container flex=30 class=m0><label>Max</label><input ng-model=filter.filter3.max md-maxlength=50 maxlength=50></md-input-container></div><div ng-if=\"filter.filter3.type.toLowerCase()==\'double\'\"><md-input-container flex=50 class=m0><label>Min</label><input ng-model=filter.filter3.min md-maxlength=50 maxlength=50></md-input-container><span>&le; {{filter.filter3.name}} &le;</span><md-input-container flex=50 class=m0><label>Max</label><input ng-model=filter.filter3.max md-maxlength=50 maxlength=50></md-input-container></div><div ng-if=\"filter.filter3.type.toLowerCase()==\'string\'\" style=\"width: 95%\"><md-input-container flex=50 class=m0><label>{{filter.filter3.name}} (text)</label><input ng-model=filter.filter3.value md-maxlength=50 maxlength=50></md-input-container></div></div></div></div></fieldset></div></md-content><md-card-actions layout=row layout-align=\"end end\"><md-button ng-click=ctrl.cleanFilter() class=md-raised>{{translation.clean}}</md-button><md-button ng-click=ctrl.applyFilters() class=\"md-raised main-color white-text\">{{translation.apply_filter}}</md-button></md-card-actions></md-sidenav>");
$templateCache.put("app/replay/component/includes/skeleton-loader-series-config.html","<div layout=row layout-padding=\"\"><div flex=30><skeleton-loader></skeleton-loader></div><div flex=25><skeleton-loader></skeleton-loader></div><div flex=15><skeleton-loader></skeleton-loader></div><div flex=15><skeleton-loader></skeleton-loader></div><div flex=10><skeleton-loader></skeleton-loader></div></div><div layout=row layout-padding=\"\" layout-wrap=\"\" style=\"border-bottom:dashed 1px solid #eaeaea\"><div flex=50><skeleton-loader></skeleton-loader></div><div flex=50><skeleton-loader></skeleton-loader></div></div><div layout=row layout-padding=\"\"><div flex=10 layout=row><div flex=100><skeleton-loader type=sk-box></skeleton-loader></div></div><div flex=90 layout=row><div flex=50><skeleton-loader></skeleton-loader></div><div flex=50><skeleton-loader></skeleton-loader></div></div></div><div layout=row layout-padding=\"\"><div flex=10 layout=row><div flex=100><skeleton-loader type=sk-box></skeleton-loader></div></div><div flex=90 layout=row><div flex=50><skeleton-loader></skeleton-loader></div><div flex=50><skeleton-loader></skeleton-loader></div></div></div><div layout=row layout-padding=\"\" layout-wrap=\"\" style=\"border-bottom:dashed 1px solid #eaeaea\"><div flex=15 layout=row layout-padding=\"\"><div flex=100><skeleton-loader type=sk-box></skeleton-loader></div></div><div flex=85 layout=row layout-padding=\"\"><div flex=20><skeleton-loader type=sk-box></skeleton-loader></div><div flex=20><skeleton-loader type=sk-box></skeleton-loader></div><div flex=20><skeleton-loader type=sk-box></skeleton-loader></div><div flex=20><skeleton-loader type=sk-box></skeleton-loader></div></div></div>");
$templateCache.put("app/rule-editor/components/expanded-table/expanded-table.html","<md-dialog><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ ctrl.paramKey }}</h2><span flex></span><md-button ng-click=ctrl.close() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-width: 60vw\"><section ng-show=!ctrl.editorMode><div style=\"padding: 0; width: 80vw; min-height: 300px\"><div ui-grid=ctrl.gridOptions ui-grid-edit ui-grid-cellnav ui-grid-selection ui-grid-resize-columns style=\"height: 100%\" class=\"myGrid font-monospace\"></div></div></section><section ng-show=ctrl.editorMode><div style=\"height: 580px\" ng-model=ctrl.schemaAsJson ui-ace=\"{ useWrapMode : true, showGutter: true, theme:\'twilight\', mode: \'json\', rendererOptions: { minLines: 3 }, onChange: aceChanged }\"></div></section></md-dialog-content><md-dialog-actions layout=columns class=w100><div flex=70><md-button ng-click=ctrl.moveRow(0) ng-disabled=\"ctrl.editorMode || !ctrl.rowEntity\">{{ ctrl.translation.move_down }}</md-button><md-button ng-click=ctrl.moveRow(1) ng-disabled=\"ctrl.editorMode || !ctrl.rowEntity\">{{ ctrl.translation.move_up }}</md-button><md-button ng-click=ctrl.addRow() ng-disabled=ruleForm.$invalid>{{ ctrl.translation.add_row }}</md-button></div><div flex=30 style=\"text-align: right\"><md-button ng-click=ctrl.togleEditionMode()>{{ ctrl.editorMode ? ctrl.translation.table_mode : ctrl.translation.edit_mode }}</md-button><md-button ng-click=ctrl.close()>{{ ctrl.translation.close }}</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/rule-editor/components/hot-expanded-table/hot-expanded-table.html","<md-dialog aria-label=\"Expanded table dialog\" style=\"width: 100vw\"><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ ctrl.paramKey }}</h2><span flex></span><md-button ng-click=ctrl.close() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=ctrl.loading><md-progress-linear></md-progress-linear></md-dialog-content><md-dialog-content ng-if=!ctrl.loading><section ng-if=!ctrl.editorMode><div style=\"padding:0; width: 80vw; min-height:300px\"><hot-table id=rule-expanded-table hot-id=rule-expanded-table settings=ctrl.tableSettings datarows=ctrl.gridOptions.data columns=ctrl.tableColumns class=\"w100 font-monospace\"></hot-table></div></section><section ng-if=ctrl.editorMode><div style=\"width: 80vw; height: 580px\" ng-model=ctrl.schemaAsJson ui-ace=\"{ useWrapMode : true, showGutter: true, theme:\'twilight\', mode: \'json\', rendererOptions: { minLines: 3 }, onChange: aceChanged }\"></div></section></md-dialog-content><md-dialog-actions layout=columns class=w100><div flex=70><md-button ng-click=ctrl.moveRow(0) ng-disabled=\"ctrl.editorMode || !ctrl.rowEntity\">{{ ctrl.translation.move_down }}</md-button><md-button ng-click=ctrl.moveRow(1) ng-disabled=\"ctrl.editorMode || !ctrl.rowEntity\">{{ ctrl.translation.move_up }}</md-button><md-button ng-click=ctrl.addRow() ng-disabled=ruleForm.$invalid>{{ ctrl.translation.add_row }}</md-button></div><div flex=30 style=text-align:right><md-button ng-click=ctrl.togleEditionMode()>{{ ctrl.editorMode ? ctrl.translation.table_mode : ctrl.translation.edit_mode }}</md-button><md-button ng-click=ctrl.close()>{{ ctrl.translation.close }}</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/rule-editor/components/json-editor/json-editor.html","<ul class=tree_list><li ng-repeat=\"(key, value) in ctrl.json track by $index\"><div class=block><label for={{key}}_{{$index}} class=key>{{key}}<small class=text-muted>- {{getTypeof(value)}}</small></label><type-object ng-if=\"getTypeof(value) == \'object\'\" obj=value ref={{key}}_{{$index}}></type-object><type-number ng-if=\"getTypeof(value) == \'number\'\" value={{value}}></type-number><type-array ng-if=\"getTypeof(value) == \'array\'\" array=value ref={{key}}_{{$index}}></type-array></div></li></ul>");
$templateCache.put("app/rule-editor/components/notes-widget/notes-widget.html","<div ng-cloak contenteditable=true style=\"width: max-content; height: max-content; padding: 5px; font-weight:600; text-align: left; white-space:pre-wrap\" class=\"window step\">{{$ctrl.label}}</div>");
$templateCache.put("app/rule-editor/components/predicates-dialog/predicates-dialog.html","<md-dialog aria-label=\"Predicates editor window\"><md-dialog-content style=\"width:60vw; min-height:60vh\"><md-content layout=column style=\"height:-webkit-fill-available; height:-moz-available\"><md-toolbar layout=row style=\"border-bottom: 1px solid #e8e8e8\" class=md-menu-toolbar><md-toolbar-filler layout layout-align=\"center center\" class=main-color><md-icon md-font-set=material-icons md-menu-align-target>account_tree</md-icon></md-toolbar-filler><div class=w100><div layout=row class=w100><h2 flex class=md-toolbar-tools><span>Predicate builder</span></h2><round-button on-click=ctrl.cancel() aria-label=Close icon=clear style=\"position:relative; top:10px\"></round-button></div></div></md-toolbar><div layout=row><div flex><predicate-builder predicate=ctrl.predicate input-schema=ctrl.inputSchema></predicate-builder></div></div></md-content></md-dialog-content><md-dialog-actions layout=row style=\"border: 1px solid #eaeaea\"><md-button ng-click=ctrl.cancel() class=md-raised>{{translation.cancel}}</md-button><md-button ng-click=ctrl.save() ng-disabled=!ctrl.valid class=\"md-raised md-primary\">{{translation.save}} {{translation.now || lowercase}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/rule-editor/components/props-bar/rule-props-bar.html","<md-sidenav md-component-id=rule-props-bar md-disable-backdrop=\"\" md-whiteframe=4 style=\"max-width: 30vw; width: 30vw\" class=md-sidenav-right><md-toolbar class=\"main-color sticky-top\"><div class=md-toolbar-tools><h2 flex=\"\" md-truncate=\"\">{{ ctrl.translation.properties }}</h2><md-menu-bar><md-menu><button id=menu-properties-actions ng-click=$mdMenu.open()><md-icon md-font-set=material-icons>menu</md-icon></button><md-menu-content><md-menu-item><md-button ng-click=\"ctrl.buildPipeline(false, true)\" aria-label=\"Typecheck button\"><span><md-icon md-font-set=material-icons md-menu-align-target>widgets</md-icon>Typecheck</span></md-button></md-menu-item><md-menu-item><md-button ng-click=ctrl.duplicateTransformation() aria-label=\"Duplicate transformation button\"><span><md-icon md-font-set=material-icons md-menu-align-target>library_add</md-icon>{{ ctrl.translation.duplicate }}</span></md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=ctrl.deleteTransformation($event) aria-label=\"Delete transformation button\"><span><md-icon md-font-set=material-icons md-menu-align-target>delete</md-icon>{{ ctrl.translation.delete }}</span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-button aria-label=close ng-click=ctrl.api.toggle() class=md-icon-button><md-icon md-font-set=material-icons>close</md-icon></md-button></div></md-toolbar><md-list class=\"md-dense p0\"><md-subheader class=\"md-no-sticky p0\"><h3 style=\"margin: 0\"><span>{{ ctrl.transformProps.name }}.</span></h3><a ng-href=\"{{ &quot;docs/transformations-&quot; + ctrl.transformProps.name }}\" onclick=\"return !window.open(this.href, \'docs\', \'width=1024,height=800\')\" target=_blank class=social_share_link><span style=\"font-size: 0.6em\">{{ ctrl.transformProps.id }}</span><span style=\"margin: 0\">{{ ctrl.transformProps.type }}</span><i class=\"material-icons theme_color\">help</i></a></md-subheader><md-divider></md-divider></md-list><div><div class=rule-prop><label>{{ ctrl.translation.label }}</label><textarea type=text ng-model=ctrl.transformProps.label ng-change=\"ctrl.isChanged = true\" rows=3></textarea></div></div><div></div><div ng-if=\"param == &quot;integer&quot; &amp;&amp; key == &quot;outputs&quot;\" class=w100><span style=\"color: #575757 !important; font-weight: 100; text-transform: uppercase; font-size: 0.65em\">{{ key }}</span><md-button ng-click=ctrl.removeOutputs(key) class=\"md-fab md-mini md-warn md-button md-ink-ripple\"><md-icon md-font-set=material-icons md-menu-align-target>remove</md-icon><span style=\"font-size: 1.5em; font-weight: 600; margin: 10%\">{{ ctrl.transformProps.parameters[key] }}</span></md-button><md-button ng-click=ctrl.addOutputs(key) class=\"md-fab md-mini md-warn md-button md-ink-ripple\"><md-icon md-font-set=material-icons md-menu-align-target>add</md-icon></md-button></div><div ng-repeat=\"(key, param) in ctrl.transformProps.types\"><div ng-if=currentsFavs.favs.includes(key) class=\"prop-item relative\"><div ng-click=removeFav(key) class=prop-fav-icon><md-tooltip md-direction=right>remove</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target class=amber-text>star</md-icon></div><div rule-props-builder key=key parameter=ctrl.transformProps.parameters[key] type=ctrl.transformProps.types[key] default-schema=ctrl.transformProps.schema[key] input-schemas=ctrl.transformProps.inputSchemas output-schemas=ctrl.transformProps.outputSchemas opt-values=ctrl.transformProps.optValues[key] grid-options=ctrl.transformProps.gridOptions[key] on-update-opt-values=ctrl.onUpdateOptValues is-changed=ctrl.isChanged class=\"w100 fav-propertie\"></div></div></div><md-divider></md-divider><div ng-if=currentsFavs.favs.includes(&quot;notes&quot;)><div class=rule-prop><div ng-click=removeFav(&quot;notes&quot;) class=prop-fav-icon><md-tooltip md-direction=right>add to Favorites</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target class=amber-text>star</md-icon></div><label>{{ ctrl.translation.notes }}:</label><textarea type=text ng-model=\"ctrl.transformProps.parameters[\'notes\']\" ng-change=\"ctrl.isChanged = true\" rows=2></textarea></div></div><md-divider></md-divider><div id=show-properties-btn ng-click=onCLickshowProperties() class=btn-toggle-props><md-icon md-font-set=material-icons md-menu-align-target class=amber-text>{{ showProperties ? \'expand_more\' : \'expand_less\' }}</md-icon>More properties</div><div ng-show=showProperties><div ng-repeat=\"(key, param) in ctrl.transformProps.types\"><div ng-if=!currentsFavs.favs.includes(key) class=\"prop-item relative\"><div ng-click=markAsFav(key) data-fav=\"{{ key }}\" class=prop-fav-icon><md-tooltip md-direction=right>add to Favorites {{ key }}</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target class=amber-text>star_outline</md-icon></div><div rule-props-builder key=key parameter=ctrl.transformProps.parameters[key] type=ctrl.transformProps.types[key] default-schema=ctrl.transformProps.schema[key] input-schemas=ctrl.transformProps.inputSchemas output-schemas=ctrl.transformProps.outputSchemas opt-values=ctrl.transformProps.optValues[key] grid-options=ctrl.transformProps.gridOptions[key] on-update-opt-values=ctrl.onUpdateOptValues is-changed=ctrl.isChanged class=w100></div></div></div><md-divider></md-divider><div ng-if=!currentsFavs.favs.includes(&quot;notes&quot;)><div class=rule-prop><div ng-click=markAsFav(&quot;notes&quot;) class=prop-fav-icon><md-tooltip md-direction=right>add to Favorites</md-tooltip><md-icon md-font-set=material-icons md-menu-align-target class=amber-text>star_outline</md-icon></div><label>{{ ctrl.translation.notes }}:</label><textarea type=text ng-model=\"ctrl.transformProps.parameters[\'notes\']\" ng-change=\"ctrl.isChanged = true\" rows=2></textarea></div></div></div><div layout=row><div flex=40><div class=\"rule-prop fl-column nborde\"><label>DEBUG MODE</label><md-switch ng-model=\"ctrl.transformProps.parameters[\'debug\']\" aria-label=\"Debug mode switch\" ng-change=\"ctrl.isChanged = true\" class=m0>{{ ctrl.transformProps.parameters[\'debug\'] }}</md-switch></div></div><div flex><div class=\"rule-prop fl-column nborde\"><label>TUPLEX_MAX</label><input type=text ng-model=\"ctrl.transformProps.parameters[\'tuplex_max\']\" ng-change=\"ctrl.isChanged = true\" placeholder=\"\"></div></div></div></md-sidenav>");
$templateCache.put("app/rule-editor/components/queries-dialog/queries-dialog.html","<md-dialog aria-label=\"Queries builder window\" class=relative><md-toolbar layout=row style=\"border-bottom: 1px solid #e8e8e8\" class=md-menu-toolbar><md-toolbar-filler layout layout-align=\"center center\" class=main-color><md-icon md-font-set=material-icons md-menu-align-target>usb</md-icon></md-toolbar-filler><div class=w100><div layout=row class=w100><h2 flex class=md-toolbar-tools><span>Queries builder</span></h2><round-button on-click=ctrl.cancel() aria-label=Close icon=clear style=\"position: relative; top: 10px\"></round-button></div></div></md-toolbar><md-dialog-content style=\"width: 80vw\"><md-progress-linear md-mode=indeterminate ng-if=ctrl.loading></md-progress-linear><div layout=column ng-if=!ctrl.loading class=w100><div flex ng-repeat=\"param in ctrl.parameters\"><query-editor query=param></query-editor></div></div></md-dialog-content><md-dialog-actions layout=row style=\"border: 1px solid #eaeaea\"><md-button ng-click=ctrl.addQuery() class=\"md-raised yellow\"><i class=material-icons>add</i>Add Query</md-button><div style=\"flex: 1\" class=spacer></div><md-button ng-click=ctrl.cancel() class=md-raised>{{ translation.cancel }}</md-button><md-button ng-click=ctrl.save() class=\"md-raised md-primary\">Set queries</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/rule-editor/components/rule-counter-widget/rule-counter-widget.html","<md-card style=\"min-width:150px; width:fit-content\"><md-card-content layout=column><div flex=1 style=\"min-width:100%; width:fit-content; font-weight:500\"><span>{{ctrl.title}}</span><md-divider></md-divider></div><div flex=2 style=\"text-align: center\"><div flex style=\"min-width:100%; width:fit-content; font-size:3em; font-weight:500; color:darkblue\"><span>{{ctrl.count}}</span><span style=font-size:0.7em>{{ctrl.symbol}}</span></div></div><div flex=1 style=\"min-width:100%; width:fit-content; font-weight:500; text-align: center\"><span>{{ctrl.label}}</span></div></md-card-content></md-card>");
$templateCache.put("app/rule-editor/components/rule-timer-widget/rule-timer-widget.html","<md-card style=\"min-width:150px; width:fit-content\"><md-card-content layout=column><div flex=1 style=\"min-width:100%; width:fit-content; font-weight:500\"><span>{{ctrl.title}}</span><md-divider></md-divider></div><div flex=2 style=\"text-align: center\"><div flex style=\"min-width:100%; width:fit-content; font-size:3em; font-weight:500; color:darkblue\"><span>{{ctrl.count | number:2}}</span><span style=font-size:0.7em>s</span></div></div><div flex=1 style=\"min-width:100%; width:fit-content; font-weight:500; text-align: center\"><span>{{ctrl.label}}</span></div></md-card-content></md-card>");
$templateCache.put("app/rule-editor/components/rules-toolbar/rules-toolbar.html","<div class=rule-toolbar><md-menu-bar><md-menu><button id=rule-editor-window-menu ng-click=$mdMenu.open() ng-disabled=ctrl.loading>view</button><md-menu-content width=3><md-menu-item ng-if=!ctrl.showCode><md-button ng-click=\"ctrl.buildPipeline(false, false); ctrl.onToogleView()\" ng-disabled=ctrl.loading><div layout=row flex><p flex><b>Code View</b></p></div></md-button></md-menu-item><md-menu-item ng-if=ctrl.showCode><md-button ng-click=\"ctrl.buildPipeline(false, false); ctrl.onToogleView()\" ng-disabled=ctrl.loading><div layout=row flex><p flex><b>Editor View</b></p></div></md-button></md-menu-item><md-menu-item><md-button ng-click=ctrl.toggleTerminal() ng-disabled=ctrl.loading><div layout=row flex><p flex><b>Terminal</b></p></div></md-button></md-menu-item><md-menu-item><md-button ng-click=ctrl.toggleDarkenMode() ng-disabled=ctrl.loading><div layout=row flex><p flex><b>Dark Mode</b>&nbsp; - {{ ctrl.isDarkMode ? \"active\" : \"disabled\" }}</p></div></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-button ng-click=ctrl.execute() ng-show=!ctrl.isRunning aria-label=\"Execute rule button\" ng-disabled=\"ctrl.loading || !ctrl.validatePermission(\'run\')\" class=md-icon-button><md-tooltip md-direction=bottom>{{ ctrl.translation.execute }}</md-tooltip><md-progress-circular md-diameter=20px style=\"margin: 0 auto\" ng-if=ctrl.onProgress class=md-hue-2></md-progress-circular><i ng-if=!ctrl.onProgress class=\"fa fa-play cep_text\"></i></md-button><md-button ng-click=ctrl.stopExecution() ng-show=ctrl.isRunning aria-label=\"Stop rule execution rule button\" ng-disabled=\"ctrl.loading || !ctrl.validatePermission(\'run\')\" class=md-icon-button><md-tooltip md-direction=bottom>Stop Executión</md-tooltip><md-progress-circular md-diameter=20px style=\"margin: 0 auto\" ng-if=ctrl.isStoping class=md-hue-2></md-progress-circular><i ng-if=!ctrl.isStoping class=\"fa fa-stop red-text\"></i></md-button><md-button ng-click=\"ctrl.buildPipeline(false, true)\" aria-label=\"Typecheck button\" ng-disabled=ctrl.loading class=md-icon-button><md-tooltip md-direction=bottom>Typecheck</md-tooltip><md-progress-circular md-diameter=20px style=\"margin: 0 auto\" ng-if=ctrl.isChecking class=md-hue-2></md-progress-circular><i ng-if=\"!ctrl.isChecking &amp;&amp; !ctrl.hasError\" class=\"fa fa-check-circle green-text\"></i><i ng-if=\"!ctrl.isChecking &amp;&amp; ctrl.hasError\" class=\"fa fa-info-circle red-text\"></i></md-button><md-button ng-click=\"ctrl.buildPipeline(true, false)\" aria-label=\"Save rule button\" ng-disabled=\"ctrl.loading || !ctrl.validatePermission(\'update\')\" class=md-icon-button><md-tooltip md-direction=bottom>{{ ctrl.translation.save }}</md-tooltip><i ng-if=!ctrl.isChanged class=\"fa fa-floppy-o green-text\"></i><i ng-if=ctrl.isChanged class=\"fa fa-floppy-o green-text\"></i></md-button><md-button ng-click=\"ctrl.loadFlowchart(); ctrl.showCode = !ctrl.showCode\" aria-label=\"Load pipeline button\" ng-disabled=\"ctrl.loading || !ctrl.showCode\" class=md-icon-button><md-tooltip md-direction=bottom>{{ ctrl.translation.load }}</md-tooltip><i class=\"fa fa-cloud-upload\"></i></md-button><div style=\"border-left: 1px solid #e8e8e8; display: inline-block\"><md-button ng-click=ctrl.showProperties() aria-label=\"Show properties button\" ng-disabled=ctrl.loading class=md-icon-button><md-tooltip md-direction=bottom>{{ ctrl.translation.properties }}</md-tooltip><i class=\"fa fa-tasks\"></i></md-button></div><div style=\"border-left: 1px solid #e8e8e8; flex-grow: 2\"><div class=\"text-center w100 lighten-4\">{{ ctrl.executionState }}</div></div><div style=\"border-left: 1px solid #e8e8e8; align-self: flex-end\"><md-button ng-click=ctrl.clear($event) aria-label=\"Clear pipeline button\" ng-show=!ctrl.isRunning ng-disabled=ctrl.loading class=\"md-icon-button reset\"><md-tooltip md-direction=bottom>{{ ctrl.translation.clear_all }}</md-tooltip><i class=\"fa fa-trash red-text\"></i></md-button></div></div>");
$templateCache.put("app/rule-editor/components/schema-bar/rule-schema-bar.html","<md-sidenav md-component-id=rule-schema-bar md-whiteframe=4 md-disable-backdrop style=\"max-width: 30vw; width: 30vw\" ng-cloak class=md-sidenav-left><md-toolbar class=\"main-color sticky-top\"><div class=md-toolbar-tools><h2 flex md-truncate>{{ ctrl.translation.schema }}</h2><md-button aria-label=Favorite ng-click=ctrl.api.toggle() class=md-icon-button><md-icon md-font-set=material-icons>close</md-icon></md-button></div></md-toolbar><md-list layout=column class=p0><md-subheader class=\"md-no-sticky p0\"><h3 style=\"margin: 0\"><span>{{ ctrl.connName }}</span></h3><div style=\"margin: 0\">SelectedConnecionSchema</div></md-subheader><md-divider></md-divider><md-progress-linear ng-hide=ctrl.inTransit></md-progress-linear><md-list-item class=p0><div ng-if=\"ctrl.isOpened &amp;&amp; ctrl.inTransit\" class=w100><hot-table hot-id=rule-pipeline-schema-table settings=ctrl.tableSettings datarows=ctrl.tableData columns=ctrl.tableColumns></hot-table></div></md-list-item><md-list-item class=p0><md-button style=\"flex-grow: 1; margin: 0\" ng-click=ctrl.createSchema($event) class=\"md-raised w100 m0 blue second-color white-text\"><strong>{{ ctrl.translation.create }} {{ ctrl.translation.schema }}</strong></md-button></md-list-item></md-list></md-sidenav>");
$templateCache.put("app/rule-editor/components/terminal/terminal.html","<div id=terminal-bar ng-class=\"{ &quot;showBar&quot; : ctrl.showConsole }\"><md-button id=terminal-bar-btn aria-label=\"Toggle Console\" ng-click=ctrl.api.toggle() style=\"height: auto; min-height: auto; line-height: 2; border-radius: unset\" class=\"w100 white m0\"><div class=\"fa fa-caret-down\"></div><div class=\"fa fa-caret-up\"></div></md-button><md-tabs md-border-bottom=true><md-tab label=Terminal md-tab-class=tab-terminal><md-tab-content style=\"height: 100%\"><pre id=console-terminal class=m0><code id=jsonOutput ng-bind-html=ctrl.consoleLog class=\"m0 p0\"></code></pre></md-tab-content></md-tab><md-tab label=Output md-tab-class=tab-terminal><md-tab-content><pre id=console-terminal class=m0>\n          <div class=w100><span ng-if=!ctrl.selectedTransform.label>Select one transformation to see statistics</span><span style=\"font-size: 1.5em\">{{ ctrl.selectedTransform.label }}</span><span style=\"font-size: 1em\">({{ ctrl.selectedTransform.name }})</span></div>\n          <hr>\n          <div ng-repeat=\"(key, records) in ctrl.debugOutput\" class=w100>\n            <div>Output {{ key }}</div>\n            <ul>\n              <li ng-repeat=\"record in records\">{{ record }}</li>\n            </ul>\n          </div></pre></md-tab-content></md-tab><md-tab label=Context md-tab-class=tab-terminal><md-tab-content><div id=execution-terminal ng-class=\"{ &quot;showBar&quot; : ctrl.showConsole }\" layout=column class=m0><div class=w100><span ng-if=!ctrl.selectedTransform.label>Select one transformation to see statistics</span><span style=\"font-size: 1.5em\">{{ ctrl.selectedTransform.label }}</span><span style=\"font-size: 1em\">({{ ctrl.selectedTransform.name }})</span></div><div layout=row layout-wrap><rule-timer-widget title=\"Rule execution time\" value=\"{{ ctrl.context.executionTime }}\" label=\"{{ctrl.context.executionTime}} ms\"></rule-timer-widget><rule-timer-widget title=\"Box execution time\" value=\"{{ ctrl.selectedContext.executionTime }}\" label=\"{{ctrl.selectedContext.executionTime}} ms\"></rule-timer-widget><rule-counter-widget ng-if=ctrl.selectedContext title=\"Box execution %\" value=\"{{ ctrl.selectedContext.executionPerecent | number: 0 }}\" label=\"{{(ctrl.selectedContext.executionTime * 100) / ctrl.context.executionTime | number: 2}}% of total\" symbol=%></rule-counter-widget><rule-counter-widget ng-if=!ctrl.selectedContext title=\"Box execution %\" value=0 label=\"0% of total\" symbol=%></rule-counter-widget><rule-counter-widget ng-repeat=\"(key, count) in ctrl.selectedContext.inputDataCount track by $index\" title=\"Input Data ({{key}})\" value=\"{{ count }}\" label=Inputs></rule-counter-widget><rule-counter-widget ng-if=\"!ctrl.selectedContext || ctrl.selectedContext.inputDataCount.length &lt; 1\" title=\"Input Data ({{key}})\" value=0 label=Inputs></rule-counter-widget><rule-counter-widget ng-if=ctrl.selectedContext ng-repeat=\"(key, count) in ctrl.selectedContext.outputDataCount track by $index\" title=\"Output Data ({{key}})\" value=\"{{ count }}\" label=Outputs></rule-counter-widget><rule-counter-widget ng-if=\"!ctrl.selectedContext || ctrl.selectedContext.outputDataCount.length &lt; 1\" title=\"Output Data ({{key}})\" value=0 label=Outputs></rule-counter-widget></div><div layout=row layout-wrap><md-card style=\"width: 250px; height: 200px\"><md-card-content layout=column><div flex=1 style=\"min-width: 100%; width: fit-content; font-weight: 500\"><span>Rule execution</span><md-divider></md-divider></div><div flex=2 style=\"text-align: center\"><canvas id=pie chart-data=ctrl.overallBench chart-labels=ctrl.overallBenchLabels chart-click=chartClick class=\"chart chart-pie\"></canvas></div><div flex=1 style=\"min-width: 100%; width: fit-content; font-weight: 500; text-align: center\"><br><span>Total execution</span></div></md-card-content></md-card><md-card ng-if=ctrl.selectedContext style=\"width: 250px; height: 200px\"><md-card-content layout=column><div flex=1 style=\"min-width: 100%; width: fit-content; font-weight: 500\"><span>Box execution</span><md-divider></md-divider></div><div flex=2 style=\"text-align: center\"><canvas id=pie chart-data=\"[ctrl.selectedContext.executionPerecent, (100-ctrl.selectedContext.executionPerecent)]\" chart-labels=\"[&quot;Selected Box&quot;, &quot;Rule Total&quot;]\" class=\"chart chart-pie\"></canvas></div><div flex=1 style=\"min-width: 100%; width: fit-content; font-weight: 500; text-align: center\"><br><span>{{ ctrl.selectedContext.executionPerecent }}% of total</span></div></md-card-content></md-card></div></div></md-tab-content></md-tab></md-tabs></div>");
$templateCache.put("app/rule-editor/components/transform-box/transform-box.html","<div ng-cloak><span style=\"top: -22px\" ng-if=$ctrl.showStats>{{ $ctrl.timeLabel }}&nbsp;</span><span style=\"text-align: left; display: flex; width: 800px;user-select: none;pointer-events: none\" ng-style=\"$ctrl.showStats ? {top:\'23px\'} : {top:\'42px\'}\"><p style=\"white-space: pre-wrap; margin: 4px 0\" class=transform-label>{{ $ctrl.label }}</p></span></div>");
$templateCache.put("app/rule-editor/components/transform-tool/transform-tool.html","<div ng-cloak><div id=\"{{ ctrl.props.name }}-tool\" transformation source=ctrl.props.defaultOutputs target=ctrl.props.defaultInputs data-tool=\"{{ ctrl.props.name }}\" data-type=\"{{ ctrl.type }}\" class=\"window step jsplumb-connected-step md-truncate\"><md-tooltip md-direction=bottom>{{ ctrl.props.name }}</md-tooltip></div></div>");
$templateCache.put("app/rule-editor/components/transformations-bar/transformations-bar.html","<section ng-show=ctrl.transformations ignore-drop-event class=w100><div flex layout=row layout-align=\"center center\"><div flex=80><input ng-model=ctrl.searchtext placeholder=\"{{ ctrl.translation.search }}...\" style=\"border:unset; padding: 5px;margin-left: 3px\"></div><div flex=20><md-button style=\"min-width: unset\" ng-click=ctrl.toggleBoxTransformsTools() aria-label=\"Toggle button\" class=\"m0 w100\"><i ng-class=\"{ &quot;fa-caret-up&quot;: !ctrl.displayToolsBox, &quot;fa-caret-down&quot;: ctrl.displayToolsBox }\" class=\"text-center fa\"></i></md-button></div></div><div tab=searched ng-if=ctrl.searched.length><div class=transformation-tab><transform-tool ng-repeat=\"transform in ctrl.searched\" props=transform type=inputs style=\"display: inline-block\"></transform-tool></div></div><div style=\"padding: 5px; background-color:#f6f6f6\" ng-if=\"!ctrl.searched.length &amp;&amp; ctrl.searchtext.length\">{{ ctrl.translation.without_results }}:<br>&quot;{{ ctrl.searchtext }}&quot;</div><div id=wrapper-trasnsforms-tools ng-show=ctrl.displayToolsBox><md-button md-truncate ng-click=ctrl.onClickTab(&quot;inputs&quot;) ng-class=\"{&quot; cep_text cep_border_bottom&quot;: ctrl.tabs.inputs }\" class=\"w100 m0 text-left\"><i class=\"fa fa-sign-in\"></i><b>&nbsp; {{ ctrl.translation.inputs }}</b></md-button><div tab=inputs ng-if=ctrl.tabs.inputs><div class=transformation-tab><transform-tool ng-repeat=\"transform in ctrl.inputs\" props=transform type=inputs style=\"display: inline-block\"></transform-tool></div></div><md-button md-truncate ng-click=ctrl.onClickTab(&quot;transforms&quot;) ng-class=\"{ &quot;cep_text cep_border_bottom&quot;: ctrl.tabs.transformations }\" class=\"w100 m0 text-left\"><i class=\"fa fa-magic\"></i><b>&nbsp; {{ ctrl.translation.transformations }}</b></md-button><div tab=transforms ng-if=ctrl.tabs.transformations><div class=transformation-tab><transform-tool ng-repeat=\"transform in ctrl.transforms\" props=transform type=transforms style=\"display: inline-block\"></transform-tool></div></div><md-button md-truncate ng-click=ctrl.onClickTab(&quot;outputs&quot;) ng-class=\"{ &quot;cep_text cep_border_bottom&quot;: ctrl.tabs.outputs }\" class=\"w100 m0 text-left\"><i class=\"fa fa-sign-out\"></i><b>&nbsp; {{ ctrl.translation.outputs }}</b></md-button><div tab=outputs ng-if=ctrl.tabs.outputs><div class=transformation-tab><transform-tool ng-repeat=\"transform in ctrl.outputs\" props=transform type=outputs style=\"display: inline-block\"></transform-tool></div></div><md-button ng-click=ctrl.onClickTab(&quot;configParams&quot;) ng-class=\"{ &quot;cep_text cep_border_bottom&quot;: ctrl.tabs.configParams }\" class=\"w100 m0 text-left\"><i class=\"fa fa-sliders\"></i><b>&nbsp; {{ ctrl.translation.others }}</b></md-button><div tab=configParams ng-if=ctrl.tabs.configParams><div class=transformation-tab><transform-tool ng-repeat=\"transform in ctrl.configParams\" props=transform type=configParams style=\"display: inline-block\"></transform-tool></div></div></div></section>");
$templateCache.put("app/rules/components/rule-group-item/rule-group-item.html","<md-list-item id=rule-path-{{ctrl.group.path}} style=\"border-bottom: 1px solid #dedcdc\" aria-label=toggleItems ng-click=ctrl.toggleItems() class=\"md-3-line item-report\"><div layout=row layout-align=\"center center\" layout-padding><div><md-icon ng-if=\"ctrl.group.isOpen==false\" md-font-set=material-icons class=color-rules>folder_open</md-icon><md-icon ng-if=\"ctrl.group.isOpen==true\" md-font-set=material-icons class=color-rules>folder</md-icon></div><div><h3><b>{{ ctrl.group.groupName }}:&nbsp;</b></h3><span><b>{{ ctrl.group.subGroup.length }}&nbsp;</b>{{ ctrl.translation.folder }}s</span>&nbsp; &nbsp;- &nbsp;<span><b>{{ ctrl.group.items.length }}&nbsp;</b>Items</span></div></div><md-button style=\"padding: 0.8rem\" aria-label=\"Display items button\" title=\"Toggle group\" ng-click=\"ctrl.group.isOpen = !ctrl.group.isOpen\" class=\"md-icon-button md-secondary text-main-color\"></md-button><div layout=row class=\"md-icon-button md-secondary\"><md-button has-permission=function:create ng-click=ctrl.openEditor($event) aria-label=\"Add rule button\"><md-icon md-font-set=material-icons style=\"position: relative; top: 3px\">add</md-icon><b>{{ ctrl.translation.new }} {{ ctrl.translation.rule }}</b></md-button><md-button has-permission=function:read ng-click=ctrl.exportFunctions() aria-label=\"Export functions button\"><md-icon md-font-set=material-icons style=\"position: relative; top: 3px\">file_download</md-icon><b>{{ ctrl.translation.export }} {{ ctrl.translation.rules }}</b><md-progress-linear md-mode=indeterminate ng-if=ctrl.downloadingRules></md-progress-linear></md-button><md-icon md-font-set=material-icons>{{ ctrl.group.isOpen ? \'keyboard_arrow_up\' : \'keyboard_arrow_down\' }}</md-icon></div></md-list-item><section ng-show=\"ctrl.group.isOpen==true\" style=\"margin: 0px 0px 0px 4rem; border-left: 4px solid rgb(202 196 196)\"><div ng-repeat=\"group in ctrl.group.subGroup | orderBy: &quot;name&quot;\"><rule-group-item group=group translation=ctrl.translation></rule-group-item></div><div class=rule-list-grid><rule-list-item ng-repeat=\"rule in ctrl.group.items\" rule=rule translation=ctrl.translation class=rule-item-list></rule-list-item></div></section>");
$templateCache.put("app/rules/components/rule-list-item/rule-list-item.html","<section class=rule-list-contend><rule-crud api=ctrl.ruleCRUD on-update=ctrl.onUpdate(rule)></rule-crud><h6 style=\"font-size: 1.2em\" ng-style=\"ctrl.rule.typeCheck ? {color:\'#2E7D32\'} : {color:\'red\'}\"><md-icon md-font-set=material-icons ng-style=\"ctrl.rule.typeCheck ? {color:\'#2E7D32\'} : {color:\'red\'}\">{{ ctrl.rule.typeCheck ? \"check_circle\" : \"error\" }}<md-tooltip>{{ ctrl.rule.typeCheck ? \"Valid Pipeline\" : \"Typecheck Error\" }}</md-tooltip></md-icon>{{ ctrl.rule.id }}. &nbsp;<strong>{{ ctrl.rule.name }}</strong></h6><div><div layout=row layout-align=\"end center\"><div flex=75><h6>Version: {{ ctrl.rule.liveVersion || \" - \" }}</h6></div><div flex style=\"margin: 0 10rem 0 0\"><md-switch md-invert ng-model=ctrl.rule.active aria-label=\"Rule activator\" ng-change=ctrl.editRule(ctrl.rule) class=\"m0 p0\">{{ ctrl.rule.active ? ctrl.translation.active : ctrl.translation.inactive }}</md-switch></div></div><div><p class=m0>{{ ctrl.rule.description }}</p></div><div><h6>Schedules<strong>{{ ctrl.rule.schedules.length ? \"\" : \" - \" }}</strong></h6><div ng-repeat=\"schedule in ctrl.rule.schedules track by $index\" style=\"margin: 0 0 0 1rem\" layout=row layout-align=\"start center\"><div flex=1>{{ $index + 1 }}. &nbsp;</div><div flex><strong>{{ schedule.cron }}</strong><br>Next execution: {{ schedule.nextExecution}}</div></div></div><div><p ng-if=ctrl.rule.running class=\"m0 text-second-color\"><strong><i>Rule is running</i></strong><md-progress-linear></md-progress-linear></p></div></div></section><section class=rule-list-actions><md-button has-permission=function#{{ctrl.rule.id}}:read-pipeline href=\"{{ ctrl.rule.editorUrl }}\" aria-label=\"{{ ctrl.translation.copy }}\" class=\"m0 md-icon-button md-secondary text-main-color launcher-btn\"><md-icon md-font-set=material-icons>launch</md-icon><md-tooltip>{{ ctrl.translation.view }} Pipeline</md-tooltip></md-button><md-button has-permission=function#{{ctrl.rule.id}}:read ng-click=\"ctrl.ruleCRUD.openEditor($event, ctrl.rule)\" aria-label=\"{{ ctrl.translation.edit }}\" class=\"m0 md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>apps</md-icon><md-tooltip>{{ ctrl.translation.properties }}</md-tooltip></md-button><md-button ng-if=!ctrl.rule.running ng-click=ctrl.execute(ctrl.rule) aria-label=\"Execute rule button\" class=\"m0 md-icon-button md-secondary text-main-color execute-btn\"><md-icon md-font-set=material-icons ng-if=!ctrl.rule.onProgress>play_arrow</md-icon><md-progress-circular md-diameter=20px style=\"margin: 0 auto\" ng-if=ctrl.rule.onProgress class=md-hue-2></md-progress-circular><md-tooltip>{{ ctrl.translation.execute }} {{ ctrl.translation.rule }}</md-tooltip></md-button><md-button has-permission=function#{{ctrl.rule.id}}:share ng-click=ctrl.showShareEntityDialog(ctrl.rule) aria-label=\"{{ ctrl.translation.share }}\" class=\"m0 md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>share</md-icon><md-tooltip>{{ ctrl.translation.share }} {{ ctrl.translation.rule }}</md-tooltip></md-button><md-button ng-if=!ctrl.rule.running has-permission=function#{{ctrl.rule.id}}:read-runs href=rule/{{ctrl.rule.id}}/executions aria-label=\"Rule versions button\" class=\"m0 md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>video_library</md-icon><md-tooltip>{{ ctrl.translation.versions }} & {{ ctrl.translation.executions }}</md-tooltip></md-button><md-button ng-if=!ctrl.rule.running has-permission=function#{{ctrl.rule.id}}:download-rule ng-click=ctrl.export(ctrl.rule) aria-label=\"export json\" class=\"m0 md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons ng-if=!ctrl.downloadingRuleAsJson>file_download</md-icon><md-progress-circular md-diameter=20px style=\"margin: 0 auto\" ng-if=ctrl.downloadingRuleAsJson class=md-hue-2></md-progress-circular><md-tooltip>{{ ctrl.translation.export }} as json</md-tooltip></md-button><md-button ng-if=ctrl.rule.running ng-click=ctrl.stopExecution(ctrl.rule) aria-label=\"Stop rule execution button\" class=\"m0 md-icon-button md-secondary text-main-color\"><md-icon style=\"color: red\" md-font-set=material-icons>stop</md-icon><md-tooltip>Stop rule execution</md-tooltip></md-button><md-button has-permission=function#{{ctrl.rule.id}}:delete ng-click=ctrl.deleteRule(ctrl.rule) aria-label=\"{{ ctrl.translation.delete }}\" class=\"m0 md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>delete</md-icon><md-tooltip>{{ ctrl.translation.delete }} {{ ctrl.translation.rule }}</md-tooltip></md-button><btn-bookmark entity-id=ctrl.rule.id entity-name=ctrl.rule.name entity-type=\"ctrl.rule.realtime ? \'realtime-rule\' : \'rule\'\" role=button-rule-bookmark has-permission=function#{{ctrl.rule.id}}:read class=\"m0 md-icon-button md-secondary text-main-color md-button md-ink-ripple\"></btn-bookmark></section>");
$templateCache.put("app/rules/components/rule-management-dialog/rule-management-dialog.html","<md-dialog style=\"width: 70vw\"><form name=ruleCreateForm ng-submit=\"ruleCreateForm.$valid &amp;&amp; rule.saveRule()\" novalidate><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ rule.data.id ? translation.edit + \" \" + translation.rule : translation.CREATE_FUNCTION }} {{ rule.realtime ? \"Realtime\" : \"\" }}</h2><span flex></span><md-button onclick=\"document.getElementById(\'ruleImportArea\').click()\" ng-if=rule.data.new>{{ translation.import }} JSON</md-button><div style=\"display: none\"><input id=ruleImportArea type=file rule-importer rule-imported-data=rule.importedData multiple accept=.json></div><md-button ng-disabled=rule.isSaving ng-click=rule.cancel() aria-label=\"Close dialog button\" class=md-icon-button><md-icon md-font-set=material-icons>clear</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding: 10px 10px 0 10px\"><cron-builder api=cronBuilder on-update=\"rule.cronBuilderCallback(expression, id)\"></cron-builder><schedule-builder api=scheduleBuilder on-update=\"rule.scheduleBuilderCallback(schedule, action, index)\"></schedule-builder><div layout=row layout-align=\"space-between stretch\"><div flex=40 style=\"border-right: 1px solid #e0e0e0; padding-right: 10px\"><div layout=row layout-align=\"space-between center\" style=\"height: 20px\"><div style=\"font-weight: 700\">{{ translation.rule }}</div><md-switch md-invert ng-model=rule.data.active aria-label=\"Rule activator\" style=\"padding: 0.8rem\">{{ rule.data.active ? translation.active : translation.inactive }}</md-switch></div><br><div layout=column><md-input-container flex=100 style=\"margin-bottom: 0\" class=p0><label>{{ translation.name }}</label><input ng-model=rule.data.name name=ruleName autocomplete=off aria-label=\"Rule name field\" required><div ng-messages=ruleCreateForm.ruleName.$error><div ng-message=required>{{ translation.field_required }}</div></div></md-input-container><div flex=100 style=\"margin-bottom: 0\" class=p0><label>{{ translation.group }}</label><div ng-if=\"loadingDialog == false\"><span>{{ rule.data.groups }}</span><md-button ng-click=rule.moveItemGroup() class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>folder_copy</md-icon><md-tooltip>Move</md-tooltip></md-button></div><div ng-if=\"loadingDialog == true\"><md-progress-circular md-mode=indeterminate md-diameter=20px></md-progress-circular><br></div></div><md-input-container flex=100 style=\"margin-bottom: 0\" class=p0><label>{{ translation.description }}</label><textarea ng-model=rule.data.description name=ruleDescription rows=3 required aria-label=\"Rule description field\"></textarea><div ng-messages=ruleCreateForm.ruleDescription.$error><div ng-message=required>{{ translation.field_required }}</div></div></md-input-container></div></div><div flex=60 style=\"padding-left: 10px\"><ng-include src=\"\'app/rules/components/rule-management-dialog/rule-schedule-selector.html\'\"></ng-include><section id=global-attributes-section><div style=\"font-weight: 700\">{{ translation.global_attributes }}</div><div style=\"display: flex; gap: 1rem; flex-wrap: nowrap; align-content: center; justify-content: flex-start; align-items: baseline; width: 100%; margin-top: 3rem\"><div style=\"flex: auto\"><md-input-container class=\"w100 p0 m0\"><label for=schema>Seleccionar esquema (opcional)</label><md-autocomplete name=schema md-selected-item=rule.data.schema md-search-text=querySearchSchema md-selected-item-change=rule.schemaItemChange(item) md-items=\"item in rule.querySearchSchema(querySearchSchema)\" md-item-text=item.name input-aria-describedby=schema md-require-match=true md-clear-button=true><md-item-template><span md-highlight-text=querySearchSchema md-highlight-flags=^i>{{ item.name }}</span></md-item-template><md-not-found>No states matching \"{{ querySearchSchema }}\" were found</md-not-found></md-autocomplete></md-input-container></div><div style=\"width: 50px\"><md-button ng-click=rule.applySchemasToAttr() ng-disabled=\"!rule.data.schema || rule.isSaving\" class=\"md-icon-button md-raised amber\"><md-icon md-font-set=material-icons class=text-red>file_copy</md-icon><md-tooltip>Aplicar schema en atributos</md-tooltip></md-button></div></div><br><div ui-grid=rule.gridOptions ui-grid-edit ui-grid-cellnav ui-grid-selection style=\"height: 206px\" class=myGrid></div></section></div></div></md-dialog-content><md-dialog-actions class=cep-top-border><md-button ng-show=rule.validatePermission() type=button ng-disabled=rule.isSaving ng-click=rule.addAttr() style=\"margin-right: 25px\" class=\"md-raised pull-right\">{{ translation.add_attribute }}</md-button><span style=\"margin-right: 15px\">|</span><md-button type=button ng-disabled=rule.isSaving ng-click=rule.cancel() class=\"md-raised pull-right\">{{ translation.cancel }}</md-button><md-button ng-show=rule.validatePermission() type=submit ng-disabled=rule.isSaving class=\"md-raised md-primary pull-right\">{{ translation.save }}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/rules/components/rule-management-dialog/rule-schedule-selector.html","<section id=rule-schedule-section><div layout=row layout-align=\"space-between center\"><span style=\"font-weight: 600\">LiveVersion:</span><md-input-container flex style=\"background-color: transparent; top: 3px\" class=\"p0 m0 rule-schedule-selector\"><select id=scheduleVersion flex ng-model=rule.data.liveVersion aria-label=\"Live version selector\" style=\"text-align-last: left; width: 100%\" class=select-filters-modal><option ng-repeat=\"version in rule.versions\" ng-value=version.id>{{ version.id + \' - \' + version.title }}</option></select></md-input-container></div><section layout=row ng-if=\"rule.data.schedules.length == 0\"><div flex class=w100><strong>no_schedules</strong></div></section><section layout=row layout-align=\"start center\" ng-repeat=\"schedule in rule.data.schedules track by $index\"><div flex md-truncate ng-click=rule.openSchedule($index)><span style=\"font-weight: 600\">{{ $index + 1 }}. {{ translation.schedule }}:&nbsp;</span><span>{{ schedule | prettyCron }}</span></div><md-button ng-click=rule.clearSchedule($index) style=\"top: -10px\" class=md-icon-button><md-icon md-font-set=material-icons>clear</md-icon></md-button></section><div style=\"text-align: right\"><md-button ng-show=rule.validatePermission() type=button ng-disabled=rule.isSaving ng-click=rule.openSchedule(-1) class=pull-right>{{ translation.configure }} {{ translation.schedule }}</md-button></div></section><md-divider style=\"margin: 7px 0\"></md-divider>");
$templateCache.put("app/rules/components/rule-preview/rule-preview.html","<rule-crud api=ctrl.ruleCRUD on-update=ctrl.onUpdate(rule)></rule-crud><div id=rule-preview-{{ctrl.rule.id}} class=rule-preview><md-toolbar ng-class=setClass() class=\"white-text toolbar-sticky\"><div layout=row layout-align=\"center center\"><md-toolbar-filler layout=column layout-align=\"center center\"><md-icon md-font-set=material-icons ng-class=\"setClass(\'\')\">{{ ctrl.rule.typeCheck ? \"spellcheck\" : \"error_outline\" }}</md-icon></md-toolbar-filler><h2 flex=\"\" md-truncate=\"\" class=md-toolbar-tools>{{ ctrl.rule.name }}</h2></div></md-toolbar><div layout=column layout-padding><div flex><span>typeCheck:&nbsp;</span><strong ng-class=\"setClass(\'-text\')\">{{ ctrl.rule.typeCheck ? \"ok\" : \"error\" }}</strong></div><div flex><span>{{ ctrl.translation.description }}:&nbsp;</span><strong>{{ ctrl.rule.description }}</strong></div><div flex ng-if=ctrl.rule.running><span>Rule is running:&nbsp;</span><md-progress-linear></md-progress-linear></div><div flex><span>LiveVersion:&nbsp;</span><strong>{{ ctrl.rule.liveVersion }}</strong></div><div flex ng-if=ctrl.rule.schedules.length><p class=m0>{{ ctrl.translation.schedules }}:&nbsp;<strong>{{ ctrl.rule.schedules.length }} &nbsp;</strong></p></div><div flex ng-if=ctrl.rule.schedules.length><div ng-repeat=\"schedule in ctrl.rule.schedules track by $index\" style=\"padding-left: 2rem; border-bottom: 1px solid #eaeaea; border-left: 1px solid #eaeaea\"><p class=m0><span>{{ $index + 1 }}. &nbsp;</span><strong>{{ schedule | prettyCron }}</strong></p><p class=m0><span>Next: &nbsp;</span><strong>{{ schedule | prettyCron:\'next\' }}</strong></p></div></div><div flex ng-if=ctrl.rule.schedules.length><md-switch md-invert ng-model=ctrl.rule.active aria-label=\"Rule activator\" style=\"padding: 0.8rem\" ng-change=ctrl.editRule(ctrl.rule)>{{ ctrl.rule.active ? ctrl.translation.active : ctrl.translation.inactive }}</md-switch></div></div><div class=buttons><md-button has-permission=function#{{ctrl.rule.id}}:read-pipeline href=\"{{ ctrl.rule.editorUrl }}\" style=\"padding: 0.8rem\" aria-label=\"{{ ctrl.translation.copy }}\" class=\"md-icon-button md-secondary text-main-color launcher-btn\"><md-icon md-font-set=material-icons>launch</md-icon><md-tooltip>{{ ctrl.translation.view }} Pipeline</md-tooltip></md-button><md-button has-permission=function#{{ctrl.rule.id}}:read ng-click=\"ctrl.ruleCRUD.openEditor($event, ctrl.rule)\" style=\"padding: 0.8rem\" aria-label=\"{{ ctrl.translation.edit }}\" class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>apps</md-icon><md-tooltip>{{ ctrl.translation.properties }}</md-tooltip></md-button><md-button has-permission=function#{{ctrl.rule.id}}:delete ng-click=ctrl.deleteRule(ctrl.rule) style=\"padding: 0.8rem\" aria-label=\"{{ ctrl.translation.delete }}\" class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>delete</md-icon><md-tooltip>{{ ctrl.translation.delete }} {{ ctrl.translation.rule }}</md-tooltip></md-button><md-button has-permission=function#{{ctrl.rule.id}}:share ng-click=ctrl.showShareEntityDialog(ctrl.rule) style=\"padding: 0.8rem\" aria-label=\"{{ ctrl.translation.share }}\" class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>share</md-icon><md-tooltip>{{ ctrl.translation.share }} {{ ctrl.translation.rule }}</md-tooltip></md-button></div><div class=buttons><md-button style=\"padding: 0.8rem\" aria-label=\"Typecheck status indicator\" class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons ng-style=\"ctrl.rule.typeCheck ? {color:\'#2E7D32\'} : {color:\'red\'}\">{{ ctrl.rule.typeCheck ? \"done\" : \"error\" }}</md-icon><md-tooltip>{{ ctrl.rule.typeCheck ? \"Valid Pipeline\" : \"Typecheck Error\" }}</md-tooltip></md-button><md-button ng-if=!ctrl.rule.running ng-click=ctrl.execute(ctrl.rule) style=\"padding: 0.8rem\" aria-label=\"Execute rule button\" class=\"md-icon-button md-secondary text-main-color execute-btn\"><md-icon md-font-set=material-icons ng-if=!ctrl.rule.onProgress>play_arrow</md-icon><md-progress-circular md-diameter=20px style=\"margin: 0 auto\" ng-if=ctrl.rule.onProgress class=md-hue-2></md-progress-circular><md-tooltip>{{ ctrl.translation.execute }} {{ ctrl.translation.rule }}</md-tooltip></md-button><md-button ng-if=!ctrl.rule.running has-permission=function#{{ctrl.rule.id}}:read-runs href=rule/{{ctrl.rule.id}}/executions style=\"padding: 0.8rem\" aria-label=\"Rule versions button\" class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>video_library</md-icon><md-tooltip>{{ ctrl.translation.versions }} & {{ ctrl.translation.executions }}</md-tooltip></md-button><md-button ng-if=!ctrl.rule.running has-permission=function#{{ctrl.rule.id}}:download-rule ng-click=ctrl.export(ctrl.rule) style=\"padding: 0.8rem\" aria-label=\"export json\" class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons ng-if=!ctrl.downloadingRuleAsJson>file_download</md-icon><md-progress-circular md-diameter=20px style=\"margin: 0 auto\" ng-if=ctrl.downloadingRuleAsJson class=md-hue-2></md-progress-circular><md-tooltip>{{ ctrl.translation.export }} as json</md-tooltip></md-button><md-button ng-if=ctrl.rule.running ng-click=ctrl.stopExecution(ctrl.rule) style=\"padding: 0.8rem\" aria-label=\"Stop rule execution button\" class=\"md-icon-button md-secondary text-main-color\"><md-icon style=\"color: red\" md-font-set=material-icons>stop</md-icon><md-tooltip>Stop rule execution</md-tooltip></md-button></div></div>");
$templateCache.put("app/rules/partials/execute-dialog/execute-dialog.html","<md-dialog aria-label=execution-dialog role=dialog><md-toolbar class=main-color><div class=md-toolbar-tools><h2>Execute Rule - {{ ctrl.rule.name }}</h2></div></md-toolbar><md-dialog-content style=\"width: 70vw\" class=md-padding><section layout=row><div flex=40><md-list><md-list-item layout=row><div flex=30>{{ translation.version }}:</div><div flex=70 ng-if=\"ctrl.loading == true\"><skeleton-loader type=sk-box></skeleton-loader></div><div flex=70 ng-if=\"ctrl.loading == false\"><span ng-if=ctrl.rule.liveVersion>{{ ctrl.rule.liveVersion }}</span><span ng-if=!ctrl.rule.liveVersion>Not Set</span></div></md-list-item><md-list-item layout=row><div flex=30>{{ translation.schedules }}:</div><div flex=70 ng-if=\"ctrl.loading == true\"><skeleton-loader type=sk-box></skeleton-loader></div><div flex=70 ng-if=\"ctrl.loading == false\"><span ng-if=ctrl.rule.schedule.length>{{ ctrl.rule.nowStr }}</span><span ng-if=!ctrl.rule.schedule.length>Not Set</span></div></md-list-item><md-list-item layout=row><div flex=30>{{ translation.last }} {{ translation.execution }}:</div><div flex=70 ng-if=\"ctrl.loading == true\"><skeleton-loader type=sk-box></skeleton-loader></div><div flex=70 ng-if=\"ctrl.loading == false\"><span ng-if=ctrl.loadExecutions>{{ translation.loading }} {{ translation.executions }}</span><span ng-if=ctrl.rule.lastStr>{{ ctrl.rule.lastStr }}</span><span ng-if=\"!ctrl.rule.lastStr &amp;&amp; !ctrl.loadExecutions\">{{ translation.not_executed }}</span></div></md-list-item><md-list-item layout=row><div flex=30>{{ translation.next }} {{ translation.execution }}:</div><div flex=70 ng-if=\"ctrl.loading == true\"><skeleton-loader type=sk-box></skeleton-loader></div><div flex=70 ng-if=\"ctrl.loading == false\"><span ng-if=ctrl.rule.schedule.length>{{ ctrl.rule.nextStr }}</span><span ng-if=!ctrl.rule.schedule.length>Not Set</span></div></md-list-item><md-list-item layout=row ng-if=ctrl.executionError><div flex=30>Error:</div><div flex=70 ng-if=\"ctrl.loading == true\"><skeleton-loader type=sk-box></skeleton-loader></div><div flex=70 ng-if=\"ctrl.loading == false\"><span>{{ ctrl.executionError }}</span></div></md-list-item></md-list></div><div flex=60><md-content><div ng-if=\"ctrl.loading == true\"><br><skeleton-loader type=sk-box></skeleton-loader></div><div ng-if=\"ctrl.loading == false\"><div ui-grid=ctrl.gridOptions ui-grid-edit ui-grid-cellnav ui-grid-selection style=\"height: 206px\" class=myGrid></div></div></md-content></div></section></md-dialog-content><md-dialog-actions><md-progress-linear ng-show=ctrl.rule.onProgress></md-progress-linear><p ng-if=!ctrl.rule.liveVersion class=\"red-text m0\"><b><md-icon md-font-set=material-icons class=red-text>error</md-icon>&nbsp; {{ translation.need_version_to_execute }}</b></p><md-button ng-show=!ctrl.rule.onProgress ng-click=ctrl.testExecution() ng-disabled=!ctrl.rule.liveVersion class=\"md-raised md-primary\">{{ translation.execute }} {{ translation.now || lowercase }}</md-button>&nbsp; &nbsp; | &nbsp;<md-button ng-if=ctrl.showsave ng-show=!ctrl.rule.onProgress ng-click=ctrl.save() ng-disabled=ctrl.loading class=\"md-raised green white-text\">{{ translation.save }}</md-button><md-button ng-show=!ctrl.rule.onProgress ng-click=ctrl.cancel() ng-disabled=ctrl.loading class=md-raised>{{ translation.close }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/schemas/components/bulk-schemas-import-dialog/bulk-schemas-import-dialog.html","<md-dialog id=bulk-schemas-import-dialog aria-label=\"Bulk schemas import dialog\" style=\"width: 50vw\"><md-toolbar class=main-color><div class=md-toolbar-tools><h2>Import Schemas</h2><span flex></span><md-button onclick=document.getElementById(&quot;importArea&quot;).click() ng-if=\"!newSchemaDef &amp;&amp; !selectedSchema\">Select JSON files</md-button><div style=display:none><input id=importArea type=file file-import file-imported-data=ctrl.importedData multiple accept=.json></div><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog button\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding: 5px\"><div ng-if=!ctrl.importedSchemas>First select one or more schemas json files to import s</div><md-list><md-list-item ng-repeat=\"schema in ctrl.importedSchemas\" style=\"padding: 5px\"><md-divider></md-divider><div layout=columns class=w100><div><span>Name:&nbsp;</span><b>{{ schema.name }}</b><br><span>Group:&nbsp;</span><b>{{ schema.group }}</b><br><span>Type:&nbsp;</span><b>{{ schema.type }}</b></div><span flex></span><div class=text-right><div ng-switch on=schema.isValid><md-progress-circular ng-switch-when=pending md-mode=indeterminate md-diameter=20 style=\"margin-right: 3px\"></md-progress-circular><md-icon ng-switch-when=true md-font-set=material-icons style=\"color: green\">check_circle_outline</md-icon><md-icon ng-switch-when=false md-font-set=material-icons style=\"color: red\">error_outline</md-icon></div><br><div>{{ schema.errorMsg }}</div></div></div></md-list-item></md-list></md-dialog-content><md-dialog-actions layout=columns class=w100><div flex=30 style=\"text-align: right\"><md-button ng-click=ctrl.cancel()>{{ translation.cancel }}</md-button><md-button ng-show=ctrl.validatePermission(&quot;schema:create&quot;) ng-click=ctrl.save()>{{ translation.save }}</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/schemas/components/schema-group-item/schema-group-item.html","<md-list-item style=\"border-bottom: 1px solid #dedcdc\" ng-click=ctrl.toggleItems() class=\"md-3-line item-report\"><div layout=row layout-align=\"center center\" layout-padding><div><md-icon ng-if=\"ctrl.displayItems==false\" md-font-set=material-icons class=color-data>folder_open</md-icon><md-icon ng-if=\"ctrl.displayItems==true\" md-font-set=material-icons class=color-data>folder</md-icon></div><div><h3><b>{{ ctrl.group.groupName }}:&nbsp;</b></h3><span><b>{{ ctrl.group.subGroup.length }}&nbsp;</b>{{ ctrl.translation.folder }}s</span>&nbsp; &nbsp;<span><b>{{ ctrl.group.items.length }}&nbsp;</b>Items</span></div></div><md-button style=\"padding: 0.8rem\" aria-label=\"Display items button\" title=\"Toggle group\" class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>{{ ctrl.displayItems ? \'keyboard_arrow_up\' : \'keyboard_arrow_down\' }}</md-icon></md-button></md-list-item><section ng-show=\"ctrl.group.isOpen==true\" style=\"margin: 0px 0px 0px 4rem; border-left: 4px solid rgb(202 196 196)\"><div><md-list-item style=\"border-bottom: 1px solid #eaeaea; padding: 1.8rem\" class=md-2-line><div layout=row class=md-list-item-text><md-button has-permission=schema:create ng-click=\"ctrl.showCreateSchemaDialog($event, false, false)\" aria-label=\"{{ ctrl.translation.add_schema }}\"><md-icon md-font-set=material-icons style=\"position: relative; top: 3px\">add</md-icon><b>{{ ctrl.translation.add_schema }}</b></md-button><md-button has-permission=schema:read ng-click=ctrl.exportSchemas() aria-label=\"Export schemas button\"><md-icon md-font-set=material-icons style=\"position: relative; top: 3px\">file_download</md-icon><b>{{ ctrl.translation.export }} {{ ctrl.translation.schema }}s</b></md-button></div></md-list-item></div><div ng-repeat=\"group in ctrl.group.subGroup track by $index\"><schema-group-item group=group display-items=ctrl.displayItems translation=ctrl.translation></schema-group-item></div><div ng-repeat=\"schema in ctrl.group.items track by $index\"><schema-list-item schema=schema translation=ctrl.translation></schema-list-item></div></section>");
$templateCache.put("app/schemas/components/schema-list-item/schema-list-item.html","<md-list-item id=schema-{{ctrl.schema.name}} class=\"md-3-line item-report\"><div layout=row flex=80 layout-padding><div flex=40><h4><span>{{ ctrl.translation.schema }}: {{ ctrl.schema.name }}</span><cep-icon flex=10 icon=\"{{ ctrl.schema.icon }}\" scale=1 style=\"margin-left: 5px; position: relative; top: 3px\"></cep-icon></h4><div ng-if=ctrl.schema.description><span style=\"word-break: break-all\">{{ ctrl.schema.description }}</span></div><div><span style=\"word-break: break-all\">- {{ ctrl.translation.type }}: {{ ctrl.schema.type | lowercase | capitalize }}</span><br><span style=\"word-break: break-all\">- Id: {{ ctrl.schema.id }}</span></div></div><div flex=60><span>{{ ctrl.translation.columns }}:</span><div style=\"height:100px; overflow:auto\"><ul style=column-count:2><li ng-repeat=\"(key, item) in ctrl.schema.schema.definitions[ctrl.schema.name].properties\"><b>{{ key }}</b><span>({{ item.type }})</span><span ng-if=item.pk>[pk]</span><span ng-if=item.required>[required]</span><span ng-if=item.ref><md-icon md-font-set=material-icons>keyboard_arrow_right<md-tooltip>Reference</md-tooltip></md-icon><span>{{ item.ref }}</span></span><span ng-if=item.description>&nbsp;- {{ item.description }}</span></li></ul></div></div></div><md-button has-permission=schema#{{ctrl.schema.id}}:read ng-click=\"ctrl.showCreateSchemaDialog($event, ctrl.schema)\" style=\"padding: .8rem\" aria-label=\"{{ ctrl.translation.edit }}\" class=\"md-icon-button md-secondary text-main-color btn-schema-edit\"><md-icon md-font-set=material-icons>edit</md-icon><md-tooltip>{{ ctrl.translation.edit }}</md-tooltip></md-button><md-button has-permission=schema#{{ctrl.schema.id}}:create ng-click=\"ctrl.showCreateSchemaDialog($event, ctrl.schema, true)\" style=\"padding: .8rem\" aria-label=\"{{ ctrl.translation.copy }}\" class=\"md-icon-button md-secondary text-main-color btn-schema-copy\"><md-icon md-font-set=material-icons>filter_none</md-icon><md-tooltip>{{ ctrl.translation.copy }}</md-tooltip></md-button><md-button has-permission=schema#{{ctrl.schema.id}}:delete ng-click=\"ctrl.deleteSchema($event, ctrl.schema)\" style=\"padding: .8rem\" aria-label=\"{{ ctrl.translation.delete }}\" class=\"md-icon-button md-secondary text-main-color btn-schema-delete\"><md-icon md-font-set=material-icons>delete</md-icon><md-tooltip>{{ ctrl.translation.delete }}</md-tooltip></md-button><md-button has-permission=schema#{{ctrl.schema.id}}:share ng-click=\"ctrl.showShareEntityDialog($event, ctrl.schema)\" style=\"padding: .8rem\" aria-label=\"{{ ctrl.translation.share }}\" class=\"md-icon-button md-secondary text-main-color btn-schema-share\"><md-icon md-font-set=material-icons>share</md-icon><md-tooltip>{{ ctrl.translation.share }}</md-tooltip></md-button><md-button has-permission=schema#{{ctrl.schema.id}}:read ng-click=ctrl.exportSchema(ctrl.schema) style=\"padding: 0.8rem\" aria-label=\"Export schema button\" class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>file_download</md-icon><md-tooltip>{{ ctrl.translation.export }} {{ ctrl.translation.schema }}</md-tooltip></md-button><btn-bookmark style=\"padding: 0.8rem\" entity-id=ctrl.schema.id entity-name=ctrl.schema.name entity-type=\"\'schema\'\" role=button-schema-bookmark has-permission=schema#{{ctrl.schema.id}}:read class=\"md-icon-button md-secondary text-main-color md-button md-ink-ripple\"></btn-bookmark></md-list-item>");
$templateCache.put("app/schemas/partials/create-schema/dialog-create-schemas.html","<md-dialog aria-label=\"{{ translation.add_schema }}\" style=\"width: 100vw\"><form><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ actionText + schemaName }}******</h2><span flex></span><md-button ng-click=cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"{{ translation.general }}\" md-on-select=\"activeTab = \'info\'; buildSchema();\"><md-content class=md-padding><div layout=row style=\"border-bottom: 1px solid #e0e0e0; margin-top: 10px\"><md-input-container flex=20 class=\"m0 p0\"><md-switch name=mustCreateList ng-model=mustCreateList style=\"position: relative; top: -15px\" aria-label=\"List creation selector\" class=\"m0 p0 md-primary\">{{ translation.add_list }}</md-switch></md-input-container></div><div layout=row style=\"margin-top: 10px\"><md-input-container flex=30 style=\"margin-right: 15px\"><label>Schema - {{ translation.name }}</label><input ng-model=schemaName name=schemaName aria-label=\"Schema name input\" required ng-disabled=\"selectedSchema.schema_usage &gt; 0 || selectedSchema.function_usage &gt; 0\"><div style=\"font-size: 0.9em; color: gray\" ng-if=\"selectedSchema.schema_usage &gt; 0 || selectedSchema.function_usage &gt; 0\" class=hint>{{ translation.schema_in_use }}</div></md-input-container><md-input-container flex=15 style=\"margin-right: 15px\"><label>{{ translation.type }}</label><select ng-model=schemaType aria-label=\"Schema type selector\" placeholder=\"\" class=select-filters-modal><option ng-repeat=\"type in schemaTypes\" ng-value=type>{{ type | lowercase | capitalize }}</option></select></md-input-container><md-input-container flex=10 style=\"margin-right: 15px\"><label>Icon</label><input ng-model=schemaIcon name=schemaIcon aria-label=\"Schema icon selector\"><md-tooltip>{{ translation.icon_selector_tooltip }}</md-tooltip></md-input-container><cep-icon flex=10 icon=\"{{ schemaIcon }}\" scale=2></cep-icon><md-input-container flex style=\"margin-right: 15px\" ng-show=mustCreateList><label>{{ translation.list }} - {{ translation.name }}</label><input ng-model=listName name=listName aria-label=\"List name input\" ng-required=mustCreateList ng-disabled=\"selectedSchema.schema_usage &gt; 0 || selectedSchema.function_usage &gt; 0\"><div style=\"font-size: 0.9em; color: gray\" ng-if=\"selectedSchema.schema_usage &gt; 0 || selectedSchema.function_usage &gt; 0\" class=hint>{{ translation.schema_in_use }}</div></md-input-container></div><div layout=row><md-input-container flex=30 style=\"margin-right: 15px\"><label>{{ translation.display }}</label><input ng-model=schemaDisplay name=schemaDisplay aria-label=translation.display></md-input-container><div flex=25 style=\"margin-right: 15px\"><label>Group</label><div ng-if=\"loadingDialog == false\"><span>{{ listGroups }}</span><md-button ng-click=moveItemGroup() class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>folder_copy</md-icon><md-tooltip>Move</md-tooltip></md-button></div><div ng-if=\"loadingDialog == true\"><md-progress-circular md-mode=indeterminate md-diameter=20px></md-progress-circular><br></div></div></div><div layout=row><md-input-container flex=50><label>{{ translation.description }}</label><input ng-model=schemaDescription name=schemaDescription aria-label=translation.description></md-input-container><md-input-container flex=50><label>{{ translation.label }}</label><select ng-model=labelId aria-label=\"{{ translation.label }}\" placeholder=\"\" required class=select-filters-modal><option ng-repeat=\"label in labelList.data\" ng-value=label.labelId>{{ translation.label + \'.\' + label.labelName }}</option></select></md-input-container></div></md-content></md-tab><md-tab label=\"{{ translation.columns }}\" md-on-select=\"activeTab = \'columns\';\"><div ng-if=!loadingSchemaGrid><md-content style=\"min-height: 300px\" class=md-padding><div ui-grid=gridOptions ui-grid-edit ui-grid-cellnav ui-grid-selection ui-grid-resize-columns style=\"min-height: 300px\" class=myGrid></div></md-content></div></md-tab><md-tab label=\"{{ translation.schema }}\" md-on-select=\"activeTab = \'schema\'; buildSchema();\"><md-content style=\"min-height: 450px\" class=md-padding><div style=\"height: 580px\" ng-model=mySchemaJson ui-ace=\"{ useWrapMode : true, showGutter: true, theme:\'twilight\', mode: \'json\', rendererOptions: { minLines: 3 }, onChange: aceChanged }\"></div></md-content></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=columns class=w100><div flex=70><md-button ng-click=moveRow(0) ng-show=\"activeTab == \'columns\'\" ng-disabled=!rowEntity>{{ translation.move_down }}</md-button><md-button ng-click=moveRow(1) ng-show=\"activeTab == \'columns\'\" ng-disabled=!rowEntity>{{ translation.move_up }}</md-button><md-button ng-disabled=!validatePermission() ng-click=addRow() ng-show=\"activeTab == \'columns\'\">{{ translation.addrow }}</md-button></div><div flex=30 style=\"text-align: right\"><md-button ng-click=cancel()>{{ translation.cancel }}</md-button><md-button ng-show=validatePermission() ng-click=createSchema($event)>{{ translation.save }}</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/schemas/partials/hot-create-schema/hot-dialog-create-schemas.html","<md-dialog aria-label=\"{{ translation.add_schema }}\" style=\"width: 100vw\" ng-cloak><form><md-toolbar class=main-color><div class=md-toolbar-tools><h2>{{ actionText + schemaName }}</h2><span flex></span><md-button ng-click=cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog button\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"{{ translation.general }}\" md-on-select=\"activeTab = &quot;info&quot;; buildSchema();\"><md-content class=md-padding><div layout=row layout-align=\"start center\" style=\"border-bottom: 1px solid #e0e0e0; margin-top: 10px\"><md-input-container flex=20 class=\"m0 p0\"><md-switch name=mustCreateList ng-model=mustCreateList style=\"position: relative; top: -15px\" aria-label=\"List creation selector\" class=\"m0 p0 md-primary\">{{ translation.add_list }}</md-switch></md-input-container><md-input-container flex ng-show=mustCreateList class=\"m0 p0\"><label>{{ translation.list }} - {{ translation.name }}</label><input ng-model=listName name=listName aria-label=\"List name input\" ng-required=mustCreateList ng-disabled=\"selectedSchema.schema_usage &gt; 0 || selectedSchema.function_usage &gt; 0\"><div style=\"font-size: 0.9em; color: gray\" ng-if=\"selectedSchema.schema_usage &gt; 0 || selectedSchema.function_usage &gt; 0\" class=hint>{{ translation.schema_in_use }}</div></md-input-container></div><div layout=row style=\"margin-top: 10px\"><md-input-container flex=50 style=\"margin-right: 15px\"><label>Schema - {{ translation.name }}</label><input ng-model=schemaName name=schemaName aria-label=\"Schema name input\" required ng-disabled=\"selectedSchema.schema_usage &gt; 0 || selectedSchema.function_usage &gt; 0\"><div style=\"font-size: 0.9em; color: gray\" ng-if=\"selectedSchema.schema_usage &gt; 0 || selectedSchema.function_usage &gt; 0\" class=hint>{{ translation.schema_in_use }}</div></md-input-container><md-input-container flex=30 style=\"margin-right: 15px\"><label>{{ translation.type }}</label><select ng-model=schemaType aria-label=\"Schema type selector\" placeholder=\"\" class=select-filters-modal><option ng-repeat=\"type in schemaTypes\" ng-value=type>{{ type | lowercase | capitalize }}</option></select></md-input-container><md-input-container flex=20 style=\"margin-right: 15px\"><label>Icon</label><input ng-model=schemaIcon name=schemaIcon aria-label=\"Schema icon selector\"><md-tooltip>{{ translation.icon_selector_tooltip }}</md-tooltip></md-input-container><cep-icon flex=10 icon=\"{{ schemaIcon }}\" scale=2></cep-icon></div><div layout=row><md-input-container flex=50 style=\"margin-right: 15px\"><label>{{ translation.display }}</label><input ng-model=schemaDisplay name=schemaDisplay aria-label=translation.display></md-input-container><div flex=50 style=\"margin-right: 15px\"><label>Group</label><div ng-if=\"loadingDialog == false\"><span>{{ schemaGroup }}</span><md-button ng-click=moveItemGroup() class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>folder_copy</md-icon><md-tooltip>Move</md-tooltip></md-button></div><div ng-if=\"loadingDialog == true\"><md-progress-circular md-mode=indeterminate md-diameter=20px></md-progress-circular><br></div></div></div><div layout=row><md-input-container flex=50><label>{{ translation.description }}</label><input ng-model=schemaDescription name=schemaDescription aria-label=translation.description></md-input-container><md-input-container flex=50><label>{{ translation.label }}</label><select ng-model=labelId aria-label=\"{{ translation.label }}\" placeholder=\"\" required class=select-filters-modal><option ng-repeat=\"label in labelList.data\" ng-value=label.labelId>{{ translation.label + \'.\' + label.labelName }}</option></select></md-input-container></div></md-content></md-tab><md-tab label=\"{{ translation.columns }}\" md-on-select=\"activeTab = &quot;columns&quot;;\"><md-content style=\"min-height: 400px\" ng-if=!loadingSchemaGrid><hot-table hot-id=schema-columns-table settings=ctrl.tableSettings datarows=gridOptions.data columns=ctrl.tableColumns class=w100></hot-table></md-content></md-tab><md-tab label=\"{{ translation.schema }}\" md-on-select=\"activeTab = &quot;schema&quot;; buildSchema();\"><md-content style=\"min-height: 450px\" class=md-padding><div style=\"height: 580px\" ng-model=mySchemaJson ui-ace=\"{ useWrapMode : true, showGutter: true, theme:&quot;twilight&quot;, mode: &quot;json&quot;, rendererOptions: { minLines: 3 }, onChange: aceChanged }\"></div></md-content></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=columns class=w100><div flex=70><md-button ng-click=moveRow(0) ng-show=\"activeTab == &quot;columns&quot;\" ng-disabled=!rowEntity>{{ translation.move_down }}</md-button><md-button ng-click=moveRow(1) ng-show=\"activeTab == &quot;columns&quot;\" ng-disabled=!rowEntity>{{ translation.move_up }}</md-button><md-button ng-disabled=!validatePermission() ng-click=addRow() ng-show=\"activeTab == &quot;columns&quot;\">{{ translation.addrow }}</md-button></div><div flex=30 style=\"text-align: right\"><md-button ng-click=cancel()>{{ translation.cancel }}</md-button><md-button ng-show=validatePermission() ng-click=createSchema($event)>{{ translation.save }}</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/searcher/components/searcher-filters-dialog/searcher-filters-dialog.html","<md-dialog aria-label=\"Issues filters dialog\"><form><md-dialog-content style=\"min-width: 600px; max-width: 800px; max-height: 810px; padding: 5px\"><b style=\"font-weight: 600\">Filter by {{ ctrl.column.name }}</b><md-divider style=\"margin-bottom: 5px\"></md-divider><div layout=row><md-input-container flex class=no-padding-no-margin><label>Condition</label><md-select ng-model=ctrl.predicate.operation placeholder=\"\" aria-label=\"Filter operation selection\" required><md-option ng-repeat=\"operation in ctrl.columnFilters.operations\" ng-value=operation>{{ operation }}</md-option></md-select></md-input-container><md-input-container flex=60 ng-switch=ctrl.columnFilters.component><label ng-if=\"ctrl.columnFilters.component != &quot;boolean&quot;\">Value</label><input ng-switch-when=TEXT|text|NUMBER|number|string ng-switch-when-separator=| ng-model=ctrl.predicate.value name=filterConditionValue ng-required=$parent.valueRequired autocomplete=off aria-label=\"Filter value field\"><md-select ng-switch-when=SELECTION|selection ng-switch-when-separator=| ng-model=ctrl.predicate.values ng-change=ctrl.onPredicateValuesChanges() multiple placeholder=\"\" aria-label=\"Filter value selector\" required><md-option ng-repeat=\"metadata in ctrl.columnFilters.metadata\" ng-value=metadata.key>{{ metadata.value }}</md-option></md-select><input ng-switch-when=calendar ng-switch-when-separator=| ng-model=ctrl.predicate.value mdc-datetime-picker=\"\" date=true time=false type=text short-time=true show-todays-date=true click-outside-to-close=true placeholder=Date auto-ok=true format=DD-MM-YYYY edit-input=false show-icon=true ng-model-options=\"{timezone: &quot;utc&quot;}\" class=md-input><div ng-switch-when=boolean style=\"position: absolute; top: -10px\"><label style=\"font-size: 0.7em; color: #5a2c7e; margin-bottom: 16px\">Value</label><md-switch ng-model=ctrl.predicate.value value=true aria-label=\"Boolean filter selector\">{{ ctrl.predicate.value ? \"true\" : \"false\" }}</md-switch></div><input ng-switch-default aria-label=\"Unhandled value field\" placeholder=\"Unhandled filter type: {{ ctrl.columnFilters.component }}\" readonly></md-input-container></div></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button ng-click=ctrl.cancel() class=md-raised>Cancel</md-button><md-button ng-click=ctrl.applyFilters() class=\"md-raised green white-text\">Filter</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/usuarios/components/user-form/password-policy.html","<span>{{ ctrl.translation.password_rules }}<p ng-if=\"ctrl.passwordPolicy.minimumPasswordLength &amp;&amp; ctrl.passwordPolicy.minimumPasswordLength &gt; 0\" ng-class=\"ctrl.passwordPolicy.minimumPasswordLengthGreen ? &quot;green-text&quot;:&quot;red-text&quot;\"><md-icon ng-class=\"ctrl.passwordPolicy.minimumPasswordLengthGreen ? &quot;green-text&quot;:&quot;red-text&quot;\">{{ ctrl.passwordPolicy.minimumPasswordLengthGreen ? \'check_circle\' : \'cancel\' }}</md-icon>{{ ctrl.translation.password_length_1 }} {{ ctrl.passwordPolicy.minimumPasswordLength }} {{ ctrl.translation.password_length_2 }}</p><p ng-if=ctrl.passwordPolicy.withAtLeastOneUppercase ng-class=\"ctrl.passwordPolicy.withAtLeastOneUppercaseGreen ? &quot;green-text&quot;:&quot;red-text&quot;\"><md-icon ng-class=\"ctrl.passwordPolicy.withAtLeastOneUppercaseGreen ? &quot;green-text&quot;:&quot;red-text&quot;\">{{ ctrl.passwordPolicy.withAtLeastOneUppercaseGreen ? \'check_circle\' : \'cancel\' }}</md-icon>{{ ctrl.translation.at_least_one_uppercase_character }}</p><p ng-if=ctrl.passwordPolicy.withAtLeastOneLowercase ng-class=\"ctrl.passwordPolicy.withAtLeastOneLowercaseGreen ? &quot;green-text&quot;:&quot;red-text&quot;\"><md-icon ng-class=\"ctrl.passwordPolicy.withAtLeastOneLowercaseGreen ? &quot;green-text&quot;:&quot;red-text&quot;\">{{ ctrl.passwordPolicy.withAtLeastOneLowercaseGreen ? \'check_circle\' : \'cancel\' }}</md-icon>{{ ctrl.translation.at_least_one_lowercase_character }}</p><p ng-if=ctrl.passwordPolicy.withAtLeastOneDigit ng-class=\"ctrl.passwordPolicy.withAtLeastOneDigitGreen ? &quot;green-text&quot;:&quot;red-text&quot;\"><md-icon ng-class=\"ctrl.passwordPolicy.withAtLeastOneDigitGreen ? &quot;green-text&quot;:&quot;red-text&quot;\">{{ ctrl.passwordPolicy.withAtLeastOneDigitGreen ? \'check_circle\' : \'cancel\' }}</md-icon>{{ ctrl.translation.at_least_one_digit }}</p><p ng-if=ctrl.passwordPolicy.withAtLeastOneSymbol ng-class=\"ctrl.passwordPolicy.withAtLeastOneSymbolGreen ? &quot;green-text&quot;:&quot;red-text&quot;\"><md-icon ng-class=\"ctrl.passwordPolicy.withAtLeastOneSymbolGreen ? &quot;green-text&quot;:&quot;red-text&quot;\">{{ ctrl.passwordPolicy.withAtLeastOneSymbolGreen ? \'check_circle\' : \'cancel\' }}</md-icon>{{ ctrl.translation.at_least_one_special_character }}</p></span>");
$templateCache.put("app/usuarios/components/user-form/user-form.html","<form name=pwsForm novalidate autocomplete=off><section layout=row layout-wrap><div flex=60><md-card id=basic-data><md-toolbar class=\"border-detail white text-main-color\"><div layout=row><h4 flex=\"\" md-truncate=\"\" class=md-toolbar-tools><span>{{ ctrl.translation.DATA_BASIC }}</span></h4></div></md-toolbar><md-card-content layout=row layout-wrap layout-align=\"space-around center\"><div flex=45><md-input-container class=w100><span>{{ ctrl.translation.NOMBRE }}</span> <input type=text name=firstName md-maxlength=50 maxlength=50 required ng-model=ctrl.userModel.name aria-label=name autocomplete=off><div ng-messages=userForm.firstName.$error multiple md-auto-hide=false><div ng-message=required>{{ ctrl.translation.REQUIRED }}</div></div></md-input-container></div><div flex=45><md-input-container class=w100><span>{{ ctrl.translation.APELLIDO }}</span> <input type=text name=userLastname md-maxlength=50 maxlength=50 required ng-model=ctrl.userModel.lastName aria-label=lastName><div ng-messages=userForm.userLastname.$error multiple md-auto-hide=false><div ng-message=required>{{ ctrl.translation.REQUIRED }}</div></div></md-input-container></div><div flex=45><md-input-container class=w100><span>{{ ctrl.translation.color }}</span> <input color-picker color-picker-model=ctrl.userModel.color color-picker-position=right ng-style=\"{ background: ctrl.userModel.color }\" type=text ng-model=ctrl.userModel.color readonly required aria-label=color><div ng-messages=userForm.color.$error multiple md-auto-hide=false><div ng-message=required>{{ ctrl.translation.REQUIRED }}</div></div></md-input-container></div><div flex=45><md-input-container class=w100><span>{{ ctrl.translation.USERNAME }}</span> <input type=text name=username md-maxlength=30 maxlength=30 required ng-model=ctrl.userModel.username aria-label=username autocomplete=off><div ng-messages=userForm.username.$error multiple md-auto-hide=false><div ng-message=required>{{ ctrl.translation.REQUIRED }}</div></div></md-input-container></div><div flex=45><md-input-container class=w100><span>{{ ctrl.translation.EMAIL }}</span> <input type=email name=email md-maxlength=50 maxlength=50 ng-required=false ng-model=ctrl.userModel.email aria-label=email autocomplete=off><div ng-messages=userForm.email.$error multiple md-auto-hide=false><div ng-message=required>{{ ctrl.translation.REQUIRED }}</div></div></md-input-container></div><div flex=45><md-input-container class=w100><span>{{ ctrl.translation.IDIOMA | lowercase | capitalize }}</span><md-select name=lang ng-model=ctrl.userModel.lang required md-select-only-option aria-label=lang><md-option ng-value=lang.value ng-repeat=\"lang in ctrl.userLangs\">{{ lang.type }}</md-option></md-select><div ng-messages=userForm.lang.$error multiple md-auto-hide=false><div ng-message=required>{{ ctrl.translation.REQUIRED }}</div></div></md-input-container></div><div flex=45><md-input-container class=w100><span>{{ ctrl.translation.region }}</span><md-select name=region ng-model=ctrl.userModel.region required aria-label=region><md-option ng-value=region ng-repeat=\"region in ctrl.userRegions\">{{ region }}</md-option></md-select></md-input-container></div><div flex=45><md-input-container class=w100><span>{{ ctrl.translation.ZONA_HORARIA }}</span><md-select name=timezone ng-model=ctrl.userModel.timeZone required aria-label=timeZone><md-option ng-value=tz.value ng-repeat=\"tz in ctrl.timesZones\">{{ tz.type }}</md-option></md-select><div ng-messages=userForm.timezone.$error multiple md-auto-hide=false><div ng-message=required>{{ ctrl.translation.REQUIRED }}</div></div></md-input-container></div></md-card-content></md-card><md-card id=Company><md-toolbar class=\"border-detail white text-main-color\"><div layout=row><h4 flex=\"\" md-truncate=\"\" class=md-toolbar-tools><span>{{ ctrl.translation.COMPANY }}</span></h4></div></md-toolbar><md-card-content layout=row layout-wrap layout-align=\"space-around center\"><div flex=45><md-input-container class=w100><span>{{ ctrl.translation.NOMBRE }}</span><md-select name=company ng-model=ctrl.userModel.company.companyId required ng-change=ctrl.changeCompany() aria-label=company><md-option ng-value=option.id ng-repeat=\"option in ctrl.companies\">{{ option.name }}</md-option></md-select><div ng-messages=userForm.company.$error multiple md-auto-hide=false><div ng-message=required>{{ ctrl.translation.REQUIRED }}</div></div></md-input-container></div><div flex=45><md-input-container class=w100><span>{{ ctrl.translation.DEPARTMENT }}</span> <input type=text name=department md-maxlength=50 maxlength=50 required ng-model=ctrl.userModel.company.department aria-label=department><div ng-messages=userForm.department.$error multiple md-auto-hide=false><div ng-message=required>{{ ctrl.translation.REQUIRED }}</div></div></md-input-container></div><div flex=100><md-input-container class=w100><span>Supervisor</span><md-select name=supervisor ng-model=ctrl.userModel.company.supervisor.userId aria-label=supervisor><md-option ng-value=option.userId ng-repeat=\"option in ctrl.usersCopmany\">{{ option.fullName }} ({{ option.profile.type }})</md-option></md-select><div ng-messages=userForm.supervisor.$error multiple md-auto-hide=false><div ng-message=required>{{ ctrl.translation.REQUIRED }}</div></div></md-input-container></div></md-card-content></md-card><md-card id=security-credencial ng-show=\"ctrl.loggedUser.userType === &quot;SA&quot; &amp;&amp; !ctrl.creation\"><md-toolbar class=\"border-detail white text-main-color\"><div layout=row><h4 flex=\"\" md-truncate=\"\" class=md-toolbar-tools><span>{{ ctrl.translation.CAMBIO_DE_PASSWORD }}</span></h4></div></md-toolbar><md-card-content><div layout=row><div flex=60 layout=row layout-wrap layout-align=\"center center\"><md-input-container flex=80 class=m0><span>Password</span> <input name=password type=\"{{ ctrl.showPassword ? &quot;text&quot; : &quot;password&quot; }}\" ng-model=ctrl.userPassword md-maxlength=35 required aria-label=userPassword role=presentation autocomplete=new-password></md-input-container><div flex=20><md-button class=\"md-fab md-mini white\"><md-icon ng-click=\"ctrl.showPassword = !ctrl.showPassword\">{{ ctrl.showPassword ? \'visibility\' : \'visibility_off\' }}</md-icon><md-tooltip md-direction=top>{{ ctrl.translation.SHOW_PASSWORD }}</md-tooltip></md-button></div><div flex=100><md-button ng-click=ctrl.generatePassword() class=md-raised><md-icon>lock</md-icon>Generate password</md-button></div></div><aside flex=40 style=\"padding-left: 10px\"><div ng-if=ctrl.passwordPolicy.showPasswordPolicy><ng-include src=&quot;app/usuarios/components/user-form/password-policy.html&quot;></ng-include></div><md-button type=button ng-click=ctrl.changePasswordV2() ng-disabled=\"ctrl.userPassword.length == 0\" class=\"md-raised main-color white-text\">{{ ctrl.translation.CAMBIO_DE_PASSWORD }}</md-button></aside></div><div layout=row><div flex=100><md-button type=button is-super-user ng-if=ctrl.disable2faButton ng-click=ctrl.disable2fa() ng-disabled=ctrl.loadingdisable2fa class=\"md-raised amber\"><md-icon>lock</md-icon>Disable 2FA</md-button></div></div></md-card-content></md-card></div><div flex><md-card id=security-permissions><md-toolbar class=\"border-detail white text-main-color\"><div layout=row><h4 flex=\"\" md-truncate=\"\" class=md-toolbar-tools><span>{{ ctrl.translation.SECURITY }} & {{ ctrl.translation.PERMISSION }}</span></h4></div></md-toolbar><md-card-content layout=row layout-wrap style=\"padding-bottom: 0\" layout-align=\"space-around center\"><div flex=45><md-input-container class=w100><span>{{ ctrl.translation.TIPO_DE_USUARIO }}</span><md-select name=userType ng-model=ctrl.userModel.profile.type required aria-label=userType><md-option ng-value=type.value ng-repeat=\"type in ctrl.userTypes\">{{ type.name }}</md-option></md-select><div ng-messages=userForm.userType.$error multiple md-auto-hide=false><div ng-message=required>{{ ctrl.translation.REQUIRED }}</div></div></md-input-container></div><div flex=45><md-input-container class=w100><span>{{ ctrl.translation.GROUP }}</span><md-select name=groups ng-model=ctrl.userModel.profile.groups multiple aria-label=groups><md-option ng-value=item.id ng-repeat=\"item in ctrl.userGroups\">{{ item.name }}</md-option></md-select><div ng-messages=userForm.groups.$error multiple md-auto-hide=false><div ng-message=required>{{ ctrl.translation.REQUIRED }}</div></div></md-input-container></div><div flex=90><md-input-container class=w100><span>{{ ctrl.translation.CATEGORIES }}</span><md-select name=categories ng-model=ctrl.userModel.profile.categories multiple aria-label=categories><md-option ng-value=item.id ng-repeat=\"item in ctrl.userCategories\">{{ item.name }}</md-option></md-select></md-input-container></div><div flex=90><md-checkbox ng-model=ctrl.userModel.active ng-true-value=&quot;t&quot; ng-false-value=&quot;f&quot; md-no-ink aria-label=active>{{ ctrl.translation.ACTIVO }}</md-checkbox></div><div flex=95 ng-if=ctrl.creation><md-checkbox ng-model=ctrl.userModel.sendPwsByMail ng-checked=true md-no-ink aria-label=sendPwsByMail>{{ ctrl.translation.welcome_notification }}</md-checkbox></div></md-card-content><md-card-content layout=row layout-wrap style=\"padding-top: 0\"><div style=\"width: 100%\" ng-if=\"ctrl.userPolicies.length &gt; 0\"><md-list style=\"max-height: 70vh; overflow: auto; padding-top: 0\"><md-list-item layout-padding=\"\" style=\"border-bottom: 1px solid #eaeaea; padding: 0.3rem; background: #ffffff; z-index: 1\" class=sticky-top><div flex=30>Resource</div><div flex=70>Action</div></md-list-item><md-list-item layout-padding=\"\" ng-repeat=\"item in ctrl.userPolicies track by $index\" style=\"border-bottom: 1px solid #eaeaea; padding: 0.3rem\"><div flex=30 ng-bind-html=ctrl.getResource(item)></div><div flex=70 ng-bind-html=ctrl.getAction(item)></div></md-list-item></md-list></div></md-card-content></md-card></div></section><div layout=column style=\"position: fixed; right: 30px; bottom: 47px; z-index: 10\"><md-button type=submit has-permission=user:create ng-if=ctrl.creation ng-click=ctrl.createUser() ng-disabled=userForm.$invalid class=\"md-fab md-mini main-color\"><md-icon class=white-text>save</md-icon><md-tooltip md-direction=left>{{ ctrl.translation.CREAR }}</md-tooltip></md-button><md-button type=button has-permission=user:update ng-if=!ctrl.creation ng-click=ctrl.updateUser() ng-disabled=userForm.$invalid class=\"md-fab md-mini green\"><md-icon class=white-text>save</md-icon><md-tooltip md-direction=left>{{ ctrl.translation.GUARDAR }}</md-tooltip></md-button><md-button type=button ng-click=ctrl.cancelEdition() class=\"md-fab md-mini red\"><md-icon class=white-text>close</md-icon><md-tooltip md-direction=left>{{ ctrl.translation.CANCELAR }}</md-tooltip></md-button></div></form>");
$templateCache.put("app/app-utils/components/file-preview/file-preview-dialog.html","<md-dialog aria-label=\"file preview\" style=\"overflow: unset\"><md-dialog-content style=\"min-width: 800px; max-width: 800px; max-height: 810px; padding: 5px; overflow: unset\"><file-preview file=ctrl.file issueuuid=ctrl.issueUuid></file-preview></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button ng-click=ctrl.cancel() aria-label=\"Cancel button\" class=md-raised>Cancel</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/app-utils/components/file-preview/file-preview.html","<div ng-if=ctrl.loading><h6 class=text-center>Loading...</h6><md-progress-linear md-mode=indeterminate></md-progress-linear></div><div ng-if=!ctrl.loading><div ng-if=\"ctrl.ext === \'image\'\"><img src=\"{{ ctrl.preview }}\" alt=\"Image preview\" style=\"width: 100%\"></div><div ng-if=\"ctrl.ext === \'video\'\"><video controls src=\"{{ ctrl.preview }}\" style=\"width: 100%\"></video></div><div ng-if=\"ctrl.ext === \'audio\'\"><audio controls src=\"{{ ctrl.preview }}\" style=\"width: 100%\"></audio></div><div ng-if=\"ctrl.ext === \'text\'\"><div ng-bind-html=ctrl.preview style=\"overflow: auto; height: 700px\"></div></div><div ng-if=\"ctrl.ext === \'document\'\"><iframe ng-src=\"{{ ctrl.preview }}\" frameborder=0 height=500 style=\"width: 100%; overflow: auto\"></iframe></div><div ng-if=\"ctrl.ext === \'other\'\"><h5>{{ ctrl.preview }}</h5></div></div>");
$templateCache.put("app/home/widgets/top-lists/top-lists.html","<div style=\"padding: 1.3em\" layout=column class=\"m0 h100\"><h4 class=widget-box-header><md-icon md-font-set=material-icons md-menu-align-target>list</md-icon>&nbsp; {{ ctrl.props.title }}</h4><md-content ng-if=\"ctrl.props.selected.length==0\"><div class=list-item><md-progress-linear md-mode=indeterminate></md-progress-linear></div></md-content><md-content flex layout=column ng-if=ctrl.permissionError><div class=text-center><br><md-icon style=\"font-size: 50px\" class=\"md-warn md-hue-1\">warning</md-icon><br><p>{{ ctrl.permissionError.message }}</p></div></md-content><md-content ng-if=ctrl.props.selected.length&gt;0><div id=sortable flex=\"\" ui-sortable ng-model=ctrl.props.selected class=\"m0 p0\"><div style=\"height: auto; min-height: auto\" ng-repeat=\"item in ctrl.props.selected track by $index\" ng-click=ctrl.viewList(item.listId) class=list-item><p style=\"white-space: nowrap\"></p><div class=\"fa fa-caret-right\"></div>&nbsp; {{ item.name }}<p></p></div></div></md-content></div>");
$templateCache.put("app/app-utils/components/table-data/components/text-search.html","<form id=text-search no-validate ng-submit=ctrl.onSearch() layout=row layout-align=\"start center\" class=w100><input type=text ng-model=ctrl.searchText placeholder=Search ng-disabled=ctrl.isLoading class=search-text> <button type=submit ng-disabled=\"!ctrl.searchText || ctrl.isLoading\" class=cep-btn><i class=\"fa fa-search\"></i>Search</button></form><md-progress-linear ng-if=ctrl.isLoading md-mode=indeterminate></md-progress-linear>");
$templateCache.put("app/app-utils/directives/cron-builder/includes/days_form.html","<div ng-click=dialog.dayToCron() class=list-group-item><input type=radio ng-model=dialog.dayMode value=every_day><label>Every day</label></div><div ng-click=dialog.dayToCron() class=list-group-item><input type=radio ng-model=dialog.dayMode value=every_day_starting_on_wewkday><label>Every<select id=from_day ng-model=dialog.input_day_on_fromday><option ng-repeat=\"day in daysOfWeek track by $index\" value=\"{{ $index + 1 }}\">{{ $index + 1 }}</option></select>&nbsp; day(s) starting on<select id=to_day ng-model=dialog.input_day_on_today><option ng-repeat=\"day in daysOfWeek track by $index\" value=\"{{ $index + 1 }}\">{{ day }}</option></select></label></div><div ng-click=dialog.dayToCron() class=list-group-item><input type=radio ng-model=dialog.dayMode value=every_day_starting_on_the_day><label>Every<select id=from_day ng-model=dialog.input_day_onthe_fromday><option ng-repeat=\"day in days track by $index\" value=\"{{ day }}\">{{ day }}</option></select>&nbsp; day(s) starting on the<select id=to_day ng-model=dialog.input_day_onthe_today><option ng-repeat=\"day in days track by $index\" value=\"{{ day }}\">{{ day }}</option></select></label></div><div ng-click=dialog.dayToCron() class=list-group-item><input type=radio ng-model=dialog.dayMode value=specific_day_of_the_week><label>Specific day of the week (choose one or many)</label><div layout=row layout-wrap><div flex ng-repeat=\"day in daysOfWeekAlies track by $index\"><input type=checkbox value=\"{{ day }}\" name=input_day_week_checkbox[] ng-checked=\"dialog.input_day_week_checkbox.indexOf(day) &gt; -1\" ng-click=\"toggleSelection(dialog.input_day_week_checkbox, day)\" class=day_checkbox>&nbsp; {{ day }}</div></div></div><div ng-click=dialog.dayToCron() class=list-group-item><input type=radio ng-model=dialog.dayMode value=specific_day_of_month><label>Specific day of month (choose one or many)</label><div layout=row layout-wrap><div flex=10 ng-repeat=\"day in daysOfMonth track by $index\"><input type=checkbox value=\"{{ day }}\" name=input_day_checkbox[] ng-checked=\"dialog.input_day_checkbox.indexOf(day) &gt; -1\" ng-click=\"toggleSelection(dialog.input_day_checkbox, day)\" class=day_checkbox>&nbsp; {{ day }}</div></div></div><div ng-click=dialog.dayToCron() class=list-group-item><input type=radio ng-model=dialog.dayMode value=on_the_last_day_of_the_month><label>On the last day of the month</label></div><div ng-click=dialog.dayToCron() class=list-group-item><input type=radio ng-model=dialog.dayMode value=on_the_last_weekday_of_the_month><label>On the last weekday of the month</label></div><div ng-click=dialog.dayToCron() class=list-group-item><input type=radio ng-model=dialog.dayMode value=on_the_last_specific_day_of_the_month><label>On the last<select id=to_day ng-model=dialog.input_day_last_day><option ng-repeat=\"day in daysOfWeek track by $index\" value=\"{{ $index + 1 }}\">{{ day }}</option></select>&nbsp; of the month</label></div><div ng-click=dialog.dayToCron() class=list-group-item><input type=radio ng-model=dialog.dayMode value=on_the_last_day_before_the_end_of_the_month checked><label>On the last<select id=from_day ng-model=dialog.input_day_on_fromdaymonth><option ng-repeat=\"day in days track by $index\" value=\"{{ day }}\">{{ day }}</option></select>&nbsp; day(s) before the end of the month</label></div>");
$templateCache.put("app/app-utils/directives/cron-builder/includes/hours_form.html","<div ng-click=dialog.hourToCron() class=list-group-item><input type=radio ng-model=dialog.hourMode value=every_hour checked><label>Every hour</label></div><div ng-click=dialog.hourToCron() class=list-group-item><input type=radio ng-model=dialog.hourMode value=every_hour_starting_at_hour><label>Every<select id=from_hour ng-model=dialog.input_hour_from><option ng-repeat=\"hour in hours track by $index\" value=\"{{ hour + 1 }}\">{{ hour + 1 }}</option></select>&nbsp; hour(s) starting at hour<select id=to_hour ng-model=dialog.input_hour_to><option ng-repeat=\"hour in hours track by $index\" value=\"{{ hour }}\">{{ hour }}</option></select></label></div><div ng-click=dialog.hourToCron() class=list-group-item><input type=radio ng-model=dialog.hourMode value=specific_hour><label>Specific hour (choose one or many)</label><div layout=row layout-wrap><div flex=10 ng-repeat=\"hour in hours track by $index\"><input type=checkbox value=\"{{ hour }}\" name=hour_checkbox[] ng-checked=\"dialog.input_hour_checkbox.indexOf(hour) &gt; -1\" ng-click=\"toggleSelection(dialog.input_hour_checkbox, hour)\" class=hour_checkbox>&nbsp; {{ hour }}</div></div></div><div ng-click=dialog.hourToCron() class=list-group-item><input type=radio ng-model=dialog.hourMode value=every_hour_between_hour_and_hour><label>Every hour between hour &nbsp;<select id=from_between_hour ng-model=dialog.input_hour_fron_between_hour><option ng-repeat=\"hour in hours track by $index\" value=\"{{ hour }}\">{{ hour }}</option></select>&nbsp; and hour &nbsp;<select id=to_between_hour ng-model=dialog.input_hour_to_between_hour><option ng-repeat=\"hour in hours track by $index\" value=\"{{ hour }}\">{{ hour }}</option></select></label></div>");
$templateCache.put("app/app-utils/directives/cron-builder/includes/minutes_form.html","<div ng-click=dialog.minuteToCron() class=list-group-item><input type=radio ng-model=dialog.minuteMode value=every_minute checked><label>Every minute</label></div><div ng-click=dialog.minuteToCron() class=list-group-item><input type=radio ng-model=dialog.minuteMode value=every_minute_starting_at_minute><label>Every<select id=from_minute ng-model=dialog.input_minute_from><option ng-repeat=\"minute in minutes track by $index\" value=\"{{ minute + 1 }}\">{{ minute + 1 }}</option></select>&nbsp; minute(s) starting at minute<select id=to_minute ng-model=dialog.input_minute_to><option ng-repeat=\"minute in minutes track by $index\" value=\"{{ minute }}\">{{ minute }}</option></select></label></div><div ng-click=dialog.minuteToCron() class=list-group-item><input type=radio ng-model=dialog.minuteMode value=specific_minute><label>Specific minute (choose one or many)</label><div layout=row layout-wrap><div flex=10 ng-repeat=\"min in minutes track by $index\"><input type=checkbox name=minute_checkbox[] value=\"{{ min }}\" ng-checked=\"dialog.input_minute_checkbox.indexOf(min) &gt; -1\" ng-click=\"toggleSelection(dialog.input_minute_checkbox, min)\" class=minute_checkbox>&nbsp;{{ min }}</div></div></div><div ng-click=dialog.minuteToCron() class=list-group-item><input type=radio ng-model=dialog.minuteMode value=every_minute_between_minute><label>Every minute between minute &nbsp;<select id=from_between_minute ng-model=dialog.input_minute_from_between><option ng-repeat=\"minute in minutes track by $index\" value=\"{{ minute }}\">{{ minute }}</option></select>&nbsp; and minute &nbsp;<select id=to_between_minute ng-model=dialog.input_minute_to_between><option ng-repeat=\"minute in minutes track by $index\" value=\"{{ minute }}\">{{ minute }}</option></select></label></div>");
$templateCache.put("app/app-utils/directives/cron-builder/includes/month_form.html","<div ng-click=dialog.monthToCron() class=list-group-item><input type=radio ng-model=dialog.monthMode value=every_month><label>Every month</label></div><div ng-click=dialog.monthToCron() class=list-group-item><input type=radio ng-model=dialog.monthMode value=every_month_starting_in><label>Every<select id=from_day ng-model=dialog.input_month_from><option ng-repeat=\"x in [].constructor(12) track by $index\" value=\"{{ $index + 1 }}\">{{ $index + 1 }}</option></select>&nbsp; month(s) starting in<select id=to_day ng-model=dialog.input_month_to><option ng-repeat=\"month in months track by $index\" value=\"{{ $index + 1 }}\">{{ month }}</option></select></label></div><div ng-click=dialog.monthToCron() class=list-group-item><input type=radio ng-model=dialog.monthMode value=specific_month><label>Specific month (choose one or many)</label><div layout=row layout-wrap><div flex=10 ng-repeat=\"month in monthsAlies track by $index\"><input type=checkbox name=month_checkbox[] value=\"{{ month }}\" ng-checked=\"dialog.input_month_checkbox.indexOf(month) &gt; -1\" ng-click=\"toggleSelection(dialog.input_month_checkbox, month)\" class=month_checkbox>&nbsp;{{ month }}</div></div></div><div ng-click=dialog.monthToCron() class=list-group-item><input type=radio ng-model=dialog.monthMode value=every_month_between_month><label>Every month between &nbsp;<select id=from_between_month ng-model=dialog.input_month_from_between><option ng-repeat=\"month in months track by $index\" value=\"{{ $index + 1 }}\">{{ month }}</option></select>&nbsp; and &nbsp;<select id=to_between_month ng-model=dialog.input_month_to_between><option ng-repeat=\"month in months track by $index\" value=\"{{ $index + 1 }}\">{{ month }}</option></select></label></div>");
$templateCache.put("app/app-utils/directives/cron-builder/includes/seconds_form.html","<div ng-click=dialog.secondsToCron()><input type=radio ng-model=dialog.secondMode value=second_mode_1 checked><label>Every second</label></div><div ng-click=dialog.secondsToCron()><input type=radio ng-model=dialog.secondMode value=second_mode_2><label>Every<select id=from_second name=from_second><option ng-repeat=\"x in [].constructor(59) track by $index\" value=\"{{ $index + 1 }}\">{{ $index + 1 }}</option></select>&nbsp; second(s) starting at second<select id=to_second name=to_second><option ng-repeat=\"x in [].constructor(59) track by $index\" value=\"{{ $index }}\">{{ $index }}</option></select></label></div><div ng-click=dialog.secondsToCron()><input type=radio ng-model=dialog.secondMode value=second_mode_3><label>Especific second (choose one or many)</label><div layout=row layout-wrap><div flex=10 ng-repeat=\"x in [].constructor(59) track by $index\"><input type=checkbox value=\"{{ $index }}\" class=second_checkbox>{{ $index }}</div></div></div><div ng-click=dialog.secondsToCron()><input type=radio ng-model=dialog.secondMode value=second_mode_4><label>Every second between second &nbsp;<select id=from_between_second name=fron_between_second><option ng-repeat=\"x in [].constructor(59) track by $index\" value=\"{{ $index }}\">{{ $index }}</option></select>&nbsp; and second &nbsp;<select id=to_between_second name=to_between_second><option ng-repeat=\"x in [].constructor(59) track by $index\" value=\"{{ $index }}\">{{ $index }}</option></select></label></div>");
$templateCache.put("app/app-utils/directives/cron-builder/includes/year_form.html","<div ng-click=dialog.yearToCron() class=list-group-item><input type=radio ng-model=dialog.yearMode value=every_year><label>Every year</label></div><div ng-click=dialog.yearToCron() class=list-group-item><input type=radio ng-model=dialog.yearMode value=every_year_starting_in><label>Every<select id=from_day ng-model=dialog.input_year_from><option ng-repeat=\"x in [].constructor(10) track by $index\" value=\"{{ $index + 1 }}\">{{ $index + 1 }}</option></select>&nbsp; year(s) starting in<select id=to_day ng-model=dialog.input_year_to><option ng-repeat=\"year in years track by $index\" value=\"{{ year }}\">{{ year }}</option></select></label></div><div ng-click=dialog.yearToCron() class=list-group-item><input type=radio ng-model=dialog.yearMode value=specific_year><label>Specific year (choose one or many)</label><div layout=row layout-wrap><div flex=10 ng-repeat=\"year in years track by $index\"><input type=checkbox name=year_checkbox[] value=\"{{ year }}\" ng-checked=\"dialog.input_year_checkbox.indexOf(year) &gt; -1\" ng-click=\"toggleSelection(dialog.input_year_checkbox, year)\" class=year_checkbox>&nbsp;{{ year }}</div></div></div><div ng-click=dialog.yearToCron() class=list-group-item><input type=radio ng-model=dialog.yearMode value=every_year_between_year><label>Every year between &nbsp;<select id=from_between_year ng-model=dialog.input_year_from_between><option ng-repeat=\"year in years track by $index\" value=\"{{ year }}\">{{ year }}</option></select>&nbsp; and &nbsp;<select id=to_between_year ng-model=dialog.input_year_to_between><option ng-repeat=\"year in years track by $index\" value=\"{{ year }}\">{{ year }}</option></select></label></div>");
$templateCache.put("app/app-utils/components/table-data/includes/table-data-main-menu.html","<md-menu-bar flex layout=row class=table-data-menu><md-menu ng-if=!ctrl.isWidget><button ng-click=$mdMenu.open()>{{ ctrl.translation.file | capitalize }}</button><md-menu-content width=3><md-menu-item has-permission=data-management#{{ctrl.tableId}}:update><md-button ng-click=ctrl.onSaveData()>{{ ctrl.translation.save | capitalize }}</md-button></md-menu-item><md-divider></md-divider><md-menu-item has-permission=data-management#{{ctrl.tableId}}:update><md-button onclick=\"document.getElementById(\'fileImportArea\').click()\">Import from .csv</md-button><div style=\"display: none\"><input id=fileImportArea type=file import-table-js=\"\" rows-remove=ctrl.rowsToRemove columns=ctrl.cols sheet-data=ctrl.importedData is-importing=ctrl.isImporting should-replace-data=ctrl.shouldReplaceData multiple accept=.csv></div></md-menu-item><md-divider></md-divider><md-menu-item has-permission=data-management#{{ctrl.tableId}}:update><md-button ng-click=ctrl.onSaveData(true)>{{ ctrl.translation.save_and_exit | capitalize }}</md-button></md-menu-item><md-menu-item><md-button id=btnctrlonGoBack ng-click=ctrl._onGoBack()>{{ ctrl.translation.exit | capitalize }}</md-button></md-menu-item></md-menu-content></md-menu><md-menu ng-if=!ctrl.isWidget><button ng-click=$mdMenu.open()>{{ ctrl.translation.export_as }}</button><md-menu-content width=3><md-menu-item><md-button ng-click=\"ctrl._onExport(\'csv\')\">{{ ctrl.translation.export | capitalize }} (.csv .xlsx)</md-button></md-menu-item></md-menu-content></md-menu><md-menu ng-if=!ctrl.isWidget has-permission=data-management#{{ctrl.tableId}}:update><button ng-click=$mdMenu.open()>{{ ctrl.translation.edit | capitalize }}</button><md-menu-content width=3><md-menu-item><md-button ng-click=\"ctrl.insertRow(\'above\')\">{{ ctrl.translation.insert }} {{ ctrl.selectedRows || 1 }} {{ ctrl.translation.row_above | lowercase }}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.insertRow(\'below\')\">{{ ctrl.translation.insert }} {{ ctrl.selectedRows || 1 }} {{ ctrl.translation.row_below | lowercase }}</md-button></md-menu-item><md-menu-item><md-button ng-click=ctrl.bulkEdit($event)>{{ ctrl.translation.bulkEdit | capitalize }}</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button ng-click=ctrl.onClearAll($event)>{{ ctrl.translation.clear_all | capitalize }}</md-button></md-menu-item></md-menu-content></md-menu><button ng-if=!ctrl.isWidget ng-click=ctrl.tableManagement()>{{ ctrl.translation.schema_info | capitalize }}</button> <button ng-click=ctrl.filterTableManagement()>{{ ctrl.translation.filter | capitalize }}</button><div ng-repeat=\"predicate in ctrl.predicates track by $index\" style=\"margin-right: 8px\" ng-click=ctrl.removePredicate($index) class=\"badge grey\">{{ predicate.fieldName }} {{ predicate.operation }} : {{ predicate.operation === \"BETWEEN\" ? predicate.values : predicate.value }}<md-icon>close</md-icon></div><div style=\"margin-left: auto; flex-grow: 1\"></div><auto-refresh-menu on-tick=ctrl.reload() disabled></auto-refresh-menu><div class=text-right><button ng-class=\"errorMsg ? \'autoSave_error\' : \'autoSave_ok\'\">{{ ctrl.infoMessage | capitalize }}</button></div></md-menu-bar>");
$templateCache.put("app/app-utils/components/table-data/includes/table-data-pagination.html","<md-divider><md-content class=\"content_blocks ctrl_footer\"><div layout=row layout-align=\"end center\"><div flex=1 ng-if=!ctrl.isWidget><md-button id=savectrl ng-click=ctrl.onSaveData() class=md-raised>{{ ctrl.translation.save }}</md-button></div><div flex=1 ng-if=!ctrl.isWidget><md-button ng-click=ctrl.insertRow(&quot;below&quot;) class=md-raised>{{ ctrl.translation.insert }} {{ ctrl.translation.row_below | lowercase }}</md-button></div><div flex ng-if=!ctrl.isWidget></div><div flex=1 ng-if=\"ctrl.selectedRows &amp;&amp; !ctrl.isWidget\"><p style=\"padding: 0 12px; position: relative; top: 7px\">{{ ctrl.translation.selected }}: {{ ctrl.selectedRows }}</p></div><list-paginator page-index=ctrl.pagination.page total-records=ctrl.pagination.totalRecords page-size=ctrl.pagination.itemsPerPage next-fn=ctrl.nextPage prev-fn=ctrl.prevPage goto-fn=ctrl.goToPage></list-paginator><div flex=1 ng-if=ctrl.isImporting style=\"color: orange\"><p style=\"padding: 0 12px\">Importing Data</p></div></div></md-content></md-divider>");
$templateCache.put("app/charts/components/chart-list-dialog/components/chart-selector.html","<div ng-if=\"ctrl.isLoading== true\"><md-progress-linear id=loading-in-progress md-mode=indeterminate></md-progress-linear></div><div ng-if=\"ctrl.isLoading== false\"><md-input-container class=w100><label>lisado de Gráficas</label><md-autocomplete md-selected-item=ctrl.selectedItem md-search-text=ctrl.searchText md-selected-item-change=ctrl.selectedItemChange(item) md-items=\"item in ctrl.querySearch(ctrl.searchText)\" md-item-text=item.name md-min-length=0 placeholder=\"Listas de datos\" input-aria-labelledby=favoriteStateLabel><md-item-template><span md-highlight-text=ctrl.searchText md-highlight-flags=^i>{{ item.name }}</span></md-item-template><md-not-found>Sin resultados para \"{{ ctrl.searchText }}\" .</md-not-found></md-autocomplete></md-input-container><div class=w100><md-list flex><md-list-item ng-repeat=\"item in ctrl.chartListSelected\" ng-click=null class=md-3-line><p>{{ item.id }} -<b>{{ item.name }}</b></p><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\" ng-click=ctrl.removeLink(item.id) class=md-secondary>delete</md-icon></md-list-item></md-list></div></div>");
$templateCache.put("app/charts/components/chart-list-dialog/components/url-link.html","<br><section layout=row layout-padding class=w100><div flex=60><md-input-container class=\"w100 m0\"><label>Nombre</label><input ng-model=ctrl.name></md-input-container></div><div flex=40><md-input-container class=\"w100 m0\"><label>Url</label><input ng-model=ctrl.url></md-input-container></div></section><section layout=row layout-aling=end layout-padding class=w100><div flex=20><md-button ng-click=ctrl.addUrl() class=\"w100 md-raised\">Anadir</md-button></div></section><div class=w100><md-list flex><md-list-item ng-repeat=\"item in ctrl.chartListSelected\" ng-click=null class=md-3-line><p class=m0><b>{{ item.name }}</b></p><small>{{ item.url }}</small><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\" ng-click=ctrl.removeLink(item.url) class=md-secondary>delete</md-icon></md-list-item></md-list></div>");
$templateCache.put("app/charts/components/wizard-dialog/data-source/data-source.html","<fieldset><div layout=row layout-margin><div flex=60><label>{{ ctrl.translation.Choose_main_data_list }}</label><md-autocomplete id=select-source-data required name=source md-selected-item=ctrl.assets.source md-search-text=ctrl.source_searchText md-items=\"item in ctrl.source_querySearch(ctrl.source_searchText)\" md-selected-item-change=sourceChange(item) md-clear-button=false md-item-text=item.name md-min-length=0 placeholder=\"choose from a list\" input-aria-labelledby=InputLists md-require-match=true md-select-on-match=true md-input-name=input-select-source><md-item-template><span md-highlight-text=ctrl.source_searchText md-highlight-flags=^i>{{ item.name }}</span></md-item-template><md-not-found>{{ ctrl.translation.No_matching_found }} \"{{ ctrl.source_searchText }}\".</md-not-found></md-autocomplete><small class=hint>{{ ctrl.translation.lists_available_graphing }}</small><div ng-if=ctrl.input_source_displayError>{{ ctrl.translation.This_is_required }}</div></div><div flex=40 ng-if=\"ctrl.relatedSchemas.length == 0\"><code>{{ ctrl.translation.No_schemes_related_found }}::<br><b>{{ ctrl.assets.source.name }}</b></code></div><div flex=40 ng-if=\"ctrl.relatedSchemas.length &gt; 0\"><label>{{ ctrl.translation.Choose_supplementary_lists }}</label><br><md-checkbox aria-label=\"Select All\" ng-checked=isChecked() md-indeterminate=isIndeterminate() ng-click=toggleAll()><span ng-if=isChecked()>Un-</span>Select All</md-checkbox><div ng-repeat=\"item in ctrl.relatedSchemas\" class=demo-select-all-checkboxes><md-checkbox ng-checked=exists(item) ng-click=toggle(item)>{{ item.name }}</md-checkbox></div></div></div></fieldset><section><div layout=column layout-margin><div flex ng-if=\"ctrl.assets.sourceSchema.length &gt; 0\"><table id=table-related-schemas class=\"table fixed-head\"><thead><tr><th colspan=3 style=\"width: 70%\">{{ ctrl.translation.Schemas_related_main_list }}</th><th><searcher value=searchSchema placeholder=\"{{ ctrl.translation.find }}\"></searcher></th></tr><tr><th>{{ ctrl.translation.name }}Nombre</th><th>{{ ctrl.translation.type }}Tipo</th><th>{{ ctrl.translation.group }}Grupo</th><th>{{ ctrl.translation.description }}Descripcion</th></tr></thead><tbody><tr ng-repeat=\"schema in ctrl.assets.sourceSchema | filter:searchSchema \"><td>{{ schema.name }}</td><td>{{ schema.type }}</td><td>{{ schema.group }}</td><td>{{ schema.description }}</td></tr></tbody></table></div></div></section>");
$templateCache.put("app/charts/components/wizard-dialog/general/general.html","<fieldset><div layout=rows layout-margin><div flex=50><md-input-container class=w100><label>{{ ctrl.translation.Title }}</label><input ng-model=ctrl.config.name name=name required><div ng-if=ctrl.input_displayError>{{ ctrl.translation.This_is_required }}</div></md-input-container><div class=w100><label>{{ ctrl.translation.Group }}</label><div ng-if=\"loadingDialog == false\"><span>{{ ctrl.config.group }}</span><md-button ng-click=moveItemGroup() class=\"md-icon-button md-secondary text-main-color\"><md-icon md-font-set=material-icons>folder_copy</md-icon><md-tooltip>Move</md-tooltip></md-button></div><div ng-if=\"loadingDialog == true\"><md-progress-circular md-mode=indeterminate md-diameter=20px></md-progress-circular><br></div></div></div><div flex=50><md-input-container class=w100><label>{{ ctrl.translation.Description }}</label><textarea ng-model=ctrl.config.description name=description></textarea></md-input-container><div class=w100><label>{{ ctrl.translation.Type }}</label><md-radio-group style=\"display: flex; justify-content: space-around\" ng-model=ctrl.assets.chartType aria-labelledby=chartTypeSelected ng-change=onChangeChart_type() ng-disabled=\"ctrl.event === \'update\'\" required><md-radio-button ng-repeat=\"type in ctrl.chartTypes\" value=\"{{ type }}\"><md-icon md-font-set=material-icons>{{ type | chartIcon }}</md-icon>{{ type }}</md-radio-button></md-radio-group></div></div></div></fieldset>");
$templateCache.put("app/charts/components/wizard-dialog/group-filter/group-filter.html","<fieldset><div layout=column layout-margin><label>{{ ctrl.translation.Group_filter_graph }}</label><div flex><div layout=row layout-aling=\"center center\" layout-margin><div flex=50><label>{{ ctrl.translation.Available_schemes }}</label><md-autocomplete id=select-filters required name=source md-selected-item=ctrl.selectedItem md-search-text=ctrl.searchText md-items=\"item in ctrl.querySearch(ctrl.searchText)\" md-clear-button=false md-item-text=item.name md-min-length=0 placeholder=\"choose from a list\" input-aria-labelledby=InputLists md-require-match=true><md-item-template><span md-highlight-text=ctrl.searchText md-highlight-flags=^i>{{ item.name }}</span></md-item-template><md-not-found>{{ ctrl.translation.No_matching_found }} \"{{ ctrl.searchText }}\".</md-not-found></md-autocomplete></div><div flex=20 class=text-center><md-input-container><md-button ng-click=ctrl.addToGrouplist() class=md-raised><md-icon md-font-set=material-icons md-menu-align-target aria-label=add>add</md-icon>{{ ctrl.translation.group }}</md-button></md-input-container></div><div flex=30 class=text-center><md-input-container><md-button ng-click=ctrl.addToFilterlist() class=md-raised><md-icon md-font-set=material-icons md-menu-align-target aria-label=add>add</md-icon>{{ ctrl.translation.Filter }}</md-button></md-input-container><md-input-container style=\"width: 125px\"><label>ver como una lista</label><md-select ng-model=ctrl.viewAs aria-label=filters><md-option ng-repeat=\"option in ctrl.FiltersOptions\" ng-value=option>{{ option }}</md-option></md-select></md-input-container></div></div></div><div flex><div layout=row layout-aling=\"center center\" layout-margin><div flex><table class=\"table w100\"><thead><tr><th colspan=2>{{ ctrl.translation.grouped_by }}</th></tr></thead><tbody><tr ng-if=\"ctrl.grouplist.length == 0\"><td colspan=2>{{ ctrl.translation.Without_Groups }}</td></tr><tr ng-repeat=\"item in ctrl.grouplist\"><td><b>{{ item }}</b></td><td style=\"width: 1%\"><md-icon ng-click=ctrl.deleteFromGroup(item) md-font-set=material-icons md-menu-align-target aria-label=delete>delete</md-icon></td></tr></tbody></table></div><div flex><table class=\"table w100\"><thead><tr><th colspan=2>{{ ctrl.translation.applying_filters_by }}</th></tr></thead><tbody><tr ng-if=\"ctrl.filterlist.length == 0\"><td colspan=2>{{ ctrl.translation.remove_filter }}</td></tr><tr ng-repeat=\"item in ctrl.filterlist\"><td><b>{{ item.field }}</b>&nbsp; {{ ctrl.translation.asList }} {{ item.viewAs }}</td><td style=\"width: 1%\"><md-icon ng-click=ctrl.deleteFromList(item.field) md-font-set=material-icons md-menu-align-target aria-label=delete>delete</md-icon></td></tr></tbody></table></div></div></div></div></fieldset>");
$templateCache.put("app/charts/components/wizard-dialog/treemap/treemap.html","<fieldset><section layout=row layout-padding><div flex><h4>source schemas</h4><div style=\"height: 400px; overflow: auto\" class=schema-container><div ng-repeat=\"schema in ctrl.assets.sourceSchema\" ng-if=\"ctrl.isSchemaInUse(schema.name) === false &amp;&amp; ctrl.isSerie(schema.name) === false\" draggable=true schema=\"{{ schema.name }}\" class=item-drag><strong>{{ schema.name }} &nbsp;</strong><small>{{ schema.type }}</small></div></div></div><div flex><h4>levels</h4><div ui-sortable=sortableOptionsList ng-model=ctrl.levels droppable style=\"height: 400px\" class=level-container><div ng-repeat=\"level in ctrl.levels  track by $index\" sortable level=\"{{ level }}\" schema=\"{{ level }}\" class=item-drop><div layout=row layout-align=\"start center\"><div flex=90><h6>level {{ $index + 1 }}</h6><strong>{{ level }}</strong></div><div flex=auto><i ng-click=ctrl.removeLevel(level) class=\"fa fa-trash-o\"></i></div></div></div></div></div></section></fieldset>");
$templateCache.put("app/charts/components/wizard-dialog/x-axis/x-axis.html","<fieldset><div layout=row><article flex layout=row layout-margin><div flex=20><label>{{ ctrl.translation.Datatype }}</label><md-radio-group ng-model=ctrl.serietype aria-labelledby=serietype disabled><md-radio-button ng-repeat=\"type in ctrl.types\" aria-label=alfanumerica value=\"{{ type }}\" class=md-primary>{{ type }}</md-radio-button></md-radio-group></div><section flex class=w100><label>{{ ctrl.translation.Choose_Scheme_Xaxis_graph }}</label><div class=w100><md-autocomplete id=select-xaxis name=source md-selected-item=ctrl.selectedItem md-search-text=ctrl.searchText md-items=\"item in ctrl.querySearch(ctrl.searchText)\" md-selected-item-change=isComplete() md-clear-button=false md-item-text=item.name md-min-length=0 placeholder=\"choose from a xaxis\" input-aria-labelledby=xaxis md-require-match=true md-select-on-match=true md-input-name=input-select-xaxis><md-item-template><span md-highlight-text=ctrl.searchText md-highlight-flags=^i>{{ item.name }}</span></md-item-template><md-not-found>{{ ctrl.translation.No_matching_found }} \"{{ ctrl.searchText }}\".</md-not-found></md-autocomplete><div ng-if=ctrl.input_displayError>{{ ctrl.translation.This_is_required }}</div><small class=hint>{{ ctrl.translation.string_fields }}</small></div></section></article><aside flex=30 class=\"text-center grey lighten-4\"><image src=/assets/images/chart-sample-x.svg style=\"height: 200px\"></image></aside></div></fieldset>");
$templateCache.put("app/charts/components/wizard-dialog/y-axis/y-axis.html","<fieldset style=\"margin-top: 20px\"><div layout=row layout-align=\"start center\" layout-padding ng-if=\"ctrl.assets.chartType != \'treemap\'\"><md-input-container flex class=m0><label>charts types</label><md-select ng-model=ctrl.selectedChart><md-option ng-repeat=\"chart in ctrl.chartTypes\" value=\"{{ chart }}\"><md-icon md-font-set=material-icons>{{ chart | chartIcon }}</md-icon>{{ chart }}</md-option></md-select></md-input-container><div flex=30><md-button ng-click=ctrl.addSerie() ng-dissabled=\"ctrl.selectedChart===null\" class=m0><md-icon>add</md-icon>Add serie</md-button></div></div><section ng-if=\"ctrl.config.series.length === 0\"><p class=text-center>No series added yet</p></section><section ng-repeat=\"serie in ctrl.config.series track by $index\"><div layout=row layout-align=\"center center\" layout-padding layout-margin><div flex=20><h6><strong><md-icon md-font-set=material-icons>{{ serie.type | chartIcon }}</md-icon>{{ serie.type }}</strong></h6></div><div flex=30 ng-if=\"[\'line\',\'bar\',\'pie\',\'treemap\'].includes(serie.type)\" class=m0><label>Value</label><md-select ng-model=serie.label aria-label=Value><md-option ng-repeat=\"schema in ctrl.sourceSchema()\" value=\"{{ schema.name }}\">{{ schema.name }}</md-option></md-select></div><div flex=30 ng-if=\"serie.type === \'treemap\'\" class=m0><md-input-container><label>{{ ctrl.translation.visibleMin }}</label><input ng-model=serie.metadata.visibleMin type=number></md-input-container><md-input-container><label>{{ ctrl.translation.leafDepth }}</label><input ng-model=serie.metadata.leafDepth type=number></md-input-container></div><div flex=30 layout=column ng-if=\"serie.type === \'boxplot\'\" class=m0><section flex layout=row ng-repeat=\"(key,val) in serie.metadata track by $index\"><div flex=20 style=\"margin: 8px\">{{ key }}:</div><md-input-container flex=auto class=m0><md-select ng-model=serie.metadata[key] aria-label=Value><md-option ng-repeat=\"schema in ctrl.sourceSchema()\" value=\"{{ schema.name }}\">{{ schema.name }}</md-option></md-select></md-input-container></section></div><div flex=10 class=m0><label>Color</label><input ng-model=serie.color type=color></div><div flex=15 class=m0><label>Function</label><md-select ng-model=serie.agregation aria-label=Function><md-option ng-repeat=\"func in ctrl.agregationFunctions\" value=\"{{ func }}\">{{ func }}</md-option></md-select></div><div flex=20 ng-if=\"serie.type !== \'treemap\'\" class=m0><md-menu><md-button aria-label=More ng-click=$mdMenu.open()><md-icon md-font-set=material-icons class=\"md-icon-button md-secondary\">more_vert</md-icon>Markline {{ serie.markline[0].data.length }}</md-button><md-menu-content width=4 ng-mouseleave=$mdMenu.close()><md-menu-item ng-repeat=\"opt in ctrl.marklinesOptions\"><md-button ng-click=\"ctrl.toggleMarkline(serie, opt.value)\">{{ opt.name }}<md-icon md-font-set=material-icons class=\"md-icon-button md-secondary\">{{ ctrl.isSelectMarkline(serie, opt.value) ? \"check\" : \"\" }}</md-icon></md-button></md-menu-item></md-menu-content></md-menu></div><div flex=10 ng-if=\"ctrl.assets.chartType != \'treemap\'\"><md-button ng-click=ctrl.removeSerie($index) class=m0><md-icon>delete</md-icon></md-button></div></div></section></fieldset>");
$templateCache.put("app/dashboard/components/issue-columns-dialog/components/column-folder.html","<div layout=column class=\"w100 m0\"><div layout=row layout-align=center><div flex><md-button ng-click=\"ctrl.folder.display = !ctrl.folder.display\" aria-label=\"Display items button\" title=\"Toggle group\" class=\"md-button text-left w100\"><md-icon md-font-set=material-icons>{{ ctrl.folder.display ? \"keyboard_arrow_down\" : \"keyboard_arrow_right\" }}</md-icon>{{ ctrl.folder.name }}</md-button></div></div><div ng-style=\"ctrl.folder.display ? {\'display\':\'block\'} : {\'display\':\'none\'}\" style=\"margin-left: 3rem\"><div ng-if=\"ctrl.folder.items.length &gt; 0\"><item-folder ng-repeat=\"item in ctrl.folder.items track by $index\" item=item></item-folder></div><div ng-if=\"ctrl.folder.folders.length &gt; 0\"><column-folder ng-repeat=\"folder in ctrl.folder.folders track by $index \" folder=folder></column-folder></div></div></div>");
$templateCache.put("app/dashboard/components/issue-columns-dialog/components/item-folder.html","<div layout=row layout-align=\"start center\" layout-padding><div flex=initial class=text-center><md-checkbox ng-model=ctrl.item.selected aria-label=\"Column selector\" class=m0></md-checkbox></div><div flex=initial><b>{{ ctrl.item.label }}</b></div><div flex=initial class=text-right></div><div flex=initial ng-if=ctrl.item.functions class=text-right>function:</div><div flex=initial class=text-center><md-input-container ng-if=ctrl.item.functions class=m0><select ng-model=ctrl.item.function aria-label=\"Function Selector\" required class=select-filters-modal><option ng-repeat=\"function in ctrl.item.functions track by $index\" ng-value=function>{{ function }}</option></select></md-input-container></div></div>");
$templateCache.put("app/dashboard/components/vinculated-issues/components/vinculated-issues-list.html","<div ng-cloak><div layout=row><section flex layout=row style=\"margin-top: 10px; padding: 8px\"><div ng-repeat=\"(key, predicate) in ctrl.filters.predicates\" style=\"margin-right: 5px\" class=\"text-center cep-badge\">{{ predicate.label }}: {{ predicate.value != null ? predicate.value : predicate.valuesLabels.join(\", \") }}<div style=\"margin-left: 5px\" ng-click=ctrl.removeFilter(key) class=\"fa fa-times\"></div></div><div ng-if=ctrl.filters.predicates.length style=\"margin-right: 5px\" ng-click=ctrl.removeFilter(&quot;ALL&quot;) class=\"text-center cep-badge\">Remove filters</div></section><section><md-menu><md-button ng-click=$mdMenu.open($event) aria-label=\"Linked issues actions menu\" class=\"pull-right md-raised md-accent md-hue-2 white-text\">Actions<md-icon md-font-set=material-icons style=\"position:relative; top: 3px\" class=white-text>keyboard_arrow_down</md-icon></md-button><md-menu-content class=md-dense><md-menu-item><md-button ng-click=ctrl.manageColumns($event)>Manage columns</md-button></md-menu-item><md-menu-item><md-button ng-click=ctrl.unlinkIssues(item)>Unlink selected issues</md-button></md-menu-item></md-menu-content></md-menu></section></div><div ui-grid-selection ui-grid-resize-columns ui-grid-move-columns ui-grid-save-state ui-grid-pagination ui-grid=ctrl.gridOptions></div></div>");
$templateCache.put("app/data-conn/components/create-conection/templates/connection-tab.html","<md-content class=md-padding><div layout=row><md-input-container flex style=margin-bottom:0><label>{{translation.name}}</label><input ng-model=ctrl.connData.name aria-label=translation.name required></md-input-container><md-input-container flex style=margin-bottom:0><label>{{translation.description}}</label><input ng-model=ctrl.connData.description aria-label=translation.name></md-input-container></div><div layout=row><md-input-container flex style=margin-bottom:0><label>{{translation.type}}</label><select ng-model=ctrl.connData.dataProcessingType aria-label=\"Connection type selector\" placeholder=Type required class=select-filters-modal><option ng-repeat=\"type in ctrl.types\" ng-value=type>{{type}}</option></select></md-input-container><md-input-container flex style=margin-bottom:0><label>{{translation.protocol}}</label><select ng-model=ctrl.connData.protocolType ng-change=ctrl.getSubprotocol(ctrl.connData.protocolType) aria-label=\"Protocol selector\" placeholder=Protocol required class=select-filters-modal><option ng-repeat=\"protocol in ctrl.protocols\" ng-value=protocol.protocolName>{{protocol.protocolName}}</option></select></md-input-container><md-input-container flex style=margin-bottom:0><label>Sub {{translation.protocol}}</label><select ng-model=ctrl.connData.protocolDriverOrSubtype aria-label=\"Sub Protocol\" placeholder=\"Sub Protocol selector\" required class=select-filters-modal><option ng-repeat=\"subProtocol in ctrl.subProtocols\" ng-value=subProtocol>{{subProtocol}}</option></select></md-input-container></div><div layout=row><md-input-container flex ng-repeat=\"param in ctrl.parameters | filter:{type:&quot;!list&quot;} | filter:{type:&quot;!{}&quot;} \" style=margin-bottom:0><label>{{param.name}} {{param.type}}</label><input ng-model=param.value name={{param.name}} autocomplete=off aria-label={{param.name}} type=\"{{param.secure ? &quot;password&quot; : param.type == &quot;integer&quot; ? &quot;number&quot; : &quot;text&quot;}}\"></md-input-container></div><div layout=row><div flex ng-repeat=\"param in ctrl.parameters | filter:{secure:false} | filter:{type:&quot;{}&quot;}\" class=\"w100 md-padding\"><span style=\"color: #575757 !important; font-weight: 100; text-transform: uppercase; font-size:0.75em\">{{param.name}}</span><div ui-grid=param.gridOptions ui-grid-edit ui-grid-cellnav ui-grid-selection ui-grid-resize-columns class=myGrid></div></div></div><div layout=row><md-input-container flex=50 ng-repeat=\"param in ctrl.parameters | filter:{secure:false} | filter:{type:&quot;list&quot;} | filter:{name:&quot;!queries&quot;}\" class=w100><label>{{param.name}}</label><md-chips ng-model=param.value md-enable-chip-edit=true md-add-on-blur=true input-aria-label=key ng-change=\"ctrl.isChanged = true\"></md-chips></md-input-container></div></md-content>");
$templateCache.put("app/data-conn/components/create-conection/templates/definitions-tab.html","<md-content class=md-padding><md-list><md-list-item style=\"border-bottom: 1px solid #eaeaea;padding: 1.8rem\" ng-if=!ctrl.connData.schemasCacheMap class=md-no-proxy><span>{{translation.msg_withoutSchemaDef}}</span></md-list-item><md-list-item ng-repeat=\"item in ctrl.connData.schemasCacheMap\" style=\"border-bottom: 1px solid #eaeaea;padding: 1.8rem\" class=md-no-proxy><div class=\"row w100\"><span style=font-weight:800>* {{item.schemaDefinition.definition}}</span><br><span>{{translation.properties}}:</span><div ng-repeat=\"(key, property) in item.schemaDefinition.data.properties\"><span style=\"font-weight:800; margin-left: 10px\">* {{key}}: </span><span>{{property.type}}</span></div></div></md-list-item></md-list></md-content>");
$templateCache.put("app/data-conn/components/create-conection/templates/queries-tab.html","<md-content class=md-padding><div layout=row><div flex ng-repeat=\"param in ctrl.parameters | filter:{secure:false} | filter:{type:&quot;list&quot;} | filter:{name:&quot;queries&quot;}\"><query-editor query=param.value></query-editor></div></div></md-content>");
$templateCache.put("app/files-storage/folder/dialog/move-file/move-file.html","<md-dialog aria-label=\"Mover archivo\"><form ng-cloak=\"\"><md-toolbar><div class=md-toolbar-tools><h2>{{ ctrl.translation.move_file }}</h2><span flex=\"\"></span><md-button ng-click=ctrl.cancel() class=md-icon-button>X</md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><h4><b>{{ ctrl.fileName }}</b></h4><h5>{{ ctrl.translation.select_destination_folder }}</h5><md-input-container ng-if=\"ctrl.foldersList.length == 0\" class=w100><div style=\"padding: 10px\" class=text-center><h4>{{ ctrl.translation.loading_folders }}</h4><md-progress-linear md-mode=indeterminate></md-progress-linear></div></md-input-container><md-input-container ng-if=\"ctrl.foldersList.length &gt; 0\" class=w100><label>{{ ctrl.translation.available_folders }}</label><md-select ng-model=ctrl.folderSelected><md-option ng-repeat=\"folder in ctrl.foldersList\" ng-value=folder.id>{{ folder.name }}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=ctrl.moveFileToFolder() ng-if=\"validatePermission(&quot;move&quot;) || ctrl.loading\">{{ ctrl.translation.move }}</md-button><md-button ng-click=ctrl.cancel()>{{ ctrl.translation.cancel }}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/files-storage/folder/dialog/settings/settings.html","<md-dialog id=ModalCreateFolder aria-label=\"folder edition dialog\" style=\"min-width: 80%\"><md-toolbar class=main-color><div class=md-toolbar-tools><h2><md-icon md-font-set=material-icons>folder_open</md-icon>{{ ctrl.folder.id ? translation.edit : translation.new_folder }}</h2><span flex></span><md-button ng-click=cancel($event) class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=row layout-padding=\"\" ng-if=ctrl.loading><div flex=100><div class=w100><md-progress-linear md-mode=indeterminate></md-progress-linear></div></div></div><div id=dialog-content layout=row layout-padding=\"\"><div flex=50><md-input-container class=w100><label>{{ translation.name }}</label><input ng-model=ctrl.folder.name type=text></md-input-container><md-input-container class=w100><label>{{ translation.description }}</label><input ng-model=ctrl.folder.description type=text></md-input-container><md-input-container class=w100><label>{{ translation.color }}</label><input ng-model=ctrl.folder.color type=color></md-input-container></div><div flex=50><div layout=row layout-padding=\"\" layout-wrap=\"\"><div flex=100><md-checkbox aria-label=\"Select All\" ng-checked=isChecked() md-indeterminate=isIndeterminate() ng-click=toggleAll()><span ng-if=isChecked()>{{ translation.unselect_all }}</span><span ng-if=!isChecked()>{{ translation.select_all }}</span></md-checkbox></div><div flex=25 ng-repeat=\"item in global_config_extensions\"><md-checkbox ng-checked=\"exists(item, selected_extensions)\" ng-click=\"toggle(item, selected_extensions)\">{{ item }}</md-checkbox></div></div></div></div></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button ng-click=save() aria-label=btn ng-if=\"!ctrl.loading || validatePermission(&quot;update&quot;)\" class=\"md-raised md-primary\">{{ translation.save }}</md-button><md-button ng-click=cancel() aria-label=btn class=md-warn>{{ translation.exit }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/home/widgets/list-details/dialog/link-list.html","<md-dialog aria-label=linklist ng-cloak><form><md-toolbar class=main-color><div layout=row layout-align=\"center center\"><div class=md-toolbar-tools><h2>{{ ctrl.list.name }}</h2></div><div><md-button ng-click=cancel() class=\"pull-right md-fab md-mini white\"><md-icon md-font-set=material-icons md-menu-align-target>close</md-icon></md-button></div></div></md-toolbar><md-content ng-if=ctrl.tableIsLoading><md-progress-linear></md-progress-linear></md-content><md-dialog-content><ng-include src=&quot;app/input-list/templates/table-list-main-menu.html&quot;></ng-include><div ui-grid-pagination ui-grid-resize-columns ui-grid-auto-resize ui-grid-expandable ui-grid-pinning ui-grid=ctrl.gridOptions style=\"height: 70vh; width: 100vw\" class=listGrid></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/rule-editor/components/json-editor/comps/type-array.html","<input type=checkbox id={{ctrl.ref}} class=display_child><ul class=tree_list><li ng-repeat=\"(key, val) in ctrl.array track by $index\"><div class=block><label for={{key}}_{{$index}} class=key>{{key}}<small class=text-muted>- {{getTypeof(val)}}</small></label></div></li></ul>");
$templateCache.put("app/rule-editor/components/json-editor/comps/type-number.html","<input value={{ctrl.value}} size={{ctrl.size}} class=value>");
$templateCache.put("app/rule-editor/components/json-editor/comps/type-object.html","<input type=checkbox id={{ctrl.ref}} class=display_child><ul class=tree_list><li ng-repeat=\"(key, value) in items track by $index\"><div class=block><label for={{key}}_{{$index}} class=key>{{key}}<small class=text-muted>- {{getTypeof(value)}}</small></label><pre>{{value}}</pre></div></li></ul>");
$templateCache.put("app/main/components/user-documents/components/document-card.html","<div layout=row layout-align=\"center center\" class=notification-box><div flex><p style=\"width: 100%; font-size: 1.5rem\" md-truncate class=m0><strong>{{ ctrl.document.fileName }}</strong></p><p ng-if=\"ctrl.document.status === \'COMPLETED\'\" style=\"font-size: 12px\" class=m0><small>{{ ctrl.document.size }} &nbsp;|&nbsp; Created {{ ctrl.document.createdAt | asDateHour}}</small></p><span ng-class=\"{ \'green\': ctrl.document.status === \'COMPLETED\' ,\'blue\': ctrl.document.status === \'IN_PROGRESS\' ,\'red\': ctrl.document.status === \'FAILED\' }\" style=\"font-size: 10px\" class=badge><md-icon ng-if=\"ctrl.document.status === \'COMPLETED\'\" md-font-set=material-icons class=white-text>check_circle</md-icon><md-icon ng-if=\"ctrl.document.status === \'IN_PROGRESS\'\" md-font-set=material-icons class=white-text>autorenew</md-icon><md-icon ng-if=\"ctrl.document.status === \'FAILED\'\" md-font-set=material-icons class=white-text>error</md-icon>&nbsp; {{ ctrl.document.status }}</span></div><div flex=20><md-button ng-click=ctrl.downloadDocument() ng-if=\"ctrl.document.status === \'COMPLETED\'\" class=\"p0 text-center\"><md-icon md-font-set=material-icons class=green-text>file_download</md-icon></md-button><md-progress-circular ng-if=\"ctrl.document.status === \'IN_PROGRESS\'\" md-mode=indeterminate md-diameter=20px></md-progress-circular></div></div>");
$templateCache.put("app/app-utils/directives/cron-builder/components/cron-once-a-day/once-a-day.html","<table class=\"table w100 m0\"><thead><tr><th class=text-center>Days</th></tr></thead><tbody><tr><td class=text-center><div flex layout=row layout-align=\"space-between center\" class=w100><div flex ng-repeat=\"day in days track by $index\" class=text-center><md-button ng-class=\"{ &quot;orange&quot;: ctrl.dayOfWeek.includes(day) , &quot;white&quot; : !ctrl.dayOfWeek.includes(day) }\" ng-click=toggleSelection(day) class=md-mini><strong>{{ day }}</strong></md-button></div></div></td></tr></tbody></table><table class=\"table w100\"><thead><tr><th class=text-center>Hour</th><th class=text-center>Minute</th></tr></thead><tbody><tr><td class=text-center><select ng-model=ctrl.hour ng-change=ctrl.updateCron() class=w100><option ng-repeat=\"hour in hours track by $index\" value=\"{{ hour }}\">{{ hour| padLeft:2 }}</option></select></td><td class=text-center><select ng-model=ctrl.minute ng-change=ctrl.updateCron() class=w100><option ng-repeat=\"minute in minutes track by $index\" value=\"{{ minute }}\">{{ minute | padLeft:2 }}</option></select></td></tr></tbody></table>");
$templateCache.put("app/app-utils/directives/cron-builder/components/cron-every-hour/every-hour.html","<table class=\"table w100 m0\"><thead><tr><th class=text-center>Days</th></tr></thead><tbody><tr><td class=text-center><div flex layout=row layout-align=\"space-between center\" class=w100><div flex ng-repeat=\"day in days track by $index\" class=text-center><md-button ng-class=\"{ &quot;orange&quot;: ctrl.dayOfWeek.includes(day) , &quot;white&quot; : !ctrl.dayOfWeek.includes(day) }\" ng-click=toggleSelection(day) class=md-mini><strong>{{ day }}</strong></md-button></div></div></td></tr></tbody></table><table class=\"table w100\"><thead><tr><th colspan=3 class=text-center>Between <input type=checkbox name=between ng-model=ctrl.between ng-change=ctrl.toggleBetween()></th><th class=text-center>Minute</th></tr></thead><tbody><tr><td class=text-center><select ng-model=ctrl.starthour ng-change=ctrl.updateCron() class=w100><option ng-repeat=\"hour in hours track by $index\" value=\"{{ hour }}\">{{ hour | padLeft:2 }}</option></select></td><td class=text-center>AND</td><td class=text-center><select ng-model=ctrl.endhour ng-change=ctrl.updateCron() class=w100><option ng-repeat=\"hour in hours track by $index\" value=\"{{ hour }}\">{{ hour | padLeft:2 }}</option></select></td><td class=text-center><select ng-model=ctrl.minute ng-change=ctrl.updateCron() class=w100><option ng-repeat=\"minute in minutes track by $index\" value=\"{{ minute }}\">{{ minute | padLeft:2 }}</option></select></td></tr></tbody></table>");
$templateCache.put("app/app-utils/directives/cron-builder/components/cron-once-a-month/once-a-month.html","<table class=\"table w100\"><thead><tr><th class=text-center>Day</th><th class=text-center>Hour</th><th class=text-center>Minute</th></tr></thead><tbody><tr><td class=text-center><select ng-model=ctrl.dayOfMonth ng-change=ctrl.updateCron() class=w100><option value=L>Last</option><option ng-repeat=\"day in days track by $index\" value=\"{{ day }}\">{{ day | padLeft:2 }}</option></select><div ng-if=[&quot;29&quot;,&quot;30&quot;,&quot;31&quot;].includes(ctrl.dayOfMonth) class=\"white-text red text-center\">Wil not execute on mont without day {{ ctrl.dayOfMonth }}</div></td><td class=text-center><select ng-model=ctrl.hour ng-change=ctrl.updateCron() class=w100><option ng-repeat=\"hour in hours track by $index\" value=\"{{ hour }}\">{{ hour | padLeft:2 }}</option></select></td><td class=text-center><select ng-model=ctrl.minute ng-change=ctrl.updateCron() class=w100><option ng-repeat=\"minute in minutes track by $index\" value=\"{{ minute }}\">{{ minute | padLeft:2 }}</option></select></td></tr></tbody></table>");
$templateCache.put("app/app-utils/directives/cron-builder/components/cron-once-a-week/once-a-week.html","<table class=\"table w100\"><thead><tr><th class=text-center>Day</th><th class=text-center>Hour</th><th class=text-center>Minute</th></tr></thead><tbody><tr><td class=text-center><select ng-model=ctrl.dayOfWeek required ng-change=ctrl.updateCron() class=w100><option ng-repeat=\"day in days track by $index\" value=\"{{ day }}\">{{ day }}</option></select></td><td class=text-center><select ng-model=ctrl.starthour required ng-change=ctrl.updateCron() class=w100><option ng-repeat=\"hour in hours track by $index\" value=\"{{ hour }}\">{{ hour | padLeft:2 }}</option></select></td><td class=text-center><select ng-model=ctrl.minute required ng-change=ctrl.updateCron() class=w100><option ng-repeat=\"minute in minutes track by $index\" value=\"{{ minute }}\">{{ minute | padLeft:2 }}</option></select></td></tr></tbody></table>");
$templateCache.put("app/app-utils/directives/cron-builder/components/cron-once-a-year/once-a-year.html","<table class=\"table w100\"><thead><tr><th class=text-center>Month</th><th class=text-center>Day</th><th class=text-center>Hour</th><th class=text-center>Minute</th></tr></thead><tbody><tr><td class=text-center><select ng-model=ctrl.month ng-change=ctrl.updateCron() class=w100><option ng-repeat=\"month in months track by $index\" value=\"{{ month }}\">{{ month }}</option></select></td><td class=text-center><select ng-model=ctrl.dayOfMonth ng-change=ctrl.updateCron() class=w100><option value=L>Last</option><option ng-repeat=\"day in days track by $index\" value=\"{{ day }}\">{{ day | padLeft:2 }}</option></select><div ng-if=[&quot;29&quot;,&quot;30&quot;,&quot;31&quot;].includes(ctrl.dayOfMonth) class=\"white-text red text-center\">Wil not execute on mont without day {{ ctrl.daysOfMonth }}</div></td><td class=text-center><select ng-model=ctrl.hour ng-change=ctrl.updateCron() class=w100><option ng-repeat=\"hour in hours track by $index\" value=\"{{ hour }}\">{{ hour | padLeft:2 }}</option></select></td><td class=text-center><select ng-model=ctrl.minute ng-change=ctrl.updateCron() class=w100><option ng-repeat=\"minute in minutes track by $index\" value=\"{{ minute }}\">{{ minute | padLeft:2 }}</option></select></td></tr></tbody></table>");
$templateCache.put("app/app-utils/directives/cron-builder/components/cron-time/cron-time.html","<md-list class=w100><md-radio-group ng-model=ctrl.rpt ng-change=ctrl.regenerateCron()><md-list-item ng-if=\"![\'day\', \'year\', \'month\'].includes(ctrl.type)\" class=w100><div><md-radio-button value=every aria-label=\"Every type option\" class=\"m0 md-primary\"></md-radio-button></div><div>&nbsp; {{ctrl.text.every}} &nbsp;<select name=minutes ng-change=ctrl.regenerateCron() ng-model=ctrl.evValue ng-options=\"minute as minute for minute in ctrl.state.values\" aria-label=\"Time selector\" class=\"minutes cep-gray-input\"></select>&nbsp; {{ctrl.text.label}}(s)</div></md-list-item><md-list-item class=w100><div><md-radio-button value=on-time aria-label=\"On time type option\" class=\"m0 md-primary\"></md-radio-button></div><div>&nbsp; {{ctrl.text.label | capitalize }} &nbsp;<select name=minutes ng-change=ctrl.regenerateCron() ng-model=ctrl.onValue ng-options=\"minute as minute for minute in ctrl.state.values\" aria-label=\"Time selector\" class=\"minutes cep-gray-input\"></select>&nbsp;</div></md-list-item></md-radio-group></md-list>");
$templateCache.put("app/app-utils/directives/cron-builder/components/cron-week/cron-week.html","<md-list class=w100><md-radio-group ng-model=ctrl.rpt ng-change=ctrl.regenerateCron()><md-list-item class=w100><div><md-radio-button value=on-time aria-label=\"On time type option\" class=\"m0 md-primary\"></md-radio-button></div><div>&nbsp; {{ctrl.text.label | lowercase }}&nbsp;<select name=weekDays ng-change=ctrl.regenerateCron() ng-model=ctrl.onValue aria-label=\"Day of week selector\" class=\"minutes cep-gray-input\"><option ng-repeat=\"weekDay in ctrl.state.values\" value={{weekDay.value}}>{{weekDay.name}}</option></select>&nbsp;</div></md-list-item><md-list-item class=w100><div><md-radio-button value=mon-fri aria-label=\"Week type option\" class=\"m0 md-primary\"></md-radio-button></div><div>&nbsp; {{ctrl.text.week }}&nbsp;</div></md-list-item><md-list-item style=margin-top:5px class=w100><div><md-radio-button value=select aria-label=\"Week type option\" class=\"m0 md-primary\"></md-radio-button></div><div><md-checkbox ng-model=day[weekDay.value] ng-repeat=\"weekDay in ctrl.state.values | filter:{value:\'!*\'}\" ng-checked=\"ctrl.exists(weekDay.value, ctrl.selected)\" ng-change=ctrl.regenerateCron() ng-click=\"ctrl.toggle(weekDay.value, ctrl.selected)\" style=\"margin: 0 10px 0 0\" aria-label=\"{{weekDay.name}} selector\">{{weekDay.nameShort}}</md-checkbox></div></md-list-item></md-radio-group></md-list>");
$templateCache.put("app/app-utils/components/table-data/dialogs/bulk-edit/bulk-edit.html","<md-dialog id=issues-type-form aria-label=\"{{ actionText }}\" style=\"width: 50vw\"><md-toolbar class=\"white-text main-color\"><div class=md-toolbar-tools><h2>{{ ctrl.translation.replaceWith }}</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column layout-padding layout-aling=\"center center\"><md-content ng-if=!ctrl.column><p>Select a column</p><div layout=row layout-padding layout-aling=\"center center\"><div flex=100><md-input-container class=w100><label>Columns</label><md-select ng-model=ctrl.column required name=column ng-change=ctrl.setupColumn()><md-option ng-repeat=\"col in ctrl.columns\" ng-value=col>{{ col.title }}</md-option></md-select></md-input-container></div></div></md-content><md-content ng-if=ctrl.column><form id=replaceWithForm layout=row layout-padding layout-aling=\"center center\" novalidate><div flex=25><md-input-container class=w100><label>columnName</label><input ng-model=ctrl.replaceWith.columnName disabled name=columnName></md-input-container></div><div flex=25><md-input-container class=w100><label>findValue</label><input required ng-model=ctrl.replaceWith.findValues[0] type=\"{{ ctrl.inputType }}\" step=\"{{ ctrl.step }}\" name=findValues1></md-input-container><md-input-container ng-if=\"ctrl.replaceWith.operator === &quot;BETWEEN&quot;\" class=w100><label>findValue</label><input required ng-model=ctrl.replaceWith.findValues[1] type=\"{{ ctrl.inputType }}\" step=\"{{ ctrl.step }}\" name=findValues2></md-input-container></div><div flex=25><md-input-container class=w100><label>operator</label><md-select ng-model=ctrl.replaceWith.operator required name=operator><md-option ng-repeat=\"operations in ctrl.column.operations\" ng-value=operations>{{ operations }}</md-option></md-select></md-input-container></div><div flex=25><md-input-container class=w100><label>newValue</label><input required ng-model=ctrl.replaceWith.newValue type=\"{{ ctrl.inputType }}\" step=\"{{ ctrl.step }}\" name=newValue></md-input-container></div></form></md-content></md-dialog-content><md-dialog-actions><md-button ng-click=ctrl.changeColumn() style=\"margin-right: auto\">Change column</md-button><md-button ng-click=ctrl.cancel()>{{ ctrl.translation.cancel }}</md-button><md-button type=submit form=replaceWithForm ng-click=ctrl.save() ng-disabled=\" ctrl.column ? false : true \">{{ ctrl.translation.replace }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/app-utils/components/table-data/dialogs/export-table-selector/export-table-selector.html","<md-dialog><md-dialog-content id=dialogContent_7 role=document tabindex=-1 class=md-dialog-content><h2 class=\"md-title ng-binding\">{{ ctrl.translation.title_export }}</h2><md-divider></md-divider><div class=md-dialog-content-body><p>{{ ctrl.translation.export_quest }}</p><br><md-radio-group ng-model=ctrl.selection><md-radio-button value=this class=md-primary>{{ ctrl.translation.actual_view }}</md-radio-button><md-radio-button value=all class=md-primary>{{ ctrl.translation.whole_list }}</md-radio-button></md-radio-group></div></md-dialog-content><md-dialog-actions><section ng-show=workbook><span>{{ ctrl.translation.reading_file_data }}</span><md-progress-linear></md-progress-linear></section><section ng-hide=workbook><md-button type=button ng-click=ctrl.abortSelection()><span>{{ ctrl.translation.cancel }}</span></md-button><md-button type=button ng-click=ctrl.selectSheet(ctrl.selection)><span>{{ ctrl.translation.export }}</span></md-button></section></md-dialog-actions></md-dialog>");
$templateCache.put("app/app-utils/components/table-data/dialogs/filter/table-data-filter.html","<md-dialog><md-dialog-content role=filter-data-manamegent tabindex=-1><form><md-content><table class=\"table w10\"><thead><tr><th>{{ translation.column }}</th><th>{{ translation.operation }}</th><th>{{ translation.value }}</th><th>-</th></tr></thead><tbody><tr><td><md-input-container class=w100><label>{{ translation.column }}</label><md-select ng-model=ctrl.newPredicate.fieldName ng-change=ctrl.onChangeColumn($index)><md-option ng-repeat=\"option in ctrl.columns track by $index\" ng-if=\"option.title != &quot;id_row&quot;\" ng-value=option.data>{{ option.title }}</md-option></md-select></md-input-container></td><td><md-input-container class=w100><label>{{ translation.operation }}</label><md-select ng-model=ctrl.newPredicate.operation ng-disabled=!ctrl.newPredicate.fieldName ng-change=ctrl.onChangeOperation($index) aria-label=predicate><md-option ng-repeat=\"option in ctrl.getOperations(ctrl.newPredicate.fieldName)\" ng-value=option>{{ option }}</md-option></md-select></md-input-container></td><td><div ng-if=\"ctrl.newPredicate.operation == &quot;BETWEEN&quot;\"><div layout=row><md-input-container class=\"w100 hide-validation-error\"><label>{{ translation.value }} {{ ctrl.getInputType(ctrl.newPredicate.fieldName) }}</label><input ng-model=ctrl.newPredicate.values[0] ng-disabled=!ctrl.newPredicate.operation type=\"{{ ctrl.getInputType(ctrl.newPredicate.fieldName) }}\"></md-input-container><md-input-container class=\"w100 hide-validation-error\"><label>{{ translation.value }} {{ ctrl.getInputType(ctrl.newPredicate.fieldName) }}</label><input ng-model=ctrl.newPredicate.values[1] ng-disabled=!ctrl.newPredicate.operation type=\"{{ ctrl.getInputType(ctrl.newPredicate.fieldName) }}\"></md-input-container></div></div><div ng-if=\"ctrl.newPredicate.operation != &quot;BETWEEN&quot;\"><md-input-container class=\"w100 hide-validation-error\"><label>{{ translation.value }} {{ ctrl.getInputType(ctrl.newPredicate.fieldName) }}</label><input ng-model=ctrl.newPredicate.value ng-disabled=!ctrl.newPredicate.operation type=\"{{ ctrl.getInputType(ctrl.newPredicate.fieldName) }}\"></md-input-container></div></td><td><md-button ng-click=ctrl.addPredicate() class=md-icon-button><md-icon>add</md-icon></md-button></td></tr><tr ng-repeat=\"predicate in ctrl.predicates track by $index\"><td>{{ predicate.fieldName }}</td><td>{{ predicate.operation }}</td><td>{{ predicate.value ? predicate.value : predicate.values.join(\',\') }}</td><td><md-button ng-click=ctrl.removePredicate($index) class=\"md-icon-button red-text\"><md-icon>delete</md-icon></md-button></td></tr></tbody></table></md-content><md-content><div layout=row layout-align=\"space-between center\"><div flex class=text-left><md-button ng-click=ctrl.cancel() class=red>cancel</md-button></div><div flex class=text-right><md-button ng-click=ctrl.applyFilters() ng-disabled=\"ctrl.predicates.length == 0\" class=green>Save</md-button></div></div></md-content></form></md-dialog-content></md-dialog>");
$templateCache.put("app/app-utils/components/table-data/dialogs/import-table/import-table.html","<md-dialog><md-dialog-content role=document tabindex=-1 class=md-dialog-content><h2 class=\"md-title ng-binding\">Import data from .csv</h2><md-divider></md-divider><div class=md-dialog-content-body><p>Do you want to add or replace the current data?</p><br></div></md-dialog-content><md-dialog-actions><md-button type=button ng-click=ctrl.replaceCurrentData()><span>replace current data</span></md-button><md-button type=button ng-click=ctrl.addToCurrentData()><span>Add to current data</span></md-button><md-button type=button ng-click=ctrl.cancel()><span>Cancel</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/app-utils/components/table-data/dialogs/text-search/text-search.html","<md-dialog id=text-search-form aria-label=\"table Searcher\" style=\"width: 80vw\"><md-toolbar class=\"white-text main-color\"><div class=md-toolbar-tools><h2>Searcher</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column layout-padding layout-aling=\"center center\"><md-content><div><table-text-search style=\"flex: 0; align-self: center\"></table-text-search></div><div></div></md-content><md-content ng-if=ctrl.showSearch><md-tabs><md-tab ng-repeat=\"item in ctrl.data track by item.target\" label=\"{{ item.target }}\"><md-content class=md-padding><table class=table><thead><tr><th ng-repeat=\"header in item.headers track by $index\">{{ header }}</th></tr></thead><tbody><tr ng-repeat=\"row in item.rows\"><td ng-repeat=\"cell in row track by $index\">{{ cell }}</td></tr></tbody></table></md-content></md-tab></md-tabs></md-content></md-dialog-content><md-dialog-actions><md-button ng-click=ctrl.cancel()>Cancel</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/configuration/dialog/issues-type/components/classifications-grid/classifications-grid.html","<div ui-grid=gridOptions ui-grid-edit ui-grid-cellnav ui-grid-resize-columns class=myGrid></div><md-button ng-click=addRow()>addrow</md-button>");
$templateCache.put("app/configuration/dialog/issues-type/components/criticalities-grid/criticalities-grid.html","<div ui-grid=gridOptions ui-grid-edit ui-grid-cellnav ui-grid-resize-columns class=myGrid></div><md-button ng-click=addRow()>addrow</md-button>");
$templateCache.put("app/configuration/dialog/issues-type/components/status-grid/status-grid.html","<div style=\"max-height: 200px; overflow: auto\" class=w100><hot-table hot-id=status-grid-table settings=ctrl.tableSettings datarows=gridOptions.data columns=ctrl.tableColumns class=w100></hot-table></div><md-button ng-click=addRow()>addrow</md-button>");
$templateCache.put("app/dashboard/components/issue-dynamic-schema/components/issue-complex-field/issue-complex-field.html","<div flex=grow><b>{{ ctrl.field.displayName | capitalize }}</b><hr style=\"margin: 0 0 18px 0\"></div><issue-dynamic-schema schema=ctrl.schema schema-data=ctrl.model show-title=false disabled></issue-dynamic-schema>");
$templateCache.put("app/dashboard/components/issue-dynamic-schema/components/issue-reference-search-dialog/issue-reference-search-dialog.html","<md-dialog aria-label=\"Evidence creation dialog\"><md-toolbar class=main-color><div class=md-toolbar-tools><h2>Search Reference</h2><span flex></span><md-button ng-click=ctrl.cancel() class=md-icon-button><md-icon md-font-set=material-icons md-menu-align-target aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"min-width: 60vw; padding: 5px\"><section flex layout=row style=\"margin-top: 10px; padding: 8px\"><div ng-repeat=\"(key, predicate) in ctrl.filters.predicates\" style=\"margin-right: 5px\" class=\"text-center cep-badge\">{{ predicate.label }}: {{ predicate.value != null ? predicate.value : predicate.valuesLabels.join(\', \') }}<div style=\"margin-left: 5px\" ng-click=ctrl.removeFilter(key) class=\"fa fa-times\"></div></div><div ng-if=ctrl.filters.predicates.length style=\"margin-right: 5px\" ng-click=ctrl.removeFilter(&quot;ALL&quot;) class=\"text-center cep-badge\">Remove filters</div></section><div ui-grid-selection ui-grid-pagination ui-grid-resize-columns ui-grid=ctrl.gridOptions class=issueGrid></div></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button ng-click=ctrl.cancel() class=md-raised>Cancel</md-button><md-button ng-click=ctrl.select() class=md-raised>Select</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/dashboard/components/issue-dynamic-schema/components/issue-reference-selector/issue-reference-selector.html","<md-input-container style=\"margin-botton: 0px\" class=w100><div ng-if=ctrl.showReferenceData style=\"background-color: white; position: absolute; z-index: 999; top: 35px; padding: 10px\" class=md-whiteframe-2dp><div ng-if=!ctrl.referencedValues._id><span>Doubleclick in field to select reference</span></div><div ng-repeat=\"(key, value) in ctrl.referencedSchema track by $index\" ng-if=\"value.tooltip &amp;&amp; !value.pk\"><span>{{ value.displayName || key | capitalize }}:&nbsp;</span><b>{{ ctrl.referencedValues[key] }}</b></div></div><label>{{ ctrl.field.displayName || ctrl.field.key | capitalize }} - {{ ctrl.field.type }}<md-tooltip md-direction=top>{{ ctrl.field.displayName || ctrl.field.key | capitalize }}</md-tooltip></label><input type=text placeholder=\"\" ng-model=ctrl.model style=\"padding: 0 10px\" ng-mouseover=ctrl.showHint() ng-mouseleave=ctrl.hideHint() readonly ng-dblclick=ctrl.openReferenceSelector($event) ng-disabled=ctrl.field.readonly class=\"cep-rounded-border cep-input-bg grey-text\"></md-input-container>");
$templateCache.put("app/dashboard/components/issue-dynamic-schema/components/issue-sequential-selector/issue-sequential-selector.html","<md-input-container style=\"margin-botton: 0px\" class=w100><label>{{ ctrl.field.displayName || ctrl.key | capitalize }} - {{ ctrl.field.type }}<md-tooltip md-direction=top>{{ ctrl.field.displayName || ctrl.key | capitalize }}</md-tooltip></label><md-select ng-model=ctrl.model md-on-open=ctrl.loadSequentialValues(ctrl.field.metadata.id) aria-label=\"{{ctrl.key}} value selector\" style=\"padding: 0 10px\" ng-disabled=ctrl.field.readonly class=\"cep-rounded-border cep-input-bg\"><md-option ng-value=item ng-repeat=\"item in ctrl.selectorData\">{{ item }}</md-option></md-select></md-input-container>");
$templateCache.put("app/dashboard/components/issue-files/components/issue-file-box/issue-file-box.html","<md-card id=file-widget><md-card-content class=p0><section layout=row layout-align=\"center center\"><div flex=100 style=\"background: #efefef\"><h2 style=\"padding: 1rem 0\" ng-if=!file.toggle class=text-center>.{{ file.data.name.split(\".\").pop() }}</h2><md-button ng-click=file.handlerToggle() aria-label=\"Toggle Button\" class=\"p0 m0 md-icon-button pull-right\"><md-icon md-font-set=material-icons>dehaze</md-icon></md-button></div></section></md-card-content><md-card-content ng-if=!file.toggle class=p0><section layout=row layout-align=\"center center\" layout-padding=\"\" layout-wrap=\"\"><div flex=100 class=p0><p md-truncate=\"\">{{ file.data.name }}</p></div><div flex=100 class=p0><p md-truncate=\"\">{{ moved }}</p></div><div flex=80 class=p0><small>{{ file.data.size | readableBytes }}</small></div></section></md-card-content><md-card-content ng-if=file.toggle class=p0><md-list flex><md-list-item ng-click=file.filePreview() aria-label=\"Preview file button\"><md-icon md-font-set=material-icons>remove_red_eye</md-icon><p>{{ translation.preview }}</p></md-list-item><md-list-item ng-click=file.downloadFile() aria-label=\"Download file button\"><md-icon md-font-set=material-icons>cloud_download</md-icon><p>{{ translation.download }}</p></md-list-item><md-list-item ng-click=file.deleteFile($event) aria-label=\"Delete file button\"><md-icon md-font-set=material-icons>delete</md-icon><p>{{ translation.delete }}</p></md-list-item></md-list></md-card-content></md-card>");
$templateCache.put("app/dashboard/components/issue-related-content-dialog/components/related-issues-list/related-issues-list.html","<div layout=column><div ui-grid-selection ui-grid-pagination ui-grid-resize-columns ui-grid=ctrl.gridOptions class=issueGrid></div></div>");
$templateCache.put("app/main/components/notification/components/notification-card/notification-card.html","<div ng-if=!isDeleted aria-label=\"noty list item\" ng-class=\"{ &quot;unRead&quot;: !ctrl.item.isRead , &quot;animated fadeOutLeft&quot;: fadeOut }\" class=notification-box><p ng-click=ctrl.clickNoty() style=\"font-size: 1.3rem\" class=p0><span><md-tooltip md-direction=left>{{ ctrl.item.body.issueType.name }}</md-tooltip><cep-icon icon=\"{{ ctrl.item.body.issueType.icon }}\" color=\"{{ ctrl.item.body.issueType.color }}\"></cep-icon><b ng-class=\"{ &quot;text-second-color&quot;: !ctrl.item.isRead }\">{{ ctrl.item.body.correlative }}</b></span></p><p class=\"p0 text-right\"><small></small><md-checkbox ng-model=ctrl.item.selected aria-label=\"remove item\"></md-checkbox></p><p style=\"width: 100%; font-size: 1.5rem\" ng-click=ctrl.clickNoty(noty)><strong>{{ ctrl.item.body.description }}</strong></p><p style=\"width: 100%; font-size: 1.2rem\" ng-click=ctrl.clickNoty(noty)><strong>{{ ctrl.item.title }}</strong></p><p style=\"font-size: 0.7rem\" ng-click=ctrl.clickNoty(noty)><small>{{ ctrl.translation.createdAt }} &nbsp;<strong>{{ ctrl.item.body.createdAt }}</strong></small></p><p style=\"font-size: 0.7rem\" ng-click=ctrl.clickNoty(noty)><small>{{ ctrl.item.target == \'ISSUE_STATUS\' ? ctrl.translation.resolutionDateByStatus : ctrl.translation.resolutionDate }} &nbsp;<strong>{{ ctrl.item.target == \'ISSUE_STATUS\' ? ctrl.item.body.resolutionDateByStatus : ctrl.item.body.resolutionDate }}</strong></small></p></div>");
$templateCache.put("app/main/components/notification/components/notifications-list/notifications-list.html","<div flex ng-if=!ctrl.isLoading class=\"noti-list relative\"><div ng-repeat=\"noty in ctrl.notifications track by $index\" class=\"noty-item notification-menu-item\"><notification-card item=noty translation=ctrl.translation remove-item=ctrl.removeItem(item)></notification-card></div></div><div flex ng-if=ctrl.isLoading><div class=\"noty-item notification-menu-item\"><div style=\"font-size: 1.3rem\" class=notification-box><p>{{ ctrl.translation.loadingMore }}</p><md-progress-linear></md-progress-linear></div></div></div><div flex ng-if=\"!ctrl.isLoading &amp;&amp; ctrl.notifications.length == 0\"><div class=\"noty-item notification-menu-item\"><div style=\"font-size: 1.3rem\" class=notification-box><div class=text-center><md-icon md-font-set=material-icons style=\"font-size: 6rem\" class=\"grey-text text-lighten-2\">thumb_up</md-icon><p>{{ ctrl.translation.dontHaveNotifications }}</p></div></div></div></div><div flex><div layout=row layout-align=\"end center\"><div flex=60 style=\"font-size: 1.3rem\" class=grey-text><pagination pagination=ctrl.pagination ng-if=!ctrl.loading on-click=loadMore()></pagination></div><div flex=40 style=\"font-size: 1.3rem\" ng-if=\"ctrl.notifications.length &gt; 0\"><md-button ng-if=\"ctrl.notifications.length &gt; 0\" ng-click=ctrl.removeSelected() style=\"font-size: 1.3rem; margin: 2px 0px\" class=\"amber white-black w100\">{{ ctrl.translation.removeSelected }}</md-button><md-button ng-click=ctrl.confirmRemoveAll() style=\"font-size: 1.3rem; margin: 2px 0px\" class=\"red white-text w100\">{{ ctrl.translation.removeAll }}</md-button></div></div></div>");
$templateCache.put("app/rule-editor/components/predicates-dialog/components/predicate-builder/predicate-builder.html","<md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=ctrl.selectedTab><md-tab label=Predicate md-on-select=ctrl.use(&quot;predicate&quot;)><md-content class=md-padding><predicate-function predicate=ctrl.predicate.predicate input-schema=ctrl.inputSchema></predicate-function></md-content></md-tab><md-tab label=Advanced md-on-select=ctrl.use(&quot;advanced&quot;)><md-progress-linear md-mode=indeterminate ng-show=!ctrl.showace class=\"md-accent md-hue-2\"></md-progress-linear><md-content style=\"min-height: 430px\" ng-if=ctrl.showace class=md-padding><div ng-model=ctrl.predicate.advancedPredicate ui-ace=ctrl.aceConfigs style=\"height: 430px; width: 100%\"></div></md-content></md-tab><md-tab label=Schema><md-content class=md-padding><pre style=\"white-space: pre\">{{ ctrl.predicate | json }}</pre></md-content></md-tab></md-tabs>");
$templateCache.put("app/rule-editor/components/predicates-dialog/components/predicate-condition/predicate-condition.html","<div ng-if=\"!predicate[\'operandType\']\" layout=row layout-align=\"space-around center\" class=\"p-rule-container md-whiteframe-1dp\"><div flex=30><md-autocomplete md-require-match=false md-floating-label=\"Schema column\" md-search-text=ctrl.predicate.operands[0].name md-items=\"item in querySearch(ctrl.predicate.operands[0].name)\" md-item-text=item.name md-min-length=0 md-clear-button=true style=\"padding-left:5px; top:9px\" md-selected-item=ctrl.selectedItem><md-item-template><span md-highlight-text=ctrl.predicate.operands[0].name md-highlight-flags=^i>{{item.name}} </span></md-item-template></md-autocomplete></div><md-input-container flex=20 style=\"position:relative; top:-2px\" class=\"no-padding-no-margin w100 md-input-has-value\"><label>Operand</label><select ng-model=ctrl.predicate.operand required class=select-filters-modal><option ng-repeat=\"opt in ctrl.operations\" value={{opt.operator}}>{{translation[opt.title]}}</option></select></md-input-container><div flex=30 layout=row><md-input-container flex style=\"position:relative; top:10px\" class=w100><label>Type</label><select ng-model=ctrl.predicate.operands[1].type placeholder=\"\" aria-label=\"Type selector\" required class=select-filters-modal><option ng-repeat=\"opt in ctrl.types\" value={{opt.id}}>{{opt.type}}</option></select></md-input-container><md-input-container flex style=\"position:relative; top:10px\" class=w100><label>Condition</label><input type=\"{{[&quot;integer&quot;, &quot;double&quot;].includes(ctrl.predicate.operands[1].type) ? &quot;number&quot; : &quot;text&quot; }}\" ng-model=ctrl.predicate.operands[1].value></md-input-container></div><div flex=10><md-button ng-click=ctrl.removeCondition(ctrl.index) aria-label=\"Remove predicate button\" class=md-icon-button><md-tooltip md-direction=left>Remove condition</md-tooltip><md-icon md-font-set=material-icons>remove_circle_outline</md-icon></md-button></div></div>");
$templateCache.put("app/rule-editor/components/predicates-dialog/components/predicate-function/predicate-function.html","<div class=\"p-group-container md-whiteframe-1dp\"><div layout=row class=p-group-header><div flex=12 layout=row layout-align=\"start top\" style=\"width: fit-content; height: fit-content; margin: 5px\"><md-button ng-click=ctrl.setOP(&quot;AND&quot;) ng-class=\"{ &quot;selected&quot; : ctrl.predicate.operand == &quot;AND&quot; }\" class=\"groupX left\">AND</md-button><md-button ng-click=ctrl.setOP(&quot;OR&quot;) ng-class=\"{ &quot;selected&quot; : ctrl.predicate.operand == &quot;OR&quot; }\" class=\"groupX right\">OR</md-button></div><md-menu style=\"margin: 5px\"><md-button aria-label=More ng-click=$mdMenu.open() class=md-icon-button><md-icon md-font-set=material-icons class=\"md-icon-button md-secondary\">add</md-icon></md-button><md-menu-content width=2 ng-mouseleave=$mdMenu.close()><md-menu-item><md-button ng-click=ctrl.addFunction()><md-icon md-font-set=material-icons>add</md-icon><span>Function</span></md-button></md-menu-item><md-menu-item><md-button ng-click=ctrl.addCondition()><md-icon md-font-set=material-icons>add</md-icon><span>Condition</span></md-button></md-menu-item></md-menu-content></md-menu><md-button ng-if=ctrl.removeFunction ng-click=ctrl.removeFunction(ctrl.index) aria-label=\"Remove function button\" style=\"margin-top: 6px\" class=md-icon-button><md-tooltip md-direction=left>Remove Function</md-tooltip><md-icon md-font-set=material-icons>remove_circle_outline</md-icon></md-button></div><div class=p-group-body><div class=p-rule-list><section ng-repeat=\"(key, predicate) in ctrl.predicate.operands track by $index\"><predicate-function ng-if=\"[&quot;AND&quot;, &quot;OR&quot;].includes(predicate[&quot;operand&quot;])\" predicate=predicate input-schema=ctrl.inputSchema index=key remove-function=ctrl.autoremove></predicate-function><predicate-condition ng-if=\"![&quot;AND&quot;, &quot;OR&quot;].includes(predicate[&quot;operand&quot;])\" predicate=predicate input-schema=ctrl.inputSchema index=key></predicate-condition></section></div></div></div>");}]);